// @__NO_SIDE_EFFECTS__
function a1(n) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const t of n.split(",")) e[t] = 1;
  return (t) => t in e;
}
const en = {}, Hr = [], ea = () => {
}, U3 = () => !1, Kf = (n) => n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && // uppercase letter
(n.charCodeAt(2) > 122 || n.charCodeAt(2) < 97), Yf = (n) => n.startsWith("onUpdate:"), gi = Object.assign, G3 = (n, e) => {
  const t = n.indexOf(e);
  t > -1 && n.splice(t, 1);
}, DP = Object.prototype.hasOwnProperty, jt = (n, e) => DP.call(n, e), mt = Array.isArray, jo = (n) => gu(n) === "[object Map]", Il = (n) => gu(n) === "[object Set]", Nx = (n) => gu(n) === "[object Date]", Ft = (n) => typeof n == "function", on = (n) => typeof n == "string", is = (n) => typeof n == "symbol", qt = (n) => n !== null && typeof n == "object", j3 = (n) => (qt(n) || Ft(n)) && Ft(n.then) && Ft(n.catch), H3 = Object.prototype.toString, gu = (n) => H3.call(n), OP = (n) => gu(n).slice(8, -1), V3 = (n) => gu(n) === "[object Object]", l1 = (n) => on(n) && n !== "NaN" && n[0] !== "-" && "" + parseInt(n, 10) === n, sc = /* @__PURE__ */ a1(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Xf = (n) => {
  const e = /* @__PURE__ */ Object.create(null);
  return ((t) => e[t] || (e[t] = n(t)));
}, LP = /-\w/g, ri = Xf(
  (n) => n.replace(LP, (e) => e.slice(1).toUpperCase())
), BP = /\B([A-Z])/g, lr = Xf(
  (n) => n.replace(BP, "-$1").toLowerCase()
), Jf = Xf((n) => n.charAt(0).toUpperCase() + n.slice(1)), Bm = Xf(
  (n) => n ? `on${Jf(n)}` : ""
), ys = (n, e) => !Object.is(n, e), fp = (n, ...e) => {
  for (let t = 0; t < n.length; t++)
    n[t](...e);
}, W3 = (n, e, t, i = !1) => {
  Object.defineProperty(n, e, {
    configurable: !0,
    enumerable: !1,
    writable: i,
    value: t
  });
}, d1 = (n) => {
  const e = parseFloat(n);
  return isNaN(e) ? n : e;
}, FP = (n) => {
  const e = on(n) ? Number(n) : NaN;
  return isNaN(e) ? n : e;
};
let Ux;
const Zf = () => Ux || (Ux = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function ce(n) {
  if (mt(n)) {
    const e = {};
    for (let t = 0; t < n.length; t++) {
      const i = n[t], s = on(i) ? jP(i) : ce(i);
      if (s)
        for (const o in s)
          e[o] = s[o];
    }
    return e;
  } else if (on(n) || qt(n))
    return n;
}
const NP = /;(?![^(]*\))/g, UP = /:([^]+)/, GP = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function jP(n) {
  const e = {};
  return n.replace(GP, (t) => t.startsWith("/*") ? "" : t).split(NP).forEach((t) => {
    if (t) {
      const i = t.split(UP);
      i.length > 1 && (e[i[0].trim()] = i[1].trim());
    }
  }), e;
}
function G(n) {
  let e = "";
  if (on(n))
    e = n;
  else if (mt(n))
    for (let t = 0; t < n.length; t++) {
      const i = G(n[t]);
      i && (e += i + " ");
    }
  else if (qt(n))
    for (const t in n)
      n[t] && (e += t + " ");
  return e.trim();
}
const HP = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", VP = /* @__PURE__ */ a1(HP);
function q3(n) {
  return !!n || n === "";
}
function WP(n, e, t) {
  if (n.length !== e.length) return !1;
  let i = !0;
  for (let s = 0; i && s < n.length; s++)
    i = Vl(n[s], e[s], t);
  return i;
}
function Gx(n, e, t) {
  if (n.size !== e.size) return !1;
  const i = Array.from(e), s = new Uint8Array(i.length);
  for (const o of n) {
    let r = -1;
    for (let a = 0; a < i.length; a++)
      if (!s[a] && Vl(o, i[a], t)) {
        r = a;
        break;
      }
    if (r < 0) return !1;
    s[r] = 1;
  }
  return !0;
}
function qP(n, e, t) {
  let i = jo(n), s = jo(e);
  if (i || s || (i = Il(n), s = Il(e), i || s))
    return i && s ? Gx(n, e, t) : !1;
  const o = Object.keys(n).length, r = Object.keys(e).length;
  if (o !== r)
    return !1;
  for (const a in n) {
    const l = n.hasOwnProperty(a), d = e.hasOwnProperty(a);
    if (l && !d || !l && d || !Vl(n[a], e[a], t))
      return !1;
  }
  return String(n) === String(e);
}
function jx(n, e, t, i) {
  t || (t = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()]);
  const [s, o] = t;
  if (s.has(n) || o.has(e))
    return s.get(n) === e && o.get(e) === n;
  s.set(n, e), o.set(e, n);
  const r = i(n, e, t);
  return s.delete(n), o.delete(e), r;
}
function Vl(n, e, t) {
  if (n === e) return !0;
  let i = Nx(n), s = Nx(e);
  return i || s ? i && s ? n.getTime() === e.getTime() : !1 : (i = is(n), s = is(e), i || s ? n === e : (i = mt(n), s = mt(e), i || s ? i && s ? jx(n, e, t, WP) : !1 : (i = qt(n), s = qt(e), i || s ? !i || !s ? !1 : jx(n, e, t, qP) : String(n) === String(e))));
}
function K3(n, e) {
  return n.findIndex((t) => Vl(t, e));
}
const Y3 = (n) => !!(n && n.__v_isRef === !0), E = (n) => on(n) ? n : n == null ? "" : mt(n) || qt(n) && (n.toString === H3 || !Ft(n.toString)) ? Y3(n) ? E(n.value) : JSON.stringify(n, X3, 2) : String(n), X3 = (n, e) => Y3(e) ? X3(n, e.value) : jo(e) ? {
  [`Map(${e.size})`]: [...e.entries()].reduce(
    (t, [i, s], o) => (t[Fm(i, o) + " =>"] = s, t),
    {}
  )
} : Il(e) ? {
  [`Set(${e.size})`]: [...e.values()].map((t) => Fm(t))
} : is(e) ? Fm(e) : qt(e) && !mt(e) && !V3(e) ? String(e) : e, Fm = (n, e = "") => {
  var t;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    is(n) ? `Symbol(${(t = n.description) != null ? t : e})` : n
  );
};
let Bn;
class J3 {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e = !1) {
    this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !e && Bn && (Bn.active ? (this.parent = Bn, this.index = (Bn.scopes || (Bn.scopes = [])).push(
      this
    ) - 1) : (this._active = !1, this._warnOnRun = !1));
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let e, t;
      if (this.scopes) {
        const i = this.scopes.slice();
        for (e = 0, t = i.length; e < t; e++)
          i[e].pause();
      }
      for (e = 0, t = this.effects.length; e < t; e++)
        this.effects[e].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let e, t;
      if (this.scopes) {
        const s = this.scopes.slice();
        for (e = 0, t = s.length; e < t; e++)
          s[e].resume();
      }
      const i = this.effects.slice();
      for (e = 0, t = i.length; e < t; e++)
        i[e].resume();
    }
  }
  run(e) {
    if (this._active) {
      const t = Bn;
      try {
        return Bn = this, e();
      } finally {
        Bn = t;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = Bn, Bn = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    if (this._on > 0 && --this._on === 0) {
      if (Bn === this)
        Bn = this.prevScope;
      else {
        let e = Bn;
        for (; e; ) {
          if (e.prevScope === this) {
            e.prevScope = this.prevScope;
            break;
          }
          e = e.prevScope;
        }
      }
      this.prevScope = void 0;
    }
  }
  stop(e) {
    if (this._active) {
      this._active = !1;
      let t, i;
      for (t = 0, i = this.effects.length; t < i; t++)
        this.effects[t].stop();
      for (this.effects.length = 0, t = 0, i = this.cleanups.length; t < i; t++)
        this.cleanups[t]();
      if (this.cleanups.length = 0, this.scopes) {
        const s = this.scopes.slice();
        for (t = 0, i = s.length; t < i; t++)
          s[t].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !e) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function c1(n) {
  return new J3(n);
}
function KP() {
  return Bn;
}
let Ht;
const Nm = /* @__PURE__ */ new WeakSet();
class Z3 {
  constructor(e) {
    this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Bn && (Bn.active ? Bn.effects.push(this) : this.flags &= -2);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Nm.has(this) && (Nm.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || e5(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Hx(this), t5(this);
    const e = Ht, t = Zi;
    Ht = this, Zi = !0;
    try {
      return this.fn();
    } finally {
      n5(this), Ht = e, Zi = t, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let e = this.deps; e; e = e.nextDep)
        p1(e);
      this.deps = this.depsTail = void 0, Hx(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Nm.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    lv(this) && this.run();
  }
  get dirty() {
    return lv(this);
  }
}
let Q3 = 0, oc, rc;
function e5(n, e = !1) {
  if (n.flags |= 8, e) {
    n.next = rc, rc = n;
    return;
  }
  n.next = oc, oc = n;
}
function u1() {
  Q3++;
}
function h1() {
  if (--Q3 > 0)
    return;
  if (rc) {
    let e = rc;
    for (rc = void 0; e; ) {
      const t = e.next;
      e.next = void 0, e.flags &= -9, e = t;
    }
  }
  let n;
  for (; oc; ) {
    let e = oc;
    for (oc = void 0; e; ) {
      const t = e.next;
      if (e.next = void 0, e.flags &= -9, e.flags & 1)
        try {
          e.trigger();
        } catch (i) {
          n || (n = i);
        }
      e = t;
    }
  }
  if (n) throw n;
}
function t5(n) {
  for (let e = n.deps; e; e = e.nextDep)
    e.version = -1, e.prevActiveLink = e.dep.activeLink, e.dep.activeLink = e;
}
function n5(n) {
  let e, t = n.depsTail, i = t;
  for (; i; ) {
    const s = i.prevDep;
    i.version === -1 ? (i === t && (t = s), p1(i), YP(i)) : e = i, i.dep.activeLink = i.prevActiveLink, i.prevActiveLink = void 0, i = s;
  }
  n.deps = e, n.depsTail = t;
}
function lv(n) {
  for (let e = n.deps; e; e = e.nextDep)
    if (e.dep.version !== e.version || e.dep.computed && (i5(e.dep.computed) || e.dep.version !== e.version))
      return !0;
  return !!n._dirty;
}
function i5(n) {
  if (n.flags & 4 && !(n.flags & 16) || (n.flags &= -17, n.globalVersion === Ac) || (n.globalVersion = Ac, !n.isSSR && n.flags & 128 && (!n.deps && !n._dirty || !lv(n))))
    return;
  n.flags |= 2;
  const e = n.dep, t = Ht, i = Zi;
  Ht = n, Zi = !0;
  try {
    t5(n);
    const s = n.fn(n._value);
    (e.version === 0 || ys(s, n._value)) && (n.flags |= 128, n._value = s, e.version++);
  } catch (s) {
    throw e.version++, s;
  } finally {
    Ht = t, Zi = i, n5(n), n.flags &= -3;
  }
}
function p1(n, e = !1) {
  const { dep: t, prevSub: i, nextSub: s } = n;
  if (i && (i.nextSub = s, n.prevSub = void 0), s && (s.prevSub = i, n.nextSub = void 0), t.subs === n && (t.subs = i, !i && t.computed)) {
    t.computed.flags &= -5;
    for (let o = t.computed.deps; o; o = o.nextDep)
      p1(o, !0);
  }
  !e && !--t.sc && t.map && t.map.delete(t.key);
}
function YP(n) {
  const { prevDep: e, nextDep: t } = n;
  e && (e.nextDep = t, n.prevDep = void 0), t && (t.prevDep = e, n.nextDep = void 0);
}
let Zi = !0;
const s5 = [];
function Jo() {
  s5.push(Zi), Zi = !1;
}
function Zo() {
  const n = s5.pop();
  Zi = n === void 0 ? !0 : n;
}
function Hx(n) {
  const { cleanup: e } = n;
  if (n.cleanup = void 0, e) {
    const t = Ht;
    Ht = void 0;
    try {
      e();
    } finally {
      Ht = t;
    }
  }
}
let Ac = 0, XP = class {
  constructor(e, t) {
    this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
};
class f1 {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e) {
    this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(e) {
    if (!Ht || !Zi || Ht === this.computed)
      return;
    let t = this.activeLink;
    if (t === void 0 || t.sub !== Ht)
      t = this.activeLink = new XP(Ht, this), Ht.deps ? (t.prevDep = Ht.depsTail, Ht.depsTail.nextDep = t, Ht.depsTail = t) : Ht.deps = Ht.depsTail = t, o5(t);
    else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
      const i = t.nextDep;
      i.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = i), t.prevDep = Ht.depsTail, t.nextDep = void 0, Ht.depsTail.nextDep = t, Ht.depsTail = t, Ht.deps === t && (Ht.deps = i);
    }
    return t;
  }
  trigger(e) {
    this.version++, Ac++, this.notify(e);
  }
  notify(e) {
    u1();
    try {
      for (let t = this.subs; t; t = t.prevSub)
        t.sub.notify() && t.sub.dep.notify();
    } finally {
      h1();
    }
  }
}
function o5(n) {
  if (n.dep.sc++, n.sub.flags & 4) {
    const e = n.dep.computed;
    if (e && !n.dep.subs) {
      e.flags |= 20;
      for (let i = e.deps; i; i = i.nextDep)
        o5(i);
    }
    const t = n.dep.subs;
    t !== n && (n.prevSub = t, t && (t.nextSub = n)), n.dep.subs = n;
  }
}
const dv = /* @__PURE__ */ new WeakMap(), ta = /* @__PURE__ */ Symbol(
  ""
), cv = /* @__PURE__ */ Symbol(
  ""
), Pc = /* @__PURE__ */ Symbol(
  ""
);
function Vn(n, e, t) {
  if (Zi && Ht) {
    let i = dv.get(n);
    i || dv.set(n, i = /* @__PURE__ */ new Map());
    let s = i.get(t);
    s || (i.set(t, s = new f1()), s.map = i, s.key = t), s.track();
  }
}
function Ws(n, e, t, i, s, o) {
  const r = dv.get(n);
  if (!r) {
    Ac++;
    return;
  }
  const a = (l) => {
    l && l.trigger();
  };
  if (u1(), e === "clear")
    r.forEach(a);
  else {
    const l = mt(n), d = l && l1(t);
    if (l && t === "length") {
      const c = Number(i);
      r.forEach((h, f) => {
        (f === "length" || f === Pc || !is(f) && f >= c) && a(h);
      });
    } else
      switch ((t !== void 0 || r.has(void 0)) && a(r.get(t)), d && a(r.get(Pc)), e) {
        case "add":
          l ? d && a(r.get("length")) : (a(r.get(ta)), jo(n) && a(r.get(cv)));
          break;
        case "delete":
          l || (a(r.get(ta)), jo(n) && a(r.get(cv)));
          break;
        case "set":
          jo(n) && a(r.get(ta));
          break;
      }
  }
  h1();
}
function ka(n) {
  const e = /* @__PURE__ */ Et(n);
  return e === n || (Vn(e, "iterate", Pc), /* @__PURE__ */ Li(n)) ? e : /* @__PURE__ */ _s(n) ? /* @__PURE__ */ Ho(n) ? e.map((t) => Qo(Fi(t))) : e.map(Qo) : e.map(Fi);
}
function Qf(n) {
  return Vn(n = /* @__PURE__ */ Et(n), "iterate", Pc), n;
}
function bs(n, e) {
  return /* @__PURE__ */ _s(n) ? Qo(/* @__PURE__ */ Ho(n) ? Fi(e) : e) : Fi(e);
}
const JP = {
  __proto__: null,
  [Symbol.iterator]() {
    return Um(this, Symbol.iterator, (n) => bs(this, n));
  },
  concat(...n) {
    return ka(this).concat(
      ...n.map((e) => mt(e) ? ka(e) : e)
    );
  },
  entries() {
    return Um(this, "entries", (n) => (n[1] = bs(this, n[1]), n));
  },
  every(n, e) {
    return As(this, "every", n, e, void 0, arguments);
  },
  filter(n, e) {
    return As(
      this,
      "filter",
      n,
      e,
      (t) => t.map((i) => bs(this, i)),
      arguments
    );
  },
  find(n, e) {
    return As(
      this,
      "find",
      n,
      e,
      (t) => bs(this, t),
      arguments
    );
  },
  findIndex(n, e) {
    return As(this, "findIndex", n, e, void 0, arguments);
  },
  findLast(n, e) {
    return As(
      this,
      "findLast",
      n,
      e,
      (t) => bs(this, t),
      arguments
    );
  },
  findLastIndex(n, e) {
    return As(this, "findLastIndex", n, e, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(n, e) {
    return As(this, "forEach", n, e, void 0, arguments);
  },
  includes(...n) {
    return Gm(this, "includes", n);
  },
  indexOf(...n) {
    return Gm(this, "indexOf", n);
  },
  join(n) {
    return ka(this).join(n);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...n) {
    return Gm(this, "lastIndexOf", n);
  },
  map(n, e) {
    return As(this, "map", n, e, void 0, arguments);
  },
  pop() {
    return sd(this, "pop");
  },
  push(...n) {
    return sd(this, "push", n);
  },
  reduce(n, ...e) {
    return Vx(this, "reduce", n, e);
  },
  reduceRight(n, ...e) {
    return Vx(this, "reduceRight", n, e);
  },
  shift() {
    return sd(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(n, e) {
    return As(this, "some", n, e, void 0, arguments);
  },
  splice(...n) {
    return sd(this, "splice", n);
  },
  toReversed() {
    return ka(this).toReversed();
  },
  toSorted(n) {
    return ka(this).toSorted(n);
  },
  toSpliced(...n) {
    return ka(this).toSpliced(...n);
  },
  unshift(...n) {
    return sd(this, "unshift", n);
  },
  values() {
    return Um(this, "values", (n) => bs(this, n));
  }
};
function Um(n, e, t) {
  const i = Qf(n), s = i[e]();
  return i !== n && !/* @__PURE__ */ Li(n) && (s._next = s.next, s.next = () => {
    const o = s._next();
    return o.done || (o.value = t(o.value)), o;
  }), s;
}
const ZP = Array.prototype;
function As(n, e, t, i, s, o) {
  const r = Qf(n), a = r !== n && !/* @__PURE__ */ Li(n), l = r[e];
  if (l !== ZP[e]) {
    const h = l.apply(n, o);
    return a ? Fi(h) : h;
  }
  let d = t;
  r !== n && (a ? d = function(h, f) {
    return t.call(this, bs(n, h), f, n);
  } : t.length > 2 && (d = function(h, f) {
    return t.call(this, h, f, n);
  }));
  const c = l.call(r, d, i);
  return a && s ? s(c) : c;
}
function Vx(n, e, t, i) {
  const s = Qf(n), o = s !== n && !/* @__PURE__ */ Li(n);
  let r = t, a = !1;
  s !== n && (o ? (a = i.length === 0, r = function(d, c, h) {
    return a && (a = !1, d = bs(n, d)), t.call(this, d, bs(n, c), h, n);
  }) : t.length > 3 && (r = function(d, c, h) {
    return t.call(this, d, c, h, n);
  }));
  const l = s[e](r, ...i);
  return a ? bs(n, l) : l;
}
function Gm(n, e, t) {
  const i = /* @__PURE__ */ Et(n);
  Vn(i, "iterate", Pc);
  const s = i[e](...t);
  return (s === -1 || s === !1) && /* @__PURE__ */ b1(t[0]) ? (t[0] = /* @__PURE__ */ Et(t[0]), i[e](...t)) : s;
}
function sd(n, e, t = []) {
  Jo(), u1();
  const i = (/* @__PURE__ */ Et(n))[e].apply(n, t);
  return h1(), Zo(), i;
}
const QP = /* @__PURE__ */ a1("__proto__,__v_isRef,__isVue"), r5 = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((n) => n !== "arguments" && n !== "caller").map((n) => Symbol[n]).filter(is)
);
function eE(n) {
  is(n) || (n = String(n));
  const e = /* @__PURE__ */ Et(this);
  return Vn(e, "has", n), e.hasOwnProperty(n);
}
class a5 {
  constructor(e = !1, t = !1) {
    this._isReadonly = e, this._isShallow = t;
  }
  get(e, t, i) {
    if (t === "__v_skip") return e.__v_skip;
    const s = this._isReadonly, o = this._isShallow;
    if (t === "__v_isReactive")
      return !s;
    if (t === "__v_isReadonly")
      return s;
    if (t === "__v_isShallow")
      return o;
    if (t === "__v_raw")
      return i === (s ? o ? cE : u5 : o ? c5 : d5).get(e) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(e) === Object.getPrototypeOf(i) ? e : void 0;
    const r = mt(e);
    if (!s) {
      let l;
      if (r && (l = JP[t]))
        return l;
      if (t === "hasOwnProperty")
        return eE;
    }
    const a = Reflect.get(
      e,
      t,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      /* @__PURE__ */ ai(e) ? e : i
    );
    if ((is(t) ? r5.has(t) : QP(t)) || (s || Vn(e, "get", t), o))
      return a;
    if (/* @__PURE__ */ ai(a)) {
      const l = r && l1(t) ? a : a.value;
      return s && qt(l) ? /* @__PURE__ */ pv(l) : l;
    }
    return qt(a) ? s ? /* @__PURE__ */ pv(a) : /* @__PURE__ */ Xt(a) : a;
  }
}
class l5 extends a5 {
  constructor(e = !1) {
    super(!1, e);
  }
  set(e, t, i, s) {
    let o = e[t];
    const r = mt(e) && l1(t);
    if (!this._isShallow) {
      const d = /* @__PURE__ */ _s(o);
      if (!/* @__PURE__ */ Li(i) && !/* @__PURE__ */ _s(i) && (o = /* @__PURE__ */ Et(o), i = /* @__PURE__ */ Et(i)), !r && /* @__PURE__ */ ai(o) && !/* @__PURE__ */ ai(i))
        return d || (o.value = i), !0;
    }
    const a = r ? Number(t) < e.length : jt(e, t), l = Reflect.set(
      e,
      t,
      i,
      /* @__PURE__ */ ai(e) ? e : s
    );
    return e === /* @__PURE__ */ Et(s) && l && (a ? ys(i, o) && Ws(e, "set", t, i) : Ws(e, "add", t, i)), l;
  }
  deleteProperty(e, t) {
    const i = jt(e, t);
    e[t];
    const s = Reflect.deleteProperty(e, t);
    return s && i && Ws(e, "delete", t, void 0), s;
  }
  has(e, t) {
    const i = Reflect.has(e, t);
    return (!is(t) || !r5.has(t)) && Vn(e, "has", t), i;
  }
  ownKeys(e) {
    return Vn(
      e,
      "iterate",
      mt(e) ? "length" : ta
    ), Reflect.ownKeys(e);
  }
}
class tE extends a5 {
  constructor(e = !1) {
    super(!0, e);
  }
  set(e, t) {
    return !0;
  }
  deleteProperty(e, t) {
    return !0;
  }
}
const nE = /* @__PURE__ */ new l5(), iE = /* @__PURE__ */ new tE(), sE = /* @__PURE__ */ new l5(!0);
const uv = (n) => n, Pu = (n) => Reflect.getPrototypeOf(n);
function oE(n, e, t) {
  return function(...i) {
    const s = this.__v_raw, o = /* @__PURE__ */ Et(s), r = jo(o), a = n === "entries" || n === Symbol.iterator && r, l = n === "keys" && r, d = s[n](...i), c = t ? uv : e ? Qo : Fi;
    return !e && Vn(
      o,
      "iterate",
      l ? cv : ta
    ), gi(
      // inheriting all iterator properties
      Object.create(d),
      {
        // iterator protocol
        next() {
          const { value: h, done: f } = d.next();
          return f ? { value: h, done: f } : {
            value: a ? [c(h[0]), c(h[1])] : c(h),
            done: f
          };
        }
      }
    );
  };
}
function Eu(n) {
  return function(...e) {
    return n === "delete" ? !1 : n === "clear" ? void 0 : this;
  };
}
function rE(n, e) {
  const t = {
    get(s) {
      const o = this.__v_raw, r = /* @__PURE__ */ Et(o), a = /* @__PURE__ */ Et(s);
      n || (ys(s, a) && Vn(r, "get", s), Vn(r, "get", a));
      const { has: l } = Pu(r), d = e ? uv : n ? Qo : Fi;
      if (l.call(r, s))
        return d(o.get(s));
      if (l.call(r, a))
        return d(o.get(a));
      o !== r && o.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !n && Vn(/* @__PURE__ */ Et(s), "iterate", ta), s.size;
    },
    has(s) {
      const o = this.__v_raw, r = /* @__PURE__ */ Et(o), a = /* @__PURE__ */ Et(s);
      return n || (ys(s, a) && Vn(r, "has", s), Vn(r, "has", a)), s === a ? o.has(s) : o.has(s) || o.has(a);
    },
    forEach(s, o) {
      const r = this, a = r.__v_raw, l = /* @__PURE__ */ Et(a), d = e ? uv : n ? Qo : Fi;
      return !n && Vn(l, "iterate", ta), a.forEach((c, h) => s.call(o, d(c), d(h), r));
    }
  };
  return gi(
    t,
    n ? {
      add: Eu("add"),
      set: Eu("set"),
      delete: Eu("delete"),
      clear: Eu("clear")
    } : {
      add(s) {
        const o = /* @__PURE__ */ Et(this), r = Pu(o), a = /* @__PURE__ */ Et(s), l = !e && !/* @__PURE__ */ Li(s) && !/* @__PURE__ */ _s(s) ? a : s;
        return r.has.call(o, l) || ys(s, l) && r.has.call(o, s) || ys(a, l) && r.has.call(o, a) || (o.add(l), Ws(o, "add", l, l)), this;
      },
      set(s, o) {
        !e && !/* @__PURE__ */ Li(o) && !/* @__PURE__ */ _s(o) && (o = /* @__PURE__ */ Et(o));
        const r = /* @__PURE__ */ Et(this), { has: a, get: l } = Pu(r);
        let d = a.call(r, s);
        d || (s = /* @__PURE__ */ Et(s), d = a.call(r, s));
        const c = l.call(r, s);
        return r.set(s, o), d ? ys(o, c) && Ws(r, "set", s, o) : Ws(r, "add", s, o), this;
      },
      delete(s) {
        const o = /* @__PURE__ */ Et(this), { has: r, get: a } = Pu(o);
        let l = r.call(o, s);
        l || (s = /* @__PURE__ */ Et(s), l = r.call(o, s)), a && a.call(o, s);
        const d = o.delete(s);
        return l && Ws(o, "delete", s, void 0), d;
      },
      clear() {
        const s = /* @__PURE__ */ Et(this), o = s.size !== 0, r = s.clear();
        return o && Ws(
          s,
          "clear",
          void 0,
          void 0
        ), r;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    t[s] = oE(s, n, e);
  }), t;
}
function m1(n, e) {
  const t = rE(n, e);
  return (i, s, o) => s === "__v_isReactive" ? !n : s === "__v_isReadonly" ? n : s === "__v_raw" ? i : Reflect.get(
    jt(t, s) && s in i ? t : i,
    s,
    o
  );
}
const aE = {
  get: /* @__PURE__ */ m1(!1, !1)
}, lE = {
  get: /* @__PURE__ */ m1(!1, !0)
}, dE = {
  get: /* @__PURE__ */ m1(!0, !1)
};
const d5 = /* @__PURE__ */ new WeakMap(), c5 = /* @__PURE__ */ new WeakMap(), u5 = /* @__PURE__ */ new WeakMap(), cE = /* @__PURE__ */ new WeakMap();
function uE(n) {
  switch (n) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
// @__NO_SIDE_EFFECTS__
function Xt(n) {
  return /* @__PURE__ */ _s(n) ? n : g1(
    n,
    !1,
    nE,
    aE,
    d5
  );
}
// @__NO_SIDE_EFFECTS__
function hv(n) {
  return g1(
    n,
    !1,
    sE,
    lE,
    c5
  );
}
// @__NO_SIDE_EFFECTS__
function pv(n) {
  return g1(
    n,
    !0,
    iE,
    dE,
    u5
  );
}
function g1(n, e, t, i, s) {
  if (!qt(n) || n.__v_raw && !(e && n.__v_isReactive) || n.__v_skip || !Object.isExtensible(n))
    return n;
  const o = s.get(n);
  if (o)
    return o;
  const r = uE(OP(n));
  if (r === 0)
    return n;
  const a = new Proxy(
    n,
    r === 2 ? i : t
  );
  return s.set(n, a), a;
}
// @__NO_SIDE_EFFECTS__
function Ho(n) {
  return /* @__PURE__ */ _s(n) ? /* @__PURE__ */ Ho(n.__v_raw) : !!(n && n.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function _s(n) {
  return !!(n && n.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Li(n) {
  return !!(n && n.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function b1(n) {
  return n ? !!n.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function Et(n) {
  const e = n && n.__v_raw;
  return e ? /* @__PURE__ */ Et(e) : n;
}
function mp(n) {
  return !jt(n, "__v_skip") && Object.isExtensible(n) && W3(n, "__v_skip", !0), n;
}
const Fi = (n) => qt(n) ? /* @__PURE__ */ Xt(n) : n, Qo = (n) => qt(n) ? /* @__PURE__ */ pv(n) : n;
// @__NO_SIDE_EFFECTS__
function ai(n) {
  return n ? n.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function W(n) {
  return h5(n, !1);
}
// @__NO_SIDE_EFFECTS__
function qe(n) {
  return h5(n, !0);
}
function h5(n, e) {
  return /* @__PURE__ */ ai(n) ? n : new hE(n, e);
}
class hE {
  constructor(e, t) {
    this.dep = new f1(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e : /* @__PURE__ */ Et(e), this._value = t ? e : Fi(e), this.__v_isShallow = t;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(e) {
    const t = this._rawValue, i = this.__v_isShallow || /* @__PURE__ */ Li(e) || /* @__PURE__ */ _s(e);
    e = i ? e : /* @__PURE__ */ Et(e), ys(e, t) && (this._rawValue = e, this._value = i ? e : Fi(e), this.dep.trigger());
  }
}
function xs(n) {
  n.dep && n.dep.trigger();
}
function m(n) {
  return /* @__PURE__ */ ai(n) ? n.value : n;
}
const pE = {
  get: (n, e, t) => e === "__v_raw" ? n : m(Reflect.get(n, e, t)),
  set: (n, e, t, i) => {
    const s = n[e];
    return /* @__PURE__ */ ai(s) && !/* @__PURE__ */ ai(t) ? (s.value = t, !0) : Reflect.set(n, e, t, i);
  }
};
function p5(n) {
  return /* @__PURE__ */ Ho(n) ? n : new Proxy(n, pE);
}
class fE {
  constructor(e, t, i) {
    this.fn = e, this.setter = t, this._value = void 0, this.dep = new f1(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Ac - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = i;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Ht !== this)
      return e5(this, !0), !0;
  }
  get value() {
    const e = this.dep.track();
    return i5(this), e && (e.version = this.dep.version), this._value;
  }
  set value(e) {
    this.setter && this.setter(e);
  }
}
// @__NO_SIDE_EFFECTS__
function mE(n, e, t = !1) {
  let i, s;
  return Ft(n) ? i = n : (i = n.get, s = n.set), new fE(i, s, t);
}
const Ru = {}, Gp = /* @__PURE__ */ new WeakMap();
let Ir;
function gE(n, e = !1, t = Ir) {
  if (t) {
    let i = Gp.get(t);
    i || Gp.set(t, i = []), i.push(n);
  }
}
function bE(n, e, t = en) {
  const { immediate: i, deep: s, once: o, scheduler: r, augmentJob: a, call: l } = t, d = (_) => s ? _ : /* @__PURE__ */ Li(_) || s === !1 || s === 0 ? qs(_, 1) : qs(_);
  let c, h, f, p, y = !1, v = !1;
  if (/* @__PURE__ */ ai(n) ? (h = () => n.value, y = /* @__PURE__ */ Li(n)) : /* @__PURE__ */ Ho(n) ? (h = () => d(n), y = !0) : mt(n) ? (v = !0, y = n.some((_) => /* @__PURE__ */ Ho(_) || /* @__PURE__ */ Li(_)), h = () => n.map((_) => {
    if (/* @__PURE__ */ ai(_))
      return _.value;
    if (/* @__PURE__ */ Ho(_))
      return d(_);
    if (Ft(_))
      return l ? l(_, 2) : _();
  })) : Ft(n) ? e ? h = l ? () => l(n, 2) : n : h = () => {
    if (f) {
      Jo();
      try {
        f();
      } finally {
        Zo();
      }
    }
    const _ = Ir;
    Ir = c;
    try {
      return l ? l(n, 3, [p]) : n(p);
    } finally {
      Ir = _;
    }
  } : h = ea, e && s) {
    const _ = h, T = s === !0 ? 1 / 0 : s;
    h = () => qs(_(), T);
  }
  const x = KP(), w = () => {
    c.stop(), x && x.active && G3(x.effects, c);
  };
  if (o && e) {
    const _ = e;
    e = (...T) => {
      const k = _(...T);
      return w(), k;
    };
  }
  let S = v ? new Array(n.length).fill(Ru) : Ru;
  const M = (_) => {
    if (!(!(c.flags & 1) || !c.dirty && !_))
      if (e) {
        const T = c.run();
        if (_ || s || y || (v ? T.some((k, P) => ys(k, S[P])) : ys(T, S))) {
          f && f();
          const k = Ir;
          Ir = c;
          try {
            const P = [
              T,
              // pass undefined as the old value when it's changed for the first time
              S === Ru ? void 0 : v && S[0] === Ru ? [] : S,
              p
            ];
            S = T, l ? l(e, 3, P) : (
              // @ts-expect-error
              e(...P)
            );
          } finally {
            Ir = k;
          }
        }
      } else
        c.run();
  };
  return a && a(M), c = new Z3(h), c.scheduler = r ? () => r(M, !1) : M, p = (_) => gE(_, !1, c), f = c.onStop = () => {
    const _ = Gp.get(c);
    if (_) {
      if (l)
        l(_, 4);
      else
        for (const T of _) T();
      Gp.delete(c);
    }
  }, e ? i ? M(!0) : S = c.run() : r ? r(M.bind(null, !0), !0) : c.run(), w.pause = c.pause.bind(c), w.resume = c.resume.bind(c), w.stop = w, w;
}
function qs(n, e = 1 / 0, t) {
  if (e <= 0 || !qt(n) || n.__v_skip || (t = t || /* @__PURE__ */ new Map(), (t.get(n) || 0) >= e))
    return n;
  if (t.set(n, e), e--, /* @__PURE__ */ ai(n))
    qs(n.value, e, t);
  else if (mt(n))
    for (let i = 0; i < n.length; i++)
      qs(n[i], e, t);
  else if (Il(n) || jo(n))
    n.forEach((i) => {
      qs(i, e, t);
    });
  else if (V3(n)) {
    for (const i in n)
      qs(n[i], e, t);
    for (const i of Object.getOwnPropertySymbols(n))
      Object.prototype.propertyIsEnumerable.call(n, i) && qs(n[i], e, t);
  }
  return n;
}
function bu(n, e, t, i) {
  try {
    return i ? n(...i) : n();
  } catch (s) {
    em(s, e, t);
  }
}
function ss(n, e, t, i) {
  if (Ft(n)) {
    const s = bu(n, e, t, i);
    return s && j3(s) && s.catch((o) => {
      em(o, e, t);
    }), s;
  }
  if (mt(n)) {
    const s = [];
    for (let o = 0; o < n.length; o++)
      s.push(ss(n[o], e, t, i));
    return s;
  }
}
function em(n, e, t, i = !0) {
  const s = e ? e.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: r } = e && e.appContext.config || en;
  if (e) {
    let a = e.parent;
    const l = e.proxy, d = `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let h = 0; h < c.length; h++)
          if (c[h](n, l, d) === !1)
            return;
      }
      a = a.parent;
    }
    if (o) {
      Jo(), bu(o, null, 10, [
        n,
        l,
        d
      ]), Zo();
      return;
    }
  }
  vE(n, t, s, i, r);
}
function vE(n, e, t, i = !0, s = !1) {
  if (s)
    throw n;
  console.error(n);
}
const ii = [];
let fs = -1;
const cl = [];
let Po = null, qa = 0;
const f5 = /* @__PURE__ */ Promise.resolve();
let jp = null;
function nt(n) {
  const e = jp || f5;
  return n ? e.then(this ? n.bind(this) : n) : e;
}
function yE(n) {
  let e = fs + 1, t = ii.length;
  for (; e < t; ) {
    const i = e + t >>> 1, s = ii[i], o = Ec(s);
    o < n || o === n && s.flags & 2 ? e = i + 1 : t = i;
  }
  return e;
}
function v1(n) {
  if (!(n.flags & 1)) {
    const e = Ec(n), t = ii[ii.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(n.flags & 2) && e >= Ec(t) ? ii.push(n) : ii.splice(yE(e), 0, n), n.flags |= 1, m5();
  }
}
function m5() {
  jp || (jp = f5.then(b5));
}
function xE(n) {
  if (!mt(n))
    Po && n.id === -1 ? Po.splice(qa + 1, 0, n) : n.flags & 1 || (cl.push(n), n.flags |= 1);
  else
    for (let e = 0; e < n.length; e++)
      cl.push(n[e]);
  m5();
}
function Wx(n, e, t = fs + 1) {
  for (; t < ii.length; t++) {
    const i = ii[t];
    if (i && i.flags & 2) {
      if (n && i.id !== n.uid)
        continue;
      ii.splice(t, 1), t--, i.flags & 4 && (i.flags &= -2), i(), i.flags & 4 || (i.flags &= -2);
    }
  }
}
function g5(n) {
  if (cl.length) {
    const e = [...new Set(cl)].sort(
      (t, i) => Ec(t) - Ec(i)
    );
    if (cl.length = 0, Po) {
      for (let t = 0; t < e.length; t++)
        Po.push(e[t]);
      return;
    }
    for (Po = e, qa = 0; qa < Po.length; qa++) {
      const t = Po[qa];
      t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2;
    }
    Po = null, qa = 0;
  }
}
const Ec = (n) => n.id == null ? n.flags & 2 ? -1 : 1 / 0 : n.id;
function b5(n) {
  try {
    for (fs = 0; fs < ii.length; fs++) {
      const e = ii[fs];
      e && !(e.flags & 8) && (e.flags & 4 && (e.flags &= -2), bu(
        e,
        e.i,
        e.i ? 15 : 14
      ), e.flags & 4 || (e.flags &= -2));
    }
  } finally {
    for (; fs < ii.length; fs++) {
      const e = ii[fs];
      e && (e.flags &= -2);
    }
    fs = -1, ii.length = 0, g5(), jp = null, (ii.length || cl.length) && b5();
  }
}
let Un = null, v5 = null;
function Hp(n) {
  const e = Un;
  return Un = n, v5 = n && n.type.__scopeId || null, e;
}
function Xe(n, e = Un, t) {
  if (!e || n._n)
    return n;
  const i = (...s) => {
    i._d && qp(-1);
    const o = Hp(e), r = Xs.length;
    let a;
    try {
      a = n(...s);
    } finally {
      for (let l = Xs.length; l > r; l--) T1();
      Hp(o), i._d && qp(1);
    }
    return a;
  };
  return i._n = !0, i._c = !0, i._d = !0, i;
}
function _t(n, e) {
  if (Un === null)
    return n;
  const t = om(Un), i = n.dirs || (n.dirs = []);
  for (let s = 0; s < e.length; s++) {
    let [o, r, a, l = en] = e[s];
    o && (Ft(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && qs(r), i.push({
      dir: o,
      instance: t,
      value: r,
      oldValue: void 0,
      arg: a,
      modifiers: l
    }));
  }
  return n;
}
function pr(n, e, t, i) {
  const s = n.dirs, o = e && e.dirs;
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    o && (a.oldValue = o[r].value);
    let l = a.dir[i];
    l && (Jo(), ss(l, t, 8, [
      n.el,
      a,
      n,
      e
    ]), Zo());
  }
}
function y5(n, e) {
  if (pi) {
    let t = pi.provides;
    const i = pi.parent && pi.parent.provides;
    i === t && (t = pi.provides = Object.create(i)), t[n] = e;
  }
}
function tm(n, e, t = !1) {
  const i = Wl();
  if (i || hl) {
    let s = hl ? hl._context.provides : i ? i.parent == null || i.ce ? i.vnode.appContext && i.vnode.appContext.provides : i.parent.provides : void 0;
    if (s && n in s)
      return s[n];
    if (arguments.length > 1)
      return t && Ft(e) ? e.call(i && i.proxy) : e;
  }
}
const wE = /* @__PURE__ */ Symbol.for("v-scx"), kE = () => tm(wE);
function _E(n, e) {
  return x5(n, null, e);
}
function Ee(n, e, t) {
  return x5(n, e, t);
}
function x5(n, e, t = en) {
  const { immediate: i, deep: s, flush: o, once: r } = t, a = gi({}, t), l = e && i || !e && o !== "post";
  let d;
  if (Oc) {
    if (o === "sync") {
      const p = kE();
      d = p.__watcherHandles || (p.__watcherHandles = []);
    } else if (!l) {
      const p = () => {
      };
      return p.stop = ea, p.resume = ea, p.pause = ea, p;
    }
  }
  const c = pi;
  a.call = (p, y, v) => ss(p, c, y, v);
  let h = !1;
  o === "post" ? a.scheduler = (p) => {
    ei(p, c && c.suspense);
  } : o !== "sync" && (h = !0, a.scheduler = (p, y) => {
    y ? p() : v1(p);
  }), a.augmentJob = (p) => {
    e && (p.flags |= 4), h && (p.flags |= 2, c && (p.id = c.uid, p.i = c));
  };
  const f = bE(n, e, a);
  return Oc && (d ? d.push(f) : l && f()), f;
}
const To = /* @__PURE__ */ new WeakMap(), w5 = /* @__PURE__ */ Symbol("_vte"), nm = (n) => n.__isTeleport, Fr = (n) => n && (n.disabled || n.disabled === ""), SE = (n) => n && (n.defer || n.defer === ""), qx = (n) => typeof SVGElement != "undefined" && n instanceof SVGElement, Kx = (n) => typeof MathMLElement == "function" && n instanceof MathMLElement, fv = (n, e) => {
  const t = n && n.to;
  return on(t) ? e ? e(t) : null : t;
}, ME = {
  name: "Teleport",
  __isTeleport: !0,
  process(n, e, t, i, s, o, r, a, l, d) {
    const {
      mc: c,
      pc: h,
      pbc: f,
      o: { insert: p, querySelector: y, createText: v, createComment: x, parentNode: w }
    } = d, S = Fr(e.props);
    let { dynamicChildren: M } = e;
    const _ = (P, A, R) => {
      P.shapeFlag & 16 && c(
        P.children,
        A,
        R,
        s,
        o,
        r,
        a,
        l
      );
    }, T = (P = e) => {
      const A = Fr(P.props), R = P.target = fv(P.props, y), D = mv(R, P, v, p);
      R && (r !== "svg" && qx(R) ? r = "svg" : r !== "mathml" && Kx(R) && (r = "mathml"), s && s.isCE && (s.ce._teleportTargets || (s.ce._teleportTargets = /* @__PURE__ */ new Set())).add(R), A || (_(P, R, D), Gd(P, !1)));
    }, k = (P) => {
      const A = () => {
        if (To.get(P) === A) {
          if (To.delete(P), Fr(P.props)) {
            const R = w(P.el) || t;
            _(P, R, P.anchor), Gd(P, !0);
          }
          T(P);
        }
      };
      To.set(P, A), ei(A, o);
    };
    if (n == null) {
      const P = e.el = v(""), A = e.anchor = v("");
      if (p(P, t, i), p(A, t, i), SE(e.props) || o && o.pendingBranch) {
        k(e);
        return;
      }
      S && (_(e, t, A), Gd(e, !0)), T();
    } else {
      e.el = n.el;
      const P = e.anchor = n.anchor, A = To.get(n);
      if (A) {
        A.flags |= 8, To.delete(n), k(e);
        return;
      }
      e.targetStart = n.targetStart;
      const R = e.target = n.target, D = e.targetAnchor = n.targetAnchor, O = Fr(n.props), F = O ? t : R, ie = O ? P : D;
      if (r === "svg" || qx(R) ? r = "svg" : (r === "mathml" || Kx(R)) && (r = "mathml"), M ? (f(
        n.dynamicChildren,
        M,
        F,
        s,
        o,
        r,
        a
      ), M1(n, e, !0)) : l || h(
        n,
        e,
        F,
        ie,
        s,
        o,
        r,
        a,
        !1
      ), S)
        O ? e.props && n.props && e.props.to !== n.props.to && (e.props.to = n.props.to) : zu(
          e,
          t,
          P,
          d,
          1
        );
      else if ((e.props && e.props.to) !== (n.props && n.props.to)) {
        const ee = fv(e.props, y);
        ee && (e.target = ee, zu(
          e,
          ee,
          null,
          d,
          0
        ));
      } else O && zu(
        e,
        R,
        D,
        d,
        1
      );
      Gd(e, S);
    }
  },
  remove(n, e, t, { um: i, o: { remove: s } }, o) {
    const {
      shapeFlag: r,
      children: a,
      anchor: l,
      targetStart: d,
      targetAnchor: c,
      target: h,
      props: f
    } = n, p = Fr(f), y = o || !p, v = To.get(n);
    if (v && (v.flags |= 8, To.delete(n)), h && (s(d), s(c)), o && s(l), !v && (p || h) && r & 16)
      for (let x = 0; x < a.length; x++) {
        const w = a[x];
        i(
          w,
          e,
          t,
          y,
          !!w.dynamicChildren
        );
      }
  },
  move: zu,
  hydrate: TE
};
function zu(n, e, t, { o: { insert: i }, m: s }, o = 2) {
  o === 0 && i(n.targetAnchor, e, t);
  const { el: r, anchor: a, shapeFlag: l, children: d, props: c } = n, h = o === 2;
  if (h && i(r, e, t), !To.has(n) && (!h || Fr(c)) && l & 16)
    for (let f = 0; f < d.length; f++)
      s(
        d[f],
        e,
        t,
        2
      );
  h && i(a, e, t);
}
function TE(n, e, t, i, s, o, {
  o: { nextSibling: r, parentNode: a, querySelector: l, insert: d, createText: c }
}, h) {
  function f(x, w) {
    let S = w;
    for (; S; ) {
      if (S && S.nodeType === 8) {
        if (S.data === "teleport start anchor")
          e.targetStart = S;
        else if (S.data === "teleport anchor") {
          e.targetAnchor = S, x._lpa = e.targetAnchor && r(e.targetAnchor);
          break;
        }
      }
      S = r(S);
    }
  }
  function p(x, w) {
    w.anchor = h(
      r(x),
      w,
      a(x),
      t,
      i,
      s,
      o
    );
  }
  const y = e.target = fv(
    e.props,
    l
  ), v = Fr(e.props);
  if (y) {
    const x = y._lpa || y.firstChild;
    e.shapeFlag & 16 && (v ? (p(n, e), f(y, x), e.targetAnchor || mv(
      y,
      e,
      c,
      d,
      // if target is the same as the main view, insert anchors before current node
      // to avoid hydrating mismatch
      a(n) === y ? n : null
    )) : (e.anchor = r(n), f(y, x), e.targetAnchor || mv(y, e, c, d), h(
      x && r(x),
      e,
      y,
      t,
      i,
      s,
      o
    ))), Gd(e, v);
  } else v && e.shapeFlag & 16 && (p(n, e), e.targetStart = n, e.targetAnchor = r(n));
  return e.anchor && r(e.anchor);
}
const y1 = ME;
function Gd(n, e) {
  const t = n.ctx;
  if (t && t.ut) {
    let i, s;
    for (e ? (i = n.el, s = n.anchor) : (i = n.targetStart, s = n.targetAnchor); i && i !== s; )
      i.nodeType === 1 && i.setAttribute("data-v-owner", t.uid), i = i.nextSibling;
    t.ut();
  }
}
function mv(n, e, t, i, s = null) {
  const o = e.targetStart = t(""), r = e.targetAnchor = t("");
  return o[w5] = r, n && (i(o, n, s), i(r, n, s)), r;
}
const $i = /* @__PURE__ */ Symbol("_leaveCb"), od = /* @__PURE__ */ Symbol("_enterCb");
function k5() {
  const n = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return it(() => {
    n.isMounted = !0;
  }), We(() => {
    n.isUnmounting = !0;
  }), n;
}
const Pi = [Function, Array], _5 = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Pi,
  onEnter: Pi,
  onAfterEnter: Pi,
  onEnterCancelled: Pi,
  // leave
  onBeforeLeave: Pi,
  onLeave: Pi,
  onAfterLeave: Pi,
  onLeaveCancelled: Pi,
  // appear
  onBeforeAppear: Pi,
  onAppear: Pi,
  onAfterAppear: Pi,
  onAppearCancelled: Pi
}, S5 = (n) => {
  const e = n.subTree;
  return e.component ? S5(e.component) : e;
}, CE = {
  name: "BaseTransition",
  props: _5,
  setup(n, { slots: e }) {
    const t = Wl(), i = k5();
    return () => {
      const s = e.default && x1(e.default(), !0), o = s && s.length ? M5(s) : (
        // Keep explicit default-slot conditionals on the same transition path
        // as regular v-if branches, which render a comment placeholder.
        t.subTree ? z() : void 0
      );
      if (!o)
        return;
      const r = /* @__PURE__ */ Et(n), { mode: a } = r;
      if (i.isLeaving)
        return jm(o);
      const l = Vp(o);
      if (!l)
        return jm(o);
      let d = Rc(
        l,
        r,
        i,
        t,
        // #11061, ensure enterHooks is fresh after clone
        (h) => d = h
      );
      l.type !== qn && la(l, d);
      let c = t.subTree && Vp(t.subTree);
      if (c && c.type !== qn && !Nr(c, l) && S5(t).type !== qn) {
        let h = Rc(
          c,
          r,
          i,
          t
        );
        if (la(c, h), a === "out-in" && l.type !== qn)
          return i.isLeaving = !0, h.afterLeave = () => {
            i.isLeaving = !1, t.job.flags & 8 || t.update(), delete h.afterLeave, c = void 0;
          }, jm(o);
        a === "in-out" && l.type !== qn ? h.delayLeave = (f, p, y) => {
          const v = T5(
            i,
            c
          );
          v[String(c.key)] = c, f[$i] = () => {
            p(), f[$i] = void 0, delete d.delayedLeave, c = void 0;
          }, d.delayedLeave = () => {
            y(), delete d.delayedLeave, c = void 0;
          };
        } : c = void 0;
      } else c && (c = void 0);
      return o;
    };
  }
};
function M5(n) {
  let e = n[0];
  if (n.length > 1) {
    for (const t of n)
      if (t.type !== qn) {
        e = t;
        break;
      }
  }
  return e;
}
const IE = CE;
function T5(n, e) {
  const { leavingVNodes: t } = n;
  let i = t.get(e.type);
  return i || (i = /* @__PURE__ */ Object.create(null), t.set(e.type, i)), i;
}
function Rc(n, e, t, i, s) {
  const {
    appear: o,
    mode: r,
    persisted: a = !1,
    onBeforeEnter: l,
    onEnter: d,
    onAfterEnter: c,
    onEnterCancelled: h,
    onBeforeLeave: f,
    onLeave: p,
    onAfterLeave: y,
    onLeaveCancelled: v,
    onBeforeAppear: x,
    onAppear: w,
    onAfterAppear: S,
    onAppearCancelled: M
  } = e, _ = String(n.key), T = T5(t, n), k = (R, D) => {
    R && ss(
      R,
      i,
      9,
      D
    );
  }, P = (R, D) => {
    const O = D[1];
    k(R, D), mt(R) ? R.every((F) => F.length <= 1) && O() : R.length <= 1 && O();
  }, A = {
    mode: r,
    persisted: a,
    beforeEnter(R) {
      let D = l;
      if (!t.isMounted)
        if (o)
          D = x || l;
        else
          return;
      R[$i] && R[$i](
        !0
        /* cancelled */
      );
      const O = T[_];
      O && Nr(n, O) && O.el[$i] && O.el[$i](), k(D, [R]);
    },
    enter(R) {
      if (T[_] === n) return;
      let D = d, O = c, F = h;
      if (!t.isMounted)
        if (o)
          D = w || d, O = S || c, F = M || h;
        else
          return;
      let ie = !1;
      R[od] = (me) => {
        ie || (ie = !0, me ? k(F, [R]) : k(O, [R]), A.delayedLeave && A.delayedLeave(), R[od] = void 0);
      };
      const ee = R[od].bind(null, !1);
      D ? P(D, [R, ee]) : ee();
    },
    leave(R, D) {
      const O = String(n.key);
      if (R[od] && R[od](
        !0
        /* cancelled */
      ), t.isUnmounting)
        return D();
      k(f, [R]);
      let F = !1;
      R[$i] = (ee) => {
        F || (F = !0, D(), ee ? k(v, [R]) : k(y, [R]), R[$i] = void 0, T[O] === n && delete T[O]);
      };
      const ie = R[$i].bind(null, !1);
      T[O] = n, p ? P(p, [R, ie]) : ie();
    },
    clone(R) {
      const D = Rc(
        R,
        e,
        t,
        i,
        s
      );
      return s && s(D), D;
    }
  };
  return A;
}
function jm(n) {
  if (w1(n))
    return n = er(n), n.children = null, n;
}
function Vp(n) {
  if (!w1(n))
    return nm(n.type) && n.children ? M5(n.children) : n;
  if (n.component)
    return n.component.subTree;
  const { shapeFlag: e, children: t } = n;
  if (t) {
    if (e & 16)
      return t[0];
    if (e & 32 && Ft(t.default))
      return t.default();
  }
}
function la(n, e) {
  if (n.shapeFlag & 6 && n.component) {
    n.transition = e;
    const t = n.component.subTree;
    la(
      nm(t.type) && Vp(t) || t,
      e
    );
  } else n.shapeFlag & 128 ? (n.ssContent.transition = e.clone(n.ssContent), n.ssFallback.transition = e.clone(n.ssFallback)) : n.transition = e;
}
function x1(n, e = !1, t) {
  let i = [], s = 0;
  for (let o = 0; o < n.length; o++) {
    let r = n[o];
    const a = t == null ? r.key : String(t) + String(r.key != null ? r.key : o);
    r.type === j ? (r.patchFlag & 128 && s++, i = i.concat(
      x1(r.children, e, a)
    )) : (e || r.type !== qn) && i.push(a != null ? er(r, { key: a }) : r);
  }
  if (s > 1)
    for (let o = 0; o < i.length; o++)
      i[o].patchFlag = -2;
  return i;
}
// @__NO_SIDE_EFFECTS__
function Pe(n, e) {
  return Ft(n) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    gi({ name: n.name }, e, { setup: n })
  ) : n;
}
function AE() {
  const n = Wl();
  return n ? (n.appContext.config.idPrefix || "v") + "-" + n.ids[0] + n.ids[1]++ : "";
}
function PE(n) {
  n.ids = [n.ids[0] + n.ids[2]++ + "-", 0, 0];
}
function Yx(n, e) {
  let t;
  return !!((t = Object.getOwnPropertyDescriptor(n, e)) && !t.configurable);
}
const Wp = /* @__PURE__ */ new WeakMap();
function ac(n, e, t, i, s = !1) {
  if (mt(n)) {
    n.forEach(
      (v, x) => ac(
        v,
        e && (mt(e) ? e[x] : e),
        t,
        i,
        s
      )
    );
    return;
  }
  if (ul(i) && !s) {
    i.shapeFlag & 512 && i.type.__asyncResolved && i.component.subTree.component && ac(n, e, t, i.component.subTree);
    return;
  }
  const o = i.shapeFlag & 4 ? om(i.component) : i.el, r = s ? null : o, { i: a, r: l } = n, d = e && e.r, c = a.refs === en ? a.refs = {} : a.refs, h = a.setupState, f = /* @__PURE__ */ Et(h), p = h === en ? U3 : (v) => Yx(c, v) ? !1 : jt(f, v), y = (v, x) => !(x && Yx(c, x));
  if (d != null && d !== l) {
    if (Xx(e), on(d))
      c[d] = null, p(d) && (h[d] = null);
    else if (/* @__PURE__ */ ai(d)) {
      const v = e;
      y(d, v.k) && (d.value = null), v.k && (c[v.k] = null);
    }
  }
  if (Ft(l))
    bu(l, a, 12, [r, c]);
  else {
    const v = on(l), x = /* @__PURE__ */ ai(l);
    if (v || x) {
      const w = () => {
        if (n.f) {
          const S = v ? p(l) ? h[l] : c[l] : y() || !n.k ? l.value : c[n.k];
          if (s)
            mt(S) && G3(S, o);
          else if (mt(S))
            S.includes(o) || S.push(o);
          else if (v)
            c[l] = [o], p(l) && (h[l] = c[l]);
          else {
            const M = [o];
            y(l, n.k) && (l.value = M), n.k && (c[n.k] = M);
          }
        } else v ? (c[l] = r, p(l) && (h[l] = r)) : x && (y(l, n.k) && (l.value = r), n.k && (c[n.k] = r));
      };
      if (r) {
        const S = () => {
          w(), Wp.delete(n);
        };
        S.id = -1, Wp.set(n, S), ei(S, t);
      } else
        Xx(n), w();
    }
  }
}
function Xx(n) {
  const e = Wp.get(n);
  e && (e.flags |= 8, Wp.delete(n));
}
Zf().requestIdleCallback;
Zf().cancelIdleCallback;
const ul = (n) => !!n.type.__asyncLoader, w1 = (n) => n.type.__isKeepAlive;
function EE(n, e, t = pi, i = !1) {
  if (t) {
    const s = t[n] || (t[n] = []), o = e.__weh || (e.__weh = (...r) => {
      Jo();
      const a = I1(t), l = ss(e, t, n, r);
      return a(), Zo(), l;
    });
    return i ? s.unshift(o) : s.push(o), o;
  }
}
const k1 = (n) => (e, t = pi) => {
  (!Oc || n === "sp") && EE(n, (...i) => e(...i), t);
}, it = k1("m"), C5 = k1("u"), We = k1(
  "bum"
), RE = "components", I5 = /* @__PURE__ */ Symbol.for("v-ndc");
function da(n) {
  return on(n) ? zE(RE, n, !1) || n : n || I5;
}
function zE(n, e, t = !0, i = !1) {
  const s = Un || pi;
  if (s) {
    const o = s.type;
    {
      const a = h9(
        o,
        !1
      );
      if (a && (a === e || a === ri(e) || a === Jf(ri(e))))
        return o;
    }
    const r = (
      // local registration
      // check instance[type] first which is resolved for options API
      Jx(s[n] || o[n], e) || // global registration
      Jx(s.appContext[n], e)
    );
    return !r && i ? o : r;
  }
}
function Jx(n, e) {
  return n && (n[e] || n[ri(e)] || n[Jf(ri(e))]);
}
function ge(n, e, t, i) {
  let s;
  const o = t, r = mt(n);
  if (r || on(n)) {
    const a = r && /* @__PURE__ */ Ho(n);
    let l = !1, d = !1;
    a && (l = !/* @__PURE__ */ Li(n), d = /* @__PURE__ */ _s(n), n = Qf(n)), s = new Array(n.length);
    for (let c = 0, h = n.length; c < h; c++)
      s[c] = e(
        l ? d ? Qo(Fi(n[c])) : Fi(n[c]) : n[c],
        c,
        void 0,
        o
      );
  } else if (typeof n == "number") {
    s = new Array(n);
    for (let a = 0; a < n; a++)
      s[a] = e(a + 1, a, void 0, o);
  } else if (qt(n))
    if (n[Symbol.iterator])
      s = Array.from(
        n,
        (a, l) => e(a, l, void 0, o)
      );
    else {
      const a = Object.keys(n);
      s = new Array(a.length);
      for (let l = 0, d = a.length; l < d; l++) {
        const c = a[l];
        s[l] = e(n[c], c, l, o);
      }
    }
  else
    s = [];
  return s;
}
function $E(n, e) {
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    if (mt(i))
      for (let s = 0; s < i.length; s++)
        n[i[s].name] = i[s].fn;
    else i && (n[i.name] = i.key ? (...s) => {
      const o = i.fn(...s);
      return o && (o.key = i.key), o;
    } : i.fn);
  }
  return n;
}
function Ss(n, e, t, i, s, o) {
  if (t == null && (t = {}), Un.ce || Un.parent && ul(Un.parent) && Un.parent.ce) {
    const d = t, c = Object.keys(d).length > 0;
    return e !== "default" && (d.name = e), g(), Ie(
      j,
      null,
      [C("slot", d, i)],
      c ? -2 : 64
    );
  }
  let r = n[e];
  r && r._c && (r._d = !1);
  const a = Xs.length;
  g();
  let l;
  try {
    const d = r && A5(r(t)), c = t.key || o || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    d && d.key;
    l = Ie(
      j,
      {
        key: (c && !is(c) ? c : `_${e}`) + // #7256 force differentiate fallback content from actual content
        (!d && i ? "_fb" : "")
      },
      d || (i ? i() : []),
      d && n._ === 1 ? 64 : -2
    );
  } catch (d) {
    for (let c = Xs.length; c > a; c--) T1();
    throw d;
  } finally {
    r && r._c && (r._d = !0);
  }
  return l.scopeId && (l.slotScopeIds = [l.scopeId + "-s"]), l;
}
function A5(n) {
  return n.some((e) => $c(e) ? !(e.type === qn || e.type === j && !A5(e.children)) : !0) ? n : null;
}
const gv = (n) => n ? V5(n) ? om(n) : gv(n.parent) : null, lc = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ gi(/* @__PURE__ */ Object.create(null), {
    $: (n) => n,
    $el: (n) => n.vnode.el,
    $data: (n) => n.data,
    $props: (n) => n.props,
    $attrs: (n) => n.attrs,
    $slots: (n) => n.slots,
    $refs: (n) => n.refs,
    $parent: (n) => gv(n.parent),
    $root: (n) => gv(n.root),
    $host: (n) => n.ce,
    $emit: (n) => n.emit,
    $options: (n) => n.type,
    $forceUpdate: (n) => n.f || (n.f = () => {
      v1(n.update);
    }),
    $nextTick: (n) => n.n || (n.n = nt.bind(n.proxy)),
    $watch: (n) => ea
  })
), Hm = (n, e) => n !== en && !n.__isScriptSetup && jt(n, e), DE = {
  get({ _: n }, e) {
    if (e === "__v_skip")
      return !0;
    const { ctx: t, setupState: i, data: s, props: o, accessCache: r, type: a, appContext: l } = n;
    if (e[0] !== "$") {
      const f = r[e];
      if (f !== void 0)
        switch (f) {
          case 1:
            return i[e];
          case 2:
            return s[e];
          case 4:
            return t[e];
          case 3:
            return o[e];
        }
      else {
        if (Hm(i, e))
          return r[e] = 1, i[e];
        if (jt(o, e))
          return r[e] = 3, o[e];
        if (t !== en && jt(t, e))
          return r[e] = 4, t[e];
        r[e] = 0;
      }
    }
    const d = lc[e];
    let c, h;
    if (d)
      return e === "$attrs" && Vn(n.attrs, "get", ""), d(n);
    if (
      // css module (injected by vue-loader)
      (c = a.__cssModules) && (c = c[e])
    )
      return c;
    if (t !== en && jt(t, e))
      return r[e] = 4, t[e];
    if (
      // global properties
      h = l.config.globalProperties, jt(h, e)
    )
      return h[e];
  },
  set({ _: n }, e, t) {
    const { data: i, setupState: s, ctx: o } = n;
    return Hm(s, e) ? (s[e] = t, !0) : jt(n.props, e) || e[0] === "$" && e.slice(1) in n ? !1 : (o[e] = t, !0);
  },
  has({
    _: { data: n, setupState: e, accessCache: t, ctx: i, appContext: s, props: o, type: r }
  }, a) {
    let l;
    return !!(t[a] || Hm(e, a) || jt(o, a) || jt(i, a) || jt(lc, a) || jt(s.config.globalProperties, a) || (l = r.__cssModules) && l[a]);
  },
  defineProperty(n, e, t) {
    return t.get != null ? n._.accessCache[e] = 0 : jt(t, "value") && this.set(n, e, t.value, null), Reflect.defineProperty(n, e, t);
  }
};
function OE() {
  return LE().slots;
}
function LE(n) {
  const e = Wl();
  return e.setupContext || (e.setupContext = q5(e));
}
function P5() {
  return {
    app: null,
    config: {
      isNativeTag: U3,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let BE = 0;
function FE(n, e) {
  return function(i, s = null) {
    Ft(i) || (i = gi({}, i)), s != null && !qt(s) && (s = null);
    const o = P5(), r = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const d = o.app = {
      _uid: BE++,
      _component: i,
      _props: s,
      _container: null,
      _context: o,
      _instance: null,
      version: f9,
      get config() {
        return o.config;
      },
      set config(c) {
      },
      use(c, ...h) {
        return r.has(c) || (c && Ft(c.install) ? (r.add(c), c.install(d, ...h)) : Ft(c) && (r.add(c), c(d, ...h))), d;
      },
      mixin(c) {
        return d;
      },
      component(c, h) {
        return h ? (o.components[c] = h, d) : o.components[c];
      },
      directive(c, h) {
        return h ? (o.directives[c] = h, d) : o.directives[c];
      },
      mount(c, h, f) {
        if (!l) {
          const p = d._ceVNode || C(i, s);
          return p.appContext = o, f === !0 ? f = "svg" : f === !1 && (f = void 0), n(p, c, f), l = !0, d._container = c, c.__vue_app__ = d, om(p.component);
        }
      },
      onUnmount(c) {
        a.push(c);
      },
      unmount() {
        l && (ss(
          a,
          d._instance,
          16
        ), n(null, d._container), delete d._container.__vue_app__);
      },
      provide(c, h) {
        return o.provides[c] = h, d;
      },
      runWithContext(c) {
        const h = hl;
        hl = d;
        try {
          return c();
        } finally {
          hl = h;
        }
      }
    };
    return d;
  };
}
let hl = null;
const NE = (n, e) => e === "modelValue" || e === "model-value" ? n.modelModifiers : n[`${e}Modifiers`] || n[`${ri(e)}Modifiers`] || n[`${lr(e)}Modifiers`];
function UE(n, e, ...t) {
  if (n.isUnmounted) return;
  const i = n.vnode.props || en;
  let s = t;
  const o = e.startsWith("update:"), r = o && NE(i, e.slice(7));
  r && (r.trim && (s = t.map((c) => on(c) ? c.trim() : c)), r.number && (s = s.map(d1)));
  let a, l = i[a = Bm(e)] || // also try camelCase event handler (#2249)
  i[a = Bm(ri(e))];
  !l && o && (l = i[a = Bm(lr(e))]), l && ss(
    l,
    n,
    6,
    s
  );
  const d = i[a + "Once"];
  if (d) {
    if (!n.emitted)
      n.emitted = {};
    else if (n.emitted[a])
      return;
    n.emitted[a] = !0, ss(
      d,
      n,
      6,
      s
    );
  }
}
function GE(n, e, t = !1) {
  const i = e.emitsCache, s = i.get(n);
  if (s !== void 0)
    return s;
  const o = n.emits;
  let r = {};
  return o ? (mt(o) ? o.forEach((a) => r[a] = null) : gi(r, o), qt(n) && i.set(n, r), r) : (qt(n) && i.set(n, null), null);
}
function im(n, e) {
  return !n || !Kf(e) ? !1 : (e = e.slice(2), e = e === "Once" ? e : e.replace(/Once$/, ""), jt(n, e[0].toLowerCase() + e.slice(1)) || jt(n, lr(e)) || jt(n, e));
}
function Zx(n) {
  const {
    type: e,
    vnode: t,
    proxy: i,
    withProxy: s,
    propsOptions: [o],
    slots: r,
    attrs: a,
    emit: l,
    render: d,
    renderCache: c,
    props: h,
    data: f,
    setupState: p,
    ctx: y,
    inheritAttrs: v
  } = n, x = Hp(n);
  let w, S;
  try {
    if (t.shapeFlag & 4) {
      const _ = s || i, T = _;
      w = vs(
        d.call(
          T,
          _,
          c,
          h,
          p,
          f,
          y
        )
      ), S = a;
    } else {
      const _ = e;
      w = vs(
        _.length > 1 ? _(
          h,
          { attrs: a, slots: r, emit: l }
        ) : _(
          h,
          null
        )
      ), S = e.props ? a : jE(a);
    }
  } catch (_) {
    Xs.length = 0, em(_, n, 1), w = C(qn);
  }
  let M = w;
  if (S && v !== !1) {
    const _ = Object.keys(S), { shapeFlag: T } = M;
    _.length && T & 7 && (o && _.some(Yf) && (S = HE(
      S,
      o
    )), M = er(M, S, !1, !0));
  }
  if (t.dirs && (M = er(M, null, !1, !0), M.dirs = M.dirs ? M.dirs.concat(t.dirs) : t.dirs), t.transition) {
    const _ = nm(M.type) && Vp(M) || M;
    la(_, t.transition);
  }
  return w = M, Hp(x), w;
}
const jE = (n) => {
  let e;
  for (const t in n)
    (t === "class" || t === "style" || Kf(t)) && ((e || (e = {}))[t] = n[t]);
  return e;
}, HE = (n, e) => {
  const t = {};
  for (const i in n)
    (!Yf(i) || !(i.slice(9) in e)) && (t[i] = n[i]);
  return t;
};
function VE(n, e, t) {
  const { props: i, children: s, component: o } = n, { props: r, children: a, patchFlag: l } = e, d = o.emitsOptions;
  if (e.dirs || e.transition)
    return !0;
  if (t && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return i ? Qx(i, r, d) : !!r;
    if (l & 8) {
      const c = e.dynamicProps;
      for (let h = 0; h < c.length; h++) {
        const f = c[h];
        if (E5(r, i, f) && !im(d, f))
          return !0;
      }
    }
  } else
    return (s || a) && (!a || !a.$stable) ? !0 : i === r ? !1 : i ? r ? Qx(i, r, d) : !0 : !!r;
  return !1;
}
function Qx(n, e, t) {
  const i = Object.keys(e);
  if (i.length !== Object.keys(n).length)
    return !0;
  for (let s = 0; s < i.length; s++) {
    const o = i[s];
    if (E5(e, n, o) && !im(t, o))
      return !0;
  }
  return !1;
}
function E5(n, e, t) {
  const i = n[t], s = e[t];
  return t === "style" && qt(i) && qt(s) ? !Vl(i, s) : i !== s;
}
function WE({ vnode: n, parent: e, suspense: t }, i) {
  for (; e; ) {
    const s = e.subTree;
    if (s.suspense && s.suspense.activeBranch === n && (s.suspense.vnode.el = s.el = i, n = s), s === n)
      (n = e.vnode).el = i, e = e.parent;
    else
      break;
  }
  t && t.activeBranch === n && (t.vnode.el = i);
}
const R5 = {}, z5 = () => Object.create(R5), $5 = (n) => Object.getPrototypeOf(n) === R5;
function qE(n, e, t, i = !1) {
  const s = {}, o = z5();
  n.propsDefaults = /* @__PURE__ */ Object.create(null), D5(n, e, s, o);
  for (const r in n.propsOptions[0])
    r in s || (s[r] = void 0);
  t ? n.props = i ? s : /* @__PURE__ */ hv(s) : n.type.props ? n.props = s : n.props = o, n.attrs = o;
}
function KE(n, e, t, i) {
  const {
    props: s,
    attrs: o,
    vnode: { patchFlag: r }
  } = n, a = /* @__PURE__ */ Et(s), [l] = n.propsOptions;
  let d = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (i || r > 0) && !(r & 16)
  ) {
    if (r & 8) {
      const c = n.vnode.dynamicProps;
      for (let h = 0; h < c.length; h++) {
        let f = c[h];
        if (im(n.emitsOptions, f))
          continue;
        const p = e[f];
        if (l)
          if (jt(o, f))
            p !== o[f] && (o[f] = p, d = !0);
          else {
            const y = ri(f);
            s[y] = bv(
              l,
              a,
              y,
              p,
              n,
              !1
            );
          }
        else
          p !== o[f] && (o[f] = p, d = !0);
      }
    }
  } else {
    D5(n, e, s, o) && (d = !0);
    let c;
    for (const h in a)
      (!e || // for camelCase
      !jt(e, h) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = lr(h)) === h || !jt(e, c))) && (l ? t && // for camelCase
      (t[h] !== void 0 || // for kebab-case
      t[c] !== void 0) && (s[h] = bv(
        l,
        a,
        h,
        void 0,
        n,
        !0
      )) : delete s[h]);
    if (o !== a)
      for (const h in o)
        (!e || !jt(e, h)) && (delete o[h], d = !0);
  }
  d && Ws(n.attrs, "set", "");
}
function D5(n, e, t, i) {
  const [s, o] = n.propsOptions;
  let r = !1, a;
  if (e)
    for (let l in e) {
      if (sc(l))
        continue;
      const d = e[l];
      let c;
      s && jt(s, c = ri(l)) ? !o || !o.includes(c) ? t[c] = d : (a || (a = {}))[c] = d : im(n.emitsOptions, l) || (!(l in i) || d !== i[l]) && (i[l] = d, r = !0);
    }
  if (o) {
    const l = /* @__PURE__ */ Et(t), d = a || en;
    for (let c = 0; c < o.length; c++) {
      const h = o[c];
      t[h] = bv(
        s,
        l,
        h,
        d[h],
        n,
        !jt(d, h)
      );
    }
  }
  return r;
}
function bv(n, e, t, i, s, o) {
  const r = n[t];
  if (r != null) {
    const a = jt(r, "default");
    if (a && i === void 0) {
      const l = r.default;
      if (r.type !== Function && !r.skipFactory && Ft(l)) {
        const { propsDefaults: d } = s;
        if (t in d)
          i = d[t];
        else {
          const c = I1(s);
          i = d[t] = l.call(
            null,
            e
          ), c();
        }
      } else
        i = l;
      s.ce && s.ce._setProp(t, i);
    }
    r[
      0
      /* shouldCast */
    ] && (o && !a ? i = !1 : r[
      1
      /* shouldCastTrue */
    ] && (i === "" || i === lr(t)) && (i = !0));
  }
  return i;
}
function YE(n, e, t = !1) {
  const i = e.propsCache, s = i.get(n);
  if (s)
    return s;
  const o = n.props, r = {}, a = [];
  if (!o)
    return qt(n) && i.set(n, Hr), Hr;
  if (mt(o))
    for (let d = 0; d < o.length; d++) {
      const c = ri(o[d]);
      ew(c) && (r[c] = en);
    }
  else if (o)
    for (const d in o) {
      const c = ri(d);
      if (ew(c)) {
        const h = o[d], f = r[c] = mt(h) || Ft(h) ? { type: h } : gi({}, h), p = f.type;
        let y = !1, v = !0;
        if (mt(p))
          for (let x = 0; x < p.length; ++x) {
            const w = p[x], S = Ft(w) && w.name;
            if (S === "Boolean") {
              y = !0;
              break;
            } else S === "String" && (v = !1);
          }
        else
          y = Ft(p) && p.name === "Boolean";
        f[
          0
          /* shouldCast */
        ] = y, f[
          1
          /* shouldCastTrue */
        ] = v, (y || jt(f, "default")) && a.push(c);
      }
    }
  const l = [r, a];
  return qt(n) && i.set(n, l), l;
}
function ew(n) {
  return n[0] !== "$" && !sc(n);
}
const _1 = (n) => n === "_" || n === "_ctx" || n === "$stable", S1 = (n) => mt(n) ? n.map(vs) : [vs(n)], XE = (n, e, t) => {
  if (e._n)
    return e;
  const i = Xe((...s) => S1(e(...s)), t);
  return i._c = !1, i;
}, O5 = (n, e, t) => {
  const i = n._ctx;
  for (const s in n) {
    if (_1(s)) continue;
    const o = n[s];
    if (Ft(o))
      e[s] = XE(s, o, i);
    else if (o != null) {
      const r = S1(o);
      e[s] = () => r;
    }
  }
}, L5 = (n, e) => {
  const t = S1(e);
  n.slots.default = () => t;
}, B5 = (n, e, t) => {
  for (const i in e)
    (t || !_1(i)) && (n[i] = e[i]);
}, JE = (n, e, t) => {
  const i = n.slots = z5();
  if (n.vnode.shapeFlag & 32) {
    const s = e._;
    s ? (B5(i, e, t), t && W3(i, "_", s, !0)) : O5(e, i);
  } else e && L5(n, e);
}, ZE = (n, e, t) => {
  const { vnode: i, slots: s } = n;
  let o = !0, r = en;
  if (i.shapeFlag & 32) {
    const a = e._;
    a ? t && a === 1 ? o = !1 : B5(s, e, t) : (o = !e.$stable, O5(e, s)), r = e;
  } else e && (L5(n, e), r = { default: 1 });
  if (o)
    for (const a in s)
      !_1(a) && r[a] == null && delete s[a];
}, ei = i9;
function QE(n) {
  return e9(n);
}
function e9(n, e) {
  const t = Zf();
  t.__VUE__ = !0;
  const {
    insert: i,
    remove: s,
    patchProp: o,
    createElement: r,
    createText: a,
    createComment: l,
    setText: d,
    setElementText: c,
    parentNode: h,
    nextSibling: f,
    setScopeId: p = ea,
    insertStaticContent: y
  } = n, v = (U, q, oe, de = null, pe = null, Ce = null, Be = void 0, be = null, se = !!q.dynamicChildren) => {
    if (U === q)
      return;
    U && !Nr(U, q) && (de = te(U), J(U, pe, Ce, !0), U = null), q.patchFlag === -2 && (se = !1, q.dynamicChildren = null), q.dynamicChildren && U && U.dynamicChildren && U.dynamicChildren.hasOnce && (q.dynamicChildren === Hr && (q.dynamicChildren = []), q.dynamicChildren.hasOnce = !0);
    const { type: ae, ref: ye, shapeFlag: Oe } = q;
    switch (ae) {
      case sm:
        x(U, q, oe, de);
        break;
      case qn:
        w(U, q, oe, de);
        break;
      case gp:
        U == null && S(q, oe, de, Be);
        break;
      case j:
        F(
          U,
          q,
          oe,
          de,
          pe,
          Ce,
          Be,
          be,
          se
        );
        break;
      default:
        Oe & 1 ? T(
          U,
          q,
          oe,
          de,
          pe,
          Ce,
          Be,
          be,
          se
        ) : Oe & 6 ? ie(
          U,
          q,
          oe,
          de,
          pe,
          Ce,
          Be,
          be,
          se
        ) : (Oe & 64 || Oe & 128) && ae.process(
          U,
          q,
          oe,
          de,
          pe,
          Ce,
          Be,
          be,
          se,
          Me
        );
    }
    ye != null && pe ? ac(ye, U && U.ref, Ce, q || U, !q) : ye == null && U && U.ref != null && ac(U.ref, null, Ce, U, !0);
  }, x = (U, q, oe, de) => {
    if (U == null)
      i(
        q.el = a(q.children),
        oe,
        de
      );
    else {
      const pe = q.el = U.el;
      q.children !== U.children && d(pe, q.children);
    }
  }, w = (U, q, oe, de) => {
    U == null ? i(
      q.el = l(q.children || ""),
      oe,
      de
    ) : q.el = U.el;
  }, S = (U, q, oe, de) => {
    [U.el, U.anchor] = y(
      U.children,
      q,
      oe,
      de,
      U.el,
      U.anchor
    );
  }, M = ({ el: U, anchor: q }, oe, de) => {
    let pe;
    for (; U && U !== q; )
      pe = f(U), i(U, oe, de), U = pe;
    i(q, oe, de);
  }, _ = ({ el: U, anchor: q }) => {
    let oe;
    for (; U && U !== q; )
      oe = f(U), s(U), U = oe;
    s(q);
  }, T = (U, q, oe, de, pe, Ce, Be, be, se) => {
    if (q.type === "svg" ? Be = "svg" : q.type === "math" && (Be = "mathml"), U == null)
      k(
        q,
        oe,
        de,
        pe,
        Ce,
        Be,
        be,
        se
      );
    else {
      const ae = U.el && U.el._isVueCE ? U.el : null;
      try {
        ae && ae._beginPatch(), R(
          U,
          q,
          pe,
          Ce,
          Be,
          be,
          se
        );
      } finally {
        ae && ae._endPatch();
      }
    }
  }, k = (U, q, oe, de, pe, Ce, Be, be) => {
    let se, ae;
    const { props: ye, shapeFlag: Oe, transition: Ve, dirs: Ue } = U;
    if (se = U.el = r(
      U.type,
      Ce,
      ye && ye.is,
      ye
    ), Oe & 8 ? c(se, U.children) : Oe & 16 && A(
      U.children,
      se,
      null,
      de,
      pe,
      Vm(U, Ce),
      Be,
      be
    ), Ue && pr(U, null, de, "created"), P(se, U, U.scopeId, Be, de), ye) {
      for (const Ye in ye)
        Ye !== "value" && !sc(Ye) && o(se, Ye, null, ye[Ye], Ce, de);
      "value" in ye && o(se, "value", null, ye.value, Ce), (ae = ye.onVnodeBeforeMount) && ds(ae, de, U);
    }
    Ue && pr(U, null, de, "beforeMount");
    const tt = t9(pe, Ve);
    tt && Ve.beforeEnter(se), i(se, q, oe), ((ae = ye && ye.onVnodeMounted) || tt || Ue) && ei(() => {
      ae && ds(ae, de, U), tt && Ve.enter(se), Ue && pr(U, null, de, "mounted");
    }, pe);
  }, P = (U, q, oe, de, pe) => {
    if (oe && p(U, oe), de)
      for (let Ce = 0; Ce < de.length; Ce++)
        p(U, de[Ce]);
    if (pe) {
      let Ce = pe.subTree;
      if (q === Ce || U5(Ce.type) && (Ce.ssContent === q || Ce.ssFallback === q)) {
        const Be = pe.vnode;
        P(
          U,
          Be,
          Be.scopeId,
          Be.slotScopeIds,
          pe.parent
        );
      }
    }
  }, A = (U, q, oe, de, pe, Ce, Be, be, se = 0) => {
    for (let ae = se; ae < U.length; ae++) {
      const ye = U[ae] = be ? Gs(U[ae]) : vs(U[ae]);
      v(
        null,
        ye,
        q,
        oe,
        de,
        pe,
        Ce,
        Be,
        be
      );
    }
  }, R = (U, q, oe, de, pe, Ce, Be) => {
    const be = q.el = U.el;
    let { patchFlag: se, dynamicChildren: ae, dirs: ye } = q;
    se |= U.patchFlag & 16;
    const Oe = U.props || en, Ve = q.props || en;
    let Ue;
    if (oe && fr(oe, !1), (Ue = Ve.onVnodeBeforeUpdate) && ds(Ue, oe, q, U), ye && pr(q, U, oe, "beforeUpdate"), oe && fr(oe, !0), // #6385 the old vnode may be a user-wrapped non-isomorphic block
    // Force full diff when block metadata is unstable.
    ae && (!U.dynamicChildren || U.dynamicChildren.length !== ae.length) && (se = 0, Be = !1, ae = null), (Oe.innerHTML && Ve.innerHTML == null || Oe.textContent && Ve.textContent == null) && c(be, ""), ae ? D(
      U.dynamicChildren,
      ae,
      be,
      oe,
      de,
      Vm(q, pe),
      Ce
    ) : Be || K(
      U,
      q,
      be,
      null,
      oe,
      de,
      Vm(q, pe),
      Ce,
      !1
    ), se > 0) {
      if (se & 16)
        O(be, Oe, Ve, oe, pe);
      else if (se & 2 && Oe.class !== Ve.class && o(be, "class", null, Ve.class, pe), se & 4 && o(be, "style", Oe.style, Ve.style, pe), se & 8) {
        const tt = q.dynamicProps;
        for (let Ye = 0; Ye < tt.length; Ye++) {
          const at = tt[Ye], kt = Oe[at], $e = Ve[at];
          ($e !== kt || at === "value") && o(be, at, kt, $e, pe, oe);
        }
      }
      se & 1 && U.children !== q.children && c(be, q.children);
    } else !Be && ae == null && O(be, Oe, Ve, oe, pe);
    ((Ue = Ve.onVnodeUpdated) || ye) && ei(() => {
      Ue && ds(Ue, oe, q, U), ye && pr(q, U, oe, "updated");
    }, de);
  }, D = (U, q, oe, de, pe, Ce, Be) => {
    for (let be = 0; be < q.length; be++) {
      const se = U[be], ae = q[be], ye = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        se.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (se.type === j || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Nr(se, ae) || // - In the case of a component, it could contain anything.
        se.shapeFlag & 198) ? h(se.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          oe
        )
      );
      v(
        se,
        ae,
        ye,
        null,
        de,
        pe,
        Ce,
        Be,
        !0
      );
    }
  }, O = (U, q, oe, de, pe) => {
    if (q !== oe) {
      if (q !== en)
        for (const Ce in q)
          !sc(Ce) && !(Ce in oe) && o(
            U,
            Ce,
            q[Ce],
            null,
            pe,
            de
          );
      for (const Ce in oe) {
        if (sc(Ce)) continue;
        const Be = oe[Ce], be = q[Ce];
        Be !== be && Ce !== "value" && o(U, Ce, be, Be, pe, de);
      }
      "value" in oe && o(U, "value", q.value, oe.value, pe);
    }
  }, F = (U, q, oe, de, pe, Ce, Be, be, se) => {
    const ae = q.el = U ? U.el : a(""), ye = q.anchor = U ? U.anchor : a("");
    let { patchFlag: Oe, dynamicChildren: Ve, slotScopeIds: Ue } = q;
    Ue && (be = be ? be.concat(Ue) : Ue), U == null ? (i(ae, oe, de), i(ye, oe, de), A(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      q.children || [],
      oe,
      ye,
      pe,
      Ce,
      Be,
      be,
      se
    )) : Oe > 0 && Oe & 64 && Ve && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    U.dynamicChildren && U.dynamicChildren.length === Ve.length ? (D(
      U.dynamicChildren,
      Ve,
      oe,
      pe,
      Ce,
      Be,
      be
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (q.key != null || pe && q === pe.subTree) && M1(
      U,
      q,
      !0
      /* shallow */
    )) : K(
      U,
      q,
      oe,
      ye,
      pe,
      Ce,
      Be,
      be,
      se
    );
  }, ie = (U, q, oe, de, pe, Ce, Be, be, se) => {
    q.slotScopeIds = be, U == null ? q.shapeFlag & 512 ? pe.ctx.activate(
      q,
      oe,
      de,
      Be,
      se
    ) : ee(
      q,
      oe,
      de,
      pe,
      Ce,
      Be,
      se
    ) : me(U, q, se);
  }, ee = (U, q, oe, de, pe, Ce, Be) => {
    const be = U.component = l9(
      U,
      de,
      pe
    );
    if (w1(U) && (be.ctx.renderer = Me), d9(be, !1, Be), be.asyncDep) {
      if (pe && pe.registerDep(be, L, Be), !U.el) {
        const se = be.subTree = C(qn);
        w(null, se, q, oe), U.placeholder = se.el;
      }
    } else
      L(
        be,
        U,
        q,
        oe,
        pe,
        Ce,
        Be
      );
  }, me = (U, q, oe) => {
    const de = q.component = U.component;
    if (VE(U, q, oe))
      if (de.asyncDep && !de.asyncResolved) {
        q.el = U.el, N(de, q, oe);
        return;
      } else
        de.next = q, de.update();
    else
      q.el = U.el, de.vnode = q;
  }, L = (U, q, oe, de, pe, Ce, Be) => {
    const be = () => {
      if (U.isMounted) {
        let { next: Oe, bu: Ve, u: Ue, parent: tt, vnode: Ye } = U;
        {
          const V = F5(U);
          if (V) {
            Oe && (Oe.el = Ye.el, N(U, Oe, Be)), V.asyncDep.then(() => {
              ei(() => {
                U.isUnmounted || ae();
              }, pe);
            });
            return;
          }
        }
        let at = Oe, kt;
        fr(U, !1), Oe ? (Oe.el = Ye.el, N(U, Oe, Be)) : Oe = Ye, Ve && fp(Ve), (kt = Oe.props && Oe.props.onVnodeBeforeUpdate) && ds(kt, tt, Oe, Ye), fr(U, !0);
        const $e = Zx(U), Ne = U.subTree;
        U.subTree = $e, v(
          Ne,
          $e,
          // parent may have changed if it's in a teleport
          h(Ne.el),
          // anchor may have changed if it's in a fragment
          te(Ne),
          U,
          pe,
          Ce
        ), Oe.el = $e.el, at === null && WE(U, $e.el), Ue && ei(Ue, pe), (kt = Oe.props && Oe.props.onVnodeUpdated) && ei(
          () => ds(kt, tt, Oe, Ye),
          pe
        );
      } else {
        let Oe;
        const { el: Ve, props: Ue } = q, { bm: tt, m: Ye, parent: at, root: kt, type: $e } = U, Ne = ul(q);
        fr(U, !1), tt && fp(tt), !Ne && (Oe = Ue && Ue.onVnodeBeforeMount) && ds(Oe, at, q), fr(U, !0);
        {
          kt.ce && kt.ce._hasShadowRoot() && kt.ce._injectChildStyle(
            $e,
            U.parent ? U.parent.type : void 0
          );
          const V = U.subTree = Zx(U);
          v(
            null,
            V,
            oe,
            de,
            U,
            pe,
            Ce
          ), q.el = V.el;
        }
        if (Ye && ei(Ye, pe), !Ne && (Oe = Ue && Ue.onVnodeMounted)) {
          const V = q;
          ei(
            () => ds(Oe, at, V),
            pe
          );
        }
        (q.shapeFlag & 256 || at && ul(at.vnode) && at.vnode.shapeFlag & 256) && U.a && ei(U.a, pe), U.isMounted = !0, q = oe = de = null;
      }
    };
    U.scope.on();
    const se = U.effect = new Z3(be);
    U.scope.off();
    const ae = U.update = se.run.bind(se), ye = U.job = se.runIfDirty.bind(se);
    ye.i = U, ye.id = U.uid, se.scheduler = () => v1(ye), fr(U, !0), ae();
  }, N = (U, q, oe) => {
    q.component = U;
    const de = U.vnode.props;
    U.vnode = q, U.next = null, KE(U, q.props, de, oe), ZE(U, q.children, oe), Jo(), Wx(U), Zo();
  }, K = (U, q, oe, de, pe, Ce, Be, be, se = !1) => {
    const ae = U && U.children, ye = U ? U.shapeFlag : 0, Oe = q.children, { patchFlag: Ve, shapeFlag: Ue } = q;
    if (Ve > 0) {
      if (Ve & 128) {
        re(
          ae,
          Oe,
          oe,
          de,
          pe,
          Ce,
          Be,
          be,
          se
        );
        return;
      } else if (Ve & 256) {
        B(
          ae,
          Oe,
          oe,
          de,
          pe,
          Ce,
          Be,
          be,
          se
        );
        return;
      }
    }
    Ue & 8 ? (ye & 16 && Z(ae, pe, Ce), Oe !== ae && c(oe, Oe)) : ye & 16 ? Ue & 16 ? re(
      ae,
      Oe,
      oe,
      de,
      pe,
      Ce,
      Be,
      be,
      se
    ) : Z(ae, pe, Ce, !0) : (ye & 8 && c(oe, ""), Ue & 16 && A(
      Oe,
      oe,
      de,
      pe,
      Ce,
      Be,
      be,
      se
    ));
  }, B = (U, q, oe, de, pe, Ce, Be, be, se) => {
    U = U || Hr, q = q || Hr;
    const ae = U.length, ye = q.length, Oe = Math.min(ae, ye);
    let Ve;
    for (Ve = 0; Ve < Oe; Ve++) {
      const Ue = q[Ve] = se ? Gs(q[Ve]) : vs(q[Ve]);
      v(
        U[Ve],
        Ue,
        oe,
        null,
        pe,
        Ce,
        Be,
        be,
        se
      );
    }
    ae > ye ? Z(
      U,
      pe,
      Ce,
      !0,
      !1,
      Oe
    ) : A(
      q,
      oe,
      de,
      pe,
      Ce,
      Be,
      be,
      se,
      Oe
    );
  }, re = (U, q, oe, de, pe, Ce, Be, be, se) => {
    let ae = 0;
    const ye = q.length;
    let Oe = U.length - 1, Ve = ye - 1;
    for (; ae <= Oe && ae <= Ve; ) {
      const Ue = U[ae], tt = q[ae] = se ? Gs(q[ae]) : vs(q[ae]);
      if (Nr(Ue, tt))
        v(
          Ue,
          tt,
          oe,
          null,
          pe,
          Ce,
          Be,
          be,
          se
        );
      else
        break;
      ae++;
    }
    for (; ae <= Oe && ae <= Ve; ) {
      const Ue = U[Oe], tt = q[Ve] = se ? Gs(q[Ve]) : vs(q[Ve]);
      if (Nr(Ue, tt))
        v(
          Ue,
          tt,
          oe,
          null,
          pe,
          Ce,
          Be,
          be,
          se
        );
      else
        break;
      Oe--, Ve--;
    }
    if (ae > Oe) {
      if (ae <= Ve) {
        const Ue = Ve + 1, tt = Ue < ye ? q[Ue].el : de;
        for (; ae <= Ve; )
          v(
            null,
            q[ae] = se ? Gs(q[ae]) : vs(q[ae]),
            oe,
            tt,
            pe,
            Ce,
            Be,
            be,
            se
          ), ae++;
      }
    } else if (ae > Ve)
      for (; ae <= Oe; )
        J(U[ae], pe, Ce, !0), ae++;
    else {
      const Ue = ae, tt = ae, Ye = /* @__PURE__ */ new Map();
      for (ae = tt; ae <= Ve; ae++) {
        const Le = q[ae] = se ? Gs(q[ae]) : vs(q[ae]);
        Le.key != null && Ye.set(Le.key, ae);
      }
      let at, kt = 0;
      const $e = Ve - tt + 1;
      let Ne = !1, V = 0;
      const X = new Array($e);
      for (ae = 0; ae < $e; ae++) X[ae] = 0;
      for (ae = Ue; ae <= Oe; ae++) {
        const Le = U[ae];
        if (kt >= $e) {
          J(Le, pe, Ce, !0);
          continue;
        }
        let ve;
        if (Le.key != null)
          ve = Ye.get(Le.key);
        else
          for (at = tt; at <= Ve; at++)
            if (X[at - tt] === 0 && Nr(Le, q[at])) {
              ve = at;
              break;
            }
        ve === void 0 ? J(Le, pe, Ce, !0) : (X[ve - tt] = ae + 1, ve >= V ? V = ve : Ne = !0, v(
          Le,
          q[ve],
          oe,
          null,
          pe,
          Ce,
          Be,
          be,
          se
        ), kt++);
      }
      const le = Ne ? n9(X) : Hr;
      for (at = le.length - 1, ae = $e - 1; ae >= 0; ae--) {
        const Le = tt + ae, ve = q[Le], _e = q[Le + 1], De = Le + 1 < ye ? (
          // #13559, #14173 fallback to el placeholder for unresolved async component
          _e.el || N5(_e)
        ) : de;
        X[ae] === 0 ? v(
          null,
          ve,
          oe,
          De,
          pe,
          Ce,
          Be,
          be,
          se
        ) : Ne && (at < 0 || ae !== le[at] ? H(ve, oe, De, 2) : at--);
      }
    }
  }, H = (U, q, oe, de, pe = null) => {
    const { el: Ce, type: Be, transition: be, children: se, shapeFlag: ae } = U;
    if (ae & 6) {
      H(U.component.subTree, q, oe, de);
      return;
    }
    if (ae & 128) {
      U.suspense.move(q, oe, de);
      return;
    }
    if (ae & 64) {
      Be.move(U, q, oe, Me);
      return;
    }
    if (Be === j) {
      i(Ce, q, oe);
      for (let Oe = 0; Oe < se.length; Oe++)
        H(se[Oe], q, oe, de);
      i(U.anchor, q, oe);
      return;
    }
    if (Be === gp) {
      M(U, q, oe);
      return;
    }
    if (de !== 2 && ae & 1 && be)
      if (de === 0)
        be.persisted && !Ce[$i] ? i(Ce, q, oe) : (be.beforeEnter(Ce), i(Ce, q, oe), ei(() => be.enter(Ce), pe));
      else {
        const { leave: Oe, delayLeave: Ve, afterLeave: Ue } = be, tt = () => {
          U.ctx.isUnmounted ? s(Ce) : i(Ce, q, oe);
        }, Ye = () => {
          const at = Ce._isLeaving || !!Ce[$i];
          Ce._isLeaving && Ce[$i](
            !0
            /* cancelled */
          ), be.persisted && !at ? tt() : Oe(Ce, () => {
            tt(), Ue && Ue();
          });
        };
        Ve ? Ve(Ce, tt, Ye) : Ye();
      }
    else
      i(Ce, q, oe);
  }, J = (U, q, oe, de = !1, pe = !1) => {
    const {
      type: Ce,
      props: Be,
      ref: be,
      children: se,
      dynamicChildren: ae,
      shapeFlag: ye,
      patchFlag: Oe,
      dirs: Ve,
      cacheIndex: Ue,
      memo: tt
    } = U;
    if ((Oe === -2 || ae && ae.hasOnce) && (pe = !1), be != null && (Jo(), ac(be, null, oe, U, !0), Zo()), Ue != null && (!U.ctx || U.ctx === q) && (q.renderCache[Ue] = void 0), ye & 256) {
      q.ctx.deactivate(U);
      return;
    }
    const Ye = ye & 1 && Ve, at = !ul(U);
    let kt;
    if (at && (kt = Be && Be.onVnodeBeforeUnmount) && ds(kt, q, U), ye & 6)
      ue(U.component, oe, de);
    else {
      if (ye & 128) {
        U.suspense.unmount(oe, de);
        return;
      }
      Ye && pr(U, null, q, "beforeUnmount"), ye & 64 ? U.type.remove(
        U,
        q,
        oe,
        Me,
        de
      ) : ae && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !ae.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (Ce !== j || Oe > 0 && Oe & 64) ? Z(
        ae,
        q,
        oe,
        !1,
        !0
      ) : (Ce === j && Oe & 384 || !pe && ye & 16) && Z(se, q, oe), de && Q(U);
    }
    const $e = tt != null && Ue == null;
    (at && (kt = Be && Be.onVnodeUnmounted) || Ye || $e) && ei(() => {
      kt && ds(kt, q, U), Ye && pr(U, null, q, "unmounted"), $e && (U.el = null);
    }, oe);
  }, Q = (U) => {
    const { type: q, el: oe, anchor: de, transition: pe } = U;
    if (q === j) {
      ne(oe, de);
      return;
    }
    if (q === gp) {
      _(U), pe && !pe.persisted && pe.afterLeave && pe.afterLeave();
      return;
    }
    const Ce = () => {
      s(oe), pe && !pe.persisted && pe.afterLeave && pe.afterLeave();
    };
    if (U.shapeFlag & 1 && pe && !pe.persisted) {
      const { leave: Be, delayLeave: be } = pe, se = () => Be(oe, Ce);
      be ? be(U.el, Ce, se) : se();
    } else
      Ce();
  }, ne = (U, q) => {
    let oe;
    for (; U !== q; )
      oe = f(U), s(U), U = oe;
    s(q);
  }, ue = (U, q, oe) => {
    const { bum: de, scope: pe, job: Ce, subTree: Be, um: be, m: se, a: ae } = U;
    tw(se), tw(ae), de && fp(de), pe.stop(), Ce ? (Ce.flags |= 8, J(Be, U, q, oe)) : U.vnode.el && Be && (Be.transition = U.vnode.transition, J(Be, U, q, oe)), be && ei(be, q), ei(() => {
      U.isUnmounted = !0;
    }, q);
  }, Z = (U, q, oe, de = !1, pe = !1, Ce = 0) => {
    for (let Be = Ce; Be < U.length; Be++)
      J(U[Be], q, oe, de, pe);
  }, te = (U) => {
    if (U.shapeFlag & 6)
      return te(U.component.subTree);
    if (U.shapeFlag & 128)
      return U.suspense.next();
    const q = f(U.anchor || U.el), oe = q && q[w5];
    return oe ? f(oe) : q;
  };
  let we = !1;
  const Fe = (U, q, oe) => {
    let de;
    U == null ? q._vnode && (J(q._vnode, null, null, !0), de = q._vnode.component) : v(
      q._vnode || null,
      U,
      q,
      null,
      null,
      null,
      oe
    ), q._vnode = U, we || (we = !0, Wx(de), g5(), we = !1);
  }, Me = {
    p: v,
    um: J,
    m: H,
    r: Q,
    mt: ee,
    mc: A,
    pc: K,
    pbc: D,
    n: te,
    o: n
  };
  return {
    render: Fe,
    hydrate: void 0,
    createApp: FE(Fe)
  };
}
function Vm({ type: n, props: e }, t) {
  return t === "svg" && n === "foreignObject" || t === "mathml" && n === "annotation-xml" && e && e.encoding && e.encoding.includes("html") ? void 0 : t;
}
function fr({ effect: n, job: e }, t) {
  t ? (n.flags |= 32, e.flags |= 4) : (n.flags &= -33, e.flags &= -5);
}
function t9(n, e) {
  return (!n || n && !n.pendingBranch) && e && !e.persisted;
}
function M1(n, e, t = !1) {
  const i = n.children, s = e.children;
  if (mt(i) && mt(s))
    for (let o = 0; o < i.length; o++) {
      const r = i[o];
      let a = s[o];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = s[o] = Gs(s[o]), a.el = r.el), !t && a.patchFlag !== -2 && M1(r, a)), a.type === sm && (a.patchFlag === -1 && (a = s[o] = Gs(a)), a.el = r.el), a.type === qn && !a.el && (a.el = r.el);
    }
}
function n9(n) {
  const e = n.slice(), t = [0];
  let i, s, o, r, a;
  const l = n.length;
  for (i = 0; i < l; i++) {
    const d = n[i];
    if (d !== 0) {
      if (s = t[t.length - 1], n[s] < d) {
        e[i] = s, t.push(i);
        continue;
      }
      for (o = 0, r = t.length - 1; o < r; )
        a = o + r >> 1, n[t[a]] < d ? o = a + 1 : r = a;
      d < n[t[o]] && (o > 0 && (e[i] = t[o - 1]), t[o] = i);
    }
  }
  for (o = t.length, r = t[o - 1]; o-- > 0; )
    t[o] = r, r = e[r];
  return t;
}
function F5(n) {
  const e = n.subTree.component;
  if (e)
    return e.asyncDep && !e.asyncResolved ? e : F5(e);
}
function tw(n) {
  if (n)
    for (let e = 0; e < n.length; e++)
      n[e].flags |= 8;
}
function N5(n) {
  if (n.placeholder)
    return n.placeholder;
  const e = n.component;
  return e ? N5(e.subTree) : null;
}
const U5 = (n) => n.__isSuspense;
function i9(n, e) {
  e && e.pendingBranch ? mt(n) ? e.effects.push(...n) : e.effects.push(n) : xE(n);
}
const j = /* @__PURE__ */ Symbol.for("v-fgt"), sm = /* @__PURE__ */ Symbol.for("v-txt"), qn = /* @__PURE__ */ Symbol.for("v-cmt"), gp = /* @__PURE__ */ Symbol.for("v-stc"), Xs = [];
let Ii = null;
function g(n = !1) {
  Xs.push(Ii = n ? null : []);
}
function T1() {
  Xs.pop(), Ii = Xs[Xs.length - 1] || null;
}
let zc = 1;
function qp(n, e = !1) {
  zc += n, n < 0 && Ii && e && (Ii.hasOnce = !0);
}
function G5(n) {
  return n.dynamicChildren = zc > 0 ? Ii || Hr : null, T1(), zc > 0 && Ii && Ii.push(n), n;
}
function b(n, e, t, i, s, o) {
  return G5(
    u(
      n,
      e,
      t,
      i,
      s,
      o,
      !0
    )
  );
}
function Ie(n, e, t, i, s) {
  return G5(
    C(
      n,
      e,
      t,
      i,
      s,
      !0
    )
  );
}
function $c(n) {
  return n ? n.__v_isVNode === !0 : !1;
}
function Nr(n, e) {
  return n.type === e.type && n.key === e.key;
}
const j5 = ({ key: n }) => n != null ? n : null, bp = ({
  ref: n,
  ref_key: e,
  ref_for: t
}) => (typeof n == "number" && (n = "" + n), n != null ? on(n) || /* @__PURE__ */ ai(n) || Ft(n) ? { i: Un, r: n, k: e, f: !!t } : n : null);
function u(n, e = null, t = null, i = 0, s = null, o = n === j ? 0 : 1, r = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: n,
    props: e,
    key: e && j5(e),
    ref: e && bp(e),
    scopeId: v5,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: i,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: Un
  };
  return a ? (Kp(l, t), o & 128 && n.normalize(l)) : t && (l.shapeFlag |= on(t) ? 8 : 16), zc > 0 && // avoid a block node from tracking itself
  !r && // has current parent block
  Ii && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && Ii.push(l), l;
}
const C = s9;
function s9(n, e = null, t = null, i = 0, s = null, o = !1) {
  if ((!n || n === I5) && (n = qn), $c(n)) {
    const a = er(
      n,
      e,
      !0
      /* mergeRef: true */
    );
    return t && Kp(a, t), zc > 0 && !o && Ii && (a.shapeFlag & 6 ? Ii[Ii.indexOf(n)] = a : Ii.push(a)), a.patchFlag = -2, a;
  }
  if (p9(n) && (n = n.__vccOpts), e) {
    e = o9(e);
    let { class: a, style: l } = e;
    a && !on(a) && (e.class = G(a)), qt(l) && (/* @__PURE__ */ b1(l) && !mt(l) && (l = gi({}, l)), e.style = ce(l));
  }
  const r = on(n) ? 1 : U5(n) ? 128 : nm(n) ? 64 : qt(n) ? 4 : Ft(n) ? 2 : 0;
  return u(
    n,
    e,
    t,
    i,
    s,
    r,
    o,
    !0
  );
}
function o9(n) {
  return n ? /* @__PURE__ */ b1(n) || $5(n) ? gi({}, n) : n : null;
}
function er(n, e, t = !1, i = !1) {
  const { props: s, ref: o, patchFlag: r, children: a, transition: l } = n, d = e ? H5(s || {}, e) : s, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: n.type,
    props: d,
    key: d && j5(d),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && o ? mt(o) ? o.concat(bp(e)) : [o, bp(e)] : bp(e)
    ) : o,
    scopeId: n.scopeId,
    slotScopeIds: n.slotScopeIds,
    children: a,
    target: n.target,
    targetStart: n.targetStart,
    targetAnchor: n.targetAnchor,
    staticCount: n.staticCount,
    shapeFlag: n.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && n.type !== j ? r === -1 ? 16 : r | 16 : r,
    dynamicProps: n.dynamicProps,
    dynamicChildren: n.dynamicChildren,
    appContext: n.appContext,
    dirs: n.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: n.component,
    suspense: n.suspense,
    ssContent: n.ssContent && er(n.ssContent),
    ssFallback: n.ssFallback && er(n.ssFallback),
    placeholder: n.placeholder,
    el: n.el,
    anchor: n.anchor,
    ctx: n.ctx,
    ce: n.ce,
    cacheIndex: n.cacheIndex
  };
  return l && i && la(
    c,
    l.clone(c)
  ), c;
}
function Y(n = " ", e = 0) {
  return C(sm, null, n, e);
}
function C1(n, e) {
  const t = C(gp, null, n);
  return t.staticCount = e, t;
}
function z(n = "", e = !1) {
  return e ? (g(), Ie(qn, null, n)) : C(qn, null, n);
}
function vs(n) {
  return n == null || typeof n == "boolean" ? C(qn) : mt(n) ? C(
    j,
    null,
    // #3666, avoid reference pollution when reusing vnode
    n.slice()
  ) : $c(n) ? Gs(n) : C(sm, null, String(n));
}
function Gs(n) {
  return n.el === null && n.patchFlag !== -1 || n.memo ? n : er(n);
}
function Kp(n, e) {
  let t = 0;
  const { shapeFlag: i } = n;
  if (e == null)
    e = null;
  else if (mt(e))
    t = 16;
  else if (typeof e == "object")
    if (i & 65) {
      const s = e.default;
      s && (s._c && (s._d = !1), Kp(n, s()), s._c && (s._d = !0));
      return;
    } else {
      t = 32;
      const s = e._;
      !s && !$5(e) ? e._ctx = Un : s === 3 && Un && (Un.slots._ === 1 ? e._ = 1 : (e._ = 2, n.patchFlag |= 1024));
    }
  else if (Ft(e)) {
    if (i & 65) {
      Kp(n, { default: e });
      return;
    }
    e = { default: e, _ctx: Un }, t = 32;
  } else
    e = String(e), i & 64 ? (t = 16, e = [Y(e)]) : t = 8;
  n.children = e, n.shapeFlag |= t;
}
function H5(...n) {
  const e = {};
  for (let t = 0; t < n.length; t++) {
    const i = n[t];
    for (const s in i)
      if (s === "class")
        e.class !== i.class && (e.class = G([e.class, i.class]));
      else if (s === "style")
        e.style = ce([e.style, i.style]);
      else if (Kf(s)) {
        const o = e[s], r = i[s];
        r && o !== r && !(mt(o) && o.includes(r)) ? e[s] = o ? [].concat(o, r) : r : r == null && o == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
        // the model listener.
        !Yf(s) && (e[s] = r);
      } else s !== "" && (e[s] = i[s]);
  }
  return e;
}
function ds(n, e, t, i = null) {
  ss(n, e, 7, [
    t,
    i
  ]);
}
const r9 = P5();
let a9 = 0;
function l9(n, e, t) {
  const i = n.type, s = (e ? e.appContext : n.appContext) || r9, o = {
    uid: a9++,
    vnode: n,
    type: i,
    parent: e,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new J3(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: e ? e.provides : Object.create(s.provides),
    ids: e ? e.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: YE(i, s),
    emitsOptions: GE(i, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: en,
    // inheritAttrs
    inheritAttrs: i.inheritAttrs,
    // state
    ctx: en,
    data: en,
    props: en,
    attrs: en,
    slots: en,
    refs: en,
    setupState: en,
    setupContext: null,
    // suspense related
    suspense: t,
    suspenseId: t ? t.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return o.ctx = { _: o }, o.root = e ? e.root : o, o.emit = UE.bind(null, o), n.ce && n.ce(o), o;
}
let pi = null;
const Wl = () => pi || Un;
let Yp, Dc;
{
  const n = Zf(), e = (t, i) => {
    let s;
    return (s = n[t]) || (s = n[t] = []), s.push(i), (o) => {
      s.length > 1 ? s.forEach((r) => r(o)) : s[0](o);
    };
  };
  Yp = e(
    "__VUE_INSTANCE_SETTERS__",
    (t) => pi = t
  ), Dc = e(
    "__VUE_SSR_SETTERS__",
    (t) => Oc = t
  );
}
const I1 = (n) => {
  const e = pi;
  return Yp(n), n.scope.on(), () => {
    n.scope.off(), Yp(e);
  };
}, nw = () => {
  pi && pi.scope.off(), Yp(null);
};
function V5(n) {
  return n.vnode.shapeFlag & 4;
}
let Oc = !1;
function d9(n, e = !1, t = !1) {
  e && Dc(e);
  const { props: i, children: s } = n.vnode, o = V5(n);
  qE(n, i, o, e), JE(n, s, t || e);
  const r = o ? c9(n, e) : void 0;
  return e && Dc(!1), r;
}
function c9(n, e) {
  const t = n.type;
  n.accessCache = /* @__PURE__ */ Object.create(null), n.proxy = new Proxy(n.ctx, DE);
  const { setup: i } = t;
  if (i) {
    Jo();
    const s = n.setupContext = i.length > 1 ? q5(n) : null, o = I1(n), r = bu(
      i,
      n,
      0,
      [
        n.props,
        s
      ]
    ), a = j3(r);
    if (Zo(), o(), (a || n.sp) && !ul(n) && PE(n), a) {
      if (r.then(nw, nw), e)
        return r.then((l) => {
          Dc(!0);
          try {
            iw(n, l, e);
          } finally {
            Dc(!1);
          }
        }).catch((l) => {
          em(l, n, 0);
        });
      n.asyncDep = r;
    } else
      iw(n, r);
  } else
    W5(n);
}
function iw(n, e, t) {
  Ft(e) ? n.type.__ssrInlineRender ? n.ssrRender = e : n.render = e : qt(e) && (n.setupState = p5(e)), W5(n);
}
function W5(n, e, t) {
  const i = n.type;
  n.render || (n.render = i.render || ea);
}
const u9 = {
  get(n, e) {
    return Vn(n, "get", ""), n[e];
  }
};
function q5(n) {
  const e = (t) => {
    n.exposed = t || {};
  };
  return {
    attrs: new Proxy(n.attrs, u9),
    slots: n.slots,
    emit: n.emit,
    expose: e
  };
}
function om(n) {
  return n.exposed ? n.exposeProxy || (n.exposeProxy = new Proxy(p5(mp(n.exposed)), {
    get(e, t) {
      if (t in e)
        return e[t];
      if (t in lc)
        return lc[t](n);
    },
    has(e, t) {
      return t in e || t in lc;
    }
  })) : n.proxy;
}
function h9(n, e = !0) {
  return Ft(n) ? n.displayName || n.name : n.name || e && n.__name;
}
function p9(n) {
  return Ft(n) && "__vccOpts" in n;
}
const I = (n, e) => /* @__PURE__ */ mE(n, e, Oc);
function Al(n, e, t) {
  try {
    qp(-1);
    const i = arguments.length;
    return i === 2 ? qt(e) && !mt(e) ? $c(e) ? C(n, null, [e]) : C(n, e) : C(n, null, e) : (i > 3 ? t = Array.prototype.slice.call(arguments, 2) : i === 3 && $c(t) && (t = [t]), C(n, e, t));
  } finally {
    qp(1);
  }
}
const f9 = "3.5.43";
let vv;
const sw = typeof window != "undefined" && window.trustedTypes;
if (sw)
  try {
    vv = /* @__PURE__ */ sw.createPolicy("vue", {
      createHTML: (n) => n
    });
  } catch {
  }
const K5 = vv ? (n) => vv.createHTML(n) : (n) => n, m9 = "http://www.w3.org/2000/svg", g9 = "http://www.w3.org/1998/Math/MathML", Ns = typeof document != "undefined" ? document : null, ow = Ns && /* @__PURE__ */ Ns.createElement("template"), b9 = {
  insert: (n, e, t) => {
    e.insertBefore(n, t || null);
  },
  remove: (n) => {
    const e = n.parentNode;
    e && e.removeChild(n);
  },
  createElement: (n, e, t, i) => {
    const s = e === "svg" ? Ns.createElementNS(m9, n) : e === "mathml" ? Ns.createElementNS(g9, n) : t ? Ns.createElement(n, { is: t }) : Ns.createElement(n);
    return n === "select" && i && i.multiple != null && s.setAttribute("multiple", i.multiple), s;
  },
  createText: (n) => Ns.createTextNode(n),
  createComment: (n) => Ns.createComment(n),
  setText: (n, e) => {
    n.nodeValue = e;
  },
  setElementText: (n, e) => {
    n.textContent = e;
  },
  parentNode: (n) => n.parentNode,
  nextSibling: (n) => n.nextSibling,
  querySelector: (n) => Ns.querySelector(n),
  setScopeId(n, e) {
    n.setAttribute(e, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(n, e, t, i, s, o) {
    const r = t ? t.previousSibling : e.lastChild;
    if (s && (s === o || s.nextSibling))
      for (; e.insertBefore(s.cloneNode(!0), t), !(s === o || !(s = s.nextSibling)); )
        ;
    else {
      ow.innerHTML = K5(
        i === "svg" ? `<svg>${n}</svg>` : i === "mathml" ? `<math>${n}</math>` : n
      );
      const a = ow.content;
      if (i === "svg" || i === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      e.insertBefore(a, t);
    }
    return [
      // first
      r ? r.nextSibling : e.firstChild,
      // last
      t ? t.previousSibling : e.lastChild
    ];
  }
}, fo = "transition", rd = "animation", Pl = /* @__PURE__ */ Symbol("_vtc"), Y5 = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, X5 = /* @__PURE__ */ gi(
  {},
  _5,
  Y5
), v9 = (n) => (n.displayName = "Transition", n.props = X5, n), vt = /* @__PURE__ */ v9(
  (n, { slots: e }) => Al(IE, J5(n), e)
), mr = (n, e = []) => {
  mt(n) ? n.forEach((t) => t(...e)) : n && n(...e);
}, rw = (n) => n ? mt(n) ? n.some((e) => e.length > 1) : n.length > 1 : !1;
function J5(n) {
  const e = {};
  for (const F in n)
    F in Y5 || (e[F] = n[F]);
  if (n.css === !1)
    return e;
  const {
    name: t = "v",
    type: i,
    duration: s,
    enterFromClass: o = `${t}-enter-from`,
    enterActiveClass: r = `${t}-enter-active`,
    enterToClass: a = `${t}-enter-to`,
    appearFromClass: l = o,
    appearActiveClass: d = r,
    appearToClass: c = a,
    leaveFromClass: h = `${t}-leave-from`,
    leaveActiveClass: f = `${t}-leave-active`,
    leaveToClass: p = `${t}-leave-to`
  } = n, y = y9(s), v = y && y[0], x = y && y[1], {
    onBeforeEnter: w,
    onEnter: S,
    onEnterCancelled: M,
    onLeave: _,
    onLeaveCancelled: T,
    onBeforeAppear: k = w,
    onAppear: P = S,
    onAppearCancelled: A = M
  } = e, R = (F, ie, ee, me) => {
    F._enterCancelled = me, Co(F, ie ? c : a), Co(F, ie ? d : r), ee && ee();
  }, D = (F, ie) => {
    F._isLeaving = !1, Co(F, h), Co(F, p), Co(F, f), ie && ie();
  }, O = (F) => (ie, ee) => {
    const me = F ? P : S, L = () => R(ie, F, ee);
    mr(me, [ie, L]), aw(() => {
      Co(ie, F ? l : o), cs(ie, F ? c : a), rw(me) || lw(ie, i, v, L);
    });
  };
  return gi(e, {
    onBeforeEnter(F) {
      mr(w, [F]), cs(F, o), cs(F, r);
    },
    onBeforeAppear(F) {
      mr(k, [F]), cs(F, l), cs(F, d);
    },
    onEnter: O(!1),
    onAppear: O(!0),
    onLeave(F, ie) {
      F._isLeaving = !0;
      const ee = () => D(F, ie);
      cs(F, h), F._enterCancelled ? (cs(F, f), yv(F)) : (yv(F), cs(F, f)), aw(() => {
        F._isLeaving && (Co(F, h), cs(F, p), rw(_) || lw(F, i, x, ee));
      }), mr(_, [F, ee]);
    },
    onEnterCancelled(F) {
      R(F, !1, void 0, !0), mr(M, [F]);
    },
    onAppearCancelled(F) {
      R(F, !0, void 0, !0), mr(A, [F]);
    },
    onLeaveCancelled(F) {
      D(F), mr(T, [F]);
    }
  });
}
function y9(n) {
  if (n == null)
    return null;
  if (qt(n))
    return [Wm(n.enter), Wm(n.leave)];
  {
    const e = Wm(n);
    return [e, e];
  }
}
function Wm(n) {
  return FP(n);
}
function cs(n, e) {
  e.split(/\s+/).forEach((t) => t && n.classList.add(t)), (n[Pl] || (n[Pl] = /* @__PURE__ */ new Set())).add(e);
}
function Co(n, e) {
  e.split(/\s+/).forEach((i) => i && n.classList.remove(i));
  const t = n[Pl];
  t && (t.delete(e), t.size || (n[Pl] = void 0));
}
function aw(n) {
  requestAnimationFrame(() => {
    requestAnimationFrame(n);
  });
}
let x9 = 0;
function lw(n, e, t, i) {
  const s = n._endId = ++x9, o = () => {
    s === n._endId && i();
  };
  if (t != null)
    return setTimeout(o, t);
  const { type: r, timeout: a, propCount: l } = Z5(n, e);
  if (!r)
    return i();
  const d = r + "end";
  let c = 0;
  const h = () => {
    n.removeEventListener(d, f), o();
  }, f = (p) => {
    p.target === n && ++c >= l && h();
  };
  setTimeout(() => {
    c < l && h();
  }, a + 1), n.addEventListener(d, f);
}
function Z5(n, e) {
  const t = window.getComputedStyle(n), i = (y) => (t[y] || "").split(", "), s = i(`${fo}Delay`), o = i(`${fo}Duration`), r = dw(s, o), a = i(`${rd}Delay`), l = i(`${rd}Duration`), d = dw(a, l);
  let c = null, h = 0, f = 0;
  e === fo ? r > 0 && (c = fo, h = r, f = o.length) : e === rd ? d > 0 && (c = rd, h = d, f = l.length) : (h = Math.max(r, d), c = h > 0 ? r > d ? fo : rd : null, f = c ? c === fo ? o.length : l.length : 0);
  const p = c === fo && /\b(?:transform|all)(?:,|$)/.test(
    i(`${fo}Property`).toString()
  );
  return {
    type: c,
    timeout: h,
    propCount: f,
    hasTransform: p
  };
}
function dw(n, e) {
  for (; n.length < e.length; )
    n = n.concat(n);
  return Math.max(...e.map((t, i) => cw(t) + cw(n[i])));
}
function cw(n) {
  return n === "auto" ? 0 : Number(n.slice(0, -1).replace(",", ".")) * 1e3;
}
function yv(n) {
  return (n ? n.ownerDocument : document).body.offsetHeight;
}
function w9(n, e, t) {
  const i = n[Pl];
  i && (e = (e ? [e, ...i] : [...i]).join(" ")), e == null ? n.removeAttribute("class") : t ? n.setAttribute("class", e) : n.className = e;
}
const Xp = /* @__PURE__ */ Symbol("_vod"), A1 = /* @__PURE__ */ Symbol("_vsh"), xv = {
  // used for prop mismatch check during hydration
  name: "show",
  beforeMount(n, { value: e }, { transition: t }) {
    n[Xp] = n.style.display === "none" ? "" : n.style.display, t && e ? t.beforeEnter(n) : ad(n, e);
  },
  mounted(n, { value: e }, { transition: t }) {
    t && e && t.enter(n);
  },
  updated(n, { value: e, oldValue: t }, { transition: i }) {
    !e != !t && (i ? e ? (i.beforeEnter(n), ad(n, !0), i.enter(n)) : i.leave(n, () => {
      ad(n, !1);
    }) : ad(n, e));
  },
  beforeUnmount(n, { value: e }) {
    ad(n, e);
  }
};
function ad(n, e) {
  n.style.display = e ? n[Xp] : "none", n[A1] = !e;
}
const k9 = /* @__PURE__ */ Symbol(""), _9 = /(?:^|;)\s*display\s*:/;
function S9(n, e, t) {
  const i = n.style, s = on(t);
  let o = !1;
  if (t && !s) {
    if (e)
      if (on(e))
        for (const r of e.split(";")) {
          const a = r.slice(0, r.indexOf(":")).trim();
          t[a] == null && jd(i, a, "");
        }
      else
        for (const r in e)
          t[r] == null && jd(i, r, "");
    for (const r in t) {
      r === "display" && (o = !0);
      const a = t[r];
      a != null ? T9(
        n,
        r,
        !on(e) && e ? e[r] : void 0,
        a
      ) || jd(i, r, a) : jd(i, r, "");
    }
  } else if (s) {
    if (e !== t) {
      const r = i[k9];
      r && (t += ";" + r), i.cssText = t, o = _9.test(t);
    }
  } else e && n.removeAttribute("style");
  Xp in n && (n[Xp] = o ? i.display : "", n[A1] && (i.display = "none"));
}
const $u = /\s*!important$/;
function jd(n, e, t) {
  if (mt(t))
    t.forEach((i) => jd(n, e, i));
  else if (t == null && (t = ""), e.startsWith("--"))
    $u.test(t) ? n.setProperty(e, t.replace($u, ""), "important") : n.setProperty(e, t);
  else {
    const i = M9(n, e);
    $u.test(t) ? n.setProperty(
      lr(i),
      t.replace($u, ""),
      "important"
    ) : n[i] = t;
  }
}
const uw = ["Webkit", "Moz", "ms"], qm = {};
function M9(n, e) {
  const t = qm[e];
  if (t)
    return t;
  let i = ri(e);
  if (i !== "filter" && i in n)
    return qm[e] = i;
  i = Jf(i);
  for (let s = 0; s < uw.length; s++) {
    const o = uw[s] + i;
    if (o in n)
      return qm[e] = o;
  }
  return e;
}
function T9(n, e, t, i) {
  return n.tagName === "TEXTAREA" && (e === "width" || e === "height") && on(i) && t === i;
}
const hw = "http://www.w3.org/1999/xlink";
function pw(n, e, t, i, s, o = VP(e)) {
  i && e.startsWith("xlink:") ? t == null ? n.removeAttributeNS(hw, e.slice(6, e.length)) : n.setAttributeNS(hw, e, t) : t == null || o && !q3(t) ? n.removeAttribute(e) : n.setAttribute(
    e,
    o ? "" : is(t) ? String(t) : t
  );
}
function fw(n, e, t, i, s) {
  if (e === "innerHTML" || e === "textContent") {
    t != null && (n[e] = e === "innerHTML" ? K5(t) : t);
    return;
  }
  const o = n.tagName;
  if (e === "value" && o !== "PROGRESS" && // custom elements may use _value internally
  !o.includes("-")) {
    const a = o === "OPTION" ? n.getAttribute("value") || "" : n.value, l = t == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      n.type === "checkbox" ? "on" : ""
    ) : String(t);
    (a !== l || !("_value" in n)) && (n.value = l), t == null && n.removeAttribute(e), n._value = t;
    return;
  }
  let r = !1;
  if (t === "" || t == null) {
    const a = typeof n[e];
    a === "boolean" ? t = q3(t) : t == null && a === "string" ? (t = "", r = !0) : a === "number" && (t = 0, r = !0);
  }
  try {
    n[e] = t;
  } catch {
  }
  r && n.removeAttribute(s || e);
}
function Ur(n, e, t, i) {
  n.addEventListener(e, t, i);
}
function C9(n, e, t, i) {
  n.removeEventListener(e, t, i);
}
const mw = /* @__PURE__ */ Symbol("_vei");
function I9(n, e, t, i, s = null) {
  const o = n[mw] || (n[mw] = {}), r = o[e];
  if (i && r)
    r.value = i;
  else {
    const [a, l] = E9(e);
    if (i) {
      const d = o[e] = $9(
        i,
        s
      );
      Ur(n, a, d, l);
    } else r && (C9(n, a, r, l), o[e] = void 0);
  }
}
const A9 = /(Once|Passive|Capture)$/, P9 = /^on:?(?:Once|Passive|Capture)$/;
function E9(n) {
  let e, t;
  for (; (t = n.match(A9)) && !P9.test(n); )
    e || (e = {}), n = n.slice(0, n.length - t[1].length), e[t[1].toLowerCase()] = !0;
  return [n[2] === ":" ? n.slice(3) : lr(n.slice(2)), e];
}
let Km = 0;
const R9 = /* @__PURE__ */ Promise.resolve(), z9 = () => Km || (R9.then(() => Km = 0), Km = Date.now());
function $9(n, e) {
  const t = (i) => {
    if (!i._vts)
      i._vts = Date.now();
    else if (i._vts <= t.attached)
      return;
    const s = t.value;
    if (mt(s)) {
      const o = i.stopImmediatePropagation;
      i.stopImmediatePropagation = () => {
        o.call(i), i._stopped = !0;
      };
      const r = s.slice(), a = [i];
      for (let l = 0; l < r.length && !i._stopped; l++) {
        const d = r[l];
        d && ss(
          d,
          e,
          5,
          a
        );
      }
    } else
      ss(
        s,
        e,
        5,
        [i]
      );
  };
  return t.value = n, t.attached = z9(), t;
}
const gw = (n) => n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && // lowercase letter
n.charCodeAt(2) > 96 && n.charCodeAt(2) < 123, D9 = (n, e, t, i, s, o) => {
  const r = s === "svg";
  e === "class" ? w9(n, i, r) : e === "style" ? S9(n, t, i) : Kf(e) ? Yf(e) || I9(n, e, t, i, o) : (e[0] === "." ? (e = e.slice(1), !0) : e[0] === "^" ? (e = e.slice(1), !1) : O9(n, e, i, r)) ? (fw(n, e, i), !n.tagName.includes("-") && (e === "value" || e === "checked" || e === "selected") && pw(n, e, i, r, o, e !== "value")) : /* #11081 force set props for possible async custom element */ n._isVueCE && // #12408 check if it's declared prop or it's async custom element
  (L9(n, e) || // @ts-expect-error _def is private
  n._def.__asyncLoader && (/[A-Z]/.test(e) || !on(i))) ? fw(n, ri(e), i, o, e) : (e === "true-value" ? n._trueValue = i : e === "false-value" && (n._falseValue = i), pw(n, e, i, r));
};
function O9(n, e, t, i) {
  if (i)
    return !!(e === "innerHTML" || e === "textContent" || e in n && gw(e) && Ft(t));
  if (e === "spellcheck" || e === "draggable" || e === "translate" || e === "autocorrect" || e === "sandbox" && n.tagName === "IFRAME" || e === "form" || e === "list" && n.tagName === "INPUT" || e === "type" && n.tagName === "TEXTAREA")
    return !1;
  if (e === "width" || e === "height") {
    const s = n.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return gw(e) && on(t) ? !1 : e in n;
}
function L9(n, e) {
  const t = (
    // @ts-expect-error _def is private
    n._def.props
  );
  if (!t)
    return !1;
  const i = ri(e);
  return Array.isArray(t) ? t.some((s) => ri(s) === i) : Object.keys(t).some((s) => ri(s) === i);
}
const Q5 = /* @__PURE__ */ new WeakMap(), e6 = /* @__PURE__ */ new WeakMap(), Jp = /* @__PURE__ */ Symbol("_moveCb"), bw = /* @__PURE__ */ Symbol("_enterCb"), B9 = (n) => (delete n.props.mode, n), F9 = /* @__PURE__ */ B9({
  name: "TransitionGroup",
  props: /* @__PURE__ */ gi({}, X5, {
    tag: String,
    moveClass: String
  }),
  setup(n, { slots: e }) {
    const t = Wl(), i = k5();
    let s, o;
    return C5(() => {
      if (!s.length)
        return;
      const r = n.moveClass || `${n.name || "v"}-move`;
      if (!j9(
        s[0].el,
        t.vnode.el,
        r
      )) {
        s = [];
        return;
      }
      s.forEach(N9), s.forEach(U9);
      const a = s.filter(G9);
      yv(t.vnode.el), a.forEach((l) => {
        const d = l.el, c = d.style;
        cs(d, r), c.transform = c.webkitTransform = c.transitionDuration = "";
        const h = d[Jp] = (f) => {
          f && f.target !== d || (!f || f.propertyName.endsWith("transform")) && (d.removeEventListener("transitionend", h), d[Jp] = null, Co(d, r));
        };
        d.addEventListener("transitionend", h);
      }), s = [];
    }), () => {
      const r = /* @__PURE__ */ Et(n), a = J5(r);
      let l = r.tag || j;
      if (s = [], o)
        for (let d = 0; d < o.length; d++) {
          const c = o[d];
          c.el && c.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
          !c.el[A1] && (s.push(c), la(
            c,
            Rc(
              c,
              a,
              i,
              t
            )
          ), Q5.set(c, t6(c.el)));
        }
      o = e.default ? x1(e.default()) : [];
      for (let d = 0; d < o.length; d++) {
        const c = o[d];
        c.key != null && la(
          c,
          Rc(c, a, i, t)
        );
      }
      return C(l, null, o);
    };
  }
}), Zp = F9;
function N9(n) {
  const e = n.el;
  e[Jp] && e[Jp](), e[bw] && e[bw]();
}
function U9(n) {
  e6.set(n, t6(n.el));
}
function G9(n) {
  const e = Q5.get(n), t = e6.get(n), i = e.left - t.left, s = e.top - t.top;
  if (i || s) {
    const o = n.el, r = o.style, a = o.getBoundingClientRect();
    let l = 1, d = 1;
    return o.offsetWidth && (l = a.width / o.offsetWidth), o.offsetHeight && (d = a.height / o.offsetHeight), (!Number.isFinite(l) || l === 0) && (l = 1), (!Number.isFinite(d) || d === 0) && (d = 1), Math.abs(l - 1) < 0.01 && (l = 1), Math.abs(d - 1) < 0.01 && (d = 1), r.transform = r.webkitTransform = `translate(${i / l}px,${s / d}px)`, r.transitionDuration = "0s", n;
  }
}
function t6(n) {
  const e = n.getBoundingClientRect();
  return {
    left: e.left,
    top: e.top
  };
}
function j9(n, e, t) {
  const i = n.cloneNode(), s = n[Pl];
  s && s.forEach((a) => {
    a.split(/\s+/).forEach((l) => l && i.classList.remove(l));
  }), t.split(/\s+/).forEach((a) => a && i.classList.add(a)), i.style.display = "none";
  const o = e.nodeType === 1 ? e : e.parentNode;
  o.appendChild(i);
  const { hasTransform: r } = Z5(i);
  return o.removeChild(i), r;
}
const Qp = (n) => {
  const e = n.props["onUpdate:modelValue"] || !1;
  return mt(e) ? (t) => fp(e, t) : e;
};
function H9(n) {
  n.target.composing = !0;
}
function vw(n) {
  const e = n.target;
  e.composing && (e.composing = !1, e.dispatchEvent(new Event("input")));
}
const Vr = /* @__PURE__ */ Symbol("_assign"), Du = /* @__PURE__ */ Symbol("_initialValue");
function Ym(n, e, t) {
  return e && (n = n.trim()), t && (n = d1(n)), n;
}
const Zt = {
  created(n, { modifiers: { lazy: e, trim: t, number: i } }, s) {
    n.parentNode && (n.type === "text" ? n[Du] = n.defaultValue.replace(/[\r\n]/g, "") : n.type === "textarea" && (n[Du] = n.defaultValue.replace(/\r\n?/g, `
`))), n[Vr] = Qp(s);
    const o = i || s.props && s.props.type === "number";
    Ur(n, e ? "change" : "input", (r) => {
      r.target.composing || n[Vr](Ym(n.value, t, o));
    }), (t || o) && Ur(n, "change", () => {
      n.value = Ym(n.value, t, o);
    }), e || (Ur(n, "compositionstart", H9), Ur(n, "compositionend", vw), Ur(n, "change", vw));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(n, { value: e, modifiers: { trim: t, number: i } }) {
    const s = e == null ? "" : e, o = n[Du];
    delete n[Du], o !== void 0 && (n.type === "text" || n.type === "textarea") && n.value !== o ? n[Vr](Ym(n.value, t, i)) : n.value = s;
  },
  beforeUpdate(n, { value: e, oldValue: t, modifiers: { lazy: i, trim: s, number: o } }, r) {
    if (n[Vr] = Qp(r), n.composing) return;
    const a = (o || n.type === "number") && !/^0\d/.test(n.value) ? d1(n.value) : n.value, l = e == null ? "" : e;
    if (a === l)
      return;
    const d = n.getRootNode();
    (d instanceof Document || d instanceof ShadowRoot) && d.activeElement === n && n.type !== "range" && (i && e === t || s && n.value.trim() === l) || (n.value = l);
  }
}, ol = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(n, e, t) {
    n[Vr] = Qp(t), Ur(n, "change", () => {
      const i = n._modelValue, s = V9(n), o = n.checked, r = n[Vr];
      if (mt(i)) {
        const a = K3(i, s), l = a !== -1;
        if (o && !l)
          r(i.concat(s));
        else if (!o && l) {
          const d = [...i];
          d.splice(a, 1), r(d);
        }
      } else if (Il(i)) {
        const a = new Set(i);
        o ? a.add(s) : a.delete(s), r(a);
      } else
        r(n6(n, o));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: yw,
  beforeUpdate(n, e, t) {
    n[Vr] = Qp(t), yw(n, e, t);
  }
};
function yw(n, { value: e, oldValue: t }, i) {
  n._modelValue = e;
  let s;
  if (mt(e))
    s = K3(e, i.props.value) > -1;
  else if (Il(e))
    s = e.has(i.props.value);
  else {
    if (e === t) return;
    s = Vl(e, n6(n, !0));
  }
  n.checked !== s && (n.checked = s);
}
function V9(n) {
  return "_value" in n ? n._value : n.value;
}
function n6(n, e) {
  const t = e ? "_trueValue" : "_falseValue";
  return t in n ? n[t] : e;
}
const W9 = ["ctrl", "shift", "alt", "meta"], q9 = {
  stop: (n) => n.stopPropagation(),
  prevent: (n) => n.preventDefault(),
  self: (n) => n.target !== n.currentTarget,
  ctrl: (n) => !n.ctrlKey,
  shift: (n) => !n.shiftKey,
  alt: (n) => !n.altKey,
  meta: (n) => !n.metaKey,
  left: (n) => "button" in n && n.button !== 0,
  middle: (n) => "button" in n && n.button !== 1,
  right: (n) => "button" in n && n.button !== 2,
  exact: (n, e) => W9.some((t) => n[`${t}Key`] && !e.includes(t))
}, Te = (n, e) => {
  if (!n) return n;
  const t = n._withMods || (n._withMods = {}), i = e.join(".");
  return t[i] || (t[i] = ((s, ...o) => {
    for (let r = 0; r < e.length; r++) {
      const a = q9[e[r]];
      if (a && a(s, e)) return;
    }
    return n(s, ...o);
  }));
}, K9 = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, tn = (n, e) => {
  const t = n._withKeys || (n._withKeys = {}), i = e.join(".");
  return t[i] || (t[i] = ((s) => {
    if (!("key" in s))
      return;
    const o = lr(s.key);
    if (e.some(
      (r) => r === o || K9[r] === o
    ))
      return n(s);
  }));
}, Y9 = /* @__PURE__ */ gi({ patchProp: D9 }, b9);
let xw;
function X9() {
  return xw || (xw = QE(Y9));
}
const i6 = ((...n) => {
  const e = X9().createApp(...n), { mount: t } = e;
  return e.mount = (i) => {
    const s = Z9(i);
    if (!s) return;
    const o = e._component;
    !Ft(o) && !o.render && !o.template && (o.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const r = t(s, !1, J9(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), r;
  }, e;
});
function J9(n) {
  if (n instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && n instanceof MathMLElement)
    return "mathml";
}
function Z9(n) {
  return on(n) ? document.querySelector(n) : n;
}
const gr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const ww = (...n) => n.filter((e, t, i) => !!e && e.trim() !== "" && i.indexOf(e) === t).join(" ").trim();
function Xm(n) {
  return n != null;
}
function Q9(n, e = {}) {
  var f, p, y, v, x, w, S, M, _, T, k, P, A, R, D;
  const t = (f = e.attributeNames) != null ? f : {}, i = (O) => {
    var F;
    return (F = t[O]) != null ? F : O;
  }, s = (y = (p = n.size) != null ? p : n.width) != null ? y : gr.width, o = (x = (v = n.size) != null ? v : n.height) != null ? x : gr.height, r = (S = (w = n.aliases) == null ? void 0 : w.filter((O) => typeof O == "string" && O.trim() !== "").map((O) => `lucide-${O}`)) != null ? S : [], a = [...n.name ? [`lucide-${n.name}`] : [], ...r], l = (_ = (M = e.className) == null ? void 0 : M.split(" ").filter(Boolean)) != null ? _ : [], d = e.includeDefaultClasses === !1 ? ww(...l) : ww("lucide", ...a, ...l), c = e.absoluteStrokeWidth ? Number((T = e.strokeWidth) != null ? T : gr["stroke-width"]) * Number((P = (k = n.size) != null ? k : n.width) != null ? P : gr.width) / Number((R = (A = e.size) != null ? A : e.width) != null ? R : gr.width) : (D = e.strokeWidth) != null ? D : gr["stroke-width"];
  return [
    "svg",
    {
      ...Object.entries(gr).reduce((O, [F, ie]) => (O[i(F)] = ie, O), {}),
      ..."color" in e && e.color && {
        [i("stroke")]: e.color
      },
      ..."size" in e && Xm(e.size) && {
        [i("width")]: e.size,
        [i("height")]: e.size
      },
      ..."width" in e && Xm(e.width) && {
        [i("width")]: e.width
      },
      ..."height" in e && Xm(e.height) && {
        [i("height")]: e.height
      },
      [i("stroke-width")]: c,
      ...d && {
        [i("class")]: d
      },
      [i("viewBox")]: `0 0 ${s} ${o}`,
      ...e.hasA11yProp === !1 ? {
        [i("aria-hidden")]: "true"
      } : {},
      ..."attributes" in e && e.attributes
    },
    n.node.map((O) => {
      const [F, ie, ee] = O, me = e.nonScalingStroke ? { [i("vector-effect")]: "non-scaling-stroke", ...ie } : ie;
      return ee ? [F, me, ee] : [F, me];
    })
  ];
}
const eR = (n) => {
  for (const e in n)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
  return !1;
};
const Ou = (n) => n === "";
const tR = (n) => n == null ? void 0 : n.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const nR = /* @__PURE__ */ Symbol("lucide-icons");
function iR() {
  return tm(nR, {});
}
const sR = ({
  name: n,
  iconNode: e,
  "icon-node": t,
  icon: i = {
    name: n && tR(n),
    node: ((x) => (x = e != null ? e : t) != null ? x : [])(),
    size: 24,
    aliases: []
  },
  absoluteStrokeWidth: s,
  "absolute-stroke-width": o,
  nonScalingStroke: r,
  "non-scaling-stroke": a,
  strokeWidth: l,
  "stroke-width": d,
  size: c,
  width: h = c,
  height: f = c,
  color: p,
  ...y
}, { slots: v }) => {
  var F, ie, ee, me;
  const {
    size: w,
    color: S,
    strokeWidth: M = 2,
    absoluteStrokeWidth: _ = !1,
    nonScalingStroke: T = !1,
    class: k = ""
  } = iR(), P = Ou(s) || Ou(o) || s === !0 || o === !0 || _ === !0, A = Ou(r) || Ou(a) || r === !0 || a === !0 || T === !0;
  delete y.class;
  const R = (F = v.default) == null ? void 0 : F.call(v), [, D, O = []] = Q9(i, {
    color: p != null ? p : S,
    width: (ie = h != null ? h : c) != null ? ie : w,
    height: (ee = f != null ? f : c) != null ? ee : w,
    strokeWidth: (me = l != null ? l : d) != null ? me : M,
    absoluteStrokeWidth: P,
    nonScalingStroke: A,
    className: k,
    hasA11yProp: R != null && R.length > 0 || eR(y),
    attributes: y
  });
  return Al("svg", D, [
    ...O.map(([L, N]) => Al(L, N)),
    ...R != null ? R : []
  ]);
};
function Se(n, e = []) {
  const t = typeof n == "string" ? {
    name: n,
    node: e
  } : n;
  return (i, { slots: s }) => Al(
    sR,
    {
      ...i,
      icon: t
    },
    s.default ? { default: s.default } : void 0
  );
}
const oR = {
  name: "align-center-horizontal",
  size: 24,
  node: [
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
    ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
    ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
    ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
  ]
}, rR = Se(oR);
const aR = {
  name: "align-horizontal-distribute-center",
  size: 24,
  node: [
    ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
    ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
    ["path", { d: "M17 22v-5", key: "4b6g73" }],
    ["path", { d: "M17 7V2", key: "hnrr36" }],
    ["path", { d: "M7 22v-3", key: "1r4jpn" }],
    ["path", { d: "M7 5V2", key: "liy1u9" }]
  ]
}, lR = Se(aR);
const dR = {
  name: "align-start-horizontal",
  size: 24,
  node: [
    ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
    ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
    ["path", { d: "M22 2H2", key: "fhrpnj" }]
  ]
}, cR = Se(dR);
const uR = {
  name: "align-start-vertical",
  size: 24,
  node: [
    ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
    ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
    ["path", { d: "M2 2v20", key: "1ivd8o" }]
  ]
}, hR = Se(uR);
const pR = {
  name: "aperture",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
    ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
    ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
    ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
    ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
    ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
  ]
}, fR = Se(pR);
const mR = {
  name: "arrow-down-to-line",
  size: 24,
  node: [
    ["path", { d: "M12 17V3", key: "1cwfxf" }],
    ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
    ["path", { d: "M19 21H5", key: "150jfl" }]
  ]
}, gR = Se(mR);
const bR = {
  name: "arrow-down",
  size: 24,
  node: [
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
  ]
}, vR = Se(bR);
const yR = {
  name: "arrow-left",
  size: 24,
  node: [
    ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
    ["path", { d: "M19 12H5", key: "x3x0zl" }]
  ]
}, xR = Se(yR);
const wR = {
  name: "arrow-right",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
  ]
}, s6 = Se(wR);
const kR = {
  name: "arrow-up-down",
  size: 24,
  node: [
    ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
    ["path", { d: "M17 20V4", key: "1ejh1v" }],
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }]
  ]
}, _R = Se(kR);
const SR = {
  name: "arrow-up-right",
  size: 24,
  node: [
    ["path", { d: "M7 7h10v10", key: "1tivn9" }],
    ["path", { d: "M7 17 17 7", key: "1vkiza" }]
  ]
}, o6 = Se(SR);
const MR = {
  name: "arrow-up",
  size: 24,
  node: [
    ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
    ["path", { d: "M12 19V5", key: "x0mq9r" }]
  ]
}, r6 = Se(MR);
const TR = {
  name: "at-sign",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
  ]
}, CR = Se(TR);
const IR = {
  name: "bell-off",
  size: 24,
  node: [
    ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
    [
      "path",
      {
        d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
        key: "178tsu"
      }
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
  ]
}, AR = Se(IR);
const PR = {
  name: "bell",
  size: 24,
  node: [
    ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
    [
      "path",
      {
        d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
        key: "11g9vi"
      }
    ]
  ]
}, ER = Se(PR);
const RR = {
  name: "blend",
  size: 24,
  node: [
    ["circle", { cx: "15", cy: "9", r: "7", key: "1i12rt" }],
    ["circle", { cx: "9", cy: "15", r: "7", key: "19bs8k" }]
  ]
}, zR = Se(RR);
const $R = {
  name: "bookmark-plus",
  size: 24,
  node: [
    ["path", { d: "M12 7v6", key: "lw1j43" }],
    ["path", { d: "M15 10H9", key: "o6yqo3" }],
    [
      "path",
      {
        d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
        key: "oz39mx"
      }
    ]
  ]
}, DR = Se($R);
const OR = {
  name: "bookmark",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
        key: "oz39mx"
      }
    ]
  ]
}, LR = Se(OR);
const BR = {
  name: "box",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
        key: "hh9hay"
      }
    ],
    ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
    ["path", { d: "M12 22V12", key: "d0xqtd" }]
  ]
}, FR = Se(BR);
const NR = {
  name: "bring-to-front",
  size: 24,
  node: [
    ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
    ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
    ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
  ]
}, UR = Se(NR);
const GR = {
  name: "brush",
  size: 24,
  node: [
    ["path", { d: "m11 10 3 3", key: "fzmg1i" }],
    [
      "path",
      {
        d: "M6.5 21A3.5 3.5 0 1 0 3 17.5a2.62 2.62 0 0 1-.708 1.792A1 1 0 0 0 3 21z",
        key: "p4q2r7"
      }
    ],
    ["path", { d: "M9.969 17.031 21.378 5.624a1 1 0 0 0-3.002-3.002L6.967 14.031", key: "wy6l02" }]
  ]
}, jR = Se(GR);
const HR = {
  name: "bug",
  size: 24,
  node: [
    ["path", { d: "M12 20v-9", key: "1qisl0" }],
    ["path", { d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z", key: "uouzyp" }],
    ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
    ["path", { d: "M21 21a4 4 0 0 0-3.81-4", key: "1b0z45" }],
    ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97", key: "5cxbf6" }],
    ["path", { d: "M22 13h-4", key: "1jl80f" }],
    ["path", { d: "M3 21a4 4 0 0 1 3.81-4", key: "1fjd4g" }],
    ["path", { d: "M3 5a4 4 0 0 0 3.55 3.97", key: "1d7oge" }],
    ["path", { d: "M6 13H2", key: "82j7cp" }],
    ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
    ["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13", key: "1vgav8" }]
  ]
}, VR = Se(HR);
const WR = {
  name: "building-complex",
  size: 24,
  node: [
    ["path", { d: "M10 12h4", key: "a56b0p" }],
    ["path", { d: "M10 8h4", key: "1sr2af" }],
    ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3", key: "1rgiei" }],
    [
      "path",
      {
        d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
        key: "secmi2"
      }
    ],
    ["path", { d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16", key: "16ra0t" }]
  ],
  aliases: ["building-2"]
}, qR = Se(WR);
const KR = {
  name: "camera",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
        key: "18u6gg"
      }
    ],
    ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
  ]
}, YR = Se(KR);
const XR = {
  name: "check-check",
  size: 24,
  node: [
    ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
    ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
  ]
}, JR = Se(XR);
const ZR = {
  name: "check",
  size: 24,
  node: [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]
}, a6 = Se(ZR);
const QR = {
  name: "chevron-down",
  size: 24,
  node: [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]]
}, l6 = Se(QR);
const ez = {
  name: "chevron-left",
  size: 24,
  node: [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]]
}, d6 = Se(ez);
const tz = {
  name: "chevron-right",
  size: 24,
  node: [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]]
}, c6 = Se(tz);
const nz = {
  name: "chevron-up",
  size: 24,
  node: [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]
}, iz = Se(nz);
const sz = {
  name: "chevrons-down-up",
  size: 24,
  node: [
    ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
    ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
  ]
}, oz = Se(sz);
const rz = {
  name: "chevrons-up-down",
  size: 24,
  node: [
    ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
    ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
  ]
}, az = Se(rz);
const lz = {
  name: "chevrons-up",
  size: 24,
  node: [
    ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
    ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
  ]
}, dz = Se(lz);
const cz = {
  name: "circle-alert",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
  ],
  aliases: ["alert-circle"]
}, wv = Se(cz);
const uz = {
  name: "circle-check",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m16 9-5.5 5.5L8 12", key: "xofnsj" }]
  ],
  aliases: ["check-circle-2"]
}, u6 = Se(uz);
const hz = {
  name: "circle-minus",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }]
  ],
  aliases: ["minus-circle"]
}, pz = Se(hz);
const fz = {
  name: "circle-play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
        key: "kmsa83"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["play-circle"]
}, mz = Se(fz);
const gz = {
  name: "circle-question-mark",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }]
  ],
  aliases: ["help-circle", "circle-help"]
}, kw = Se(gz);
const bz = {
  name: "circle-stop",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
  ],
  aliases: ["stop-circle"]
}, vz = Se(bz);
const yz = {
  name: "circle",
  size: 24,
  node: [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]]
}, xz = Se(yz);
const wz = {
  name: "circle-x",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }]
  ],
  aliases: ["x-circle"]
}, h6 = Se(wz);
const kz = {
  name: "clapperboard",
  size: 24,
  node: [
    ["path", { d: "m12.296 3.464 3.02 3.956", key: "qash78" }],
    [
      "path",
      {
        d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3z",
        key: "1h7j8b"
      }
    ],
    ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", key: "4lm6w1" }],
    ["path", { d: "m6.18 5.276 3.1 3.899", key: "zjj9t3" }]
  ]
}, _z = Se(kz);
const Sz = {
  name: "clipboard",
  size: 24,
  node: [
    ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196"
      }
    ]
  ]
}, Mz = Se(Sz);
const Tz = {
  name: "clock",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }]
  ]
}, Cz = Se(Tz);
const Iz = {
  name: "cloud-off",
  size: 24,
  node: [
    [
      "path",
      { d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057", key: "1uxyv8" }
    ],
    ["path", { d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78", key: "99tcn7" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }]
  ]
}, Az = Se(Iz);
const Pz = {
  name: "coffee",
  size: 24,
  node: [
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M14 2v2", key: "6buw04" }],
    [
      "path",
      {
        d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
        key: "pwadti"
      }
    ],
    ["path", { d: "M6 2v2", key: "colzsn" }]
  ]
}, Ez = Se(Pz);
const Rz = {
  name: "columns-2",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M12 3v18", key: "108xh3" }]
  ],
  aliases: ["columns"]
}, zz = Se(Rz);
const $z = {
  name: "columns-3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }]
  ],
  aliases: ["panels-left-right"]
}, Dz = Se($z);
const Oz = {
  name: "contrast",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
  ]
}, Lz = Se(Oz);
const Bz = {
  name: "copy",
  size: 24,
  node: [
    ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
    ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
  ]
}, p6 = Se(Bz);
const Fz = {
  name: "corner-down-left",
  size: 24,
  node: [
    ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }],
    ["path", { d: "m9 10-5 5 5 5", key: "1kshq7" }]
  ]
}, Nz = Se(Fz);
const Uz = {
  name: "corner-down-right",
  size: 24,
  node: [
    ["path", { d: "m15 10 5 5-5 5", key: "qqa56n" }],
    ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
  ]
}, Gz = Se(Uz);
const jz = {
  name: "cpu",
  size: 24,
  node: [
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M17 20v2", key: "1rnc9c" }],
    ["path", { d: "M17 2v2", key: "11trls" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M2 17h2", key: "7oei6x" }],
    ["path", { d: "M2 7h2", key: "asdhe0" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "M20 17h2", key: "1fpfkl" }],
    ["path", { d: "M20 7h2", key: "1o8tra" }],
    ["path", { d: "M7 20v2", key: "4gnj0m" }],
    ["path", { d: "M7 2v2", key: "1i4yhu" }],
    ["rect", { x: "4", y: "4", width: "16", height: "16", rx: "2", key: "1vbyd7" }],
    ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
  ]
}, Hz = Se(jz);
const Vz = {
  name: "crop",
  size: 24,
  node: [
    ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
    ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
  ]
}, Wz = Se(Vz);
const qz = {
  name: "dice-5",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
    ["path", { d: "M16 8h.01", key: "cr5u4v" }],
    ["path", { d: "M8 8h.01", key: "1e4136" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
    ["path", { d: "M16 16h.01", key: "1f9h7w" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }]
  ]
}, Kz = Se(qz);
const Yz = {
  name: "download",
  size: 24,
  node: [
    ["path", { d: "M12 15V3", key: "m9g1x1" }],
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
    ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
  ]
}, f6 = Se(Yz);
const Xz = {
  name: "droplet",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
        key: "c7niix"
      }
    ]
  ]
}, Jz = Se(Xz);
const Zz = {
  name: "ellipsis-vertical",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
    ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
  ],
  aliases: ["more-vertical"]
}, Qz = Se(Zz);
const e$ = {
  name: "ellipsis",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
    ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
  ],
  aliases: ["more-horizontal"]
}, m6 = Se(e$);
const t$ = {
  name: "eraser",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21",
        key: "g5wo59"
      }
    ],
    ["path", { d: "m5.082 11.09 8.828 8.828", key: "1wx5vj" }]
  ]
}, n$ = Se(t$);
const i$ = {
  name: "expand",
  size: 24,
  node: [
    ["path", { d: "m15 15 6 6", key: "1s409w" }],
    ["path", { d: "m15 9 6-6", key: "ko1vev" }],
    ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
    ["path", { d: "M21 8V3h-5", key: "1qoq8a" }],
    ["path", { d: "M3 16v5h5", key: "1t08am" }],
    ["path", { d: "m3 21 6-6", key: "wwnumi" }],
    ["path", { d: "M3 8V3h5", key: "1ln10m" }],
    ["path", { d: "M9 9 3 3", key: "v551iv" }]
  ]
}, s$ = Se(i$);
const o$ = {
  name: "external-link",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "M10 14 21 3", key: "gplh6r" }],
    ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
  ]
}, g6 = Se(o$);
const r$ = {
  name: "eye-off",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
        key: "ct8e1f"
      }
    ],
    ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
    [
      "path",
      {
        d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
        key: "13bj9a"
      }
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }]
  ]
}, a$ = Se(r$);
const l$ = {
  name: "eye",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
        key: "1nclc0"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, d$ = Se(l$);
const c$ = {
  name: "face-slightly-smiling-plus",
  size: 24,
  node: [
    ["path", { d: "M13.267 2.08a10 10 0 108.653 8.653", key: "1wbpyh" }],
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M16.472 15a6 6 0 01-8.943 0", key: "7qomzy" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
    ["path", { d: "M9 10V9", key: "1lazqi" }]
  ],
  aliases: ["smile-plus"]
}, u$ = Se(c$);
const h$ = {
  name: "face-slightly-smiling",
  size: 24,
  node: [
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    ["path", { d: "M16.472 15a6 6 0 01-8.943 0", key: "7qomzy" }],
    ["path", { d: "M9 10V9", key: "1lazqi" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["smile"]
}, p$ = Se(h$);
const f$ = {
  name: "file-box",
  size: 24,
  node: [
    ["path", { d: "M14 2v5a1 1 0 001 1h5", key: "9v5fu7" }],
    [
      "path",
      {
        d: "M14.692 22H18a2 2 0 002-2V8a2.4 2.4 0 00-.706-1.706l-3.588-3.588A2.4 2.4 0 0014 2H6a2 2 0 00-2 2v3.804",
        key: "1ne0j7"
      }
    ],
    ["path", { d: "M2.264 13.752 7 16.5l4.737-2.748", key: "t73mg3" }],
    [
      "path",
      {
        d: "M2.995 13.014A2 2 0 002 14.744v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0012 18.26v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z",
        key: "h4qck"
      }
    ],
    ["path", { d: "M7 16.5V22", key: "1i1gou" }]
  ]
}, m$ = Se(f$);
const g$ = {
  name: "film",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M7 3v18", key: "bbkbws" }],
    ["path", { d: "M3 7.5h4", key: "zfgn84" }],
    ["path", { d: "M3 12h18", key: "1i2n21" }],
    ["path", { d: "M3 16.5h4", key: "1230mu" }],
    ["path", { d: "M17 3v18", key: "in4fa5" }],
    ["path", { d: "M17 7.5h4", key: "myr1c1" }],
    ["path", { d: "M17 16.5h4", key: "go4c1d" }]
  ]
}, b$ = Se(g$);
const v$ = {
  name: "flag",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
        key: "1jaruq"
      }
    ]
  ]
}, y$ = Se(v$);
const x$ = {
  name: "focus",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
  ]
}, w$ = Se(x$);
const k$ = {
  name: "folder-open",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
        key: "usdka0"
      }
    ]
  ]
}, _$ = Se(k$);
const S$ = {
  name: "frame",
  size: 24,
  node: [
    ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
    ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
    ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
    ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
  ]
}, b6 = Se(S$);
const M$ = {
  name: "gauge",
  size: 24,
  node: [
    ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
    ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
  ]
}, T$ = Se(M$);
const C$ = {
  name: "globe",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }]
  ]
}, v6 = Se(C$);
const I$ = {
  name: "grid-3x3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }]
  ],
  aliases: ["grid", "grid-3-x-3"]
}, A$ = Se(I$);
const P$ = {
  name: "group",
  size: 24,
  node: [
    ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
    ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
    ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
    ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
    ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
    ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
  ]
}, E$ = Se(P$);
const R$ = {
  name: "hand",
  size: 24,
  node: [
    ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
    ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
    ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
    [
      "path",
      {
        d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        key: "1s1gnw"
      }
    ]
  ]
}, y6 = Se(R$);
const z$ = {
  name: "heart",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
        key: "mvr1a0"
      }
    ]
  ]
}, x6 = Se(z$);
const $$ = {
  name: "image-off",
  size: 24,
  node: [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
    ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
    ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
    [
      "path",
      {
        d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
        key: "mmje98"
      }
    ],
    ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
  ]
}, D$ = Se($$);
const O$ = {
  name: "image-plus",
  size: 24,
  node: [
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
    ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
  ]
}, w6 = Se(O$);
const L$ = {
  name: "image",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
  ]
}, k6 = Se(L$);
const B$ = {
  name: "images",
  size: 24,
  node: [
    ["path", { d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16", key: "9kzy35" }],
    ["path", { d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2", key: "1t0f0t" }],
    ["circle", { cx: "13", cy: "7", r: "1", fill: "currentColor", key: "1obus6" }],
    ["rect", { x: "8", y: "2", width: "14", height: "14", rx: "2", key: "1gvhby" }]
  ]
}, F$ = Se(B$);
const N$ = {
  name: "inbox",
  size: 24,
  node: [
    ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
    [
      "path",
      {
        d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
        key: "oot6mr"
      }
    ]
  ]
}, U$ = Se(N$);
const G$ = {
  name: "info",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 16v-4", key: "1dtifu" }],
    ["path", { d: "M12 8h.01", key: "e9boi3" }]
  ]
}, j$ = Se(G$);
const H$ = {
  name: "keyboard",
  size: 24,
  node: [
    ["path", { d: "M10 8h.01", key: "1r9ogq" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M14 8h.01", key: "1primd" }],
    ["path", { d: "M16 12h.01", key: "1l6xoz" }],
    ["path", { d: "M18 8h.01", key: "emo2bl" }],
    ["path", { d: "M6 8h.01", key: "x9i8wu" }],
    ["path", { d: "M7 16h10", key: "wp8him" }],
    ["path", { d: "M8 12h.01", key: "czm47f" }],
    ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
  ]
}, V$ = Se(H$);
const W$ = {
  name: "lamp",
  size: 24,
  node: [
    ["path", { d: "M12 12v6", key: "3ahymv" }],
    [
      "path",
      {
        d: "M4.077 10.615A1 1 0 0 0 5 12h14a1 1 0 0 0 .923-1.385l-3.077-7.384A2 2 0 0 0 15 2H9a2 2 0 0 0-1.846 1.23Z",
        key: "1l7kg2"
      }
    ],
    [
      "path",
      { d: "M8 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z", key: "1mmzpi" }
    ]
  ]
}, q$ = Se(W$);
const K$ = {
  name: "lasso-select",
  size: 24,
  node: [
    ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
    ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
    [
      "path",
      {
        d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
        key: "gt5e1w"
      }
    ],
    ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
    [
      "path",
      {
        d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
        key: "72q637"
      }
    ]
  ]
}, Y$ = Se(K$);
const X$ = {
  name: "layers",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
        key: "zw3jo"
      }
    ],
    [
      "path",
      {
        d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
        key: "1wduqc"
      }
    ],
    [
      "path",
      {
        d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
        key: "kqbvx6"
      }
    ]
  ],
  aliases: ["layers-3"]
}, J$ = Se(X$);
const Z$ = {
  name: "layout-dashboard",
  size: 24,
  node: [
    ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
    ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
    ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
    ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
  ]
}, Q$ = Se(Z$);
const e7 = {
  name: "layout-grid",
  size: 24,
  node: [
    ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
    ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
    ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
    ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
  ]
}, _6 = Se(e7);
const t7 = {
  name: "layout-template",
  size: 24,
  node: [
    ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
    ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
    ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
  ]
}, S6 = Se(t7);
const n7 = {
  name: "leaf",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11 20a10 10 0 0010-10 25.9 25.9 0 00-1.04-7.281 1 1 0 00-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0011 20",
        key: "1wjnjv"
      }
    ],
    ["path", { d: "M2 21a5 5 0 012.911-4.544C7.613 15.212 8.351 15.24 11 13", key: "c1ejpn" }]
  ]
}, i7 = Se(n7);
const s7 = {
  name: "library",
  size: 24,
  node: [
    ["path", { d: "m16 6 4 14", key: "ji33uf" }],
    ["path", { d: "M12 6v14", key: "1n7gus" }],
    ["path", { d: "M8 8v12", key: "1gg7y9" }],
    ["path", { d: "M4 4v16", key: "6qkkli" }]
  ]
}, o7 = Se(s7);
const r7 = {
  name: "lightbulb",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
        key: "1gvzjb"
      }
    ],
    ["path", { d: "M9 18h6", key: "x1upvd" }],
    ["path", { d: "M10 22h4", key: "ceow96" }]
  ]
}, a7 = Se(r7);
const l7 = {
  name: "link",
  size: 24,
  node: [
    ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
    ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
  ]
}, d7 = Se(l7);
const c7 = {
  name: "link-2",
  size: 24,
  node: [
    ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
    ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
  ]
}, u7 = Se(c7);
const h7 = {
  name: "loader-circle",
  size: 24,
  node: [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]],
  aliases: ["loader-2"]
}, M6 = Se(h7);
const p7 = {
  name: "locate-fixed",
  size: 24,
  node: [
    ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
    ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
    ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, f7 = Se(p7);
const m7 = {
  name: "lock-open",
  size: 24,
  node: [
    ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
    ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
  ],
  aliases: ["unlock"]
}, g7 = Se(m7);
const b7 = {
  name: "lock",
  size: 24,
  node: [
    ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
    ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
  ]
}, T6 = Se(b7);
const v7 = {
  name: "log-out",
  size: 24,
  node: [
    ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
    ["path", { d: "M21 12H9", key: "dn1m92" }],
    ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
  ]
}, y7 = Se(v7);
const x7 = {
  name: "map-pin",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        key: "1r0f0z"
      }
    ],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
  ]
}, w7 = Se(x7);
const k7 = {
  name: "map",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
        key: "169xi5"
      }
    ],
    ["path", { d: "M15 5.764v15", key: "1pn4in" }],
    ["path", { d: "M9 3.236v15", key: "1uimfh" }]
  ]
}, _7 = Se(k7);
const S7 = {
  name: "maximize-2",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "m21 3-7 7", key: "1l2asr" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
  ]
}, C6 = Se(S7);
const M7 = {
  name: "message-circle-plus",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        key: "1sd12s"
      }
    ],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "M12 8v8", key: "napkw2" }]
  ]
}, T7 = Se(M7);
const C7 = {
  name: "message-circle",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        key: "1sd12s"
      }
    ]
  ]
}, I7 = Se(C7);
const A7 = {
  name: "message-square-dot",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7",
        key: "wjb7ig"
      }
    ],
    ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }]
  ]
}, P7 = Se(A7);
const E7 = {
  name: "message-square-plus",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ],
    ["path", { d: "M12 8v6", key: "1ib9pf" }],
    ["path", { d: "M9 11h6", key: "1fldmi" }]
  ]
}, R7 = Se(E7);
const z7 = {
  name: "message-square-warning",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ],
    ["path", { d: "M12 15h.01", key: "q59x07" }],
    ["path", { d: "M12 7v4", key: "xawao1" }]
  ]
}, $7 = Se(z7);
const D7 = {
  name: "message-square",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ]
  ]
}, O7 = Se(D7);
const L7 = {
  name: "messages-square",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
        key: "1n2ejm"
      }
    ],
    [
      "path",
      {
        d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
        key: "1qfcsi"
      }
    ]
  ]
}, B7 = Se(L7);
const F7 = {
  name: "minimize-2",
  size: 24,
  node: [
    ["path", { d: "m14 10 7-7", key: "oa77jy" }],
    ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
  ]
}, N7 = Se(F7);
const U7 = {
  name: "minus",
  size: 24,
  node: [["path", { d: "M5 12h14", key: "1ays0h" }]]
}, I6 = Se(U7);
const G7 = {
  name: "moon",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
        key: "kfwtm"
      }
    ]
  ]
}, j7 = Se(G7);
const H7 = {
  name: "mountain",
  size: 24,
  node: [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]]
}, V7 = Se(H7);
const W7 = {
  name: "mouse-pointer-2",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
        key: "edeuup"
      }
    ]
  ]
}, A6 = Se(W7);
const q7 = {
  name: "mouse-pointer-click",
  size: 24,
  node: [
    ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
    ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
    ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
    ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
    [
      "path",
      {
        d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
        key: "s0h3yz"
      }
    ]
  ]
}, K7 = Se(q7);
const Y7 = {
  name: "move",
  size: 24,
  node: [
    ["path", { d: "M12 2v20", key: "t6zp3m" }],
    ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
    ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
    ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
  ]
}, X7 = Se(Y7);
const J7 = {
  name: "orbit",
  size: 24,
  node: [
    ["path", { d: "M20.341 6.484A10 10 0 0 1 10.266 21.85", key: "1enhxb" }],
    ["path", { d: "M3.659 17.516A10 10 0 0 1 13.74 2.152", key: "1crzgf" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
    ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }]
  ]
}, Z7 = Se(J7);
const Q7 = {
  name: "paint-bucket",
  size: 24,
  node: [
    ["path", { d: "M11 7 6 2", key: "1jwth8" }],
    ["path", { d: "M18.992 12H2.041", key: "xw1gg" }],
    [
      "path",
      {
        d: "M21.145 18.38A3.34 3.34 0 0 1 20 16.5a3.3 3.3 0 0 1-1.145 1.88c-.575.46-.855 1.02-.855 1.595A2 2 0 0 0 20 22a2 2 0 0 0 2-2.025c0-.58-.285-1.13-.855-1.595",
        key: "1nkol4"
      }
    ],
    [
      "path",
      {
        d: "m8.5 4.5 2.148-2.148a1.205 1.205 0 0 1 1.704 0l7.296 7.296a1.205 1.205 0 0 1 0 1.704l-7.592 7.592a3.615 3.615 0 0 1-5.112 0l-3.888-3.888a3.615 3.615 0 0 1 0-5.112L5.67 7.33",
        key: "1nk1rd"
      }
    ]
  ]
}, eD = Se(Q7);
const tD = {
  name: "paintbrush",
  size: 24,
  node: [
    ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
    [
      "path",
      {
        d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
        key: "18tc5c"
      }
    ],
    [
      "path",
      {
        d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
        key: "ytzfxy"
      }
    ]
  ]
}, nD = Se(tD);
const iD = {
  name: "palette",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
        key: "e79jfc"
      }
    ],
    ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
    ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
    ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
    ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
  ]
}, sD = Se(iD);
const oD = {
  name: "panel-left",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }]
  ],
  aliases: ["sidebar"]
}, rD = Se(oD);
const aD = {
  name: "panel-right-close",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
  ]
}, lD = Se(aD);
const dD = {
  name: "panel-right-open",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
  ]
}, cD = Se(dD);
const uD = {
  name: "pause",
  size: 24,
  node: [
    ["rect", { x: "14", y: "3", width: "5", height: "18", rx: "1", key: "kaeet6" }],
    ["rect", { x: "5", y: "3", width: "5", height: "18", rx: "1", key: "1wsw3u" }]
  ]
}, hD = Se(uD);
const pD = {
  name: "pencil",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        key: "1a8usu"
      }
    ],
    ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
  ]
}, P6 = Se(pD);
const fD = {
  name: "pin-off",
  size: 24,
  node: [
    ["path", { d: "M12 17v5", key: "bb1du9" }],
    ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      {
        d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
        key: "c9qhm2"
      }
    ]
  ]
}, mD = Se(fD);
const gD = {
  name: "pin",
  size: 24,
  node: [
    ["path", { d: "M12 17v5", key: "bb1du9" }],
    [
      "path",
      {
        d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
        key: "1nkz8b"
      }
    ]
  ]
}, bD = Se(gD);
const vD = {
  name: "pipette",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12",
        key: "1y3wsu"
      }
    ],
    [
      "path",
      {
        d: "m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z",
        key: "110lr1"
      }
    ],
    ["path", { d: "m2 22 .414-.414", key: "jhxm08" }]
  ]
}, E6 = Se(vD);
const yD = {
  name: "plane",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
        key: "1v9wt8"
      }
    ]
  ]
}, xD = Se(yD);
const wD = {
  name: "play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
        key: "10ikf1"
      }
    ]
  ]
}, R6 = Se(wD);
const kD = {
  name: "plus",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "M12 5v14", key: "s699le" }]
  ]
}, z6 = Se(kD);
const _D = {
  name: "proportions",
  size: 24,
  node: [
    ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
    ["path", { d: "M12 9v11", key: "1fnkrn" }],
    ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
  ]
}, SD = Se(_D);
const MD = {
  name: "rainbow",
  size: 24,
  node: [
    ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
    ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
    ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
  ]
}, TD = Se(MD);
const CD = {
  name: "rectangle-vertical",
  size: 24,
  node: [["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]]
}, $6 = Se(CD);
const ID = {
  name: "rectangle-horizontal",
  size: 24,
  node: [["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]]
}, AD = Se(ID);
const PD = {
  name: "redo-2",
  size: 24,
  node: [
    ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
    ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
  ]
}, ED = Se(PD);
const RD = {
  name: "refresh-cw",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
    ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
    ["path", { d: "M8 16H3v5", key: "1cv678" }]
  ]
}, zD = Se(RD);
const $D = {
  name: "repeat",
  size: 24,
  node: [
    ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
    ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
    ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
    ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
  ]
}, DD = Se($D);
const OD = {
  name: "replace",
  size: 24,
  node: [
    ["path", { d: "M14 4a1 1 0 0 1 1-1", key: "dhj8ez" }],
    ["path", { d: "M15 10a1 1 0 0 1-1-1", key: "1mnyi5" }],
    ["path", { d: "M21 4a1 1 0 0 0-1-1", key: "sfs9ap" }],
    ["path", { d: "M21 9a1 1 0 0 1-1 1", key: "mp6qeo" }],
    ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
    ["path", { d: "M6 10V5a2 2 0 0 1 2-2h2", key: "15xut4" }],
    ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }]
  ]
}, LD = Se(OD);
const BD = {
  name: "rotate-3d",
  size: 24,
  node: [
    ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
    ["path", { d: "M16.47214 7.52786 A 5 10 0 1 0 13 21.79796", key: "1245p8" }],
    ["path", { d: "M21.79796 11 A 10 5 0 1 0 19 15.57071", key: "1i40ks" }]
  ],
  aliases: ["rotate-3-d"]
}, FD = Se(BD);
const ND = {
  name: "rotate-ccw-clock",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
    ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
  ],
  aliases: ["history"]
}, UD = Se(ND);
const GD = {
  name: "rotate-ccw",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
  ]
}, jD = Se(GD);
const HD = {
  name: "rotate-cw",
  size: 24,
  node: [
    ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
  ]
}, VD = Se(HD);
const WD = {
  name: "route",
  size: 24,
  node: [
    ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
    ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
  ]
}, qD = Se(WD);
const KD = {
  name: "rows-3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M21 9H3", key: "1338ky" }],
    ["path", { d: "M21 15H3", key: "9uk58r" }]
  ],
  aliases: ["panels-top-bottom"]
}, YD = Se(KD);
const XD = {
  name: "scan-face",
  size: 24,
  node: [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "M15 9h.01", key: "x1ddxp" }]
  ]
}, JD = Se(XD);
const ZD = {
  name: "scan",
  size: 24,
  node: [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
  ]
}, QD = Se(ZD);
const eO = {
  name: "search",
  size: 24,
  node: [
    ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
  ]
}, D6 = Se(eO);
const tO = {
  name: "send",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
        key: "1ffxy3"
      }
    ],
    ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
  ]
}, nO = Se(tO);
const iO = {
  name: "send-to-back",
  size: 24,
  node: [
    ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
    ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
    ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
    ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
  ]
}, sO = Se(iO);
const oO = {
  name: "settings-2",
  size: 24,
  node: [
    ["path", { d: "M14 17H5", key: "gfn3mx" }],
    ["path", { d: "M19 7h-9", key: "6i9tg" }],
    ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
    ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
  ]
}, rO = Se(oO);
const aO = {
  name: "settings",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
        key: "1i5ecw"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, O6 = Se(aO);
const lO = {
  name: "share-2",
  size: 24,
  node: [
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
    ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
    ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
    ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
    ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
  ]
}, dO = Se(lO);
const cO = {
  name: "shield-check",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y"
      }
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
  ]
}, uO = Se(cO);
const hO = {
  name: "slash",
  size: 24,
  node: [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]
}, pO = Se(hO);
const fO = {
  name: "sliders-horizontal",
  size: 24,
  node: [
    ["path", { d: "M10 5H3", key: "1qgfaw" }],
    ["path", { d: "M12 19H3", key: "yhmn1j" }],
    ["path", { d: "M14 3v4", key: "1sua03" }],
    ["path", { d: "M16 17v4", key: "1q0r14" }],
    ["path", { d: "M21 12h-9", key: "1o4lsq" }],
    ["path", { d: "M21 19h-5", key: "1rlt1p" }],
    ["path", { d: "M21 5h-7", key: "1oszz2" }],
    ["path", { d: "M8 10v4", key: "tgpxqk" }],
    ["path", { d: "M8 12H3", key: "a7s4jb" }]
  ]
}, L6 = Se(fO);
const mO = {
  name: "sofa",
  size: 24,
  node: [
    ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
    [
      "path",
      {
        d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
        key: "xacw8m"
      }
    ],
    ["path", { d: "M4 18v2", key: "jwo5n2" }],
    ["path", { d: "M20 18v2", key: "1ar1qi" }],
    ["path", { d: "M12 4v9", key: "oqhhn3" }]
  ]
}, gO = Se(mO);
const bO = {
  name: "sparkle",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        key: "1s2grr"
      }
    ]
  ]
}, vO = Se(bO);
const yO = {
  name: "sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        key: "1s2grr"
      }
    ],
    ["path", { d: "M20 2v4", key: "1rf3ol" }],
    ["path", { d: "M22 4h-4", key: "gwowj6" }],
    ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
  ],
  aliases: ["stars"]
}, kv = Se(yO);
const xO = {
  name: "spotlight",
  size: 24,
  node: [
    ["path", { d: "M15.295 19.562 16 22", key: "31jsb7" }],
    ["path", { d: "m17 16 3.758 2.098", key: "121ar7" }],
    ["path", { d: "m19 12.5 3.026-.598", key: "19ukd3" }],
    [
      "path",
      {
        d: "M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341z",
        key: "lwb9l9"
      }
    ],
    ["path", { d: "M8 9V2", key: "1xa0v7" }]
  ]
}, wO = Se(xO);
const kO = {
  name: "square-check",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "m16 9-5.5 5.5L8 12", key: "xofnsj" }]
  ],
  aliases: ["check-square-2"]
}, _O = Se(kO);
const SO = {
  name: "square-dashed",
  size: 24,
  node: [
    ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
    ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
    ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
    ["path", { d: "M9 3h1", key: "1yesri" }],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 3h1", key: "1ec4yj" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
    ["path", { d: "M3 9v1", key: "1r0deq" }],
    ["path", { d: "M21 9v1", key: "mxsmne" }],
    ["path", { d: "M3 14v1", key: "vnatye" }],
    ["path", { d: "M21 14v1", key: "169vum" }]
  ],
  aliases: ["box-select"]
}, MO = Se(SO);
const TO = {
  name: "square",
  size: 24,
  node: [["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]]
}, B6 = Se(TO);
const CO = {
  name: "sticky-note",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
        key: "1dfntj"
      }
    ],
    ["path", { d: "M15 3v5a1 1 0 0 0 1 1h5", key: "6s6qgf" }]
  ]
}, F6 = Se(CO);
const IO = {
  name: "sun",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
    ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
    ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
  ]
}, AO = Se(IO);
const PO = {
  name: "swatch-book",
  size: 24,
  node: [
    ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
    ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
    ["path", { d: "M 7 17h.01", key: "1euzgo" }],
    [
      "path",
      {
        d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
        key: "o2gii7"
      }
    ]
  ]
}, EO = Se(PO);
const RO = {
  name: "table-2",
  size: 24,
  node: [
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
  ]
}, zO = Se(RO);
const $O = {
  name: "thermometer",
  size: 24,
  node: [["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]]
}, DO = Se($O);
const OO = {
  name: "trash",
  size: 24,
  node: [
    ["path", { d: "M10 11v6", key: "nco0om" }],
    ["path", { d: "M14 11v6", key: "outv1u" }],
    ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
  ],
  aliases: ["trash-2"]
}, N6 = Se(OO);
const LO = {
  name: "trees",
  size: 24,
  node: [
    [
      "path",
      { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }
    ],
    ["path", { d: "M7 16v6", key: "1a82de" }],
    ["path", { d: "M13 19v3", key: "13sx9i" }],
    [
      "path",
      {
        d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
        key: "1sj9kv"
      }
    ]
  ]
}, BO = Se(LO);
const FO = {
  name: "triangles-centerline-dashed-horizontal",
  size: 24,
  node: [
    ["path", { d: "M10 12H8", key: "s88cx1" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
    ["path", { d: "M4 12H2", key: "rhcxmi" }],
    [
      "path",
      {
        d: "M7.298 20.288A1 1 0 008 22h8a1 1 0 00.703-1.712l-3.991-3.99a1 1 0 00-1.424-.001z",
        key: "15ue1v"
      }
    ],
    [
      "path",
      {
        d: "M7.298 3.712A1 1 0 018 2h8a1 1 0 01.703 1.712l-3.991 3.99a1 1 0 01-1.424.001z",
        key: "lzh03e"
      }
    ]
  ],
  aliases: ["flip-horizontal-2"]
}, NO = Se(FO);
const UO = {
  name: "triangles-centerline-dashed-vertical",
  size: 24,
  node: [
    ["path", { d: "M12 14v2", key: "8jcxud" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 8v2", key: "1woqiv" }],
    [
      "path",
      {
        d: "M20.288 16.703A1 1 0 0022 16V8a1 1 0 00-1.712-.703l-3.99 3.991a1 1 0 00-.001 1.424z",
        key: "1ewq2t"
      }
    ],
    [
      "path",
      {
        d: "M3.712 16.703A1 1 0 012 16V8a1 1 0 011.712-.703l3.99 3.991a1 1 0 01.001 1.424z",
        key: "1c1klx"
      }
    ]
  ],
  aliases: ["flip-vertical-2"]
}, GO = Se(UO);
const jO = {
  name: "trophy",
  size: 24,
  node: [
    ["path", { d: "M10 14.66V17a1 1 0 0 1-1 1 2 2 0 0 0-2 2v2", key: "pwuv1l" }],
    ["path", { d: "M14 14.66V17a1 1 0 0 0 1 1 2 2 0 0 1 2 2v2", key: "1y54w1" }],
    ["path", { d: "M17.916 10H19.5A2.5 2.5 0 0 0 22 7.5V5a1 1 0 0 0-1-1h-3", key: "e30mpu" }],
    ["path", { d: "M4 22h16", key: "57wxv0" }],
    ["path", { d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z", key: "1mhfuq" }],
    ["path", { d: "M6.084 10H4.5A2.5 2.5 0 0 1 2 7.5V5a1 1 0 0 1 1-1h3", key: "i0yafy" }]
  ]
}, HO = Se(jO);
const VO = {
  name: "type",
  size: 24,
  node: [
    ["path", { d: "M12 4v16", key: "1654pz" }],
    ["path", { d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2", key: "e0r10z" }],
    ["path", { d: "M9 20h6", key: "s66wpe" }]
  ]
}, WO = Se(VO);
const qO = {
  name: "undo-2",
  size: 24,
  node: [
    ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
    ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
  ]
}, KO = Se(qO);
const YO = {
  name: "upload",
  size: 24,
  node: [
    ["path", { d: "M12 3v12", key: "1x0j5s" }],
    ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
  ]
}, XO = Se(YO);
const JO = {
  name: "user-check",
  size: 24,
  node: [
    ["path", { d: "m16 11 2 2 4-4", key: "9rsbq5" }],
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, ZO = Se(JO);
const QO = {
  name: "user-plus",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
    ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
  ]
}, U6 = Se(QO);
const eL = {
  name: "user-round-cog",
  size: 24,
  node: [
    ["path", { d: "m14.305 19.53.923-.382", key: "3m78fa" }],
    ["path", { d: "m15.228 16.852-.923-.383", key: "npixar" }],
    ["path", { d: "m16.852 15.228-.383-.923", key: "5xggr7" }],
    ["path", { d: "m16.852 20.772-.383.924", key: "dpfhf9" }],
    ["path", { d: "m19.148 15.228.383-.923", key: "1reyyz" }],
    ["path", { d: "m19.53 21.696-.382-.924", key: "1goivc" }],
    ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
    ["path", { d: "m20.772 16.852.924-.383", key: "htqkph" }],
    ["path", { d: "m20.772 19.148.924.383", key: "9w9pjp" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
  ],
  aliases: ["user-cog-2"]
}, tL = Se(eL);
const nL = {
  name: "user-round",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
    ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
  ],
  aliases: ["user-2"]
}, iL = Se(nL);
const sL = {
  name: "users",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
    ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, G6 = Se(sL);
const oL = {
  name: "video",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
        key: "ftymec"
      }
    ],
    ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
  ]
}, j6 = Se(oL);
const rL = {
  name: "wand-sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
        key: "ul74o6"
      }
    ],
    ["path", { d: "m14 7 3 3", key: "1r5n42" }],
    ["path", { d: "M5 6v4", key: "ilb8ba" }],
    ["path", { d: "M19 14v4", key: "blhpug" }],
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M7 8H3", key: "zfb6yr" }],
    ["path", { d: "M21 16h-4", key: "1cnmox" }],
    ["path", { d: "M11 3H9", key: "1obp7u" }]
  ],
  aliases: ["wand-2"]
}, H6 = Se(rL);
const aL = {
  name: "x",
  size: 24,
  node: [
    ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
    ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
  ]
}, V6 = Se(aL);
const lL = {
  name: "zoom-in",
  size: 24,
  node: [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
  ]
}, dL = Se(lL);
const cL = {
  name: "zoom-out",
  size: 24,
  node: [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
  ]
}, uL = Se(cL), hL = [
  "M7.61988 8.70002C9.40944 8.70002 10.8599 7.97426 10.8599 7.08002C10.8599 6.18578 9.40944 5.46002 7.61988 5.46002C5.83032 5.46002 4.37988 6.18578 4.37988 7.08002C4.37988 7.97426 5.83032 8.70002 7.61988 8.70002Z",
  "M4.37988 7.08002V9.24002C4.37988 10.1343 5.83032 10.86 7.61988 10.86C9.40944 10.86 10.8599 10.1343 10.8599 9.24002V7.08002",
  "M4.37989 4.38001C6.16945 4.38001 7.61989 3.65425 7.61989 2.76001C7.61989 1.86577 6.16945 1.14001 4.37989 1.14001C2.59033 1.14001 1.13989 1.86577 1.13989 2.76001C1.13989 3.65425 2.59033 4.38001 4.37989 4.38001Z",
  "M1.13989 2.76001V8.16001C1.13989 8.63953 1.55677 9.07045 2.21989 9.36745",
  "M1.13989 5.46002C1.13989 5.93954 1.55677 6.37046 2.21989 6.66746"
], W6 = (n) => Al(
  "svg",
  { width: n.size || 16, height: n.size || 16, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
  hL.map((e) => Al("path", { d: e, stroke: "currentColor", "stroke-width": 1.2, "stroke-linecap": "round", "stroke-linejoin": "round" }))
);
W6.props = ["size"];
const $ = /* @__PURE__ */ Pe({
  __name: "Icon",
  props: {
    name: {},
    size: { default: 16 },
    stroke: { default: 2 },
    spin: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = {
      MousePointer2: A6,
      Hand: y6,
      Image: k6,
      StickyNote: F6,
      Frame: b6,
      ChevronDown: l6,
      ChevronUp: iz,
      ChevronRight: c6,
      ChevronLeft: d6,
      X: V6,
      Square: B6,
      Circle: xz,
      Slash: pO,
      ArrowUpRight: o6,
      ArrowRight: s6,
      Check: a6,
      Search: D6,
      Plus: z6,
      Minus: I6,
      Scan: QD,
      Sun: AO,
      Moon: j7,
      Map: _7,
      PanelRightOpen: cD,
      PanelRightClose: lD,
      Trash2: N6,
      Play: R6,
      Heart: x6,
      Link2: u7,
      Info: j$,
      Wand2: H6,
      AlignStartVertical: hR,
      AlignCenterHorizontal: rR,
      AlignStartHorizontal: cR,
      AlignHorizontalDistributeCenter: lR,
      BringToFront: UR,
      SendToBack: sO,
      Settings: O6,
      Settings2: rO,
      ImagePlus: w6,
      Clock: Cz,
      Loader2: M6,
      Type: WO,
      Images: F$,
      MessageSquare: O7,
      Clipboard: Mz,
      Share2: dO,
      Download: f6,
      Maximize2: C6,
      ArrowDownToLine: gR,
      Repeat: DD,
      RotateCcw: jD,
      HelpCircle: kw,
      CircleHelp: kw,
      Video: j6,
      Box: FR,
      Layers: J$,
      Sparkles: kv,
      RectangleVertical: $6,
      RectangleHorizontal: AD,
      Building2: qR,
      Sofa: gO,
      Rows3: YD,
      LayoutGrid: _6,
      Copy: p6,
      Undo2: KO,
      Redo2: ED,
      Group: E$,
      AlertCircle: wv,
      CircleAlert: wv,
      Upload: XO,
      FolderOpen: _$,
      Ellipsis: m6,
      EllipsisVertical: Qz,
      Pencil: P6,
      ArrowLeft: xR,
      Gauge: T$,
      ImageOff: D$,
      Trees: BO,
      Eye: d$,
      Mountain: V7,
      Lightbulb: a7,
      Camera: YR,
      Palette: sD,
      LocateFixed: f7,
      Clapperboard: _z,
      Keyboard: V$,
      EyeOff: a$,
      Users: G6,
      Lock: T6,
      Globe: v6,
      UserPlus: U6,
      ExternalLink: g6,
      Library: o7,
      LogOut: y7,
      // the Studios view
      Brush: jR,
      MapPin: w7,
      Eraser: n$,
      BookmarkPlus: DR,
      CornerDownLeft: Nz,
      Rotate3d: FD,
      Cpu: Hz,
      SquareCheck: _O,
      Replace: LD,
      FileBox: m$,
      // the Library
      Grid3x3: A$,
      LayoutDashboard: Q$,
      SlidersHorizontal: L6,
      Columns3: Dz,
      // the prompt library (its sidebar opens from PanelLeft when the panel is narrow)
      LayoutTemplate: S6,
      ChevronsUp: dz,
      CloudOff: Az,
      Bookmark: LR,
      PanelLeft: rD,
      // pinned sessions
      Pin: bD,
      PinOff: mD,
      // the eyedropper
      Pipette: E6,
      // the board's history, on the side rail
      History: UD,
      // beta feedback
      MessageSquareWarning: $7,
      Bug: VR,
      Send: nO,
      // unlocking a frame
      LockOpen: g7,
      // the Edit side's tools (IL-073)
      Crop: Wz,
      Smile: p$,
      LassoSelect: Y$,
      MousePointerClick: K7,
      Expand: s$,
      FlipHorizontal2: NO,
      FlipVertical2: GO,
      RotateCw: VD,
      Contrast: Lz,
      Droplet: Jz,
      Paintbrush: nD,
      Aperture: fR,
      Film: b$,
      Blend: zR,
      SquareDashed: MO,
      Sparkle: vO,
      Move: X7,
      Thermometer: DO,
      Columns2: zz,
      Spotlight: wO,
      Orbit: Z7,
      ZoomIn: dL,
      ZoomOut: uL,
      Proportions: SD,
      ScanFace: JD,
      Dice5: Kz,
      Lamp: q$,
      SwatchBook: EO,
      Rainbow: TD,
      PaintBucket: eD,
      // comments (IL-092) and the emoji picker's categories
      SmilePlus: u$,
      AtSign: CR,
      Bell: ER,
      BellOff: AR,
      CircleCheck: u6,
      MessageCircle: I7,
      MessageCirclePlus: T7,
      MessagesSquare: B7,
      MessageSquareDot: P7,
      Leaf: i7,
      Coffee: Ez,
      Plane: xD,
      Trophy: HO,
      Flag: y$,
      ArrowUp: r6,
      CheckCheck: JR,
      Inbox: U$,
      // chat sessions in frames (Smart Frames)
      MessageSquarePlus: R7,
      Route: qD,
      CornerDownRight: Gz,
      CircleX: h6,
      CircleStop: vz,
      Focus: w$,
      // RunDiffusion's own mark for token costs
      Tokens: W6,
      ChevronsDownUp: oz,
      ChevronsUpDown: az
    }, t = n, i = I(() => e[t.name] || e.Sparkles);
    return (s, o) => (g(), b("span", {
      class: G(["licon", { "licon-spin": n.spin }]),
      "aria-hidden": "true"
    }, [
      (g(), Ie(da(i.value), {
        size: n.size,
        "stroke-width": n.stroke
      }, null, 8, ["size", "stroke-width"]))
    ], 2));
  }
}), q6 = /* @__PURE__ */ Symbol("board");
function pL(n) {
  y5(q6, n);
}
function Ze() {
  const n = tm(q6);
  if (!n) throw new Error("useBoard() outside a board");
  return n;
}
function as(n) {
  const { board: e } = Ze(), t = I(() => {
    const i = n();
    e.rev(i).value;
    const s = e.store.get(i);
    return s ? { ...s } : null;
  });
  return We(() => {
    e.store.get(n()) || e.releaseRev(n());
  }), t;
}
const fL = { class: "cv-atmo" }, mL = /* @__PURE__ */ Pe({
  __name: "Atmosphere",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(null);
    function i(o) {
      const r = t.value;
      if (!r) return;
      let l = 30 * (Number.isFinite(o.zoom) && o.zoom > 0 ? o.zoom : 1);
      for (let d = 0; d < 24 && l < 16; d++) l *= 2;
      for (let d = 0; d < 24 && l > 64; d++) l /= 2;
      r.style.backgroundSize = l + "px " + l + "px", r.style.backgroundPosition = o.x % l + "px " + (o.y + e.view.top) % l + "px";
    }
    let s = null;
    return it(() => {
      s = e.onCameraFrame(i), i(e.cam.value);
    }), We(() => {
      s && s();
    }), (o, r) => (g(), b("div", fL, [
      r[0] || (r[0] = u("div", { class: "cv-atmo-glow" }, null, -1)),
      r[1] || (r[1] = u("div", { class: "cv-atmo-orb-a" }, null, -1)),
      r[2] || (r[2] = u("div", { class: "cv-atmo-orb-b" }, null, -1)),
      u("div", {
        ref_key: "grid",
        ref: t,
        class: "cv-grid"
      }, null, 512)
    ]));
  }
}), gL = ["title", "aria-expanded"], bL = {
  key: 0,
  class: "n"
}, vL = {
  key: 0,
  class: "cv-board-menu cv-links-menu",
  role: "dialog",
  "aria-label": "Linked boards",
  "data-testid": "linked-boards"
}, yL = { class: "cv-links-head" }, xL = {
  key: 0,
  class: "n"
}, wL = {
  key: 0,
  class: "cv-links-empty"
}, kL = { class: "ic" }, _L = { class: "tx" }, SL = ["title"], ML = { class: "s" }, TL = ["aria-label", "onClick"], CL = ["data-testid", "onClick"], IL = /* @__PURE__ */ Pe({
  __name: "LinkedBoards",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(!1), i = /* @__PURE__ */ W(null), s = I(() => {
      e.docRev.value;
      const c = [], h = /* @__PURE__ */ new Set();
      for (const f of e.store.all()) {
        const p = f.type === "note" ? f.link : void 0;
        !p || h.has(p.boardId) || (h.add(p.boardId), c.push({ id: f.id, boardId: p.boardId, title: p.title, back: !!p.back, missing: e.missingBoards.value.has(p.boardId) }));
      }
      return c.sort((f, p) => f.title.localeCompare(p.title));
    });
    function o(c) {
      t.value = !1, e.openBoardLink(c);
    }
    function r(c) {
      t.value = !1;
      const h = e.store.get(c);
      h && (e.ui.selection = [c], e.jumpTo(h.x + h.w / 2, h.y + h.h / 2, Math.max(e.cam.value.zoom, 0.8)));
    }
    function a() {
      t.value = !1;
      const c = e.view;
      e.openBoardLinkMenu(c.left + c.w / 2 - 170, c.top + c.h / 2 - 160);
    }
    function l(c) {
      i.value && !i.value.contains(c.target) && (t.value = !1);
    }
    function d(c) {
      c.key === "Escape" && (c.stopPropagation(), t.value = !1);
    }
    return Ee(t, (c) => {
      c ? (window.addEventListener("pointerdown", l, !0), window.addEventListener("keydown", d, !0), e.refreshLinks()) : (window.removeEventListener("pointerdown", l, !0), window.removeEventListener("keydown", d, !0));
    }), We(() => {
      window.removeEventListener("pointerdown", l, !0), window.removeEventListener("keydown", d, !0);
    }), (c, h) => m(e).canLinkBoards ? (g(), b("div", {
      key: 0,
      ref_key: "wrap",
      ref: i,
      class: "cv-links-wrap"
    }, [
      u("button", {
        class: G(["cv-links-btn", { on: t.value, "has-links": s.value.length > 0 }]),
        title: s.value.length ? "Linked boards (" + s.value.length + ")" : "Linked boards",
        "aria-label": "Linked boards",
        "aria-haspopup": "dialog",
        "aria-expanded": t.value,
        "data-testid": "linked-boards-button",
        onClick: h[0] || (h[0] = (f) => t.value = !t.value)
      }, [
        C($, {
          name: "Link2",
          size: 14
        }),
        s.value.length ? (g(), b("span", bL, E(s.value.length), 1)) : z("", !0)
      ], 10, gL),
      t.value ? (g(), b("div", vL, [
        u("div", yL, [
          h[1] || (h[1] = Y("Linked boards ", -1)),
          s.value.length ? (g(), b("span", xL, E(s.value.length), 1)) : z("", !0)
        ]),
        s.value.length ? z("", !0) : (g(), b("div", wL, "No linked boards yet. Link the boards a project spans, and go between them in a click.")),
        (g(!0), b(j, null, ge(s.value, (f) => (g(), b("div", {
          key: f.boardId,
          class: G(["cv-links-row", { "is-missing": f.missing }])
        }, [
          u("span", kL, [
            C($, {
              name: "LayoutDashboard",
              size: 14
            })
          ]),
          u("span", _L, [
            u("span", {
              class: "t",
              title: f.title
            }, E(f.title), 9, SL),
            u("span", ML, E(f.missing ? "Not found, or you can't open it" : f.back ? "You came here from it" : "Linked from this board"), 1)
          ]),
          u("button", {
            class: "cv-topbar-btn",
            title: "Find its card on the board",
            "aria-label": "Find the card for " + f.title,
            "data-testid": "linked-boards-show",
            onClick: (p) => r(f.id)
          }, [
            C($, {
              name: "LocateFixed",
              size: 14
            })
          ], 8, TL),
          f.missing ? z("", !0) : (g(), b("button", {
            key: 0,
            class: "cv-links-open",
            "data-testid": "linked-boards-open-" + f.boardId,
            onClick: (p) => o(f.id)
          }, [
            h[2] || (h[2] = Y("Open ", -1)),
            C($, {
              name: "ArrowUpRight",
              size: 12
            })
          ], 8, CL))
        ], 2))), 128)),
        u("button", {
          class: "cv-board-menu-item cv-links-add",
          "data-testid": "linked-boards-add",
          onClick: a
        }, [
          C($, {
            name: "Plus",
            size: 15
          }),
          h[3] || (h[3] = u("span", { class: "cv-board-menu-text" }, [
            u("span", { class: "cv-board-menu-title" }, "Link a board"),
            u("span", { class: "cv-board-menu-desc" }, "An existing board, or a new one; it links back here")
          ], -1))
        ])
      ])) : z("", !0)
    ], 512)) : z("", !0);
  }
}), P1 = !1;
function E1(n) {
  const e = Math.max(0, Math.floor(n / 1e3));
  return Math.floor(e / 60) + ":" + String(e % 60).padStart(2, "0");
}
function AL(n) {
  const e = Math.max(1, Math.round(n / 1e3));
  if (e < 60) return e + " s";
  const t = Math.floor(e / 60);
  return t < 60 ? t + " min" + (e % 60 ? " " + e % 60 + " s" : "") : Math.floor(t / 60) + " h" + (t % 60 ? " " + t % 60 + " min" : "");
}
const Lu = /* @__PURE__ */ qe(Date.now());
let _w = 0, Sw = 0;
function dr() {
  return Wl() && (_w++ === 0 && (Sw = window.setInterval(() => {
    Lu.value = Date.now();
  }, 1e3)), Lu.value = Date.now(), We(() => {
    --_w === 0 && clearInterval(Sw);
  })), Lu;
}
function Jn(n, e = Date.now()) {
  const t = Math.max(0, Math.round((e - n) / 1e3));
  if (t < 45) return "just now";
  const i = Math.round(t / 60);
  if (i < 60) return i + "m ago";
  const s = Math.round(i / 60);
  if (s < 24) return s + "h ago";
  const o = Math.round(s / 24);
  return o < 7 ? o + "d ago" : new Date(n).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
function R1(n) {
  const e = new Date(n), t = e.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  let i = e.getHours();
  const s = i >= 12 ? "pm" : "am";
  return i = i % 12 || 12, t + " @ " + i + ":" + String(e.getMinutes()).padStart(2, "0") + " " + s;
}
const K6 = 24 * 3600 * 1e3;
function ef(n, e = Date.now()) {
  const t = new Date(n), i = t.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase(), s = new Date(e);
  if (s.setHours(0, 0, 0, 0), n >= s.getTime()) return "today, " + i;
  if (n >= s.getTime() - K6) return "yesterday, " + i;
  const o = t.getFullYear() === s.getFullYear() ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" };
  return t.toLocaleDateString("en-US", o) + ", " + i;
}
function PL(n, e = Date.now()) {
  const t = Math.max(1, Math.ceil((n - e) / K6));
  return t === 1 ? "1 day" : t + " days";
}
function _v(n) {
  return String(n || "").split(/\s+/).filter(Boolean).map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function ga(n) {
  const e = String(n || "").trim(), t = (e.includes("@") ? e.split("@")[0].replace(/[._+-]+/g, " ") : e).split(/\s+/).filter(Boolean);
  return t.length ? t.length === 1 ? t[0].slice(0, 2).toUpperCase() : (t[0][0] + t[t.length - 1][0]).toUpperCase() : "YOU";
}
const Mw = [
  ["1:1", 1],
  ["4:3", 4 / 3],
  ["3:2", 1.5],
  ["16:9", 16 / 9],
  ["3:4", 0.75],
  ["2:3", 2 / 3],
  ["9:16", 9 / 16]
];
function EL(n, e) {
  const t = n / Math.max(1, e);
  let i = Mw[0];
  for (const s of Mw) Math.abs(s[1] - t) < Math.abs(i[1] - t) && (i = s);
  return i[0];
}
const Tw = null, RL = "";
function zL(n, e) {
  return $L(e.type) ? OL(n, e) : e.type === "SINGLE_SELECT" ? BL(n, e) : e.type === "WIDTH_HEIGHT" ? FL(n, e) : { valid: !0 };
}
function $L(n) {
  return n === "SLIDER" || n === "UPSCALE_FACTOR_SLIDER" || n === "CFG" || n === "STEPS";
}
function DL(n) {
  if (typeof n == "number" && Number.isFinite(n)) return n;
  if (n && typeof n == "object" && "value" in n) {
    const e = n.value;
    if (typeof e == "number" && Number.isFinite(e)) return e;
  }
  return typeof n == "string" && !isNaN(Number(n)) ? Number(n) : null;
}
function OL(n, e) {
  const t = e.display || {}, i = DL(n);
  if (i === null)
    return { valid: !1, reason: "Invalid numeric value" };
  if (Array.isArray(t.options) && t.options.length > 0)
    return t.options.some(
      (c) => Number(c.value) === i || c.value === i
    ) ? { valid: !0 } : { valid: !1, reason: "Value is not one of the allowed options" };
  if (i < t.min)
    return { valid: !1, reason: `Value below minimum (${t.min})` };
  if (i > t.max)
    return { valid: !1, reason: `Value above maximum (${t.max})` };
  const s = typeof t.step == "number" ? t.step : 1, o = (i - t.min) / s, r = Math.round(o), a = t.min + r * s, l = s * 1e-4;
  return Math.abs(i - a) > l ? { valid: !1, reason: `Value doesn't align with step (${s})` } : { valid: !0 };
}
function LL(n) {
  return n ? n.text && Array.isArray(n.text.options) ? n.text.options : n.radio && Array.isArray(n.radio.options) ? n.radio.options : n.image && Array.isArray(n.image.options) ? n.image.options : [] : [];
}
function BL(n, e) {
  const t = LL(e.display);
  if (t.length === 0)
    return { valid: !1, reason: "No valid options available" };
  let i = n;
  return n && typeof n == "object" && "value" in n && (i = n.value), t.some((o) => o.value === i) ? { valid: !0 } : typeof i != "string" && typeof i != "number" ? { valid: !1, reason: "Invalid option format" } : t.some(
    (o) => (typeof o.value == "string" || typeof o.value == "number") && String(o.value) === String(i)
  ) ? { valid: !0 } : { valid: !1, reason: "Invalid option" };
}
function FL(n, e) {
  const t = e.display, i = t && t.select;
  if (!i) return { valid: !0 };
  const s = Array.isArray(i.options) ? i.options : [];
  if (s.length === 0)
    return { valid: !1, reason: "No valid resolution options available" };
  if (i.format === "wh") {
    if (n && typeof n == "object" && !Array.isArray(n) && typeof n.width == "number" && typeof n.height == "number") {
      const a = n.width, l = n.height;
      return s.some((c) => c.width === a && c.height === l) ? { valid: !0 } : { valid: !1, reason: "Invalid width/height combination" };
    }
    return { valid: !1, reason: "Invalid width/height format" };
  }
  let o = n;
  return n && typeof n == "object" && "value" in n && (o = n.value), typeof o != "string" && typeof o != "number" ? { valid: !1, reason: "Invalid resolution option format" } : s.some(
    (a) => a.value === o || String(a.value) === String(o)
  ) ? { valid: !0 } : { valid: !1, reason: "Invalid resolution option" };
}
function Js(n) {
  return n !== null && (typeof n == "object" || typeof n == "function");
}
function ln(n, e) {
  let t = n;
  for (const i of e.replace(/\[(\d+)\]/g, ".$1").split(".")) {
    if (t == null) return;
    t = t[i];
  }
  return t;
}
const Hd = (n, e) => n === !0 && !!e || Array.isArray(n) && n.some((t) => t === e), Cw = {
  "720p": { width: 1280, height: 720 },
  "1080p": { width: 1920, height: 1080 },
  "1440p": { width: 2560, height: 1440 },
  "2160p": { width: 3840, height: 2160 },
  "4k": { width: 3840, height: 2160 }
};
function z1(n) {
  return Js(n) && "value" in n ? n.value : n;
}
function _a(n) {
  if (!Js(n)) return null;
  const e = n.width, t = n.height;
  return !e || !t ? null : { width: e, height: t };
}
function Y6(n) {
  const e = z1(n);
  if (typeof e != "string" && typeof e != "number") return null;
  const t = String(e).trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(Cw, t) ? Cw[t] : null;
}
function ba(n) {
  if (!Js(n)) return null;
  const e = Js(n.image) ? n.image : {}, t = Js(n.video) ? n.video : {};
  return t.nodeRunResult ? _a(ln(t, "nodeRunResult.file")) : t.upload ? _a(t.upload) : e.nodeRunResult ? _a(ln(e, "nodeRunResult.file")) : n.nodeRunResult ? _a(ln(n, "nodeRunResult.file")) : e.upload ? _a(e.upload) : n.upload ? _a(n.upload) : null;
}
const X6 = (n, e) => n.width >= e.width || n.height >= e.height;
function NL(n, e) {
  let t = null, i = 1 / 0;
  for (const s of e) {
    const o = Y6(s);
    if (!o || X6(n, o)) continue;
    const r = o.width * o.height;
    r >= i || (i = r, t = String(z1(s)));
  }
  return t;
}
function UL(n, e, t, i, s) {
  if (!n.width || !n.height) return null;
  const o = Y6(e);
  if (!o || !X6(n, o)) return null;
  const r = i ? i + ": " : "";
  if (s) return r + s;
  const a = n.width + "x" + n.height, l = NL(n, t), d = l ? "Choose " + l + " or higher." : "No available option is larger than your " + a + " input.";
  return r + String(z1(e)) + " targets " + o.width + "x" + o.height + ", which is not larger than your " + a + " input. " + d;
}
function J6(n) {
  return n ? n.text && Array.isArray(n.text.options) ? n.text.options : n.radio && Array.isArray(n.radio.options) ? n.radio.options : n.image && Array.isArray(n.image.options) ? n.image.options : [] : [];
}
function vu(n, e) {
  const t = { allDisables: [], allShows: [], allRequires: [], triggeredDisables: [], triggeredShows: [], triggeredRequires: [] }, i = n.logic && n.logic.field || {};
  for (const s of Object.keys(i)) {
    const o = (e || {})[s] || null, { disable: r, show: a, autoSet: l, require: d, enforceTargetLargerThanInput: c } = i[s];
    if (r && t.allDisables.push(r), a && t.allShows.push(a), d && t.allRequires.push(d), r && Hd(r.onValue, o) && t.triggeredDisables.push(r), a && Hd(a.onValue, o) && t.triggeredShows.push(a), d && Hd(d.onValue, o) && t.triggeredRequires.push(d), c) {
      const y = ba(o);
      if (y) {
        const v = J6(n.display).map((w) => w ? w.value : void 0), x = UL(y, (e || {})[n.fieldDefUuid || ""], v, n.label, c.message);
        x && (t.targetLargerThanInputError = x);
      }
    }
    if (!l || l.onValue !== null && l.onValue !== void 0 && !Hd(l.onValue, o)) continue;
    t.autoSetAllowEdit = l.allowEdit || !1, t.autoSetVisible = l.visible || l.allowEdit || !1;
    const h = e[s];
    if (!h) continue;
    const f = l.dataFieldKey;
    let p = null;
    if (f ? (ln(h, "image.nodeRunResult") ? p = ln(h, "image.nodeRunResult.file." + f) : ln(h, "nodeRunResult") ? p = ln(h, "nodeRunResult.file." + f) : ln(h, "image.upload") ? p = ln(h, "image.upload." + f) : ln(h, "upload") && (p = ln(h, "upload." + f)), ln(h, "video.nodeRunResult") ? p = ln(h, "video.nodeRunResult.file." + f) : ln(h, "video.upload") && (p = ln(h, "video.upload." + f)), p == null && (p = ln(h, f))) : p = h, p != null)
      t.autoSetValue = l.setToValue !== void 0 ? l.setToValue : p;
    else {
      const y = ln(h, "image.nodeRunResult") || ln(h, "image.upload") || ln(h, "video.nodeRunResult") || ln(h, "video.upload") || ln(h, "upload") || ln(h, "nodeRunResult");
      f && y && (t.autoSetError = l.errorMessage || "Unable to extract " + f + " from input data");
    }
  }
  return t;
}
function $1(n, e, t = !1) {
  if (!n.logic) return !0;
  const i = vu(n, e), s = !i.allShows.length || i.triggeredShows.length > 0, o = s && i.triggeredDisables.length > 0;
  return !i.autoSetVisible && !i.autoSetAllowEdit && t ? !1 : s && !o;
}
function Z6(n, e) {
  return n.required ? !0 : n.logic ? vu(n, e).triggeredRequires.length > 0 : !1;
}
function yu(n) {
  const e = [];
  for (const t of n || [])
    t && (t.__rgroup ? e.push(...yu(t.fields)) : t.__rfield && e.push(t));
  return e;
}
function D1(n, e, t = !1) {
  const i = [];
  for (const s of n || [])
    !s || !$1(s, e, t) || (s.__rgroup ? i.push(...D1(s.fields, e, t)) : s.__rfield && i.push(s));
  return i;
}
function Q6(n, e) {
  const t = [];
  for (const i of n || [])
    !i || !i.__rgroup || !$1(i, e) || (i.required && !D1(i.fields, e).some((s) => {
      const o = e[s.fieldDefUuid || ""];
      return s.type === "PROMPT" ? (typeof o == "string" ? o : Js(o) && typeof o.value == "string" ? o.value : "").trim() !== "" : !!o;
    }) && t.push(i), t.push(...Q6(i.fields, e)));
  return t;
}
function Iw(n, e) {
  if (e === !0 && n) return !0;
  if (Array.isArray(e)) {
    if (e.includes(n)) return !0;
    if (Js(n))
      return e.some((t) => Js(t) && Object.keys(t).every((i) => n[i] === t[i]));
  }
  return !1;
}
function GL(n, e, t, i, s) {
  let o = n || 0;
  if (t && i)
    for (const r of t)
      for (const [a, l] of Object.entries(r.field)) {
        const d = i[a];
        if (s) {
          const p = yu(s).find((y) => y.fieldDefUuid === a);
          if (p && !$1(p, i)) continue;
        }
        let c = l.operand;
        if (l.operandIsFieldValue) {
          const p = Number(d);
          Number.isFinite(p) && (c = p);
        }
        let h = null;
        l.logicPerArrayItem && (Array.isArray(d) ? h = d : Js(d) && (Array.isArray(d.uploads) || Array.isArray(d.nodeRunResults)) && (h = [...d.uploads || [], ...d.nodeRunResults || []]));
        const f = h !== null ? h.filter((p) => Iw(p, l.onValue)).length : Iw(d, l.onValue) ? 1 : 0;
        for (let p = 0; p < f; p++)
          l.operator === "ADD" ? o += c : l.operator === "MULTIPLY" ? o *= c : l.operator === "SET" && (o = c);
      }
  return jL(o, e || 1);
}
function Aw(n) {
  const [e, t] = String(n).toLowerCase().split("e"), i = e[0] === "-", [s, o = ""] = (i ? e.slice(1) : e).split("."), r = BigInt(s + o);
  return { digits: i ? -r : r, scale: o.length - (t ? Number(t) : 0) };
}
function jL(n, e) {
  if (!Number.isFinite(n) || !Number.isFinite(e)) return Math.floor(n * e);
  const t = Aw(n), i = Aw(e), s = t.digits * i.digits, o = t.scale + i.scale, r = BigInt(10);
  if (o <= 0) return Number(s * r ** BigInt(-o));
  const a = r ** BigInt(o);
  let l = s / a;
  return s < BigInt(0) && l * a !== s && (l -= BigInt(1)), Number(l);
}
const O1 = "__boardUrls", e8 = 0.8;
function tf(n) {
  return "strength:" + n;
}
function HL(n) {
  return n.raw && n.raw.display || {};
}
function VL(n) {
  const e = HL(n);
  return n.kind === "video" ? !!e.hasStrength : !!(e.hasStrength || e.hasInpainting);
}
function t8(n) {
  return n.fields.filter((e) => e.placement === "reference");
}
function n8(n, e, t) {
  const i = t.inputs ? t.inputs[e.key] : void 0;
  if (e.kind === "images" && Array.isArray(i)) {
    const o = i.filter((r) => typeof r == "string" && !!r);
    if (o.length) return o;
  }
  const s = t8(n)[0] === e ? t.ref : i;
  return typeof s == "string" && s ? s : null;
}
function Pw(n) {
  return { boardUrl: n };
}
function Eo(n, e, t = "run") {
  const i = {}, s = [], o = {}, r = e.assets || {}, a = t === "rules";
  for (const d of n.fields) {
    if (d.kind === "header") continue;
    if (d.placement === "reference") {
      const h = n8(n, d, e);
      if (!h || Array.isArray(h) && !h.length) continue;
      if (d.kind === "images") {
        const y = [].concat(h), v = [], x = [], w = [];
        for (const S of y) {
          const M = r[S];
          M ? "upload" in M ? v.push(M.upload) : x.push(M.nodeRunResult) : a ? v.push(Pw(S)) : w.push(S);
        }
        (v.length || x.length) && (i[d.key] = { uploads: v, nodeRunResults: x }), w.length && (s.push(...w), o[d.key] = w);
        continue;
      }
      const f = Array.isArray(h) ? h[0] : h, p = r[f] || (a ? Pw(f) : null);
      if (!p) {
        s.push(f), o[d.key] = f;
        continue;
      }
      if (VL(d)) {
        const y = e.inputs && e.inputs[tf(d.key)], v = typeof y == "number" ? y : e8, x = e.masks && e.masks[d.key];
        i[d.key] = d.kind === "video" ? { video: p, strength: v } : { image: p, inpainting: x ? { mask: x } : null, strength: v };
      } else
        i[d.key] = p;
      continue;
    }
    const c = d.placement === "prompt" ? e.prompt : e.inputs && e.inputs[d.key] !== void 0 ? e.inputs[d.key] : d.defaultValue;
    c == null || c === "" || (i[d.key] = d.kind === "prompt" ? { value: c } : c);
  }
  const l = n.raw && n.raw.fields;
  if (l) {
    const d = new Set(n.fields.map((c) => c.key));
    for (const c of yu(l)) {
      const h = c.fieldDefUuid;
      !h || d.has(h) || h in i || c.defaultValue !== void 0 && c.defaultValue !== null && (i[h] = c.defaultValue);
    }
  }
  return t === "draft" && Object.keys(o).length && (i[O1] = o), { inputs: i, pending: s };
}
function WL(n) {
  return typeof n == "string" ? n : n && typeof n == "object" && "value" in n ? String(n.value || "") : "";
}
function Sv(n) {
  if (!n || typeof n != "object") return null;
  const e = n;
  return e.upload && typeof e.upload == "object" ? { upload: e.upload } : e.nodeRunResult && typeof e.nodeRunResult == "object" ? { nodeRunResult: e.nodeRunResult } : e.image ? Sv(e.image) : e.video ? Sv(e.video) : null;
}
function dc(n, e, t) {
  const i = { prompt: "", ref: null, inputs: {}, assets: {} }, s = i.inputs, o = i.assets, r = e[O1] || {}, a = t8(n), l = (d, c) => {
    const h = [].concat(c);
    h.length > 1 && (s[d.key] = h), a[0] === d ? i.ref = h[0] : h.length === 1 && (s[d.key] = h[0]);
  };
  for (const d of n.fields) {
    if (d.kind === "header") continue;
    const c = e[d.key];
    if (d.placement === "prompt") {
      i.prompt = WL(c);
      continue;
    }
    if (d.placement === "reference") {
      if (d.kind === "images") {
        const f = [], p = c || {};
        for (const v of p.uploads || []) {
          const x = { upload: v }, w = t(x);
          o[w] = x, f.push(w);
        }
        for (const v of p.nodeRunResults || []) {
          const x = { nodeRunResult: v }, w = t(x);
          o[w] = x, f.push(w);
        }
        const y = r[d.key];
        y && f.push(...[].concat(y)), f.length && l(d, f);
        continue;
      }
      const h = Sv(c);
      if (h) {
        const f = t(h);
        o[f] = h, l(d, f);
        const p = c && typeof c == "object" ? c.strength : void 0;
        typeof p == "number" && (s[tf(d.key)] = p);
      } else typeof r[d.key] == "string" && l(d, r[d.key]);
      continue;
    }
    c !== void 0 && (s[d.key] = c);
  }
  return i;
}
function qL(n, e) {
  const t = (i) => JSON.stringify({
    prompt: i && i.prompt || "",
    ref: i && i.ref || null,
    n: i && i.n || null,
    inputs: KL(i && i.inputs || {})
  });
  return t(n) === t(e);
}
function KL(n) {
  const e = {};
  for (const t of Object.keys(n).sort()) n[t] !== void 0 && n[t] !== null && n[t] !== "" && (e[t] = n[t]);
  return e;
}
const YL = { shown: !0, locked: !1, why: "", required: !1, problem: "" };
function Ka(n) {
  return /[.!?]$/.test(n) ? n : n + ".";
}
function Gr(n, e) {
  return n.fields.get(e) || YL;
}
function Ki(n) {
  return !!n && typeof n == "object";
}
function XL(n, e) {
  const t = n.display || {};
  if (n.type === "SINGLE_SELECT") {
    const i = J6(t).find((s) => !!s && s.value === e);
    return i ? i.value : void 0;
  }
  if (n.type === "WIDTH_HEIGHT" && t.select) {
    const i = t.select.options || [], s = typeof e == "string" ? i.find((o) => !!o && o.value === e) : Ki(e) && e.width && e.height ? i.find((o) => !!o && o.width === e.width && o.height === e.height) : void 0;
    return s ? t.select.format === "value" ? s.value : { width: s.width, height: s.height } : void 0;
  }
  if (n.type === "SLIDER") {
    const i = Number(e);
    if (!Number.isFinite(i)) return;
    const s = t.min == null ? 1 : t.min, o = t.max || 30, r = t.step || 1;
    return s + Math.round((Math.min(o, Math.max(s, i)) - s) / r) * r;
  }
  return e;
}
function Mv(n, e, t) {
  const i = n.raw && n.raw.fields;
  if (!i) return { values: e, errors: [] };
  const s = yu(i).filter((a) => !!a.logic && !!a.fieldDefUuid);
  if (!s.length) return { values: e, errors: [] };
  let o = e;
  const r = [];
  for (let a = 0; a < 4; a++) {
    let l = !1;
    for (const d of s) {
      const c = d.fieldDefUuid, h = vu(d, o);
      if (h.autoSetError && !r.includes(h.autoSetError) && r.push(h.autoSetError), h.autoSetValue === null || h.autoSetValue === void 0 || h.autoSetAllowEdit && t && t.inputs && t.inputs[c] !== void 0) continue;
      const f = XL(d, h.autoSetValue);
      if (f === void 0) {
        const p = h.autoSetError || (d.label || "A setting") + " couldn't be set to match your other settings.";
        r.includes(p) || r.push(p);
        continue;
      }
      JSON.stringify(o[c]) !== JSON.stringify(f) && (o = { ...o, [c]: f }, l = !0);
    }
    if (!l) break;
  }
  return { values: o, errors: r };
}
const Ew = [
  ["3:1", 3],
  ["2.5:1", 2.5],
  ["21:9", 2.3],
  ["16:9", 1.8],
  ["3:2", 1.5],
  ["4:3", 1.33],
  ["5:4", 1.25],
  ["1:1", 1],
  ["3:4", 0.75],
  ["2:3", 0.67],
  ["9:16", 0.6],
  ["9:21", 0.4],
  ["1:3", 0.33]
];
function JL(n) {
  const e = ba(n);
  if (!e) return null;
  const t = Math.round(e.width / e.height * 10) / 10;
  let i = Ew[0];
  for (const s of Ew) Math.abs(s[1] - t) < Math.abs(i[1] - t) && (i = s);
  return i[0];
}
function ZL(n, e, t, i) {
  const s = n.logic && n.logic.field || {}, o = e.triggeredDisables[0];
  if (!o) {
    let l = "";
    for (const d of Object.keys(s)) {
      const c = s[d].autoSet;
      c && (c.onValue === null || c.onValue === void 0 || Hd(c.onValue, t[d] || null)) && (l = i.get(d) || "");
    }
    return l ? "Set to match your " + l.toLowerCase() : "Set for you by your other settings";
  }
  const r = Object.keys(s).find((l) => s[l].disable === o) || "";
  if (n.type === "WIDTH_HEIGHT" && o.imageAspectRatioOverride && r) {
    const l = JL(t[r]);
    if (l) return "Aspect Ratio will match input image (" + l + ")";
  }
  if (o.message) return o.message;
  const a = i.get(r);
  return a ? "Turned off by your " + a.toLowerCase() : "Another setting turned this off";
}
function i8(n, e, t) {
  const { values: i, isAdmin: s, labels: o, out: r } = e;
  for (const a of n) {
    if (!a) continue;
    const l = a.logic ? vu(a, i) : null, d = a.logic && a.logic.field || {}, c = !!l && l.autoSetVisible === !1 && Object.keys(d).some((y) => !!d[y].autoSet), h = t.shown && (!l || !l.allShows.length || l.triggeredShows.length > 0) && (!a.adminOnly || s) && !c, f = h && !!l && (l.triggeredDisables.length > 0 || l.autoSetValue !== void 0 && !!l.autoSetVisible && !l.autoSetAllowEdit), p = {
      shown: h,
      locked: t.locked || f,
      why: f && l ? ZL(a, l, i, o) : t.why
    };
    a.__rgroup ? i8(a.fields || [], e, p) : a.__rfield && a.fieldDefUuid && r.set(a.fieldDefUuid, {
      ...p,
      required: Z6(a, i),
      problem: h && !p.locked && l && l.targetLargerThanInputError ? l.targetLargerThanInputError : ""
    });
  }
}
const QL = 2e3;
function Rw(n) {
  return Ki(n) ? Ki(n.nodeRunResult) && Ki(n.nodeRunResult.file) ? n.nodeRunResult.file : Ki(n.upload) ? n.upload : null : null;
}
function zw(n, e, t) {
  if (!e || !e.width || !e.height) return "";
  const i = t || 3, s = e.width / e.height;
  return s > i ? n + " aspect ratio (" + s.toFixed(2) + ":1) is too wide. Maximum allowed is " + i + ":1" : s < 1 / i ? n + " aspect ratio (1:" + (1 / s).toFixed(2) + ") is too tall. Maximum allowed is 1:" + i : "";
}
function $w(n, e, t) {
  return !e || !t ? "" : e.width !== void 0 && e.width < t ? n + " width (" + e.width + "px) is too small. Minimum required is " + t + "px" : e.height !== void 0 && e.height < t ? n + " height (" + e.height + "px) is too small. Minimum required is " + t + "px" : "";
}
function Dw(n) {
  return typeof n == "string" ? n : Ki(n) && typeof n.value == "string" ? n.value : "";
}
const eB = /* @__PURE__ */ new Set(["IMG", "IMGS", "VIDEO", "ASSET_3D"]);
function s8(n, e, t) {
  if (t) return "Write a prompt first";
  if (n === "MODEL_SINGLE_SELECT") return "Choose a trained model first";
  const i = (e || "a setting").toLowerCase();
  return (n && eB.has(n) ? "Add " : "Set ") + i + " first";
}
function tB(n, e) {
  const t = [], i = e[n.fieldDefUuid || ""], s = n.display || {}, o = n.label || n.fieldDefUuid || "A field";
  if (Z6(n, e) && (!i || n.type === "PROMPT" && !Dw(i).trim())) {
    const a = n.type === "PROMPT" || (n.type === "TEXT" || n.type === "TEXT_AREA") && s.primaryForm === "PROMPT";
    t.push(s8(n.type, n.label, a));
  }
  if (n.type === "IMG") {
    const a = Rw(i), l = zw("Image", a, s.maxAspectRatio);
    l && t.push(l);
    const d = $w("Image", a, s.minDimension);
    d && t.push(d), s.hasInpainting && s.inpaintingRequired && !(Ki(i) && Ki(i.inpainting) && i.inpainting.mask) && t.push("Mask is required");
  }
  if (n.type === "IMGS" && s.maxImages && Ki(i) && (Array.isArray(i.uploads) ? i.uploads.length : 0) + (Array.isArray(i.nodeRunResults) ? i.nodeRunResults.length : 0) > s.maxImages && t.push("Maximum of " + s.maxImages + " images allowed"), n.type === "VIDEO") {
    const a = Rw(Ki(i) && i.video ? i.video : i), l = zw("Video", a, s.maxAspectRatio);
    l && t.push(l);
    const d = $w("Video", a, s.minDimension);
    d && t.push(d), a && a.width && s.maxWidth && a.width > s.maxWidth && t.push("Video width (" + a.width + "px) exceeds maximum allowed width of " + s.maxWidth + "px"), a && a.height && s.maxHeight && a.height > s.maxHeight && t.push("Video height (" + a.height + "px) exceeds maximum allowed height of " + s.maxHeight + "px"), a && a.duration && s.maxDuration && a.duration > s.maxDuration && t.push("Video duration (" + a.duration + "s) exceeds maximum allowed duration of " + s.maxDuration + "s");
  }
  if (n.type === "PROMPT") {
    const a = s.maxLength || QL;
    Dw(i).length > a && t.push("Maximum of " + a + " characters allowed");
  }
  if (n.type === "UPSCALE_FACTOR_SLIDER") {
    const a = typeof i == "number" ? i : Ki(i) && typeof i.value == "number" ? i.value : null, l = s.dataFieldDefUuid ? ba(e[s.dataFieldDefUuid]) : null;
    if (a !== null && l) {
      const d = Math.round(l.width * a), c = Math.round(l.height * a), h = s.maxWidth || 3840, f = s.maxHeight || 2160;
      d > h ? t.push("Final width (" + d + "px) exceeds maximum allowed width of " + h + "px") : c > f && t.push("Final height (" + c + "px) exceeds maximum allowed height of " + f + "px");
    }
  }
  if (n.type === "SINGLE_SELECT") {
    const a = vu(n, e).targetLargerThanInputError;
    a && t.push(a);
  }
  if ((n.type === "UPSCALE_FACTOR_SLIDER" || !!i && (n.type === "WIDTH_HEIGHT" || n.type === "SINGLE_SELECT" || n.type === "SLIDER" || n.type === "CFG" || n.type === "STEPS")) && n.type) {
    const a = zL(i, { type: n.type, display: n.display, label: n.label, fieldDefUuid: n.fieldDefUuid });
    a.valid || t.push((a.reason || "Invalid value") + " for " + o);
  }
  return t;
}
function Xi(n, e, t, i = !1) {
  const { values: s, errors: o } = Mv(n, Eo(n, e, "rules").inputs, e), r = n.raw, a = r && r.fields, l = /* @__PURE__ */ new Map(), d = [];
  if (a) {
    const h = /* @__PURE__ */ new Map();
    for (const f of yu(a)) f.fieldDefUuid && f.label && h.set(f.fieldDefUuid, f.label);
    i8(a, { values: s, isAdmin: i, labels: h, out: l }, { shown: !0, locked: !1, why: "" });
    for (const f of D1(a, s)) d.push(...tB(f, s));
    for (const f of Q6(a, s)) d.push("Select at least one: " + (f.label || "option"));
  } else
    for (const h of n.fields) {
      if (!h.required) continue;
      const f = h.placement === "prompt";
      (f ? !(e.prompt || "").trim() : !s[h.key]) && d.push(s8(h.placement === "reference" ? "IMG" : void 0, h.label, f));
    }
  let c = null;
  return r && (!r.pricingType || r.pricingType === "COST") && r.costPerResult > 0 ? c = GL(r.costPerResult, t, r.costPerResultLogics, s, a) : !r && n.tokensPerResult != null && (c = Math.round(n.tokensPerResult * t * 100)), { fields: l, values: s, problems: d, price: c, autoErrors: o };
}
function xn(n) {
  if (n && typeof n == "object") {
    const e = n;
    return e.width != null && e.height != null ? e.width + "x" + e.height : JSON.stringify(n);
  }
  return String(n);
}
function Qi(n, e) {
  return xn(n) === xn(e);
}
function nf(n) {
  if (!n || typeof n != "object") return !1;
  const e = n;
  return e.width != null && e.height != null;
}
function cc(n, e) {
  const t = typeof e == "number" ? e : typeof e == "string" && e.trim() !== "" ? Number(e) : NaN;
  if (!Number.isFinite(t)) return null;
  const i = n.min == null ? 1 : n.min, s = n.max == null ? 30 : n.max, o = n.step && n.step > 0 ? n.step : 1;
  let r = i + Math.round((Math.min(s, Math.max(i, t)) - i) / o) * o;
  r > s + 1e-9 && (r -= o);
  const a = (String(o).split(".")[1] || "").length;
  return Number(r.toFixed(a));
}
function Lc(n, e) {
  if (n.placement === "prompt") return e.prompt != null ? e.prompt : n.defaultValue;
  const t = e.inputs ? e.inputs[n.key] : void 0;
  return t !== void 0 ? t : n.defaultValue;
}
function nB(n) {
  const e = n.value;
  if (e && typeof e == "object" && Number(e.width) > 0 && Number(e.height) > 0) return { width: Number(e.width), height: Number(e.height) };
  const t = /(\d+)\s*×\s*(\d+)/.exec(n.meta || "");
  return t ? { width: Number(t[1]), height: Number(t[2]) } : null;
}
function o8(n, e, t, i = () => null) {
  const s = e.raw && e.raw.display || {}, o = s.dataFieldDefUuid || s.imageFieldDefUuid, r = o ? n.fields.find((v) => v.key === o && v.placement === "reference") : null;
  if (e.kind !== "size" || !e.options || !r) return null;
  const a = n8(n, r, t), l = Array.isArray(a) ? a[0] : a, d = l ? t.assets && ba(t.assets[l]) || i(l) : null;
  if (!d) return null;
  const c = d.width / d.height, h = e.options.flatMap((v) => {
    const x = nB(v);
    return x ? [{ o: v, gap: Math.abs(x.width / x.height - c), px: Math.abs(x.width - d.width) + Math.abs(x.height - d.height) }] : [];
  }), f = Math.min(...h.map((v) => v.gap));
  let p = null, y = 1 / 0;
  for (const v of h)
    Math.abs(v.gap - f) < 1e-4 && v.px < y && (p = v.o, y = v.px);
  return p;
}
function r8(n, e) {
  var t;
  if (!n) return "";
  let i = "";
  const s = n.fields.find((d) => d.kind === "size"), o = s ? e(s) : void 0;
  if (o && nf(o)) {
    const d = o;
    i = d.width + " × " + d.height;
  } else if (s && s.options) {
    const d = s.options.find((h) => Qi(h.value, o)), c = d && d.meta ? /(\d{3,5})\s*[x×]\s*(\d{3,5})/.exec(d.meta) : null;
    c && (i = c[1] + " × " + c[2]);
  }
  if (!i) {
    const d = n.fields.find((f) => /resolution/i.test(f.key + " " + f.label)), c = d ? /(\d{3,4})\s*p/i.exec(String(e(d) || "")) : null, h = o && typeof o != "object" ? /(\d+(?:\.\d+)?)\s*:\s*(\d+(?:\.\d+)?)/.exec(String(o)) : null;
    if (c && h) {
      const f = Number(c[1]), p = Number(h[1]) / Number(h[2]), y = p >= 1 ? Math.round(f * p / 16) * 16 : f, v = p >= 1 ? f : Math.round(f / p / 16) * 16;
      i = y + " × " + v;
    }
  }
  const r = n.fields.find((d) => d.kind !== "size" && /dur|length|seconds/i.test(d.key + " " + d.label)), a = r ? /(\d+(?:\.\d+)?)/.exec(String((t = e(r)) != null ? t : "")) : null, l = a ? Number(a[1]) + " s" : "";
  return !i && !l ? "" : "Comes out at about " + [i, l].filter(Boolean).join(", ");
}
function Zs(n) {
  return n.kind === "images" ? Math.max(1, n.maxImages || 4) : 1;
}
function El(n) {
  const e = n / 100;
  return e >= 100 ? String(Math.round(e)) : String(Math.round(e * 10) / 10);
}
function a8(n, e, t) {
  if (!n) return "";
  if (n.raw && t) {
    const i = Xi(n, t, e).price;
    if (i != null) return El(i);
  }
  return n.tokensPerResult != null ? String(Math.round(n.tokensPerResult * e * 100) / 100) : n.tokensLabel || "";
}
const iB = { class: "cv-topbar-left" }, sB = ["value"], oB = { class: "cv-topbar-right" }, rB = ["title"], aB = ["title"], lB = {
  key: 0,
  class: "cv-feedback-dot",
  "data-testid": "feedback-draft-dot"
}, dB = { class: "cv-board-menu-wrap" }, cB = ["aria-expanded"], uB = {
  key: 0,
  class: "cv-topbar-dot",
  "data-testid": "board-menu-dot"
}, hB = {
  key: 0,
  class: "cv-board-menu",
  role: "menu",
  "data-testid": "board-menu"
}, pB = {
  key: 0,
  class: "cv-board-menu-count",
  "data-testid": "trash-count"
}, fB = /* @__PURE__ */ Pe({
  __name: "TopBar",
  props: {
    onHome: { type: Function },
    onIndex: { type: Function }
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = /* @__PURE__ */ W(!1), s = /* @__PURE__ */ W(null), o = I(() => {
      const S = t.balance.value;
      if (!S) return null;
      const M = S.tokens / 100, _ = Math.abs(M) >= 1e3 ? Math.floor(M).toLocaleString("en-US") : El(S.tokens);
      return t.teamName.value, { text: _, title: t.tokensTitle(), empty: S.tokens <= 0 };
    }), r = I(() => t.canGetTokens || !!t.meta.teamId && !t.canBuyTokens), a = I(() => t.trash.value.length);
    function l(S) {
      t.ui.boardMenu = !1, t.ui[S] = !0;
    }
    const d = t.feedback, c = I(() => !!d && d.state.mode === "closed" && d.hasDraft);
    function h(S) {
      t.ui.boardMenu = !1, d && d.start(S);
    }
    function f() {
      t.ui.boardMenu = !1, t.openTour();
    }
    function p() {
      t.ui.boardMenu = !1;
      const S = t.promptTool.value;
      t.promptLibrary.open(S ? S.id : null);
    }
    function y(S) {
      t.ui.boardMenu && !S.target.closest(".cv-board-menu-wrap") && (t.ui.boardMenu = !1);
    }
    it(() => window.addEventListener("pointerdown", y, !0)), We(() => window.removeEventListener("pointerdown", y, !0));
    const v = I(() => {
      const S = t.saveState.value;
      return S === "saving" ? { cls: "is-saving", text: "Saving…" } : S === "error" ? { cls: "is-error", text: "Not saved: retrying" } : S === "offline" ? { cls: "is-error", text: "Offline: changes kept here" } : { cls: "", text: "Saved" };
    });
    function x() {
      i.value = !0, nt(() => {
        s.value && (s.value.focus({ preventScroll: !0 }), s.value.select());
      });
    }
    function w(S) {
      if (!i.value) return;
      const M = s.value ? s.value.value : "";
      i.value = !1, S && t.renameBoard(M);
    }
    return (S, M) => (g(), b("div", {
      class: "cv-topbar",
      onPointerdown: M[11] || (M[11] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", iB, [
        u("button", {
          class: "cv-mark",
          title: "RunDiffusion",
          "aria-label": "RunDiffusion",
          onClick: M[0] || (M[0] = (_) => e.onHome())
        }, [...M[12] || (M[12] = [
          u("svg", {
            viewBox: "1 33 239 173",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            u("path", {
              d: "M160.973 91.1044H105.586C103.271 91.1044 101.134 89.8671 99.9766 87.8597L74.5215 43.7307C72.0284 39.4055 75.1448 33.9999 80.1311 33.9999H135.518C137.833 33.9999 139.97 35.2372 141.128 37.2447L166.579 81.3772C169.072 85.7024 165.956 91.108 160.97 91.108L160.973 91.1044Z",
              fill: "#CC5FD1"
            }),
            u("path", {
              d: "M160.974 205.317H105.587C103.271 205.317 101.134 204.079 99.9769 202.072L74.5254 157.939C72.0323 153.614 75.1487 148.209 80.135 148.209H135.522C137.837 148.209 139.974 149.446 141.132 151.453L166.583 195.586C169.076 199.911 165.96 205.317 160.974 205.317Z",
              fill: "#B0B3F6"
            }),
            u("path", {
              d: "M150.485 148.213H205.872C208.187 148.213 210.324 146.975 211.481 144.968L236.933 100.835C239.426 96.5102 236.31 91.1046 231.323 91.1046H175.936C173.621 91.1046 171.484 92.3419 170.327 94.3494L144.875 138.482C142.382 142.807 145.498 148.213 150.485 148.213Z",
              fill: "#9A6ADF"
            }),
            u("path", {
              d: "M40.7394 200.572L67.1953 151.857C68.2994 149.821 68.2389 147.35 67.0279 145.371L40.4581 101.905C37.8545 97.6479 31.6216 97.8048 29.2389 102.194L2.78656 150.909C1.68245 152.945 1.74299 155.416 2.95395 157.395L29.5238 200.86C32.1274 205.118 38.3603 204.961 40.743 200.572H40.7394Z",
              fill: "#A691DF"
            })
          ], -1)
        ])]),
        u("button", {
          class: "cv-crumb",
          title: "All boards",
          onClick: M[1] || (M[1] = (_) => e.onIndex())
        }, "Boards"),
        M[13] || (M[13] = u("span", { class: "cv-crumb cv-crumb-sep" }, "/", -1)),
        i.value ? (g(), b("input", {
          key: 0,
          ref_key: "inputEl",
          ref: s,
          class: "cv-board-title-input",
          value: m(t).meta.title,
          spellcheck: "false",
          maxlength: "120",
          onKeydown: [
            M[2] || (M[2] = tn(Te((_) => w(!0), ["prevent"]), ["enter"])),
            M[3] || (M[3] = tn(Te((_) => w(!1), ["stop", "prevent"]), ["esc"]))
          ],
          onBlur: M[4] || (M[4] = (_) => w(!0))
        }, null, 40, sB)) : (g(), b("span", {
          key: 1,
          class: "cv-board-title",
          title: "Rename board",
          onClick: x
        }, E(m(t).meta.title), 1)),
        C(IL)
      ]),
      u("div", oB, [
        m(Tw) ? (g(), Ie(da(m(Tw)), {
          key: 0,
          board: m(t)
        }, null, 8, ["board"])) : z("", !0),
        o.value ? (g(), Ie(da(r.value ? "button" : "span"), {
          key: 1,
          class: G(["cv-tokens", { "is-empty": o.value.empty, "is-link": r.value }]),
          title: o.value.title,
          "data-testid": "token-balance",
          onClick: M[5] || (M[5] = (_) => m(t).getTokens())
        }, {
          default: Xe(() => [
            C($, {
              name: "Tokens",
              size: 13
            }),
            Y(E(o.value.text), 1)
          ]),
          _: 1
        }, 8, ["class", "title"])) : z("", !0),
        u("span", {
          class: G(["cv-save-state", v.value.cls]),
          title: v.value.text
        }, [
          M[14] || (M[14] = u("span", { class: "dot" }, null, -1)),
          Y(E(v.value.text), 1)
        ], 10, rB),
        m(d) ? (g(), b("button", {
          key: 2,
          class: "cv-feedback",
          title: c.value ? "Your report is waiting: open it to finish and send" : "Report a bug or share an idea (`)",
          "data-testid": "feedback-button",
          onClick: M[6] || (M[6] = (_) => h("button"))
        }, [
          C($, {
            name: "MessageSquareWarning",
            size: 13
          }),
          M[15] || (M[15] = Y("Feedback ", -1)),
          c.value ? (g(), b("span", lB)) : z("", !0)
        ], 8, aB)) : z("", !0),
        u("div", dB, [
          u("button", {
            class: G(["cv-topbar-btn", { on: m(t).ui.boardMenu }]),
            title: "Board menu",
            "aria-label": "Board menu",
            "aria-haspopup": "menu",
            "aria-expanded": m(t).ui.boardMenu,
            "data-testid": "board-menu-button",
            onClick: M[7] || (M[7] = (_) => m(t).ui.boardMenu = !m(t).ui.boardMenu)
          }, [
            C($, {
              name: "EllipsisVertical",
              size: 16
            }),
            a.value && !m(t).ui.boardMenu ? (g(), b("span", uB)) : z("", !0)
          ], 10, cB),
          m(t).ui.boardMenu ? (g(), b("div", hB, [
            u("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "library-menu-item",
              onClick: p
            }, [
              C($, {
                name: "LayoutTemplate",
                size: 17
              }),
              M[16] || (M[16] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Prompt Library"),
                u("span", { class: "cv-board-menu-desc" }, "Browse Featured prompts and start a session from one")
              ], -1))
            ]),
            u("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "trash-button",
              onClick: M[8] || (M[8] = (_) => l("trashOpen"))
            }, [
              C($, {
                name: "Trash2",
                size: 17
              }),
              M[17] || (M[17] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Recently Deleted"),
                u("span", { class: "cv-board-menu-desc" }, "Recover what was deleted from this board, or delete it for good")
              ], -1)),
              a.value ? (g(), b("span", pB, E(a.value > 99 ? "99+" : a.value), 1)) : z("", !0)
            ]),
            u("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "shortcuts-button",
              onClick: M[9] || (M[9] = (_) => l("keysOpen"))
            }, [
              C($, {
                name: "Keyboard",
                size: 17
              }),
              M[18] || (M[18] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Keyboard Shortcuts"),
                u("span", { class: "cv-board-menu-desc" }, "Every key the board answers to")
              ], -1)),
              M[19] || (M[19] = u("kbd", { class: "cv-board-menu-kbd" }, "?", -1))
            ]),
            m(t).canOpenTour ? (g(), b("button", {
              key: 0,
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "tour-menu-item",
              onClick: f
            }, [
              C($, {
                name: "CircleHelp",
                size: 17
              }),
              M[20] || (M[20] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Take the Tour"),
                u("span", { class: "cv-board-menu-desc" }, "Three minutes on sessions, Tab, Studio view and Edit")
              ], -1))
            ])) : z("", !0),
            m(d) ? (g(), b("button", {
              key: 1,
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "feedback-menu-item",
              onClick: M[10] || (M[10] = (_) => h("menu"))
            }, [
              C($, {
                name: "MessageSquareWarning",
                size: 17
              }),
              M[21] || (M[21] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Send Feedback"),
                u("span", { class: "cv-board-menu-desc" }, "Report a bug or share an idea, with a screenshot")
              ], -1)),
              M[22] || (M[22] = u("kbd", { class: "cv-board-menu-kbd" }, "`", -1))
            ])) : z("", !0)
          ])) : z("", !0)
        ])
      ])
    ], 32));
  }
});
function mB(n) {
  const e = [n.userAgentData && n.userAgentData.platform || "", n.platform || "", n.userAgent || ""].join(" ").toLowerCase();
  return /mac|iphone|ipad|ipod/.test(e) ? "mac" : /\bwin/.test(e) ? "windows" : /cros|chrome os|chromeos/.test(e) ? "chromeos" : /linux|x11|android/.test(e) ? "linux" : "other";
}
const ws = typeof navigator == "undefined" ? "other" : mB(navigator);
function bn(n, e = ws) {
  return e === "mac" ? n.metaKey : n.ctrlKey;
}
function gB(n, e = ws) {
  return e === "mac" ? n.ctrlKey : n.metaKey;
}
function rm(n = ws) {
  return n === "mac" ? { mod: "⌘", shift: "⇧", alt: "⌥", enter: "↵", del: "⌫", esc: "Esc" } : { mod: "Ctrl", shift: "Shift", alt: "Alt", enter: "Enter", del: "Del", esc: "Esc" };
}
function pn(n, e = ws) {
  const t = rm(e), s = (e === "mac" ? ["alt", "shift", "mod"] : ["mod", "alt", "shift"]).filter((r) => n.includes(r)).map((r) => t[r]), o = n.filter((r) => r !== "mod" && r !== "shift" && r !== "alt").map((r) => r === "enter" ? t.enter : r === "del" ? t.del : r === "esc" ? t.esc : r);
  return s.concat(o);
}
function wn(n, e = ws) {
  return pn(n, e).join(e === "mac" ? "" : "+");
}
function am(n = ws) {
  return n === "mac" ? ["shift", "mod", "Z"] : ["mod", "Y"];
}
const bB = ["aria-label", "aria-expanded"], vB = {
  class: "caret",
  "aria-hidden": "true"
}, yB = ["aria-checked", "data-testid", "onClick"], xB = { class: "tick" }, wB = { class: "lb" }, kB = { class: "k" }, _B = /* @__PURE__ */ Pe({
  __name: "ShapeTool",
  setup(n) {
    const { board: e } = Ze(), t = [
      { id: "rect", label: "Rectangle", icon: "Square", key: "M" },
      { id: "ellipse", label: "Ellipse", icon: "Circle", key: "L" },
      { id: "line", label: "Line", icon: "Slash", key: "\\" },
      { id: "arrow", label: "Arrow", icon: "ArrowUpRight", key: wn(["shift", "\\"]) }
    ], i = I(() => t.find((o) => o.id === e.ui.shapeKind) || t[0]);
    function s() {
      e.ui.addMenu = !1, e.ui.shapeMenu = !e.ui.shapeMenu;
    }
    return (o, r) => (g(), b("div", {
      class: G(["v2-shapetool", { on: m(e).ui.shapeArmed, "is-open": m(e).ui.shapeMenu }])
    }, [
      u("button", {
        class: "face cv-tool",
        "aria-label": "Shapes: " + i.value.label,
        "aria-haspopup": "menu",
        "aria-expanded": m(e).ui.shapeMenu,
        "data-testid": "shape-tool",
        onClick: s
      }, [
        C($, {
          name: i.value.icon,
          size: 17
        }, null, 8, ["name"]),
        u("span", vB, [
          C($, {
            name: "ChevronUp",
            size: 9,
            stroke: 2.5
          })
        ]),
        r[1] || (r[1] = u("span", { class: "tip" }, "Shapes", -1))
      ], 8, bB),
      m(e).ui.shapeMenu ? (g(), b("div", {
        key: 0,
        class: "v2-shapemenu",
        role: "menu",
        "data-testid": "shape-menu",
        onPointerdown: r[0] || (r[0] = Te(() => {
        }, ["stop"]))
      }, [
        r[2] || (r[2] = u("div", { class: "hd" }, "Shapes", -1)),
        (g(), b(j, null, ge(t, (a) => u("button", {
          key: a.id,
          class: G(["row", { on: a.id === m(e).ui.shapeKind }]),
          role: "menuitemradio",
          "aria-checked": m(e).ui.shapeArmed && a.id === m(e).ui.shapeKind,
          "data-testid": "shape-" + a.id,
          onClick: (l) => m(e).armShape(a.id)
        }, [
          u("span", xB, [
            a.id === m(e).ui.shapeKind ? (g(), Ie($, {
              key: 0,
              name: "Check",
              size: 13
            })) : z("", !0)
          ]),
          C($, {
            name: a.icon,
            size: 15
          }, null, 8, ["name"]),
          u("span", wB, E(a.label), 1),
          u("span", kB, E(a.key), 1)
        ], 10, yB)), 64))
      ], 32)) : z("", !0)
    ], 2));
  }
}), SB = { class: "cv-badge" }, MB = { class: "cv-badge is-lib" }, TB = /* @__PURE__ */ Pe({
  __name: "PlaceMenu",
  emits: ["computer"],
  setup(n, { emit: e }) {
    const t = e, { board: i } = Ze(), s = /* @__PURE__ */ W(null);
    function o() {
      i.ui.placeMenu = !1, t("computer");
    }
    function r() {
      i.openLibrary({ purpose: "place" });
    }
    function a(l) {
      const d = l.target;
      !s.value || !d || s.value.contains(d) || d.closest("[data-place-toggle]") || (i.ui.placeMenu = !1);
    }
    return it(() => window.addEventListener("pointerdown", a, !0)), We(() => window.removeEventListener("pointerdown", a, !0)), (l, d) => (g(), b("div", {
      ref_key: "el",
      ref: s,
      class: "v2-placemenu",
      role: "menu",
      "aria-label": "Place images",
      "data-testid": "place-menu"
    }, [
      u("button", {
        class: "am-row",
        role: "menuitem",
        "data-testid": "place-computer",
        onClick: o
      }, [
        u("span", SB, [
          C($, {
            name: "Upload",
            size: 15
          })
        ]),
        d[0] || (d[0] = u("span", { class: "am-main" }, [
          u("span", { class: "am-name" }, "From your computer"),
          u("span", { class: "am-sub" }, "Or drop images anywhere on the board")
        ], -1))
      ]),
      u("button", {
        class: "am-row",
        role: "menuitem",
        "data-testid": "place-library",
        onClick: r
      }, [
        u("span", MB, [
          C($, {
            name: "Library",
            size: 15
          })
        ]),
        d[1] || (d[1] = u("span", { class: "am-main" }, [
          u("span", { class: "am-name" }, "From your Library"),
          u("span", { class: "am-sub" }, "Your generations, uploads and favorites")
        ], -1))
      ])
    ], 512));
  }
}), CB = ["aria-label", "data-testid"], IB = { class: "dp-card" }, AB = { class: "dp-media" }, PB = ["poster", "autoplay", "data-slide"], EB = ["src"], RB = ["src"], zB = ["src", "data-slide"], $B = { class: "dp-tag" }, DB = { class: "dp-body" }, OB = { class: "dp-foot" }, LB = {
  class: "dp-dots",
  role: "tablist",
  "aria-label": "Slides"
}, BB = ["aria-selected", "aria-label", "onClick"], FB = { class: "dp-cta" }, NB = 500, UB = 160, Jm = 3400, Zm = 8e3, l8 = /* @__PURE__ */ Pe({
  __name: "DemoPopout",
  props: {
    slides: {},
    media: {},
    tag: {},
    tagIcon: {},
    cta: {},
    placement: { default: "above" },
    disabled: { type: Boolean, default: !1 },
    testid: { default: "demo-popout" }
  },
  emits: ["open"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches, o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(0), a = /* @__PURE__ */ W(Jm / 1e3), l = I(() => t.slides[r.value]);
    let d = 0, c = 0, h = 0;
    function f() {
      clearTimeout(c), !(o.value || t.disabled) && (clearTimeout(d), d = window.setTimeout(v, NB));
    }
    function p() {
      clearTimeout(d), clearTimeout(c), c = window.setTimeout(y, UB);
    }
    function y() {
      clearTimeout(d), clearTimeout(h), o.value = !1;
    }
    function v() {
      t.disabled || !t.slides.length || (w(), r.value = 0, o.value = !0, S());
    }
    let x = !1;
    function w() {
      if (!x) {
        x = !0;
        for (const P of t.slides) {
          const A = new Image();
          A.src = t.media + P.id + ".jpg";
        }
      }
    }
    function S() {
      if (clearTimeout(h), s) return;
      const P = l.value;
      a.value = (P.video ? Zm : Jm) / 1e3, h = window.setTimeout(_, P.video ? Zm : Jm);
    }
    function M(P) {
      r.value = (P + t.slides.length) % t.slides.length, S();
    }
    function _() {
      M(r.value + 1);
    }
    function T(P) {
      if (s) return;
      const A = P.target;
      Number.isFinite(A.duration) && A.duration > 0 && (a.value = Math.min(Zm / 1e3, A.duration + 0.6), clearTimeout(h), h = window.setTimeout(_, a.value * 1e3));
    }
    function k() {
      y(), i("open");
    }
    return Ee(() => t.disabled, (P) => {
      P && y();
    }), We(() => {
      clearTimeout(d), clearTimeout(c), clearTimeout(h);
    }), (P, A) => (g(), b("span", {
      class: G(["dp-wrap", "is-" + n.placement]),
      onMouseenter: f,
      onMouseleave: p,
      onFocusin: f,
      onFocusout: p,
      onClick: y
    }, [
      Ss(P.$slots, "default", { open: o.value }),
      C(vt, { name: "dp-pop" }, {
        default: Xe(() => [
          o.value ? (g(), b("div", {
            key: 0,
            class: "dp-pop",
            role: "dialog",
            "aria-label": n.tag,
            "data-testid": n.testid,
            onClick: Te(k, ["stop"])
          }, [
            u("div", IB, [
              u("div", AB, [
                C(vt, { name: "dp-slide" }, {
                  default: Xe(() => [
                    l.value.video ? (g(), b("video", {
                      key: l.value.id,
                      poster: n.media + l.value.id + ".jpg",
                      autoplay: !m(s),
                      muted: "",
                      playsinline: "",
                      preload: "auto",
                      disablepictureinpicture: "",
                      "data-slide": l.value.id,
                      onLoadedmetadata: T
                    }, [
                      u("source", {
                        src: n.media + l.value.id + ".webm",
                        type: "video/webm"
                      }, null, 8, EB),
                      u("source", {
                        src: n.media + l.value.id + ".mp4",
                        type: "video/mp4"
                      }, null, 8, RB)
                    ], 40, PB)) : (g(), b("img", {
                      key: l.value.id,
                      src: n.media + l.value.id + ".jpg",
                      alt: "",
                      "data-slide": l.value.id,
                      draggable: "false"
                    }, null, 8, zB))
                  ]),
                  _: 1
                }),
                u("span", $B, [
                  C($, {
                    name: n.tagIcon,
                    size: 10
                  }, null, 8, ["name"]),
                  Y(E(n.tag), 1)
                ])
              ]),
              u("div", DB, [
                C(vt, {
                  name: "dp-words",
                  mode: "out-in"
                }, {
                  default: Xe(() => [
                    (g(), b("div", {
                      key: l.value.id,
                      class: "dp-words"
                    }, [
                      u("b", null, E(l.value.title), 1),
                      u("span", null, E(l.value.text), 1)
                    ]))
                  ]),
                  _: 1
                }),
                u("div", OB, [
                  u("span", LB, [
                    (g(!0), b(j, null, ge(n.slides, (R, D) => (g(), b("button", {
                      key: R.id,
                      role: "tab",
                      "aria-selected": D === r.value,
                      "aria-label": R.title,
                      class: G({ on: D === r.value }),
                      style: ce(D === r.value ? { "--d": a.value + "s" } : void 0),
                      onClick: Te((O) => M(D), ["stop"])
                    }, [
                      (g(), b("i", {
                        key: r.value + ":" + D
                      }))
                    ], 14, BB))), 128))
                  ]),
                  u("span", FB, [
                    Y(E(n.cta), 1),
                    C($, {
                      name: "ChevronRight",
                      size: 12
                    })
                  ])
                ])
              ])
            ])
          ], 8, CB)) : z("", !0)
        ]),
        _: 1
      })
    ], 34));
  }
});
function sf(n) {
  if (!n.detail) return;
  const e = n.target instanceof Element ? n.target.closest("button") : null;
  e && e === document.activeElement && e.blur();
}
const d8 = "/img/board/prompt-library/", c8 = [
  { id: "start", video: !0, title: "Start from a prompt", text: "Open the prompt library from the toolbar, or from Start from a prompt when you add a session." },
  { id: "browse", video: !0, title: "Browse by picture", text: "Pick a kind and a category on the left, or search. Hover a tile to see the images it starts from." },
  { id: "use", video: !0, title: "Use it, or remix it", text: "Use prompt puts the words in your session. Remix sets up the whole example, images included." },
  { id: "session", video: !1, title: "On every session", text: "The same icon sits beside every session's prompt. A prompt picked there goes straight into it." },
  { id: "save", video: !0, title: "Save your own", text: "Keep the prompt behind a result you like, just for you or shared with the people you work with." },
  { id: "kinds", video: !1, title: "Generate or edit", text: "Image and Video each split in two: Generate starts from words, Edit from your own image." }
], u8 = "rd-board-prompt-library-seen";
function GB() {
  try {
    return window.localStorage.getItem(u8) === "1";
  } catch {
    return !1;
  }
}
const Bc = /* @__PURE__ */ W(typeof window != "undefined" && GB());
function jB() {
  if (!Bc.value) {
    Bc.value = !0;
    try {
      window.localStorage.setItem(u8, "1");
    } catch {
    }
  }
}
const HB = ["aria-expanded"], VB = {
  key: 0,
  class: "tip"
}, WB = ["aria-expanded"], qB = {
  key: 0,
  class: "lib-new",
  "aria-hidden": "true"
}, KB = ["aria-label", "onClick"], YB = { class: "tip" }, XB = { class: "key" }, JB = { class: "v2-placewrap" }, ZB = ["aria-expanded"], QB = {
  key: 0,
  class: "tip"
}, eF = ["aria-pressed"], tF = /* @__PURE__ */ Pe({
  __name: "ToolRail",
  props: {
    away: { type: Boolean },
    onImage: { type: Function }
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = I(() => t.ui.library.open && !t.ui.library.sessionId);
    function s() {
      t.ui.addMenu = !1, t.ui.placeMenu = !1, t.promptLibrary.toggle(null);
    }
    const o = [
      { id: "select", icon: "MousePointer2", label: "Select", key: "V" },
      { id: "hand", icon: "Hand", label: "Pan", key: "H" }
    ];
    function r() {
      if (!t.hasLibrary) {
        e.onImage();
        return;
      }
      t.ui.addMenu = !1, t.ui.placeMenu = !t.ui.placeMenu;
    }
    return (a, l) => (g(), b("div", {
      class: G(["v2-railwrap", { "is-away": e.away }]),
      onPointerdown: l[6] || (l[6] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", {
        class: "v2-rail",
        "data-testid": "tool-rail",
        onClick: l[5] || (l[5] = //@ts-ignore
        (...d) => m(sf) && m(sf)(...d))
      }, [
        u("button", {
          class: G(["cv-tool v2-add", { on: m(t).ui.addMenu }]),
          "aria-label": "Start a tool session",
          "aria-expanded": m(t).ui.addMenu,
          "data-testid": "all-tools",
          onClick: l[0] || (l[0] = (d) => m(t).addElement("tool"))
        }, [
          C($, {
            name: "Plus",
            size: 19,
            stroke: 2.4
          }),
          m(t).ui.addMenu ? z("", !0) : (g(), b("span", VB, "Start a tool session"))
        ], 10, HB),
        C(l8, {
          slides: m(c8),
          media: m(d8),
          tag: "Prompt library",
          "tag-icon": "LayoutTemplate",
          cta: "Open the prompt library",
          disabled: i.value,
          testid: "rail-prompts-demo",
          onOpen: s
        }, {
          default: Xe(() => [
            u("button", {
              class: G(["cv-tool v2-prompts", { on: i.value }]),
              "aria-label": "Start from a prompt",
              "aria-expanded": i.value,
              "data-testid": "rail-prompts",
              onClick: s
            }, [
              C($, {
                name: "LayoutTemplate",
                size: 15
              }),
              m(Bc) ? z("", !0) : (g(), b("span", qB))
            ], 10, WB)
          ]),
          _: 1
        }, 8, ["slides", "media", "disabled"]),
        l[11] || (l[11] = u("span", { class: "sep" }, null, -1)),
        (g(), b(j, null, ge(o, (d) => u("button", {
          key: d.id,
          class: G(["cv-tool", { on: m(t).ui.mode === d.id && !m(t).ui.shapeArmed && !m(t).comments.ui.armed }]),
          "aria-label": d.label,
          onClick: (c) => m(t).setMode(d.id)
        }, [
          C($, {
            name: d.icon,
            size: 17
          }, null, 8, ["name"]),
          u("span", YB, [
            Y(E(d.label), 1),
            u("span", XB, E(d.key), 1)
          ])
        ], 10, KB)), 64)),
        l[12] || (l[12] = u("span", { class: "sep" }, null, -1)),
        u("span", JB, [
          u("button", {
            class: G(["cv-tool", { on: m(t).ui.placeMenu }]),
            "aria-label": "Place image",
            "aria-expanded": m(t).hasLibrary ? m(t).ui.placeMenu : void 0,
            "data-place-toggle": "",
            "data-testid": "place-image",
            onClick: r
          }, [
            C($, {
              name: "Image",
              size: 17
            }),
            m(t).ui.placeMenu ? z("", !0) : (g(), b("span", QB, "Place image"))
          ], 10, ZB),
          C(vt, { name: "v2-placemenu" }, {
            default: Xe(() => [
              m(t).ui.placeMenu ? (g(), Ie(TB, {
                key: 0,
                onComputer: l[1] || (l[1] = (d) => e.onImage())
              })) : z("", !0)
            ]),
            _: 1
          })
        ]),
        u("button", {
          class: "cv-tool",
          "aria-label": "Add note",
          onClick: l[2] || (l[2] = (d) => m(t).addElement("note"))
        }, [
          C($, {
            name: "StickyNote",
            size: 17
          }),
          l[7] || (l[7] = u("span", { class: "tip" }, [
            Y("Add note"),
            u("span", { class: "key" }, "N")
          ], -1))
        ]),
        u("button", {
          class: "cv-tool",
          "aria-label": "Add frame",
          onClick: l[3] || (l[3] = (d) => m(t).addElement("frame"))
        }, [
          C($, {
            name: "Frame",
            size: 17
          }),
          l[8] || (l[8] = u("span", { class: "tip" }, [
            Y("Add frame"),
            u("span", { class: "key" }, "F")
          ], -1))
        ]),
        C(_B),
        m(t).comments.enabled ? (g(), b(j, { key: 0 }, [
          l[10] || (l[10] = u("span", { class: "sep" }, null, -1)),
          u("button", {
            class: G(["cv-tool", { on: m(t).comments.ui.armed }]),
            "aria-label": "Comment",
            "aria-pressed": m(t).comments.ui.armed,
            "data-testid": "comment-tool",
            onClick: l[4] || (l[4] = (d) => m(t).comments.arm())
          }, [
            C($, {
              name: "MessageCirclePlus",
              size: 17
            }),
            l[9] || (l[9] = u("span", { class: "tip" }, [
              Y("Comment"),
              u("span", { class: "key" }, "C")
            ], -1))
          ], 10, eF)
        ], 64)) : z("", !0)
      ])
    ], 34));
  }
});
function L1(n) {
  const e = /^(.*\/o\/)([^?#]+)(\?[^#]*)?$/.exec(n || "");
  if (!e) return null;
  let t;
  try {
    t = decodeURIComponent(e[2]);
  } catch {
    return null;
  }
  if (!/^(runnitResults|runnitUploads)\//.test(t) || t.includes("/thumbs/")) return null;
  const i = t.lastIndexOf("/"), s = t.slice(0, i) + "/thumbs/" + t.slice(i + 1).replace(/\.[^/.]+$/, "_512x512.webp");
  return e[1] + encodeURIComponent(s) + (e[3] || "");
}
const Qm = /* @__PURE__ */ Xt(/* @__PURE__ */ new Map()), Ow = /* @__PURE__ */ new Set();
function Bt(n) {
  const e = Qm.get(n);
  if (e) return e;
  const t = L1(n);
  if (!t) return n;
  if (!Ow.has(n) && typeof Image != "undefined") {
    Ow.add(n);
    const i = new Image();
    i.onload = () => Qm.set(n, t), i.onerror = () => Qm.set(n, n), i.src = t;
  }
  return t;
}
const lm = [
  { id: "all", label: "All" },
  { id: "pinned", label: "Pinned" },
  { id: "image", label: "Image", match: /image/i },
  { id: "video", label: "Video", match: /video/i },
  { id: "threed", label: "3D", match: /3d/i },
  { id: "upscale", label: "Upscale", match: /upscale|enhance/i }
];
function h8(n, e, t, i) {
  const s = lm.find((r) => r.id === e), o = t.trim().toLowerCase();
  return n.filter((r) => e === "pinned" && !i(r.id) || s && s.match && !s.match.test((r.kind || "") + " " + (r.name || "")) ? !1 : !o || ((r.kind || "") + " " + (r.name || "") + " " + (r.model || "")).toLowerCase().includes(o));
}
const nF = "start from a prompt prompts library featured saved my templates ideas";
function p8(n) {
  return n.trim().toLowerCase().split(/\s+/).filter(Boolean).every((e) => nF.includes(e));
}
function f8(n, e, t) {
  if (e === "pinned") return [];
  const i = lm.find((o) => o.id === e), s = t.trim().toLowerCase();
  return n.filter((o) => i && i.match && !i.match.test(o.name) ? !1 : !s || (o.name + " " + o.desc + " " + o.models.map((r) => r.name).join(" ")).toLowerCase().includes(s));
}
function Bi(n) {
  return n.models.find((e) => e.id === n.defaultModelId) || n.models[0] || null;
}
function of(n, e, t = [], i = []) {
  const s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  for (const a of e)
    for (const l of a.models)
      s.set(l.id, l), o.has(l.name) || o.set(l.name, l);
  for (const a of t)
    s.has(a.id) || (s.set(a.id, a), o.has(a.name) || o.set(a.name, a));
  const r = [...s.values()].sort((a, l) => a.name.localeCompare(l.name, void 0, { numeric: !0, sensitivity: "base" }));
  return { source: n, kits: e, all: r, byId: s, byName: o, tools: i };
}
function pl(n) {
  return n === "imageEdit" ? "image" : n === "videoEdit" ? "video" : n || "";
}
function Fc(n, e, t) {
  const i = pl(e.id);
  let s = !1;
  for (const o of n.kits)
    if (o.models.some((r) => r.id === t.id)) {
      if (pl(o.id) === i) return !0;
      s = !0;
    }
  return !s && pl(t.kitId) === i;
}
function Tv(n, e, t) {
  const i = t && n.kits.find((s) => s.id === t) || null;
  return i && Fc(n, i, e) ? i : n.kits.find((s) => s.models.some((o) => o.id === e.id)) || n.kits.find((s) => s.id === e.kitId) || n.kits.find((s) => pl(s.id) === pl(e.kitId)) || null;
}
const iF = { class: "rs-empty-body" }, sF = { class: "rs-empty-kinds" }, oF = ["tabindex", "title", "data-testid", "onClick"], rF = ["tabindex"], aF = { class: "rs-head" }, lF = { class: "rs-count" }, dF = { class: "rs-tools" }, cF = { class: "v2-dock-search rs-search" }, uF = ["tabindex"], hF = { class: "v2-dock-filters rs-filters" }, pF = ["tabindex", "onClick"], fF = ["data-ref-session", "title", "onClick"], mF = {
  key: 1,
  class: "busy"
}, gF = { class: "k" }, bF = {
  key: 2,
  class: "pin"
}, vF = { class: "rs-meta" }, yF = { class: "rs-name" }, xF = { class: "rs-sub" }, wF = { class: "kind" }, kF = {
  key: 0,
  class: "rs-n"
}, _F = ["title", "aria-label", "aria-pressed", "tabindex", "data-testid", "onClick"], SF = {
  key: 0,
  class: "rs-none"
}, MF = {
  key: 0,
  class: "rs-more"
}, Lw = 4, eg = 40, TF = /* @__PURE__ */ Pe({
  __name: "RecentSessions",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(!1), i = /* @__PURE__ */ W(!1), s = /* @__PURE__ */ W(""), o = /* @__PURE__ */ W("all");
    let r = 0;
    const a = () => {
      clearTimeout(r), r = window.setTimeout(() => {
        t.value = !0;
      }, 90);
    }, l = () => {
      clearTimeout(r), !i.value && (r = window.setTimeout(() => {
        t.value = !1;
      }, 240));
    };
    We(() => clearTimeout(r));
    const d = I(() => (e.docRev.value, e.ui.recentIds.length, e.recentTools())), c = I(() => e.promptTool.value ? e.promptTool.value.id : null), h = I(() => t.value ? h8(d.value, o.value, s.value, (_) => e.isPinned(_)) : d.value), f = I(() => d.value.length - Lw), p = /* @__PURE__ */ W(eg), y = I(() => t.value ? h.value.slice(0, p.value) : h.value.slice(0, Lw));
    Ee([s, o, t], () => {
      p.value = eg;
    });
    function v(_) {
      const T = _.target;
      T.scrollTop + T.clientHeight > T.scrollHeight - 150 && p.value < h.value.length && (p.value += eg);
    }
    function x(_) {
      _.stopPropagation(), _.key === "Escape" ? (s.value = "", _.target.blur(), t.value = !1) : _.key === "Enter" && h.value.length && e.openSession(h.value[0]);
    }
    function w() {
      e.openAddMenu(), t.value = !1;
    }
    const S = I(() => e.catalog.value.kits.filter((_) => !!Bi(_)));
    function M(_) {
      const T = e.catalog.value.kits.find((P) => P.id === _), k = T && Bi(T);
      !T || !k || (e.pickModel(T, k), t.value = !1);
    }
    return (_, T) => d.value.length ? (g(), b("div", {
      key: 1,
      class: G(["rs", { "is-open": t.value }]),
      "data-testid": "recent-sessions",
      onMouseenter: a,
      onMouseleave: l,
      onPointerdown: T[5] || (T[5] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", aF, [
        T[10] || (T[10] = u("span", { class: "rs-eyebrow" }, "Tool sessions", -1)),
        u("span", lF, E(d.value.length), 1)
      ]),
      u("div", dF, [
        u("div", cF, [
          C($, {
            name: "Search",
            size: 13
          }),
          _t(u("input", {
            "onUpdate:modelValue": T[1] || (T[1] = (k) => s.value = k),
            type: "text",
            placeholder: "Search tool sessions",
            tabindex: t.value ? 0 : -1,
            onFocus: T[2] || (T[2] = (k) => i.value = !0),
            onBlur: T[3] || (T[3] = (k) => {
              i.value = !1, l();
            }),
            onKeydown: x
          }, null, 40, uF), [
            [Zt, s.value]
          ]),
          s.value ? (g(), b("button", {
            key: 0,
            class: "cv-iconbtn",
            style: { width: "22px", height: "22px" },
            onClick: T[4] || (T[4] = (k) => s.value = "")
          }, [
            C($, {
              name: "X",
              size: 11
            })
          ])) : z("", !0)
        ]),
        u("div", hF, [
          (g(!0), b(j, null, ge(m(lm), (k) => (g(), b("button", {
            key: k.id,
            class: G(["v2-fchip", { on: o.value === k.id }]),
            tabindex: t.value ? 0 : -1,
            onClick: (P) => o.value = k.id
          }, E(k.label), 11, pF))), 128))
        ])
      ]),
      u("div", {
        class: "rs-list",
        onScrollPassive: v
      }, [
        (g(!0), b(j, null, ge(y.value, (k) => (g(), b("div", {
          key: k.id,
          class: G(["rs-item", { "is-pinned": m(e).isPinned(k.id) }])
        }, [
          u("button", {
            class: G(["rs-row", { on: k.id === c.value, "is-ref-target": m(e).ui.refSession === k.id }]),
            "data-ref-session": k.id,
            "data-ref-reveal": "",
            title: t.value ? void 0 : k.name,
            onClick: (P) => m(e).openSession(k)
          }, [
            u("span", {
              class: "rs-shot",
              style: ce(k.thumbs && k.thumbs.length ? { backgroundImage: 'url("' + m(Bt)(k.thumbs[0]) + '")' } : void 0)
            }, [
              !k.thumbs || !k.thumbs.length ? (g(), Ie($, {
                key: 0,
                name: k.icon,
                size: 15
              }, null, 8, ["name"])) : z("", !0),
              m(e).generating[k.id] ? (g(), b("span", mF)) : z("", !0),
              u("span", gF, [
                C($, {
                  name: k.icon,
                  size: 9
                }, null, 8, ["name"])
              ]),
              m(e).isPinned(k.id) ? (g(), b("span", bF, [
                C($, {
                  name: "Pin",
                  size: 8
                })
              ])) : z("", !0)
            ], 4),
            u("span", vF, [
              u("span", yF, E(k.name), 1),
              u("span", xF, [
                u("span", wF, E(k.kind), 1),
                k.model ? (g(), b(j, { key: 0 }, [
                  T[11] || (T[11] = u("span", { class: "sep" }, "·", -1)),
                  Y(E(k.model), 1)
                ], 64)) : z("", !0)
              ])
            ]),
            k.count ? (g(), b("span", kF, E(k.count), 1)) : z("", !0)
          ], 10, fF),
          u("button", {
            class: G(["rs-pin", { on: m(e).isPinned(k.id) }]),
            title: m(e).isPinned(k.id) ? "Unpin" : "Pin to the top",
            "aria-label": (m(e).isPinned(k.id) ? "Unpin " : "Pin ") + k.name,
            "aria-pressed": m(e).isPinned(k.id),
            tabindex: t.value ? 0 : -1,
            "data-testid": "rs-pin-" + k.id,
            onClick: Te((P) => m(e).togglePinned(k.id), ["stop"])
          }, [
            C($, {
              name: "Pin",
              size: 12
            })
          ], 10, _F)
        ], 2))), 128)),
        t.value && !h.value.length ? (g(), b("div", SF, E(o.value === "pinned" && !s.value.trim() ? "Nothing pinned yet. Pin a session to keep it at the top." : "No tool sessions match"), 1)) : z("", !0)
      ], 32),
      !t.value && f.value > 0 ? (g(), b("span", MF, "+" + E(f.value), 1)) : z("", !0),
      T[12] || (T[12] = u("div", { class: "rs-pad" }, null, -1))
    ], 34)) : (g(), b("div", {
      key: 0,
      class: G(["rs rs-empty", { "is-open": t.value }]),
      "data-testid": "recent-sessions",
      onMouseenter: a,
      onMouseleave: l,
      onPointerdown: T[0] || (T[0] = Te(() => {
      }, ["stop"]))
    }, [
      T[8] || (T[8] = u("div", { class: "rs-head" }, [
        u("span", { class: "rs-eyebrow" }, "Tool sessions"),
        u("span", { class: "rs-count" }, "0")
      ], -1)),
      u("div", iF, [
        u("button", {
          class: "rs-empty-slot",
          title: "Start a tool session",
          onClick: w
        }, [
          C($, {
            name: "Plus",
            size: 16
          })
        ]),
        T[6] || (T[6] = u("span", { class: "rs-empty-txt" }, [
          u("span", { class: "t" }, "No tool sessions yet"),
          u("span", { class: "s" }, "Each generator you add to the board keeps its prompts and results here.")
        ], -1))
      ]),
      u("div", sF, [
        (g(!0), b(j, null, ge(S.value, (k) => (g(), b("button", {
          key: k.id,
          type: "button",
          class: "rs-empty-kind",
          tabindex: t.value ? 0 : -1,
          title: "New " + k.name + " session",
          "data-testid": "start-kind-" + k.id,
          onClick: (P) => M(k.id)
        }, [
          C($, {
            name: k.icon,
            size: 12
          }, null, 8, ["name"]),
          Y(E(k.name), 1)
        ], 8, oF))), 128))
      ]),
      u("button", {
        class: "rs-empty-cta",
        tabindex: t.value ? 0 : -1,
        onClick: w
      }, [
        C($, {
          name: "Plus",
          size: 13
        }),
        T[7] || (T[7] = Y(" Start a tool session", -1))
      ], 8, rF),
      T[9] || (T[9] = u("div", { class: "rs-pad" }, null, -1))
    ], 34));
  }
}), CF = { class: "am-view fwd" }, IF = { class: "am-searchrow" }, AF = { class: "am-search" }, PF = { class: "am-rows" }, EF = {
  key: 0,
  class: "am-eyebrow"
}, RF = ["data-testid", "onMouseenter", "onClick"], zF = { class: "cv-badge" }, $F = { class: "am-main" }, DF = { class: "am-name" }, OF = { class: "am-sub" }, LF = { class: "am-go" }, BF = { class: "cv-badge is-prompts" }, FF = { class: "am-go" }, NF = {
  key: 2,
  class: "am-none"
}, UF = /* @__PURE__ */ Pe({
  __name: "AddToolMenu",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(""), i = /* @__PURE__ */ W(0), s = /* @__PURE__ */ W(null), o = I(() => f8(e.catalog.value.kits, "all", t.value)), r = I(() => p8(t.value)), a = I(() => o.value.length + (r.value ? 1 : 0));
    Ee(t, () => {
      i.value = 0;
    }), it(() => {
      s.value && s.value.focus({ preventScroll: !0 });
    });
    function l(h) {
      if (h === o.value.length && r.value) {
        d();
        return;
      }
      const f = o.value[h];
      if (!f) return;
      const p = Bi(f);
      p && e.pickModel(f, p);
    }
    function d() {
      e.ui.addMenu = !1, e.promptLibrary.open(null);
    }
    function c(h) {
      h.key === "Escape" ? (h.stopPropagation(), t.value ? t.value = "" : e.ui.addMenu = !1) : h.key === "ArrowDown" ? (h.preventDefault(), i.value = Math.min(a.value - 1, i.value + 1)) : h.key === "ArrowUp" ? (h.preventDefault(), i.value = Math.max(0, i.value - 1)) : h.key === "Enter" && (h.preventDefault(), l(i.value));
    }
    return (h, f) => (g(), b("div", {
      class: "cv-addmenu at-rail",
      "data-testid": "add-menu",
      onPointerdown: f[4] || (f[4] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", CF, [
        u("div", IF, [
          u("div", AF, [
            C($, {
              name: "Search",
              size: 13
            }),
            _t(u("input", {
              ref_key: "inputEl",
              ref: s,
              "onUpdate:modelValue": f[0] || (f[0] = (p) => t.value = p),
              type: "text",
              placeholder: "Search generators",
              onKeydown: c
            }, null, 544), [
              [Zt, t.value]
            ]),
            t.value ? (g(), b("button", {
              key: 0,
              class: "cv-iconbtn",
              style: { width: "22px", height: "22px" },
              title: "Clear",
              onClick: f[1] || (f[1] = (p) => t.value = "")
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])) : z("", !0)
          ]),
          u("button", {
            class: "am-close",
            title: "Close",
            onClick: f[2] || (f[2] = (p) => m(e).ui.addMenu = !1)
          }, [
            C($, {
              name: "X",
              size: 14
            })
          ])
        ]),
        u("div", PF, [
          o.value.length ? (g(), b("div", EF, "New tool session")) : z("", !0),
          (g(!0), b(j, null, ge(o.value, (p, y) => (g(), b("button", {
            key: p.id,
            class: G(["am-row", { "is-active": i.value === y }]),
            "data-testid": "add-kit-" + p.id,
            onMouseenter: (v) => i.value = y,
            onClick: (v) => l(y)
          }, [
            u("span", zF, [
              C($, {
                name: p.icon,
                size: 15
              }, null, 8, ["name"])
            ]),
            u("span", $F, [
              u("div", DF, E(p.name), 1),
              u("div", OF, E(p.desc), 1)
            ]),
            u("span", LF, [
              C($, {
                name: "Plus",
                size: 13
              })
            ])
          ], 42, RF))), 128)),
          r.value ? (g(), b(j, { key: 1 }, [
            u("div", {
              class: G(["am-eyebrow", { "is-apart": o.value.length }])
            }, "Start from a prompt", 2),
            u("button", {
              class: G(["am-row", { "is-active": i.value === o.value.length }]),
              "data-testid": "add-menu-prompts",
              onMouseenter: f[3] || (f[3] = (p) => i.value = o.value.length),
              onClick: d
            }, [
              u("span", BF, [
                C($, {
                  name: "LayoutTemplate",
                  size: 15
                })
              ]),
              f[5] || (f[5] = u("span", { class: "am-main" }, [
                u("div", { class: "am-name" }, "Prompt library"),
                u("div", { class: "am-sub" }, "Featured prompts and your saved ones")
              ], -1)),
              u("span", FF, [
                C($, {
                  name: "ChevronRight",
                  size: 14
                })
              ])
            ], 34)
          ], 64)) : z("", !0),
          a.value ? z("", !0) : (g(), b("div", NF, "Nothing matches “" + E(t.value.trim()) + "”", 1))
        ])
      ])
    ], 32));
  }
}), Sa = 2, Os = 10, Cv = 52;
function GF(n, e, t) {
  let i = n.x + Sa, s = !1;
  i + e.w > t.w - Os && (n.x - Sa - e.w >= Os ? (i = n.x - Sa - e.w, s = !0) : i = Math.max(Os, t.w - Os - e.w));
  let o = n.y + Sa, r = !1;
  return o + e.h > t.h - Os && (n.y - Sa - e.h >= Cv + Os ? (o = n.y - Sa - e.h, r = !0) : o = Math.max(Cv + Os, t.h - Os - e.h)), { left: i, top: o, up: r, leftward: s };
}
function jF(n, e) {
  return Math.max(160, Math.min(e, n - Cv - Os * 2));
}
function B1(n, e, t, i = {}) {
  const s = (o) => {
    const r = o.target;
    n.value && r && n.value.contains(r) || t();
  };
  it(() => {
    const o = n.value;
    if (!o) return;
    const a = (o.offsetParent || document.body).getBoundingClientRect(), l = { w: a.width, h: a.height }, d = e();
    i.maxH && (o.style.maxHeight = jF(l.h, i.maxH) + "px");
    const c = GF({ x: d.x - a.left, y: d.y - a.top }, { w: o.offsetWidth, h: o.offsetHeight }, l);
    o.style.left = c.left + "px", o.style.top = c.top + "px", i.fixHeight && (o.style.height = o.offsetHeight + "px"), o.style.setProperty("--pm-origin", (c.up ? "bottom" : "top") + " " + (c.leftward ? "right" : "left")), window.addEventListener("pointerdown", s, !0), i.keepOnResize || window.addEventListener("resize", t);
  }), We(() => {
    window.removeEventListener("pointerdown", s, !0), window.removeEventListener("resize", t);
  });
}
function HF(n, e, t, i, s) {
  const o = t + i;
  if (!o || n < 0 || n >= o) return 0;
  const r = n < t, a = Math.floor((t - 1) / s) * s;
  return e === "ArrowRight" ? r ? Math.min(t - 1, n + 1) : n : e === "ArrowLeft" ? r ? Math.max(0, n - 1) : n : e === "ArrowDown" ? r ? n < a ? Math.min(t - 1, n + s) : i ? t : n : Math.min(o - 1, n + 1) : r ? n >= s ? n - s : n : n === t ? t ? a : n : n - 1;
}
const VF = {
  key: 0,
  class: "bd-pm-eyebrow"
}, WF = ["data-testid", "onClick"], qF = { class: "bd-pm-ic" }, KF = { class: "lbl" }, YF = {
  class: "bd-pm-add",
  "aria-hidden": "true"
}, XF = {
  key: 1,
  class: "bd-pm-sep",
  role: "separator"
}, JF = { class: "bd-pm-ic is-prompts" }, ZF = ["data-testid", "onClick"], QF = { class: "bd-pm-ic is-plain" }, eN = { class: "lbl" }, tN = { key: 0 }, nN = /* @__PURE__ */ Pe({
  __name: "CanvasMenu",
  props: {
    menu: {},
    onImage: { type: Function }
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = /* @__PURE__ */ W(null), s = I(() => t.catalog.value.kits.filter((f) => Bi(f)).map((f) => ({
      id: "kit-" + f.id,
      icon: f.icon,
      label: f.name,
      run: () => {
        const p = Bi(f);
        p && t.pickModel(f, p, e.menu.at);
      }
    }))), o = {
      rect: { label: "Rectangle", icon: "Square", key: "M" },
      ellipse: { label: "Ellipse", icon: "Circle", key: "L" },
      line: { label: "Line", icon: "Slash", key: "\\" },
      arrow: { label: "Arrow", icon: "ArrowUpRight", key: "" }
    }, r = I(() => o[t.ui.shapeKind] || o.rect), a = I(() => {
      const f = e.menu.at, p = [
        { id: "note", icon: "StickyNote", label: "Sticky note", key: "N", plain: !0, run: () => t.addElement("note", f) },
        { id: "frame", icon: "Frame", label: "Frame", key: "F", plain: !0, run: () => t.addElement("frame", f) },
        { id: "shape", icon: r.value.icon, label: r.value.label, key: r.value.key, plain: !0, run: () => {
          l(), t.addShape(f);
        } }
      ];
      if (e.onImage) {
        const y = e.onImage;
        p.push({ id: "image", icon: "ImagePlus", label: "Image from computer", plain: !0, run: () => {
          l(), y(f);
        } });
      }
      return t.hasLibrary && p.push({ id: "library", icon: "Library", label: "Image from Library", plain: !0, run: () => {
        l(), t.openLibrary({ purpose: "place", at: f });
      } }), t.canLinkBoards && p.push({ id: "board-link", icon: "Link2", label: "Link to a board", plain: !0, run: () => t.openBoardLinkMenu(e.menu.x, e.menu.y) }), t.comments.enabled && p.push({ id: "comment", icon: "MessageCirclePlus", label: "Comment", key: "C", plain: !0, run: () => {
        l(), t.comments.startAt(f);
      } }), p;
    }), l = () => {
      t.ui.canvasMenu = null;
    };
    B1(i, () => e.menu, l);
    function d() {
      const f = e.menu.at;
      l(), t.promptLibrary.open(null, { at: f });
    }
    it(() => {
      i.value && i.value.focus({ preventScroll: !0 });
    });
    function c() {
      return i.value ? Array.from(i.value.querySelectorAll(".bd-pm-row")) : [];
    }
    function h(f) {
      const p = f.key;
      if (p === "ArrowDown" || p === "ArrowUp" || p === "Home" || p === "End") {
        f.preventDefault(), f.stopPropagation();
        const y = c(), v = y.indexOf(document.activeElement), x = p === "Home" ? 0 : p === "End" ? y.length - 1 : v < 0 ? p === "ArrowDown" ? 0 : y.length - 1 : (v + (p === "ArrowDown" ? 1 : -1) + y.length) % y.length;
        y[x] && y[x].focus();
      } else if (p === "Escape")
        f.preventDefault(), f.stopPropagation(), l();
      else if (!f.metaKey && !f.ctrlKey && !f.altKey && /^[nfc]$/i.test(p)) {
        f.preventDefault(), f.stopPropagation();
        const y = a.value.find((v) => v.id === { n: "note", f: "frame", c: "comment" }[p.toLowerCase()]);
        y && y.run();
      } else p === "Tab" ? f.preventDefault() : p === "Enter" || p === " " ? f.stopPropagation() : p !== "Shift" && p !== "Meta" && p !== "Control" && p !== "Alt" && l();
    }
    return (f, p) => (g(), b("div", {
      ref_key: "el",
      ref: i,
      class: "bd-pointmenu bd-canvasmenu",
      role: "menu",
      "aria-label": "Add to the board here",
      tabindex: "-1",
      "data-testid": "canvas-menu",
      onKeydown: h,
      onPointerdown: p[3] || (p[3] = Te(() => {
      }, ["stop"])),
      onContextmenu: p[4] || (p[4] = Te(() => {
      }, ["prevent"]))
    }, [
      s.value.length ? (g(), b("div", VF, "New tool session")) : z("", !0),
      (g(!0), b(j, null, ge(s.value, (y) => (g(), b("button", {
        key: y.id,
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-" + y.id,
        onMouseenter: p[0] || (p[0] = (v) => v.currentTarget.focus({ preventScroll: !0 })),
        onClick: (v) => y.run()
      }, [
        u("span", qF, [
          C($, {
            name: y.icon,
            size: 13
          }, null, 8, ["name"])
        ]),
        u("span", KF, E(y.label), 1),
        u("span", YF, [
          C($, {
            name: "Plus",
            size: 12
          })
        ])
      ], 40, WF))), 128)),
      s.value.length ? (g(), b("div", XF)) : z("", !0),
      p[6] || (p[6] = u("div", { class: "bd-pm-eyebrow" }, "Start from a prompt", -1)),
      u("button", {
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-prompts",
        onMouseenter: p[1] || (p[1] = (y) => y.currentTarget.focus({ preventScroll: !0 })),
        onClick: d
      }, [
        u("span", JF, [
          C($, {
            name: "LayoutTemplate",
            size: 13
          })
        ]),
        p[5] || (p[5] = u("span", { class: "lbl" }, "Prompt library", -1))
      ], 32),
      p[7] || (p[7] = u("div", {
        class: "bd-pm-sep",
        role: "separator"
      }, null, -1)),
      (g(!0), b(j, null, ge(a.value, (y) => (g(), b("button", {
        key: y.id,
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-" + y.id,
        onMouseenter: p[2] || (p[2] = (v) => v.currentTarget.focus({ preventScroll: !0 })),
        onClick: (v) => y.run()
      }, [
        u("span", QF, [
          C($, {
            name: y.icon,
            size: 13
          }, null, 8, ["name"])
        ]),
        u("span", eN, E(y.label), 1),
        y.key ? (g(), b("kbd", tN, E(y.key), 1)) : z("", !0)
      ], 40, ZF))), 128))
    ], 544));
  }
}), iN = { class: "am-searchrow sf-searchrow" }, sN = { class: "am-search" }, oN = { class: "v2-dock-filters sf-filters" }, rN = ["onClick"], aN = { class: "sf-kits" }, lN = ["data-i", "title", "aria-label", "data-testid", "onMousemove", "onClick"], dN = { class: "bd-pm-ic sf-kit-ic" }, cN = {
  class: "sf-add",
  "aria-hidden": "true"
}, uN = { class: "nm" }, hN = ["data-i"], pN = { class: "bd-pm-ic is-prompts" }, fN = { class: "sf-eyebrow" }, mN = { class: "n" }, gN = ["data-i", "data-testid", "onMousemove", "onClick"], bN = {
  key: 1,
  class: "busy"
}, vN = { class: "k" }, yN = { class: "sf-meta" }, xN = { class: "rs-name" }, wN = { class: "rs-sub" }, kN = { class: "kind" }, _N = {
  key: 0,
  class: "sf-n"
}, SN = ["title", "aria-label", "aria-pressed", "onClick"], MN = {
  key: 3,
  class: "sf-none"
}, TN = { class: "sf-foot" }, CN = { key: 0 }, IN = 3, Bu = 40, AN = /* @__PURE__ */ Pe({
  __name: "SessionFinder",
  props: {
    menu: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = pn(["enter"])[0], a = /* @__PURE__ */ W(""), l = /* @__PURE__ */ W("all"), d = /* @__PURE__ */ W(0), c = I(() => f8(t.catalog.value.kits.filter((R) => Bi(R)), l.value, a.value)), h = I(() => (t.docRev.value, t.ui.recentIds.length, t.ui.pinnedIds.length, t.recentTools())), f = I(() => h8(h.value, l.value, a.value, (R) => t.isPinned(R))), p = /* @__PURE__ */ W(Bu), y = I(() => f.value.slice(0, p.value));
    function v(R) {
      const D = R.target;
      D.scrollTop + D.clientHeight > D.scrollHeight - 150 && p.value < f.value.length && (p.value += Bu);
    }
    Ee([a, l], () => {
      d.value = 0, p.value = Bu, s.value && (s.value.scrollTop = 0);
    });
    const x = I(() => ["all", "image", "video"].includes(l.value) && p8(a.value)), w = I(() => c.value.length + (x.value ? 1 : 0)), S = I(() => d.value < w.value), M = I(() => !w.value && !f.value.length), _ = () => {
      t.ui.finder = null;
    };
    B1(i, () => e.menu, _, { maxH: 500, fixHeight: !0, keepOnResize: !0 }), it(() => {
      o.value && o.value.focus({ preventScroll: !0 });
    });
    function T() {
      const R = e.menu.at, D = l.value === "image" || l.value === "video" ? l.value : null;
      _(), t.promptLibrary.open(null, { at: R, kind: D });
    }
    function k(R) {
      const D = c.value.length;
      if (R < D) {
        const F = c.value[R], ie = Bi(F);
        ie && t.pickModel(F, ie, e.menu.at);
        return;
      }
      if (R === D && x.value) {
        T();
        return;
      }
      const O = f.value[R - w.value];
      O && (_(), t.openSession(O));
    }
    async function P() {
      await nt();
      const R = s.value && s.value.querySelector('[data-i="' + d.value + '"]');
      R && R.scrollIntoView({ block: "nearest" });
    }
    function A(R) {
      R.stopPropagation();
      const D = R.key, O = w.value;
      if (D === "Escape")
        R.preventDefault(), a.value ? a.value = "" : _();
      else if (D === "ArrowDown" || D === "ArrowUp" || (D === "ArrowLeft" || D === "ArrowRight") && S.value && O > 0) {
        R.preventDefault();
        const F = HF(d.value, D, O, f.value.length, IN);
        F - O >= p.value && (p.value += Bu), d.value = F, P();
      } else D === "Enter" && (R.preventDefault(), k(d.value));
    }
    return (R, D) => (g(), b("div", {
      ref_key: "el",
      ref: i,
      class: "bd-pointmenu bd-finder",
      role: "dialog",
      "aria-label": "Find or start a tool session",
      "data-testid": "session-finder",
      onPointerdown: D[10] || (D[10] = Te(() => {
      }, ["stop"])),
      onContextmenu: D[11] || (D[11] = Te(() => {
      }, ["prevent"]))
    }, [
      u("div", iN, [
        u("div", sN, [
          C($, {
            name: "Search",
            size: 13
          }),
          _t(u("input", {
            ref_key: "inputEl",
            ref: o,
            "onUpdate:modelValue": D[0] || (D[0] = (O) => a.value = O),
            type: "text",
            placeholder: "Search sessions and generators",
            "aria-label": "Search sessions and generators",
            "data-testid": "session-finder-search",
            onKeydown: A
          }, null, 544), [
            [Zt, a.value]
          ]),
          a.value ? (g(), b("button", {
            key: 0,
            class: "cv-iconbtn",
            style: { width: "22px", height: "22px" },
            title: "Clear",
            onMousedown: D[1] || (D[1] = Te(() => {
            }, ["prevent"])),
            onClick: D[2] || (D[2] = (O) => a.value = "")
          }, [
            C($, {
              name: "X",
              size: 11
            })
          ], 32)) : z("", !0)
        ]),
        u("button", {
          class: "am-close",
          title: "Close",
          onClick: _
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      u("div", oN, [
        (g(!0), b(j, null, ge(m(lm), (O) => (g(), b("button", {
          key: O.id,
          class: G(["v2-fchip", { on: l.value === O.id }]),
          onMousedown: D[3] || (D[3] = Te(() => {
          }, ["prevent"])),
          onClick: (F) => l.value = O.id
        }, E(O.label), 43, rN))), 128))
      ]),
      u("div", {
        ref_key: "body",
        ref: s,
        class: "sf-body",
        onScrollPassive: v
      }, [
        c.value.length ? (g(), b(j, { key: 0 }, [
          D[12] || (D[12] = u("div", { class: "sf-eyebrow" }, "New tool session", -1)),
          u("div", aN, [
            (g(!0), b(j, null, ge(c.value, (O, F) => (g(), b("button", {
              key: O.id,
              class: G(["sf-kit", { "is-active": d.value === F }]),
              "data-i": F,
              title: O.desc,
              "aria-label": "New " + O.name + " session",
              "data-testid": "finder-kit-" + O.id,
              onMousemove: (ie) => d.value = F,
              onMousedown: D[4] || (D[4] = Te(() => {
              }, ["prevent"])),
              onClick: (ie) => k(F)
            }, [
              u("span", dN, [
                C($, {
                  name: O.icon,
                  size: 13
                }, null, 8, ["name"]),
                u("span", cN, [
                  C($, {
                    name: "Plus",
                    size: 9
                  })
                ])
              ]),
              u("span", uN, E(O.name), 1)
            ], 42, lN))), 128))
          ])
        ], 64)) : z("", !0),
        x.value ? (g(), b(j, { key: 1 }, [
          D[15] || (D[15] = u("div", { class: "sf-eyebrow" }, "Start from a prompt", -1)),
          u("button", {
            class: G(["sf-prompts", { "is-active": d.value === c.value.length }]),
            "data-i": c.value.length,
            title: "Featured prompts and your saved ones",
            "data-testid": "finder-prompts",
            onMousemove: D[5] || (D[5] = (O) => d.value = c.value.length),
            onMousedown: D[6] || (D[6] = Te(() => {
            }, ["prevent"])),
            onClick: D[7] || (D[7] = (O) => k(c.value.length))
          }, [
            u("span", pN, [
              C($, {
                name: "LayoutTemplate",
                size: 13
              })
            ]),
            D[13] || (D[13] = u("span", { class: "nm" }, "Prompt library", -1)),
            D[14] || (D[14] = u("span", { class: "sub" }, "Featured prompts and your saved ones", -1))
          ], 42, hN)
        ], 64)) : z("", !0),
        f.value.length ? (g(), b(j, { key: 2 }, [
          u("div", fN, [
            D[16] || (D[16] = Y("Tool sessions", -1)),
            u("span", mN, E(f.value.length), 1)
          ]),
          (g(!0), b(j, null, ge(y.value, (O, F) => (g(), b("div", {
            key: O.id,
            class: G(["sf-item", { "is-active": d.value === w.value + F, "is-pinned": m(t).isPinned(O.id) }])
          }, [
            u("button", {
              class: "sf-row",
              "data-i": w.value + F,
              "data-testid": "finder-session-" + O.id,
              onMousemove: (ie) => d.value = w.value + F,
              onMousedown: D[8] || (D[8] = Te(() => {
              }, ["prevent"])),
              onClick: (ie) => k(w.value + F)
            }, [
              u("span", {
                class: "rs-shot",
                style: ce(O.thumbs && O.thumbs.length ? { backgroundImage: 'url("' + m(Bt)(O.thumbs[0]) + '")' } : void 0)
              }, [
                !O.thumbs || !O.thumbs.length ? (g(), Ie($, {
                  key: 0,
                  name: O.icon,
                  size: 15
                }, null, 8, ["name"])) : z("", !0),
                m(t).generating[O.id] ? (g(), b("span", bN)) : z("", !0),
                u("span", vN, [
                  C($, {
                    name: O.icon,
                    size: 9
                  }, null, 8, ["name"])
                ])
              ], 4),
              u("span", yN, [
                u("span", xN, E(O.name), 1),
                u("span", wN, [
                  u("span", kN, E(O.kind), 1),
                  O.model ? (g(), b(j, { key: 0 }, [
                    D[17] || (D[17] = u("span", { class: "sep" }, "·", -1)),
                    Y(E(O.model), 1)
                  ], 64)) : z("", !0)
                ])
              ]),
              O.count ? (g(), b("span", _N, E(O.count), 1)) : z("", !0)
            ], 40, gN),
            u("button", {
              class: G(["sf-pin", { on: m(t).isPinned(O.id) }]),
              title: m(t).isPinned(O.id) ? "Unpin" : "Pin to the top",
              "aria-label": (m(t).isPinned(O.id) ? "Unpin " : "Pin ") + O.name,
              "aria-pressed": m(t).isPinned(O.id),
              tabindex: "-1",
              onMousedown: D[9] || (D[9] = Te(() => {
              }, ["prevent"])),
              onClick: Te((ie) => m(t).togglePinned(O.id), ["stop"])
            }, [
              C($, {
                name: "Pin",
                size: 12
              })
            ], 42, SN)
          ], 2))), 128))
        ], 64)) : z("", !0),
        M.value ? (g(), b("div", MN, E(a.value.trim() ? "Nothing matches “" + a.value.trim() + "”" : l.value === "pinned" ? "Nothing pinned yet. Pin a session to keep it at the top." : "No tool sessions match"), 1)) : z("", !0)
      ], 544),
      u("div", TN, [
        D[18] || (D[18] = u("span", null, [
          u("kbd", null, "↑"),
          u("kbd", null, "↓"),
          Y("Move")
        ], -1)),
        M.value ? z("", !0) : (g(), b("span", CN, [
          u("kbd", null, E(m(r)), 1),
          Y(E(S.value ? "Start here" : "Open"), 1)
        ])),
        D[19] || (D[19] = u("span", null, [
          u("kbd", null, "Esc"),
          Y("Close")
        ], -1))
      ])
    ], 544));
  }
}), PN = { class: "am-searchrow sf-searchrow" }, EN = { class: "am-search" }, RN = { class: "sf-eyebrow" }, zN = {
  key: 0,
  class: "n"
}, $N = {
  key: 0,
  class: "sf-none"
}, DN = {
  key: 1,
  class: "sf-none"
}, ON = ["data-i", "data-testid", "onMousemove", "onClick"], LN = { class: "bl-ic" }, BN = { class: "sf-meta" }, FN = { class: "rs-name" }, NN = { class: "rs-sub" }, UN = ["data-i"], GN = { class: "bl-ic" }, jN = { class: "sf-meta" }, HN = { class: "rs-name" }, VN = {
  key: 3,
  class: "sf-none"
}, WN = /* @__PURE__ */ Pe({
  __name: "BoardLinkMenu",
  props: {
    menu: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(""), a = /* @__PURE__ */ W(0), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(!1), c = /* @__PURE__ */ W(!1), h = I(() => {
      t.docRev.value;
      const T = /* @__PURE__ */ new Set();
      for (const k of t.store.all()) k.type === "note" && k.link && T.add(k.link.boardId);
      return T;
    }), f = I(() => {
      const T = l.value || [], k = r.value.trim().toLowerCase();
      return k ? T.filter((P) => P.title.toLowerCase().includes(k)) : T;
    }), p = I(() => !!r.value.trim() && !f.value.some((T) => T.title.trim().toLowerCase() === r.value.trim().toLowerCase())), y = I(() => f.value.length + (p.value ? 1 : 0)), v = () => {
      t.ui.boardLinkMenu = null;
    };
    B1(i, () => e.menu, v, { maxH: 440, fixHeight: !0, keepOnResize: !0 }), it(async () => {
      o.value && o.value.focus({ preventScroll: !0 });
      try {
        l.value = await t.linkableBoards();
      } catch (T) {
        console.error("[board] boards not listed", T), d.value = !0, l.value = [];
      }
    });
    let x = 0, w = 0;
    Ee(r, (T) => {
      a.value = 0, s.value && (s.value.scrollTop = 0), clearTimeout(x), x = window.setTimeout(async () => {
        const k = ++w;
        try {
          const P = await t.linkableBoards(T);
          k === w && (l.value = P);
        } catch (P) {
          console.error("[board] boards not searched", P);
        }
      }, 250);
    }), We(() => clearTimeout(x));
    async function S(T) {
      if (c.value) return;
      const k = f.value[T];
      if (k) {
        v(), t.addBoardLink({ id: k.id, title: k.title }, e.menu.at);
        return;
      }
      if (p.value && T === f.value.length) {
        c.value = !0;
        const P = e.menu.at, A = r.value.trim();
        v(), await t.addNewBoardLink(A, P);
      }
    }
    async function M() {
      await nt();
      const T = s.value && s.value.querySelector('[data-i="' + a.value + '"]');
      T && T.scrollIntoView({ block: "nearest" });
    }
    function _(T) {
      T.stopPropagation();
      const k = T.key;
      if (k === "Escape")
        T.preventDefault(), r.value ? r.value = "" : v();
      else if (k === "ArrowDown" || k === "ArrowUp") {
        if (T.preventDefault(), !y.value) return;
        a.value = (a.value + (k === "ArrowDown" ? 1 : -1) + y.value) % y.value, M();
      } else k === "Enter" && (T.preventDefault(), S(a.value));
    }
    return (T, k) => (g(), b("div", {
      ref_key: "el",
      ref: i,
      class: "bd-pointmenu bd-finder bd-linkmenu",
      role: "dialog",
      "aria-label": "Link to a board",
      "data-testid": "board-link-menu",
      onPointerdown: k[5] || (k[5] = Te(() => {
      }, ["stop"])),
      onContextmenu: k[6] || (k[6] = Te(() => {
      }, ["prevent"]))
    }, [
      u("div", PN, [
        u("div", EN, [
          C($, {
            name: "Search",
            size: 13
          }),
          _t(u("input", {
            ref_key: "inputEl",
            ref: o,
            "onUpdate:modelValue": k[0] || (k[0] = (P) => r.value = P),
            type: "text",
            placeholder: "Find a board, or name a new one",
            "aria-label": "Find a board, or name a new one",
            "data-testid": "board-link-search",
            onKeydown: _
          }, null, 544), [
            [Zt, r.value]
          ])
        ]),
        u("button", {
          class: "am-close",
          title: "Close",
          onClick: v
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      u("div", {
        ref_key: "body",
        ref: s,
        class: "sf-body"
      }, [
        u("div", RN, [
          k[7] || (k[7] = Y("Link to a board ", -1)),
          l.value ? (g(), b("span", zN, E(l.value.length), 1)) : z("", !0)
        ]),
        l.value ? d.value ? (g(), b("div", DN, "Your boards couldn't be listed. You can still name a new one.")) : z("", !0) : (g(), b("div", $N, "Finding your boards…")),
        (g(!0), b(j, null, ge(f.value, (P, A) => (g(), b("div", {
          key: P.id,
          class: G(["sf-item", { "is-active": a.value === A }])
        }, [
          u("button", {
            class: "sf-row bl-row",
            "data-i": A,
            "data-testid": "board-link-pick-" + P.id,
            onMousemove: (R) => a.value = A,
            onMousedown: k[1] || (k[1] = Te(() => {
            }, ["prevent"])),
            onClick: (R) => S(A)
          }, [
            u("span", LN, [
              C($, {
                name: "LayoutDashboard",
                size: 14
              })
            ]),
            u("span", BN, [
              u("span", FN, E(P.title), 1),
              u("span", NN, E(h.value.has(P.id) ? "Linked here already" : P.at ? "Updated " + m(Jn)(P.at) : "Board"), 1)
            ])
          ], 40, ON)
        ], 2))), 128)),
        p.value ? (g(), b("div", {
          key: 2,
          class: G(["sf-item", { "is-active": a.value === f.value.length }])
        }, [
          u("button", {
            class: "sf-row bl-row is-new",
            "data-i": f.value.length,
            "data-testid": "board-link-new",
            onMousemove: k[2] || (k[2] = (P) => a.value = f.value.length),
            onMousedown: k[3] || (k[3] = Te(() => {
            }, ["prevent"])),
            onClick: k[4] || (k[4] = (P) => S(f.value.length))
          }, [
            u("span", GN, [
              C($, {
                name: "Plus",
                size: 14
              })
            ]),
            u("span", jN, [
              u("span", HN, "New board: " + E(r.value.trim()), 1),
              k[8] || (k[8] = u("span", { class: "rs-sub" }, "Made now, and linked here", -1))
            ])
          ], 40, UN)
        ], 2)) : z("", !0),
        l.value && !d.value && !f.value.length && !p.value ? (g(), b("div", VN, E(l.value.length ? "No board by that name." : "No other boards yet. Type a name to make one."), 1)) : z("", !0)
      ], 512),
      k[9] || (k[9] = u("div", { class: "sf-foot" }, [
        u("span", null, "Its card opens the board, which links back here")
      ], -1))
    ], 544));
  }
});
function Ro(n) {
  return !!n && n.type === "frame" && !!n.locked;
}
const qN = [
  { id: "amethyst", label: "Amethyst" },
  { id: "vista", label: "Vista" },
  { id: "sky", label: "Sky" },
  { id: "mint", label: "Mint" },
  { id: "amber", label: "Amber" },
  { id: "rose", label: "Rose" },
  { id: "glass", label: "Glass" }
], Fu = { w: 248, h: 124 }, Rt = { w: 252, h: 160 }, Nc = 64;
function He(n) {
  if (n.type === "tool") {
    const e = n.scale || 1;
    return { x: n.x, y: n.y, w: Math.round(Rt.w * e), h: Math.round((n.collapsed ? Nc : Rt.h) * e) };
  }
  return n.type === "chat" && n.collapsed ? { x: n.x, y: n.y, w: n.w, h: Nc } : { x: n.x, y: n.y, w: n.w, h: n.h };
}
function Ya(n, e) {
  return n.x < e.x + e.w && n.x + n.w > e.x && n.y < e.y + e.h && n.y + n.h > e.y;
}
function uc(n) {
  if (!n.length) return null;
  let e = 1 / 0, t = 1 / 0, i = -1 / 0, s = -1 / 0;
  for (const o of n)
    o.x < e && (e = o.x), o.y < t && (t = o.y), o.x + o.w > i && (i = o.x + o.w), o.y + o.h > s && (s = o.y + o.h);
  return { x: e, y: t, w: i - e, h: s - t };
}
const Iv = {
  frame: "frames",
  image: "content",
  shape: "annotations",
  note: "annotations",
  tool: "annotations",
  chat: "annotations",
  // never in the store (studio/records.ts); named so the table stays whole
  studio: "annotations"
}, Ri = { w: 252, h: 160 }, KN = 0.01, YN = 4;
function tr(n) {
  return Number.isFinite(n) ? Math.min(YN, Math.max(KN, n)) : 1;
}
function Av(n, e, t) {
  return { x: (e - n.x) / n.zoom, y: (t - n.y) / n.zoom };
}
function Pv(n, e, t, i) {
  const s = tr(n.zoom * i), o = s / n.zoom;
  return { zoom: s, x: e - (e - n.x) * o, y: t - (t - n.y) * o };
}
function XN(n, e) {
  const t = tr(n * e), i = 5e-3;
  return n < 1 - i && t > 1 || n > 1 + i && t < 1 ? 1 : t;
}
function dm(n, e, t, i = 120, s = 1) {
  const o = Math.max(1, n.w), r = Math.max(1, n.h), a = tr(Math.min(s, (e - i * 2) / o, (t - i * 2) / r));
  return {
    zoom: a,
    x: (e - o * a) / 2 - n.x * a,
    y: (t - r * a) / 2 - n.y * a
  };
}
function rl(n, e, t, i, s) {
  const o = tr(t);
  return { zoom: o, x: i / 2 - n * o, y: s / 2 - e * o };
}
function fl(n, e, t, i = 0) {
  const s = i / n.zoom;
  return {
    x: -n.x / n.zoom - s,
    y: -n.y / n.zoom - s,
    w: e / n.zoom + s * 2,
    h: t / n.zoom + s * 2
  };
}
function tg(n) {
  return JN(0.16, 1, 0.3, 1, n);
}
function JN(n, e, t, i, s) {
  let o = s;
  for (let r = 0; r < 6; r++) {
    const a = Bw(n, t, o) - s, l = ZN(n, t, o);
    if (Math.abs(a) < 1e-5 || Math.abs(l) < 1e-6) break;
    o -= a / l;
  }
  return o = Math.min(1, Math.max(0, o)), Bw(e, i, o);
}
function Bw(n, e, t) {
  return ((1 - 3 * e + 3 * n) * t + (3 * e - 6 * n)) * t * t + 3 * n * t;
}
function ZN(n, e, t) {
  return 3 * (1 - 3 * e + 3 * n) * t * t + 2 * (3 * e - 6 * n) * t + 3 * n;
}
function QN(n, e, t, i, s) {
  const o = Av(n, i / 2, s / 2), r = Av(e, i / 2, s / 2), a = Math.exp(Math.log(n.zoom) + (Math.log(e.zoom) - Math.log(n.zoom)) * t), l = o.x + (r.x - o.x) * t, d = o.y + (r.y - o.y) * t;
  return { zoom: a, x: i / 2 - l * a, y: s / 2 - d * a };
}
const ld = 188, Nu = 124, Fw = 28, eU = /* @__PURE__ */ Pe({
  __name: "Minimap",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(null), i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(!1), o = /* @__PURE__ */ qe(null);
    let r = 0;
    function a() {
      !e.engine || e.view.w < 2 || e.view.h < 2 || (o.value = fl(e.cam.value, e.view.w, e.view.h, 0));
    }
    Ee(() => e.cam.value, () => {
      if (!o.value) {
        a();
        return;
      }
      clearTimeout(r), r = window.setTimeout(a, 240);
    }, { immediate: !0 });
    const l = I(() => {
      e.docRev.value;
      const S = e.store.bounds(), M = o.value;
      let _ = S || M || { x: 0, y: 0, w: 1200, h: 800 };
      if (S && M) {
        const O = Math.min(S.x, M.x), F = Math.min(S.y, M.y);
        _ = { x: O, y: F, w: Math.max(S.x + S.w, M.x + M.w) - O, h: Math.max(S.y + S.h, M.y + M.h) - F };
      }
      const T = Math.max(80, Math.max(_.w, _.h) * 0.06), k = _.x - T, P = _.y - T, A = _.w + T * 2, R = _.h + T * 2, D = Math.min(ld / A, Nu / R);
      return { bx: k, by: P, k: D, ox: (ld - A * D) / 2, oy: (Nu - R * D) / 2 };
    }), d = I(() => {
      const S = l.value, M = e.cam.value, _ = -M.x / M.zoom, T = -M.y / M.zoom;
      return {
        left: (_ - S.bx) * S.k + S.ox,
        top: (T - S.by) * S.k + S.oy,
        width: e.view.w / M.zoom * S.k,
        height: e.view.h / M.zoom * S.k
      };
    });
    let c = 0, h = 0;
    function f() {
      if (c) return;
      const S = Math.max(0, 90 - (performance.now() - h));
      c = window.setTimeout(() => {
        c = 0, h = performance.now(), p();
      }, S);
    }
    function p() {
      const S = t.value;
      if (!S) return;
      const M = Math.min(2, window.devicePixelRatio || 1);
      S.width !== ld * M && (S.width = ld * M, S.height = Nu * M);
      const _ = S.getContext("2d");
      if (!_) return;
      _.setTransform(M, 0, 0, M, 0, 0), _.clearRect(0, 0, ld, Nu);
      const T = l.value, k = e.ui.lightCanvas, P = [];
      for (const A of e.store.all()) {
        const R = He(A), D = (R.x - T.bx) * T.k + T.ox, O = (R.y - T.by) * T.k + T.oy, F = Math.max(2, R.w * T.k), ie = Math.max(2, R.h * T.k), ee = A.type === "frame" ? 0 : A.type === "image" ? 1 : 2;
        P.push([ee, () => {
          A.type === "frame" ? (_.fillStyle = k ? "rgba(19,24,40,0.05)" : "rgba(255,255,255,0.08)", _.fillRect(D, O, F, ie), _.strokeStyle = k ? "rgba(19,24,40,0.16)" : "rgba(255,255,255,0.14)", _.lineWidth = 1, _.strokeRect(D + 0.5, O + 0.5, F - 1, ie - 1)) : A.type === "shape" ? (_.strokeStyle = A.stroke || (k ? "rgba(19,24,40,0.35)" : "rgba(255,255,255,0.3)"), _.lineWidth = 1, _.strokeRect(D + 0.5, O + 0.5, Math.max(1, F - 1), Math.max(1, ie - 1))) : (_.fillStyle = A.type === "tool" ? "rgba(153,104,223,0.65)" : A.type === "chat" ? "rgba(194,164,236,0.8)" : A.type === "note" ? "rgba(163,167,245,0.55)" : k ? "rgba(19,24,40,0.28)" : "rgba(255,255,255,0.30)", _.fillRect(D, O, F, ie));
        }]);
      }
      P.sort((A, R) => A[0] - R[0]);
      for (const A of P) A[1]();
    }
    Ee(() => e.docRev.value, f), Ee(() => e.ui.lightCanvas, f), Ee(l, f), it(() => {
      a(), p();
    }), We(() => {
      clearTimeout(c), clearTimeout(r);
    });
    function y(S) {
      const M = i.value;
      if (!M) return;
      const _ = M.getBoundingClientRect(), T = l.value, k = (S.clientX - _.left - T.ox) / T.k + T.bx, P = (S.clientY - _.top - T.oy) / T.k + T.by, A = e.cam.value;
      e.setCamera({ zoom: A.zoom, x: e.view.w / 2 - k * A.zoom, y: e.view.h / 2 - P * A.zoom });
    }
    function v(S) {
      e.ui.miniGoing || (s.value = !0, S.currentTarget.setPointerCapture(S.pointerId), y(S));
    }
    function x() {
      const S = i.value, M = S && S.parentElement ? S.parentElement.querySelector(".cv-zoomhud") : null;
      if (!S || !M) {
        e.ui.miniOpen = !1;
        return;
      }
      const _ = S.getBoundingClientRect(), T = M.getBoundingClientRect(), k = T.right - 5 - Fw / 2 - (_.left + _.width / 2), P = T.top + T.height / 2 - (_.top + _.height / 2);
      e.ui.miniGoing = !0, S.classList.add("is-going"), S.offsetWidth, S.style.transform = "translate(" + k + "px, " + P + "px) scale(" + (Fw / _.width).toFixed(3) + ")", S.style.opacity = "0", S.style.borderRadius = "40px";
    }
    function w(S) {
      e.ui.miniGoing && S.propertyName === "transform" && (e.ui.miniOpen = !1, e.ui.miniGoing = !1);
    }
    return (S, M) => (g(), b("div", {
      ref_key: "self",
      ref: i,
      class: "cv-minimap",
      "data-testid": "minimap",
      onTransitionend: w,
      onPointerdown: Te(v, ["stop"]),
      onPointermove: M[1] || (M[1] = (_) => s.value && y(_)),
      onPointerup: M[2] || (M[2] = (_) => s.value = !1),
      onPointercancel: M[3] || (M[3] = (_) => s.value = !1)
    }, [
      u("canvas", {
        ref_key: "canvas",
        ref: t
      }, null, 512),
      u("button", {
        class: "mm-hide",
        title: "Hide minimap",
        onPointerdown: M[0] || (M[0] = Te(() => {
        }, ["stop"])),
        onClick: Te(x, ["stop"])
      }, [
        C($, {
          name: "Minus",
          size: 12
        })
      ], 32),
      u("span", {
        class: "mm-view",
        style: ce({ left: d.value.left + "px", top: d.value.top + "px", width: d.value.width + "px", height: d.value.height + "px" })
      }, null, 4)
    ], 544));
  }
}), tU = ["title", "aria-label"], nU = ["title", "aria-label", "aria-pressed"], iU = ["disabled"], sU = /* @__PURE__ */ Pe({
  __name: "ZoomHud",
  setup(n) {
    const { board: e } = Ze(), t = I(() => Math.round(e.cam.value.zoom * 100) + "%");
    return (i, s) => (g(), b("div", {
      class: "cv-zoomhud",
      "data-testid": "zoom-hud",
      onPointerdown: s[7] || (s[7] = Te(() => {
      }, ["stop"])),
      onClick: s[8] || (s[8] = //@ts-ignore
      (...o) => m(sf) && m(sf)(...o))
    }, [
      u("button", {
        title: "Zoom out",
        "aria-label": "Zoom out",
        onClick: s[0] || (s[0] = (o) => m(e).zoomBy(1 / 1.25))
      }, [
        C($, {
          name: "Minus",
          size: 14
        })
      ]),
      u("button", {
        class: "pct",
        title: "Reset to 100%",
        "data-testid": "zoom-pct",
        onClick: s[1] || (s[1] = (o) => m(e).zoomTo(1))
      }, E(t.value), 1),
      u("button", {
        title: "Zoom in",
        "aria-label": "Zoom in",
        onClick: s[2] || (s[2] = (o) => m(e).zoomBy(1.25))
      }, [
        C($, {
          name: "Plus",
          size: 14
        })
      ]),
      u("button", {
        title: "Fit to content",
        "aria-label": "Fit to content",
        onClick: s[3] || (s[3] = (o) => m(e).fit())
      }, [
        C($, {
          name: "Scan",
          size: 14
        })
      ]),
      s[10] || (s[10] = u("span", { class: "sep" }, null, -1)),
      u("button", {
        title: m(e).ui.lightCanvas ? "Dark board" : "Light board",
        "aria-label": m(e).ui.lightCanvas ? "Dark board" : "Light board",
        "data-testid": "light-toggle",
        onClick: s[4] || (s[4] = (o) => m(e).ui.lightCanvas = !m(e).ui.lightCanvas)
      }, [
        C($, {
          name: m(e).ui.lightCanvas ? "Moon" : "Sun",
          size: 14
        }, null, 8, ["name"])
      ], 8, tU),
      u("button", {
        class: G(["grid-toggle", { "is-off": !m(e).ui.showGrid }]),
        title: m(e).ui.showGrid ? "Hide grid" : "Show grid",
        "aria-label": m(e).ui.showGrid ? "Hide grid" : "Show grid",
        "aria-pressed": m(e).ui.showGrid,
        "data-testid": "grid-toggle",
        onClick: s[5] || (s[5] = (o) => m(e).ui.showGrid = !m(e).ui.showGrid)
      }, [
        C($, {
          name: "Grid3x3",
          size: 14
        })
      ], 10, nU),
      !m(e).ui.miniOpen || m(e).ui.miniGoing ? (g(), b(j, { key: 0 }, [
        s[9] || (s[9] = u("span", { class: "sep" }, null, -1)),
        u("button", {
          class: G(["mm-slot", { "is-landing": m(e).ui.miniGoing }]),
          disabled: m(e).ui.miniGoing,
          title: "Show minimap",
          "aria-label": "Show minimap",
          onClick: s[6] || (s[6] = (o) => m(e).ui.miniOpen = !0)
        }, [
          C($, {
            name: "Map",
            size: 14
          })
        ], 10, iU)
      ], 64)) : z("", !0)
    ], 32));
  }
}), io = { stroke: "#9968df", sw: 3 };
function cm(n) {
  const e = Math.max(0, n.w), t = Math.max(0, n.h), i = n.sc || [0, 0];
  return { x1: i[0] * e, y1: i[1] * t, x2: (1 - i[0]) * e, y2: (1 - i[1]) * t };
}
function m8(n) {
  const { x1: e, y1: t, x2: i, y2: s } = cm(n), o = n.sw == null ? io.sw : n.sw, r = Math.atan2(s - t, i - e), a = Math.max(11, o * 3.6), l = 0.44;
  return [
    [i - a * Math.cos(r - l), s - a * Math.sin(r - l)],
    [i, s],
    [i - a * Math.cos(r + l), s - a * Math.sin(r + l)]
  ];
}
function oU(n) {
  return /^#[0-9a-f]{6}$/i.test(n) ? parseInt(n.slice(1), 16) : /^#[0-9a-f]{3}$/i.test(n) ? parseInt(n.slice(1).split("").map((e) => e + e).join(""), 16) : 10053855;
}
function Nw(n, e) {
  const t = Math.max(0, e.w), i = Math.max(0, e.h), s = e.sw == null ? io.sw : e.sw, o = oU(e.stroke || io.stroke), r = { width: s, color: o, cap: "round", join: "round" };
  if (n.clear(), e.shape === "rect")
    n.roundRect(0, 0, t, i, Math.min(10, t / 8, i / 8)), n.stroke(r);
  else if (e.shape === "ellipse")
    n.ellipse(t / 2, i / 2, Math.max(0.01, t / 2), Math.max(0.01, i / 2)), n.stroke(r);
  else {
    const { x1: a, y1: l, x2: d, y2: c } = cm(e);
    if (n.moveTo(a, l), n.lineTo(d, c), n.stroke(r), e.shape === "arrow") {
      const h = m8(e);
      n.moveTo(h[0][0], h[0][1]), n.lineTo(h[1][0], h[1][1]), n.lineTo(h[2][0], h[2][1]), n.stroke(r);
    }
  }
}
function ng(n, e, t, i, s, o) {
  const r = s - t, a = o - i, l = r * r + a * a;
  let d = l ? ((n - t) * r + (e - i) * a) / l : 0;
  d = Math.max(0, Math.min(1, d));
  const c = t + d * r, h = i + d * a;
  return Math.hypot(n - c, e - h);
}
function rU(n, e, t, i) {
  const s = e - n.x, o = t - n.y, r = Math.max(0, n.w), a = Math.max(0, n.h);
  if (n.shape === "rect") {
    const f = s >= -i && o >= -i && s <= r + i && o <= a + i, p = s > i && o > i && s < r - i && o < a - i;
    return f && !p;
  }
  if (n.shape === "ellipse") {
    const f = Math.max(0.01, r / 2), p = Math.max(0.01, a / 2), y = s - f, v = o - p, x = y * y / (f * f) + v * v / (p * p) - 1, w = 2 * y / (f * f), S = 2 * v / (p * p), M = Math.hypot(w, S);
    return M ? Math.abs(x) / M <= i : Math.min(f, p) <= i;
  }
  const { x1: l, y1: d, x2: c, y2: h } = cm(n);
  if (ng(s, o, l, d, c, h) <= i) return !0;
  if (n.shape === "arrow") {
    const f = m8(n);
    if (ng(s, o, f[0][0], f[0][1], f[1][0], f[1][1]) <= i || ng(s, o, f[1][0], f[1][1], f[2][0], f[2][1]) <= i) return !0;
  }
  return !1;
}
const Xn = {
  /** a pin control, off */
  pin: "Pin for yourself (only you see your pins)",
  /** a pin control, on */
  unpin: "Unpin",
  /** the badge on a pinned picture */
  badge: "Pinned by you (only you see it)",
  /** the toast on your first pin, once */
  first: "Pinned for you. Only you see your pins: find them under Pinned in the board's history."
};
function um(n) {
  return {
    url: n.url,
    w: n.w,
    h: n.h,
    label: n.label || n.prompt || "Result",
    asset: n.asset || null,
    resultId: n.id,
    sessionId: n.sessionId,
    video: !!n.video,
    videoSrc: n.videoSrc || null,
    dur: n.dur || null
  };
}
function g8(n, e) {
  if (e && e.url === n.src) return um(e);
  const t = ba(n.asset);
  return {
    url: n.src,
    w: t ? t.width : n.w,
    h: t ? t.height : n.h,
    label: n.label || "Image",
    asset: n.asset || null,
    resultId: n.resultId || null,
    sessionId: n.sessionId || null,
    video: !!n.video,
    videoSrc: n.videoSrc || null,
    dur: n.dur || null
  };
}
function aU(n) {
  return {
    url: n.url,
    w: n.w || 4,
    h: n.h || 3,
    label: n.label || "Image",
    asset: n.asset || null,
    video: !!n.video,
    videoSrc: n.video && n.videoSrc || null
  };
}
const lU = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function wt() {
  const n = new Uint8Array(20);
  crypto.getRandomValues(n);
  let e = "";
  for (let t = 0; t < 20; t++) e += lU[n[t] % 62];
  return e;
}
var dU = Object.defineProperty, cU = (n, e, t) => e in n ? dU(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Uu = (n, e, t) => cU(n, typeof e != "symbol" ? e + "" : e, t);
function uU(n, e = 30) {
  const t = /^(\d+(?:\.\d+)?)\s*(s|m)$/.exec((n || "").trim());
  return t ? Math.round(Number(t[1]) * (t[2] === "m" ? 60 : 1)) : e;
}
function Rl(n) {
  return String(n || "").toLowerCase().replace(/[^a-z0-9.\s]+/g, " ").replace(/\s+/g, " ").trim();
}
function hU(n) {
  return n.fields.find((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images")) || null;
}
class b8 {
  constructor(e, t = !1) {
    Uu(this, "catalog", e), Uu(this, "isAdmin", t), Uu(this, "list", []), Uu(this, "byIdMap", /* @__PURE__ */ new Map());
    for (const i of e.kits)
      for (const s of i.models) {
        const o = this.byIdMap.get(s.id);
        if (o) {
          o.kits.push(i);
          continue;
        }
        const r = hU(s), a = {
          id: s.id,
          name: s.name,
          desc: s.desc,
          model: s,
          kits: [i],
          imageField: r,
          maxImages: r ? r.kind === "images" ? Math.max(1, r.maxImages || 4) : 1 : 0,
          needsImage: !!r && !!r.required,
          secs: uU(s.time)
        };
        this.byIdMap.set(s.id, a), this.list.push(a);
      }
  }
  entries() {
    return this.list;
  }
  get(e) {
    return this.byIdMap.get(e) || null;
  }
  /** It's on this board's tool list. */
  has(e) {
    return this.byIdMap.has(e);
  }
  /**
   * Tools whose names match what someone typed: every word they typed starts
   * a word of the name ("chatgpt image 2.5" finds both ChatGPT Image 2.5
   * tools, "flux 3" finds Flux 3 Image). Exact names first, then shorter ones.
   */
  search(e) {
    const t = Rl(e);
    if (!t) return [];
    const i = t.split(" "), s = [];
    for (const o of this.list) {
      const r = Rl(o.name);
      if (r === t) {
        s.push({ e: o, score: 0 });
        continue;
      }
      const a = r.split(" ");
      i.every((d) => a.some((c) => c.startsWith(d))) && s.push({ e: o, score: 1 + a.length - i.length });
    }
    return s.sort((o, r) => o.score - r.score || o.e.name.localeCompare(r.e.name)).map((o) => o.e);
  }
  /** The kit a job wants it in: an edit in Image Edit, a new picture in Image, else its first. */
  kitFor(e, t) {
    const i = t === "edit" ? ["imageEdit", "image"] : ["image", "imageEdit"];
    for (const s of i) {
      const o = e.kits.find((r) => r.id === s);
      if (o) return o;
    }
    return e.kits[0];
  }
  /** What `runs` runs of `n` results cost with this prompt state, in tokens (the price rules v1's Run button uses); null when it has none. */
  price(e, t, i, s = 1) {
    const o = Xi(e.model, t, i, this.isAdmin).price;
    return o == null ? null : o * s / 100;
  }
  /** Why a run of this prompt state couldn't go (a required field, a bad value); empty when it can. */
  problems(e, t, i) {
    return Xi(e.model, t, i, this.isAdmin).problems;
  }
  /** The results a run makes: n clamped to what the tool allows. */
  results(e, t) {
    const i = e.model.numResults;
    return Math.max(i.min, Math.min(i.max, Math.round(t) || i.def || 1));
  }
  /** A field by its label ("Quality"), any case. */
  field(e, t) {
    const i = t.trim().toLowerCase();
    return e.model.fields.find((s) => (s.label || "").trim().toLowerCase() === i) || null;
  }
  /** The size option nearest an image's shape, in the size tier the tool starts at. */
  sizeFor(e, t, i) {
    const s = e.model.fields.find((x) => x.kind === "size" && x.options && x.options.length);
    if (!s || !s.options || !t || !i) return null;
    const o = (x) => {
      const w = x;
      return w && w.width && w.height ? w.width * w.height : 0;
    }, r = (x) => {
      const w = x;
      return w && w.width && w.height ? w.width / w.height : 1;
    }, a = s.defaultValue != null ? s.defaultValue : s.options[0].value, l = s.options.find((x) => xn(x.value) === xn(a)), d = l ? (/^(\d+(?:\.\d+)?K)\b/i.exec(l.label) || [])[1] : void 0, c = o(a), h = d ? s.options.filter((x) => x.label.toUpperCase().startsWith(d.toUpperCase() + " ")) : [], f = s.options.filter((x) => c && Math.abs(o(x.value) - c) / c < 0.34), p = h.length ? h : f.length ? f : s.options, y = Math.log(t / i);
    let v = p[0];
    for (const x of p) Math.abs(Math.log(r(x.value)) - y) < Math.abs(Math.log(r(v.value)) - y) && (v = x);
    return { field: s, value: v.value, label: v.label };
  }
  /** An option of a select field by its value or its label, any case; null when it has no such option. */
  option(e, t) {
    const i = e.options || [], s = xn(t).toLowerCase(), o = i.find((r) => xn(r.value).toLowerCase() === s || r.label.toLowerCase() === s);
    return o ? { value: o.value, label: o.label } : null;
  }
}
function Gu(n) {
  return {
    get: (e) => n.store.get(e),
    childrenOf: (e) => n.childrenOf(e),
    framesIn: (e) => n.store.query(He(e)).filter((t) => {
      if (t.type !== "frame" || t.id === e.id) return !1;
      const i = t.x + t.w / 2, s = t.y + t.h / 2;
      return i > e.x && i < e.x + e.w && s > e.y && s < e.y + e.h;
    }),
    promptOf: (e) => n.promptOf(e),
    result: (e) => n.results.get(e),
    modelOf: (e) => n.modelFor(e).model,
    generating: (e) => !!n.generating[e]
  };
}
function pU(n) {
  const e = (t) => {
    const i = n.ui.selection.slice(), s = t();
    return n.ui.selection = i.filter((o) => !!n.store.get(o)), s;
  };
  return {
    element: (t) => n.store.get(t),
    contents: (t) => n.childrenOf(t).map((i) => n.store.get(i)).filter(Boolean).map((i) => He(i)),
    modelOf: (t, i) => {
      const s = n.catalog.value, o = s.kits.find((a) => a.id === t && a.models.some((l) => l.id === i)) || s.kits.find((a) => a.models.some((l) => l.id === i)), r = o ? o.models.find((a) => a.id === i) : null;
      return o && r ? { kit: o, model: r } : null;
    },
    imageFields: (t) => {
      const i = n.store.get(t);
      if (!i || i.type !== "tool") return [];
      const { model: s } = n.modelFor(i);
      return s ? s.fields.filter((o) => o.placement === "reference" && (o.kind === "image" || o.kind === "images")) : [];
    },
    assetOf: (t, i) => {
      const s = n.store.get(t);
      return s && s.type === "image" && s.asset || n.assetFor(i);
    },
    promptOf: (t) => n.promptOf(t),
    // a second "Night versions" in the frame is "Night versions 2", as the board names a copy
    addSession: (t, i, s, o) => n.addSession(t, i, n.uniqueSessionName(s), o, { quiet: !0 }),
    move: (t, i, s) => n.patch(t, { x: i, y: s }, "Move"),
    resizeFrame: (t, i) => n.patch(t, { x: i.x, y: i.y, w: i.w, h: i.h }, "Resize frame"),
    setPrompt: (t, i) => n.setPrompt(t, i),
    setRefInput: (t, i, s, o) => n.setRefInput(t, i, s, o),
    generate: (t) => n.generate(t),
    submitting: (t) => n.submitting(t),
    generating: (t) => !!n.generating[t],
    error: (t) => {
      const i = n.store.get(t);
      return i && i.type === "tool" && i.error || null;
    },
    results: (t) => n.results.list(t),
    place: (t, i) => e(() => n.placeImages([{
      url: t.url,
      w: i.w,
      h: i.h,
      x: i.x,
      y: i.y,
      label: t.label || "result",
      resultId: t.id,
      sessionId: t.sessionId,
      video: t.video,
      dur: t.dur,
      videoSrc: t.videoSrc,
      previewSrc: t.previewSrc,
      asset: t.asset,
      download: t.download,
      kind: t.kind
    }], { x: i.x + i.w / 2, y: i.y + i.h / 2 })[0] || null),
    wait: (t) => new Promise((i) => window.setTimeout(i, t))
  };
}
function dd(n) {
  const e = n.slice().sort((i, s) => i.y - s.y || i.x - s.x), t = [];
  for (; e.length; ) {
    const i = e[0], s = i.y + i.h / 2, o = e.filter((r) => r.y <= s && r.y + r.h >= s).sort((r, a) => r.x - a.x);
    for (const r of o) e.splice(e.indexOf(r), 1);
    t.push(...o);
  }
  return t;
}
function fU(n) {
  return !!n && n.fields.some((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images"));
}
const ig = (n) => ({ x: n.x + n.w / 2, y: n.y + n.h / 2 }), sg = (n, e, t = 0) => n.x > e.x - t && n.x < e.x + e.w + t && n.y > e.y - t && n.y < e.y + e.h + t, mo = (n) => n.w * n.h, mU = 4, gU = 32, bU = /* @__PURE__ */ new Set(["select", "size", "boolean", "slider", "text", "seed"]);
function F1(n, e) {
  const t = n.replace(/\s+/g, " ").trim();
  return t.length > e ? t.slice(0, e - 1) + "…" : t;
}
function vU(n, e) {
  if (e == null || e === "") return null;
  if (n.options && n.options.length) {
    const t = n.options.find((i) => xn(i.value) === xn(e));
    return t ? t.label : null;
  }
  return n.kind === "boolean" ? e ? "on" : "off" : typeof e == "number" ? String(e) : typeof e == "string" ? F1(e, 80) : null;
}
function yU(n, e) {
  if (!n) return [];
  const t = [], i = e.inputs || {};
  for (const s of n.fields) {
    const o = Object.prototype.hasOwnProperty.call(i, s.key) ? i[s.key] : void 0;
    if (s.kind === "negPrompt") {
      typeof o == "string" && o.trim() && t.push({ label: s.label || "Negative prompt", value: F1(o, 200) });
      continue;
    }
    if (!bU.has(s.kind) || s.placement === "reference" || s.placement === "prompt") continue;
    const r = o !== void 0 && xn(o) !== xn(s.defaultValue);
    if (s.placement !== "chip" && !r) continue;
    const a = vU(s, o !== void 0 ? o : s.defaultValue);
    a != null && t.push({ label: s.label, value: a });
  }
  return t;
}
function xU(n, e) {
  const t = [];
  e.ref && t.push(e.ref);
  for (const i of n && n.fields || []) {
    if (i.placement !== "reference" || i.kind !== "image" && i.kind !== "images") continue;
    const s = e.inputs ? e.inputs[i.key] : void 0;
    if (typeof s == "string" && s) t.push(s);
    else if (Array.isArray(s))
      for (const o of s) typeof o == "string" && o && t.push(o);
  }
  return Array.from(new Set(t));
}
function wU(n, e) {
  const t = e.w / 2, i = e.h / 2;
  if (t <= 0 || i <= 0) return !1;
  const s = (n.x - (e.x + t)) / t, o = (n.y - (e.y + i)) / i;
  return s * s + o * o <= 1;
}
function ju(n, e, t) {
  const i = [], s = [], o = [], r = [], a = [];
  let l = 0;
  for (const k of n.childrenOf(e)) {
    if (k === t) continue;
    const P = n.get(k);
    P && (P.type === "image" ? i.push(P) : P.type === "tool" ? s.push(P) : P.type === "note" && !P.link ? o.push(P) : P.type === "shape" ? r.push(P) : P.type === "chat" ? a.push(P.name || "Chat") : l++);
  }
  const d = He(e), c = n.framesIn(e).filter((k) => k.id !== e.id && mo(He(k)) < mo(d)).sort((k, P) => mo(He(k)) - mo(He(P))), h = dd(c.map((k) => ({ ...He(k), g: k }))).map(({ g: k }) => ({ id: k.id, title: (k.title || "").trim() || "Untitled frame", members: [] })), f = (k) => {
    const P = ig(k), A = c.find((R) => sg(P, He(R)));
    return A && h.find((R) => R.id === A.id) || null;
  }, p = (k, P) => {
    const A = f(P);
    if (A)
      return A.members.push(k), A.title;
  }, y = /* @__PURE__ */ new Map();
  for (const k of i) {
    y.set(k.src, k.id);
    for (const P of Object.values(k.tiers || {})) y.has(P) || y.set(P, k.id);
  }
  const v = dd(i).map((k) => {
    const P = k.resultId ? n.result(k.resultId) : void 0, A = !P && k.sessionId ? n.get(k.sessionId) : void 0, R = { id: k.id, url: k.src, w: k.w, h: k.h, hasAsset: !!k.asset };
    k.label && k.label !== "placed_image" && (R.label = k.label), k.video ? R.video = !0 : (k.kind === "3d" || k.kind === "layers") && (R.kind = k.kind), k.fav && (R.fav = !0), k.sessionId && (R.sessionId = k.sessionId), P ? (P.prompt && (R.prompt = P.prompt), P.model && (R.model = P.model), P.modelId && (R.modelId = P.modelId)) : A && A.type === "tool" && (R.model = A.model);
    const D = p(k.id, He(k));
    return D && (R.group = D), R;
  }), x = dd(s.map((k) => ({ ...k, ...He(k) }))).map((k) => {
    const P = n.modelOf(k), A = n.promptOf(k.id), R = [];
    let D = 0;
    for (const ie of xU(P, A)) {
      const ee = y.get(ie);
      ee ? R.push(ee) : D++;
    }
    const O = {
      id: k.id,
      name: k.name,
      kind: k.kind,
      kitId: k.kitId,
      model: P && P.name || k.model,
      nodeDefId: P && P.id || k.nodeDefId,
      prompt: (A.prompt || "").trim(),
      n: A.n || (P ? P.numResults.def : 1) || 1,
      results: k.count || 0,
      takesImages: fU(P),
      generating: n.generating(k.id),
      settings: yU(P, A),
      inputs: R,
      otherInputs: D,
      thumbs: (k.thumbs || []).filter(Boolean).slice(0, mU)
    };
    k.error && (O.error = F1(String(k.error), 200));
    const F = p(k.id, He(k));
    return F && (O.group = F), O;
  }), w = dd(o).filter((k) => !!(k.text || "").trim()).map((k) => {
    const P = { id: k.id, text: (k.text || "").trim() };
    k.author && (P.author = k.author), k.tint && k.tint !== "glass" && (P.tint = k.tint);
    const A = p(k.id, He(k));
    return A && (P.group = A), P;
  }), S = [
    ...i.map((k) => ({ id: k.id, rect: He(k) })),
    ...s.map((k) => ({ id: k.id, rect: He(k) })),
    ...o.filter((k) => !!(k.text || "").trim()).map((k) => ({ id: k.id, rect: He(k) })),
    ...c.map((k) => ({ id: k.id, rect: He(k) }))
  ], M = (k) => {
    let P = null;
    for (const A of S)
      sg(k, A.rect, gU) && (!P || mo(A.rect) < mo(P.rect)) && (P = A);
    return P ? P.id : null;
  }, _ = [], T = [];
  for (const k of dd(r)) {
    if (k.shape === "line" || k.shape === "arrow") {
      const R = cm(k), D = M({ x: k.x + R.x1, y: k.y + R.y1 }), O = M({ x: k.x + R.x2, y: k.y + R.y2 });
      !D && !O ? l++ : _.push({ id: k.id, kind: k.shape, from: D, to: O });
      continue;
    }
    const P = He(k), A = S.filter((R) => mo(R.rect) < mo(P) && (k.shape === "ellipse" ? wU(ig(R.rect), P) : sg(ig(R.rect), P))).map((R) => R.id);
    A.length ? T.push({ id: k.id, kind: k.shape === "ellipse" ? "ellipse" : "rect", around: A }) : l++;
  }
  return {
    frameId: e.id,
    title: e.title || "Untitled frame",
    rect: d,
    images: v,
    sessions: x,
    notes: w,
    groups: h,
    links: _,
    marks: T,
    chats: a,
    ignored: l
  };
}
function og(n, e, t = e + "s") {
  return n + " " + (n === 1 ? e : t);
}
function v8(n) {
  return n.images.length + n.sessions.length + n.notes.length;
}
function y8(n) {
  const e = [];
  return n.images.length && e.push(og(n.images.length, "image")), n.sessions.length && e.push(og(n.sessions.length, "session")), n.notes.length && e.push(og(n.notes.length, "note")), e.length ? e.join(", ") : "Empty";
}
function kU(n) {
  return n ? n.images.length ? "Ask about " + (n.images.length === 1 ? "this image" : "these " + n.images.length + " images") + "…" : n.sessions.length ? "Ask about " + (n.sessions.length === 1 ? "this session" : "these " + n.sessions.length + " sessions") + "…" : "What should we build here?" : "Move this chat into a frame to give it something to work with";
}
function _U(n, e) {
  const t = He(e), i = t.x + t.w / 2, s = t.y + t.h / 2;
  let o = null;
  for (const r of n)
    i > r.x && i < r.x + r.w && s > r.y && s < r.y + r.h && (!o || r.w * r.h < o.w * o.h || r.w * r.h === o.w * o.h && r.z > o.z) && (o = r);
  return o;
}
const SU = "draft", MU = "Draft guidance: placeholder recommendations that RunDiffusion will tune", st = {
  flare: { id: "50XKlkMz7r9kmipyspRQ", name: "ChatGPT Image 2.5 Flare" },
  sunburst: { id: "s9ShIto8LPgdOSImFC39", name: "ChatGPT Image 2.5 Sunburst" },
  nb2: { id: "6BJyvazKHGTilS1yWk76", name: "Nano Banana 2" },
  nbPro: { id: "eILT27MJkTwxnVSPQP2x", name: "Nano Banana Pro" },
  nb2Lite: { id: "VpkLvmqERLkoU2vBNTJ7" },
  nb1: { id: "umNAyCPJkWXmSrTUevOM" },
  flux3: { id: "JcDKjRIyFolGJVEOIgya", name: "Flux 3 Image" },
  flux2Max: { id: "vMzpgBA14pAFuBgU8yby", name: "Flux 2 Max" },
  kontextPro: { id: "bKkjGeP6wjLsl1314ybn", name: "Flux Kontext Pro" },
  seedream5: { id: "B9nbLi2HgM7XHeaBoOJD", name: "Seedream V5 Pro" },
  seedream45: { id: "sI3TYrxuB8l4st8KXHSH" },
  rdPhoto: { id: "4Qsc76pSm5HKYRMnClef", name: "RunDiffusion Photo FLUX" },
  zTurbo: { id: "cnedcdG4HabkoZGBu1Fs", name: "Z Image Turbo" },
  juggLightning: { id: "2t5JQGvAIiSr669KYnVq", name: "Juggernaut Lightning Flux" },
  klein4b: { id: "UNuq3Ia9Wlos2DWSFrlv", name: "Flux 2 Klein 4B" },
  ideoEdit: { id: "uW9DvVweUX4OoA3n8Brt" },
  ideoReframe: { id: "F4QfdOqv9ehwMR4Z0qNW" },
  layers: { id: "px6klFXH0N11egFiDoVB", name: "Image-to-Layers" },
  wanPro: { id: "seBwSSKFPpNZMYycG7i5" }
}, TU = {
  status: SU,
  jobs: {
    compare: {
      id: "compare",
      label: "Comparing one prompt across tools",
      intro: "For a fair comparison, use strong all-rounders that take a prompt on its own and finish in about the same time.",
      suggest: 3,
      picks: [
        { ...st.flare, why: "follows long, detailed prompts closely and lights scenes naturally" },
        { ...st.nb2, why: "photoreal materials and geometry, a strong all-rounder for architecture" },
        { ...st.flux3, why: "crisp detail up to 4K, and the cleanest text of the group" },
        { ...st.seedream5, why: "cinematic light and colour, up to six results a run" },
        { ...st.nbPro, why: "the highest fidelity here, slower and the most expensive" },
        { ...st.flux2Max, why: "sharp, high-resolution renders with tight prompt control" }
      ]
    },
    photoreal: {
      id: "photoreal",
      label: "Photoreal renders",
      intro: "For photoreal architecture and interiors:",
      picks: [
        { ...st.nbPro, why: "the most convincing materials and light, for finals" },
        { ...st.nb2, why: "nearly as real for half the price, and quick to iterate" },
        { ...st.rdPhoto, why: "RunDiffusion's own photographic model, for natural daylight" },
        { ...st.seedream5, why: "cinematic mood and colour grading" }
      ]
    },
    text: {
      id: "text",
      label: "Text and signage",
      intro: "For legible words in the picture (signage, posters, labels):",
      picks: [
        { ...st.flux3, why: "the most reliable lettering here, up to 4K" },
        { ...st.sunburst, why: "precise layout and tight revisions, with transparent backgrounds" },
        { ...st.nbPro, why: "good short signage inside a photoreal scene" }
      ]
    },
    edit: {
      id: "edit",
      label: "Editing images you have",
      intro: "For changing an image while keeping the building and camera:",
      picks: [
        { ...st.flare, why: "relights and restyles naturally while holding the layout" },
        { ...st.nb2, why: "keeps geometry and materials steady through big changes" },
        { ...st.kontextPro, why: "fast, faithful single-image edits" },
        { ...st.seedream5, why: "mood and colour changes with up to ten reference images" }
      ]
    },
    drafts: {
      id: "drafts",
      label: "Fast, cheap drafts",
      intro: "For quick drafts while you find the idea:",
      picks: [
        { ...st.zTurbo, why: "about five seconds and 12 tokens a picture" },
        { ...st.juggLightning, why: "about 3 tokens a picture, good for volume" },
        { ...st.klein4b, why: "cheap, and it takes reference images" }
      ]
    },
    design: {
      id: "design",
      label: "Design and vector-style graphics",
      intro: "For logos, icons and flat graphics (no true vector tool is on this board yet):",
      picks: [
        { ...st.sunburst, why: "transparent backgrounds and tight control of layout" },
        { ...st.flux3, why: "clean type and graphic layouts" },
        { ...st.layers, why: "splits a finished design into editable layers (it needs the image)" }
      ]
    }
  },
  families: [
    {
      name: "ChatGPT Image 2.5",
      match: /\b(chat\s*gpt|gpt)[\s-]*image(?:[\s-]*2\.5)?\b|\bchatgpt\b/i,
      members: [st.flare.id, st.sunburst.id],
      pick: {
        edit: { id: st.flare.id, why: "it relights scenes naturally and keeps the layout, which suits a time-of-day change" },
        text: { id: st.sunburst.id, why: "it has tighter revision control and the most detail, which lettering needs" },
        design: { id: st.sunburst.id, why: "it has tighter revision control and supports transparent backgrounds" },
        default: { id: st.flare.id, why: "it's the faster of the two and the better all-rounder" }
      }
    },
    {
      name: "Nano Banana",
      match: /\bnano[\s-]*banana\b/i,
      members: [st.nb2.id, st.nbPro.id, st.nb1.id, st.nb2Lite.id],
      pick: {
        photoreal: { id: st.nbPro.id, why: "it's the highest-fidelity Nano Banana" },
        default: { id: st.nb2.id, why: "it's the best balance of quality and price of the Nano Banana tools" }
      }
    },
    {
      name: "Flux 3",
      match: /\bflux[\s-]*3\b/i,
      members: [st.flux3.id],
      pick: { default: { id: st.flux3.id, why: "it's the Flux 3 tool on this board" } }
    },
    {
      name: "Seedream",
      match: /\bseedream\b/i,
      members: [st.seedream5.id, st.seedream45.id],
      pick: { default: { id: st.seedream5.id, why: "it's the newest Seedream and takes reference images" } }
    },
    {
      name: "Flux Kontext",
      match: /\b(flux[\s-]*)?kontext\b/i,
      members: [st.kontextPro.id],
      pick: { default: { id: st.kontextPro.id, why: "Pro is the balanced Kontext" } }
    },
    {
      name: "Wan",
      match: /\bwan(?:[\s-]*2\.7)?\b/i,
      members: [st.wanPro.id],
      pick: { default: { id: st.wanPro.id, why: "Pro is the sharper Wan image tool" } }
    },
    {
      name: "Ideogram",
      match: /\bideogram\b/i,
      members: [st.ideoEdit.id, st.ideoReframe.id],
      pick: {
        edit: { id: st.ideoEdit.id, why: "it edits an image (with a mask), and it's the Ideogram that does" }
      },
      note: "Ideogram v4, the Ideogram that makes a picture from a prompt alone, isn't on this board's tool list. The Ideogram tools here (v3 Edit and V3 Reframe) need an image to start from."
    }
  ],
  tools: [
    {
      ids: [st.flare.id, st.sunburst.id],
      name: "ChatGPT Image 2.5",
      tips: [
        'Say what changes first, then what must stay: "same building, same camera angle, same materials".',
        "Name the light: the time of day, where it comes from and its colour.",
        "Quality sets the price: Medium for drafts, High for finals, Extra High only for print.",
        "Pick the size that matches your source image's shape, so nothing gets cropped."
      ],
      settings: [{ field: "Quality", value: "high", say: "High quality" }],
      sizeFromInput: !0,
      tuned: "{prompt}. Natural, physically accurate light and a precise, well-balanced composition."
    },
    {
      ids: [st.nb2.id, st.nbPro.id, st.nb1.id, st.nb2Lite.id],
      name: "Nano Banana",
      tips: [
        "Write plain, complete sentences: it follows them closely.",
        "Name materials and finishes (board-formed concrete, oiled oak, bronze mullions).",
        "For an edit, attach the image and describe only what should change."
      ],
      tuned: "A photograph of {prompt}. Real materials and finishes, accurate geometry, natural light."
    },
    {
      ids: [st.flux3.id],
      name: "Flux 3 Image",
      tips: [
        "Put exact words in double quotes and name the type style.",
        "Choose the size first: it sets the price.",
        'Concrete nouns beat adjectives: "cedar slats" says more than "warm and natural".'
      ],
      tuned: "{prompt}, highly detailed, sharp focus, professional architectural photography"
    },
    {
      ids: [st.seedream5.id, st.seedream45.id],
      name: "Seedream",
      tips: [
        "Describe mood and light like a cinematographer: golden hour, low sun, long shadows.",
        "Reference images steer style and palette: add one or two."
      ],
      tuned: "{prompt}, cinematic lighting, rich colour, atmospheric depth"
    },
    {
      ids: [st.ideoEdit.id, st.ideoReframe.id],
      name: "Ideogram",
      tips: [
        "Put the exact sign text in double quotes, and keep it short: one to four words read best.",
        "Name the lettering: bold geometric sans serif, brushed steel channel letters, hand-painted serif.",
        "Say where the sign is and how it's lit: on the canopy fascia, backlit, facing the street.",
        "Ask for clean, legible typography, and leave other words out of the prompt so they don't end up on the sign.",
        "Choose a Design or Typography style when the tool offers one."
      ]
    },
    {
      ids: [st.kontextPro.id],
      name: "Flux Kontext Pro",
      tips: [
        'Describe the change as an instruction: "make it night", "replace the cladding with zinc".',
        "One change per run edits most faithfully."
      ]
    }
  ],
  edits: [
    { match: /night|nighttime|night-time|evening|after dark/i, name: "Night versions", change: "a nighttime scene", light: "Deep blue night sky, warm light glowing from the interior windows, soft uplighting on the facade, realistic reflections and gentle street lighting." },
    { match: /dusk|twilight|blue hour/i, name: "Dusk versions", change: "dusk", light: "Blue-hour sky fading to warm orange at the horizon, interior lights coming on, soft even light on the facade." },
    { match: /sunset|golden hour/i, name: "Golden hour versions", change: "golden hour", light: "Low warm sun, long soft shadows, glowing highlights on the facade, a clear gradient sky." },
    { match: /\bfog|\bmist/i, name: "Fog versions", change: "a foggy morning", light: "Dense soft fog fading the background, muted colours, diffuse light." },
    { match: /dawn|sunrise|morning/i, name: "Morning versions", change: "early morning", light: "Cool soft dawn light, a pale sky with warm first light on the upper floors, light mist at street level." },
    { match: /snow|winter/i, name: "Winter versions", change: "a snowy winter scene", light: "Fresh snow on the ground and ledges, overcast soft light, cool tones with warm windows." },
    { match: /\brain|\bwet\b|storm/i, name: "Rainy day versions", change: "a rainy day", light: "Wet reflective pavement, overcast sky, soft diffuse light, rain streaks in the air." },
    { match: /autumn|\bfall\b/i, name: "Autumn versions", change: "autumn", light: "Trees in full autumn colour, low warm sun, fallen leaves on the ground." }
  ]
};
function hm(n, e) {
  return n.tools.find((t) => t.ids.includes(e)) || null;
}
function x8(n, e, t) {
  const i = hm(n, e), s = t.trim().replace(/[.\s]+$/, "");
  return i && i.tuned ? i.tuned.replace("{prompt}", s) : s;
}
function w8(n, e, t, i, s) {
  const o = { prompt: e, n: t, inputs: { ...i } }, r = n.imageField;
  if (r && s.length) {
    const a = n.model.fields.find((l) => l.placement === "reference") === r;
    s.length > 1 && r.kind === "images" ? o.inputs[r.key] = s.slice() : a ? o.ref = s[0] : o.inputs[r.key] = s[0];
  }
  return o;
}
function CU(n, e, t, i) {
  const s = {}, o = [];
  for (const [r, a] of Object.entries(t.settings || {})) {
    if (r.toLowerCase() === "size") {
      if (a !== "match" || !i) continue;
      const d = n.sizeFor(e, i.w, i.h);
      if (!d) continue;
      s[d.field.key] = d.value, o.push(d.label.replace(/\s*-\s*\d+x\d+$/, ""));
      continue;
    }
    const l = n.field(e, r);
    if (!l) return e.name + " has no " + r + " setting.";
    if (l.options && l.options.length) {
      const d = n.option(l, a);
      if (!d) return r + " can't be " + String(a) + " in " + e.name + ".";
      s[l.key] = d.value, o.push(d.label + " " + r.toLowerCase());
    } else
      s[l.key] = a, o.push(r + " " + String(a));
  }
  return { inputs: s, said: o };
}
function IU(n) {
  let e = 0;
  for (const t of n) e = Math.max(e, t.secs + 4 * Math.max(0, t.runs - 1));
  return Math.round(e);
}
function Ev(n, e, t) {
  if (!n.sessions.length) return { ok: !1, error: "The plan has nothing to run." };
  const i = new Map(e.images.map((a) => [a.id, a])), s = [], o = [];
  let r = 0;
  for (const a of n.sessions) {
    const l = t.get(a.modelId);
    if (!l) return { ok: !1, error: "That tool isn't on this board's tool list, so the plan can't use it." };
    let d;
    if (a.toolId) {
      const w = e.sessions.find((S) => S.id === a.toolId);
      if (!w) return { ok: !1, error: "A session the plan uses is no longer in this frame." };
      d = w.kitId;
    } else
      d = t.kitFor(l, a.job || "generate").id;
    const c = (a.runs && a.runs.length ? a.runs : [{ imageIds: [] }]).map((w) => {
      const S = [];
      for (const M of w.imageIds || []) {
        const _ = i.get(M);
        _ && S.push(_);
      }
      return S;
    });
    if (c.some((w, S) => w.length !== (a.runs && a.runs[S] && a.runs[S].imageIds || []).length))
      return { ok: !1, error: "An image the plan uses is no longer in this frame." };
    const h = c.some((w) => w.length);
    if (h && !l.imageField) return { ok: !1, error: l.name + " can't take an image as input." };
    if (c.some((w) => w.length > l.maxImages)) return { ok: !1, error: l.name + " takes up to " + l.maxImages + (l.maxImages === 1 ? " image" : " images") + " a run." };
    if (!h && l.needsImage) return { ok: !1, error: l.name + " needs an image to start from." };
    const f = t.results(l, a.n || 1), p = c.find((w) => w.length) ? c.find((w) => w.length)[0] : null, y = CU(t, l, a, p);
    if (typeof y == "string") return { ok: !1, error: y };
    let v = 0, x = !0;
    for (const w of c) {
      const S = w8(l, a.prompt, f, y.inputs, w.map((T) => T.url)), M = t.problems(l, S, f);
      if (M.length) return { ok: !1, error: M[0] };
      const _ = t.price(l, S, f);
      _ == null ? x = !1 : v += _;
    }
    if (!x) return { ok: !1, error: l.name + " has no price the board can show, so the plan can't include it." };
    v = Math.round(v * 10) / 10, r += v, o.push({ secs: l.secs, runs: c.length }), s.push({
      key: "s" + (s.length + 1),
      ...a.toolId ? { toolId: a.toolId } : {},
      name: a.name,
      kitId: d,
      modelId: l.id,
      model: l.name,
      prompt: a.prompt,
      n: f,
      runs: c.map((w) => w.length ? { images: w.map((S) => ({ id: S.id, url: S.url })) } : {}),
      ...Object.keys(y.inputs).length ? { inputs: y.inputs } : {},
      ...y.said.length ? { settings: y.said.join(" · ") } : {},
      tokens: v,
      ...a.why ? { why: a.why } : {}
    });
  }
  return {
    ok: !0,
    plan: {
      id: wt(),
      title: n.title,
      ...n.summary ? { summary: n.summary } : {},
      status: "proposed",
      tokens: Math.round(r * 10) / 10,
      secs: IU(o),
      sessions: s,
      ...n.place ? { place: !0 } : {}
    }
  };
}
function AU(n) {
  let e = 0, t = 0, i = 0;
  for (const s of n.sessions)
    e += s.runs.length, t += s.runs.length * s.n, s.toolId || i++;
  return { runs: e, results: t, sessions: n.sessions.length, added: i };
}
function hc(n) {
  return (n >= 100 ? Math.round(n) : Math.round(n * 10) / 10).toLocaleString("en-US");
}
function k8(n) {
  return hc(n) + (n === 1 ? " token" : " tokens");
}
function Uw(n) {
  return n < 90 ? Math.max(1, Math.round(n)) + "s" : Math.round(n / 60) + " min";
}
var PU = Object.defineProperty, EU = (n, e, t) => e in n ? PU(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, rg = (n, e, t) => EU(n, typeof e != "symbol" ? e + "" : e, t);
const _8 = "/__smart-frames", S8 = { url: _8 }, RU = { "Content-Type": "application/json", "X-Smart-Frames": "1" }, ag = 16, zU = 384, $U = 1, DU = 4, M8 = (n) => n.url === _8, lg = (n) => M8(n) ? "The assistant runs in the web app's dev server, which didn't answer here." : "The chat couldn't be reached. Try again in a little while.";
async function T8(n, e, t, i) {
  const s = { ...RU };
  if (n.token) {
    const r = await n.token();
    r && (s.Authorization = "Bearer " + r);
  }
  const o = n.url + e + (n.teamId ? "?team=" + encodeURIComponent(n.teamId) : "");
  return i(o, { ...t, headers: s });
}
async function OU(n = S8, e = fetch) {
  try {
    const t = await T8(n, "/status", {}, e);
    let i = null;
    try {
      i = await t.json();
    } catch {
      i = null;
    }
    if (!t.ok || !i) return { ready: !1, reason: i && i.reason || lg(n) };
    const s = Array.isArray(i.models) ? i.models.filter((o) => o && o.id && o.label) : [];
    return i.ready && s.length ? { ready: !0, models: s } : { ready: !1, reason: i.reason || lg(n) };
  } catch {
    return { ready: !1, reason: lg(n) };
  }
}
function dg(n, e, t, i = []) {
  return n.price(e, w8(e, "x", 1, t, i), 1);
}
const Gw = /* @__PURE__ */ new WeakMap();
function LU(n, e) {
  let t = Gw.get(n.catalog);
  t || (t = /* @__PURE__ */ new Map(), Gw.set(n.catalog, t));
  const i = t.get(e.id);
  if (i) return i;
  const s = [], o = dg(n, e, {});
  if (o != null) {
    for (const r of e.model.fields) {
      if (r.kind !== "select" && r.kind !== "size" || !r.options || r.options.length < 2 || r.options.length > 10) continue;
      const a = r.options.map((l) => ({ label: l.label, p: dg(n, e, { [r.key]: l.value }) }));
      a.some((l) => l.p == null) || a.every((l) => l.p === a[0].p) || s.push(r.label + ": " + a.map((l) => l.label + " " + Math.round(l.p * 10) / 10).join(", ") + " tokens a result");
    }
    if (e.imageField) {
      const r = dg(n, e, {}, ["https://board.invalid/a.png"]);
      r != null && r !== o && s.push("each input image adds " + Math.round((r - o) * 10) / 10 + " tokens a result");
    }
  }
  return t.set(e.id, s), s;
}
function BU(n) {
  const e = [];
  for (const t of n.entries()) {
    const i = n.price(t, { prompt: "x", n: 1 }, 1), s = t.model.fields.find((r) => r.placement === "reference" && r.kind === "video"), o = LU(n, t);
    e.push({
      id: t.id,
      name: t.name,
      ...t.desc ? { desc: t.desc.slice(0, 240) } : {},
      kits: t.kits.map((r) => r.id),
      ...t.model.kitTags && t.model.kitTags.length ? { tags: t.model.kitTags.slice(0, 6) } : {},
      ...t.model.labels && t.model.labels.length ? { labels: t.model.labels.map((r) => r.label).slice(0, 6) } : {},
      images: t.imageField ? t.needsImage ? "required" : "optional" : "none",
      maxImages: t.maxImages,
      ...s ? { video: s.required ? "required" : "optional" } : {},
      maxResults: t.model.numResults.max,
      perResult: i == null ? null : Math.round(i * 10) / 10,
      priceVaries: o.length > 0,
      ...o.length ? { priceNotes: o } : {},
      secs: t.secs,
      settings: t.model.fields.filter((r) => (r.kind === "select" || r.kind === "size") && r.options && r.options.length).map((r) => {
        const a = r.options.find((l) => xn(l.value) === xn(r.defaultValue));
        return {
          label: r.label,
          kind: r.kind,
          options: r.options.map((l) => l.label),
          values: r.options.map((l) => xn(l.value)),
          ...a ? { default: a.label } : {}
        };
      })
    });
  }
  return { kits: n.catalog.kits.map((t) => ({ id: t.id, name: t.name, ...t.desc ? { desc: t.desc } : {} })), tools: e };
}
function FU(n) {
  return {
    status: n.status,
    jobs: n.jobs,
    families: n.families.map((e) => ({ ...e, match: e.match.source })),
    tools: n.tools,
    edits: n.edits.map((e) => ({ ...e, match: e.match.source }))
  };
}
function C8(n) {
  return {
    title: n.title,
    status: n.status,
    ...n.results != null ? { results: n.results } : {},
    ...n.error ? { error: n.error } : {},
    sessions: n.sessions.map((e) => ({
      name: e.name,
      model: e.model,
      modelId: e.modelId,
      ...e.toolId || e.addedId ? { toolId: e.toolId || e.addedId } : {},
      prompt: e.prompt,
      runs: e.runs.length,
      n: e.n,
      images: e.runs.reduce((t, i) => t + (i.images ? i.images.length : 0), 0)
    }))
  };
}
function NU(n) {
  return n.map((e) => ({
    role: e.role,
    author: e.role === "agent" ? "Assistant" : e.author,
    text: e.text || "",
    ...e.plan ? { plan: C8(e.plan) } : {},
    ...e.picks && e.picks.length ? { picks: e.picks.map((t) => t.name) } : {},
    ...e.ideas && e.ideas.length ? { ideas: e.ideas.map((t) => t.title) } : {}
  }));
}
const Ma = /* @__PURE__ */ new Map();
function jw(n) {
  return new Promise((e) => {
    if (typeof Image == "undefined" || typeof document == "undefined") {
      e(null);
      return;
    }
    const t = new Image();
    t.crossOrigin = "anonymous", t.decoding = "async";
    const i = window.setTimeout(() => e(null), 8e3);
    t.onload = () => {
      window.clearTimeout(i);
      try {
        const s = t.naturalWidth, o = t.naturalHeight;
        if (!s || !o) return e(null);
        const r = Math.min(1, zU / Math.max(s, o)), a = document.createElement("canvas");
        a.width = Math.max(1, Math.round(s * r)), a.height = Math.max(1, Math.round(o * r));
        const l = a.getContext("2d");
        if (!l) return e(null);
        l.drawImage(t, 0, 0, a.width, a.height), e({ data: a.toDataURL("image/jpeg", 0.85), w: s, h: o });
      } catch {
        e(null);
      }
    }, t.onerror = () => {
      window.clearTimeout(i), e(null);
    }, t.src = n;
  });
}
function UU(n) {
  const e = Ma.get(n);
  if (e) return e;
  const t = L1(n), i = (t ? jw(t) : Promise.resolve(null)).then((s) => s || jw(n)).then((s) => (s || Ma.delete(n), s));
  return Ma.set(n, i), Ma.size > 96 && Ma.delete(Ma.keys().next().value), i;
}
async function GU(n) {
  try {
    const e = await crypto.subtle.digest("SHA-256", new TextEncoder().encode("smart-frames:" + n));
    return Array.from(new Uint8Array(e)).slice(0, 16).map((t) => t.toString(16).padStart(2, "0")).join("");
  } catch {
    return;
  }
}
function jU(n, e = /* @__PURE__ */ new Set()) {
  const t = n.sessions.map((a) => Math.min(a.thumbs.length, a.id && e.has(a.id) ? DU : $U)), i = t.reduce((a, l) => a + l, 0), s = Math.min(n.images.length, i ? ag - Math.min(i, 4) : ag);
  let o = ag - s;
  const r = t.map((a) => {
    const l = Math.max(0, Math.min(a, o));
    return o -= l, l;
  });
  return { images: s, sessions: r };
}
async function HU(n, e, t = UU) {
  const i = n.context, s = new Set(n.input.kind === "plan-ended" ? n.input.plan.sessions.map((l) => l.toolId || l.addedId || "").filter(Boolean) : []), o = jU(i, s), r = await Promise.all(i.images.map((l, d) => d < o.images ? t(l.url) : Promise.resolve(null))), a = await Promise.all(i.sessions.map((l, d) => Promise.all(l.thumbs.slice(0, o.sessions[d]).map((c) => t(c)))));
  return {
    v: 2,
    model: e.model,
    ...e.boardId ? { board: { id: e.boardId } } : {},
    ...n.chatId ? { chat: { id: n.chatId } } : {},
    ...e.user ? { user: e.user } : {},
    input: n.input.kind === "message" ? { kind: "message", text: n.input.text, author: n.input.author } : { kind: "plan-ended", plan: C8(n.input.plan) },
    frame: {
      title: i.title,
      images: i.images.map((l, d) => {
        const c = L1(l.url), h = r[d];
        return {
          id: l.id,
          url: l.url,
          w: l.w,
          h: l.h,
          ...c ? { thumb: c } : {},
          ...h ? { thumbData: h.data, px: { w: h.w, h: h.h } } : {},
          ...l.label ? { label: l.label } : {},
          ...l.prompt ? { prompt: l.prompt } : {},
          ...l.model ? { model: l.model } : {},
          ...l.sessionId ? { session: l.sessionId } : {},
          ...l.video ? { video: !0 } : {},
          ...l.kind ? { kind: l.kind } : {},
          ...l.fav ? { fav: !0 } : {},
          ...l.group ? { group: l.group } : {}
        };
      }),
      sessions: i.sessions.map((l, d) => ({
        id: l.id,
        name: l.name,
        kit: l.kind,
        kitId: l.kitId,
        model: l.model,
        ...l.nodeDefId ? { modelId: l.nodeDefId } : {},
        prompt: l.prompt,
        n: l.n,
        results: l.results,
        takesImages: l.takesImages,
        generating: l.generating,
        settings: l.settings,
        inputs: l.inputs,
        otherInputs: l.otherInputs,
        ...l.error ? { error: l.error } : {},
        ...l.group ? { group: l.group } : {},
        ...o.sessions[d] ? {
          latest: l.thumbs.slice(0, o.sessions[d]).map((c, h) => {
            const f = a[d][h];
            return { url: c, ...f ? { thumbData: f.data } : {} };
          })
        } : {}
      })),
      notes: i.notes.map((l) => ({ id: l.id, text: l.text, ...l.author ? { author: l.author } : {}, ...l.tint ? { tint: l.tint } : {}, ...l.group ? { group: l.group } : {} })),
      groups: i.groups,
      links: i.links.map((l) => ({ kind: l.kind, from: l.from, to: l.to })),
      marks: i.marks.map((l) => ({ kind: l.kind, around: l.around })),
      chats: i.chats,
      ignored: i.ignored
    },
    history: NU(n.history),
    ...n.dropped ? { dropped: n.dropped } : {},
    catalog: BU(n.catalog),
    guidance: FU(n.guidance)
  };
}
async function* VU(n, e) {
  const t = n.getReader(), i = new TextDecoder();
  let s = "";
  try {
    for (; !(e && e.aborted); ) {
      const { done: o, value: r } = await t.read();
      s += i.decode(r || new Uint8Array(), { stream: !o });
      const a = s.split(/\r?\n\r?\n/);
      s = o ? "" : a.pop() || "";
      for (const l of a) {
        const d = l.split(/\r?\n/).filter((c) => c.startsWith("data:")).map((c) => c.slice(5).trimStart()).join(`
`);
        if (d)
          try {
            yield JSON.parse(d);
          } catch {
          }
      }
      if (o) break;
    }
  } finally {
    e && e.aborted ? t.cancel().catch(() => {
    }) : t.releaseLock();
  }
}
class WU {
  constructor(e) {
    rg(this, "opts", e), rg(this, "id"), rg(this, "label"), this.id = "model:" + e.model.id, this.label = e.model.label;
  }
  async *turn(e, t) {
    const i = this.opts.fetchImpl || fetch, s = this.opts.endpoint || S8;
    yield { type: "status", text: e.context.images.length && e.input.kind === "message" ? "Looking at the frame…" : "Thinking…" };
    let o;
    try {
      const a = await HU(e, { model: this.opts.model.id, boardId: this.opts.boardId, user: this.opts.uid ? await GU(this.opts.uid) : void 0 }, this.opts.draw);
      if (t.aborted) return;
      o = await T8(s, "/turn", { method: "POST", body: JSON.stringify(a), signal: t }, i);
    } catch {
      if (t.aborted) return;
      yield { type: "text", delta: M8(s) ? "The assistant couldn't be reached. Is the dev server still running?" : "The chat couldn't be reached. Check your connection and try again." };
      return;
    }
    if (!o.ok || !o.body) {
      let a = "";
      try {
        a = (await o.json()).error || "";
      } catch {
        a = "";
      }
      yield { type: "text", delta: a || "The assistant couldn't answer (HTTP " + o.status + ")." };
      return;
    }
    let r = !1;
    for await (const a of VU(o.body, t))
      if (a.type === "status") yield a;
      else if (a.type === "text")
        r = !0, yield a;
      else if (a.type === "plan") yield { type: "plan", plan: a.plan };
      else if (a.type === "picks" || a.type === "ideas" || a.type === "chips") yield a;
      else if (a.type === "error")
        yield { type: "text", delta: (r ? `

` : "") + a.message }, r = !0;
      else if (a.type === "done") {
        a.usage && (yield { type: "usage", usage: a.usage });
        return;
      }
  }
}
const An = 40, pm = 24, I8 = 56;
function qU(n, e) {
  return { x: n.x - e, y: n.y - e, w: n.w + e * 2, h: n.h + e * 2 };
}
function Rv(n, e, t, i, s = pm, o = 16) {
  const r = n.x + An, a = n.y + An;
  for (let l = a; l + i <= n.y + n.h - An; l += o)
    for (let d = r; d + t <= n.x + n.w - An; d += o) {
      const c = qU({ x: d, y: l, w: t, h: i }, s - 1);
      if (!e.some((h) => Ya(c, h))) return { x: d, y: l };
    }
  return null;
}
function zv(n, e, t = pm) {
  const i = uc(e);
  return { x: n.x + An, y: i ? Math.max(n.y + An, i.y + i.h + t) : n.y + An };
}
function KU(n, e, t, i, s, o = I8) {
  if (t <= 0) return [];
  const r = t * i + (t - 1) * o, l = Rv(n, e, r, s, o) || zv(n, e, o), d = [];
  for (let c = 0; c < t; c++) d.push({ x: l.x + c * (i + o), y: l.y, w: i, h: s });
  return d;
}
function $v(n, e) {
  let t = n.x + n.w, i = n.y + n.h;
  for (const s of e)
    t = Math.max(t, s.x + s.w + An), i = Math.max(i, s.y + s.h + An);
  return t === n.x + n.w && i === n.y + n.h ? null : { x: n.x, y: n.y, w: Math.round(t - n.x), h: Math.round(i - n.y) };
}
function YU(n, e, t, i, s = pm) {
  let o = n.y + n.h;
  for (const r of e)
    r.x < n.x + n.w && r.x + r.w > n.x && r.y >= n.y && r.y + r.h > o && (o = r.y + r.h);
  return { x: n.x, y: o + s, w: t, h: i };
}
function XU(n, e, t, i = 400) {
  if (!e || !t) return { w: n, h: Math.round(n * 0.75) };
  const s = Math.round(n * t / e);
  return s <= i ? { w: n, h: s } : { w: Math.round(i * e / t), h: i };
}
var JU = Object.defineProperty, ZU = (n, e, t) => e in n ? JU(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, di = (n, e, t) => ZU(n, typeof e != "symbol" ? e + "" : e, t);
const QU = Rt.w;
function br(n) {
  return "“" + n + "”";
}
function Hu(n, e, t = e + "s") {
  return n + " " + (n === 1 ? e : t);
}
class eG {
  constructor(e, t, i, s = () => {
  }, o = {}) {
    di(this, "cmd", e), di(this, "plan", t), di(this, "frameId", i), di(this, "onUpdate", s), di(this, "cancelled", !1), di(this, "steps", []), di(this, "added", {}), di(this, "results", 0), di(this, "pollMs"), di(this, "timeoutMs"), di(this, "sendTimeoutMs"), di(this, "columns", []), di(this, "rowY", null), di(this, "nextY", /* @__PURE__ */ new Map()), this.pollMs = o.pollMs || 400, this.timeoutMs = o.timeoutMs || 600 * 1e3, this.sendTimeoutMs = o.sendTimeoutMs || 120 * 1e3;
  }
  /** Stop before the next step. Runs already sent finish anyway (they're paid for). */
  cancel() {
    this.cancelled = !0;
  }
  step(e) {
    return this.steps.find((t) => t.id === e);
  }
  set(e, t) {
    Object.assign(this.step(e), t), this.emit();
  }
  emit() {
    this.onUpdate({ steps: this.steps.map((e) => ({ ...e })), added: { ...this.added }, results: this.results });
  }
  outcome(e, t) {
    return { status: e, steps: this.steps.map((i) => ({ ...i })), added: { ...this.added }, results: this.results, ...t ? { error: t } : {} };
  }
  fail(e, t) {
    return this.set(e, { status: "failed", detail: t }), this.outcome("failed", t);
  }
  stopIfCancelled(e) {
    return this.cancelled ? (this.set(e, { status: "failed", detail: "Stopped before this step" }), this.outcome("cancelled", "Stopped")) : null;
  }
  frame() {
    const e = this.cmd.element(this.frameId);
    return e && e.type === "frame" ? e : null;
  }
  /** Grow the frame to hold these rects, when it doesn't. */
  fit(e) {
    const t = this.frame();
    if (!t) return;
    const i = $v(He(t), e);
    i && this.cmd.resizeFrame(t.id, i);
  }
  toolOf(e) {
    const t = e.toolId || this.added[e.key], i = t ? this.cmd.element(t) : void 0;
    return i && i.type === "tool" ? t : null;
  }
  async until(e, t) {
    const i = Math.max(1, Math.ceil(t / this.pollMs));
    for (let s = 0; s < i; s++) {
      if (e()) return !0;
      await this.cmd.wait(this.pollMs);
    }
    return e();
  }
  async run() {
    const e = this.plan, t = e.sessions, i = t.filter((_) => !_.toolId), s = t.reduce((_, T) => _ + T.runs.length, 0), o = t.reduce((_, T) => _ + T.runs.reduce((k, P) => k + (P.images ? P.images.length : 0), 0), 0), r = t.some((_) => _.inputs && Object.keys(_.inputs).length);
    for (const _ of i) this.steps.push({ id: "add:" + _.key, text: "Add " + br(_.name) + " to the frame", status: "pending" });
    if (this.steps.push({ id: "prompt", text: t.length > 1 ? "Set the prompt in " + t.length + " sessions" : "Set the prompt" + (r ? " and recommended settings" : ""), status: "pending" }), o && this.steps.push({ id: "attach", text: "Attach " + Hu(o, "image") + (o === s ? ", one per run" : ""), status: "pending" }), this.steps.push({ id: "run", text: s === 1 ? "Run it" : "Run " + s + " times", status: "pending" }), e.place && this.steps.push({ id: "place", text: "Set the results out under their sessions", status: "pending" }), this.emit(), !this.frame()) return this.fail(this.steps[0].id, "The frame is gone, so there's nowhere to put the work.");
    if (i.length) {
      const _ = this.frame(), T = KU(He(_), this.cmd.contents(_), i.length, Rt.w, Rt.h, I8);
      this.fit(T);
      for (let k = 0; k < i.length; k++) {
        const P = i[k], A = "add:" + P.key, R = this.stopIfCancelled(A);
        if (R) return R;
        this.set(A, { status: "running" });
        const D = this.cmd.modelOf(P.kitId, P.modelId);
        if (!D) return this.fail(A, P.model + " isn't on this board's tool list any more.");
        const O = T[k], F = this.cmd.addSession(D.kit, D.model, P.name, { x: O.x + O.w / 2, y: O.y + O.h / 2 });
        (F.x !== O.x || F.y !== O.y) && this.cmd.move(F.id, O.x, O.y), this.added[P.key] = F.id, this.set(A, { status: "done", text: "Added " + br(F.name || P.name) + " to the frame" });
      }
    }
    {
      const _ = this.stopIfCancelled("prompt");
      if (_) return _;
      this.set("prompt", { status: "running" });
      for (const T of t) {
        const k = this.toolOf(T);
        if (!k) return this.fail("prompt", br(T.name) + " is no longer on the board.");
        const P = this.cmd.promptOf(k);
        this.cmd.setPrompt(k, { prompt: T.prompt, n: T.n, inputs: { ...P.inputs || {}, ...T.inputs || {} } });
      }
      this.set("prompt", { status: "done", text: t.length > 1 ? "Set the prompt in " + t.length + " sessions" : "Set the prompt" + (r ? " and recommended settings" : "") });
    }
    const a = /* @__PURE__ */ new Map();
    for (const _ of t) {
      const T = this.toolOf(_);
      a.set(T, new Set(this.cmd.results(T).map((k) => k.id)));
    }
    let l = 0, d = 0;
    const c = /* @__PURE__ */ new Set();
    this.set("run", { status: "running", text: "Running 0 of " + s });
    for (const _ of t) {
      const T = this.toolOf(_);
      if (!T) return this.fail("run", br(_.name) + " is no longer on the board.");
      for (const k of _.runs) {
        const P = this.stopIfCancelled("run");
        if (P) return P;
        if (!await this.until(() => !this.cmd.submitting(T), this.sendTimeoutMs)) return this.fail("run", "The last run in " + br(_.name) + " is still being sent.");
        const R = this.cmd.error(T);
        if (c.has(T) && R) return this.fail("run", R);
        if (k.images && k.images.length) {
          const O = this.cmd.imageFields(T)[0];
          if (!O) return this.fail("attach", _.model + " takes no images.");
          d === 0 && this.set("attach", { status: "running" }), this.cmd.setRefInput(T, O.key, null);
          for (const F of k.images) {
            if (!this.cmd.setRefInput(T, O.key, F.url, this.cmd.assetOf(F.id, F.url))) return this.fail("attach", "An image couldn't be attached to " + br(_.name) + ".");
            d++;
          }
          this.set("attach", d >= o ? { status: "done", text: "Attached " + Hu(o, "image") + (o === s ? ", one per run" : "") } : { text: "Attaching " + d + " of " + o });
        }
        const D = this.cmd.generate(T);
        if (D) return this.fail("run", D);
        c.add(T), l++, this.set("run", { text: "Running " + l + " of " + s });
      }
    }
    const h = t.reduce((_, T) => _ + T.runs.length * T.n, 0);
    this.columns = t.map((_) => this.toolOf(_)).filter((_) => !!_);
    const f = /* @__PURE__ */ new Set(), p = (_) => this.cmd.results(_).filter((T) => T.status === "done" && !!T.url && !a.get(_).has(T.id)), y = () => {
      let _ = 0;
      for (const T of t) _ += p(this.toolOf(T) || "").length;
      return _;
    }, v = () => {
      let _ = !1;
      for (const k of t) {
        const P = this.toolOf(k);
        if (P) {
          if (this.cmd.submitting(P) || this.cmd.generating(P)) {
            _ = !0;
            continue;
          }
          e.place && this.placeFor(P, p(P), f);
        }
      }
      const T = y();
      return T !== this.results && (this.results = T, this.emit()), !_;
    }, x = await this.until(v, this.timeoutMs), w = t.map((_) => this.toolOf(_)).filter((_) => !!_).map((_) => this.cmd.error(_)).filter((_) => !!_);
    if (!x)
      return this.fail("run", "Still running after " + Math.round(this.timeoutMs / 6e4) + " minutes. The results will land in their sessions when they finish.");
    if (w.length && this.results < h)
      return this.fail("run", w[0]);
    const S = t.length === 1 ? this.cmd.element(this.toolOf(t[0]) || "") : void 0, M = S && S.type === "tool" ? S.name : t[0].name;
    return this.set("run", { status: "done", text: Hu(this.results, "result") + " landed" + (t.length === 1 ? " in " + br(M) : "") }), e.place && this.set("place", { status: f.size ? "done" : "failed", text: f.size ? "Set " + Hu(f.size, "result") + " out under " + (t.length === 1 ? "the session" : "their sessions") : "Set the results out under their sessions", ...f.size ? {} : { detail: "No results to place" } }), this.outcome("done");
  }
  /**
   * Where this plan's results start: one row, under whatever is already in
   * every one of its sessions' columns, so a comparison reads as a grid (a
   * row per prompt, a column per tool). Worked out when the first result is
   * ready, so a run started before anything else was placed starts higher.
   */
  firstRow() {
    if (this.rowY != null) return this.rowY;
    const e = this.frame(), t = e ? this.cmd.contents(e) : [];
    let i = -1 / 0;
    for (const s of this.columns) {
      const o = this.cmd.element(s);
      o && (i = Math.max(i, YU(He(o), t, 0, 0).y));
    }
    return this.rowY = Number.isFinite(i) ? i : 0, this.rowY;
  }
  /** A session's new results onto the board, in its column from the plan's row down, the frame growing to hold them. */
  placeFor(e, t, i) {
    const s = this.frame(), o = this.cmd.element(e);
    if (!s || !o) return;
    const r = He(o), a = t.filter((l) => !i.has(l.id)).sort((l, d) => l.createdAt - d.createdAt);
    if (a.length) {
      this.step("place").status === "pending" && this.set("place", { status: "running" });
      for (const l of a) {
        const d = XU(Math.min(QU, r.w), l.w, l.h), c = this.nextY.has(e) ? this.nextY.get(e) : this.firstRow(), h = { x: r.x, y: c, w: d.w, h: d.h };
        this.fit([h]), this.cmd.place(l, h) && (i.add(l.id), this.nextY.set(e, c + d.h + pm));
      }
    }
  }
}
function A8(n) {
  for (let e = n.length - 1; e >= 0; e--) {
    const t = n[e];
    if (t.role === "agent") return t.memo || null;
  }
  return null;
}
var tG = Object.defineProperty, nG = (n, e, t) => e in n ? tG(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Vu = (n, e, t) => nG(n, typeof e != "symbol" ? e + "" : e, t);
const fm = [
  "A glass pavilion in a pine forest at dawn",
  "A timber library on a lake at dusk",
  "A rooftop garden café in the rain"
], P8 = /* @__PURE__ */ new Set(["image", "imageEdit"]), iG = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, twelve: 12 };
function Do(n) {
  const e = /\b(\d{1,2}|one|two|three|four|five|six|seven|eight|nine|ten|twelve)\b/i.exec(n);
  if (!e) return null;
  const t = /\d/.test(e[1]) ? Number(e[1]) : iG[e[1].toLowerCase()];
  return Number.isFinite(t) && t > 0 ? t : null;
}
function es(n, e, t = e + "s") {
  return n + " " + (n === 1 ? e : t);
}
function ca(n) {
  return n && n.charAt(0).toUpperCase() + n.slice(1);
}
function nr(n) {
  return n.length <= 1 ? n.join("") : n.slice(0, -1).join(", ") + " and " + n[n.length - 1];
}
function Kn(n) {
  return "**" + n + "**";
}
function ml(n) {
  return n.trim().replace(/^(now\s+)?(try|run|do|prompt|another( one)?|next)\s*[:,-]\s*/i, "").replace(/^["“'‘]+|["”'’]+$/g, "").trim();
}
function ql(n, e, t) {
  const i = " " + Rl(n) + " ", s = [], o = [], r = (l, d) => !o.some(([c, h]) => l < h && d > c), a = e.entries().filter((l) => l.kits.some((d) => P8.has(d.id))).map((l) => ({ e: l, n: Rl(l.name) })).filter((l) => l.n.length >= 4).sort((l, d) => d.n.length - l.n.length);
  for (const { e: l, n: d } of a) {
    const c = i.indexOf(" " + d + " ");
    c < 0 || !r(c, c + d.length + 2) || (o.push([c, c + d.length + 2]), s.push({ at: c, entry: l }));
  }
  for (const l of t.families) {
    const d = new RegExp(l.match.source, "gi");
    let c;
    for (; c = d.exec(i); )
      if (r(c.index, c.index + c[0].length)) {
        o.push([c.index, c.index + c[0].length]), s.push({ at: c.index, family: l });
        break;
      }
  }
  return s.sort((l, d) => l.at - d.at);
}
function mm(n, e, t) {
  if (n.entry) return { entry: n.entry, others: [] };
  const i = n.family, s = i.members.map((r) => t.get(r)).filter((r) => !!r), o = i.pick[e] || i.pick.default;
  return o && t.has(o.id) ? { entry: t.get(o.id), why: o.why, family: i, others: s.filter((r) => r.id !== o.id) } : { entry: null, family: i, others: s, note: i.note };
}
function ts(n, e, t) {
  return t.jobs[n].picks.filter((i) => e.has(i.id)).map((i) => ({ entry: e.get(i.id), why: i.why }));
}
function sG(n, e) {
  const t = n.price(e, { prompt: "x", n: 1 }, 1);
  return t == null ? "" : "about " + k8(t) + " a picture";
}
function vp(n) {
  return /\b(sign|signage|text|lettering|typograph|poster|logo type|wordmark|label)/i.test(n) ? "text" : /\b(logo|icon|vector|flat|graphic|illustration|design)/i.test(n) ? "design" : /\b(draft|quick|fast|cheap|rough|sketch)/i.test(n) ? "drafts" : /\b(edit|change|relight|restyle|retouch)/i.test(n) ? "edit" : /\b(compar|side by side|shoot-?out)/i.test(n) ? "compare" : "photoreal";
}
function E8(n) {
  return n.notes.map((e) => e.text.replace(/^\s*(client|note|brief|nb|todo)\s*:\s*/i, "").replace(/\s+/g, " ").trim()).filter(Boolean);
}
function R8(n) {
  const e = n.trim();
  return e ? ca(e) + (/[.!?]$/.test(e) ? "" : ".") : "";
}
function Vo(n) {
  const e = [];
  return n.images.length && e.push({ label: "Make these night scenes", send: "Change " + (n.images.length === 1 ? "this image" : "all " + n.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }), n.sessions.length && e.push({ label: "Run a new prompt here", send: "Now try: " + fm[0].toLowerCase() }), e.push({ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }), e.push({ label: "Prompting tips", send: "How should I prompt Ideogram for signage text?" }), {
    text: `I can't do that one in this prototype. Here's what I can do with this frame:
- change the images in it with a tool you name
- recommend tools and set up a side-by-side comparison
- run a new prompt through the sessions in it
- make new pictures from a prompt
- give prompting tips for a tool

Every plan shows its token cost, and nothing runs until you press Run plan.`,
    chips: e
  };
}
function oG(n) {
  const e = y8(n), t = e === "Empty" ? "which is empty so far" : "which holds " + e, i = n.images.length ? [{ label: "Make these night scenes", send: "Change " + (n.images.length === 1 ? "this image" : "all " + n.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }, { label: "What's in this frame?" }] : [{ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }, { label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }];
  return i.push({ label: "Which tools are best for photoreal?" }), {
    text: "Hi! I work on what's in “" + n.title + "”, " + t + ". I set up tool sessions here and run them for you, always with a priced plan you approve first. What should we do?",
    chips: i
  };
}
function rG(n) {
  const e = ["Here's what's in “" + n.title + "”:"];
  n.images.forEach((t, i) => {
    const s = t.model ? t.prompt ? ": made with " + t.model + " from “" + Qs(t.prompt, 90) + "”" : ": made with " + t.model : ": an image I have no record of";
    e.push(i + 1 + ". Image " + (i + 1) + s);
  });
  for (const t of n.sessions) e.push("- Session " + Kn(t.name) + " (" + t.model + ")" + (t.prompt ? ", prompt “" + Qs(t.prompt, 70) + "”" : "") + ", " + es(t.results, "result"));
  for (const t of n.notes) e.push("- Note: “" + Qs(t.text, 100) + "” (I treat notes as standing instructions)");
  return e.length === 1 && e.push("Nothing yet. Add images, sessions or notes to the frame and I'll read them."), n.ignored && e.push(`
I leave out ` + es(n.ignored, "shape or nested frame", "shapes and nested frames") + "."), { text: e.join(`
`) };
}
function Qs(n, e) {
  const t = n.replace(/\s+/g, " ").trim();
  return t.length > e ? t.slice(0, e - 1).trimEnd() + "…" : t;
}
function Hw(n) {
  return /\b(change|turn|make|convert|edit|transform|restyle|relight|redo|update|switch)\b/i.test(n) && /\b(these|this|them|those|all|every|each|the)\b(\s+\w+){0,3}\s*\b(images?|pictures?|renders?|photos?|shots?|views?|ones)\b|\b(them|these|all of (them|these)|each of (them|these))\b/i.test(n);
}
function aG(n) {
  const e = /\b(?:to|into|as)\s+(.+?)(?:\s+\b(?:with|using|in|via|on)\b\s+.*|[.!?\n]|$)/i.exec(n);
  return e ? e[1].trim().replace(/^(an?|the)\s+/i, (t) => t.toLowerCase()) : "";
}
function lG(n, e, t) {
  const i = n.edits.findIndex((a) => a.match.test(e)), s = i >= 0 ? n.edits[i] : null, r = [
    "Turn this image into " + (s ? s.change : e || "the change described") + ".",
    "Keep the same building, camera angle, framing and materials."
  ];
  s && r.push(s.light);
  for (const a of t) r.push(R8(a));
  return r.push("Photorealistic architectural photograph."), { prompt: r.join(" "), name: s ? s.name : ca(Qs(e || "Edited", 24)) + (s ? "" : " versions"), recipe: i };
}
function pc(n) {
  return Math.max(1, n.model.numResults.max);
}
function yp(n, e, t, i, s) {
  const o = Math.min(s.n, pc(i)), r = E8(e), { prompt: a, name: l, recipe: d } = lG(n, s.change, r), c = hm(n, i.id), h = {};
  for (const p of c && c.settings || []) h[p.field] = p.value;
  s.quality && (h.Quality = s.quality), c && c.sizeFromInput && (h.size = "match");
  const f = {
    name: l,
    modelId: i.id,
    job: "edit",
    prompt: a,
    n: o,
    runs: t.map((p) => ({ imageIds: [p.id] })),
    settings: h,
    ...s.why ? { why: s.why } : {}
  };
  return {
    plan: {
      title: l,
      summary: "One session, one run per image, each with that image as its input" + (o > 1 ? ", " + o + " results a run" : "") + ".",
      sessions: [f]
    },
    recipe: d,
    name: l
  };
}
function dG(n, e, t) {
  const { context: i, catalog: s, guidance: o } = n;
  if (!i.images.length)
    return {
      text: "There are no images in “" + i.title + "” to change. Drag some into the frame, or ask me to make new ones.",
      chips: [{ label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }]
    };
  const r = Do(e.replace(/\b2\.5\b/g, "")), l = (r && r < i.images.length && /\b(first|these|the)\b/i.test(e) ? i.images.slice(0, r) : i.images).filter((F) => !F.video);
  if (!l.length) return { text: "Those are videos, and this prototype only edits still images." };
  const d = /(\d+|two|three|four)\s+(versions?|results?|options?|variations?)\s+(each|per image|of each)/i.exec(e), c = d && Do(d[1]) || 1, h = aG(e) || t && t.change || "", f = ql(e, s, o), p = [];
  let y = null, v = "";
  if (f.length) {
    const F = mm(f[0], "edit", s);
    if (F.entry && F.entry.imageField)
      y = F.entry, F.family && F.others.length ? (v = F.why || "", p.push(F.family.name + " comes in " + so(F.others.length + 1) + " versions here, " + nr([F.entry, ...F.others].map((ie) => ie.name.replace(F.family.name, "").trim() || ie.name)) + ". I picked " + Kn(F.entry.name) + ": " + v + ".")) : p.push("I'll use " + Kn(F.entry.name) + ".");
    else {
      const ie = F.entry ? F.entry.name : F.family ? F.family.name : "That tool", ee = ts("edit", s, o)[0];
      if (!ee) return Vo(i);
      y = ee.entry, v = ee.why, p.push((F.note || ie + " can't take an image as input, so it can't change these.") + " " + Kn(y.name) + " can: " + ee.why + ". I've used it instead.");
    }
  } else {
    const F = ts("edit", s, o)[0];
    if (!F) return Vo(i);
    y = F.entry, v = F.why, p.push("I'll use " + Kn(y.name) + ", RunDiffusion's pick for edits: it " + F.why + ".");
  }
  const x = yp(o, i, l, y, { change: h, n: c, quality: void 0, why: v }), w = Ev(x.plan, i, s);
  let S = x.plan;
  if (!w.ok) {
    const F = ts("edit", s, o).find((ie) => ie.entry.id !== y.id && Ev(yp(o, i, l, ie.entry, { change: h, n: c }).plan, i, s).ok);
    if (!F) return { text: y.name + " can't run this: " + w.error + " I couldn't find another tool here that can." };
    p.length = 0, p.push(y.name + " can't run this as asked (" + w.error.replace(/\.$/, "") + "). " + Kn(F.entry.name) + " can: it " + F.why + ". I've used it instead."), y = F.entry, S = yp(o, i, l, y, { change: h, n: c }).plan;
  }
  const M = l.length, _ = M === 1 ? "I'll edit this image with the change you asked for." : "I'll edit each image on its own so the " + so(M) + " stay comparable: one session, one run per image, each with that image as its input.", T = E8(i);
  T.length && p.push("I kept " + (T.length === 1 ? "your note" : "your notes") + " in the prompt: " + T.map((F) => "“" + Qs(F, 80).replace(/[.!]+$/, "") + "”").join(", ") + ".");
  const k = hm(o, y.id), P = (k && k.settings ? k.settings.map((F) => F.say) : []).concat(k && k.sizeFromInput ? ["sized to match your images"] : []);
  P.length && p.push((/recommended/i.test(e) ? "Recommended settings, as you asked: " : "Recommended settings: ") + nr(P) + ".");
  const A = [], R = o.families.find((F) => F.members.includes(y.id) && F.members.length > 1) || null, D = R ? R.members.map((F) => s.get(F)).find((F) => F && F.id !== y.id && !!F.imageField) : null;
  R && D && A.push({ label: "Use " + (D.name.replace(R.name, "").trim() || D.name) + " instead", send: "Use " + D.name + " instead" });
  const O = S.sessions[0] ? S.sessions[0].n : 1;
  return O === 1 && pc(y) > 1 && A.push({ label: "2 versions per image", send: "Make 2 versions per image" }), s.field(y, "Quality") && A.push({ label: "Medium quality, cheaper", send: "Use medium quality" }), {
    status: "Reading the frame…",
    text: [_, ...p].join(`

`),
    plan: S,
    chips: A,
    memo: { flow: "edit", step: "proposed", modelId: y.id, imageIds: l.map((F) => F.id), change: h, n: O, quality: t ? t.quality : void 0 }
  };
}
function cG(n, e, t) {
  const { context: i, catalog: s, guidance: o } = n;
  let r = t.modelId ? s.get(t.modelId) : null;
  if (!r) return null;
  const a = [];
  let l = t.n || 1, d = t.quality;
  const c = ql(e, s, o);
  let h = !1;
  if (/\b(instead|switch|swap|use)\b/i.test(e) && c.length) {
    const x = mm(c[0], "edit", s);
    if (x.entry && x.entry.imageField && x.entry.id !== r.id)
      r = x.entry, a.push("Switched to " + Kn(r.name) + "."), h = !0;
    else if (x.entry && !x.entry.imageField)
      return { text: x.entry.name + " can't take an image as input, so I've kept " + r.name + "." };
  }
  const f = /(\d+|two|three|four)\s+(versions?|results?|options?|variations?)/i.exec(e);
  if (f) {
    const x = Math.max(1, Math.min(4, Do(f[1]) || 1));
    l = Math.min(x, pc(r)), a.push(l < x ? r.name + " makes " + es(pc(r), "result") + " a run, so it stays at " + es(l, "result") + " per image." : es(l, "result") + " per image."), h = !0;
  }
  const p = /\b(low|medium|high|extra high|xhigh|max)\b\s*quality|\bquality\s*(low|medium|high|max)\b|\bcheaper\b/i.exec(e);
  if (p && s.field(r, "Quality")) {
    const x = (p[1] || p[2] || "medium").toLowerCase().replace("extra high", "xhigh");
    d = p[0].toLowerCase().includes("cheaper") && !p[1] && !p[2] ? "medium" : x, a.push(ca(d === "xhigh" ? "extra high" : d) + " quality."), h = !0;
  }
  if (!h) return null;
  const y = (t.imageIds || []).map((x) => i.images.find((w) => w.id === x)).filter((x) => !!x);
  if (!y.length) return null;
  const v = yp(o, i, y, r, { change: t.change || "", n: l, quality: d });
  return {
    text: "Here's the plan again with that change. " + a.join(" "),
    plan: v.plan,
    chips: v.plan.sessions[0].n === 1 && pc(r) > 1 ? [{ label: "2 versions per image", send: "Make 2 versions per image" }] : [],
    memo: { ...t, modelId: r.id, n: v.plan.sessions[0].n, quality: d }
  };
}
function uG(n) {
  return /\bcompar(e|ing|ison)\b|\bside[- ]by[- ]side\b|\bshoot-?out\b|\bhead[- ]to[- ]head\b|\bacross\s+(\d+|two|three|four)\s+(different\s+)?(image\s+)?(tools|models)\b/i.test(n);
}
function Vw(n, e) {
  const { catalog: t, guidance: i } = n, s = i.jobs.compare, o = ts("compare", t, i);
  if (o.length < 2) return { text: "There aren't enough image tools on this board's tool list to compare." };
  const r = Math.min(o.length, Do(e) && Do(e) >= 2 && Do(e) <= 5 ? Do(e) : s.suggest || 3), a = [s.intro + " From RunDiffusion's guidance:", ""];
  return o.forEach((l, d) => {
    const c = sG(t, l.entry);
    a.push(d + 1 + ". " + Kn(l.entry.name) + ": " + l.why + (c ? ". " + ca(c) + "." : "."));
  }), a.push("", "My " + so(r) + ": " + nr(o.slice(0, r).map((l) => l.entry.name)) + ", a good spread of strengths at a fair price. Pick yours below, or name them."), {
    status: "Checking the tool list…",
    text: a.join(`
`),
    chips: [{ label: "Use your top " + r, send: "Use your top " + r }].concat(o.map((l) => ({ label: l.entry.name, send: l.entry.name }))),
    memo: { flow: "rig", step: "pick", picks: [], n: r }
  };
}
function Vd(n) {
  return /\b(tuned?|tuning|per[- ]tool|optimi[sz]ed?|each its own|adapt)/i.test(n) ? "tuned" : /\b(exact|same|identical|fair|verbatim|as[- ]is|one prompt)\b/i.test(n) ? "exact" : null;
}
function Wd(n) {
  const e = n.indexOf(":");
  return e >= 0 ? ml(n.slice(e + 1)) : "";
}
function xp(n) {
  const e = n.trim();
  return e.length < 8 || /\?$/.test(e) || /^(yes|yeah|yep|no|nope|ok|okay|sure|thanks|thank you|cool|great|nice|done|that'?s it)\b/i.test(e) ? !1 : /\b(a|an|the)\b/i.test(e) || e.split(/\s+/).length >= 4;
}
function Ww(n, e, t) {
  const { catalog: i, guidance: s } = n, o = t.n || s.jobs.compare.suggest || 3;
  let r = (t.picks || []).filter((l) => i.has(l));
  const a = [];
  if (t.step === "pick") {
    if (/\b(top|your|recommended|suggested|default)\b.*\b(\d|three|two|four|picks?|ones)\b|\byour picks\b|\bgo with yours\b|\bsounds good\b/i.test(e))
      r = ts("compare", i, s).slice(0, o).map((c) => c.entry.id);
    else {
      const c = ql(e, i, s);
      if (!c.length && !/\b(that'?s it|just these|done|only these)\b/i.test(e)) return null;
      const h = c.map((p) => mm(p, "compare", i)), f = new Set(h.filter((p) => p.entry && !p.entry.needsImage).map((p) => p.entry.id));
      for (const p of h) {
        if (p.entry && !p.entry.needsImage) {
          r.includes(p.entry.id) || r.push(p.entry.id), p.family && p.others.length && p.why && a.push("For " + p.family.name + " I took " + Kn(p.entry.name) + ": " + p.why + ".");
          continue;
        }
        const y = ts("compare", i, s).find((w) => !r.includes(w.entry.id) && !f.has(w.entry.id)), v = p.entry ? p.entry.name : p.family ? p.family.name : "That tool", x = p.note || v + " needs an image to start from, so it can't run a prompt on its own.";
        y ? (r.push(y.entry.id), f.add(y.entry.id), a.push(x + " I've put " + Kn(y.entry.name) + " in its place: " + y.why + ".")) : a.push(x);
      }
      if (r.length < 2 || r.length < o && !/\b(that'?s it|just these|done|only these)\b/i.test(e)) {
        const p = ts("compare", i, s).filter((v) => !r.includes(v.entry.id)), y = r.map((v) => i.get(v).name);
        return {
          text: [a.join(" "), (y.length ? nr(y) + ", noted. " : "") + (o - r.length === 1 ? "One more: pick it below, or name it." : o - r.length + " more: pick them below, or name them.") + (r.length >= 2 ? " Or say “that's it” to compare just these." : "")].filter(Boolean).join(`

`),
          chips: p.map((v) => ({ label: v.entry.name, send: v.entry.name })),
          memo: { ...t, picks: r }
        };
      }
    }
    const l = Vd(e), d = Wd(e);
    return Wu(n, { ...t, picks: r, mode: l || void 0, prompt: d || void 0 }, a);
  }
  if (t.step === "mode") {
    const l = Vd(e), d = Wd(e) || (!l && xp(e) ? ml(e) : "");
    if (!l && !d) return null;
    const c = !l && d ? ["I'll keep the exact same prompt for all of them, the fairest test. Say “tuned” to word it for each tool instead."] : [];
    return Wu(n, { ...t, mode: l || "exact", prompt: d || t.prompt }, c);
  }
  if (t.step === "prompt") {
    const l = Vd(e), d = /:/.test(e) ? Wd(e) : ml(e);
    return !xp(d) && !(d && d.split(/\s+/).length >= 2) ? null : Wu(n, { ...t, mode: l || t.mode, prompt: d }, []);
  }
  if (t.step === "proposed") {
    const l = Vd(e), d = /:/.test(e) ? Wd(e) : xp(e) && !l ? ml(e) : "";
    return !l && !d ? null : Wu(n, { ...t, mode: l || t.mode, prompt: d || t.prompt }, ["Here's the rig again with that change."]);
  }
  return null;
}
function Wu(n, e, t) {
  const { catalog: i, guidance: s } = n, o = (e.picks || []).map((d) => i.get(d)).filter((d) => !!d), r = nr(o.map((d) => Kn(d.name)));
  if (!e.mode)
    return {
      text: [t.join(" "), r + " it is. Should " + (o.length === 2 ? "both" : "all " + so(o.length)) + " get the exact same prompt, which is the fairest test, or should I tune the wording for each tool, closer to how each is best used? Then tell me the prompt."].filter(Boolean).join(`

`),
      chips: [{ label: "Exact prompt" }, { label: "Tuned per tool" }],
      memo: { ...e, flow: "rig", step: "mode" }
    };
  if (!e.prompt)
    return {
      text: [t.join(" "), (e.mode === "exact" ? "Exact prompt it is: every tool gets the same words." : "Tuned it is: I'll word the prompt for each tool, from RunDiffusion's prompt tips.") + " What's the prompt?"].filter(Boolean).join(`

`),
      chips: fm.map((d) => ({ label: d })),
      memo: { ...e, flow: "rig", step: "prompt" }
    };
  const a = e.prompt, l = o.map((d) => ({
    name: d.name,
    modelId: d.id,
    job: "generate",
    prompt: e.mode === "tuned" ? x8(s, d.id, a) : a,
    n: 1,
    why: (s.jobs.compare.picks.find((c) => c.id === d.id) || { why: "" }).why
  }));
  return {
    status: "Laying out the rig…",
    text: [
      t.join(" "),
      "Here's the rig: " + so(o.length) + " sessions side by side in this frame, " + (e.mode === "tuned" ? "each with the prompt worded for its tool" : "the same prompt in each") + ", one picture apiece. Results land under their tools, so you can compare them right here.",
      e.mode === "tuned" ? "Each session's wording is on the plan; open any session to change it." : ""
    ].filter(Boolean).join(`

`),
    plan: {
      title: "Compare " + o.length + " tools",
      summary: o.length + " sessions side by side under one prompt: “" + Qs(a, 80) + "”.",
      place: !0,
      sessions: l
    },
    memo: { ...e, flow: "rig", step: "proposed" }
  };
}
function hG(n, e) {
  return /^\s*(now\s+)?(try|run|do)\s*[:,-]/i.test(n) || /^\s*now try\b/i.test(n) || /^\s*(another( one)?|next( prompt)?)\s*:/i.test(n) || /\brun\b.*\b(across|through|in)\b.*\b(all|each|every|these|the)\b.*\b(sessions?|tools?)\b/i.test(n) ? !0 : !!e && e.step === "ready" && xp(n) && !/\b(how|what|which|why)\b/i.test(n);
}
function pG(n, e, t) {
  const { context: i, catalog: s, guidance: o } = n, r = /:/.test(e) ? Wd(e) : ml(e.replace(/\brun\b.*\b(across|through)\b.*?\b(sessions?|tools?)\b[:,]?/i, ""));
  if (!r) return { text: "What's the prompt? Write it after “Now try:” and I'll run it through every session here." };
  const a = [], l = [];
  for (const f of i.sessions) {
    const p = f.nodeDefId ? s.get(f.nodeDefId) : null;
    !p || p.needsImage || !P8.has(f.kitId) ? l.push(f.name) : a.push(f);
  }
  if (!a.length)
    return { text: "None of the sessions here can run a prompt on its own" + (l.length ? " (" + nr(l) + " need an image to start from)" : "") + ". Want me to set up a comparison instead?", chips: [{ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }] };
  const d = Vd(e) || t && t.mode || "exact", c = a.map((f) => ({
    toolId: f.id,
    name: f.name,
    modelId: f.nodeDefId,
    prompt: d === "tuned" ? x8(o, f.nodeDefId, r) : r,
    n: 1
  })), h = a.length === 1 ? "the session" : a.length === 2 ? "both sessions" : "all " + so(a.length) + " sessions";
  return {
    status: "Reading the frame…",
    text: [
      "I'll run it through " + h + " in this frame, " + (d === "tuned" ? "with the wording tuned for each tool" : "the exact same prompt in each") + (t && t.mode ? ", as before" : "") + ". The results land in a new row under each tool.",
      l.length ? "I've left out " + nr(l) + ": " + (l.length === 1 ? "it needs" : "they need") + " an image to start from." : "",
      !t || !t.mode ? "Say “tuned” to word it for each tool instead." : ""
    ].filter(Boolean).join(`

`),
    plan: {
      title: "New prompt across " + es(a.length, "session"),
      summary: "“" + Qs(r, 90) + "”, through " + h + " here.",
      place: !0,
      sessions: c
    },
    memo: { flow: "reuse", step: "proposed", mode: d, prompt: r }
  };
}
function fG(n) {
  return /\?\s*$/.test(n) || /^(how|what|which|why|when|should|can|could|is|are|do|does|any)\b/i.test(n.trim()) || /\b(tips?|advice|best way)\b/i.test(n);
}
function mG(n, e) {
  const { catalog: t, guidance: i } = n, s = ql(e, t, i), o = vp(e);
  if (/\bprompt|tips?|advice|best way|write\b/i.test(e) && s.length) {
    const r = s[0], a = r.entry ? r.entry.id : r.family ? r.family.members[0] : "", l = a ? hm(i, a) : null, d = r.entry ? r.entry.name : r.family ? r.family.name : "";
    if (l) {
      const c = [(l.tips.length > 3 ? ca(so(l.tips.length)) + " things" : "A few things") + " that help " + d + (o === "text" ? " with signage and lettering" : "") + ":"];
      for (const p of l.tips) c.push("- " + p);
      const h = r.family && r.family.note, f = ts(o, t, i)[0];
      return h && c.push("", "On this board: " + h + (f && o !== "edit" ? " For a new picture with " + (o === "text" ? "signage" : "this kind of work") + ", " + Kn(f.entry.name) + " is the strongest here: " + f.why + "." : "")), { status: "Looking it up…", text: c.join(`
`), chips: o === "text" ? [{ label: "Which tools are best for text?" }] : [] };
    }
  }
  if (/\b(best|which|recommend|good)\b/i.test(e)) {
    const r = i.jobs[o], a = ts(o, t, i);
    if (a.length) {
      const l = [r.intro];
      for (const d of a) l.push("- " + Kn(d.entry.name) + ": " + d.why + ".");
      return {
        status: "Checking the tool list…",
        text: l.join(`
`),
        chips: [{ label: "Compare the top 3", send: "Compare " + nr(a.slice(0, 3).map((d) => d.entry.name)) + " side by side" }]
      };
    }
  }
  return Vo(n.context);
}
function so(n) {
  return ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"][n] || String(n);
}
function gG(n) {
  return /\b(make|create|generate|render|draw|design|imagine|give me|show me|produce)\b/i.test(n);
}
function bG(n, e) {
  const { catalog: t, guidance: i } = n, s = ql(e, t, i), o = vp(e) === "edit" || vp(e) === "compare" ? "photoreal" : vp(e);
  let r = null, a = "";
  const l = [];
  if (s.length) {
    const y = mm(s[0], o, t);
    if (y.entry && !y.entry.needsImage)
      r = y.entry, a = y.why || "", y.family && y.others.length && a && l.push("For " + y.family.name + " I took " + Kn(r.name) + ": " + a + ".");
    else {
      const v = ts(o, t, i)[0];
      if (!v) return Vo(n.context);
      l.push((y.note || (y.entry ? y.entry.name : "That tool") + " needs an image to start from.") + " I've used " + Kn(v.entry.name) + " instead: " + v.why + "."), r = v.entry;
    }
  } else {
    const y = ts(o, t, i)[0];
    if (!y) return Vo(n.context);
    r = y.entry, a = y.why, l.push("I'll use " + Kn(r.name) + ", RunDiffusion's pick for " + i.jobs[o].label.toLowerCase() + ": " + a + ".");
  }
  const d = ml(e.replace(/^\s*(please\s+)?(can you\s+)?(make|create|generate|render|draw|design|imagine|give me|show me|produce)\s+(me\s+)?/i, "").replace(/^(\d+|one|two|three|four|five|six|seven|eight|nine|ten|twelve|a|an|some)\s+/i, "").replace(/^((concept|new|quick|fresh)\s+)*(images?|pictures?|renders?|options?|versions?|concepts?|variations?|shots?)\s+(of\s+)?/i, "").replace(/\s+(with|using|in)\s+[^,]*?(nano banana|chatgpt|flux|seedream|ideogram|gpt)[^,.]*$/i, ""));
  if (!d || d.split(/\s+/).length < 2)
    return { text: "What should the pictures show? Describe the subject and I'll plan it.", chips: fm.map((y) => ({ label: y, send: "Make 4 images of " + y.charAt(0).toLowerCase() + y.slice(1) })) };
  const c = Math.max(1, Math.min(12, Do(e.replace(/\b\d\.\d\b/g, "")) || 1)), h = t.results(r, c), f = Math.ceil(c / h), p = R8(d).replace(/\.$/, "") + ". " + (o === "photoreal" ? "Photorealistic architectural photograph, natural light." : "");
  return {
    status: "Reading the frame…",
    text: [
      "I'll add a session to this frame and make " + es(c, "picture") + (f > 1 ? " in " + f + " runs of " + h : "") + ". They'll land under the session.",
      ...l
    ].join(`

`),
    plan: {
      title: ca(Qs(d, 32)),
      summary: "One new session, " + es(c, "picture") + ".",
      place: !0,
      sessions: [{ name: ca(Qs(d.split(/[,.]/)[0], 28)), modelId: r.id, job: "generate", prompt: p.trim(), n: h, runs: Array.from({ length: f }, () => ({ imageIds: [] })), ...a ? { why: a } : {} }]
    },
    memo: { flow: "make", step: "proposed" }
  };
}
function vG(n, e) {
  const t = A8(n.history) || {}, i = e.results || 0;
  if (e.status === "cancelled") return null;
  if (e.status === "failed" || e.status === "stopped")
    return {
      text: "The plan stopped" + (e.error ? ": " + e.error.replace(/\.$/, "") : "") + "." + (i ? " " + es(i, "result") + " made it before it did." : " Nothing was charged for the steps that didn't run."),
      chips: [{ label: "What's in this frame?" }],
      memo: t
    };
  const s = e.sessions.some((r) => r.runs.some((a) => a.images && a.images.length));
  if (!s && (e.sessions.length > 1 || e.sessions.every((r) => !!r.toolId))) {
    const r = e.sessions.length, a = e.sessions.map((d) => Rl(d.prompt)), l = fm.filter((d) => !a.some((c) => c.includes(Rl(d))));
    return {
      text: (r === 2 ? "Both are" : r === 1 ? "It's" : "All " + so(r) + " are") + " in, side by side under " + (r === 1 ? "the session" : "their tools") + ". Want to run another prompt across " + (r === 2 ? "both" : r === 1 ? "it" : "all " + so(r)) + "? Just type it, like “Now try: " + l[0].toLowerCase() + "”.",
      chips: l.slice(0, 2).map((d) => ({ label: "Now try: " + d.toLowerCase() })),
      memo: { flow: "rig", step: "ready", mode: t.mode || "exact" }
    };
  }
  if (s) {
    const r = e.sessions[0];
    return {
      text: "Done: " + es(i, "result") + " in “" + (r ? r.name : e.title) + "”. Click a thumbnail on the session to see one full size, or drag it onto the board.",
      chips: [{ label: "Make them dusk instead", send: "Change all of these images to dusk" }, { label: "What's in this frame?" }],
      memo: { flow: "edit", step: "ready" }
    };
  }
  return {
    text: "Done: " + es(i, "result") + " in the frame.",
    chips: [{ label: "What's in this frame?" }],
    memo: t
  };
}
function yG(n) {
  if (n.input.kind === "plan-ended") return vG(n, n.input.plan);
  const e = n.input.text.trim(), t = n.context, i = A8(n.history);
  if (!e) return Vo(t);
  if (/^(hi|hello|hey|hiya|yo|good (morning|afternoon|evening))\b[\s!.,]*$/i.test(e)) return oG(t);
  const s = /\bhow (should|do|can) i\b|\btips?\b|\badvice\b/i.test(e);
  if (i && i.flow === "rig" && (i.step === "pick" || i.step === "mode" || i.step === "prompt" || i.step === "proposed") && !s && !Hw(e)) {
    const o = Ww(n, e, i);
    if (o) return o;
  }
  if (i && i.flow === "edit" && i.step === "proposed" && !s) {
    const o = cG(n, e, i);
    if (o) return o;
  }
  if (/\bwhat('?s| is| are)?\s+(in|on)\s+(this|the)\s+frame\b|\bwhat do you see\b|\bdescribe (these|this|the)\b|\bwhat are these\b/i.test(e)) return rG(t);
  if (Hw(e) && !s) return dG(n, e, null);
  if (uG(e) && !s) {
    const o = ql(e, n.catalog, n.guidance);
    return o.length >= 2 && Ww(n, e, { flow: "rig", step: "pick", picks: [], n: o.length }) || Vw(n, e);
  }
  if (t.sessions.length && hG(e, i)) return pG(n, e, i);
  if (fG(e)) return mG(n, e);
  if (/\b(video|animate|animation|upscale|3d|mesh)\b/i.test(e)) {
    const o = Vo(t);
    return { ...o, text: "Video, upscale and 3D tools aren't part of this prototype's plans. " + o.text.replace("I can't do that one in this prototype. ", "") };
  }
  return gG(e) ? bG(n, e) : Vo(t);
}
const xG = (n) => new Promise((e) => window.setTimeout(e, n));
function z8(n) {
  const e = [], t = n.split(/(\s+)/);
  let i = "", s = 0;
  for (const o of t)
    i += o, /\S/.test(o) && s++, (s >= 2 || o.includes(`
`)) && (e.push(i), i = "", s = 0);
  return i && e.push(i), e;
}
class wG {
  constructor(e = {}) {
    Vu(this, "id", "simulated"), Vu(this, "label", "Simulated assistant"), Vu(this, "sleep"), Vu(this, "pace"), this.sleep = e.sleep || xG, this.pace = e.pace == null ? 1 : e.pace;
  }
  wait(e) {
    return this.pace > 0 ? this.sleep(e * this.pace) : Promise.resolve();
  }
  async *turn(e, t) {
    const i = yG(e);
    if (i) {
      yield { type: "status", text: i.status || "Thinking…" }, await this.wait(500 + Math.min(700, i.text.length * 1.5));
      for (const s of z8(i.text)) {
        if (t.aborted) return;
        yield { type: "text", delta: s }, await this.wait(16 + Math.random() * 22);
      }
      if (!t.aborted) {
        if (i.plan) {
          if (yield { type: "status", text: "Pricing the plan…" }, await this.wait(420), t.aborted) return;
          yield { type: "plan", plan: i.plan };
        }
        i.chips && i.chips.length && (yield { type: "chips", chips: i.chips }), i.memo && (yield { type: "memo", memo: i.memo });
      }
    }
  }
}
var kG = Object.defineProperty, _G = (n, e, t) => e in n ? kG(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, qu = (n, e, t) => _G(n, typeof e != "symbol" ? e + "" : e, t);
const $8 = 1, SG = 400, MG = 300 * 1024, Dv = 90, N1 = Dv * 24 * 3600 * 1e3, D8 = ["deletedAt", "hardDeleteAt", "deletedBy", "deletedByEmail", "shelvedAt"];
function Uc(n) {
  if (n === null || typeof n != "object") return JSON.stringify(n === void 0 ? null : n);
  if (Array.isArray(n)) return "[" + n.map(Uc).join(",") + "]";
  const e = n;
  return "{" + Object.keys(e).filter((i) => e[i] !== void 0).sort().map((i) => JSON.stringify(i) + ":" + Uc(e[i])).join(",") + "}";
}
function rf(n) {
  if (Array.isArray(n)) return n.map((e) => rf(e));
  if (n && typeof n == "object" && Object.getPrototypeOf(n) === Object.prototype) {
    const e = {};
    for (const [t, i] of Object.entries(n))
      i !== void 0 && (e[t] = rf(i));
    return e;
  }
  return n;
}
function zl(n) {
  return Uc(n).length;
}
function wp(n, e, t, i = {}) {
  const s = rf({ ...n, createdBy: n.createdBy || e, updatedBy: e, updatedAt: t, ...i });
  for (const o of D8) s[o] == null && delete s[o];
  return s;
}
function O8(n, e) {
  const t = { ...e };
  for (const i of D8) delete t[i];
  return { ...t, id: n };
}
function TG(n, e, t) {
  return { deletedAt: t, hardDeleteAt: t + N1, deletedBy: n, deletedByEmail: e || null, updatedBy: n, updatedAt: t };
}
function cg(n) {
  return !n || n.deletedAt ? "deleted" : n.shelvedAt ? "shelved" : "live";
}
function fc(n) {
  return !!(n && n.deletedAt);
}
function U1(n) {
  return !n || !n.deletedAt ? null : typeof n.hardDeleteAt == "number" ? n.hardDeleteAt : n.deletedAt + N1;
}
function L8(n) {
  let e = null;
  for (const t of Object.values(n)) {
    const i = U1(t);
    i != null && (e == null || i < e) && (e = i);
  }
  return e;
}
function CG(n, e, t) {
  let i = null;
  for (const [s, o] of e) {
    if (fc(s) || !fc(o)) continue;
    const r = U1(o);
    r != null && (i == null || r < i) && (i = r);
  }
  return i != null ? n != null && n < i ? n : i : n != null ? null : L8(t);
}
function IG(n, e, t) {
  const i = U1(e);
  return !e || i == null || i <= t ? null : {
    el: O8(n, e),
    deletedAt: e.deletedAt,
    hardDeleteAt: i,
    deletedBy: e.deletedBy || void 0,
    deletedByEmail: e.deletedByEmail || void 0
  };
}
class B8 {
  constructor(e = SG, t = MG) {
    qu(this, "maxElements", e), qu(this, "maxBytes", t), qu(this, "home", /* @__PURE__ */ new Map()), qu(this, "use", /* @__PURE__ */ new Map());
  }
  /** What a bucket holds now, from its document (a load, or anyone's write). */
  setBucket(e, t) {
    let i = 0, s = 0;
    for (const [o, r] of Object.entries(t))
      r && (s++, i += zl(r), this.home.has(o) || this.home.set(o, e));
    this.use.set(e, { count: s, bytes: i });
  }
  bucketOf(e) {
    return this.home.get(e);
  }
  buckets() {
    return Array.from(this.use.keys());
  }
  usage(e) {
    return this.use.get(e);
  }
  /** A home for a new element; `newBucketId` names a bucket when none has room. */
  place(e, t, i) {
    const s = this.home.get(e);
    if (s) return s;
    let o = null, r = -1;
    for (const [d, c] of this.use)
      c.count + 1 > this.maxElements || c.bytes + t > this.maxBytes || c.count > r && (o = d, r = c.count);
    const a = o || i(), l = this.use.get(a) || { count: 0, bytes: 0 };
    return this.use.set(a, { count: l.count + 1, bytes: l.bytes + t }), this.home.set(e, a), a;
  }
  /** An element's size changed (a long note, more thumbnails). */
  grow(e, t) {
    const i = this.home.get(e), s = i ? this.use.get(i) : void 0;
    s && (s.bytes = Math.max(0, s.bytes + t));
  }
}
function qw(n, e, t, i = /* @__PURE__ */ new Set()) {
  const s = { upserted: [], removed: [], trash: !1 }, o = /* @__PURE__ */ new Set();
  for (const [r, a] of Object.entries(t)) {
    if (!a || (o.add(r), e.add(r), i.has(r))) continue;
    const l = n.get(r);
    if (l && Uc(l) === Uc(a)) continue;
    n.set(r, a), (fc(l) || fc(a)) && (s.trash = !0);
    const d = cg(l);
    cg(a) === "live" ? s.upserted.push(O8(r, a)) : d === "live" && s.removed.push(r);
  }
  for (const r of Array.from(e)) {
    if (o.has(r) || i.has(r)) continue;
    e.delete(r);
    const a = n.get(r);
    n.delete(r), fc(a) && (s.trash = !0), cg(a) === "live" && s.removed.push(r);
  }
  return s;
}
function Ku(n, e) {
  if (!n) return e;
  if (e.kind === "patch") {
    if (n.kind === "put") {
      const t = { ...n.data };
      for (const [i, s] of Object.entries(e.fields))
        s === void 0 ? delete t[i] : t[i] = s;
      return { kind: "put", data: t };
    }
    return n.kind === "patch" ? { kind: "patch", fields: { ...n.fields, ...e.fields } } : n;
  }
  return e;
}
function ug(n, e) {
  if (e.kind === "put") return e.data;
  if (e.kind === "delete" || !n) return;
  const t = { ...n };
  for (const [i, s] of Object.entries(e.fields))
    s === void 0 ? delete t[i] : t[i] = s;
  return t;
}
const AG = 40 * 1024, Ov = 2e3;
function PG(n, e = 0) {
  let t = n.slice(-60), i = e + (n.length - t.length), s = zl(t);
  for (; t.length > 1 && s > AG; )
    s -= zl(t[0]) + 1, t = t.slice(1), i++;
  return { messages: t, dropped: i };
}
function EG(n) {
  const e = String(n || "").replace(/\r\n/g, `
`).trim();
  return e.length > Ov ? e.slice(0, Ov - 1).trimEnd() + "…" : e;
}
function cd(n, e) {
  const t = n.messages || [];
  for (let i = t.length - 1; i >= 0; i--) {
    const s = t[i].plan;
    if (s && s.id === e) return { index: i, message: t[i], plan: s };
  }
  return null;
}
function Yu(n, e, t) {
  return n.map((i) => i.plan && i.plan.id === e ? { ...i, plan: { ...i.plan, ...t } } : i);
}
function RG(n) {
  return n.map((e) => e.plan && e.plan.status === "proposed" ? { ...e, plan: { ...e.plan, status: "cancelled", error: "Replaced by a newer plan" } } : e);
}
function zG(n) {
  const e = n.messages || [];
  for (let t = e.length - 1; t >= 0; t--) {
    const i = e[t], s = (i.text || "").replace(/\*\*/g, "").replace(/\s+/g, " ").trim();
    if (s) return { who: i.role === "agent" ? "Assistant" : i.author || "Someone", text: s };
    if (i.plan) return { who: "Assistant", text: "Plan: " + i.plan.title };
  }
  return null;
}
function $G(n) {
  const e = n.messages || [];
  for (let t = e.length - 1; t >= 0; t--) if (e[t].plan) return e[t].plan;
  return null;
}
function F8(n) {
  return (n.messages ? n.messages.length : 0) + (n.dropped || 0);
}
function N8(n) {
  return String(n || "").replace(/^([ \t]*)—[ \t]*/gm, "$1- ").replace(/[ \t]*—[ \t]*/g, ", ").replace(/,([ \t]*,)+/g, ",").replace(/\bcoming soon\b/gi, (e) => e[0] === "C" ? "In development" : "in development");
}
function DG(n, e) {
  const t = n ? { usd: n.usd, credits: n.credits, turns: n.turns, byModel: { ...n.byModel } } : { usd: 0, credits: 0, turns: 0, byModel: {} };
  t.usd += e.usd || 0, t.credits += e.credits || 0, t.turns += 1;
  const i = t.byModel[e.model] || { usd: 0, turns: 0 };
  return t.byModel[e.model] = { usd: i.usd + (e.usd || 0), turns: i.turns + 1 }, t;
}
function hg(n) {
  return n === 0 ? "$0" : "$" + (n < 0.1 ? n.toFixed(4) : n.toFixed(2));
}
var OG = Object.defineProperty, LG = (n, e, t) => e in n ? OG(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, yn = (n, e, t) => LG(n, typeof e != "symbol" ? e + "" : e, t);
const BG = 464, Ci = "simulated", Lv = "unavailable";
class Kw {
  constructor(e) {
    yn(this, "reason", e), yn(this, "id", Lv), yn(this, "label", "Unavailable");
  }
  // eslint-disable-next-line require-yield
  async *turn() {
    yield { type: "text", delta: this.reason };
  }
}
const Yw = (n) => "rd-smart-frames-model:" + n;
class FG {
  constructor(e, t) {
    yn(this, "board", e), yn(this, "live", /* @__PURE__ */ Xt({})), yn(this, "brain", /* @__PURE__ */ qe(Ci)), yn(this, "agentStatus", /* @__PURE__ */ qe(null)), yn(this, "canSimulate"), yn(this, "showCosts"), yn(this, "endpoint"), yn(this, "asksAgent"), yn(this, "agentReady", null), yn(this, "usage", /* @__PURE__ */ Xt({})), yn(this, "driver"), yn(this, "simulated"), yn(this, "running", /* @__PURE__ */ new Map()), yn(this, "aborts", /* @__PURE__ */ new Map()), yn(this, "scope", c1(!0)), yn(this, "disposed", !1), yn(this, "open"), this.simulated = t || new wG(), this.canSimulate = !!t || P1, this.showCosts = !!e.user.isAdmin, this.endpoint = t ? null : e.agent ? { url: e.agent.url, token: e.agent.token, teamId: e.user.teamId || null } : null, this.asksAgent = !!this.endpoint, this.driver = this.canSimulate ? this.simulated : new Kw("The chat isn't available here."), this.brain.value = this.canSimulate ? Ci : Lv, this.endpoint && (this.agentReady = this.refreshAgent().catch(() => {
    })), this.open = this.scope.run(() => I(() => {
      const i = e.ui.chatOpen;
      if (!i) return null;
      e.rev(i).value;
      const s = e.store.get(i);
      return s && s.type === "chat" ? { ...s } : null;
    })), this.scope.run(() => {
      Ee(() => e.docRev.value, () => {
        const i = e.ui.chatOpen;
        i && !e.store.get(i) && (e.ui.chatOpen = null);
      }), Ee(() => e.ui.chatOpen, (i, s) => {
        i && (e.ui.boardHistory && (e.ui.boardHistory = !1), e.comments.ui.panelOpen && (e.comments.ui.panelOpen = !1), i !== s && this.onOpen(i));
      }), Ee(() => e.ui.boardHistory || e.comments.ui.panelOpen, (i) => {
        i && e.ui.chatOpen && (e.ui.chatOpen = null);
      }), Ee(() => e.ui.selection.slice(), (i) => {
        if (i.length !== 1 || e.ui.marquee) return;
        const s = e.store.get(i[0]);
        s && s.type === "chat" && e.ui.chatOpen !== s.id && (e.ui.chatOpen = s.id);
      }), Ee(() => e.loaded.value, (i) => {
        i && this.recover();
      }, { immediate: !0 });
    }), e.shiftPick = (i) => {
      const s = e.ui.chatOpen ? this.chat(e.ui.chatOpen) : null;
      return !s || this.frameOf(s) ? !1 : (this.togglePick(s.id, i), !0);
    };
  }
  setDriver(e) {
    this.driver = e;
  }
  get driverLabel() {
    return this.answerer().label;
  }
  /** A tour drives this board (src/onboarding): its scripted brain answers, and there's no model to pick. */
  get guided() {
    return !!(this.board.tour && this.board.tour.chat);
  }
  /** Who answers the next turn: the tour's brain while one drives the board, else this person's pick. */
  answerer() {
    const e = this.board.tour;
    return e && e.chat || this.driver;
  }
  /** Ask the agent again, and answer with this person's model (the default one, unless they picked another or the simulated brain). */
  async refreshAgent() {
    if (!this.endpoint) return;
    const e = await OU(this.endpoint);
    if (this.disposed) return;
    this.agentStatus.value = e;
    let t = null;
    try {
      t = window.localStorage.getItem(Yw(this.board.user.uid));
    } catch {
      t = null;
    }
    const i = e.ready && e.models || [];
    this.useBrain(t === Ci && this.canSimulate || !i.length ? Ci : (i.find((s) => s.id === t) || i[0]).id);
  }
  /** The models the agent offers (none until it's asked, or without a key). */
  get models() {
    const e = this.agentStatus.value;
    return e && e.ready && e.models || [];
  }
  useBrain(e) {
    const t = this.models.find((i) => i.id === e);
    if (t)
      this.driver = new WU({ model: t, boardId: this.board.meta.id, uid: this.board.user.uid, endpoint: this.endpoint || void 0 }), this.brain.value = t.id;
    else if (this.canSimulate)
      this.driver = this.simulated, this.brain.value = Ci;
    else {
      const i = this.agentStatus.value;
      this.driver = new Kw(i && i.reason || "The chat isn't available right now. Try again in a little while."), this.brain.value = Lv;
    }
  }
  /** This person's pick of brain (SIMULATED or a model's id), kept in this browser. */
  setBrain(e) {
    if (!(e === Ci && !this.canSimulate)) {
      try {
        window.localStorage.setItem(Yw(this.board.user.uid), e);
      } catch {
      }
      this.useBrain(e);
    }
  }
  // ------------------------------------------------------------ reading
  chat(e) {
    const t = this.board.store.get(e);
    return t && t.type === "chat" ? t : null;
  }
  /** The frame a chat's card sits in: its context. */
  frameOf(e) {
    const t = He(e), i = this.board.store.query(t).filter((s) => s.type === "frame");
    return _U(i, e);
  }
  /** What the chat sees now. Reactive: it follows the board, its results and its prompts. */
  contextOf(e) {
    this.board.docRev.value, this.board.results.rev.value, this.board.promptRev.value;
    const t = this.frameOf(e);
    return t ? ju(Gu(this.board), t, e.id) : this.pickedContext(e);
  }
  // ------------------------------------------------------------ outside a frame (A3, Decision 5)
  /** What was picked for a chat outside a frame, still on the board: pictures, sessions and notes. */
  picksOf(e) {
    const t = [];
    for (const i of e.contextIds || []) {
      const s = this.board.store.get(i);
      s && (s.type === "image" || s.type === "tool" || s.type === "note") && t.push(s);
    }
    return t;
  }
  /** Its picks read as a frame's contents would be: a frame round them that isn't on the board. */
  pickedContext(e) {
    const t = this.picksOf(e);
    if (!t.length) return null;
    const i = uc(t.map((a) => He(a))), s = { id: "picks:" + e.id, type: "frame", title: "Picked from the board", x: i.x - An, y: i.y - An, w: i.w + An * 2, h: i.h + An * 2, z: 0 }, o = Gu(this.board), r = t.map((a) => a.id);
    return ju({ ...o, childrenOf: (a) => a.id === s.id ? r : o.childrenOf(a), framesIn: (a) => a.id === s.id ? [] : o.framesIn(a) }, s, e.id);
  }
  /** In or out of a chat's picks (Shift-click on the board, or a chip's ×). Not an undo step: a conversation's context. */
  togglePick(e, t) {
    const i = this.chat(e), s = this.board.store.get(t);
    if (!i || !s) return;
    const o = i.contextIds || [], r = !o.includes(t), a = r ? o.concat([t]) : o.filter((l) => l !== t);
    this.board.store.update(e, { contextIds: a.length ? a : void 0 }, { history: !1 }), r && s.type === "image" && s.resultId && !this.board.results.get(s.resultId) && this.board.loadRecord(s.resultId).catch(() => {
    }), this.board.toast(r ? "Added to " + i.name + "'s context" : "Taken out of " + i.name + "'s context");
  }
  /**
   * A plan from a chat outside a frame runs in one (Decision 5): a frame is
   * made round the chat and its picks first, named for the chat, and the
   * picks are the frame's now. One Undo step; null when there's nothing picked.
   */
  frameForPicks(e) {
    const t = this.picksOf(e);
    if (!t.length) return null;
    const i = this.board, s = uc([He(e), ...t.map((r) => He(r))]), o = { id: wt(), type: "frame", title: e.name, x: Math.round(s.x - An), y: Math.round(s.y - An - 24), w: Math.round(s.w + An * 2), h: Math.round(s.h + An * 2 + 24), z: 0, createdBy: i.user.uid };
    return o.z = i.store.nextZ(o, !0), i.store.batch("Frame the chat's work", () => {
      i.store.add([o]), i.store.update(e.id, { contextIds: void 0 });
    }), i.toast("Put " + e.name + " and its pictures in a frame, where its plan runs"), o;
  }
  /** The chats in a frame, in reading order. */
  chatsIn(e) {
    return this.board.childrenOf(e).map((t) => this.board.store.get(t)).filter((t) => !!t && t.type === "chat");
  }
  /** Every chat on the board, the most recently active first. */
  allChats() {
    this.board.docRev.value;
    const e = [];
    for (const i of this.board.store.all()) i.type === "chat" && e.push(i);
    const t = (i) => (i.messages && i.messages.length ? i.messages[i.messages.length - 1].at : 0) || i.updatedAt || 0;
    return e.sort((i, s) => t(s) - t(i));
  }
  busy(e) {
    return !!this.live[e];
  }
  /** A plan this page is running. */
  isRunningHere(e) {
    return this.running.has(e);
  }
  // ------------------------------------------------------------ chats in frames
  /** "Chat 1", "Chat 2"… per frame. */
  nextName(e) {
    let t = 0;
    for (const i of this.chatsIn(e)) {
      const s = /^Chat (\d+)$/.exec(i.name || "");
      s && (t = Math.max(t, Number(s[1])));
    }
    return "Chat " + (t + 1);
  }
  /** A new chat card in the frame's first clear spot (the frame grows when it has none), selected and open. */
  createChat(e) {
    const t = this.board, i = t.store.get(e);
    if (!i || i.type !== "frame") return null;
    const s = i, o = t.childrenOf(s).map((c) => t.store.get(c)).filter(Boolean).map((c) => He(c)), r = He(s), a = Rv(r, o, Ri.w, Ri.h) || zv(r, o), l = {
      id: wt(),
      type: "chat",
      x: a.x,
      y: a.y,
      w: Ri.w,
      h: Ri.h,
      z: 0,
      name: this.nextName(s),
      messages: [],
      createdBy: t.user.uid
    };
    l.z = t.store.nextZ(l);
    const d = $v(r, [He(l)]);
    return t.store.batch("Add chat", () => {
      d && t.store.update(s.id, { w: d.w, h: d.h }), t.store.add([l]);
    }), t.ui.selection = [l.id], t.ui.chatOpen = l.id, l;
  }
  /**
   * A chat about pictures picked on the board, outside any frame (A3: Nathan,
   * start from the pictures you have): beside them, with them as its context.
   */
  createChatFor(e) {
    const t = this.board, i = e.map((l) => t.store.get(l)).filter((l) => !!l && l.type === "image");
    if (!i.length) return null;
    const s = uc(i.map((l) => He(l))), o = t.freeSpot(Ri.w, Ri.h, { x: s.x + s.w + 48 + Ri.w / 2, y: s.y + Ri.h / 2 }, [], { outsideFrames: !0 }), r = this.allChats().length + 1, a = {
      id: wt(),
      type: "chat",
      x: o.x,
      y: o.y,
      w: Ri.w,
      h: Ri.h,
      z: 0,
      name: "Chat " + r,
      messages: [],
      createdBy: t.user.uid,
      contextIds: i.map((l) => l.id)
    };
    a.z = t.store.nextZ(a), t.store.add([a]), t.ui.selection = [a.id], t.ui.chatOpen = a.id;
    for (const l of i) {
      const d = l.resultId;
      d && !t.results.get(d) && t.loadRecord(d).catch(() => {
      });
    }
    return a;
  }
  /** The selected pictures into a frameless chat's context, all at once (those not in it already). */
  addPicks(e, t) {
    const i = this.chat(e);
    if (!i || this.frameOf(i)) return 0;
    const s = new Set(i.contextIds || []), o = t.filter((r) => {
      var a;
      return !s.has(r) && ((a = this.board.store.get(r)) == null ? void 0 : a.type) === "image";
    });
    return o.length ? (this.board.store.update(e, { contextIds: (i.contextIds || []).concat(o) }, { history: !1 }), o.length) : 0;
  }
  close() {
    this.board.ui.chatOpen = null;
  }
  /**
   * A recommended tool, tried: a new session with it in the chat's frame (in
   * its first clear spot, the frame growing when it has none), selected so
   * its prompt opens. Nothing runs: the person writes the prompt.
   */
  addTool(e, t) {
    const i = this.board, s = this.chat(e), o = s ? this.frameOf(s) : null, r = this.catalogView(), a = r.get(t);
    if (!o || !a) return null;
    const l = r.kitFor(a, "generate"), d = He(o), c = i.childrenOf(o).map((p) => i.store.get(p)).filter(Boolean).map((p) => He(p)), h = Rv(d, c, Rt.w, Rt.h) || zv(d, c);
    let f = null;
    return i.store.batch("Add session", () => {
      f = i.addSession(l, a.model, i.uniqueSessionName(a.name), { x: h.x + Rt.w / 2, y: h.y + Rt.h / 2 }, { quiet: !0 }), i.store.update(f.id, { x: h.x, y: h.y });
      const p = $v(d, [{ x: h.x, y: h.y, w: Rt.w, h: Rt.h }]);
      p && i.store.update(o.id, { x: p.x, y: p.y, w: p.w, h: p.h });
    }), f && (i.ui.selection = [f.id]), f;
  }
  /** Opening a chat: its frame comes into view beside the panel, and its images' records are read for the context. */
  onOpen(e) {
    const t = this.chat(e);
    if (!t) return;
    const i = this.frameOf(t);
    if (!i) {
      for (const s of this.picksOf(t)) {
        const o = s.type === "image" ? s.resultId : void 0;
        o && !this.board.results.get(o) && this.board.loadRecord(o).catch(() => {
        });
      }
      return;
    }
    this.showFrame(i, !1);
    for (const s of this.board.childrenOf(i)) {
      const o = this.board.store.get(s);
      o && o.type === "image" && o.resultId && !this.board.results.get(o.resultId) && this.board.loadRecord(o.resultId).catch(() => {
      });
    }
  }
  /** Where the board can be seen beside the chat panel, in the stage's pixels. */
  freeArea() {
    const e = this.board.view;
    return { x: 76, y: 16, w: Math.max(240, e.w - 76 - BG), h: Math.max(200, e.h - 16 - 110) };
  }
  /** Bring a frame into view beside the panel; `always`, even when it's already in view. */
  showFrame(e, t) {
    const i = this.board.engine;
    if (!i) return;
    const s = He(e), o = this.board.cam.value, r = this.freeArea(), a = s.x * o.zoom + o.x, l = s.y * o.zoom + o.y;
    if (a >= r.x && l >= r.y + 24 && a + s.w * o.zoom <= r.x + r.w && l + s.h * o.zoom <= r.y + r.h && s.w * o.zoom > r.w * 0.3 && !t) return;
    const c = dm(s, r.w, r.h, 48, 1);
    i.animateCamera({ zoom: tr(c.zoom), x: c.x + r.x, y: c.y + r.y + 12 }, 460);
  }
  // ------------------------------------------------------------ the transcript
  /** Change a chat's transcript (capped), outside the undo history: a conversation isn't undone. `also` patches the chat with it (its spend). */
  write(e, t, i = {}) {
    const s = this.chat(e);
    if (!s) return;
    const o = PG(t((s.messages || []).slice()), s.dropped || 0);
    this.board.store.update(e, { ...i, messages: o.messages, dropped: o.dropped || void 0 }, { history: !1 });
  }
  catalogView() {
    return new b8(this.board.catalog.value, !!this.board.user.isAdmin);
  }
  /** A person's message, and the agent's answer to it. */
  async send(e, t) {
    const i = EG(t), s = this.chat(e);
    if (!i || !s || this.busy(e)) return;
    const o = this.frameOf(s), r = o ? ju(Gu(this.board), o, s.id) : this.pickedContext(s);
    if (!r) {
      this.board.toast("Shift-click pictures on the board to give this chat something to work with, or move it into a frame.");
      return;
    }
    const a = (s.messages || []).slice(), l = this.board.user;
    this.write(e, (d) => d.concat({
      id: wt(),
      role: "user",
      author: l.name || l.initials || "You",
      authorId: l.uid,
      at: Date.now(),
      text: i,
      context: y8(r)
    })), await this.answer(e, { kind: "message", text: i, author: l.name || "You" }, a, r);
  }
  /** Ask the agent for its next message, stream it, and put it in the transcript. */
  async answer(e, t, i, s) {
    const o = this.catalogView(), r = { status: "Thinking…", text: "", plan: null, chips: [], picks: [], ideas: [] };
    this.live[e] = r;
    const a = new AbortController();
    this.aborts.set(e, a);
    let l, d, c = "";
    try {
      if (this.agentReady && !this.guided && await this.agentReady, this.disposed || a.signal.aborted) return;
      const v = this.chat(e), x = { input: t, context: s, history: i, dropped: v && v.dropped || 0, chatId: e, catalog: o, guidance: TU };
      for await (const w of this.answerer().turn(x, a.signal)) {
        if (this.disposed || a.signal.aborted) return;
        const S = this.live[e];
        if (!S) return;
        if (w.type === "status") S.status = w.text;
        else if (w.type === "text")
          S.status = null, S.text += w.delta;
        else if (w.type === "plan") {
          const M = Ev(w.plan, s, o);
          M.ok ? S.plan = M.plan : S.text += (S.text ? `

` : "") + "I couldn't put that plan together: " + M.error, S.status = null;
        } else if (w.type === "chips") S.chips = w.chips;
        else if (w.type === "picks")
          S.picks = w.picks.filter((M) => o.has(M.modelId)), S.status = null;
        else if (w.type === "ideas")
          S.ideas = w.ideas.map((M) => M.modelId && !o.has(M.modelId) ? { title: M.title, pitch: M.pitch } : M), S.status = null;
        else if (w.type === "usage") {
          this.usage[e] = w.usage;
          const M = w.usage;
          d = { model: M.model, usd: M.usd, credits: M.credits, input: M.input, cached: M.cached, output: M.output, ms: M.ms };
        } else w.type === "memo" && (l = w.memo);
      }
    } catch (v) {
      console.error("[board] the chat's answer failed", v), c = "Something went wrong while I was answering. Please try again.";
    } finally {
      this.aborts.delete(e);
    }
    const h = this.live[e];
    if (delete this.live[e], this.disposed || !h || !this.chat(e)) return;
    const f = N8(h.text.trim() || c).trim();
    if (!f && !h.plan && !h.picks.length && !h.ideas.length) return;
    const p = { id: wt(), role: "agent", author: "Assistant", at: Date.now(), text: f };
    h.plan && (p.plan = h.plan), h.picks.length && (p.picks = h.picks), h.ideas.length && (p.ideas = h.ideas), h.chips.length && (p.chips = h.chips), l && (p.memo = l), d && (p.usage = d);
    const y = this.chat(e);
    this.write(e, (v) => (h.plan ? RG(v) : v).concat(p), d && y ? { spend: DG(y.spend, d) } : {});
  }
  /** Stop an answer on its way (the chat closed, the card was deleted). */
  stopAnswer(e) {
    const t = this.aborts.get(e);
    t && t.abort(), delete this.live[e];
  }
  // ------------------------------------------------------------ plans
  /** Run a proposed plan: one click, the board's own commands, progress in the transcript as it goes. */
  async runPlan(e, t) {
    const i = this.chat(e), s = i ? cd(i, t) : null;
    if (!i || !s || s.plan.status !== "proposed") return;
    const o = this.frameOf(i) || this.frameForPicks(i);
    if (!o) {
      this.board.toast("Move this chat back into a frame to run its plan.");
      return;
    }
    const r = this.board.user;
    this.write(e, (v) => Yu(v, t, { status: "running", ranBy: r.name || r.initials || "You", ranById: r.uid, ranAt: Date.now(), steps: [] }));
    const a = cd(this.chat(e), t).plan, l = new eG(pU(this.board), a, o.id, (v) => this.onProgress(e, t, o.id, v));
    this.running.set(t, { chatId: e, runner: l });
    let d;
    try {
      d = await l.run();
    } catch (v) {
      console.error("[board] the plan failed", v), d = { status: "failed", steps: [], added: {}, results: 0, error: "Something went wrong while it ran." };
    } finally {
      this.running.delete(t);
    }
    if (this.disposed || !this.chat(e)) return;
    const c = d.status === "cancelled" ? "cancelled" : d.status;
    this.write(e, (v) => Yu(v, t, {
      status: c,
      endedAt: Date.now(),
      results: d.results,
      ...d.steps.length ? { steps: d.steps } : {},
      ...d.error ? { error: d.error } : {},
      sessions: a.sessions.map((x) => this.withAdded(x, d.added[x.key]))
    }));
    const h = this.board.store.get(o.id);
    h && h.type === "frame" && this.showFrame(h, !1);
    const f = this.chat(e), p = f ? cd(f, t) : null, y = f ? this.frameOf(f) : null;
    f && p && y && c !== "cancelled" && await this.answer(e, { kind: "plan-ended", plan: p.plan }, (f.messages || []).slice(), ju(Gu(this.board), y, f.id));
  }
  onProgress(e, t, i, s) {
    if (this.disposed) return;
    const o = this.chat(e), r = o ? cd(o, t) : null;
    if (!r) return;
    this.write(e, (l) => Yu(l, t, {
      steps: s.steps,
      results: s.results,
      sessions: r.plan.sessions.map((d) => this.withAdded(d, s.added[d.key]))
    }));
    const a = this.board.store.get(i);
    a && a.type === "frame" && this.board.ui.chatOpen === e && this.showFrame(a, !1);
  }
  /** A plan's session with the one it added, under the name the board gave it ("Night versions 2"). */
  withAdded(e, t) {
    if (!t) return e;
    const i = this.board.store.get(t);
    return { ...e, addedId: t, ...i && i.type === "tool" ? { name: i.name } : {} };
  }
  /** Cancel a plan not yet run; stop one running here before its next step. */
  cancelPlan(e, t) {
    const i = this.chat(e), s = i ? cd(i, t) : null;
    if (!s) return;
    if (s.plan.status === "proposed") {
      this.write(e, (r) => Yu(r, t, { status: "cancelled", endedAt: Date.now() }));
      return;
    }
    const o = this.running.get(t);
    o && o.runner.cancel();
  }
  /**
   * Plans this person started that were running when their page closed: a
   * runner lives in the page that started it, so they're stopped where they
   * were (what ran stays on the board).
   */
  recover() {
    const e = this.board.user.uid;
    for (const t of this.board.store.all()) {
      if (t.type !== "chat") continue;
      const i = t, s = (i.messages || []).filter((o) => o.plan && o.plan.status === "running" && o.plan.ranById === e && !this.running.has(o.plan.id));
      s.length && this.write(i.id, (o) => o.map((r) => s.some((a) => a.id === r.id) && r.plan ? { ...r, plan: { ...r.plan, status: "stopped", error: "The page running it closed before it finished", endedAt: Date.now() } } : r));
    }
  }
  dispose() {
    this.board.shiftPick && (this.board.shiftPick = null), this.disposed = !0;
    for (const e of this.running.values()) e.runner.cancel();
    this.running.clear();
    for (const e of this.aborts.values()) e.abort();
    this.aborts.clear(), this.scope.stop();
  }
}
const af = /* @__PURE__ */ new WeakMap();
function os(n) {
  let e = af.get(n);
  return e || (e = new FG(n), af.set(n, e)), e;
}
function NG(n) {
  const e = af.get(n);
  e && e.dispose(), af.delete(n);
}
const UG = ["aria-pressed"], GG = { class: "tip" }, jG = ["title"], HG = ["aria-label", "aria-pressed", "data-testid", "onClick"], VG = { class: "tip" }, WG = { class: "tip" }, qG = { style: { opacity: ".5", "margin-left": "6px" } }, KG = { class: "tip" }, YG = { class: "tip" }, XG = { style: { opacity: ".5", "margin-left": "6px" } }, JG = ["aria-disabled"], ZG = { class: "tip" }, QG = {
  key: 0,
  class: "why"
}, ej = ["aria-disabled"], tj = { class: "tip" }, nj = {
  key: 0,
  class: "why"
}, ij = ["aria-expanded"], sj = {
  key: 0,
  class: "tip"
}, oj = {
  key: 0,
  class: "bd-pm-sep",
  role: "separator"
}, rj = ["disabled", "data-testid", "onClick"], aj = { class: "bd-pm-ic is-plain is-bare" }, lj = { class: "lbl" }, dj = { key: 0 }, cj = /* @__PURE__ */ Pe({
  __name: "ContextToolbar",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(null), i = /* @__PURE__ */ W(160), s = I(() => e.selectedEls.value), o = I(() => s.value.length > 1), r = I(() => s.value.filter((Me) => Me.type === "tool" || Me.type === "chat")), a = I(() => r.value.length > 0 && r.value.every((Me) => !!Me.collapsed)), l = I(() => s.value.length === 1 ? s.value[0] : null), d = I(() => !!l.value && l.value.type === "image"), c = I(() => !!l.value && l.value.type === "shape"), h = I(() => !!l.value && l.value.type === "frame");
    function f() {
      l.value && os(e).createChat(l.value.id);
    }
    const p = I(() => s.value.length > 0 && s.value.every((Me) => Me.type === "image" && !e.ownerFrame(Me)));
    function y() {
      os(e).createChatFor(s.value.map((Me) => Me.id));
    }
    const v = I(() => s.value.some((Me) => Me.type === "note")), x = I(() => {
      const Me = new Set(s.value.filter((he) => he.type === "note").map((he) => he.tint || "glass"));
      return Me.size === 1 ? Array.from(Me)[0] : null;
    }), w = I(() => {
      e.docRev.value;
      const Me = s.value.map((he) => he.id);
      return { forward: e.orderBlock(Me, "forward"), back: e.orderBlock(Me, "back") };
    }), S = I(() => s.value.length > 0 && !(s.value.length === 1 && s.value[0].type === "frame")), M = I(() => s.value.length === 1 && Ro(s.value[0])), _ = I(() => s.value.filter((Me) => Me.type === "frame")), T = I(() => _.value.length > 0 && _.value.every((Me) => Me.locked)), k = wn(["mod", "shift", "L"]), P = I(() => c.value ? l.value.stroke || io.stroke : ""), A = I(() => s.value.length > 0 && !e.ui.marquee && !e.ui.dragging && !e.ui.studio), R = I(() => !!e.ui.editingNote);
    function D(Me) {
      R.value && Me.preventDefault();
    }
    const O = I(() => d.value && !l.value.video), F = I(() => d.value && e.isPinnedImage(l.value.src));
    function ie() {
      const Me = l.value;
      e.togglePinImage(g8(Me, Me.resultId && e.results.get(Me.resultId) || null));
    }
    const ee = I(() => {
      if (!d.value || !e.promptLibrary.canSave) return !1;
      const Me = l.value.resultId;
      if (!Me) return !1;
      const he = e.results.get(Me);
      return !he || !!he.prompt && he.status === "done";
    }), me = I(() => {
      e.docRev.value;
      const Me = e.cam.value;
      let he = 1 / 0, U = 1 / 0, q = -1 / 0, oe = -1 / 0;
      for (const de of s.value) {
        const pe = He(de);
        he = Math.min(he, pe.x), U = Math.min(U, pe.y), q = Math.max(q, pe.x + pe.w), oe = Math.max(oe, pe.y + pe.h);
      }
      return {
        cx: (he + q) / 2 * Me.zoom + Me.x + e.view.left,
        top: U * Me.zoom + Me.y + e.view.top,
        bottom: oe * Me.zoom + Me.y + e.view.top
      };
    }), L = I(() => {
      const Me = i.value, he = Math.min(Math.max(8, me.value.cx - Me / 2), window.innerWidth - Me - 8), U = me.value.top - 50, q = U < 62 ? Math.min(window.innerHeight - 60, me.value.bottom + 12) : U;
      return { left: he, top: q };
    });
    Ee(() => [A.value, s.value.length, d.value, c.value, h.value, v.value, o.value, M.value, ee.value], () => {
      nt(() => {
        t.value && (i.value = t.value.offsetWidth);
      });
    }, { immediate: !0 });
    function N() {
      const Me = s.value[0];
      Me && (e.ui.selection = [], e.comments.draftOn(Me));
    }
    function K(Me) {
      e.ctxAction(Me);
    }
    const B = /* @__PURE__ */ W(null), re = I(() => A.value && e.ui.ctxMenu), H = /* @__PURE__ */ W({ w: 220, h: 0, barH: 42 }), J = I(() => {
      const Me = [
        { id: "copy", icon: "Clipboard", label: "Copy", keys: wn(["mod", "C"]) },
        { id: "duplicate", icon: "Copy", label: "Duplicate", keys: wn(["mod", "D"]) }
      ];
      return l.value && l.value.type === "frame" && Me.push({ id: "rename", icon: "Pencil", label: "Rename" }), _.value.length && Me.push({ id: "lock", icon: T.value ? "LockOpen" : "Lock", label: T.value ? "Unlock" : "Lock", keys: k, sepBefore: !0 }), Me.push({ id: "delete", icon: "Trash2", label: "Delete", keys: wn(["del"]), off: s.value.every((he) => e.isHeld(he)), danger: !0, sepBefore: !0 }), Me;
    }), Q = I(() => {
      const Me = H.value, he = Math.min(Math.max(8, L.value.left + i.value - Me.w), window.innerWidth - Me.w - 8), U = L.value.top + Me.barH + 6, q = U + Me.h > window.innerHeight - 8 && L.value.top - 6 - Me.h >= 8;
      return { left: he, top: q ? L.value.top - 6 - Me.h : U, up: q };
    });
    function ne() {
      e.ui.ctxMenu = !1;
    }
    function ue() {
      e.ui.ctxMenu = !e.ui.ctxMenu;
    }
    function Z(Me) {
      const he = Me.target;
      he && (B.value && B.value.contains(he) || t.value && t.value.contains(he)) || ne();
    }
    Ee(re, (Me) => {
      if (!Me) {
        window.removeEventListener("pointerdown", Z, !0);
        return;
      }
      window.addEventListener("pointerdown", Z, !0), nt(() => {
        const he = B.value;
        he && (H.value = { w: he.offsetWidth, h: he.offsetHeight, barH: t.value ? t.value.offsetHeight : 42 }, he.focus({ preventScroll: !0 }));
      });
    }), Ee(() => e.ui.selection, ne), Ee(A, (Me) => {
      Me || ne();
    }), We(() => {
      window.removeEventListener("pointerdown", Z, !0), ne();
    });
    function te(Me) {
      Me.off || (ne(), K(Me.id));
    }
    function we() {
      return B.value ? Array.from(B.value.querySelectorAll(".bd-pm-row:not(:disabled)")) : [];
    }
    function Fe(Me) {
      const he = Me.key;
      if (he === "ArrowDown" || he === "ArrowUp" || he === "Home" || he === "End") {
        Me.preventDefault(), Me.stopPropagation();
        const U = we(), q = U.indexOf(document.activeElement), oe = he === "Home" ? 0 : he === "End" ? U.length - 1 : q < 0 ? he === "ArrowDown" ? 0 : U.length - 1 : (q + (he === "ArrowDown" ? 1 : -1) + U.length) % U.length;
        U[oe] && U[oe].focus();
      } else he === "Escape" ? (Me.preventDefault(), Me.stopPropagation(), ne()) : he === "Tab" ? Me.preventDefault() : (he === "Enter" || he === " ") && Me.stopPropagation();
    }
    return (Me, he) => (g(), b(j, null, [
      A.value ? (g(), b("div", {
        ref_key: "bar",
        ref: t,
        key: s.value.length + (d.value ? "i" : "") + (c.value ? "s" : "") + (h.value ? "f" : "") + (o.value ? "m" : "") + (M.value ? "l" : ""),
        class: "cv-ctxbar",
        "data-testid": "context-toolbar",
        style: ce({ left: L.value.left + "px", top: L.value.top + "px" }),
        onPointerdown: Te(D, ["stop"])
      }, [
        d.value ? (g(), b(j, { key: 0 }, [
          O.value ? (g(), b("button", {
            key: 0,
            class: "cv-ctx-info",
            title: "Edit in Studio view, in its session",
            "data-testid": "ctx-edit",
            onClick: he[0] || (he[0] = (U) => K("edit"))
          }, [
            C($, {
              name: "Wand2",
              size: 13
            }),
            he[20] || (he[20] = Y(" Edit", -1))
          ])) : z("", !0),
          u("button", {
            class: "cv-ctx-info",
            title: "Its details, large",
            "data-testid": "ctx-details",
            onClick: he[1] || (he[1] = (U) => K("info"))
          }, [
            C($, {
              name: "Info",
              size: 13
            }),
            he[21] || (he[21] = Y(" Details", -1))
          ]),
          u("button", {
            title: "Download",
            onClick: he[2] || (he[2] = (U) => K("download"))
          }, [
            C($, {
              name: "Download",
              size: 14
            }),
            he[22] || (he[22] = u("span", { class: "tip" }, "Download", -1))
          ]),
          u("button", {
            title: "Use as reference",
            onClick: he[3] || (he[3] = (U) => K("reference"))
          }, [
            C($, {
              name: "ImagePlus",
              size: 14
            }),
            he[23] || (he[23] = u("span", { class: "tip" }, "Use as reference", -1))
          ]),
          u("button", {
            class: G(["is-pin", { on: F.value }]),
            "aria-pressed": F.value,
            "data-testid": "ctx-pin",
            onClick: ie
          }, [
            C($, {
              name: "Pin",
              size: 14
            }),
            u("span", GG, E(F.value ? m(Xn).unpin : m(Xn).pin), 1)
          ], 10, UG),
          ee.value ? (g(), b("button", {
            key: 1,
            title: "Save to the prompt library",
            "data-testid": "ctx-save-prompt",
            onClick: he[4] || (he[4] = (U) => K("save-prompt"))
          }, [
            C($, {
              name: "Bookmark",
              size: 14
            }),
            he[24] || (he[24] = u("span", { class: "tip" }, "Save to the prompt library", -1))
          ])) : z("", !0),
          he[25] || (he[25] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        h.value ? (g(), b(j, { key: 1 }, [
          u("button", {
            class: "cv-ctx-info is-chat",
            title: "Start a chat about everything in this frame",
            "data-testid": "ctx-chat",
            onClick: f
          }, [
            C($, {
              name: "MessageSquarePlus",
              size: 13
            }),
            he[26] || (he[26] = Y(" Chat", -1))
          ]),
          he[27] || (he[27] = u("span", { class: "sep" }, null, -1))
        ], 64)) : p.value ? (g(), b(j, { key: 2 }, [
          u("button", {
            class: "cv-ctx-info is-chat",
            title: s.value.length === 1 ? "Start a chat about this picture" : "Start a chat about these " + s.value.length + " pictures",
            "data-testid": "ctx-chat-pics",
            onClick: y
          }, [
            C($, {
              name: "MessageSquarePlus",
              size: 13
            }),
            he[28] || (he[28] = Y(" Chat", -1))
          ], 8, jG),
          he[29] || (he[29] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        c.value ? (g(), b(j, { key: 3 }, [
          u("button", {
            class: "cv-ctx-edit",
            title: "Stroke colour and width",
            onClick: he[5] || (he[5] = (U) => K("style"))
          }, [
            u("span", {
              class: "swatch",
              style: ce({ background: P.value })
            }, null, 4),
            he[30] || (he[30] = Y(" Stroke ", -1))
          ]),
          he[31] || (he[31] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        o.value ? (g(), b(j, { key: 4 }, [
          u("button", {
            onClick: he[6] || (he[6] = (U) => K("align-left"))
          }, [
            C($, {
              name: "AlignStartVertical",
              size: 14
            }),
            he[32] || (he[32] = u("span", { class: "tip" }, "Align left", -1))
          ]),
          u("button", {
            onClick: he[7] || (he[7] = (U) => K("align-center"))
          }, [
            C($, {
              name: "AlignCenterHorizontal",
              size: 14
            }),
            he[33] || (he[33] = u("span", { class: "tip" }, "Align centres", -1))
          ]),
          u("button", {
            onClick: he[8] || (he[8] = (U) => K("align-top"))
          }, [
            C($, {
              name: "AlignStartHorizontal",
              size: 14
            }),
            he[34] || (he[34] = u("span", { class: "tip" }, "Align top", -1))
          ]),
          u("button", {
            onClick: he[9] || (he[9] = (U) => K("distribute-h"))
          }, [
            C($, {
              name: "AlignHorizontalDistributeCenter",
              size: 14
            }),
            he[35] || (he[35] = u("span", { class: "tip" }, "Distribute horizontally", -1))
          ]),
          he[36] || (he[36] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        v.value ? (g(), b(j, { key: 5 }, [
          (g(!0), b(j, null, ge(m(qN), (U) => (g(), b("button", {
            key: U.id,
            class: G(["is-swatch", { on: x.value === U.id }]),
            "aria-label": U.label,
            "aria-pressed": x.value === U.id,
            "data-testid": "note-tint-" + U.id,
            onClick: (q) => K("tint-" + U.id)
          }, [
            u("span", {
              class: G(["swatch", "tint-" + U.id])
            }, null, 2),
            u("span", VG, E(U.label), 1)
          ], 10, HG))), 128)),
          he[37] || (he[37] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        M.value ? (g(), b("button", {
          key: 6,
          class: "cv-ctx-info is-locked",
          "aria-label": "Unlock frame",
          "data-testid": "ctx-unlock",
          onClick: he[10] || (he[10] = (U) => K("lock"))
        }, [
          C($, {
            name: "Lock",
            size: 13
          }),
          he[39] || (he[39] = Y(" Locked", -1)),
          u("span", WG, [
            he[38] || (he[38] = Y("Unlock", -1)),
            u("span", qG, E(m(k)), 1)
          ])
        ])) : (g(), b(j, { key: 7 }, [
          S.value ? (g(), b("button", {
            key: 0,
            onClick: he[11] || (he[11] = (U) => K("frame"))
          }, [
            C($, {
              name: "Frame",
              size: 14
            }),
            he[40] || (he[40] = u("span", { class: "tip" }, "Group into frame", -1))
          ])) : z("", !0),
          r.value.length ? (g(), b("button", {
            key: 1,
            "data-testid": "ctx-fold",
            onClick: he[12] || (he[12] = (U) => m(e).toggleCollapsed(r.value.map((q) => q.id)))
          }, [
            C($, {
              name: a.value ? "ChevronsUpDown" : "ChevronsDownUp",
              size: 14
            }, null, 8, ["name"]),
            u("span", KG, E(a.value ? "Expand" : "Collapse to the title"), 1)
          ])) : z("", !0),
          u("button", {
            onClick: he[13] || (he[13] = (U) => K("duplicate"))
          }, [
            C($, {
              name: "Copy",
              size: 14
            }),
            u("span", YG, [
              he[41] || (he[41] = Y("Duplicate", -1)),
              u("span", XG, E(m(wn)(["mod", "D"])), 1)
            ])
          ]),
          u("button", {
            class: G({ "is-rest": !!w.value.forward }),
            "aria-disabled": !!w.value.forward,
            "data-testid": "ctx-forward",
            onClick: he[14] || (he[14] = (U) => !w.value.forward && K("forward"))
          }, [
            C($, {
              name: "BringToFront",
              size: 14
            }),
            u("span", ZG, [
              he[42] || (he[42] = Y("Bring forward", -1)),
              w.value.forward ? (g(), b("span", QG, E(w.value.forward), 1)) : z("", !0)
            ])
          ], 10, JG),
          u("button", {
            class: G({ "is-rest": !!w.value.back }),
            "aria-disabled": !!w.value.back,
            "data-testid": "ctx-back",
            onClick: he[15] || (he[15] = (U) => !w.value.back && K("back"))
          }, [
            C($, {
              name: "SendToBack",
              size: 14
            }),
            u("span", tj, [
              he[43] || (he[43] = Y("Send back", -1)),
              w.value.back ? (g(), b("span", nj, E(w.value.back), 1)) : z("", !0)
            ])
          ], 10, ej),
          he[45] || (he[45] = u("span", { class: "sep" }, null, -1)),
          u("button", {
            class: "danger",
            "data-testid": "ctx-delete",
            onClick: he[16] || (he[16] = (U) => K("delete"))
          }, [
            C($, {
              name: "Trash2",
              size: 14
            }),
            he[44] || (he[44] = u("span", { class: "tip" }, "Delete", -1))
          ])
        ], 64)),
        !o.value && m(e).comments.enabled ? (g(), b("button", {
          key: 8,
          "data-testid": "ctx-comment",
          onClick: N
        }, [
          C($, {
            name: "MessageCirclePlus",
            size: 14
          }),
          he[46] || (he[46] = u("span", { class: "tip" }, [
            Y("Comment"),
            u("span", { style: { opacity: ".5", "margin-left": "6px" } }, "C")
          ], -1))
        ])) : z("", !0),
        u("button", {
          class: G(["is-more", { on: re.value }]),
          "aria-label": "More",
          "aria-haspopup": "menu",
          "aria-expanded": re.value,
          "data-testid": "ctx-more",
          onClick: ue
        }, [
          C($, {
            name: "EllipsisVertical",
            size: 14
          }),
          re.value ? z("", !0) : (g(), b("span", sj, "More"))
        ], 10, ij)
      ], 36)) : z("", !0),
      re.value ? (g(), b("div", {
        key: 1,
        ref_key: "menu",
        ref: B,
        class: "bd-pointmenu bd-ctxmenu",
        role: "menu",
        "aria-label": "More",
        tabindex: "-1",
        "data-testid": "ctx-menu",
        style: ce({ left: Q.value.left + "px", top: Q.value.top + "px", "--pm-origin": (Q.value.up ? "bottom" : "top") + " right" }),
        onKeydown: Fe,
        onPointerdown: he[18] || (he[18] = Te(() => {
        }, ["stop"])),
        onContextmenu: he[19] || (he[19] = Te(() => {
        }, ["prevent"]))
      }, [
        (g(!0), b(j, null, ge(J.value, (U) => (g(), b(j, {
          key: U.id
        }, [
          U.sepBefore ? (g(), b("div", oj)) : z("", !0),
          u("button", {
            class: G(["bd-pm-row", { "is-danger": U.danger }]),
            role: "menuitem",
            tabindex: "-1",
            disabled: U.off,
            "data-testid": "ctx-menu-" + U.id,
            onMouseenter: he[17] || (he[17] = (q) => q.currentTarget.focus({ preventScroll: !0 })),
            onClick: (q) => te(U)
          }, [
            u("span", aj, [
              C($, {
                name: U.icon,
                size: 14
              }, null, 8, ["name"])
            ]),
            u("span", lj, E(U.label), 1),
            U.keys ? (g(), b("kbd", dj, E(U.keys), 1)) : z("", !0)
          ], 42, rj)
        ], 64))), 128))
      ], 36)) : z("", !0)
    ], 64));
  }
});
var uj = Object.defineProperty, hj = (n, e, t) => e in n ? uj(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, pg = (n, e, t) => hj(n, typeof e != "symbol" ? e + "" : e, t);
const pj = 0.5;
function fj(n) {
  return n.type === "tool" || n.type === "chat";
}
function mj(n, e) {
  const t = Math.min(n.x + n.w, e.x + e.w) - Math.max(n.x, e.x), i = Math.min(n.y + n.h, e.y + e.h) - Math.max(n.y, e.y);
  return t <= 0 || i <= 0 ? 0 : t * i / Math.max(1, Math.min(n.w * n.h, e.w * e.h));
}
function gj(n) {
  const e = n.filter(fj), t = e.map((a, l) => l), i = (a) => {
    for (; t[a] !== a; ) a = t[a] = t[t[a]];
    return a;
  }, s = e.map(He);
  for (let a = 0; a < e.length; a++)
    for (let l = a + 1; l < e.length; l++)
      mj(s[a], s[l]) >= pj && (t[i(a)] = i(l));
  const o = /* @__PURE__ */ new Map();
  e.forEach((a, l) => {
    const d = i(l), c = o.get(d);
    c ? c.push(a) : o.set(d, [a]);
  });
  const r = /* @__PURE__ */ new Map();
  for (const a of o.values())
    a.length < 2 || (a.sort((l, d) => d.z - l.z), r.set(a[0].id, a.map((l) => l.id)));
  return r;
}
const bj = 450;
class vj {
  constructor(e) {
    pg(this, "board", e), pg(this, "s", /* @__PURE__ */ Xt({ top: null, ids: [] })), pg(this, "timer", 0);
  }
  /** Fan this stack out (a hover on its badge), or keep it open. */
  open(e, t) {
    clearTimeout(this.timer), this.s.top = e, this.s.ids = t.slice();
  }
  /** The pointer is on the fan or the badge: it stays. */
  keep() {
    clearTimeout(this.timer);
  }
  /** The pointer left: fold after a moment, unless it comes back. */
  leave() {
    clearTimeout(this.timer), this.timer = window.setTimeout(() => this.close(), bj);
  }
  close() {
    clearTimeout(this.timer), this.s.top = null, this.s.ids = [];
  }
  /** A card in the fan picked: it comes to the top of the stack, selected. */
  pick(e) {
    this.close(), this.board.bringToTop(e);
  }
}
const Xw = /* @__PURE__ */ new WeakMap();
function U8(n) {
  let e = Xw.get(n);
  return e || (e = new vj(n), Xw.set(n, e)), e;
}
const yj = ["title", "data-testid", "onClick"], xj = { class: "txt" }, wj = {
  key: 0,
  class: "on-top"
}, kj = 168, _j = 10, Sj = /* @__PURE__ */ Pe({
  __name: "StackFan",
  setup(n) {
    const { board: e } = Ze(), t = U8(e), i = I(() => (e.docRev.value, t.s.ids.map((r) => e.store.get(r)).filter((r) => !!r && (r.type === "tool" || r.type === "chat")).map((r) => {
      const a = r.type === "tool" ? r : null;
      return {
        id: r.id,
        name: r.name || (a ? a.kind : "Chat"),
        icon: a ? a.icon || "Image" : "MessagesSquare",
        sub: a ? a.kind + (a.model ? " · " + a.model : "") : "Chat",
        thumb: a && a.thumbs && a.thumbs.length ? Bt(a.thumbs[0]) : ""
      };
    }))), s = I(() => {
      e.docRev.value;
      const r = t.s.top ? e.store.get(t.s.top) : null;
      if (!r || i.value.length < 2) return null;
      const a = e.cam.value, l = He(r), d = (l.x + l.w / 2) * a.zoom + a.x + e.view.left, c = l.y * a.zoom + a.y + e.view.top, h = (l.y + l.h) * a.zoom + a.y + e.view.top, f = i.value.length, p = f * kj + (f - 1) * _j, y = Math.min(Math.max(8, d - p / 2), window.innerWidth - p - 8), v = c - 164 < 62;
      return { left: y, top: v ? h + 22 : c - 150, width: p, below: v, origin: d - y + "px " + (v ? "0" : "100%") };
    });
    function o(r) {
      const a = i.value.length, l = a > 1 ? (r - (a - 1) / 2) / ((a - 1) / 2) : 0;
      return "rotate(" + (l * 4).toFixed(2) + "deg) translateY(" + (Math.abs(l) * 8).toFixed(1) + "px)";
    }
    return (r, a) => (g(), Ie(vt, { name: "cv-fan" }, {
      default: Xe(() => [
        s.value ? (g(), b("div", {
          key: 0,
          class: G(["cv-fan", { "is-below": s.value.below }]),
          style: ce({ left: s.value.left + "px", top: s.value.top + "px", width: s.value.width + "px", transformOrigin: s.value.origin }),
          role: "menu",
          "aria-label": "The cards in this stack",
          "data-testid": "stack-fan",
          onPointerdown: a[0] || (a[0] = Te(() => {
          }, ["stop"])),
          onMouseenter: a[1] || (a[1] = (l) => m(t).keep()),
          onMouseleave: a[2] || (a[2] = (l) => m(t).leave())
        }, [
          (g(!0), b(j, null, ge(i.value, (l, d) => (g(), b("button", {
            key: l.id,
            type: "button",
            role: "menuitem",
            class: G(["cv-fan-card", { "is-top": d === 0 }]),
            style: ce({ "--tilt": o(d), "--i": d }),
            title: d === 0 ? l.name + " (on top)" : "Bring " + l.name + " to the top",
            "data-testid": "stack-fan-" + l.id,
            onClick: (c) => m(t).pick(l.id)
          }, [
            u("span", {
              class: "pic",
              style: ce(l.thumb ? { backgroundImage: 'url("' + l.thumb + '")' } : void 0)
            }, [
              l.thumb ? z("", !0) : (g(), Ie($, {
                key: 0,
                name: l.icon,
                size: 18
              }, null, 8, ["name"]))
            ], 4),
            u("span", xj, [
              u("b", null, E(l.name), 1),
              u("small", null, [
                C($, {
                  name: l.icon,
                  size: 10
                }, null, 8, ["name"]),
                Y(E(l.sub), 1)
              ])
            ]),
            d === 0 ? (g(), b("span", wj, "On top")) : z("", !0)
          ], 14, yj))), 128))
        ], 38)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), Mj = { class: "hd" }, Tj = { class: "sw-grid" }, Cj = ["title", "onClick"], Ij = { class: "wrow" }, Aj = ["value"], Pj = { class: "num" }, Ej = { class: "stp" }, Rj = { class: "prev" }, zj = {
  width: "100%",
  height: "26",
  viewBox: "0 0 250 26",
  fill: "none",
  preserveAspectRatio: "none"
}, $j = ["stroke", "stroke-width"], fg = 306, Jw = 168, Zw = 62, Dj = /* @__PURE__ */ Pe({
  __name: "ShapeStyleBar",
  setup(n) {
    const e = ["#9968df", "#a3a7f5", "#c750ce", "#37d399", "#ffb347", "#ff5c7a", "#ffffff", "#8b93ad", "#0b0d14"], { board: t } = Ze(), i = I(() => {
      t.docRev.value;
      const l = t.ui.selection.length === 1 ? t.store.get(t.ui.selection[0]) : null;
      return l && l.type === "shape" ? { ...l } : null;
    }), s = I(() => i.value && i.value.sw != null ? i.value.sw : io.sw), o = I(() => i.value && i.value.stroke || io.stroke), r = I(() => {
      const l = i.value;
      if (!l) return { left: 0, top: 0 };
      const d = t.cam.value, c = He(l), h = (c.x + c.w / 2) * d.zoom + d.x + t.view.left, f = c.y * d.zoom + d.y + t.view.top, p = f + c.h * d.zoom, y = f - 50;
      let v;
      return y >= Zw ? v = y - Jw - 8 >= Zw ? y - Jw - 8 : p + 12 : v = p + 12 + 46, {
        left: Math.min(Math.max(8, h - fg / 2), window.innerWidth - fg - 8),
        top: v
      };
    });
    function a(l) {
      i.value && t.patchShape(i.value.id, { sw: Math.max(1, Math.min(32, Math.round(l))) });
    }
    return (l, d) => i.value && m(t).ui.styleOpen && !m(t).ui.dragging ? (g(), b("div", {
      key: 0,
      class: "v2-stylebar",
      "data-testid": "stroke-popover",
      style: ce({ left: r.value.left + "px", top: r.value.top + "px", width: fg + "px" }),
      onPointerdown: d[4] || (d[4] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", Mj, [
        d[5] || (d[5] = u("span", null, "Stroke", -1)),
        u("button", {
          class: "x",
          "aria-label": "Close",
          onClick: d[0] || (d[0] = (c) => m(t).ui.styleOpen = !1)
        }, [
          C($, {
            name: "X",
            size: 12
          })
        ])
      ]),
      u("div", Tj, [
        (g(), b(j, null, ge(e, (c) => u("button", {
          key: c,
          class: G(["sw", { on: c === o.value }]),
          title: c,
          onClick: (h) => m(t).patchShape(i.value.id, { stroke: c })
        }, [
          u("span", {
            style: ce({ background: c })
          }, null, 4)
        ], 10, Cj)), 64))
      ]),
      u("div", Ij, [
        d[6] || (d[6] = u("span", { class: "lb" }, "Width", -1)),
        u("input", {
          type: "range",
          min: "1",
          max: "32",
          step: "1",
          value: s.value,
          onInput: d[1] || (d[1] = (c) => a(+c.target.value))
        }, null, 40, Aj),
        u("div", Pj, [
          u("span", null, E(s.value), 1),
          u("div", Ej, [
            u("button", {
              "aria-label": "Thicker",
              onClick: d[2] || (d[2] = (c) => a(s.value + 1))
            }, [
              C($, {
                name: "ChevronUp",
                size: 10
              })
            ]),
            u("button", {
              "aria-label": "Thinner",
              onClick: d[3] || (d[3] = (c) => a(s.value - 1))
            }, [
              C($, {
                name: "ChevronDown",
                size: 10
              })
            ])
          ])
        ])
      ]),
      u("div", Rj, [
        (g(), b("svg", zj, [
          u("path", {
            d: "M6 13 H244",
            stroke: o.value,
            "stroke-width": s.value,
            "stroke-linecap": "round"
          }, null, 8, $j)
        ]))
      ])
    ], 36)) : z("", !0);
  }
}), Oj = /* @__PURE__ */ new Set(["fbx"]);
function Lj(n) {
  const e = /\.([a-z0-9]+)$/i.exec(n || ""), t = e ? e[1].toLowerCase() : "";
  return Oj.has(t) ? t : null;
}
const Vt = 768, G8 = [
  "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
  "m3.3 7 8.7 5 8.7-5",
  "M12 22V12"
], lf = 'Inter, system-ui, -apple-system, "Segoe UI", sans-serif', j8 = "#1d1730", H8 = "#0b0d15", V8 = "#b79cf0", W8 = "#ece8f6", q8 = "#8f8aa6", Bv = /* @__PURE__ */ new Map();
function K8(n) {
  return ["3D model, ." + n, "No preview: download to open it"];
}
function Bj(n) {
  const [e, t] = K8(n), i = 8, s = (Vt - 24 * i) / 2, o = `<svg xmlns="http://www.w3.org/2000/svg" width="${Vt}" height="${Vt}" viewBox="0 0 ${Vt} ${Vt}"><defs><radialGradient id="g" cx="50%" cy="40%" r="70%"><stop offset="0" stop-color="${j8}"/><stop offset="1" stop-color="${H8}"/></radialGradient></defs><rect width="${Vt}" height="${Vt}" fill="url(#g)"/><g transform="translate(${s} ${s - 70}) scale(${i})" fill="none" stroke="${V8}" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">${G8.map((r) => `<path d="${r}"/>`).join("")}</g><text x="${Vt / 2}" y="${Vt / 2 + 150}" text-anchor="middle" font-family='${lf}' font-size="66" font-weight="600" fill="${W8}">${e}</text><text x="${Vt / 2}" y="${Vt / 2 + 214}" text-anchor="middle" font-family='${lf}' font-size="38" fill="${q8}">${t}</text></svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(o);
}
function Fj(n) {
  if (typeof document == "undefined" || typeof Path2D == "undefined") return null;
  const e = document.createElement("canvas");
  e.width = Vt, e.height = Vt;
  const t = e.getContext("2d");
  if (!t) return null;
  const i = t.createRadialGradient(Vt / 2, Vt * 0.4, 0, Vt / 2, Vt * 0.4, Vt * 0.7);
  i.addColorStop(0, j8), i.addColorStop(1, H8), t.fillStyle = i, t.fillRect(0, 0, Vt, Vt);
  const s = 8, o = (Vt - 24 * s) / 2;
  t.save(), t.translate(o, o - 70), t.scale(s, s), t.strokeStyle = V8, t.lineWidth = 1.4, t.lineCap = "round", t.lineJoin = "round";
  for (const l of G8) t.stroke(new Path2D(l));
  t.restore();
  const [r, a] = K8(n);
  t.textAlign = "center", t.fillStyle = W8, t.font = "600 66px " + lf, t.fillText(r, Vt / 2, Vt / 2 + 150), t.fillStyle = q8, t.font = "38px " + lf, t.fillText(a, Vt / 2, Vt / 2 + 214);
  try {
    return e.toDataURL("image/png");
  } catch {
    return null;
  }
}
function Nj(n, e = "") {
  let t = Bv.get(n);
  return t || (t = Fj(n) || Bj(n), Bv.set(n, t)), e ? t + "#" + encodeURIComponent(e) : t;
}
function df(n) {
  if (!n) return !1;
  const e = n.split("#")[0];
  for (const t of Bv.values()) if (t === e) return !0;
  return !1;
}
const Qw = Vt, Uj = { class: "v2-hist-head" }, Gj = { class: "n" }, jj = { class: "t" }, Hj = {
  key: 0,
  class: "v2-hist-empty"
}, Vj = ["data-testid", "onMouseenter"], Wj = ["title", "onPointerdown"], qj = {
  key: 1,
  class: "v2-hist-withheld"
}, Kj = {
  key: 0,
  class: "v2-hist-time"
}, Yj = {
  key: 1,
  class: "v2-hist-vid"
}, Xj = {
  key: 2,
  class: "v2-hist-fav"
}, Jj = ["title"], Zj = {
  key: 1,
  class: "v2-hist-more"
}, Qj = ["src"], eH = { class: "cap" }, tH = { class: "n" }, nH = {
  key: 0,
  class: "m"
}, iH = { class: "v2-hist-acts" }, sH = ["aria-pressed"], oH = { class: "tip" }, ek = 300, Xu = 8, rH = /* @__PURE__ */ Pe({
  __name: "ToolHistory",
  props: {
    tool: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = Ze(), s = dr(), o = /* @__PURE__ */ W(!1);
    async function r() {
      if (!(o.value || t.historyDone(e.tool.id))) {
        o.value = !0;
        try {
          await t.loadHistory(e.tool.id);
        } finally {
          o.value = !1;
        }
      }
    }
    Ee(() => e.tool.id, () => {
      r();
    }, { immediate: !0 });
    function a(L) {
      const N = L.target;
      c.value = N.scrollTop, P(), N.scrollHeight - N.scrollTop - N.clientHeight < 400 && r();
    }
    const l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(null), c = /* @__PURE__ */ W(0), h = /* @__PURE__ */ W(600), f = /* @__PURE__ */ W(274), p = /* @__PURE__ */ W(null);
    let y = 0;
    const v = I(() => (t.results.rev.value, t.results.list(e.tool.id))), x = I(() => new Set(v.value.slice(0, t.ui.newThumbs[e.tool.id] || 0).map((L) => L.id))), w = I(() => {
      const L = (f.value - Xu) / 2;
      return { w: L, h: Math.round(L * 3 / 4) };
    }), S = I(() => Math.ceil(v.value.length / 2) * (w.value.h + Xu)), M = I(() => {
      const L = w.value.h + Xu, N = Math.max(0, Math.floor(c.value / L) - 2), K = Math.ceil((c.value + h.value) / L) + 2, B = [];
      for (let re = N; re <= K; re++)
        for (let H = 0; H < 2; H++) {
          const J = re * 2 + H, Q = v.value[J];
          Q && B.push({ it: Q, i: J, x: H * (w.value.w + Xu), y: re * L });
        }
      return B;
    });
    let _ = null;
    it(() => {
      d.value && (_ = new ResizeObserver(() => {
        d.value && (h.value = d.value.clientHeight, f.value = d.value.clientWidth - 2);
      }), _.observe(d.value));
    }), We(() => {
      _ && _.disconnect(), clearTimeout(y);
    });
    const T = () => clearTimeout(y), k = () => {
      clearTimeout(y), y = window.setTimeout(() => {
        p.value = null;
      }, 180);
    }, P = () => {
      clearTimeout(y), p.value = null;
    };
    function A(L, N) {
      if (T(), L.status !== "done") return;
      const K = l.value;
      if (!K) return;
      const B = N.currentTarget.getBoundingClientRect(), re = K.getBoundingClientRect(), H = Math.round(ek * ((L.h || 3) / (L.w || 4))), J = Math.min(Math.max(8 - re.top, B.top - re.top + B.height / 2 - H / 2), window.innerHeight - 8 - H - re.top);
      p.value = { id: L.id, it: L, top: J, h: H };
    }
    function R(L) {
      if (L.status !== "done") return;
      const N = t.placedFor(L.id);
      t.ui.infoSession = e.tool.id, t.ui.infoAt = N ? N.id : "result:" + L.id;
    }
    function D(L, N) {
      if (P(), L.status !== "done") return;
      if (t.ui.eyedropper) {
        N.preventDefault(), t.eyedrop(L.url, L.asset || null, !!L.video);
        return;
      }
      const K = Math.min(360, Math.max(200, L.w || 300)), B = Math.round(K * (L.h || 3) / (L.w || 4));
      i.dragResultOut({ url: L.url, w: K, h: B, result: L, sessionId: e.tool.id }, N, {
        keepSelection: e.tool.id,
        onClick: () => R(L)
      });
    }
    function O(L) {
      P();
      const N = t.placedFor(L.id);
      N && (t.ui.selection = [N.id], t.jumpTo(N.x + N.w / 2, N.y + N.h / 2, Math.max(t.cam.value.zoom, 0.6)));
    }
    function F(L) {
      P(), t.placeResult(L);
    }
    function ie(L) {
      t.setPrompt(e.tool.id, { prompt: L.prompt || "" }), t.toast("Prompt loaded into " + e.tool.name);
    }
    function ee(L) {
      t.addReference(e.tool.id, L.url, L.asset || null);
    }
    function me(L) {
      R(L), t.ui.infoSave = !0;
    }
    return (L, N) => (g(), b("div", {
      ref_key: "panel",
      ref: l,
      class: "v2-hist",
      "data-testid": "results-gallery",
      onPointerdown: N[11] || (N[11] = Te(() => {
      }, ["stop"])),
      onWheel: N[12] || (N[12] = Te(() => {
      }, ["stop"])),
      onMouseleave: k
    }, [
      u("div", Uj, [
        u("span", Gj, E(v.value.length), 1),
        u("span", jj, E(n.tool.name), 1),
        u("button", {
          class: "v2-hist-close",
          title: "Hide the gallery",
          onClick: N[0] || (N[0] = (K) => m(t).ui.histOpen = !1)
        }, [
          C($, {
            name: "PanelRightClose",
            size: 13
          })
        ])
      ]),
      N[22] || (N[22] = u("div", { class: "v2-hist-hint" }, "Click for the full record · drag onto the board", -1)),
      u("div", {
        ref_key: "grid",
        ref: d,
        class: "v2-hist-grid",
        onScroll: a
      }, [
        !v.value.length && !o.value ? (g(), b("div", Hj, "Results from this session will collect here. Write a prompt and Run.")) : z("", !0),
        u("div", {
          style: ce({ height: S.value + "px", position: "relative" })
        }, [
          (g(!0), b(j, null, ge(M.value, (K) => (g(), b("div", {
            key: K.it.id,
            class: G(["v2-hist-item", {
              "is-on": p.value && p.value.id === K.it.id,
              "is-new": x.value.has(K.it.id),
              "is-pending": K.it.status === "pending",
              "is-failed": K.it.status === "failed",
              "is-withheld": K.it.status === "moderated"
            }]),
            style: ce({ left: K.x + "px", top: K.y + "px", width: w.value.w + "px", height: w.value.h + "px" }),
            "data-testid": "gallery-item-" + K.it.status,
            onMouseenter: (B) => A(K.it, B)
          }, [
            u("button", {
              class: "shot",
              title: K.it.status === "moderated" ? "Withheld by the safety check" : K.it.label,
              onPointerdown: (B) => D(K.it, B)
            }, [
              u("span", {
                class: "art",
                style: ce(K.it.url && K.it.status === "done" ? { backgroundImage: 'url("' + m(Bt)(K.it.url) + '")' } : void 0)
              }, [
                K.it.status === "failed" ? (g(), Ie($, {
                  key: 0,
                  name: "AlertCircle",
                  size: 16
                })) : K.it.status === "moderated" ? (g(), b("span", qj, [
                  C($, {
                    name: "EyeOff",
                    size: 14
                  }),
                  N[13] || (N[13] = Y("Withheld", -1))
                ])) : z("", !0)
              ], 4),
              K.it.status === "pending" && K.it.startedAt ? (g(), b("span", Kj, E(m(E1)(m(s) - K.it.startedAt)), 1)) : z("", !0),
              K.it.video && K.it.status === "done" ? (g(), b("span", Yj, [
                C($, {
                  name: "Play",
                  size: 8
                }),
                Y(" " + E(K.it.dur || "0:05"), 1)
              ])) : z("", !0),
              m(t).isFav(K.it) ? (g(), b("span", Xj, [
                C($, {
                  name: "Heart",
                  size: 8
                })
              ])) : z("", !0),
              K.it.status === "done" && m(t).isPinnedImage(K.it.url) ? (g(), b("span", {
                key: 3,
                class: "v2-hist-pin",
                title: m(Xn).badge
              }, [
                C($, {
                  name: "Pin",
                  size: 9
                })
              ], 8, Jj)) : z("", !0)
            ], 40, Wj)
          ], 46, Vj))), 128))
        ], 4),
        o.value ? (g(), b("div", Zj, [...N[14] || (N[14] = [
          u("span", { class: "bd-spinner is-sm" }, null, -1)
        ])])) : z("", !0)
      ], 544),
      p.value ? (g(), b("div", {
        key: 0,
        class: "v2-hist-pop",
        style: ce({ top: p.value.top + "px", width: ek + "px", height: p.value.h + "px" }),
        onMouseenter: T,
        onMouseleave: k
      }, [
        u("button", {
          class: "art",
          title: "Open the full record",
          style: ce({ backgroundImage: 'url("' + p.value.it.url + '")' }),
          onClick: N[2] || (N[2] = (K) => R(p.value.it))
        }, [
          p.value.it.video && p.value.it.videoSrc ? (g(), b("video", {
            key: p.value.it.videoSrc,
            class: "art-vid",
            src: p.value.it.videoSrc,
            "data-testid": "gallery-video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            preload: "auto",
            disablepictureinpicture: "",
            onPlaying: N[1] || (N[1] = (K) => K.target.classList.add("is-shown"))
          }, null, 40, Qj)) : z("", !0)
        ], 4),
        u("span", eH, [
          u("span", tH, E(p.value.it.label || p.value.it.prompt), 1),
          p.value.it.video ? (g(), b("span", nH, [
            C($, {
              name: "Play",
              size: 10
            }),
            Y(" " + E(p.value.it.dur || "0:05"), 1)
          ])) : z("", !0)
        ]),
        u("span", iH, [
          u("button", {
            class: G(["find is-pin", { on: m(t).isPinnedImage(p.value.it.url) }]),
            "aria-pressed": m(t).isPinnedImage(p.value.it.url),
            "data-testid": "gallery-pin",
            onClick: N[3] || (N[3] = Te((K) => m(t).togglePinImage(m(um)(p.value.it)), ["stop"]))
          }, [
            C($, {
              name: "Pin",
              size: 13
            }),
            u("span", oH, E(m(t).isPinnedImage(p.value.it.url) ? m(Xn).unpin : m(Xn).pin), 1)
          ], 10, sH),
          m(df)(p.value.it.url) ? z("", !0) : (g(), b("button", {
            key: 0,
            class: "find",
            "data-testid": "gallery-use-ref",
            onClick: N[4] || (N[4] = Te((K) => ee(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "ImagePlus",
              size: 13
            }),
            N[15] || (N[15] = u("span", { class: "tip" }, "Use as reference", -1))
          ])),
          u("button", {
            class: "find",
            "data-testid": "gallery-use-prompt",
            onClick: N[5] || (N[5] = Te((K) => ie(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Type",
              size: 13
            }),
            N[16] || (N[16] = u("span", { class: "tip" }, "Use the prompt", -1))
          ]),
          m(t).placedFor(p.value.it.id) ? (g(), b("button", {
            key: 1,
            class: "find",
            "data-testid": "gallery-find",
            onClick: N[6] || (N[6] = Te((K) => O(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "LocateFixed",
              size: 13
            }),
            N[17] || (N[17] = u("span", { class: "tip" }, "Find it on the board", -1))
          ])) : p.value.it.status === "done" ? (g(), b("button", {
            key: 2,
            class: "find",
            "data-testid": "gallery-place",
            onClick: N[7] || (N[7] = Te((K) => F(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "ArrowDownToLine",
              size: 13
            }),
            N[18] || (N[18] = u("span", { class: "tip" }, "Place on the board", -1))
          ])) : z("", !0),
          p.value.it.status === "done" ? (g(), b("button", {
            key: 3,
            class: "find",
            "data-testid": "gallery-details",
            onClick: N[8] || (N[8] = Te((K) => R(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Info",
              size: 13
            }),
            N[19] || (N[19] = u("span", { class: "tip" }, "Details", -1))
          ])) : z("", !0),
          m(t).promptLibrary.canSave && p.value.it.prompt ? (g(), b("button", {
            key: 4,
            class: "find",
            "data-testid": "gallery-save-prompt",
            onClick: N[9] || (N[9] = Te((K) => me(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Bookmark",
              size: 13
            }),
            N[20] || (N[20] = u("span", { class: "tip" }, "Save to the prompt library", -1))
          ])) : z("", !0),
          p.value.it.kind === "3d" && p.value.it.download ? (g(), b("button", {
            key: 5,
            class: "find",
            "data-testid": "gallery-download",
            onClick: N[10] || (N[10] = Te((K) => m(t).downloadResult(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Download",
              size: 13
            }),
            N[21] || (N[21] = u("span", { class: "tip" }, "Download the 3D model", -1))
          ])) : z("", !0)
        ])
      ], 36)) : z("", !0)
    ], 544));
  }
});
var aH = Object.defineProperty, lH = (n, e, t) => e in n ? aH(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, go = (n, e, t) => lH(n, typeof e != "symbol" ? e + "" : e, t);
const jr = 1, mc = 5, Fv = 2;
function G1(n) {
  if (n.allSessions()) return "All sessions";
  const e = n.pickedSessions();
  if (e.length > 1) return e.length + " sessions";
  const t = n.historySessions.value.find((i) => i.id === e[0]);
  return t ? t.name : "All sessions";
}
const Y8 = (n) => "rd-board-studio-history:" + n;
function X8(n) {
  try {
    const e = Number(JSON.parse(localStorage.getItem(Y8(n)) || "{}").columns);
    return e >= jr && e <= mc ? Math.round(e) : Fv;
  } catch {
    return Fv;
  }
}
function J8(n, e) {
  try {
    localStorage.setItem(Y8(n), JSON.stringify({ columns: e }));
  } catch {
  }
}
function Z8(n) {
  const e = Math.round(n);
  return Number.isFinite(e) ? Math.max(jr, Math.min(mc, e)) : Fv;
}
function tk(n) {
  return n.doneAt || n.createdAt;
}
function dH(n) {
  return n.status !== "moderated" && !(n.status === "done" && !n.url);
}
class cH {
  constructor(e) {
    go(this, "board", e), go(this, "s"), go(this, "boardItems"), go(this, "historySessions"), go(this, "shown"), go(this, "unread"), go(this, "seenAt"), go(this, "scope", c1(!0)), this.s = /* @__PURE__ */ Xt({ sessions: [], columns: X8(e.user.uid), pinned: !1 }), this.seenAt = /* @__PURE__ */ W(e.historySeenAt != null ? e.historySeenAt : Date.now());
    const t = this.scope.run(() => {
      const i = I(() => {
        e.docRev.value;
        const l = [];
        for (const d of e.store.all()) d.type === "tool" && l.push(d.id);
        return l.join(" ");
      }), s = I(() => {
        e.results.rev.value;
        const l = [];
        for (const d of i.value ? i.value.split(" ") : [])
          for (const c of e.results.list(d)) dH(c) && l.push(c);
        return l.sort((d, c) => c.createdAt - d.createdAt);
      }), o = I(() => {
        const l = /* @__PURE__ */ new Map();
        for (const d of s.value) l.set(d.sessionId, (l.get(d.sessionId) || 0) + 1);
        return e.recentTools().filter((d) => l.has(d.id) || e.isPinned(d.id)).map((d) => ({ id: d.id, name: d.name, icon: d.icon || "Image", count: l.get(d.id) || 0, here: !1, pinned: e.isPinned(d.id) }));
      }), r = I(() => {
        const l = this.pickedSessions();
        return l.length ? s.value.filter((d) => l.includes(d.sessionId)) : s.value;
      }), a = I(() => {
        const l = this.seenAt.value;
        let d = 0;
        for (const c of s.value) c.status === "done" && tk(c) > l && d++;
        return d;
      });
      return Ee([() => e.ui.boardHistory, s], ([l]) => {
        l && this.markSeen();
      }, { immediate: !0 }), { boardItems: s, historySessions: o, shown: r, unread: a };
    });
    this.boardItems = t.boardItems, this.historySessions = t.historySessions, this.shown = t.shown, this.unread = t.unread;
  }
  /** Everything in history seen: the newest finish, or now, whichever is later. */
  markSeen() {
    let e = Math.max(this.seenAt.value, Date.now());
    for (const t of this.boardItems.value) t.status === "done" && (e = Math.max(e, tk(t)));
    this.seenAt.value = e, this.board.markHistorySeen(e);
  }
  pickedSessions() {
    const e = this.historySessions.value;
    return this.s.sessions.filter((t) => e.some((i) => i.id === t));
  }
  allSessions() {
    const e = this.pickedSessions();
    return !e.length || e.length === this.historySessions.value.length;
  }
  toggleSession(e) {
    const t = this.pickedSessions();
    this.s.sessions = t.includes(e) ? t.filter((i) => i !== e) : [...t, e];
  }
  onlySession(e) {
    this.s.sessions = e ? [e] : [];
  }
  /** History's columns, remembered for the next visit and the next board (the Studios view's too). */
  setColumns(e) {
    const t = Z8(e);
    t !== this.s.columns && (this.s.columns = t, J8(this.board.user.uid, t));
  }
  /** The session a result came from, while it's on the board. */
  sessionOf(e) {
    const t = this.board.store.get(e.sessionId);
    return t && t.type === "tool" ? t : null;
  }
  dispose() {
    this.scope.stop();
  }
}
const nk = /* @__PURE__ */ new WeakMap();
function Q8(n) {
  let e = nk.get(n);
  return e || (e = new cH(n), nk.set(n, e)), e;
}
const uH = ["aria-pressed"], hH = {
  key: 0,
  class: "badge is-unread",
  "data-testid": "comments-badge"
}, pH = {
  key: 1,
  class: "cm-rail-dot",
  "data-testid": "comments-elsewhere-dot"
}, fH = { class: "tip" }, mH = ["aria-pressed"], gH = {
  key: 0,
  class: "badge is-unread",
  "data-testid": "board-history-badge"
}, bH = { class: "tip" }, vH = ["aria-pressed"], yH = {
  key: 0,
  class: "badge"
}, xH = { class: "tip" }, wH = /* @__PURE__ */ Pe({
  __name: "SideRail",
  setup(n) {
    const { board: e } = Ze(), t = Q8(e), i = I(() => t.unread.value), s = e.comments, o = I(() => s.unreadCount.value), r = I(() => s.elsewhereUnread.value);
    function a() {
      s.ui.panelOpen = !s.ui.panelOpen;
    }
    const l = os(e), d = I(() => l.allChats());
    function c() {
      if (e.ui.chatOpen) {
        e.ui.chatOpen = null;
        return;
      }
      const h = d.value[0];
      h && (e.ui.selection = [h.id], e.ui.chatOpen = h.id);
    }
    return (h, f) => (g(), b("nav", {
      class: "bd-siderail",
      "aria-label": "Board panels",
      "data-testid": "side-rail",
      onPointerdown: f[1] || (f[1] = Te(() => {
      }, ["stop"]))
    }, [
      m(s).enabled ? (g(), b("button", {
        key: 0,
        class: G(["bd-siderail-btn", { on: m(s).ui.panelOpen }]),
        "aria-pressed": m(s).ui.panelOpen,
        "aria-label": "Comments",
        "data-testid": "comments-toggle",
        onClick: a
      }, [
        C($, {
          name: "MessageCircle",
          size: 16
        }),
        o.value ? (g(), b("span", hH, E(o.value > 99 ? "99+" : o.value), 1)) : r.value ? (g(), b("span", pH)) : z("", !0),
        u("span", fH, "Comments" + E(o.value ? ": " + o.value + " unread" : r.value ? ": news on other boards" : ""), 1)
      ], 10, uH)) : z("", !0),
      u("button", {
        class: G(["bd-siderail-btn", { on: m(e).ui.boardHistory }]),
        "aria-pressed": m(e).ui.boardHistory,
        "aria-label": "Board history",
        "data-testid": "board-history-toggle",
        onClick: f[0] || (f[0] = (p) => m(e).ui.boardHistory = !m(e).ui.boardHistory)
      }, [
        C($, {
          name: "History",
          size: 16
        }),
        i.value ? (g(), b("span", gH, E(i.value > 99 ? "99+" : i.value), 1)) : z("", !0),
        u("span", bH, "Board history" + E(i.value ? ": " + i.value + " new" : ""), 1)
      ], 10, mH),
      d.value.length ? (g(), b("button", {
        key: 1,
        class: G(["bd-siderail-btn", { on: !!m(e).ui.chatOpen }]),
        "aria-pressed": !!m(e).ui.chatOpen,
        "aria-label": "Chats",
        "data-testid": "chat-toggle",
        onClick: c
      }, [
        C($, {
          name: "MessagesSquare",
          size: 16
        }),
        d.value.length > 1 ? (g(), b("span", yH, E(d.value.length), 1)) : z("", !0),
        u("span", xH, E(d.value.length === 1 ? d.value[0].name : "Chats: the latest opens"), 1)
      ], 10, vH)) : z("", !0)
    ], 32));
  }
}), kH = { "data-testid": "elapsed" }, j1 = /* @__PURE__ */ Pe({
  __name: "Elapsed",
  props: {
    since: {}
  },
  setup(n) {
    const e = n, t = dr(), i = I(() => E1(t.value - e.since));
    return (s, o) => (g(), b("span", kH, E(i.value), 1));
  }
}), _H = ["title"], SH = { class: "sv-hist-cols-track" }, MH = ["min", "max", "value", "aria-valuetext", "data-testid"], eS = /* @__PURE__ */ Pe({
  __name: "HistoryColumns",
  props: {
    columns: {},
    testid: {}
  },
  emits: ["set"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = Array.from({ length: mc - jr + 1 }, (a, l) => jr + l), o = (a) => (a - jr) / (mc - jr), r = I(() => t.columns + (t.columns === 1 ? " column" : " columns"));
    return (a, l) => (g(), b("div", {
      class: "sv-hist-cols",
      title: r.value
    }, [
      C($, {
        name: "Square",
        size: 11
      }),
      u("span", SH, [
        l[1] || (l[1] = u("span", { class: "rail" }, null, -1)),
        u("span", {
          class: "fill",
          style: ce({ width: "calc((100% - 12px) * " + o(n.columns) + ")" })
        }, null, 4),
        (g(!0), b(j, null, ge(m(s), (d) => (g(), b("i", {
          key: d,
          class: G({ on: d <= n.columns }),
          style: ce({ left: "calc(6px + (100% - 12px) * " + o(d) + ")" })
        }, null, 6))), 128)),
        u("input", {
          type: "range",
          min: m(jr),
          max: m(mc),
          step: "1",
          value: n.columns,
          "aria-label": "Columns",
          "aria-valuetext": r.value,
          "data-testid": n.testid,
          onInput: l[0] || (l[0] = (d) => i("set", +d.target.value))
        }, null, 40, MH)
      ]),
      C($, {
        name: "Grid3x3",
        size: 11
      })
    ], 8, _H));
  }
}), TH = { class: "sv-hist-filterrow" }, CH = ["aria-expanded", "disabled", "title", "data-testid"], IH = { class: "lb" }, AH = ["data-testid"], PH = {
  key: 0,
  class: "sv-hist-filter-pop",
  role: "menu",
  "aria-label": "Sessions in history"
}, EH = { class: "sv-hist-search" }, RH = ["data-testid", "onKeydown"], zH = ["aria-checked", "data-testid"], $H = { class: "ck" }, DH = { class: "ct" }, OH = ["aria-checked", "title", "data-testid"], LH = { class: "ck" }, BH = { class: "tx" }, FH = { class: "ct" }, NH = { class: "sv-hist-opts" }, UH = ["data-testid"], GH = ["aria-checked", "data-testid", "onClick"], jH = { class: "ck" }, HH = { class: "ic" }, VH = { class: "tx" }, WH = { key: 0 }, qH = { class: "ct" }, KH = { class: "sv-hist-opt-acts" }, YH = ["title", "aria-label", "data-testid", "onClick"], XH = ["title", "data-testid", "onClick"], JH = ["aria-checked", "title", "aria-label", "data-testid", "onClick"], ZH = {
  key: 0,
  class: "sv-hist-opt-none"
}, QH = {
  key: 1,
  class: "sv-hist-opt-none"
}, eV = ["data-testid"], tV = ["aria-pressed", "title", "data-testid"], nV = ["data-testid"], tS = /* @__PURE__ */ Pe({
  __name: "HistorySessions",
  props: {
    filter: {},
    tid: {},
    pinned: { type: Boolean },
    pinCount: {},
    current: {},
    goTo: { type: Function }
  },
  emits: ["pinned"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = Ze(), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(null), a = I(() => t.filter.historySessions.value), l = I(() => t.filter.pickedSessions()), d = I(() => t.filter.allSessions()), c = I(() => G1(t.filter)), h = I(() => a.value.find((T) => T.here) || (t.current ? a.value.find((T) => T.id === t.current) : null) || null), f = I(() => !!h.value && l.value.length === 1 && l.value[0] === h.value.id);
    function p(T) {
      o.value = !1, t.goTo && t.goTo(T);
    }
    const y = /* @__PURE__ */ W(""), v = /* @__PURE__ */ W(null), x = I(() => {
      const T = y.value.trim().toLowerCase(), k = a.value.filter((A) => !T || A.name.toLowerCase().includes(T)), P = k.filter((A) => !A.here && A.pinned);
      return [
        { id: "here", label: "", rows: k.filter((A) => A.here) },
        { id: "pinned", label: P.length ? "Pinned" : "", rows: P },
        { id: "rest", label: P.length ? "Sessions" : "", rows: k.filter((A) => !A.here && !A.pinned) }
      ].map((A) => ({ ...A, label: A.rows.length ? A.label : "" }));
    });
    function w() {
      const T = x.value.flatMap((k) => k.rows)[0];
      T && t.filter.toggleSession(T.id);
    }
    function S() {
      y.value = "", v.value && v.value.focus();
    }
    function M(T) {
      r.value && !r.value.contains(T.target) && (o.value = !1);
    }
    Ee(o, async (T) => {
      T ? window.addEventListener("pointerdown", M, !0) : window.removeEventListener("pointerdown", M, !0), y.value = "", T && (await nt(), v.value && v.value.focus());
    }), We(() => window.removeEventListener("pointerdown", M, !0));
    function _(T) {
      T.key === "Escape" && o.value && (T.preventDefault(), T.stopPropagation(), o.value = !1);
    }
    return (T, k) => (g(), b("div", TH, [
      u("div", {
        ref_key: "menuEl",
        ref: r,
        class: G(["sv-hist-filter", { "is-resting": n.pinned }]),
        onKeydown: _
      }, [
        u("button", {
          class: G(["sv-hist-filter-btn", { on: o.value, "is-narrowed": !d.value && !n.pinned }]),
          "aria-expanded": o.value,
          "aria-haspopup": "menu",
          disabled: n.pinned,
          title: n.pinned ? "Showing your pinned images, which only you see: turn Pinned off to pick sessions" : void 0,
          "data-testid": n.tid + "-sessions",
          onClick: k[0] || (k[0] = (P) => o.value = !o.value)
        }, [
          C($, {
            name: n.pinned ? "Pin" : "Layers",
            size: 13
          }, null, 8, ["name"]),
          u("span", IH, E(n.pinned ? "Your pinned images" : c.value), 1),
          n.pinned ? (g(), b("span", {
            key: 0,
            class: "sv-hist-private",
            "data-testid": n.tid + "-pinned-private"
          }, [
            C($, {
              name: "Lock",
              size: 10
            }),
            k[5] || (k[5] = Y("Only you", -1))
          ], 8, AH)) : (g(), Ie($, {
            key: 1,
            name: "ChevronDown",
            size: 12,
            class: "chev"
          }))
        ], 10, CH),
        o.value ? (g(), b("div", PH, [
          u("div", EH, [
            C($, {
              name: "Search",
              size: 13
            }),
            _t(u("input", {
              ref_key: "searchEl",
              ref: v,
              "onUpdate:modelValue": k[1] || (k[1] = (P) => y.value = P),
              type: "text",
              placeholder: "Search sessions",
              "aria-label": "Search sessions",
              "data-testid": n.tid + "-sessions-search",
              onKeydown: tn(Te(w, ["prevent"]), ["enter"])
            }, null, 40, RH), [
              [Zt, y.value]
            ]),
            y.value ? (g(), b("button", {
              key: 0,
              class: "x",
              "aria-label": "Clear the search",
              onClick: S
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])) : z("", !0)
          ]),
          u("button", {
            role: "menuitemcheckbox",
            "aria-checked": d.value,
            class: G(["sv-hist-opt is-all", { on: d.value }]),
            "data-testid": n.tid + "-sessions-all",
            onClick: k[2] || (k[2] = (P) => n.filter.onlySession(null))
          }, [
            u("span", $H, [
              d.value ? (g(), Ie($, {
                key: 0,
                name: "Check",
                size: 11
              })) : z("", !0)
            ]),
            k[6] || (k[6] = u("span", { class: "tx" }, [
              u("b", null, "All sessions"),
              u("small", null, "Everything made on this board")
            ], -1)),
            u("span", DH, E(n.filter.boardItems.value.length), 1)
          ], 10, zH),
          h.value ? (g(), b("button", {
            key: 0,
            role: "menuitemcheckbox",
            "aria-checked": f.value,
            class: G(["sv-hist-opt is-all is-current", { on: f.value }]),
            title: "Only what " + h.value.name + " made",
            "data-testid": n.tid + "-sessions-current",
            onClick: k[3] || (k[3] = (P) => n.filter.onlySession(h.value.id))
          }, [
            u("span", LH, [
              f.value ? (g(), Ie($, {
                key: 0,
                name: "Check",
                size: 11
              })) : z("", !0)
            ]),
            u("span", BH, [
              k[7] || (k[7] = u("b", null, "Current session", -1)),
              u("small", null, E(h.value.name), 1)
            ]),
            u("span", FH, E(h.value.count), 1)
          ], 10, OH)) : z("", !0),
          k[8] || (k[8] = u("div", {
            class: "sv-hist-opt-sep",
            role: "separator"
          }, null, -1)),
          u("div", NH, [
            (g(!0), b(j, null, ge(x.value, (P) => (g(), b(j, {
              key: P.id
            }, [
              P.label ? (g(), b("div", {
                key: 0,
                class: "sv-hist-opt-label",
                "data-testid": n.tid + "-sessions-" + P.id
              }, E(P.label), 9, UH)) : z("", !0),
              (g(!0), b(j, null, ge(P.rows, (A) => (g(), b("div", {
                key: A.id,
                class: G(["sv-hist-opt-line", { "is-pinned": A.pinned }])
              }, [
                u("button", {
                  role: "menuitemcheckbox",
                  "aria-checked": l.value.includes(A.id),
                  class: G(["sv-hist-opt", { on: l.value.includes(A.id) }]),
                  "data-testid": n.tid + "-session-" + A.id,
                  onClick: (R) => n.filter.toggleSession(A.id)
                }, [
                  u("span", jH, [
                    l.value.includes(A.id) ? (g(), Ie($, {
                      key: 0,
                      name: "Check",
                      size: 11
                    })) : z("", !0)
                  ]),
                  u("span", HH, [
                    C($, {
                      name: A.icon,
                      size: 12
                    }, null, 8, ["name"])
                  ]),
                  u("span", VH, [
                    u("b", null, E(A.name), 1),
                    A.here ? (g(), b("small", WH, "This session")) : z("", !0)
                  ]),
                  u("span", qH, E(A.count), 1)
                ], 10, GH),
                u("span", KH, [
                  p ? (g(), b("button", {
                    key: 0,
                    role: "menuitem",
                    class: "sv-hist-pin is-go",
                    title: "Go to " + A.name + " on the board",
                    "aria-label": "Go to " + A.name + " on the board",
                    "data-testid": n.tid + "-session-go-" + A.id,
                    onClick: (R) => p(A.id)
                  }, [
                    C($, {
                      name: "LocateFixed",
                      size: 12
                    })
                  ], 8, YH)) : z("", !0),
                  u("button", {
                    role: "menuitem",
                    class: "sv-hist-only",
                    title: "Show only " + A.name,
                    "data-testid": n.tid + "-session-only-" + A.id,
                    onClick: (R) => n.filter.onlySession(A.id)
                  }, "Only", 8, XH),
                  u("button", {
                    role: "menuitemcheckbox",
                    "aria-checked": A.pinned,
                    class: G(["sv-hist-pin", { on: A.pinned }]),
                    title: A.pinned ? "Unpin" : "Pin to the top",
                    "aria-label": (A.pinned ? "Unpin " : "Pin ") + A.name,
                    "data-testid": n.tid + "-session-pin-" + A.id,
                    onClick: (R) => m(s).togglePinned(A.id)
                  }, [
                    C($, {
                      name: "Pin",
                      size: 12
                    })
                  ], 10, JH)
                ])
              ], 2))), 128))
            ], 64))), 128)),
            y.value && !x.value.some((P) => P.rows.length) ? (g(), b("div", ZH, "No sessions match")) : z("", !0),
            !y.value && !a.value.length ? (g(), b("div", QH, "No sessions have made anything yet")) : z("", !0)
          ]),
          u("p", {
            class: "sv-hist-opt-note",
            "data-testid": n.tid + "-sessions-note"
          }, "Each session is a tool on the board, named after its first prompt until you rename it on its card.", 8, eV)
        ])) : z("", !0)
      ], 34),
      u("button", {
        class: G(["sv-hist-pinned", { on: n.pinned }]),
        "aria-pressed": n.pinned,
        title: n.pinned ? "Back to everything" : "Your pinned images (only you see them)",
        "data-testid": n.tid + "-pinned",
        onClick: k[4] || (k[4] = (P) => {
          o.value = !1, i("pinned", !n.pinned);
        })
      }, [
        C($, {
          name: "Pin",
          size: 13
        }),
        n.pinCount ? (g(), b("span", {
          key: 0,
          class: "ct",
          "data-testid": n.tid + "-pinned-count"
        }, E(n.pinCount), 9, nV)) : z("", !0)
      ], 10, tV)
    ]));
  }
}), iV = ["data-testid"], sV = {
  class: "pe-art",
  "aria-hidden": "true"
}, oV = { class: "pe-pin" }, rV = { class: "pe-private" }, aV = {
  key: 0,
  class: "pe-body"
}, lV = { class: "pe-hint" }, dV = { class: "pe-key" }, H1 = /* @__PURE__ */ Pe({
  __name: "PinnedEmpty",
  props: {
    compact: { type: Boolean, default: !1 },
    kind: { default: "image" }
  },
  setup(n) {
    const e = n, t = I(() => e.kind === "video" ? "videos" : "images");
    return (i, s) => (g(), b("div", {
      class: G(["pe", { "is-compact": n.compact }]),
      "data-testid": n.compact ? "ref-pinned-empty" : "pinned-empty"
    }, [
      u("div", sV, [
        s[0] || (s[0] = C1('<span class="pe-glow"></span><span class="pe-card c1"><i class="sun"></i><i class="hill"></i></span><span class="pe-card c3"><i class="sun"></i><i class="hill"></i></span><span class="pe-card c2"><i class="sun"></i><i class="hill"></i><i class="hill b"></i></span><span class="pe-ring"></span>', 5)),
        u("span", oV, [
          C($, {
            name: "Pin",
            size: 12
          })
        ])
      ]),
      u("span", rV, [
        C($, {
          name: "Lock",
          size: 10
        }),
        s[1] || (s[1] = Y("Only you see your pins", -1))
      ]),
      s[5] || (s[5] = u("b", { class: "pe-title" }, "Pin your go-to references", -1)),
      n.compact ? (g(), b("p", aV, "Pin the " + E(t.value) + " you reach for as references and they wait here, one click away.", 1)) : (g(), b(j, { key: 1 }, [
        s[2] || (s[2] = u("p", { class: "pe-body" }, "Keep the images you reach for again and again one click away: a mood shot, a material, the site photo you're matching. Use them as references in any prompt on this board.", -1)),
        s[3] || (s[3] = u("p", { class: "pe-note" }, "They're personal: everyone on this board has their own. And unlike favorites, which gather in your Library from every board, pins stay with this board.", -1))
      ], 64)),
      u("span", lV, [
        s[4] || (s[4] = Y("Look for ", -1)),
        u("span", dV, [
          C($, {
            name: "Pin",
            size: 11
          })
        ]),
        Y(" on any " + E(n.kind), 1)
      ])
    ], 10, iV));
  }
}), cV = { class: "sv-hist-head" }, uV = { class: "t" }, hV = {
  class: "n",
  "data-testid": "board-history-count"
}, pV = ["title", "data-testid", "data-result", "data-url", "onMouseenter", "onPointerdown"], fV = { class: "frame" }, mV = {
  key: 0,
  class: "sv-art"
}, gV = ["src"], bV = {
  key: 1,
  class: "sv-cell-fail"
}, vV = {
  key: 0,
  class: "bd-boardhist-vid"
}, yV = ["title"], xV = { class: "sv-cell-cap" }, wV = {
  key: 1,
  class: "sv-hist-empty"
}, kV = {
  key: 2,
  class: "sv-hist-empty"
}, _V = ["title"], SV = { class: "sv-art" }, MV = ["src"], TV = ["src"], CV = { class: "cap" }, IV = { class: "n" }, AV = { class: "m" }, PV = { class: "sv-hist-acts" }, EV = ["aria-pressed"], RV = { class: "tip" }, zV = { class: "tip" }, mg = 60, $V = 300, DV = 380, OV = 52, LV = /* @__PURE__ */ Pe({
  __name: "BoardHistory",
  setup(n) {
    const { board: e, input: t } = Ze(), i = Q8(e), s = i.s, o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null);
    function a(ne) {
      return {
        id: ne.id,
        url: ne.url,
        w: ne.w || 4,
        h: ne.h || 3,
        status: ne.status === "moderated" ? "failed" : ne.status,
        label: ne.label || ne.prompt || "Result",
        createdAt: ne.createdAt,
        video: !!ne.video,
        videoSrc: ne.videoSrc || null,
        dur: ne.dur || null,
        sessionId: ne.sessionId,
        result: ne,
        asset: ne.asset || null
      };
    }
    function l(ne) {
      const ue = ne.resultId && e.results.get(ne.resultId) || null;
      return {
        id: "pin:" + ne.id,
        url: ne.url,
        w: ne.pw,
        h: ne.ph,
        status: "done",
        label: ne.label,
        createdAt: ne.createdAt,
        video: !!ne.video,
        videoSrc: ne.videoSrc || null,
        dur: ne.dur || null,
        sessionId: ne.fromSession || (ue ? ue.sessionId : null),
        result: ue,
        asset: ne.asset || null
      };
    }
    const d = I(() => s.pinned ? (e.results.rev.value, e.pinnedImages.value.map(l)) : i.shown.value.map(a)), c = I(() => i.allSessions()), h = I(() => G1(i)), f = I(() => (c.value ? i.historySessions.value.length : i.pickedSessions().length) > 1), p = I(() => {
      e.docRev.value;
      const ne = /* @__PURE__ */ new Map(), ue = /* @__PURE__ */ new Map();
      for (const Z of e.store.all()) {
        if (Z.type !== "image") continue;
        const te = Z;
        te.resultId && !ne.has(te.resultId) && ne.set(te.resultId, te), ue.has(te.src) || ue.set(te.src, te);
      }
      return { byResult: ne, byUrl: ue };
    });
    function y(ne) {
      return ne.result && p.value.byResult.get(ne.result.id) || p.value.byUrl.get(ne.url) || null;
    }
    function v(ne) {
      const ue = ne.sessionId ? e.store.get(ne.sessionId) : null;
      return ue && ue.type === "tool" ? ue : null;
    }
    const x = /* @__PURE__ */ W(mg), w = I(() => d.value.slice(0, x.value)), S = /* @__PURE__ */ W(!1);
    async function M() {
      if (!(s.pinned || S.value || e.boardHistoryDone())) {
        S.value = !0;
        try {
          await e.loadBoardHistory();
        } finally {
          S.value = !1;
        }
      }
    }
    Ee(() => i.pickedSessions().join(" ") + (s.pinned ? " pinned" : ""), () => {
      x.value = mg, D(), r.value && (r.value.scrollTop = 0);
    });
    function _(ne) {
      D();
      const ue = ne.target;
      ue.scrollHeight - ue.scrollTop - ue.clientHeight > 400 || (x.value < d.value.length ? x.value += mg : M());
    }
    it(() => {
      M();
    });
    function T(ne) {
      if (ne.status === "pending") return "Making…";
      if (ne.status === "failed") return "Failed";
      if (s.pinned || f.value) {
        const ue = v(ne);
        if (ue) return ue.name;
        if (s.pinned) return ne.label;
      }
      return Jn(ne.createdAt);
    }
    const k = /* @__PURE__ */ W(null);
    let P = 0;
    const A = () => clearTimeout(P), R = () => {
      clearTimeout(P), P = window.setTimeout(() => {
        k.value = null;
      }, 180);
    }, D = () => {
      clearTimeout(P), k.value = null;
    };
    We(() => clearTimeout(P));
    function O(ne, ue) {
      if (A(), ne.status !== "done" || !o.value) {
        k.value = null;
        return;
      }
      const Z = ue.currentTarget.getBoundingClientRect(), te = o.value.getBoundingClientRect(), we = Math.min($V / ne.w, DV / ne.h), Fe = Math.round(ne.w * we), Me = Math.round(ne.h * we), he = Math.min(Math.max(OV + 8 - te.top, Z.top - te.top + Z.height / 2 - Me / 2), window.innerHeight - 8 - Me - te.top);
      k.value = { c: ne, top: he, w: Fe, h: Me };
    }
    function F(ne) {
      return ne.status === "done" && (!!ne.result || !!y(ne));
    }
    function ie(ne) {
      if (!F(ne)) return;
      const ue = y(ne);
      e.ui.infoSession = ne.result ? ne.result.sessionId : null, e.ui.infoAt = ue ? ue.id : "result:" + ne.result.id;
    }
    function ee(ne, ue) {
      if (D(), ne.status !== "done") return;
      if (e.ui.eyedropper) {
        ue.preventDefault(), e.eyedrop(ne.url, ne.asset, ne.video);
        return;
      }
      const Z = Math.min(360, Math.max(200, ne.w || 300)), te = Math.round(Z * ne.h / ne.w);
      t.dragResultOut({ url: ne.url, w: Z, h: te, result: ne.result, label: ne.label, sessionId: ne.sessionId || void 0 }, ue, { onClick: () => ie(ne) });
    }
    function me(ne) {
      ne(), D();
    }
    function L(ne) {
      return ne.result ? um(ne.result) : { url: ne.url, w: ne.w, h: ne.h, label: ne.label, asset: ne.asset, sessionId: ne.sessionId, video: ne.video, videoSrc: ne.videoSrc, dur: ne.dur };
    }
    function N(ne) {
      const ue = y(ne);
      ue && (e.ui.selection = [ue.id], e.jumpTo(ue.x + ue.w / 2, ue.y + ue.h / 2, Math.max(e.cam.value.zoom, 0.6)));
    }
    const K = I(() => e.promptTool.value);
    function B(ne) {
      const ue = K.value;
      ue && e.addReference(ue.id, ne.url, ne.asset) && e.toast("Added to " + ue.name + " as a reference");
    }
    function re(ne) {
      ne.result && ne.result.url === ne.url ? e.placeResult(ne.result) : e.placeImages([{ url: ne.url, w: Math.min(360, ne.w), h: Math.round(Math.min(360, ne.w) * ne.h / ne.w), label: ne.label, asset: ne.asset || void 0, video: ne.video || void 0, videoSrc: ne.videoSrc || void 0, dur: ne.dur || void 0 }]);
    }
    function H(ne) {
      const ue = v(ne);
      return (ue ? ue.name + " · " : "") + Jn(ne.createdAt);
    }
    function J(ne) {
      s.pinned = ne;
    }
    function Q(ne) {
      const ue = e.store.get(ne);
      ue && ue.type === "tool" && e.openSession(ue);
    }
    return (ne, ue) => (g(), b("aside", {
      ref_key: "panel",
      ref: o,
      class: G(["sv-hist bd-boardhist", ["cols-" + m(s).columns, { "is-pinned-view": m(s).pinned }]]),
      "aria-label": "Board history",
      "data-testid": "board-history",
      onPointerdown: ue[12] || (ue[12] = Te(() => {
      }, ["stop"])),
      onWheel: ue[13] || (ue[13] = Te(() => {
      }, ["stop"])),
      onMouseleave: R
    }, [
      u("div", cV, [
        u("span", uV, E(m(s).pinned ? "Pinned" : "History"), 1),
        u("span", hV, E(d.value.length), 1),
        ue[14] || (ue[14] = u("span", { class: "sv-grow" }, null, -1)),
        m(e).hasLibrary ? (g(), b("button", {
          key: 0,
          class: "sv-hist-lib",
          title: "Place pictures from your Library",
          "data-testid": "board-history-library",
          onClick: ue[0] || (ue[0] = (Z) => m(e).openLibrary())
        }, [
          C($, {
            name: "Library",
            size: 14
          })
        ])) : z("", !0),
        C(eS, {
          columns: m(s).columns,
          testid: "board-history-cols",
          onSet: ue[1] || (ue[1] = (Z) => m(i).setColumns(Z))
        }, null, 8, ["columns"]),
        u("button", {
          class: "bd-boardhist-close",
          title: "Close (Esc)",
          "aria-label": "Close the board history",
          "data-testid": "board-history-close",
          onClick: ue[2] || (ue[2] = (Z) => m(e).ui.boardHistory = !1)
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      C(tS, {
        filter: m(i),
        tid: "board-history",
        pinned: m(s).pinned,
        "pin-count": m(e).pinnedImages.value.length,
        current: m(e).promptTool.value ? m(e).promptTool.value.id : null,
        "go-to": Q,
        onPinned: J
      }, null, 8, ["filter", "pinned", "pin-count", "current"]),
      u("div", {
        ref_key: "grid",
        ref: r,
        class: "sv-hist-grid",
        style: ce({ "--cols": m(s).columns }),
        onScroll: _
      }, [
        (g(!0), b(j, null, ge(w.value, (Z) => (g(), b("div", {
          key: Z.id,
          class: G(["sv-cell", {
            "is-pending": Z.status === "pending",
            "is-failed": Z.status === "failed",
            "is-new": Date.now() - Z.createdAt < 4e3,
            "is-on": k.value && k.value.c.id === Z.id
          }]),
          title: Z.status === "done" ? void 0 : T(Z),
          "data-testid": (m(s).pinned ? "board-history-pinned-" : "board-history-item-") + Z.status,
          "data-result": Z.result ? Z.result.id : void 0,
          "data-url": Z.url,
          onMouseenter: (te) => O(Z, te),
          onMouseleave: R,
          onPointerdown: (te) => ee(Z, te)
        }, [
          u("span", fV, [
            Z.status === "done" ? (g(), b("span", mV, [
              u("img", {
                src: m(Bt)(Z.url),
                alt: "",
                draggable: "false",
                loading: "lazy"
              }, null, 8, gV)
            ])) : Z.status === "failed" ? (g(), b("span", bV, [
              C($, {
                name: "AlertCircle",
                size: 16
              })
            ])) : Z.status === "pending" ? (g(), Ie(j1, {
              key: 2,
              class: "sv-cell-time",
              since: Z.result && Z.result.startedAt || Z.createdAt
            }, null, 8, ["since"])) : z("", !0)
          ]),
          Z.video && Z.status === "done" ? (g(), b("span", vV, [
            C($, {
              name: "Play",
              size: 8
            }),
            Y(E(Z.dur || "0:05"), 1)
          ])) : z("", !0),
          !m(s).pinned && Z.status === "done" && m(e).isPinnedImage(Z.url) ? (g(), b("span", {
            key: 1,
            class: "sv-cell-pin",
            title: m(Xn).badge
          }, [
            C($, {
              name: "Pin",
              size: 10
            })
          ], 8, yV)) : z("", !0),
          u("span", xV, E(T(Z)), 1)
        ], 42, pV))), 128)),
        m(s).pinned && !d.value.length ? (g(), Ie(H1, { key: 0 })) : !d.value.length && !S.value ? (g(), b("div", wV, E(c.value ? "What the board's sessions make collects here, newest first." : "Nothing from " + h.value + " yet."), 1)) : z("", !0),
        S.value && !m(s).pinned ? (g(), b("div", kV, [...ue[15] || (ue[15] = [
          u("span", { class: "bd-spinner is-sm" }, null, -1)
        ])])) : z("", !0)
      ], 36),
      k.value ? (g(), b("div", {
        key: 0,
        class: "sv-hist-pop",
        style: ce({ top: k.value.top + "px", width: k.value.w + "px", height: k.value.h + "px" }),
        "data-testid": "board-history-preview",
        onMouseenter: A,
        onMouseleave: R
      }, [
        u("button", {
          class: "art",
          title: F(k.value.c) ? "Open the full record" : k.value.c.label,
          onClick: ue[3] || (ue[3] = (Z) => me(() => ie(k.value.c)))
        }, [
          u("span", SV, [
            u("img", {
              src: k.value.c.url,
              alt: "",
              draggable: "false"
            }, null, 8, MV)
          ]),
          k.value.c.video && k.value.c.videoSrc ? (g(), b("video", {
            key: k.value.c.videoSrc,
            class: "bd-boardhist-play",
            src: k.value.c.videoSrc,
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            preload: "auto",
            disablepictureinpicture: ""
          }, null, 8, TV)) : z("", !0)
        ], 8, _V),
        u("span", CV, [
          u("span", IV, E(k.value.c.label), 1),
          u("span", AV, E(H(k.value.c)), 1)
        ]),
        u("span", PV, [
          u("button", {
            class: G(["is-pin", { on: m(e).isPinnedImage(k.value.c.url) }]),
            "aria-pressed": m(e).isPinnedImage(k.value.c.url),
            "data-testid": "board-history-pin",
            onClick: ue[4] || (ue[4] = Te((Z) => m(e).togglePinImage(L(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "Pin",
              size: 13
            }),
            u("span", RV, E(m(e).isPinnedImage(k.value.c.url) ? m(Xn).unpin : m(Xn).pin), 1)
          ], 10, EV),
          K.value && !k.value.c.video && !m(df)(k.value.c.url) ? (g(), b("button", {
            key: 0,
            "data-testid": "board-history-use-ref",
            onClick: ue[5] || (ue[5] = Te((Z) => me(() => B(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "ImagePlus",
              size: 13
            }),
            u("span", zV, "Use as reference in " + E(K.value.name), 1)
          ])) : z("", !0),
          y(k.value.c) ? (g(), b("button", {
            key: 1,
            "data-testid": "board-history-find",
            onClick: ue[6] || (ue[6] = Te((Z) => me(() => N(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "LocateFixed",
              size: 13
            }),
            ue[16] || (ue[16] = u("span", { class: "tip" }, "Find it on the board", -1))
          ])) : (g(), b("button", {
            key: 2,
            "data-testid": "board-history-place",
            onClick: ue[7] || (ue[7] = Te((Z) => me(() => re(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "ArrowDownToLine",
              size: 13
            }),
            ue[17] || (ue[17] = u("span", { class: "tip" }, "Place on the board", -1))
          ])),
          F(k.value.c) ? (g(), b("button", {
            key: 3,
            "data-testid": "board-history-details",
            onClick: ue[8] || (ue[8] = Te((Z) => me(() => ie(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "Info",
              size: 13
            }),
            ue[18] || (ue[18] = u("span", { class: "tip" }, "Details", -1))
          ])) : z("", !0),
          v(k.value.c) ? (g(), b("button", {
            key: 4,
            "data-testid": "board-history-session",
            onClick: ue[9] || (ue[9] = Te((Z) => me(() => m(e).openSession(v(k.value.c))), ["stop"]))
          }, [
            C($, {
              name: "LayoutGrid",
              size: 13
            }),
            ue[19] || (ue[19] = u("span", { class: "tip" }, "Open its session", -1))
          ])) : z("", !0),
          k.value.c.result && !k.value.c.video && !m(df)(k.value.c.url) ? (g(), b("button", {
            key: 5,
            "data-testid": "board-history-edit",
            onClick: ue[10] || (ue[10] = Te((Z) => me(() => m(e).openStudio({ resultId: k.value.c.result.id })), ["stop"]))
          }, [
            C($, {
              name: "Wand2",
              size: 13
            }),
            ue[20] || (ue[20] = u("span", { class: "tip" }, "Edit in Studio view", -1))
          ])) : z("", !0),
          k.value.c.result && k.value.c.result.kind === "3d" && k.value.c.result.download ? (g(), b("button", {
            key: 6,
            "data-testid": "board-history-download",
            onClick: ue[11] || (ue[11] = Te((Z) => me(() => m(e).downloadResult(k.value.c.result)), ["stop"]))
          }, [
            C($, {
              name: "Download",
              size: 13
            }),
            ue[21] || (ue[21] = u("span", { class: "tip" }, "Download the 3D model", -1))
          ])) : z("", !0)
        ])
      ], 36)) : z("", !0)
    ], 34));
  }
});
function gn(n) {
  if (n == null) return;
  if (typeof n == "number") return n;
  if (n instanceof Date) return n.getTime();
  const e = n;
  if (typeof e.toMillis == "function") return e.toMillis();
}
function Wo(n) {
  return n && typeof n == "object" && "code" in n && typeof n.code == "string" ? n.code : "";
}
function Lt(n) {
  return typeof n == "string" ? n : "";
}
function na(n) {
  return n && typeof n == "object" && !Array.isArray(n) ? n : null;
}
function BV(n) {
  const e = na(n);
  return !e || !Lt(e.url) ? null : { label: Lt(e.label), role: Lt(e.role), title: Lt(e.title) || void 0, kind: e.kind === "markup" ? "markup" : "reference", url: Lt(e.url) };
}
function FV(n) {
  const e = na(n), t = e && na(e.tool), i = e && na(e.output);
  if (!e || !t || !i || !Lt(e.id) || !Lt(e.name) || !Lt(e.prompt) || !Lt(i.url)) return null;
  const s = {
    id: Lt(e.id),
    name: Lt(e.name),
    category: Lt(e.category),
    description: Lt(e.description),
    prompt: Lt(e.prompt),
    mode: Lt(e.mode),
    tags: Array.isArray(e.tags) ? e.tags.filter((o) => typeof o == "string") : [],
    kind: e.kind === "video" ? "video" : "image",
    tool: { nodeDefId: Lt(t.nodeDefId), name: Lt(t.name) },
    output: { url: Lt(i.url), w: Number(i.w) || 0, h: Number(i.h) || 0, video: Lt(i.video) || void 0 },
    inputs: Array.isArray(e.inputs) ? e.inputs.map(BV).filter((o) => !!o) : []
  };
  return Lt(e.line) && (s.line = Lt(e.line)), s;
}
function NV(n) {
  const e = na(n);
  if (!e || !Array.isArray(e.prompts)) return null;
  const t = e.prompts.map(FV).filter((s) => !!s), i = Array.isArray(e.categories) ? e.categories.map((s) => na(s)).filter((s) => !!s && !!Lt(s.label)).map((s) => ({ id: Lt(s.id) || Lt(s.label), label: Lt(s.label), description: Lt(s.description) })) : [];
  return { id: Lt(e.id), name: Lt(e.name), source: Lt(e.source) || void 0, categories: i, prompts: t };
}
function V1(n) {
  return (n || "").toLowerCase().split(/\s+/).filter(Boolean);
}
function nS(n, e, t) {
  let i = 0;
  const s = n.name.toLowerCase(), o = [n.category, n.tool.name, n.tags.join(" ")].join(" ").toLowerCase(), r = n.description.toLowerCase(), a = n.prompt.toLowerCase();
  for (const l of e) {
    const d = s.includes(l) ? 8 : o.includes(l) ? 4 : r.includes(l) ? 2 : a.includes(l) ? 1 : 0;
    if (!d) return null;
    i += d;
  }
  return t && n.kind === t ? i + 100 : i;
}
function UV(n, e = {}) {
  const t = V1(e.query), i = [];
  return n.forEach((s, o) => {
    if (e.category && s.category !== e.category || e.only && s.kind !== e.only || e.action && ua(s) !== e.action) return;
    const r = nS(s, t, e.kind);
    r !== null && i.push({ p: s, score: r, at: o });
  }), i.sort((s, o) => o.score - s.score || s.at - o.at).map((s) => s.p);
}
function ua(n) {
  return n.inputs.length ? "edit" : "generate";
}
const GV = ["image", "video"], jV = ["generate", "edit"];
function ik(n) {
  const e = /* @__PURE__ */ new Map();
  for (const t of n) {
    const i = { kind: t.kind, action: ua(t), label: t.category || "" }, s = i.kind + "|" + i.action + "|" + i.label, o = e.get(s);
    o ? o.count++ : e.set(s, { ...i, count: 1 });
  }
  return Array.from(e.values()).sort((t, i) => i.count - t.count || t.label.localeCompare(i.label));
}
function Ju(n, e = [], t) {
  const i = (o) => {
    const r = e.indexOf(o);
    return r < 0 ? e.length : r;
  }, s = GV.map((o) => {
    const r = jV.map((a) => {
      const l = n.filter((h) => h.kind === o && h.action === a && h.count > 0), d = l.reduce((h, f) => h + f.count, 0), c = l.filter((h) => !!h.label).sort((h, f) => i(h.label) - i(f.label) || f.count - h.count || h.label.localeCompare(f.label)).map((h) => ({ label: h.label, count: h.count }));
      return { action: a, count: t ? t[o][a] : d, categories: c };
    });
    return { kind: o, count: r.reduce((a, l) => a + l.count, 0), actions: r };
  });
  return { total: s.reduce((o, r) => o + r.count, 0), kinds: s };
}
function HV(n) {
  return n ? n.charAt(0).toUpperCase() + n.slice(1) : "";
}
function Xa(n, e) {
  return n.byId.get(e.nodeDefId) || n.source === "demo" && n.byName.get(e.name) || null;
}
function sk(n, e, t) {
  return Tv(n, e, t);
}
function Ja(n) {
  return n === "image" || n === "imageEdit" ? "image" : n === "video" || n === "videoEdit" ? "video" : null;
}
function ok(n) {
  return /^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(n || "");
}
const VV = /^\s*(\d+(?:\.\d+)?)\s*[:x×]\s*(\d+(?:\.\d+)?)\s*$/;
function iS(n) {
  const e = na(n.value);
  if (e && Number(e.width) > 0 && Number(e.height) > 0) return Number(e.width) / Number(e.height);
  for (const t of [typeof n.value == "string" ? n.value : "", n.meta || "", n.label]) {
    const i = VV.exec(t);
    if (i && Number(i[2]) > 0) return Number(i[1]) / Number(i[2]);
  }
  return null;
}
function WV(n) {
  return n.fields.find((e) => e.placement === "chip" && !!e.options && (e.kind === "size" || e.kind === "select" && /aspect|ratio|size/i.test(e.label) && e.options.filter((t) => iS(t) != null).length >= 2)) || null;
}
function qV(n, e, t) {
  if (!e || !t || !n.options) return;
  const i = e / t;
  let s = null;
  for (const o of n.options) {
    const r = iS(o);
    if (r == null) continue;
    const a = Math.abs(Math.log(r / i));
    (!s || a < s.d) && (s = { v: o.value, d: a });
  }
  return s && s.d < Math.log(1.12) ? s.v : void 0;
}
function KV(n, e) {
  const t = n.fields.filter((l) => l.placement === "reference"), i = e.inputs.map((l) => l.url), s = {}, o = { prompt: e.prompt, ref: null, inputs: s, n: 1 };
  let r = 0;
  for (const l of t) {
    if (r >= i.length) break;
    if (l.kind !== "image" && l.kind !== "images") continue;
    const d = l.kind === "images" ? i.slice(r, r + Math.max(1, l.maxImages || i.length)) : [i[r]];
    r += d.length, l === t[0] && (o.ref = d[0]), d.length > 1 ? s[l.key] = d : l !== t[0] && (s[l.key] = d[0]);
  }
  const a = WV(n);
  if (a) {
    const l = qV(a, e.output.w, e.output.h);
    l !== void 0 && (s[a.key] = l);
  }
  return { up: o, dropped: i.length - r };
}
function YV(n, e, t) {
  return e ? n.filter((i) => !!i.line && i.kind === e && (t || !i.inputs.length)).map((i) => ({ id: i.id, text: i.line })) : [];
}
function XV(n, e) {
  if (!e) return 0;
  let t = 0;
  for (let i = 0; i < n.length; i++) t = t * 31 + n.charCodeAt(i) >>> 0;
  return t % e;
}
const Kt = (n) => typeof n == "string" ? n : "", Ta = (n) => n && typeof n == "object" && !Array.isArray(n) ? n : null;
function JV(n, e) {
  const t = Ta(e), i = t && Ta(t.tool);
  if (!t || !i || t.deletedAt || !Kt(t.authorId) || !Kt(t.prompt)) return null;
  const s = Ta(t.output) || {}, o = Array.isArray(t.inputs) ? t.inputs.map(Ta).filter((a) => !!a && !!Kt(a.url)).map((a) => ({ label: Kt(a.label), role: Kt(a.role), title: Kt(a.title) || void 0, kind: a.kind === "markup" ? "markup" : "reference", url: Kt(a.url) })) : [], r = Ta(t.run);
  return {
    id: n,
    name: Kt(t.name) || "Untitled prompt",
    category: Kt(t.category),
    description: Kt(t.description),
    prompt: Kt(t.prompt),
    mode: Kt(t.mode) || xu(o.length),
    tags: Array.isArray(t.tags) ? t.tags.filter((a) => typeof a == "string") : [],
    kind: t.kind === "video" ? "video" : "image",
    tool: { nodeDefId: Kt(i.nodeDefId), name: Kt(i.name) },
    output: { url: Kt(s.url), w: Number(s.w) || 0, h: Number(s.h) || 0, thumb: Kt(s.thumb) || void 0, video: Kt(s.video) || void 0 },
    inputs: o,
    authorId: Kt(t.authorId),
    authorName: Kt(t.authorName),
    boardId: Kt(t.boardId) || null,
    teamId: Kt(t.teamId) || null,
    companyId: Kt(t.companyId) || null,
    values: Ta(t.values),
    run: r && Kt(r.runId) ? { runId: Kt(r.runId), uuid: Kt(r.uuid) } : null,
    createdAt: gn(t.createdAt) || 0,
    updatedAt: gn(t.updatedAt) || gn(t.createdAt) || 0
  };
}
function cf(n, e) {
  const t = [];
  return n.boardId && n.boardId === e && t.push("board"), n.teamId && t.push("team"), n.companyId && t.push("company"), t.length || n.boardId ? t : ["me"];
}
function sS(n, e) {
  return !!n.boardId && n.boardId !== e;
}
function xu(n) {
  return n === 0 ? "text only" : n === 1 ? "one image" : "multiple images";
}
const ZV = 2e4;
function QV(n) {
  const e = n ? n.fields.find((i) => i.kind === "prompt") : void 0, t = e && e.raw && e.raw.display ? e.raw.display.maxLength : void 0;
  return Math.min(typeof t == "number" && t > 0 ? t : 2e3, ZV);
}
function rk(n, e) {
  if (e && !/^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(e)) return e;
  const t = String(n || "").replace(/([.!?])\s+/g, `$1
`).split(/\n+/).map((o) => o.trim()).filter(Boolean);
  let s = (t.find((o) => !/^create one finished architectural/i.test(o) && !/^image \d+ is /i.test(o)) || t[0] || "").replace(/[.!?]+$/, "").split(/[,;:]/)[0].trim();
  return s.length > 42 && (s = s.slice(0, 42).replace(/\s\S*$/, "")), s ? s.charAt(0).toUpperCase() + s.slice(1) : "Untitled prompt";
}
function oS(n, e, t, i) {
  const s = [];
  if (n && e) {
    const o = dc(n, e, i);
    n.fields.filter((a) => a.placement === "reference").forEach((a, l) => {
      const d = o.inputs ? o.inputs[a.key] : void 0, c = Array.isArray(d) ? d.filter((f) => typeof f == "string") : [], h = l === 0 ? o.ref : typeof d == "string" ? d : null;
      for (const f of c.length ? c : h ? [h] : []) s.push({ url: f, role: a.label });
    });
  }
  if (!s.length) for (const o of t) s.push({ url: o, role: "Input image" });
  return s.map((o, r) => ({ label: "Image " + (r + 1), role: o.role, kind: "reference", url: o.url }));
}
function eW(n, e) {
  if (!e) return null;
  const t = { ...e };
  if (delete t[O1], n)
    for (const i of n.fields) i.placement === "reference" && delete t[i.key];
  return t;
}
function tW(n, e, t) {
  const i = n.inputs ? JSON.parse(JSON.stringify(n.inputs)) : null, s = oS(e, i, n.refs || [], t);
  return {
    name: "",
    category: "",
    description: "",
    prompt: n.prompt || "",
    mode: xu(s.length),
    tags: [],
    kind: n.video ? "video" : "image",
    tool: { nodeDefId: n.modelId || (e ? e.id : ""), name: e && e.name || n.model || "" },
    output: { url: n.url, w: n.w || 0, h: n.h || 0, thumb: n.thumb, video: n.videoSrc },
    inputs: s,
    boardId: null,
    teamId: null,
    companyId: null,
    values: i,
    run: n.runId && n.uuid ? { runId: n.runId, uuid: n.uuid } : null
  };
}
function ak(n, e, t, i) {
  const s = new Set(e.filter((a) => a.authorId === t && a.id !== i).map((a) => a.name.trim().toLowerCase())), o = n.trim();
  if (!s.has(o.toLowerCase())) return o;
  let r = 2;
  for (; s.has((o + " " + r).toLowerCase()); ) r++;
  return o + " " + r;
}
function lk(n, e, t, i, s) {
  const o = t.trim();
  return n.find((r) => r.authorId === e && r.id !== s && r.tool.nodeDefId === i && r.prompt.trim() === o) || null;
}
function nW(n) {
  const e = /* @__PURE__ */ new Map();
  for (const t of n) t.category && e.set(t.category, (e.get(t.category) || 0) + 1);
  return Array.from(e.entries()).sort((t, i) => i[1] - t[1] || t[0].localeCompare(i[0])).map(([t]) => t);
}
const W1 = 200, rS = 12, iW = 100;
function sW(n) {
  return V1(n.slice(0, W1)).slice(0, rS);
}
function oW(n) {
  const e = Array.from(new Set(V1(n))).sort((s, o) => o.length - s.length), t = [];
  let i = 0;
  for (const s of e) {
    if (t.length === rS) break;
    const o = (t.length ? 1 : 0) + s.length;
    i + o > W1 || (t.push(s), i += o);
  }
  return t.join(" ");
}
function rW(n, e) {
  return e.levels.length && !cf(n, e.boardId).some((t) => e.levels.includes(t)) || e.onlyKind && n.kind !== e.onlyKind || e.onlyAction && ua(n) !== e.onlyAction || e.category && n.category !== e.category || e.mine && n.authorId !== e.uid || e.toolId && n.tool.nodeDefId !== e.toolId ? !1 : nS(n, sW(e.query)) !== null;
}
function aW(n) {
  return Array.from(n.entries()).filter(([, e]) => e > 0).sort((e, t) => t[1] - e[1] || e[0].localeCompare(t[0])).slice(0, iW).map(([e, t]) => ({ label: e, count: t }));
}
function lW(n, e, t) {
  const i = { kind: e.kind, action: ua(e), label: e.category || "" }, s = n.findIndex((r) => r.kind === i.kind && r.action === i.action && r.label === i.label), o = n.slice();
  return s < 0 ? t > 0 && o.push({ ...i, count: t }) : o[s] = { ...o[s], count: Math.max(0, o[s].count + t) }, o.filter((r) => r.count > 0).sort((r, a) => a.count - r.count || r.label.localeCompare(a.label));
}
function gg(n, e, t, i) {
  if (!n) return n;
  const s = { ...n.levels }, o = n.kinds ? { ...n.kinds } : void 0, r = n.actions ? { image: { ...n.actions.image }, video: { ...n.actions.video } } : void 0;
  let a = n.groups;
  const l = new Map(n.categories.map((h) => [h.label, h.count]));
  let d = n.total;
  const c = (h, f) => {
    d = Math.max(0, d + f);
    for (const p of cf(h, i)) s[p] = Math.max(0, s[p] + f);
    o && (o[h.kind] = Math.max(0, o[h.kind] + f)), r && (r[h.kind][ua(h)] = Math.max(0, r[h.kind][ua(h)] + f)), a && (a = lW(a, h, f)), h.category && l.set(h.category, Math.max(0, (l.get(h.category) || 0) + f));
  };
  return e && c(e, -1), t && c(t, 1), { total: d, levels: s, ...o ? { kinds: o } : {}, ...r ? { actions: r } : {}, categories: aW(l), ...a ? { groups: a } : {} };
}
function aS(n) {
  const e = /* @__PURE__ */ W(!1), t = () => {
    const s = n.value;
    e.value = !!s && s.scrollHeight - s.scrollTop - s.clientHeight > 4;
  }, i = typeof ResizeObserver != "undefined" ? new ResizeObserver(t) : null;
  return Ee(n, (s, o) => {
    i && o && i.unobserve(o), i && s && i.observe(s), t();
  }, { flush: "post" }), C5(t), We(() => {
    i && i.disconnect();
  }), { more: e, measure: t };
}
const dW = { class: "ps-head" }, cW = { class: "ps-mark" }, uW = { class: "ps-title" }, hW = { class: "ps-field" }, pW = { class: "ps-field" }, fW = {
  class: "ps-audience",
  "data-testid": "save-audience"
}, mW = { class: "ps-levels" }, gW = ["aria-checked"], bW = { class: "ps-level-text" }, vW = ["aria-checked", "disabled"], yW = { class: "ps-level-text" }, xW = ["aria-checked", "disabled"], wW = { class: "ps-level-text" }, kW = { class: "ps-field" }, _W = { class: "ps-cats" }, SW = ["onClick"], MW = { class: "ps-field" }, TW = { class: "ps-field" }, CW = { class: "pl-pills" }, IW = { class: "pl-pill" }, AW = { class: "pl-pill is-quiet" }, PW = {
  key: 0,
  class: "ps-check",
  "data-testid": "save-inputs"
}, EW = { class: "ps-thumbs" }, RW = {
  key: 0,
  class: "ps-dup",
  "data-testid": "save-duplicate"
}, zW = ["disabled"], $W = { class: "ps-foot" }, DW = ["disabled"], lS = /* @__PURE__ */ Pe({
  __name: "SavePromptSheet",
  props: {
    draft: {},
    editingId: {}
  },
  emits: ["done", "cancel"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = Ze(), o = s.promptLibrary, r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), { more: l, measure: d } = aS(a), c = /* @__PURE__ */ W(t.draft.name), h = /* @__PURE__ */ W(!1), f = /* @__PURE__ */ W(t.draft.category), p = /* @__PURE__ */ W(""), y = /* @__PURE__ */ W(t.draft.prompt), v = /* @__PURE__ */ W(!0), x = { levels: o.levelsFor(t.draft), boardId: t.draft.boardId, teamId: t.draft.teamId, companyId: t.draft.companyId }, w = /* @__PURE__ */ Xt({ ...x.levels }), S = I(() => !w.board && sS(t.draft, s.meta.id)), M = /* @__PURE__ */ W(!1), _ = I(() => o.team.value), T = I(() => o.company()), k = I(() => o.managesTeam() || !!t.editingId && x.levels.team), P = I(() => o.managesCompany() || !!t.editingId && x.levels.company), A = I(() => w.team && k.value), R = I(() => w.company && P.value), D = I(() => s.labels.team), O = I(() => s.meta.title || "this board"), F = I(() => !!s.meta.teamId), ie = I(() => {
      o.myPrompts.counts.value, o.mine.value;
      const de = o.mineCategories();
      return t.draft.category && !de.includes(t.draft.category) ? [t.draft.category].concat(de) : de;
    }), ee = I(() => p.value.trim() || f.value), me = I(() => s.catalog.value.byId.get(t.draft.tool.nodeDefId) || null), L = I(() => QV(me.value)), N = I(() => y.value.length > L.value), K = I(() => !!c.value.trim() && !!y.value.trim() && !N.value && !M.value), B = I(() => _.value && _.value.name ? "Everyone in " + _.value.name : "Everyone in your " + D.value), re = I(() => "Only people who manage " + (_.value && _.value.name ? _.value.name + "'s" : "your " + D.value + "'s") + " prompts can share here"), H = I(() => T.value && T.value.name ? "Everyone at " + T.value.name : "Everyone in your company"), J = I(() => "Only people who manage " + (T.value && T.value.name ? T.value.name + "'s" : "your company's") + " prompts can share here"), Q = I(() => S.value ? "On another board now: turn this on to move it here" : F.value ? "Everyone who can open this board" : "Only you can open this board"), ne = I(() => {
      const de = w.board ? O.value : S.value ? "the board it's filed on" : "";
      return R.value && T.value ? H.value + (de ? ", and kept with " + de : "") : A.value && _.value ? B.value + (de ? ", and kept with " + de : "") : w.board ? F.value ? "Everyone who can open " + O.value : "Kept with " + O.value + ", which only you can open" : S.value ? "Everyone who can open the board it's filed on" : "Only you, on every board";
    }), ue = /* @__PURE__ */ W(null);
    let Z = 0, te = null;
    function we() {
      const de = ++Z;
      o.duplicateFor(y.value, t.draft.tool.nodeDefId, t.editingId).then((pe) => {
        de === Z && (ue.value = pe);
      }).catch(() => {
        de === Z && (ue.value = null);
      });
    }
    Ee(y, () => {
      te && clearTimeout(te), te = setTimeout(we, 300);
    });
    function Fe() {
      const de = v.value ? t.draft.inputs : [], pe = v.value ? t.draft.values : eW(me.value, t.draft.values);
      return o.withLevels({
        ...t.draft,
        name: c.value.trim(),
        category: ee.value,
        prompt: y.value,
        inputs: de,
        mode: xu(de.length),
        values: pe
      }, { board: w.board, team: A.value, company: R.value }, x);
    }
    async function Me() {
      if (!K.value) return;
      M.value = !0;
      const de = await o.save(Fe(), t.editingId);
      M.value = !1, de && i("done", de);
    }
    async function he() {
      const de = ue.value;
      if (!de || M.value) return;
      M.value = !0;
      const pe = await o.save({ ...Fe(), name: de.name, category: de.category, boardId: de.boardId, teamId: de.teamId, companyId: de.companyId }, de.id);
      M.value = !1, pe && i("done", pe);
    }
    function U(de) {
      de.stopPropagation(), de.key === "Escape" ? (de.preventDefault(), i("cancel")) : de.key === "Enter" && bn(de) && (de.preventDefault(), Me());
    }
    function q() {
      if (t.editingId) return;
      const de = c.value;
      o.freshNameFor(de).then((pe) => {
        h.value || M.value || c.value !== de || pe === de || (c.value = pe, nt(() => {
          r.value && document.activeElement === r.value && r.value.select();
        }));
      }).catch(() => {
      });
    }
    function oe(de) {
      f.value = f.value === de && !p.value ? "" : de, p.value = "";
    }
    return We(() => {
      te && clearTimeout(te), Z++;
    }), it(() => {
      o.startMine(), q(), we(), nt(() => {
        const de = r.value;
        de && (de.focus({ preventScroll: !0 }), de.select());
      });
    }), (de, pe) => (g(), b("form", {
      class: "ps",
      "data-testid": "save-prompt",
      onSubmit: Te(Me, ["prevent"]),
      onKeydown: U,
      onPointerdown: pe[10] || (pe[10] = Te(() => {
      }, ["stop"]))
    }, [
      u("header", dW, [
        u("span", cW, [
          C($, {
            name: "Bookmark",
            size: 15
          })
        ]),
        u("span", uW, [
          u("b", null, E(n.editingId ? "Edit prompt" : "Save to the prompt library"), 1),
          u("em", null, E(n.editingId ? "Changes reach everyone it's shared with." : "Keep it for any board, or share it."), 1)
        ])
      ]),
      u("div", {
        ref_key: "bodyEl",
        ref: a,
        class: G(["ps-body", { "is-more": m(l) }]),
        onScrollPassive: pe[8] || (pe[8] = //@ts-ignore
        (...Ce) => m(d) && m(d)(...Ce))
      }, [
        u("label", hW, [
          pe[11] || (pe[11] = u("span", { class: "pl-label" }, "Name", -1)),
          _t(u("input", {
            ref_key: "nameEl",
            ref: r,
            "onUpdate:modelValue": pe[0] || (pe[0] = (Ce) => c.value = Ce),
            class: "ps-input",
            maxlength: "80",
            placeholder: "Name this prompt",
            "data-testid": "save-name",
            onInput: pe[1] || (pe[1] = (Ce) => h.value = !0)
          }, null, 544), [
            [Zt, c.value]
          ])
        ]),
        u("div", pW, [
          pe[17] || (pe[17] = u("span", { class: "pl-label" }, "Who can use it", -1)),
          u("p", fW, [
            C($, {
              name: w.board || A.value || R.value || S.value ? "Users" : "Lock",
              size: 12
            }, null, 8, ["name"]),
            Y(E(ne.value), 1)
          ]),
          u("div", mW, [
            u("button", {
              type: "button",
              class: G(["ps-level", { on: w.board }]),
              role: "switch",
              "aria-checked": w.board,
              "data-testid": "level-board",
              onClick: pe[2] || (pe[2] = (Ce) => w.board = !w.board)
            }, [
              C($, {
                name: "LayoutGrid",
                size: 14
              }),
              u("span", bW, [
                pe[12] || (pe[12] = u("b", null, "This board", -1)),
                u("em", null, E(Q.value), 1)
              ]),
              pe[13] || (pe[13] = u("span", { class: "ps-switch" }, null, -1))
            ], 10, gW),
            _.value ? (g(), b("button", {
              key: 0,
              type: "button",
              class: G(["ps-level", { on: A.value, "is-off": !k.value }]),
              role: "switch",
              "aria-checked": A.value,
              disabled: !k.value,
              "data-testid": "level-team",
              onClick: pe[3] || (pe[3] = (Ce) => w.team = !w.team)
            }, [
              C($, {
                name: "Users",
                size: 14
              }),
              u("span", yW, [
                u("b", null, E(m(_v)(D.value)), 1),
                u("em", null, E(k.value ? B.value : re.value), 1)
              ]),
              pe[14] || (pe[14] = u("span", { class: "ps-switch" }, null, -1))
            ], 10, vW)) : z("", !0),
            T.value ? (g(), b("button", {
              key: 1,
              type: "button",
              class: G(["ps-level", { on: R.value, "is-off": !P.value }]),
              role: "switch",
              "aria-checked": R.value,
              disabled: !P.value,
              "data-testid": "level-company",
              onClick: pe[4] || (pe[4] = (Ce) => w.company = !w.company)
            }, [
              C($, {
                name: "Building2",
                size: 14
              }),
              u("span", wW, [
                pe[15] || (pe[15] = u("b", null, "Company", -1)),
                u("em", null, E(P.value ? H.value : J.value), 1)
              ]),
              pe[16] || (pe[16] = u("span", { class: "ps-switch" }, null, -1))
            ], 10, xW)) : z("", !0)
          ])
        ]),
        u("div", kW, [
          pe[18] || (pe[18] = u("span", { class: "pl-label" }, "Category", -1)),
          u("div", _W, [
            (g(!0), b(j, null, ge(ie.value, (Ce) => (g(), b("button", {
              key: Ce,
              type: "button",
              class: G(["pl-chip", { on: !p.value.trim() && f.value === Ce }]),
              onClick: (Be) => oe(Ce)
            }, E(Ce), 11, SW))), 128)),
            _t(u("input", {
              "onUpdate:modelValue": pe[5] || (pe[5] = (Ce) => p.value = Ce),
              class: "ps-input is-chip",
              maxlength: "40",
              placeholder: "New category",
              "data-testid": "save-new-category"
            }, null, 512), [
              [Zt, p.value]
            ])
          ])
        ]),
        u("label", MW, [
          pe[19] || (pe[19] = u("span", { class: "pl-label" }, "Prompt", -1)),
          _t(u("textarea", {
            "onUpdate:modelValue": pe[6] || (pe[6] = (Ce) => y.value = Ce),
            class: "ps-input ps-text",
            rows: "5",
            "data-testid": "save-prompt-text"
          }, null, 512), [
            [Zt, y.value]
          ]),
          u("span", {
            class: G(["ps-hint", { "is-bad": N.value }])
          }, E(N.value ? y.value.length.toLocaleString() + " characters: " + (n.draft.tool.name || "its tool") + " takes up to " + L.value.toLocaleString() + "." : "Edit it to take out anything only this project needs."), 3)
        ]),
        u("div", TW, [
          pe[21] || (pe[21] = u("span", { class: "pl-label" }, "Comes with", -1)),
          u("div", CW, [
            u("span", IW, [
              C($, {
                name: "Sparkles",
                size: 12
              }),
              Y(E(n.draft.tool.name || "Its tool"), 1)
            ]),
            u("span", AW, [
              C($, {
                name: "Settings2",
                size: 12
              }),
              pe[20] || (pe[20] = Y("Its settings", -1))
            ])
          ]),
          n.draft.inputs.length ? (g(), b("label", PW, [
            _t(u("input", {
              "onUpdate:modelValue": pe[7] || (pe[7] = (Ce) => v.value = Ce),
              type: "checkbox"
            }, null, 512), [
              [ol, v.value]
            ]),
            u("span", null, "Its " + E(n.draft.inputs.length === 1 ? "input image" : n.draft.inputs.length + " input images"), 1),
            u("span", EW, [
              (g(!0), b(j, null, ge(n.draft.inputs.slice(0, 5), (Ce, Be) => (g(), b("span", {
                key: Be,
                style: ce({ backgroundImage: 'url("' + m(Bt)(Ce.url) + '")' })
              }, null, 4))), 128))
            ])
          ])) : z("", !0)
        ]),
        ue.value ? (g(), b("p", RW, [
          C($, {
            name: "Info",
            size: 12
          }),
          u("span", null, "You saved this prompt before as “" + E(ue.value.name) + "”.", 1),
          u("button", {
            type: "button",
            class: "ps-link",
            disabled: M.value,
            onClick: he
          }, "Update that one instead", 8, zW)
        ])) : z("", !0)
      ], 34),
      u("footer", $W, [
        u("button", {
          type: "submit",
          class: "pl-cta",
          disabled: !K.value,
          "data-testid": "save-submit"
        }, E(M.value ? "Saving…" : n.editingId ? "Save changes" : "Save prompt"), 9, DW),
        u("button", {
          type: "button",
          class: "pl-btn is-glass is-lg",
          "data-testid": "save-cancel",
          onClick: pe[9] || (pe[9] = (Ce) => i("cancel"))
        }, "Cancel")
      ])
    ], 32));
  }
}), OW = "Bonneville Tower", LW = { team: [{ initials: "KB", name: "Kira Bennett" }, { initials: "JR", name: "Jonah Reyes" }, { initials: "MT", name: "Mei Tanaka" }] }, BW = /* @__PURE__ */ JSON.parse('[{"id":"f1","type":"frame","x":200,"y":200,"w":1400,"h":548,"title":"Site photos","z":0},{"id":"f2","type":"frame","x":1720,"y":200,"w":1400,"h":626,"title":"Massing sketches","z":1},{"id":"f3","type":"frame","x":3240,"y":200,"w":1400,"h":389,"title":"Site plans & analysis","z":2},{"id":"f4","type":"frame","x":4760,"y":200,"w":1400,"h":575,"title":"White card models","z":3},{"id":"f5","type":"frame","x":200,"y":858,"w":1400,"h":573,"title":"Direction renders","z":4},{"id":"f6","type":"frame","x":1720,"y":936,"w":1400,"h":997,"title":"Bench Gardens","z":5},{"id":"f7","type":"frame","x":3240,"y":699,"w":1400,"h":575,"title":"Hero options","z":6},{"id":"f8","type":"frame","x":4760,"y":885,"w":1400,"h":1473,"title":"Facade iterations","z":7},{"id":"f9","type":"frame","x":200,"y":1541,"w":1400,"h":1075,"title":"Material studies","z":8},{"id":"f10","type":"frame","x":1720,"y":2043,"w":1400,"h":650,"title":"Lobby","z":9},{"id":"f11","type":"frame","x":3240,"y":1384,"w":1400,"h":532,"title":"Sky lounge","z":10},{"id":"f12","type":"frame","x":4760,"y":2468,"w":1400,"h":1022,"title":"Camera set","z":11},{"id":"f13","type":"frame","x":200,"y":2726,"w":1400,"h":600,"title":"Corner residence","z":12},{"id":"f14","type":"frame","x":1720,"y":2803,"w":1400,"h":1473,"title":"Seasons & light","z":13},{"id":"f15","type":"frame","x":3240,"y":2026,"w":1400,"h":530,"title":"Masterplan views","z":14},{"id":"f16","type":"frame","x":4760,"y":3600,"w":1400,"h":1473,"title":"Motion","z":15},{"id":"f17","type":"frame","x":200,"y":3436,"w":1400,"h":575,"title":"Print upscales","z":16},{"id":"b1","type":"tool","x":244,"y":296,"name":"Site photos","kind":"Image","model":"Nano Banana 2","icon":"Map","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s03-existing-buried-creek-channel-160598-800w.webp"],"z":17},{"id":"n11","type":"note","x":244,"y":492,"w":184,"h":184,"tint":"amethyst","text":"Site walk done. The buried creek is the opportunity.","author":"KB","z":18},{"id":"x1","type":"image","x":540,"y":296,"w":316,"h":176,"label":"existing_site_aerial","tid":"s01","z":19,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","pw":800,"ph":447},{"id":"x2","type":"image","x":882,"y":304,"w":316,"h":176,"label":"existing_depot_street","tid":"s02","z":20,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp","pw":800,"ph":447},{"id":"x3","type":"image","x":1224,"y":292,"w":316,"h":176,"label":"existing_buried_creek_ch","tid":"s03","z":21,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s03-existing-buried-creek-channel-160598-800w.webp","pw":800,"ph":447},{"id":"b2","type":"tool","x":1764,"y":296,"name":"Massing sketches","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e03-option-c-sketch-salt-11df63-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e01-option-a-sketch-shoreline-c101a0-800w.webp"],"z":22},{"id":"x4","type":"image","x":2060,"y":296,"w":316,"h":423,"label":"option_b_sketch_canyon","tid":"e02","z":23,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","pw":800,"ph":1071},{"id":"x5","type":"image","x":2402,"y":304,"w":316,"h":421,"label":"option_c_sketch_salt","tid":"e03","z":24,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e03-option-c-sketch-salt-11df63-800w.webp","pw":800,"ph":1067},{"id":"x6","type":"image","x":2744,"y":292,"w":316,"h":474,"label":"option_a_sketch_shorelin","tid":"e01","z":25,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e01-option-a-sketch-shoreline-c101a0-800w.webp","pw":800,"ph":1200},{"id":"b3","type":"tool","x":3284,"y":296,"name":"Site plans","kind":"Image","model":"ChatGPT Image 2","icon":"Map","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s05-concept-drivers-board-25e1a7-800w.webp"],"z":26},{"id":"x7","type":"image","x":3580,"y":296,"w":316,"h":237,"label":"existing_site_plan","tid":"s04","z":27,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","pw":800,"ph":600},{"id":"x8","type":"image","x":3922,"y":304,"w":316,"h":178,"label":"concept_drivers_board","tid":"s05","z":28,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s05-concept-drivers-board-25e1a7-800w.webp","pw":800,"ph":450},{"id":"b4","type":"tool","x":4804,"y":296,"name":"White card","kind":"Image","model":"Seedream 5 Lite","icon":"Building2","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp"],"z":29},{"id":"n41","type":"note","x":4804,"y":492,"w":184,"h":184,"tint":"amethyst","text":"Client leaning A. The shorelines story lands.","author":"JR","z":30},{"id":"x9","type":"image","x":5100,"y":296,"w":316,"h":178,"label":"white_card_options_a_b_c","tid":"e04","z":31,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","pw":800,"ph":450},{"id":"x10","type":"image","x":5442,"y":304,"w":316,"h":423,"label":"option_a_white_card_mode","tid":"e05","z":32,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp","pw":800,"ph":1071},{"id":"b5","type":"tool","x":244,"y":954,"name":"Direction renders","kind":"Image","model":"ChatGPT Image 2","icon":"Building2","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e06-option-b-render-parked-80d4c0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e07-option-c-render-parked-e0c191-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e08-option-a-watercolor-db5917-800w.webp"],"z":33},{"id":"x11","type":"image","x":540,"y":954,"w":316,"h":421,"label":"option_b_render_parked","tid":"e06","z":34,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e06-option-b-render-parked-80d4c0-800w.webp","pw":800,"ph":1067},{"id":"x12","type":"image","x":882,"y":962,"w":316,"h":421,"label":"option_c_render_parked","tid":"e07","z":35,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e07-option-c-render-parked-e0c191-800w.webp","pw":800,"ph":1067},{"id":"x13","type":"image","x":1224,"y":950,"w":316,"h":421,"label":"option_a_watercolor","tid":"e08","z":36,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e08-option-a-watercolor-db5917-800w.webp","pw":800,"ph":1067},{"id":"b6","type":"tool","x":1764,"y":1032,"name":"Bench Gardens","kind":"Image","model":"Nano Banana 2","icon":"Trees","count":12,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l09-greener-depot-street-a56204-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp"],"z":37},{"id":"x14","type":"image","x":2060,"y":1032,"w":316,"h":237,"label":"rendered_landscape_maste","tid":"l01","z":38,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp","pw":800,"ph":600},{"id":"x15","type":"image","x":2402,"y":1040,"w":316,"h":237,"label":"watercolor_masterplan","tid":"l02","z":39,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","pw":800,"ph":600},{"id":"x16","type":"image","x":2744,"y":1028,"w":316,"h":176,"label":"greener_depot_street","tid":"l09","z":40,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l09-greener-depot-street-a56204-800w.webp","pw":800,"ph":447},{"id":"x17","type":"image","x":2060,"y":1295,"w":316,"h":178,"label":"creek_walk_engine_export","tid":"l03","z":41,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp","pw":800,"ph":450},{"id":"x18","type":"image","x":2402,"y":1303,"w":316,"h":176,"label":"creek_walk_marketing_her","tid":"l04","fav":true,"z":42,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l04-creek-walk-marketing-hero-92d17d-800w.webp","pw":800,"ph":447},{"id":"x19","type":"image","x":2744,"y":1291,"w":316,"h":176,"label":"swap_trees_to_gambel_oak","tid":"l05","z":43,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l05-swap-trees-to-gambel-oak-2f2873-800w.webp","pw":800,"ph":447},{"id":"x20","type":"image","x":2060,"y":1499,"w":316,"h":176,"label":"markup_benches_and_overl","tid":"l06","z":44,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l06-markup-benches-and-overlook-11b969-800w.webp","pw":800,"ph":447},{"id":"x21","type":"image","x":2402,"y":1507,"w":316,"h":176,"label":"benches_and_overlook_add","tid":"l07","z":45,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp","pw":800,"ph":447},{"id":"x22","type":"image","x":2744,"y":1495,"w":316,"h":176,"label":"level_24_terrace_empty","tid":"l10","z":46,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l10-level-24-terrace-empty-788189-800w.webp","pw":800,"ph":447},{"id":"x23","type":"image","x":2060,"y":1701,"w":316,"h":176,"label":"terrace_built_in_seating","tid":"l11","z":47,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l11-terrace-built-in-seating-56f47f-800w.webp","pw":800,"ph":447},{"id":"x24","type":"image","x":2402,"y":1709,"w":316,"h":176,"label":"taller_planters_trailing","tid":"l12","z":48,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l12-taller-planters-trailing-plants-0310f9-800w.webp","pw":800,"ph":447},{"id":"x25","type":"image","x":2744,"y":1697,"w":316,"h":176,"label":"daytime_gardens_with_peo","tid":"l08","fav":true,"z":49,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l08-daytime-gardens-with-people-8fb7f2-800w.webp","pw":800,"ph":447},{"id":"b7","type":"tool","x":3284,"y":795,"name":"Hero options","kind":"Image","model":"Nano Banana Pro","icon":"Building2","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e21-hero-as-fine-pen-colour-sketch-92581b-800w.webp"],"z":50},{"id":"n71","type":"note","x":3284,"y":991,"w":184,"h":184,"tint":"amethyst","text":"Client review Thursday. Pick two for the cover spread.","author":"JR","z":51},{"id":"x26","type":"image","x":3580,"y":795,"w":316,"h":423,"label":"hero_v1_model_to_photo","tid":"e09","fav":true,"z":52,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","pw":800,"ph":1071},{"id":"x27","type":"image","x":3922,"y":803,"w":316,"h":423,"label":"hero_as_fine_pen_colour_","tid":"e21","z":53,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e21-hero-as-fine-pen-colour-sketch-92581b-800w.webp","pw":800,"ph":1071},{"id":"b8","type":"tool","x":4804,"y":981,"name":"Facade iterations","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":7,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e10-hero-v2-open-crown-4a3b4d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e11-markup-terraces-8b641f-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e13-markup-crown-louvres-c1ed86-800w.webp"],"z":54},{"id":"n81","type":"note","x":4804,"y":1177,"w":184,"h":184,"tint":"vista","text":"Crown feels heavy. Open it up.","author":"JR","z":55},{"id":"n82","type":"note","x":4804,"y":1377,"w":184,"h":184,"tint":"glass","text":"Plum crown? Fun, but reads Vegas. Staying sandstone.","author":"MT","z":56},{"id":"x28","type":"image","x":5100,"y":981,"w":316,"h":423,"label":"hero_v2_open_crown","tid":"e10","z":57,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e10-hero-v2-open-crown-4a3b4d-800w.webp","pw":800,"ph":1071},{"id":"x29","type":"image","x":5442,"y":989,"w":316,"h":423,"label":"markup_terraces","tid":"e11","z":58,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e11-markup-terraces-8b641f-800w.webp","pw":800,"ph":1071},{"id":"x30","type":"image","x":5784,"y":977,"w":316,"h":423,"label":"hero_v3_deeper_terraces","tid":"e12","z":59,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","pw":800,"ph":1071},{"id":"x31","type":"image","x":5100,"y":1430,"w":316,"h":423,"label":"markup_crown_louvres","tid":"e13","z":60,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e13-markup-crown-louvres-c1ed86-800w.webp","pw":800,"ph":1071},{"id":"x32","type":"image","x":5442,"y":1438,"w":316,"h":423,"label":"option_plum_crown_reject","tid":"e14","z":61,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e14-option-plum-crown-rejected-0a7466-800w.webp","pw":800,"ph":1071},{"id":"x33","type":"image","x":5784,"y":1426,"w":316,"h":423,"label":"hero_v4_brick_podium","tid":"e15","fav":true,"z":62,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","pw":800,"ph":1071},{"id":"x34","type":"image","x":5100,"y":1879,"w":316,"h":423,"label":"option_east_face_balconi","tid":"e23","z":63,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e23-option-east-face-balconies-21b33e-800w.webp","pw":800,"ph":1071},{"id":"b9","type":"tool","x":244,"y":1637,"name":"Material studies","kind":"Image","model":"Nano Banana 2","icon":"Layers","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m05-lobby-floor-red-rock-terrazzo-5379b6-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m06-match-paving-to-the-benches-f8aac0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m02-louvre-option-oxide-red-3b9834-800w.webp"],"z":64},{"id":"n91","type":"note","x":244,"y":1833,"w":184,"h":184,"tint":"glass","text":"Try oxide red on the west face?","author":"MT","z":65},{"id":"x35","type":"image","x":540,"y":1637,"w":316,"h":237,"label":"material_sample_flat_lay","tid":"m01","z":66,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp","pw":800,"ph":600},{"id":"x36","type":"image","x":882,"y":1645,"w":316,"h":236,"label":"lobby_floor_red_rock_ter","tid":"m05","z":67,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m05-lobby-floor-red-rock-terrazzo-5379b6-800w.webp","pw":800,"ph":597},{"id":"x37","type":"image","x":1224,"y":1633,"w":316,"h":176,"label":"match_paving_to_the_benc","tid":"m06","z":68,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m06-match-paving-to-the-benches-f8aac0-800w.webp","pw":800,"ph":447},{"id":"x38","type":"image","x":540,"y":1900,"w":316,"h":423,"label":"louvre_option_oxide_red","tid":"m02","z":69,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m02-louvre-option-oxide-red-3b9834-800w.webp","pw":800,"ph":1071},{"id":"x39","type":"image","x":882,"y":1908,"w":316,"h":423,"label":"louvre_option_pale_limes","tid":"m03","z":70,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m03-louvre-option-pale-limestone-b2566c-800w.webp","pw":800,"ph":1071},{"id":"x40","type":"image","x":1224,"y":1896,"w":316,"h":176,"label":"local_sandstone_podium_a","tid":"m04","z":71,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m04-local-sandstone-podium-and-walls-34452a-800w.webp","pw":800,"ph":447},{"id":"x41","type":"image","x":540,"y":2349,"w":316,"h":211,"label":"residence_palette_from_r","tid":"m07","z":72,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m07-residence-palette-from-reference-371621-800w.webp","pw":800,"ph":534},{"id":"x42","type":"image","x":882,"y":2357,"w":316,"h":211,"label":"island_countertop_and_re","tid":"m08","z":73,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m08-island-countertop-and-render-polish-c79356-800w.webp","pw":800,"ph":534},{"id":"b10","type":"tool","x":1764,"y":2139,"name":"Lobby","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":6,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i03-lobby-v2-artwork-sconces-7284ac-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i04-markup-longer-desk-260c81-800w.webp"],"z":74},{"id":"n101","type":"note","x":1764,"y":2335,"w":184,"h":184,"tint":"amethyst","text":"Desk needs to be twice as long. Marked it up.","author":"KB","z":75},{"id":"x43","type":"image","x":2060,"y":2139,"w":316,"h":178,"label":"lobby_white_model","tid":"i01","z":76,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","pw":800,"ph":450},{"id":"x44","type":"image","x":2402,"y":2147,"w":316,"h":236,"label":"lobby_v1_geometry_materi","tid":"i02","z":77,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","pw":800,"ph":597},{"id":"x45","type":"image","x":2744,"y":2135,"w":316,"h":236,"label":"lobby_v2_artwork_sconces","tid":"i03","z":78,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i03-lobby-v2-artwork-sconces-7284ac-800w.webp","pw":800,"ph":597},{"id":"x46","type":"image","x":2060,"y":2401,"w":316,"h":236,"label":"markup_longer_desk","tid":"i04","z":79,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i04-markup-longer-desk-260c81-800w.webp","pw":800,"ph":597},{"id":"x47","type":"image","x":2402,"y":2409,"w":316,"h":236,"label":"lobby_v3_stone_desk_plac","tid":"i05","z":80,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i05-lobby-v3-stone-desk-placed-c250ca-800w.webp","pw":800,"ph":597},{"id":"x48","type":"image","x":2744,"y":2397,"w":316,"h":236,"label":"lobby_v4_competition_bri","tid":"i06","fav":true,"z":81,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i06-lobby-v4-competition-brightening-34918a-800w.webp","pw":800,"ph":597},{"id":"b11","type":"tool","x":3284,"y":1480,"name":"Sky lounge","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":5,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i07-sky-lounge-engine-export-f60a11-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i08-sky-lounge-engine-to-photo-a7f5c1-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i09-sky-lounge-staged-from-reference-8b3de4-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp"],"z":82},{"id":"x49","type":"image","x":3580,"y":1480,"w":316,"h":178,"label":"sky_lounge_engine_export","tid":"i07","z":83,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i07-sky-lounge-engine-export-f60a11-800w.webp","pw":800,"ph":450},{"id":"x50","type":"image","x":3922,"y":1488,"w":316,"h":178,"label":"sky_lounge_engine_to_pho","tid":"i08","z":84,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i08-sky-lounge-engine-to-photo-a7f5c1-800w.webp","pw":800,"ph":450},{"id":"x51","type":"image","x":4264,"y":1476,"w":316,"h":176,"label":"sky_lounge_staged_from_r","tid":"i09","z":85,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i09-sky-lounge-staged-from-reference-8b3de4-800w.webp","pw":800,"ph":447},{"id":"x52","type":"image","x":3580,"y":1684,"w":316,"h":176,"label":"sky_lounge_borrow_evenin","tid":"i10","z":86,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp","pw":800,"ph":447},{"id":"x53","type":"image","x":3922,"y":1692,"w":316,"h":176,"label":"sky_lounge_evening_gathe","tid":"i11","fav":true,"z":87,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i11-sky-lounge-evening-gathering-b786e8-800w.webp","pw":800,"ph":447},{"id":"b12","type":"tool","x":4804,"y":2564,"name":"Camera set","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":5,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e16-raise-camera-reveal-the-gardens-4fe978-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e17-top-down-drone-over-the-crown-87d397-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e19-cutaway-axonometric-22df20-800w.webp"],"z":88},{"id":"x54","type":"image","x":5100,"y":2564,"w":316,"h":176,"label":"raise_camera_reveal_the_","tid":"e16","z":89,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e16-raise-camera-reveal-the-gardens-4fe978-800w.webp","pw":800,"ph":447},{"id":"x55","type":"image","x":5442,"y":2572,"w":316,"h":316,"label":"top_down_drone_over_the_","tid":"e17","z":90,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e17-top-down-drone-over-the-crown-87d397-800w.webp","pw":800,"ph":800},{"id":"x56","type":"image","x":5784,"y":2560,"w":316,"h":423,"label":"terrace_edge_detail_with","tid":"e18","z":91,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","pw":800,"ph":1071},{"id":"x57","type":"image","x":5100,"y":3013,"w":316,"h":421,"label":"cutaway_axonometric","tid":"e19","z":92,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e19-cutaway-axonometric-22df20-800w.webp","pw":800,"ph":1067},{"id":"x58","type":"image","x":5442,"y":3021,"w":316,"h":176,"label":"lunchtime_people_in_the_","tid":"e20","z":93,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e20-lunchtime-people-in-the-gardens-280901-800w.webp","pw":800,"ph":447},{"id":"b13","type":"tool","x":244,"y":2822,"name":"Corner residence","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":4,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i14-residence-curated-styling-f59e05-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i15-residence-winter-view-2b49f6-800w.webp"],"z":94},{"id":"x59","type":"image","x":540,"y":2822,"w":316,"h":211,"label":"corner_residence_sketch","tid":"i12","z":95,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp","pw":800,"ph":533},{"id":"x60","type":"image","x":882,"y":2830,"w":316,"h":211,"label":"residence_sketch_to_rend","tid":"i13","z":96,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","pw":800,"ph":534},{"id":"x61","type":"image","x":1224,"y":2818,"w":316,"h":211,"label":"residence_curated_stylin","tid":"i14","z":97,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i14-residence-curated-styling-f59e05-800w.webp","pw":800,"ph":534},{"id":"x62","type":"image","x":540,"y":3059,"w":316,"h":211,"label":"residence_winter_view","tid":"i15","z":98,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i15-residence-winter-view-2b49f6-800w.webp","pw":800,"ph":534},{"id":"b14","type":"tool","x":1764,"y":2899,"name":"Seasons & light","kind":"Image","model":"Nano Banana 2","icon":"Sun","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t02-summer-monsoon-afternoon-8923fc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t01-spring-noon-3be8a4-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp"],"z":99},{"id":"n141","type":"note","x":1764,"y":3095,"w":184,"h":184,"tint":"vista","text":"Winter set is for the ski-season brochure.","author":"MT","z":100},{"id":"x63","type":"image","x":2060,"y":2899,"w":316,"h":423,"label":"summer_monsoon_afternoon","tid":"t02","z":101,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t02-summer-monsoon-afternoon-8923fc-800w.webp","pw":800,"ph":1071},{"id":"x64","type":"image","x":2402,"y":2907,"w":316,"h":423,"label":"alpenglow_dusk","tid":"t07","fav":true,"z":102,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","pw":800,"ph":1071},{"id":"x65","type":"image","x":2744,"y":2895,"w":316,"h":423,"label":"spring_noon","tid":"t01","z":103,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t01-spring-noon-3be8a4-800w.webp","pw":800,"ph":1071},{"id":"x66","type":"image","x":2060,"y":3348,"w":316,"h":423,"label":"autumn_golden_hour","tid":"t03","z":104,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp","pw":800,"ph":1071},{"id":"x67","type":"image","x":2402,"y":3356,"w":316,"h":423,"label":"winter_inversion_haze","tid":"t05","z":105,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t05-winter-inversion-haze-c734b0-800w.webp","pw":800,"ph":1071},{"id":"x68","type":"image","x":2744,"y":3344,"w":316,"h":423,"label":"winter_blue_hour","tid":"t04","fav":true,"z":106,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t04-winter-blue-hour-50f063-800w.webp","pw":800,"ph":1071},{"id":"x69","type":"image","x":2060,"y":3797,"w":316,"h":423,"label":"night_facade_lighting","tid":"t06","z":107,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t06-night-facade-lighting-69ccb0-800w.webp","pw":800,"ph":1071},{"id":"x70","type":"image","x":2402,"y":3805,"w":316,"h":423,"label":"soft_glow_behind_glazing","tid":"t08","z":108,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t08-soft-glow-behind-glazing-6fc036-800w.webp","pw":800,"ph":1071},{"id":"b15","type":"tool","x":3284,"y":2122,"name":"Masterplan views","kind":"Image","model":"Nano Banana Pro","icon":"Map","count":4,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s09-masterplan-twilight-glow-1694c9-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp"],"z":109},{"id":"x71","type":"image","x":3580,"y":2122,"w":316,"h":176,"label":"masterplan_aerial","tid":"s06","fav":true,"z":110,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","pw":800,"ph":447},{"id":"x72","type":"image","x":3922,"y":2130,"w":316,"h":176,"label":"masterplan_twilight_glow","tid":"s09","z":111,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s09-masterplan-twilight-glow-1694c9-800w.webp","pw":800,"ph":447},{"id":"x73","type":"image","x":4264,"y":2118,"w":316,"h":176,"label":"markup_eye_level_camera_","tid":"s07","z":112,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","pw":800,"ph":447},{"id":"x74","type":"image","x":3580,"y":2324,"w":316,"h":176,"label":"eye_level_view_from_site","tid":"s08","z":113,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp","pw":800,"ph":447},{"id":"b16","type":"tool","x":4804,"y":3696,"name":"Motion","kind":"Video","model":"Kling 2.6 Pro","icon":"Video","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-400w.webp"],"z":114},{"id":"x75","type":"image","x":5100,"y":3696,"w":316,"h":423,"label":"white_card_model_orbit","tid":"v01","video":true,"dur":"0:05","kind":"video","z":115,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-optimized.mp4"},{"id":"x76","type":"image","x":5442,"y":3704,"w":316,"h":178,"label":"creek_walk_evening_strol","tid":"v07","video":true,"dur":"0:10","kind":"video","z":116,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-optimized.mp4"},{"id":"x77","type":"image","x":5784,"y":3692,"w":316,"h":423,"label":"detail_to_tower_pull_out","tid":"v05","video":true,"dur":"0:05","kind":"video","z":117,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-optimized.mp4"},{"id":"x78","type":"image","x":5100,"y":4145,"w":316,"h":423,"label":"hero_dolly_in","tid":"v02","video":true,"dur":"0:05","kind":"video","z":118,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-optimized.mp4"},{"id":"x79","type":"image","x":5442,"y":4153,"w":316,"h":178,"label":"sky_lounge_sunset_time_l","tid":"v06","video":true,"dur":"0:08","kind":"video","z":119,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v06-sky-lounge-sunset-time-lapse-a0a91aee-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v06-sky-lounge-sunset-time-lapse-a0a91aee-optimized.mp4"},{"id":"x80","type":"image","x":5784,"y":4141,"w":316,"h":177,"label":"bring_the_gardens_to_lif","tid":"v04","video":true,"dur":"0:05","kind":"video","z":120,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v04-bring-the-gardens-to-life-1cb39008-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v04-bring-the-gardens-to-life-1cb39008-optimized.mp4"},{"id":"x81","type":"image","x":5100,"y":4594,"w":316,"h":178,"label":"aerial_day_to_night_time","tid":"v03","video":true,"dur":"0:08","kind":"video","z":121,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v03-aerial-day-to-night-time-lapse-744df3b5-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v03-aerial-day-to-night-time-lapse-744df3b5-optimized.mp4"},{"id":"x82","type":"image","x":5442,"y":4602,"w":316,"h":423,"label":"white_card_to_photo_tran","tid":"v08","video":true,"dur":"0:05","kind":"video","z":122,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v08-white-card-to-photo-transition-ad34593f-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v08-white-card-to-photo-transition-ad34593f-optimized.mp4"},{"id":"b17","type":"tool","x":244,"y":3532,"name":"Print upscales","kind":"Image","model":"Nano Banana Pro","icon":"Building2","count":1,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp"],"z":123},{"id":"x83","type":"image","x":540,"y":3532,"w":316,"h":423,"label":"hero_final_editorial_upg","tid":"e22","fav":true,"z":124,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp","pw":800,"ph":1071},{"id":"lg1","type":"note","x":204,"y":-132,"w":184,"h":184,"tint":"amethyst","text":"1 - CANVAS\\n\\n- Tools\\n- Generations\\n- Organization","author":"You","z":125},{"id":"lga1","type":"shape","shape":"arrow","x":425,"y":-41,"w":38,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":126},{"id":"lg2","type":"note","x":499,"y":-132,"w":184,"h":184,"tint":"vista","text":"2 - PROMPT LIBRARY","author":"You","z":127},{"id":"lga2","type":"shape","shape":"arrow","x":717,"y":-41,"w":36,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":128},{"id":"lg3","type":"note","x":796,"y":-131,"w":184,"h":212,"tint":"glass","text":"3 - INTEGRATIONS\\n\\n- Revit\\n- Photoshop\\n- Rhino\\n- Sketchup\\n- Miro","author":"You","z":129},{"id":"lga3","type":"shape","shape":"arrow","x":1022,"y":-40,"w":33,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":130},{"id":"lg4","type":"note","x":1101,"y":-131,"w":184,"h":212,"tint":"amethyst","text":"4 - CHAT\\n\\n- Tutorials/Questions\\n- Prompts\\n- Generations\\n- Workflows","author":"You","z":131}]'), FW = /* @__PURE__ */ JSON.parse(`[{"id":"bm1","name":"Existing site aerial","model":"Nano Banana Pro","prompt":"Create a realistic oblique aerial drone photograph of Depot Yards, a 4-acre former rail yard block at the west edge of downtown Salt Lake City, Utah, with a restored red-brick freight depot, rusted rail spurs and a buried creek channel crossing the block diagonally, looking east. The block is empty: gravel lots, rail spurs, the restored brick depot with a gabled roof in the lower left, and a dry, overgrown creek channel cutting diagonally across it. Surround it with low brick warehouses, a light rail line along the north edge and mid-rise downtown buildings beyond, with the snow-capped Wasatch Range rising to the east behind. Use a clear spring morning with long soft shadows and crisp, dry high-desert light under a deep blue sky. Retain the utilitarian character of a real site photograph, with no diagram overlays, labels or proposed buildings.","author":"KB","at":"2026-09-01","board":"Site photos","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","inputs":[]},{"id":"bm2","name":"Existing site plan","model":"ChatGPT Image 2","prompt":"Create a clean top-down architectural site plan drawing of Depot Yards, a 4-acre former rail yard block at the west edge of downtown Salt Lake City, Utah, with a restored red-brick freight depot, rusted rail spurs and a buried creek channel crossing the block diagonally as it exists today. Show the city block outline and surrounding streets, the brick depot footprint in the lower left, rail spurs, the buried creek alignment as a dashed line crossing the block diagonally, the light rail line along the top edge and adjacent warehouse footprints. Use thin black linework on white, light grey hatching for existing buildings, a north arrow, a scale bar and small neat labels: 'DEPOT YARDS', 'FREIGHT DEPOT', 'CREEK (CULVERTED)', 'LIGHT RAIL', '400 WEST'. No colour, no rendering and no proposed buildings.","author":"MT","at":"2026-09-02","board":"Site plans & analysis","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","inputs":[]},{"id":"bm3","name":"Masterplan aerial","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the existing Depot Yards site aerial and is the primary scene to edit. Image 2 is the Bench Gardens landscape masterplan, supplied only for the specific reference role described below. Image 3 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nRender the proposed project into the aerial in Image 1. Use Image 2 for the site layout: the daylighted creek, curved limestone terraces, cottonwood grove, water-mirror plaza, depot plaza and paths. Use Image 3 for the tower's design, placing it in the northeast corner of the block with its four planted setbacks, terracotta bands, open crown and brick podium. Keep the surrounding city, the brick depot, the light rail line, the mountains, the camera and the morning light unchanged. Make the new landscape and tower read as built and mature, at correct scale.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-12","board":"Masterplan views","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm4","name":"Eye-level view from site markup","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the annotated masterplan aerial with a camera position and view arrow and is the primary scene to edit. Image 2 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nFollow and remove the annotations marked on the image; create an eye-level view at the red dot looking along the arrow toward the tower. Show the daylighted creek and curved limestone terraces in the foreground, the cottonwood grove and the tower from Image 2 rising behind, with the snow-capped Wasatch Range rising to the east beyond. This is a reimagining of the site as built. Photo reference: documentary-style architectural photography in late-afternoon spring light.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-13","board":"Masterplan views","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm5","name":"Option B sketch: Canyon","model":"Nano Banana 2","prompt":"Create an architectural concept marker sketch on white trace paper of a 52-storey skyscraper split top to bottom by a narrow slot-canyon void, its two halves clad in curved vertical fins. Render it in warm red-rock and ochre marker tones with black fineliner linework. Use a street-level perspective with loose people silhouettes at the base and a mountain range hinted behind in grey marker. A designer's quick ideation sketch with energetic line weight and white paper showing through.","author":"MT","at":"2026-09-02","board":"Massing sketches","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","inputs":[]},{"id":"bm6","name":"White card options A / B / C","model":"Seedream 5 Lite","prompt":"Create a photograph of an architecture studio's white card massing models on a large worktable: three alternative skyscraper options side by side on one shared site base, each about 60 cm tall and built from white foam board and basswood. Option A is a slender tower tapering through four stepped setbacks with horizontal banding. Option B is a tower split top to bottom by a narrow vertical slot with vertical fin ribs. Option C is a faceted crystalline tower with folded facets and a sharp crown. The site base shows a city block with a diagonal creek channel cut into it, small white context buildings and one tiny brick-red depot building. Small folded paper tags in front read 'A', 'B' and 'C'. Soft overhead studio daylight, shallow depth of field, with a cutting mat and rolls of trace paper at the edge of the frame.","author":"JR","at":"2026-09-03","board":"White card models","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","inputs":[]},{"id":"bm7","name":"Hero v1: model to photo","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the white card model of Bonneville Tower and is the primary scene to edit. Image 2 is the existing Depot Yards street photograph, supplied only for the specific reference role described below.\\n\\nRender Image 1 as the completed Bonneville Tower in Salt Lake City. Use Image 2 only for site context, photographic atmosphere and material realism, not its building geometry. Preserve the model's silhouette, four stepped setbacks and undulating horizontal bands. Clad the bands in warm sandstone-coloured terracotta louvres alternating with low-iron glass, with bronze soffits and native trees and grasses on every setback terrace. Show the tower rising beyond the restored brick depot, with a light rail line and a few pedestrians in the foreground and the snow-capped Wasatch Range rising to the east behind. Late-afternoon spring light, crisp, dry high-desert light under a deep blue sky. Keep the camera level with corrected verticals, a restrained 24 mm architectural lens character and deep focus.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-05","board":"Hero options","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp"]},{"id":"bm8","name":"Hero v4: brick podium","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bonneville Tower render with deepened terraces and is the primary scene to edit. Image 2 is the tight brick facade rhythm reference, supplied only for the specific reference role described below.\\n\\nApply the tight vertical pier rhythm from Image 2 only to the five-storey podium at the base of the tower in Image 1: close-spaced warm brick piers with deep-set glazing that relate the podium to the neighbouring brick freight depot. Keep the tower above the podium, its setbacks, crown, terracotta bands, street, light and camera unchanged. Use Image 2 only for facade rhythm and brick character, not its building form. Keep the full tower in frame from the street to the top of the open crown, with the same portrait composition as Image 1.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-09","board":"Facade iterations","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r117-tight-facade-rhythm-reference-a4ddff-800w.webp"]},{"id":"bm9","name":"Hero final: editorial upgrade","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit. Image 2 is the residential tower comparison photograph, supplied only for the specific reference role described below.\\n\\nUpgrade Image 1 to an editorial architectural photograph, using Image 2 only as a realism reference. Preserve the tower design, setback terraces, crown, podium rhythm, street context and camera. Use warm late-afternoon sunlight, soft shadows, a subtle deep-blue sky gradient and the snow-capped Wasatch Range crisp behind. Refine glass reflections, terracotta material response and planting with balanced colour and controlled contrast. Keep the building crisp, without exaggerated sharpening or artificial saturation.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-13","board":"Print upscales","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r143-residential-tower-comparison-reference-620572-800w.webp"]},{"id":"bm10","name":"Terrace edge detail with bokeh","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nCreate a close-up detail photograph of one setback terrace edge: warm sandstone terracotta louvres, a bronze soffit, a low-iron glass guardrail and native grasses spilling over the planter lip, with the upper tower bands blurred into soft bokeh behind. Keep the materials, colours and afternoon light consistent with Image 1. Shallow depth of field with an 85 mm lens character.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","author":"KB","at":"2026-09-10","board":"Camera set","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm11","name":"Watercolor masterplan","model":"ChatGPT Image 2","prompt":"Create one finished architectural image. Image 1 is the rendered landscape masterplan and is the primary scene to edit.\\n\\nMake this plan a clean architectural watercolor sketch: loose ink linework, soft transparent washes for the planting and water, white paper left for the paths, and the existing labels kept neat and legible.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","author":"MT","at":"2026-09-05","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp"]},{"id":"bm12","name":"Creek walk marketing hero","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bench Gardens creek walk engine render and is the primary scene to edit. Image 2 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nStrengthen this engine render into a marketing hero image: photorealistic limestone, clear rippling creek water, lush native grasses, sagebrush and flowering purple penstemon, mature cottonwoods, and natural people walking and sitting on the benches. Replace the placeholder striped tower at the right edge of the frame with the tower from Image 2 (its brick podium, warm terracotta bands and planted setback terraces) at the same position and scale, using Image 2 only for the tower's design. Late-afternoon spring light, crisp, dry high-desert light under a deep blue sky, with the snow-capped Wasatch Range rising to the east glimpsed beyond. Top-tier architectural visualization quality with verticals corrected.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-09","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l04-creek-walk-marketing-hero-92d17d-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm13","name":"Daytime gardens with people","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bench Gardens creek walk render and is the primary scene to edit. Image 2 is the pavilion terrace people and placement reference, supplied only for the specific reference role described below.\\n\\nRender Image 1 in bright daytime and add people inspired by the placement and activity in Image 2: small groups sitting on the new benches, a couple leaning on the boardwalk rail and people strolling the path, all at correct scale. Use Image 2 only for people and placement. Keep the architecture, landscape, boardwalk and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-12","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l08-daytime-gardens-with-people-8fb7f2-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r123-pavilion-terrace-people-reference-crop-a239be-800w.webp"]},{"id":"bm14","name":"Louvre option: pale limestone","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the terrace-edge louvre detail photograph and is the primary scene to edit. Image 2 is the material sample board, supplied only for the specific reference role described below.\\n\\nReplace only the sandstone terracotta louvre finish in Image 1 with the pale limestone glazed terracotta sample from Image 2. Follow every louvre edge and profile with consistent glaze and realistic joints, and preserve the louvre geometry exactly. Keep the bronze soffit, glass guardrail, planting, bokeh background, camera and lighting unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Material studies","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m03-louvre-option-pale-limestone-b2566c-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp"]},{"id":"bm15","name":"Residence palette from reference","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the corner residence living room render and is the primary scene to edit. Image 2 is the amber and rose lounge atmosphere reference, supplied only for the specific reference role described below.\\n\\nTransfer the warm amber-and-rose material palette and moody lighting of Image 2 onto the residence in Image 1: warm walnut millwork, rust and rose upholstery, bronze accents and soft amber lamp light. Use Image 2 only for palette and lighting, not its layout. Keep the room geometry, windows, mountain view, furniture layout and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-12","board":"Material studies","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m07-residence-palette-from-reference-371621-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r044-amber-and-rose-lounge-atmosphere-396273-800w.webp"]},{"id":"bm16","name":"Lobby v1: geometry + materials","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the white clay model of the lobby geometry and is the primary scene to edit. Image 2 is the material sample board, supplied only for the specific reference role described below.\\n\\nRender Image 1 as a finished photorealistic lobby while keeping its geometry, openings and camera exactly. Use Image 2 only for materials: the rammed-earth sample for the long curved feature wall, with horizontal strata like ancient shorelines; warm sandstone terracotta for the fin walls; red-rock terrazzo for the floor; walnut for the reception desk; and bronze trim. Warm afternoon light through the window wall onto the garden, with a few natural people.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-09","board":"Lobby","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp"]},{"id":"bm17","name":"Lobby v4: competition brightening","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the lobby photograph and is the primary scene to edit.\\n\\nBrighten this lobby for a competition board: lift the interior exposure, add soft daylight bouncing off the floor, keep the sconces and artwork warm, and make the colours clean and inviting without losing material detail. Keep everything else unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-11","board":"Lobby","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i06-lobby-v4-competition-brightening-34918a-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i05-lobby-v3-stone-desk-placed-c250ca-800w.webp"]},{"id":"bm18","name":"Sky lounge: evening gathering","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the evening sky lounge photograph and is the primary scene to edit. Image 2 is the casual evening gathering people reference, supplied only for the specific reference role described below.\\n\\nStage a lively evening gathering in Image 1, with people inspired by the mix, clothing and activity in Image 2: small groups talking with drinks, people seated in the lounge chairs and someone photographing the view. Use Image 2 only for people. Keep the architecture, furniture, lighting and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-12","board":"Sky lounge","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i11-sky-lounge-evening-gathering-b786e8-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r095-casual-workplace-evening-gathering-0bce32-800w.webp"]},{"id":"bm19","name":"Residence: sketch to render","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the fine-pen corner residence sketch and is the primary scene to edit.\\n\\nPlease transform this sketch into a hyper realistic render. Recognize the different textures from the sketch and translate them into warm walnut, pale limestone floors, linen upholstery and bronze fixtures. Maintain the point of view. Show the snow-capped Wasatch Range through the corner windows in afternoon light.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Corner residence","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp"]},{"id":"bm20","name":"Winter blue hour","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nKeep image exactly how it is. Only change the season and time to a deep winter blue hour: fresh snow on the terraces, street and depot roof, light snow falling, the mountains fully white and warm glowing windows.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-12","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t04-winter-blue-hour-50f063-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm21","name":"Alpenglow dusk","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nReveal the full horizon behind the tower: show the whole Wasatch Range glowing pink and orange with alpenglow just after sunset, under a clear peach-to-deep-blue sky. Keep the tower, street context and camera exactly the same.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm22","name":"Autumn golden hour","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nSet the scene at golden hour in early October, with the building's interior lights glowing warmly and spilling outward into the fading light. The foothills behind are red and orange with autumn scrub oak, and the terrace trees have turned gold. You can't see the sun.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-12","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm23","name":"Hero dolly-in","model":"Kling 2.6 Pro","prompt":"Do a gentle, smooth cinematic dolly forward toward the tower, as if the viewer is slowly walking up the street. Keep the architecture perfectly stable and verticals straight, with subtle natural motion in the trees and a few pedestrians.","author":"KB","at":"2026-09-14","board":"Motion","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-400w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp"]},{"id":"bm24","name":"Creek walk evening stroll","model":"LTX 2.3","prompt":"People stroll along the creek path and sit on the benches as the evening light warms. Slight, slow camera push in. The water ripples and the grasses sway. The architecture and landscape remain stable.","author":"MT","at":"2026-09-14","board":"Motion","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-400w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp"]},{"id":"sm1","name":"Ink + wet watercolour board","model":"Seedream 5 Lite","prompt":"Create one finished architectural image. Image 1 is the timber riverside pavilion at sunset and is the primary scene to edit. Image 2 is the watercolor stepped public courtyard, supplied only for the specific reference role described below. Image 3 is the watercolor stone and glass entrance, supplied only for the specific reference role described below. Image 4 is the forest cabin pencil and wash study, supplied only for the specific reference role described below. Image 5 is the watercolor glass pavilion and pool, supplied only for the specific reference role described below. Image 6 is the sepia civic pavilion beside water, supplied only for the specific reference role described below. Image 7 is the glass pavilion landscape watercolor, supplied only for the specific reference role described below. Image 8 is the raw timber building concept sketch, supplied only for the specific reference role described below. Image 9 is the red urban building watercolor, supplied only for the specific reference role described below. Image 10 is the orange modular building sketch, supplied only for the specific reference role described below. Image 11 is the slender red tower concept sketch, supplied only for the specific reference role described below. Image 12 is the three sculptural facade studies, supplied only for the specific reference role described below. Image 13 is the three colorful massing studies, supplied only for the specific reference role described below.\\n\\nRestyle Image 1 as a single architectural illustration. Use Images 2 through 13 solely as references for ink and watercolor technique; do not combine their buildings or make a collage. Draw structural edges in medium black ink with loose wet-in-wet washes, soft bleeds, pigment blooms and light paper grain. Use transparent blues, warm ochres and greens, darker pooled shadows and untouched white highlights. Simplify the existing people into loose silhouettes while preserving the pavilion, river landscape and composition from Image 1.\\n\\nPreserve the source design and spatial relationships except for the requested transformation. Keep linework, color and surface treatment consistent with the specified illustration style. Include no unrelated labels or graphic marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f015-ink-and-wet-watercolor-8fee6e-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r016-timber-riverside-pavilion-at-sunset-fa0780-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r017-watercolor-stepped-public-courtyard-7fc530-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r018-watercolor-stone-and-glass-entrance-09e1b4-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r019-forest-cabin-pencil-and-wash-study-aee0f0-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r020-watercolor-glass-pavilion-and-pool-9ae5e5-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r021-sepia-civic-pavilion-beside-water-118403-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r022-glass-pavilion-landscape-watercolor-ec8063-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r023-raw-timber-building-concept-sketch-863af3-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r024-red-urban-building-watercolor-225c95-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r025-orange-modular-building-sketch-88edb7-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r026-slender-red-tower-concept-sketch-4ccc34-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r027-three-sculptural-facade-studies-e88423-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r028-three-colorful-massing-studies-f239ea-original.webp"]},{"id":"sm2","name":"White model → render","model":"GPT Image 1.5","prompt":"Create one finished architectural image. Image 1 is the white office model interior and is the primary scene to edit. Image 2 is the warm workplace interior mood board, supplied only for the specific reference role described below. Image 3 is the office materials and furniture board, supplied only for the specific reference role described below. Image 4 is the sunlit industrial office lounge, supplied only for the specific reference role described below.\\n\\nRender the white office model in Image 1 with the warm workplace palette and furnishings suggested by Images 2 and 3. Use Image 4 for the rhythm of the exposed ceiling structure, translated into smooth warm concrete as the specified finish. Preserve the office layout, workstation positions, window arrangement and camera. Produce a coherent photorealistic workplace with credible material scale, daylight and contact shadows.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f009-white-model-look-transfer-820fb4-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r005-white-office-model-interior-ace253-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r006-warm-workplace-interior-mood-board-1dc35d-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r007-office-materials-and-furniture-board-95471b-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r008-sunlit-industrial-office-lounge-59d45b-original.webp"]},{"id":"sm3","name":"Magazine-grade upgrade","model":"ChatGPT Image 2","prompt":"Create one finished architectural image. Image 1 is the residential tower street render and is the primary scene to edit. Image 2 is the residential tower comparison reference, supplied only for the specific reference role described below.\\n\\nUpgrade Image 1 to an editorial architectural photograph, using Image 2 only as a realism reference. Preserve the tower design, facade proportions, balcony rhythm, street context and camera. Use warm natural sunlight, soft shadows, a subtle sky gradient and mild atmospheric depth. Refine glass reflections, material response and planting with balanced color and controlled contrast. Keep the building crisp without exaggerated sharpening or artificial saturation.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f093-magazine-grade-photoreal-upgrade-bd0a54-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r142-residential-tower-street-render-359681-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r143-residential-tower-comparison-reference-29add0-original.webp"]},{"id":"sm4","name":"Colour-coded markup edits","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the new annotated color-coded multi-markup edits and is the primary scene to edit.\\n\\nReplace the surface within the red outline with a perforated metal panel system fitted to the existing stair-tower facade. Turn the ground-level bay within the white outline into a vehicle exit with a proportionate exit barrier arm. Preserve the garage structure, other openings, street, people, trees and camera. Remove the red and white annotations from the completed scene.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f087-color-coded-multi-markup-edits-76f768-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/a087-color-coded-multi-markup-edits-annotation-4043aa-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r131-urban-parking-garage-street-approach-fabe37-original.webp"]},{"id":"sm5","name":"Remove the CGI look","model":"GPT Image 1.5","prompt":"Create one finished architectural image. Image 1 is the neutral stone elevator lobby render and is the primary scene to edit.\\n\\nRefine the lighting in the render view - True-to-life color grading, architectural digest style. No cgi look, no over-sharpening, no artificial symmetry perfection. 4000k lighting. Keep everything else the same.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f094-remove-the-cgi-look-532569-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r144-neutral-stone-elevator-lobby-render-a2ae6f-original.webp"]},{"id":"sm6","name":"Raise camera, reveal plaza","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the residential courtyard street elevation and is the primary scene to edit.\\n\\nRaise the camera upward and look slightly down so more of the central plaza and foreground public space become visible.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f072-raise-camera-reveal-the-plaza-7d8009-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r102-residential-courtyard-street-elevation-fe3a75-original.webp"]}]`), NW = [{ id: "image", name: "Image", icon: "Image", desc: "Create images with AI-powered models", models: [{ name: "Nano Banana Pro", desc: "Best-in-class prompt adherence and editing", time: "50s", tokens: "240", g: 4 }, { name: "Nano Banana 2", desc: "Improved text, realism, and editing (Gemini 3.1)", time: "45s", tokens: "173", g: 8 }, { name: "ChatGPT Image 2", desc: "Prompt-perfect generation and surgical editing", time: "24s", tokens: "22–484", g: 10 }, { name: "GPT Image 1.5", desc: "Fast, faithful edits with strong text", time: "20s", tokens: "120", g: 1 }, { name: "Seedream 5 Lite", desc: "Bytedance’s fast, low-cost image model", time: "8s", tokens: "40", g: 2 }, { name: "Flux 2 Pro", desc: "FLUX 2 by Black Forest Labs", time: "15s", tokens: "70–700", g: 15 }] }, { id: "video", name: "Video", icon: "Video", desc: "Generate dynamic videos and animations", models: [{ name: "Kling 2.6 Pro", desc: "Expressive motion with strong camera control", time: "2m", tokens: "210", g: 6 }, { name: "LTX 2.3", desc: "Fast open video generation", time: "70s", tokens: "90", g: 12 }, { name: "Veo 3 Fast", desc: "Cinematic motion, quick turnaround", time: "90s", tokens: "260", g: 0 }, { name: "Hailuo 02", desc: "Strong physics and camera control", time: "2m", tokens: "210", g: 14 }] }, { id: "threed", name: "3D", icon: "Box", desc: "Generate 3D models from images or prompts", models: [{ name: "Hunyuan3D 2.1", desc: "Textured meshes from a single image", time: "2m", tokens: "240", g: 5 }, { name: "Trellis", desc: "Detailed geometry for hard-surface objects", time: "90s", tokens: "150", g: 9 }, { name: "Rodin Gen-2", desc: "Production-ready meshes with clean topology", time: "4m", tokens: "360", g: 3 }] }, { id: "upscale", name: "Upscale", icon: "Maximize2", desc: "Upscale your images and videos", models: [{ name: "Clarity Upscale", desc: "Crisp detail for print and large format", time: "30s", tokens: "40", g: 17 }, { name: "SUPIR", desc: "Restoration-grade photo upscaling", time: "50s", tokens: "55", g: 2 }, { name: "Topaz Video AI", desc: "Footage upscaling to 4k", time: "6m", tokens: "310", g: 10 }] }], ia = {
  title: OW,
  project: LW,
  elements: BW,
  templates: FW,
  kits: NW
}, UW = { image: "image", video: "video", "3d": "threed", upscale: "upscale" };
function GW(n) {
  return UW[String(n || "").toLowerCase()] || "image";
}
function dk(n, e) {
  return n.x >= e.x && n.y >= e.y && n.x < e.x + e.w && n.y < e.y + e.h;
}
function Kl() {
  const n = ia.elements, e = n.map((d) => {
    const c = { id: d.id, x: d.x, y: d.y, z: d.z };
    switch (d.type) {
      case "frame":
        return { ...c, type: "frame", w: d.w, h: d.h, title: d.title };
      case "note":
        return { ...c, type: "note", w: d.w, h: d.h, text: d.text, tint: d.tint || "glass", author: d.author };
      case "shape":
        return { ...c, type: "shape", w: d.w, h: d.h, shape: d.shape, stroke: d.stroke, sw: d.sw, sc: d.sc || [0, 0] };
      case "tool":
        return {
          ...c,
          type: "tool",
          w: 252,
          h: 160,
          name: d.name,
          kind: d.kind,
          kitId: GW(d.kind),
          model: d.model,
          icon: d.icon || "Image",
          count: d.count || 0,
          thumbs: d.thumbs || [],
          up: {},
          lastRunAt: Date.UTC(2026, 8, 1 + d.z % 14, 15, d.z * 7 % 60)
        };
      default:
        return {
          ...c,
          type: "image",
          w: d.w,
          h: d.h,
          src: d.src,
          label: d.label,
          fav: !!d.fav || void 0,
          video: !!d.video || void 0,
          dur: d.dur,
          videoSrc: d.videoSrc
        };
    }
  }), t = e.filter((d) => d.type === "frame"), i = e.filter((d) => d.type === "tool"), s = ia.templates, o = /* @__PURE__ */ new Map();
  for (const d of n) d.type === "image" && d.pw && d.ph && o.set(d.id, { pw: d.pw, ph: d.ph });
  const r = [], a = Date.UTC(2026, 8, 1, 14, 0);
  let l = 0;
  for (const d of e) {
    if (d.type !== "image") continue;
    const c = d, h = t.find((x) => dk(He(c), He(x))), f = h ? i.find((x) => dk(He(x), He(h))) : void 0;
    if (!f) continue;
    const p = s.find((x) => x.img === c.src) || s.find((x) => x.board === f.name), y = "r-" + c.id, v = o.get(c.id);
    c.resultId = y, c.sessionId = f.id, r.push({
      id: y,
      sessionId: f.id,
      status: "done",
      url: c.src,
      w: v ? v.pw : c.w,
      h: v ? v.ph : c.h,
      video: c.video,
      dur: c.dur,
      videoSrc: c.videoSrc,
      prompt: p ? p.prompt : "",
      model: p && p.model || f.model,
      author: p ? p.author : "KB",
      createdAt: a + l++ * 3.7 * 3600 * 1e3,
      label: c.label,
      fav: c.fav,
      refs: p ? p.inputs : [],
      parents: p ? p.inputs : []
    });
  }
  return { title: ia.title, elements: e, results: r };
}
function jW(n) {
  const e = /* @__PURE__ */ new Set();
  for (const t of n) {
    const i = t.type === "image" ? t.resultId : void 0;
    i && i.startsWith("r-") && !i.includes(":") && e.add(i);
  }
  return e.size ? Kl().results.filter((t) => e.has(t.id)) : [];
}
function dS() {
  const n = /* @__PURE__ */ new Set();
  for (const e of ia.elements) e.type === "image" && e.src && !e.video && n.add(e.src);
  return Array.from(n);
}
function HW() {
  return ia.elements.filter((n) => n.type === "image" && n.video && n.videoSrc).map((n) => ({ poster: n.src, src: n.videoSrc }));
}
function VW() {
  return ia.project.team || [];
}
const ck = 600;
function cS(n, e) {
  const t = n.elements.filter((p) => p.type === "image").length, i = Math.max(1, Math.ceil(Math.max(1, e) / Math.max(1, t)));
  let s = 1 / 0, o = 1 / 0, r = -1 / 0, a = -1 / 0;
  for (const p of n.elements) {
    const y = He(p);
    s = Math.min(s, y.x), o = Math.min(o, y.y), r = Math.max(r, y.x + y.w), a = Math.max(a, y.y + y.h);
  }
  const l = r - s, d = a - o, c = Math.max(1, Math.min(i, Math.round(Math.sqrt(i * 1.6 * d / l)))), h = Math.ceil(i / c), f = [];
  for (let p = 0; p < i; p++)
    f.push({ x: s + p % c * (l + ck), y: o + Math.floor(p / c) * (d + ck), w: l, h: d });
  return { perCopy: t, copies: i, cols: c, rows: h, tiles: f };
}
function uk(n) {
  return cS(Kl(), n);
}
function WW(n) {
  const e = Kl(), t = cS(e, n), { copies: i, tiles: s } = t;
  let o = 0;
  for (const d of e.elements) o = Math.max(o, d.z + 1);
  const r = [], a = [];
  for (let d = 0; d < i; d++) {
    const c = d === 0 ? "" : "~" + d, h = s[d].x - s[0].x, f = s[d].y - s[0].y;
    for (const p of e.elements) {
      const y = JSON.parse(JSON.stringify(p));
      y.id = p.id + c, y.x = p.x + h, y.y = p.y + f, y.z = p.z + d * o, y.resultId && (y.resultId += c), y.sessionId && (y.sessionId += c), y.type === "frame" && i > 1 && (y.title = y.title + " · " + (d + 1)), r.push(y);
    }
    for (const p of e.results) {
      const y = JSON.parse(JSON.stringify(p));
      y.id = p.id + c, y.sessionId = p.sessionId + c, a.push(y);
    }
  }
  return { title: "Stress test: " + (t.perCopy * i).toLocaleString("en-US") + " images", elements: r, results: a, layout: t };
}
function qW(n, e) {
  const t = [], i = [], s = dS(), o = 24, r = 6, a = 316, l = 26, d = Math.ceil(n / o), c = Math.max(1, Math.round(Math.sqrt(d * 0.7))), h = 300 + r * (a + l) + 60, f = Math.ceil(o / r);
  let p = 0, y = 0;
  for (let v = 0; v < d; v++) {
    const x = v % c * (h + 140), w = Math.floor(v / c) * (f * 300 + 260), S = f * 300 + 100;
    t.push({ id: "sf" + v, type: "frame", x, y: w, w: h, h: S, z: p++, title: "Study " + (v + 1) });
    const M = "st" + v, _ = [];
    for (let T = 0; T < o && y < n; T++, y++) {
      const k = T % r, P = Math.floor(T / r), A = [176, 211, 316, 236][(v + T) % 4], R = e ? "synthetic://" + (y + 1) + "/800x" + Math.round(800 * A / a) : s[y % s.length], D = "si" + y;
      t.push({
        id: D,
        type: "image",
        x: x + 300 + k * (a + l),
        y: w + 50 + P * 300,
        w: a,
        h: A,
        z: p++,
        src: R,
        label: "study_" + (v + 1) + "_v" + String(T + 1).padStart(2, "0"),
        resultId: "r-" + D,
        sessionId: M
      }), _.length < 4 && _.push(R), i.push({
        id: "r-" + D,
        sessionId: M,
        status: "done",
        url: R,
        w: a,
        h: A,
        prompt: "Study " + (v + 1) + ", variation " + (T + 1),
        model: "Nano Banana 2",
        createdAt: Date.now() - y * 6e4,
        label: "study_" + (v + 1) + "_v" + String(T + 1).padStart(2, "0")
      });
    }
    t.push({
      id: M,
      type: "tool",
      x: x + 30,
      y: w + 50,
      w: 252,
      h: 160,
      z: p++,
      name: "Study " + (v + 1),
      kind: "Image",
      kitId: "image",
      model: "Nano Banana 2",
      icon: "Image",
      count: o,
      thumbs: _,
      up: {}
    }), v % 3 === 0 && t.push({
      id: "sn" + v,
      type: "note",
      x: x + 30,
      y: w + 260,
      w: 184,
      h: 184,
      z: p++,
      tint: ["amethyst", "vista", "glass"][v % 3],
      text: "Review notes for study " + (v + 1) + ".",
      author: "KB"
    }), v % 4 === 1 && t.push({
      id: "ss" + v,
      type: "shape",
      shape: "arrow",
      x: x + 120,
      y: w + 470,
      w: 160,
      h: 0,
      z: p++,
      stroke: "#a3a7f5",
      sw: 4,
      sc: [0, 0]
    });
  }
  return { title: n + " image benchmark", elements: t, results: i };
}
function uS(n) {
  return n === "INIT" || n === "QUEUED";
}
function KW(n) {
  return n === "DONE" || n === "ERROR" || n === "NSFW";
}
const hk = 512;
function pk(n, e) {
  return "thumbs/" + n.replace(/\.[^/.]+$/, `_${hk}x${hk}.${e}`);
}
function q1(n) {
  const e = n.templateOriginalData || null, t = e && e.nodeRunId || n.nodeRunId || "", i = e && e.teamId || n.teamId || null, s = e && e.userId || n.userId || "", o = i ? `runnitResults/teams/${i}/runs/${t}/` : `runnitResults/users/${s}/runs/${t}/`, r = n.type === "LAYERS" && n.displayFile ? n.displayFile : n.file, a = r && r.name || "", l = n.downloadFile && n.downloadFile.name ? o + n.downloadFile.name : null;
  return { file: o + a, thumb: o + pk(a, "webp"), mp4: o + pk(a, "mp4"), download: l };
}
function K1(n) {
  return (n.teamId ? `runnitUploads/teams/${n.teamId}/uploads/` : `runnitUploads/users/${n.userId || ""}/uploads/`) + (n.name || "");
}
function hS(n) {
  const e = n.teamId ? `avatars/teams/${n.teamId}/uploads/` : `avatars/users/${n.userId || ""}/uploads/`, t = n.name || "avatar";
  return { file: e + t, thumb: e + "thumbs/" + t.replace(/\.[^/.]+$/, "_256x256.webp") };
}
function YW(n) {
  return "nodeRunResult" in n ? q1(n.nodeRunResult).file : "upload" in n ? K1(n.upload) : null;
}
function* pS(n) {
  for (const e of n || []) {
    const t = e;
    t && (t.__rgroup ? yield* pS(t.fields) : t.__rfield && (yield t));
  }
}
function XW(n) {
  return typeof n == "string" ? n : n && typeof n == "object" && "value" in n ? String(n.value || "") : "";
}
function JW(n) {
  let e = "", t = null;
  const i = n.inputs || {};
  for (const s of pS(n.fields)) {
    const o = String(s.fieldDefUuid || s.uuid || "");
    !e && s.type === "PROMPT" && (e = XW(i[o])), t == null && s.type === "SEED" && Number.isFinite(Number(i[o])) && (t = Number(i[o]));
  }
  return { prompt: e, seed: t };
}
function ZW(n) {
  const e = [], t = (i) => {
    if (!i || typeof i != "object") return;
    const s = i;
    s.nodeRunResult && typeof s.nodeRunResult == "object" ? e.push(q1(s.nodeRunResult).file) : s.upload && typeof s.upload == "object" && e.push(K1(s.upload));
    for (const o of ["image", "video"]) s[o] && t(s[o]);
    for (const o of ["uploads", "nodeRunResults"]) {
      const r = s[o];
      if (Array.isArray(r)) for (const a of r) t(o === "uploads" ? { upload: a } : { nodeRunResult: a });
    }
  };
  for (const i of Object.values(n.inputs || {})) t(i);
  return e;
}
function uf(n, e, t) {
  const i = t.split("?")[0], s = i.lastIndexOf("."), o = s > i.lastIndexOf("/") && s > i.lastIndexOf("%2F") ? i.slice(s) : "", r = String(n || "").replace(/@{MODEL-(\S{12,36})}/g, "MODEL").slice(0, 100).replace(/[^a-zA-Z0-9_-]+/g, "_").replace(/^_+|_+$/g, "");
  return (r ? r + "-" + e : e) + o;
}
function QW(n) {
  if (!n || !Number.isFinite(n)) return;
  const e = Math.round(n);
  return Math.floor(e / 60) + ":" + String(e % 60).padStart(2, "0");
}
function eq(n, e) {
  return (String(n || "result").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").trim().split(/\s+/).slice(0, 4).join("_") || "result").slice(0, 24) + "_v" + String(e + 1).padStart(2, "0");
}
function tq(n) {
  return n.initAt && n.doneAt && n.doneAt >= n.initAt ? n.doneAt - n.initAt : void 0;
}
function fS(n, e) {
  if (n.deletedAt) return [];
  const { prompt: t, seed: i } = JW(n), s = n.initAt || Date.now(), o = {
    sessionId: n.nodeId,
    prompt: t,
    model: e.modelName(n.nodeDefId),
    modelId: n.nodeDefId,
    inputs: n.inputs,
    refs: ZW(n).map((a) => e.storageUrl(a)),
    seed: i,
    author: e.authorName(n.userId, n.email),
    userId: n.userId,
    authorEmail: n.email,
    runId: n.id
  };
  if (uS(n.state)) {
    const a = Math.max(1, Number(n.staticInputs && n.staticInputs.numResults) || 1), l = [];
    for (let d = 0; d < a; d++)
      l.push({ ...o, id: `${n.id}:p${d}`, status: "pending", url: "", w: 0, h: 0, createdAt: s + d, startedAt: s });
    return l;
  }
  if (n.state !== "DONE" && n.state !== "NSFW") return [];
  const r = [];
  return (n.results || []).forEach((a, l) => {
    if (!a || a.deletedAt) return;
    const d = q1({ ...a, nodeRunId: a.nodeRunId || n.id, userId: a.userId || n.userId, teamId: a.teamId !== void 0 ? a.teamId : n.teamId }), c = a.type === "LAYERS" && a.displayFile || a.file || {}, h = a.type === "VID", f = a.type === "ASSET_3D" || a.type === "MODEL", p = f ? Lj(c.name) : null, y = p ? Qw : c.width || 1024, v = p ? Qw : c.height || (c.aspectRatio ? Math.round(y / c.aspectRatio) : y);
    r.push({
      ...o,
      id: `${n.id}:${a.uuid}`,
      uuid: a.uuid,
      status: a.isNsfw ? "moderated" : "done",
      kind: h ? "video" : f ? "3d" : a.type === "LAYERS" ? "layers" : "image",
      // a video shows its first frame and a 3D model its preview until opened
      url: p ? Nj(p, `${n.id}:${a.uuid}`) : e.storageUrl(h || f ? d.thumb : d.file),
      thumb: h || f ? void 0 : e.storageUrl(d.thumb),
      video: h || void 0,
      videoSrc: h ? e.storageUrl(d.file) : void 0,
      previewSrc: h ? e.storageUrl(d.mp4) : void 0,
      dur: h ? QW(c.duration) : void 0,
      download: f ? e.storageUrl(d.file) : d.download ? e.storageUrl(d.download) : void 0,
      w: y,
      h: v,
      createdAt: (n.initAt || n.doneAt || 0) + l,
      took: tq(n),
      doneAt: n.doneAt,
      label: eq(t, l),
      asset: { nodeRunResult: { ...a, nodeRunId: a.nodeRunId || n.id } }
    });
  }), r;
}
const nq = ["disabled"], iq = ["disabled"], sq = ["src", "poster", "aria-label"], oq = ["src"], rq = ["src", "alt"], aq = { class: "knob" }, lq = { class: "tag at-left" }, dq = {
  key: 2,
  class: "v2-info-pair-view",
  "data-testid": "info-compare"
}, cq = { class: "pic" }, uq = ["src"], hq = { class: "pic" }, pq = ["src", "alt"], fq = ["src", "alt"], mq = {
  key: 4,
  class: "v2-info-play",
  "aria-hidden": "true"
}, gq = { class: "v2-info-zoom" }, bq = ["aria-expanded"], vq = {
  key: 5,
  class: "v2-info-cmp-menu",
  role: "menu",
  "data-testid": "info-compare-menu"
}, yq = ["data-testid", "onClick"], xq = { class: "v2-info-side" }, wq = { class: "v2-info-top" }, kq = ["title"], _q = ["title"], Sq = ["title"], Mq = {
  key: 0,
  class: "v2-info-confirm"
}, Tq = {
  key: 0,
  class: "v2-info-card is-form"
}, Cq = {
  key: 1,
  class: "v2-info-card is-record"
}, Iq = { class: "v2-info-strip" }, Aq = { class: "n" }, Pq = { class: "when" }, Eq = ["title", "aria-pressed"], Rq = ["title", "aria-pressed"], zq = { class: "v2-info-block" }, $q = { class: "v2-info-block-head" }, Dq = {
  key: 0,
  class: "v2-info-prompt is-reading",
  "data-testid": "info-reading"
}, Oq = {
  key: 0,
  class: "v2-info-specs",
  "data-testid": "info-settings"
}, Lq = ["title", "onClick", "onKeydown"], Bq = ["title"], Fq = {
  key: 1,
  class: "v2-info-specs"
}, Nq = {
  key: 1,
  class: "none"
}, Uq = {
  key: 1,
  class: "none"
}, Gq = ["title"], jq = { class: "body" }, Hq = { class: "v2-info-acts" }, Vq = { class: "v2-info-pair" }, Wq = /* @__PURE__ */ Pe({
  __name: "ImageInfoModal",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(1), i = /* @__PURE__ */ W(!1), s = /* @__PURE__ */ W(""), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(1.3), a = I(() => {
      e.docRev.value, e.results.rev.value;
      const V = e.ui.infoAt;
      if (!V) return null;
      if (V.startsWith("result:")) {
        const Le = e.results.get(V.slice(7)) || null;
        return Le ? { el: null, result: Le } : null;
      }
      const X = e.store.get(V);
      if (!X || X.type !== "image") return null;
      const le = X;
      return { el: { ...le }, result: le.resultId && e.results.get(le.resultId) || null };
    }), l = I(() => !!e.ui.infoSession), d = I(() => {
      e.docRev.value, e.results.rev.value;
      const V = e.ui.infoSession;
      if (V) {
        const X = /* @__PURE__ */ new Map();
        for (const le of e.store.all()) {
          const Le = le.type === "image" ? le.resultId : void 0;
          Le && !X.has(Le) && X.set(Le, le.id);
        }
        return e.results.list(V).filter((le) => le.status === "done").map((le) => ({ key: X.get(le.id) || "result:" + le.id }));
      }
      return e.imagesInOrder().map((X) => ({ key: X.id }));
    }), c = I(() => {
      const V = e.ui.infoAt, X = d.value.findIndex((Le) => Le.key === V);
      if (X >= 0 || !V || !V.startsWith("result:")) return X;
      const le = e.placedFor(V.slice(7));
      return le ? d.value.findIndex((Le) => Le.key === le.id) : -1;
    }), h = I(() => a.value ? a.value.el ? a.value.el.src : a.value.result.url : ""), f = I(() => a.value && (a.value.el ? a.value.el.w : a.value.result.w) || 4), p = I(() => a.value && (a.value.el ? a.value.el.h : a.value.result.h) || 3), y = I(() => !!(a.value && (a.value.el && a.value.el.video || a.value.result && a.value.result.video))), v = I(() => {
      const V = a.value;
      return !V || !y.value ? "" : V.el && V.el.videoSrc || V.result && V.result.videoSrc || "";
    }), x = I(() => a.value ? a.value.el && a.value.el.label || a.value.result && a.value.result.label || "image" : ""), w = I(() => !!a.value && e.isFav(a.value.result, a.value.el)), S = I(() => !!a.value && e.canFav(a.value.result, a.value.el)), M = I(() => {
      const V = a.value;
      if (!V) return null;
      if (V.el) return e.toolFor(V.el);
      const X = e.store.get(V.result.sessionId);
      return X && X.type === "tool" ? X : null;
    }), _ = I(() => a.value ? a.value.result : null), T = I(() => {
      const V = a.value;
      return V && V.el && V.el.resultId && !V.result ? V.el.resultId : null;
    });
    Ee(T, (V) => {
      V && e.loadRecord(V);
    }, { immediate: !0 });
    const k = I(() => !!T.value && e.readingRecord(T.value)), P = VW(), A = I(() => {
      const V = _.value;
      if (V && V.userId) {
        const ve = V.userId === e.user.uid, _e = (ve ? e.user.email : V.authorEmail) || V.author || "Someone else", De = ve && e.user.name || _e;
        return { initials: ve && e.user.initials || ga(De), name: De, mail: _e };
      }
      const X = V && V.author || e.user.initials || "YOU", le = P.find((ve) => ve.initials === X), Le = le ? le.name : V && V.author && V.author !== e.user.initials ? V.author : e.user.name || "You";
      return { initials: X, name: Le, mail: le ? le.name.split(" ")[0].toLowerCase() + "@rundiffusion.com" : e.user.email || Le };
    }), R = I(() => _.value ? R1(_.value.createdAt) : k.value ? "" : "Not recorded"), D = I(() => {
      const V = _.value, X = V && V.modelId ? e.toolModel(V.modelId) : null;
      return X && X.name || (V && V.model !== "Tool" ? V.model : "") || M.value && M.value.model || (k.value ? "" : "Not recorded");
    }), O = I(() => _.value ? "No prompt: this run didn't use one." : T.value ? "Its run's record couldn't be read." : "No prompt recorded: this image was placed on the board rather than generated here."), F = I(() => EL(f.value, p.value)), ie = I(() => /upgrade|upscal|editorial|print/i.test(x.value) ? "4K" : y.value ? "1080p" : "1K"), ee = I(() => _.value && _.value.refs || []), me = I(() => {
      const V = _.value;
      if (!V || !V.inputs || !V.modelId) return null;
      const X = e.catalog.value.byId.get(V.modelId), le = [];
      if (V.w && V.h && V.status === "done" && le.push({ label: "Size", value: V.w + " × " + V.h + (V.dur ? " · " + V.dur : "") }), V.took && le.push({ label: "Generation time", value: AL(V.took) }), X)
        for (const Le of X.fields) {
          if (Le.placement === "prompt" || Le.placement === "reference" || Le.kind === "header") continue;
          const ve = V.inputs[Le.key];
          ve == null || ve === "" || le.push({ label: Le.label || "Setting", value: L(Le, ve) });
        }
      return le;
    });
    function L(V, X) {
      if (typeof X == "boolean") return X ? "On" : "Off";
      const le = (V.options || []).find((Le) => Qi(Le.value, X));
      if (le) return le.label;
      if (X && typeof X == "object") {
        const Le = X;
        return Le.width && Le.height ? Le.width + " × " + Le.height : Le.value !== void 0 ? String(Le.value) : Le.model && Le.model.name ? Le.model.name : "";
      }
      return String(X);
    }
    const N = I(() => {
      const V = _.value, X = ee.value;
      if (!V || !V.modelId || !X.length) return [];
      const le = e.catalog.value.byId.get(V.modelId), Le = le ? le.fields.filter((ve) => ve.placement === "reference").map((ve) => ve.label) : [];
      return X.slice(0, 4).map((ve, _e) => ({ label: Le[_e] || "Input " + (_e + 1), url: ve }));
    }), K = I(() => {
      if (y.value) return [];
      const V = [], X = (Qe) => {
        Qe.url && Qe.url !== h.value && !V.some((ft) => ft.url === Qe.url) && V.push(Qe);
      }, le = N.value;
      ee.value.forEach((Qe, ft) => X({ key: "in:" + ft, label: le[ft] && le[ft].label || "Image " + (ft + 1), url: Qe }));
      const Le = _.value;
      for (const Qe of Le && Le.parents || []) {
        const ft = e.results.get(Qe);
        ft && ft.url && !ft.video && X({ key: "from:" + Qe, label: "What it was made from", url: ft.url });
      }
      const ve = d.value, _e = c.value, De = _e >= 0 && _e + 1 < ve.length ? ve[_e + 1].key : null;
      if (De) {
        const Qe = De.startsWith("result:") ? e.results.get(De.slice(7)) : null, ft = Qe ? null : e.store.get(De), Dn = Qe ? Qe.video ? "" : Qe.url : ft && ft.type === "image" && !ft.video ? ft.src : "";
        Dn && X({ key: "prev", label: "The one before", url: Dn });
      }
      return V;
    }), B = /* @__PURE__ */ W(null), re = /* @__PURE__ */ W("split"), H = /* @__PURE__ */ W(0.5), J = /* @__PURE__ */ W(!1), Q = /* @__PURE__ */ W(null);
    function ne(V) {
      B.value = V, J.value = !1, H.value = 0.5, t.value = 1;
    }
    function ue() {
      B.value = null, J.value = !1;
    }
    function Z(V) {
      const X = Q.value;
      if (!X || re.value !== "split") return;
      V.preventDefault(), X.setPointerCapture(V.pointerId);
      const le = (_e) => {
        const De = X.getBoundingClientRect();
        H.value = Math.min(0.98, Math.max(0.02, (_e.clientX - De.left) / Math.max(1, De.width)));
      };
      le(V);
      const Le = (_e) => le(_e), ve = () => {
        X.removeEventListener("pointermove", Le), X.removeEventListener("pointerup", ve), X.removeEventListener("pointercancel", ve);
      };
      X.addEventListener("pointermove", Le), X.addEventListener("pointerup", ve), X.addEventListener("pointercancel", ve);
    }
    const te = I(() => e.canDelete(_.value)), we = /* @__PURE__ */ W(!1);
    async function Fe() {
      const V = _.value;
      if (!V) return;
      if (!we.value) {
        we.value = !0;
        return;
      }
      we.value = !1;
      const X = e.ui.infoAt, le = e.ui.infoSession;
      if (l.value) {
        const ve = d.value, _e = c.value;
        e.ui.infoAt = ve.length > 1 && _e >= 0 ? ve[_e + 1 < ve.length ? _e + 1 : _e - 1].key : null;
      }
      const Le = e.ui.infoAt;
      !await e.deleteResult(V) && e.ui.infoAt === Le && (e.ui.infoSession = le, e.ui.infoAt = X);
    }
    const Me = /* @__PURE__ */ W(null), { more: he, measure: U } = aS(Me);
    Ee(() => e.ui.infoAt, (V, X) => {
      t.value = 1, ue(), i.value = !1, we.value = !1, Me.value && (Me.value.scrollTop = 0), X && V !== X && (e.ui.infoSave = !1);
    });
    const q = I(() => e.promptLibrary.canSave && !!_.value && !!_.value.prompt && _.value.status === "done"), oe = /* @__PURE__ */ qe(null);
    Ee(() => [e.ui.infoSave, _.value ? _.value.id : null], ([V]) => {
      const X = _.value;
      oe.value = V && X && q.value ? e.promptLibrary.draftForResult(X) : null;
    }, { immediate: !0 });
    function de() {
      e.ui.infoSave = !0;
    }
    function pe() {
      e.ui.infoSave = !1;
    }
    function Ce(V) {
      const X = d.value;
      if (!X.length) return;
      const le = c.value < 0 ? 0 : (c.value + V + X.length) % X.length;
      e.ui.infoAt = X[le].key, l.value || (e.ui.selection = [X[le].key]);
    }
    function Be(V) {
      if (!(V.target.tagName === "INPUT" || V.target.tagName === "TEXTAREA")) {
        if (V.key === "Escape" && (B.value || J.value)) {
          V.stopPropagation(), ue();
          return;
        }
        V.key === "ArrowRight" ? Ce(1) : V.key === "ArrowLeft" ? Ce(-1) : V.key === "+" || V.key === "=" ? t.value = Math.min(2, +(t.value + 0.2).toFixed(2)) : V.key === "-" && (t.value = Math.max(0.6, +(t.value - 0.2).toFixed(2)));
      }
    }
    let be = null;
    it(() => {
      window.addEventListener("keydown", Be, !0), o.value && (be = new ResizeObserver(() => {
        if (!o.value) return;
        const V = o.value.getBoundingClientRect();
        V.height && (r.value = V.width / V.height);
      }), be.observe(o.value));
    }), We(() => {
      window.removeEventListener("keydown", Be, !0), be && be.disconnect(), e.ui.infoSession = null;
    });
    function se() {
      const V = _.value ? _.value.prompt : "";
      try {
        navigator.clipboard.writeText(V).catch(() => {
        });
      } catch {
      }
      i.value = !0, setTimeout(() => {
        i.value = !1;
      }, 1400);
    }
    function ae() {
      e.ui.infoAt = null;
    }
    function ye() {
      const V = a.value;
      V && (V.el ? e.toggleFav(V.el.id) : V.result && e.toggleResultFav(V.result));
    }
    const Oe = I(() => !!h.value && e.isPinnedImage(h.value));
    function Ve() {
      const V = a.value;
      V && e.togglePinImage(V.el ? g8(V.el, V.result) : um(V.result));
    }
    const Ue = I(() => {
      e.docRev.value;
      const V = a.value;
      return V ? V.el ? V.el : V.result ? e.placedFor(V.result.id) : null : null;
    });
    function tt() {
      const V = a.value;
      if (!V) return;
      const X = Ue.value;
      if (X) {
        e.ui.infoAt = null, e.ui.selection = [X.id], e.jumpTo(X.x + X.w / 2, X.y + X.h / 2, Math.max(e.cam.value.zoom, 0.6));
        return;
      }
      V.result && (e.ui.infoAt = null, e.placeResult(V.result));
    }
    function Ye() {
      const V = a.value;
      if (!V) return;
      const X = V.el || { id: "", type: "image", x: 0, y: 0, w: f.value, h: p.value, z: 0, src: h.value, video: y.value };
      e.remixFrom(X, _.value);
    }
    function at() {
      const V = a.value;
      if (!V) return;
      const X = _.value, le = X && X.download || V.el && V.el.download || v.value || h.value, Le = X && X.uuid ? uf(X.prompt, X.uuid, le) : x.value;
      e.saveFile(le, Le), X && X.runId && e.trackDownload(X);
    }
    function kt() {
      const V = M.value;
      !V || !e.store.get(V.id) || (e.ui.infoAt = null, e.openSession(V));
    }
    const $e = I(() => !y.value && !!a.value);
    function Ne() {
      const V = a.value;
      V && (V.result ? e.openStudio({ resultId: V.result.id }) : V.el && e.openStudio({ elementId: V.el.id }));
    }
    return (V, X) => a.value ? (g(), b("div", {
      key: 0,
      class: "v2-info",
      "data-testid": "info-modal",
      onPointerdown: Te(ae, ["self"])
    }, [
      u("button", {
        class: "v2-info-nav at-left",
        title: "Previous",
        disabled: d.value.length < 2,
        onClick: X[0] || (X[0] = (le) => Ce(-1))
      }, [
        C($, {
          name: "ChevronLeft",
          size: 22
        })
      ], 8, nq),
      u("button", {
        class: "v2-info-nav at-right",
        title: "Next",
        disabled: d.value.length < 2,
        onClick: X[1] || (X[1] = (le) => Ce(1))
      }, [
        C($, {
          name: "ChevronRight",
          size: 22
        })
      ], 8, iq),
      u("div", {
        class: "v2-info-shell",
        onPointerdown: X[11] || (X[11] = Te(() => {
        }, ["stop"]))
      }, [
        u("div", {
          ref_key: "stage",
          ref: o,
          class: "v2-info-stage"
        }, [
          v.value ? (g(), b("video", {
            key: v.value,
            class: G(["v2-info-art is-video", { "is-loading": s.value !== h.value }]),
            src: v.value,
            poster: h.value,
            "aria-label": x.value,
            style: ce({
              width: f.value / p.value > r.value ? "calc(100% - 36px)" : "auto",
              height: f.value / p.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: f.value + " / " + p.value,
              transform: "scale(" + t.value + ")"
            }),
            "data-testid": "info-video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            controls: "",
            controlslist: "nodownload noplaybackrate",
            disablepictureinpicture: "",
            onLoadeddata: X[2] || (X[2] = (le) => s.value = h.value)
          }, null, 46, sq)) : B.value && re.value === "split" ? (g(), b("div", {
            key: 1,
            ref_key: "cmpBox",
            ref: Q,
            class: "v2-info-cmp",
            style: ce({
              width: f.value / p.value > r.value ? "calc(100% - 36px)" : "auto",
              height: f.value / p.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: f.value + " / " + p.value
            }),
            "data-testid": "info-compare",
            onPointerdown: Z
          }, [
            u("img", {
              class: "under",
              src: B.value.url,
              alt: "",
              draggable: "false"
            }, null, 8, oq),
            u("img", {
              class: "over",
              src: h.value,
              alt: x.value,
              draggable: "false",
              style: ce({ clipPath: "inset(0 0 0 " + (H.value * 100).toFixed(2) + "%)" })
            }, null, 12, rq),
            u("span", {
              class: "line",
              style: ce({ left: (H.value * 100).toFixed(2) + "%" })
            }, [
              u("span", aq, [
                C($, {
                  name: "ChevronLeft",
                  size: 12
                }),
                C($, {
                  name: "ChevronRight",
                  size: 12
                })
              ])
            ], 4),
            u("span", lq, E(B.value.label), 1),
            X[12] || (X[12] = u("span", { class: "tag at-right" }, "This one", -1))
          ], 36)) : B.value ? (g(), b("div", dq, [
            u("figure", null, [
              u("span", cq, [
                u("img", {
                  src: B.value.url,
                  alt: "",
                  draggable: "false"
                }, null, 8, uq),
                u("figcaption", null, E(B.value.label), 1)
              ])
            ]),
            u("figure", null, [
              u("span", hq, [
                u("img", {
                  src: h.value,
                  alt: x.value,
                  draggable: "false"
                }, null, 8, pq),
                X[13] || (X[13] = u("figcaption", null, "This one", -1))
              ])
            ])
          ])) : (g(), b("img", {
            key: h.value,
            class: G(["v2-info-art", { "is-loading": s.value !== h.value }]),
            src: h.value,
            alt: x.value,
            style: ce({
              width: f.value / p.value > r.value ? "calc(100% - 36px)" : "auto",
              height: f.value / p.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: f.value + " / " + p.value,
              transform: "scale(" + t.value + ")"
            }),
            draggable: "false",
            onLoad: X[3] || (X[3] = (le) => s.value = h.value)
          }, null, 46, fq)),
          y.value && !v.value ? (g(), b("span", mq, [
            C($, {
              name: "Play",
              size: 24
            })
          ])) : z("", !0),
          u("div", gq, [
            B.value ? (g(), b(j, { key: 0 }, [
              u("button", {
                class: G(["is-word", { on: re.value === "split" }]),
                "data-testid": "info-compare-split",
                onClick: X[4] || (X[4] = (le) => re.value = "split")
              }, "Split", 2),
              u("button", {
                class: G(["is-word", { on: re.value === "side" }]),
                "data-testid": "info-compare-side",
                onClick: X[5] || (X[5] = (le) => re.value = "side")
              }, "Side by side", 2),
              X[14] || (X[14] = u("i", { class: "sep" }, null, -1)),
              u("button", {
                class: "is-word",
                title: "Stop comparing (Esc)",
                "data-testid": "info-compare-done",
                onClick: ue
              }, "Done")
            ], 64)) : (g(), b(j, { key: 1 }, [
              u("button", {
                title: "Zoom out",
                onClick: X[6] || (X[6] = (le) => t.value = Math.max(0.6, +(t.value - 0.2).toFixed(2)))
              }, [
                C($, {
                  name: "Minus",
                  size: 13
                })
              ]),
              u("span", null, E(Math.round(t.value * 100)) + "%", 1),
              u("button", {
                title: "Zoom in",
                onClick: X[7] || (X[7] = (le) => t.value = Math.min(2, +(t.value + 0.2).toFixed(2)))
              }, [
                C($, {
                  name: "Plus",
                  size: 13
                })
              ]),
              K.value.length ? (g(), b(j, { key: 0 }, [
                X[16] || (X[16] = u("i", { class: "sep" }, null, -1)),
                u("button", {
                  class: G(["is-word", { on: J.value }]),
                  "aria-expanded": J.value,
                  title: "Compare it with what it was made from",
                  "data-testid": "info-compare-open",
                  onClick: X[8] || (X[8] = (le) => J.value = !J.value)
                }, [
                  C($, {
                    name: "Columns2",
                    size: 13
                  }),
                  X[15] || (X[15] = Y(" Compare ", -1))
                ], 10, bq)
              ], 64)) : z("", !0)
            ], 64))
          ]),
          J.value && !B.value ? (g(), b("div", vq, [
            X[17] || (X[17] = u("div", { class: "hd" }, "Compare with", -1)),
            (g(!0), b(j, null, ge(K.value, (le) => (g(), b("button", {
              key: le.key,
              role: "menuitem",
              class: "row",
              "data-testid": "info-compare-" + le.key,
              onClick: (Le) => ne(le)
            }, [
              u("span", {
                class: "pic",
                style: ce({ backgroundImage: 'url("' + m(Bt)(le.url) + '"), url("' + le.url + '")' })
              }, null, 4),
              u("span", null, E(le.label), 1)
            ], 8, yq))), 128))
          ])) : z("", !0)
        ], 512),
        u("div", xq, [
          u("div", wq, [
            u("span", {
              class: "v2-info-avatar",
              title: A.value.name
            }, E(A.value.initials), 9, kq),
            u("span", {
              class: "v2-info-mail",
              title: A.value.name
            }, E(A.value.mail), 9, _q),
            u("button", {
              class: "v2-info-act",
              title: "Download",
              "data-testid": "info-download",
              onClick: at
            }, [
              C($, {
                name: "Download",
                size: 14
              })
            ]),
            te.value ? (g(), b("button", {
              key: 0,
              class: G(["v2-info-act is-danger", { "is-confirming": we.value }]),
              title: we.value ? "Click again to delete it from this session's history" + (Ue.value ? " (its card stays on the board)" : "") : "Delete from history",
              "data-testid": "info-delete",
              onClick: Fe,
              onBlur: X[9] || (X[9] = (le) => we.value = !1)
            }, [
              C($, {
                name: we.value ? "Check" : "Trash2",
                size: 14
              }, null, 8, ["name"]),
              we.value ? (g(), b("span", Mq, "Delete?")) : z("", !0)
            ], 42, Sq)) : z("", !0),
            u("button", {
              class: "v2-info-act",
              title: "Close",
              "data-testid": "info-close",
              onClick: ae
            }, [
              C($, {
                name: "X",
                size: 14
              })
            ])
          ]),
          m(e).ui.infoSave && oe.value ? (g(), b("div", Tq, [
            (g(), Ie(lS, {
              key: oe.value.output.url,
              draft: oe.value,
              "editing-id": null,
              onDone: pe,
              onCancel: pe
            }, null, 8, ["draft"]))
          ])) : (g(), b("div", Cq, [
            u("div", {
              ref_key: "detailsEl",
              ref: Me,
              class: G(["v2-info-scroll", { "is-more": m(he) }]),
              onScrollPassive: X[10] || (X[10] = //@ts-ignore
              (...le) => m(U) && m(U)(...le))
            }, [
              u("div", Iq, [
                u("span", Aq, [
                  C($, {
                    name: "Images",
                    size: 13
                  }),
                  Y(" " + E(c.value >= 0 ? c.value + 1 : "–") + " of " + E(d.value.length), 1)
                ]),
                u("span", Pq, E(R.value), 1),
                u("button", {
                  class: G(["v2-info-star is-pin", { on: Oe.value }]),
                  title: Oe.value ? m(Xn).unpin : "Pin for yourself: one click away under Pinned, and only you see your pins",
                  "aria-pressed": Oe.value,
                  "data-testid": "info-pin",
                  onClick: Ve
                }, [
                  C($, {
                    name: "Pin",
                    size: 15
                  })
                ], 10, Eq),
                S.value ? (g(), b("button", {
                  key: 0,
                  class: G(["v2-info-star", { on: w.value }]),
                  title: w.value ? "Remove from your favorites" : "Add to your favorites",
                  "aria-pressed": w.value,
                  "data-testid": "info-fav",
                  onClick: ye
                }, [
                  C($, {
                    name: "Heart",
                    size: 15
                  })
                ], 10, Rq)) : z("", !0)
              ]),
              u("div", zq, [
                u("div", $q, [
                  u("span", null, [
                    C($, {
                      name: "MessageSquare",
                      size: 13
                    }),
                    X[18] || (X[18] = Y(" Prompt", -1))
                  ]),
                  _.value && _.value.prompt ? (g(), b("button", {
                    key: 0,
                    title: "Copy prompt",
                    onClick: se
                  }, [
                    C($, {
                      name: i.value ? "Check" : "Clipboard",
                      size: 13
                    }, null, 8, ["name"])
                  ])) : z("", !0)
                ]),
                k.value && !_.value ? (g(), b("p", Dq, "Loading its record…")) : (g(), b("p", {
                  key: 1,
                  class: G(["v2-info-prompt", { "is-none": !(_.value && _.value.prompt) }]),
                  "data-testid": "info-prompt"
                }, E(_.value && _.value.prompt ? _.value.prompt : O.value), 3))
              ]),
              me.value ? (g(), b("div", Oq, [
                (g(!0), b(j, null, ge(N.value, (le, Le) => (g(), b("div", {
                  key: le.label + le.url
                }, [
                  u("span", null, E(le.label), 1),
                  u("em", {
                    class: "is-compare",
                    role: "button",
                    tabindex: "0",
                    title: "Compare with " + le.label,
                    style: ce({ backgroundImage: 'url("' + m(Bt)(le.url) + '")' }),
                    onClick: (ve) => ne({ key: "in:" + Le, label: le.label, url: le.url }),
                    onKeydown: tn((ve) => ne({ key: "in:" + Le, label: le.label, url: le.url }), ["enter"])
                  }, null, 44, Lq)
                ]))), 128)),
                (g(!0), b(j, null, ge(me.value, (le) => (g(), b("div", {
                  key: le.label
                }, [
                  u("span", null, E(le.label), 1),
                  u("b", {
                    title: le.value
                  }, E(le.value), 9, Bq)
                ]))), 128)),
                u("div", null, [
                  X[19] || (X[19] = u("span", null, "Session", -1)),
                  u("b", null, E(M.value ? M.value.name : "Removed"), 1)
                ])
              ])) : (g(), b("div", Fq, [
                u("div", null, [
                  X[20] || (X[20] = u("span", null, "Image to edit", -1)),
                  ee.value[0] ? (g(), b("em", {
                    key: 0,
                    style: ce({ backgroundImage: 'url("' + m(Bt)(ee.value[0]) + '")' })
                  }, null, 4)) : (g(), b("b", Nq, "none"))
                ]),
                u("div", null, [
                  X[21] || (X[21] = u("span", null, "Second image", -1)),
                  ee.value[1] ? (g(), b("em", {
                    key: 0,
                    style: ce({ backgroundImage: 'url("' + m(Bt)(ee.value[1]) + '")' })
                  }, null, 4)) : (g(), b("b", Uq, "none"))
                ]),
                u("div", null, [
                  X[22] || (X[22] = u("span", null, "Aspect ratio", -1)),
                  u("b", null, E(F.value), 1)
                ]),
                u("div", null, [
                  X[23] || (X[23] = u("span", null, "Resolution", -1)),
                  u("b", null, E(ie.value), 1)
                ]),
                u("div", null, [
                  X[24] || (X[24] = u("span", null, "File", -1)),
                  u("b", { title: x.value }, E(x.value), 9, Gq)
                ]),
                u("div", null, [
                  X[25] || (X[25] = u("span", null, "Session", -1)),
                  u("b", null, E(M.value ? M.value.name : "None"), 1)
                ])
              ])),
              (g(), Ie(da(M.value && m(e).store.get(M.value.id) ? "button" : "div"), {
                class: "v2-info-tool",
                title: M.value && m(e).store.get(M.value.id) ? "Open this session" : void 0,
                onClick: kt
              }, {
                default: Xe(() => [
                  u("span", {
                    class: "thumb",
                    style: ce({ backgroundImage: 'url("' + m(Bt)(M.value && M.value.thumbs && M.value.thumbs[0] || h.value) + '")' })
                  }, null, 4),
                  u("span", jq, [
                    X[26] || (X[26] = u("em", null, "Tool", -1)),
                    u("b", null, E(D.value), 1)
                  ]),
                  M.value && m(e).store.get(M.value.id) ? (g(), Ie($, {
                    key: 0,
                    class: "go",
                    name: "ChevronRight",
                    size: 15
                  })) : z("", !0)
                ]),
                _: 1
              }, 8, ["title"]))
            ], 34),
            u("div", Hq, [
              u("button", {
                class: "v2-info-place",
                "data-testid": "info-place",
                onClick: tt
              }, [
                Ue.value ? (g(), b(j, { key: 0 }, [
                  C($, {
                    name: "LocateFixed",
                    size: 15
                  }),
                  X[27] || (X[27] = Y(" Find it on the board", -1))
                ], 64)) : (g(), b(j, { key: 1 }, [
                  C($, {
                    name: "ArrowDownToLine",
                    size: 15
                  }),
                  X[28] || (X[28] = Y(" Place on the board", -1))
                ], 64))
              ]),
              u("div", Vq, [
                u("button", {
                  class: "v2-info-remix",
                  onClick: Ye
                }, [
                  C($, {
                    name: "Repeat",
                    size: 14
                  }),
                  Y(" Remix this " + E(y.value ? "video" : "image"), 1)
                ]),
                q.value ? (g(), b("button", {
                  key: 0,
                  class: "v2-info-remix",
                  title: "Save its prompt, tool, settings and images to the prompt library",
                  "data-testid": "info-save-prompt",
                  onClick: de
                }, [
                  C($, {
                    name: "Bookmark",
                    size: 14
                  }),
                  X[29] || (X[29] = Y(" Save prompt ", -1))
                ])) : z("", !0),
                $e.value ? (g(), b("button", {
                  key: 1,
                  class: "v2-info-remix",
                  "data-testid": "info-edit",
                  onClick: Ne
                }, [
                  C($, {
                    name: "Wand2",
                    size: 14
                  }),
                  X[30] || (X[30] = Y(" Edit in Studio view", -1))
                ])) : z("", !0)
              ])
            ])
          ]))
        ])
      ], 32)
    ], 32)) : z("", !0);
  }
}), qq = { class: "ks-head" }, Kq = { class: "ks-mark" }, Yq = { class: "ks-titles" }, Xq = { id: "ks-title" }, Jq = {
  key: 0,
  class: "ks-os",
  "data-testid": "shortcuts-os"
}, Zq = { class: "ks-grid" }, Qq = { class: "ks-label" }, eK = { key: 0 }, tK = { class: "ks-keys" }, nK = /* @__PURE__ */ Pe({
  __name: "ShortcutsPanel",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(null), i = rm().shift, s = ws === "mac" ? "Mac" : ws === "windows" ? "Windows" : ws === "chromeos" ? "ChromeOS" : ws === "linux" ? "Linux" : "", o = [
      {
        title: "Tools",
        area: "tools",
        rows: [
          { label: "Select", keys: ["V"] },
          { label: "Hand", keys: ["H"] },
          { label: "Pan while held", keys: ["Space"] },
          { label: "Note", keys: ["N"] },
          { label: "Frame", keys: ["F"] },
          { label: "Rectangle", keys: ["M"] },
          { label: "Ellipse", keys: ["L"] },
          { label: "Line", keys: ["\\"] },
          { label: "Arrow", keys: pn(["shift", "\\"]) },
          { label: "Pick from the board", keys: ["I"], hint: "Into the open prompt's images" },
          { label: "Comment", keys: ["C"], hint: "Then click anything on the board" },
          { label: "Show or hide comments", keys: pn(["shift", "C"]) }
        ]
      },
      {
        title: "View",
        area: "view",
        rows: [
          { label: "Pan", keys: ["Scroll"], hint: "Or drag with two fingers" },
          { label: "Pan sideways", keys: pn(["shift", "Scroll"]) },
          { label: "Zoom", keys: pn(["mod", "Scroll"]), hint: "Or pinch" },
          { label: "Zoom in", keys: ["+"] },
          { label: "Zoom out", keys: ["−"] },
          { label: "Zoom to 100%", keys: ["0"] },
          { label: "Fit the board", keys: ["1"] }
        ]
      },
      {
        title: "Board",
        area: "board",
        rows: [
          { label: "Find or start a session", keys: ["Double-click"], hint: "On the empty board; it starts one there" },
          { label: "Add a session, note or frame there", keys: ["Right-click"] },
          { label: "Use an image as a reference", keys: pn(["shift", "Drag"]), hint: "Onto a session, or the open prompt" },
          { label: "Run the prompt", keys: pn(["mod", "enter"]) },
          { label: "Edit a note, open an image", keys: pn(["enter"]) },
          { label: "Close, then deselect", keys: pn(["esc"]) },
          { label: "These shortcuts", keys: ["?"] },
          { label: "Send feedback", keys: ["`"], hint: "With a screenshot of what's open" }
        ]
      },
      {
        title: "Edit",
        area: "edit",
        rows: [
          { label: "Undo", keys: pn(["mod", "Z"]) },
          { label: "Redo", keys: pn(am()) },
          { label: "Copy", keys: pn(["mod", "C"]) },
          { label: "Cut", keys: pn(["mod", "X"]) },
          { label: "Paste", keys: pn(["mod", "V"]) },
          { label: "Duplicate", keys: pn(["mod", "D"]) },
          { label: "Select all", keys: pn(["mod", "A"]) },
          { label: "Delete", keys: pn(["del"]) },
          { label: "Lock or unlock a frame", keys: pn(["mod", "shift", "L"]) },
          { label: "Nudge", keys: ["←", "↑", "↓", "→"], hint: `Hold ${i} for 10 px` },
          { label: "Drag without snapping", keys: pn(["mod", "Drag"]) }
        ]
      }
    ];
    function r() {
      e.ui.keysOpen = !1;
    }
    let a = null;
    return it(() => {
      a = document.activeElement, t.value && t.value.focus({ preventScroll: !0 });
    }), We(() => {
      a && document.contains(a) && a.focus({ preventScroll: !0 });
    }), (l, d) => (g(), b("div", {
      class: "ks",
      "data-testid": "shortcuts",
      onPointerdown: Te(r, ["self"]),
      onWheel: d[1] || (d[1] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", {
        ref_key: "card",
        ref: t,
        class: "ks-card",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "ks-title",
        tabindex: "-1",
        onPointerdown: d[0] || (d[0] = Te(() => {
        }, ["stop"]))
      }, [
        u("header", qq, [
          u("span", Kq, [
            C($, {
              name: "Keyboard",
              size: 17
            })
          ]),
          u("div", Yq, [
            u("h2", Xq, [
              d[2] || (d[2] = Y("Keyboard shortcuts", -1)),
              m(s) ? (g(), b("span", Jq, E(m(s)), 1)) : z("", !0)
            ]),
            d[3] || (d[3] = u("p", null, [
              Y("Press "),
              u("kbd", { class: "ks-key is-inline" }, "?"),
              Y(" on the board to bring these up any time.")
            ], -1))
          ]),
          u("button", {
            class: "ks-close",
            title: "Close",
            "aria-label": "Close",
            "data-testid": "shortcuts-close",
            onClick: r
          }, [
            C($, {
              name: "X",
              size: 15
            })
          ])
        ]),
        u("div", Zq, [
          (g(), b(j, null, ge(o, (c) => u("section", {
            key: c.title,
            class: "ks-group",
            style: ce({ gridArea: c.area })
          }, [
            u("h3", null, E(c.title), 1),
            u("ul", null, [
              (g(!0), b(j, null, ge(c.rows, (h) => (g(), b("li", {
                key: h.label
              }, [
                u("span", Qq, [
                  Y(E(h.label) + " ", 1),
                  h.hint ? (g(), b("small", eK, E(h.hint), 1)) : z("", !0)
                ]),
                u("span", tK, [
                  (g(!0), b(j, null, ge(h.keys, (f, p) => (g(), b("kbd", {
                    key: p,
                    class: G(["ks-key", { "is-word": f.length > 1 }])
                  }, E(f), 3))), 128))
                ])
              ]))), 128))
            ])
          ], 4)), 64))
        ])
      ], 544)
    ], 32));
  }
});
var iK = Object.defineProperty, sK = (n, e, t) => e in n ? iK(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Zu = (n, e, t) => sK(n, typeof e != "symbol" ? e + "" : e, t);
const Qu = 32768;
class oK {
  constructor(e = 512) {
    Zu(this, "cell"), Zu(this, "cells", /* @__PURE__ */ new Map()), Zu(this, "items", /* @__PURE__ */ new Map()), Zu(this, "mark", 0), this.cell = e;
  }
  get size() {
    return this.items.size;
  }
  has(e) {
    return this.items.has(e);
  }
  rectOf(e) {
    const t = this.items.get(e);
    return t ? t.r : void 0;
  }
  keysFor(e) {
    const t = this.cell, i = Math.floor(e.x / t), s = Math.floor(e.y / t), o = Math.floor((e.x + Math.max(0, e.w)) / t), r = Math.floor((e.y + Math.max(0, e.h)) / t), a = [];
    for (let l = i; l <= o; l++)
      for (let d = s; d <= r; d++) a.push((l + Qu) * 65536 + (d + Qu));
    return a;
  }
  insert(e, t) {
    if (this.items.has(e)) {
      this.update(e, t);
      return;
    }
    const i = this.keysFor(t);
    this.items.set(e, { r: { x: t.x, y: t.y, w: t.w, h: t.h }, keys: i, mark: 0 });
    for (const s of i) {
      let o = this.cells.get(s);
      o || (o = /* @__PURE__ */ new Set(), this.cells.set(s, o)), o.add(e);
    }
  }
  update(e, t) {
    const i = this.items.get(e);
    if (!i) {
      this.insert(e, t);
      return;
    }
    const s = this.keysFor(t);
    if (i.r.x = t.x, i.r.y = t.y, i.r.w = t.w, i.r.h = t.h, !(s.length === i.keys.length && s.every((o, r) => o === i.keys[r]))) {
      for (const o of i.keys) {
        const r = this.cells.get(o);
        r && (r.delete(e), r.size || this.cells.delete(o));
      }
      i.keys = s;
      for (const o of s) {
        let r = this.cells.get(o);
        r || (r = /* @__PURE__ */ new Set(), this.cells.set(o, r)), r.add(e);
      }
    }
  }
  remove(e) {
    const t = this.items.get(e);
    if (t) {
      for (const i of t.keys) {
        const s = this.cells.get(i);
        s && (s.delete(e), s.size || this.cells.delete(i));
      }
      this.items.delete(e);
    }
  }
  clear() {
    this.cells.clear(), this.items.clear();
  }
  /** Ids whose rects intersect r (touching edges count). Unordered. */
  query(e, t = []) {
    const i = ++this.mark, s = this.cell, o = Math.floor(e.x / s), r = Math.floor(e.y / s), a = Math.floor((e.x + e.w) / s), l = Math.floor((e.y + e.h) / s), d = e.x + e.w, c = e.y + e.h;
    if ((a - o + 1) * (l - r + 1) > this.cells.size) {
      for (const [h, f] of this.items) {
        const p = f.r;
        p.x <= d && p.x + p.w >= e.x && p.y <= c && p.y + p.h >= e.y && t.push(h);
      }
      return t;
    }
    for (let h = o; h <= a; h++)
      for (let f = r; f <= l; f++) {
        const p = this.cells.get((h + Qu) * 65536 + (f + Qu));
        if (p)
          for (const y of p) {
            const v = this.items.get(y);
            if (v.mark === i) continue;
            v.mark = i;
            const x = v.r;
            x.x <= d && x.x + x.w >= e.x && x.y <= c && x.y + x.h >= e.y && t.push(y);
          }
      }
    return t;
  }
  queryPoint(e, t, i = 0, s = []) {
    return this.query({ x: e - i, y: t - i, w: i * 2, h: i * 2 }, s);
  }
}
var rK = Object.defineProperty, aK = (n, e, t) => e in n ? rK(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, ci = (n, e, t) => aK(n, typeof e != "symbol" ? e + "" : e, t);
const lK = 100;
function us(n) {
  return n == null || typeof n != "object" ? n : JSON.parse(JSON.stringify(n));
}
function bg(n) {
  const e = {};
  for (const t of Object.keys(n)) e[t] = us(n[t]);
  return e;
}
function vg(n, e) {
  return n === e ? !0 : n && e && typeof n == "object" && typeof e == "object" ? JSON.stringify(n) === JSON.stringify(e) : !1;
}
class dK {
  constructor() {
    ci(this, "elements", /* @__PURE__ */ new Map()), ci(this, "index", new oK(512)), ci(this, "listeners", /* @__PURE__ */ new Set()), ci(this, "undoStack", []), ci(this, "redoStack", []), ci(this, "depth", 0), ci(this, "batchLabel", ""), ci(this, "batchPatches", []), ci(this, "batchSet", null), ci(this, "batchHistory", !0), ci(this, "gesture", null), ci(this, "maxZ", { frames: 0, content: 0, annotations: 0 }), ci(this, "minZ", { frames: 0, content: 0, annotations: 0 }), ci(this, "version", 0);
  }
  // ---------------------------------------------------------------- reads
  get(e) {
    return this.elements.get(e);
  }
  all() {
    return this.elements.values();
  }
  get size() {
    return this.elements.size;
  }
  /** Elements intersecting a world rect, unordered. */
  query(e) {
    const t = this.index.query(e), i = [];
    for (const s of t) {
      const o = this.elements.get(s);
      o && i.push(o);
    }
    return i;
  }
  bounds(e) {
    let t = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
    const r = (a) => {
      const l = He(a);
      l.x < t && (t = l.x), l.y < i && (i = l.y), l.x + l.w > s && (s = l.x + l.w), l.y + l.h > o && (o = l.y + l.h);
    };
    if (e)
      for (const a of e) {
        const l = this.elements.get(a);
        l && r(l);
      }
    else
      for (const a of this.elements.values()) r(a);
    return t === 1 / 0 ? null : { x: t, y: i, w: s - t, h: o - i };
  }
  nextZ(e, t = !1) {
    const i = Iv[e.type];
    return t ? this.minZ[i] - 1 : this.maxZ[i] + 1;
  }
  get canUndo() {
    return this.undoStack.length > 0;
  }
  get canRedo() {
    return this.redoStack.length > 0;
  }
  get inGesture() {
    return !!this.gesture;
  }
  // -------------------------------------------------------------- events
  subscribe(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
  emit(e) {
    if (!(!e.added.length && !e.updated.length && !e.removed.length)) {
      this.version++;
      for (const t of this.listeners)
        try {
          t(e);
        } catch (i) {
          console.error("[board] change listener failed", i);
        }
    }
  }
  // ------------------------------------------------------------ batching
  /** Run fn as one undo step and one change set. Nestable. */
  batch(e, t, i = {}) {
    this.open(e, i);
    try {
      return t();
    } finally {
      this.close();
    }
  }
  open(e, t) {
    this.depth++ === 0 && (this.batchLabel = e, this.batchPatches = [], this.batchHistory = t.history !== !1 && (t.origin || "local") === "local", this.batchSet = {
      origin: t.origin || "local",
      ephemeral: !!this.gesture && (t.origin || "local") === "local",
      label: e,
      added: [],
      updated: [],
      removed: []
    });
  }
  close() {
    if (--this.depth > 0) return;
    const e = this.batchSet, t = this.batchPatches;
    this.batchSet = null, this.batchPatches = [], this.batchHistory && t.length && !this.gesture && this.pushHistory({ label: this.batchLabel, patches: t }), this.emit(e);
  }
  pushHistory(e) {
    this.undoStack.push(e), this.undoStack.length > lK && this.undoStack.shift(), this.redoStack = [];
  }
  // ----------------------------------------------------------- mutations
  add(e, t = {}) {
    this.batch("Add", () => {
      for (const i of e) {
        if (this.elements.has(i.id)) continue;
        const s = i;
        this.elements.set(s.id, s), this.index.insert(s.id, He(s)), this.trackZ(s), this.batchSet.added.push(s), this.batchPatches.push({ op: "add", el: us(s) }), this.gesture && this.batchSet.origin === "local" && this.gesture.added.add(s.id);
      }
    }, t);
  }
  update(e, t, i = {}) {
    this.updateMany([[e, t]], i);
  }
  updateMany(e, t = {}) {
    this.batch("Edit", () => {
      for (const [i, s] of e) {
        const o = this.elements.get(i);
        if (!o) continue;
        const r = {}, a = {};
        let l = !1;
        for (const c of Object.keys(s)) {
          if (c === "id" || c === "type") continue;
          const h = s[c];
          vg(o[c], h) || (r[c] = us(o[c]), a[c] = us(h), o[c] = h === void 0 ? void 0 : us(h), h === void 0 && delete o[c], l = !0);
        }
        if (!l) continue;
        if (("x" in a || "y" in a || "w" in a || "h" in a || "scale" in a) && this.index.update(i, He(o)), "z" in a && this.trackZ(o), this.gesture && this.batchSet.origin === "local" && !this.gesture.added.has(i)) {
          const c = this.gesture.before.get(i) || {};
          for (const h of Object.keys(r)) h in c || (c[h] = r[h]);
          this.gesture.before.set(i, c);
        }
        const d = this.batchSet.updated.find((c) => c.id === i);
        if (d)
          for (const c of Object.keys(a))
            c in d.before || (d.before[c] = r[c]), d.after[c] = a[c];
        else
          this.batchSet.updated.push({ id: i, el: o, before: r, after: a });
        this.batchPatches.push({ op: "update", id: i, before: r, after: a });
      }
    }, t);
  }
  remove(e, t = {}) {
    this.batch("Delete", () => {
      for (const i of e) {
        const s = this.elements.get(i);
        s && (this.elements.delete(i), this.index.remove(i), this.batchSet.removed.push(s), this.batchPatches.push({ op: "remove", el: us(s) }));
      }
    }, t);
  }
  /** Replace everything (initial load). No history. */
  load(e) {
    const t = Array.from(this.elements.values());
    this.elements.clear(), this.index.clear(), this.maxZ = { frames: 0, content: 0, annotations: 0 }, this.minZ = { frames: 0, content: 0, annotations: 0 }, this.undoStack = [], this.redoStack = [];
    for (const i of e)
      this.elements.set(i.id, i), this.index.insert(i.id, He(i)), this.trackZ(i);
    this.emit({ origin: "load", ephemeral: !1, label: "Load", added: e, updated: [], removed: t });
  }
  trackZ(e) {
    const t = Iv[e.type];
    e.z > this.maxZ[t] && (this.maxZ[t] = e.z), e.z < this.minZ[t] && (this.minZ[t] = e.z);
  }
  // ------------------------------------------------------------ gestures
  beginGesture(e) {
    this.gesture && this.endGesture(), this.gesture = { label: e, before: /* @__PURE__ */ new Map(), added: /* @__PURE__ */ new Set() };
  }
  /** Commit the gesture: one persisted change set, one undo step. */
  endGesture() {
    const e = this.gesture;
    if (!e) return;
    this.gesture = null;
    const t = { origin: "local", ephemeral: !1, label: e.label, added: [], updated: [], removed: [] }, i = [];
    for (const s of e.added) {
      const o = this.elements.get(s);
      o && (t.added.push(o), i.push({ op: "add", el: us(o) }));
    }
    for (const [s, o] of e.before) {
      const r = this.elements.get(s);
      if (!r) continue;
      const a = {}, l = {};
      for (const d of Object.keys(o))
        vg(o[d], r[d]) || (l[d] = o[d], a[d] = us(r[d]));
      Object.keys(a).length && (t.updated.push({ id: s, el: r, before: l, after: a }), i.push({ op: "update", id: s, before: l, after: a }));
    }
    i.length && this.pushHistory({ label: e.label, patches: i }), this.emit(t);
  }
  /** Abandon the gesture and put everything back. */
  cancelGesture() {
    const e = this.gesture;
    e && (this.gesture = null, this.batch("Cancel", () => {
      this.remove(e.added, { history: !1 });
      const t = [];
      for (const [i, s] of e.before) t.push([i, s]);
      this.updateMany(t, { history: !1 });
    }, { history: !1 }));
  }
  // ------------------------------------------------------------- history
  /**
   * Record an undo step for an edit already applied without history (text
   * typed into a note, saved as you type): one step for the whole edit.
   */
  recordEdit(e, t, i, s) {
    !Object.keys(s).some((r) => !vg(i[r], s[r])) || !this.elements.has(t) || this.pushHistory({ label: e, patches: [{ op: "update", id: t, before: bg(i), after: bg(s) }] });
  }
  undo() {
    this.gesture && this.endGesture();
    const e = this.undoStack.pop();
    return e ? (this.applyPatches(e.patches, !0, "Undo " + e.label), this.redoStack.push(e), !0) : !1;
  }
  redo() {
    this.gesture && this.endGesture();
    const e = this.redoStack.pop();
    return e ? (this.applyPatches(e.patches, !1, "Redo " + e.label), this.undoStack.push(e), !0) : !1;
  }
  /**
   * Elements gone for good (deleted from Recently Deleted): no undo or redo
   * step brings them back or changes them. Their part of each step goes, and
   * a step left with nothing goes too; the rest of a step stays, so Undo
   * still takes back whatever else it did.
   */
  forget(e) {
    if (!e.length) return;
    const t = new Set(e), i = (s) => s.map((o) => ({ ...o, patches: o.patches.filter((r) => !t.has(r.op === "update" ? r.id : r.el.id)) })).filter((o) => o.patches.length > 0);
    this.undoStack = i(this.undoStack), this.redoStack = i(this.redoStack);
  }
  /** The elements an Undo (or a Redo) would put back on the board: what an undoable step removed, or Undo took away. */
  restorableIds() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.undoStack) for (const i of t.patches) i.op === "remove" && e.add(i.el.id);
    for (const t of this.redoStack) for (const i of t.patches) i.op === "add" && e.add(i.el.id);
    return Array.from(e);
  }
  /** The labels on the undo stack, oldest first: what Undo would take back, in turn from the end. */
  undoLabels() {
    return this.undoStack.map((e) => e.label);
  }
  applyPatches(e, t, i) {
    const s = t ? e.slice().reverse() : e;
    this.batch(i, () => {
      for (const o of s)
        o.op === "add" ? t ? this.remove([o.el.id], { history: !1, origin: "local" }) : this.add([us(o.el)], { history: !1, origin: "local" }) : o.op === "remove" ? t ? this.add([us(o.el)], { history: !1, origin: "local" }) : this.remove([o.el.id], { history: !1, origin: "local" }) : this.update(o.id, bg(t ? o.before : o.after), { history: !1, origin: "local" });
    }, { history: !1, origin: "local" });
  }
}
var Ae = /* @__PURE__ */ ((n) => (n.Application = "application", n.WebGLPipes = "webgl-pipes", n.WebGLPipesAdaptor = "webgl-pipes-adaptor", n.WebGLSystem = "webgl-system", n.WebGLLoader = "webgl-loader", n.WebGPUPipes = "webgpu-pipes", n.WebGPUPipesAdaptor = "webgpu-pipes-adaptor", n.WebGPUSystem = "webgpu-system", n.WebGPULoader = "webgpu-loader", n.CanvasSystem = "canvas-system", n.CanvasPipesAdaptor = "canvas-pipes-adaptor", n.CanvasPipes = "canvas-pipes", n.CanvasLoader = "canvas-loader", n.Asset = "asset", n.LoadParser = "load-parser", n.ResolveParser = "resolve-parser", n.CacheParser = "cache-parser", n.DetectionParser = "detection-parser", n.MaskEffect = "mask-effect", n.BlendMode = "blend-mode", n.TextureSource = "texture-source", n.TextureUploaderWebGL = "texture-uploader-webgl", n.TextureUploaderWebGPU = "texture-uploader-webgpu", n.Environment = "environment", n.ShapeBuilder = "shape-builder", n.Batcher = "batcher", n))(Ae || {});
const Nv = (n) => {
  if (typeof n == "function" || typeof n == "object" && n.extension) {
    if (!n.extension)
      throw new Error("Extension class must have an extension object");
    n = { ...typeof n.extension != "object" ? { type: n.extension } : n.extension, ref: n };
  }
  if (typeof n == "object")
    n = { ...n };
  else
    throw new Error("Invalid extension type");
  return typeof n.type == "string" && (n.type = [n.type]), n;
}, eh = (n, e) => {
  var t;
  return (t = Nv(n).priority) != null ? t : e;
}, ht = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */
  remove(...n) {
    return n.map(Nv).forEach((e) => {
      e.type.forEach((t) => {
        var i, s;
        return (s = (i = this._removeHandlers)[t]) == null ? void 0 : s.call(i, e);
      });
    }), this;
  },
  /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */
  add(...n) {
    return n.map(Nv).forEach((e) => {
      e.type.forEach((t) => {
        var o, r;
        const i = this._addHandlers, s = this._queue;
        i[t] ? (r = i[t]) == null || r.call(i, e) : (s[t] = s[t] || [], (o = s[t]) == null || o.push(e));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */
  handle(n, e, t) {
    var r;
    const i = this._addHandlers, s = this._removeHandlers;
    if (i[n] || s[n])
      throw new Error(`Extension type ${n} already has a handler`);
    i[n] = e, s[n] = t;
    const o = this._queue;
    return o[n] && ((r = o[n]) == null || r.forEach((a) => e(a)), delete o[n]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */
  handleByMap(n, e) {
    return this.handle(
      n,
      (t) => {
        t.name && (e[t.name] = t.ref);
      },
      (t) => {
        t.name && delete e[t.name];
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */
  handleByNamedList(n, e, t = -1) {
    return this.handle(
      n,
      (i) => {
        e.findIndex((o) => o.name === i.name) >= 0 || (e.push({ name: i.name, value: i.ref }), e.sort((o, r) => eh(r.value, t) - eh(o.value, t)));
      },
      (i) => {
        const s = e.findIndex((o) => o.name === i.name);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */
  handleByList(n, e, t = -1) {
    return this.handle(
      n,
      (i) => {
        e.includes(i.ref) || (e.push(i.ref), e.sort((s, o) => eh(o, t) - eh(s, t)));
      },
      (i) => {
        const s = e.indexOf(i.ref);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */
  mixin(n, ...e) {
    for (const t of e)
      Object.defineProperties(n.prototype, Object.getOwnPropertyDescriptors(t));
  }
}, cK = {
  extension: {
    type: Ae.Environment,
    name: "browser",
    priority: -1
  },
  test: () => !0,
  load: async () => {
    await Promise.resolve().then(() => dze);
  }
}, uK = {
  extension: {
    type: Ae.Environment,
    name: "webworker",
    priority: 0
  },
  test: () => typeof self != "undefined" && self.WorkerGlobalScope !== void 0,
  load: async () => {
    await Promise.resolve().then(() => cze);
  }
};
class Fn {
  /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e, t, i) {
    this._x = t || 0, this._y = i || 0, this._observer = e;
  }
  /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */
  clone(e) {
    return new Fn(e != null ? e : this._observer, this._x, this._y);
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */
  set(e = 0, t = e) {
    return (this._x !== e || this._y !== t) && (this._x = e, this._y = t, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyFrom(e) {
    return (this._x !== e.x || this._y !== e.y) && (this._x = e.x, this._y = e.y, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyTo(e) {
    return e.set(this._x, this._y), e;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(e) {
    return e.x === this._x && e.y === this._y;
  }
  toString() {
    return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
  }
  /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x !== e && (this._x = e, this._observer._onUpdate(this));
  }
  /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y !== e && (this._y = e, this._observer._onUpdate(this));
  }
}
function hK(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var yg = { exports: {} }, fk;
function pK() {
  return fk || (fk = 1, (function(n) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function i() {
    }
    Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (t = !1));
    function s(l, d, c) {
      this.fn = l, this.context = d, this.once = c || !1;
    }
    function o(l, d, c, h, f) {
      if (typeof c != "function")
        throw new TypeError("The listener must be a function");
      var p = new s(c, h || l, f), y = t ? t + d : d;
      return l._events[y] ? l._events[y].fn ? l._events[y] = [l._events[y], p] : l._events[y].push(p) : (l._events[y] = p, l._eventsCount++), l;
    }
    function r(l, d) {
      --l._eventsCount === 0 ? l._events = new i() : delete l._events[d];
    }
    function a() {
      this._events = new i(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var d = [], c, h;
      if (this._eventsCount === 0) return d;
      for (h in c = this._events)
        e.call(c, h) && d.push(t ? h.slice(1) : h);
      return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(c)) : d;
    }, a.prototype.listeners = function(d) {
      var c = t ? t + d : d, h = this._events[c];
      if (!h) return [];
      if (h.fn) return [h.fn];
      for (var f = 0, p = h.length, y = new Array(p); f < p; f++)
        y[f] = h[f].fn;
      return y;
    }, a.prototype.listenerCount = function(d) {
      var c = t ? t + d : d, h = this._events[c];
      return h ? h.fn ? 1 : h.length : 0;
    }, a.prototype.emit = function(d, c, h, f, p, y) {
      var v = t ? t + d : d;
      if (!this._events[v]) return !1;
      var x = this._events[v], w = arguments.length, S, M;
      if (x.fn) {
        switch (x.once && this.removeListener(d, x.fn, void 0, !0), w) {
          case 1:
            return x.fn.call(x.context), !0;
          case 2:
            return x.fn.call(x.context, c), !0;
          case 3:
            return x.fn.call(x.context, c, h), !0;
          case 4:
            return x.fn.call(x.context, c, h, f), !0;
          case 5:
            return x.fn.call(x.context, c, h, f, p), !0;
          case 6:
            return x.fn.call(x.context, c, h, f, p, y), !0;
        }
        for (M = 1, S = new Array(w - 1); M < w; M++)
          S[M - 1] = arguments[M];
        x.fn.apply(x.context, S);
      } else {
        var _ = x.length, T;
        for (M = 0; M < _; M++)
          switch (x[M].once && this.removeListener(d, x[M].fn, void 0, !0), w) {
            case 1:
              x[M].fn.call(x[M].context);
              break;
            case 2:
              x[M].fn.call(x[M].context, c);
              break;
            case 3:
              x[M].fn.call(x[M].context, c, h);
              break;
            case 4:
              x[M].fn.call(x[M].context, c, h, f);
              break;
            default:
              if (!S) for (T = 1, S = new Array(w - 1); T < w; T++)
                S[T - 1] = arguments[T];
              x[M].fn.apply(x[M].context, S);
          }
      }
      return !0;
    }, a.prototype.on = function(d, c, h) {
      return o(this, d, c, h, !1);
    }, a.prototype.once = function(d, c, h) {
      return o(this, d, c, h, !0);
    }, a.prototype.removeListener = function(d, c, h, f) {
      var p = t ? t + d : d;
      if (!this._events[p]) return this;
      if (!c)
        return r(this, p), this;
      var y = this._events[p];
      if (y.fn)
        y.fn === c && (!f || y.once) && (!h || y.context === h) && r(this, p);
      else {
        for (var v = 0, x = [], w = y.length; v < w; v++)
          (y[v].fn !== c || f && !y[v].once || h && y[v].context !== h) && x.push(y[v]);
        x.length ? this._events[p] = x.length === 1 ? x[0] : x : r(this, p);
      }
      return this;
    }, a.prototype.removeAllListeners = function(d) {
      var c;
      return d ? (c = t ? t + d : d, this._events[c] && r(this, c)) : (this._events = new i(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, n.exports = a;
  })(yg)), yg.exports;
}
var fK = pK();
const bi = /* @__PURE__ */ hK(fK), mK = Math.PI * 2, gK = 180 / Math.PI, bK = Math.PI / 180;
class Wt {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e = 0, t = 0) {
    this.x = 0, this.y = 0, this.x = e, this.y = t;
  }
  /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */
  clone() {
    return new Wt(this.x, this.y);
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyFrom(e) {
    return this.set(e.x, e.y), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyTo(e) {
    return e.set(this.x, this.y), e;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */
  set(e = 0, t = e) {
    return this.x = e, this.y = t, this;
  }
  toString() {
    return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
  }
  /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */
  static get shared() {
    return xg.x = 0, xg.y = 0, xg;
  }
}
const xg = new Wt();
class ot {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(e = 1, t = 0, i = 0, s = 1, o = 0, r = 0) {
    this.array = null, this.a = e, this.b = t, this.c = i, this.d = s, this.tx = o, this.ty = r;
  }
  /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */
  fromArray(e) {
    this.a = e[0], this.b = e[1], this.c = e[3], this.d = e[4], this.tx = e[2], this.ty = e[5];
  }
  /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */
  set(e, t, i, s, o, r) {
    return this.a = e, this.b = t, this.c = i, this.d = s, this.tx = o, this.ty = r, this;
  }
  /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */
  toArray(e, t) {
    this.array || (this.array = new Float32Array(9));
    const i = t || this.array;
    return e ? (i[0] = this.a, i[1] = this.b, i[2] = 0, i[3] = this.c, i[4] = this.d, i[5] = 0, i[6] = this.tx, i[7] = this.ty, i[8] = 1) : (i[0] = this.a, i[1] = this.c, i[2] = this.tx, i[3] = this.b, i[4] = this.d, i[5] = this.ty, i[6] = 0, i[7] = 0, i[8] = 1), i;
  }
  /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */
  apply(e, t) {
    t = t || new Wt();
    const i = e.x, s = e.y;
    return t.x = this.a * i + this.c * s + this.tx, t.y = this.b * i + this.d * s + this.ty, t;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */
  applyInverse(e, t) {
    t = t || new Wt();
    const i = this.a, s = this.b, o = this.c, r = this.d, a = this.tx, l = this.ty, d = 1 / (i * r + o * -s), c = e.x, h = e.y;
    return t.x = r * d * c + -o * d * h + (l * o - a * r) * d, t.y = i * d * h + -s * d * c + (-l * i + a * s) * d, t;
  }
  /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */
  translate(e, t) {
    return this.tx += e, this.ty += t, this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */
  scale(e, t) {
    return this.a *= e, this.d *= t, this.c *= e, this.b *= t, this.tx *= e, this.ty *= t, this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */
  rotate(e) {
    const t = Math.cos(e), i = Math.sin(e), s = this.a, o = this.c, r = this.tx;
    return this.a = s * t - this.b * i, this.b = s * i + this.b * t, this.c = o * t - this.d * i, this.d = o * i + this.d * t, this.tx = r * t - this.ty * i, this.ty = r * i + this.ty * t, this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */
  append(e) {
    const t = this.a, i = this.b, s = this.c, o = this.d;
    return this.a = e.a * t + e.b * s, this.b = e.a * i + e.b * o, this.c = e.c * t + e.d * s, this.d = e.c * i + e.d * o, this.tx = e.tx * t + e.ty * s + this.tx, this.ty = e.tx * i + e.ty * o + this.ty, this;
  }
  /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */
  appendFrom(e, t) {
    const i = e.a, s = e.b, o = e.c, r = e.d, a = e.tx, l = e.ty, d = t.a, c = t.b, h = t.c, f = t.d;
    return this.a = i * d + s * h, this.b = i * c + s * f, this.c = o * d + r * h, this.d = o * c + r * f, this.tx = a * d + l * h + t.tx, this.ty = a * c + l * f + t.ty, this;
  }
  /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */
  setTransform(e, t, i, s, o, r, a, l, d) {
    return this.a = Math.cos(a + d) * o, this.b = Math.sin(a + d) * o, this.c = -Math.sin(a - l) * r, this.d = Math.cos(a - l) * r, this.tx = e - (i * this.a + s * this.c), this.ty = t - (i * this.b + s * this.d), this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */
  prepend(e) {
    const t = this.tx;
    if (e.a !== 1 || e.b !== 0 || e.c !== 0 || e.d !== 1) {
      const i = this.a, s = this.c;
      this.a = i * e.a + this.b * e.c, this.b = i * e.b + this.b * e.d, this.c = s * e.a + this.d * e.c, this.d = s * e.b + this.d * e.d;
    }
    return this.tx = t * e.a + this.ty * e.c + e.tx, this.ty = t * e.b + this.ty * e.d + e.ty, this;
  }
  /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */
  decompose(e) {
    const t = this.a, i = this.b, s = this.c, o = this.d, r = e.pivot, a = -Math.atan2(-s, o), l = Math.atan2(i, t), d = Math.abs(a + l);
    let c = Math.sqrt(t * t + i * i);
    return d < 1e-5 || Math.abs(mK - d) < 1e-5 ? (e.rotation = l, e.skew.x = e.skew.y = 0) : Math.abs(Math.PI - d) < 1e-5 ? (e.rotation = l - Math.PI, e.skew.x = e.skew.y = 0, c = -c) : (e.rotation = 0, e.skew.x = a, e.skew.y = l), e.scale.x = c, e.scale.y = Math.sqrt(s * s + o * o), e.position.x = this.tx + (r.x * t + r.y * s), e.position.y = this.ty + (r.x * i + r.y * o), e;
  }
  /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */
  invert() {
    const e = this.a, t = this.b, i = this.c, s = this.d, o = this.tx, r = e * s - t * i;
    return this.a = s / r, this.b = -t / r, this.c = -i / r, this.d = e / r, this.tx = (i * this.ty - s * o) / r, this.ty = -(e * this.ty - t * o) / r, this;
  }
  /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */
  isIdentity() {
    return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const e = new ot();
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */
  copyTo(e) {
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */
  copyFrom(e) {
    return this.a = e.a, this.b = e.b, this.c = e.c, this.d = e.d, this.tx = e.tx, this.ty = e.ty, this;
  }
  /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */
  equals(e) {
    return e.a === this.a && e.b === this.b && e.c === this.c && e.d === this.d && e.tx === this.tx && e.ty === this.ty;
  }
  toString() {
    return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
  }
  /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get IDENTITY() {
    return yK.identity();
  }
  /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get shared() {
    return vK.identity();
  }
}
const vK = new ot(), yK = new ot(), Ar = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], Pr = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], Er = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], Rr = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], Uv = [], mS = [], th = Math.sign;
function xK() {
  for (let n = 0; n < 16; n++) {
    const e = [];
    Uv.push(e);
    for (let t = 0; t < 16; t++) {
      const i = th(Ar[n] * Ar[t] + Er[n] * Pr[t]), s = th(Pr[n] * Ar[t] + Rr[n] * Pr[t]), o = th(Ar[n] * Er[t] + Er[n] * Rr[t]), r = th(Pr[n] * Er[t] + Rr[n] * Rr[t]);
      for (let a = 0; a < 16; a++)
        if (Ar[a] === i && Pr[a] === s && Er[a] === o && Rr[a] === r) {
          e.push(a);
          break;
        }
    }
  }
  for (let n = 0; n < 16; n++) {
    const e = new ot();
    e.set(Ar[n], Pr[n], Er[n], Rr[n], 0, 0), mS.push(e);
  }
}
xK();
const Mt = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (n) => Ar[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (n) => Pr[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (n) => Er[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (n) => Rr[n],
  /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (n) => n & 8 ? n & 15 : -n & 7,
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */
  add: (n, e) => Uv[n][e],
  /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */
  sub: (n, e) => Uv[n][Mt.inv(e)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (n) => n ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (n) => (n & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (n, e) => Math.abs(n) * 2 <= Math.abs(e) ? e >= 0 ? Mt.S : Mt.N : Math.abs(e) * 2 <= Math.abs(n) ? n > 0 ? Mt.E : Mt.W : e > 0 ? n > 0 ? Mt.SE : Mt.SW : n > 0 ? Mt.NE : Mt.NW,
  /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   * @param {number} dw - sprite width
   * @param {number} dh - sprite height
   */
  matrixAppendRotationInv: (n, e, t = 0, i = 0, s = 0, o = 0) => {
    const r = mS[Mt.inv(e)], a = r.a, l = r.b, d = r.c, c = r.d, h = t - Math.min(0, a * s, d * o, a * s + d * o), f = i - Math.min(0, l * s, c * o, l * s + c * o), p = n.a, y = n.b, v = n.c, x = n.d;
    n.a = a * p + l * v, n.b = a * y + l * x, n.c = d * p + c * v, n.d = d * y + c * x, n.tx = h * p + f * v + n.tx, n.ty = h * y + f * x + n.ty;
  },
  /**
   * Transforms rectangle coordinates based on texture packer rotation.
   * Used when texture atlas pages are rotated and coordinates need to be adjusted.
   * @group groupD8
   * @param {RectangleLike} rect - Rectangle with original coordinates to transform
   * @param {RectangleLike} sourceFrame - Source texture frame (includes offset and dimensions)
   * @param {GD8Symmetry} rotation - The groupD8 rotation value
   * @param {Rectangle} out - Rectangle to store the result
   * @returns {Rectangle} Transformed coordinates (includes source frame offset)
   */
  transformRectCoords: (n, e, t, i) => {
    const { x: s, y: o, width: r, height: a } = n, { x: l, y: d, width: c, height: h } = e;
    return t === Mt.E ? (i.set(s + l, o + d, r, a), i) : t === Mt.S ? i.set(
      c - o - a + l,
      s + d,
      a,
      r
    ) : t === Mt.W ? i.set(
      c - s - r + l,
      h - o - a + d,
      r,
      a
    ) : t === Mt.N ? i.set(
      o + l,
      h - s - r + d,
      a,
      r
    ) : i.set(s + l, o + d, r, a);
  }
}, nh = [new Wt(), new Wt(), new Wt(), new Wt()];
class Tt {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(e = 0, t = 0, i = 0, s = 0) {
    this.type = "rectangle", this.x = Number(e), this.y = Number(t), this.width = Number(i), this.height = Number(s);
  }
  /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */
  get left() {
    return this.x;
  }
  /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */
  get right() {
    return this.x + this.width;
  }
  /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */
  get top() {
    return this.y;
  }
  /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */
  get bottom() {
    return this.y + this.height;
  }
  /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
  /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */
  static get EMPTY() {
    return new Tt(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new Tt(this.x, this.y, this.width, this.height);
  }
  /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */
  copyFromBounds(e) {
    return this.x = e.minX, this.y = e.minY, this.width = e.maxX - e.minX, this.height = e.maxY - e.minY, this;
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */
  contains(e, t) {
    return this.width <= 0 || this.height <= 0 ? !1 : e >= this.x && e < this.x + this.width && t >= this.y && t < this.y + this.height;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { width: o, height: r } = this;
    if (o <= 0 || r <= 0) return !1;
    const a = this.x, l = this.y, d = i * (1 - s), c = i - d, h = a - d, f = a + o + d, p = l - d, y = l + r + d, v = a + c, x = a + o - c, w = l + c, S = l + r - c;
    return e >= h && e <= f && t >= p && t <= y && !(e > v && e < x && t > w && t < S);
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */
  intersects(e, t) {
    if (!t) {
      const A = this.x < e.x ? e.x : this.x;
      if ((this.right > e.right ? e.right : this.right) <= A)
        return !1;
      const D = this.y < e.y ? e.y : this.y;
      return (this.bottom > e.bottom ? e.bottom : this.bottom) > D;
    }
    const i = this.left, s = this.right, o = this.top, r = this.bottom;
    if (s <= i || r <= o)
      return !1;
    const a = nh[0].set(e.left, e.top), l = nh[1].set(e.left, e.bottom), d = nh[2].set(e.right, e.top), c = nh[3].set(e.right, e.bottom);
    if (d.x <= a.x || l.y <= a.y)
      return !1;
    const h = Math.sign(t.a * t.d - t.b * t.c);
    if (h === 0 || (t.apply(a, a), t.apply(l, l), t.apply(d, d), t.apply(c, c), Math.max(a.x, l.x, d.x, c.x) <= i || Math.min(a.x, l.x, d.x, c.x) >= s || Math.max(a.y, l.y, d.y, c.y) <= o || Math.min(a.y, l.y, d.y, c.y) >= r))
      return !1;
    const f = h * (l.y - a.y), p = h * (a.x - l.x), y = f * i + p * o, v = f * s + p * o, x = f * i + p * r, w = f * s + p * r;
    if (Math.max(y, v, x, w) <= f * a.x + p * a.y || Math.min(y, v, x, w) >= f * c.x + p * c.y)
      return !1;
    const S = h * (a.y - d.y), M = h * (d.x - a.x), _ = S * i + M * o, T = S * s + M * o, k = S * i + M * r, P = S * s + M * r;
    return !(Math.max(_, T, k, P) <= S * a.x + M * a.y || Math.min(_, T, k, P) >= S * c.x + M * c.y);
  }
  /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */
  pad(e = 0, t = e) {
    return this.x -= e, this.y -= t, this.width += e * 2, this.height += t * 2, this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  fit(e) {
    const t = Math.max(this.x, e.x), i = Math.min(this.x + this.width, e.x + e.width), s = Math.max(this.y, e.y), o = Math.min(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = Math.max(i - t, 0), this.y = s, this.height = Math.max(o - s, 0), this;
  }
  /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */
  ceil(e = 1, t = 1e-3) {
    const i = Math.ceil((this.x + this.width - t) * e) / e, s = Math.ceil((this.y + this.height - t) * e) / e;
    return this.x = Math.floor((this.x + t) * e) / e, this.y = Math.floor((this.y + t) * e) / e, this.width = i - this.x, this.height = s - this.y, this;
  }
  /**
   * Scales the rectangle's dimensions and position by the specified factors.
   * @example
   * ```ts
   * const rect = new Rectangle(50, 50, 100, 100);
   *
   * // Scale uniformly
   * rect.scale(0.5, 0.5);
   * // rect is now: x=25, y=25, width=50, height=50
   *
   * // non-uniformly
   * rect.scale(0.5, 1);
   * // rect is now: x=25, y=50, width=50, height=100
   * ```
   * @param x - The factor by which to scale the horizontal properties (x, width).
   * @param y - The factor by which to scale the vertical properties (y, height).
   * @returns Returns itself
   */
  scale(e, t = e) {
    return this.x *= e, this.y *= t, this.width *= e, this.height *= t, this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  enlarge(e) {
    const t = Math.min(this.x, e.x), i = Math.max(this.x + this.width, e.x + e.width), s = Math.min(this.y, e.y), o = Math.max(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = i - t, this.y = s, this.height = o - s, this;
  }
  /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */
  getBounds(e) {
    return e || (e = new Tt()), e.copyFrom(this), e;
  }
  /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles can't contain anything
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(empty.containsRect(inner)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */
  containsRect(e) {
    if (this.width <= 0 || this.height <= 0) return !1;
    const t = e.x, i = e.y, s = e.x + e.width, o = e.y + e.height;
    return t >= this.x && t < this.x + this.width && i >= this.y && i < this.y + this.height && s >= this.x && s <= this.x + this.width && o >= this.y && o <= this.y + this.height;
  }
  /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */
  set(e, t, i, s) {
    return this.x = e, this.y = t, this.width = i, this.height = s, this;
  }
  toString() {
    return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
  }
}
const wg = {
  default: -1
};
function Nt(n = "default") {
  return wg[n] === void 0 && (wg[n] = -1), ++wg[n];
}
const mk = /* @__PURE__ */ new Set(), dn = "8.0.0", wK = "8.3.4", js = "8.21.0", kK = "8.22.0", al = {
  quiet: !1,
  noColor: !1
}, rt = ((n, e, t = 3) => {
  if (al.quiet || mk.has(e)) return;
  let i = new Error().stack;
  const s = `${e}
Deprecated since v${n}`, o = typeof console.groupCollapsed == "function" && !al.noColor;
  typeof i == "undefined" ? console.warn("PixiJS Deprecation Warning: ", s) : (i = i.split(`
`).splice(t).join(`
`), o ? (console.groupCollapsed(
    "%cPixiJS Deprecation Warning: %c%s",
    "color:#614108;background:#fffbe6",
    "font-weight:normal;color:#614108;background:#fffbe6",
    s
  ), console.warn(i), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", s), console.warn(i))), mk.add(e);
});
Object.defineProperties(rt, {
  quiet: {
    get: () => al.quiet,
    set: (n) => {
      al.quiet = n;
    },
    enumerable: !0,
    configurable: !1
  },
  noColor: {
    get: () => al.noColor,
    set: (n) => {
      al.noColor = n;
    },
    enumerable: !0,
    configurable: !1
  }
});
const gS = () => {
};
function Gv(n) {
  return n.endsWith("int");
}
function hf(n) {
  return n += n === 0 ? 1 : 0, --n, n |= n >>> 1, n |= n >>> 2, n |= n >>> 4, n |= n >>> 8, n |= n >>> 16, n + 1;
}
function $l(n) {
  return !(n & n - 1) && !!n;
}
function bS(n) {
  const e = {};
  for (const t in n)
    n[t] !== void 0 && (e[t] = n[t]);
  return e;
}
const gk = /* @__PURE__ */ Object.create(null);
function _K(n) {
  const e = gk[n];
  return e === void 0 && (gk[n] = Nt("resource")), e;
}
const vS = class yS extends bi {
  /**
   * @param options - options for the style
   */
  constructor(e = {}) {
    var t, i, s, o, r, a, l;
    super(), this._resourceType = "textureSampler", this._maxAnisotropy = 1, this.destroyed = !1, e = { ...yS.defaultOptions, ...e }, this.addressMode = e.addressMode, this.addressModeU = (t = e.addressModeU) != null ? t : this.addressModeU, this.addressModeV = (i = e.addressModeV) != null ? i : this.addressModeV, this.addressModeW = (s = e.addressModeW) != null ? s : this.addressModeW, this.scaleMode = e.scaleMode, this.magFilter = (o = e.magFilter) != null ? o : this.magFilter, this.minFilter = (r = e.minFilter) != null ? r : this.minFilter, this.mipmapFilter = (a = e.mipmapFilter) != null ? a : this.mipmapFilter, this.lodMinClamp = e.lodMinClamp, this.lodMaxClamp = e.lodMaxClamp, this.compare = e.compare, this.maxAnisotropy = (l = e.maxAnisotropy) != null ? l : 1;
  }
  set addressMode(e) {
    this.addressModeU = e, this.addressModeV = e, this.addressModeW = e;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this.addressModeU;
  }
  set wrapMode(e) {
    rt(dn, "TextureStyle.wrapMode is now TextureStyle.addressMode"), this.addressMode = e;
  }
  get wrapMode() {
    return this.addressMode;
  }
  set scaleMode(e) {
    this.magFilter = e, this.minFilter = e, this.mipmapFilter = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this.magFilter;
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(e) {
    this._maxAnisotropy = Math.min(e, 16), this._maxAnisotropy > 1 && (this.scaleMode = "linear");
  }
  get maxAnisotropy() {
    return this._maxAnisotropy;
  }
  // TODO - move this to WebGL?
  get _resourceId() {
    return this._sharedResourceId || this._generateResourceId();
  }
  update() {
    this._sharedResourceId = null, this.emit("change", this);
  }
  _generateResourceId() {
    const e = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
    return this._sharedResourceId = _K(e), this._resourceId;
  }
  /** Destroys the style */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this.removeAllListeners();
  }
};
vS.defaultOptions = {
  addressMode: "clamp-to-edge",
  scaleMode: "linear"
};
let kp = vS;
const xS = class wS extends bi {
  /**
   * @param options - options for creating a new TextureSource
   */
  constructor(e = {}) {
    var o, r, a, l, d, c;
    super(), this.options = e, this._gpuData = /* @__PURE__ */ Object.create(null), this._gcLastUsed = -1, this.uid = Nt("textureSource"), this._resourceType = "textureSource", this._resourceId = Nt("resource"), this.uploadMethodId = "unknown", this._resolution = 1, this.pixelWidth = 1, this.pixelHeight = 1, this.width = 1, this.height = 1, this.sampleCount = 1, this.mipLevelCount = 1, this.autoGenerateMipmaps = !1, this.format = "rgba8unorm", this.dimension = "2d", this.viewDimension = "2d", this.arrayLayerCount = 1, this.depth = 1, this._ownsStyle = !1, this.antialias = !1, this.transient = !1, this.storage = !1, this._batchTick = -1, this._textureBindLocation = -1;
    const t = e;
    e = { ...wS.defaultOptions, ...e };
    const i = SK(e), s = i === "3d" || i === "1d" ? i : "2d";
    MK(t, i, s), this.label = (o = e.label) != null ? o : "", this.resource = e.resource, this.autoGarbageCollect = e.autoGarbageCollect, this._resolution = e.resolution, e.width ? this.pixelWidth = e.width * this._resolution : this.pixelWidth = this.resource && (r = this.resourceWidth) != null ? r : 1, e.height ? this.pixelHeight = e.height * this._resolution : this.pixelHeight = this.resource && (a = this.resourceHeight) != null ? a : 1, this.width = this.pixelWidth / this._resolution, this.height = this.pixelHeight / this._resolution, this.format = e.format, this.dimension = s, this.viewDimension = i, this.arrayLayerCount = e.arrayLayerCount, this.depth = s === "3d" && (l = e.depth) != null ? l : 1, this.mipLevelCount = e.mipLevelCount, this.autoGenerateMipmaps = e.autoGenerateMipmaps, this.sampleCount = e.sampleCount, this.antialias = s === "3d" ? !1 : e.antialias, this.transient = (d = e.transient) != null ? d : !1, this.storage = (c = e.storage) != null ? c : !1, this.alphaMode = e.alphaMode, this.style = new kp(bS(e)), this._ownsStyle = !0, this.destroyed = !1, this._refreshPOT();
  }
  /**
   * The size along z that the GPU allocates: {@link TextureSource#depth} for a 3D texture,
   * {@link TextureSource#arrayLayerCount} otherwise. WebGPU's `depthOrArrayLayers`.
   */
  get depthOrArrayLayers() {
    return this.dimension === "3d" ? this.depth : this.arrayLayerCount || 1;
  }
  /** returns itself */
  get source() {
    return this;
  }
  /** the style of the texture */
  get style() {
    return this._style;
  }
  set style(e) {
    var t, i;
    this.style !== e && (this._ownsStyle = !1, (t = this._style) == null || t.off("change", this._onStyleChange, this), this._style = e, (i = this._style) == null || i.on("change", this._onStyleChange, this), this._onStyleChange());
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(e) {
    this._style.maxAnisotropy = e;
  }
  get maxAnisotropy() {
    return this._style.maxAnisotropy;
  }
  /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this._style.addressMode;
  }
  set addressMode(e) {
    this._style.addressMode = e;
  }
  /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */
  get repeatMode() {
    return this._style.addressMode;
  }
  set repeatMode(e) {
    this._style.addressMode = e;
  }
  /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */
  get magFilter() {
    return this._style.magFilter;
  }
  set magFilter(e) {
    this._style.magFilter = e;
  }
  /** Specifies the sampling behavior when the sample footprint is larger than one texel. */
  get minFilter() {
    return this._style.minFilter;
  }
  set minFilter(e) {
    this._style.minFilter = e;
  }
  /** Specifies behavior for sampling between mipmap levels. */
  get mipmapFilter() {
    return this._style.mipmapFilter;
  }
  set mipmapFilter(e) {
    this._style.mipmapFilter = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMinClamp() {
    return this._style.lodMinClamp;
  }
  set lodMinClamp(e) {
    this._style.lodMinClamp = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMaxClamp() {
    return this._style.lodMaxClamp;
  }
  set lodMaxClamp(e) {
    this._style.lodMaxClamp = e;
  }
  _onStyleChange() {
    this.emit("styleChange", this);
  }
  /** call this if you have modified the texture outside of the constructor */
  update() {
    if (this.resource) {
      const e = this._resolution;
      if (this.resize(this.resourceWidth / e, this.resourceHeight / e)) return;
    }
    this.emit("update", this);
  }
  /** Destroys this texture source */
  destroy() {
    this.destroyed = !0, this.unload(), this.emit("destroy", this), this._style && (this._ownsStyle && this._style.destroy(), this._style = null), this.uploadMethodId = null, this.resource = null, this.removeAllListeners();
  }
  /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */
  unload() {
    var e, t;
    this._resourceId = Nt("resource"), this.emit("change", this), this.emit("unload", this);
    for (const i in this._gpuData)
      (t = (e = this._gpuData[i]) == null ? void 0 : e.destroy) == null || t.call(e);
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /** the width of the resource. This is the REAL pure number, not accounting resolution   */
  get resourceWidth() {
    const { resource: e } = this;
    return e.naturalWidth || e.videoWidth || e.displayWidth || e.width;
  }
  /** the height of the resource. This is the REAL pure number, not accounting resolution */
  get resourceHeight() {
    const { resource: e } = this;
    return e.naturalHeight || e.videoHeight || e.displayHeight || e.height;
  }
  /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._resolution !== e && (this._resolution = e, this.width = this.pixelWidth / e, this.height = this.pixelHeight / e);
  }
  /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */
  resize(e, t, i) {
    i || (i = this._resolution), e || (e = this.width), t || (t = this.height);
    const s = Math.round(e * i), o = Math.round(t * i);
    return this.width = s / i, this.height = o / i, this._resolution = i, this.pixelWidth === s && this.pixelHeight === o ? !1 : (this._refreshPOT(), this.pixelWidth = s, this.pixelHeight = o, this.emit("resize", this), this._resourceId = Nt("resource"), this.emit("change", this), !0);
  }
  /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */
  updateMipmaps() {
    this.autoGenerateMipmaps && this.mipLevelCount > 1 && this.emit("updateMipmaps", this);
  }
  set wrapMode(e) {
    this._style.wrapMode = e;
  }
  get wrapMode() {
    return this._style.wrapMode;
  }
  set scaleMode(e) {
    this._style.scaleMode = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this._style.scaleMode;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = $l(this.pixelWidth) && $l(this.pixelHeight);
  }
  static test(e) {
    throw new Error("Unimplemented");
  }
};
xS.defaultOptions = {
  resolution: 1,
  format: "bgra8unorm",
  alphaMode: "premultiply-alpha-on-upload",
  arrayLayerCount: 1,
  mipLevelCount: 1,
  autoGenerateMipmaps: !1,
  sampleCount: 1,
  antialias: !1,
  autoGarbageCollect: !1
};
let un = xS;
function SK(n) {
  return n.viewDimension ? n.viewDimension : n.depth ? "3d" : n.arrayLayerCount > 1 ? "2d-array" : "2d";
}
function MK(n, e, t) {
  if (n.depth !== void 0 && typeof n.depth != "number")
    throw new Error(`[TextureSource] depth is a 3D texture's depth in texels, but got ${n.depth}. For a depth buffer, use the depth option of a RenderTarget or the renderer.`);
  if (n.depth && n.arrayLayerCount > 1)
    throw new Error("[TextureSource] depth and arrayLayerCount can't be combined: use depth for a 3D texture or arrayLayerCount for a 2D array.");
  if (n.depth && e !== "3d")
    throw new Error(`[TextureSource] depth makes a 3D texture, but viewDimension is '${e}'. Use arrayLayerCount for layered textures.`);
  if (e === "3d" && n.arrayLayerCount > 1)
    throw new Error("[TextureSource] a 3D texture takes depth, not arrayLayerCount.");
  if (n.dimensions && n.dimensions !== t)
    throw new Error(`[TextureSource] dimensions '${n.dimensions}' doesn't match viewDimension '${e}'. Leave dimensions out; it is derived from the view.`);
  if (n.dimensions && rt(kK, "TextureSource dimensions is derived from viewDimension and depth; leave it out."), t === "3d" && n.antialias)
    throw new Error("[TextureSource] a 3D texture can't be antialiased: WebGPU has no multisampled 3D textures.");
}
class Y1 extends un {
  constructor(e) {
    var r, a;
    const t = (a = (r = e.depth) != null ? r : e.arrayLayerCount) != null ? a : 1, i = e.resource || new Float32Array(e.width * e.height * t * 4);
    let s = e.format;
    s || (i instanceof Float32Array ? s = "rgba32float" : i instanceof Int32Array || i instanceof Uint32Array ? s = "rgba32uint" : i instanceof Int16Array || i instanceof Uint16Array ? s = "rgba16uint" : (i instanceof Int8Array, s = "bgra8unorm"));
    const o = Gv(s) || t > 1;
    super({
      ...o && { alphaMode: "no-premultiply-alpha" },
      ...e,
      resource: i,
      format: s
    }), this.uploadMethodId = "buffer", this._updateStart = 0, this._updateEnd = 1 / 0;
  }
  /**
   * Uploads the buffer to the GPU. Call this after changing the data in {@link TextureSource#resource}.
   *
   * The buffer is a flat list of texels in row-major order, so texel `i` sits at
   * `x = i % width`, `y = floor(i / width)`. Pass a texel range to upload only that part of
   * the texture; leave it out to upload everything.
   *
   * The upload happens immediately for every renderer that already holds the texture, and the
   * range applies to this call only. If you change several parts of the buffer, track the dirty
   * span yourself and call `update` once with the combined range. Each call has a fixed cost on
   * top of the bytes it moves, which reaches tens of microseconds on some mobile GPUs. One span
   * usually beats many small calls.
   *
   * Partial uploads assume the buffer holds exactly `width * height` texels. A 3D texture or 2D array
   * always uploads whole, so it takes no range.
   * @example
   * ```ts
   * const data = new Float32Array(4096 * 64 * 4);
   * const source = new BufferImageSource({ resource: data, width: 4096, height: 64 });
   *
   * // change texels 100 to 115 (4 floats per rgba32float texel)
   * data.fill(1, 100 * 4, 116 * 4);
   *
   * // upload only those 16 texels
   * source.update(100, 116);
   * ```
   * @param start - index of the first texel to upload
   * @param end - index one past the last texel to upload (exclusive, like `TypedArray.subarray`)
   */
  update(e = 0, t = 1 / 0) {
    if ((e > 0 || t < 1 / 0) && this.depthOrArrayLayers > 1)
      throw new Error("[BufferImageSource] a 3D texture or 2D array uploads whole: call update() with no range.");
    this._updateStart = e, this._updateEnd = t, super.update(), this._updateStart = 0, this._updateEnd = 1 / 0;
  }
  static test(e) {
    return e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array;
  }
}
Y1.extension = Ae.TextureSource;
const bk = new ot();
class kS {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(e, t) {
    this.mapCoord = new ot(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._updateID = 0, this.clampOffset = 0, typeof t == "undefined" ? this.clampMargin = e.width < 10 ? 0 : 0.5 : this.clampMargin = t, this.isSimple = !1, this.texture = e;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    var t;
    this._texture !== e && ((t = this._texture) == null || t.removeListener("update", this.update, this), this._texture = e, this._texture.addListener("update", this.update, this)), this.update();
  }
  /** Releases the observed texture, removing the `update` listener from it. */
  destroy() {
    var e;
    (e = this._texture) == null || e.removeListener("update", this.update, this), this._texture = null;
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(e, t) {
    t === void 0 && (t = e);
    const i = this.mapCoord;
    for (let s = 0; s < e.length; s += 2) {
      const o = e[s], r = e[s + 1];
      t[s] = o * i.a + r * i.c + i.tx, t[s + 1] = o * i.b + r * i.d + i.ty;
    }
    return t;
  }
  /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */
  update() {
    const e = this._texture;
    this._updateID++;
    const t = e.uvs;
    this.mapCoord.set(t.x1 - t.x0, t.y1 - t.y0, t.x3 - t.x0, t.y3 - t.y0, t.x0, t.y0);
    const i = e.orig, s = e.trim;
    s && (bk.set(
      i.width / s.width,
      0,
      0,
      i.height / s.height,
      -s.x / s.width,
      -s.y / s.height
    ), this.mapCoord.append(bk));
    const o = e.source, r = this.uClampFrame, a = this.clampMargin / o._resolution, l = this.clampOffset / o._resolution;
    return r[0] = (e.frame.x + a + l) / o.width, r[1] = (e.frame.y + a + l) / o.height, r[2] = (e.frame.x + e.frame.width - a + l) / o.width, r[3] = (e.frame.y + e.frame.height - a + l) / o.height, this.uClampOffset[0] = this.clampOffset / o.pixelWidth, this.uClampOffset[1] = this.clampOffset / o.pixelHeight, this.isSimple = e.frame.width === o.width && e.frame.height === o.height && e.rotate === 0, !0;
  }
}
class et extends bi {
  /**
   * @param {TextureOptions} options - Options for the texture
   */
  constructor({
    source: e,
    label: t,
    frame: i,
    orig: s,
    trim: o,
    defaultAnchor: r,
    defaultBorders: a,
    rotate: l,
    dynamic: d
  } = {}) {
    var c;
    if (super(), this.uid = Nt("texture"), this.uvs = { x0: 0, y0: 0, x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0 }, this.frame = new Tt(), this.noFrame = !1, this.dynamic = !1, this.isTexture = !0, this.label = t, this.source = (c = e == null ? void 0 : e.source) != null ? c : new un(), this.noFrame = !i, i)
      this.frame.copyFrom(i);
    else {
      const { width: h, height: f } = this._source;
      this.frame.width = h, this.frame.height = f;
    }
    this.orig = s || this.frame, this.trim = o, this.rotate = l != null ? l : 0, this.defaultAnchor = r, this.defaultBorders = a, this.destroyed = !1, this.dynamic = d || !1, this.updateUvs();
  }
  set source(e) {
    this._source && this._source.off("resize", this.update, this), this._source = e, e.on("resize", this.update, this), this.emit("update", this);
  }
  /** the underlying source of the texture (equivalent of baseTexture in v7) */
  get source() {
    return this._source;
  }
  /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */
  get textureMatrix() {
    return this._textureMatrix || (this._textureMatrix = new kS(this)), this._textureMatrix;
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Call this function when you have modified the frame of this texture. */
  updateUvs() {
    const { uvs: e, frame: t } = this, { width: i, height: s } = this._source, o = t.x / i, r = t.y / s, a = t.width / i, l = t.height / s;
    let d = this.rotate;
    if (d) {
      const c = a / 2, h = l / 2, f = o + c, p = r + h;
      d = Mt.add(d, Mt.NW), e.x0 = f + c * Mt.uX(d), e.y0 = p + h * Mt.uY(d), d = Mt.add(d, 2), e.x1 = f + c * Mt.uX(d), e.y1 = p + h * Mt.uY(d), d = Mt.add(d, 2), e.x2 = f + c * Mt.uX(d), e.y2 = p + h * Mt.uY(d), d = Mt.add(d, 2), e.x3 = f + c * Mt.uX(d), e.y3 = p + h * Mt.uY(d);
    } else
      e.x0 = o, e.y0 = r, e.x1 = o + a, e.y1 = r, e.x2 = o + a, e.y2 = r + l, e.x3 = o, e.y3 = r + l;
  }
  /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */
  destroy(e = !1) {
    this._source && (this._source.off("resize", this.update, this), e && (this._source.destroy(), this._source = null)), this._textureMatrix = null, this.destroyed = !0, this.emit("destroy", this), this.removeAllListeners();
  }
  /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */
  update() {
    this.noFrame && (this.frame.width = this._source.width, this.frame.height = this._source.height), this.updateUvs(), this.emit("update", this);
  }
  /** @deprecated since 8.0.0 */
  get baseTexture() {
    return rt(dn, "Texture.baseTexture is now Texture.source"), this._source;
  }
}
et.EMPTY = new et({
  label: "EMPTY",
  source: new un({
    label: "EMPTY"
  })
});
et.EMPTY.destroy = gS;
et.WHITE = new et({
  source: new Y1({
    resource: new Uint8Array([255, 255, 255, 255]),
    width: 1,
    height: 1,
    alphaMode: "premultiply-alpha-on-upload",
    label: "WHITE"
  }),
  label: "WHITE"
});
et.WHITE.destroy = gS;
function TK(n, e, t) {
  const { width: i, height: s } = t.orig, o = t.trim;
  if (o) {
    const r = o.width, a = o.height;
    n.minX = o.x - e._x * i, n.maxX = n.minX + r, n.minY = o.y - e._y * s, n.maxY = n.minY + a;
  } else
    n.minX = -e._x * i, n.maxX = n.minX + i, n.minY = -e._y * s, n.maxY = n.minY + s;
}
const vk = new ot();
class Gn {
  /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */
  constructor(e = 1 / 0, t = 1 / 0, i = -1 / 0, s = -1 / 0) {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = vk, this.minX = e, this.minY = t, this.maxX = i, this.maxY = s;
  }
  /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */
  get rectangle() {
    this._rectangle || (this._rectangle = new Tt());
    const e = this._rectangle;
    return this.minX > this.maxX || this.minY > this.maxY ? (e.x = 0, e.y = 0, e.width = 0, e.height = 0) : e.copyFromBounds(this), e;
  }
  /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */
  clear() {
    return this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = vk, this;
  }
  /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */
  set(e, t, i, s) {
    this.minX = e, this.minY = t, this.maxX = i, this.maxY = s;
  }
  /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */
  addFrame(e, t, i, s, o) {
    o || (o = this.matrix);
    const r = o.a, a = o.b, l = o.c, d = o.d, c = o.tx, h = o.ty;
    let f = this.minX, p = this.minY, y = this.maxX, v = this.maxY, x = r * e + l * t + c, w = a * e + d * t + h;
    x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), x = r * i + l * t + c, w = a * i + d * t + h, x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), x = r * e + l * s + c, w = a * e + d * s + h, x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), x = r * i + l * s + c, w = a * i + d * s + h, x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), this.minX = f, this.minY = p, this.maxX = y, this.maxY = v;
  }
  /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */
  addRect(e, t) {
    this.addFrame(e.x, e.y, e.x + e.width, e.y + e.height, t);
  }
  /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */
  addBounds(e, t) {
    this.addFrame(e.minX, e.minY, e.maxX, e.maxY, t);
  }
  /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */
  addBoundsMask(e) {
    this.minX = this.minX > e.minX ? this.minX : e.minX, this.minY = this.minY > e.minY ? this.minY : e.minY, this.maxX = this.maxX < e.maxX ? this.maxX : e.maxX, this.maxY = this.maxY < e.maxY ? this.maxY : e.maxY;
  }
  /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */
  applyMatrix(e) {
    const t = this.minX, i = this.minY, s = this.maxX, o = this.maxY, { a: r, b: a, c: l, d, tx: c, ty: h } = e;
    let f = r * t + l * i + c, p = a * t + d * i + h;
    this.minX = f, this.minY = p, this.maxX = f, this.maxY = p, f = r * s + l * i + c, p = a * s + d * i + h, this.minX = f < this.minX ? f : this.minX, this.minY = p < this.minY ? p : this.minY, this.maxX = f > this.maxX ? f : this.maxX, this.maxY = p > this.maxY ? p : this.maxY, f = r * t + l * o + c, p = a * t + d * o + h, this.minX = f < this.minX ? f : this.minX, this.minY = p < this.minY ? p : this.minY, this.maxX = f > this.maxX ? f : this.maxX, this.maxY = p > this.maxY ? p : this.maxY, f = r * s + l * o + c, p = a * s + d * o + h, this.minX = f < this.minX ? f : this.minX, this.minY = p < this.minY ? p : this.minY, this.maxX = f > this.maxX ? f : this.maxX, this.maxY = p > this.maxY ? p : this.maxY;
  }
  /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */
  fit(e) {
    return this.minX < e.left && (this.minX = e.left), this.maxX > e.right && (this.maxX = e.right), this.minY < e.top && (this.minY = e.top), this.maxY > e.bottom && (this.maxY = e.bottom), this;
  }
  /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */
  fitBounds(e, t, i, s) {
    return this.minX < e && (this.minX = e), this.maxX > t && (this.maxX = t), this.minY < i && (this.minY = i), this.maxY > s && (this.maxY = s), this;
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */
  pad(e, t = e) {
    return this.minX -= e, this.maxX += e, this.minY -= t, this.maxY += t, this;
  }
  /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */
  ceil() {
    return this.minX = Math.floor(this.minX), this.minY = Math.floor(this.minY), this.maxX = Math.ceil(this.maxX), this.maxY = Math.ceil(this.maxY), this;
  }
  /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */
  clone() {
    return new Gn(this.minX, this.minY, this.maxX, this.maxY);
  }
  /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */
  scale(e, t = e) {
    return this.minX *= e, this.minY *= t, this.maxX *= e, this.maxY *= t, this;
  }
  /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */
  get x() {
    return this.minX;
  }
  set x(e) {
    const t = this.maxX - this.minX;
    this.minX = e, this.maxX = e + t;
  }
  /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */
  get y() {
    return this.minY;
  }
  set y(e) {
    const t = this.maxY - this.minY;
    this.minY = e, this.maxY = e + t;
  }
  /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */
  get width() {
    return this.maxX - this.minX;
  }
  set width(e) {
    this.maxX = this.minX + e;
  }
  /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */
  get height() {
    return this.maxY - this.minY;
  }
  set height(e) {
    this.maxY = this.minY + e;
  }
  /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */
  get left() {
    return this.minX;
  }
  /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */
  get right() {
    return this.maxX;
  }
  /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */
  get top() {
    return this.minY;
  }
  /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */
  get bottom() {
    return this.maxY;
  }
  /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */
  get isPositive() {
    return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
  }
  /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */
  get isValid() {
    return this.minX + this.minY !== 1 / 0;
  }
  /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */
  addVertexData(e, t, i, s) {
    let o = this.minX, r = this.minY, a = this.maxX, l = this.maxY;
    s || (s = this.matrix);
    const d = s.a, c = s.b, h = s.c, f = s.d, p = s.tx, y = s.ty;
    for (let v = t; v < i; v += 2) {
      const x = e[v], w = e[v + 1], S = d * x + h * w + p, M = c * x + f * w + y;
      o = S < o ? S : o, r = M < r ? M : r, a = S > a ? S : a, l = M > l ? M : l;
    }
    this.minX = o, this.minY = r, this.maxX = a, this.maxY = l;
  }
  /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */
  containsPoint(e, t) {
    return this.minX <= e && this.minY <= t && this.maxX >= e && this.maxY >= t;
  }
  /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */
  toString() {
    return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
  }
  /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */
  copyFrom(e) {
    return this.minX = e.minX, this.minY = e.minY, this.maxX = e.maxX, this.maxY = e.maxY, this;
  }
}
var CK = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, Ps = function(n) {
  return typeof n == "string" ? n.length > 0 : typeof n == "number";
}, Pn = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = Math.pow(10, e)), Math.round(t * n) / t + 0;
}, Di = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 1), n > t ? t : n > e ? n : e;
}, _S = function(n) {
  return (n = isFinite(n) ? n % 360 : 0) > 0 ? n : n + 360;
}, yk = function(n) {
  return { r: Di(n.r, 0, 255), g: Di(n.g, 0, 255), b: Di(n.b, 0, 255), a: Di(n.a) };
}, kg = function(n) {
  return { r: Pn(n.r), g: Pn(n.g), b: Pn(n.b), a: Pn(n.a, 3) };
}, IK = /^#([0-9a-f]{3,8})$/i, ih = function(n) {
  var e = n.toString(16);
  return e.length < 2 ? "0" + e : e;
}, SS = function(n) {
  var e = n.r, t = n.g, i = n.b, s = n.a, o = Math.max(e, t, i), r = o - Math.min(e, t, i), a = r ? o === e ? (t - i) / r : o === t ? 2 + (i - e) / r : 4 + (e - t) / r : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: o ? r / o * 100 : 0, v: o / 255 * 100, a: s };
}, MS = function(n) {
  var e = n.h, t = n.s, i = n.v, s = n.a;
  e = e / 360 * 6, t /= 100, i /= 100;
  var o = Math.floor(e), r = i * (1 - t), a = i * (1 - (e - o) * t), l = i * (1 - (1 - e + o) * t), d = o % 6;
  return { r: 255 * [i, a, r, r, l, i][d], g: 255 * [l, i, i, a, r, r][d], b: 255 * [r, r, l, i, i, a][d], a: s };
}, xk = function(n) {
  return { h: _S(n.h), s: Di(n.s, 0, 100), l: Di(n.l, 0, 100), a: Di(n.a) };
}, wk = function(n) {
  return { h: Pn(n.h), s: Pn(n.s), l: Pn(n.l), a: Pn(n.a, 3) };
}, kk = function(n) {
  return MS((t = (e = n).s, { h: e.h, s: (t *= ((i = e.l) < 50 ? i : 100 - i) / 100) > 0 ? 2 * t / (i + t) * 100 : 0, v: i + t, a: e.a }));
  var e, t, i;
}, gc = function(n) {
  return { h: (e = SS(n)).h, s: (s = (200 - (t = e.s)) * (i = e.v) / 100) > 0 && s < 200 ? t * i / 100 / (s <= 100 ? s : 200 - s) * 100 : 0, l: s / 2, a: e.a };
  var e, t, i, s;
}, AK = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, PK = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, EK = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, RK = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, jv = { string: [[function(n) {
  var e = IK.exec(n);
  return e ? (n = e[1]).length <= 4 ? { r: parseInt(n[0] + n[0], 16), g: parseInt(n[1] + n[1], 16), b: parseInt(n[2] + n[2], 16), a: n.length === 4 ? Pn(parseInt(n[3] + n[3], 16) / 255, 2) : 1 } : n.length === 6 || n.length === 8 ? { r: parseInt(n.substr(0, 2), 16), g: parseInt(n.substr(2, 2), 16), b: parseInt(n.substr(4, 2), 16), a: n.length === 8 ? Pn(parseInt(n.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(n) {
  var e = EK.exec(n) || RK.exec(n);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : yk({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(n) {
  var e = AK.exec(n) || PK.exec(n);
  if (!e) return null;
  var t, i, s = xk({ h: (t = e[1], i = e[2], i === void 0 && (i = "deg"), Number(t) * (CK[i] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return kk(s);
}, "hsl"]], object: [[function(n) {
  var e = n.r, t = n.g, i = n.b, s = n.a, o = s === void 0 ? 1 : s;
  return Ps(e) && Ps(t) && Ps(i) ? yk({ r: Number(e), g: Number(t), b: Number(i), a: Number(o) }) : null;
}, "rgb"], [function(n) {
  var e = n.h, t = n.s, i = n.l, s = n.a, o = s === void 0 ? 1 : s;
  if (!Ps(e) || !Ps(t) || !Ps(i)) return null;
  var r = xk({ h: Number(e), s: Number(t), l: Number(i), a: Number(o) });
  return kk(r);
}, "hsl"], [function(n) {
  var e = n.h, t = n.s, i = n.v, s = n.a, o = s === void 0 ? 1 : s;
  if (!Ps(e) || !Ps(t) || !Ps(i)) return null;
  var r = (function(a) {
    return { h: _S(a.h), s: Di(a.s, 0, 100), v: Di(a.v, 0, 100), a: Di(a.a) };
  })({ h: Number(e), s: Number(t), v: Number(i), a: Number(o) });
  return MS(r);
}, "hsv"]] }, _k = function(n, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t][0](n);
    if (i) return [i, e[t][1]];
  }
  return [null, void 0];
}, zK = function(n) {
  return typeof n == "string" ? _k(n.trim(), jv.string) : typeof n == "object" && n !== null ? _k(n, jv.object) : [null, void 0];
}, _g = function(n, e) {
  var t = gc(n);
  return { h: t.h, s: Di(t.s + 100 * e, 0, 100), l: t.l, a: t.a };
}, Sg = function(n) {
  return (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 / 255;
}, Sk = function(n, e) {
  var t = gc(n);
  return { h: t.h, s: t.s, l: Di(t.l + 100 * e, 0, 100), a: t.a };
}, Hv = (function() {
  function n(e) {
    this.parsed = zK(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return n.prototype.isValid = function() {
    return this.parsed !== null;
  }, n.prototype.brightness = function() {
    return Pn(Sg(this.rgba), 2);
  }, n.prototype.isDark = function() {
    return Sg(this.rgba) < 0.5;
  }, n.prototype.isLight = function() {
    return Sg(this.rgba) >= 0.5;
  }, n.prototype.toHex = function() {
    return e = kg(this.rgba), t = e.r, i = e.g, s = e.b, r = (o = e.a) < 1 ? ih(Pn(255 * o)) : "", "#" + ih(t) + ih(i) + ih(s) + r;
    var e, t, i, s, o, r;
  }, n.prototype.toRgb = function() {
    return kg(this.rgba);
  }, n.prototype.toRgbString = function() {
    return e = kg(this.rgba), t = e.r, i = e.g, s = e.b, (o = e.a) < 1 ? "rgba(" + t + ", " + i + ", " + s + ", " + o + ")" : "rgb(" + t + ", " + i + ", " + s + ")";
    var e, t, i, s, o;
  }, n.prototype.toHsl = function() {
    return wk(gc(this.rgba));
  }, n.prototype.toHslString = function() {
    return e = wk(gc(this.rgba)), t = e.h, i = e.s, s = e.l, (o = e.a) < 1 ? "hsla(" + t + ", " + i + "%, " + s + "%, " + o + ")" : "hsl(" + t + ", " + i + "%, " + s + "%)";
    var e, t, i, s, o;
  }, n.prototype.toHsv = function() {
    return e = SS(this.rgba), { h: Pn(e.h), s: Pn(e.s), v: Pn(e.v), a: Pn(e.a, 3) };
    var e;
  }, n.prototype.invert = function() {
    return hs({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, n.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), hs(_g(this.rgba, e));
  }, n.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), hs(_g(this.rgba, -e));
  }, n.prototype.grayscale = function() {
    return hs(_g(this.rgba, -1));
  }, n.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), hs(Sk(this.rgba, e));
  }, n.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), hs(Sk(this.rgba, -e));
  }, n.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, n.prototype.alpha = function(e) {
    return typeof e == "number" ? hs({ r: (t = this.rgba).r, g: t.g, b: t.b, a: e }) : Pn(this.rgba.a, 3);
    var t;
  }, n.prototype.hue = function(e) {
    var t = gc(this.rgba);
    return typeof e == "number" ? hs({ h: e, s: t.s, l: t.l, a: t.a }) : Pn(t.h);
  }, n.prototype.isEqual = function(e) {
    return this.toHex() === hs(e).toHex();
  }, n;
})(), hs = function(n) {
  return n instanceof Hv ? n : new Hv(n);
}, Mk = [], $K = function(n) {
  n.forEach(function(e) {
    Mk.indexOf(e) < 0 && (e(Hv, jv), Mk.push(e));
  });
};
function DK(n, e) {
  var t = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, i = {};
  for (var s in t) i[t[s]] = s;
  var o = {};
  n.prototype.toName = function(r) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var a, l, d = i[this.toHex()];
    if (d) return d;
    if (r != null && r.closest) {
      var c = this.toRgb(), h = 1 / 0, f = "black";
      if (!o.length) for (var p in t) o[p] = new n(t[p]).toRgb();
      for (var y in t) {
        var v = (a = c, l = o[y], Math.pow(a.r - l.r, 2) + Math.pow(a.g - l.g, 2) + Math.pow(a.b - l.b, 2));
        v < h && (h = v, f = y);
      }
      return f;
    }
  }, e.string.push([function(r) {
    var a = r.toLowerCase(), l = a === "transparent" ? "#0000" : t[a];
    return l ? new n(l).toRgb() : null;
  }, "name"]);
}
$K([DK]);
const Dl = class qd {
  /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(e = 16777215) {
    this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = e;
  }
  /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */
  get red() {
    return this._components[0];
  }
  /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */
  get green() {
    return this._components[1];
  }
  /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */
  get blue() {
    return this._components[2];
  }
  /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */
  get alpha() {
    return this._components[3];
  }
  /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */
  setValue(e) {
    return this.value = e, this;
  }
  /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */
  set value(e) {
    if (e instanceof qd)
      this._value = this._cloneSource(e._value), this._int = e._int, this._components.set(e._components);
    else {
      if (e === null)
        throw new Error("Cannot set Color#value to null");
      (this._value === null || !this._isSourceEqual(this._value, e)) && (this._value = this._cloneSource(e), this._normalize(this._value));
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  _cloneSource(e) {
    return typeof e == "string" || typeof e == "number" || e instanceof Number || e === null ? e : Array.isArray(e) || ArrayBuffer.isView(e) ? e.slice(0) : typeof e == "object" && e !== null ? { ...e } : e;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  _isSourceEqual(e, t) {
    const i = typeof e;
    if (i !== typeof t)
      return !1;
    if (i === "number" || i === "string" || e instanceof Number)
      return e === t;
    if (Array.isArray(e) && Array.isArray(t) || ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return e.length !== t.length ? !1 : e.every((o, r) => o === t[r]);
    if (e !== null && t !== null) {
      const o = Object.keys(e), r = Object.keys(t);
      return o.length !== r.length ? !1 : o.every((a) => e[a] === t[a]);
    }
    return e === t;
  }
  /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */
  toRgba() {
    const [e, t, i, s] = this._components;
    return { r: e, g: t, b: i, a: s };
  }
  /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */
  toRgb() {
    const [e, t, i] = this._components;
    return { r: e, g: t, b: i };
  }
  /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */
  toRgbaString() {
    const [e, t, i] = this.toUint8RgbArray();
    return `rgba(${e},${t},${i},${this.alpha})`;
  }
  /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */
  toUint8RgbArray(e) {
    const [t, i, s] = this._components;
    return this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb), e[0] = Math.round(t * 255), e[1] = Math.round(i * 255), e[2] = Math.round(s * 255), e;
  }
  /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */
  toArray(e) {
    this._arrayRgba || (this._arrayRgba = []), e || (e = this._arrayRgba);
    const [t, i, s, o] = this._components;
    return e[0] = t, e[1] = i, e[2] = s, e[3] = o, e;
  }
  /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */
  toRgbArray(e) {
    this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb);
    const [t, i, s] = this._components;
    return e[0] = t, e[1] = i, e[2] = s, e;
  }
  /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */
  toBgrNumber() {
    const [e, t, i] = this.toUint8RgbArray();
    return (i << 16) + (t << 8) + e;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */
  toLittleEndianNumber() {
    const e = this._int;
    return (e >> 16) + (e & 65280) + ((e & 255) << 16);
  }
  /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  multiply(e) {
    const [t, i, s, o] = qd._temp.setValue(e)._components;
    return this._components[0] *= t, this._components[1] *= i, this._components[2] *= s, this._components[3] *= o, this._refreshInt(), this._value = null, this;
  }
  /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  premultiply(e, t = !0) {
    return t && (this._components[0] *= e, this._components[1] *= e, this._components[2] *= e), this._components[3] = e, this._refreshInt(), this._value = null, this;
  }
  /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */
  toPremultiplied(e, t = !0) {
    if (e === 1)
      return (255 << 24) + this._int;
    if (e === 0)
      return t ? 0 : this._int;
    let i = this._int >> 16 & 255, s = this._int >> 8 & 255, o = this._int & 255;
    return t && (i = i * e + 0.5 | 0, s = s * e + 0.5 | 0, o = o * e + 0.5 | 0), (e * 255 << 24) + (i << 16) + (s << 8) + o;
  }
  /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */
  toHex() {
    const e = this._int.toString(16);
    return `#${"000000".substring(0, 6 - e.length) + e}`;
  }
  /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */
  toHexa() {
    const t = Math.round(this._components[3] * 255).toString(16);
    return this.toHex() + "00".substring(0, 2 - t.length) + t;
  }
  /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */
  setAlpha(e) {
    return this._components[3] = this._clamp(e), this._value = null, this;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  _normalize(e) {
    let t, i, s, o;
    if ((typeof e == "number" || e instanceof Number) && e >= 0 && e <= 16777215) {
      const r = e;
      t = (r >> 16 & 255) / 255, i = (r >> 8 & 255) / 255, s = (r & 255) / 255, o = 1;
    } else if ((Array.isArray(e) || e instanceof Float32Array) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e), [t, i, s, o = 1] = e;
    else if ((e instanceof Uint8Array || e instanceof Uint8ClampedArray) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e, 0, 255), [t, i, s, o = 255] = e, t /= 255, i /= 255, s /= 255, o /= 255;
    else if (typeof e == "string" || typeof e == "object") {
      if (typeof e == "string") {
        const a = qd.HEX_PATTERN.exec(e);
        a && (e = `#${a[2]}`);
      }
      const r = hs(e);
      r.isValid() && ({ r: t, g: i, b: s, a: o } = r.rgba, t /= 255, i /= 255, s /= 255);
    }
    if (t !== void 0)
      this._components[0] = t, this._components[1] = i, this._components[2] = s, this._components[3] = o, this._refreshInt();
    else
      throw new Error(`Unable to convert color ${e}`);
  }
  /** Refresh the internal color rgb number */
  _refreshInt() {
    this._clamp(this._components);
    const [e, t, i] = this._components;
    this._int = (e * 255 << 16) + (t * 255 << 8) + (i * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(e, t = 0, i = 1) {
    return typeof e == "number" ? Math.min(Math.max(e, t), i) : (e.forEach((s, o) => {
      e[o] = Math.min(Math.max(s, t), i);
    }), e);
  }
  /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */
  static isColorLike(e) {
    return typeof e == "number" || typeof e == "string" || e instanceof Number || e instanceof qd || Array.isArray(e) || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Float32Array || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 && e.a !== void 0;
  }
};
Dl.shared = new Dl();
Dl._temp = new Dl();
Dl.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let vn = Dl;
const OK = {
  cullArea: null,
  cullable: !1,
  cullableChildren: !0
};
let Mg = 0;
const Tk = 500;
function dt(...n) {
  Mg !== Tk && (Mg++, Mg === Tk ? console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.") : console.warn("PixiJS Warning: ", ...n));
}
const Yl = {
  /**
   * Set of registered pools and cleanable objects.
   * @private
   */
  _registeredResources: /* @__PURE__ */ new Set(),
  /**
   * Registers a pool or cleanable object for cleanup.
   * @param {Cleanable} pool - The pool or object to register.
   */
  register(n) {
    this._registeredResources.add(n);
  },
  /**
   * Unregisters a pool or cleanable object from cleanup.
   * @param {Cleanable} pool - The pool or object to unregister.
   */
  unregister(n) {
    this._registeredResources.delete(n);
  },
  /** Clears all registered pools and cleanable objects. This will call clear() on each registered item. */
  release() {
    this._registeredResources.forEach((n) => n.clear());
  },
  /**
   * Gets the number of registered pools and cleanable objects.
   * @returns {number} The count of registered items.
   */
  get registeredCount() {
    return this._registeredResources.size;
  },
  /**
   * Checks if a specific pool or cleanable object is registered.
   * @param {Cleanable} pool - The pool or object to check.
   * @returns {boolean} True if the item is registered, false otherwise.
   */
  isRegistered(n) {
    return this._registeredResources.has(n);
  },
  /**
   * Removes all registrations without clearing the pools.
   * Useful if you want to reset the collector without affecting the pools.
   */
  reset() {
    this._registeredResources.clear();
  }
};
class LK {
  /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */
  constructor(e, t) {
    this._pool = [], this._count = 0, this._index = 0, this._classType = e, t && this.prepopulate(t);
  }
  /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */
  prepopulate(e) {
    for (let t = 0; t < e; t++)
      this._pool[this._index++] = new this._classType();
    this._count += e;
  }
  /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {I} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e) {
    var i;
    let t;
    return this._index > 0 ? t = this._pool[--this._index] : (t = new this._classType(), this._count++), (i = t.init) == null || i.call(t, e), t;
  }
  /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */
  return(e) {
    var t;
    (t = e.reset) == null || t.call(e), this._pool[this._index++] = e;
  }
  /**
   * Gets the number of items in the pool.
   * @readonly
   */
  get totalSize() {
    return this._count;
  }
  /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */
  get totalFree() {
    return this._index;
  }
  /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */
  get totalUsed() {
    return this._count - this._index;
  }
  /** clears the pool */
  clear() {
    if (this._pool.length > 0 && this._pool[0].destroy)
      for (let e = 0; e < this._index; e++)
        this._pool[e].destroy();
    this._pool.length = 0, this._count = 0, this._index = 0;
  }
}
class BK {
  constructor() {
    this._poolsByClass = /* @__PURE__ */ new Map();
  }
  /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */
  prepopulate(e, t) {
    this.getPool(e).prepopulate(t);
  }
  /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e, t) {
    return this.getPool(e).get(t);
  }
  /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */
  return(e) {
    this.getPool(e.constructor).return(e);
  }
  /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */
  getPool(e) {
    return this._poolsByClass.has(e) || this._poolsByClass.set(e, new LK(e)), this._poolsByClass.get(e);
  }
  /** gets the usage stats of each pool in the system */
  stats() {
    const e = {};
    return this._poolsByClass.forEach((t) => {
      const i = e[t._classType.name] ? t._classType.name + t._classType.ID : t._classType.name;
      e[i] = {
        free: t.totalFree,
        used: t.totalUsed,
        size: t.totalSize
      };
    }), e;
  }
  /** Clears all pools in the group. This will reset all pools and free their resources. */
  clear() {
    this._poolsByClass.forEach((e) => e.clear()), this._poolsByClass.clear();
  }
}
const $n = new BK();
Yl.register($n);
const FK = {
  get isCachedAsTexture() {
    var n;
    return !!((n = this.renderGroup) != null && n.isCachedAsTexture);
  },
  cacheAsTexture(n) {
    typeof n == "boolean" && n === !1 ? this.disableRenderGroup() : (this.enableRenderGroup(), this.renderGroup.enableCacheAsTexture(n === !0 ? {} : n));
  },
  updateCacheTexture() {
    var n;
    (n = this.renderGroup) == null || n.updateCacheTexture();
  },
  get cacheAsBitmap() {
    return this.isCachedAsTexture;
  },
  set cacheAsBitmap(n) {
    rt("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead."), this.cacheAsTexture(n);
  }
};
function TS(n, e, t) {
  const i = n.length;
  let s;
  if (e >= i || t === 0)
    return;
  t = e + t > i ? i - e : t;
  const o = i - t;
  for (s = e; s < o; ++s)
    n[s] = n[s + t];
  n.length = o;
}
const NK = {
  allowChildren: !0,
  removeChildren(n = 0, e) {
    var o;
    const t = e != null ? e : this.children.length, i = t - n, s = [];
    if (i > 0 && i <= t) {
      for (let a = t - 1; a >= n; a--) {
        const l = this.children[a];
        l && (s.push(l), l.parent = null);
      }
      TS(this.children, n, t);
      const r = this.renderGroup || this.parentRenderGroup;
      r && r.removeChildren(s);
      for (let a = 0; a < s.length; ++a) {
        const l = s[a];
        (o = l.parentRenderLayer) == null || o.detach(l), this.emit("childRemoved", l, this, a), s[a].emit("removed", this);
      }
      return s.length > 0 && this._didViewChangeTick++, s;
    } else if (i === 0 && this.children.length === 0)
      return s;
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  },
  removeChildAt(n) {
    const e = this.getChildAt(n);
    return this.removeChild(e);
  },
  getChildAt(n) {
    if (n < 0 || n >= this.children.length)
      throw new Error(`getChildAt: Index (${n}) does not exist.`);
    return this.children[n];
  },
  setChildIndex(n, e) {
    if (e < 0 || e >= this.children.length)
      throw new Error(`The index ${e} supplied is out of bounds ${this.children.length}`);
    this.getChildIndex(n), this.addChildAt(n, e);
  },
  getChildIndex(n) {
    const e = this.children.indexOf(n);
    if (e === -1)
      throw new Error("The supplied Container must be a child of the caller");
    return e;
  },
  addChildAt(n, e) {
    this.allowChildren || rt(dn, "addChildAt: Only Containers will be allowed to add children in v8.0.0");
    const { children: t } = this;
    if (e < 0 || e > t.length)
      throw new Error(`${n}addChildAt: The index ${e} supplied is out of bounds ${t.length}`);
    const i = n.parent === this;
    if (n.parent) {
      const o = n.parent.children.indexOf(n);
      if (i) {
        if (o === e)
          return n;
        n.parent.children.splice(o, 1);
      } else
        n.removeFromParent();
    }
    e === t.length ? t.push(n) : t.splice(e, 0, n);
    const s = this.renderGroup || this.parentRenderGroup;
    return this.sortableChildren && (this.sortDirty = !0), i ? (s && (s.structureDidChange = !0), n) : (n.parent = this, n.didChange = !0, n._updateFlags = 15, s && s.addChild(n), this.emit("childAdded", n, this, e), n.emit("added", this), n);
  },
  swapChildren(n, e) {
    if (n === e)
      return;
    const t = this.getChildIndex(n), i = this.getChildIndex(e);
    this.children[t] = e, this.children[i] = n;
    const s = this.renderGroup || this.parentRenderGroup;
    s && (s.structureDidChange = !0), this._didContainerChangeTick++;
  },
  removeFromParent() {
    var n;
    (n = this.parent) == null || n.removeChild(this);
  },
  reparentChild(...n) {
    return n.length === 1 ? this.reparentChildAt(n[0], this.children.length) : (n.forEach((e) => this.reparentChildAt(e, this.children.length)), n[0]);
  },
  reparentChildAt(n, e) {
    if (n.parent === this)
      return this.setChildIndex(n, e), n;
    const t = n.worldTransform.clone();
    n.removeFromParent(), this.addChildAt(n, e);
    const i = this.worldTransform.clone();
    return i.invert(), t.prepend(i), n.setFromMatrix(t), n;
  },
  replaceChild(n, e) {
    n.updateLocalTransform(), this.addChildAt(e, this.getChildIndex(n)), e.setFromMatrix(n.localTransform), e.updateLocalTransform(), this.removeChild(n);
  }
}, UK = {
  collectRenderables(n, e, t) {
    this.parentRenderLayer && this.parentRenderLayer !== t || this.globalDisplayStatus < 7 || !this.includeInBuild || (this.sortableChildren && this.sortChildren(), this.isSimple ? this.collectRenderablesSimple(n, e, t) : this.renderGroup ? e.renderPipes.renderGroup.addRenderGroup(this.renderGroup, n) : this.collectRenderablesWithEffects(n, e, t));
  },
  collectRenderablesSimple(n, e, t) {
    const i = this.children, s = i.length;
    for (let o = 0; o < s; o++)
      i[o].collectRenderables(n, e, t);
  },
  collectRenderablesWithEffects(n, e, t) {
    const { renderPipes: i } = e;
    for (let s = 0; s < this.effects.length; s++) {
      const o = this.effects[s];
      i[o.pipe].push(o, this, n);
    }
    this.collectRenderablesSimple(n, e, t);
    for (let s = this.effects.length - 1; s >= 0; s--) {
      const o = this.effects[s];
      i[o.pipe].pop(o, this, n);
    }
  }
};
class pf {
  constructor() {
    this.pipe = "filter", this.priority = 1;
  }
  destroy() {
    for (let e = 0; e < this.filters.length; e++)
      this.filters[e].destroy();
    this.filters = null, this.filterArea = null;
  }
}
class GK {
  constructor() {
    this._effectClasses = [], this._tests = [], this._initialized = !1;
  }
  init() {
    this._initialized || (this._initialized = !0, this._effectClasses.forEach((e) => {
      this.add({
        test: e.test,
        maskClass: e
      });
    }));
  }
  add(e) {
    this._tests.push(e);
  }
  getMaskEffect(e) {
    this._initialized || this.init();
    for (let t = 0; t < this._tests.length; t++) {
      const i = this._tests[t];
      if (i.test(e))
        return $n.get(i.maskClass, e);
    }
    return e;
  }
  returnMaskEffect(e) {
    $n.return(e);
  }
}
const Vv = new GK();
ht.handleByList(Ae.MaskEffect, Vv._effectClasses);
const jK = {
  _maskEffect: null,
  _maskOptions: {
    inverse: !1,
    channel: "red"
  },
  _filterEffect: null,
  effects: [],
  _markStructureAsChanged() {
    const n = this.renderGroup || this.parentRenderGroup;
    n && (n.structureDidChange = !0);
  },
  addEffect(n) {
    this.effects.indexOf(n) === -1 && (this.effects.push(n), this.effects.sort((t, i) => t.priority - i.priority), this._markStructureAsChanged(), this._updateIsSimple());
  },
  removeEffect(n) {
    const e = this.effects.indexOf(n);
    e !== -1 && (this.effects.splice(e, 1), this._markStructureAsChanged(), this._updateIsSimple());
  },
  set mask(n) {
    const e = this._maskEffect;
    (e == null ? void 0 : e.mask) !== n && (e && (this.removeEffect(e), Vv.returnMaskEffect(e), this._maskEffect = null), n != null && (this._maskEffect = Vv.getMaskEffect(n), this.addEffect(this._maskEffect)));
  },
  get mask() {
    var n;
    return (n = this._maskEffect) == null ? void 0 : n.mask;
  },
  setMask(n) {
    this._maskOptions = {
      ...this._maskOptions,
      ...n
    }, n.mask && (this.mask = n.mask), this._markStructureAsChanged();
  },
  set filters(n) {
    var o;
    !Array.isArray(n) && n && (n = [n]);
    const e = this._filterEffect || (this._filterEffect = new pf());
    n = n;
    const t = (n == null ? void 0 : n.length) > 0, i = ((o = e.filters) == null ? void 0 : o.length) > 0, s = t !== i;
    n = Array.isArray(n) ? n.slice(0) : n, e.filters = Object.freeze(n), s && (t ? this.addEffect(e) : (this.removeEffect(e), e.filters = n != null ? n : null));
  },
  get filters() {
    var n;
    return (n = this._filterEffect) == null ? void 0 : n.filters;
  },
  set filterArea(n) {
    this._filterEffect || (this._filterEffect = new pf()), this._filterEffect.filterArea = n;
  },
  get filterArea() {
    var n;
    return (n = this._filterEffect) == null ? void 0 : n.filterArea;
  }
}, HK = {
  label: null,
  get name() {
    return rt(dn, "Container.name property has been removed, use Container.label instead"), this.label;
  },
  set name(n) {
    rt(dn, "Container.name property has been removed, use Container.label instead"), this.label = n;
  },
  getChildByName(n, e = !1) {
    return this.getChildByLabel(n, e);
  },
  getChildByLabel(n, e = !1) {
    const t = this.children;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (s.label === n || n instanceof RegExp && n.test(s.label)) return s;
    }
    if (e)
      for (let i = 0; i < t.length; i++) {
        const o = t[i].getChildByLabel(n, !0);
        if (o)
          return o;
      }
    return null;
  },
  getChildrenByLabel(n, e = !1, t = []) {
    const i = this.children;
    for (let s = 0; s < i.length; s++) {
      const o = i[s];
      (o.label === n || n instanceof RegExp && n.test(o.label)) && t.push(o);
    }
    if (e)
      for (let s = 0; s < i.length; s++)
        i[s].getChildrenByLabel(n, !0, t);
    return t;
  }
}, oi = $n.getPool(ot), eo = $n.getPool(Gn), VK = new ot(), WK = {
  getFastGlobalBounds(n, e) {
    e || (e = new Gn()), e.clear(), this._getGlobalBoundsRecursive(!!n, e, this.parentRenderLayer), e.isValid || e.set(0, 0, 0, 0);
    const t = this.renderGroup || this.parentRenderGroup;
    return e.applyMatrix(t.worldTransform), e;
  },
  _getGlobalBoundsRecursive(n, e, t) {
    let i = e;
    if (n && this.parentRenderLayer && this.parentRenderLayer !== t || this.localDisplayStatus !== 7 || !this.measurable)
      return;
    const s = !!this.effects.length;
    if ((this.renderGroup || s) && (i = eo.get().clear()), this.boundsArea)
      e.addRect(this.boundsArea, this.worldTransform);
    else {
      if (this.renderPipeId) {
        const r = this.bounds;
        i.addFrame(
          r.minX,
          r.minY,
          r.maxX,
          r.maxY,
          this.groupTransform
        );
      }
      const o = this.children;
      for (let r = 0; r < o.length; r++)
        o[r]._getGlobalBoundsRecursive(n, i, t);
    }
    if (s) {
      let o = !1;
      const r = this.renderGroup || this.parentRenderGroup;
      for (let a = 0; a < this.effects.length; a++)
        this.effects[a].addBounds && (o || (o = !0, i.applyMatrix(r.worldTransform)), this.effects[a].addBounds(i, !0));
      o && i.applyMatrix(r.worldTransform.copyTo(VK).invert()), e.addBounds(i), eo.return(i);
    } else this.renderGroup && (e.addBounds(i, this.relativeGroupTransform), eo.return(i));
  }
};
function X1(n, e, t) {
  t.clear();
  let i, s;
  return n.parent ? e ? i = n.parent.worldTransform : (s = oi.get().identity(), i = J1(n, s)) : i = ot.IDENTITY, CS(n, t, i, e), s && oi.return(s), t.isValid || t.set(0, 0, 0, 0), t;
}
function CS(n, e, t, i) {
  var a, l;
  if (!n.visible || !n.measurable) return;
  let s;
  i ? s = n.worldTransform : (n.updateLocalTransform(), s = oi.get(), s.appendFrom(n.localTransform, t));
  const o = e, r = !!n.effects.length;
  if (r && (e = eo.get().clear()), n.boundsArea)
    e.addRect(n.boundsArea, s);
  else {
    const d = n.bounds;
    d && !d.isEmpty() && (e.matrix = s, e.addBounds(d));
    for (let c = 0; c < n.children.length; c++)
      CS(n.children[c], e, s, i);
  }
  if (r) {
    for (let d = 0; d < n.effects.length; d++)
      (l = (a = n.effects[d]).addBounds) == null || l.call(a, e);
    o.addBounds(e, ot.IDENTITY), eo.return(e);
  }
  i || oi.return(s);
}
function J1(n, e) {
  const t = n.parent;
  return t && (J1(t, e), t.updateLocalTransform(), e.append(t.localTransform)), e;
}
function sa(n, e) {
  if (n === 16777215 || !e) return e;
  if (e === 16777215 || !n) return n;
  const t = n >> 16 & 255, i = n >> 8 & 255, s = n & 255, o = e >> 16 & 255, r = e >> 8 & 255, a = e & 255, l = t * o / 255 | 0, d = i * r / 255 | 0, c = s * a / 255 | 0;
  return (l << 16) + (d << 8) + c;
}
const Ck = 16777215;
function ff(n, e) {
  return n === Ck ? e : e === Ck ? n : sa(n, e);
}
function oa(n) {
  return ((n & 255) << 16) + (n & 65280) + (n >> 16 & 255);
}
const qK = {
  getGlobalAlpha(n) {
    if (n)
      return this.renderGroup ? this.renderGroup.worldAlpha : this.parentRenderGroup ? this.parentRenderGroup.worldAlpha * this.alpha : this.alpha;
    let e = this.alpha, t = this.parent;
    for (; t; )
      e *= t.alpha, t = t.parent;
    return e;
  },
  getGlobalTransform(n = new ot(), e) {
    if (e)
      return n.copyFrom(this.worldTransform);
    this.updateLocalTransform();
    const t = J1(this, oi.get().identity());
    return n.appendFrom(this.localTransform, t), oi.return(t), n;
  },
  getGlobalTint(n) {
    if (n)
      return this.renderGroup ? oa(this.renderGroup.worldColor) : this.parentRenderGroup ? oa(
        ff(this.localColor, this.parentRenderGroup.worldColor)
      ) : this.tint;
    let e = this.localColor, t = this.parent;
    for (; t; )
      e = ff(e, t.localColor), t = t.parent;
    return oa(e);
  }
};
function Z1(n, e, t) {
  return e.clear(), t || (t = ot.IDENTITY), IS(n, e, t, n, !0), e.isValid || e.set(0, 0, 0, 0), e;
}
function IS(n, e, t, i, s) {
  var l, d;
  let o;
  if (s)
    o = oi.get(), o = t.copyTo(o);
  else {
    if (!n.visible || !n.measurable) return;
    n.updateLocalTransform();
    const c = n.localTransform;
    o = oi.get(), o.appendFrom(c, t);
  }
  const r = e, a = !!n.effects.length;
  if (a && (e = eo.get().clear()), n.boundsArea)
    e.addRect(n.boundsArea, o);
  else {
    n.renderPipeId && (e.matrix = o, e.addBounds(n.bounds));
    const c = n.children;
    for (let h = 0; h < c.length; h++)
      IS(c[h], e, o, i, !1);
  }
  if (a) {
    for (let c = 0; c < n.effects.length; c++)
      (d = (l = n.effects[c]).addLocalBounds) == null || d.call(l, e, i);
    r.addBounds(e, ot.IDENTITY), eo.return(e);
  }
  oi.return(o);
}
function AS(n, e) {
  const t = n.children;
  for (let i = 0; i < t.length; i++) {
    const s = t[i], o = s.uid, r = (s._didViewChangeTick & 65535) << 16 | s._didContainerChangeTick & 65535, a = e.index;
    (e.data[a] !== o || e.data[a + 1] !== r) && (e.data[e.index] = o, e.data[e.index + 1] = r, e.didChange = !0), e.index = a + 2, s.children.length && AS(s, e);
  }
  return e.didChange;
}
const KK = new ot(), YK = {
  _localBoundsCacheId: -1,
  _localBoundsCacheData: null,
  _setWidth(n, e) {
    const t = Math.sign(this.scale.x) || 1;
    e !== 0 ? this.scale.x = n / e * t : this.scale.x = t;
  },
  _setHeight(n, e) {
    const t = Math.sign(this.scale.y) || 1;
    e !== 0 ? this.scale.y = n / e * t : this.scale.y = t;
  },
  getLocalBounds() {
    this._localBoundsCacheData || (this._localBoundsCacheData = {
      data: [],
      index: 1,
      didChange: !1,
      localBounds: new Gn()
    });
    const n = this._localBoundsCacheData;
    return n.index = 1, n.didChange = !1, n.data[0] !== this._didViewChangeTick && (n.didChange = !0, n.data[0] = this._didViewChangeTick), AS(this, n), n.didChange && Z1(this, n.localBounds, KK), n.localBounds;
  },
  getBounds(n, e) {
    return X1(this, n, e || new Gn());
  }
}, XK = {
  _onRender: null,
  set onRender(n) {
    const e = this.renderGroup || this.parentRenderGroup;
    if (!n) {
      this._onRender && (e == null || e.removeOnRender(this)), this._onRender = null;
      return;
    }
    this._onRender || e == null || e.addOnRender(this), this._onRender = n;
  },
  get onRender() {
    return this._onRender;
  }
}, JK = {
  _zIndex: 0,
  sortDirty: !1,
  sortableChildren: !1,
  get zIndex() {
    return this._zIndex;
  },
  set zIndex(n) {
    this._zIndex !== n && (this._zIndex = n, this.depthOfChildModified());
  },
  depthOfChildModified() {
    this.parent && (this.parent.sortableChildren = !0, this.parent.sortDirty = !0), this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0);
  },
  sortChildren() {
    this.sortDirty && (this.sortDirty = !1, this.children.sort(ZK));
  }
};
function ZK(n, e) {
  return n._zIndex - e._zIndex;
}
const QK = {
  getGlobalPosition(n = new Wt(), e = !1) {
    return this.parent ? this.parent.toGlobal(this._position, n, e) : (n.x = this._position.x, n.y = this._position.y), n;
  },
  toGlobal(n, e, t = !1) {
    const i = this.getGlobalTransform(oi.get(), t);
    return e = i.apply(n, e), oi.return(i), e;
  },
  toLocal(n, e, t, i) {
    e && (n = e.toGlobal(n, t, i));
    const s = this.getGlobalTransform(oi.get(), i);
    return t = s.applyInverse(n, t), oi.return(s), t;
  }
};
class Q1 {
  constructor() {
    this.uid = Nt("instructionSet"), this.instructions = [], this.instructionSize = 0, this.renderables = [], this.gcTick = 0;
  }
  /** reset the instruction set so it can be reused set size back to 0 */
  reset() {
    this.instructionSize = 0;
  }
  /**
   * Destroy the instruction set, clearing the instructions and renderables and notifying
   * each render pipe so it can release any per-InstructionSet cached resources.
   * @internal
   */
  destroy() {
    var e, t;
    if (this.renderPipes)
      for (const i in this.renderPipes)
        (t = (e = this.renderPipes[i]).destroyInstructionSet) == null || t.call(e, this);
    this.instructions.length = 0, this.renderables.length = 0, this.renderPipes = null, this.gcTick = 0;
  }
  /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */
  add(e) {
    this.instructions[this.instructionSize++] = e;
  }
  /**
   * Log the instructions to the console (for debugging)
   * @internal
   */
  log() {
    this.instructions.length = this.instructionSize, console.table(this.instructions, ["type", "action"]);
  }
}
class PS {
  constructor() {
    this._screenSizes = /* @__PURE__ */ new Map(), this._widths = [], this._heights = [];
  }
  /** The number of renderers with a registered screen. */
  get size() {
    return this._screenSizes.size;
  }
  /**
   * Registers, or updates, the screen size of a renderer.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   * @returns `true` if this changed the registered screens, `false` if the size was already registered.
   */
  set(e, t, i) {
    const s = this._screenSizes.get(e);
    return s && s.pixelWidth === t && s.pixelHeight === i ? !1 : (this._screenSizes.set(e, { pixelWidth: t, pixelHeight: i }), this._update(), !0);
  }
  /**
   * Removes the screen of a renderer.
   * @param rendererUid - The uid the screen was registered with.
   * @returns `true` if a screen was removed, `false` if the renderer had none registered.
   */
  remove(e) {
    return this._screenSizes.delete(e) ? (this._update(), !0) : !1;
  }
  /**
   * The smallest registered screen width the request fits in.
   * @param pixelWidth - The requested width in physical pixels.
   * @returns The smallest live screen width that is at least `pixelWidth`, or `undefined` if none.
   */
  getFittingWidth(e) {
    return this._getFittingAxis(e, this._widths);
  }
  /**
   * The smallest registered screen height the request fits in.
   * @param pixelHeight - The requested height in physical pixels.
   * @returns The smallest live screen height that is at least `pixelHeight`, or `undefined` if none.
   */
  getFittingHeight(e) {
    return this._getFittingAxis(e, this._heights);
  }
  /**
   * Whether a live screen uses this width.
   * @param width - The width in physical pixels.
   */
  hasWidth(e) {
    return this._widths.includes(e);
  }
  /**
   * Whether a live screen uses this height.
   * @param height - The height in physical pixels.
   */
  hasHeight(e) {
    return this._heights.includes(e);
  }
  /**
   * The smallest registered screen on this axis that the request still fits in.
   * @param pixelSize - The requested size on this axis in physical pixels.
   * @param screenSizes - The live screen sizes on this axis, sorted ascending.
   * @returns The smallest screen size that is at least `pixelSize`, or `undefined` if none.
   */
  _getFittingAxis(e, t) {
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (s >= e) return s;
    }
  }
  /** Rebuilds the sorted unique sizes for each axis. */
  _update() {
    this._widths = [...this._screenSizes.values()].map((e) => e.pixelWidth).filter((e, t, i) => i.indexOf(e) === t).sort((e, t) => e - t), this._heights = [...this._screenSizes.values()].map((e) => e.pixelHeight).filter((e, t, i) => i.indexOf(e) === t).sort((e, t) => e - t);
  }
}
let eY = 0;
const Tg = 32767, tY = 4294967296, nY = 8589934592, Ik = /* @__PURE__ */ Object.create(null);
let iY = 0;
function sY(n) {
  const e = Ik[n];
  return e !== void 0 ? e : Ik[n] = iY++;
}
function oY(n, e, t, i, s, o) {
  return (n << 17) + (e << 2) + ((i ? 1 : 0) << 1) + (t ? 1 : 0) + (o === "nearest" ? 1 : 0) * tY + sY(s) * nY;
}
class rY {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */
  constructor(e) {
    this._buckets = /* @__PURE__ */ new Map(), this._poolKey = /* @__PURE__ */ Object.create(null), this._poolStyle = /* @__PURE__ */ Object.create(null), this._screens = new PS(), this._enableFullScreen = !1, this.textureOptions = e || {};
  }
  /**
   * A style built from the pool options. The pool no longer applies it to anything.
   * @deprecated since 8.21.0, pooled textures carry their own style; pass `scaleMode` in the request instead.
   */
  get textureStyle() {
    return rt(js, "TexturePool.textureStyle is no longer used, pooled textures carry their own style. Pass scaleMode in the request instead."), this._textureStyle || (this._textureStyle = new kp(this.textureOptions)), this._textureStyle;
  }
  set textureStyle(e) {
    rt(js, "TexturePool.textureStyle is no longer used, pooled textures carry their own style. Pass scaleMode in the request instead."), this._textureStyle = e;
  }
  /**
   * Has no effect. The pool sizes textures to the screens registered with
   * {@link TexturePoolClass#setScreenSize|setScreenSize}.
   * @deprecated since 8.21.0
   */
  get enableFullScreen() {
    return rt(js, "TexturePool.enableFullScreen is no longer used, the pool sizes textures to the screens registered with setScreenSize."), this._enableFullScreen;
  }
  set enableFullScreen(e) {
    rt(js, "TexturePool.enableFullScreen is no longer used, the pool sizes textures to the screens registered with setScreenSize."), this._enableFullScreen = e;
  }
  createTexture(...e) {
    var r, a, l, d, c, h, f, p;
    let t = e[0];
    typeof t == "number" && (rt(js, "TexturePool.createTexture params are now an options object. See params: { width, height, antialias, autoGenerateMipmaps }"), t = {
      width: t,
      height: e[1],
      antialias: (r = e[2]) != null ? r : !1,
      autoGenerateMipmaps: (a = e[3]) != null ? a : !1
    });
    const i = (d = (l = t.format) != null ? l : this.textureOptions.format) != null ? d : un.defaultOptions.format, s = (h = (c = t.scaleMode) != null ? c : this.textureOptions.scaleMode) != null ? h : kp.defaultOptions.scaleMode, o = new un({
      ...this.textureOptions,
      width: t.width,
      height: t.height,
      resolution: 1,
      antialias: (f = t.antialias) != null ? f : !1,
      autoGarbageCollect: !1,
      autoGenerateMipmaps: (p = t.autoGenerateMipmaps) != null ? p : !1,
      format: i,
      scaleMode: s
    });
    return new et({
      source: o,
      label: `texturePool_${eY++}`
    });
  }
  getOptimalTexture(...e) {
    var v, x, w, S, M, _, T, k, P, A;
    let t = e[0];
    typeof t == "number" && (rt(js, "TexturePool.getOptimalTexture params are now an options object. See params: { width, height, resolution, antialias, autoGenerateMipmaps }"), t = {
      width: t,
      height: e[1],
      resolution: (v = e[2]) != null ? v : 1,
      antialias: (x = e[3]) != null ? x : !1,
      autoGenerateMipmaps: (w = e[4]) != null ? w : !1
    });
    const i = t.width, s = t.height, o = (S = t.resolution) != null ? S : 1, r = (M = t.antialias) != null ? M : !1, a = (_ = t.autoGenerateMipmaps) != null ? _ : !1, l = (k = (T = t.format) != null ? T : this.textureOptions.format) != null ? k : un.defaultOptions.format, d = (A = (P = t.scaleMode) != null ? P : this.textureOptions.scaleMode) != null ? A : kp.defaultOptions.scaleMode, { width: c, height: h } = this.getOptimalSize(
      i,
      s,
      o
    );
    (c > Tg || h > Tg) && dt(`TexturePool: ${c}x${h} is larger than the ${Tg}px pool key limit, textures of this size may be pooled together`);
    const f = oY(c, h, r, a, l, d);
    let p = this._buckets.get(f);
    p || (p = [], this._buckets.set(f, p));
    let y = p.pop();
    return y || (y = this.createTexture({
      width: c,
      height: h,
      antialias: r,
      autoGenerateMipmaps: a,
      format: l,
      scaleMode: d
    }), this._poolStyle[y.uid] = y.source.style), y.source._resolution = o, y.source.width = c / o, y.source.height = h / o, y.source.pixelWidth = c, y.source.pixelHeight = h, y.frame.x = 0, y.frame.y = 0, y.frame.width = i, y.frame.height = s, y.updateUvs(), this._poolKey[y.uid] = f, y;
  }
  /**
   * The backing size, in physical pixels, that {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * would allocate for a request, without taking a texture from the pool.
   *
   * Each axis is the next power of two, or the smallest registered screen the request fits inside
   * (see {@link TexturePoolClass#setScreenSize|setScreenSize}). Use it when a consumer needs to know
   * where a request's content will sit inside its pooled texture before it has one, such as a uniform
   * that maps content space onto texture space.
   * @param frameWidth - The minimum width of the texture.
   * @param frameHeight - The minimum height of the texture.
   * @param resolution - The resolution of the texture.
   * @returns The width and height the pooled texture would have, in physical pixels.
   */
  getOptimalSize(e, t, i = 1) {
    const s = Math.ceil(e * i - 1e-6), o = Math.ceil(t * i - 1e-6), r = hf(s), a = this._screens.getFittingWidth(s), l = hf(o), d = this._screens.getFittingHeight(o);
    return {
      width: a !== void 0 ? Math.min(a, r) : r,
      height: d !== void 0 ? Math.min(d, l) : l
    };
  }
  /**
   * Gets a pooled texture matching the dimensions and resolution of the given texture.
   *
   * This is a convenience wrapper around {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * that copies width, height, and resolution from an existing texture. Useful when a filter needs
   * a temporary texture the same size as its input (e.g., for multi-pass blur).
   * @param texture - The texture whose dimensions to match.
   * @param antialias - Whether to use antialias on the pooled texture. Defaults to `false`.
   * @returns A pooled texture with power-of-two or screen sized backing dimensions at the source resolution.
   */
  getSameSizeTexture(e, t = !1) {
    const i = e.source;
    return this.getOptimalTexture({
      width: e.width,
      height: e.height,
      resolution: i._resolution,
      antialias: t
    });
  }
  /**
   * Returns a texture to the pool so it can be reused by future
   * {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * or {@link TexturePoolClass#getSameSizeTexture|getSameSizeTexture} calls.
   *
   * If you gave the texture a style of your own after obtaining it (a different address mode, anisotropy
   * or similar), pass `resetStyle = true` so the pool puts its own style back. Otherwise your style stays
   * on the texture and the next consumer inherits it.
   * @param renderTexture - The texture to return to the pool.
   * @param resetStyle - When `true`, restores the style the pool created for this texture. Defaults to `false`.
   */
  returnTexture(e, t = !1) {
    const i = e.uid, s = this._poolKey[i];
    if (s === void 0) {
      dt("TexturePool: returnTexture was passed a texture that did not come from this pool, ignoring it");
      return;
    }
    const o = this._poolStyle[i];
    t && e.source.style !== o && (e.source.style = o);
    const r = this._buckets.get(s);
    if (!r) {
      delete this._poolKey[i], delete this._poolStyle[i], e.destroy(!0);
      return;
    }
    r.push(e);
  }
  /**
   * Registers the screen size of a renderer with the pool, in physical pixels.
   *
   * While a screen is registered, a request that fits inside it on an axis is given that screen's size on
   * that axis instead of the next power of two, which stops a full screen filter from allocating a texture
   * far larger than the screen. Requests larger than every registered screen on an axis keep the power of
   * two size - the pool never rounds a request up to a screen it does not fit in.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   */
  setScreenSize(e, t, i) {
    this._screens.set(e, t, i) && this._pruneScreenTextures();
  }
  /**
   * Removes a screen previously registered with
   * {@link TexturePoolClass#setScreenSize|setScreenSize}, destroying any idle textures that were
   * only being kept for it.
   * @param rendererUid - The uid the screen was registered with.
   */
  removeScreen(e) {
    this._screens.remove(e) && this._pruneScreenTextures();
  }
  /**
   * Destroys the idle textures in every bucket that has a non power of two dimension matching no live
   * screen. Power of two buckets are always kept, as any request can fall back to them.
   */
  _pruneScreenTextures() {
    for (const [e, t] of this._buckets) {
      const i = e >>> 0, s = i >>> 17, o = i >>> 2 & 32767;
      ($l(s) || this._screens.hasWidth(s)) && ($l(o) || this._screens.hasHeight(o)) || (this._dropTextures(t, !0), this._buckets.delete(e));
    }
  }
  /**
   * Forgets idle textures were ever handed out, so a later return is ignored, and optionally destroys them.
   * @param textures - The textures of one bucket.
   * @param destroy - Whether to destroy the textures as well.
   */
  _dropTextures(e, t) {
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      delete this._poolKey[s.uid], delete this._poolStyle[s.uid], t && s.destroy(!0);
    }
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(e) {
    for (const t of this._buckets.values())
      this._dropTextures(t, e !== !1);
    this._buckets.clear();
  }
}
const Nn = new rY();
Yl.register(Nn);
class Wv {
  constructor() {
    this.renderPipeId = "renderGroup", this.root = null, this.canBundle = !1, this.renderGroupParent = null, this.renderGroupChildren = [], this.worldTransform = new ot(), this.worldColorAlpha = 4294967295, this.worldColor = 16777215, this.worldAlpha = 1, this.childrenToUpdate = /* @__PURE__ */ Object.create(null), this.updateTick = 0, this.gcTick = 0, this.childrenRenderablesToUpdate = { list: [], index: 0 }, this.structureDidChange = !0, this.instructionSet = new Q1(), this._onRenderContainers = [], this.textureNeedsUpdate = !0, this.isCachedAsTexture = !1, this._matrixDirty = 7;
  }
  init(e) {
    this.root = e, e._onRender && this.addOnRender(e), e.didChange = !0;
    const t = e.children;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      s._updateFlags = 15, this.addChild(s);
    }
  }
  enableCacheAsTexture(e = {}) {
    this.textureOptions = e, this.isCachedAsTexture = !0, this.textureNeedsUpdate = !0;
  }
  disableCacheAsTexture() {
    this.isCachedAsTexture = !1, this.texture && (Nn.returnTexture(this.texture), this.texture = null);
  }
  updateCacheTexture() {
    this.textureNeedsUpdate = !0;
    const e = this._parentCacheAsTextureRenderGroup;
    e && !e.textureNeedsUpdate && e.updateCacheTexture();
  }
  reset() {
    this.renderGroupChildren.length = 0;
    for (const e in this.childrenToUpdate) {
      const t = this.childrenToUpdate[e];
      t.list.fill(null), t.index = 0;
    }
    this.childrenRenderablesToUpdate.index = 0, this.childrenRenderablesToUpdate.list.fill(null), this.root = null, this.updateTick = 0, this.structureDidChange = !0, this._onRenderContainers.length = 0, this.renderGroupParent = null, this.disableCacheAsTexture();
  }
  get localTransform() {
    return this.root.localTransform;
  }
  addRenderGroupChild(e) {
    e.renderGroupParent && e.renderGroupParent._removeRenderGroupChild(e), e.renderGroupParent = this, this.renderGroupChildren.push(e);
  }
  _removeRenderGroupChild(e) {
    const t = this.renderGroupChildren.indexOf(e);
    t > -1 && this.renderGroupChildren.splice(t, 1), e.renderGroupParent = null;
  }
  addChild(e) {
    if (this.structureDidChange = !0, e.parentRenderGroup = this, e.updateTick = -1, e.parent === this.root ? e.relativeRenderGroupDepth = 1 : e.relativeRenderGroupDepth = e.parent.relativeRenderGroupDepth + 1, e.didChange = !0, this.onChildUpdate(e), e.renderGroup) {
      this.addRenderGroupChild(e.renderGroup);
      return;
    }
    e._onRender && this.addOnRender(e);
    const t = e.children;
    for (let i = 0; i < t.length; i++)
      this.addChild(t[i]);
  }
  removeChild(e) {
    if (this.structureDidChange = !0, e._onRender && (e.renderGroup || this.removeOnRender(e)), e.parentRenderGroup = null, e.renderGroup) {
      this._removeRenderGroupChild(e.renderGroup);
      return;
    }
    const t = e.children;
    for (let i = 0; i < t.length; i++)
      this.removeChild(t[i]);
  }
  removeChildren(e) {
    for (let t = 0; t < e.length; t++)
      this.removeChild(e[t]);
  }
  onChildUpdate(e) {
    let t = this.childrenToUpdate[e.relativeRenderGroupDepth];
    t || (t = this.childrenToUpdate[e.relativeRenderGroupDepth] = {
      index: 0,
      list: []
    }), t.list[t.index++] = e;
  }
  updateRenderable(e) {
    e.globalDisplayStatus < 7 || (this.instructionSet.renderPipes[e.renderPipeId].updateRenderable(e), e.didViewUpdate = !1);
  }
  onChildViewUpdate(e) {
    this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = e;
  }
  get isRenderable() {
    return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
  }
  /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */
  addOnRender(e) {
    this._onRenderContainers.indexOf(e) === -1 && this._onRenderContainers.push(e);
  }
  removeOnRender(e) {
    const t = this._onRenderContainers.indexOf(e);
    t !== -1 && this._onRenderContainers.splice(t, 1);
  }
  runOnRender(e) {
    for (let t = 0; t < this._onRenderContainers.length; t++)
      this._onRenderContainers[t]._onRender(e);
  }
  destroy() {
    var e;
    this.disableCacheAsTexture(), this.renderGroupParent = null, this.root = null, this.childrenRenderablesToUpdate = null, this.childrenToUpdate = null, this.renderGroupChildren = null, this._onRenderContainers = null, (e = this.instructionSet) == null || e.destroy(), this.instructionSet = null;
  }
  getChildren(e = []) {
    const t = this.root.children;
    for (let i = 0; i < t.length; i++)
      this._getChildren(t[i], e);
    return e;
  }
  _getChildren(e, t = []) {
    if (t.push(e), e.renderGroup) return t;
    const i = e.children;
    for (let s = 0; s < i.length; s++)
      this._getChildren(i[s], t);
    return t;
  }
  invalidateMatrices() {
    this._matrixDirty = 7;
  }
  /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */
  get inverseWorldTransform() {
    return (this._matrixDirty & 1) === 0 ? this._inverseWorldTransform : (this._matrixDirty &= -2, this._inverseWorldTransform || (this._inverseWorldTransform = new ot()), this._inverseWorldTransform.copyFrom(this.worldTransform).invert());
  }
  /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */
  get textureOffsetInverseTransform() {
    return (this._matrixDirty & 2) === 0 ? this._textureOffsetInverseTransform : (this._matrixDirty &= -3, this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new ot()), this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(
      -this._textureBounds.x,
      -this._textureBounds.y
    ));
  }
  /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */
  get inverseParentTextureTransform() {
    if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
    this._matrixDirty &= -5;
    const e = this._parentCacheAsTextureRenderGroup;
    return e ? (this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new ot()), this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(e.inverseWorldTransform).translate(
      -e._textureBounds.x,
      -e._textureBounds.y
    )) : this.worldTransform;
  }
  /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */
  get cacheToLocalTransform() {
    return this.isCachedAsTexture ? this.textureOffsetInverseTransform : this._parentCacheAsTextureRenderGroup ? this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform : null;
  }
}
function aY(n, e, t = {}) {
  for (const i in e)
    !t[i] && e[i] !== void 0 && (n[i] = e[i]);
}
const Cg = new Fn(null), sh = new Fn(null), Ig = new Fn(null, 1, 1), oh = new Fn(null), mf = 1, ey = 2, bc = 4;
class mn extends bi {
  constructor(e = {}) {
    var t, i;
    super(), this.uid = Nt("renderable"), this._updateFlags = 15, this.renderGroup = null, this.parentRenderGroup = null, this.parentRenderGroupIndex = 0, this.didChange = !1, this.didViewUpdate = !1, this.relativeRenderGroupDepth = 0, this.children = [], this.parent = null, this.includeInBuild = !0, this.measurable = !0, this.isSimple = !0, this.parentRenderLayer = null, this.updateTick = -1, this.localTransform = new ot(), this.relativeGroupTransform = new ot(), this.groupTransform = this.relativeGroupTransform, this.destroyed = !1, this._position = new Fn(this, 0, 0), this._scale = Ig, this._pivot = sh, this._origin = oh, this._skew = Cg, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._rotation = 0, this.localColor = 16777215, this.localAlpha = 1, this.groupAlpha = 1, this.groupColor = 16777215, this.groupColorAlpha = 4294967295, this.localBlendMode = "inherit", this.groupBlendMode = "normal", this.localDisplayStatus = 7, this.globalDisplayStatus = 7, this._didContainerChangeTick = 0, this._didViewChangeTick = 0, this._didLocalTransformChangeId = -1, this.effects = [], aY(this, e, {
      children: !0,
      parent: !0,
      effects: !0
    }), (t = e.children) == null || t.forEach((s) => this.addChild(s)), (i = e.parent) == null || i.addChild(this);
  }
  /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */
  static mixin(e) {
    rt("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead."), ht.mixin(mn, e);
  }
  // = 'default';
  /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */
  set _didChangeId(e) {
    this._didViewChangeTick = e >> 12 & 4095, this._didContainerChangeTick = e & 4095;
  }
  /** @ignore */
  get _didChangeId() {
    return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
  }
  /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */
  addChild(...e) {
    if (this.allowChildren || rt(dn, "addChild: Only Containers will be allowed to add children in v8.0.0"), e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.addChild(e[s]);
      return e[0];
    }
    const t = e[0], i = this.renderGroup || this.parentRenderGroup;
    return t.parent === this ? (this.children.splice(this.children.indexOf(t), 1), this.children.push(t), i && (i.structureDidChange = !0), t) : (t.parent && t.parent.removeChild(t), this.children.push(t), this.sortableChildren && (this.sortDirty = !0), t.parent = this, t.didChange = !0, t._updateFlags = 15, i && i.addChild(t), this.emit("childAdded", t, this, this.children.length - 1), t.emit("added", this), this._didViewChangeTick++, t._zIndex !== 0 && t.depthOfChildModified(), t);
  }
  /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */
  removeChild(...e) {
    if (e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.removeChild(e[s]);
      return e[0];
    }
    const t = e[0], i = this.children.indexOf(t);
    return i > -1 && (this._didViewChangeTick++, this.children.splice(i, 1), this.renderGroup ? this.renderGroup.removeChild(t) : this.parentRenderGroup && this.parentRenderGroup.removeChild(t), t.parentRenderLayer && t.parentRenderLayer.detach(t), t.parent = null, this.emit("childRemoved", t, this, i), t.emit("removed", this)), t;
  }
  /** @ignore */
  _onUpdate(e) {
    e && e === this._skew && this._updateSkew(), this._didContainerChangeTick++, !this.didChange && (this.didChange = !0, this.parentRenderGroup && this.parentRenderGroup.onChildUpdate(this));
  }
  set isRenderGroup(e) {
    !!this.renderGroup !== e && (e ? this.enableRenderGroup() : this.disableRenderGroup());
  }
  /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */
  get isRenderGroup() {
    return !!this.renderGroup;
  }
  /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */
  enableRenderGroup() {
    if (this.renderGroup) return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), this.renderGroup = $n.get(Wv, this), this.groupTransform = ot.IDENTITY, e == null || e.addChild(this), this._updateIsSimple();
  }
  /**
   * This will disable the render group for this container.
   * @advanced
   */
  disableRenderGroup() {
    if (!this.renderGroup) return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), $n.return(this.renderGroup), this.renderGroup = null, this.groupTransform = this.relativeGroupTransform, e == null || e.addChild(this), this._updateIsSimple();
  }
  /** @ignore */
  _updateIsSimple() {
    this.isSimple = !this.renderGroup && this.effects.length === 0;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */
  get worldTransform() {
    return this._worldTransform || (this._worldTransform = new ot()), this.renderGroup ? this._worldTransform.copyFrom(this.renderGroup.worldTransform) : this.parentRenderGroup && this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform), this._worldTransform;
  }
  /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */
  get x() {
    return this._position.x;
  }
  set x(e) {
    this._position.x = e;
  }
  /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */
  get y() {
    return this._position.y;
  }
  set y(e) {
    this._position.y = e;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */
  get position() {
    return this._position;
  }
  set position(e) {
    this._position.copyFrom(e);
  }
  /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   *
   * // Rotate around center with origin
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation !== e && (this._rotation = e, this._onUpdate(this._skew));
  }
  /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Rotate around center with origin
   * sprite.origin.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */
  get angle() {
    return this.rotation * gK;
  }
  set angle(e) {
    this.rotation = e * bK;
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */
  get pivot() {
    return this._pivot === sh && (this._pivot = new Fn(this, 0, 0)), this._pivot;
  }
  set pivot(e) {
    this._pivot === sh && (this._pivot = new Fn(this, 0, 0), this._origin !== oh && dt("Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.")), typeof e == "number" ? this._pivot.set(e) : this._pivot.copyFrom(e);
  }
  /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */
  get skew() {
    return this._skew === Cg && (this._skew = new Fn(this, 0, 0)), this._skew;
  }
  set skew(e) {
    this._skew === Cg && (this._skew = new Fn(this, 0, 0)), this._skew.copyFrom(e);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */
  get scale() {
    return this._scale === Ig && (this._scale = new Fn(this, 1, 1)), this._scale;
  }
  set scale(e) {
    this._scale === Ig && (this._scale = new Fn(this, 0, 0)), typeof e == "string" && (e = parseFloat(e)), typeof e == "number" ? this._scale.set(e) : this._scale.copyFrom(e);
  }
  /**
   * @experimental
   * The origin point around which the container rotates and scales without affecting its position.
   * Unlike pivot, changing the origin will not move the container's position.
   * @example
   * ```ts
   * // Rotate around center point
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   *
   * // Reset origin
   * container.origin.set(0, 0);
   * ```
   */
  get origin() {
    return this._origin === oh && (this._origin = new Fn(this, 0, 0)), this._origin;
  }
  set origin(e) {
    this._origin === oh && (this._origin = new Fn(this, 0, 0), this._pivot !== sh && dt("Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.")), typeof e == "number" ? this._origin.set(e) : this._origin.copyFrom(e);
  }
  /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */
  get width() {
    return Math.abs(this.scale.x * this.getLocalBounds().width);
  }
  set width(e) {
    const t = this.getLocalBounds().width;
    this._setWidth(e, t);
  }
  /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */
  get height() {
    return Math.abs(this.scale.y * this.getLocalBounds().height);
  }
  set height(e) {
    const t = this.getLocalBounds().height;
    this._setHeight(e, t);
  }
  /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns The size of the container.
   */
  getSize(e) {
    e || (e = {});
    const t = this.getLocalBounds();
    return e.width = Math.abs(this.scale.x * t.width), e.height = Math.abs(this.scale.y * t.height), e;
  }
  /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(e, t) {
    var s;
    const i = this.getLocalBounds();
    typeof e == "object" ? (t = (s = e.height) != null ? s : e.width, e = e.width) : t != null || (t = e), e !== void 0 && this._setWidth(e, i.width), t !== void 0 && this._setHeight(t, i.height);
  }
  /** Called when the skew or the rotation changes. */
  _updateSkew() {
    const e = this._rotation, t = this._skew;
    this._cx = Math.cos(e + t._y), this._sx = Math.sin(e + t._y), this._cy = -Math.sin(e - t._x), this._sy = Math.cos(e - t._x);
  }
  /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */
  updateTransform(e) {
    return this.position.set(
      typeof e.x == "number" ? e.x : this.position.x,
      typeof e.y == "number" ? e.y : this.position.y
    ), this.scale.set(
      typeof e.scaleX == "number" ? e.scaleX : this.scale.x,
      typeof e.scaleY == "number" ? e.scaleY : this.scale.y
    ), this.rotation = typeof e.rotation == "number" ? e.rotation : this.rotation, this.skew.set(
      typeof e.skewX == "number" ? e.skewX : this.skew.x,
      typeof e.skewY == "number" ? e.skewY : this.skew.y
    ), this.pivot.set(
      typeof e.pivotX == "number" ? e.pivotX : this.pivot.x,
      typeof e.pivotY == "number" ? e.pivotY : this.pivot.y
    ), this.origin.set(
      typeof e.originX == "number" ? e.originX : this.origin.x,
      typeof e.originY == "number" ? e.originY : this.origin.y
    ), this;
  }
  /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */
  setFromMatrix(e) {
    e.decompose(this);
  }
  /** Updates the local transform. */
  updateLocalTransform() {
    const e = this._didContainerChangeTick;
    if (this._didLocalTransformChangeId === e) return;
    this._didLocalTransformChangeId = e;
    const t = this.localTransform, i = this._scale, s = this._pivot, o = this._origin, r = this._position, a = i._x, l = i._y, d = s._x, c = s._y, h = -o._x, f = -o._y;
    t.a = this._cx * a, t.b = this._sx * a, t.c = this._cy * l, t.d = this._sy * l, t.tx = r._x - (d * t.a + c * t.c) + (h * t.a + f * t.c) - h, t.ty = r._y - (d * t.b + c * t.d) + (h * t.b + f * t.d) - f;
  }
  // / ///// color related stuff
  set alpha(e) {
    e !== this.localAlpha && (this.localAlpha = e, this._updateFlags |= mf, this._onUpdate());
  }
  /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */
  get alpha() {
    return this.localAlpha;
  }
  set tint(e) {
    const i = vn.shared.setValue(e != null ? e : 16777215).toBgrNumber();
    i !== this.localColor && (this.localColor = i, this._updateFlags |= mf, this._onUpdate());
  }
  /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */
  get tint() {
    return oa(this.localColor);
  }
  // / //////////////// blend related stuff
  set blendMode(e) {
    this.localBlendMode !== e && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= ey, this.localBlendMode = e, this._onUpdate());
  }
  /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */
  get blendMode() {
    return this.localBlendMode;
  }
  // / ///////// VISIBILITY / RENDERABLE /////////////////
  /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */
  get visible() {
    return !!(this.localDisplayStatus & 2);
  }
  set visible(e) {
    const t = e ? 2 : 0;
    (this.localDisplayStatus & 2) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= bc, this.localDisplayStatus ^= 2, this._onUpdate(), this.emit("visibleChanged", e));
  }
  /** @ignore */
  get culled() {
    return !(this.localDisplayStatus & 4);
  }
  /** @ignore */
  set culled(e) {
    const t = e ? 0 : 4;
    (this.localDisplayStatus & 4) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= bc, this.localDisplayStatus ^= 4, this._onUpdate());
  }
  /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */
  get renderable() {
    return !!(this.localDisplayStatus & 1);
  }
  set renderable(e) {
    const t = e ? 1 : 0;
    (this.localDisplayStatus & 1) !== t && (this._updateFlags |= bc, this.localDisplayStatus ^= 1, this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._onUpdate());
  }
  /**
   * Whether or not the object should be rendered.
   * @advanced
   */
  get isRenderable() {
    return this.localDisplayStatus === 7 && this.groupAlpha > 0;
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */
  destroy(e = !1) {
    var s;
    if (this.destroyed) return;
    this.destroyed = !0;
    let t;
    if (this.children.length && (t = this.removeChildren(0, this.children.length)), this.removeFromParent(), this.parent = null, this._maskEffect = null, this._filterEffect = null, this.effects = null, this._position = null, this._scale = null, this._pivot = null, this._origin = null, this._skew = null, this.emit("destroyed", this), this.removeAllListeners(), (typeof e == "boolean" ? e : e == null ? void 0 : e.children) && t)
      for (let o = 0; o < t.length; ++o)
        t[o].destroy(e);
    (s = this.renderGroup) == null || s.destroy(), this.renderGroup = null;
  }
}
ht.mixin(
  mn,
  NK,
  WK,
  QK,
  XK,
  YK,
  jK,
  HK,
  JK,
  OK,
  FK,
  qK,
  UK
);
class ty extends mn {
  constructor(e) {
    var t;
    super(e), this.canBundle = !0, this.allowChildren = !1, this._roundPixels = 0, this._lastUsed = -1, this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this._bounds = new Gn(0, 1, 0, 0), this._boundsDirty = !0, this.autoGarbageCollect = (t = e.autoGarbageCollect) != null ? t : !0;
  }
  /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */
  get bounds() {
    return this._boundsDirty ? (this.updateBounds(), this._boundsDirty = !1, this._bounds) : this._bounds;
  }
  /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  set roundPixels(e) {
    this._roundPixels = e ? 1 : 0;
  }
  /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */
  containsPoint(e) {
    const t = this.bounds, { x: i, y: s } = e;
    return i >= t.minX && i <= t.maxX && s >= t.minY && s <= t.maxY;
  }
  /** @private */
  onViewUpdate() {
    if (this._didViewChangeTick++, this._boundsDirty = !0, this.didViewUpdate) return;
    this.didViewUpdate = !0;
    const e = this.renderGroup || this.parentRenderGroup;
    e && e.onChildViewUpdate(this);
  }
  /** Unloads the GPU data from the view. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null), this.onViewUpdate();
  }
  destroy(e) {
    this.unload(), super.destroy(e), this._bounds = null;
  }
  /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */
  collectRenderablesSimple(e, t, i) {
    const { renderPipes: s } = t;
    s.blendMode.pushBlendMode(this, this.groupBlendMode, e);
    const r = s[this.renderPipeId];
    r != null && r.addRenderable && r.addRenderable(this, e), this.didViewUpdate = !1;
    const a = this.children, l = a.length;
    for (let d = 0; d < l; d++)
      a[d].collectRenderables(e, t, i);
    s.blendMode.popBlendMode(e);
  }
}
class ks extends ty {
  /**
   * @param options - The options for creating the sprite.
   */
  constructor(e = et.EMPTY) {
    e instanceof et && (e = { texture: e });
    const { texture: t = et.EMPTY, anchor: i, roundPixels: s, width: o, height: r, ...a } = e;
    super({
      label: "Sprite",
      ...a
    }), this.renderPipeId = "sprite", this.batched = !0, this._visualBounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, this._anchor = new Fn(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), i ? this.anchor = i : t.defaultAnchor && (this.anchor = t.defaultAnchor), this.texture = t, this.allowChildren = !1, this.roundPixels = s != null ? s : !1, o !== void 0 && (this.width = o), r !== void 0 && (this.height = r);
  }
  /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */
  static from(e, t = !1) {
    return e instanceof et ? new ks(e) : new ks(et.from(e, t));
  }
  set texture(e) {
    e || (e = et.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this._width && this._setWidth(this._width, this._texture.orig.width), this._height && this._setHeight(this._height, this._texture.orig.height), this.onViewUpdate());
  }
  /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */
  get texture() {
    return this._texture;
  }
  /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */
  get visualBounds() {
    return TK(this._visualBounds, this._anchor, this._texture), this._visualBounds;
  }
  /**
   * @deprecated
   * @ignore
   */
  get sourceBounds() {
    return rt("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead."), this.visualBounds;
  }
  /** @private */
  updateBounds() {
    const e = this._anchor, t = this._texture, i = this._bounds, { width: s, height: o } = t.orig;
    i.minX = -e._x * s, i.maxX = i.minX + s, i.minY = -e._y * o, i.maxY = i.minY + o;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */
  destroy(e = !1) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const i = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(i);
    }
    this._texture = null, this._visualBounds = null, this._bounds = null, this._anchor = null;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(e) {
    this._setWidth(e, this._texture.orig.width), this._width = e;
  }
  /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(e) {
    this._setHeight(e, this._texture.orig.height), this._height = e;
  }
  /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */
  getSize(e) {
    return e || (e = {}), e.width = Math.abs(this.scale.x) * this._texture.orig.width, e.height = Math.abs(this.scale.y) * this._texture.orig.height, e;
  }
  /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */
  setSize(e, t) {
    var i;
    typeof e == "object" ? (t = (i = e.height) != null ? i : e.width, e = e.width) : t != null || (t = e), e !== void 0 && this._setWidth(e, this._texture.orig.width), t !== void 0 && this._setHeight(t, this._texture.orig.height);
  }
}
const lY = new Gn();
function ES(n, e, t) {
  const i = lY;
  n.measurable = !0, X1(n, t, i), e.addBoundsMask(i), n.measurable = !1;
}
function RS(n, e, t) {
  const i = eo.get();
  n.measurable = !0;
  const s = oi.get().identity(), o = zS(n, t, s);
  Z1(n, i, o), n.measurable = !1, e.addBoundsMask(i), oi.return(s), eo.return(i);
}
function zS(n, e, t) {
  return n ? (n !== e && (zS(n.parent, e, t), n.updateLocalTransform(), t.append(n.localTransform)), t) : (dt("Mask bounds, renderable is not inside the root container"), t);
}
class $S {
  constructor(e) {
    this.priority = 0, this.inverse = !1, this.channel = "red", this.pipe = "alphaMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.renderMaskToTexture = !(e instanceof ks), this.mask.renderable = this.renderMaskToTexture, this.mask.includeInBuild = !this.renderMaskToTexture, this.mask.measurable = !1;
  }
  reset() {
    this.mask !== null && (this.mask.measurable = !0, this.mask = null);
  }
  addBounds(e, t) {
    this.inverse || ES(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    RS(this.mask, e, t);
  }
  containsPoint(e, t) {
    const i = this.mask;
    return t(i, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof ks;
  }
}
$S.extension = Ae.MaskEffect;
class DS {
  constructor(e) {
    this.priority = 0, this.pipe = "colorMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e;
  }
  destroy() {
  }
  static test(e) {
    return typeof e == "number";
  }
}
DS.extension = Ae.MaskEffect;
class OS {
  constructor(e) {
    this.priority = 0, this.pipe = "stencilMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.mask.includeInBuild = !1, this.mask.measurable = !1;
  }
  reset() {
    this.mask !== null && (this.mask.measurable = !0, this.mask.includeInBuild = !0, this.mask = null);
  }
  addBounds(e, t) {
    ES(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    RS(this.mask, e, t);
  }
  containsPoint(e, t) {
    const i = this.mask;
    return t(i, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof mn;
  }
}
OS.extension = Ae.MaskEffect;
const dY = {
  createCanvas: (n, e) => {
    const t = document.createElement("canvas");
    return t.width = n, t.height = e, t;
  },
  createImage: () => new Image(),
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => {
    var n;
    return (n = document.baseURI) != null ? n : window.location.href;
  },
  getFontFaceSet: () => document.fonts,
  fetch: (n, e) => fetch(n, e),
  parseXML: (n) => new DOMParser().parseFromString(n, "text/xml")
};
let Ak = dY;
const zt = {
  /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */
  get() {
    return Ak;
  },
  /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */
  set(n) {
    Ak = n;
  }
};
class Ai extends un {
  constructor(e) {
    e.resource || (e.resource = zt.get().createCanvas()), e.width || (e.width = e.resource.width, e.autoDensity || (e.width /= e.resolution)), e.height || (e.height = e.resource.height, e.autoDensity || (e.height /= e.resolution)), super(e), this.uploadMethodId = "image", this.autoDensity = e.autoDensity, this.resizeCanvas(), this.transparent = !!e.transparent;
  }
  resizeCanvas() {
    this.autoDensity && "style" in this.resource && (this.resource.style.width = `${this.width}px`, this.resource.style.height = `${this.height}px`), (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) && (this.resource.width = this.pixelWidth, this.resource.height = this.pixelHeight);
  }
  resize(e = this.width, t = this.height, i = this._resolution) {
    const s = super.resize(e, t, i);
    return s && this.resizeCanvas(), s;
  }
  static test(e) {
    return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && e instanceof OffscreenCanvas;
  }
  /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */
  get context2D() {
    return this._context2D || (this._context2D = this.resource.getContext("2d"));
  }
}
Ai.extension = Ae.TextureSource;
class Gc extends un {
  constructor(e) {
    super(e), this.uploadMethodId = "image", this.autoGarbageCollect = !0;
  }
  static test(e) {
    return globalThis.HTMLImageElement && e instanceof HTMLImageElement || typeof ImageBitmap != "undefined" && e instanceof ImageBitmap || globalThis.VideoFrame && e instanceof VideoFrame;
  }
}
Gc.extension = Ae.TextureSource;
var Ol = /* @__PURE__ */ ((n) => (n[n.INTERACTION = 50] = "INTERACTION", n[n.HIGH = 25] = "HIGH", n[n.NORMAL = 0] = "NORMAL", n[n.LOW = -25] = "LOW", n[n.UTILITY = -50] = "UTILITY", n))(Ol || {});
class Ag {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(e, t = null, i = 0, s = !1) {
    this.next = null, this.previous = null, this._destroyed = !1, this._fn = e, this._context = t, this.priority = i, this._once = s;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(e, t = null) {
    return this._fn === e && this._context === t;
  }
  /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */
  emit(e) {
    this._fn && (this._context ? this._fn.call(this._context, e) : this._fn(e));
    const t = this.next;
    return this._once && this.destroy(!0), this._destroyed && (this.next = null), t;
  }
  /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */
  connect(e) {
    this.previous = e, e.next && (e.next.previous = this), this.next = e.next, e.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(e = !1) {
    this._destroyed = !0, this._fn = null, this._context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
    const t = this.next;
    return this.next = e ? null : t, this.previous = null, t;
  }
}
const LS = class xi {
  constructor() {
    this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new Ag(null, null, 1 / 0), this.deltaMS = 1 / xi.targetFPMS, this.elapsedMS = 1 / xi.targetFPMS, this._tick = (e) => {
      this._requestId = null, this.started && (this.update(e), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */
  _requestIfNeeded() {
    this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
  }
  /** Conditionally cancels a pending animation frame. */
  _cancelIfNeeded() {
    this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */
  _startIfPossible() {
    this.started ? this._requestIfNeeded() : this.autoStart && this.start();
  }
  /**
   * Register a handler for tick events.
   * @param fn - The listener function to add. Receives the Ticker instance as parameter
   * @param context - The context for the listener
   * @param priority - The priority of the listener
   * @example
   * ```ts
   * // Access time properties through the ticker parameter
   * ticker.add((ticker) => {
   *     // Use deltaTime (dimensionless scalar) for frame-independent animations
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   *
   *     // Use deltaMS (milliseconds) for time-based calculations
   *     const progress = ticker.deltaMS / animationDuration;
   *
   *     // Use elapsedMS for raw timing measurements
   *     console.log(`Raw frame time: ${ticker.elapsedMS}ms`);
   * });
   * ```
   */
  add(e, t, i = Ol.NORMAL) {
    return this._addListener(new Ag(e, t, i));
  }
  /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */
  addOnce(e, t, i = Ol.NORMAL) {
    return this._addListener(new Ag(e, t, i, !0));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(e) {
    let t = this._head.next, i = this._head;
    if (!t)
      e.connect(i);
    else {
      for (; t; ) {
        if (e.priority > t.priority) {
          e.connect(i);
          break;
        }
        i = t, t = t.next;
      }
      e.previous || e.connect(i);
    }
    return this._startIfPossible(), this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */
  remove(e, t) {
    let i = this._head.next;
    for (; i; )
      i.match(e, t) ? i = i.destroy() : i = i.next;
    return this._head.next || this._cancelIfNeeded(), this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */
  get count() {
    if (!this._head)
      return 0;
    let e = 0, t = this._head;
    for (; t = t.next; )
      e++;
    return e;
  }
  /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */
  start() {
    this.started || (this.started = !0, this._requestIfNeeded());
  }
  /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */
  stop() {
    this.started && (this.started = !1, this._cancelIfNeeded());
  }
  /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */
  destroy() {
    if (!this._protected) {
      this.stop();
      let e = this._head.next;
      for (; e; )
        e = e.destroy(!0);
      this._head.destroy(), this._head = null;
    }
  }
  /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */
  update(e = performance.now()) {
    let t;
    if (e > this.lastTime) {
      if (t = this.elapsedMS = e - this.lastTime, t > this._maxElapsedMS && (t = this._maxElapsedMS), t *= this.speed, this._minElapsedMS) {
        const o = e - this._lastFrame | 0;
        if (o < this._minElapsedMS)
          return;
        this._lastFrame = e - o % this._minElapsedMS;
      }
      this.deltaMS = t, this.deltaTime = this.deltaMS * xi.targetFPMS;
      const i = this._head;
      let s = i.next;
      for (; s; )
        s = s.emit(this);
      i.next || this._cancelIfNeeded();
    } else
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    this.lastTime = e;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000` (typically 60).
   *
   * If `maxFPS` is currently set (non-zero) and `minFPS` is set above it,
   * `maxFPS` is automatically raised to match. This keeps the two limits consistent.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // minFPS above maxFPS pushes maxFPS up
   * ticker.minFPS = 50; // maxFPS is raised to 50
   * ```
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(e) {
    const t = Math.min(Math.max(0, e) / 1e3, xi.targetFPMS);
    this._maxElapsedMS = 1 / t, this._minElapsedMS && e > this.maxFPS && (this.maxFPS = e);
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`.
   *
   * If `maxFPS` is set below the current `minFPS`, `minFPS` is automatically lowered to match.
   * This keeps the two limits consistent.
   * @example
   * ```ts
   * // Cap the frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with minFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // maxFPS below minFPS pushes minFPS down
   * ticker.maxFPS = 20; // minFPS is now also 20
   * ```
   * @default 0
   */
  get maxFPS() {
    return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
  }
  set maxFPS(e) {
    e === 0 ? this._minElapsedMS = 0 : (e < this.minFPS && (this.minFPS = e), this._minElapsedMS = 1 / (e / 1e3));
  }
  /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */
  static get shared() {
    if (!xi._shared) {
      const e = xi._shared = new xi();
      e.autoStart = !0, e._protected = !0;
    }
    return xi._shared;
  }
  /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */
  static get system() {
    if (!xi._system) {
      const e = xi._system = new xi();
      e.autoStart = !0, e._protected = !0;
    }
    return xi._system;
  }
};
LS.targetFPMS = 0.06;
let Oi = LS, ud;
async function cY() {
  return ud != null || (ud = (async () => {
    var r;
    const e = zt.get().createCanvas(1, 1).getContext("webgl");
    if (!e)
      return "premultiply-alpha-on-upload";
    const t = await new Promise((a) => {
      const l = document.createElement("video");
      l.onloadeddata = () => a(l), l.onerror = () => a(null), l.autoplay = !1, l.crossOrigin = "anonymous", l.preload = "auto", l.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", l.load();
    });
    if (!t)
      return "premultiply-alpha-on-upload";
    const i = e.createTexture();
    e.bindTexture(e.TEXTURE_2D, i);
    const s = e.createFramebuffer();
    e.bindFramebuffer(e.FRAMEBUFFER, s), e.framebufferTexture2D(
      e.FRAMEBUFFER,
      e.COLOR_ATTACHMENT0,
      e.TEXTURE_2D,
      i,
      0
    ), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.NONE), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, t);
    const o = new Uint8Array(4);
    return e.readPixels(0, 0, 1, 1, e.RGBA, e.UNSIGNED_BYTE, o), e.deleteFramebuffer(s), e.deleteTexture(i), (r = e.getExtension("WEBGL_lose_context")) == null || r.loseContext(), o[0] <= o[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
  })()), ud;
}
const gm = class BS extends un {
  constructor(e) {
    var t;
    super(e), this.isReady = !1, this.uploadMethodId = "video", e = {
      ...BS.defaultOptions,
      ...e
    }, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = e.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = e.autoPlay !== !1, this.alphaMode = (t = e.alphaMode) != null ? t : "premultiply-alpha-on-upload", this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onCanPlayThrough = this._onCanPlayThrough.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), this._onLoadedMetadata = this._onLoadedMetadata.bind(this), e.autoLoad !== !1 && this.load();
  }
  /** Update the video frame if the source is not destroyed and meets certain conditions. */
  updateFrame() {
    if (!this.destroyed) {
      if (this._updateFPS) {
        const e = Oi.shared.elapsedMS * this.resource.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - e);
      }
      (!this._updateFPS || this._msToNextUpdate <= 0) && (this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0), this.isValid && this.update();
    }
  }
  /** Callback to update the video frame and potentially request the next frame update. */
  _videoFrameRequestCallback() {
    this.updateFrame(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    );
  }
  /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */
  get isValid() {
    return !!this.resource.videoWidth && !!this.resource.videoHeight;
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */
  async load() {
    if (this._load)
      return this._load;
    const e = this.resource, t = this.options;
    return (e.readyState === e.HAVE_ENOUGH_DATA || e.readyState === e.HAVE_FUTURE_DATA) && e.width && e.height && (e.complete = !0), e.addEventListener("play", this._onPlayStart), e.addEventListener("pause", this._onPlayStop), e.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._mediaReady() : (t.preload || e.addEventListener("canplay", this._onCanPlay), e.addEventListener("canplaythrough", this._onCanPlayThrough), e.addEventListener("error", this._onError, !0)), this.isValid || e.addEventListener("loadedmetadata", this._onLoadedMetadata), this.alphaMode = await cY(), this._load = new Promise((i, s) => {
      this.isValid ? i(this) : (this._resolve = i, this._reject = s, t.preloadTimeoutMs !== void 0 && (this._preloadTimeout = setTimeout(() => {
        this._onError(new ErrorEvent(`Preload exceeded timeout of ${t.preloadTimeoutMs}ms`));
      })), e.load());
    }), this._load;
  }
  /**
   * Handle video error events.
   * @param event - The error event
   */
  _onError(e) {
    this.resource.removeEventListener("error", this._onError, !0), this.emit("error", e), this._reject && (this._reject(e), this._reject = null, this._resolve = null);
  }
  /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */
  _isSourcePlaying() {
    const e = this.resource;
    return !e.paused && !e.ended;
  }
  /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */
  _isSourceReady() {
    return this.resource.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    this._configureAutoUpdate();
  }
  /** Stops the update loop when a pause event is triggered. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Handles behavior when the video completes seeking to the current playback position. */
  _onSeeked() {
    this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0);
  }
  /** When intrinsic size becomes known after play / canplay (common with MediaStream). */
  _onLoadedMetadata() {
    this.isValid && this._mediaReady();
  }
  _onCanPlay() {
    this.resource.removeEventListener("canplay", this._onCanPlay), this._mediaReady();
  }
  _onCanPlayThrough() {
    this.resource.removeEventListener("canplaythrough", this._onCanPlayThrough), this._preloadTimeout && (clearTimeout(this._preloadTimeout), this._preloadTimeout = void 0), this._mediaReady();
  }
  /** Fired when the video is loaded and ready to play. */
  _mediaReady() {
    const e = this.resource;
    this.isValid && (this.isReady = !0, this.resize(e.videoWidth, e.videoHeight)), this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0, this._resolve && this.isValid && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && this.resource.play();
  }
  /** Cleans up resources and event listeners associated with this texture. */
  destroy() {
    this._configureAutoUpdate();
    const e = this.resource;
    e && (e.removeEventListener("play", this._onPlayStart), e.removeEventListener("pause", this._onPlayStop), e.removeEventListener("seeked", this._onSeeked), e.removeEventListener("canplay", this._onCanPlay), e.removeEventListener("canplaythrough", this._onCanPlayThrough), e.removeEventListener("loadedmetadata", this._onLoadedMetadata), e.removeEventListener("error", this._onError, !0), e.pause(), e.src = "", e.load()), super.destroy();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(e) {
    e !== this._autoUpdate && (this._autoUpdate = e, this._configureAutoUpdate());
  }
  /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(e) {
    e !== this._updateFPS && (this._updateFPS = e, this._configureAutoUpdate());
  }
  /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */
  _configureAutoUpdate() {
    this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.resource.requestVideoFrameCallback ? (this._isConnectedToTicker && (Oi.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    ))) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || (Oi.shared.add(this.updateFrame, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && (Oi.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
  }
  static test(e) {
    return globalThis.HTMLVideoElement && e instanceof HTMLVideoElement;
  }
};
gm.extension = Ae.TextureSource;
gm.defaultOptions = {
  ...un.defaultOptions,
  /** If true, the video will start loading immediately. */
  autoLoad: !0,
  /** If true, the video will start playing as soon as it is loaded. */
  autoPlay: !0,
  /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */
  updateFPS: 0,
  /** If true, the video will be loaded with the `crossorigin` attribute. */
  crossorigin: !0,
  /** If true, the video will loop when it ends. */
  loop: !1,
  /** If true, the video will be muted. */
  muted: !0,
  /** If true, the video will play inline. */
  playsinline: !0,
  /** If true, the video will be preloaded. */
  preload: !1
};
gm.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let uY = gm;
const Za = (n, e, t = !1) => (Array.isArray(n) || (n = [n]), e ? n.map((i) => typeof i == "string" || t ? e(i) : i) : n);
class hY {
  constructor() {
    this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear(), this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(e) {
    return this._cache.has(e);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(e) {
    const t = this._cache.get(e);
    return t || dt(`[Assets] Asset id ${e} was not found in the Cache`), t;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(e, t) {
    const i = Za(e);
    let s;
    for (let l = 0; l < this.parsers.length; l++) {
      const d = this.parsers[l];
      if (d.test(t)) {
        s = d.getCacheableAssets(i, t);
        break;
      }
    }
    const o = new Map(Object.entries(s || {}));
    s || i.forEach((l) => {
      o.set(l, t);
    });
    const r = [...o.keys()], a = {
      cacheKeys: r,
      keys: i
    };
    i.forEach((l) => {
      this._cacheMap.set(l, a);
    }), r.forEach((l) => {
      const d = s ? s[l] : t;
      this._cache.has(l) && this._cache.get(l) !== d && dt("[Cache] already has key:", l), this._cache.set(l, o.get(l));
    });
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(e) {
    if (!this._cacheMap.has(e)) {
      dt(`[Assets] Asset id ${e} was not found in the Cache`);
      return;
    }
    const t = this._cacheMap.get(e);
    t.cacheKeys.forEach((s) => {
      this._cache.delete(s);
    }), t.keys.forEach((s) => {
      this._cacheMap.delete(s);
    });
  }
  /**
   * All loader parsers registered
   * @advanced
   */
  get parsers() {
    return this._parsers;
  }
}
const Qa = new hY(), qv = [];
ht.handleByList(Ae.TextureSource, qv);
function FS(n = {}) {
  const e = n && n.resource, t = e ? n.resource : n, i = e ? n : { resource: n };
  for (let s = 0; s < qv.length; s++) {
    const o = qv[s];
    if (o.test(t))
      return new o(i);
  }
  throw new Error(`Could not find a source type for resource: ${i.resource}`);
}
function pY(n = {}, e = !1) {
  const t = n && n.resource, i = t ? n.resource : n, s = t ? n : { resource: n };
  if (!e && Qa.has(i))
    return Qa.get(i);
  const o = new et({ source: FS(s) });
  return o.on("destroy", () => {
    Qa.has(i) && Qa.remove(i);
  }), e || Qa.set(i, o), o;
}
function fY(n, e = !1) {
  return typeof n == "string" ? Qa.get(n) : n instanceof un ? new et({ source: n }) : pY(n, e);
}
et.from = fY;
un.from = FS;
ht.add(
  $S,
  DS,
  OS,
  uY,
  Gc,
  Ai,
  Y1
);
var NS = /* @__PURE__ */ ((n) => (n[n.Low = 0] = "Low", n[n.Normal = 1] = "Normal", n[n.High = 2] = "High", n))(NS || {});
function Gi(n) {
  if (typeof n != "string")
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(n)}`);
}
function hd(n) {
  return n.split("?")[0].split("#")[0];
}
function mY(n) {
  return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function gY(n, e, t) {
  return n.replace(new RegExp(mY(e), "g"), t);
}
function bY(n, e) {
  let t = "", i = 0, s = -1, o = 0, r = -1;
  for (let a = 0; a <= n.length; ++a) {
    if (a < n.length)
      r = n.charCodeAt(a);
    else {
      if (r === 47)
        break;
      r = 47;
    }
    if (r === 47) {
      if (!(s === a - 1 || o === 1)) if (s !== a - 1 && o === 2) {
        if (t.length < 2 || i !== 2 || t.charCodeAt(t.length - 1) !== 46 || t.charCodeAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            const l = t.lastIndexOf("/");
            if (l !== t.length - 1) {
              l === -1 ? (t = "", i = 0) : (t = t.slice(0, l), i = t.length - 1 - t.lastIndexOf("/")), s = a, o = 0;
              continue;
            }
          } else if (t.length === 2 || t.length === 1) {
            t = "", i = 0, s = a, o = 0;
            continue;
          }
        }
      } else
        t.length > 0 ? t += `/${n.slice(s + 1, a)}` : t = n.slice(s + 1, a), i = a - s - 1;
      s = a, o = 0;
    } else r === 46 && o !== -1 ? ++o : o = -1;
  }
  return t;
}
const jc = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */
  toPosix(n) {
    return gY(n, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */
  isUrl(n) {
    return /^https?:/.test(this.toPosix(n));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */
  isDataUrl(n) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(n);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */
  isBlobUrl(n) {
    return n.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  hasProtocol(n) {
    return /^[^/:]+:/.test(this.toPosix(n));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  getProtocol(n) {
    Gi(n), n = this.toPosix(n);
    const e = /^file:\/\/\//.exec(n);
    if (e)
      return e[0];
    const t = /^[^/:]+:\/{0,2}/.exec(n);
    return t ? t[0] : "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */
  toAbsolute(n, e, t) {
    if (Gi(n), this.isDataUrl(n) || this.isBlobUrl(n)) return n;
    const i = hd(this.toPosix(e != null ? e : zt.get().getBaseUrl())), s = hd(this.toPosix(t != null ? t : this.rootname(i)));
    return n = this.toPosix(n), n.startsWith("/") ? jc.join(s, n.slice(1)) : this.isAbsolute(n) ? n : this.join(i, n);
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */
  normalize(n) {
    if (Gi(n), n.length === 0) return ".";
    if (this.isDataUrl(n) || this.isBlobUrl(n)) return n;
    n = this.toPosix(n);
    let e = "";
    const t = n.startsWith("/");
    this.hasProtocol(n) && (e = this.rootname(n), n = n.slice(e.length));
    const i = n.endsWith("/");
    return n = bY(n), n.length > 0 && i && (n += "/"), t ? `/${n}` : e + n;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  isAbsolute(n) {
    return Gi(n), n = this.toPosix(n), this.hasProtocol(n) ? !0 : n.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */
  join(...n) {
    var t;
    if (n.length === 0)
      return ".";
    let e;
    for (let i = 0; i < n.length; ++i) {
      const s = n[i];
      if (Gi(s), s.length > 0)
        if (e === void 0) e = s;
        else {
          const o = (t = n[i - 1]) != null ? t : "";
          this.joinExtensions.includes(this.extname(o).toLowerCase()) ? e += `/../${s}` : e += `/${s}`;
        }
    }
    return e === void 0 ? "." : this.normalize(e);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */
  dirname(n) {
    if (Gi(n), n.length === 0) return ".";
    n = this.toPosix(n);
    let e = n.charCodeAt(0);
    const t = e === 47;
    let i = -1, s = !0;
    const o = this.getProtocol(n), r = n;
    n = n.slice(o.length);
    for (let a = n.length - 1; a >= 1; --a)
      if (e = n.charCodeAt(a), e === 47) {
        if (!s) {
          i = a;
          break;
        }
      } else
        s = !1;
    return i === -1 ? t ? "/" : this.isUrl(r) ? o + n : o : t && i === 1 ? "//" : o + n.slice(0, i);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  rootname(n) {
    Gi(n), n = this.toPosix(n);
    let e = "";
    if (n.startsWith("/") ? e = "/" : e = this.getProtocol(n), this.isUrl(n)) {
      const t = n.indexOf("/", e.length);
      t !== -1 ? e = n.slice(0, t) : e = n, e.endsWith("/") || (e += "/");
    }
    return e;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */
  basename(n, e) {
    Gi(n), e && Gi(e), n = hd(this.toPosix(n));
    let t = 0, i = -1, s = !0, o;
    if (e !== void 0 && e.length > 0 && e.length <= n.length) {
      if (e.length === n.length && e === n) return "";
      let r = e.length - 1, a = -1;
      for (o = n.length - 1; o >= 0; --o) {
        const l = n.charCodeAt(o);
        if (l === 47) {
          if (!s) {
            t = o + 1;
            break;
          }
        } else
          a === -1 && (s = !1, a = o + 1), r >= 0 && (l === e.charCodeAt(r) ? --r === -1 && (i = o) : (r = -1, i = a));
      }
      return t === i ? i = a : i === -1 && (i = n.length), n.slice(t, i);
    }
    for (o = n.length - 1; o >= 0; --o)
      if (n.charCodeAt(o) === 47) {
        if (!s) {
          t = o + 1;
          break;
        }
      } else i === -1 && (s = !1, i = o + 1);
    return i === -1 ? "" : n.slice(t, i);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */
  extname(n) {
    Gi(n), n = hd(this.toPosix(n));
    let e = -1, t = 0, i = -1, s = !0, o = 0;
    for (let r = n.length - 1; r >= 0; --r) {
      const a = n.charCodeAt(r);
      if (a === 47) {
        if (!s) {
          t = r + 1;
          break;
        }
        continue;
      }
      i === -1 && (s = !1, i = r + 1), a === 46 ? e === -1 ? e = r : o !== 1 && (o = 1) : e !== -1 && (o = -1);
    }
    return e === -1 || i === -1 || o === 0 || o === 1 && e === i - 1 && e === t + 1 ? "" : n.slice(e, i);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */
  parse(n) {
    Gi(n);
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (n.length === 0) return e;
    n = hd(this.toPosix(n));
    let t = n.charCodeAt(0);
    const i = this.isAbsolute(n);
    let s;
    e.root = this.rootname(n), i || this.hasProtocol(n) ? s = 1 : s = 0;
    let o = -1, r = 0, a = -1, l = !0, d = n.length - 1, c = 0;
    for (; d >= s; --d) {
      if (t = n.charCodeAt(d), t === 47) {
        if (!l) {
          r = d + 1;
          break;
        }
        continue;
      }
      a === -1 && (l = !1, a = d + 1), t === 46 ? o === -1 ? o = d : c !== 1 && (c = 1) : o !== -1 && (c = -1);
    }
    return o === -1 || a === -1 || c === 0 || c === 1 && o === a - 1 && o === r + 1 ? a !== -1 && (r === 0 && i ? e.base = e.name = n.slice(1, a) : e.base = e.name = n.slice(r, a)) : (r === 0 && i ? (e.name = n.slice(1, o), e.base = n.slice(1, a)) : (e.name = n.slice(r, o), e.base = n.slice(r, a)), e.ext = n.slice(o, a)), e.dir = this.dirname(n), e;
  },
  sep: "/",
  delimiter: ":",
  joinExtensions: [".html"]
};
function US(n, e, t, i, s) {
  const o = e[t];
  for (let r = 0; r < o.length; r++) {
    const a = o[r];
    t < e.length - 1 ? US(n.replace(i[t], a), e, t + 1, i, s) : s.push(n.replace(i[t], a));
  }
}
function vY(n) {
  const e = /\{(.*?)\}/g, t = n.match(e), i = [];
  if (t) {
    const s = [];
    t.forEach((o) => {
      const r = o.substring(1, o.length - 1).split(",");
      s.push(r);
    }), US(n, s, 0, t, i);
  } else
    i.push(n);
  return i;
}
const Pk = (n) => !Array.isArray(n);
class GS {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (e, t) => `${e}${this._bundleIdConnector}${t}`,
      extractAssetIdFromBundle: (e, t) => t.replace(`${e}${this._bundleIdConnector}`, "")
    }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(e) {
    var t, i, s;
    if (this._bundleIdConnector = (t = e.connector) != null ? t : this._bundleIdConnector, this._createBundleAssetId = (i = e.createBundleAssetId) != null ? i : this._createBundleAssetId, this._extractAssetIdFromBundle = (s = e.extractAssetIdFromBundle) != null ? s : this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar")
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...e) {
    e.forEach((t) => {
      this._preferredOrder.push(t), t.priority || (t.priority = Object.keys(t.params));
    }), this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(e) {
    this._basePath = e;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(e) {
    this._rootPath = e;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(e) {
    if (typeof e == "string")
      this._defaultSearchParams = e;
    else {
      const t = e;
      this._defaultSearchParams = Object.keys(t).map((i) => `${encodeURIComponent(i)}=${encodeURIComponent(t[i])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(e) {
    const { alias: t, src: i } = e;
    return Za(
      t || i,
      (o) => typeof o == "string" ? o : Array.isArray(o) ? o.map((r) => {
        var a;
        return (a = r == null ? void 0 : r.src) != null ? a : r;
      }) : o != null && o.src ? o.src : o,
      !0
    );
  }
  /**
   * Removes the specified alias for an asset.
   *
   * This only removes the alias mapping. It does **not** remove, unload, or destroy the
   * underlying asset. If the asset is already cached, it stays in memory until you call
   * `Assets.unload`.
   *
   * If `asset` is provided, the alias is only removed when the resolver's current mapping for
   * that alias matches the given `ResolvedAsset`. This lets you avoid accidentally removing an
   * alias that has been reassigned.
   *
   * Silently returns if the alias does not exist or the asset does not match.
   * @param alias - the alias to remove
   * @param asset - only remove the alias if it is currently assigned to this asset
   * @example
   * ```ts
   * resolver.add({ alias: 'hero', src: 'hero.png' });
   *
   * // Simple removal
   * resolver.removeAlias('hero');
   *
   * // Conditional removal — only if alias currently maps to a specific asset
   * const resolved = resolver.resolve('hero');
   * resolver.removeAlias('hero', resolved);
   * ```
   */
  removeAlias(e, t) {
    this._assetMap[e] && (t && t !== this._resolverHash[e] || (delete this._resolverHash[e], delete this._assetMap[e]));
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(e) {
    this._manifest && dt("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = e, e.bundles.forEach((t) => {
      this.addBundle(t.name, t.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(e, t) {
    const i = [];
    let s = t;
    Array.isArray(t) || (s = Object.entries(t).map(([o, r]) => typeof r == "string" || Array.isArray(r) ? { alias: o, src: r } : { alias: o, ...r })), s.forEach((o) => {
      const r = o.src, a = o.alias;
      let l;
      if (typeof a == "string") {
        const d = this._createBundleAssetId(e, a);
        i.push(d), l = [a, d];
      } else {
        const d = a.map((c) => this._createBundleAssetId(e, c));
        i.push(...d), l = [...a, ...d];
      }
      this.add({
        ...o,
        alias: l,
        src: r
      });
    }), this._bundles[e] = i;
  }
  /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */
  add(e) {
    const t = [];
    Array.isArray(e) ? t.push(...e) : t.push(e);
    let i;
    i = (o) => {
      this.hasKey(o) && dt(`[Resolver] already has key: ${o} overwriting`);
    }, Za(t).forEach((o) => {
      const { src: r } = o;
      let {
        data: a,
        format: l,
        loadParser: d,
        parser: c
      } = o;
      const h = Za(r).map((v) => typeof v == "string" ? vY(v) : Array.isArray(v) ? v : [v]), f = this.getAlias(o);
      Array.isArray(f) ? f.forEach(i) : i(f);
      const p = [], y = (v) => {
        const x = this._parsers.find((w) => w.test(v));
        return {
          src: v,
          ...x == null ? void 0 : x.parse(v)
        };
      };
      h.forEach((v) => {
        v.forEach((x) => {
          var S, M, _, T;
          let w = {};
          if (typeof x != "object" ? w = y(x) : (a = (S = x.data) != null ? S : a, l = (M = x.format) != null ? M : l, (x.loadParser || x.parser) && (d = (_ = x.loadParser) != null ? _ : d, c = (T = x.parser) != null ? T : c), w = {
            ...y(x.src),
            ...x
          }), !f)
            throw new Error(`[Resolver] alias is undefined for this asset: ${w.src}`);
          w = this._buildResolvedAsset(w, {
            aliases: f,
            data: a,
            format: l,
            loadParser: d,
            parser: c,
            progressSize: o.progressSize
          }), p.push(w);
        });
      }), f.forEach((v) => {
        this._assetMap[v] = p;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(e) {
    const t = Pk(e);
    e = Za(e);
    const i = {};
    return e.forEach((s) => {
      const o = this._bundles[s];
      if (o) {
        const r = this.resolve(o), a = {};
        for (const l in r) {
          const d = r[l];
          a[this._extractAssetIdFromBundle(s, l)] = d;
        }
        i[s] = a;
      }
    }), t ? i[e[0]] : i;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(e) {
    const t = this.resolve(e);
    if (typeof e != "string") {
      const i = {};
      for (const s in t)
        i[s] = t[s].src;
      return i;
    }
    return t.src;
  }
  resolve(e) {
    const t = Pk(e);
    e = Za(e);
    const i = {};
    return e.forEach((s) => {
      if (!this._resolverHash[s])
        if (this._assetMap[s]) {
          let o = this._assetMap[s];
          const r = this._getPreferredOrder(o);
          r == null || r.priority.forEach((a) => {
            r.params[a].forEach((l) => {
              const d = o.filter((c) => c[a] ? c[a] === l : !1);
              d.length && (o = d);
            });
          }), this._resolverHash[s] = o[0];
        } else
          this._resolverHash[s] = this._buildResolvedAsset({
            alias: [s],
            src: s
          }, {});
      i[s] = this._resolverHash[s];
    }), t ? i[e[0]] : i;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(e) {
    return !!this._assetMap[e];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(e) {
    return !!this._bundles[e];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(e) {
    for (let t = 0; t < e.length; t++) {
      const i = e[t], s = this._preferredOrder.find((o) => o.params.format.includes(i.format));
      if (s)
        return s;
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(e) {
    if (!this._defaultSearchParams) return e;
    const t = /\?/.test(e) ? "&" : "?";
    return `${e}${t}${this._defaultSearchParams}`;
  }
  _buildResolvedAsset(e, t) {
    var d, c;
    const { aliases: i, data: s, loadParser: o, parser: r, format: a, progressSize: l } = t;
    return (this._basePath || this._rootPath) && (e.src = jc.toAbsolute(e.src, this._basePath, this._rootPath)), e.alias = (d = i != null ? i : e.alias) != null ? d : [e.src], e.src = this._appendDefaultSearchParams(e.src), e.data = { ...s || {}, ...e.data }, e.loadParser = o != null ? o : e.loadParser, e.parser = r != null ? r : e.parser, e.format = (c = a != null ? a : e.format) != null ? c : yY(e.src), l !== void 0 && (e.progressSize = l), e;
  }
}
GS.RETINA_PREFIX = /@([0-9\.]+)x/;
function yY(n) {
  return n.split(".").pop().split("?").shift().split("#").shift();
}
const Ek = (n, e) => {
  const t = e.split("?")[1];
  return t && (n += `?${t}`), n;
}, jS = class Kd {
  constructor(e, t) {
    this.linkedSheets = [];
    let i = e;
    (e == null ? void 0 : e.source) instanceof un && (i = {
      texture: e,
      data: t
    });
    const { texture: s, data: o, cachePrefix: r = "" } = i;
    this.cachePrefix = r, this._texture = s instanceof et ? s : null, this.textureSource = s.source, this.textures = {}, this.animations = {}, this.data = o;
    const a = parseFloat(o.meta.scale);
    a ? (this.resolution = a, s.source.resolution = this.resolution) : this.resolution = s.source._resolution, this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
  }
  /**
   * Parse spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */
  parse() {
    return new Promise((e) => {
      this._callback = e, this._batchIndex = 0, this._frameKeys.length <= Kd.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
    });
  }
  /**
   * Parse spritesheet from loaded data. This is done synchronously
   * and is only suitable for smaller spritesheets (less than ~1000 frames)
   * or may cause too many Texture within a single process. However, synchronous parsing may be
   * more convenient since the called does not need to be asynchronous and is safe for
   * small-to-medium sized spritesheets.
   *
   * Other than being synchronous, `parseSync` is otherwise identical to `.parse()`.
   */
  parseSync() {
    return this._processFrames(0, !0), this._processAnimations(), this.textures;
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   * @param processAll - if true will process all frames in a single batch, ignoring BATCH_SIZE - this
   * is used for synchronous parsing.
   */
  _processFrames(e, t = !1) {
    let i = e;
    const s = t ? 1 / 0 : Kd.BATCH_SIZE;
    for (; i - e < s && i < this._frameKeys.length; ) {
      const o = this._frameKeys[i], r = this._frames[o], a = r.frame;
      if (a) {
        let l = null, d = null;
        const c = r.trimmed !== !1 && r.sourceSize ? r.sourceSize : r.frame, h = new Tt(
          0,
          0,
          Math.floor(c.w) / this.resolution,
          Math.floor(c.h) / this.resolution
        );
        r.rotated ? l = new Tt(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.h) / this.resolution,
          Math.floor(a.w) / this.resolution
        ) : l = new Tt(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        ), r.trimmed !== !1 && r.spriteSourceSize && (d = new Tt(
          Math.floor(r.spriteSourceSize.x) / this.resolution,
          Math.floor(r.spriteSourceSize.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        )), this.textures[o] = new et({
          source: this.textureSource,
          frame: l,
          orig: h,
          trim: d,
          rotate: r.rotated ? 2 : 0,
          defaultAnchor: r.anchor,
          defaultBorders: r.borders,
          label: o.toString()
        });
      }
      i++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const e = this.data.animations || {};
    for (const t in e) {
      this.animations[t] = [];
      for (let i = 0; i < e[t].length; i++) {
        const s = e[t][i];
        this.animations[t].push(this.textures[s]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const e = this._callback;
    this._callback = null, this._batchIndex = 0, e.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * Kd.BATCH_SIZE), this._batchIndex++, setTimeout(() => {
      this._batchIndex * Kd.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(e = !1) {
    var t;
    for (const i in this.textures)
      this.textures[i].destroy();
    this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, e && ((t = this._texture) == null || t.destroy(), this.textureSource.destroy()), this._texture = null, this.textureSource = null, this.linkedSheets = [];
  }
};
jS.BATCH_SIZE = 1e3;
let Rk = jS;
const xY = [
  "jpg",
  "png",
  "jpeg",
  "avif",
  "webp",
  "basis",
  "etc2",
  "bc7",
  "bc6h",
  "bc5",
  "bc4",
  "bc3",
  "bc2",
  "bc1",
  "eac",
  "astc"
];
function HS(n, e, t) {
  const i = {};
  if (n.forEach((s) => {
    i[s] = e;
  }), Object.keys(e.textures).forEach((s) => {
    i[`${e.cachePrefix}${s}`] = e.textures[s];
  }), !t) {
    const s = jc.dirname(n[0]);
    e.linkedSheets.forEach((o, r) => {
      const a = HS([`${s}/${e.data.meta.related_multi_packs[r]}`], o, !0);
      Object.assign(i, a);
    });
  }
  return i;
}
const wY = {
  extension: Ae.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (n) => n instanceof Rk,
    getCacheableAssets: (n, e) => HS(n, e, !1)
  },
  /** Resolve the resolution of the asset. */
  resolver: {
    extension: {
      type: Ae.ResolveParser,
      name: "resolveSpritesheet"
    },
    test: (n) => {
      const t = n.split("?")[0].split("."), i = t.pop(), s = t.pop();
      return i === "json" && xY.includes(s);
    },
    parse: (n) => {
      var t, i;
      const e = n.split(".");
      return {
        resolution: parseFloat((i = (t = GS.RETINA_PREFIX.exec(n)) == null ? void 0 : t[1]) != null ? i : "1"),
        format: e[e.length - 2],
        src: n
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */
  loader: {
    /** used for deprecation purposes */
    name: "spritesheetLoader",
    id: "spritesheet",
    extension: {
      type: Ae.LoadParser,
      priority: NS.Normal,
      name: "spritesheetLoader"
    },
    async testParse(n, e) {
      return jc.extname(e.src).toLowerCase() === ".json" && !!n.frames;
    },
    async parse(n, e, t) {
      var h, f, p;
      const {
        texture: i,
        // if user need to use preloaded texture
        imageFilename: s,
        // if user need to use custom filename (not from jsonFile.meta.image)
        textureOptions: o,
        // if user need to set texture options on texture
        cachePrefix: r
        // if user need to use custom cache prefix
      } = (h = e == null ? void 0 : e.data) != null ? h : {};
      let a = jc.dirname(e.src);
      a && a.lastIndexOf("/") !== a.length - 1 && (a += "/");
      let l;
      if (i instanceof et)
        l = i;
      else {
        const y = Ek(a + (s != null ? s : n.meta.image), e.src);
        l = (await t.load([{ src: y, data: o }]))[y];
      }
      const d = new Rk({
        texture: l.source,
        data: n,
        cachePrefix: r
      });
      await d.parse();
      const c = (f = n == null ? void 0 : n.meta) == null ? void 0 : f.related_multi_packs;
      if (Array.isArray(c)) {
        const y = [];
        for (const x of c) {
          if (typeof x != "string")
            continue;
          let w = a + x;
          (p = e.data) != null && p.ignoreMultiPack || (w = Ek(w, e.src), y.push(t.load({
            src: w,
            data: {
              textureOptions: o,
              ignoreMultiPack: !0
            }
          })));
        }
        const v = await Promise.all(y);
        d.linkedSheets = v, v.forEach((x) => {
          x.linkedSheets = [d].concat(d.linkedSheets.filter((w) => w !== x));
        });
      }
      return d;
    },
    async unload(n, e, t) {
      await t.unload(n.textureSource._sourceOrigin), n.destroy(!1);
    }
  }
};
ht.add(wY);
class VS {
  constructor(e) {
    this._lastTransform = "", this._observer = null, this._tickerAttached = !1, this.updateTranslation = () => {
      if (!this._canvas) return;
      const t = this._canvas.getBoundingClientRect(), i = this._canvas.width, s = this._canvas.height, o = t.width / i * this._renderer.resolution, r = t.height / s * this._renderer.resolution, a = t.left, l = t.top, d = `translate(${a}px, ${l}px) scale(${o}, ${r})`;
      d !== this._lastTransform && (this._domElement.style.transform = d, this._lastTransform = d);
    }, this._domElement = e.domElement, this._renderer = e.renderer, !(globalThis.OffscreenCanvas && this._renderer.canvas instanceof OffscreenCanvas) && (this._canvas = this._renderer.canvas, this._attachObserver());
  }
  /** The canvas element that this CanvasObserver is associated with. */
  get canvas() {
    return this._canvas;
  }
  /** Attaches the DOM element to the canvas parent if it is not already attached. */
  ensureAttached() {
    !this._domElement.parentNode && this._canvas.parentNode && (this._canvas.parentNode.appendChild(this._domElement), this.updateTranslation());
  }
  /** Sets up a ResizeObserver if available. This ensures that the DOM element is kept in sync with the canvas size . */
  _attachObserver() {
    "ResizeObserver" in globalThis ? (this._observer && (this._observer.disconnect(), this._observer = null), this._observer = new ResizeObserver((e) => {
      for (const t of e) {
        if (t.target !== this._canvas)
          continue;
        const i = this.canvas.width, s = this.canvas.height, o = t.contentRect.width / i * this._renderer.resolution, r = t.contentRect.height / s * this._renderer.resolution;
        (this._lastScaleX !== o || this._lastScaleY !== r) && (this.updateTranslation(), this._lastScaleX = o, this._lastScaleY = r);
      }
    }), this._observer.observe(this._canvas)) : this._tickerAttached || Oi.shared.add(this.updateTranslation, this, Ol.HIGH);
  }
  /** Destroys the CanvasObserver instance, cleaning up observers and Ticker. */
  destroy() {
    this._observer ? (this._observer.disconnect(), this._observer = null) : this._tickerAttached && Oi.shared.remove(this.updateTranslation), this._domElement = null, this._renderer = null, this._canvas = null, this._tickerAttached = !1, this._lastTransform = "", this._lastScaleX = null, this._lastScaleY = null;
  }
}
class wu {
  /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */
  constructor(e) {
    this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = wu.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new Wt(), this.page = new Wt(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = e;
  }
  /** @readonly */
  get layerX() {
    return this.layer.x;
  }
  /** @readonly */
  get layerY() {
    return this.layer.y;
  }
  /** @readonly */
  get pageX() {
    return this.page.x;
  }
  /** @readonly */
  get pageY() {
    return this.page.y;
  }
  /**
   * Fallback for the deprecated `InteractionEvent.data`.
   * @deprecated since 7.0.0
   */
  get data() {
    return this;
  }
  /**
   * The propagation path for this event. Alias for {@link EventBoundary.propagationPath}.
   * @advanced
   */
  composedPath() {
    return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
  }
  /**
   * Unimplemented method included for implementing the DOM interface `Event`. It will throw an `Error`.
   * @deprecated
   * @ignore
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */
  initEvent(e, t, i) {
    throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Unimplemented method included for implementing the DOM interface `UIEvent`. It will throw an `Error`.
   * @ignore
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */
  initUIEvent(e, t, i, s, o) {
    throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Prevent default behavior of both PixiJS and the user agent.
   * @example
   * ```ts
   * sprite.on('click', (event) => {
   *     // Prevent both browser's default click behavior
   *     // and PixiJS's default handling
   *     event.preventDefault();
   *
   *     // Custom handling
   *     customClickHandler();
   * });
   * ```
   * @remarks
   * - Only works if the native event is cancelable
   * - Does not stop event propagation
   */
  preventDefault() {
    this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
  }
  /**
   * Stop this event from propagating to any additional listeners, including those
   * on the current target and any following targets in the propagation path.
   * @example
   * ```ts
   * container.on('pointerdown', (event) => {
   *     // Stop all further event handling
   *     event.stopImmediatePropagation();
   *
   *     // These handlers won't be called:
   *     // - Other pointerdown listeners on this container
   *     // - Any pointerdown listeners on parent containers
   * });
   * ```
   * @remarks
   * - Immediately stops all event propagation
   * - Prevents other listeners on same target from being called
   * - More aggressive than stopPropagation()
   */
  stopImmediatePropagation() {
    this.propagationImmediatelyStopped = !0;
  }
  /**
   * Stop this event from propagating to the next target in the propagation path.
   * The rest of the listeners on the current target will still be notified.
   * @example
   * ```ts
   * child.on('pointermove', (event) => {
   *     // Handle event on child
   *     updateChild();
   *
   *     // Prevent parent handlers from being called
   *     event.stopPropagation();
   * });
   *
   * // This won't be called if child handles the event
   * parent.on('pointermove', (event) => {
   *     updateParent();
   * });
   * ```
   * @remarks
   * - Stops event bubbling to parent containers
   * - Does not prevent other listeners on same target
   * - Less aggressive than stopImmediatePropagation()
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
var Pg = /iPhone/i, zk = /iPod/i, $k = /iPad/i, Dk = /\biOS-universal(?:.+)Mac\b/i, Eg = /\bAndroid(?:.+)Mobile\b/i, Ok = /Android/i, Ca = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, rh = /Silk/i, Es = /Windows Phone/i, Lk = /\bWindows(?:.+)ARM\b/i, Bk = /BlackBerry/i, Fk = /BB10/i, Nk = /Opera Mini/i, Uk = /\b(CriOS|Chrome)(?:.+)Mobile/i, Gk = /Mobile(?:.+)Firefox\b/i, jk = function(n) {
  return typeof n != "undefined" && n.platform === "MacIntel" && typeof n.maxTouchPoints == "number" && n.maxTouchPoints > 1 && typeof MSStream == "undefined";
};
function kY(n) {
  return function(e) {
    return e.test(n);
  };
}
function Hk(n) {
  var e = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !n && typeof navigator != "undefined" ? e = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof n == "string" ? e.userAgent = n : n && n.userAgent && (e = {
    userAgent: n.userAgent,
    platform: n.platform,
    maxTouchPoints: n.maxTouchPoints || 0
  });
  var t = e.userAgent, i = t.split("[FBAN");
  typeof i[1] != "undefined" && (t = i[0]), i = t.split("Twitter"), typeof i[1] != "undefined" && (t = i[0]);
  var s = kY(t), o = {
    apple: {
      phone: s(Pg) && !s(Es),
      ipod: s(zk),
      tablet: !s(Pg) && (s($k) || jk(e)) && !s(Es),
      universal: s(Dk),
      device: (s(Pg) || s(zk) || s($k) || s(Dk) || jk(e)) && !s(Es)
    },
    amazon: {
      phone: s(Ca),
      tablet: !s(Ca) && s(rh),
      device: s(Ca) || s(rh)
    },
    android: {
      phone: !s(Es) && s(Ca) || !s(Es) && s(Eg),
      tablet: !s(Es) && !s(Ca) && !s(Eg) && (s(rh) || s(Ok)),
      device: !s(Es) && (s(Ca) || s(rh) || s(Eg) || s(Ok)) || s(/\bokhttp\b/i)
    },
    windows: {
      phone: s(Es),
      tablet: s(Lk),
      device: s(Es) || s(Lk)
    },
    other: {
      blackberry: s(Bk),
      blackberry10: s(Fk),
      opera: s(Nk),
      firefox: s(Gk),
      chrome: s(Uk),
      device: s(Bk) || s(Fk) || s(Nk) || s(Gk) || s(Uk)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return o.any = o.apple.device || o.android.device || o.windows.device || o.other.device, o.phone = o.apple.phone || o.android.phone || o.windows.phone, o.tablet = o.apple.tablet || o.android.tablet || o.windows.tablet, o;
}
var F3;
const _Y = (F3 = Hk.default) != null ? F3 : Hk, SY = _Y(globalThis.navigator), MY = 9, Vk = 100, TY = 0, CY = 0, Wk = 2, qk = 1, IY = -1e3, AY = -1e3, PY = 2, ny = class WS {
  // eslint-disable-next-line jsdoc/require-param
  /**
   * @param {WebGLRenderer|WebGPURenderer} renderer - A reference to the current renderer
   */
  constructor(e, t = SY) {
    this._mobileInfo = t, this.debug = !1, this._activateOnTab = !0, this._deactivateOnMouseMove = !0, this._isActive = !1, this._isMobileAccessibility = !1, this._div = null, this._pools = {}, this._renderId = 0, this._children = [], this._androidUpdateCount = 0, this._androidUpdateFrequency = 500, this._isRunningTests = !1, this._boundOnKeyDown = this._onKeyDown.bind(this), this._boundOnMouseMove = this._onMouseMove.bind(this), this._hookDiv = null, (t.tablet || t.phone) && this._createTouchHook(), this._renderer = e;
  }
  /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @type {boolean}
   * @readonly
   */
  get isActive() {
    return this._isActive;
  }
  /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @type {boolean}
   * @readonly
   */
  get isMobileAccessibility() {
    return this._isMobileAccessibility;
  }
  /**
   * Button element for handling touch hooks.
   * @readonly
   */
  get hookDiv() {
    return this._hookDiv;
  }
  /**
   * The DOM element that will sit over the PixiJS element. This is where the div overlays will go.
   * @readonly
   */
  get div() {
    return this._div;
  }
  /**
   * Creates the touch hooks.
   * @private
   */
  _createTouchHook() {
    const e = document.createElement("button");
    e.style.width = `${qk}px`, e.style.height = `${qk}px`, e.style.position = "absolute", e.style.top = `${IY}px`, e.style.left = `${AY}px`, e.style.zIndex = PY.toString(), e.style.backgroundColor = "#FF0000", e.title = "select to enable accessibility for this content", e.addEventListener("focus", () => {
      this._isMobileAccessibility = !0, this._activate(), this._destroyTouchHook();
    }), document.body.appendChild(e), this._hookDiv = e;
  }
  /**
   * Destroys the touch hooks.
   * @private
   */
  _destroyTouchHook() {
    this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
  }
  /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */
  _activate() {
    if (this._isActive)
      return;
    this._isActive = !0, this._div || (this._div = document.createElement("div"), this._div.style.position = "absolute", this._div.style.top = `${TY}px`, this._div.style.left = `${CY}px`, this._div.style.pointerEvents = "none", this._div.style.zIndex = Wk.toString(), this._canvasObserver = new VS({
      domElement: this._div,
      renderer: this._renderer
    })), this._deactivateOnMouseMove && globalThis.document.addEventListener("mousemove", this._boundOnMouseMove, !0);
    const e = this._renderer.view.canvas;
    if (e.parentNode)
      this._canvasObserver.ensureAttached(), this._initAccessibilitySetup();
    else {
      const t = new MutationObserver(() => {
        e.parentNode && (t.disconnect(), this._canvasObserver.ensureAttached(), this._initAccessibilitySetup());
      });
      t.observe(document.body, { childList: !0, subtree: !0 });
    }
  }
  // New method to handle initialization after div is ready
  _initAccessibilitySetup() {
    this._renderer.runners.postrender.add(this), this._renderer.lastObjectRendered && this._updateAccessibleObjects(this._renderer.lastObjectRendered);
  }
  /**
   * Deactivates the accessibility system. Removes listeners and accessibility elements.
   * @private
   */
  _deactivate() {
    var e, t;
    if (!(!this._isActive || this._isMobileAccessibility)) {
      this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, !0), this._renderer.runners.postrender.remove(this);
      for (const i of this._children)
        (e = i._accessibleDiv) != null && e.parentNode && (i._accessibleDiv.parentNode.removeChild(i._accessibleDiv), i._accessibleDiv = null), i._accessibleActive = !1;
      for (const i in this._pools)
        this._pools[i].forEach((o) => {
          o.parentNode && o.parentNode.removeChild(o);
        }), delete this._pools[i];
      (t = this._div) != null && t.parentNode && this._div.parentNode.removeChild(this._div), this._pools = {}, this._children = [];
    }
  }
  /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {Container} container - The Container to check.
   */
  _updateAccessibleObjects(e) {
    if (!e.visible || !e.accessibleChildren)
      return;
    e.accessible && (e._accessibleActive || this._addChild(e), e._renderId = this._renderId);
    const t = e.children;
    if (t)
      for (let i = 0; i < t.length; i++)
        this._updateAccessibleObjects(t[i]);
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    const i = {
      accessibilityOptions: {
        ...WS.defaultOptions,
        ...(e == null ? void 0 : e.accessibilityOptions) || {}
      }
    };
    this.debug = i.accessibilityOptions.debug, this._activateOnTab = i.accessibilityOptions.activateOnTab, this._deactivateOnMouseMove = i.accessibilityOptions.deactivateOnMouseMove, this._activateOnTab && globalThis.addEventListener("keydown", this._boundOnKeyDown, !1), i.accessibilityOptions.enabledByDefault && this._activate(), this._renderer.runners.postrender.remove(this);
  }
  /**
   * Updates the accessibility layer during rendering.
   * - Removes divs for containers no longer in the scene
   * - Updates the position and dimensions of the root div
   * - Updates positions of active accessibility divs
   * Only fires while the accessibility system is active.
   * @ignore
   */
  postrender() {
    const e = performance.now();
    if (this._mobileInfo.android.device && e < this._androidUpdateCount || (this._androidUpdateCount = e + this._androidUpdateFrequency, (!this._renderer.renderingToScreen || !this._renderer.view.canvas) && !this._isRunningTests))
      return;
    const t = /* @__PURE__ */ new Set();
    if (this._renderer.lastObjectRendered) {
      this._updateAccessibleObjects(this._renderer.lastObjectRendered);
      for (const i of this._children)
        i._renderId === this._renderId && t.add(this._children.indexOf(i));
    }
    for (let i = this._children.length - 1; i >= 0; i--) {
      const s = this._children[i];
      t.has(i) || (s._accessibleDiv && s._accessibleDiv.parentNode && (s._accessibleDiv.parentNode.removeChild(s._accessibleDiv), this._getPool(s.accessibleType).push(s._accessibleDiv), s._accessibleDiv = null), s._accessibleActive = !1, TS(this._children, i, 1));
    }
    this._renderer.renderingToScreen && this._canvasObserver.ensureAttached();
    for (let i = 0; i < this._children.length; i++) {
      const s = this._children[i];
      if (!s._accessibleActive || !s._accessibleDiv)
        continue;
      const o = s._accessibleDiv, r = s.hitArea || s.getBounds().rectangle;
      if (s.hitArea) {
        const a = s.worldTransform;
        o.style.left = `${a.tx + r.x * a.a}px`, o.style.top = `${a.ty + r.y * a.d}px`, o.style.width = `${r.width * a.a}px`, o.style.height = `${r.height * a.d}px`;
      } else
        this._capHitArea(r), o.style.left = `${r.x}px`, o.style.top = `${r.y}px`, o.style.width = `${r.width}px`, o.style.height = `${r.height}px`;
    }
    this._renderId++;
  }
  /**
   * private function that will visually add the information to the
   * accessibility div
   * @param {HTMLElement} div -
   */
  _updateDebugHTML(e) {
    e.innerHTML = `type: ${e.type}</br> title : ${e.title}</br> tabIndex: ${e.tabIndex}`;
  }
  /**
   * Adjust the hit area based on the bounds of a display object
   * @param {Rectangle} hitArea - Bounds of the child
   */
  _capHitArea(e) {
    e.x < 0 && (e.width += e.x, e.x = 0), e.y < 0 && (e.height += e.y, e.y = 0);
    const { width: t, height: i } = this._renderer;
    e.x + e.width > t && (e.width = t - e.x), e.y + e.height > i && (e.height = i - e.y);
  }
  /**
   * Creates or reuses a div element for a Container and adds it to the accessibility layer.
   * Sets up ARIA attributes, event listeners, and positioning based on the container's properties.
   * @private
   * @param {Container} container - The child to make accessible.
   */
  _addChild(e) {
    let i = this._getPool(e.accessibleType).pop();
    i ? (i.innerHTML = "", i.removeAttribute("title"), i.removeAttribute("aria-label"), i.tabIndex = 0) : (e.accessibleType === "button" ? (i = document.createElement("button"), this.debug || (i.style.color = "transparent")) : (i = document.createElement(e.accessibleType), i.style.cssText = `
                        color: transparent;
                        pointer-events: none;
                        padding: 0;
                        margin: 0;
                        border: 0;
                        outline: 0;
                        background: transparent;
                        box-sizing: border-box;
                        user-select: none;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                    `), i.style.width = `${Vk}px`, i.style.height = `${Vk}px`, i.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", i.style.position = "absolute", i.style.zIndex = Wk.toString(), i.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? i.setAttribute("aria-live", "off") : i.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? i.setAttribute("aria-relevant", "additions") : i.setAttribute("aria-relevant", "text"), i.addEventListener("click", this._onClick.bind(this)), i.addEventListener("focus", this._onFocus.bind(this)), i.addEventListener("focusout", this._onFocusOut.bind(this))), i.style.pointerEvents = e.accessiblePointerEvents, i.type = e.accessibleType, e.accessibleText && (i.innerText = e.accessibleText), e.accessibleTitle && e.accessibleTitle !== null ? i.title = e.accessibleTitle : (!e.accessibleHint || e.accessibleHint === null) && (i.title = `container ${e.tabIndex}`), e.accessibleHint && e.accessibleHint !== null && i.setAttribute("aria-label", e.accessibleHint), e.interactive ? i.tabIndex = e.tabIndex : i.tabIndex = 0, this.debug && this._updateDebugHTML(i), e._accessibleActive = !0, e._accessibleDiv = i, i.container = e, this._children.push(e), this._div.appendChild(e._accessibleDiv);
  }
  /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */
  _dispatchEvent(e, t) {
    const { container: i } = e.target, s = this._renderer.events.rootBoundary, o = Object.assign(new wu(s), { target: i });
    s.rootTarget = this._renderer.lastObjectRendered, t.forEach((r) => s.dispatchEvent(o, r));
  }
  /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */
  _onClick(e) {
    this._dispatchEvent(e, ["click", "pointertap", "tap"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */
  _onFocus(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, ["mouseover"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */
  _onFocusOut(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, ["mouseout"]);
  }
  /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */
  _onKeyDown(e) {
    e.keyCode !== MY || !this._activateOnTab || this._activate();
  }
  /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */
  _onMouseMove(e) {
    e.movementX === 0 && e.movementY === 0 || this._deactivate();
  }
  /**
   * Destroys the accessibility system. Removes all elements and listeners.
   * > [!IMPORTANT] This is typically called automatically when the {@link Application} is destroyed.
   * > A typically user should not need to call this method directly.
   */
  destroy() {
    var e;
    this._deactivate(), this._destroyTouchHook(), (e = this._canvasObserver) == null || e.destroy(), this._canvasObserver = null, this._div = null, this._pools = null, this._children = null, this._renderer = null, this._hookDiv = null, globalThis.removeEventListener("keydown", this._boundOnKeyDown), this._boundOnKeyDown = null, globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, !0), this._boundOnMouseMove = null;
  }
  /**
   * Enables or disables the accessibility system.
   * @param enabled - Whether to enable or disable accessibility.
   * @example
   * ```js
   * app.renderer.accessibility.setAccessibilityEnabled(true); // Enable accessibility
   * app.renderer.accessibility.setAccessibilityEnabled(false); // Disable accessibility
   * ```
   */
  setAccessibilityEnabled(e) {
    e ? this._activate() : this._deactivate();
  }
  _getPool(e) {
    return this._pools[e] || (this._pools[e] = []), this._pools[e];
  }
};
ny.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "accessibility"
};
ny.defaultOptions = {
  /**
   * Whether to enable accessibility features on initialization
   * @default false
   */
  enabledByDefault: !1,
  /**
   * Whether to visually show the accessibility divs for debugging
   * @default false
   */
  debug: !1,
  /**
   * Whether to activate accessibility when tab key is pressed
   * @default true
   */
  activateOnTab: !0,
  /**
   * Whether to deactivate accessibility when mouse moves
   * @default true
   */
  deactivateOnMouseMove: !0
};
let EY = ny;
const RY = {
  accessible: !1,
  accessibleTitle: null,
  accessibleHint: null,
  tabIndex: 0,
  accessibleType: "button",
  accessibleText: null,
  accessiblePointerEvents: "auto",
  accessibleChildren: !0,
  _accessibleActive: !1,
  _accessibleDiv: null,
  _renderId: -1
}, Rg = /* @__PURE__ */ Object.create(null), Kk = /* @__PURE__ */ Object.create(null);
function Ll(n, e) {
  let t = Kk[n];
  return t === void 0 && (Rg[e] === void 0 && (Rg[e] = 1), Kk[n] = t = Rg[e]++), t;
}
let Ia;
function qS() {
  return (!Ia || Ia != null && Ia.isContextLost()) && (Ia = zt.get().createCanvas().getContext("webgl", {})), Ia;
}
let ah;
function zY() {
  if (!ah) {
    ah = "mediump";
    const n = qS();
    n && n.getShaderPrecisionFormat && (ah = n.getShaderPrecisionFormat(n.FRAGMENT_SHADER, n.HIGH_FLOAT).precision ? "highp" : "mediump");
  }
  return ah;
}
function $Y(n, e, t) {
  return e ? n : t ? (n = n.replace("out vec4 finalColor;", ""), `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${n}
        `) : `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${n}
        `;
}
const DY = /\buniform\s+([iu]?sampler\w+)/g, OY = /\bprecision\s+\w+\s+([iu]?sampler\w+)\s*;/g, LY = {
  sampler2D: "lowp",
  samplerCube: "lowp"
};
function BY(n, e, t) {
  const i = t ? e.maxSupportedFragmentPrecision : e.maxSupportedVertexPrecision;
  if (n.substring(0, 9) !== "precision") {
    let o = t ? e.requestedFragmentPrecision : e.requestedVertexPrecision;
    o === "highp" && i !== "highp" && (o = "mediump"), n = `precision ${o} float;
${n}`;
  } else i !== "highp" && n.substring(0, 15) === "precision highp" && (n = n.replace("precision highp", "precision mediump"));
  const s = e.maxSupportedFragmentPrecision === "highp" ? "highp" : "mediump";
  return FY(n, s);
}
function FY(n, e) {
  var s;
  const t = /* @__PURE__ */ new Set();
  let i = "";
  for (const [, o] of n.matchAll(OY)) t.add(o);
  for (const [, o] of n.matchAll(DY))
    t.has(o) || (t.add(o), i += `precision ${(s = LY[o]) != null ? s : e} ${o};
`);
  return i + n;
}
function NY(n, e) {
  return e ? `#version 300 es
${n}` : n;
}
const UY = {}, GY = {};
function jY(n, { name: e = "pixi-program" }, t = !0) {
  e = e.replace(/\s+/g, "-"), e += t ? "-fragment" : "-vertex";
  const i = t ? UY : GY;
  return i[e] ? (i[e]++, e += `-${i[e]}`) : i[e] = 1, n.indexOf("#define SHADER_NAME") !== -1 ? n : `${`#define SHADER_NAME ${e}`}
${n}`;
}
function HY(n, e) {
  return e ? n.replace("#version 300 es", "") : n;
}
const zg = {
  // strips any version headers..
  stripVersion: HY,
  // adds precision string if not already present
  ensurePrecision: BY,
  // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
  addProgramDefines: $Y,
  // add the program name to the shader
  setProgramName: jY,
  // add the version string to the shader header
  insertVersion: NY
}, pd = /* @__PURE__ */ Object.create(null), KS = class Kv {
  /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */
  constructor(e) {
    e = { ...Kv.defaultOptions, ...e };
    const t = e.fragment.indexOf("#version 300 es") !== -1, i = {
      stripVersion: t,
      ensurePrecision: {
        requestedFragmentPrecision: e.preferredFragmentPrecision,
        requestedVertexPrecision: e.preferredVertexPrecision,
        maxSupportedVertexPrecision: "highp",
        maxSupportedFragmentPrecision: zY()
      },
      setProgramName: {
        name: e.name
      },
      addProgramDefines: t,
      insertVersion: t
    };
    let s = e.fragment, o = e.vertex;
    Object.keys(zg).forEach((r) => {
      const a = i[r];
      s = zg[r](s, a, !0), o = zg[r](o, a, !1);
    }), this.fragment = s, this.vertex = o, this.transformFeedbackVaryings = e.transformFeedbackVaryings, this._key = Ll(`${this.vertex}:${this.fragment}`, "gl-program");
  }
  /** destroys the program */
  destroy() {
    this.fragment = null, this.vertex = null, this._attributeData = null, this._uniformData = null, this._uniformBlockData = null, this.transformFeedbackVaryings = null, pd[this._cacheKey] = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex}:${e.fragment}`;
    return pd[t] || (pd[t] = new Kv(e), pd[t]._cacheKey = t), pd[t];
  }
};
KS.defaultOptions = {
  preferredVertexPrecision: "highp",
  preferredFragmentPrecision: "mediump"
};
let Xl = KS;
const Yk = {
  uint8x2: { size: 2, stride: 2, normalised: !1 },
  uint8x4: { size: 4, stride: 4, normalised: !1 },
  sint8x2: { size: 2, stride: 2, normalised: !1 },
  sint8x4: { size: 4, stride: 4, normalised: !1 },
  unorm8x2: { size: 2, stride: 2, normalised: !0 },
  unorm8x4: { size: 4, stride: 4, normalised: !0 },
  snorm8x2: { size: 2, stride: 2, normalised: !0 },
  snorm8x4: { size: 4, stride: 4, normalised: !0 },
  uint16x2: { size: 2, stride: 4, normalised: !1 },
  uint16x4: { size: 4, stride: 8, normalised: !1 },
  sint16x2: { size: 2, stride: 4, normalised: !1 },
  sint16x4: { size: 4, stride: 8, normalised: !1 },
  unorm16x2: { size: 2, stride: 4, normalised: !0 },
  unorm16x4: { size: 4, stride: 8, normalised: !0 },
  snorm16x2: { size: 2, stride: 4, normalised: !0 },
  snorm16x4: { size: 4, stride: 8, normalised: !0 },
  float16x2: { size: 2, stride: 4, normalised: !1 },
  float16x4: { size: 4, stride: 8, normalised: !1 },
  float32: { size: 1, stride: 4, normalised: !1 },
  float32x2: { size: 2, stride: 8, normalised: !1 },
  float32x3: { size: 3, stride: 12, normalised: !1 },
  float32x4: { size: 4, stride: 16, normalised: !1 },
  uint32: { size: 1, stride: 4, normalised: !1 },
  uint32x2: { size: 2, stride: 8, normalised: !1 },
  uint32x3: { size: 3, stride: 12, normalised: !1 },
  uint32x4: { size: 4, stride: 16, normalised: !1 },
  sint32: { size: 1, stride: 4, normalised: !1 },
  sint32x2: { size: 2, stride: 8, normalised: !1 },
  sint32x3: { size: 3, stride: 12, normalised: !1 },
  sint32x4: { size: 4, stride: 16, normalised: !1 }
};
function Hc(n) {
  var e;
  return (e = Yk[n]) != null ? e : Yk.float32;
}
const VY = {
  f32: "float32",
  "vec2<f32>": "float32x2",
  "vec3<f32>": "float32x3",
  "vec4<f32>": "float32x4",
  vec2f: "float32x2",
  vec3f: "float32x3",
  vec4f: "float32x4",
  i32: "sint32",
  "vec2<i32>": "sint32x2",
  "vec3<i32>": "sint32x3",
  "vec4<i32>": "sint32x4",
  vec2i: "sint32x2",
  vec3i: "sint32x3",
  vec4i: "sint32x4",
  u32: "uint32",
  "vec2<u32>": "uint32x2",
  "vec3<u32>": "uint32x3",
  "vec4<u32>": "uint32x4",
  vec2u: "uint32x2",
  vec3u: "uint32x3",
  vec4u: "uint32x4",
  bool: "uint32",
  "vec2<bool>": "uint32x2",
  "vec3<bool>": "uint32x3",
  "vec4<bool>": "uint32x4"
}, Xk = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|\)|$)/g;
function Jk(n, e) {
  var i;
  let t;
  for (; (t = Xk.exec(n)) !== null; ) {
    const s = (i = VY[t[3]]) != null ? i : "float32";
    e[t[2]] = {
      location: parseInt(t[1], 10),
      format: s,
      stride: Hc(s).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  Xk.lastIndex = 0;
}
function WY(n) {
  return n.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "");
}
function qY({ source: n, entryPoint: e }) {
  const t = {}, i = WY(n), s = i.indexOf(`fn ${e}(`);
  if (s === -1)
    return t;
  const o = i.indexOf("->", s);
  if (o === -1)
    return t;
  const r = i.substring(s, o);
  if (Jk(r, t), Object.keys(t).length === 0) {
    const a = r.match(/\(\s*\w+\s*:\s*(\w+)/);
    if (a) {
      const l = a[1], d = new RegExp(`struct\\s+${l}\\s*\\{([^}]+)\\}`, "s"), c = i.match(d);
      c && Jk(c[1], t);
    }
  }
  return t;
}
function $g(n) {
  var h, f, p;
  const e = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g, t = /@group\((\d+)\)/, i = /@binding\((\d+)\)/, s = /var(<[^>]+>)? (\w+)/, o = /:\s*([\w<>]+)/, r = /struct\s+(\w+)\s*{([^}]+)}/g, a = /(\w+)\s*:\s*([\w\<\>]+)/g, l = /struct\s+(\w+)/, d = (h = n.match(e)) == null ? void 0 : h.map((y) => {
    var S;
    const v = y.match(s), x = (S = v == null ? void 0 : v[1]) != null ? S : "";
    let w;
    return x === "<uniform>" ? w = "uniform" : x.startsWith("<storage") && (w = "storage"), {
      group: parseInt(y.match(t)[1], 10),
      binding: parseInt(y.match(i)[1], 10),
      name: v[2],
      accessMode: w,
      type: y.match(o)[1]
    };
  });
  if (!d)
    return {
      groups: [],
      structs: []
    };
  const c = (p = (f = n.match(r)) == null ? void 0 : f.map((y) => {
    const v = y.match(l)[1], x = y.match(a).reduce((w, S) => {
      const [M, _] = S.split(":");
      return w[M.trim()] = _.trim(), w;
    }, {});
    return x ? { name: v, members: x } : null;
  }).filter(({ name: y }) => d.some(
    (v) => (
      // Handle both direct type matches and generic types like array<StructName>
      v.type === y || v.type.includes(`<${y}>`)
    )
  ))) != null ? p : [];
  return {
    groups: d,
    structs: c
  };
}
var hn = /* @__PURE__ */ ((n) => (n[n.VERTEX = 1] = "VERTEX", n[n.FRAGMENT = 2] = "FRAGMENT", n[n.COMPUTE = 4] = "COMPUTE", n))(hn || {});
function lh(n) {
  return n.endsWith("<u32>") ? "uint" : n.endsWith("<i32>") ? "sint" : "float";
}
function KY({ groups: n }) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const i = n[t];
    e[i.group] || (e[i.group] = []), i.accessMode === "uniform" ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      buffer: {
        type: "uniform"
      }
    }) : i.accessMode === "storage" ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      buffer: {
        type: "read-only-storage"
      }
    }) : i.type === "sampler" ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      sampler: {
        type: "filtering"
      }
    }) : i.type === "sampler_comparison" ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      sampler: {
        type: "comparison"
      }
    }) : i.type === "texture_2d" || i.type.startsWith("texture_2d<") ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: lh(i.type),
        viewDimension: "2d",
        multisampled: !1
      }
    }) : i.type === "texture_depth_2d" ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: "depth",
        viewDimension: "2d",
        multisampled: !1
      }
    }) : i.type === "texture_depth_2d_array" ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: "depth",
        viewDimension: "2d-array",
        multisampled: !1
      }
    }) : i.type === "texture_2d_array" || i.type.startsWith("texture_2d_array<") ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: lh(i.type),
        viewDimension: "2d-array",
        multisampled: !1
      }
    }) : i.type === "texture_3d" || i.type.startsWith("texture_3d<") ? e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: lh(i.type),
        viewDimension: "3d",
        multisampled: !1
      }
    }) : (i.type === "texture_cube" || i.type.startsWith("texture_cube<")) && e[i.group].push({
      binding: i.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: lh(i.type),
        viewDimension: "cube",
        multisampled: !1
      }
    });
  }
  for (let t = 0; t < e.length; t++)
    e[t] || (e[t] = []);
  return e;
}
function YY({ groups: n }) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const i = n[t];
    e[i.group] || (e[i.group] = {}), e[i.group][i.name] = i.binding;
  }
  return e;
}
function XY(n, e) {
  const t = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), s = [...n.structs, ...e.structs].filter((r) => t.has(r.name) ? !1 : (t.add(r.name), !0)), o = [...n.groups, ...e.groups].filter((r) => {
    const a = `${r.name}-${r.binding}`;
    return i.has(a) ? !1 : (i.add(a), !0);
  });
  return { structs: s, groups: o };
}
const fd = /* @__PURE__ */ Object.create(null);
class va {
  /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */
  constructor(e) {
    var a, l;
    this._layoutKey = 0, this._attributeLocationsKey = 0;
    const { fragment: t, vertex: i, layout: s, gpuLayout: o, name: r } = e;
    if (this.name = r, this.fragment = t, this.vertex = i, t.source === i.source) {
      const d = $g(t.source);
      this.structsAndGroups = d;
    } else {
      const d = $g(i.source), c = $g(t.source);
      this.structsAndGroups = XY(d, c);
    }
    this.layout = s != null ? s : YY(this.structsAndGroups), this.gpuLayout = o != null ? o : KY(this.structsAndGroups), this.autoAssignGlobalUniforms = ((a = this.layout[0]) == null ? void 0 : a.globalUniforms) !== void 0, this.autoAssignLocalUniforms = ((l = this.layout[1]) == null ? void 0 : l.localUniforms) !== void 0, this._generateProgramKey();
  }
  // TODO maker this pure
  _generateProgramKey() {
    const { vertex: e, fragment: t } = this, i = e.source + t.source + e.entryPoint + t.entryPoint;
    this._layoutKey = Ll(i, "program");
  }
  get attributeData() {
    var e;
    return (e = this._attributeData) != null || (this._attributeData = qY(this.vertex)), this._attributeData;
  }
  /** destroys the program */
  destroy() {
    this.gpuLayout = null, this.layout = null, this.structsAndGroups = null, this.fragment = null, this.vertex = null, fd[this._cacheKey] = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex.source}:${e.fragment.source}:${e.fragment.entryPoint}:${e.vertex.entryPoint}`;
    return fd[t] || (fd[t] = new va(e), fd[t]._cacheKey = t), fd[t];
  }
}
const YS = [
  "f32",
  "i32",
  "u32",
  "vec2<f32>",
  "vec3<f32>",
  "vec4<f32>",
  "mat2x2<f32>",
  "mat3x3<f32>",
  "mat4x4<f32>",
  "mat3x2<f32>",
  "mat4x2<f32>",
  "mat2x3<f32>",
  "mat4x3<f32>",
  "mat2x4<f32>",
  "mat3x4<f32>",
  "vec2<i32>",
  "vec3<i32>",
  "vec4<i32>",
  "vec2<u32>",
  "vec3<u32>",
  "vec4<u32>"
], JY = YS.reduce((n, e) => (n[e] = !0, n), {});
function ZY(n, e) {
  switch (n) {
    case "f32":
      return 0;
    case "vec2<f32>":
      return new Float32Array(2 * e);
    case "vec3<f32>":
      return new Float32Array(3 * e);
    case "vec4<f32>":
      return new Float32Array(4 * e);
    case "mat2x2<f32>":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3x3<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4x4<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const XS = class JS extends bi {
  /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */
  constructor(e, t) {
    var s, o;
    super(), this.uid = Nt("uniform"), this._resourceType = "uniformGroup", this._resourceId = Nt("resource"), this.isUniformGroup = !0, this._dirtyId = 0, this.destroyed = !1, t = { ...JS.defaultOptions, ...t }, this.uniformStructures = e;
    const i = {};
    for (const r in e) {
      const a = e[r];
      if (a.name = r, a.size = (s = a.size) != null ? s : 1, !JY[a.type]) {
        const l = a.type.match(/^array<(\w+(?:<\w+>)?),\s*(\d+)>$/);
        if (l) {
          const [, d, c] = l;
          throw new Error(
            `Uniform type ${a.type} is not supported. Use type: '${d}', size: ${c} instead.`
          );
        }
        throw new Error(`Uniform type ${a.type} is not supported. Supported uniform types are: ${YS.join(", ")}`);
      }
      (o = a.value) != null || (a.value = ZY(a.type, a.size)), i[r] = a.value;
    }
    this.uniforms = i, this._dirtyId = 1, this.ubo = t.ubo, this.isStatic = t.isStatic, this._signature = Ll(Object.keys(i).map(
      (r) => `${r}-${e[r].type}`
    ).join("-"), "uniform-group");
  }
  /**
   * an underlying buffer that will be uploaded to the GPU when using this UniformGroup.
   * It is created lazily by the renderer's ubo system on first use.
   */
  get buffer() {
    return this._buffer;
  }
  set buffer(e) {
    var t;
    this._buffer !== e && ((t = this._buffer) == null || t.off("change", this.onBufferChange, this), this._buffer = e, e == null || e.on("change", this.onBufferChange, this));
  }
  /**
   * The GC tracks this group's underlying buffer, not the group itself — a GC stamp on the
   * group (see BindGroup._touch) must land on the buffer, or the GC collects it while
   * cached bind groups still reference it.
   * @internal
   */
  get _gcLastUsed() {
    var e, t;
    return (t = (e = this._buffer) == null ? void 0 : e._gcLastUsed) != null ? t : -1;
  }
  set _gcLastUsed(e) {
    this._buffer && (this._buffer._gcLastUsed = e);
  }
  /**
   * Bind group keys are built from this group's _resourceId, not the buffer's — so when the
   * buffer re-keys (it resized, or the GC unloaded its GPU copy), this group must re-key too,
   * or cached GPUBindGroups keep referencing the destroyed GPU buffer.
   */
  onBufferChange() {
    this._resourceId = Nt("resource"), this.emit("change", this);
  }
  /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */
  update() {
    this._dirtyId++;
  }
};
XS.defaultOptions = {
  /** if true the UniformGroup is handled as an Uniform buffer object. */
  ubo: !1,
  /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */
  isStatic: !1
};
let Ts = XS;
class qo {
  /**
   * Create a new instance of the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */
  constructor(e) {
    this.resources = /* @__PURE__ */ Object.create(null), this._resourceKeysValue = null, this._dirty = !0;
    let t = 0;
    for (const i in e) {
      const s = e[i];
      this.setResource(s, t++);
    }
  }
  /**
   * The binding numbers in use in {@link BindGroup#resources}, ascending. Binding numbers can
   * have gaps, so per-draw loops index this list instead of running `for...in` over
   * `resources`, which builds a fresh key list on every call for integer keys.
   * @internal
   */
  get _resourceKeys() {
    var e;
    return (e = this._resourceKeysValue) != null || (this._resourceKeysValue = Object.keys(this.resources).map(Number)), this._resourceKeysValue;
  }
  /**
   * A key used internally to match it up to a WebGPU BindGroup.
   * Lazily rebuilt from resource IDs when dirty.
   * @internal
   */
  get _key() {
    if (this._dirty) {
      this._dirty = !1;
      const e = [];
      let t = 0;
      for (const i in this.resources)
        e[t++] = this.resources[i] ? this.resources[i]._resourceId : -1;
      this._keyValue = e.join("|");
    }
    return this._keyValue;
  }
  /**
   * Set a resource at a given index. This function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */
  setResource(e, t) {
    var s, o;
    const i = this.resources[t];
    e !== i && (i && ((s = i.off) == null || s.call(i, "change", this.onResourceChange, this)), (o = e.on) == null || o.call(e, "change", this.onResourceChange, this), i === void 0 && (this._resourceKeysValue = null), this.resources[t] = e, this._dirty = !0);
  }
  /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */
  getResource(e) {
    return this.resources[e];
  }
  /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param now - The current time in milliseconds.
   * @internal
   */
  _touch(e) {
    const t = this.resources, i = this._resourceKeys;
    for (let s = 0; s < i.length; s++) {
      const o = t[i[s]];
      o && (o._gcLastUsed = e);
    }
  }
  /** Destroys this bind group and removes all listeners. */
  destroy() {
    var t;
    const e = this.resources;
    for (const i in e) {
      const s = e[i];
      (t = s == null ? void 0 : s.off) == null || t.call(s, "change", this.onResourceChange, this);
    }
    this.resources = null, this._resourceKeysValue = null;
  }
  onResourceChange(e) {
    if (this._dirty = !0, e.destroyed) {
      const t = this.resources;
      for (const i in t)
        t[i] === e && (t[i] = null);
      dt(`[BindGroup] a '${e._resourceType}' was destroyed while still bound to a shader. Remove it from the shader before destroying it.`);
    }
  }
}
var rs = /* @__PURE__ */ ((n) => (n[n.WEBGL = 1] = "WEBGL", n[n.WEBGPU = 2] = "WEBGPU", n[n.CANVAS = 4] = "CANVAS", n[n.BOTH = 3] = "BOTH", n))(rs || {});
class Vc {
  /**
   * @param data - A dictionary of constants to set on the shader.
   * Keys should match the constant names in the WGSL shader.
   */
  constructor(e) {
    this.data = { ...e };
    const t = Object.keys(e).sort().map((i) => `${i}:${e[i]}`).join("|");
    this.id = Ll(t, "shader-overrides");
  }
  /**
   * Creates a ShaderOverrides instance from a plain object or existing instance.
   * @param overrides - The overrides to convert.
   * @returns A ShaderOverrides instance.
   */
  static from(e) {
    return e instanceof Vc ? e : new Vc(e);
  }
}
class lo extends bi {
  constructor(e) {
    super(), this.uid = Nt("shader"), this._uniformBindMap = /* @__PURE__ */ Object.create(null), this._ownedBindGroups = [], this._destroyed = !1;
    let {
      gpuProgram: t,
      glProgram: i,
      groups: s,
      resources: o,
      compatibleRenderers: r,
      groupMap: a,
      overrides: l
    } = e;
    this._overrides = l ? Vc.from(l) : null, this.gpuProgram = t, this.glProgram = i, r === void 0 && (r = 0, t && (r |= rs.WEBGPU), i && (r |= rs.WEBGL)), this.compatibleRenderers = r;
    const d = {};
    if (a)
      for (const c in a)
        for (const h in a[c]) {
          const f = a[c][h];
          d[f] = {
            group: c,
            binding: h,
            name: f
          };
        }
    if (!o && !s && (o = {}), o && s)
      throw new Error("[Shader] Cannot have both resources and groups");
    if (!t && s && !a)
      throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
    if (t && s && !a) {
      const c = t.structsAndGroups.groups;
      a = {}, c.forEach((h) => {
        a[h.group] = a[h.group] || {}, a[h.group][h.binding] = h.name, d[h.name] = h;
      });
    } else if (o) {
      s = {}, a || (a = {}), t && t.structsAndGroups.groups.forEach((f) => {
        a[f.group] = a[f.group] || {}, a[f.group][f.binding] = f.name, d[f.name] = f;
      });
      let c = 0;
      for (const h in o)
        d[h] || (t && !i && dt(`[Shader] the resource '${h}' matches no binding in the WGSL source — is the name correct?`), s[99] || (s[99] = new qo(), this._ownedBindGroups.push(s[99])), d[h] = { group: 99, binding: c, name: h }, a[99] = a[99] || {}, a[99][c] = h, c++);
      for (const h in o) {
        const f = h;
        let p = o[h];
        !p.source && !p._resourceType && (p = new Ts(p));
        const y = d[f];
        y && (s[y.group] || (s[y.group] = new qo(), this._ownedBindGroups.push(s[y.group])), s[y.group].setResource(p, y.binding));
      }
    }
    this.groups = s, this._uniformBindMap = a, this.resources = this._buildResourceAccessor(s, d);
  }
  /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */
  addResource(e, t, i) {
    var s, o;
    (s = this._uniformBindMap)[t] || (s[t] = {}), (o = this._uniformBindMap[t])[i] || (o[i] = e), this.groups[t] || (this.groups[t] = new qo(), this._ownedBindGroups.push(this.groups[t]));
  }
  _buildResourceAccessor(e, t) {
    const i = {};
    for (const s in t) {
      const o = t[s];
      Object.defineProperty(i, o.name, {
        get() {
          return e[o.group].getResource(o.binding);
        },
        set(r) {
          e[o.group].setResource(r, o.binding);
        }
      });
    }
    return i;
  }
  /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */
  destroy(e = !1) {
    var t, i;
    this._destroyed || (this._destroyed = !0, this.emit("destroy", this), e && ((t = this.gpuProgram) == null || t.destroy(), (i = this.glProgram) == null || i.destroy()), this.gpuProgram = null, this.glProgram = null, this.removeAllListeners(), this._uniformBindMap = null, this._ownedBindGroups.forEach((s) => {
      s.destroy();
    }), this._ownedBindGroups = null, this.resources = null, this.groups = null, this._overrides = null);
  }
  static from(e) {
    const { gpu: t, gl: i, ...s } = e;
    let o, r;
    return t && (o = va.from(t)), i && (r = Xl.from(i)), new lo({
      gpuProgram: o,
      glProgram: r,
      ...s
    });
  }
}
const QY = {
  normal: 0,
  add: 1,
  multiply: 2,
  screen: 3,
  overlay: 4,
  erase: 5,
  "normal-npm": 6,
  "add-npm": 7,
  "screen-npm": 8,
  min: 9,
  max: 10
}, ZS = {
  BLEND: 0,
  OFFSET: 1,
  CULLING: 2,
  DEPTH_TEST: 3,
  WINDING: 4,
  DEPTH_MASK: 5
}, { BLEND: Dg, OFFSET: Og, CULLING: Lg, DEPTH_TEST: Bg, WINDING: Fg, DEPTH_MASK: Ng } = ZS, Yv = class QS {
  constructor() {
    this.data = 0, this.blendMode = "normal", this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << Dg);
  }
  set blend(e) {
    !!(this.data & 1 << Dg) !== e && (this.data ^= 1 << Dg);
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << Og);
  }
  set offsets(e) {
    !!(this.data & 1 << Og) !== e && (this.data ^= 1 << Og);
  }
  /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */
  set cullMode(e) {
    if (e === "none") {
      this.culling = !1;
      return;
    }
    this.culling = !0, this.clockwiseFrontFace = e === "front";
  }
  get cullMode() {
    return this.culling ? this.clockwiseFrontFace ? "front" : "back" : "none";
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << Lg);
  }
  set culling(e) {
    !!(this.data & 1 << Lg) !== e && (this.data ^= 1 << Lg);
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << Bg);
  }
  set depthTest(e) {
    !!(this.data & 1 << Bg) !== e && (this.data ^= 1 << Bg);
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << Ng);
  }
  set depthMask(e) {
    !!(this.data & 1 << Ng) !== e && (this.data ^= 1 << Ng);
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << Fg);
  }
  set clockwiseFrontFace(e) {
    !!(this.data & 1 << Fg) !== e && (this.data ^= 1 << Fg);
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(e) {
    this.blend = e !== "none", this._blendMode = e, this._blendModeId = QY[e] || 0;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(e) {
    this.offsets = !!e, this._polygonOffset = e;
  }
  toString() {
    return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
  }
  /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */
  static for2d() {
    const e = new QS();
    return e.depthTest = !1, e.depthMask = !1, e.blend = !0, e;
  }
};
Yv.default2d = Yv.for2d();
let co = Yv;
const eM = class Xv extends lo {
  /**
   * @param options - The optional parameters of this filter.
   */
  constructor(e) {
    e = { ...Xv.defaultOptions, ...e }, super(e), this.enabled = !0, this._state = co.for2d(), this.blendMode = e.blendMode, this.padding = e.padding, typeof e.antialias == "boolean" ? this.antialias = e.antialias ? "on" : "off" : this.antialias = e.antialias, this.resolution = e.resolution, this.blendRequired = e.blendRequired, this.clipToViewport = e.clipToViewport, this.addResource("uTexture", 0, 1), e.blendRequired && this.addResource("uBackTexture", 0, 3);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  apply(e, t, i, s) {
    e.applyFilter(this, t, i, s);
  }
  /**
   * Get the blend mode of the filter.
   * @default "normal"
   */
  get blendMode() {
    return this._state.blendMode;
  }
  /** Sets the blend mode of the filter. */
  set blendMode(e) {
    this._state.blendMode = e;
  }
  /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */
  static from(e) {
    const { gpu: t, gl: i, ...s } = e;
    let o, r;
    return t && (o = va.from(t)), i && (r = Xl.from(i)), new Xv({
      gpuProgram: o,
      glProgram: r,
      ...s
    });
  }
};
eM.defaultOptions = {
  blendMode: "normal",
  resolution: 1,
  padding: 0,
  antialias: "off",
  blendRequired: !1,
  clipToViewport: !0
};
let tM = eM;
const Jv = [];
ht.handleByNamedList(Ae.Environment, Jv);
async function eX(n) {
  if (!n)
    for (let e = 0; e < Jv.length; e++) {
      const t = Jv[e];
      if (t.value.test()) {
        await t.value.load();
        return;
      }
    }
}
let md;
function nM() {
  if (typeof md == "boolean")
    return md;
  try {
    md = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({ a: "b" }, "a", "b") === !0;
  } catch {
    md = !1;
  }
  return md;
}
const Wc = /* @__PURE__ */ new Set();
let Zv = !1;
function Zk(n, e, t = 2) {
  const i = e && e.length, s = i ? e[0] * t : n.length;
  Wc.size && Wc.clear();
  let o = iM(n, 0, s, t, !0);
  const r = [];
  if (!o || o.next === o.prev) return r;
  let a = 0, l = 0, d = 0;
  if (i && (o = oX(n, e, o, t)), n.length > 80 * t) {
    a = n[0], l = n[1];
    let c = a, h = l;
    for (let f = t; f < s; f += t) {
      const p = n[f], y = n[f + 1];
      p < a && (a = p), y < l && (l = y), p > c && (c = p), y > h && (h = y);
    }
    d = Math.max(c - a, h - l), d = d !== 0 ? 32767 / d : 0;
  }
  return Qv(o, r, a, l, d), r;
}
function iM(n, e, t, i, s) {
  let o = null;
  if (s === vX(n, e, t, i) > 0)
    for (let r = e; r < t; r += i) o = t2(r / i | 0, n[r], n[r + 1], o);
  else
    for (let r = t - i; r >= e; r -= i) o = t2(r / i | 0, n[r], n[r + 1], o);
  return o && qc(o, o.next) && (Yc(o), o = o.next), o;
}
function ha(n, e = n) {
  const t = e === n;
  let i = n, s;
  do
    s = !1, i !== i.next && (Wc.size === 0 || !Wc.has(i)) && (qc(i, i.next) || kn(i.prev, i, i.next) === 0) ? ((t || i === e) && (e = i.prev), Zv = !0, Yc(i), i = i.prev, s = !0) : (t || i !== e) && (i = i.next, s = !t);
  while (s || i !== e);
  return e;
}
function Qv(n, e, t, i, s) {
  s && hX(n, t, i, s);
  let o = n, r = !1;
  for (; n.prev !== n.next; ) {
    const a = n.prev, l = n.next;
    if (kn(a, n, l) < 0 && (s ? nX(n, t, i, s) : tX(n))) {
      e.push(a.i, n.i, l.i), Yc(n), n = l, o = l;
      continue;
    }
    if (n = l, n === o) {
      if (Zv = !1, n = ha(n), Zv) {
        o = n;
        continue;
      }
      if (!r) {
        n = iX(n, e), o = n, r = !0;
        continue;
      }
      sX(n, e, t, i, s);
      break;
    }
  }
}
function tX(n) {
  const e = n.prev, t = n, i = n.next, s = e.x, o = t.x, r = i.x, a = e.y, l = t.y, d = i.y, c = Math.min(s, o, r), h = Math.min(a, l, d), f = Math.max(s, o, r), p = Math.max(a, l, d);
  let y = i.next;
  for (; y !== e; ) {
    if (y.x >= c && y.x <= f && y.y >= h && y.y <= p && !(s === y.x && a === y.y) && bf(s, a, o, l, r, d, y.x, y.y) && kn(y.prev, y, y.next) >= 0) return !1;
    y = y.next;
  }
  return !0;
}
function nX(n, e, t, i) {
  const s = n.prev, o = n, r = n.next, a = s.x, l = o.x, d = r.x, c = s.y, h = o.y, f = r.y, p = Math.min(a, l, d), y = Math.min(c, h, f), v = Math.max(a, l, d), x = Math.max(c, h, f), w = i0(p, y, e, t, i), S = i0(v, x, e, t, i);
  let M = n.prevZ;
  for (; M && M.z >= w; ) {
    if (M.x >= p && M.x <= v && M.y >= y && M.y <= x && M !== r && !(a === M.x && c === M.y) && bf(a, c, l, h, d, f, M.x, M.y) && kn(M.prev, M, M.next) >= 0) return !1;
    M = M.prevZ;
  }
  let _ = n.nextZ;
  for (; _ && _.z <= S; ) {
    if (_.x >= p && _.x <= v && _.y >= y && _.y <= x && _ !== r && !(a === _.x && c === _.y) && bf(a, c, l, h, d, f, _.x, _.y) && kn(_.prev, _, _.next) >= 0) return !1;
    _ = _.nextZ;
  }
  return !0;
}
function iX(n, e) {
  let t = n, i = !1;
  do {
    const s = t.prev, o = t.next.next;
    rM(s, t, t.next, o, !1) && Kc(s, o) && Kc(o, s) && (e.push(s.i, t.i, o.i), Yc(t), Yc(t.next), t = n = o, i = !0), t = t.next;
  } while (t !== n);
  return i ? ha(t) : t;
}
function sX(n, e, t, i, s) {
  let o = n;
  do {
    let r = o.next.next;
    for (; r !== o.prev; ) {
      if (o.i !== r.i && mX(o, r)) {
        let a = aM(o, r);
        o = ha(o, o.next), a = ha(a, a.next), Qv(o, e, t, i, s), Qv(a, e, t, i, s);
        return;
      }
      r = r.next;
    }
    o = o.next;
  } while (o !== n);
}
let e0 = !1;
function oX(n, e, t, i) {
  const s = [];
  for (let o = 0, r = e.length; o < r; o++) {
    const a = e[o] * i, l = o < r - 1 ? e[o + 1] * i : n.length, d = (
      /** @type {Node} */
      iM(n, a, l, i, !1)
    );
    d === d.next && Wc.add(d), s.push(fX(d));
  }
  s.sort(rX), lX(n.length / i, e.length), oM(t, t), e0 = !0;
  for (let o = 0; o < s.length; o++)
    t = aX(s[o], t);
  return e0 = !1, ha(t);
}
function rX(n, e) {
  return n.x - e.x || n.y - e.y || (n.next.y - n.y) / (n.next.x - n.x) - (e.next.y - e.y) / (e.next.x - e.x);
}
function aX(n, e) {
  const t = cX(n, e);
  if (!t)
    return e;
  const i = aM(t, n), s = i.next;
  return oM(t, s.next), ha(i, i.next), ha(t, t.next);
}
const sM = 16;
let cn = new Float64Array(0), gf = 0;
const t0 = [], n0 = [];
function lX(n, e) {
  const t = Math.ceil((n + 2 * e) / sM) + e + 2;
  cn.length < t * 4 && (cn = new Float64Array(t * 4)), gf = 0;
}
function oM(n, e) {
  let t = n;
  do {
    const i = gf++;
    t0[i] = t;
    let s = t.x, o = t.y, r = t.x, a = t.y, l = 0;
    do {
      const c = t.next;
      t.z = i, c.x < s && (s = c.x), c.x > r && (r = c.x), c.y < o && (o = c.y), c.y > a && (a = c.y), t = c;
    } while (++l < sM && t !== e);
    n0[i] = t;
    const d = i * 4;
    cn[d] = s, cn[d + 1] = o, cn[d + 2] = r, cn[d + 3] = a;
  } while (t !== e);
}
function dX(n, e) {
  const t = n.z * 4;
  e.x < cn[t] && (cn[t] = e.x), e.y < cn[t + 1] && (cn[t + 1] = e.y), e.x > cn[t + 2] && (cn[t + 2] = e.x), e.y > cn[t + 3] && (cn[t + 3] = e.y);
}
function Qk(n) {
  let e = n0[n];
  for (; e.prev.next !== e; ) e = e.next;
  return n0[n] = e, e;
}
function e2(n) {
  let e = t0[n];
  for (; e.prev.next !== e; ) e = e.next;
  return t0[n] = e, e;
}
function cX(n, e) {
  let t = e;
  const i = n.x, s = n.y;
  let o = -1 / 0, r;
  if (qc(n, t)) return t;
  for (let f = 0, p = 0; f < gf; f++, p += 4) {
    if (s < cn[p + 1] || s > cn[p + 3] || cn[p] > i || cn[p + 2] <= o) continue;
    const y = Qk(f);
    t = e2(f);
    do {
      if (t.prev.next === t) {
        if (qc(n, t.next)) return t.next;
        if (s <= t.y && s >= t.next.y && t.next.y !== t.y) {
          const v = t.x + (s - t.y) * (t.next.x - t.x) / (t.next.y - t.y);
          if (v <= i && v > o && (o = v, r = t.x < t.next.x ? t : t.next, v === i))
            return r;
        }
      }
      t = t.next;
    } while (t !== y);
  }
  if (!r) return null;
  const a = r.x, l = r.y, d = Math.min(s, l), c = Math.max(s, l);
  let h = 1 / 0;
  for (let f = 0, p = 0; f < gf; f++, p += 4) {
    if (cn[p + 2] < a || cn[p] > i || cn[p + 3] < d || cn[p + 1] > c) continue;
    const y = Qk(f);
    t = e2(f);
    do {
      if (t.prev.next === t && i >= t.x && t.x >= a && i !== t.x && // skip dead nodes
      bf(s < l ? i : o, s, a, l, s < l ? o : i, s, t.x, t.y)) {
        const v = Math.abs(s - t.y) / (i - t.x);
        (Kc(t, n) || t.y === s && t.next.y === s && t.next.x > i) && (v < h || v === h && (t.x > r.x || t.x === r.x && uX(r, t))) && (r = t, h = v);
      }
      t = t.next;
    } while (t !== y);
  }
  return r;
}
function uX(n, e) {
  return kn(n.prev, n, e.prev) < 0 && kn(e.next, n, n.next) < 0;
}
const Mi = [];
let el = [], vr = new Uint32Array(0), gd = new Uint32Array(0);
const bd = new Uint32Array(256);
function hX(n, e, t, i) {
  let s = n, o = 0;
  do
    s.z = i0(s.x, s.y, e, t, i), Mi[o++] = s, s = s.next;
  while (s !== n);
  pX(o);
  let r = null;
  for (let a = 0; a < o; a++) {
    const l = Mi[a];
    l.prevZ = r, r && (r.nextZ = l), r = l;
  }
  r.nextZ = null, Mi.fill(
    /** @type {Node} */
    /** @type {unknown} */
    null,
    0,
    o
  ), el.fill(
    /** @type {Node} */
    /** @type {unknown} */
    null,
    0,
    o
  );
}
function pX(n) {
  if (n <= 32) {
    for (let e = 1; e < n; e++) {
      const t = Mi[e], i = t.z;
      let s = e - 1;
      for (; s >= 0 && Mi[s].z > i; )
        Mi[s + 1] = Mi[s], s--;
      Mi[s + 1] = t;
    }
    return;
  }
  vr.length < n && (vr = new Uint32Array(n), gd = new Uint32Array(n), el = new Array(n));
  for (let e = 0; e < n; e++) vr[e] = Mi[e].z;
  dh(n, Mi, vr, el, gd, 0), dh(n, el, gd, Mi, vr, 8), dh(n, Mi, vr, el, gd, 16), dh(n, el, gd, Mi, vr, 24);
}
function dh(n, e, t, i, s, o) {
  bd.fill(0);
  for (let a = 0; a < n; a++) bd[t[a] >>> o & 255]++;
  let r = 0;
  for (let a = 0; a < 256; a++) {
    const l = bd[a];
    bd[a] = r, r += l;
  }
  for (let a = 0; a < n; a++) {
    const l = t[a], d = bd[l >>> o & 255]++;
    i[d] = e[a], s[d] = l;
  }
}
function i0(n, e, t, i, s) {
  return n = (n - t) * s | 0, e = (e - i) * s | 0, n = (n | n << 8) & 16711935, n = (n | n << 4) & 252645135, n = (n | n << 2) & 858993459, n = (n | n << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, n | e << 1;
}
function fX(n) {
  let e = n, t = n;
  do
    (e.x < t.x || e.x === t.x && e.y < t.y) && (t = e), e = e.next;
  while (e !== n);
  return t;
}
function bf(n, e, t, i, s, o, r, a) {
  return (s - r) * (e - a) >= (n - r) * (o - a) && (n - r) * (i - a) >= (t - r) * (e - a) && (t - r) * (o - a) >= (s - r) * (i - a);
}
function mX(n, e) {
  const t = qc(n, e) && kn(n.prev, n, n.next) > 0 && kn(e.prev, e, e.next) > 0;
  return n.next.i !== e.i && (t || Kc(n, e) && Kc(e, n) && // // locally visible
  (kn(n.prev, n, e.prev) !== 0 || kn(n, e.prev, e) !== 0)) && // no opposite-facing sectors
  !gX(n, e) && (t || bX(n, e));
}
function kn(n, e, t) {
  return (e.y - n.y) * (t.x - e.x) - (e.x - n.x) * (t.y - e.y);
}
function qc(n, e) {
  return n.x === e.x && n.y === e.y;
}
function rM(n, e, t, i, s = !0) {
  const o = kn(n, e, t), r = kn(n, e, i), a = kn(t, i, n), l = kn(t, i, e);
  return (o > 0 && r < 0 || o < 0 && r > 0) && (a > 0 && l < 0 || a < 0 && l > 0) ? !0 : s ? !!(o === 0 && ch(n, t, e) || r === 0 && ch(n, i, e) || a === 0 && ch(t, n, i) || l === 0 && ch(t, e, i)) : !1;
}
function ch(n, e, t) {
  return e.x <= Math.max(n.x, t.x) && e.x >= Math.min(n.x, t.x) && e.y <= Math.max(n.y, t.y) && e.y >= Math.min(n.y, t.y);
}
function gX(n, e) {
  const t = Math.min(n.x, e.x), i = Math.max(n.x, e.x), s = Math.min(n.y, e.y), o = Math.max(n.y, e.y);
  let r = n;
  do {
    const a = r.next;
    if (r.x > i && a.x > i || r.x < t && a.x < t || r.y > o && a.y > o || r.y < s && a.y < s) {
      r = a;
      continue;
    }
    if (r.i !== n.i && a.i !== n.i && r.i !== e.i && a.i !== e.i && rM(r, a, n, e)) return !0;
    r = a;
  } while (r !== n);
  return !1;
}
function Kc(n, e) {
  return kn(n.prev, n, n.next) < 0 ? kn(n, e, n.next) >= 0 && kn(n, n.prev, e) >= 0 : kn(n, e, n.prev) < 0 || kn(n, n.next, e) < 0;
}
function bX(n, e) {
  let t = n, i = !1;
  const s = (n.x + e.x) / 2, o = (n.y + e.y) / 2;
  do {
    const r = t.next;
    t.y > o != r.y > o && s < (r.x - t.x) * (o - t.y) / (r.y - t.y) + t.x && (i = !i), t = r;
  } while (t !== n);
  return i;
}
function aM(n, e) {
  const t = s0(n.i, n.x, n.y), i = s0(e.i, e.x, e.y), s = n.next, o = e.prev;
  return n.next = e, e.prev = n, t.next = s, s.prev = t, i.next = t, t.prev = i, o.next = i, i.prev = o, i;
}
function t2(n, e, t, i) {
  const s = s0(n, e, t);
  return i ? (s.next = i.next, s.prev = i, i.next.prev = s, i.next = s) : (s.prev = s, s.next = s), s;
}
function Yc(n) {
  n.next.prev = n.prev, n.prev.next = n.next, n.prevZ && (n.prevZ.nextZ = n.nextZ), n.nextZ && (n.nextZ.prevZ = n.prevZ), e0 && dX(n.prev, n.next);
}
function s0(n, e, t) {
  return (
    /** @type {Node} */
    /** @type {unknown} */
    {
      i: n,
      // vertex index in coordinates array
      x: e,
      y: t,
      // vertex coordinates
      prev: null,
      // previous and next vertex nodes in a polygon ring
      next: null,
      z: 0,
      // z-order curve value; doubles as owning block in the hole-bridge index during eliminateHoles
      prevZ: null,
      // previous and next nodes in z-order
      nextZ: null
    }
  );
}
function vX(n, e, t, i) {
  let s = 0;
  for (let o = e, r = t - i; o < t; o += i)
    s += (n[r] - n[o]) * (n[o + 1] + n[r + 1]), r = o;
  return s;
}
const yX = Zk.default || Zk;
var Tn = /* @__PURE__ */ ((n) => (n[n.NONE = 0] = "NONE", n[n.COLOR = 16384] = "COLOR", n[n.STENCIL = 1024] = "STENCIL", n[n.DEPTH = 256] = "DEPTH", n[n.COLOR_DEPTH = 16640] = "COLOR_DEPTH", n[n.COLOR_STENCIL = 17408] = "COLOR_STENCIL", n[n.DEPTH_STENCIL = 1280] = "DEPTH_STENCIL", n[n.ALL = 17664] = "ALL", n))(Tn || {});
class lM {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(e) {
    this.items = [], this._name = e;
  }
  /* jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /* jsdoc/check-param-names */
  emit(e, t, i, s, o, r, a, l) {
    const { name: d, items: c } = this;
    for (let h = 0, f = c.length; h < f; h++)
      c[h][d](e, t, i, s, o, r, a, l);
    return this;
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(e) {
    return e[this._name] && (this.remove(e), this.items.push(e)), this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(e) {
    const t = this.items.indexOf(e);
    return t !== -1 && this.items.splice(t, 1), this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(e) {
    return this.items.indexOf(e) !== -1;
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    return this.items.length = 0, this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll(), this.items = null, this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
const xX = [
  "init",
  "destroy",
  "contextChange",
  "resolutionChange",
  "resetState",
  "renderEnd",
  "renderStart",
  "render",
  "update",
  "postrender",
  "prerender"
], dM = class cM extends bi {
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  constructor(e) {
    var i;
    super(), this.tick = 0, this.uid = Nt("renderer"), this.runners = /* @__PURE__ */ Object.create(null), this.renderPipes = /* @__PURE__ */ Object.create(null), this._initOptions = {}, this._systemsHash = /* @__PURE__ */ Object.create(null), this.type = e.type, this.name = e.name, this.config = e;
    const t = [...xX, ...(i = this.config.runners) != null ? i : []];
    this._addRunners(...t), this._unsafeEvalCheck();
  }
  /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */
  async init(e = {}) {
    const t = e.skipExtensionImports === !0 ? !0 : e.manageImports === !1;
    await eX(t), !t && this.config.loaders && await Promise.all(this.config.loaders.map((i) => i.value.load())), this._addSystems(this.config.systems), this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
    for (const i in this._systemsHash)
      e = { ...this._systemsHash[i].constructor.defaultOptions, ...e };
    e = { ...cM.defaultOptions, ...e }, this._roundPixels = e.roundPixels ? 1 : 0;
    for (let i = 0; i < this.runners.init.items.length; i++)
      await this.runners.init.items[i].init(e);
    this._initOptions = e;
  }
  render(e, t) {
    var s, o;
    this.tick++;
    let i = e;
    if (i instanceof mn && (i = { container: i }, t && (rt(dn, "passing a second argument is deprecated, please use render options instead"), i.target = t.renderTexture)), i.target || (i.target = this.view.renderTarget), i.target === this.view.renderTarget && (this._lastObjectRendered = i.container, (s = i.clearColor) != null || (i.clearColor = this.background.colorRgba), (o = i.clear) != null || (i.clear = this.background.clearBeforeRender)), i.clearColor) {
      const r = Array.isArray(i.clearColor) && i.clearColor.length === 4;
      i.clearColor = r ? i.clearColor : vn.shared.setValue(i.clearColor).toArray();
    }
    i.transform || (i.container.updateLocalTransform(), i.transform = i.container.localTransform), i.container.visible && (i.container.enableRenderGroup(), this.runners.prerender.emit(i), this.runners.renderStart.emit(i), this.runners.render.emit(i), this.runners.renderEnd.emit(i), this.runners.postrender.emit(i));
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */
  resize(e, t, i) {
    const s = this.view.resolution;
    this.view.resize(e, t, i), this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution), i !== void 0 && i !== s && this.runners.resolutionChange.emit(i);
  }
  /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */
  clear(e = {}) {
    var l;
    const t = this;
    e.target || (e.target = t.renderTarget.renderTarget), e.clearColor || (e.clearColor = this.background.colorRgba), (l = e.clear) != null || (e.clear = Tn.ALL);
    const { clear: i, clearColor: s, target: o, mipLevel: r, layer: a } = e;
    vn.shared.setValue(s != null ? s : this.background.colorRgba), t.renderTarget.clear(o, i, vn.shared.toArray(), r != null ? r : 0, a != null ? a : 0);
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.view.resolution;
  }
  set resolution(e) {
    this.view.resolution = e, this.runners.resolutionChange.emit(e);
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this.view.texture.frame.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this.view.texture.frame.height;
  }
  // NOTE: this was `view` in v7
  /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */
  get canvas() {
    return this.view.canvas;
  }
  /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */
  get lastObjectRendered() {
    return this._lastObjectRendered;
  }
  /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */
  get renderingToScreen() {
    return this.renderTarget.renderingToScreen;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */
  get screen() {
    return this.view.screen;
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  _addRunners(...e) {
    e.forEach((t) => {
      this.runners[t] = new lM(t);
    });
  }
  _addSystems(e) {
    let t;
    for (t in e) {
      const i = e[t];
      this._addSystem(i.value, i.name);
    }
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  _addSystem(e, t) {
    const i = new e(this);
    if (this[t])
      throw new Error(`Whoops! The name "${t}" is already in use`);
    this[t] = i, this._systemsHash[t] = i;
    for (const s in this.runners)
      this.runners[s].add(i);
    return this;
  }
  _addPipes(e, t) {
    const i = t.reduce((s, o) => (s[o.name] = o.value, s), {});
    e.forEach((s) => {
      const o = s.value, r = s.name, a = i[r];
      this.renderPipes[r] = new o(
        this,
        a ? new a() : null
      ), this.runners.destroy.add(this.renderPipes[r]);
    });
  }
  destroy(e = !1) {
    this.runners.destroy.items.reverse(), this.runners.destroy.emit(e), (e === !0 || typeof e == "object" && e.releaseGlobalResources) && Yl.release(), Object.values(this.runners).forEach((t) => {
      t.destroy();
    }), this._systemsHash = null, this.renderPipes = null, this.removeAllListeners();
  }
  /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */
  generateTexture(e) {
    return this.textureGenerator.generateTexture(e);
  }
  /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */
  _unsafeEvalCheck() {
    if (!nM())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */
  resetState() {
    this.runners.resetState.emit();
  }
};
dM.defaultOptions = {
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */
  resolution: 1,
  /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */
  failIfMajorPerformanceCaveat: !1,
  /**
   * Should round pixels be forced when rendering?
   * @default false
   */
  roundPixels: !1
};
let ku = dM, uh;
function wX(n) {
  return uh !== void 0 || (uh = (() => {
    var t;
    const e = {
      stencil: !0,
      failIfMajorPerformanceCaveat: n != null ? n : ku.defaultOptions.failIfMajorPerformanceCaveat
    };
    try {
      if (!zt.get().getWebGLRenderingContext())
        return !1;
      let s = zt.get().createCanvas().getContext("webgl", e);
      const o = !!((t = s == null ? void 0 : s.getContextAttributes()) != null && t.stencil);
      if (s) {
        const r = s.getExtension("WEBGL_lose_context");
        r && r.loseContext();
      }
      return s = null, o;
    } catch {
      return !1;
    }
  })()), uh;
}
let hh;
async function kX(n = {}) {
  return hh !== void 0 || (hh = await (async () => {
    const e = zt.get().getNavigator().gpu;
    if (!e)
      return !1;
    try {
      return await (await e.requestAdapter(n)).requestDevice(), !0;
    } catch {
      return !1;
    }
  })()), hh;
}
const n2 = ["webgl", "webgpu", "canvas"];
async function _X(n) {
  var o;
  let e = [];
  n.preference ? Array.isArray(n.preference) ? e = n.preference.slice() : (e.push(n.preference), n2.forEach((r) => {
    r !== n.preference && e.push(r);
  })) : e = n2.slice();
  let t, i = {};
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    if (a === "webgpu" && await kX()) {
      const { WebGPURenderer: l } = await Promise.resolve().then(() => nte);
      t = l, i = { ...n, ...n.webgpu };
      break;
    } else if (a === "webgl" && wX(
      (o = n.failIfMajorPerformanceCaveat) != null ? o : ku.defaultOptions.failIfMajorPerformanceCaveat
    )) {
      const { WebGLRenderer: l } = await Promise.resolve().then(() => _ee);
      t = l, i = { ...n, ...n.webgl };
      break;
    } else if (a === "canvas") {
      const { CanvasRenderer: l } = await Promise.resolve().then(() => kQ);
      t = l, i = { ...n, ...n.canvasOptions };
      break;
    }
  }
  if (delete i.webgpu, delete i.webgl, delete i.canvasOptions, !t)
    throw new Error("No available renderer for the current environment");
  const s = new t();
  return await s.init(i), s;
}
const vf = "8.22.0";
class uM {
  static init() {
    var e;
    (e = globalThis.__PIXI_APP_INIT__) == null || e.call(globalThis, this, vf);
  }
  static destroy() {
  }
}
uM.extension = Ae.Application;
class hM {
  constructor(e) {
    this._renderer = e;
  }
  init() {
    var e;
    (e = globalThis.__PIXI_RENDERER_INIT__) == null || e.call(globalThis, this._renderer, vf);
  }
  destroy() {
    this._renderer = null;
  }
}
hM.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "initHook",
  priority: -10
};
class pM {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    Object.defineProperty(
      this,
      "resizeTo",
      {
        configurable: !0,
        set(t) {
          globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = t, t && (globalThis.addEventListener("resize", this.queueResize), this.resize());
        },
        get() {
          return this._resizeTo;
        }
      }
    ), this.queueResize = () => {
      this._resizeTo && (this._cancelResize(), this._resizeId = requestAnimationFrame(() => this.resize()));
    }, this._cancelResize = () => {
      this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
    }, this.resize = () => {
      if (!this._resizeTo)
        return;
      this._cancelResize();
      let t, i;
      if (this._resizeTo === globalThis.window)
        t = globalThis.innerWidth, i = globalThis.innerHeight;
      else {
        const { clientWidth: s, clientHeight: o } = this._resizeTo;
        t = s, i = o;
      }
      this.renderer.resize(t, i), this.render();
    }, this._resizeId = null, this._resizeTo = null, this.resizeTo = e.resizeTo || null;
  }
  /**
   * Clean up the ticker, scoped to application
   * @private
   */
  static destroy() {
    globalThis.removeEventListener("resize", this.queueResize), this._cancelResize(), this._cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
  }
}
pM.extension = Ae.Application;
class fM {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    e = Object.assign({
      autoStart: !0,
      sharedTicker: !1
    }, e), Object.defineProperty(
      this,
      "ticker",
      {
        configurable: !0,
        set(t) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = t, t && t.add(this.render, this, Ol.LOW);
        },
        get() {
          return this._ticker;
        }
      }
    ), this.stop = () => {
      this._ticker.stop();
    }, this.start = () => {
      this._ticker.start();
    }, this._ticker = null, this.ticker = e.sharedTicker ? Oi.shared : new Oi(), e.autoStart && this.start();
  }
  /**
   * Clean up the ticker, scoped to application.
   * @private
   */
  static destroy() {
    if (this._ticker) {
      const e = this._ticker;
      this.ticker = null, e.destroy();
    }
  }
}
fM.extension = Ae.Application;
ht.add(pM);
ht.add(fM);
const mM = class o0 {
  constructor(...e) {
    this.stage = new mn(), e[0] !== void 0 && rt(dn, "Application constructor options are deprecated, please use Application.init() instead.");
  }
  /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */
  async init(e) {
    e = { ...e }, this.stage || (this.stage = new mn()), this.renderer = await _X(e), o0._plugins.forEach((t) => {
      t.init.call(this, e);
    });
  }
  /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */
  render() {
    this.renderer.render({ container: this.stage });
  }
  /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */
  get canvas() {
    return this.renderer.canvas;
  }
  /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */
  get view() {
    return rt(dn, "Application.view is deprecated, please use Application.canvas instead."), this.renderer.canvas;
  }
  /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */
  get screen() {
    return this.renderer.screen;
  }
  /**
   * Get the html div element that holds all DOM Container elements.
   * @readonly
   * @type {HTMLDivElement}
   */
  get domContainerRoot() {
    var e;
    return (e = this.renderer.renderPipes.dom) == null ? void 0 : e._domElement;
  }
  /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */
  destroy(e = !1, t = !1) {
    const i = o0._plugins.slice(0);
    i.reverse(), i.forEach((s) => {
      s.destroy.call(this);
    }), this.stage.destroy(t), this.stage = null, this.renderer.destroy(e), this.renderer = null;
  }
};
mM._plugins = [];
let gM = mM;
ht.handleByList(Ae.Application, gM._plugins);
ht.add(uM);
const Ug = {
  a: 7,
  c: 6,
  h: 1,
  l: 2,
  m: 2,
  q: 4,
  s: 4,
  t: 2,
  v: 1,
  z: 0
}, SX = /([astvzqmhlc])([^astvzqmhlc]*)/gi, MX = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
function TX(n) {
  const e = [];
  return n.replace(SX, (t, i, s) => {
    let o = i.toLowerCase(), r = i;
    const a = CX(s);
    for (o === "m" && a.length > 2 && (e.push([r, ...a.splice(0, 2)]), o = "l", r = r === "m" ? "l" : "L"); ; ) {
      if (a.length === Ug[o])
        return e.push([r, ...a]), "";
      if (a.length < Ug[o]) throw new Error("malformed path data");
      e.push([r, ...a.splice(0, Ug[o])]);
    }
  }), e;
}
function CX(n) {
  const e = n.match(MX);
  return e ? e.map(Number) : [];
}
function IX(n, e) {
  const t = TX(n), i = [];
  let s = null, o = 0, r = 0;
  for (let a = 0; a < t.length; a++) {
    const l = t[a], d = l[0], c = l;
    switch (d) {
      case "M":
        o = c[1], r = c[2], e.moveTo(o, r);
        break;
      case "m":
        o += c[1], r += c[2], e.moveTo(o, r);
        break;
      case "H":
        o = c[1], e.lineTo(o, r);
        break;
      case "h":
        o += c[1], e.lineTo(o, r);
        break;
      case "V":
        r = c[1], e.lineTo(o, r);
        break;
      case "v":
        r += c[1], e.lineTo(o, r);
        break;
      case "L":
        o = c[1], r = c[2], e.lineTo(o, r);
        break;
      case "l":
        o += c[1], r += c[2], e.lineTo(o, r);
        break;
      case "C":
        o = c[5], r = c[6], e.bezierCurveTo(
          c[1],
          c[2],
          // First control point
          c[3],
          c[4],
          // Second control point
          o,
          r
          // End point
        );
        break;
      case "c":
        e.bezierCurveTo(
          o + c[1],
          r + c[2],
          // First control point
          o + c[3],
          r + c[4],
          // Second control point
          o + c[5],
          r + c[6]
          // End point
        ), o += c[5], r += c[6];
        break;
      case "S":
        o = c[3], r = c[4], e.bezierCurveToShort(
          c[1],
          c[2],
          // Control point
          o,
          r
          // End point
        );
        break;
      case "s":
        e.bezierCurveToShort(
          o + c[1],
          r + c[2],
          // Control point
          o + c[3],
          r + c[4]
          // End point
        ), o += c[3], r += c[4];
        break;
      case "Q":
        o = c[3], r = c[4], e.quadraticCurveTo(
          c[1],
          c[2],
          // Control point
          o,
          r
          // End point
        );
        break;
      case "q":
        e.quadraticCurveTo(
          o + c[1],
          r + c[2],
          // Control point
          o + c[3],
          r + c[4]
          // End point
        ), o += c[3], r += c[4];
        break;
      case "T":
        o = c[1], r = c[2], e.quadraticCurveToShort(
          o,
          r
          // End point
        );
        break;
      case "t":
        o += c[1], r += c[2], e.quadraticCurveToShort(
          o,
          r
          // End point
        );
        break;
      case "A":
        o = c[6], r = c[7], e.arcToSvg(
          c[1],
          // rx
          c[2],
          // ry
          c[3],
          // x-axis-rotation
          c[4],
          // large-arc-flag
          c[5],
          // sweep-flag
          o,
          r
          // End point
        );
        break;
      case "a":
        o += c[6], r += c[7], e.arcToSvg(
          c[1],
          // rx
          c[2],
          // ry
          c[3],
          // x-axis-rotation
          c[4],
          // large-arc-flag
          c[5],
          // sweep-flag
          o,
          r
          // End point
        );
        break;
      case "Z":
      // Close Path
      case "z":
        e.closePath(), i.length > 0 && (s = i.pop(), s ? (o = s.startX, r = s.startY) : (o = 0, r = 0)), s = null;
        break;
      default:
        dt(`Unknown SVG path command: ${d}`);
    }
    d !== "Z" && d !== "z" && s === null && (s = { startX: o, startY: r }, i.push(s));
  }
  return e;
}
class iy {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(e = 0, t = 0, i = 0) {
    this.type = "circle", this.x = e, this.y = t, this.radius = i;
  }
  /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */
  clone() {
    return new iy(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */
  contains(e, t) {
    if (this.radius <= 0) return !1;
    const i = this.radius * this.radius;
    let s = this.x - e, o = this.y - t;
    return s *= s, o *= o, s + o <= i;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    if (this.radius === 0) return !1;
    const o = this.x - e, r = this.y - t, a = this.radius, l = (1 - s) * i, d = Math.sqrt(o * o + r * r);
    return d <= a + l && d > a - (i - l);
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */
  getBounds(e) {
    return e || (e = new Tt()), e.x = this.x - this.radius, e.y = this.y - this.radius, e.width = this.radius * 2, e.height = this.radius * 2, e;
  }
  /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.radius = e.radius, this;
  }
  /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
  }
}
class sy {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(e = 0, t = 0, i = 0, s = 0) {
    this.type = "ellipse", this.x = e, this.y = t, this.halfWidth = i, this.halfHeight = s;
  }
  /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */
  clone() {
    return new sy(this.x, this.y, this.halfWidth, this.halfHeight);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */
  contains(e, t) {
    if (this.halfWidth <= 0 || this.halfHeight <= 0)
      return !1;
    let i = (e - this.x) / this.halfWidth, s = (t - this.y) / this.halfHeight;
    return i *= i, s *= s, i + s <= 1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * - A stroke wider than the shape covers it entirely, leaving no unstroked interior
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { halfWidth: o, halfHeight: r } = this;
    if (o <= 0 || r <= 0)
      return !1;
    const a = i * (1 - s), l = i - a, d = o - l, c = r - l, h = o + a, f = r + a, p = e - this.x, y = t - this.y;
    return p * p / (h * h) + y * y / (f * f) > 1 ? !1 : d <= 0 || c <= 0 ? !0 : p * p / (d * d) + y * y / (c * c) > 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */
  getBounds(e) {
    return e || (e = new Tt()), e.x = this.x - this.halfWidth, e.y = this.y - this.halfHeight, e.width = this.halfWidth * 2, e.height = this.halfHeight * 2, e;
  }
  /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.halfWidth = e.halfWidth, this.halfHeight = e.halfHeight, this;
  }
  /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
  }
}
function bM(n) {
  const e = n.length;
  if (e < 6)
    return 1;
  let t = 0;
  for (let i = 0, s = n[e - 2], o = n[e - 1]; i < e; i += 2) {
    const r = n[i], a = n[i + 1];
    t += (r - s) * (a + o), s = r, o = a;
  }
  return t < 0 ? -1 : 1;
}
function AX(n, e, t, i, s, o) {
  const r = n - t, a = e - i, l = s - t, d = o - i, c = r * l + a * d, h = l * l + d * d;
  let f = -1;
  h !== 0 && (f = c / h);
  let p, y;
  f < 0 ? (p = t, y = i) : f > 1 ? (p = s, y = o) : (p = t + f * l, y = i + f * d);
  const v = n - p, x = e - y;
  return v * v + x * x;
}
let PX, EX;
class vc {
  /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...e) {
    this.type = "polygon";
    let t = Array.isArray(e[0]) ? e[0] : e;
    if (typeof t[0] != "number") {
      const i = [];
      for (let s = 0, o = t.length; s < o; s++)
        i.push(t[s].x, t[s].y);
      t = i;
    }
    this.points = t, this.closePath = !0;
  }
  /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */
  isClockwise() {
    let e = 0;
    const t = this.points, i = t.length;
    for (let s = 0; s < i; s += 2) {
      const o = t[s], r = t[s + 1], a = t[(s + 2) % i], l = t[(s + 3) % i];
      e += (a - o) * (l + r);
    }
    return e < 0;
  }
  /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */
  containsPolygon(e) {
    const t = this.getBounds(PX), i = e.getBounds(EX);
    if (!t.containsRect(i))
      return !1;
    const s = e.points;
    for (let o = 0; o < s.length; o += 2) {
      const r = s[o], a = s[o + 1];
      if (!this.contains(r, a))
        return !1;
    }
    return !0;
  }
  /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */
  clone() {
    const e = this.points.slice(), t = new vc(e);
    return t.closePath = this.closePath, t;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */
  contains(e, t) {
    let i = !1;
    const s = this.points.length / 2;
    for (let o = 0, r = s - 1; o < s; r = o++) {
      const a = this.points[o * 2], l = this.points[o * 2 + 1], d = this.points[r * 2], c = this.points[r * 2 + 1];
      l > t != c > t && e < (d - a) * ((t - l) / (c - l)) + a && (i = !i);
    }
    return i;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { points: o } = this, r = s === 0.5 ? s : (s - 0.5) * bM(o) + 0.5, a = i * r, l = i - a, d = a * a, c = l * l, h = o.length - (this.closePath ? 0 : 2);
    for (let f = 0; f < h; f += 2) {
      const p = o[f], y = o[f + 1], v = o[(f + 2) % o.length], x = o[(f + 3) % o.length], w = AX(e, t, p, y, v, x), S = Math.sign((v - p) * (t - y) - (x - y) * (e - p));
      if (w <= (S < 0 ? d : c))
        return !0;
    }
    return !1;
  }
  /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */
  getBounds(e) {
    e || (e = new Tt());
    const t = this.points;
    let i = 1 / 0, s = -1 / 0, o = 1 / 0, r = -1 / 0;
    for (let a = 0, l = t.length; a < l; a += 2) {
      const d = t[a], c = t[a + 1];
      i = d < i ? d : i, s = d > s ? d : s, o = c < o ? c : o, r = c > r ? c : r;
    }
    return e.x = i, e.width = s - i, e.y = o, e.height = r - o, e;
  }
  /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyFrom(e) {
    return this.points = e.points.slice(), this.closePath = e.closePath, this;
  }
  /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((e, t) => `${e}, ${t}`, "")}]`;
  }
  /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastX() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastY() {
    return this.points[this.points.length - 1];
  }
  /**
   * Get the last X coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastX} instead.
   */
  get x() {
    return rt("8.11.0", "Polygon.lastX is deprecated, please use Polygon.lastX instead."), this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastY} instead.
   */
  get y() {
    return rt("8.11.0", "Polygon.y is deprecated, please use Polygon.lastY instead."), this.points[this.points.length - 1];
  }
  /**
   * Get the first X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.x); // 0
   * ```
   * @readonly
   * @returns The x-coordinate of the first vertex
   * @see {@link Polygon.startY} For first Y coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get startX() {
    return this.points[0];
  }
  /**
   * Get the first Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.y); // 0
   * ```
   * @readonly
   * @returns The y-coordinate of the first vertex
   * @see {@link Polygon.startX} For first X coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get startY() {
    return this.points[1];
  }
}
const ph = (n, e, t, i, s, o, r) => {
  const a = n - t, l = e - i, d = Math.sqrt(a * a + l * l);
  return d >= s - o && d <= s + r;
};
class oy {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(e = 0, t = 0, i = 0, s = 0, o = 20) {
    this.type = "roundedRectangle", this.x = e, this.y = t, this.width = i, this.height = s, this.radius = o;
  }
  /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */
  getBounds(e) {
    return e || (e = new Tt()), e.x = this.x, e.y = this.y, e.width = this.width, e.height = this.height, e;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new oy(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this.radius = e.radius, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */
  contains(e, t) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    if (e >= this.x && e <= this.x + this.width && t >= this.y && t <= this.y + this.height) {
      const i = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
      if (t >= this.y + i && t <= this.y + this.height - i || e >= this.x + i && e <= this.x + this.width - i)
        return !0;
      let s = e - (this.x + i), o = t - (this.y + i);
      const r = i * i;
      if (s * s + o * o <= r || (s = e - (this.x + this.width - i), s * s + o * o <= r) || (o = t - (this.y + this.height - i), s * s + o * o <= r) || (s = e - (this.x + i), s * s + o * o <= r))
        return !0;
    }
    return !1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, i, s = 0.5) {
    const { x: o, y: r, width: a, height: l, radius: d } = this, c = i * (1 - s), h = i - c, f = o + d, p = r + d, y = a - d * 2, v = l - d * 2, x = o + a, w = r + l;
    return (e >= o - c && e <= o + h || e >= x - h && e <= x + c) && t >= p && t <= p + v || (t >= r - c && t <= r + h || t >= w - h && t <= w + c) && e >= f && e <= f + y ? !0 : (
      // Top-left
      e < f && t < p && ph(
        e,
        t,
        f,
        p,
        d,
        h,
        c
      ) || e > x - d && t < p && ph(
        e,
        t,
        x - d,
        p,
        d,
        h,
        c
      ) || e > x - d && t > w - d && ph(
        e,
        t,
        x - d,
        w - d,
        d,
        h,
        c
      ) || e < f && t > w - d && ph(
        e,
        t,
        f,
        w - d,
        d,
        h,
        c
      )
    );
  }
  toString() {
    return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
  }
}
const vM = {};
function ry(n, e, t) {
  let i = 2166136261;
  for (let s = 0; s < e; s++)
    i ^= n[s].uid, i = Math.imul(i, 16777619), i >>>= 0;
  return vM[i] || RX(n, e, i, t);
}
function RX(n, e, t, i) {
  const s = {};
  let o = 0;
  for (let a = 0; a < i; a++) {
    const l = a < e ? n[a] : et.EMPTY.source;
    s[o++] = l.source, s[o++] = l.style;
  }
  const r = new qo(s);
  return vM[t] = r, r;
}
class i2 {
  constructor(e) {
    typeof e == "number" ? this.rawBinaryData = new ArrayBuffer(e) : e instanceof Uint8Array ? this.rawBinaryData = e.buffer : this.rawBinaryData = e, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData), this.size = this.rawBinaryData.byteLength;
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
  }
  /** View on the raw binary data as a `Float64Array`. */
  get float64View() {
    return this._float64Array || (this._float64Array = new Float64Array(this.rawBinaryData)), this._float64Array;
  }
  /** View on the raw binary data as a `BigUint64Array`. */
  get bigUint64View() {
    return this._bigUint64Array || (this._bigUint64Array = new BigUint64Array(this.rawBinaryData)), this._bigUint64Array;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(e) {
    return this[`${e}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null, this.uint32View = null, this.float32View = null, this.uint16View = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._int32View = null, this._float64Array = null, this._bigUint64Array = null;
  }
  /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */
  static sizeOf(e) {
    switch (e) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${e} isn't a valid view type`);
    }
  }
}
function r0(n, e, t, i) {
  if (t != null || (t = 0), i != null || (i = Math.min(n.byteLength - t, e.byteLength)), !(t & 7) && !(i & 7)) {
    const s = i / 8;
    new Float64Array(e, 0, s).set(new Float64Array(n, t, s));
  } else if (!(t & 3) && !(i & 3)) {
    const s = i / 4;
    new Float32Array(e, 0, s).set(new Float32Array(n, t, s));
  } else
    new Uint8Array(e).set(new Uint8Array(n, t, i));
}
const zX = {
  normal: "normal-npm",
  add: "add-npm",
  screen: "screen-npm"
};
var fn = /* @__PURE__ */ ((n) => (n[n.DISABLED = 0] = "DISABLED", n[n.RENDERING_MASK_ADD = 1] = "RENDERING_MASK_ADD", n[n.MASK_ACTIVE = 2] = "MASK_ACTIVE", n[n.INVERSE_MASK_ACTIVE = 3] = "INVERSE_MASK_ACTIVE", n[n.RENDERING_MASK_REMOVE = 4] = "RENDERING_MASK_REMOVE", n[n.NONE = 5] = "NONE", n))(fn || {});
function s2(n, e) {
  return e.alphaMode === "no-premultiply-alpha" && zX[n] || n;
}
const $X = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function DX(n) {
  let e = "";
  for (let t = 0; t < n; ++t)
    t > 0 && (e += `
else `), t < n - 1 && (e += `if(test == ${t}.0){}`);
  return e;
}
function yM(n, e) {
  if (n === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  const t = e.createShader(e.FRAGMENT_SHADER);
  try {
    for (; ; ) {
      const i = $X.replace(/%forloop%/gi, DX(n));
      if (e.shaderSource(t, i), e.compileShader(t), !e.getShaderParameter(t, e.COMPILE_STATUS))
        n = n / 2 | 0;
      else
        break;
    }
  } finally {
    e.deleteShader(t);
  }
  return n;
}
let Aa = null;
function OX() {
  var e;
  if (Aa) return Aa;
  const n = qS();
  return Aa = n.getParameter(n.MAX_TEXTURE_IMAGE_UNITS), Aa = yM(
    Aa,
    n
  ), (e = n.getExtension("WEBGL_lose_context")) == null || e.loseContext(), Aa;
}
class LX {
  constructor() {
    this.ids = /* @__PURE__ */ Object.create(null), this.textures = [], this.count = 0;
  }
  /** Clear the textures and their locations. */
  clear() {
    for (let e = 0; e < this.count; e++) {
      const t = this.textures[e];
      this.textures[e] = null, this.ids[t.uid] = null;
    }
    this.count = 0;
  }
}
class BX {
  constructor() {
    this.renderPipeId = "batch", this.action = "startBatch", this.start = 0, this.size = 0, this.textures = new LX(), this.blendMode = "normal", this.topology = "triangle-strip", this.canBundle = !0;
  }
  destroy() {
    this.textures = null, this.gpuBindGroup = null, this.bindGroup = null, this.batcher = null, this.elements = null;
  }
}
const yc = [];
let yf = 0;
Yl.register({
  clear: () => {
    if (yc.length > 0)
      for (const n of yc)
        n && n.destroy();
    yc.length = 0, yf = 0;
  }
});
function o2() {
  return yf > 0 ? yc[--yf] : new BX();
}
function r2(n) {
  n.elements = null, yc[yf++] = n;
}
let vd = 0;
const xM = class wM {
  constructor(e) {
    this.uid = Nt("batcher"), this.dirty = !0, this.batchIndex = 0, this.batches = [], this._elements = [], e = { ...wM.defaultOptions, ...e }, e.maxTextures || (rt("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options"), e.maxTextures = OX());
    const { maxTextures: t, attributesInitialSize: i, indicesInitialSize: s } = e;
    this.attributeBuffer = new i2(i * 4), this.indexBuffer = new Uint16Array(s), this.maxTextures = t;
  }
  begin() {
    this.elementSize = 0, this.elementStart = 0, this.indexSize = 0, this.attributeSize = 0;
    for (let e = 0; e < this.batchIndex; e++)
      r2(this.batches[e]);
    this.batchIndex = 0, this._batchIndexStart = 0, this._batchIndexSize = 0, this.dirty = !0;
  }
  add(e) {
    this._elements[this.elementSize++] = e, e._indexStart = this.indexSize, e._attributeStart = this.attributeSize, e._batcher = this, this.indexSize += e.indexSize, this.attributeSize += e.attributeSize * this.vertexSize;
  }
  checkAndUpdateTexture(e, t) {
    const i = e._batch.textures.ids[t._source.uid];
    return !i && i !== 0 ? !1 : (e._textureId = i, e.texture = t, !0);
  }
  updateElement(e) {
    this.dirty = !0;
    const t = this.attributeBuffer;
    e.packAsQuad ? this.packQuadAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    ) : this.packAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    );
  }
  /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */
  break(e) {
    const t = this._elements;
    if (!t[this.elementStart]) return;
    let i = o2(), s = i.textures;
    s.clear();
    const o = t[this.elementStart];
    let r = s2(o.blendMode, o.texture._source), a = o.topology;
    this.attributeSize * 4 > this.attributeBuffer.size && this._resizeAttributeBuffer(this.attributeSize * 4), this.indexSize > this.indexBuffer.length && this._resizeIndexBuffer(this.indexSize);
    const l = this.attributeBuffer.float32View, d = this.attributeBuffer.uint32View, c = this.indexBuffer;
    let h = this._batchIndexSize, f = this._batchIndexStart, p = "startBatch", y = [];
    const v = this.maxTextures;
    for (let x = this.elementStart; x < this.elementSize; ++x) {
      const w = t[x];
      t[x] = null;
      const M = w.texture._source, _ = s2(w.blendMode, M), T = r !== _ || a !== w.topology;
      if (M._batchTick === vd && !T) {
        w._textureId = M._textureBindLocation, h += w.indexSize, w.packAsQuad ? (this.packQuadAttributes(
          w,
          l,
          d,
          w._attributeStart,
          w._textureId
        ), this.packQuadIndex(
          c,
          w._indexStart,
          w._attributeStart / this.vertexSize
        )) : (this.packAttributes(
          w,
          l,
          d,
          w._attributeStart,
          w._textureId
        ), this.packIndex(
          w,
          c,
          w._indexStart,
          w._attributeStart / this.vertexSize
        )), w._batch = i, y.push(w);
        continue;
      }
      M._batchTick = vd, (s.count >= v || T) && (this._finishBatch(
        i,
        f,
        h - f,
        s,
        r,
        a,
        e,
        p,
        y
      ), p = "renderBatch", f = h, r = _, a = w.topology, i = o2(), s = i.textures, s.clear(), y = [], ++vd), w._textureId = M._textureBindLocation = s.count, s.ids[M.uid] = s.count, s.textures[s.count++] = M, w._batch = i, y.push(w), h += w.indexSize, w.packAsQuad ? (this.packQuadAttributes(
        w,
        l,
        d,
        w._attributeStart,
        w._textureId
      ), this.packQuadIndex(
        c,
        w._indexStart,
        w._attributeStart / this.vertexSize
      )) : (this.packAttributes(
        w,
        l,
        d,
        w._attributeStart,
        w._textureId
      ), this.packIndex(
        w,
        c,
        w._indexStart,
        w._attributeStart / this.vertexSize
      ));
    }
    s.count > 0 && (this._finishBatch(
      i,
      f,
      h - f,
      s,
      r,
      a,
      e,
      p,
      y
    ), f = h, ++vd), this.elementStart = this.elementSize, this._batchIndexStart = f, this._batchIndexSize = h;
  }
  _finishBatch(e, t, i, s, o, r, a, l, d) {
    e.gpuBindGroup = null, e.bindGroup = null, e.action = l, e.batcher = this, e.textures = s, e.blendMode = o, e.topology = r, e.start = t, e.size = i, e.elements = d, ++vd, this.batches[this.batchIndex++] = e, a.add(e);
  }
  finish(e) {
    this.break(e);
  }
  /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureAttributeBuffer(e) {
    e * 4 <= this.attributeBuffer.size || this._resizeAttributeBuffer(e * 4);
  }
  /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureIndexBuffer(e) {
    e <= this.indexBuffer.length || this._resizeIndexBuffer(e);
  }
  _resizeAttributeBuffer(e) {
    const t = Math.max(e, this.attributeBuffer.size * 2), i = new i2(t);
    r0(this.attributeBuffer.rawBinaryData, i.rawBinaryData), this.attributeBuffer = i;
  }
  _resizeIndexBuffer(e) {
    const t = this.indexBuffer;
    let i = Math.max(e, t.length * 1.5);
    i += i % 2;
    const s = i > 65535 ? new Uint32Array(i) : new Uint16Array(i);
    if (s.BYTES_PER_ELEMENT !== t.BYTES_PER_ELEMENT)
      for (let o = 0; o < t.length; o++)
        s[o] = t[o];
    else
      r0(t.buffer, s.buffer);
    this.indexBuffer = s;
  }
  packQuadIndex(e, t, i) {
    e[t] = i + 0, e[t + 1] = i + 1, e[t + 2] = i + 2, e[t + 3] = i + 0, e[t + 4] = i + 2, e[t + 5] = i + 3;
  }
  packIndex(e, t, i, s) {
    const o = e.indices, r = e.indexSize, a = e.indexOffset, l = e.attributeOffset;
    for (let d = 0; d < r; d++)
      t[i++] = s + o[d + a] - l;
  }
  /**
   * Destroys the batch and its resources.
   * @param options - destruction options
   * @param options.shader - whether to destroy the associated shader
   */
  destroy(e = {}) {
    var t;
    if (this.batches !== null) {
      for (let i = 0; i < this.batchIndex; i++)
        r2(this.batches[i]);
      this.batches = null, this.geometry.destroy(!0), this.geometry = null, e.shader && ((t = this.shader) == null || t.destroy(), this.shader = null);
      for (let i = 0; i < this._elements.length; i++)
        this._elements[i] && (this._elements[i]._batch = null);
      this._elements = null, this.indexBuffer = null, this.attributeBuffer.destroy(), this.attributeBuffer = null;
    }
  }
};
xM.defaultOptions = {
  maxTextures: null,
  attributesInitialSize: 4,
  indicesInitialSize: 6
};
let FX = xM;
var $t = /* @__PURE__ */ ((n) => (n[n.MAP_READ = 1] = "MAP_READ", n[n.MAP_WRITE = 2] = "MAP_WRITE", n[n.COPY_SRC = 4] = "COPY_SRC", n[n.COPY_DST = 8] = "COPY_DST", n[n.INDEX = 16] = "INDEX", n[n.VERTEX = 32] = "VERTEX", n[n.UNIFORM = 64] = "UNIFORM", n[n.STORAGE = 128] = "STORAGE", n[n.INDIRECT = 256] = "INDIRECT", n[n.QUERY_RESOLVE = 512] = "QUERY_RESOLVE", n[n.STATIC = 1024] = "STATIC", n))($t || {});
class ns extends bi {
  /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */
  constructor(e) {
    let { data: t, size: i } = e;
    const { usage: s, label: o, shrinkToFit: r } = e;
    super(), this._gpuData = /* @__PURE__ */ Object.create(null), this._gcLastUsed = -1, this.autoGarbageCollect = !0, this.uid = Nt("buffer"), this._resourceType = "buffer", this._resourceId = Nt("resource"), this._updateID = 1, this._updateOffset = 0, this._dataInt32 = null, this.shrinkToFit = !0, this.destroyed = !1, t instanceof Array && (t = new Float32Array(t)), this._data = t, i != null || (i = t == null ? void 0 : t.byteLength);
    const a = !!t;
    this.descriptor = {
      size: i,
      usage: s,
      mappedAtCreation: a,
      label: o
    }, this.shrinkToFit = r != null ? r : !0;
  }
  /** the data in the buffer */
  get data() {
    return this._data;
  }
  set data(e) {
    this.setDataWithSize(e, e.length, !0);
  }
  get dataInt32() {
    return this._dataInt32 || (this._dataInt32 = new Int32Array(this.data.buffer)), this._dataInt32;
  }
  /** whether the buffer is static or not */
  get static() {
    return !!(this.descriptor.usage & $t.STATIC);
  }
  set static(e) {
    e ? this.descriptor.usage |= $t.STATIC : this.descriptor.usage &= ~$t.STATIC;
  }
  /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */
  setDataWithSize(e, t, i) {
    if (this._updateID++, this._updateSize = t * e.BYTES_PER_ELEMENT, this._updateOffset = 0, this._data === e) {
      i && this.emit("update", this);
      return;
    }
    const s = this._data;
    if (this._data = e, this._dataInt32 = null, !s || s.length !== e.length) {
      !this.shrinkToFit && s && e.byteLength < s.byteLength ? i && this.emit("update", this) : (this.descriptor.size = e.byteLength, this._resourceId = Nt("resource"), this.emit("change", this));
      return;
    }
    i && this.emit("update", this);
  }
  /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   * @param offsetInBytes - the offset to start updating from
   */
  update(e, t) {
    this._updateSize = e != null ? e : this._updateSize, this._updateOffset = t || 0, this._updateID++, this.emit("update", this);
  }
  /** Unloads the buffer from the GPU */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null), this.destroyed || (this._resourceId = Nt("resource"), this.emit("change", this));
  }
  /** Destroys the buffer */
  destroy() {
    this.destroyed = !0, this.unload(), this.emit("destroy", this), this.emit("change", this), this._data = null, this.descriptor = null, this.removeAllListeners();
  }
}
function kM(n, e) {
  if (!(n instanceof ns)) {
    let t = e ? $t.INDEX : $t.VERTEX;
    n instanceof Array && (e ? (n = new Uint32Array(n), t = $t.INDEX | $t.COPY_DST) : (n = new Float32Array(n), t = $t.VERTEX | $t.COPY_DST)), n = new ns({
      data: n,
      label: e ? "index-mesh-buffer" : "vertex-mesh-buffer",
      usage: t
    });
  }
  return n;
}
function NX(n, e, t) {
  const i = n.getAttribute(e);
  if (!i)
    return t.minX = 0, t.minY = 0, t.maxX = 0, t.maxY = 0, t;
  const s = i.buffer.data;
  let o = 1 / 0, r = 1 / 0, a = -1 / 0, l = -1 / 0;
  const d = s.BYTES_PER_ELEMENT, c = (i.offset || 0) / d, h = (i.stride || 8) / d;
  for (let f = c; f < s.length; f += h) {
    const p = s[f], y = s[f + 1];
    p > a && (a = p), y > l && (l = y), p < o && (o = p), y < r && (r = y);
  }
  return t.minX = o, t.minY = r, t.maxX = a, t.maxY = l, t;
}
function UX(n) {
  return (n instanceof ns || Array.isArray(n) || n.BYTES_PER_ELEMENT) && (n = {
    buffer: n
  }), n.buffer = kM(n.buffer, !1), n;
}
class bm extends bi {
  /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */
  constructor(e = {}) {
    var o, r;
    super(), this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this.uid = Nt("geometry"), this._layoutKey = 0, this.instanceCount = 1, this.indexCount = 0, this._bounds = new Gn(), this._boundsDirty = !0, this._vertexCount = 0, this._vertexCountDirty = !0;
    const { attributes: t, indexBuffer: i, topology: s } = e;
    if (this.buffers = [], this.attributes = {}, t)
      for (const a in t)
        this.addAttribute(a, t[a]);
    this.instanceCount = (o = e.instanceCount) != null ? o : 1, this.indexCount = (r = e.indexCount) != null ? r : 0, i && this.addIndex(i), this.topology = s || "triangle-list";
  }
  onBufferUpdate() {
    this._boundsDirty = !0, this._vertexCountDirty = !0, this.emit("update", this);
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(e) {
    return this.getAttribute(e).buffer;
  }
  /**
   * The number of vertices in this geometry, derived from the first non-instanced attribute.
   * The value is cached and only recalculated when the geometry's buffers or attributes change.
   */
  get vertexCount() {
    if (!this._vertexCountDirty) return this._vertexCount;
    this._vertexCountDirty = !1;
    const e = this.attributes;
    for (const t in e) {
      const i = e[t];
      if (i.instance) continue;
      const s = i.buffer;
      return this._vertexCount = s.data.length / (i.stride / 4 || i.size), this._vertexCount;
    }
    return this._vertexCount = 0, 0;
  }
  /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   * @deprecated since 8.20.0, use {@link Geometry.vertexCount} instead
   */
  getSize() {
    return rt("8.20.0", "Geometry.getSize is deprecated, please use Geometry.vertexCount instead."), this.vertexCount;
  }
  /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */
  addAttribute(e, t) {
    const i = UX(t);
    this.buffers.indexOf(i.buffer) === -1 && (this.buffers.push(i.buffer), i.buffer.on("update", this.onBufferUpdate, this), i.buffer.on("change", this.onBufferUpdate, this)), this.attributes[e] = i, this._vertexCountDirty = !0;
  }
  /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */
  addIndex(e) {
    this.indexBuffer = kM(e, !0), this.buffers.push(this.indexBuffer);
  }
  /** Returns the bounds of the geometry. */
  get bounds() {
    return this._boundsDirty ? (this._boundsDirty = !1, NX(this, "aPosition", this._bounds)) : this._bounds;
  }
  /** Unloads the geometry from the GPU. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */
  destroy(e = !1) {
    this.emit("destroy", this);
    for (const t of this.buffers)
      t.off("update", this.onBufferUpdate, this), t.off("change", this.onBufferUpdate, this), e && t.destroy();
    this.unload(), this.removeAllListeners(), this.attributes = null, this.buffers = null, this.indexBuffer = null, this._bounds = null;
  }
}
const GX = new Float32Array(1), jX = new Uint32Array(1);
class HX extends bm {
  constructor() {
    const t = new ns({
      data: GX,
      label: "attribute-batch-buffer",
      usage: $t.VERTEX | $t.COPY_DST,
      shrinkToFit: !1
    }), i = new ns({
      data: jX,
      label: "index-batch-buffer",
      usage: $t.INDEX | $t.COPY_DST,
      // | BufferUsage.STATIC,
      shrinkToFit: !1
    }), s = 24;
    super({
      attributes: {
        aPosition: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 0
        },
        aUV: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 8
        },
        aColor: {
          buffer: t,
          format: "unorm8x4",
          stride: s,
          offset: 16
        },
        aTextureIdAndRound: {
          buffer: t,
          format: "uint16x2",
          stride: s,
          offset: 20
        }
      },
      indexBuffer: i
    });
  }
}
function a2(n, e, t) {
  if (n)
    for (const i in n) {
      const s = i.toLocaleLowerCase(), o = e[s];
      if (o) {
        let r = n[i];
        i === "header" && (r = r.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "")), t && o.push(`//----${t}----//`), o.push(r);
      } else
        dt(`${i} placement hook does not exist in shader`);
    }
}
const VX = /\{\{(.*?)\}\}/g;
function l2(n) {
  var i, s;
  const e = {};
  return ((s = (i = n.match(VX)) == null ? void 0 : i.map((o) => o.replace(/[{()}]/g, ""))) != null ? s : []).forEach((o) => {
    e[o] = [];
  }), e;
}
function d2(n, e) {
  let t;
  const i = /@in\s+([^;]+);/g;
  for (; (t = i.exec(n)) !== null; )
    e.push(t[1]);
}
function c2(n, e, t = !1) {
  const i = [];
  d2(e, i), n.forEach((a) => {
    a.header && d2(a.header, i);
  });
  const s = i;
  t && s.sort();
  const o = s.map((a, l) => `       @location(${l}) ${a},`).join(`
`);
  let r = e.replace(/@in\s+[^;]+;\s*/g, "");
  return r = r.replace("{{in}}", `
${o}
`), r;
}
function u2(n, e) {
  let t;
  const i = /@out\s+([^;]+);/g;
  for (; (t = i.exec(n)) !== null; )
    e.push(t[1]);
}
function WX(n) {
  const t = /\b(\w+)\s*:/g.exec(n);
  return t ? t[1] : "";
}
function qX(n) {
  const e = /@.*?\s+/g;
  return n.replace(e, "");
}
function KX(n, e) {
  const t = [];
  u2(e, t), n.forEach((l) => {
    l.header && u2(l.header, t);
  });
  let i = 0;
  const s = t.sort().map((l) => l.indexOf("builtin") > -1 ? l : `@location(${i++}) ${l}`).join(`,
`), o = t.sort().map((l) => `       var ${qX(l)};`).join(`
`), r = `return VSOutput(
            ${t.sort().map((l) => ` ${WX(l)}`).join(`,
`)});`;
  let a = e.replace(/@out\s+[^;]+;\s*/g, "");
  return a = a.replace("{{struct}}", `
${s}
`), a = a.replace("{{start}}", `
${o}
`), a = a.replace("{{return}}", `
${r}
`), a;
}
function h2(n, e) {
  let t = n;
  for (const i in e) {
    const s = e[i];
    s.join(`
`).length ? t = t.replace(`{{${i}}}`, `//-----${i} START-----//
${s.join(`
`)}
//----${i} FINISH----//`) : t = t.replace(`{{${i}}}`, "");
  }
  return t;
}
const Oo = /* @__PURE__ */ Object.create(null), Gg = /* @__PURE__ */ new Map();
let YX = 0;
function XX({
  template: n,
  bits: e
}) {
  const t = _M(n, e);
  if (Oo[t]) return Oo[t];
  const { vertex: i, fragment: s } = ZX(n, e);
  return Oo[t] = SM(i, s, e), Oo[t];
}
function JX({
  template: n,
  bits: e
}) {
  const t = _M(n, e);
  return Oo[t] || (Oo[t] = SM(n.vertex, n.fragment, e)), Oo[t];
}
function ZX(n, e) {
  const t = e.map((r) => r.vertex).filter((r) => !!r), i = e.map((r) => r.fragment).filter((r) => !!r);
  let s = c2(t, n.vertex, !0);
  s = KX(t, s);
  const o = c2(i, n.fragment, !0);
  return {
    vertex: s,
    fragment: o
  };
}
function _M(n, e) {
  return e.map((t) => (Gg.has(t) || Gg.set(t, YX++), Gg.get(t))).sort((t, i) => t - i).join("-") + n.vertex + n.fragment;
}
function SM(n, e, t) {
  const i = l2(n), s = l2(e);
  return t.forEach((o) => {
    a2(o.vertex, i, o.name), a2(o.fragment, s, o.name);
  }), {
    vertex: h2(n, i),
    fragment: h2(e, s)
  };
}
const QX = (
  /* wgsl */
  `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`
), eJ = (
  /* wgsl */
  `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`
), tJ = (
  /* glsl */
  `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`
), nJ = (
  /* glsl */
  `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`
), iJ = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* wgsl */
      `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    )
  }
}, sJ = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* glsl */
      `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    )
  }
};
function ay({ bits: n, name: e }) {
  const t = XX({
    template: {
      fragment: eJ,
      vertex: QX
    },
    bits: [
      iJ,
      ...n
    ]
  });
  return va.from({
    name: e,
    vertex: {
      source: t.vertex,
      entryPoint: "main"
    },
    fragment: {
      source: t.fragment,
      entryPoint: "main"
    }
  });
}
function ly({ bits: n, name: e }) {
  return new Xl({
    name: e,
    ...JX({
      template: {
        vertex: tJ,
        fragment: nJ
      },
      bits: [
        sJ,
        ...n
      ]
    })
  });
}
const MM = {
  name: "color-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            @in aColor: vec4<f32>;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, TM = {
  name: "color-bit",
  vertex: {
    header: (
      /* glsl */
      `
            in vec4 aColor;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, jg = {};
function oJ(n) {
  const e = [];
  if (n === 1)
    e.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;"), e.push("@group(1) @binding(1) var textureSampler1: sampler;");
  else {
    let t = 0;
    for (let i = 0; i < n; i++)
      e.push(`@group(1) @binding(${t++}) var textureSource${i + 1}: texture_2d<f32>;`), e.push(`@group(1) @binding(${t++}) var textureSampler${i + 1}: sampler;`);
  }
  return e.join(`
`);
}
function rJ(n) {
  const e = [];
  if (n === 1)
    e.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
  else {
    e.push("switch vTextureId {");
    for (let t = 0; t < n; t++)
      t === n - 1 ? e.push("  default:{") : e.push(`  case ${t}:{`), e.push(`      outColor = textureSampleGrad(textureSource${t + 1}, textureSampler${t + 1}, vUV, uvDx, uvDy);`), e.push("      break;}");
    e.push("}");
  }
  return e.join(`
`);
}
function CM(n) {
  return jg[n] || (jg[n] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
    },
    fragment: {
      header: `
                @in @interpolate(flat) vTextureId: u32;

                ${oJ(n)}
            `,
      main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${rJ(n)}
            `
    }
  }), jg[n];
}
const Hg = {};
function aJ(n) {
  const e = [];
  for (let t = 0; t < n; t++)
    t > 0 && e.push("else"), t < n - 1 && e.push(`if(vTextureId < ${t}.5)`), e.push("{"), e.push(`	outColor = texture(uTextures[${t}], vUV);`), e.push("}");
  return e.join(`
`);
}
function IM(n) {
  return Hg[n] || (Hg[n] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
    },
    fragment: {
      header: `
                in float vTextureId;

                uniform sampler2D uTextures[${n}];

            `,
      main: `

                ${aJ(n)}
            `
    }
  }), Hg[n];
}
const dy = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, cy = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* glsl */
      `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, p2 = {};
function AM(n) {
  let e = p2[n];
  if (e) return e;
  const t = new Int32Array(n);
  for (let i = 0; i < n; i++)
    t[i] = i;
  return e = p2[n] = new Ts({
    uTextures: { value: t, type: "i32", size: n }
  }, { isStatic: !0 }), e;
}
class f2 extends lo {
  constructor(e) {
    const t = ly({
      name: "batch",
      bits: [
        TM,
        IM(e),
        cy
      ]
    }), i = ay({
      name: "batch",
      bits: [
        MM,
        CM(e),
        dy
      ]
    });
    super({
      glProgram: t,
      gpuProgram: i,
      resources: {
        batchSamplers: AM(e)
      }
    }), this.maxTextures = e;
  }
}
let yr = null;
const PM = class EM extends FX {
  constructor(e) {
    super(e), this.geometry = new HX(), this.name = EM.extension.name, this.vertexSize = 6, yr != null || (yr = new f2(e.maxTextures)), this.shader = yr;
  }
  /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packAttributes(e, t, i, s, o) {
    const r = o << 16 | e.roundPixels & 65535, a = e.transform, l = a.a, d = a.b, c = a.c, h = a.d, f = a.tx, p = a.ty, { positions: y, uvs: v } = e, x = e.color, w = e.attributeOffset, S = w + e.attributeSize;
    for (let M = w; M < S; M++) {
      const _ = M * 2, T = y[_], k = y[_ + 1];
      t[s++] = l * T + c * k + f, t[s++] = h * k + d * T + p, t[s++] = v[_], t[s++] = v[_ + 1], i[s++] = x, i[s++] = r;
    }
  }
  /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packQuadAttributes(e, t, i, s, o) {
    const r = e.texture, a = e.transform, l = a.a, d = a.b, c = a.c, h = a.d, f = a.tx, p = a.ty, y = e.bounds, v = y.maxX, x = y.minX, w = y.maxY, S = y.minY, M = r.uvs, _ = e.color, T = o << 16 | e.roundPixels & 65535;
    t[s + 0] = l * x + c * S + f, t[s + 1] = h * S + d * x + p, t[s + 2] = M.x0, t[s + 3] = M.y0, i[s + 4] = _, i[s + 5] = T, t[s + 6] = l * v + c * S + f, t[s + 7] = h * S + d * v + p, t[s + 8] = M.x1, t[s + 9] = M.y1, i[s + 10] = _, i[s + 11] = T, t[s + 12] = l * v + c * w + f, t[s + 13] = h * w + d * v + p, t[s + 14] = M.x2, t[s + 15] = M.y2, i[s + 16] = _, i[s + 17] = T, t[s + 18] = l * x + c * w + f, t[s + 19] = h * w + d * x + p, t[s + 20] = M.x3, t[s + 21] = M.y3, i[s + 22] = _, i[s + 23] = T;
  }
  /**
   * Updates the maximum number of textures that can be used in the shader.
   * @param maxTextures - The maximum number of textures that can be used in the shader.
   * @internal
   */
  _updateMaxTextures(e) {
    this.shader.maxTextures !== e && (yr = new f2(e), this.shader = yr);
  }
  destroy() {
    this.shader = null, super.destroy();
  }
};
PM.extension = {
  type: [
    Ae.Batcher
  ],
  name: "default"
};
let uy = PM;
class Cs {
  constructor(e) {
    this.items = /* @__PURE__ */ Object.create(null);
    const { renderer: t, type: i, onUnload: s, priority: o, name: r } = e;
    this._renderer = t, t.gc.addResourceHash(this, "items", i, o != null ? o : 0), this._onUnload = s, this.name = r;
  }
  /**
   * Add an item to the hash. No-op if already added.
   * @param item
   * @returns true if the item was added, false if it was already in the hash
   */
  add(e) {
    return this.items[e.uid] ? !1 : (this.items[e.uid] = e, e.once("unload", this.remove, this), e._gcLastUsed = this._renderer.gc.now, !0);
  }
  remove(e, ...t) {
    var s;
    if (!this.items[e.uid]) return;
    const i = e._gpuData[this._renderer.uid];
    i && ((s = this._onUnload) == null || s.call(this, e, ...t), e.off("unload", this.remove, this), i.destroy(), e._gpuData[this._renderer.uid] = null, this.items[e.uid] = null);
  }
  removeAll(...e) {
    Object.values(this.items).forEach((t) => t && this.remove(t, ...e));
  }
  destroy(...e) {
    this.removeAll(...e), this.items = /* @__PURE__ */ Object.create(null), this._renderer = null, this._onUnload = null;
  }
}
function lJ(n, e, t, i, s, o, r, a = null) {
  let l = 0;
  t *= e, s *= o;
  const d = a.a, c = a.b, h = a.c, f = a.d, p = a.tx, y = a.ty;
  for (; l < r; ) {
    const v = n[t], x = n[t + 1];
    i[s] = d * v + h * x + p, i[s + 1] = c * v + f * x + y, s += o, t += e, l++;
  }
}
function dJ(n, e, t, i) {
  let s = 0;
  for (e *= t; s < i; )
    n[e] = 0, n[e + 1] = 0, e += t, s++;
}
function RM(n, e, t, i, s) {
  const o = e.a, r = e.b, a = e.c, l = e.d, d = e.tx, c = e.ty;
  t || (t = 0), i || (i = 2), s || (s = n.length / i - t);
  let h = t * i;
  for (let f = 0; f < s; f++) {
    const p = n[h], y = n[h + 1];
    n[h] = o * p + a * y + d, n[h + 1] = r * p + l * y + c, h += i;
  }
}
const cJ = new ot();
class hy {
  constructor() {
    this.packAsQuad = !1, this.batcherName = "default", this.topology = "triangle-list", this.applyTransform = !0, this.roundPixels = 0, this._batcher = null, this._batch = null;
  }
  get uvs() {
    return this.geometryData.uvs;
  }
  get positions() {
    return this.geometryData.vertices;
  }
  get indices() {
    return this.geometryData.indices;
  }
  get blendMode() {
    return this.renderable && this.applyTransform ? this.renderable.groupBlendMode : "normal";
  }
  get color() {
    const e = this.baseColor, t = e >> 16 | e & 65280 | (e & 255) << 16, i = this.renderable;
    return i ? sa(t, i.groupColor) + (this.alpha * i.groupAlpha * 255 << 24) : t + (this.alpha * 255 << 24);
  }
  get transform() {
    var e;
    return ((e = this.renderable) == null ? void 0 : e.groupTransform) || cJ;
  }
  copyTo(e) {
    e.indexOffset = this.indexOffset, e.indexSize = this.indexSize, e.attributeOffset = this.attributeOffset, e.attributeSize = this.attributeSize, e.baseColor = this.baseColor, e.alpha = this.alpha, e.texture = this.texture, e.geometryData = this.geometryData, e.topology = this.topology;
  }
  reset() {
    this.applyTransform = !0, this.renderable = null, this.topology = "triangle-list";
  }
  destroy() {
    this.renderable = null, this.texture = null, this.geometryData = null, this._batcher = null, this._batch = null;
  }
}
const Xc = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "circle"
  },
  build(n, e) {
    let t, i, s, o, r, a;
    if (n.type === "circle") {
      const _ = n;
      if (r = a = _.radius, r <= 0)
        return !1;
      t = _.x, i = _.y, s = o = 0;
    } else if (n.type === "ellipse") {
      const _ = n;
      if (r = _.halfWidth, a = _.halfHeight, r <= 0 || a <= 0)
        return !1;
      t = _.x, i = _.y, s = o = 0;
    } else {
      const _ = n, T = _.width / 2, k = _.height / 2;
      t = _.x + T, i = _.y + k, r = a = Math.max(0, Math.min(_.radius, Math.min(T, k))), s = T - r, o = k - a;
    }
    if (s < 0 || o < 0)
      return !1;
    const l = Math.ceil(2.3 * Math.sqrt(r + a)), d = l * 8 + (s ? 4 : 0) + (o ? 4 : 0);
    if (d === 0)
      return !1;
    if (l === 0)
      return e[0] = e[6] = t + s, e[1] = e[3] = i + o, e[2] = e[4] = t - s, e[5] = e[7] = i - o, !0;
    let c = 0, h = l * 4 + (s ? 2 : 0) + 2, f = h, p = d, y = s + r, v = o, x = t + y, w = t - y, S = i + v;
    if (e[c++] = x, e[c++] = S, e[--h] = S, e[--h] = w, o) {
      const _ = i - v;
      e[f++] = w, e[f++] = _, e[--p] = _, e[--p] = x;
    }
    for (let _ = 1; _ < l; _++) {
      const T = Math.PI / 2 * (_ / l), k = s + Math.cos(T) * r, P = o + Math.sin(T) * a, A = t + k, R = t - k, D = i + P, O = i - P;
      e[c++] = A, e[c++] = D, e[--h] = D, e[--h] = R, e[f++] = R, e[f++] = O, e[--p] = O, e[--p] = A;
    }
    y = s, v = o + a, x = t + y, w = t - y, S = i + v;
    const M = i - v;
    return e[c++] = x, e[c++] = S, e[--p] = M, e[--p] = x, s && (e[c++] = w, e[c++] = S, e[--p] = M, e[--p] = w), !0;
  },
  triangulate(n, e, t, i, s, o) {
    if (n.length === 0)
      return;
    let r = 0, a = 0;
    for (let c = 0; c < n.length; c += 2)
      r += n[c], a += n[c + 1];
    r /= n.length / 2, a /= n.length / 2;
    let l = i;
    e[l * t] = r, e[l * t + 1] = a;
    const d = l++;
    for (let c = 0; c < n.length; c += 2)
      e[l * t] = n[c], e[l * t + 1] = n[c + 1], c > 0 && (s[o++] = l, s[o++] = d, s[o++] = l - 1), l++;
    s[o++] = d + 1, s[o++] = d, s[o++] = l - 1;
  }
}, uJ = { ...Xc, extension: { ...Xc.extension, name: "ellipse" } }, hJ = { ...Xc, extension: { ...Xc.extension, name: "roundedRectangle" } }, zM = 1e-4, m2 = 1e-4;
function g2(n, e, t, i, s, o, r, a) {
  const l = n - t * s, d = e - i * s, c = n + t * o, h = e + i * o;
  let f, p;
  r ? (f = i, p = -t) : (f = -i, p = t);
  const y = l + f, v = d + p, x = c + f, w = h + p;
  return a.push(y, v), a.push(x, w), 2;
}
function xr(n, e, t, i, s, o, r, a) {
  const l = t - n, d = i - e;
  let c = Math.atan2(l, d), h = Math.atan2(s - n, o - e);
  a && c < h ? c += Math.PI * 2 : !a && c > h && (h += Math.PI * 2);
  let f = c;
  const p = h - c, y = Math.abs(p), v = Math.sqrt(l * l + d * d), x = (15 * y * Math.sqrt(v) / Math.PI >> 0) + 1, w = p / x;
  if (f += w, a) {
    r.push(n, e), r.push(t, i);
    for (let S = 1, M = f; S < x; S++, M += w)
      r.push(n, e), r.push(
        n + Math.sin(M) * v,
        e + Math.cos(M) * v
      );
    r.push(n, e), r.push(s, o);
  } else {
    r.push(t, i), r.push(n, e);
    for (let S = 1, M = f; S < x; S++, M += w)
      r.push(
        n + Math.sin(M) * v,
        e + Math.cos(M) * v
      ), r.push(n, e);
    r.push(s, o), r.push(n, e);
  }
  return x * 2;
}
function py(n, e, t, i, s, o) {
  const r = zM;
  if (n.length === 0)
    return;
  const a = e;
  let l = a.alignment;
  if (e.alignment !== 0.5) {
    let B = bM(n);
    l = (l - 0.5) * B + 0.5;
  }
  const d = new Wt(n[0], n[1]), c = new Wt(n[n.length - 2], n[n.length - 1]), h = i, f = Math.abs(d.x - c.x) < r && Math.abs(d.y - c.y) < r;
  if (h) {
    n = n.slice(), f && (n.pop(), n.pop(), c.set(n[n.length - 2], n[n.length - 1]));
    const B = (d.x + c.x) * 0.5, re = (c.y + d.y) * 0.5;
    n.unshift(B, re), n.push(B, re);
  }
  const p = s, y = n.length / 2;
  let v = n.length;
  const x = p.length / 2, w = a.width / 2, S = w * w, M = a.miterLimit * a.miterLimit;
  let _ = n[0], T = n[1], k = n[2], P = n[3], A = 0, R = 0, D = -(T - P), O = _ - k, F = 0, ie = 0, ee = Math.sqrt(D * D + O * O);
  D /= ee, O /= ee, D *= w, O *= w;
  const me = l, L = (1 - me) * 2, N = me * 2;
  h || (a.cap === "round" ? v += xr(
    _ - D * (L - N) * 0.5,
    T - O * (L - N) * 0.5,
    _ - D * L,
    T - O * L,
    _ + D * N,
    T + O * N,
    p,
    !0
  ) + 2 : a.cap === "square" && (v += g2(_, T, D, O, L, N, !0, p))), p.push(
    _ - D * L,
    T - O * L
  ), p.push(
    _ + D * N,
    T + O * N
  );
  for (let B = 1; B < y - 1; ++B) {
    _ = n[(B - 1) * 2], T = n[(B - 1) * 2 + 1], k = n[B * 2], P = n[B * 2 + 1], A = n[(B + 1) * 2], R = n[(B + 1) * 2 + 1], D = -(T - P), O = _ - k, ee = Math.sqrt(D * D + O * O), D /= ee, O /= ee, D *= w, O *= w, F = -(P - R), ie = k - A, ee = Math.sqrt(F * F + ie * ie), F /= ee, ie /= ee, F *= w, ie *= w;
    const re = k - _, H = T - P, J = k - A, Q = R - P, ne = re * J + H * Q, ue = H * J - Q * re, Z = ue < 0;
    if (Math.abs(ue) < 1e-3 * Math.abs(ne)) {
      p.push(
        k - D * L,
        P - O * L
      ), p.push(
        k + D * N,
        P + O * N
      ), ne >= 0 && (a.join === "round" ? v += xr(
        k,
        P,
        k - D * L,
        P - O * L,
        k - F * L,
        P - ie * L,
        p,
        !1
      ) + 4 : v += 2, p.push(
        k - F * N,
        P - ie * N
      ), p.push(
        k + F * L,
        P + ie * L
      ));
      continue;
    }
    const te = (-D + _) * (-O + P) - (-D + k) * (-O + T), we = (-F + A) * (-ie + P) - (-F + k) * (-ie + R), Fe = (re * we - J * te) / ue, Me = (Q * te - H * we) / ue, he = (Fe - k) * (Fe - k) + (Me - P) * (Me - P), U = k + (Fe - k) * L, q = P + (Me - P) * L, oe = k - (Fe - k) * N, de = P - (Me - P) * N, pe = Math.min(re * re + H * H, J * J + Q * Q), Ce = Z ? L : N, Be = pe + Ce * Ce * S;
    he <= Be ? a.join === "bevel" || he / S > M ? (Z ? (p.push(U, q), p.push(k + D * N, P + O * N), p.push(U, q), p.push(k + F * N, P + ie * N)) : (p.push(k - D * L, P - O * L), p.push(oe, de), p.push(k - F * L, P - ie * L), p.push(oe, de)), v += 2) : a.join === "round" ? Z ? (p.push(U, q), p.push(k + D * N, P + O * N), v += xr(
      k,
      P,
      k + D * N,
      P + O * N,
      k + F * N,
      P + ie * N,
      p,
      !0
    ) + 4, p.push(U, q), p.push(k + F * N, P + ie * N)) : (p.push(k - D * L, P - O * L), p.push(oe, de), v += xr(
      k,
      P,
      k - D * L,
      P - O * L,
      k - F * L,
      P - ie * L,
      p,
      !1
    ) + 4, p.push(k - F * L, P - ie * L), p.push(oe, de)) : (p.push(U, q), p.push(oe, de)) : (p.push(k - D * L, P - O * L), p.push(k + D * N, P + O * N), a.join === "round" ? Z ? v += xr(
      k,
      P,
      k + D * N,
      P + O * N,
      k + F * N,
      P + ie * N,
      p,
      !0
    ) + 2 : v += xr(
      k,
      P,
      k - D * L,
      P - O * L,
      k - F * L,
      P - ie * L,
      p,
      !1
    ) + 2 : a.join === "miter" && he / S <= M && (Z ? (p.push(oe, de), p.push(oe, de)) : (p.push(U, q), p.push(U, q)), v += 2), p.push(k - F * L, P - ie * L), p.push(k + F * N, P + ie * N), v += 2);
  }
  _ = n[(y - 2) * 2], T = n[(y - 2) * 2 + 1], k = n[(y - 1) * 2], P = n[(y - 1) * 2 + 1], D = -(T - P), O = _ - k, ee = Math.sqrt(D * D + O * O), D /= ee, O /= ee, D *= w, O *= w, p.push(k - D * L, P - O * L), p.push(k + D * N, P + O * N), h || (a.cap === "round" ? v += xr(
    k - D * (L - N) * 0.5,
    P - O * (L - N) * 0.5,
    k - D * L,
    P - O * L,
    k + D * N,
    P + O * N,
    p,
    !1
  ) + 2 : a.cap === "square" && (v += g2(k, P, D, O, L, N, !1, p)));
  const K = m2 * m2;
  for (let B = x; B < v + x - 2; ++B)
    _ = p[B * 2], T = p[B * 2 + 1], k = p[(B + 1) * 2], P = p[(B + 1) * 2 + 1], A = p[(B + 2) * 2], R = p[(B + 2) * 2 + 1], !(Math.abs(_ * (P - R) + k * (R - T) + A * (T - P)) < K) && o.push(B, B + 1, B + 2);
}
function pJ(n, e, t, i) {
  const s = zM;
  if (n.length === 0)
    return;
  const o = n[0], r = n[1], a = n[n.length - 2], l = n[n.length - 1], d = e || Math.abs(o - a) < s && Math.abs(r - l) < s, c = t, h = n.length / 2, f = c.length / 2;
  for (let p = 0; p < h; p++)
    c.push(n[p * 2]), c.push(n[p * 2 + 1]);
  for (let p = 0; p < h - 1; p++)
    i.push(f + p, f + p + 1);
  d && i.push(f + h - 1, f);
}
function $M(n, e, t, i, s, o, r) {
  const a = yX(n, e, 2);
  if (!a)
    return;
  for (let d = 0; d < a.length; d += 3)
    o[r++] = a[d] + s, o[r++] = a[d + 1] + s, o[r++] = a[d + 2] + s;
  let l = s * i;
  for (let d = 0; d < n.length; d += 2)
    t[l] = n[d], t[l + 1] = n[d + 1], l += i;
}
const fJ = [], mJ = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "polygon"
  },
  build(n, e) {
    for (let t = 0; t < n.points.length; t++)
      e[t] = n.points[t];
    return !0;
  },
  triangulate(n, e, t, i, s, o) {
    $M(n, fJ, e, t, i, s, o);
  }
}, gJ = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "rectangle"
  },
  build(n, e) {
    const t = n, i = t.x, s = t.y, o = t.width, r = t.height;
    return o > 0 && r > 0 ? (e[0] = i, e[1] = s, e[2] = i + o, e[3] = s, e[4] = i + o, e[5] = s + r, e[6] = i, e[7] = s + r, !0) : !1;
  },
  triangulate(n, e, t, i, s, o) {
    let r = 0;
    i *= t, e[i + r] = n[0], e[i + r + 1] = n[1], r += t, e[i + r] = n[2], e[i + r + 1] = n[3], r += t, e[i + r] = n[6], e[i + r + 1] = n[7], r += t, e[i + r] = n[4], e[i + r + 1] = n[5], r += t;
    const a = i / t;
    s[o++] = a, s[o++] = a + 1, s[o++] = a + 2, s[o++] = a + 1, s[o++] = a + 3, s[o++] = a + 2;
  }
}, bJ = {
  extension: {
    type: Ae.ShapeBuilder,
    name: "triangle"
  },
  build(n, e) {
    return e[0] = n.x, e[1] = n.y, e[2] = n.x2, e[3] = n.y2, e[4] = n.x3, e[5] = n.y3, !0;
  },
  triangulate(n, e, t, i, s, o) {
    let r = 0;
    i *= t, e[i + r] = n[0], e[i + r + 1] = n[1], r += t, e[i + r] = n[2], e[i + r + 1] = n[3], r += t, e[i + r] = n[4], e[i + r + 1] = n[5];
    const a = i / t;
    s[o++] = a, s[o++] = a + 1, s[o++] = a + 2;
  }
}, b2 = [{ offset: 0, color: "white" }, { offset: 1, color: "black" }], fy = class a0 {
  constructor(...e) {
    var s;
    this.uid = Nt("fillGradient"), this._tick = 0, this.type = "linear", this.colorStops = [];
    let t = vJ(e);
    t = { ...t.type === "radial" ? a0.defaultRadialOptions : a0.defaultLinearOptions, ...bS(t) }, this._textureSize = t.textureSize, this._wrapMode = t.wrapMode, t.type === "radial" ? (this.center = t.center, this.outerCenter = (s = t.outerCenter) != null ? s : this.center, this.innerRadius = t.innerRadius, this.outerRadius = t.outerRadius, this.scale = t.scale, this.rotation = t.rotation) : (this.start = t.start, this.end = t.end), this.textureSpace = t.textureSpace, this.type = t.type, t.colorStops.forEach((o) => {
      this.addColorStop(o.offset, o.color);
    });
  }
  /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */
  addColorStop(e, t) {
    return this.colorStops.push({ offset: e, color: vn.shared.setValue(t).toHexa() }), this;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildLinearGradient() {
    if (this.texture) return;
    let { x: e, y: t } = this.start, { x: i, y: s } = this.end, o = i - e, r = s - t;
    const a = o < 0 || r < 0;
    if (this._wrapMode === "clamp-to-edge") {
      if (o < 0) {
        const x = e;
        e = i, i = x, o *= -1;
      }
      if (r < 0) {
        const x = t;
        t = s, s = x, r *= -1;
      }
    }
    const l = this.colorStops.length ? this.colorStops : b2, d = this._textureSize, { canvas: c, context: h } = y2(d, 1), f = a ? h.createLinearGradient(this._textureSize, 0, 0, 0) : h.createLinearGradient(0, 0, this._textureSize, 0);
    v2(f, l), h.fillStyle = f, h.fillRect(0, 0, d, 1), this.texture = new et({
      source: new Gc({
        resource: c,
        addressMode: this._wrapMode
      })
    });
    const p = Math.sqrt(o * o + r * r), y = Math.atan2(r, o), v = new ot();
    v.scale(p / d, 1), v.rotate(y), v.translate(e, t), this.textureSpace === "local" && v.scale(d, d), this.transform = v;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildGradient() {
    this.texture || this._tick++, this.type === "linear" ? this.buildLinearGradient() : this.buildRadialGradient();
  }
  /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildRadialGradient() {
    if (this.texture) return;
    const e = this.colorStops.length ? this.colorStops : b2, t = this._textureSize, { canvas: i, context: s } = y2(t, t), { x: o, y: r } = this.center, { x: a, y: l } = this.outerCenter, d = this.innerRadius, c = this.outerRadius, h = a - c, f = l - c, p = t / (c * 2), y = (o - h) * p, v = (r - f) * p, x = s.createRadialGradient(
      y,
      v,
      d * p,
      (a - h) * p,
      (l - f) * p,
      c * p
    );
    v2(x, e), s.fillStyle = e[e.length - 1].color, s.fillRect(0, 0, t, t), s.fillStyle = x, s.translate(y, v), s.rotate(this.rotation), s.scale(1, this.scale), s.translate(-y, -v), s.fillRect(0, 0, t, t), this.texture = new et({
      source: new Gc({
        resource: i,
        addressMode: this._wrapMode
      })
    });
    const w = new ot();
    this.textureSpace === "local" ? w.scale(2 * c, 2 * c) : w.scale(1 / p, 1 / p), w.translate(h, f), this.transform = w;
  }
  /** Destroys the gradient, releasing resources. This will also destroy the internal texture. */
  destroy() {
    var e;
    (e = this.texture) == null || e.destroy(!0), this.texture = null, this.transform = null, this.colorStops = [], this.start = null, this.end = null, this.center = null, this.outerCenter = null;
  }
  /**
   * Returns a unique key for this gradient instance.
   * This key is used for caching and texture management.
   * @returns {string} Unique key for the gradient
   */
  get styleKey() {
    return `fill-gradient-${this.uid}-${this._tick}`;
  }
};
fy.defaultLinearOptions = {
  start: { x: 0, y: 0 },
  end: { x: 0, y: 1 },
  colorStops: [],
  textureSpace: "local",
  type: "linear",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
fy.defaultRadialOptions = {
  center: { x: 0.5, y: 0.5 },
  innerRadius: 0,
  outerRadius: 0.5,
  colorStops: [],
  scale: 1,
  rotation: 0,
  textureSpace: "local",
  type: "radial",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
let Jl = fy;
function v2(n, e) {
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    n.addColorStop(i.offset, i.color);
  }
}
function y2(n, e) {
  const t = zt.get().createCanvas(n, e), i = t.getContext("2d");
  return { canvas: t, context: i };
}
function vJ(n) {
  var t, i;
  let e = (t = n[0]) != null ? t : {};
  return (typeof e == "number" || n[1]) && (rt("8.5.2", "use options object instead"), e = {
    type: "linear",
    start: { x: n[0], y: n[1] },
    end: { x: n[2], y: n[3] },
    textureSpace: n[4],
    textureSize: (i = n[5]) != null ? i : Jl.defaultLinearOptions.textureSize
  }), e;
}
const yJ = new ot(), xJ = new Tt(), wJ = new ot();
function DM(n, e, t, i) {
  const s = e.matrix ? n.copyFrom(e.matrix).invert() : n.identity();
  if (e.textureSpace === "local") {
    const r = t.getBounds(xJ);
    e.width && r.pad(e.width);
    const { x: a, y: l } = r, d = 1 / r.width, c = 1 / r.height, h = -a * d, f = -l * c, p = s.a, y = s.b, v = s.c, x = s.d;
    s.a *= d, s.b *= d, s.c *= c, s.d *= c, s.tx = h * p + f * v + s.tx, s.ty = h * y + f * x + s.ty;
  } else if (e.texture.rotate) {
    const { uvs: r, orig: a } = e.texture;
    s.scale(1 / a.width, 1 / a.height), s.prepend(wJ.set(
      r.x1 - r.x0,
      r.y1 - r.y0,
      r.x3 - r.x0,
      r.y3 - r.y0,
      r.x0,
      r.y0
    ));
  } else
    s.translate(e.texture.frame.x, e.texture.frame.y), s.scale(1 / e.texture.source.width, 1 / e.texture.source.height);
  const o = e.texture.source.style;
  return !(e.fill instanceof Jl) && o.addressMode === "clamp-to-edge" && (o.addressMode = "repeat", o.update()), i && s.append(yJ.copyFrom(i).invert()), s;
}
const Zl = {};
ht.handleByMap(Ae.ShapeBuilder, Zl);
ht.add(gJ, mJ, bJ, Xc, uJ, hJ);
const kJ = new Tt(), _J = new ot();
function SJ(n, e) {
  const { geometryData: t, batches: i } = e;
  i.length = 0, t.indices.length = 0, t.vertices.length = 0, t.uvs.length = 0;
  for (let s = 0; s < n.instructions.length; s++) {
    const o = n.instructions[s];
    if (o.action === "texture")
      MJ(o.data, i, t);
    else if (o.action === "fill" || o.action === "stroke") {
      const r = o.action === "stroke", a = o.data.path.shapePath, l = o.data.style, d = o.data.hole;
      r && d && x2(d.shapePath, l, !0, i, t), d && (a.shapePrimitives[a.shapePrimitives.length - 1].holes = d.shapePath.shapePrimitives), x2(a, l, r, i, t);
    }
  }
}
function MJ(n, e, t) {
  const i = [], s = Zl.rectangle, o = kJ;
  o.x = n.dx, o.y = n.dy, o.width = n.dw, o.height = n.dh;
  const r = n.transform;
  if (!s.build(o, i))
    return;
  const { vertices: a, uvs: l, indices: d } = t, c = d.length, h = a.length / 2;
  r && RM(i, r), s.triangulate(i, a, 2, h, d, c);
  const f = n.image, p = f.uvs;
  l.push(
    p.x0,
    p.y0,
    p.x1,
    p.y1,
    p.x3,
    p.y3,
    p.x2,
    p.y2
  );
  const y = $n.get(hy);
  y.indexOffset = c, y.indexSize = d.length - c, y.attributeOffset = h, y.attributeSize = a.length / 2 - h, y.baseColor = n.style, y.alpha = n.alpha, y.texture = f, y.geometryData = t, e.push(y);
}
function x2(n, e, t, i, s) {
  const { vertices: o, uvs: r, indices: a } = s;
  n.shapePrimitives.forEach(({ shape: l, transform: d, holes: c }) => {
    var M;
    const h = [], f = Zl[l.type];
    if (!f.build(l, h))
      return;
    const p = a.length, y = o.length / 2;
    let v = "triangle-list";
    if (d && RM(h, d), t) {
      const _ = (M = l.closePath) != null ? M : !0, T = e;
      T.pixelLine ? (pJ(h, _, o, a), v = "line-list") : py(h, T, !1, _, o, a);
    } else if (c) {
      const _ = [], T = h.slice();
      TJ(c).forEach((P) => {
        _.push(T.length / 2), T.push(...P);
      }), $M(T, _, o, 2, y, a, p);
    } else
      f.triangulate(h, o, 2, y, a, p);
    const x = r.length / 2, w = e.texture;
    if (w !== et.WHITE) {
      const _ = DM(_J, e, l, d);
      lJ(o, 2, y, r, x, 2, o.length / 2 - y, _);
    } else
      dJ(r, x, 2, o.length / 2 - y);
    const S = $n.get(hy);
    S.indexOffset = p, S.indexSize = a.length - p, S.attributeOffset = y, S.attributeSize = o.length / 2 - y, S.baseColor = e.color, S.alpha = e.alpha, S.texture = w, S.geometryData = s, S.topology = v, i.push(S);
  });
}
function TJ(n) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const i = n[t].shape, s = [];
    Zl[i.type].build(i, s) && e.push(s);
  }
  return e;
}
class CJ {
  constructor() {
    this.batches = [], this.geometryData = {
      vertices: [],
      uvs: [],
      indices: []
    };
  }
  reset() {
    this.batches && this.batches.forEach((e) => {
      $n.return(e);
    }), this.graphicsData && $n.return(this.graphicsData), this.isBatchable = !1, this.context = null, this.batches.length = 0, this.geometryData.indices.length = 0, this.geometryData.vertices.length = 0, this.geometryData.uvs.length = 0, this.graphicsData = null;
  }
  destroy() {
    this.reset(), this.batches = null, this.geometryData = null;
  }
}
class IJ {
  constructor() {
    this.instructions = new Q1();
  }
  init(e) {
    const t = e.maxTextures;
    this.batcher ? this.batcher._updateMaxTextures(t) : this.batcher = new uy({ maxTextures: t }), this.instructions.reset();
  }
  /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */
  get geometry() {
    return rt(wK, "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead."), this.batcher.geometry;
  }
  destroy() {
    this.batcher.destroy(), this.instructions.destroy(), this.batcher = null, this.instructions = null;
  }
}
const my = class l0 {
  constructor(e) {
    this._renderer = e, this._managedContexts = new Cs({ renderer: e, type: "resource", name: "graphicsContext" });
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(e) {
    var t;
    l0.defaultOptions.bezierSmoothness = (t = e == null ? void 0 : e.bezierSmoothness) != null ? t : l0.defaultOptions.bezierSmoothness;
  }
  /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */
  getContextRenderData(e) {
    return e._gpuData[this._renderer.uid].graphicsData || this._initContextRenderData(e);
  }
  /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */
  updateGpuContext(e) {
    const t = !!e._gpuData[this._renderer.uid], i = e._gpuData[this._renderer.uid] || this._initContext(e);
    if (e.dirty || !t) {
      t && i.reset(), SJ(e, i);
      const s = e.batchMode;
      e.customShader || s === "no-batch" ? i.isBatchable = !1 : s === "auto" ? i.isBatchable = i.geometryData.vertices.length < 400 : i.isBatchable = !0, e.dirty = !1;
    }
    return i;
  }
  /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */
  getGpuContext(e) {
    return e._gpuData[this._renderer.uid] || this._initContext(e);
  }
  _initContextRenderData(e) {
    const t = $n.get(IJ, {
      maxTextures: this._renderer.limits.maxBatchableTextures
    }), i = e._gpuData[this._renderer.uid], { batches: s, geometryData: o } = i;
    i.graphicsData = t;
    const r = o.vertices.length, a = o.indices.length;
    for (let h = 0; h < s.length; h++)
      s[h].applyTransform = !1;
    const l = t.batcher;
    l.ensureAttributeBuffer(r), l.ensureIndexBuffer(a), l.begin();
    for (let h = 0; h < s.length; h++) {
      const f = s[h];
      l.add(f);
    }
    l.finish(t.instructions);
    const d = l.geometry;
    d.indexBuffer.setDataWithSize(l.indexBuffer, l.indexSize, !0), d.buffers[0].setDataWithSize(l.attributeBuffer.float32View, l.attributeSize, !0);
    const c = l.batches;
    for (let h = 0; h < l.batchIndex; h++) {
      const f = c[h];
      f.bindGroup = ry(
        f.textures.textures,
        f.textures.count,
        this._renderer.limits.maxBatchableTextures
      );
    }
    return t;
  }
  _initContext(e) {
    const t = new CJ();
    return t.context = e, e._gpuData[this._renderer.uid] = t, this._managedContexts.add(e), t;
  }
  destroy() {
    this._managedContexts.destroy(), this._renderer = null;
  }
};
my.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "graphicsContext"
};
my.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let gy = my;
const AJ = 8, fh = 11920929e-14, PJ = 1;
function OM(n, e, t, i, s, o, r, a, l, d) {
  const h = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, d != null ? d : gy.defaultOptions.bezierSmoothness)
  );
  let f = (PJ - h) / 1;
  return f *= f, EJ(e, t, i, s, o, r, a, l, n, f), n;
}
function EJ(n, e, t, i, s, o, r, a, l, d) {
  d0(n, e, t, i, s, o, r, a, l, d, 0), l.push(r, a);
}
function d0(n, e, t, i, s, o, r, a, l, d, c) {
  if (c > AJ)
    return;
  const h = (n + t) / 2, f = (e + i) / 2, p = (t + s) / 2, y = (i + o) / 2, v = (s + r) / 2, x = (o + a) / 2, w = (h + p) / 2, S = (f + y) / 2, M = (p + v) / 2, _ = (y + x) / 2, T = (w + M) / 2, k = (S + _) / 2;
  if (c > 0) {
    let P = r - n, A = a - e;
    const R = Math.abs((t - r) * A - (i - a) * P), D = Math.abs((s - r) * A - (o - a) * P);
    if (R > fh && D > fh) {
      if ((R + D) * (R + D) <= d * (P * P + A * A)) {
        l.push(T, k);
        return;
      }
    } else if (R > fh) {
      if (R * R <= d * (P * P + A * A)) {
        l.push(T, k);
        return;
      }
    } else if (D > fh) {
      if (D * D <= d * (P * P + A * A)) {
        l.push(T, k);
        return;
      }
    } else if (P = T - (n + r) / 2, A = k - (e + a) / 2, P * P + A * A <= d) {
      l.push(T, k);
      return;
    }
  }
  d0(n, e, h, f, w, S, T, k, l, d, c + 1), d0(T, k, M, _, v, x, r, a, l, d, c + 1);
}
const RJ = 8, zJ = 11920929e-14, $J = 1;
function DJ(n, e, t, i, s, o, r, a) {
  const d = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, a != null ? a : gy.defaultOptions.bezierSmoothness)
  );
  let c = ($J - d) / 1;
  return c *= c, OJ(e, t, i, s, o, r, n, c), n;
}
function OJ(n, e, t, i, s, o, r, a) {
  c0(r, n, e, t, i, s, o, a, 0), r.push(s, o);
}
function c0(n, e, t, i, s, o, r, a, l) {
  if (l > RJ)
    return;
  const d = (e + i) / 2, c = (t + s) / 2, h = (i + o) / 2, f = (s + r) / 2, p = (d + h) / 2, y = (c + f) / 2;
  let v = o - e, x = r - t;
  const w = Math.abs((i - o) * x - (s - r) * v);
  if (w > zJ) {
    if (w * w <= a * (v * v + x * x)) {
      n.push(p, y);
      return;
    }
  } else if (v = p - (e + o) / 2, x = y - (t + r) / 2, v * v + x * x <= a) {
    n.push(p, y);
    return;
  }
  c0(n, e, t, d, c, p, y, a, l + 1), c0(n, p, y, h, f, o, r, a, l + 1);
}
function LM(n, e, t, i, s, o, r, a) {
  let l = Math.abs(s - o);
  (!r && s > o || r && o > s) && (l = 2 * Math.PI - l), a || (a = Math.max(6, Math.floor(6 * Math.pow(i, 1 / 3) * (l / Math.PI)))), a = Math.max(a, 3);
  let d = l / a, c = s;
  d *= r ? -1 : 1;
  for (let h = 0; h < a + 1; h++) {
    const f = Math.cos(c), p = Math.sin(c), y = e + f * i, v = t + p * i;
    n.push(y, v), c += d;
  }
}
function LJ(n, e, t, i, s, o) {
  const r = n[n.length - 2], l = n[n.length - 1] - t, d = r - e, c = s - t, h = i - e, f = Math.abs(l * h - d * c);
  if (f < 1e-8 || o === 0) {
    (n[n.length - 2] !== e || n[n.length - 1] !== t) && n.push(e, t);
    return;
  }
  const p = l * l + d * d, y = c * c + h * h, v = l * c + d * h, x = o * Math.sqrt(p) / f, w = o * Math.sqrt(y) / f, S = x * v / p, M = w * v / y, _ = x * h + w * d, T = x * c + w * l, k = d * (w + S), P = l * (w + S), A = h * (x + M), R = c * (x + M), D = Math.atan2(P - T, k - _), O = Math.atan2(R - T, A - _);
  LM(
    n,
    _ + e,
    T + t,
    o,
    D,
    O,
    d * c > h * l
  );
}
const xc = Math.PI * 2, Vg = {
  centerX: 0,
  centerY: 0,
  ang1: 0,
  ang2: 0
}, Wg = ({ x: n, y: e }, t, i, s, o, r, a, l) => {
  n *= t, e *= i;
  const d = s * n - o * e, c = o * n + s * e;
  return l.x = d + r, l.y = c + a, l;
};
function BJ(n, e) {
  const t = e === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(e / 4), i = e === 1.5707963267948966 ? 0.551915024494 : t, s = Math.cos(n), o = Math.sin(n), r = Math.cos(n + e), a = Math.sin(n + e);
  return [
    {
      x: s - o * i,
      y: o + s * i
    },
    {
      x: r + a * i,
      y: a - r * i
    },
    {
      x: r,
      y: a
    }
  ];
}
const w2 = (n, e, t, i) => {
  const s = n * i - e * t < 0 ? -1 : 1;
  let o = n * t + e * i;
  return o > 1 && (o = 1), o < -1 && (o = -1), s * Math.acos(o);
}, FJ = (n, e, t, i, s, o, r, a, l, d, c, h, f) => {
  const p = Math.pow(s, 2), y = Math.pow(o, 2), v = Math.pow(c, 2), x = Math.pow(h, 2);
  let w = p * y - p * x - y * v;
  w < 0 && (w = 0), w /= p * x + y * v, w = Math.sqrt(w) * (r === a ? -1 : 1);
  const S = w * s / o * h, M = w * -o / s * c, _ = d * S - l * M + (n + t) / 2, T = l * S + d * M + (e + i) / 2, k = (c - S) / s, P = (h - M) / o, A = (-c - S) / s, R = (-h - M) / o, D = w2(1, 0, k, P);
  let O = w2(k, P, A, R);
  a === 0 && O > 0 && (O -= xc), a === 1 && O < 0 && (O += xc), f.centerX = _, f.centerY = T, f.ang1 = D, f.ang2 = O;
};
function NJ(n, e, t, i, s, o, r, a = 0, l = 0, d = 0) {
  if (o === 0 || r === 0)
    return;
  const c = Math.sin(a * xc / 360), h = Math.cos(a * xc / 360), f = h * (e - i) / 2 + c * (t - s) / 2, p = -c * (e - i) / 2 + h * (t - s) / 2;
  if (f === 0 && p === 0)
    return;
  o = Math.abs(o), r = Math.abs(r);
  const y = Math.pow(f, 2) / Math.pow(o, 2) + Math.pow(p, 2) / Math.pow(r, 2);
  y > 1 && (o *= Math.sqrt(y), r *= Math.sqrt(y)), FJ(
    e,
    t,
    i,
    s,
    o,
    r,
    l,
    d,
    c,
    h,
    f,
    p,
    Vg
  );
  let { ang1: v, ang2: x } = Vg;
  const { centerX: w, centerY: S } = Vg;
  let M = Math.abs(x) / (xc / 4);
  Math.abs(1 - M) < 1e-7 && (M = 1);
  const _ = Math.max(Math.ceil(M), 1);
  x /= _;
  let T = n[n.length - 2], k = n[n.length - 1];
  const P = { x: 0, y: 0 };
  for (let A = 0; A < _; A++) {
    const R = BJ(v, x), { x: D, y: O } = Wg(R[0], o, r, h, c, w, S, P), { x: F, y: ie } = Wg(R[1], o, r, h, c, w, S, P), { x: ee, y: me } = Wg(R[2], o, r, h, c, w, S, P);
    OM(
      n,
      T,
      k,
      D,
      O,
      F,
      ie,
      ee,
      me
    ), T = ee, k = me, v += x;
  }
}
function UJ(n, e, t) {
  var r;
  const i = (a, l) => {
    const d = l.x - a.x, c = l.y - a.y, h = Math.sqrt(d * d + c * c), f = d / h, p = c / h;
    return { len: h, nx: f, ny: p };
  }, s = (a, l) => {
    a === 0 ? n.moveTo(l.x, l.y) : n.lineTo(l.x, l.y);
  };
  let o = e[e.length - 1];
  for (let a = 0; a < e.length; a++) {
    const l = e[a % e.length], d = (r = l.radius) != null ? r : t;
    if (d <= 0) {
      s(a, l), o = l;
      continue;
    }
    const c = e[(a + 1) % e.length], h = i(l, o), f = i(l, c);
    if (h.len < 1e-4 || f.len < 1e-4) {
      s(a, l), o = l;
      continue;
    }
    let p = Math.asin(h.nx * f.ny - h.ny * f.nx), y = 1, v = !1;
    h.nx * f.nx - h.ny * -f.ny < 0 ? p < 0 ? p = Math.PI + p : (p = Math.PI - p, y = -1, v = !0) : p > 0 && (y = -1, v = !0);
    const x = p / 2;
    let w, S = Math.abs(
      Math.cos(x) * d / Math.sin(x)
    );
    S > Math.min(h.len / 2, f.len / 2) ? (S = Math.min(h.len / 2, f.len / 2), w = Math.abs(S * Math.sin(x) / Math.cos(x))) : w = d;
    const M = l.x + f.nx * S + -f.ny * w * y, _ = l.y + f.ny * S + f.nx * w * y, T = Math.atan2(h.ny, h.nx) + Math.PI / 2 * y, k = Math.atan2(f.ny, f.nx) - Math.PI / 2 * y;
    a === 0 && n.moveTo(
      M + Math.cos(T) * w,
      _ + Math.sin(T) * w
    ), n.arc(M, _, w, T, k, v), o = l;
  }
}
function GJ(n, e, t, i) {
  var a;
  const s = (l, d) => Math.sqrt((l.x - d.x) ** 2 + (l.y - d.y) ** 2), o = (l, d, c) => ({
    x: l.x + (d.x - l.x) * c,
    y: l.y + (d.y - l.y) * c
  }), r = e.length;
  for (let l = 0; l < r; l++) {
    const d = e[(l + 1) % r], c = (a = d.radius) != null ? a : t;
    if (c <= 0) {
      l === 0 ? n.moveTo(d.x, d.y) : n.lineTo(d.x, d.y);
      continue;
    }
    const h = e[l], f = e[(l + 2) % r], p = s(h, d);
    let y;
    if (p < 1e-4)
      y = d;
    else {
      const w = Math.min(p / 2, c);
      y = o(
        d,
        h,
        w / p
      );
    }
    const v = s(f, d);
    let x;
    if (v < 1e-4)
      x = d;
    else {
      const w = Math.min(v / 2, c);
      x = o(
        d,
        f,
        w / v
      );
    }
    l === 0 ? n.moveTo(y.x, y.y) : n.lineTo(y.x, y.y), n.quadraticCurveTo(d.x, d.y, x.x, x.y, i);
  }
}
const jJ = new Tt();
class HJ {
  constructor(e) {
    this.shapePrimitives = [], this._currentPoly = null, this._bounds = new Gn(), this._graphicsPath2D = e, this.signed = e.checkForHoles;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    return this.startPoly(e, t), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._ensurePoly();
    const i = this._currentPoly.points, s = i[i.length - 2], o = i[i.length - 1];
    return (s !== e || o !== t) && i.push(e, t), this;
  }
  /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */
  arc(e, t, i, s, o, r) {
    this._ensurePoly(!1);
    const a = this._currentPoly.points;
    return LM(a, e, t, i, s, o, r), this;
  }
  /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */
  arcTo(e, t, i, s, o) {
    this._ensurePoly();
    const r = this._currentPoly.points;
    return LJ(r, e, t, i, s, o), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, i, s, o, r, a) {
    const l = this._currentPoly.points;
    return NJ(
      l,
      this._currentPoly.lastX,
      this._currentPoly.lastY,
      r,
      a,
      e,
      t,
      i,
      s,
      o
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, i, s, o, r, a) {
    this._ensurePoly();
    const l = this._currentPoly;
    return OM(
      this._currentPoly.points,
      l.lastX,
      l.lastY,
      e,
      t,
      i,
      s,
      o,
      r,
      a
    ), this;
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, i, s, o) {
    this._ensurePoly();
    const r = this._currentPoly;
    return DJ(
      this._currentPoly.points,
      r.lastX,
      r.lastY,
      e,
      t,
      i,
      s,
      o
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.endPoly(!0), this;
  }
  /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    this.endPoly(), t && !t.isIdentity() && (e = e.clone(!0), e.transform(t));
    const i = this.shapePrimitives, s = i.length;
    for (let o = 0; o < e.instructions.length; o++) {
      const r = e.instructions[o];
      this[r.action](...r.data);
    }
    if (e.checkForHoles && i.length - s > 1) {
      let o = null;
      for (let r = s; r < i.length; r++) {
        const a = i[r];
        if (a.shape.type === "polygon") {
          const l = a.shape, d = o == null ? void 0 : o.shape;
          d && d.containsPolygon(l) ? (o.holes || (o.holes = []), o.holes.push(a), i.copyWithin(r, r + 1), i.length--, r--) : o = a;
        }
      }
    }
    return this;
  }
  /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */
  finish(e = !1) {
    this.endPoly(e);
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, i, s, o) {
    return this.drawShape(new Tt(e, t, i, s), o), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, i, s) {
    return this.drawShape(new iy(e, t, i), s), this;
  }
  /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  poly(e, t, i) {
    const s = new vc(e);
    return s.closePath = t, this.drawShape(s, i), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, i, s, o = 0, r) {
    s = Math.max(s | 0, 3);
    const a = -1 * Math.PI / 2 + o, l = Math.PI * 2 / s, d = [];
    for (let c = 0; c < s; c++) {
      const h = a - c * l;
      d.push(
        e + i * Math.cos(h),
        t + i * Math.sin(h)
      );
    }
    return this.poly(d, !0, r), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, i, s, o, r = 0, a) {
    if (s = Math.max(s | 0, 3), o <= 0)
      return this.regularPoly(e, t, i, s, r);
    const l = i * Math.sin(Math.PI / s) - 1e-3;
    o = Math.min(o, l);
    const d = -1 * Math.PI / 2 + r, c = Math.PI * 2 / s, h = (s - 2) * Math.PI / s / 2;
    for (let f = 0; f < s; f++) {
      const p = f * c + d, y = e + i * Math.cos(p), v = t + i * Math.sin(p), x = p + Math.PI + h, w = p - Math.PI - h, S = y + o * Math.cos(x), M = v + o * Math.sin(x), _ = y + o * Math.cos(w), T = v + o * Math.sin(w);
      f === 0 ? this.moveTo(S, M) : this.lineTo(S, M), this.quadraticCurveTo(y, v, _, T, a);
    }
    return this.closePath();
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, i = !1, s) {
    return e.length < 3 ? this : (i ? GJ(this, e, t, s) : UJ(this, e, t), this.closePath());
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, i, s, o) {
    if (o === 0)
      return this.rect(e, t, i, s);
    const r = Math.min(i, s) / 2, a = Math.min(r, Math.max(-r, o)), l = e + i, d = t + s, c = a < 0 ? -a : 0, h = Math.abs(a);
    return this.moveTo(e, t + h).arcTo(e + c, t + c, e + h, t, h).lineTo(l - h, t).arcTo(l - c, t + c, l, t + h, h).lineTo(l, d - h).arcTo(l - c, d - c, e + i - h, d, h).lineTo(e + h, d).arcTo(e + c, d - c, e, d - h, h).closePath();
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, i, s, o, r) {
    if (o <= 0)
      return this.rect(e, t, i, s);
    const a = Math.min(o, Math.min(i, s) / 2), l = e + i, d = t + s, c = [
      e + a,
      t,
      l - a,
      t,
      l,
      t + a,
      l,
      d - a,
      l - a,
      d,
      e + a,
      d,
      e,
      d - a,
      e,
      t + a
    ];
    for (let h = c.length - 1; h >= 2; h -= 2)
      c[h] === c[h - 2] && c[h - 1] === c[h - 3] && c.splice(h - 1, 2);
    return this.poly(c, !0, r);
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, i, s, o) {
    return this.drawShape(new sy(e, t, i, s), o), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, i, s, o, r) {
    return this.drawShape(new oy(e, t, i, s, o), r), this;
  }
  /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */
  drawShape(e, t) {
    return this.endPoly(), this.shapePrimitives.push({ shape: e, transform: t }), this;
  }
  /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */
  startPoly(e, t) {
    let i = this._currentPoly;
    return i && this.endPoly(), i = new vc(), i.points.push(e, t), this._currentPoly = i, this;
  }
  /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */
  endPoly(e = !1) {
    const t = this._currentPoly;
    return t && t.points.length > 2 && (t.closePath = e, this.shapePrimitives.push({ shape: t })), this._currentPoly = null, this;
  }
  _ensurePoly(e = !0) {
    if (!this._currentPoly && (this._currentPoly = new vc(), e)) {
      const t = this.shapePrimitives[this.shapePrimitives.length - 1];
      if (t) {
        let i = t.shape.x, s = t.shape.y;
        if (t.transform && !t.transform.isIdentity()) {
          const o = t.transform, r = i;
          i = o.a * i + o.c * s + o.tx, s = o.b * r + o.d * s + o.ty;
        }
        this._currentPoly.points.push(i, s);
      } else
        this._currentPoly.points.push(0, 0);
    }
  }
  /** Builds the path. */
  buildPath() {
    const e = this._graphicsPath2D;
    this.shapePrimitives.length = 0, this._currentPoly = null;
    for (let t = 0; t < e.instructions.length; t++) {
      const i = e.instructions[t];
      this[i.action](...i.data);
    }
    this.finish();
  }
  /** Gets the bounds of the path. */
  get bounds() {
    const e = this._bounds;
    e.clear();
    const t = this.shapePrimitives;
    for (let i = 0; i < t.length; i++) {
      const s = t[i], o = s.shape.getBounds(jJ);
      s.transform ? e.addRect(o, s.transform) : e.addRect(o);
    }
    return e;
  }
}
class to {
  /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */
  constructor(e, t = !1) {
    var i;
    this.instructions = [], this.uid = Nt("graphicsPath"), this._dirty = !0, this.checkForHoles = t, typeof e == "string" ? IX(e, this) : this.instructions = (i = e == null ? void 0 : e.slice()) != null ? i : [];
  }
  /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */
  get shapePath() {
    return this._shapePath || (this._shapePath = new HJ(this)), this._dirty && (this._dirty = !1, this._shapePath.buildPath()), this._shapePath;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    return e = e.clone(), this.instructions.push({ action: "addPath", data: [e, t] }), this._dirty = !0, this;
  }
  arc(...e) {
    return this.instructions.push({ action: "arc", data: e }), this._dirty = !0, this;
  }
  arcTo(...e) {
    return this.instructions.push({ action: "arcTo", data: e }), this._dirty = !0, this;
  }
  arcToSvg(...e) {
    return this.instructions.push({ action: "arcToSvg", data: e }), this._dirty = !0, this;
  }
  bezierCurveTo(...e) {
    return this.instructions.push({ action: "bezierCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveToShort(e, t, i, s, o) {
    const r = this.instructions[this.instructions.length - 1], a = this.getLastPoint(Wt.shared);
    let l = 0, d = 0;
    if (!r || r.action !== "bezierCurveTo")
      l = a.x, d = a.y;
    else {
      l = r.data[2], d = r.data[3];
      const c = a.x, h = a.y;
      l = c + (c - l), d = h + (h - d);
    }
    return this.instructions.push({ action: "bezierCurveTo", data: [l, d, e, t, i, s, o] }), this._dirty = !0, this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.instructions.push({ action: "closePath", data: [] }), this._dirty = !0, this;
  }
  ellipse(...e) {
    return this.instructions.push({ action: "ellipse", data: e }), this._dirty = !0, this;
  }
  lineTo(...e) {
    return this.instructions.push({ action: "lineTo", data: e }), this._dirty = !0, this;
  }
  moveTo(...e) {
    return this.instructions.push({ action: "moveTo", data: e }), this;
  }
  quadraticCurveTo(...e) {
    return this.instructions.push({ action: "quadraticCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveToShort(e, t, i) {
    const s = this.instructions[this.instructions.length - 1], o = this.getLastPoint(Wt.shared);
    let r = 0, a = 0;
    if (!s || s.action !== "quadraticCurveTo")
      r = o.x, a = o.y;
    else {
      r = s.data[0], a = s.data[1];
      const l = o.x, d = o.y;
      r = l + (l - r), a = d + (d - a);
    }
    return this.instructions.push({ action: "quadraticCurveTo", data: [r, a, e, t, i] }), this._dirty = !0, this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, i, s, o) {
    return this.instructions.push({ action: "rect", data: [e, t, i, s, o] }), this._dirty = !0, this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, i, s) {
    return this.instructions.push({ action: "circle", data: [e, t, i, s] }), this._dirty = !0, this;
  }
  roundRect(...e) {
    return this.instructions.push({ action: "roundRect", data: e }), this._dirty = !0, this;
  }
  poly(...e) {
    return this.instructions.push({ action: "poly", data: e }), this._dirty = !0, this;
  }
  regularPoly(...e) {
    return this.instructions.push({ action: "regularPoly", data: e }), this._dirty = !0, this;
  }
  roundPoly(...e) {
    return this.instructions.push({ action: "roundPoly", data: e }), this._dirty = !0, this;
  }
  roundShape(...e) {
    return this.instructions.push({ action: "roundShape", data: e }), this._dirty = !0, this;
  }
  filletRect(...e) {
    return this.instructions.push({ action: "filletRect", data: e }), this._dirty = !0, this;
  }
  chamferRect(...e) {
    return this.instructions.push({ action: "chamferRect", data: e }), this._dirty = !0, this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  // eslint-disable-next-line max-len
  star(e, t, i, s, o, r, a) {
    o || (o = s / 2);
    const l = -1 * Math.PI / 2 + r, d = i * 2, c = Math.PI * 2 / d, h = [];
    for (let f = 0; f < d; f++) {
      const p = f % 2 ? o : s, y = f * c + l;
      h.push(
        e + p * Math.cos(y),
        t + p * Math.sin(y)
      );
    }
    return this.poly(h, !0, a), this;
  }
  /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */
  clone(e = !1) {
    const t = new to();
    if (t.checkForHoles = this.checkForHoles, !e)
      t.instructions = this.instructions.slice();
    else
      for (let i = 0; i < this.instructions.length; i++) {
        const s = this.instructions[i];
        t.instructions.push({ action: s.action, data: s.data.slice() });
      }
    return t;
  }
  clear() {
    return this.instructions.length = 0, this._dirty = !0, this;
  }
  /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */
  transform(e) {
    if (e.isIdentity()) return this;
    const t = e.a, i = e.b, s = e.c, o = e.d, r = e.tx, a = e.ty;
    let l = 0, d = 0, c = 0, h = 0, f = 0, p = 0, y = 0, v = 0;
    for (let x = 0; x < this.instructions.length; x++) {
      const w = this.instructions[x], S = w.data;
      switch (w.action) {
        case "moveTo":
        case "lineTo":
          l = S[0], d = S[1], S[0] = t * l + s * d + r, S[1] = i * l + o * d + a;
          break;
        case "bezierCurveTo":
          c = S[0], h = S[1], f = S[2], p = S[3], l = S[4], d = S[5], S[0] = t * c + s * h + r, S[1] = i * c + o * h + a, S[2] = t * f + s * p + r, S[3] = i * f + o * p + a, S[4] = t * l + s * d + r, S[5] = i * l + o * d + a;
          break;
        case "quadraticCurveTo":
          c = S[0], h = S[1], l = S[2], d = S[3], S[0] = t * c + s * h + r, S[1] = i * c + o * h + a, S[2] = t * l + s * d + r, S[3] = i * l + o * d + a;
          break;
        case "arcToSvg":
          l = S[5], d = S[6], y = S[0], v = S[1], S[0] = t * y + s * v, S[1] = i * y + o * v, S[5] = t * l + s * d + r, S[6] = i * l + o * d + a;
          break;
        case "circle":
          S[4] = Pa(S[3], e);
          break;
        case "rect":
          S[4] = Pa(S[4], e);
          break;
        case "ellipse":
          S[8] = Pa(S[8], e);
          break;
        case "roundRect":
          S[5] = Pa(S[5], e);
          break;
        case "addPath":
          S[0].transform(e);
          break;
        case "poly":
          S[2] = Pa(S[2], e);
          break;
        case "regularPoly":
        case "chamferRect":
          S[5] = Pa(S[5], e);
          break;
        case "closePath":
          break;
        default:
          dt("unknown transform action", w.action);
          break;
      }
    }
    return this._dirty = !0, this;
  }
  get bounds() {
    return this.shapePath.bounds;
  }
  /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */
  getLastPoint(e) {
    let t = this.instructions.length - 1, i = this.instructions[t];
    if (!i)
      return e.x = 0, e.y = 0, e;
    for (; i.action === "closePath"; ) {
      if (t--, t < 0)
        return e.x = 0, e.y = 0, e;
      i = this.instructions[t];
    }
    switch (i.action) {
      case "moveTo":
      case "lineTo":
        e.x = i.data[0], e.y = i.data[1];
        break;
      case "quadraticCurveTo":
        e.x = i.data[2], e.y = i.data[3];
        break;
      case "bezierCurveTo":
        e.x = i.data[4], e.y = i.data[5];
        break;
      case "arc":
      case "arcToSvg":
        e.x = i.data[5], e.y = i.data[6];
        break;
      case "addPath":
        i.data[0].getLastPoint(e);
        break;
    }
    return e;
  }
}
function Pa(n, e) {
  return n ? n.prepend(e) : e.clone();
}
function In(n, e, t) {
  const i = n.getAttribute(e);
  return i ? Number(i) : t;
}
function VJ(n, e) {
  const t = n.querySelectorAll("defs");
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    for (let o = 0; o < s.children.length; o++) {
      const r = s.children[o];
      switch (r.nodeName.toLowerCase()) {
        case "lineargradient":
          e.defs[r.id] = WJ(r);
          break;
        case "radialgradient":
          e.defs[r.id] = qJ(r);
          break;
      }
    }
  }
}
function qi(n, e, t) {
  const i = n.getAttribute(e);
  if (i != null && i.trim().endsWith("%")) {
    const s = Number(i.trim().slice(0, -1));
    return Number.isNaN(s) ? t : s / 100;
  }
  return In(n, e, t);
}
function BM(n) {
  return (n.getAttribute("gradientUnits") || "objectBoundingBox") === "objectBoundingBox" ? "local" : "global";
}
function FM(n) {
  const e = [];
  for (let t = 0; t < n.children.length; t++) {
    const i = n.children[t], s = qi(i, "offset", 0), o = vn.shared.setValue(i.getAttribute("stop-color")).toNumber();
    e.push({ offset: s, color: o });
  }
  return e;
}
function WJ(n) {
  const e = qi(n, "x1", 0), t = qi(n, "y1", 0), i = qi(n, "x2", 1), s = qi(n, "y2", 0);
  return new Jl({
    type: "linear",
    start: { x: e, y: t },
    end: { x: i, y: s },
    textureSpace: BM(n),
    colorStops: FM(n)
  });
}
function qJ(n) {
  const e = qi(n, "cx", 0.5), t = qi(n, "cy", 0.5), i = qi(n, "r", 0.5), s = qi(n, "fx", e), o = qi(n, "fy", t), r = qi(n, "fr", 0);
  return new Jl({
    type: "radial",
    center: { x: s, y: o },
    innerRadius: r,
    outerCenter: { x: e, y: t },
    outerRadius: i,
    textureSpace: BM(n),
    colorStops: FM(n)
  });
}
function k2(n) {
  const e = n.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
  return e ? e[1] : "";
}
const _2 = {
  // Fill properties
  fill: { type: "paint", default: 0 },
  // Fill color/gradient
  "fill-opacity": { type: "number", default: 1 },
  // Fill transparency
  // Stroke properties
  stroke: { type: "paint", default: 0 },
  // Stroke color/gradient
  "stroke-width": { type: "number", default: 1 },
  // Width of stroke
  "stroke-opacity": { type: "number", default: 1 },
  // Stroke transparency
  "stroke-linecap": { type: "string", default: "butt" },
  // End cap style: butt, round, square
  "stroke-linejoin": { type: "string", default: "miter" },
  // Join style: miter, round, bevel
  "stroke-miterlimit": { type: "number", default: 10 },
  // Limit on miter join sharpness
  "stroke-dasharray": { type: "string", default: "none" },
  // Dash pattern
  "stroke-dashoffset": { type: "number", default: 0 },
  // Offset for dash pattern
  // Global properties
  opacity: { type: "number", default: 1 }
  // Overall opacity
};
function NM(n, e) {
  const t = n.getAttribute("style"), i = {}, s = {}, o = {
    strokeStyle: i,
    fillStyle: s,
    useFill: !1,
    useStroke: !1
  };
  for (const r in _2) {
    const a = n.getAttribute(r);
    a && S2(e, o, r, a.trim());
  }
  if (t) {
    const r = t.split(";");
    for (let a = 0; a < r.length; a++) {
      const l = r[a].trim(), [d, c] = l.split(":");
      _2[d] && S2(e, o, d, c.trim());
    }
  }
  return {
    strokeStyle: o.useStroke ? i : null,
    fillStyle: o.useFill ? s : null,
    useFill: o.useFill,
    useStroke: o.useStroke
  };
}
function S2(n, e, t, i) {
  switch (t) {
    case "stroke":
      if (i !== "none") {
        if (i.startsWith("url(")) {
          const s = k2(i);
          e.strokeStyle.fill = n.defs[s];
        } else
          e.strokeStyle.color = vn.shared.setValue(i).toNumber();
        e.useStroke = !0;
      }
      break;
    case "stroke-width":
      e.strokeStyle.width = Number(i);
      break;
    case "fill":
      if (i !== "none") {
        if (i.startsWith("url(")) {
          const s = k2(i);
          e.fillStyle.fill = n.defs[s];
        } else
          e.fillStyle.color = vn.shared.setValue(i).toNumber();
        e.useFill = !0;
      }
      break;
    case "fill-opacity":
      e.fillStyle.alpha = Number(i);
      break;
    case "stroke-opacity":
      e.strokeStyle.alpha = Number(i);
      break;
    case "opacity":
      e.fillStyle.alpha = Number(i), e.strokeStyle.alpha = Number(i);
      break;
  }
}
function KJ(n) {
  if (n.length <= 2)
    return !0;
  const e = n.map((a) => a.area).sort((a, l) => l - a), [t, i] = e, s = e[e.length - 1], o = t / i, r = i / s;
  return !(o > 3 && r < 2);
}
function YJ(n) {
  return n.split(/(?=[Mm])/).filter((i) => i.trim().length > 0);
}
function XJ(n) {
  const e = n.match(/[-+]?[0-9]*\.?[0-9]+/g);
  if (!e || e.length < 4) return 0;
  const t = e.map(Number), i = [], s = [];
  for (let c = 0; c < t.length; c += 2)
    c + 1 < t.length && (i.push(t[c]), s.push(t[c + 1]));
  if (i.length === 0 || s.length === 0) return 0;
  const o = Math.min(...i), r = Math.max(...i), a = Math.min(...s), l = Math.max(...s);
  return (r - o) * (l - a);
}
function M2(n, e) {
  const t = new to(n, !1);
  for (const i of t.instructions)
    e.instructions.push(i);
}
function JJ(n, e) {
  if (typeof n == "string") {
    const r = document.createElement("div");
    r.innerHTML = n.trim(), n = r.querySelector("svg");
  }
  const t = {
    context: e,
    defs: {},
    path: new to()
  };
  VJ(n, t);
  const i = n.children, { fillStyle: s, strokeStyle: o } = NM(n, t);
  for (let r = 0; r < i.length; r++) {
    const a = i[r];
    a.nodeName.toLowerCase() !== "defs" && UM(a, t, s, o);
  }
  return e;
}
function UM(n, e, t, i) {
  const s = n.children, { fillStyle: o, strokeStyle: r } = NM(n, e);
  o && t ? t = { ...t, ...o } : o && (t = o), r && i ? i = { ...i, ...r } : r && (i = r);
  const a = !t && !i;
  a && (t = { color: 0 });
  let l, d, c, h, f, p, y, v, x, w, S, M, _, T, k, P, A;
  switch (n.nodeName.toLowerCase()) {
    case "path": {
      T = n.getAttribute("d");
      const R = n.getAttribute("fill-rule"), D = YJ(T), O = R === "evenodd", F = D.length > 1;
      if (O && F) {
        const ee = D.map((L) => ({
          path: L,
          area: XJ(L)
        }));
        if (ee.sort((L, N) => N.area - L.area), D.length > 3 || !KJ(ee))
          for (let L = 0; L < ee.length; L++) {
            const N = ee[L], K = L === 0;
            e.context.beginPath();
            const B = new to(void 0, !0);
            M2(N.path, B), e.context.path(B), K ? (t && e.context.fill(t), i && e.context.stroke(i)) : e.context.cut();
          }
        else
          for (let L = 0; L < ee.length; L++) {
            const N = ee[L], K = L % 2 === 1;
            e.context.beginPath();
            const B = new to(void 0, !0);
            M2(N.path, B), e.context.path(B), K ? e.context.cut() : (t && e.context.fill(t), i && e.context.stroke(i));
          }
      } else {
        const ee = R ? R === "evenodd" : !0;
        k = new to(T, ee), e.context.path(k), t && e.context.fill(t), i && e.context.stroke(i);
      }
      break;
    }
    case "circle":
      y = In(n, "cx", 0), v = In(n, "cy", 0), x = In(n, "r", 0), e.context.ellipse(y, v, x, x), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "rect":
      l = In(n, "x", 0), d = In(n, "y", 0), P = In(n, "width", 0), A = In(n, "height", 0), w = In(n, "rx", 0), S = In(n, "ry", 0), w || S ? e.context.roundRect(l, d, P, A, w || S) : e.context.rect(l, d, P, A), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "ellipse":
      y = In(n, "cx", 0), v = In(n, "cy", 0), w = In(n, "rx", 0), S = In(n, "ry", 0), e.context.beginPath(), e.context.ellipse(y, v, w, S), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "line":
      c = In(n, "x1", 0), h = In(n, "y1", 0), f = In(n, "x2", 0), p = In(n, "y2", 0), e.context.beginPath(), e.context.moveTo(c, h), e.context.lineTo(f, p), i && e.context.stroke(i);
      break;
    case "polygon":
      _ = n.getAttribute("points"), M = _.match(/-?\d+/g).map((R) => parseInt(R, 10)), e.context.poly(M, !0), t && e.context.fill(t), i && e.context.stroke(i);
      break;
    case "polyline":
      _ = n.getAttribute("points"), M = _.match(/-?\d+/g).map((R) => parseInt(R, 10)), e.context.poly(M, !1), i && e.context.stroke(i);
      break;
    // Group elements - just process children
    case "g":
    case "svg":
      break;
    default: {
      dt(`[SVG parser] <${n.nodeName}> elements unsupported`);
      break;
    }
  }
  a && (t = null);
  for (let R = 0; R < s.length; R++)
    UM(s[R], e, t, i);
}
function ZJ(n) {
  return n.texture !== void 0;
}
const T2 = {
  repeat: {
    addressModeU: "repeat",
    addressModeV: "repeat"
  },
  "repeat-x": {
    addressModeU: "repeat",
    addressModeV: "clamp-to-edge"
  },
  "repeat-y": {
    addressModeU: "clamp-to-edge",
    addressModeV: "repeat"
  },
  "no-repeat": {
    addressModeU: "clamp-to-edge",
    addressModeV: "clamp-to-edge"
  }
};
class GM {
  constructor(e, t) {
    var o;
    this.uid = Nt("fillPattern"), this._tick = 0, this.transform = new ot();
    const i = ZJ(e) ? e : { texture: e, repetition: t };
    this.texture = i.texture, this.textureSpace = (o = i.textureSpace) != null ? o : "global";
    const s = i.repetition;
    s && (this.texture.source.style.addressModeU = T2[s].addressModeU, this.texture.source.style.addressModeV = T2[s].addressModeV);
  }
  /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */
  setTransform(e) {
    if (e) {
      if (this.transform.equals(e)) return;
      this.transform.copyFrom(e);
    } else {
      if (this.transform.isIdentity()) return;
      this.transform.identity();
    }
    this._tick++;
  }
  /** Internal texture used to render the gradient */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    this._texture !== e && (this._texture = e, this._tick++);
  }
  /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */
  get styleKey() {
    return `fill-pattern-${this.uid}-${this._tick}`;
  }
  /** Destroys the fill pattern, releasing resources. This will also destroy the internal texture. */
  destroy() {
    this.texture.destroy(!0), this.texture = null;
  }
}
function QJ(n) {
  return vn.isColorLike(n);
}
function C2(n) {
  return n instanceof GM;
}
function I2(n) {
  return n instanceof Jl;
}
function eZ(n) {
  return n instanceof et;
}
function tZ(n, e, t) {
  const i = vn.shared.setValue(e != null ? e : 0);
  return n.color = i.toNumber(), n.alpha = i.alpha === 1 ? t.alpha : i.alpha, n.texture = et.WHITE, { ...t, ...n };
}
function nZ(n, e, t) {
  return n.texture = e, { ...t, ...n };
}
function A2(n, e, t) {
  return n.fill = e, n.color = 16777215, n.texture = e.texture, n.matrix = e.transform, n.textureSpace = e.textureSpace, { ...t, ...n };
}
function P2(n, e, t) {
  return e.buildGradient(), n.fill = e, n.color = 16777215, n.texture = e.texture, n.matrix = e.transform, n.textureSpace = e.textureSpace, { ...t, ...n };
}
function iZ(n, e) {
  const t = { ...e, ...n }, i = vn.shared.setValue(t.color);
  return t.alpha *= i.alpha, t.color = i.toNumber(), t;
}
function Yd(n, e) {
  if (n == null)
    return null;
  const t = {}, i = n;
  return QJ(n) ? tZ(t, n, e) : eZ(n) ? nZ(t, n, e) : C2(n) ? A2(t, n, e) : I2(n) ? P2(t, n, e) : i.fill && C2(i.fill) ? A2(i, i.fill, e) : i.fill && I2(i.fill) ? P2(i, i.fill, e) : iZ(i, e);
}
function E2(n, e) {
  const { width: t, alignment: i, miterLimit: s, cap: o, join: r, pixelLine: a, ...l } = e, d = Yd(n, l);
  return d ? {
    width: t,
    alignment: i,
    miterLimit: s,
    cap: o,
    join: r,
    pixelLine: a,
    ...d
  } : null;
}
function sZ(n, e) {
  let t = 1;
  const i = n.shapePath.shapePrimitives;
  for (let s = 0; s < i.length; s++) {
    const o = i[s].shape;
    if (o.type !== "polygon") continue;
    const r = o.points, a = r.length;
    if (a < 6) continue;
    const l = o.closePath;
    for (let d = 0; d < a; d += 2) {
      if (!l && (d === 0 || d === a - 2)) continue;
      const c = (d - 2 + a) % a, h = (d + 2) % a, f = r[c], p = r[c + 1], y = r[d], v = r[d + 1], x = r[h], w = r[h + 1], S = f - y, M = p - v, _ = x - y, T = w - v, k = S * S + M * M, P = _ * _ + T * T;
      if (k < 1e-12 || P < 1e-12) continue;
      let D = (S * _ + M * T) / Math.sqrt(k * P);
      D < -1 ? D = -1 : D > 1 && (D = 1);
      const O = Math.sqrt((1 - D) * 0.5);
      if (O < 1e-6) continue;
      const F = Math.min(1 / O, e);
      F > t && (t = F);
    }
  }
  return t;
}
const oZ = new Wt(), R2 = new ot(), by = class ps extends bi {
  constructor() {
    super(...arguments), this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this.uid = Nt("graphicsContext"), this.dirty = !0, this.batchMode = "auto", this.instructions = [], this.destroyed = !1, this._activePath = new to(), this._transform = new ot(), this._fillStyle = { ...ps.defaultFillStyle }, this._strokeStyle = { ...ps.defaultStrokeStyle }, this._stateStack = [], this._tick = 0, this._bounds = new Gn(), this._boundsDirty = !0;
  }
  /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */
  clone() {
    const e = new ps();
    return e.batchMode = this.batchMode, e.instructions = this.instructions.slice(), e._activePath = this._activePath.clone(), e._transform = this._transform.clone(), e._fillStyle = { ...this._fillStyle }, e._strokeStyle = { ...this._strokeStyle }, e._stateStack = this._stateStack.slice(), e._bounds = this._bounds.clone(), e._boundsDirty = !0, e;
  }
  /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */
  get fillStyle() {
    return this._fillStyle;
  }
  set fillStyle(e) {
    this._fillStyle = Yd(e, ps.defaultFillStyle);
  }
  /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */
  get strokeStyle() {
    return this._strokeStyle;
  }
  set strokeStyle(e) {
    this._strokeStyle = E2(e, ps.defaultStrokeStyle);
  }
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(e) {
    return this._fillStyle = Yd(e, ps.defaultFillStyle), this;
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(e) {
    return this._strokeStyle = Yd(e, ps.defaultStrokeStyle), this;
  }
  texture(e, t, i, s, o, r) {
    return this.instructions.push({
      action: "texture",
      data: {
        image: e,
        dx: i || 0,
        dy: s || 0,
        dw: o || e.frame.width,
        dh: r || e.frame.height,
        transform: this._transform.clone(),
        alpha: this._fillStyle.alpha,
        style: t || t === 0 ? vn.shared.setValue(t).toNumber() : 16777215
      }
    }), this.onUpdate(), this;
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    return this._activePath = new to(), this;
  }
  fill(e, t) {
    let i;
    const s = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && (s == null ? void 0 : s.action) === "stroke" ? i = s.data.path : i = this._activePath.clone(), i ? (e != null && (t !== void 0 && typeof e == "number" && (rt(dn, "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead"), e = { color: e, alpha: t }), this._fillStyle = Yd(e, ps.defaultFillStyle)), this.instructions.push({
      action: "fill",
      // TODO copy fill style!
      data: { style: this.fillStyle, path: i }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  _initNextPathLocation() {
    const { x: e, y: t } = this._activePath.getLastPoint(Wt.shared);
    this._activePath.clear(), this._activePath.moveTo(e, t);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(e) {
    let t;
    const i = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && (i == null ? void 0 : i.action) === "fill" ? t = i.data.path : t = this._activePath.clone(), t ? (e != null && (this._strokeStyle = E2(e, ps.defaultStrokeStyle)), this.instructions.push({
      action: "stroke",
      // TODO copy fill style!
      data: { style: this.strokeStyle, path: t }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  cut() {
    for (let e = 0; e < 2; e++) {
      const t = this.instructions[this.instructions.length - 1 - e], i = this._activePath.clone();
      if (t && (t.action === "stroke" || t.action === "fill"))
        if (t.data.hole)
          t.data.hole.addPath(i);
        else {
          t.data.hole = i;
          break;
        }
    }
    return this._initNextPathLocation(), this;
  }
  /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arc(e, t, i, s, o, r) {
    this._tick++;
    const a = this._transform;
    return this._activePath.arc(
      a.a * e + a.c * t + a.tx,
      a.b * e + a.d * t + a.ty,
      i,
      s,
      o,
      r
    ), this;
  }
  /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arcTo(e, t, i, s, o) {
    this._tick++;
    const r = this._transform;
    return this._activePath.arcTo(
      r.a * e + r.c * t + r.tx,
      r.b * e + r.d * t + r.ty,
      r.a * i + r.c * s + r.tx,
      r.b * i + r.d * s + r.ty,
      o
    ), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, i, s, o, r, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.arcToSvg(
      e,
      t,
      i,
      // should we rotate this with transform??
      s,
      o,
      l.a * r + l.c * a + l.tx,
      l.b * r + l.d * a + l.ty
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, i, s, o, r, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.bezierCurveTo(
      l.a * e + l.c * t + l.tx,
      l.b * e + l.d * t + l.ty,
      l.a * i + l.c * s + l.tx,
      l.b * i + l.d * s + l.ty,
      l.a * o + l.c * r + l.tx,
      l.b * o + l.d * r + l.ty,
      a
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    var e;
    return this._tick++, (e = this._activePath) == null || e.closePath(), this;
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, i, s) {
    return this._tick++, this._activePath.ellipse(e, t, i, s, this._transform.clone()), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, i) {
    return this._tick++, this._activePath.circle(e, t, i, this._transform.clone()), this;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */
  path(e) {
    return this._tick++, this._activePath.addPath(e, this._transform.clone()), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._tick++;
    const i = this._transform;
    return this._activePath.lineTo(
      i.a * e + i.c * t + i.tx,
      i.b * e + i.d * t + i.ty
    ), this;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    this._tick++;
    const i = this._transform, s = this._activePath.instructions, o = i.a * e + i.c * t + i.tx, r = i.b * e + i.d * t + i.ty;
    return s.length === 1 && s[0].action === "moveTo" ? (s[0].data[0] = o, s[0].data[1] = r, this) : (this._activePath.moveTo(
      o,
      r
    ), this);
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, i, s, o) {
    this._tick++;
    const r = this._transform;
    return this._activePath.quadraticCurveTo(
      r.a * e + r.c * t + r.tx,
      r.b * e + r.d * t + r.ty,
      r.a * i + r.c * s + r.tx,
      r.b * i + r.d * s + r.ty,
      o
    ), this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, i, s) {
    return this._tick++, this._activePath.rect(e, t, i, s, this._transform.clone()), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, i, s, o) {
    return this._tick++, this._activePath.roundRect(e, t, i, s, o, this._transform.clone()), this;
  }
  /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */
  poly(e, t) {
    return this._tick++, this._activePath.poly(e, t, this._transform.clone()), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, i, s, o = 0, r) {
    return this._tick++, this._activePath.regularPoly(e, t, i, s, o, r), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, i, s, o, r) {
    return this._tick++, this._activePath.roundPoly(e, t, i, s, o, r), this;
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, i, s) {
    return this._tick++, this._activePath.roundShape(e, t, i, s), this;
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, i, s, o) {
    return this._tick++, this._activePath.filletRect(e, t, i, s, o), this;
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, i, s, o, r) {
    return this._tick++, this._activePath.chamferRect(e, t, i, s, o, r), this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  star(e, t, i, s, o = 0, r = 0) {
    return this._tick++, this._activePath.star(e, t, i, s, o, r, this._transform.clone()), this;
  }
  /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */
  svg(e) {
    return this._tick++, JJ(e, this), this;
  }
  /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */
  restore() {
    const e = this._stateStack.pop();
    return e && (this._transform = e.transform, this._fillStyle = e.fillStyle, this._strokeStyle = e.strokeStyle), this;
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    return this._stateStack.push({
      transform: this._transform.clone(),
      fillStyle: { ...this._fillStyle },
      strokeStyle: { ...this._strokeStyle }
    }), this;
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this._transform;
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    return this._transform.identity(), this;
  }
  /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  rotate(e) {
    return this._transform.rotate(e), this;
  }
  /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  scale(e, t = e) {
    return this._transform.scale(e, t), this;
  }
  setTransform(e, t, i, s, o, r) {
    return e instanceof ot ? (this._transform.set(e.a, e.b, e.c, e.d, e.tx, e.ty), this) : (this._transform.set(e, t, i, s, o, r), this);
  }
  transform(e, t, i, s, o, r) {
    return e instanceof ot ? (this._transform.append(e), this) : (R2.set(e, t, i, s, o, r), this._transform.append(R2), this);
  }
  /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  translate(e, t = e) {
    return this._transform.translate(e, t), this;
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    return this._activePath.clear(), this.instructions.length = 0, this.resetTransform(), this.onUpdate(), this;
  }
  onUpdate() {
    this._boundsDirty = !0, this.dirty = !0, this.emit("update", this, 16);
  }
  /** The bounds of the graphic shape. */
  get bounds() {
    if (!this._boundsDirty) return this._bounds;
    this._boundsDirty = !1;
    const e = this._bounds;
    e.clear();
    for (let t = 0; t < this.instructions.length; t++) {
      const i = this.instructions[t], s = i.action;
      if (s === "fill") {
        const o = i.data;
        e.addBounds(o.path.bounds);
      } else if (s === "texture") {
        const o = i.data;
        e.addFrame(o.dx, o.dy, o.dx + o.dw, o.dy + o.dh, o.transform);
      }
      if (s === "stroke") {
        const o = i.data, r = o.style.alignment;
        let a = o.style.width * (1 - r);
        o.style.join === "miter" && (a *= sZ(o.path, o.style.miterLimit));
        const l = o.path.bounds;
        e.addFrame(
          l.minX - a,
          l.minY - a,
          l.maxX + a,
          l.maxY + a
        );
      }
    }
    return e.isValid || e.set(0, 0, 0, 0), e;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(e) {
    var s;
    if (!this.bounds.containsPoint(e.x, e.y)) return !1;
    const t = this.instructions;
    let i = !1;
    for (let o = 0; o < t.length; o++) {
      const r = t[o], a = r.data, l = a.path;
      if (!r.action || !l) continue;
      const d = a.style, c = l.shapePath.shapePrimitives;
      for (let h = 0; h < c.length; h++) {
        const f = c[h].shape;
        if (!d || !f) continue;
        const p = c[h].transform, y = p ? p.applyInverse(e, oZ) : e;
        if (r.action === "fill")
          i = f.contains(y.x, y.y);
        else {
          const x = d;
          i = f.strokeContains(y.x, y.y, x.width, x.alignment);
        }
        const v = a.hole;
        if (v) {
          const x = (s = v.shapePath) == null ? void 0 : s.shapePrimitives;
          if (x)
            for (let w = 0; w < x.length; w++)
              x[w].shape.contains(y.x, y.y) && (i = !1);
        }
        if (i)
          return !0;
      }
    }
    return i;
  }
  /** Unloads the GPU data from the graphics context. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */
  destroy(e = !1) {
    if (this.destroyed) return;
    if (this.destroyed = !0, this._stateStack.length = 0, this._transform = null, this.unload(), this.emit("destroy", this), this.removeAllListeners(), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const i = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._fillStyle.texture && (this._fillStyle.fill && "uid" in this._fillStyle.fill ? this._fillStyle.fill.destroy() : this._fillStyle.texture.destroy(i)), this._strokeStyle.texture && (this._strokeStyle.fill && "uid" in this._strokeStyle.fill ? this._strokeStyle.fill.destroy() : this._strokeStyle.texture.destroy(i));
    }
    this._fillStyle = null, this._strokeStyle = null, this.instructions = null, this._activePath = null, this._bounds = null, this._stateStack = null, this.customShader = null, this._transform = null;
  }
};
by.defaultFillStyle = {
  /** The color to use for the fill. */
  color: 16777215,
  /** The alpha value to use for the fill. */
  alpha: 1,
  /** The texture to use for the fill. */
  texture: et.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local"
};
by.defaultStrokeStyle = {
  /** The width of the stroke. */
  width: 1,
  /** The color to use for the stroke. */
  color: 16777215,
  /** The alpha value to use for the stroke. */
  alpha: 1,
  /** The alignment of the stroke. */
  alignment: 0.5,
  /** The miter limit to use. */
  miterLimit: 10,
  /** The line cap style to use. */
  cap: "butt",
  /** The line join style to use. */
  join: "miter",
  /** The texture to use for the fill. */
  texture: et.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local",
  /** If the stroke is a pixel line. */
  pixelLine: !1
};
let yd = by;
class jM {
  /**
   * Constructor for the DOMPipe class.
   * @param renderer - The renderer instance that this DOMPipe will be associated with.
   */
  constructor(e) {
    this._attachedDomElements = [], this._renderer = e, this._renderer.runners.postrender.add(this), this._renderer.runners.init.add(this), this._domElement = document.createElement("div"), this._domElement.style.position = "absolute", this._domElement.style.top = "0", this._domElement.style.left = "0", this._domElement.style.pointerEvents = "none", this._domElement.style.zIndex = "1000";
  }
  /** Initializes the DOMPipe, setting up the main DOM element and adding it to the document body. */
  init() {
    this._canvasObserver = new VS({
      domElement: this._domElement,
      renderer: this._renderer
    });
  }
  /**
   * Adds a renderable DOM container to the list of attached elements.
   * @param domContainer - The DOM container to be added.
   * @param _instructionSet - The instruction set (unused).
   */
  addRenderable(e, t) {
    this._attachedDomElements.includes(e) || this._attachedDomElements.push(e);
  }
  /**
   * Updates a renderable DOM container.
   * @param _domContainer - The DOM container to be updated (unused).
   */
  updateRenderable(e) {
  }
  /**
   * Validates a renderable DOM container.
   * @param _domContainer - The DOM container to be validated (unused).
   * @returns Always returns true as validation is not required.
   */
  validateRenderable(e) {
    return !0;
  }
  /** Handles the post-rendering process, ensuring DOM elements are correctly positioned and visible. */
  postrender() {
    const e = this._attachedDomElements;
    if (e.length === 0) {
      this._domElement.remove();
      return;
    }
    this._canvasObserver.ensureAttached();
    for (let t = 0; t < e.length; t++) {
      const i = e[t], s = i.element;
      if (!i.parent || i.globalDisplayStatus < 7)
        s == null || s.remove(), e.splice(t, 1), t--;
      else {
        this._domElement.contains(s) || (s.style.position = "absolute", s.style.pointerEvents = "auto", this._domElement.appendChild(s));
        const o = i.worldTransform, r = i._anchor, a = i.width * r.x, l = i.height * r.y;
        s.style.transformOrigin = `${a}px ${l}px`, s.style.transform = `matrix(${o.a}, ${o.b}, ${o.c}, ${o.d}, ${o.tx - a}, ${o.ty - l})`, s.style.opacity = i.groupAlpha.toString();
      }
    }
  }
  /** Destroys the DOMPipe, removing all attached DOM elements and cleaning up resources. */
  destroy() {
    var e;
    this._renderer.runners.postrender.remove(this);
    for (let t = 0; t < this._attachedDomElements.length; t++)
      (e = this._attachedDomElements[t].element) == null || e.remove();
    this._attachedDomElements.length = 0, this._domElement.remove(), this._canvasObserver.destroy(), this._renderer = null;
  }
}
jM.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "dom"
};
class rZ {
  constructor() {
    this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /**
   * Initializes the event ticker.
   * @param events - The event system.
   */
  init(e) {
    this.removeTickerListener(), this.events = e, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /** Whether to pause the update checks or not. */
  get pauseUpdate() {
    return this._pauseUpdate;
  }
  set pauseUpdate(e) {
    this._pauseUpdate = e;
  }
  /** Adds the ticker listener. */
  addTickerListener() {
    this._tickerAdded || !this.domElement || (Oi.system.add(this._tickerUpdate, this, Ol.INTERACTION), this._tickerAdded = !0);
  }
  /** Removes the ticker listener. */
  removeTickerListener() {
    this._tickerAdded && (Oi.system.remove(this._tickerUpdate, this), this._tickerAdded = !1);
  }
  /** Sets flag to not fire extra events when the user has already moved there mouse */
  pointerMoved() {
    this._didMove = !0;
  }
  /** Updates the state of interactive objects. */
  _update() {
    if (!this.domElement || this._pauseUpdate)
      return;
    if (this._didMove) {
      this._didMove = !1;
      return;
    }
    const e = this.events._rootPointerEvent;
    this.events.supportsTouchEvents && e.pointerType === "touch" || globalThis.document.dispatchEvent(this.events.supportsPointerEvents ? new PointerEvent("pointermove", {
      clientX: e.clientX,
      clientY: e.clientY,
      pointerType: e.pointerType,
      pointerId: e.pointerId
    }) : new MouseEvent("mousemove", {
      clientX: e.clientX,
      clientY: e.clientY
    }));
  }
  /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link Ticker.system}.
   * @param ticker - The throttled ticker.
   */
  _tickerUpdate(e) {
    this._deltaTime += e.deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this._update());
  }
  /** Destroys the event ticker. */
  destroy() {
    this.removeTickerListener(), this.events = null, this.domElement = null, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
}
const Hs = new rZ();
class xf extends wu {
  constructor() {
    super(...arguments), this.client = new Wt(), this.movement = new Wt(), this.offset = new Wt(), this.global = new Wt(), this.screen = new Wt();
  }
  /** @readonly */
  get clientX() {
    return this.client.x;
  }
  /** @readonly */
  get clientY() {
    return this.client.y;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */
  get x() {
    return this.clientX;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */
  get y() {
    return this.clientY;
  }
  /** @readonly */
  get movementX() {
    return this.movement.x;
  }
  /** @readonly */
  get movementY() {
    return this.movement.y;
  }
  /** @readonly */
  get offsetX() {
    return this.offset.x;
  }
  /** @readonly */
  get offsetY() {
    return this.offset.y;
  }
  /** @readonly */
  get globalX() {
    return this.global.x;
  }
  /** @readonly */
  get globalY() {
    return this.global.y;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.x`.
   * @readonly
   */
  get screenX() {
    return this.screen.x;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.y`.
   * @readonly
   */
  get screenY() {
    return this.screen.y;
  }
  /**
   * Converts global coordinates into container-local coordinates.
   *
   * This method transforms coordinates from world space to a container's local space,
   * useful for precise positioning and hit testing.
   * @param container - The Container to get local coordinates for
   * @param point - Optional Point object to store the result. If not provided, a new Point will be created
   * @param globalPos - Optional custom global coordinates. If not provided, the event's global position is used
   * @returns The local coordinates as a Point object
   * @example
   * ```ts
   * // Basic usage - get local coordinates relative to a container
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Get position relative to the sprite
   *     const localPos = event.getLocalPosition(sprite);
   *     console.log('Local position:', localPos.x, localPos.y);
   * });
   * // Using custom global coordinates
   * const customGlobal = new Point(100, 100);
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Transform custom coordinates
   *     const localPos = event.getLocalPosition(sprite, undefined, customGlobal);
   *     console.log('Custom local position:', localPos.x, localPos.y);
   * });
   * ```
   * @see {@link Container.worldTransform} For the transformation matrix
   * @see {@link Point} For the point class used to store coordinates
   */
  getLocalPosition(e, t, i) {
    return e.worldTransform.applyInverse(i || this.global, t);
  }
  /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */
  getModifierState(e) {
    return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(e);
  }
  /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   * @ignore
   */
  // eslint-disable-next-line max-params
  initMouseEvent(e, t, i, s, o, r, a, l, d, c, h, f, p, y, v) {
    throw new Error("Method not implemented.");
  }
}
class _i extends xf {
  constructor() {
    super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1, this.persistentDeviceId = 0;
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getCoalescedEvents() {
    return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [this] : [];
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getPredictedEvents() {
    throw new Error("getPredictedEvents is not supported!");
  }
}
class Bl extends xf {
  constructor() {
    super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
  }
}
Bl.DOM_DELTA_PIXEL = 0;
Bl.DOM_DELTA_LINE = 1;
Bl.DOM_DELTA_PAGE = 2;
const aZ = 2048, lZ = new Wt(), xd = new Wt();
class dZ {
  /**
   * @param rootTarget - The holder of the event boundary.
   */
  constructor(e) {
    this.dispatch = new bi(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
      trackingData: {}
    }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = e, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mapContextMenu = this.mapContextMenu.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel), this.addEventMapping("contextmenu", this.mapContextMenu);
  }
  /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */
  addEventMapping(e, t) {
    this.mappingTable[e] || (this.mappingTable[e] = []), this.mappingTable[e].push({
      fn: t,
      priority: 0
    }), this.mappingTable[e].sort((i, s) => i.priority - s.priority);
  }
  /**
   * Dispatches the given event
   * @param e - The event to dispatch.
   * @param type - The type of event to dispatch. Defaults to `e.type`.
   */
  dispatchEvent(e, t) {
    e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, t), this.dispatch.emit(t || e.type, e);
  }
  /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e - The event to map.
   */
  mapEvent(e) {
    if (!this.rootTarget)
      return;
    const t = this.mappingTable[e.type];
    if (t)
      for (let i = 0, s = t.length; i < s; i++)
        t[i].fn(e);
    else
      dt(`[EventBoundary]: Event mapping not defined for ${e.type}`);
  }
  /**
   * Finds the Container that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x - The x coordinate of the event.
   * @param y - The y coordinate of the event.
   */
  hitTest(e, t) {
    Hs.pauseUpdate = !0;
    const s = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", o = this[s](
      this.rootTarget,
      this.rootTarget.eventMode,
      lZ.set(e, t),
      this.hitTestFn,
      this.hitPruneFn
    );
    return o && o[0];
  }
  /**
   * Propagate the passed event from from {@link EventBoundary.rootTarget this.rootTarget} to its
   * target `e.target`.
   * @param e - The event to propagate.
   * @param type - The type of event to propagate. Defaults to `e.type`.
   */
  propagate(e, t) {
    if (!e.target)
      return;
    const i = e.composedPath();
    e.eventPhase = e.CAPTURING_PHASE;
    for (let s = 0, o = i.length - 1; s < o; s++)
      if (e.currentTarget = i[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped) return;
    if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, t), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
      e.eventPhase = e.BUBBLING_PHASE;
      for (let s = i.length - 2; s >= 0; s--)
        if (e.currentTarget = i[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped) return;
    }
  }
  /**
   * Emits the event `e` to all interactive containers. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */
  all(e, t, i = this._allInteractiveElements) {
    if (i.length === 0) return;
    e.eventPhase = e.BUBBLING_PHASE;
    const s = Array.isArray(t) ? t : [t];
    for (let o = i.length - 1; o >= 0; o--)
      s.forEach((r) => {
        e.currentTarget = i[o], this.notifyTarget(e, r);
      });
  }
  /**
   * Finds the propagation path from {@link EventBoundary.rootTarget rootTarget} to the passed
   * `target`. The last element in the path is `target`.
   * @param target - The target to find the propagation path to.
   */
  propagationPath(e) {
    const t = [e];
    for (let i = 0; i < aZ && e !== this.rootTarget && e.parent; i++) {
      if (!e.parent)
        throw new Error("Cannot find propagation path to disconnected target");
      t.push(e.parent), e = e.parent;
    }
    return t.reverse(), t;
  }
  hitTestMoveRecursive(e, t, i, s, o, r = !1) {
    let a = !1;
    if (this._interactivePrune(e)) return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && (Hs.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const c = e.children;
      for (let h = c.length - 1; h >= 0; h--) {
        const f = c[h], p = this.hitTestMoveRecursive(
          f,
          this._isInteractive(t) ? t : f.eventMode,
          i,
          s,
          o,
          r || o(e, i)
        );
        if (p) {
          if (p.length > 0 && !p[p.length - 1].parent)
            continue;
          const y = e.isInteractive();
          (p.length > 0 || y) && (y && this._allInteractiveElements.push(e), p.push(e)), this._hitElements.length === 0 && (this._hitElements = p), a = !0;
        }
      }
    }
    const l = this._isInteractive(t), d = e.isInteractive();
    return d && d && this._allInteractiveElements.push(e), r || this._hitElements.length > 0 ? null : a ? this._hitElements : l && !o(e, i) && s(e, i) ? d ? [e] : [] : null;
  }
  /**
   * Recursive implementation for {@link EventBoundary.hitTest hitTest}.
   * @param currentTarget - The Container that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the container.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */
  hitTestRecursive(e, t, i, s, o) {
    if (this._interactivePrune(e) || o(e, i))
      return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && (Hs.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const l = e.children, d = i;
      for (let c = l.length - 1; c >= 0; c--) {
        const h = l[c], f = this.hitTestRecursive(
          h,
          this._isInteractive(t) ? t : h.eventMode,
          d,
          s,
          o
        );
        if (f) {
          if (f.length > 0 && !f[f.length - 1].parent)
            continue;
          const p = e.isInteractive();
          return (f.length > 0 || p) && f.push(e), f;
        }
      }
    }
    const r = this._isInteractive(t), a = e.isInteractive();
    return r && s(e, i) ? a ? [e] : [] : null;
  }
  _isInteractive(e) {
    return e === "static" || e === "dynamic";
  }
  _interactivePrune(e) {
    return !e || !e.visible || !e.renderable || !e.measurable || e.eventMode === "none" || e.eventMode === "passive" && !e.interactiveChildren;
  }
  /**
   * Checks whether the container or any of its children cannot pass the hit test at all.
   *
   * {@link EventBoundary}'s implementation uses the {@link Container.hitArea hitArea}
   * and {@link Container._maskEffect} for pruning.
   * @param container - The container to prune.
   * @param location - The location to test for overlap.
   */
  hitPruneFn(e, t) {
    if (e.hitArea && (e.worldTransform.applyInverse(t, xd), !e.hitArea.contains(xd.x, xd.y)))
      return !0;
    if (e.effects && e.effects.length)
      for (let i = 0; i < e.effects.length; i++) {
        const s = e.effects[i];
        if (s.containsPoint && !s.containsPoint(t, this.hitTestFn))
          return !0;
      }
    return !1;
  }
  /**
   * Checks whether the container passes hit testing for the given location.
   * @param container - The container to test.
   * @param location - The location to test for overlap.
   * @returns - Whether `container` passes hit testing for `location`.
   */
  hitTestFn(e, t) {
    return e.hitArea ? !0 : e != null && e.containsPoint ? (e.worldTransform.applyInverse(t, xd), e.containsPoint(xd)) : !1;
  }
  /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type - The type of event to notify. Defaults to `e.type`.
   */
  notifyTarget(e, t) {
    var o, r;
    if (!e.currentTarget.isInteractive())
      return;
    t != null || (t = e.type);
    const i = `on${t}`;
    (r = (o = e.currentTarget)[i]) == null || r.call(o, e);
    const s = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${t}capture` : t;
    this._notifyListeners(e, s), e.eventPhase === e.AT_TARGET && this._notifyListeners(e, t);
  }
  /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from - The upstream `pointerdown` event.
   */
  mapPointerDown(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.createPointerEvent(e);
    if (this.dispatchEvent(t, "pointerdown"), t.pointerType === "touch")
      this.dispatchEvent(t, "touchstart");
    else if (t.pointerType === "mouse" || t.pointerType === "pen") {
      const s = t.button === 2;
      this.dispatchEvent(t, s ? "rightdown" : "mousedown");
    }
    const i = this.trackingData(e.pointerId);
    i.pressTargetsByButton[e.button] = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */
  mapPointerMove(e) {
    var l, d, c;
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
    const t = this.createPointerEvent(e);
    this._isPointerMoveEvent = !1;
    const i = t.pointerType === "mouse" || t.pointerType === "pen", s = this.trackingData(e.pointerId), o = this.findMountedTarget(s.overTargets);
    if (((l = s.overTargets) == null ? void 0 : l.length) > 0 && o !== t.target) {
      const h = e.type === "mousemove" ? "mouseout" : "pointerout", f = this.createPointerEvent(e, h, o);
      if (this.dispatchEvent(f, "pointerout"), i && this.dispatchEvent(f, "mouseout"), !t.composedPath().includes(o)) {
        const p = this.createPointerEvent(e, "pointerleave", o);
        for (p.eventPhase = p.AT_TARGET; p.target && !t.composedPath().includes(p.target); )
          p.currentTarget = p.target, this.notifyTarget(p), i && this.notifyTarget(p, "mouseleave"), p.target = p.target.parent;
        this.freeEvent(p);
      }
      this.freeEvent(f);
    }
    if (o !== t.target) {
      const h = e.type === "mousemove" ? "mouseover" : "pointerover", f = this.clonePointerEvent(t, h);
      this.dispatchEvent(f, "pointerover"), i && this.dispatchEvent(f, "mouseover");
      let p = o == null ? void 0 : o.parent;
      for (; p && p !== this.rootTarget.parent && p !== t.target; )
        p = p.parent;
      if (!p || p === this.rootTarget.parent) {
        const v = this.clonePointerEvent(t, "pointerenter");
        for (v.eventPhase = v.AT_TARGET; v.target && v.target !== o && v.target !== this.rootTarget.parent; )
          v.currentTarget = v.target, this.notifyTarget(v), i && this.notifyTarget(v, "mouseenter"), v.target = v.target.parent;
        this.freeEvent(v);
      }
      this.freeEvent(f);
    }
    const r = [], a = (d = this.enableGlobalMoveEvents) != null ? d : !0;
    this.moveOnAll ? r.push("pointermove") : this.dispatchEvent(t, "pointermove"), a && r.push("globalpointermove"), t.pointerType === "touch" && (this.moveOnAll ? r.splice(1, 0, "touchmove") : this.dispatchEvent(t, "touchmove"), a && r.push("globaltouchmove")), i && (this.moveOnAll ? r.splice(1, 0, "mousemove") : this.dispatchEvent(t, "mousemove"), a && r.push("globalmousemove"), this.cursor = (c = t.target) == null ? void 0 : c.cursor), r.length > 0 && this.all(t, r), this._allInteractiveElements.length = 0, this._hitElements.length = 0, s.overTargets = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */
  mapPointerOver(e) {
    var r;
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), i = this.createPointerEvent(e), s = i.pointerType === "mouse" || i.pointerType === "pen";
    this.dispatchEvent(i, "pointerover"), s && this.dispatchEvent(i, "mouseover"), i.pointerType === "mouse" && (this.cursor = (r = i.target) == null ? void 0 : r.cursor);
    const o = this.clonePointerEvent(i, "pointerenter");
    for (o.eventPhase = o.AT_TARGET; o.target && o.target !== this.rootTarget.parent; )
      o.currentTarget = o.target, this.notifyTarget(o), s && this.notifyTarget(o, "mouseenter"), o.target = o.target.parent;
    t.overTargets = i.composedPath(), this.freeEvent(i), this.freeEvent(o);
  }
  /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */
  mapPointerOut(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId);
    if (t.overTargets) {
      const i = e.pointerType === "mouse" || e.pointerType === "pen", s = this.findMountedTarget(t.overTargets), o = this.createPointerEvent(e, "pointerout", s);
      this.dispatchEvent(o), i && this.dispatchEvent(o, "mouseout");
      const r = this.createPointerEvent(e, "pointerleave", s);
      for (r.eventPhase = r.AT_TARGET; r.target && r.target !== this.rootTarget.parent; )
        r.currentTarget = r.target, this.notifyTarget(r), i && this.notifyTarget(r, "mouseleave"), r.target = r.target.parent;
      t.overTargets = null, this.freeEvent(o), this.freeEvent(r);
    }
    this.cursor = null;
  }
  /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */
  mapPointerUp(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = performance.now(), i = this.createPointerEvent(e);
    if (this.dispatchEvent(i, "pointerup"), i.pointerType === "touch")
      this.dispatchEvent(i, "touchend");
    else if (i.pointerType === "mouse" || i.pointerType === "pen") {
      const a = i.button === 2;
      this.dispatchEvent(i, a ? "rightup" : "mouseup");
    }
    const s = this.trackingData(e.pointerId), o = this.findMountedTarget(s.pressTargetsByButton[e.button]);
    let r = o;
    if (o && !i.composedPath().includes(o)) {
      let a = o;
      for (; a && !i.composedPath().includes(a); ) {
        if (i.currentTarget = a, this.notifyTarget(i, "pointerupoutside"), i.pointerType === "touch")
          this.notifyTarget(i, "touchendoutside");
        else if (i.pointerType === "mouse" || i.pointerType === "pen") {
          const l = i.button === 2;
          this.notifyTarget(i, l ? "rightupoutside" : "mouseupoutside");
        }
        a = a.parent;
      }
      delete s.pressTargetsByButton[e.button], r = a;
    }
    if (r) {
      const a = this.clonePointerEvent(i, "click");
      a.target = r, a.path = null, s.clicksByButton[e.button] || (s.clicksByButton[e.button] = {
        clickCount: 0,
        target: a.target,
        timeStamp: t
      });
      const l = s.clicksByButton[e.button];
      if (l.target === a.target && t - l.timeStamp < 200 ? ++l.clickCount : l.clickCount = 1, l.target = a.target, l.timeStamp = t, a.detail = l.clickCount, a.pointerType === "mouse") {
        const d = a.button === 2;
        this.dispatchEvent(a, d ? "rightclick" : "click");
      } else a.pointerType === "touch" && this.dispatchEvent(a, "tap");
      this.dispatchEvent(a, "pointertap"), this.freeEvent(a);
    }
    this.freeEvent(i);
  }
  /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */
  mapPointerUpOutside(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), i = this.findMountedTarget(t.pressTargetsByButton[e.button]), s = this.createPointerEvent(e);
    if (i) {
      let o = i;
      for (; o; )
        s.currentTarget = o, this.notifyTarget(s, "pointerupoutside"), s.pointerType === "touch" ? this.notifyTarget(s, "touchendoutside") : (s.pointerType === "mouse" || s.pointerType === "pen") && this.notifyTarget(s, s.button === 2 ? "rightupoutside" : "mouseupoutside"), o = o.parent;
      delete t.pressTargetsByButton[e.button];
    }
    this.freeEvent(s);
  }
  /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */
  mapWheel(e) {
    if (!(e instanceof Bl)) {
      dt("EventBoundary cannot map a non-wheel event as a wheel event");
      return;
    }
    const t = this.createWheelEvent(e);
    this.dispatchEvent(t), this.freeEvent(t);
  }
  /**
   * Maps the upstream `contextmenu` event to a downstream `contextmenu` event.
   * @param from - The upstream `contextmenu` event.
   */
  mapContextMenu(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.createPointerEvent(e);
    this.dispatchEvent(t, "contextmenu"), this.freeEvent(t);
  }
  /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */
  findMountedTarget(e) {
    if (!e)
      return null;
    let t = e[0];
    for (let i = 1; i < e.length && e[i].parent === t; i++)
      t = e[i];
    return t;
  }
  /**
   * Creates an event whose `originalEvent` is `from`, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The `originalEvent` for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */
  createPointerEvent(e, t, i) {
    var o;
    const s = this.allocateEvent(_i);
    return this.copyPointerData(e, s), this.copyMouseData(e, s), this.copyData(e, s), s.nativeEvent = e.nativeEvent, s.originalEvent = e, s.target = (o = i != null ? i : this.hitTest(s.global.x, s.global.y)) != null ? o : this._hitElements[0], typeof t == "string" && (s.type = t), s;
  }
  /**
   * Creates a wheel event whose `originalEvent` is `from`.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */
  createWheelEvent(e) {
    const t = this.allocateEvent(Bl);
    return this.copyWheelData(e, t), this.copyMouseData(e, t), this.copyData(e, t), t.nativeEvent = e.nativeEvent, t.originalEvent = e, t.target = this.hitTest(t.global.x, t.global.y), t;
  }
  /**
   * Clones the event `from`, with an optional `type` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */
  clonePointerEvent(e, t) {
    const i = this.allocateEvent(_i);
    return i.nativeEvent = e.nativeEvent, i.originalEvent = e.originalEvent, this.copyPointerData(e, i), this.copyMouseData(e, i), this.copyData(e, i), i.target = e.target, i.path = e.composedPath().slice(), i.type = t != null ? t : i.type, i;
  }
  /**
   * Copies wheel {@link FederatedWheelEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyWheelData(e, t) {
    t.deltaMode = e.deltaMode, t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ;
  }
  /**
   * Copies pointer {@link FederatedPointerEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyPointerData(e, t) {
    e instanceof _i && t instanceof _i && (t.pointerId = e.pointerId, t.width = e.width, t.height = e.height, t.isPrimary = e.isPrimary, t.pointerType = e.pointerType, t.pressure = e.pressure, t.tangentialPressure = e.tangentialPressure, t.tiltX = e.tiltX, t.tiltY = e.tiltY, t.twist = e.twist, t.persistentDeviceId = e.persistentDeviceId);
  }
  /**
   * Copies mouse {@link FederatedMouseEvent} data from `from` to `to`.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyMouseData(e, t) {
    e instanceof xf && t instanceof xf && (t.altKey = e.altKey, t.button = e.button, t.buttons = e.buttons, t.client.copyFrom(e.client), t.ctrlKey = e.ctrlKey, t.metaKey = e.metaKey, t.movement.copyFrom(e.movement), t.screen.copyFrom(e.screen), t.shiftKey = e.shiftKey, t.global.copyFrom(e.global));
  }
  /**
   * Copies base {@link FederatedEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyData(e, t) {
    t.isTrusted = e.isTrusted, t.srcElement = e.srcElement, t.timeStamp = performance.now(), t.type = e.type, t.detail = e.detail, t.view = e.view, t.which = e.which, t.layer.copyFrom(e.layer), t.page.copyFrom(e.page);
  }
  /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */
  trackingData(e) {
    return this.mappingState.trackingData[e] || (this.mappingState.trackingData[e] = {
      pressTargetsByButton: {},
      clicksByButton: {},
      overTarget: null
    }), this.mappingState.trackingData[e];
  }
  /**
   * Allocate a specific type of event from {@link EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   * @returns An event of the given type.
   */
  allocateEvent(e) {
    this.eventPool.has(e) || this.eventPool.set(e, []);
    const t = this.eventPool.get(e).pop() || new e(this);
    return t.eventPhase = t.NONE, t.currentTarget = null, t.defaultPrevented = !1, t.path = null, t.target = null, t;
  }
  /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */
  freeEvent(e) {
    if (e.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
    const t = e.constructor;
    this.eventPool.has(t) || this.eventPool.set(t, []), this.eventPool.get(t).push(e);
  }
  /**
   * Similar to {@link EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */
  _notifyListeners(e, t) {
    const i = e.currentTarget._events[t];
    if (i)
      if ("fn" in i)
        i.once && e.currentTarget.removeListener(t, i.fn, void 0, !0), i.fn.call(i.context, e);
      else
        for (let s = 0, o = i.length; s < o && !e.propagationImmediatelyStopped; s++)
          i[s].once && e.currentTarget.removeListener(t, i[s].fn, void 0, !0), i[s].fn.call(i[s].context, e);
  }
}
const cZ = 1, uZ = {
  touchstart: "pointerdown",
  touchend: "pointerup",
  touchendoutside: "pointerupoutside",
  touchmove: "pointermove",
  touchcancel: "pointercancel"
}, vy = class u0 {
  /**
   * @param {Renderer} renderer
   */
  constructor(e) {
    this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = e, this.rootBoundary = new dZ(null), Hs.init(this), this.autoPreventDefault = !0, this._eventsAdded = !1, this._rootPointerEvent = new _i(null), this._rootWheelEvent = new Bl(null), this._rootContextMenuEvent = new _i(null), this.cursorStyles = {
      default: "inherit",
      pointer: "pointer"
    }, this.features = new Proxy({ ...u0.defaultEventFeatures }, {
      set: (t, i, s) => (i === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = s), t[i] = s, !0)
    }), this._onPointerDown = this._onPointerDown.bind(this), this._onPointerMove = this._onPointerMove.bind(this), this._onPointerUp = this._onPointerUp.bind(this), this._onPointerOverOut = this._onPointerOverOut.bind(this), this._onContextMenu = this._onContextMenu.bind(this), this.onWheel = this.onWheel.bind(this);
  }
  /**
   * The default interaction mode for all display objects.
   * @see Container.eventMode
   * @type {EventMode}
   * @readonly
   * @since 7.2.0
   */
  static get defaultEventMode() {
    return this._defaultEventMode;
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    var s, o;
    const { canvas: t, resolution: i } = this.renderer;
    this.setTargetElement(t), this.resolution = i, u0._defaultEventMode = (s = e.eventMode) != null ? s : "passive", Object.assign(this.features, (o = e.eventFeatures) != null ? o : {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
  }
  /**
   * Handle changing resolution.
   * @ignore
   */
  resolutionChange(e) {
    this.resolution = e;
  }
  /** Destroys all event listeners and detaches the renderer. */
  destroy() {
    Hs.destroy(), this.setTargetElement(null), this.renderer = null, this._currentCursor = null;
  }
  /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * The cursor can be a CSS cursor string, a custom callback function, or a key from the cursorStyles dictionary.
   * @param mode - Cursor mode to set. Can be:
   * - A CSS cursor string (e.g., 'pointer', 'grab')
   * - A key from the cursorStyles dictionary
   * - null/undefined to reset to default
   * @example
   * ```ts
   * // Using predefined cursor styles
   * app.renderer.events.setCursor('pointer');    // Set standard pointer cursor
   * app.renderer.events.setCursor('grab');       // Set grab cursor
   * app.renderer.events.setCursor(null);         // Reset to default
   *
   * // Using custom cursor styles
   * app.renderer.events.cursorStyles.custom = 'url("cursor.png"), auto';
   * app.renderer.events.setCursor('custom');     // Apply custom cursor
   *
   * // Using callback-based cursor
   * app.renderer.events.cursorStyles.dynamic = (mode) => {
   *     document.body.style.cursor = mode === 'hover' ? 'pointer' : 'default';
   * };
   * app.renderer.events.setCursor('dynamic');    // Trigger cursor callback
   * ```
   * @remarks
   * - Has no effect on OffscreenCanvas except for callback-based cursors
   * - Caches current cursor to avoid unnecessary DOM updates
   * - Supports CSS cursor values, style objects, and callback functions
   * @see {@link EventSystem.cursorStyles} For defining custom cursor styles
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/cursor} MDN Cursor Reference
   */
  setCursor(e) {
    e || (e = "default");
    let t = !0;
    if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (t = !1), this._currentCursor === e)
      return;
    this._currentCursor = e;
    const i = this.cursorStyles[e];
    if (i)
      switch (typeof i) {
        case "string":
          t && (this.domElement.style.cursor = i);
          break;
        case "function":
          i(e);
          break;
        case "object":
          t && Object.assign(this.domElement.style, i);
          break;
      }
    else t && typeof e == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, e) && (this.domElement.style.cursor = e);
  }
  /**
   * The global pointer event instance containing the most recent pointer state.
   * This is useful for accessing pointer information without listening to events.
   * @example
   * ```ts
   * // Access current pointer position at any time
   * const eventSystem = app.renderer.events;
   * const pointer = eventSystem.pointer;
   *
   * // Get global coordinates
   * console.log('Position:', pointer.global.x, pointer.global.y);
   *
   * // Check button state
   * console.log('Buttons pressed:', pointer.buttons);
   *
   * // Get pointer type and pressure
   * console.log('Type:', pointer.pointerType);
   * console.log('Pressure:', pointer.pressure);
   * ```
   * @readonly
   * @since 7.2.0
   * @see {@link FederatedPointerEvent} For all available pointer properties
   */
  get pointer() {
    return this._rootPointerEvent;
  }
  /**
   * Event handler for pointer down events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerDown(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    this.autoPreventDefault && t[0].isNormalized && (e.cancelable || !("cancelable" in e)) && e.preventDefault();
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i], r = this._bootstrapEvent(this._rootPointerEvent, o);
      this.rootBoundary.mapEvent(r);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer move events on on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */
  _onPointerMove(e) {
    if (!this.features.move) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, Hs.pointerMoved();
    const t = this._normalizeToPointerData(e);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = this._bootstrapEvent(this._rootPointerEvent, t[i]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer up events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerUp(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    let t = e.target;
    e.composedPath && e.composedPath().length > 0 && (t = e.composedPath()[0]);
    const i = t !== this.domElement ? "outside" : "", s = this._normalizeToPointerData(e);
    for (let o = 0, r = s.length; o < r; o++) {
      const a = this._bootstrapEvent(this._rootPointerEvent, s[o]);
      a.type += i, this.rootBoundary.mapEvent(a);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer over & out events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerOverOut(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = this._bootstrapEvent(this._rootPointerEvent, t[i]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for `contextmenu` events on {@link EventSystem#domElement this.domElement}.
   *
   * {@link EventSystem#autoPreventDefault autoPreventDefault} does not apply, so the browser menu
   * opens unless a listener calls `preventDefault()`.
   * @param nativeEvent - The native mouse/pointer event.
   */
  _onContextMenu(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    for (let i = 0, s = t.length; i < s; i++) {
      const o = this._bootstrapEvent(this._rootContextMenuEvent, t[i]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Passive handler for `wheel` events on {@link EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */
  onWheel(e) {
    if (!this.features.wheel) return;
    const t = this.normalizeWheelEvent(e);
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(t);
  }
  /**
   * Sets the {@link EventSystem#domElement domElement} and binds event listeners.
   * This method manages the DOM event bindings for the event system, allowing you to
   * change or remove the target element that receives input events.
   * > [!IMPORTANT] This will default to the canvas element of the renderer, so you
   * > should not need to call this unless you are using a custom element.
   * @param element - The new DOM element to bind events to, or null to remove all event bindings
   * @example
   * ```ts
   * // Set a new canvas element as the target
   * const canvas = document.createElement('canvas');
   * app.renderer.events.setTargetElement(canvas);
   *
   * // Remove all event bindings
   * app.renderer.events.setTargetElement(null);
   *
   * // Switch to a different canvas
   * const newCanvas = document.querySelector('#game-canvas');
   * app.renderer.events.setTargetElement(newCanvas);
   * ```
   * @remarks
   * - Automatically removes event listeners from previous element
   * - Required for the event system to function
   * - Safe to call multiple times
   * @see {@link EventSystem#domElement} The current DOM element
   * @see {@link EventsTicker} For the ticker system that tracks pointer movement
   */
  setTargetElement(e) {
    this._removeEvents(), this.domElement = e, Hs.domElement = e, this._addEvents();
  }
  /** Register event listeners on {@link Renderer#domElement this.domElement}. */
  _addEvents() {
    if (this._eventsAdded || !this.domElement)
      return;
    Hs.addTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "none", e.msTouchAction = "none") : this.supportsPointerEvents && (e.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this._onPointerMove, !0), this.domElement.addEventListener("pointerdown", this._onPointerDown, !0), this.domElement.addEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this._onPointerOverOut, !0), globalThis.addEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this._onPointerMove, !0), this.domElement.addEventListener("mousedown", this._onPointerDown, !0), this.domElement.addEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this._onPointerOverOut, !0), globalThis.addEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this._onPointerDown, !0), this.domElement.addEventListener("touchend", this._onPointerUp, !0), this.domElement.addEventListener("touchmove", this._onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
      passive: !0,
      capture: !0
    }), this.domElement.addEventListener("contextmenu", this._onContextMenu, !0), this._eventsAdded = !0;
  }
  /** Unregister event listeners on {@link EventSystem#domElement this.domElement}. */
  _removeEvents() {
    if (!this._eventsAdded || !this.domElement)
      return;
    Hs.removeTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "", e.msTouchAction = "") : this.supportsPointerEvents && (e.touchAction = "")), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this._onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this._onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this._onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this._onPointerMove, !0), this.domElement.removeEventListener("mousedown", this._onPointerDown, !0), this.domElement.removeEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this._onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this._onPointerDown, !0), this.domElement.removeEventListener("touchend", this._onPointerUp, !0), this.domElement.removeEventListener("touchmove", this._onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement.removeEventListener("contextmenu", this._onContextMenu, !0), this.domElement = null, this._eventsAdded = !1;
  }
  /**
   * Maps coordinates from DOM/screen space into PixiJS normalized coordinates.
   * This takes into account the current scale, position, and resolution of the DOM element.
   * @param point - The point to store the mapped coordinates in
   * @param x - The x coordinate in DOM/client space
   * @param y - The y coordinate in DOM/client space
   * @example
   * ```ts
   * // Map mouse coordinates to PixiJS space
   * const point = new Point();
   * app.renderer.events.mapPositionToPoint(
   *     point,
   *     event.clientX,
   *     event.clientY
   * );
   * console.log('Mapped position:', point.x, point.y);
   *
   * // Using with pointer events
   * sprite.on('pointermove', (event) => {
   *     // event.global already contains mapped coordinates
   *     console.log('Global:', event.global.x, event.global.y);
   *
   *     // Map to local coordinates
   *     const local = event.getLocalPosition(sprite);
   *     console.log('Local:', local.x, local.y);
   * });
   * ```
   * @remarks
   * - Accounts for element scaling and positioning
   * - Adjusts for device pixel ratio/resolution
   */
  mapPositionToPoint(e, t, i) {
    const s = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
      width: this.domElement.width,
      height: this.domElement.height,
      left: 0,
      top: 0
    }, o = 1 / this.resolution;
    e.x = (t - s.left) * (this.domElement.width / s.width) * o, e.y = (i - s.top) * (this.domElement.height / s.height) * o;
  }
  /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */
  _normalizeToPointerData(e) {
    var i, s, o, r;
    const t = [];
    if (this.supportsTouchEvents && e instanceof TouchEvent)
      for (let a = 0, l = e.changedTouches.length; a < l; a++) {
        const d = e.changedTouches[a];
        typeof d.button == "undefined" && (d.button = 0), typeof d.buttons == "undefined" && (d.buttons = 1), typeof d.isPrimary == "undefined" && (d.isPrimary = e.touches.length === 1 && e.type === "touchstart"), typeof d.width == "undefined" && (d.width = d.radiusX || 1), typeof d.height == "undefined" && (d.height = d.radiusY || 1), typeof d.tiltX == "undefined" && (d.tiltX = 0), typeof d.tiltY == "undefined" && (d.tiltY = 0), typeof d.pointerType == "undefined" && (d.pointerType = "touch"), typeof d.pointerId == "undefined" && (d.pointerId = d.identifier || 0), typeof d.pressure == "undefined" && (d.pressure = d.force || 0.5), typeof d.twist == "undefined" && (d.twist = 0), typeof d.tangentialPressure == "undefined" && (d.tangentialPressure = 0), typeof d.layerX == "undefined" && (d.layerX = d.offsetX = d.clientX), typeof d.layerY == "undefined" && (d.layerY = d.offsetY = d.clientY), d.isNormalized = !0, d.type = e.type, (i = d.altKey) != null || (d.altKey = e.altKey), (s = d.ctrlKey) != null || (d.ctrlKey = e.ctrlKey), (o = d.metaKey) != null || (d.metaKey = e.metaKey), (r = d.shiftKey) != null || (d.shiftKey = e.shiftKey), t.push(d);
      }
    else if (!globalThis.MouseEvent || e instanceof MouseEvent && (!this.supportsPointerEvents || !(e instanceof globalThis.PointerEvent))) {
      const a = e;
      typeof a.isPrimary == "undefined" && (a.isPrimary = !0), typeof a.width == "undefined" && (a.width = 1), typeof a.height == "undefined" && (a.height = 1), typeof a.tiltX == "undefined" && (a.tiltX = 0), typeof a.tiltY == "undefined" && (a.tiltY = 0), typeof a.pointerType == "undefined" && (a.pointerType = "mouse"), typeof a.pointerId == "undefined" && (a.pointerId = cZ), typeof a.pressure == "undefined" && (a.pressure = 0.5), typeof a.twist == "undefined" && (a.twist = 0), typeof a.tangentialPressure == "undefined" && (a.tangentialPressure = 0), a.isNormalized = !0, t.push(a);
    } else
      t.push(e);
    return t;
  }
  /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */
  normalizeWheelEvent(e) {
    const t = this._rootWheelEvent;
    return this._transferMouseData(t, e), t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ, t.deltaMode = e.deltaMode, this.mapPositionToPoint(t.screen, e.clientX, e.clientY), t.global.copyFrom(t.screen), t.offset.copyFrom(t.screen), t.nativeEvent = e, t.type = e.type, t;
  }
  /**
   * Normalizes the `nativeEvent` into a federateed {@link FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */
  _bootstrapEvent(e, t) {
    return e.originalEvent = null, e.nativeEvent = t, e.pointerId = t.pointerId, e.width = t.width, e.height = t.height, e.isPrimary = t.isPrimary, e.pointerType = t.pointerType, e.pressure = t.pressure, e.tangentialPressure = t.tangentialPressure, e.tiltX = t.tiltX, e.tiltY = t.tiltY, e.twist = t.twist, this._transferMouseData(e, t), this.mapPositionToPoint(e.screen, t.clientX, t.clientY), e.global.copyFrom(e.screen), e.offset.copyFrom(e.screen), e.isTrusted = t.isTrusted, e.type === "pointerleave" && (e.type = "pointerout"), e.type.startsWith("mouse") && (e.type = e.type.replace("mouse", "pointer")), e.type.startsWith("touch") && (e.type = uZ[e.type] || e.type), e;
  }
  /**
   * Transfers base & mouse event data from the `nativeEvent` to the federated event.
   * @param event
   * @param nativeEvent
   */
  _transferMouseData(e, t) {
    e.isTrusted = t.isTrusted, e.srcElement = t.srcElement, e.timeStamp = performance.now(), e.type = t.type, e.altKey = t.altKey, e.button = t.button, e.buttons = t.buttons, e.client.x = t.clientX, e.client.y = t.clientY, e.ctrlKey = t.ctrlKey, e.metaKey = t.metaKey, e.movement.x = t.movementX, e.movement.y = t.movementY, e.page.x = t.pageX, e.page.y = t.pageY, e.relatedTarget = null, e.shiftKey = t.shiftKey;
  }
};
vy.extension = {
  name: "events",
  type: [
    Ae.WebGLSystem,
    Ae.CanvasSystem,
    Ae.WebGPUSystem
  ],
  priority: -1
};
vy.defaultEventFeatures = {
  /** Enables pointer events associated with pointer movement. */
  move: !0,
  /** Enables global pointer move events. */
  globalMove: !0,
  /** Enables pointer events associated with clicking. */
  click: !0,
  /** Enables wheel events. */
  wheel: !0
};
let HM = vy;
const hZ = {
  onclick: null,
  oncontextmenu: null,
  onmousedown: null,
  onmouseenter: null,
  onmouseleave: null,
  onmousemove: null,
  onglobalmousemove: null,
  onmouseout: null,
  onmouseover: null,
  onmouseup: null,
  onmouseupoutside: null,
  onpointercancel: null,
  onpointerdown: null,
  onpointerenter: null,
  onpointerleave: null,
  onpointermove: null,
  onglobalpointermove: null,
  onpointerout: null,
  onpointerover: null,
  onpointertap: null,
  onpointerup: null,
  onpointerupoutside: null,
  onrightclick: null,
  onrightdown: null,
  onrightup: null,
  onrightupoutside: null,
  ontap: null,
  ontouchcancel: null,
  ontouchend: null,
  ontouchendoutside: null,
  ontouchmove: null,
  onglobaltouchmove: null,
  ontouchstart: null,
  onwheel: null,
  get interactive() {
    return this.eventMode === "dynamic" || this.eventMode === "static";
  },
  set interactive(n) {
    this.eventMode = n ? "static" : "passive";
  },
  _internalEventMode: void 0,
  get eventMode() {
    var n;
    return (n = this._internalEventMode) != null ? n : HM.defaultEventMode;
  },
  set eventMode(n) {
    this._internalEventMode = n;
  },
  isInteractive() {
    return this.eventMode === "static" || this.eventMode === "dynamic";
  },
  interactiveChildren: !0,
  hitArea: null,
  addEventListener(n, e, t) {
    const i = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof t == "object" ? t.signal : void 0, o = typeof t == "object" ? t.once === !0 : !1, r = typeof e == "function" ? void 0 : e;
    n = i ? `${n}capture` : n;
    const a = typeof e == "function" ? e : e.handleEvent, l = this;
    s && s.addEventListener("abort", () => {
      l.off(n, a, r);
    }), o ? l.once(n, a, r) : l.on(n, a, r);
  },
  removeEventListener(n, e, t) {
    const i = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof e == "function" ? void 0 : e;
    n = i ? `${n}capture` : n, e = typeof e == "function" ? e : e.handleEvent, this.off(n, e, s);
  },
  dispatchEvent(n) {
    if (!(n instanceof wu))
      throw new Error("Container cannot propagate events outside of the Federated Events API");
    return n.defaultPrevented = !1, n.path = null, n.target = this, n.manager.dispatchEvent(n), !n.defaultPrevented;
  }
};
let Ea;
function z2(n) {
  const e = zt.get().createCanvas(6, 1), t = e.getContext("2d");
  return t.fillStyle = n, t.fillRect(0, 0, 6, 1), e;
}
function VM() {
  if (Ea !== void 0)
    return Ea;
  try {
    const n = z2("#ff00ff"), e = z2("#ffff00"), i = zt.get().createCanvas(6, 1).getContext("2d");
    i.globalCompositeOperation = "multiply", i.drawImage(n, 0, 0), i.drawImage(e, 2, 0);
    const s = i.getImageData(2, 0, 1, 1);
    if (!s)
      Ea = !1;
    else {
      const o = s.data;
      Ea = o[0] === 255 && o[1] === 0 && o[2] === 0;
    }
  } catch {
    Ea = !1;
  }
  return Ea;
}
const St = {
  canvas: null,
  convertTintToImage: !1,
  cacheStepsPerColorChannel: 8,
  canUseMultiply: VM(),
  tintMethod: null,
  _canvasSourceCache: /* @__PURE__ */ new WeakMap(),
  _unpremultipliedCache: /* @__PURE__ */ new WeakMap(),
  getCanvasSource: (n) => {
    var a, l;
    const e = n.source, t = e == null ? void 0 : e.resource;
    if (!t)
      return null;
    const i = e.alphaMode === "premultiplied-alpha", s = (a = e.resourceWidth) != null ? a : e.pixelWidth, o = (l = e.resourceHeight) != null ? l : e.pixelHeight, r = s !== e.pixelWidth || o !== e.pixelHeight;
    if (i) {
      if ((t instanceof HTMLCanvasElement || typeof OffscreenCanvas != "undefined" && t instanceof OffscreenCanvas) && !r)
        return t;
      const d = St._unpremultipliedCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
    }
    if (t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int8Array || t instanceof Uint16Array || t instanceof Int16Array || t instanceof Uint32Array || t instanceof Int32Array || t instanceof Float32Array || t instanceof ArrayBuffer) {
      const d = St._canvasSourceCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
      const c = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), h = c.getContext("2d"), f = h.createImageData(e.pixelWidth, e.pixelHeight), p = f.data, y = t instanceof ArrayBuffer ? new Uint8Array(t) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
      if (e.format === "bgra8unorm")
        for (let v = 0; v < p.length && v + 3 < y.length; v += 4)
          p[v] = y[v + 2], p[v + 1] = y[v + 1], p[v + 2] = y[v], p[v + 3] = y[v + 3];
      else
        p.set(y.subarray(0, p.length));
      return h.putImageData(f, 0, 0), St._canvasSourceCache.set(e, { canvas: c, resourceId: e._resourceId }), c;
    }
    if (i) {
      const d = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), c = d.getContext("2d", { willReadFrequently: !0 });
      d.width = e.pixelWidth, d.height = e.pixelHeight, c.drawImage(t, 0, 0);
      const h = c.getImageData(0, 0, d.width, d.height), f = h.data;
      for (let p = 0; p < f.length; p += 4) {
        const y = f[p + 3];
        if (y > 0) {
          const v = 255 / y;
          f[p] = Math.min(255, f[p] * v + 0.5), f[p + 1] = Math.min(255, f[p + 1] * v + 0.5), f[p + 2] = Math.min(255, f[p + 2] * v + 0.5);
        }
      }
      return c.putImageData(h, 0, 0), St._unpremultipliedCache.set(e, { canvas: d, resourceId: e._resourceId }), d;
    }
    if (r) {
      const d = St._canvasSourceCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
      const c = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), h = c.getContext("2d");
      return c.width = e.pixelWidth, c.height = e.pixelHeight, h.drawImage(t, 0, 0), St._canvasSourceCache.set(e, { canvas: c, resourceId: e._resourceId }), c;
    }
    return t;
  },
  getTintedCanvas: (n, e) => {
    const t = n.texture, i = vn.shared.setValue(e).toHex(), s = t.tintCache || (t.tintCache = {}), o = s[i], r = t.source._resourceId;
    if ((o == null ? void 0 : o.tintId) === r)
      return o;
    const a = o && "getContext" in o ? o : zt.get().createCanvas();
    return St.tintMethod(t, e, a), a.tintId = r, s[i] = a, s[i];
  },
  getTintedPattern: (n, e) => {
    const t = vn.shared.setValue(e).toHex(), i = n.patternCache || (n.patternCache = {}), s = n.source._resourceId;
    let o = i[t];
    return (o == null ? void 0 : o.tintId) === s || (St.canvas || (St.canvas = zt.get().createCanvas()), St.tintMethod(n, e, St.canvas), o = St.canvas.getContext("2d").createPattern(St.canvas, "repeat"), o.tintId = s, i[t] = o), o;
  },
  /**
   * Applies a transform to a CanvasPattern.
   * @param pattern - The pattern to apply the transform to.
   * @param matrix - The matrix to apply.
   * @param matrix.a
   * @param matrix.b
   * @param matrix.c
   * @param matrix.d
   * @param matrix.tx
   * @param matrix.ty
   * @param invert
   */
  applyPatternTransform: (n, e, t = !0) => {
    if (!e) return;
    const i = n;
    if (!i.setTransform) return;
    const s = globalThis.DOMMatrix;
    if (!s) return;
    const o = new s([e.a, e.b, e.c, e.d, e.tx, e.ty]);
    i.setTransform(t ? o.inverse() : o);
  },
  tintWithMultiply: (n, e, t) => {
    var h, f;
    const i = t.getContext("2d"), s = n.frame.clone(), o = (f = (h = n.source._resolution) != null ? h : n.source.resolution) != null ? f : 1, r = n.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = Mt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), i.save(), e !== 16777215 && (i.fillStyle = vn.shared.setValue(e).toHex(), i.fillRect(0, 0, l, d), i.globalCompositeOperation = "multiply");
    const c = St.getCanvasSource(n);
    if (!c) {
      i.restore();
      return;
    }
    r && St._applyInverseRotation(i, r, s.width, s.height), i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), e !== 16777215 && (i.globalCompositeOperation = "destination-atop", i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    )), i.restore();
  },
  tintWithOverlay: (n, e, t) => {
    var h, f;
    const i = t.getContext("2d"), s = n.frame.clone(), o = (f = (h = n.source._resolution) != null ? h : n.source.resolution) != null ? f : 1, r = n.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = Mt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), i.save(), i.globalCompositeOperation = "copy", i.fillStyle = vn.shared.setValue(e).toHex(), i.fillRect(0, 0, l, d), i.globalCompositeOperation = "destination-atop";
    const c = St.getCanvasSource(n);
    if (!c) {
      i.restore();
      return;
    }
    r && St._applyInverseRotation(i, r, s.width, s.height), i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), i.restore();
  },
  tintWithPerPixel: (n, e, t) => {
    var x, w;
    const i = t.getContext("2d"), s = n.frame.clone(), o = (w = (x = n.source._resolution) != null ? x : n.source.resolution) != null ? w : 1, r = n.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = Mt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), i.save(), i.globalCompositeOperation = "copy";
    const c = St.getCanvasSource(n);
    if (!c) {
      i.restore();
      return;
    }
    r && St._applyInverseRotation(i, r, s.width, s.height), i.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), i.restore();
    const h = e >> 16 & 255, f = e >> 8 & 255, p = e & 255, y = i.getImageData(0, 0, l, d), v = y.data;
    for (let S = 0; S < v.length; S += 4)
      v[S] = v[S] * h / 255, v[S + 1] = v[S + 1] * f / 255, v[S + 2] = v[S + 2] * p / 255;
    i.putImageData(y, 0, 0);
  },
  /**
   * Applies inverse rotation transform to context for texture packer rotation compensation.
   * Supports all 16 groupD8 symmetries (rotations and reflections).
   * @param context - Canvas 2D context
   * @param rotate - The groupD8 rotation value
   * @param srcWidth - Source crop width (before rotation)
   * @param srcHeight - Source crop height (before rotation)
   */
  _applyInverseRotation: (n, e, t, i) => {
    const s = Mt.inv(e), o = Mt.uX(s), r = Mt.uY(s), a = Mt.vX(s), l = Mt.vY(s), d = -Math.min(0, o * t, a * i, o * t + a * i), c = -Math.min(0, r * t, l * i, r * t + l * i);
    n.transform(o, r, a, l, d, c);
  }
};
St.tintMethod = St.canUseMultiply ? St.tintWithMultiply : St.tintWithPerPixel;
const qg = 32767;
function $2(n, e) {
  return (n << 17) + (e << 2);
}
class pZ {
  constructor(e) {
    this._buckets = /* @__PURE__ */ new Map(), this._screens = new PS(), this._enableFullScreen = !1, this.canvasOptions = e || {};
  }
  /**
   * Has no effect. The pool sizes canvases to the screens registered with
   * {@link CanvasPoolClass#setScreenSize|setScreenSize}.
   * @deprecated since 8.21.0
   */
  get enableFullScreen() {
    return rt(js, "CanvasPool.enableFullScreen is no longer used, the pool sizes canvases to the screens registered with setScreenSize."), this._enableFullScreen;
  }
  set enableFullScreen(e) {
    rt(js, "CanvasPool.enableFullScreen is no longer used, the pool sizes canvases to the screens registered with setScreenSize."), this._enableFullScreen = e;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */
  _createCanvasAndContext(e, t) {
    const i = zt.get().createCanvas();
    i.width = e, i.height = t;
    const s = i.getContext("2d");
    return { canvas: i, context: s };
  }
  /**
   * Gets a Power-of-Two canvas or screen sized canvas
   * @param minWidth - The minimum width of the canvas.
   * @param minHeight - The minimum height of the canvas.
   * @param resolution - The resolution of the canvas.
   * @returns The new canvas and its context.
   */
  getOptimalCanvasAndContext(e, t, i = 1) {
    const { width: s, height: o } = this.getOptimalSize(e, t, i);
    (s > qg || o > qg) && dt(`CanvasPool: ${s}x${o} is larger than the ${qg}px pool key limit, canvases of this size may be pooled together`);
    const r = $2(s, o);
    let a = this._buckets.get(r);
    a || (a = [], this._buckets.set(r, a));
    let l = a.pop();
    return l || (l = this._createCanvasAndContext(s, o)), l;
  }
  /**
   * The backing size, in physical pixels, that
   * {@link CanvasPoolClass#getOptimalCanvasAndContext|getOptimalCanvasAndContext} would allocate for a request,
   * without taking a canvas from the pool.
   *
   * Each axis is the next power of two, or the smallest registered screen the request fits inside
   * (see {@link CanvasPoolClass#setScreenSize|setScreenSize}).
   * @param minWidth - The minimum width of the canvas.
   * @param minHeight - The minimum height of the canvas.
   * @param resolution - The resolution of the canvas.
   * @returns The width and height the pooled canvas would have, in physical pixels.
   */
  getOptimalSize(e, t, i = 1) {
    const s = Math.ceil(e * i - 1e-6), o = Math.ceil(t * i - 1e-6), r = hf(s), a = this._screens.getFittingWidth(s), l = hf(o), d = this._screens.getFittingHeight(o);
    return {
      width: a !== void 0 ? Math.min(a, r) : r,
      height: d !== void 0 ? Math.min(d, l) : l
    };
  }
  /**
   * Place a canvas back into the pool.
   * @param canvasAndContext
   */
  returnCanvasAndContext(e) {
    const t = e.canvas, { width: i, height: s } = t, o = this._buckets.get($2(i, s));
    o && (e.context.resetTransform(), e.context.clearRect(0, 0, i, s), o.push(e));
  }
  /**
   * Registers the screen size of a renderer with the pool, in physical pixels.
   *
   * While a screen is registered, a request that fits inside it on an axis is given that screen's size on
   * that axis instead of the next power of two, which stops a full screen canvas from being allocated far
   * larger than the screen. Requests larger than every registered screen on an axis keep the power of two
   * size - the pool never rounds a request up to a screen it does not fit in.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   */
  setScreenSize(e, t, i) {
    this._screens.set(e, t, i) && this._pruneScreenCanvases();
  }
  /**
   * Removes a screen previously registered with
   * {@link CanvasPoolClass#setScreenSize|setScreenSize}, dropping any idle canvases that were
   * only being kept for it.
   * @param rendererUid - The uid the screen was registered with.
   */
  removeScreen(e) {
    this._screens.remove(e) && this._pruneScreenCanvases();
  }
  /** Clears the pool. */
  clear() {
    this._buckets.clear();
  }
  /**
   * Drops the idle canvases in every bucket that has a non power of two dimension matching no live
   * screen. Power of two buckets are always kept, as any request can fall back to them.
   */
  _pruneScreenCanvases() {
    for (const [e] of this._buckets) {
      const t = e >>> 17, i = e >>> 2 & 32767;
      ($l(t) || this._screens.hasWidth(t)) && ($l(i) || this._screens.hasHeight(i)) || this._buckets.delete(e);
    }
  }
}
const Fl = new pZ();
Yl.register(Fl);
const D2 = new ot();
function WM(n, e) {
  var i;
  e.clear();
  const t = e.matrix;
  for (let s = 0; s < n.length; s++) {
    const o = n[s];
    if (o.globalDisplayStatus < 7)
      continue;
    const r = (i = o.renderGroup) != null ? i : o.parentRenderGroup;
    r != null && r.isCachedAsTexture ? e.matrix = D2.copyFrom(r.textureOffsetInverseTransform).append(o.worldTransform) : r != null && r._parentCacheAsTextureRenderGroup ? e.matrix = D2.copyFrom(r._parentCacheAsTextureRenderGroup.inverseWorldTransform).append(o.groupTransform) : e.matrix = o.worldTransform, e.addBounds(o.bounds);
  }
  return e.matrix = t, e;
}
const fZ = new Gn();
function mZ(n, e, t, i, s = !1, o) {
  const r = fZ;
  r.minX = 0, r.minY = 0, r.maxX = n.width / i | 0, r.maxY = n.height / i | 0;
  const a = Nn.getOptimalTexture({
    width: r.width,
    height: r.height,
    resolution: i,
    autoGenerateMipmaps: s,
    scaleMode: o
  });
  return a.source.uploadMethodId = "image", a.source.resource = n, a.source.alphaMode = "premultiply-alpha-on-upload", a.frame.width = e / i, a.frame.height = t / i, a.source.emit("update", a.source), a.updateUvs(), a;
}
function O2(n) {
  return typeof n.getCanvasFilterString == "function";
}
class gZ {
  constructor() {
    this.skip = !1, this.useClip = !1, this.filters = null, this.container = null, this.bounds = new Gn(), this.cssFilterString = "";
  }
}
class qM {
  /**
   * @param renderer - The Canvas renderer
   * @param renderer.canvasContext
   * @param renderer.canvasContext.activeContext
   * @param renderer.canvasContext.activeResolution
   */
  constructor(e) {
    this._filterStack = [], this._filterStackIndex = 0, this._savedStates = [], this._alphaMultiplier = 1, this._warnedFilterTypes = /* @__PURE__ */ new Set(), this.renderer = e;
  }
  /**
   * Push a filter instruction onto the stack.
   * Called when entering a filtered container.
   * @param instruction - The filter instruction from FilterPipe
   */
  push(e) {
    const t = this._pushFilterFrame(), i = e.filterEffect.filters;
    if (t.skip = !1, t.useClip = !1, t.filters = i, t.container = e.container, t.cssFilterString = "", i.every((l) => !l.enabled)) {
      t.skip = !0;
      return;
    }
    const s = [], o = 1;
    for (const l of i) {
      if (!l.enabled) continue;
      if (!O2(l)) {
        this._warnUnsupportedFilter(l);
        continue;
      }
      const d = l.getCanvasFilterString();
      if (d === null) {
        this._warnUnsupportedFilter(l);
        continue;
      }
      d && s.push(d);
    }
    if (s.length === 0 && o === 1) {
      t.skip = !0;
      return;
    }
    t.cssFilterString = s.join(" "), this._calculateFilterArea(e, t.bounds), t.useClip = !!e.filterEffect.filterArea;
    const r = this.renderer.canvasContext.activeContext, a = r.filter || "none";
    if (this._savedStates.push({ filter: a, alphaMultiplier: this._alphaMultiplier }), t.useClip && Number.isFinite(t.bounds.width) && Number.isFinite(t.bounds.height) && t.bounds.width > 0 && t.bounds.height > 0) {
      const l = this.renderer.canvasContext.activeResolution || 1;
      r.save(), r.setTransform(1, 0, 0, 1, 0, 0), r.beginPath(), r.rect(
        t.bounds.x * l,
        t.bounds.y * l,
        t.bounds.width * l,
        t.bounds.height * l
      ), r.clip();
    } else
      t.useClip = !1;
    t.cssFilterString && (r.filter = a !== "none" ? `${a} ${t.cssFilterString}` : t.cssFilterString);
  }
  /** Pop a filter from the stack. Called when exiting a filtered container. */
  pop() {
    const e = this._popFilterFrame();
    if (e.skip)
      return;
    const t = this._savedStates.pop();
    if (!t)
      return;
    const i = this.renderer.canvasContext.activeContext;
    e.useClip ? i.restore() : i.filter = t.filter, this._alphaMultiplier = t.alphaMultiplier;
  }
  /**
   * Applies supported filters to a texture and returns a new texture.
   * Unsupported filters are skipped with a warn-once message.
   * @param params - The parameters for applying filters.
   * @param params.texture
   * @param params.filters
   * @returns The resulting texture after filters are applied.
   */
  generateFilteredTexture({ texture: e, filters: t }) {
    var w, S;
    if (!(t != null && t.length) || t.every((M) => !M.enabled))
      return e;
    const i = [], s = 1;
    for (const M of t) {
      if (!M.enabled) continue;
      if (!O2(M)) {
        this._warnUnsupportedFilter(M);
        continue;
      }
      const _ = M.getCanvasFilterString();
      if (_ === null) {
        this._warnUnsupportedFilter(M);
        continue;
      }
      _ && i.push(_);
    }
    if (i.length === 0 && s === 1)
      return e;
    const o = St.getCanvasSource(e);
    if (!o)
      return e;
    const r = e.frame, a = (S = (w = e.source._resolution) != null ? w : e.source.resolution) != null ? S : 1, l = r.width, d = r.height, c = Fl.getOptimalCanvasAndContext(l, d, a), { canvas: h, context: f } = c;
    f.setTransform(1, 0, 0, 1, 0, 0), f.clearRect(0, 0, h.width, h.height), i.length && (f.filter = i.join(" "));
    const p = r.x * a, y = r.y * a, v = l * a, x = d * a;
    return f.drawImage(
      o,
      p,
      y,
      v,
      x,
      0,
      0,
      v,
      x
    ), f.filter = "none", f.globalAlpha = 1, mZ(h, l, d, a);
  }
  /**
   * Calculate the filter area bounds.
   * @param instruction - Filter instruction
   * @param bounds - Bounds object to populate
   */
  _calculateFilterArea(e, t) {
    if (e.renderables ? WM(e.renderables, t) : e.filterEffect.filterArea ? (t.clear(), t.addRect(e.filterEffect.filterArea), t.applyMatrix(e.container.worldTransform)) : e.container.getFastGlobalBounds(!0, t), e.container) {
      const i = e.container.renderGroup || e.container.parentRenderGroup, s = i == null ? void 0 : i.cacheToLocalTransform;
      s && t.applyMatrix(s);
    }
  }
  _warnUnsupportedFilter(e) {
    var i;
    const t = ((i = e == null ? void 0 : e.constructor) == null ? void 0 : i.name) || "Filter";
    this._warnedFilterTypes.has(t) || (this._warnedFilterTypes.add(t), console.warn(
      `CanvasRenderer: filter "${t}" is not supported in Canvas2D and will be skipped.`
    ));
  }
  get alphaMultiplier() {
    return this._alphaMultiplier;
  }
  _pushFilterFrame() {
    let e = this._filterStack[this._filterStackIndex];
    return e || (e = this._filterStack[this._filterStackIndex] = new gZ()), this._filterStackIndex++, e;
  }
  _popFilterFrame() {
    return this._filterStackIndex <= 0 ? this._filterStack[0] : (this._filterStackIndex--, this._filterStack[this._filterStackIndex]);
  }
  /** Destroys the system */
  destroy() {
    this._filterStack = null, this._savedStates = null, this._warnedFilterTypes = null, this._alphaMultiplier = 1;
  }
}
qM.extension = {
  type: [Ae.CanvasSystem],
  name: "filter"
};
var bZ = `in vec2 aPosition;
out vec2 vTextureCoord;

uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;

vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`, vZ = `in vec2 vTextureCoord;
out vec4 finalColor;
uniform sampler2D uTexture;
void main() {
    finalColor = texture(uTexture, vTextureCoord);
}
`, L2 = `struct GlobalFilterUniforms {
  uInputSize: vec4<f32>,
  uInputPixel: vec4<f32>,
  uInputClamp: vec4<f32>,
  uOutputFrame: vec4<f32>,
  uGlobalFrame: vec4<f32>,
  uOutputTexture: vec4<f32>,
};

@group(0) @binding(0) var <uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler: sampler;

struct VSOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) uv: vec2<f32>
};

fn filterVertexPosition(aPosition: vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0 * gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord(aPosition: vec2<f32>) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

@vertex
fn mainVertex(
  @location(0) aPosition: vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
) -> @location(0) vec4<f32> {
    return textureSample(uTexture, uSampler, uv);
}
`;
class yZ extends tM {
  constructor() {
    const e = va.from({
      vertex: { source: L2, entryPoint: "mainVertex" },
      fragment: { source: L2, entryPoint: "mainFragment" },
      name: "passthrough-filter"
    }), t = Xl.from({
      vertex: bZ,
      fragment: vZ,
      name: "passthrough-filter"
    });
    super({
      gpuProgram: e,
      glProgram: t
    });
  }
}
class KM {
  constructor(e) {
    this._renderer = e;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "filter",
      canBundle: !1,
      action: "pushFilter",
      container: t,
      filterEffect: e
    });
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  execute(e) {
    e.action === "pushFilter" ? this._renderer.filter.push(e) : e.action === "popFilter" && this._renderer.filter.pop();
  }
  destroy() {
    this._renderer = null;
  }
}
KM.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "filter"
};
const xZ = new bm({
  attributes: {
    aPosition: {
      buffer: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      format: "float32x2",
      stride: 8,
      offset: 0
    }
  },
  indexBuffer: new Uint32Array([0, 1, 2, 0, 2, 3])
});
class wZ {
  constructor() {
    this.skip = !1, this.inputTexture = null, this.backTexture = null, this.filters = null, this.bounds = new Gn(), this.container = null, this.blendRequired = !1, this.outputRenderSurface = null, this.firstEnabledIndex = -1, this.lastEnabledIndex = -1;
  }
}
class YM {
  constructor(e) {
    this._filterStackIndex = 0, this._filterStack = [], this._filterGlobalUniforms = new Ts({
      uInputSize: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputPixel: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputClamp: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uGlobalFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputTexture: { value: new Float32Array(4), type: "vec4<f32>" }
    }), this._globalFilterBindGroup = new qo({}), this.renderer = e;
  }
  /**
   * The back texture of the currently active filter. Requires the filter to have `blendRequired` set to true.
   * @readonly
   */
  get activeBackTexture() {
    var e;
    return (e = this._activeFilterData) == null ? void 0 : e.backTexture;
  }
  /**
   * Pushes a filter instruction onto the filter stack.
   * @param instruction - The instruction containing the filter effect and container.
   * @internal
   */
  push(e) {
    const t = this.renderer, i = e.filterEffect.filters, s = this._pushFilterData();
    s.skip = !1, s.filters = i, s.container = e.container, s.outputRenderSurface = t.renderTarget.renderSurface;
    const o = t.renderTarget.renderTarget.colorTexture.source, r = o.resolution, a = o.antialias;
    if (i.every((c) => !c.enabled)) {
      s.skip = !0;
      return;
    }
    const l = s.bounds;
    if (this._calculateFilterArea(e, l), this._calculateFilterBounds(s, t.renderTarget.rootViewPort, a, r, 1), s.skip)
      return;
    const d = this._getPreviousFilterData();
    this._setupFilterTextures(s, l, t, d);
  }
  /**
   * Applies filters to a texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture.
   * @param {object} params - The parameters for applying filters.
   * @param {Texture} params.texture - The texture to apply filters to.
   * @param {Filter[]} params.filters - The filters to apply.
   * @returns {Texture} The resulting texture after all filters have been applied.
   * @example
   *
   * ```ts
   * // Create a texture and a list of filters
   * const texture = new Texture(...);
   * const filters = [new BlurFilter(), new ColorMatrixFilter()];
   *
   * // Apply the filters to the texture
   * const resultTexture = renderer.filter.generateFilteredTexture({ texture, filters });
   *
   * // Use the resulting texture
   * sprite.texture = resultTexture;
   * ```
   *
   * Key Points:
   * 1. padding is not currently supported here - so clipping may occur with filters that use padding.
   * 2. If all filters are disabled or skipped, the original texture is returned.
   */
  generateFilteredTexture({ texture: e, filters: t }) {
    if (t.every((c) => !c.enabled))
      return e;
    const i = this._pushFilterData();
    this._activeFilterData = i, i.skip = !1, i.filters = t;
    const s = e.source, o = s.resolution, r = s.antialias, a = i.bounds;
    if (a.clear(), a.addRect(e.frame), this._calculateFilterBounds(i, a.rectangle, r, o, 0), i.skip)
      return this._popFilterData(), e;
    i.outputRenderSurface = Nn.getOptimalTexture({
      width: a.width,
      height: a.height,
      resolution: i.resolution,
      antialias: i.antialias
    }), i.backTexture = et.EMPTY, i.inputTexture = e, this.renderer.renderTarget.finishRenderPass(), this._applyFiltersToTexture(i, !0);
    const d = i.outputRenderSurface;
    return d.source.alphaMode = "premultiplied-alpha", this._popFilterData(), d;
  }
  /** @internal */
  pop() {
    const e = this.renderer, t = this._popFilterData();
    t.skip || (e.globalUniforms.pop(), e.renderTarget.finishRenderPass(), this._activeFilterData = t, this._applyFiltersToTexture(t, !1), t.blendRequired && Nn.returnTexture(t.backTexture), Nn.returnTexture(t.inputTexture));
  }
  /**
   * Copies the last render surface to a texture.
   * @param lastRenderSurface - The last render surface to copy from.
   * @param bounds - The bounds of the area to copy.
   * @param previousBounds - The previous bounds to use for offsetting the copy.
   */
  getBackTexture(e, t, i) {
    const s = e.colorTexture.source._resolution, o = Nn.getOptimalTexture({
      width: t.width,
      height: t.height,
      resolution: s
    });
    let r = t.minX, a = t.minY;
    i && (r -= i.minX, a -= i.minY), r = Math.floor(r * s), a = Math.floor(a * s);
    const l = Math.ceil(t.width * s), d = Math.ceil(t.height * s);
    return this.renderer.renderTarget.copyToTexture(
      e,
      o,
      { x: r, y: a },
      { width: l, height: d },
      { x: 0, y: 0 }
    ), o;
  }
  /**
   * Applies a filter to a texture.
   * @param filter - The filter to apply.
   * @param input - The input texture.
   * @param output - The output render surface.
   * @param clear - Whether to clear the output surface before applying the filter.
   */
  applyFilter(e, t, i, s) {
    const o = this.renderer, r = this._activeFilterData, l = r.outputRenderSurface === i, d = this._findClosestFilterData(), c = d ? d.inputTexture.source._resolution : o.renderTarget.rootRenderTarget.colorTexture.source._resolution;
    let h = 0, f = 0;
    l && d && (h = d.bounds.minX, f = d.bounds.minY), this._updateFilterUniforms(t, i, r, h, f, c, l, s);
    const p = e.enabled ? e : this._getPassthroughFilter();
    this._setupBindGroupsAndRender(p, t, o);
  }
  /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */
  calculateSpriteMatrix(e, t) {
    const i = this._activeFilterData, s = e.set(
      i.inputTexture._source.width,
      0,
      0,
      i.inputTexture._source.height,
      i.bounds.minX,
      i.bounds.minY
    ), o = t.worldTransform.copyTo(ot.shared), r = t.renderGroup || t.parentRenderGroup;
    return r && r.cacheToLocalTransform && o.prepend(r.cacheToLocalTransform), o.invert(), s.prepend(o), s.scale(
      1 / t.texture.orig.width,
      1 / t.texture.orig.height
    ), s.translate(t.anchor.x, t.anchor.y), s;
  }
  destroy() {
    var e;
    (e = this._passthroughFilter) == null || e.destroy(!0), this._passthroughFilter = null;
  }
  _getPassthroughFilter() {
    var e;
    return (e = this._passthroughFilter) != null || (this._passthroughFilter = new yZ()), this._passthroughFilter;
  }
  /**
   * Sets up the bind groups and renders the filter.
   * @param filter - The filter to apply
   * @param input - The input texture
   * @param renderer - The renderer instance
   */
  _setupBindGroupsAndRender(e, t, i) {
    if (i.renderPipes.uniformBatch) {
      const s = i.renderPipes.uniformBatch.getUboResource(this._filterGlobalUniforms);
      this._globalFilterBindGroup.setResource(s, 0);
    } else
      this._globalFilterBindGroup.setResource(this._filterGlobalUniforms, 0);
    this._globalFilterBindGroup.setResource(t.source, 1), this._globalFilterBindGroup.setResource(t.source.style, 2), e.groups[0] = this._globalFilterBindGroup, i.encoder.draw({
      geometry: xZ,
      shader: e,
      state: e._state,
      topology: "triangle-list"
    }), i.type === rs.WEBGL && i.renderTarget.finishRenderPass();
  }
  /**
   * Sets up the filter textures including input texture and back texture if needed.
   * @param filterData - The filter data to update
   * @param bounds - The bounds for the texture
   * @param renderer - The renderer instance
   * @param previousFilterData - The previous filter data for back texture calculation
   */
  _setupFilterTextures(e, t, i, s) {
    if (e.backTexture = et.EMPTY, e.inputTexture = Nn.getOptimalTexture({
      width: t.width,
      height: t.height,
      resolution: e.resolution,
      antialias: e.antialias
    }), e.blendRequired) {
      i.renderTarget.finishRenderPass();
      const o = i.renderTarget.getRenderTarget(e.outputRenderSurface);
      e.backTexture = this.getBackTexture(o, t, s == null ? void 0 : s.bounds);
    }
    i.renderTarget.bind({ target: e.inputTexture, clear: !0 }), i.globalUniforms.push({
      offset: t
    });
  }
  /**
   * Updates the filter uniforms with the current filter state.
   * @param input - The input texture
   * @param output - The output render surface
   * @param filterData - The current filter data
   * @param offsetX - The X offset for positioning
   * @param offsetY - The Y offset for positioning
   * @param resolution - The current resolution
   * @param isFinalTarget - Whether this is the final render target
   * @param clear - Whether to clear the output surface
   */
  _updateFilterUniforms(e, t, i, s, o, r, a, l) {
    const d = this._filterGlobalUniforms.uniforms, c = d.uOutputFrame, h = d.uInputSize, f = d.uInputPixel, p = d.uInputClamp, y = d.uGlobalFrame, v = d.uOutputTexture;
    a ? (c[0] = i.bounds.minX - s, c[1] = i.bounds.minY - o) : (c[0] = 0, c[1] = 0), c[2] = e.frame.width, c[3] = e.frame.height, h[0] = e.source.width, h[1] = e.source.height, h[2] = 1 / h[0], h[3] = 1 / h[1], f[0] = e.source.pixelWidth, f[1] = e.source.pixelHeight, f[2] = 1 / f[0], f[3] = 1 / f[1], p[0] = 0.5 * f[2], p[1] = 0.5 * f[3], p[2] = e.frame.width * h[2] - 0.5 * f[2], p[3] = e.frame.height * h[3] - 0.5 * f[3];
    const x = this.renderer.renderTarget.rootRenderTarget.colorTexture;
    y[0] = s * r, y[1] = o * r, y[2] = x.source.width * r, y[3] = x.source.height * r, t instanceof et && (t.source.resource = null);
    const w = this.renderer.renderTarget.getRenderTarget(t);
    this.renderer.renderTarget.bind({ target: t, clear: !!l }), t instanceof et ? (v[0] = t.frame.width, v[1] = t.frame.height) : (v[0] = w.width, v[1] = w.height), v[2] = w.isRoot ? -1 : 1, this._filterGlobalUniforms.update();
  }
  /**
   * Finds the non-skipped entry closest to the top of the filter stack.
   *
   * `pop()` removes its entry before it applies the filters, so the result is the enclosing filter's entry.
   * `generateFilteredTexture()` applies the filters while its entry is still on the stack, so the result is that entry.
   * @returns The entry, or null if there is none
   */
  _findClosestFilterData() {
    for (let e = this._filterStackIndex - 1; e >= 0; e--) {
      const t = this._filterStack[e];
      if (!t.skip) return t;
    }
    return null;
  }
  /**
   * Calculates the filter area bounds based on the instruction type.
   * @param instruction - The filter instruction
   * @param bounds - The bounds object to populate
   */
  _calculateFilterArea(e, t) {
    if (e.renderables ? WM(e.renderables, t) : e.filterEffect.filterArea ? (t.clear(), t.addRect(e.filterEffect.filterArea), t.applyMatrix(e.container.worldTransform)) : e.container.getFastGlobalBounds(!0, t), e.container) {
      const s = (e.container.renderGroup || e.container.parentRenderGroup).cacheToLocalTransform;
      s && t.applyMatrix(s);
    }
  }
  _applyFiltersToTexture(e, t) {
    const i = e.inputTexture, s = e.bounds, o = e.filters, r = e.firstEnabledIndex, a = e.lastEnabledIndex;
    if (this._globalFilterBindGroup.setResource(i.source.style, 2), this._globalFilterBindGroup.setResource(e.backTexture.source, 3), r === a)
      o[r].apply(this, i, e.outputRenderSurface, t);
    else {
      let l = e.inputTexture;
      const d = Nn.getOptimalTexture({
        width: s.width,
        height: s.height,
        resolution: l.source._resolution
      });
      let c = d;
      for (let h = r; h < a; h++) {
        const f = o[h];
        if (!f.enabled) continue;
        f.apply(this, l, c, !0);
        const p = l;
        l = c, c = p;
      }
      o[a].apply(this, l, e.outputRenderSurface, t), Nn.returnTexture(d);
    }
  }
  _calculateFilterBounds(e, t, i, s, o) {
    var w, S;
    const r = this.renderer, a = e.bounds, l = e.filters;
    let d = 1 / 0, c = 0, h = !0, f = !1, p = !1, y = !0, v = -1, x = -1;
    for (let M = 0; M < l.length; M++) {
      const _ = l[M];
      if (!_.enabled) continue;
      if (v === -1 && (v = M), x = M, d = Math.min(d, _.resolution === "inherit" ? s : _.resolution), c += _.padding, _.antialias === "off" ? h = !1 : _.antialias === "inherit" && h && (h = i), _.clipToViewport || (y = !1), !!!(_.compatibleRenderers & r.type)) {
        p = !1;
        break;
      }
      if (_.blendRequired && !((S = (w = r.backBuffer) == null ? void 0 : w.useBackBuffer) == null || S)) {
        dt("Blend filter requires backBuffer on WebGL renderer to be enabled. Set `useBackBuffer: true` in the renderer options."), p = !1;
        break;
      }
      p = !0, f || (f = _.blendRequired);
    }
    if (!p) {
      e.skip = !0;
      return;
    }
    if (y && a.fitBounds(0, t.width / s, 0, t.height / s), a.scale(d).ceil().scale(1 / d).pad((c | 0) * o), !a.isPositive) {
      e.skip = !0;
      return;
    }
    e.antialias = h, e.resolution = d, e.blendRequired = f, e.firstEnabledIndex = v, e.lastEnabledIndex = x;
  }
  _popFilterData() {
    return this._filterStackIndex--, this._filterStack[this._filterStackIndex];
  }
  /**
   * Finds the closest non-skipped entry that encloses the filter being pushed.
   *
   * `push()` has already added that filter's own entry, so the search starts one entry below it.
   * @returns The entry, or null if there is none
   */
  _getPreviousFilterData() {
    for (let e = this._filterStackIndex - 2; e >= 0; e--) {
      const t = this._filterStack[e];
      if (!t.skip) return t;
    }
    return null;
  }
  _pushFilterData() {
    let e = this._filterStack[this._filterStackIndex];
    return e || (e = this._filterStack[this._filterStackIndex] = new wZ()), this._filterStackIndex++, e;
  }
}
YM.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "filter"
};
var kZ = `in vec2 vMaskCoord;
in vec2 vTextureCoord;

uniform sampler2D uTexture;
uniform sampler2D uMaskTexture;

uniform float uAlpha;
uniform vec4 uMaskClamp;
uniform float uInverse;
uniform float uChannel;

out vec4 finalColor;

void main(void)
{
    float clip = step(3.5,
        step(uMaskClamp.x, vMaskCoord.x) +
        step(uMaskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, uMaskClamp.z) +
        step(vMaskCoord.y, uMaskClamp.w));

    // TODO look into why this is needed
    float npmAlpha = uAlpha;
    vec4 original = texture(uTexture, vTextureCoord);
    vec4 masky = texture(uMaskTexture, vMaskCoord);

    float a;
    if (uChannel == 1.0) {
        a = masky.a * npmAlpha * clip;
    } else {
        float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);
        a = alphaMul * masky.r * npmAlpha * clip;
    }

    if (uInverse == 1.0) {
        a = 1.0 - a;
    }

    finalColor = original * a;
}
`, _Z = `in vec2 aPosition;

out vec2 vTextureCoord;
out vec2 vMaskCoord;


uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;
uniform mat3 uFilterMatrix;

vec4 filterVertexPosition(  vec2 aPosition )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
       
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord(  vec2 aPosition )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

vec2 getFilterCoord( vec2 aPosition )
{
    return  ( uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}   

void main(void)
{
    gl_Position = filterVertexPosition(aPosition);
    vTextureCoord = filterTextureCoord(aPosition);
    vMaskCoord = getFilterCoord(aPosition);
}
`, B2 = `struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct MaskUniforms {
  uFilterMatrix:mat3x3<f32>,
  uMaskClamp:vec4<f32>,
  uAlpha:f32,
  uInverse:f32,
  uChannel:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> filterUniforms : MaskUniforms;
@group(1) @binding(1) var uMaskTexture: texture_2d<f32>;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) filterUv : vec2<f32>,
};

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);
}

fn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>
{
  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}

@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition),
   getFilterCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) filterUv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {

    var maskClamp = filterUniforms.uMaskClamp;
    var uAlpha = filterUniforms.uAlpha;

    var clip = step(3.5,
      step(maskClamp.x, filterUv.x) +
      step(maskClamp.y, filterUv.y) +
      step(filterUv.x, maskClamp.z) +
      step(filterUv.y, maskClamp.w));

    var mask = textureSample(uMaskTexture, uSampler, filterUv);
    var source = textureSample(uTexture, uSampler, uv);

    var a: f32;
    if (filterUniforms.uChannel == 1.0) {
        a = mask.a * uAlpha * clip;
    } else {
        var alphaMul = 1.0 - uAlpha * (1.0 - mask.a);
        a = alphaMul * mask.r * uAlpha * clip;
    }

    if (filterUniforms.uInverse == 1.0) {
        a = 1.0 - a;
    }

    return source * a;
}
`;
class SZ extends tM {
  constructor(e) {
    const { sprite: t, ...i } = e, s = new kS(t.texture), o = new Ts({
      uFilterMatrix: { value: new ot(), type: "mat3x3<f32>" },
      uMaskClamp: { value: s.uClampFrame, type: "vec4<f32>" },
      uAlpha: { value: 1, type: "f32" },
      uInverse: { value: e.inverse ? 1 : 0, type: "f32" },
      uChannel: { value: e.channel === "alpha" ? 1 : 0, type: "f32" }
    }), r = va.from({
      vertex: {
        source: B2,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: B2,
        entryPoint: "mainFragment"
      }
    }), a = Xl.from({
      vertex: _Z,
      fragment: kZ,
      name: "mask-filter"
    });
    super({
      ...i,
      gpuProgram: r,
      glProgram: a,
      clipToViewport: !1,
      resources: {
        filterUniforms: o,
        uMaskTexture: t.texture.source
      }
    }), this.sprite = t, this._textureMatrix = s;
  }
  /**
   * Rebinds the filter to a new mask sprite, moving the texture-matrix `update`
   * listener and the bind group's `change` subscription over to the new sprite's
   * texture. `apply` refreshes the same bindings on every use — this method exists
   * to release the previous sprite's texture immediately, without waiting for
   * (or requiring) another `apply`.
   * @param sprite - the sprite to mask with from now on.
   */
  setSprite(e) {
    this.sprite = e;
    const t = this._getSafeTexture();
    this._textureMatrix.texture = t, this.resources.uMaskTexture = t.source;
  }
  set inverse(e) {
    this.resources.filterUniforms.uniforms.uInverse = e ? 1 : 0;
  }
  get inverse() {
    return this.resources.filterUniforms.uniforms.uInverse === 1;
  }
  set channel(e) {
    this.resources.filterUniforms.uniforms.uChannel = e === "alpha" ? 1 : 0;
  }
  get channel() {
    return this.resources.filterUniforms.uniforms.uChannel === 1 ? "alpha" : "red";
  }
  apply(e, t, i, s) {
    const o = this._getSafeTexture();
    this._textureMatrix.texture = o, e.calculateSpriteMatrix(
      this.resources.filterUniforms.uniforms.uFilterMatrix,
      this.sprite
    ).prepend(this._textureMatrix.mapCoord), this.resources.uMaskTexture = o.source, e.applyFilter(this, t, i, s);
  }
  /**
   * The sprite's texture, or `Texture.EMPTY` when that texture has been destroyed —
   * a destroyed texture has no source left to sample, so the mask degrades to empty
   * rather than crashing the render.
   */
  _getSafeTexture() {
    const e = this.sprite.texture;
    return e.destroyed || !e.source || e.source.destroyed ? (dt("[MaskFilter] The mask texture was destroyed while the mask is still in use. Remove the mask before destroying its texture."), et.EMPTY) : e;
  }
  destroy(e = !1) {
    this._textureMatrix.destroy(), super.destroy(e);
  }
}
class MZ {
  constructor() {
    this.isBatchable = !1;
  }
  /**
   * Reset cached canvas data.
   * @advanced
   */
  reset() {
    this.isBatchable = !1, this.context = null, this.graphicsData && (this.graphicsData.destroy(), this.graphicsData = null);
  }
  /**
   * Destroy the cached data.
   * @advanced
   */
  destroy() {
    this.reset();
  }
}
class TZ {
  constructor() {
    this.instructions = new Q1();
  }
  /**
   * Initialize render data.
   * @advanced
   */
  init() {
    this.instructions.reset();
  }
  /**
   * Destroy render data.
   * @advanced
   */
  destroy() {
    this.instructions.destroy(), this.instructions = null;
  }
}
const yy = class h0 {
  constructor(e) {
    this._renderer = e, this._managedContexts = new Cs({ renderer: e, type: "resource", name: "graphicsContext" });
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(e) {
    var t;
    h0.defaultOptions.bezierSmoothness = (t = e == null ? void 0 : e.bezierSmoothness) != null ? t : h0.defaultOptions.bezierSmoothness;
  }
  /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */
  getContextRenderData(e) {
    return this.getGpuContext(e).graphicsData || this._initContextRenderData(e);
  }
  /**
   * Updates the GPU context for a given GraphicsContext.
   * @param context - The GraphicsContext to update.
   * @returns The updated CanvasGraphicsContext.
   * @internal
   */
  updateGpuContext(e) {
    const t = e._gpuData, i = !!t[this._renderer.uid], s = t[this._renderer.uid] || this._initContext(e);
    return (e.dirty || !i) && (i && s.reset(), s.isBatchable = !1, e.dirty = !1), s;
  }
  /**
   * Returns the CanvasGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the CanvasGraphicsContext for.
   * @returns The CanvasGraphicsContext for the given GraphicsContext.
   * @internal
   */
  getGpuContext(e) {
    return e._gpuData[this._renderer.uid] || this._initContext(e);
  }
  _initContextRenderData(e) {
    const t = new TZ(), i = this.getGpuContext(e);
    return i.graphicsData = t, t.init(), t;
  }
  _initContext(e) {
    const t = new MZ();
    return t.context = e, e._gpuData[this._renderer.uid] = t, this._managedContexts.add(e), t;
  }
  destroy() {
    this._managedContexts.destroy(), this._renderer = null;
  }
};
yy.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "graphicsContext"
};
yy.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let CZ = yy;
class XM {
  constructor(e, t) {
    this.state = co.for2d(), this.renderer = e, this._adaptor = t, this.renderer.runners.contextChange.add(this), this._managedGraphics = new Cs({ renderer: e, type: "renderable", priority: -1, name: "graphics" });
  }
  contextChange() {
    this._adaptor.contextChange(this.renderer);
  }
  validateRenderable(e) {
    return !1;
  }
  addRenderable(e, t) {
    this._managedGraphics.add(e), this.renderer.renderPipes.batch.break(t), t.add(e);
  }
  updateRenderable(e) {
  }
  execute(e) {
    e.isRenderable && this._adaptor.execute(this, e);
  }
  destroy() {
    this._managedGraphics.destroy(), this.renderer = null, this._adaptor.destroy(), this._adaptor = null;
  }
}
XM.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "graphics"
};
function JM(n, e, t) {
  const i = (n >> 24 & 255) / 255;
  e[t++] = (n & 255) / 255 * i, e[t++] = (n >> 8 & 255) / 255 * i, e[t++] = (n >> 16 & 255) / 255 * i, e[t++] = i;
}
class IZ {
  constructor() {
    this.batches = [], this.batched = !1;
  }
  destroy() {
    this.batches.forEach((e) => {
      $n.return(e);
    }), this.batches.length = 0;
  }
}
class ZM {
  constructor(e, t) {
    this.state = co.for2d(), this.renderer = e, this._adaptor = t, this.renderer.runners.contextChange.add(this), this._managedGraphics = new Cs({ renderer: e, type: "renderable", priority: -1, name: "graphics" });
  }
  contextChange() {
    this._adaptor.contextChange(this.renderer);
  }
  validateRenderable(e) {
    const t = e.context, i = !!e._gpuData, o = this.renderer.graphicsContext.updateGpuContext(t);
    return !!(o.isBatchable || i !== o.isBatchable);
  }
  addRenderable(e, t) {
    const s = this.renderer.graphicsContext.updateGpuContext(e.context);
    (e.didViewUpdate || !e._gpuData[this.renderer.uid]) && this._rebuild(e), s.isBatchable ? this._addToBatcher(e, t) : (this.renderer.renderPipes.batch.break(t), t.add(e));
  }
  updateRenderable(e) {
    const i = this._getGpuDataForRenderable(e).batches;
    for (let s = 0; s < i.length; s++) {
      const o = i[s];
      o._batcher.updateElement(o);
    }
  }
  execute(e) {
    if (!e.isRenderable) return;
    const t = this.renderer, i = e.context;
    if (!t.graphicsContext.getGpuContext(i).batches.length)
      return;
    const o = i.customShader || this._adaptor.shader;
    this.state.blendMode = e.groupBlendMode;
    const r = o.resources.localUniforms.uniforms;
    r.uTransformMatrix = e.groupTransform, r.uRound = t._roundPixels | e._roundPixels, JM(
      e.groupColorAlpha,
      r.uColor,
      0
    ), this._adaptor.execute(this, e);
  }
  _rebuild(e) {
    const t = this._getGpuDataForRenderable(e), s = this.renderer.graphicsContext.updateGpuContext(e.context);
    t.destroy(), s.isBatchable && this._updateBatchesForRenderable(e, t);
  }
  _addToBatcher(e, t) {
    const i = this.renderer.renderPipes.batch, s = this._getGpuDataForRenderable(e).batches;
    for (let o = 0; o < s.length; o++) {
      const r = s[o];
      i.addToBatch(r, t);
    }
  }
  _getGpuDataForRenderable(e) {
    return e._gpuData[this.renderer.uid] || this._initGpuDataForRenderable(e);
  }
  _initGpuDataForRenderable(e) {
    const t = new IZ();
    return e._gpuData[this.renderer.uid] = t, this._managedGraphics.add(e), t;
  }
  _updateBatchesForRenderable(e, t) {
    const i = e.context, o = this.renderer.graphicsContext.getGpuContext(i), r = this.renderer._roundPixels | e._roundPixels;
    t.batches = o.batches.map((a) => {
      const l = $n.get(hy);
      return a.copyTo(l), l.renderable = e, l.roundPixels = r, l;
    });
  }
  destroy() {
    this._managedGraphics.destroy(), this.renderer = null, this._adaptor.destroy(), this._adaptor = null, this.state = null;
  }
}
ZM.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "graphics"
};
ht.add(XM);
ht.add(ZM);
ht.add(CZ);
ht.add(gy);
class Ko extends ty {
  /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */
  constructor(e) {
    e instanceof yd && (e = { context: e });
    const { context: t, roundPixels: i, ...s } = e || {};
    super({
      label: "Graphics",
      ...s
    }), this.renderPipeId = "graphics", t ? this.context = t : (this.context = this._ownedContext = new yd(), this.context.autoGarbageCollect = this.autoGarbageCollect), this.didViewUpdate = !0, this.allowChildren = !1, this.roundPixels = i != null ? i : !1;
  }
  set context(e) {
    e !== this._context && (this._context && (this._context.off("update", this.onViewUpdate, this), this._context.off("unload", this.unload, this)), this._context = e, this._context.on("update", this.onViewUpdate, this), this._context.on("unload", this.unload, this), this.onViewUpdate());
  }
  /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */
  get context() {
    return this._context;
  }
  /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */
  get bounds() {
    return this._context.bounds;
  }
  /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */
  updateBounds() {
  }
  /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */
  containsPoint(e) {
    return this._context.containsPoint(e);
  }
  /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */
  destroy(e) {
    var t, i;
    this._ownedContext && !e ? this._ownedContext.destroy(e) : (e === !0 || (e == null ? void 0 : e.context) === !0) && this._context.destroy(e), (t = this._context) == null || t.off("update", this.onViewUpdate, this), (i = this._context) == null || i.off("unload", this.unload, this), this._ownedContext = null, this._context = null, super.destroy(e);
  }
  /**
   * @param now - The current time in milliseconds.
   * @internal
   */
  _onTouch(e) {
    this._gcLastUsed = e, this._context._gcLastUsed = e;
  }
  _callContextMethod(e, t) {
    return this.context[e](...t), this;
  }
  // --------------------------------------- GraphicsContext methods ---------------------------------------
  /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */
  setFillStyle(...e) {
    return this._callContextMethod("setFillStyle", e);
  }
  /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */
  setStrokeStyle(...e) {
    return this._callContextMethod("setStrokeStyle", e);
  }
  fill(...e) {
    return this._callContextMethod("fill", e);
  }
  /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */
  stroke(...e) {
    return this._callContextMethod("stroke", e);
  }
  texture(...e) {
    return this._callContextMethod("texture", e);
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */
  beginPath() {
    return this._callContextMethod("beginPath", []);
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */
  cut() {
    return this._callContextMethod("cut", []);
  }
  arc(...e) {
    return this._callContextMethod("arc", e);
  }
  arcTo(...e) {
    return this._callContextMethod("arcTo", e);
  }
  arcToSvg(...e) {
    return this._callContextMethod("arcToSvg", e);
  }
  bezierCurveTo(...e) {
    return this._callContextMethod("bezierCurveTo", e);
  }
  /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */
  closePath() {
    return this._callContextMethod("closePath", []);
  }
  ellipse(...e) {
    return this._callContextMethod("ellipse", e);
  }
  circle(...e) {
    return this._callContextMethod("circle", e);
  }
  path(...e) {
    return this._callContextMethod("path", e);
  }
  lineTo(...e) {
    return this._callContextMethod("lineTo", e);
  }
  moveTo(...e) {
    return this._callContextMethod("moveTo", e);
  }
  quadraticCurveTo(...e) {
    return this._callContextMethod("quadraticCurveTo", e);
  }
  rect(...e) {
    return this._callContextMethod("rect", e);
  }
  roundRect(...e) {
    return this._callContextMethod("roundRect", e);
  }
  poly(...e) {
    return this._callContextMethod("poly", e);
  }
  regularPoly(...e) {
    return this._callContextMethod("regularPoly", e);
  }
  roundPoly(...e) {
    return this._callContextMethod("roundPoly", e);
  }
  roundShape(...e) {
    return this._callContextMethod("roundShape", e);
  }
  filletRect(...e) {
    return this._callContextMethod("filletRect", e);
  }
  chamferRect(...e) {
    return this._callContextMethod("chamferRect", e);
  }
  star(...e) {
    return this._callContextMethod("star", e);
  }
  svg(...e) {
    return this._callContextMethod("svg", e);
  }
  restore(...e) {
    return this._callContextMethod("restore", e);
  }
  /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */
  save() {
    return this._callContextMethod("save", []);
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */
  getTransform() {
    return this.context.getTransform();
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */
  resetTransform() {
    return this._callContextMethod("resetTransform", []);
  }
  rotateTransform(...e) {
    return this._callContextMethod("rotate", e);
  }
  scaleTransform(...e) {
    return this._callContextMethod("scale", e);
  }
  setTransform(...e) {
    return this._callContextMethod("setTransform", e);
  }
  transform(...e) {
    return this._callContextMethod("transform", e);
  }
  translateTransform(...e) {
    return this._callContextMethod("translate", e);
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */
  clear() {
    return this._callContextMethod("clear", []);
  }
  /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */
  get fillStyle() {
    return this._context.fillStyle;
  }
  set fillStyle(e) {
    this._context.fillStyle = e;
  }
  /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */
  get strokeStyle() {
    return this._context.strokeStyle;
  }
  set strokeStyle(e) {
    this._context.strokeStyle = e;
  }
  /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */
  clone(e = !1) {
    return e ? new Ko(this._context.clone()) : (this._ownedContext = null, new Ko(this._context));
  }
  // -------- v7 deprecations ---------
  /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */
  lineStyle(e, t, i) {
    rt(dn, "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
    const s = {};
    return e && (s.width = e), t && (s.color = t), i && (s.alpha = i), this.context.strokeStyle = s, this;
  }
  /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  beginFill(e, t) {
    rt(dn, "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
    const i = {};
    return e !== void 0 && (i.color = e), t !== void 0 && (i.alpha = t), this.context.fillStyle = i, this;
  }
  /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  endFill() {
    rt(dn, "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style."), this.context.fill();
    const e = this.context.strokeStyle;
    return (e.width !== yd.defaultStrokeStyle.width || e.color !== yd.defaultStrokeStyle.color || e.alpha !== yd.defaultStrokeStyle.alpha) && this.context.stroke(), this;
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */
  drawCircle(...e) {
    return rt(dn, "Graphics#drawCircle has been renamed to Graphics#circle"), this._callContextMethod("circle", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */
  drawEllipse(...e) {
    return rt(dn, "Graphics#drawEllipse has been renamed to Graphics#ellipse"), this._callContextMethod("ellipse", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */
  drawPolygon(...e) {
    return rt(dn, "Graphics#drawPolygon has been renamed to Graphics#poly"), this._callContextMethod("poly", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */
  drawRect(...e) {
    return rt(dn, "Graphics#drawRect has been renamed to Graphics#rect"), this._callContextMethod("rect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */
  drawRoundedRect(...e) {
    return rt(dn, "Graphics#drawRoundedRect has been renamed to Graphics#roundRect"), this._callContextMethod("roundRect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */
  drawStar(...e) {
    return rt(dn, "Graphics#drawStar has been renamed to Graphics#star"), this._callContextMethod("star", e);
  }
}
const QM = class eT extends bm {
  constructor(...e) {
    var c;
    let t = (c = e[0]) != null ? c : {};
    t instanceof Float32Array && (rt(dn, "use new MeshGeometry({ positions, uvs, indices }) instead"), t = {
      positions: t,
      uvs: e[1],
      indices: e[2]
    }), t = { ...eT.defaultOptions, ...t };
    const i = t.positions || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    let s = t.uvs;
    s || (t.positions ? s = new Float32Array(i.length) : s = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]));
    const o = t.indices || new Uint32Array([0, 1, 2, 0, 2, 3]), r = t.shrinkBuffersToFit, a = new ns({
      data: i,
      label: "attribute-mesh-positions",
      shrinkToFit: r,
      usage: $t.VERTEX | $t.COPY_DST
    }), l = new ns({
      data: s,
      label: "attribute-mesh-uvs",
      shrinkToFit: r,
      usage: $t.VERTEX | $t.COPY_DST
    }), d = new ns({
      data: o,
      label: "index-mesh-buffer",
      shrinkToFit: r,
      usage: $t.INDEX | $t.COPY_DST
    });
    super({
      attributes: {
        aPosition: {
          buffer: a,
          format: "float32x2",
          stride: 8,
          offset: 0
        },
        aUV: {
          buffer: l,
          format: "float32x2",
          stride: 8,
          offset: 0
        }
      },
      indexBuffer: d,
      topology: t.topology
    }), this.batchMode = "auto";
  }
  /** The positions of the mesh. */
  get positions() {
    return this.attributes.aPosition.buffer.data;
  }
  /**
   * Set the positions of the mesh.
   * When setting the positions, its important that the uvs array is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The positions of the mesh.
   */
  set positions(e) {
    this.attributes.aPosition.buffer.data = e;
  }
  /** The UVs of the mesh. */
  get uvs() {
    return this.attributes.aUV.buffer.data;
  }
  /**
   * Set the UVs of the mesh.
   * Its important that the uvs array you set is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The UVs of the mesh.
   */
  set uvs(e) {
    this.attributes.aUV.buffer.data = e;
  }
  /** The indices of the mesh. */
  get indices() {
    return this.indexBuffer.data;
  }
  set indices(e) {
    this.indexBuffer.data = e;
  }
};
QM.defaultOptions = {
  topology: "triangle-list",
  shrinkBuffersToFit: !1
};
let AZ = QM;
class PZ {
  constructor() {
    this.batcherName = "default", this.packAsQuad = !1, this.indexOffset = 0, this.attributeOffset = 0, this.roundPixels = 0, this._batcher = null, this._batch = null, this._textureMatrixUpdateId = -1, this._uvUpdateId = -1;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get topology() {
    return this._topology || this.geometry.topology;
  }
  set topology(e) {
    this._topology = e;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.geometry = null, this._uvUpdateId = -1, this._textureMatrixUpdateId = -1;
  }
  /**
   * Sets the texture for the batchable mesh.
   * As it does so, it resets the texture matrix update ID.
   * this is to ensure that the texture matrix is recalculated when the uvs are referenced
   * @param value - The texture to set.
   */
  setTexture(e) {
    this.texture !== e && (this.texture = e, this._textureMatrixUpdateId = -1);
  }
  get uvs() {
    const t = this.geometry.getBuffer("aUV"), i = t.data;
    let s = i;
    const o = this.texture.textureMatrix;
    return o.isSimple || (s = this._transformedUvs, (this._textureMatrixUpdateId !== o._updateID || this._uvUpdateId !== t._updateID) && ((!s || s.length < i.length) && (s = this._transformedUvs = new Float32Array(i.length)), this._textureMatrixUpdateId = o._updateID, this._uvUpdateId = t._updateID, o.multiplyUvs(i, s))), s;
  }
  get positions() {
    return this.geometry.positions;
  }
  get indices() {
    return this.geometry.indices;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  get groupTransform() {
    return this.renderable.groupTransform;
  }
  get attributeSize() {
    return this.geometry.positions.length / 2;
  }
  get indexSize() {
    return this.geometry.indices.length;
  }
}
const _p = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* wgsl */
      `

            struct LocalUniforms {
                uTransformMatrix:mat3x3<f32>,
                uColor:vec4<f32>,
                uRound:f32,
            }

            @group(1) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `
    ),
    end: (
      /* wgsl */
      `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    )
  }
}, EZ = {
  ..._p,
  vertex: {
    ..._p.vertex,
    // replace the group!
    header: _p.vertex.header.replace("group(1)", "group(2)")
  }
}, tT = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* glsl */
      `

            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= uColor;
            modelMatrix = uTransformMatrix;
        `
    ),
    end: (
      /* glsl */
      `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    )
  }
};
class nT {
  constructor() {
    this.batcherName = "default", this.topology = "triangle-list", this.attributeSize = 4, this.indexSize = 6, this.packAsQuad = !0, this.roundPixels = 0, this._attributeStart = 0, this._batcher = null, this._batch = null;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.bounds = null;
  }
  destroy() {
    this.reset();
  }
}
function RZ() {
  const { userAgent: n } = zt.get().getNavigator();
  return /^((?!chrome|android).)*safari/i.test(n);
}
const xy = class zr {
  static _getPatternRepeat(e, t) {
    const i = e && e !== "clamp-to-edge", s = t && t !== "clamp-to-edge";
    return i && s ? "repeat" : i ? "repeat-x" : s ? "repeat-y" : "no-repeat";
  }
  start(e, t, i) {
  }
  execute(e, t) {
    var a, l, d, c, h, f, p, y, v, x;
    const i = t.elements;
    if (!i || !i.length) return;
    const s = e.renderer, o = s.canvasContext, r = o.activeContext;
    for (let w = 0; w < i.length; w++) {
      const S = i[w];
      if (!S.packAsQuad) continue;
      const M = S, _ = M.texture, T = _ ? St.getCanvasSource(_) : null;
      if (!T) continue;
      const k = _.source.style, P = o.smoothProperty, A = k.scaleMode !== "nearest";
      r[P] !== A && (r[P] = A), o.setBlendMode(t.blendMode);
      const R = (l = (a = s.globalUniforms.globalUniformData) == null ? void 0 : a.worldColor) != null ? l : 4294967295, D = M.color, O = (R >>> 24 & 255) / 255, F = (D >>> 24 & 255) / 255, ie = (c = (d = s.filter) == null ? void 0 : d.alphaMultiplier) != null ? c : 1, ee = O * F * ie;
      if (ee <= 0) continue;
      r.globalAlpha = ee;
      const me = R & 16777215, L = D & 16777215, N = oa(sa(L, me)), K = _.frame, B = (h = k.addressModeU) != null ? h : k.addressMode, re = (f = k.addressModeV) != null ? f : k.addressMode, H = zr._getPatternRepeat(B, re), J = (y = (p = _.source._resolution) != null ? p : _.source.resolution) != null ? y : 1, Q = (x = (v = M.renderable) == null ? void 0 : v.renderGroup) == null ? void 0 : x.isCachedAsTexture, ne = K.x * J, ue = K.y * J, Z = K.width * J, te = K.height * J, we = M.bounds, Fe = s.renderTarget.renderTarget.isRoot, Me = we.minX, he = we.minY, U = we.maxX - we.minX, q = we.maxY - we.minY, oe = _.rotate, de = _.uvs, pe = Math.min(de.x0, de.x1, de.x2, de.x3, de.y0, de.y1, de.y2, de.y3), Ce = Math.max(de.x0, de.x1, de.x2, de.x3, de.y0, de.y1, de.y2, de.y3), Be = H !== "no-repeat" && (pe < 0 || Ce > 1), se = oe && !(!Be && (N !== 16777215 || oe));
      se ? (zr._tempPatternMatrix.copyFrom(M.transform), Mt.matrixAppendRotationInv(
        zr._tempPatternMatrix,
        oe,
        Me,
        he,
        U,
        q
      ), o.setContextTransform(
        zr._tempPatternMatrix,
        M.roundPixels === 1,
        void 0,
        Q && Fe
      )) : o.setContextTransform(
        M.transform,
        M.roundPixels === 1,
        void 0,
        Q && Fe
      );
      const ae = U, ye = q;
      let Oe = se ? 0 : Me, Ve = se ? 0 : he;
      if (!se && M.roundPixels === 1 && (Oe |= 0, Ve |= 0), Be) {
        let Ue = T;
        const tt = N !== 16777215 && !oe, Ye = K.width <= _.source.width && K.height <= _.source.height;
        tt && Ye && (Ue = St.getTintedCanvas({ texture: _ }, N));
        const at = r.createPattern(Ue, H);
        if (!at) continue;
        const kt = ae, $e = ye;
        if (kt === 0 || $e === 0) continue;
        const Ne = 1 / kt, V = 1 / $e, X = (de.x1 - de.x0) * Ne, le = (de.y1 - de.y0) * Ne, Le = (de.x3 - de.x0) * V, ve = (de.y3 - de.y0) * V, _e = de.x0 - X * Oe - Le * Ve, De = de.y0 - le * Oe - ve * Ve, Qe = _.source.pixelWidth, ft = _.source.pixelHeight;
        zr._tempPatternMatrix.set(
          X * Qe,
          le * ft,
          Le * Qe,
          ve * ft,
          _e * Qe,
          De * ft
        ), St.applyPatternTransform(at, zr._tempPatternMatrix), r.fillStyle = at, r.fillRect(Oe, Ve, ae, ye);
      } else {
        const tt = N !== 16777215 || oe ? St.getTintedCanvas({ texture: _ }, N) : T, Ye = tt !== T;
        r.drawImage(
          tt,
          Ye ? 0 : ne,
          Ye ? 0 : ue,
          Ye ? tt.width : Z,
          Ye ? tt.height : te,
          Oe,
          Ve,
          ae,
          ye
        );
      }
    }
  }
};
xy._tempPatternMatrix = new ot();
xy.extension = {
  type: [
    Ae.CanvasPipesAdaptor
  ],
  name: "batch"
};
let zZ = xy;
class iT {
  constructor() {
    this._tempState = co.for2d(), this._didUploadHash = {};
  }
  init(e) {
    e.renderer.runners.contextChange.add(this);
  }
  contextChange() {
    this._didUploadHash = {};
  }
  start(e, t, i) {
    const s = e.renderer, o = this._didUploadHash[i.uid];
    s.shader.bind(i, o), o || (this._didUploadHash[i.uid] = !0), s.shader.updateUniformGroup(s.globalUniforms.uniformGroup), s.geometry.bind(t, i.glProgram);
  }
  execute(e, t) {
    const i = e.renderer;
    this._tempState.blendMode = t.blendMode, i.state.set(this._tempState);
    const s = t.textures.textures;
    for (let o = 0; o < t.textures.count; o++)
      i.texture.bind(s[o], o);
    i.texture.unbindIntegerTextures(t.textures.count), i.geometry.draw(t.topology, t.size, t.start);
  }
}
iT.extension = {
  type: [
    Ae.WebGLPipesAdaptor
  ],
  name: "batch"
};
const mh = co.for2d();
class sT {
  start(e, t, i) {
    const s = e.renderer, o = s.encoder, r = i.gpuProgram;
    this._shader = i, this._geometry = t, o.setGeometry(t, r), mh.blendMode = "normal", s.pipeline.getPipeline(
      t,
      r,
      mh,
      void 0,
      i._overrides
    );
    const a = s.globalUniforms.bindGroup;
    o.resetBindGroup(1), o.setBindGroup(0, a, r);
  }
  execute(e, t) {
    const i = this._shader.gpuProgram, s = e.renderer, o = s.encoder;
    if (!t.bindGroup) {
      const l = t.textures;
      t.bindGroup = ry(
        l.textures,
        l.count,
        s.limits.maxBatchableTextures
      );
    }
    mh.blendMode = t.blendMode;
    const r = s.bindGroup.getBindGroup(
      t.bindGroup,
      i,
      1
    ), a = s.pipeline.getPipeline(
      this._geometry,
      i,
      mh,
      t.topology,
      this._shader._overrides
    );
    t.bindGroup._touch(s.gc.now), o.setPipeline(a), o.renderPassEncoder.setBindGroup(1, r), o.renderPassEncoder.drawIndexed(t.size, 1, t.start);
  }
}
sT.extension = {
  type: [
    Ae.WebGPUPipesAdaptor
  ],
  name: "batch"
};
const wy = class oT {
  constructor(e, t) {
    var i, s;
    this.state = co.for2d(), this._batchersByInstructionSet = /* @__PURE__ */ Object.create(null), this._activeBatches = /* @__PURE__ */ Object.create(null), this.renderer = e, this._adaptor = t, (s = (i = this._adaptor).init) == null || s.call(i, this);
  }
  static getBatcher(e, t) {
    return new this._availableBatchers[e]({ maxTextures: t });
  }
  buildStart(e) {
    let t = this._batchersByInstructionSet[e.uid];
    t || (t = this._batchersByInstructionSet[e.uid] = /* @__PURE__ */ Object.create(null), t.default || (t.default = new uy({
      maxTextures: this.renderer.limits.maxBatchableTextures
    }))), this._activeBatches = t, this._activeBatch = this._activeBatches.default;
    for (const i in this._activeBatches)
      this._activeBatches[i].begin();
  }
  addToBatch(e, t) {
    if (this._activeBatch.name !== e.batcherName) {
      this._activeBatch.break(t);
      let i = this._activeBatches[e.batcherName];
      i || (i = this._activeBatches[e.batcherName] = oT.getBatcher(e.batcherName, this.renderer.limits.maxBatchableTextures), i.begin()), this._activeBatch = i;
    }
    this._activeBatch.add(e);
  }
  break(e) {
    this._activeBatch.break(e);
  }
  buildEnd(e) {
    this._activeBatch.break(e);
    const t = this._activeBatches;
    for (const i in t) {
      const s = t[i], o = s.geometry;
      o.indexBuffer.setDataWithSize(s.indexBuffer, s.indexSize, !0), o.buffers[0].setDataWithSize(s.attributeBuffer.float32View, s.attributeSize, !1);
    }
  }
  upload(e) {
    const t = this._batchersByInstructionSet[e.uid];
    for (const i in t) {
      const s = t[i], o = s.geometry;
      s.dirty && (s.dirty = !1, o.buffers[0].update(s.attributeSize * 4));
    }
  }
  execute(e) {
    if (e.action === "startBatch") {
      const t = e.batcher, i = t.geometry, s = t.shader;
      this._adaptor.start(this, i, s);
    }
    this._adaptor.execute(this, e);
  }
  /**
   * Releases all batchers cached for the given InstructionSet. Called from
   * `InstructionSet.destroy()` so that batchers (and their GPU geometry / attribute
   * buffers / referenced textures) do not leak when the owning RenderGroup is destroyed.
   * @param instructionSet - the instruction set being destroyed
   */
  destroyInstructionSet(e) {
    const t = this._batchersByInstructionSet[e.uid];
    if (t) {
      for (const i in t)
        t[i].destroy();
      delete this._batchersByInstructionSet[e.uid], this._activeBatches === t && (this._activeBatches = /* @__PURE__ */ Object.create(null), this._activeBatch = null);
    }
  }
  destroy() {
    this.state = null, this.renderer = null, this._adaptor = null;
    for (const e in this._activeBatches)
      this._activeBatches[e].destroy();
    this._activeBatches = null;
  }
};
wy.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "batch"
};
wy._availableBatchers = /* @__PURE__ */ Object.create(null);
let ky = wy;
ht.handleByMap(Ae.Batcher, ky._availableBatchers);
ht.add(uy);
const $Z = {
  name: "texture-bit",
  vertex: {
    header: (
      /* wgsl */
      `

        struct TextureUniforms {
            uTextureMatrix:mat3x3<f32>,
        }

        @group(2) @binding(2) var<uniform> textureUniforms : TextureUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            uv = (textureUniforms.uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            @group(2) @binding(0) var uTexture: texture_2d<f32>;
            @group(2) @binding(1) var uSampler: sampler;


        `
    ),
    main: (
      /* wgsl */
      `
            outColor = textureSample(uTexture, uSampler, vUV);
        `
    )
  }
}, DZ = {
  name: "texture-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTextureMatrix;
        `
    ),
    main: (
      /* glsl */
      `
            uv = (uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
        uniform sampler2D uTexture;


        `
    ),
    main: (
      /* glsl */
      `
            outColor = texture(uTexture, vUV);
        `
    )
  }
}, OZ = new Gn();
class LZ extends pf {
  constructor() {
    super(), this._placeholderSprite = new ks(et.EMPTY), this.filters = [new SZ({
      sprite: this._placeholderSprite,
      inverse: !1,
      resolution: "inherit",
      antialias: "inherit"
    })];
  }
  get sprite() {
    return this.filters[0].sprite;
  }
  set sprite(e) {
    this.filters[0].setSprite(e);
  }
  get inverse() {
    return this.filters[0].inverse;
  }
  set inverse(e) {
    this.filters[0].inverse = e;
  }
  get channel() {
    return this.filters[0].channel;
  }
  set channel(e) {
    this.filters[0].channel = e;
  }
  /**
   * Called by {@link BigPool} when the pipe returns the effect: parks the filter
   * on the empty placeholder so a pooled effect keeps no bindings to the last
   * mask it applied. Without this, the pooled filter pins the mask sprite and
   * its texture for as long as the effect sits in the pool, and destroying that
   * texture's source hits a bind group subscription the user cannot release.
   */
  reset() {
    this._placeholderSprite.texture = et.EMPTY, this.sprite = this._placeholderSprite;
  }
}
class _y {
  constructor(e) {
    this._activeMaskStage = [], this._usedEffects = [], this._renderer = e, e.runners.postrender.add(this);
  }
  push(e, t, i) {
    var o;
    const s = this._renderer;
    if (s.renderPipes.batch.break(i), i.add({
      renderPipeId: "alphaMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1,
      maskedContainer: t
    }), e.inverse = t._maskOptions.inverse, e.channel = (o = t._maskOptions.channel) != null ? o : "red", e.renderMaskToTexture) {
      const r = e.mask;
      r.includeInBuild = !0, r.collectRenderables(
        i,
        s,
        null
      ), r.includeInBuild = !1;
    }
    s.renderPipes.batch.break(i), i.add({
      renderPipeId: "alphaMask",
      action: "pushMaskEnd",
      mask: e,
      maskedContainer: t,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "alphaMask",
      action: "popMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(e) {
    const t = this._renderer, i = e.mask.renderMaskToTexture;
    if (e.action === "pushMaskBegin") {
      const s = $n.get(LZ);
      if (s.inverse = e.inverse, s.channel = e.mask.channel, i) {
        e.mask.mask.measurable = !0;
        const o = X1(e.mask.mask, !0, OZ);
        e.mask.mask.measurable = !1, o.ceil();
        const r = t.renderTarget.renderTarget.colorTexture.source, a = Nn.getOptimalTexture({
          width: o.width,
          height: o.height,
          resolution: r._resolution,
          antialias: r.antialias
        });
        t.renderTarget.push({ target: a, clear: !0 }), t.globalUniforms.push({
          offset: o,
          worldColor: 4294967295
        });
        const l = s.sprite;
        l.texture = a, l.worldTransform.tx = o.minX, l.worldTransform.ty = o.minY, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer,
          filterTexture: a
        });
      } else
        s.sprite = e.mask.mask, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer
        });
    } else if (e.action === "pushMaskEnd") {
      const s = this._activeMaskStage[this._activeMaskStage.length - 1];
      i && (t.type === rs.WEBGL && t.renderTarget.finishRenderPass(), t.renderTarget.pop(), t.globalUniforms.pop()), t.filter.push({
        renderPipeId: "filter",
        action: "pushFilter",
        container: s.maskedContainer,
        filterEffect: s.filterEffect,
        canBundle: !1
      });
    } else if (e.action === "popMaskEnd") {
      t.filter.pop();
      const s = this._activeMaskStage.pop();
      i && Nn.returnTexture(s.filterTexture), this._usedEffects.push(s.filterEffect);
    }
  }
  postrender() {
    const e = this._usedEffects;
    for (let t = 0; t < e.length; t++)
      $n.return(e[t]);
    e.length = 0;
  }
  destroy() {
    this.postrender(), this._renderer.runners.postrender.remove(this), this._renderer = null, this._activeMaskStage = null, this._usedEffects = null;
  }
}
_y.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "alphaMask"
};
class rT {
  constructor(e) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = e;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const s = this._colorStack;
    s[this._colorStackIndex] = s[this._colorStackIndex - 1] & e.mask;
    const o = this._colorStack[this._colorStackIndex];
    o !== this._currentColor && (this._currentColor = o, i.add({
      renderPipeId: "colorMask",
      colorMask: o,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const s = this._colorStack;
    this._colorStackIndex--;
    const o = s[this._colorStackIndex - 1];
    o !== this._currentColor && (this._currentColor = o, i.add({
      renderPipeId: "colorMask",
      colorMask: o,
      canBundle: !1
    }));
  }
  execute(e) {
  }
  destroy() {
    this._renderer = null, this._colorStack = null;
  }
}
rT.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "colorMask"
};
class aT {
  constructor(e) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = e;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const o = this._colorStack;
    o[this._colorStackIndex] = o[this._colorStackIndex - 1] & e.mask;
    const r = this._colorStack[this._colorStackIndex];
    r !== this._currentColor && (this._currentColor = r, i.add({
      renderPipeId: "colorMask",
      colorMask: r,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i);
    const o = this._colorStack;
    this._colorStackIndex--;
    const r = o[this._colorStackIndex - 1];
    r !== this._currentColor && (this._currentColor = r, i.add({
      renderPipeId: "colorMask",
      colorMask: r,
      canBundle: !1
    }));
  }
  execute(e) {
    this._renderer.colorMask.setMask(e.colorMask);
  }
  destroy() {
    this._renderer = null, this._colorStack = null;
  }
}
aT.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "colorMask"
};
function BZ(n, e, t, i, s, o) {
  o = Math.max(0, Math.min(o, Math.min(i, s) / 2)), n.moveTo(e + o, t), n.lineTo(e + i - o, t), n.quadraticCurveTo(e + i, t, e + i, t + o), n.lineTo(e + i, t + s - o), n.quadraticCurveTo(e + i, t + s, e + i - o, t + s), n.lineTo(e + o, t + s), n.quadraticCurveTo(e, t + s, e, t + s - o), n.lineTo(e, t + o), n.quadraticCurveTo(e, t, e + o, t);
}
function lT(n, e) {
  switch (e.type) {
    case "rectangle": {
      const t = e;
      n.rect(t.x, t.y, t.width, t.height);
      break;
    }
    case "roundedRectangle": {
      const t = e;
      BZ(n, t.x, t.y, t.width, t.height, t.radius);
      break;
    }
    case "circle": {
      const t = e;
      n.moveTo(t.x + t.radius, t.y), n.arc(t.x, t.y, t.radius, 0, Math.PI * 2);
      break;
    }
    case "ellipse": {
      const t = e;
      n.ellipse ? (n.moveTo(t.x + t.halfWidth, t.y), n.ellipse(t.x, t.y, t.halfWidth, t.halfHeight, 0, 0, Math.PI * 2)) : (n.save(), n.translate(t.x, t.y), n.scale(t.halfWidth, t.halfHeight), n.moveTo(1, 0), n.arc(0, 0, 1, 0, Math.PI * 2), n.restore());
      break;
    }
    case "triangle": {
      const t = e;
      n.moveTo(t.x, t.y), n.lineTo(t.x2, t.y2), n.lineTo(t.x3, t.y3), n.closePath();
      break;
    }
    default: {
      const t = e, i = t.points;
      if (!(i != null && i.length)) break;
      n.moveTo(i[0], i[1]);
      for (let s = 2; s < i.length; s += 2)
        n.lineTo(i[s], i[s + 1]);
      t.closePath && n.closePath();
      break;
    }
  }
}
function FZ(n, e, t) {
  var l;
  const i = [], s = [], o = [], r = Zl[e.type];
  if (!(r != null && r.build(e, i))) return !1;
  const a = (l = e.closePath) != null ? l : !0;
  py(i, t, !1, a, s, o);
  for (let d = 0; d < o.length; d += 3) {
    const c = o[d] * 2, h = o[d + 1] * 2, f = o[d + 2] * 2;
    n.moveTo(s[c], s[c + 1]), n.lineTo(s[h], s[h + 1]), n.lineTo(s[f], s[f + 1]), n.closePath();
  }
  return !0;
}
function NZ(n, e) {
  if (!(e != null && e.length)) return !1;
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    if (!(i != null && i.shape)) continue;
    const s = i.transform, o = s && !s.isIdentity();
    o && (n.save(), n.transform(s.a, s.b, s.c, s.d, s.tx, s.ty)), lT(n, i.shape), o && n.restore();
  }
  return !0;
}
class dT {
  constructor(e) {
    this._warnedMaskTypes = /* @__PURE__ */ new Set(), this._canvasMaskStack = [], this._renderer = e;
  }
  push(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(e, t, i) {
    this._renderer.renderPipes.batch.break(i), i.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(e) {
    var c, h, f;
    if (e.action !== "pushMaskBegin" && e.action !== "popMaskEnd")
      return;
    const t = this._renderer, i = t.canvasContext, s = i == null ? void 0 : i.activeContext;
    if (!s) return;
    if (e.action === "popMaskEnd") {
      this._canvasMaskStack.pop() && s.restore();
      return;
    }
    e.inverse && this._warnOnce(
      "inverse",
      "CanvasRenderer: inverse masks are not supported on Canvas2D; ignoring inverse flag."
    );
    const o = e.mask.mask;
    if (!(o instanceof Ko)) {
      this._warnOnce(
        "nonGraphics",
        "CanvasRenderer: only Graphics masks are supported in Canvas2D; skipping mask."
      ), this._canvasMaskStack.push(!1);
      return;
    }
    const r = o, a = (c = r.context) == null ? void 0 : c.instructions;
    if (!(a != null && a.length)) {
      this._canvasMaskStack.push(!1);
      return;
    }
    s.save(), i.setContextTransform(
      r.groupTransform,
      (t._roundPixels | r._roundPixels) === 1
    ), s.beginPath();
    let l = !1, d = !1;
    for (let p = 0; p < a.length; p++) {
      const y = a[p], v = y.action;
      if (v !== "fill" && v !== "stroke") continue;
      const x = y.data, w = (h = x == null ? void 0 : x.path) == null ? void 0 : h.shapePath;
      if (!((f = w == null ? void 0 : w.shapePrimitives) != null && f.length)) continue;
      const S = v === "stroke", M = w.shapePrimitives;
      for (let _ = 0; _ < M.length; _++) {
        const T = M[_];
        if (!(T != null && T.shape)) continue;
        const k = T.transform, P = k && !k.isIdentity();
        P && (s.save(), s.transform(k.a, k.b, k.c, k.d, k.tx, k.ty)), S && x.style ? l = FZ(
          s,
          T.shape,
          x.style
        ) || l : (lT(s, T.shape), d = NZ(s, T.holes) || d, l = !0), P && s.restore();
      }
    }
    if (!l) {
      s.restore(), this._canvasMaskStack.push(!1);
      return;
    }
    d ? s.clip("evenodd") : s.clip(), this._canvasMaskStack.push(!0);
  }
  destroy() {
    this._renderer = null, this._warnedMaskTypes = null, this._canvasMaskStack = null;
  }
  _warnOnce(e, t) {
    this._warnedMaskTypes.has(e) || (this._warnedMaskTypes.add(e), dt(t));
  }
}
dT.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "stencilMask"
};
class cT {
  constructor(e) {
    this._maskHash = /* @__PURE__ */ new WeakMap(), this._renderer = e;
  }
  push(e, t, i) {
    const s = e, o = this._renderer;
    o.renderPipes.batch.break(i), o.renderPipes.blendMode.setBlendMode(s.mask, "none", i), i.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const r = s.mask;
    r.includeInBuild = !0, this._maskHash.has(s) || this._maskHash.set(s, {
      instructionsStart: 0,
      instructionsLength: 0
    });
    const a = this._maskHash.get(s);
    a.instructionsStart = i.instructionSize, r.collectRenderables(
      i,
      o,
      null
    ), r.includeInBuild = !1, o.renderPipes.batch.break(i), i.add({
      renderPipeId: "stencilMask",
      action: "pushMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const l = i.instructionSize - a.instructionsStart - 1;
    a.instructionsLength = l;
  }
  pop(e, t, i) {
    const s = e, o = this._renderer;
    o.renderPipes.batch.break(i), o.renderPipes.blendMode.setBlendMode(s.mask, "none", i), i.add({
      renderPipeId: "stencilMask",
      action: "popMaskBegin",
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const r = this._maskHash.get(e);
    for (let a = 0; a < r.instructionsLength; a++)
      i.instructions[i.instructionSize++] = i.instructions[r.instructionsStart++];
    i.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      canBundle: !1
    });
  }
  execute(e) {
    const i = this._renderer, s = i.renderTarget.getGpuRenderTarget(i.renderTarget.renderTarget);
    let o = s.maskStackIndex;
    e.action === "pushMaskBegin" ? (i.renderTarget.ensureDepthStencil(), i.stencil.setStencilMode(fn.RENDERING_MASK_ADD, o), o++, i.colorMask.setMask(0)) : e.action === "pushMaskEnd" ? (e.inverse ? i.stencil.setStencilMode(fn.INVERSE_MASK_ACTIVE, o) : i.stencil.setStencilMode(fn.MASK_ACTIVE, o), i.colorMask.setMask(15)) : e.action === "popMaskBegin" ? (i.colorMask.setMask(0), o !== 0 ? i.stencil.setStencilMode(fn.RENDERING_MASK_REMOVE, o) : (i.renderTarget.clear(null, Tn.STENCIL), i.stencil.setStencilMode(fn.DISABLED, o)), o--) : e.action === "popMaskEnd" && (e.inverse ? i.stencil.setStencilMode(fn.INVERSE_MASK_ACTIVE, o) : i.stencil.setStencilMode(fn.MASK_ACTIVE, o), i.colorMask.setMask(15)), s.maskStackIndex = o;
  }
  destroy() {
    this._renderer = null, this._maskHash = null;
  }
}
cT.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "stencilMask"
};
const Gt = "source-over";
function UZ() {
  const n = VM(), e = /* @__PURE__ */ Object.create(null);
  return e.inherit = Gt, e.none = Gt, e.normal = "source-over", e.add = "lighter", e.multiply = n ? "multiply" : Gt, e.screen = n ? "screen" : Gt, e.overlay = n ? "overlay" : Gt, e.darken = n ? "darken" : Gt, e.lighten = n ? "lighten" : Gt, e["color-dodge"] = n ? "color-dodge" : Gt, e["color-burn"] = n ? "color-burn" : Gt, e["hard-light"] = n ? "hard-light" : Gt, e["soft-light"] = n ? "soft-light" : Gt, e.difference = n ? "difference" : Gt, e.exclusion = n ? "exclusion" : Gt, e.saturation = n ? "saturation" : Gt, e.color = n ? "color" : Gt, e.luminosity = n ? "luminosity" : Gt, e["linear-burn"] = n ? "color-burn" : Gt, e["linear-dodge"] = n ? "color-dodge" : Gt, e["linear-light"] = n ? "hard-light" : Gt, e["pin-light"] = n ? "hard-light" : Gt, e["vivid-light"] = n ? "hard-light" : Gt, e["hard-mix"] = Gt, e.negation = n ? "difference" : Gt, e["normal-npm"] = e.normal, e["add-npm"] = e.add, e["screen-npm"] = e.screen, e.erase = "destination-out", e.subtract = Gt, e.divide = Gt, e.min = Gt, e.max = Gt, e;
}
const GZ = new ot();
class uT {
  /**
   * @param renderer - The owning CanvasRenderer.
   */
  constructor(e) {
    this.activeResolution = 1, this.smoothProperty = "imageSmoothingEnabled", this.blendModes = UZ(), this._activeBlendMode = "normal", this._projTransform = null, this._outerBlend = !1, this._warnedBlendModes = /* @__PURE__ */ new Set(), this._renderer = e;
  }
  resolutionChange(e) {
    this.activeResolution = e;
  }
  /** Initializes the root context and smoothing flag selection. */
  init() {
    const e = this._renderer.background.alpha < 1;
    if (this.rootContext = this._renderer.canvas.getContext(
      "2d",
      { alpha: e }
    ), this.activeContext = this.rootContext, this.activeResolution = this._renderer.resolution, !this.rootContext.imageSmoothingEnabled) {
      const t = this.rootContext;
      t.webkitImageSmoothingEnabled ? this.smoothProperty = "webkitImageSmoothingEnabled" : t.mozImageSmoothingEnabled ? this.smoothProperty = "mozImageSmoothingEnabled" : t.oImageSmoothingEnabled ? this.smoothProperty = "oImageSmoothingEnabled" : t.msImageSmoothingEnabled && (this.smoothProperty = "msImageSmoothingEnabled");
    }
  }
  /**
   * Sets the current transform on the active context.
   * @param transform - Transform to apply.
   * @param roundPixels - Whether to round translation to integers.
   * @param localResolution - Optional local resolution multiplier.
   * @param skipGlobalTransform - If true, skip applying the global world transform matrix.
   */
  setContextTransform(e, t, i, s) {
    var d;
    const o = s ? ot.IDENTITY : ((d = this._renderer.globalUniforms.globalUniformData) == null ? void 0 : d.worldTransformMatrix) || ot.IDENTITY;
    let r = GZ;
    r.copyFrom(o), r.append(e);
    const a = this._projTransform, l = this.activeResolution;
    if (i = i || l, a) {
      const c = ot.shared;
      c.copyFrom(r), c.prepend(a), r = c;
    }
    t ? this.activeContext.setTransform(
      r.a * i,
      r.b * i,
      r.c * i,
      r.d * i,
      r.tx * l | 0,
      r.ty * l | 0
    ) : this.activeContext.setTransform(
      r.a * i,
      r.b * i,
      r.c * i,
      r.d * i,
      r.tx * l,
      r.ty * l
    );
  }
  /**
   * Clears the current render target, optionally filling with a color.
   * @param clearColor - Color to fill after clearing.
   * @param alpha - Alpha override for the clear color.
   */
  clear(e, t) {
    const i = this.activeContext, s = this._renderer;
    if (i.clearRect(0, 0, s.width, s.height), e) {
      const o = vn.shared.setValue(e);
      i.globalAlpha = t != null ? t : o.alpha, i.fillStyle = o.toHex(), i.fillRect(0, 0, s.width, s.height), i.globalAlpha = 1;
    }
  }
  /**
   * Sets the active blend mode.
   * @param blendMode - Pixi blend mode.
   */
  setBlendMode(e) {
    if (this._activeBlendMode === e) return;
    this._activeBlendMode = e, this._outerBlend = !1;
    const t = this.blendModes[e];
    if (!t) {
      this._warnedBlendModes.has(e) || (console.warn(
        `CanvasRenderer: blend mode "${e}" is not supported in Canvas2D; falling back to "source-over".`
      ), this._warnedBlendModes.add(e)), this.activeContext.globalCompositeOperation = "source-over";
      return;
    }
    this.activeContext.globalCompositeOperation = t;
  }
  /** Releases context references. */
  destroy() {
    this.rootContext = null, this.activeContext = null, this._warnedBlendModes.clear();
  }
}
uT.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "canvasContext"
};
class hT {
  constructor() {
    this.maxTextures = 16, this.maxBatchableTextures = 16, this.maxUniformBindings = 0;
  }
  init() {
  }
}
hT.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "limits"
};
class Sy {
  constructor(e) {
    this._renderer = e;
  }
  updateRenderable() {
  }
  destroyRenderable() {
  }
  validateRenderable() {
    return !1;
  }
  addRenderable(e, t) {
    this._renderer.renderPipes.batch.break(t), t.add(e);
  }
  execute(e) {
    e.isRenderable && e.render(this._renderer);
  }
  destroy() {
    this._renderer = null;
  }
}
Sy.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "customRender"
};
function p0(n, e) {
  const t = n.instructionSet, i = t.instructions;
  for (let s = 0; s < t.instructionSize; s++) {
    const o = i[s];
    e[o.renderPipeId].execute(o);
  }
}
class My {
  constructor(e) {
    this._renderer = e;
  }
  addRenderGroup(e, t) {
    e.isCachedAsTexture ? this._addRenderableCacheAsTexture(e, t) : this._addRenderableDirect(e, t);
  }
  execute(e) {
    e.isRenderable && (e.isCachedAsTexture ? this._executeCacheAsTexture(e) : this._executeDirect(e));
  }
  destroy() {
    this._renderer = null;
  }
  _addRenderableDirect(e, t) {
    this._renderer.renderPipes.batch.break(t), e._batchableRenderGroup && ($n.return(e._batchableRenderGroup), e._batchableRenderGroup = null), t.add(e);
  }
  _addRenderableCacheAsTexture(e, t) {
    var s;
    const i = (s = e._batchableRenderGroup) != null ? s : e._batchableRenderGroup = $n.get(nT);
    i.renderable = e.root, i.transform = e.root.relativeGroupTransform, i.texture = e.texture, i.bounds = e._textureBounds, t.add(e), this._renderer.renderPipes.blendMode.pushBlendMode(e, e.root.groupBlendMode, t), this._renderer.renderPipes.batch.addToBatch(i, t), this._renderer.renderPipes.blendMode.popBlendMode(t);
  }
  _executeCacheAsTexture(e) {
    if (e.textureNeedsUpdate) {
      e.textureNeedsUpdate = !1;
      const t = new ot().translate(
        -e._textureBounds.x,
        -e._textureBounds.y
      );
      this._renderer.renderTarget.push({
        target: e.texture,
        clear: !0,
        frame: e.texture.frame
      }), this._renderer.globalUniforms.push({
        worldTransformMatrix: t,
        worldColor: 4294967295,
        offset: { x: 0, y: 0 }
      }), p0(e, this._renderer.renderPipes), this._renderer.renderTarget.finishRenderPass(), this._renderer.renderTarget.pop(), this._renderer.globalUniforms.pop();
    }
    e._batchableRenderGroup._batcher.updateElement(e._batchableRenderGroup), e._batchableRenderGroup._batcher.geometry.buffers[0].update();
  }
  _executeDirect(e) {
    this._renderer.globalUniforms.push({
      worldTransformMatrix: e.inverseParentTextureTransform,
      worldColor: e.worldColorAlpha
    }), p0(e, this._renderer.renderPipes), this._renderer.globalUniforms.pop();
  }
}
My.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "renderGroup"
};
const jZ = "#808080", gh = new ot(), HZ = new ot(), VZ = new ot(), Kg = new ot(), WZ = new ot();
function qZ(n, e, t) {
  n.beginPath();
  for (let i = 0; i < t.length; i += 3) {
    const s = t[i] * 2, o = t[i + 1] * 2, r = t[i + 2] * 2;
    n.moveTo(e[s], e[s + 1]), n.lineTo(e[o], e[o + 1]), n.lineTo(e[r], e[r + 1]), n.closePath();
  }
  n.fill();
}
function KZ(n) {
  return `#${(n & 16777215).toString(16).padStart(6, "0")}`;
}
function YZ(n, e, t, i, s, o) {
  o = Math.max(0, Math.min(o, Math.min(i, s) / 2)), n.moveTo(e + o, t), n.lineTo(e + i - o, t), n.quadraticCurveTo(e + i, t, e + i, t + o), n.lineTo(e + i, t + s - o), n.quadraticCurveTo(e + i, t + s, e + i - o, t + s), n.lineTo(e + o, t + s), n.quadraticCurveTo(e, t + s, e, t + s - o), n.lineTo(e, t + o), n.quadraticCurveTo(e, t, e + o, t);
}
function Sp(n, e) {
  switch (e.type) {
    case "rectangle": {
      const t = e;
      n.rect(t.x, t.y, t.width, t.height);
      break;
    }
    case "roundedRectangle": {
      const t = e;
      YZ(n, t.x, t.y, t.width, t.height, t.radius);
      break;
    }
    case "circle": {
      const t = e;
      n.arc(t.x, t.y, t.radius, 0, Math.PI * 2);
      break;
    }
    case "ellipse": {
      const t = e;
      n.ellipse ? n.ellipse(t.x, t.y, t.halfWidth, t.halfHeight, 0, 0, Math.PI * 2) : (n.save(), n.translate(t.x, t.y), n.scale(t.halfWidth, t.halfHeight), n.arc(0, 0, 1, 0, Math.PI * 2), n.restore());
      break;
    }
    case "triangle": {
      const t = e;
      n.moveTo(t.x, t.y), n.lineTo(t.x2, t.y2), n.lineTo(t.x3, t.y3), n.closePath();
      break;
    }
    default: {
      const t = e, i = t.points;
      if (!(i != null && i.length)) break;
      n.moveTo(i[0], i[1]);
      for (let s = 2; s < i.length; s += 2)
        n.lineTo(i[s], i[s + 1]);
      t.closePath && n.closePath();
      break;
    }
  }
}
function XZ(n, e) {
  if (!(e != null && e.length)) return !1;
  for (let t = 0; t < e.length; t++) {
    const i = e[t];
    if (!(i != null && i.shape)) continue;
    const s = i.transform, o = s && !s.isIdentity();
    o && (n.save(), n.transform(s.a, s.b, s.c, s.d, s.tx, s.ty)), Sp(n, i.shape), o && n.restore();
  }
  return !0;
}
function JZ(n, e, t, i) {
  const s = n.fill;
  if (s instanceof Jl) {
    s.buildGradient();
    const r = s.texture;
    if (r) {
      const a = St.getTintedPattern(r, e), l = t ? Kg.copyFrom(t).scale(r.source.pixelWidth, r.source.pixelHeight) : Kg.copyFrom(s.transform);
      return i && !n.textureSpace && l.append(i), St.applyPatternTransform(a, l), a;
    }
  }
  if (s instanceof GM) {
    const r = St.getTintedPattern(s.texture, e);
    return St.applyPatternTransform(r, s.transform, !1), r;
  }
  const o = n.texture;
  if (o && o !== et.WHITE) {
    if (!o.source.resource)
      return jZ;
    const r = St.getTintedPattern(o, e);
    let a = n.matrix;
    if (t) {
      const { resolution: l } = o.source;
      if (a = Kg.copyFrom(t), o.rotate) {
        const { uvs: d, orig: c } = o;
        a.prepend(WZ.set(
          d.x1 - d.x0,
          d.y1 - d.y0,
          d.x3 - d.x0,
          d.y3 - d.y0,
          d.x0,
          d.y0
        ).invert()).scale(c.width * l, c.height * l);
      } else
        a.scale(o.source.pixelWidth, o.source.pixelHeight).translate(-o.frame.x * l, -o.frame.y * l);
    }
    return St.applyPatternTransform(r, a), r;
  }
  return KZ(e);
}
class pT {
  constructor() {
    this.shader = null;
  }
  contextChange(e) {
  }
  execute(e, t) {
    var S, M, _, T, k, P, A, R, D, O, F, ie;
    const i = e.renderer, s = i.canvasContext, o = s.activeContext, r = t.groupTransform, a = (M = (S = i.globalUniforms.globalUniformData) == null ? void 0 : S.worldColor) != null ? M : 4294967295, l = t.groupColorAlpha, d = (a >>> 24 & 255) / 255, c = (l >>> 24 & 255) / 255, h = (T = (_ = i.filter) == null ? void 0 : _.alphaMultiplier) != null ? T : 1, f = d * c * h;
    if (f <= 0) return;
    const p = a & 16777215, y = l & 16777215, v = oa(sa(y, p)), x = i._roundPixels | t._roundPixels;
    o.save(), s.setContextTransform(r, x === 1), s.setBlendMode(t.groupBlendMode);
    const w = t.context.instructions;
    for (let ee = 0; ee < w.length; ee++) {
      const me = w[ee];
      if (me.action === "texture") {
        const Q = me.data, ne = Q.image, ue = ne ? St.getCanvasSource(ne) : null;
        if (!ue) continue;
        const Z = Q.alpha * f;
        if (Z <= 0) continue;
        const te = sa(Q.style, v);
        o.globalAlpha = Z;
        let we = ue;
        te !== 16777215 && (we = St.getTintedCanvas({ texture: ne }, te));
        const Fe = ne.frame, Me = (P = (k = ne.source._resolution) != null ? k : ne.source.resolution) != null ? P : 1;
        let he = Fe.x * Me, U = Fe.y * Me;
        const q = Fe.width * Me, oe = Fe.height * Me;
        we !== ue && (he = 0, U = 0);
        const de = Q.transform, pe = de && !de.isIdentity(), Ce = ne.rotate;
        pe || Ce ? (gh.copyFrom(r), pe && gh.append(de), Ce && Mt.matrixAppendRotationInv(gh, Ce, Q.dx, Q.dy, Q.dw, Q.dh), s.setContextTransform(gh, x === 1)) : s.setContextTransform(r, x === 1), o.drawImage(
          we,
          he,
          U,
          we === ue ? q : we.width,
          we === ue ? oe : we.height,
          Ce ? 0 : Q.dx,
          Ce ? 0 : Q.dy,
          Q.dw,
          Q.dh
        ), (pe || Ce) && s.setContextTransform(r, x === 1);
        continue;
      }
      const L = me.data, N = (A = L == null ? void 0 : L.path) == null ? void 0 : A.shapePath;
      if (!((R = N == null ? void 0 : N.shapePrimitives) != null && R.length)) continue;
      const K = L.style, B = sa(K.color, v), re = K.alpha * f;
      if (re <= 0) continue;
      const H = me.action === "stroke";
      if (o.globalAlpha = re, H) {
        const Q = K;
        o.lineWidth = Q.width, o.lineCap = Q.cap, o.lineJoin = Q.join, o.miterLimit = Q.miterLimit;
      }
      const J = N.shapePrimitives;
      if (!H && ((F = (O = (D = L.hole) == null ? void 0 : D.shapePath) == null ? void 0 : O.shapePrimitives) != null && F.length)) {
        const Q = J[J.length - 1];
        Q.holes = L.hole.shapePath.shapePrimitives;
      }
      for (let Q = 0; Q < J.length; Q++) {
        const ne = J[Q];
        if (!(ne != null && ne.shape)) continue;
        const ue = ne.transform, Z = ue && !ue.isIdentity(), te = K.texture && K.texture !== et.WHITE, we = K.textureSpace === "global" ? ue : null, Fe = te ? DM(HZ, K, ne.shape, we) : null, Me = Z ? VZ.copyFrom(r).append(ue) : r, he = JZ(
          K,
          B,
          Fe,
          Me
        );
        if (Z && (o.save(), o.transform(ue.a, ue.b, ue.c, ue.d, ue.tx, ue.ty)), H) {
          const U = K;
          if (U.alignment !== 0.5 && !U.pixelLine) {
            const oe = [], de = [], pe = [], Ce = Zl[ne.shape.type];
            if (Ce != null && Ce.build(ne.shape, oe)) {
              const Be = (ie = ne.shape.closePath) != null ? ie : !0;
              py(oe, U, !1, Be, de, pe), o.fillStyle = he, qZ(o, de, pe);
            } else
              o.strokeStyle = he, o.beginPath(), Sp(o, ne.shape), o.stroke();
          } else
            o.strokeStyle = he, o.beginPath(), Sp(o, ne.shape), o.stroke();
        } else
          o.fillStyle = he, o.beginPath(), Sp(o, ne.shape), XZ(o, ne.holes) ? o.fill("evenodd") : o.fill();
        Z && o.restore();
      }
    }
    o.restore();
  }
  destroy() {
    this.shader = null;
  }
}
pT.extension = {
  type: [
    Ae.CanvasPipesAdaptor
  ],
  name: "graphics"
};
class Ty {
  constructor(e) {
    this._renderer = e;
  }
  addRenderable(e, t) {
    const i = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, i), this._renderer.renderPipes.batch.addToBatch(i, t);
  }
  updateRenderable(e) {
    const t = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  _updateBatchableSprite(e, t) {
    t.bounds = e.visualBounds, t.texture = e._texture;
  }
  _getGpuSprite(e) {
    return e._gpuData[this._renderer.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = new nT();
    return t.renderable = e, t.transform = e.groupTransform, t.texture = e._texture, t.bounds = e.visualBounds, t.roundPixels = this._renderer._roundPixels | e._roundPixels, e._gpuData[this._renderer.uid] = t, t;
  }
  destroy() {
    this._renderer = null;
  }
}
Ty.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "sprite"
};
const wc = {};
ht.handle(Ae.BlendMode, (n) => {
  if (!n.name)
    throw new Error("BlendMode extension must have a name property");
  wc[n.name] = n.ref;
}, (n) => {
  delete wc[n.name];
});
class Cy {
  constructor(e) {
    this._blendModeStack = [], this._isAdvanced = !1, this._filterHash = /* @__PURE__ */ Object.create(null), this._renderer = e, this._renderer.runners.prerender.add(this);
  }
  prerender() {
    this._activeBlendMode = "normal", this._isAdvanced = !1;
  }
  /**
   * Push a blend mode onto the internal stack and apply it to the instruction set if needed.
   * @param renderable - The renderable or {@link RenderGroup} associated with the change.
   * @param blendMode - The blend mode to activate.
   * @param instructionSet - The instruction set being built.
   */
  pushBlendMode(e, t, i) {
    this._blendModeStack.push(t), this.setBlendMode(e, t, i);
  }
  /**
   * Pop the last blend mode from the stack and apply the new top-of-stack mode.
   * @param instructionSet - The instruction set being built.
   */
  popBlendMode(e) {
    var i;
    this._blendModeStack.pop();
    const t = (i = this._blendModeStack[this._activeBlendMode.length - 1]) != null ? i : "normal";
    this.setBlendMode(null, t, e);
  }
  /**
   * Ensure a blend mode switch is added to the instruction set when the mode changes.
   * If an advanced blend mode is active, subsequent renderables will be collected so they can be
   * rendered within a single filter pass.
   * @param renderable - The renderable or {@link RenderGroup} to associate with the change, or null when unwinding.
   * @param blendMode - The target blend mode.
   * @param instructionSet - The instruction set being built.
   */
  setBlendMode(e, t, i) {
    var o;
    const s = e instanceof Wv;
    if (this._activeBlendMode === t) {
      this._isAdvanced && e && !s && ((o = this._renderableList) == null || o.push(e));
      return;
    }
    this._isAdvanced && this._endAdvancedBlendMode(i), this._activeBlendMode = t, e && (this._isAdvanced = !!wc[t], this._isAdvanced && this._beginAdvancedBlendMode(e, i));
  }
  _beginAdvancedBlendMode(e, t) {
    this._renderer.renderPipes.batch.break(t);
    const i = this._activeBlendMode;
    if (!wc[i]) {
      dt(`Unable to assign BlendMode: '${i}'. You may want to include: import 'pixi.js/advanced-blend-modes'`);
      return;
    }
    const s = this._ensureFilterEffect(i), o = e instanceof Wv, r = {
      renderPipeId: "filter",
      action: "pushFilter",
      filterEffect: s,
      renderables: o ? null : [e],
      container: o ? e.root : null,
      canBundle: !1
    };
    this._renderableList = r.renderables, t.add(r);
  }
  _ensureFilterEffect(e) {
    let t = this._filterHash[e];
    return t || (t = this._filterHash[e] = new pf(), t.filters = [new wc[e]()]), t;
  }
  _endAdvancedBlendMode(e) {
    this._isAdvanced = !1, this._renderableList = null, this._renderer.renderPipes.batch.break(e), e.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  /**
   * called when the instruction build process is starting this will reset internally to the default blend mode
   * @internal
   */
  buildStart() {
    this._isAdvanced = !1;
  }
  /**
   * called when the instruction build process is finished, ensuring that if there is an advanced blend mode
   * active, we add the final render instructions added to the instruction set
   * @param instructionSet - The instruction set we are adding to
   * @internal
   */
  buildEnd(e) {
    this._isAdvanced && this._endAdvancedBlendMode(e);
  }
  /** @internal */
  destroy() {
    this._renderer = null, this._renderableList = null;
    for (const e in this._filterHash)
      this._filterHash[e].destroy();
    this._filterHash = null;
  }
}
Cy.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes,
    Ae.CanvasPipes
  ],
  name: "blendMode"
};
function f0(n, e) {
  e || (e = 0);
  for (let t = e; t < n.length && n[t]; t++)
    n[t] = null;
}
const ZZ = new mn(), F2 = bc | mf | ey;
function fT(n, e = !1) {
  QZ(n);
  const t = n.childrenToUpdate, i = n.updateTick++;
  for (const s in t) {
    const o = Number(s), r = t[s], a = r.list, l = r.index;
    for (let d = 0; d < l; d++) {
      const c = a[d];
      c.parentRenderGroup === n && c.relativeRenderGroupDepth === o && mT(c, i, 0);
    }
    f0(a, l), r.index = 0;
  }
  if (e)
    for (let s = 0; s < n.renderGroupChildren.length; s++)
      fT(n.renderGroupChildren[s], e);
}
function QZ(n) {
  const e = n.root;
  let t;
  if (n.renderGroupParent) {
    const i = n.renderGroupParent;
    n.worldTransform.appendFrom(
      e.relativeGroupTransform,
      i.worldTransform
    ), n.worldColor = ff(
      e.groupColor,
      i.worldColor
    ), t = e.groupAlpha * i.worldAlpha;
  } else
    n.worldTransform.copyFrom(e.localTransform), n.worldColor = e.localColor, t = e.localAlpha;
  t = t < 0 ? 0 : t > 1 ? 1 : t, n.worldAlpha = t, n.worldColorAlpha = n.worldColor + ((t * 255 | 0) << 24);
}
function mT(n, e, t) {
  if (e === n.updateTick) return;
  n.updateTick = e, n.didChange = !1;
  const i = n.localTransform;
  n.updateLocalTransform();
  const s = n.parent;
  if (s && !s.renderGroup ? (t |= n._updateFlags, n.relativeGroupTransform.appendFrom(
    i,
    s.relativeGroupTransform
  ), t & F2 && N2(n, s, t)) : (t = n._updateFlags, n.relativeGroupTransform.copyFrom(i), t & F2 && N2(n, ZZ, t)), !n.renderGroup) {
    const o = n.children, r = o.length;
    for (let d = 0; d < r; d++)
      mT(o[d], e, t);
    const a = n.parentRenderGroup, l = n;
    l.renderPipeId && !a.structureDidChange && a.updateRenderable(l);
  }
}
function N2(n, e, t) {
  if (t & mf) {
    n.groupColor = ff(
      n.localColor,
      e.groupColor
    );
    let i = n.localAlpha * e.groupAlpha;
    i = i < 0 ? 0 : i > 1 ? 1 : i, n.groupAlpha = i, n.groupColorAlpha = n.groupColor + ((i * 255 | 0) << 24);
  }
  t & ey && (n.groupBlendMode = n.localBlendMode === "inherit" ? e.groupBlendMode : n.localBlendMode), t & bc && (n.globalDisplayStatus = n.localDisplayStatus & e.globalDisplayStatus), n._updateFlags = 0;
}
function eQ(n, e) {
  const { list: t } = n.childrenRenderablesToUpdate;
  let i = !1;
  for (let s = 0; s < n.childrenRenderablesToUpdate.index; s++) {
    const o = t[s];
    if (i = e[o.renderPipeId].validateRenderable(o), i)
      break;
  }
  return n.structureDidChange = i, i;
}
const tQ = new ot();
class gT {
  constructor(e) {
    this._renderer = e;
  }
  render({ container: e, transform: t }) {
    const i = e.parent, s = e.renderGroup.renderGroupParent;
    e.parent = null, e.renderGroup.renderGroupParent = null;
    const o = this._renderer, r = tQ;
    t && (r.copyFrom(e.renderGroup.localTransform), e.renderGroup.localTransform.copyFrom(t));
    const a = o.renderPipes;
    this._updateCachedRenderGroups(e.renderGroup, null), this._updateRenderGroups(e.renderGroup), o.globalUniforms.start({
      worldTransformMatrix: t ? e.renderGroup.localTransform : e.renderGroup.worldTransform,
      worldColor: e.renderGroup.worldColorAlpha
    }), p0(e.renderGroup, a), a.uniformBatch && a.uniformBatch.renderEnd(), t && e.renderGroup.localTransform.copyFrom(r), e.parent = i, e.renderGroup.renderGroupParent = s;
  }
  destroy() {
    this._renderer = null;
  }
  _updateCachedRenderGroups(e, t) {
    var i, s;
    if (e._parentCacheAsTextureRenderGroup = t, e.isCachedAsTexture) {
      if (!e.textureNeedsUpdate) return;
      t = e;
    }
    for (let o = e.renderGroupChildren.length - 1; o >= 0; o--)
      this._updateCachedRenderGroups(e.renderGroupChildren[o], t);
    if (e.invalidateMatrices(), e.isCachedAsTexture) {
      if (e.textureNeedsUpdate) {
        const o = e.root.getLocalBounds(), r = this._renderer, a = e.textureOptions.resolution || r.view.resolution, l = (i = e.textureOptions.antialias) != null ? i : r.view.antialias, d = (s = e.textureOptions.scaleMode) != null ? s : "linear", c = e.texture;
        o.ceil(), e.texture && Nn.returnTexture(e.texture);
        const h = Nn.getOptimalTexture({
          width: o.width,
          height: o.height,
          resolution: a,
          antialias: l,
          scaleMode: d
        });
        e.texture = h, e._textureBounds || (e._textureBounds = new Gn()), e._textureBounds.copyFrom(o), c !== e.texture && e.renderGroupParent && (e.renderGroupParent.structureDidChange = !0);
      }
    } else e.texture && (Nn.returnTexture(e.texture), e.texture = null);
  }
  _updateRenderGroups(e) {
    const t = this._renderer, i = t.renderPipes;
    if (e.runOnRender(t), e.instructionSet.renderPipes = i, e.structureDidChange ? f0(e.childrenRenderablesToUpdate.list, 0) : eQ(e, i), fT(e), e.structureDidChange ? (e.structureDidChange = !1, this._buildInstructions(e, t)) : this._updateRenderables(e), e.childrenRenderablesToUpdate.index = 0, t.renderPipes.batch.upload(e.instructionSet), !(e.isCachedAsTexture && !e.textureNeedsUpdate))
      for (let s = 0; s < e.renderGroupChildren.length; s++)
        this._updateRenderGroups(e.renderGroupChildren[s]);
  }
  _updateRenderables(e) {
    const { list: t, index: i } = e.childrenRenderablesToUpdate;
    for (let s = 0; s < i; s++) {
      const o = t[s];
      o.didViewUpdate && e.updateRenderable(o);
    }
    f0(t, i);
  }
  _buildInstructions(e, t) {
    const i = e.root, s = e.instructionSet;
    s.reset();
    const o = t.renderPipes ? t : t.batch.renderer, r = o.renderPipes;
    r.batch.buildStart(s), r.blendMode.buildStart(), r.colorMask.buildStart(), i.sortableChildren && i.sortChildren(), i.collectRenderablesWithEffects(s, o, null), r.batch.buildEnd(s), r.blendMode.buildEnd(s);
  }
}
gT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "renderGroup"
};
const Iy = class bT {
  constructor() {
    this.clearBeforeRender = !0, this._backgroundColor = new vn(0), this.color = this._backgroundColor, this.alpha = 1;
  }
  /**
   * initiates the background system
   * @param options - the options for the background colors
   */
  init(e) {
    e = { ...bT.defaultOptions, ...e }, this.clearBeforeRender = e.clearBeforeRender, this.color = e.background || e.backgroundColor || this._backgroundColor, this.alpha = e.backgroundAlpha, this._backgroundColor.setAlpha(e.backgroundAlpha);
  }
  /** The background color to fill if not transparent */
  get color() {
    return this._backgroundColor;
  }
  set color(e) {
    vn.shared.setValue(e).alpha < 1 && this._backgroundColor.alpha === 1 && dt(
      "Cannot set a transparent background on an opaque canvas. To enable transparency, set backgroundAlpha < 1 when initializing your Application."
    ), this._backgroundColor.setValue(e);
  }
  /** The background color alpha. Setting this to 0 will make the canvas transparent. */
  get alpha() {
    return this._backgroundColor.alpha;
  }
  set alpha(e) {
    this._backgroundColor.setAlpha(e);
  }
  /** The background color as an [R, G, B, A] array. */
  get colorRgba() {
    return this._backgroundColor.toArray();
  }
  /**
   * destroys the background system
   * @internal
   */
  destroy() {
  }
};
Iy.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "background",
  priority: 0
};
Iy.defaultOptions = {
  /**
   * {@link WebGLOptions.backgroundAlpha}
   * @default 1
   */
  backgroundAlpha: 1,
  /**
   * {@link WebGLOptions.backgroundColor}
   * @default 0x000000
   */
  backgroundColor: 0,
  /**
   * {@link WebGLOptions.clearBeforeRender}
   * @default true
   */
  clearBeforeRender: !0
};
let nQ = Iy;
const Yg = {
  png: "image/png",
  jpg: "image/jpeg",
  webp: "image/webp"
}, Ay = class vT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e;
  }
  _normalizeOptions(e, t = {}) {
    return e instanceof mn || e instanceof et ? {
      target: e,
      ...t
    } : {
      ...t,
      ...e
    };
  }
  /**
   * Creates an IImage from a display object or texture.
   * @param options - Options for creating the image, or the target to extract
   * @returns Promise that resolves with the generated IImage
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const image = await renderer.extract.image(sprite);
   * document.body.appendChild(image);
   *
   * // Advanced usage with options
   * const image = await renderer.extract.image({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2,
   *     clearColor: '#ff0000',
   *     antialias: true
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const image = await renderer.extract.image(texture);
   * ```
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.base64} For base64 string output
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ImageLike} For the image interface
   * @category rendering
   */
  async image(e) {
    const t = zt.get().createImage();
    return t.src = await this.base64(e), t;
  }
  /**
   * Converts the target into a base64 encoded string.
   *
   * This method works by first creating
   * a canvas using `Extract.canvas` and then converting it to a base64 string.
   * @param options - The options for creating the base64 string, or the target to extract
   * @returns Promise that resolves with the base64 encoded string
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const base64 = await renderer.extract.base64(sprite);
   * console.log(base64); // data:image/png;base64,...
   *
   * // Advanced usage with options
   * const base64 = await renderer.extract.base64({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2
   * });
   * ```
   * @throws Will throw an error if the platform doesn't support any of:
   * - ICanvas.toDataURL
   * - ICanvas.toBlob
   * - ICanvas.convertToBlob
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @category rendering
   */
  async base64(e) {
    e = this._normalizeOptions(
      e,
      vT.defaultImageOptions
    );
    const { format: t, quality: i } = e, s = this.canvas(e);
    if (s.toBlob !== void 0)
      return new Promise((o, r) => {
        s.toBlob((a) => {
          if (!a) {
            r(new Error("ICanvas.toBlob failed!"));
            return;
          }
          const l = new FileReader();
          l.onload = () => o(l.result), l.onerror = r, l.readAsDataURL(a);
        }, Yg[t], i);
      });
    if (s.toDataURL !== void 0)
      return s.toDataURL(Yg[t], i);
    if (s.convertToBlob !== void 0) {
      const o = await s.convertToBlob({ type: Yg[t], quality: i });
      return new Promise((r, a) => {
        const l = new FileReader();
        l.onload = () => r(l.result), l.onerror = a, l.readAsDataURL(o);
      });
    }
    throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
  }
  /**
   * Creates a Canvas element, renders the target to it and returns it.
   * This method is useful for creating static images or when you need direct canvas access.
   * @param options - The options for creating the canvas, or the target to extract
   * @returns A Canvas element with the texture rendered on
   * @example
   * ```ts
   * // Basic canvas extraction from a sprite
   * const sprite = new Sprite(texture);
   * const canvas = renderer.extract.canvas(sprite);
   * document.body.appendChild(canvas);
   *
   * // Extract with custom region
   * const canvas = renderer.extract.canvas({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const canvas = renderer.extract.canvas({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const canvas = renderer.extract.canvas(texture);
   *
   * // Extract with anti-aliasing
   * const canvas = renderer.extract.canvas({
   *     target: graphics,
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   */
  canvas(e) {
    e = this._normalizeOptions(e);
    const t = e.target, i = this._renderer;
    if (t instanceof et)
      return i.texture.generateCanvas(t);
    const s = i.textureGenerator.generateTexture(e), o = i.texture.generateCanvas(s);
    return s.destroy(!0), o;
  }
  /**
   * Returns a one-dimensional array containing the pixel data of the entire texture in RGBA order,
   * with integer values between 0 and 255 (inclusive).
   * > [!NOE] The returned array is a flat Uint8Array where every 4 values represent RGBA
   * @param options - The options for extracting the image, or the target to extract
   * @returns One-dimensional Uint8Array containing the pixel data in RGBA format
   * @example
   * ```ts
   * // Basic pixel extraction
   * const sprite = new Sprite(texture);
   * const pixels = renderer.extract.pixels(sprite);
   * console.log(pixels[0], pixels[1], pixels[2], pixels[3]); // R,G,B,A values
   *
   * // Extract with custom region
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     resolution: 2
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For image output
   * @category rendering
   */
  pixels(e) {
    e = this._normalizeOptions(e);
    const t = e.target, i = this._renderer, s = t instanceof et ? t : i.textureGenerator.generateTexture(e), o = i.texture.getPixels(s);
    return t instanceof mn && s.destroy(!0), o;
  }
  /**
   * Creates a texture from a display object or existing texture.
   *
   * This is useful for creating
   * reusable textures from rendered content or making copies of existing textures.
   * > [!NOTE] The returned texture should be destroyed when no longer needed
   * @param options - The options for creating the texture, or the target to extract
   * @returns A new texture containing the extracted content
   * @example
   * ```ts
   * // Basic texture extraction from a sprite
   * const sprite = new Sprite(texture);
   * const extractedTexture = renderer.extract.texture(sprite);
   *
   * // Extract with custom region
   * const regionTexture = renderer.extract.texture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const hiResTexture = renderer.extract.texture({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Create a new sprite from extracted texture
   * const newSprite = new Sprite(
   *     renderer.extract.texture({
   *         target: graphics,
   *         antialias: true
   *     })
   * );
   *
   * // Clean up when done
   * extractedTexture.destroy(true);
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link Texture} For texture management
   * @see {@link GenerateTextureSystem} For texture generation
   * @category rendering
   */
  texture(e) {
    return e = this._normalizeOptions(e), e.target instanceof et ? e.target : this._renderer.textureGenerator.generateTexture(e);
  }
  /**
   * Extracts and downloads content from the renderer as an image file.
   * This is a convenient way to save screenshots or export rendered content.
   * > [!NOTE] The download will use PNG format regardless of the filename extension
   * @param options - The options for downloading and extracting the image, or the target to extract
   * @example
   * ```ts
   * // Basic download with default filename
   * const sprite = new Sprite(texture);
   * renderer.extract.download(sprite); // Downloads as 'image.png'
   *
   * // Download with custom filename
   * renderer.extract.download({
   *     target: sprite,
   *     filename: 'screenshot.png'
   * });
   *
   * // Download with custom region
   * renderer.extract.download({
   *     target: container,
   *     filename: 'region.png',
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Download with high resolution and background
   * renderer.extract.download({
   *     target: stage,
   *     filename: 'hd-screenshot.png',
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Download with anti-aliasing
   * renderer.extract.download({
   *     target: graphics,
   *     filename: 'smooth.png',
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractDownloadOptions} For detailed options
   * @see {@link ExtractSystem.image} For creating images without download
   * @see {@link ExtractSystem.canvas} For canvas output
   * @category rendering
   */
  download(e) {
    var s;
    e = this._normalizeOptions(e);
    const t = this.canvas(e), i = document.createElement("a");
    i.download = (s = e.filename) != null ? s : "image.png", i.href = t.toDataURL("image/png"), document.body.appendChild(i), i.click(), document.body.removeChild(i);
  }
  /**
   * Logs the target to the console as an image. This is a useful way to debug what's happening in the renderer.
   * The image will be displayed in the browser's console using CSS background images.
   * @param options - The options for logging the image, or the target to log
   * @param options.width - The width of the logged image preview in the console (in pixels)
   * @example
   * ```ts
   * // Basic usage
   * const sprite = new Sprite(texture);
   * renderer.extract.log(sprite);
   * ```
   * @see {@link ExtractSystem.canvas} For getting raw canvas output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   * @advanced
   */
  log(e) {
    var r;
    const t = (r = e.width) != null ? r : 200;
    e = this._normalizeOptions(e);
    const i = this.canvas(e), s = i.toDataURL();
    console.log(`[Pixi Texture] ${i.width}px ${i.height}px`);
    const o = [
      "font-size: 1px;",
      `padding: ${t}px 300px;`,
      `background: url(${s}) no-repeat;`,
      "background-size: contain;"
    ].join(" ");
    console.log("%c ", o);
  }
  destroy() {
    this._renderer = null;
  }
};
Ay.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "extract"
};
Ay.defaultImageOptions = {
  format: "png",
  quality: 1
};
let iQ = Ay;
class Py extends et {
  /**
   * Creates a RenderTexture. Pass `dynamic: true` in options to allow resizing after creation.
   * @param options - Options for the RenderTexture, including width, height, textureOptions, and dynamic.
   * @returns A new RenderTexture instance.
   * @example
   * const textureOptions = { defaultAnchor: { x: 0.5, y: 0.5 } };
   * const rt = RenderTexture.create({ width: 100, height: 100, dynamic: true, textureOptions });
   * rt.resize(500, 500);
   */
  static create(e) {
    const { dynamic: t, textureOptions: i, ...s } = e;
    return new Py({
      ...i,
      source: new un(s),
      dynamic: t != null ? t : !1
    });
  }
  /**
   * Resizes the render texture.
   * @param width - The new width of the render texture.
   * @param height - The new height of the render texture.
   * @param resolution - The new resolution of the render texture.
   * @returns This texture.
   */
  resize(e, t, i) {
    return this.source.resize(e, t, i), this;
  }
}
const sQ = new Tt(), oQ = new Gn(), rQ = [0, 0, 0, 0];
class yT {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * Creates a texture from a display object that can be used for creating sprites and other textures.
   * This is particularly useful for optimizing performance when a complex container needs to be reused.
   * @param options - Generate texture options or a container to convert to texture
   * @returns A new RenderTexture containing the rendered display object
   * @example
   * ```ts
   * // Basic usage with a container
   * const container = new Container();
   * container.addChild(
   *     new Graphics()
   *         .circle(0, 0, 50)
   *         .fill('red')
   * );
   *
   * const texture = renderer.textureGenerator.generateTexture(container);
   *
   * // Advanced usage with options
   * const texture = renderer.textureGenerator.generateTexture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100), // Specific region
   *     resolution: 2,                        // High DPI
   *     clearColor: '#ff0000',               // Red background
   *     antialias: true                      // Smooth edges
   * });
   *
   * // Create a sprite from the generated texture
   * const sprite = new Sprite(texture);
   *
   * // Clean up when done
   * texture.destroy(true);
   * ```
   * @see {@link GenerateTextureOptions} For detailed texture generation options
   * @see {@link RenderTexture} For the type of texture created
   * @category rendering
   */
  generateTexture(e) {
    var c;
    e instanceof mn && (e = {
      target: e,
      frame: void 0,
      textureSourceOptions: {},
      resolution: void 0
    });
    const t = e.resolution || this._renderer.resolution, i = e.antialias || this._renderer.view.antialias, s = e.target;
    let o = e.clearColor;
    o ? o = Array.isArray(o) && o.length === 4 ? o : vn.shared.setValue(o).toArray() : o = rQ;
    const r = ((c = e.frame) == null ? void 0 : c.copyTo(sQ)) || Z1(s, oQ).rectangle, a = e.defaultAnchor && {
      defaultAnchor: e.defaultAnchor
    };
    r.width = Math.max(r.width, 1 / t) | 0, r.height = Math.max(r.height, 1 / t) | 0;
    const l = Py.create({
      ...e.textureSourceOptions,
      width: r.width,
      height: r.height,
      resolution: t,
      antialias: i,
      textureOptions: a
    }), d = ot.shared.translate(-r.x, -r.y);
    return this._renderer.render({
      container: s,
      transform: d,
      target: l,
      clearColor: o
    }), l.source.updateMipmaps(), l;
  }
  destroy() {
    this._renderer = null;
  }
}
yT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "textureGenerator"
};
function aQ(n) {
  let e = !1;
  for (const i in n)
    if (n[i] == null) {
      e = !0;
      break;
    }
  if (!e) return n;
  const t = /* @__PURE__ */ Object.create(null);
  for (const i in n) {
    const s = n[i];
    s && (t[i] = s);
  }
  return t;
}
function lQ(n) {
  let e = 0;
  for (let t = 0; t < n.length; t++)
    n[t] == null ? e++ : n[t - e] = n[t];
  return n.length -= e, n;
}
const Ey = class xT {
  /**
   * Creates a new GCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(e) {
    this._managedResources = [], this._managedResourceHashes = [], this._managedCollections = [], this._ready = !1, this._running = !1, this._renderer = e;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options
   */
  init(e) {
    e = { ...xT.defaultOptions, ...e }, this.maxUnusedTime = e.gcMaxUnusedTime, this._frequency = e.gcFrequency, this.enabled = e.gcActive, this.now = performance.now();
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return !!this._handler;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(e) {
    this.enabled !== e && (e ? (this._handler = this._renderer.scheduler.repeat(
      () => {
        this._ready = !0;
      },
      this._frequency,
      !1
    ), this._collectionsHandler = this._renderer.scheduler.repeat(
      () => {
        for (const t of this._managedCollections) {
          const { context: i, collection: s, type: o } = t;
          o === "hash" ? i[s] = aQ(i[s]) : i[s] = lQ(i[s]);
        }
      },
      this._frequency
    )) : (this._renderer.scheduler.cancel(this._handler), this._renderer.scheduler.cancel(this._collectionsHandler), this._handler = 0, this._collectionsHandler = 0));
  }
  /**
   * Called before rendering. Updates the current timestamp.
   * @param options - The render options
   * @param options.container - The container to render
   */
  prerender({ container: e }) {
    this.now = performance.now(), e.renderGroup.gcTick = this._renderer.tick++, this._updateInstructionGCTick(e.renderGroup, e.renderGroup.gcTick);
  }
  /** Performs garbage collection after rendering. */
  postrender() {
    !this._ready || !this.enabled || (this.run(), this._ready = !1);
  }
  /**
   * Updates the GC tick counter for a render group and its children.
   * @param renderGroup - The render group to update
   * @param gcTick - The new tick value
   */
  _updateInstructionGCTick(e, t) {
    e.instructionSet.gcTick = t, e.gcTick = t;
    for (const i of e.renderGroupChildren)
      this._updateInstructionGCTick(i, t);
  }
  /**
   * Registers a collection for garbage collection tracking.
   * @param context - The object containing the collection
   * @param collection - The property name on context that holds the collection
   * @param type - The type of collection to track ('hash' or 'array')
   */
  addCollection(e, t, i) {
    this._managedCollections.push({
      context: e,
      collection: t,
      type: i
    });
  }
  /**
   * Registers a resource for garbage collection tracking.
   * @param resource - The resource to track
   * @param type - The type of resource to track
   */
  addResource(e, t) {
    var s, o;
    if (e._gcLastUsed !== -1) {
      e._gcLastUsed = this.now, (s = e._onTouch) == null || s.call(e, this.now);
      return;
    }
    const i = this._managedResources.length;
    e._gcData = {
      index: i,
      type: t
    }, e._gcLastUsed = this.now, (o = e._onTouch) == null || o.call(e, this.now), e.once("unload", this.removeResource, this), this._managedResources.push(e);
  }
  /**
   * Removes a resource from garbage collection tracking.
   * Call this when manually destroying a resource.
   * @param resource - The resource to stop tracking
   */
  removeResource(e) {
    const t = e._gcData;
    if (!t) return;
    const i = t.index, s = this._managedResources.length - 1;
    if (this._running)
      this._managedResources[i] = null;
    else {
      if (i !== s) {
        const o = this._managedResources[s];
        this._managedResources[i] = o, o._gcData.index = i;
      }
      this._managedResources.length--;
    }
    e._gcData = null, e._gcLastUsed = -1;
  }
  /**
   * Registers a hash-based resource collection for garbage collection tracking.
   * Resources in the hash will be automatically tracked and cleaned up when unused.
   * @param context - The object containing the hash property
   * @param hash - The property name on context that holds the resource hash
   * @param type - The type of resources in the hash ('resource' or 'renderable')
   * @param priority - Processing priority (lower values are processed first)
   */
  addResourceHash(e, t, i, s = 0) {
    this._managedResourceHashes.push({
      context: e,
      hash: t,
      type: i,
      priority: s
    }), this._managedResourceHashes.sort((o, r) => o.priority - r.priority);
  }
  /**
   * Performs garbage collection by cleaning up unused resources.
   * Removes resources that haven't been used for longer than maxUnusedTime.
   */
  run() {
    if (this._running) return;
    const e = performance.now(), t = this._managedResourceHashes, i = this._managedResources;
    this._running = !0;
    try {
      for (const o of t)
        this.runOnHash(o, e);
      const s = i.length;
      for (let o = 0; o < s; o++) {
        const r = i[o];
        r && this.runOnResource(r, e);
      }
    } finally {
      let s = 0;
      for (let o = 0; o < i.length; o++) {
        const r = i[o];
        r && (s !== o && (i[s] = r, r._gcData.index = s), s++);
      }
      i.length = s, this._running = !1;
    }
  }
  updateRenderableGCTick(e, t) {
    var o, r, a, l, d;
    const i = (o = e.renderGroup) != null ? o : e.parentRenderGroup, s = (a = (r = i == null ? void 0 : i.instructionSet) == null ? void 0 : r.gcTick) != null ? a : -1;
    ((l = i == null ? void 0 : i.gcTick) != null ? l : 0) === s && (e._gcLastUsed = t, (d = e._onTouch) == null || d.call(e, t));
  }
  runOnResource(e, t) {
    e._gcData.type === "renderable" && this.updateRenderableGCTick(e, t), !(t - e._gcLastUsed < this.maxUnusedTime || !e.autoGarbageCollect) && (e.off("unload", this.removeResource, this), e.unload(), this.removeResource(e));
  }
  /**
   * Creates a clone of the hash, copying all non-null entries up to (but not including) the stop key.
   * @param hashValue - The original hash to clone from
   * @param stopKey - The key to stop at (exclusive)
   * @returns A new hash object with copied entries
   */
  _createHashClone(e, t) {
    const i = /* @__PURE__ */ Object.create(null);
    for (const s in e) {
      if (s === t) break;
      e[s] !== null && (i[s] = e[s]);
    }
    return i;
  }
  runOnHash(e, t) {
    var d, c;
    const { context: i, hash: s, type: o } = e, r = i[s];
    let a = null, l = 0;
    for (const h in r) {
      const f = r[h];
      if (f === null) {
        l++, l === 1e4 && !a && (a = this._createHashClone(r, h));
        continue;
      }
      if (f._gcLastUsed === -1) {
        f._gcLastUsed = t, (d = f._onTouch) == null || d.call(f, t), a && (a[h] = f);
        continue;
      }
      if (o === "renderable" && this.updateRenderableGCTick(f, t), !(t - f._gcLastUsed < this.maxUnusedTime) && f.autoGarbageCollect) {
        if (o === "renderable") {
          const y = f, v = (c = y.renderGroup) != null ? c : y.parentRenderGroup;
          v && (v.structureDidChange = !0);
        }
        f.unload(), f._gcData = null, f._gcLastUsed = -1, a || (l + 1 !== 1e4 ? (r[h] = null, l++) : a = this._createHashClone(r, h));
      } else a && (a[h] = f);
    }
    a && (i[s] = a);
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this.enabled = !1, this._managedResources.forEach((e) => {
      e == null || e.off("unload", this.removeResource, this);
    }), this._managedResources.length = 0, this._managedResourceHashes.length = 0, this._managedCollections.length = 0, this._renderer = null;
  }
};
Ey.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "gc",
  priority: 0
};
Ey.defaultOptions = {
  /** Enable/disable the garbage collector */
  gcActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  gcMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  gcFrequency: 3e4
};
let dQ = Ey;
class wT {
  constructor(e) {
    this._stackIndex = 0, this._globalUniformDataStack = [], this._uniformsPool = [], this._activeUniforms = [], this._bindGroupPool = [], this._activeBindGroups = [], this._renderer = e;
  }
  reset() {
    this._stackIndex = 0;
    for (let e = 0; e < this._activeUniforms.length; e++)
      this._uniformsPool.push(this._activeUniforms[e]);
    for (let e = 0; e < this._activeBindGroups.length; e++)
      this._bindGroupPool.push(this._activeBindGroups[e]);
    this._activeUniforms.length = 0, this._activeBindGroups.length = 0;
  }
  start(e) {
    this.reset(), this.push(e);
  }
  bind({
    size: e,
    projectionMatrix: t,
    worldTransformMatrix: i,
    worldColor: s,
    offset: o
  }) {
    const r = this._renderer.renderTarget.renderTarget, a = this._stackIndex ? this._globalUniformDataStack[this._stackIndex - 1] : {
      worldTransformMatrix: new ot(),
      worldColor: 4294967295,
      offset: new Wt()
    }, l = {
      projectionMatrix: t || this._renderer.renderTarget.projectionMatrix,
      resolution: e || r.size,
      worldTransformMatrix: i || a.worldTransformMatrix,
      worldColor: s || a.worldColor,
      offset: o || a.offset,
      bindGroup: null
    }, d = this._uniformsPool.pop() || this._createUniforms();
    this._activeUniforms.push(d);
    const c = d.uniforms;
    c.uProjectionMatrix = l.projectionMatrix, c.uResolution = l.resolution, c.uWorldTransformMatrix.copyFrom(l.worldTransformMatrix), c.uWorldTransformMatrix.tx -= l.offset.x, c.uWorldTransformMatrix.ty -= l.offset.y, JM(
      l.worldColor,
      c.uWorldColorAlpha,
      0
    ), d.update();
    let h;
    this._renderer.renderPipes.uniformBatch ? h = this._renderer.renderPipes.uniformBatch.getUniformBindGroup(d, !1) : (h = this._bindGroupPool.pop() || new qo(), this._activeBindGroups.push(h), h.setResource(d, 0)), l.bindGroup = h, this._currentGlobalUniformData = l;
  }
  push(e) {
    this.bind(e), this._globalUniformDataStack[this._stackIndex++] = this._currentGlobalUniformData;
  }
  pop() {
    this._currentGlobalUniformData = this._globalUniformDataStack[--this._stackIndex - 1], this._renderer.type === rs.WEBGL && this._currentGlobalUniformData.bindGroup.resources[0].update();
  }
  get bindGroup() {
    return this._currentGlobalUniformData.bindGroup;
  }
  get globalUniformData() {
    return this._currentGlobalUniformData;
  }
  get uniformGroup() {
    return this._currentGlobalUniformData.bindGroup.resources[0];
  }
  _createUniforms() {
    return new Ts({
      uProjectionMatrix: { value: new ot(), type: "mat3x3<f32>" },
      uWorldTransformMatrix: { value: new ot(), type: "mat3x3<f32>" },
      // TODO - someone smart - set this to be a unorm8x4 rather than a vec4<f32>
      uWorldColorAlpha: { value: new Float32Array(4), type: "vec4<f32>" },
      uResolution: { value: [0, 0], type: "vec2<f32>" }
    }, {
      isStatic: !0
    });
  }
  destroy() {
    this._renderer = null, this._globalUniformDataStack.length = 0, this._uniformsPool.length = 0, this._activeUniforms.length = 0, this._bindGroupPool.length = 0, this._activeBindGroups.length = 0, this._currentGlobalUniformData = null;
  }
}
wT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "globalUniforms"
};
let cQ = 1;
class kT {
  constructor() {
    this._tasks = [], this._offset = 0;
  }
  /** Initializes the scheduler system and starts the ticker. */
  init() {
    Oi.system.add(this._update, this);
  }
  /**
   * Schedules a repeating task.
   * @param func - The function to execute.
   * @param duration - The interval duration in milliseconds.
   * @param useOffset - this will spread out tasks so that they do not all run at the same time
   * @returns The unique identifier for the scheduled task.
   */
  repeat(e, t, i = !0) {
    const s = cQ++;
    let o = 0;
    return i && (this._offset += 1e3, o = this._offset), this._tasks.push({
      func: e,
      duration: t,
      start: performance.now(),
      offset: o,
      last: performance.now(),
      repeat: !0,
      id: s
    }), s;
  }
  /**
   * Cancels a scheduled task.
   * @param id - The unique identifier of the task to cancel.
   */
  cancel(e) {
    for (let t = 0; t < this._tasks.length; t++)
      if (this._tasks[t].id === e) {
        this._tasks.splice(t, 1);
        return;
      }
  }
  /**
   * Updates and executes the scheduled tasks.
   * @private
   */
  _update() {
    const e = performance.now();
    for (let t = 0; t < this._tasks.length; t++) {
      const i = this._tasks[t];
      if (e - i.offset - i.last >= i.duration) {
        const s = e - i.start;
        i.func(s), i.last = e;
      }
    }
  }
  /**
   * Destroys the scheduler system and removes all tasks.
   * @internal
   */
  destroy() {
    Oi.system.remove(this._update, this), this._tasks.length = 0;
  }
}
kT.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "scheduler",
  priority: 0
};
let U2 = !1;
function uQ(n) {
  if (!U2) {
    if (zt.get().getNavigator().userAgent.toLowerCase().indexOf("chrome") > -1) {
      const e = [
        `%c  %c  %c  %c  %c PixiJS %c v${vf} (${n}) http://www.pixijs.com/

`,
        "background: #E72264; padding:5px 0;",
        "background: #6CA2EA; padding:5px 0;",
        "background: #B5D33D; padding:5px 0;",
        "background: #FED23F; padding:5px 0;",
        "color: #FFFFFF; background: #E72264; padding:5px 0;",
        "color: #E72264; background: #FFFFFF; padding:5px 0;"
      ];
      globalThis.console.log(...e);
    } else globalThis.console && globalThis.console.log(`PixiJS ${vf} - ${n} - http://www.pixijs.com/`);
    U2 = !0;
  }
}
class Ry {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */
  init(e) {
    if (e.hello) {
      let t = this._renderer.name;
      this._renderer.type === rs.WEBGL && (t += ` ${this._renderer.context.webGLVersion}`), uQ(t);
    }
  }
}
Ry.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "hello",
  priority: -2
};
Ry.defaultOptions = {
  /** {@link WebGLOptions.hello} */
  hello: !1
};
const zy = class _T {
  /**
   * Creates a new RenderableGCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(e) {
    this._renderer = e;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options for the renderer
   */
  init(e) {
    e = { ..._T.defaultOptions, ...e }, this.maxUnusedTime = e.renderableGCMaxUnusedTime;
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return rt("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead."), this._renderer.gc.enabled;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(e) {
    rt("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead."), this._renderer.gc.enabled = e;
  }
  /**
   * Adds a hash table to be managed by the garbage collector.
   * @param context - The object containing the hash table
   * @param hash - The property name of the hash table
   */
  addManagedHash(e, t) {
    rt("8.15.0", "RenderableGCSystem.addManagedHash is deprecated, please use the GCSystem.addCollection instead."), this._renderer.gc.addCollection(e, t, "hash");
  }
  /**
   * Adds an array to be managed by the garbage collector.
   * @param context - The object containing the array
   * @param hash - The property name of the array
   */
  addManagedArray(e, t) {
    rt("8.15.0", "RenderableGCSystem.addManagedArray is deprecated, please use the GCSystem.addCollection instead."), this._renderer.gc.addCollection(e, t, "array");
  }
  /**
   * Starts tracking a renderable for garbage collection.
   * @param _renderable - The renderable to track
   * @deprecated since 8.15.0
   */
  addRenderable(e) {
    rt("8.15.0", "RenderableGCSystem.addRenderable is deprecated, please use the GCSystem instead."), this._renderer.gc.addResource(e, "renderable");
  }
  /**
   * Performs garbage collection by cleaning up unused renderables.
   * Removes renderables that haven't been used for longer than maxUnusedTime.
   */
  run() {
    rt("8.15.0", "RenderableGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.run();
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this._renderer = null;
  }
};
zy.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "renderableGC",
  priority: 0
};
zy.defaultOptions = {
  /** Enable/disable the garbage collector */
  renderableGCActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  renderableGCMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  renderableGCFrequency: 3e4
};
let hQ = zy;
const $y = class Mp {
  /**
   * Frame count since started.
   * @readonly
   * @deprecated since 8.15.0
   */
  get count() {
    return this._renderer.tick;
  }
  /**
   * Frame count since last garbage collection.
   * @readonly
   * @deprecated since 8.15.0
   */
  get checkCount() {
    return this._checkCount;
  }
  set checkCount(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._checkCount = e;
  }
  /**
   * Maximum idle frames before a texture is destroyed by garbage collection.
   * @see TextureGCSystem.defaultMaxIdle
   * @deprecated since 8.15.0
   */
  get maxIdle() {
    return this._renderer.gc.maxUnusedTime / 1e3 * 60;
  }
  set maxIdle(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.maxUnusedTime = e / 60 * 1e3;
  }
  /**
   * Frames between two garbage collections.
   * @see TextureGCSystem.defaultCheckCountMax
   * @deprecated since 8.15.0
   */
  // eslint-disable-next-line dot-notation
  get checkCountMax() {
    return Math.floor(this._renderer.gc._frequency / 1e3);
  }
  set checkCountMax(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
  }
  /**
   * Current garbage collection mode.
   * @see TextureGCSystem.defaultMode
   * @deprecated since 8.15.0
   */
  get active() {
    return this._renderer.gc.enabled;
  }
  set active(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.enabled = e;
  }
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e, this._checkCount = 0;
  }
  init(e) {
    e.textureGCActive !== Mp.defaultOptions.textureGCActive && (this.active = e.textureGCActive), e.textureGCMaxIdle !== Mp.defaultOptions.textureGCMaxIdle && (this.maxIdle = e.textureGCMaxIdle), e.textureGCCheckCountMax !== Mp.defaultOptions.textureGCCheckCountMax && (this.checkCountMax = e.textureGCCheckCountMax);
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   * @deprecated since 8.15.0
   */
  run() {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.run();
  }
  destroy() {
    this._renderer = null;
  }
};
$y.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem
  ],
  name: "textureGC"
};
$y.defaultOptions = {
  /**
   * If set to true, this will enable the garbage collector on the GPU.
   * @default true
   */
  textureGCActive: !0,
  /**
   * @deprecated since 8.3.0
   * @see {@link TextureGCSystemOptions.textureGCMaxIdle}
   */
  textureGCAMaxIdle: null,
  /**
   * The maximum idle frames before a texture is destroyed by garbage collection.
   * @default 60 * 60
   */
  textureGCMaxIdle: 3600,
  /**
   * Frames between two garbage collections.
   * @default 600
   */
  textureGCCheckCountMax: 600
};
let pQ = $y;
const ST = class MT extends bi {
  /**
   * @param options - Options for creating a render target, or a WebGPU-flavored descriptor.
   */
  constructor(e = {}) {
    var i;
    super(), this.uid = Nt("renderTarget"), this.colorAttachments = [], this.dirtyId = 0, this.isRoot = !1, this._size = new Float32Array(2), this._managedColorTextures = !1, this._depth = !1, this._stencil = !1, this._colorTextures = null;
    const t = "colorAttachments" in e ? e : this._normalizeOptions(e);
    if (this.isRoot = (i = t.isRoot) != null ? i : !1, this.label = t.label, this.colorAttachments = t.colorAttachments, this.depthStencilAttachment = t.depthStencilAttachment, this.depthStencilAttachment) {
      const s = this.depthStencilAttachment.texture.format;
      this._depth || (this._depth = s.includes("depth")), this._stencil || (this._stencil = s.includes("stencil"));
    }
    if (this.colorAttachments.length === 0 && !this.depthStencilAttachment)
      throw new Error("[RenderTarget] no color textures or depth textures were provided. Provide a depthStencilTexture or set depth/stencil to true when using colorTextures: 0.");
    if (this.colorAttachments.length > 0) {
      const s = this.colorTexture;
      this.resize(s.width, s.height, s._resolution);
    }
    this.sizeSource && this.sizeSource.on("resize", this.onSourceResize, this);
  }
  _normalizeOptions(e) {
    const t = { ...MT.defaultOptions, ...e }, i = [];
    let s;
    if (typeof t.colorTextures == "number") {
      if (t.colorTextures > 0) {
        this._managedColorTextures = !0;
        for (let r = 0; r < t.colorTextures; r++)
          i.push({
            texture: new un({
              width: t.width,
              height: t.height,
              resolution: t.resolution,
              antialias: t.antialias
            }),
            loadOp: "clear",
            storeOp: "store"
          });
      }
    } else
      t.colorTextures.forEach((r) => {
        i.push({
          texture: r.source,
          loadOp: "clear",
          storeOp: "store"
        });
      });
    const o = t.depthStencilTexture === !0;
    if (this._depth = !!(t.depth || o), this._stencil = !!(t.stencil || o), t.depthStencilTexture instanceof et || t.depthStencilTexture instanceof un) {
      if (t.isRoot)
        throw new Error("[RenderTarget] cannot attach a depth-stencil texture to the screen — the canvas owns its own depth/stencil buffers. Render to a texture target instead.");
      s = {
        texture: t.depthStencilTexture.source
      };
    } else (o && !t.isRoot || (t.stencil || t.depth) && i.length === 0) && (s = this._createDepthStencilTexture(t.width, t.height, t.resolution));
    return {
      colorAttachments: i,
      depthStencilAttachment: s,
      isRoot: t.isRoot,
      label: t.label
    };
  }
  get size() {
    const e = this._size;
    return e[0] = this.pixelWidth, e[1] = this.pixelHeight, e;
  }
  get width() {
    return this.sizeSource.width;
  }
  get height() {
    return this.sizeSource.height;
  }
  get pixelWidth() {
    return this.sizeSource.pixelWidth;
  }
  get pixelHeight() {
    return this.sizeSource.pixelHeight;
  }
  get resolution() {
    return this.sizeSource._resolution;
  }
  /**
   * An array of textures that can be written to by the GPU - mostly this has one texture in Pixi, but you could
   * write to multiple if required! (eg deferred lighting).
   * This is a backwards-compatible getter that extracts the textures from `colorAttachments`.
   */
  get colorTextures() {
    return this._colorTextures || (this._colorTextures = this.colorAttachments.map((e) => e.texture)), this._colorTextures;
  }
  /** The stencil and depth buffer will write to this texture in WebGPU. */
  get depthStencilTexture() {
    var e, t;
    return (t = (e = this.depthStencilAttachment) == null ? void 0 : e.texture) != null ? t : null;
  }
  /** Whether this target provides a depth buffer — requested via options or implied by its attachment's format. */
  get depth() {
    return this._depth;
  }
  /** Whether this target provides a stencil buffer — requested via options or implied by its attachment's format. */
  get stencil() {
    return this._stencil;
  }
  get colorTexture() {
    var e;
    return (e = this.colorAttachments[0]) == null ? void 0 : e.texture;
  }
  /**
   * The texture that drives size, resolution, and resize events.
   * For standard targets this is `colorAttachments[0].texture`;
   * for depth-only targets it is `depthStencilAttachment.texture`.
   */
  get sizeSource() {
    var e, t, i;
    return (i = (e = this.colorAttachments[0]) == null ? void 0 : e.texture) != null ? i : (t = this.depthStencilAttachment) == null ? void 0 : t.texture;
  }
  onSourceResize(e) {
    this.resize(e.width, e.height, e._resolution, !0);
  }
  /**
   * This will ensure a depthStencil texture is created for this render target.
   * Most likely called by the mask system to make sure we have stencil buffer added.
   * @internal
   */
  ensureDepthStencilTexture() {
    this._createDepthStencilTexture(this.sizeSource.width, this.sizeSource.height, this.sizeSource._resolution), this._depth = !0, this._stencil = !0;
  }
  resize(e, t, i = this.resolution, s = !1) {
    if (this.dirtyId++, this.colorAttachments.forEach((o, r) => {
      s && r === 0 || o.texture.resize(e, t, i);
    }), this.depthStencilAttachment) {
      if (s && this.colorAttachments.length === 0) return;
      this.depthStencilAttachment.texture.resize(e, t, i);
    }
  }
  destroy() {
    !this.colorAttachments && !this.depthStencilAttachment || (this.emit("destroy", this), this.sizeSource.off("resize", this.onSourceResize, this), this._managedColorTextures && this.colorAttachments.forEach((e) => {
      e.texture.destroy();
    }), this.depthStencilAttachment && (this.depthStencilAttachment.texture.destroy(), delete this.depthStencilAttachment), this.colorAttachments = null, this._colorTextures = null, this.removeAllListeners());
  }
  /**
   * The single recipe for internally-created depth-stencil textures.
   * @param width
   * @param height
   * @param resolution
   */
  _createDepthStencilTexture(e, t, i) {
    var s;
    return (s = this.depthStencilAttachment) != null || (this.depthStencilAttachment = {
      texture: new un({
        width: e,
        height: t,
        resolution: i,
        format: "depth24plus-stencil8",
        autoGenerateMipmaps: !1,
        antialias: !1,
        mipLevelCount: 1
        // sampleCount: handled by the render target system..
      })
    }), this.depthStencilAttachment;
  }
};
ST.defaultOptions = {
  /** the width of the RenderTarget */
  width: 0,
  /** the height of the RenderTarget */
  height: 0,
  /** the resolution of the RenderTarget */
  resolution: 1,
  /** an array of textures, or a number indicating how many color textures there should be */
  colorTextures: 1,
  /** should this render target have a stencil buffer? */
  stencil: !1,
  /** should this render target have a depth buffer? */
  depth: !1,
  /** should this render target be antialiased? */
  antialias: !1,
  // save on perf by default!
  /** is this a root element, true if this is gl context owners render target */
  isRoot: !1
};
let Tp = ST;
const tl = /* @__PURE__ */ new Map();
Yl.register(tl);
function TT(n, e) {
  if (!tl.has(n)) {
    const t = new et({
      source: new Ai({
        resource: n,
        ...e
      })
    }), i = () => {
      tl.get(n) === t && tl.delete(n);
    };
    t.once("destroy", i), t.source.once("destroy", i), tl.set(n, t);
  }
  return tl.get(n);
}
const Dy = class CT {
  /**
   * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
   * This is only supported for HTMLCanvasElement and will be ignored if the canvas is an OffscreenCanvas.
   * @type {boolean}
   */
  get autoDensity() {
    return this.texture.source.autoDensity;
  }
  set autoDensity(e) {
    this.texture.source.autoDensity = e;
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.texture.source._resolution;
  }
  set resolution(e) {
    this.texture.source.resize(
      this.texture.source.width,
      this.texture.source.height,
      e
    );
  }
  constructor(e) {
    this._renderer = e;
  }
  /**
   * initiates the view system
   * @param options - the options for the view
   */
  init(e) {
    e = {
      ...CT.defaultOptions,
      ...e
    }, e.view && (rt(dn, "ViewSystem.view has been renamed to ViewSystem.canvas"), e.canvas = e.view), this.screen = new Tt(0, 0, e.width, e.height), this.canvas = e.canvas || zt.get().createCanvas(), this.antialias = !!e.antialias;
    const { depth: t, ...i } = e;
    this.texture = TT(this.canvas, i), this.renderTarget = new Tp({
      colorTextures: [this.texture],
      depth: !!t,
      isRoot: !0
    }), this.texture.source.transparent = e.backgroundAlpha < 1, this.texture.source.on("resize", this._updateScreenSize, this), this.resolution = e.resolution, this._updateScreenSize();
  }
  /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   * @param resolution
   */
  resize(e, t, i) {
    this.texture.source.resize(e, t, i), this.screen.width = this.texture.frame.width, this.screen.height = this.texture.frame.height;
  }
  /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {options | false} options - The options for destroying the view, or "false".
   * @example
   * viewSystem.destroy();
   * viewSystem.destroy(true);
   * viewSystem.destroy({ removeView: true });
   */
  destroy(e = !1) {
    (typeof e == "boolean" ? e : e != null && e.removeView) && this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas), this.texture.source.off("resize", this._updateScreenSize, this), Nn.removeScreen(this._renderer.uid), Fl.removeScreen(this._renderer.uid), this.texture.destroy();
  }
  /**
   * Tells the texture and canvas pools how big this renderer's screen is, in physical pixels, so they
   * can hand out screen sized resources instead of rounding every request up to a power of two.
   */
  _updateScreenSize() {
    const { pixelWidth: e, pixelHeight: t } = this.texture.source, i = this._renderer.uid;
    Nn.setScreenSize(i, e, t), Fl.setScreenSize(i, e, t);
  }
};
Dy.extension = {
  type: [
    Ae.WebGLSystem,
    Ae.WebGPUSystem,
    Ae.CanvasSystem
  ],
  name: "view",
  priority: 0
};
Dy.defaultOptions = {
  /**
   * {@link WebGLOptions.width}
   * @default 800
   */
  width: 800,
  /**
   * {@link WebGLOptions.height}
   * @default 600
   */
  height: 600,
  /**
   * {@link WebGLOptions.autoDensity}
   * @default false
   */
  autoDensity: !1,
  /**
   * {@link WebGLOptions.antialias}
   * @default false
   */
  antialias: !1
};
let fQ = Dy;
const Oy = [
  nQ,
  wT,
  Ry,
  fQ,
  gT,
  dQ,
  pQ,
  yT,
  iQ,
  hM,
  hQ,
  kT
], IT = [
  Cy,
  ky,
  Ty,
  My,
  _y,
  cT,
  aT,
  Sy
];
function mQ(n, e, t, i, s, o) {
  const r = o ? 1 : -1;
  return n.identity(), n.a = 1 / i * 2, n.d = r * (1 / s * 2), n.tx = -1 - e * n.a, n.ty = -r - t * n.d, n;
}
function gQ(n) {
  if (n.colorAttachments.length === 0) return !1;
  const e = n.colorTexture.resource;
  return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement && document.body.contains(e);
}
class Ly {
  constructor(e) {
    this.rootViewPort = new Tt(), this.viewport = new Tt(), this.onRenderTargetChange = new lM("onRenderTargetChange"), this.projectionMatrix = new ot(), this.defaultClearColor = [0, 0, 0, 0], this._renderSurfaceToRenderTargetHash = /* @__PURE__ */ new Map(), this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null), this._renderTargetStack = [], this._bindState = {
      target: null,
      frame: void 0,
      mipLevel: 0,
      layer: 0,
      flipY: !1
    }, this._bindFrame = new Tt(), this._renderer = e, e.gc.addCollection(this, "_gpuRenderTargetHash", "hash");
  }
  /** the current active render surface that the render target is created from */
  get renderSurface() {
    return this._bindState.target;
  }
  /** the current mip level being rendered to (for texture subresources) */
  get mipLevel() {
    return this._bindState.mipLevel;
  }
  /** the current array layer being rendered to (for array-backed targets) */
  get layer() {
    return this._bindState.layer;
  }
  /** called when dev wants to finish a render pass */
  finishRenderPass() {
    this.adaptor.finishRenderPass(this.renderTarget);
  }
  /**
   * called when the renderer starts to render a scene: resets the bind stack and binds the
   * root render surface
   * @param options - the {@link BindOptions} for the root binding
   */
  renderStart(e) {
    var t, i;
    this._renderTargetStack.length = 0, this.push(e), this.rootViewPort.copyFrom(this.viewport), this.rootRenderTarget = this.renderTarget, this.renderingToScreen = gQ(this.rootRenderTarget), (i = (t = this.adaptor).prerender) == null || i.call(t, this.rootRenderTarget);
  }
  postrender() {
    var e, t;
    (t = (e = this.adaptor).postrender) == null || t.call(e, this.rootRenderTarget);
  }
  bind(e, t = !0, i, s, o = 0, r = 0, a) {
    var M, _, T, k, P;
    let l;
    "target" in e ? l = e : (rt("8.20.0", "RenderTargetSystem.bind: positional arguments are deprecated, please use an options object instead: bind({ target, clear, clearColor, frame, mipLevel, layer, flipY })"), l = { target: e, clear: t, clearColor: i, frame: s, mipLevel: o, layer: r, flipY: a });
    const d = l.target;
    t = (M = l.clear) != null ? M : !0, i = l.clearColor, o = ((_ = l.mipLevel) != null ? _ : 0) | 0, r = ((T = l.layer) != null ? T : 0) | 0, a = l.flipY, s = l.frame;
    const c = this.getRenderTarget(d), h = this.renderTarget !== c || !!c.flipY != !!a;
    this.renderTarget = c;
    const f = this.getGpuRenderTarget(c);
    (c.pixelWidth !== f.width || c.pixelHeight !== f.height) && (this.adaptor.resizeGpuRenderTarget(c), f.width = c.pixelWidth, f.height = c.pixelHeight);
    const p = ((k = c.colorAttachments[0]) == null ? void 0 : k.texture) || ((P = c.depthStencilAttachment) == null ? void 0 : P.texture), y = this.viewport, v = p.dimension === "3d" ? Math.max(p.depth >> o, 1) : p.depthOrArrayLayers;
    if (r < 0 || r >= v)
      throw new Error(`[RenderTargetSystem] layer ${r} is out of bounds (layer count=${v}).`);
    const x = this._bindState;
    x.target = d, x.frame = s ? this._bindFrame.copyFrom(s) : void 0, x.mipLevel = o, x.layer = r, x.flipY = a;
    const w = Math.max(p.pixelWidth >> o, 1), S = Math.max(p.pixelHeight >> o, 1);
    if (!s && d instanceof et && (s = d.frame), s) {
      const A = p._resolution, R = 1 << Math.max(o, 0), D = s.x * A + 0.5 | 0, O = s.y * A + 0.5 | 0, F = s.width * A + 0.5 | 0, ie = s.height * A + 0.5 | 0;
      let ee = Math.floor(D / R), me = Math.floor(O / R), L = Math.ceil(F / R), N = Math.ceil(ie / R);
      ee < 0 && (L += ee, ee = 0), me < 0 && (N += me, me = 0), ee = Math.min(ee, w - 1), me = Math.min(me, S - 1), L = Math.min(L, w - ee), N = Math.min(N, S - me), L = Math.max(L, 1), N = Math.max(N, 1), y.x = ee, y.y = me, y.width = L, y.height = N;
    } else
      y.x = 0, y.y = 0, y.width = w, y.height = S;
    return c.flipY = a, mQ(
      this.projectionMatrix,
      0,
      0,
      y.width / p.resolution,
      y.height / p.resolution,
      !c.isRoot != !!c.flipY
    ), this.adaptor.startRenderPass(c, t, i, y, o, r), h && this.onRenderTargetChange.emit(c), c;
  }
  /**
   * Captures the current binding as a {@link BindOptions} that can be passed back to
   * {@link RenderTargetSystem.bind} to restore it. The capture replays non-destructively:
   * its `clear` is `CLEAR.NONE`, so restoring never wipes the target.
   *
   * ```js
   * const saved = renderer.renderTarget.getBindState();
   *
   * renderer.renderTarget.bind({ target: scratchTexture, clear: true });
   * // ... draw ...
   * renderer.renderTarget.bind(saved);
   *
   * // or compose: the saved binding, but into mip 1
   * renderer.renderTarget.bind({ ...saved, mipLevel: 1 });
   * ```
   *
   * The capture is a snapshot owned by the caller — later binds cannot change it — and holds
   * `target` and `frame` as they were passed, so a Texture bound without an explicit frame
   * replays through its frame fallback. It stays valid for as long as its target does.
   * Pass `out` to reuse one object across captures; every field of it is overwritten.
   * @param out - an optional object to write the bind state into; allocated when omitted
   * @returns the captured bind state (`out` when provided)
   */
  getBindState(e) {
    if (!this.renderTarget)
      throw new Error("[RenderTargetSystem] getBindState is only valid while a render surface is bound");
    const t = this._bindState;
    return e != null || (e = {}), e.target = t.target, e.clear = Tn.NONE, e.clearColor = void 0, t.frame ? e.frame ? e.frame.copyFrom(t.frame) : e.frame = t.frame.clone() : e.frame = void 0, e.mipLevel = t.mipLevel, e.layer = t.layer, e.flipY = !!t.flipY, e;
  }
  /**
   * Whether pixi inverts the front face for a bind — `true` when a front-facing triangle ends up
   * wound the opposite way on the surface, so the winding/cull has been inverted to compensate.
   *
   * With no arguments, answers for the current bind. With a target, answers for that target as if
   * it were bound with the given `flipY` (defaulting to `false`, exactly as {@link bind} would), so
   * a consumer can choose a projection or a `flipY` before binding.
   *
   * This is the requested `flipY` combined with the backend's inherent orientation, not the raw request:
   *
   * ```text
   * inverted = flipY XOR (isWebGL && !isRoot)
   * ```
   *
   * WebGL's non-root FBOs carry an inherent Y-flip vs the root (the classic render-texture flip), so the
   * same requested `flipY` lands with the opposite winding depending on `isRoot`. WebGPU has no such
   * inherent flip, so there it is simply `flipY`. This is the one spelling of the rule: the winding each
   * backend bakes at bind ({@link GlStateSystem} / {@link PipelineSystem}) comes from here too, so
   * consumers (e.g. 3D pipelines) read the resolved orientation instead of re-deriving it.
   * @param renderTarget - the target to ask about; omit for the current bind
   * @param flipY - the `flipY` the target would be bound with; ignored when `renderTarget` is omitted
   * @returns whether the front face is inverted
   */
  isFrontFaceInverted(e, t) {
    if (!e) {
      if (e = this.renderTarget, !e) return !1;
      t = e.flipY;
    }
    return !!t != (this._renderer.type === rs.WEBGL && !e.isRoot);
  }
  /**
   * The effective front-face orientation of the current bind.
   * @deprecated since 8.21.0, use {@link isFrontFaceInverted} instead
   * @returns whether the current bind's front face is inverted
   */
  get frontFaceInverted() {
    return rt(js, "RenderTargetSystem.frontFaceInverted is deprecated, use isFrontFaceInverted() instead"), this.isFrontFaceInverted();
  }
  clear(e, t = Tn.ALL, i, s = this.mipLevel, o = this.layer) {
    t && (e && (e = this.getRenderTarget(e)), this.adaptor.clear(
      e || this.renderTarget,
      t,
      i,
      this.viewport,
      s,
      o
    ));
  }
  contextChange() {
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  push(e, t = Tn.ALL, i, s, o = 0, r = 0, a) {
    let l;
    "target" in e ? l = e : (rt("8.20.0", "RenderTargetSystem.push: positional arguments are deprecated, please use an options object instead: push({ target, clear, clearColor, frame, mipLevel, layer, flipY })"), l = { target: e, clear: t, clearColor: i, frame: s, mipLevel: o, layer: r, flipY: a });
    const d = this.bind(l);
    return this._renderTargetStack.push({
      target: l.target,
      clear: !1,
      clearColor: void 0,
      frame: l.frame ? l.frame.clone() : void 0,
      mipLevel: l.mipLevel,
      layer: l.layer,
      flipY: l.flipY
    }), d;
  }
  /**
   * Pops the current render target and restores the previous binding.
   * @returns the render target that was restored
   */
  pop() {
    this._renderTargetStack.pop();
    const e = this._renderTargetStack[this._renderTargetStack.length - 1];
    if (!e)
      throw new Error("[RenderTargetSystem] pop: no previous binding to restore (unbalanced pop)");
    return this.bind(e);
  }
  /**
   * Gets the render target from the provide render surface. Eg if its a texture,
   * it will return the render target for the texture.
   * If its a render target, it will return the same render target.
   * @param renderSurface - the render surface to get the render target for
   * @returns the render target for the render surface
   */
  getRenderTarget(e) {
    var t;
    return e.isTexture && (e = e.source), (t = this._renderSurfaceToRenderTargetHash.get(e)) != null ? t : this._initRenderTarget(e);
  }
  /**
   * Copies a render surface to another texture.
   *
   * NOTE:
   * for sourceRenderSurfaceTexture, The render target must be something that is written too by the renderer
   *
   * The following is not valid:
   * @example
   * const canvas = document.createElement('canvas')
   * canvas.width = 200;
   * canvas.height = 200;
   *
   * const ctx = canvas2.getContext('2d')!
   * ctx.fillStyle = 'red'
   * ctx.fillRect(0, 0, 200, 200);
   *
   * const texture = RenderTexture.create({
   *   width: 200,
   *   height: 200,
   * })
   * const renderTarget = renderer.renderTarget.getRenderTarget(canvas2);
   *
   * renderer.renderTarget.copyToTexture(renderTarget,texture, {x:0,y:0},{width:200,height:200},{x:0,y:0});
   *
   * The best way to copy a canvas is to create a texture from it. Then render with that.
   *
   * Parsing in a RenderTarget canvas context (with a 2d context)
   * @param sourceRenderSurface - the render surface (render target, texture, or canvas) to copy from
   * @param {Texture} destinationTexture - the texture to copy to
   * @param {object} originSrc - the origin of the copy
   * @param {number} originSrc.x - the x origin of the copy
   * @param {number} originSrc.y - the y origin of the copy
   * @param {object} size - the size of the copy
   * @param {number} size.width - the width of the copy
   * @param {number} size.height - the height of the copy
   * @param {object} originDest - the destination origin (top left to paste from!)
   * @param {number} originDest.x - the x origin of the paste
   * @param {number} originDest.y - the y origin of the paste
   */
  copyToTexture(e, t, i, s, o) {
    const r = this.getRenderTarget(e);
    i.x < 0 && (s.width += i.x, o.x -= i.x, i.x = 0), i.y < 0 && (s.height += i.y, o.y -= i.y, i.y = 0);
    const { pixelWidth: a, pixelHeight: l } = r;
    return s.width = Math.min(s.width, a - i.x), s.height = Math.min(s.height, l - i.y), this.adaptor.copyToTexture(
      r,
      t,
      i,
      s,
      o
    );
  }
  /**
   * Copies the depth attachment from one render target to another.
   * Both source and destination must have a depthStencilAttachment.
   *
   * **Important Note:** When using the copied depth buffer in a subsequent render pass,
   * you must ensure you do not clear the depth buffer again. If you need to clear the color
   * buffer of the destination render target, use `clear: CLEAR.COLOR` to preserve the copied depth data.
   * @example
   * ```js
   * renderer.renderTarget.copyDepthTexture(
   *   sourceRT, destRT, { x: 0, y: 0 }, { width: 200, height: 200 }, { x: 0, y: 0 }
   * );
   *
   * // In the subsequent render pass, clear ONLY the color buffer!
   * renderer.render({
   *   target: destRT,
   *   container: myMesh,
   *   clear: CLEAR.COLOR, // Preserves the copied depth
   *   clearColor: [0, 0, 0, 1]
   * });
   * ```
   * @param source - the render surface (render target, depth texture, or canvas) to copy depth from
   * @param destination - the depth/stencil texture to copy depth to
   * @param {object} originSrc - the origin of the copy
   * @param {number} originSrc.x - the x origin of the copy
   * @param {number} originSrc.y - the y origin of the copy
   * @param {object} size - the size of the copy
   * @param {number} size.width - the width of the copy
   * @param {number} size.height - the height of the copy
   * @param {object} originDest - the destination origin (top left to paste from!)
   * @param {number} originDest.x - the x origin of the paste
   * @param {number} originDest.y - the y origin of the paste
   */
  copyDepthTexture(e, t, i, s, o = { x: 0, y: 0 }) {
    const r = this.getRenderTarget(e);
    if (!r.depthStencilAttachment) {
      dt("[RenderTargetSystem] copyDepthTexture: the source render target has no depth attachment to copy from");
      return;
    }
    const a = t.source;
    if (!a.format.includes("depth") && !a.format.includes("stencil")) {
      dt(`[RenderTargetSystem] copyDepthTexture: the destination texture must have a depth/stencil format (got '${a.format}')`);
      return;
    }
    let l = i.x, d = i.y, c = o.x, h = o.y, f = s.width, p = s.height;
    l < 0 && (f += l, c -= l, l = 0), d < 0 && (p += d, h -= d, d = 0), f = Math.min(f, r.pixelWidth - l), p = Math.min(p, r.pixelHeight - d), f = Math.min(f, a.pixelWidth - c), p = Math.min(p, a.pixelHeight - h), !(f <= 0 || p <= 0) && this.adaptor.copyDepthTexture(
      r,
      t,
      { x: l, y: d },
      { width: f, height: p },
      { x: c, y: h }
    );
  }
  /**
   * ensures that we have a depth stencil buffer available to render to
   * This is used by the mask system to make sure we have a stencil buffer.
   */
  ensureDepthStencil() {
    if (!this.renderTarget.stencil) {
      if (this.renderTarget.depthStencilTexture) {
        dt(`[RenderTargetSystem] a stencil mask is being used, but the render target's depthStencilTexture format '${this.renderTarget.depthStencilTexture.format}' has no stencil aspect, so masking cannot work here. Use a 'depth24plus-stencil8' texture instead.`);
        return;
      }
      this.renderTarget._depth = !0, this.renderTarget._stencil = !0, this.adaptor.startRenderPass(this.renderTarget, !1, null, this.viewport, 0, this.layer);
    }
  }
  /** nukes the render target system */
  destroy() {
    this._renderer = null, this._renderSurfaceToRenderTargetHash.forEach((e, t) => {
      e !== t ? this._releaseRenderTarget(t, e) : e.off("destroy", this._onRenderTargetDestroy, this);
    }), this._renderSurfaceToRenderTargetHash.clear();
    for (const e of Object.values(this._gpuRenderTargetHash))
      e && this.adaptor.destroyGpuRenderTarget(e);
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  _initRenderTarget(e) {
    let t = null;
    if (Ai.test(e) && (e = TT(e).source), e instanceof Tp)
      t = e, e.once("destroy", this._onRenderTargetDestroy, this);
    else if (e instanceof un) {
      const i = e.format;
      t = i.includes("depth") || i.includes("stencil") ? new Tp({ colorTextures: 0, depthStencilTexture: e }) : new Tp({ colorTextures: [e] }), e.source instanceof Ai && (t.isRoot = !0), e.once("destroy", this._onRenderSurfaceDestroy, this);
    }
    return this._renderSurfaceToRenderTargetHash.set(e, t), t;
  }
  _onRenderSurfaceDestroy(e) {
    const t = this._renderSurfaceToRenderTargetHash.get(e);
    t && this._releaseRenderTarget(e, t);
  }
  /**
   * A caller-owned render target is tearing itself down. It releases its own attachments,
   * so only the system's references to it and the backend objects built for it go here.
   * @param renderTarget - the render target being destroyed
   */
  _onRenderTargetDestroy(e) {
    this._renderSurfaceToRenderTargetHash.delete(e), this._releaseGpuRenderTarget(e);
  }
  /**
   * Tears down a render target that wraps a texture source, removing every reference the
   * system holds to it so neither the system's own teardown nor the source's `destroy`
   * event can destroy it a second time.
   * @param renderSurface - the texture source the render target wraps
   * @param renderTarget - the render target to release
   */
  _releaseRenderTarget(e, t) {
    t.destroy(), this._renderSurfaceToRenderTargetHash.delete(e), e.off("destroy", this._onRenderSurfaceDestroy, this), this._releaseGpuRenderTarget(t);
  }
  /**
   * Frees the backend objects (framebuffers, renderbuffers, MSAA textures) cached for a render target.
   * @param renderTarget - the render target whose backend counterpart is no longer needed
   */
  _releaseGpuRenderTarget(e) {
    const t = this._gpuRenderTargetHash[e.uid];
    t && (this._gpuRenderTargetHash[e.uid] = null, this.adaptor.destroyGpuRenderTarget(t));
  }
  getGpuRenderTarget(e) {
    return this._gpuRenderTargetHash[e.uid] || (this._gpuRenderTargetHash[e.uid] = this.adaptor.initGpuRenderTarget(e));
  }
  resetState() {
    this.renderTarget = null, this._bindState.target = null;
  }
}
class bQ {
  /**
   * Initializes the adaptor.
   * @param renderer - Canvas renderer instance.
   * @param renderTargetSystem - The render target system.
   * @advanced
   */
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t;
  }
  /**
   * Creates a GPU render target for canvas.
   * @param renderTarget - Render target to initialize.
   * @advanced
   */
  initGpuRenderTarget(e) {
    const t = e.colorTexture, { canvas: i, context: s } = this._ensureCanvas(t);
    return {
      canvas: i,
      context: s,
      width: i.width,
      height: i.height
    };
  }
  /**
   * Resizes the backing canvas for a render target.
   * @param renderTarget - Render target to resize.
   * @advanced
   */
  resizeGpuRenderTarget(e) {
    const t = e.colorTexture, { canvas: i } = this._ensureCanvas(t);
    i.width = e.pixelWidth, i.height = e.pixelHeight;
  }
  /**
   * Starts a render pass on the canvas target.
   * @param renderTarget - Target to render to.
   * @param clear - Clear mode.
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport.
   * @advanced
   */
  startRenderPass(e, t, i, s) {
    const o = this._renderTargetSystem.getGpuRenderTarget(e);
    this._renderer.canvasContext.activeContext = o.context, this._renderer.canvasContext.activeResolution = e.resolution, t && this.clear(e, t, i, s);
  }
  /**
   * Clears the render target.
   * @param renderTarget - Target to clear.
   * @param _clear - Clear mode (unused).
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport rectangle.
   * @advanced
   */
  clear(e, t, i, s) {
    const r = this._renderTargetSystem.getGpuRenderTarget(e).context, a = s || { x: 0, y: 0, width: e.pixelWidth, height: e.pixelHeight };
    if (r.setTransform(1, 0, 0, 1, 0, 0), r.clearRect(a.x, a.y, a.width, a.height), i) {
      const l = vn.shared.setValue(i);
      l.alpha > 0 && (r.globalAlpha = l.alpha, r.fillStyle = l.toHex(), r.fillRect(a.x, a.y, a.width, a.height), r.globalAlpha = 1);
    }
  }
  /**
   * Finishes the render pass (no-op for canvas).
   * @advanced
   */
  finishRenderPass() {
  }
  /**
   * Copies a render target into a texture source.
   * @param {RenderTarget} sourceRenderSurfaceTexture - Source render target.
   * @param {Texture} destinationTexture - Destination texture.
   * @param {object} originSrc - Source origin.
   * @param {number} originSrc.x - Source x origin.
   * @param {number} originSrc.y - Source y origin.
   * @param {object} size - Copy size.
   * @param {number} size.width - Copy width.
   * @param {number} size.height - Copy height.
   * @param {object} [originDest] - Destination origin.
   * @param {number} originDest.x - Destination x origin.
   * @param {number} originDest.y - Destination y origin.
   * @advanced
   */
  copyToTexture(e, t, i, s, o) {
    var f, p;
    const a = this._renderTargetSystem.getGpuRenderTarget(e).canvas, l = t.source, { context: d } = this._ensureCanvas(l), c = (f = o == null ? void 0 : o.x) != null ? f : 0, h = (p = o == null ? void 0 : o.y) != null ? p : 0;
    return d.drawImage(
      a,
      i.x,
      i.y,
      s.width,
      s.height,
      c,
      h,
      s.width,
      s.height
    ), l.update(), t;
  }
  /**
   * Copies the depth attachment of a render target into a texture (not supported in canvas).
   * @param _source - Source render target.
   * @param _destination - Destination depth/stencil texture.
   * @param _originSrc - Source origin of the copy.
   * @param _originSrc.x
   * @param _originSrc.y
   * @param _size - Size of the copy.
   * @param _size.width
   * @param _size.height
   * @param _originDest - Destination origin of the copy.
   * @param _originDest.x
   * @param _originDest.y
   * @advanced
   */
  copyDepthTexture(e, t, i, s, o) {
    dt("[CanvasRenderTargetAdaptor] copyDepthTexture is not supported in the canvas renderer");
  }
  /**
   * Destroys a GPU render target (no-op for canvas).
   * @param _gpuRenderTarget - Target to destroy.
   * @advanced
   */
  destroyGpuRenderTarget(e) {
  }
  _ensureCanvas(e) {
    let t = e.resource;
    (!t || !Ai.test(t)) && (t = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), e.resource = t), (t.width !== e.pixelWidth || t.height !== e.pixelHeight) && (t.width = e.pixelWidth, t.height = e.pixelHeight);
    const i = t.getContext("2d");
    return { canvas: t, context: i };
  }
}
class AT extends Ly {
  constructor(e) {
    super(e), this.adaptor = new bQ(), this.adaptor.init(e, this);
  }
}
AT.extension = {
  type: [Ae.CanvasSystem],
  name: "renderTarget"
};
class PT {
  /**
   * @param renderer - The owning CanvasRenderer.
   */
  constructor(e) {
  }
  /** Initializes the system (no-op for canvas). */
  init() {
  }
  /**
   * Initializes a texture source (no-op for canvas).
   * @param _source - Texture source.
   */
  initSource(e) {
  }
  /**
   * Creates a canvas containing the texture's frame.
   * @param texture - Texture to render.
   */
  generateCanvas(e) {
    var h, f;
    const t = zt.get().createCanvas(), i = t.getContext("2d"), s = St.getCanvasSource(e);
    if (!s)
      return t;
    const o = e.frame, r = (f = (h = e.source._resolution) != null ? h : e.source.resolution) != null ? f : 1, a = o.x * r, l = o.y * r, d = o.width * r, c = o.height * r;
    return t.width = Math.ceil(d), t.height = Math.ceil(c), i.drawImage(
      s,
      a,
      l,
      d,
      c,
      0,
      0,
      d,
      c
    ), t;
  }
  /**
   * Reads pixel data from a texture.
   * @param texture - Texture to read.
   */
  getPixels(e) {
    const t = this.generateCanvas(e);
    return {
      pixels: t.getContext("2d", { willReadFrequently: !0 }).getImageData(0, 0, t.width, t.height).data,
      width: t.width,
      height: t.height
    };
  }
  /** Destroys the system (no-op for canvas). */
  destroy() {
  }
}
PT.extension = {
  type: [
    Ae.CanvasSystem
  ],
  name: "texture"
};
const vQ = [
  ...Oy,
  uT,
  hT,
  PT,
  AT
], yQ = [
  Cy,
  ky,
  Ty,
  My,
  _y,
  dT,
  rT,
  Sy
], xQ = [
  zZ,
  pT
], ET = [], RT = [], zT = [], $T = [];
ht.handleByNamedList(Ae.CanvasSystem, ET);
ht.handleByNamedList(Ae.CanvasPipes, RT);
ht.handleByNamedList(Ae.CanvasPipesAdaptor, zT);
ht.handleByNamedList(Ae.CanvasLoader, $T);
ht.add(...vQ, ...yQ, ...xQ);
class wQ extends ku {
  constructor() {
    const e = {
      name: "canvas",
      type: rs.CANVAS,
      systems: ET,
      renderPipes: RT,
      renderPipeAdaptors: zT,
      loaders: $T
    };
    super(e);
  }
}
const kQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CanvasRenderer: wQ
}, Symbol.toStringTag, { value: "Module" }));
var Cp = /* @__PURE__ */ ((n) => (n[n.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", n[n.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", n[n.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", n))(Cp || {});
class _Q {
  constructor(e, t) {
    this._lastBindBaseLocation = -1, this._lastBindCallId = -1, this.buffer = e || null, this.updateID = -1, this.byteLength = -1, this.type = t;
  }
  destroy() {
    this.buffer = null, this.updateID = -1, this.byteLength = -1, this.type = -1, this._lastBindBaseLocation = -1, this._lastBindCallId = -1;
  }
}
class DT {
  /**
   * @param {Renderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null), this._minBaseLocation = 0, this._nextBindBaseIndex = this._minBaseLocation, this._bindCallId = 0, this._renderer = e, this._managedBuffers = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onBufferUnload.bind(this),
      name: "glBuffer"
    });
  }
  /** @ignore */
  destroy() {
    this._managedBuffers.destroy(), this._renderer = null, this._gl = null, this._boundBufferBases = {};
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this._gl = this._renderer.gl, this.destroyAll(!0), this._maxBindings = this._renderer.limits.maxUniformBindings;
  }
  getGlBuffer(e) {
    return e._gcLastUsed = this._renderer.gc.now, e._gpuData[this._renderer.uid] || this.createGLBuffer(e);
  }
  /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */
  bind(e) {
    const { _gl: t } = this, i = this.getGlBuffer(e);
    t.bindBuffer(i.type, i.buffer);
  }
  /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind it to.
   */
  bindBufferBase(e, t) {
    const { _gl: i } = this;
    this._boundBufferBases[t] !== e && (this._boundBufferBases[t] = e, e._lastBindBaseLocation = t, i.bindBufferBase(i.UNIFORM_BUFFER, t, e.buffer));
  }
  nextBindBase(e) {
    this._bindCallId++, this._minBaseLocation = 0, e && (this._boundBufferBases[0] = null, this._minBaseLocation = 1, this._nextBindBaseIndex < 1 && (this._nextBindBaseIndex = 1));
  }
  freeLocationForBufferBase(e) {
    let t = this.getLastBindBaseLocation(e);
    if (t >= this._minBaseLocation)
      return e._lastBindCallId = this._bindCallId, t;
    let i = 0, s = this._nextBindBaseIndex;
    for (; i < 2; ) {
      s >= this._maxBindings && (s = this._minBaseLocation, i++);
      const o = this._boundBufferBases[s];
      if (o && o._lastBindCallId === this._bindCallId) {
        s++;
        continue;
      }
      break;
    }
    return t = s, this._nextBindBaseIndex = s + 1, i >= 2 ? -1 : (e._lastBindCallId = this._bindCallId, this._boundBufferBases[t] = null, t);
  }
  getLastBindBaseLocation(e) {
    const t = e._lastBindBaseLocation;
    return this._boundBufferBases[t] === e ? t : -1;
  }
  /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   * @param size - the size to bind at (this is blocks of 256).
   */
  bindBufferRange(e, t, i, s) {
    const { _gl: o } = this;
    i || (i = 0), t || (t = 0), this._boundBufferBases[t] = null, o.bindBufferRange(o.UNIFORM_BUFFER, t || 0, e.buffer, i * 256, s || 256);
  }
  /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {Buffer} buffer - the buffer to update
   */
  updateBuffer(e) {
    const { _gl: t } = this, i = this.getGlBuffer(e);
    if (e._updateID === i.updateID)
      return i;
    i.updateID = e._updateID, t.bindBuffer(i.type, i.buffer);
    const s = e.data, o = e.descriptor.usage & $t.STATIC ? t.STATIC_DRAW : t.DYNAMIC_DRAW;
    return s ? i.byteLength >= s.byteLength ? t.bufferSubData(
      i.type,
      e._updateOffset,
      s,
      e._updateOffset / s.BYTES_PER_ELEMENT,
      (e._updateSize || s.byteLength) / s.BYTES_PER_ELEMENT
    ) : (i.byteLength = s.byteLength, t.bufferData(i.type, s, o)) : (i.byteLength = e.descriptor.size, t.bufferData(i.type, i.byteLength, o)), i;
  }
  /**
   * dispose all WebGL resources of all managed buffers
   * @param contextLost
   */
  destroyAll(e = !1) {
    this._managedBuffers.removeAll(e);
  }
  onBufferUnload(e, t = !1) {
    const i = e._gpuData[this._renderer.uid];
    i && (t || this._gl.deleteBuffer(i.buffer));
  }
  /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */
  createGLBuffer(e) {
    const { _gl: t } = this;
    let i = Cp.ARRAY_BUFFER;
    e.descriptor.usage & $t.INDEX ? i = Cp.ELEMENT_ARRAY_BUFFER : e.descriptor.usage & $t.UNIFORM && (i = Cp.UNIFORM_BUFFER);
    const s = new _Q(t.createBuffer(), i);
    return e._gpuData[this._renderer.uid] = s, this._managedBuffers.add(e), s;
  }
  resetState() {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null);
  }
}
DT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "buffer"
};
const By = class OT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.supports = {
      /** Support for 32-bit indices buffer. */
      uint32Indices: !0,
      /** Support for UniformBufferObjects */
      uniformBufferObject: !0,
      /** Support for VertexArrayObjects */
      vertexArrayObject: !0,
      /** Support for SRGB texture format */
      srgbTextures: !0,
      /** Support for wrapping modes if a texture is non-power of two */
      nonPowOf2wrapping: !0,
      /** Support for MSAA (antialiasing of dynamic textures) */
      msaa: !0,
      /** Support for mipmaps if a texture is non-power of two */
      nonPowOf2mipmaps: !0
    }, this._renderer = e, this.extensions = /* @__PURE__ */ Object.create(null), this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
  }
  /**
   * `true` if the context is lost
   * @readonly
   */
  get isLost() {
    return !this.gl || this.gl.isContextLost();
  }
  /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */
  contextChange(e) {
    this.gl = e, this._renderer.gl = e;
  }
  init(e) {
    var i, s;
    e = { ...OT.defaultOptions, ...e };
    let t = this.multiView = e.multiView;
    if (e.context && t && (dt("Renderer created with both a context and multiview enabled. Disabling multiView as both cannot work together."), t = !1), t ? this.canvas = zt.get().createCanvas(this._renderer.canvas.width, this._renderer.canvas.height) : this.canvas = this._renderer.view.canvas, e.context)
      this.initFromContext(e.context);
    else {
      const o = this._renderer.background.alpha < 1, r = (i = e.premultipliedAlpha) != null ? i : !0, a = e.antialias && !this._renderer.backBuffer.useBackBuffer;
      this.createContext(e.preferWebGLVersion, {
        alpha: o,
        premultipliedAlpha: r,
        antialias: a,
        stencil: !0,
        preserveDrawingBuffer: e.preserveDrawingBuffer,
        powerPreference: (s = e.powerPreference) != null ? s : "default"
      });
    }
  }
  ensureCanvasSize(e) {
    if (!this.multiView) {
      e !== this.canvas && dt("multiView is disabled, but targetCanvas is not the main canvas");
      return;
    }
    const { canvas: t } = this;
    (t.width < e.width || t.height < e.height) && (t.width = Math.max(e.width, e.width), t.height = Math.max(e.height, e.height));
  }
  /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */
  initFromContext(e) {
    this.gl = e, this.webGLVersion = e instanceof zt.get().getWebGLRenderingContext() ? 1 : 2, this.getExtensions(), this.validateContext(e), this._renderer.runners.contextChange.emit(e);
    const t = this._renderer.view.canvas;
    t.addEventListener("webglcontextlost", this.handleContextLost, !1), t.addEventListener("webglcontextrestored", this.handleContextRestored, !1);
  }
  /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param preferWebGLVersion
   * @param {object} options - context attributes
   */
  createContext(e, t) {
    let i;
    const s = this.canvas;
    if (e === 2 && (i = s.getContext("webgl2", t)), !i && (i = s.getContext("webgl", t), !i))
      throw new Error("This browser does not support WebGL. Try using the canvas renderer");
    this.gl = i, this.initFromContext(this.gl);
  }
  /** Auto-populate the {@link GlContextSystem.extensions extensions}. */
  getExtensions() {
    const { gl: e } = this, t = {
      anisotropicFiltering: e.getExtension("EXT_texture_filter_anisotropic"),
      floatTextureLinear: e.getExtension("OES_texture_float_linear"),
      s3tc: e.getExtension("WEBGL_compressed_texture_s3tc"),
      s3tc_sRGB: e.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
      // eslint-disable-line camelcase
      etc: e.getExtension("WEBGL_compressed_texture_etc"),
      etc1: e.getExtension("WEBGL_compressed_texture_etc1"),
      pvrtc: e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      atc: e.getExtension("WEBGL_compressed_texture_atc"),
      astc: e.getExtension("WEBGL_compressed_texture_astc"),
      bptc: e.getExtension("EXT_texture_compression_bptc"),
      rgtc: e.getExtension("EXT_texture_compression_rgtc"),
      loseContext: e.getExtension("WEBGL_lose_context")
    };
    if (this.webGLVersion === 1)
      this.extensions = {
        ...t,
        drawBuffers: e.getExtension("WEBGL_draw_buffers"),
        depthTexture: e.getExtension("WEBGL_depth_texture"),
        vertexArrayObject: e.getExtension("OES_vertex_array_object") || e.getExtension("MOZ_OES_vertex_array_object") || e.getExtension("WEBKIT_OES_vertex_array_object"),
        uint32ElementIndex: e.getExtension("OES_element_index_uint"),
        // Floats and half-floats
        floatTexture: e.getExtension("OES_texture_float"),
        floatTextureLinear: e.getExtension("OES_texture_float_linear"),
        textureHalfFloat: e.getExtension("OES_texture_half_float"),
        textureHalfFloatLinear: e.getExtension("OES_texture_half_float_linear"),
        vertexAttribDivisorANGLE: e.getExtension("ANGLE_instanced_arrays"),
        srgb: e.getExtension("EXT_sRGB")
      };
    else {
      this.extensions = {
        ...t,
        colorBufferFloat: e.getExtension("EXT_color_buffer_float")
      };
      const i = e.getExtension("WEBGL_provoking_vertex");
      i && i.provokingVertexWEBGL(i.FIRST_VERTEX_CONVENTION_WEBGL);
    }
  }
  /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */
  handleContextLost(e) {
    e.preventDefault(), this._contextLossForced && (this._contextLossForced = !1, setTimeout(() => {
      var t;
      this.gl.isContextLost() && ((t = this.extensions.loseContext) == null || t.restoreContext());
    }, 0));
  }
  /** Handles a restored webgl context. */
  handleContextRestored() {
    this.getExtensions(), this._renderer.runners.contextChange.emit(this.gl);
  }
  destroy() {
    var t;
    const e = this._renderer.view.canvas;
    this._renderer = null, e.removeEventListener("webglcontextlost", this.handleContextLost), e.removeEventListener("webglcontextrestored", this.handleContextRestored), this.gl.useProgram(null), (t = this.extensions.loseContext) == null || t.loseContext();
  }
  /**
   * this function can be called to force a webGL context loss
   * this will release all resources on the GPU.
   * Useful if you need to put Pixi to sleep, and save some GPU memory
   *
   * As soon as render is called - all resources will be created again.
   */
  forceContextLoss() {
    var e;
    (e = this.extensions.loseContext) == null || e.loseContext(), this._contextLossForced = !0;
  }
  /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */
  validateContext(e) {
    const t = e.getContextAttributes();
    t && !t.stencil && dt("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
    const i = this.supports, s = this.webGLVersion === 2, o = this.extensions;
    i.uint32Indices = s || !!o.uint32ElementIndex, i.uniformBufferObject = s, i.vertexArrayObject = s || !!o.vertexArrayObject, i.srgbTextures = s || !!o.srgb, i.nonPowOf2wrapping = s, i.nonPowOf2mipmaps = s, i.msaa = s, i.uint32Indices || dt("Provided WebGL context does not support 32 index buffer, large scenes may not render correctly");
  }
};
By.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "context"
};
By.defaultOptions = {
  /**
   * {@link WebGLOptions.context}
   * @default null
   */
  context: null,
  /**
   * {@link WebGLOptions.premultipliedAlpha}
   * @default true
   */
  premultipliedAlpha: !0,
  /**
   * {@link WebGLOptions.preserveDrawingBuffer}
   * @default false
   */
  preserveDrawingBuffer: !1,
  /**
   * {@link WebGLOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * {@link WebGLOptions.webGLVersion}
   * @default 2
   */
  preferWebGLVersion: 2,
  /**
   * {@link WebGLOptions.multiView}
   * @default false
   */
  multiView: !1
};
let SQ = By;
function m0(n, e) {
  var t, i, s;
  for (const o in n.attributes) {
    const r = n.attributes[o], a = e[o];
    a ? ((t = r.format) != null || (r.format = a.format), (i = r.offset) != null || (r.offset = a.offset), (s = r.instance) != null || (r.instance = a.instance)) : r.format || dt(`Attribute ${o} is not present in the shader, but is present in the geometry. Unable to infer attribute details.`);
  }
  MQ(n);
}
function MQ(n) {
  var o, r;
  const { buffers: e, attributes: t } = n, i = {}, s = {};
  for (const a in e) {
    const l = e[a];
    i[l.uid] = 0, s[l.uid] = 0;
  }
  for (const a in t) {
    const l = t[a];
    i[l.buffer.uid] += Hc(l.format).stride;
  }
  for (const a in t) {
    const l = t[a];
    (o = l.stride) != null || (l.stride = i[l.buffer.uid]), (r = l.start) != null || (l.start = s[l.buffer.uid]), s[l.buffer.uid] += Hc(l.format).stride;
  }
}
var g0 = /* @__PURE__ */ ((n) => (n[n.RGBA = 6408] = "RGBA", n[n.RGB = 6407] = "RGB", n[n.RG = 33319] = "RG", n[n.RED = 6403] = "RED", n[n.RGBA_INTEGER = 36249] = "RGBA_INTEGER", n[n.RGB_INTEGER = 36248] = "RGB_INTEGER", n[n.RG_INTEGER = 33320] = "RG_INTEGER", n[n.RED_INTEGER = 36244] = "RED_INTEGER", n[n.ALPHA = 6406] = "ALPHA", n[n.LUMINANCE = 6409] = "LUMINANCE", n[n.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", n[n.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", n[n.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", n))(g0 || {}), Jc = /* @__PURE__ */ ((n) => (n[n.TEXTURE_2D = 3553] = "TEXTURE_2D", n[n.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", n[n.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", n[n.TEXTURE_3D = 32879] = "TEXTURE_3D", n[n.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", n[n.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", n[n.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", n[n.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", n[n.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", n[n.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", n))(Jc || {}), At = /* @__PURE__ */ ((n) => (n[n.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", n[n.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", n[n.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", n[n.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", n[n.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", n[n.UNSIGNED_INT = 5125] = "UNSIGNED_INT", n[n.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", n[n.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", n[n.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", n[n.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", n[n.BYTE = 5120] = "BYTE", n[n.SHORT = 5122] = "SHORT", n[n.INT = 5124] = "INT", n[n.FLOAT = 5126] = "FLOAT", n[n.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", n[n.HALF_FLOAT = 36193] = "HALF_FLOAT", n))(At || {});
const G2 = {
  uint8x2: At.UNSIGNED_BYTE,
  uint8x4: At.UNSIGNED_BYTE,
  sint8x2: At.BYTE,
  sint8x4: At.BYTE,
  unorm8x2: At.UNSIGNED_BYTE,
  unorm8x4: At.UNSIGNED_BYTE,
  snorm8x2: At.BYTE,
  snorm8x4: At.BYTE,
  uint16x2: At.UNSIGNED_SHORT,
  uint16x4: At.UNSIGNED_SHORT,
  sint16x2: At.SHORT,
  sint16x4: At.SHORT,
  unorm16x2: At.UNSIGNED_SHORT,
  unorm16x4: At.UNSIGNED_SHORT,
  snorm16x2: At.SHORT,
  snorm16x4: At.SHORT,
  float16x2: At.HALF_FLOAT,
  float16x4: At.HALF_FLOAT,
  float32: At.FLOAT,
  float32x2: At.FLOAT,
  float32x3: At.FLOAT,
  float32x4: At.FLOAT,
  uint32: At.UNSIGNED_INT,
  uint32x2: At.UNSIGNED_INT,
  uint32x3: At.UNSIGNED_INT,
  uint32x4: At.UNSIGNED_INT,
  sint32: At.INT,
  sint32x2: At.INT,
  sint32x3: At.INT,
  sint32x4: At.INT
};
function TQ(n) {
  var e;
  return (e = G2[n]) != null ? e : G2.float32;
}
const CQ = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 3,
  "triangle-list": 4,
  "triangle-strip": 5
};
class IQ {
  constructor() {
    this.vaoCache = /* @__PURE__ */ Object.create(null);
  }
  destroy() {
    this.vaoCache = /* @__PURE__ */ Object.create(null);
  }
}
class LT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this._managedGeometries = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onGeometryUnload.bind(this),
      name: "glGeometry"
    });
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const e = this.gl = this._renderer.gl;
    if (!this._renderer.context.supports.vertexArrayObject)
      throw new Error("[PixiJS] Vertex Array Objects are not supported on this device");
    this.destroyAll(!0);
    const t = this._renderer.context.extensions.vertexArrayObject;
    t && (e.createVertexArray = () => t.createVertexArrayOES(), e.bindVertexArray = (s) => t.bindVertexArrayOES(s), e.deleteVertexArray = (s) => t.deleteVertexArrayOES(s));
    const i = this._renderer.context.extensions.vertexAttribDivisorANGLE;
    i && (e.drawArraysInstanced = (s, o, r, a) => {
      i.drawArraysInstancedANGLE(s, o, r, a);
    }, e.drawElementsInstanced = (s, o, r, a, l) => {
      i.drawElementsInstancedANGLE(s, o, r, a, l);
    }, e.vertexAttribDivisor = (s, o) => i.vertexAttribDivisorANGLE(s, o)), this._activeGeometry = null, this._activeVao = null;
  }
  /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param program - Instance of program to use vao for.
   */
  bind(e, t) {
    const i = this.gl;
    this._activeGeometry = e;
    const s = this.getVao(e, t);
    this._activeVao !== s && (this._activeVao = s, i.bindVertexArray(s)), this.updateBuffers();
  }
  /** Reset and unbind any active VAO and geometry. */
  resetState() {
    this.unbind();
  }
  /** Update buffers of the currently bound geometry. */
  updateBuffers() {
    const e = this._activeGeometry, t = this._renderer.buffer;
    for (let i = 0; i < e.buffers.length; i++) {
      const s = e.buffers[i];
      t.updateBuffer(s);
    }
    e._gcLastUsed = this._renderer.gc.now;
  }
  /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */
  checkCompatibility(e, t) {
    const i = e.attributes, s = t._attributeData;
    for (const o in s)
      if (!i[o])
        throw new Error(`shader and geometry incompatible, geometry missing the "${o}" attribute`);
  }
  /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */
  getSignature(e, t) {
    const i = e.attributes, s = t._attributeData, o = ["g", e.uid];
    for (const r in i)
      s[r] && o.push(r, s[r].location);
    return o.join("-");
  }
  getVao(e, t) {
    var i;
    return ((i = e._gpuData[this._renderer.uid]) == null ? void 0 : i.vaoCache[t._key]) || this.initGeometryVao(e, t);
  }
  /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param program
   * @param _incRefCount - Increment refCount of all geometry buffers.
   */
  initGeometryVao(e, t, i = !0) {
    const s = this._renderer.gl, o = this._renderer.buffer;
    this._renderer.shader._getProgramData(t), this.checkCompatibility(e, t);
    const r = this.getSignature(e, t);
    let a = e._gpuData[this._renderer.uid];
    a || (a = new IQ(), e._gpuData[this._renderer.uid] = a, this._managedGeometries.add(e));
    const l = a.vaoCache;
    let d = l[r];
    if (d)
      return l[t._key] = d, d;
    m0(e, t._attributeData);
    const c = e.buffers;
    d = s.createVertexArray(), s.bindVertexArray(d);
    for (let h = 0; h < c.length; h++) {
      const f = c[h];
      o.bind(f);
    }
    return this.activateVao(e, t), l[t._key] = d, l[r] = d, s.bindVertexArray(null), d;
  }
  onGeometryUnload(e, t = !1) {
    const i = e._gpuData[this._renderer.uid];
    if (!i) return;
    const s = i.vaoCache;
    if (!t)
      for (const o in s)
        this._activeVao === s[o] && this.resetState(), this.gl.deleteVertexArray(s[o]);
  }
  /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  destroyAll(e = !1) {
    this._managedGeometries.removeAll(e);
  }
  /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */
  activateVao(e, t) {
    var a, l;
    const i = this._renderer.gl, s = this._renderer.buffer, o = e.attributes;
    e.indexBuffer && s.bind(e.indexBuffer);
    let r = null;
    for (const d in o) {
      const c = o[d], h = c.buffer, f = s.getGlBuffer(h), p = t._attributeData[d];
      if (p) {
        r !== f && (s.bind(h), r = f);
        const y = p.location;
        i.enableVertexAttribArray(y);
        const v = Hc(c.format), x = TQ(c.format);
        if (((a = p.format) == null ? void 0 : a.substring(1, 4)) === "int" ? i.vertexAttribIPointer(
          y,
          v.size,
          x,
          c.stride,
          c.offset
        ) : i.vertexAttribPointer(
          y,
          v.size,
          x,
          v.normalised,
          c.stride,
          c.offset
        ), c.instance)
          if (this.hasInstance) {
            const w = (l = c.divisor) != null ? l : 1;
            i.vertexAttribDivisor(y, w);
          } else
            throw new Error("geometry error, GPU Instancing is not supported on this device");
      }
    }
  }
  /**
   * Draws the currently bound geometry.
   * @param topology - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, an indexed geometry
   *  falls back to {@link Geometry.indexCount} and then to its whole index buffer, and a
   *  non-indexed one to {@link Geometry.vertexCount}.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   * @returns This instance of the geometry system.
   */
  draw(e, t, i, s) {
    const { gl: o } = this._renderer, r = this._activeGeometry, a = CQ[e || r.topology];
    if (s != null || (s = r.instanceCount), r.indexBuffer) {
      const l = r.indexBuffer.data.BYTES_PER_ELEMENT, d = l === 2 ? o.UNSIGNED_SHORT : o.UNSIGNED_INT, c = t || r.indexCount || r.indexBuffer.data.length, h = (i || 0) * l;
      s !== 1 ? o.drawElementsInstanced(a, c, d, h, s) : o.drawElements(a, c, d, h);
    } else s !== 1 ? o.drawArraysInstanced(a, i || 0, t || r.vertexCount, s) : o.drawArrays(a, i || 0, t || r.vertexCount);
    return this;
  }
  /** Unbind/reset everything. */
  unbind() {
    this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
  }
  destroy() {
    this._managedGeometries.destroy(), this._renderer = null, this.gl = null, this._activeVao = null, this._activeGeometry = null;
  }
}
LT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "geometry"
};
const AQ = new bm({
  attributes: {
    aPosition: [
      -1,
      -1,
      // Bottom left corner
      3,
      -1,
      // Bottom right corner, extending beyond right edge
      -1,
      3
      // Top left corner, extending beyond top edge
    ]
  }
}), Fy = class BT {
  constructor(e) {
    this.useBackBuffer = !1, this._useBackBufferThisRender = !1, this._renderer = e;
  }
  init(e = {}) {
    const { useBackBuffer: t, antialias: i } = { ...BT.defaultOptions, ...e };
    this.useBackBuffer = t, this._antialias = i, this._renderer.context.supports.msaa || (dt("antialiasing, is not supported on when using the back buffer"), this._antialias = !1), this._state = co.for2d();
    const s = new Xl({
      vertex: `
                attribute vec2 aPosition;
                out vec2 vUv;

                void main() {
                    gl_Position = vec4(aPosition, 0.0, 1.0);

                    vUv = (aPosition + 1.0) / 2.0;

                    // flip dem UVs
                    vUv.y = 1.0 - vUv.y;
                }`,
      fragment: `
                in vec2 vUv;
                out vec4 finalColor;

                uniform sampler2D uTexture;

                void main() {
                    finalColor = texture(uTexture, vUv);
                }`,
      name: "big-triangle"
    });
    this._bigTriangleShader = new lo({
      glProgram: s,
      resources: {
        uTexture: et.WHITE.source
      }
    });
  }
  /**
   * This is called before the RenderTargetSystem is started. This is where
   * we replace the target with the back buffer if required.
   * @param options - The options for this render.
   */
  renderStart(e) {
    const t = this._renderer.renderTarget.getRenderTarget(e.target);
    if (this._useBackBufferThisRender = this.useBackBuffer && !!t.isRoot, this._useBackBufferThisRender) {
      const i = this._renderer.renderTarget.getRenderTarget(e.target);
      this._targetTexture = i.colorTexture, e.target = this._getBackBufferTexture(i.colorTexture);
    }
  }
  renderEnd() {
    this._presentBackBuffer();
  }
  _presentBackBuffer() {
    const e = this._renderer;
    e.renderTarget.finishRenderPass(), this._useBackBufferThisRender && (e.renderTarget.bind({ target: this._targetTexture, clear: !1 }), this._bigTriangleShader.resources.uTexture = this._backBufferTexture.source, e.encoder.draw({
      geometry: AQ,
      shader: this._bigTriangleShader,
      state: this._state
    }));
  }
  _getBackBufferTexture(e) {
    return this._backBufferTexture = this._backBufferTexture || new et({
      source: new un({
        width: e.width,
        height: e.height,
        resolution: e._resolution,
        antialias: this._antialias
      })
    }), this._backBufferTexture.source.resize(
      e.width,
      e.height,
      e._resolution
    ), this._backBufferTexture;
  }
  /** destroys the back buffer */
  destroy() {
    this._backBufferTexture && (this._backBufferTexture.destroy(), this._backBufferTexture = null);
  }
};
Fy.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "backBuffer",
  priority: 1
};
Fy.defaultOptions = {
  /** if true will use the back buffer where required */
  useBackBuffer: !1
};
let PQ = Fy;
class FT {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.gl.colorMask(
      !!(e & 8),
      !!(e & 4),
      !!(e & 2),
      !!(e & 1)
    ));
  }
}
FT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "colorMask"
};
class NT {
  constructor(e) {
    this.commandFinished = Promise.resolve(), this._renderer = e;
  }
  setGeometry(e, t) {
    this._renderer.geometry.bind(e, t.glProgram);
  }
  finishRenderPass() {
  }
  draw(e) {
    const t = this._renderer, { geometry: i, shader: s, state: o, skipSync: r, topology: a, size: l, start: d, instanceCount: c } = e;
    t.shader.bind(s, r), t.geometry.bind(i, t.shader._activeProgram), o && t.state.set(o), t.geometry.draw(a, l, d, c != null ? c : i.instanceCount);
  }
  destroy() {
    this._renderer = null;
  }
}
NT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "encoder"
};
class UT {
  constructor(e) {
    this._renderer = e;
  }
  contextChange() {
    const e = this._renderer.gl;
    this.maxTextures = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), this.maxBatchableTextures = yM(this.maxTextures, e);
    const t = this._renderer.context.webGLVersion === 2;
    this.maxUniformBindings = t ? e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
  }
  destroy() {
  }
}
UT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "limits"
};
class EQ {
  constructor() {
    this.width = -1, this.height = -1, this.msaa = !1, this._attachedMipLevel = 0, this._attachedLayer = 0, this.msaaRenderBuffer = [], this.stencilMode = fn.DISABLED, this.stencilReference = 0, this.maskStackIndex = 0;
  }
}
const cr = [];
cr[fn.NONE] = void 0;
cr[fn.DISABLED] = {
  stencilWriteMask: 0,
  stencilReadMask: 0
};
cr[fn.RENDERING_MASK_ADD] = {
  stencilFront: {
    compare: "equal",
    passOp: "increment-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "increment-clamp"
  }
};
cr[fn.RENDERING_MASK_REMOVE] = {
  stencilFront: {
    compare: "equal",
    passOp: "decrement-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "decrement-clamp"
  }
};
cr[fn.MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "equal",
    passOp: "keep"
  }
};
cr[fn.INVERSE_MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "not-equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "not-equal",
    passOp: "keep"
  }
};
class GT {
  constructor(e) {
    this._stencilCache = {
      enabled: !1,
      stencilReference: 0,
      stencilMode: fn.NONE
    }, this._renderer = e, e.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange(e) {
    this._gl = e, this._comparisonFuncMapping = {
      always: e.ALWAYS,
      never: e.NEVER,
      equal: e.EQUAL,
      "not-equal": e.NOTEQUAL,
      less: e.LESS,
      "less-equal": e.LEQUAL,
      greater: e.GREATER,
      "greater-equal": e.GEQUAL
    }, this._stencilOpsMapping = {
      keep: e.KEEP,
      zero: e.ZERO,
      replace: e.REPLACE,
      invert: e.INVERT,
      "increment-clamp": e.INCR,
      "decrement-clamp": e.DECR,
      "increment-wrap": e.INCR_WRAP,
      "decrement-wrap": e.DECR_WRAP
    }, this._activeGpuRenderTarget = null, this.resetState();
  }
  onRenderTargetChange(e) {
    if (this._activeRenderTarget === e) return;
    this._activeRenderTarget = e;
    const t = this._renderer.renderTarget.getGpuRenderTarget(e);
    this._activeGpuRenderTarget = t, this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  resetState() {
    this._stencilCache.enabled = !1, this._stencilCache.stencilMode = fn.NONE, this._stencilCache.stencilReference = 0;
  }
  setStencilMode(e, t) {
    var a;
    const i = (a = this._activeGpuRenderTarget) != null ? a : this._activeGpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(this._activeRenderTarget), s = this._gl, o = cr[e], r = this._stencilCache;
    if (i.stencilMode = e, i.stencilReference = t, e === fn.DISABLED) {
      this._stencilCache.enabled && (this._stencilCache.enabled = !1, s.disable(s.STENCIL_TEST));
      return;
    }
    this._stencilCache.enabled || (this._stencilCache.enabled = !0, s.enable(s.STENCIL_TEST)), (e !== r.stencilMode || r.stencilReference !== t) && (r.stencilMode = e, r.stencilReference = t, s.stencilFunc(this._comparisonFuncMapping[o.stencilBack.compare], t, 255), s.stencilOp(s.KEEP, s.KEEP, this._stencilOpsMapping[o.stencilBack.passOp]));
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._gl = null, this._activeRenderTarget = null, this._activeGpuRenderTarget = null;
  }
}
GT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "stencil"
};
class jT {
  constructor(e) {
    this._syncFunctionHash = /* @__PURE__ */ Object.create(null), this._adaptor = e, this._systemCheck();
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */
  _systemCheck() {
    if (!nM())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  ensureUniformGroup(e) {
    const t = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new ns({
      data: new Float32Array(t.layout.size / 4),
      usage: $t.UNIFORM | $t.COPY_DST
    }));
  }
  getUniformGroupData(e) {
    return this._syncFunctionHash[e._signature] || this._initUniformGroup(e);
  }
  _initUniformGroup(e) {
    const t = e._signature;
    let i = this._syncFunctionHash[t];
    if (!i) {
      const s = Object.keys(e.uniformStructures).map((a) => e.uniformStructures[a]), o = this._adaptor.createUboElements(s), r = this._generateUboSync(o.uboElements);
      i = this._syncFunctionHash[t] = {
        layout: o,
        syncFunction: r
      };
    }
    return this._syncFunctionHash[t];
  }
  _generateUboSync(e) {
    return this._adaptor.generateUboSync(e);
  }
  syncUniformGroup(e, t, i) {
    const s = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new ns({
      data: new Float32Array(s.layout.size / 4),
      usage: $t.UNIFORM | $t.COPY_DST
    }));
    let o = null;
    return t || (t = e.buffer.data, o = e.buffer.dataInt32), i || (i = 0), s.syncFunction(e.uniforms, t, o, i), !0;
  }
  updateUniformGroup(e) {
    if (e.isStatic && !e._dirtyId) return !1;
    e._dirtyId = 0;
    const t = this.syncUniformGroup(e);
    return e.buffer.update(), t;
  }
  destroy() {
    this._syncFunctionHash = null;
  }
}
const HT = {
  f32: 4,
  i32: 4,
  "vec2<f32>": 8,
  "vec3<f32>": 12,
  "vec4<f32>": 16,
  "vec2<i32>": 8,
  "vec3<i32>": 12,
  "vec4<i32>": 16,
  u32: 4,
  "vec2<u32>": 8,
  "vec3<u32>": 12,
  "vec4<u32>": 16,
  "mat2x2<f32>": 32,
  "mat3x3<f32>": 48,
  "mat4x4<f32>": 64
  // TODO - not essential for now but support these in the future
  // int:      4,
  // ivec2:    8,
  // ivec3:    12,
  // ivec4:    16,
  // uint:     4,
  // uvec2:    8,
  // uvec3:    12,
  // uvec4:    16,
  // bool:     4,
  // bvec2:    8,
  // bvec3:    12,
  // bvec4:    16,
  // mat2:     16 * 2,
  // mat3:     16 * 3,
  // mat4:     16 * 4,
};
function RQ(n) {
  const e = n.map((o) => ({
    data: o,
    offset: 0,
    size: 0
  })), t = 16;
  let i = 0, s = 0;
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (i = HT[r.data.type], !i)
      throw new Error(`Unknown type ${r.data.type}`);
    r.data.size > 1 && (i = Math.max(i, t) * r.data.size);
    const a = i === 12 ? 16 : i;
    r.size = i;
    const l = s % t;
    l > 0 && t - l < a ? s += (t - l) % 16 : s += (i - l % i) % i, r.offset = s, s += i;
  }
  return s = Math.ceil(s / 16) * 16, { uboElements: e, size: s };
}
const gl = [
  // uploading pixi matrix object to mat3
  {
    type: "mat3x3<f32>",
    test: (n) => n.value.a !== void 0,
    ubo: `
            var matrix = uv[name].toArray(true);
            data[offset] = matrix[0];
            data[offset + 1] = matrix[1];
            data[offset + 2] = matrix[2];
            data[offset + 4] = matrix[3];
            data[offset + 5] = matrix[4];
            data[offset + 6] = matrix[5];
            data[offset + 8] = matrix[6];
            data[offset + 9] = matrix[7];
            data[offset + 10] = matrix[8];
        `,
    uniform: `
            gl.uniformMatrix3fv(ud[name].location, false, uv[name].toArray(true));
        `
  },
  // uploading a pixi rectangle as a vec4
  {
    type: "vec4<f32>",
    test: (n) => n.type === "vec4<f32>" && n.size === 1 && n.value.width !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
            data[offset + 2] = v.width;
            data[offset + 3] = v.height;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height) {
                cv[0] = v.x;
                cv[1] = v.y;
                cv[2] = v.width;
                cv[3] = v.height;
                gl.uniform4f(ud[name].location, v.x, v.y, v.width, v.height);
            }
        `
  },
  // uploading a pixi point as a vec2
  {
    type: "vec2<f32>",
    test: (n) => n.type === "vec2<f32>" && n.size === 1 && n.value.x !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y) {
                cv[0] = v.x;
                cv[1] = v.y;
                gl.uniform2f(ud[name].location, v.x, v.y);
            }
        `
  },
  // uploading a pixi color as a vec4
  {
    type: "vec4<f32>",
    test: (n) => n.type === "vec4<f32>" && n.size === 1 && n.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
            data[offset + 3] = v.alpha;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                cv[3] = v.alpha;
                gl.uniform4f(ud[name].location, v.red, v.green, v.blue, v.alpha);
            }
        `
  },
  // uploading a pixi color as a vec3
  {
    type: "vec3<f32>",
    test: (n) => n.type === "vec3<f32>" && n.size === 1 && n.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                gl.uniform3f(ud[name].location, v.red, v.green, v.blue);
            }
        `
  }
];
function VT(n, e, t) {
  const i = [`
        var v = null;
        var v2 = null;
        var t = 0;
        var index = 0;
        var name = null;
        var arrayOffset = null;
    `];
  let s = 0;
  for (let r = 0; r < n.length; r++) {
    const a = n[r], l = a.data.name;
    let d = !1, c = 0;
    for (let h = 0; h < gl.length; h++)
      if (gl[h].test(a.data)) {
        c = a.offset / 4, i.push(
          `name = "${l}";`,
          `offset += ${c - s};`,
          gl[h].ubo
        ), d = !0;
        break;
      }
    if (!d)
      if (a.data.size > 1)
        c = a.offset / 4, i.push(t(a, c - s));
      else {
        const h = e[a.data.type];
        c = a.offset / 4, i.push(
          /* wgsl */
          `
                    v = uv.${l};
                    offset += ${c - s};
                    ${h};
                `
        );
      }
    s = c;
  }
  const o = i.join(`
`);
  return new Function(
    "uv",
    "data",
    "dataInt32",
    "offset",
    o
  );
}
function Ra(n, e) {
  return `
        for (let i = 0; i < ${n * e}; i++) {
            data[offset + (((i / ${n})|0) * 4) + (i % ${n})] = v[i];
        }
    `;
}
const WT = {
  f32: `
        data[offset] = v;`,
  i32: `
        dataInt32[offset] = v;`,
  u32: `
        dataInt32[offset] = v;`,
  "vec2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];`,
  "vec3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];`,
  "vec4<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];`,
  "vec2<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "vec2<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 4] = v[2];
        data[offset + 5] = v[3];`,
  "mat3x3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];
        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];`,
  "mat4x4<f32>": `
        for (let i = 0; i < 16; i++) {
            data[offset + i] = v[i];
        }`,
  "mat3x2<f32>": Ra(3, 2),
  "mat4x2<f32>": Ra(4, 2),
  "mat2x3<f32>": Ra(2, 3),
  "mat4x3<f32>": Ra(4, 3),
  "mat2x4<f32>": Ra(2, 4),
  "mat3x4<f32>": Ra(3, 4)
}, zQ = {
  ...WT,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];
    `
};
function $Q(n, e) {
  const t = Math.max(HT[n.data.type] / 16, 1), i = n.data.value.length / n.data.size, s = (4 - i % 4) % 4, o = n.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
        v = uv.${n.data.name};
        offset += ${e};

        arrayOffset = offset;

        t = 0;

        for(var i=0; i < ${n.data.size * t}; i++)
        {
            for(var j = 0; j < ${i}; j++)
            {
                ${o}[arrayOffset++] = v[t++];
            }
            ${s !== 0 ? `arrayOffset += ${s};` : ""}
        }
    `;
}
function DQ(n) {
  return VT(
    n,
    WT,
    $Q
  );
}
class qT extends jT {
  constructor() {
    super({
      createUboElements: RQ,
      generateUboSync: DQ
    });
  }
}
qT.extension = {
  type: [Ae.WebGLSystem],
  name: "ubo"
};
class OQ {
  constructor() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new Tt(), this._boundFramebuffer = void 0;
  }
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t, e.runners.contextChange.add(this);
  }
  contextChange() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new Tt(), this._boundFramebuffer = void 0;
    const e = this._renderer.gl;
    this._drawBuffersCache = [];
    for (let t = 1; t <= 16; t++)
      this._drawBuffersCache[t] = Array.from({ length: t }, (i, s) => e.COLOR_ATTACHMENT0 + s);
  }
  copyToTexture(e, t, i, s, o) {
    const r = this._renderTargetSystem, a = this._renderer, l = r.getGpuRenderTarget(e), d = a.gl;
    return this.finishRenderPass(e), d.bindFramebuffer(d.FRAMEBUFFER, l.resolveTargetFramebuffer), this._boundFramebuffer = l.resolveTargetFramebuffer, a.texture.bind(t, 0), d.copyTexSubImage2D(
      d.TEXTURE_2D,
      0,
      o.x,
      o.y,
      i.x,
      i.y,
      s.width,
      s.height
    ), t;
  }
  copyDepthTexture(e, t, i, s, o) {
    const r = this._renderTargetSystem, a = this._renderer.gl;
    this.finishRenderPass(e);
    const l = r.getRenderTarget(t), d = r.getGpuRenderTarget(e), c = r.getGpuRenderTarget(l);
    a.bindFramebuffer(a.READ_FRAMEBUFFER, d.framebuffer), a.bindFramebuffer(a.DRAW_FRAMEBUFFER, c.framebuffer), this._boundFramebuffer = void 0, a.blitFramebuffer(
      i.x,
      i.y,
      i.x + s.width,
      i.y + s.height,
      o.x,
      o.y,
      o.x + s.width,
      o.y + s.height,
      a.DEPTH_BUFFER_BIT,
      a.NEAREST
    );
  }
  startRenderPass(e, t = !0, i, s, o = 0, r = 0) {
    const l = this._renderTargetSystem.getGpuRenderTarget(e);
    if (r !== 0 && this._renderer.context.webGLVersion < 2)
      throw new Error("[RenderTargetSystem] Rendering to array layers requires WebGL2.");
    if (o > 0) {
      if (l.msaa)
        throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
      if (this._renderer.context.webGLVersion < 2)
        throw new Error("[RenderTargetSystem] Rendering to mip levels requires WebGL2.");
    }
    e.colorAttachments.forEach((f) => {
      this._renderer.texture.unbind(f.texture);
    });
    const d = this._renderer.gl;
    this.bindFramebuffer(l.framebuffer), !e.isRoot && e.colorAttachments.length > 0 && (l._attachedMipLevel !== o || l._attachedLayer !== r) && (e.colorAttachments.forEach((f, p) => {
      const y = f.texture, v = this._renderer.texture.getGlSource(y);
      if (v.target === d.TEXTURE_2D) {
        if (r !== 0)
          throw new Error("[RenderTargetSystem] layer must be 0 when rendering to 2D textures in WebGL.");
        d.framebufferTexture2D(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + p,
          d.TEXTURE_2D,
          v.texture,
          o
        );
      } else if (v.target === d.TEXTURE_2D_ARRAY || v.target === d.TEXTURE_3D)
        d.framebufferTextureLayer(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + p,
          v.texture,
          o,
          r
        );
      else if (v.target === d.TEXTURE_CUBE_MAP) {
        if (r < 0 || r > 5)
          throw new Error("[RenderTargetSystem] Cube map layer must be between 0 and 5.");
        d.framebufferTexture2D(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + p,
          d.TEXTURE_CUBE_MAP_POSITIVE_X + r,
          v.texture,
          o
        );
      } else
        throw new Error("[RenderTargetSystem] Unsupported texture target for render-to-layer in WebGL.");
    }), l._attachedMipLevel = o, l._attachedLayer = r), l.framebuffer && (e.depthStencilAttachment ? this._attachDepthStencilTexture(e, o, r) : !l.depthStencilRenderBuffer && (e.stencil || e.depth) && this._initStencil(l)), e.colorAttachments.length > 1 && this._setDrawBuffers(e, d);
    let c = s.y;
    e.isRoot && (c = e.pixelHeight - s.height - s.y);
    const h = this._viewPortCache;
    (h.x !== s.x || h.y !== c || h.width !== s.width || h.height !== s.height) && (h.x = s.x, h.y = c, h.width = s.width, h.height = s.height, d.viewport(
      s.x,
      c,
      s.width,
      s.height
    )), this.clear(e, t, i);
  }
  finishRenderPass(e) {
    const i = this._renderTargetSystem.getGpuRenderTarget(e);
    if (!i.msaa || e.colorAttachments.length === 0) return;
    const s = this._renderer.gl;
    s.bindFramebuffer(s.FRAMEBUFFER, i.resolveTargetFramebuffer), s.bindFramebuffer(s.READ_FRAMEBUFFER, i.framebuffer), s.blitFramebuffer(
      0,
      0,
      i.width,
      i.height,
      0,
      0,
      i.width,
      i.height,
      s.COLOR_BUFFER_BIT,
      s.NEAREST
    ), s.bindFramebuffer(s.FRAMEBUFFER, i.framebuffer), this._boundFramebuffer = i.framebuffer;
  }
  initGpuRenderTarget(e) {
    const i = this._renderer.gl, s = new EQ();
    s._attachedMipLevel = 0, s._attachedLayer = 0;
    const o = e.colorTexture;
    return o instanceof Ai ? (this._renderer.context.ensureCanvasSize(o.resource), s.framebuffer = null, s) : (s.width = e.pixelWidth, s.height = e.pixelHeight, e.colorAttachments.length === 0 ? this._initDepth(e, s) : this._initColor(e, s), e.depthStencilAttachment && this._attachDepthStencilTexture(e, 0, 0), i.bindFramebuffer(i.FRAMEBUFFER, null), this._boundFramebuffer = null, s);
  }
  destroyGpuRenderTarget(e) {
    const t = this._renderer.gl;
    e.framebuffer && (t.deleteFramebuffer(e.framebuffer), e.framebuffer = null), e.resolveTargetFramebuffer && (t.deleteFramebuffer(e.resolveTargetFramebuffer), e.resolveTargetFramebuffer = null), e.depthStencilRenderBuffer && (t.deleteRenderbuffer(e.depthStencilRenderBuffer), e.depthStencilRenderBuffer = null), e.msaaRenderBuffer.forEach((i) => {
      t.deleteRenderbuffer(i);
    }), e.msaaRenderBuffer.length = 0;
  }
  clear(e, t, i, s, o = 0, r = 0) {
    if (!t) return;
    if (r !== 0)
      throw new Error("[RenderTargetSystem] Clearing array layers is not supported in WebGL renderer.");
    const a = this._renderTargetSystem;
    if (typeof t == "boolean" && (t = t ? Tn.ALL : Tn.NONE), e.colorAttachments.length === 0 && (t &= ~Tn.COLOR, !t))
      return;
    const l = this._renderer.gl, d = !!(t & Tn.DEPTH) && !this._renderer.state.depthMaskEnabled;
    if (t & Tn.COLOR) {
      i != null || (i = a.defaultClearColor);
      const c = this._clearColorCache, h = i;
      (c[0] !== h[0] || c[1] !== h[1] || c[2] !== h[2] || c[3] !== h[3]) && (c[0] = h[0], c[1] = h[1], c[2] = h[2], c[3] = h[3], l.clearColor(h[0], h[1], h[2], h[3]));
    }
    d && l.depthMask(!0), l.clear(t), d && l.depthMask(!1);
  }
  resizeGpuRenderTarget(e) {
    if (e.isRoot) return;
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    t.width = e.pixelWidth, t.height = e.pixelHeight, e.colorAttachments.length > 0 && this._resizeColor(e, t), t.depthStencilRenderBuffer && this._resizeStencil(t), this._boundFramebuffer = void 0;
  }
  _initColor(e, t) {
    const i = this._renderer, s = i.gl, o = s.createFramebuffer();
    if (t.resolveTargetFramebuffer = o, s.bindFramebuffer(s.FRAMEBUFFER, o), e.colorAttachments.forEach((a, l) => {
      const d = a.texture;
      d.antialias && (i.context.supports.msaa ? t.msaa = !0 : dt("[RenderTexture] Antialiasing on textures is not supported in WebGL1")), i.texture.bindSource(d, 0);
      const c = i.texture.getGlSource(d), h = c.texture;
      if (c.target === s.TEXTURE_2D)
        s.framebufferTexture2D(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          s.TEXTURE_2D,
          h,
          0
        );
      else if (c.target === s.TEXTURE_2D_ARRAY || c.target === s.TEXTURE_3D)
        s.framebufferTextureLayer(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          h,
          0,
          0
        );
      else if (c.target === s.TEXTURE_CUBE_MAP)
        s.framebufferTexture2D(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          s.TEXTURE_CUBE_MAP_POSITIVE_X,
          h,
          0
        );
      else
        throw new Error("[RenderTargetSystem] Unsupported texture target for framebuffer attachment.");
    }), t.msaa) {
      const a = s.createFramebuffer();
      t.framebuffer = a, s.bindFramebuffer(s.FRAMEBUFFER, a), e.colorAttachments.forEach((l, d) => {
        const c = s.createRenderbuffer();
        t.msaaRenderBuffer[d] = c;
      });
    } else
      t.framebuffer = o;
    this._resizeColor(e, t);
  }
  _initDepth(e, t) {
    const i = this._renderer;
    if (i.context.webGLVersion < 2)
      throw new Error("[RenderTargetSystem] Depth-only render targets require WebGL2.");
    const s = i.gl, o = s.createFramebuffer();
    t.resolveTargetFramebuffer = o, t.framebuffer = o, s.bindFramebuffer(s.FRAMEBUFFER, o), s.drawBuffers([s.NONE]), s.readBuffer(s.NONE);
  }
  _resizeColor(e, t) {
    const i = e.colorAttachments[0].texture;
    if (t._attachedMipLevel = 0, t._attachedLayer = 0, e.colorAttachments.forEach((s, o) => {
      o !== 0 && s.texture.resize(i.width, i.height, i._resolution);
    }), t.msaa) {
      const s = this._renderer, o = s.gl, r = t.framebuffer;
      o.bindFramebuffer(o.FRAMEBUFFER, r), e.colorAttachments.forEach((a, l) => {
        const d = a.texture;
        s.texture.bindSource(d, 0);
        const h = s.texture.getGlSource(d).internalFormat, f = t.msaaRenderBuffer[l];
        o.bindRenderbuffer(
          o.RENDERBUFFER,
          f
        ), o.renderbufferStorageMultisample(
          o.RENDERBUFFER,
          4,
          h,
          d.pixelWidth,
          d.pixelHeight
        ), o.framebufferRenderbuffer(
          o.FRAMEBUFFER,
          o.COLOR_ATTACHMENT0 + l,
          o.RENDERBUFFER,
          f
        );
      });
    }
  }
  _attachDepthStencilTexture(e, t, i) {
    const s = this._renderer, o = s.gl, r = e.depthStencilAttachment.texture, a = s.texture.getGlSource(r), l = a.texture, d = r.format;
    let c;
    d === "depth24plus-stencil8" || d === "depth32float-stencil8" ? c = o.DEPTH_STENCIL_ATTACHMENT : d === "stencil8" ? c = o.STENCIL_ATTACHMENT : c = o.DEPTH_ATTACHMENT, a.target === o.TEXTURE_2D ? o.framebufferTexture2D(
      o.FRAMEBUFFER,
      c,
      o.TEXTURE_2D,
      l,
      t
    ) : a.target === o.TEXTURE_2D_ARRAY || a.target === o.TEXTURE_3D ? o.framebufferTextureLayer(
      o.FRAMEBUFFER,
      c,
      l,
      t,
      i
    ) : a.target === o.TEXTURE_CUBE_MAP && o.framebufferTexture2D(
      o.FRAMEBUFFER,
      c,
      o.TEXTURE_CUBE_MAP_POSITIVE_X + i,
      l,
      t
    );
  }
  _initStencil(e) {
    if (e.framebuffer === null) return;
    const t = this._renderer.gl, i = t.createRenderbuffer();
    e.depthStencilRenderBuffer = i, t.bindRenderbuffer(
      t.RENDERBUFFER,
      i
    ), t.framebufferRenderbuffer(
      t.FRAMEBUFFER,
      t.DEPTH_STENCIL_ATTACHMENT,
      t.RENDERBUFFER,
      i
    ), this._resizeStencil(e);
  }
  _resizeStencil(e) {
    const t = this._renderer.gl;
    t.bindRenderbuffer(
      t.RENDERBUFFER,
      e.depthStencilRenderBuffer
    ), e.msaa ? t.renderbufferStorageMultisample(
      t.RENDERBUFFER,
      4,
      t.DEPTH24_STENCIL8,
      e.width,
      e.height
    ) : t.renderbufferStorage(
      t.RENDERBUFFER,
      this._renderer.context.webGLVersion === 2 ? t.DEPTH24_STENCIL8 : t.DEPTH_STENCIL,
      e.width,
      e.height
    );
  }
  prerender(e) {
    if (e.colorAttachments.length === 0) return;
    const t = e.colorAttachments[0].texture.resource;
    this._renderer.context.multiView && Ai.test(t) && this._renderer.context.ensureCanvasSize(t);
  }
  postrender(e) {
    if (!this._renderer.context.multiView || e.colorAttachments.length === 0) return;
    const t = e.colorAttachments[0].texture;
    if (Ai.test(t.resource)) {
      const i = this._renderer.context.canvas, s = t;
      s.context2D.drawImage(
        i,
        0,
        s.pixelHeight - i.height
      );
    }
  }
  _setDrawBuffers(e, t) {
    const i = e.colorAttachments.length, s = this._drawBuffersCache[i];
    if (this._renderer.context.webGLVersion === 1) {
      const o = this._renderer.context.extensions.drawBuffers;
      o ? o.drawBuffersWEBGL(s) : dt("[RenderTexture] This WebGL1 context does not support rendering to multiple targets");
    } else
      t.drawBuffers(s);
  }
  /**
   * Forget the GL-call caches (framebuffer binding, viewport, clear color) so the next pass
   * re-applies them. Called via the renderer's `resetState` runner when external GL code may
   * have changed state behind our back.
   */
  resetState() {
    this._boundFramebuffer = void 0, this._viewPortCache = new Tt(), this._clearColorCache = [0, 0, 0, 0];
  }
  /**
   * Binds a framebuffer to `gl.FRAMEBUFFER`, skipping the call when it is already bound.
   * The single blessed way to bind a framebuffer — keeps {@link _boundFramebuffer} coherent.
   * @param framebuffer - the framebuffer to bind
   * @internal
   */
  bindFramebuffer(e) {
    this._boundFramebuffer !== e && (this._boundFramebuffer = e, this._renderer.gl.bindFramebuffer(this._renderer.gl.FRAMEBUFFER, e));
  }
}
class KT extends Ly {
  constructor(e) {
    super(e), this.adaptor = new OQ(), this.adaptor.init(e, this);
  }
  /** Called via the renderer's `resetState` runner when mixing Pixi with external GL code. */
  resetState() {
    this.adaptor.resetState();
  }
}
KT.extension = {
  type: [Ae.WebGLSystem],
  name: "renderTarget"
};
class Ny extends bi {
  /**
   * Create a new Buffer Resource.
   * @param options - The options for the buffer resource
   * @param options.buffer - The underlying buffer that this resource is using
   * @param options.offset - The offset of the buffer this resource is using.
   * If not provided, then it will use the offset of the buffer.
   * @param options.size - The size of the buffer this resource is using.
   * If not provided, then it will use the size of the buffer.
   */
  constructor({ buffer: e, offset: t, size: i }) {
    super(), this.uid = Nt("buffer"), this._resourceType = "bufferResource", this._resourceId = Nt("resource"), this._bufferResource = !0, this.destroyed = !1, this.buffer = e, this.offset = t | 0, this.size = i, this.buffer.on("change", this.onBufferChange, this);
  }
  /**
   * The GC tracks the underlying buffer, not this resource — a GC stamp here (see
   * BindGroup._touch) must land on the buffer, or the GC collects it while cached
   * bind groups still reference it.
   * @internal
   */
  get _gcLastUsed() {
    var e, t;
    return (t = (e = this.buffer) == null ? void 0 : e._gcLastUsed) != null ? t : -1;
  }
  set _gcLastUsed(e) {
    this.buffer && (this.buffer._gcLastUsed = e);
  }
  onBufferChange() {
    this._resourceId = Nt("resource"), this.emit("change", this);
  }
  /**
   * Destroys this resource. Make sure the underlying buffer is not used anywhere else
   * if you want to destroy it as well, or code will explode
   * @param destroyBuffer - Should the underlying buffer be destroyed as well?
   */
  destroy(e = !1) {
    this.destroyed = !0, e && this.buffer.destroy(), this.emit("change", this), this.buffer = null, this.removeAllListeners();
  }
}
class LQ extends bi {
  /**
   * @param source - The texture source to view.
   * @param viewDescriptor - The WebGPU texture view descriptor.
   */
  constructor(e, t) {
    super(), this._resourceType = "textureView", this._resourceId = Nt("resource"), this.source = e, this.viewDescriptor = t, this._onChange = this._onChange.bind(this), this._onDestroy = this._onDestroy.bind(this), this.source.on("change", this._onChange), this.source.on("destroy", this._onDestroy);
  }
  _onChange() {
    this.emit("change", this);
  }
  _onDestroy() {
    this.destroy();
  }
  /** Returns whether the underlying source is destroyed. */
  get destroyed() {
    return this.source.destroyed;
  }
  /** Destroys the view and cleans up event listeners. */
  destroy() {
    this.source && (this.source.off("change", this._onChange), this.source.off("destroy", this._onDestroy)), this.emit("destroy", this), this.removeAllListeners();
  }
}
function BQ(n, e) {
  const t = [], i = [`
        var g = s.groups;
        var sS = r.shader;
        var p = s.glProgram;
        var ugS = r.uniformGroup;
        var resources;
    `];
  let s = !1, o = 0;
  const r = e._getProgramData(n.glProgram);
  for (const l in n.groups) {
    const d = n.groups[l];
    t.push(`
            resources = g[${l}].resources;
        `);
    for (const c in d.resources) {
      const h = d.resources[c];
      if (h instanceof Ts)
        if (h.ubo) {
          const f = n._uniformBindMap[l][Number(c)];
          t.push(`
                        sS.bindUniformBlock(
                            resources[${c}],
                            '${f}',
                            ${n.glProgram._uniformBlockData[f].index}
                        );
                    `);
        } else
          t.push(`
                        ugS.updateUniformGroup(resources[${c}], p, sD);
                    `);
      else if (h instanceof Ny) {
        const f = n._uniformBindMap[l][Number(c)];
        t.push(`
                    sS.bindUniformBlock(
                        resources[${c}],
                        '${f}',
                        ${n.glProgram._uniformBlockData[f].index}
                    );
                `);
      } else if (h instanceof un || h instanceof LQ) {
        const f = n._uniformBindMap[l][c], p = r.uniformData[f];
        p && (s || (s = !0, i.push(`
                        var tS = r.texture;
                        `)), e._gl.uniform1i(p.location, o), t.push(`
                        tS.bind(resources[${c}], ${o});
                    `), o++);
      }
    }
  }
  const a = [...i, ...t].join(`
`);
  return new Function("r", "s", "sD", a);
}
class FQ {
  /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */
  constructor(e, t) {
    this.program = e, this.uniformData = t, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBlockBindings = {};
  }
  /** Destroys this program. */
  destroy() {
    this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBlockBindings = null, this.program = null;
  }
}
function j2(n, e, t) {
  const i = n.createShader(e);
  return n.shaderSource(i, t), n.compileShader(i), i;
}
function Xg(n) {
  const e = new Array(n);
  for (let t = 0; t < e.length; t++)
    e[t] = !1;
  return e;
}
function YT(n, e) {
  switch (n) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * e);
    case "vec3":
      return new Float32Array(3 * e);
    case "vec4":
      return new Float32Array(4 * e);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
    case "sampler3D":
      return 0;
    case "ivec2":
      return new Int32Array(2 * e);
    case "ivec3":
      return new Int32Array(3 * e);
    case "ivec4":
      return new Int32Array(4 * e);
    case "uvec2":
      return new Uint32Array(2 * e);
    case "uvec3":
      return new Uint32Array(3 * e);
    case "uvec4":
      return new Uint32Array(4 * e);
    case "bool":
      return !1;
    case "bvec2":
      return Xg(2 * e);
    case "bvec3":
      return Xg(3 * e);
    case "bvec4":
      return Xg(4 * e);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
let bh = null;
const H2 = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_2D_SHADOW: "sampler2DShadow",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_CUBE_SHADOW: "samplerCubeShadow",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  SAMPLER_2D_ARRAY_SHADOW: "sampler2DArrayShadow",
  SAMPLER_3D: "sampler3D",
  INT_SAMPLER_3D: "sampler3D",
  UNSIGNED_INT_SAMPLER_3D: "sampler3D"
}, NQ = {
  float: "float32",
  vec2: "float32x2",
  vec3: "float32x3",
  vec4: "float32x4",
  int: "sint32",
  ivec2: "sint32x2",
  ivec3: "sint32x3",
  ivec4: "sint32x4",
  uint: "uint32",
  uvec2: "uint32x2",
  uvec3: "uint32x3",
  uvec4: "uint32x4",
  bool: "uint32",
  bvec2: "uint32x2",
  bvec3: "uint32x3",
  bvec4: "uint32x4"
};
function XT(n, e) {
  if (!bh) {
    const t = Object.keys(H2);
    bh = {};
    for (let i = 0; i < t.length; ++i) {
      const s = t[i];
      bh[n[s]] = H2[s];
    }
  }
  return bh[e];
}
function UQ(n, e) {
  const t = XT(n, e);
  return NQ[t] || "float32";
}
function GQ(n, e, t = !1) {
  const i = {}, s = e.getProgramParameter(n, e.ACTIVE_ATTRIBUTES);
  for (let r = 0; r < s; r++) {
    const a = e.getActiveAttrib(n, r);
    if (a.name.startsWith("gl_"))
      continue;
    const l = UQ(e, a.type);
    i[a.name] = {
      location: 0,
      // set further down..
      format: l,
      stride: Hc(l).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  const o = Object.keys(i);
  if (t) {
    o.sort((r, a) => r > a ? 1 : -1);
    for (let r = 0; r < o.length; r++)
      i[o[r]].location = r, e.bindAttribLocation(n, r, o[r]);
    e.linkProgram(n);
  } else
    for (let r = 0; r < o.length; r++)
      i[o[r]].location = e.getAttribLocation(n, o[r]);
  return i;
}
function jQ(n, e) {
  if (!e.ACTIVE_UNIFORM_BLOCKS) return {};
  const t = {}, i = e.getProgramParameter(n, e.ACTIVE_UNIFORM_BLOCKS);
  for (let s = 0; s < i; s++) {
    const o = e.getActiveUniformBlockName(n, s), r = e.getUniformBlockIndex(n, o), a = e.getActiveUniformBlockParameter(n, s, e.UNIFORM_BLOCK_DATA_SIZE);
    t[o] = {
      name: o,
      index: r,
      size: a
    };
  }
  return t;
}
function HQ(n, e) {
  const t = {}, i = e.getProgramParameter(n, e.ACTIVE_UNIFORMS);
  for (let s = 0; s < i; s++) {
    const o = e.getActiveUniform(n, s), r = o.name.replace(/\[.*?\]$/, ""), a = !!o.name.match(/\[.*?\]$/), l = XT(e, o.type);
    t[r] = {
      name: r,
      index: s,
      type: l,
      size: o.size,
      isArray: a,
      value: YT(l, o.size)
    };
  }
  return t;
}
function V2(n, e) {
  var c;
  const t = n.getShaderSource(e);
  if (t === null) {
    console.error("PixiJS Error: Could not retrieve shader source (WebGL context may be lost).");
    return;
  }
  const i = t.split(`
`).map((h, f) => `${f}: ${h}`), s = (c = n.getShaderInfoLog(e)) != null ? c : "", o = s.split(`
`), r = {}, a = o.map((h) => parseFloat(h.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((h) => h && !r[h] ? (r[h] = !0, !0) : !1), l = [""];
  a.forEach((h) => {
    i[h - 1] = `%c${i[h - 1]}%c`, l.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  const d = i.join(`
`);
  l[0] = d, console.error(s), console.groupCollapsed("click to view full shader code"), console.warn(...l), console.groupEnd();
}
function VQ(n, e, t, i) {
  n.getProgramParameter(e, n.LINK_STATUS) || (n.getShaderParameter(t, n.COMPILE_STATUS) || V2(n, t), n.getShaderParameter(i, n.COMPILE_STATUS) || V2(n, i), console.error("PixiJS Error: Could not initialize shader."), n.getProgramInfoLog(e) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", n.getProgramInfoLog(e)));
}
function WQ(n, e) {
  const t = j2(n, n.VERTEX_SHADER, e.vertex), i = j2(n, n.FRAGMENT_SHADER, e.fragment), s = n.createProgram();
  n.attachShader(s, t), n.attachShader(s, i);
  const o = e.transformFeedbackVaryings;
  o && (typeof n.transformFeedbackVaryings != "function" ? dt("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : n.transformFeedbackVaryings(
    s,
    o.names,
    o.bufferMode === "separate" ? n.SEPARATE_ATTRIBS : n.INTERLEAVED_ATTRIBS
  )), n.linkProgram(s), n.getProgramParameter(s, n.LINK_STATUS) || VQ(n, s, t, i), e._attributeData = GQ(
    s,
    n,
    !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(e.vertex)
  ), e._uniformData = HQ(s, n), e._uniformBlockData = jQ(s, n), n.deleteShader(t), n.deleteShader(i);
  const r = {};
  for (const l in e._uniformData) {
    const d = e._uniformData[l];
    r[l] = {
      location: n.getUniformLocation(s, l),
      value: YT(d.type, d.size)
    };
  }
  return new FQ(s, r);
}
const vh = {
  textureCount: 0,
  blockIndex: 0
};
class JT {
  constructor(e) {
    this._activeProgram = null, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._renderer = e;
  }
  contextChange(e) {
    this._gl = e, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._activeProgram = null;
  }
  /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param skipSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */
  bind(e, t) {
    if (this._setProgram(e.glProgram), t) return;
    vh.textureCount = 0, vh.blockIndex = 0;
    let i = this._shaderSyncFunctions[e.glProgram._key];
    i || (i = this._shaderSyncFunctions[e.glProgram._key] = this._generateShaderSync(e, this)), this._renderer.buffer.nextBindBase(!!e.glProgram.transformFeedbackVaryings), i(this._renderer, e, vh);
  }
  /**
   * Updates the uniform group.
   * @param uniformGroup - the uniform group to update
   */
  updateUniformGroup(e) {
    this._renderer.uniformGroup.updateUniformGroup(e, this._activeProgram, vh);
  }
  /**
   * Binds a uniform block to the shader.
   * @param uniformGroup - the uniform group to bind
   * @param name - the name of the uniform block
   * @param index - the index of the uniform block
   */
  bindUniformBlock(e, t, i = 0) {
    const s = this._renderer.buffer, o = this._getProgramData(this._activeProgram), r = e._bufferResource;
    r || this._renderer.ubo.updateUniformGroup(e);
    const a = e.buffer, l = s.updateBuffer(a), d = s.freeLocationForBufferBase(l);
    if (r) {
      const { offset: h, size: f } = e;
      h === 0 && f === a.data.byteLength ? s.bindBufferBase(l, d) : s.bindBufferRange(l, d, h);
    } else s.getLastBindBaseLocation(l) !== d && s.bindBufferBase(l, d);
    const c = this._activeProgram._uniformBlockData[t].index;
    o.uniformBlockBindings[i] !== d && (o.uniformBlockBindings[i] = d, this._renderer.gl.uniformBlockBinding(o.program, c, d));
  }
  _setProgram(e) {
    if (this._activeProgram === e) return;
    this._activeProgram = e;
    const t = this._getProgramData(e);
    this._gl.useProgram(t.program);
  }
  /**
   * @param program - the program to get the data for
   * @internal
   */
  _getProgramData(e) {
    return this._programDataHash[e._key] || this._createProgramData(e);
  }
  _createProgramData(e) {
    const t = e._key;
    return this._programDataHash[t] = WQ(this._gl, e), this._programDataHash[t];
  }
  destroy() {
    for (const e of Object.keys(this._programDataHash))
      this._programDataHash[e].destroy();
    this._programDataHash = null, this._shaderSyncFunctions = null, this._activeProgram = null, this._renderer = null, this._gl = null;
  }
  /**
   * Creates a function that can be executed that will sync the shader as efficiently as possible.
   * Overridden by the unsafe eval package if you don't want eval used in your project.
   * @param shader - the shader to generate the sync function for
   * @param shaderSystem - the shader system to use
   * @returns - the generated sync function
   * @ignore
   */
  _generateShaderSync(e, t) {
    return BQ(e, t);
  }
  resetState() {
    this._activeProgram = null;
  }
}
JT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "shader"
};
const qQ = {
  f32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1f(location, v);
        }`,
  "vec2<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2f(location, v[0], v[1]);
        }`,
  "vec3<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3f(location, v[0], v[1], v[2]);
        }`,
  "vec4<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4f(location, v[0], v[1], v[2], v[3]);
        }`,
  i32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  u32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1ui(location, v);
        }`,
  "vec2<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2ui(location, v[0], v[1]);
        }`,
  "vec3<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3ui(location, v[0], v[1], v[2]);
        }`,
  "vec4<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
        }`,
  bool: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);"
}, KQ = {
  f32: "gl.uniform1fv(location, v);",
  "vec2<f32>": "gl.uniform2fv(location, v);",
  "vec3<f32>": "gl.uniform3fv(location, v);",
  "vec4<f32>": "gl.uniform4fv(location, v);",
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);",
  i32: "gl.uniform1iv(location, v);",
  "vec2<i32>": "gl.uniform2iv(location, v);",
  "vec3<i32>": "gl.uniform3iv(location, v);",
  "vec4<i32>": "gl.uniform4iv(location, v);",
  u32: "gl.uniform1iv(location, v);",
  "vec2<u32>": "gl.uniform2iv(location, v);",
  "vec3<u32>": "gl.uniform3iv(location, v);",
  "vec4<u32>": "gl.uniform4iv(location, v);",
  bool: "gl.uniform1iv(location, v);",
  "vec2<bool>": "gl.uniform2iv(location, v);",
  "vec3<bool>": "gl.uniform3iv(location, v);",
  "vec4<bool>": "gl.uniform4iv(location, v);"
};
function YQ(n, e) {
  const t = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
        var name = null;
    `];
  for (const i in n.uniforms) {
    if (!e[i]) {
      n.uniforms[i] instanceof Ts ? n.uniforms[i].ubo ? t.push(`
                        renderer.shader.bindUniformBlock(uv.${i}, "${i}");
                    `) : t.push(`
                        renderer.shader.updateUniformGroup(uv.${i});
                    `) : n.uniforms[i] instanceof Ny && t.push(`
                        renderer.shader.bindBufferResource(uv.${i}, "${i}");
                    `);
      continue;
    }
    const s = n.uniformStructures[i];
    let o = !1;
    for (let r = 0; r < gl.length; r++) {
      const a = gl[r];
      if (s.type === a.type && a.test(s)) {
        t.push(`name = "${i}";`, gl[r].uniform), o = !0;
        break;
      }
    }
    if (!o) {
      const a = (s.size === 1 ? qQ : KQ)[s.type].replace("location", `ud["${i}"].location`);
      t.push(`
            cu = ud["${i}"];
            cv = cu.value;
            v = uv["${i}"];
            ${a};`);
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", t.join(`
`));
}
class ZT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._cache = {}, this._uniformGroupSyncHash = {}, this._renderer = e, this.gl = null, this._cache = {};
  }
  contextChange(e) {
    this.gl = e;
  }
  /**
   * Uploads the uniforms values to the currently bound shader.
   * @param group - the uniforms values that be applied to the current shader
   * @param program
   * @param syncData
   * @param syncData.textureCount
   */
  updateUniformGroup(e, t, i) {
    const s = this._renderer.shader._getProgramData(t);
    (!e.isStatic || e._dirtyId !== s.uniformDirtyGroups[e.uid]) && (s.uniformDirtyGroups[e.uid] = e._dirtyId, this._getUniformSyncFunction(e, t)(s.uniformData, e.uniforms, this._renderer, i));
  }
  /**
   * Overridable by the pixi.js/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param program
   */
  _getUniformSyncFunction(e, t) {
    var i;
    return ((i = this._uniformGroupSyncHash[e._signature]) == null ? void 0 : i[t._key]) || this._createUniformSyncFunction(e, t);
  }
  _createUniformSyncFunction(e, t) {
    const i = this._uniformGroupSyncHash[e._signature] || (this._uniformGroupSyncHash[e._signature] = {}), s = this._getSignature(e, t._uniformData, "u");
    return this._cache[s] || (this._cache[s] = this._generateUniformsSync(e, t._uniformData)), i[t._key] = this._cache[s], i[t._key];
  }
  _generateUniformsSync(e, t) {
    return YQ(e, t);
  }
  /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */
  _getSignature(e, t, i) {
    const s = e.uniforms, o = [`${i}-`];
    for (const r in s)
      o.push(r), t[r] && o.push(t[r].type);
    return o.join("-");
  }
  /** Destroys this System and removes all its textures. */
  destroy() {
    this._renderer = null, this._cache = null;
  }
}
ZT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "uniformGroup"
};
function XQ(n) {
  const e = {};
  if (e.normal = [n.ONE, n.ONE_MINUS_SRC_ALPHA], e.add = [n.ONE, n.ONE], e.multiply = [n.DST_COLOR, n.ONE_MINUS_SRC_ALPHA, n.ONE, n.ONE_MINUS_SRC_ALPHA], e.screen = [n.ONE, n.ONE_MINUS_SRC_COLOR, n.ONE, n.ONE_MINUS_SRC_ALPHA], e.none = [0, 0], e["normal-npm"] = [n.SRC_ALPHA, n.ONE_MINUS_SRC_ALPHA, n.ONE, n.ONE_MINUS_SRC_ALPHA], e["add-npm"] = [n.SRC_ALPHA, n.ONE, n.ONE, n.ONE], e["screen-npm"] = [n.SRC_ALPHA, n.ONE_MINUS_SRC_COLOR, n.ONE, n.ONE_MINUS_SRC_ALPHA], e.erase = [n.ZERO, n.ONE_MINUS_SRC_ALPHA], !(n instanceof zt.get().getWebGLRenderingContext()))
    e.min = [n.ONE, n.ONE, n.ONE, n.ONE, n.MIN, n.MIN], e.max = [n.ONE, n.ONE, n.ONE, n.ONE, n.MAX, n.MAX];
  else {
    const i = n.getExtension("EXT_blend_minmax");
    i && (e.min = [n.ONE, n.ONE, n.ONE, n.ONE, i.MIN_EXT, i.MIN_EXT], e.max = [n.ONE, n.ONE, n.ONE, n.ONE, i.MAX_EXT, i.MAX_EXT]);
  }
  return e;
}
const { BLEND: JQ, OFFSET: ZQ, CULLING: QQ, DEPTH_TEST: eee, WINDING: tee, DEPTH_MASK: W2 } = ZS, QT = class b0 {
  constructor(e) {
    this._invertFrontFace = !1, this._renderer = e, this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = "none", this._blendEq = !1, this.map = [], this.map[JQ] = this.setBlend, this.map[ZQ] = this.setOffset, this.map[QQ] = this.setCullFace, this.map[eee] = this.setDepthTest, this.map[tee] = this.setFrontFace, this.map[W2] = this.setDepthMask, this.checks = [], this.defaultState = co.for2d(), e.renderTarget.onRenderTargetChange.add(this);
  }
  onRenderTargetChange(e) {
    this._invertFrontFace = this._renderer.renderTarget.isFrontFaceInverted(e, e.flipY), this._cullFace ? this.setFrontFace(this._frontFace) : this._frontFaceDirty = !0;
  }
  contextChange(e) {
    this.gl = e, this.blendModesMap = XQ(e), this.resetState();
  }
  /**
   * Sets the current state
   * @param {*} state - The state to set.
   */
  set(e) {
    if (e || (e = this.defaultState), this.stateId !== e.data) {
      let t = this.stateId ^ e.data, i = 0;
      for (; t; )
        t & 1 && this.map[i].call(this, !!(e.data & 1 << i)), t >>= 1, i++;
      this.stateId = e.data;
    }
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
  }
  /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */
  forceState(e) {
    e || (e = this.defaultState);
    for (let t = 0; t < this.map.length; t++)
      this.map[t].call(this, !!(e.data & 1 << t));
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
    this.stateId = e.data;
  }
  /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */
  setBlend(e) {
    this._updateCheck(b0._checkBlendMode, e), this.gl[e ? "enable" : "disable"](this.gl.BLEND);
  }
  /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */
  setOffset(e) {
    this._updateCheck(b0._checkPolygonOffset, e), this.gl[e ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
  }
  /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */
  setDepthTest(e) {
    this.gl[e ? "enable" : "disable"](this.gl.DEPTH_TEST);
  }
  /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */
  setDepthMask(e) {
    this.gl.depthMask(e);
  }
  /**
   * Whether depth writes are currently enabled on the GL context, as last applied by this
   * system. `gl.clear` is masked by this state, so depth clears must consult it.
   * @internal
   */
  get depthMaskEnabled() {
    return !!(this.stateId & 1 << W2);
  }
  /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */
  setCullFace(e) {
    this._cullFace = e, this.gl[e ? "enable" : "disable"](this.gl.CULL_FACE), this._cullFace && this._frontFaceDirty && this.setFrontFace(this._frontFace);
  }
  /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */
  setFrontFace(e) {
    this._frontFace = e, this._frontFaceDirty = !1;
    const t = this._invertFrontFace ? !e : e;
    this._glFrontFace !== t && (this._glFrontFace = t, this.gl.frontFace(this.gl[t ? "CW" : "CCW"]));
  }
  /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */
  setBlendMode(e) {
    if (this.blendModesMap[e] || (e = "normal"), e === this.blendMode)
      return;
    this.blendMode = e;
    const t = this.blendModesMap[e], i = this.gl;
    t.length === 2 ? i.blendFunc(t[0], t[1]) : i.blendFuncSeparate(t[0], t[1], t[2], t[3]), t.length === 6 ? (this._blendEq = !0, i.blendEquationSeparate(t[4], t[5])) : this._blendEq && (this._blendEq = !1, i.blendEquationSeparate(i.FUNC_ADD, i.FUNC_ADD));
  }
  /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */
  setPolygonOffset(e, t) {
    this.gl.polygonOffset(e, t);
  }
  /** Resets all the logic and disables the VAOs. */
  resetState() {
    this._glFrontFace = !1, this._frontFace = !1, this._cullFace = !1, this._frontFaceDirty = !1, this._invertFrontFace = !1, this.gl.frontFace(this.gl.CCW), this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = "", this.setBlendMode("normal");
  }
  /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */
  _updateCheck(e, t) {
    const i = this.checks.indexOf(e);
    t && i === -1 ? this.checks.push(e) : !t && i !== -1 && this.checks.splice(i, 1);
  }
  /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkBlendMode(e, t) {
    e.setBlendMode(t.blendMode);
  }
  /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkPolygonOffset(e, t) {
    e.setPolygonOffset(1, t.polygonOffset);
  }
  /** @ignore */
  destroy() {
    this.gl = null, this.checks.length = 0, this._renderer = null;
  }
};
QT.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "state"
};
let nee = QT;
class iee {
  constructor(e) {
    this.target = Jc.TEXTURE_2D, this._layerInitMask = 0, this.texture = e, this.width = -1, this.height = -1, this.type = At.UNSIGNED_BYTE, this.internalFormat = g0.RGBA, this.format = g0.RGBA, this.samplerType = 0;
  }
  destroy() {
  }
}
function eC(n, e, t, i, s) {
  if (n = Math.max(0, n), e = Math.min(e, t * i), n >= e) return 0;
  const o = Math.floor(n / t), r = n - o * t, a = Math.floor(e / t), l = e - a * t;
  if (o === a)
    return s[0].set(r, o, l - r, 1), 1;
  let d = 0, c = o;
  return r > 0 && (s[d++].set(r, o, t - r, 1), c++), a > c && s[d++].set(0, c, t, a - c), l > 0 && s[d++].set(0, a, l, 1), d;
}
const q2 = [new Tt(), new Tt(), new Tt()], see = {
  id: "buffer",
  upload(n, e, t, i, s, o = !1) {
    const r = s || e.target, a = n.resource;
    if (r === Jc.TEXTURE_3D || r === Jc.TEXTURE_2D_ARRAY) {
      o || e.width !== n.width || e.height !== n.height ? t.texImage3D(
        r,
        0,
        e.internalFormat,
        n.width,
        n.height,
        n.depthOrArrayLayers,
        0,
        e.format,
        e.type,
        a
      ) : t.texSubImage3D(
        r,
        0,
        0,
        0,
        0,
        n.width,
        n.height,
        n.depthOrArrayLayers,
        e.format,
        e.type,
        a
      ), e.width = n.width, e.height = n.height;
      return;
    }
    const l = n.width * n.height, d = o || e.width !== n.width || e.height !== n.height, c = n._updateStart > 0 || n._updateEnd < l;
    if (d)
      t.texImage2D(
        r,
        0,
        e.internalFormat,
        n.width,
        n.height,
        0,
        e.format,
        e.type,
        a
      );
    else if (c) {
      const h = a.length / l, f = eC(
        n._updateStart,
        n._updateEnd,
        n.width,
        n.height,
        q2
      );
      for (let p = 0; p < f; p++) {
        const y = q2[p], v = (y.y * n.width + y.x) * h;
        t.texSubImage2D(
          r,
          0,
          y.x,
          y.y,
          y.width,
          y.height,
          e.format,
          e.type,
          a.subarray(v, v + y.width * y.height * h)
        );
      }
    } else
      t.texSubImage2D(
        r,
        0,
        0,
        0,
        n.width,
        n.height,
        e.format,
        e.type,
        a
      );
    e.width = n.width, e.height = n.height;
  }
}, oee = {
  "bc1-rgba-unorm": !0,
  "bc1-rgba-unorm-srgb": !0,
  "bc2-rgba-unorm": !0,
  "bc2-rgba-unorm-srgb": !0,
  "bc3-rgba-unorm": !0,
  "bc3-rgba-unorm-srgb": !0,
  "bc4-r-unorm": !0,
  "bc4-r-snorm": !0,
  "bc5-rg-unorm": !0,
  "bc5-rg-snorm": !0,
  "bc6h-rgb-ufloat": !0,
  "bc6h-rgb-float": !0,
  "bc7-rgba-unorm": !0,
  "bc7-rgba-unorm-srgb": !0,
  // ETC2 compressed formats usable if "texture-compression-etc2" is both
  // supported by the device/user agent and enabled in requestDevice.
  "etc2-rgb8unorm": !0,
  "etc2-rgb8unorm-srgb": !0,
  "etc2-rgb8a1unorm": !0,
  "etc2-rgb8a1unorm-srgb": !0,
  "etc2-rgba8unorm": !0,
  "etc2-rgba8unorm-srgb": !0,
  "eac-r11unorm": !0,
  "eac-r11snorm": !0,
  "eac-rg11unorm": !0,
  "eac-rg11snorm": !0,
  // ASTC compressed formats usable if "texture-compression-astc" is both
  // supported by the device/user agent and enabled in requestDevice.
  "astc-4x4-unorm": !0,
  "astc-4x4-unorm-srgb": !0,
  "astc-5x4-unorm": !0,
  "astc-5x4-unorm-srgb": !0,
  "astc-5x5-unorm": !0,
  "astc-5x5-unorm-srgb": !0,
  "astc-6x5-unorm": !0,
  "astc-6x5-unorm-srgb": !0,
  "astc-6x6-unorm": !0,
  "astc-6x6-unorm-srgb": !0,
  "astc-8x5-unorm": !0,
  "astc-8x5-unorm-srgb": !0,
  "astc-8x6-unorm": !0,
  "astc-8x6-unorm-srgb": !0,
  "astc-8x8-unorm": !0,
  "astc-8x8-unorm-srgb": !0,
  "astc-10x5-unorm": !0,
  "astc-10x5-unorm-srgb": !0,
  "astc-10x6-unorm": !0,
  "astc-10x6-unorm-srgb": !0,
  "astc-10x8-unorm": !0,
  "astc-10x8-unorm-srgb": !0,
  "astc-10x10-unorm": !0,
  "astc-10x10-unorm-srgb": !0,
  "astc-12x10-unorm": !0,
  "astc-12x10-unorm-srgb": !0,
  "astc-12x12-unorm": !0,
  "astc-12x12-unorm-srgb": !0
}, ree = {
  id: "compressed",
  upload(n, e, t, i, s, o) {
    const r = s != null ? s : e.target;
    t.pixelStorei(t.UNPACK_ALIGNMENT, 4);
    let a = n.pixelWidth, l = n.pixelHeight;
    const d = !!oee[n.format];
    for (let c = 0; c < n.resource.length; c++) {
      const h = n.resource[c];
      d ? t.compressedTexImage2D(
        r,
        c,
        e.internalFormat,
        a,
        l,
        0,
        h
      ) : t.texImage2D(
        r,
        c,
        e.internalFormat,
        a,
        l,
        0,
        e.format,
        e.type,
        h
      ), a = Math.max(a >> 1, 1), l = Math.max(l >> 1, 1);
    }
  }
}, K2 = ["right", "left", "top", "bottom", "front", "back"];
function aee(n) {
  return {
    id: "cube",
    upload(e, t, i, s) {
      const o = e.faces;
      for (let r = 0; r < K2.length; r++) {
        const a = K2[r], l = o[a];
        if (!l.resource) continue;
        (n[l.uploadMethodId] || n.image).upload(
          l,
          t,
          i,
          s,
          // Use the face target for the current face. cube faces ids go up 1 so
          // GL_TARGETS.TEXTURE_CUBE_MAP_POSITIVE_X + i addresses the i'th face target.
          Jc.TEXTURE_CUBE_MAP_POSITIVE_X + r,
          // Force allocation for the first upload of each face.
          (t._layerInitMask & 1 << r) === 0
        ), t._layerInitMask |= 1 << r;
      }
      t.width = e.pixelWidth, t.height = e.pixelHeight;
    }
  };
}
const tC = {
  id: "image",
  upload(n, e, t, i, s, o = !1) {
    const r = s || e.target, a = n.pixelWidth, l = n.pixelHeight, d = n.resourceWidth, c = n.resourceHeight, h = i === 2, f = o || e.width !== a || e.height !== l, p = d >= a && c >= l, y = n.resource;
    (h ? lee : dee)(
      t,
      r,
      e,
      a,
      l,
      d,
      c,
      y,
      f,
      p
    ), e.width = a, e.height = l;
  }
};
function lee(n, e, t, i, s, o, r, a, l, d) {
  if (!d) {
    l && n.texImage2D(
      e,
      0,
      t.internalFormat,
      i,
      s,
      0,
      t.format,
      t.type,
      null
    ), n.texSubImage2D(
      e,
      0,
      0,
      0,
      o,
      r,
      t.format,
      t.type,
      a
    );
    return;
  }
  if (!l) {
    n.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  n.texImage2D(
    e,
    0,
    t.internalFormat,
    i,
    s,
    0,
    t.format,
    t.type,
    a
  );
}
function dee(n, e, t, i, s, o, r, a, l, d) {
  if (!d) {
    l && n.texImage2D(
      e,
      0,
      t.internalFormat,
      i,
      s,
      0,
      t.format,
      t.type,
      null
    ), n.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  if (!l) {
    n.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  n.texImage2D(
    e,
    0,
    t.internalFormat,
    t.format,
    t.type,
    a
  );
}
const cee = RZ(), uee = {
  id: "video",
  upload(n, e, t, i, s, o = cee) {
    if (!n.isValid) {
      const r = s != null ? s : e.target;
      t.texImage2D(
        r,
        0,
        e.internalFormat,
        1,
        1,
        0,
        e.format,
        e.type,
        null
      );
      return;
    }
    tC.upload(n, e, t, i, s, o);
  }
}, Y2 = {
  linear: 9729,
  nearest: 9728
}, hee = {
  linear: {
    linear: 9987,
    nearest: 9985
  },
  nearest: {
    linear: 9986,
    nearest: 9984
  }
}, Jg = {
  "clamp-to-edge": 33071,
  repeat: 10497,
  "mirror-repeat": 33648
}, pee = {
  never: 512,
  less: 513,
  equal: 514,
  "less-equal": 515,
  greater: 516,
  "not-equal": 517,
  "greater-equal": 518,
  always: 519
};
function X2(n, e, t, i, s, o, r, a) {
  const l = o;
  if (!a || n.addressModeU !== "repeat" || n.addressModeV !== "repeat" || n.addressModeW !== "repeat") {
    const d = Jg[r ? "clamp-to-edge" : n.addressModeU], c = Jg[r ? "clamp-to-edge" : n.addressModeV], h = Jg[r ? "clamp-to-edge" : n.addressModeW];
    e[s](l, e.TEXTURE_WRAP_S, d), e[s](l, e.TEXTURE_WRAP_T, c), e.TEXTURE_WRAP_R && e[s](l, e.TEXTURE_WRAP_R, h);
  }
  if ((!a || n.magFilter !== "linear") && e[s](l, e.TEXTURE_MAG_FILTER, Y2[n.magFilter]), t) {
    if (!a || n.mipmapFilter !== "linear") {
      const d = hee[n.minFilter][n.mipmapFilter];
      e[s](l, e.TEXTURE_MIN_FILTER, d);
    }
  } else
    e[s](l, e.TEXTURE_MIN_FILTER, Y2[n.minFilter]);
  if (i && n.maxAnisotropy > 1) {
    const d = Math.min(n.maxAnisotropy, e.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
    e[s](l, i.TEXTURE_MAX_ANISOTROPY_EXT, d);
  }
  n.compare ? (e[s](l, e.TEXTURE_COMPARE_FUNC, pee[n.compare]), e[s](l, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE)) : a || e[s](l, e.TEXTURE_COMPARE_MODE, e.NONE);
}
function fee(n) {
  return {
    // 8-bit formats
    r8unorm: n.RED,
    r8snorm: n.RED,
    r8uint: n.RED_INTEGER,
    r8sint: n.RED_INTEGER,
    // 16-bit formats
    r16uint: n.RED_INTEGER,
    r16sint: n.RED_INTEGER,
    r16float: n.RED,
    rg8unorm: n.RG,
    rg8snorm: n.RG,
    rg8uint: n.RG_INTEGER,
    rg8sint: n.RG_INTEGER,
    // 32-bit formats
    r32uint: n.RED_INTEGER,
    r32sint: n.RED_INTEGER,
    r32float: n.RED,
    rg16uint: n.RG_INTEGER,
    rg16sint: n.RG_INTEGER,
    rg16float: n.RG,
    rgba8unorm: n.RGBA,
    "rgba8unorm-srgb": n.RGBA,
    // Packed 32-bit formats
    rgba8snorm: n.RGBA,
    rgba8uint: n.RGBA_INTEGER,
    rgba8sint: n.RGBA_INTEGER,
    bgra8unorm: n.RGBA,
    "bgra8unorm-srgb": n.RGBA,
    rgb9e5ufloat: n.RGB,
    rgb10a2unorm: n.RGBA,
    rg11b10ufloat: n.RGB,
    // 64-bit formats
    rg32uint: n.RG_INTEGER,
    rg32sint: n.RG_INTEGER,
    rg32float: n.RG,
    rgba16uint: n.RGBA_INTEGER,
    rgba16sint: n.RGBA_INTEGER,
    rgba16float: n.RGBA,
    // 128-bit formats
    rgba32uint: n.RGBA_INTEGER,
    rgba32sint: n.RGBA_INTEGER,
    rgba32float: n.RGBA,
    // Depth/stencil formats
    stencil8: n.STENCIL_INDEX8,
    depth16unorm: n.DEPTH_COMPONENT,
    depth24plus: n.DEPTH_COMPONENT,
    "depth24plus-stencil8": n.DEPTH_STENCIL,
    depth32float: n.DEPTH_COMPONENT,
    "depth32float-stencil8": n.DEPTH_STENCIL
  };
}
function mee(n, e) {
  let t = {}, i = n.RGBA;
  return n instanceof zt.get().getWebGLRenderingContext() ? e.srgb && (t = {
    "rgba8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT,
    "bgra8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT
  }) : (t = {
    "rgba8unorm-srgb": n.SRGB8_ALPHA8,
    "bgra8unorm-srgb": n.SRGB8_ALPHA8
  }, i = n.RGBA8), {
    // 8-bit formats
    r8unorm: n.R8,
    r8snorm: n.R8_SNORM,
    r8uint: n.R8UI,
    r8sint: n.R8I,
    // 16-bit formats
    r16uint: n.R16UI,
    r16sint: n.R16I,
    r16float: n.R16F,
    rg8unorm: n.RG8,
    rg8snorm: n.RG8_SNORM,
    rg8uint: n.RG8UI,
    rg8sint: n.RG8I,
    // 32-bit formats
    r32uint: n.R32UI,
    r32sint: n.R32I,
    r32float: n.R32F,
    rg16uint: n.RG16UI,
    rg16sint: n.RG16I,
    rg16float: n.RG16F,
    rgba8unorm: n.RGBA,
    ...t,
    // Packed 32-bit formats
    rgba8snorm: n.RGBA8_SNORM,
    rgba8uint: n.RGBA8UI,
    rgba8sint: n.RGBA8I,
    bgra8unorm: i,
    rgb9e5ufloat: n.RGB9_E5,
    rgb10a2unorm: n.RGB10_A2,
    rg11b10ufloat: n.R11F_G11F_B10F,
    // 64-bit formats
    rg32uint: n.RG32UI,
    rg32sint: n.RG32I,
    rg32float: n.RG32F,
    rgba16uint: n.RGBA16UI,
    rgba16sint: n.RGBA16I,
    rgba16float: n.RGBA16F,
    // 128-bit formats
    rgba32uint: n.RGBA32UI,
    rgba32sint: n.RGBA32I,
    rgba32float: n.RGBA32F,
    // Depth/stencil formats
    stencil8: n.STENCIL_INDEX8,
    depth16unorm: n.DEPTH_COMPONENT16,
    depth24plus: n.DEPTH_COMPONENT24,
    "depth24plus-stencil8": n.DEPTH24_STENCIL8,
    depth32float: n.DEPTH_COMPONENT32F,
    "depth32float-stencil8": n.DEPTH32F_STENCIL8,
    // Compressed formats
    ...e.s3tc ? {
      "bc1-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT5_EXT
    } : {},
    ...e.s3tc_sRGB ? {
      "bc1-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
    } : {},
    ...e.rgtc ? {
      "bc4-r-unorm": e.rgtc.COMPRESSED_RED_RGTC1_EXT,
      "bc4-r-snorm": e.rgtc.COMPRESSED_SIGNED_RED_RGTC1_EXT,
      "bc5-rg-unorm": e.rgtc.COMPRESSED_RED_GREEN_RGTC2_EXT,
      "bc5-rg-snorm": e.rgtc.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
    } : {},
    ...e.bptc ? {
      "bc6h-rgb-float": e.bptc.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT,
      "bc6h-rgb-ufloat": e.bptc.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
      "bc7-rgba-unorm": e.bptc.COMPRESSED_RGBA_BPTC_UNORM_EXT,
      "bc7-rgba-unorm-srgb": e.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
    } : {},
    ...e.etc ? {
      "etc2-rgb8unorm": e.etc.COMPRESSED_RGB8_ETC2,
      "etc2-rgb8unorm-srgb": e.etc.COMPRESSED_SRGB8_ETC2,
      "etc2-rgb8a1unorm": e.etc.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgb8a1unorm-srgb": e.etc.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgba8unorm": e.etc.COMPRESSED_RGBA8_ETC2_EAC,
      "etc2-rgba8unorm-srgb": e.etc.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC,
      "eac-r11unorm": e.etc.COMPRESSED_R11_EAC,
      // 'eac-r11snorm'
      "eac-rg11unorm": e.etc.COMPRESSED_SIGNED_RG11_EAC
      // 'eac-rg11snorm'
    } : {},
    ...e.astc ? {
      "astc-4x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_4x4_KHR,
      "astc-4x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR,
      "astc-5x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x4_KHR,
      "astc-5x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR,
      "astc-5x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x5_KHR,
      "astc-5x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR,
      "astc-6x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x5_KHR,
      "astc-6x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR,
      "astc-6x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x6_KHR,
      "astc-6x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR,
      "astc-8x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x5_KHR,
      "astc-8x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR,
      "astc-8x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x6_KHR,
      "astc-8x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR,
      "astc-8x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x8_KHR,
      "astc-8x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR,
      "astc-10x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x5_KHR,
      "astc-10x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR,
      "astc-10x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x6_KHR,
      "astc-10x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR,
      "astc-10x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x8_KHR,
      "astc-10x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR,
      "astc-10x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x10_KHR,
      "astc-10x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR,
      "astc-12x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x10_KHR,
      "astc-12x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR,
      "astc-12x12-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x12_KHR,
      "astc-12x12-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
    } : {}
  };
}
function gee(n) {
  return {
    // 8-bit formats
    r8unorm: n.UNSIGNED_BYTE,
    r8snorm: n.BYTE,
    r8uint: n.UNSIGNED_BYTE,
    r8sint: n.BYTE,
    // 16-bit formats
    r16uint: n.UNSIGNED_SHORT,
    r16sint: n.SHORT,
    r16float: n.HALF_FLOAT,
    rg8unorm: n.UNSIGNED_BYTE,
    rg8snorm: n.BYTE,
    rg8uint: n.UNSIGNED_BYTE,
    rg8sint: n.BYTE,
    // 32-bit formats
    r32uint: n.UNSIGNED_INT,
    r32sint: n.INT,
    r32float: n.FLOAT,
    rg16uint: n.UNSIGNED_SHORT,
    rg16sint: n.SHORT,
    rg16float: n.HALF_FLOAT,
    rgba8unorm: n.UNSIGNED_BYTE,
    "rgba8unorm-srgb": n.UNSIGNED_BYTE,
    // Packed 32-bit formats
    rgba8snorm: n.BYTE,
    rgba8uint: n.UNSIGNED_BYTE,
    rgba8sint: n.BYTE,
    bgra8unorm: n.UNSIGNED_BYTE,
    "bgra8unorm-srgb": n.UNSIGNED_BYTE,
    rgb9e5ufloat: n.UNSIGNED_INT_5_9_9_9_REV,
    rgb10a2unorm: n.UNSIGNED_INT_2_10_10_10_REV,
    rg11b10ufloat: n.UNSIGNED_INT_10F_11F_11F_REV,
    // 64-bit formats
    rg32uint: n.UNSIGNED_INT,
    rg32sint: n.INT,
    rg32float: n.FLOAT,
    rgba16uint: n.UNSIGNED_SHORT,
    rgba16sint: n.SHORT,
    rgba16float: n.HALF_FLOAT,
    // 128-bit formats
    rgba32uint: n.UNSIGNED_INT,
    rgba32sint: n.INT,
    rgba32float: n.FLOAT,
    // Depth/stencil formats
    stencil8: n.UNSIGNED_BYTE,
    depth16unorm: n.UNSIGNED_SHORT,
    depth24plus: n.UNSIGNED_INT,
    "depth24plus-stencil8": n.UNSIGNED_INT_24_8,
    depth32float: n.FLOAT,
    "depth32float-stencil8": n.FLOAT_32_UNSIGNED_INT_24_8_REV
  };
}
function bee(n) {
  return {
    "2d": n.TEXTURE_2D,
    cube: n.TEXTURE_CUBE_MAP,
    "1d": null,
    // WebGL2 only
    "3d": (n == null ? void 0 : n.TEXTURE_3D) || null,
    "2d-array": (n == null ? void 0 : n.TEXTURE_2D_ARRAY) || null,
    "cube-array": (n == null ? void 0 : n.TEXTURE_CUBE_MAP_ARRAY) || null
  };
}
const vee = 4, Uy = class nC {
  constructor(e) {
    this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundTextures = [], this._integerUnits = 0, this._activeTextureLocation = -1, this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1, this._useSeparateSamplers = !1, this._renderer = e, this._managedTextures = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onSourceUnload.bind(this),
      name: "glTexture"
    });
    const t = {
      image: tC,
      buffer: see,
      video: uee,
      compressed: ree,
      ...nC.uploadExtensions
    };
    this._uploads = {
      ...t,
      cube: aee(t)
    };
  }
  /**
   * @deprecated since 8.15.0
   */
  get managedTextures() {
    return Object.values(this._managedTextures.items);
  }
  contextChange(e) {
    this._gl = e, this._mapFormatToInternalFormat || (this._mapFormatToInternalFormat = mee(e, this._renderer.context.extensions), this._mapFormatToType = gee(e), this._mapFormatToFormat = fee(e), this._mapViewDimensionToGlTarget = bee(e)), this._managedTextures.removeAll(!0), this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1;
    for (let t = 0; t < 16; t++)
      this.bind(et.EMPTY, t);
  }
  /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */
  initSource(e) {
    this.bind(e);
  }
  bind(e, t = 0) {
    const i = e.source;
    e ? (this.bindSource(i, t), this._useSeparateSamplers && this._bindSampler(i.style, t)) : (this.bindSource(null, t), this._useSeparateSamplers && this._bindSampler(null, t));
  }
  bindSource(e, t = 0) {
    const i = this._gl;
    if (e._gcLastUsed = this._renderer.gc.now, this._boundTextures[t] !== e) {
      this._setBoundTexture(t, e), this._activateLocation(t), e || (e = et.EMPTY.source);
      const s = this.getGlSource(e);
      i.bindTexture(s.target, s.texture);
    }
  }
  /**
   * Binds the empty texture over every integer texture on unit `location` and above
   *
   * WebGL fails a draw when a float sampler's unit holds an integer texture, even if the shader
   * never samples it. Call this after binding a batch's textures when the shader declares more
   * samplers than the batch binds.
   * @param location - The first texture unit to check.
   */
  unbindIntegerTextures(e) {
    if (e >= 32) return;
    let t = this._integerUnits >>> e << e;
    for (; t; ) {
      const i = 31 - Math.clz32(t);
      t &= ~(1 << i), this.bind(et.EMPTY, i);
    }
  }
  /**
   * Records the source bound to a unit, keeping `_integerUnits` in step. Every per-unit write to
   * `_boundTextures` goes through here so the two can't drift apart.
   *
   * A unit has a separate binding per target (2D, 2D array, cube), and the batch shaders sample
   * the 2D target, so only a 2D source changes the unit's bit. Anything else, including null,
   * leaves it as it was: a bit left set after the integer texture is gone only costs one extra
   * `bind(Texture.EMPTY)` in `unbindIntegerTextures`, while a cleared bit over an integer texture
   * fails the next batch.
   * @param location - The texture unit.
   * @param source - The source now bound there, or null.
   */
  _setBoundTexture(e, t) {
    this._boundTextures[e] = t, !(e < 0 || e > 31) && (!t || t.viewDimension !== "2d" || (Gv(t.format) ? this._integerUnits |= 1 << e : this._integerUnits &= ~(1 << e)));
  }
  _bindSampler(e, t = 0) {
    const i = this._gl;
    if (!e) {
      this._boundSamplers[t] = null, i.bindSampler(t, null);
      return;
    }
    const s = this._getGlSampler(e);
    this._boundSamplers[t] !== s && (this._boundSamplers[t] = s, i.bindSampler(t, s));
  }
  unbind(e) {
    const t = e.source, i = this._boundTextures, s = this._gl;
    for (let o = 0; o < i.length; o++)
      if (i[o] === t) {
        this._activateLocation(o);
        const r = this.getGlSource(t);
        s.bindTexture(r.target, null), this._setBoundTexture(o, null);
      }
  }
  _activateLocation(e) {
    this._activeTextureLocation !== e && (this._activeTextureLocation = e, this._gl.activeTexture(this._gl.TEXTURE0 + e));
  }
  _initSource(e) {
    const t = this._gl, i = new iee(t.createTexture());
    if (i.type = this._mapFormatToType[e.format], i.internalFormat = this._mapFormatToInternalFormat[e.format], i.format = this._mapFormatToFormat[e.format], i.target = this._mapViewDimensionToGlTarget[e.viewDimension], i.target === null)
      throw new Error(`Unsupported view dimension: ${e.viewDimension} with this webgl version: ${this._renderer.context.webGLVersion}`);
    if (e.autoGenerateMipmaps && (this._renderer.context.supports.nonPowOf2mipmaps || e.isPowerOfTwo)) {
      const o = Math.max(e.width, e.height, e.depth);
      e.mipLevelCount = Math.floor(Math.log2(o)) + 1;
    }
    return e._gpuData[this._renderer.uid] = i, this._managedTextures.add(e) && (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceUpdate, this), e.on("styleChange", this.onStyleChange, this), e.on("updateMipmaps", this.onUpdateMipmaps, this)), this.onSourceUpdate(e), this.updateStyle(e, !1), i;
  }
  onStyleChange(e) {
    this.updateStyle(e, !1);
  }
  updateStyle(e, t) {
    const i = this._gl, s = this.getGlSource(e);
    i.bindTexture(s.target, s.texture), this._setBoundTexture(this._activeTextureLocation, e), X2(
      e.style,
      i,
      e.mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "texParameteri",
      s.target,
      // will force a clamp to edge if the texture is not a power of two
      !this._renderer.context.supports.nonPowOf2wrapping && !e.isPowerOfTwo,
      t
    );
  }
  onSourceUnload(e, t = !1) {
    const i = e._gpuData[this._renderer.uid];
    i && (t || (this.unbind(e), this._gl.deleteTexture(i.texture)), e.off("update", this.onSourceUpdate, this), e.off("resize", this.onSourceUpdate, this), e.off("styleChange", this.onStyleChange, this), e.off("updateMipmaps", this.onUpdateMipmaps, this));
  }
  onSourceUpdate(e) {
    const t = this._gl, i = this.getGlSource(e);
    t.bindTexture(i.target, i.texture), this._setBoundTexture(this._activeTextureLocation, e);
    const s = e.alphaMode === "premultiply-alpha-on-upload" && !Gv(e.format) && i.target !== t.TEXTURE_3D && i.target !== t.TEXTURE_2D_ARRAY;
    if (this._premultiplyAlpha !== s && (this._premultiplyAlpha = s, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s)), this._uploads[e.uploadMethodId])
      this._uploads[e.uploadMethodId].upload(e, i, t, this._renderer.context.webGLVersion);
    else if (i.target === t.TEXTURE_2D)
      this._initEmptyTexture2D(i, e);
    else if (i.target === t.TEXTURE_2D_ARRAY || i.target === t.TEXTURE_3D)
      this._initEmptyTexture3D(i, e);
    else if (i.target === t.TEXTURE_CUBE_MAP)
      this._initEmptyTextureCube(i, e);
    else
      throw new Error("[GlTextureSystem] Unsupported texture target for empty allocation.");
    this._applyMipRange(i, e), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e, !1);
  }
  onUpdateMipmaps(e, t = !0) {
    t && this.bindSource(e, 0);
    const i = this.getGlSource(e);
    this._gl.generateMipmap(i.target);
  }
  _initEmptyTexture2D(e, t) {
    const i = this._gl;
    i.texImage2D(
      i.TEXTURE_2D,
      0,
      e.internalFormat,
      t.pixelWidth,
      t.pixelHeight,
      0,
      e.format,
      e.type,
      null
    );
    let s = Math.max(t.pixelWidth >> 1, 1), o = Math.max(t.pixelHeight >> 1, 1);
    for (let r = 1; r < t.mipLevelCount; r++)
      i.texImage2D(
        i.TEXTURE_2D,
        r,
        e.internalFormat,
        s,
        o,
        0,
        e.format,
        e.type,
        null
      ), s = Math.max(s >> 1, 1), o = Math.max(o >> 1, 1);
  }
  /**
   * Allocates a texture with a depth: the layers of a 2D array or the slices of a 3D texture.
   * Layer counts stay the same at every mip level; 3D depth halves like width and height.
   * @param glTexture - The GL texture wrapper.
   * @param source - The texture source describing the size.
   */
  _initEmptyTexture3D(e, t) {
    const i = this._gl, s = e.target === i.TEXTURE_3D;
    let o = t.pixelWidth, r = t.pixelHeight, a = t.depthOrArrayLayers;
    for (let l = 0; l < t.mipLevelCount; l++)
      i.texImage3D(
        e.target,
        l,
        e.internalFormat,
        o,
        r,
        a,
        0,
        e.format,
        e.type,
        null
      ), o = Math.max(o >> 1, 1), r = Math.max(r >> 1, 1), s && (a = Math.max(a >> 1, 1));
  }
  _initEmptyTextureCube(e, t) {
    const i = this._gl, s = 6;
    for (let a = 0; a < s; a++)
      i.texImage2D(
        i.TEXTURE_CUBE_MAP_POSITIVE_X + a,
        0,
        e.internalFormat,
        t.pixelWidth,
        t.pixelHeight,
        0,
        e.format,
        e.type,
        null
      );
    let o = Math.max(t.pixelWidth >> 1, 1), r = Math.max(t.pixelHeight >> 1, 1);
    for (let a = 1; a < t.mipLevelCount; a++) {
      for (let l = 0; l < s; l++)
        i.texImage2D(
          i.TEXTURE_CUBE_MAP_POSITIVE_X + l,
          a,
          e.internalFormat,
          o,
          r,
          0,
          e.format,
          e.type,
          null
        );
      o = Math.max(o >> 1, 1), r = Math.max(r >> 1, 1);
    }
  }
  /**
   * Applies a mip range to the currently-bound texture so WebGL2 considers the texture "mipmap complete"
   * for the declared `mipLevelCount` (especially important for partial mip chains rendered via FBO).
   * @param glTexture - The GL texture wrapper.
   * @param source - The texture source describing mipLevelCount.
   */
  _applyMipRange(e, t) {
    if (this._renderer.context.webGLVersion !== 2 || t.mipLevelCount <= 1) return;
    const i = this._gl, s = Math.max((t.mipLevelCount | 0) - 1, 0);
    i.texParameteri(e.target, i.TEXTURE_BASE_LEVEL, 0), i.texParameteri(e.target, i.TEXTURE_MAX_LEVEL, s);
  }
  _initSampler(e) {
    const t = this._gl, i = this._gl.createSampler();
    return this._glSamplers[e._resourceId] = i, X2(
      e,
      t,
      this._boundTextures[this._activeTextureLocation].mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "samplerParameteri",
      i,
      !1,
      !0
    ), this._glSamplers[e._resourceId];
  }
  _getGlSampler(e) {
    return this._glSamplers[e._resourceId] || this._initSampler(e);
  }
  getGlSource(e) {
    return e._gcLastUsed = this._renderer.gc.now, e._gpuData[this._renderer.uid] || this._initSource(e);
  }
  generateCanvas(e) {
    const { pixels: t, width: i, height: s } = this.getPixels(e), o = zt.get().createCanvas();
    o.width = i, o.height = s;
    const r = o.getContext("2d");
    if (r) {
      const a = r.createImageData(i, s);
      a.data.set(t), r.putImageData(a, 0, 0);
    }
    return o;
  }
  getPixels(e) {
    const t = e.source.resolution, i = e.frame, s = Math.max(Math.round(i.width * t), 1), o = Math.max(Math.round(i.height * t), 1), r = new Uint8Array(vee * s * o), a = this._renderer, l = a.renderTarget.getRenderTarget(e), d = a.renderTarget.getGpuRenderTarget(l), c = a.gl;
    return a.renderTarget.adaptor.bindFramebuffer(d.resolveTargetFramebuffer), c.readPixels(
      Math.round(i.x * t),
      Math.round(i.y * t),
      s,
      o,
      c.RGBA,
      c.UNSIGNED_BYTE,
      r
    ), { pixels: new Uint8ClampedArray(r.buffer), width: s, height: o };
  }
  destroy() {
    this._managedTextures.destroy(), this._glSamplers = null, this._boundTextures = null, this._boundSamplers = null, this._mapFormatToInternalFormat = null, this._mapFormatToType = null, this._mapFormatToFormat = null, this._uploads = null, this._renderer = null;
  }
  resetState() {
    const e = this._renderer.limits.maxTextures;
    this._activeTextureLocation = -1, this._boundTextures.fill(null), this._integerUnits = e >= 32 ? -1 : (1 << e) - 1, this._boundSamplers = /* @__PURE__ */ Object.create(null);
    const t = this._gl;
    this._premultiplyAlpha = !1, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this._premultiplyAlpha);
  }
};
Uy.extension = {
  type: [
    Ae.WebGLSystem
  ],
  name: "texture"
};
Uy.uploadExtensions = /* @__PURE__ */ Object.create(null);
let iC = Uy;
ht.handleByMap(Ae.TextureUploaderWebGL, iC.uploadExtensions);
class sC {
  contextChange(e) {
    const t = new Ts({
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uTransformMatrix: { value: new ot(), type: "mat3x3<f32>" },
      uRound: { value: 0, type: "f32" }
    }), i = e.limits.maxBatchableTextures, s = ly({
      name: "graphics",
      bits: [
        TM,
        IM(i),
        tT,
        cy
      ]
    });
    this.shader = new lo({
      glProgram: s,
      resources: {
        localUniforms: t,
        batchSamplers: AM(i)
      }
    });
  }
  execute(e, t) {
    const i = t.context, s = i.customShader || this.shader, o = e.renderer, r = o.graphicsContext, {
      batcher: a,
      instructions: l
    } = r.getContextRenderData(i);
    s.groups[0] = o.globalUniforms.bindGroup, o.state.set(e.state), o.shader.bind(s), o.geometry.bind(a.geometry, s.glProgram);
    const d = l.instructions;
    for (let c = 0; c < l.instructionSize; c++) {
      const h = d[c];
      if (h.size) {
        for (let f = 0; f < h.textures.count; f++)
          o.texture.bind(h.textures.textures[f], f);
        o.texture.unbindIntegerTextures(h.textures.count), o.geometry.draw(h.topology, h.size, h.start);
      }
    }
  }
  destroy() {
    this.shader.destroy(!0), this.shader = null;
  }
}
sC.extension = {
  type: [
    Ae.WebGLPipesAdaptor
  ],
  name: "graphics"
};
class oC {
  init() {
    const e = ly({
      name: "mesh",
      bits: [
        tT,
        DZ,
        cy
      ]
    });
    this._shader = new lo({
      glProgram: e,
      resources: {
        uTexture: et.EMPTY.source,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new ot() }
        }
      }
    });
  }
  execute(e, t) {
    const i = e.renderer;
    let s = t._shader;
    if (s) {
      if (!s.glProgram) {
        dt("Mesh shader has no glProgram", t.shader);
        return;
      }
    } else {
      s = this._shader;
      const o = t.texture, r = o.source;
      s.resources.uTexture = r, s.resources.uSampler = r.style, s.resources.textureUniforms.uniforms.uTextureMatrix = o.textureMatrix.mapCoord;
    }
    s.groups[100] = i.globalUniforms.bindGroup, s.groups[101] = e.localUniformsBindGroup, i.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(!0), this._shader = null;
  }
}
oC.extension = {
  type: [
    Ae.WebGLPipesAdaptor
  ],
  name: "mesh"
};
const yee = [
  ...Oy,
  qT,
  PQ,
  SQ,
  UT,
  DT,
  iC,
  KT,
  LT,
  ZT,
  JT,
  NT,
  nee,
  GT,
  FT
], xee = [...IT], wee = [iT, oC, sC], rC = [], aC = [], lC = [], dC = [];
ht.handleByNamedList(Ae.WebGLSystem, rC);
ht.handleByNamedList(Ae.WebGLPipes, aC);
ht.handleByNamedList(Ae.WebGLPipesAdaptor, lC);
ht.handleByNamedList(Ae.WebGLLoader, dC);
ht.add(...yee, ...xee, ...wee);
class kee extends ku {
  constructor() {
    const e = {
      name: "webgl",
      type: rs.WEBGL,
      systems: rC,
      renderPipes: aC,
      renderPipeAdaptors: lC,
      loaders: dC
    };
    super(e);
  }
}
const _ee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGLRenderer: kee
}, Symbol.toStringTag, { value: "Module" }));
class See {
  constructor(e, t) {
    this.autoGarbageCollect = !0, this._gpuData = null, this.gpuBindGroup = e, this._gcLastUsed = t;
  }
  /**
   * Native bind groups have no destroy; dropping the reference is the whole release. Anything
   * still holding the group (a recorded render bundle, a graphics batch) keeps it alive, and the
   * next immediate-mode bind simply recreates the cache entry.
   */
  unload() {
    this.gpuBindGroup = null;
  }
}
class cC {
  constructor(e) {
    this._hash = /* @__PURE__ */ Object.create(null), this._renderer = e, e.gc.addResourceHash(this, "_hash", "resource"), e.gc.addCollection(this, "_hash", "hash");
  }
  contextChange(e) {
    this._gpu = e, this._hash = /* @__PURE__ */ Object.create(null);
  }
  getBindGroup(e, t, i) {
    const s = `${e._key}:${t._layoutKey << 4 | i}`, o = this._hash[s];
    return o ? (o._gcLastUsed = this._renderer.gc.now, o.gpuBindGroup) : this._createBindGroup(s, e, t, i);
  }
  _createBindGroup(e, t, i, s) {
    var h, f;
    const o = this._gpu.device, r = i.layout[s], a = [], l = this._renderer;
    for (const p in r) {
      const y = (h = t.resources[p]) != null ? h : t.resources[r[p]];
      if (!y || y.destroyed)
        throw new Error(`[BindGroup] the resource bound as '${p}' was destroyed while a shader still uses it. Remove it from the shader before destroying it.`);
      let v;
      if (y._resourceType === "uniformGroup") {
        const x = y;
        l.ubo.updateUniformGroup(x);
        const w = x.buffer;
        v = {
          buffer: l.buffer.getGPUBuffer(w),
          offset: 0,
          size: w.descriptor.size
        };
      } else if (y._resourceType === "buffer") {
        const x = y;
        v = {
          buffer: l.buffer.getGPUBuffer(x),
          offset: 0,
          size: x.descriptor.size
        };
      } else if (y._resourceType === "bufferResource") {
        const x = y;
        v = {
          buffer: l.buffer.getGPUBuffer(x.buffer),
          offset: x.offset,
          size: (f = x.size) != null ? f : x.buffer.descriptor.size
        };
      } else if (y._resourceType === "textureSampler") {
        const x = y;
        v = l.texture.getGpuSampler(x);
      } else if (y._resourceType === "textureSource") {
        const x = y;
        v = l.texture.getTextureView(x);
      } else if (y._resourceType === "textureView") {
        const x = y;
        v = l.texture.getTextureView(x.source, x.viewDescriptor);
      }
      a.push({
        binding: r[p],
        resource: v
      });
    }
    const d = l.shader.getProgramData(i).bindGroups[s], c = o.createBindGroup({
      layout: d,
      entries: a
    });
    return this._hash[e] = new See(c, l.gc.now), c;
  }
  destroy() {
    this._hash = null, this._renderer = null;
  }
}
cC.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "bindGroup"
};
class Mee {
  constructor(e) {
    this.gpuBuffer = e;
  }
  destroy() {
    this.gpuBuffer.destroy(), this.gpuBuffer = null;
  }
}
class uC {
  constructor(e) {
    this._renderer = e, this._managedBuffers = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onBufferUnload.bind(this),
      name: "gpuBuffer"
    });
  }
  contextChange(e) {
    this._gpu = e, this.destroyAll();
  }
  getGPUBuffer(e) {
    var t;
    return e._gcLastUsed = this._renderer.gc.now, ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuBuffer) || this.createGPUBuffer(e);
  }
  updateBuffer(e) {
    const t = this.getGPUBuffer(e), i = e.data;
    return e._updateID && i && (e._updateID = 0, this._gpu.device.queue.writeBuffer(
      t,
      e._updateOffset,
      i.buffer,
      i.byteOffset + e._updateOffset,
      // round to the nearest 4 bytes
      (e._updateSize || i.byteLength) + 3 & -4
    )), t;
  }
  /** dispose all WebGL resources of all managed buffers */
  destroyAll() {
    this._managedBuffers.removeAll();
  }
  onBufferUnload(e) {
    e.off("update", this.updateBuffer, this), e.off("change", this.onBufferChange, this);
  }
  createGPUBuffer(e) {
    const t = this._gpu.device.createBuffer(e.descriptor);
    return e._updateID = 0, e.data && (r0(
      e.data.buffer,
      t.getMappedRange(),
      e.data.byteOffset,
      e.data.byteLength
    ), t.unmap()), e._gpuData[this._renderer.uid] = new Mee(t), this._managedBuffers.add(e) && (e.on("update", this.updateBuffer, this), e.on("change", this.onBufferChange, this)), t;
  }
  onBufferChange(e) {
    this._managedBuffers.remove(e), e._updateID = 0, this.createGPUBuffer(e);
  }
  destroy() {
    this._managedBuffers.destroy(), this._renderer = null, this._gpu = null;
  }
}
uC.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "buffer"
};
class Tee {
  constructor({ minUniformOffsetAlignment: e }) {
    this._minUniformOffsetAlignment = 256, this.byteIndex = 0, this._minUniformOffsetAlignment = e, this.data = new Float32Array(65535);
  }
  clear() {
    this.byteIndex = 0;
  }
  addEmptyGroup(e) {
    if (e > this._minUniformOffsetAlignment / 4)
      throw new Error(`UniformBufferBatch: array is too large: ${e * 4}`);
    const t = this.byteIndex;
    let i = t + e * 4;
    if (i = Math.ceil(i / this._minUniformOffsetAlignment) * this._minUniformOffsetAlignment, i > this.data.length * 4)
      throw new Error("UniformBufferBatch: ubo batch got too big");
    return this.byteIndex = i, t;
  }
  addGroup(e) {
    const t = this.addEmptyGroup(e.length);
    for (let i = 0; i < e.length; i++)
      this.data[t / 4 + i] = e[i];
    return t;
  }
  destroy() {
    this.data = null;
  }
}
class hC {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.pipeline.setColorMask(e));
  }
  destroy() {
    this._renderer = null, this._colorMaskCache = null;
  }
}
hC.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "colorMask"
};
const Cee = /* @__PURE__ */ new Set(["apple", "arm", "qualcomm", "img-tec"]);
class Gy {
  /**
   * @param {WebGPURenderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._renderer = e;
  }
  async init(e) {
    return this._initPromise ? this._initPromise : (this._options = e, this._initPromise = (e.gpu ? Promise.resolve(e.gpu) : this._createDeviceAndAdaptor(e)).then((t) => this._setGpu(t)), this._initPromise);
  }
  _setGpu(e) {
    var t, i;
    this.gpu = e, this.extensions = {
      transientAttachment: typeof GPUTextureUsage.TRANSIENT_ATTACHMENT == "number",
      tileBased: Cee.has((i = (t = e.adapter) == null ? void 0 : t.info) == null ? void 0 : i.vendor)
    }, this._options.gpu || e.device.lost.then(() => this._restoreDevice()).catch((s) => dt("WebGPU device was lost and could not be restored", s)), this._renderer.runners.contextChange.emit(this.gpu);
  }
  async _restoreDevice() {
    if (!this._renderer) return;
    const e = await this._createDeviceAndAdaptor(this._options);
    if (!this._renderer) {
      e.device.destroy();
      return;
    }
    this._setGpu(e);
  }
  /**
   * Handle the context change event
   * @param gpu
   */
  contextChange(e) {
    this._renderer.gpu = e;
  }
  /**
   * Helper class to create a WebGL Context
   * @param {object} options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */
  async _createDeviceAndAdaptor(e) {
    const t = await zt.get().getNavigator().gpu.requestAdapter({
      powerPreference: e.powerPreference,
      forceFallbackAdapter: e.forceFallbackAdapter
    });
    if (!t)
      throw new Error("WebGPU not supported. No GPU adapter was returned by navigator.gpu.requestAdapter().");
    const i = [
      "texture-compression-bc",
      "texture-compression-astc",
      "texture-compression-etc2",
      "indirect-first-instance",
      // more formats for TextureSource `storage`
      "bgra8unorm-storage",
      "texture-formats-tier1"
    ].filter((o) => t.features.has(o)), s = await t.requestDevice({
      requiredFeatures: i,
      requiredLimits: {
        maxSampledTexturesPerShaderStage: t.limits.maxSampledTexturesPerShaderStage,
        maxSamplersPerShaderStage: t.limits.maxSamplersPerShaderStage
      }
    });
    return { adapter: t, device: s };
  }
  destroy() {
    var e, t;
    (e = this._options) != null && e.gpu || (t = this.gpu) == null || t.device.destroy(), this.gpu = null, this.extensions = null, this._renderer = null;
  }
}
Gy.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "device"
};
Gy.defaultOptions = {
  /**
   * {@link WebGPUOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * Force the use of the fallback adapter
   * @default false
   */
  forceFallbackAdapter: !1
};
class Iee {
  /**
   * @param gpuBundle - The recorded native render bundle.
   * @param stateKey - The pipeline state key captured when recording began.
   * @param device - The device the bundle was recorded on.
   * @param label - Optional debug label for the bundle.
   */
  constructor(e, t, i, s) {
    this.gpuBundle = e, this.stateKey = t, this.device = i, this.label = s;
  }
}
class pC {
  constructor(e) {
    this._boundBindGroup = /* @__PURE__ */ Object.create(null), this._boundVertexBuffer = /* @__PURE__ */ Object.create(null), this._renderer = e;
    for (let t = 0; t < 16; t++)
      this._boundBindGroup[t] = { bindGroup: null, program: null, key: null };
  }
  renderStart() {
    this.commandFinished = new Promise((e) => {
      this._resolveCommandFinished = e;
    }), this.commandEncoder = this._renderer.gpu.device.createCommandEncoder();
  }
  /**
   * Ends any open pass and begins one on the target's descriptor.
   * @param gpuRenderTarget - the target to render to
   * @returns the begun pass
   */
  beginRenderPass(e) {
    return this.endRenderPass(), this._clearCache(), this._passEncoder = this.commandEncoder.beginRenderPass(e.descriptor), this.renderPassEncoder = this._passEncoder, this._passEncoder;
  }
  endRenderPass() {
    this._passEncoder && this._passEncoder.end(), this.renderPassEncoder = null, this._passEncoder = null;
  }
  /**
   * Begins recording a render bundle. While recording, all draw commands are captured into a
   * {@link GPURenderBundleEncoder} instead of the active render pass. The current render pass
   * encoder is saved and restored when {@link endBundle} is called.
   *
   * Render bundles allow pre-recording of draw commands that can be replayed multiple times
   * via {@link executeBundle}, reducing CPU overhead for repeated draw sequences.
   * @param label - Optional debug label. Names the bundle in GPU captures and in the WebGPU
   * validation errors it can raise when replayed, instead of `(unlabeled)`.
   * @throws If a render bundle is already being recorded.
   */
  beginBundle(e) {
    if (this._passEncoder !== this.renderPassEncoder)
      throw new Error("Cannot begin a new render bundle while one is already being recorded.");
    this._clearCache();
    const t = this._renderer.pipeline, i = t.getBundleDescriptor();
    i.label = e, this._bundleStateKey = t.bundleStateKey, this._bundleLabel = e, this.renderPassEncoder = this._gpu.device.createRenderBundleEncoder(i);
  }
  /**
   * Finishes recording the current render bundle and restores the previous render pass encoder.
   * @returns The recorded {@link RenderBundle}, ready to be executed via {@link executeBundle} and
   * stamped with the pipeline state it baked so {@link isBundleValid} can vet it on later frames.
   */
  endBundle() {
    const e = this.renderPassEncoder;
    if (!e || !("finish" in e))
      throw new Error("endBundle called without an active render bundle.");
    const t = e.finish({ label: this._bundleLabel });
    return this.renderPassEncoder = this._passEncoder, this._clearCache(), new Iee(t, this._bundleStateKey, this._gpu.device, this._bundleLabel);
  }
  /**
   * Checks whether a recorded bundle can still be replayed against the render target that is
   * bound now.
   *
   * A bundle permanently bakes the attachment state it was recorded with — color format(s),
   * color target count, depth/stencil format, sample count — and WebGPU rejects the entire
   * command buffer if any of it differs at execute time. It also bakes the front-face winding of
   * its pipelines, which WebGPU does *not* validate: once the target's {@link RenderTarget.flipY}
   * parity changes, replaying silently renders geometry inside out.
   *
   * Ask before replaying rather than after: only the caller owns the draw commands, so only the
   * caller can re-record. A missing bundle reports `false`, so `!isBundleValid(bundles[i])` reads
   * correctly on the first frame, before anything has been recorded.
   * @param bundle - The bundle to check, as returned by {@link endBundle}.
   * @returns `true` if the bundle is safe to execute right now, `false` if it must be re-recorded.
   */
  isBundleValid(e) {
    return (e == null ? void 0 : e.stateKey) === this._renderer.pipeline.bundleStateKey && e.device === this._gpu.device;
  }
  /**
   * Replays previously recorded render bundles on the current render pass.
   * The bound state cache is cleared since a bundle may set its own pipeline, bind groups, and buffers.
   *
   * Pass a whole run of bundles rather than calling this once per bundle: WebGPU resets the pass
   * state after every call, so N calls cost N cache clears and N trips through the binding layer
   * for exactly the same result.
   *
   * Every bundle must have been recorded against a matching render target — check with
   * {@link isBundleValid} first and re-record if it says no, as Pixi cannot rebuild your draw
   * commands for you.
   * @param bundle - The render bundle to execute, or a run of them to execute in one call.
   */
  executeBundle(e) {
    const t = [];
    if (Array.isArray(e))
      for (let i = 0; i < e.length; i++)
        t[i] = this._getGpuBundle(e[i]);
    else
      t[0] = this._getGpuBundle(e);
    this._clearCache(), this._passEncoder.executeBundles(t);
  }
  /**
   * Unwraps a bundle for {@link executeBundle}, complaining first if it no longer matches the
   * bound render target — the winding half of that mismatch is invisible otherwise, since WebGPU
   * validates attachments but not front-face order.
   * @param bundle - The bundle being executed.
   * @returns The native bundle to hand to `executeBundles`.
   */
  _getGpuBundle(e) {
    var t;
    return this.isBundleValid(e) || dt(`Render bundle ${(t = e == null ? void 0 : e.label) != null ? t : "(unlabeled)"} was recorded against a different render target state or on a lost device. Re-record it — replaying it will either be rejected by WebGPU or draw with the wrong winding. Check encoder.isBundleValid(bundle) before executing.`), e.gpuBundle;
  }
  setViewport(e) {
    this._passEncoder.setViewport(e.x, e.y, e.width, e.height, 0, 1);
  }
  /**
   * Sets the stencil reference value for subsequent draws. This is a pass-level command, so it
   * always targets the real render pass — not a bundle encoder, which cannot set stencil state.
   * @param stencilReference - The stencil reference value to use.
   */
  setStencilReference(e) {
    this._passEncoder.setStencilReference(e);
  }
  setPipelineFromGeometryProgramAndState(e, t, i, s, o) {
    const r = this._renderer.pipeline.getPipeline(
      e,
      t,
      i,
      s,
      o
    );
    this.setPipeline(r);
  }
  setPipeline(e) {
    this._boundPipeline !== e && (this._boundPipeline = e, this.renderPassEncoder.setPipeline(e));
  }
  _setVertexBuffer(e, t) {
    this._boundVertexBuffer[e] !== t && (this._boundVertexBuffer[e] = t, this.renderPassEncoder.setVertexBuffer(e, this._renderer.buffer.updateBuffer(t)));
  }
  _setIndexBuffer(e) {
    if (this._boundIndexBuffer === e) return;
    this._boundIndexBuffer = e;
    const t = e.data.BYTES_PER_ELEMENT === 2 ? "uint16" : "uint32";
    this.renderPassEncoder.setIndexBuffer(this._renderer.buffer.updateBuffer(e), t);
  }
  resetBindGroup(e) {
    const t = this._boundBindGroup[e];
    t.bindGroup = null, t.program = null, t.key = null;
  }
  setBindGroup(e, t, i) {
    const s = this._boundBindGroup[e];
    if (s.bindGroup === t && s.program === i && s.key === t._key) return;
    s.bindGroup = t, s.program = i, s.key = t._key, t._touch(this._renderer.gc.now);
    const o = this._renderer.bindGroup.getBindGroup(t, i, e);
    this.renderPassEncoder.setBindGroup(e, o);
  }
  setGeometry(e, t) {
    const i = this._renderer.pipeline.getBufferNamesToBind(e, t);
    for (let s = 0; s < i.length; s++)
      this._setVertexBuffer(s, e.attributes[i[s]].buffer);
    e.indexBuffer && this._setIndexBuffer(e.indexBuffer);
  }
  _setShaderBindGroups(e, t) {
    const i = e.gpuProgram, s = i.layout;
    for (let o = 0; o < s.length; o++) {
      const r = e.groups[o];
      !s[o] || !r || (t || this._syncBindGroup(r), this.setBindGroup(o, r, i));
    }
  }
  _syncBindGroup(e) {
    const t = e.resources, i = e._resourceKeys;
    for (let s = 0; s < i.length; s++) {
      const o = t[i[s]];
      o && o.isUniformGroup && this._renderer.ubo.updateUniformGroup(o);
    }
  }
  draw(e) {
    const { geometry: t, shader: i, state: s, topology: o, size: r, start: a, baseVertex: l, instanceCount: d, skipSync: c, firstInstance: h } = e;
    this.setPipelineFromGeometryProgramAndState(t, i.gpuProgram, s, o, i._overrides), this.setGeometry(t, i.gpuProgram), this._setShaderBindGroups(i, c), t.indexBuffer ? this.renderPassEncoder.drawIndexed(
      r || t.indexCount || t.indexBuffer.data.length,
      d != null ? d : t.instanceCount,
      a || 0,
      l || 0,
      h || 0
    ) : this.renderPassEncoder.draw(
      r || t.vertexCount,
      d != null ? d : t.instanceCount,
      a || 0,
      h || 0
    );
  }
  /**
   * Sets up the pipeline, geometry, and bind groups then issues an indirect draw call.
   * Uses `drawIndexedIndirect` when the geometry has an index buffer, otherwise `drawIndirect`.
   * Draw parameters (vertex count, instance count, etc.) are read from the indirect buffer on the GPU.
   * @param options - The draw options.
   * @param options.geometry - The geometry to draw.
   * @param options.shader - The shader to use.
   * @param options.state - Optional render state (blending, depth, etc.).
   * @param options.topology - Optional primitive topology override.
   * @param options.skipSync - If true, skips syncing uniform groups to their GPU buffers.
   * @param options.indirectBuffer - The GPU buffer containing the indirect draw parameters.
   * @param options.indirectOffset - Byte offset into the indirect buffer.
   */
  drawIndirect(e) {
    const { geometry: t, shader: i, state: s, topology: o, skipSync: r, indirectBuffer: a, indirectOffset: l } = e;
    this.setPipelineFromGeometryProgramAndState(t, i.gpuProgram, s, o, i._overrides), this.setGeometry(t, i.gpuProgram), this._setShaderBindGroups(i, r), t.indexBuffer ? this.renderPassEncoder.drawIndexedIndirect(a, l) : this.renderPassEncoder.drawIndirect(a, l);
  }
  finishRenderPass() {
    this._passEncoder && (this._passEncoder.end(), this.renderPassEncoder = null, this._passEncoder = null);
  }
  postrender() {
    this.finishRenderPass(), this._gpu.device.queue.submit([this.commandEncoder.finish()]), this._resolveCommandFinished(), this.commandEncoder = null;
  }
  _clearCache() {
    for (let e = 0; e < 16; e++) {
      const t = this._boundBindGroup[e];
      t.bindGroup = null, t.program = null, t.key = null, this._boundVertexBuffer[e] = null;
    }
    this._boundIndexBuffer = null, this._boundPipeline = null;
  }
  destroy() {
    this._renderer = null, this._gpu = null, this._boundBindGroup = null, this._boundVertexBuffer = null, this._boundIndexBuffer = null, this._boundPipeline = null, this.renderPassEncoder = null, this._passEncoder = null;
  }
  contextChange(e) {
    this._gpu = e;
  }
}
pC.extension = {
  type: [Ae.WebGPUSystem],
  name: "encoder",
  priority: 1
};
class fC {
  constructor(e) {
    this.supportsOverrideConstants = !1, this._renderer = e;
  }
  contextChange() {
    const e = this._renderer.device.gpu.device;
    this.maxTextures = Math.min(
      e.limits.maxSampledTexturesPerShaderStage,
      e.limits.maxSamplersPerShaderStage
    ), this.maxBatchableTextures = this.maxTextures, this._detectOverrideConstantsSupport(e);
  }
  _detectOverrideConstantsSupport(e) {
    e.pushErrorScope("validation");
    const t = e.createShaderModule({
      code: `override TEST_VALUE: f32 = 0.0;
@compute @workgroup_size(1) fn main() {}`
    });
    e.createComputePipeline({
      layout: "auto",
      compute: {
        module: t,
        entryPoint: "main",
        constants: { TEST_VALUE: 1 }
      }
    }), e.popErrorScope().then((i) => {
      this.supportsOverrideConstants = !i;
    });
  }
  destroy() {
  }
}
fC.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "limits"
};
class mC {
  constructor(e) {
    this._renderer = e, e.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange() {
    this._activeGpuRenderTarget = null;
  }
  onRenderTargetChange(e) {
    const t = this._renderer.renderTarget.getGpuRenderTarget(e);
    this._activeRenderTarget = e, this._activeGpuRenderTarget = t, this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  setStencilMode(e, t) {
    var o;
    const i = (o = this._activeGpuRenderTarget) != null ? o : this._activeGpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(this._activeRenderTarget);
    i.stencilMode = e, i.stencilReference = t;
    const s = this._renderer;
    s.pipeline.setStencilMode(e), s.encoder.setStencilReference(t);
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._activeRenderTarget = null, this._activeGpuRenderTarget = null;
  }
}
mC.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "stencil"
};
const Ip = {
  i32: { align: 4, size: 4 },
  u32: { align: 4, size: 4 },
  f32: { align: 4, size: 4 },
  f16: { align: 2, size: 2 },
  "vec2<i32>": { align: 8, size: 8 },
  "vec2<u32>": { align: 8, size: 8 },
  "vec2<f32>": { align: 8, size: 8 },
  "vec2<f16>": { align: 4, size: 4 },
  "vec3<i32>": { align: 16, size: 12 },
  "vec3<u32>": { align: 16, size: 12 },
  "vec3<f32>": { align: 16, size: 12 },
  "vec3<f16>": { align: 8, size: 6 },
  "vec4<i32>": { align: 16, size: 16 },
  "vec4<u32>": { align: 16, size: 16 },
  "vec4<f32>": { align: 16, size: 16 },
  "vec4<f16>": { align: 8, size: 8 },
  "mat2x2<f32>": { align: 8, size: 16 },
  "mat2x2<f16>": { align: 4, size: 8 },
  "mat3x2<f32>": { align: 8, size: 24 },
  "mat3x2<f16>": { align: 4, size: 12 },
  "mat4x2<f32>": { align: 8, size: 32 },
  "mat4x2<f16>": { align: 4, size: 16 },
  "mat2x3<f32>": { align: 16, size: 32 },
  "mat2x3<f16>": { align: 8, size: 16 },
  "mat3x3<f32>": { align: 16, size: 48 },
  "mat3x3<f16>": { align: 8, size: 24 },
  "mat4x3<f32>": { align: 16, size: 64 },
  "mat4x3<f16>": { align: 8, size: 32 },
  "mat2x4<f32>": { align: 16, size: 32 },
  "mat2x4<f16>": { align: 8, size: 16 },
  "mat3x4<f32>": { align: 16, size: 48 },
  "mat3x4<f16>": { align: 8, size: 24 },
  "mat4x4<f32>": { align: 16, size: 64 },
  "mat4x4<f16>": { align: 8, size: 32 }
};
function Aee(n) {
  const e = n.map((i) => ({
    data: i,
    offset: 0,
    size: 0
  }));
  let t = 0;
  for (let i = 0; i < e.length; i++) {
    const s = e[i];
    let o = Ip[s.data.type].size;
    const r = Ip[s.data.type].align;
    if (!Ip[s.data.type])
      throw new Error(`[Pixi.js] WebGPU UniformBuffer: Unknown type ${s.data.type}`);
    s.data.size > 1 && (o = Math.max(o, r) * s.data.size), t = Math.ceil(t / r) * r, s.size = o, s.offset = t, t += o;
  }
  return t = Math.ceil(t / 16) * 16, { uboElements: e, size: t };
}
function Pee(n, e) {
  const { size: t, align: i } = Ip[n.data.type], s = (Math.max(t, i) - t) / 4, o = n.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
         v = uv.${n.data.name};
         ${e !== 0 ? `offset += ${e};` : ""}

         arrayOffset = offset;

         t = 0;

         for(var i=0; i < ${n.data.size}; i++)
         {
             for(var j = 0; j < ${t / 4}; j++)
             {
                 ${o}[arrayOffset++] = v[t++];
             }
             ${s !== 0 ? `arrayOffset += ${s};` : ""}
         }
     `;
}
function Eee(n) {
  return VT(
    n,
    zQ,
    Pee
  );
}
class gC extends jT {
  constructor() {
    super({
      createUboElements: Aee,
      generateUboSync: Eee
    });
  }
}
gC.extension = {
  type: [Ae.WebGPUSystem],
  name: "ubo"
};
const bo = 128;
class bC {
  constructor(e) {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._buffers = [], this._bindGroups = [], this._bufferResources = [], this._renderer = e, this._batchBuffer = new Tee({ minUniformOffsetAlignment: bo });
    const t = 256 / bo;
    for (let i = 0; i < t; i++) {
      let s = $t.UNIFORM | $t.COPY_DST;
      i === 0 && (s |= $t.COPY_SRC), this._buffers.push(new ns({
        data: this._batchBuffer.data,
        usage: s
      }));
    }
  }
  renderEnd() {
    this._uploadBindGroups(), this._resetBindGroups();
  }
  _resetBindGroups() {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._batchBuffer.clear();
  }
  // just works for single bind groups for now
  getUniformBindGroup(e, t) {
    if (!t && this._bindGroupHash[e.uid])
      return this._bindGroupHash[e.uid];
    this._renderer.ubo.ensureUniformGroup(e);
    const i = e.buffer.data, s = this._batchBuffer.addEmptyGroup(i.length);
    return this._renderer.ubo.syncUniformGroup(e, this._batchBuffer.data, s / 4), this._bindGroupHash[e.uid] = this._getBindGroup(s / bo), this._bindGroupHash[e.uid];
  }
  getUboResource(e) {
    this._renderer.ubo.updateUniformGroup(e);
    const t = e.buffer.data, i = this._batchBuffer.addGroup(t);
    return this._getBufferResource(i / bo);
  }
  getArrayBindGroup(e) {
    const t = this._batchBuffer.addGroup(e);
    return this._getBindGroup(t / bo);
  }
  getArrayBufferResource(e) {
    const i = this._batchBuffer.addGroup(e) / bo;
    return this._getBufferResource(i);
  }
  _getBufferResource(e) {
    if (!this._bufferResources[e]) {
      const t = this._buffers[e % 2];
      this._bufferResources[e] = new Ny({
        buffer: t,
        offset: (e / 2 | 0) * 256,
        size: bo
      });
    }
    return this._bufferResources[e];
  }
  _getBindGroup(e) {
    if (!this._bindGroups[e]) {
      const t = new qo({
        0: this._getBufferResource(e)
      });
      this._bindGroups[e] = t;
    }
    return this._bindGroups[e];
  }
  _uploadBindGroups() {
    const e = this._renderer.buffer, t = this._buffers[0];
    t.update(this._batchBuffer.byteIndex), e.updateBuffer(t);
    const i = this._renderer.gpu.device.createCommandEncoder();
    for (let s = 1; s < this._buffers.length; s++) {
      const o = this._buffers[s];
      i.copyBufferToBuffer(
        e.getGPUBuffer(t),
        bo,
        e.getGPUBuffer(o),
        0,
        this._batchBuffer.byteIndex
      );
    }
    this._renderer.gpu.device.queue.submit([i.finish()]);
  }
  destroy() {
    var e;
    for (let t = 0; t < this._bindGroups.length; t++)
      (e = this._bindGroups[t]) == null || e.destroy();
    this._bindGroups = null, this._bindGroupHash = null;
    for (let t = 0; t < this._buffers.length; t++)
      this._buffers[t].destroy();
    this._buffers = null;
    for (let t = 0; t < this._bufferResources.length; t++)
      this._bufferResources[t].destroy();
    this._bufferResources = null, this._batchBuffer.destroy(), this._renderer = null;
  }
}
bC.extension = {
  type: [
    Ae.WebGPUPipes
  ],
  name: "uniformBatch"
};
const J2 = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 2,
  "triangle-list": 3,
  "triangle-strip": 4
}, Ree = new Vc({}), zee = {
  "depth24plus-stencil8": { depth: !0, stencil: !0, index: 1 },
  depth24plus: { depth: !0, stencil: !1, index: 2 },
  depth32float: { depth: !0, stencil: !1, index: 3 },
  "depth32float-stencil8": { depth: !0, stencil: !0, index: 4 },
  depth16unorm: { depth: !0, stencil: !1, index: 5 },
  stencil8: { depth: !1, stencil: !0, index: 6 }
}, Z2 = { depth: !1, stencil: !1, index: 0 };
function Q2(n, e) {
  for (const [t, i] of Object.entries(e)) {
    const s = new RegExp(
      `override\\s+${t}\\s*:\\s*(\\w+)\\s*(?:=[^;]*)?;`
    );
    n = n.replace(s, (o, r) => {
      let a;
      return r === "u32" ? a = `${Math.trunc(i)}u` : r === "i32" ? a = `${Math.trunc(i)}` : a = Number.isInteger(i) ? `${i}.0` : `${i}`, `const ${t}: ${r} = ${a};`;
    });
  }
  return n;
}
function e_(n, e, t, i, s, o) {
  return n * 35184372088832 + e * 536870912 + o * 16384 + (t << 8) + (i << 3) + s;
}
const t_ = /* @__PURE__ */ Object.create(null);
let $ee = 0;
function n_(n) {
  let e = t_[n];
  return e === void 0 && (e = t_[n] = $ee++), e;
}
function Dee(n, e, t, i, s, o, r, a) {
  return a << 20 | o << 16 | s << 13 | t << 9 | n << 6 | r << 5 | i << 1 | e;
}
function Oee(n, e, t, i, s, o, r) {
  return r << 11 | o << 10 | s << 9 | i << 8 | t << 5 | e << 1 | n;
}
class vC {
  constructor(e) {
    this._moduleCache = /* @__PURE__ */ Object.create(null), this._bufferLayoutsCache = /* @__PURE__ */ Object.create(null), this._bindingNamesCache = /* @__PURE__ */ Object.create(null), this._pipeCache = /* @__PURE__ */ new Map(), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this._colorMask = 15, this._multisampleCount = 1, this._colorTargetCount = 1, this._colorFormat = "bgra8unorm", this._colorFormatId = n_("bgra8unorm"), this._depthStencilFormat = "depth24plus-stencil8", this._depthStencilFormatData = Z2, this._depthReadOnly = !1, this._stencilReadOnly = !1, this._invertFrontFace = !1, this._renderer = e;
  }
  contextChange(e) {
    this._gpu = e, this._moduleCache = /* @__PURE__ */ Object.create(null), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this.setStencilMode(fn.DISABLED), this._updatePipeHash();
  }
  setMultisampleCount(e) {
    this._multisampleCount !== e && (this._multisampleCount = e, this._updatePipeHash());
  }
  setRenderTarget(e) {
    var i, s, o, r, a, l, d;
    const t = (i = e.colorAttachments[0]) == null ? void 0 : i.texture;
    this._multisampleCount = t != null && t.source.antialias ? 4 : 1, this._colorTargetCount = e.colorAttachments.length, this._colorFormat = (s = t == null ? void 0 : t.format) != null ? s : "bgra8unorm", this._colorFormatId = n_(this._colorFormat), this._depthStencilFormat = (o = e.depthStencilAttachment) == null ? void 0 : o.texture.format, this._depthStencilFormatData = zee[this._depthStencilFormat] || Z2, this._depthReadOnly = (a = (r = e.depthStencilAttachment) == null ? void 0 : r.depthReadOnly) != null ? a : !1, this._stencilReadOnly = (d = (l = e.depthStencilAttachment) == null ? void 0 : l.stencilReadOnly) != null ? d : this._depthReadOnly, this._invertFrontFace = this._renderer.renderTarget.isFrontFaceInverted(e, e.flipY), this._updatePipeHash();
  }
  setColorMask(e) {
    this._colorMask !== e && (this._colorMask = e, this._updatePipeHash());
  }
  setStencilMode(e) {
    this._stencilMode !== e && (this._stencilMode = e, this._stencilState = cr[e], this._updatePipeHash());
  }
  /**
   * A packed key for everything a render bundle recorded right now would bake into itself: the
   * attachment state WebGPU validates when the bundle is executed (color format(s), color target
   * count, depth/stencil format, sample count, read-only aspects), plus the front-face winding
   * its pipelines capture — which WebGPU does *not* validate.
   *
   * Equal keys mean a bundle recorded then is compatible with, and correct for, the pass now;
   * different keys mean it has to be re-recorded before it is replayed. Comparing the two is
   * what {@link GpuEncoderSystem.isBundleValid} does.
   *
   * `colorMask` and `stencilMode` are deliberately left out, unlike the pipeline cache key: they
   * are ambient draw state a bundle bakes per-pipeline as it records, so their value at execute
   * time says nothing about whether the bundle is still good.
   */
  get bundleStateKey() {
    const e = this._depthStencilFormatData;
    return Oee(
      // normalize the raw sample count (1 or 4 — WebGPU's only renderable counts) to a
      // true single bit, so it cannot spill into the colorTargetCount field above it
      this._multisampleCount === 1 ? 0 : 1,
      this._colorTargetCount,
      e.index,
      // the same two flags getBundleDescriptor sets — keep them in step
      e.depth && this._depthReadOnly ? 1 : 0,
      e.stencil && this._stencilReadOnly ? 1 : 0,
      this._invertFrontFace ? 1 : 0,
      this._colorFormatId
    );
  }
  /**
   * Builds a `GPURenderBundleEncoderDescriptor` that matches the current render target
   * configuration (color formats, sample count, depth/stencil format, and which of its aspects
   * are read-only).
   * Used by {@link GpuEncoderSystem.beginBundle} to create a compatible render bundle encoder.
   * @returns A descriptor for creating a GPURenderBundleEncoder.
   */
  getBundleDescriptor() {
    const e = [];
    for (let s = 0; s < this._colorTargetCount; s++)
      e.push(this._colorFormat);
    const t = {
      colorFormats: e,
      sampleCount: this._multisampleCount
    }, i = this._depthStencilFormatData;
    return (i.depth || i.stencil) && (t.depthStencilFormat = this._depthStencilFormat, i.depth && this._depthReadOnly && (t.depthReadOnly = !0), i.stencil && this._stencilReadOnly && (t.stencilReadOnly = !0)), t;
  }
  setPipeline(e, t, i, s) {
    const o = this.getPipeline(e, t, i);
    s.setPipeline(o);
  }
  /**
   * Generates a key for the pipeline.advanced usage only.
   * @param geometry - The geometry to get the key for
   * @param program - The program to get the key for
   * @param state - The state to get the key for
   * @param topology - The topology to get the key for
   * @param overrides - The overrides to get the key for
   * @returns The key for the pipeline
   */
  getPipelineKey(e, t, i, s, o) {
    return e._layoutKey || (m0(e, t.attributeData), this._generateBufferKey(e)), e_(
      e._layoutKey,
      t._layoutKey,
      i.data,
      i._blendModeId,
      J2[s],
      o.id
    );
  }
  getPipeline(e, t, i, s, o) {
    e._layoutKey || (m0(e, t.attributeData), this._generateBufferKey(e)), s || (s = e.topology), o || (o = Ree);
    const r = e_(
      e._layoutKey,
      t._layoutKey,
      i.data,
      i._blendModeId,
      J2[s],
      o.id
    );
    let a = this._pipeCache.get(r);
    return a || (a = this._createPipeline(e, t, i, s, o), this._pipeCache.set(r, a)), a;
  }
  _createPipeline(e, t, i, s, o) {
    const r = this._gpu.device, a = this._createVertexBufferLayouts(e, t), l = this._renderer.state.getColorTargets(i, this._colorTargetCount, this._colorFormat), d = this._stencilMode === fn.RENDERING_MASK_ADD ? 0 : this._colorMask;
    for (let w = 0; w < l.length; w++)
      l[w].writeMask = d;
    const c = this._renderer.shader.getProgramData(t).pipeline, h = Object.keys(o.data).length > 0;
    let f = t.vertex.source, p = t.fragment.source, y;
    h && (this._renderer.limits.supportsOverrideConstants ? y = o.data : (f = Q2(f, o.data), p = Q2(p, o.data)));
    const v = {
      // TODO later check if its helpful to create..
      // layout,
      vertex: {
        module: this._getModule(f),
        entryPoint: t.vertex.entryPoint,
        constants: y,
        buffers: a
      },
      fragment: {
        module: this._getModule(p),
        entryPoint: t.fragment.entryPoint,
        targets: l,
        constants: y
      },
      primitive: {
        topology: s,
        // Mirror WebGL's split: `gl.cullFace` is left at its `BACK` default, so the back is always
        // the culled side. Taking this from `state.cullMode` instead folds the winding into *which
        // side* is culled — the same triangles survive, but `@builtin(front_facing)` then reports
        // the opposite of `gl_FrontFacing` for clockwise-wound geometry.
        cullMode: i.culling ? "back" : "none",
        // The winding is stated once, here, exactly as `gl.frontFace` does it. `flipY` inverts the
        // projection (see setRenderTarget), so inverting the winding alongside it makes the two
        // cancel and a front face stays a front face. Both flags are part of the pipeline cache key.
        frontFace: i.clockwiseFrontFace !== this._invertFrontFace ? "cw" : "ccw"
      },
      layout: c,
      multisample: {
        count: this._multisampleCount
      },
      // depthStencil,
      label: t.name ? `PIXI Pipeline (${t.name})` : "PIXI Pipeline"
    };
    if (this._depthStencilFormatData.depth || this._depthStencilFormatData.stencil) {
      const w = this._depthStencilFormatData;
      v.depthStencil = {
        ...this._stencilState,
        format: this._depthStencilFormat,
        depthWriteEnabled: w.depth ? i.depthMask && !this._depthReadOnly : !1,
        depthCompare: w.depth && i.depthTest ? "less" : "always"
      };
    }
    return r.createRenderPipeline(v);
  }
  _getModule(e) {
    return this._moduleCache[e] || this._createModule(e);
  }
  _createModule(e) {
    const t = this._gpu.device;
    return this._moduleCache[e] = t.createShaderModule({
      code: e
    }), this._moduleCache[e];
  }
  /**
   * Generates and caches a numeric layout key on the geometry based on its sorted attribute
   * descriptors (offset, format, stride, instancing). Geometries with identical attribute
   * layouts share the same key, enabling pipeline reuse.
   * @param geometry - The geometry to generate a layout key for.
   */
  _generateBufferKey(e) {
    const t = [];
    let i = 0;
    const s = Object.keys(e.attributes).sort();
    for (let r = 0; r < s.length; r++) {
      const a = e.attributes[s[r]];
      t[i++] = a.offset, t[i++] = a.format, t[i++] = a.stride, t[i++] = a.instance;
    }
    const o = t.join("|");
    return e._layoutKey = Ll(o, "geometry"), e._layoutKey;
  }
  _generateAttributeLocationsKey(e) {
    const t = [];
    let i = 0;
    const s = Object.keys(e.attributeData).sort();
    for (let r = 0; r < s.length; r++) {
      const a = e.attributeData[s[r]];
      t[i++] = a.location;
    }
    const o = t.join("|");
    return e._attributeLocationsKey = Ll(o, "programAttributes"), e._attributeLocationsKey;
  }
  /**
   * Returns the buffer names to bind, one per vertex buffer slot.
   * This is used to bind the correct buffer to the correct location in the shader.
   * @param geometry - The geometry where to get the buffer names
   * @param program - The program where to get the buffer names
   * @returns The buffer names, indexed by vertex buffer slot.
   */
  getBufferNamesToBind(e, t) {
    const i = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bindingNamesCache[i]) return this._bindingNamesCache[i];
    const s = this._createVertexBufferLayouts(e, t), o = [], r = t.attributeData;
    for (let a = 0; a < s.length; a++) {
      const d = Object.values(s[a].attributes)[0].shaderLocation;
      for (const c in r)
        if (r[c].location === d) {
          o[a] = c;
          break;
        }
    }
    return this._bindingNamesCache[i] = o, o;
  }
  _createVertexBufferLayouts(e, t) {
    t._attributeLocationsKey || this._generateAttributeLocationsKey(t);
    const i = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bufferLayoutsCache[i])
      return this._bufferLayoutsCache[i];
    const s = [];
    return e.buffers.forEach((o) => {
      var l;
      const r = {
        arrayStride: 0,
        stepMode: "vertex",
        attributes: []
      }, a = r.attributes;
      for (const d in t.attributeData) {
        const c = e.attributes[d];
        ((l = c.divisor) != null ? l : 1) !== 1 && dt(`Attribute ${d} has an invalid divisor value of '${c.divisor}'. WebGPU only supports a divisor value of 1`), c.buffer === o && (r.arrayStride = c.stride, r.stepMode = c.instance ? "instance" : "vertex", a.push({
          shaderLocation: t.attributeData[d].location,
          offset: c.offset,
          format: c.format
        }));
      }
      a.length && s.push(r);
    }), this._bufferLayoutsCache[i] = s, s;
  }
  _updatePipeHash() {
    var i;
    var e;
    const t = Dee(
      this._stencilMode,
      // normalize the raw sample count (1 or 4 — WebGPU's only renderable counts) to a
      // true single bit, so it cannot spill into the colorTargetCount field above it
      this._multisampleCount === 1 ? 0 : 1,
      this._colorMask,
      this._colorTargetCount,
      this._depthStencilFormatData.index,
      this._colorFormatId,
      this._depthReadOnly ? 1 : 0,
      this._invertFrontFace ? 1 : 0
    );
    this._pipeCache = (i = (e = this._pipeStateCaches)[t]) != null ? i : e[t] = /* @__PURE__ */ new Map();
  }
  destroy() {
    this._bufferLayoutsCache = null, this._pipeCache = null, this._gpu = null, this._renderer = null, this._bindingNamesCache = null, this._pipeStateCaches = null, this._moduleCache = null;
  }
}
vC.extension = {
  type: [Ae.WebGPUSystem],
  name: "pipeline"
};
class Lee {
  constructor(e) {
    this._pipelines = /* @__PURE__ */ Object.create(null), this._modules = /* @__PURE__ */ Object.create(null), this._bindGroups = /* @__PURE__ */ new WeakMap(), this._renderer = e, this._device = e.gpu.device, this._layout = this._device.createBindGroupLayout({
      entries: [{
        binding: 0,
        visibility: GPUShaderStage.FRAGMENT,
        texture: { sampleType: "unfilterable-float" }
      }]
    }), this._pipelineLayout = this._device.createPipelineLayout({ bindGroupLayouts: [this._layout] });
  }
  /**
   * Copies one colour attachment's resolved image into the target's back texture, creating it on first use
   * at the attachment's size and format. Must be recorded outside a render pass.
   * @param commandEncoder - the encoder to record the copy on
   * @param renderTarget - the target being reopened
   * @param index - the colour attachment to copy
   * @param resolved - the attachment's resolved texture
   */
  copy(e, t, i, s) {
    var d;
    var o;
    const r = this._renderer.renderTarget.getGpuRenderTarget(t), a = t.colorAttachments[i].texture;
    (d = (o = r.msaaBackTextures)[i]) != null || (o[i] = new un({
      label: "msaa-back-texture",
      width: a.width,
      height: a.height,
      resolution: a._resolution,
      format: r.msaaTextures[i].format,
      autoGenerateMipmaps: !1,
      // every restore copies into it afresh, so an idle one can be freed and re-created on the next restore
      autoGarbageCollect: !0
    }));
    const l = this._renderer.texture.getGpuSource(r.msaaBackTextures[i]);
    e.copyTextureToTexture(
      { texture: s },
      { texture: l },
      { width: Math.min(s.width, l.width), height: Math.min(s.height, l.height) }
    );
  }
  /**
   * Draws one colour attachment's back texture into the multisampled buffer. Must be the first draw of the
   * pass, before any viewport or scissor is set.
   * @param pass - the pass that was just begun
   * @param renderTarget - the target the pass renders to
   * @param index - the colour attachment to restore, copied by {@link GpuMsaaRestore.copy}
   */
  draw(e, t, i) {
    var c, h, f, p;
    var s;
    const o = this._renderer.renderTarget.getGpuRenderTarget(t), r = this._renderer.texture.getGpuSource(o.msaaBackTextures[i]);
    let a = (h = (c = t.depthStencilAttachment) == null ? void 0 : c.texture.format) != null ? h : "";
    for (const y of t.colorAttachments)
      a += `|${y.texture.format}`;
    const l = (f = (s = this._pipelines)[a]) != null ? f : s[a] = [];
    let d = this._bindGroups.get(r);
    d || (d = this._device.createBindGroup({
      layout: this._layout,
      entries: [{ binding: 0, resource: r.createView() }]
    }), this._bindGroups.set(r, d)), e.setPipeline((p = l[i]) != null ? p : l[i] = this._createPipeline(t, i)), e.setBindGroup(0, d), e.draw(3);
  }
  _getModule(e) {
    var i;
    var t;
    return (i = (t = this._modules)[e]) != null || (t[e] = this._device.createShaderModule({
      label: "msaa-restore",
      code: (
        /* wgsl */
        `
                @group(0) @binding(0) var resolved: texture_2d<f32>;

                @vertex
                fn vertexMain(@builtin(vertex_index) i: u32) -> @builtin(position) vec4<f32> {
                    let pos = array<vec2<f32>, 3>(vec2<f32>(-1.0, -1.0), vec2<f32>(3.0, -1.0), vec2<f32>(-1.0, 3.0));

                    return vec4<f32>(pos[i], 0.0, 1.0);
                }

                @fragment
                fn fragmentMain(@builtin(position) position: vec4<f32>) -> @location(${e}) vec4<f32> {
                    return textureLoad(resolved, vec2<i32>(position.xy), 0);
                }
            `
      )
    })), this._modules[e];
  }
  _createPipeline(e, t) {
    var r;
    const i = (r = e.depthStencilAttachment) == null ? void 0 : r.texture.format;
    let s;
    i && (s = { format: i }, i.includes("depth") && (s.depthWriteEnabled = !1, s.depthCompare = "always"));
    const o = this._getModule(t);
    return this._device.createRenderPipeline({
      label: "msaa-restore",
      layout: this._pipelineLayout,
      vertex: { module: o, entryPoint: "vertexMain" },
      fragment: {
        module: o,
        entryPoint: "fragmentMain",
        // every attachment must be declared to match the pass; only the restored one is written
        targets: e.colorAttachments.map((a, l) => ({
          format: a.texture.format,
          writeMask: l === t ? GPUColorWrite.ALL : 0
        }))
      },
      depthStencil: s,
      multisample: { count: 4 }
    });
  }
}
class Bee {
  constructor() {
    this.contexts = [], this.canvasTextures = [], this.msaaTextures = [], this.transient = !1, this.msaaSamples = 1, this.msaaBackTextures = [], this.stencilMode = fn.DISABLED, this.stencilReference = 0, this.maskStackIndex = 0;
  }
}
const Fee = {
  bgra8unorm: !0,
  rgba8unorm: !0,
  rgba16float: !0
};
function Nee(n) {
  if (Fee[n]) return n;
  const e = navigator.gpu.getPreferredCanvasFormat();
  return dt(`[WebGPU] CanvasSource format '${n}' is not a valid GPUCanvasContext format. Falling back to '${e}'. Allowed formats are: bgra8unorm, rgba8unorm, rgba16float.`), e;
}
class Uee {
  constructor() {
    this._activePass = null;
  }
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t, e.runners.contextChange.add(this), e.runners.destroy.add(this);
  }
  /** Drops the restore helper, whose pipelines belong to the old device. The next restore makes a new one. */
  contextChange() {
    this._msaaRestore = null;
  }
  destroy() {
    this._msaaRestore = null;
  }
  copyToTexture(e, t, i, s, o) {
    const r = this._renderer;
    this.finishRenderPass();
    const a = this._getGpuColorTexture(
      e
    ), l = r.texture.getGpuSource(
      t.source
    );
    return r.encoder.commandEncoder.copyTextureToTexture(
      {
        texture: a,
        origin: i
      },
      {
        texture: l,
        origin: o
      },
      s
    ), t;
  }
  copyDepthTexture(e, t, i, s, o) {
    const r = this._renderer;
    this.finishRenderPass();
    const a = e.depthStencilAttachment.texture, l = r.texture.getGpuSource(a), d = r.texture.getGpuSource(t.source), c = r.encoder.commandEncoder === null, h = c ? r.gpu.device.createCommandEncoder() : r.encoder.commandEncoder;
    h.copyTextureToTexture(
      { texture: l, origin: i },
      { texture: d, origin: o },
      { width: s.width, height: s.height }
    ), c && r.gpu.device.queue.submit([h.finish()]);
  }
  startRenderPass(e, t = !0, i, s, o = 0, r = 0) {
    var x, w;
    const l = this._renderTargetSystem.getGpuRenderTarget(e);
    if (r !== 0 && ((x = l.msaaTextures) != null && x.length))
      throw new Error("[RenderTargetSystem] Rendering to array layers is not supported with MSAA render targets.");
    if (o > 0 && ((w = l.msaaTextures) != null && w.length))
      throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
    let d = t;
    typeof d == "boolean" && (d = d ? Tn.ALL : Tn.NONE), (e.stencil || e.depth) && !e.depthStencilAttachment && e.ensureDepthStencilTexture();
    const c = !!e.depthStencilAttachment, h = this._activePass, f = h !== null && h.renderTarget === e && h.mipLevel === o && h.layer === r && h.depthStencil === c && this._renderer.encoder.renderPassEncoder !== null && d === Tn.NONE;
    if (this._renderer.pipeline.setRenderTarget(e), f) {
      this._renderer.encoder.setViewport(s);
      return;
    }
    const { descriptor: p, restore: y } = this._buildDescriptor(e, t, i, o, r);
    l.descriptor = p;
    const v = this._renderer.encoder;
    y ? (v.endRenderPass(), this._beginRestoredPass(
      e,
      y,
      v.commandEncoder,
      () => v.beginRenderPass(l)
    )) : v.beginRenderPass(l), v.setViewport(s), this._activePass = { renderTarget: e, mipLevel: o, layer: r, depthStencil: c };
  }
  finishRenderPass() {
    this._renderer.encoder.endRenderPass(), this._activePass = null;
  }
  /**
   * Begins a pass whose MSAA colour must be restored: copies each resolved texture in `restore` into the
   * target's back textures, begins the pass, and draws them back in before anything else (see GpuMsaaRestore).
   * @param renderTarget - the target being reopened
   * @param restore - the colour attachments to restore
   * @param commandEncoder - the encoder to record the copies on, with no pass open
   * @param beginPass - begins the pass on the same encoder
   * @returns the begun pass
   */
  _beginRestoredPass(e, t, i, s) {
    var a;
    const o = (a = this._msaaRestore) != null ? a : this._msaaRestore = new Lee(this._renderer);
    for (const l of t)
      o.copy(i, e, l, this._getGpuColorTexture(e, l));
    const r = s();
    for (const l of t)
      o.draw(r, e, l);
    return r;
  }
  /**
   * returns the gpu texture for a color texture in the render target, the first by default
   * mainly used by the filter manager to copy the texture for blending
   * @param renderTarget
   * @param index - the color attachment to get
   * @returns a gpu texture
   */
  _getGpuColorTexture(e, t = 0) {
    if (e.colorAttachments.length === 0)
      throw new Error("[GpuRenderTargetAdaptor] cannot get gpu color texture from a depth-only render target");
    const i = e.colorAttachments[t].texture;
    return i instanceof Ai && i._gpuContext ? i._gpuContext.getCurrentTexture() : this._renderer.texture.getGpuSource(i);
  }
  getDescriptor(e, t, i, s = 0, o = 0) {
    return this._buildDescriptor(e, t, i, s, o).descriptor;
  }
  /**
   * Builds the pass descriptor, along with the MSAA colour attachments it opens with `clear` in place of
   * `load`. Those buffers were discarded, so the pass must restore them before drawing.
   * @param renderTarget - the target to render to
   * @param clear - what to clear
   * @param clearValue - the colour to clear to
   * @param mipLevel - the mip level to render to
   * @param layer - the array layer to render to
   */
  _buildDescriptor(e, t, i, s = 0, o = 0) {
    var f, p, y, v, x, w, S, M;
    let r = null;
    typeof t == "boolean" && (t = t ? Tn.ALL : Tn.NONE);
    const a = this._renderTargetSystem, l = a.getGpuRenderTarget(e), d = e.colorAttachments.map(
      (_, T) => {
        var N, K;
        const k = _.texture, P = k instanceof Ai ? k._gpuContext : null;
        let A, R, D = !1;
        if (P) {
          if (o !== 0)
            throw new Error("[RenderTargetSystem] Rendering to array layers is not supported for canvas targets.");
          const B = P.getCurrentTexture();
          D = l.canvasTextures[T] !== B, l.canvasTextures[T] = B, A = B.createView(_.viewDescriptor);
        } else
          A = this._renderer.texture.getTextureRenderTargetView(
            _.texture,
            s,
            o,
            _.viewDescriptor
          );
        const O = l.msaaTextures[T];
        O && (R = A, A = this._renderer.texture.getTextureView(O));
        let F = _.loadOp;
        t !== void 0 && (F = t & Tn.COLOR ? "clear" : "load"), i != null || (i = a.defaultClearColor);
        const ie = !!(O != null && O.transient), ee = ie && F !== "clear", me = ee && !D;
        ee && (F = "clear", me && (r != null ? r : r = []).push(T));
        const L = {
          view: A,
          resolveTarget: R,
          storeOp: ie ? "discard" : (N = _.storeOp) != null ? N : "store",
          loadOp: F
        };
        k.dimension === "3d" && (L.depthSlice = o), ee ? L.clearValue = [0, 0, 0, 0] : F === "clear" && (i != null || (i = (K = _.clearValue) != null ? K : a.defaultClearColor), L.clearValue = i);
        for (const B in _)
          B !== "texture" && B !== "viewDescriptor" && B !== "clearValue" && B !== "loadOp" && B !== "storeOp" && (L[B] = _[B]);
        return L;
      }
    );
    let c;
    if (e.depthStencilAttachment) {
      this._prepareDepthStencil(e, l);
      const _ = e.depthStencilAttachment, T = _.texture.format.includes("stencil"), k = _.texture.format.includes("depth"), P = l.transient ? "discard" : "store", A = l.transient ? "clear" : "load";
      c = {
        view: this._renderer.texture.getTextureRenderTargetView(
          _.texture,
          s,
          o,
          _.viewDescriptor
        )
      };
      const R = (f = _.depthReadOnly) != null ? f : !1, D = (p = _.stencilReadOnly) != null ? p : R;
      T && !D ? (c.stencilLoadOp = t & Tn.STENCIL ? "clear" : (y = _.stencilLoadOp) != null ? y : A, c.stencilStoreOp = (v = _.stencilStoreOp) != null ? v : P, c.stencilLoadOp === "clear" && (c.stencilClearValue = (x = _.stencilClearValue) != null ? x : 0)) : T && D && (c.stencilReadOnly = !0), k && !R ? (c.depthLoadOp = t & Tn.DEPTH ? "clear" : (w = _.depthLoadOp) != null ? w : A, c.depthStoreOp = (S = _.depthStoreOp) != null ? S : P, c.depthLoadOp === "clear" && (c.depthClearValue = (M = _.depthClearValue) != null ? M : 1)) : k && R && (c.depthReadOnly = !0);
      for (const O in _)
        O !== "texture" && O !== "viewDescriptor" && O !== "stencilLoadOp" && O !== "stencilStoreOp" && O !== "stencilClearValue" && O !== "stencilReadOnly" && O !== "depthLoadOp" && O !== "depthStoreOp" && O !== "depthClearValue" && O !== "depthReadOnly" && (c[O] = _[O]);
    }
    return { descriptor: {
      colorAttachments: d,
      depthStencilAttachment: c,
      label: e.label
    }, restore: r };
  }
  clear(e, t = !0, i, s, o = 0, r = 0) {
    if (!t) return;
    const { gpu: a, encoder: l } = this._renderer, d = a.device;
    if (l.commandEncoder === null) {
      const h = d.createCommandEncoder(), { descriptor: f, restore: p } = this._buildDescriptor(e, t, i, o, r), y = () => h.beginRenderPass(f), v = p ? this._beginRestoredPass(e, p, h, y) : y();
      v.setViewport(s.x, s.y, s.width, s.height, 0, 1), v.end();
      const x = h.finish();
      d.queue.submit([x]);
    } else
      this.startRenderPass(e, t, i, s, o, r);
  }
  initGpuRenderTarget(e) {
    var i;
    e.isRoot = !0;
    const t = new Bee();
    return t.transient = !!((i = e.colorTexture) != null && i.antialias) && !!e.colorTexture.transient, e.colorAttachments.forEach((s, o) => {
      var a;
      const r = s.texture;
      if (r instanceof Ai) {
        const l = (a = r._gpuContext) != null ? a : r._gpuContext = r.resource.getContext(
          "webgpu"
        ), d = r.transparent ? "premultiplied" : "opaque", c = Nee(r.format);
        try {
          l.configure({
            device: this._renderer.gpu.device,
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
            format: c,
            alphaMode: d,
            ...c === "rgba16float" ? { toneMapping: { mode: "extended" } } : {}
          });
        } catch (h) {
          console.error(h);
        }
        t.contexts[o] = l;
      }
      if (t.msaa = r.source.antialias, r.antialias) {
        const l = new un({
          width: 0,
          height: 0,
          sampleCount: 4,
          // WebGPU requires multisampled textures to have exactly 1 mip level, so this must never
          // inherit TextureSource.defaultOptions.autoGenerateMipmaps
          autoGenerateMipmaps: !1,
          transient: this._renderer.device.extensions.tileBased || t.transient,
          arrayLayerCount: r.arrayLayerCount,
          format: r.format
        });
        t.msaaTextures[o] = l;
      }
    }), t.msaa && (t.msaaSamples = 4), t;
  }
  /**
   * Sets up a depth/stencil texture for an MSAA target before its GPU texture is created: 4 samples, and
   * the transient usage bit when the user marked the target single-pass. Both are fixed at creation, so this
   * runs when a pass descriptor is built, just before the depth/stencil view is first made.
   * @param renderTarget - the target whose depth/stencil texture to set up
   * @param gpuRenderTarget - its backend target
   */
  _prepareDepthStencil(e, t) {
    var s;
    const i = (s = e.depthStencilAttachment) == null ? void 0 : s.texture;
    !i || !t.msaa || (i.sampleCount = 4, i.transient = t.transient);
  }
  destroyGpuRenderTarget(e) {
    e.contexts.forEach((t) => {
      t.unconfigure();
    }), e.msaaTextures.forEach((t) => {
      t.destroy();
    }), e.msaaBackTextures.forEach((t) => {
      t == null || t.destroy();
    }), e.msaaTextures.length = 0, e.msaaBackTextures.length = 0, e.contexts.length = 0;
  }
  ensureDepthStencilTexture(e) {
    this._prepareDepthStencil(e, this._renderTargetSystem.getGpuRenderTarget(e));
  }
  resizeGpuRenderTarget(e) {
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    t.width = e.width, t.height = e.height, t.msaa && e.colorAttachments.forEach((i, s) => {
      var r, a;
      const o = i.texture;
      (r = t.msaaTextures[s]) == null || r.resize(o.width, o.height, o._resolution), (a = t.msaaBackTextures[s]) == null || a.resize(
        o.width,
        o.height,
        o._resolution
      );
    });
  }
}
class yC extends Ly {
  constructor(e) {
    super(e), this.adaptor = new Uee(), this.adaptor.init(e, this);
  }
}
yC.extension = {
  type: [Ae.WebGPUSystem],
  name: "renderTarget"
};
class xC {
  constructor() {
    this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  contextChange(e) {
    this._gpu = e, this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  getProgramData(e) {
    return this._gpuProgramData[e._layoutKey] || this._createGPUProgramData(e);
  }
  _createGPUProgramData(e) {
    const t = this._gpu.device, i = e.gpuLayout.map((o) => t.createBindGroupLayout({ entries: o })), s = { bindGroupLayouts: i };
    return this._gpuProgramData[e._layoutKey] = {
      bindGroups: i,
      pipeline: t.createPipelineLayout(s)
    }, this._gpuProgramData[e._layoutKey];
  }
  destroy() {
    this._gpu = null, this._gpuProgramData = null;
  }
}
xC.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "shader"
};
const mi = {};
mi.normal = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
mi.add = {
  alpha: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  }
};
mi.multiply = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "dst",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
mi.screen = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.overlay = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.none = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "zero",
    operation: "add"
  }
};
mi["normal-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
mi["add-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one",
    operation: "add"
  }
};
mi["screen-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.erase = {
  alpha: {
    srcFactor: "zero",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.min = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  }
};
mi.max = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  }
};
class wC {
  constructor() {
    this.defaultState = new co(), this.defaultState.blend = !0;
  }
  contextChange(e) {
    this.gpu = e;
  }
  /**
   * Gets the blend mode data for the current state
   * @param state - The state to get the blend mode from
   * @param count - The number of color targets to create
   * @param format - The texture format of the color attachments (assumed uniform across attachments)
   */
  getColorTargets(e, t, i) {
    const s = e.blend ? mi[e.blendMode] || mi.normal : void 0, o = [];
    for (let r = 0; r < t; r++)
      o[r] = {
        format: i,
        writeMask: 0,
        blend: s
      };
    return o;
  }
  destroy() {
    this.gpu = null;
  }
}
wC.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "state"
};
const i_ = [new Tt(), new Tt(), new Tt()], Gee = {
  type: "image",
  upload(n, e, t, i = 0) {
    const s = n.resource, o = n.pixelWidth | 0, r = n.pixelHeight | 0, a = n.depthOrArrayLayers, l = s.byteLength / (o * r * a);
    if (a > 1) {
      t.device.queue.writeTexture(
        { texture: e, origin: { x: 0, y: 0, z: i } },
        s,
        { offset: 0, rowsPerImage: r, bytesPerRow: o * l },
        { width: o, height: r, depthOrArrayLayers: a }
      );
      return;
    }
    const d = eC(n._updateStart, n._updateEnd, o, r, i_);
    for (let c = 0; c < d; c++) {
      const h = i_[c];
      t.device.queue.writeTexture(
        { texture: e, origin: { x: h.x, y: h.y, z: i } },
        s,
        {
          offset: (h.y * o + h.x) * l,
          rowsPerImage: h.height,
          bytesPerRow: o * l
        },
        {
          width: h.width,
          height: h.height,
          depthOrArrayLayers: 1
        }
      );
    }
  }
}, kC = {
  "bc1-rgba-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "bc2-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc3-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc7-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "etc1-rgb-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "etc2-rgba8unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "astc-4x4-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 }
}, jee = { blockBytes: 4, blockWidth: 1, blockHeight: 1 }, Hee = {
  type: "compressed",
  upload(n, e, t, i = 0) {
    let s = n.pixelWidth, o = n.pixelHeight;
    const r = kC[n.format] || jee;
    for (let a = 0; a < n.resource.length; a++) {
      const l = n.resource[a], d = Math.ceil(s / r.blockWidth) * r.blockBytes;
      t.device.queue.writeTexture(
        {
          texture: e,
          mipLevel: a,
          origin: { x: 0, y: 0, z: i }
        },
        l,
        {
          offset: 0,
          bytesPerRow: d
        },
        {
          width: Math.ceil(s / r.blockWidth) * r.blockWidth,
          height: Math.ceil(o / r.blockHeight) * r.blockHeight,
          depthOrArrayLayers: 1
        }
      ), s = Math.max(s >> 1, 1), o = Math.max(o >> 1, 1);
    }
  }
}, s_ = ["right", "left", "top", "bottom", "front", "back"];
function Vee(n) {
  return {
    type: "cube",
    upload(e, t, i) {
      const s = e.faces;
      for (let o = 0; o < s_.length; o++) {
        const r = s_[o], a = s[r];
        (n[a.uploadMethodId] || n.image).upload(a, t, i, o);
      }
    }
  };
}
const _C = {
  type: "image",
  upload(n, e, t, i = 0) {
    const s = n.resource;
    if (!s) return;
    if (globalThis.HTMLImageElement && s instanceof HTMLImageElement) {
      const l = zt.get().createCanvas(s.width, s.height);
      l.getContext("2d").drawImage(s, 0, 0, s.width, s.height), n.resource = l, dt("ImageSource: Image element passed, converting to canvas and replacing resource.");
    }
    const o = Math.min(e.width, n.resourceWidth || n.pixelWidth), r = Math.min(e.height, n.resourceHeight || n.pixelHeight), a = n.alphaMode === "premultiply-alpha-on-upload";
    t.device.queue.copyExternalImageToTexture(
      { source: s },
      { texture: e, origin: { x: 0, y: 0, z: i }, premultipliedAlpha: a },
      {
        width: o,
        height: r
      }
    );
  }
}, Wee = {
  type: "video",
  upload(n, e, t, i) {
    _C.upload(n, e, t, i);
  }
}, o_ = ["rgba8unorm", "rgba16float"], za = 4;
function SC(n, e) {
  if (!e)
    throw new Error("[Gpu3dMipmapGenerator] generating mipmaps for a 3D texture needs storage: true.");
  if (!o_.includes(n))
    throw new Error(`[Gpu3dMipmapGenerator] format '${n}' can't be downsampled. Use ${o_.join(", ")}.`);
}
class qee {
  constructor(e) {
    this._pipelines = {}, this._device = e, this._sampler = e.createSampler({
      magFilter: "linear",
      minFilter: "linear"
    });
  }
  _getMipmapPipeline(e) {
    var i;
    var t;
    return (i = (t = this._pipelines)[e]) != null || (t[e] = this._device.createComputePipeline({
      layout: "auto",
      compute: {
        module: this._device.createShaderModule({
          code: (
            /* wgsl */
            `
                        @group(0) @binding(0) var srcSampler : sampler;
                        @group(0) @binding(1) var src : texture_3d<f32>;
                        @group(0) @binding(2) var dst : texture_storage_3d<${e}, write>;

                        @compute @workgroup_size(${za}, ${za}, ${za})
                        fn main(@builtin(global_invocation_id) gid : vec3<u32>) {
                            let dstSize = textureDimensions(dst);

                            if (gid.x >= dstSize.x || gid.y >= dstSize.y || gid.z >= dstSize.z) {
                                return;
                            }

                            // centre of the 2x2x2 footprint in the previous mip. When a dimension is
                            // odd its last texel, row or slice is never sampled, as in the 2D generator
                            let uv = (vec3<f32>(gid) * 2.0 + 1.0) / vec3<f32>(textureDimensions(src));

                            textureStore(dst, gid, textureSampleLevel(src, srcSampler, uv, 0.0));
                        }
                    `
          )
        }),
        entryPoint: "main"
      }
    })), this._pipelines[e];
  }
  /**
   * Fills mip levels 1..n of a 3D texture from level 0.
   * @param texture - a 3D texture with `STORAGE_BINDING` and more than one mip level
   */
  generateMipmap(e) {
    if (e.dimension !== "3d")
      throw new Error("[Gpu3dMipmapGenerator] generateMipmap expects a 3D texture.");
    if (e.mipLevelCount < 2) return;
    SC(e.format, (e.usage & GPUTextureUsage.STORAGE_BINDING) !== 0);
    const t = this._getMipmapPipeline(e.format), i = t.getBindGroupLayout(0), s = this._device.createCommandEncoder({ label: "Gpu3dMipmapGenerator" }), o = s.beginComputePass();
    o.setPipeline(t);
    let r = e.width, a = e.height, l = e.depthOrArrayLayers, d = e.createView({ dimension: "3d", baseMipLevel: 0, mipLevelCount: 1 });
    for (let c = 1; c < e.mipLevelCount; c++) {
      r = Math.max(1, r >> 1), a = Math.max(1, a >> 1), l = Math.max(1, l >> 1);
      const h = e.createView({ dimension: "3d", baseMipLevel: c, mipLevelCount: 1 });
      o.setBindGroup(0, this._device.createBindGroup({
        layout: i,
        entries: [
          { binding: 0, resource: this._sampler },
          { binding: 1, resource: d },
          { binding: 2, resource: h }
        ]
      })), o.dispatchWorkgroups(
        Math.ceil(r / za),
        Math.ceil(a / za),
        Math.ceil(l / za)
      ), d = h;
    }
    o.end(), this._device.queue.submit([s.finish()]);
  }
}
class Kee {
  constructor(e) {
    this._pipelines = {}, this._device = e, this._sampler = e.createSampler({ minFilter: "linear" });
  }
  _getMipmapPipeline(e) {
    let t = this._pipelines[e];
    return t || (this._mipmapShaderModule || (this._mipmapShaderModule = this._device.createShaderModule({
      code: (
        /* wgsl */
        `
                        var<private> pos : array<vec2<f32>, 3> = array<vec2<f32>, 3>(
                        vec2<f32>(-1.0, -1.0), vec2<f32>(-1.0, 3.0), vec2<f32>(3.0, -1.0));

                        struct VertexOutput {
                        @builtin(position) position : vec4<f32>,
                        @location(0) texCoord : vec2<f32>,
                        };

                        @vertex
                        fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
                        var output : VertexOutput;
                        output.texCoord = pos[vertexIndex] * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5);
                        output.position = vec4<f32>(pos[vertexIndex], 0.0, 1.0);
                        return output;
                        }

                        @group(0) @binding(0) var imgSampler : sampler;
                        @group(0) @binding(1) var img : texture_2d<f32>;

                        @fragment
                        fn fragmentMain(@location(0) texCoord : vec2<f32>) -> @location(0) vec4<f32> {
                        return textureSample(img, imgSampler, texCoord);
                        }
                    `
      )
    })), t = this._device.createRenderPipeline({
      layout: "auto",
      vertex: {
        module: this._mipmapShaderModule,
        entryPoint: "vertexMain"
      },
      fragment: {
        module: this._mipmapShaderModule,
        entryPoint: "fragmentMain",
        targets: [{ format: e }]
      }
    }), this._pipelines[e] = t), t;
  }
  /**
   * Generates mipmaps for the given GPUTexture from the data in level 0.
   * @param {module:External.GPUTexture} texture - Texture to generate mipmaps for.
   * @returns {module:External.GPUTexture} - The originally passed texture
   */
  generateMipmap(e) {
    if (e.dimension === "3d")
      throw new Error("[GpuMipmapGenerator] a 3D texture uses Gpu3dMipmapGenerator.");
    if (e.dimension === "1d")
      throw new Error("Generating mipmaps for 1d textures is currently unsupported!");
    const t = this._getMipmapPipeline(e.format);
    let i = e;
    const s = e.depthOrArrayLayers || 1, o = e.usage & GPUTextureUsage.RENDER_ATTACHMENT;
    if (!o) {
      const l = {
        size: {
          width: Math.ceil(e.width / 2),
          height: Math.ceil(e.height / 2),
          depthOrArrayLayers: s
        },
        format: e.format,
        usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT,
        mipLevelCount: e.mipLevelCount - 1
      };
      i = this._device.createTexture(l);
    }
    const r = this._device.createCommandEncoder({}), a = t.getBindGroupLayout(0);
    for (let l = 0; l < s; ++l) {
      let d = e.createView({
        baseMipLevel: 0,
        mipLevelCount: 1,
        dimension: "2d",
        baseArrayLayer: l,
        arrayLayerCount: 1
      }), c = o ? 1 : 0;
      for (let h = 1; h < e.mipLevelCount; ++h) {
        const f = i.createView({
          baseMipLevel: c++,
          mipLevelCount: 1,
          dimension: "2d",
          baseArrayLayer: l,
          arrayLayerCount: 1
        }), p = r.beginRenderPass({
          colorAttachments: [{
            view: f,
            storeOp: "store",
            loadOp: "clear",
            clearValue: { r: 0, g: 0, b: 0, a: 0 }
          }]
        }), y = this._device.createBindGroup({
          layout: a,
          entries: [{
            binding: 0,
            resource: this._sampler
          }, {
            binding: 1,
            resource: d
          }]
        });
        p.setPipeline(t), p.setBindGroup(0, y), p.draw(3, 1, 0, 0), p.end(), d = f;
      }
    }
    if (!o) {
      const l = {
        width: Math.ceil(e.width / 2),
        height: Math.ceil(e.height / 2),
        depthOrArrayLayers: s
      };
      for (let d = 1; d < e.mipLevelCount; ++d)
        r.copyTextureToTexture({
          texture: i,
          mipLevel: d - 1
        }, {
          texture: e,
          mipLevel: d
        }, l), l.width = Math.ceil(l.width / 2), l.height = Math.ceil(l.height / 2);
    }
    return this._device.queue.submit([r.finish()]), o || i.destroy(), e;
  }
}
class Yee {
  constructor(e) {
    this.textureView = null, this.textureViews = /* @__PURE__ */ Object.create(null), this.gpuTexture = e;
  }
  /** Destroys this GPU data instance. */
  destroy() {
    this.gpuTexture.destroy(), this.textureView = null, this.textureViews = null, this.gpuTexture = null;
  }
}
const Xee = /^(rgba8|bgra8|bc[1237]-rgba-|etc2-rgb8|etc2-rgb8a1|etc2-rgba8|astc-\d+x\d+-)unorm$/;
function Jee(n) {
  return Xee.test(n) ? [`${n}-srgb`] : void 0;
}
function r_(n) {
  return `${n.format || ""}.${n.dimension || ""}.${n.aspect || ""}.${n.baseMipLevel || 0}.${n.mipLevelCount || ""}.${n.baseArrayLayer || 0}.${n.arrayLayerCount || ""}`;
}
const jy = class MC {
  constructor(e) {
    this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._renderer = e, e.gc.addCollection(this, "_bindGroupHash", "hash"), this._managedTextures = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onSourceUnload.bind(this),
      name: "gpuTextureSource"
    });
    const t = {
      image: _C,
      buffer: Gee,
      video: Wee,
      compressed: Hee,
      ...MC.uploadExtensions
    };
    this._uploads = {
      ...t,
      cube: Vee(t)
    };
  }
  /**
   * @deprecated since 8.15.0
   */
  get managedTextures() {
    return Object.values(this._managedTextures.items);
  }
  contextChange(e) {
    this._gpu = e, this._managedTextures.removeAll(), this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._mipmapGenerator = null, this._mipmap3dGenerator = null;
  }
  /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */
  initSource(e) {
    var t;
    return ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuTexture) || this._initSource(e);
  }
  _initSource(e) {
    if (e.autoGenerateMipmaps) {
      e.dimension === "3d" && SC(e.format, e.storage);
      const c = Math.max(e.pixelWidth, e.pixelHeight, e.depth);
      e.mipLevelCount = Math.floor(Math.log2(c)) + 1;
    }
    let t, i;
    e.sampleCount > 1 ? (t = GPUTextureUsage.RENDER_ATTACHMENT, e.transient && this._renderer.device.extensions.transientAttachment && (t |= GPUTextureUsage.TRANSIENT_ATTACHMENT)) : (t = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST, e.uploadMethodId !== "compressed" && (t |= GPUTextureUsage.RENDER_ATTACHMENT, t |= GPUTextureUsage.COPY_SRC), e.storage && (t |= GPUTextureUsage.STORAGE_BINDING), i = Jee(e.format));
    const s = kC[e.format] || { blockWidth: 1, blockHeight: 1 }, o = Math.ceil(e.pixelWidth / s.blockWidth) * s.blockWidth, r = Math.ceil(e.pixelHeight / s.blockHeight) * s.blockHeight, a = {
      label: e.label,
      // WebGPU cube textures are 2D textures with 6 array layers and a cube view.
      size: { width: o, height: r, depthOrArrayLayers: e.depthOrArrayLayers },
      format: e.format,
      viewFormats: i,
      sampleCount: e.sampleCount,
      mipLevelCount: e.mipLevelCount,
      dimension: e.dimension,
      usage: t
    }, l = this._gpu.device.createTexture(a);
    return e._gpuData[this._renderer.uid] = new Yee(l), this._managedTextures.add(e) && (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceResize, this), e.on("updateMipmaps", this.onUpdateMipmaps, this)), this.onSourceUpdate(e), l;
  }
  onSourceUpdate(e) {
    const t = this.getGpuSource(e);
    t && (this._uploads[e.uploadMethodId] && this._uploads[e.uploadMethodId].upload(e, t, this._gpu), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e));
  }
  onUpdateMipmaps(e) {
    var i, s;
    const t = this.getGpuSource(e);
    if (e.dimension === "3d") {
      (i = this._mipmap3dGenerator) != null || (this._mipmap3dGenerator = new qee(this._gpu.device)), this._mipmap3dGenerator.generateMipmap(t);
      return;
    }
    (s = this._mipmapGenerator) != null || (this._mipmapGenerator = new Kee(this._gpu.device)), this._mipmapGenerator.generateMipmap(t);
  }
  onSourceUnload(e) {
    e.off("update", this.onSourceUpdate, this), e.off("resize", this.onSourceResize, this), e.off("updateMipmaps", this.onUpdateMipmaps, this);
  }
  onSourceResize(e) {
    e._gcLastUsed = this._renderer.gc.now;
    const t = e._gpuData[this._renderer.uid], i = t == null ? void 0 : t.gpuTexture;
    i ? (i.width !== e.pixelWidth || i.height !== e.pixelHeight) && (t.destroy(), this._bindGroupHash[e.uid] = null, e._gpuData[this._renderer.uid] = null, this.initSource(e)) : this.initSource(e);
  }
  _initSampler(e) {
    return this._gpuSamplers[e._resourceId] = this._gpu.device.createSampler(e), this._gpuSamplers[e._resourceId];
  }
  getGpuSampler(e) {
    return this._gpuSamplers[e._resourceId] || this._initSampler(e);
  }
  getGpuSource(e) {
    var t;
    return e._gcLastUsed = this._renderer.gc.now, ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuTexture) || this.initSource(e);
  }
  /**
   * this returns s bind group for a specific texture, the bind group contains
   * - the texture source
   * - the texture style
   * - the texture matrix
   * This is cached so the bind group should only be created once per texture
   * @param texture - the texture you want the bindgroup for
   * @returns the bind group for the texture
   */
  getTextureBindGroup(e) {
    return this._bindGroupHash[e.uid] || this._createTextureBindGroup(e);
  }
  _createTextureBindGroup(e) {
    const t = e.source;
    return this._bindGroupHash[e.uid] = new qo({
      0: t,
      1: t.style,
      2: new Ts({
        uTextureMatrix: { type: "mat3x3<f32>", value: e.textureMatrix.mapCoord }
      })
    }), this._bindGroupHash[e.uid];
  }
  getTextureView(e, t) {
    var i;
    const s = e.source;
    s._gcLastUsed = this._renderer.gc.now;
    let o = s._gpuData[this._renderer.uid];
    o || (this.initSource(s), o = s._gpuData[this._renderer.uid]);
    const r = t ? r_(t) : 0;
    return (i = o.textureViews)[r] || (i[r] = o.gpuTexture.createView({
      dimension: s.viewDimension,
      ...t
    })), o.textureViews[r];
  }
  getTextureRenderTargetView(e, t = 0, i = 0, s) {
    var o;
    const r = e.source;
    r._gcLastUsed = this._renderer.gc.now;
    let a = r._gpuData[this._renderer.uid];
    a || (this.initSource(r), a = r._gpuData[this._renderer.uid]);
    const l = r.dimension === "3d";
    l && (i = 0);
    let d = i * (r.mipLevelCount || 1) + t + 1;
    return s && (d = `${d}.${r_(s)}`), (o = a.textureViews)[d] || (o[d] = a.gpuTexture.createView({
      dimension: l ? "3d" : "2d",
      baseMipLevel: t,
      mipLevelCount: 1,
      baseArrayLayer: i,
      arrayLayerCount: 1,
      ...s
    })), a.textureViews[d];
  }
  generateCanvas(e) {
    const t = this._renderer, i = t.gpu.device.createCommandEncoder(), s = zt.get().createCanvas();
    s.width = e.source.pixelWidth, s.height = e.source.pixelHeight;
    const o = s.getContext("webgpu");
    return o.configure({
      device: t.gpu.device,
      usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC,
      format: zt.get().getNavigator().gpu.getPreferredCanvasFormat(),
      alphaMode: "premultiplied"
    }), i.copyTextureToTexture({
      texture: t.texture.getGpuSource(e.source),
      origin: {
        x: 0,
        y: 0
      }
    }, {
      texture: o.getCurrentTexture()
    }, {
      width: s.width,
      height: s.height
    }), t.gpu.device.queue.submit([i.finish()]), s;
  }
  getPixels(e) {
    const t = this.generateCanvas(e), i = Fl.getOptimalCanvasAndContext(t.width, t.height), s = i.context;
    s.drawImage(t, 0, 0);
    const { width: o, height: r } = t, a = s.getImageData(0, 0, o, r), l = new Uint8ClampedArray(a.data.buffer);
    return Fl.returnCanvasAndContext(i), { pixels: l, width: o, height: r };
  }
  destroy() {
    this._managedTextures.destroy();
    for (const e of Object.keys(this._bindGroupHash)) {
      const t = Number(e), i = this._bindGroupHash[t];
      i == null || i.destroy();
    }
    this._renderer = null, this._gpu = null, this._mipmapGenerator = null, this._mipmap3dGenerator = null, this._gpuSamplers = null, this._bindGroupHash = null;
  }
};
jy.extension = {
  type: [
    Ae.WebGPUSystem
  ],
  name: "texture"
};
jy.uploadExtensions = /* @__PURE__ */ Object.create(null);
let TC = jy;
ht.handleByMap(Ae.TextureUploaderWebGPU, TC.uploadExtensions);
class CC {
  constructor() {
    this._maxTextures = 0;
  }
  contextChange(e) {
    const t = new Ts({
      uTransformMatrix: { value: new ot(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uRound: { value: 0, type: "f32" }
    });
    this._maxTextures = e.limits.maxBatchableTextures;
    const i = ay({
      name: "graphics",
      bits: [
        MM,
        CM(this._maxTextures),
        EZ,
        dy
      ]
    });
    this.shader = new lo({
      gpuProgram: i,
      resources: {
        // added on the fly!
        localUniforms: t
      }
    });
  }
  execute(e, t) {
    const i = t.context, s = i.customShader || this.shader, o = e.renderer, r = o.graphicsContext, {
      batcher: a,
      instructions: l
    } = r.getContextRenderData(i), d = o.encoder;
    d.setGeometry(a.geometry, s.gpuProgram);
    const c = o.globalUniforms.bindGroup;
    d.setBindGroup(0, c, s.gpuProgram);
    const h = o.renderPipes.uniformBatch.getUniformBindGroup(s.resources.localUniforms, !0);
    d.setBindGroup(2, h, s.gpuProgram);
    const f = l.instructions;
    let p = null;
    for (let y = 0; y < l.instructionSize; y++) {
      const v = f[y];
      if (v.topology !== p && (p = v.topology, d.setPipelineFromGeometryProgramAndState(
        a.geometry,
        s.gpuProgram,
        e.state,
        v.topology,
        s._overrides
      )), s.groups[1] = v.bindGroup, !v.gpuBindGroup) {
        const x = v.textures;
        v.bindGroup = ry(
          x.textures,
          x.count,
          this._maxTextures
        ), v.gpuBindGroup = o.bindGroup.getBindGroup(
          v.bindGroup,
          s.gpuProgram,
          1
        );
      }
      d.setBindGroup(1, v.bindGroup, s.gpuProgram), d.renderPassEncoder.drawIndexed(v.size, 1, v.start);
    }
  }
  destroy() {
    this.shader.destroy(), this.shader = null;
  }
}
CC.extension = {
  type: [
    Ae.WebGPUPipesAdaptor
  ],
  name: "graphics"
};
class IC {
  init() {
    const e = ay({
      name: "mesh",
      bits: [
        _p,
        $Z,
        dy
      ]
    });
    this._shader = new lo({
      gpuProgram: e,
      resources: {
        uTexture: et.EMPTY._source,
        uSampler: et.EMPTY._source.style,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new ot() }
        }
      }
    });
  }
  execute(e, t) {
    const i = e.renderer;
    let s = t._shader;
    if (!s)
      s = this._shader, s.groups[2] = i.texture.getTextureBindGroup(t.texture);
    else if (!s.gpuProgram) {
      dt("Mesh shader has no gpuProgram", t.shader);
      return;
    }
    const o = s.gpuProgram;
    if (o.autoAssignGlobalUniforms && (s.groups[0] = i.globalUniforms.bindGroup), o.autoAssignLocalUniforms) {
      const r = e.localUniforms;
      s.groups[1] = i.renderPipes.uniformBatch.getUniformBindGroup(r, !0);
    }
    i.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(), this._shader = null;
  }
}
IC.extension = {
  type: [
    Ae.WebGPUPipesAdaptor
  ],
  name: "mesh"
};
const Zee = [
  ...Oy,
  gC,
  pC,
  Gy,
  fC,
  uC,
  TC,
  yC,
  xC,
  wC,
  vC,
  hC,
  mC,
  cC
], Qee = [...IT, bC], ete = [sT, IC, CC], AC = [], PC = [], EC = [], RC = [];
ht.handleByNamedList(Ae.WebGPUSystem, AC);
ht.handleByNamedList(Ae.WebGPUPipes, PC);
ht.handleByNamedList(Ae.WebGPUPipesAdaptor, EC);
ht.handleByNamedList(Ae.WebGPULoader, RC);
ht.add(...Zee, ...Qee, ...ete);
class tte extends ku {
  constructor() {
    const e = {
      name: "webgpu",
      type: rs.WEBGPU,
      systems: AC,
      renderPipes: PC,
      renderPipeAdaptors: EC,
      loaders: RC
    };
    super(e);
  }
}
const nte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGPURenderer: tte
}, Symbol.toStringTag, { value: "Module" })), zC = class $C extends AZ {
  constructor(...e) {
    var i;
    super({});
    let t = (i = e[0]) != null ? i : {};
    typeof t == "number" && (rt(dn, "PlaneGeometry constructor changed please use { width, height, verticesX, verticesY } instead"), t = {
      width: t,
      height: e[1],
      verticesX: e[2],
      verticesY: e[3]
    }), this.build(t);
  }
  /**
   * Refreshes plane coordinates
   * @param options - Options to be applied to plane geometry
   */
  build(e) {
    var h, f, p, y;
    e = { ...$C.defaultOptions, ...e }, this.verticesX = (h = this.verticesX) != null ? h : e.verticesX, this.verticesY = (f = this.verticesY) != null ? f : e.verticesY, this.width = (p = this.width) != null ? p : e.width, this.height = (y = this.height) != null ? y : e.height;
    const t = this.verticesX * this.verticesY, i = [], s = [], o = [], r = this.verticesX - 1, a = this.verticesY - 1, l = this.width / r, d = this.height / a;
    for (let v = 0; v < t; v++) {
      const x = v % this.verticesX, w = v / this.verticesX | 0;
      i.push(x * l, w * d), s.push(x / r, w / a);
    }
    const c = r * a;
    for (let v = 0; v < c; v++) {
      const x = v % r, w = v / r | 0, S = w * this.verticesX + x, M = w * this.verticesX + x + 1, _ = (w + 1) * this.verticesX + x, T = (w + 1) * this.verticesX + x + 1;
      o.push(
        S,
        M,
        _,
        M,
        T,
        _
      );
    }
    this.buffers[0].data = new Float32Array(i), this.buffers[1].data = new Float32Array(s), this.indexBuffer.data = new Uint32Array(o), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
  }
};
zC.defaultOptions = {
  width: 100,
  height: 100,
  verticesX: 10,
  verticesY: 10
};
let ite = zC;
const Zg = [[0, 0], [0, 0], [0, 0]], Qg = [[0, 0], [0, 0], [0, 0]], eb = [[0, 0], [0, 0], [0, 0]], tb = [[0, 0], [0, 0], [0, 0]];
function yh(n, e, t, i, s, o, r) {
  n[0][0] = e, n[0][1] = t, n[1][0] = i, n[1][1] = s, n[2][0] = o, n[2][1] = r;
}
class DC {
  constructor(e) {
    this._renderer = e;
  }
  validateRenderable(e) {
    return !1;
  }
  addRenderable(e, t) {
    this._renderer.renderPipes.batch.break(t), t.add(e);
  }
  updateRenderable(e) {
  }
  execute(e) {
    var be, se, ae, ye, Oe, Ve;
    const t = this._renderer, i = t.canvasContext, s = i.activeContext;
    s.save();
    const o = e.groupTransform, r = t._roundPixels | e._roundPixels;
    i.setContextTransform(o, r === 1), i.setBlendMode(e.groupBlendMode);
    const a = (se = (be = t.globalUniforms.globalUniformData) == null ? void 0 : be.worldColor) != null ? se : 4294967295, l = e.groupColorAlpha, d = (a >>> 24 & 255) / 255, c = (l >>> 24 & 255) / 255, h = (ye = (ae = t.filter) == null ? void 0 : ae.alphaMultiplier) != null ? ye : 1, f = d * c * h;
    if (f <= 0) {
      s.restore();
      return;
    }
    s.globalAlpha = f;
    const p = a & 16777215, y = l & 16777215, v = oa(sa(y, p)), x = e.texture, w = St.getCanvasSource(x);
    if (!w) {
      s.restore();
      return;
    }
    const S = i.smoothProperty, M = x.source.style.scaleMode !== "nearest";
    s[S] !== M && (s[S] = M);
    const _ = v !== 16777215 || x.rotate !== 0, T = _ ? St.getTintedCanvas({ texture: x }, v) : w, {
      leftWidth: k,
      topHeight: P,
      rightWidth: A,
      bottomHeight: R,
      width: D,
      height: O
    } = e, F = k + A, ie = P + R, ee = Math.min(
      F > D ? D / F : 1,
      ie > O ? O / ie : 1,
      1
    ), me = k * ee, L = A * ee, N = P * ee, K = R * ee, B = Math.max(0, D - me - L), re = Math.max(0, O - N - K), H = e.anchor, J = (Ve = (Oe = x.source._resolution) != null ? Oe : x.source.resolution) != null ? Ve : 1;
    let Q = x.frame.x * J, ne = x.frame.y * J;
    const ue = -H.x * D, Z = -H.y * O, te = k * J, we = P * J, Fe = A * J, Me = R * J;
    let he = x.frame.width * J, U = x.frame.height * J;
    _ && (Q = 0, ne = 0, he = T.width, U = T.height);
    const q = he - te - Fe, oe = U - we - Me, de = q > 0 ? Q + te : Math.max(Q, Math.min(Q + te, Q + he - 1)), pe = q > 0 ? q : 1, Ce = oe > 0 ? ne + we : Math.max(ne, Math.min(ne + we, ne + U - 1)), Be = oe > 0 ? oe : 1;
    yh(Zg, Q, te, de, pe, Q + he - Fe, Fe), yh(Qg, ne, we, Ce, Be, ne + U - Me, Me), yh(
      eb,
      ue,
      me,
      ue + me,
      B,
      ue + D - L,
      L
    ), yh(
      tb,
      Z,
      N,
      Z + N,
      re,
      Z + O - K,
      K
    );
    for (let Ue = 0; Ue < 3; Ue++) {
      const tt = eb[Ue][1];
      if (tt <= 0) continue;
      const Ye = Zg[Ue][0], at = Zg[Ue][1], kt = eb[Ue][0];
      for (let $e = 0; $e < 3; $e++) {
        const Ne = tb[$e][1];
        Ne <= 0 || s.drawImage(
          T,
          Ye,
          Qg[$e][0],
          at,
          Qg[$e][1],
          kt,
          tb[$e][0],
          tt,
          Ne
        );
      }
    }
    s.restore();
  }
  destroy() {
    this._renderer = null;
  }
}
DC.extension = {
  type: [
    Ae.CanvasPipes
  ],
  name: "nineSliceSprite"
};
const OC = class Ap extends ite {
  constructor(e = {}) {
    var t, i;
    e = { ...Ap.defaultOptions, ...e }, super({
      width: e.width,
      height: e.height,
      verticesX: 4,
      verticesY: 4
    }), this._trimX = 0, this._trimY = 0, this._trimWidth = (t = e.originalWidth) != null ? t : Ap.defaultOptions.originalWidth, this._trimHeight = (i = e.originalHeight) != null ? i : Ap.defaultOptions.originalHeight, this.update(e);
  }
  /**
   * Updates the NineSliceGeometry with the options.
   * @param options - The options of the NineSliceGeometry.
   */
  update(e) {
    var t, i, s, o, r, a, l, d, c, h, f, p, y, v, x, w, S, M;
    this.width = (t = e.width) != null ? t : this.width, this.height = (i = e.height) != null ? i : this.height, this._originalWidth = (s = e.originalWidth) != null ? s : this._originalWidth, this._originalHeight = (o = e.originalHeight) != null ? o : this._originalHeight, this._leftWidth = (r = e.leftWidth) != null ? r : this._leftWidth, this._rightWidth = (a = e.rightWidth) != null ? a : this._rightWidth, this._topHeight = (l = e.topHeight) != null ? l : this._topHeight, this._bottomHeight = (d = e.bottomHeight) != null ? d : this._bottomHeight, this._anchorX = (c = e.anchor) == null ? void 0 : c.x, this._anchorY = (h = e.anchor) == null ? void 0 : h.y, e.trim !== void 0 ? (this._trimX = (p = (f = e.trim) == null ? void 0 : f.x) != null ? p : 0, this._trimY = (v = (y = e.trim) == null ? void 0 : y.y) != null ? v : 0, this._trimWidth = (w = (x = e.trim) == null ? void 0 : x.width) != null ? w : this._originalWidth, this._trimHeight = (M = (S = e.trim) == null ? void 0 : S.height) != null ? M : this._originalHeight) : (this._trimWidth = this._originalWidth, this._trimHeight = this._originalHeight), this.updateUvs(), this.updatePositions();
  }
  /** Updates the positions of the vertices. */
  updatePositions() {
    const e = this.positions, {
      width: t,
      height: i,
      _leftWidth: s,
      _rightWidth: o,
      _topHeight: r,
      _bottomHeight: a,
      _anchorX: l,
      _anchorY: d
    } = this, c = s + o, h = t > c ? 1 : t / c, f = r + a, p = i > f ? 1 : i / f, y = Math.min(h, p), v = l * t, x = d * i;
    e[0] = e[8] = e[16] = e[24] = -v, e[2] = e[10] = e[18] = e[26] = s * y - v, e[4] = e[12] = e[20] = e[28] = t - o * y - v, e[6] = e[14] = e[22] = e[30] = t - v, e[1] = e[3] = e[5] = e[7] = -x, e[9] = e[11] = e[13] = e[15] = r * y - x, e[17] = e[19] = e[21] = e[23] = i - a * y - x, e[25] = e[27] = e[29] = e[31] = i - x, this.getBuffer("aPosition").update();
  }
  /** Updates the UVs of the vertices. */
  updateUvs() {
    const e = this.uvs, t = this._originalWidth, i = this._originalHeight, s = this._trimX / t, o = this._trimY / i, r = (this._trimX + this._trimWidth) / t, a = (this._trimY + this._trimHeight) / i;
    e[0] = e[8] = e[16] = e[24] = s, e[1] = e[3] = e[5] = e[7] = o, e[6] = e[14] = e[22] = e[30] = r, e[25] = e[27] = e[29] = e[31] = a;
    const l = 1 / t, d = 1 / i;
    e[2] = e[10] = e[18] = e[26] = s + l * this._leftWidth, e[9] = e[11] = e[13] = e[15] = o + d * this._topHeight, e[4] = e[12] = e[20] = e[28] = r - l * this._rightWidth, e[17] = e[19] = e[21] = e[23] = a - d * this._bottomHeight, this.getBuffer("aUV").update();
  }
};
OC.defaultOptions = {
  /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  width: 100,
  /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  height: 100,
  /** The width of the left column. */
  leftWidth: 10,
  /** The height of the top row. */
  topHeight: 10,
  /** The width of the right column. */
  rightWidth: 10,
  /** The height of the bottom row. */
  bottomHeight: 10,
  /** The original width of the texture */
  originalWidth: 100,
  /** The original height of the texture */
  originalHeight: 100
};
let $r = OC;
class ste extends PZ {
  constructor() {
    super(), this.geometry = new $r();
  }
  destroy() {
    this.geometry.destroy();
  }
}
class LC {
  constructor(e) {
    this._renderer = e, this._managedSprites = new Cs({ renderer: e, type: "renderable", name: "nineSliceSprite" });
  }
  addRenderable(e, t) {
    const i = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, i), this._renderer.renderPipes.batch.addToBatch(i, t);
  }
  updateRenderable(e) {
    const t = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  _updateBatchableSprite(e, t) {
    t.geometry.update(e), t.setTexture(e._texture);
  }
  _getGpuSprite(e) {
    return e._gpuData[this._renderer.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = e._gpuData[this._renderer.uid] = new ste(), i = t;
    return i.renderable = e, i.transform = e.groupTransform, i.texture = e._texture, i.roundPixels = this._renderer._roundPixels | e._roundPixels, this._managedSprites.add(e), e.didViewUpdate || this._updateBatchableSprite(e, i), t;
  }
  destroy() {
    this._managedSprites.destroy(), this._renderer = null;
  }
}
LC.extension = {
  type: [
    Ae.WebGLPipes,
    Ae.WebGPUPipes
  ],
  name: "nineSliceSprite"
};
ht.add(DC);
ht.add(LC);
const BC = class FC extends ty {
  constructor(e) {
    var f, p, y, v, x, w, S, M, _, T;
    e instanceof et && (e = { texture: e });
    const {
      width: t,
      height: i,
      anchor: s,
      leftWidth: o,
      rightWidth: r,
      topHeight: a,
      bottomHeight: l,
      texture: d,
      roundPixels: c,
      ...h
    } = e;
    super({
      label: "NineSliceSprite",
      ...h
    }), this.renderPipeId = "nineSliceSprite", this.batched = !0, this._leftWidth = (p = o != null ? o : (f = d == null ? void 0 : d.defaultBorders) == null ? void 0 : f.left) != null ? p : $r.defaultOptions.leftWidth, this._topHeight = (v = a != null ? a : (y = d == null ? void 0 : d.defaultBorders) == null ? void 0 : y.top) != null ? v : $r.defaultOptions.topHeight, this._rightWidth = (w = r != null ? r : (x = d == null ? void 0 : d.defaultBorders) == null ? void 0 : x.right) != null ? w : $r.defaultOptions.rightWidth, this._bottomHeight = (M = l != null ? l : (S = d == null ? void 0 : d.defaultBorders) == null ? void 0 : S.bottom) != null ? M : $r.defaultOptions.bottomHeight, this._width = (_ = t != null ? t : d.width) != null ? _ : $r.defaultOptions.width, this._height = (T = i != null ? i : d.height) != null ? T : $r.defaultOptions.height, this.allowChildren = !1, this.texture = d != null ? d : FC.defaultOptions.texture, this.roundPixels = c != null ? c : !1, this._anchor = new Fn(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), s ? this.anchor = s : this.texture.defaultAnchor && (this.anchor = this.texture.defaultAnchor);
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /**
   * The width of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The width affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed width
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     width: 200  // Sets initial width
   * });
   *
   * // Adjust width dynamically
   * panel.width = 300;  // Stretches middle sections
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#height} For setting height
   */
  get width() {
    return this._width;
  }
  set width(e) {
    this._width = e, this.onViewUpdate();
  }
  /**
   * The height of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The height affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed height
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     height: 150  // Sets initial height
   * });
   *
   * // Adjust height dynamically
   * panel.height = 200;  // Stretches middle sections
   *
   * // Create responsive UI element
   * const dialog = new NineSliceSprite({
   *     texture: Texture.from('dialog.png'),
   *     topHeight: 30,
   *     bottomHeight: 30,
   *     height: parent.height * 0.5  // 50% of parent height
   * });
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#width} For setting width
   */
  get height() {
    return this._height;
  }
  set height(e) {
    this._height = e, this.onViewUpdate();
  }
  /**
   * Sets the size of the NineSliceSprite to the specified width and height.
   * This method directly modifies the vertices and UV coordinates of the sprite.
   *
   * Using this is more efficient than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set to specific dimensions
   * panel.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size
   * panel.setSize(200); // Makes a square 200x200
   *
   * // Set size using object
   * panel.setSize({
   *     width: 400,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link NineSliceSprite#width} For setting width only
   * @see {@link NineSliceSprite#height} For setting height only
   */
  setSize(e, t) {
    var i;
    typeof e == "object" && (t = (i = e.height) != null ? i : e.width, e = e.width), this._width = e, this._height = t != null ? t : e, this.onViewUpdate();
  }
  /**
   * Retrieves the size of the NineSliceSprite as a [Size]{@link Size} object.
   * This method is more efficient than getting width and height separately.
   * @example
   * ```ts
   * // Get basic size
   * const size = panel.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * panel.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the NineSliceSprite
   * @see {@link NineSliceSprite#width} For getting just the width
   * @see {@link NineSliceSprite#height} For getting just the height
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   */
  getSize(e) {
    return e || (e = {}), e.width = this._width, e.height = this._height, e;
  }
  /**
   * Width of the left vertical bar (A).
   * Controls the size of the left edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., leftWidth: 20 });
   * sprite.leftWidth = 20; // Set left border width
   * ```
   * @default 10
   */
  get leftWidth() {
    return this._leftWidth;
  }
  set leftWidth(e) {
    this._leftWidth = e, this.onViewUpdate();
  }
  /**
   * Height of the top horizontal bar (C).
   * Controls the size of the top edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., topHeight: 20 });
   * sprite.topHeight = 20; // Set top border height
   * ```
   * @default 10
   */
  get topHeight() {
    return this._topHeight;
  }
  set topHeight(e) {
    this._topHeight = e, this.onViewUpdate();
  }
  /**
   * Width of the right vertical bar (B).
   * Controls the size of the right edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., rightWidth: 20 });
   * sprite.rightWidth = 20; // Set right border width
   * ```
   * @default 10
   */
  get rightWidth() {
    return this._rightWidth;
  }
  set rightWidth(e) {
    this._rightWidth = e, this.onViewUpdate();
  }
  /**
   * Height of the bottom horizontal bar (D).
   * Controls the size of the bottom edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., bottomHeight: 20 });
   * sprite.bottomHeight = 20; // Set bottom border height
   * ```
   * @default 10
   */
  get bottomHeight() {
    return this._bottomHeight;
  }
  set bottomHeight(e) {
    this._bottomHeight = e, this.onViewUpdate();
  }
  /**
   * The texture to use on the NineSliceSprite.
   * ```ts
   * // Create a sprite with a texture
   * const sprite = new NineSliceSprite({
   *     texture: Texture.from('path/to/image.png')
   * });
   * // Update the texture later
   * sprite.texture = Texture.from('path/to/another-image.png');
   * ```
   * @default Texture.EMPTY
   */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    e || (e = et.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this.onViewUpdate());
  }
  /**
   * The original width of the texture before any nine-slice scaling.
   * This is the width of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.width = sprite.originalWidth * 2; // Double the original width
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#width} For the current displayed width
   * @see {@link Texture#width} For direct texture width access
   * @returns The original width of the texture
   */
  get originalWidth() {
    return this._texture.width;
  }
  /**
   * The original height of the texture before any nine-slice scaling.
   * This is the height of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.height = sprite.originalHeight * 2; // Double the original height
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#height} For the current displayed height
   * @see {@link Texture#height} For direct texture height access
   * @returns The original height of the texture
   */
  get originalHeight() {
    return this._texture.height;
  }
  /**
   * The trim rectangle of the underlying texture, or `null` if the texture is not trimmed.
   * This is forwarded to the {@link NineSliceGeometry} so that UV coordinates are clamped
   * to the visible pixel region, preventing transparent atlas padding from bleeding into
   * the rendered sprite corners.
   * @readonly
   * @internal
   */
  get trim() {
    var e;
    return (e = this._texture.trim) != null ? e : null;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * nineSliceSprite.destroy();
   * nineSliceSprite.destroy(true);
   * nineSliceSprite.destroy({ texture: true, textureSource: true });
   */
  destroy(e) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const i = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(i);
    }
    this._texture = null;
  }
  /** @private */
  updateBounds() {
    const e = this._bounds, t = this._anchor, i = this._width, s = this._height;
    e.minX = -t._x * i, e.maxX = e.minX + i, e.minY = -t._y * s, e.maxY = e.minY + s;
  }
};
BC.defaultOptions = {
  /** @default Texture.EMPTY */
  texture: et.EMPTY
};
let ote = BC;
ht.add(cK, uK);
function rte() {
  const n = self;
  function e(s) {
    const o = /^synthetic:\/\/(\d+)\/(\d+)x(\d+)/.exec(s), r = o ? Number(o[1]) : 1, a = o ? Number(o[2]) : 640, l = o ? Number(o[3]) : 480, d = new OffscreenCanvas(a, l), c = d.getContext("2d");
    let h = r * 9301 + 49297;
    const f = () => (h = (h * 9301 + 49297) % 233280, h / 233280), p = Math.floor(f() * 360), y = c.createLinearGradient(0, 0, a, l);
    y.addColorStop(0, "hsl(" + p + ",45%," + (18 + f() * 20) + "%)"), y.addColorStop(1, "hsl(" + (p + 40 + f() * 80) % 360 + ",55%," + (35 + f() * 25) + "%)"), c.fillStyle = y, c.fillRect(0, 0, a, l);
    for (let v = 0; v < 7; v++) {
      c.fillStyle = "hsla(" + (p + f() * 120) % 360 + ",60%," + (40 + f() * 40) + "%," + (0.25 + f() * 0.4) + ")";
      const x = a * (0.1 + f() * 0.4), w = l * (0.1 + f() * 0.6);
      c.fillRect(f() * (a - x), l - w - f() * l * 0.3, x, w);
    }
    return c.fillStyle = "rgba(255,255,255,0.85)", c.font = "600 " + Math.round(l * 0.09) + "px sans-serif", c.fillText("#" + r, a * 0.06, l * 0.9), { canvas: d, w: a, h: l };
  }
  async function t(s) {
    if (s.startsWith("synthetic://")) {
      const d = e(s);
      return { src: d.canvas, sw: d.w, sh: d.h };
    }
    const o = s.startsWith("blob:") || s.startsWith("data:") ? s : s + (s.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", r = await fetch(o, { mode: "cors", credentials: "omit" });
    if (!r.ok) throw new Error("HTTP " + r.status);
    const a = await r.blob(), l = await createImageBitmap(a);
    return { src: l, sw: l.width, sh: l.height, close: () => l.close() };
  }
  function i(s, o, r) {
    const l = new OffscreenCanvas(1, 1).getContext("2d", { willReadFrequently: !0 });
    l.drawImage(s, 0, 0, o, r, 0, 0, 1, 1);
    const d = l.getImageData(0, 0, 1, 1).data, c = (h) => h.toString(16).padStart(2, "0");
    return "#" + c(d[0]) + c(d[1]) + c(d[2]);
  }
  n.onmessage = async (s) => {
    const o = s.data;
    let r = null;
    try {
      r = await t(o.url);
      const { src: a, sw: l, sh: d } = r, c = Math.max(1, Math.round(o.tw)), h = Math.max(1, Math.round(o.th)), f = c / h, p = l / d;
      let y = 0, v = 0, x = l, w = d;
      p > f ? (x = d * f, y = (l - x) / 2) : (w = l / f, v = (d - w) / 2);
      const S = new OffscreenCanvas(c, h), M = S.getContext("2d");
      M.imageSmoothingEnabled = !0, M.imageSmoothingQuality = "high";
      const _ = Math.min(o.radius, c / 2, h / 2);
      M.save(), M.beginPath(), M.roundRect(0, 0, c, h, _), M.clip();
      let T = a, k = x, P = w, A = y, R = v;
      for (; k > c * 2.5 && P > h * 2.5; ) {
        const F = Math.max(c, Math.round(k / 2)), ie = Math.max(h, Math.round(P / 2)), ee = new OffscreenCanvas(F, ie), me = ee.getContext("2d");
        me.imageSmoothingEnabled = !0, me.imageSmoothingQuality = "high", me.drawImage(T, A, R, k, P, 0, 0, F, ie), T = ee, A = 0, R = 0, k = F, P = ie;
      }
      if (M.drawImage(T, A, R, k, P, 0, 0, c, h), M.restore(), o.border > 0) {
        const F = o.border;
        M.lineWidth = F, M.strokeStyle = "rgba(255,255,255,0.09)", M.beginPath(), M.roundRect(F / 2, F / 2, c - F, h - F, Math.max(0, _ - F / 2)), M.stroke(), M.save(), M.beginPath(), M.roundRect(0, 0, c, h, _), M.clip(), M.fillStyle = "rgba(255,255,255,0.07)", M.fillRect(0, F, c, F), M.restore();
      }
      const D = i(a, l, d), O = S.transferToImageBitmap();
      r.close && r.close(), n.postMessage({ id: o.id, bitmap: O, color: D, sw: l, sh: d }, [O]);
    } catch (a) {
      r && r.close && r.close(), n.postMessage({ id: o.id, error: String(a && a.message || a) });
    }
  };
}
let nb = null;
function ate() {
  return typeof Worker != "undefined" && typeof OffscreenCanvas != "undefined" && typeof createImageBitmap != "undefined";
}
function lte() {
  if (!nb) {
    const n = "(" + rte.toString() + ")();";
    nb = URL.createObjectURL(new Blob([n], { type: "text/javascript" }));
  }
  return new Worker(nb);
}
var dte = Object.defineProperty, cte = (n, e, t) => e in n ? dte(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, yi = (n, e, t) => cte(n, typeof e != "symbol" ? e + "" : e, t);
const Pp = [64, 128, 256, 512, 1024, 2048], xh = 64;
function ute(n) {
  for (const e of Pp) if (e >= n / 1.15) return e;
  return Pp[Pp.length - 1];
}
class hte {
  constructor(e) {
    if (yi(this, "opts", e), yi(this, "entries", /* @__PURE__ */ new Map()), yi(this, "queue", []), yi(this, "queueDirty", !1), yi(this, "workers", []), yi(this, "idle", []), yi(this, "jobs", /* @__PURE__ */ new Map()), yi(this, "jobSeq", 0), yi(this, "frame", 0), yi(this, "bytes", 0), yi(this, "ready", []), yi(this, "destroyed", !1), yi(this, "evicted", []), ate()) {
      const t = Math.max(2, Math.min(4, Math.floor((navigator.hardwareConcurrency || 4) / 2)));
      for (let i = 0; i < t; i++) {
        const s = lte();
        s.onmessage = (o) => this.onResult(s, o.data), this.workers.push(s), this.idle.push(s);
      }
    }
  }
  get totalBytes() {
    return this.bytes;
  }
  get textureCount() {
    let e = 0;
    for (const t of this.entries.values()) e += t.tiers.size;
    return e;
  }
  get pending() {
    return this.jobs.size + this.queue.length;
  }
  /** Register or refresh a card's source. Size changes keep loaded tiers. */
  track(e, t, i, s) {
    const o = this.entries.get(e);
    if (!o) {
      this.entries.set(e, {
        id: e,
        url: t,
        w: i,
        h: s,
        tiers: /* @__PURE__ */ new Map(),
        sw: 0,
        sh: 0,
        want: 0,
        priority: 0,
        inflight: 0,
        failed: 0,
        lastSeen: 0
      });
      return;
    }
    o.url !== t && (this.dropAll(o), o.url = t, o.sw = 0, o.sh = 0, o.failed = 0), o.w = i, o.h = s;
  }
  untrack(e) {
    const t = this.entries.get(e);
    if (!t) return;
    this.dropAll(t), this.entries.delete(e);
    const i = this.queue.indexOf(t);
    i >= 0 && this.queue.splice(i, 1);
  }
  /** Called once per rendered frame. */
  tick() {
    this.frame++;
  }
  /**
   * A card is on screen at `screenPx` device pixels on its long edge. Returns
   * the best rendition already loaded (exact tier, else the nearest), and
   * queues the wanted tier. `settled` false = only fill gaps, don't refine.
   */
  request(e, t, i, s) {
    const o = this.entries.get(e);
    if (!o) return null;
    o.lastSeen = this.frame;
    let r = ute(t);
    const a = Math.max(o.sw, o.sh);
    if (a) {
      let c = xh;
      for (const h of Pp) h <= a * 1.1 && (c = h);
      r = Math.min(r, Math.max(c, xh));
    }
    const l = this.best(o, r);
    l && (l.lastUsed = this.frame);
    const d = !l || l.tier * 2 < r;
    if (o.failed < 3 && !o.tiers.has(r) && (s || d)) {
      const c = !l && !s ? Math.min(r, 128) : r;
      o.tiers.has(c) || (o.want = c, o.priority = i, !o.inflight && this.queue.indexOf(o) < 0 && this.queue.push(o), this.queueDirty = !0);
    }
    return l;
  }
  best(e, t) {
    const i = e.tiers.get(t);
    if (i) return i;
    let s = null, o = null;
    for (const r of e.tiers.values())
      r.tier < t && (!s || r.tier > s.tier) && (s = r), r.tier > t && (!o || r.tier < o.tier) && (o = r);
    return o || s;
  }
  /** Start queued loads; call each frame after the visible pass. */
  pump() {
    if (!this.destroyed)
      for (this.queueDirty && (this.queue.sort((e, t) => e.priority - t.priority), this.queueDirty = !1); this.jobs.size < this.opts.maxInFlight && this.queue.length; ) {
        const e = this.queue.shift();
        this.frame - e.lastSeen > 120 || e.tiers.has(e.want) || this.start(e, e.want);
      }
  }
  /**
   * Bitmaps finished since last frame, at most `max` (the upload budget).
   * Ids `cheap` says yes to (no texture upload) have their own budget,
   * `maxCheap`; the rest wait their turn in order.
   */
  drainReady(e, t, i, s = 0) {
    if (!this.ready.length) return [];
    const o = [], r = [];
    let a = 0, l = 0, d = 0;
    for (const c of this.ready)
      i && d < s && i(c.id) ? (d++, o.push(c)) : l < e && (a < t || !l) ? (l++, a += c.tex.bytes, o.push(c)) : r.push(c);
    return this.ready = r, o;
  }
  start(e, t) {
    const i = Math.max(e.w, e.h), s = t / i, o = Math.max(1, Math.round(e.w * s)), r = Math.max(1, Math.round(e.h * s)), a = this.opts.radius * s, l = s >= 0.5 ? Math.max(1, s) : 0, d = ++this.jobSeq;
    e.inflight++, this.jobs.set(d, { entry: e, tier: t, jobId: d });
    const c = { id: d, url: e.url, tw: o, th: r, radius: a, border: l }, h = this.idle.pop();
    h ? h.postMessage(c) : this.workers.length ? this.workers[d % this.workers.length].postMessage(c) : pte(c).then((f) => this.onResult(null, f));
  }
  onResult(e, t) {
    e && this.idle.indexOf(e) < 0 && this.idle.push(e);
    const i = this.jobs.get(t.id);
    if (this.jobs.delete(t.id), !i || this.destroyed) {
      t.bitmap && t.bitmap.close();
      return;
    }
    const s = i.entry;
    if (s.inflight = Math.max(0, s.inflight - 1), t.error || !t.bitmap) {
      s.failed++, s.failed >= 3 && this.opts.onError ? this.opts.onError(s.id, t.error || "unknown") : s.failed < 3 && setTimeout(() => {
        !this.destroyed && this.entries.get(s.id) === s && !s.tiers.has(i.tier) && (s.want = i.tier, this.queue.indexOf(s) < 0 && this.queue.push(s), this.queueDirty = !0);
      }, 800 * s.failed);
      return;
    }
    if (this.entries.get(s.id) !== s) {
      t.bitmap.close();
      return;
    }
    t.sw && t.sh && (s.sw = t.sw, s.sh = t.sh);
    const o = t.bitmap, r = new Gc({
      resource: o,
      alphaMode: "premultiplied-alpha",
      autoGenerateMipmaps: i.tier >= 256,
      scaleMode: "linear"
    }), a = new et({ source: r }), l = o.width * o.height * 4 * (i.tier >= 256 ? 1.34 : 1), d = s.tiers.get(i.tier);
    d && this.free(d);
    const c = { tier: i.tier, texture: a, bytes: l, lastUsed: this.frame };
    s.tiers.set(i.tier, c), this.bytes += l, this.ready.push({ id: s.id, tex: c, color: t.color }), s.want !== i.tier && !s.tiers.has(s.want) && this.queue.indexOf(s) < 0 && (this.queue.push(s), this.queueDirty = !0), this.evict();
  }
  /** Free renditions until under budget; returns ids whose shown tier went. */
  evict() {
    if (this.bytes <= this.opts.budgetBytes) return;
    const e = [];
    for (const t of this.entries.values())
      for (const i of t.tiers.values())
        this.frame - i.lastUsed < 2 || e.push({ e: t, t: i });
    e.sort((t, i) => t.t.lastUsed - i.t.lastUsed || (t.t.tier === xh ? 1 : 0) - (i.t.tier === xh ? 1 : 0) || i.t.bytes - t.t.bytes);
    for (const t of e) {
      if (this.bytes <= this.opts.budgetBytes * 0.9) break;
      t.e.tiers.delete(t.t.tier), this.evicted.push({ id: t.e.id, tier: t.t.tier, texture: t.t.texture, bytes: t.t.bytes }), this.bytes -= t.t.bytes;
    }
  }
  /** Renditions evicted since the last call. The caller swaps any sprite
   *  still pointing at one, then calls release(). */
  takeEvicted() {
    const e = this.evicted;
    return this.evicted = [], e;
  }
  release(e) {
    e.destroy(!0);
  }
  /** Best loaded rendition for an id, regardless of want. */
  anyFor(e) {
    const t = this.entries.get(e);
    if (!t) return null;
    let i = null;
    for (const s of t.tiers.values()) (!i || s.tier > i.tier) && (i = s);
    return i;
  }
  free(e) {
    this.bytes -= e.bytes, e.texture.destroy(!0);
  }
  dropAll(e) {
    for (const t of e.tiers.values()) this.free(t);
    e.tiers.clear();
  }
  destroy() {
    this.destroyed = !0;
    for (const e of this.workers) e.terminate();
    this.workers.length = 0, this.idle.length = 0;
    for (const e of this.entries.values()) this.dropAll(e);
    this.entries.clear();
    for (const e of this.ready) e.tex.texture.destroy(!0);
    this.ready.length = 0;
    for (const e of this.evicted) e.texture.destroy(!0);
    this.evicted = [];
  }
}
async function pte(n) {
  try {
    const e = n.url.startsWith("blob:") || n.url.startsWith("data:") ? n.url : n.url + (n.url.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", t = await fetch(e, { mode: "cors", credentials: "omit" });
    if (!t.ok) throw new Error("HTTP " + t.status);
    const i = await createImageBitmap(await t.blob()), s = document.createElement("canvas");
    s.width = Math.max(1, Math.round(n.tw)), s.height = Math.max(1, Math.round(n.th));
    const o = s.getContext("2d"), r = s.width / s.height;
    let a = i.width, l = i.height, d = 0, c = 0;
    i.width / i.height > r ? (a = i.height * r, d = (i.width - a) / 2) : (l = i.width / r, c = (i.height - l) / 2), o.beginPath(), o.roundRect(0, 0, s.width, s.height, n.radius), o.clip(), o.imageSmoothingQuality = "high", o.drawImage(i, d, c, a, l, 0, 0, s.width, s.height);
    const h = await createImageBitmap(s), f = i.width, p = i.height;
    return i.close(), { id: n.id, bitmap: h, sw: f, sh: p };
  } catch (e) {
    return { id: n.id, error: String(e && e.message || e) };
  }
}
var fte = Object.defineProperty, mte = (n, e, t) => e in n ? fte(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, wd = (n, e, t) => mte(n, typeof e != "symbol" ? e + "" : e, t);
const pa = 32, Ls = 1, Wr = pa + Ls * 2, Xd = 1024, wf = Math.floor(Xd / Wr), a_ = wf * wf;
function ib(n) {
  return { x: n % wf * Wr, y: Math.floor(n / wf) * Wr };
}
function gte(n, e) {
  const t = Math.max(1, n, e);
  return { w: Math.max(1, Math.round(pa * n / t)), h: Math.max(1, Math.round(pa * e / t)) };
}
class bte {
  constructor() {
    wd(this, "pages", []), wd(this, "cells", /* @__PURE__ */ new Map()), wd(this, "free", []), wd(this, "next", 0), wd(this, "blank", null);
  }
  get size() {
    return this.cells.size;
  }
  get pageCount() {
    return this.pages.length;
  }
  /** GPU bytes held (each page also keeps its canvas). */
  get bytes() {
    return this.pages.length * Xd * Xd * 4 * 1.34;
  }
  has(e) {
    return this.cells.has(e);
  }
  get(e) {
    const t = this.cells.get(e);
    return t ? t.texture : null;
  }
  /** A white cell on the first page: tinted, it is a tiny image's placeholder. */
  get placeholder() {
    if (!this.blank) {
      const e = this.take(), t = this.pages[e.page], i = ib(e.slot);
      t.ctx.fillStyle = "#fff", t.ctx.fillRect(i.x, i.y, Wr, Wr), t.dirty = !0, this.blank = new et({ source: t.source, frame: new Tt(i.x + Ls, i.y + Ls, pa, pa) });
    }
    return this.blank;
  }
  /** Draw `image` (any rendition of the picture) into the id's cell; returns its texture. */
  put(e, t, i, s) {
    let o = this.cells.get(e);
    const r = gte(i, s);
    if (o)
      (o.texture.frame.width !== r.w || o.texture.frame.height !== r.h) && (o.texture.frame.width = r.w, o.texture.frame.height = r.h, o.texture.update());
    else {
      const c = this.take(), h = ib(c.slot), f = this.pages[c.page];
      o = {
        page: c.page,
        slot: c.slot,
        texture: new et({ source: f.source, frame: new Tt(h.x + Ls, h.y + Ls, r.w, r.h) })
      }, this.cells.set(e, o);
    }
    const a = this.pages[o.page], l = ib(o.slot), d = a.ctx;
    return d.clearRect(l.x, l.y, Wr, Wr), d.drawImage(t, l.x, l.y, r.w + Ls * 2, r.h + Ls * 2), d.drawImage(t, l.x + Ls, l.y + Ls, r.w, r.h), a.dirty = !0, o.texture;
  }
  remove(e) {
    const t = this.cells.get(e);
    t && (this.cells.delete(e), t.texture.destroy(!1), this.free.push({ page: t.page, slot: t.slot }));
  }
  /** Upload the pages drawn into since the last call; once per frame, before rendering. */
  flush() {
    for (const e of this.pages)
      e.dirty && (e.dirty = !1, e.source.update());
  }
  destroy() {
    for (const e of this.cells.values()) e.texture.destroy(!1);
    this.cells.clear(), this.blank && this.blank.destroy(!1), this.blank = null;
    for (const e of this.pages) e.source.destroy();
    this.pages.length = 0, this.free.length = 0, this.next = 0;
  }
  take() {
    const e = this.free.pop();
    if (e) return e;
    const t = Math.floor(this.next / a_), i = this.next % a_;
    return this.next++, t === this.pages.length && this.pages.push(this.newPage()), { page: t, slot: i };
  }
  newPage() {
    const e = document.createElement("canvas");
    e.width = Xd, e.height = Xd;
    const t = e.getContext("2d");
    t.imageSmoothingEnabled = !0, t.imageSmoothingQuality = "high";
    const i = new Ai({
      resource: e,
      scaleMode: "linear",
      // mipmaps keep a 3 px thumbnail from shimmering as the board pans
      autoGenerateMipmaps: !0,
      // a page's pixels live only in this atlas: never let the GPU copy idle out
      autoGarbageCollect: !1
    });
    return { canvas: e, ctx: t, source: i, dirty: !1 };
  }
}
const l_ = /* @__PURE__ */ new Map();
function $a(n, e) {
  const t = Math.round(n / Math.max(1, e) * 20) / 20, i = String(t);
  let s = l_.get(i);
  if (s) return s;
  const o = 128, r = t >= 1 ? o : Math.max(8, Math.round(o * t)), a = t >= 1 ? Math.max(8, Math.round(o / t)) : o, l = document.createElement("canvas");
  l.width = r, l.height = a;
  const d = l.getContext("2d");
  return d.fillStyle = "#fff", d.beginPath(), d.roundRect(0, 0, r, a, Math.max(2, o * 0.038)), d.fill(), s = et.from(l), l_.set(i, s), s;
}
let wh = null;
function vte() {
  if (wh) return wh;
  const n = 60, e = n * 2, t = 64, i = t + e * 2, s = document.createElement("canvas");
  s.width = i, s.height = i;
  const o = s.getContext("2d");
  return o.shadowColor = "rgba(5,8,20,1)", o.shadowBlur = n, o.shadowOffsetX = i * 2, o.fillStyle = "#000", o.beginPath(), o.roundRect(e - i * 2, e, t, t, 12), o.fill(), wh = et.from(s), wh;
}
const yte = 120, NC = "rd-board-colors", xte = 6e3;
let kd = null, d_ = 0;
function UC() {
  if (kd) return kd;
  kd = /* @__PURE__ */ new Map();
  try {
    const n = localStorage.getItem(NC);
    if (n) for (const [e, t] of JSON.parse(n)) kd.set(e, t);
  } catch {
  }
  return kd;
}
function wte(n) {
  return UC().get(n);
}
function kte(n, e) {
  const t = UC();
  if (t.get(n) !== e) {
    for (t.delete(n), t.set(n, e); t.size > xte; ) t.delete(t.keys().next().value);
    clearTimeout(d_), d_ = window.setTimeout(() => {
      try {
        localStorage.setItem(NC, JSON.stringify(Array.from(t.entries())));
      } catch {
      }
    }, 2e3);
  }
}
const kf = {
  amethyst: { fill: 10053855, fillA: 0.13, line: 12756204, lineA: 0.22 },
  vista: { fill: 5923309, fillA: 0.13, line: 10725365, lineA: 0.22 },
  sky: { fill: 4044006, fillA: 0.13, line: 10082803, lineA: 0.22 },
  mint: { fill: 3458970, fillA: 0.13, line: 9430473, lineA: 0.22 },
  amber: { fill: 15774794, fillA: 0.13, line: 16241807, lineA: 0.22 },
  rose: { fill: 15489946, fillA: 0.13, line: 16098247, lineA: 0.22 },
  glass: { fill: 16777215, fillA: 0.06, line: 16777215, lineA: 0.1 }
};
function _te() {
  const n = new mn(), e = new Ko();
  return n.addChild(e), { root: n, g: e, thumbs: [] };
}
function _f() {
  const t = (Rt.w - 28 - 2 - 18) / 4;
  return [0, 1, 2, 3].map((i) => ({ x: 15 + i * (t + 6), y: 63, s: t }));
}
function GC(n, e, t, i, s) {
  const o = Nc, r = n.g, a = i ? 1251368 : 16777215;
  r.clear(), r.roundRect(0, 0, e, o, 16), r.fill(i ? { color: 16777215, alpha: 1 } : s ? { color: 10053855, alpha: 0.1 } : { color: 16777215, alpha: 0.062 }), r.roundRect(0.5, 0.5, e - 1, o - 1, 15.5), r.stroke({ width: 1, color: i ? s ? 7680723 : 1251368 : s ? 12756204 : 16777215, alpha: i ? s ? 0.3 : 0.14 : s ? 0.24 : 0.1 }), r.roundRect(14, 14, 36, 36, 12).fill({ color: a, alpha: i ? 0.05 : 0.06 }), r.roundRect(24, 24, 16, 16, 4).fill({ color: i ? 7680723 : 12756204, alpha: 0.55 }), r.roundRect(60, 20, 46, 5, 2.5).fill({ color: a, alpha: i ? 0.3 : 0.22 }), r.roundRect(60, 31, Math.min(e - 120, 30 + t.length * 6.4), 9, 4.5).fill({ color: a, alpha: i ? 0.75 : 0.78 }), r.roundRect(e - 14 - 30, 23, 30, 18, 9).fill({ color: a, alpha: i ? 0.06 : 0.05 });
}
function Ste(n, e, t) {
  const i = e.scale || 1, s = Rt.w, o = Rt.h, r = n.g;
  if (e.collapsed) {
    GC(n, s, e.name || "", t, !1), n.root.position.set(e.x, e.y), n.root.scale.set(i), n.root.zIndex = e.z;
    return;
  }
  r.clear(), r.roundRect(0, 0, s, o, 16), r.fill(t ? { color: 16777215, alpha: 1 } : { color: 16777215, alpha: 0.062 }), r.roundRect(0.5, 0.5, s - 1, o - 1, 15.5), r.stroke({ width: 1, color: t ? 1251368 : 16777215, alpha: t ? 0.14 : 0.1 });
  const a = t ? 1251368 : 16777215;
  r.roundRect(15, 15, 36, 36, 12).fill({ color: a, alpha: t ? 0.05 : 0.06 }), r.roundRect(25, 25, 16, 16, 4).fill({ color: t ? 7680723 : 12756204, alpha: 0.55 }), r.roundRect(61, 21, 46, 5, 2.5).fill({ color: a, alpha: t ? 0.3 : 0.22 }), r.roundRect(61, 32, Math.min(130, 30 + (e.name || "").length * 6.4), 9, 4.5).fill({ color: a, alpha: t ? 0.75 : 0.78 }), r.roundRect(s - 15 - 30, 24, 30, 18, 9).fill({ color: a, alpha: t ? 0.06 : 0.05 }), r.roundRect(15, o - 15 - 6, 70, 5, 2.5).fill({ color: a, alpha: t ? 0.25 : 0.2 });
  const l = _f(), d = (e.thumbs || []).slice(0, 4);
  for (let c = d.length; c < 4; c++) {
    const h = l[c];
    r.roundRect(h.x, h.y, h.s, h.s, 8).stroke({ width: 1, color: a, alpha: 0.1 });
  }
  n.root.position.set(e.x, e.y), n.root.scale.set(i), n.root.zIndex = e.z;
}
function Mte(n, e, t) {
  const i = _f();
  for (; n.thumbs.length > e; ) n.thumbs.pop().destroy();
  for (; n.thumbs.length < e; ) {
    const s = new ks(et.WHITE);
    n.root.addChild(s), n.thumbs.push(s);
  }
  n.thumbs.forEach((s, o) => {
    const r = i[o], a = t(o);
    (s.texture === et.WHITE || !s.texture) && (s.texture = a.texture, s.tint = a.tint), s.position.set(r.x, r.y), s.setSize(r.s, r.s);
  });
}
function Tte(n, e, t) {
  const i = e.w || Ri.w, s = e.h || Ri.h, o = n.g;
  if (e.collapsed) {
    GC(n, i, e.name || "", t, !0), n.root.position.set(e.x, e.y), n.root.scale.set(1), n.root.zIndex = e.z;
    return;
  }
  o.clear(), o.roundRect(0, 0, i, s, 16), o.fill(t ? { color: 16777215, alpha: 1 } : { color: 10053855, alpha: 0.1 }), o.roundRect(0.5, 0.5, i - 1, s - 1, 15.5), o.stroke({ width: 1, color: t ? 7680723 : 12756204, alpha: t ? 0.3 : 0.24 });
  const r = t ? 1251368 : 16777215;
  o.roundRect(15, 15, 36, 36, 12).fill({ color: r, alpha: t ? 0.05 : 0.06 }), o.roundRect(24, 26, 18, 13, 4).fill({ color: t ? 7680723 : 12756204, alpha: 0.6 }), o.roundRect(61, 21, 40, 5, 2.5).fill({ color: r, alpha: t ? 0.3 : 0.22 }), o.roundRect(61, 32, Math.min(130, 30 + (e.name || "").length * 6.4), 9, 4.5).fill({ color: r, alpha: t ? 0.75 : 0.78 }), o.roundRect(i - 15 - 30, 24, 30, 18, 9).fill({ color: r, alpha: t ? 0.06 : 0.05 }), o.roundRect(15, 68, i - 30, 7, 3.5).fill({ color: r, alpha: t ? 0.4 : 0.32 }), o.roundRect(15, 84, (i - 30) * 0.66, 7, 3.5).fill({ color: r, alpha: t ? 0.4 : 0.32 }), o.roundRect(15, s - 15 - 6, 70, 5, 2.5).fill({ color: r, alpha: t ? 0.25 : 0.2 }), n.root.position.set(e.x, e.y), n.root.scale.set(1), n.root.zIndex = e.z;
}
function Cte(n, e) {
  const t = { color: 15132910, alpha: 1 };
  if (n.type === "tool") return e ? t : { color: 16777215, alpha: 0.09 };
  if (n.type === "chat") return e ? t : { color: 10053855, alpha: 0.16 };
  const i = kf[n.tint] || kf.glass;
  return e && n.tint === "glass" ? t : { color: i.fill, alpha: (e ? i.fillA * 1.4 : i.fillA) + 0.05 };
}
function Ite(n, e, t) {
  const i = n.g, s = kf[e.tint] || kf.glass;
  i.clear(), i.roundRect(0, 0, e.w, e.h, 16), t && e.tint === "glass" ? i.fill({ color: 16777215, alpha: 1 }) : i.fill({ color: s.fill, alpha: t ? s.fillA * 1.4 : s.fillA }), i.roundRect(0.5, 0.5, e.w - 1, e.h - 1, 15.5), i.stroke({ width: 1, color: t && e.tint === "glass" ? 1251368 : s.line, alpha: t ? 0.3 : s.lineA });
  const o = t ? 1251368 : 16777215, r = e.w - 32, a = Math.max(4, Math.floor(r / 7.1)), l = Math.max(0, Math.floor((e.h - 32 - 20) / 19.6));
  let d = 0;
  for (const c of String((e.link ? e.link.title : e.text) || "").split(`
`)) {
    const h = c.trim().length;
    if (!h) {
      d++;
      continue;
    }
    const f = Math.ceil(h / a);
    for (let p = 0; p < f && d < l; p++, d++) {
      const y = p === f - 1 ? h - a * p : a;
      i.roundRect(16, 16 + d * 19.6 + 6, Math.max(10, y / a * r), 7, 3.5).fill({ color: o, alpha: t ? 0.55 : 0.5 });
    }
    if (d >= l) break;
  }
  i.roundRect(16, e.h - 16 - 7, 16, 6, 3).fill({ color: o, alpha: 0.22 }), n.root.position.set(e.x, e.y), n.root.scale.set(1), n.root.zIndex = e.z;
}
var Ate = Object.defineProperty, Pte = (n, e, t) => e in n ? Ate(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, gt = (n, e, t) => Pte(n, typeof e != "symbol" ? e + "" : e, t);
const c_ = 10053855, Ete = 12, u_ = 650, Rte = 0.05, zte = 0.06;
class $te {
  constructor(e) {
    gt(this, "app"), gt(this, "camera", { x: 0, y: 0, zoom: 1 }), gt(this, "viewW", 1), gt(this, "viewH", 1), gt(this, "dpr", 1), gt(this, "theme"), gt(this, "opts"), gt(this, "store"), gt(this, "world"), gt(this, "frameLayer"), gt(this, "imageLayer"), gt(this, "shapeLayer"), gt(this, "cardLayer"), gt(this, "screenLayer"), gt(this, "far", !1), gt(this, "simple", !1), gt(this, "rings"), gt(this, "textures"), gt(this, "micro", new bte()), gt(this, "nodes", /* @__PURE__ */ new Map()), gt(this, "unsub", null), gt(this, "resizeObs", null), gt(this, "raf", 0), gt(this, "paused", !1), gt(this, "ringsDirty", !0), gt(this, "cameraChanged", !0), gt(this, "lastCameraMove", 0), gt(this, "settledPass", !1), gt(this, "tween", null), gt(this, "visibleIds", /* @__PURE__ */ new Set()), gt(this, "lastCull", null), gt(this, "selection", /* @__PURE__ */ new Set()), gt(this, "dragging", !1), gt(this, "hoverId", null), gt(this, "hidden", /* @__PURE__ */ new Set()), gt(this, "enteringUntil", 0), gt(this, "destroyed", !1), gt(this, "frameTimes", []), gt(this, "lastFrameAt", 0), gt(this, "lastRenderMs", 0), gt(this, "statsAt", 0), gt(this, "ready"), this.opts = e, this.store = e.store, this.theme = e.theme || "dark", this.ready = this.init();
  }
  // ------------------------------------------------------------- setup
  async init() {
    const e = this.opts.host;
    this.dpr = Math.min(2, window.devicePixelRatio || 1);
    const t = e.getBoundingClientRect();
    this.viewW = Math.max(1, t.width), this.viewH = Math.max(1, t.height);
    const i = new gM();
    if (await i.init({
      width: this.viewW,
      height: this.viewH,
      resolution: this.dpr,
      autoDensity: !0,
      antialias: !0,
      backgroundAlpha: 0,
      autoStart: !1,
      sharedTicker: !1,
      preference: "webgl",
      powerPreference: "high-performance",
      eventMode: "none"
    }), this.destroyed) {
      i.destroy(!0);
      return;
    }
    this.app = i, i.ticker.stop();
    const s = i.canvas;
    s.className = "bd-canvas", e.appendChild(s), i.stage.eventMode = "none", this.world = new mn({ isRenderGroup: !0 }), this.frameLayer = new mn(), this.imageLayer = new mn(), this.imageLayer.sortableChildren = !0, this.shapeLayer = new mn(), this.shapeLayer.sortableChildren = !0, this.frameLayer.sortableChildren = !0, this.cardLayer = new mn(), this.cardLayer.sortableChildren = !0, this.cardLayer.visible = this.far, this.world.addChild(this.frameLayer, this.imageLayer, this.shapeLayer, this.cardLayer), this.screenLayer = new mn(), this.rings = new Ko(), this.screenLayer.addChild(this.rings), i.stage.addChild(this.world, this.screenLayer);
    const o = (navigator.deviceMemory || 8) <= 4;
    this.textures = new hte({
      budgetBytes: (o ? 160 : 420) * 1024 * 1024,
      maxInFlight: 10,
      radius: Ete,
      onReady: () => this.requestRender(),
      onError: (r, a) => console.warn("[board] image failed to load", r, a)
    }), this.resizeObs = new ResizeObserver(() => this.resize()), this.resizeObs.observe(e);
    for (const r of this.store.all()) this.addNode(r, !1);
    this.unsub = this.store.subscribe((r) => this.onChange(r)), this.requestRender();
  }
  resize() {
    if (!this.app) return;
    const e = this.opts.host.getBoundingClientRect(), t = Math.max(1, e.width), i = Math.max(1, e.height);
    t === this.viewW && i === this.viewH || (this.viewW = t, this.viewH = i, this.app.renderer.resize(t, i), this.cameraChanged = !0, this.requestRender());
  }
  destroy() {
    this.destroyed = !0, cancelAnimationFrame(this.raf), this.unsub && this.unsub(), this.resizeObs && this.resizeObs.disconnect(), this.textures && this.textures.destroy(), this.micro.destroy(), this.app && this.app.destroy(!0, { children: !0 }), this.nodes.clear();
  }
  // ------------------------------------------------------------ camera
  setCamera(e) {
    this.tween = null, this.applyCamera(e);
  }
  applyCamera(e) {
    const t = tr(e.zoom);
    !Number.isFinite(e.x) || !Number.isFinite(e.y) || t === this.camera.zoom && e.x === this.camera.x && e.y === this.camera.y || (this.camera = { x: e.x, y: e.y, zoom: t }, this.cameraChanged = !0, this.ringsDirty = !0, this.lastCameraMove = performance.now(), this.settledPass = !1, this.requestRender());
  }
  /** Glide to a camera with the design's ease-out curve. */
  animateCamera(e, t = 420) {
    const i = { ...e, zoom: tr(e.zoom) };
    return t <= 0 || matchMedia("(prefers-reduced-motion: reduce)").matches ? (this.setCamera(i), Promise.resolve()) : (this.tween && this.tween.resolve(), new Promise((s) => {
      this.tween = { from: { ...this.camera }, to: i, start: performance.now(), ms: t, resolve: s }, this.requestRender();
    }));
  }
  get isAnimatingCamera() {
    return !!this.tween;
  }
  /** Where the camera is headed: a glide's end while one is under way, else where it is. */
  get cameraGoal() {
    return this.tween ? this.tween.to : this.camera;
  }
  zoomAt(e, t, i) {
    this.setCamera(Pv(this.tween ? this.tween.to : this.camera, e, t, i));
  }
  panBy(e, t) {
    const i = this.camera;
    this.setCamera({ zoom: i.zoom, x: i.x + e, y: i.y + t });
  }
  fitTo(e, t = {}) {
    if (!e) return Promise.resolve();
    const i = dm(e, this.viewW, this.viewH, t.pad == null ? 120 : t.pad, t.maxZoom == null ? 1 : t.maxZoom);
    return this.animateCamera(i, t.animate == null ? 420 : t.animate);
  }
  screenToWorld(e, t) {
    return Av(this.camera, e, t);
  }
  get moving() {
    return !!this.tween || performance.now() - this.lastCameraMove < 160;
  }
  // ------------------------------------------------------------- state
  setTheme(e) {
    if (this.theme !== e) {
      this.theme = e;
      for (const t of this.nodes.values())
        t.kind === "frame" && this.drawFrame(t), t.kind === "image" && !t.loaded && (t.sprite.tint = this.placeholderTint(t.el)), t.kind === "card" && this.drawCard(t);
      this.ringsDirty = !0, this.requestRender();
    }
  }
  setSelection(e) {
    this.selection = new Set(e), this.ringsDirty = !0, this.requestRender();
  }
  /** A drag is moving the selection: a shape's square box steps aside while it moves (IL-100). */
  setDragging(e) {
    e !== this.dragging && (this.dragging = e, this.ringsDirty = !0, this.requestRender());
  }
  /** The hovered image lifts 4px and casts a deeper shadow. */
  setHover(e) {
    if (e === this.hoverId) return;
    const t = this.hoverId ? this.nodes.get(this.hoverId) : null;
    t && t.kind === "image" && (t.liftTarget = 0), this.hoverId = e;
    const i = e ? this.nodes.get(e) : null;
    i && i.kind === "image" && !this.selection.has(e) && (i.liftTarget = 1), this.requestRender();
  }
  /** Hide elements another layer is drawing (e.g. while dragged as DOM). */
  setHidden(e) {
    this.hidden = new Set(e);
    for (const t of this.nodes.values()) this.applyVisibility(t);
    this.requestRender();
  }
  /**
   * Far zoom: the engine draws tool sessions and notes itself (cheap
   * stand-ins) and the DOM layer stands down; near, the reverse.
   */
  setFar(e) {
    this.far !== e && (this.far = e, this.cardLayer.visible = e, this.ringsDirty = !0, this.requestRender());
  }
  get isFar() {
    return this.far;
  }
  /** Play the board's entrance: elements rise in with a short stagger. */
  playEntrance() {
    const e = performance.now(), i = Array.from(this.nodes.values()).sort((o, r) => o.el.y - r.el.y || o.el.x - r.el.x).filter((o) => this.isInView(o.el)), s = Math.min(45, 900 / Math.max(1, i.length));
    i.forEach((o, r) => {
      o.enter = e + r * s;
    }), this.enteringUntil = e + i.length * s + u_, this.requestRender();
  }
  // ------------------------------------------------------------ queries
  /** Topmost GPU-drawn element under a screen point (images, shapes, frames). */
  hitTest(e, t) {
    const i = this.screenToWorld(e, t), s = 10 / this.camera.zoom, o = this.store.index.queryPoint(i.x, i.y, s);
    let r = null, a = -1 / 0;
    for (const l of o) {
      const d = this.store.get(l);
      if (!d || this.hidden.has(l)) continue;
      let c;
      if (d.type === "shape") {
        if (!rU(d, i.x, i.y, Math.max(d.sw / 2 + 2 / this.camera.zoom, 7 / this.camera.zoom))) continue;
        c = 3e9 + d.z;
      } else if (d.type === "image") {
        const h = He(d);
        if (i.x < h.x || i.y < h.y || i.x > h.x + h.w || i.y > h.y + h.h) continue;
        c = 2e9 + d.z;
      } else if (d.type === "frame") {
        const h = He(d);
        if (i.x < h.x || i.y < h.y || i.x > h.x + h.w || i.y > h.y + h.h) continue;
        c = 1e9 + d.z;
      } else if (this.far && (d.type === "tool" || d.type === "note" || d.type === "chat")) {
        const h = He(d);
        if (i.x < h.x || i.y < h.y || i.x > h.x + h.w || i.y > h.y + h.h) continue;
        c = 4e9 + d.z;
      } else
        continue;
      c > a && (a = c, r = d);
    }
    return r;
  }
  isInView(e, t = 0) {
    const i = fl(this.camera, this.viewW, this.viewH, t), s = He(e);
    return s.x < i.x + i.w && s.x + s.w > i.x && s.y < i.y + i.h && s.y + s.h > i.y;
  }
  textureStats() {
    return {
      textures: (this.textures ? this.textures.textureCount : 0) + this.micro.pageCount,
      mb: Math.round(((this.textures ? this.textures.totalBytes : 0) + this.micro.bytes) / 1048576),
      pending: this.textures ? this.textures.pending : 0
    };
  }
  // ---------------------------------------------------------- document
  onChange(e) {
    for (const t of e.removed) this.removeNode(t.id);
    for (const t of e.added) this.addNode(t, e.origin !== "load");
    for (const t of e.updated) this.updateNode(t.el, t.after);
    this.ringsDirty = !0, this.lastCull = null, this.requestRender();
  }
  addNode(e, t) {
    if (this.nodes.has(e.id)) return;
    const i = t ? performance.now() : 0;
    if (e.type === "image") {
      const s = new ks($a(e.w, e.h));
      s.tint = this.placeholderTint(e);
      const o = {
        kind: "image",
        el: e,
        sprite: s,
        shown: null,
        loaded: !1,
        lift: 0,
        liftTarget: 0,
        fade: 1,
        under: null,
        shadow: null,
        visible: !1,
        enter: i,
        tiny: !1
      };
      this.layoutImage(o), this.imageLayer.addChild(s), this.textures.track(e.id, e.src, e.w, e.h), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "frame") {
      const s = new Ko(), o = { kind: "frame", el: e, g: s, rect: null, visible: !1, enter: i };
      this.drawFrame(o), this.frameLayer.addChild(s), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "tool" || e.type === "note" || e.type === "chat") {
      const s = _te(), o = { kind: "card", el: e, proxy: s, thumbShown: [], rect: null, visible: !1, enter: i };
      this.drawCard(o), this.cardLayer.addChild(s.root), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "shape") {
      const s = new Ko(), o = { kind: "shape", el: e, g: s, visible: !1, enter: i };
      Nw(s, e), s.position.set(e.x, e.y), s.zIndex = e.z, this.shapeLayer.addChild(s), this.nodes.set(e.id, o), this.applyVisibility(o);
    }
  }
  updateNode(e, t) {
    const i = this.nodes.get(e.id);
    if (i) {
      if (i.kind === "image") {
        const s = e;
        ("src" in t || "w" in t || "h" in t) && (this.textures.track(s.id, s.src, s.w, s.h), this.micro.remove(s.id), i.tiny && this.enterTiny(i)), ("w" in t || "h" in t) && !i.loaded && !i.tiny && (i.sprite.texture = $a(s.w, s.h)), "color" in t && !i.loaded && (i.sprite.tint = this.placeholderTint(s)), this.layoutImage(i);
      } else if (i.kind === "frame")
        this.drawFrame(i);
      else if (i.kind === "card") {
        if ("thumbs" in t) {
          for (let s = 0; s < 4; s++) this.textures.untrack(this.thumbKey(i.el.id, s));
          i.thumbShown = [];
          for (const s of i.proxy.thumbs) s.texture = et.WHITE;
        }
        this.drawCard(i);
      } else
        Nw(i.g, i.el), i.g.position.set(i.el.x, i.el.y), i.g.zIndex = i.el.z;
      this.applyVisibility(i);
    }
  }
  removeNode(e) {
    const t = this.nodes.get(e);
    if (t)
      if (this.nodes.delete(e), this.visibleIds.delete(e), t.kind === "image")
        t.sprite.destroy(), t.under && t.under.destroy(), t.shadow && t.shadow.destroy(), this.textures.untrack(e), this.micro.remove(e);
      else if (t.kind === "card") {
        for (let i = 0; i < 4; i++) this.textures.untrack(this.thumbKey(e, i));
        t.proxy.root.destroy({ children: !0 }), t.rect && t.rect.destroy();
      } else
        t.kind === "frame" && t.rect && t.rect.destroy(), t.g.destroy();
  }
  placeholderTint(e) {
    const t = e.color || wte(e.src);
    if (t && /^#[0-9a-f]{6}$/i.test(t)) {
      const i = parseInt(t.slice(1), 16), s = this.theme === "light" ? 0.92 : 0.82;
      return Math.round((i >> 16 & 255) * s) << 16 | Math.round((i >> 8 & 255) * s) << 8 | Math.round((i & 255) * s);
    }
    return this.theme === "light" ? 14672618 : 1777456;
  }
  layoutImage(e) {
    const t = e.el, i = e.sprite;
    i.position.set(t.x, t.y - 4 * e.lift), i.setSize(t.w, t.h), i.zIndex = t.z, e.under && (e.under.position.copyFrom(i.position), e.under.setSize(t.w, t.h), e.under.zIndex = t.z - 1e-4), e.shadow && this.layoutShadow(e);
  }
  layoutShadow(e) {
    const t = e.shadow, i = e.el, s = 1 + 0.18 * e.lift, o = yte * s * 0.5;
    t.position.set(i.x - o, i.y - o + 18 + 6 * e.lift - 4 * e.lift), t.setSize(i.w + o * 2, i.h + o * 2), t.alpha = (this.theme === "light" ? 0.22 : 0.3) + 0.14 * e.lift, t.zIndex = i.z - 2e-4;
  }
  thumbKey(e, t) {
    return e + "#t" + t;
  }
  drawCard(e) {
    const t = this.theme === "light";
    if (e.el.type === "tool") {
      const i = e.el;
      Ste(e.proxy, i, t);
      const s = i.collapsed ? [] : (i.thumbs || []).slice(0, 4), o = _f()[0].s;
      s.forEach((r, a) => this.textures.track(this.thumbKey(i.id, a), r, o, o)), Mte(e.proxy, s.length, (r) => ({
        texture: $a(1, 1),
        tint: this.placeholderTint({ src: s[r] })
      }));
    } else e.el.type === "chat" ? Tte(e.proxy, e.el, t) : Ite(e.proxy, e.el, t);
    (e.rect || this.simple) && this.layoutRect(e);
  }
  /** A frame's or card's plain-rectangle stand-in (see SIMPLE_IN), made on first use. */
  layoutRect(e) {
    e.rect || (e.rect = new ks(et.WHITE), e.rect.visible = !1, (e.kind === "frame" ? this.frameLayer : this.cardLayer).addChild(e.rect));
    const t = this.theme === "light", i = He(e.el), s = e.kind === "frame" ? { color: 16777215, alpha: t ? 0.62 : 0.03 } : Cte(e.el, t);
    e.rect.position.set(i.x, i.y), e.rect.setSize(i.w, i.h), e.rect.tint = s.color, e.rect.alpha = s.alpha, e.rect.zIndex = e.el.z;
  }
  setSimple(e) {
    this.simple = e;
    for (const t of this.nodes.values())
      t.kind !== "frame" && t.kind !== "card" || (e && this.layoutRect(t), this.applyVisibility(t));
  }
  drawFrame(e) {
    const t = e.el, i = e.g, s = this.theme === "light";
    i.clear(), i.roundRect(0, 0, t.w, t.h, 24), i.fill({ color: 16777215, alpha: s ? 0.62 : 0.022 }), i.roundRect(0.5, 0.5, t.w - 1, t.h - 1, 23.5), i.stroke({ width: 1, color: s ? 1251368 : 16777215, alpha: s ? 0.14 : 0.06 }), i.position.set(t.x, t.y), i.zIndex = t.z, (e.rect || this.simple) && this.layoutRect(e);
  }
  applyVisibility(e) {
    const t = e.visible && !this.hidden.has(e.el.id);
    e.kind === "image" ? (e.sprite.visible = t, e.under && (e.under.visible = t), e.shadow && (e.shadow.visible = t)) : e.kind === "card" ? (e.proxy.root.visible = t && !this.simple, e.rect && (e.rect.visible = t && this.simple)) : e.kind === "frame" ? (e.g.visible = t && !this.simple, e.rect && (e.rect.visible = t && this.simple)) : e.g.visible = t;
  }
  // --------------------------------------------------------- screenshots
  /**
   * The board as it is on screen now, read back from the GPU into a 2D canvas
   * (a feedback report's screenshot). The WebGL canvas is made without
   * preserveDrawingBuffer, which would cost every frame, so a copy of it taken
   * after the browser presents is blank: this renders the stage itself, in
   * this task. Null before the engine is ready or once it's gone.
   */
  snapshot() {
    if (!this.app || this.destroyed) return null;
    this.cameraChanged && (this.world.position.set(this.camera.x, this.camera.y), this.world.scale.set(this.camera.zoom));
    const e = this.app.renderer.extract.canvas({
      target: this.app.stage,
      frame: new Tt(0, 0, this.viewW, this.viewH),
      resolution: this.dpr,
      antialias: !0
    });
    return e instanceof HTMLCanvasElement ? e : null;
  }
  /** The last 90 frame intervals (ms), oldest first: a feedback report's frame-time history. */
  frameIntervals() {
    return this.frameTimes.slice();
  }
  /** The GPU as this board's WebGL context names it, for a feedback report; null where the browser won't say. */
  gpu() {
    if (!this.app || this.destroyed || !("gl" in this.app.renderer)) return null;
    const e = this.app.renderer.gl, t = e.getExtension("WEBGL_debug_renderer_info"), i = t ? e.getParameter(t.UNMASKED_RENDERER_WEBGL) : e.getParameter(e.RENDERER);
    return typeof i == "string" ? i : null;
  }
  // ------------------------------------------------------------- frame
  requestRender() {
    !this.raf && !this.destroyed && !this.paused && (this.raf = requestAnimationFrame((e) => this.frame(e)));
  }
  /**
   * Covered (the Studios view is open over the board): draw nothing, not
   * even textures still arriving, until it's uncovered; then carry on.
   */
  setPaused(e) {
    this.paused !== e && (this.paused = e, e ? (this.raf && cancelAnimationFrame(this.raf), this.raf = 0) : this.requestRender());
  }
  frame(e) {
    if (this.raf = 0, this.destroyed || !this.app) return;
    const t = performance.now();
    let i = !1;
    if (this.tween) {
      const r = this.tween, a = Math.min(1, (e - r.start) / r.ms);
      this.applyCamera(QN(r.from, r.to, tg(a), this.viewW, this.viewH)), a >= 1 ? (this.tween = null, this.applyCamera(r.to), r.resolve()) : i = !0;
    }
    const s = this.moving;
    if (this.cameraChanged) {
      this.world.position.set(this.camera.x, this.camera.y), this.world.scale.set(this.camera.zoom), this.opts.onCamera && this.opts.onCamera(this.camera, s), this.cameraChanged = !1;
      const r = this.camera.zoom < (this.simple ? zte : Rte);
      r !== this.simple && this.setSimple(r);
    }
    this.cull();
    const o = !s;
    this.updateTextures(o && !this.settledPass), o && (this.settledPass = !0), this.textures.pending && (i = !0), this.animate(e) && (i = !0), this.ringsDirty && this.drawRings(), this.textures.tick(), this.micro.flush(), this.app.render(), s && (i = !0), i && this.requestRender(), this.recordStats(e, performance.now() - t);
  }
  cull() {
    const e = fl(this.camera, this.viewW, this.viewH, 0), t = this.lastCull;
    if (t && e.x >= t.x && e.y >= t.y && e.x + e.w <= t.x + t.w && e.y + e.h <= t.y + t.h && t.w < e.w * 2.2)
      return;
    const i = e.w * 0.35, s = e.h * 0.35, o = { x: e.x - i, y: e.y - s, w: e.w + i * 2, h: e.h + s * 2 };
    this.lastCull = o;
    const r = this.store.index.query(o), a = /* @__PURE__ */ new Set();
    for (const l of r) this.nodes.has(l) && a.add(l);
    for (const l of this.visibleIds)
      if (!a.has(l)) {
        const d = this.nodes.get(l);
        d && (d.visible = !1, this.applyVisibility(d));
      }
    for (const l of a)
      if (!this.visibleIds.has(l)) {
        const d = this.nodes.get(l);
        d.visible = !0, this.applyVisibility(d);
      }
    this.visibleIds = a;
  }
  updateTextures(e) {
    const t = this.camera.zoom, i = this.dpr, s = (this.viewW / 2 - this.camera.x) / t, o = (this.viewH / 2 - this.camera.y) / t, r = fl(this.camera, this.viewW, this.viewH, 0), a = !this.moving, l = (d) => {
      const c = this.nodes.get(d);
      return !!c && c.kind === "image" && c.tiny;
    };
    for (const d of this.textures.drainReady(a ? 10 : 5, a ? 12 * 1048576 : 5 * 1048576, l, 64)) {
      const c = d.id.indexOf("#t");
      if (c > 0) {
        const f = this.nodes.get(d.id.slice(0, c)), p = Number(d.id.slice(c + 2));
        f && f.kind === "card" && f.proxy.thumbs[p] && (f.proxy.thumbs[p].texture = d.tex.texture, f.proxy.thumbs[p].tint = 16777215, f.thumbShown[p] = d.tex);
        continue;
      }
      const h = this.nodes.get(d.id);
      h && h.kind === "image" && (d.color && kte(h.el.src, d.color), h.tiny ? this.fillCell(h, d.tex) : this.consider(h, d.tex));
    }
    for (const d of this.textures.takeEvicted()) {
      const c = d.id.indexOf("#t");
      if (c > 0) {
        const f = this.nodes.get(d.id.slice(0, c)), p = Number(d.id.slice(c + 2));
        f && f.kind === "card" && f.proxy.thumbs[p] && f.proxy.thumbs[p].texture === d.texture && (f.proxy.thumbs[p].texture = $a(1, 1), f.thumbShown[p] = null), this.textures.release(d.texture);
        continue;
      }
      const h = this.nodes.get(d.id);
      if (h && h.kind === "image" && h.shown && h.shown.texture === d.texture) {
        const f = this.textures.anyFor(d.id);
        f ? this.show(h, f, !1) : this.showPlaceholder(h);
      }
      this.textures.release(d.texture);
    }
    if (this.visibleIds.size) {
      for (const d of this.visibleIds) {
        const c = this.nodes.get(d);
        if (c && c.kind === "card" && this.far && c.el.type === "tool" && t >= 0.08) {
          const S = c.el, M = _f()[0].s * (S.scale || 1), _ = Math.min(4, (S.thumbs || []).length);
          for (let T = 0; T < _; T++) {
            const k = this.textures.request(this.thumbKey(S.id, T), M * t * i, 1e12, a || e);
            k && k !== c.thumbShown[T] && c.proxy.thumbs[T] && (c.proxy.thumbs[T].texture = k.texture, c.proxy.thumbs[T].tint = 16777215, c.thumbShown[T] = k);
          }
          continue;
        }
        if (!c || c.kind !== "image") continue;
        const h = c.el;
        if (!(h.x < r.x + r.w && h.x + h.w > r.x && h.y < r.y + r.h && h.y + h.h > r.y)) continue;
        const p = Math.max(h.w, h.h) * t * i, y = h.x + h.w / 2 - s, v = h.y + h.h / 2 - o, x = (y * y + v * v) * t * t - p * p * 0.25;
        if (p <= pa || c.tiny && p <= pa * 1.25) {
          if (c.tiny || this.enterTiny(c), !this.micro.has(d)) {
            const S = this.textures.anyFor(d);
            S ? this.fillCell(c, S) : this.textures.request(d, p, x, a || e);
          }
          continue;
        }
        c.tiny && this.leaveTiny(c);
        const w = this.textures.request(d, p, x, a || e);
        w && w !== c.shown && this.consider(c, w);
      }
      this.textures.pump();
    }
  }
  /** Tiny on screen: draw from the shared atlas, its cell or (until that fills) the tinted blank. */
  enterTiny(e) {
    e.under && (e.under.destroy(), e.under = null), e.fade = 1, e.sprite.alpha = 1, e.tiny = !0, e.shown = null;
    const t = this.micro.get(e.el.id);
    e.sprite.texture = t || this.micro.placeholder, e.sprite.tint = t ? 16777215 : this.placeholderTint(e.el), e.loaded = !!t, this.layoutImage(e);
  }
  /** Big enough for its own texture again: the best rendition loaded, else the thumbnail stretched. */
  leaveTiny(e) {
    e.tiny = !1;
    const t = this.textures.anyFor(e.el.id), i = this.micro.get(e.el.id);
    t ? (e.sprite.texture = t.texture, e.shown = t) : i ? e.sprite.texture = i : e.sprite.texture = $a(e.el.w, e.el.h), e.loaded = !!(t || i), e.sprite.tint = e.loaded ? 16777215 : this.placeholderTint(e.el), this.layoutImage(e);
  }
  fillCell(e, t) {
    const i = t.texture.source.resource;
    i && (e.sprite.texture = this.micro.put(e.el.id, i, e.el.w, e.el.h), e.sprite.tint = 16777215, e.loaded = !0, this.layoutImage(e), this.requestRender());
  }
  consider(e, t) {
    if (e.shown !== t) {
      if (e.shown && e.shown.tier > t.tier) {
        const i = Math.max(e.el.w, e.el.h) * this.camera.zoom * this.dpr;
        if (e.shown.tier < i * 4) return;
      }
      this.show(e, t, !e.loaded);
    }
  }
  show(e, t, i) {
    i && !matchMedia("(prefers-reduced-motion: reduce)").matches && (e.under || (e.under = new ks(e.sprite.texture), e.under.tint = e.sprite.tint, this.imageLayer.addChild(e.under)), e.fade = 0, e.sprite.alpha = 0), e.sprite.texture = t.texture, e.sprite.tint = 16777215, e.shown = t, e.loaded = !0, this.layoutImage(e), this.applyVisibility(e), this.requestRender();
  }
  showPlaceholder(e) {
    e.sprite.texture = $a(e.el.w, e.el.h), e.sprite.tint = this.placeholderTint(e.el), e.shown = null, e.loaded = !1, this.layoutImage(e);
  }
  /** Advance per-node animations; true while any is still running. */
  animate(e) {
    let t = !1;
    const i = e < this.enteringUntil;
    for (const s of this.visibleIds) {
      const o = this.nodes.get(s);
      if (o) {
        if (o.kind === "image") {
          let r = !1;
          if (o.lift !== o.liftTarget) {
            const a = o.liftTarget - o.lift;
            o.lift = Math.abs(a) < 0.02 ? o.liftTarget : o.lift + a * 0.28, r = !0, t = !0, o.liftTarget > 0 && !o.shadow && (o.shadow = new ote({
              texture: vte(),
              leftWidth: 124,
              rightWidth: 124,
              topHeight: 124,
              bottomHeight: 124
            }), this.imageLayer.addChild(o.shadow)), o.lift === 0 && o.liftTarget === 0 && o.shadow && (o.shadow.destroy(), o.shadow = null);
          }
          o.fade < 1 && (o.fade = Math.min(1, o.fade + 0.09), o.sprite.alpha = tg(o.fade), o.fade >= 1 && o.under && (o.under.destroy(), o.under = null), t = !0), r && this.layoutImage(o);
        }
        if (i || o.enter) {
          const r = o.enter ? Math.min(1, Math.max(0, (e - o.enter) / u_)) : 1, a = tg(r), l = o.kind === "image" ? o.sprite : o.kind === "card" ? o.proxy.root : o.g, d = o.kind === "image" ? o.el.y - 4 * o.lift : o.el.y;
          l.y = d + 34 * (1 - a), o.kind === "image" ? o.fade >= 1 && (l.alpha = a) : l.alpha = a, r < 1 ? t = !0 : o.enter = 0;
        }
      }
    }
    return t;
  }
  drawRings() {
    this.ringsDirty = !1;
    const e = this.rings;
    if (e.clear(), !this.selection.size) return;
    const t = this.camera.zoom, i = this.theme === "light";
    for (const s of this.selection) {
      const o = this.nodes.get(s);
      if (!o || o.kind === "card" && !this.far) continue;
      const r = o.el;
      if (this.dragging && r.type === "shape") continue;
      let a = 3, l = 12 * t + 3;
      r.type === "frame" && (l = 24 * t + 3), (r.type === "tool" || r.type === "note" || r.type === "chat") && (l = 16 * t * (r.scale || 1) + 3), r.type === "shape" && (a = r.shape === "line" || r.shape === "arrow" ? 12 : 9, l = 10);
      const d = He(r), c = d.x * t + this.camera.x - a, h = (d.y - (o.kind === "image" ? 4 * o.lift : 0)) * t + this.camera.y - a, f = d.w * t + a * 2, p = d.h * t + a * 2;
      e.roundRect(c - 2.75, h - 2.75, f + 5.5, p + 5.5, l + 2.75), e.stroke({ width: 4, color: c_, alpha: i ? 0.2 : 0.16 }), e.roundRect(c, h, f, p, l), e.stroke({ width: 1.5, color: c_, alpha: 1 });
    }
  }
  recordStats(e, t) {
    if (this.lastFrameAt) {
      const i = e - this.lastFrameAt;
      i < 250 && this.frameTimes.push(i), this.frameTimes.length > 90 && this.frameTimes.shift();
    }
    this.lastFrameAt = e, this.lastRenderMs = t, !(!this.opts.onStats || e - this.statsAt < 250) && (this.statsAt = e, this.opts.onStats(this.currentStats()));
  }
  /** What the stats readout shows, as of the last frame: a feedback report carries it too. */
  currentStats() {
    const e = this.frameTimes.length ? this.frameTimes.reduce((s, o) => s + o, 0) / this.frameTimes.length : 16.7;
    let t = 0;
    for (const s of this.nodes.values()) s.kind === "image" && t++;
    const i = this.textureStats();
    return {
      fps: Math.round(1e3 / e),
      frameMs: Math.round(this.lastRenderMs * 10) / 10,
      visible: this.visibleIds.size,
      images: t,
      textures: i.textures,
      textureMB: i.mb,
      pending: i.pending
    };
  }
}
function Dte() {
  return /* @__PURE__ */ Xt({
    mode: "select",
    selection: [],
    editingNote: null,
    editingTitle: null,
    marquee: null,
    panning: !1,
    dragging: !1,
    addMenu: !1,
    placeMenu: !1,
    canvasMenu: null,
    finder: null,
    boardLinkMenu: null,
    libraryOpen: null,
    shapeKind: "rect",
    shapeArmed: !1,
    shapeMenu: !1,
    shapeStyle: { ...io },
    styleOpen: !1,
    infoAt: null,
    infoSave: !1,
    infoSession: null,
    histOpen: !0,
    miniOpen: !0,
    miniGoing: !1,
    lightCanvas: !1,
    showGrid: !0,
    advOpen: !1,
    ghost: null,
    hoverId: null,
    newThumbs: {},
    recentIds: [],
    pinnedIds: [],
    pinnedModelIds: [],
    cameraViews: [],
    noteTint: "amethyst",
    promptH: null,
    boardMenu: !1,
    ctxMenu: !1,
    keysOpen: !1,
    trashOpen: !1,
    boardHistory: !1,
    chatOpen: null,
    toast: null,
    showStats: !1,
    refTarget: !1,
    eyedropper: null,
    refPulse: null,
    refSession: null,
    refGlow: null,
    studio: null,
    library: { open: !1, sessionId: null, tab: "featured", category: null, query: "", detail: null, levels: [], kind: null, action: null, at: null, editing: null, saveLevels: { board: !0, team: !1 } },
    promptLanded: null,
    promptCardH: 0
  });
}
const Ote = {
  lightCanvas: !1,
  showGrid: !0,
  shapeStyle: { ...io },
  shapeKind: "rect",
  histOpen: !0,
  miniOpen: !0,
  recentIds: [],
  pinnedIds: [],
  pinnedModelIds: [],
  noteTint: "amethyst",
  camera: null,
  promptH: null,
  library: { tab: "featured", category: null },
  pinHintSeen: !1,
  cameraViews: [],
  histSeenAt: null
}, jC = ["recentIds", "pinnedIds", "camera", "histSeenAt"], HC = ["lightCanvas", "showGrid", "shapeStyle", "shapeKind", "histOpen", "miniOpen", "noteTint", "promptH", "library", "pinHintSeen", "pinnedModelIds", "cameraViews"], VC = (n, e) => "rd-board-prefs:" + n + ":" + e, WC = (n) => "rd-board-prefs:" + n;
function Lte(n, e) {
  let t = JSON.parse(JSON.stringify(Ote));
  try {
    const i = JSON.parse(localStorage.getItem(WC(n)) || "{}"), s = JSON.parse(localStorage.getItem(VC(n, e)) || "{}");
    t = { ...t, ...Sf(i, HC), ...Sf(s, jC) };
  } catch {
  }
  return t;
}
function Bte(n, e, t) {
  try {
    localStorage.setItem(WC(n), JSON.stringify(Sf(t, HC))), localStorage.setItem(VC(n, e), JSON.stringify(Sf(t, jC)));
  } catch {
  }
}
function Sf(n, e) {
  const t = {};
  if (!n || typeof n != "object") return t;
  for (const i of e) n[i] !== void 0 && (t[i] = n[i]);
  return t;
}
var Fte = Object.defineProperty, Nte = (n, e, t) => e in n ? Fte(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, kh = (n, e, t) => Nte(n, typeof e != "symbol" ? e + "" : e, t);
class Ute {
  constructor() {
    kh(this, "bySession", /* @__PURE__ */ new Map()), kh(this, "byId", /* @__PURE__ */ new Map()), kh(this, "rev", /* @__PURE__ */ qe(0)), kh(this, "listeners", /* @__PURE__ */ new Set());
  }
  list(e) {
    return this.bySession.get(e) || [];
  }
  get(e) {
    return this.byId.get(e);
  }
  /** Every result, any session (the tour's Back puts a board back as a step found it). */
  all() {
    return Array.from(this.byId.values());
  }
  get size() {
    return this.byId.size;
  }
  /**
   * Insert or replace, keeping each list newest first. Lists are
   * copy-on-write: a changed session gets a new array, so anything that
   * derives from list() sees the change.
   */
  upsert(e, t = !0) {
    if (!e.length) return;
    const i = /* @__PURE__ */ new Map();
    for (const s of e) {
      const o = this.byId.get(s.id);
      this.byId.set(s.id, s);
      let r = i.get(s.sessionId);
      r || (r = (this.bySession.get(s.sessionId) || []).slice(), i.set(s.sessionId, r));
      const a = o ? r.indexOf(o) : -1;
      a >= 0 ? r[a] = s : r.push(s);
    }
    for (const [s, o] of i)
      o.sort((r, a) => a.createdAt - r.createdAt), this.bySession.set(s, o);
    if (this.rev.value++, xs(this.rev), t) for (const s of this.listeners) s(e);
  }
  /**
   * A run's results as they now are: its placeholders give way to its
   * results, or to nothing if it failed. One change for the lot.
   */
  replaceRun(e, t) {
    const i = [];
    for (const s of this.byId.values()) s.runId === e && !t.some((o) => o.id === s.id) && i.push(s.id);
    i.length && this.drop(i), t.length ? this.upsert(t, !1) : i.length && this.bump();
  }
  /** Every result of a run, in its order. */
  ofRun(e) {
    const t = [];
    for (const i of this.byId.values()) i.runId === e && t.push(i);
    return t.sort((i, s) => i.createdAt - s.createdAt);
  }
  drop(e) {
    const t = /* @__PURE__ */ new Set();
    for (const i of e) {
      const s = this.byId.get(i);
      s && (this.byId.delete(i), t.add(s.sessionId));
    }
    for (const i of t) this.bySession.set(i, (this.bySession.get(i) || []).filter((s) => this.byId.has(s.id)));
  }
  bump() {
    this.rev.value++, xs(this.rev);
  }
  remove(e) {
    const t = /* @__PURE__ */ new Set();
    for (const i of e) {
      const s = this.byId.get(i);
      s && (this.byId.delete(i), t.add(s.sessionId));
    }
    for (const i of t) this.bySession.set(i, (this.bySession.get(i) || []).filter((s) => this.byId.has(s.id)));
    this.rev.value++, xs(this.rev);
  }
  clear() {
    this.bySession.clear(), this.byId.clear(), this.rev.value++, xs(this.rev);
  }
  /** Local changes, for the sync adapter to persist. */
  onLocalChange(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
}
const qC = 768;
function ir(n) {
  return new Promise((e, t) => {
    const i = new Image(), s = n.startsWith("data:") || n.startsWith("blob:");
    s || (i.crossOrigin = "anonymous"), i.onload = () => e(i), i.onerror = () => t(new Error("stand-in: picture not read")), i.src = s ? n : n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
  });
}
function sr(n, e) {
  if (typeof document == "undefined") return null;
  const t = document.createElement("canvas");
  t.width = Math.max(1, Math.round(n)), t.height = Math.max(1, Math.round(e));
  const i = t.getContext("2d");
  return i ? { c: t, x: i } : null;
}
function vm(n, e = qC) {
  const t = Math.min(1, e / Math.max(n.naturalWidth, n.naturalHeight));
  return { w: Math.round(n.naturalWidth * t), h: Math.round(n.naturalHeight * t) };
}
function Vs(n, e) {
  const t = n[e];
  return typeof t == "number" && Number.isFinite(t) ? t : null;
}
async function Gte(n) {
  const e = await ir(n), t = vm(e), i = sr(t.w, t.h);
  if (!i) return null;
  i.x.drawImage(e, 0, 0, t.w, t.h);
  const s = sr(t.w, t.h), o = s.x.createRadialGradient(t.w / 2, t.h * 0.55, Math.min(t.w, t.h) * 0.22, t.w / 2, t.h * 0.55, Math.min(t.w, t.h) * 0.46);
  return o.addColorStop(0, "rgba(0,0,0,1)"), o.addColorStop(0.85, "rgba(0,0,0,1)"), o.addColorStop(1, "rgba(0,0,0,0)"), s.x.fillStyle = o, s.x.fillRect(0, 0, t.w, t.h), i.x.globalCompositeOperation = "destination-in", i.x.drawImage(s.c, 0, 0), { url: i.c.toDataURL("image/png"), ...t };
}
async function jte(n) {
  const e = await ir(n), t = 160, i = Math.max(1, Math.round(t * e.naturalHeight / e.naturalWidth)), s = sr(t, i);
  if (!s) return null;
  s.x.drawImage(e, 0, 0, t, i);
  const o = s.x.getImageData(0, 0, t, i).data, r = 7, a = [];
  for (let x = 0; x < r; x++) {
    const w = Math.floor((x + 0.5) / r * t * i) * 4;
    a.push([o[w], o[w + 1], o[w + 2]]);
  }
  const l = new Uint8Array(t * i);
  for (let x = 0; x < 8; x++) {
    const w = a.map(() => [0, 0, 0, 0]);
    for (let S = 0; S < t * i; S++) {
      const M = o[S * 4], _ = o[S * 4 + 1], T = o[S * 4 + 2];
      let k = 0, P = 1 / 0;
      for (let R = 0; R < r; R++) {
        const D = (M - a[R][0]) ** 2 + (_ - a[R][1]) ** 2 + (T - a[R][2]) ** 2;
        D < P && (P = D, k = R);
      }
      l[S] = k;
      const A = w[k];
      A[0] += M, A[1] += _, A[2] += T, A[3]++;
    }
    w.forEach((S, M) => {
      S[3] && (a[M] = [S[0] / S[3], S[1] / S[3], S[2] / S[3]]);
    });
  }
  const d = new Int32Array(t * i).fill(-1), c = [];
  let h = 0;
  const f = [];
  for (let x = 0; x < t * i; x++) {
    if (d[x] >= 0) continue;
    d[x] = h, f.push(x);
    let w = 0;
    for (; f.length; ) {
      const S = f.pop();
      w++;
      const M = S % t, _ = (S - M) / t, T = [M > 0 ? S - 1 : -1, M < t - 1 ? S + 1 : -1, _ > 0 ? S - t : -1, _ < i - 1 ? S + t : -1];
      for (const k of T)
        k < 0 || d[k] >= 0 || l[k] !== l[S] || (d[k] = h, f.push(k));
    }
    c.push(w), h++;
  }
  const p = t * i * 4e-3;
  for (let x = 0; x < 2; x++)
    for (let w = 0; w < t * i; w++) {
      if (c[d[w]] >= p) continue;
      const M = w % t > 0 ? w - 1 : w + 1 < t * i ? w + 1 : w;
      c[d[M]] >= p && (d[w] = d[M]);
    }
  const y = /* @__PURE__ */ new Map(), v = s.x.createImageData(t, i);
  for (let x = 0; x < t * i; x++) {
    let w = y.get(d[x]);
    w === void 0 && (w = y.size + 1, y.set(d[x], w)), v.data[x * 4] = w & 255, v.data[x * 4 + 1] = w >> 8 & 255, v.data[x * 4 + 2] = 0, v.data[x * 4 + 3] = 255;
  }
  return s.x.putImageData(v, 0, 0), { url: s.c.toDataURL("image/png"), w: t, h: i };
}
async function Hte(n, e) {
  const t = await ir(n), i = vm(t), s = sr(i.w, i.h);
  if (!s) return null;
  if (s.x.drawImage(t, 0, 0, i.w, i.h), !e) return { url: s.c.toDataURL("image/jpeg", 0.88), ...i };
  const o = await ir(e), r = sr(i.w, i.h);
  return r.x.filter = "blur(" + Math.round(Math.max(i.w, i.h) / 22) + "px)", r.x.drawImage(t, -i.w * 0.06, -i.h * 0.06, i.w * 1.12, i.h * 1.12), r.x.filter = "none", r.x.globalCompositeOperation = "destination-in", r.x.filter = "blur(3px)", r.x.drawImage(o, 0, 0, i.w, i.h), s.x.drawImage(r.c, 0, 0), { url: s.c.toDataURL("image/jpeg", 0.88), ...i };
}
async function Vte(n, e) {
  const t = await ir(n), i = Vs(e, "canvasWidth"), s = Vs(e, "canvasHeight");
  if (!i || !s) return null;
  const o = Math.min(1, qC / Math.max(i, s)), r = Math.round(i * o), a = Math.round(s * o), l = sr(r, a);
  if (!l) return null;
  const d = (Vs(e, "imageWidth") || t.naturalWidth) * o, c = (Vs(e, "imageHeight") || t.naturalHeight) * o, h = (Vs(e, "imageX") || 0) * o, f = (Vs(e, "imageY") || 0) * o;
  return l.x.filter = "blur(" + Math.round(Math.max(r, a) / 18) + "px) saturate(1.05)", l.x.drawImage(t, -r * 0.05, -a * 0.05, r * 1.1, a * 1.1), l.x.filter = "none", l.x.drawImage(t, h, f, d, c), { url: l.c.toDataURL("image/jpeg", 0.88), w: r, h: a };
}
async function Wte(n, e) {
  var t, i, s;
  const o = await ir(n), r = vm(o), a = sr(r.w, r.h);
  if (!a) return null;
  const l = (t = Vs(e, "rotate")) != null ? t : 45, d = (i = Vs(e, "vertical")) != null ? i : 0, c = (s = Vs(e, "zoom")) != null ? s : 5, h = (l % 360 + 360) % 360, f = h > 180 ? h - 360 : h, p = Math.abs(f) > 120, y = 1 + (c - 5) * 0.06;
  return a.x.fillStyle = "#20222b", a.x.fillRect(0, 0, r.w, r.h), a.x.save(), a.x.translate(r.w / 2, r.h / 2), a.x.transform(1 - Math.abs(Math.sin(f * Math.PI / 180)) * 0.18, Math.sin(f * Math.PI / 180) * 0.12, 0, 1 - d / 90 * 0.12, 0, 0), a.x.scale(p ? -y : y, y), a.x.drawImage(o, -r.w / 2, -r.h / 2, r.w, r.h), a.x.restore(), { url: a.c.toDataURL("image/jpeg", 0.88), ...r };
}
async function qte(n, e) {
  const t = await ir(n), i = vm(t), s = sr(i.w, i.h);
  if (!s) return null;
  s.x.drawImage(t, 0, 0, i.w, i.h);
  const o = /golden|warm|tungsten|candle|dusk|night/i.test(e), r = /from the (front )?left/i.test(e), a = s.x.createLinearGradient(r ? 0 : i.w, 0, r ? i.w : 0, i.h * 0.4);
  return a.addColorStop(0, o ? "rgba(255,170,80,0.55)" : "rgba(170,200,255,0.5)"), a.addColorStop(1, "rgba(10,8,30,0.55)"), s.x.globalCompositeOperation = "soft-light", s.x.fillStyle = a, s.x.fillRect(0, 0, i.w, i.h), /night|dusk|dark/i.test(e) && (s.x.globalCompositeOperation = "multiply", s.x.fillStyle = "rgba(40,50,110,0.5)", s.x.fillRect(0, 0, i.w, i.h)), { url: s.c.toDataURL("image/jpeg", 0.88), ...i };
}
let _h = null;
function Kte() {
  if (_h === null)
    try {
      _h = typeof document != "undefined" && !!document.createElement("canvas").getContext("2d");
    } catch {
      _h = !1;
    }
  return _h;
}
function Yte(n, e, t) {
  return Kte() ? n === "removebg" || n === "select" || n === "erase" || n === "expand" || n === "camera" || e === "upscale" || /^Relighting only|^Relight image 1/.test(t) : !1;
}
async function Xte(n, e, t, i, s) {
  const o = t[0];
  if (!o || typeof document == "undefined") return null;
  try {
    if (n === "removebg") return await Gte(o);
    if (n === "select") return await jte(o);
    if (n === "erase") return await Hte(o, typeof i.__mask == "string" ? i.__mask : null);
    if (n === "expand") return await Vte(o, i);
    if (n === "camera") return await Wte(o, i);
    if (e === "upscale") {
      const r = await ir(o);
      return { url: o, w: r.naturalWidth * 2, h: r.naturalHeight * 2 };
    }
    return /^Relighting only|^Relight image 1/.test(s) ? await qte(o, s) : null;
  } catch (r) {
    return console.warn("[harness] no stand-in for this tool", r), null;
  }
}
var Jte = Object.defineProperty, Zte = (n, e, t) => e in n ? Jte(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, sb = (n, e, t) => Zte(n, typeof e != "symbol" ? e + "" : e, t);
const Qte = {
  "1:1": [1, 1],
  "3:4": [3, 4],
  "4:3": [4, 3],
  "16:9": [16, 9],
  "9:16": [9, 16],
  "2:3": [2, 3],
  "3:2": [3, 2]
};
function Hy(n, e = 316) {
  const t = n && Qte[n] || [4, 3];
  return t[0] >= t[1] ? { w: e, h: Math.round(e * t[1] / t[0]) } : { w: Math.round(e * t[0] / t[1]), h: e };
}
class ene {
  /** `pool`: still images; `videoPool`: videos, each a poster and its playable file */
  constructor(e, t = []) {
    sb(this, "pool", e), sb(this, "videoPool", t), sb(this, "cursor", 0);
  }
  run(e, t) {
    const i = wt(), s = e.model.kitId === "video", o = Hy(e.aspect || (s ? "16:9" : "3:4")), r = Math.max(1, Math.round(parseFloat(String(e.inputs.length || "5s")) || 5)), a = s ? Math.floor(r / 60) + ":" + String(r % 60).padStart(2, "0") : void 0, l = Date.now(), d = [];
    for (let v = 0; v < e.count; v++)
      d.push({
        id: wt(),
        sessionId: e.sessionId,
        status: "pending",
        url: "",
        w: o.w,
        h: o.h,
        prompt: e.prompt,
        model: e.model.name,
        modelId: e.model.id,
        inputs: e.inputs,
        refs: e.refs,
        seed: Math.floor(Math.random() * 1e9),
        author: e.author,
        createdAt: l + v,
        runId: i,
        parents: e.refs.slice(),
        video: s || void 0,
        dur: a
      });
    const c = [];
    let h = !1;
    const f = /\bfail\b/i.test(e.prompt), p = 1300 + Math.random() * 600, y = [];
    if (f)
      c.push(window.setTimeout(() => {
        h || t.onError("The provider rejected this prompt. No tokens were charged.", d);
      }, p));
    else {
      const v = Yte(e.model.boardTool, e.model.kitId, e.prompt);
      d.forEach((x, w) => {
        c.push(window.setTimeout(async () => {
          if (h) return;
          const S = v ? await Xte(e.model.boardTool, e.model.kitId, e.refs, e.inputs, e.prompt) : null;
          if (h) return;
          const M = !S && s && this.videoPool.length ? this.videoPool[this.cursor++ % this.videoPool.length] : null, _ = S ? S.url : M ? M.poster : this.pool[this.cursor++ % this.pool.length], T = {
            ...x,
            status: "done",
            url: _,
            w: S ? S.w : x.w,
            h: S ? S.h : x.h,
            videoSrc: M ? M.src : void 0,
            dur: a,
            took: Date.now() - l,
            label: tne(e.prompt, w)
          };
          y.push(T), t.onResult(T), y.length === d.length && t.onDone(y);
        }, p + w * (260 + Math.random() * 220)));
      });
    }
    return {
      runId: i,
      pending: d,
      cancel: () => {
        h = !0;
        for (const v of c) clearTimeout(v);
      }
    };
  }
}
function tne(n, e) {
  return (String(n || "result").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").trim().split(/\s+/).slice(0, 4).join("_") || "result").slice(0, 24) + "_v" + String(e + 1).padStart(2, "0");
}
const Dr = {
  image: "image",
  video: "video",
  imageEdit: "imageEdit",
  videoEdit: "videoEdit",
  upscale: "upscale",
  // Quoted key: an identifier cannot start with a digit, so this kit is
  // always reached as KIT_TYPE['3d'], unlike its dot-accessed siblings.
  "3d": "3d"
}, v0 = [
  Dr.image,
  Dr.video,
  Dr.imageEdit,
  Dr.videoEdit,
  Dr.upscale,
  Dr["3d"]
], h_ = (n) => typeof n == "string" && Object.prototype.hasOwnProperty.call(Dr, n), nne = "mdi-shape-outline", ob = "Featured", rb = "Other", KC = (n) => {
  const e = {};
  if (!n || typeof n != "object") return e;
  for (const t of Object.keys(n))
    n[t] && (e[t] = !0);
  return e;
}, ine = (n, e, t) => {
  if (!n || typeof n != "object") return null;
  const i = n, s = typeof i.label == "string" ? i.label : "", o = typeof i.icon == "string" ? i.icon : "";
  return !s && !o ? null : {
    // Heal a label authored without an id rather than dropping it. The id
    // is an opaque UI key, so a positional fallback is safe and stable
    // for a given stored array.
    id: typeof i.id == "string" && i.id ? i.id : `${t}:${e}`,
    icon: o,
    label: s,
    value: typeof i.value == "number" ? i.value : null,
    type: typeof i.type == "string" ? i.type : void 0,
    tooltip: typeof i.tooltip == "string" ? i.tooltip : void 0
  };
}, sne = (n) => {
  if (!n || typeof n != "object") return null;
  const e = n, t = typeof e.nodeDefId == "string" ? e.nodeDefId.trim() : "";
  if (!t) return null;
  const i = Array.isArray(e.labels) ? e.labels.map((s, o) => ine(s, o, t)).filter((s) => s !== null) : [];
  return { nodeDefId: t, tags: KC(e.tags), labels: i };
}, one = (n, e) => {
  if (!n || typeof n != "object") return null;
  const t = n, i = h_(t.id) ? t.id : h_(e) ? e : null;
  if (!i) return null;
  const s = Array.isArray(t.tools) ? t.tools.map(sne).filter((o) => o !== null) : [];
  return {
    id: i,
    label: typeof t.label == "string" && t.label ? t.label : i,
    icon: typeof t.icon == "string" && t.icon ? t.icon : nne,
    description: typeof t.description == "string" ? t.description : "",
    sortOrder: typeof t.sortOrder == "number" ? t.sortOrder : v0.indexOf(i),
    // STRICT. Anything other than an explicit `true` is a draft, matching
    // the Firestore rule and the non-admin query in web
    // (`where('isPublished', '==', true)`), which cannot match a document
    // where the field is missing or null. Read loosely, a half-authored Kit
    // would read as live here while being unreadable to the very users it
    // claims to be published for.
    isPublished: t.isPublished === !0,
    // `=== undefined` rather than `??`: web's webpack-4 parser lints the
    // symlinked shared dist and cannot parse nullish-coalescing.
    publishedAt: t.publishedAt === void 0 ? null : t.publishedAt,
    // Faithful (`=== true`) rather than strict-inverse, deliberately: a Kit
    // whose `isDeleted` is missing is INVISIBLE to users (see
    // `isKitReadableByUsers`) but must still appear in Manage Kits, because
    // an admin is the only one who can repair it. Reading a missing field
    // as deleted here would hide the broken Kit from the person fixing it.
    isDeleted: t.isDeleted === !0,
    deletedAt: t.deletedAt === void 0 ? null : t.deletedAt,
    defaultNodeDefId: typeof t.defaultNodeDefId == "string" && t.defaultNodeDefId ? t.defaultNodeDefId : null,
    surfaces: t.surfaces && typeof t.surfaces == "object" ? KC(t.surfaces) : null,
    tools: s
  };
}, rne = (n) => {
  if (!n || typeof n != "object") return !1;
  const e = n;
  return e.isPublished === !0 && e.isDeleted === !1;
}, ane = (n, e) => {
  if (!e) return !0;
  const t = n.surfaces;
  return !t || !Object.keys(t).length ? !0 : !!t[e];
}, lne = (n) => {
  const e = [];
  for (const s of n)
    for (const o of Object.keys(s.tags))
      e.includes(o) || e.push(o);
  const t = e.filter((s) => s !== ob && s !== rb).sort((s, o) => s.localeCompare(o));
  return [
    ...e.includes(ob) ? [ob] : [],
    ...t,
    ...e.includes(rb) ? [rb] : []
  ].map((s) => ({ key: s, label: s }));
}, dne = (n) => {
  const { nodeDefs: e, isBlocked: t, surface: i, includeUnpublished: s } = n, o = one(n.kit);
  if (!o || !s && !rne(n.kit) || !ane(o, i)) return null;
  const r = {};
  for (const c of e || [])
    c && typeof c.id == "string" && (r[c.id] = c);
  const a = [], l = {};
  for (const c of o.tools) {
    if (l[c.nodeDefId]) continue;
    const h = r[c.nodeDefId];
    h && (!s && (h.isPublished === !1 || h.isDeleted === !0) || t && t(h) || (l[c.nodeDefId] = !0, a.push({
      value: h.id,
      nodeDefId: h.id,
      text: typeof h.title == "string" ? h.title : "",
      description: typeof h.description == "string" ? h.description : "",
      imageUrl: h.imageUrl || null,
      avatar: h.avatar || null,
      newUntil: h.newUntil === void 0 ? null : h.newUntil,
      sortOrder: typeof h.sortOrder == "number" ? h.sortOrder : 0,
      tags: c.tags,
      labels: c.labels,
      nodeDef: h
    })));
  }
  const d = a.some((c) => c.nodeDefId === o.defaultNodeDefId) ? o.defaultNodeDefId : a.length ? a[0].nodeDefId : null;
  return {
    id: o.id,
    label: o.label,
    icon: o.icon,
    description: o.description,
    sortOrder: o.sortOrder,
    tools: a,
    tags: lne(a),
    defaultNodeDefId: d
  };
}, cne = (n) => {
  const e = [];
  for (const t of n.kits || []) {
    const i = dne({ ...n, kit: t });
    i && e.push(i);
  }
  return e.sort((t, i) => t.sortOrder - i.sortOrder || v0.indexOf(t.id) - v0.indexOf(i.id));
}, Ti = {
  image: "YrM1HzvaCa9i1Y62U05t",
  video: "yAF6gcg8KczjQx4XVBgr",
  threed: "tfGE9ARninUX4Ledph0j",
  upscaling: "ZV5i4keWclGqG7zfUMPw",
  app: "bt7aOyhEugBXpHu80JsX",
  pluginEdit: "TN70c8DUV6X82hM8xM9W",
  pluginLayers: "b1fdfcfIpojbCLpks6JI"
}, YC = [
  { id: "image", name: "Image", icon: "Image", desc: "Create images with AI-powered models", prefer: ["Nano Banana Pro", "Nano Banana 2", "ChatGPT Image 2.0", "ChatGPT Image 1.5", "Seedream V5 Lite", "Flux 2 Pro", "Seedream V5 Pro"] },
  { id: "video", name: "Video", icon: "Video", desc: "Generate dynamic videos and animations", prefer: ["Kling 3.0 Pro", "Veo 3.1 Fast", "Kling 2.6 Pro", "LTX 2.3", "Seedance 2.0", "Hailuo 2"] },
  { id: "threed", name: "3D", icon: "Box", desc: "Generate 3D models from images or prompts", prefer: ["Hunyuan3D 3", "Trellis 2", "Rodin Gen-2", "Meshy v7", "Tripo"] },
  { id: "upscale", name: "Upscale", icon: "Maximize2", desc: "Upscale your images and videos", prefer: ["Topaz Generative Upscale", "SeedVR Upscale", "Magnific Upscale", "AuraSR - True Upscaler", "Topaz Video Upscale"] }
];
function XC(n) {
  const e = n.tags || {};
  return (e[Ti.app] || e[Ti.pluginEdit] || e[Ti.pluginLayers]) && !e[Ti.image] && !e[Ti.video] ? null : e[Ti.upscaling] ? "upscale" : e[Ti.threed] ? "threed" : e[Ti.video] ? "video" : e[Ti.image] ? "image" : null;
}
function une(n) {
  const e = n.tags || {};
  return e[Ti.app] ? null : e[Ti.upscaling] ? "upscale" : e[Ti.threed] ? "threed" : e[Ti.video] ? "video" : "image";
}
function* JC(n) {
  for (const e of n || [])
    e && (e.__rgroup ? yield* JC(e.fields) : e.__rfield && (yield e));
}
function p_(n, e) {
  return Math.abs(n - e) / Math.max(n, e) < 0.04 ? "Square" : n > e ? "RectangleHorizontal" : "RectangleVertical";
}
function hne(n) {
  return (n && (n.text && n.text.options || n.radio && n.radio.options || n.image && n.image.options) || []).map((t) => ({ value: t.value, label: String(t.text != null ? t.text : t.value), image: t.imageUrl }));
}
const pne = [["1:1", 1, 1], ["4:3", 4, 3], ["3:4", 3, 4], ["16:9", 16, 9], ["9:16", 9, 16]];
function fne(n, e) {
  if (n.adminOnly && !e.isAdmin) return null;
  const t = n.display || {}, i = t.primaryForm, s = {
    key: String(n.fieldDefUuid || n.uuid),
    label: n.label || "",
    required: !!n.required,
    defaultValue: n.defaultValue,
    tooltip: n.tooltip,
    placeholder: n.placeholder,
    raw: n
  }, o = (r) => i === "CHIP" ? "chip" : i === "MAIN_ACTION" ? "reference" : i === "PROMPT" ? "prompt" : r;
  switch (n.type) {
    case "PROMPT":
      return e.firstPrompt ? { ...s, kind: "prompt", placement: "prompt", defaultValue: n.defaultValue && typeof n.defaultValue == "object" ? n.defaultValue.value || "" : n.defaultValue || "" } : { ...s, kind: "text", placement: "advanced" };
    case "NEG_PROMPT":
      return { ...s, kind: "negPrompt", placement: "advanced" };
    case "TEXT":
    case "TEXT_AREA":
      return { ...s, kind: "text", placement: i === "PROMPT" && e.firstPrompt ? "prompt" : "advanced" };
    case "BOOLEAN":
      return i === "CHIP" ? { ...s, kind: "select", placement: "chip", icon: "Settings2", options: [{ value: !0, label: "On" }, { value: !1, label: "Off" }], defaultValue: !!n.defaultValue } : { ...s, kind: "boolean", placement: "advanced", defaultValue: !!n.defaultValue };
    case "SINGLE_SELECT": {
      const r = hne(t);
      return r.length ? { ...s, kind: "select", placement: o("advanced"), options: r, defaultValue: n.defaultValue != null ? n.defaultValue : r[0].value } : null;
    }
    case "WIDTH_HEIGHT": {
      if (t.select && Array.isArray(t.select.options) && t.select.options.length) {
        const r = t.select.options.map((a) => ({
          value: t.select.format === "wh" ? { width: a.width, height: a.height } : a.value,
          label: a.text || a.value,
          meta: a.width && a.height ? a.width + "×" + a.height : void 0,
          icon: p_(a.width || 1, a.height || 1)
        }));
        return { ...s, kind: "size", placement: i ? o("chip") : "chip", options: r, defaultValue: n.defaultValue != null ? n.defaultValue : r[0].value };
      }
      if (t.sliders) {
        const [r, a] = t.sliders.max || [1024, 1024], [l, d] = t.sliders.min || [256, 256], c = pne.map(([h, f, p]) => {
          const y = Math.min(r / f, a / p), v = Math.max(l, Math.round(f * y / 64) * 64), x = Math.max(d, Math.round(p * y / 64) * 64);
          return { value: { width: v, height: x }, label: h, meta: v + "×" + x, icon: p_(v, x) };
        });
        return { ...s, kind: "size", placement: "chip", options: c, defaultValue: n.defaultValue || c[0].value };
      }
      return null;
    }
    case "IMG":
      return { ...s, kind: "image", placement: i === "CHIP" || i === "MAIN_ACTION" || e.imageIndex < 3 ? "reference" : "advanced" };
    case "IMGS":
      return { ...s, kind: "images", placement: "reference", maxImages: t.maxImages || 4 };
    case "VIDEO":
    case "ASSET_3D":
      return { ...s, kind: "video", placement: "reference" };
    case "SLIDER":
    case "UPSCALE_FACTOR_SLIDER": {
      if (Array.isArray(t.options) && t.options.length) {
        const r = t.options.map((a) => ({ value: a.value, label: String(a.label) }));
        return { ...s, kind: "select", placement: o("advanced"), icon: "Maximize2", options: r, defaultValue: n.defaultValue != null ? n.defaultValue : r[0].value };
      }
      return { ...s, kind: "slider", placement: o("advanced"), min: t.min, max: t.max, step: t.step || 1 };
    }
    case "CFG":
      return { ...s, kind: "slider", placement: "advanced", min: t.min != null ? t.min : 1, max: t.max != null ? t.max : 20, step: 0.5 };
    case "STEPS":
      return { ...s, kind: "slider", placement: "advanced", min: t.min != null ? t.min : 1, max: t.max != null ? t.max : 50, step: 1 };
    case "SEED":
      return { ...s, kind: "seed", placement: "advanced", defaultValue: n.defaultValue != null ? n.defaultValue : null };
    case "NUM":
      return { ...s, kind: "text", placement: "advanced" };
    case "MODEL_SINGLE_SELECT":
      return { ...s, kind: "model", placement: "chip", icon: "Sparkles", architecture: t.architecture || void 0 };
    default:
      return null;
  }
}
function _u(n, e, t, i = XC(e)) {
  if (!i) return null;
  const s = [];
  let o = !0, r = 0;
  for (const c of JC(e.fields)) {
    const h = fne(c, { isAdmin: t, firstPrompt: o, imageIndex: r });
    h && (h.placement === "prompt" && (o = !1), (h.kind === "image" || h.kind === "images") && r++, s.push(h));
  }
  s.sort((c, h) => f_(c) - f_(h));
  const a = e.staticFields && e.staticFields.numResults || { min: 1, max: 1, defaultValue: 1 }, l = Number(e.costPerResult) || 0, d = Array.isArray(e.costPerResultLogics) && e.costPerResultLogics.length > 0;
  return {
    id: n,
    name: e.title || "Tool",
    desc: e.description,
    kitId: i,
    tokensLabel: gne(l) + (d ? "+" : ""),
    tokensPerResult: d ? void 0 : l / 100,
    time: e.averageGenInSeconds ? bne(e.averageGenInSeconds) : void 0,
    fields: s,
    numResults: { min: a.min || 1, max: a.max || 1, def: a.defaultValue || 1 },
    raw: { id: n, costPerResult: l, costPerResultLogics: e.costPerResultLogics || [], sortOrder: e.sortOrder || 0, pricingType: e.pricingType, fields: e.fields || [] },
    boardTool: typeof e.boardTool == "string" && e.boardTool ? e.boardTool : void 0
  };
}
function mne(n, e) {
  const t = [];
  for (const i of n) {
    const s = _u(i.id, i.data, e, XC(i.data) || "tools");
    s && t.push(s);
  }
  return t;
}
function f_(n) {
  return n.placement === "prompt" ? 0 : n.placement === "reference" ? 1 : n.placement === "chip" ? 2 : 3;
}
function gne(n) {
  const e = Math.floor(n) / 100;
  return e >= 100 ? String(Math.round(e)) : String(Math.round(e * 10) / 10);
}
function bne(n) {
  return n < 90 ? Math.round(n) + "s" : Math.round(n / 60) + "m";
}
const vne = { "3d": "threed" }, yne = {
  image: "Image",
  video: "Video",
  imageEdit: "Wand2",
  videoEdit: "Clapperboard",
  upscale: "Maximize2",
  "3d": "Box"
};
function xne(n, e, t) {
  const i = e.map((o) => ({ ...o.data, id: o.id })), s = [];
  for (const o of cne({ kits: n, nodeDefs: i, surface: "web" })) {
    const r = vne[o.id] || o.id, a = [];
    for (const c of o.tools) {
      const h = _u(c.nodeDefId, c.nodeDef, t, r);
      h && (h.kitTags = Object.keys(c.tags), h.labels = c.labels.map((f) => ({ label: f.label, tooltip: f.tooltip, type: f.type })), a.push(h));
    }
    if (!a.length) continue;
    const l = o.tags.map((c) => c.key).filter((c) => a.some((h) => h.kitTags && h.kitTags.includes(c))), d = a.some((c) => c.id === o.defaultNodeDefId) ? o.defaultNodeDefId : a[0].id;
    s.push({ id: r, name: o.label, icon: yne[o.id] || "Sparkles", desc: o.description, models: a, tags: l, defaultModelId: d });
  }
  return s;
}
const y0 = "Company";
async function ZC(n, e, t, i = {}) {
  const s = await n.db.doc("teams/" + e).get(), o = s.exists ? (s.data() || {}).companyId : null;
  if (!o) return [];
  let r = n.db.collection("runnitNodeDefs").where("appType", "==", "RUNNIT").where("type", "==", "COMPANY").where("isDeleted", "==", !1).where("companyIds." + o, "==", !0);
  t.isAdmin || (r = r.where("isPublished", "==", !0));
  const a = await r.get(), l = [];
  for (const d of a.docs) {
    const c = { ...d.data(), id: d.id };
    if (i.isBlocked && i.isBlocked(c)) continue;
    const h = _u(d.id, c, !!t.isAdmin);
    h && (h.kitTags = [y0], l.push(h));
  }
  return l;
}
function wne(n, e) {
  if (!e.length) return n;
  const t = n.kits.map((i) => ({ ...i, models: i.models.slice(), tags: i.tags ? i.tags.slice() : void 0 }));
  for (const i of e) {
    let s = t.find((o) => o.id === i.kitId);
    if (!s) {
      const o = YC.find((r) => r.id === i.kitId);
      if (!o) continue;
      s = { id: o.id, name: o.name, icon: o.icon, desc: o.desc, models: [] }, t.push(s);
    }
    s.models.some((o) => o.id === i.id) || (s.models.push(i), s.tags && !s.tags.includes(y0) && s.tags.unshift(y0));
  }
  return of(n.source, t, n.all, n.tools || []);
}
function kne(n, e, t) {
  const i = /* @__PURE__ */ new Set();
  for (const o of n) for (const r of o.models) i.add(r.id);
  const s = [];
  for (const o of e) {
    if (i.has(o.id) || !o.data || o.data.isPublished !== !0) continue;
    const r = _u(o.id, o.data, t, une(o.data));
    r && !r.boardTool && s.push(r);
  }
  return s;
}
async function _ne(n, e, t = {}) {
  let i = n.db.collection("runnitNodeDefs").where("appType", "==", "RUNNIT").where("type", "==", "CORE").where("isDeleted", "==", !1);
  e.isAdmin || (i = i.where("isPublished", "==", !0));
  const s = n.db.collection("runnitKits").where("isPublished", "==", !0).where("isDeleted", "==", !1), [o, r] = await Promise.all([
    i.get(),
    s.get().catch((p) => (console.warn("[board] v1 kits unavailable, grouping tools by tag", p), { docs: [] }))
  ]), a = t.isBlocked, l = o.docs.map((p) => ({ id: p.id, data: p.data() })).filter((p) => !a || !a({ ...p.data, id: p.id })), d = xne(r.docs.map((p) => ({ ...p.data(), id: p.id })), l, !!e.isAdmin), c = mne(l, !!e.isAdmin);
  if (d.length) return of("firestore", d, kne(d, l, !!e.isAdmin), c);
  const h = /* @__PURE__ */ new Map();
  l.forEach((p) => {
    const y = _u(p.id, p.data, !!e.isAdmin);
    y && (h.has(y.kitId) || h.set(y.kitId, []), h.get(y.kitId).push(y));
  });
  const f = YC.map((p) => {
    const y = (h.get(p.id) || []).slice().sort((v, x) => {
      const w = p.prefer.indexOf(v.name), S = p.prefer.indexOf(x.name);
      if (w >= 0 || S >= 0) return (w < 0 ? 999 : w) - (S < 0 ? 999 : S);
      const M = v.raw && v.raw.sortOrder || 0, _ = x.raw && x.raw.sortOrder || 0;
      return M - _ || v.name.localeCompare(x.name);
    });
    return { id: p.id, name: p.name, icon: p.icon, desc: p.desc, models: y };
  }).filter((p) => p.models.length);
  return of("firestore", f, [], c);
}
var Sne = Object.defineProperty, Mne = (n, e, t) => e in n ? Sne(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Sh = (n, e, t) => Mne(n, typeof e != "symbol" ? e + "" : e, t);
function Tne(n) {
  return "deleted:" + n;
}
function Ep(n) {
  return "edit:" + n;
}
function m_(n) {
  return "marks:" + n;
}
const bl = { x: 0, y: 0, w: 0, h: 0, z: 0 };
function Bs(n) {
  return n.type === "studio";
}
function Cne(n, e) {
  return n === e ? !0 : n && e && typeof n == "object" && typeof e == "object" ? JSON.stringify(n) === JSON.stringify(e) : !1;
}
class Ine {
  constructor(e, t) {
    Sh(this, "save", e), Sh(this, "who", t), Sh(this, "byId", /* @__PURE__ */ new Map()), Sh(this, "rev", /* @__PURE__ */ qe(0));
  }
  bump() {
    this.rev.value++, xs(this.rev);
  }
  /** What the board loaded with. */
  load(e) {
    for (const t of e) this.byId.set(t.id, t);
    this.bump();
  }
  /** Someone else changed some (another tab, a teammate). */
  applyRemote(e, t) {
    if (!(!e.length && !t.length)) {
      for (const i of e) this.byId.set(i.id, i);
      for (const i of t) this.byId.delete(i);
      this.bump();
    }
  }
  has(e) {
    return this.byId.has(e);
  }
  get(e) {
    return this.byId.get(e);
  }
  all() {
    return this.rev.value, Array.from(this.byId.values());
  }
  /** A session's records. */
  forSession(e) {
    return this.all().filter((t) => t.sessionId === e);
  }
  /** Add a record, or replace one whole. Unchanged, it writes nothing. */
  put(e) {
    const t = this.byId.get(e.id), i = { updatedAt: Date.now(), updatedBy: this.who() };
    if (!t) {
      const c = { ...e, ...i };
      this.byId.set(e.id, c), this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [c], updated: [], removed: [] });
      return;
    }
    const s = {}, o = {}, r = t, a = e;
    for (const c of /* @__PURE__ */ new Set([...Object.keys(r), ...Object.keys(a)]))
      c === "updatedAt" || c === "updatedBy" || Cne(r[c], a[c]) || (s[c] = r[c], o[c] = a[c]);
    if (!Object.keys(o).length) return;
    const l = { ...e, ...i };
    this.byId.set(e.id, l), this.bump(), Object.assign(o, i);
    const d = { id: e.id, el: l, before: s, after: o };
    this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [], updated: [d], removed: [] });
  }
  /** Change some of a record's fields. */
  patch(e, t) {
    const i = this.byId.get(e);
    i && this.put({ ...i, ...t });
  }
  /** Into Recently Deleted. */
  remove(e) {
    const t = [];
    for (const i of e) {
      const s = this.byId.get(i);
      s && (this.byId.delete(i), t.push(s));
    }
    t.length && (this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [], updated: [], removed: t }));
  }
  /** Back from Recently Deleted, as they were. */
  restore(e) {
    const t = e.filter((i) => !this.byId.has(i.id));
    if (t.length) {
      for (const i of t) this.byId.set(i.id, i);
      this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: t, updated: [], removed: [] });
    }
  }
}
function Ane(n) {
  if ("nodeRunResult" in n) {
    const t = n.nodeRunResult, i = typeof t.nodeRunId == "string" ? t.nodeRunId : "", s = typeof t.uuid == "string" ? t.uuid : "";
    return i && s ? { kind: "result", nodeRunId: i, resultUuid: s, variant: "file" } : null;
  }
  const e = typeof n.upload.id == "string" ? n.upload.id : "";
  return e ? { kind: "upload", uploadId: e } : null;
}
function oo(n) {
  return n ? n.fields.filter((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images")) : [];
}
function zo(n) {
  return oo(n).reduce((e, t) => e + Zs(t), 0);
}
function Pne(n) {
  const e = oo(n);
  if (e.length < 2) return [];
  const t = [];
  for (const i of e) for (let s = 0; s < Zs(i); s++) t.push(i.label);
  return t;
}
function Mf(n) {
  return zo(n) > 0;
}
function QC(n, e, t) {
  if (e === "prompt") {
    const o = n.kits.find((r) => r.id === t) || n.kits.find((r) => r.id === "image") || n.kits[0];
    return o ? o.models : [];
  }
  const i = /* @__PURE__ */ new Set(), s = [];
  for (const o of n.kits)
    if (o.id === "image")
      for (const r of o.models)
        i.has(r.id) || !Mf(r) || (i.add(r.id), s.push(r));
  return s;
}
function Vy(n) {
  return n.fields.find((e) => e.placement === "reference") || null;
}
function Tf(n, e) {
  if (!n) return [];
  const t = Vy(n), i = [];
  for (const s of oo(n)) {
    const o = e.inputs ? e.inputs[s.key] : void 0;
    if (s.kind === "images" && Array.isArray(o)) {
      for (const a of o) typeof a == "string" && a && i.push(a);
      continue;
    }
    const r = s === t ? e.ref : o;
    typeof r == "string" && r && i.push(r);
  }
  return i;
}
function _d(n, e, t) {
  const i = Vy(n), s = { ...e.inputs || {} }, o = { ...e.assets || {} };
  let r = i && oo(n).includes(i) ? null : e.ref || null, a = 0;
  for (const l of oo(n)) {
    delete s[l.key];
    const d = t.slice(a, a + Zs(l));
    if (a += d.length, !d.length) continue;
    for (const h of d) h.asset && (o[h.url] = h.asset);
    const c = d.map((h) => h.url);
    l === i ? (r = c[0], c.length > 1 && (s[l.key] = c)) : s[l.key] = l.kind === "images" ? c : c[0];
  }
  return { ...e, ref: r, inputs: s, assets: o };
}
function Ene(n, e) {
  const t = e.assets || {}, i = [], s = Vy(n);
  for (const o of oo(n)) {
    if (o.kind !== "images") continue;
    const r = e.inputs ? e.inputs[o.key] : void 0, a = Array.isArray(r) ? r : o === s && e.ref ? [e.ref] : [];
    let l = -1;
    a.forEach((d, c) => {
      const h = t[d];
      (!h || "upload" in h) && (l = c);
    }), a.forEach((d, c) => {
      const h = t[d];
      c < l && h && "nodeRunResult" in h && !i.includes(d) && i.push(d);
    });
  }
  return i;
}
const Rne = /(?:^|\s)(\d+(?:\.\d+)?)\s*[:x×]\s*(\d+(?:\.\d+)?)$/;
function Cf(n) {
  if (n.value && typeof n.value == "object") {
    const e = n.value, t = Number(e.width), i = Number(e.height);
    if (t > 0 && i > 0) return t / i;
  }
  for (const e of [typeof n.value == "string" ? n.value : "", n.label, n.meta || ""]) {
    const t = Rne.exec(String(e).trim());
    if (t && Number(t[2]) > 0) return Number(t[1]) / Number(t[2]);
  }
  return null;
}
const zne = /match|auto|input|original/i;
function Wy(n) {
  return zne.test(String(n.label) + " " + String(typeof n.value == "string" ? n.value : ""));
}
function qy(n) {
  for (const e of n.fields) {
    if (e.kind === "size") return e;
    if (e.kind !== "select" || !e.options) continue;
    const t = e.options.filter((i) => Cf(i) != null).length;
    if (t >= 2 || t >= 1 && e.options.some(Wy)) return e;
  }
  return null;
}
function $ne(n) {
  if (n.value && typeof n.value == "object") {
    const t = n.value, i = Number(t.width) * Number(t.height);
    if (i > 0) return i;
  }
  const e = /(\d+)\s*[×x]\s*(\d+)/.exec(n.meta || "");
  return e ? Number(e[1]) * Number(e[2]) : null;
}
function Dne(n) {
  const e = /^(\d+(?:\.\d+)?K)\b/i.exec(String(n.label).trim());
  return e ? e[1].toUpperCase() : n.meta || String(n.label);
}
function eI(n, e, t) {
  const i = qy(n);
  if (!i || !i.options || !e || !t || i.options.some(Wy)) return [];
  const s = Math.log(e / t);
  let o = null;
  for (const l of i.options) {
    const d = Cf(l);
    d != null && (o == null || Math.abs(Math.log(d) - s) < Math.abs(Math.log(o) - s)) && (o = d);
  }
  if (o == null) return [];
  const r = o, a = i.options.filter((l) => {
    const d = Cf(l);
    return d != null && Math.abs(Math.log(d) - Math.log(r)) < 1e-6;
  }).map((l) => ({ o: l, px: $ne(l) }));
  return a.length < 2 || a.some((l) => l.px == null) ? [] : (a.sort((l, d) => l.px - d.px), a.map(({ o: l, px: d }) => ({ label: Dne(l), value: l.value, meta: l.meta, px: d })));
}
function One(n, e, t, i = 0) {
  const s = qy(n);
  if (!s || !s.options || !s.options.length || !e || !t) return null;
  const o = s.options.find(Wy);
  if (o) return { key: s.key, value: o.value };
  const r = eI(n, e, t);
  if (r.length) return { key: s.key, value: r[Math.max(0, Math.min(i, r.length - 1))].value };
  const a = Math.log(e / t);
  let l = s.options[0], d = 1 / 0;
  for (const c of s.options) {
    const h = Cf(c);
    if (h == null) continue;
    const f = Math.abs(Math.log(h) - a);
    f < d && (d = f, l = c);
  }
  return { key: s.key, value: l.value };
}
const Rp = { rotate: 45, vertical: 0, zoom: 5 }, If = 50, Ky = 60;
function Lne(n, e) {
  const t = ro(n), i = ro(e);
  return t.rotate === i.rotate && t.vertical === i.vertical && t.zoom === i.zoom;
}
function Bne(n) {
  if (!n || typeof n != "object") return null;
  const e = n;
  if (typeof e.id != "string" || !e.id || typeof e.name != "string") return null;
  const t = ro({ rotate: Number(e.rotate), vertical: Number(e.vertical), zoom: Number(e.zoom) });
  return { id: e.id, name: e.name.slice(0, Ky), ...t, createdAt: Number(e.createdAt) || 0 };
}
const Fne = -30, Nne = 90, Une = 0, Gne = 10, x0 = [0, 45, 90, 135, 180, 225, 270, 315], jne = ["Front", "Front right", "Right side", "Back right", "Back", "Back left", "Left side", "Front left"], Af = [
  { at: -30, name: "Low, looking up" },
  { at: 0, name: "Eye level" },
  { at: 30, name: "Slightly above" },
  { at: 60, name: "High above" },
  { at: 90, name: "Overhead" }
], tI = [
  { at: 0, name: "Wide" },
  { at: 5, name: "Medium" },
  { at: 10, name: "Close-up" }
], Hne = 0.9, Vne = "same scene and subject, same materials, colours and lighting", Wne = "different person, changed clothing, distorted face, extra limbs, warped architecture";
function Su(n) {
  const e = (n % 360 + 360) % 360;
  return Math.round(e * 1e3) / 1e3;
}
function Yy(n) {
  const e = Su(n);
  return e > 180 ? e - 360 : e;
}
function g_(n, e, t) {
  return Math.min(t, Math.max(e, n));
}
function ro(n) {
  const e = Number.isFinite(n.rotate) ? n.rotate : Rp.rotate, t = Number.isFinite(n.vertical) ? n.vertical : Rp.vertical, i = Number.isFinite(n.zoom) ? n.zoom : Rp.zoom, s = Su(e);
  return { rotate: s === 360 ? 0 : s, vertical: g_(t, Fne, Nne), zoom: g_(i, Une, Gne) };
}
function qne(n) {
  return Math.round(Su(n) / 45) % 8;
}
function Xy(n, e, t) {
  let i = n, s = t;
  for (const o of e) {
    const r = Math.abs(o - n);
    r <= s && (s = r, i = o);
  }
  return i;
}
function b_(n, e = 7) {
  const t = Xy(Su(n), [...x0, 360], e);
  return t === 360 ? 0 : t;
}
function v_(n, e = 6) {
  return Xy(n, Af.map((t) => t.at), e);
}
function Kne(n, e = 0.6) {
  return Xy(n, tI.map((t) => t.at), e);
}
function Yne(n, e) {
  return e.reduce((t, i) => Math.abs(i.at - n) < Math.abs(t.at - n) ? i : t);
}
function w0(n) {
  return jne[qne(n)];
}
function k0(n) {
  return Yne(n, Af).name;
}
function nI(n) {
  return n <= 3 ? "Wide" : n >= 7 ? "Close-up" : "Medium";
}
function kc(n) {
  const e = ro(n);
  return w0(e.rotate) + ", " + k0(e.vertical).toLowerCase() + ", " + nI(e.zoom).toLowerCase();
}
function iI(n) {
  return Math.abs(Yy(n.rotate)) > 90;
}
function Xne(n, e) {
  const t = ro(n), i = {
    rotate: t.rotate,
    vertical: t.vertical,
    zoom: t.zoom,
    keep: Vne,
    avoid: Wne,
    loraScale: Hne
  };
  return e != null && (i.seed = e), i;
}
const Jne = "/internal/library-prompts", Zne = 40, sI = 100, Qne = 80, eie = ["me", "board", "team", "company"];
function Da(n) {
  return n && n.trim() ? n.trim() : null;
}
function tie(n) {
  const e = new URLSearchParams(), t = Da(n.teamId);
  t && e.set("team_id", t);
  const i = Da(n.boardId);
  i && e.set("board_id", i);
  const s = eie.filter((d) => n.levels.includes(d));
  s.length && e.set("level", s.join(","));
  const o = Da(n.category);
  o && e.set("category", o.slice(0, Qne));
  const r = Da(n.query);
  r && e.set("q", r.slice(0, W1)), n.kind && e.set("kind", n.kind), n.onlyKind && e.set("only_kind", n.onlyKind), n.onlyAction && e.set("only_action", n.onlyAction), n.mine && e.set("author", "me");
  const a = Da(n.toolId);
  a && e.set("tool_id", a);
  const l = Da(n.cursor);
  return l && e.set("cursor", l), e.set("limit", String(Math.min(sI, Math.max(1, Math.floor(n.limit) || 1)))), e;
}
function En(n) {
  return n !== null && typeof n == "object" && !Array.isArray(n) ? n : null;
}
const Pt = (n) => typeof n == "string" ? n : "", Si = (n) => typeof n == "number" && Number.isFinite(n) ? n : 0, y_ = (n) => {
  const e = typeof n == "string" ? Date.parse(n) : NaN;
  return Number.isFinite(e) ? e : 0;
};
function nie(n) {
  const e = En(n), t = e ? Pt(e.id) : "";
  if (!e || !t || !Pt(e.author_id) || !Pt(e.prompt)) return null;
  const i = En(e.tool) || {}, s = En(e.output) || {}, o = Array.isArray(e.inputs) ? e.inputs.map(En).filter((a) => !!a && !!Pt(a.url)).map((a) => ({ label: Pt(a.label), role: Pt(a.role), title: Pt(a.title) || void 0, kind: a.kind === "markup" ? "markup" : "reference", url: Pt(a.url) })) : [], r = y_(e.created);
  return {
    id: t,
    name: Pt(e.name) || "Untitled prompt",
    category: Pt(e.category),
    description: Pt(e.description),
    prompt: Pt(e.prompt),
    mode: Pt(e.mode) || xu(o.length),
    tags: Array.isArray(e.tags) ? e.tags.filter((a) => typeof a == "string") : [],
    kind: e.kind === "video" ? "video" : "image",
    tool: { nodeDefId: Pt(i.node_def_id), name: Pt(i.name) },
    output: { url: Pt(s.url), w: Si(s.w), h: Si(s.h), thumb: Pt(s.thumb) || void 0, video: Pt(s.video) || void 0 },
    inputs: o,
    authorId: Pt(e.author_id),
    authorName: Pt(e.author_name),
    boardId: Pt(e.board_id) || null,
    teamId: Pt(e.team_id) || null,
    companyId: Pt(e.company_id) || null,
    values: En(e.values),
    // not mirrored: the document has it, and an edit reads the document
    run: null,
    createdAt: r,
    updatedAt: y_(e.updated) || r
  };
}
function iie(n) {
  const e = En(n);
  if (!e) return null;
  const t = En(e.levels) || {}, i = En(e.kinds), s = Array.isArray(e.categories) ? e.categories.map(En).filter((l) => !!l && !!Pt(l.label)).map((l) => ({ label: Pt(l.label), count: Si(l.count) })) : [], o = En(e.actions), r = (l) => {
    const d = En(l) || {};
    return { generate: Si(d.generate), edit: Si(d.edit) };
  }, a = Array.isArray(e.groups) ? e.groups.map(En).filter((l) => !!l && (l.kind === "image" || l.kind === "video") && (l.action === "generate" || l.action === "edit")).map((l) => ({ kind: l.kind, action: l.action, label: Pt(l.label), count: Si(l.count) })) : null;
  return {
    total: Si(e.total),
    levels: { me: Si(t.me), board: Si(t.board), team: Si(t.team), company: Si(t.company) },
    // an API from before the Image and Video filter doesn't count them
    ...i ? { kinds: { image: Si(i.image), video: Si(i.video) } } : {},
    // nor one from before Generate and Edit (IL-103)
    ...o ? { actions: { image: r(o.image), video: r(o.video) } } : {},
    categories: s,
    ...a ? { groups: a } : {}
  };
}
function sie(n) {
  const e = En(n);
  if (!e) return null;
  const t = En(e.team), i = En(e.company);
  return {
    team: t && Pt(t.id) ? { id: Pt(t.id), manage: t.manage === !0 } : null,
    company: i && Pt(i.id) ? { id: Pt(i.id), name: Pt(i.name) || null, manage: i.manage === !0 } : null
  };
}
function oie(n) {
  const e = En(n) || {};
  return {
    prompts: Array.isArray(e.data) ? e.data.map(nie).filter((t) => t !== null) : [],
    nextCursor: Pt(e.next_cursor) || null,
    hasMore: !!e.has_more,
    counts: iie(e.counts),
    access: sie(e.access)
  };
}
async function rie(n) {
  var e;
  try {
    const t = En((e = En(await n.json())) == null ? void 0 : e.error) || {};
    return {
      code: typeof t.code == "string" ? t.code : void 0,
      message: typeof t.message == "string" ? t.message : void 0
    };
  } catch {
    return {};
  }
}
async function aie(n, e, t, i = window.fetch.bind(window)) {
  const s = n.replace(/\/$/, "") + Jne + "?" + tie(t).toString();
  let o;
  try {
    o = await i(s, { method: "GET", headers: { Authorization: "Bearer " + e.idToken, "X-Device-Id": e.deviceId } });
  } catch {
    return { ok: !1, reason: "network" };
  }
  if (!o.ok) {
    const { code: r, message: a } = await rie(o);
    return { ok: !1, reason: r === "INVALID_CURSOR" ? "stale-cursor" : o.status === 401 ? "unauthorized" : o.status === 403 ? "forbidden" : "failed", ...r ? { code: r } : {}, message: a || "HTTP " + o.status };
  }
  try {
    return { ok: !0, page: oie(await o.json()) };
  } catch {
    return { ok: !1, reason: "failed", message: "Invalid JSON" };
  }
}
var lie = Object.defineProperty, die = (n, e, t) => e in n ? lie(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Sn = (n, e, t) => die(n, typeof e != "symbol" ? e + "" : e, t);
const cie = 2e4;
function uie(n, e) {
  return JSON.stringify(n) === JSON.stringify(e);
}
class hie {
  constructor(e, t = {}) {
    Sn(this, "shelf", e), Sn(this, "opts", t), Sn(this, "rows", /* @__PURE__ */ qe([])), Sn(this, "state", /* @__PURE__ */ qe("idle")), Sn(this, "counts", /* @__PURE__ */ qe(null)), Sn(this, "access", /* @__PURE__ */ qe(null)), Sn(this, "hasMore", /* @__PURE__ */ qe(!1)), Sn(this, "loadingMore", /* @__PURE__ */ qe(!1)), Sn(this, "ask", null), Sn(this, "fetched", []), Sn(this, "cursor", null), Sn(this, "version", 0), Sn(this, "stale", !1), Sn(this, "shown", !1), Sn(this, "followed", /* @__PURE__ */ new Map()), Sn(this, "pinned", /* @__PURE__ */ new Map()), Sn(this, "hidden", /* @__PURE__ */ new Map()), Sn(this, "lastWrite", 0), Sn(this, "lagTimer", null);
  }
  get pageSize() {
    return this.opts.pageSize || Zne;
  }
  /**
   * Ask for the first page, with these filters. The same ask again is
   * answered by what's here, unless it failed, it was refreshed, or a write
   * since needs the mirror's word.
   */
  query(e) {
    return this.ask && uie(this.ask, e) && !this.stale && (this.state.value === "ready" || this.state.value === "loading") ? Promise.resolve() : (this.ask = e, this.firstPage());
  }
  /** The next ask goes to the API even if it's the same: the panel opened again, and others may have saved since. */
  refresh() {
    this.stale = !0;
  }
  /** The next page, when there is one. */
  async loadMore() {
    const e = this.ask;
    if (!e || !this.cursor || this.loadingMore.value || this.state.value !== "ready") return;
    const t = this.version;
    this.loadingMore.value = !0;
    const i = await this.shelf.list({ ...e, cursor: this.cursor, limit: this.pageSize });
    if (t !== this.version) return;
    if (this.loadingMore.value = !1, !i.ok) {
      if (i.reason === "stale-cursor") return this.firstPage();
      console.warn("[board] more of my prompts unavailable", i);
      return;
    }
    const s = new Set(this.fetched.map((o) => o.id));
    this.fetched = this.fetched.concat(i.page.prompts.filter((o) => !s.has(o.id))), this.cursor = i.page.nextCursor, this.hasMore.value = i.page.hasMore, this.recompute();
  }
  /** While the panel shows the list, each prompt it holds follows its document. */
  setShown(e) {
    this.shown !== e && (this.shown = e, e ? this.follow() : this.unfollowAll());
  }
  /** A prompt saved (no `before`) or edited here: shown at once, first when it fits the filters. */
  pin(e, t) {
    this.pinned.set(e.id, e), this.hidden.delete(e.id), this.counts.value = gg(this.counts.value, t, e, this.boardId()), this.wrote();
  }
  /** A prompt deleted here: gone at once. */
  drop(e) {
    this.hidden.has(e.id) || (this.counts.value = gg(this.counts.value, e, null, this.boardId())), this.hidden.set(e.id, Date.now()), this.pinned.delete(e.id), this.wrote();
  }
  /** A delete undone (or refused): back at once. */
  undrop(e) {
    this.hidden.delete(e.id) && (this.findHeld(e.id) || this.pinned.set(e.id, e), this.counts.value = gg(this.counts.value, null, e, this.boardId()), this.wrote());
  }
  /**
   * A prompt the list holds, as it is now; null when it doesn't, or it's gone.
   * Read through the rows, so a view that shows one (the detail) changes with it.
   */
  get(e) {
    const t = this.rows.value.find((i) => i.id === e);
    return t || (!e || this.hidden.has(e) ? null : this.findHeld(e));
  }
  /** Whether this prompt is as its document says (followed), rather than as the API listed it. */
  isLive(e) {
    const t = this.followed.get(e);
    return !!t && !!t.prompt;
  }
  /** Every prompt the list knows of: for spotting a name or a prompt you have, before the API answers. */
  known() {
    const e = /* @__PURE__ */ new Map();
    for (const t of this.fetched) e.set(t.id, t);
    for (const t of this.pinned.values()) e.set(t.id, t);
    for (const [t, i] of this.followed) i.prompt && e.set(t, i.prompt);
    for (const t of this.hidden.keys()) e.delete(t);
    return Array.from(e.values());
  }
  dispose() {
    this.version++, this.unfollowAll(), this.lagTimer && clearTimeout(this.lagTimer), this.lagTimer = null;
  }
  // ------------------------------------------------------------- inside
  async firstPage() {
    const e = this.ask;
    if (!e) return;
    const t = ++this.version, i = Date.now();
    this.stale = !1, this.loadingMore.value = !1, this.state.value !== "ready" && (this.state.value = "loading");
    const s = await this.shelf.list({ ...e, cursor: null, limit: this.pageSize });
    if (t !== this.version) return;
    if (!s.ok) {
      console.warn("[board] my prompts unavailable", s), this.state.value = "failed";
      return;
    }
    const o = s.page;
    this.fetched = o.prompts, this.cursor = o.nextCursor, this.hasMore.value = o.hasMore, o.counts && (!this.counts.value || i - this.lastWrite >= this.lagMs) && (this.counts.value = o.counts), o.access !== void 0 && (this.access.value = o.access);
    for (const r of o.prompts) this.pinned.delete(r.id);
    for (const [r, a] of this.hidden) i - a >= this.lagMs && this.hidden.delete(r);
    this.state.value = "ready", this.recompute();
  }
  /** The board the list is asked for, whose prompts are "This board"'s. */
  boardId() {
    return this.ask ? this.ask.boardId : null;
  }
  findHeld(e) {
    const t = this.followed.get(e);
    return t && t.prompt ? t.prompt : t && t.prompt === null ? null : this.pinned.get(e) || this.fetched.find((i) => i.id === e) || null;
  }
  recompute() {
    const e = this.ask, t = [], i = /* @__PURE__ */ new Set(), s = (o) => {
      if (i.has(o.id) || this.hidden.has(o.id)) return;
      i.add(o.id);
      const r = this.followed.get(o.id);
      t.push(r && r.prompt ? r.prompt : o);
    };
    if (e) {
      const o = Array.from(this.pinned.values()).sort((r, a) => a.updatedAt - r.updatedAt);
      for (const r of o) {
        const a = this.findHeld(r.id) || r;
        rW(a, { ...e, limit: this.pageSize }) && s(a);
      }
    }
    for (const o of this.fetched) s(o);
    this.rows.value = t, this.shown && this.follow();
  }
  /** Follow exactly what's shown: start the new ones, stop the ones that went. */
  follow() {
    const e = new Set(this.rows.value.map((t) => t.id));
    for (const [t, i] of this.followed)
      e.has(t) || (i.stop(), this.followed.delete(t));
    for (const t of e) {
      if (this.followed.has(t)) continue;
      const i = { prompt: void 0, failed: !1, stop: () => {
      } };
      this.followed.set(t, i);
      try {
        i.stop = this.shelf.follow(t, (s) => this.heard(t, i, s), (s) => {
          s.code !== "permission-denied" && console.warn("[board] could not follow a saved prompt", t, s), i.failed = !0;
        });
      } catch (s) {
        console.warn("[board] could not follow a saved prompt", t, s), i.failed = !0;
      }
    }
  }
  heard(e, t, i) {
    this.followed.get(e) === t && (t.prompt = i, i || (this.hidden.set(e, Date.now()), this.pinned.delete(e)), this.recompute());
  }
  unfollowAll() {
    for (const e of this.followed.values()) e.stop();
    this.followed.clear();
  }
  /** A write of yours: what's shown changes now, and the list asks again once the mirror has it. */
  wrote() {
    this.lastWrite = Date.now(), this.recompute(), this.lagTimer && clearTimeout(this.lagTimer), this.lagTimer = setTimeout(() => {
      this.lagTimer = null, this.shown ? this.firstPage() : this.stale = !0;
    }, this.lagMs);
  }
  get lagMs() {
    return this.opts.lagMs !== void 0 ? this.opts.lagMs : cie;
  }
}
var pie = Object.defineProperty, fie = (n, e, t) => e in n ? pie(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, ji = (n, e, t) => fie(n, typeof e != "symbol" ? e + "" : e, t);
function Or(n) {
  return "authorId" in n;
}
const Mh = () => Promise.reject(new Error("Saving prompts isn't available here")), mie = {
  list: () => Promise.resolve({ ok: !0, page: { prompts: [], nextCursor: null, hasMore: !1, counts: { total: 0, levels: { me: 0, board: 0, team: 0, company: 0 }, categories: [] }, access: null } }),
  follow: () => () => {
  },
  save: Mh,
  update: Mh,
  remove: Mh,
  restore: Mh,
  teamName: () => Promise.resolve(null)
};
class gie {
  constructor(e, t, i = null) {
    ji(this, "b", e), ji(this, "source", t), ji(this, "shelf", i), ji(this, "featured", /* @__PURE__ */ qe(null)), ji(this, "state", /* @__PURE__ */ qe("idle")), ji(this, "scroll", {}), ji(this, "loading", null), ji(this, "myPrompts"), ji(this, "mine"), ji(this, "mineState"), ji(this, "team", /* @__PURE__ */ qe(null)), this.myPrompts = new hie(i || mie), this.mine = this.myPrompts.rows, this.mineState = this.myPrompts.state;
  }
  /** Saving is offered where prompts can be kept. */
  get canSave() {
    return !!this.shelf;
  }
  dispose() {
    this.myPrompts.dispose();
  }
  /** Read the Featured set, once (again after a failure). */
  load() {
    if (this.loading) return this.loading;
    if (this.state.value === "ready") return Promise.resolve();
    if (!this.source)
      return this.state.value = "ready", Promise.resolve();
    this.state.value = "loading";
    const e = this.source.load().then((t) => {
      this.featured.value = t, this.state.value = "ready";
    }).catch((t) => {
      console.warn("[board] featured prompts unavailable", t), this.state.value = "failed";
    }).then(() => {
      this.loading = null;
    });
    return this.loading = e, e;
  }
  prompt(e) {
    const t = this.featured.value;
    return e && t && t.prompts.find((i) => i.id === e) || null;
  }
  /** A saved prompt My prompts holds, as it is now. */
  myPrompt(e) {
    return this.myPrompts.get(e);
  }
  // -------------------------------------------------------------- my prompts
  /** The team a prompt can be shared with on this board. */
  teamId() {
    return this.b.meta.teamId || this.b.user.teamId || null;
  }
  /** What My prompts asks for: what's yours or shared here, through the panel's filters. */
  mineAsk() {
    const e = this.b.ui.library, t = this.session(e.sessionId);
    return {
      uid: this.b.user.uid,
      boardId: this.b.meta.id,
      teamId: this.teamId(),
      levels: e.levels.slice(),
      category: e.category,
      query: e.query.trim(),
      kind: t ? Ja(t.kitId) : null,
      onlyKind: e.kind,
      onlyAction: e.kind ? e.action : null,
      mine: !1,
      toolId: null
    };
  }
  /** Ask for My prompts as the panel's filters stand (the same ask again is answered by what's here). */
  startMine() {
    this.myPrompts.query(this.mineAsk());
    const e = this.teamId();
    !this.shelf || !e || this.team.value && this.team.value.id === e || (this.team.value = { id: e, name: null }, this.shelf.teamName(e).then((t) => {
      this.team.value && this.team.value.id === e && (this.team.value = { id: e, name: t });
    }));
  }
  /** The categories My prompts uses, most used first: everything you can read here, not just what's loaded. */
  mineCategories() {
    const e = this.myPrompts.counts.value;
    return e ? e.categories.map((t) => t.label) : nW(this.myPrompts.known());
  }
  /** Your own prompts that hold every word of a search (the API's answer; none when it can't be asked). */
  async yours(e, t = null) {
    if (!this.shelf || !e) return [];
    const i = { ...this.mineAsk(), levels: [], category: null, query: e, kind: null, onlyKind: null, onlyAction: null, mine: !0, toolId: t, cursor: null, limit: sI }, s = await this.shelf.list(i);
    return s.ok ? s.page.prompts : [];
  }
  // ---------------------------------------------------- who manages what (IL-101)
  /** Who manages the shared levels here, as the API said for this board's team; null until it has. */
  access() {
    const e = this.myPrompts.access.value;
    return e && e.team && e.team.id === this.teamId() ? e : null;
  }
  /** You may share with this board's team, and edit or remove what's shared with it: its library is yours to manage, or the company's is. */
  managesTeam() {
    const e = this.access();
    return !!e && !!e.team && (e.team.manage || !!e.company && e.company.manage);
  }
  /** The company prompts can be shared with here: this board's team's. */
  company() {
    const e = this.access();
    return e && e.company ? { id: e.company.id, name: e.company.name } : null;
  }
  /** You may share with the whole company, and edit or remove what's shared in it. */
  managesCompany() {
    const e = this.access();
    return !!e && !!e.company && e.company.manage;
  }
  /** Who may edit or delete a saved prompt here: whoever saved it, and whoever manages a library it's shared with. */
  canEdit(e) {
    if (e.authorId === this.b.user.uid) return !0;
    const t = this.access();
    return t ? e.teamId && t.team && e.teamId === t.team.id && this.managesTeam() ? !0 : !!e.companyId && !!t.company && e.companyId === t.company.id && t.company.manage : !1;
  }
  /**
   * A draft's levels from the save form's toggles (none: Only me). A toggle
   * the form left as it found it (`was`) keeps that level as it was, so
   * editing a prompt filed on another board, or shared with another team or
   * company, doesn't move it here.
   */
  withLevels(e, t, i) {
    const s = this.teamId(), o = this.company(), r = i && t.board === i.levels.board ? i.boardId : t.board ? this.b.meta.id : null, a = i && t.team === i.levels.team ? i.teamId : t.team && s ? s : null, l = i && !!t.company === i.levels.company ? i.companyId : t.company && o ? o.id : null;
    return { ...e, boardId: r, teamId: a, companyId: l };
  }
  /** The save form's toggles for a draft: This board when it's filed on this board, the team or company when it's shared with one. */
  levelsFor(e) {
    return { board: !!e.boardId && e.boardId === this.b.meta.id, team: !!e.teamId, company: !!e.companyId };
  }
  /** What saving a finished result keeps: its prompt, tool, input images, settings and picture. */
  draftForResult(e) {
    const t = e.modelId && this.b.catalog.value.byId.get(e.modelId) || null, i = tW(e, t, (o) => this.b.assetUrl(o)), s = this.session(e.sessionId);
    return i.name = this.freshName(rk(i.prompt, s ? s.name : null)), this.withLevels(i, this.b.ui.library.saveLevels);
  }
  /** A name none of your saved prompts that My prompts knows of has yet (freshNameFor asks about the rest). */
  freshName(e) {
    return ak(e, this.myPrompts.known(), this.b.user.uid);
  }
  /** A name none of your saved prompts has: the API names yours that share its words. */
  async freshNameFor(e, t = null) {
    const i = await this.yours(e.trim());
    return ak(e, i.concat(this.myPrompts.known()), this.b.user.uid, t);
  }
  /** A prompt you saved before with this text and tool: the API names yours that hold its words. */
  async duplicateFor(e, t, i) {
    const s = this.b.user.uid, o = lk(this.myPrompts.known(), s, e, t, i);
    return o || !e.trim() ? o : lk(await this.yours(oW(e), t), s, e, t, i);
  }
  /** What saving a session's current prompt keeps; its latest result from that prompt is the picture. Null with no prompt. */
  draftForSession(e) {
    const t = this.session(e);
    if (!t) return null;
    const i = this.b.promptOf(t.id), s = (i.prompt || "").trim();
    if (!s) return null;
    const { model: o } = this.b.modelFor(t), r = o ? Eo(o, i, "draft").inputs : null, a = oS(o, r, i.ref ? [i.ref] : [], (d) => this.b.assetUrl(d)), l = this.b.results.list(t.id).find((d) => d.status === "done" && !!d.url && (d.prompt || "").trim() === s) || null;
    return this.withLevels({
      name: this.freshName(rk(s, t.name)),
      category: "",
      description: "",
      prompt: i.prompt || "",
      mode: xu(a.length),
      tags: [],
      kind: Ja(t.kitId) === "video" ? "video" : "image",
      tool: { nodeDefId: o ? o.id : t.nodeDefId || "", name: o ? o.name : t.model },
      output: l ? { url: l.url, w: l.w, h: l.h, thumb: l.thumb, video: l.videoSrc } : { url: "", w: 0, h: 0 },
      inputs: a,
      boardId: null,
      teamId: null,
      companyId: null,
      values: r,
      run: l && l.runId && l.uuid ? { runId: l.runId, uuid: l.uuid } : null
    }, this.b.ui.library.saveLevels);
  }
  /**
   * A saved prompt as the save form edits it. Until its document has been
   * read, the prompt is as the API listed it, which doesn't carry the run it
   * was saved from: the draft leaves the run out, so saving keeps it.
   */
  draftFor(e) {
    const t = { ...e };
    return delete t.id, delete t.authorId, delete t.authorName, delete t.createdAt, delete t.updatedAt, this.myPrompts.isLive(e.id) || delete t.run, t;
  }
  /**
   * Save (or, with `editingId`, update) a prompt. The levels it went to are
   * where the next save starts. A new one's toast opens it. My prompts shows
   * it at once, as saved.
   */
  async save(e, t) {
    const i = this.b, s = this.shelf;
    if (!s)
      return i.toast("Saving prompts isn't available here.", "error"), null;
    const o = this.levelsFor(e);
    i.ui.library.saveLevels = { board: o.board, team: o.team };
    try {
      if (t) {
        const d = this.myPrompt(t);
        return await s.update(t, e), d && this.myPrompts.pin({ ...d, ...e, updatedAt: Date.now() }, d), i.toast("Saved your changes to " + e.name), t;
      }
      const r = { uid: i.user.uid, name: i.user.name || i.user.email || "You" }, a = await s.save(e, r), l = Date.now();
      return this.myPrompts.pin({ ...e, id: a, authorId: r.uid, authorName: r.name, createdAt: l, updatedAt: l }, null), i.toast("Saved to My prompts: " + e.name, "info", { label: "Open", run: () => this.openMine(a) }), a;
    } catch (r) {
      return console.warn("[board] saving a prompt failed", r), i.toast("The prompt couldn't be saved. Try again.", "error"), null;
    }
  }
  /** Open My prompts (at one of them). */
  openMine(e) {
    const t = this.b;
    t.dismissToast(), t.ui.infoAt = null, t.ui.infoSave = !1;
    const i = t.promptTool.value;
    this.open(i ? i.id : null), t.ui.library.tab = "mine", t.ui.library.detail = e, this.startMine();
  }
  /** Delete a saved prompt (a soft delete): gone at once, and the toast's Undo brings it back. */
  async remove(e) {
    const t = this.b, i = this.shelf;
    if (!(!i || !this.canEdit(e))) {
      t.ui.library.detail === e.id && (t.ui.library.detail = null), this.myPrompts.drop(e);
      try {
        await i.remove(e.id), t.toast("Deleted " + e.name, "info", {
          label: "Undo",
          run: () => {
            t.dismissToast(), this.myPrompts.undrop(e), i.restore(e.id).catch(() => {
              this.myPrompts.drop(e), t.toast("It couldn't be brought back.", "error");
            });
          }
        });
      } catch (s) {
        console.warn("[board] deleting a prompt failed", s), this.myPrompts.undrop(e), t.toast("The prompt couldn't be deleted. Try again.", "error");
      }
    }
  }
  // --------------------------------------------------------------- the panel
  /**
   * Open it over a session's prompt, or over the canvas: from the board menu,
   * the rail, or Start from a prompt in a menu that starts sessions. It opens
   * on All prompts (or the kind `kind` asks for), so a branch left from one
   * session never hides another's prompts. Over the canvas, `at` is where a
   * session it starts goes (a right-click's point).
   */
  open(e, t = {}) {
    const i = this.b.ui;
    i.advOpen = !1, i.boardMenu = !1, i.library.sessionId = e, i.library.inStudio = !1, i.library.at = e ? null : t.at || null, i.library.kind = t.kind || null, i.library.action = null, i.library.category = null, i.library.detail = null, i.library.editing = null, i.library.query = "", i.library.open = !0, this.load(), this.myPrompts.refresh(), this.startMine();
  }
  /** Open it over the Studios view, for the session open there (B25: Studio's Generate side offers everything the card does). */
  openInStudio(e) {
    this.open(e), this.b.ui.library.inStudio = !0;
  }
  toggle(e) {
    const t = this.b.ui.library;
    t.open && t.sessionId === e ? this.close() : this.open(e);
  }
  close() {
    this.b.ui.library.open = !1, this.b.ui.library.detail = null, this.b.ui.library.editing = null;
  }
  /** Esc: the detail steps back to the grid, then the panel closes. */
  back() {
    const e = this.b.ui.library;
    e.editing ? e.editing = null : e.detail ? e.detail = null : this.close();
  }
  setTab(e) {
    const t = this.b.ui.library;
    t.tab = e, t.detail = null, t.editing = null, e === "mine" && this.startMine();
  }
  setCategory(e) {
    this.b.ui.library.category = e, this.b.ui.library.detail = null;
  }
  /** Both tabs narrowed to prompts for image sessions or for video ones; null for both. */
  setKind(e) {
    this.setBranch(e, null, null);
  }
  /**
   * The sidebar's branch (IL-103): a kind, what its prompts do (Generate or
   * Edit) and a category under that; each narrower one needs the one before.
   */
  setBranch(e, t = null, i = null) {
    const s = this.b.ui.library;
    s.kind = e, s.action = e ? t : null, s.category = e && t ? i : null, s.detail = null;
  }
  /** Where a tab's grid scroll is kept: it comes back only to the branch it was left in. */
  scrollKey() {
    const e = this.b.ui.library;
    return [e.tab, e.kind || "", e.action || "", e.category || ""].join("|");
  }
  // ------------------------------------------------------- what it will do
  /** The session the panel applies to, if it's still there. */
  session(e) {
    const t = e ? this.b.store.get(e) : null;
    return t && t.type === "tool" ? t : null;
  }
  /**
   * What Use prompt and Remix will do with this prompt here, said before the
   * click: the tool isn't on this board, or isn't in this session's kit.
   */
  toolNote(e, t) {
    const i = this.b.catalog.value, s = Xa(i, e.tool);
    if (!s) {
      const r = this.kitForKind(i, e.kind, this.session(t)), a = r ? Bi(r) : null;
      return e.tool.name + " isn't available here. Use prompt keeps your tool" + (a ? "; Remix uses " + a.name + "." : ".");
    }
    const o = this.session(t);
    if (o) {
      const { kit: r } = this.b.modelFor(o);
      if (r && !Fc(i, r, s)) return "This session can't run " + s.name + ". Use prompt keeps its tool; Remix starts a new " + (sk(i, s) || { name: "" }).name.toLowerCase() + " session.";
    }
    return "";
  }
  /**
   * Where Remix will put the example: the session it was opened for, when
   * that session's kit runs it (B25: Nathan, a remix belongs with the
   * session's work, not in a new session), else a new one beside it.
   */
  remixFills(e, t) {
    const i = this.session(t);
    if (!i || this.b.isHeld(i)) return !1;
    const s = this.remixKit(e, i);
    return !!s && s.id === i.kitId;
  }
  // ---------------------------------------------------------- use prompt
  /**
   * Put the prompt's text in the session, switching it to the prompt's tool
   * when its kit has it. Its images and settings stay; one Undo puts it all
   * back. With no session (opened from the board menu), a new one starts.
   */
  async use(e, t) {
    const i = this.b, s = this.session(t);
    if (this.close(), !s) {
      this.startSession(e);
      return;
    }
    await i.draftReady(s.id);
    const o = this.session(s.id);
    if (!o) return;
    const r = { prompt: i.promptOf(o.id).prompt || "", model: o.model, nodeDefId: o.nodeDefId, name: o.name, fresh: i.freshTools.has(o.id) }, a = Xa(i.catalog.value, e.tool), { kit: l, model: d } = i.modelFor(o), c = a && l && (!d || d.id !== a.id) && Fc(i.catalog.value, l, a) ? a : null, h = ok(o.name) ? i.uniqueSessionName(e.name, o.id) : null;
    (c || h) && i.patchTool(o.id, { ...c ? { model: c.name, nodeDefId: c.id } : {}, ...h ? { name: h } : {} }), i.setPrompt(o.id, { prompt: e.prompt }), i.landPrompt(o.id);
    const f = h || o.name;
    i.toast(c ? "Prompt added to " + f + ", on " + c.name : "Prompt added to " + f, "info", {
      label: "Undo",
      run: () => this.undoUse(o.id, r)
    });
  }
  undoUse(e, t) {
    const i = this.b, s = this.session(e);
    if (!s) return;
    const o = {};
    s.nodeDefId !== t.nodeDefId && (o.model = t.model, o.nodeDefId = t.nodeDefId), s.name !== t.name && (o.name = t.name), Object.keys(o).length && i.patchTool(e, o), i.setPrompt(e, { prompt: t.prompt }), t.fresh && i.freshTools.add(e), i.landPrompt(e), i.dismissToast();
  }
  // --------------------------------------------------------------- remix
  /** The kit Remix runs the prompt in: its tool's, the session's own first. */
  remixKit(e, t) {
    const i = this.b.catalog.value, s = Xa(i, e.tool);
    return s ? sk(i, s, t ? t.kitId : null) : this.kitForKind(i, e.kind, t);
  }
  /** Without the prompt's tool: the session's kit when it takes this kind of prompt, else the first that does. */
  kitForKind(e, t, i) {
    if (i && Ja(i.kitId) === t) {
      const s = e.kits.find((o) => o.id === i.kitId);
      if (s) return s;
    }
    return e.kits.find((s) => Ja(s.id) === t) || null;
  }
  /**
   * Recreate the example: the tool, the prompt, its input images in order and
   * the output's shape, so Run makes it again. A new, empty session takes it;
   * otherwise a new session starts beside it (a session is one line of work,
   * so one with results is never overwritten).
   */
  async remix(e, t) {
    const i = this.b, s = this.session(t);
    s && this.remixFills(e, s.id) && await i.draftReady(s.id);
    const o = this.session(t), r = i.catalog.value, a = Xa(r, e.tool), l = this.remixKit(e, o), d = a || (l ? Bi(l) : null);
    if (this.close(), !l || !d) {
      i.toast("No tool on this board can run this prompt.", "error");
      return;
    }
    let c, h = 0;
    if (Or(e) && e.values && a && a.id === e.tool.nodeDefId) {
      const w = dc(a, e.values, (S) => i.assetUrl(S));
      if (w.inputs)
        for (const S of a.fields) S.kind === "seed" && delete w.inputs[S.key];
      c = { ...w, prompt: e.prompt, n: 1 };
    } else
      ({ up: c, dropped: h } = KV(d, e));
    let f, p, y = null;
    o && this.remixFills(e, o.id) ? (y = { up: JSON.parse(JSON.stringify(i.promptOf(o.id))), model: o.model, nodeDefId: o.nodeDefId, name: o.name }, p = ok(o.name) ? i.uniqueSessionName(e.name, o.id) : o.name, i.patchTool(o.id, { model: d.name, nodeDefId: d.id, ...p !== o.name ? { name: p } : {} }), f = o.id, i.ui.selection = [f]) : (p = i.uniqueSessionName(e.name), f = i.addSession(l, d, p, o ? void 0 : i.ui.library.at || void 0).id), i.setPrompt(f, { prompt: c.prompt, ref: c.ref || null, inputs: c.inputs || {}, assets: c.assets, n: 1 }), i.landPrompt(f), i.track("remix_initiated", { node_def_id: d.id, source: "prompt_library", prompt_id: e.id });
    let v = "";
    a ? h && (v = " " + (h === 1 ? "One of its images doesn't" : h + " of its images don't") + " fit " + d.name + ", so " + (h === 1 ? "it was" : "they were") + " left out.") : v = " " + e.tool.name + " isn't available here, so it uses " + d.name + ".";
    const x = y;
    i.toast("Remix ready in " + p + ". Run makes it again." + v, "info", x ? {
      label: "Undo",
      run: () => {
        const w = this.session(f);
        w && (i.patchTool(f, { model: x.model, nodeDefId: x.nodeDefId, ...w.name !== x.name ? { name: x.name } : {} }), i.replacePrompt(f, x.up), i.landPrompt(f), i.dismissToast());
      }
    } : void 0);
  }
  /** Use prompt with no session: a new one, with the prompt's text, where the panel was opened for (a right-click's point). */
  startSession(e) {
    const t = this.b, i = t.catalog.value, s = Xa(i, e.tool), o = this.remixKit(e, null), r = s || (o ? Bi(o) : null);
    if (!o || !r) {
      t.toast("No tool on this board can run this prompt.", "error");
      return;
    }
    const a = t.uniqueSessionName(e.name), l = t.addSession(o, r, a, t.ui.library.at || void 0).id;
    t.setPrompt(l, { prompt: e.prompt, n: 1 }), t.landPrompt(l), t.toast("New session ready: " + a);
  }
  // ----------------------------------------------------------- ghost text
  /**
   * The one-liners a new session's empty prompt cycles: its kind's, the edits
   * only once it has an image. Each session starts on its own line.
   */
  ghostLines(e) {
    const t = this.featured.value;
    if (!t) return [];
    const i = this.b.promptOf(e.id), s = (l) => typeof l == "string" && /^(https?:|blob:|data:)/.test(l), o = !!i.ref || Object.values(i.inputs || {}).some((l) => s(l) || Array.isArray(l) && l.some(s)), r = YV(t.prompts, Ja(e.kitId), o), a = XV(e.id, r.length);
    return r.slice(a).concat(r.slice(0, a));
  }
}
const bie = [{ key: "smileys", label: "Smileys" }, { key: "people", label: "People" }, { key: "nature", label: "Animals & nature" }, { key: "food", label: "Food & drink" }, { key: "travel", label: "Travel & places" }, { key: "activities", label: "Activities" }, { key: "objects", label: "Objects" }, { key: "symbols", label: "Symbols" }, { key: "flags", label: "Flags" }], vie = `#smileys
😀|grinning face|cheerful cheery grin happy laugh nice|grinning|1|
😃|grinning face with big eyes|awesome grin happy mouth open smile|smiley|0.6|
😄|grinning face with smiling eyes|eye grin happy laugh lol mouth|smile|0.6|
😁|beaming face with smiling eyes|eye grin grinning happy nice smile|grin|0.6|
😆|grinning squinting face|closed eyes haha hahaha happy laugh|laughing satisfied|0.6|
😅|grinning face with sweat|cold dejected excited mouth nervous open|sweat_smile|0.6|
🤣|rolling on the floor laughing|crying face funny haha happy hehe|rofl|3|
😂|face with tears of joy|crying feels funny haha happy hehe|joy|0.6|
🙂|slightly smiling face|happy smile|slightly_smiling_face|1|
🙃|upside-down face|hehe smile upside-down|upside_down_face|1|
🫠|melting face|disappear dissolve embarrassed haha heat hot|melting_face|14|
🫫|cracking face|breaking crumbling masking resilience reveal tension||18|
😉|winking face|flirt heartbreaker sexy slide tease wink|wink|0.6|
😊|smiling face with smiling eyes|blush eye glad satisfied smile|blush|0.6|
😇|smiling face with halo|angel angelic angels blessed fairy fairytale|innocent|1|
🥰|smiling face with hearts|3 adore crush heart ily love|smiling_face_with_three_hearts|11|
😍|smiling face with heart-eyes|143 bae eye feels heart-eyes hearts|heart_eyes|0.6|
🤩|star-struck|excited eyes face grinning smile starry-eyed|star_struck|5|
😘|face blowing a kiss|adorbs bae flirt heart ily love|kissing_heart|0.6|
😗|kissing face|143 date dating flirt ily kiss|kissing|1|
☺️|smiling face|happy outlined relaxed smile|relaxed|0.6|
😚|kissing face with closed eyes|143 bae blush date dating eye|kissing_closed_eyes|0.6|
😙|kissing face with smiling eyes|143 closed date dating eye flirt|kissing_smiling_eyes|1|
🥲|smiling face with tear|glad grateful happy joy pain proud|smiling_face_with_tear|13|
😋|face savoring food|delicious eat full hungry savor smile|yum|0.6|
😛|face with tongue|awesome cool nice party stuck-out sweet|stuck_out_tongue|1|
😜|winking face with tongue|crazy epic eye funny joke loopy|stuck_out_tongue_winking_eye|0.6|
🤪|zany face|crazy eye eyes goofy large small|zany_face|5|
😝|squinting face with tongue|closed eye eyes gross horrible omg|stuck_out_tongue_closed_eyes|0.6|
🤑|money-mouth face|money-mouth paid|money_mouth_face|1|
🤗|smiling face with open hands|hug hugging|hugs|1|
🤭|face with hand over mouth|giggle giggling oops realization secret shock|hand_over_mouth|5|
🫢|face with open eyes and hand over mouth|amazement awe disbelief embarrass gasp omg|face_with_open_eyes_and_hand_over_mouth|14|
🫣|face with peeking eye|captivated embarrass hide hiding peek peep|face_with_peeking_eye|14|
🤫|shushing face|quiet shh shush|shushing_face|5|
🤔|thinking face|chin consider hmm ponder pondering wondering|thinking|1|
🫡|saluting face|ok good luck ma’am respect salute|saluting_face|14|
🤐|zipper-mouth face|keep quiet secret shut zip zipper-mouth|zipper_mouth_face|1|
🤨|face with raised eyebrow|disapproval disbelief distrust emoji hmm mild|raised_eyebrow|5|
😐|neutral face|awkward blank deadpan expressionless fine jealous|neutral_face|0.7|
😑|expressionless face|awkward dead fine inexpressive jealous meh|expressionless|1|
😶|face without mouth|awkward blank expressionless mouthless mute quiet|no_mouth|1|
🫥|dotted line face|depressed disappear hidden hide introvert invisible|dotted_line_face|14|
😶‍🌫️|face in clouds|absentminded fog head|face_in_clouds|13.1|
😏|smirking face|boss dapper flirt homie kidding leer|smirk|0.6|
😒|unamused face|... bored fine jealous jel jelly|unamused|0.6|
🙄|face with rolling eyes|eyeroll shade ugh whatever|roll_eyes|1|
😬|grimacing face|awk awkward dentist grimace grinning smile|grimacing|1|
😮‍💨|face exhaling|blow blowing exhale exhausted gasp groan|face_exhaling|13.1|
🤥|lying face|liar lie pinocchio|lying_face|3|
🫨|shaking face|crazy daze earthquake omg panic shock|shaking_face|15|
🙂‍↔️|head shaking horizontally|no shake||15.1|
🙂‍↕️|head shaking vertically|nod yes||15.1|
😌|relieved face|calm peace relief zen|relieved|0.6|
😔|pensive face|awful bored dejected died disappointed losing|pensive|0.6|
😪|sleepy face|crying good night sad sleep sleeping|sleepy|0.6|
🤤|drooling face||drooling_face|3|
😴|sleeping face|bed bedtime good goodnight nap night|sleeping|1|
🫩|face with bags under eyes|bored exhausted fatigued late sleepy tired||16|
😷|face with medical mask|cold dentist dermatologist doctor dr germs|mask|0.6|
🤒|face with thermometer|ill sick|face_with_thermometer|1|
🤕|face with head-bandage|head-bandage hurt injury ouch|face_with_head_bandage|1|
🤢|nauseated face|gross nasty sick vomit|nauseated_face|3|
🤮|face vomiting|barf ew gross puke sick spew|vomiting_face|5|
🤧|sneezing face|fever flu gesundheit sick sneeze|sneezing_face|3|
🥵|hot face|dying feverish heat panting red-faced stroke|hot_face|11|
🥶|cold face|blue blue-faced freezing frostbite icicles subzero|cold_face|11|
🥴|woozy face|dizzy drunk eyes intoxicated mouth tipsy|woozy_face|11|
😵|face with crossed-out eyes|crossed-out dead dizzy feels knocked sick|dizzy_face|0.6|
😵‍💫|face with spiral eyes|confused dizzy hypnotized omg smiley trouble|face_with_spiral_eyes|13.1|
🤯|exploding head|blown explode mind mindblown no shocked|exploding_head|5|
🤠|cowboy hat face|cowgirl|cowboy_hat_face|3|
🥳|partying face|bday birthday celebrate celebration excited happy|partying_face|11|
🥸|disguised face|disguise eyebrow glasses incognito moustache mustache|disguised_face|13|
😎|smiling face with sunglasses|awesome beach bright bro chilling cool|sunglasses|1|
🤓|nerd face|brainy clever expert geek gifted glasses|nerd_face|1|
🧐|face with monocle|classy fancy rich stuffy wealthy|monocle_face|5|
😕|confused face|befuddled confusing dunno frown hm meh|confused|1|
🫤|face with diagonal mouth|confused confusion disappointed doubt doubtful frustrated|face_with_diagonal_mouth|14|
😟|worried face|anxious butterflies nerves nervous sad stress|worried|1|
🙁|slightly frowning face|frown sad|slightly_frowning_face|1|
☹️|frowning face|frown sad|frowning_face|0.7|
😮|face with open mouth|believe forgot omg shocked surprised sympathy|open_mouth|1|
😯|hushed face|epic omg stunned surprised whoa woah|hushed|1|
😲|astonished face|cost no omg shocked totally way|astonished|0.6|
😳|flushed face|amazed awkward crazy dazed dead disbelief|flushed|0.6|
🫪|distorted face|anxiety bloated panic shocked surprised vulnerable||17|
🥺|pleading face|begging big eyes mercy not please|pleading_face|11|
🥹|face holding back tears|admiration aww cry embarrassed feelings grateful|face_holding_back_tears|14|
😦|frowning face with open mouth|caught frown guard scared scary surprise|frowning|1|
😧|anguished face|forgot scared scary stressed surprise unhappy|anguished|1|
😨|fearful face|afraid anxious blame fear scared worried|fearful|0.6|
😰|anxious face with sweat|blue cold eek mouth nervous open|cold_sweat|0.6|
😥|sad but relieved face|anxious call close complicated disappointed not|disappointed_relieved|0.6|
😢|crying face|awful cry feels miss sad tear|cry|0.6|
😭|loudly crying face|bawling cry sad sob tear tears|sob|0.6|
😱|face screaming in fear|epic fearful munch scared scream screamer|scream|0.6|
😖|confounded face|annoyed confused cringe distraught feels frustrated|confounded|0.6|
😣|persevering face|concentrate concentration focus headache persevere|persevere|0.6|
😞|disappointed face|awful blame dejected fail losing sad|disappointed|0.6|
😓|downcast face with sweat|close cold feels headache nervous sad|sweat|0.6|
😩|weary face|crying fail feels hungry mad nooo|weary|0.6|
😫|tired face|cost feels nap sad sneeze|tired_face|0.6|
🥱|yawning face|bedtime bored goodnight nap night sleep|yawning_face|12|
😤|face with steam from nose|anger angry feels fume fuming furious|triumph|0.6|
😡|enraged face|anger angry feels mad maddening pouting|pout rage|0.6|
😠|angry face|anger blame feels frustrated mad maddening|angry|0.6|
🤬|face with symbols on mouth|censor cursing cussing mad pissed swearing|cursing_face|5|
😈|smiling face with horns|demon devil evil fairy fairytale fantasy|smiling_imp|1|
👿|angry face with horns|demon devil evil fairy fairytale fantasy|imp|0.6|
💀|skull|body dead death face fairy fairytale|skull|0.6|
☠️|skull and crossbones|bone dead death face monster|skull_and_crossbones|1|
💩|pile of poo|bs comic doo dung face fml|hankey poop|0.6|
🤡|clown face||clown_face|3|
👹|ogre|creature devil face fairy fairytale fantasy|japanese_ogre|0.6|
👺|goblin|angry creature face fairy fairytale fantasy|japanese_goblin|0.6|
👻|ghost|boo creature excited face fairy fairytale|ghost|0.6|
👽|alien|creature extraterrestrial face fairy fairytale fantasy|alien|0.6|
👾|alien monster|creature extraterrestrial face fairy fairytale fantasy|space_invader|0.6|
🤖|robot|face monster|robot|1|
😺|grinning cat|animal face mouth open smile smiling|smiley_cat|0.6|
😸|grinning cat with smiling eyes|animal eye face grin smile|smile_cat|0.6|
😹|cat with tears of joy|animal face laugh laughing lol tear|joy_cat|0.6|
😻|smiling cat with heart-eyes|animal eye face heart-eyes love smile|heart_eyes_cat|0.6|
😼|cat with wry smile|animal face ironic|smirk_cat|0.6|
😽|kissing cat|animal closed eye eyes face kiss|kissing_cat|0.6|
🙀|weary cat|animal face oh surprised|scream_cat|0.6|
😿|crying cat|animal cry face sad tear|crying_cat_face|0.6|
😾|pouting cat|animal face|pouting_cat|0.6|
🙈|see-no-evil monkey|embarrassed face forbidden forgot gesture hide|see_no_evil|0.6|
🙉|hear-no-evil monkey|animal ears face forbidden gesture listen|hear_no_evil|0.6|
🙊|speak-no-evil monkey|animal face forbidden gesture not oops|speak_no_evil|0.6|
💌|love letter|heart mail romance valentine|love_letter|0.6|
💘|heart with arrow|143 adorbs cupid date emotion ily|cupid|0.6|
💝|heart with ribbon|143 anniversary emotion ily kisses valentine|gift_heart|0.6|
💖|sparkling heart|143 emotion excited good ily kisses|sparkling_heart|0.6|
💗|growing heart|143 emotion excited heartpulse ily kisses|heartpulse|0.6|
💓|beating heart|143 cardio emotion heartbeat ily love|heartbeat|0.6|
💞|revolving hearts|143 adorbs anniversary emotion heart|revolving_hearts|0.6|
💕|two hearts|143 anniversary date dating emotion heart|two_hearts|0.6|
💟|heart decoration|143 emotion hearth purple white|heart_decoration|0.6|
❣️|heart exclamation|bang heavy mark punctuation|heavy_heart_exclamation|1|
💔|broken heart|break crushed emotion heartbroken lonely sad|broken_heart|0.6|
❤️‍🔥|heart on fire|burn love lust sacred|heart_on_fire|13.1|
❤️‍🩹|mending heart|healthier improving recovering recuperating well|mending_heart|13.1|
❤️|red heart|emotion love|heart|0.6|
🩷|pink heart|143 adorable cute emotion ily like|pink_heart|15|
🧡|orange heart|143|orange_heart|5|
💛|yellow heart|143 cardiac emotion ily love|yellow_heart|0.6|
💚|green heart|143 emotion ily love romantic|green_heart|0.6|
💙|blue heart|143 emotion ily love romance|blue_heart|0.6|
🩵|light blue heart|143 cute cyan emotion ily like|light_blue_heart|15|
💜|purple heart|143 bestest emotion ily love|purple_heart|0.6|
🤎|brown heart|143|brown_heart|12|
🖤|black heart|evil wicked|black_heart|3|
🩶|grey heart|143 emotion gray ily love silver|grey_heart|15|
🤍|white heart|143|white_heart|12|
💋|kiss mark|dating emotion heart kissing lips romance|kiss|0.6|
💯|hundred points|100 true a+ agree clearly definitely|100|0.6|
💢|anger symbol|angry comic mad upset|anger|0.6|
🫯|fight cloud|argument brawl debate disagreement ruckus wrestle||17|
💥|collision|bomb boom collide comic explode|boom collision|0.6|
💫|dizzy|comic shining shooting star stars|dizzy|0.6|
💦|sweat droplets|comic drip droplet drops splashing squirt|sweat_drops|0.6|
💨|dashing away|cloud comic dash fart fast go|dash|0.6|
🕳️|hole||hole|0.7|
💬|speech balloon|bubble comic dialog message sms talk|speech_balloon|0.6|
👁️‍🗨️|eye in speech bubble|balloon witness|eye_speech_bubble|2|
🗨️|left speech bubble|balloon dialog|left_speech_bubble|2|
🗯️|right anger bubble|angry balloon mad|right_anger_bubble|0.7|
💭|thought balloon|bubble cartoon cloud comic daydream decisions|thought_balloon|1|
💤|ZZZ|comic good goodnight night sleep sleeping|zzz|0.6|
#people
👋|waving hand|bye cya g2g greetings gtg hello|wave|0.6|👋🏻 👋🏼 👋🏽 👋🏾 👋🏿
🤚|raised back of hand|backhand|raised_back_of_hand|3|🤚🏻 🤚🏼 🤚🏽 🤚🏾 🤚🏿
🖐️|hand with fingers splayed|finger raised stop|raised_hand_with_fingers_splayed|0.7|🖐🏻 🖐🏼 🖐🏽 🖐🏾 🖐🏿
✋|raised hand|5 five high stop|hand raised_hand|0.6|✋🏻 ✋🏼 ✋🏽 ✋🏾 ✋🏿
🖖|vulcan salute|finger hand hands|vulcan_salute|1|🖖🏻 🖖🏼 🖖🏽 🖖🏾 🖖🏿
🫱|rightwards hand|handshake hold reach right rightward shake|rightwards_hand|14|🫱🏻 🫱🏼 🫱🏽 🫱🏾 🫱🏿
🫲|leftwards hand|handshake hold left leftward reach shake|leftwards_hand|14|🫲🏻 🫲🏼 🫲🏽 🫲🏾 🫲🏿
🫳|palm down hand|dismiss drop dropped pick shoo up|palm_down_hand|14|🫳🏻 🫳🏼 🫳🏽 🫳🏾 🫳🏿
🫴|palm up hand|beckon catch come hold know lift|palm_up_hand|14|🫴🏻 🫴🏼 🫴🏽 🫴🏾 🫴🏿
🫷|leftwards pushing hand|block five halt high hold leftward|leftwards_pushing_hand|15|🫷🏻 🫷🏼 🫷🏽 🫷🏾 🫷🏿
🫸|rightwards pushing hand|block five halt high hold pause|rightwards_pushing_hand|15|🫸🏻 🫸🏼 🫸🏽 🫸🏾 🫸🏿
👌|OK hand|awesome bet dope fleek fosho got|ok_hand|0.6|👌🏻 👌🏼 👌🏽 👌🏾 👌🏿
🤌|pinched fingers|gesture hand hold huh interrogation patience|pinched_fingers|13|🤌🏻 🤌🏼 🤌🏽 🤌🏾 🤌🏿
🤏|pinching hand|amount bit fingers little small sort|pinching_hand|12|🤏🏻 🤏🏼 🤏🏽 🤏🏾 🤏🏿
✌️|victory hand|peace v|v|0.6|✌🏻 ✌🏼 ✌🏽 ✌🏾 ✌🏿
🤞|crossed fingers|cross finger hand luck|crossed_fingers|3|🤞🏻 🤞🏼 🤞🏽 🤞🏾 🤞🏿
🫰|hand with index finger and thumb crossed|<3 expensive heart love money snap|hand_with_index_finger_and_thumb_crossed|14|🫰🏻 🫰🏼 🫰🏽 🫰🏾 🫰🏿
🤟|love-you gesture|ily fingers hand love-you three|love_you_gesture|5|🤟🏻 🤟🏼 🤟🏽 🤟🏾 🤟🏿
🤘|sign of the horns|finger hand rock-on|metal|1|🤘🏻 🤘🏼 🤘🏽 🤘🏾 🤘🏿
🤙|call me hand|shaka hang loose|call_me_hand|3|🤙🏻 🤙🏼 🤙🏽 🤙🏾 🤙🏿
👈|backhand index pointing left|finger hand point|point_left|0.6|👈🏻 👈🏼 👈🏽 👈🏾 👈🏿
👉|backhand index pointing right|finger hand point|point_right|0.6|👉🏻 👉🏼 👉🏽 👉🏾 👉🏿
👆|backhand index pointing up|finger hand point|point_up_2|0.6|👆🏻 👆🏼 👆🏽 👆🏾 👆🏿
🖕|middle finger|hand|fu middle_finger|1|🖕🏻 🖕🏼 🖕🏽 🖕🏾 🖕🏿
👇|backhand index pointing down|finger hand point|point_down|0.6|👇🏻 👇🏼 👇🏽 👇🏾 👇🏿
☝️|index pointing up|finger hand point this|point_up|0.6|☝🏻 ☝🏼 ☝🏽 ☝🏾 ☝🏿
🫵|index pointing at the viewer|finger hand poke you|index_pointing_at_the_viewer|14|🫵🏻 🫵🏼 🫵🏽 🫵🏾 🫵🏿
👍|thumbs up|+1 good hand like thumb yes|+1 thumbsup|0.6|👍🏻 👍🏼 👍🏽 👍🏾 👍🏿
👎|thumbs down|-1 bad dislike good hand no|-1 thumbsdown|0.6|👎🏻 👎🏼 👎🏽 👎🏾 👎🏿
🫹|leftwards thumb sign|grip left neutral point that this||18|🫹🏻 🫹🏼 🫹🏽 🫹🏾 🫹🏿
🫺|rightwards thumb sign|grip neutral point right that this||18|🫺🏻 🫺🏼 🫺🏽 🫺🏾 🫺🏿
✊|raised fist|clenched hand punch solidarity|fist fist_raised|0.6|✊🏻 ✊🏼 ✊🏽 ✊🏾 ✊🏿
👊|oncoming fist|absolutely agree boom bro bruh bump|facepunch fist_oncoming|0.6|👊🏻 👊🏼 👊🏽 👊🏾 👊🏿
🤛|left-facing fist|left-facing leftwards|fist_left|3|🤛🏻 🤛🏼 🤛🏽 🤛🏾 🤛🏿
🤜|right-facing fist|right-facing rightwards|fist_right|3|🤜🏻 🤜🏼 🤜🏽 🤜🏾 🤜🏿
👏|clapping hands|applause approval awesome clap congrats congratulations|clap|0.6|👏🏻 👏🏼 👏🏽 👏🏾 👏🏿
🙌|raising hands|celebration gesture hand hooray praise raised|raised_hands|0.6|🙌🏻 🙌🏼 🙌🏽 🙌🏾 🙌🏿
🫶|heart hands|<3 love you|heart_hands|14|🫶🏻 🫶🏼 🫶🏽 🫶🏾 🫶🏿
👐|open hands|hand hug jazz swerve|open_hands|0.6|👐🏻 👐🏼 👐🏽 👐🏾 👐🏿
🤲|palms up together|cupped dua hands pray prayer wish|palms_up_together|5|🤲🏻 🤲🏼 🤲🏽 🤲🏾 🤲🏿
🤝|handshake|agreement deal hand meeting shake|handshake|3|🤝🏻 🤝🏼 🤝🏽 🤝🏾 🤝🏿
🙏|folded hands|appreciate ask beg blessed bow cmon|pray|0.6|🙏🏻 🙏🏼 🙏🏽 🙏🏾 🙏🏿
✍️|writing hand|write|writing_hand|0.7|✍🏻 ✍🏼 ✍🏽 ✍🏾 ✍🏿
💅|nail polish|bored care cosmetics done makeup manicure|nail_care|0.6|💅🏻 💅🏼 💅🏽 💅🏾 💅🏿
🤳|selfie|camera phone|selfie|3|🤳🏻 🤳🏼 🤳🏽 🤳🏾 🤳🏿
💪|flexed biceps|arm beast bench bodybuilder bro curls|muscle|0.6|💪🏻 💪🏼 💪🏽 💪🏾 💪🏿
🦾|mechanical arm|accessibility prosthetic|mechanical_arm|12|
🦿|mechanical leg|accessibility prosthetic|mechanical_leg|12|
🦵|leg|bent foot kick knee limb|leg|11|🦵🏻 🦵🏼 🦵🏽 🦵🏾 🦵🏿
🦶|foot|ankle feet kick stomp|foot|11|🦶🏻 🦶🏼 🦶🏽 🦶🏾 🦶🏿
👂|ear|body ears hear hearing listen listening|ear|0.6|👂🏻 👂🏼 👂🏽 👂🏾 👂🏿
🦻|ear with hearing aid|accessibility hard|ear_with_hearing_aid|12|🦻🏻 🦻🏼 🦻🏽 🦻🏾 🦻🏿
👃|nose|body noses nosey odor smell smells|nose|0.6|👃🏻 👃🏼 👃🏽 👃🏾 👃🏿
🧠|brain|intelligent smart|brain|5|
🫀|anatomical heart|beat cardiology heartbeat organ pulse real|anatomical_heart|13|
🫁|lungs|breath breathe exhalation inhalation lung organ|lungs|13|
🦷|tooth|dentist pearly teeth white|tooth|11|
🦴|bone|bones dog skeleton wishbone|bone|11|
👀|eyes|body eye face googly look looking|eyes|0.6|
👁️|eye|1 body one|eye|0.7|
👅|tongue|body lick slurp|tongue|0.6|
👄|mouth|beauty body kiss kissing lips lipstick|lips|0.6|
🫦|biting lip|anxious bite fear flirt flirting kiss|biting_lip|14|
👶|baby|babies children goo infant newborn pregnant|baby|0.6|👶🏻 👶🏼 👶🏽 👶🏾 👶🏿
🧒|child|bright-eyed grandchild kid young younger|child|5|🧒🏻 🧒🏼 🧒🏽 🧒🏾 🧒🏿
👦|boy|bright-eyed child grandson kid son young|boy|0.6|👦🏻 👦🏼 👦🏽 👦🏾 👦🏿
👧|girl|virgo bright-eyed child daughter granddaughter kid|girl|0.6|👧🏻 👧🏼 👧🏽 👧🏾 👧🏿
🧑|person|adult|adult|5|🧑🏻 🧑🏼 🧑🏽 🧑🏾 🧑🏿
👱|person: blond hair|blond-haired human|blond_haired_person|0.6|👱🏻 👱🏼 👱🏽 👱🏾 👱🏿
👨|man|adult bro|man|0.6|👨🏻 👨🏼 👨🏽 👨🏾 👨🏿
🧔|person: beard|bearded whiskers|bearded_person|5|🧔🏻 🧔🏼 🧔🏽 🧔🏾 🧔🏿
🧔‍♂️|man: beard|bearded whiskers|man_beard|13.1|🧔🏻‍♂️ 🧔🏼‍♂️ 🧔🏽‍♂️ 🧔🏾‍♂️ 🧔🏿‍♂️
🧔‍♀️|woman: beard|bearded whiskers|woman_beard|13.1|🧔🏻‍♀️ 🧔🏼‍♀️ 🧔🏽‍♀️ 🧔🏾‍♀️ 🧔🏿‍♀️
👨‍🦰|man: red hair|adult bro red hair|red_haired_man|11|👨🏻‍🦰 👨🏼‍🦰 👨🏽‍🦰 👨🏾‍🦰 👨🏿‍🦰
👨‍🦱|man: curly hair|adult bro curly hair|curly_haired_man|11|👨🏻‍🦱 👨🏼‍🦱 👨🏽‍🦱 👨🏾‍🦱 👨🏿‍🦱
👨‍🦳|man: white hair|adult bro white hair|white_haired_man|11|👨🏻‍🦳 👨🏼‍🦳 👨🏽‍🦳 👨🏾‍🦳 👨🏿‍🦳
👨‍🦲|man: bald|adult bro|bald_man|11|👨🏻‍🦲 👨🏼‍🦲 👨🏽‍🦲 👨🏾‍🦲 👨🏿‍🦲
👩|woman|adult lady|woman|0.6|👩🏻 👩🏼 👩🏽 👩🏾 👩🏿
👩‍🦰|woman: red hair|adult lady red hair|red_haired_woman|11|👩🏻‍🦰 👩🏼‍🦰 👩🏽‍🦰 👩🏾‍🦰 👩🏿‍🦰
🧑‍🦰|person: red hair|adult red hair|person_red_hair|12.1|🧑🏻‍🦰 🧑🏼‍🦰 🧑🏽‍🦰 🧑🏾‍🦰 🧑🏿‍🦰
👩‍🦱|woman: curly hair|adult curly hair lady|curly_haired_woman|11|👩🏻‍🦱 👩🏼‍🦱 👩🏽‍🦱 👩🏾‍🦱 👩🏿‍🦱
🧑‍🦱|person: curly hair|adult curly hair|person_curly_hair|12.1|🧑🏻‍🦱 🧑🏼‍🦱 🧑🏽‍🦱 🧑🏾‍🦱 🧑🏿‍🦱
👩‍🦳|woman: white hair|adult lady white hair|white_haired_woman|11|👩🏻‍🦳 👩🏼‍🦳 👩🏽‍🦳 👩🏾‍🦳 👩🏿‍🦳
🧑‍🦳|person: white hair|adult white hair|person_white_hair|12.1|🧑🏻‍🦳 🧑🏼‍🦳 🧑🏽‍🦳 🧑🏾‍🦳 🧑🏿‍🦳
👩‍🦲|woman: bald|adult lady|bald_woman|11|👩🏻‍🦲 👩🏼‍🦲 👩🏽‍🦲 👩🏾‍🦲 👩🏿‍🦲
🧑‍🦲|person: bald|adult|person_bald|12.1|🧑🏻‍🦲 🧑🏼‍🦲 🧑🏽‍🦲 🧑🏾‍🦲 🧑🏿‍🦲
👱‍♀️|woman: blond hair|blond-haired blonde|blond_haired_woman blonde_woman|4|👱🏻‍♀️ 👱🏼‍♀️ 👱🏽‍♀️ 👱🏾‍♀️ 👱🏿‍♀️
👱‍♂️|man: blond hair|blond-haired|blond_haired_man|4|👱🏻‍♂️ 👱🏼‍♂️ 👱🏽‍♂️ 👱🏾‍♂️ 👱🏿‍♂️
🧓|older person|adult elderly grandparent old wise|older_adult|5|🧓🏻 🧓🏼 🧓🏽 🧓🏾 🧓🏿
👴|old man|adult bald elderly gramps grandfather grandpa|older_man|0.6|👴🏻 👴🏼 👴🏽 👴🏾 👴🏿
👵|old woman|adult elderly grandma grandmother granny lady|older_woman|0.6|👵🏻 👵🏼 👵🏽 👵🏾 👵🏿
🙍|person frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_person|0.6|🙍🏻 🙍🏼 🙍🏽 🙍🏾 🙍🏿
🙍‍♂️|man frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_man|4|🙍🏻‍♂️ 🙍🏼‍♂️ 🙍🏽‍♂️ 🙍🏾‍♂️ 🙍🏿‍♂️
🙍‍♀️|woman frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_woman|4|🙍🏻‍♀️ 🙍🏼‍♀️ 🙍🏽‍♀️ 🙍🏾‍♀️ 🙍🏿‍♀️
🙎|person pouting|disappointed downtrodden frown grimace scowl sulk|pouting_face|0.6|🙎🏻 🙎🏼 🙎🏽 🙎🏾 🙎🏿
🙎‍♂️|man pouting|disappointed downtrodden frown grimace scowl sulk|pouting_man|4|🙎🏻‍♂️ 🙎🏼‍♂️ 🙎🏽‍♂️ 🙎🏾‍♂️ 🙎🏿‍♂️
🙎‍♀️|woman pouting|disappointed downtrodden frown grimace scowl sulk|pouting_woman|4|🙎🏻‍♀️ 🙎🏼‍♀️ 🙎🏽‍♀️ 🙎🏾‍♀️ 🙎🏿‍♀️
🙅|person gesturing NO|forbidden gesture hand not prohibit|no_good|0.6|🙅🏻 🙅🏼 🙅🏽 🙅🏾 🙅🏿
🙅‍♂️|man gesturing NO|forbidden gesture hand not prohibit|ng_man no_good_man|4|🙅🏻‍♂️ 🙅🏼‍♂️ 🙅🏽‍♂️ 🙅🏾‍♂️ 🙅🏿‍♂️
🙅‍♀️|woman gesturing NO|forbidden gesture hand not prohibit|ng_woman no_good_woman|4|🙅🏻‍♀️ 🙅🏼‍♀️ 🙅🏽‍♀️ 🙅🏾‍♀️ 🙅🏿‍♀️
🙆|person gesturing OK|exercise gesture hand omg|ok_person|0.6|🙆🏻 🙆🏼 🙆🏽 🙆🏾 🙆🏿
🙆‍♂️|man gesturing OK|exercise gesture hand omg|ok_man|4|🙆🏻‍♂️ 🙆🏼‍♂️ 🙆🏽‍♂️ 🙆🏾‍♂️ 🙆🏿‍♂️
🙆‍♀️|woman gesturing OK|exercise gesture hand omg|ok_woman|4|🙆🏻‍♀️ 🙆🏼‍♀️ 🙆🏽‍♀️ 🙆🏾‍♀️ 🙆🏿‍♀️
💁|person tipping hand|fetch flick flip gossip sarcasm sarcastic|information_desk_person tipping_hand_person|0.6|💁🏻 💁🏼 💁🏽 💁🏾 💁🏿
💁‍♂️|man tipping hand|fetch flick flip gossip sarcasm sarcastic|sassy_man tipping_hand_man|4|💁🏻‍♂️ 💁🏼‍♂️ 💁🏽‍♂️ 💁🏾‍♂️ 💁🏿‍♂️
💁‍♀️|woman tipping hand|fetch flick flip gossip sarcasm sarcastic|sassy_woman tipping_hand_woman|4|💁🏻‍♀️ 💁🏼‍♀️ 💁🏽‍♀️ 💁🏾‍♀️ 💁🏿‍♀️
🙋|person raising hand|gesture here know me pick question|raising_hand|0.6|🙋🏻 🙋🏼 🙋🏽 🙋🏾 🙋🏿
🙋‍♂️|man raising hand|gesture here know me pick question|raising_hand_man|4|🙋🏻‍♂️ 🙋🏼‍♂️ 🙋🏽‍♂️ 🙋🏾‍♂️ 🙋🏿‍♂️
🙋‍♀️|woman raising hand|gesture here know me pick question|raising_hand_woman|4|🙋🏻‍♀️ 🙋🏼‍♀️ 🙋🏽‍♀️ 🙋🏾‍♀️ 🙋🏿‍♀️
🧏|deaf person|accessibility ear gesture hear|deaf_person|12|🧏🏻 🧏🏼 🧏🏽 🧏🏾 🧏🏿
🧏‍♂️|deaf man|accessibility ear gesture hear|deaf_man|12|🧏🏻‍♂️ 🧏🏼‍♂️ 🧏🏽‍♂️ 🧏🏾‍♂️ 🧏🏿‍♂️
🧏‍♀️|deaf woman|accessibility ear gesture hear|deaf_woman|12|🧏🏻‍♀️ 🧏🏼‍♀️ 🧏🏽‍♀️ 🧏🏾‍♀️ 🧏🏿‍♀️
🙇|person bowing|apology ask beg bow favor forgive|bow|0.6|🙇🏻 🙇🏼 🙇🏽 🙇🏾 🙇🏿
🙇‍♂️|man bowing|apology ask beg bow favor forgive|bowing_man|4|🙇🏻‍♂️ 🙇🏼‍♂️ 🙇🏽‍♂️ 🙇🏾‍♂️ 🙇🏿‍♂️
🙇‍♀️|woman bowing|apology ask beg bow favor forgive|bowing_woman|4|🙇🏻‍♀️ 🙇🏼‍♀️ 🙇🏽‍♀️ 🙇🏾‍♀️ 🙇🏿‍♀️
🤦|person facepalming|again bewilder disbelief exasperation facepalm no|facepalm|3|🤦🏻 🤦🏼 🤦🏽 🤦🏾 🤦🏿
🤦‍♂️|man facepalming|again bewilder disbelief exasperation facepalm no|man_facepalming|4|🤦🏻‍♂️ 🤦🏼‍♂️ 🤦🏽‍♂️ 🤦🏾‍♂️ 🤦🏿‍♂️
🤦‍♀️|woman facepalming|again bewilder disbelief exasperation facepalm no|woman_facepalming|4|🤦🏻‍♀️ 🤦🏼‍♀️ 🤦🏽‍♀️ 🤦🏾‍♀️ 🤦🏿‍♀️
🤷|person shrugging|doubt dunno guess idk ignorance indifference|shrug|3|🤷🏻 🤷🏼 🤷🏽 🤷🏾 🤷🏿
🤷‍♂️|man shrugging|doubt dunno guess idk ignorance indifference|man_shrugging|4|🤷🏻‍♂️ 🤷🏼‍♂️ 🤷🏽‍♂️ 🤷🏾‍♂️ 🤷🏿‍♂️
🤷‍♀️|woman shrugging|doubt dunno guess idk ignorance indifference|woman_shrugging|4|🤷🏻‍♀️ 🤷🏼‍♀️ 🤷🏽‍♀️ 🤷🏾‍♀️ 🤷🏿‍♀️
🧑‍⚕️|health worker|doctor healthcare nurse therapist|health_worker|12.1|🧑🏻‍⚕️ 🧑🏼‍⚕️ 🧑🏽‍⚕️ 🧑🏾‍⚕️ 🧑🏿‍⚕️
👨‍⚕️|man health worker|doctor healthcare nurse therapist|man_health_worker|4|👨🏻‍⚕️ 👨🏼‍⚕️ 👨🏽‍⚕️ 👨🏾‍⚕️ 👨🏿‍⚕️
👩‍⚕️|woman health worker|doctor healthcare nurse therapist|woman_health_worker|4|👩🏻‍⚕️ 👩🏼‍⚕️ 👩🏽‍⚕️ 👩🏾‍⚕️ 👩🏿‍⚕️
🧑‍🎓|student|graduate|student|12.1|🧑🏻‍🎓 🧑🏼‍🎓 🧑🏽‍🎓 🧑🏾‍🎓 🧑🏿‍🎓
👨‍🎓|man student|graduate|man_student|4|👨🏻‍🎓 👨🏼‍🎓 👨🏽‍🎓 👨🏾‍🎓 👨🏿‍🎓
👩‍🎓|woman student|graduate|woman_student|4|👩🏻‍🎓 👩🏼‍🎓 👩🏽‍🎓 👩🏾‍🎓 👩🏿‍🎓
🧑‍🏫|teacher|instructor lecturer professor|teacher|12.1|🧑🏻‍🏫 🧑🏼‍🏫 🧑🏽‍🏫 🧑🏾‍🏫 🧑🏿‍🏫
👨‍🏫|man teacher|instructor lecturer professor|man_teacher|4|👨🏻‍🏫 👨🏼‍🏫 👨🏽‍🏫 👨🏾‍🏫 👨🏿‍🏫
👩‍🏫|woman teacher|instructor lecturer professor|woman_teacher|4|👩🏻‍🏫 👩🏼‍🏫 👩🏽‍🏫 👩🏾‍🏫 👩🏿‍🏫
🧑‍⚖️|judge|justice law scales|judge|12.1|🧑🏻‍⚖️ 🧑🏼‍⚖️ 🧑🏽‍⚖️ 🧑🏾‍⚖️ 🧑🏿‍⚖️
👨‍⚖️|man judge|justice law scales|man_judge|4|👨🏻‍⚖️ 👨🏼‍⚖️ 👨🏽‍⚖️ 👨🏾‍⚖️ 👨🏿‍⚖️
👩‍⚖️|woman judge|justice law scales|woman_judge|4|👩🏻‍⚖️ 👩🏼‍⚖️ 👩🏽‍⚖️ 👩🏾‍⚖️ 👩🏿‍⚖️
🧑‍🌾|farmer|gardener rancher|farmer|12.1|🧑🏻‍🌾 🧑🏼‍🌾 🧑🏽‍🌾 🧑🏾‍🌾 🧑🏿‍🌾
👨‍🌾|man farmer|gardener rancher|man_farmer|4|👨🏻‍🌾 👨🏼‍🌾 👨🏽‍🌾 👨🏾‍🌾 👨🏿‍🌾
👩‍🌾|woman farmer|gardener rancher|woman_farmer|4|👩🏻‍🌾 👩🏼‍🌾 👩🏽‍🌾 👩🏾‍🌾 👩🏿‍🌾
🧑‍🍳|cook|chef|cook|12.1|🧑🏻‍🍳 🧑🏼‍🍳 🧑🏽‍🍳 🧑🏾‍🍳 🧑🏿‍🍳
👨‍🍳|man cook|chef|man_cook|4|👨🏻‍🍳 👨🏼‍🍳 👨🏽‍🍳 👨🏾‍🍳 👨🏿‍🍳
👩‍🍳|woman cook|chef|woman_cook|4|👩🏻‍🍳 👩🏼‍🍳 👩🏽‍🍳 👩🏾‍🍳 👩🏿‍🍳
🧑‍🔧|mechanic|electrician plumber tradesperson|mechanic|12.1|🧑🏻‍🔧 🧑🏼‍🔧 🧑🏽‍🔧 🧑🏾‍🔧 🧑🏿‍🔧
👨‍🔧|man mechanic|electrician plumber tradesperson|man_mechanic|4|👨🏻‍🔧 👨🏼‍🔧 👨🏽‍🔧 👨🏾‍🔧 👨🏿‍🔧
👩‍🔧|woman mechanic|electrician plumber tradesperson|woman_mechanic|4|👩🏻‍🔧 👩🏼‍🔧 👩🏽‍🔧 👩🏾‍🔧 👩🏿‍🔧
🧑‍🏭|factory worker|assembly industrial|factory_worker|12.1|🧑🏻‍🏭 🧑🏼‍🏭 🧑🏽‍🏭 🧑🏾‍🏭 🧑🏿‍🏭
👨‍🏭|man factory worker|assembly industrial|man_factory_worker|4|👨🏻‍🏭 👨🏼‍🏭 👨🏽‍🏭 👨🏾‍🏭 👨🏿‍🏭
👩‍🏭|woman factory worker|assembly industrial|woman_factory_worker|4|👩🏻‍🏭 👩🏼‍🏭 👩🏽‍🏭 👩🏾‍🏭 👩🏿‍🏭
🧑‍💼|office worker|architect business manager white-collar|office_worker|12.1|🧑🏻‍💼 🧑🏼‍💼 🧑🏽‍💼 🧑🏾‍💼 🧑🏿‍💼
👨‍💼|man office worker|architect business manager white-collar|man_office_worker|4|👨🏻‍💼 👨🏼‍💼 👨🏽‍💼 👨🏾‍💼 👨🏿‍💼
👩‍💼|woman office worker|architect business manager white-collar|woman_office_worker|4|👩🏻‍💼 👩🏼‍💼 👩🏽‍💼 👩🏾‍💼 👩🏿‍💼
🧑‍🔬|scientist|biologist chemist engineer mathematician physicist|scientist|12.1|🧑🏻‍🔬 🧑🏼‍🔬 🧑🏽‍🔬 🧑🏾‍🔬 🧑🏿‍🔬
👨‍🔬|man scientist|biologist chemist engineer mathematician physicist|man_scientist|4|👨🏻‍🔬 👨🏼‍🔬 👨🏽‍🔬 👨🏾‍🔬 👨🏿‍🔬
👩‍🔬|woman scientist|biologist chemist engineer mathematician physicist|woman_scientist|4|👩🏻‍🔬 👩🏼‍🔬 👩🏽‍🔬 👩🏾‍🔬 👩🏿‍🔬
🧑‍💻|technologist|coder computer developer inventor software|technologist|12.1|🧑🏻‍💻 🧑🏼‍💻 🧑🏽‍💻 🧑🏾‍💻 🧑🏿‍💻
👨‍💻|man technologist|coder computer developer inventor software|man_technologist|4|👨🏻‍💻 👨🏼‍💻 👨🏽‍💻 👨🏾‍💻 👨🏿‍💻
👩‍💻|woman technologist|coder computer developer inventor software|woman_technologist|4|👩🏻‍💻 👩🏼‍💻 👩🏽‍💻 👩🏾‍💻 👩🏿‍💻
🧑‍🎤|singer|actor entertainer rock rockstar star|singer|12.1|🧑🏻‍🎤 🧑🏼‍🎤 🧑🏽‍🎤 🧑🏾‍🎤 🧑🏿‍🎤
👨‍🎤|man singer|actor entertainer rock rockstar star|man_singer|4|👨🏻‍🎤 👨🏼‍🎤 👨🏽‍🎤 👨🏾‍🎤 👨🏿‍🎤
👩‍🎤|woman singer|actor entertainer rock rockstar star|woman_singer|4|👩🏻‍🎤 👩🏼‍🎤 👩🏽‍🎤 👩🏾‍🎤 👩🏿‍🎤
🧑‍🎨|artist|palette|artist|12.1|🧑🏻‍🎨 🧑🏼‍🎨 🧑🏽‍🎨 🧑🏾‍🎨 🧑🏿‍🎨
👨‍🎨|man artist|palette|man_artist|4|👨🏻‍🎨 👨🏼‍🎨 👨🏽‍🎨 👨🏾‍🎨 👨🏿‍🎨
👩‍🎨|woman artist|palette|woman_artist|4|👩🏻‍🎨 👩🏼‍🎨 👩🏽‍🎨 👩🏾‍🎨 👩🏿‍🎨
🧑‍✈️|pilot|plane|pilot|12.1|🧑🏻‍✈️ 🧑🏼‍✈️ 🧑🏽‍✈️ 🧑🏾‍✈️ 🧑🏿‍✈️
👨‍✈️|man pilot|plane|man_pilot|4|👨🏻‍✈️ 👨🏼‍✈️ 👨🏽‍✈️ 👨🏾‍✈️ 👨🏿‍✈️
👩‍✈️|woman pilot|plane|woman_pilot|4|👩🏻‍✈️ 👩🏼‍✈️ 👩🏽‍✈️ 👩🏾‍✈️ 👩🏿‍✈️
🧑‍🚀|astronaut|rocket space|astronaut|12.1|🧑🏻‍🚀 🧑🏼‍🚀 🧑🏽‍🚀 🧑🏾‍🚀 🧑🏿‍🚀
👨‍🚀|man astronaut|rocket space|man_astronaut|4|👨🏻‍🚀 👨🏼‍🚀 👨🏽‍🚀 👨🏾‍🚀 👨🏿‍🚀
👩‍🚀|woman astronaut|rocket space|woman_astronaut|4|👩🏻‍🚀 👩🏼‍🚀 👩🏽‍🚀 👩🏾‍🚀 👩🏿‍🚀
🧑‍🚒|firefighter|fire firetruck|firefighter|12.1|🧑🏻‍🚒 🧑🏼‍🚒 🧑🏽‍🚒 🧑🏾‍🚒 🧑🏿‍🚒
👨‍🚒|man firefighter|fire firetruck|man_firefighter|4|👨🏻‍🚒 👨🏼‍🚒 👨🏽‍🚒 👨🏾‍🚒 👨🏿‍🚒
👩‍🚒|woman firefighter|fire firetruck|woman_firefighter|4|👩🏻‍🚒 👩🏼‍🚒 👩🏽‍🚒 👩🏾‍🚒 👩🏿‍🚒
👮|police officer|apprehend arrest citation cop law over|cop police_officer|0.6|👮🏻 👮🏼 👮🏽 👮🏾 👮🏿
👮‍♂️|man police officer|apprehend arrest citation cop law over|policeman|4|👮🏻‍♂️ 👮🏼‍♂️ 👮🏽‍♂️ 👮🏾‍♂️ 👮🏿‍♂️
👮‍♀️|woman police officer|apprehend arrest citation cop law over|policewoman|4|👮🏻‍♀️ 👮🏼‍♀️ 👮🏽‍♀️ 👮🏾‍♀️ 👮🏿‍♀️
🕵️|detective|sleuth spy|detective|0.7|🕵🏻 🕵🏼 🕵🏽 🕵🏾 🕵🏿
🕵️‍♂️|man detective|sleuth spy|male_detective|4|🕵🏻‍♂️ 🕵🏼‍♂️ 🕵🏽‍♂️ 🕵🏾‍♂️ 🕵🏿‍♂️
🕵️‍♀️|woman detective|sleuth spy|female_detective|4|🕵🏻‍♀️ 🕵🏼‍♀️ 🕵🏽‍♀️ 🕵🏾‍♀️ 🕵🏿‍♀️
💂|guard|buckingham helmet london palace|guard|0.6|💂🏻 💂🏼 💂🏽 💂🏾 💂🏿
💂‍♂️|man guard|buckingham helmet london palace|guardsman|4|💂🏻‍♂️ 💂🏼‍♂️ 💂🏽‍♂️ 💂🏾‍♂️ 💂🏿‍♂️
💂‍♀️|woman guard|buckingham helmet london palace|guardswoman|4|💂🏻‍♀️ 💂🏼‍♀️ 💂🏽‍♀️ 💂🏾‍♀️ 💂🏿‍♀️
🥷|ninja|assassin fight fighter hidden person secret|ninja|13|🥷🏻 🥷🏼 🥷🏽 🥷🏾 🥷🏿
👷|construction worker|build fix hardhat hat man person|construction_worker|0.6|👷🏻 👷🏼 👷🏽 👷🏾 👷🏿
👷‍♂️|man construction worker|build fix hardhat hat rebuild remodel|construction_worker_man|4|👷🏻‍♂️ 👷🏼‍♂️ 👷🏽‍♂️ 👷🏾‍♂️ 👷🏿‍♂️
👷‍♀️|woman construction worker|build fix hardhat hat man rebuild|construction_worker_woman|4|👷🏻‍♀️ 👷🏼‍♀️ 👷🏽‍♀️ 👷🏾‍♀️ 👷🏿‍♀️
🫅|person with crown|monarch noble regal royal royalty|person_with_crown|14|🫅🏻 🫅🏼 🫅🏽 🫅🏾 🫅🏿
🤴|prince|crown fairy fairytale fantasy king royal|prince|3|🤴🏻 🤴🏼 🤴🏽 🤴🏾 🤴🏿
👸|princess|crown fairy fairytale fantasy queen royal|princess|0.6|👸🏻 👸🏼 👸🏽 👸🏾 👸🏿
👳|person wearing turban||person_with_turban|0.6|👳🏻 👳🏼 👳🏽 👳🏾 👳🏿
👳‍♂️|man wearing turban||man_with_turban|4|👳🏻‍♂️ 👳🏼‍♂️ 👳🏽‍♂️ 👳🏾‍♂️ 👳🏿‍♂️
👳‍♀️|woman wearing turban||woman_with_turban|4|👳🏻‍♀️ 👳🏼‍♀️ 👳🏽‍♀️ 👳🏾‍♀️ 👳🏿‍♀️
👲|person with skullcap|chinese cap gua guapi hat mao|man_with_gua_pi_mao|0.6|👲🏻 👲🏼 👲🏽 👲🏾 👲🏿
🧕|woman with headscarf|bandana head hijab kerchief mantilla tichel|woman_with_headscarf|5|🧕🏻 🧕🏼 🧕🏽 🧕🏾 🧕🏿
🤵|person in tuxedo|formal wedding|person_in_tuxedo|3|🤵🏻 🤵🏼 🤵🏽 🤵🏾 🤵🏿
🤵‍♂️|man in tuxedo|formal groom wedding|man_in_tuxedo|13|🤵🏻‍♂️ 🤵🏼‍♂️ 🤵🏽‍♂️ 🤵🏾‍♂️ 🤵🏿‍♂️
🤵‍♀️|woman in tuxedo|formal wedding|woman_in_tuxedo|13|🤵🏻‍♀️ 🤵🏼‍♀️ 🤵🏽‍♀️ 🤵🏾‍♀️ 🤵🏿‍♀️
👰|person with veil|wedding|person_with_veil|0.6|👰🏻 👰🏼 👰🏽 👰🏾 👰🏿
👰‍♂️|man with veil|wedding|man_with_veil|13|👰🏻‍♂️ 👰🏼‍♂️ 👰🏽‍♂️ 👰🏾‍♂️ 👰🏿‍♂️
👰‍♀️|woman with veil|bride wedding|bride_with_veil woman_with_veil|13|👰🏻‍♀️ 👰🏼‍♀️ 👰🏽‍♀️ 👰🏾‍♀️ 👰🏿‍♀️
🤰|pregnant woman||pregnant_woman|3|🤰🏻 🤰🏼 🤰🏽 🤰🏾 🤰🏿
🫃|pregnant man|belly bloated full overeat|pregnant_man|14|🫃🏻 🫃🏼 🫃🏽 🫃🏾 🫃🏿
🫄|pregnant person|belly bloated full overeat stuffed|pregnant_person|14|🫄🏻 🫄🏼 🫄🏽 🫄🏾 🫄🏿
🤱|breast-feeding|baby mom mother nursing woman|breast_feeding|5|🤱🏻 🤱🏼 🤱🏽 🤱🏾 🤱🏿
👩‍🍼|woman feeding baby|feed mom mother nanny newborn nursing|woman_feeding_baby|13|👩🏻‍🍼 👩🏼‍🍼 👩🏽‍🍼 👩🏾‍🍼 👩🏿‍🍼
👨‍🍼|man feeding baby|dad father feed nanny newborn nursing|man_feeding_baby|13|👨🏻‍🍼 👨🏼‍🍼 👨🏽‍🍼 👨🏾‍🍼 👨🏿‍🍼
🧑‍🍼|person feeding baby|feed nanny newborn nursing parent|person_feeding_baby|13|🧑🏻‍🍼 🧑🏼‍🍼 🧑🏽‍🍼 🧑🏾‍🍼 🧑🏿‍🍼
👼|baby angel|church face fairy fairytale fantasy tale|angel|0.6|👼🏻 👼🏼 👼🏽 👼🏾 👼🏿
🎅|Santa Claus|christmas celebration fairy fantasy father holiday|santa|0.6|🎅🏻 🎅🏼 🎅🏽 🎅🏾 🎅🏿
🤶|Mrs. Claus|christmas mrs celebration fairy fantasy holiday|mrs_claus|3|🤶🏻 🤶🏼 🤶🏽 🤶🏾 🤶🏿
🧑‍🎄|Mx Claus|christmas celebration fairy fantasy holiday merry|mx_claus|13|🧑🏻‍🎄 🧑🏼‍🎄 🧑🏽‍🎄 🧑🏾‍🎄 🧑🏿‍🎄
🦸|superhero|good hero superpower|superhero|11|🦸🏻 🦸🏼 🦸🏽 🦸🏾 🦸🏿
🦸‍♂️|man superhero|good hero superpower|superhero_man|11|🦸🏻‍♂️ 🦸🏼‍♂️ 🦸🏽‍♂️ 🦸🏾‍♂️ 🦸🏿‍♂️
🦸‍♀️|woman superhero|good hero heroine superpower|superhero_woman|11|🦸🏻‍♀️ 🦸🏼‍♀️ 🦸🏽‍♀️ 🦸🏾‍♀️ 🦸🏿‍♀️
🦹|supervillain|bad criminal evil superpower villain|supervillain|11|🦹🏻 🦹🏼 🦹🏽 🦹🏾 🦹🏿
🦹‍♂️|man supervillain|bad criminal evil superpower villain|supervillain_man|11|🦹🏻‍♂️ 🦹🏼‍♂️ 🦹🏽‍♂️ 🦹🏾‍♂️ 🦹🏿‍♂️
🦹‍♀️|woman supervillain|bad criminal evil superpower villain|supervillain_woman|11|🦹🏻‍♀️ 🦹🏼‍♀️ 🦹🏽‍♀️ 🦹🏾‍♀️ 🦹🏿‍♀️
🧙|mage|fantasy magic play sorcerer sorceress sorcery|mage|5|🧙🏻 🧙🏼 🧙🏽 🧙🏾 🧙🏿
🧙‍♂️|man mage|fantasy magic play sorcerer sorceress sorcery|mage_man|5|🧙🏻‍♂️ 🧙🏼‍♂️ 🧙🏽‍♂️ 🧙🏾‍♂️ 🧙🏿‍♂️
🧙‍♀️|woman mage|fantasy magic play sorcerer sorceress sorcery|mage_woman|5|🧙🏻‍♀️ 🧙🏼‍♀️ 🧙🏽‍♀️ 🧙🏾‍♀️ 🧙🏿‍♀️
🧚|fairy|fairytale fantasy myth person pixie tale|fairy|5|🧚🏻 🧚🏼 🧚🏽 🧚🏾 🧚🏿
🧚‍♂️|man fairy|oberon puck fairytale fantasy myth person|fairy_man|5|🧚🏻‍♂️ 🧚🏼‍♂️ 🧚🏽‍♂️ 🧚🏾‍♂️ 🧚🏿‍♂️
🧚‍♀️|woman fairy|titania fairytale fantasy myth person pixie|fairy_woman|5|🧚🏻‍♀️ 🧚🏼‍♀️ 🧚🏽‍♀️ 🧚🏾‍♀️ 🧚🏿‍♀️
🧛|vampire|dracula blood fangs halloween scary supernatural|vampire|5|🧛🏻 🧛🏼 🧛🏽 🧛🏾 🧛🏿
🧛‍♂️|man vampire|blood fangs halloween scary supernatural teeth|vampire_man|5|🧛🏻‍♂️ 🧛🏼‍♂️ 🧛🏽‍♂️ 🧛🏾‍♂️ 🧛🏿‍♂️
🧛‍♀️|woman vampire|blood fangs halloween scary supernatural teeth|vampire_woman|5|🧛🏻‍♀️ 🧛🏼‍♀️ 🧛🏽‍♀️ 🧛🏾‍♀️ 🧛🏿‍♀️
🧜|merperson|creature fairytale folklore ocean sea siren|merperson|5|🧜🏻 🧜🏼 🧜🏽 🧜🏾 🧜🏿
🧜‍♂️|merman|neptune poseidon triton creature fairytale folklore|merman|5|🧜🏻‍♂️ 🧜🏼‍♂️ 🧜🏽‍♂️ 🧜🏾‍♂️ 🧜🏿‍♂️
🧜‍♀️|mermaid|creature fairytale folklore merwoman ocean sea|mermaid|5|🧜🏻‍♀️ 🧜🏼‍♀️ 🧜🏽‍♀️ 🧜🏾‍♀️ 🧜🏿‍♀️
🧝|elf|elves enchantment fantasy folklore magic magical|elf|5|🧝🏻 🧝🏼 🧝🏽 🧝🏾 🧝🏿
🧝‍♂️|man elf|elves enchantment fantasy folklore magic magical|elf_man|5|🧝🏻‍♂️ 🧝🏼‍♂️ 🧝🏽‍♂️ 🧝🏾‍♂️ 🧝🏿‍♂️
🧝‍♀️|woman elf|elves enchantment fantasy folklore magic magical|elf_woman|5|🧝🏻‍♀️ 🧝🏼‍♀️ 🧝🏽‍♀️ 🧝🏾‍♀️ 🧝🏿‍♀️
🧞|genie|djinn fantasy jinn lamp myth rub|genie|5|
🧞‍♂️|man genie|djinn fantasy jinn lamp myth rub|genie_man|5|
🧞‍♀️|woman genie|djinn fantasy jinn lamp myth rub|genie_woman|5|
🧟|zombie|apocalypse dead halloween horror scary undead|zombie|5|
🧟‍♂️|man zombie|apocalypse dead halloween horror scary undead|zombie_man|5|
🧟‍♀️|woman zombie|apocalypse dead halloween horror scary undead|zombie_woman|5|
🧌|troll|fairy fantasy monster tale trolling|troll|14|
🫈|hairy creature|bigfoot cryptid forest giant sasquatch woodwose||17|
💆|person getting massage|face headache relax relaxing salon soothe|massage|0.6|💆🏻 💆🏼 💆🏽 💆🏾 💆🏿
💆‍♂️|man getting massage|face headache relax relaxing salon soothe|massage_man|4|💆🏻‍♂️ 💆🏼‍♂️ 💆🏽‍♂️ 💆🏾‍♂️ 💆🏿‍♂️
💆‍♀️|woman getting massage|face headache relax relaxing salon soothe|massage_woman|4|💆🏻‍♀️ 💆🏼‍♀️ 💆🏽‍♀️ 💆🏾‍♀️ 💆🏿‍♀️
💇|person getting haircut|barber beauty chop cosmetology cut groom|haircut|0.6|💇🏻 💇🏼 💇🏽 💇🏾 💇🏿
💇‍♂️|man getting haircut|barber beauty chop cosmetology cut groom|haircut_man|4|💇🏻‍♂️ 💇🏼‍♂️ 💇🏽‍♂️ 💇🏾‍♂️ 💇🏿‍♂️
💇‍♀️|woman getting haircut|barber beauty chop cosmetology cut groom|haircut_woman|4|💇🏻‍♀️ 💇🏼‍♀️ 💇🏽‍♀️ 💇🏾‍♀️ 💇🏿‍♀️
🚶|person walking|amble gait hike man pace pedestrian|walking|0.6|🚶🏻 🚶🏼 🚶🏽 🚶🏾 🚶🏿
🚶‍♂️|man walking|amble gait hike pace pedestrian stride|walking_man|4|🚶🏻‍♂️ 🚶🏼‍♂️ 🚶🏽‍♂️ 🚶🏾‍♂️ 🚶🏿‍♂️
🚶‍♀️|woman walking|amble gait hike man pace pedestrian|walking_woman|4|🚶🏻‍♀️ 🚶🏼‍♀️ 🚶🏽‍♀️ 🚶🏾‍♀️ 🚶🏿‍♀️
🚶‍➡️|person walking: facing right|amble gait hike man pace pedestrian||15.1|🚶🏻‍➡️ 🚶🏼‍➡️ 🚶🏽‍➡️ 🚶🏾‍➡️ 🚶🏿‍➡️
🚶‍♀️‍➡️|woman walking: facing right|amble gait hike man pace pedestrian||15.1|🚶🏻‍♀️‍➡️ 🚶🏼‍♀️‍➡️ 🚶🏽‍♀️‍➡️ 🚶🏾‍♀️‍➡️ 🚶🏿‍♀️‍➡️
🚶‍♂️‍➡️|man walking: facing right|amble gait hike pace pedestrian stride||15.1|🚶🏻‍♂️‍➡️ 🚶🏼‍♂️‍➡️ 🚶🏽‍♂️‍➡️ 🚶🏾‍♂️‍➡️ 🚶🏿‍♂️‍➡️
🧍|person standing|stand|standing_person|12|🧍🏻 🧍🏼 🧍🏽 🧍🏾 🧍🏿
🧍‍♂️|man standing|stand|standing_man|12|🧍🏻‍♂️ 🧍🏼‍♂️ 🧍🏽‍♂️ 🧍🏾‍♂️ 🧍🏿‍♂️
🧍‍♀️|woman standing|stand|standing_woman|12|🧍🏻‍♀️ 🧍🏼‍♀️ 🧍🏽‍♀️ 🧍🏾‍♀️ 🧍🏿‍♀️
🧎|person kneeling|kneel knees|kneeling_person|12|🧎🏻 🧎🏼 🧎🏽 🧎🏾 🧎🏿
🧎‍♂️|man kneeling|kneel knees|kneeling_man|12|🧎🏻‍♂️ 🧎🏼‍♂️ 🧎🏽‍♂️ 🧎🏾‍♂️ 🧎🏿‍♂️
🧎‍♀️|woman kneeling|kneel knees|kneeling_woman|12|🧎🏻‍♀️ 🧎🏼‍♀️ 🧎🏽‍♀️ 🧎🏾‍♀️ 🧎🏿‍♀️
🧎‍➡️|person kneeling: facing right|kneel knees||15.1|🧎🏻‍➡️ 🧎🏼‍➡️ 🧎🏽‍➡️ 🧎🏾‍➡️ 🧎🏿‍➡️
🧎‍♀️‍➡️|woman kneeling: facing right|kneel knees||15.1|🧎🏻‍♀️‍➡️ 🧎🏼‍♀️‍➡️ 🧎🏽‍♀️‍➡️ 🧎🏾‍♀️‍➡️ 🧎🏿‍♀️‍➡️
🧎‍♂️‍➡️|man kneeling: facing right|kneel knees||15.1|🧎🏻‍♂️‍➡️ 🧎🏼‍♂️‍➡️ 🧎🏽‍♂️‍➡️ 🧎🏾‍♂️‍➡️ 🧎🏿‍♂️‍➡️
🧑‍🦯|person with white cane|accessibility blind probing|person_with_probing_cane|12.1|🧑🏻‍🦯 🧑🏼‍🦯 🧑🏽‍🦯 🧑🏾‍🦯 🧑🏿‍🦯
🧑‍🦯‍➡️|person with white cane: facing right|accessibility blind probing||15.1|🧑🏻‍🦯‍➡️ 🧑🏼‍🦯‍➡️ 🧑🏽‍🦯‍➡️ 🧑🏾‍🦯‍➡️ 🧑🏿‍🦯‍➡️
👨‍🦯|man with white cane|accessibility blind probing|man_with_probing_cane|12|👨🏻‍🦯 👨🏼‍🦯 👨🏽‍🦯 👨🏾‍🦯 👨🏿‍🦯
👨‍🦯‍➡️|man with white cane: facing right|accessibility blind probing||15.1|👨🏻‍🦯‍➡️ 👨🏼‍🦯‍➡️ 👨🏽‍🦯‍➡️ 👨🏾‍🦯‍➡️ 👨🏿‍🦯‍➡️
👩‍🦯|woman with white cane|accessibility blind probing|woman_with_probing_cane|12|👩🏻‍🦯 👩🏼‍🦯 👩🏽‍🦯 👩🏾‍🦯 👩🏿‍🦯
👩‍🦯‍➡️|woman with white cane: facing right|accessibility blind probing||15.1|👩🏻‍🦯‍➡️ 👩🏼‍🦯‍➡️ 👩🏽‍🦯‍➡️ 👩🏾‍🦯‍➡️ 👩🏿‍🦯‍➡️
🧑‍🦼|person in motorized wheelchair|accessibility|person_in_motorized_wheelchair|12.1|🧑🏻‍🦼 🧑🏼‍🦼 🧑🏽‍🦼 🧑🏾‍🦼 🧑🏿‍🦼
🧑‍🦼‍➡️|person in motorized wheelchair: facing right|accessibility||15.1|🧑🏻‍🦼‍➡️ 🧑🏼‍🦼‍➡️ 🧑🏽‍🦼‍➡️ 🧑🏾‍🦼‍➡️ 🧑🏿‍🦼‍➡️
👨‍🦼|man in motorized wheelchair|accessibility|man_in_motorized_wheelchair|12|👨🏻‍🦼 👨🏼‍🦼 👨🏽‍🦼 👨🏾‍🦼 👨🏿‍🦼
👨‍🦼‍➡️|man in motorized wheelchair: facing right|accessibility||15.1|👨🏻‍🦼‍➡️ 👨🏼‍🦼‍➡️ 👨🏽‍🦼‍➡️ 👨🏾‍🦼‍➡️ 👨🏿‍🦼‍➡️
👩‍🦼|woman in motorized wheelchair|accessibility|woman_in_motorized_wheelchair|12|👩🏻‍🦼 👩🏼‍🦼 👩🏽‍🦼 👩🏾‍🦼 👩🏿‍🦼
👩‍🦼‍➡️|woman in motorized wheelchair: facing right|accessibility||15.1|👩🏻‍🦼‍➡️ 👩🏼‍🦼‍➡️ 👩🏽‍🦼‍➡️ 👩🏾‍🦼‍➡️ 👩🏿‍🦼‍➡️
🧑‍🦽|person in manual wheelchair|accessibility|person_in_manual_wheelchair|12.1|🧑🏻‍🦽 🧑🏼‍🦽 🧑🏽‍🦽 🧑🏾‍🦽 🧑🏿‍🦽
🧑‍🦽‍➡️|person in manual wheelchair: facing right|accessibility||15.1|🧑🏻‍🦽‍➡️ 🧑🏼‍🦽‍➡️ 🧑🏽‍🦽‍➡️ 🧑🏾‍🦽‍➡️ 🧑🏿‍🦽‍➡️
👨‍🦽|man in manual wheelchair|accessibility|man_in_manual_wheelchair|12|👨🏻‍🦽 👨🏼‍🦽 👨🏽‍🦽 👨🏾‍🦽 👨🏿‍🦽
👨‍🦽‍➡️|man in manual wheelchair: facing right|accessibility||15.1|👨🏻‍🦽‍➡️ 👨🏼‍🦽‍➡️ 👨🏽‍🦽‍➡️ 👨🏾‍🦽‍➡️ 👨🏿‍🦽‍➡️
👩‍🦽|woman in manual wheelchair|accessibility|woman_in_manual_wheelchair|12|👩🏻‍🦽 👩🏼‍🦽 👩🏽‍🦽 👩🏾‍🦽 👩🏿‍🦽
👩‍🦽‍➡️|woman in manual wheelchair: facing right|accessibility||15.1|👩🏻‍🦽‍➡️ 👩🏼‍🦽‍➡️ 👩🏽‍🦽‍➡️ 👩🏾‍🦽‍➡️ 👩🏿‍🦽‍➡️
🏃|person running|fast hurry marathon move quick race|runner running|0.6|🏃🏻 🏃🏼 🏃🏽 🏃🏾 🏃🏿
🏃‍♂️|man running|fast hurry marathon move quick race|running_man|4|🏃🏻‍♂️ 🏃🏼‍♂️ 🏃🏽‍♂️ 🏃🏾‍♂️ 🏃🏿‍♂️
🏃‍♀️|woman running|fast hurry marathon move quick race|running_woman|4|🏃🏻‍♀️ 🏃🏼‍♀️ 🏃🏽‍♀️ 🏃🏾‍♀️ 🏃🏿‍♀️
🏃‍➡️|person running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍➡️ 🏃🏼‍➡️ 🏃🏽‍➡️ 🏃🏾‍➡️ 🏃🏿‍➡️
🏃‍♀️‍➡️|woman running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍♀️‍➡️ 🏃🏼‍♀️‍➡️ 🏃🏽‍♀️‍➡️ 🏃🏾‍♀️‍➡️ 🏃🏿‍♀️‍➡️
🏃‍♂️‍➡️|man running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍♂️‍➡️ 🏃🏼‍♂️‍➡️ 🏃🏽‍♂️‍➡️ 🏃🏾‍♂️‍➡️ 🏃🏿‍♂️‍➡️
🧑‍🩰|ballet dancer|||17|🧑🏻‍🩰 🧑🏼‍🩰 🧑🏽‍🩰 🧑🏾‍🩰 🧑🏿‍🩰
💃|woman dancing|dance dancer elegant festive flair flamenco|dancer woman_dancing|0.6|💃🏻 💃🏼 💃🏽 💃🏾 💃🏿
🕺|man dancing|dance dancer elegant festive flair flamenco|man_dancing|3|🕺🏻 🕺🏼 🕺🏽 🕺🏾 🕺🏿
🕴️|person in suit levitating|business|business_suit_levitating|0.7|🕴🏻 🕴🏼 🕴🏽 🕴🏾 🕴🏿
👯|people with bunny ears|bestie bff counterpart dancer double ear|dancers|0.6|👯🏻 👯🏼 👯🏽 👯🏾 👯🏿
👯‍♂️|men with bunny ears|bestie bff counterpart dancer double ear|dancing_men|4|👯🏻‍♂️ 👯🏼‍♂️ 👯🏽‍♂️ 👯🏾‍♂️ 👯🏿‍♂️
👯‍♀️|women with bunny ears|bestie bff counterpart dancer double ear|dancing_women|4|👯🏻‍♀️ 👯🏼‍♀️ 👯🏽‍♀️ 👯🏾‍♀️ 👯🏿‍♀️
🧖|person in steamy room|day luxurious pamper relax sauna spa|sauna_person|5|🧖🏻 🧖🏼 🧖🏽 🧖🏾 🧖🏿
🧖‍♂️|man in steamy room|day luxurious pamper relax sauna spa|sauna_man|5|🧖🏻‍♂️ 🧖🏼‍♂️ 🧖🏽‍♂️ 🧖🏾‍♂️ 🧖🏿‍♂️
🧖‍♀️|woman in steamy room|day luxurious pamper relax sauna spa|sauna_woman|5|🧖🏻‍♀️ 🧖🏼‍♀️ 🧖🏽‍♀️ 🧖🏾‍♀️ 🧖🏿‍♀️
🧗|person climbing|climb climber mountain rock scale up|climbing|5|🧗🏻 🧗🏼 🧗🏽 🧗🏾 🧗🏿
🧗‍♂️|man climbing|climb climber mountain rock scale up|climbing_man|5|🧗🏻‍♂️ 🧗🏼‍♂️ 🧗🏽‍♂️ 🧗🏾‍♂️ 🧗🏿‍♂️
🧗‍♀️|woman climbing|climb climber mountain rock scale up|climbing_woman|5|🧗🏻‍♀️ 🧗🏼‍♀️ 🧗🏽‍♀️ 🧗🏾‍♀️ 🧗🏿‍♀️
🤺|person fencing|fencer sword|person_fencing|3|
🏇|horse racing|jockey racehorse riding sport|horse_racing|1|🏇🏻 🏇🏼 🏇🏽 🏇🏾 🏇🏿
⛷️|skier|ski snow|skier|0.7|
🏂|snowboarder|ski snow snowboard sport|snowboarder|0.6|🏂🏻 🏂🏼 🏂🏽 🏂🏾 🏂🏿
🏌️|person golfing|ball birdie caddy driving golf green|golfing|0.7|🏌🏻 🏌🏼 🏌🏽 🏌🏾 🏌🏿
🏌️‍♂️|man golfing|ball birdie caddy driving golf green|golfing_man|4|🏌🏻‍♂️ 🏌🏼‍♂️ 🏌🏽‍♂️ 🏌🏾‍♂️ 🏌🏿‍♂️
🏌️‍♀️|woman golfing|ball birdie caddy driving golf green|golfing_woman|4|🏌🏻‍♀️ 🏌🏼‍♀️ 🏌🏽‍♀️ 🏌🏾‍♀️ 🏌🏿‍♀️
🏄|person surfing|beach ocean sport surf surfer swell|surfer|0.6|🏄🏻 🏄🏼 🏄🏽 🏄🏾 🏄🏿
🏄‍♂️|man surfing|beach ocean sport surf surfer swell|surfing_man|4|🏄🏻‍♂️ 🏄🏼‍♂️ 🏄🏽‍♂️ 🏄🏾‍♂️ 🏄🏿‍♂️
🏄‍♀️|woman surfing|beach ocean person sport surf surfer|surfing_woman|4|🏄🏻‍♀️ 🏄🏼‍♀️ 🏄🏽‍♀️ 🏄🏾‍♀️ 🏄🏿‍♀️
🚣|person rowing boat|canoe cruise fishing lake oar paddle|rowboat|1|🚣🏻 🚣🏼 🚣🏽 🚣🏾 🚣🏿
🚣‍♂️|man rowing boat|canoe cruise fishing lake oar paddle|rowing_man|4|🚣🏻‍♂️ 🚣🏼‍♂️ 🚣🏽‍♂️ 🚣🏾‍♂️ 🚣🏿‍♂️
🚣‍♀️|woman rowing boat|canoe cruise fishing lake oar paddle|rowing_woman|4|🚣🏻‍♀️ 🚣🏼‍♀️ 🚣🏽‍♀️ 🚣🏾‍♀️ 🚣🏿‍♀️
🏊|person swimming|freestyle sport swim swimmer triathlon|swimmer|0.6|🏊🏻 🏊🏼 🏊🏽 🏊🏾 🏊🏿
🏊‍♂️|man swimming|freestyle sport swim swimmer triathlon|swimming_man|4|🏊🏻‍♂️ 🏊🏼‍♂️ 🏊🏽‍♂️ 🏊🏾‍♂️ 🏊🏿‍♂️
🏊‍♀️|woman swimming|freestyle man sport swim swimmer triathlon|swimming_woman|4|🏊🏻‍♀️ 🏊🏼‍♀️ 🏊🏽‍♀️ 🏊🏾‍♀️ 🏊🏿‍♀️
⛹️|person bouncing ball|athletic basketball championship dribble net player|bouncing_ball_person|0.7|⛹🏻 ⛹🏼 ⛹🏽 ⛹🏾 ⛹🏿
⛹️‍♂️|man bouncing ball|athletic basketball championship dribble net player|basketball_man bouncing_ball_man|4|⛹🏻‍♂️ ⛹🏼‍♂️ ⛹🏽‍♂️ ⛹🏾‍♂️ ⛹🏿‍♂️
⛹️‍♀️|woman bouncing ball|athletic basketball championship dribble net player|basketball_woman bouncing_ball_woman|4|⛹🏻‍♀️ ⛹🏼‍♀️ ⛹🏽‍♀️ ⛹🏾‍♀️ ⛹🏿‍♀️
🏋️|person lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting|0.7|🏋🏻 🏋🏼 🏋🏽 🏋🏾 🏋🏿
🏋️‍♂️|man lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting_man|4|🏋🏻‍♂️ 🏋🏼‍♂️ 🏋🏽‍♂️ 🏋🏾‍♂️ 🏋🏿‍♂️
🏋️‍♀️|woman lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting_woman|4|🏋🏻‍♀️ 🏋🏼‍♀️ 🏋🏽‍♀️ 🏋🏾‍♀️ 🏋🏿‍♀️
🚴|person biking|bicycle bicyclist bike cycle cyclist riding|bicyclist|1|🚴🏻 🚴🏼 🚴🏽 🚴🏾 🚴🏿
🚴‍♂️|man biking|bicycle bicyclist bike cycle cyclist riding|biking_man|4|🚴🏻‍♂️ 🚴🏼‍♂️ 🚴🏽‍♂️ 🚴🏾‍♂️ 🚴🏿‍♂️
🚴‍♀️|woman biking|bicycle bicyclist bike cycle cyclist riding|biking_woman|4|🚴🏻‍♀️ 🚴🏼‍♀️ 🚴🏽‍♀️ 🚴🏾‍♀️ 🚴🏿‍♀️
🚵|person mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_bicyclist|1|🚵🏻 🚵🏼 🚵🏽 🚵🏾 🚵🏿
🚵‍♂️|man mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_biking_man|4|🚵🏻‍♂️ 🚵🏼‍♂️ 🚵🏽‍♂️ 🚵🏾‍♂️ 🚵🏿‍♂️
🚵‍♀️|woman mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_biking_woman|4|🚵🏻‍♀️ 🚵🏼‍♀️ 🚵🏽‍♀️ 🚵🏾‍♀️ 🚵🏿‍♀️
🤸|person cartwheeling|active cartwheel excited flip gymnastics happy|cartwheeling|3|🤸🏻 🤸🏼 🤸🏽 🤸🏾 🤸🏿
🤸‍♂️|man cartwheeling|active cartwheel excited flip gymnastics happy|man_cartwheeling|4|🤸🏻‍♂️ 🤸🏼‍♂️ 🤸🏽‍♂️ 🤸🏾‍♂️ 🤸🏿‍♂️
🤸‍♀️|woman cartwheeling|active cartwheel excited flip gymnastics happy|woman_cartwheeling|4|🤸🏻‍♀️ 🤸🏼‍♀️ 🤸🏽‍♀️ 🤸🏾‍♀️ 🤸🏿‍♀️
🤼|people wrestling|combat duel grapple ring tournament wrestle|wrestling|3|🤼🏻 🤼🏼 🤼🏽 🤼🏾 🤼🏿
🤼‍♂️|men wrestling|combat duel grapple ring tournament wrestle|men_wrestling|4|🤼🏻‍♂️ 🤼🏼‍♂️ 🤼🏽‍♂️ 🤼🏾‍♂️ 🤼🏿‍♂️
🤼‍♀️|women wrestling|combat duel grapple ring tournament wrestle|women_wrestling|4|🤼🏻‍♀️ 🤼🏼‍♀️ 🤼🏽‍♀️ 🤼🏾‍♀️ 🤼🏿‍♀️
🤽|person playing water polo|sport swimming waterpolo|water_polo|3|🤽🏻 🤽🏼 🤽🏽 🤽🏾 🤽🏿
🤽‍♂️|man playing water polo|sport swimming waterpolo|man_playing_water_polo|4|🤽🏻‍♂️ 🤽🏼‍♂️ 🤽🏽‍♂️ 🤽🏾‍♂️ 🤽🏿‍♂️
🤽‍♀️|woman playing water polo|sport swimming waterpolo|woman_playing_water_polo|4|🤽🏻‍♀️ 🤽🏼‍♀️ 🤽🏽‍♀️ 🤽🏾‍♀️ 🤽🏿‍♀️
🤾|person playing handball|athletics ball catch chuck hurl lob|handball_person|3|🤾🏻 🤾🏼 🤾🏽 🤾🏾 🤾🏿
🤾‍♂️|man playing handball|athletics ball catch chuck hurl lob|man_playing_handball|4|🤾🏻‍♂️ 🤾🏼‍♂️ 🤾🏽‍♂️ 🤾🏾‍♂️ 🤾🏿‍♂️
🤾‍♀️|woman playing handball|athletics ball catch chuck hurl lob|woman_playing_handball|4|🤾🏻‍♀️ 🤾🏼‍♀️ 🤾🏽‍♀️ 🤾🏾‍♀️ 🤾🏿‍♀️
🤹|person juggling|act balance balancing handle juggle manage|juggling_person|3|🤹🏻 🤹🏼 🤹🏽 🤹🏾 🤹🏿
🤹‍♂️|man juggling|act balance balancing handle juggle manage|man_juggling|4|🤹🏻‍♂️ 🤹🏼‍♂️ 🤹🏽‍♂️ 🤹🏾‍♂️ 🤹🏿‍♂️
🤹‍♀️|woman juggling|act balance balancing handle juggle manage|woman_juggling|4|🤹🏻‍♀️ 🤹🏼‍♀️ 🤹🏽‍♀️ 🤹🏾‍♀️ 🤹🏿‍♀️
🧘|person in lotus position|cross legged legs meditation peace relax|lotus_position|5|🧘🏻 🧘🏼 🧘🏽 🧘🏾 🧘🏿
🧘‍♂️|man in lotus position|cross legged legs meditation peace relax|lotus_position_man|5|🧘🏻‍♂️ 🧘🏼‍♂️ 🧘🏽‍♂️ 🧘🏾‍♂️ 🧘🏿‍♂️
🧘‍♀️|woman in lotus position|cross legged legs meditation peace relax|lotus_position_woman|5|🧘🏻‍♀️ 🧘🏼‍♀️ 🧘🏽‍♀️ 🧘🏾‍♀️ 🧘🏿‍♀️
🛀|person taking bath|bathtub tub|bath|0.6|🛀🏻 🛀🏼 🛀🏽 🛀🏾 🛀🏿
🛌|person in bed|bedtime good goodnight hotel nap night|sleeping_bed|1|🛌🏻 🛌🏼 🛌🏽 🛌🏾 🛌🏿
🧑‍🤝‍🧑|people holding hands|bae bestie bff couple dating flirt|people_holding_hands|12|🧑🏻‍🤝‍🧑🏻 🧑🏼‍🤝‍🧑🏼 🧑🏽‍🤝‍🧑🏽 🧑🏾‍🤝‍🧑🏾 🧑🏿‍🤝‍🧑🏿
👭|women holding hands|bae bestie bff couple dating flirt|two_women_holding_hands|1|👭🏻 👭🏼 👭🏽 👭🏾 👭🏿
👫|woman and man holding hands|bae bestie bff couple dating flirt|couple|0.6|👫🏻 👫🏼 👫🏽 👫🏾 👫🏿
👬|men holding hands|bae bestie bff boys brothers couple|two_men_holding_hands|1|👬🏻 👬🏼 👬🏽 👬🏾 👬🏿
💏|kiss|anniversary babe bae couple date dating|couplekiss|0.6|💏🏻 💏🏼 💏🏽 💏🏾 💏🏿
👩‍❤️‍💋‍👨|kiss: woman, man|anniversary babe bae couple date dating|couplekiss_man_woman|2|👩🏻‍❤️‍💋‍👨🏻 👩🏼‍❤️‍💋‍👨🏼 👩🏽‍❤️‍💋‍👨🏽 👩🏾‍❤️‍💋‍👨🏾 👩🏿‍❤️‍💋‍👨🏿
👨‍❤️‍💋‍👨|kiss: man, man|anniversary babe bae couple date dating|couplekiss_man_man|2|👨🏻‍❤️‍💋‍👨🏻 👨🏼‍❤️‍💋‍👨🏼 👨🏽‍❤️‍💋‍👨🏽 👨🏾‍❤️‍💋‍👨🏾 👨🏿‍❤️‍💋‍👨🏿
👩‍❤️‍💋‍👩|kiss: woman, woman|anniversary babe bae couple date dating|couplekiss_woman_woman|2|👩🏻‍❤️‍💋‍👩🏻 👩🏼‍❤️‍💋‍👩🏼 👩🏽‍❤️‍💋‍👩🏽 👩🏾‍❤️‍💋‍👩🏾 👩🏿‍❤️‍💋‍👩🏿
💑|couple with heart|anniversary babe bae dating kiss love|couple_with_heart|0.6|💑🏻 💑🏼 💑🏽 💑🏾 💑🏿
👩‍❤️‍👨|couple with heart: woman, man|anniversary babe bae dating kiss love|couple_with_heart_woman_man|2|👩🏻‍❤️‍👨🏻 👩🏼‍❤️‍👨🏼 👩🏽‍❤️‍👨🏽 👩🏾‍❤️‍👨🏾 👩🏿‍❤️‍👨🏿
👨‍❤️‍👨|couple with heart: man, man|anniversary babe bae dating kiss love|couple_with_heart_man_man|2|👨🏻‍❤️‍👨🏻 👨🏼‍❤️‍👨🏼 👨🏽‍❤️‍👨🏽 👨🏾‍❤️‍👨🏾 👨🏿‍❤️‍👨🏿
👩‍❤️‍👩|couple with heart: woman, woman|anniversary babe bae dating kiss love|couple_with_heart_woman_woman|2|👩🏻‍❤️‍👩🏻 👩🏼‍❤️‍👩🏼 👩🏽‍❤️‍👩🏽 👩🏾‍❤️‍👩🏾 👩🏿‍❤️‍👩🏿
👨‍👩‍👦|family: man, woman, boy|child|family_man_woman_boy|2|
👨‍👩‍👧|family: man, woman, girl|child|family_man_woman_girl|2|
👨‍👩‍👧‍👦|family: man, woman, girl, boy|child|family_man_woman_girl_boy|2|
👨‍👩‍👦‍👦|family: man, woman, boy, boy|child|family_man_woman_boy_boy|2|
👨‍👩‍👧‍👧|family: man, woman, girl, girl|child|family_man_woman_girl_girl|2|
👨‍👨‍👦|family: man, man, boy|child|family_man_man_boy|2|
👨‍👨‍👧|family: man, man, girl|child|family_man_man_girl|2|
👨‍👨‍👧‍👦|family: man, man, girl, boy|child|family_man_man_girl_boy|2|
👨‍👨‍👦‍👦|family: man, man, boy, boy|child|family_man_man_boy_boy|2|
👨‍👨‍👧‍👧|family: man, man, girl, girl|child|family_man_man_girl_girl|2|
👩‍👩‍👦|family: woman, woman, boy|child|family_woman_woman_boy|2|
👩‍👩‍👧|family: woman, woman, girl|child|family_woman_woman_girl|2|
👩‍👩‍👧‍👦|family: woman, woman, girl, boy|child|family_woman_woman_girl_boy|2|
👩‍👩‍👦‍👦|family: woman, woman, boy, boy|child|family_woman_woman_boy_boy|2|
👩‍👩‍👧‍👧|family: woman, woman, girl, girl|child|family_woman_woman_girl_girl|2|
👨‍👦|family: man, boy|child|family_man_boy|4|
👨‍👦‍👦|family: man, boy, boy|child|family_man_boy_boy|4|
👨‍👧|family: man, girl|child|family_man_girl|4|
👨‍👧‍👦|family: man, girl, boy|child|family_man_girl_boy|4|
👨‍👧‍👧|family: man, girl, girl|child|family_man_girl_girl|4|
👩‍👦|family: woman, boy|child|family_woman_boy|4|
👩‍👦‍👦|family: woman, boy, boy|child|family_woman_boy_boy|4|
👩‍👧|family: woman, girl|child|family_woman_girl|4|
👩‍👧‍👦|family: woman, girl, boy|child|family_woman_girl_boy|4|
👩‍👧‍👧|family: woman, girl, girl|child|family_woman_girl_girl|4|
🗣️|speaking head|face silhouette speak|speaking_head|0.7|
👤|bust in silhouette|mysterious shadow|bust_in_silhouette|0.6|
👥|busts in silhouette|bff bust everyone friend friends people|busts_in_silhouette|1|
🫂|people hugging|comfort embrace farewell friendship goodbye hello|people_hugging|13|
👪|family|child|family|0.6|
🧑‍🧑‍🧒|family: adult, adult, child|||15.1|
🧑‍🧑‍🧒‍🧒|family: adult, adult, child, child|||15.1|
🧑‍🧒|family: adult, child|||15.1|
🧑‍🧒‍🧒|family: adult, child, child|||15.1|
👣|footprints|barefoot clothing footprint omw print walk|footprints|0.6|
🫆|fingerprint|clue crime detective forensics identity mystery||16|
#nature
🐵|monkey face|animal banana|monkey_face|0.6|
🐒|monkey|animal banana|monkey|0.6|
🦍|gorilla|animal|gorilla|3|
🦧|orangutan|animal ape monkey|orangutan|12|
🐶|dog face|adorbs animal pet puppies puppy|dog|0.6|
🐕|dog|animal animals dogs pet|dog2|0.7|
🦮|guide dog|accessibility animal blind|guide_dog|12|
🐕‍🦺|service dog|accessibility animal assistance|service_dog|12|
🐩|poodle|animal dog fluffy|poodle|0.6|
🐺|wolf|animal face|wolf|0.6|
🦊|fox|animal face|fox_face|3|
🦝|raccoon|animal curious sly|raccoon|11|
🐱|cat face|animal kitten kitty pet|cat|0.6|
🐈|cat|animal animals cats kitten pet|cat2|0.7|
🐈‍⬛|black cat|animal feline halloween meow unlucky|black_cat|13|
🦁|lion|leo alpha animal face mane order|lion|1|
🐯|tiger face|animal big cat predator|tiger|0.6|
🐅|tiger|animal big cat predator zoo|tiger2|1|
🐆|leopard|animal big cat predator zoo|leopard|1|
🐴|horse face|animal dressage equine farm horses|horse|0.6|
🫎|moose|alces animal antlers elk mammal|moose|15|
🫏|donkey|animal ass burro hinny mammal mule|donkey|15|
🐎|horse|animal equestrian farm racehorse racing|racehorse|0.6|
🦄|unicorn|face|unicorn|1|
🦓|zebra|animal stripe|zebra|5|
🦌|deer|animal|deer|3|
🦬|bison|animal buffalo herd wisent|bison|13|
🐮|cow face|animal farm milk moo|cow|0.6|
🐂|ox|taurus animal animals bull farm zodiac|ox|1|
🐃|water buffalo|animal zoo|water_buffalo|1|
🐄|cow|animal animals farm milk moo|cow2|1|
🐷|pig face|animal bacon farm pork|pig|0.6|
🐖|pig|animal bacon farm pork sow|pig2|1|
🐗|boar|animal pig|boar|0.6|
🐽|pig nose|animal face farm smell snout|pig_nose|0.6|
🐏|ram|aries animal horns male sheep zodiac|ram|1|
🐑|ewe|animal baa farm female fluffy lamb|sheep|0.6|
🐐|goat|capricorn animal farm milk zodiac|goat|1|
🐪|camel|animal desert dromedary hump one|dromedary_camel|1|
🐫|two-hump camel|animal bactrian desert two-hump|camel|0.6|
🦙|llama|alpaca animal guanaco vicuña wool|llama|11|
🦒|giraffe|animal spots|giraffe|5|
🐘|elephant|animal|elephant|0.6|
🦣|mammoth|animal extinction large tusk wooly|mammoth|13|
🦏|rhinoceros|animal|rhinoceros|3|
🦛|hippopotamus|animal hippo|hippopotamus|11|
🐭|mouse face|animal|mouse|0.6|
🐁|mouse|animal animals|mouse2|1|
🐀|rat|animal|rat|1|
🐹|hamster|animal face pet|hamster|0.6|
🐰|rabbit face|animal bunny pet|rabbit|0.6|
🐇|rabbit|animal bunny pet|rabbit2|1|
🐿️|chipmunk|animal squirrel|chipmunk|0.7|
🦫|beaver|animal dam teeth|beaver|13|
🦔|hedgehog|animal spiny|hedgehog|5|
🦇|bat|animal vampire|bat|3|
🐻|bear|animal face grizzly growl honey|bear|0.6|
🐻‍❄️|polar bear|animal arctic white|polar_bear|13|
🐨|koala|animal australia bear down face marsupial|koala|0.6|
🐼|panda|animal bamboo face|panda_face|0.6|
🦥|sloth|lazy slow|sloth|12|
🦦|otter|animal fishing playful|otter|12|
🦨|skunk|animal stink|skunk|12|
🦘|kangaroo|animal joey jump marsupial|kangaroo|11|
🦡|badger|animal honey pester|badger|11|
🐾|paw prints|feet paws print|feet paw_prints|0.6|
🦃|turkey|bird gobble thanksgiving|turkey|1|
🐔|chicken|animal bird ornithology|chicken|0.6|
🐓|rooster|animal bird ornithology|rooster|1|
🐣|hatching chick|animal baby bird egg|hatching_chick|0.6|
🐤|baby chick|animal bird ornithology|baby_chick|0.6|
🐥|front-facing baby chick|animal bird front-facing newborn ornithology|hatched_chick|0.6|
🐦|bird|animal ornithology|bird|0.6|
🐧|penguin|animal antarctica bird ornithology|penguin|0.6|
🕊️|dove|bird fly ornithology peace|dove|0.7|
🦅|eagle|animal bird ornithology|eagle|3|
🦆|duck|animal bird ornithology|duck|3|
🦢|swan|animal bird cygnet duckling ornithology ugly|swan|11|
🦉|owl|animal bird ornithology wise|owl|3|
🦤|dodo|animal bird extinction large ornithology|dodo|13|
🪶|feather|bird flight light plumage|feather|13|
🦩|flamingo|animal bird flamboyant ornithology tropical|flamingo|12|
🦚|peacock|animal bird colorful ornithology ostentatious peahen|peacock|11|
🦜|parrot|animal bird ornithology pirate talk|parrot|11|
🪽|wing|angelic ascend aviation bird fly flying|wing|15|
🐦‍⬛|black bird|animal beak caw corvid crow ornithology|black_bird|15|
🪿|goose|animal bird duck flock fowl gaggle|goose|15|
🐦‍🔥|phoenix|ascend ascension emerge fantasy firebird glory||15.1|
🐸|frog|animal face|frog|0.6|
🐊|crocodile|animal zoo|crocodile|1|
🐢|turtle|animal terrapin tortoise|turtle|0.6|
🦎|lizard|animal reptile|lizard|3|
🐍|snake|ophiuchus animal bearer serpent zodiac|snake|0.6|
🐲|dragon face|animal fairy fairytale tale|dragon_face|0.6|
🐉|dragon|animal fairy fairytale knights tale|dragon|1|
🦕|sauropod|brachiosaurus brontosaurus dinosaur diplodocus|sauropod|5|
🦖|T-Rex|tyrannosaurus dinosaur|t-rex|5|
🐳|spouting whale|animal beach face ocean|whale|0.6|
🐋|whale|animal beach ocean|whale2|1|
🐬|dolphin|animal beach flipper ocean|dolphin flipper|0.6|
🫍|orca|marine ocean whale||17|
🦭|seal|animal lion ocean sea|seal|13|
🐟|fish|pisces animal dinner fishes fishing zodiac|fish|0.6|
🐠|tropical fish|animal fishes|tropical_fish|0.6|
🐡|blowfish|animal fish|blowfish|0.6|
🦈|shark|animal fish|shark|3|
🐙|octopus|animal creature ocean|octopus|0.6|
🐚|spiral shell|animal beach conch sea|shell|0.6|
🪸|coral|change climate ocean reef sea|coral|14|
🪼|jellyfish|animal aquarium burn invertebrate jelly life|jellyfish|15|
🦀|crab|cancer zodiac|crab|1|
🦞|lobster|animal bisque claws seafood|lobster|11|
🦐|shrimp|food shellfish small|shrimp|3|
🦑|squid|animal food mollusk|squid|3|
🦪|oyster|diving pearl|oyster|12|
🐌|snail|animal escargot garden nature slug|snail|0.6|
🦋|butterfly|insect pretty|butterfly|3|
🫌|monarch butterfly|caterpillar change fragile hope insect metamorphosis||18|
🐛|bug|animal garden insect|bug|0.6|
🐜|ant|animal garden insect|ant|0.6|
🐝|honeybee|animal bee bumblebee honey insect nature|bee honeybee|0.6|
🪲|beetle|animal bug insect|beetle|13|
🐞|lady beetle|animal garden insect ladybird ladybug nature|lady_beetle|0.6|
🦗|cricket|orthoptera animal bug grasshopper insect|cricket|5|
🪳|cockroach|animal insect pest roach|cockroach|13|
🕷️|spider|animal insect|spider|0.7|
🕸️|spider web||spider_web|0.7|
🦂|scorpion|scorpio scorpius zodiac|scorpion|1|
🦟|mosquito|bite disease fever insect malaria pest|mosquito|11|
🪰|fly|animal disease insect maggot pest rotting|fly|13|
🪱|worm|animal annelid earthworm parasite|worm|13|
🦠|microbe|amoeba bacteria science virus|microbe|11|
💐|bouquet|anniversary birthday date flower love plant|bouquet|0.6|
🌸|cherry blossom|flower plant spring springtime|cherry_blossom|0.6|
💮|white flower||white_flower|0.6|
🪷|lotus|buddhism hinduism beauty calm flower peace|lotus|14|
🏵️|rosette|plant|rosette|0.7|
🌹|rose|beauty elegant flower love plant red|rose|0.6|
🥀|wilted flower|dying|wilted_flower|3|
🌺|hibiscus|flower plant|hibiscus|0.6|
🌻|sunflower|flower outdoors plant sun|sunflower|0.6|
🌼|blossom|buttercup dandelion flower plant|blossom|0.6|
🌷|tulip|blossom flower growth plant|tulip|0.6|
🪻|hyacinth|bloom bluebonnet flower indigo lavender lilac|hyacinth|15|
🌱|seedling|plant sapling sprout young|seedling|0.6|
🪴|potted plant|decor grow house nurturing pot|potted_plant|13|
🌲|evergreen tree|christmas forest pine|evergreen_tree|1|
🌳|deciduous tree|forest green habitat shedding|deciduous_tree|1|
🌴|palm tree|beach plant tropical|palm_tree|0.6|
🌵|cactus|desert drought nature plant|cactus|0.6|
🌾|sheaf of rice|ear grain grains plant|ear_of_rice|0.6|
🌿|herb|leaf plant|herb|0.6|
☘️|shamrock|irish plant|shamrock|1|
🍀|four leaf clover|4 four-leaf irish lucky plant|four_leaf_clover|0.6|
🍁|maple leaf|falling|maple_leaf|0.6|
🍂|fallen leaf|autumn fall falling|fallen_leaf|0.6|
🍃|leaf fluttering in wind|blow flutter|leaves|0.6|
🪹|empty nest|branch home nesting|empty_nest|14|
🪺|nest with eggs|bird branch egg nesting|nest_with_eggs|14|
🍄|mushroom|fungus toadstool|mushroom|0.6|
🪾|leafless tree|bare barren branches dead drought trunk||16|
#food
🍇|grapes|dionysus fruit grape|grapes|0.6|
🍈|melon|cantaloupe fruit|melon|0.6|
🍉|watermelon|fruit|watermelon|0.6|
🍊|tangerine|c citrus fruit nectarine orange vitamin|mandarin orange|0.6|
🍋|lemon|citrus fruit sour|lemon|1|
🍋‍🟩|lime|acidity citrus cocktail fruit garnish key||15.1|
🍌|banana|fruit potassium|banana|0.6|
🍍|pineapple|colada fruit pina tropical|pineapple|0.6|
🥭|mango|food fruit tropical|mango|11|
🍎|red apple|diet food fruit health ripe|apple|0.6|
🍏|green apple|fruit|green_apple|0.6|
🍐|pear|fruit|pear|1|
🍑|peach|fruit|peach|0.6|
🍒|cherries|berries cherry fruit red|cherries|0.6|
🍓|strawberry|berry fruit|strawberry|0.6|
🫐|blueberries|berries berry bilberry blue blueberry food|blueberries|13|
🥝|kiwi fruit|food|kiwi_fruit|3|
🍅|tomato|food fruit vegetable|tomato|0.6|
🫒|olive|food|olive|13|
🥥|coconut|colada palm piña|coconut|5|
🥑|avocado|food fruit|avocado|3|
🍆|eggplant|aubergine vegetable|eggplant|0.6|
🥔|potato|food vegetable|potato|3|
🥕|carrot|food vegetable|carrot|3|
🌽|ear of corn|crops farm maize maze|corn|0.6|
🌶️|hot pepper||hot_pepper|0.7|
🫑|bell pepper|capsicum food vegetable|bell_pepper|13|
🥒|cucumber|food pickle vegetable|cucumber|3|
🫝|pickle|brine condiment cucumber ferment gherkin relish||18|
🥬|leafy green|bok burgers cabbage choy kale lettuce|leafy_green|11|
🥦|broccoli|cabbage wild|broccoli|5|
🧄|garlic|flavoring|garlic|12|
🧅|onion|flavoring|onion|12|
🥜|peanuts|food nut peanut vegetable|peanuts|3|
🫘|beans|food kidney legume small|beans|14|
🌰|chestnut|almond plant|chestnut|0.6|
🫚|ginger root|beer health herb natural spice|ginger_root|15|
🫛|pea pod|beans beanstalk edamame legume soybean vegetable|pea_pod|15|
🍄‍🟫|brown mushroom|food fungi fungus nature pizza portobello||15.1|
🫜|root vegetable|beet food garden radish salad turnip||16|
🍞|bread|carbs food grain loaf restaurant toast|bread|0.6|
🥐|croissant|bread breakfast crescent food french roll|croissant|3|
🥖|baguette bread|food french|baguette_bread|3|
🫓|flatbread|arepa bread food gordita lavash naan|flatbread|13|
🥨|pretzel|convoluted twisted|pretzel|5|
🥯|bagel|bakery bread breakfast schmear|bagel|11|
🥞|pancakes|breakfast crêpe food hotcake pancake|pancakes|3|
🧇|waffle|breakfast indecisive iron|waffle|12|
🧀|cheese wedge||cheese|1|
🍖|meat on bone||meat_on_bone|0.6|
🍗|poultry leg|bone chicken drumstick hungry turkey|poultry_leg|0.6|
🥩|cut of meat|chop lambchop porkchop red steak|cut_of_meat|5|
🥓|bacon|breakfast food meat|bacon|3|
🍔|hamburger|burger eat fast food hungry|hamburger|0.6|
🍟|french fries|fast food|fries|0.6|
🍕|pizza|cheese food hungry pepperoni slice|pizza|0.6|
🌭|hot dog|frankfurter hotdog sausage|hotdog|1|
🥪|sandwich|bread|sandwich|5|
🌮|taco|mexican|taco|1|
🌯|burrito|mexican wrap|burrito|1|
🫔|tamale|food mexican pamonha wrapped|tamale|13|
🥙|stuffed flatbread|falafel food gyro kebab|stuffed_flatbread|3|
🧆|falafel|chickpea meatball|falafel|12|
🥚|egg|breakfast food|egg|3|
🍳|cooking|breakfast easy egg fry frying over|fried_egg|0.6|
🥘|shallow pan of food|casserole paella|shallow_pan_of_food|3|
🍲|pot of food|soup stew|stew|0.6|
🫕|fondue|cheese chocolate food melted pot ski|fondue|13|
🥣|bowl with spoon|breakfast cereal congee oatmeal porridge|bowl_with_spoon|5|
🥗|green salad|food|green_salad|3|
🍿|popcorn|corn movie pop|popcorn|1|
🧈|butter|dairy|butter|12|
🧂|salt|condiment flavor mad salty shaker taste|salt|11|
🥫|canned food|can|canned_food|5|
🍱|bento box|food|bento|0.6|
🍘|rice cracker|food|rice_cracker|0.6|
🍙|rice ball|japanese food|rice_ball|0.6|
🍚|cooked rice|food|rice|0.6|
🍛|curry rice|food|curry|0.6|
🍜|steaming bowl|chopsticks food noodle pho ramen soup|ramen|0.6|
🍝|spaghetti|food meatballs pasta restaurant|spaghetti|0.6|
🍠|roasted sweet potato|food|sweet_potato|0.6|
🍢|oden|food kebab restaurant seafood skewer stick|oden|0.6|
🍣|sushi|food|sushi|0.6|
🍤|fried shrimp|prawn tempura|fried_shrimp|0.6|
🍥|fish cake with swirl|food pastry restaurant|fish_cake|0.6|
🥮|moon cake|autumn festival yuèbǐng|moon_cake|11|
🍡|dango|japanese dessert skewer stick sweet|dango|0.6|
🥟|dumpling|empanada gyōza jiaozi pierogi potsticker|dumpling|5|
🥠|fortune cookie|prophecy|fortune_cookie|5|
🥡|takeout box|chopsticks delivery food oyster pail|takeout_box|5|
🍦|soft ice cream|dessert food icecream restaurant serve sweet|icecream|0.6|
🍧|shaved ice|dessert restaurant sweet|shaved_ice|0.6|
🍨|ice cream|dessert food restaurant sweet|ice_cream|0.6|
🍩|doughnut|breakfast dessert donut food sweet|doughnut|0.6|
🍪|cookie|chip chocolate dessert sweet|cookie|0.6|
🎂|birthday cake|bday celebration dessert happy pastry sweet|birthday|0.6|
🍰|shortcake|cake dessert pastry slice sweet|cake|0.6|
🧁|cupcake|bakery dessert sprinkles sugar sweet treat|cupcake|11|
🥧|pie|apple filling fruit meat pastry pumpkin|pie|5|
🍫|chocolate bar|candy dessert halloween sweet tooth|chocolate_bar|0.6|
🍬|candy|cavities dessert halloween restaurant sweet tooth|candy|0.6|
🍭|lollipop|candy dessert food restaurant sweet|lollipop|0.6|
🍮|custard|dessert pudding sweet|custard|0.6|
🍯|honey pot|barrel bear food honeypot jar sweet|honey_pot|0.6|
🍼|baby bottle|babies birth born drink infant milk|baby_bottle|1|
🥛|glass of milk|drink|milk_glass|3|
☕|hot beverage|cafe caffeine chai coffee drink morning|coffee|0.6|
🫖|teapot|brew drink food pot tea|teapot|13|
🍵|teacup without handle|beverage cup drink oolong tea|tea|0.6|
🍶|sake|bar beverage bottle cup drink restaurant|sake|0.6|
🍾|bottle with popping cork|bar drink|champagne|1|
🍷|wine glass|alcohol bar beverage booze club drink|wine_glass|0.6|
🍸|cocktail glass|alcohol bar booze club drink drinking|cocktail|0.6|
🍹|tropical drink|alcohol bar booze club cocktail drinking|tropical_drink|0.6|
🍺|beer mug|alcohol ale bar booze drink drinking|beer|0.6|
🍻|clinking beer mugs|alcohol bar booze bottoms cheers clink|beers|0.6|
🥂|clinking glasses|celebrate clink drink glass|clinking_glasses|3|
🥃|tumbler glass|liquor scotch shot whiskey whisky|tumbler_glass|3|
🫗|pouring liquid|accident drink empty glass oops pour|pouring_liquid|14|
🥤|cup with straw|drink juice malt soda soft water|cup_with_straw|5|
🧋|bubble tea|boba food milk pearl|bubble_tea|13|
🧃|beverage box|juice straw sweet|beverage_box|12|
🧉|mate|drink|mate|12|
🧊|ice|cold cube iceberg|ice_cube|12|
🥢|chopsticks|hashi jeotgarak kuaizi|chopsticks|5|
🍽️|fork and knife with plate|cooking dinner eat|plate_with_cutlery|0.7|
🍴|fork and knife|breakfast breaky cooking cutlery delicious dinner|fork_and_knife|0.6|
🥄|spoon|eat tableware|spoon|3|
🔪|kitchen knife|chef cooking hocho tool weapon|hocho knife|0.6|
🫙|jar|condiment container empty nothing sauce store|jar|14|
🏺|amphora|aquarius cooking drink jug tool weapon|amphora|1|
#travel
🌍|globe showing Europe-Africa|europe-africa earth world|earth_africa|0.7|
🌎|globe showing Americas|earth world|earth_americas|0.7|
🌏|globe showing Asia-Australia|asia-australia earth world|earth_asia|0.6|
🌐|globe with meridians|earth internet web world worldwide|globe_with_meridians|1|
🗺️|world map||world_map|0.7|
🗾|map of Japan||japan|0.6|
🧭|compass|direction magnetic navigation orienteering|compass|11|
🏔️|snow-capped mountain|cold snow-capped|mountain_snow|0.7|
⛰️|mountain||mountain|0.7|
🛘|landslide|avalanche danger disaster earthquake mountain mudslide||17|
🌋|volcano|eruption mountain nature|volcano|0.6|
🗻|mount fuji|mountain nature|mount_fuji|0.6|
🏕️|camping||camping|0.7|
🏖️|beach with umbrella||beach_umbrella|0.7|
🏜️|desert||desert|0.7|
🏝️|desert island||desert_island|0.7|
🏞️|national park||national_park|0.7|
🏟️|stadium||stadium|0.7|
🏛️|classical building||classical_building|0.7|
🏗️|building construction|crane|building_construction|0.7|
🧱|brick|bricks clay mortar wall|bricks|11|
🪨|rock|boulder heavy solid stone tough|rock|13|
🪵|wood|log lumber timber|wood|13|
🛖|hut|home house roundhouse shelter yurt|hut|13|
🏘️|houses|house|houses|0.7|
🏚️|derelict house|home|derelict_house|0.7|
🏠|house|building country heart home ranch settle|house|0.6|
🏡|house with garden|building country heart home ranch settle|house_with_garden|0.6|
🏢|office building|city cubical job|office|0.6|
🏣|Japanese post office|building|post_office|0.6|
🏤|post office|european building|european_post_office|1|
🏥|hospital|building doctor medicine|hospital|0.6|
🏦|bank|building|bank|0.6|
🏨|hotel|building|hotel|0.6|
🏩|love hotel|building|love_hotel|0.6|
🏪|convenience store|24 building hours|convenience_store|0.6|
🏫|school|building|school|0.6|
🏬|department store|building|department_store|0.6|
🏭|factory|building|factory|0.6|
🏯|Japanese castle|building|japanese_castle|0.6|
🏰|castle|european building|european_castle|0.6|
💒|wedding|chapel hitched nuptials romance|wedding|0.6|
🗼|Tokyo tower||tokyo_tower|0.6|
🗽|Statue of Liberty|new ny nyc york|statue_of_liberty|0.6|
⛪|church|christian bless chapel cross religion|church|0.6|
🕌|mosque|muslim islam masjid religion|mosque|1|
🛕|hindu temple||hindu_temple|12|
🕍|synagogue|jew jewish judaism religion temple|synagogue|1|
⛩️|shinto shrine|religion|shinto_shrine|0.7|
🕋|kaaba|muslim hajj islam religion umrah|kaaba|1|
⛲|fountain||fountain|0.6|
⛺|tent|camping|tent|0.6|
🌁|foggy|fog|foggy|0.6|
🌃|night with stars|star|night_with_stars|0.6|
🏙️|cityscape|city|cityscape|0.7|
🌄|sunrise over mountains|morning sun|sunrise_over_mountains|0.6|
🌅|sunrise|morning nature sun|sunrise|0.6|
🌆|cityscape at dusk|building city evening landscape sun sunset|city_sunset|0.6|
🌇|sunset|building dusk sun|city_sunrise|0.6|
🌉|bridge at night||bridge_at_night|0.6|
♨️|hot springs|hotsprings steaming|hotsprings|0.6|
🎠|carousel horse|entertainment|carousel_horse|0.6|
🛝|playground slide|amusement park play playing sliding theme|playground_slide|14|
🎡|ferris wheel|amusement park theme|ferris_wheel|0.6|
🎢|roller coaster|amusement park theme|roller_coaster|0.6|
💈|barber pole|cut fresh haircut shave|barber|0.6|
🎪|circus tent||circus_tent|0.6|
🚂|locomotive|caboose engine railway steam train trains|steam_locomotive|1|
🚃|railway car|electric train tram travel trolleybus|railway_car|0.6|
🚄|high-speed train|high-speed railway shinkansen|bullettrain_side|0.6|
🚅|bullet train|high-speed nose railway shinkansen speed travel|bullettrain_front|0.6|
🚆|train|arrived choo railway|train2|1|
🚇|metro|subway travel|metro|0.6|
🚈|light rail|arrived monorail railway|light_rail|1|
🚉|station|railway train|station|0.6|
🚊|tram|trolleybus|tram|1|
🚝|monorail|vehicle|monorail|1|
🚞|mountain railway|car trip|mountain_railway|1|
🚋|tram car|bus trolley trolleybus|train|1|
🚌|bus|school vehicle|bus|0.6|
🚍|oncoming bus|cars|oncoming_bus|0.7|
🚎|trolleybus|bus tram trolley|trolleybus|1|
🚐|minibus|bus drive van vehicle|minibus|1|
🚑|ambulance|emergency vehicle|ambulance|0.6|
🚒|fire engine|truck|fire_engine|0.6|
🚓|police car|5–0 cops patrol|police_car|0.6|
🚔|oncoming police car||oncoming_police_car|0.7|
🚕|taxi|cab cabbie car drive vehicle yellow|taxi|0.6|
🚖|oncoming taxi|cab cabbie cars drove hail yellow|oncoming_taxi|1|
🚗|automobile|car driving vehicle|car red_car|0.6|
🚘|oncoming automobile|car cars drove vehicle|oncoming_automobile|0.7|
🚙|sport utility vehicle|car drive recreational sportutility|blue_car|0.6|
🛻|pickup truck|automobile car flatbed pick-up transportation|pickup_truck|13|
🚚|delivery truck|car drive vehicle|truck|0.6|
🚛|articulated lorry|car drive move semi truck vehicle|articulated_lorry|1|
🚜|tractor|vehicle|tractor|1|
🏎️|racing car|zoom|racing_car|0.7|
🏍️|motorcycle|racing|motorcycle|0.7|
🛵|motor scooter||motor_scooter|3|
🦽|manual wheelchair|accessibility|manual_wheelchair|12|
🦼|motorized wheelchair|accessibility|motorized_wheelchair|12|
🛺|auto rickshaw|tuk|auto_rickshaw|12|
🚲|bicycle|bike class cycle cycling cyclist gang|bike|0.6|
🛴|kick scooter||kick_scooter|3|
🛹|skateboard|board skate skater wheels|skateboard|11|
🛼|roller skate|blades skates sport|roller_skate|13|
🚏|bus stop|busstop|busstop|0.6|
🛣️|motorway|highway road|motorway|0.7|
🛤️|railway track|train|railway_track|0.7|
🛢️|oil drum||oil_drum|0.7|
⛽|fuel pump|diesel fuelpump gas gasoline station|fuelpump|0.6|
🛞|wheel|car circle tire turn vehicle|wheel|14|
🚨|police car light|alarm alert beacon emergency revolving siren|rotating_light|0.6|
🚥|horizontal traffic light|intersection signal stop stoplight|traffic_light|0.6|
🚦|vertical traffic light|drove intersection signal stop stoplight|vertical_traffic_light|1|
🛑|stop sign|octagonal|stop_sign|3|
🚧|construction|barrier|construction|0.6|
🛙|lighthouse|beacon enlightenment guidance hope light maritime||18|
⚓|anchor|ship tool|anchor|0.6|
🛟|ring buoy|float life lifesaver preserver rescue safety|ring_buoy|14|
⛵|sailboat|boat resort sailing sea yacht|boat sailboat|0.6|
🛶|canoe|boat|canoe|3|
🚤|speedboat|billionaire boat lake luxury millionaire summer|speedboat|0.6|
🛳️|passenger ship||passenger_ship|0.7|
⛴️|ferry|boat passenger|ferry|0.7|
🛥️|motor boat|motorboat|motor_boat|0.7|
🚢|ship|boat passenger travel|ship|0.6|
✈️|airplane|aeroplane fly flying jet plane travel|airplane|0.6|
🛩️|small airplane|aeroplane plane|small_airplane|0.7|
🛫|airplane departure|aeroplane check-in departures plane|flight_departure|1|
🛬|airplane arrival|aeroplane arrivals arriving landing plane|flight_arrival|1|
🪂|parachute|hang-glide parasail skydive|parachute|12|
💺|seat|chair|seat|0.6|
🚁|helicopter|copter roflcopter travel vehicle|helicopter|1|
🚟|suspension railway||suspension_railway|1|
🚠|mountain cableway|cable gondola lift ski|mountain_cableway|1|
🚡|aerial tramway|cable car gondola ropeway|aerial_tramway|1|
🛰️|satellite|space|artificial_satellite|0.7|
🚀|rocket|launch rockets space travel|rocket|0.6|
🛸|flying saucer|ufo aliens extra terrestrial|flying_saucer|5|
🛎️|bellhop bell|hotel|bellhop_bell|0.7|
🧳|luggage|bag packing roller suitcase travel|luggage|11|
⌛|hourglass done|sand time timer|hourglass|0.6|
⏳|hourglass not done|flowing hours sand timer waiting yolo|hourglass_flowing_sand|0.6|
⌚|watch|clock time|watch|0.6|
⏰|alarm clock|hours hrs late time waiting|alarm_clock|0.6|
⏱️|stopwatch|clock time|stopwatch|1|
⏲️|timer clock||timer_clock|1|
🕰️|mantelpiece clock|time|mantelpiece_clock|0.7|
🕛|twelve o’clock|12 12:00 clock time|clock12|0.6|
🕧|twelve-thirty|12 12:30 30 clock time|clock1230|0.7|
🕐|one o’clock|1 1:00 clock time|clock1|0.6|
🕜|one-thirty|1 1:30 30 clock time|clock130|0.7|
🕑|two o’clock|2 2:00 clock time|clock2|0.6|
🕝|two-thirty|2 2:30 30 clock time|clock230|0.7|
🕒|three o’clock|3 3:00 clock time|clock3|0.6|
🕞|three-thirty|3 30 3:30 clock time|clock330|0.7|
🕓|four o’clock|4 4:00 clock time|clock4|0.6|
🕟|four-thirty|30 4 4:30 clock time|clock430|0.7|
🕔|five o’clock|5 5:00 clock time|clock5|0.6|
🕠|five-thirty|30 5 5:30 clock time|clock530|0.7|
🕕|six o’clock|6 6:00 clock time|clock6|0.6|
🕡|six-thirty|30 6 6:30 clock|clock630|0.7|
🕖|seven o’clock|0 7 7:00 clock|clock7|0.6|
🕢|seven-thirty|30 7 7:30 clock|clock730|0.7|
🕗|eight o’clock|8 8:00 clock time|clock8|0.6|
🕣|eight-thirty|30 8 8:30 clock time|clock830|0.7|
🕘|nine o’clock|9 9:00 clock time|clock9|0.6|
🕤|nine-thirty|30 9 9:30 clock time|clock930|0.7|
🕙|ten o’clock|0 10 10:00 clock|clock10|0.6|
🕥|ten-thirty|10 10:30 30 clock time|clock1030|0.7|
🕚|eleven o’clock|11 11:00 clock time|clock11|0.6|
🕦|eleven-thirty|11 11:30 30 clock time|clock1130|0.7|
🌑|new moon|dark space|new_moon|0.6|
🌒|waxing crescent moon|dreams space|waxing_crescent_moon|1|
🌓|first quarter moon|space|first_quarter_moon|0.6|
🌔|waxing gibbous moon|space|moon waxing_gibbous_moon|0.6|
🌕|full moon|space|full_moon|0.6|
🌖|waning gibbous moon|space|waning_gibbous_moon|1|
🌗|last quarter moon|space|last_quarter_moon|1|
🌘|waning crescent moon|space|waning_crescent_moon|1|
🌙|crescent moon|ramadan space|crescent_moon|0.6|
🌚|new moon face|space|new_moon_with_face|1|
🌛|first quarter moon face|space|first_quarter_moon_with_face|0.6|
🌜|last quarter moon face|dreams|last_quarter_moon_with_face|0.7|
🌡️|thermometer|weather|thermometer|0.7|
☀️|sun|bright rays space sunny weather|sunny|0.6|
🌝|full moon face|bright|full_moon_with_face|1|
🌞|sun with face|beach bright day heat shine sunny|sun_with_face|1|
🪐|ringed planet|saturn saturnine|ringed_planet|12|
⭐|star|astronomy medium stars white|star|0.6|
🌟|glowing star|glittery glow night shining sparkle win|star2|0.6|
🌠|shooting star|falling night space|stars|0.6|
🌌|milky way|space|milky_way|0.6|
☁️|cloud|weather|cloud|0.6|
⛅|sun behind cloud|cloudy weather|partly_sunny|0.6|
⛈️|cloud with lightning and rain|thunder thunderstorm|cloud_with_lightning_and_rain|0.7|
🌤️|sun behind small cloud|weather|sun_behind_small_cloud|0.7|
🌥️|sun behind large cloud|weather|sun_behind_large_cloud|0.7|
🌦️|sun behind rain cloud|weather|sun_behind_rain_cloud|0.7|
🌧️|cloud with rain|weather|cloud_with_rain|0.7|
🌨️|cloud with snow|cold weather|cloud_with_snow|0.7|
🌩️|cloud with lightning|weather|cloud_with_lightning|0.7|
🌪️|tornado|cloud weather whirlwind|tornado|0.7|
🌫️|fog|cloud weather|fog|0.7|
🌬️|wind face|blow cloud|wind_face|0.7|
🌀|cyclone|dizzy hurricane twister typhoon weather|cyclone|0.6|
🌈|rainbow|gay genderqueer glbt glbtq lesbian lgbt|rainbow|0.6|
🌂|closed umbrella|clothing rain|closed_umbrella|0.6|
☂️|umbrella|clothing rain|open_umbrella|0.7|
☔|umbrella with rain drops|clothing drop weather|umbrella|0.6|
⛱️|umbrella on ground|rain sun|parasol_on_ground|0.7|
⚡|high voltage|danger electric electricity lightning nature thunder|zap|0.6|
❄️|snowflake|cold snow weather|snowflake|0.6|
☃️|snowman|cold man snow|snowman_with_snow|0.7|
⛄|snowman without snow|cold man|snowman|0.6|
☄️|comet|space|comet|1|
🪋|meteor|apocalypse falling fireball gravity rock space||18|
🔥|fire|af burn flame hot lit litaf|fire|0.6|
💧|droplet|cold comic drop nature sad sweat|droplet|0.6|
🌊|water wave|nature ocean surf surfer surfing|ocean|0.6|
#activities
🎃|jack-o-lantern|celebration halloween pumpkin|jack_o_lantern|0.6|
🎄|Christmas tree|celebration|christmas_tree|0.6|
🎆|fireworks|boom celebration entertainment yolo|fireworks|0.6|
🎇|sparkler|boom celebration fireworks sparkle|sparkler|0.6|
🧨|firecracker|dynamite explosive fire fireworks light pop|firecracker|11|
✨|sparkles|* magic sparkle star|sparkles|0.6|
🎈|balloon|birthday celebrate celebration|balloon|0.6|
🎉|party popper|awesome birthday celebrate celebration excited hooray|tada|0.6|
🎊|confetti ball|celebrate celebration party woohoo|confetti_ball|0.6|
🎋|tanabata tree|japanese banner celebration|tanabata_tree|0.6|
🎍|pine decoration|japanese bamboo celebration plant|bamboo|0.6|
🎎|Japanese dolls|celebration doll festival|dolls|0.6|
🎏|carp streamer|celebration|flags|0.6|
🎐|wind chime|bell celebration|wind_chime|0.6|
🎑|moon viewing ceremony|celebration|rice_scene|0.6|
🧧|red envelope|gift good hóngbāo lai luck money|red_envelope|11|
🎀|ribbon|celebration|ribbon|0.6|
🎁|wrapped gift|birthday bow box celebration christmas present|gift|0.6|
🎗️|reminder ribbon|celebration|reminder_ribbon|0.7|
🎟️|admission tickets|ticket|tickets|0.7|
🎫|ticket|admission stub|ticket|0.6|
🎖️|military medal|award celebration|medal_military|0.7|
🏆|trophy|champion champs prize slay sport victory|trophy|0.6|
🏅|sports medal|award gold winner|medal_sports|1|
🥇|1st place medal|first gold|1st_place_medal|3|
🥈|2nd place medal|second silver|2nd_place_medal|3|
🥉|3rd place medal|bronze third|3rd_place_medal|3|
⚽|soccer ball|football futbol sport|soccer|0.6|
⚾|baseball|ball sport|baseball|0.6|
🥎|softball|ball glove sports underarm|softball|11|
🏀|basketball|ball hoop sport|basketball|0.6|
🏐|volleyball|ball game|volleyball|1|
🏈|american football|ball bowl sport super|football|0.6|
🏉|rugby football|ball sport|rugby_football|1|
🎾|tennis|ball racquet sport|tennis|0.6|
🥏|flying disc|ultimate|flying_disc|11|
🎳|bowling|ball game sport strike|bowling|0.6|
🏏|cricket game|ball bat|cricket_game|1|
🏑|field hockey|ball game stick|field_hockey|1|
🏒|ice hockey|game puck stick|ice_hockey|1|
🥍|lacrosse|ball goal sports stick|lacrosse|11|
🏓|ping pong|ball bat game paddle pingpong table|ping_pong|1|
🏸|badminton|birdie game racquet shuttlecock|badminton|1|
🥊|boxing glove||boxing_glove|3|
🥋|martial arts uniform|judo karate taekwondo|martial_arts_uniform|3|
🥅|goal net||goal_net|3|
⛳|flag in hole|golf sport|golf|0.6|
⛸️|ice skate|skating|ice_skate|0.7|
🎣|fishing pole|entertainment fish sport|fishing_pole_and_fish|0.6|
🤿|diving mask|scuba snorkeling|diving_mask|12|
🎽|running shirt|athletics sash|running_shirt_with_sash|0.6|
🎿|skis|ski snow sport|ski|0.6|
🛷|sled|luge sledge sleigh snow toboggan|sled|5|
🥌|curling stone|game rock|curling_stone|5|
🎯|bullseye|bull dart direct entertainment game hit|dart|0.6|
🪀|yo-yo|fluctuate toy|yo_yo|12|
🪁|kite|fly soar|kite|12|
🔫|water pistol|gun handgun revolver tool weapon|gun|0.6|
🎱|pool 8 ball|8ball billiard eight game|8ball|0.6|
🔮|crystal ball|fairy fairytale fantasy fortune future magic|crystal_ball|0.6|
🪄|magic wand|magician witch wizard|magic_wand|13|
🎮|video game|controller entertainment|video_game|0.6|
🕹️|joystick|game video videogame|joystick|0.7|
🎰|slot machine|casino gamble gambling game slots|slot_machine|0.6|
🎲|game die|dice entertainment|game_die|0.6|
🧩|puzzle piece|clue interlocking jigsaw|jigsaw|11|
🧸|teddy bear|plaything plush stuffed toy|teddy_bear|11|
🪅|piñata|candy celebrate celebration cinco de festive|pinata|13|
🪩|mirror ball|dance disco glitter party|mirror_ball|14|
🪆|nesting dolls|babooshka baboushka babushka doll matryoshka russia|nesting_dolls|13|
♠️|spade suit|card game|spades|0.6|
♥️|heart suit|card emotion game hearts|hearts|0.6|
♦️|diamond suit|card game|diamonds|0.6|
♣️|club suit|card clubs game|clubs|0.6|
♟️|chess pawn|dupe expendable|chess_pawn|11|
🃏|joker|card game wildcard|black_joker|0.6|
🀄|mahjong red dragon|game|mahjong|0.6|
🎴|flower playing cards|japanese card game|flower_playing_cards|0.6|
🎭|performing arts|actor actress art entertainment mask theater|performing_arts|0.6|
🖼️|framed picture|art frame museum painting|framed_picture|0.7|
🎨|artist palette|art artsy arty colorful creative entertainment|art|0.6|
🧵|thread|needle sewing spool string|thread|11|
🪡|sewing needle|embroidery sew stitches sutures tailoring thread|sewing_needle|13|
🧶|yarn|ball crochet knit|yarn|11|
🪢|knot|cord rope tangled tie twine twist|knot|13|
#objects
👓|glasses|clothing eye eyeglasses eyewear|eyeglasses|0.6|
🕶️|sunglasses|dark eye eyewear glasses|dark_sunglasses|0.7|
🥽|goggles|dive eye protection scuba swimming welding|goggles|11|
🥼|lab coat|clothes doctor dr experiment jacket scientist|lab_coat|11|
🦺|safety vest|emergency|safety_vest|12|
👔|necktie|clothing employed serious shirt tie|necktie|0.6|
👕|t-shirt|blue casual clothes clothing collar dressed|shirt tshirt|0.6|
👖|jeans|blue casual clothes clothing denim dressed|jeans|0.6|
🧣|scarf|bundle cold neck up|scarf|5|
🧤|gloves|hand|gloves|5|
🧥|coat|brr bundle cold jacket up|coat|5|
🧦|socks|stocking|socks|5|
👗|dress|clothes clothing dressed fancy shopping|dress|0.6|
👘|kimono|clothing comfortable|kimono|0.6|
🥻|sari|clothing dress|sari|12|
🩱|one-piece swimsuit|bathing one-piece suit|one_piece_swimsuit|12|
🩲|briefs|bathing one-piece suit swimsuit underwear|swim_brief|12|
🩳|shorts|bathing pants suit swimsuit underwear|shorts|12|
👙|bikini|bathing beach clothing pool suit swim|bikini|0.6|
👚|woman’s clothes|blouse clothing collar dress dressed lady|womans_clothes|0.6|
🪭|folding hand fan|clack clap cool cooling dance flirt|folding_hand_fan|15|
👛|purse|clothes clothing coin dress fancy handbag|purse|0.6|
👜|handbag|bag clothes clothing dress lady purse|handbag|0.6|
👝|clutch bag|clothes clothing dress handbag pouch purse|pouch|0.6|
🛍️|shopping bags|bag hotel|shopping|0.7|
🎒|backpack|backpacking bag bookbag education rucksack satchel|school_satchel|0.6|
🩴|thong sandal|beach flip flop sandals shoe thongs|thong_sandal|13|
👞|man’s shoe|brown clothes clothing feet foot kick|mans_shoe shoe|0.6|
👟|running shoe|athletic clothes clothing fast kick shoes|athletic_shoe|0.6|
🥾|hiking boot|backpacking brown camping outdoors shoe|hiking_boot|11|
🥿|flat shoe|ballet comfy flats slip-on slipper|flat_shoe|11|
👠|high-heeled shoe|clothes clothing dress fashion heel heels|high_heel|0.6|
👡|woman’s sandal|clothing shoe woman|sandal|0.6|
🩰|ballet shoes|dance|ballet_shoes|12|
👢|woman’s boot|clothes clothing dress shoe shoes shopping|boot|0.6|
🪮|hair pick|afro comb groom|hair_pick|15|
👑|crown|clothing family king medieval queen royal|crown|0.6|
👒|woman’s hat|clothes clothing garden hats party woman|womans_hat|0.6|
🎩|top hat|clothes clothing fancy formal magic tophat|tophat|0.6|
🎓|graduation cap|celebration clothing education hat scholar|mortar_board|0.6|
🧢|billed cap|baseball bent dad hat|billed_cap|5|
🪖|military helmet|army soldier war warrior|military_helmet|13|
⛑️|rescue worker’s helmet|aid cross face hat|rescue_worker_helmet|0.7|
📿|prayer beads|clothing necklace religion|prayer_beads|1|
💄|lipstick|cosmetics date makeup|lipstick|0.6|
💍|ring|diamond engaged engagement married romance shiny|ring|0.6|
💎|gem stone|diamond engagement jewel money romance wedding|gem|0.6|
🔇|muted speaker|mute quiet silent sound|mute|1|
🔈|speaker low volume|soft sound|speaker|0.7|
🔉|speaker medium volume|sound|sound|1|
🔊|speaker high volume|loud music sound|loud_sound|0.6|
📢|loudspeaker|address communication loud public sound|loudspeaker|0.6|
📣|megaphone|cheering sound|mega|0.6|
📯|postal horn|post|postal_horn|1|
🔔|bell|break church sound|bell|0.6|
🔕|bell with slash|forbidden mute no not prohibited quiet|no_bell|1|
🎼|musical score|music note|musical_score|0.6|
🎵|musical note|music sound|musical_note|0.6|
🎶|musical notes|music note sound|notes|0.6|
🎙️|studio microphone|mic music|studio_microphone|0.7|
🎚️|level slider|music|level_slider|0.7|
🎛️|control knobs|music|control_knobs|0.7|
🎤|microphone|karaoke mic music sing sound|microphone|0.6|
🎧|headphone|earbud sound|headphones|0.6|
📻|radio|entertainment tbt video|radio|0.6|
🎷|saxophone|instrument music sax|saxophone|0.6|
🎺|trumpet|instrument music|trumpet|0.6|
🪊|trombone|brass instrument jazz music sad slide||17|
🪗|accordion|box concertina instrument music squeeze squeezebox|accordion|13|
🎸|guitar|instrument music strat|guitar|0.6|
🎹|musical keyboard|instrument music piano|musical_keyboard|0.6|
🎻|violin|instrument music|violin|0.6|
🪕|banjo|music stringed|banjo|12|
🥁|drum|drumsticks music|drum|3|
🪘|long drum|beat conga instrument rhythm|long_drum|13|
🪇|maracas|cha dance instrument music party percussion|maracas|15|
🪈|flute|band fife flautist instrument marching music|flute|15|
🪉|harp|cupid instrument love music orchestra||16|
📱|mobile phone|cell communication telephone|iphone|0.6|
📲|mobile phone with arrow|build call cell communication receive telephone|calling|0.6|
☎️|telephone|phone|phone telephone|0.6|
📞|telephone receiver|communication phone voip|telephone_receiver|0.6|
📟|pager|communication|pager|0.6|
📠|fax machine|communication|fax|0.6|
🔋|battery||battery|0.6|
🪫|low battery|drained electronic energy power|low_battery|14|
🔌|electric plug|electricity|electric_plug|0.6|
💻|laptop|computer office pc personal|computer|0.6|
🖥️|desktop computer|monitor|desktop_computer|0.7|
🖨️|printer|computer|printer|0.7|
⌨️|keyboard|computer|keyboard|1|
🖱️|computer mouse||computer_mouse|0.7|
🖲️|trackball|computer|trackball|0.7|
💽|computer disk|minidisk optical|minidisc|0.6|
💾|floppy disk|computer|floppy_disk|0.6|
💿|optical disk|cd blu-ray computer dvd|cd|0.6|
📀|dvd|blu-ray cd computer disk optical|dvd|0.6|
🧮|abacus|calculation calculator|abacus|11|
🎥|movie camera|bollywood cinema film hollywood record|movie_camera|0.6|
🎞️|film frames|cinema movie|film_strip|0.7|
📽️|film projector|cinema movie video|film_projector|0.7|
🎬|clapper board|action movie|clapper|0.6|
📺|television|tv video|tv|0.6|
📷|camera|photo selfie snap tbt trip video|camera|0.6|
📸|camera with flash|video|camera_flash|1|
📹|video camera|camcorder tbt|video_camera|0.6|
📼|videocassette|old school tape vcr vhs video|vhs|0.6|
🔍|magnifying glass tilted left|lab left-pointing science search tool|mag|0.6|
🔎|magnifying glass tilted right|contact lab right-pointing science search tool|mag_right|0.6|
🕯️|candle|light|candle|0.7|
💡|light bulb|comic electric idea|bulb|0.6|
🔦|flashlight|electric light tool torch|flashlight|0.6|
🏮|red paper lantern|bar light restaurant|izakaya_lantern lantern|0.6|
🪔|diya lamp|light oil|diya_lamp|12|
📔|notebook with decorative cover|book decorated education school writing|notebook_with_decorative_cover|0.6|
📕|closed book|education|closed_book|0.6|
📖|open book|education fantasy knowledge library novels reading|book open_book|0.6|
📗|green book|education fantasy library reading|green_book|0.6|
📘|blue book|education fantasy library reading|blue_book|0.6|
📙|orange book|education fantasy library reading|orange_book|0.6|
📚|books|book education fantasy knowledge library novels|books|0.6|
📓|notebook||notebook|0.6|
📒|ledger|notebook|ledger|0.6|
📃|page with curl|document paper|page_with_curl|0.6|
📜|scroll|paper|scroll|0.6|
📄|page facing up|document paper|page_facing_up|0.6|
📰|newspaper|communication news paper|newspaper|0.6|
🗞️|rolled-up newspaper|news paper rolled-up|newspaper_roll|0.7|
📑|bookmark tabs|mark marker|bookmark_tabs|0.6|
🔖|bookmark|mark|bookmark|0.6|
🏷️|label|tag|label|0.7|
🪙|coin|dollar euro gold metal money rich|coin|13|
💰|money bag|bank bet billion cash cost dollar|moneybag|0.6|
🪎|treasure chest|gem gold jewels loot money prize||17|
💴|yen banknote|bank bill currency money note|yen|0.6|
💵|dollar banknote|bank bill currency money note|dollar|0.6|
💶|euro banknote|100 bank bill currency money note|euro|1|
💷|pound banknote|bank bill billion cash currency money|pound|1|
💸|money with wings|bank banknote bill billion cash dollar|money_with_wings|0.6|
💳|credit card|bank cash charge money pay|credit_card|0.6|
🧾|receipt|accounting bookkeeping evidence invoice proof|receipt|11|
💹|chart increasing with yen|bank currency graph growth market money|chart|0.6|
✉️|envelope|e-mail email letter|envelope|0.6|
📧|e-mail|email letter|e-mail email|0.6|
📨|incoming envelope|delivering e-mail email letter mail receive|incoming_envelope|0.6|
📩|envelope with arrow|communication down e-mail email letter mail|envelope_with_arrow|0.6|
📤|outbox tray|box email letter mail sent|outbox_tray|0.6|
📥|inbox tray|box email letter mail receive zero|inbox_tray|0.6|
📦|package|box communication delivery parcel shipping|package|0.6|
📫|closed mailbox with raised flag|communication mail postbox|mailbox|0.6|
📪|closed mailbox with lowered flag|mail postbox|mailbox_closed|0.6|
📬|open mailbox with raised flag|mail postbox|mailbox_with_mail|0.7|
📭|open mailbox with lowered flag|mail postbox|mailbox_with_no_mail|0.7|
📮|postbox|mail mailbox|postbox|0.6|
🗳️|ballot box with ballot||ballot_box|0.7|
✏️|pencil||pencil2|0.6|
✒️|black nib|pen|black_nib|0.6|
🖋️|fountain pen||fountain_pen|0.7|
🖊️|pen|ballpoint|pen|0.7|
🖌️|paintbrush|painting|paintbrush|0.7|
🖍️|crayon||crayon|0.7|
📝|memo|communication media notes pencil|memo pencil|0.6|
🪌|eraser|correction delete drawing erase error mistake||18|
💼|briefcase|office|briefcase|0.6|
📁|file folder||file_folder|0.6|
📂|open file folder||open_file_folder|0.6|
🗂️|card index dividers||card_index_dividers|0.7|
📅|calendar|date|date|0.6|
📆|tear-off calendar|tear-off|calendar|0.6|
🗒️|spiral notepad|note pad|spiral_notepad|0.7|
🗓️|spiral calendar|pad|spiral_calendar|0.7|
📇|card index|old rolodex school|card_index|0.6|
📈|chart increasing|data graph growth right trend up|chart_with_upwards_trend|0.6|
📉|chart decreasing|data down downward graph negative trend|chart_with_downwards_trend|0.6|
📊|bar chart|data graph|bar_chart|0.6|
📋|clipboard|do list notes|clipboard|0.6|
📌|pushpin|collage pin|pushpin|0.6|
📍|round pushpin|location map pin|round_pushpin|0.6|
📎|paperclip||paperclip|0.6|
🖇️|linked paperclips|link paperclip|paperclips|0.7|
📏|straight ruler|angle edge math straightedge|straight_ruler|0.6|
📐|triangular ruler|angle math rule set slide triangle|triangular_ruler|0.6|
✂️|scissors|cut cutting paper tool|scissors|0.6|
🗃️|card file box||card_file_box|0.7|
🗄️|file cabinet|filing paper|file_cabinet|0.7|
🗑️|wastebasket|can garbage trash waste|wastebasket|0.7|
🔒|locked|closed lock private|lock|0.6|
🔓|unlocked|cracked lock open unlock|unlock|0.6|
🔏|locked with pen|ink lock nib privacy|lock_with_ink_pen|0.6|
🔐|locked with key|bike closed lock secure|closed_lock_with_key|0.6|
🔑|key|keys lock major password unlock|key|0.6|
🗝️|old key|clue lock|old_key|0.7|
🪍|net with handle|catch collect mesh trap||18|
🔨|hammer|home improvement repairs tool|hammer|0.6|
🪓|axe|ax chop hatchet split wood|axe|12|
⛏️|pick|hammer mining tool|pick|0.7|
⚒️|hammer and pick|tool|hammer_and_pick|1|
🛠️|hammer and wrench|spanner tool|hammer_and_wrench|0.7|
🗡️|dagger|knife weapon|dagger|0.7|
⚔️|crossed swords|weapon|crossed_swords|1|
💣|bomb|boom comic dangerous explosion hot|bomb|0.6|
🪃|boomerang|rebound repercussion weapon|boomerang|13|
🏹|bow and arrow|sagittarius archer archery tool weapon zodiac|bow_and_arrow|1|
🛡️|shield|weapon|shield|0.7|
🪚|carpentry saw|carpenter cut lumber tool trim|carpentry_saw|13|
🔧|wrench|home improvement spanner tool|wrench|0.6|
🪛|screwdriver|flathead handy screw tool|screwdriver|13|
🔩|nut and bolt|home improvement tool|nut_and_bolt|0.6|
⚙️|gear|cog cogwheel tool|gear|1|
🗜️|clamp|compress tool vice|clamp|0.7|
⚖️|balance scale|libra justice scales tool weight zodiac|balance_scale|1|
🦯|white cane|accessibility blind probing|probing_cane|12|
🔗|link|links|link|0.6|
⛓️‍💥|broken chain|break breaking cuffs freedom||15.1|
⛓️|chains|chain|chains|0.7|
🪝|hook|catch crook curve ensnare point selling|hook|13|
🧰|toolbox|box chest mechanic red tool|toolbox|11|
🧲|magnet|attraction horseshoe magnetic negative positive shape|magnet|11|
🪜|ladder|climb rung step|ladder|13|
🪏|shovel|bury dig garden hole plant scoop||16|
⚗️|alembic|chemistry tool|alembic|1|
🧪|test tube|chemist chemistry experiment lab science|test_tube|11|
🧫|petri dish|bacteria biologist biology culture lab|petri_dish|11|
🧬|dna|biologist evolution gene genetics life|dna|11|
🔬|microscope|experiment lab science tool|microscope|1|
🔭|telescope|contact extraterrestrial science tool|telescope|1|
📡|satellite antenna|aliens contact dish science|satellite|0.6|
💉|syringe|doctor flu medicine needle shot sick|syringe|0.6|
🩸|drop of blood|bleed donation injury medicine menstruation|drop_of_blood|12|
💊|pill|doctor drugs medicated medicine pills sick|pill|0.6|
🩹|adhesive bandage||adhesive_bandage|12|
🩼|crutch|aid cane disability help hurt injured|crutch|14|
🩺|stethoscope|doctor heart medicine|stethoscope|12|
🩻|x-ray|bones doctor medical skeleton skull xray|x_ray|14|
🚪|door|back closet front|door|0.6|
🛗|elevator|accessibility hoist lift|elevator|13|
🪞|mirror|makeup reflection reflector speculum|mirror|13|
🪟|window|air frame fresh opening transparent view|window|13|
🛏️|bed|hotel sleep|bed|0.7|
🛋️|couch and lamp|hotel|couch_and_lamp|0.7|
🪑|chair|seat sit|chair|12|
🚽|toilet|bathroom|toilet|0.6|
🪠|plunger|cup force plumber poop suction toilet|plunger|13|
🚿|shower|water|shower|1|
🛁|bathtub|bath|bathtub|1|
🪤|mouse trap|bait cheese lure mousetrap snare|mouse_trap|13|
🪒|razor|sharp shave|razor|12|
🧴|lotion bottle|moisturizer shampoo sunscreen|lotion_bottle|11|
🧷|safety pin|diaper punk rock|safety_pin|11|
🧹|broom|cleaning sweeping witch|broom|11|
🧺|basket|farming laundry picnic|basket|11|
🧻|roll of paper|toilet towels|roll_of_paper|11|
🪣|bucket|cask pail vat|bucket|13|
🧼|soap|bar bathing clean cleaning lather soapdish|soap|11|
🫧|bubbles|bubble burp clean floating pearl soap|bubbles|14|
🪥|toothbrush|bathroom brush clean dental hygiene teeth|toothbrush|13|
🧽|sponge|absorbing cleaning porous soak|sponge|11|
🧯|fire extinguisher|extinguish quench|fire_extinguisher|11|
🛒|shopping cart|trolley|shopping_cart|3|
🚬|cigarette|smoking|smoking|0.6|
⚰️|coffin|dead death vampire|coffin|1|
🪦|headstone|cemetery dead grave graveyard memorial rip|headstone|13|
⚱️|funeral urn|ashes death|funeral_urn|1|
🧿|nazar amulet|bead blue charm evil-eye talisman|nazar_amulet|11|
🪬|hamsa|fatima mary miriam amulet fortune guide|hamsa|14|
🗿|moai|face moyai statue stoneface travel|moyai|0.6|
🪧|placard|card demonstration notice picket plaque protest|placard|13|
🪪|identification card|id credentials document license security|identification_card|14|
#symbols
🏧|ATM sign|automated bank cash money teller|atm|0.6|
🚮|litter in bin sign|litterbin|put_litter_in_its_place|1|
🚰|potable water|drinking|potable_water|1|
♿|wheelchair symbol|access handicap|wheelchair|0.6|
🚹|men’s room|wc bathroom lavatory man restroom toilet|mens|0.6|
🚺|women’s room|wc bathroom lavatory restroom toilet woman|womens|0.6|
🚻|restroom|wc bathroom lavatory toilet|restroom|0.6|
🚼|baby symbol|changing|baby_symbol|0.6|
🚾|water closet|wc bathroom lavatory restroom toilet|wc|0.6|
🛂|passport control||passport_control|1|
🛃|customs|packing|customs|1|
🛄|baggage claim|arrived bags case checked journey packing|baggage_claim|1|
🛅|left luggage|baggage case locker|left_luggage|1|
⚠️|warning|caution|warning|0.6|
🚸|children crossing|child pedestrian traffic|children_crossing|1|
⛔|no entry|do fail forbidden not pass prohibited|no_entry|0.6|
🚫|prohibited|entry forbidden no not smoke|no_entry_sign|0.6|
🚳|no bicycles|bicycle bike forbidden not prohibited|no_bicycles|1|
🚭|no smoking|forbidden not prohibited smoke|no_smoking|0.6|
🚯|no littering|forbidden litter not prohibited|do_not_litter|1|
🚱|non-potable water|dry non-drinking non-potable prohibited|non-potable_water|1|
🚷|no pedestrians|forbidden not pedestrian prohibited|no_pedestrians|1|
📵|no mobile phones|cell forbidden not phone prohibited telephone|no_mobile_phones|1|
🔞|no one under eighteen|18 age forbidden not prohibited restriction|underage|0.6|
☢️|radioactive|sign|radioactive|1|
☣️|biohazard|sign|biohazard|1|
⬆️|up arrow|cardinal direction north|arrow_up|0.6|
↗️|up-right arrow|direction intercardinal northeast up-right|arrow_upper_right|0.6|
➡️|right arrow|cardinal direction east|arrow_right|0.6|
↘️|down-right arrow|direction down-right intercardinal southeast|arrow_lower_right|0.6|
⬇️|down arrow|cardinal direction south|arrow_down|0.6|
↙️|down-left arrow|direction down-left intercardinal southwest|arrow_lower_left|0.6|
⬅️|left arrow|cardinal direction west|arrow_left|0.6|
↖️|up-left arrow|direction intercardinal northwest up-left|arrow_upper_left|0.6|
↕️|up-down arrow|up-down|arrow_up_down|0.6|
↔️|left-right arrow|left-right|left_right_arrow|0.6|
↩️|right arrow curving left||leftwards_arrow_with_hook|0.6|
↪️|left arrow curving right||arrow_right_hook|0.6|
⤴️|right arrow curving up||arrow_heading_up|0.6|
⤵️|right arrow curving down||arrow_heading_down|0.6|
🔃|clockwise vertical arrows|arrow refresh reload|arrows_clockwise|0.6|
🔄|counterclockwise arrows button|again anticlockwise arrow deja refresh rewindershins|arrows_counterclockwise|1|
🔙|BACK arrow||back|0.6|
🔚|END arrow||end|0.6|
🔛|ON! arrow|mark|on|0.6|
🔜|SOON arrow|brb omw|soon|0.6|
🔝|TOP arrow|homie up|top|0.6|
🛐|place of worship|pray religion|place_of_worship|1|
⚛️|atom symbol|atheist|atom_symbol|1|
🕉️|om|hindu religion|om|0.7|
✡️|star of David|jew jewish judaism religion|star_of_david|0.7|
☸️|wheel of dharma|buddhist religion|wheel_of_dharma|0.7|
☯️|yin yang|difficult lives religion tao taoist total|yin_yang|0.7|
✝️|latin cross|christian christ religion|latin_cross|0.7|
☦️|orthodox cross|christian religion|orthodox_cross|1|
☪️|star and crescent|muslim islam ramadan religion|star_and_crescent|0.7|
☮️|peace symbol|healing peaceful|peace_symbol|1|
🕎|menorah|candelabrum candlestick hanukkah jewish judaism religion|menorah|1|
🔯|dotted six-pointed star|fortune jewish judaism six-pointed|six_pointed_star|0.6|
🪯|khanda|deg fateh khalsa sikh sikhism tegh|khanda|15|
♈|Aries|horoscope ram zodiac|aries|0.6|
♉|Taurus|bull horoscope ox zodiac|taurus|0.6|
♊|Gemini|horoscope twins zodiac|gemini|0.6|
♋|Cancer|crab horoscope zodiac|cancer|0.6|
♌|Leo|horoscope lion zodiac|leo|0.6|
♍|Virgo|horoscope zodiac|virgo|0.6|
♎|Libra|balance horoscope justice scales zodiac|libra|0.6|
♏|Scorpio|scorpius horoscope scorpion zodiac|scorpius|0.6|
♐|Sagittarius|archer horoscope zodiac|sagittarius|0.6|
♑|Capricorn|goat horoscope zodiac|capricorn|0.6|
♒|Aquarius|bearer horoscope water zodiac|aquarius|0.6|
♓|Pisces|fish horoscope zodiac|pisces|0.6|
⛎|Ophiuchus|bearer serpent snake zodiac|ophiuchus|0.6|
🔀|shuffle tracks button|arrow crossed|twisted_rightwards_arrows|1|
🔁|repeat button|arrow clockwise|repeat|1|
🔂|repeat single button|arrow clockwise once|repeat_one|1|
▶️|play button|arrow right triangle|arrow_forward|0.6|
⏩|fast-forward button|arrow double fast-forward|fast_forward|0.6|
⏭️|next track button|arrow scene triangle|next_track_button|0.7|
⏯️|play or pause button|arrow right triangle|play_or_pause_button|1|
◀️|reverse button|arrow left triangle|arrow_backward|0.6|
⏪|fast reverse button|arrow double rewind|rewind|0.6|
⏮️|last track button|arrow previous scene triangle|previous_track_button|0.7|
🔼|upwards button|arrow red up|arrow_up_small|0.6|
⏫|fast up button|arrow double|arrow_double_up|0.6|
🔽|downwards button|arrow down red|arrow_down_small|0.6|
⏬|fast down button|arrow double|arrow_double_down|0.6|
⏸️|pause button|bar double vertical|pause_button|0.7|
⏹️|stop button|square|stop_button|0.7|
⏺️|record button|circle|record_button|0.7|
⏏️|eject button||eject_button|1|
🎦|cinema|camera film movie|cinema|0.6|
🔅|dim button|brightness low|low_brightness|1|
🔆|bright button|brightness light|high_brightness|1|
📶|antenna bars|bar cell communication mobile phone signal|signal_strength|0.6|
🛜|wireless|broadband computer connectivity hotspot internet network|wireless|15|
📳|vibration mode|cell communication mobile phone telephone|vibration_mode|0.6|
📴|mobile phone off|cell telephone|mobile_phone_off|0.6|
♀️|female sign|woman|female_sign|4|
♂️|male sign|man|male_sign|4|
⚧️|transgender symbol||transgender_symbol|13|
✖️|multiply|cancel multiplication sign x ×|heavy_multiplication_x|0.6|
➕|plus|+|heavy_plus_sign|0.6|
➖|minus|- heavy math sign −|heavy_minus_sign|0.6|
➗|divide|division heavy math sign ÷|heavy_division_sign|0.6|
🟰|heavy equals sign|answer equal equality math|heavy_equals_sign|14|
♾️|infinity|forever unbounded universal|infinity|11|
‼️|double exclamation mark|! !! bangbang punctuation|bangbang|0.6|
⁉️|exclamation question mark|! !? ? interrobang punctuation|interrobang|0.6|
❓|red question mark|? punctuation|question|0.6|
❔|white question mark|? outlined punctuation|grey_question|0.6|
❕|white exclamation mark|! bang outlined punctuation|grey_exclamation|0.6|
❗|red exclamation mark|! bang punctuation|exclamation heavy_exclamation_mark|0.6|
〰️|wavy dash|punctuation|wavy_dash|0.6|
💱|currency exchange|bank money|currency_exchange|0.6|
💲|heavy dollar sign|billion cash charge currency million money|heavy_dollar_sign|0.6|
⚕️|medical symbol|aesculapius medicine staff|medical_symbol|4|
♻️|recycling symbol|recycle|recycle|0.6|
⚜️|fleur-de-lis|knights|fleur_de_lis|1|
🔱|trident emblem|anchor poseidon ship tool|trident|0.6|
📛|name badge||name_badge|0.6|
🔰|Japanese symbol for beginner|chevron green leaf tool yellow|beginner|0.6|
⭕|hollow red circle|heavy large o|o|0.6|
✅|check mark button|checked checkmark complete completed done fixed|white_check_mark|0.6|
☑️|check box with check|ballot checked done off tick ✓|ballot_box_with_check|0.6|
✔️|check mark|checked checkmark done heavy tick ✓|heavy_check_mark|0.6|
❌|cross mark|cancel multiplication multiply x ×|x|0.6|
❎|cross mark button|multiplication multiply square x ×|negative_squared_cross_mark|0.6|
➰|curly loop|curl|curly_loop|0.6|
➿|double curly loop|curl|loop|1|
〽️|part alternation mark||part_alternation_mark|0.6|
✳️|eight-spoked asterisk|* eight-spoked|eight_spoked_asterisk|0.6|
✴️|eight-pointed star|* eight-pointed|eight_pointed_black_star|0.6|
❇️|sparkle|*|sparkle|0.6|
©️|copyright|c|copyright|0.6|
®️|registered|r|registered|0.6|
™️|trade mark|tm trademark|tm|0.6|
🫟|splatter|drip holi ink liquid mess paint||16|
#️⃣|keycap: #||hash|0.6|
*️⃣|keycap: *||asterisk|2|
0️⃣|keycap: 0|zero|zero|0.6|
1️⃣|keycap: 1|one|one|0.6|
2️⃣|keycap: 2|two|two|0.6|
3️⃣|keycap: 3|three|three|0.6|
4️⃣|keycap: 4|four|four|0.6|
5️⃣|keycap: 5|five|five|0.6|
6️⃣|keycap: 6|six|six|0.6|
7️⃣|keycap: 7|seven|seven|0.6|
8️⃣|keycap: 8|eight|eight|0.6|
9️⃣|keycap: 9|nine|nine|0.6|
🔟|keycap: 10||keycap_ten|0.6|
🔠|input latin uppercase|abcd letters|capital_abcd|0.6|
🔡|input latin lowercase|abcd letters|abcd|0.6|
🔢|input numbers|1234|1234|0.6|
🔣|input symbols|% & ♪ 〒|symbols|0.6|
🔤|input latin letters|abc alphabet|abc|0.6|
🅰️|A button (blood type)|blood type|a|0.6|
🆎|AB button (blood type)|blood type|ab|0.6|
🅱️|B button (blood type)|blood type|b|0.6|
🆑|CL button||cl|0.6|
🆒|COOL button||cool|0.6|
🆓|FREE button||free|0.6|
ℹ️|information|i|information_source|0.6|
🆔|ID button|identity|id|0.6|
Ⓜ️|circled M|circle|m|0.6|
🆕|NEW button||new|0.6|
🆖|NG button||ng|0.6|
🅾️|O button (blood type)|blood type|o2|0.6|
🆗|OK button|okay|ok|0.6|
🅿️|P button|parking|parking|0.6|
🆘|SOS button|help|sos|0.6|
🆙|UP! button|up mark|up|0.6|
🆚|VS button|versus|vs|0.6|
🈁|Japanese “here” button|here katakana|koko|0.6|
🈂️|Japanese “service charge” button|charge katakana service|sa|0.6|
🈷️|Japanese “monthly amount” button|amount ideograph monthly|u6708|0.6|
🈶|Japanese “not free of charge” button|charge ideograph not|u6709|0.6|
🈯|Japanese “reserved” button|ideograph reserved|u6307|0.6|
🉐|Japanese “bargain” button|bargain ideograph|ideograph_advantage|0.6|
🈹|Japanese “discount” button|discount ideograph|u5272|0.6|
🈚|Japanese “free of charge” button|charge free ideograph|u7121|0.6|
🈲|Japanese “prohibited” button|ideograph prohibited|u7981|0.6|
🉑|Japanese “acceptable” button|acceptable ideograph|accept|0.6|
🈸|Japanese “application” button|application ideograph|u7533|0.6|
🈴|Japanese “passing grade” button|grade ideograph passing|u5408|0.6|
🈳|Japanese “vacancy” button|ideograph vacancy|u7a7a|0.6|
㊗️|Japanese “congratulations” button|congratulations ideograph|congratulations|0.6|
㊙️|Japanese “secret” button|ideograph secret|secret|0.6|
🈺|Japanese “open for business” button|business ideograph open|u55b6|0.6|
🈵|Japanese “no vacancy” button|ideograph no vacancy|u6e80|0.6|
🔴|red circle|geometric|red_circle|0.6|
🟠|orange circle||orange_circle|12|
🟡|yellow circle||yellow_circle|12|
🟢|green circle||green_circle|12|
🔵|blue circle|geometric|large_blue_circle|0.6|
🟣|purple circle||purple_circle|12|
🟤|brown circle||brown_circle|12|
⚫|black circle|geometric|black_circle|0.6|
⚪|white circle|geometric|white_circle|0.6|
🟥|red square|card penalty|red_square|12|
🟧|orange square||orange_square|12|
🟨|yellow square|card penalty|yellow_square|12|
🟩|green square||green_square|12|
🟦|blue square||blue_square|12|
🟪|purple square||purple_square|12|
🟫|brown square||brown_square|12|
⬛|black large square|geometric|black_large_square|0.6|
⬜|white large square|geometric|white_large_square|0.6|
◼️|black medium square|geometric|black_medium_square|0.6|
◻️|white medium square|geometric|white_medium_square|0.6|
◾|black medium-small square|geometric medium-small|black_medium_small_square|0.6|
◽|white medium-small square|geometric medium-small|white_medium_small_square|0.6|
▪️|black small square|geometric|black_small_square|0.6|
▫️|white small square|geometric|white_small_square|0.6|
🔶|large orange diamond|geometric|large_orange_diamond|0.6|
🔷|large blue diamond|geometric|large_blue_diamond|0.6|
🔸|small orange diamond|geometric|small_orange_diamond|0.6|
🔹|small blue diamond|geometric|small_blue_diamond|0.6|
🔺|red triangle pointed up|geometric|small_red_triangle|0.6|
🔻|red triangle pointed down|geometric|small_red_triangle_down|0.6|
💠|diamond with a dot|comic geometric|diamond_shape_with_a_dot_inside|0.6|
🔘|radio button|geometric|radio_button|0.6|
🔳|white square button|geometric outlined|white_square_button|0.6|
🔲|black square button|geometric|black_square_button|0.6|
#flags
🏁|chequered flag|checkered finish flags game race racing|checkered_flag|0.6|
🚩|triangular flag|construction golf post|triangular_flag_on_post|0.6|
🎌|crossed flags|japanese celebration cross|crossed_flags|0.6|
🏴|black flag|waving|black_flag|1|
🏳️|white flag|waving|white_flag|0.7|
🏳️‍🌈|rainbow flag|bisexual gay genderqueer glbt glbtq lesbian|rainbow_flag|4|
🏳️‍⚧️|transgender flag|blue light pink white|transgender_flag|13|
🏴‍☠️|pirate flag|jolly roger plunder treasure|pirate_flag|11|
🇦🇨|flag: Ascension Island|ac|ascension_island|2|
🇦🇩|flag: Andorra|ad|andorra|2|
🇦🇪|flag: United Arab Emirates|ae|united_arab_emirates|2|
🇦🇫|flag: Afghanistan|af|afghanistan|2|
🇦🇬|flag: Antigua & Barbuda|ag|antigua_barbuda|2|
🇦🇮|flag: Anguilla|ai|anguilla|2|
🇦🇱|flag: Albania|al|albania|2|
🇦🇲|flag: Armenia|am|armenia|2|
🇦🇴|flag: Angola|ao|angola|2|
🇦🇶|flag: Antarctica|aq|antarctica|2|
🇦🇷|flag: Argentina|ar|argentina|2|
🇦🇸|flag: American Samoa|as|american_samoa|2|
🇦🇹|flag: Austria|at|austria|2|
🇦🇺|flag: Australia|au|australia|2|
🇦🇼|flag: Aruba|aw|aruba|2|
🇦🇽|flag: Åland Islands|ax|aland_islands|2|
🇦🇿|flag: Azerbaijan|az|azerbaijan|2|
🇧🇦|flag: Bosnia & Herzegovina|ba|bosnia_herzegovina|2|
🇧🇧|flag: Barbados|bb|barbados|2|
🇧🇩|flag: Bangladesh|bd|bangladesh|2|
🇧🇪|flag: Belgium|be|belgium|2|
🇧🇫|flag: Burkina Faso|bf|burkina_faso|2|
🇧🇬|flag: Bulgaria|bg|bulgaria|2|
🇧🇭|flag: Bahrain|bh|bahrain|2|
🇧🇮|flag: Burundi|bi|burundi|2|
🇧🇯|flag: Benin|bj|benin|2|
🇧🇱|flag: St. Barthélemy|bl|st_barthelemy|2|
🇧🇲|flag: Bermuda|bm|bermuda|2|
🇧🇳|flag: Brunei|bn|brunei|2|
🇧🇴|flag: Bolivia|bo|bolivia|2|
🇧🇶|flag: Caribbean Netherlands|bq|caribbean_netherlands|2|
🇧🇷|flag: Brazil|br|brazil|2|
🇧🇸|flag: Bahamas|bs|bahamas|2|
🇧🇹|flag: Bhutan|bt|bhutan|2|
🇧🇻|flag: Bouvet Island|bv|bouvet_island|2|
🇧🇼|flag: Botswana|bw|botswana|2|
🇧🇾|flag: Belarus|by|belarus|2|
🇧🇿|flag: Belize|bz|belize|2|
🇨🇦|flag: Canada|ca|canada|2|
🇨🇨|flag: Cocos (Keeling) Islands|cc|cocos_islands|2|
🇨🇩|flag: Congo - Kinshasa|cd|congo_kinshasa|2|
🇨🇫|flag: Central African Republic|cf|central_african_republic|2|
🇨🇬|flag: Congo - Brazzaville|cg|congo_brazzaville|2|
🇨🇭|flag: Switzerland|ch|switzerland|2|
🇨🇮|flag: Côte d’Ivoire|ci|cote_divoire|2|
🇨🇰|flag: Cook Islands|ck|cook_islands|2|
🇨🇱|flag: Chile|cl|chile|2|
🇨🇲|flag: Cameroon|cm|cameroon|2|
🇨🇳|flag: China|cn|cn|0.6|
🇨🇴|flag: Colombia|co|colombia|2|
🇨🇵|flag: Clipperton Island|cp|clipperton_island|2|
🇨🇶|flag: Sark|cq||16|
🇨🇷|flag: Costa Rica|cr|costa_rica|2|
🇨🇺|flag: Cuba|cu|cuba|2|
🇨🇻|flag: Cape Verde|cv|cape_verde|2|
🇨🇼|flag: Curaçao|cw|curacao|2|
🇨🇽|flag: Christmas Island|cx|christmas_island|2|
🇨🇾|flag: Cyprus|cy|cyprus|2|
🇨🇿|flag: Czechia|cz|czech_republic|2|
🇩🇪|flag: Germany|de|de|0.6|
🇩🇬|flag: Diego Garcia|dg|diego_garcia|2|
🇩🇯|flag: Djibouti|dj|djibouti|2|
🇩🇰|flag: Denmark|dk|denmark|2|
🇩🇲|flag: Dominica|dm|dominica|2|
🇩🇴|flag: Dominican Republic|do|dominican_republic|2|
🇩🇿|flag: Algeria|dz|algeria|2|
🇪🇦|flag: Ceuta & Melilla|ea|ceuta_melilla|2|
🇪🇨|flag: Ecuador|ec|ecuador|2|
🇪🇪|flag: Estonia|ee|estonia|2|
🇪🇬|flag: Egypt|eg|egypt|2|
🇪🇭|flag: Western Sahara|eh|western_sahara|2|
🇪🇷|flag: Eritrea|er|eritrea|2|
🇪🇸|flag: Spain|es|es|0.6|
🇪🇹|flag: Ethiopia|et|ethiopia|2|
🇪🇺|flag: European Union|eu|eu european_union|2|
🇫🇮|flag: Finland|fi|finland|2|
🇫🇯|flag: Fiji|fj|fiji|2|
🇫🇰|flag: Falkland Islands|fk|falkland_islands|2|
🇫🇲|flag: Micronesia|fm|micronesia|2|
🇫🇴|flag: Faroe Islands|fo|faroe_islands|2|
🇫🇷|flag: France|fr|fr|0.6|
🇬🇦|flag: Gabon|ga|gabon|2|
🇬🇧|flag: United Kingdom|gb|gb uk|0.6|
🇬🇩|flag: Grenada|gd|grenada|2|
🇬🇪|flag: Georgia|ge|georgia|2|
🇬🇫|flag: French Guiana|gf|french_guiana|2|
🇬🇬|flag: Guernsey|gg|guernsey|2|
🇬🇭|flag: Ghana|gh|ghana|2|
🇬🇮|flag: Gibraltar|gi|gibraltar|2|
🇬🇱|flag: Greenland|gl|greenland|2|
🇬🇲|flag: Gambia|gm|gambia|2|
🇬🇳|flag: Guinea|gn|guinea|2|
🇬🇵|flag: Guadeloupe|gp|guadeloupe|2|
🇬🇶|flag: Equatorial Guinea|gq|equatorial_guinea|2|
🇬🇷|flag: Greece|gr|greece|2|
🇬🇸|flag: South Georgia & South Sandwich Islands|gs|south_georgia_south_sandwich_islands|2|
🇬🇹|flag: Guatemala|gt|guatemala|2|
🇬🇺|flag: Guam|gu|guam|2|
🇬🇼|flag: Guinea-Bissau|gw|guinea_bissau|2|
🇬🇾|flag: Guyana|gy|guyana|2|
🇭🇰|flag: Hong Kong SAR China|hk|hong_kong|2|
🇭🇲|flag: Heard Island & McDonald Islands|hm|heard_mcdonald_islands|2|
🇭🇳|flag: Honduras|hn|honduras|2|
🇭🇷|flag: Croatia|hr|croatia|2|
🇭🇹|flag: Haiti|ht|haiti|2|
🇭🇺|flag: Hungary|hu|hungary|2|
🇮🇨|flag: Canary Islands|ic|canary_islands|2|
🇮🇩|flag: Indonesia|id|indonesia|2|
🇮🇪|flag: Ireland|ie|ireland|2|
🇮🇱|flag: Israel|il|israel|2|
🇮🇲|flag: Isle of Man|im|isle_of_man|2|
🇮🇳|flag: India|in|india|2|
🇮🇴|flag: British Indian Ocean Territory|io|british_indian_ocean_territory|2|
🇮🇶|flag: Iraq|iq|iraq|2|
🇮🇷|flag: Iran|ir|iran|2|
🇮🇸|flag: Iceland|is|iceland|2|
🇮🇹|flag: Italy|it|it|0.6|
🇯🇪|flag: Jersey|je|jersey|2|
🇯🇲|flag: Jamaica|jm|jamaica|2|
🇯🇴|flag: Jordan|jo|jordan|2|
🇯🇵|flag: Japan|jp|jp|0.6|
🇰🇪|flag: Kenya|ke|kenya|2|
🇰🇬|flag: Kyrgyzstan|kg|kyrgyzstan|2|
🇰🇭|flag: Cambodia|kh|cambodia|2|
🇰🇮|flag: Kiribati|ki|kiribati|2|
🇰🇲|flag: Comoros|km|comoros|2|
🇰🇳|flag: St. Kitts & Nevis|kn|st_kitts_nevis|2|
🇰🇵|flag: North Korea|kp|north_korea|2|
🇰🇷|flag: South Korea|kr|kr|0.6|
🇰🇼|flag: Kuwait|kw|kuwait|2|
🇰🇾|flag: Cayman Islands|ky|cayman_islands|2|
🇰🇿|flag: Kazakhstan|kz|kazakhstan|2|
🇱🇦|flag: Laos|la|laos|2|
🇱🇧|flag: Lebanon|lb|lebanon|2|
🇱🇨|flag: St. Lucia|lc|st_lucia|2|
🇱🇮|flag: Liechtenstein|li|liechtenstein|2|
🇱🇰|flag: Sri Lanka|lk|sri_lanka|2|
🇱🇷|flag: Liberia|lr|liberia|2|
🇱🇸|flag: Lesotho|ls|lesotho|2|
🇱🇹|flag: Lithuania|lt|lithuania|2|
🇱🇺|flag: Luxembourg|lu|luxembourg|2|
🇱🇻|flag: Latvia|lv|latvia|2|
🇱🇾|flag: Libya|ly|libya|2|
🇲🇦|flag: Morocco|ma|morocco|2|
🇲🇨|flag: Monaco|mc|monaco|2|
🇲🇩|flag: Moldova|md|moldova|2|
🇲🇪|flag: Montenegro|me|montenegro|2|
🇲🇫|flag: St. Martin|mf|st_martin|2|
🇲🇬|flag: Madagascar|mg|madagascar|2|
🇲🇭|flag: Marshall Islands|mh|marshall_islands|2|
🇲🇰|flag: North Macedonia|mk|macedonia|2|
🇲🇱|flag: Mali|ml|mali|2|
🇲🇲|flag: Myanmar (Burma)|mm|myanmar|2|
🇲🇳|flag: Mongolia|mn|mongolia|2|
🇲🇴|flag: Macao SAR China|mo|macau|2|
🇲🇵|flag: Northern Mariana Islands|mp|northern_mariana_islands|2|
🇲🇶|flag: Martinique|mq|martinique|2|
🇲🇷|flag: Mauritania|mr|mauritania|2|
🇲🇸|flag: Montserrat|ms|montserrat|2|
🇲🇹|flag: Malta|mt|malta|2|
🇲🇺|flag: Mauritius|mu|mauritius|2|
🇲🇻|flag: Maldives|mv|maldives|2|
🇲🇼|flag: Malawi|mw|malawi|2|
🇲🇽|flag: Mexico|mx|mexico|2|
🇲🇾|flag: Malaysia|my|malaysia|2|
🇲🇿|flag: Mozambique|mz|mozambique|2|
🇳🇦|flag: Namibia|na|namibia|2|
🇳🇨|flag: New Caledonia|nc|new_caledonia|2|
🇳🇪|flag: Niger|ne|niger|2|
🇳🇫|flag: Norfolk Island|nf|norfolk_island|2|
🇳🇬|flag: Nigeria|ng|nigeria|2|
🇳🇮|flag: Nicaragua|ni|nicaragua|2|
🇳🇱|flag: Netherlands|nl|netherlands|2|
🇳🇴|flag: Norway|no|norway|2|
🇳🇵|flag: Nepal|np|nepal|2|
🇳🇷|flag: Nauru|nr|nauru|2|
🇳🇺|flag: Niue|nu|niue|2|
🇳🇿|flag: New Zealand|nz|new_zealand|2|
🇴🇲|flag: Oman|om|oman|2|
🇵🇦|flag: Panama|pa|panama|2|
🇵🇪|flag: Peru|pe|peru|2|
🇵🇫|flag: French Polynesia|pf|french_polynesia|2|
🇵🇬|flag: Papua New Guinea|pg|papua_new_guinea|2|
🇵🇭|flag: Philippines|ph|philippines|2|
🇵🇰|flag: Pakistan|pk|pakistan|2|
🇵🇱|flag: Poland|pl|poland|2|
🇵🇲|flag: St. Pierre & Miquelon|pm|st_pierre_miquelon|2|
🇵🇳|flag: Pitcairn Islands|pn|pitcairn_islands|2|
🇵🇷|flag: Puerto Rico|pr|puerto_rico|2|
🇵🇸|flag: Palestinian Territories|ps|palestinian_territories|2|
🇵🇹|flag: Portugal|pt|portugal|2|
🇵🇼|flag: Palau|pw|palau|2|
🇵🇾|flag: Paraguay|py|paraguay|2|
🇶🇦|flag: Qatar|qa|qatar|2|
🇷🇪|flag: Réunion|re|reunion|2|
🇷🇴|flag: Romania|ro|romania|2|
🇷🇸|flag: Serbia|rs|serbia|2|
🇷🇺|flag: Russia|ru|ru|0.6|
🇷🇼|flag: Rwanda|rw|rwanda|2|
🇸🇦|flag: Saudi Arabia|sa|saudi_arabia|2|
🇸🇧|flag: Solomon Islands|sb|solomon_islands|2|
🇸🇨|flag: Seychelles|sc|seychelles|2|
🇸🇩|flag: Sudan|sd|sudan|2|
🇸🇪|flag: Sweden|se|sweden|2|
🇸🇬|flag: Singapore|sg|singapore|2|
🇸🇭|flag: St. Helena, Ascension & Tristan da Cunha|sh|st_helena|2|
🇸🇮|flag: Slovenia|si|slovenia|2|
🇸🇯|flag: Svalbard & Jan Mayen|sj|svalbard_jan_mayen|2|
🇸🇰|flag: Slovakia|sk|slovakia|2|
🇸🇱|flag: Sierra Leone|sl|sierra_leone|2|
🇸🇲|flag: San Marino|sm|san_marino|2|
🇸🇳|flag: Senegal|sn|senegal|2|
🇸🇴|flag: Somalia|so|somalia|2|
🇸🇷|flag: Suriname|sr|suriname|2|
🇸🇸|flag: South Sudan|ss|south_sudan|2|
🇸🇹|flag: São Tomé & Príncipe|st|sao_tome_principe|2|
🇸🇻|flag: El Salvador|sv|el_salvador|2|
🇸🇽|flag: Sint Maarten|sx|sint_maarten|2|
🇸🇾|flag: Syria|sy|syria|2|
🇸🇿|flag: Eswatini|sz|swaziland|2|
🇹🇦|flag: Tristan da Cunha|ta|tristan_da_cunha|2|
🇹🇨|flag: Turks & Caicos Islands|tc|turks_caicos_islands|2|
🇹🇩|flag: Chad|td|chad|2|
🇹🇫|flag: French Southern and Antarctic Lands|tf|french_southern_territories|2|
🇹🇬|flag: Togo|tg|togo|2|
🇹🇭|flag: Thailand|th|thailand|2|
🇹🇯|flag: Tajikistan|tj|tajikistan|2|
🇹🇰|flag: Tokelau|tk|tokelau|2|
🇹🇱|flag: Timor-Leste|tl|timor_leste|2|
🇹🇲|flag: Turkmenistan|tm|turkmenistan|2|
🇹🇳|flag: Tunisia|tn|tunisia|2|
🇹🇴|flag: Tonga|to|tonga|2|
🇹🇷|flag: Türkiye|tr|tr|2|
🇹🇹|flag: Trinidad & Tobago|tt|trinidad_tobago|2|
🇹🇻|flag: Tuvalu|tv|tuvalu|2|
🇹🇼|flag: Taiwan|tw|taiwan|2|
🇹🇿|flag: Tanzania|tz|tanzania|2|
🇺🇦|flag: Ukraine|ua|ukraine|2|
🇺🇬|flag: Uganda|ug|uganda|2|
🇺🇲|flag: U.S. Outlying Islands|um|us_outlying_islands|2|
🇺🇳|flag: United Nations|un|united_nations|4|
🇺🇸|flag: United States|us|us|0.6|
🇺🇾|flag: Uruguay|uy|uruguay|2|
🇺🇿|flag: Uzbekistan|uz|uzbekistan|2|
🇻🇦|flag: Vatican City|va|vatican_city|2|
🇻🇨|flag: St. Vincent & Grenadines|vc|st_vincent_grenadines|2|
🇻🇪|flag: Venezuela|ve|venezuela|2|
🇻🇬|flag: British Virgin Islands|vg|british_virgin_islands|2|
🇻🇮|flag: U.S. Virgin Islands|vi|us_virgin_islands|2|
🇻🇳|flag: Vietnam|vn|vietnam|2|
🇻🇺|flag: Vanuatu|vu|vanuatu|2|
🇼🇫|flag: Wallis & Futuna|wf|wallis_futuna|2|
🇼🇸|flag: Samoa|ws|samoa|2|
🇽🇰|flag: Kosovo|xk|kosovo|2|
🇾🇪|flag: Yemen|ye|yemen|2|
🇾🇹|flag: Mayotte|yt|mayotte|2|
🇿🇦|flag: South Africa|za|south_africa|2|
🇿🇲|flag: Zambia|zm|zambia|2|
🇿🇼|flag: Zimbabwe|zw|zimbabwe|2|
🏴󠁧󠁢󠁥󠁮󠁧󠁿|flag: England|gbeng|england|5|
🏴󠁧󠁢󠁳󠁣󠁴󠁿|flag: Scotland|gbsct|scotland|5|
🏴󠁧󠁢󠁷󠁬󠁳󠁿|flag: Wales|gbwls|wales|5|`, yie = ["👍", "❤️", "😂", "🎉", "🔥", "👀", "✅", "🙏"], x_ = ["✋", "✋🏻", "✋🏼", "✋🏽", "✋🏾", "✋🏿"];
let Th = null;
function or(n) {
  return n.replace(/️/g, "");
}
function ym() {
  if (Th) return Th;
  const n = [], e = [], t = /* @__PURE__ */ new Map(), i = new Map(bie.map((o) => [o.key, o.label]));
  let s = null;
  for (const o of vie.split(`
`)) {
    if (o.charAt(0) === "#" && o.indexOf("|") < 0) {
      const p = o.slice(1);
      s = { key: p, label: i.get(p) || p, emoji: [] }, n.push(s);
      continue;
    }
    if (!s) continue;
    const [r, a, l, d, c, h] = o.split("|"), f = { c: r, n: a, k: (a + " " + l).toLowerCase(), s: d ? d.split(" ") : [], v: Number(c) || 0, skins: h ? h.split(" ") : null, g: s.key };
    if (s.emoji.push(f), e.push(f), t.set(or(r), f), f.skins) for (const p of f.skins) t.set(or(p), f);
  }
  return Th = { groups: n, all: e, byBase: t }, Th;
}
const w_ = "rd-board-emoji-version";
let Ch = null;
function oI() {
  if (Ch != null) return Ch;
  if (typeof document == "undefined" || /jsdom/i.test(navigator.userAgent)) return 1 / 0;
  try {
    const e = JSON.parse(localStorage.getItem(w_) || "null");
    if (e && e.ua === navigator.userAgent && typeof e.v == "number") return Ch = e.v;
  } catch {
  }
  const n = Ch = xie();
  try {
    localStorage.setItem(w_, JSON.stringify({ ua: navigator.userAgent, v: n }));
  } catch {
  }
  return n;
}
function xie() {
  const n = document.createElement("canvas");
  n.width = n.height = 32;
  const e = n.getContext("2d", { willReadFrequently: !0 });
  if (!e) return 1 / 0;
  e.font = '24px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif', e.textBaseline = "top";
  const t = e.measureText("😀").width;
  if (!t) return 1 / 0;
  const i = /* @__PURE__ */ new Map();
  for (const o of ym().all) o.v > 12 && !i.has(o.v) && i.set(o.v, o.c);
  let s = 12;
  for (const o of Array.from(i.keys()).sort((r, a) => r - a)) {
    if (!wie(e, i.get(o), t)) break;
    s = o;
  }
  return s;
}
function wie(n, e, t) {
  if (n.measureText(e).width > t * 1.5) return !1;
  n.clearRect(0, 0, 32, 32), n.fillText(e, 0, 0);
  const i = n.getImageData(0, 0, 32, 32).data;
  for (let s = 0; s < i.length; s += 4) {
    if (i[s + 3] < 128) continue;
    const o = i[s], r = i[s + 1], a = i[s + 2];
    if (Math.max(o, r, a) - Math.min(o, r, a) > 40) return !0;
  }
  return !1;
}
function kie() {
  const n = oI();
  return ym().groups.map((e) => ({ ...e, emoji: e.emoji.filter((t) => t.v <= n) }));
}
function Jy(n) {
  return ym().byBase.get(or(n)) || null;
}
function ll(n, e) {
  return e && n.skins ? n.skins[e - 1] : n.c;
}
function rI(n, e = 120) {
  const t = n.toLowerCase().replace(/^:+|:+$/g, "").trim();
  if (!t) return [];
  const i = t.split(/\s+/), s = oI(), o = [];
  for (const r of ym().all) {
    if (r.v > s) continue;
    let a = 0, l = !0;
    for (const d of i) {
      const c = _ie(r, d);
      if (!c) {
        l = !1;
        break;
      }
      a += c;
    }
    l && o.push({ e: r, score: a });
  }
  return o.sort((r, a) => a.score - r.score), o.slice(0, e).map((r) => r.e);
}
function _ie(n, e) {
  if (n.s.some((a) => a === e)) return 100;
  const t = n.n.toLowerCase();
  if (t === e) return 90;
  const i = (a) => e.length / Math.max(e.length, a.length), s = n.s.find((a) => a.startsWith(e));
  if (s) return 60 + 20 * i(s);
  if (t.startsWith(e)) return 50 + 20 * i(t);
  const o = t.split(/[\s:,-]+/).find((a) => a.startsWith(e));
  if (o) return 40 + 10 * i(o);
  const r = n.k.split(" ").find((a) => a.startsWith(e));
  return r ? 25 + 10 * i(r) : n.k.includes(e) ? 8 : 0;
}
const Zy = "rd-board-emoji-recent", aI = "rd-board-emoji-tone", lI = 24;
function _0() {
  try {
    const n = JSON.parse(localStorage.getItem(Zy) || "[]");
    return Array.isArray(n) ? n.filter((e) => typeof e == "string").slice(0, lI) : [];
  } catch {
    return [];
  }
}
function Pf(n) {
  const e = [n, ..._0().filter((t) => or(t) !== or(n))].slice(0, lI);
  try {
    localStorage.setItem(Zy, JSON.stringify(e));
  } catch {
  }
}
function Sie() {
  try {
    localStorage.removeItem(Zy);
  } catch {
  }
}
function S0() {
  try {
    const n = Number(localStorage.getItem(aI));
    return n >= 0 && n <= 5 ? n : 0;
  } catch {
    return 0;
  }
}
function Mie(n) {
  try {
    localStorage.setItem(aI, String(n));
  } catch {
  }
}
function Tie(n) {
  return Array.from(or(n)).map((e) => e.codePointAt(0).toString(16)).join("-");
}
function Cie(n) {
  const e = n.split("-").map((i) => String.fromCodePoint(parseInt(i, 16) || 63)).join(""), t = Jy(e);
  return t ? or(t.c) === e ? t.c : (t.skins || []).find((i) => or(i) === e) || e : e;
}
function Iie(n) {
  const e = n.trim();
  if (!e || e.length > 40) return !1;
  const i = (typeof Intl != "undefined" && "Segmenter" in Intl ? Array.from(new Intl.Segmenter(void 0, { granularity: "grapheme" }).segment(e)).map((s) => s.segment) : Array.from(e)).filter((s) => s.trim());
  return i.length > 0 && i.length <= 3 && i.every((s) => !!Jy(s) || /[\u{1F000}-\u{1FAFF}]/u.test(s));
}
const Aie = 280, ab = 5e3;
function Ih(n, e, t, i = 0) {
  return n.markedUnread.includes(t) ? !0 : M0(n, e, t, i) > 0;
}
function M0(n, e, t, i = 0) {
  const s = Math.max(n.readBy[t] || 0, i);
  let o = 0;
  for (const r of e) r.authorId !== t && r.createdAt > s && o++;
  return o;
}
function gs(n, e) {
  return n.markedUnread.includes(e) ? !0 : n.lastBy !== e && n.lastAt > (n.readBy[e] || 0);
}
function Pie(n, e) {
  return n.some((t) => t.mentions.some((i) => i.uid === e));
}
function k_(n, e, t) {
  return n.createdBy === t || e.some((i) => i.authorId === t);
}
function __(n, e) {
  if (e && n.elementId && e.id === n.elementId) {
    const t = He(e);
    return { x: t.x + Ef(n.ex) * t.w, y: t.y + Ef(n.ey) * t.h };
  }
  return { x: n.x, y: n.y };
}
function Ef(n) {
  return Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : 0;
}
function lb(n, e, t) {
  if (!t || t.type === "studio") return { x: n, y: e, elementId: null, ex: 0, ey: 0, label: "", thumb: null };
  const i = He(t);
  return {
    x: n,
    y: e,
    elementId: t.id,
    ex: i.w ? Ef((n - i.x) / i.w) : 0,
    ey: i.h ? Ef((e - i.y) / i.h) : 0,
    label: Eie(t),
    thumb: t.type === "image" ? t.src || null : t.type === "tool" && (t.thumbs || [])[0] || null
  };
}
function Eie(n) {
  switch (n.type) {
    case "image": {
      const e = n;
      return nl(e.label || (e.video ? "Video" : "Image"), 80);
    }
    case "note":
      return nl(n.text.replace(/\s+/g, " ").trim() || "Note", 80);
    case "tool":
      return nl(n.name || "Session", 80);
    case "frame":
      return nl(n.title || "Frame", 80);
    case "shape":
      return "Shape";
    case "chat":
      return nl(n.name || "Chat", 80);
    default:
      return "";
  }
}
function Rie(n) {
  return n ? n.type === "image" ? n.video ? "video" : "image" : n.type === "studio" ? "canvas" : n.type : "canvas";
}
const S_ = /\b(?:https?:\/\/|www\.)[^\s<>"']+[^\s<>"'.,;:!?)\]}]/gi;
function zie(n, e, t) {
  const i = [], s = (d, c) => i.some((h) => d < h.end && c > h.start), o = e.slice().sort((d, c) => c.name.length - d.name.length);
  for (const d of o) {
    if (!d.name) continue;
    const c = "@" + d.name;
    let h = n.indexOf(c);
    for (; h !== -1; ) {
      const f = h + c.length;
      s(h, f) || i.push({ start: h, end: f, part: { kind: "mention", text: c, uid: d.uid, me: d.uid === t } }), h = n.indexOf(c, f);
    }
  }
  S_.lastIndex = 0;
  let r;
  for (; r = S_.exec(n); ) {
    const d = r.index, c = d + r[0].length;
    if (s(d, c)) continue;
    const h = /^https?:/i.test(r[0]) ? r[0] : "https://" + r[0];
    i.push({ start: d, end: c, part: { kind: "link", text: r[0], href: h } });
  }
  i.sort((d, c) => d.start - c.start);
  const a = [];
  let l = 0;
  for (const d of i)
    d.start > l && a.push({ kind: "text", text: n.slice(l, d.start) }), a.push(d.part), l = d.end;
  return l < n.length && a.push({ kind: "text", text: n.slice(l) }), a;
}
const dI = 50;
function db(n, e) {
  const t = /* @__PURE__ */ new Set(), i = [];
  for (const s of e) {
    if (i.length >= dI) break;
    t.has(s.uid) || !s.name || !n.includes("@" + s.name) || (t.add(s.uid), i.push({ uid: s.uid, name: s.name }));
  }
  return i;
}
function $ie(n, e) {
  const t = n.slice(0, e), i = t.lastIndexOf("@");
  if (i === -1 || i > 0 && /[\w.]/.test(t.charAt(i - 1))) return null;
  const s = t.slice(i + 1);
  return s.length > 30 || /[\n@]/.test(s) || /\s{2}/.test(s) ? null : { start: i, query: s };
}
function Die(n, e) {
  const t = /(^|[\s(])(:[a-z0-9_+-]{2,30})$/i.exec(n.slice(0, e));
  return t ? { start: e - t[2].length, query: t[2].slice(1) } : null;
}
function nl(n, e) {
  const t = String(n || "");
  return t.length > e ? t.slice(0, e - 1).trimEnd() + "…" : t;
}
function zp(n) {
  return { by: n.authorId, byName: n.authorName, text: nl(n.text.replace(/\s+/g, " ").trim(), Aie) };
}
function Oie(n, e) {
  const t = /* @__PURE__ */ new Map();
  let i = 0;
  const s = /* @__PURE__ */ new Map();
  for (const [o, r] of Object.entries(n.reactions || {}))
    if (Array.isArray(r))
      for (const a of r) {
        let l = t.get(a);
        l || (l = { key: a, emoji: Cie(a), count: 0, mine: !1, who: [] }, t.set(a, l), s.set(a, i++)), !l.who.includes(o) && (l.who.push(o), l.count++, o === e && (l.mine = !0));
      }
  return Array.from(t.values()).sort((o, r) => r.count - o.count || s.get(o.key) - s.get(r.key));
}
function _c(n) {
  const t = String(n || "").split("@")[0].split("+")[0].split(/[._-]+/).filter(Boolean);
  return t.length ? t.map((i) => i.charAt(0).toUpperCase() + i.slice(1)).join(" ") : n || "Someone";
}
function Lie(n, e, t) {
  const i = e.trim().toLowerCase(), s = n.map((o, r) => {
    const a = o.name.toLowerCase(), l = o.email.toLowerCase();
    let d = 0;
    return i ? a.startsWith(i) ? d = 4 : a.split(/\s+/).some((c) => c.startsWith(i)) ? d = 3 : l.startsWith(i) ? d = 2 : (a.includes(i) || l.includes(i)) && (d = 1) : d = 1, { p: o, i: r, score: d && (o.uid === t ? d - 0.5 : d) };
  }).filter((o) => o.score > 0);
  return s.sort((o, r) => r.score - o.score || o.i - r.i), s.map((o) => o.p);
}
const M_ = [
  ["#9968df", "#5a61ed"],
  ["#c750ce", "#9968df"],
  ["#3db4e6", "#5a61ed"],
  ["#34c79a", "#2a8fd6"],
  ["#f2a93b", "#ef5f7a"],
  ["#ef5f7a", "#c750ce"],
  ["#7a86ff", "#3db4e6"],
  ["#5fd0b5", "#9968df"]
];
function Bie(n) {
  let e = 0;
  for (let t = 0; t < n.length; t++) e = e * 31 + n.charCodeAt(t) | 0;
  return M_[Math.abs(e) % M_.length];
}
function Fie(n, e, t) {
  const i = t.toLowerCase().split(/\s+/).filter(Boolean);
  if (!i.length) return !0;
  const s = [n.anchorLabel, n.createdByName, ...e.map((o) => o.authorName + " " + o.text)].join(" ").toLowerCase();
  return i.every((o) => s.includes(o));
}
var Nie = Object.defineProperty, Uie = (n, e, t) => e in n ? Nie(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ot = (n, e, t) => Uie(n, typeof e != "symbol" ? e + "" : e, t);
const cI = "rd-board-comments", Gie = 6500;
function jie() {
  try {
    const n = JSON.parse(localStorage.getItem(cI) || "{}");
    return { showPins: n.showPins !== !1, showResolved: n.showResolved === !0, elsewhereUnread: n.elsewhereUnread !== !1 };
  } catch {
    return { showPins: !0, showResolved: !1, elsewhereUnread: !0 };
  }
}
class Hie {
  constructor(e, t) {
    Ot(this, "board", e), Ot(this, "opts", t), Ot(this, "ui"), Ot(this, "rev", /* @__PURE__ */ qe(0)), Ot(this, "loaded", /* @__PURE__ */ qe(!1)), Ot(this, "failed", /* @__PURE__ */ qe(!1)), Ot(this, "people", /* @__PURE__ */ qe({ people: [], scope: "personal" })), Ot(this, "followed", /* @__PURE__ */ qe([])), Ot(this, "titles", /* @__PURE__ */ qe({})), Ot(this, "enabled"), Ot(this, "pins"), Ot(this, "feed"), Ot(this, "unreadCount"), Ot(this, "elsewhere"), Ot(this, "elsewhereUnread"), Ot(this, "openCards"), Ot(this, "threads", /* @__PURE__ */ new Map()), Ot(this, "comments", /* @__PURE__ */ new Map()), Ot(this, "byThread", /* @__PURE__ */ new Map()), Ot(this, "hidden", /* @__PURE__ */ qe(/* @__PURE__ */ new Set())), Ot(this, "pending", /* @__PURE__ */ new Map()), Ot(this, "since", 0), Ot(this, "initial"), Ot(this, "unsubs", []), Ot(this, "readTimer", 0), Ot(this, "goneFor", /* @__PURE__ */ new Set()), Ot(this, "marked", /* @__PURE__ */ new Set()), Ot(this, "disposed", !1), Ot(this, "store"), this.store = t.store, this.enabled = !!t.store, this.initial = t.initial || null;
    const i = jie();
    this.ui = /* @__PURE__ */ Xt({
      armed: !1,
      draft: null,
      openId: null,
      panelOpen: !1,
      tab: "board",
      filter: "all",
      query: "",
      showPins: i.showPins,
      showResolved: i.showResolved,
      elsewhereUnread: i.elsewhereUnread,
      flash: null,
      editingId: null,
      dragging: null,
      confirmDelete: null
    }), Ee(() => [this.ui.showPins, this.ui.showResolved, this.ui.elsewhereUnread], () => {
      try {
        localStorage.setItem(cI, JSON.stringify({ showPins: this.ui.showPins, showResolved: this.ui.showResolved, elsewhereUnread: this.ui.elsewhereUnread }));
      } catch {
      }
    }), Ee(() => this.ui.armed, (s) => {
      s && (e.ui.shapeArmed = !1, e.ui.eyedropper = null, e.ui.mode = "select");
    }), Ee(() => e.ui.shapeArmed || e.ui.mode === "hand" || !!e.ui.eyedropper, (s) => {
      s && (this.ui.armed = !1);
    }), Ee(() => [this.ui.openId, this.rev.value], () => this.readOpenSoon()), Ee(() => this.ui.panelOpen, (s) => {
      s && (e.ui.boardHistory = !1);
    }), Ee(() => e.ui.boardHistory, (s) => {
      s && (this.ui.panelOpen = !1);
    }), this.pins = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.ui.openId === a.id;
        if (a.resolvedAt && !this.ui.showResolved && !l) continue;
        const c = (this.ui.dragging && this.ui.dragging.id === a.id ? this.ui.dragging : null) || __(a, a.elementId ? e.store.get(a.elementId) : null), h = this.commentsOf(a.id);
        r.push({ t: a, x: c.x, y: c.y, unread: !a.resolvedAt && Ih(a, h, o, this.since), count: h.length });
      }
      return r.sort((a, l) => a.t.lastAt - l.t.lastAt), r;
    }), this.feed = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.commentsOf(a.id), d = Ih(a, l, o, this.since), c = {
          t: a,
          first: l[0] || null,
          last: l[l.length - 1] || null,
          replies: Math.max(0, l.length - 1),
          fresh: M0(a, l, o, this.since),
          unread: d,
          pinned: a.pinnedBy.includes(o),
          mentionsMe: Pie(l, o)
        };
        a.resolvedAt && !this.ui.showResolved || this.ui.filter === "unread" && !d || this.ui.filter === "mentions" && !c.mentionsMe && !(k_(a, l, o) && c.fresh) || this.ui.filter === "mine" && !k_(a, l, o) || this.ui.query && !Fie(a, l, this.ui.query) || r.push(c);
      }
      return r.sort((a, l) => Number(l.pinned) - Number(a.pinned) || l.t.lastAt - a.t.lastAt), r;
    }), this.unreadCount = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid;
      let r = 0;
      for (const a of this.threads.values())
        s.has(a.id) || a.resolvedAt || this.gone(a) || Ih(a, this.commentsOf(a.id), o, this.since) && r++;
      return r;
    }), this.elsewhere = I(() => {
      const s = e.user.uid, o = this.titles.value, r = /* @__PURE__ */ new Map();
      for (const a of this.followed.value) {
        if (a.boardId === e.meta.id || o[a.boardId] === null || a.deletedAt || this.ui.elsewhereUnread && !gs(a, s)) continue;
        let l = r.get(a.boardId);
        l || (l = { boardId: a.boardId, title: o[a.boardId] || a.boardTitle || "Untitled board", items: [] }, r.set(a.boardId, l)), l.items.push(a);
      }
      return Array.from(r.values());
    }), this.elsewhereUnread = I(() => {
      const s = e.user.uid, o = this.titles.value;
      return this.followed.value.filter((r) => r.boardId !== e.meta.id && o[r.boardId] !== null && !r.deletedAt && gs(r, s)).length;
    }), this.openCards = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.ui.openId === a.id;
        !l && (!this.ui.showPins || a.resolvedAt && !this.ui.showResolved) || (l || a.pinnedBy.includes(o)) && r.push(a);
      }
      return r;
    });
  }
  // ---------------------------------------------------------------- loading
  /** Start listening, once the board has loaded (its title and team are known). */
  start() {
    const e = this.store;
    !e || this.disposed || (this.unsubs.push(e.watchBoard({
      threads: (t, i) => {
        for (const s of t) this.threads.set(s.id, s);
        this.markGone(t);
        for (const s of i)
          this.threads.delete(s), this.ui.openId === s && (this.ui.openId = null);
        this.bump(), this.loaded.value || (this.loaded.value = !0, this.openInitial());
      },
      comments: (t, i) => {
        const s = /* @__PURE__ */ new Set();
        for (const o of t) {
          const r = this.comments.get(o.id);
          r && r.threadId !== o.threadId && s.add(r.threadId), this.comments.set(o.id, o), s.add(o.threadId);
        }
        for (const o of i) {
          const r = this.comments.get(o);
          r && s.add(r.threadId), this.comments.delete(o), this.ui.editingId === o && (this.ui.editingId = null);
        }
        for (const o of s) this.reindex(o);
        this.bump();
      },
      error: (t) => {
        console.warn("[board] comments are unavailable", t), this.failed.value = !0, this.loaded.value = !0;
      }
    })), this.unsubs.push(e.watchFollowed((t) => {
      this.followed.value = t, this.fetchTitles(t);
    }, (t) => console.warn("[board] comments on other boards are unavailable", t))), e.checkIn().then((t) => {
      t && !this.disposed && (this.since = t, this.bump());
    }).catch((t) => console.warn("[board] comments: could not check in", t)), this.refreshPeople(), window.setTimeout(() => {
      !this.loaded.value && !this.disposed && (this.loaded.value = !0, this.openInitial());
    }, 4e3));
  }
  refreshPeople() {
    this.store && this.store.people().then((e) => {
      if (this.disposed) return;
      const t = /* @__PURE__ */ new Map();
      for (const s of this.comments.values()) t.set(s.authorId, s.authorName);
      const i = e.people.map((s) => ({ ...s, name: t.get(s.uid) || s.name || _c(s.email) }));
      this.people.value = { ...e, people: i };
    }).catch((e) => console.warn("[board] comments: who can be mentioned is unknown", e));
  }
  fetchTitles(e) {
    if (!this.store) return;
    const t = this.titles.value, i = Array.from(new Set(e.map((s) => s.boardId))).filter((s) => s !== this.board.meta.id && !(s in t));
    i.length && this.store.boardTitles(i).then((s) => {
      this.disposed || (this.titles.value = { ...this.titles.value, ...s });
    }).catch(() => {
    });
  }
  openInitial() {
    const e = this.initial;
    e && (this.initial = null, window.setTimeout(() => {
      this.disposed || (this.threads.has(e) ? this.focus(e) : this.board.toast("That comment was deleted, or it's on a board you can't open.", "error"), this.opts.onShown && this.opts.onShown());
    }, 350));
  }
  reindex(e) {
    const t = [];
    for (const i of this.comments.values()) i.threadId === e && t.push(i);
    t.sort((i, s) => i.createdAt - s.createdAt || (i.id < s.id ? -1 : 1)), t.length ? this.byThread.set(e, t) : this.byThread.delete(e);
  }
  bump() {
    this.rev.value++;
  }
  // ---------------------------------------------------------------- reading
  /** Your name as your comments carry it (an account without one goes by its email's). */
  get myName() {
    const e = this.board.user;
    return e.name || _c(e.email);
  }
  thread(e) {
    return this.rev.value, e && !this.hidden.value.has(e) && this.threads.get(e) || null;
  }
  /** A thread's comments, oldest first, less any deleted here and waiting out their Undo. */
  commentsOf(e) {
    this.rev.value;
    const t = this.byThread.get(e) || [], i = this.hidden.value;
    return i.size ? t.filter((s) => !i.has(s.id)) : t;
  }
  allThreads() {
    this.rev.value;
    const e = this.hidden.value;
    return Array.from(this.threads.values()).filter((t) => !e.has(t.id) && !t.deletedAt);
  }
  isUnread(e) {
    return Ih(e, this.commentsOf(e.id), this.board.user.uid, this.since);
  }
  /** A comment that's news to you: someone else's, since you last read its thread (and since you first opened the board). */
  isFresh(e, t) {
    const i = this.board.user.uid;
    return t.authorId !== i && t.createdAt > Math.max(e.readBy[i] || 0, e.boardId === this.board.meta.id ? this.since : 0);
  }
  /** A thread on another board, read whole (Everywhere else's expanded card). */
  commentsElsewhere(e) {
    return this.store ? this.store.threadComments(e.boardId, e.id) : Promise.resolve([]);
  }
  freshIn(e) {
    return M0(e, this.commentsOf(e.id), this.board.user.uid, this.since);
  }
  following(e) {
    return e.followers.includes(this.board.user.uid);
  }
  pinned(e) {
    return e.pinnedBy.includes(this.board.user.uid);
  }
  /** You may delete it: you started it, or it's your board. */
  canDelete(e) {
    const t = this.board.user.uid;
    return e.createdBy === t || this.board.meta.ownerId === t;
  }
  /** You may delete this comment: it's yours, or the thread or the board is. */
  canDeleteComment(e) {
    const t = this.board.user.uid, i = this.threads.get(e.threadId);
    return e.authorId === t || !!i && i.createdBy === t || this.board.meta.ownerId === t;
  }
  /** Where a thread's pin is now (world). */
  pointOf(e) {
    this.board.docRev.value;
    const t = this.ui.dragging;
    return t && t.id === e.id ? { x: t.x, y: t.y } : __(e, e.elementId ? this.board.store.get(e.elementId) : null);
  }
  /** The element a thread is on, while it's on the board. */
  elementOf(e) {
    return this.board.docRev.value, e.elementId && this.board.store.get(e.elementId) || null;
  }
  /** People who can be mentioned, with anyone who has commented here. */
  mentionable() {
    this.rev.value;
    const e = this.people.value.people.slice(), t = new Set(e.map((i) => i.uid));
    for (const i of this.comments.values())
      t.has(i.authorId) || (t.add(i.authorId), e.push({ uid: i.authorId, name: i.authorName, email: i.authorEmail }));
    return e;
  }
  // ---------------------------------------------------------------- the tool
  arm(e = !this.ui.armed) {
    this.ui.armed = e, e && (this.board.ui.selection = [], this.ui.showPins || (this.ui.showPins = !0));
  }
  /** The topmost element at a world point, notes and sessions first (they sit over the canvas). */
  elementAt(e, t) {
    const i = 2 / Math.max(0.01, this.board.cam.value.zoom);
    let s = null, o = -1 / 0;
    const r = { frames: 1, content: 2, annotations: 3 };
    for (const a of this.board.store.index.queryPoint(e, t, i)) {
      const l = this.board.store.get(a);
      if (!l || l.type === "studio") continue;
      const d = He(l);
      if (e < d.x - i || t < d.y - i || e > d.x + d.w + i || t > d.y + d.h + i) continue;
      const c = (l.type === "note" || l.type === "tool" ? 4 : r[Iv[l.type]]) * 1e9 + l.z;
      c > o && (o = c, s = l);
    }
    return s;
  }
  /** The Comment tool's click: a draft thread there (a draft with words in it stays, and nods). */
  placeAt(e, t) {
    this.startAt(this.board.screenToWorld(e, t));
  }
  /** A draft at a point on the board (the canvas menu's Comment, CHAT-01): on what's under it, if anything. */
  startAt(e) {
    const t = this.ui.draft;
    if (t && t.text.trim()) {
      t.n++;
      return;
    }
    this.ui.openId = null, this.ui.draft = { anchor: lb(e.x, e.y, this.elementAt(e.x, e.y)), text: "", mentions: [], n: 0 };
  }
  /** A draft on an element, from its toolbar: at its top right corner. */
  draftOn(e) {
    const t = He(e);
    this.ui.armed = !1, this.ui.openId = null, this.ui.draft = { anchor: lb(t.x + t.w, t.y, e), text: "", mentions: [], n: 0 };
    const i = this.board.cam.value.zoom, s = this.board.view, o = this.board.worldToClient(t.x + t.w, t.y);
    (o.x < s.left + 40 || o.y < s.top + 30 || o.x > s.left + s.w - 380 || o.y > s.top + s.h - 220) && this.board.jumpTo(t.x + t.w + 170 / i, t.y + 90 / i);
  }
  cancelDraft() {
    this.ui.draft = null;
  }
  /** Post the draft as a new thread. */
  async post(e, t) {
    const i = this.ui.draft, s = this.store, o = e.trim().slice(0, ab);
    if (!i || !s || !o) return !1;
    const r = this.board, a = r.user, l = db(o, t), d = wt(), c = Date.now(), h = {
      id: wt(),
      threadId: d,
      boardId: r.meta.id,
      authorId: a.uid,
      authorName: this.myName,
      authorEmail: a.email,
      text: o,
      mentions: l,
      createdAt: c,
      editedAt: null,
      reactions: {}
    }, f = i.anchor, p = {
      id: d,
      boardId: r.meta.id,
      teamId: r.meta.teamId || null,
      createdBy: a.uid,
      createdByName: h.authorName,
      createdByEmail: a.email,
      createdAt: c,
      x: f.x,
      y: f.y,
      elementId: f.elementId,
      ex: f.ex,
      ey: f.ey,
      anchorLabel: f.label,
      anchorThumb: f.thumb,
      color: "amethyst",
      resolvedAt: null,
      resolvedBy: null,
      followers: [a.uid, ...l.map((y) => y.uid).filter((y) => y !== a.uid)].slice(0, 300),
      readBy: { [a.uid]: c },
      markedUnread: [],
      pinnedBy: [],
      lastAt: c,
      lastBy: a.uid,
      count: 1,
      preview: zp(h),
      boardTitle: r.meta.title
    };
    this.ui.draft = null, this.ui.openId = d;
    try {
      return await s.createThread(p, h), !0;
    } catch (y) {
      return this.fail("Your comment couldn't be posted", y), this.ui.openId = null, this.ui.draft = { anchor: f, text: o, mentions: l, n: 0 }, !1;
    }
  }
  // ---------------------------------------------------------------- threads
  /** Open a thread's card. */
  open(e) {
    this.ui.draft = null, this.ui.editingId = null, this.ui.openId = e;
  }
  close() {
    this.ui.openId = null, this.ui.editingId = null;
  }
  /** Fly to a thread, open it, and draw the eye to its pin. */
  focus(e) {
    const t = this.threads.get(e);
    if (!t) return;
    const i = this.board;
    if (t.deletedAt) {
      i.toast("This comment was deleted along with the item it was on.");
      return;
    }
    if (this.gone(t)) {
      i.toast("The item this comment is on was deleted. Recover it from Recently Deleted to see the comment.");
      return;
    }
    this.ui.draft = null, this.ui.openId = e, this.ui.showPins || (this.ui.showPins = !0);
    const s = this.pointOf(t), o = this.elementOf(t), r = i.cam.value;
    let a = Math.min(1.2, Math.max(r.zoom, 0.7));
    if (o) {
      const h = He(o), f = Math.min((i.view.w - this.rightInset() - 460) / h.w, (i.view.h - 220) / h.h);
      f > 0 && (a = Math.min(a, Math.max(0.35, f)));
    }
    const l = i.view.w - this.rightInset(), d = Math.max(140, l / 2 - 150), c = i.view.h / 2 - 40;
    i.engine && i.engine.animateCamera({ zoom: a, x: d - s.x * a, y: c - s.y * a }, 460), this.ui.flash = { id: e, n: (this.ui.flash ? this.ui.flash.n : 0) + 1 };
  }
  /** The width the Updates panel (or the history beside the rail) covers on the right. */
  rightInset() {
    return this.ui.panelOpen || this.board.ui.boardHistory ? 412 : 72;
  }
  /** The thread before or after the open one, in the panel's order (or the board's newest first). */
  step(e) {
    const t = this.order();
    if (!t.length) return;
    const i = this.ui.openId ? t.indexOf(this.ui.openId) : -1, s = t[(i + e + t.length) % t.length];
    s && this.focus(s);
  }
  /** Where the open thread is among those you can step through: "2 of 7". */
  position() {
    const e = this.order(), t = this.ui.openId ? e.indexOf(this.ui.openId) : -1;
    return t === -1 ? null : { at: t + 1, of: e.length };
  }
  order() {
    return this.ui.panelOpen && this.ui.tab === "board" ? this.feed.value.map((e) => e.t.id) : this.allThreads().filter((e) => !e.resolvedAt || this.ui.showResolved || e.id === this.ui.openId).sort((e, t) => t.lastAt - e.lastAt).map((e) => e.id);
  }
  async reply(e, t, i) {
    const s = this.threads.get(e), o = this.store, r = t.trim().slice(0, ab);
    if (!s || !o || !r) return !1;
    const a = this.board.user, l = db(r, i), d = {
      id: wt(),
      threadId: e,
      boardId: s.boardId,
      authorId: a.uid,
      authorName: this.myName,
      authorEmail: a.email,
      text: r,
      mentions: l,
      createdAt: Date.now(),
      editedAt: null,
      reactions: {}
    };
    try {
      return await o.reply(s, d, l.map((c) => c.uid).filter((c) => c !== a.uid)), s.resolvedAt && this.board.toast("Reopened with your reply"), !0;
    } catch (c) {
      return this.fail("Your reply couldn't be posted", c), !1;
    }
  }
  async edit(e, t, i) {
    const s = this.comments.get(e), o = this.store, r = t.trim().slice(0, ab);
    if (!s || !o || !r) return !1;
    if (r === s.text)
      return this.ui.editingId = null, !0;
    const a = db(r, i), l = new Set(s.mentions.map((p) => p.uid)), d = a.map((p) => p.uid).filter((p) => !l.has(p) && p !== this.board.user.uid), c = this.commentsOf(s.threadId), h = c[c.length - 1], f = { ...s, text: r, mentions: a };
    this.ui.editingId = null;
    try {
      return await o.editComment(f, h && h.id === s.id ? zp(f) : null, d), !0;
    } catch (p) {
      return this.fail("Your edit couldn't be saved", p), !1;
    }
  }
  /** Delete one comment; the first one takes its thread with it. Undo for a few seconds. */
  deleteComment(e) {
    const t = this.comments.get(e);
    if (!t) return;
    const i = this.commentsOf(t.threadId);
    if (i[0] && i[0].id === t.id) {
      this.askDeleteThread(t.threadId);
      return;
    }
    const s = i.filter((r) => r.id !== t.id), o = s[s.length - 1];
    this.ui.editingId = null, this.later(t.id, "Comment deleted", () => {
      this.store && this.store.deleteComment(t, s.length, o ? zp(o) : null).catch((r) => this.fail("The comment couldn't be deleted", r));
    });
  }
  /**
   * On something no longer on the board: deleted with it (ADMIN-001), so
   * hidden while it waits in Recently Deleted. Undo or Recover puts the
   * element back, and the thread with it; deleting it for good marks the
   * thread deleted (deleteWith), which hides it everywhere.
   */
  gone(e) {
    return !!e.deletedAt || !!e.elementId && !this.board.store.get(e.elementId);
  }
  /**
   * Elements deleted for good: their threads are marked deleted with them,
   * whoever started them (a soft delete: each stays, with its comments,
   * hidden on this board and in everyone's Everywhere else).
   */
  deleteWith(e) {
    if (!(!this.store || !e.length)) {
      for (const t of e) this.goneFor.add(t);
      this.markGone(Array.from(this.threads.values()));
    }
  }
  /** Mark deleted the threads among these on an item deleted for good this visit, each once. */
  markGone(e) {
    const t = this.store;
    if (!(!t || !this.goneFor.size))
      for (const i of e)
        !i.elementId || !this.goneFor.has(i.elementId) || i.deletedAt || this.marked.has(i.id) || (this.marked.add(i.id), t.markDeleted(i.id).catch((s) => this.fail("The thread couldn't be deleted", s)));
  }
  /** The replies in a thread from anyone but you, and who wrote them. */
  othersReplies(e) {
    const t = this.board.user.uid, i = this.commentsOf(e).slice(1).filter((s) => s.authorId !== t);
    return { replies: i.length, names: Array.from(new Set(i.map((s) => s.authorName || "Someone"))) };
  }
  /**
   * Delete thread, from any of its buttons: when others have replied it asks
   * first, since their replies go too (CHAT-28); otherwise it goes now. Either
   * way Undo stays for a few seconds.
   */
  askDeleteThread(e) {
    const t = this.othersReplies(e);
    t.replies ? this.ui.confirmDelete = { threadId: e, ...t } : this.deleteThread(e);
  }
  /** The question's answer: delete it, or keep it. */
  answerDelete(e) {
    const t = this.ui.confirmDelete;
    this.ui.confirmDelete = null, e && t && this.deleteThread(t.threadId);
  }
  /** Delete a thread and everything in it. Undo for a few seconds. */
  deleteThread(e) {
    if (!this.threads.get(e)) return;
    this.ui.openId === e && (this.ui.openId = null);
    const i = (this.byThread.get(e) || []).map((s) => s.id);
    this.later(e, "Thread deleted", () => {
      this.store && this.store.deleteThread(e, i).catch((s) => this.fail("The thread couldn't be deleted", s));
    });
  }
  /** Hide something now and send its delete once its Undo has passed (or the page is leaving). */
  later(e, t, i) {
    const s = new Set(this.hidden.value);
    s.add(e), this.hidden.value = s;
    const o = window.setTimeout(() => this.commit(e), Gie);
    this.pending.set(e, { timer: o, send: i }), this.board.toast(t, "info", {
      label: "Undo",
      run: () => {
        const r = this.pending.get(e);
        if (!r) return;
        clearTimeout(r.timer), this.pending.delete(e);
        const a = new Set(this.hidden.value);
        a.delete(e), this.hidden.value = a, this.board.dismissToast();
      }
    });
  }
  commit(e) {
    const t = this.pending.get(e);
    t && (clearTimeout(t.timer), this.pending.delete(e), t.send());
  }
  /** Send every delete still waiting (the board is closing). */
  flush() {
    for (const e of Array.from(this.pending.keys())) this.commit(e);
  }
  async react(e, t) {
    const i = this.comments.get(e);
    if (!i || !this.store) return;
    const s = Tie(t), o = !(i.reactions[this.board.user.uid] || []).includes(s);
    o && Pf(t);
    try {
      await this.store.react(i, s, o);
    } catch (r) {
      this.fail("Your reaction couldn't be saved", r);
    }
  }
  async resolve(e, t) {
    if (!(!this.threads.get(e) || !this.store)) {
      try {
        await this.store.resolve(e, t);
      } catch (s) {
        this.fail(t ? "The thread couldn't be resolved" : "The thread couldn't be reopened", s);
        return;
      }
      t && (this.ui.openId === e && !this.ui.showResolved && (this.ui.openId = null), this.board.toast("Resolved", "info", { label: "Undo", run: () => {
        this.resolve(e, !1), this.board.dismissToast();
      } }));
    }
  }
  setColor(e, t) {
    this.store && this.store.setColor(e, t).catch((i) => this.fail("The colour couldn't be saved", i));
  }
  /** A pin dropped at a world point: on the element there, if any. */
  moveTo(e, t, i) {
    this.store && this.store.move(e, lb(t, i, this.elementAt(t, i))).catch((s) => this.fail("The comment couldn't be moved", s));
  }
  follow(e, t) {
    this.store && (this.store.follow(e.id, t, e.boardId).catch((i) => this.fail("Couldn't change following", i)), this.board.toast(t ? "Following: replies show in your Updates" : "Unfollowed: you'll hear of it only if you're mentioned"));
  }
  pin(e, t) {
    this.store && (this.store.pin(e, t).catch((i) => this.fail("Couldn't change your pin", i)), t && this.board.toast("Pinned for you: it stays open on the board and first in Updates. Only you see your pins."));
  }
  markRead(e) {
    !this.store || !e.length || this.store.markRead(e.map((t) => ({ id: t.id, boardId: t.boardId }))).catch((t) => this.fail("Couldn't mark it read", t));
  }
  markUnread(e) {
    this.store && (this.ui.openId === e.id && (this.ui.openId = null), this.store.markUnread(e.id, e.boardId).catch((t) => this.fail("Couldn't mark it unread", t)));
  }
  /** Every unread thread on this board, read. */
  markAllRead() {
    this.markRead(this.allThreads().filter((e) => this.isUnread(e)));
  }
  markAllReadElsewhere(e) {
    const t = this.board.user.uid;
    this.markRead(this.followed.value.filter((i) => i.boardId !== this.board.meta.id && (!e || i.boardId === e) && gs(i, t)));
  }
  /** The open thread, read once it's been open a moment. */
  readOpenSoon() {
    clearTimeout(this.readTimer);
    const e = this.ui.openId;
    e && (this.readTimer = window.setTimeout(() => {
      const t = this.thread(e);
      t && this.ui.openId === e && this.isUnread(t) && this.markRead([t]);
    }, 600));
  }
  async copyLink(e) {
    const t = this.opts.linkFor ? this.opts.linkFor(e.boardId, e.id) : location.origin + "/board/" + e.boardId + "?comment=" + e.id;
    try {
      await navigator.clipboard.writeText(t), this.board.toast("Link copied: it opens this board at this thread");
    } catch {
      this.board.toast("Couldn't copy the link", "error");
    }
  }
  /** A thread on another board (Everywhere else): open that board there. */
  openElsewhere(e) {
    if (e.boardId === this.board.meta.id) {
      this.focus(e.id);
      return;
    }
    this.opts.openAt && this.opts.openAt(e.boardId, e.id);
  }
  /** A comment's reactions with one emoji tried: the picker remembers it. */
  pick(e) {
    Pf(e);
  }
  fail(e, t) {
    console.error("[board] " + e, t), this.board.toast(e + ". Please try again.", "error");
  }
  dispose() {
    this.disposed = !0, this.flush(), clearTimeout(this.readTimer);
    for (const e of this.unsubs) e();
    this.unsubs = [], this.store && this.store.dispose();
  }
}
var Vie = Object.defineProperty, Wie = (n, e, t) => e in n ? Vie(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ke = (n, e, t) => Wie(n, typeof e != "symbol" ? e + "" : e, t);
const T_ = 4e3;
function qie(n) {
  return "linkback-" + n;
}
const Kie = 12e4, Yie = 25e3, Xie = 120 * 1e3, Jie = 5e3, Nl = { image: "Image", video: "Video", imageEdit: "Wand2", videoEdit: "Clapperboard", threed: "Box", upscale: "Maximize2" }, Ah = { w: 184, h: 184 }, Zie = 0.32, Qie = 0.36, ese = 120, Ph = { w: 720, h: 480 }, C_ = { w: 300, h: 200 };
let wr = null;
class Rf {
  constructor(e) {
    Ke(this, "store", new dK()), Ke(this, "results", new Ute()), Ke(this, "ui", Dte()), Ke(this, "cam", /* @__PURE__ */ qe({ x: 0, y: 0, zoom: 1 })), Ke(this, "view", /* @__PURE__ */ Xt({ w: 1, h: 1, left: 0, top: 52 })), Ke(this, "docRev", /* @__PURE__ */ qe(0)), Ke(this, "meta", /* @__PURE__ */ Xt({
      id: "",
      title: "",
      /** who made the board: only they can rename it */
      ownerId: "",
      /** the team that owns it (and pays for its runs); null on a personal board */
      teamId: null,
      description: "",
      accessLevel: null
    })), Ke(this, "overlayIds", /* @__PURE__ */ qe([])), Ke(this, "moving", /* @__PURE__ */ qe(!1)), Ke(this, "far", /* @__PURE__ */ qe(!1)), Ke(this, "guides", /* @__PURE__ */ qe(null)), Ke(this, "stats", /* @__PURE__ */ qe(null)), Ke(this, "loaded", /* @__PURE__ */ qe(!1)), Ke(this, "loadError", /* @__PURE__ */ qe(null)), Ke(this, "generating", /* @__PURE__ */ Xt({})), Ke(this, "runningSince", /* @__PURE__ */ Xt({})), Ke(this, "saveState"), Ke(this, "promptRev", /* @__PURE__ */ qe(0)), Ke(this, "loadErrorKind", /* @__PURE__ */ qe(null)), Ke(this, "trashRev", /* @__PURE__ */ qe(0)), Ke(this, "recovering", /* @__PURE__ */ new Set()), Ke(this, "trash"), Ke(this, "user"), Ke(this, "catalog"), Ke(this, "companyModels", /* @__PURE__ */ qe([])), Ke(this, "engine", null), Ke(this, "worldEl", null), Ke(this, "uploader", null), Ke(this, "onStep", null), Ke(this, "feedback", null), Ke(this, "cameraHooks", /* @__PURE__ */ new Set()), Ke(this, "styledZoom", 0), Ke(this, "opts"), Ke(this, "sync"), Ke(this, "gen"), Ke(this, "elRevs", /* @__PURE__ */ new Map()), Ke(this, "runs", /* @__PURE__ */ hv(/* @__PURE__ */ new Map())), Ke(this, "overlayArea", null), Ke(this, "unsubs", []), Ke(this, "pinsKept", { models: "unknown", sessions: "unknown" }), Ke(this, "viewsKept", "unknown"), Ke(this, "prefs"), Ke(this, "settleTimer", 0), Ke(this, "pasteCount", 0), Ke(this, "disposed", !1), Ke(this, "toastSeq", 0), Ke(this, "toastTimer", 0), Ke(this, "newThumbTimers", /* @__PURE__ */ new Map()), Ke(this, "prompts", /* @__PURE__ */ new Map()), Ke(this, "undecoded", /* @__PURE__ */ new Map()), Ke(this, "forgottenLibrary", []), Ke(this, "inflight", /* @__PURE__ */ new Map()), Ke(this, "started", /* @__PURE__ */ new Map()), Ke(this, "historyCursor", /* @__PURE__ */ new Map()), Ke(this, "boardCursor", null), Ke(this, "knownAssets", /* @__PURE__ */ new Map()), Ke(this, "measured", /* @__PURE__ */ hv(/* @__PURE__ */ new Map())), Ke(this, "recordReads", /* @__PURE__ */ new Map()), Ke(this, "readingRecords", /* @__PURE__ */ Xt({})), Ke(this, "studioRecords"), Ke(this, "pinnedImages"), Ke(this, "pinnedUrls"), Ke(this, "studioRuns", /* @__PURE__ */ new Map()), Ke(this, "studioFails", /* @__PURE__ */ new Map()), Ke(this, "promptTool"), Ke(this, "selectedEls"), Ke(this, "promptLibrary"), Ke(this, "comments"), Ke(this, "labels"), Ke(this, "tour", null), Ke(this, "agent"), Ke(this, "freshTools", /* @__PURE__ */ Xt(/* @__PURE__ */ new Set())), Ke(this, "shiftPick", null), Ke(this, "missingBoards", /* @__PURE__ */ qe(/* @__PURE__ */ new Set())), Ke(this, "balance", /* @__PURE__ */ qe(null)), Ke(this, "teamActive", /* @__PURE__ */ qe(null)), Ke(this, "teamName", /* @__PURE__ */ qe(null)), Ke(this, "tokenAccessRev", /* @__PURE__ */ qe(0)), Ke(this, "trainedModelsSeen", /* @__PURE__ */ qe(null)), this.opts = e, this.sync = e.sync, this.gen = e.gen, this.user = e.user, this.catalog = I(() => wne(e.catalog.value, this.companyModels.value)), this.saveState = /* @__PURE__ */ qe("saved"), this.meta.id = e.boardId, this.prefs = Lte(e.user.uid, e.boardId), this.ui.lightCanvas = this.prefs.lightCanvas, this.ui.showGrid = this.prefs.showGrid !== !1, this.ui.shapeStyle = { ...io, ...this.prefs.shapeStyle }, this.ui.shapeKind = this.prefs.shapeKind, this.ui.histOpen = this.prefs.histOpen, this.ui.miniOpen = this.prefs.miniOpen, this.ui.recentIds = this.prefs.recentIds.slice(), this.ui.pinnedIds = Array.isArray(this.prefs.pinnedIds) ? this.prefs.pinnedIds.filter((i) => typeof i == "string") : [], this.ui.pinnedModelIds = Array.isArray(this.prefs.pinnedModelIds) ? this.prefs.pinnedModelIds.filter((i) => typeof i == "string") : [], this.ui.cameraViews = P_(this.prefs.cameraViews), this.ui.noteTint = this.prefs.noteTint, this.ui.promptH = typeof this.prefs.promptH == "number" ? this.prefs.promptH : null, this.prefs.library && (this.ui.library.tab = this.prefs.library.tab === "mine" ? "mine" : "featured", this.ui.library.category = typeof this.prefs.library.category == "string" ? this.prefs.library.category : null, typeof this.prefs.library.saveBoard == "boolean" && (this.ui.library.saveLevels = { board: this.prefs.library.saveBoard, team: !!this.prefs.library.saveTeam })), this.labels = { team: e.labels && e.labels.team || "Team" }, this.agent = e.agent || null, this.promptLibrary = new gie(this, e.featured || null, e.myPrompts || null), this.comments = new Hie(this, e.comments || { store: null }), this.promptTool = I(() => {
      if (this.docRev.value, this.ui.selection.length !== 1 || this.ui.marquee) return null;
      const i = this.store.get(this.ui.selection[0]);
      return i && i.type === "tool" ? { ...i } : null;
    }), this.selectedEls = I(() => (this.docRev.value, this.ui.selection.map((i) => this.store.get(i)).filter(Boolean))), this.studioRecords = new Ine((i) => this.sync.commit(i), () => this.user.uid), this.pinnedImages = I(() => {
      this.studioRecords.rev.value;
      const i = /* @__PURE__ */ new Set();
      return this.studioRecords.all().filter((s) => s.role === "pin" && s.createdBy === this.user.uid).reverse().sort((s, o) => o.createdAt - s.createdAt).filter((s) => !i.has(s.url) && !!i.add(s.url));
    }), this.pinnedUrls = I(() => new Set(this.pinnedImages.value.map((i) => i.url))), Ee(this.pinnedUrls, () => {
      this.overlayArea = null, this.updateOverlay();
    }), this.trash = I(() => (this.trashRev.value, this.docRev.value, this.loaded.value ? this.sync.trash().filter((i) => !Bs(i.el) || this.recoverableRecord(i.el)) : [])), this.unsubs.push(this.store.subscribe((i) => this.onDocChange(i)));
    const t = () => {
      const i = document.activeElement;
      i && i.blur && i.closest && i.closest(".bd-root") && i.blur(), this.comments.flush(), this.sync.flush().catch(() => {
      });
    };
    window.addEventListener("pagehide", t), this.unsubs.push(() => window.removeEventListener("pagehide", t)), Ee(() => this.sync.status.value, (i) => {
      this.saveState.value = i;
    }), Ee(() => this.promptTool.value ? this.promptTool.value.id : null, (i) => {
      this.ui.eyedropper && this.ui.eyedropper.sessionId !== i && (this.ui.eyedropper = null);
      const s = this.ui.library;
      s.open && i && s.sessionId !== i ? s.sessionId = i : s.open && !i && s.sessionId && this.promptLibrary.close(), i && (this.ui.recentIds = [i].concat(this.ui.recentIds.filter((o) => o !== i)).slice(0, 200), this.persistPrefs());
    }), Ee(() => this.ui.selection.slice(), (i) => {
      this.engine && this.engine.setSelection(i);
    }), Ee(() => this.ui.dragging, (i) => {
      this.engine && this.engine.setDragging(i);
    }), Ee(() => !!(this.ui.studio || this.ui.infoAt || this.ui.libraryOpen || this.ui.trashOpen), (i) => {
      i && (this.ui.eyedropper = null);
    }), Ee(() => this.ui.studio ? this.ui.studio.sessionId : null, (i) => {
      this.opts.onStudio && this.opts.onStudio(i);
    }, { flush: "sync" }), Ee(() => (this.docRev.value, !!this.ui.eyedropper && !this.eyedropperField), (i) => {
      i && (this.ui.eyedropper = null);
    }), Ee(() => this.ui.lightCanvas, (i) => {
      this.engine && this.engine.setTheme(i ? "light" : "dark"), this.persistPrefs();
    }), Ee(() => [this.ui.showGrid, this.ui.histOpen, this.ui.miniOpen, this.ui.shapeKind, this.ui.noteTint, this.ui.shapeStyle.stroke, this.ui.shapeStyle.sw, this.ui.promptH, this.ui.library.tab, this.ui.library.category, this.ui.library.saveLevels.board, this.ui.library.saveLevels.team], () => this.persistPrefs());
  }
  // ----------------------------------------------------------- lifecycle
  async load() {
    var e;
    try {
      const t = await this.sync.load();
      if (this.disposed) return;
      this.meta.title = t.meta.title || "Untitled board", this.meta.ownerId = t.meta.ownerId || "", this.meta.teamId = t.meta.teamId || null, this.meta.description = t.meta.description || "", this.meta.accessLevel = t.meta.accessLevel || null, this.opts.onTitle && this.opts.onTitle(this.meta.title), this.results.upsert(t.results, !1);
      const i = [], s = [];
      for (const r of t.elements)
        Bs(r) ? i.push(r) : s.push(r);
      this.studioRecords.load(i), this.store.load(s), this.sweepStudioRecords(), this.sync.watch((r) => this.onRemote(r)), this.unsubs.push(this.results.onLocalChange((r) => this.sync.commitResults(r.filter((a) => a.status !== "pending")))), this.loaded.value = !0, this.startRealtime(), this.comments.start();
      const o = this.opts.initialStudio;
      o && ((e = this.store.get(o)) == null ? void 0 : e.type) === "tool" && this.restoreStudio(o), this.opts.linkedFrom && this.linkBack(this.opts.linkedFrom), this.refreshLinks();
    } catch (t) {
      if (this.disposed) return;
      console.error("[board] load failed", t), this.loadError.value = t instanceof Error && t.message || "This board could not be loaded.";
      const i = t && typeof t == "object" && "kind" in t ? String(t.kind) : null;
      this.loadErrorKind.value = i;
    }
  }
  /** Real boards: the board's runs, and your prompts, as they change. */
  startRealtime() {
    const e = this.opts.runs;
    e && e.watchRecent((a, l) => {
      for (const d of a) this.onRun(d);
      for (const d of l) this.onRunGone(d);
    }), this.opts.favorites && this.opts.favorites.start();
    const t = this.opts.pins;
    if (t) {
      for (const a of ["models", "sessions"])
        this.unsubs.push(t.watch(a, (l) => this.pinsFromAccount(a, l), () => {
          this.pinsKept[a] = "off";
        }));
      t.watchViews && this.unsubs.push(t.watchViews((a) => this.viewsFromAccount(a), () => {
        this.viewsKept = "off";
      }));
    }
    const i = this.opts.balance;
    i && this.unsubs.push(i.watch(this.meta.teamId || this.user.uid, (a) => {
      this.balance.value = a;
    }));
    const s = this.opts.teamStatus;
    s && this.meta.teamId && this.unsubs.push(s.watch(this.meta.teamId, (a, l) => {
      this.teamActive.value = a, l !== void 0 && (this.teamName.value = l);
    }));
    const o = this.opts.companyTools;
    o && this.meta.teamId && o(this.meta.teamId).then((a) => {
      this.disposed || (this.companyModels.value = a);
    }).catch((a) => console.warn("[board] company tools unavailable", a));
    const r = this.opts.prompts;
    r && (r.start((a, l) => this.onSavedPrompt(a, l)).catch(() => {
    }), this.unsubs.push(Ee(this.catalog, () => {
      for (const [a, l] of Array.from(this.undecoded)) this.onSavedPrompt(a, l);
    })));
  }
  /** Called by BoardView once the stage is in the DOM. */
  async attach(e, t) {
    this.worldEl = t;
    const i = e.getBoundingClientRect();
    this.view.w = i.width, this.view.h = i.height, this.view.left = i.left, this.view.top = i.top;
    const s = new $te({
      host: e,
      store: this.store,
      theme: this.ui.lightCanvas ? "light" : "dark",
      onCamera: (a, l) => this.onCamera(a, l),
      onStats: (a) => {
        this.ui.showStats && (this.stats.value = a);
      }
    });
    if (this.engine = s, await s.ready, this.disposed) return;
    s.setSelection(this.ui.selection), s.setPaused(!!this.ui.studio);
    const o = new ResizeObserver(() => {
      const a = e.getBoundingClientRect();
      this.view.w = a.width, this.view.h = a.height, this.view.left = a.left, this.view.top = a.top, this.overlayArea = null, this.updateOverlay();
    });
    o.observe(e), this.unsubs.push(() => o.disconnect());
    const r = this.opts.initialCamera || this.prefs.camera;
    r && Number.isFinite(r.zoom) ? s.setCamera(r) : this.fit(0), s.playEntrance(), this.updateOverlay();
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.unsubs) e();
    this.unsubs = [];
    for (const e of this.runs.values()) e.cancel();
    this.runs.clear();
    for (const e of this.started.values())
      e.unwatch(), clearTimeout(e.timer);
    this.started.clear(), this.opts.runs && this.opts.runs.dispose(), this.opts.prompts && this.opts.prompts.dispose(), this.opts.favorites && this.opts.favorites.dispose(), this.promptLibrary.dispose(), this.comments.dispose(), clearTimeout(this.settleTimer), clearTimeout(this.toastTimer);
    for (const e of this.newThumbTimers.values()) clearTimeout(e);
    this.persistPrefs(), this.sync.dispose(), this.engine && this.engine.destroy(), this.engine = null;
  }
  // ------------------------------------------------------------ reactivity
  /** A per-element revision ref, for DOM-layer components. */
  rev(e) {
    let t = this.elRevs.get(e);
    return t || (t = /* @__PURE__ */ qe(0), this.elRevs.set(e, t)), t;
  }
  releaseRev(e) {
    this.elRevs.delete(e);
  }
  bump(e) {
    const t = this.elRevs.get(e);
    t && (t.value++, xs(t));
  }
  onDocChange(e) {
    for (const t of e.added) this.bump(t.id);
    for (const t of e.updated) this.bump(t.id);
    for (const t of e.removed) this.bump(t.id);
    for (const t of e.updated) {
      const i = t.el;
      if (i.type !== "image" || !i.resultId || !("fav" in t.after)) continue;
      const s = this.results.get(i.resultId);
      s && !!s.fav != !!i.fav && this.results.upsert([{ ...s, fav: i.fav || void 0 }], e.origin === "local");
    }
    if (e.removed.length) {
      const t = new Set(e.removed.map((i) => i.id));
      this.ui.selection.some((i) => t.has(i)) && (this.ui.selection = this.ui.selection.filter((i) => !t.has(i))), this.ui.infoAt && t.has(this.ui.infoAt) && (this.ui.infoAt = null), this.ui.editingNote && t.has(this.ui.editingNote) && (this.ui.editingNote = null);
    }
    this.docRev.value++, xs(this.docRev), (e.added.length || e.removed.length) && (this.overlayArea = null), this.updateOverlay(), !e.ephemeral && e.origin !== "remote" && e.origin !== "load" && (this.sync.commit(e), (e.added.length || e.removed.length) && this.trashRev.value++);
  }
  onRemote(e) {
    if (e.meta) {
      const r = e.meta;
      if (r.deleted) {
        this.loadError.value = "This board was deleted.", this.loadErrorKind.value = "deleted";
        return;
      }
      r.refused && this.toast(r.refused === "owner" ? "Only the board's owner can change its name and description." : "The board's details couldn't be saved.", "error"), r.title && r.title !== this.meta.title && (this.meta.title = r.title, this.opts.onTitle && this.opts.onTitle(r.title)), r.description !== void 0 && (this.meta.description = r.description || ""), r.accessLevel !== void 0 && (this.meta.accessLevel = r.accessLevel || null);
    }
    e.results && e.results.length && this.results.upsert(e.results, !1), e.trash && (this.trashRev.value++, this.forgetPurged());
    const t = e.upserted.filter(Bs), i = e.removed.filter((r) => this.studioRecords.has(r));
    this.studioRecords.applyRemote(t, i);
    const s = t.length ? e.upserted.filter((r) => !Bs(r)) : e.upserted, o = i.length ? e.removed.filter((r) => !i.includes(r)) : e.removed;
    !s.length && !o.length || this.store.batch("Remote", () => {
      const r = [];
      for (const a of s)
        if (this.store.get(a.id)) {
          if (this.store.inGesture && this.ui.selection.includes(a.id)) continue;
          this.store.update(a.id, a, { origin: "remote", history: !1 });
        } else
          r.push(a);
      r.length && this.store.add(r, { origin: "remote", history: !1 }), o.length && this.store.remove(o, { origin: "remote", history: !1 });
    }, { origin: "remote", history: !1 });
  }
  /**
   * The Studios view's records of a session deleted for good (Recently
   * Deleted's 90 days passed, or by hand elsewhere) go too: nothing can show
   * them again. Only old ones, so a session still arriving from another tab
   * keeps its records.
   */
  sweepStudioRecords() {
    const e = /* @__PURE__ */ new Set();
    for (const s of this.store.all()) s.type === "tool" && e.add(s.id);
    for (const s of this.sync.trash()) s.el.type === "tool" && e.add(s.el.id);
    const t = Date.now(), i = this.studioRecords.all().filter((s) => s.role !== "pin" && !e.has(s.sessionId) && t - (s.updatedAt || s.createdAt || 0) > 600 * 1e3).map((s) => s.id);
    i.length && (this.studioRecords.remove(i), this.sync.purge(i));
  }
  // ---------------------------------------------------------------- camera
  /** Run fn on every camera frame (DOM writes that must not wait for Vue). */
  onCameraFrame(e) {
    return this.cameraHooks.add(e), () => this.cameraHooks.delete(e);
  }
  onCamera(e, t) {
    this.cam.value = e;
    for (const s of this.cameraHooks) s(e);
    this.worldEl && (this.worldEl.style.transform = "translate3d(" + e.x + "px," + e.y + "px,0) scale(" + e.zoom + ")", e.zoom !== this.styledZoom && (this.styledZoom = e.zoom, this.worldEl.style.setProperty("--cv-zoom", String(e.zoom)), this.worldEl.style.setProperty("--cv-inv-zoom", String(1 / e.zoom)))), t !== this.moving.value && (this.moving.value = t);
    const i = this.far.value ? e.zoom < Qie : e.zoom < Zie;
    i !== this.far.value && (this.far.value = i, this.engine && this.engine.setFar(i), this.overlayArea = null), this.updateOverlay(), clearTimeout(this.settleTimer), this.settleTimer = window.setTimeout(() => {
      this.moving.value = !1, this.prefs.camera = { ...this.cam.value }, this.persistPrefs(), this.opts.onCameraSettled && this.opts.onCameraSettled(this.cam.value);
    }, 220);
  }
  /** Recompute which DOM-layer elements should exist, with a margin. */
  updateOverlay() {
    if (!this.engine) return;
    const e = this.cam.value, t = fl(e, this.view.w, this.view.h, 0), i = this.overlayArea;
    if (i && t.x >= i.x && t.y >= i.y && t.x + t.w <= i.x + i.w && t.y + t.h <= i.y + i.h && i.w < t.w * 2.6) return;
    const s = t.w * 0.5, o = t.h * 0.5, r = { x: t.x - s, y: t.y - o, w: t.w + s * 2, h: t.h + o * 2 };
    this.overlayArea = r;
    const a = [];
    if (this.far.value) {
      const d = ese / e.zoom;
      for (const c of this.store.index.query(r)) {
        const h = this.store.get(c);
        h && h.type === "frame" && h.w >= d && a.push(c);
      }
      for (const c of [this.ui.editingNote, this.ui.editingTitle]) c && !a.includes(c) && this.store.get(c) && a.push(c);
    } else {
      for (const d of this.store.index.query(r)) {
        const c = this.store.get(d);
        c && (c.type === "note" || c.type === "tool" || c.type === "chat" || c.type === "frame" || c.type === "image" && (c.fav || c.video || this.isPinnedImage(c.src))) && a.push(d);
      }
      for (const d of this.ui.selection) if (!a.includes(d)) {
        const c = this.store.get(d);
        c && (c.type === "note" || c.type === "tool" || c.type === "chat") && a.push(d);
      }
    }
    const l = this.overlayIds.value;
    if (l.length === a.length) {
      const d = new Set(l);
      if (a.every((c) => d.has(c))) return;
    }
    this.overlayIds.value = a;
  }
  screenToWorld(e, t) {
    const i = this.cam.value;
    return { x: (e - this.view.left - i.x) / i.zoom, y: (t - this.view.top - i.y) / i.zoom };
  }
  worldToClient(e, t) {
    const i = this.cam.value;
    return { x: e * i.zoom + i.x + this.view.left, y: t * i.zoom + i.y + this.view.top };
  }
  viewportCentre() {
    const e = this.cam.value;
    return { x: (this.view.w / 2 - e.x) / e.zoom, y: (this.view.h / 2 - e.y) / e.zoom };
  }
  fit(e = 420) {
    if (!this.engine) return;
    const t = this.store.bounds();
    if (!t) {
      this.engine.animateCamera({ zoom: 1, x: this.view.w / 2, y: this.view.h / 2 }, e);
      return;
    }
    this.engine.fitTo(t, { pad: 120, maxZoom: 1, animate: e });
  }
  /** One press of zoom in or out: from where a glide under way is headed, so quick presses step evenly, and stopping at 100% on the way past (CHAT-29). */
  zoomBy(e) {
    if (!this.engine) return;
    const t = this.engine.cameraGoal;
    this.engine.animateCamera(Pv(t, this.view.w / 2, this.view.h / 2, XN(t.zoom, e) / t.zoom), 220);
  }
  zoomTo(e) {
    this.engine && this.engine.animateCamera(Pv(this.cam.value, this.view.w / 2, this.view.h / 2, e / this.cam.value.zoom), 260);
  }
  jumpTo(e, t, i) {
    this.engine && this.engine.animateCamera(rl(e, t, i || this.cam.value.zoom, this.view.w, this.view.h), 420);
  }
  /** Open a session from anywhere: centre it, close enough to read (≥ 50%). */
  openSession(e) {
    const t = He(e);
    this.ui.infoAt = null, this.ui.selection = [e.id], this.jumpTo(t.x + t.w / 2, t.y + t.h / 2, Math.max(this.cam.value.zoom, 0.5));
  }
  /** A tool by its id: in a kit, or one of the tools no kit lists (the Edit side's, IL-073). */
  toolModel(e) {
    const t = this.catalog.value;
    return t.byId.get(e) || (t.tools || []).find((i) => i.id === e) || null;
  }
  /**
   * A session card's Open, its empty slots, or a double-click on it (IL-100;
   * Adam: Open did nothing, and the empty slots should open the tool): the
   * session open and in view, with its results beside it. The board's
   * history, the comments and a chat open in the gallery's place, so they
   * step aside for it.
   */
  showSession(e) {
    this.openSession(e), this.ui.histOpen = !0, this.ui.boardHistory = !1, this.ui.chatOpen = null, this.comments.ui.panelOpen = !1;
  }
  /**
   * A new element lands where you look, at a readable zoom (≥ 100%). One put
   * where you pointed (a right-click, a double-click) stays where it is if it
   * can be read there (≥ 50%) and the chrome doesn't cover it.
   */
  revealNew(e, t = !1) {
    const i = He(e);
    t && this.inClearView(i, e.type === "tool") || this.jumpTo(i.x + i.w / 2, i.y + i.h / 2, Math.max(this.cam.value.zoom, 1));
  }
  /** All on screen at a readable zoom, clear of the top bar, the session list and the bottom bar (or, for a session, its prompt). */
  inClearView(e, t) {
    const i = this.cam.value;
    if (i.zoom < 0.5) return !1;
    const s = e.x * i.zoom + i.x, o = e.y * i.zoom + i.y;
    return s >= 84 && o >= 64 && s + e.w * i.zoom <= this.view.w - 24 && o + e.h * i.zoom <= this.view.h - (t ? 280 : 96);
  }
  /**
   * Where something placed without a point goes: beside the selection (its
   * right, top-aligned), where there is one (IL-100; Nathan: "if you have a
   * selection and place an image it should place next to that instead of
   * the center of the screen"), else the middle of the view.
   */
  placeNear(e, t) {
    const i = this.ui.selection.filter((o) => !!this.store.get(o)), s = i.length ? this.store.bounds(i) : null;
    return s ? { x: s.x + s.w + 48 + e / 2, y: s.y + t / 2 } : void 0;
  }
  /** The canvas menu's Shape (IL-100): the dock's shape, as a click with it drops one, centred where you pointed. */
  addShape(e) {
    const t = this.ui.shapeKind, i = t === "line" || t === "arrow", s = {
      id: wt(),
      type: "shape",
      shape: t,
      z: 0,
      sc: [0, 0],
      x: Math.round(e.x - 130),
      y: Math.round(i ? e.y : e.y - 85),
      w: 260,
      h: i ? 0 : 170,
      stroke: this.ui.shapeStyle.stroke,
      sw: this.ui.shapeStyle.sw,
      createdBy: this.user.uid
    };
    return s.z = this.store.nextZ(s), this.closeAddMenus(), this.store.add([s]), this.ui.selection = [s.id], this.ui.styleOpen = !0, this.revealNew(s, !0), s.id;
  }
  /**
   * Clear space near the viewport centre (or `near`, a world point): rings
   * 160px apart, a 48px margin around everything already there. Frames
   * don't count — things go in them. `taken`: places already given out that the
   * board doesn't hold yet (several pictures placed at once).
   */
  freeSpot(e, t, i, s = [], o = {}) {
    const r = i || this.viewportCentre(), a = 48, l = (h, f) => {
      const p = { x: h - a, y: f - a, w: e + a * 2, h: t + a * 2 };
      for (const y of s) if (Ya({ x: h, y: f, w: e, h: t }, { x: y.x - 24, y: y.y - 24, w: y.w + 48, h: y.h + 48 })) return !1;
      for (const y of this.store.index.query(p)) {
        const v = this.store.get(y);
        if (!v) continue;
        const x = He(v);
        if (v.type === "frame") {
          if (o.outsideFrames) {
            if (Ya(p, x)) return !1;
            continue;
          }
          const w = 16;
          if (!(h >= x.x + w && f >= x.y + w && h + e <= x.x + x.w - w && f + t <= x.y + x.h - w) && Ya(p, x)) return !1;
          continue;
        }
        if (Ya(p, x)) return !1;
      }
      return !0;
    }, d = Math.round(r.x - e / 2), c = Math.round(r.y - t / 2);
    if (l(d, c)) return { x: d, y: c };
    for (let h = 1; h <= 14; h++) {
      const f = h * 160, p = 8 * h;
      let y = null;
      for (let v = 0; v < p; v++) {
        const x = v / p * Math.PI * 2, w = Math.round(d + Math.cos(x) * f), S = Math.round(c + Math.sin(x) * f * 0.75);
        if (l(w, S)) {
          y = { x: w, y: S };
          break;
        }
      }
      if (y) return y;
    }
    return { x: d, y: c };
  }
  /** Typing needs a readable zoom: bring a far element close first. */
  editNote(e) {
    const t = this.store.get(e);
    if (t) {
      if (t.type === "note" && t.link) {
        this.openBoardLink(e);
        return;
      }
      if (this.ui.selection = [e], this.far.value) {
        const i = He(t);
        this.jumpTo(i.x + i.w / 2, i.y + i.h / 2, 0.8);
      }
      this.ui.editingNote = e, this.overlayArea = null, this.updateOverlay();
    }
  }
  // ------------------------------------------------------------ selection
  select(e) {
    this.ui.selection = e, this.ui.styleOpen = !1;
  }
  /** Everything on the board, frames too: a move takes each frame with what it holds (CHAT-26). */
  selectAll() {
    this.ui.selection = Array.from(this.store.all()).map((e) => e.id);
  }
  clearSelection() {
    this.ui.selection = [], this.ui.styleOpen = !1;
  }
  // -------------------------------------------------------------- creation
  author() {
    return this.user.initials || "You";
  }
  // ------------------------------------------------------- menus at a point
  /** Right-click on the canvas: its menu, at the pointer, adds things there. */
  openCanvasMenu(e, t) {
    this.closeMenus(), this.ui.canvasMenu = this.pointMenu(e, t);
  }
  /** Link to a board (B33), at a point: the canvas menu's row hands over to it. */
  openBoardLinkMenu(e, t) {
    this.closeMenus(), this.ui.boardLinkMenu = this.pointMenu(e, t);
  }
  /** Double-click on the canvas: the session finder, at the pointer; a session started from it goes there. */
  openFinder(e, t) {
    this.closeMenus(), this.ui.finder = this.pointMenu(e, t);
  }
  pointMenu(e, t) {
    return { x: e, y: t, at: this.screenToWorld(e, t) };
  }
  /** The menus over the board (the add menu, the place menu, the shape menu, the board menu, the menus at a point); not its dialogs. */
  closeMenus() {
    this.ui.placeMenu = !1, this.ui.shapeMenu = !1, this.ui.boardMenu = !1, this.closeAddMenus();
  }
  /** The menus that add to the board: something added closes them. */
  closeAddMenus() {
    this.ui.addMenu = !1, this.ui.canvasMenu = null, this.ui.finder = null, this.ui.boardLinkMenu = null;
  }
  /**
   * The add menu opens where the tool rail is, and an open session's prompt
   * takes the rail's place: picking "new session" leaves the current one.
   */
  openAddMenu() {
    this.promptTool.value && (this.ui.selection = []), this.ui.addMenu = !0;
  }
  /**
   * `at`: a world point (a right-click's) the new element is centred on, or
   * as near it as there's room; without one, clear space where you look.
   */
  addElement(e, t) {
    if (e === "tool") {
      this.ui.addMenu ? this.ui.addMenu = !1 : this.openAddMenu();
      return;
    }
    if (this.closeAddMenus(), e === "image-gen") {
      this.newImageSession(t);
      return;
    }
    let i = null;
    if (e !== "image") {
      if (e === "note") {
        const s = this.freeSpot(Ah.w, Ah.h, t);
        i = { id: wt(), type: "note", x: s.x, y: s.y, w: Ah.w, h: Ah.h, z: 0, tint: this.ui.noteTint, text: "", author: this.author(), grow: !0 };
      } else if (e === "frame") {
        const s = this.freeSpot(Ph.w, Ph.h, t);
        i = { id: wt(), type: "frame", x: s.x, y: s.y, w: Ph.w, h: Ph.h, z: 0, title: "New frame" };
      }
      i && (i.z = this.store.nextZ(i, i.type === "frame"), i.createdBy = this.user.uid, this.store.add([i]), this.ui.selection = [i.id], this.revealNew(i, !!t), i.type === "note" && (this.ui.editingNote = i.id), i.type === "frame" && (this.ui.editingTitle = i.id));
    }
  }
  /** Place images (urls) at the viewport centre or a world point. */
  placeImages(e, t) {
    const i = [], s = [];
    let o = 0;
    const r = [];
    for (const a of e) {
      const l = a.w || C_.w, d = a.h || C_.h, c = r[r.length - 1], h = c ? { x: c.x + c.w + 24 + l / 2, y: c.y + d / 2 } : this.placeNear(l, d), f = a.x !== void 0 && a.y !== void 0 ? { x: a.x, y: a.y } : t ? { x: Math.round(t.x - l / 2 + o), y: Math.round(t.y - d / 2 + o) } : this.freeSpot(l, d, h, r);
      r.push({ x: f.x, y: f.y, w: l, h: d });
      const p = {
        id: wt(),
        type: "image",
        x: f.x,
        y: f.y,
        w: l,
        h: d,
        z: 0,
        src: a.url,
        label: a.label || "placed_image",
        resultId: a.resultId,
        sessionId: a.sessionId,
        video: a.video,
        dur: a.dur,
        videoSrc: a.videoSrc,
        previewSrc: a.previewSrc,
        asset: a.asset,
        download: a.download,
        kind: a.kind,
        createdBy: this.user.uid
      };
      p.z = this.store.nextZ(p) + s.length, s.push(p), i.push(p.id), o += 28;
    }
    return s.length && (this.store.batch("Place", () => {
      this.store.add(s), this.growFramesFor(i);
    }), this.ui.selection = i, t || this.revealNew(s[0])), i;
  }
  // ------------------------------------------------------------ your Library
  /** Open your Library over the board: to place pictures on it (the default), or to pick some for something. */
  openLibrary(e = {}) {
    this.ui.placeMenu = !1, this.ui.addMenu = !1, this.ui.libraryOpen = {
      purpose: e.purpose || "place",
      max: e.max || tse,
      kinds: e.kinds,
      confirmLabel: e.confirmLabel,
      onPick: e.onPick,
      at: e.at,
      n: (this.ui.libraryOpen ? this.ui.libraryOpen.n : 0) + 1
    };
  }
  closeLibrary() {
    this.ui.libraryOpen = null;
  }
  /**
   * Pictures picked in your Library go on the board at a card's size, in the
   * order picked, each with its record (so a run can send it as is).
   */
  placeFromLibrary(e, t) {
    const i = [];
    for (const y of e) {
      this.rememberAsset(y.url, y.asset);
      const v = I_(y.w || 0, y.h || 0);
      i.push({
        url: y.url,
        w: v.w,
        h: v.h,
        label: y.label.slice(0, 60),
        asset: y.asset,
        video: y.video && y.videoSrc ? !0 : void 0,
        videoSrc: y.video ? y.videoSrc : void 0,
        // a 3D model's preview, which keeps its model to download (IL-100)
        kind: y.model3d ? "3d" : void 0,
        download: y.model3d ? y.model3d.url : void 0
      });
    }
    const s = 24, o = Math.max(1, Math.ceil(Math.sqrt(i.length * 1.6))), r = [];
    for (let y = 0; y < i.length; y += o) r.push(i.slice(y, y + o));
    const a = r.map((y) => y.reduce((v, x) => v + (x.w || 0), 0) + s * (y.length - 1)), l = r.map((y) => Math.max(...y.map((v) => v.h || 0))), d = Math.max(0, ...a), c = l.reduce((y, v) => y + v, 0) + s * (r.length - 1), h = this.freeSpot(d, c, t || this.placeNear(d, c));
    let f = h.y;
    r.forEach((y, v) => {
      let x = h.x;
      for (const w of y)
        w.x = x, w.y = f + Math.round((l[v] - (w.h || 0)) / 2), x += (w.w || 0) + s;
      f += l[v] + s;
    });
    const p = this.placeImages(i);
    return p.length && this.toast(p.length === 1 ? "Placed 1 image from your Library" : "Placed " + p.length + " images from your Library"), p;
  }
  /** Tools are concepts, not models: "Image Tool 3" until its first run. */
  nextToolName(e) {
    const t = new RegExp("^" + e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + " Tool (\\d+)$");
    let i = 0;
    const s = (o) => {
      const r = t.exec(o || "");
      r && (i = Math.max(i, Number(r[1])));
    };
    for (const o of this.store.all()) o.type === "tool" && s(o.name);
    for (const o of this.trash.value) o.el.type === "tool" && s(o.el.name);
    return e + " Tool " + (i + 1);
  }
  /** A new session on this kit and model; `at` as addElement has it, or where a tour (IL-095) says it lands. */
  pickModel(e, t, i) {
    const s = i || this.tour && this.tour.landing && this.tour.landing() || void 0, o = this.addSession(e, t, void 0, s);
    return this.prompts.set(o.id, { prompt: "", n: t.numResults.def || 1 }), this.bumpPrompt(), this.freshTools.add(o.id), o;
  }
  /** Image Gen: a session on the image kit's default model, or none while there's no catalog. */
  newImageSession(e) {
    const t = this.catalog.value.kits.find((s) => s.id === "image") || this.catalog.value.kits[0], i = t ? Bi(t) : null;
    return t && i ? this.pickModel(t, i, e) : null;
  }
  /**
   * A new session in clear space where you're looking (or near `at`), selected
   * and in view. `quiet`: the selection and the view stay as they are (a chat's
   * plan adds sessions to a frame you're already looking at).
   */
  addSession(e, t, i, s, o = {}) {
    const r = Rt, a = this.freeSpot(r.w, r.h, s), l = {
      id: wt(),
      type: "tool",
      x: a.x,
      y: a.y,
      w: r.w,
      h: r.h,
      z: 0,
      name: i || this.nextToolName(e.name),
      kind: e.name,
      kitId: e.id,
      model: t.name,
      nodeDefId: t.id,
      icon: Nl[e.id] || e.icon || "Image",
      count: 0,
      thumbs: [],
      createdBy: this.user.uid
    };
    return l.z = this.store.nextZ(l), this.store.add([l]), o.quiet || (this.closeAddMenus(), this.ui.selection = [l.id], this.revealNew(l, !!s)), l;
  }
  /** `name`, or "name 2", "name 3"… when another session has it. */
  uniqueSessionName(e, t) {
    const i = /* @__PURE__ */ new Set();
    for (const o of this.store.all()) o.type === "tool" && o.id !== t && i.add(o.name);
    if (!i.has(e)) return e;
    let s = 2;
    for (; i.has(e + " " + s); ) s++;
    return e + " " + s;
  }
  /** A session that has made nothing yet, and isn't making anything. */
  isUnused(e) {
    return this.results.rev.value, !e.count && !(e.thumbs && e.thumbs.length) && !this.results.list(e.id).length && !this.generating[e.id];
  }
  /** A prompt just landed in this session's card: it glows once. */
  landPrompt(e) {
    this.ui.promptLanded = { id: e, seq: (this.ui.promptLanded ? this.ui.promptLanded.seq : 0) + 1 };
  }
  // ------------------------------------------------------------ mutations
  patch(e, t, i = "Edit") {
    this.store.batch(i, () => this.store.update(e, t));
  }
  patchTool(e, t) {
    this.store.batch("Edit session", () => this.store.update(e, t)), t.nodeDefId !== void 0 && this.persistPrompt(e);
  }
  // ------------------------------------------------------------- prompts
  /**
   * Your prompt in a session. On a real board it's your run draft, so it's
   * yours alone; until you change it, a demo session offers its own.
   */
  promptOf(e) {
    this.promptRev.value;
    const t = this.store.get(e);
    t && t.type === "tool" && this.opts.prompts && this.opts.prompts.follow(e).catch(() => {
    });
    const i = this.prompts.get(e);
    return i || t && t.type === "tool" && t.up || {};
  }
  setPrompt(e, t) {
    const i = { ...this.promptOf(e), ...t };
    t.assets && (i.assets = { ...this.promptOf(e).assets || {}, ...t.assets }), this.prompts.set(e, i), this.bumpPrompt(), t.prompt && this.freshTools.delete(e), this.persistPrompt(e);
  }
  /** Put a session's prompt back whole, as it was (an Undo's): what setPrompt merges, replaced. */
  replacePrompt(e, t) {
    this.prompts.set(e, t), this.bumpPrompt(), this.persistPrompt(e);
  }
  bumpPrompt() {
    this.promptRev.value++, xs(this.promptRev);
  }
  /** Save a session's prompt (your run draft), for its current model. */
  persistPrompt(e) {
    const t = this.opts.prompts;
    if (!t) return;
    const i = this.store.get(e);
    if (!i || i.type !== "tool") return;
    const { model: s } = this.modelFor(i);
    if (!s) return;
    const o = this.promptOf(e);
    t.save(e, s.id, Eo(s, o, "draft").inputs, this.countFor(s, o));
  }
  countFor(e, t) {
    return Math.max(e.numResults.min, Math.min(e.numResults.max, t.n || e.numResults.def || 1));
  }
  /** Your saved prompt for a session arrived (the load, or another tab of yours). */
  onSavedPrompt(e, t) {
    if (!t) return;
    const i = this.catalog.value, s = this.store.get(e), r = i.byId.get(t.nodeDefId) || null || (i.source === "firestore" && s ? this.modelFor(s).model : null);
    if (!r) {
      this.undecoded.set(e, t);
      return;
    }
    this.undecoded.delete(e);
    const a = dc(r, t.inputs, (l) => this.assetUrl(l));
    t.numResults && (a.n = t.numResults), !qL(this.prompts.get(e), a) && (this.prompts.set(e, a), this.dropForgotten(e), this.bumpPrompt());
  }
  /** Where the board shows a result's or an upload's file. */
  assetUrl(e) {
    const t = YW(e) || "";
    return this.opts.storageUrl ? this.opts.storageUrl(t) : t;
  }
  /** A session's image inputs, in the model's order. */
  refFieldsOf(e) {
    const { model: t } = this.modelFor(e);
    return t ? t.fields.filter((i) => i.placement === "reference") : [];
  }
  /**
   * The pictures in one of a session's image inputs. The first input is the
   * session's own reference (`ref`), the rest live under `inputs` by field
   * key; one that takes several keeps a list there once it holds more than one.
   */
  refImages(e, t) {
    const i = this.store.get(e);
    if (!i || i.type !== "tool") return [];
    const s = this.refFieldsOf(i), o = this.promptOf(e), r = o.inputs ? o.inputs[t] : void 0;
    if (Array.isArray(r)) {
      const l = r.filter((d) => typeof d == "string" && !!d);
      if (l.length) return l;
    }
    const a = !s.length || s[0].key === t ? o.ref : r;
    return typeof a == "string" && a ? [a] : [];
  }
  putRefImages(e, t, i, s) {
    const o = this.store.get(e);
    if (!o || o.type !== "tool") return;
    const r = this.refFieldsOf(o), a = !r.length || r[0].key === t, l = this.promptOf(e), d = i.length > 1 ? i : a ? void 0 : i[0] || null, c = {};
    s && (c.assets = s), a && (c.ref = i[0] || null), (!a || d !== void 0 || l.inputs && l.inputs[t] !== void 0) && (c.inputs = { ...l.inputs || {}, [t]: d }), this.setPrompt(e, c);
  }
  /**
   * Fill one of a session's image inputs, or clear it (null). One that takes
   * several adds the picture to those it holds, up to the model's limit; any
   * other holds just this one. `asset` is the result or upload behind the
   * picture, which a run sends. False when it didn't take (the input is full).
   */
  setRefInput(e, t, i, s) {
    const o = this.store.get(e);
    if (!o || o.type !== "tool") return !1;
    if (!i)
      return this.putRefImages(e, t, []), !0;
    const r = s ? { [i]: s } : void 0, a = this.refFieldsOf(o).find((l) => l.key === t);
    if (a && a.kind === "images") {
      const l = this.refImages(e, t);
      if (l.includes(i)) return !0;
      const d = Zs(a);
      return l.length >= d ? (this.toast("This model takes up to " + d + " images. Remove one to add another."), !1) : (this.putRefImages(e, t, l.concat(i), r), !0);
    }
    return this.putRefImages(e, t, [i], r), !0;
  }
  /** Take one picture out of an image input (the rest stay, in order). */
  removeRefImage(e, t, i) {
    this.putRefImages(e, t, this.refImages(e, t).filter((s) => s !== i));
  }
  /** A picture for a session's reference: its first image input. */
  addReference(e, t, i) {
    const s = this.store.get(e);
    if (!s || s.type !== "tool") return !1;
    const o = this.refFieldsOf(s)[0];
    return this.setRefInput(e, o ? o.key : "", t, i);
  }
  // ---------------------------------------------------------------- the eyedropper
  /**
   * The eyedropper: armed for one of a session's image inputs, a click on an
   * image on the board (or a session card's thumbnail, or a gallery result)
   * puts it there instead of selecting it. Without a key it arms the first
   * input with room for another picture, else the first.
   */
  armEyedropper(e, t) {
    const i = this.store.get(e);
    if (!i || i.type !== "tool") return;
    const s = this.refFieldsOf(i), o = t ? s.find((r) => r.key === t) : s.find((r) => this.refImages(e, r.key).length < Zs(r)) || s[0];
    if (!o) {
      this.toast("This model takes no images.");
      return;
    }
    this.ui.shapeArmed = !1, this.ui.mode = "select", this.ui.addMenu = !1, this.ui.eyedropper = { sessionId: e, key: o.key };
  }
  /** The prompt's eyedropper button (and I): on, or off again. */
  toggleEyedropper(e) {
    this.ui.eyedropper && this.ui.eyedropper.sessionId === e ? this.ui.eyedropper = null : this.armEyedropper(e);
  }
  /** The input the eyedropper fills, while the session still has it. */
  get eyedropperField() {
    const e = this.ui.eyedropper, t = e ? this.store.get(e.sessionId) : void 0;
    return !e || !t || t.type !== "tool" ? null : this.refFieldsOf(t).find((i) => i.key === e.key) || null;
  }
  /** Whether the eyedropper's input takes this picture (a video input takes videos, the rest stills). */
  eyedropperTakes(e) {
    const t = this.eyedropperField;
    return !!t && t.kind === "video" === e;
  }
  /**
   * Put a picture from the board in the eyedropper's input, and put the
   * eyedropper away: one pick per press. A picture of the wrong kind (a video
   * for an image input) is turned away and the eyedropper stays on.
   */
  eyedrop(e, t, i) {
    const s = this.ui.eyedropper, o = this.eyedropperField;
    if (!s || !o) {
      this.ui.eyedropper = null;
      return;
    }
    if (o.kind === "video" !== i) {
      this.toast(o.kind === "video" ? "This input takes a video. Pick a video on the board." : "This input takes images, not videos.");
      return;
    }
    this.ui.eyedropper = null;
    const r = t && "nodeRunResult" in t ? t.nodeRunResult : null;
    if (r && r.type === "ASSET_3D" && r.nodeRunId && r.uuid) {
      this.openStudio({ sessionId: s.sessionId, resultId: r.nodeRunId + ":" + r.uuid });
      return;
    }
    if (!this.refImages(s.sessionId, s.key).includes(e) && !this.setRefInput(s.sessionId, s.key, e, t)) return;
    const a = (this.ui.refPulse ? this.ui.refPulse.n : 0) + 1;
    this.ui.refPulse = { url: e, n: a }, window.setTimeout(() => {
      this.ui.refPulse && this.ui.refPulse.n === a && (this.ui.refPulse = null);
    }, 900);
  }
  /** An image on the board, through the eyedropper: its record goes with it, for the run. */
  eyedropImage(e) {
    const t = this.ui.eyedropper;
    if (t && e.kind === "3d" && !e.resultId) {
      this.ui.eyedropper = null, this.openStudio({ sessionId: t.sessionId, elementId: e.id });
      return;
    }
    this.eyedrop(e.src, e.asset || this.assetFor(e.src), !!e.video);
  }
  // ---------------------------------------------------------------- Shift-drag to a session
  /**
   * An image on the board, Shift-dragged onto a session (IL-071): its card,
   * its row in the sessions rail, or its open prompt. It goes into the input
   * it was dropped on, else the session's first input that takes it (with
   * room, if one has), with its record for the run. The session opens, and
   * the picture glows softly in its prompt for a few seconds. One already
   * there isn't added twice; it glows again. `reveal` brings a session from
   * elsewhere on the board into view.
   */
  referenceImage(e, t, i = {}) {
    const s = this.store.get(e), o = this.store.get(t);
    if (!s || s.type !== "image" || !o || o.type !== "tool") return !1;
    const r = s.resultId ? this.results.get(s.resultId) : void 0;
    if (s.kind === "3d" || r && r.kind === "3d")
      return this.openStudio({ sessionId: t, elementId: e }), !1;
    const a = !!s.video, l = this.refFieldsOf(o), d = (p) => p.kind === "video" === a, c = i.key ? l.find((p) => p.key === i.key) : l.find((p) => d(p) && this.refImages(t, p.key).length < Zs(p)) || l.find(d);
    if (!c)
      return this.toast(l.length ? a ? o.name + " takes images, not videos." : o.name + " takes a video, not images." : o.name + " takes no images."), !1;
    if (!d(c))
      return this.toast(c.kind === "video" ? "This input takes a video, not images." : "This input takes images, not videos."), !1;
    const h = s.src;
    if (!this.refImages(t, c.key).includes(h) && !this.setRefInput(t, c.key, h, s.asset || this.assetFor(h))) return !1;
    i.reveal ? this.openSession(o) : this.ui.selection = [t];
    const f = (this.ui.refGlow ? this.ui.refGlow.n : 0) + 1;
    return this.ui.refGlow = { sessionId: t, url: h, n: f }, window.setTimeout(() => {
      this.ui.refGlow && this.ui.refGlow.n === f && (this.ui.refGlow = null);
    }, Jie), !0;
  }
  /**
   * Upload a file (a drop, a paste, the picker's Upload): to your uploads
   * where the host offers its pipeline, keeping the upload's record so a run
   * can send the picture without uploading it again.
   */
  async uploadFile(e) {
    const t = this.uploader;
    if (!t) throw new Error("Uploads aren't available here.");
    if (t.uploadRecord) {
      const i = await t.uploadRecord(e), s = i.upload ? { upload: i.upload } : null;
      return s && this.knownAssets.set(i.url, s), { url: i.url, asset: s };
    }
    return { url: await t.upload(e), asset: null };
  }
  /** Whether a video can be brought in from your computer (the host keeps it in your uploads). */
  get canUploadVideo() {
    return !!(this.uploader && this.uploader.uploadVideo);
  }
  /** A video into your uploads, as a run's video input takes it (TD-13). */
  async uploadVideoFile(e) {
    const t = this.uploader;
    if (!t || !t.uploadVideo) throw new Error("Videos can't be uploaded here.");
    const i = await t.uploadVideo(e), s = i.upload ? { upload: i.upload } : null;
    return s && this.knownAssets.set(i.url, s), { url: i.url, asset: s };
  }
  get hasLibrary() {
    return !!this.opts.library;
  }
  /** Your Library, where the host gives the board one (the harness has a demo one). */
  get libraryShelf() {
    return this.opts.library || null;
  }
  /** A page of your Library: your generations, uploads or favorites, from `q.cursor`, filtered and searched as `q` says. */
  libraryPage(e, t = {}) {
    const i = this.opts.library;
    return i ? e === "generations" ? i.generations(t) : e === "uploads" ? i.uploads(t) : i.favorites(t) : Promise.resolve({ items: [], next: null });
  }
  /**
   * Something deleted from your Library (CHAT-13): the pictures the Studios
   * view brought in from it go too, for good (what they pointed at is
   * deleted, so there's nothing to recover), with their marks; and the
   * sessions' prompts let go of it, or opening a Studios view would bring it
   * back from its queue. Matched by its upload, its result, or its file. The
   * prompts are those of the sessions it was brought into and those already
   * read; reading every session's saved prompt for it would read the board's.
   */
  forgetLibraryItem(e) {
    const t = e.run ? e.run.uuid : null, i = (d, c) => d === e.url ? !0 : c ? e.uploadId && "upload" in c && c.upload.id === e.uploadId ? !0 : !!t && "nodeRunResult" in c && c.nodeRunResult.uuid === t : !1;
    e.run && this.forgetDeletedResult(e.run.id, e.run.uuid, e.run.nodeId, e.url), this.forgottenLibrary.push(i);
    const s = this.studioRecords.all().filter((d) => d.role === "ref" && i(d.url, d.asset)), o = /* @__PURE__ */ new Set([...s.map((d) => d.sessionId), ...this.prompts.keys()]);
    for (const d of o) {
      if (!this.store.get(d)) continue;
      const h = this.promptOf(d).assets || {};
      this.dropPictures(d, (f) => i(f, h[f] || this.knownAssets.get(f)));
    }
    if (!s.length) return;
    const r = s.map((d) => d.id), a = this.studioRecords.all().filter((d) => d.role === "marks" && r.includes(d.target)).map((d) => d.id), l = [...r, ...a];
    this.studioRecords.remove(l), this.sync.purge(l), this.trashRev.value++;
  }
  /**
   * A result deleted somewhere else this visit (the Library: CHAT-52, Adam
   * deleted a picture there and its session still said 12): off the session's
   * history and card. Its session's history needn't be read for the card to
   * come right: one off its count, and its picture off the thumbnails.
   */
  forgetDeletedResult(e, t, i, s) {
    const o = this.results.ofRun(e).find((r) => r.uuid === t);
    o && (this.ui.infoAt === "result:" + o.id && (this.ui.infoAt = null), this.results.remove([o.id])), o && this.historyCursor.get(o.sessionId) === "end" ? this.recount(o.sessionId) : this.uncount(o || { id: e + ":" + t, sessionId: i, status: "done", url: s, w: 0, h: 0, prompt: "", model: "", createdAt: 0 });
  }
  /** A session's prompt without the Library items deleted this visit (forgetLibraryItem), once its saved draft is read. */
  dropForgotten(e) {
    if (!this.forgottenLibrary.length || !this.store.get(e)) return;
    const t = this.promptOf(e).assets || {};
    this.dropPictures(e, (i) => this.forgottenLibrary.some((s) => s(i, t[i] || this.knownAssets.get(i))));
  }
  /** A session's prompt without the pictures `gone` names, in its reference and its picture inputs. */
  dropPictures(e, t) {
    const i = this.promptOf(e), s = (l) => typeof l == "string" && t(l);
    let o = !1;
    const r = i.ref && s(i.ref) ? null : i.ref;
    r !== i.ref && (o = !0);
    const a = {};
    for (const [l, d] of Object.entries(i.inputs || {})) {
      if (s(d)) {
        o = !0;
        continue;
      }
      if (Array.isArray(d) && d.some(s)) {
        o = !0;
        const c = d.filter((h) => !s(h));
        c.length && (a[l] = c);
        continue;
      }
      a[l] = d;
    }
    o && this.setPrompt(e, { ref: r, inputs: a });
  }
  /** Keep a picture's record (a Library pick), so a run sends it without uploading it again. */
  rememberAsset(e, t) {
    this.knownAssets.set(e, t);
  }
  /** The record behind a picture on the board or in a gallery, if it has one. */
  assetFor(e) {
    const t = this.knownAssets.get(e);
    if (t) return t;
    for (const s of this.store.all())
      if (s.type === "image" && s.src === e && s.asset) return s.asset;
    const i = this.resultByUrl(e);
    return i && i.asset || null;
  }
  /**
   * A picture's or video's own pixels, for one with no record to say them (a
   * board picture that isn't a result or an upload, B26): read from the file
   * once it loads. Null until then, or if it can't be read.
   */
  measuredSize(e) {
    const t = this.measured.get(e);
    if (t !== void 0) return t;
    this.measured.set(e, null);
    const i = (o, r) => {
      o && r && this.measured.set(e, { width: o, height: r });
    }, s = new Image();
    return s.onload = () => i(s.naturalWidth, s.naturalHeight), s.onerror = () => {
      const o = document.createElement("video");
      o.preload = "metadata", o.onloadedmetadata = () => i(o.videoWidth, o.videoHeight), o.src = e;
    }, s.src = e, null;
  }
  resultByUrl(e) {
    this.results.rev.value;
    for (const t of this.allResults()) if (t.url === e || t.thumb === e) return t;
    return null;
  }
  allResults() {
    const e = [];
    for (const t of this.store.all()) t.type === "tool" && e.push(...this.results.list(t.id));
    return e;
  }
  /**
   * Into Recently Deleted, sessions too (with their history); a session's run
   * in flight stops. A locked frame and what it holds stay, and say why.
   */
  deleteIds(e) {
    const t = e.filter((r) => !this.isHeld(this.store.get(r))), i = e.filter((r) => Ro(this.store.get(r))).length, s = e.length - t.length - i;
    if (i && s ? this.toast("Locked frames and what they hold stay. Unlock the frames to delete them.") : i ? this.toast(i === 1 ? "The locked frame stays. Unlock it to delete it." : "Locked frames stay. Unlock them to delete them.") : s && this.toast(s === 1 ? "It's in a locked frame. Unlock the frame to delete it." : "These are in a locked frame. Unlock the frame to delete them."), !t.length) return;
    const o = t.filter((r) => {
      var a;
      return ((a = this.store.get(r)) == null ? void 0 : a.type) === "tool";
    });
    this.store.batch("Delete", () => this.store.remove(t));
    for (const r of o) {
      const a = this.runs.get(r);
      a && (a.cancel(), this.runs.delete(r), delete this.generating[r]);
    }
    this.ui.selection = this.ui.selection.filter((r) => !t.includes(r));
  }
  duplicateIds(e, t = 28) {
    const i = [], s = /* @__PURE__ */ new Map();
    for (const o of e) {
      const r = this.store.get(o);
      if (!r) continue;
      const a = JSON.parse(JSON.stringify(r));
      if (a.id = wt(), a.x += t, a.y += t, a.type === "frame" && delete a.locked, a.z = this.store.nextZ(a, a.type === "frame") + i.length, a.type === "tool")
        a.name = a.name + " copy", a.count = 0, a.thumbs = [];
      else if (a.type === "chat") {
        const l = a;
        l.name = l.name + " copy", l.messages = (l.messages || []).map((d) => d.plan && d.plan.status === "running" ? { ...d, plan: { ...d.plan, status: "stopped" } } : d);
      }
      s.set(o, a.id), i.push(a);
    }
    return i.length ? (this.store.batch("Duplicate", () => this.store.add(i)), this.ui.selection = i.map((o) => o.id), this.ui.selection) : [];
  }
  /**
   * Why Bring forward or Send back can't move any of `ids`, or null when it
   * can (B16: Blake found the commands dead on a shape over a picture). Order
   * only works inside a layer (frames, then pictures, then shapes, then notes,
   * sessions and chats), so a shape sent back stays over a picture: the
   * toolbar rests the button and says why, rather than doing nothing.
   */
  orderBlock(e, t) {
    const i = (a) => a === "frame" ? 0 : a === "image" ? 1 : a === "shape" ? 2 : 3, s = ["Frames stay under what they hold", "Pictures stay under shapes and notes", "Shapes stay under notes and sessions"], o = ["", "Pictures stay above frames", "Shapes stay above pictures", "Notes and sessions stay above pictures and shapes"];
    let r = null;
    for (const a of e) {
      const l = this.store.get(a);
      if (!l || Ro(l)) continue;
      const d = this.store.query(He(l)).filter((y) => y.id !== a);
      if (d.filter((y) => A_(y, l)).some((y) => t === "forward" ? y.z > l.z : y.z < l.z)) return null;
      const h = i(l.type), f = d.some((y) => t === "forward" ? i(y.type) > h : i(y.type) < h), p = f ? t === "forward" ? s[h] : o[h] : t === "forward" ? "Already at the front" : "Already at the back";
      (!r || f) && (r = p || r);
    }
    return r;
  }
  /** A card to the top of its layer, selected: a stack's fan picks one this way (CHAT-23). One undo step. */
  bringToTop(e) {
    const t = this.store.get(e);
    t && (Ro(t) || this.store.batch("Bring to top", () => this.store.update(e, { z: this.store.nextZ(t) })), this.select([e]));
  }
  /** Swap with the neighbour above / below, within the element's layer. A locked frame keeps its place. */
  reorder(e, t) {
    this.store.batch(t === "forward" ? "Bring forward" : "Send back", () => {
      for (const i of e) {
        const s = this.store.get(i);
        if (!s || Ro(s)) continue;
        const o = He(s), r = this.store.query(o).filter((a) => a.id !== i && A_(a, s));
        if (t === "forward") {
          const a = r.filter((d) => d.z > s.z).sort((d, c) => d.z - c.z)[0], l = a ? a.z + 0.5 : this.store.nextZ(s);
          this.store.update(i, { z: l });
        } else {
          const a = r.filter((d) => d.z < s.z).sort((d, c) => c.z - d.z)[0], l = a ? a.z - 0.5 : this.store.nextZ(s, !0);
          this.store.update(i, { z: l });
        }
      }
    });
  }
  /**
   * Lines up the selection; a locked frame and what it holds neither move nor count. A
   * frame lines up with what it holds, which goes with it rather than
   * lining up on its own (a selection can hold both since CHAT-26).
   */
  align(e) {
    var t, i;
    const s = this.ui.selection.map((c) => this.store.get(c)).filter((c) => c && !this.isHeld(c)), o = /* @__PURE__ */ new Map();
    for (const c of s) c.type === "frame" && o.set(c.id, this.carriedBy(c));
    const r = new Set(Array.from(o.values()).flat()), a = s.filter((c) => !r.has(c.id));
    if (a.length < 2) return;
    const l = a.map((c) => ({ id: c.id, ...He(c) })), d = [];
    if (e === "align-left") {
      const c = Math.min(...l.map((h) => h.x));
      l.forEach((h) => d.push([h.id, { x: c }]));
    } else if (e === "align-top") {
      const c = Math.min(...l.map((h) => h.y));
      l.forEach((h) => d.push([h.id, { y: c }]));
    } else if (e === "align-center") {
      const c = l.reduce((h, f) => h + f.y + f.h / 2, 0) / l.length;
      l.forEach((h) => d.push([h.id, { y: Math.round(c - h.h / 2) }]));
    } else {
      const c = l.slice().sort((x, w) => x.x - w.x), h = c[0].x, f = Math.max(...c.map((x) => x.x + x.w)), p = c.reduce((x, w) => x + w.w, 0), y = (f - h - p) / Math.max(1, c.length - 1);
      let v = h;
      c.forEach((x) => {
        d.push([x.id, { x: Math.round(v) }]), v += x.w + y;
      });
    }
    for (const [c, h] of d.slice()) {
      const f = o.get(c), p = this.store.get(c);
      if (!f || !p) continue;
      const y = ((t = h.x) != null ? t : p.x) - p.x, v = ((i = h.y) != null ? i : p.y) - p.y;
      for (const x of f) {
        const w = this.store.get(x);
        w && !this.isHeld(w) && d.push([x, { x: w.x + y, y: w.y + v }]);
      }
    }
    this.store.batch("Align", () => this.store.updateMany(d));
  }
  tint(e) {
    const t = [];
    for (const i of this.ui.selection) {
      const s = this.store.get(i);
      s && s.type === "note" && t.push([i, { tint: e }]);
    }
    t.length && this.store.batch("Tint", () => this.store.updateMany(t)), this.ui.noteTint = e;
  }
  /** Wrap the selection in a frame that hugs it. */
  groupIntoFrame() {
    const e = this.ui.selection.map((o) => this.store.get(o)).filter((o) => o && o.type !== "frame"), t = this.store.bounds(e.map((o) => o.id));
    if (!t) return;
    const i = 48, s = {
      id: wt(),
      type: "frame",
      x: Math.round(t.x - i),
      y: Math.round(t.y - i - 12),
      w: Math.round(t.w + i * 2),
      h: Math.round(t.h + i * 2 + 12),
      z: 0,
      title: "New frame"
    };
    s.z = this.store.nextZ(s, !0), this.store.batch("Group into frame", () => this.store.add([s])), this.ui.selection = [s.id], this.ui.editingTitle = s.id;
  }
  /**
   * Lock the selected frames (IL-070), or unlock them when every one is
   * locked already: one undo step. Only frames lock; with none selected it
   * does nothing.
   */
  toggleLock(e = this.ui.selection) {
    const t = e.map((r) => this.store.get(r)).filter((r) => r && r.type === "frame");
    if (!t.length) return;
    const i = t.some((r) => !r.locked), s = t.length === 1 ? " frame" : " " + t.length + " frames", o = t.map((r) => [r.id, { locked: i ? !0 : void 0 }]);
    this.store.batch((i ? "Lock" : "Unlock") + s, () => this.store.updateMany(o));
  }
  ctxAction(e) {
    const t = this.ui.selection.slice();
    e === "delete" ? this.deleteIds(t) : e === "duplicate" ? this.duplicateIds(t) : e === "copy" ? this.copy(!1) : e === "lock" ? this.toggleLock(t) : e === "rename" ? this.ui.editingTitle = t[0] : e === "style" ? this.ui.styleOpen = !this.ui.styleOpen : e === "info" ? this.ui.infoAt = t[0] : e === "save-prompt" ? (this.ui.infoAt = t[0], this.ui.infoSave = !0) : e === "frame" ? this.groupIntoFrame() : e === "download" ? this.download(t[0]) : e === "reference" ? this.useAsReference(t[0]) : e === "edit" ? this.openStudio({ elementId: t[0] }) : e === "forward" || e === "back" ? this.reorder(t, e) : e.startsWith("tint-") ? this.tint(e.slice(5)) : (e.startsWith("align-") || e === "distribute-h") && this.align(e);
  }
  /** Download a card's file: a video's own file, a 3D model's, named as v1 names results. */
  download(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    const i = t, s = i.download || i.videoSrc || i.src, o = i.resultId ? this.results.get(i.resultId) : void 0, r = (/(\.\w{3,4})(\?|$)/.exec(s.replace(/%2F/gi, "/")) || ["", ".webp"])[1];
    this.saveFile(s, o && o.uuid ? uf(o.prompt, o.uuid, s) : (i.label || "image") + r);
  }
  // ------------------------------------------------------------ board links (B33)
  /** The tour's practice board as it is now, to come back to (TD-03). */
  tourSnapshot() {
    const e = (t) => JSON.parse(JSON.stringify(t));
    return {
      elements: e(Array.from(this.store.all())),
      results: e(this.results.all()),
      prompts: e(Array.from(this.prompts.entries())),
      fresh: Array.from(this.freshTools),
      selection: this.ui.selection.slice(),
      studio: this.ui.studio ? { ...this.ui.studio } : null,
      chatOpen: this.ui.chatOpen,
      histOpen: this.ui.histOpen
    };
  }
  /** Put the practice board back as a snapshot found it: what the steps since added, ran or opened goes. */
  tourRestore(e) {
    const t = (s) => JSON.parse(JSON.stringify(s));
    this.ui.selection = [], this.store.load(t(e.elements)), this.results.clear(), this.results.upsert(t(e.results), !1), this.prompts.clear();
    for (const [s, o] of t(e.prompts)) this.prompts.set(s, o);
    this.bumpPrompt(), this.freshTools.clear();
    for (const s of e.fresh) this.freshTools.add(s);
    this.ui.chatOpen = e.chatOpen, this.ui.histOpen = e.histOpen;
    const i = this.ui.studio;
    e.studio ? (!i || i.sessionId !== e.studio.sessionId) && (this.ui.studio = { ...e.studio }) : i && this.closeStudio(), this.ui.selection = e.selection.filter((s) => !!this.store.get(s));
  }
  get canLinkBoards() {
    return !!this.opts.boardLinks;
  }
  /** The boards you can link to, from this board's own account, newest first, this one left out. */
  async linkableBoards(e = "") {
    const t = this.opts.boardLinks;
    return t ? (await t.list(this.meta.teamId || null, e.trim())).filter((s) => s.id !== this.meta.id).sort((s, o) => (o.at || 0) - (s.at || 0)) : [];
  }
  /** A card linking to a board, at a point (or near the view's middle), selected. One Undo step. */
  addBoardLink(e, t, i = {}) {
    const s = this.freeSpot(Fu.w, Fu.h, t), o = {
      id: i.id || wt(),
      type: "note",
      x: s.x,
      y: s.y,
      w: Fu.w,
      h: Fu.h,
      z: 0,
      tint: "vista",
      text: "",
      author: this.author(),
      createdBy: this.user.uid,
      link: { boardId: e.id, title: e.title, ...i.back ? { back: !0 } : {} }
    };
    return o.z = this.store.nextZ(o), this.store.add([o], i.quiet ? { history: !1 } : {}), i.quiet || (this.ui.selection = [o.id], this.revealNew(o, !!t)), o.id;
  }
  /** Make a board from a link's name, and link to it. */
  async addNewBoardLink(e, t) {
    const i = this.opts.boardLinks, s = e.trim() || "Untitled board";
    if (!i) return null;
    try {
      const o = await i.create(s), r = this.addBoardLink({ id: o.id, title: o.title || s }, t);
      return this.toast("Made " + (o.title || s) + " and linked it here"), r;
    } catch (o) {
      return console.error("[board] linked board not made", o), this.toast("The board couldn't be made. Try again.", "error"), null;
    }
  }
  /** Go to a link card's board; it links back to this one when you land. */
  openBoardLink(e) {
    const t = this.store.get(e), i = this.opts.boardLinks;
    if (!(!t || t.type !== "note" || !t.link || !i)) {
      if (this.missingBoards.value.has(t.link.boardId)) {
        this.toast(t.link.title + " isn't there any more, or you can't open it.", "error");
        return;
      }
      i.open(t.link.boardId, { id: this.meta.id, title: this.meta.title, teamId: this.meta.teamId || null, accessLevel: this.meta.accessLevel || null, ownerId: this.meta.ownerId || "" });
    }
  }
  /**
   * Whether this board may link back to the one you came from (R2): only
   * where everyone who can see this board could see that one's name anyway.
   * A board shared with the whole team links back from another of the
   * team's boards; a personal board links back from another of your own
   * personal boards. A private or restricted board, or one in another
   * account, gets no card here: its name isn't this board's people's to see.
   */
  mayLinkBack(e) {
    const t = this.meta;
    return e.teamId ? e.teamId === (t.teamId || null) && e.accessLevel === "SHARED" : !t.teamId && !!t.ownerId && t.ownerId === e.ownerId && e.ownerId === this.user.uid;
  }
  /**
   * Arrived by a link: this board links back to where you came from, unless
   * it already does, or that board's name isn't for this board's people
   * (R2). Its id is the source board's (R14), so two people landing at once
   * write one card, not two.
   */
  linkBack(e) {
    if (e.id !== this.meta.id) {
      for (const t of this.store.all())
        if (t.type === "note" && t.link && t.link.boardId === e.id) return;
      if (!this.mayLinkBack(e)) {
        this.toast("No link back to " + e.title + " here: it isn't shared with everyone who sees this board");
        return;
      }
      this.addBoardLink({ id: e.id, title: e.title }, void 0, { back: !0, quiet: !0, id: qie(e.id) }), this.toast("Linked back to " + e.title + ", so you can return to it");
    }
  }
  /**
   * Link cards keep their boards' titles, and say when one has gone or isn't
   * yours to open. Each linked board is looked up on its own (R11: a listing
   * capped at its first page, or kept to one account, took the rest for
   * gone); one that can't be read just now is left as it was.
   */
  async refreshLinks() {
    const e = this.opts.boardLinks, t = Array.from(this.store.all()).filter((a) => a.type === "note" && !!a.link);
    if (!e || !t.length) return;
    const i = Array.from(new Set(t.map((a) => a.link.boardId))), s = /* @__PURE__ */ new Map();
    if (await Promise.all(i.map(async (a) => {
      try {
        s.set(a, await e.get(a));
      } catch {
      }
    })), this.disposed) return;
    const o = /* @__PURE__ */ new Set(), r = [];
    for (const a of t) {
      const l = a.link.boardId;
      if (!s.has(l)) continue;
      const d = s.get(l);
      d ? d.title && d.title !== a.link.title && r.push([a.id, { link: { ...a.link, title: d.title } }]) : o.add(l);
    }
    this.missingBoards.value = o, r.length && this.store.updateMany(r, { history: !1 });
  }
  /**
   * Fold session and chat cards to their title bars, or open them again
   * (ADMIN-002: Blake, to move them out of the way in a busy frame): all of
   * them fold unless every one already is. One Undo step.
   */
  toggleCollapsed(e) {
    const t = e.map((s) => this.store.get(s)).filter((s) => !!s && (s.type === "tool" || s.type === "chat") && !this.isHeld(s));
    if (!t.length) return;
    const i = t.some((s) => !s.collapsed);
    this.store.batch(i ? "Collapse" : "Expand", () => this.store.updateMany(t.map((s) => [s.id, { collapsed: i }])));
  }
  /** Download a result from a gallery's hover: a 3D model's own file (P3-11), else the picture, named as v1 names results. */
  downloadResult(e) {
    const t = e.download || e.videoSrc || e.url;
    this.saveFile(t, e.uuid ? uf(e.prompt, e.uuid, t) : e.label || "result"), e.runId && this.trackDownload(e);
  }
  /**
   * An image goes back to the session that made it (its `sessionId`), as that
   * session's reference, and the session opens. An image no session on the
   * board made (an upload, a drop, one whose session was deleted) goes to the
   * session used last.
   */
  useAsReference(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    const i = t;
    let s = this.toolFor(i);
    if (!s) {
      const r = this.ui.recentIds.find((a) => {
        var l;
        return ((l = this.store.get(a)) == null ? void 0 : l.type) === "tool";
      });
      s = r ? this.store.get(r) : null;
    }
    if (!s) {
      this.toast("Add a tool session first, then use this image as its reference.");
      return;
    }
    const o = this.addReference(s.id, i.src, i.asset || null);
    this.openSession(s), o && this.toast("Added as the reference for " + s.name);
  }
  // ---------------------------------------------------------------- the Studios view
  /**
   * Open the Studios view (plans/board-canvas/studios-view.md) on an image,
   * in its own session as Use as reference finds it (an image no session
   * made goes to the session used last); on a session's result; or on a
   * session alone.
   */
  openStudio(e) {
    let t = e.sessionId || null;
    if (e.resultId && !t) {
      const s = this.results.get(e.resultId);
      s && (t = s.sessionId);
    }
    const i = e.elementId ? this.store.get(e.elementId) : void 0;
    if (!(e.elementId && (!i || i.type !== "image"))) {
      if (i && !t) {
        let s = this.toolFor(i);
        if (!s) {
          const o = this.ui.recentIds.find((r) => {
            var a;
            return ((a = this.store.get(r)) == null ? void 0 : a.type) === "tool";
          });
          s = o ? this.store.get(o) : null;
        }
        if (!s) {
          for (const o of this.store.all())
            if (o.type === "tool") {
              s = o;
              break;
            }
        }
        s || (s = this.newImageSession({ x: i.x + i.w + Rt.w / 2 + 48, y: i.y + Math.min(i.h, Rt.h) / 2 })), t = s ? s.id : null;
      }
      if (!t || !this.store.get(t)) {
        this.toast("Add an image session first, then open it in Studio view.");
        return;
      }
      this.ui.infoAt = null, this.ui.addMenu = !1, this.ui.studio = {
        sessionId: t,
        elementId: e.elementId,
        resultId: e.resultId,
        n: (this.ui.studio ? this.ui.studio.n : 0) + 1
      };
    }
  }
  /**
   * Back in the Studios view a refresh left (CHAT-07), once its session's
   * saved draft is in: the view reads the draft's words and pictures as it
   * opens. Opened before, its queue went without the draft's pictures, and
   * the next picture queued saved over them. A draft still waiting for the
   * catalog to read it holds the view up a few seconds at most.
   */
  restoreStudio(e) {
    const t = () => {
      var s;
      this.disposed || this.ui.studio || ((s = this.store.get(e)) == null ? void 0 : s.type) !== "tool" || this.openStudio({ sessionId: e });
    }, i = this.opts.prompts;
    if (!i) {
      t();
      return;
    }
    i.follow(e).catch(() => {
    }).then(() => this.whenDecoded(e, T_)).then(t);
  }
  /** Once a session's saved draft has been read against the catalog (it waits there for its tool's definition), or `ms` at most. */
  whenDecoded(e, t) {
    return this.undecoded.has(e) ? new Promise((i) => {
      let s = !1;
      const o = () => {
        s || (s = !0, r(), clearTimeout(a), i());
      }, r = Ee(() => (this.promptRev.value, this.undecoded.has(e)), (l) => {
        l || o();
      }), a = window.setTimeout(o, t);
    }) : Promise.resolve();
  }
  closeStudio() {
    this.ui.studio = null, this.ui.infoAt = null;
  }
  // ---------------------------------------------------------------- notes
  setNoteText(e, t) {
    const i = this.store.get(e);
    !i || i.text === t || this.patch(e, { text: t }, "Edit note");
  }
  renameFrame(e, t) {
    const i = t.trim() || "Untitled frame";
    this.patch(e, { title: i }, "Rename frame");
  }
  renameTool(e, t) {
    const i = t.trim();
    i && this.patch(e, { name: i }, "Rename session");
  }
  renameBoard(e) {
    const t = e.trim() || "Untitled board";
    t !== this.meta.title && (this.meta.title = t, this.sync.saveMeta({ title: t }), this.opts.onTitle && this.opts.onTitle(t));
  }
  // --------------------------------------------------------------- shapes
  armShape(e) {
    this.ui.eyedropper = null, this.ui.shapeKind = e, this.ui.shapeArmed = !0, this.ui.shapeMenu = !1, this.ui.mode = "select", this.ui.selection = [], this.ui.styleOpen = !1;
  }
  /** Select or Pan (the rail's buttons, V and H): either puts down the shape tool, the eyedropper and the Comment tool (TD-05). */
  setMode(e) {
    this.ui.mode = e, this.ui.shapeArmed = !1, this.ui.eyedropper = null, this.comments.arm(!1);
  }
  /** The last style used becomes the default for the next shape. */
  patchShape(e, t) {
    this.patch(e, t, "Restyle shape"), this.ui.shapeStyle = { ...this.ui.shapeStyle, ...t.stroke ? { stroke: t.stroke } : {}, ...t.sw ? { sw: t.sw } : {} };
  }
  // ----------------------------------------------------------- generation
  modelFor(e) {
    const t = this.catalog.value, i = t.kits.find((a) => a.id === e.kitId) || null, s = i && (i.models.find((a) => !!e.nodeDefId && a.id === e.nodeDefId) || i.models.find((a) => a.name === e.model)) || null;
    if (i && s) return { kit: i, model: s };
    const o = e.nodeDefId && t.byId.get(e.nodeDefId) || t.byName.get(e.model) || null, r = o && Tv(t, o, e.kitId) || i || t.kits.find((a) => a.name === e.kind) || t.kits[0] || null;
    return { kit: r, model: o || (r ? Bi(r) : null) };
  }
  /** The first run names the tool after the prompt's opening clause. */
  static conceptName(e) {
    const t = String(e || "").split(/[,.;\n]/)[0].trim().replace(/\s+/g, " ");
    if (!t) return null;
    let i = t.split(" ").slice(0, 4).join(" ");
    return i.length > 30 && (i = i.slice(0, 30).replace(/\s\S*$/, "")), i ? i.charAt(0).toUpperCase() + i.slice(1) : null;
  }
  /** Your run in this session is being sent (a moment; then it's in flight like anyone's). */
  submitting(e) {
    return this.promptRev.value, !!this.generating[e] && this.runs.has(e);
  }
  /**
   * Run a session's tool with your prompt. Answers null when the run went,
   * else why it didn't (also told in a toast): a chat's plan reports it.
   */
  generate(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "tool") return "This session is no longer on the board.";
    if (this.runs.has(e)) return "This session is still sending its last run.";
    const { model: i } = this.modelFor(t);
    if (!i)
      return this.toast("No model is available for this session.", "error"), "No model is available for this session.";
    const s = this.promptOf(e), o = Xi(i, s, this.countFor(i, s), !!this.user.isAdmin), r = this.accountProblem() || o.problems[0] || this.tokensProblem(o.price);
    if (r)
      return this.toast(Ka(r), "error"), Ka(r);
    if (this.opts.runs)
      return this.generateReal(t, i, s), null;
    const a = { ...s.inputs || {} }, l = this.countFor(i, s), d = s.ref ? [s.ref] : [];
    this.generating[e] = !0, this.freshTools.delete(e), t.error && this.store.update(e, { error: null }, { history: !1 });
    const c = this.gen.run({
      sessionId: e,
      model: i,
      prompt: s.prompt || "",
      inputs: a,
      refs: d,
      count: l,
      aspect: a.aspect || void 0,
      author: this.author()
    }, {
      onResult: (h) => {
        this.results.upsert([h]), this.countStubResult(e, h, s.prompt || "");
      },
      onDone: () => {
        this.runs.delete(e), delete this.generating[e];
      },
      onError: (h, f) => {
        this.runs.delete(e), delete this.generating[e], this.results.remove(f.map((p) => p.id)), this.tellRunError(e, h);
      }
    });
    return this.runs.set(e, c), this.results.upsert(c.pending, !1), null;
  }
  /**
   * A real run: images without a record (a picture on the board that isn't a
   * result or an upload) go to your uploads first, then your prompt is saved
   * as your run draft and runRunnitNode runs it. The run, and its results,
   * arrive with the board's runs.
   */
  async generateReal(e, t, i) {
    const s = e.id, o = this.countFor(t, i), r = { runId: "", pending: [], cancel: () => {
    } };
    this.runs.set(s, r), this.generating[s] = !0, this.freshTools.delete(s), e.error && this.store.update(s, { error: null }, { history: !1 });
    const a = (h) => {
      this.disposed || (this.runs.delete(s), this.settleGenerating(s), this.tellRunError(s, h));
    };
    let l = i, d = Eo(t, l);
    if (d.pending.length) {
      let h;
      try {
        h = await this.uploadPending(s, d.pending);
      } catch (p) {
        a(p instanceof Error && p.message || "An image couldn't be uploaded, so the run didn't start.");
        return;
      }
      if (this.disposed) return;
      if (l = { ...i, assets: { ...i.assets || {}, ...h } }, d = Eo(t, l), d.pending.length) {
        a("An image couldn't be uploaded, so the run didn't start.");
        return;
      }
      const f = Xi(t, l, o, !!this.user.isAdmin).problems[0];
      if (f) {
        a(Ka(f));
        return;
      }
    }
    if (this.disposed) return;
    const c = this.gen.run({
      sessionId: s,
      model: t,
      prompt: l.prompt || "",
      inputs: { ...l.inputs || {} },
      refs: l.ref ? [l.ref] : [],
      count: o,
      author: this.author(),
      // with the values the tool sets for itself (a video's length, a forced model)
      v1Inputs: Mv(t, d.inputs, l).values
    }, {
      onStarted: (h) => {
        if (this.disposed) return;
        this.runs.delete(s), this.followRun(h, s, o, l.prompt || "");
        const f = t.raw;
        this.track("generation_run", {
          node_def_id: t.id,
          tool_title: t.name,
          app_type: "RUNNIT",
          cost_per_result: f ? f.costPerResult : null,
          runnit_id: this.meta.id,
          is_team_run: !!this.meta.teamId,
          is_first_run: this.firstRunEver()
        });
      },
      onResult: () => {
      },
      onDone: () => {
      },
      onError: (h) => a(h)
    });
    r.cancel = () => c.cancel();
  }
  /**
   * Pictures without a record go to your uploads (as a drop would), so a run
   * can send them. Their records also go into the session's prompt, so the
   * next run doesn't upload them again.
   */
  async uploadPending(e, t) {
    const i = await this.uploadPictures(t);
    return this.disposed || this.setPrompt(e, { assets: i }), i;
  }
  /** Pictures (by URL) into your uploads, for a run to send: each one's record. */
  async uploadPictures(e) {
    if (!this.uploader || !this.uploader.uploadRecord)
      throw new Error("That image can't be sent to a tool from here. Upload it, or use one of your results.");
    const t = {};
    for (const i of e) {
      const s = await fetch(nse(i), { mode: "cors" }).catch(() => null);
      if (!s || !s.ok) throw new Error("An image couldn't be read, so the run didn't start.");
      const o = await s.blob(), r = (o.type.split("/")[1] || "png").replace("jpeg", "jpg"), a = new File([o], "board-reference." + r, { type: o.type || "image/png" }), l = await this.uploader.uploadRecord(a);
      if (!l.upload) throw new Error("An image couldn't be uploaded, so the run didn't start.");
      t[i] = { upload: l.upload };
    }
    return t;
  }
  /** A stub run's result landed: count it on its session card, as countRun counts a real one. */
  countStubResult(e, t, i) {
    const s = this.store.get(e);
    if (!s) return;
    const o = [t.url].concat(s.thumbs || []).slice(0, 6), r = /^(Image|Video|3D|Upscale) Tool \d+$/.test(s.name || "") && Rf.conceptName(i);
    this.store.update(e, {
      thumbs: o,
      count: (s.count || 0) + 1,
      lastRunAt: Date.now(),
      ...r ? { name: r } : {}
    }, { history: !1 }), this.ui.newThumbs = { ...this.ui.newThumbs, [e]: Math.min(4, (this.ui.newThumbs[e] || 0) + 1) }, clearTimeout(this.newThumbTimers.get(e)), this.newThumbTimers.set(e, window.setTimeout(() => {
      const a = { ...this.ui.newThumbs };
      delete a[e], this.ui.newThumbs = a;
    }, 1400));
  }
  // ---------------------------------------------------------------- the Studios view's runs
  /**
   * A run from the Studios view (IL-045). Its model may not be the session's
   * and its prompt isn't your session prompt, which stays as it was (on a
   * real board, it goes back into your run draft once the run has taken
   * it). Checked as v1's Run button checks a run. An Edit run records the
   * picture it changed, so its results are that picture's next versions.
   * Answers once the run is on its way, with its id, or with why it isn't.
   */
  async runStudio(e) {
    const t = this.store.get(e.sessionId);
    if (!t || t.type !== "tool") return { error: "This session is no longer on the board." };
    const i = Xi(e.model, e.up, e.count, !!this.user.isAdmin), s = this.accountProblem() || i.problems[0] || this.tokensProblem(i.price);
    return s ? { error: Ka(s) } : (this.freshTools.delete(t.id), t.error && this.store.update(t.id, { error: null }, { history: !1 }), this.opts.runs ? this.runStudioReal(t, e) : this.runStudioStub(t, e));
  }
  /** The harness's run: the stub's results, landing on the session card as a real run's do. */
  runStudioStub(e, t) {
    const { model: i, up: s, count: o } = t, r = { ...s.inputs || {} }, a = s.masks ? Object.values(s.masks)[0] : null;
    a && typeof a.boardMask == "string" && (r.__mask = a.boardMask);
    let l = "";
    const d = this.gen.run({
      sessionId: e.id,
      model: i,
      prompt: s.prompt || "",
      inputs: r,
      refs: Tf(i, s),
      count: o,
      aspect: typeof r.aspect == "string" ? r.aspect : void 0,
      author: this.author()
    }, {
      onResult: (c) => {
        this.results.upsert([c]), this.countStubResult(e.id, c, t.words);
      },
      onDone: () => this.markDone(e.id, l),
      onError: (c, h) => {
        this.markDone(e.id, l), this.results.remove(h.map((f) => f.id)), t.onFail && t.onFail(c);
      }
    });
    return l = d.runId, this.results.upsert(d.pending, !1), this.markRunning(e.id, l, Date.now()), this.studioRuns.set(l, t.words), t.edit && this.recordEdit(e.id, l, t.edit), { runId: l };
  }
  /**
   * A real run: pictures without a record go to your uploads first, and so
   * does a generation queued ahead of an upload (an input that takes several
   * sends its uploads first, so the model would get them out of order).
   */
  async runStudioReal(e, t) {
    const { model: i, count: s } = t;
    let o = t.up, r = Eo(i, o);
    const a = Ene(i, o).filter((h) => !r.pending.includes(h)), l = r.pending.concat(a);
    if (l.length) {
      let h;
      try {
        h = await this.uploadPictures(l);
      } catch (p) {
        return { error: p instanceof Error && p.message || "An image couldn't be uploaded, so the run didn't start." };
      }
      if (this.disposed) return { error: "The board was closed, so the run didn't start." };
      if (o = { ...o, assets: { ...o.assets || {}, ...h } }, r = Eo(i, o), r.pending.length) return { error: "An image couldn't be uploaded, so the run didn't start." };
      const f = Xi(i, o, s, !!this.user.isAdmin).problems[0];
      if (f) return { error: Ka(f) };
    }
    const d = this.draftOf(e), c = o.prompt || "";
    return new Promise((h) => {
      let f = !1;
      const p = (v) => {
        f || (f = !0, h(v));
      }, y = window.setTimeout(() => p({ error: "The run is taking a while to start. If it went, its results will appear here." }), Kie);
      this.gen.run({
        sessionId: e.id,
        model: i,
        prompt: c,
        inputs: { ...o.inputs || {} },
        refs: Tf(i, o),
        count: s,
        author: this.author(),
        // with the values the tool sets for itself (a video's length, a forced model)
        v1Inputs: Mv(i, r.inputs, o).values,
        restore: d
      }, {
        onStarted: (v) => {
          if (clearTimeout(y), this.disposed) return;
          this.studioRuns.set(v, t.words), t.onFail && this.studioFails.set(v, t.onFail), t.edit && this.recordEdit(e.id, v, t.edit), this.followRun(v, e.id, s, c);
          const x = i.raw;
          this.track("generation_run", {
            node_def_id: i.id,
            tool_title: i.name,
            app_type: "RUNNIT",
            cost_per_result: x ? x.costPerResult : null,
            runnit_id: this.meta.id,
            is_team_run: !!this.meta.teamId,
            is_first_run: this.firstRunEver()
          }), p({ runId: v });
        },
        onResult: () => {
        },
        onDone: () => {
        },
        onError: (v) => {
          clearTimeout(y), p({ error: v });
        }
      });
    });
  }
  /** Your session prompt as its run draft keeps it: what a Studios view run puts back. */
  draftOf(e) {
    const { model: t } = this.modelFor(e);
    if (!t) return null;
    const i = this.promptOf(e.id);
    return { nodeDefId: t.id, inputs: Eo(t, i, "draft").inputs, numResults: this.countFor(t, i) };
  }
  /** An Edit run's record: the picture it changed, so its results are that picture's next versions, and what the tool set. */
  recordEdit(e, t, i) {
    this.studioRecords.put({
      ...bl,
      id: Ep(t),
      type: "studio",
      role: "edit",
      sessionId: e,
      runId: t,
      base: i.base,
      studio: i.studio,
      createdAt: Date.now(),
      ...i.settings ? { settings: i.settings } : {},
      ...i.helper ? { helper: !0 } : {},
      ...i.precision ? { precision: i.precision } : {}
    });
  }
  /**
   * An area's mask, as v1's inpainting masks are kept (a runnitMasks record,
   * which a run's picture input carries as its mask): through the host's
   * pipeline, where it has one.
   */
  async uploadMask(e) {
    const t = this.opts.studio && this.opts.studio.uploadMask;
    if (!t) throw new Error("Masks can't be kept from here, so this edit can't run.");
    return t(e);
  }
  /** A real board's runs (runRunnitNode), rather than the harness's stub. */
  get realRuns() {
    return !!this.opts.runs;
  }
  /** Whether marked pictures are flattened by v1's annotation service (real boards), rather than here. */
  get canAnnotate() {
    return !!(this.opts.studio && this.opts.studio.annotate);
  }
  /**
   * A marked picture made one, to send in its place: by v1's annotation
   * service, which scales the overlay to the picture's full size, flattens
   * them and keeps the result in your uploads. A picture without a record
   * goes to your uploads first.
   */
  async flattenPicture(e, t) {
    const i = this.opts.studio && this.opts.studio.annotate;
    if (!i) throw new Error("Annotated pictures can't be sent from here.");
    let s = e.asset;
    const o = !!s && "upload" in s && typeof s.upload.userId == "string" && s.upload.userId !== this.user.uid;
    (!s || o) && (s = (await this.uploadPictures([e.url]))[e.url] || null);
    const r = s ? Ane(s) : null;
    if (!r) throw new Error("This picture can't be annotated for a run. Try one of your results or uploads.");
    const l = { upload: await i(r, t) };
    return { url: this.assetUrl(l), asset: l };
  }
  /** The Studios view's 3D: the host's Babylon, when it lends one. */
  get babylon() {
    return this.opts.studio && this.opts.studio.babylon || null;
  }
  /** A 3D model into your Library, where the host can keep one; null where it can't (the harness). */
  upload3d(e) {
    const t = this.opts.studio && this.opts.studio.upload3d;
    return t ? t(e) : null;
  }
  /**
   * Show another picture in a card's place on the canvas (the Studios view's
   * Promote, IL-045): another version of the same image. The card keeps its
   * place and width; its height follows the new picture's shape. One undo step.
   */
  showOnCard(e, t) {
    const i = this.store.get(e);
    if (!i || i.type !== "image" || !t.w || !t.h) return !1;
    const s = Math.max(1, Math.round(i.w * (t.h / t.w))), o = {
      src: t.url,
      h: s,
      tiers: void 0,
      color: void 0,
      label: t.label || i.label,
      resultId: t.resultId || void 0,
      sessionId: t.sessionId || i.sessionId,
      asset: t.asset || void 0,
      fav: t.fav || void 0,
      video: void 0,
      videoSrc: void 0,
      previewSrc: void 0,
      dur: void 0,
      download: void 0,
      kind: void 0
    };
    return this.patch(e, o, "Show another version"), !0;
  }
  /** Follow a run you started until it's over, and tell you how it went. */
  followRun(e, t, i, s) {
    if (this.onStep) {
      const h = this.store.get(t);
      this.onStep("run", "Ran " + (h && h.type === "tool" ? h.model : "a session") + " for " + i + (i === 1 ? " result" : " results"), "run " + e + ", session " + t);
    }
    const o = this.opts.runs;
    if (!o) return;
    const r = Date.now(), a = [];
    for (let h = 0; h < i; h++)
      a.push({
        id: `${e}:p${h}`,
        sessionId: t,
        runId: e,
        status: "pending",
        url: "",
        w: 0,
        h: 0,
        prompt: s,
        model: "",
        createdAt: r + h,
        startedAt: r,
        userId: this.user.uid
      });
    this.results.replaceRun(e, a), this.markRunning(t, e, r);
    const l = window.setTimeout(() => {
      this.settleStart(e, t).catch(() => {
      });
    }, Yie);
    this.started.set(e, { sessionId: t, unwatch: () => {
    }, timer: l, seen: !1 });
    const d = o.watchRun(e, (h) => {
      h && this.onRun(h);
    }), c = this.started.get(e);
    c ? c.unwatch = d : d();
  }
  /**
   * A run answered success but hasn't shown up. runRunnitNode answers success
   * for a few failures it swallows, and a listener can also miss a run that
   * went (a dropped connection), so the server has the last word: a run's
   * charge is written with its document. There, it's followed as usual; not
   * there, it never started and cost nothing. When the server can't be
   * asked, nobody can say yet, and the board's runs bring it if it went.
   */
  async settleStart(e, t) {
    const i = this.opts.runs, s = this.started.get(e);
    if (!i || !s || s.seen) return;
    let o;
    try {
      o = await i.getRun(e, !0);
    } catch {
      o = void 0;
    }
    const r = this.started.get(e);
    if (this.disposed || !r || r.seen) return;
    if (o) {
      this.onRun(o);
      return;
    }
    this.endFollow(e), this.results.replaceRun(e, []), this.markDone(t, e);
    const a = o === null ? "The run didn't start, so nothing was charged. Please try again." : "We couldn't confirm the run started. If it did, its results will appear here, so wait a moment before running it again.";
    this.tellRunError(t, a);
    const l = this.studioFails.get(e);
    l && (this.studioFails.delete(e), l(a));
  }
  endFollow(e) {
    const t = this.started.get(e);
    t && (t.unwatch(), clearTimeout(t.timer), this.started.delete(e));
  }
  /** A run on this board changed: yours, or anyone's on the team. */
  onRun(e) {
    if (this.disposed) return;
    const t = this.started.get(e.id);
    t && !t.seen && (t.seen = !0, clearTimeout(t.timer));
    const i = fS(e, {
      storageUrl: (s) => this.opts.storageUrl ? this.opts.storageUrl(s) : s,
      modelName: (s) => {
        const o = this.toolModel(s);
        return o ? o.name : "Tool";
      },
      authorName: (s, o) => s === this.user.uid ? this.author() : o ? o.split("@")[0] : "Someone else"
    });
    if (this.results.replaceRun(e.id, i), uS(e.state)) {
      this.markRunning(e.nodeId, e.id, e.initAt || Date.now());
      return;
    }
    this.markDone(e.nodeId, e.id), KW(e.state) && this.finishRun(e, i);
  }
  onRunGone(e) {
    if (!this.started.has(e))
      for (const [t, i] of this.inflight) i.has(e) && this.markDone(t, e);
  }
  markRunning(e, t, i) {
    let s = this.inflight.get(e);
    s || (s = /* @__PURE__ */ new Map(), this.inflight.set(e, s)), s.set(t, i), this.generating[e] = !0, this.runningSince[e] = Math.min(...Array.from(s.values()));
  }
  markDone(e, t) {
    const i = this.inflight.get(e);
    i && (i.delete(t), i.size || this.inflight.delete(e)), this.settleGenerating(e);
  }
  settleGenerating(e) {
    const t = this.inflight.get(e);
    t && t.size ? (this.generating[e] = !0, this.runningSince[e] = Math.min(...Array.from(t.values()))) : this.runs.has(e) || (delete this.generating[e], delete this.runningSince[e]);
  }
  /** A run finished: count it on its session card (once), and tell whoever started it how it went. */
  finishRun(e, t) {
    const i = this.started.has(e.id);
    i && this.endFollow(e.id);
    const s = t.filter((a) => a.status === "done"), o = t.filter((a) => a.status === "moderated").length;
    if (i && this.onStep) {
      const a = e.state === "ERROR" ? "A run failed" : "A run finished with " + s.length + (s.length === 1 ? " result" : " results") + (o ? ", " + o + " withheld" : "");
      this.onStep(e.state === "ERROR" ? "error" : "run", a, "run " + e.id + ", state " + e.state + ", model " + e.nodeDefId);
    }
    const r = this.studioFails.get(e.id);
    r && this.studioFails.delete(e.id), i && (e.state === "ERROR" ? (this.tellRunError(e.nodeId, "The run failed, so its tokens are being refunded. Try again, or try another model."), r && r("The run failed, so its tokens are being refunded. Try again, or try another model.")) : o && this.toast((o === 1 ? "A result was" : o + " results were") + " withheld by the safety check.", "error")), s.length && this.countRun(e, s, i);
  }
  /**
   * A run of yours failed: the card says so (the message in its tooltip),
   * and the session's prompt says why. A toast only when that prompt isn't
   * open, so the same news isn't told twice.
   */
  tellRunError(e, t) {
    this.store.update(e, { error: t }, { history: !1 });
    const i = this.promptTool.value;
    (!i || i.id !== e) && this.toast(t, "error");
  }
  /**
   * Fold a finished run into its session card: the newest thumbnails, the
   * count, when it last ran. Whoever ran it does this; anyone does, for a run
   * left uncounted (its runner closed the board before it finished). `ran`
   * keeps one run from being counted twice.
   */
  countRun(e, t, i) {
    const s = this.store.get(e.nodeId) || null;
    if (!s || s.type !== "tool") return;
    const o = s.ran || [];
    if (o.includes(e.id)) return;
    const r = e.doneAt || e.initAt || Date.now(), a = e.userId === this.user.uid;
    if (s.lastRunAt && r < s.lastRunAt - 1e3 && !i || !a && Date.now() - r < Xie) return;
    const l = t.map((h) => h.url).concat(s.thumbs || []).filter((h, f, p) => !!h && p.indexOf(h) === f).slice(0, 6), d = this.studioRuns.has(e.id) ? this.studioRuns.get(e.id) || "" : t[0].prompt || "", c = i && /^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(s.name || "") && Rf.conceptName(d);
    this.store.update(e.nodeId, {
      thumbs: l,
      count: (s.count || 0) + t.length,
      lastRunAt: Math.max(s.lastRunAt || 0, r),
      ran: [e.id].concat(o).slice(0, 12),
      error: null,
      ...c ? { name: c } : {}
    }, { history: !1 }), i && (this.ui.newThumbs = { ...this.ui.newThumbs, [e.nodeId]: Math.min(4, t.length) }, clearTimeout(this.newThumbTimers.get(e.nodeId)), this.newThumbTimers.set(e.nodeId, window.setTimeout(() => {
      const h = { ...this.ui.newThumbs };
      delete h[e.nodeId], this.ui.newThumbs = h;
    }, 1400)));
  }
  /**
   * A result deleted from its session's history comes off the session's card:
   * one fewer, and its thumbnail gone, the next newest the board holds taking
   * its place. Only a finished result was ever counted (finishRun).
   */
  uncount(e) {
    const t = this.store.get(e.sessionId) || null;
    if (!t || t.type !== "tool" || e.status !== "done") return;
    const i = (t.thumbs || []).filter((o) => o !== e.url), s = this.results.list(e.sessionId).filter((o) => o.status === "done").map((o) => o.url);
    this.store.update(t.id, {
      count: Math.max(0, (t.count || 0) - 1),
      thumbs: i.concat(s).filter((o, r, a) => !!o && a.indexOf(o) === r).slice(0, 6)
    }, { history: !1 });
  }
  /**
   * A session's whole history is in: its card says what that history holds.
   * The count is a tally kept as runs finish (countRun), so a result deleted
   * somewhere else (the Library, v1, another person) or two runs counted at
   * once leaves it off, and this is where it comes right. Only a complete
   * history can say (a long one pages in as its gallery scrolls), and only for
   * a card that has counted real runs: the demo board's seeded cards keep what
   * they were made with.
   */
  recount(e) {
    const t = this.store.get(e) || null;
    if (!t || t.type !== "tool" || !(t.ran && t.ran.length)) return;
    const i = this.results.list(e).filter((a) => a.status === "done"), s = i.map((a) => a.url).filter((a, l, d) => !!a && d.indexOf(a) === l).slice(0, 6), o = t.thumbs || [];
    if ((t.count || 0) === i.length && o.length === s.length && o.every((a, l) => a === s[l])) return;
    const r = i.map((a) => a.runId).filter((a, l, d) => !!a && d.indexOf(a) === l).slice(0, 12);
    this.store.update(e, { count: i.length, thumbs: s, ran: r }, { history: !1 });
  }
  /** A session's past runs, a page at a time (its gallery asks as it scrolls). */
  async loadHistory(e) {
    const t = this.opts.runs;
    if (!t) return;
    const i = this.historyCursor.get(e);
    if (i === "end") return;
    const s = await t.sessionPage(e, i == null ? null : i).catch((r) => (console.warn("[board] session history unavailable", r), null));
    if (!s || this.disposed) return;
    for (const r of s) this.onRun(r);
    const o = s.length ? s[s.length - 1].initAt : null;
    this.historyCursor.set(e, s.length < 24 || o == null ? "end" : o), this.historyCursor.get(e) === "end" && this.recount(e);
  }
  historyDone(e) {
    return this.historyCursor.get(e) === "end" || !this.opts.runs;
  }
  /**
   * The board's history, a page further back: every session's runs, older
   * than the newest the board follows (watchRecent) and what's been paged.
   */
  async loadBoardHistory() {
    const e = this.opts.runs;
    if (!e || this.boardCursor === "end") return;
    const t = 40, i = await e.boardPage(this.boardCursor, t).catch((o) => (console.warn("[board] the board's history unavailable", o), null));
    if (!i || this.disposed) return;
    for (const o of i) this.onRun(o);
    const s = i.length ? i[i.length - 1].initAt : null;
    this.boardCursor = i.length < t || s == null ? "end" : s;
  }
  boardHistoryDone() {
    return this.boardCursor === "end" || !this.opts.runs;
  }
  /** Remix: a fresh session preloaded with the image's prompt and model. */
  remixFrom(e, t) {
    this.ui.infoAt = null;
    const i = this.catalog.value, s = this.remixHome(e, t);
    if (s) return this.remixInSession(s.tool, s.model, e, t);
    const o = t && t.modelId && i.byId.get(t.modelId) || null, r = o && Tv(i, o) || i.kits.find((p) => p.id === (e.video ? "video" : "image")) || i.kits[0];
    if (!r) return;
    const a = o || t && r.models.find((p) => p.name === t.model) || r.models[0], l = this.freeSpot(Rt.w, Rt.h), d = {
      id: wt(),
      type: "tool",
      x: l.x,
      y: l.y,
      w: Rt.w,
      h: Rt.h,
      z: 0,
      name: this.nextToolName(r.name),
      kind: r.name,
      kitId: r.id,
      model: a.name,
      nodeDefId: a.id,
      icon: Nl[r.id] || "Image",
      count: 0,
      thumbs: [],
      createdBy: this.user.uid
    };
    d.z = this.store.nextZ(d), this.store.add([d]), t && t.runId && this.track("remix_initiated", { node_def_id: t.modelId || null, node_run_id: t.runId, source: "canvas_remix" });
    const c = e.asset || t && t.asset || null, h = t && t.inputs && t.modelId === a.id ? a : null, f = h ? dc(h, t.inputs, (p) => this.assetUrl(p)) : {};
    if (f.inputs)
      for (const p of a.fields) p.kind === "seed" && delete f.inputs[p.key];
    this.setPrompt(d.id, {
      ...f,
      prompt: t ? t.prompt : "",
      ref: e.src,
      n: 1,
      assets: { ...f.assets || {}, ...c ? { [e.src]: c } : {} }
    }), this.ui.selection = [d.id], this.revealNew(d);
  }
  /**
   * The session a picture remixes in (B25): the one on the board that made
   * it, when its kit has the run's model (R6: an Edit tool's upscale, made in
   * an Image session, isn't that session's to run again; it gets a session of
   * its own as before). A picture with no run's model takes its session's.
   */
  remixHome(e, t) {
    const i = t && t.sessionId || e.sessionId || null, s = i ? this.store.get(i) : void 0;
    if (!s || s.type !== "tool" || this.isHeld(s)) return null;
    const o = this.catalog.value.kits.find((a) => a.id === s.kitId);
    if (!o) return null;
    const r = t && t.modelId ? o.models.find((a) => a.id === t.modelId) || null : this.modelFor(s).model;
    return r ? { tool: s, model: r } : null;
  }
  /**
   * A session's saved draft, read (R4): on a real board a session's prompt
   * arrives after the board, so what's changed in it first waits for it,
   * or Undo's copy is the empty default and the change saves over the draft.
   */
  draftReady(e) {
    const t = this.opts.prompts;
    return t ? t.follow(e).catch(() => {
    }).then(() => this.whenDecoded(e, T_)) : Promise.resolve();
  }
  /**
   * Remix a session's own picture in that session: its model and settings
   * back as the run had them (a fresh seed), the picture as the reference,
   * the session opened, once its saved draft is in. Undo puts its prompt and
   * model back.
   */
  async remixInSession(e, t, i, s) {
    await this.draftReady(e.id);
    const o = this.store.get(e.id);
    if (this.disposed || !o || o.type !== "tool") return;
    const r = { up: JSON.parse(JSON.stringify(this.promptOf(o.id))), model: o.model, nodeDefId: o.nodeDefId };
    o.nodeDefId !== t.id && this.patchTool(o.id, { model: t.name, nodeDefId: t.id }), s && s.runId && this.track("remix_initiated", { node_def_id: s.modelId || null, node_run_id: s.runId, source: "canvas_remix" });
    const a = i.asset || s && s.asset || null, l = s && s.inputs && s.modelId === t.id ? t : null, d = l ? dc(l, s.inputs, (c) => this.assetUrl(c)) : {};
    if (d.inputs)
      for (const c of t.fields) c.kind === "seed" && delete d.inputs[c.key];
    this.setPrompt(o.id, {
      ...d,
      prompt: s ? s.prompt : this.promptOf(o.id).prompt || "",
      ref: i.src,
      n: 1,
      assets: { ...d.assets || {}, ...a ? { [i.src]: a } : {} }
    }), this.openSession(this.store.get(o.id)), this.toast("Remix ready in " + o.name + ". Run makes it again.", "info", {
      label: "Undo",
      run: () => {
        const c = this.store.get(o.id);
        c && (c.nodeDefId !== r.nodeDefId && this.patchTool(o.id, { model: r.model, nodeDefId: r.nodeDefId }), this.replacePrompt(o.id, r.up), this.dismissToast());
      }
    });
  }
  /** Placing from the record drops a copy where you are looking. */
  placeCopy(e) {
    this.ui.infoAt = null;
    const t = this.freeSpot(e.w, e.h), i = { ...JSON.parse(JSON.stringify(e)), id: wt(), x: t.x, y: t.y };
    i.z = this.store.nextZ(i), this.store.add([i]), this.ui.selection = [i.id], this.revealNew(i);
  }
  placeResult(e, t) {
    if (e.status !== "done" || !e.url) return null;
    const i = I_(e.w, e.h);
    return this.placeImages([{
      url: e.url,
      w: i.w,
      h: i.h,
      label: e.label || "result",
      resultId: e.id,
      sessionId: e.sessionId,
      video: e.video,
      dur: e.dur,
      videoSrc: e.videoSrc,
      previewSrc: e.previewSrc,
      asset: e.asset,
      download: e.download,
      kind: e.kind
    }], t)[0] || null;
  }
  /**
   * The record behind a result placed on the board: the board follows only
   * its newest runs (and the galleries' pages), so an older card's run is
   * read when its record is wanted. Null when there's none: deleted from its
   * session's history, or another board's (a pasted card).
   */
  loadRecord(e) {
    const t = this.results.get(e);
    if (t) return Promise.resolve(t);
    const i = this.opts.runs, s = e.split(":")[0];
    if (!i || !s) return Promise.resolve(null);
    let o = this.recordReads.get(s);
    return o || (this.readingRecords[s] = !0, o = i.getRun(s).then((r) => {
      r && r.runnitId === this.meta.id && !r.deletedAt && !this.disposed && this.onRun(r);
    }, (r) => {
      this.recordReads.delete(s), console.warn("[board] a result's record is unavailable", r);
    }).then(() => {
      delete this.readingRecords[s];
    }), this.recordReads.set(s, o)), o.then(() => this.results.get(e) || null);
  }
  /** Whether a result's record is being read (loadRecord). */
  readingRecord(e) {
    return !!this.readingRecords[e.split(":")[0]];
  }
  // ------------------------------------------------------------ recently deleted
  /**
   * Bring elements back from Recently Deleted, where they were (one undo
   * step), unless something has taken their place since: then they go
   * together to the nearest clear spot (CHAT-22). They come back selected.
   */
  recoverDeleted(e) {
    const t = new Map(this.trash.value.map((r) => [r.el.id, r])), i = [], s = [];
    for (const r of e) {
      const a = t.get(r);
      a && (Bs(a.el) ? this.recovering.has(r) || s.push(JSON.parse(JSON.stringify(a.el))) : this.store.get(r) || i.push(JSON.parse(JSON.stringify(a.el))));
    }
    if (!i.length && !s.length) return;
    if (i.length) {
      const r = this.recoverShift(i);
      if (r) for (const a of i)
        a.x += r.x, a.y += r.y;
      this.store.batch("Recover", () => this.store.add(i)), this.ui.selection = i.map((a) => a.id);
    }
    s.length && this.recoverRecords(s);
    const o = i.length + s.length;
    this.toast(o === 1 ? "Recovered 1 item." : "Recovered " + o + " items.");
  }
  /**
   * The Studios view's records Recently Deleted shows (CHAT-14): a deleted
   * result, and a picture brought into a session that's still on the board
   * (deleted with its session, it comes back with it).
   */
  recoverableRecord(e) {
    return e.role === "deleted" ? !0 : e.role === "ref" && !!this.store.get(e.sessionId);
  }
  /**
   * Recovered records: a picture brought in comes back with its marks; a
   * deleted result comes back to its run, and then its marks with it.
   */
  recoverRecords(e) {
    const t = e.filter((i) => i.role === "ref");
    t.length && this.studioRecords.restore([...t, ...this.trashedMarks(t.map((i) => i.id))]);
    for (const i of e) i.role === "deleted" && this.restoreResult(i);
    this.trashRev.value++;
  }
  /** The marks in Recently Deleted drawn on these pictures (StudioItem ids: a reference's, a result's). */
  trashedMarks(e) {
    const t = new Set(e);
    return this.sync.trash().map((i) => i.el).filter((i) => Bs(i) && i.role === "marks" && t.has(i.target));
  }
  /**
   * How far recovered elements move: nowhere while their place is clear,
   * else to freeSpot's nearest clear place for the group's box. Only what
   * sits on the board counts, not frames (things go in them), and a
   * neighbour that merely sits close doesn't move them.
   */
  recoverShift(e) {
    if (!e.filter((r) => r.type !== "frame").map(He).some((r) => this.store.index.query(r).some((a) => {
      const l = this.store.get(a);
      return !!l && l.type !== "frame" && Ya(r, He(l));
    }))) return null;
    const s = uc(e.map(He)), o = this.freeSpot(s.w, s.h, { x: s.x + s.w / 2, y: s.y + s.h / 2 });
    return { x: o.x - s.x, y: o.y - s.y };
  }
  /**
   * What was deleted for good elsewhere (another tab's Delete for good, or its
   * 90 days) leaves this tab's Undo too: put back, it would return without the
   * comment threads deleted with it. What Undo would bring back that's neither
   * on the board nor in Recently Deleted any more is gone for good.
   */
  forgetPurged() {
    const e = new Set(this.sync.trash().map((i) => i.el.id)), t = this.store.restorableIds().filter((i) => !e.has(i) && !this.store.get(i));
    t.length && this.store.forget(t);
  }
  /** Delete elements in Recently Deleted for good: they can't be recovered after this. */
  purgeDeleted(e) {
    const t = new Set(this.trash.value.map((l) => l.el.id)), i = e.filter((l) => this.recovering.has(l));
    i.length && this.toast(i.length === 1 ? "That picture is still being recovered." : "Those pictures are still being recovered.");
    const s = e.filter((l) => t.has(l) && !this.recovering.has(l));
    if (!s.length) return;
    const o = s.length, r = new Set(this.trash.value.filter((l) => s.includes(l.el.id) && l.el.type === "tool").map((l) => l.el.id));
    if (r.size) {
      const l = this.studioRecords.all().filter((c) => r.has(c.sessionId)).map((c) => c.id), d = this.sync.trash().filter((c) => Bs(c.el) && r.has(c.el.sessionId)).map((c) => c.el.id);
      this.studioRecords.remove(l), s.push(...l, ...d);
    }
    const a = [];
    for (const l of this.trash.value)
      !s.includes(l.el.id) || !Bs(l.el) || (l.el.role === "ref" ? a.push(l.el.id) : l.el.role === "deleted" && a.push(l.el.result.id));
    a.length && s.push(...this.trashedMarks(a).map((l) => l.id)), this.sync.purge(s), this.store.forget(s), this.comments.deleteWith(s), this.trashRev.value++, this.toast(o === 1 ? "Deleted 1 item for good." : "Deleted " + o + " items for good.");
  }
  // ---------------------------------------------------------------- pinned pictures
  /** Whether you've pinned this picture to the board. */
  isPinnedImage(e) {
    return !!e && this.pinnedUrls.value.has(e);
  }
  /**
   * Pin a picture to the board, or unpin it. Pins are yours, on this board,
   * kept with the board so they follow you to any device. An unpinned one is
   * gone at once (its records wait where deleted records do, never shown).
   */
  togglePinImage(e) {
    if (!e.url) return !1;
    if (this.isPinnedImage(e.url)) {
      const i = this.studioRecords.all().filter((s) => s.role === "pin" && s.createdBy === this.user.uid && s.url === e.url).map((s) => s.id);
      return this.studioRecords.remove(i), !1;
    }
    e.asset && this.rememberAsset(e.url, e.asset);
    const t = {
      ...bl,
      id: wt(),
      type: "studio",
      role: "pin",
      sessionId: "",
      createdAt: Date.now(),
      createdBy: this.user.uid,
      url: e.url,
      pw: e.w || 4,
      ph: e.h || 3,
      label: (e.label || "Image").slice(0, 80),
      asset: e.asset || null,
      resultId: e.resultId || null,
      fromSession: e.sessionId || null,
      video: !!e.video,
      videoSrc: e.videoSrc || null,
      dur: e.dur || null
    };
    return this.studioRecords.put(t), this.prefs.pinHintSeen || (this.prefs.pinHintSeen = !0, this.persistPrefs(), this.toast(Xn.first)), !0;
  }
  /** The placed card for a result, if any. */
  placedFor(e) {
    for (const t of this.store.all()) if (t.type === "image" && t.resultId === e) return t;
    return null;
  }
  /**
   * A star. On a real board it's yours, v1's favorite (the Library lists
   * it), and only your own finished results take one; in the harness it's
   * the card's. The image's result follows along in onDocChange there (so
   * undo and redo do too).
   */
  toggleFav(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    if (this.opts.favorites) {
      const s = t.resultId && this.results.get(t.resultId) || null;
      s ? this.toggleResultFav(s) : t.resultId && this.opts.runs ? this.loadRecord(t.resultId).then((o) => {
        o ? this.toggleResultFav(o) : this.toast("Only generated results can be favorited.");
      }) : this.toast("Only generated results can be favorited.");
      return;
    }
    const i = !t.fav;
    this.patch(e, { fav: i || void 0 }, i ? "Favourite" : "Unfavourite");
  }
  isFav(e, t) {
    const i = this.opts.favorites;
    return i ? (i.uuids.value, !!(e && i.has(e.uuid))) : !!(t && t.fav || e && e.fav);
  }
  /** Whether the star is yours to set: on a real board, your own finished results only (v1's rule). */
  canFav(e, t) {
    const i = this.opts.favorites;
    return i ? !!e && i.canStar(e) : !!(t || e);
  }
  async toggleResultFav(e) {
    const t = this.opts.favorites;
    if (!t) {
      this.results.upsert([{ ...e, fav: !e.fav || void 0 }]);
      return;
    }
    if (!t.canStar(e)) {
      this.toast("Only the person who ran it can favorite a result.");
      return;
    }
    try {
      const i = !t.has(e.uuid);
      await t.set(e, i), i && this.track("result_favorited", this.resultEvent(e));
    } catch (i) {
      console.error("[board] favorite not saved", i), this.toast("The favorite couldn't be saved.", "error");
    }
  }
  /**
   * Why no run can go on this board, whatever its form and price: its team
   * is deactivated. The board and its results stay; new runs don't. Empty
   * when runs can go, and while the team's state is unknown (the server
   * decides then, and says so when it refuses).
   */
  accountProblem() {
    return !this.meta.teamId || this.teamActive.value !== !1 ? "" : "This " + this.labels.team + " is deactivated, so it can't run new generations.";
  }
  /** the board menu offers Take the tour (IL-095) where the host has it */
  get canOpenTour() {
    return !!this.opts.onOpenTour;
  }
  openTour() {
    this.opts.onOpenTour && this.opts.onOpenTour();
  }
  /**
   * Whether you may get more tokens for the account that pays for this board
   * (N5, Decision 3): on a personal board, yours, always; on a team board,
   * only with the host's say (MANAGE_COMPANY). Everyone else is pointed at an admin.
   */
  get canBuyTokens() {
    return this.tokenAccessRev.value, !this.meta.teamId || !this.opts.canBuyTokens ? !0 : this.opts.canBuyTokens(this.meta.teamId);
  }
  /** The host's say on who may buy tokens changed (its role loaded, or you switched team). */
  refreshTokenAccess() {
    this.tokenAccessRev.value++;
  }
  get canGetTokens() {
    return !!this.opts.onGetTokens && this.canBuyTokens;
  }
  /** Where someone who can't buy tokens for this board's {Team} gets more. */
  tokensAsk() {
    const e = this.labels.team;
    return "Ask " + (/^[aeiou]/i.test(e) ? "an " : "a ") + e + " admin for more tokens";
  }
  /**
   * The token chip's tooltip: whose tokens pay (the board's owner: its
   * {Team}, or you), and how to get more (N5).
   */
  tokensTitle() {
    if (!this.meta.teamId) return "Your tokens pay for runs on this board." + (this.opts.onGetTokens ? " Click to get more" : "");
    const e = this.labels.team.toLowerCase(), t = this.teamName.value, i = t ? t + "’s tokens (the " + e + " that owns this board)" : "the tokens of the " + e + " that owns this board", s = this.canGetTokens ? " Click to get more" : this.opts.onGetTokens ? " " + this.tokensAsk() : "";
    return "Runs on this board are paid from " + i + "." + s;
  }
  /** Open the plan of the account that pays for this board, to get more tokens; or say who can. */
  getTokens() {
    if (this.opts.onGetTokens) {
      if (!this.canBuyTokens) {
        this.toast(this.tokensAsk() + ".");
        return;
      }
      this.opts.onGetTokens(this.meta.teamId || null);
    }
  }
  /** Tell the host's analytics (v1's events and property names), marked as a canvas board's. */
  track(e, t) {
    if (this.opts.track)
      try {
        this.opts.track(e, { ...t, board_type: "CANVAS" });
      } catch (i) {
        console.warn("[board] analytics", i);
      }
  }
  /** A result's identity for analytics, as v1 names it. */
  resultEvent(e) {
    return { result_type: e.kind === "video" ? "VID" : e.kind === "3d" ? "ASSET_3D" : "IMG", node_run_id: e.runId || null, node_def_id: e.modelId || null, runnit_id: this.meta.id };
  }
  /** v1's "first run ever" for analytics: once per person, in this browser. */
  firstRunEver() {
    const e = "rd_has_generated_" + this.user.uid;
    try {
      return window.localStorage.getItem(e) ? !1 : (window.localStorage.setItem(e, "1"), !0);
    } catch {
      return !1;
    }
  }
  /** A result was downloaded (the info view's Download). */
  trackDownload(e) {
    const t = this.resultEvent(e);
    this.track("image_downloaded", { result_type: t.result_type, node_run_id: t.node_run_id, node_def_id: t.node_def_id, bulk: !1 });
  }
  /**
   * Why a run of this price (hundredths) can't go for want of tokens, as
   * v1's Run button says it; empty when it can. Only a personal account is
   * held to its balance here: some teams may run below zero, which only the
   * server knows, and it says so when it refuses.
   */
  tokensProblem(e) {
    const t = this.balance.value;
    return !t || t.team || e == null || e <= t.tokens ? "" : "Not enough tokens: this run costs " + El(e) + " and you have " + El(Math.max(0, t.tokens));
  }
  /**
   * Your trained models a model field can use on this board: on a team
   * board yours in the team and its shared ones, else your own. Empty in the
   * harness, which has none.
   */
  async trainedModels() {
    const e = this.opts.models;
    if (!e) return [];
    const t = await e.list(this.meta.teamId || null);
    return this.trainedModelsSeen.value = t, t;
  }
  /** The picture of a model chosen for a field (it carries its avatar, as v1 keeps it): small, and full. */
  modelPicture(e) {
    const t = this.opts.storageUrl, i = e && typeof e == "object" ? e.avatar : null;
    if (!t || !i || typeof i != "object") return null;
    const s = hS(i);
    return { thumb: t(s.thumb), image: t(s.file) };
  }
  /** Whether you can delete a result from its session's history: your own, as v1 allows. */
  canDelete(e) {
    return !!(this.opts.runs && e && e.runId && e.uuid && e.userId === this.user.uid && e.status !== "pending");
  }
  /**
   * Delete a result from its session's history (v1 marks it deleted in its
   * run), and take it off its session's card.
   */
  async deleteResult(e) {
    const t = this.opts.runs;
    if (!t || !e.runId || !e.uuid) return !1;
    try {
      await t.deleteResult(e.runId, e.uuid, this.user.uid);
    } catch (i) {
      return console.error("[board] result not deleted", i), this.toast("That result couldn't be deleted.", "error"), !1;
    }
    return this.ui.infoAt === "result:" + e.id && (this.ui.infoAt = null), this.results.remove([e.id]), this.historyCursor.get(e.sessionId) === "end" ? this.recount(e.sessionId) : this.uncount(e), this.binResult(e), !0;
  }
  /**
   * A deleted result waits in Recently Deleted (CHAT-14): its record is
   * written straight there, with the result as it was, so Recover can take
   * the delete back.
   */
  binResult(e) {
    const t = {
      ...bl,
      id: Tne(e.id),
      type: "studio",
      role: "deleted",
      sessionId: e.sessionId,
      createdAt: Date.now(),
      createdBy: this.user.uid,
      result: JSON.parse(JSON.stringify(e))
    };
    this.studioRecords.put(t), this.studioRecords.remove([t.id]), this.trashRev.value++, this.toast(e.video ? "Video deleted. It waits in Recently Deleted." : "Picture deleted. It waits in Recently Deleted.");
  }
  /** A recovered result: back on its run, in its session's history, and counted. */
  async restoreResult(e) {
    const t = e.result, i = this.opts.runs;
    if (i && this.realRuns && t.runId && t.uuid) {
      this.recovering.add(e.id);
      try {
        await i.restoreResult(t.runId, t.uuid);
      } catch (o) {
        return console.error("[board] result not recovered", o), this.toast("That picture couldn't be recovered.", "error"), !1;
      } finally {
        this.recovering.delete(e.id);
      }
    }
    const s = this.trashedMarks([t.id]);
    return s.length && this.studioRecords.restore(s), this.results.upsert([t]), this.historyCursor.get(t.sessionId) === "end" ? this.recount(t.sessionId) : this.countBack(t), this.sync.purge([e.id]), this.trashRev.value++, !0;
  }
  /** uncount's other way: one more on the session's card, its picture among the thumbnails. */
  countBack(e) {
    const t = this.store.get(e.sessionId) || null;
    if (!t || t.type !== "tool" || e.status !== "done") return;
    const i = (t.thumbs || []).concat(e.url).filter((s, o, r) => !!s && r.indexOf(s) === o).slice(0, 6);
    this.store.update(t.id, { count: (t.count || 0) + 1, thumbs: i }, { history: !1 });
  }
  /**
   * Save a file under a name. The file is fetched first: a download link to
   * another origin (Storage, the CDN) ignores the name it's given.
   */
  async saveFile(e, t) {
    try {
      const i = await fetch(e, { mode: "cors" });
      if (!i.ok) throw new Error("HTTP " + i.status);
      const s = URL.createObjectURL(await i.blob()), o = document.createElement("a");
      o.href = s, o.download = t, document.body.appendChild(o), o.click(), o.remove(), window.setTimeout(() => URL.revokeObjectURL(s), 1e4);
    } catch (i) {
      console.warn("[board] download fell back to opening the file", i), window.open(e, "_blank", "noopener");
    }
  }
  // ------------------------------------------------------------ clipboard
  copy(e = !1) {
    const t = this.ui.selection.map((o) => this.store.get(o)).filter(Boolean);
    if (!t.length) return;
    const i = new Set(t.map((o) => o.id));
    for (const o of t) if (o.type === "frame") for (const r of this.carriedBy(o)) i.add(r);
    const s = Array.from(i).map((o) => this.store.get(o)).filter(Boolean);
    wr = { els: JSON.parse(JSON.stringify(s)), board: this.meta.id }, this.pasteCount = 0;
    try {
      navigator.clipboard.writeText(JSON.stringify({ rdBoard: 1, board: wr.board, els: wr.els })).catch(() => {
      });
    } catch {
    }
    e && this.deleteIds(this.ui.selection.slice());
  }
  /**
   * `fromBoard`: the board the system clipboard's copy came from, where it
   * says. Copied on this board with the originals in view, each paste steps
   * down and right; anything else (another board's, or this board's from out
   * of view) lands in the middle of the view (IL-100: on another board, an
   * empty one above all, it landed where it had been, often out of sight).
   */
  paste(e, t) {
    const i = e || (wr ? wr.els : null);
    if (!i || !i.length) return;
    const s = e ? t : wr ? wr.board : null, o = s == null || s === this.meta.id;
    this.pasteCount++;
    let r = 1 / 0, a = 1 / 0, l = -1 / 0, d = -1 / 0;
    for (const w of i) {
      const S = He(w);
      r = Math.min(r, S.x), a = Math.min(a, S.y), l = Math.max(l, S.x + S.w), d = Math.max(d, S.y + S.h);
    }
    const c = { x: r, y: a, w: l - r, h: d - a }, h = this.viewportCentre(), f = Math.round(h.x - (c.x + c.w / 2)), p = Math.round(h.y - (c.y + c.h / 2)), y = o && this.engine ? this.engine.isInView({ ...i[0] }) : !1, v = y ? 28 * this.pasteCount : 0, x = i.map((w, S) => {
      const M = JSON.parse(JSON.stringify(w));
      return M.id = wt(), M.x = y ? w.x + v : w.x + f, M.y = y ? w.y + v : w.y + p, M.type === "frame" && delete M.locked, M.z = this.store.nextZ(M, M.type === "frame") + S, M;
    });
    this.store.batch("Paste", () => this.store.add(x)), this.ui.selection = x.filter((w) => w.type !== "frame" || x.length === 1).map((w) => w.id);
  }
  childrenOf(e) {
    const t = [];
    for (const i of this.store.query(He(e))) {
      if (i.id === e.id || i.type === "frame") continue;
      const s = He(i), o = s.x + s.w / 2, r = s.y + s.h / 2;
      o > e.x && o < e.x + e.w && r > e.y && r < e.y + e.h && t.push(i.id);
    }
    return t;
  }
  /**
   * The frame that holds something (CHAT-54): of the frames round its centre,
   * the innermost (the smallest; the higher one on a tie), as a chat picks its
   * frame. One frame each, so two overlapping frames never both carry a card
   * (Adam: "both of these frames control this 3D image"). A frame is held by a
   * bigger one round its centre: nested frames ride with their parent.
   */
  ownerFrame(e) {
    const t = He(e), i = t.x + t.w / 2, s = t.y + t.h / 2, o = e.type === "frame" ? t.w * t.h : 0;
    let r = null;
    for (const a of this.store.query({ x: i - 1, y: s - 1, w: 2, h: 2 })) {
      if (a.type !== "frame" || a.id === e.id || !(i > a.x && i < a.x + a.w && s > a.y && s < a.y + a.h)) continue;
      const l = a.w * a.h;
      l <= o || (!r || l < r.w * r.h || l === r.w * r.h && a.z > r.z) && (r = a);
    }
    return r;
  }
  /**
   * Frames grow to fit the pictures dropped into them (B4: Blake's smart,
   * responsive frames): a picture whose frame (ownerFrame) doesn't hold all of
   * it, with its padding, widens or lengthens that frame on whichever side it
   * hangs over, and a frame it pushes past its own parent grows that one too.
   * Never smaller, and never a locked frame. In the caller's undo step.
   */
  growFramesFor(e, t) {
    const i = An, s = /* @__PURE__ */ new Map(), o = (r, a) => {
      if (Ro(r)) return;
      const l = s.get(r.id) || He(r), d = Math.min(l.x, a.x - i), c = Math.min(l.y, a.y - i), h = Math.max(l.x + l.w, a.x + a.w + i), f = Math.max(l.y + l.h, a.y + a.h + i);
      if (d === l.x && c === l.y && h === l.x + l.w && f === l.y + l.h) return;
      const p = { x: Math.round(d), y: Math.round(c), w: Math.round(h - d), h: Math.round(f - c) };
      s.set(r.id, p);
      const y = this.ownerFrame(r);
      y && o(y, p);
    };
    for (const r of e) {
      const a = this.store.get(r);
      if (!a || a.type !== "image") continue;
      const l = t && t.get(r) ? this.store.get(t.get(r)) : void 0, d = l && l.type === "frame" ? l : this.ownerFrame(a);
      d && o(d, He(a));
    }
    s.size && this.store.updateMany(Array.from(s, ([r, a]) => [r, { x: a.x, y: a.y, w: a.w, h: a.h }]));
  }
  /**
   * What goes with a frame when it moves, is copied or lines up: what it holds
   * itself (ownerFrame), and the frames nested in it with what they hold.
   */
  carriedBy(e) {
    const t = [], i = /* @__PURE__ */ new Set([e.id]), s = (o) => {
      for (const r of this.store.query(He(o))) {
        if (i.has(r.id)) continue;
        const a = this.ownerFrame(r);
        !a || a.id !== o.id || (i.add(r.id), t.push(r.id), r.type === "frame" && s(r));
      }
    };
    return s(e), t;
  }
  /** The locked frame something sits in: its own frame, or one that frame sits in, if any is locked. */
  lockedFrameOf(e) {
    let t = this.ownerFrame(e);
    for (let i = 0; t && i < 32; i++) {
      if (t.locked) return t;
      t = this.ownerFrame(t);
    }
    return null;
  }
  /**
   * Stays where it is: a locked frame (IL-070), or what one holds (B31).
   * Held things can still be selected, opened, restacked and commented on;
   * they can't be moved, resized or deleted until the frame is unlocked.
   */
  isHeld(e) {
    return !!e && (Ro(e) || !!this.lockedFrameOf(e));
  }
  frameFor(e) {
    const t = He(e);
    let i = null;
    for (const s of this.store.query(t))
      s.type === "frame" && t.x >= s.x && t.y >= s.y && t.x < s.x + s.w && t.y < s.y + s.h && (!i || s.z > i.z) && (i = s);
    return i;
  }
  /** The session that made an image: its record, else the tool in its frame. */
  toolFor(e) {
    if (e.sessionId) {
      const i = this.store.get(e.sessionId);
      if (i && i.type === "tool") return i;
    }
    const t = this.frameFor(e);
    if (!t) return null;
    for (const i of this.store.query(He(t)))
      if (i.type === "tool" && i.x >= t.x && i.y >= t.y && i.x < t.x + t.w && i.y < t.y + t.h) return i;
    return null;
  }
  // --------------------------------------------------------------- history
  undo() {
    this.store.undo();
  }
  redo() {
    this.store.redo();
  }
  /** The arrow keys: the selection, a frame with what it holds; a locked frame and what it holds stay. */
  nudge(e, t) {
    const i = this.ui.selection.filter((r) => !this.isHeld(this.store.get(r)));
    if (!i.length) return;
    const s = new Set(i);
    for (const r of i) {
      const a = this.store.get(r);
      if (a && a.type === "frame")
        for (const l of this.carriedBy(a)) this.isHeld(this.store.get(l)) || s.add(l);
    }
    const o = [];
    for (const r of s) {
      const a = this.store.get(r);
      a && o.push([r, { x: a.x + e, y: a.y + t }]);
    }
    this.store.batch("Nudge", () => this.store.updateMany(o));
  }
  // ----------------------------------------------------------------- misc
  toast(e, t = "info", i) {
    const s = ++this.toastSeq;
    this.ui.toast = { id: s, text: e, tone: t, action: i }, clearTimeout(this.toastTimer);
    const o = t === "error" || e.length > 70 ? Math.max(5200, Math.min(1e4, 1800 + e.length * 45)) : i ? 6e3 : 3200;
    this.toastTimer = window.setTimeout(() => {
      this.ui.toast && this.ui.toast.id === s && (this.ui.toast = null);
    }, o);
  }
  dismissToast() {
    clearTimeout(this.toastTimer), this.ui.toast = null;
  }
  /** When you last looked at Board history here, or null before you ever have on this board (CHAT-46). */
  get historySeenAt() {
    return typeof this.prefs.histSeenAt == "number" ? this.prefs.histSeenAt : null;
  }
  /** Board history seen up to `at`: kept for the next visit. */
  markHistorySeen(e) {
    this.prefs.histSeenAt != null && e <= this.prefs.histSeenAt || (this.prefs.histSeenAt = e, this.persistPrefs());
  }
  persistPrefs() {
    this.prefs.lightCanvas = this.ui.lightCanvas, this.prefs.showGrid = this.ui.showGrid, this.prefs.shapeStyle = { ...this.ui.shapeStyle }, this.prefs.shapeKind = this.ui.shapeKind, this.prefs.histOpen = this.ui.histOpen, this.prefs.miniOpen = this.ui.miniOpen, this.prefs.recentIds = this.ui.recentIds.slice(0, 200), this.prefs.pinnedIds = this.ui.pinnedIds.slice(), this.prefs.pinnedModelIds = this.ui.pinnedModelIds.slice(), this.prefs.cameraViews = this.ui.cameraViews.map((e) => ({ ...e })), this.prefs.noteTint = this.ui.noteTint, this.prefs.promptH = this.ui.promptH, this.prefs.library = { tab: this.ui.library.tab, category: this.ui.library.category, saveBoard: this.ui.library.saveLevels.board, saveTeam: this.ui.library.saveLevels.team }, Bte(this.user.uid, this.meta.id, this.prefs);
  }
  /**
   * The board's sessions as the session lists show them: pinned ones first,
   * in the order pinned (Tyler, 2026-10-14: pinned sessions "stay at the
   * top"), then the most recently touched, then the rest by newest placement.
   */
  recentTools() {
    this.docRev.value;
    const e = [];
    for (const r of this.store.all()) r.type === "tool" && e.push(r);
    const t = new Map(e.map((r) => [r.id, r])), i = this.ui.pinnedIds.filter((r) => t.has(r)).map((r) => t.get(r)), s = this.ui.recentIds.filter((r) => t.has(r) && !this.ui.pinnedIds.includes(r)).map((r) => t.get(r)), o = e.filter((r) => !this.ui.recentIds.includes(r.id) && !this.ui.pinnedIds.includes(r.id)).sort((r, a) => (a.lastRunAt || a.z) - (r.lastRunAt || r.z));
    return i.concat(s, o);
  }
  /** A session pinned to the top of the session lists (yours, on this board). */
  isPinned(e) {
    return this.ui.pinnedIds.includes(e);
  }
  /** Pin a session to the top of the session lists, after those pinned before it; or unpin it. */
  togglePinned(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "tool") return;
    const i = !this.isPinned(e);
    this.ui.pinnedIds = i ? [...this.ui.pinnedIds, e] : this.ui.pinnedIds.filter((s) => s !== e), this.persistPrefs(), this.savePin("sessions", e, i);
  }
  /** A model pinned to the top of the model menus (yours, on every board). */
  isModelPinned(e) {
    return this.ui.pinnedModelIds.includes(e);
  }
  /**
   * Pin a model to the top of the model menus, after those pinned before it;
   * or unpin it. Only a model in the catalog can be pinned; one that has left
   * it can still be unpinned.
   */
  toggleModelPinned(e) {
    const t = !this.isModelPinned(e);
    t && !this.catalog.value.byId.has(e) || (this.ui.pinnedModelIds = t ? [...this.ui.pinnedModelIds, e] : this.ui.pinnedModelIds.filter((i) => i !== e), this.persistPrefs(), this.savePin("models", e, t));
  }
  /**
   * A pin list as your account has it (IL-068), from any device: it replaces
   * this browser's, which keeps a copy for the next open. An account with
   * none saved yet takes this browser's, on its first answer only: later, no
   * list means no pins (a refused first pin comes back that way).
   */
  pinsFromAccount(e, t) {
    const i = this.pinsKept[e] === "unknown";
    this.pinsKept[e] = "yes";
    const s = e === "models" ? this.ui.pinnedModelIds : this.ui.pinnedIds;
    if (t === null && i) {
      s.length && this.opts.pins && this.opts.pins.seed(e, s.slice()).catch((o) => console.warn("[board] your pins could not be saved to your account", o));
      return;
    }
    t === null && (t = []), !(t.length === s.length && t.every((o, r) => o === s[r])) && (e === "models" ? this.ui.pinnedModelIds = t.slice() : this.ui.pinnedIds = t.slice(), this.persistPrefs());
  }
  /** A pin or unpin, sent to your account where it keeps them; a refusal comes back as its pins, undoing this one. */
  savePin(e, t, i) {
    const s = this.opts.pins;
    !s || this.pinsKept[e] === "off" || s.pin(e, t, i).catch((o) => {
      console.warn("[board] pin not saved to your account", o), this.toast(i ? "Your pin couldn't be saved. Please try again." : "Your pin couldn't be removed. Please try again.", "error");
    });
  }
  // ---------------------------------------------------------------- your camera views (IL-077)
  /**
   * Save a camera view from Change camera, by name: yours alone, on every
   * board. The newest goes last. Null when you already keep the most.
   */
  saveCameraView(e, t) {
    if (this.ui.cameraViews.length >= If)
      return this.toast("You can keep up to " + If + " camera views. Remove one first."), null;
    const i = { id: wt(), name: E_(t) || "Camera view", ...ro(e), createdAt: Date.now() };
    return this.ui.cameraViews = [...this.ui.cameraViews, i], this.keepViews(), i;
  }
  renameCameraView(e, t) {
    const i = E_(t), s = this.ui.cameraViews.find((o) => o.id === e);
    !s || !i || i === s.name || (this.ui.cameraViews = this.ui.cameraViews.map((o) => o.id === e ? { ...o, name: i } : o), this.keepViews());
  }
  removeCameraView(e) {
    this.ui.cameraViews.some((t) => t.id === e) && (this.ui.cameraViews = this.ui.cameraViews.filter((t) => t.id !== e), this.keepViews());
  }
  /**
   * Your views as your account has them, from any device: they replace this
   * browser's. An account with none yet takes this browser's, on its first
   * answer only, as your pins do.
   */
  viewsFromAccount(e) {
    if (this.viewsKept === "off") return;
    const t = this.viewsKept === "unknown";
    if (this.viewsKept = "yes", e === null && t) {
      this.ui.cameraViews.length && this.opts.pins && this.opts.pins.saveViews && this.opts.pins.saveViews(this.ui.cameraViews.map((s) => ({ ...s }))).catch((s) => {
        console.warn("[board] your camera views could not be saved to your account", s), this.viewsKept = "off";
      });
      return;
    }
    const i = P_(e || []);
    JSON.stringify(i) !== JSON.stringify(this.ui.cameraViews) && (this.ui.cameraViews = i, this.persistPrefs());
  }
  /** Your views, kept here and sent to your account where it keeps them. */
  keepViews() {
    this.persistPrefs();
    const e = this.opts.pins;
    !e || !e.saveViews || this.viewsKept === "off" || e.saveViews(this.ui.cameraViews.map((t) => ({ ...t }))).catch((t) => {
      console.warn("[board] camera views not saved to your account", t), this.toast("Your camera views are kept in this browser only for now.", "error"), this.viewsKept = "off";
    });
  }
  /** A model list as the model menus show it: your pinned models first, in the order pinned, then the rest in their own order. */
  pinnedModelsFirst(e) {
    const t = this.ui.pinnedModelIds;
    if (!t.length) return e;
    const i = e.filter((s) => t.includes(s.id)).sort((s, o) => t.indexOf(s.id) - t.indexOf(o.id));
    return i.length ? i.concat(e.filter((s) => !t.includes(s.id))) : e;
  }
  /** Images in board order, for the info modal's previous / next. */
  imagesInOrder() {
    const e = [];
    for (const t of this.store.all()) t.type === "image" && e.push(t);
    return e.sort((t, i) => t.z - i.z);
  }
  /** World rect of the selection, or null. */
  selectionRect() {
    return this.store.bounds(this.ui.selection);
  }
  zoomAroundPoint(e, t, i) {
    this.engine && this.engine.zoomAt(e - this.view.left, t - this.view.top, i);
  }
  setCamera(e) {
    this.engine && this.engine.setCamera({ ...e, zoom: tr(e.zoom) });
  }
}
const tse = 24;
function I_(n, e, t = 360) {
  return !n || !e ? Hy("4:3") : n >= e ? { w: t, h: Math.round(t * e / n) } : { w: Math.round(t * n / e), h: t };
}
function A_(n, e) {
  const t = (i) => i === "note" || i === "tool" || i === "chat" ? "dom" : i;
  return t(n.type) === t(e.type);
}
function nse(n) {
  return /^(blob|data):/.test(n) ? n : n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
}
function P_(n) {
  return Array.isArray(n) ? n.map(Bne).filter((e) => !!e).slice(0, If) : [];
}
function E_(n) {
  return n.replace(/\s+/g, " ").trim().slice(0, Ky);
}
const ise = { class: "rd-head" }, sse = { class: "rd-mark" }, ose = { class: "rd-titles" }, rse = {
  key: 0,
  class: "rd-head-acts"
}, ase = {
  key: 0,
  class: "rd-empty",
  "data-testid": "trash-empty"
}, lse = { class: "rd-empty-mark" }, dse = { class: "rd-group-head" }, cse = {
  class: "rd-avatar",
  "aria-hidden": "true"
}, use = { class: "rd-who" }, hse = ["title"], pse = { key: 0 }, fse = { class: "rd-when" }, mse = ["title"], gse = { class: "rd-group-acts" }, bse = ["onClick"], vse = ["onClick", "onBlur"], yse = ["data-id"], xse = ["src"], wse = {
  key: 0,
  class: "rd-play",
  "aria-hidden": "true"
}, kse = ["src"], _se = {
  key: 0,
  class: "rd-play",
  "aria-hidden": "true"
}, Sse = {
  key: 3,
  class: "rd-frame"
}, Mse = {
  key: 4,
  class: "rd-shape",
  viewBox: "0 0 100 100",
  "aria-hidden": "true"
}, Tse = ["stroke"], Cse = ["stroke"], Ise = ["stroke"], Ase = {
  key: 0,
  d: "M58 24 H78 V44"
}, Pse = {
  key: 5,
  class: "rd-tool"
}, Ese = { class: "rd-item-acts" }, Rse = ["onClick"], zse = ["title", "aria-label", "onClick", "onBlur"], $se = { class: "rd-item-name" }, Dse = ["title"], Ose = ["onClick"], Lse = 24, Bse = /* @__PURE__ */ Pe({
  __name: "RecentlyDeleted",
  setup(n) {
    const { board: e } = Ze(), t = /* @__PURE__ */ W(null), i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W([]), o = I(() => {
      const M = [], _ = /* @__PURE__ */ new Map();
      for (const T of e.trash.value) {
        const k = T.deletedAt + ":" + (T.deletedBy || "");
        let P = _.get(k);
        P || (P = { key: k, at: T.deletedAt, email: T.deletedByEmail || "", mine: !!T.deletedBy && T.deletedBy === e.user.uid, items: [], due: T.hardDeleteAt }, _.set(k, P), M.push(P)), P.items.push(T), T.hardDeleteAt < P.due && (P.due = T.hardDeleteAt);
      }
      return M;
    }), r = I(() => e.trash.value.length), a = I(() => e.trash.value.map((M) => M.el.id)), l = {
      rect: { label: "Rectangle", icon: "Square" },
      ellipse: { label: "Ellipse", icon: "Circle" },
      line: { label: "Line", icon: "Slash" },
      arrow: { label: "Arrow", icon: "ArrowUpRight" }
    };
    function d(M) {
      const _ = M.el;
      if (!Bs(_)) return null;
      if (_.role === "deleted") {
        const T = _.result;
        return { url: T.thumb || T.url, video: !!T.video, label: T.label || (T.video ? "Video" : "Image") };
      }
      return _.role === "ref" ? { url: _.url, video: !1, label: _.label || "Image" } : null;
    }
    function c(M) {
      const _ = M.el, T = d(M);
      return T ? T.video ? { one: "video", many: "videos", icon: "Video" } : { one: "image", many: "images", icon: "Image" } : _.type === "image" ? _.video ? { one: "video", many: "videos", icon: "Video" } : { one: "image", many: "images", icon: "Image" } : _.type === "note" ? { one: "note", many: "notes", icon: "StickyNote" } : _.type === "chat" ? { one: "chat", many: "chats", icon: "MessagesSquare" } : _.type === "frame" ? { one: "frame", many: "frames", icon: "Frame" } : _.type === "shape" ? { one: "shape", many: "shapes", icon: (l[_.shape] || l.rect).icon } : { one: "tool session", many: "tool sessions", icon: Nl[_.kitId] || "Image" };
    }
    function h(M) {
      const _ = M.el, T = d(M);
      if (T) return T.label;
      if (_.type === "image") return _.label || (_.video ? "Video" : "Image");
      if (_.type === "note") {
        const k = (_.text || "").replace(/\s+/g, " ").trim();
        return k ? k.length > 60 ? k.slice(0, 60) + "…" : k : "Empty note";
      }
      return _.type === "frame" ? _.title || "Frame" : _.type === "chat" ? _.name || "Chat" : _.type === "shape" ? (l[_.shape] || l.rect).label : _.name || "Tool session";
    }
    function f(M) {
      const _ = /* @__PURE__ */ new Map();
      for (const T of M.items) {
        const k = c(T), P = _.get(k.one) || { n: 0, one: k.one, many: k.many };
        P.n++, _.set(k.one, P);
      }
      return Array.from(_.values()).map((T) => T.n + " " + (T.n === 1 ? T.one : T.many)).join(", ");
    }
    function p(M) {
      return s.value.includes(M.key) ? M.items : M.items.slice(0, Lse);
    }
    function y(M) {
      return new Date(M).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
    function v(M) {
      i.value = null, e.recoverDeleted(M);
    }
    function x(M, _) {
      if (i.value !== M) {
        i.value = M;
        return;
      }
      i.value = null, e.purgeDeleted(_);
    }
    function w() {
      e.ui.trashOpen = !1;
    }
    let S = null;
    return it(() => {
      S = document.activeElement, t.value && t.value.focus({ preventScroll: !0 });
    }), We(() => {
      S && document.contains(S) && S.focus({ preventScroll: !0 });
    }), (M, _) => (g(), b("div", {
      class: "rd",
      "data-testid": "trash",
      onPointerdown: Te(w, ["self"]),
      onWheel: _[4] || (_[4] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", {
        ref_key: "card",
        ref: t,
        class: "rd-card",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "rd-title",
        tabindex: "-1",
        onPointerdown: _[3] || (_[3] = Te(() => {
        }, ["stop"]))
      }, [
        u("header", ise, [
          u("span", sse, [
            C($, {
              name: "Trash2",
              size: 17
            })
          ]),
          u("div", ose, [
            _[5] || (_[5] = u("h2", { id: "rd-title" }, "Recently Deleted", -1)),
            u("p", null, "Deleted items stay here for " + E(m(Dv)) + " days, then they're deleted for good.", 1)
          ]),
          r.value ? (g(), b("div", rse, [
            u("button", {
              class: "rd-btn",
              "data-testid": "trash-recover-all",
              onClick: _[0] || (_[0] = (T) => v(a.value))
            }, [
              C($, {
                name: "RotateCcw",
                size: 13
              }),
              _[6] || (_[6] = Y("Recover all ", -1))
            ]),
            u("button", {
              class: G(["rd-btn is-danger", { "is-confirming": i.value === "all" }]),
              "data-testid": "trash-delete-all",
              onClick: _[1] || (_[1] = (T) => x("all", a.value)),
              onBlur: _[2] || (_[2] = (T) => i.value === "all" && (i.value = null))
            }, [
              C($, {
                name: i.value === "all" ? "Check" : "Trash2",
                size: 13
              }, null, 8, ["name"]),
              Y(E(i.value === "all" ? "Delete all for good?" : "Delete all"), 1)
            ], 34)
          ])) : z("", !0),
          u("button", {
            class: "rd-close",
            title: "Close",
            "aria-label": "Close",
            "data-testid": "trash-close",
            onClick: w
          }, [
            C($, {
              name: "X",
              size: 15
            })
          ])
        ]),
        r.value ? (g(), Ie(Zp, {
          key: 1,
          tag: "div",
          name: "rd-pop",
          class: "rd-groups"
        }, {
          default: Xe(() => [
            (g(!0), b(j, null, ge(o.value, (T) => (g(), b("section", {
              key: T.key,
              class: "rd-group",
              "data-testid": "trash-group"
            }, [
              u("header", dse, [
                u("span", cse, E(T.mine && m(e).user.initials ? m(e).user.initials : m(ga)(T.email || "Someone")), 1),
                u("div", use, [
                  u("span", {
                    class: "rd-email",
                    title: T.email,
                    "data-testid": "trash-deleted-by"
                  }, [
                    Y(E(T.email || "Someone"), 1),
                    T.mine ? (g(), b("em", pse, "you")) : z("", !0)
                  ], 8, hse),
                  u("span", fse, "Deleted " + E(m(ef)(T.at)) + " · " + E(f(T)), 1)
                ]),
                u("span", {
                  class: "rd-left",
                  title: "Deleted for good on " + y(T.due)
                }, [
                  C($, {
                    name: "Clock",
                    size: 12
                  }),
                  Y(E(m(PL)(T.due)), 1)
                ], 8, mse),
                u("div", gse, [
                  u("button", {
                    class: "rd-btn",
                    "data-testid": "trash-group-recover",
                    onClick: (k) => v(T.items.map((P) => P.el.id))
                  }, [
                    C($, {
                      name: "RotateCcw",
                      size: 13
                    }),
                    _[8] || (_[8] = Y("Recover ", -1))
                  ], 8, bse),
                  u("button", {
                    class: G(["rd-btn is-danger", { "is-confirming": i.value === T.key }]),
                    "data-testid": "trash-group-delete",
                    onClick: (k) => x(T.key, T.items.map((P) => P.el.id)),
                    onBlur: (k) => i.value === T.key && (i.value = null)
                  }, [
                    C($, {
                      name: i.value === T.key ? "Check" : "Trash2",
                      size: 13
                    }, null, 8, ["name"]),
                    Y(E(i.value === T.key ? "Delete for good?" : "Delete"), 1)
                  ], 42, vse)
                ])
              ]),
              C(Zp, {
                tag: "div",
                name: "rd-pop",
                class: "rd-grid"
              }, {
                default: Xe(() => [
                  (g(!0), b(j, null, ge(p(T), (k) => (g(), b("div", {
                    key: k.el.id,
                    class: "rd-item",
                    "data-id": k.el.id,
                    "data-testid": "trash-item"
                  }, [
                    u("div", {
                      class: G(["rd-thumb", "is-" + k.el.type])
                    }, [
                      k.el.type === "image" ? (g(), b(j, { key: 0 }, [
                        u("img", {
                          src: m(Bt)(k.el.src),
                          alt: "",
                          loading: "lazy",
                          draggable: "false"
                        }, null, 8, xse),
                        k.el.video ? (g(), b("span", wse, [
                          C($, {
                            name: "Play",
                            size: 14
                          })
                        ])) : z("", !0)
                      ], 64)) : d(k) ? (g(), b(j, { key: 1 }, [
                        u("img", {
                          src: m(Bt)(d(k).url),
                          alt: "",
                          loading: "lazy",
                          draggable: "false"
                        }, null, 8, kse),
                        d(k).video ? (g(), b("span", _se, [
                          C($, {
                            name: "Play",
                            size: 14
                          })
                        ])) : z("", !0)
                      ], 64)) : k.el.type === "note" ? (g(), b("div", {
                        key: 2,
                        class: G(["rd-note", "tint-" + k.el.tint])
                      }, [
                        u("span", null, E(k.el.text || ""), 1)
                      ], 2)) : k.el.type === "frame" ? (g(), b("div", Sse, [
                        u("span", null, E(k.el.title || "Frame"), 1)
                      ])) : k.el.type === "shape" ? (g(), b("svg", Mse, [
                        k.el.shape === "rect" ? (g(), b("rect", {
                          key: 0,
                          x: "18",
                          y: "28",
                          width: "64",
                          height: "44",
                          rx: "5",
                          stroke: k.el.stroke
                        }, null, 8, Tse)) : k.el.shape === "ellipse" ? (g(), b("ellipse", {
                          key: 1,
                          cx: "50",
                          cy: "50",
                          rx: "33",
                          ry: "23",
                          stroke: k.el.stroke
                        }, null, 8, Cse)) : (g(), b("g", {
                          key: 2,
                          stroke: k.el.stroke
                        }, [
                          _[9] || (_[9] = u("line", {
                            x1: "22",
                            y1: "76",
                            x2: "78",
                            y2: "24"
                          }, null, -1)),
                          k.el.shape === "arrow" ? (g(), b("path", Ase)) : z("", !0)
                        ], 8, Ise))
                      ])) : (g(), b("span", Pse, [
                        C($, {
                          name: c(k).icon,
                          size: 22
                        }, null, 8, ["name"])
                      ])),
                      u("div", Ese, [
                        u("button", {
                          title: "Recover",
                          "aria-label": "Recover",
                          "data-testid": "trash-item-recover",
                          onClick: (P) => v([k.el.id])
                        }, [
                          C($, {
                            name: "RotateCcw",
                            size: 14
                          })
                        ], 8, Rse),
                        u("button", {
                          class: G(["is-danger", { "is-confirming": i.value === k.el.id }]),
                          title: i.value === k.el.id ? "Click again to delete it for good" : "Delete for good",
                          "aria-label": i.value === k.el.id ? "Click again to delete it for good" : "Delete for good",
                          "data-testid": "trash-item-delete",
                          onClick: (P) => x(k.el.id, [k.el.id]),
                          onBlur: (P) => i.value === k.el.id && (i.value = null)
                        }, [
                          C($, {
                            name: i.value === k.el.id ? "Check" : "Trash2",
                            size: 14
                          }, null, 8, ["name"])
                        ], 42, zse)
                      ])
                    ], 2),
                    u("div", $se, [
                      C($, {
                        name: c(k).icon,
                        size: 12
                      }, null, 8, ["name"]),
                      u("span", {
                        title: h(k)
                      }, E(h(k)), 9, Dse)
                    ])
                  ], 8, yse))), 128)),
                  T.items.length > p(T).length ? (g(), b("button", {
                    key: "more",
                    class: "rd-more",
                    "data-testid": "trash-more",
                    onClick: (k) => s.value = s.value.concat(T.key)
                  }, " +" + E(T.items.length - p(T).length) + " more ", 9, Ose)) : z("", !0)
                ]),
                _: 2
              }, 1024)
            ]))), 128))
          ]),
          _: 1
        })) : (g(), b("div", ase, [
          u("span", lse, [
            C($, {
              name: "Trash2",
              size: 22
            })
          ]),
          _[7] || (_[7] = u("h3", null, "Nothing deleted lately", -1)),
          u("p", null, "Images, notes, frames and shapes deleted from this board wait here for " + E(m(Dv)) + " days, so they can be recovered.", 1)
        ]))
      ], 544)
    ], 32));
  }
}), Fse = {
  class: "bd-stats",
  "data-testid": "stats"
}, Nse = { key: 1 }, Use = /* @__PURE__ */ Pe({
  __name: "StatsOverlay",
  setup(n) {
    const { board: e } = Ze(), t = I(() => e.stats.value), i = I(() => e.overlayIds.value.length);
    return (s, o) => (g(), b("div", Fse, [
      t.value ? (g(), b(j, { key: 0 }, [
        u("b", {
          class: G({ warn: t.value.fps < 55, bad: t.value.fps < 40 })
        }, E(t.value.fps) + " fps", 3),
        u("span", null, E(t.value.frameMs) + " ms/frame", 1),
        u("span", null, E(m(e).store.size) + " elements · " + E(t.value.images) + " images", 1),
        u("span", null, E(t.value.visible) + " culled-in · " + E(i.value) + " DOM", 1),
        u("span", null, E(t.value.textures) + " textures · " + E(t.value.textureMB) + " MB", 1),
        u("span", null, E(t.value.pending) + " loading", 1)
      ], 64)) : (g(), b("span", Nse, "measuring…"))
    ]));
  }
}), Gse = ["aria-label"], uI = /* @__PURE__ */ Pe({
  __name: "StackBadge",
  props: {
    top: {},
    ids: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = U8(t);
    return (s, o) => (g(), b("button", {
      type: "button",
      class: G(["cv-stack-badge", { "is-open": m(i).s.top === e.top }]),
      "aria-label": e.ids.length + " cards stacked here: show them",
      "data-testid": "stack-badge",
      onPointerdown: o[0] || (o[0] = Te(() => {
      }, ["stop"])),
      onMouseenter: o[1] || (o[1] = (r) => m(i).open(e.top, e.ids)),
      onMouseleave: o[2] || (o[2] = (r) => m(i).leave()),
      onClick: o[3] || (o[3] = Te((r) => m(i).open(e.top, e.ids), ["stop"]))
    }, [
      C($, {
        name: "Layers",
        size: 11,
        stroke: 2.2
      }),
      Y(E(e.ids.length), 1)
    ], 42, Gse));
  }
}), jse = ["data-el", "data-ref-session"], Hse = { class: "cv-bucket-head" }, Vse = { class: "cv-badge" }, Wse = { class: "cv-bucket-titles" }, qse = { class: "cv-bucket-kind" }, Kse = ["title"], Yse = ["value"], Xse = ["title"], Jse = ["title", "aria-label", "aria-expanded", "disabled"], Zse = ["title"], Qse = ["title"], eoe = {
  key: 2,
  class: "cv-count"
}, toe = {
  key: 0,
  class: "cv-bucket-thumbs"
}, noe = ["data-testid", "onPointerdown"], ioe = {
  key: 1,
  class: "cv-bucket-foot"
}, soe = ["title"], ooe = { key: 1 }, roe = /* @__PURE__ */ Pe({
  __name: "ToolCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {},
    stack: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = Ze(), s = as(() => e.id), o = I(() => t.ui.selection.includes(e.id)), r = I(() => o.value && t.ui.selection.length === 1), a = I(() => (t.docRev.value, t.isHeld(s.value))), l = I(() => !!t.generating[e.id]), d = I(() => t.ui.newThumbs[e.id] || 0), c = I(() => s.value && s.value.scale || 1), h = I(() => !!(s.value && s.value.collapsed)), f = I(() => h.value ? Nc : Rt.h), p = I(() => s.value ? (s.value.thumbs || []).slice(0, 4) : []), y = I(() => Math.max(0, 4 - p.value.length)), v = dr(), x = I(() => {
      const ie = s.value;
      if (!ie) return "";
      if (l.value) {
        const ee = t.runningSince[e.id];
        return ee ? "Generating… " + E1(v.value - ee) : "Generating…";
      }
      return ie.lastRunAt ? "Updated " + Jn(ie.lastRunAt) : ie.count ? "Ready" : "No runs yet";
    }), w = /* @__PURE__ */ W(!1), S = /* @__PURE__ */ W(null);
    function M() {
      w.value = !0, nt(() => {
        S.value && (S.value.focus({ preventScroll: !0 }), S.value.select());
      });
    }
    function _(ie) {
      if (!w.value) return;
      const ee = S.value ? S.value.value : "";
      w.value = !1, ie && s.value && t.renameTool(e.id, ee);
    }
    function T(ie) {
      !s.value || w.value || i.elementDown(t.store.get(e.id), ie);
    }
    function k(ie) {
      const ee = t.store.get(e.id);
      !ee || w.value || i.elementDown(ee, ie, { onClick: () => P() });
    }
    function P() {
      const ie = t.store.get(e.id);
      ie && ie.type === "tool" && t.showSession(ie);
    }
    function A(ie) {
      ie.detail === 0 && P();
    }
    function R(ie) {
      const ee = ie.target;
      w.value || ee && ee.closest(".cv-thumb, input, textarea") || P();
    }
    function D(ie, ee) {
      const me = s.value;
      if (!me || ee.button === 2) return;
      ee.stopPropagation();
      const L = t.results.list(e.id).find((B) => B.url === ie) || null;
      if (t.ui.eyedropper) {
        ee.preventDefault(), t.eyedrop(ie, L && L.asset || t.assetFor(ie), !!(L && L.video));
        return;
      }
      const N = L && L.w ? Math.max(200, Math.min(360, L.w)) : 300, K = L && L.w ? Math.round(N * L.h / L.w) : 200;
      i.dragResultOut({ url: ie, w: N, h: K, result: L, sessionId: me.id, label: L ? L.label : void 0 }, ee, {
        slop: 5,
        onClick: () => O(ie, L)
      });
    }
    function O(ie, ee) {
      const me = ee ? t.placedFor(ee.id) : null;
      if (ee && me) {
        t.ui.infoSession = ee.sessionId, t.ui.infoAt = me.id;
        return;
      }
      if (ee && ee.status === "done") {
        t.ui.infoSession = ee.sessionId, t.ui.infoAt = "result:" + ee.id;
        return;
      }
      const L = t.imagesInOrder().find((N) => N.src === ie);
      L && (t.ui.infoAt = L.id);
    }
    function F(ie) {
      const ee = t.store.get(e.id);
      ee && i.resizeDown(ee, ie);
    }
    return (ie, ee) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-tool", { "is-selected": o.value, "is-open": r.value, "cv-enter": n.enter, "is-ref-target": m(t).ui.refSession === n.id, "is-stack-top": !!n.stack, "is-stack-deep": !!n.stack && n.stack.length > 2, "is-folded": h.value }]),
      style: ce({
        left: m(s).x + "px",
        top: m(s).y + "px",
        width: m(Rt).w * c.value + "px",
        height: f.value * c.value + "px",
        zIndex: Math.round(m(s).z) + 10,
        "--d": (n.delay || 0) + "s"
      }),
      "data-el": n.id,
      "data-ref-session": n.id,
      onPointerdown: T,
      onDblclick: Te(R, ["stop"])
    }, [
      u("div", {
        class: "cv-el-body",
        style: ce(c.value !== 1 ? { transform: "scale(" + c.value + ")", transformOrigin: "0 0", width: m(Rt).w + "px", height: f.value + "px" } : void 0)
      }, [
        u("div", {
          class: G(["cv-bucket style-strip", { "is-busy": l.value }])
        }, [
          u("div", Hse, [
            u("span", Vse, [
              C($, {
                name: m(s).icon,
                size: 17
              }, null, 8, ["name"])
            ]),
            u("span", Wse, [
              u("span", qse, [
                Y(E(m(s).kind) + " ", 1),
                m(s).model ? (g(), b(j, { key: 0 }, [
                  ee[7] || (ee[7] = u("span", { class: "cv-bucket-sep" }, "·", -1)),
                  u("span", {
                    class: "cv-bucket-model",
                    title: "Model: " + m(s).model
                  }, E(m(s).model), 9, Kse)
                ], 64)) : z("", !0)
              ]),
              w.value ? (g(), b("input", {
                key: 0,
                ref_key: "nameInput",
                ref: S,
                class: "cv-bucket-name-input",
                value: m(s).name,
                spellcheck: "false",
                onPointerdown: ee[0] || (ee[0] = Te(() => {
                }, ["stop"])),
                onKeydown: [
                  ee[1] || (ee[1] = tn(Te((me) => _(!0), ["prevent"]), ["enter"])),
                  ee[2] || (ee[2] = tn(Te((me) => _(!1), ["stop", "prevent"]), ["esc"]))
                ],
                onBlur: ee[3] || (ee[3] = (me) => _(!0))
              }, null, 40, Yse)) : (g(), b("div", {
                key: 1,
                class: "cv-bucket-name",
                title: m(s).name,
                onDblclick: Te(M, ["stop"])
              }, E(m(s).name), 41, Xse))
            ]),
            u("button", {
              type: "button",
              class: "cv-fold",
              title: h.value ? "Expand" : "Collapse to its title",
              "aria-label": h.value ? "Expand" : "Collapse to its title",
              "aria-expanded": !h.value,
              disabled: a.value,
              "data-testid": "card-fold",
              onPointerdown: ee[4] || (ee[4] = Te(() => {
              }, ["stop"])),
              onDblclick: ee[5] || (ee[5] = Te(() => {
              }, ["stop"])),
              onClick: ee[6] || (ee[6] = Te((me) => m(t).toggleCollapsed([n.id]), ["stop"]))
            }, [
              C($, {
                name: h.value ? "ChevronDown" : "ChevronUp",
                size: 14
              }, null, 8, ["name"])
            ], 40, Jse),
            h.value && l.value ? (g(), b("span", {
              key: 0,
              class: "cv-count is-state",
              title: x.value
            }, [
              C($, {
                name: "Loader2",
                size: 11,
                spin: ""
              })
            ], 8, Zse)) : h.value && m(s).error ? (g(), b("span", {
              key: 1,
              class: "cv-count is-state is-error",
              title: m(s).error
            }, [
              C($, {
                name: "AlertCircle",
                size: 11
              })
            ], 8, Qse)) : (g(), b("span", eoe, E(m(s).count), 1))
          ]),
          h.value ? z("", !0) : (g(), b("div", toe, [
            l.value ? (g(), b(j, { key: 0 }, [
              (g(!0), b(j, null, ge(p.value, (me, L) => (g(), b("div", {
                key: "s" + L,
                class: "cv-thumb thumb-shimmer",
                style: ce({ backgroundImage: 'url("' + m(Bt)(me) + '")' })
              }, null, 4))), 128)),
              (g(!0), b(j, null, ge(y.value, (me) => (g(), b("div", {
                key: "se" + me,
                class: "cv-thumb-empty thumb-shimmer"
              }))), 128))
            ], 64)) : (g(), b(j, { key: 1 }, [
              (g(!0), b(j, null, ge(p.value, (me, L) => (g(), b("div", {
                key: m(s).id + "-" + me + "-" + L,
                class: G(["cv-thumb cv-thumb-pull", { "thumb-new": L < d.value }]),
                style: ce({ backgroundImage: 'url("' + m(Bt)(me) + '")', "--d": L < d.value ? L * 0.07 + "s" : void 0 }),
                title: "Click to view. Drag onto the board to place it.",
                "data-testid": "session-thumb-" + L,
                onPointerdown: (N) => D(me, N)
              }, null, 46, noe))), 128)),
              (g(!0), b(j, null, ge(y.value, (me) => (g(), b("div", {
                key: "e" + me,
                class: "cv-thumb-empty is-open",
                title: "Open this session",
                "data-testid": "session-slot",
                onPointerdown: k
              }, null, 32))), 128))
            ], 64))
          ])),
          h.value ? z("", !0) : (g(), b("div", ioe, [
            m(s).error && !l.value ? (g(), b("span", {
              key: 0,
              class: "is-error",
              title: m(s).error
            }, [
              C($, {
                name: "AlertCircle",
                size: 11
              }),
              ee[8] || (ee[8] = Y(" Run failed", -1))
            ], 8, soe)) : (g(), b("span", ooe, E(x.value), 1)),
            r.value ? z("", !0) : (g(), b("button", {
              key: 2,
              type: "button",
              class: "cv-bucket-open-hint",
              "data-testid": "session-open",
              onPointerdown: k,
              onClick: Te(A, ["stop"])
            }, [
              ee[9] || (ee[9] = Y("Open ", -1)),
              C($, {
                name: "ChevronRight",
                size: 11
              })
            ], 32))
          ])),
          ee[10] || (ee[10] = u("span", { class: "cv-ring" }, null, -1))
        ], 2)
      ], 4),
      r.value && !a.value && !h.value ? (g(), b("span", {
        key: 0,
        class: "cv-resize",
        title: "Resize",
        onPointerdown: F
      }, null, 32)) : z("", !0),
      n.stack ? (g(), Ie(uI, {
        key: 1,
        top: n.id,
        ids: n.stack
      }, null, 8, ["top", "ids"])) : z("", !0)
    ], 46, jse)) : z("", !0);
  }
}), aoe = ["data-el"], loe = {
  key: 0,
  class: "cv-el-body"
}, doe = { class: "cv-link-head" }, coe = { class: "ic" }, uoe = { class: "kind" }, hoe = ["title"], poe = { class: "cv-link-foot" }, foe = {
  key: 0,
  class: "miss"
}, moe = {
  key: 1,
  class: "cv-el-body"
}, goe = { class: "cv-note-meta" }, boe = /* @__PURE__ */ Pe({
  __name: "NoteCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = Ze(), s = as(() => e.id), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ Xt({ above: !1, below: !1 });
    function l() {
      const D = f.value ? o.value : r.value;
      a.above = !!D && D.scrollTop > 0, a.below = !!D && D.scrollTop + D.clientHeight < D.scrollHeight - 1;
    }
    const d = I(() => t.ui.selection.includes(e.id)), c = I(() => d.value && t.ui.selection.length === 1), h = I(() => (t.docRev.value, t.isHeld(s.value))), f = I(() => t.ui.editingNote === e.id), p = I(() => s.value && s.value.link || null), y = I(() => !!p.value && t.missingBoards.value.has(p.value.boardId));
    let v = "", x = 0, w = 0;
    function S() {
      if (clearTimeout(w), !o.value) return;
      const D = o.value.innerText.replace(/\n$/, ""), O = t.store.get(e.id);
      O && O.text !== D && t.store.update(e.id, { text: D }, { history: !1 });
    }
    function M() {
      clearTimeout(w), w = window.setTimeout(S, 350), _(), l();
    }
    function _() {
      const D = o.value, O = s.value;
      if (!D || !O || !O.grow || h.value) return;
      const F = D.scrollHeight - D.clientHeight;
      F > 0 && t.store.update(e.id, { h: O.h + F }, { history: !1 });
    }
    Ee(f, (D) => {
      if (!D) {
        nt(l);
        return;
      }
      v = s.value && s.value.text || "", x = s.value && s.value.h || 0, nt(() => {
        const O = o.value;
        if (!O) return;
        O.innerText = s.value && s.value.text || "", O.focus({ preventScroll: !0 });
        const F = document.createRange();
        F.selectNodeContents(O), F.collapse(!1);
        const ie = window.getSelection();
        ie && (ie.removeAllRanges(), ie.addRange(F)), l();
      });
    }, { immediate: !0 }), Ee(() => s.value && [s.value.text, s.value.w, s.value.h], () => nt(l)), it(l);
    function T(D) {
      if (f.value) {
        D.stopPropagation();
        return;
      }
      const O = t.store.get(e.id);
      O && i.elementDown(O, D);
    }
    function k() {
      t.editNote(e.id);
    }
    function P() {
      if (!f.value || !o.value) return;
      S();
      const D = o.value.innerText.replace(/\n$/, "");
      i.commitNote(e.id, D);
      const O = s.value && s.value.h || x, F = O !== x ? { h: x } : {};
      t.store.recordEdit("Edit note", e.id, { text: v, ...F }, { text: D, ...O !== x ? { h: O } : {} });
    }
    We(() => {
      f.value && S(), clearTimeout(w);
    });
    function A(D) {
      D.key === "Escape" && (D.preventDefault(), D.stopPropagation(), D.target.blur());
    }
    function R(D) {
      const O = t.store.get(e.id);
      O && i.resizeDown(O, D);
    }
    return (D, O) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-note", { "is-selected": d.value, "cv-enter": n.enter }]),
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: m(s).h + "px", zIndex: Math.round(m(s).z) + 10, "--d": (n.delay || 0) + "s" }),
      "data-el": n.id,
      onPointerdown: T
    }, [
      p.value ? (g(), b("div", loe, [
        u("div", {
          class: G(["cv-note cv-link", ["tint-" + (m(s).tint || "vista"), { "is-missing": y.value }]]),
          "data-testid": "board-link",
          onDblclick: O[2] || (O[2] = Te((F) => m(t).openBoardLink(n.id), ["stop"]))
        }, [
          u("div", doe, [
            u("span", coe, [
              C($, {
                name: "Link2",
                size: 13
              })
            ]),
            u("span", uoe, E(p.value.back ? "Back to" : "Linked board"), 1)
          ]),
          u("div", {
            class: "cv-link-title",
            title: p.value.title
          }, E(p.value.title), 9, hoe),
          u("div", poe, [
            y.value ? (g(), b("span", foe, "Not found, or you can't open it")) : (g(), b("button", {
              key: 1,
              type: "button",
              class: "cv-link-open",
              "data-testid": "board-link-open",
              onPointerdown: O[0] || (O[0] = Te(() => {
              }, ["stop"])),
              onClick: O[1] || (O[1] = Te((F) => m(t).openBoardLink(n.id), ["stop"]))
            }, [
              O[4] || (O[4] = Y(" Open board ", -1)),
              C($, {
                name: "ArrowUpRight",
                size: 12
              })
            ], 32))
          ]),
          O[5] || (O[5] = u("span", { class: "cv-ring" }, null, -1))
        ], 34)
      ])) : (g(), b("div", moe, [
        u("div", {
          class: G(["cv-note", ["tint-" + (m(s).tint || "glass"), { "is-editing": f.value, "more-above": a.above, "more-below": a.below }]]),
          onDblclick: Te(k, ["stop"])
        }, [
          f.value ? (g(), b("div", {
            key: 1,
            ref_key: "textEl",
            ref: o,
            class: "cv-note-text",
            contenteditable: "plaintext-only",
            spellcheck: "false",
            "data-placeholder": "Type a note…",
            onBlur: P,
            onInput: M,
            onKeydown: A,
            onScroll: l,
            onPointerdown: O[3] || (O[3] = Te(() => {
            }, ["stop"]))
          }, null, 544)) : (g(), b("div", {
            key: 0,
            ref_key: "viewEl",
            ref: r,
            class: "cv-note-text",
            "data-placeholder": "Double-click to write",
            onScroll: l
          }, E(m(s).text), 545)),
          u("div", goe, E(m(s).author || "You"), 1),
          O[6] || (O[6] = u("span", { class: "cv-ring" }, null, -1))
        ], 34)
      ])),
      c.value && !f.value && !h.value && !p.value ? (g(), b("span", {
        key: 2,
        class: "cv-resize",
        title: "Resize",
        onPointerdown: R
      }, null, 32)) : z("", !0)
    ], 46, aoe)) : z("", !0);
  }
}), voe = ["data-el"], yoe = { class: "cv-el-body" }, xoe = { class: "cv-bucket-head" }, woe = { class: "cv-badge ch-badge" }, koe = { class: "cv-bucket-titles" }, _oe = { class: "cv-bucket-kind" }, Soe = { class: "cv-bucket-model" }, Moe = ["value"], Toe = ["title"], Coe = ["title", "aria-label", "aria-expanded", "disabled"], Ioe = ["title"], Aoe = ["title"], Poe = {
  key: 1,
  class: "cv-bucket-foot"
}, Eoe = {
  key: 0,
  class: "ch-pulse"
}, Roe = {
  key: 0,
  class: "cv-bucket-open-hint"
}, zoe = /* @__PURE__ */ Pe({
  __name: "ChatCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {},
    stack: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = Ze(), s = os(t), o = as(() => e.id), r = I(() => t.ui.selection.includes(e.id)), a = I(() => t.ui.chatOpen === e.id), l = I(() => o.value ? s.contextOf(o.value) : null), d = I(() => l.value ? v8(l.value) : 0), c = I(() => o.value ? F8(o.value) : 0), h = I(() => o.value ? zG(o.value) : null), f = I(() => s.live[e.id] || null), p = I(() => o.value ? $G(o.value) : null), y = dr(), v = I(() => !!(o.value && o.value.collapsed)), x = I(() => (t.docRev.value, t.isHeld(o.value))), w = I(() => {
      if (f.value) return { text: f.value.status || "Writing…", busy: !0 };
      const A = p.value;
      if (A && A.status === "running") {
        const O = (A.steps || []).find((F) => F.id === "run" && F.status === "running");
        return { text: O ? O.text : "Running the plan…", busy: !0 };
      }
      if (A && A.status === "proposed") return { text: "Plan ready · " + k8(A.tokens), busy: !1 };
      const R = o.value ? o.value.messages || [] : [], D = R.length ? R[R.length - 1].at : 0;
      return y.value, { text: D ? "Updated " + Jn(D) : l.value ? "No messages yet" : "Not in a frame", busy: !1 };
    }), S = /* @__PURE__ */ W(!1), M = /* @__PURE__ */ W(null);
    function _() {
      S.value = !0, nt(() => {
        M.value && (M.value.focus({ preventScroll: !0 }), M.value.select());
      });
    }
    function T(A) {
      if (!S.value) return;
      const R = M.value ? M.value.value.trim() : "";
      S.value = !1, A && R && o.value && R !== o.value.name && t.patch(e.id, { name: R }, "Rename chat");
    }
    function k(A) {
      !o.value || S.value || i.elementDown(t.store.get(e.id), A);
    }
    function P() {
      t.ui.selection = [e.id], t.ui.chatOpen = e.id;
    }
    return (A, R) => m(o) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-chat", { "is-selected": r.value, "is-open": a.value, "cv-enter": n.enter, "is-stack-top": !!n.stack, "is-stack-deep": !!n.stack && n.stack.length > 2, "is-folded": v.value }]),
      style: ce({ left: m(o).x + "px", top: m(o).y + "px", width: m(o).w + "px", height: (v.value ? m(Nc) : m(o).h) + "px", zIndex: Math.round(m(o).z) + 10, "--d": (n.delay || 0) + "s" }),
      "data-el": n.id,
      "data-testid": "chat-card",
      onPointerdown: k,
      onDblclick: Te(P, ["stop"])
    }, [
      u("div", yoe, [
        u("div", {
          class: G(["cv-bucket ch-card", { "is-busy": w.value.busy, "is-live": a.value }])
        }, [
          u("div", xoe, [
            u("span", woe, [
              C($, {
                name: "MessagesSquare",
                size: 17
              })
            ]),
            u("span", koe, [
              u("span", _oe, [
                R[8] || (R[8] = Y(" Chat ", -1)),
                l.value ? (g(), b(j, { key: 0 }, [
                  R[7] || (R[7] = u("span", { class: "cv-bucket-sep" }, "·", -1)),
                  u("span", Soe, E(d.value) + " in context", 1)
                ], 64)) : z("", !0)
              ]),
              S.value ? (g(), b("input", {
                key: 0,
                ref_key: "nameInput",
                ref: M,
                class: "cv-bucket-name-input",
                value: m(o).name,
                spellcheck: "false",
                onPointerdown: R[0] || (R[0] = Te(() => {
                }, ["stop"])),
                onKeydown: [
                  R[1] || (R[1] = tn(Te((D) => T(!0), ["prevent"]), ["enter"])),
                  R[2] || (R[2] = tn(Te((D) => T(!1), ["stop", "prevent"]), ["esc"]))
                ],
                onBlur: R[3] || (R[3] = (D) => T(!0))
              }, null, 40, Moe)) : (g(), b("div", {
                key: 1,
                class: "cv-bucket-name",
                title: m(o).name,
                onDblclick: Te(_, ["stop"])
              }, E(m(o).name), 41, Toe))
            ]),
            u("button", {
              type: "button",
              class: "cv-fold",
              title: v.value ? "Expand" : "Collapse to its title",
              "aria-label": v.value ? "Expand" : "Collapse to its title",
              "aria-expanded": !v.value,
              disabled: x.value,
              "data-testid": "card-fold",
              onPointerdown: R[4] || (R[4] = Te(() => {
              }, ["stop"])),
              onDblclick: R[5] || (R[5] = Te(() => {
              }, ["stop"])),
              onClick: R[6] || (R[6] = Te((D) => m(t).toggleCollapsed([n.id]), ["stop"]))
            }, [
              C($, {
                name: v.value ? "ChevronDown" : "ChevronUp",
                size: 14
              }, null, 8, ["name"])
            ], 40, Coe),
            v.value && w.value.busy ? (g(), b("span", {
              key: 0,
              class: "cv-count is-state",
              title: w.value.text
            }, [...R[9] || (R[9] = [
              u("span", { class: "ch-pulse" }, null, -1)
            ])], 8, Ioe)) : (g(), b("span", {
              key: 1,
              class: "cv-count",
              title: c.value === 1 ? "1 message" : c.value + " messages"
            }, E(c.value), 9, Aoe))
          ]),
          v.value ? z("", !0) : (g(), b("div", {
            key: 0,
            class: G(["ch-card-last", { "is-empty": !h.value }])
          }, [
            h.value ? (g(), b(j, { key: 0 }, [
              u("b", null, E(h.value.who) + ":", 1),
              Y(" " + E(h.value.text), 1)
            ], 64)) : (g(), b(j, { key: 1 }, [
              Y(E(m(s).frameOf(m(o)) ? "Ask about this frame, or have it set up tools here." : "Ask about the pictures it picked, or have it set up tools for them."), 1)
            ], 64))
          ], 2)),
          v.value ? z("", !0) : (g(), b("div", Poe, [
            u("span", {
              class: G(["ch-card-state", { "is-busy": w.value.busy }])
            }, [
              w.value.busy ? (g(), b("span", Eoe)) : z("", !0),
              Y(E(w.value.text), 1)
            ], 2),
            a.value ? z("", !0) : (g(), b("span", Roe, [
              R[10] || (R[10] = Y("Open ", -1)),
              C($, {
                name: "ChevronRight",
                size: 11
              })
            ]))
          ])),
          R[11] || (R[11] = u("span", { class: "cv-ring" }, null, -1))
        ], 2)
      ]),
      n.stack ? (g(), Ie(uI, {
        key: 0,
        top: n.id,
        ids: n.stack
      }, null, 8, ["top", "ids"])) : z("", !0)
    ], 46, voe)) : z("", !0);
  }
}), $oe = /* @__PURE__ */ Pe({
  __name: "FrameGlow",
  props: {
    frameId: {},
    chatId: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = os(t), s = as(() => e.frameId), o = I(() => {
      if (i.live[e.chatId]) return !0;
      const r = i.open.value;
      return !!r && (r.messages || []).some((a) => a.plan && a.plan.status === "running");
    });
    return (r, a) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-frame-glow", { "is-working": o.value }]),
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: m(s).h + "px" }),
      "data-testid": "frame-glow",
      "aria-hidden": "true"
    }, null, 6)) : z("", !0);
  }
}), Doe = /* @__PURE__ */ Pe({
  __name: "PickGlow",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, t = as(() => e.id);
    return (i, s) => m(t) ? (g(), b("div", {
      key: 0,
      class: "cv-frame-glow cv-pick-glow",
      style: ce({ left: m(t).x + "px", top: m(t).y + "px", width: m(t).w + "px", height: m(t).h + "px" }),
      "data-testid": "pick-glow",
      "aria-hidden": "true"
    }, null, 4)) : z("", !0);
  }
}), Ooe = ["value"], Loe = {
  key: 2,
  class: "cv-frame-name"
}, Boe = { class: "cv-frame-count" }, Foe = /* @__PURE__ */ Pe({
  __name: "FrameTitle",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = Ze(), s = as(() => e.id), o = /* @__PURE__ */ W(null), r = I(() => t.ui.selection.includes(e.id)), a = I(() => t.ui.editingTitle === e.id), l = I(() => {
      t.docRev.value;
      const h = t.store.get(e.id);
      return h ? t.carriedBy(h).filter((f) => {
        const p = t.store.get(f);
        return !!p && p.type !== "frame";
      }).length : 0;
    });
    Ee(a, (h) => {
      h && nt(() => {
        o.value && (o.value.focus({ preventScroll: !0 }), o.value.select());
      });
    }, { immediate: !0 });
    function d(h) {
      if (a.value) return;
      const f = t.store.get(e.id);
      f && i.elementDown(f, h);
    }
    function c(h) {
      if (!a.value) return;
      const f = o.value ? o.value.value : "";
      t.ui.editingTitle = null, h && t.renameFrame(e.id, f);
    }
    return (h, f) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-frame-title", { "cv-enter": n.enter }]),
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: "0px", zIndex: 5, "--d": (n.delay || 0) + "s" })
    }, [
      u("div", {
        class: G(["cv-frame-title", { "is-selected": r.value, "is-locked": m(s).locked }]),
        onPointerdown: d,
        onDblclick: f[4] || (f[4] = Te((p) => m(t).ui.editingTitle = n.id, ["stop"]))
      }, [
        m(s).locked ? (g(), Ie($, {
          key: 0,
          class: "cv-frame-lock",
          name: "Lock",
          size: 11,
          stroke: 2.25,
          "data-testid": "frame-locked"
        })) : z("", !0),
        a.value ? (g(), b("input", {
          key: 1,
          ref_key: "inputEl",
          ref: o,
          class: "cv-frame-title-input",
          value: m(s).title,
          spellcheck: "false",
          onPointerdown: f[0] || (f[0] = Te(() => {
          }, ["stop"])),
          onKeydown: [
            f[1] || (f[1] = tn(Te((p) => c(!0), ["prevent"]), ["enter"])),
            f[2] || (f[2] = tn(Te((p) => c(!1), ["stop", "prevent"]), ["esc"]))
          ],
          onBlur: f[3] || (f[3] = (p) => c(!0))
        }, null, 40, Ooe)) : (g(), b("span", Loe, E(m(s).title), 1)),
        u("span", Boe, E(l.value) + " " + E(l.value === 1 ? "item" : "items"), 1)
      ], 34)
    ], 6)) : z("", !0);
  }
}), Noe = {
  key: 0,
  class: "cv-img-vid"
}, Uoe = {
  key: 1,
  class: "cv-img-fav"
}, Goe = ["title"], joe = /* @__PURE__ */ Pe({
  __name: "ImageBadges",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = as(() => e.id), s = I(() => {
      const r = i.value;
      return r ? (t.results.rev.value, t.isFav(r.resultId && t.results.get(r.resultId) || null, r)) : !1;
    }), o = I(() => !!i.value && t.isPinnedImage(i.value.src));
    return (r, a) => m(i) && (m(i).video || s.value || o.value) ? (g(), b("div", {
      key: 0,
      class: "cv-img-badges",
      style: ce({
        left: m(i).x + "px",
        top: m(i).y - (m(t).ui.hoverId === n.id ? 4 : 0) + "px",
        width: m(i).w + "px",
        height: m(i).h + "px",
        transition: "top 200ms cubic-bezier(0.16,1,0.3,1)"
      })
    }, [
      m(i).video ? (g(), b("span", Noe, [
        C($, {
          name: "Play",
          size: 9
        }),
        Y(" " + E(m(i).dur || "0:05"), 1)
      ])) : z("", !0),
      s.value ? (g(), b("span", Uoe, [
        C($, {
          name: "Heart",
          size: 9
        })
      ])) : z("", !0),
      o.value ? (g(), b("span", {
        key: 2,
        class: "cv-img-pin",
        title: m(Xn).badge,
        "data-testid": "card-pinned"
      }, [
        C($, {
          name: "Pin",
          size: 10
        })
      ], 8, Goe)) : z("", !0)
    ], 4)) : z("", !0);
  }
}), Hoe = { class: "cv-img-foot" }, Voe = {
  key: 0,
  class: "cv-img-model",
  "data-testid": "image-model"
}, Woe = { class: "cv-img-label" }, qoe = {
  key: 1,
  class: "cv-img-hint",
  "data-testid": "image-ref-hint"
}, Koe = { class: "cv-img-actions" }, Yoe = 280, Xoe = /* @__PURE__ */ Pe({
  __name: "ImageHover",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = as(() => e.id), s = rm().shift, o = I(() => !!i.value && !!t.promptTool.value && i.value.w * t.cam.value.zoom >= Yoe), r = I(() => {
      const l = i.value;
      if (!l || !l.resultId) return "";
      t.results.rev.value;
      const d = t.results.get(l.resultId);
      return d && d.model || "";
    });
    function a(l) {
      l.stopPropagation(), t.deleteIds([e.id]);
    }
    return (l, d) => m(i) ? (g(), b("div", {
      key: 0,
      class: "cv-img-hover",
      style: ce({ left: m(i).x + "px", top: m(i).y - 4 + "px", width: m(i).w + "px", height: m(i).h + "px" })
    }, [
      d[2] || (d[2] = u("div", { class: "cv-img-shade" }, null, -1)),
      u("div", Hoe, [
        r.value ? (g(), b("span", Voe, E(r.value), 1)) : z("", !0),
        u("span", Woe, E(m(i).label), 1),
        o.value ? (g(), b("span", qoe, [
          u("kbd", null, E(m(s)), 1),
          d[1] || (d[1] = Y("Drag to use as a reference", -1))
        ])) : z("", !0)
      ]),
      u("div", Koe, [
        u("button", {
          title: "Remove",
          onPointerdown: d[0] || (d[0] = Te(() => {
          }, ["stop"])),
          onClick: a
        }, [
          C($, {
            name: "Trash2",
            size: 13
          })
        ], 32)
      ])
    ], 4)) : z("", !0);
  }
}), Joe = { class: "cv-dropper-chip" }, Zoe = /* @__PURE__ */ Pe({
  __name: "DropperRing",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = as(() => e.id), s = I(() => {
      const r = t.ui.eyedropper;
      return !!r && !!i.value && t.refImages(r.sessionId, r.key).includes(i.value.src);
    }), o = I(() => {
      if (s.value) return "In the prompt";
      const r = t.eyedropperField;
      return r && r.kind === "images" ? "Add to the prompt" : "Use in the prompt";
    });
    return (r, a) => m(i) ? (g(), b("div", {
      key: 0,
      class: G(["cv-dropper-ring", { "is-in": s.value }]),
      style: ce({ left: m(i).x + "px", top: m(i).y - 4 + "px", width: m(i).w + "px", height: m(i).h + "px" }),
      "data-testid": "eyedropper-ring"
    }, [
      u("span", Joe, [
        C($, {
          name: s.value ? "Check" : "Pipette",
          size: 11
        }, null, 8, ["name"]),
        Y(E(o.value), 1)
      ])
    ], 6)) : z("", !0);
  }
}), Qoe = ["data-id"], ere = ["src"], tre = { class: "cv-vid-bar" }, nre = /* @__PURE__ */ Pe({
  __name: "VideoHover",
  props: {
    id: {},
    active: { type: Boolean },
    light: { type: Boolean }
  },
  setup(n) {
    const e = n, t = as(() => e.id), i = I(() => {
      const c = t.value;
      return c && (e.light && c.previewSrc || c.videoSrc) || "";
    }), s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(!1);
    let a = 0;
    function l() {
      const c = s.value;
      c && o.value && c.duration > 0 && (o.value.style.transform = "scaleX(" + Math.min(1, c.currentTime / c.duration) + ")"), a = requestAnimationFrame(l);
    }
    function d() {
      const c = s.value;
      if (!c) return;
      c.muted = !0;
      const h = c.play();
      h && h.catch(() => {
      });
    }
    return Ee(() => e.active, (c) => {
      c && d();
    }), it(() => {
      const c = s.value;
      c && (typeof c.requestVideoFrameCallback == "function" ? c.requestVideoFrameCallback(() => {
        r.value = !0;
      }) : c.addEventListener("playing", () => {
        r.value = !0;
      }, { once: !0 }), d(), a = requestAnimationFrame(l));
    }), We(() => {
      cancelAnimationFrame(a);
      const c = s.value;
      c && (c.pause(), c.removeAttribute("src"), c.load());
    }), (c, h) => m(t) && m(t).videoSrc ? (g(), b("div", {
      key: 0,
      class: G(["cv-vid", { "is-shown": r.value && n.active }]),
      style: ce({ left: m(t).x + "px", top: m(t).y - (n.active ? 4 : 0) + "px", width: m(t).w + "px", height: m(t).h + "px" }),
      "data-testid": "hover-video",
      "data-id": n.id
    }, [
      u("video", {
        ref_key: "video",
        ref: s,
        src: i.value,
        muted: "",
        loop: "",
        playsinline: "",
        preload: "auto",
        disablepictureinpicture: ""
      }, null, 8, ere),
      u("div", tre, [
        u("i", {
          ref_key: "bar",
          ref: o
        }, null, 512)
      ])
    ], 14, Qoe)) : z("", !0);
  }
}), ire = /* @__PURE__ */ Pe({
  __name: "GpuHandle",
  props: {
    id: {}
  },
  setup(n) {
    const e = n, { board: t, input: i } = Ze(), s = as(() => e.id);
    function o(r) {
      const a = t.store.get(e.id);
      a && i.resizeDown(a, r);
    }
    return (r, a) => m(s) ? (g(), b("div", {
      key: 0,
      class: "cv-el is-handle",
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: Math.max(0, m(s).w) + "px", height: Math.max(0, m(s).h) + "px", pointerEvents: "none", zIndex: 9999 })
    }, [
      u("span", {
        class: "cv-resize",
        title: "Resize",
        onPointerdown: o
      }, null, 32)
    ], 4)) : z("", !0);
  }
}), sre = 64, ore = 512, rre = /* @__PURE__ */ Pe({
  __name: "WorldLayer",
  setup(n) {
    const { board: e } = Ze(), t = os(e), i = /* @__PURE__ */ W(!0), s = /* @__PURE__ */ new Map();
    {
      const x = e.overlayIds.value.map((S) => e.store.get(S)).filter(Boolean);
      x.sort((S, M) => S.y - M.y || S.x - M.x);
      const w = Math.min(0.045, 0.9 / Math.max(1, x.length));
      x.forEach((S, M) => s.set(S.id, M * w));
    }
    const o = window.setTimeout(() => {
      i.value = !1;
    }, 1700);
    We(() => clearTimeout(o));
    const r = I(() => {
      e.docRev.value;
      const x = [], w = [], S = [];
      for (const M of e.overlayIds.value) {
        const _ = e.store.get(M);
        _ && (_.type === "frame" ? x.push(M) : _.type === "tool" || _.type === "note" || _.type === "chat" ? w.push({ id: M, type: _.type, z: _.z }) : _.type === "image" && S.push(M));
      }
      return w.sort((M, _) => M.z - _.z), { frames: x, cards: w, badges: S };
    }), a = I(() => {
      e.docRev.value;
      const x = [];
      for (const w of r.value.cards) {
        const S = w.type === "note" ? null : e.store.get(w.id);
        S && x.push(S);
      }
      return gj(x);
    }), l = I(() => {
      const x = e.ui.hoverId;
      if (!x || e.ui.dragging || e.ui.eyedropper) return null;
      const w = e.store.get(x);
      return w && w.type === "image" && !e.ui.selection.includes(x) ? x : null;
    }), d = I(() => {
      const x = e.ui.hoverId;
      if (!x || e.ui.dragging || !e.ui.eyedropper) return null;
      const w = e.store.get(x);
      return w && w.type === "image" && e.eyedropperTakes(!!w.video) ? x : null;
    }), c = I(() => {
      e.docRev.value;
      const x = e.ui.hoverId;
      if (!x || e.ui.dragging) return null;
      const w = e.store.get(x);
      if (!w || w.type !== "image") return null;
      const S = w;
      return !S.video || !S.videoSrc ? null : S.w * e.cam.value.zoom >= sre ? x : null;
    }), h = /* @__PURE__ */ qe(null);
    let f = 0;
    Ee(c, (x) => {
      if (clearTimeout(f), x) {
        const S = h.value;
        if (S && S.id === x) {
          h.value = { ...S, active: !0 };
          return;
        }
        const M = e.store.get(x), _ = !!M && Math.max(M.w, M.h) * e.cam.value.zoom <= ore;
        h.value = { id: x, active: !0, light: _ };
        return;
      }
      const w = h.value;
      w && (h.value = { ...w, active: !1 }, f = window.setTimeout(() => {
        h.value && !h.value.active && (h.value = null);
      }, 260));
    }, { immediate: !0 }), We(() => clearTimeout(f));
    const p = I(() => {
      const x = t.open.value, w = x ? t.frameOf(x) : null;
      return x && w ? { frameId: w.id, chatId: x.id } : null;
    }), y = I(() => {
      const x = t.open.value;
      return !x || p.value ? [] : t.picksOf(x).map((w) => w.id);
    }), v = I(() => {
      if (e.docRev.value, e.ui.selection.length !== 1 || e.ui.dragging) return null;
      const x = e.store.get(e.ui.selection[0]);
      return x && (x.type === "image" || x.type === "frame" || x.type === "shape") && !e.isHeld(x) ? x.id : null;
    });
    return (x, w) => (g(), b(j, null, [
      (g(!0), b(j, null, ge(r.value.frames, (S) => (g(), Ie(Foe, {
        key: "ft-" + S,
        id: S,
        enter: i.value && m(s).has(S),
        delay: m(s).get(S)
      }, null, 8, ["id", "enter", "delay"]))), 128)),
      p.value ? (g(), Ie($oe, {
        key: "fg-" + p.value.frameId,
        "frame-id": p.value.frameId,
        "chat-id": p.value.chatId
      }, null, 8, ["frame-id", "chat-id"])) : z("", !0),
      (g(!0), b(j, null, ge(y.value, (S) => (g(), Ie(Doe, {
        key: "pg-" + S,
        id: S
      }, null, 8, ["id"]))), 128)),
      h.value ? (g(), Ie(nre, {
        key: "vh-" + h.value.id,
        id: h.value.id,
        active: h.value.active,
        light: h.value.light
      }, null, 8, ["id", "active", "light"])) : z("", !0),
      (g(!0), b(j, null, ge(r.value.badges, (S) => (g(), Ie(joe, {
        key: "ib-" + S,
        id: S
      }, null, 8, ["id"]))), 128)),
      (g(!0), b(j, null, ge(r.value.cards, (S) => (g(), b(j, {
        key: S.id
      }, [
        S.type === "tool" ? (g(), Ie(roe, {
          key: 0,
          id: S.id,
          enter: i.value && m(s).has(S.id),
          delay: m(s).get(S.id),
          stack: a.value.get(S.id) || null
        }, null, 8, ["id", "enter", "delay", "stack"])) : S.type === "chat" ? (g(), Ie(zoe, {
          key: 1,
          id: S.id,
          enter: i.value && m(s).has(S.id),
          delay: m(s).get(S.id),
          stack: a.value.get(S.id) || null
        }, null, 8, ["id", "enter", "delay", "stack"])) : (g(), Ie(boe, {
          key: 2,
          id: S.id,
          enter: i.value && m(s).has(S.id),
          delay: m(s).get(S.id)
        }, null, 8, ["id", "enter", "delay"]))
      ], 64))), 128)),
      l.value ? (g(), Ie(Xoe, {
        key: "hv-" + l.value,
        id: l.value
      }, null, 8, ["id"])) : z("", !0),
      d.value ? (g(), Ie(Zoe, {
        key: "dr-" + d.value,
        id: d.value
      }, null, 8, ["id"])) : z("", !0),
      v.value ? (g(), Ie(ire, {
        key: 4,
        id: v.value
      }, null, 8, ["id"])) : z("", !0)
    ], 64));
  }
}), are = {
  key: 0,
  class: "cv-guides",
  "aria-hidden": "true",
  "data-testid": "snap-guides"
}, lre = ["d"], dre = ["d"], cre = ["d"], ure = ["d"], Eh = 16, R_ = 4, z_ = 4, vo = 4, hre = /* @__PURE__ */ Pe({
  __name: "SnapGuides",
  setup(n) {
    const { board: e } = Ze(), t = I(() => {
      const i = e.guides.value;
      if (!i) return null;
      const s = e.cam.value, o = window.devicePixelRatio || 1, r = (f) => Math.round((f - 0.5) * o) / o + 0.5, a = (f) => f * s.zoom + s.x, l = (f) => f * s.zoom + s.y, d = (f) => Math.floor(f / (R_ * 2)) * R_ * 2;
      let c = "";
      for (const f of i.lines)
        if (f.axis === "x") {
          const p = r(a(f.at));
          c += "M" + p + " " + d(l(f.from) - Eh) + "V" + (l(f.to) + Eh);
        } else {
          const p = r(l(f.at));
          c += "M" + d(a(f.from) - Eh) + " " + p + "H" + (a(f.to) + Eh);
        }
      let h = "";
      for (const f of i.gaps) {
        const p = (f.axis === "x" ? a(f.from) : l(f.from)) + z_, y = (f.axis === "x" ? a(f.to) : l(f.to)) - z_;
        if (y - p < 4) continue;
        const v = r(p), x = r(y), w = r(f.axis === "x" ? l(f.at) : a(f.at));
        h += f.axis === "x" ? "M" + v + " " + w + "H" + x + "M" + v + " " + (w - vo) + "V" + (w + vo) + "M" + x + " " + (w - vo) + "V" + (w + vo) : "M" + w + " " + v + "V" + x + "M" + (w - vo) + " " + v + "H" + (w + vo) + "M" + (w - vo) + " " + x + "H" + (w + vo);
      }
      return c || h ? { lines: c, gaps: h } : null;
    });
    return (i, s) => t.value ? (g(), b("svg", are, [
      t.value.lines ? (g(), b("path", {
        key: 0,
        class: "cv-guide-halo is-dashed",
        d: t.value.lines
      }, null, 8, lre)) : z("", !0),
      t.value.gaps ? (g(), b("path", {
        key: 1,
        class: "cv-guide-halo",
        d: t.value.gaps
      }, null, 8, dre)) : z("", !0),
      t.value.lines ? (g(), b("path", {
        key: 2,
        class: "cv-guide-line",
        d: t.value.lines,
        "data-testid": "snap-lines"
      }, null, 8, cre)) : z("", !0),
      t.value.gaps ? (g(), b("path", {
        key: 3,
        class: "cv-guide-gap",
        d: t.value.gaps,
        "data-testid": "snap-gaps"
      }, null, 8, ure)) : z("", !0)
    ])) : z("", !0);
  }
}), pre = { class: "bd-dropper-mark" }, fre = { class: "bd-dropper-text" }, mre = {
  key: 0,
  class: "bd-dropper-count",
  "data-testid": "eyedropper-count"
}, gre = /* @__PURE__ */ Pe({
  __name: "EyedropperBanner",
  setup(n) {
    const { board: e } = Ze(), t = I(() => {
      e.docRev.value;
      const i = e.ui.eyedropper, s = e.eyedropperField, o = e.promptTool.value;
      if (!i || !s || !o) return null;
      if (s.kind === "images")
        return { text: "Click an image on the board to add it to the prompt", count: e.refImages(i.sessionId, i.key).length + " of " + Zs(s) };
      const r = e.modelFor(o).model, a = !!r && r.fields.filter((d) => d.placement === "reference").length > 1;
      return { text: (s.kind === "video" ? "Click a video on the board to use it" : "Click an image on the board to use it") + (a ? " for the " + s.label.toLowerCase() : ""), count: "" };
    });
    return (i, s) => (g(), Ie(vt, { name: "bd-dropper" }, {
      default: Xe(() => [
        t.value ? (g(), b("div", {
          key: 0,
          class: "bd-dropper",
          role: "status",
          "data-testid": "eyedropper-banner",
          onPointerdown: s[1] || (s[1] = Te(() => {
          }, ["stop"]))
        }, [
          u("span", pre, [
            C($, {
              name: "Pipette",
              size: 13
            })
          ]),
          u("span", fre, E(t.value.text), 1),
          t.value.count ? (g(), b("span", mre, E(t.value.count), 1)) : z("", !0),
          u("button", {
            class: "bd-dropper-done",
            title: "Done (Esc)",
            "data-testid": "eyedropper-done",
            onClick: s[0] || (s[0] = (o) => m(e).ui.eyedropper = null)
          }, "Done")
        ], 32)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), bre = { class: "up-adv-head" }, vre = ["disabled", "data-testid"], yre = { class: "up-adv-label" }, xre = {
  key: 0,
  class: "req"
}, wre = ["title"], kre = {
  key: 0,
  class: "up-adv-why"
}, _re = {
  key: 1,
  class: "up-adv-row"
}, Sre = ["min", "max", "step", "value", "onInput"], Mre = ["min", "max", "step", "value", "onChange"], Tre = { class: "up-seg" }, Cre = ["onClick"], Ire = ["onClick"], Are = ["value", "onChange"], Pre = ["aria-pressed", "onClick"], Ere = {
  key: 4,
  class: "up-seg"
}, Rre = ["onClick"], zre = ["value", "onChange"], $re = ["value"], Dre = ["value", "placeholder", "onChange"], Ore = ["value", "placeholder", "onChange"], Lre = /* @__PURE__ */ Pe({
  __name: "AdvancedPanel",
  props: {
    tool: {},
    model: {},
    form: {}
  },
  emits: ["close"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = Ze(), o = I(() => t.model.fields.filter((v) => v.placement === "advanced" && v.kind !== "header" && Gr(t.form, v.key).shown)), r = I(() => s.promptOf(t.tool.id));
    function a(v) {
      return Gr(t.form, v.key);
    }
    function l(v) {
      return v.key in t.form.values ? t.form.values[v.key] : Lc(v, r.value);
    }
    function d(v) {
      const x = l(v);
      return x == null ? "" : String(x);
    }
    function c(v, x) {
      s.setPrompt(t.tool.id, { inputs: { ...r.value.inputs || {}, [v]: x } });
    }
    function h() {
      const v = { ...r.value.inputs || {} };
      for (const x of o.value) delete v[x.key];
      s.setPrompt(t.tool.id, { inputs: v });
    }
    function f(v) {
      const x = Number(l(v));
      return Number.isFinite(x) ? x : v.min || 0;
    }
    function p(v, x) {
      const w = cc(v, x);
      w != null && c(v.key, w);
    }
    function y(v) {
      const x = l(v);
      return x == null || x === "" || x === -1 ? "random" : "custom";
    }
    return (v, x) => (g(), b("aside", {
      class: "up-adv",
      "data-testid": "advanced-panel",
      onPointerdown: x[5] || (x[5] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", bre, [
        x[6] || (x[6] = u("span", { class: "up-adv-title" }, "Advanced", -1)),
        u("button", {
          class: "cv-iconbtn",
          title: "Reset to model defaults",
          onClick: h
        }, [
          C($, {
            name: "RotateCcw",
            size: 14
          })
        ]),
        u("button", {
          class: "cv-iconbtn",
          title: "Close",
          onClick: x[0] || (x[0] = (w) => i("close"))
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      (g(!0), b(j, null, ge(o.value, (w) => (g(), b("fieldset", {
        key: w.key,
        class: G(["up-adv-field", { "is-locked": a(w).locked }]),
        disabled: a(w).locked,
        "data-testid": "adv-" + w.key
      }, [
        u("div", yre, [
          Y(E(w.label), 1),
          a(w).required ? (g(), b("span", xre, "*")) : z("", !0),
          w.tooltip ? (g(), b("span", {
            key: 1,
            title: w.tooltip
          }, [
            C($, {
              name: "HelpCircle",
              size: 12
            })
          ], 8, wre)) : z("", !0)
        ]),
        a(w).locked ? (g(), b("div", kre, [
          C($, {
            name: "Lock",
            size: 11
          }),
          Y(E(a(w).why), 1)
        ])) : z("", !0),
        w.kind === "slider" ? (g(), b("div", _re, [
          u("input", {
            class: "up-range",
            type: "range",
            min: w.min,
            max: w.max,
            step: w.step || 1,
            value: f(w),
            onInput: (S) => p(w, S.target.value)
          }, null, 40, Sre),
          u("input", {
            class: "up-adv-num",
            type: "number",
            min: w.min,
            max: w.max,
            step: w.step || 1,
            value: f(w),
            onChange: (S) => p(w, S.target.value),
            onKeydown: x[1] || (x[1] = Te(() => {
            }, ["stop"]))
          }, null, 40, Mre)
        ])) : w.kind === "seed" ? (g(), b(j, { key: 2 }, [
          u("div", Tre, [
            u("button", {
              class: G({ on: y(w) === "random" }),
              onClick: (S) => c(w.key, null)
            }, "Random", 10, Cre),
            u("button", {
              class: G({ on: y(w) === "custom" }),
              onClick: (S) => y(w) === "random" && c(w.key, Math.floor(Math.random() * 1e9))
            }, "Custom", 10, Ire)
          ]),
          y(w) === "custom" ? (g(), b("input", {
            key: 0,
            class: "up-adv-num is-full",
            value: d(w),
            placeholder: "e.g. 284917",
            inputmode: "numeric",
            onChange: (S) => c(w.key, S.target.value === "" ? null : Number(S.target.value)),
            onKeydown: x[2] || (x[2] = Te(() => {
            }, ["stop"]))
          }, null, 40, Are)) : z("", !0)
        ], 64)) : w.kind === "boolean" ? (g(), b("button", {
          key: 3,
          class: G(["up-toggle", { on: !!l(w) }]),
          "aria-pressed": !!l(w),
          onClick: (S) => c(w.key, !l(w))
        }, null, 10, Pre)) : (w.kind === "select" || w.kind === "size") && (w.options || []).length <= 6 ? (g(), b("div", Ere, [
          (g(!0), b(j, null, ge(w.options || [], (S) => (g(), b("button", {
            key: m(xn)(S.value),
            class: G({ on: m(Qi)(S.value, l(w)) }),
            onClick: (M) => c(w.key, S.value)
          }, E(S.label), 11, Rre))), 128))
        ])) : w.kind === "select" || w.kind === "size" ? (g(), b("select", {
          key: 5,
          class: "up-adv-num is-full",
          value: m(xn)(l(w)),
          onChange: (S) => {
            var M;
            return c(w.key, (M = (w.options || []).find((_) => m(xn)(_.value) === S.target.value)) == null ? void 0 : M.value);
          }
        }, [
          (g(!0), b(j, null, ge(w.options || [], (S) => (g(), b("option", {
            key: m(xn)(S.value),
            value: m(xn)(S.value)
          }, E(S.label), 9, $re))), 128))
        ], 40, zre)) : w.kind === "negPrompt" ? (g(), b("textarea", {
          key: 6,
          class: "up-adv-num is-full",
          value: d(w),
          placeholder: w.placeholder || "What to keep out of the image",
          onChange: (S) => c(w.key, S.target.value),
          onKeydown: x[3] || (x[3] = Te(() => {
          }, ["stop"]))
        }, null, 40, Dre)) : (g(), b("input", {
          key: 7,
          class: "up-adv-num is-full",
          value: d(w),
          placeholder: w.placeholder,
          onChange: (S) => c(w.key, S.target.value),
          onKeydown: x[4] || (x[4] = Te(() => {
          }, ["stop"]))
        }, null, 40, Ore))
      ], 10, vre))), 128))
    ], 32));
  }
}), Bre = ["aria-label", "onMouseenter"], Fre = ["title", "aria-label"], Nre = { class: "n" }, Ure = { class: "ic" }, cb = 3, Gre = /* @__PURE__ */ Pe({
  __name: "InputStack",
  props: {
    inputs: {}
  },
  emits: ["peek"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(0), o = /* @__PURE__ */ W(-1), r = I(() => Math.max(0, t.inputs.length - cb)), a = I(() => r.value - s.value);
    function l(c) {
      o.value = c, i("peek", c >= 0 ? t.inputs[c] : null);
    }
    function d() {
      s.value = s.value >= r.value ? 0 : s.value + 1;
    }
    return (c, h) => (g(), b("div", {
      class: "pl-stack",
      onMouseleave: h[1] || (h[1] = (f) => l(-1)),
      onClick: h[2] || (h[2] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", {
        class: "pl-stack-win",
        style: ce({ "--rows": Math.min(cb, n.inputs.length) })
      }, [
        u("div", {
          class: "pl-stack-reel",
          style: ce({ "--off": s.value })
        }, [
          (g(!0), b(j, null, ge(n.inputs, (f, p) => (g(), b("span", {
            key: p,
            class: G(["pl-stack-th", { on: o.value === p, "is-markup": f.kind === "markup" }]),
            style: ce({ backgroundImage: 'url("' + f.url + '")' }),
            "aria-label": f.label + ": " + f.role,
            "data-testid": "input-thumb",
            onMouseenter: (y) => l(p)
          }, null, 46, Bre))), 128))
        ], 4)
      ], 4),
      r.value ? (g(), b("button", {
        key: 0,
        class: G(["pl-stack-more", { "is-end": a.value <= 0 }]),
        title: a.value > 0 ? "Next image" : "Back to the first image",
        "aria-label": a.value > 0 ? "Next image" : "Back to the first image",
        "data-testid": "input-more",
        onClick: Te(d, ["stop"]),
        onKeydown: h[0] || (h[0] = Te(() => {
        }, ["stop"]))
      }, [
        u("span", Nre, E(a.value > 0 ? "+" + a.value : s.value + cb + "/" + n.inputs.length), 1),
        u("span", Ure, [
          C($, {
            name: a.value > 0 ? "ChevronDown" : "ChevronsUp",
            size: 13
          }, null, 8, ["name"])
        ])
      ], 42, Fre)) : z("", !0)
    ], 32));
  }
}), jre = ["data-prompt-id"], Hre = ["src"], Vre = ["src"], Wre = {
  key: 2,
  class: "pl-tile-words"
}, qre = ["src"], Kre = ["title"], Yre = ["aria-label"], Xre = {
  key: 0,
  class: "pl-tile-cap",
  "data-testid": "tile-caption"
}, Jre = { class: "pl-tile-meta" }, Zre = { class: "pl-tile-name" }, Qre = { class: "pl-tile-tool" }, eae = { class: "pl-tile-acts" }, tae = ["title"], nae = /* @__PURE__ */ Pe({
  __name: "PromptTile",
  props: {
    prompt: {},
    toolName: {},
    remixHint: {},
    levels: {}
  },
  emits: ["open", "use", "remix"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(!1), a = /* @__PURE__ */ W(null), l = I(() => t.prompt.output.thumb || (t.prompt.output.url ? Bt(t.prompt.output.url) : ""));
    function d() {
      s.value && i("open", s.value.getBoundingClientRect());
    }
    return (c, h) => (g(), b("article", {
      class: G(["pl-tile", { "is-in": o.value || !l.value, "is-peeking": !!a.value, "is-text": !l.value }]),
      "data-prompt-id": n.prompt.id,
      "data-testid": "prompt-tile",
      onMouseenter: h[5] || (h[5] = (f) => r.value = !0),
      onMouseleave: h[6] || (h[6] = (f) => r.value = !1)
    }, [
      u("span", {
        ref_key: "art",
        ref: s,
        class: "pl-tile-art"
      }, [
        l.value ? (g(), b("img", {
          key: 0,
          class: "pl-tile-img",
          src: l.value,
          alt: "",
          loading: "lazy",
          decoding: "async",
          draggable: "false",
          onLoad: h[0] || (h[0] = (f) => o.value = !0),
          onError: h[1] || (h[1] = (f) => o.value = !0)
        }, null, 40, Hre)) : z("", !0),
        n.prompt.output.video && r.value ? (g(), b("video", {
          key: 1,
          class: "pl-tile-img is-video",
          src: n.prompt.output.video,
          muted: "",
          loop: "",
          autoplay: "",
          playsinline: ""
        }, null, 8, Vre)) : z("", !0),
        l.value ? z("", !0) : (g(), b("span", Wre, E(n.prompt.prompt), 1)),
        C(vt, { name: "pl-peek" }, {
          default: Xe(() => [
            a.value ? (g(), b("img", {
              key: a.value.url,
              class: "pl-tile-img is-peek",
              src: m(Bt)(a.value.url),
              alt: "",
              draggable: "false"
            }, null, 8, qre)) : z("", !0)
          ]),
          _: 1
        })
      ], 512),
      n.levels && n.levels.length ? (g(), b("span", {
        key: 0,
        class: "pl-tile-levels",
        title: n.levels.map((f) => f.label).join(" · "),
        "data-testid": "tile-levels"
      }, [
        (g(!0), b(j, null, ge(n.levels, (f) => (g(), Ie($, {
          key: f.label,
          name: f.icon,
          size: 11
        }, null, 8, ["name"]))), 128))
      ], 8, Kre)) : z("", !0),
      h[8] || (h[8] = u("span", { class: "pl-tile-shade" }, null, -1)),
      u("button", {
        class: "pl-tile-hit",
        "aria-label": "Open " + n.prompt.name,
        "data-testid": "tile-open",
        onClick: d
      }, null, 8, Yre),
      C(vt, { name: "pl-peek" }, {
        default: Xe(() => [
          a.value ? (g(), b("span", Xre, E(a.value.label) + " · " + E(a.value.role), 1)) : z("", !0)
        ]),
        _: 1
      }),
      n.prompt.inputs.length ? (g(), Ie(Gre, {
        key: 1,
        inputs: n.prompt.inputs,
        onPeek: h[2] || (h[2] = (f) => a.value = f)
      }, null, 8, ["inputs"])) : z("", !0),
      u("span", Jre, [
        u("span", Zre, E(n.prompt.name), 1),
        u("span", Qre, E(n.toolName), 1),
        u("span", eae, [
          u("button", {
            class: "pl-btn is-light",
            "data-testid": "tile-use",
            onClick: h[3] || (h[3] = (f) => i("use"))
          }, "Use prompt"),
          u("button", {
            class: "pl-btn is-glass",
            title: n.remixHint,
            "data-testid": "tile-remix",
            onClick: h[4] || (h[4] = (f) => i("remix"))
          }, [
            C($, {
              name: "Repeat",
              size: 12
            }),
            h[7] || (h[7] = Y("Remix ", -1))
          ], 8, tae)
        ])
      ])
    ], 42, jre));
  }
}), iae = ["data-prompt-id"], sae = {
  class: "pl-detail-art",
  "data-testid": "detail-art"
}, oae = {
  key: 0,
  class: "pl-cover-text"
}, rae = ["src", "alt"], aae = {
  class: "pl-detail-cap",
  "data-testid": "detail-caption"
}, lae = {
  key: 2,
  class: "pl-detail-strip"
}, dae = ["onMouseenter"], cae = ["aria-label", "onFocus"], uae = {
  key: 0,
  class: "pl-detail-more"
}, hae = { class: "pl-detail-info" }, pae = { class: "pl-detail-scroll" }, fae = { class: "pl-detail-top" }, mae = { class: "pl-crumb" }, gae = { class: "pl-detail-nav" }, bae = ["disabled"], vae = { class: "pl-detail-count" }, yae = ["disabled"], xae = { class: "pl-detail-name" }, wae = {
  key: 0,
  class: "pl-detail-by",
  "data-testid": "detail-byline"
}, kae = {
  key: 1,
  class: "pl-detail-desc"
}, _ae = { class: "pl-block" }, Sae = { class: "pl-label-row" }, Mae = ["title", "aria-label"], Tae = {
  class: "pl-prompt",
  "data-testid": "detail-prompt"
}, Cae = { class: "pl-block" }, Iae = { class: "pl-pills" }, Aae = { class: "pl-pill" }, Pae = {
  key: 0,
  class: "pl-pill is-quiet"
}, Eae = {
  key: 0,
  class: "pl-note",
  "data-testid": "detail-note"
}, Rae = {
  key: 2,
  class: "pl-block"
}, zae = { class: "pl-pills" }, $ae = {
  key: 3,
  class: "pl-block"
}, Dae = { class: "pl-inputs" }, Oae = ["onMouseenter"], Lae = ["title", "aria-label", "onFocus"], Bae = { class: "pl-input-n" }, Fae = {
  key: 0,
  class: "pl-input-tag"
}, Nae = { class: "pl-detail-foot" }, Uae = { class: "pl-detail-acts" }, Gae = ["title"], jae = {
  key: 0,
  class: "pl-acts-own"
}, Hae = ["title", "aria-label"], Vae = { key: 0 }, Wae = { class: "pl-acts-hint" }, qae = 5, Kae = /* @__PURE__ */ Pe({
  __name: "PromptDetail",
  props: {
    prompt: {},
    index: {},
    total: {},
    more: { type: Boolean },
    toolName: {},
    note: {},
    remixHint: {},
    from: {},
    crumb: {},
    byline: {},
    levels: {},
    canEdit: { type: Boolean }
  },
  emits: ["back", "step", "use", "remix", "edit", "delete"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(!!t.from);
    let l = 0;
    const d = I(() => s.value ? s.value.url : t.prompt.output.url), c = /* @__PURE__ */ W(!1);
    function h() {
      if (!c.value) {
        c.value = !0;
        return;
      }
      c.value = !1, i("delete");
    }
    const f = I(() => s.value ? s.value.label + " · " + s.value.role : "Output"), p = I(() => t.prompt.inputs.slice(0, qae)), y = I(() => t.prompt.inputs.length - p.value.length);
    Ee(() => t.prompt.id, () => {
      s.value = null, o.value = !1, c.value = !1;
    });
    function v() {
      try {
        navigator.clipboard.writeText(t.prompt.prompt).catch(() => {
        });
      } catch {
      }
      o.value = !0, clearTimeout(l), l = window.setTimeout(() => {
        o.value = !1;
      }, 1400);
    }
    async function x() {
      const w = t.from, S = typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!w || S) {
        a.value = !1;
        return;
      }
      await nt();
      const M = r.value;
      if (!M) {
        a.value = !1;
        return;
      }
      M.complete || await new Promise((A) => {
        M.addEventListener("load", () => A(), { once: !0 }), M.addEventListener("error", () => A(), { once: !0 });
      });
      const _ = M.getBoundingClientRect();
      if (!_.width || !_.height || typeof document.body.animate != "function") {
        a.value = !1;
        return;
      }
      const T = document.createElement("img");
      T.src = M.currentSrc || M.src, T.alt = "", Object.assign(T.style, {
        position: "fixed",
        left: w.left + "px",
        top: w.top + "px",
        width: w.width + "px",
        height: w.height + "px",
        objectFit: "cover",
        borderRadius: "14px",
        zIndex: "2147483000",
        pointerEvents: "none",
        margin: "0",
        boxShadow: "0 30px 80px rgba(2, 4, 12, 0.55)"
      }), document.body.appendChild(T);
      const k = T.animate([
        { left: w.left + "px", top: w.top + "px", width: w.width + "px", height: w.height + "px", borderRadius: "14px" },
        { left: _.left + "px", top: _.top + "px", width: _.width + "px", height: _.height + "px", borderRadius: "12px" }
      ], { duration: 460, easing: "cubic-bezier(0.16, 1, 0.3, 1)", fill: "forwards" }), P = () => {
        a.value = !1, requestAnimationFrame(() => T.remove());
      };
      k.onfinish = P, k.oncancel = P;
    }
    return it(x), We(() => clearTimeout(l)), (w, S) => (g(), b("div", {
      class: "pl-detail",
      "data-testid": "prompt-detail",
      "data-prompt-id": n.prompt.id
    }, [
      u("div", sae, [
        d.value ? (g(), Ie(vt, {
          key: 1,
          name: "pl-peek",
          mode: "out-in"
        }, {
          default: Xe(() => [
            (g(), b("img", {
              key: d.value,
              ref_key: "artImg",
              ref: r,
              class: G(["pl-detail-img", { "is-landing": a.value }]),
              src: d.value,
              alt: s.value ? s.value.title || s.value.role : n.prompt.name,
              draggable: "false"
            }, null, 10, rae))
          ]),
          _: 1
        })) : (g(), b("span", oae, E(n.prompt.prompt), 1)),
        u("button", {
          class: "pl-back",
          title: "Back to the prompts",
          "aria-label": "Back to the prompts",
          "data-testid": "detail-back",
          onClick: S[0] || (S[0] = (M) => i("back"))
        }, [
          C($, {
            name: "ArrowLeft",
            size: 15
          })
        ]),
        u("span", aae, E(f.value), 1),
        n.prompt.inputs.length ? (g(), b("div", lae, [
          (g(!0), b(j, null, ge(p.value, (M, _) => (g(), b("span", {
            key: _,
            class: "pl-th-slot",
            onMouseenter: (T) => s.value = M,
            onMouseleave: S[2] || (S[2] = (T) => s.value = null)
          }, [
            u("button", {
              class: G(["pl-detail-th", { on: s.value === M, "is-markup": M.kind === "markup" }]),
              style: ce({ backgroundImage: 'url("' + M.url + '")' }),
              "aria-label": "Show " + M.label + ": " + M.role,
              "data-testid": "detail-thumb",
              onFocus: (T) => s.value = M,
              onBlur: S[1] || (S[1] = (T) => s.value = null)
            }, null, 46, cae)
          ], 40, dae))), 128)),
          y.value > 0 ? (g(), b("span", uae, "+" + E(y.value), 1)) : z("", !0)
        ])) : z("", !0)
      ]),
      u("div", hae, [
        u("div", pae, [
          u("div", fae, [
            u("span", mae, E(n.crumb), 1),
            u("span", gae, [
              u("button", {
                title: "Previous prompt",
                "aria-label": "Previous prompt",
                disabled: n.total < 2 && !n.more,
                onClick: S[3] || (S[3] = (M) => i("step", -1))
              }, [
                C($, {
                  name: "ChevronLeft",
                  size: 14
                })
              ], 8, bae),
              u("span", vae, E(n.index + 1) + " of " + E(n.total) + E(n.more ? "+" : ""), 1),
              u("button", {
                title: "Next prompt",
                "aria-label": "Next prompt",
                disabled: n.total < 2 && !n.more,
                onClick: S[4] || (S[4] = (M) => i("step", 1))
              }, [
                C($, {
                  name: "ChevronRight",
                  size: 14
                })
              ], 8, yae)
            ])
          ]),
          u("h3", xae, E(n.prompt.name), 1),
          n.byline ? (g(), b("p", wae, E(n.byline), 1)) : z("", !0),
          n.prompt.description ? (g(), b("p", kae, E(n.prompt.description), 1)) : z("", !0),
          u("section", _ae, [
            u("div", Sae, [
              S[11] || (S[11] = u("span", { class: "pl-label" }, "Prompt", -1)),
              u("button", {
                class: "pl-icon-btn",
                title: o.value ? "Copied" : "Copy the prompt",
                "aria-label": o.value ? "Copied" : "Copy the prompt",
                onClick: v
              }, [
                C($, {
                  name: o.value ? "Check" : "Copy",
                  size: 13
                }, null, 8, ["name"])
              ], 8, Mae)
            ]),
            u("p", Tae, E(n.prompt.prompt), 1)
          ]),
          u("section", Cae, [
            S[12] || (S[12] = u("span", { class: "pl-label" }, "Tool", -1)),
            u("div", Iae, [
              u("span", Aae, [
                C($, {
                  name: "Sparkles",
                  size: 12
                }),
                Y(E(n.toolName), 1)
              ]),
              n.prompt.mode ? (g(), b("span", Pae, [
                C($, {
                  name: n.prompt.inputs.length ? "Images" : "Type",
                  size: 12
                }, null, 8, ["name"]),
                Y(E(m(HV)(n.prompt.mode)), 1)
              ])) : z("", !0)
            ]),
            n.note ? (g(), b("p", Eae, [
              C($, {
                name: "Info",
                size: 12
              }),
              Y(E(n.note), 1)
            ])) : z("", !0)
          ]),
          n.levels && n.levels.length ? (g(), b("section", Rae, [
            S[13] || (S[13] = u("span", { class: "pl-label" }, "Who can use it", -1)),
            u("div", zae, [
              (g(!0), b(j, null, ge(n.levels, (M) => (g(), b("span", {
                key: M.label,
                class: "pl-pill is-quiet",
                "data-testid": "detail-level"
              }, [
                C($, {
                  name: M.icon,
                  size: 12
                }, null, 8, ["name"]),
                Y(E(M.label), 1)
              ]))), 128))
            ])
          ])) : z("", !0),
          n.prompt.inputs.length ? (g(), b("section", $ae, [
            S[14] || (S[14] = u("span", { class: "pl-label" }, "Input images · hover to preview", -1)),
            u("div", Dae, [
              (g(!0), b(j, null, ge(n.prompt.inputs, (M, _) => (g(), b("span", {
                key: _,
                class: "pl-th-slot",
                onMouseenter: (T) => s.value = M,
                onMouseleave: S[6] || (S[6] = (T) => s.value = null)
              }, [
                u("button", {
                  class: G(["pl-input", { on: s.value === M, "is-markup": M.kind === "markup" }]),
                  style: ce({ backgroundImage: 'url("' + M.url + '")' }),
                  title: [M.label, M.role, M.title].filter(Boolean).join(" · "),
                  "aria-label": "Show " + M.label + ": " + M.role,
                  "data-testid": "detail-input",
                  onFocus: (T) => s.value = M,
                  onBlur: S[5] || (S[5] = (T) => s.value = null)
                }, [
                  u("span", Bae, E(_ + 1), 1),
                  M.kind === "markup" ? (g(), b("span", Fae, "Markup")) : z("", !0)
                ], 46, Lae)
              ], 40, Oae))), 128))
            ])
          ])) : z("", !0)
        ]),
        u("div", Nae, [
          u("div", Uae, [
            u("button", {
              class: "pl-cta",
              "data-testid": "detail-use",
              onClick: S[7] || (S[7] = (M) => i("use"))
            }, "Use prompt"),
            u("button", {
              class: "pl-btn is-glass is-lg",
              title: n.remixHint,
              "data-testid": "detail-remix",
              onClick: S[8] || (S[8] = (M) => i("remix"))
            }, [
              C($, {
                name: "Repeat",
                size: 13
              }),
              S[15] || (S[15] = Y("Remix ", -1))
            ], 8, Gae),
            n.canEdit ? (g(), b("span", jae, [
              u("button", {
                class: "pl-icon-btn is-lg",
                title: "Edit",
                "aria-label": "Edit",
                "data-testid": "detail-edit",
                onClick: S[9] || (S[9] = (M) => i("edit"))
              }, [
                C($, {
                  name: "Pencil",
                  size: 14
                })
              ]),
              u("button", {
                class: G(["pl-icon-btn is-lg is-danger", { "is-confirming": c.value }]),
                title: c.value ? "Click again to delete it for everyone it is shared with" : "Delete",
                "aria-label": c.value ? "Confirm delete" : "Delete",
                "data-testid": "detail-delete",
                onClick: h,
                onBlur: S[10] || (S[10] = (M) => c.value = !1)
              }, [
                C($, {
                  name: c.value ? "Check" : "Trash2",
                  size: 14
                }, null, 8, ["name"]),
                c.value ? (g(), b("span", Vae, "Delete?")) : z("", !0)
              ], 42, Hae)
            ])) : z("", !0)
          ]),
          u("p", Wae, E(n.remixHint), 1)
        ])
      ])
    ], 8, iae));
  }
}), Yae = {
  class: "pl-tabs pl-side-tabs",
  role: "tablist",
  "aria-label": "Prompts"
}, Xae = ["aria-selected"], Jae = {
  key: 0,
  class: "n"
}, Zae = ["aria-selected"], Qae = {
  key: 0,
  class: "n"
}, ele = { class: "pl-side-scroll" }, tle = {
  class: "pl-tree",
  "aria-label": "Kinds and categories",
  "data-testid": "library-tree"
}, nle = ["aria-current"], ile = { class: "n" }, sle = ["aria-current", "aria-label", "data-testid", "onClick"], ole = { class: "lbl" }, rle = { class: "n" }, ale = ["aria-current", "aria-label", "title", "data-testid", "onClick"], lle = { class: "lbl" }, dle = { class: "n" }, cle = {
  key: 0,
  class: "pl-leaves",
  "data-testid": "library-categories"
}, ule = ["aria-current", "title", "data-testid", "onClick"], hle = { class: "lbl" }, ple = { class: "n" }, fle = {
  key: 0,
  class: "pl-side-sec",
  "aria-label": "Shared with"
}, mle = ["aria-pressed", "data-testid", "onClick"], gle = { class: "pl-tick" }, ble = { class: "lbl" }, vle = { class: "n" }, yle = { class: "pl-content" }, xle = { class: "pl-head" }, wle = ["aria-expanded"], kle = { class: "pl-search" }, _le = ["placeholder"], Sle = {
  key: 1,
  class: "pl-kbd"
}, Mle = {
  key: 0,
  class: "pl-scope",
  "data-testid": "library-scope"
}, Tle = {
  key: 0,
  class: "pl-scope-crumb"
}, Cle = { class: "pl-scope-title" }, Ile = ["title"], Ale = {
  key: 1,
  class: "pl-scope-n"
}, Ple = { class: "pl-main" }, Ele = {
  key: 0,
  class: "pl-grid",
  "aria-busy": "true"
}, Rle = {
  key: 1,
  class: "pl-empty",
  "data-testid": "library-failed"
}, zle = {
  key: 2,
  class: "pl-empty",
  "data-testid": "library-unpublished"
}, $le = { key: 0 }, Dle = {
  key: 3,
  class: "pl-empty is-roomy",
  "data-testid": "library-mine-off"
}, Ole = { class: "pl-empty-mark" }, Lle = {
  key: 4,
  class: "pl-empty is-roomy",
  "data-testid": "library-mine-empty"
}, Ble = { class: "pl-empty-mark" }, Fle = {
  key: 5,
  class: "pl-empty is-roomy",
  "data-testid": "library-video-none"
}, Nle = { class: "pl-empty-mark" }, Ule = { class: "pl-empty-acts" }, Gle = {
  key: 6,
  class: "pl-empty",
  "data-testid": "library-no-match"
}, jle = { class: "pl-empty-acts" }, Hle = {
  key: 0,
  class: "pl-edit",
  "data-testid": "library-edit"
}, Vle = { class: "pl-detail-art" }, Wle = ["src"], qle = {
  key: 1,
  class: "pl-cover-text"
}, Kle = { class: "pl-edit-form" }, Yle = 250, Xle = 600, Qy = /* @__PURE__ */ Pe({
  __name: "PromptLibrary",
  props: {
    floating: { type: Boolean }
  },
  setup(n) {
    const { board: e } = Ze(), t = e.promptLibrary, i = e.ui.library, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(!1), c = I(() => (e.docRev.value, t.session(i.sessionId))), h = I(() => c.value ? Ja(c.value.kitId) : null), f = I(() => i.tab === "featured"), p = I(() => t.featured.value), y = I(() => f.value ? t.state.value : t.mineState.value), v = I(() => t.mine.value), x = I(() => t.myPrompts.counts.value), w = I(() => x.value ? x.value.total : v.value.length), S = I(() => e.labels.team), M = I(() => [
      { id: "me", icon: "Lock", label: "Only me" },
      { id: "board", icon: "LayoutGrid", label: "This board" },
      ...t.team.value ? [{ id: "team", icon: "Users", label: _v(S.value) }] : [],
      // the company's, where the board's team has one (IL-101)
      ...t.company() || _("company") ? [{ id: "company", icon: "Building2", label: "Company" }] : []
    ]);
    function _(ve) {
      return x.value ? x.value.levels[ve] : v.value.filter((_e) => cf(_e, e.meta.id).includes(ve)).length;
    }
    function T(ve) {
      i.levels = i.levels.includes(ve) ? i.levels.filter((_e) => _e !== ve) : i.levels.concat([ve]), i.detail = null;
    }
    const k = I(() => f.value ? p.value ? UV(p.value.prompts, { category: i.category, query: i.query, kind: h.value, only: i.kind, action: i.action }) : [] : v.value), P = { image: "Image", video: "Video" }, A = { image: "Image", video: "Video" }, R = { generate: "Generate", edit: "Edit" }, D = { generate: "Sparkles", edit: "Wand2" }, O = {
      image: { generate: "From words alone", edit: "From your image" },
      video: { generate: "From words alone", edit: "From your image or clip" }
    }, F = {
      image: "Generate an image from words, or edit one of yours",
      video: "Generate a clip from words, or bring your image to life",
      "image-generate": "Start from words: a new concept, no image needed",
      "image-edit": "Start from your own image: change it, restyle it or add to it",
      "video-generate": "Start from words: a new clip, no image needed",
      "video-edit": "Start from your image or clip: move the camera, add life or transform it"
    }, ie = I(() => {
      if (f.value) {
        const _e = p.value;
        return _e ? Ju(ik(_e.prompts), _e.categories.map((De) => De.label)) : Ju([]);
      }
      const ve = x.value;
      return ve && ve.groups && ve.actions ? Ju(ve.groups, [], ve.actions) : Ju(ik(v.value));
    }), ee = I(() => {
      const ve = /* @__PURE__ */ new Map();
      if (f.value && p.value) for (const _e of p.value.categories) ve.set(_e.label, { id: _e.id, description: _e.description });
      return ve;
    });
    function me(ve) {
      const _e = ee.value.get(ve);
      return _e ? _e.id : ve;
    }
    const L = I(() => {
      const ve = ie.value.kinds.find((De) => De.kind === i.kind), _e = ve && ve.actions.find((De) => De.action === i.action);
      return _e ? _e.categories : [];
    }), N = I(() => {
      if (!i.kind)
        return { crumb: "", title: "All prompts", hint: f.value ? "Curated by RunDiffusion: each with its tool and the images it was given" : "Prompts you saved, and prompts shared with you here" };
      const ve = P[i.kind];
      if (!i.action) return { crumb: "", title: ve + " prompts", hint: F[i.kind] };
      const _e = F[i.kind + "-" + i.action];
      if (!i.category) return { crumb: ve, title: R[i.action], hint: _e };
      const De = ee.value.get(i.category);
      return { crumb: ve + " · " + R[i.action], title: i.category, hint: De && De.description ? De.description : _e };
    }), K = I(() => {
      if (!i.query.trim() || y.value !== "ready") return "";
      const ve = k.value.length, _e = !f.value && t.myPrompts.hasMore.value;
      return ve + (_e ? "+" : "") + (ve === 1 && !_e ? " match" : " matches");
    }), B = I(() => ({ image: ie.value.kinds[0].count, video: ie.value.kinds[1].count })), re = I(() => {
      const ve = i.category || (i.kind ? P[i.kind] + (i.action ? " · " + R[i.action] : "") : ""), _e = i.query.trim();
      return _e ? "Nothing " + (ve ? "in " + ve + " " : "") + "matches “" + _e + "”" : ve ? "No prompts in " + ve : "No prompts here";
    }), H = I(() => f.value ? t.prompt(i.detail) : t.myPrompt(i.detail)), J = I(() => H.value ? k.value.findIndex((ve) => ve.id === H.value.id) : -1), Q = I(() => p.value ? p.value.prompts.length : 0), ne = I(() => {
      const ve = k.value.length;
      if (f.value) return { n: ve, more: !1 };
      const _e = x.value;
      return _e && !i.query.trim() && !i.category && !i.levels.length && !i.kind ? { n: Math.max(_e.total, ve), more: !1 } : { n: ve, more: t.myPrompts.hasMore.value };
    });
    Ee(f, (ve) => t.myPrompts.setShown(!ve), { immediate: !0 });
    let ue = null;
    Ee(() => [i.tab, i.levels.join(","), i.category, i.kind, i.action, h.value], () => {
      f.value || t.startMine();
    }), Ee(() => i.query, () => {
      ue && clearTimeout(ue), ue = setTimeout(() => {
        ue = null, f.value || t.startMine();
      }, Yle);
    });
    function Z() {
      const ve = s.value;
      f.value || !ve || !t.myPrompts.hasMore.value || ve.scrollTop + ve.clientHeight >= ve.scrollHeight - Xle && t.myPrompts.loadMore();
    }
    function te() {
      X(), Z();
    }
    Ee(() => v.value.length, () => nt(Z)), Ee(L, (ve) => {
      (f.value ? !p.value : !x.value) || i.category && !ve.some((_e) => _e.label === i.category) && t.setCategory(null);
    });
    function we(ve) {
      const _e = Xa(e.catalog.value, ve.tool);
      return _e ? _e.name : ve.tool.name;
    }
    function Fe(ve) {
      if (ve === "company") return { icon: "Building2", label: "Company" };
      if (ve === "team") return { icon: "Users", label: _v(S.value) };
      const _e = M.value.find((De) => De.id === ve);
      return { icon: _e.icon, label: _e.label };
    }
    function Me(ve) {
      if (!Or(ve)) return;
      const _e = cf(ve, e.meta.id).map(Fe);
      return sS(ve, e.meta.id) ? [{ icon: "LayoutGrid", label: "Another board" }].concat(_e) : _e;
    }
    function he(ve) {
      return c.value ? t.remixFills(ve, i.sessionId) ? "Remix sets this session up with the prompt, its tool and its images." : "Remix starts a new session beside this one, with the prompt, its tool and its images." : "Remix starts a new session with this prompt, its tool and its images.";
    }
    function U(ve) {
      const _e = P[ve.kind] + " " + R[ua(ve)].toLowerCase();
      return (Or(ve) ? "My prompts" : "Featured") + " · " + _e + (ve.category ? " · " + ve.category : "");
    }
    function q(ve) {
      return Or(ve) ? "Saved by " + (ve.authorId === e.user.uid ? "you" : ve.authorName || "someone") + (ve.updatedAt ? " · " + R1(ve.updatedAt) : "") : "";
    }
    const oe = I(() => (e.promptRev.value, e.results.rev.value, t.canSave ? t.draftForSession(i.sessionId) : null)), de = I(() => {
      if (!i.editing) return null;
      if (i.editing === "new") return oe.value;
      const ve = t.myPrompt(i.editing);
      return ve ? t.draftFor(ve) : null;
    }), pe = I(() => de.value ? de.value.output.thumb || de.value.output.url : "");
    function Ce() {
      i.detail = null, i.editing = "new";
    }
    function Be(ve) {
      i.editing = null, i.detail = ve;
    }
    function be(ve) {
      X(), t.setTab(ve), nt(le);
    }
    function se(ve, _e = null, De = null) {
      X(), t.setBranch(ve, _e, De), d.value = !1, nt(le);
    }
    function ae(ve, _e) {
      l.value = _e, i.detail = ve.id;
    }
    function ye(ve) {
      const _e = k.value;
      if (!_e.length) return;
      if (!f.value && ve > 0 && J.value === _e.length - 1 && t.myPrompts.hasMore.value) {
        const Qe = _e.length;
        t.myPrompts.loadMore().then(() => {
          const ft = k.value[Qe];
          ft && i.detail === _e[Qe - 1].id && (l.value = null, i.detail = ft.id);
        });
        return;
      }
      const De = J.value < 0 ? 0 : (J.value + ve + _e.length) % _e.length;
      l.value = null, i.detail = _e[De].id;
    }
    function Oe() {
      const ve = i.detail;
      i.detail = null, nt(() => {
        const _e = o.value && ve ? o.value.querySelector('[data-prompt-id="' + ve + '"] .pl-tile-hit') : null;
        _e && _e.focus({ preventScroll: !0 });
      });
    }
    function Ve() {
      i.query = "", r.value && r.value.focus();
    }
    function Ue(ve) {
      Or(ve) && t.remove(ve);
    }
    function tt(ve) {
      Or(ve) && (i.editing = ve.id);
    }
    Ee(() => i.query, () => {
      i.detail = null, s.value && (s.value.scrollTop = 0);
    });
    function Ye(ve) {
      ve.key === "Escape" ? (ve.preventDefault(), ve.stopPropagation(), i.query ? i.query = "" : r.value && r.value.blur()) : ve.key === "ArrowDown" && (ve.preventDefault(), kt(0));
    }
    function at() {
      return o.value ? Array.from(o.value.querySelectorAll(".pl-tile-hit")) : [];
    }
    function kt(ve) {
      const _e = at();
      if (!_e.length) return;
      const De = _e[Math.max(0, Math.min(_e.length - 1, ve))];
      De.focus(), De.scrollIntoView({ block: "nearest" });
    }
    function $e() {
      const ve = o.value;
      return ve ? Math.max(1, getComputedStyle(ve).gridTemplateColumns.split(" ").filter(Boolean).length) : 1;
    }
    function Ne(ve) {
      if (ve.key !== "ArrowDown" && ve.key !== "ArrowUp") return;
      const _e = a.value ? Array.from(a.value.querySelectorAll(".pl-node")) : [], De = _e.indexOf(document.activeElement);
      De < 0 || (ve.preventDefault(), ve.stopPropagation(), _e[Math.max(0, Math.min(_e.length - 1, De + (ve.key === "ArrowDown" ? 1 : -1)))].focus());
    }
    function V(ve) {
      if (!i.open || i.editing || ve.metaKey || ve.ctrlKey || ve.altKey) return;
      const _e = ve.target;
      if (_e && (_e.tagName === "INPUT" || _e.tagName === "TEXTAREA" || _e.isContentEditable) || _e && _e.closest && _e.closest(".pl-side") && ve.key !== "/") return;
      if (ve.key === "/") {
        ve.preventDefault(), r.value && r.value.focus();
        return;
      }
      if (H.value) {
        (ve.key === "ArrowRight" || ve.key === "ArrowLeft") && (ve.preventDefault(), ye(ve.key === "ArrowRight" ? 1 : -1));
        return;
      }
      const De = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: $e(), ArrowUp: -$e() };
      if (!(ve.key in De)) return;
      ve.preventDefault();
      const ft = at().indexOf(document.activeElement);
      kt(ft < 0 ? 0 : ft + De[ve.key]);
    }
    function X() {
      s.value && (t.scroll[t.scrollKey()] = s.value.scrollTop);
    }
    function le() {
      s.value && (s.value.scrollTop = t.scroll[t.scrollKey()] || 0);
    }
    Ee(y, (ve) => {
      ve === "ready" && nt(le);
    }), it(() => {
      window.addEventListener("keydown", V), nt(le), jB();
    }), We(() => {
      window.removeEventListener("keydown", V), X(), ue && clearTimeout(ue), t.myPrompts.setShown(!1);
    });
    function Le(ve) {
      return Or(ve) && t.canEdit(ve);
    }
    return (ve, _e) => (g(), b("div", {
      class: G(["pl-wrap", { "is-floating": n.floating }]),
      "data-testid": "prompt-library",
      onPointerdown: _e[20] || (_e[20] = Te(() => {
      }, ["stop"]))
    }, [
      u("button", {
        class: "pl-close",
        title: "Close",
        "aria-label": "Close the prompt library",
        "data-testid": "library-close",
        onClick: _e[0] || (_e[0] = (De) => m(t).close())
      }, [
        C($, {
          name: "X",
          size: 15
        })
      ]),
      u("section", {
        class: G(["pl-panel", { "is-side-open": d.value }]),
        role: "dialog",
        "aria-label": "Prompt library"
      }, [
        u("aside", {
          ref_key: "sideEl",
          ref: a,
          class: "pl-side",
          "aria-label": "Browse prompts",
          "data-testid": "library-side",
          onKeydown: Ne
        }, [
          u("div", Yae, [
            u("button", {
              role: "tab",
              "aria-selected": m(i).tab === "featured",
              class: G({ on: m(i).tab === "featured" }),
              "data-testid": "tab-featured",
              onClick: _e[1] || (_e[1] = (De) => be("featured"))
            }, [
              _e[21] || (_e[21] = Y(" Featured", -1)),
              Q.value ? (g(), b("span", Jae, E(Q.value), 1)) : z("", !0)
            ], 10, Xae),
            u("button", {
              role: "tab",
              "aria-selected": m(i).tab === "mine",
              class: G({ on: m(i).tab === "mine" }),
              "data-testid": "tab-mine",
              onClick: _e[2] || (_e[2] = (De) => be("mine"))
            }, [
              _e[22] || (_e[22] = Y(" My prompts", -1)),
              w.value ? (g(), b("span", Qae, E(w.value), 1)) : z("", !0)
            ], 10, Zae)
          ]),
          u("div", ele, [
            u("nav", tle, [
              u("button", {
                class: G(["pl-node is-root", { on: !m(i).kind }]),
                "aria-current": m(i).kind ? void 0 : "true",
                "data-testid": "kind-all",
                onClick: _e[3] || (_e[3] = (De) => se(null))
              }, [
                C($, {
                  name: "LayoutGrid",
                  size: 14
                }),
                _e[23] || (_e[23] = u("span", { class: "lbl" }, "All prompts", -1)),
                u("span", ile, E(ie.value.total), 1)
              ], 10, nle),
              (g(!0), b(j, null, ge(ie.value.kinds, (De) => (g(), b("div", {
                key: De.kind,
                class: G(["pl-branch", { "is-in": m(i).kind === De.kind }])
              }, [
                u("button", {
                  class: G(["pl-node is-kind", { on: m(i).kind === De.kind && !m(i).action, "is-empty": !De.count }]),
                  "aria-current": m(i).kind === De.kind && !m(i).action ? "true" : void 0,
                  "aria-label": P[De.kind] + " prompts, " + De.count,
                  "data-testid": "kind-" + De.kind,
                  onClick: (Qe) => se(De.kind)
                }, [
                  C($, {
                    name: A[De.kind],
                    size: 14
                  }, null, 8, ["name"]),
                  u("span", ole, E(P[De.kind]), 1),
                  u("span", rle, E(De.count), 1)
                ], 10, sle),
                (g(!0), b(j, null, ge(De.actions, (Qe) => (g(), b(j, {
                  key: Qe.action
                }, [
                  u("button", {
                    class: G(["pl-node is-action", { on: m(i).kind === De.kind && m(i).action === Qe.action && !m(i).category, "is-in": m(i).kind === De.kind && m(i).action === Qe.action, "is-empty": !Qe.count }]),
                    "aria-current": m(i).kind === De.kind && m(i).action === Qe.action && !m(i).category ? "true" : void 0,
                    "aria-label": R[Qe.action] + " " + (De.kind === "image" ? "images" : "videos") + ", " + O[De.kind][Qe.action].toLowerCase() + ", " + Qe.count,
                    title: F[De.kind + "-" + Qe.action],
                    "data-testid": "action-" + De.kind + "-" + Qe.action,
                    onClick: (ft) => se(De.kind, Qe.action)
                  }, [
                    C($, {
                      name: D[Qe.action],
                      size: 13
                    }, null, 8, ["name"]),
                    u("span", lle, [
                      Y(E(R[Qe.action]), 1),
                      u("em", null, E(O[De.kind][Qe.action]), 1)
                    ]),
                    u("span", dle, E(Qe.count), 1)
                  ], 10, ale),
                  m(i).kind === De.kind && m(i).action === Qe.action && Qe.categories.length ? (g(), b("div", cle, [
                    (g(!0), b(j, null, ge(Qe.categories, (ft) => {
                      var Dn;
                      return g(), b("button", {
                        key: ft.label,
                        class: G(["pl-node is-cat", { on: m(i).category === ft.label }]),
                        "aria-current": m(i).category === ft.label ? "true" : void 0,
                        title: ((Dn = ee.value.get(ft.label)) == null ? void 0 : Dn.description) || void 0,
                        "data-testid": "category-" + me(ft.label),
                        onClick: (Zn) => se(De.kind, Qe.action, ft.label)
                      }, [
                        u("span", hle, E(ft.label), 1),
                        u("span", ple, E(ft.count), 1)
                      ], 10, ule);
                    }), 128))
                  ])) : z("", !0)
                ], 64))), 128))
              ], 2))), 128))
            ]),
            f.value ? z("", !0) : (g(), b("section", fle, [
              _e[24] || (_e[24] = u("span", { class: "pl-side-label" }, "Shared with", -1)),
              (g(!0), b(j, null, ge(M.value, (De) => (g(), b("button", {
                key: De.id,
                class: G(["pl-node is-level", { on: m(i).levels.includes(De.id) }]),
                "aria-pressed": m(i).levels.includes(De.id),
                "data-testid": "level-filter-" + De.id,
                onClick: (Qe) => T(De.id)
              }, [
                u("span", gle, [
                  C($, {
                    name: "Check",
                    size: 10,
                    stroke: 3
                  })
                ]),
                C($, {
                  name: De.icon,
                  size: 13
                }, null, 8, ["name"]),
                u("span", ble, E(De.label), 1),
                u("span", vle, E(_(De.id)), 1)
              ], 10, mle))), 128))
            ]))
          ])
        ], 544),
        d.value ? (g(), b("div", {
          key: 0,
          class: "pl-side-scrim",
          onClick: _e[4] || (_e[4] = (De) => d.value = !1)
        })) : z("", !0),
        u("div", yle, [
          u("header", xle, [
            u("button", {
              class: "pl-icon-btn pl-side-toggle",
              "aria-expanded": d.value,
              title: "Browse by kind and category",
              "aria-label": "Browse by kind and category",
              "data-testid": "library-side-toggle",
              onClick: _e[5] || (_e[5] = (De) => d.value = !d.value)
            }, [
              C($, {
                name: "PanelLeft",
                size: 16
              })
            ], 8, wle),
            u("label", kle, [
              C($, {
                name: "Search",
                size: 14
              }),
              _t(u("input", {
                ref_key: "searchEl",
                ref: r,
                "onUpdate:modelValue": _e[6] || (_e[6] = (De) => m(i).query = De),
                placeholder: f.value ? "Search featured prompts" : "Search your prompts",
                spellcheck: "false",
                "data-testid": "library-search",
                onKeydown: Ye
              }, null, 40, _le), [
                [Zt, m(i).query]
              ]),
              m(i).query ? (g(), b("button", {
                key: 0,
                class: "pl-clear",
                title: "Clear the search",
                "aria-label": "Clear the search",
                onClick: Ve
              }, [
                C($, {
                  name: "X",
                  size: 12
                })
              ])) : (g(), b("kbd", Sle, "/"))
            ]),
            !f.value && oe.value && !m(i).editing ? (g(), b("button", {
              key: 0,
              class: "pl-btn is-glass is-lg pl-head-act",
              title: "Save this session's prompt, tool and settings",
              "data-testid": "save-current",
              onClick: Ce
            }, [
              C($, {
                name: "Plus",
                size: 13
              }),
              _e[25] || (_e[25] = Y("Save current prompt ", -1))
            ])) : z("", !0)
          ]),
          !H.value && !m(i).editing ? (g(), b("div", Mle, [
            N.value.crumb ? (g(), b("span", Tle, [
              Y(E(N.value.crumb), 1),
              C($, {
                name: "ChevronRight",
                size: 12
              })
            ])) : z("", !0),
            u("b", Cle, E(N.value.title), 1),
            u("span", {
              class: "pl-scope-hint",
              title: N.value.hint
            }, E(N.value.hint), 9, Ile),
            K.value ? (g(), b("span", Ale, E(K.value), 1)) : z("", !0)
          ])) : z("", !0),
          u("div", Ple, [
            u("div", {
              ref_key: "bodyEl",
              ref: s,
              class: G(["pl-body", { "is-covered": !!H.value || !!m(i).editing }]),
              onScrollPassive: te
            }, [
              y.value === "idle" || y.value === "loading" ? (g(), b("div", Ele, [
                (g(), b(j, null, ge(6, (De) => u("span", {
                  key: De,
                  class: "pl-tile is-skeleton"
                })), 64))
              ])) : y.value === "failed" ? (g(), b("div", Rle, [
                C($, {
                  name: "CloudOff",
                  size: 22
                }),
                u("b", null, E(f.value ? "The Featured prompts couldn't be loaded" : "Your prompts couldn't be loaded"), 1),
                _e[26] || (_e[26] = u("span", null, "Check your connection, then try again.", -1)),
                f.value ? (g(), b("button", {
                  key: 0,
                  class: "pl-btn is-glass is-lg",
                  onClick: _e[7] || (_e[7] = (De) => m(t).load())
                }, "Try again")) : (g(), b("button", {
                  key: 1,
                  class: "pl-btn is-glass is-lg",
                  "data-testid": "library-mine-retry",
                  onClick: _e[8] || (_e[8] = (De) => m(t).startMine())
                }, "Try again"))
              ])) : f.value && !Q.value ? (g(), b("div", zle, [
                C($, {
                  name: "LayoutTemplate",
                  size: 22
                }),
                _e[27] || (_e[27] = u("b", null, "Featured prompts are in development", -1)),
                m(e).user.isAdmin ? (g(), b("span", $le, "No Featured set is published here yet.")) : z("", !0)
              ])) : !f.value && !m(t).canSave ? (g(), b("div", Dle, [
                u("span", Ole, [
                  C($, {
                    name: "Bookmark",
                    size: 20
                  })
                ]),
                _e[28] || (_e[28] = u("b", null, "Your own prompts", -1)),
                _e[29] || (_e[29] = u("span", null, "Saving prompts isn't available here.", -1))
              ])) : !f.value && !w.value && !v.value.length ? (g(), b("div", Lle, [
                u("span", Ble, [
                  C($, {
                    name: "Bookmark",
                    size: 20
                  })
                ]),
                _e[31] || (_e[31] = u("b", null, "Nothing saved yet", -1)),
                u("span", null, "Save the prompt behind a result you like: select it on the canvas, open its record or hover it in a session's gallery, and choose Save prompt. Keep it for yourself, or share it with this board or your " + E(S.value) + ".", 1),
                oe.value ? (g(), b("button", {
                  key: 0,
                  class: "pl-btn is-glass is-lg",
                  onClick: Ce
                }, [
                  C($, {
                    name: "Plus",
                    size: 13
                  }),
                  _e[30] || (_e[30] = Y("Save current prompt", -1))
                ])) : z("", !0)
              ])) : f.value && m(i).kind === "video" && B.value && !B.value.video ? (g(), b("div", Fle, [
                u("span", Nle, [
                  C($, {
                    name: "Video",
                    size: 20
                  })
                ]),
                _e[32] || (_e[32] = u("b", null, "Featured video prompts are in development", -1)),
                _e[33] || (_e[33] = u("span", null, "Prompts you save from a video session are under My prompts.", -1)),
                u("span", Ule, [
                  u("button", {
                    class: "pl-btn is-glass",
                    onClick: _e[9] || (_e[9] = (De) => be("mine"))
                  }, "My prompts"),
                  u("button", {
                    class: "pl-btn is-glass",
                    onClick: _e[10] || (_e[10] = (De) => se(null))
                  }, "All prompts")
                ])
              ])) : k.value.length ? (g(), b("div", {
                key: 7,
                ref_key: "gridEl",
                ref: o,
                class: "pl-grid",
                "data-testid": "library-grid"
              }, [
                (g(!0), b(j, null, ge(k.value, (De) => (g(), Ie(nae, {
                  key: De.id,
                  prompt: De,
                  "tool-name": we(De),
                  "remix-hint": he(De),
                  levels: Me(De),
                  onOpen: (Qe) => ae(De, Qe),
                  onUse: (Qe) => m(t).use(De, m(i).sessionId),
                  onRemix: (Qe) => m(t).remix(De, m(i).sessionId)
                }, null, 8, ["prompt", "tool-name", "remix-hint", "levels", "onOpen", "onUse", "onRemix"]))), 128))
              ], 512)) : (g(), b("div", Gle, [
                C($, {
                  name: "Search",
                  size: 22
                }),
                u("b", null, E(re.value), 1),
                u("span", jle, [
                  m(i).category ? (g(), b("button", {
                    key: 0,
                    class: "pl-btn is-glass",
                    onClick: _e[11] || (_e[11] = (De) => se(m(i).kind, m(i).action))
                  }, "Every category")) : z("", !0),
                  m(i).kind ? (g(), b("button", {
                    key: 1,
                    class: "pl-btn is-glass",
                    onClick: _e[12] || (_e[12] = (De) => se(null))
                  }, "All prompts")) : z("", !0),
                  m(i).levels.length ? (g(), b("button", {
                    key: 2,
                    class: "pl-btn is-glass",
                    onClick: _e[13] || (_e[13] = (De) => m(i).levels = [])
                  }, "Every level")) : z("", !0),
                  m(i).query ? (g(), b("button", {
                    key: 3,
                    class: "pl-btn is-glass",
                    onClick: Ve
                  }, "Clear the search")) : z("", !0)
                ])
              ]))
            ], 34),
            C(vt, { name: "pl-detail" }, {
              default: Xe(() => [
                H.value && !m(i).editing ? (g(), Ie(Kae, {
                  key: 0,
                  prompt: H.value,
                  index: J.value < 0 ? 0 : J.value,
                  total: ne.value.n,
                  more: ne.value.more,
                  "tool-name": we(H.value),
                  note: m(t).toolNote(H.value, m(i).sessionId),
                  "remix-hint": he(H.value),
                  from: l.value,
                  crumb: U(H.value),
                  byline: q(H.value),
                  levels: Me(H.value),
                  "can-edit": Le(H.value),
                  onBack: Oe,
                  onStep: ye,
                  onUse: _e[14] || (_e[14] = (De) => m(t).use(H.value, m(i).sessionId)),
                  onRemix: _e[15] || (_e[15] = (De) => m(t).remix(H.value, m(i).sessionId)),
                  onEdit: _e[16] || (_e[16] = (De) => tt(H.value)),
                  onDelete: _e[17] || (_e[17] = (De) => Ue(H.value))
                }, null, 8, ["prompt", "index", "total", "more", "tool-name", "note", "remix-hint", "from", "crumb", "byline", "levels", "can-edit"])) : z("", !0)
              ]),
              _: 1
            }),
            C(vt, { name: "pl-detail" }, {
              default: Xe(() => [
                m(i).editing && de.value ? (g(), b("div", Hle, [
                  u("div", Vle, [
                    pe.value ? (g(), b("img", {
                      key: 0,
                      class: "pl-detail-img",
                      src: pe.value,
                      alt: "",
                      draggable: "false"
                    }, null, 8, Wle)) : (g(), b("span", qle, E(de.value.prompt), 1)),
                    u("button", {
                      class: "pl-back",
                      title: "Back",
                      "aria-label": "Back",
                      onClick: _e[18] || (_e[18] = (De) => m(i).editing = null)
                    }, [
                      C($, {
                        name: "ArrowLeft",
                        size: 15
                      })
                    ])
                  ]),
                  u("div", Kle, [
                    (g(), Ie(lS, {
                      key: m(i).editing,
                      draft: de.value,
                      "editing-id": m(i).editing === "new" ? null : m(i).editing,
                      onDone: Be,
                      onCancel: _e[19] || (_e[19] = (De) => m(i).editing = null)
                    }, null, 8, ["draft", "editing-id"]))
                  ])
                ])) : z("", !0)
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ], 34));
  }
}), Jle = { class: "up-pop-label" }, Zle = ["aria-label"], Qle = ["aria-selected", "data-testid", "onClick"], ede = {
  key: 0,
  class: "up-refgrid",
  "data-testid": "ref-pinned"
}, tde = ["title", "onClick"], nde = {
  key: 0,
  class: "up-refgrid"
}, ide = ["title", "onClick"], sde = {
  key: 1,
  class: "up-adv-hint up-refpick-note"
}, ode = {
  key: 0,
  class: "up-refgrid",
  "data-testid": "ref-library"
}, rde = ["title", "onClick"], ade = {
  key: 1,
  class: "up-adv-hint up-refpick-note"
}, lde = {
  key: 2,
  class: "up-adv-hint up-refpick-note"
}, dde = {
  key: 3,
  class: "up-adv-hint up-refpick-note"
}, cde = { class: "up-pop-main" }, ude = ["disabled"], hde = { class: "up-pop-main" }, pde = ["accept"], fde = {
  key: 6,
  class: "up-refpick-tip",
  "data-testid": "ref-tip"
}, mde = {
  key: 7,
  class: "up-refpick-tip",
  "data-testid": "ref-shift-tip"
}, Zc = /* @__PURE__ */ Pe({
  __name: "RefPicker",
  props: {
    sessionId: {},
    label: {},
    kind: { default: "image" },
    dropperLabel: { default: "Pick from the board" },
    tip: { default: "" },
    dropper: { type: Boolean, default: !0 }
  },
  emits: ["pick", "dropper", "close"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = Ze(), o = /* @__PURE__ */ W(null), r = rm().shift, a = /* @__PURE__ */ W(!1), l = I(() => t.kind === "video"), d = [
      { id: "pinned", label: "Pinned" },
      { id: "board", label: "This board" },
      ...s.hasLibrary ? [
        { id: "generations", label: "Generations" },
        { id: "uploads", label: "Uploads" },
        { id: "favorites", label: "Favorites" }
      ] : []
    ], c = I(() => s.pinnedImages.value.filter((R) => !!R.video === l.value)), h = /* @__PURE__ */ W(c.value.length ? "pinned" : "board");
    function f(R) {
      R.asset && s.rememberAsset(R.url, R.asset), i("pick", R.url);
    }
    const p = I(() => {
      s.docRev.value, s.results.rev.value;
      const R = /* @__PURE__ */ new Set(), D = [];
      for (const F of s.results.list(t.sessionId))
        F.status !== "done" || !F.url || !!F.video !== l.value || R.has(F.url) || (R.add(F.url), D.push({ url: F.url, label: F.label || "result" }));
      const O = s.imagesInOrder().slice().reverse();
      for (const F of O)
        if (!(!!F.video !== l.value || R.has(F.src)) && (R.add(F.src), D.push({ url: F.src, label: F.label || "image" }), D.length >= 60))
          break;
      return D;
    }), y = /* @__PURE__ */ Xt({
      generations: { items: [], next: null, loading: !1, loaded: !1, failed: !1 },
      uploads: { items: [], next: null, loading: !1, loaded: !1, failed: !1 },
      favorites: { items: [], next: null, loading: !1, loaded: !1, failed: !1 }
    });
    async function v(R, D = !1) {
      const O = y[R];
      if (!O.loading) {
        O.loading = !0, O.failed = !1;
        try {
          const F = await s.libraryPage(R, { cursor: D ? O.next : null });
          O.items = D ? O.items.concat(F.items) : F.items, O.next = F.next, O.loaded = !0;
        } catch (F) {
          console.warn("[board] library unavailable", F), O.failed = !0;
        } finally {
          O.loading = !1;
        }
      }
    }
    const x = (R) => R !== "board" && R !== "pinned";
    Ee(h, (R) => {
      x(R) && !y[R].loaded && v(R);
    });
    function w() {
      const R = h.value;
      x(R) && v(R, !0);
    }
    const S = I(() => {
      const R = h.value;
      return x(R) ? y[R] : null;
    }), M = I(() => S.value ? S.value.items.filter((R) => R.video === l.value && !R.moderated) : []), _ = I(() => {
      const R = l.value ? "videos" : "images";
      return h.value === "generations" ? "No generated " + R + " yet." : h.value === "uploads" ? "No uploaded " + R + " yet." : "Star a result to keep it here.";
    });
    function T(R) {
      s.rememberAsset(R.url, R.asset), i("pick", R.url);
    }
    function k() {
      s.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: [t.kind],
        onPick: (R) => {
          R[0] && T(R[0]);
        }
      });
    }
    const P = I(() => !!s.uploader && (!l.value || s.canUploadVideo));
    async function A(R) {
      const D = R.target.files;
      if (!(!D || !D.length || !s.uploader)) {
        a.value = !0;
        try {
          const { url: O } = l.value ? await s.uploadVideoFile(D[0]) : await s.uploadFile(D[0]);
          i("pick", O);
        } catch (O) {
          const F = O ? O.userMessage : void 0;
          s.toast(F || (l.value ? "That video could not be uploaded." : "That image could not be uploaded."), "error");
        } finally {
          a.value = !1;
        }
      }
    }
    return (R, D) => (g(), b("div", {
      class: "up-pop up-refpick has-tabs",
      "data-testid": "ref-picker",
      onPointerdown: D[2] || (D[2] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", Jle, E(n.label), 1),
      u("div", {
        class: "up-pop-tabs",
        role: "tablist",
        "aria-label": n.label + " sources"
      }, [
        (g(), b(j, null, ge(d, (O) => u("button", {
          key: O.id,
          role: "tab",
          "aria-selected": h.value === O.id,
          class: G({ on: h.value === O.id }),
          "data-testid": "ref-tab-" + O.id,
          onClick: (F) => h.value = O.id
        }, E(O.label), 11, Qle)), 64))
      ], 8, Zle),
      h.value === "pinned" ? (g(), b(j, { key: 0 }, [
        c.value.length ? (g(), b("div", ede, [
          (g(!0), b(j, null, ge(c.value, (O) => (g(), b("button", {
            key: O.id,
            class: G(["up-refcell", { "is-video": O.video }]),
            title: O.label,
            style: ce({ backgroundImage: 'url("' + m(Bt)(O.url) + '")' }),
            onClick: (F) => f(O)
          }, null, 14, tde))), 128))
        ])) : (g(), Ie(H1, {
          key: 1,
          compact: "",
          kind: n.kind
        }, null, 8, ["kind"]))
      ], 64)) : h.value === "board" ? (g(), b(j, { key: 1 }, [
        p.value.length ? (g(), b("div", nde, [
          (g(!0), b(j, null, ge(p.value, (O) => (g(), b("button", {
            key: O.url,
            class: "up-refcell",
            title: O.label,
            style: ce({ backgroundImage: 'url("' + m(Bt)(O.url) + '")' }),
            onClick: (F) => i("pick", O.url)
          }, null, 12, ide))), 128))
        ])) : (g(), b("div", sde, E(n.kind === "video" ? "No videos on this board yet." : "No images on this board yet."), 1))
      ], 64)) : S.value ? (g(), b(j, { key: 2 }, [
        M.value.length ? (g(), b("div", ode, [
          (g(!0), b(j, null, ge(M.value, (O) => (g(), b("button", {
            key: O.id,
            class: G(["up-refcell", { "is-video": O.video }]),
            title: O.label,
            style: ce({ backgroundImage: 'url("' + m(Bt)(O.url) + '")' }),
            onClick: (F) => T(O)
          }, null, 14, rde))), 128))
        ])) : z("", !0),
        S.value.loading ? (g(), b("div", ade, [...D[3] || (D[3] = [
          u("span", { class: "bd-spinner is-sm" }, null, -1),
          Y("Loading", -1)
        ])])) : S.value.failed ? (g(), b("div", lde, "This couldn't be loaded.")) : M.value.length ? z("", !0) : (g(), b("div", dde, E(_.value), 1)),
        S.value.next && !S.value.loading ? (g(), b("button", {
          key: 4,
          class: "up-pop-row up-refpick-more",
          onClick: w
        }, [
          C($, {
            name: "ChevronDown",
            size: 13
          }),
          D[4] || (D[4] = u("span", { class: "up-pop-main" }, "Load more", -1))
        ])) : z("", !0)
      ], 64)) : z("", !0),
      n.dropper ? (g(), b("button", {
        key: 3,
        class: "up-pop-row",
        "data-testid": "ref-pick-from-board",
        onClick: D[0] || (D[0] = (O) => i("dropper"))
      }, [
        C($, {
          name: "Pipette",
          size: 13
        }),
        u("span", cde, E(n.dropperLabel), 1)
      ])) : z("", !0),
      m(s).hasLibrary ? (g(), b("button", {
        key: 4,
        class: "up-pop-row",
        "data-testid": "ref-open-library",
        onClick: k
      }, [
        C($, {
          name: "Library",
          size: 13
        }),
        D[5] || (D[5] = u("span", { class: "up-pop-main" }, "Open your Library", -1))
      ])) : z("", !0),
      P.value ? (g(), b("button", {
        key: 5,
        class: "up-pop-row",
        disabled: a.value,
        "data-testid": "ref-upload",
        onClick: D[1] || (D[1] = (O) => o.value && o.value.click())
      }, [
        C($, {
          name: a.value ? "Loader2" : "Upload",
          size: 13,
          spin: a.value
        }, null, 8, ["name", "spin"]),
        u("span", hde, E(a.value ? "Uploading…" : l.value ? "Upload a video" : "Upload an image"), 1)
      ], 8, ude)) : z("", !0),
      u("input", {
        ref_key: "fileEl",
        ref: o,
        type: "file",
        accept: l.value ? "video/*" : "image/*",
        style: { display: "none" },
        onChange: A
      }, null, 40, pde),
      n.tip ? (g(), b("div", fde, [
        C($, {
          name: "Hand",
          size: 13
        }),
        u("span", null, E(n.tip), 1)
      ])) : (g(), b("div", mde, [
        u("kbd", null, E(m(r)), 1),
        u("span", null, "Or hold Shift and drag " + E(n.kind === "video" ? "a video" : "an image") + " from the board here, or onto any session.", 1)
      ]))
    ], 32));
  }
}), gde = { class: "up-pop-label" }, bde = {
  key: 0,
  class: "up-pop-search"
}, vde = { class: "up-modelpick-av is-none" }, yde = {
  key: 0,
  class: "up-modelpick-group"
}, xde = ["title", "onClick"], wde = ["src", "onError"], kde = {
  key: 1,
  class: "up-modelpick-av"
}, _de = { class: "up-pop-main" }, Sde = {
  key: 0,
  class: "up-modelpick-desc"
}, Mde = {
  key: 2,
  class: "up-modelpick-note"
}, Tde = {
  key: 3,
  class: "up-modelpick-note"
}, Cde = {
  key: 4,
  class: "up-modelpick-note"
}, Ide = {
  key: 5,
  class: "up-modelpick-note"
}, Ade = /* @__PURE__ */ Pe({
  __name: "ModelFieldPop",
  props: {
    field: {},
    selectedId: {},
    required: { type: Boolean }
  },
  emits: ["pick"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = Ze(), o = /* @__PURE__ */ W(!0), r = /* @__PURE__ */ W(!1), a = /* @__PURE__ */ W(""), l = /* @__PURE__ */ W(s.trainedModelsSeen.value || []);
    it(async () => {
      try {
        l.value = await s.trainedModels();
      } catch (x) {
        console.warn("[board] trained models unavailable", x), r.value = !0;
      } finally {
        o.value = !1;
      }
    });
    const d = I(() => l.value.filter((x) => !t.field.architecture || x.architecture === t.field.architecture)), c = I(() => {
      const x = a.value.trim().toLowerCase();
      return x ? d.value.filter((w) => w.name.toLowerCase().includes(x) || (w.description || "").toLowerCase().includes(x)) : d.value;
    }), h = I(() => c.value.filter((x) => !x.shared)), f = I(() => c.value.filter((x) => x.shared)), p = I(() => [
      { key: "yours", label: f.value.length ? "Yours" : "", list: h.value },
      { key: "shared", label: "Shared", list: f.value }
    ].filter((x) => x.list.length)), y = I(() => t.field.architecture ? t.field.architecture + " " : "");
    function v(x, w) {
      const S = x.target;
      w.image && S.src !== w.image && (S.src = w.image);
    }
    return (x, w) => (g(), b("div", {
      class: "up-pop is-wide up-modelpick",
      "data-testid": "model-field-pop",
      onPointerdown: w[3] || (w[3] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", gde, E(n.field.label || "Trained model"), 1),
      d.value.length > 6 ? (g(), b("div", bde, [
        C($, {
          name: "Search",
          size: 12
        }),
        _t(u("input", {
          "onUpdate:modelValue": w[0] || (w[0] = (S) => a.value = S),
          placeholder: "Search your models",
          onKeydown: w[1] || (w[1] = Te(() => {
          }, ["stop"]))
        }, null, 544), [
          [Zt, a.value]
        ])
      ])) : z("", !0),
      !n.required && n.selectedId ? (g(), b("button", {
        key: 1,
        class: "up-pop-row",
        "data-testid": "model-field-none",
        onClick: w[2] || (w[2] = (S) => i("pick", null))
      }, [
        u("span", vde, [
          C($, {
            name: "X",
            size: 13
          })
        ]),
        w[4] || (w[4] = u("span", { class: "up-pop-main" }, "Don't use a trained model", -1))
      ])) : z("", !0),
      (g(!0), b(j, null, ge(p.value, (S) => (g(), b(j, {
        key: S.key
      }, [
        S.label ? (g(), b("div", yde, E(S.label), 1)) : z("", !0),
        (g(!0), b(j, null, ge(S.list, (M) => (g(), b("button", {
          key: M.id,
          class: G(["up-pop-row up-modelpick-row", { on: M.id === n.selectedId }]),
          title: M.description || M.name,
          onClick: (_) => i("pick", M.record)
        }, [
          M.thumb ? (g(), b("img", {
            key: 0,
            class: "up-modelpick-av",
            src: M.thumb,
            alt: "",
            draggable: "false",
            onError: (_) => v(_, M)
          }, null, 40, wde)) : (g(), b("span", kde, [
            C($, {
              name: "Sparkles",
              size: 13
            })
          ])),
          u("span", _de, [
            Y(E(M.name) + " ", 1),
            M.description ? (g(), b("span", Sde, E(M.description), 1)) : z("", !0)
          ]),
          M.id === n.selectedId ? (g(), Ie($, {
            key: 2,
            name: "Check",
            size: 13
          })) : z("", !0)
        ], 10, xde))), 128))
      ], 64))), 128)),
      o.value && !l.value.length ? (g(), b("div", Mde, [...w[5] || (w[5] = [
        u("span", { class: "bd-spinner is-sm" }, null, -1),
        Y("Loading your models", -1)
      ])])) : r.value && !l.value.length ? (g(), b("div", Tde, "Your models couldn't be loaded.")) : !o.value && !d.value.length ? (g(), b("div", Cde, " No " + E(y.value) + "models yet. Models you train show up here. ", 1)) : a.value && !c.value.length ? (g(), b("div", Ide, "No models match “" + E(a.value) + "”.", 1)) : z("", !0)
    ], 32));
  }
}), Pde = { class: "media" }, Ede = ["poster", "autoplay", "data-slide"], Rde = ["src"], zde = ["src", "data-slide"], $de = { class: "tag" }, Dde = { class: "body" }, Ode = { class: "foot" }, Lde = {
  class: "dots",
  role: "tablist",
  "aria-label": "Slides"
}, Bde = ["aria-selected", "aria-label", "onClick"], Fde = { class: "cta" }, Rh = "/img/board/studio-view/", Nde = 500, ub = 3400, hb = 7e3, Ude = /* @__PURE__ */ Pe({
  __name: "StudioViewButton",
  emits: ["open"],
  setup(n, { emit: e }) {
    const t = e, { board: i } = Ze(), s = [
      { id: "overview", video: !1, title: "Your session, full screen", text: "The picture large, its versions above it, the board's history beside it." },
      { id: "area", video: !0, title: "Change just one area", text: "Paint over it and say what changes. Precision keeps every other pixel." },
      { id: "refs", video: !0, title: "References from history", text: "Pick pictures from history to guide the edit, or drag them in." },
      { id: "camera", video: !0, title: "Move the camera", text: "See the same scene from another angle." },
      { id: "relight", video: !0, title: "Relight it", text: "Golden hour, dusk or night: new light on the same scene." },
      { id: "compare", video: !0, title: "Compare versions", text: "Every result is a version. Split two to see what changed." }
    ], o = typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches, r = /* @__PURE__ */ W(!1), a = /* @__PURE__ */ W(0), l = /* @__PURE__ */ W(ub / 1e3), d = I(() => s[a.value]);
    let c = 0, h = 0, f = 0;
    function p() {
      clearTimeout(h), !(r.value || i.tour) && (clearTimeout(c), c = window.setTimeout(v, Nde));
    }
    function y() {
      clearTimeout(c), clearTimeout(h), h = window.setTimeout(() => {
        r.value = !1, clearTimeout(f);
      }, 160);
    }
    function v() {
      w(), a.value = 0, r.value = !0, S();
    }
    let x = !1;
    function w() {
      if (!x) {
        x = !0;
        for (const P of s) {
          const A = new Image();
          A.src = Rh + P.id + ".jpg";
        }
      }
    }
    function S() {
      if (clearTimeout(f), o) return;
      const P = d.value;
      l.value = (P.video ? hb : ub) / 1e3, f = window.setTimeout(_, P.video ? hb : ub);
    }
    function M(P) {
      a.value = (P + s.length) % s.length, S();
    }
    function _() {
      M(a.value + 1);
    }
    function T(P) {
      const A = P.target;
      Number.isFinite(A.duration) && A.duration > 0 && (l.value = A.duration, clearTimeout(f), f = window.setTimeout(_, Math.min(hb, A.duration * 1e3 + 600)));
    }
    function k() {
      clearTimeout(c), clearTimeout(f), r.value = !1, t("open");
    }
    return We(() => {
      clearTimeout(c), clearTimeout(h), clearTimeout(f);
    }), (P, A) => (g(), b("span", {
      class: "up-studio-wrap",
      onMouseenter: p,
      onMouseleave: y
    }, [
      u("button", {
        class: G(["up-studio", { on: r.value }]),
        "aria-label": "Studio view: open this session full screen",
        "data-testid": "prompt-studio",
        onClick: k,
        onFocus: p,
        onBlur: y
      }, [
        C($, {
          name: "Expand",
          size: 13
        }),
        A[0] || (A[0] = u("span", null, "Studio", -1))
      ], 34),
      C(vt, { name: "up-studio-pop" }, {
        default: Xe(() => [
          r.value ? (g(), b("div", {
            key: 0,
            class: "up-studio-pop",
            role: "dialog",
            "aria-label": "Studio view",
            "data-testid": "studio-view-preview",
            onClick: k
          }, [
            u("div", Pde, [
              C(vt, { name: "up-studio-slide" }, {
                default: Xe(() => [
                  d.value.video ? (g(), b("video", {
                    key: d.value.id,
                    poster: Rh + d.value.id + (m(o) ? "-end" : "") + ".jpg",
                    autoplay: !m(o),
                    muted: "",
                    playsinline: "",
                    preload: "auto",
                    disablepictureinpicture: "",
                    "data-slide": d.value.id,
                    onLoadedmetadata: T
                  }, [
                    u("source", {
                      src: Rh + d.value.id + ".webm",
                      type: "video/webm"
                    }, null, 8, Rde)
                  ], 40, Ede)) : (g(), b("img", {
                    key: d.value.id,
                    src: Rh + d.value.id + ".jpg",
                    alt: "",
                    "data-slide": d.value.id,
                    draggable: "false"
                  }, null, 8, zde))
                ]),
                _: 1
              }),
              u("span", $de, [
                C($, {
                  name: "Expand",
                  size: 10
                }),
                A[1] || (A[1] = Y(" Studio view", -1))
              ])
            ]),
            u("div", Dde, [
              C(vt, {
                name: "up-studio-words",
                mode: "out-in"
              }, {
                default: Xe(() => [
                  (g(), b("div", {
                    key: d.value.id,
                    class: "words"
                  }, [
                    u("b", null, E(d.value.title), 1),
                    u("span", null, E(d.value.text), 1)
                  ]))
                ]),
                _: 1
              }),
              u("div", Ode, [
                u("span", Lde, [
                  (g(), b(j, null, ge(s, (R, D) => u("button", {
                    key: R.id,
                    role: "tab",
                    "aria-selected": D === a.value,
                    "aria-label": R.title,
                    class: G({ on: D === a.value }),
                    style: ce(D === a.value ? { "--d": l.value + "s" } : void 0),
                    onClick: Te((O) => M(D), ["stop"])
                  }, [
                    (g(), b("i", {
                      key: a.value + ":" + D
                    }))
                  ], 14, Bde)), 64))
                ]),
                u("span", Fde, [
                  A[2] || (A[2] = Y("Open Studio ", -1)),
                  C($, {
                    name: "ArrowRight",
                    size: 11
                  })
                ])
              ])
            ])
          ])) : z("", !0)
        ]),
        _: 1
      })
    ], 32));
  }
}), Gde = ["aria-expanded", "aria-label", "title", "disabled"], jde = ["data-testid"], Hde = { class: "sv-pop-rows" }, Vde = ["aria-selected", "data-testid", "onClick"], Wde = { class: "nm" }, ex = /* @__PURE__ */ Pe({
  __name: "CountPick",
  props: {
    value: {},
    min: { default: 1 },
    max: {},
    testid: { default: void 0 },
    tall: { type: Boolean, default: !1 }
  },
  emits: ["update"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(!1), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = I(() => {
      const x = [];
      for (let w = Math.max(1, t.min); w <= Math.max(t.min, t.max); w++) x.push(w);
      return x;
    }), d = I(() => l.value.length < 2);
    function c(x) {
      s.value = !1, x && nt(() => {
        var w;
        return (w = r.value) == null ? void 0 : w.focus({ preventScroll: !0 });
      });
    }
    function h(x) {
      c(!0), x !== t.value && i("update", x);
    }
    function f() {
      return a.value ? [...a.value.querySelectorAll('[role="option"]')] : [];
    }
    function p(x) {
      const w = f(), S = w.indexOf(document.activeElement);
      let M = -1;
      x.key === "ArrowDown" ? M = Math.min(w.length - 1, S + 1) : x.key === "ArrowUp" ? M = Math.max(0, S < 0 ? w.length - 1 : S - 1) : x.key === "Home" ? M = 0 : x.key === "End" && (M = w.length - 1), !(M < 0) && (x.preventDefault(), w[M].focus());
    }
    function y(x) {
      o.value && !o.value.contains(x.target) && c(!1);
    }
    function v(x) {
      x.key === "Escape" && (x.stopPropagation(), x.preventDefault(), c(!0));
    }
    return Ee(s, (x) => {
      x ? (window.addEventListener("pointerdown", y, !0), window.addEventListener("keydown", v, !0), nt(() => {
        const w = f().find((S) => S.getAttribute("aria-selected") === "true");
        w && w.focus({ preventScroll: !0 });
      })) : (window.removeEventListener("pointerdown", y, !0), window.removeEventListener("keydown", v, !0));
    }), We(() => {
      window.removeEventListener("pointerdown", y, !0), window.removeEventListener("keydown", v, !0);
    }), (x, w) => (g(), b("span", {
      ref_key: "wrap",
      ref: o,
      class: "up-count-wrap"
    }, [
      u("button", {
        ref_key: "btn",
        ref: r,
        class: G(["up-count", { on: s.value, "is-tall": n.tall }]),
        "aria-expanded": s.value,
        "aria-haspopup": "listbox",
        "aria-label": "How many to make: " + n.value,
        title: d.value ? "This model makes " + n.value + " a run" : "How many to make",
        disabled: d.value,
        "data-testid": "count-pick",
        onClick: w[0] || (w[0] = (S) => s.value = !s.value)
      }, [
        u("span", {
          class: "n",
          "data-testid": n.testid
        }, E(n.value), 9, jde),
        d.value ? z("", !0) : (g(), Ie($, {
          key: 0,
          name: "ChevronDown",
          size: 12,
          class: "chev"
        }))
      ], 10, Gde),
      s.value ? (g(), b("div", {
        key: 0,
        ref_key: "list",
        ref: a,
        class: "sv-pop is-narrow up-count-pop",
        role: "listbox",
        "aria-label": "How many to make",
        "data-testid": "count-menu",
        onKeydown: p
      }, [
        w[1] || (w[1] = u("div", { class: "sv-pop-title" }, "How many", -1)),
        u("div", Hde, [
          (g(!0), b(j, null, ge(l.value, (S) => (g(), b("button", {
            key: S,
            class: G(["sv-pop-row", { on: S === n.value }]),
            role: "option",
            "aria-selected": S === n.value,
            "data-testid": "count-" + S,
            onClick: (M) => h(S)
          }, [
            u("span", Wde, E(S), 1),
            S === n.value ? (g(), Ie($, {
              key: 0,
              name: "Check",
              size: 12,
              class: "ck"
            })) : z("", !0)
          ], 10, Vde))), 128))
        ])
      ], 544)) : z("", !0)
    ], 512));
  }
}), qr = ":pinned", vl = ":all", Mu = ":kit";
function T0(n) {
  return n.tags && n.tags.length >= 2 ? n.tags : [Mu];
}
function hI(n, e) {
  return (e ? [qr] : []).concat([vl], n);
}
function pI(n, e = "Models") {
  return n === qr ? "Pinned" : n === vl ? "All" : n === Mu ? e : n;
}
function fI(n, e, t, i, s) {
  const o = i.trim().toLowerCase();
  return o ? e.filter((r) => r.name.toLowerCase().includes(o)) : t === qr ? e.filter((r) => s(r.id)) : t === vl ? e.slice().sort((r, a) => r.name.localeCompare(a.name, void 0, { sensitivity: "base", numeric: !0 })) : t && t !== Mu ? n.filter((r) => !!r.kitTags && r.kitTags.includes(t)) : n.slice();
}
function qde(n) {
  return n.scrollWidth > n.clientWidth + 1;
}
function $_(n, e) {
  e && qde(n) ? n.setAttribute("title", e) : n.removeAttribute("title");
}
const dl = {
  mounted(n, e) {
    $_(n, e.value);
  },
  updated(n, e) {
    e.value !== e.oldValue && $_(n, e.value);
  }
}, Kde = 42, Yde = 3200;
function mI(n, e = Kde, t = Yde) {
  const i = Array.from(n);
  if (!i.length) return [];
  const s = i.map((l, d) => {
    const c = i[d - 1], h = (Math.sin((d + 1) * 12.9898) * 43758.5453 % 1 + 1) % 1;
    return (c === "," || c === "." || c === ":" ? 3.4 : c === " " ? 1.45 : 1) * (0.78 + 0.44 * h);
  }), o = s.reduce((l, d) => l + d, 0), r = Math.min(t, i.length / e * 1e3);
  let a = 0;
  return s.map((l) => (a += l, Math.round(a / o * r)));
}
function Xde(n, e, t = mI(n)) {
  const i = Array.from(n);
  let s = 0;
  for (; s < t.length && t[s] <= e; ) s++;
  return i.slice(0, s).join("");
}
function tx(n) {
  const e = n.board.tour, t = I(() => {
    const l = n.sessionId();
    return e && l ? e.lineFor(n.field, l) : null;
  }), i = I(() => {
    const l = n.sessionId();
    return !!(e && l && e.holds(n.field, l));
  }), s = /* @__PURE__ */ W(!1), o = I(() => t.value && !s.value && !n.value() ? t.value : null);
  let r = 0;
  function a() {
    const l = t.value;
    if (!l || s.value || !e) return;
    s.value = !0, e.typing(n.field, !0);
    const d = mI(l), c = performance.now(), h = () => {
      const f = Xde(l, performance.now() - c, d);
      if (f !== n.value() && n.write(f), f.length < Array.from(l).length) {
        r = requestAnimationFrame(h);
        return;
      }
      r = 0, s.value = !1, n.done && n.done(), e.typing(n.field, !1);
    };
    r = requestAnimationFrame(h);
  }
  return e && Ee(() => e.tabbed(n.field), (l, d) => {
    l > (d || 0) && o.value && a();
  }), We(() => {
    r && cancelAnimationFrame(r), s.value && t.value && e && (n.write(t.value), n.done && n.done(), s.value = !1, e.typing(n.field, !1));
  }), { line: t, ghost: o, held: i, typing: s, typeIn: a };
}
const Jde = {
  key: 0,
  class: "up-error",
  role: "alert",
  "data-testid": "prompt-error"
}, Zde = ["aria-valuenow"], Qde = { class: "up-side" }, ece = ["aria-expanded"], tce = {
  key: 0,
  class: "lib-new",
  "aria-hidden": "true"
}, nce = ["aria-pressed"], ice = {
  key: 1,
  class: "up-refs",
  "data-testid": "prompt-refs"
}, sce = ["title", "data-ref-key", "onMouseenter"], oce = ["aria-label", "onClick"], rce = {
  key: 0,
  class: "lbl"
}, ace = {
  key: 0,
  class: "up-drop-wrap"
}, lce = ["title", "aria-label", "data-ref-key", "onClick"], dce = {
  key: 0,
  class: "up-drop-wrap"
}, cce = ["title", "aria-label", "aria-expanded"], uce = { class: "n" }, hce = { class: "s" }, pce = { class: "up-moregrid" }, fce = ["title", "data-ref-key"], mce = ["onClick"], gce = ["title", "aria-label", "data-ref-key", "onClick"], bce = ["title"], vce = ["value", "placeholder", "readonly"], yce = ["data-ref-key"], xce = {
  key: 5,
  class: "up-cue",
  "data-testid": "ghost-cue"
}, wce = ["src"], kce = { class: "n" }, _ce = { class: "up-foot" }, Sce = { class: "up-chips" }, Mce = { class: "up-chip-wrap up-model-wrap" }, Tce = { class: "nm" }, Cce = { class: "up-pop-label" }, Ice = { class: "up-pop-search" }, Ace = ["placeholder", "aria-label"], Pce = ["aria-label"], Ece = ["aria-selected", "data-testid", "onClick"], Rce = ["onClick"], zce = { class: "up-pop-main" }, $ce = ["title"], Dce = { class: "up-pop-meta" }, Oce = ["title", "aria-label", "aria-pressed", "data-testid", "onClick"], Lce = {
  key: 1,
  class: "up-pop-empty"
}, Bce = {
  key: 2,
  class: "up-pop-empty",
  "data-testid": "model-search-empty"
}, Fce = {
  key: 1,
  class: "up-cost",
  title: "Token cost for this run",
  "data-testid": "run-cost"
}, Nce = {
  key: 0,
  class: "up-foot-sep"
}, Uce = ["title", "aria-disabled", "data-testid", "onClick"], Gce = ["src", "onError"], jce = { class: "t" }, Hce = { class: "up-pop-label" }, Vce = {
  key: 0,
  class: "up-pop-slider",
  "data-testid": "chip-slider"
}, Wce = ["min", "max", "step", "value", "aria-label", "onInput"], qce = ["min", "max", "step", "value", "aria-label", "onChange"], Kce = ["onClick"], Yce = ["onClick"], Xce = { class: "up-pop-main" }, Jce = {
  key: 1,
  class: "up-pop-meta"
}, Zce = ["title", "onClick"], Qce = { class: "t" }, eue = { class: "up-pop-label" }, tue = { class: "up-influence-ends" }, nue = ["value", "onInput"], iue = { class: "up-adv-hint" }, sue = ["aria-expanded"], oue = ["title"], rue = { class: "up-run-wrap" }, aue = ["disabled", "title"], lue = {
  key: 2,
  class: "tip"
}, zh = 3, due = 70, cue = 48, D_ = 200, O_ = 44, uue = 12, hue = 84, pue = 3400, fue = 320, mue = /* @__PURE__ */ Pe({
  __name: "UnifiedPrompt",
  props: {
    tool: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(""), a = I(() => t.modelFor(e.tool)), l = I(() => a.value.model), d = I(() => a.value.kit), c = I(() => l.value ? l.value.fields : []), h = I(() => c.value.find((fe) => fe.placement === "prompt" && (fe.kind === "prompt" || fe.kind === "text")) || null), f = I(() => c.value.filter((fe) => fe.placement === "reference")), p = I(() => f.value.filter(kt)), y = I(() => p.value.length > zh ? p.value.slice(0, zh - 1) : p.value), v = I(() => p.value.length > zh ? p.value.slice(zh - 1) : []), x = I(() => v.value.filter((fe) => !!X(fe)).length), w = /* @__PURE__ */ W(!1), S = I(() => v.value.find((fe) => fe.key === s.value) || null), M = I(() => {
      const fe = p.value[0];
      return fe ? "No prompt needed. Drop " + (fe.kind === "video" ? "a video" : "an image") + " here, or pick one from the board." : "No prompt needed for this tool.";
    }), _ = I(() => c.value.filter((fe) => fe.placement === "chip" && kt(fe))), T = I(() => t.promptOf(e.tool.id)), k = I(() => {
      const fe = l.value;
      return !fe || !(e.tool.kitId === "video" || e.tool.kitId === "videoEdit" || fe.fields.some((ke) => ke.kind === "video")) ? "" : r8(fe, (ke) => Lc(ke, T.value));
    }), P = /* @__PURE__ */ W(T.value.prompt || "");
    let A = 0;
    Ee(() => e.tool.id, (fe) => {
      P.value = t.promptOf(fe).prompt || "";
    }), Ee(() => T.value.prompt, (fe) => {
      document.activeElement !== o.value && (P.value = fe || "");
    });
    function R(fe) {
      P.value = fe.target.value, clearTimeout(A), A = window.setTimeout(O, 450);
    }
    function D(fe) {
      bn(fe) && (fe.preventDefault(), Ex());
    }
    function O() {
      clearTimeout(A), (T.value.prompt || "") !== P.value && t.setPrompt(e.tool.id, { prompt: P.value });
    }
    const F = tx({
      board: t,
      field: "session",
      sessionId: () => e.tool.id,
      value: () => P.value,
      write: (fe) => {
        P.value = fe;
      },
      done: () => {
        O(), nt(() => {
          const fe = o.value;
          fe && fe.setSelectionRange(fe.value.length, fe.value.length);
        });
      }
    }), ie = I(() => F.ghost.value ? hue : p.value.length ? cue : due), ee = /* @__PURE__ */ W(0), me = /* @__PURE__ */ W(0), L = I(() => Math.max(ie.value, Math.min(D_, ee.value - me.value))), N = I(() => t.ui.promptH != null ? t.ui.promptH : L.value), K = /* @__PURE__ */ W(!1), B = () => Math.max(D_, Math.round(window.innerHeight * 0.5) - 60), re = (fe) => Math.round(Math.max(O_, Math.min(B(), fe)));
    function H() {
      const fe = o.value;
      if (!fe) return;
      const ke = fe.style.height;
      fe.style.height = "0px", ee.value = fe.scrollHeight, fe.style.height = ke;
    }
    Ee(P, () => nt(H)), Ee(ee, () => {
      me.value = Math.min(me.value, Math.max(0, ee.value - ie.value));
    });
    let J = 0;
    const Q = new ResizeObserver((fe) => {
      const ke = Math.round(fe[0].contentRect.width);
      if (ke !== J) {
        J = ke;
        const xe = ee.value;
        H(), me.value && (me.value = Math.max(0, me.value + ee.value - xe));
      }
    });
    Ee(o, (fe, ke) => {
      ke && Q.unobserve(ke), fe && (Q.observe(fe), H());
    }), We(() => Q.disconnect());
    function ne(fe) {
      if (fe.button !== 0) return;
      fe.preventDefault();
      const ke = fe.currentTarget;
      ke.setPointerCapture(fe.pointerId);
      const xe = fe.clientY, ct = N.value;
      K.value = !0;
      const vi = (hr) => {
        Z(ct + (xe - hr.clientY));
      }, li = () => {
        K.value = !1, ke.removeEventListener("pointermove", vi), ke.removeEventListener("pointerup", li), ke.removeEventListener("pointercancel", li), te();
      };
      ke.addEventListener("pointermove", vi), ke.addEventListener("pointerup", li), ke.addEventListener("pointercancel", li);
    }
    const ue = (fe) => Math.abs(fe - ie.value) <= uue;
    function Z(fe) {
      const ke = re(fe);
      t.ui.promptH = ue(ke) ? ie.value : ke;
    }
    function te() {
      t.ui.promptH == null || !ue(t.ui.promptH) || (t.ui.promptH = null, me.value = Math.max(0, ee.value - ie.value));
    }
    function we() {
      t.ui.promptH = null, me.value = 0, nt(H);
    }
    function Fe(fe) {
      fe.key === "ArrowUp" || fe.key === "ArrowDown" ? (fe.preventDefault(), fe.stopPropagation(), Z(N.value + (fe.key === "ArrowUp" ? 20 : -20)), te()) : fe.key === "Enter" && (fe.preventDefault(), fe.stopPropagation(), we());
    }
    We(O);
    const Me = I(() => t.freshTools.has(e.tool.id) && !P.value);
    it(() => {
      Me.value && nt(() => o.value && o.value.focus({ preventScroll: !0 })), Me.value && t.promptLibrary.load();
    });
    const he = I(() => t.ui.library.open && t.ui.library.sessionId === e.tool.id && !t.ui.library.inStudio);
    function U() {
      O(), i.value = null, t.promptLibrary.toggle(e.tool.id);
    }
    function q() {
      he.value && t.promptLibrary.close(), t.ui.advOpen = !t.ui.advOpen;
    }
    const oe = I(() => Me.value && !!h.value && !i.value && !he.value && !t.ui.advOpen), de = I(() => oe.value && !t.tour ? t.promptLibrary.ghostLines(e.tool) : []), pe = /* @__PURE__ */ W(0), Ce = I(() => F.ghost.value && h.value ? { id: "tour", text: F.ghost.value, tour: !0 } : de.value.length ? { ...de.value[pe.value % de.value.length], tour: !1 } : null);
    _E((fe) => {
      if (de.value.length < 2) return;
      const ke = window.setInterval(() => {
        pe.value = (pe.value + 1) % de.value.length;
      }, pue);
      fe(() => clearInterval(ke));
    });
    function Be(fe) {
      !Ce.value || fe.shiftKey || Ce.value.tour || (fe.preventDefault(), P.value = Ce.value.text, O(), nt(() => {
        const ke = o.value;
        ke && ke.setSelectionRange(ke.value.length, ke.value.length);
      }));
    }
    const be = /* @__PURE__ */ W(!1);
    let se = 0;
    Ee(() => t.ui.promptLanded && t.ui.promptLanded.id === e.tool.id ? t.ui.promptLanded.seq : 0, (fe) => {
      fe && (be.value = !1, clearTimeout(se), requestAnimationFrame(() => {
        be.value = !0, se = window.setTimeout(() => {
          be.value = !1, t.ui.promptLanded && t.ui.promptLanded.id === e.tool.id && (t.ui.promptLanded = null);
        }, 1300);
      }));
    }, { immediate: !0 }), We(() => clearTimeout(se));
    const ae = /* @__PURE__ */ W(null), ye = /* @__PURE__ */ W(0), Oe = new ResizeObserver((fe) => {
      ye.value = Math.round(fe[0].contentRect.height), t.ui.promptCardH = ye.value;
    });
    Ee(ae, (fe, ke) => {
      ke && Oe.unobserve(ke), fe && Oe.observe(fe);
    }), We(() => {
      Oe.disconnect(), t.ui.promptCardH = 0;
    });
    function Ve(fe) {
      t.setPrompt(e.tool.id, { prompt: P.value, ...fe });
    }
    function Ue(fe, ke) {
      Ve({ inputs: { ...T.value.inputs || {}, [fe]: ke } });
    }
    const tt = I(() => {
      const fe = l.value, ke = T.value.n || (fe ? fe.numResults.def : 1) || 1;
      return fe ? Math.max(fe.numResults.min, Math.min(fe.numResults.max, ke)) : ke;
    }), Ye = I(() => l.value ? Xi(l.value, { ...T.value, prompt: P.value }, tt.value, !!t.user.isAdmin) : null), at = I(() => {
      const fe = l.value, ke = Ye.value;
      return !!fe && !!ke && fe.fields.some((xe) => xe.placement === "advanced" && xe.kind !== "header" && Gr(ke, xe.key).shown);
    });
    Ee(at, (fe) => {
      !fe && t.ui.advOpen && (t.ui.advOpen = !1);
    });
    function kt(fe) {
      return !Ye.value || Gr(Ye.value, fe.key).shown;
    }
    function $e(fe) {
      return !!Ye.value && Gr(Ye.value, fe.key).locked;
    }
    function Ne(fe) {
      return Ye.value ? Gr(Ye.value, fe.key).why : "";
    }
    function V(fe) {
      const ke = Ye.value;
      return ke && fe.key in ke.values ? ke.values[fe.key] : Lc(fe, T.value);
    }
    Ee(() => Ye.value ? Ye.value.autoErrors.join(`
`) : "", (fe, ke) => {
      if (!fe) return;
      const xe = new Set((ke || "").split(`
`));
      for (const ct of fe.split(`
`)) xe.has(ct) || t.toast(ct, "error");
    });
    function X(fe) {
      if (fe === f.value[0]) return T.value.ref || null;
      const ke = T.value.inputs ? T.value.inputs[fe.key] : null;
      return typeof ke == "string" ? ke : null;
    }
    function le(fe, ke) {
      O(), t.setRefInput(e.tool.id, fe.key, ke, ke ? t.assetFor(ke) : null);
    }
    function Le(fe) {
      const ke = T.value.inputs ? T.value.inputs[fe.key] : null;
      return Array.isArray(ke) ? ke.filter((xe) => typeof xe == "string" && !!xe) : [];
    }
    function ve(fe) {
      const ke = Le(fe);
      if (ke.length) return ke;
      const xe = X(fe);
      return xe ? [xe] : [];
    }
    function _e(fe, ke) {
      return fe.kind === "images" ? "Image " + (ke + 1) : fe.label;
    }
    const De = I(() => !!t.ui.eyedropper && t.ui.eyedropper.sessionId === e.tool.id);
    function Qe(fe) {
      return De.value && !!t.ui.eyedropper && t.ui.eyedropper.key === fe.key;
    }
    function ft(fe) {
      s.value = null, w.value = !1, t.armEyedropper(e.tool.id, fe.key);
    }
    function Dn(fe) {
      s.value = s.value === fe ? null : fe, s.value && (t.ui.eyedropper = null);
    }
    function Zn(fe) {
      const ke = t.ui.refPulse;
      return ke && ke.url === fe ? ke.n : 0;
    }
    function xa(fe) {
      const ke = t.ui.refGlow;
      return ke && ke.sessionId === e.tool.id && ke.url === fe ? ke.n : 0;
    }
    function wa(fe, ke) {
      O(), ze.value = null, t.removeRefImage(e.tool.id, fe.key, ke);
    }
    const ze = /* @__PURE__ */ W(null);
    function Re(fe, ke, xe) {
      const ct = ae.value;
      if (!ct) return;
      const vi = xe.currentTarget.getBoundingClientRect(), li = ct.getBoundingClientRect(), hr = fue / 2;
      ze.value = { url: fe, label: ke, left: Math.max(hr, Math.min(li.width - hr, vi.left - li.left + vi.width / 2)) };
    }
    const lt = I(() => {
      const fe = ze.value;
      return !fe || t.ui.dragging || s.value || w.value ? null : p.value.some((ke) => ve(ke).includes(fe.url)) ? fe : null;
    }), nn = I(() => t.accountProblem()), Ui = I(() => t.labels.team + " deactivated"), ho = I(() => !nn.value && Ye.value && !Ye.value.problems.length ? t.tokensProblem(Ye.value.price) : ""), po = I(() => nn.value || Ye.value && Ye.value.problems[0] || ho.value || null), xP = I(() => !!ho.value && t.canGetTokens), Is = I(() => t.submitting(e.tool.id)), Px = I(() => {
      const fe = l.value;
      return fe ? fe.raw && Ye.value && Ye.value.price != null ? El(Ye.value.price) : a8(fe, tt.value) : "";
    }), nd = /* @__PURE__ */ W(!1);
    let Rm = 0;
    function wP() {
      nd.value = !1, clearTimeout(Rm), requestAnimationFrame(() => {
        nd.value = !0, Rm = window.setTimeout(() => nd.value = !1, 1800);
      });
    }
    We(() => clearTimeout(Rm));
    function Ex() {
      if (O(), !Is.value) {
        if (po.value) {
          wP();
          return;
        }
        t.generate(e.tool.id);
      }
    }
    function zm(fe) {
      i.value = i.value === fe ? null : fe, r.value = "", i.value === "model" && (ls.value = kP());
    }
    const ls = /* @__PURE__ */ W(null);
    function kP() {
      const fe = d.value, ke = l.value;
      if (ke && t.isModelPinned(ke.id)) return qr;
      if (!fe || ke && !fe.models.some((xe) => xe.id === ke.id)) return vl;
      if (!fe.tags || fe.tags.length < 2) return Mu;
      if (ke && ke.kitTags) {
        if (ke.kitTags.includes("Featured") && fe.tags.includes("Featured")) return "Featured";
        const xe = ke.kitTags.find((ct) => fe.tags.includes(ct));
        if (xe) return xe;
      }
      return fe.tags.includes("Featured") ? "Featured" : fe.tags[0];
    }
    function $m(fe) {
      const ke = V(fe), xe = ke && typeof ke == "object" ? ke.model : null;
      return xe && typeof xe == "object" ? xe : null;
    }
    function Dm(fe) {
      const ke = fe.kind === "model" ? $m(fe) : null;
      return ke ? t.modelPicture(ke) : null;
    }
    function _P(fe, ke) {
      const xe = Dm(ke), ct = fe.target;
      xe && ct.src !== xe.image && (ct.src = xe.image);
    }
    function SP(fe, ke) {
      Ue(fe.key, ke ? { model: ke } : null), i.value = null;
    }
    function MP(fe) {
      return !!Ye.value && Gr(Ye.value, fe.key).required;
    }
    function TP(fe) {
      if (fe.kind === "model") {
        const ct = $m(fe);
        return ct && ct.name || "Trained model";
      }
      const ke = V(fe), xe = (fe.options || []).find((ct) => Qi(ct.value, ke));
      return fe.kind === "size" && xe ? nf(xe.value) && xe.meta || xe.label : fe.kind === "size" && ke && typeof ke == "object" ? xn(ke).replace("x", "×") : xe ? xe.label : String(ke == null ? fe.label : ke);
    }
    function CP(fe) {
      if (fe.icon) return fe.icon;
      if (fe.kind === "size") {
        const ke = V(fe), xe = (fe.options || []).find((ct) => Qi(ct.value, ke));
        return xe && xe.icon || "RectangleHorizontal";
      }
      return "Settings2";
    }
    const Om = I(() => p.value.filter((fe) => !!(fe.raw && fe.raw.display && fe.raw.display.hasStrength) && !!X(fe)));
    function Rx(fe) {
      const ke = T.value.inputs ? T.value.inputs[tf(fe.key)] : void 0;
      return typeof ke == "number" ? ke : e8;
    }
    function id(fe) {
      return 100 - Math.round(Rx(fe) * 100);
    }
    function IP(fe, ke) {
      const xe = Math.min(0.95, Math.max(0.05, Number(ke)));
      Number.isFinite(xe) && Ue(tf(fe.key), Math.round(xe * 100) / 100);
    }
    function AP(fe) {
      if ($e(fe)) {
        t.toast(Ka(Ne(fe)));
        return;
      }
      zm(fe.key);
    }
    function zx(fe, ke) {
      Ue(fe.key, ke.value), i.value = null;
    }
    function $x(fe) {
      return l.value ? o8(l.value, fe, T.value, (ke) => t.measuredSize(ke)) : null;
    }
    function Dx(fe, ke) {
      return ke.meta && (fe.kind !== "size" || nf(ke.value)) ? ke.meta : "";
    }
    function Ox(fe) {
      const ke = cc(fe, V(fe));
      return ke == null ? cc(fe, fe.min == null ? 1 : fe.min) || 0 : ke;
    }
    function Lx(fe, ke) {
      const xe = cc(fe, ke);
      xe != null && Ue(fe.key, xe);
    }
    const PP = I(() => Bx.value.filter((fe) => t.isModelPinned(fe.id))), EP = I(() => {
      const fe = d.value;
      if (!fe || !ls.value) return [];
      const ke = ls.value === qr || PP.value.length > 0;
      return hI(T0(fe), ke);
    }), RP = I(() => !!r.value.trim() || ls.value === vl), zP = { image: "image", video: "video", threed: "3D", upscale: "upscale" }, Au = I(() => d.value ? zP[pl(d.value.id)] || d.value.name.toLowerCase() : ""), Bx = I(() => {
      const fe = d.value, ke = t.catalog.value;
      return fe ? ke.all.filter((xe) => Fc(ke, fe, xe)) : [];
    }), Lm = I(() => {
      const fe = d.value;
      return fe ? t.pinnedModelsFirst(fI(fe.models, Bx.value, ls.value, r.value, (ke) => t.isModelPinned(ke))) : [];
    });
    function $P(fe) {
      t.patchTool(e.tool.id, { model: fe.name, nodeDefId: fe.id }), i.value = null;
    }
    function Fx(fe) {
      const ke = fe.target;
      !ke.closest(".v2-uprompt") && !ke.closest(".lb-backdrop") && (i.value = null, s.value = null, w.value = !1);
    }
    return it(() => window.addEventListener("pointerdown", Fx, !0)), We(() => window.removeEventListener("pointerdown", Fx, !0)), (fe, ke) => (g(), b("div", {
      class: "v2-uprompt",
      style: ce({ "--up-card-h": (ye.value || 150) + "px" }),
      "data-testid": "unified-prompt",
      onPointerdown: ke[21] || (ke[21] = Te(() => {
      }, ["stop"]))
    }, [
      n.tool.error && !Is.value ? (g(), b("div", Jde, [
        C($, {
          name: "AlertCircle",
          size: 14
        }),
        u("span", null, E(n.tool.error), 1),
        u("button", {
          "aria-label": "Dismiss",
          onClick: ke[0] || (ke[0] = (xe) => m(t).patchTool(n.tool.id, { error: null }))
        }, [
          C($, {
            name: "X",
            size: 12
          })
        ])
      ])) : z("", !0),
      he.value ? (g(), Ie(Qy, { key: 1 })) : z("", !0),
      m(t).ui.advOpen && !he.value && l.value && Ye.value && at.value ? (g(), Ie(Lre, {
        key: 2,
        tool: n.tool,
        model: l.value,
        form: Ye.value,
        onClose: ke[1] || (ke[1] = (xe) => m(t).ui.advOpen = !1)
      }, null, 8, ["tool", "model", "form"])) : z("", !0),
      u("div", {
        ref_key: "cardEl",
        ref: ae,
        class: G(["up-card", { "has-refs": p.value.length > 0, "is-fresh": Me.value && !nd.value, "is-nudge": nd.value, "is-resizing": K.value, "is-landed": be.value }])
      }, [
        h.value ? (g(), b("div", {
          key: 0,
          class: G(["up-grip", { "is-on": K.value, "is-hand": m(t).ui.promptH != null }]),
          role: "separator",
          "aria-orientation": "horizontal",
          "aria-label": "Prompt height",
          "aria-valuenow": Math.round(N.value),
          "aria-valuemin": O_,
          tabindex: "0",
          title: "Drag to resize. Double-click to fit the text.",
          "data-testid": "prompt-grip",
          onPointerdown: ne,
          onDblclick: we,
          onKeydown: Fe
        }, [...ke[22] || (ke[22] = [
          u("i", null, null, -1)
        ])], 42, Zde)) : z("", !0),
        u("div", Qde, [
          h.value ? (g(), Ie(l8, {
            key: 0,
            slides: m(c8),
            media: m(d8),
            tag: "Prompt library",
            "tag-icon": "LayoutTemplate",
            cta: "Open the prompt library",
            placement: "above-start",
            disabled: he.value || m(t).ui.advOpen,
            testid: "library-demo",
            onOpen: U
          }, {
            default: Xe(() => [
              u("button", {
                class: G(["up-side-btn", { on: he.value, "has-new": !m(Bc) }]),
                "aria-label": "Prompt library",
                "aria-expanded": he.value,
                "data-testid": "library-button",
                onClick: U
              }, [
                C($, {
                  name: "LayoutTemplate",
                  size: 15
                }),
                m(Bc) ? z("", !0) : (g(), b("span", tce))
              ], 10, ece)
            ]),
            _: 1
          }, 8, ["slides", "media", "disabled"])) : z("", !0),
          p.value.length ? (g(), b("button", {
            key: 1,
            class: G(["up-side-btn", { on: De.value }]),
            title: "Pick from the board (I)",
            "aria-label": "Pick from the board",
            "aria-pressed": De.value,
            "data-testid": "eyedropper-button",
            onClick: ke[2] || (ke[2] = (xe) => m(t).toggleEyedropper(n.tool.id))
          }, [
            C($, {
              name: "Pipette",
              size: 15
            })
          ], 10, nce)) : z("", !0)
        ]),
        C(Ude, {
          onOpen: ke[3] || (ke[3] = (xe) => m(t).openStudio({ sessionId: n.tool.id }))
        }),
        p.value.length ? (g(), b("div", ice, [
          (g(!0), b(j, null, ge(y.value, (xe) => (g(), b(j, {
            key: xe.key
          }, [
            (g(!0), b(j, null, ge(ve(xe), (ct, vi) => (g(), b("div", {
              key: xe.key + ":" + ct,
              class: G(["up-ref", { "is-target": m(t).ui.refTarget === xe.key, "is-dropper": Qe(xe) && ve(xe).length >= m(Zs)(xe) }]),
              style: ce({ backgroundImage: 'url("' + m(Bt)(ct) + '")' }),
              title: _e(xe, vi),
              "data-ref-key": xe.key,
              "data-testid": "prompt-ref",
              onMouseenter: (li) => Re(ct, _e(xe, vi), li),
              onMouseleave: ke[4] || (ke[4] = (li) => ze.value = null)
            }, [
              u("button", {
                title: "Remove",
                "aria-label": "Remove " + _e(xe, vi).toLowerCase(),
                onClick: (li) => wa(xe, ct)
              }, [
                C($, {
                  name: "X",
                  size: 11
                })
              ], 8, oce),
              p.value.length > 1 && vi === 0 ? (g(), b("span", rce, E(xe.label), 1)) : z("", !0),
              Zn(ct) ? (g(), b("span", {
                key: "pulse" + Zn(ct),
                class: "up-ref-pulse",
                "aria-hidden": "true"
              })) : z("", !0),
              xa(ct) ? (g(), b("span", {
                key: "glow" + xa(ct),
                class: "up-ref-glow",
                "aria-hidden": "true",
                "data-testid": "prompt-ref-glow"
              })) : z("", !0)
            ], 46, sce))), 128)),
            ve(xe).length < m(Zs)(xe) ? (g(), b("div", ace, [
              u("button", {
                class: G(["up-drop", { "is-target": m(t).ui.refTarget === xe.key, "is-dropper": Qe(xe) }]),
                title: (ve(xe).length ? "Add another image" : "Add " + xe.label.toLowerCase()) + ". Or Shift-drag one here from the board.",
                "aria-label": ve(xe).length ? "Add another image" : "Add " + xe.label.toLowerCase(),
                "data-ref-key": xe.key,
                onClick: (ct) => Dn(xe.key)
              }, [
                C($, {
                  name: xe.kind === "video" ? "Video" : "ImagePlus",
                  size: 18
                }, null, 8, ["name"])
              ], 10, lce),
              s.value === xe.key ? (g(), Ie(Zc, {
                key: 0,
                "session-id": n.tool.id,
                label: xe.label,
                kind: xe.kind === "video" ? "video" : "image",
                onPick: (ct) => {
                  le(xe, ct), s.value = null;
                },
                onDropper: (ct) => ft(xe),
                onClose: ke[5] || (ke[5] = (ct) => s.value = null)
              }, null, 8, ["session-id", "label", "kind", "onPick", "onDropper"])) : z("", !0)
            ])) : z("", !0)
          ], 64))), 128)),
          v.value.length ? (g(), b("div", dce, [
            u("button", {
              class: G(["up-drop up-more", { on: w.value, "has-some": x.value > 0 }]),
              title: v.value.length + " more image inputs",
              "aria-label": v.value.length + " more image inputs",
              "aria-expanded": w.value,
              "data-testid": "more-refs",
              onClick: ke[6] || (ke[6] = (xe) => {
                w.value = !w.value, s.value = null;
              })
            }, [
              u("span", uce, "+" + E(v.value.length), 1),
              u("span", hce, E(x.value ? x.value + " set" : "inputs"), 1)
            ], 10, cce),
            w.value ? (g(), b("div", {
              key: 0,
              class: "up-pop up-refmore",
              onPointerdown: ke[7] || (ke[7] = Te(() => {
              }, ["stop"]))
            }, [
              ke[23] || (ke[23] = u("div", { class: "up-pop-label" }, "More inputs", -1)),
              u("div", pce, [
                (g(!0), b(j, null, ge(v.value, (xe) => (g(), b("div", {
                  key: xe.key,
                  class: "up-morecell"
                }, [
                  X(xe) ? (g(), b("div", {
                    key: 0,
                    class: G(["up-ref is-sm", { "is-target": m(t).ui.refTarget === xe.key }]),
                    style: ce({ backgroundImage: 'url("' + m(Bt)(X(xe) || "") + '")' }),
                    title: xe.label,
                    "data-ref-key": xe.key
                  }, [
                    u("button", {
                      title: "Remove",
                      onClick: (ct) => le(xe, null)
                    }, [
                      C($, {
                        name: "X",
                        size: 10
                      })
                    ], 8, mce),
                    xa(X(xe) || "") ? (g(), b("span", {
                      key: "glow" + xa(X(xe) || ""),
                      class: "up-ref-glow",
                      "aria-hidden": "true"
                    })) : z("", !0)
                  ], 14, fce)) : (g(), b("button", {
                    key: 1,
                    class: G(["up-drop is-sm", { "is-target": m(t).ui.refTarget === xe.key }]),
                    title: "Add " + xe.label.toLowerCase(),
                    "aria-label": "Add " + xe.label.toLowerCase(),
                    "data-ref-key": xe.key,
                    onClick: (ct) => {
                      w.value = !1, Dn(xe.key);
                    }
                  }, [
                    C($, {
                      name: xe.kind === "video" ? "Video" : "ImagePlus",
                      size: 15
                    }, null, 8, ["name"])
                  ], 10, gce)),
                  u("span", {
                    class: "lbl",
                    title: xe.label
                  }, E(xe.label), 9, bce)
                ]))), 128))
              ])
            ], 32)) : z("", !0),
            S.value ? (g(), Ie(Zc, {
              key: 1,
              "session-id": n.tool.id,
              label: S.value.label,
              kind: S.value.kind === "video" ? "video" : "image",
              onPick: ke[8] || (ke[8] = (xe) => {
                le(S.value, xe), s.value = null, w.value = !0;
              }),
              onDropper: ke[9] || (ke[9] = (xe) => ft(S.value)),
              onClose: ke[10] || (ke[10] = (xe) => s.value = null)
            }, null, 8, ["session-id", "label", "kind"])) : z("", !0)
          ])) : z("", !0)
        ])) : z("", !0),
        h.value ? (g(), b("textarea", {
          key: 2,
          ref_key: "textEl",
          ref: o,
          class: G(["up-text", { "is-typing": m(F).typing.value }]),
          style: ce({ height: N.value + "px" }),
          value: P.value,
          spellcheck: "false",
          placeholder: Ce.value ? "" : h.value.placeholder || "Describe what " + n.tool.name + " should make",
          readonly: m(F).held.value || m(F).typing.value,
          "data-testid": "prompt-text",
          onInput: R,
          onBlur: O,
          onKeydown: [
            tn(D, ["enter"]),
            tn(Be, ["tab"])
          ]
        }, null, 46, vce)) : (g(), b("div", {
          key: 3,
          class: G(["up-text up-text-static", { "is-target": !!p.value.length && m(t).ui.refTarget === p.value[0].key }]),
          "data-ref-key": p.value.length ? p.value[0].key : void 0
        }, E(M.value), 11, yce)),
        C(vt, {
          name: "up-ghost",
          mode: "out-in"
        }, {
          default: Xe(() => [
            Ce.value ? (g(), b("span", {
              key: Ce.value.id,
              class: G(["up-ghost", { "is-tour": Ce.value.tour }]),
              "aria-hidden": "true",
              "data-testid": "ghost-line"
            }, E(Ce.value.text), 3)) : z("", !0)
          ]),
          _: 1
        }),
        Ce.value && Ce.value.tour ? (g(), b("button", {
          key: 4,
          type: "button",
          tabindex: "-1",
          class: "up-cue is-tour",
          "data-testid": "ghost-cue",
          onClick: ke[11] || (ke[11] = (xe) => m(t).tour && m(t).tour.press && m(t).tour.press("session"))
        }, [...ke[24] || (ke[24] = [
          u("kbd", null, "Tab", -1),
          Y(" to write it in", -1)
        ])])) : Ce.value ? (g(), b("span", xce, [...ke[25] || (ke[25] = [
          u("kbd", null, "Tab", -1),
          Y(" to use this prompt", -1),
          u("span", { class: "src" }, "Featured", -1)
        ])])) : z("", !0),
        lt.value ? (g(), b("div", {
          key: 6,
          class: "up-ref-peek",
          style: ce({ left: lt.value.left + "px" }),
          "aria-hidden": "true",
          "data-testid": "prompt-ref-peek"
        }, [
          u("img", {
            src: m(Bt)(lt.value.url),
            alt: "",
            draggable: "false"
          }, null, 8, wce),
          u("span", kce, E(lt.value.label), 1)
        ], 4)) : z("", !0),
        u("div", _ce, [
          u("div", Sce, [
            u("span", Mce, [
              u("button", {
                class: G(["up-model", { on: i.value === "model" }]),
                "data-testid": "model-picker",
                onClick: ke[12] || (ke[12] = (xe) => zm("model"))
              }, [
                ke[26] || (ke[26] = u("span", { class: "lb" }, "Model", -1)),
                _t((g(), b("span", Tce, [
                  Y(E(l.value ? l.value.name : n.tool.model), 1)
                ])), [
                  [m(dl), l.value ? l.value.name : n.tool.model]
                ]),
                C($, {
                  name: "ChevronDown",
                  size: 12
                })
              ], 2),
              i.value === "model" && d.value ? (g(), b("div", {
                key: 0,
                class: "up-pop is-wide",
                onPointerdown: ke[15] || (ke[15] = Te(() => {
                }, ["stop"]))
              }, [
                u("div", Cce, E(RP.value ? "All " + Au.value + " models" : d.value.name + " models"), 1),
                u("div", Ice, [
                  C($, {
                    name: "Search",
                    size: 12
                  }),
                  _t(u("input", {
                    "onUpdate:modelValue": ke[13] || (ke[13] = (xe) => r.value = xe),
                    placeholder: "Search all " + Au.value + " models",
                    "aria-label": "Search all " + Au.value + " models",
                    "data-testid": "model-search",
                    onKeydown: ke[14] || (ke[14] = Te(() => {
                    }, ["stop"]))
                  }, null, 40, Ace), [
                    [Zt, r.value]
                  ])
                ]),
                ls.value && !r.value.trim() ? (g(), b("div", {
                  key: 0,
                  class: "up-pop-tabs",
                  role: "tablist",
                  "aria-label": d.value.name + " model groups"
                }, [
                  (g(!0), b(j, null, ge(EP.value, (xe) => (g(), b("button", {
                    key: xe,
                    role: "tab",
                    "aria-selected": ls.value === xe,
                    class: G({ on: ls.value === xe }),
                    "data-testid": xe === m(qr) ? "model-tab-pinned" : xe === m(vl) ? "model-tab-all" : void 0,
                    onClick: (ct) => ls.value = xe
                  }, E(m(pI)(xe, d.value.name)), 11, Ece))), 128))
                ], 8, Pce)) : z("", !0),
                (g(!0), b(j, null, ge(Lm.value, (xe) => (g(), b("div", {
                  key: xe.id,
                  class: G(["up-pop-item", { "is-pinned": m(t).isModelPinned(xe.id) }])
                }, [
                  u("button", {
                    class: G(["up-pop-row", { on: l.value && xe.id === l.value.id }]),
                    onClick: (ct) => $P(xe)
                  }, [
                    xe.avatar ? (g(), b("span", {
                      key: 0,
                      class: "up-pop-avatar",
                      style: ce({ backgroundImage: 'url("' + xe.avatar + '")' })
                    }, null, 4)) : z("", !0),
                    _t((g(), b("span", zce, [
                      Y(E(xe.name) + " ", 1),
                      (g(!0), b(j, null, ge(xe.labels || [], (ct) => (g(), b("span", {
                        key: ct.label,
                        class: G(["up-pop-badge", { "is-popular": ct.type === "POPULAR" }]),
                        title: ct.tooltip
                      }, E(ct.label), 11, $ce))), 128))
                    ])), [
                      [m(dl), xe.name]
                    ]),
                    u("span", Dce, [
                      Y(E(xe.tokensLabel) + " tk", 1),
                      xe.time ? (g(), b(j, { key: 0 }, [
                        Y(" · " + E(xe.time), 1)
                      ], 64)) : z("", !0)
                    ])
                  ], 10, Rce),
                  u("button", {
                    class: G(["up-pop-pin", { on: m(t).isModelPinned(xe.id) }]),
                    title: m(t).isModelPinned(xe.id) ? "Unpin" : "Pin to the top",
                    "aria-label": (m(t).isModelPinned(xe.id) ? "Unpin " : "Pin ") + xe.name,
                    "aria-pressed": m(t).isModelPinned(xe.id),
                    "data-testid": "model-pin-" + xe.id,
                    onClick: Te((ct) => m(t).toggleModelPinned(xe.id), ["stop"])
                  }, [
                    C($, {
                      name: "Pin",
                      size: 12
                    })
                  ], 10, Oce)
                ], 2))), 128)),
                ls.value === m(qr) && !r.value.trim() && !Lm.value.length ? (g(), b("div", Lce, "Nothing pinned yet. Pin a model to keep it at the top.")) : z("", !0),
                r.value.trim() && !Lm.value.length ? (g(), b("div", Bce, "No " + E(Au.value) + " model matches “" + E(r.value.trim()) + "”. Try a different search.", 1)) : z("", !0)
              ], 32)) : z("", !0),
              Px.value ? (g(), b("span", Fce, [
                C($, {
                  name: "Tokens",
                  size: 12
                }),
                Y(E(Px.value), 1)
              ])) : z("", !0)
            ]),
            _.value.length || Om.value.length || at.value ? (g(), b("span", Nce)) : z("", !0),
            (g(!0), b(j, null, ge(_.value, (xe) => {
              var ct, vi, li, hr;
              return g(), b("span", {
                key: xe.key,
                class: "up-chip-wrap"
              }, [
                u("button", {
                  class: G(["up-chip", { on: i.value === xe.key, "is-locked": $e(xe) }]),
                  title: $e(xe) ? xe.label + ": " + Ne(xe) : xe.label,
                  "aria-disabled": $e(xe) || void 0,
                  "data-testid": "chip-" + xe.key,
                  onClick: (Cn) => AP(xe)
                }, [
                  Dm(xe) ? (g(), b("img", {
                    key: 0,
                    class: "av",
                    src: Dm(xe).thumb,
                    alt: "",
                    draggable: "false",
                    onError: (Cn) => _P(Cn, xe)
                  }, null, 40, Gce)) : (g(), Ie($, {
                    key: 1,
                    name: CP(xe),
                    size: 13
                  }, null, 8, ["name"])),
                  u("span", jce, E(TP(xe)), 1),
                  $e(xe) ? (g(), Ie($, {
                    key: 2,
                    class: "lk",
                    name: "Lock",
                    size: 10
                  })) : z("", !0)
                ], 10, Uce),
                i.value === xe.key && xe.kind === "model" ? (g(), Ie(Ade, {
                  key: 0,
                  field: xe,
                  "selected-id": ($m(xe) || {}).id || null,
                  required: MP(xe),
                  onPick: (Cn) => SP(xe, Cn)
                }, null, 8, ["field", "selected-id", "required", "onPick"])) : i.value === xe.key ? (g(), b("div", {
                  key: 1,
                  class: "up-pop",
                  onPointerdown: ke[17] || (ke[17] = Te(() => {
                  }, ["stop"]))
                }, [
                  u("div", Hce, E(xe.label), 1),
                  xe.kind === "slider" ? (g(), b("div", Vce, [
                    u("input", {
                      class: "up-range",
                      type: "range",
                      min: (ct = xe.min) != null ? ct : 1,
                      max: (vi = xe.max) != null ? vi : 30,
                      step: xe.step || 1,
                      value: Ox(xe),
                      "aria-label": xe.label,
                      onInput: (Cn) => Lx(xe, Cn.target.value)
                    }, null, 40, Wce),
                    u("input", {
                      class: "up-adv-num",
                      type: "number",
                      min: (li = xe.min) != null ? li : 1,
                      max: (hr = xe.max) != null ? hr : 30,
                      step: xe.step || 1,
                      value: Ox(xe),
                      "aria-label": xe.label,
                      "data-testid": "chip-slider-num",
                      onChange: (Cn) => Lx(xe, Cn.target.value),
                      onKeydown: ke[16] || (ke[16] = Te(() => {
                      }, ["stop"]))
                    }, null, 40, qce)
                  ])) : (g(), b(j, { key: 1 }, [
                    $x(xe) ? (g(), b(j, { key: 0 }, [
                      u("button", {
                        class: "up-pop-row",
                        "data-testid": "chip-match",
                        onClick: (Cn) => zx(xe, $x(xe))
                      }, [
                        C($, {
                          name: "Proportions",
                          size: 13
                        }),
                        ke[27] || (ke[27] = u("span", { class: "up-pop-main" }, "Match media input", -1))
                      ], 8, Kce),
                      ke[28] || (ke[28] = u("div", { class: "up-pop-sep" }, null, -1))
                    ], 64)) : z("", !0),
                    (g(!0), b(j, null, ge(xe.options || [], (Cn) => (g(), b("button", {
                      key: m(xn)(Cn.value),
                      class: G(["up-pop-row", { on: m(Qi)(Cn.value, V(xe)) }]),
                      onClick: (v$e) => zx(xe, Cn)
                    }, [
                      Cn.icon ? (g(), Ie($, {
                        key: 0,
                        name: Cn.icon,
                        size: 13
                      }, null, 8, ["name"])) : z("", !0),
                      u("span", Xce, E(Cn.label), 1),
                      Dx(xe, Cn) ? (g(), b("span", Jce, E(Dx(xe, Cn)), 1)) : z("", !0)
                    ], 10, Yce))), 128))
                  ], 64))
                ], 32)) : z("", !0)
              ]);
            }), 128)),
            (g(!0), b(j, null, ge(Om.value, (xe) => (g(), b("span", {
              key: "influence:" + xe.key,
              class: "up-chip-wrap"
            }, [
              u("button", {
                class: G(["up-chip", { on: i.value === "influence:" + xe.key }]),
                title: "Influence of " + xe.label.toLowerCase() + " against the prompt",
                "data-testid": "influence-chip",
                onClick: (ct) => zm("influence:" + xe.key)
              }, [
                C($, {
                  name: xe.kind === "video" ? "Video" : "Image",
                  size: 13
                }, null, 8, ["name"]),
                u("span", Qce, E(xe.kind === "video" ? "Video" : "Image") + " " + E(id(xe)) + "%", 1)
              ], 10, Zce),
              i.value === "influence:" + xe.key ? (g(), b("div", {
                key: 0,
                class: "up-pop up-influence",
                "data-testid": "influence-pop",
                onPointerdown: ke[18] || (ke[18] = Te(() => {
                }, ["stop"]))
              }, [
                u("div", eue, "Influence" + E(Om.value.length > 1 ? ": " + xe.label : ""), 1),
                u("div", tue, [
                  u("span", {
                    style: ce({ fontSize: 11 + id(xe) / 25 + "px" })
                  }, [
                    C($, {
                      name: xe.kind === "video" ? "Video" : "Image",
                      size: 12
                    }, null, 8, ["name"]),
                    Y(E(id(xe)) + "%", 1)
                  ], 4),
                  u("span", {
                    style: ce({ fontSize: 11 + (100 - id(xe)) / 25 + "px" })
                  }, [
                    Y(E(100 - id(xe)) + "%", 1),
                    C($, {
                      name: "Type",
                      size: 12
                    })
                  ], 4)
                ]),
                u("input", {
                  class: "up-range",
                  type: "range",
                  min: "0.05",
                  max: "0.95",
                  step: "0.01",
                  value: Rx(xe),
                  "aria-label": "Influence",
                  "data-testid": "influence-range",
                  onInput: (ct) => IP(xe, ct.target.value)
                }, null, 40, nue),
                u("div", iue, "How much your " + E(xe.kind === "video" ? "video" : "image") + " shapes the result, against your prompt.", 1)
              ], 32)) : z("", !0)
            ]))), 128)),
            at.value ? (g(), b("button", {
              key: 1,
              class: G(["up-cog", { on: m(t).ui.advOpen && !he.value }]),
              title: "Advanced settings",
              "aria-label": "Advanced settings",
              "aria-expanded": m(t).ui.advOpen && !he.value,
              "data-testid": "advanced-button",
              onClick: q
            }, [
              C($, {
                name: "Settings",
                size: 15
              })
            ], 10, sue)) : z("", !0)
          ]),
          k.value ? (g(), b("span", {
            key: 0,
            class: "up-out-line",
            "data-testid": "prompt-output-line",
            title: k.value + ": from this tool's settings"
          }, E(k.value), 9, oue)) : z("", !0),
          l.value && l.value.numResults.max > 1 ? (g(), Ie(ex, {
            key: 1,
            value: tt.value,
            min: l.value.numResults.min,
            max: l.value.numResults.max,
            testid: "run-count",
            onUpdate: ke[19] || (ke[19] = (xe) => Ve({ n: xe }))
          }, null, 8, ["value", "min", "max"])) : z("", !0),
          u("span", rue, [
            xP.value && !Is.value ? (g(), b("button", {
              key: 0,
              class: "up-run is-get",
              "data-testid": "get-tokens",
              onClick: ke[20] || (ke[20] = (xe) => m(t).getTokens())
            }, [
              C($, {
                name: "Tokens",
                size: 13
              }),
              ke[29] || (ke[29] = Y("Get tokens ", -1))
            ])) : (g(), b("button", {
              key: 1,
              class: G(["up-run", { "is-busy": Is.value }]),
              disabled: Is.value || !!po.value,
              title: po.value || Is.value ? void 0 : "Run (" + m(wn)(["mod", "enter"]) + ")",
              "data-testid": "run",
              onClick: Ex
            }, [
              Is.value ? (g(), Ie($, {
                key: 0,
                name: "Loader2",
                size: 14,
                spin: ""
              })) : nn.value ? (g(), Ie($, {
                key: 1,
                name: "Lock",
                size: 13
              })) : z("", !0),
              Y(" " + E(Is.value ? "Running" : nn.value ? Ui.value : "Run"), 1)
            ], 10, aue)),
            po.value && !Is.value ? (g(), b("span", lue, E(po.value), 1)) : z("", !0)
          ])
        ])
      ], 2)
    ], 36));
  }
}), Qc = "Arial, Helvetica, sans-serif", eu = 1.22, gue = 20;
let $h;
function bue() {
  if ($h === void 0) {
    const n = typeof navigator != "undefined" && /jsdom/i.test(navigator.userAgent);
    try {
      $h = typeof document != "undefined" && !n ? document.createElement("canvas").getContext("2d") : null;
    } catch {
      $h = null;
    }
  }
  return $h;
}
function $p(n, e) {
  const t = bue();
  return t ? (t.font = "100px " + Qc, t.measureText(n).width * e / 100) : n.length * e * 0.55;
}
function vue(n, e, t) {
  const i = [];
  for (const s of (n || "").split(`
`)) {
    const o = s.split(/(\s+)/);
    let r = "";
    for (const a of o) {
      if (!a) continue;
      const l = r + a;
      for ($p(l.replace(/\s+$/, ""), e) <= t || !r.trim() ? r = l : (i.push(r.replace(/\s+$/, "")), r = /^\s+$/.test(a) ? "" : a); $p(r, e) > t && r.length > 1; ) {
        let d = r.length - 1;
        for (; d > 1 && $p(r.slice(0, d), e) > t; ) d--;
        i.push(r.slice(0, d)), r = r.slice(d);
      }
    }
    i.push(r.replace(/\s+$/, ""));
  }
  return i.length ? i : [""];
}
function yue(n, e, t) {
  const i = vue(n, e, t), s = Math.max(e * 0.6, ...i.map((o) => $p(o, e)));
  return { lines: i, width: Math.min(s, t), height: i.length * e * eu };
}
function Kr(n) {
  return Math.max(n.w, n.h);
}
function tu(n, e) {
  return { x: n.x * e.w, y: n.y * e.h };
}
function $o(n, e) {
  return { x: n.x / e.w, y: n.y / e.h };
}
function Tu(n, e) {
  const t = n.size * Kr(e), i = tu(n.pts[0], e), s = yue(n.text || "", t, Math.max(t, e.w - i.x));
  return { lines: s.lines, font: t, box: { x: i.x, y: i.y, w: s.width, h: s.height } };
}
function Sc(n, e) {
  if (n.kind === "text") return Tu(n, e).box;
  let t = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
  for (const r of n.pts) {
    const a = tu(r, e);
    t = Math.min(t, a.x), i = Math.min(i, a.y), s = Math.max(s, a.x), o = Math.max(o, a.y);
  }
  return { x: t, y: i, w: s - t, h: o - i };
}
function Yr(n, e) {
  const t = Sc(n, e);
  return { x: t.x + t.w / 2, y: t.y + t.h / 2 };
}
function Lo(n, e, t) {
  const i = Math.cos(t), s = Math.sin(t), o = n.x - e.x, r = n.y - e.y;
  return { x: e.x + o * i - r * s, y: e.y + o * s + r * i };
}
function yl(n, e, t) {
  return e.rot ? Lo(n, Yr(e, t), -e.rot) : n;
}
function Sd(n, e, t) {
  const i = t.x - e.x, s = t.y - e.y, o = i * i + s * s || 1, r = Math.max(0, Math.min(1, ((n.x - e.x) * i + (n.y - e.y) * s) / o));
  return Math.hypot(n.x - (e.x + r * i), n.y - (e.y + r * s));
}
function C0(n, e, t) {
  if (n.kind === "text") {
    const l = Tu(n, t).box, d = Math.max(l.x - e.x, 0, e.x - (l.x + l.w)), c = Math.max(l.y - e.y, 0, e.y - (l.y + l.h));
    return Math.hypot(d, c);
  }
  const i = n.pts.map((l) => tu(l, t));
  if (n.kind === "brush" || n.kind === "arrow") {
    if (i.length === 1) return Math.hypot(e.x - i[0].x, e.y - i[0].y);
    let l = 1 / 0;
    for (let d = 1; d < i.length; d++) l = Math.min(l, Sd(e, i[d - 1], i[d]));
    return l;
  }
  const s = Sc(n, t);
  if (n.kind === "box") {
    const l = [{ x: s.x, y: s.y }, { x: s.x + s.w, y: s.y }, { x: s.x + s.w, y: s.y + s.h }, { x: s.x, y: s.y + s.h }];
    return Math.min(Sd(e, l[0], l[1]), Sd(e, l[1], l[2]), Sd(e, l[2], l[3]), Sd(e, l[3], l[0]));
  }
  const o = s.x + s.w / 2, r = s.y + s.h / 2;
  let a = 1 / 0;
  for (let l = 0; l < 64; l++) {
    const d = l / 64 * Math.PI * 2;
    a = Math.min(a, Math.hypot(e.x - (o + s.w / 2 * Math.cos(d)), e.y - (r + s.h / 2 * Math.sin(d))));
  }
  return a;
}
function xue(n, e, t, i = 6) {
  const s = yl(e, n, t);
  return n.kind === "text" ? C0(n, s, t) <= i : C0(n, s, t) <= Math.max(i, n.size * Kr(t) / 2 + 4);
}
function gI(n, e, t) {
  const i = (s) => ({ x: s.x + e, y: s.y + t });
  return { ...n, pts: n.pts.map(i), erase: n.erase ? n.erase.map((s) => ({ ...s, pts: s.pts.map(i) })) : void 0 };
}
function wue(n, e, t, i, s) {
  const o = Yr(n, s), r = n.rot ? Lo(e, o, -n.rot) : e, a = (f) => {
    const p = tu(f, s);
    return $o({ x: r.x + (p.x - r.x) * t, y: r.y + (p.y - r.y) * i }, s);
  };
  let l;
  if (n.kind === "text") {
    const f = Math.max(0.05, i), p = tu(n.pts[0], s);
    l = { ...n, size: n.size * f, pts: [$o({ x: r.x + (p.x - r.x) * f, y: r.y + (p.y - r.y) * f }, s)] };
  } else
    l = { ...n, pts: n.pts.map(a), erase: n.erase ? n.erase.map((f) => ({ ...f, pts: f.pts.map(a) })) : void 0 };
  if (!n.rot) return l;
  const d = Yr(l, s), c = Lo(r, o, n.rot), h = Lo(r, d, n.rot);
  return gI(l, (c.x - h.x) / s.w, (c.y - h.y) / s.h);
}
function kue(n, e, t, i, s) {
  if (n.kind === "text") return !1;
  const o = yl(e, n, s), r = yl(t, n, s), a = i / 2 + n.size * Kr(s) / 2 + 1, l = Math.max(1, Math.ceil(Math.hypot(r.x - o.x, r.y - o.y) / 3));
  for (let d = 0; d <= l; d++) {
    const c = d / l;
    if (C0(n, { x: o.x + (r.x - o.x) * c, y: o.y + (r.y - o.y) * c }, s) <= a) return !0;
  }
  return !1;
}
function _ue(n, e) {
  return n.x < e.x + e.w && n.x + n.w > e.x && n.y < e.y + e.h && n.y + n.h > e.y;
}
const pb = 1e3, bI = 0.1;
function I0(n) {
  return n.kind === "text" || n.opacity == null ? 1 : Math.max(bI, Math.min(1, n.opacity));
}
function vI(n, e) {
  const t = Math.round(pb * (e || 3) / (n || 4));
  return { w: pb, h: t, long: Math.max(pb, t) };
}
function ui(n, e) {
  return n * e.w;
}
function hi(n, e) {
  return n * e.h;
}
function zf(n, e) {
  if (!n.length) return "";
  if (n.length < 3) return "M" + ui(n[0].x, e) + " " + hi(n[0].y, e) + n.slice(1).map((s) => " L" + ui(s.x, e) + " " + hi(s.y, e)).join("") + (n.length === 1 ? " l0.1 0" : "");
  let t = "M" + ui(n[0].x, e) + " " + hi(n[0].y, e);
  for (let s = 1; s < n.length - 1; s++) {
    const o = (ui(n[s].x, e) + ui(n[s + 1].x, e)) / 2, r = (hi(n[s].y, e) + hi(n[s + 1].y, e)) / 2;
    t += " Q" + ui(n[s].x, e) + " " + hi(n[s].y, e) + " " + o + " " + r;
  }
  const i = n[n.length - 1];
  return t + " L" + ui(i.x, e) + " " + hi(i.y, e);
}
function nx(n, e) {
  return Math.max(1.5, n.size * e.long);
}
function yI(n, e) {
  return Math.max(1.5, n * e.long);
}
function A0(n, e) {
  const t = n.pts[0], i = n.pts[n.pts.length - 1], s = ui(t.x, e), o = hi(t.y, e), r = ui(i.x, e), a = hi(i.y, e), l = Math.atan2(a - o, r - s), d = Math.max(0.012 * e.long, nx(n, e) * 3.5), c = r - Math.cos(l) * d, h = a - Math.sin(l) * d, f = -Math.sin(l) * (d / 2), p = Math.cos(l) * (d / 2), y = r - Math.cos(l) * (d / 2), v = a - Math.sin(l) * (d / 2);
  return { line: "M" + s + " " + o + " L" + y + " " + v, head: r + "," + a + " " + (c + f) + "," + (h + p) + " " + (c - f) + "," + (h - p) };
}
function Us(n, e) {
  const t = n.pts[0], i = n.pts[n.pts.length - 1];
  return { x: ui(Math.min(t.x, i.x), e), y: hi(Math.min(t.y, i.y), e), width: Math.abs(ui(i.x, e) - ui(t.x, e)), height: Math.abs(hi(i.y, e) - hi(t.y, e)) };
}
function xI(n, e) {
  if (!n.rot) return;
  const t = n.kind === "text" ? Tu(n, e).box : null;
  let i, s;
  if (t)
    i = t.x + t.w / 2, s = t.y + t.h / 2;
  else {
    const o = n.pts.map((a) => ui(a.x, e)), r = n.pts.map((a) => hi(a.y, e));
    i = (Math.min(...o) + Math.max(...o)) / 2, s = (Math.min(...r) + Math.max(...r)) / 2;
  }
  return "rotate(" + n.rot * 180 / Math.PI + " " + i + " " + s + ")";
}
function Lr(n, e) {
  const t = Tu(n, e);
  return { x: t.box.x, y: t.box.y, font: t.font, lines: t.lines };
}
function wI(n, e) {
  return n ? e * eu : e * (eu - 1) / 2;
}
function kI(n, e = !1) {
  return (e ? 0.022 : 0.026) * n.long;
}
function Jd(n, e) {
  return { cx: ui(n.x, e), cy: hi(n.y, e) };
}
const Sue = "#7c4dff", Mue = "#ffffff";
function Oa(n) {
  return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function rn(n) {
  return String(Math.round(n * 100) / 100);
}
function Tue(n, e, t, i, s) {
  const o = vI(e, t), r = [], a = [];
  n.strokes.forEach((d, c) => {
    const h = "e" + c, f = !!(d.erase && d.erase.length);
    if (f) {
      const S = d.erase.map((M) => '<path d="' + zf(M.pts, o) + '" fill="none" stroke="#000" stroke-width="' + rn(yI(M.size, o)) + '" stroke-linecap="round" stroke-linejoin="round"/>').join("");
      a.push('<mask id="' + h + '" maskUnits="userSpaceOnUse" x="' + -o.w + '" y="' + -o.h + '" width="' + o.w * 3 + '" height="' + o.h * 3 + '"><rect x="' + -o.w + '" y="' + -o.h + '" width="' + o.w * 3 + '" height="' + o.h * 3 + '" fill="#fff"/>' + S + "</mask>");
    }
    const p = xI(d, o);
    let y = "";
    if (d.kind === "text") {
      const S = Lr(d, o), M = S.lines.map((_, T) => '<tspan x="' + rn(S.x) + '" dy="' + rn(wI(T, S.font)) + '">' + Oa(_ || " ") + "</tspan>").join("");
      y = '<text x="' + rn(S.x) + '" y="' + rn(S.y) + '" font-size="' + rn(S.font) + '" fill="' + Oa(d.color) + '" font-family="' + Oa(Qc) + '" dominant-baseline="text-before-edge">' + M + "</text>";
    } else {
      const S = 'fill="none" stroke="' + Oa(d.color) + '" stroke-width="' + rn(nx(d, o)) + '" stroke-linecap="round" stroke-linejoin="round"';
      if (d.kind === "brush") y = '<path d="' + zf(d.pts, o) + '" ' + S + "/>";
      else if (d.kind === "arrow") {
        const M = A0(d, o);
        y = '<path d="' + M.line + '" ' + S + '/><polygon points="' + M.head + '" fill="' + Oa(d.color) + '"/>';
      } else if (d.kind === "box") {
        const M = Us(d, o);
        y = '<rect x="' + rn(M.x) + '" y="' + rn(M.y) + '" width="' + rn(M.width) + '" height="' + rn(M.height) + '" ' + S + "/>";
      } else if (d.kind === "ellipse") {
        const M = Us(d, o);
        y = '<ellipse cx="' + rn(M.x + M.width / 2) + '" cy="' + rn(M.y + M.height / 2) + '" rx="' + rn(M.width / 2) + '" ry="' + rn(M.height / 2) + '" ' + S + "/>";
      }
    }
    const v = f ? '<g mask="url(#' + h + ')">' + y + "</g>" : y, x = I0(d), w = x < 1 ? '<g opacity="' + rn(x) + '">' + v + "</g>" : v;
    r.push(p ? '<g transform="' + p + '">' + w + "</g>" : w);
  });
  const l = kI(o);
  return n.pins.forEach((d, c) => {
    const h = Jd(d, o);
    r.push('<circle cx="' + rn(h.cx) + '" cy="' + rn(h.cy) + '" r="' + rn(l) + '" fill="' + Sue + '" stroke="#fff" stroke-width="2.5"/><text x="' + rn(h.cx) + '" y="' + rn(h.cy) + '" font-size="' + rn(l * 1.05) + '" fill="' + Mue + '" font-family="' + Oa(Qc) + '" font-weight="700" text-anchor="middle" dominant-baseline="central">' + (c + 1) + "</text>");
  }), '<svg xmlns="http://www.w3.org/2000/svg" width="' + i + '" height="' + s + '" viewBox="0 0 ' + o.w + " " + o.h + '" preserveAspectRatio="none">' + (a.length ? "<defs>" + a.join("") + "</defs>" : "") + r.join("") + "</svg>";
}
const Cue = ["viewBox", "preserveAspectRatio"], Iue = ["id", "x", "y", "width", "height"], Aue = ["x", "y", "width", "height"], Pue = ["d", "stroke-width"], Eue = ["data-stroke", "transform", "opacity"], Rue = ["mask"], zue = ["x", "y", "font-size", "fill", "font-family"], $ue = ["x", "dy"], Due = ["stroke", "stroke-width"], Oue = ["d"], Lue = ["d"], Bue = ["points", "fill"], Fue = ["cx", "cy", "rx", "ry"], Nue = ["cx", "cy", "r"], Uue = ["x", "y", "font-size"], xm = /* @__PURE__ */ Pe({
  __name: "MarksSvg",
  props: {
    marks: {},
    w: {},
    h: {},
    live: { default: null },
    small: { type: Boolean, default: !1 },
    hide: { default: () => [] },
    fit: { default: "slice" }
  },
  setup(n) {
    const e = n, t = AE(), i = I(() => vI(e.w, e.h)), s = I(() => {
      const r = e.live ? [...e.marks.strokes, e.live] : e.marks.strokes;
      return e.hide.length ? r.filter((a) => !e.hide.includes(a.id)) : r;
    }), o = I(() => kI(i.value, e.small));
    return (r, a) => (g(), b("svg", {
      class: "sv-marks",
      viewBox: "0 0 " + i.value.w + " " + i.value.h,
      preserveAspectRatio: n.fit === "slice" ? "xMidYMid slice" : "none",
      "aria-hidden": "true"
    }, [
      u("defs", null, [
        (g(!0), b(j, null, ge(s.value.filter((l) => l.erase && l.erase.length), (l) => (g(), b("mask", {
          id: m(t) + "-" + l.id,
          key: l.id,
          maskUnits: "userSpaceOnUse",
          x: -i.value.w,
          y: -i.value.h,
          width: i.value.w * 3,
          height: i.value.h * 3
        }, [
          u("rect", {
            x: -i.value.w,
            y: -i.value.h,
            width: i.value.w * 3,
            height: i.value.h * 3,
            fill: "#fff"
          }, null, 8, Aue),
          (g(!0), b(j, null, ge(l.erase, (d, c) => (g(), b("path", {
            key: c,
            d: m(zf)(d.pts, i.value),
            fill: "none",
            stroke: "#000",
            "stroke-width": m(yI)(d.size, i.value),
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Pue))), 128))
        ], 8, Iue))), 128))
      ]),
      (g(!0), b(j, null, ge(s.value, (l) => (g(), b("g", {
        key: l.id,
        "data-stroke": l.id,
        class: "sv-stroke",
        transform: m(xI)(l, i.value),
        opacity: m(I0)(l) < 1 ? m(I0)(l) : void 0
      }, [
        u("g", {
          mask: l.erase && l.erase.length ? "url(#" + m(t) + "-" + l.id + ")" : void 0
        }, [
          l.kind === "text" ? (g(), b("text", {
            key: 0,
            x: m(Lr)(l, i.value).x,
            y: m(Lr)(l, i.value).y,
            "font-size": m(Lr)(l, i.value).font,
            fill: l.color,
            "font-family": m(Qc),
            "dominant-baseline": "text-before-edge"
          }, [
            (g(!0), b(j, null, ge(m(Lr)(l, i.value).lines, (d, c) => (g(), b("tspan", {
              key: c,
              x: m(Lr)(l, i.value).x,
              dy: m(wI)(c, m(Lr)(l, i.value).font)
            }, E(d || " "), 9, $ue))), 128))
          ], 8, zue)) : (g(), b("g", {
            key: 1,
            fill: "none",
            stroke: l.color,
            "stroke-width": m(nx)(l, i.value),
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            l.kind === "brush" ? (g(), b("path", {
              key: 0,
              d: m(zf)(l.pts, i.value)
            }, null, 8, Oue)) : l.kind === "arrow" ? (g(), b(j, { key: 1 }, [
              u("path", {
                d: m(A0)(l, i.value).line
              }, null, 8, Lue),
              u("polygon", {
                points: m(A0)(l, i.value).head,
                fill: l.color,
                stroke: "none"
              }, null, 8, Bue)
            ], 64)) : l.kind === "box" ? (g(), b("rect", H5({
              key: 2,
              ref_for: !0
            }, m(Us)(l, i.value)), null, 16)) : l.kind === "ellipse" ? (g(), b("ellipse", {
              key: 3,
              cx: m(Us)(l, i.value).x + m(Us)(l, i.value).width / 2,
              cy: m(Us)(l, i.value).y + m(Us)(l, i.value).height / 2,
              rx: m(Us)(l, i.value).width / 2,
              ry: m(Us)(l, i.value).height / 2
            }, null, 8, Fue)) : z("", !0)
          ], 8, Due))
        ], 8, Rue)
      ], 8, Eue))), 128)),
      (g(!0), b(j, null, ge(n.marks.pins, (l, d) => (g(), b("g", {
        key: l.id,
        class: "sv-pin-mark"
      }, [
        u("circle", {
          cx: m(Jd)(l, i.value).cx,
          cy: m(Jd)(l, i.value).cy,
          r: o.value
        }, null, 8, Nue),
        n.small ? z("", !0) : (g(), b("text", {
          key: 0,
          x: m(Jd)(l, i.value).cx,
          y: m(Jd)(l, i.value).cy,
          "font-size": o.value * 1.05,
          "text-anchor": "middle",
          "dominant-baseline": "central"
        }, E(d + 1), 9, Uue))
      ]))), 128))
    ], 8, Cue));
  }
});
function _I(n, e) {
  const t = /* @__PURE__ */ new Set([e]);
  let i = e;
  for (; ; ) {
    const s = n(i);
    if (!s || t.has(s)) return i;
    t.add(s), i = s;
  }
}
function Gue(n, e, t) {
  if (!t) return [];
  const i = /* @__PURE__ */ new Map(), s = (r) => {
    let a = i.get(r);
    return a === void 0 && (a = _I(e, r), i.set(r, a)), a;
  }, o = s(t);
  return n.filter((r) => s(r.id) === o).sort((r, a) => a.createdAt - r.createdAt);
}
function jue(n, e) {
  const t = /* @__PURE__ */ new Map(), i = n.filter((s) => s.id !== e).sort((s, o) => s.createdAt - o.createdAt);
  return e && n.some((s) => s.id === e) && t.set(e, "Original"), i.forEach((s, o) => t.set(s.id, "v" + (o + 1))), t;
}
function Dh(n, e, t) {
  return n.includes(e) ? { queue: n, full: !1 } : n.length >= t ? { queue: n, full: !0 } : { queue: [...n, e], full: !1 };
}
function L_(n, e) {
  return n.filter((t) => t !== e);
}
function Oh(n, e, t) {
  const i = n.filter((s) => s !== e);
  return i.length ? { queue: [e, ...i.slice(1)].slice(0, Math.max(1, t)), full: !1 } : { queue: [e], full: !1 };
}
function Hue(n, e) {
  return Math.min(n.length, Math.max(0, e));
}
function Vue() {
  const n = [];
  n.push({ x: 0, z: 0, y: 0, w: 64, d: 44, h: 9, rot: 0 }), n.push({ x: 0, z: 0, y: 9, w: 58, d: 38, h: 3, rot: 0 });
  for (let e = 0; e < 15; e++) n.push({ x: -13, z: -2, y: 12 + e * 5.2, w: 17, d: 17, h: 5.2, rot: e * 0.045 });
  for (let e = 0; e < 12; e++) n.push({ x: 14, z: 5, y: 12 + e * 5.2, w: 15, d: 15, h: 5.2, rot: -e * 0.06 });
  return n.push({ x: 0.5, z: 1.5, y: 58, w: 12, d: 5, h: 3.6, rot: 0.12 }), n.push({ x: -52, z: -40, y: 0, w: 26, d: 22, h: 16, rot: 0 }), n.push({ x: 50, z: -38, y: 0, w: 24, d: 26, h: 22, rot: 0 }), n.push({ x: -50, z: 42, y: 0, w: 22, d: 18, h: 11, rot: 0 }), n.push({ x: 54, z: 40, y: 0, w: 20, d: 20, h: 28, rot: 0 }), n.push({ x: 0, z: 0, y: -0.4, w: 180, d: 150, h: 0.4, rot: 0 }), n;
}
function La(n) {
  return String(Math.round(n * 1e3) / 1e3);
}
function SI() {
  const n = ["# Bonneville Tower massing (sample)", "o massing"];
  let e = 1, t = 1;
  for (const i of Vue()) {
    const s = Math.cos(i.rot), o = Math.sin(i.rot), r = (c, h, f) => {
      const p = c * i.w / 2, y = f * i.d / 2;
      return [i.x + p * s - y * o, h, i.z + p * o + y * s];
    }, a = i.y, l = i.y + i.h, d = [
      { pts: [r(-1, l, -1), r(-1, l, 1), r(1, l, 1), r(1, l, -1)], nrm: [0, 1, 0] },
      { pts: [r(-1, a, -1), r(1, a, -1), r(1, a, 1), r(-1, a, 1)], nrm: [0, -1, 0] },
      { pts: [r(-1, a, -1), r(-1, l, -1), r(1, l, -1), r(1, a, -1)], nrm: [o, 0, -s] },
      { pts: [r(1, a, -1), r(1, l, -1), r(1, l, 1), r(1, a, 1)], nrm: [s, 0, o] },
      { pts: [r(1, a, 1), r(1, l, 1), r(-1, l, 1), r(-1, a, 1)], nrm: [-o, 0, s] },
      { pts: [r(-1, a, 1), r(-1, l, 1), r(-1, l, -1), r(-1, a, -1)], nrm: [-s, 0, -o] }
    ];
    for (const c of d) {
      for (const h of c.pts) n.push("v " + La(h[0]) + " " + La(h[1]) + " " + La(h[2]));
      n.push("vn " + La(c.nrm[0]) + " " + La(c.nrm[1]) + " " + La(c.nrm[2])), n.push("f " + [0, 1, 2, 3].map((h) => e + h + "//" + t).join(" ")), e += 4, t += 1;
    }
  }
  return n.join(`
`) + `
`;
}
const Wue = 800;
function MI(n, e, t = Wue) {
  const i = Math.min(1, t / Math.max(n || 1, e || 1));
  return { w: Math.max(1, Math.round((n || 1) * i)), h: Math.max(1, Math.round((e || 1) * i)) };
}
function TI(n, e) {
  return new Promise((t, i) => {
    const s = new Image();
    e && (s.crossOrigin = "anonymous"), s.onload = () => t(s), s.onerror = () => i(new Error("The picture couldn't be read.")), s.src = n;
  });
}
function que(n) {
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n);
}
async function ix(n, e, t, i, s, o) {
  const r = await TI(que(Tue(e, t, i, s, o)), !1);
  n.drawImage(r, 0, 0, s, o);
}
async function Kue(n, e, t) {
  const i = MI(e, t), s = document.createElement("canvas");
  s.width = i.w, s.height = i.h;
  const o = s.getContext("2d");
  if (!o) throw new Error("The annotations couldn't be drawn.");
  return await ix(o, n, e, t, i.w, i.h), s.toDataURL("image/png").split(",")[1] || "";
}
async function Yue(n, e, t, i, s = 640) {
  const o = MI(t, i, s), r = document.createElement("canvas");
  r.width = o.w, r.height = o.h;
  const a = r.getContext("2d");
  if (!a) throw new Error("The annotations couldn't be drawn.");
  try {
    const l = await TI(n, !n.startsWith("data:") && !n.startsWith("blob:"));
    a.drawImage(l, 0, 0, o.w, o.h);
  } catch {
    a.fillStyle = "#808080", a.fillRect(0, 0, o.w, o.h);
  }
  return await ix(a, e, t, i, o.w, o.h), r.toDataURL("image/jpeg", 0.85);
}
const B_ = { prompt: "generate", threed: "generate", edit: "edit" };
function fb(n) {
  return n !== "prompt" && n !== "threed";
}
const xl = {
  threed: { text: "3D view", icon: "Box" },
  upload: { text: "Brought in", icon: "Upload" },
  board: { text: "From the board", icon: "LayoutGrid" },
  library: { text: "From your Library", icon: "Library" },
  tool: { text: "Made here", icon: "Wand2" }
};
function Md() {
  return { strokes: [], pins: [] };
}
function Zd(n) {
  return !!n && (n.strokes.length > 0 || n.pins.length > 0);
}
function CI(n) {
  return !!n && !!n.area && n.area.some((e) => !e.cut);
}
function mb(n) {
  return Zd(n) || CI(n);
}
function Xue(n) {
  return n.kind === "object" ? { ...n } : { ...n, pts: n.pts.slice() };
}
function Td(n) {
  const e = {
    strokes: n.strokes.map((t) => ({ ...t, pts: t.pts.slice(), erase: t.erase ? t.erase.map((i) => ({ ...i, pts: i.pts.slice() })) : void 0 })),
    pins: n.pins.map((t) => ({ ...t }))
  };
  return n.area && n.area.length && (e.area = n.area.map(Xue)), e;
}
function Jue(n, e) {
  return JSON.stringify(n) === JSON.stringify(e);
}
const II = [
  { id: "upscale", label: "Upscale", icon: "Maximize2", hint: "More pixels and detail, for print and large screens" },
  { id: "resize", label: "Resize", icon: "Crop", hint: "Crop to a shape, or expand past the edges" },
  { id: "background", label: "Background", icon: "Layers", hint: "Remove it, replace it, or adjust it apart from the subject" },
  { id: "adjust", label: "Adjust", icon: "SlidersHorizontal", hint: "Light, colour, grading, grain and rotation, live" },
  { id: "skin", label: "Improve people", icon: "Smile", hint: "Natural skin, light and detail on the people" },
  { id: "camera", label: "Change camera", icon: "Rotate3d", hint: "See the scene from another angle" },
  { id: "relight", label: "Relight", icon: "Lightbulb", hint: "New light: direction, colour and mood" }
];
function sx(n) {
  return n && II.find((e) => e.id === n) || null;
}
const gb = {
  edit: "Edit",
  erase: "Erase",
  upscale: "Upscale",
  removebg: "Remove background",
  replacebg: "Replace background",
  expand: "Expand",
  skin: "Improve people",
  camera: "Change camera",
  relight: "Relight",
  select: "Find objects",
  draw: "Draw edit",
  comment: "Annotate edit",
  threed: "3D edit"
}, F_ = {
  removebg: ["w4WjiaPJ8YlnXqalLseS"],
  erase: ["n830hmDOmMafIztf5qZs"],
  upscale: ["n5NO4aX5MGjmfEVg0KdE", "ykyBMjS0ISJeWy9jOqhm", "QCpMJ7Dw9Wa1956Sh6Hw", "QejUMwHU49HRMWwpqhkD", "n4H8sQlLxTc1aeYJxdiv"]
}, Zue = {
  removebg: /^remove background$/i,
  erase: /person and object remover|eraser|^erase$/i,
  expand: /^expand$/i,
  camera: /^change camera|multiple angles/i,
  select: /^find objects|select objects/i
}, AI = /^nano banana pro\b/i, Que = [
  "4CJEOIwhf2WhGq2K0eHl",
  // Nano Banana 2.1
  "6BJyvazKHGTilS1yWk76",
  // Nano Banana 2
  "VpkLvmqERLkoU2vBNTJ7",
  // Nano Banana 2 Lite
  "eILT27MJkTwxnVSPQP2x",
  // Nano Banana Pro
  "s9ShIto8LPgdOSImFC39",
  // ChatGPT Image 2.5 Sunburst
  "50XKlkMz7r9kmipyspRQ",
  // ChatGPT Image 2.5 Flare
  "YuklxMGHwrC50w7yjLBm",
  // ChatGPT Image 2.0 (Krea's ChatGPT 2)
  "B9nbLi2HgM7XHeaBoOJD",
  // Seedream V5 Pro
  "zzhnCi7Bow9ekkRXy5pP",
  // Luma UNI-1
  "gYjYjnyvD6hFxcdl1mul",
  // Luma UNI-1 Max
  "UNuq3Ia9Wlos2DWSFrlv",
  // Flux 2 Klein 4B
  "9rnhLVpVce28QPnjYiQ3",
  // ChatGPT Image Edit 1.5 (Krea's ChatGPT 1.5)
  "JcDKjRIyFolGJVEOIgya",
  // Flux 3 Image
  "7XrsYAALFZVLveefN5DL",
  // Flux 2 Pro
  "BfRqukmRHNORna2upyyt",
  // Flux 2 Flex
  "vMzpgBA14pAFuBgU8yby",
  // Flux 2 Max
  "2oYW3kqy1XetTh4PURbF",
  // Qwen Edit 2511 (Krea's Qwen Image Plus)
  "2aIZvnBeZYdY4ldYEdGO",
  // Nano Banana Edit (Krea's Nano Banana)
  "CzrPq1r9zRrEb8hsES2e",
  // Qwen Image Edit
  "bKkjGeP6wjLsl1314ybn",
  // Flux Kontext Pro
  "Wee8kviizptLQp8DkEKn"
  // Flux Kontext Max
];
function Ul(n) {
  return !!PI(n);
}
function PI(n) {
  return oo(n).find((e) => !!(e.raw && e.raw.display && e.raw.display.hasInpainting)) || null;
}
function ehe(n) {
  const e = /* @__PURE__ */ new Set(), t = [];
  for (const i of [...n.tools || [], ...n.kits.flatMap((s) => s.models)])
    e.has(i.id) || (e.add(i.id), t.push(i));
  return t;
}
function N_(n) {
  return oo(n).length > 0 && !n.fields.some((e) => e.kind === "video" && e.placement === "reference");
}
function the(n, e, t) {
  const i = Que.map((s) => e.find((o) => o.id === s)).filter((s) => !!s && Mf(s) && !Ul(s));
  return i.length ? i : QC(n, "edit", t).filter((s) => !Ul(s));
}
function nhe(n, e, t) {
  if (e === "prompt" || e === "threed") return QC(n, e, t);
  const i = ehe(n), s = i.filter((d) => d.boardTool === e);
  if (e === "edit" || e === "replacebg" || e === "skin" || e === "relight") {
    const d = the(n, i, t), c = d.find((f) => AI.test(f.name)), h = c ? [c, ...d.filter((f) => f !== c)] : d;
    return e === "relight" ? h.slice(0, 1) : h;
  }
  if (e === "upscale") {
    const d = n.kits.find((p) => p.id === "upscale"), c = (d ? d.models : []).filter((p) => N_(p) && Mf(p)), h = (F_.upscale || []).map((p) => i.find((y) => y.id === p)).filter((p) => !!p && N_(p)), f = [];
    for (const p of [...s, ...h, ...c]) f.some((y) => y.id === p.id) || f.push(p);
    return f;
  }
  const o = F_[e] || [], r = Zue[e], a = [], l = [...s, ...o.map((d) => i.find((c) => c.id === d)).filter((d) => !!d), ...r ? i.filter((d) => r.test(d.name)) : []];
  for (const d of l)
    !a.some((c) => c.id === d.id) && Mf(d) && a.push(d);
  return e === "erase" ? a.filter(Ul).concat(a.filter((d) => !Ul(d))) : a;
}
function ihe(n, e, t) {
  return n.fields.find((i) => i.raw && i.raw.boardKey === e) || n.fields.find((i) => i.key === e) || t && n.fields.find((i) => t.test(i.label)) || null;
}
function U_(n, e, t = {}) {
  const i = {};
  for (const [s, o] of Object.entries(e)) {
    if (o === void 0) continue;
    const r = ihe(n, s, t[s]);
    r && (i[r.key] = o);
  }
  return i;
}
function she(n, e) {
  const t = [], i = n.trim();
  return e.erase ? t.push(i ? "Remove what is marked in magenta from image 1, and put this in its place, matching the surroundings: " + i : "Remove what is marked in magenta from image 1, and fill the space with what would naturally be behind it, matching the surroundings.") : i && t.push(i), e.guide ? t.push(e.erase ? "Image 2 is image 1 with the area to remove marked in magenta; it is a guide only." : "Image 1 is the image to edit. Image 2 is the same image with the area to change marked in magenta: make the change only inside that area of image 1, and keep the rest of image 1 as it is. Image 2 is a guide only: the result is image 1, with no magenta marking.") : t.push("The area to change is marked in magenta (a tinted wash with an outline): make the change only there, keep the rest of the image as it is, and remove the magenta marking from the result."), t.join(`
`);
}
function ohe(n, e) {
  return e <= 1 ? "Image " + n + " is a reference." : "Images " + n + (e === 2 ? " and " : " to ") + (n + e - 1) + " are references.";
}
function rhe(n, e) {
  const t = n.trim().replace(/\.$/, "");
  return "Replace the background of image 1 with " + (e ? "the background in image 2" + (t ? " (" + t + ")" : "") : t || "a clean, natural background that suits the subject") + ". Keep the subject exactly as it is: its shape, edges, colours and the light on it, and its place and size in the frame. Match the new background's perspective and horizon to the camera, and its light to the light on the subject, with natural contact shadows.";
}
const bb = [
  { id: "faithful", label: "Faithful", hint: "Keeps every feature; refines only the skin" },
  { id: "flexible", label: "Flexible", hint: "A balance of fidelity and polish" },
  { id: "creative", label: "Creative", hint: "Polishes freely; people stay recognisable" }
], ahe = [
  { id: "skin", label: "Natural skin" },
  { id: "everything", label: "Skin, eyes, hair and clothes" },
  { id: "light", label: "Better light on faces" },
  { id: "real", label: "Make them look real" },
  { id: "nomakeup", label: "No makeup" }
];
function lhe() {
  return { version: "faithful", focus: "skin", sharpen: 30, grain: 0 };
}
function dhe(n) {
  const e = ["Retouch the people in image 1 as a high-end photo retoucher would."];
  e.push(n.version === "faithful" ? "Keep each person's identity, features and expression exactly as they are, and change nothing about them except what follows." : n.version === "creative" ? "Improve them freely, as a beauty retoucher would, while keeping each person recognisable." : "Keep each person's identity and expression, and polish the skin and details with a light hand.");
  const t = {
    skin: "Give the skin natural texture and pores, even out blotches and blemishes, and remove any plastic, airbrushed look.",
    everything: "Give the skin natural texture and pores, and refine the eyes, hair, teeth and the detail in clothing.",
    light: "Improve the light on the faces: soft, flattering and natural, with gentle shadows.",
    real: "Make the people look like a real photograph of real people: real skin texture, natural imperfections and realistic hair, nothing rendered or doll-like.",
    nomakeup: "Remove all makeup, leaving natural bare skin."
  };
  return e.push(t[n.focus]), n.sharpen >= 60 ? e.push("Render fine detail crisply.") : n.sharpen >= 25 && e.push("Keep detail sharp."), n.grain >= 50 ? e.push("Add visible fine film grain.") : n.grain >= 15 && e.push("Add a subtle, natural photographic grain."), e.push("Keep everything else in the picture as it is: the background, the composition, the colours and the camera angle."), e.join(" ");
}
const che = 8192, Ba = /* @__PURE__ */ new Map();
function uhe(n) {
  return n.startsWith("blob:") || n.startsWith("data:") ? n : n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
}
function si(n) {
  let e = Ba.get(n);
  if (!e && (e = (async () => {
    const t = await fetch(uhe(n), { mode: "cors", credentials: "omit" });
    if (!t.ok) throw new Error("The picture couldn't be read (" + t.status + ").");
    return createImageBitmap(await t.blob());
  })(), Ba.set(n, e), e.catch(() => Ba.delete(n)), Ba.size > 12)) {
    const t = Ba.keys().next().value;
    t !== void 0 && t !== n && Ba.delete(t);
  }
  return e;
}
function Rn(n, e) {
  const t = document.createElement("canvas");
  return t.width = Math.max(1, Math.round(n)), t.height = Math.max(1, Math.round(e)), t;
}
function zn(n) {
  const e = n.getContext("2d", { willReadFrequently: !1 });
  if (!e) throw new Error("The browser couldn't draw the picture.");
  return e;
}
function vb(n, e = !1) {
  return new Promise((t, i) => {
    n.toBlob((s) => s ? t(s) : i(new Error("The picture couldn't be saved.")), e ? "image/png" : "image/jpeg", 0.94);
  });
}
function yb(n, e) {
  const t = n.type === "image/png" ? "png" : "jpg";
  return new File([n], e.replace(/[^a-z0-9-]+/gi, "-").toLowerCase() + "." + t, { type: n.type });
}
function wl(n, e, t = che) {
  const i = Math.min(1, t / Math.max(n, e));
  return { w: Math.max(1, Math.round(n * i)), h: Math.max(1, Math.round(e * i)) };
}
function hhe(n, e, t) {
  const i = e.x * n.width, s = e.y * n.height, o = e.w * n.width, r = e.h * n.height, a = wl(o, r), l = Rn(a.w, a.h), d = zn(l);
  return d.imageSmoothingQuality = "high", d.drawImage(n, i, s, o, r, 0, 0, a.w, a.h), l;
}
function EI(n) {
  const e = Math.min(1, 256 / Math.max(n.width, n.height)), t = Rn(n.width * e, n.height * e), i = zn(t);
  i.drawImage(n, 0, 0, t.width, t.height);
  const s = i.getImageData(0, 0, t.width, t.height).data;
  for (let o = 3; o < s.length; o += 4) if (s[o] < 250) return !0;
  return !1;
}
function phe(n, e = 256) {
  const t = Math.min(1, e / Math.max(n.width, n.height)), i = Rn(n.width * t, n.height * t), s = zn(i);
  return s.drawImage(n, 0, 0, i.width, i.height), s.getImageData(0, 0, i.width, i.height).data;
}
function RI(n, e) {
  const t = Rn(n.width, n.height), i = zn(t);
  return e && (i.fillStyle = e, i.fillRect(0, 0, t.width, t.height)), i.drawImage(n, 0, 0), t;
}
function Lh() {
  return { target: "background", blur: 0, grayscale: 0, sepia: 0, brightness: 100, contrast: 100, saturation: 100 };
}
function nu(n) {
  return n.blur > 0 || n.grayscale > 0 || n.sepia > 0 || n.brightness !== 100 || n.contrast !== 100 || n.saturation !== 100;
}
function G_(n, e = 1) {
  const t = [];
  return n.blur > 0 && t.push("blur(" + (n.blur * e).toFixed(2) + "px)"), n.grayscale > 0 && t.push("grayscale(" + n.grayscale + "%)"), n.sepia > 0 && t.push("sepia(" + n.sepia + "%)"), n.brightness !== 100 && t.push("brightness(" + n.brightness + "%)"), n.contrast !== 100 && t.push("contrast(" + n.contrast + "%)"), n.saturation !== 100 && t.push("saturate(" + n.saturation + "%)"), t.join(" ") || "none";
}
function zI(n, e, t, i = n.width, s = n.height) {
  const o = i / n.width, r = Rn(i, s), a = zn(r), l = Rn(i, s), d = zn(l);
  return d.drawImage(n, 0, 0, i, s), d.globalCompositeOperation = "destination-in", d.drawImage(e, 0, 0, i, s), t.target === "background" ? (a.filter = G_(t, o), a.drawImage(n, 0, 0, i, s), a.filter = "none", a.drawImage(l, 0, 0)) : (a.drawImage(n, 0, 0, i, s), a.filter = G_(t, o), a.drawImage(l, 0, 0), a.filter = "none"), r;
}
function fhe(n, e, t, i) {
  const s = n.width, o = n.height, r = Rn(s, o), a = zn(r);
  a.drawImage(n, 0, 0);
  const l = Rn(s, o), d = zn(l);
  return d.imageSmoothingQuality = "high", d.drawImage(e, 0, 0, s, o), d.globalCompositeOperation = "destination-in", d.filter = i > 0 ? "blur(" + i.toFixed(1) + "px)" : "none", d.drawImage(t, 0, 0, s, o), d.filter = "none", a.drawImage(l, 0, 0), r;
}
function xb(n, e, t) {
  const i = Math.min(1, e / Math.max(n.width, n.height));
  if (i >= 1) return n.toDataURL(t ? "image/png" : "image/jpeg", 0.9);
  const s = Rn(n.width * i, n.height * i), o = zn(s);
  return o.imageSmoothingQuality = "high", o.drawImage(n, 0, 0, s.width, s.height), s.toDataURL(t ? "image/png" : "image/jpeg", 0.9);
}
const wb = /* @__PURE__ */ new Map();
function mhe(n, e, t, i = "") {
  const s = new Uint16Array(e * t), o = /* @__PURE__ */ new Map();
  let r = 0;
  for (let a = 0, l = 0; a < s.length; a++, l += 4) {
    const d = n[l + 3] >= 128;
    d && n[l + 2] > 0 && r++;
    const c = !d || n[l + 2] > 0 ? 0 : n[l] + n[l + 1] * 256;
    s[a] = c, c && o.set(c, (o.get(c) || 0) + 1);
  }
  return { url: i, w: e, h: t, ids: s, count: o.size, sizes: o, stray: r, masks: /* @__PURE__ */ new Map() };
}
const ghe = 2048;
function bhe(n) {
  return n.count > 0 && n.count <= ghe && n.stray <= n.w * n.h * 0.01;
}
function $f(n) {
  let e = wb.get(n);
  return e || (e = si(n).then((t) => {
    const i = Rn(t.width, t.height), s = i.getContext("2d", { willReadFrequently: !0 });
    s.imageSmoothingEnabled = !1, s.drawImage(t, 0, 0);
    const o = mhe(s.getImageData(0, 0, i.width, i.height).data, i.width, i.height, n);
    if (!bhe(o)) throw new Error(`not a map of objects (${o.count} objects, ${o.stray} stray pixels)`);
    return o;
  }), wb.set(n, e), e.catch(() => wb.delete(n))), e;
}
function j_(n, e, t) {
  const i = Math.min(n.w - 1, Math.max(0, Math.floor(e * n.w))), s = Math.min(n.h - 1, Math.max(0, Math.floor(t * n.h)));
  return n.ids[s * n.w + i] || 0;
}
function $I(n, e) {
  const t = n.masks.get(e);
  if (t) return t;
  const i = Rn(n.w, n.h), s = zn(i), o = s.createImageData(n.w, n.h), r = o.data;
  for (let a = 0, l = 0; a < n.ids.length; a++, l += 4)
    n.ids[a] === e && (r[l] = 255, r[l + 1] = 255, r[l + 2] = 255, r[l + 3] = 255);
  return s.putImageData(o, 0, 0), n.masks.set(e, i), i;
}
function H_(n) {
  return !!n && n.some((e) => !e.cut);
}
function DI(n) {
  return Array.from(new Set(n.filter((e) => e.kind === "object").map((e) => e.map)));
}
function V_(n, e, t, i) {
  n.beginPath(), e.forEach((s, o) => o ? n.lineTo(s.x * t, s.y * i) : n.moveTo(s.x * t, s.y * i));
}
function vhe(n, e, t, i, s) {
  const o = Math.max(t, i);
  n.save(), n.lineCap = "round", n.lineJoin = "round";
  for (const r of e)
    if (n.globalCompositeOperation = r.cut ? "destination-out" : "source-over", n.fillStyle = "#fff", n.strokeStyle = "#fff", r.kind === "brush") {
      const a = Math.max(1, r.size * o);
      if (r.pts.length === 1) {
        n.beginPath(), n.arc(r.pts[0].x * t, r.pts[0].y * i, a / 2, 0, Math.PI * 2), n.fill();
        continue;
      }
      n.lineWidth = a, V_(n, r.pts, t, i), n.stroke();
    } else if (r.kind === "lasso") {
      if (r.pts.length < 3) continue;
      V_(n, r.pts, t, i), n.closePath(), n.fill();
    } else {
      const a = s.get(r.map);
      if (!a) continue;
      n.imageSmoothingEnabled = !0, n.drawImage($I(a, r.segment), 0, 0, t, i);
    }
  n.restore();
}
function Dp(n, e, t, i) {
  const s = Rn(e, t);
  return vhe(zn(s), n, e, t, i), s;
}
const W_ = "#ff2bd6";
function yhe(n, e) {
  const t = n.width, i = n.height, s = Rn(t, i), o = zn(s);
  o.drawImage(n, 0, 0, t, i);
  const r = Rn(t, i), a = zn(r);
  a.drawImage(e, 0, 0, t, i), a.globalCompositeOperation = "source-in", a.fillStyle = W_, a.fillRect(0, 0, t, i), o.globalAlpha = 0.38, o.drawImage(r, 0, 0), o.globalAlpha = 1;
  const l = Rn(t, i), d = zn(l), c = Math.max(2, Math.round(Math.max(t, i) / 300));
  return d.filter = "blur(" + c + "px)", d.drawImage(e, 0, 0, t, i), d.filter = "none", d.globalCompositeOperation = "destination-out", d.drawImage(e, 0, 0, t, i), d.globalCompositeOperation = "source-in", d.fillStyle = W_, d.fillRect(0, 0, t, i), o.drawImage(l, 0, 0), s;
}
const P0 = [
  { id: "free", label: "Free", r: null },
  { id: "original", label: "Original", r: NaN },
  { id: "1:1", label: "1:1", r: 1 },
  { id: "4:5", label: "4:5", r: 4 / 5 },
  { id: "3:4", label: "3:4", r: 3 / 4 },
  { id: "2:3", label: "2:3", r: 2 / 3 },
  { id: "9:16", label: "9:16", r: 9 / 16 },
  { id: "16:9", label: "16:9", r: 16 / 9 },
  { id: "3:2", label: "3:2", r: 3 / 2 },
  { id: "4:3", label: "4:3", r: 4 / 3 },
  { id: "21:9", label: "21:9", r: 21 / 9 },
  { id: "5:4", label: "5:4", r: 5 / 4, more: !0 },
  { id: "2:1", label: "2:1", r: 2, more: !0 },
  { id: "3:1", label: "3:1", r: 3, more: !0 },
  { id: "1:2", label: "1:2", r: 1 / 2, more: !0 },
  { id: "1:3", label: "1:3", r: 1 / 3, more: !0 }
];
function Mc(n, e, t) {
  const i = P0.find((s) => s.id === n);
  return !i || i.r === null ? null : Number.isNaN(i.r) ? e / t : i.r;
}
const Bh = { x: 0, y: 0, w: 1, h: 1 };
function fi(n, e, t) {
  return Math.min(t, Math.max(e, n));
}
function xhe(n, e, t, i = { x: 0.5, y: 0.5 }) {
  const s = e / t, o = n >= s ? 1 : n / s, r = n >= s ? s / n : 1;
  return { x: fi(i.x - o / 2, 0, 1 - o), y: fi(i.y - r / 2, 0, 1 - r), w: o, h: r };
}
function E0(n, e, t) {
  return { w: Math.max(1, Math.round(n.w * e)), h: Math.max(1, Math.round(n.h * t)) };
}
function OI(n, e = 0.02) {
  const t = fi(n.w, e, 1), i = fi(n.h, e, 1);
  return { x: fi(n.x, 0, 1 - t), y: fi(n.y, 0, 1 - i), w: t, h: i };
}
function whe(n, e, t) {
  return { ...n, x: fi(n.x + e, 0, 1 - n.w), y: fi(n.y + t, 0, 1 - n.h) };
}
function khe(n, e, t, i, s, o, r, a = 24) {
  const l = a / s, d = a / o;
  let c = n.x, h = n.y, f = n.x + n.w, p = n.y + n.h;
  if (e.includes("w") && (c = fi(c + t, 0, f - l)), e.includes("e") && (f = fi(f + t, c + l, 1)), e.includes("n") && (h = fi(h + i, 0, p - d)), e.includes("s") && (p = fi(p + i, h + d, 1)), r == null) return { x: c, y: h, w: f - c, h: p - h };
  const y = s / (r * o), v = e.length === 2;
  let x = f - c, w = p - h;
  v ? Math.abs(t) * s >= Math.abs(i) * o ? w = x * y : x = w / y : e === "e" || e === "w" ? w = x * y : x = w / y;
  const S = e.includes("w") ? n.x + n.w : e.includes("e") ? 1 - n.x : Math.min(n.x + n.w / 2, 1 - n.x - n.w / 2) * 2, M = e.includes("n") ? n.y + n.h : e.includes("s") ? 1 - n.y : Math.min(n.y + n.h / 2, 1 - n.y - n.h / 2) * 2;
  x > S && (x = S, w = x * y), w > M && (w = M, x = w / y), x = Math.max(x, l), w = Math.max(w, d);
  const _ = n.x + n.w / 2, T = n.y + n.h / 2, k = e.includes("w") ? n.x + n.w - x : e.includes("e") ? n.x : _ - x / 2, P = e.includes("n") ? n.y + n.h - w : e.includes("s") ? n.y : T - w / 2;
  return OI({ x: k, y: P, w: x, h: w }, 0);
}
function q_(n, e, t, i, s) {
  const o = fi(e / i, 5e-3, 1), r = fi(t / s, 5e-3, 1), a = n.x + n.w / 2, l = n.y + n.h / 2;
  return OI({ x: a - o / 2, y: l - r / 2, w: o, h: r }, 0);
}
function K_(n) {
  return n.x <= 5e-4 && n.y <= 5e-4 && n.w >= 0.999 && n.h >= 0.999;
}
function _he(n, e) {
  return n !== "free" && n !== "original" ? "Crop " + n : "Crop " + e.w + " × " + e.h;
}
const She = 5e3 * 5e3, Mhe = 0.15;
function LI(n, e) {
  return { cw: n, ch: e, ix: 0, iy: 0, iw: n, ih: e };
}
function kb(n, e, t, i = 1) {
  let s = e * i, o = t * i;
  return s / o < n ? s = o * n : o = s / n, s = Math.round(s), o = Math.round(o), { cw: s, ch: o, ix: Math.round((s - e) / 2), iy: Math.round((o - t) / 2), iw: e, ih: t };
}
function The(n) {
  return n.iw * n.ih / Math.max(1, n.cw * n.ch);
}
function R0(n) {
  return n.ix > 0.5 || n.iy > 0.5 || n.ix + n.iw < n.cw - 0.5 || n.iy + n.ih < n.ch - 0.5;
}
function Che(n) {
  const e = Math.min(1, Math.sqrt(She / Math.max(1, n.cw * n.ch)) * 0.999);
  return {
    canvas_size: [Math.round(n.cw * e), Math.round(n.ch * e)],
    original_image_size: [Math.max(1, Math.round(n.iw * e)), Math.max(1, Math.round(n.ih * e))],
    original_image_location: [Math.round(n.ix * e), Math.round(n.iy * e)]
  };
}
function Ihe(n, e, t, i = 64) {
  const s = { ...n };
  if (e === "e" && (s.cw = Math.max(i, n.cw + t)), e === "s" && (s.ch = Math.max(i, n.ch + t)), e === "w") {
    const o = Math.max(i, n.cw + t);
    s.ix = n.ix + (o - n.cw), s.cw = o;
  }
  if (e === "n") {
    const o = Math.max(i, n.ch + t);
    s.iy = n.iy + (o - n.ch), s.ch = o;
  }
  return s;
}
function Ahe(n, e, t) {
  const i = Math.min(n.cw - n.iw * 0.25, Math.max(-n.iw * 0.75, n.ix + e)), s = Math.min(n.ch - n.ih * 0.25, Math.max(-n.ih * 0.75, n.iy + t));
  return { ...n, ix: Math.round(i), iy: Math.round(s) };
}
function Phe(n, e, t, i) {
  const s = Math.max(16, Math.round(e * i)), o = Math.max(16, Math.round(t * i)), r = n.ix + n.iw / 2, a = n.iy + n.ih / 2;
  return { ...n, iw: s, ih: o, ix: Math.round(r - s / 2), iy: Math.round(a - o / 2) };
}
function Ehe(n) {
  return { ...n, ix: Math.round((n.cw - n.iw) / 2), iy: Math.round((n.ch - n.ih) / 2) };
}
function Rhe(n, e) {
  return n && n !== "free" ? n : Math.round(e.cw) + " × " + Math.round(e.ch);
}
const Yi = [
  { id: "red", label: "Red", hue: 0, color: "#ff4d4d" },
  { id: "orange", label: "Orange", hue: 30, color: "#ff9a3d" },
  { id: "yellow", label: "Yellow", hue: 60, color: "#ffe14d" },
  { id: "green", label: "Green", hue: 120, color: "#4dd26b" },
  { id: "aqua", label: "Aqua", hue: 180, color: "#3dd9d9" },
  { id: "blue", label: "Blue", hue: 225, color: "#4d7bff" },
  { id: "purple", label: "Purple", hue: 275, color: "#a35cff" },
  { id: "magenta", label: "Magenta", hue: 315, color: "#ff4dcf" }
], zhe = [
  { id: "normal", label: "Normal" },
  { id: "multiply", label: "Multiply" },
  { id: "screen", label: "Screen" },
  { id: "overlay", label: "Overlay" },
  { id: "soft-light", label: "Soft light" },
  { id: "color", label: "Colour" }
], _b = () => ({ hue: 0, amount: 0, lum: 0 });
function Df() {
  const n = {};
  for (const e of Yi) n[e.id] = { hue: 0, sat: 0, lum: 0 };
  return {
    exposure: 0,
    contrast: 0,
    brightness: 0,
    highlights: 0,
    shadows: 0,
    saturation: 0,
    hue: 0,
    temperature: 0,
    tint: 0,
    grade: { shadows: _b(), midtones: _b(), highlights: _b() },
    mixer: n,
    overlay: { color: "#ff8a3d", blend: "soft-light", opacity: 0 },
    grain: { amount: 0, size: 35 },
    straighten: 0,
    quarter: 0,
    flipH: !1,
    flipV: !1,
    match: { to: null, amount: 0, stats: null },
    look: null
  };
}
function $he(n, e) {
  const t = Df(), i = iu(n);
  return e === "light" && Object.assign(i, { exposure: 0, contrast: 0, brightness: 0, highlights: 0, shadows: 0 }), e === "colour" && Object.assign(i, { saturation: 0, hue: 0, temperature: 0, tint: 0 }), e === "grading" && (i.grade = t.grade), e === "mixer" && (i.mixer = t.mixer), e === "overlay" && (i.overlay = { ...i.overlay, opacity: 0 }), e === "grain" && (i.grain = t.grain), e === "rotate" && Object.assign(i, { straighten: 0, quarter: 0, flipH: !1, flipV: !1 }), e === "match" && (i.match = t.match), i.look = null, i;
}
function iu(n) {
  return JSON.parse(JSON.stringify(n));
}
function kl(n, e) {
  return e === "light" ? !!(n.exposure || n.contrast || n.brightness || n.highlights || n.shadows) : e === "colour" ? !!(n.saturation || n.hue || n.temperature || n.tint) : e === "grading" ? ["shadows", "midtones", "highlights"].some((t) => n.grade[t].amount > 0 || n.grade[t].lum !== 0) : e === "mixer" ? Yi.some((t) => n.mixer[t.id].hue || n.mixer[t.id].sat || n.mixer[t.id].lum) : e === "overlay" ? n.overlay.opacity > 0 : e === "grain" ? n.grain.amount > 0 : e === "rotate" ? !!(n.straighten || n.quarter || n.flipH || n.flipV) : !!n.match.to && n.match.amount > 0 && !!n.match.stats;
}
const z0 = ["light", "colour", "grading", "mixer", "overlay", "grain", "rotate", "match"];
function $0(n) {
  return z0.some((e) => kl(n, e));
}
function Dhe(n) {
  return kl(n, "rotate");
}
function su(n, e, t) {
  return n.quarter % 2 ? { w: t, h: e } : { w: e, h: t };
}
function Ohe(n, e, t) {
  const i = Math.abs(n * Math.PI / 180);
  if (i < 1e-6) return 1;
  const s = Math.cos(i), o = Math.sin(i);
  return Math.max((e * s + t * o) / e, (e * o + t * s) / t);
}
const ox = [
  { id: "vintage", label: "Vintage", set: (n) => {
    Object.assign(n, { saturation: -28, contrast: -12, temperature: 18, shadows: 18 }), n.grade.shadows = { hue: 190, amount: 22, lum: 8 }, n.grade.highlights = { hue: 42, amount: 26, lum: 0 }, n.grain = { amount: 22, size: 40 };
  } },
  { id: "retro-film", label: "Retro film", set: (n) => {
    Object.assign(n, { contrast: 16, saturation: -10, highlights: -14 }), n.grade.shadows = { hue: 215, amount: 30, lum: 0 }, n.grade.highlights = { hue: 35, amount: 24, lum: 0 }, n.grain = { amount: 34, size: 45 };
  } },
  { id: "duotone", label: "Duotone", set: (n) => {
    Object.assign(n, { saturation: -100, contrast: 12 }), n.grade.shadows = { hue: 255, amount: 70, lum: -6 }, n.grade.highlights = { hue: 38, amount: 62, lum: 4 };
  } },
  { id: "vibrant", label: "Vibrant", set: (n) => Object.assign(n, { saturation: 34, contrast: 12, shadows: 8 }) },
  { id: "warm", label: "Warm tone", set: (n) => Object.assign(n, { temperature: 32, tint: 4, saturation: 6 }) },
  { id: "cool-breeze", label: "Cool breeze", set: (n) => Object.assign(n, { temperature: -28, tint: -4, highlights: 10, saturation: -6 }) },
  { id: "red-tint", label: "Red tint", set: (n) => {
    n.overlay = { color: "#ff3b30", blend: "soft-light", opacity: 30 };
  } },
  { id: "cold", label: "Cold tone", set: (n) => Object.assign(n, { temperature: -44, saturation: -18, contrast: 6 }) },
  { id: "mono", label: "Black and white", set: (n) => Object.assign(n, { saturation: -100, contrast: 16 }) },
  { id: "matte", label: "Matte", set: (n) => {
    Object.assign(n, { contrast: -22, shadows: 26, saturation: -12 }), n.grade.shadows = { hue: 220, amount: 10, lum: 10 };
  } }
];
function Y_(n, e) {
  const t = ox.find((s) => s.id === e), i = Df();
  return Object.assign(i, { straighten: n.straighten, quarter: n.quarter, flipH: n.flipH, flipV: n.flipV, match: n.match }), t && t.set(i), i.look = t ? t.id : null, i;
}
function Lhe(n) {
  const e = ox.find((t) => t.id === n.look);
  return e ? "Adjust · " + e.label : kl(n, "match") && z0.filter((t) => kl(n, t)).length === 1 ? "Match colours" : Dhe(n) && z0.filter((t) => kl(n, t)).length === 1 ? n.straighten ? "Straighten" : "Rotate" : "Adjust";
}
function Sb(n) {
  return n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
}
function Bhe(n, e, t) {
  const i = Sb(n), s = Sb(e), o = Sb(t);
  let r = (i * 0.4124 + s * 0.3576 + o * 0.1805) / 0.95047, a = i * 0.2126 + s * 0.7152 + o * 0.0722, l = (i * 0.0193 + s * 0.1192 + o * 0.9505) / 1.08883;
  const d = (c) => c > 8856e-6 ? Math.cbrt(c) : 7.787 * c + 16 / 116;
  return r = d(r), a = d(a), l = d(l), [116 * a - 16, 500 * (r - a), 200 * (a - l)];
}
function Fhe(n) {
  let e = 0;
  const t = [0, 0, 0], i = [0, 0, 0];
  for (let r = 0; r < n.length; r += 4) {
    if (n[r + 3] < 128) continue;
    const a = n[r] / 255, l = n[r + 1] / 255, d = n[r + 2] / 255, c = Math.max(a, l, d), h = Math.min(a, l, d);
    if (c < 0.02 || h > 0.985) continue;
    const f = Bhe(a, l, d);
    for (let p = 0; p < 3; p++)
      t[p] += f[p], i[p] += f[p] * f[p];
    e++;
  }
  if (!e) return { mean: [50, 0, 0], std: [1, 1, 1] };
  const s = t.map((r) => r / e), o = i.map((r, a) => Math.sqrt(Math.max(1e-6, r / e - s[a] * s[a])));
  return { mean: s, std: o };
}
function Nhe(n, e) {
  const t = [0, 1, 2].map((s) => Math.max(0.5, Math.min(2, e.std[s] / Math.max(1e-3, n.std[s])))), i = [0, 1, 2].map((s) => e.mean[s] - n.mean[s] * t[s]);
  return { scale: t, shift: i };
}
function rx([n, e, t]) {
  const i = Math.max(n, e, t), s = Math.min(n, e, t), o = (i + s) / 2;
  if (i === s) return [0, 0, o];
  const r = i - s, a = o > 0.5 ? r / (2 - i - s) : r / (i + s);
  let l = i === n ? (e - t) / r + (e < t ? 6 : 0) : i === e ? (t - n) / r + 2 : (n - e) / r + 4;
  return l /= 6, [l, a, o];
}
function Uhe([n, e, t]) {
  if (e === 0) return [t, t, t];
  const i = t < 0.5 ? t * (1 + e) : t + e - t * e, s = 2 * t - i, o = (r) => {
    let a = r;
    return a < 0 && (a += 1), a > 1 && (a -= 1), a < 1 / 6 ? s + (i - s) * 6 * a : a < 1 / 2 ? i : a < 2 / 3 ? s + (i - s) * (2 / 3 - a) * 6 : s;
  };
  return [o(n + 1 / 3), o(n), o(n - 1 / 3)];
}
const BI = (n, e, t) => {
  const i = Math.min(1, Math.max(0, (t - n) / (e - n)));
  return i * i * (3 - 2 * i);
};
function Ghe(n, e) {
  const [t, i, s] = rx(n), o = t * 360;
  let r = [0, 0, 0], a = 0;
  for (const p of Yi) {
    const y = Math.abs(((o - p.hue + 180) % 360 + 360) % 360 - 180);
    let v = Math.max(0, 1 - y / 45);
    v = v * v * (3 - 2 * v);
    const x = e[p.id];
    r = [r[0] + x.hue / 100 * v, r[1] + x.sat / 100 * v, r[2] + x.lum / 100 * v], a += v;
  }
  const l = Math.max(1, a);
  r = [r[0] / l, r[1] / l, r[2] / l];
  const d = BI(0.02, 0.25, i), c = ((t + r[0] * d / 12 + 1) % 1 + 1) % 1, h = Math.min(1, Math.max(0, i * (1 + r[1] * d))), f = Math.min(1, Math.max(0, s + r[2] * 0.22 * d * i));
  return Uhe([c, h, f]);
}
function jhe(n) {
  const e = rx(n)[0] * 360;
  let t = Yi[0], i = 999;
  for (const s of Yi) {
    const o = Math.abs(((e - s.hue + 180) % 360 + 360) % 360 - 180);
    o < i && (i = o, t = s);
  }
  return t.id;
}
function Hhe(n) {
  return BI(0.02, 0.25, rx(n)[1]);
}
function X_([n, e, t]) {
  return "rgb(" + Math.round(n * 255) + ", " + Math.round(e * 255) + ", " + Math.round(t * 255) + ")";
}
function Vhe(n) {
  const e = n.replace("#", ""), t = parseInt(e.length === 3 ? e.split("").map((i) => i + i).join("") : e, 16);
  return [(t >> 16 & 255) / 255, (t >> 8 & 255) / 255, (t & 255) / 255];
}
var Whe = Object.defineProperty, qhe = (n, e, t) => e in n ? Whe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, kr = (n, e, t) => qhe(n, typeof e != "symbol" ? e + "" : e, t);
const Khe = `#version 300 es
in vec2 aPos;
out vec2 vUv;
void main() {
	vUv = aPos * 0.5 + 0.5;
	gl_Position = vec4(aPos, 0.0, 1.0);
}`, Yhe = `#version 300 es
precision highp float;
in vec2 vUv;
out vec4 outColor;
uniform sampler2D uImg;
uniform vec2 uSrc;
uniform vec2 uOut;
uniform float uQuarter;
uniform vec2 uFlip;
uniform float uTurn;
uniform float uTurnScale;
uniform float uExposure;
uniform float uContrast;
uniform float uBrightness;
uniform float uHighlights;
uniform float uShadows;
uniform float uSaturation;
uniform float uHue;
uniform float uTemperature;
uniform float uTint;
uniform vec3 uGradeS;
uniform vec3 uGradeM;
uniform vec3 uGradeH;
uniform vec3 uGradeLum;
uniform vec3 uMixer[8];
uniform float uMixerHue[8];
uniform float uMixerOn;
uniform vec3 uOverlay;
uniform float uOverlayOpacity;
uniform int uBlend;
uniform float uGrain;
uniform float uGrainSize;
uniform float uSeed;
uniform vec3 uMatchScale;
uniform vec3 uMatchShift;
uniform float uMatch;
uniform float uShowOriginal;

float luma(vec3 c) { return dot(c, vec3(0.2126, 0.7152, 0.0722)); }

vec3 toLinear(vec3 c) {
	return mix(c / 12.92, pow((c + 0.055) / 1.055, vec3(2.4)), step(0.04045, c));
}
vec3 toSrgb(vec3 c) {
	c = max(c, 0.0);
	return mix(c * 12.92, 1.055 * pow(c, vec3(1.0 / 2.4)) - 0.055, step(0.0031308, c));
}

vec3 rgb2hsl(vec3 c) {
	float mx = max(c.r, max(c.g, c.b));
	float mn = min(c.r, min(c.g, c.b));
	float l = (mx + mn) * 0.5;
	float d = mx - mn;
	if (d < 1e-5) return vec3(0.0, 0.0, l);
	float s = d / (1.0 - abs(2.0 * l - 1.0) + 1e-5);
	float h;
	if (mx == c.r) h = mod((c.g - c.b) / d, 6.0);
	else if (mx == c.g) h = (c.b - c.r) / d + 2.0;
	else h = (c.r - c.g) / d + 4.0;
	return vec3(h / 6.0, clamp(s, 0.0, 1.0), l);
}
vec3 hsl2rgb(vec3 hsl) {
	vec3 rgb = clamp(abs(mod(hsl.x * 6.0 + vec3(0.0, 4.0, 2.0), 6.0) - 3.0) - 1.0, 0.0, 1.0);
	float C = (1.0 - abs(2.0 * hsl.z - 1.0)) * hsl.y;
	return (rgb - 0.5) * C + hsl.z;
}

vec3 rgb2lab(vec3 c) {
	vec3 l = toLinear(c);
	vec3 xyz = vec3(
		dot(l, vec3(0.4124, 0.3576, 0.1805)) / 0.95047,
		dot(l, vec3(0.2126, 0.7152, 0.0722)),
		dot(l, vec3(0.0193, 0.1192, 0.9505)) / 1.08883);
	vec3 f = mix(7.787 * xyz + 16.0 / 116.0, pow(xyz, vec3(1.0 / 3.0)), step(0.008856, xyz));
	return vec3(116.0 * f.y - 16.0, 500.0 * (f.x - f.y), 200.0 * (f.y - f.z));
}
vec3 lab2rgb(vec3 lab) {
	float fy = (lab.x + 16.0) / 116.0;
	float fx = fy + lab.y / 500.0;
	float fz = fy - lab.z / 200.0;
	vec3 f = vec3(fx, fy, fz);
	vec3 f3 = f * f * f;
	vec3 xyz = mix((f - 16.0 / 116.0) / 7.787, f3, step(0.008856, f3));
	xyz *= vec3(0.95047, 1.0, 1.08883);
	vec3 l = vec3(
		dot(xyz, vec3(3.2406, -1.5372, -0.4986)),
		dot(xyz, vec3(-0.9689, 1.8758, 0.0415)),
		dot(xyz, vec3(0.0557, -0.2040, 1.0570)));
	return toSrgb(l);
}

float hash(vec2 p) {
	p = fract(p * vec2(123.34, 456.21) + uSeed);
	p += dot(p, p + 45.32);
	return fract(p.x * p.y);
}

vec3 blend(vec3 base, vec3 top, int mode) {
	if (mode == 1) return base * top;
	if (mode == 2) return 1.0 - (1.0 - base) * (1.0 - top);
	if (mode == 3) return mix(2.0 * base * top, 1.0 - 2.0 * (1.0 - base) * (1.0 - top), step(0.5, base));
	if (mode == 4) return (1.0 - 2.0 * top) * base * base + 2.0 * top * base;
	if (mode == 5) {
		vec3 h = rgb2hsl(top);
		return hsl2rgb(vec3(h.x, h.y, rgb2hsl(base).z));
	}
	return top;
}

void main() {
	// where this output pixel comes from, in the source's pixels with y down as on screen:
	// undo the flip, the quarter turns (clockwise), then the straighten (clockwise)
	vec2 p = (vUv - 0.5) * uOut;
	p.y = -p.y;
	if (uFlip.x > 0.5) p.x = -p.x;
	if (uFlip.y > 0.5) p.y = -p.y;
	for (int i = 0; i < 3; i++) {
		if (float(i) < uQuarter) p = vec2(p.y, -p.x);
	}
	float cs = cos(uTurn);
	float sn = sin(uTurn);
	p = vec2(p.x * cs + p.y * sn, -p.x * sn + p.y * cs) / uTurnScale;
	vec2 uv = p / uSrc + 0.5;
	// the texture's first row is the picture's top (uploads aren't flipped: an ImageBitmap ignores the flag)
	vec4 src = texture(uImg, uv);
	vec3 c = src.rgb;
	if (uShowOriginal > 0.5) {
		outColor = vec4(c, src.a);
		return;
	}

	// exposure and white balance, in linear light
	vec3 lin = toLinear(c) * exp2(uExposure * 2.0);
	vec3 wb = vec3(1.0 + uTemperature * 0.22, 1.0 - uTint * 0.14, 1.0 - uTemperature * 0.22);
	wb /= max(1e-3, dot(wb, vec3(0.2126, 0.7152, 0.0722)));
	lin *= wb;
	c = toSrgb(lin);

	// highlights and shadows: lift or hold each end of the tones, keeping the colour
	float L = luma(c);
	float ws = pow(1.0 - smoothstep(0.0, 0.62, L), 2.0);
	float wh = pow(smoothstep(0.38, 1.0, L), 2.0);
	float L2 = L;
	L2 += uShadows * ws * 0.5 * (uShadows > 0.0 ? (1.0 - L) : L);
	L2 += uHighlights * wh * 0.5 * (uHighlights > 0.0 ? (1.0 - L) : L);
	c *= L2 / max(L, 1e-4);

	// brightness (the midtones), then contrast about the middle grey
	c = pow(max(c, 0.0), vec3(exp2(-uBrightness * 0.75)));
	float k = uContrast >= 0.0 ? 1.0 + uContrast * 1.1 : 1.0 + uContrast * 0.75;
	c = (c - 0.5) * k + 0.5;

	// colour grading: a tint and a brightness for the shadows, midtones and highlights
	L = clamp(luma(c), 0.0, 1.0);
	float gs = pow(1.0 - L, 2.0);
	float gh = L * L;
	float gm = max(0.0, 1.0 - gs - gh);
	c += uGradeS * gs + uGradeM * gm + uGradeH * gh;
	c += uGradeLum.x * gs + uGradeLum.y * gm + uGradeLum.z * gh;

	// the colour mixer: each hue band's own hue, saturation and luminance
	if (uMixerOn > 0.5) {
		vec3 hsl = rgb2hsl(clamp(c, 0.0, 1.0));
		float hue = hsl.x * 360.0;
		vec3 acc = vec3(0.0);
		float wsum = 0.0;
		for (int i = 0; i < 8; i++) {
			float d = abs(mod(hue - uMixerHue[i] + 180.0, 360.0) - 180.0);
			float w = max(0.0, 1.0 - d / 45.0);
			w = w * w * (3.0 - 2.0 * w);
			acc += uMixer[i] * w;
			wsum += w;
		}
		acc /= max(1.0, wsum);
		float chroma = smoothstep(0.02, 0.25, hsl.y);
		hsl.x = fract(hsl.x + acc.x * chroma / 12.0 + 1.0);
		hsl.y = clamp(hsl.y * (1.0 + acc.y * chroma), 0.0, 1.0);
		hsl.z = clamp(hsl.z + acc.z * 0.22 * chroma * hsl.y, 0.0, 1.0);
		c = hsl2rgb(hsl);
	}

	// hue, then saturation
	if (abs(uHue) > 1e-4) {
		vec3 hsl = rgb2hsl(clamp(c, 0.0, 1.0));
		hsl.x = fract(hsl.x + uHue / 360.0 + 1.0);
		c = hsl2rgb(hsl);
	}
	L = luma(c);
	c = mix(vec3(L), c, 1.0 + uSaturation);

	// match colours: another version's colour, carried over in Lab
	if (uMatch > 0.0) {
		vec3 lab = rgb2lab(clamp(c, 0.0, 1.0));
		vec3 moved = lab * uMatchScale + uMatchShift;
		c = mix(c, lab2rgb(moved), uMatch);
	}

	c = clamp(c, 0.0, 1.0);
	if (uOverlayOpacity > 0.0) c = mix(c, clamp(blend(c, uOverlay, uBlend), 0.0, 1.0), uOverlayOpacity);
	if (uGrain > 0.0) {
		vec2 cell = floor(gl_FragCoord.xy / max(1.0, uGrainSize));
		float n = hash(cell) - 0.5;
		float midtones = 1.0 - pow(abs(luma(c) - 0.5) * 2.0, 2.0);
		c += n * uGrain * (0.35 + 0.65 * midtones);
	}
	outColor = vec4(clamp(c, 0.0, 1.0), src.a);
}`, Xhe = { normal: 0, multiply: 1, screen: 2, overlay: 3, "soft-light": 4, color: 5 };
function Jhe(n) {
  const e = /^#?([0-9a-f]{6})$/i.exec(n.trim()), t = e ? parseInt(e[1], 16) : 0;
  return [(t >> 16 & 255) / 255, (t >> 8 & 255) / 255, (t & 255) / 255];
}
function Mb(n, e) {
  const t = (n % 360 + 360) % 360 / 60, i = 1 - Math.abs(t % 2 - 1), [s, o, r] = t < 1 ? [1, i, 0] : t < 2 ? [i, 1, 0] : t < 3 ? [0, 1, i] : t < 4 ? [0, i, 1] : t < 5 ? [i, 0, 1] : [1, 0, i], a = 0.2126 * s + 0.7152 * o + 0.0722 * r, l = e / 100 * 0.32;
  return [(s - a) * l, (o - a) * l, (r - a) * l];
}
class FI {
  constructor(e) {
    kr(this, "canvas", e), kr(this, "gl"), kr(this, "prog"), kr(this, "tex"), kr(this, "loc", /* @__PURE__ */ new Map()), kr(this, "src", { w: 1, h: 1 }), kr(this, "seed", Math.random());
    const t = e.getContext("webgl2", { premultipliedAlpha: !1, preserveDrawingBuffer: !0, antialias: !1 });
    if (!t) throw new Error("This browser can't adjust pictures (it has no WebGL 2).");
    this.gl = t;
    const i = this.shader(t.VERTEX_SHADER, Khe), s = this.shader(t.FRAGMENT_SHADER, Yhe), o = t.createProgram();
    if (t.attachShader(o, i), t.attachShader(o, s), t.linkProgram(o), !t.getProgramParameter(o, t.LINK_STATUS)) throw new Error("Adjust's shader didn't link: " + t.getProgramInfoLog(o));
    this.prog = o, t.useProgram(o);
    const r = t.createBuffer();
    t.bindBuffer(t.ARRAY_BUFFER, r), t.bufferData(t.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), t.STATIC_DRAW);
    const a = t.getAttribLocation(o, "aPos");
    t.enableVertexAttribArray(a), t.vertexAttribPointer(a, 2, t.FLOAT, !1, 0, 0), this.tex = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.tex), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE);
  }
  shader(e, t) {
    const i = this.gl, s = i.createShader(e);
    if (i.shaderSource(s, t), i.compileShader(s), !i.getShaderParameter(s, i.COMPILE_STATUS)) throw new Error("Adjust's shader didn't compile: " + i.getShaderInfoLog(s));
    return s;
  }
  u(e) {
    return this.loc.has(e) || this.loc.set(e, this.gl.getUniformLocation(this.prog, e)), this.loc.get(e) || null;
  }
  /** The picture to adjust. */
  setImage(e, t, i) {
    const s = this.gl;
    s.bindTexture(s.TEXTURE_2D, this.tex), s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, !1), s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, e), this.src = { w: t, h: i };
  }
  /** The biggest picture this browser's graphics take. */
  maxSize() {
    return this.gl.getParameter(this.gl.MAX_TEXTURE_SIZE);
  }
  /**
   * Draw the picture adjusted, `w` by `h` (the output's shape: a quarter turn
   * swaps them). `grainScale` keeps grain the same size on the picture
   * whatever size it's drawn at (the preview is smaller than the bake).
   */
  render(e, t, i, s = {}) {
    const o = this.gl;
    this.canvas.width !== t && (this.canvas.width = t), this.canvas.height !== i && (this.canvas.height = i), o.viewport(0, 0, t, i), o.useProgram(this.prog);
    const r = (p, y) => o.uniform1f(this.u(p), y);
    o.uniform1i(this.u("uImg"), 0), o.uniform2f(this.u("uSrc"), this.src.w, this.src.h);
    const a = e.quarter % 2 ? [this.src.h, this.src.w] : [this.src.w, this.src.h];
    o.uniform2f(this.u("uOut"), a[0], a[1]), r("uQuarter", e.quarter), o.uniform2f(this.u("uFlip"), e.flipH ? 1 : 0, e.flipV ? 1 : 0), r("uTurn", e.straighten * Math.PI / 180), r("uTurnScale", Ohe(e.straighten, this.src.w, this.src.h)), r("uExposure", e.exposure / 100), r("uContrast", e.contrast / 100), r("uBrightness", e.brightness / 100), r("uHighlights", e.highlights / 100), r("uShadows", e.shadows / 100), r("uSaturation", e.saturation / 100), r("uHue", e.hue), r("uTemperature", e.temperature / 100), r("uTint", e.tint / 100), o.uniform3fv(this.u("uGradeS"), Mb(e.grade.shadows.hue, e.grade.shadows.amount)), o.uniform3fv(this.u("uGradeM"), Mb(e.grade.midtones.hue, e.grade.midtones.amount)), o.uniform3fv(this.u("uGradeH"), Mb(e.grade.highlights.hue, e.grade.highlights.amount)), o.uniform3f(this.u("uGradeLum"), e.grade.shadows.lum / 100 * 0.22, e.grade.midtones.lum / 100 * 0.22, e.grade.highlights.lum / 100 * 0.22);
    const l = [], d = [];
    let c = 0;
    for (const p of Yi) {
      const y = e.mixer[p.id];
      l.push(y.hue / 100, y.sat / 100, y.lum / 100), d.push(p.hue), (y.hue || y.sat || y.lum) && (c = 1);
    }
    o.uniform3fv(this.u("uMixer"), new Float32Array(l)), o.uniform1fv(this.u("uMixerHue"), new Float32Array(d)), r("uMixerOn", c), o.uniform3fv(this.u("uOverlay"), Jhe(e.overlay.color)), r("uOverlayOpacity", e.overlay.opacity / 100), o.uniform1i(this.u("uBlend"), Xhe[e.overlay.blend] || 0), r("uGrain", e.grain.amount / 100 * 0.22), r("uGrainSize", (1 + e.grain.size / 100 * 3) * (s.grainScale || 1)), r("uSeed", this.seed);
    const h = s.transfer, f = e.match;
    r("uMatch", h && f.to && f.stats ? f.amount / 100 : 0), o.uniform3fv(this.u("uMatchScale"), h ? h.scale : [1, 1, 1]), o.uniform3fv(this.u("uMatchShift"), h ? h.shift : [0, 0, 0]), r("uShowOriginal", s.original ? 1 : 0), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, this.tex), o.drawArrays(o.TRIANGLE_STRIP, 0, 4);
  }
  dispose() {
    const e = this.gl.getExtension("WEBGL_lose_context");
    e && e.loseContext();
  }
}
const J_ = 3, NI = [
  { kelvin: 1900, name: "Candlelight", color: "#ff9329" },
  { kelvin: 2800, name: "Golden", color: "#ffad5e" },
  { kelvin: 3200, name: "Tungsten", color: "#ffb46b" },
  { kelvin: 4300, name: "Warm white", color: "#ffd4a6" },
  { kelvin: 5600, name: "Daylight", color: "#fff4e5" },
  { kelvin: 6500, name: "Overcast", color: "#f2f5ff" },
  { kelvin: 8e3, name: "Blue hour", color: "#c9d9ff" }
], Zhe = ["#ff2bd6", "#2be4ff", "#ff3d3d", "#ff8a3d", "#ffd23d", "#3dff8a", "#3d7bff", "#9b5cff"], Qhe = [
  { id: "top", label: "Top", rotate: 0, elevation: 90 },
  { id: "front", label: "Front", rotate: 0, elevation: 0 },
  { id: "right", label: "Right", rotate: 90, elevation: 0 },
  { id: "left", label: "Left", rotate: -90, elevation: 0 },
  { id: "back", label: "Back", rotate: 180, elevation: 0 },
  { id: "bottom", label: "Bottom", rotate: 0, elevation: -90 }
];
let Z_ = 0;
function epe() {
  return Z_++, "l" + Date.now().toString(36) + Z_;
}
function ax(n) {
  var e, t, i;
  return {
    id: n.id || epe(),
    rotate: (e = n.rotate) != null ? e : -45,
    elevation: (t = n.elevation) != null ? t : 45,
    intensity: (i = n.intensity) != null ? i : 7,
    color: n.color || "#fff4e5",
    kelvin: n.kelvin === void 0 ? n.color ? null : 5600 : n.kelvin
  };
}
const D0 = [
  {
    id: "golden-hour",
    label: "Golden hour",
    swatch: ["#ffad5e", "#3b2a4a"],
    softness: "soft",
    lights: [{ rotate: -45, elevation: 0, intensity: 7, color: "#ffad5e", kelvin: 2800 }],
    words: "Golden hour: a low warm sun casting long soft shadows, with a warm glow in the air."
  },
  {
    id: "dusk-interiors",
    label: "Dusk, interiors lit",
    swatch: ["#ffcf8a", "#24345e"],
    softness: "soft",
    arch: !0,
    lights: [{ rotate: 0, elevation: 45, intensity: 3, color: "#c9d9ff", kelvin: 8e3 }],
    words: "Dusk at blue hour: a deep blue sky with a last warm glow at the horizon; every interior is lit with warm light that glows through the windows; exterior surfaces are lit softly by the sky."
  },
  {
    id: "night-facade",
    label: "Night, facade lit",
    swatch: ["#ffd9a0", "#0d1226"],
    softness: "hard",
    arch: !0,
    lights: [{ rotate: 0, elevation: -45, intensity: 6, color: "#ffd4a6", kelvin: 4300 }],
    words: "Night: a dark sky; the facade is washed by warm architectural uplights from the ground, with soft pools of light and deep shadows above them; windows glow faintly."
  },
  {
    id: "overcast",
    label: "Overcast",
    swatch: ["#f2f5ff", "#6b7280"],
    softness: "soft",
    arch: !0,
    lights: [{ rotate: 0, elevation: 45, intensity: 5, color: "#f2f5ff", kelvin: 6500 }],
    words: "Overcast sky: diffuse light from above with no hard shadows and soft, low contrast."
  },
  {
    id: "midday-sun",
    label: "Midday sun",
    swatch: ["#fff4e5", "#38506b"],
    softness: "hard",
    arch: !0,
    lights: [{ rotate: 45, elevation: 90, intensity: 9, color: "#fff4e5", kelvin: 5600 }],
    words: "Midday sun: bright, high sunlight with short, crisp shadows and a clear blue sky."
  },
  {
    id: "softbox",
    label: "Studio softbox",
    swatch: ["#ffffff", "#4b5563"],
    softness: "soft",
    lights: [
      { rotate: -45, elevation: 45, intensity: 7, color: "#fff4e5", kelvin: 5600 },
      { rotate: 90, elevation: 0, intensity: 3, color: "#fff4e5", kelvin: 5600 }
    ],
    words: "A large studio softbox as the key light with a gentle fill: clean, even, flattering light with soft shadow edges."
  },
  {
    id: "rim",
    label: "Rim light",
    swatch: ["#eef3ff", "#111827"],
    softness: "hard",
    lights: [{ rotate: 135, elevation: 0, intensity: 8, color: "#f2f5ff", kelvin: 6500 }],
    words: "The front of the subject stays dim, lit only by faint ambient light."
  },
  {
    id: "neon",
    label: "Neon",
    swatch: ["#ff2bd6", "#2be4ff"],
    softness: "soft",
    lights: [
      { rotate: -90, elevation: 0, intensity: 7, color: "#ff2bd6", kelvin: null },
      { rotate: 90, elevation: 0, intensity: 7, color: "#2be4ff", kelvin: null }
    ],
    words: "The rest of the scene is dark."
  },
  {
    id: "three-point",
    label: "Key, fill and rim",
    swatch: ["#ffb46b", "#5fd8ff"],
    softness: "hard",
    lights: [
      { rotate: 45, elevation: 45, intensity: 8, color: "#ffb46b", kelvin: 3200 },
      { rotate: -90, elevation: 0, intensity: 3, color: "#5fd8ff", kelvin: null },
      { rotate: 135, elevation: 0, intensity: 6, color: "#ff8a3d", kelvin: null }
    ],
    words: ""
  }
];
function lx(n) {
  return n && D0.find((e) => e.id === n) || null;
}
function tpe(n, e = "relight") {
  return { mode: e, softness: n.softness, look: n.id, lights: n.lights.map((t) => ax({ ...t })) };
}
function Tc() {
  return { mode: "relight", softness: "soft", look: null, lights: [ax({ rotate: -45, elevation: 45, intensity: 7, color: "#ffb46b", kelvin: 3200 })] };
}
function UI(n) {
  const e = lx(n.look);
  return !e || e.lights.length !== n.lights.length || e.softness !== n.softness ? !1 : e.lights.every((t, i) => {
    const s = n.lights[i];
    return s.rotate === t.rotate && s.elevation === t.elevation && s.intensity === t.intensity && s.color.toLowerCase() === t.color.toLowerCase();
  });
}
function Gl(n) {
  const e = (n % 360 + 360) % 360;
  return e > 180 ? e - 360 : e;
}
function Cc(n) {
  const e = Gl(Math.round(Gl(n) / 45) * 45);
  return e === -180 ? 180 : e;
}
function Q_(n) {
  return Math.max(-90, Math.min(90, Math.round(n / 45) * 45));
}
const GI = {
  0: "from the front (the camera's side)",
  45: "from the front right of the frame",
  90: "from the right side of the frame",
  135: "from behind on the right",
  180: "from directly behind",
  "-45": "from the front left of the frame",
  "-90": "from the left side of the frame",
  "-135": "from behind on the left"
}, e4 = [[-90, "from below"], [-45, "low, from below the subject"], [0, "at subject height"], [45, "high, about 45° above"], [90, "from directly overhead"]];
function t4(n, e) {
  return e.reduce((t, i) => Math.abs(i[0] - n) < Math.abs(t[0] - n) ? i : t)[1];
}
const dx = (n) => Math.abs(Gl(n.rotate)) >= 135, wm = (n) => n.elevation >= 75, km = (n) => n.elevation <= -75, npe = (n) => n <= 2 ? "faint" : n <= 4 ? "soft" : n <= 6 ? "moderate" : n <= 8 ? "strong" : "very strong";
function jI(n) {
  const e = /^#?([0-9a-f]{6})$/i.exec(n.trim()), t = e ? parseInt(e[1], 16) : 16777215;
  return [t >> 16 & 255, t >> 8 & 255, t & 255];
}
function ipe(n) {
  const [e, t, i] = jI(n).map((c) => c / 255), s = Math.max(e, t, i), o = Math.min(e, t, i), r = (s + o) / 2, a = s - o;
  if (a < 1e-6) return { h: 0, s: 0, l: r };
  const l = a / (1 - Math.abs(2 * r - 1));
  let d = s === e ? (t - i) / a % 6 : s === t ? (i - e) / a + 2 : (e - t) / a + 4;
  return d = (d * 60 + 360) % 360, { h: d, s: l, l: r };
}
const n4 = [
  [0, "red"],
  [14, "red-orange"],
  [30, "orange"],
  [45, "amber"],
  [56, "yellow"],
  [80, "lime green"],
  [120, "green"],
  [160, "teal"],
  [185, "cyan"],
  [205, "sky blue"],
  [225, "blue"],
  [250, "indigo"],
  [272, "violet"],
  [290, "purple"],
  [312, "magenta"],
  [335, "pink"],
  [360, "red"]
];
function HI(n) {
  if (n.kelvin) {
    const s = NI.find((a) => a.kelvin === n.kelvin), o = s ? s.name.toLowerCase() : "white";
    return (o === "daylight" ? "daylight" : o === "tungsten" ? "warm tungsten" : o === "overcast" ? "cool overcast" : o === "blue hour" ? "cool blue-hour" : o) + " (about " + n.kelvin + " K)";
  }
  const e = ipe(n.color);
  if (e.s < 0.18) return e.l > 0.5 ? "white" : "grey";
  let t = n4[0][1], i = 999;
  for (const [s, o] of n4) {
    const r = Math.abs(s - e.h);
    r < i && (i = r, t = o);
  }
  return (e.s < 0.45 ? "soft " : "") + t;
}
function spe(n, e) {
  const t = n.intensity / e.intensity;
  return t <= 0.45 ? "about a third as bright" : t <= 0.75 ? "about two thirds as bright" : t < 0.95 ? "a little dimmer" : t > 1.3 ? "brighter" : "as bright";
}
function Of(n) {
  const e = Gl(n.rotate) * Math.PI / 180, t = n.elevation * Math.PI / 180;
  return { x: Math.sin(e) * Math.cos(t), y: -Math.sin(t) };
}
function ope(n) {
  if (wm(n)) return "Tops of surfaces are lit; the sides fall into shade.";
  if (km(n)) return "Undersides are lit from below; upper surfaces fall into shadow.";
  if (dx(n)) return "The side facing the camera falls into shadow.";
  const e = Of(n);
  return e.x > 0.3 ? "Surfaces facing the right of the frame are lit; surfaces facing the left of the frame fall into shadow." : e.x < -0.3 ? "Surfaces facing the left of the frame are lit; surfaces facing the right of the frame fall into shadow." : "The side facing the camera is lit evenly.";
}
function rpe(n) {
  if (wm(n)) return "Shadows fall straight down.";
  if (km(n)) return "Shadows are cast upward.";
  if (dx(n)) return "Shadows fall toward the camera.";
  const e = Of(n);
  if (Math.hypot(e.x, e.y) < 0.3) return "Shadows fall behind the subject, mostly out of view.";
  const t = [];
  return e.x > 0.3 && t.push("toward the left of the frame"), e.x < -0.3 && t.push("toward the right of the frame"), e.y < -0.3 && t.push("down"), e.y > 0.3 && t.push("upward"), t.length || t.push(Math.abs(e.x) >= Math.abs(e.y) ? e.x > 0 ? "toward the left of the frame" : "toward the right of the frame" : e.y < 0 ? "down" : "upward"), "Shadows fall " + t.join(" and ") + ".";
}
function VI(n, e) {
  const t = n[e];
  return e === 0 || !t ? "Key" : dx(t) ? "Rim" : t.intensity < n[0].intensity ? "Fill" : "Second";
}
function ape(n) {
  const e = /* @__PURE__ */ new Map();
  return n.map((t, i) => {
    const s = VI(n, i), o = (e.get(s) || 0) + 1;
    return e.set(s, o), o > 1 ? s + " " + o : s;
  });
}
const lpe = "Relighting only: keep the people, pose, expression, composition, camera angle, materials and object colours; change only the light, shadows, highlights and colour cast.";
function dpe(n) {
  if (n.mode === "transfer") return cpe();
  const e = n.lights.length ? n.lights : Tc().lights, t = e[0], i = n.softness === "hard" ? "hard, with crisp shadow edges" : "soft and diffused", s = [lpe];
  e.forEach((r, a) => {
    const l = VI(e, a) + " light", d = a === 0 ? npe(r.intensity) + ", " + i : spe(r, t), c = wm(r) || km(r) ? t4(r.elevation, e4) : GI[String(Cc(r.rotate))] + ", " + t4(r.elevation, e4), h = l === "Rim light" ? ", outlining the edges" : "";
    s.push(l + ": " + HI(r) + " light " + c + h + ", " + d + ".");
  }), s.push(ope(t)), s.push(rpe(t));
  const o = lx(n.look);
  return o && o.words && UI(n) && s.push(o.words), s.join(" ");
}
function cpe() {
  return "Relight image 1 with the lighting of image 2: its direction, colour, softness and contrast. Keep everything in image 1 as it is: the people, pose, composition, camera angle, materials and object colours. Use image 2 only for its light, not for anything in it.";
}
function upe(n) {
  if (n.mode === "transfer") return "Light transfer";
  const e = lx(n.look);
  if (e && UI(n)) return e.label;
  const t = n.lights[0];
  if (!t) return "Relight";
  const i = wm(t) ? "from above" : km(t) ? "from below" : GI[String(Cc(t.rotate))].replace(" (the camera's side)", "").replace(" of the frame", "");
  return (n.lights.length > 1 ? n.lights.length + " lights, " : "") + HI(t).replace(/ \(about \d+ K\)/, "") + " key " + i;
}
function hpe(n, e) {
  const t = new Uint8ClampedArray(e * e * 4), i = n.lights.map((r) => {
    const a = Gl(r.rotate) * Math.PI / 180, l = r.elevation * Math.PI / 180, [d, c, h] = jI(r.color);
    return { x: Math.sin(a) * Math.cos(l), y: Math.sin(l), z: Math.cos(a) * Math.cos(l), r: d / 255, g: c / 255, b: h / 255, k: r.intensity / 7 };
  }), s = n.softness === "soft" ? 0.45 : 0.08, o = e / 2 - 1;
  for (let r = 0; r < e; r++)
    for (let a = 0; a < e; a++) {
      const l = (a + 0.5 - e / 2) / o, d = -(r + 0.5 - e / 2) / o, c = l * l + d * d, h = (r * e + a) * 4;
      if (c > 1) continue;
      const f = Math.sqrt(1 - c);
      let p = 0.06, y = 0.06, v = 0.075;
      for (const w of i) {
        const S = l * w.x + d * w.y + f * w.z, M = Math.max(0, (S + s) / (1 + s)), _ = n.softness === "hard" ? Math.pow(Math.max(0, S), 24) * 0.35 : Math.pow(Math.max(0, S), 8) * 0.12;
        p += (M * 0.85 + _) * w.r * w.k, y += (M * 0.85 + _) * w.g * w.k, v += (M * 0.85 + _) * w.b * w.k;
      }
      const x = Math.min(1, (1 - Math.sqrt(c)) * o * 0.9);
      t[h] = Math.min(255, Math.pow(p, 1 / 2.2) * 255), t[h + 1] = Math.min(255, Math.pow(y, 1 / 2.2) * 255), t[h + 2] = Math.min(255, Math.pow(v, 1 / 2.2) * 255), t[h + 3] = Math.round(255 * x);
    }
  return t;
}
function Tb(n) {
  const e = Gl(n.rotate) * Math.PI / 180, t = n.elevation * Math.PI / 180, i = Math.sin(e) * Math.cos(t), s = Math.sin(t), o = Math.cos(e) * Math.cos(t), r = 0.43;
  return { x: 0.5 + i * r, y: 0.5 - s * r, front: o >= -0.05 };
}
var ppe = Object.defineProperty, fpe = (n, e, t) => e in n ? ppe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Cb = (n, e, t) => fpe(n, typeof e != "symbol" ? e + "" : e, t);
const i4 = ["#ffffff", "#f4f1ea", "#d9d9de", "#8a8f99", "#16141f", "#e9d5c4", "#f6c9c9", "#cfe3f5", "#cdebd5", "#ffe9a8"], Ib = /* @__PURE__ */ new Map();
function s4(n) {
  let e = Ib.get(n);
  return e || (e = si(n).then((t) => Fhe(phe(t))), Ib.set(n, e), e.catch(() => Ib.delete(n))), e;
}
class mpe {
  constructor(e, t) {
    Cb(this, "studio", e), Cb(this, "board", t), Cb(this, "t"), this.t = /* @__PURE__ */ Xt({
      open: null,
      guard: null,
      busy: null,
      resize: { mode: "crop", ratio: "free", crop: { ...Bh }, frame: null, frameRatio: "16:9", words: "", for: null, auto: !1 },
      background: { mode: "remove", fill: void 0, words: "", refId: null, layer: Lh(), for: null },
      adjust: { a: Df(), group: "light", original: !1, source: null, for: null, band: "red", picked: null, picking: !1 },
      skin: lhe(),
      camera: { set: { ...Rp }, seed: null, lock: !0 },
      relight: { rig: Tc(), selected: null, refId: null },
      compare: null
    });
  }
  get stage() {
    return this.studio.stage.value;
  }
  // ---------------------------------------------------------------- one tool at a time
  /** Open a tool (the bar shows it, active); open again, or Close, and the bar is back. */
  open(e) {
    this.t.open === e || this.held() || this.leave(() => {
      this.t.open = e, this.t.compare = null, this.studio.finishEditing(), this.ready(e);
    });
  }
  /** Back to the bar, through the question if the tool has a change not yet made. */
  close(e) {
    if (!this.t.open) {
      e && e();
      return;
    }
    this.held() || this.leave(() => {
      this.t.open = null, e && e();
    });
  }
  /**
   * Leave the open tool, then do `then`: at once when nothing's pending, else
   * once you've chosen to apply or discard. True when it went at once.
   */
  leave(e) {
    const t = this.t.open;
    return this.held() ? !1 : !t || !this.pending(t) ? (t && this.reset(t), e(), !0) : (this.t.guard = { tool: t, then: e }, !1);
  }
  /** The question answered: apply the change (it becomes a version), or discard it; then what was asked for. */
  async answer(e) {
    const t = this.t.guard;
    t && (this.t.guard = null, !(e && !await this.apply(t.tool)) && (this.reset(t.tool), t.then && t.then()));
  }
  /** Stay in the tool (Escape on the question). */
  stay() {
    this.t.guard = null;
  }
  /** Whether a tool has a change showing on the stage that isn't a version yet. */
  pending(e = this.t.open) {
    const t = this.stage;
    if (!e || !t) return !1;
    if (e === "resize") {
      const i = this.t.resize;
      return i.for !== t.id ? !1 : i.mode === "crop" ? !K_(i.crop) : !!i.frame && R0(i.frame) && !i.auto;
    }
    if (e === "background") {
      const i = this.t.background;
      return i.for !== t.id ? !1 : i.mode === "remove" ? i.fill !== void 0 && this.isCutout(t) : i.mode === "adjust" ? nu(i.layer) : !1;
    }
    if (e === "adjust") {
      const i = this.t.adjust;
      if (i.for !== t.id) return !1;
      const s = t.made && t.made.tool === "adjust" && t.made.settings ? t.made.settings.adjust : void 0;
      return s ? JSON.stringify(o4(s)) !== JSON.stringify(o4(i.a)) : $0(i.a);
    }
    return !1;
  }
  /** A tool's stage state as it starts, for the picture on the stage. */
  ready(e) {
    const t = this.stage;
    if (t) {
      if (e === "resize") {
        const i = this.t.resize;
        i.for !== t.id && (i.for = t.id, i.crop = { ...Bh }, i.ratio = "free", i.frame = null), this.readyExpand();
      }
      if (e === "background") {
        const i = this.t.background;
        i.for !== t.id && (i.for = t.id, i.fill = void 0, i.layer = { ...Lh(), target: i.layer.target });
      }
      e === "adjust" && this.readyAdjust();
    }
  }
  /** A tool's change dropped: the stage shows the picture as it is. */
  reset(e) {
    if (this.t.busy) return;
    const t = this.stage;
    e === "resize" && (this.t.resize.crop = { ...Bh }, this.t.resize.ratio = "free", this.t.resize.frame = null, this.t.resize.frameRatio = "free", this.t.resize.auto = !1, this.t.resize.for = t ? t.id : null), e === "background" && (this.t.background.fill = void 0, this.t.background.layer = { ...Lh(), target: this.t.background.layer.target }, this.t.background.for = t ? t.id : null), e === "adjust" && (this.t.adjust.for = null, this.readyAdjust());
  }
  /** The picture on the stage changed: a tool's stage state is for the old one. */
  stageChanged() {
    const e = this.t.open;
    this.t.compare = this.t.compare && this.stage && this.t.compare.with !== this.stage.id ? this.t.compare : null, e && this.ready(e);
  }
  /** Apply the open tool's change: its version is made and takes the stage. */
  async apply(e = this.t.open) {
    return e ? e === "resize" ? this.t.resize.mode === "crop" ? this.applyCrop() : this.runTool("expand") : e === "background" ? this.t.background.mode === "adjust" ? this.applyLayers() : this.applyFill() : e === "adjust" ? this.applyAdjust() : !1 : !1;
  }
  // ---------------------------------------------------------------- Crop
  setRatio(e) {
    if (this.t.busy) return;
    const t = this.stage, i = this.t.resize;
    if (i.ratio = e, !t) return;
    i.for = t.id;
    const s = Mc(e, t.w, t.h);
    if (s == null) return;
    const o = i.crop;
    i.crop = xhe(s, t.w, t.h, { x: o.x + o.w / 2, y: o.y + o.h / 2 });
  }
  setCrop(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.resize.crop = e, t && (this.t.resize.for = t.id);
  }
  /** The crop's size in the picture's pixels. */
  cropPixels() {
    const e = this.stage;
    return e ? E0(this.t.resize.crop, e.w, e.h) : { w: 0, h: 0 };
  }
  async applyCrop() {
    const e = this.stage, t = this.t.resize;
    if (!e || K_(t.crop)) return !1;
    const i = { ...t.crop }, s = t.ratio;
    return this.bake("Cropping", async () => {
      const o = await si(e.url), r = hhe(o, i), a = E0(i, e.w, e.h);
      return this.studio.addVersion(r, { tool: "crop", label: _he(s, a), settings: { crop: i, ratio: s } }, e);
    }, () => {
      t.crop = { ...Bh }, t.ratio = "free";
    });
  }
  // ---------------------------------------------------------------- Expand (Bria)
  /**
   * Expand opens with the shape it lights already framed (CHAT-41: its New
   * size read the picture's own size while 16:9 was lit and no frame made).
   * The frame isn't a change of yours until you touch it, so leaving doesn't ask.
   */
  readyExpand() {
    const e = this.stage, t = this.t.resize;
    if (!e || t.mode !== "expand" || t.frameRatio === "free" || t.for === e.id && t.frame) return;
    const i = Mc(t.frameRatio, e.w, e.h);
    i != null && (t.for = e.id, t.frame = kb(i, e.w, e.h, 1.06), t.auto = !0);
  }
  setFrameRatio(e) {
    if (this.t.busy) return;
    const t = this.stage, i = this.t.resize;
    if (i.auto = !1, i.frameRatio = e, !t) return;
    i.for = t.id;
    const s = Mc(e, t.w, t.h);
    i.frame = s == null ? i.frame || kb(t.w / t.h, t.w, t.h, 1.25) : kb(s, t.w, t.h, 1.06);
  }
  setFrame(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.resize.frame = e, this.t.resize.auto = !1, t && (this.t.resize.for = t.id);
  }
  frame() {
    const e = this.stage;
    return e ? this.t.resize.frame || LI(e.w, e.h) : null;
  }
  // ---------------------------------------------------------------- Background
  /** Whether the picture is a cut-out (Remove background's result, or anything see-through). */
  isCutout(e) {
    if (!e) return !1;
    if (e.made && (e.made.tool === "removebg" || e.made.settings && e.made.settings.cutout)) return !0;
    const t = e.runId ? this.board.studioRecords.get("edit:" + e.runId) : void 0;
    return !!t && t.role === "edit" && t.studio === "removebg";
  }
  /** The cut-out a background adjustment needs: the stage picture's own Remove background result, if there is one. */
  cutoutFor(e) {
    return e ? this.isCutout(e) ? e : this.studio.items.value.find((t) => t.parentId === e.id && t.status === "done" && this.isCutout(t)) || null : null;
  }
  setFill(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.background.fill = e, t && (this.t.background.for = t.id);
  }
  async applyFill() {
    const e = this.stage, t = this.t.background.fill;
    return !e || t === void 0 || !this.isCutout(e) ? !1 : this.bake("Filling the background", async () => {
      const i = await si(e.url), s = RI(i, t), o = t ? "Background filled" : "Background see-through";
      return this.studio.addVersion(s, { tool: "background", label: o, settings: { fill: t, cutout: !t } }, e, { alpha: !t });
    }, () => {
      this.t.background.fill = void 0;
    });
  }
  setLayer(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.background.layer = { ...this.t.background.layer, ...e }, t && (this.t.background.for = t.id);
  }
  async applyLayers() {
    const e = this.stage, t = this.cutoutFor(e), i = this.t.background.layer;
    if (!e || !t || !nu(i)) return !1;
    const s = t === e ? e.parentId && this.studio.items.value.find((o) => o.id === e.parentId) || null : e;
    return s ? this.bake("Adjusting the " + (i.target === "background" ? "background" : "subject"), async () => {
      const [o, r] = await Promise.all([si(s.url), si(t.url)]), a = wl(o.width, o.height), l = zI(o, r, i, a.w, a.h);
      return this.studio.addVersion(l, { tool: "layers", label: i.target === "background" ? "Background adjusted" : "Subject adjusted", settings: { layer: { ...i } } }, s);
    }, () => {
      this.t.background.layer = { ...Lh(), target: i.target };
    }) : !1;
  }
  // ---------------------------------------------------------------- Adjust
  /** Adjust as it opens on the stage picture: an Adjust version reopens with its settings, drawn from its own original. */
  readyAdjust() {
    const e = this.stage, t = this.t.adjust;
    if (!e || t.for === e.id) return;
    t.for = e.id;
    const i = e.made && e.made.tool === "adjust" && e.made.settings ? e.made.settings.adjust : void 0, s = i && e.parentId ? this.studio.items.value.find((o) => o.id === e.parentId && o.status === "done") : null;
    i && s ? (t.a = iu(i), t.source = s.id) : (t.a = Df(), t.source = e.id);
  }
  /** The picture Adjust draws from. */
  adjustSource() {
    const e = this.t.adjust.source;
    return e && this.studio.items.value.find((t) => t.id === e) || this.stage;
  }
  setAdjust(e) {
    this.t.busy || (this.t.adjust.a = e);
  }
  /** Match colours to another version: its colour read, then carried onto this one as you set how much. */
  async matchTo(e) {
    if (this.t.busy) return;
    const t = this.t.adjust.a;
    if (!e) {
      this.t.adjust.a = { ...t, match: { to: null, amount: 0, stats: null }, look: null };
      return;
    }
    const i = this.studio.items.value.find((s) => s.id === e);
    if (i)
      try {
        const s = await s4(i.url);
        this.t.adjust.a = { ...this.t.adjust.a, match: { to: e, amount: this.t.adjust.a.match.amount || 80, stats: s } };
      } catch (s) {
        console.warn("[board] that version's colour couldn't be read", s), this.studio.say("That version's colour couldn't be read");
      }
  }
  /** How Match colours moves this picture's colour, for the shader (null when it isn't matched). */
  async transfer(e = this.t.adjust.a, t = this.adjustSource()) {
    if (!e.match.to || !e.match.stats || !t) return null;
    try {
      return Nhe(await s4(t.url), e.match.stats);
    } catch {
      return null;
    }
  }
  async applyAdjust() {
    const e = this.adjustSource(), t = iu(this.t.adjust.a);
    return !e || !$0(t) ? !1 : this.bake("Applying your adjustments", async () => {
      const i = await si(e.url), s = new FI(document.createElement("canvas"));
      try {
        const o = wl(i.width, i.height, Math.min(8192, s.maxSize())), r = su(t, o.w, o.h);
        s.setImage(i, i.width, i.height), s.render(t, r.w, r.h, { transfer: await this.transfer(t, e), grainScale: r.w / Math.max(1, su(t, i.width, i.height).w) });
        const a = Rn(r.w, r.h);
        return zn(a).drawImage(s.canvas, 0, 0), this.studio.addVersion(a, { tool: "adjust", label: Lhe(t), settings: { adjust: t } }, e, { alpha: EI(i) });
      } finally {
        s.dispose();
      }
    }, () => {
      this.t.adjust.for = null;
    });
  }
  // ---------------------------------------------------------------- shared
  /**
   * While a tool's version is being made, nothing else moves (IL-100; Adam:
   * changing exposure or resize while one applied raced it): it says so, and
   * the tools, their settings and the stage wait for it.
   */
  held() {
    const e = this.t.busy;
    return e ? (this.studio.say("One moment: " + e.charAt(0).toLowerCase() + e.slice(1)), !0) : !1;
  }
  /** Make a tool's version: one at a time, said in the bar while it's made. */
  async bake(e, t, i) {
    if (this.t.busy) return !1;
    this.t.busy = e, this.studio.s.baking = e;
    try {
      return await t() ? (i(), !0) : !1;
    } catch (s) {
      return console.warn("[board] a tool's version couldn't be made", s), this.studio.say(s instanceof Error && /read|draw|saved|uploaded/i.test(s.message) ? s.message.replace(/\.$/, "") : "That couldn't be made. Please try again"), !1;
    } finally {
      this.t.busy = null, this.studio.s.baking = null;
    }
  }
  // ---------------------------------------------------------------- the model tools' runs
  /** A reference picture a tool sends as image 2 (Replace background's, Light transfer's). */
  refItem(e) {
    return e && this.studio.items.value.find((t) => t.id === e && t.status === "done") || null;
  }
  /** A model tool's run, as its plan: the stage picture, the tool's settings as its model's inputs, its words. */
  plan(e) {
    var t;
    const i = this.stage, s = this.studio.modelOf(e);
    if (!i || i.status !== "done" || !s) return null;
    const o = { w: i.w, h: i.h }, r = { kind: e, model: s, words: "", count: this.studio.countOf(e), base: i.id }, a = { kind: "item", item: i, marks: !1 }, l = s.fields.find((c) => c.placement === "prompt"), d = l ? String((t = this.studio.valueOf(e, l)) != null ? t : "") : "";
    if (e === "upscale")
      return { ...r, pics: [a], compiled: d, inputs: this.studio.editInputs(e, s, null), settings: { label: vpe(s, this.studio.valueOfKey(e, "scale")) } };
    if (e === "removebg")
      return { ...r, count: 1, pics: [a], compiled: d, inputs: this.studio.editInputs(e, s, null), settings: { label: "" } };
    if (e === "replacebg") {
      const c = this.refItem(this.t.background.refId), h = this.t.background.words;
      return {
        ...r,
        words: h,
        pics: c ? [a, { kind: "item", item: c, marks: !1 }] : [a],
        compiled: rhe(h, !!c),
        inputs: this.studio.editInputs(e, s, o),
        settings: { label: bpe(h) || (c ? "from a picture" : "") }
      };
    }
    if (e === "skin")
      return { ...r, pics: [a], compiled: dhe(this.t.skin), inputs: this.studio.editInputs(e, s, o), settings: { label: "", skin: { ...this.t.skin } } };
    if (e === "expand") {
      const c = this.frame();
      if (!c) return null;
      const h = Che(c), f = this.t.resize.words, p = {
        canvasWidth: h.canvas_size[0],
        canvasHeight: h.canvas_size[1],
        imageWidth: h.original_image_size[0],
        imageHeight: h.original_image_size[1],
        imageX: h.original_image_location[0],
        imageY: h.original_image_location[1]
      }, y = { ...this.studio.editInputs(e, s, null), ...U_(s, p) };
      return {
        ...r,
        count: 1,
        words: f,
        pics: [a],
        compiled: f.trim(),
        inputs: y,
        settings: { label: Rhe(this.t.resize.frameRatio, c), frame: { ...c } }
      };
    }
    if (e === "camera") {
      const c = this.t.camera, h = ro(c.set), f = Xne(h, c.lock ? this.seed() : null), p = { ...this.studio.editInputs(e, s, null), ...U_(s, f, { rotate: /rotate|horizontal/i, vertical: /vertical/i, zoom: /zoom/i }) };
      return {
        ...r,
        count: this.studio.countOf(e),
        pics: [a],
        compiled: d,
        inputs: p,
        settings: { label: kc(h), camera: h }
      };
    }
    if (e === "relight") {
      const c = this.t.relight, h = c.rig.mode === "transfer" ? this.refItem(c.refId) : null;
      return {
        ...r,
        pics: h ? [a, { kind: "item", item: h, marks: !1 }] : [a],
        compiled: dpe(c.rig),
        inputs: this.studio.editInputs(e, s, o),
        settings: { label: upe(c.rig), rig: JSON.parse(JSON.stringify(c.rig)) }
      };
    }
    return null;
  }
  /** What stops a tool's run before its model's own checks. */
  problem(e, t = !1) {
    const i = this.stage;
    if (!i || i.status !== "done") return "Pick an image first";
    if (!this.studio.modelOf(e)) return (gpe[e] || "This") + " isn't available here yet";
    if (e === "replacebg" && !t && !this.t.background.words.trim() && !this.refItem(this.t.background.refId)) return "Say what background you want, or pick a picture of it";
    if (e === "expand") {
      const s = this.frame();
      if (!s || !R0(s)) return "Drag the frame past the picture, or pick a shape";
    }
    return e === "relight" && this.t.relight.rig.mode === "transfer" && !this.refItem(this.t.relight.refId) ? "Pick the picture whose light to copy" : null;
  }
  /** Send a model tool's run: with the prompt it puts together, or your own full prompt instead (IL-076). */
  async runTool(e, t = null) {
    const i = this.problem(e, t != null);
    if (i)
      return this.studio.say(i), !1;
    const s = this.plan(e);
    if (!s) return !1;
    const o = this.t.resize.frame, r = this.t.resize.words, a = await this.studio.run(t != null ? { ...s, compiled: t } : s);
    return a && e === "expand" && (this.t.resize.frame === o && (this.t.resize.frame = null), this.t.resize.words === r && (this.t.resize.words = "")), a;
  }
  /**
   * The colour mixer's picker (CHAT-42: Adam couldn't tell what the mixer was
   * for): a click on the picture (fx, fy: 0 to 1 across it) picks its colour,
   * and the mixer goes to that colour's band, so its sliders move what you picked.
   */
  async pickColourAt(e, t) {
    const i = this.t.adjust;
    i.picking = !1;
    const s = this.stage, o = i.source ? this.studio.itemById(i.source) : null, r = o && o.url || (s ? s.url : "");
    if (r)
      try {
        const a = await si(r), l = Math.min(a.width - 1, Math.max(0, Math.round(e * a.width))), d = Math.min(a.height - 1, Math.max(0, Math.round(t * a.height))), c = Rn(5, 5), h = zn(c);
        h.drawImage(a, l - 2, d - 2, 5, 5, 0, 0, 5, 5);
        const f = h.getImageData(0, 0, 5, 5).data;
        let p = 0, y = 0, v = 0;
        for (let S = 0; S < f.length; S += 4)
          p += f[S], y += f[S + 1], v += f[S + 2];
        const x = f.length / 4, w = [p / x / 255, y / x / 255, v / x / 255];
        i.picked = w, i.band = jhe(w);
      } catch {
        this.studio.say("That colour couldn't be read from the picture.");
      }
  }
  /** Change camera's seed, kept while you nudge the sliders so a small move doesn't reshuffle the picture. */
  seed() {
    return this.t.camera.seed == null && (this.t.camera.seed = Math.floor(Math.random() * 2147483646) + 1), this.t.camera.seed;
  }
  setCamera(e) {
    this.t.camera.set = ro({ ...this.t.camera.set, ...e });
  }
  // ---------------------------------------------------------------- Compare
  /** Compare the stage picture with another version: Split (a slider) or Toggle. */
  compare(e, t = this.t.compare ? this.t.compare.mode : "split") {
    const i = this.stage;
    if (!e || !i || e === i.id) {
      this.t.compare = null;
      return;
    }
    this.t.compare = { with: e, mode: t, at: this.t.compare ? this.t.compare.at : 0.5, other: !1 };
  }
  /** What Compare starts against: the version the stage picture was made from, else its original. */
  compareDefault() {
    const e = this.stage;
    if (!e) return null;
    if (e.parentId && this.studio.items.value.some((i) => i.id === e.parentId && i.status === "done")) return e.parentId;
    const t = this.studio.rootId.value;
    return t && t !== e.id ? t : null;
  }
  dispose() {
    this.t.guard = null;
  }
}
const gpe = {
  upscale: "Upscaling",
  removebg: "Removing backgrounds",
  replacebg: "Replacing backgrounds",
  expand: "Expand",
  skin: "Improve people",
  camera: "Change camera",
  relight: "Relight",
  erase: "Erase",
  select: "Picking objects"
};
function o4(n) {
  const e = iu(n);
  return e.look = null, e.match = { ...e.match, stats: null }, e;
}
function bpe(n) {
  const e = n.trim().split(/\s+/).filter(Boolean);
  return e.slice(0, 5).join(" ") + (e.length > 5 ? "…" : "");
}
function vpe(n, e) {
  const t = typeof e == "number" ? e : typeof e == "string" ? parseFloat(e) : NaN;
  return Number.isFinite(t) ? t + "×" : n.name;
}
var ype = Object.defineProperty, xpe = (n, e, t) => e in n ? ype(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, bt = (n, e, t) => xpe(n, typeof e != "symbol" ? e + "" : e, t);
const O0 = ["#ff3d6e", "#ffc93c", "#36d6ff", "#ffffff", "#16141f"], wpe = 0.5, WI = ["threed", "edit", "erase", "upscale", "removebg", "replacebg", "expand", "skin", "camera", "relight", "select"], r4 = 700, Ab = 1024, kpe = 1400, qI = (n) => "rd-board-studio:" + n, KI = "Your edited prompt runs instead: use Run with this prompt, or reset it";
class _pe {
  constructor(e, t) {
    bt(this, "board", e), bt(this, "sessionId", t), bt(this, "s"), bt(this, "items"), bt(this, "boardItems"), bt(this, "historySessions"), bt(this, "side"), bt(this, "video"), bt(this, "genMode"), bt(this, "stage"), bt(this, "family"), bt(this, "rootId"), bt(this, "names"), bt(this, "shown"), bt(this, "queueItems"), bt(this, "editRefItems"), bt(this, "dockModel"), bt(this, "limit"), bt(this, "session"), bt(this, "models3d"), bt(this, "model3d"), bt(this, "card"), bt(this, "tools"), bt(this, "parentOf"), bt(this, "undo", /* @__PURE__ */ new Map()), bt(this, "redo", /* @__PURE__ */ new Map()), bt(this, "newText", null), bt(this, "textBefore", ""), bt(this, "newPin", null), bt(this, "pinBefore", ""), bt(this, "noteTimer", 0), bt(this, "queueKey", ""), bt(this, "promptTimer", 0), bt(this, "promptBase", ""), bt(this, "keeping", []), bt(this, "dirty", /* @__PURE__ */ new Set()), bt(this, "marksTimer", 0), bt(this, "awaiting", /* @__PURE__ */ new Map()), bt(this, "resumed", /* @__PURE__ */ new Set()), bt(this, "flat", /* @__PURE__ */ new Map()), bt(this, "files", /* @__PURE__ */ new Map()), bt(this, "scope", c1(!0));
    const i = Ipe(e.user.uid), s = {};
    for (const a of WI) s[a] = i[a] || { modelId: "", count: 1, inputs: {} };
    this.s = /* @__PURE__ */ Xt({
      studio: "prompt",
      last: { generate: "prompt", edit: "edit" },
      modes: s,
      bar: "edit",
      areaTool: "brush",
      areaCut: !1,
      areaSize: 48,
      precision: !0,
      objects: {},
      baking: null,
      finishing: [],
      stageId: null,
      queue: [],
      editRefs: [],
      dropper: !1,
      refPulse: null,
      fullOpen: {},
      fullEdits: {},
      wordsOnly: Ape(e.user.uid),
      sessions: [],
      pinned: !1,
      columns: X8(e.user.uid),
      histShut: Epe(e.user.uid),
      peekId: null,
      cardId: null,
      marks: {},
      asks: {},
      tool: "brush",
      color: O0[0],
      opacity: wpe,
      size: 5,
      selection: [],
      editingText: null,
      editingPin: null,
      histRev: 0,
      prompt: e.promptOf(t).prompt || "",
      sending: 0,
      ghosts: [],
      three: { model: null, cam: null, backdrop: "studio", aspect: "16:9", loading: !1, keeping: null, error: null },
      note: null
    }), this.session = I(() => {
      e.docRev.value;
      const a = e.store.get(t);
      return a && a.type === "tool" ? a : null;
    }), this.video = I(() => {
      const a = this.session.value;
      return !!a && (a.kitId === "video" || a.kitId === "videoEdit");
    });
    const o = I(() => e.studioRecords.forSession(t)), r = I(() => o.value.filter((a) => a.role === "ref"));
    this.models3d = I(() => o.value.filter((a) => a.role === "model").sort((a, l) => a.createdAt - l.createdAt)), this.model3d = I(() => this.models3d.value.find((a) => a.id === this.s.three.model) || null), this.parentOf = (a) => {
      const l = this.s.ghosts.find((p) => p.id === a);
      if (l) return l.parentId;
      const d = e.studioRecords.get(a);
      if (d && d.role === "ref") return d.base && d.base !== a ? d.base : null;
      const c = e.results.get(a), h = c ? c.runId : a.includes(":") ? a.split(":")[0] : null;
      if (!h) return null;
      const f = e.studioRecords.get(Ep(h));
      return f && f.role === "edit" && f.base !== a ? f.base : null;
    }, this.items = I(() => {
      e.results.rev.value, e.studioRecords.rev.value;
      const a = this.hidden(e.studioRecords.forSession(t)), l = e.results.list(t).filter((c) => l4(c, a)).map((c) => this.genItem(c)), d = r.value.map((c) => a4(c));
      return [...this.s.ghosts, ...l, ...d].sort((c, h) => h.createdAt - c.createdAt);
    }), this.boardItems = I(() => {
      e.results.rev.value, e.docRev.value;
      const a = this.items.value.filter((d) => !(d.kind === "ref" && d.how === "board")), l = this.hidden(e.studioRecords.all());
      for (const d of e.store.all())
        if (!(d.type !== "tool" || d.id === t))
          for (const c of e.results.list(d.id))
            l4(c, l) && a.push({ ...this.genItem(c), parentId: null, sessionId: d.id });
      return a.sort((d, c) => c.createdAt - d.createdAt);
    }), this.historySessions = I(() => {
      const a = /* @__PURE__ */ new Map();
      for (const h of this.boardItems.value) {
        const f = h.sessionId || t;
        a.set(f, (a.get(f) || 0) + 1);
      }
      const l = e.recentTools(), d = l.find((h) => h.id === t), c = l.filter((h) => h.id !== t && (a.has(h.id) || e.isPinned(h.id)));
      return [...d ? [d] : [], ...c].map((h) => ({
        id: h.id,
        name: h.name,
        icon: h.icon || "Image",
        count: a.get(h.id) || 0,
        here: h.id === t,
        pinned: e.isPinned(h.id)
      }));
    }), this.side = I(() => B_[this.s.studio]), this.genMode = I(() => this.side.value === "generate" ? this.s.studio : this.s.last.generate), this.stage = I(() => this.items.value.find((a) => a.id === this.s.stageId) || null), this.family = I(() => Gue(this.items.value, this.parentOf, this.s.stageId)), this.rootId = I(() => this.s.stageId ? _I(this.parentOf, this.s.stageId) : null), this.names = I(() => {
      const a = jue(this.family.value, this.rootId.value), l = this.rootId.value ? this.family.value.find((d) => d.id === this.rootId.value) : null;
      return l && l.kind === "gen" && a.set(l.id, l.label), a;
    }), this.shown = I(() => {
      if (this.s.pinned) return this.pinnedItems();
      const a = this.pickedSessions();
      return a.length ? this.boardItems.value.filter((l) => a.includes(l.sessionId || t)) : this.boardItems.value;
    }), this.queueItems = I(() => {
      const a = new Map(this.items.value.map((l) => [l.id, l]));
      return this.s.queue.map((l) => a.get(l)).filter((l) => !!l);
    }), this.editRefItems = I(() => {
      const a = new Map(this.items.value.map((l) => [l.id, l]));
      return this.s.editRefs.map((l) => a.get(l)).filter((l) => !!l && l.status === "done");
    }), this.dockModel = I(() => this.modelOf(this.genMode.value)), this.limit = I(() => zo(this.dockModel.value)), this.card = I(() => (e.docRev.value, this.cardFor(this.family.value))), this.promptBase = this.s.prompt, this.tools = new mpe(this, e), this.scope.run(() => {
      Ee(() => e.studioRecords.rev.value, () => this.readMarks(), { immediate: !0 }), Ee(() => e.results.rev.value, () => this.landResults(), { immediate: !0 }), Ee(() => this.s.modes, () => zpe(e.user.uid, this.s.modes), { deep: !0 }), Ee(() => this.s.stageId, () => this.dropStaleEdits()), Ee(() => e.promptOf(t).prompt || "", (a) => {
        const l = this.s.prompt === this.promptBase;
        this.promptBase = a, l && (this.s.prompt = a);
      }), Ee(() => this.promptPictures(), (a) => {
        a !== this.queueKey && this.loadQueue();
      }), Ee(() => this.s.dropper && (this.side.value === "edit" ? !!this.tools.t.open || !this.takesRefs() : !this.limit.value), (a) => {
        a && (this.s.dropper = !1);
      }), Ee(this.side, () => {
        this.s.dropper = !1;
      });
    });
  }
  /**
   * Results no one should see as pictures: a helper run's (Select's map of a
   * picture's objects), one a Precision version stands in for, and one being
   * finished here (IL-073). Run ids are kept as "run:" and the id.
   */
  hidden(e) {
    const t = new Set(this.s.finishing);
    for (const i of e)
      i.role === "edit" && i.helper && t.add("run:" + i.runId), i.role === "ref" && i.made && i.made.from && t.add(i.made.from);
    return t;
  }
  genItem(e) {
    return {
      id: e.id,
      kind: "gen",
      url: e.url,
      w: e.w || 4,
      h: e.h || 3,
      createdAt: e.createdAt,
      parentId: this.parentOf(e.id),
      label: this.labelOf(e),
      status: e.status === "done" ? "done" : e.status === "pending" ? "pending" : "failed",
      result: e,
      asset: e.asset || null,
      runId: e.runId
    };
  }
  /**
   * A result's name here: what its person wrote (a Studios view run's prompt
   * is their words, then lines for the model, which aren't a name), else
   * what kind of run it was.
   */
  labelOf(e) {
    const t = e.runId ? this.board.studioRecords.get(Ep(e.runId)) : void 0, i = t && t.role === "edit" ? t : null;
    if (i && !["edit", "draw", "comment", "threed"].includes(i.studio)) {
      const o = gb[i.studio] || "Edit", r = i.settings && typeof i.settings.label == "string" ? i.settings.label : "";
      return r ? o + " · " + r : o;
    }
    const s = Tpe(e.prompt || "");
    return s ? zb(s, 7) : i ? gb[i.studio] || "Edit" : e.prompt && /^Image 1 is the image to edit/.test(e.prompt) ? "From image 1" : e.label || e.model || "Generation";
  }
  // ---------------------------------------------------------------- entering
  /**
   * Open on an image (Edit: it goes on the stage, ready to mark up, and is
   * queued as image 1 for the Generate side; its versions run under the
   * stage) or on the session alone (Generate, Prompt).
   */
  enter(e) {
    if (this.loadQueue(), this.s.prompt = this.board.promptOf(this.sessionId).prompt || "", this.promptBase = this.s.prompt, this.s.editingPin = null, this.s.editingText = null, this.s.selection = [], e && this.as3d(this.entryModel3d(e))) {
      this.s.cardId = null;
      return;
    }
    const t = e ? this.itemFor(e) : null;
    this.s.cardId = e && e.elementId ? e.elementId : null, t ? (this.s.stageId = t.id, this.limit.value && this.setQueue(Oh(this.s.queue, t.id, this.limit.value).queue), this.s.studio = this.video.value ? "prompt" : this.s.last.edit) : (this.s.stageId = null, this.s.studio = "prompt", this.s.last.generate = "prompt");
  }
  /** The 3D model an entry is, where it's one: a 3D result, or a 3D model placed on the board from your Library. */
  entryModel3d(e) {
    if (e.resultId) return Rb(this.board.results.get(e.resultId));
    const t = e.elementId ? this.board.store.get(e.elementId) : void 0;
    if (!t || t.type !== "image") return null;
    const i = t;
    return Rb(i.resultId && this.board.results.get(i.resultId) || i);
  }
  /** The item for a board image or a result; an image no session made comes in as a reference. */
  itemFor(e) {
    const t = this.items.value;
    if (e.resultId) return t.find((l) => l.id === e.resultId) || null;
    if (!e.elementId) return null;
    const i = this.board.store.get(e.elementId);
    if (!i || i.type !== "image") return null;
    if (i.resultId) {
      const l = t.find((d) => d.id === i.resultId);
      if (l) return l;
    }
    const s = t.find((l) => l.url === i.src);
    if (s) return s;
    const o = i.asset || this.board.assetFor(i.src), r = ba(o), a = this.addRef({
      how: "board",
      url: i.src,
      w: r ? r.width : i.w,
      h: r ? r.height : i.h,
      label: i.label || "Board image",
      asset: o,
      source: i.resultId || null
    });
    return r || this.measureRef(a.id, i.src), a;
  }
  /** A reference whose record holds no size takes its picture's own, once it loads (IL-100). */
  measureRef(e, t) {
    Id(t).then((i) => {
      if (i.w === 4 && i.h === 3) return;
      const s = this.board.studioRecords.get(e);
      s && s.role === "ref" && (s.pw !== i.w || s.ph !== i.h) && this.board.studioRecords.patch(e, { pw: i.w, ph: i.h });
    });
  }
  // ---------------------------------------------------------------- models and settings
  /** The models a studio offers, from the board's catalog. */
  modelsFor(e) {
    const t = this.session.value;
    return nhe(this.board.catalog.value, e, t ? t.kitId : null);
  }
  /** A studio's model: Prompt's is the session's; the others keep their own. */
  modelOf(e) {
    if (e === "prompt") {
      const s = this.session.value;
      return s ? this.board.modelFor(s).model : null;
    }
    const t = this.modelsFor(e), i = this.s.modes[e].modelId;
    return t.find((s) => s.id === i) || t.find((s) => AI.test(s.name)) || t[0] || null;
  }
  setModel(e, t) {
    if (e === "prompt") {
      this.board.patchTool(this.sessionId, { model: t.name, nodeDefId: t.id });
      return;
    }
    const i = this.s.modes[e];
    i.modelId !== t.id && (this.s.modes[e] = { modelId: t.id, count: i.count, inputs: {} });
  }
  /** How many a studio makes, within what its model allows. */
  countOf(e) {
    const t = this.modelOf(e), i = e === "prompt" ? this.board.promptOf(this.sessionId).n || (t ? t.numResults.def : 1) || 1 : this.s.modes[e].count;
    return t ? Math.max(t.numResults.min, Math.min(t.numResults.max, i)) : i;
  }
  setCount(e, t) {
    const i = this.modelOf(e), s = i ? Math.max(i.numResults.min, Math.min(Math.min(i.numResults.max, 8), t)) : Math.max(1, Math.min(4, t));
    e === "prompt" ? this.board.setPrompt(this.sessionId, { n: s }) : this.s.modes[e].count = s;
  }
  /** The most a studio's count goes to. */
  maxCount(e) {
    const t = this.modelOf(e);
    return t ? Math.min(t.numResults.max, 8) : 4;
  }
  /** The least it goes to: its model's least. */
  minCount(e) {
    const t = this.modelOf(e);
    return t ? Math.max(1, t.numResults.min) : 1;
  }
  /** A studio's values for its model's inputs: Prompt's are your session prompt's. */
  inputsOf(e) {
    return e === "prompt" ? { ...this.board.promptOf(this.sessionId).inputs || {} } : { ...this.s.modes[e].inputs };
  }
  /** The chips a studio shows under its words: its model's chip inputs. */
  chipsOf(e) {
    const t = this.modelOf(e);
    return t ? t.fields.filter((i) => i.placement === "chip" && i.kind !== "model") : [];
  }
  /** The chips that can be changed here (a choice, a switch or a slider), less any the run sets itself. */
  shownChips(e, t = []) {
    return this.chipsOf(e).filter((i) => !t.includes(i.key) && (i.kind === "boolean" || i.kind === "slider" || !!(i.options && i.options.length)));
  }
  /** A chip's value as the run will send it: an Edit studio's and 3D's shape follow their picture's unless you chose one. */
  valueOf(e, t) {
    const i = this.modelOf(e);
    if (!i || e === "prompt") return Lc(t, { inputs: this.inputsOf(e) });
    const s = this.editInputs(e, i, this.shapeSource(e));
    return Lc(t, { inputs: s, prompt: t.placement === "prompt" ? s[t.key] : void 0 });
  }
  /** v1's "Match Media Input" (B26): the size nearest the picture the run sends in the input this size follows. */
  matchOf(e, t) {
    const i = t.kind === "size" ? this.previewUp(e) : null;
    return i ? o8(i.model, t, i.up, (s) => this.board.measuredSize(s)) : null;
  }
  setInput(e, t, i) {
    if (e === "prompt") {
      const s = this.board.promptOf(this.sessionId);
      this.board.setPrompt(this.sessionId, { inputs: { ...s.inputs || {}, [t]: i } });
      return;
    }
    this.s.modes[e] = { ...this.s.modes[e], inputs: { ...this.s.modes[e].inputs, [t]: i } };
  }
  // ---------------------------------------------------------------- studios
  needsImage(e) {
    return e === "edit";
  }
  canUse(e) {
    if (this.video.value && e !== "prompt") return !1;
    if (!this.needsImage(e)) return !0;
    const t = this.stage.value;
    return !!t && t.status === "done";
  }
  setStudio(e) {
    this.canUse(e) && (this.finishEditing(), this.s.studio = e, this.s.last[B_[e]] = e, this.s.selection = [], e === "threed" && !this.s.three.model && this.models3d.value.length && (this.s.three.model = this.models3d.value[this.models3d.value.length - 1].id));
  }
  /** Generate or Edit: back to the studio last open there. Edit needs a picture. */
  setSide(e) {
    if (this.side.value !== e) {
      if (e === "edit" && this.video.value) {
        this.say("Edit changes pictures: this session makes videos");
        return;
      }
      if (e === "edit" && !this.toEdit()) {
        this.say("Make an image or bring one in first, then edit it");
        return;
      }
      e === "edit" && this.s.stageId && this.from3d(this.s.stageId) || this.setStudio(this.s.last[e]);
    }
  }
  /** There's something to edit: a finished picture in history. */
  canEdit() {
    return this.items.value.some((e) => e.status === "done");
  }
  /** The stage's picture, or else the newest finished one, put on the stage. */
  toEdit() {
    const e = this.stage.value;
    if (e && e.status === "done") return !0;
    const t = this.items.value.find((i) => i.status === "done");
    return t ? (this.show(t.id), !0) : !1;
  }
  // ---------------------------------------------------------------- the stage and history
  /** Any item: this session's, or another session's on the board. */
  itemById(e) {
    return this.items.value.find((t) => t.id === e) || this.boardItems.value.find((t) => t.id === e) || null;
  }
  /**
   * An item as this session has it: its own, or another session's (the Board
   * view) brought in as a reference, once, to stage, queue, mark up or edit.
   */
  bringIn(e) {
    if (e.startsWith("pin:")) return this.bringInPin(e.slice(4));
    const t = this.items.value.find((o) => o.id === e);
    if (t) return t;
    const i = this.boardItems.value.find((o) => o.id === e);
    if (!i || i.status !== "done") return null;
    const s = this.items.value.find((o) => o.kind === "ref" && o.how === "board" && o.source === e);
    return s || this.addRef({ how: "board", url: i.url, w: i.w, h: i.h, label: i.label, asset: i.asset || null, source: e });
  }
  /**
   * The result behind an item: a run's own, or the one another session's
   * picture brought in here came from (a video plays on the stage as itself,
   * not as its poster, CHAT-31). Null for an upload, a capture, a version
   * made here.
   */
  resultOf(e) {
    return e.result ? e.result : e.kind !== "ref" || !e.source ? null : (this.board.results.rev.value, this.board.results.get(e.source) || null);
  }
  /**
   * Your pinned pictures, as history's Pinned view shows them: a result the
   * board has as itself, one already brought in here as that, and any other
   * as a stand-in that comes in (bringInPin) when it's used.
   */
  pinnedItems() {
    const e = new Map(this.boardItems.value.map((i) => [i.id, i])), t = this.items.value.filter((i) => i.kind === "ref");
    return this.board.pinnedImages.value.map((i) => {
      const s = i.resultId && e.get(i.resultId) || t.find((o) => o.url === i.url);
      return s || {
        id: "pin:" + i.id,
        kind: "ref",
        how: "board",
        pin: !0,
        url: i.url,
        w: i.pw,
        h: i.ph,
        createdAt: i.createdAt,
        parentId: null,
        label: i.label,
        status: "done",
        asset: i.asset || null,
        source: i.resultId || i.url,
        sessionId: i.fromSession || void 0
      };
    });
  }
  /** A pinned picture brought into this session: as a reference from the board, once. */
  bringInPin(e) {
    const t = this.board.studioRecords.get(e);
    if (!t || t.role !== "pin") return null;
    const i = t.resultId || t.url, s = this.items.value.find((o) => o.kind === "ref" && (o.source === i || o.url === t.url));
    if (s) return s;
    if (t.resultId) {
      const o = this.items.value.find((r) => r.id === t.resultId);
      if (o) return o;
    }
    return this.addRef({ how: "board", url: t.url, w: t.pw, h: t.ph, label: t.label, asset: t.asset || null, source: i });
  }
  /** A picture brought into this session, saved on the board as a reference; the item it is here. */
  addRef(e, t = Date.now()) {
    e.how !== "board" && this.reveal();
    const i = {
      ...bl,
      id: wt(),
      type: "studio",
      role: "ref",
      sessionId: this.sessionId,
      createdAt: t,
      how: e.how,
      url: e.url,
      pw: e.w || 4,
      ph: e.h || 3,
      label: e.label,
      asset: e.asset || null,
      source: e.source || null,
      model: e.model || null,
      camera: e.camera || null,
      shot: e.shot || null,
      ...e.base ? { base: e.base } : {},
      ...e.made ? { made: e.made } : {}
    };
    return this.board.studioRecords.put(i), a4(i);
  }
  /**
   * The name of the session an item came from. A picture brought in from the
   * board names the session whose result it copies, and none when no session
   * made it (an upload dropped on the canvas): its record is this session's.
   */
  sessionName(e) {
    var t;
    const i = e.sessionId || (e.kind === "ref" && e.how === "board" ? e.source && ((t = this.board.results.get(e.source)) == null ? void 0 : t.sessionId) || null : this.sessionId), s = i ? this.board.store.get(i) : void 0;
    return s && s.type === "tool" ? s.name : "";
  }
  /**
   * Put an item on the stage (another session's comes in first). An Edit
   * tool with a change on the stage that isn't a version yet asks first
   * (IL-073): apply it, or discard it.
   */
  show(e) {
    if (this.tools && this.s.stageId !== e && this.tools.held()) return;
    if (this.tools && this.tools.t.open && this.tools.pending() && this.s.stageId !== e) {
      this.tools.leave(() => {
        const i = this.tools.t.open;
        this.show(e), i && (this.tools.t.open = i);
      });
      return;
    }
    if (this.side.value === "edit" && this.from3d(e)) return;
    const t = this.bringIn(e);
    t && (this.finishEditing(), this.s.stageId = t.id, this.s.selection = [], this.s.studio === "threed" && (this.s.studio = "prompt", this.s.last.generate = "prompt"));
  }
  // ---------------------------------------------------------------- history: the board's, by session
  /** The sessions history is narrowed to, of those it lists; none is every session. */
  pickedSessions() {
    const e = this.historySessions.value;
    return this.s.sessions.filter((t) => e.some((i) => i.id === t));
  }
  /** Whether history shows every session on the board. */
  allSessions() {
    const e = this.pickedSessions();
    return !e.length || e.length === this.historySessions.value.length;
  }
  /** Add a session to the ones history shows, or take it out (the last one out is every session again). */
  toggleSession(e) {
    const t = this.pickedSessions();
    this.s.sessions = t.includes(e) ? t.filter((i) => i !== e) : [...t, e];
  }
  /** History shows this session alone; or every session, with none named. */
  onlySession(e) {
    this.s.sessions = e ? [e] : [];
  }
  /** What you make or bring in here always shows in history, whatever sessions it was narrowed to. */
  reveal() {
    const e = this.pickedSessions();
    e.length && !e.includes(this.sessionId) && (this.s.sessions = [...e, this.sessionId]);
  }
  /** History's columns, remembered for the next visit and the next board. */
  setColumns(e) {
    const t = Z8(e);
    t !== this.s.columns && (this.s.columns = t, J8(this.board.user.uid, t));
  }
  // ---------------------------------------------------------------- the queue (your session prompt's pictures)
  /**
   * The session prompt's pictures, as this session's items, and then what's
   * queued beyond the model's limit (kept here, not in the prompt). A result
   * not read yet is read; a picture from elsewhere comes in as a reference.
   */
  loadQueue() {
    this.queueKey = this.promptPictures();
    const e = this.modelOf("prompt"), t = this.board.promptOf(this.sessionId), i = [];
    for (const o of Tf(e, t)) {
      const r = t.assets && t.assets[o] || this.board.assetFor(o), a = this.items.value.find((c) => c.url === o || c.result && c.result.thumb === o);
      if (a) {
        i.includes(a.id) || i.push(a.id);
        continue;
      }
      const l = r && "nodeRunResult" in r ? Cpe(r) : null;
      if (l) {
        i.push(l), this.board.loadRecord(l).then((c) => {
          if (c && c.sessionId === this.sessionId) return;
          const h = this.s.queue.indexOf(l);
          if (h < 0) return;
          const f = this.bringInResult(l, o, r, c), p = this.s.queue.slice();
          p[h] = f.id, this.s.queue = p;
        }).catch(() => {
        });
        continue;
      }
      const d = this.addRef({ how: "board", url: o, w: 4, h: 3, label: "Reference", asset: r });
      i.push(d.id);
    }
    const s = this.s.queue.filter((o) => !i.includes(o) && this.items.value.some((r) => r.id === o));
    this.s.queue = i.concat(s);
  }
  /** Another session's result (or one that's gone) in your prompt: a reference here, once. */
  bringInResult(e, t, i, s) {
    const o = this.items.value.find((r) => r.kind === "ref" && r.source === e);
    return o || this.addRef({ how: "board", url: t, w: s ? s.w : 4, h: s ? s.h : 3, label: s && (s.label || s.prompt) || "Reference", asset: i, source: e });
  }
  /** A new queue: the model's share of it goes into your session prompt. */
  setQueue(e) {
    this.s.queue = e;
    const t = this.modelOf("prompt");
    if (!t || !zo(t)) return;
    const i = new Map(this.items.value.map((r) => [r.id, r])), s = e.slice(0, zo(t)).map((r) => i.get(r)).filter((r) => !!r).map((r) => ({ url: r.url, asset: r.asset || this.board.assetFor(r.url) })), o = _d(t, this.board.promptOf(this.sessionId), s);
    this.board.setPrompt(this.sessionId, { ref: o.ref, inputs: o.inputs, assets: o.assets }), this.queueKey = this.promptPictures();
  }
  /** The session prompt's pictures, as a key: the queue's own writes, told from anyone else's. */
  promptPictures() {
    const e = this.modelOf("prompt");
    return e ? Tf(e, this.board.promptOf(this.sessionId)).join(`
`) : "";
  }
  /** Its place in the queue (1 first), or 0; another session's item counts by its copy here. */
  queued(e) {
    const t = this.s.queue.indexOf(e);
    if (t >= 0) return t + 1;
    const i = this.items.value.find((s) => s.kind === "ref" && s.source === e);
    return i ? this.s.queue.indexOf(i.id) + 1 : 0;
  }
  /** What each slot is, where the dock's model has several image inputs (a start and an end frame). */
  slotName(e) {
    return Pne(this.dockModel.value)[e] || "";
  }
  add(e) {
    if (!this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " takes no images");
      return;
    }
    const t = Dh(this.s.queue, e, this.limit.value);
    t.full && this.say(this.modelName(this.genMode.value) + " takes " + this.limit.value + ": remove one first"), this.setQueue(t.queue);
  }
  remove(e) {
    this.setQueue(L_(this.s.queue, e));
  }
  toggleQueued(e) {
    if (!this.queued(e) && (this.refuseVideo(e) || this.from3d(e))) return;
    const t = this.bringIn(e);
    t && (this.queued(t.id) ? this.remove(t.id) : this.add(t.id));
  }
  /** The result goes into slot 1, in place of the image its run edited. */
  // ---------------------------------------------------------------- a Video Edit session's video (TD-13)
  //
  // A Video Edit tool takes a video, not pictures: the Studios view said it
  // "works from words alone" and offered only pictures. Its video is the
  // session's own input, the one its canvas card sets, so either place sets it.
  /** The session's model's video input, where it takes one. */
  videoField() {
    const e = this.modelOf("prompt");
    return e && e.fields.find((t) => t.placement === "reference" && t.kind === "video") || null;
  }
  /** The video the next run edits: the session's, set here or on its card. */
  sessionVideo() {
    const e = this.videoField();
    return e ? (this.board.promptRev.value, this.board.refImages(this.sessionId, e.key)[0] || null) : null;
  }
  /**
   * The file that plays for a video input's value: a board video is handed
   * over as its poster (its run's record carries the video), so it's looked
   * up; an upload is the file itself. Null when only a poster is known.
   */
  playableVideo(e) {
    if (!e) return null;
    this.board.results.rev.value;
    for (const i of this.board.store.all()) {
      if (i.type !== "tool") continue;
      const s = this.board.results.list(i.id).find((o) => o.url === e && o.video);
      if (s) return s.videoSrc || s.previewSrc || null;
    }
    const t = this.board.imagesInOrder().find((i) => i.src === e && i.video);
    return t ? t.videoSrc || null : /^blob:|\.(mp4|mov|m4v|webm)(\?|#|$)/i.test(e) ? e : null;
  }
  /** A video for the next run: from the board, your Library, or an upload (null takes it out). */
  setSessionVideo(e, t) {
    const i = this.videoField();
    i && this.board.setRefInput(this.sessionId, i.key, e, e ? t || this.board.assetFor(e) : null);
  }
  /** A video file from your computer, kept in your uploads, as the next run's video. */
  async bringInVideo(e) {
    if (this.videoField())
      try {
        const t = await this.board.uploadVideoFile(e);
        this.setSessionVideo(t.url, t.asset);
      } catch (t) {
        this.say(Cd(t, e.name));
      }
  }
  /**
   * Where a result sits in its run's batch, "1 of 2", when the run made more
   * than one (B29: a batch's results were each tagged "Original").
   */
  batchOf(e) {
    if (e.kind !== "gen" || !e.runId) return "";
    const t = this.items.value.filter((i) => i.kind === "gen" && i.runId === e.runId).sort((i, s) => i.createdAt - s.createdAt);
    return t.length < 2 ? "" : t.findIndex((i) => i.id === e.id) + 1 + " of " + t.length;
  }
  /**
   * What a picture was made from (B29: Studio showed none of it): the images
   * its run took, in their order. Empty for one brought in, or a run that took none.
   */
  madeFrom(e) {
    const t = e ? this.resultOf(e) : null;
    return (t && t.refs ? t.refs.filter((s, o, r) => !!s && r.indexOf(s) === o) : []).map((s, o) => ({ url: s, n: o + 1 }));
  }
  /** One of those, in the viewer: the picture it is if it's here, else brought in as a reference. */
  async showUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) {
      this.show(t.id);
      return;
    }
    const i = await Promise.race([Id(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: i.w, h: i.h, label: "Input", asset: this.board.assetFor(e) });
    this.show(s.id);
  }
  continueFrom(e) {
    if (!this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " takes no images");
      return;
    }
    const t = this.bringIn(e);
    t && (this.setQueue(Oh(this.s.queue, t.id, this.limit.value).queue), this.show(t.id), this.say("Next run starts from this"));
  }
  move(e, t) {
    const i = this.s.queue.filter((s) => s !== e);
    i.splice(Math.max(0, Math.min(t, i.length)), 0, e), this.setQueue(i);
  }
  /**
   * Pictures picked in your Library (from anywhere): references here, queued
   * as far as the model takes them, the first on the stage. Each starts a
   * history of its own; history shows the session, where they join
   * everything else.
   */
  addFromLibrary(e) {
    const t = [], i = Date.now();
    if (e.forEach((l, d) => {
      const c = this.items.value.find((h) => h.kind === "ref" && h.how === "library" && h.source === l.id || h.url === l.url);
      if (c) {
        t.push(c);
        return;
      }
      l.asset && this.board.rememberAsset(l.url, l.asset), t.push(this.addRef({
        how: "library",
        url: l.url,
        w: l.w || 4,
        h: l.h || 3,
        label: zb(l.prompt || l.label || "From your Library", 6),
        asset: l.asset || null,
        source: l.id
      }, i + d));
    }), !t.length) return;
    let s = 0, o = this.s.queue;
    if (this.limit.value) {
      for (const l of t) {
        const d = Dh(o, l.id, this.limit.value);
        !d.full && d.queue !== o && s++, o = d.queue;
      }
      this.setQueue(o);
    }
    this.show(t[0].id);
    const r = t.length, a = this.modelName(this.genMode.value);
    this.limit.value ? s < r ? this.say(s ? s + " queued, the rest are in history: " + a + " takes " + this.limit.value : "The queue is full: " + (r === 1 ? "it's" : "they're") + " in history") : this.say(r === 1 ? "Brought in and queued" : "Brought in " + r + ", queued") : this.say(a + " takes no images: " + (r === 1 ? "it's" : "they're") + " in history");
  }
  /** An image from your computer: into your uploads (made a picture any browser shows), a reference here, queued. */
  async addUpload(e) {
    const t = await this.upload(e);
    t && (this.add(t.id), this.s.stageId || this.show(t.id));
  }
  /** An image from your computer on the Edit side: into your uploads, and one of the edit's references. */
  async addUploadRef(e) {
    const t = await this.upload(e);
    t && this.addEditRef(t.id);
  }
  /** A file into your uploads, as a picture brought into this session. */
  async upload(e) {
    const t = e.name.replace(/\.[a-z0-9]+$/i, "").slice(0, 40) || "Upload";
    let i, s;
    try {
      s = this.board.realRuns ? await this.board.uploadFile(e) : { url: await d4(e, Ab), asset: null }, i = await Id(s.url);
    } catch (o) {
      return this.say(Cd(o, e.name)), null;
    }
    return this.addRef({ how: "upload", url: s.url, w: i.w, h: i.h, label: t, asset: s.asset });
  }
  // ---------------------------------------------------------------- marks (Draw and Annotate)
  //
  // Each picture has its own marks, and they go with it when it's sent. They
  // stay editable shapes (v1 baked them into the picture), and are saved on
  // the board with the picture, for next time and for teammates.
  /** A picture's marks. */
  marksOf(e) {
    return e && this.s.marks[e.id] || Md();
  }
  /** The stage's marks, as Draw and Annotate edit them. */
  working() {
    return this.marksOf(this.stage.value);
  }
  /** The picture has marks or notes on it (they'll go with it when it's sent). */
  marked(e) {
    return Zd(this.s.marks[e]);
  }
  canUndo() {
    return this.s.histRev, !!this.s.stageId && !!(this.undo.get(this.s.stageId) || []).length;
  }
  canRedo() {
    return this.s.histRev, !!this.s.stageId && !!(this.redo.get(this.s.stageId) || []).length;
  }
  /** One undo step, before a change. */
  remember(e) {
    const t = this.undo.get(e) || [];
    t.push(Td(this.s.marks[e] || Md())), t.length > 100 && t.shift(), this.undo.set(e, t), this.redo.delete(e), this.s.histRev++;
  }
  /** Set a picture's marks, to be saved on the board after a pause. */
  putMarks(e, t) {
    const i = { ...this.s.marks };
    t && mb(t) ? i[e] = t : delete i[e], this.s.marks = i, this.changed(e);
  }
  /** Change the stage's marks: one undo step, unless `step` is false (the moves inside a gesture). */
  editMarks(e, t = !0) {
    const i = this.s.stageId;
    if (!i) return;
    t && this.remember(i);
    const s = this.marksOf(this.stage.value);
    this.putMarks(i, e({ strokes: s.strokes.slice(), pins: s.pins.slice(), ...s.area ? { area: s.area.slice() } : {} }));
  }
  /** A drag that changes marks as it goes: one undo step for all of it. */
  beginGesture() {
    this.s.stageId && this.remember(this.s.stageId);
  }
  /** The gesture changed nothing after all: its undo step goes too. */
  dropGesture() {
    const e = this.s.stageId ? this.undo.get(this.s.stageId) : null;
    e && e.length && (e.pop(), this.s.histRev++);
  }
  addStroke(e) {
    this.editMarks((t) => ({ ...t, strokes: [...t.strokes, e] }));
  }
  /** Change some marks: one undo step, unless `step` is false (inside a gesture). */
  updateStrokes(e, t, i = !0) {
    const s = new Set(e);
    this.editMarks((o) => ({ ...o, strokes: o.strokes.map((r) => s.has(r.id) ? t(r) : r) }), i);
  }
  deleteStrokes(e) {
    if (!e.length) return;
    const t = new Set(e);
    this.editMarks((i) => ({ ...i, strokes: i.strokes.filter((s) => !t.has(s.id)) })), this.s.selection = this.s.selection.filter((i) => !t.has(i)), this.s.editingText && t.has(this.s.editingText) && (this.s.editingText = null);
  }
  /** The colour for new marks; it also recolours the selection, or the block being written (as v1 did). */
  setColor(e) {
    this.s.color = e;
    const t = this.s.editingText ? [this.s.editingText] : this.s.tool === "move" ? this.s.selection : [];
    t.length && this.updateStrokes(t, (i) => ({ ...i, color: e }), !this.s.editingText);
  }
  /**
   * How solid new marks are (IL-079), and the selected ones with them (not
   * text: it stays solid). `step` false while a slider drags, after a
   * beginGesture, so the drag is one undo step.
   */
  setOpacity(e, t = !0) {
    const i = Math.round(Math.max(bI, Math.min(1, e)) * 100) / 100;
    if (this.s.opacity = i, this.s.tool !== "move") return;
    const s = this.working().strokes.filter((o) => this.s.selection.includes(o.id) && o.kind !== "text").map((o) => o.id);
    s.length && this.updateStrokes(s, (o) => ({ ...o, opacity: i }), t);
  }
  select(e) {
    this.s.selection = e;
  }
  /** Drop selected or edited marks that undo took away. */
  pruneSelection() {
    const e = new Set(this.working().strokes.map((i) => i.id));
    this.s.selection = this.s.selection.filter((i) => e.has(i)), this.s.editingText && !e.has(this.s.editingText) && (this.s.editingText = null);
    const t = new Set(this.working().pins.map((i) => i.id));
    this.s.editingPin && !t.has(this.s.editingPin) && (this.s.editingPin = null);
  }
  // ------ text blocks (Draw)
  /** A new block at `p`, open for writing. It and its first words are one undo step. */
  addText(e, t) {
    this.s.editingText && this.commitText(this.s.editingText);
    const i = { id: wt(), kind: "text", color: this.s.color, size: t, pts: [e], text: "" };
    return this.addStroke(i), this.s.selection = [], this.s.editingText = i.id, this.newText = i.id, this.textBefore = "", i;
  }
  /** Open a block for writing again: this edit is one undo step. */
  editText(e) {
    if (this.s.editingText === e) return;
    this.s.editingText && this.commitText(this.s.editingText);
    const t = this.working().strokes.find((i) => i.id === e);
    !t || t.kind !== "text" || (this.beginGesture(), this.s.editingText = e, this.s.selection = [], this.newText = null, this.textBefore = t.text || "");
  }
  setText(e, t) {
    this.updateStrokes([e], (i) => ({ ...i, text: t }), !1);
  }
  /** Leaving a block. An empty new one never happened; an emptied old one is removed (undo brings it back). */
  commitText(e) {
    this.s.editingText === e && (this.s.editingText = null);
    const t = this.working().strokes.find((o) => o.id === e), i = this.newText === e;
    if (this.newText = null, !t) return;
    const s = (t.text || "").replace(/\s+$/, "");
    if (!s.trim()) {
      i ? this.revertStep() : this.editMarks((o) => ({ ...o, strokes: o.strokes.filter((r) => r.id !== e) }), !1);
      return;
    }
    s !== t.text && this.setText(e, s), !i && s === this.textBefore && this.dropGesture();
  }
  // ------ pins (Annotate)
  addPin(e, t) {
    if (!this.s.stageId) return null;
    this.s.editingPin && this.commitPin(this.s.editingPin);
    const i = { id: wt(), x: e, y: t, text: "" };
    return this.editMarks((s) => ({ ...s, pins: [...s.pins, i] })), this.s.editingPin = i.id, this.newPin = i.id, this.pinBefore = "", i;
  }
  /** Open a pin's text: this edit is one undo step. */
  editPin(e) {
    if (this.s.editingPin === e) return;
    this.s.editingPin && this.commitPin(this.s.editingPin);
    const t = this.working().pins.find((i) => i.id === e);
    t && (this.beginGesture(), this.s.editingPin = e, this.newPin = null, this.pinBefore = t.text);
  }
  /** A pin dragged: `step` true on its first move, so the whole drag is one undo step. */
  movePin(e, t, i, s = !1) {
    this.editMarks((o) => ({ ...o, pins: o.pins.map((r) => r.id === e ? { ...r, x: t, y: i } : r) }), s);
  }
  setPinText(e, t) {
    this.editMarks((i) => ({ ...i, pins: i.pins.map((s) => s.id === e ? { ...s, text: t } : s) }), !1);
  }
  removePin(e) {
    this.editMarks((t) => ({ ...t, pins: t.pins.filter((i) => i.id !== e) })), this.s.editingPin === e && (this.s.editingPin = null), this.newPin === e && (this.newPin = null);
  }
  /** Leaving a pin's text. An empty new pin never happened; an emptied old one is removed. */
  commitPin(e) {
    this.s.editingPin === e && (this.s.editingPin = null);
    const t = this.newPin === e;
    this.newPin = null;
    const i = this.working().pins.find((s) => s.id === e);
    if (i) {
      if (!i.text.trim()) {
        t ? this.revertStep() : this.editMarks((s) => ({ ...s, pins: s.pins.filter((o) => o.id !== e) }), !1);
        return;
      }
      !t && i.text === this.pinBefore && this.dropGesture();
    }
  }
  // ------ undo, redo, clear
  /** Take the last step back as if it never happened: nothing to redo. */
  revertStep() {
    const e = this.s.stageId, t = e ? (this.undo.get(e) || []).pop() : void 0;
    !e || !t || (this.putMarks(e, t), this.s.histRev++, this.pruneSelection());
  }
  undoMark() {
    const e = this.s.stageId;
    if (!e) return;
    const t = (this.undo.get(e) || []).pop();
    if (!t) return;
    const i = this.redo.get(e) || [];
    i.push(Td(this.working())), this.redo.set(e, i), this.putMarks(e, t), this.s.histRev++, this.pruneSelection();
  }
  redoMark() {
    const e = this.s.stageId;
    if (!e) return;
    const t = (this.redo.get(e) || []).pop();
    if (!t) return;
    const i = this.undo.get(e) || [];
    i.push(Td(this.working())), this.undo.set(e, i), this.putMarks(e, t), this.s.histRev++, this.pruneSelection();
  }
  /** Clear all: every mark and note on the picture, as v1's Clear did (one undo step); its area stays. */
  clearMarks() {
    Zd(this.working()) && (this.finishEditing(), this.editMarks((e) => ({ ...Md(), ...e.area ? { area: e.area } : {} })), this.s.selection = []);
  }
  // ------ the area (the bar's Edit and Erase modes)
  /** The stage picture's selected area, as its steps. */
  area() {
    return this.working().area || [];
  }
  /** Whether the stage picture has an area selected. */
  hasArea() {
    return CI(this.working());
  }
  /** One more step of the area (a brush stroke, a lasso, an object): one undo step. */
  addAreaOp(e) {
    this.editMarks((t) => ({ ...t, area: [...t.area || [], e] }));
  }
  /** The area cleared (one undo step). */
  clearArea() {
    this.area().length && this.editMarks((e) => ({ strokes: e.strokes, pins: e.pins }));
  }
  /** The bar's mode: Edit (words, and an area to keep the change in), Erase, or Annotate (marks and notes). */
  setBar(e) {
    this.s.bar !== e && (this.finishEditing(), this.s.bar = e, this.s.selection = []);
  }
  /** Close whatever is being written. */
  finishEditing() {
    this.s.editingText && this.commitText(this.s.editingText), this.s.editingPin && this.commitPin(this.s.editingPin);
  }
  // ------ kept on the board
  /** A picture's marks or words changed here: saved after a pause. */
  changed(e) {
    this.dirty.add(e), clearTimeout(this.marksTimer), this.marksTimer = window.setTimeout(() => this.saveMarks(), r4);
  }
  /** Save what changed: each picture's marks and words in its one record, or none when it has neither. */
  saveMarks() {
    clearTimeout(this.marksTimer);
    const e = this.s.editingText || this.s.editingPin ? this.s.stageId : null;
    for (const t of Array.from(this.dirty)) {
      if (t === e) continue;
      this.dirty.delete(t);
      const i = this.s.marks[t], s = (this.s.asks[t] || "").trim() ? this.s.asks[t] : "", o = m_(t), r = this.board.studioRecords.get(o);
      if (!mb(i) && !s) {
        r && this.board.studioRecords.remove([o]);
        continue;
      }
      const a = {
        ...bl,
        id: o,
        type: "studio",
        role: "marks",
        sessionId: this.sessionId,
        target: t,
        marks: i ? Td(i) : Md(),
        ask: s,
        createdAt: r ? r.createdAt : Date.now()
      };
      this.board.studioRecords.put(a);
    }
    this.dirty.size && (this.marksTimer = window.setTimeout(() => this.saveMarks(), r4));
  }
  /** Marks and words saved on the board, for every picture you aren't changing here. */
  readMarks() {
    const e = {}, t = {};
    for (const a of this.board.studioRecords.forSession(this.sessionId))
      a.role === "marks" && (mb(a.marks) && (e[a.target] = a.marks), a.ask && (t[a.target] = a.ask));
    const i = { ...this.s.marks }, s = { ...this.s.asks };
    let o = !1;
    const r = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t), ...Object.keys(this.s.marks), ...Object.keys(this.s.asks)]);
    for (const a of r) {
      if (this.dirty.has(a)) continue;
      const l = e[a], d = this.s.marks[a];
      l && (!d || !Jue(l, d)) ? (i[a] = Td(l), o = !0) : !l && d && (delete i[a], o = !0), (t[a] || "") !== (this.s.asks[a] || "") && (t[a] ? s[a] = t[a] : delete s[a], o = !0);
    }
    o && (this.s.marks = i, this.s.asks = s, this.pruneSelection());
  }
  // ---------------------------------------------------------------- 3D
  /** A model file from your computer: kept in your Library where the host can, and shown. */
  async addModelFile(e) {
    const t = (e.name.split(".").pop() || "").toLowerCase();
    if (!["glb", "gltf", "obj", "stl"].includes(t)) {
      this.say(e.name + " isn't a model the 3D studio reads: use .glb, .gltf, .obj or .stl");
      return;
    }
    this.s.three.loading = !0, this.s.three.error = null;
    let i = "", s = null;
    const o = this.board.upload3d(e);
    try {
      if (o) {
        this.keeping.push(e.name), this.s.three.keeping = e.name;
        const a = await o;
        i = a.url, s = a.upload ? { upload: a.upload } : null;
      } else
        i = URL.createObjectURL(e);
    } catch (a) {
      this.keeping.length <= 1 && (this.s.three.loading = !1), this.say(Cd(a, e.name));
      return;
    } finally {
      o && (this.keeping.splice(this.keeping.indexOf(e.name), 1), this.s.three.keeping = this.keeping.length ? this.keeping[this.keeping.length - 1] : null);
    }
    const r = this.addModel({ name: e.name, url: i, ext: t, asset: s });
    this.files.set(r.id, e);
  }
  /** A 3D model picked in your Library. */
  addModelFromLibrary(e) {
    e.model3d && this.openModel({ name: e.label || "Model", url: e.model3d.url, ext: e.model3d.ext, asset: e.asset || null });
  }
  /** A model into the 3D view: the one this session has already, or a new one. */
  openModel(e) {
    const t = this.models3d.value.find((i) => i.url === e.url);
    t ? this.useModel(t.id) : this.addModel(e);
  }
  /**
   * A 3D model used as a picture (P3-02): its file is a model, not a picture,
   * so it opens in Generate's 3D view, as one picked in your Library does,
   * for a view of it to be captured as the picture. True when it was one.
   */
  as3d(e) {
    return e ? this.canUse("threed") ? (this.openModel(e), this.setStudio("threed"), this.say("Frame a view, then Capture to use it as a picture"), !0) : (this.say("A 3D model can't be used as a picture here"), !0) : !1;
  }
  /** An item in history, or the board's, used as a picture: as3d where it's a 3D model. */
  from3d(e) {
    const t = this.items.value.find((i) => i.id === e) || this.boardItems.value.find((i) => i.id === e);
    return this.as3d(t ? Rb(this.resultOf(t)) : null);
  }
  /** Bonneville Tower's massing, built in the viewer: a model to try the studio with. */
  addSample() {
    const e = this.models3d.value.find((t) => t.url === Eb);
    if (e) {
      this.s.three.model = e.id;
      return;
    }
    this.addModel({ name: "Bonneville massing", url: Eb, ext: "obj", asset: null });
  }
  addModel(e) {
    const t = {
      ...bl,
      id: wt(),
      type: "studio",
      role: "model",
      sessionId: this.sessionId,
      createdAt: Date.now(),
      name: e.name,
      url: e.url,
      ext: e.ext,
      asset: e.asset,
      cameras: []
    };
    return this.board.studioRecords.put(t), this.s.three.model = t.id, this.s.three.cam = null, t;
  }
  /** The model's file, for the viewer: picked this visit, or read from where it's kept. */
  async modelFile(e) {
    const t = this.files.get(e.id);
    if (t) return t;
    if (e.url === Eb) return new Blob([SI()], { type: "text/plain" });
    const i = await fetch(e.url, { mode: "cors" }).catch(() => null);
    if (!i || !i.ok) throw new Error("This model's file couldn't be read. Bring it in again.");
    return i.blob();
  }
  useModel(e) {
    this.s.three.model !== e && (this.s.three.model = e, this.s.three.cam = null, this.s.three.error = null);
  }
  saveCamera() {
    const e = this.model3d.value, t = this.s.three.cam;
    if (!e || !t) return null;
    const i = { id: wt(), name: "View " + (e.cameras.length + 1), cam: { ...t } };
    return this.board.studioRecords.patch(e.id, { cameras: [...e.cameras, i] }), i;
  }
  renameCamera(e, t) {
    const i = this.model3d.value;
    i && this.board.studioRecords.patch(i.id, { cameras: i.cameras.map((s) => s.id === e ? { ...s, name: t.trim() || s.name } : s) });
  }
  removeCamera(e) {
    const t = this.model3d.value;
    t && this.board.studioRecords.patch(t.id, { cameras: t.cameras.filter((i) => i.id !== e) });
  }
  /** A captured view's shape, width over height (the viewfinder's). */
  captureRatio() {
    const [e, t] = this.s.three.aspect.split(":").map(Number);
    return e > 0 && t > 0 ? e / t : 1;
  }
  /**
   * A 3D view captured as a picture: kept with your uploads, in history (a
   * history of its own), on the stage, and in the queue (at the end, or as
   * image 1 when it's what the run will start from). The same frame captured
   * a moment ago is used again rather than captured twice. Picking a view
   * leaves the 3D view for Prompt, as Use 3D did (CHAT-08); a run from the
   * view leaves once it goes (generate).
   */
  async captureView(e, t = !1) {
    const i = this.model3d.value, s = this.s.three.cam;
    if (!i || !s) return null;
    const o = JSON.stringify({ m: i.id, cam: L0(s), b: this.s.three.backdrop, a: this.s.three.aspect }), r = this.items.value.find((f) => f.kind === "ref" && f.how === "threed" && f.shot === o);
    if (r)
      return t ? this.setQueue(Oh(this.s.queue, r.id, this.limit.value).queue) : this.queued(r.id) || this.setQueue(Dh(this.s.queue, r.id, this.limit.value).queue), this.s.stageId = r.id, this.say("Using this view, already captured" + (this.queued(r.id) ? " as image " + this.queued(r.id) : "")), t || this.setStudio("prompt"), r;
    const a = new File([e.blob], "view.png", { type: "image/png" });
    let l;
    try {
      l = this.board.realRuns ? await this.board.uploadFile(a) : { url: await d4(a, Ab), asset: null };
    } catch (f) {
      return this.say(Cd(f, "The view")), null;
    }
    const d = i.cameras.find((f) => Spe(f.cam, s)) || null, c = this.items.value.filter((f) => f.kind === "ref" && f.how === "threed").length + 1, h = this.addRef({
      how: "threed",
      url: l.url,
      w: e.w,
      h: e.h,
      label: d ? d.name : "View " + c,
      asset: l.asset,
      model: i.id,
      camera: d || { id: wt(), name: "View " + c, cam: { ...s } },
      shot: o
    });
    if (!this.limit.value)
      this.say("Captured. " + this.modelName(this.genMode.value) + " takes no images");
    else {
      const f = t ? Oh(this.s.queue, h.id, this.limit.value) : Dh(this.s.queue, h.id, this.limit.value);
      this.setQueue(f.queue), this.say(f.full ? "Captured. The queue is full" : "Captured as image " + (f.queue.indexOf(h.id) + 1));
    }
    return this.s.stageId = h.id, t || this.setStudio("prompt"), h;
  }
  // ---------------------------------------------------------------- what's sent
  /** The prompt the model gets: your words, then which image is which, then the notes by image and marker. */
  compileFor(e, t) {
    const i = [], s = t.trim();
    return s && i.push(s), e.length && i.push(e.length === 1 ? "Image 1 is the image to edit." : "Image 1 is the image to edit; the others are references."), i.push(...this.notesFor(e.map((o, r) => ({ it: o, n: r + 1 })))), i.join(`
`);
  }
  /** What to follow on the pictures sent, then each note by marker: `n` is the image each is sent as (a guide copy can come between). */
  notesFor(e) {
    const t = [], i = e.length === 1, s = e.some(({ it: a }) => this.marksOf(a).pins.some((l) => l.text.trim())), o = e.some(({ it: a }) => this.marksOf(a).strokes.length > 0), r = i ? "image" : "images";
    if (s || o) {
      const a = s && o ? "the numbered annotations and the annotations drawn on the " + r : s ? "the numbered annotations on the " + r : "the annotations drawn on the " + r;
      t.push("Follow " + a + ", then remove every annotation from the result.");
    }
    for (const { it: a, n: l } of e)
      this.marksOf(a).pins.forEach((d, c) => {
        d.text.trim() && t.push((i ? "Annotation " : "Image " + l + ", annotation ") + (c + 1) + ": " + d.text.trim());
      });
    return t;
  }
  /** The queue's images the dock's model takes, image 1 first. */
  sentFromQueue() {
    return this.queueItems.value.slice(0, Hue(this.s.queue, this.limit.value)).filter((e) => e.status === "done");
  }
  /** What goes with the queue's images: per image, how many marks and notes. */
  sending() {
    return this.sentFromQueue().map((e, t) => ({ image: t + 1, ...this.carried(e) })).filter((e) => e.marks || e.comments);
  }
  /** A picture's marks and notes, counted. */
  carried(e) {
    const t = this.marksOf(e);
    return { marks: t.strokes.length, comments: t.pins.filter((i) => i.text.trim()).length };
  }
  // ------ the Edit side's runs, in one shape (IL-073)
  /** What the bar sends: Erase on an eraser where the board has one, else an edit. */
  barKind() {
    if (this.s.bar !== "erase") return "edit";
    const e = this.modelOf("erase");
    return e && Ul(e) ? "erase" : "edit";
  }
  /** The bar's run, by its mode: words and the area (Edit), the area alone (Erase), marks and notes (Annotate). */
  barPlan() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return null;
    const t = this.askOf(e.id), i = this.s.bar === "annotate" ? [] : this.area(), s = H_(i);
    if (this.s.bar === "erase") {
      const v = this.modelOf("erase");
      if (v && Ul(v)) {
        const x = PI(v);
        return {
          kind: "erase",
          model: v,
          pics: [{ kind: "item", item: e, marks: !1 }],
          words: "",
          compiled: "",
          inputs: this.editInputs("erase", v, { w: e.w, h: e.h }),
          count: this.countOf("erase"),
          base: e.id,
          mask: s ? { field: x.key, make: () => this.areaCanvas(e, i) } : null,
          settings: { label: "" }
        };
      }
    }
    const o = this.modelOf("edit");
    if (!o) return null;
    const r = this.s.bar === "erase", a = this.editInputs("edit", o, { w: e.w, h: e.h }), l = r ? 1 : this.countOf("edit"), d = this.sentRefs(), c = d.map((v) => ({ kind: "item", item: v, marks: !0 }));
    if (!s)
      return {
        kind: "edit",
        model: o,
        pics: [{ kind: "item", item: e, marks: !0 }, ...c],
        words: t,
        compiled: this.s.wordsOnly ? t.trim() : this.compileFor([e, ...d], t),
        inputs: a,
        count: l,
        base: e.id
      };
    const h = zo(o) >= 2, f = h ? [{ kind: "item", item: e, marks: !0 }, { kind: "made", name: "area", make: () => this.guideCanvas(e, i) }, ...c] : [{ kind: "made", name: "area", make: () => this.guideCanvas(e, i) }], p = [she(t, { erase: r, guide: h })];
    h && (p.push(...this.notesFor([{ it: e, n: 1 }, ...d.map((v, x) => ({ it: v, n: x + 3 }))])), d.length && p.push(ohe(3, d.length)));
    const y = r || this.s.precision;
    return {
      kind: r ? "erase" : "edit",
      model: o,
      pics: f,
      words: r ? "" : t,
      compiled: this.s.wordsOnly && !r ? t.trim() : p.join(`
`),
      inputs: a,
      count: l,
      base: e.id,
      precision: y ? { area: i.map((v) => ({ ...v })) } : null,
      settings: r ? { label: "" } : null
    };
  }
  // ------ the full prompt (IL-076): what a run puts together, to see and change
  /** The prompt a run puts together, as its model gets it: your words, then which picture is which, then the notes. */
  fullPromptOf(e) {
    if (e === "prompt" || e === "threed") return this.s.wordsOnly ? this.s.prompt.trim() : this.compileFor(this.sentFromQueue(), this.s.prompt);
    const t = this.planFor(e);
    return t ? t.compiled : "";
  }
  /** Your change to a run's full prompt, while it holds: for the picture it was written on (the dock's for the session). */
  fullEdit(e) {
    const t = this.s.fullEdits[e];
    return t && t.on === this.fullScope(e) ? t.text : null;
  }
  /** Whether the prompt the run puts together has changed since you began changing yours. */
  fullDrifted(e) {
    const t = this.s.fullEdits[e];
    return !!t && t.on === this.fullScope(e) && t.from !== this.fullPromptOf(e);
  }
  /** Change a run's full prompt; back to just what the run puts together, it's yours no longer. */
  setFullEdit(e, t) {
    const i = this.fullPromptOf(e), s = this.s.fullEdits[e], o = { ...this.s.fullEdits };
    t === i ? delete o[e] : o[e] = { text: t, on: this.fullScope(e), from: s && s.on === this.fullScope(e) ? s.from : i }, this.s.fullEdits = o;
  }
  /** Back to the prompt the run puts together. */
  resetFullEdit(e) {
    if (!this.s.fullEdits[e]) return;
    const t = { ...this.s.fullEdits };
    delete t[e], this.s.fullEdits = t;
  }
  /** Whether this run can send your words alone: Generate's and the Edit bar's (a tool's prompt is its own words). */
  /**
   * Whether the full prompt (and its Send my words only switch) has something
   * to show: its words, your own version of them, or the switch on (R15:
   * with no typed words the switch emptied the prompt, which hid the panel
   * holding the switch).
   */
  fullShown(e) {
    return !!this.fullPromptOf(e).trim() || this.fullEdit(e) != null || this.s.wordsOnly && this.takesWordsOnly(e);
  }
  takesWordsOnly(e) {
    return e === "prompt" || e === "threed" || e === "edit";
  }
  /** Send my words only, on or off (CHAT-34), kept for next time. */
  setWordsOnly(e) {
    this.s.wordsOnly = e, Ppe(this.board.user.uid, e);
  }
  setFullOpen(e, t) {
    this.s.fullOpen = { ...this.s.fullOpen, [e]: t };
  }
  /** Your full prompt runs instead of the run's own: it's open, and you've changed it. Then the run's own button rests. */
  fullTakesOver(e) {
    return !!this.s.fullOpen[e] && this.fullEdit(e) != null;
  }
  /** What stops a run with your own full prompt: none written, what a tool needs besides words (Expand's frame), then the model's checks. */
  fullProblem(e, t) {
    if (!t.trim()) return "Write the prompt first";
    const i = this.stage.value;
    if (fb(e) && (!i || i.status !== "done")) return "Pick an image to edit first";
    if (e !== "edit" && e !== "erase" && fb(e)) {
      const s = this.tools.problem(e, !0);
      if (s) return s;
    }
    return this.checkOf(e, t).problem;
  }
  fullScope(e) {
    return e === "prompt" || e === "threed" ? null : this.s.stageId;
  }
  /** A change written for another picture than the one on the stage goes. */
  dropStaleEdits() {
    const e = { ...this.s.fullEdits };
    let t = !1;
    for (const i of Object.keys(e)) {
      const s = e[i];
      s && s.on !== this.fullScope(i) && (delete e[i], t = !0);
    }
    t && (this.s.fullEdits = e);
  }
  // ------ the bar's references (IL-075)
  /** Whether the bar's run takes references: an edit on a model that reads more than one picture (the eraser reads one, and a mask). */
  takesRefs() {
    if (this.barKind() === "erase") return !1;
    const e = this.modelOf("edit");
    return !!e && zo(e) >= 2;
  }
  /** How many references the bar's run sends: its model's pictures, less the one it edits and an area's guide copy. */
  refRoom() {
    const e = this.modelOf("edit");
    if (!e || !this.takesRefs()) return 0;
    const t = this.s.bar !== "annotate" && H_(this.area());
    return Math.max(0, zo(e) - 1 - (t ? 1 : 0));
  }
  /** The references the bar's run sends: as many as its model has room for, never the picture on the stage itself. */
  sentRefs() {
    const e = this.stage.value;
    return this.editRefItems.value.filter((t) => !e || t.id !== e.id).slice(0, this.refRoom());
  }
  /** Whether a reference goes with the next run (one past the model's room, or on the stage, waits). */
  refSent(e) {
    return this.sentRefs().some((t) => t.id === e);
  }
  /**
   * A picture as one of the edit's references: from history (another
   * session's comes in first), a version, the slot's picker or an upload.
   * One already there isn't added twice; its tile pulses instead.
   */
  addEditRef(e) {
    if (this.from3d(e)) return "none";
    const t = this.bringIn(e);
    if (!t || t.status !== "done") return "none";
    const i = this.stage.value;
    if (i && t.id === i.id)
      return this.say("That's the picture you're editing"), "stage";
    if (this.s.editRefs.includes(t.id))
      return this.pulseRef(t.id), "have";
    if (!this.takesRefs())
      return this.say(this.refsRefused()), "none";
    const s = this.refRoom();
    return this.editRefItems.value.filter((r) => !i || r.id !== i.id).length >= s ? (this.say(s ? this.modelName("edit") + " takes " + s + (s === 1 ? " reference" : " references") + " here: remove one first" : "No room for a reference while an area is selected"), "full") : (this.s.editRefs = [...this.s.editRefs, t.id], this.pulseRef(t.id), "added");
  }
  /**
   * A picture by its address, from the slot's picker (a pinned picture, the
   * board's, your Library's, an upload): the one here already, else brought in.
   */
  async addEditRefUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) return this.addEditRef(t.id) === "added";
    const i = await Promise.race([Id(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: i.w, h: i.h, label: "Reference", asset: this.board.assetFor(e) });
    return this.addEditRef(s.id) === "added";
  }
  /**
   * How a picture picked by its address came in: from the board when it's
   * there (a picture on it, or one you've pinned), which history leaves to
   * where it is; else as its record says, an upload or a Library generation,
   * which history shows, as nothing else does.
   */
  howPicked(e) {
    if (this.board.isPinnedImage(e)) return "board";
    for (const i of this.board.store.all()) if (i.type === "image" && i.src === e) return "board";
    const t = this.board.assetFor(e);
    return t && "nodeRunResult" in t ? "library" : "upload";
  }
  /**
   * A picture dropped on Generate's queue, from history or a version
   * (CHAT-06), as the Edit bar takes one: brought in, and queued.
   */
  queueItem(e) {
    if (this.refuseVideo(e) || this.from3d(e)) return;
    const t = this.bringIn(e);
    t && !this.queued(t.id) && this.add(t.id);
  }
  /**
   * The queue holds pictures (a Video Edit model's video is the one on the
   * session's card): a video dragged onto it, or added from its preview, is
   * turned away, rather than sent as an image input.
   */
  refuseVideo(e) {
    const t = this.items.value.find((s) => s.id === e) || this.boardItems.value.find((s) => s.id === e), i = t ? this.resultOf(t) : null;
    return t && df(t.url) ? (this.say("The queue takes pictures, not 3D models"), !0) : !i || !(i.video || i.kind === "video") ? !1 : (this.say("The queue takes pictures, not videos"), !0);
  }
  /** A picture by its address, from the queue's picker (a pinned picture, the board's, your Library's, an upload): queued. */
  async queueUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) {
      this.queueItem(t.id);
      return;
    }
    const i = await Promise.race([Id(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: i.w, h: i.h, label: "Reference", asset: this.board.assetFor(e) });
    this.queued(s.id) || this.add(s.id);
  }
  removeEditRef(e) {
    this.s.editRefs = this.s.editRefs.filter((t) => t !== e);
  }
  /** Why the bar takes no references right now. */
  refsRefused() {
    return this.barKind() === "erase" ? "Erase takes no references" : this.modelName("edit") + " takes one picture: the one you're editing";
  }
  pulseRef(e) {
    const t = (this.s.refPulse ? this.s.refPulse.n : 0) + 1;
    this.s.refPulse = { id: e, n: t }, window.setTimeout(() => {
      this.s.refPulse && this.s.refPulse.n === t && (this.s.refPulse = null);
    }, 900);
  }
  /**
   * The eyedropper, on or off: on, a click on a picture in history (or a
   * version) makes it a reference on the Edit side, and queues it for the
   * next image on the Generate side (CHAT-10: both rows pick the same way).
   */
  setDropper(e) {
    if (e && this.side.value === "edit" && !this.takesRefs()) {
      this.say(this.refsRefused());
      return;
    }
    if (e && this.side.value !== "edit" && !this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " works from words alone");
      return;
    }
    this.s.dropper = e, e && this.s.histShut && this.setHistShut(!1);
  }
  /** Fold history down to a slim rail (the stage takes the room), or bring it back; remembered for next time. */
  setHistShut(e) {
    this.s.histShut !== e && (this.s.histShut = e, Rpe(this.board.user.uid, e));
  }
  /** A pick with the eyedropper: the picture becomes a reference, or joins the queue, and the eyedropper goes (it stays for another try on the picture being edited). */
  dropperPick(e) {
    if (this.side.value !== "edit") {
      this.queueItem(e), this.s.dropper = !1;
      return;
    }
    this.addEditRef(e) !== "stage" && (this.s.dropper = !1);
  }
  /** What stops the bar's run before the model's own checks: nothing to send yet, or no area to erase. */
  barProblem() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return "Pick an image to edit first";
    const t = this.askOf(e.id).trim(), i = Zd(this.marksOf(e));
    return this.s.bar === "erase" ? this.hasArea() ? null : "Paint over what should go first" : this.s.bar === "edit" && this.hasArea() && !t ? "Say what to change in the area" : !t && !i ? this.s.bar === "annotate" ? "Annotate the image, or say what to change" : "Say what to change, or select an area" : null;
  }
  /** A run's plan: the bar's or a tool's. */
  planFor(e) {
    return e === "edit" || e === "erase" ? this.barPlan() : this.tools.plan(e);
  }
  /** A plan's prompt state before anything is made or uploaded: stand-ins for what's still to make. */
  previewOf(e) {
    const t = e.pics.map((s, o) => s.kind === "item" ? { url: s.item.url, asset: s.item.asset || null } : { url: "made:" + o + ":" + s.name, asset: null }), i = _d(e.model, { prompt: e.compiled, ...Pb(e.ref), inputs: e.inputs, n: e.count }, t);
    return e.mask ? { ...i, masks: { [e.mask.field]: { boardMask: "pending" } } } : i;
  }
  /** The area as a mask the picture's size (capped), white where it is. */
  async areaCanvas(e, t) {
    const i = wl(e.w, e.h, 4096);
    return Dp(t, i.w, i.h, await this.mapsFor(t));
  }
  /** The picture with the area marked in magenta, for a model that reads pictures, not masks. */
  async guideCanvas(e, t) {
    const i = await si(e.url), s = wl(i.width, i.height, 2048);
    return yhe(i, Dp(t, s.w, s.h, await this.mapsFor(t)));
  }
  /** The segment maps an area's picked objects come from, read. */
  async mapsFor(e) {
    const t = /* @__PURE__ */ new Map();
    for (const i of DI(e)) t.set(i, await $f(i));
    return t;
  }
  modelName(e) {
    const t = this.modelOf(e);
    return t ? t.name : "This model";
  }
  /** A run's words, pictures and settings as the model's form has them (before marks are flattened and masks made). */
  previewUp(e, t = null) {
    if (fb(e)) {
      const a = this.planFor(e);
      if (a) return { model: a.model, count: a.count, up: this.previewOf(t != null ? { ...a, compiled: t } : a) };
      const l = this.modelOf(e);
      if (!l) return null;
      const d = this.countOf(e), c = this.stage.value, h = c ? [{ url: c.url, asset: c.asset || null }] : [];
      return { model: l, count: d, up: _d(l, { prompt: "", inputs: this.editInputs(e, l, c ? { w: c.w, h: c.h } : null), n: d }, h) };
    }
    const i = this.modelOf(e);
    if (!i) return null;
    const s = this.countOf(e), o = this.sentFromQueue(), r = o.map((a) => ({ url: a.url, asset: a.asset || null }));
    return { model: i, count: s, up: _d(i, { prompt: t != null ? t : this.compileFor(o, this.s.prompt), ...Pb(this.ownRef(e, i)), inputs: this.inputsOf(e), n: s }, r) };
  }
  /**
   * The sizes an Edit run can be made at, keeping its picture's shape
   * (TD-10): Nano Banana Pro's 1K, 2K and 4K. The bar hides the shape chip,
   * so this is where the size is chosen.
   */
  tiersOf(e) {
    const t = this.modelOf(e), i = e === "prompt" ? null : this.shapeSource(e);
    return t && i ? eI(t, i.w, i.h) : [];
  }
  /**
   * The size you chose, else the smallest; but a Precision edit, whose result
   * keeps the picture's own pixels outside its area, defaults to the
   * picture's own size (P3-04): the smallest at least as big, or the biggest.
   */
  tierOf(e) {
    if (e === "prompt") return 0;
    const t = this.s.modes[e].tier;
    if (t != null) return t;
    if (!((e === "edit" || e === "erase") && this.s.bar !== "annotate" && this.hasArea() && (this.s.bar === "erase" || this.s.precision))) return 0;
    const s = this.shapeSource(e), o = this.tiersOf(e), r = s ? o.findIndex((a) => a.px >= s.w * s.h) : -1;
    return r >= 0 ? r : Math.max(0, o.length - 1);
  }
  setTier(e, t) {
    e !== "prompt" && (this.s.modes[e] = { ...this.s.modes[e], tier: t });
  }
  /** A model's settings that aren't chips (the bar's More settings, TD-10): what ModelFields lays out under More. */
  advancedOf(e) {
    const t = this.modelOf(e);
    return t ? t.fields.filter((i) => i.placement === "advanced" && i.kind !== "seed" && i.kind !== "header" && i.kind !== "model" && i.kind !== "video") : [];
  }
  /** The shape a studio's result keeps: an Edit studio's picture's, 3D's frame's. */
  shapeSource(e) {
    if (e === "threed") return { w: Math.round(1e3 * this.captureRatio()), h: 1e3 };
    const t = this.stage.value;
    return t ? { w: t.w, h: t.h } : null;
  }
  /** A field's value by what it is (the tools read their model's scale this way). */
  valueOfKey(e, t) {
    const i = this.modelOf(e);
    if (!i) return;
    const s = i.fields.find((o) => o.raw && o.raw.boardKey === t || o.key === t || o.label.toLowerCase().includes(t));
    return s ? this.valueOf(e, s) : void 0;
  }
  /** An Edit run's or 3D's inputs: its own, with the shape kept to its picture's (at the size you chose) unless you chose one. */
  editInputs(e, t, i) {
    const s = this.inputsOf(e), o = i ? One(t, i.w, i.h, this.tierOf(e)) : null;
    return o && s[o.key] === void 0 && (s[o.key] = o.value), s;
  }
  /** What stops a studio's run, in v1's words; null when it can go. */
  problemOf(e) {
    return this.checkOf(e).problem;
  }
  /** What stops a studio's run, and whether it's only the tokens it costs (Run then offers to get more, as the board's does). */
  checkOf(e, t = null) {
    const i = this.previewUp(e, t);
    if (!i) return { problem: "No model is available for this.", tokens: !1 };
    const s = Xi(i.model, i.up, i.count, !!this.board.user.isAdmin);
    if (s.problems[0]) return { problem: s.problems[0], tokens: !1 };
    const o = this.board.tokensProblem(s.price);
    return { problem: o || null, tokens: !!o };
  }
  /** A studio's run's cost, as the board writes tokens. */
  priceOf(e) {
    const t = this.previewUp(e);
    if (!t) return "";
    const i = Xi(t.model, t.up, t.count, !!this.board.user.isAdmin);
    return i.price != null ? El(i.price) : a8(t.model, t.count);
  }
  // ------ what you ask an Edit studio to change, kept with the picture
  askOf(e) {
    return e && this.s.asks[e] || "";
  }
  setAsk(e, t) {
    const i = { ...this.s.asks };
    t ? i[e] = t : delete i[e], this.s.asks = i, this.changed(e);
  }
  // ------ the dock's words: your session prompt's
  setPrompt(e) {
    this.s.prompt = e, clearTimeout(this.promptTimer), this.promptTimer = window.setTimeout(() => this.commitPrompt(), 450);
  }
  commitPrompt() {
    clearTimeout(this.promptTimer), this.s.prompt !== this.promptBase && (this.promptBase = this.s.prompt, (this.board.promptOf(this.sessionId).prompt || "") !== this.s.prompt && this.board.setPrompt(this.sessionId, { prompt: this.s.prompt }));
  }
  // ------ runs
  /** Runs of yours in flight from here: being got ready, or sent and not all back. */
  busy() {
    return this.s.sending > 0 || this.items.value.some((e) => e.status === "pending" && !!e.runId && this.awaiting.has(e.runId));
  }
  /**
   * The dock's run (the Generate side): the queue, image 1 first, and the
   * words, on the open studio's model. Generate makes new images, each the
   * start of a history of its own; history shows the session.
   */
  async generate(e = null) {
    this.commitPrompt(), this.finishEditing();
    const t = this.genMode.value, i = this.modelOf(t);
    if (!i)
      return this.say("No model is available for this session"), !1;
    const s = this.sentFromQueue(), o = this.s.prompt, r = t === "threed" ? this.editInputs(t, i, s[0] ? { w: s[0].w, h: s[0].h } : this.shapeSource(t)) : this.inputsOf(t), a = await this.run({
      kind: t,
      model: i,
      pics: s.map((l) => ({ kind: "item", item: l, marks: !0 })),
      words: o,
      compiled: e != null ? e : this.s.wordsOnly ? o.trim() : this.compileFor(s, o),
      inputs: r,
      count: this.countOf(t),
      base: null,
      ref: this.ownRef(t, i)
    });
    return a && t === "threed" && this.s.studio === "threed" && this.setStudio("prompt"), a;
  }
  /**
   * Your session's own first input, sent as it is, where Prompt's model's
   * first input isn't a picture (a Video Edit model's video: the queue holds
   * pictures, so the video is the one set on the session's card), with its
   * record, so a run sends it as it is. Null otherwise: the queue's pictures
   * fill a picture input.
   */
  ownRef(e, t) {
    if (e !== "prompt") return null;
    const i = t.fields.find((o) => o.placement === "reference");
    if (!i || oo(t).includes(i)) return null;
    const s = this.board.promptOf(this.sessionId);
    return s.ref ? { url: s.ref, asset: s.assets && s.assets[s.ref] || this.board.assetFor(s.ref) } : null;
  }
  /**
   * The bar's run (IL-073): the picture on the stage, by the bar's mode (its
   * words and area, its area to erase, its marks and notes), on the bar's
   * model. Its results are the picture's next versions, in its history; the
   * first takes the stage. Your own full prompt (IL-076) goes instead of the
   * one the bar puts together, and is all it needs to go.
   */
  async generateEdit(e = null) {
    const t = this.stage.value;
    if (!t || t.status !== "done")
      return this.say("Pick an image to edit first"), !1;
    this.finishEditing();
    const i = e != null ? null : this.barProblem();
    if (i)
      return this.say(i), !1;
    const s = this.barPlan();
    return s ? this.run(e != null ? { ...s, compiled: e } : s) : (this.say("No model is available for this"), !1);
  }
  /**
   * Get a run ready and send it: stand-ins in history at once, marked
   * pictures flattened, pictures and a mask made here uploaded, then the
   * board's run path. Its first result takes the stage when it lands, unless
   * you've moved on; a Precision edit's is put back inside its area first.
   */
  async run(e) {
    const t = Xi(e.model, this.previewOf(e), e.count, !!this.board.user.isAdmin), i = t.problems[0] || this.board.tokensProblem(t.price);
    if (i)
      return this.say(i.replace(/\.$/, "")), !1;
    this.reveal();
    const s = Date.now(), o = [], r = e.base && this.items.value.find((d) => d.id === e.base) || null;
    if (!e.helper) {
      const d = zb(e.words, 5) || e.settings && typeof e.settings.label == "string" && e.settings.label || gb[e.kind] || "New image";
      for (let c = 0; c < e.count; c++)
        o.push({
          id: "sending:" + wt(),
          kind: "gen",
          url: "",
          w: r ? r.w : 4,
          h: r ? r.h : 3,
          createdAt: s + c,
          parentId: e.base,
          label: d,
          status: "pending"
        });
    }
    this.s.ghosts = [...o, ...this.s.ghosts], this.s.sending++;
    const a = this.s.stageId, l = this.draftOf(a);
    try {
      const d = [];
      for (const f of e.pics) d.push(f.kind === "item" ? await this.pictureToSend(f.item, f.marks) : await this.madeToSend(await f.make(), f.name));
      let c = _d(e.model, { prompt: e.compiled, ...Pb(e.ref), inputs: e.inputs, n: e.count }, d);
      e.mask && (c = { ...c, masks: { [e.mask.field]: await this.maskToSend(await e.mask.make()) } });
      const h = await this.board.runStudio({
        sessionId: this.sessionId,
        model: e.model,
        up: c,
        count: e.count,
        words: e.words,
        edit: e.base ? { base: e.base, studio: e.kind, settings: e.settings || null, helper: !!e.helper, precision: e.precision || null } : null,
        onFail: (f) => {
          e.helper && e.base && this.objectsFailed(e.base), this.say(f);
        }
      });
      return "error" in h ? (this.say(h.error.replace(/\.$/, "")), !1) : (this.awaiting.set(h.runId, { stageWas: a, base: e.base, helper: !!e.helper, precision: e.precision || null, finished: /* @__PURE__ */ new Set(), draft: l }), !0);
    } catch (d) {
      return this.say(d instanceof Error && d.message.replace(/\.$/, "") || "The run couldn't start. Please try again"), !1;
    } finally {
      this.s.sending = Math.max(0, this.s.sending - 1);
      const d = new Set(o.map((c) => c.id));
      this.s.ghosts = this.s.ghosts.filter((c) => !d.has(c.id));
    }
  }
  /**
   * A picture as a run sends it: as it is, or with its marks flattened in (by
   * v1's annotation service on a real board, by the browser in the harness).
   */
  async pictureToSend(e, t = !0) {
    const i = e.asset || this.board.assetFor(e.url), s = this.s.marks[e.id];
    if (!t || !Zd(s)) return { url: e.url, asset: i };
    const o = { strokes: s.strokes, pins: s.pins }, r = e.id + ":" + JSON.stringify(o), a = this.flat.get(r);
    if (a) return a;
    let l;
    if (this.board.canAnnotate) {
      const d = await this.board.flattenPicture({ url: e.url, asset: i }, await Kue(o, e.w, e.h));
      l = { url: d.url, asset: d.asset };
    } else
      l = { url: await Yue(e.url, o, e.w, e.h), asset: null };
    return this.flat.set(r, l), l;
  }
  /** A picture made for a run (the area's guide): into your uploads on a real board, a small copy in the harness. */
  async madeToSend(e, t) {
    if (!this.board.realRuns) return { url: xb(e, Ab, !1), asset: null };
    const i = await this.board.uploadFile(yb(await vb(e, !1), "board-" + t));
    return { url: i.url, asset: i.asset };
  }
  /** An area's mask for a run: kept as one of your masks on a real board (v1's inpainting masks), a stand-in in the harness. */
  async maskToSend(e) {
    return this.board.realRuns ? this.board.uploadMask(yb(await vb(e, !0), "board-mask")) : { boardMask: xb(e, 512, !0) };
  }
  /**
   * Runs sent from here: the first result takes the stage, unless you've
   * moved on or are writing. A helper run's result is the picture's objects;
   * a Precision edit's results are put back inside the area first.
   */
  landResults() {
    for (const [t, i] of Array.from(this.awaiting)) {
      const s = this.board.results.ofRun(t), o = s.filter((l) => l.status === "done" && !!l.url).sort((l, d) => l.createdAt - d.createdAt), r = s.some((l) => l.status === "pending");
      if (!o.length) {
        r || (this.awaiting.delete(t), i.helper && i.base && this.objectsFailed(i.base));
        continue;
      }
      if (i.helper) {
        this.awaiting.delete(t), i.base && this.objectsFound(i.base, o[0].url, t);
        continue;
      }
      if (i.precision) {
        for (const l of o)
          i.finished.has(l.id) || (i.finished.add(l.id), this.finishPrecision(l, i, i.finished.size === 1));
        r || this.awaiting.delete(t);
        continue;
      }
      this.awaiting.delete(t), !(this.s.editingText || this.s.editingPin || this.s.stageId !== i.stageWas || this.startedSince(i)) && (this.s.stageId = o[0].id, this.s.selection = []);
    }
    const e = this.hidden(this.board.studioRecords.forSession(this.sessionId));
    for (const t of this.board.results.list(this.sessionId)) {
      if (t.status !== "done" || !t.url || !t.runId || this.awaiting.has(t.runId) || this.resumed.has(t.id) || e.has(t.id)) continue;
      const i = this.board.studioRecords.get(Ep(t.runId));
      !i || i.role !== "edit" || !i.precision || i.updatedBy !== this.board.user.uid || this.finishPrecision(t, { stageWas: null, base: i.base, helper: !1, precision: i.precision, finished: /* @__PURE__ */ new Set(), draft: "" }, !1);
    }
  }
  /** A picture's words and marks (its area among them), to tell later whether they've changed. */
  draftOf(e) {
    if (!e) return "";
    const t = Object.values(this.s.fullEdits).filter((i) => !!i && i.on === e).map((i) => i.text);
    return JSON.stringify([this.s.asks[e] || "", this.s.marks[e] || null, t]);
  }
  /**
   * Whether you've started something on the picture a run went from since
   * it went: a tool's change not applied yet, or new words, marks or an
   * area. Its result then waits in history rather than take the stage (and
   * a tool's change isn't dropped without asking, as show() would ask).
   */
  startedSince(e) {
    return !!this.tools && this.tools.pending() || this.draftOf(e.stageWas) !== e.draft;
  }
  /**
   * A Precision edit's result put back inside its area, every other pixel
   * the original's, as a version of its own that stands in for the result
   * (which history then hides). If it can't be, the result shows as it came.
   */
  async finishPrecision(e, t, i) {
    this.resumed.add(e.id);
    const s = t.base ? this.items.value.find((a) => a.id === t.base) : null;
    if (!s || !t.precision) return;
    this.s.finishing = [...this.s.finishing, e.id];
    const o = { id: "finishing:" + e.id, kind: "gen", url: "", w: s.w, h: s.h, createdAt: e.createdAt, parentId: s.id, label: "Precision", status: "pending" };
    this.s.ghosts = [o, ...this.s.ghosts];
    const r = this.s.stageId;
    try {
      const [a, l] = await Promise.all([si(s.url), si(e.url)]), d = wl(a.width, a.height), c = Dp(t.precision.area, d.w, d.h, await this.mapsFor(t.precision.area)), h = fhe(a, l, c, Math.max(2, Math.max(d.w, d.h) * 6e-3)), f = await this.addVersion(h, { tool: "precision", label: "Precision", from: e.id }, s, { stage: !1, name: this.labelOf(e), at: e.createdAt }), p = this.s.stageId !== r && this.s.stageId !== t.stageWas;
      f && i && !p && !this.s.editingText && !this.s.editingPin && !this.startedSince(t) && (this.s.stageId = f.id);
    } catch (a) {
      console.warn("[board] a Precision edit couldn't be put back inside its area", a), this.say("The edit couldn't be kept to its area, so it shows as it came back"), i && this.s.stageId === t.stageWas && !this.startedSince(t) && (this.s.stageId = e.id);
    } finally {
      this.s.finishing = this.s.finishing.filter((a) => a !== e.id), this.s.ghosts = this.s.ghosts.filter((a) => a.id !== o.id);
    }
  }
  /**
   * A version made here by a tool (IL-073): kept in your uploads on a real
   * board (a small copy in the harness), a reference whose parent is the
   * picture it was made from, with how it was made. It takes the stage.
   */
  async addVersion(e, t, i, s = {}) {
    const o = s.alpha != null ? s.alpha : EI(e);
    let r;
    try {
      r = this.board.realRuns ? await this.board.uploadFile(yb(await vb(e, o), "board-" + t.tool)) : { url: xb(e, kpe, o), asset: null };
    } catch (l) {
      return this.say(Cd(l, "The new version")), null;
    }
    const a = this.addRef({ how: "tool", url: r.url, w: e.width, h: e.height, label: s.name || t.label, asset: r.asset, base: i.id, made: t }, s.at);
    return s.stage !== !1 && (this.finishEditing(), this.s.stageId = a.id, this.s.selection = []), a;
  }
  // ------ a picture's objects (Select)
  /** The stage picture's objects: found already (here, or by an earlier visit's run), being found, or not yet. */
  objectsOf(e) {
    if (!e) return null;
    const t = this.s.objects[e];
    if (t) return t;
    this.board.results.rev.value;
    for (const i of this.board.studioRecords.forSession(this.sessionId)) {
      if (i.role !== "edit" || !i.helper || i.base !== e) continue;
      const s = this.board.results.ofRun(i.runId).find((o) => o.status === "done" && !!o.url);
      if (s) return { status: "ready", url: s.url, runId: i.runId };
    }
    return null;
  }
  /** Find the stage picture's objects, once: a run of the segmentation model, whose result is never shown. */
  async findObjects() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return !1;
    const t = this.objectsOf(e.id);
    if (t && t.status !== "failed") return t.status === "ready";
    const i = this.modelOf("select");
    if (!i)
      return this.say("Picking objects isn't available here yet: paint or draw round the area instead"), !1;
    this.s.objects = { ...this.s.objects, [e.id]: { status: "finding" } };
    const s = await this.run({
      kind: "select",
      model: i,
      pics: [{ kind: "item", item: e, marks: !1 }],
      words: "",
      compiled: "",
      inputs: this.inputsOf("select"),
      count: 1,
      base: e.id,
      helper: !0,
      settings: { label: "Objects" }
    });
    return s || this.objectsFailed(e.id), s;
  }
  objectsFound(e, t, i) {
    this.s.objects = { ...this.s.objects, [e]: { status: "ready", url: t, runId: i } }, $f(t).catch((s) => {
      console.warn("[board] the picture's objects couldn't be read", s), this.objectsFailed(e);
    });
  }
  /** The picture's objects couldn't be found, or their map couldn't be read: Select offers to try again. */
  objectsFailed(e) {
    this.s.objects = { ...this.s.objects, [e]: { status: "failed" } };
  }
  // ---------------------------------------------------------------- Promote: which version the canvas shows
  /** A card on the canvas showing a picture from this history: the one you came in from first. */
  cardFor(e) {
    if (!e.length) return null;
    const t = (s) => e.some((o) => this.cardShows(s, o)), i = this.s.cardId ? this.board.store.get(this.s.cardId) : void 0;
    if (i && i.type === "image" && t(i)) return i;
    for (const s of this.board.store.all()) if (s.type === "image" && t(s)) return s;
    return null;
  }
  /** Whether a card shows this picture: its result, or the same picture (a reference copies another's). */
  cardShows(e, t) {
    return e.resultId && (e.resultId === t.id || e.resultId === t.source) ? !0 : !e.resultId && !!t.url && e.src === t.url;
  }
  /** The picture the card on the canvas shows now, if it's one of the stage's history. */
  onCard(e) {
    this.board.docRev.value;
    const t = this.card.value, i = this.items.value.find((s) => s.id === e);
    return !!t && !!i && this.cardShows(t, i);
  }
  /** Show this version on the canvas, in the card's place (Tyler, 2026-10-13). */
  promote(e) {
    const t = this.card.value, i = this.items.value.find((a) => a.id === e);
    if (!t || !i || i.status !== "done" || this.cardShows(t, i)) return;
    const s = i.kind === "gen" ? i.id : i.how === "board" && i.source ? i.source : null, o = s ? this.board.results.get(s) : void 0;
    this.board.showOnCard(t.id, {
      url: i.url,
      w: i.w,
      h: i.h,
      label: i.label,
      resultId: s,
      sessionId: i.kind === "gen" ? this.sessionId : t.sessionId || null,
      asset: i.asset || null,
      fav: o ? !!o.fav : !1
    }) && this.say((this.names.value.get(e) || "This version") + " is on the board now");
  }
  // ---------------------------------------------------------------- info and the board
  /** The board's info view, over the Studios view, for a generation (this session's, or another's on the board). */
  openInfo(e) {
    const t = this.itemById(e);
    if (!t || t.kind !== "gen" || t.status !== "done") return !1;
    const i = this.board.placedFor(e);
    return this.board.ui.infoSession = t.sessionId || this.sessionId, this.board.ui.infoAt = i ? i.id : "result:" + e, !0;
  }
  placeOnBoard(e) {
    const t = this.itemById(e);
    if (!(!t || t.status !== "done")) {
      if (t.kind === "gen" && t.result) {
        if (this.board.placedFor(e)) {
          this.say("Already on the board");
          return;
        }
        this.board.placeResult(t.result);
      } else {
        const s = 360 / Math.max(t.w, t.h);
        this.board.placeImages([{ url: t.url, w: Math.round(t.w * s), h: Math.round(t.h * s), label: t.label, asset: t.asset || void 0 }]);
      }
      this.say("Placed on the board");
    }
  }
  /** References, and your own results (a real board lets you delete only yours, as v1 does). */
  canDelete(e) {
    const t = this.items.value.find((i) => i.id === e);
    return !t || t.status === "pending" ? !1 : t.kind === "ref" ? !0 : !!t.result && (this.board.canDelete(t.result) || !this.board.realRuns);
  }
  async deleteItem(e) {
    const t = this.items.value.find((s) => s.id === e);
    if (!t || !this.canDelete(e)) return;
    if (t.kind === "ref")
      this.board.studioRecords.remove([e]), this.board.trashRev.value++, this.board.toast("Picture deleted. It waits in Recently Deleted.");
    else if (t.result)
      if (this.board.realRuns) {
        if (!await this.board.deleteResult(t.result)) return;
      } else
        this.board.results.remove([e]), this.board.binResult(t.result);
    const i = m_(e);
    if (this.board.studioRecords.has(i) && this.board.studioRecords.remove([i]), this.s.queue.includes(e) && this.setQueue(L_(this.s.queue, e)), this.s.stageId === e) {
      const s = this.family.value.find((o) => o.id !== e && o.status === "done");
      this.s.stageId = s ? s.id : null;
    }
  }
  say(e) {
    clearTimeout(this.noteTimer), this.s.note = { id: Date.now(), text: e }, this.noteTimer = window.setTimeout(() => {
      this.s.note = null;
    }, 3200);
  }
  /** Leaving: what's typed and drawn is saved. */
  leave() {
    this.s.dropper = !1, this.finishEditing(), this.commitPrompt(), this.saveMarks();
  }
  dispose() {
    this.leave(), this.tools.dispose(), this.scope.stop(), clearTimeout(this.noteTimer), clearTimeout(this.promptTimer), clearTimeout(this.marksTimer);
  }
}
function Pb(n) {
  return n ? { ref: n.url, assets: n.asset ? { [n.url]: n.asset } : {} } : {};
}
const Eb = "sample:bonneville-massing";
function a4(n) {
  return {
    id: n.id,
    kind: "ref",
    how: n.how,
    url: n.url,
    w: n.pw || 4,
    h: n.ph || 3,
    createdAt: n.createdAt,
    parentId: n.base || null,
    label: n.label,
    status: "done",
    source: n.source || void 0,
    asset: n.asset || null,
    camera: n.camera || null,
    shot: n.shot || void 0,
    modelId: n.model || void 0,
    made: n.made || null
  };
}
function Rb(n) {
  if (!n || n.kind !== "3d" || !n.download) return null;
  const e = (/\.([a-z0-9]+)$/i.exec(decodeURIComponent(n.download.split("?")[0])) || ["", "glb"])[1].toLowerCase();
  return { name: n.label || "Model", url: n.download, ext: e, asset: n.asset || null };
}
function l4(n, e) {
  return n.status === "moderated" || n.status === "done" && !n.url ? !1 : !e.has(n.id) && !(n.runId && e.has("run:" + n.runId));
}
function Spe(n, e) {
  return JSON.stringify(L0(n)) === JSON.stringify(L0(e));
}
function L0(n) {
  const e = (i) => Math.round(i * 100) / 100, t = (i) => Number((i || 0).toPrecision(3));
  return { yaw: e(n.yaw), pitch: e(n.pitch), dist: t(n.dist), tx: t(n.tx), ty: t(n.ty), tz: t(n.tz), ox: t(n.ox), oy: t(n.oy) };
}
const Mpe = [
  /^Image 1 is the image to edit/,
  /^Follow (the numbered markers|the marks drawn)/,
  /^Marker \d+:/,
  /^Image \d+, marker \d+:/,
  // today's wording (IL-100); the lines above read results made before it
  /^Follow (the numbered annotations|the annotations drawn)/,
  /^Annotation \d+:/,
  /^Image \d+, annotation \d+:/,
  /^The area to change is marked/,
  /^Remove what is marked in magenta/,
  /^Image 2 is image 1 with the area/
];
function Tpe(n) {
  return n.split(`
`).filter((e) => e.trim() && !Mpe.some((t) => t.test(e.trim()))).join(" ").trim();
}
function zb(n, e) {
  const t = n.trim().split(/\s+/).filter(Boolean);
  return t.slice(0, e).join(" ") + (t.length > e ? "…" : "");
}
function Cd(n, e) {
  return (n && typeof n == "object" && "userMessage" in n ? String(n.userMessage || "") : "") || e + " couldn't be uploaded";
}
function Id(n) {
  return new Promise((e) => {
    const t = new Image();
    t.onload = () => e({ w: t.naturalWidth || 4, h: t.naturalHeight || 3 }), t.onerror = () => e({ w: 4, h: 3 }), t.src = n;
  });
}
function Cpe(n) {
  if (!("nodeRunResult" in n)) return null;
  const e = n.nodeRunResult;
  return typeof e.nodeRunId == "string" && typeof e.uuid == "string" ? e.nodeRunId + ":" + e.uuid : null;
}
function d4(n, e) {
  return new Promise((t, i) => {
    const s = URL.createObjectURL(n), o = new Image();
    o.onload = () => {
      const r = Math.min(1, e / Math.max(o.naturalWidth, o.naturalHeight)), a = document.createElement("canvas");
      a.width = Math.max(1, Math.round(o.naturalWidth * r)), a.height = Math.max(1, Math.round(o.naturalHeight * r));
      const l = a.getContext("2d");
      if (URL.revokeObjectURL(s), !l) {
        i(new Error(n.name + " couldn't be read as an image"));
        return;
      }
      l.fillStyle = "#ffffff", l.fillRect(0, 0, a.width, a.height), l.drawImage(o, 0, 0, a.width, a.height), t(a.toDataURL("image/jpeg", 0.86));
    }, o.onerror = () => {
      URL.revokeObjectURL(s), i(new Error(n.name + " couldn't be read as an image"));
    }, o.src = s;
  });
}
function Ipe(n) {
  try {
    const e = JSON.parse(localStorage.getItem(qI(n)) || "{}");
    !e.edit && e.draw && (e.edit = e.draw);
    const t = {};
    for (const i of WI) {
      const s = e[i];
      if (!s || typeof s.modelId != "string") continue;
      t[i] = { modelId: s.modelId, count: Number(s.count) || 1, inputs: s.inputs && typeof s.inputs == "object" ? s.inputs : {} };
      const o = Number(s.tier);
      s.tier != null && Number.isInteger(o) && o >= 0 && (t[i].tier = o);
    }
    return t;
  } catch {
    return {};
  }
}
const B0 = (n) => "rd-board-studio-hist:" + n, F0 = (n) => "rd-board-studio-words-only:" + n;
function Ape(n) {
  try {
    return localStorage.getItem(F0(n)) === "1";
  } catch {
    return !1;
  }
}
function Ppe(n, e) {
  try {
    e ? localStorage.setItem(F0(n), "1") : localStorage.removeItem(F0(n));
  } catch {
  }
}
function Epe(n) {
  try {
    return localStorage.getItem(B0(n)) === "shut";
  } catch {
    return !1;
  }
}
function Rpe(n, e) {
  try {
    e ? localStorage.setItem(B0(n), "shut") : localStorage.removeItem(B0(n));
  } catch {
  }
}
function zpe(n, e) {
  try {
    localStorage.setItem(qI(n), JSON.stringify(e));
  } catch {
  }
}
const c4 = /* @__PURE__ */ new WeakMap();
function N0(n, e) {
  let t = c4.get(n);
  t || (t = /* @__PURE__ */ new Map(), c4.set(n, t));
  let i = t.get(e);
  return i || (i = new _pe(n, e), t.set(e, i)), i;
}
function $pe() {
  return wt();
}
const YI = /* @__PURE__ */ Symbol("studio");
function Dpe(n) {
  y5(YI, { studio: n });
}
function yt() {
  const n = tm(YI);
  if (!n) throw new Error("useStudio() outside the Studios view");
  return n.studio;
}
const Ope = ["value"], Lpe = /* @__PURE__ */ Pe({
  __name: "DrawLayer",
  props: {
    w: {},
    h: {}
  },
  emits: ["live"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = yt(), o = s.s, r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(!1), c = /* @__PURE__ */ W(null), h = I(() => ({ w: t.w, h: t.h })), f = I(() => s.working().strokes);
    let p = null;
    function y(L) {
      const N = r.value.getBoundingClientRect();
      return { x: (L.clientX - N.left) * (t.w / (N.width || t.w)), y: (L.clientY - N.top) * (t.h / (N.height || t.h)) };
    }
    function v(L) {
      return { x: Math.min(t.w, Math.max(0, L.x)), y: Math.min(t.h, Math.max(0, L.y)) };
    }
    function x(L, N = !1) {
      const K = f.value;
      for (let B = K.length - 1; B >= 0; B--) {
        const re = K[B];
        if (!(N && re.kind !== "text") && xue(re, L, h.value))
          return re;
      }
      return null;
    }
    function w(L) {
      const N = Sc(L, h.value);
      if (!L.rot) return N;
      const K = Yr(L, h.value), B = [{ x: N.x, y: N.y }, { x: N.x + N.w, y: N.y }, { x: N.x + N.w, y: N.y + N.h }, { x: N.x, y: N.y + N.h }].map((J) => Lo(J, K, L.rot)), re = B.map((J) => J.x), H = B.map((J) => J.y);
      return { x: Math.min(...re), y: Math.min(...H), w: Math.max(...re) - Math.min(...re), h: Math.max(...H) - Math.min(...H) };
    }
    function S() {
      const L = document.activeElement;
      L && L !== a.value && /^(INPUT|TEXTAREA|BUTTON|SELECT)$/.test(L.tagName) && L.blur();
    }
    function M(L) {
      if (L.button !== 0 || !r.value) return;
      S();
      const N = y(L);
      o.editingText && s.commitText(o.editingText), L.preventDefault(), r.value.setPointerCapture(L.pointerId);
      const K = o.tool;
      if (K === "move") {
        _(L, N);
        return;
      }
      if (K === "text") {
        const H = x(N, !0);
        if (H) {
          s.editText(H.id);
          return;
        }
        const J = Math.min(N.x, Math.max(0, t.w - 50)), Q = Math.min(N.y, Math.max(0, t.h - 50));
        s.addText($o({ x: J, y: Q }, h.value), Math.max(gue, o.size) / Kr(h.value));
        return;
      }
      if (K === "eraser") {
        s.beginGesture(), p = { kind: "erase", start: N, last: N, moved: !1, trails: /* @__PURE__ */ new Map() }, R(N);
        return;
      }
      if (K === "note") return;
      const B = $o(v(N), h.value), re = { id: $pe(), kind: K, color: o.color, size: o.size / Kr(h.value), pts: K === "brush" ? [B] : [B, B], opacity: o.opacity };
      p = { kind: "draw", stroke: re }, i("live", re);
    }
    function _(L, N) {
      const K = L.target.dataset.handle, B = o.selection.length === 1 && f.value.find((H) => H.id === o.selection[0]) || null;
      if (B && K) {
        if (s.beginGesture(), K === "turn") {
          const H = Yr(B, h.value);
          p = { kind: "turn", orig: B, centre: H, a0: Math.atan2(N.y - H.y, N.x - H.x) };
        } else {
          const H = Sc(B, h.value), Q = {
            nw: { x: H.x + H.w, y: H.y + H.h },
            ne: { x: H.x, y: H.y + H.h },
            se: { x: H.x, y: H.y },
            sw: { x: H.x + H.w, y: H.y }
          }[K], ne = B.rot ? Lo(Q, Yr(B, h.value), B.rot) : Q;
          p = { kind: "resize", orig: B, anchor: ne, box: H, even: B.kind === "text" };
        }
        return;
      }
      const re = x(N);
      if (re) {
        if (L.shiftKey) {
          s.select(o.selection.includes(re.id) ? o.selection.filter((J) => J !== re.id) : [...o.selection, re.id]);
          return;
        }
        o.selection.includes(re.id) || s.select([re.id]), s.beginGesture();
        const H = /* @__PURE__ */ new Map();
        for (const J of f.value) o.selection.includes(J.id) && H.set(J.id, J);
        p = { kind: "move", start: N, orig: H, moved: !1 };
        return;
      }
      p = { kind: "marquee", start: N, before: L.shiftKey ? o.selection.slice() : [] }, L.shiftKey || s.select([]), c.value = { x: N.x, y: N.y, w: 0, h: 0 };
    }
    function T(L) {
      const N = y(L);
      if ((o.tool === "brush" || o.tool === "eraser") && (l.value = N), !p) {
        d.value = o.tool === "move" && !!x(N);
        return;
      }
      if (!r.value || !r.value.hasPointerCapture(L.pointerId)) return;
      const K = p;
      if (K.kind === "draw") {
        const B = $o(v(N), h.value), re = K.stroke;
        if (re.kind === "brush") {
          const H = re.pts[re.pts.length - 1];
          if (Math.hypot((B.x - H.x) * t.w, (B.y - H.y) * t.h) < 2) return;
          K.stroke = { ...re, pts: [...re.pts, B] };
        } else
          K.stroke = { ...re, pts: [re.pts[0], B] };
        i("live", K.stroke);
      } else if (K.kind === "erase")
        R(N);
      else if (K.kind === "move") {
        if (!K.moved && Math.hypot(N.x - K.start.x, N.y - K.start.y) < 2) return;
        K.moved = !0;
        const B = (N.x - K.start.x) / t.w, re = (N.y - K.start.y) / t.h;
        s.updateStrokes(Array.from(K.orig.keys()), (H) => gI(K.orig.get(H.id) || H, B, re), !1);
      } else if (K.kind === "resize") {
        const B = K.orig, re = Yr(B, h.value), H = B.rot ? Lo(N, re, -B.rot) : N, J = B.rot ? Lo(K.anchor, re, -B.rot) : K.anchor;
        let Q = Math.abs(H.x - J.x) / Math.max(1, K.box.w), ne = Math.abs(H.y - J.y) / Math.max(1, K.box.h);
        if (K.even || L.shiftKey) {
          const ue = Math.max(Q, ne);
          Q = ue, ne = ue;
        }
        s.updateStrokes([B.id], () => wue(B, K.anchor, Math.max(0.05, Q), Math.max(0.05, ne), h.value), !1);
      } else if (K.kind === "turn") {
        let B = (K.orig.rot || 0) + Math.atan2(N.y - K.centre.y, N.x - K.centre.x) - K.a0;
        L.shiftKey && (B = Math.round(B / (Math.PI / 12)) * (Math.PI / 12)), s.updateStrokes([K.orig.id], (re) => ({ ...re, rot: B }), !1);
      } else if (K.kind === "marquee") {
        const B = { x: Math.min(K.start.x, N.x), y: Math.min(K.start.y, N.y), w: Math.abs(N.x - K.start.x), h: Math.abs(N.y - K.start.y) };
        c.value = B;
        const re = f.value.filter((H) => _ue(w(H), B)).map((H) => H.id);
        s.select(Array.from(/* @__PURE__ */ new Set([...K.before, ...re])));
      }
    }
    function k(L) {
      r.value && r.value.hasPointerCapture(L.pointerId) && r.value.releasePointerCapture(L.pointerId);
      const N = p;
      if (p = null, c.value = null, i("live", null), !!N)
        if (N.kind === "draw") {
          const K = N.stroke, B = K.pts[0], re = K.pts[K.pts.length - 1], H = Math.hypot((re.x - B.x) * t.w, (re.y - B.y) * t.h);
          if (K.kind !== "brush" && H < 4) return;
          s.addStroke(K);
        } else if (N.kind === "erase") {
          if (!N.moved) {
            const K = x(N.start, !0);
            if (K) {
              s.dropGesture(), s.deleteStrokes([K.id]);
              return;
            }
          }
          N.trails.size || s.dropGesture();
        } else N.kind === "move" && !N.moved && s.dropGesture();
    }
    function P() {
      l.value = null, d.value = !1;
    }
    function A(L) {
      if (o.tool !== "move") return;
      const N = x(y(L), !0);
      N && s.editText(N.id);
    }
    function R(L) {
      const N = p;
      if (!N || N.kind !== "erase") return;
      Math.hypot(L.x - N.start.x, L.y - N.start.y) > 4 && (N.moved = !0);
      const K = N.last;
      N.last = L;
      const B = o.size, re = h.value;
      let H = !1;
      for (const Q of f.value) {
        const ne = N.trails.get(Q.id);
        ne ? (ne.trail.pts.push($o(yl(L, Q, re), re)), H = !0) : kue(Q, K, L, B, re) && (N.trails.set(Q.id, {
          before: Q.erase || [],
          trail: { pts: [$o(yl(K, Q, re), re), $o(yl(L, Q, re), re)], size: B / Kr(re) }
        }), H = !0);
      }
      if (!H) return;
      const J = N.trails;
      s.updateStrokes(Array.from(J.keys()), (Q) => {
        const ne = J.get(Q.id);
        return { ...Q, erase: [...ne.before, { size: ne.trail.size, pts: ne.trail.pts.slice() }] };
      }, !1);
    }
    const D = (L) => L.kind === "text" ? 5 : L.size * Kr(h.value) / 2 + 5, O = I(() => {
      if (o.tool !== "move") return [];
      const L = new Set(o.selection);
      return f.value.filter((N) => L.has(N.id)).map((N) => {
        const K = Sc(N, h.value), B = D(N);
        return { id: N.id, left: K.x - B, top: K.y - B, width: K.w + B * 2, height: K.h + B * 2, rot: N.rot || 0 };
      });
    }), F = I(() => f.value.find((L) => L.id === o.editingText && L.kind === "text") || null), ie = I(() => {
      const L = F.value;
      if (!L) return null;
      const N = Tu(L, h.value), K = Math.max(N.font, t.w - N.box.x);
      return {
        left: N.box.x + "px",
        top: N.box.y + "px",
        width: Math.min(K, N.box.w + N.font * 0.7) + "px",
        height: Math.max(N.box.h, N.font * eu) + "px",
        fontSize: N.font + "px",
        lineHeight: String(eu),
        fontFamily: Qc,
        color: L.color,
        transform: L.rot ? "rotate(" + L.rot + "rad)" : void 0
      };
    });
    Ee(() => o.editingText, (L) => {
      L && nt(() => {
        a.value && (a.value.focus(), a.value.select());
      });
    });
    function ee(L) {
      var N;
      L.key === "Enter" && (L.metaKey || L.ctrlKey) && (L.preventDefault(), (N = a.value) == null || N.blur());
    }
    function me() {
      o.editingText && s.commitText(o.editingText);
    }
    return (L, N) => (g(), b("div", {
      ref_key: "layer",
      ref: r,
      class: G(["sv-layer is-draw", ["tool-" + m(o).tool, { "is-over": d.value }]]),
      "data-testid": "studio-draw-layer",
      onPointerdown: M,
      onPointermove: T,
      onPointerup: k,
      onPointercancel: k,
      onPointerleave: P,
      onDblclick: A
    }, [
      (g(!0), b(j, null, ge(O.value, (K) => (g(), b("div", {
        key: K.id,
        class: "sv-sel",
        style: ce({ left: K.left + "px", top: K.top + "px", width: K.width + "px", height: K.height + "px", transform: K.rot ? "rotate(" + K.rot + "rad)" : void 0 })
      }, [
        O.value.length === 1 ? (g(), b(j, { key: 0 }, [
          N[2] || (N[2] = C1('<i class="h nw" data-handle="nw"></i><i class="h ne" data-handle="ne"></i><i class="h se" data-handle="se"></i><i class="h sw" data-handle="sw"></i><i class="stem"></i><i class="h turn" data-handle="turn" title="Turn (Shift snaps)"></i>', 6))
        ], 64)) : z("", !0)
      ], 4))), 128)),
      c.value ? (g(), b("div", {
        key: 0,
        class: "sv-marquee",
        style: ce({ left: c.value.x + "px", top: c.value.y + "px", width: c.value.w + "px", height: c.value.h + "px" })
      }, null, 4)) : z("", !0),
      l.value && (m(o).tool === "brush" || m(o).tool === "eraser") ? (g(), b("span", {
        key: 1,
        class: G(["sv-ring", { "is-eraser": m(o).tool === "eraser" }]),
        style: ce({ left: l.value.x + "px", top: l.value.y + "px", width: Math.max(4, m(o).size) + "px", height: Math.max(4, m(o).size) + "px" })
      }, null, 6)) : z("", !0),
      F.value && ie.value ? (g(), b("textarea", {
        key: 2,
        ref_key: "editor",
        ref: a,
        class: "sv-text-editor",
        style: ce(ie.value),
        value: F.value.text,
        placeholder: "Text",
        spellcheck: "false",
        "data-testid": "studio-text-editor",
        onInput: N[0] || (N[0] = (K) => m(s).setText(F.value.id, K.target.value)),
        onKeydown: ee,
        onBlur: me,
        onPointerdown: N[1] || (N[1] = Te(() => {
        }, ["stop"]))
      }, null, 44, Ope)) : z("", !0)
    ], 34));
  }
}), Bpe = ["title", "data-testid", "onPointerdown"], Fpe = { class: "sv-pin-editor-head" }, Npe = { class: "n" }, Upe = ["value"], Gpe = { class: "sv-pin-editor-foot" }, jpe = /* @__PURE__ */ Pe({
  __name: "PinLayer",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = yt(), i = t.s, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = I(() => t.working().pins), a = I(() => r.value.find((x) => x.id === i.editingPin) || null);
    Ee(() => i.editingPin, (x) => {
      x && nt(() => o.value && o.value.focus());
    });
    function l(x) {
      const w = s.value.getBoundingClientRect();
      return { x: Math.min(1, Math.max(0, (x.clientX - w.left) / w.width)), y: Math.min(1, Math.max(0, (x.clientY - w.top) / w.height)) };
    }
    function d(x) {
      if (x.button !== 0) return;
      if (x.preventDefault(), i.editingPin) {
        t.commitPin(i.editingPin);
        return;
      }
      const w = l(x);
      t.addPin(w.x, w.y);
    }
    let c = null;
    function h(x, w) {
      w.stopPropagation(), w.button === 0 && (w.currentTarget.setPointerCapture(w.pointerId), c = { id: x, x0: w.clientX, y0: w.clientY, moved: !1 });
    }
    function f(x) {
      if (!c || !c.moved && Math.hypot(x.clientX - c.x0, x.clientY - c.y0) < 4) return;
      const w = !c.moved;
      c.moved = !0;
      const S = l(x);
      t.movePin(c.id, S.x, S.y, w);
    }
    function p(x) {
      const w = c;
      c = null, x.currentTarget.releasePointerCapture(x.pointerId), w && !w.moved && t.editPin(w.id);
    }
    function y(x, w) {
      x.key === "Enter" && !x.shiftKey ? (x.preventDefault(), t.commitPin(w)) : x.key === "Escape" && (x.preventDefault(), x.stopPropagation(), t.commitPin(w));
    }
    const v = I(() => {
      const x = a.value;
      if (!x) return null;
      const w = x.x * e.w, S = x.y * e.h;
      return { left: w > e.w - 280 ? w - 262 : w + 22, top: Math.min(Math.max(S - 22, -8), e.h - 120) };
    });
    return (x, w) => (g(), b("div", {
      ref_key: "layer",
      ref: s,
      class: "sv-layer is-comment",
      "data-testid": "studio-pin-layer",
      onPointerdown: Te(d, ["self"])
    }, [
      (g(!0), b(j, null, ge(r.value, (S, M) => (g(), b("button", {
        key: S.id,
        class: G(["sv-pin", { "is-on": m(i).editingPin === S.id, "is-empty": !S.text.trim() }]),
        style: ce({ left: S.x * 100 + "%", top: S.y * 100 + "%" }),
        title: S.text || "New note",
        "data-testid": "studio-pin-" + (M + 1),
        onPointerdown: (_) => h(S.id, _),
        onPointermove: f,
        onPointerup: p
      }, E(M + 1), 47, Bpe))), 128)),
      a.value && v.value ? (g(), b("div", {
        key: 0,
        class: "sv-pin-editor",
        style: ce({ left: v.value.left + "px", top: v.value.top + "px" }),
        onPointerdown: w[4] || (w[4] = Te(() => {
        }, ["stop"]))
      }, [
        u("div", Fpe, [
          u("span", Npe, E(r.value.indexOf(a.value) + 1), 1),
          w[5] || (w[5] = u("span", { class: "t" }, "Note for the model", -1)),
          u("button", {
            class: "x",
            title: "Delete this note",
            onClick: w[0] || (w[0] = (S) => m(t).removePin(a.value.id))
          }, [
            C($, {
              name: "Trash2",
              size: 12
            })
          ])
        ]),
        u("textarea", {
          ref_key: "editor",
          ref: o,
          value: a.value.text,
          rows: "2",
          spellcheck: "false",
          placeholder: "What should change here?",
          "data-testid": "studio-pin-text",
          onInput: w[1] || (w[1] = (S) => m(t).setPinText(a.value.id, S.target.value)),
          onKeydown: w[2] || (w[2] = (S) => y(S, a.value.id))
        }, null, 40, Upe),
        u("div", Gpe, [
          w[6] || (w[6] = u("span", null, "Enter to save", -1)),
          u("button", {
            class: "sv-mini-btn",
            onClick: w[3] || (w[3] = (S) => m(t).commitPin(a.value.id))
          }, "Done")
        ])
      ], 36)) : z("", !0)
    ], 544));
  }
}), u4 = 1400, Hpe = 3e-3, Vpe = 1, h4 = 4096, p4 = {
  studio: [0.925, 0.918, 0.902, 1],
  clear: [0, 0, 0, 0],
  night: [0.055, 0.06, 0.09, 1]
};
function Wpe(n, e) {
  const t = Math.PI * 2;
  let i = (e - n) % t;
  return i > Math.PI && (i -= t), i < -Math.PI && (i += t), n + i;
}
function qpe(n) {
  return n < 0.5 ? 4 * n * n * n : 1 - Math.pow(-2 * n + 2, 3) / 2;
}
function Kpe(n, e, t) {
  const i = (s, o) => s + (o - s) * t;
  return {
    yaw: i(n.yaw, Wpe(n.yaw, e.yaw)),
    pitch: i(n.pitch, e.pitch),
    dist: i(n.dist, e.dist),
    tx: i(n.tx, e.tx),
    ty: i(n.ty, e.ty),
    tz: i(n.tz, e.tz),
    ox: i(n.ox || 0, e.ox || 0),
    oy: i(n.oy || 0, e.oy || 0)
  };
}
async function Ype(n, e) {
  const t = new n.Engine(e, !0, { preserveDrawingBuffer: !0, stencil: !0 }, !0), i = new n.Scene(t), s = new n.ArcRotateCamera("studio-camera", Math.PI / 2, Math.PI / 2.5, 3, n.Vector3.Zero(), i);
  s.attachControl(e, !0), s.angularSensibilityX = u4, s.angularSensibilityY = u4, s.wheelDeltaPercentage = Hpe, s.inertia = 0.6, s.panningInertia = 0.6, s.lowerRadiusLimit = 0.01, s.minZ = 0.01, s.lowerBetaLimit = 0.02, s.upperBetaLimit = Math.PI - 0.02;
  const o = new n.HemisphericLight("studio-hemi", new n.Vector3(0, 1, 0), i);
  o.intensity = 0.75, o.groundColor = new n.Color3(0.32, 0.31, 0.34);
  const r = new n.DirectionalLight("studio-sun", new n.Vector3(-0.55, -1, -0.35), i);
  r.intensity = 0.75;
  let a = [], l = { yaw: Math.PI / 2, pitch: Math.PI / 2.5, dist: 3, tx: 0, ty: 0, tz: 0, ox: 0, oy: 0 }, d = null;
  const c = /* @__PURE__ */ new Set();
  let h = 0;
  const f = () => ({
    yaw: s.alpha,
    pitch: s.beta,
    dist: s.radius,
    tx: s.target.x,
    ty: s.target.y,
    tz: s.target.z,
    ox: s.targetScreenOffset.x,
    oy: s.targetScreenOffset.y
  }), p = (L) => {
    s.alpha = L.yaw, s.beta = L.pitch, s.radius = L.dist, s.setTarget(new n.Vector3(L.tx, L.ty, L.tz)), s.alpha = L.yaw, s.beta = L.pitch, s.radius = L.dist, s.targetScreenOffset.set(L.ox || 0, L.oy || 0);
  }, y = () => {
    h || (h = requestAnimationFrame(() => {
      h = 0;
      const L = f();
      for (const N of c) N(L);
    }));
  };
  s.onViewMatrixChangedObservable.add(y);
  const v = () => (s.radius > 0 ? s.radius : 1) * Math.tan((s.fov > 0 ? s.fov : 0.8) / 2), x = () => {
    const L = v() * Vpe, N = s.targetScreenOffset, K = Math.hypot(N.x, N.y);
    K > L && K > 0 && N.set(N.x * L / K, N.y * L / K);
  };
  s.panningSensibility = 1200, s.panningAxis = new n.Vector3(0, 0, 0);
  let w = null;
  const S = (L) => L.button === 2 || L.button === 0 && L.ctrlKey, M = (L) => {
    S(L) && (w = { x: L.clientX, y: L.clientY }, d = null);
  }, _ = (L) => {
    if (!w) return;
    if (L.buttons === 0) {
      w = null;
      return;
    }
    const N = 2 * v() / Math.max(1, e.clientHeight), K = s.targetScreenOffset;
    K.set(K.x + (L.clientX - w.x) * N, K.y - (L.clientY - w.y) * N), w = { x: L.clientX, y: L.clientY }, x(), y();
  }, T = () => {
    w = null;
  }, k = () => {
    w = null, window.removeEventListener("pointermove", _), window.removeEventListener("pointerup", k), window.removeEventListener("pointercancel", k);
  }, P = (L) => {
    L.target !== e || L.button !== 0 || !L.shiftKey || L.ctrlKey || (L.stopPropagation(), L.preventDefault(), w = { x: L.clientX, y: L.clientY }, d = null, window.addEventListener("pointermove", _), window.addEventListener("pointerup", k), window.addEventListener("pointercancel", k));
  };
  window.addEventListener("pointerdown", P, !0);
  const A = (L) => L.preventDefault();
  e.addEventListener("pointerdown", M), e.addEventListener("pointermove", _), e.addEventListener("pointerup", T), e.addEventListener("pointercancel", T), e.addEventListener("contextmenu", A);
  let R = null;
  const D = () => {
    if (R == null) return;
    const L = Math.max(s.radius, 1e-6), N = (R + L * 0.02 - s.target.y) / L, K = N <= -1 ? Math.PI - 0.02 : N >= 1 ? 0.02 : Math.min(Math.PI - 0.02, Math.acos(N));
    s.upperBetaLimit = Math.max(0.02, K), s.beta > s.upperBetaLimit && (s.beta = s.upperBetaLimit);
  }, O = i.onBeforeRenderObservable.add(() => {
    if (d) {
      const L = Math.min(1, (performance.now() - d.t0) / d.ms);
      p(Kpe(d.from, d.to, qpe(L))), L >= 1 && (d = null);
    }
    x(), D();
  }), F = new ResizeObserver(() => t.resize());
  F.observe(e), t.runRenderLoop(() => i.render());
  let ie = "studio";
  const ee = (L) => {
    ie = L;
    const N = p4[L];
    i.clearColor = new n.Color4(N[0], N[1], N[2], N[3]);
  };
  ee("studio");
  const me = () => {
    let L = null, N = null;
    for (const re of i.meshes) {
      if (!re.getTotalVertices()) continue;
      re.computeWorldMatrix(!0);
      const H = re.getBoundingInfo().boundingBox;
      L = L ? n.Vector3.Minimize(L, H.minimumWorld) : H.minimumWorld.clone(), N = N ? n.Vector3.Maximize(N, H.maximumWorld) : H.maximumWorld.clone();
    }
    if (!L || !N) return l;
    const K = Math.max(N.x - L.x, N.y - L.y, N.z - L.z) || 2;
    R = L.y;
    const B = K * 1.5;
    return s.lowerRadiusLimit = B * 0.08, s.upperRadiusLimit = B * 10, s.minZ = B * 2e-3, s.maxZ = B * 60, {
      yaw: Math.PI / 2 + 0.75,
      pitch: 1.2,
      dist: B,
      tx: (L.x + N.x) / 2,
      ty: (L.y + N.y) / 2,
      tz: (L.z + N.z) / 2,
      ox: 0,
      oy: 0
    };
  };
  return {
    async load(L, N) {
      const K = L instanceof File ? L : new File([L], "model." + N), B = await n.SceneLoader.ImportMeshAsync("", "", K, i, null, "." + N.replace(/^\./, ""));
      for (const H of a) H.dispose();
      a = B.meshes;
      const re = new n.StandardMaterial("studio-clay", i);
      re.diffuseColor = new n.Color3(0.8, 0.77, 0.73), re.specularColor = new n.Color3(0.08, 0.08, 0.08), re.backFaceCulling = !1;
      for (const H of B.meshes) !H.material && H.getTotalVertices() && (H.material = re);
      l = me(), d = null, p(l);
    },
    camera: f,
    setCamera(L) {
      d = null, p(L);
    },
    fly(L, N = 460) {
      d = { from: f(), to: L, t0: performance.now(), ms: N };
    },
    home: () => ({ ...l }),
    setBackdrop: ee,
    async capture(L, N, K) {
      const B = Math.max(1, e.clientWidth), re = Math.max(1, e.clientHeight);
      let H = Math.max(N / L.w, K / L.h);
      H = Math.min(H, h4 / B, h4 / re);
      const J = Math.round(B * H), Q = Math.round(re * H), ne = await new Promise((we) => {
        n.CreateScreenshotUsingRenderTarget(t, s, { width: J, height: Q, precision: 1 }, (Fe) => we(Fe), "image/png", 1, !0);
      }), ue = await new Promise((we, Fe) => {
        const Me = new Image();
        Me.onload = () => we(Me), Me.onerror = () => Fe(new Error("The view couldn't be captured.")), Me.src = ne;
      }), Z = document.createElement("canvas");
      Z.width = N, Z.height = K;
      const te = Z.getContext("2d");
      if (!te) throw new Error("The view couldn't be captured.");
      if (ie !== "clear") {
        const we = p4[ie];
        te.fillStyle = "rgb(" + Math.round(we[0] * 255) + "," + Math.round(we[1] * 255) + "," + Math.round(we[2] * 255) + ")", te.fillRect(0, 0, N, K);
      }
      return te.drawImage(ue, L.x * H, L.y * H, L.w * H, L.h * H, 0, 0, N, K), new Promise((we, Fe) => Z.toBlob((Me) => Me ? we(Me) : Fe(new Error("The view couldn't be captured.")), "image/png"));
    },
    onCamera(L) {
      return c.add(L), () => c.delete(L);
    },
    dispose() {
      cancelAnimationFrame(h), c.clear(), F.disconnect(), i.onBeforeRenderObservable.remove(O), e.removeEventListener("pointerdown", M), e.removeEventListener("pointermove", _), e.removeEventListener("pointerup", T), e.removeEventListener("pointercancel", T), e.removeEventListener("contextmenu", A), window.removeEventListener("pointerdown", P, !0), k();
      try {
        t.stopRenderLoop(), t.dispose();
      } catch {
      }
    }
  };
}
const Xpe = { class: "sv-finder-tag" }, Jpe = {
  key: 1,
  class: "sv-model-state",
  "data-testid": "studio-3d-loading"
}, Zpe = {
  key: 2,
  class: "sv-model-state is-error",
  "data-testid": "studio-3d-error"
}, Qpe = {
  class: "sv-seg is-text is-small is-dark",
  role: "radiogroup",
  "aria-label": "Frame"
}, efe = ["aria-checked", "title", "data-testid", "onClick"], tfe = {
  class: "sv-seg is-text is-small is-dark",
  role: "radiogroup",
  "aria-label": "Backdrop"
}, nfe = ["aria-checked", "onClick"], ife = /* @__PURE__ */ Pe({
  __name: "ModelView",
  setup(n, { expose: e }) {
    const t = yt(), { board: i } = Ze(), s = t.s, o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W({ w: 800, h: 600 }), l = /* @__PURE__ */ W(!1), d = [
      { id: "studio", label: "Studio" },
      { id: "clear", label: "Clear" },
      { id: "night", label: "Night" }
    ], c = ["1:1", "4:3", "3:4", "16:9", "9:16"];
    let h = null, f = null, p = null, y = !1;
    const v = I(() => {
      const k = t.captureRatio(), P = a.value.w - 48, A = a.value.h - 48, R = Math.min(P, A * k), D = R / k;
      return { w: R, h: D, left: (a.value.w - R) / 2, top: (a.value.h - D) / 2 };
    });
    function x(k) {
      const P = k instanceof Error ? k.message : "";
      return P && /couldn't|isn't|unavailable/i.test(P) ? P : "This file couldn't be read as a 3D model. Try a .glb, or an .obj or .stl.";
    }
    async function w(k) {
      if (!(!h || !k || p === k.id)) {
        p = k.id, s.three.loading = !0, s.three.error = null;
        try {
          const P = await t.modelFile(k);
          if (y || p !== k.id || !h || (await h.load(P, k.ext), y || p !== k.id || !h)) return;
          s.three.cam = h.camera();
        } catch (P) {
          console.warn("[board] 3D model not shown", P), p === k.id && (s.three.error = x(P), p = null);
        } finally {
          y || (s.three.loading = !1);
        }
      }
    }
    let S = null;
    it(async () => {
      o.value && (S = new ResizeObserver(() => {
        if (!o.value) return;
        const P = o.value.getBoundingClientRect();
        a.value = { w: Math.max(200, P.width), h: Math.max(160, P.height) };
      }), S.observe(o.value));
      const k = i.babylon;
      if (!k || !r.value) {
        s.three.error = "3D isn't available here.";
        return;
      }
      s.three.loading = !0;
      try {
        const P = await k();
        if (y || !r.value) return;
        h = await Ype(P, r.value);
      } catch (P) {
        console.error("[board] 3D unavailable", P), s.three.error = "3D couldn't start in this browser.", s.three.loading = !1;
        return;
      }
      if (y) {
        h.dispose(), h = null;
        return;
      }
      h.setBackdrop(s.three.backdrop), f = h.onCamera((P) => {
        s.three.cam = P;
      }), l.value = !0, s.three.loading = !1, await w(t.model3d.value);
    }), Ee(() => t.model3d.value ? t.model3d.value.id : null, () => w(t.model3d.value)), Ee(() => s.three.backdrop, (k) => {
      h && h.setBackdrop(k);
    }), We(() => {
      y = !0, S && S.disconnect(), f && f(), h && h.dispose(), h = null;
    });
    function M(k) {
      h && h.fly(k);
    }
    function _() {
      h && h.fly(h.home());
    }
    async function T() {
      if (!h || !l.value || s.three.loading || s.three.error) return null;
      const k = v.value, P = t.captureRatio(), A = P >= 1 ? 1024 : Math.round(1024 * P), R = P >= 1 ? Math.round(1024 / P) : 1024;
      return { blob: await h.capture({ x: k.left, y: k.top, w: k.w, h: k.h }, A, R), w: A, h: R };
    }
    return e({ fly: M, capture: T, home: _ }), (k, P) => (g(), b("div", {
      ref_key: "box",
      ref: o,
      class: G(["sv-model", { "is-clear": m(s).three.backdrop === "clear", "is-night": m(s).three.backdrop === "night" }]),
      "data-testid": "studio-model-view"
    }, [
      u("canvas", {
        ref_key: "canvas",
        ref: r,
        class: "sv-model-canvas",
        onDblclick: _
      }, null, 544),
      l.value && !m(s).three.error ? (g(), b("div", {
        key: 0,
        class: "sv-finder",
        style: ce({ left: v.value.left + "px", top: v.value.top + "px", width: v.value.w + "px", height: v.value.h + "px" }),
        "aria-hidden": "true"
      }, [
        P[1] || (P[1] = u("i", { class: "tl" }, null, -1)),
        P[2] || (P[2] = u("i", { class: "tr" }, null, -1)),
        P[3] || (P[3] = u("i", { class: "bl" }, null, -1)),
        P[4] || (P[4] = u("i", { class: "br" }, null, -1)),
        u("span", Xpe, E(m(s).three.aspect), 1)
      ], 4)) : z("", !0),
      m(s).three.loading || m(s).three.keeping ? (g(), b("div", Jpe, [
        P[5] || (P[5] = u("span", { class: "sv-making" }, null, -1)),
        Y(" " + E(m(s).three.keeping ? "Keeping " + m(s).three.keeping + " in your Library, then opening it" : "Opening the model"), 1)
      ])) : m(s).three.error ? (g(), b("div", Zpe, [
        C($, {
          name: "AlertCircle",
          size: 15
        }),
        Y(" " + E(m(s).three.error), 1)
      ])) : z("", !0),
      u("div", {
        class: "sv-model-tools",
        onPointerdown: P[0] || (P[0] = Te(() => {
        }, ["stop"]))
      }, [
        u("div", Qpe, [
          (g(), b(j, null, ge(c, (A) => u("button", {
            key: A,
            class: G({ on: m(s).three.aspect === A }),
            role: "radio",
            "aria-checked": m(s).three.aspect === A,
            title: "Capture a " + A + " frame",
            "data-testid": "studio-3d-aspect-" + A.replace(":", "x"),
            onClick: (R) => m(s).three.aspect = A
          }, E(A), 11, efe)), 64))
        ]),
        u("div", tfe, [
          (g(), b(j, null, ge(d, (A) => u("button", {
            key: A.id,
            class: G({ on: m(s).three.backdrop === A.id }),
            role: "radio",
            "aria-checked": m(s).three.backdrop === A.id,
            onClick: (R) => m(s).three.backdrop = A.id
          }, E(A.label), 11, nfe)), 64))
        ]),
        u("button", {
          class: "sv-model-btn",
          title: "Back to the framed view (double-click the model)",
          onClick: _
        }, [
          C($, {
            name: "RotateCcw",
            size: 13
          })
        ])
      ], 32)
    ], 2));
  }
}), sfe = ["viewBox"], ofe = ["d"], rfe = {
  key: 0,
  class: "tk"
}, afe = /* @__PURE__ */ Pe({
  __name: "AreaLayer",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = yt(), i = t.s, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(!1), c = /* @__PURE__ */ W(0), h = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ W(null), p = I(() => t.area()), y = I(() => i.bar === "erase"), v = I(() => i.areaCut !== d.value), x = I(() => t.objectsOf(i.stageId)), w = I(() => Math.max(e.w, e.h)), S = I(() => y.value ? [255, 92, 110] : [168, 118, 255]);
    Ee(() => x.value && x.value.status === "ready" ? x.value.url : null, async (L) => {
      if (f.value = null, c.value = 0, !L) return;
      const N = i.stageId;
      try {
        const K = await $f(L);
        h.set(L, K), f.value = K;
      } catch {
        f.value = null, N && t.objectsFailed(N);
      }
    }, { immediate: !0 });
    let M = 0;
    function _() {
      cancelAnimationFrame(M), M = requestAnimationFrame(T);
    }
    async function T() {
      const L = o.value;
      if (!L) return;
      const N = Math.min(2, window.devicePixelRatio || 1), K = Math.max(1, Math.round(e.w * N)), B = Math.max(1, Math.round(e.h * N));
      (L.width !== K || L.height !== B) && (L.width = K, L.height = B);
      const re = l.value ? [...p.value, k(l.value)] : p.value;
      for (const we of DI(re))
        if (!h.has(we))
          try {
            h.set(we, await $f(we));
          } catch {
          }
      const H = L.getContext("2d");
      if (H.clearRect(0, 0, K, B), !re.length) return;
      const J = Dp(re, K, B, h), [Q, ne, ue] = S.value;
      H.save(), H.drawImage(J, 0, 0), H.globalCompositeOperation = "source-in", H.fillStyle = "rgba(" + Q + "," + ne + "," + ue + ",0.4)", H.fillRect(0, 0, K, B), H.restore();
      const Z = document.createElement("canvas");
      Z.width = K, Z.height = B;
      const te = Z.getContext("2d");
      te.filter = "blur(" + 1.6 * N + "px)", te.drawImage(J, 0, 0), te.filter = "none", te.globalCompositeOperation = "destination-out", te.drawImage(J, 0, 0), te.globalCompositeOperation = "source-in", te.fillStyle = "rgba(255,255,255,0.95)", te.fillRect(0, 0, K, B), H.drawImage(Z, 0, 0);
    }
    function k(L) {
      return L.kind === "brush" ? { kind: "brush", pts: L.pts, size: i.areaSize / w.value, cut: L.cut } : { kind: "lasso", pts: L.pts, cut: L.cut };
    }
    Ee([p, () => e.w, () => e.h, y], _, { deep: !0 }), it(_);
    function P() {
      const L = r.value;
      if (!L) return;
      const N = Math.min(2, window.devicePixelRatio || 1);
      L.width = Math.max(1, Math.round(e.w * N)), L.height = Math.max(1, Math.round(e.h * N));
      const K = L.getContext("2d");
      if (K.clearRect(0, 0, L.width, L.height), !f.value || !c.value) return;
      const B = $I(f.value, c.value), re = L.width, H = L.height;
      K.drawImage(B, 0, 0, re, H), K.globalCompositeOperation = "source-in", K.fillStyle = v.value ? "rgba(255, 92, 110, 0.3)" : "rgba(190, 150, 255, 0.34)", K.fillRect(0, 0, re, H);
      const J = document.createElement("canvas");
      J.width = re, J.height = H;
      const Q = J.getContext("2d");
      Q.filter = "blur(2px)", Q.drawImage(B, 0, 0, re, H), Q.filter = "none", Q.globalCompositeOperation = "destination-out", Q.drawImage(B, 0, 0, re, H), Q.globalCompositeOperation = "source-in", Q.fillStyle = "#fff", Q.fillRect(0, 0, re, H), K.globalCompositeOperation = "source-over", K.drawImage(J, 0, 0);
    }
    Ee(c, P);
    function A(L) {
      const N = s.value.getBoundingClientRect();
      return { x: (L.clientX - N.left) * (e.w / (N.width || e.w)), y: (L.clientY - N.top) * (e.h / (N.height || e.h)) };
    }
    function R(L) {
      return { x: Math.min(1, Math.max(0, L.x / e.w)), y: Math.min(1, Math.max(0, L.y / e.h)) };
    }
    function D(L) {
      if (L.button !== 0 || !s.value) return;
      const N = document.activeElement;
      N && /^(INPUT|TEXTAREA|BUTTON|SELECT)$/.test(N.tagName) && N.blur(), d.value = L.altKey;
      const K = R(A(L));
      if (i.areaTool === "object") {
        if (!f.value) return;
        const B = j_(f.value, K.x, K.y);
        B && t.addAreaOp({ kind: "object", map: f.value.url, segment: B, cut: v.value });
        return;
      }
      L.preventDefault(), s.value.setPointerCapture(L.pointerId), l.value = { kind: i.areaTool === "lasso" ? "lasso" : "brush", pts: [K], cut: v.value }, _();
    }
    function O(L) {
      const N = A(L);
      if (d.value = L.altKey, i.areaTool === "brush" && (a.value = N), i.areaTool === "object" && f.value) {
        const H = R(N), J = j_(f.value, H.x, H.y);
        J !== c.value && (c.value = J);
      }
      const K = l.value;
      if (!K || !s.value || !s.value.hasPointerCapture(L.pointerId)) return;
      const B = R(N), re = K.pts[K.pts.length - 1];
      Math.hypot((B.x - re.x) * e.w, (B.y - re.y) * e.h) < (K.kind === "brush" ? 2 : 3) || (K.pts = [...K.pts, B], _());
    }
    function F(L) {
      s.value && s.value.hasPointerCapture(L.pointerId) && s.value.releasePointerCapture(L.pointerId);
      const N = l.value;
      if (l.value = null, !!N) {
        if (N.kind === "lasso" && N.pts.length < 3) {
          _();
          return;
        }
        t.addAreaOp(k(N));
      }
    }
    function ie() {
      a.value = null, c.value = 0;
    }
    function ee(L) {
      d.value = L.altKey;
    }
    it(() => {
      window.addEventListener("keydown", ee), window.addEventListener("keyup", ee);
    }), We(() => {
      cancelAnimationFrame(M), window.removeEventListener("keydown", ee), window.removeEventListener("keyup", ee);
    });
    const me = I(() => {
      const L = l.value;
      return !L || L.kind !== "lasso" ? "" : L.pts.map((N, K) => (K ? "L" : "M") + (N.x * e.w).toFixed(1) + " " + (N.y * e.h).toFixed(1)).join(" ");
    });
    return (L, N) => (g(), b("div", {
      ref_key: "layer",
      ref: s,
      class: G(["sv-layer ed-area-layer", ["tool-" + m(i).areaTool, { "is-cut": v.value, "is-erase": y.value, "is-picking": m(i).areaTool === "object" && !!f.value, "is-over": !!c.value }]]),
      "data-testid": "studio-area-layer",
      onPointerdown: D,
      onPointermove: O,
      onPointerup: F,
      onPointercancel: F,
      onPointerleave: ie
    }, [
      u("canvas", {
        ref_key: "paint",
        ref: o,
        class: "ed-area-paint",
        style: ce({ width: n.w + "px", height: n.h + "px" })
      }, null, 4),
      m(i).areaTool === "object" ? (g(), b("canvas", {
        key: 0,
        ref_key: "hoverCanvas",
        ref: r,
        class: "ed-area-hover",
        style: ce({ width: n.w + "px", height: n.h + "px" })
      }, null, 4)) : z("", !0),
      me.value ? (g(), b("svg", {
        key: 1,
        class: "ed-area-lasso",
        viewBox: "0 0 " + n.w + " " + n.h,
        style: ce({ width: n.w + "px", height: n.h + "px" })
      }, [
        u("path", { d: me.value }, null, 8, ofe)
      ], 12, sfe)) : z("", !0),
      a.value && m(i).areaTool === "brush" ? (g(), b("span", {
        key: 2,
        class: G(["sv-ring ed-area-ring", { "is-eraser": v.value }]),
        style: ce({ left: a.value.x + "px", top: a.value.y + "px", width: Math.max(4, m(i).areaSize) + "px", height: Math.max(4, m(i).areaSize) + "px" })
      }, null, 6)) : z("", !0),
      C(vt, { name: "ed-fade" }, {
        default: Xe(() => [
          m(i).areaTool === "object" && (!x.value || x.value.status !== "ready" || !f.value) ? (g(), b("div", {
            key: 0,
            class: "ed-area-find",
            onPointerdown: N[1] || (N[1] = Te(() => {
            }, ["stop"]))
          }, [
            x.value && x.value.status === "finding" ? (g(), b(j, { key: 0 }, [
              C($, {
                name: "Loader2",
                size: 13,
                spin: ""
              }),
              N[2] || (N[2] = Y(" Finding the objects in this picture", -1))
            ], 64)) : x.value && x.value.status === "ready" ? (g(), b(j, { key: 1 }, [
              C($, {
                name: "Loader2",
                size: 13,
                spin: ""
              }),
              N[3] || (N[3] = Y(" Reading the objects", -1))
            ], 64)) : (g(), b("button", {
              key: 2,
              class: "ed-area-find-btn",
              "data-testid": "studio-find-objects",
              onClick: N[0] || (N[0] = (K) => m(t).findObjects())
            }, [
              C($, {
                name: "MousePointerClick",
                size: 13
              }),
              Y(" " + E(x.value && x.value.status === "failed" ? "The objects couldn't be found. Try again" : "Find the objects in this picture") + " ", 1),
              m(t).modelOf("select") ? (g(), b("span", rfe, [
                C($, {
                  name: "Tokens",
                  size: 10
                }),
                Y(" " + E(m(t).priceOf("select")), 1)
              ])) : z("", !0)
            ]))
          ], 32)) : z("", !0)
        ]),
        _: 1
      })
    ], 34));
  }
}), lfe = ["data-handle", "onPointerdown"], dfe = { class: "ed-crop-size" }, cfe = /* @__PURE__ */ Pe({
  __name: "CropOverlay",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = yt(), i = t.tools, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(!1), r = I(() => i.t.resize.crop), a = I(() => ({ left: r.value.x * e.w, top: r.value.y * e.h, width: r.value.w * e.w, height: r.value.h * e.h })), l = I(() => {
      const y = t.stage.value;
      return y ? E0(r.value, y.w, y.h) : { w: 0, h: 0 };
    }), d = ["nw", "n", "ne", "e", "se", "s", "sw", "w"];
    let c = null;
    function h(y, v) {
      if (v.button !== 0 || !s.value) return;
      v.preventDefault(), v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
      const x = t.stage.value, w = x ? Mc(i.t.resize.ratio, x.w, x.h) : null;
      c = { kind: y, x0: v.clientX, y0: v.clientY, start: { ...r.value }, ratio: w }, o.value = !0;
    }
    function f(y) {
      var v;
      if (!c) return;
      const x = t.stage.value;
      if (!x) return;
      const w = (y.clientX - c.x0) / e.w, S = (y.clientY - c.y0) / e.h;
      if (c.kind === "move") {
        i.setCrop(whe(c.start, w, S));
        return;
      }
      const M = (v = c.ratio) != null ? v : y.shiftKey ? c.start.w * x.w / (c.start.h * x.h) : null;
      i.setCrop(khe(c.start, c.kind, w, S, x.w, x.h, M, 16));
    }
    function p(y) {
      const v = y.currentTarget;
      v.hasPointerCapture(y.pointerId) && v.releasePointerCapture(y.pointerId), c = null, o.value = !1;
    }
    return (y, v) => (g(), b("div", {
      ref_key: "layer",
      ref: s,
      class: G(["sv-layer ed-crop", { "is-active": o.value }]),
      "data-testid": "studio-crop-frame"
    }, [
      u("i", {
        class: "shade",
        style: ce({ left: 0, top: 0, width: n.w + "px", height: a.value.top + "px" })
      }, null, 4),
      u("i", {
        class: "shade",
        style: ce({ left: 0, top: a.value.top + a.value.height + "px", width: n.w + "px", height: Math.max(0, n.h - a.value.top - a.value.height) + "px" })
      }, null, 4),
      u("i", {
        class: "shade",
        style: ce({ left: 0, top: a.value.top + "px", width: a.value.left + "px", height: a.value.height + "px" })
      }, null, 4),
      u("i", {
        class: "shade",
        style: ce({ left: a.value.left + a.value.width + "px", top: a.value.top + "px", width: Math.max(0, n.w - a.value.left - a.value.width) + "px", height: a.value.height + "px" })
      }, null, 4),
      u("div", {
        class: "ed-crop-box",
        style: ce({ left: a.value.left + "px", top: a.value.top + "px", width: a.value.width + "px", height: a.value.height + "px" }),
        onPointerdown: v[0] || (v[0] = (x) => h("move", x)),
        onPointermove: f,
        onPointerup: p,
        onPointercancel: p
      }, [
        v[1] || (v[1] = u("i", { class: "third v1" }, null, -1)),
        v[2] || (v[2] = u("i", { class: "third v2" }, null, -1)),
        v[3] || (v[3] = u("i", { class: "third h1" }, null, -1)),
        v[4] || (v[4] = u("i", { class: "third h2" }, null, -1)),
        (g(), b(j, null, ge(d, (x) => u("span", {
          key: x,
          class: G(["ed-crop-h", "h-" + x]),
          "data-handle": x,
          onPointerdown: (w) => h(x, w),
          onPointermove: f,
          onPointerup: p,
          onPointercancel: p
        }, null, 42, lfe)), 64)),
        u("span", dfe, E(l.value.w) + " × " + E(l.value.h), 1)
      ], 36)
    ], 2));
  }
}), ufe = ["src"], hfe = ["data-handle", "onPointerdown"], pfe = { class: "ed-crop-size" }, f4 = 32, ffe = /* @__PURE__ */ Pe({
  __name: "ExpandStage",
  props: {
    room: {}
  },
  setup(n) {
    const e = n, t = yt(), i = t.tools, s = I(() => t.stage.value), o = I(() => i.frame()), r = /* @__PURE__ */ W(!1), a = I(() => {
      const p = o.value;
      if (!p) return null;
      const y = Math.max(80, e.room.w - f4 * 2), v = Math.max(80, e.room.h - f4 * 2), x = Math.min(y / p.cw, v / p.ch), w = Math.round(p.cw * x), S = Math.round(p.ch * x);
      return { k: x, w, h: S, left: Math.round((e.room.w - w) / 2), top: Math.round((e.room.h - S) / 2) };
    }), l = I(() => {
      const p = o.value, y = a.value;
      return !p || !y ? null : { left: p.ix * y.k, top: p.iy * y.k, width: p.iw * y.k, height: p.ih * y.k };
    });
    let d = null;
    function c(p, y) {
      y.button !== 0 || !o.value || !a.value || (y.preventDefault(), y.stopPropagation(), y.currentTarget.setPointerCapture(y.pointerId), d = { kind: p, x0: y.clientX, y0: y.clientY, start: { ...o.value }, k: a.value.k }, r.value = !0);
    }
    function h(p) {
      if (!d) return;
      const y = (p.clientX - d.x0) / d.k, v = (p.clientY - d.y0) / d.k;
      if (d.kind === "pic") {
        i.setFrame(Ahe(d.start, y, v));
        return;
      }
      const x = d.kind === "e" ? y : d.kind === "w" ? -y : d.kind === "s" ? v : -v;
      let w = Ihe(d.start, d.kind, Math.round(x));
      d.kind === "e" && (w = { ...w, cw: Math.max(w.cw, w.ix + w.iw * 0.5) }), d.kind === "s" && (w = { ...w, ch: Math.max(w.ch, w.iy + w.ih * 0.5) }), i.t.resize.frameRatio = "free", i.setFrame(w);
    }
    function f(p) {
      const y = p.currentTarget;
      y.hasPointerCapture(p.pointerId) && y.releasePointerCapture(p.pointerId), d = null, r.value = !1;
    }
    return (p, y) => s.value && a.value && l.value && o.value ? (g(), b("div", {
      key: 0,
      class: G(["ed-expand", { "is-active": r.value }]),
      style: ce({ left: a.value.left + "px", top: a.value.top + "px", width: a.value.w + "px", height: a.value.h + "px" }),
      "data-testid": "studio-expand-frame"
    }, [
      y[2] || (y[2] = u("div", { class: "ed-expand-room" }, null, -1)),
      u("div", {
        class: "ed-expand-pic",
        style: ce({ left: l.value.left + "px", top: l.value.top + "px", width: l.value.width + "px", height: l.value.height + "px" }),
        onPointerdown: y[0] || (y[0] = (v) => c("pic", v)),
        onPointermove: h,
        onPointerup: f,
        onPointercancel: f
      }, [
        u("img", {
          src: s.value.url,
          alt: "",
          draggable: "false"
        }, null, 8, ufe)
      ], 36),
      (g(), b(j, null, ge(["n", "s", "e", "w"], (v) => u("span", {
        key: v,
        class: G(["ed-expand-h", "h-" + v]),
        "data-handle": v,
        onPointerdown: (x) => c(v, x),
        onPointermove: h,
        onPointerup: f,
        onPointercancel: f
      }, [...y[1] || (y[1] = [
        u("i", null, null, -1)
      ])], 42, hfe)), 64)),
      u("span", pfe, E(Math.round(o.value.cw)) + " × " + E(Math.round(o.value.ch)), 1)
    ], 6)) : z("", !0);
  }
}), mfe = {
  key: 0,
  class: "ed-stage-note"
}, gfe = /* @__PURE__ */ Pe({
  __name: "AdjustCanvas",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, i = yt().tools, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(!1);
    let a = null, l = "", d = { w: 1, h: 1 }, c = null, h = 0;
    const f = I(() => i.adjustSource());
    async function p() {
      const v = f.value;
      if (!(!v || !a) && v.url !== l) {
        l = v.url, o.value = !1;
        try {
          const x = await si(v.url);
          if (!a || l !== v.url) return;
          a.setImage(x, x.width, x.height), d = { w: x.width, h: x.height }, o.value = !0, y();
        } catch (x) {
          console.warn("[board] Adjust couldn't read the picture", x), r.value = !0;
        }
      }
    }
    function y() {
      cancelAnimationFrame(h), h = requestAnimationFrame(() => {
        if (!a || !o.value) return;
        const v = i.t.adjust.a, x = Math.min(2, window.devicePixelRatio || 1), w = su(v, e.w, e.h), S = Math.max(1, Math.round(w.w * x)), M = Math.max(1, Math.round(w.h * x)), _ = su(v, d.w, d.h);
        a.render(v, S, M, { transfer: c, original: i.t.adjust.original, grainScale: S / Math.max(1, _.w) });
      });
    }
    return it(() => {
      if (s.value) {
        try {
          a = new FI(s.value);
        } catch (v) {
          console.warn("[board] Adjust has no WebGL 2 here", v), r.value = !0;
          return;
        }
        p();
      }
    }), We(() => {
      cancelAnimationFrame(h), a && a.dispose(), a = null;
    }), Ee(f, () => {
      p();
    }), Ee(() => [i.t.adjust.a, i.t.adjust.original, e.w, e.h], y, { deep: !0 }), Ee(() => [i.t.adjust.a.match.to, i.t.adjust.a.match.stats, f.value && f.value.url], async () => {
      c = await i.transfer(), y();
    }, { immediate: !0 }), (v, x) => (g(), b(j, null, [
      u("canvas", {
        ref_key: "el",
        ref: s,
        class: G(["ed-adjust-canvas", { "is-ready": o.value }]),
        style: ce({ width: n.w + "px", height: n.h + "px" }),
        "data-testid": "studio-adjust-preview"
      }, null, 6),
      r.value ? (g(), b("span", mfe, "This picture can't be adjusted live here")) : z("", !0)
    ], 64));
  }
}), bfe = /* @__PURE__ */ Pe({
  __name: "LayersPreview",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = n, t = yt(), i = t.tools, s = /* @__PURE__ */ W(null);
    let o = 0;
    const r = I(() => i.t.background), a = I(() => t.stage.value), l = I(() => i.cutoutFor(a.value)), d = I(() => {
      const p = a.value, y = l.value;
      return !p || !y ? null : y === p ? t.items.value.find((v) => v.id === p.parentId) || null : p;
    }), c = I(() => r.value.mode === "remove" ? r.value.fill !== void 0 && i.isCutout(a.value) : r.value.mode === "adjust" && !!l.value && !!d.value && nu(r.value.layer));
    async function h() {
      var p;
      const y = s.value;
      if (!y || !c.value) return;
      const v = Math.min(2, window.devicePixelRatio || 1), x = Math.max(1, Math.round(e.w * v)), w = Math.max(1, Math.round(e.h * v));
      try {
        let S;
        if (r.value.mode === "remove") {
          const _ = await si(a.value.url), T = Rn(x, w);
          zn(T).drawImage(_, 0, 0, x, w), S = RI(T, (p = r.value.fill) != null ? p : null);
        } else {
          const [_, T] = await Promise.all([si(d.value.url), si(l.value.url)]);
          S = zI(_, T, r.value.layer, x, w);
        }
        y.width = x, y.height = w;
        const M = zn(y);
        M.clearRect(0, 0, x, w), M.drawImage(S, 0, 0);
      } catch (S) {
        console.warn("[board] the background preview couldn't be drawn", S);
      }
    }
    function f() {
      cancelAnimationFrame(o), o = requestAnimationFrame(() => {
        h();
      });
    }
    return it(f), We(() => cancelAnimationFrame(o)), Ee(() => [r.value.fill, r.value.layer, r.value.mode, e.w, e.h, a.value && a.value.url, c.value], f, { deep: !0 }), (p, y) => (g(), Ie(vt, { name: "ed-fade" }, {
      default: Xe(() => [
        _t(u("canvas", {
          ref_key: "el",
          ref: s,
          class: G(["ed-layers-canvas", { "is-clear": r.value.mode === "remove" && r.value.fill === null }]),
          style: ce({ width: n.w + "px", height: n.h + "px" }),
          "data-testid": "studio-background-preview"
        }, null, 6), [
          [xv, c.value]
        ])
      ]),
      _: 1
    }));
  }
}), vfe = ["src"], yfe = { class: "ed-compare-tag is-left" }, xfe = { class: "ed-compare-tag is-right" }, wfe = {
  key: 1,
  class: "ed-compare-tag is-left"
}, kfe = /* @__PURE__ */ Pe({
  __name: "CompareOverlay",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = yt(), t = e.tools, i = I(() => t.t.compare), s = I(() => i.value && e.items.value.find((p) => p.id === i.value.with) || null), o = I(() => s.value ? e.names.value.get(s.value.id) || s.value.label : ""), r = I(() => e.stage.value ? e.names.value.get(e.stage.value.id) || "This" : ""), a = /* @__PURE__ */ W(null);
    let l = !1;
    function d(p) {
      if (!a.value || !t.t.compare) return;
      const y = a.value.getBoundingClientRect();
      t.t.compare.at = Math.min(1, Math.max(0, (p.clientX - y.left) / y.width));
    }
    function c(p) {
      if (!(p.button !== 0 || !i.value)) {
        if (p.stopPropagation(), i.value.mode === "toggle") {
          t.t.compare.other = !0;
          return;
        }
        l = !0, p.currentTarget.setPointerCapture(p.pointerId), d(p);
      }
    }
    function h(p) {
      l && d(p);
    }
    function f() {
      l = !1, t.t.compare && (t.t.compare.other = !1);
    }
    return (p, y) => i.value && s.value ? (g(), b("div", {
      key: 0,
      ref_key: "layer",
      ref: a,
      class: G(["sv-layer ed-compare", "is-" + i.value.mode]),
      "data-testid": "studio-compare-view",
      onPointerdown: c,
      onPointermove: h,
      onPointerup: f,
      onPointercancel: f,
      onPointerleave: f
    }, [
      u("div", {
        class: "ed-compare-other",
        style: ce(i.value.mode === "split" ? { clipPath: "inset(0 " + (100 - i.value.at * 100) + "% 0 0)" } : { opacity: i.value.other ? 1 : 0 })
      }, [
        u("img", {
          src: s.value.url,
          alt: "",
          draggable: "false"
        }, null, 8, vfe)
      ], 4),
      i.value.mode === "split" ? (g(), b(j, { key: 0 }, [
        u("i", {
          class: "ed-compare-line",
          style: ce({ left: i.value.at * 100 + "%" })
        }, [
          u("span", null, [
            C($, {
              name: "ChevronLeft",
              size: 12
            }),
            C($, {
              name: "ChevronRight",
              size: 12
            })
          ])
        ], 4),
        u("span", yfe, E(o.value), 1),
        u("span", xfe, E(r.value), 1)
      ], 64)) : (g(), b("span", wfe, E(i.value.other ? o.value : r.value) + " · press and hold to see " + E(i.value.other ? r.value : o.value), 1))
    ], 34)) : z("", !0);
  }
}), _fe = {
  key: 0,
  class: "ed-cam-stage",
  "data-testid": "studio-camera-preview"
}, Sfe = { class: "ed-cam-view" }, Mfe = ["src"], Tfe = { class: "ed-cam-hud" }, Cfe = /* @__PURE__ */ Pe({
  __name: "CameraPreview",
  props: {
    room: {}
  },
  setup(n) {
    const e = n, t = yt(), i = I(() => t.stage.value), s = I(() => ro(t.tools.t.camera.set)), o = I(() => {
      const d = i.value;
      if (!d) return null;
      const h = Math.min(e.room.w * 0.42, e.room.h * 0.5) / Math.max(d.w, d.h), f = Math.round(d.w * h), p = Math.round(d.h * h);
      return { w: f, h: p, d: Math.round(Math.min(f, p) * 0.55) };
    }), r = I(() => {
      const d = s.value;
      return { transform: "scale(" + (0.8 + d.zoom / 10 * 0.45).toFixed(3) + ") rotateX(" + (-d.vertical * 0.72).toFixed(1) + "deg) rotateY(" + (-Yy(d.rotate)).toFixed(1) + "deg)" };
    }), a = I(() => i.value ? 'url("' + i.value.url + '")' : "none");
    function l(d, c, h, f) {
      const p = o.value;
      return {
        width: d + "px",
        height: c + "px",
        left: (p.w - d) / 2 + "px",
        top: (p.h - c) / 2 + "px",
        transform: h,
        backgroundImage: a.value,
        backgroundPosition: f,
        backgroundSize: p.w + "px " + p.h + "px"
      };
    }
    return (d, c) => i.value && o.value ? (g(), b("div", _fe, [
      u("div", Sfe, [
        u("div", {
          class: "ed-cam-scene",
          style: ce({ ...r.value, top: o.value.h / 2 + "px" })
        }, [
          c[1] || (c[1] = u("div", { class: "ed-cam-floor" }, null, -1)),
          u("div", {
            class: "ed-cam-box",
            style: ce({ width: o.value.w + "px", height: o.value.h + "px", marginLeft: -o.value.w / 2 + "px", marginTop: -o.value.h + "px" })
          }, [
            u("img", {
              class: "ed-cam-face is-front",
              src: i.value.url,
              alt: "",
              draggable: "false",
              style: ce({ transform: "translateZ(" + o.value.d / 2 + "px)" })
            }, null, 12, Mfe),
            u("i", {
              class: "ed-cam-face is-side",
              style: ce(l(o.value.d, o.value.h, "rotateY(90deg) translateZ(" + o.value.w / 2 + "px)", "right center"))
            }, null, 4),
            u("i", {
              class: "ed-cam-face is-side",
              style: ce(l(o.value.d, o.value.h, "rotateY(-90deg) translateZ(" + o.value.w / 2 + "px)", "left center"))
            }, null, 4),
            u("i", {
              class: "ed-cam-face is-side is-top",
              style: ce(l(o.value.w, o.value.d, "rotateX(90deg) translateZ(" + o.value.h / 2 + "px)", "center top"))
            }, null, 4),
            u("i", {
              class: "ed-cam-face is-back",
              style: ce(l(o.value.w, o.value.h, "rotateY(180deg) translateZ(" + o.value.d / 2 + "px)", "center"))
            }, [...c[0] || (c[0] = [
              u("span", null, "Not in the picture: invented", -1)
            ])], 4)
          ], 4)
        ], 4)
      ]),
      u("div", Tfe, [
        u("b", null, E(m(kc)(s.value)), 1),
        u("span", null, "A preview of the move. The model draws the new view" + E(m(iI)(s.value) ? ", inventing what the picture doesn't show" : "") + ".", 1)
      ])
    ])) : z("", !0);
  }
}), Ife = {
  key: 0,
  class: "ed-relight-preview",
  "data-testid": "studio-relight-preview"
}, Afe = /* @__PURE__ */ Pe({
  __name: "RelightPreview",
  props: {
    w: {},
    h: {}
  },
  setup(n) {
    const e = yt(), t = I(() => e.tools.t.relight.rig);
    function i(a) {
      const l = Of(a), d = (a.rotate % 360 + 360) % 360, c = d >= 135 && d <= 225, h = Math.min(0.85, 0.25 + a.intensity * 0.06);
      if (c)
        return "radial-gradient(ellipse 70% 80% at 50% 50%, transparent 55%, " + a.color + " 100%)";
      const f = 50 + l.x * 62, p = 50 + l.y * 62;
      return "radial-gradient(circle at " + f.toFixed(0) + "% " + p.toFixed(0) + "%, " + a.color + " 0%, " + s(a.color, h * 0.55) + " 26%, transparent " + (t.value.softness === "soft" ? 78 : 58) + "%)";
    }
    function s(a, l) {
      const d = /^#?([0-9a-f]{6})$/i.exec(a), c = d ? parseInt(d[1], 16) : 16777215;
      return "rgba(" + (c >> 16 & 255) + "," + (c >> 8 & 255) + "," + (c & 255) + "," + l.toFixed(2) + ")";
    }
    const o = I(() => t.value.lights[0] || null), r = I(() => {
      const a = o.value;
      if (!a) return "";
      const l = Of(a);
      return Math.hypot(l.x, l.y) < 0.25 ? "" : "radial-gradient(circle at " + (50 - l.x * 70).toFixed(0) + "% " + (50 - l.y * 70).toFixed(0) + "%, rgba(4,3,12,0.5), transparent 70%)";
    });
    return (a, l) => t.value.mode === "relight" ? (g(), b("div", Ife, [
      r.value ? (g(), b("i", {
        key: 0,
        class: "shade",
        style: ce({ background: r.value })
      }, null, 4)) : z("", !0),
      (g(!0), b(j, null, ge(t.value.lights, (d) => (g(), b("i", {
        key: d.id,
        class: "wash",
        style: ce({ background: i(d), opacity: Math.min(0.9, 0.3 + d.intensity * 0.05) })
      }, null, 4))), 128)),
      l[0] || (l[0] = u("span", { class: "ed-stage-note" }, "A hint of the light. The model relights the picture.", -1))
    ])) : z("", !0);
  }
}), Pfe = ["aria-label"], Efe = { class: "ed-guard-card" }, Rfe = { class: "ic" }, zfe = { class: "tx" }, $fe = { class: "acts" }, Dfe = /* @__PURE__ */ Pe({
  __name: "GuardAsk",
  setup(n) {
    const e = yt(), t = e.tools, i = I(() => t.t.guard), s = I(() => i.value ? sx(i.value.tool) : null), o = I(() => {
      const l = i.value ? i.value.tool : null;
      return l === "resize" ? t.t.resize.mode === "crop" ? "your crop" : "the expanded frame" : l === "background" ? t.t.background.mode === "adjust" ? "your background adjustments" : "the new background" : l === "adjust" ? "your adjustments" : "your changes";
    }), r = I(() => (i.value ? i.value.tool : null) === "resize" && t.t.resize.mode === "expand" ? "Expand (" + e.priceOf("expand") + ")" : "Apply");
    function a(l) {
      i.value && (l.key === "Escape" ? (l.preventDefault(), l.stopImmediatePropagation(), t.stay()) : l.key === "Enter" && (l.preventDefault(), l.stopImmediatePropagation(), t.answer(!0)));
    }
    return it(() => window.addEventListener("keydown", a, !0)), We(() => window.removeEventListener("keydown", a, !0)), (l, d) => (g(), Ie(vt, { name: "ed-guard" }, {
      default: Xe(() => [
        i.value && s.value ? (g(), b("div", {
          key: 0,
          class: "ed-guard",
          role: "alertdialog",
          "aria-modal": "true",
          "aria-label": "Apply " + o.value + "?",
          "data-testid": "studio-tool-guard",
          onPointerdown: d[2] || (d[2] = Te((c) => m(t).stay(), ["self"]))
        }, [
          u("div", Efe, [
            u("span", Rfe, [
              C($, {
                name: s.value.icon,
                size: 16
              }, null, 8, ["name"])
            ]),
            u("div", zfe, [
              u("b", null, "Apply " + E(o.value) + "?", 1),
              u("span", null, E(s.value.label) + " has a change that isn't a version yet. Apply makes it one; Discard leaves the picture as it was.", 1)
            ]),
            u("div", $fe, [
              u("button", {
                class: "sv-btn",
                "data-testid": "studio-tool-discard",
                onClick: d[0] || (d[0] = (c) => m(t).answer(!1))
              }, "Discard"),
              u("button", {
                class: "sv-btn is-primary",
                "data-testid": "studio-tool-apply",
                onClick: d[1] || (d[1] = (c) => m(t).answer(!0))
              }, E(r.value), 1)
            ])
          ])
        ], 40, Pfe)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), Ofe = ["disabled", "title"], Lfe = ["aria-expanded", "aria-label"], Bfe = ["disabled", "title"], Ffe = {
  key: 0,
  class: "sv-pop sv-zoom-pop",
  role: "menu",
  "aria-label": "Zoom",
  "data-testid": "studio-zoom-menu"
}, Nfe = ["disabled"], Ufe = ["disabled"], Gfe = ["disabled"], jfe = /* @__PURE__ */ Pe({
  __name: "StageZoom",
  props: {
    share: {},
    fitted: { type: Boolean },
    atMin: { type: Boolean },
    atMax: { type: Boolean }
  },
  emits: ["step", "fit", "actual"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(!1), o = /* @__PURE__ */ W(null), r = I(() => Math.round(t.share * 100) + "%"), a = {
      in: wn(["mod", "+"]),
      out: wn(["mod", "-"]),
      actual: wn(["mod", "0"]),
      fit: "D"
    };
    function l(f) {
      s.value = !1, f === "in" ? i("step", 1) : f === "out" ? i("step", -1) : i(f === "actual" ? "actual" : "fit");
    }
    function d(f) {
      o.value && !o.value.contains(f.target) && (s.value = !1);
    }
    function c(f) {
      f.key === "Escape" && (f.stopPropagation(), f.preventDefault(), s.value = !1);
    }
    function h() {
      window.removeEventListener("pointerdown", d, !0), window.removeEventListener("keydown", c, !0);
    }
    return Ee(s, (f) => {
      if (!f) {
        h();
        return;
      }
      window.addEventListener("pointerdown", d, !0), window.addEventListener("keydown", c, !0);
    }), We(h), (f, p) => (g(), b("span", {
      ref_key: "wrap",
      ref: o,
      class: "sv-zoom",
      "data-testid": "studio-zoom",
      onPointerdown: p[7] || (p[7] = Te(() => {
      }, ["stop"]))
    }, [
      u("button", {
        class: "sv-zoom-btn",
        disabled: n.atMin,
        title: "Zoom out (" + a.out + ")",
        "aria-label": "Zoom out",
        "data-testid": "studio-zoom-out",
        onClick: p[0] || (p[0] = (y) => i("step", -1))
      }, [
        C($, {
          name: "Minus",
          size: 12
        })
      ], 8, Ofe),
      u("button", {
        class: G(["sv-zoom-pct", { on: s.value }]),
        "aria-haspopup": "menu",
        "aria-expanded": s.value,
        "aria-label": "Zoom: " + r.value,
        "data-testid": "studio-zoom-pct",
        onClick: p[1] || (p[1] = (y) => s.value = !s.value)
      }, [
        Y(E(r.value), 1),
        C($, {
          name: "ChevronDown",
          size: 11,
          class: "chev"
        })
      ], 10, Lfe),
      u("button", {
        class: "sv-zoom-btn",
        disabled: n.atMax,
        title: "Zoom in (" + a.in + ")",
        "aria-label": "Zoom in",
        "data-testid": "studio-zoom-in",
        onClick: p[2] || (p[2] = (y) => i("step", 1))
      }, [
        C($, {
          name: "Plus",
          size: 12
        })
      ], 8, Bfe),
      s.value ? (g(), b("div", Ffe, [
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: n.atMax,
          "data-testid": "studio-zoom-menu-in",
          onClick: p[3] || (p[3] = (y) => l("in"))
        }, [
          p[8] || (p[8] = u("span", { class: "nm" }, "Zoom in", -1)),
          u("kbd", null, E(a.in), 1)
        ], 8, Nfe),
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: n.atMin,
          "data-testid": "studio-zoom-menu-out",
          onClick: p[4] || (p[4] = (y) => l("out"))
        }, [
          p[9] || (p[9] = u("span", { class: "nm" }, "Zoom out", -1)),
          u("kbd", null, E(a.out), 1)
        ], 8, Ufe),
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          "data-testid": "studio-zoom-menu-actual",
          onClick: p[5] || (p[5] = (y) => l("actual"))
        }, [
          p[10] || (p[10] = u("span", { class: "nm" }, "Zoom to 100%", -1)),
          u("kbd", null, E(a.actual), 1)
        ]),
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: n.fitted,
          "data-testid": "studio-zoom-menu-fit",
          onClick: p[6] || (p[6] = (y) => l("fit"))
        }, [
          p[11] || (p[11] = u("span", { class: "nm" }, "Zoom to fit", -1)),
          u("kbd", null, E(a.fit), 1)
        ], 8, Gfe)
      ])) : z("", !0)
    ], 544));
  }
}), Fh = { k: 1, cx: 0.5, cy: 0.5 }, _r = [0.1, 0.125, 0.25, 1 / 3, 0.5, 2 / 3, 1, 1.5, 2, 3, 4, 6, 8], Hfe = 8, Vfe = 0.25;
function m4(n) {
  return Math.abs(n.k - 1) < 1e-4 && Math.abs(n.cx - 0.5) < 1e-4 && Math.abs(n.cy - 0.5) < 1e-4;
}
function XI(n, e) {
  const t = n.w * e.k, i = n.h * e.k;
  return { left: n.left + n.w / 2 - e.cx * t, top: n.top + n.h / 2 - e.cy * i, w: t, h: i };
}
function Wfe(n, e) {
  const t = Math.max(n.left, e.left), i = Math.max(n.top, e.top), s = Math.min(n.left + n.w, e.left + e.w), o = Math.min(n.top + n.h, e.top + e.h);
  return { left: t, top: i, w: Math.max(0, s - t), h: Math.max(0, o - i) };
}
function g4(n, e, t) {
  const i = (s, o, r, a, l) => {
    if (o <= l) return 0.5;
    const d = (r - a) / o, c = (r + o - a - l) / o;
    return Math.min(c, Math.max(d, s));
  };
  return {
    k: n.k,
    cx: i(n.cx, e.w * n.k, e.left + e.w / 2, t.left, t.w),
    cy: i(n.cy, e.h * n.k, e.top + e.h / 2, t.top, t.h)
  };
}
function qfe(n, e, t, i, s) {
  const o = XI(s, n), r = (t - o.left) / o.w, a = (i - o.top) / o.h;
  return { k: e, cx: (s.left + s.w / 2 - t) / (s.w * e) + r, cy: (s.top + s.h / 2 - i) / (s.h * e) + a };
}
function b4(n, e, t, i) {
  return { k: n.k, cx: n.cx - e / (i.w * n.k), cy: n.cy - t / (i.h * n.k) };
}
function Kfe(n, e, t) {
  return e * n / Math.max(1, t);
}
function U0(n, e, t) {
  return n * Math.max(1, t) / Math.max(1, e);
}
function Yfe(n, e) {
  return { min: Vfe, max: Math.max(1, U0(Hfe, n, e)) };
}
function Xfe(n, e) {
  if (e > 0) {
    const t = _r.find((i) => i > n * 1.01);
    return t == null ? _r[_r.length - 1] : t;
  }
  for (let t = _r.length - 1; t >= 0; t--) if (_r[t] < n * 0.99) return _r[t];
  return _r[0];
}
function Jfe(n) {
  return Math.exp(-Math.max(-60, Math.min(60, n)) / 100);
}
const Zfe = {
  key: 1,
  class: "sv-invite",
  "data-testid": "studio-3d-empty"
}, Qfe = { class: "sv-invite-mark" }, eme = {
  key: 0,
  class: "sv-model-state is-inline",
  "data-testid": "studio-3d-keeping"
}, tme = {
  key: 1,
  class: "sv-invite-acts"
}, nme = ["title"], ime = ["src", "poster"], sme = ["src"], ome = {
  key: 0,
  class: "sv-pic-unsaved is-marks",
  title: "Its annotations go with it when it's sent"
}, rme = {
  key: 3,
  class: "sv-promote is-done",
  "data-testid": "studio-stage-on-board",
  title: "This is the version the board shows"
}, ame = {
  key: 4,
  class: "ed-stage-tools"
}, lme = ["aria-pressed", "title"], dme = {
  key: 0,
  class: "sv-seg is-small is-dark"
}, cme = {
  key: 0,
  class: "ed-baking"
}, ume = {
  key: 5,
  class: "sv-invite is-making"
}, hme = {
  key: 6,
  class: "sv-invite",
  "data-testid": "studio-edit-empty"
}, pme = { class: "sv-invite-mark" }, fme = { class: "sv-invite-acts" }, mme = {
  key: 7,
  class: "sv-edit-video",
  "data-testid": "studio-edit-video"
}, gme = ["src", "poster"], bme = ["src"], vme = { class: "sv-invite-acts" }, yme = {
  key: 8,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, xme = { class: "sv-invite-mark" }, wme = { class: "sub" }, kme = { class: "sv-invite-acts" }, _me = {
  key: 9,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, Sme = { class: "sv-invite-mark" }, Mme = { class: "sv-invite-acts" }, Tme = {
  key: 10,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, Cme = { class: "sv-invite-mark" }, Ime = { class: "sv-invite-acts" }, Ad = 8, Ame = /* @__PURE__ */ Pe({
  __name: "Stage",
  emits: ["upload", "upload-model", "library-model", "upload-video"],
  setup(n, { expose: e, emit: t }) {
    const i = t, s = yt(), { board: o } = Ze(), r = s.s, a = s.tools, l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W({ w: 800, h: 600 }), c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(""), f = /* @__PURE__ */ W(null), p = I(() => s.stage.value), y = I(() => {
      const ze = p.value && s.resultOf(p.value);
      return ze && ze.video && ze.videoSrc || null;
    }), v = I(() => s.side.value === "edit"), x = I(() => v.value ? a.t.open : null), w = I(() => x.value === "resize" && a.t.resize.mode === "expand"), S = I(() => x.value === "adjust"), M = /* @__PURE__ */ W(!1);
    Ee(() => r.stageId, (ze, Re) => {
      x.value === "camera" && ze && Re && ze !== Re && (M.value = !0);
    }), Ee(() => a.t.camera.set, () => {
      M.value = !1;
    }, { deep: !0 }), Ee(x, (ze) => {
      ze !== "camera" && (M.value = !1);
    });
    const _ = I(() => x.value === "camera" && !M.value), T = I(() => {
      const ze = p.value;
      if (!ze) return null;
      if (S.value) {
        const Re = a.adjustSource() || ze;
        return su(a.t.adjust.a, Re.w, Re.h);
      }
      return { w: ze.w, h: ze.h };
    }), k = I(() => {
      const ze = T.value;
      if (!ze) return null;
      const Re = 32, lt = Math.max(80, d.value.w - Re * 2), nn = Math.max(80, d.value.h - Re * 2), Ui = Math.min(lt / ze.w, nn / ze.h), ho = Math.round(ze.w * Ui), po = Math.round(ze.h * Ui);
      return { w: ho, h: po, left: Math.round((d.value.w - ho) / 2), top: Math.round((d.value.h - po) / 2) };
    }), P = /* @__PURE__ */ W({ ...Fh }), A = /* @__PURE__ */ W(null), R = /* @__PURE__ */ W(!1);
    let D = 0;
    const O = I(() => !!p.value && p.value.status === "done" && !!k.value && r.studio !== "threed" && !w.value && !_.value && x.value !== "resize"), F = I(() => ({ left: Ad, top: Ad, w: Math.max(1, d.value.w - Ad * 2), h: Math.max(1, d.value.h - Ad * 2) })), ie = I(() => O.value ? P.value : Fh), ee = I(() => !m4(ie.value)), me = I(() => k.value ? XI(k.value, ie.value) : null), L = I(() => me.value ? ee.value ? Wfe(me.value, F.value) : me.value : null), N = I(() => {
      const ze = T.value, Re = p.value;
      if (!ze) return 1;
      const lt = A.value;
      return lt && Re && Re.w ? lt.w * (ze.w / Re.w) : ze.w;
    }), K = I(() => k.value ? Kfe(ie.value.k, k.value.w, N.value) : 1), B = I(() => k.value ? Yfe(k.value.w, N.value) : { min: 1, max: 1 }), re = I(() => ee.value && !!L.value && L.value.top < Ad + 30), H = I(() => {
      const ze = L.value;
      return ze ? { left: ze.left + "px", top: ze.top + "px", width: ze.w + "px", height: ze.h + "px" } : {};
    }), J = I(() => {
      const ze = me.value, Re = L.value, lt = k.value;
      if (!ee.value || !ze || !Re || !lt) return {};
      const nn = ie.value.k;
      return { left: ze.left - Re.left + "px", top: ze.top - Re.top + "px", width: lt.w + "px", height: lt.h + "px", transform: "scale(" + nn + ")", "--zoom": String(nn) };
    });
    function Q(ze, Re = !1) {
      const lt = k.value;
      lt && (P.value = g4(ze, lt, F.value), R.value = Re, clearTimeout(D), Re && (D = window.setTimeout(() => {
        R.value = !1;
      }, 280)));
    }
    function ne(ze, Re = null, lt = !0) {
      const nn = k.value;
      if (!nn || !O.value) return;
      const Ui = Math.min(B.value.max, Math.max(B.value.min, ze)), ho = Re || { x: F.value.left + F.value.w / 2, y: F.value.top + F.value.h / 2 };
      Q(qfe(P.value, Ui, ho.x, ho.y, nn), lt);
    }
    function ue(ze) {
      const Re = k.value;
      Re && ne(U0(Xfe(K.value, ze), Re.w, N.value));
    }
    function Z() {
      O.value && Q({ ...Fh }, !0);
    }
    function te() {
      const ze = k.value;
      ze && ne(U0(1, ze.w, N.value));
    }
    function we(ze, Re) {
      if (!O.value) return !1;
      const lt = bn(ze);
      if (lt && (ze.key === "=" || ze.key === "+")) ue(1);
      else if (lt && (ze.key === "-" || ze.key === "_")) ue(-1);
      else if (lt && ze.key === "0") te();
      else if (!lt && !Re && !ze.altKey && !ze.shiftKey && ze.key.toLowerCase() === "d") Z();
      else return !1;
      return !0;
    }
    function Fe(ze) {
      const Re = k.value, lt = me.value;
      if (!O.value || !Re || !lt || !l.value) return;
      const nn = l.value.getBoundingClientRect(), Ui = ze.deltaMode === 1 ? 16 : ze.deltaMode === 2 ? nn.height : 1;
      if (ze.ctrlKey || ze.metaKey) {
        ze.preventDefault(), ne(P.value.k * Jfe(ze.deltaY * Ui), { x: ze.clientX - nn.left, y: ze.clientY - nn.top }, !1);
        return;
      }
      lt.w <= F.value.w + 0.5 && lt.h <= F.value.h + 0.5 || (ze.preventDefault(), Q(b4(P.value, -ze.deltaX * Ui, -ze.deltaY * Ui, Re)));
    }
    const Me = /* @__PURE__ */ W(!1), he = /* @__PURE__ */ W(!1);
    let U = null;
    function q(ze) {
      const Re = ze;
      return !!Re && (Re.tagName === "INPUT" || Re.tagName === "TEXTAREA" || Re.isContentEditable);
    }
    function oe(ze) {
      ze.code !== "Space" || q(ze.target) || !O.value || (ze.preventDefault(), Me.value = !0);
    }
    function de(ze) {
      ze.code === "Space" && (Me.value && ze.preventDefault(), Me.value = !1);
    }
    function pe() {
      Me.value = !1;
    }
    function Ce(ze) {
      !O.value || !l.value || !(Me.value && ze.button === 0) && ze.button !== 1 || (ze.preventDefault(), ze.stopPropagation(), l.value.setPointerCapture(ze.pointerId), U = { id: ze.pointerId, x: ze.clientX, y: ze.clientY }, he.value = !0);
    }
    function Be(ze) {
      const Re = k.value;
      !U || U.id !== ze.pointerId || !Re || (Q(b4(P.value, ze.clientX - U.x, ze.clientY - U.y, Re)), U = { id: U.id, x: ze.clientX, y: ze.clientY });
    }
    function be(ze) {
      !U || U.id !== ze.pointerId || (l.value && l.value.hasPointerCapture(ze.pointerId) && l.value.releasePointerCapture(ze.pointerId), U = null, he.value = !1);
    }
    function se(ze) {
      const Re = ze.target;
      p.value && (h.value = p.value.url), Re.naturalWidth && (A.value = { w: Re.naturalWidth, h: Re.naturalHeight });
    }
    function ae(ze) {
      const Re = ze.target;
      p.value && (h.value = p.value.url), Re.videoWidth && (A.value = { w: Re.videoWidth, h: Re.videoHeight });
    }
    let ye = 0;
    Ee(() => p.value && p.value.status === "done" ? T.value : null, (ze) => {
      if (!ze) return;
      const Re = ze.h ? ze.w / ze.h : 0;
      (!ye || !Re || Math.abs(Re - ye) / ye > 0.04) && (P.value = { ...Fh }), ye = Re;
    }, { immediate: !0 }), Ee(() => p.value ? p.value.url : null, () => {
      A.value = null;
    });
    let Oe = 0;
    Ee([k, F, B], () => {
      const ze = k.value;
      if (!ze) return;
      const Re = Oe;
      if (Oe = ze.w, m4(P.value)) return;
      const lt = Re && Re !== ze.w ? P.value.k * (Re / ze.w) : P.value.k, nn = Math.min(B.value.max, Math.max(B.value.min, lt));
      P.value = g4({ ...P.value, k: nn }, ze, F.value);
    });
    const Ve = I(() => v.value && !x.value && r.bar === "annotate"), Ue = I(() => Ve.value && r.tool === "note"), tt = I(() => v.value && !x.value && r.bar !== "annotate"), Ye = I(() => {
      const ze = s.marksOf(p.value);
      return x.value ? { strokes: [], pins: [] } : Ue.value ? { strokes: ze.strokes, pins: [] } : { strokes: ze.strokes, pins: ze.pins };
    }), at = I(() => r.editingText ? [r.editingText] : []), kt = I(() => {
      const ze = p.value;
      if (!ze) return "";
      const Re = s.names.value.get(ze.id), lt = ze.parentId ? s.names.value.get(ze.parentId) : null, nn = Re ? Re + (lt && Re !== "Original" ? " · from " + lt : "") : "";
      return ze.kind === "gen" ? [nn || "Generation", s.batchOf(ze)].filter(Boolean).join(" · ") : ze.how === "tool" ? [nn, ze.made ? ze.made.label : ""].filter(Boolean).join(" · ") || "Version" : "Reference · " + (xl[ze.how || "upload"].text + (ze.how === "board" && s.sessionName(ze) ? " (" + s.sessionName(ze) + ")" : "")) + (nn ? " · " + nn : "");
    }), $e = I(() => s.sessionVideo()), Ne = I(() => s.playableVideo($e.value));
    function V() {
      o.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: ["video"],
        confirmLabel: "Edit this video",
        onPick: (ze) => {
          const Re = ze[0];
          Re && (o.rememberAsset(Re.url, Re.asset), s.setSessionVideo(Re.url, Re.asset));
        }
      });
    }
    const X = I(() => {
      const ze = p.value;
      return !!ze && ze.kind === "gen" && ze.status === "done" && !v.value && !x.value && !y.value && !Me.value;
    });
    function le(ze) {
      if (Le.value) {
        ve(ze);
        return;
      }
      !X.value || he.value || ze.defaultPrevented || p.value && s.openInfo(p.value.id);
    }
    const Le = I(() => S.value && !!a.t.adjust.picking);
    function ve(ze) {
      const Re = ze.currentTarget.querySelector(".sv-pic-view");
      if (!Re) return;
      const lt = Re.getBoundingClientRect();
      !lt.width || !lt.height || a.pickColourAt((ze.clientX - lt.left) / lt.width, (ze.clientY - lt.top) / lt.height);
    }
    const _e = I(() => {
      const ze = p.value;
      return !!ze && ze.status === "done" && !v.value && !y.value && s.limit.value > 0 && r.queue[0] !== ze.id;
    }), De = I(() => s.card.value), Qe = I(() => !!p.value && s.onCard(p.value.id)), ft = I(() => !!De.value && !!p.value && p.value.status === "done" && !Qe.value), Dn = I(() => a.compareDefault()), Zn = I(() => !!a.t.compare);
    function xa() {
      a.t.compare ? a.compare(null) : a.compare(Dn.value);
    }
    Ee(() => r.stageId, () => a.stageChanged());
    let wa = null;
    return it(() => {
      l.value && (wa = new ResizeObserver((ze) => {
        const Re = ze[ze.length - 1].contentRect;
        d.value = { w: Re.width, h: Re.height };
      }), wa.observe(l.value));
    }), it(() => {
      window.addEventListener("keydown", oe), window.addEventListener("keyup", de), window.addEventListener("blur", pe);
    }), We(() => {
      wa && wa.disconnect(), clearTimeout(D), window.removeEventListener("keydown", oe), window.removeEventListener("keyup", de), window.removeEventListener("blur", pe);
    }), e({ model: f, zoomKey: we }), (ze, Re) => (g(), b("div", {
      ref_key: "area",
      ref: l,
      class: G(["sv-stage", { "is-threed": m(r).studio === "threed", ["tool-" + x.value]: !!x.value, "is-space": Me.value && O.value, "is-panning": he.value }]),
      "data-testid": "studio-stage",
      onWheel: Fe,
      onPointerdownCapture: Ce,
      onPointermove: Be,
      onPointerup: be,
      onPointercancel: be
    }, [
      m(r).studio === "threed" && m(s).model3d.value ? (g(), Ie(ife, {
        key: 0,
        ref_key: "model",
        ref: f
      }, null, 512)) : m(r).studio === "threed" ? (g(), b("div", Zfe, [
        u("span", Qfe, [
          C($, {
            name: "Box",
            size: 20
          })
        ]),
        Re[18] || (Re[18] = u("b", null, "Start from a 3D model", -1)),
        Re[19] || (Re[19] = u("span", { class: "sub" }, "Bring in a .glb, .gltf, .obj or .stl, find the view you want, and generate from it. Models you bring in stay with the session, and so do the views you save.", -1)),
        m(r).three.keeping ? (g(), b("div", eme, [
          Re[14] || (Re[14] = u("span", { class: "sv-making" }, null, -1)),
          Y(" Keeping " + E(m(r).three.keeping) + " in your Library, then opening it", 1)
        ])) : (g(), b("div", tme, [
          u("button", {
            class: "sv-btn is-primary",
            "data-testid": "studio-3d-upload",
            onClick: Re[0] || (Re[0] = (lt) => i("upload-model"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Re[15] || (Re[15] = Y(" From your computer", -1))
          ]),
          m(o).hasLibrary ? (g(), b("button", {
            key: 0,
            class: "sv-btn",
            "data-testid": "studio-3d-library",
            onClick: Re[1] || (Re[1] = (lt) => i("library-model"))
          }, [
            C($, {
              name: "Library",
              size: 14
            }),
            Re[16] || (Re[16] = Y(" From your Library", -1))
          ])) : z("", !0),
          u("button", {
            class: "sv-btn",
            "data-testid": "studio-3d-sample",
            onClick: Re[2] || (Re[2] = (lt) => m(s).addSample())
          }, [
            C($, {
              name: "Building2",
              size: 14
            }),
            Re[17] || (Re[17] = Y(" Try the sample", -1))
          ])
        ]))
      ])) : p.value && w.value ? (g(), Ie(ffe, {
        key: 2,
        room: d.value
      }, null, 8, ["room"])) : p.value && _.value ? (g(), Ie(Cfe, {
        key: 3,
        room: d.value
      }, null, 8, ["room"])) : p.value && k.value && L.value ? (g(), b("div", {
        key: 4,
        class: G(["sv-pic", { "is-loading": p.value.status === "pending" || h.value !== p.value.url, "is-editing": v.value && !x.value, "is-failed": p.value.status === "failed", "is-tool": !!x.value, "is-cutout": m(s).tools.isCutout(p.value), "is-viewed": ee.value, "is-tag-inside": re.value, "is-gliding": R.value }]),
        style: ce(H.value)
      }, [
        u("div", {
          class: G(["sv-pic-clip", { "is-openable": X.value && !Le.value, "is-picking": Le.value }]),
          title: Le.value ? "Click the colour to work on" : X.value ? "Open it large, with its details" : void 0,
          "data-testid": "studio-pic",
          onClick: le
        }, [
          u("div", {
            class: "sv-pic-view",
            style: ce(J.value),
            "data-testid": "studio-pic-view"
          }, [
            y.value ? (g(), b("video", {
              key: y.value,
              src: y.value,
              poster: p.value.url || void 0,
              controls: "",
              loop: "",
              playsinline: "",
              preload: "metadata",
              "data-testid": "studio-stage-video",
              onLoadedmetadata: ae
            }, null, 40, ime)) : p.value.url ? (g(), b("img", {
              key: p.value.url,
              src: p.value.url,
              alt: "",
              draggable: "false",
              onLoad: se
            }, null, 40, sme)) : z("", !0),
            S.value ? (g(), Ie(gfe, {
              key: 2,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            x.value === "background" ? (g(), Ie(bfe, {
              key: 3,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            x.value === "relight" ? (g(), Ie(Afe, {
              key: 4,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            C(xm, {
              marks: Ye.value,
              w: p.value.w,
              h: p.value.h,
              live: c.value,
              hide: at.value,
              fit: "none"
            }, null, 8, ["marks", "w", "h", "live", "hide"]),
            tt.value && !Zn.value ? (g(), Ie(afe, {
              key: 5,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : Ve.value && !Ue.value && !Zn.value ? (g(), Ie(Lpe, {
              key: 6,
              w: k.value.w,
              h: k.value.h,
              onLive: Re[3] || (Re[3] = (lt) => c.value = lt)
            }, null, 8, ["w", "h"])) : Ue.value && !Zn.value ? (g(), Ie(jpe, {
              key: 7,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            x.value === "resize" && !Zn.value ? (g(), Ie(cfe, {
              key: 8,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            Zn.value ? (g(), Ie(kfe, {
              key: 9,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0)
          ], 4)
        ], 10, nme),
        u("span", {
          class: G(["sv-pic-tag", { "is-ref": p.value.kind === "ref" && p.value.how !== "tool" }])
        }, E(kt.value), 3),
        !v.value && m(s).marked(p.value.id) ? (g(), b("span", ome, [
          C($, {
            name: "Pencil",
            size: 11
          }),
          Re[20] || (Re[20] = Y(" Annotated", -1))
        ])) : z("", !0),
        _e.value ? (g(), b("button", {
          key: 1,
          class: "sv-continue",
          "data-testid": "studio-stage-continue",
          title: "Make this image 1: the next run starts from it",
          onClick: Re[4] || (Re[4] = (lt) => m(s).continueFrom(p.value.id))
        }, [
          C($, {
            name: "CornerDownLeft",
            size: 13
          }),
          Re[21] || (Re[21] = Y(" Start from this image ", -1))
        ])) : z("", !0),
        ft.value ? (g(), b("button", {
          key: 2,
          class: "sv-promote",
          "data-testid": "studio-stage-promote",
          title: "The board shows another version of this picture: use this one there instead",
          onClick: Re[5] || (Re[5] = (lt) => m(s).promote(p.value.id))
        }, [
          C($, {
            name: "Replace",
            size: 13
          }),
          Re[22] || (Re[22] = Y(" Use this version on the board ", -1))
        ])) : De.value && Qe.value ? (g(), b("span", rme, [
          C($, {
            name: "LayoutGrid",
            size: 12
          }),
          Re[23] || (Re[23] = Y(" On the board", -1))
        ])) : z("", !0),
        O.value || v.value && p.value.status === "done" && (Dn.value || Zn.value) ? (g(), b("div", ame, [
          v.value && p.value.status === "done" && (Dn.value || Zn.value) ? (g(), b(j, { key: 0 }, [
            u("button", {
              class: G(["ed-stage-btn", { on: Zn.value }]),
              "aria-pressed": Zn.value,
              title: Zn.value ? "Stop comparing" : "Compare with the version it came from",
              "data-testid": "studio-compare",
              onClick: xa
            }, [
              C($, {
                name: "Columns2",
                size: 13
              }),
              Re[24] || (Re[24] = Y(" Compare ", -1))
            ], 10, lme),
            Zn.value && m(a).t.compare ? (g(), b("span", dme, [
              u("button", {
                class: G({ on: m(a).t.compare.mode === "split" }),
                onClick: Re[6] || (Re[6] = (lt) => m(a).t.compare.mode = "split")
              }, "Split", 2),
              u("button", {
                class: G({ on: m(a).t.compare.mode === "toggle" }),
                onClick: Re[7] || (Re[7] = (lt) => m(a).t.compare.mode = "toggle")
              }, "Toggle", 2)
            ])) : z("", !0)
          ], 64)) : z("", !0),
          O.value ? (g(), Ie(jfe, {
            key: 1,
            share: K.value,
            fitted: !ee.value,
            "at-min": ie.value.k <= B.value.min + 1e-4,
            "at-max": ie.value.k >= B.value.max - 1e-4,
            onStep: ue,
            onFit: Z,
            onActual: te
          }, null, 8, ["share", "fitted", "at-min", "at-max"])) : z("", !0)
        ])) : z("", !0),
        C(vt, { name: "ed-fade" }, {
          default: Xe(() => [
            m(r).baking ? (g(), b("div", cme, [
              C($, {
                name: "Loader2",
                size: 14,
                spin: ""
              }),
              Y(" " + E(m(r).baking), 1)
            ])) : z("", !0)
          ]),
          _: 1
        })
      ], 6)) : m(s).busy() ? (g(), b("div", ume, [
        Re[25] || (Re[25] = u("span", { class: "sv-making" }, null, -1)),
        u("b", null, E(m(s).video.value ? "Making your video" : "Making your image"), 1),
        m(o).runningSince[m(s).sessionId] ? (g(), Ie(j1, {
          key: 0,
          class: "sv-making-time",
          since: m(o).runningSince[m(s).sessionId]
        }, null, 8, ["since"])) : z("", !0)
      ])) : v.value ? (g(), b("div", hme, [
        u("span", pme, [
          C($, {
            name: "Pencil",
            size: 20
          })
        ]),
        Re[27] || (Re[27] = u("b", null, "Pick an image to edit", -1)),
        Re[28] || (Re[28] = u("span", { class: "sub" }, "Choose one from history on the right, or bring in your own.", -1)),
        u("div", fme, [
          u("button", {
            class: "sv-btn",
            onClick: Re[8] || (Re[8] = (lt) => i("upload"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Re[26] || (Re[26] = Y(" Bring in an image", -1))
          ])
        ])
      ])) : m(s).videoField() && $e.value ? (g(), b("div", mme, [
        Re[31] || (Re[31] = u("span", { class: "sv-pic-tag" }, "Video to edit", -1)),
        Ne.value ? (g(), b("video", {
          key: Ne.value,
          src: Ne.value,
          poster: Ne.value === $e.value ? void 0 : $e.value,
          controls: "",
          autoplay: "",
          muted: "",
          loop: "",
          playsinline: ""
        }, null, 8, gme)) : (g(), b("img", {
          key: 1,
          src: $e.value,
          alt: "The video to edit"
        }, null, 8, bme)),
        u("div", vme, [
          m(o).canUploadVideo ? (g(), b("button", {
            key: 0,
            class: "sv-btn",
            onClick: Re[9] || (Re[9] = (lt) => i("upload-video"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Re[29] || (Re[29] = Y(" Another from your computer", -1))
          ])) : z("", !0),
          m(o).hasLibrary ? (g(), b("button", {
            key: 1,
            class: "sv-btn",
            onClick: V
          }, [
            C($, {
              name: "Library",
              size: 14
            }),
            Re[30] || (Re[30] = Y(" From your Library", -1))
          ])) : z("", !0)
        ])
      ])) : m(s).videoField() ? (g(), b("div", yme, [
        u("span", xme, [
          C($, {
            name: "Clapperboard",
            size: 20
          })
        ]),
        Re[34] || (Re[34] = u("b", null, "Choose the video to edit", -1)),
        u("span", wme, E(m(s).modelName("prompt")) + " edits a video: bring one in, then say what to change in the box below. A video on the board can go in from the box's Video slot.", 1),
        u("div", kme, [
          m(o).canUploadVideo ? (g(), b("button", {
            key: 0,
            class: "sv-btn is-primary",
            "data-testid": "studio-video-upload",
            onClick: Re[10] || (Re[10] = (lt) => i("upload-video"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Re[32] || (Re[32] = Y(" From your computer", -1))
          ])) : z("", !0),
          m(o).hasLibrary ? (g(), b("button", {
            key: 1,
            class: "sv-btn",
            "data-testid": "studio-video-library",
            onClick: V
          }, [
            C($, {
              name: "Library",
              size: 14
            }),
            Re[33] || (Re[33] = Y(" From your Library", -1))
          ])) : z("", !0)
        ])
      ])) : m(s).video.value ? (g(), b("div", _me, [
        u("span", Sme, [
          C($, {
            name: "Video",
            size: 20
          })
        ]),
        Re[36] || (Re[36] = u("b", null, "Describe a new video", -1)),
        Re[37] || (Re[37] = u("span", { class: "sub" }, "Write a prompt below. To start the video from a picture, pick one from history or bring in your own.", -1)),
        u("div", Mme, [
          u("button", {
            class: "sv-btn",
            onClick: Re[11] || (Re[11] = (lt) => i("upload"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Re[35] || (Re[35] = Y(" Bring in a picture", -1))
          ])
        ])
      ])) : (g(), b("div", Tme, [
        u("span", Cme, [
          C($, {
            name: "Sparkles",
            size: 20
          })
        ]),
        Re[40] || (Re[40] = u("b", null, "Describe a new image", -1)),
        Re[41] || (Re[41] = u("span", { class: "sub" }, "Write a prompt below. To change an image instead, pick one from history, start from a 3D model, or bring in your own.", -1)),
        u("div", Ime, [
          u("button", {
            class: "sv-btn",
            onClick: Re[12] || (Re[12] = (lt) => m(s).setStudio("threed"))
          }, [
            C($, {
              name: "Box",
              size: 14
            }),
            Re[38] || (Re[38] = Y(" Start from 3D", -1))
          ]),
          u("button", {
            class: "sv-btn",
            onClick: Re[13] || (Re[13] = (lt) => i("upload"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Re[39] || (Re[39] = Y(" Bring in an image", -1))
          ])
        ])
      ])),
      C(Dfe)
    ], 34));
  }
}), Pme = { class: "sv-art" }, Eme = ["src"], Rme = {
  key: 2,
  class: "sv-art-play",
  "aria-hidden": "true"
}, ao = /* @__PURE__ */ Pe({
  __name: "ItemArt",
  props: {
    item: {},
    full: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = yt(), i = I(() => t.marksOf(e.item)), s = I(() => e.item.url.startsWith("data:") || e.item.url.startsWith("blob:") || e.full ? e.item.url : Bt(e.item.url)), o = I(() => {
      const r = t.resultOf(e.item);
      return !!(r && r.video);
    });
    return (r, a) => (g(), b("span", Pme, [
      n.item.url ? (g(), b("img", {
        key: 0,
        src: s.value,
        alt: "",
        draggable: "false",
        loading: "lazy"
      }, null, 8, Eme)) : z("", !0),
      i.value.strokes.length || i.value.pins.length ? (g(), Ie(xm, {
        key: 1,
        marks: i.value,
        w: n.item.w,
        h: n.item.h,
        small: ""
      }, null, 8, ["marks", "w", "h"])) : z("", !0),
      o.value ? (g(), b("span", Rme, [
        C($, {
          name: "Play",
          size: 10
        })
      ])) : z("", !0)
    ]));
  }
}), cx = "application/x-rd-studio-item", Xr = /* @__PURE__ */ W(null);
function zme(n, e, t) {
  n.dataTransfer && (n.dataTransfer.effectAllowed = "copy", n.dataTransfer.setData(cx, e), t && n.dataTransfer.setDragImage(t, t.offsetWidth / 2, t.offsetHeight / 2), Xr.value = e);
}
function Lf() {
  Xr.value = null;
}
function JI(n) {
  return !!n.dataTransfer && Array.from(n.dataTransfer.types).includes(cx);
}
function ZI(n) {
  return n.dataTransfer && n.dataTransfer.getData(cx) || null;
}
const QI = 230, eA = 260, Bo = {
  label: "Add an image",
  addTitle: "Add an image: your pinned pictures, the board's, your Library, or an upload",
  dropper: "Pick from history",
  tip: "Or drag a picture here from history, or from your computer."
}, $me = { class: "sv-queue-slots is-video" }, Dme = ["title"], Ome = ["src", "poster"], Lme = ["src"], Bme = { class: "v" }, Fme = { class: "sv-slot-add-wrap" }, Nme = ["title", "aria-label", "aria-expanded"], Ume = {
  key: 1,
  class: "sv-queue-empty"
}, Gme = {
  key: 0,
  class: "sv-queue-count"
}, jme = {
  key: 1,
  class: "sv-queue-sep"
}, Hme = {
  key: 1,
  class: "sv-queue-label"
}, Vme = {
  key: 2,
  class: "sv-queue-slots"
}, Wme = ["title", "data-testid", "onDragstart", "onDrop", "onClick", "onMouseenter"], qme = { class: "n" }, Kme = {
  key: 0,
  class: "m",
  title: "Its annotations and notes go with it"
}, Yme = ["title", "onClick"], Xme = {
  key: 2,
  class: "sv-slot-add-wrap"
}, Jme = ["title", "aria-expanded"], Zme = {
  key: 3,
  class: "sv-queue-empty"
}, Qme = { class: "n" }, v4 = 6, ege = /* @__PURE__ */ Pe({
  __name: "QueueRow",
  setup(n) {
    const e = yt(), t = e.s, i = /* @__PURE__ */ W(!1), s = I(() => e.queueItems.value), o = I(() => i.value ? s.value : s.value.slice(0, v4)), r = I(() => s.value.length - o.value.length), a = I(() => e.limit.value), l = I(() => e.modelName(e.genMode.value)), d = /* @__PURE__ */ W(null), c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(null);
    function f(ee, me) {
      const L = s.value.find((Q) => Q.id === ee);
      if (!L || !c.value || d.value) return;
      const N = Math.min(QI / L.w, eA / L.h), K = Math.round(L.w * N), B = Math.round(L.h * N), re = me.currentTarget.getBoundingClientRect(), H = c.value.getBoundingClientRect(), J = Math.max(0, Math.min(H.width - K, re.left - H.left + re.width / 2 - K / 2));
      h.value = { id: ee, left: J, w: K, h: B };
    }
    const p = I(() => h.value && s.value.find((ee) => ee.id === h.value.id) || null);
    function y(ee, me) {
      d.value = ee, h.value = null, me.dataTransfer && (me.dataTransfer.effectAllowed = "move", me.dataTransfer.setData("text/plain", ee));
    }
    function v(ee) {
      d.value && e.move(d.value, ee), d.value = null;
    }
    const x = /* @__PURE__ */ W(!1), w = I(() => !!Xr.value && !!a.value);
    function S(ee) {
      !JI(ee) || !a.value || (ee.preventDefault(), ee.dataTransfer && (ee.dataTransfer.dropEffect = "copy"), x.value = !0);
    }
    function M(ee) {
      const me = ee.relatedTarget;
      (!me || !ee.currentTarget.contains(me)) && (x.value = !1);
    }
    function _(ee) {
      const me = ZI(ee);
      x.value = !1, Lf(), !(!me || !a.value) && (ee.preventDefault(), e.queueItem(me));
    }
    const T = /* @__PURE__ */ W(!1);
    async function k(ee) {
      T.value = !1, await e.queueUrl(ee);
    }
    function P() {
      T.value = !1, e.setDropper(!0);
    }
    const A = I(() => e.videoField()), R = I(() => e.sessionVideo()), D = I(() => e.playableVideo(R.value)), O = /* @__PURE__ */ W(!1);
    function F(ee) {
      O.value = !1, e.setSessionVideo(ee);
    }
    function ie(ee) {
      ee.key === "Escape" && (ee.stopPropagation(), ee.preventDefault(), T.value = !1, O.value = !1);
    }
    return Ee(() => T.value || O.value, (ee) => {
      ee ? window.addEventListener("keydown", ie, !0) : window.removeEventListener("keydown", ie, !0);
    }), We(() => window.removeEventListener("keydown", ie, !0)), (ee, me) => (g(), b("div", {
      ref_key: "row",
      ref: c,
      class: G(["sv-queue", { "is-empty": !s.value.length, "no-images": !a.value, "is-over": x.value, "is-air": w.value && !x.value }]),
      "data-testid": "studio-queue",
      onDragover: S,
      onDragleave: M,
      onDrop: _
    }, [
      A.value ? (g(), b(j, { key: 0 }, [
        me[9] || (me[9] = u("span", { class: "sv-queue-label" }, "Video to edit", -1)),
        u("div", $me, [
          R.value ? (g(), b("div", {
            key: 0,
            class: "sv-slot is-video",
            title: "The video " + l.value + " edits",
            "data-testid": "studio-video-slot"
          }, [
            D.value ? (g(), b("video", {
              key: 0,
              src: D.value,
              poster: D.value === R.value ? void 0 : R.value,
              muted: "",
              preload: "metadata",
              playsinline: ""
            }, null, 8, Ome)) : (g(), b("img", {
              key: 1,
              src: R.value,
              alt: ""
            }, null, 8, Lme)),
            u("span", Bme, [
              C($, {
                name: "Video",
                size: 9
              })
            ]),
            u("button", {
              class: "x",
              title: "Take the video out",
              "data-testid": "studio-video-remove",
              onClick: me[0] || (me[0] = Te((L) => m(e).setSessionVideo(null), ["stop"]))
            }, [
              C($, {
                name: "X",
                size: 10
              })
            ])
          ], 8, Dme)) : z("", !0),
          u("div", Fme, [
            u("button", {
              class: "sv-slot-add",
              title: R.value ? "Choose another video" : "Choose the video to edit: from the board, your Library or your computer",
              "aria-label": R.value ? "Choose another video" : "Choose the video to edit",
              "aria-expanded": O.value,
              "data-testid": "studio-video-add",
              onClick: me[1] || (me[1] = (L) => O.value = !O.value)
            }, [
              C($, {
                name: "Video",
                size: 14
              })
            ], 8, Nme),
            O.value ? (g(), Ie(Zc, {
              key: 0,
              "session-id": m(e).sessionId,
              label: "Video",
              kind: "video",
              dropper: !1,
              tip: "Or set it on the session's card, on the board.",
              onPick: F,
              onClose: me[2] || (me[2] = (L) => O.value = !1)
            }, null, 8, ["session-id"])) : z("", !0)
          ]),
          R.value ? z("", !0) : (g(), b("span", Ume, "Choose the video " + E(l.value) + " edits: from the board, your Library or your computer.", 1))
        ]),
        a.value ? z("", !0) : (g(), b("span", Gme, E(R.value ? "1 video" : "No video yet"), 1)),
        a.value ? (g(), b("i", jme)) : z("", !0)
      ], 64)) : z("", !0),
      !A.value || a.value ? (g(), b("span", Hme, E(m(e).video.value ? "Next video starts from" : "Next image uses"), 1)) : z("", !0),
      !A.value || a.value ? (g(), b("div", Vme, [
        (g(!0), b(j, null, ge(o.value, (L, N) => (g(), b("div", {
          key: L.id,
          class: G(["sv-slot", { "is-base": N === 0, "is-unsent": N >= a.value, "is-stage": m(t).stageId === L.id, "is-ref": L.kind === "ref" }]),
          title: (m(e).slotName(N) ? m(e).slotName(N) + ": image " + (N + 1) : N === 0 ? "Image 1: the one it starts from" : "Image " + (N + 1) + ": a reference") + (N >= a.value ? " (not sent: " + l.value + " takes " + a.value + ")" : ""),
          draggable: "true",
          "data-testid": "studio-slot-" + (N + 1),
          onDragstart: (K) => y(L.id, K),
          onDragover: me[3] || (me[3] = Te(() => {
          }, ["prevent"])),
          onDrop: Te((K) => v(N), ["prevent"]),
          onClick: (K) => m(e).show(L.id),
          onMouseenter: (K) => f(L.id, K),
          onMouseleave: me[4] || (me[4] = (K) => h.value = null)
        }, [
          C(ao, { item: L }, null, 8, ["item"]),
          u("span", qme, E(N + 1), 1),
          m(e).marked(L.id) ? (g(), b("span", Kme, [
            C($, {
              name: "Pencil",
              size: 8
            })
          ])) : z("", !0),
          u("button", {
            class: "x",
            title: "Take image " + (N + 1) + " out",
            onClick: Te((K) => m(e).remove(L.id), ["stop"])
          }, [
            C($, {
              name: "X",
              size: 10
            })
          ], 8, Yme)
        ], 42, Wme))), 128)),
        r.value > 0 ? (g(), b("button", {
          key: 0,
          class: "sv-slot-more",
          onClick: me[5] || (me[5] = (L) => i.value = !0)
        }, "+" + E(r.value), 1)) : z("", !0),
        i.value && s.value.length > v4 ? (g(), b("button", {
          key: 1,
          class: "sv-slot-more",
          title: "Fewer",
          onClick: me[6] || (me[6] = (L) => i.value = !1)
        }, [
          C($, {
            name: "ChevronLeft",
            size: 12
          })
        ])) : z("", !0),
        a.value ? (g(), b("div", Xme, [
          u("button", {
            class: G(["sv-slot-add", { "is-dropper": m(t).dropper }]),
            title: m(Bo).addTitle,
            "aria-label": "Add an image",
            "aria-expanded": T.value,
            "data-testid": "studio-queue-add",
            onClick: me[7] || (me[7] = (L) => {
              T.value = !T.value, m(e).setDropper(!1);
            })
          }, [
            C($, {
              name: "ImagePlus",
              size: 16
            })
          ], 10, Jme),
          T.value ? (g(), Ie(Zc, {
            key: 0,
            "session-id": m(e).sessionId,
            label: m(Bo).label,
            "dropper-label": m(Bo).dropper,
            tip: m(Bo).tip,
            onPick: k,
            onDropper: P,
            onClose: me[8] || (me[8] = (L) => T.value = !1)
          }, null, 8, ["session-id", "label", "dropper-label", "tip"])) : z("", !0)
        ])) : z("", !0),
        s.value.length ? z("", !0) : (g(), b("span", Zme, E(a.value ? "Nothing yet: your words alone make a new " + (m(e).video.value ? "video." : "image.") : l.value + " works from words alone; pick another model to send images."), 1))
      ])) : z("", !0),
      h.value && p.value ? (g(), b("div", {
        key: 3,
        class: "sv-slot-peek",
        style: ce({ left: h.value.left + "px", width: h.value.w + "px", height: h.value.h + "px" }),
        "aria-hidden": "true"
      }, [
        C(ao, {
          item: p.value,
          full: ""
        }, null, 8, ["item"]),
        u("span", Qme, E(m(e).slotName(m(e).queued(p.value.id) - 1) || "Image " + m(e).queued(p.value.id)), 1)
      ], 4)) : z("", !0),
      !A.value || a.value ? (g(), b("span", {
        key: 4,
        class: G(["sv-queue-count", { "is-over": s.value.length > a.value }])
      }, [
        a.value ? (g(), b(j, { key: 0 }, [
          Y(E(Math.min(s.value.length, a.value)) + " of " + E(a.value), 1)
        ], 64)) : (g(), b(j, { key: 1 }, [
          Y("No images")
        ], 64))
      ], 2)) : z("", !0)
    ], 34));
  }
}), tge = ["aria-expanded", "disabled", "title"], nge = { class: "lb" }, ige = { class: "nm" }, sge = ["aria-expanded", "disabled"], oge = { class: "nm" }, rge = ["aria-expanded", "disabled", "title"], age = { class: "nm" }, lge = {
  key: 0,
  class: "tk"
}, dge = {
  key: 0,
  class: "sv-pop-tabs",
  role: "tablist",
  "aria-label": "Model groups"
}, cge = ["aria-selected", "data-testid", "onClick"], uge = {
  key: 1,
  class: "sv-pop-search"
}, hge = { class: "sv-pop-rows" }, pge = ["aria-selected", "onClick"], fge = { class: "nm" }, mge = { class: "mt" }, gge = { class: "tk" }, bge = ["title", "aria-label", "aria-pressed", "data-testid", "onClick"], vge = {
  key: 0,
  class: "sv-pop-empty"
}, yge = {
  key: 2,
  class: "sv-pop-foot"
}, xge = {
  key: 3,
  class: "sv-pop-foot"
}, tA = /* @__PURE__ */ Pe({
  __name: "ModelPicker",
  props: {
    mode: {},
    variant: { default: "chip" }
  },
  setup(n) {
    const e = n, t = I(() => e.mode === "edit"), i = yt(), { board: s } = Ze(), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(""), l = /* @__PURE__ */ W(null), d = I(() => i.modelsFor(e.mode)), c = I(() => {
      if (e.mode !== "prompt") return null;
      const P = i.session.value;
      return P && s.catalog.value.kits.find((A) => A.id === P.kitId) || null;
    }), h = I(() => {
      const P = c.value, A = s.catalog.value;
      return P ? A.all.filter((R) => Fc(A, P, R)) : [];
    }), f = I(() => c.value ? hI(T0(c.value), h.value.some((P) => s.isModelPinned(P.id))) : []), p = /* @__PURE__ */ W(null), y = I(() => {
      if (f.value.length && c.value) return s.pinnedModelsFirst(fI(c.value.models, h.value, p.value, a.value, (A) => s.isModelPinned(A)));
      const P = a.value.trim().toLowerCase();
      return s.pinnedModelsFirst(P ? d.value.filter((A) => A.name.toLowerCase().includes(P)) : d.value);
    }), v = I(() => i.modelOf(e.mode)), x = I(() => d.value.length > 7);
    function w(P) {
      const A = zo(P);
      return A ? "up to " + A + (A === 1 ? " image" : " images") : "words only";
    }
    function S(P) {
      return P.tokensLabel || (P.tokensPerResult != null ? String(P.tokensPerResult) : "");
    }
    function M(P) {
      i.setModel(e.mode, P), o.value = !1;
    }
    function _() {
      if (o.value = !o.value, a.value = "", o.value && f.value.length) {
        const P = v.value, A = P && P.kitTags ? f.value.find((R) => P.kitTags.includes(R)) : null;
        p.value = A || T0(c.value)[0] || Mu;
      }
      o.value && x.value && nt(() => l.value && l.value.focus());
    }
    function T(P) {
      r.value && !r.value.contains(P.target) && (o.value = !1);
    }
    Ee(o, (P) => {
      P ? window.addEventListener("pointerdown", T, !0) : window.removeEventListener("pointerdown", T, !0);
    }), We(() => window.removeEventListener("pointerdown", T, !0));
    function k(P) {
      P.key === "Escape" ? (P.stopPropagation(), o.value = !1) : P.key === "Enter" && y.value.length && (P.preventDefault(), M(y.value[0]));
    }
    return (P, A) => (g(), b("div", {
      ref_key: "wrap",
      ref: r,
      class: G(["sv-pop-wrap", { "is-row": n.variant === "row" }]),
      onKeydown: k
    }, [
      n.variant === "flat" ? (g(), b("button", {
        key: 0,
        class: G(["up-model", { on: o.value }]),
        "aria-expanded": o.value,
        disabled: !d.value.length,
        title: v.value && v.value.time ? "About " + v.value.time + " a run" : void 0,
        "data-testid": "studio-model",
        onClick: _
      }, [
        u("span", nge, E(t.value ? "Edit model" : "Model"), 1),
        _t((g(), b("span", ige, [
          Y(E(v.value ? v.value.name : "None available"), 1)
        ])), [
          [m(dl), v.value ? v.value.name : null]
        ]),
        C($, {
          name: "ChevronDown",
          size: 12
        })
      ], 10, tge)) : n.variant === "chip" ? (g(), b("button", {
        key: 1,
        class: G(["sv-chip is-model", { on: o.value }]),
        "aria-expanded": o.value,
        disabled: !d.value.length,
        "data-testid": "studio-model",
        onClick: _
      }, [
        A[2] || (A[2] = u("span", { class: "lb" }, "Model", -1)),
        _t((g(), b("span", oge, [
          Y(E(v.value ? v.value.name : "None available"), 1)
        ])), [
          [m(dl), v.value ? v.value.name : null]
        ]),
        C($, {
          name: "ChevronDown",
          size: 12
        })
      ], 10, sge)) : (g(), b("button", {
        key: 2,
        class: G(["sv-model-row", { on: o.value }]),
        "aria-expanded": o.value,
        disabled: !d.value.length,
        title: v.value ? "Model: " + v.value.name + (v.value.time ? " (about " + v.value.time + " a run)" : "") : "No model takes a picture here",
        "data-testid": "studio-edit-model",
        onClick: _
      }, [
        C($, {
          name: "Cpu",
          size: 14
        }),
        _t((g(), b("span", age, [
          Y(E(v.value ? v.value.name : "None available"), 1)
        ])), [
          [m(dl), v.value ? v.value.name : null]
        ]),
        v.value ? (g(), b("span", lge, [
          C($, {
            name: "Tokens",
            size: 11
          }),
          Y(" " + E(m(i).priceOf(n.mode)), 1)
        ])) : z("", !0),
        C($, {
          class: "chev",
          name: o.value ? "ChevronUp" : "ChevronDown",
          size: 13
        }, null, 8, ["name"])
      ], 10, rge)),
      o.value ? (g(), b("div", {
        key: 3,
        class: G(n.variant === "row" ? "sv-model-list" : "sv-pop"),
        role: "listbox",
        "aria-label": "Models for this studio"
      }, [
        f.value.length ? (g(), b("div", dge, [
          (g(!0), b(j, null, ge(f.value, (R) => (g(), b("button", {
            key: R,
            role: "tab",
            class: G(["sv-pop-tab", { on: p.value === R && !a.value.trim() }]),
            "aria-selected": p.value === R,
            "data-testid": "studio-model-tab-" + R.replace(/[^a-z]/gi, "").toLowerCase(),
            onClick: (D) => {
              p.value = R, a.value = "";
            }
          }, E(m(pI)(R, c.value ? c.value.name : "Models")), 11, cge))), 128))
        ])) : z("", !0),
        x.value || f.value.length ? (g(), b("label", uge, [
          C($, {
            name: "Search",
            size: 12
          }),
          _t(u("input", {
            ref_key: "searchEl",
            ref: l,
            "onUpdate:modelValue": A[0] || (A[0] = (R) => a.value = R),
            placeholder: "Find a model",
            spellcheck: "false",
            "data-testid": "studio-model-search"
          }, null, 512), [
            [Zt, a.value]
          ])
        ])) : z("", !0),
        u("div", hge, [
          (g(!0), b(j, null, ge(y.value, (R) => (g(), b("div", {
            key: R.id,
            class: "sv-pop-item"
          }, [
            u("button", {
              class: G(["sv-pop-row", { on: !!v.value && R.id === v.value.id }]),
              role: "option",
              "aria-selected": !!v.value && R.id === v.value.id,
              onClick: (D) => M(R)
            }, [
              _t((g(), b("span", fge, [
                Y(E(R.name), 1)
              ])), [
                [m(dl), R.name]
              ]),
              u("span", mge, E(w(R)), 1),
              u("span", gge, [
                C($, {
                  name: "Tokens",
                  size: 11
                }),
                Y(" " + E(S(R)), 1)
              ])
            ], 10, pge),
            u("button", {
              class: G(["sv-pop-pin", { on: m(s).isModelPinned(R.id) }]),
              title: m(s).isModelPinned(R.id) ? "Unpin" : "Pin to the top",
              "aria-label": (m(s).isModelPinned(R.id) ? "Unpin " : "Pin ") + R.name,
              "aria-pressed": m(s).isModelPinned(R.id),
              "data-testid": "studio-model-pin-" + R.id,
              onKeydown: A[1] || (A[1] = tn(Te(() => {
              }, ["stop"]), ["enter"])),
              onClick: Te((D) => m(s).toggleModelPinned(R.id), ["stop"])
            }, [
              C($, {
                name: "Pin",
                size: 12
              })
            ], 42, bge)
          ]))), 128)),
          y.value.length ? z("", !0) : (g(), b("div", vge, E(d.value.length ? "No tools found. Try a different search." : "No model here takes a picture"), 1))
        ]),
        n.mode === "prompt" ? (g(), b("p", yge, "Changes the session's model, as its prompt box does.")) : t.value ? (g(), b("p", xge, "Edit keeps a model of its own: the session's Generate model stays as it is.")) : z("", !0)
      ], 2)) : z("", !0)
    ], 34));
  }
}), wge = ["title", "data-testid", "onClick"], kge = {
  key: 0,
  class: "t"
}, _ge = ["aria-label"], Sge = { class: "sv-pop-title" }, Mge = {
  key: 0,
  class: "sv-pop-slider"
}, Tge = ["min", "max", "step", "value", "onInput"], Cge = {
  key: 1,
  class: "sv-pop-rows"
}, Ige = ["onClick"], Age = ["aria-selected", "onClick"], Pge = { class: "nm" }, Ege = {
  key: 1,
  class: "mt"
}, Rge = /* @__PURE__ */ Pe({
  __name: "FieldChips",
  props: {
    mode: {},
    upward: { type: Boolean, default: !0 },
    hide: { default: () => [] },
    pills: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = yt(), i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(null), o = I(() => t.shownChips(e.mode, e.hide));
    function r(x) {
      return t.valueOf(e.mode, x);
    }
    function a(x) {
      const w = r(x);
      return (x.options || []).find((S) => Qi(S.value, w)) || null;
    }
    function l(x) {
      if (x.kind === "boolean") return x.label;
      const w = r(x), S = a(x);
      return x.kind === "size" && S || S ? S.label : w == null || w === "" ? x.label : String(w);
    }
    function d(x) {
      if (x.icon) return x.icon;
      if (x.kind === "size") {
        const w = a(x);
        return w && w.icon || "RectangleHorizontal";
      }
      return x.kind === "boolean" ? r(x) ? "SquareCheck" : "Square" : "Settings2";
    }
    function c(x) {
      if (x.kind === "boolean") {
        t.setInput(e.mode, x.key, !r(x));
        return;
      }
      i.value = i.value === x.key ? null : x.key;
    }
    function h(x, w) {
      t.setInput(e.mode, x.key, w.value), i.value = null;
    }
    function f(x) {
      return t.matchOf(e.mode, x);
    }
    function p(x, w) {
      const S = cc(x, w);
      S != null && t.setInput(e.mode, x.key, S);
    }
    function y(x, w) {
      return w.meta && (x.kind !== "size" || nf(w.value)) ? w.meta : "";
    }
    function v(x) {
      s.value && !s.value.contains(x.target) && (i.value = null);
    }
    return Ee(i, (x) => {
      x ? window.addEventListener("pointerdown", v, !0) : window.removeEventListener("pointerdown", v, !0);
    }), We(() => window.removeEventListener("pointerdown", v, !0)), (x, w) => o.value.length ? (g(), b("div", {
      key: 0,
      ref_key: "wrap",
      ref: s,
      class: G(["sv-fields", { "is-pills": n.pills }]),
      "data-testid": "studio-fields"
    }, [
      (g(!0), b(j, null, ge(o.value, (S) => {
        var M, _, T, k, P, A;
        return g(), b("div", {
          key: S.key,
          class: "sv-pop-wrap"
        }, [
          u("button", {
            class: G([n.pills ? "up-chip" : "sv-chip", { on: i.value === S.key || S.kind === "boolean" && !!r(S) }]),
            title: S.tooltip || S.label,
            "data-testid": "studio-field-" + S.key,
            onClick: (R) => c(S)
          }, [
            C($, {
              name: d(S),
              size: n.pills ? 13 : 12
            }, null, 8, ["name", "size"]),
            n.pills ? (g(), b("span", kge, E(l(S)), 1)) : (g(), b(j, { key: 1 }, [
              Y(E(l(S)), 1)
            ], 64))
          ], 10, wge),
          i.value === S.key ? (g(), b("div", {
            key: 0,
            class: G(["sv-pop is-narrow", { "is-down": !n.upward }]),
            role: "listbox",
            "aria-label": S.label,
            onKeydown: w[0] || (w[0] = tn(Te((R) => i.value = null, ["stop"]), ["esc"]))
          }, [
            u("div", Sge, E(S.label), 1),
            S.kind === "slider" ? (g(), b("label", Mge, [
              u("input", {
                type: "range",
                min: (M = S.min) != null ? M : 0,
                max: (_ = S.max) != null ? _ : 100,
                step: (T = S.step) != null ? T : 1,
                value: Number((P = (k = r(S)) != null ? k : S.defaultValue) != null ? P : 0),
                onInput: (R) => p(S, R.target.value)
              }, null, 40, Tge),
              u("b", null, E((A = r(S)) != null ? A : S.defaultValue), 1)
            ])) : (g(), b("div", Cge, [
              f(S) ? (g(), b(j, { key: 0 }, [
                u("button", {
                  class: "sv-pop-row",
                  role: "option",
                  "aria-selected": !1,
                  "data-testid": "studio-field-match",
                  onClick: (R) => h(S, f(S))
                }, [
                  C($, {
                    name: "Proportions",
                    size: 12
                  }),
                  w[1] || (w[1] = u("span", { class: "nm" }, "Match media input", -1))
                ], 8, Ige),
                w[2] || (w[2] = u("div", {
                  class: "sv-pop-sep",
                  "aria-hidden": "true"
                }, null, -1))
              ], 64)) : z("", !0),
              (g(!0), b(j, null, ge(S.options, (R) => (g(), b("button", {
                key: String(R.label),
                class: G(["sv-pop-row", { on: m(Qi)(R.value, r(S)) }]),
                role: "option",
                "aria-selected": m(Qi)(R.value, r(S)),
                onClick: (D) => h(S, R)
              }, [
                R.icon ? (g(), Ie($, {
                  key: 0,
                  name: R.icon,
                  size: 12
                }, null, 8, ["name"])) : z("", !0),
                u("span", Pge, E(R.label), 1),
                y(S, R) ? (g(), b("span", Ege, E(y(S, R)), 1)) : z("", !0)
              ], 10, Age))), 128))
            ]))
          ], 42, _ge)) : z("", !0)
        ]);
      }), 128))
    ], 2)) : z("", !0);
  }
}), zge = { class: "up-chips" }, $ge = { class: "up-chip-wrap up-model-wrap" }, Dge = ["title"], Oge = { class: "nm" }, Lge = ["title"], Bge = ["title"], Fge = { class: "up-run-wrap" }, Nge = ["disabled", "title", "data-testid"], Uge = {
  key: 2,
  class: "tip",
  "data-testid": "studio-run-tip"
}, nA = /* @__PURE__ */ Pe({
  __name: "PromptFoot",
  props: {
    kind: {},
    own: { default: null },
    resting: { type: Boolean, default: !1 },
    unchecked: { type: Boolean, default: !1 },
    fixed: { type: Boolean, default: !1 },
    fixedTitle: { default: "" },
    most: { default: null },
    hide: { default: () => [] },
    label: { default: null },
    runTestid: { default: "studio-run" },
    countTestid: { default: "studio-count" }
  },
  emits: ["run"],
  setup(n, { expose: e, emit: t }) {
    const i = n, s = t, o = yt(), r = o.s, { board: a } = Ze(), l = /* @__PURE__ */ W(null), d = I(() => o.modelOf(i.kind)), c = I(() => i.unchecked ? { problem: null, tokens: !1 } : o.checkOf(i.kind)), h = I(() => i.resting ? KI : i.own || c.value.problem || (d.value ? null : "No model is available for this")), f = I(() => !i.own && c.value.tokens && a.canGetTokens), p = I(() => d.value ? o.priceOf(i.kind) : ""), y = I(() => o.countOf(i.kind)), v = I(() => i.most != null ? Math.min(i.most, o.maxCount(i.kind)) : o.maxCount(i.kind)), x = I(() => o.shownChips(i.kind, i.hide).length > 0), w = I(() => r.sending > 0), S = I(() => o.video.value || d.value && d.value.fields.some((k) => k.kind === "video") ? r8(d.value, (k) => o.valueOf(i.kind, k)) : "");
    let M = 0;
    function _() {
      const k = l.value ? l.value.closest(".sv-dock") : null;
      k && (k.classList.remove("is-nudge"), k.offsetWidth, k.classList.add("is-nudge"), clearTimeout(M), M = window.setTimeout(() => k.classList.remove("is-nudge"), 1800));
    }
    We(() => clearTimeout(M));
    function T() {
      if (!w.value) {
        if (h.value || f.value) {
          _();
          return;
        }
        s("run");
      }
    }
    return e({ tryRun: T }), (k, P) => (g(), b("div", {
      ref_key: "root",
      ref: l,
      class: "up-foot sv-pfoot",
      "data-testid": "studio-foot"
    }, [
      u("div", zge, [
        u("span", $ge, [
          n.fixed ? (g(), b("span", {
            key: 0,
            class: "up-model is-fixed",
            title: n.fixedTitle || void 0,
            "data-testid": "studio-model-fixed"
          }, [
            P[2] || (P[2] = u("span", { class: "lb" }, "Model", -1)),
            u("span", Oge, E(d.value ? d.value.name : "None"), 1)
          ], 8, Dge)) : (g(), Ie(tA, {
            key: 1,
            mode: n.kind,
            variant: "flat"
          }, null, 8, ["mode"])),
          p.value ? (g(), b("span", {
            key: 2,
            class: "up-cost",
            title: "Token cost for this run" + (d.value && d.value.time ? ", about " + d.value.time : ""),
            "data-testid": "studio-cost"
          }, [
            C($, {
              name: "Tokens",
              size: 12
            }),
            Y(E(p.value), 1)
          ], 8, Lge)) : z("", !0)
        ]),
        x.value ? (g(), b(j, { key: 0 }, [
          P[3] || (P[3] = u("span", { class: "up-foot-sep" }, null, -1)),
          C(Rge, {
            mode: n.kind,
            hide: n.hide,
            pills: ""
          }, null, 8, ["mode", "hide"])
        ], 64)) : z("", !0),
        Ss(k.$slots, "chips")
      ]),
      Ss(k.$slots, "aside"),
      S.value ? (g(), b("span", {
        key: 0,
        class: "sv-out-line",
        "data-testid": "studio-output-line",
        title: S.value + ": from this tool's settings"
      }, E(S.value), 9, Bge)) : z("", !0),
      v.value > 1 ? (g(), Ie(ex, {
        key: 1,
        value: y.value,
        min: m(o).minCount(n.kind),
        max: v.value,
        testid: n.countTestid,
        onUpdate: P[0] || (P[0] = (A) => m(o).setCount(n.kind, A))
      }, null, 8, ["value", "min", "max", "testid"])) : z("", !0),
      u("span", Fge, [
        f.value && !w.value ? (g(), b("button", {
          key: 0,
          class: "up-run is-get",
          "data-testid": "studio-get-tokens",
          onClick: P[1] || (P[1] = (A) => m(a).getTokens())
        }, [
          C($, {
            name: "Tokens",
            size: 13
          }),
          P[4] || (P[4] = Y("Get tokens ", -1))
        ])) : (g(), b("button", {
          key: 1,
          class: G(["up-run", { "is-busy": w.value }]),
          disabled: w.value || !!h.value,
          title: n.resting ? h.value || void 0 : h.value || w.value ? void 0 : "Run (" + m(wn)(["mod", "enter"]) + ")",
          "data-testid": n.runTestid,
          onClick: T
        }, [
          w.value ? (g(), Ie($, {
            key: 0,
            name: "Loader2",
            size: 14,
            spin: ""
          })) : z("", !0),
          Y(" " + E(w.value ? "Running" : n.label || "Run"), 1)
        ], 10, Nge)),
        (h.value || f.value) && !w.value && !n.resting ? (g(), b("span", Uge, E(h.value), 1)) : z("", !0)
      ])
    ], 512));
  }
}), Gge = { class: "sv-fp-head" }, jge = {
  key: 0,
  class: "sv-fp-tag",
  "data-testid": "studio-full-prompt-edited"
}, Hge = ["aria-checked"], Vge = ["value"], Wge = { class: "sv-fp-foot" }, qge = {
  class: "sv-fp-note",
  "data-testid": "studio-full-prompt-note"
}, Kge = { class: "up-run-wrap" }, Yge = ["disabled", "title"], Xge = {
  key: 0,
  class: "tip"
}, ux = /* @__PURE__ */ Pe({
  __name: "FullPrompt",
  props: {
    kind: {}
  },
  emits: ["run"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = yt(), o = /* @__PURE__ */ W(null), r = I(() => s.fullEdit(t.kind)), a = I(() => r.value != null), l = I(() => r.value != null ? r.value : s.fullPromptOf(t.kind)), d = I(() => s.s.sending > 0), c = I(() => a.value ? s.fullProblem(t.kind, l.value) : null), h = I(() => a.value && s.fullDrifted(t.kind));
    function f() {
      const x = o.value;
      x && (x.style.height = "0px", x.style.height = Math.min(180, Math.max(54, x.scrollHeight)) + "px");
    }
    Ee(l, () => nt(f)), it(f);
    function p(x) {
      s.setFullEdit(t.kind, x.target.value);
    }
    function y() {
      !a.value || c.value || d.value || i("run", l.value);
    }
    function v(x) {
      x.key === "Enter" && bn(x) && (x.preventDefault(), y());
    }
    return (x, w) => (g(), b("div", {
      class: G(["sv-fp", { "is-edited": a.value }]),
      "data-testid": "studio-full-prompt"
    }, [
      u("div", Gge, [
        w[4] || (w[4] = u("span", { class: "t" }, "Full prompt", -1)),
        C(vt, { name: "sv-fp-tag" }, {
          default: Xe(() => [
            a.value ? (g(), b("span", jge, "Edited")) : z("", !0)
          ]),
          _: 1
        }),
        w[5] || (w[5] = u("span", { class: "sv-grow" }, null, -1)),
        m(s).takesWordsOnly(n.kind) ? (g(), b("button", {
          key: 0,
          class: G(["sv-fp-only", { on: m(s).s.wordsOnly }]),
          role: "switch",
          "aria-checked": m(s).s.wordsOnly,
          title: "Send exactly what you typed, without the lines about the pictures and notes",
          "data-testid": "studio-words-only",
          onClick: w[0] || (w[0] = (S) => m(s).setWordsOnly(!m(s).s.wordsOnly))
        }, [...w[2] || (w[2] = [
          u("i", null, null, -1),
          Y("Send my words only", -1)
        ])], 10, Hge)) : z("", !0),
        a.value ? (g(), b("button", {
          key: 1,
          class: "sv-fp-reset",
          title: "Back to the prompt put together from your words",
          "data-testid": "studio-full-prompt-reset",
          onClick: w[1] || (w[1] = (S) => m(s).resetFullEdit(n.kind))
        }, [
          C($, {
            name: "RotateCcw",
            size: 11
          }),
          w[3] || (w[3] = Y(" Reset ", -1))
        ])) : z("", !0)
      ]),
      u("textarea", {
        ref_key: "el",
        ref: o,
        class: "sv-fp-text",
        value: l.value,
        spellcheck: "false",
        "aria-label": "Full prompt",
        "data-testid": "studio-full-prompt-text",
        onInput: p,
        onKeydown: v
      }, null, 40, Vge),
      u("div", Wge, [
        u("span", qge, [
          h.value ? (g(), b(j, { key: 0 }, [
            Y("Your words changed since: reset to start again from them")
          ], 64)) : a.value ? (g(), b(j, { key: 1 }, [
            Y("Runs instead of the prompt put together from your words")
          ], 64)) : m(s).s.wordsOnly && m(s).takesWordsOnly(n.kind) ? (g(), b(j, { key: 2 }, [
            Y("Only your words go: the lines about the pictures and notes are left out")
          ], 64)) : (g(), b(j, { key: 3 }, [
            Y("What the model gets. Change it to run your own")
          ], 64))
        ]),
        u("span", Kge, [
          u("button", {
            class: G(["up-run sv-fp-run", { "is-busy": d.value && a.value }]),
            disabled: !a.value || !!c.value || d.value,
            title: a.value ? void 0 : "Change the prompt to run it",
            "data-testid": "studio-full-prompt-run",
            onClick: y
          }, [
            d.value && a.value ? (g(), Ie($, {
              key: 0,
              name: "Loader2",
              size: 13,
              spin: ""
            })) : z("", !0),
            Y(" " + E(d.value && a.value ? "Running" : "Run with this prompt"), 1)
          ], 10, Yge),
          a.value && c.value && !d.value ? (g(), b("span", Xge, E(c.value), 1)) : z("", !0)
        ])
      ])
    ], 2));
  }
}), Jge = ["aria-expanded", "title"], Zge = {
  key: 0,
  class: "dot",
  "aria-hidden": "true"
}, hx = /* @__PURE__ */ Pe({
  __name: "FullPromptToggle",
  props: {
    kind: {}
  },
  setup(n) {
    const e = n, t = yt(), i = I(() => !!t.s.fullOpen[e.kind]), s = I(() => t.fullEdit(e.kind) != null), o = I(() => i.value || t.fullShown(e.kind)), r = I(() => i.value ? "Hide the full prompt" : s.value ? "Your edited prompt: open it to run it" : "See the whole prompt the model gets, and change it");
    return (a, l) => o.value ? (g(), b("button", {
      key: 0,
      class: G(["sv-fp-link", { on: i.value, "is-edited": s.value }]),
      "aria-expanded": i.value,
      title: r.value,
      "data-testid": "studio-full-prompt-toggle",
      onClick: l[0] || (l[0] = (d) => m(t).setFullOpen(n.kind, !i.value))
    }, [
      l[1] || (l[1] = u("span", null, "Full prompt", -1)),
      s.value ? (g(), b("span", Zge)) : z("", !0),
      C($, {
        name: "ChevronDown",
        size: 12,
        class: "chev"
      })
    ], 10, Jge)) : z("", !0);
  }
}), Qge = {
  key: 0,
  class: "ed-collapse"
}, fa = /* @__PURE__ */ Pe({
  __name: "Collapse",
  props: {
    open: { type: Boolean }
  },
  setup(n) {
    const e = () => typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function t(r, a) {
      let l = !1;
      const d = () => {
        l || (l = !0, r.removeEventListener("transitionend", c), a());
      }, c = (h) => {
        h.target === r && h.propertyName === "height" && d();
      };
      r.addEventListener("transitionend", c), window.setTimeout(d, 520);
    }
    function i(r, a) {
      const l = r;
      if (e()) {
        a();
        return;
      }
      l.style.clipPath = "inset(0)", l.style.height = "0px", l.style.opacity = "0", l.offsetHeight, l.style.height = l.scrollHeight + "px", l.style.opacity = "1", t(l, a);
    }
    function s(r) {
      const a = r;
      a.style.height = "", a.style.opacity = "", a.style.clipPath = "";
    }
    function o(r, a) {
      const l = r;
      if (e()) {
        a();
        return;
      }
      l.style.clipPath = "inset(0)", l.style.height = l.scrollHeight + "px", l.offsetHeight, l.style.height = "0px", l.style.opacity = "0", t(l, a);
    }
    return (r, a) => (g(), Ie(vt, {
      css: !1,
      onEnter: i,
      onAfterEnter: s,
      onLeave: o
    }, {
      default: Xe(() => [
        n.open ? (g(), b("div", Qge, [
          Ss(r.$slots, "default")
        ])) : z("", !0)
      ]),
      _: 3
    }));
  }
}), ebe = { class: "ed-slider-head" }, tbe = { class: "lb" }, nbe = ["title"], ibe = { class: "ed-slider-track" }, sbe = ["min", "max", "step", "value", "disabled", "aria-label", "data-testid"], Ct = /* @__PURE__ */ Pe({
  __name: "Slider",
  props: {
    label: {},
    modelValue: {},
    min: {},
    max: {},
    step: { default: 1 },
    start: { default: 0 },
    format: { type: [Function, null], default: null },
    ticks: { default: () => [] },
    testid: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "commit"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = I(() => t.min < 0 && t.max > 0), o = I(() => Math.max(1e-9, t.max - t.min)), r = (f) => (Math.min(t.max, Math.max(t.min, f)) - t.min) / o.value, a = I(() => {
      const f = s.value ? r(0) : 0, p = r(t.modelValue);
      return { left: Math.min(f, p) * 100 + "%", width: Math.abs(p - f) * 100 + "%" };
    }), l = I(() => {
      if (t.format) return t.format(t.modelValue);
      const f = Math.round(t.modelValue * 100) / 100;
      return s.value && f > 0 ? "+" + f : String(f);
    }), d = I(() => Math.abs(t.modelValue - t.start) > 1e-9);
    function c(f) {
      i("update:modelValue", Number(f.target.value));
    }
    function h() {
      t.disabled || (i("update:modelValue", t.start), i("commit", t.start));
    }
    return (f, p) => (g(), b("label", {
      class: G(["ed-slider", { "is-changed": d.value, "is-off": n.disabled }]),
      onDblclick: h
    }, [
      u("span", ebe, [
        u("span", tbe, E(n.label), 1),
        u("span", {
          class: "v",
          title: d.value ? "Double-click to reset" : ""
        }, E(l.value), 9, nbe)
      ]),
      u("span", ibe, [
        p[1] || (p[1] = u("span", { class: "rail" }, null, -1)),
        u("span", {
          class: "fill",
          style: ce(a.value)
        }, null, 4),
        (g(!0), b(j, null, ge(n.ticks, (y) => (g(), b("i", {
          key: y,
          class: G(["tick", { on: Math.abs(y - n.modelValue) < 1e-6 }]),
          style: ce({ left: r(y) * 100 + "%" })
        }, null, 6))), 128)),
        u("input", {
          type: "range",
          min: n.min,
          max: n.max,
          step: n.step,
          value: n.modelValue,
          disabled: n.disabled,
          "aria-label": n.label,
          "data-testid": n.testid,
          onInput: c,
          onChange: p[0] || (p[0] = (y) => i("commit", Number(y.target.value)))
        }, null, 40, sbe)
      ])
    ], 34));
  }
}), obe = ["data-testid"], rbe = {
  key: 0,
  class: "ed-field"
}, abe = { class: "ed-field-lb" }, lbe = ["aria-label"], dbe = ["aria-checked", "onClick"], cbe = {
  key: 1,
  class: "ed-field"
}, ube = { class: "ed-field-lb" }, hbe = { class: "ed-select" }, pbe = ["value", "onChange"], fbe = ["value"], mbe = {
  key: 3,
  class: "ed-field"
}, gbe = { class: "ed-field-lb" }, bbe = ["value", "placeholder", "onInput"], vbe = ["aria-expanded"], ybe = {
  key: 1,
  class: "ed-fields-more"
}, xbe = {
  key: 1,
  class: "ed-switch"
}, wbe = ["checked", "onChange"], kbe = {
  key: 2,
  class: "ed-field"
}, _be = { class: "ed-field-lb" }, Sbe = { class: "ed-select" }, Mbe = ["value", "onChange"], Tbe = ["value"], Cbe = {
  key: 3,
  class: "ed-field"
}, Ibe = { class: "ed-field-lb" }, Abe = ["value", "placeholder", "onInput"], px = /* @__PURE__ */ Pe({
  __name: "ModelFields",
  props: {
    kind: {},
    skip: { default: () => [] },
    part: { default: "all" }
  },
  setup(n) {
    const e = n, t = yt(), i = /* @__PURE__ */ W(!1), s = I(() => t.modelOf(e.kind)), o = I(() => {
      const p = s.value;
      return p ? p.fields.filter((y) => y.placement !== "reference" && y.kind !== "seed" && y.kind !== "header" && y.kind !== "model" && y.kind !== "video" && !e.skip.includes(y.key) && !e.skip.includes(y.label)) : [];
    }), r = I(() => e.part === "more" ? [] : o.value.filter((p) => p.placement === "chip" || p.placement === "prompt")), a = I(() => o.value.filter((p) => p.placement === "advanced"));
    function l(p) {
      return t.valueOf(e.kind, p);
    }
    function d(p, y) {
      t.setInput(e.kind, p.key, y);
    }
    function c(p) {
      const y = l(p), v = typeof y == "number" ? y : Number(y);
      return Number.isFinite(v) ? v : Number(p.defaultValue) || 0;
    }
    function h(p) {
      return p.replace(/\s*\(optional\)\s*/i, "").replace(/\s*\(must be [^)]*\)\s*/i, "");
    }
    function f(p) {
      return p.replace(/_n_/g, " and ").replace(/_/g, " ").replace(/^\w/, (y) => y.toUpperCase());
    }
    return (p, y) => (n.part === "more" ? a.value.length : o.value.length) ? (g(), b("div", {
      key: 0,
      class: "ed-fields",
      "data-testid": n.part === "more" ? "studio-edit-more" : void 0
    }, [
      (g(!0), b(j, null, ge(r.value, (v) => {
        var x, w, S, M;
        return g(), b(j, {
          key: v.key
        }, [
          (v.kind === "select" || v.kind === "size") && v.options && v.options.length <= 5 ? (g(), b("div", rbe, [
            u("span", abe, E(h(v.label)), 1),
            u("div", {
              class: "sv-seg is-small ed-pills",
              role: "radiogroup",
              "aria-label": v.label
            }, [
              (g(!0), b(j, null, ge(v.options, (_) => (g(), b("button", {
                key: String(_.label),
                role: "radio",
                "aria-checked": m(Qi)(_.value, l(v)),
                class: G({ on: m(Qi)(_.value, l(v)) }),
                onClick: (T) => d(v, _.value)
              }, E(/^\d+$/.test(String(_.label)) ? _.label + "×" : f(String(_.label))), 11, dbe))), 128))
            ], 8, lbe)
          ])) : v.kind === "select" && v.options ? (g(), b("label", cbe, [
            u("span", ube, E(h(v.label)), 1),
            u("span", hbe, [
              u("select", {
                value: JSON.stringify(l(v)),
                onChange: (_) => d(v, JSON.parse(_.target.value))
              }, [
                (g(!0), b(j, null, ge(v.options, (_) => (g(), b("option", {
                  key: String(_.label),
                  value: JSON.stringify(_.value)
                }, E(f(String(_.label))), 9, fbe))), 128))
              ], 40, pbe),
              C($, {
                name: "ChevronDown",
                size: 12
              })
            ])
          ])) : v.kind === "slider" ? (g(), Ie(Ct, {
            key: 2,
            label: h(v.label),
            "model-value": c(v),
            min: (x = v.min) != null ? x : 0,
            max: (w = v.max) != null ? w : 100,
            step: (S = v.step) != null ? S : 1,
            start: Number(v.defaultValue) || 0,
            "onUpdate:modelValue": (_) => d(v, _)
          }, null, 8, ["label", "model-value", "min", "max", "step", "start", "onUpdate:modelValue"])) : v.kind === "prompt" || v.kind === "text" ? (g(), b("label", mbe, [
            u("span", gbe, E(h(v.label)), 1),
            u("textarea", {
              class: "ed-text",
              rows: "2",
              value: String((M = l(v)) != null ? M : ""),
              placeholder: v.placeholder || "Optional",
              spellcheck: "false",
              onInput: (_) => d(v, _.target.value)
            }, null, 40, bbe)
          ])) : z("", !0)
        ], 64);
      }), 128)),
      a.value.length && n.part !== "more" ? (g(), b("button", {
        key: 0,
        class: G(["ed-more", { on: i.value }]),
        "aria-expanded": i.value,
        onClick: y[0] || (y[0] = (v) => i.value = !i.value)
      }, [
        C($, {
          name: "Settings2",
          size: 12
        }),
        Y(" " + E(i.value ? "Fewer settings" : "More settings") + " ", 1),
        C($, {
          name: i.value ? "ChevronUp" : "ChevronDown",
          size: 12
        }, null, 8, ["name"])
      ], 10, vbe)) : z("", !0),
      i.value || n.part === "more" ? (g(), b("div", ybe, [
        (g(!0), b(j, null, ge(a.value, (v) => {
          var x, w, S, M;
          return g(), b(j, {
            key: v.key
          }, [
            v.kind === "slider" ? (g(), Ie(Ct, {
              key: 0,
              label: h(v.label),
              "model-value": c(v),
              min: (x = v.min) != null ? x : 0,
              max: (w = v.max) != null ? w : 100,
              step: (S = v.step) != null ? S : 1,
              start: Number(v.defaultValue) || 0,
              "onUpdate:modelValue": (_) => d(v, _)
            }, null, 8, ["label", "model-value", "min", "max", "step", "start", "onUpdate:modelValue"])) : v.kind === "boolean" ? (g(), b("label", xbe, [
              u("input", {
                type: "checkbox",
                checked: !!l(v),
                onChange: (_) => d(v, _.target.checked)
              }, null, 40, wbe),
              y[1] || (y[1] = u("i", null, null, -1)),
              u("span", null, E(h(v.label)), 1)
            ])) : (v.kind === "select" || v.kind === "size") && v.options ? (g(), b("label", kbe, [
              u("span", _be, E(h(v.label)), 1),
              u("span", Sbe, [
                u("select", {
                  value: JSON.stringify(l(v)),
                  onChange: (_) => d(v, JSON.parse(_.target.value))
                }, [
                  (g(!0), b(j, null, ge(v.options, (_) => (g(), b("option", {
                    key: String(_.label),
                    value: JSON.stringify(_.value)
                  }, E(f(String(_.label))), 9, Tbe))), 128))
                ], 40, Mbe),
                C($, {
                  name: "ChevronDown",
                  size: 12
                })
              ])
            ])) : v.kind === "prompt" || v.kind === "text" || v.kind === "negPrompt" ? (g(), b("label", Cbe, [
              u("span", Ibe, E(h(v.label)), 1),
              u("textarea", {
                class: "ed-text",
                rows: "2",
                value: String((M = l(v)) != null ? M : ""),
                placeholder: v.placeholder || "Optional",
                spellcheck: "false",
                onInput: (_) => d(v, _.target.value)
              }, null, 40, Abe)
            ])) : z("", !0)
          ], 64);
        }), 128))
      ])) : z("", !0)
    ], 8, obe)) : z("", !0);
  }
}), Pbe = {
  class: "sv-describe",
  "data-testid": "studio-composer"
}, Ebe = ["value", "placeholder"], Rbe = ["aria-expanded"], zbe = ["aria-expanded"], $be = ["title"], Dbe = /* @__PURE__ */ Pe({
  __name: "Composer",
  props: {
    before: { type: [Function, null], default: null },
    label: { default: null }
  },
  setup(n) {
    const e = n, t = yt(), { board: i } = Ze(), s = t.s, o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = I(() => t.genMode.value), l = I(() => t.sending()), d = I(() => t.queueItems.value.length > 0 && t.limit.value > 0), c = I(() => Math.max(0, Math.min(t.queueItems.value.length, t.limit.value) - 1)), h = I(() => a.value === "threed" && !!e.before), f = I(() => t.fullTakesOver(a.value)), p = I(() => !!s.fullOpen[a.value] && t.fullShown(a.value)), y = /* @__PURE__ */ W(!1), v = I(() => t.advancedOf(a.value).length > 0);
    Ee(a, () => {
      y.value = !1;
    });
    const x = I(() => i.ui.library.open && i.ui.library.inStudio);
    function w() {
      if (x.value) {
        i.promptLibrary.close();
        return;
      }
      t.commitPrompt(), i.promptLibrary.openInStudio(t.sessionId);
    }
    function S(R, D) {
      return R + " " + D + (R === 1 ? "" : "s");
    }
    const M = I(() => l.value.map((R) => {
      const D = [R.marks ? S(R.marks, "annotation") : "", R.comments ? S(R.comments, "note") : ""].filter(Boolean);
      return "Image " + R.image + ": " + D.join(", ");
    }).join(" · ")), _ = I(() => {
      if (l.value.length) {
        const R = l.value.reduce((F, ie) => F + ie.marks, 0), D = l.value.reduce((F, ie) => F + ie.comments, 0);
        return { icon: "Pencil", text: [R ? S(R, "annotation") : "", D ? S(D, "note") : ""].filter(Boolean).join(", ") + (R + D === 1 ? " goes with it" : " go with them"), title: "Goes with it: " + M.value };
      }
      return d.value ? { icon: "Images", text: c.value ? "From image 1, with " + c.value + " more" : "From image 1", title: "Starts from image 1" + (c.value ? ", with " + c.value + " more as references" : "") } : null;
    }), T = I(() => t.video.value ? d.value ? c.value ? "Describe the video to make from these pictures" : "Describe the video to make from image 1" : "Describe a new video" : d.value ? l.value.length ? "Anything to add? Their annotations and notes go with them" : c.value ? "Describe what to make from these images" : "Describe what to make from image 1" : "Describe a new image");
    function k() {
      const R = o.value;
      R && (R.style.height = "0px", R.style.height = Math.min(160, Math.max(48, R.scrollHeight)) + "px");
    }
    Ee(() => s.prompt, () => nt(k)), it(() => {
      k(), s.studio === "prompt" && o.value && o.value.focus();
    });
    async function P(R = null) {
      s.sending || e.before && !await e.before() || await t.generate(R);
    }
    function A(R) {
      R.key === "Enter" && bn(R) && (R.preventDefault(), r.value && r.value.tryRun());
    }
    return (R, D) => (g(), b("div", Pbe, [
      u("div", {
        class: G(["sv-words", { "has-side": a.value === "prompt" }])
      }, [
        u("textarea", {
          ref_key: "text",
          ref: o,
          value: m(s).prompt,
          class: "up-text sv-describe-text",
          rows: "1",
          spellcheck: "false",
          placeholder: T.value,
          "data-testid": "studio-prompt",
          onInput: D[0] || (D[0] = (O) => {
            m(t).setPrompt(O.target.value), k();
          }),
          onBlur: D[1] || (D[1] = (O) => m(t).commitPrompt()),
          onKeydown: A
        }, null, 40, Ebe),
        a.value === "prompt" ? (g(), b("button", {
          key: 0,
          class: G(["up-side-btn sv-words-side", { on: x.value }]),
          title: "Prompt library",
          "aria-label": "Prompt library",
          "aria-expanded": x.value,
          "data-testid": "studio-library-button",
          onClick: w
        }, [
          C($, {
            name: "LayoutTemplate",
            size: 15
          })
        ], 10, Rbe)) : z("", !0)
      ], 2),
      C(fa, { open: p.value }, {
        default: Xe(() => [
          C(ux, {
            kind: a.value,
            onRun: P
          }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["open"]),
      C(fa, {
        open: y.value && v.value
      }, {
        default: Xe(() => [
          C(px, {
            kind: a.value,
            part: "more"
          }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["open"]),
      C(nA, {
        ref_key: "foot",
        ref: r,
        kind: a.value,
        resting: f.value,
        unchecked: h.value,
        label: n.label,
        "run-testid": "studio-generate",
        "count-testid": "studio-count",
        onRun: D[3] || (D[3] = (O) => P())
      }, {
        chips: Xe(() => [
          v.value ? (g(), b("button", {
            key: 0,
            class: G(["up-chip", { on: y.value }]),
            "aria-expanded": y.value,
            title: "More settings",
            "data-testid": "studio-more-toggle",
            onClick: D[2] || (D[2] = (O) => y.value = !y.value)
          }, [
            C($, {
              name: "Settings2",
              size: 13
            }),
            D[4] || (D[4] = u("span", { class: "t" }, "More", -1))
          ], 10, zbe)) : z("", !0),
          _.value ? (g(), b(j, { key: 1 }, [
            D[5] || (D[5] = u("span", { class: "up-foot-sep" }, null, -1)),
            u("span", {
              class: "up-note",
              title: _.value.title,
              "data-testid": "studio-sending"
            }, [
              C($, {
                name: _.value.icon,
                size: 12
              }, null, 8, ["name"]),
              Y(E(_.value.text), 1)
            ], 8, $be)
          ], 64)) : z("", !0)
        ]),
        aside: Xe(() => [
          C(hx, { kind: a.value }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["kind", "resting", "unchecked", "label"])
    ]));
  }
}), _m = /* @__PURE__ */ Pe({
  __name: "Radio",
  props: {
    on: { type: Boolean }
  },
  setup(n) {
    return (e, t) => (g(), b("span", {
      class: G(["ed-radio", { on: n.on }]),
      "aria-hidden": "true"
    }, [...t[0] || (t[0] = [
      u("i", null, null, -1)
    ])], 2));
  }
}), Obe = /* @__PURE__ */ Pe({
  __name: "AutoHeight",
  setup(n) {
    const e = /* @__PURE__ */ W(null), t = /* @__PURE__ */ W(null), i = /* @__PURE__ */ W(!1);
    let s = null, o = 0;
    function r() {
      if (!e.value) return;
      const a = e.value.offsetHeight;
      t.value != null && Math.abs(a - t.value) > 0.5 && (i.value = !0, clearTimeout(o), o = window.setTimeout(() => {
        i.value = !1;
      }, 380)), t.value = a;
    }
    return it(() => {
      r(), e.value && (s = new ResizeObserver(r), s.observe(e.value));
    }), We(() => {
      s && s.disconnect(), clearTimeout(o);
    }), (a, l) => (g(), b("div", {
      class: G(["ed-autoh", { "is-moving": i.value }]),
      style: ce({ height: t.value != null ? t.value + "px" : "auto" })
    }, [
      u("div", {
        ref_key: "inner",
        ref: e,
        class: "ed-autoh-in"
      }, [
        Ss(a.$slots, "default")
      ], 512)
    ], 6));
  }
}), Lbe = {
  class: "ed-tools-inline",
  "data-testid": "studio-area-tools"
}, Bbe = {
  class: "sv-seg is-small ed-seg-icons",
  role: "radiogroup",
  "aria-label": "Select the area with"
}, Fbe = ["aria-checked", "title", "aria-label", "data-testid", "onClick"], Nbe = ["aria-pressed", "title"], Ube = ["title"], Gbe = ["disabled", "title"], jbe = ["disabled", "title"], Hbe = ["disabled"], Vbe = /* @__PURE__ */ Pe({
  __name: "AreaTools",
  setup(n) {
    const e = yt(), t = e.s, i = [
      { id: "brush", icon: "Paintbrush", label: "Brush", key: "B", hint: "Paint over what should change" },
      { id: "lasso", icon: "LassoSelect", label: "Lasso", key: "L", hint: "Draw round what should change" },
      { id: "object", icon: "MousePointerClick", label: "Pick an object", key: "S", hint: "Click a thing in the picture to take it all" }
    ], s = wn(["alt"]), o = I(() => e.area().length > 0);
    function r(a) {
      t.areaTool = a;
    }
    return (a, l) => (g(), b("div", Lbe, [
      u("div", Bbe, [
        (g(), b(j, null, ge(i, (d) => u("button", {
          key: d.id,
          role: "radio",
          "aria-checked": m(t).areaTool === d.id,
          class: G({ on: m(t).areaTool === d.id }),
          title: d.label + " (" + d.key + `)
` + d.hint,
          "aria-label": d.label,
          "data-testid": "studio-area-" + d.id,
          onClick: (c) => r(d.id)
        }, [
          C($, {
            name: d.icon,
            size: 14
          }, null, 8, ["name"])
        ], 10, Fbe)), 64))
      ]),
      u("button", {
        class: G(["ed-icon-chip", { on: m(t).areaCut }]),
        "aria-pressed": m(t).areaCut,
        title: `Take away from the area
Or hold ` + m(s) + " as you paint",
        "data-testid": "studio-area-cut",
        onClick: l[0] || (l[0] = (d) => m(t).areaCut = !m(t).areaCut)
      }, [
        C($, {
          name: "Minus",
          size: 13
        })
      ], 10, Nbe),
      m(t).areaTool === "brush" ? (g(), b("label", {
        key: 0,
        class: "ed-size",
        title: "Brush size: " + m(t).areaSize + `
[ and ] change it`
      }, [
        u("i", {
          style: ce({ width: Math.max(4, Math.min(18, m(t).areaSize / 6)) + "px", height: Math.max(4, Math.min(18, m(t).areaSize / 6)) + "px" })
        }, null, 4),
        _t(u("input", {
          "onUpdate:modelValue": l[1] || (l[1] = (d) => m(t).areaSize = d),
          type: "range",
          min: "6",
          max: "200",
          step: "1",
          "aria-label": "Brush size",
          "data-testid": "studio-area-size"
        }, null, 512), [
          [
            Zt,
            m(t).areaSize,
            void 0,
            { number: !0 }
          ]
        ])
      ], 8, Ube)) : z("", !0),
      l[5] || (l[5] = u("span", { class: "ed-mini-sep" }, null, -1)),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canUndo(),
        title: "Undo (" + m(wn)(["mod", "Z"]) + ")",
        "aria-label": "Undo",
        onClick: l[2] || (l[2] = (d) => m(e).undoMark())
      }, [
        C($, {
          name: "Undo2",
          size: 13
        })
      ], 8, Gbe),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canRedo(),
        title: "Redo (" + m(wn)(m(am)()) + ")",
        "aria-label": "Redo",
        onClick: l[3] || (l[3] = (d) => m(e).redoMark())
      }, [
        C($, {
          name: "Redo2",
          size: 13
        })
      ], 8, jbe),
      u("button", {
        class: "ed-icon-chip",
        disabled: !o.value,
        title: "Clear the area",
        "aria-label": "Clear the area",
        "data-testid": "studio-area-clear",
        onClick: l[4] || (l[4] = (d) => m(e).clearArea())
      }, [
        C($, {
          name: "Trash2",
          size: 13
        })
      ], 8, Hbe)
    ]));
  }
}), Wbe = { class: "sv-pop-wrap" }, qbe = ["aria-expanded", "title"], Kbe = {
  key: 0,
  class: "sv-pop ed-mark-pop",
  role: "radiogroup",
  "aria-label": "Annotate with"
}, Ybe = ["aria-checked", "data-testid", "onClick"], Xbe = { class: "nm" }, Jbe = ["value"], Zbe = ["disabled"], Qbe = { class: "sv-pop-wrap" }, eve = ["title"], tve = { class: "ed-swatch-row" }, nve = ["title", "onClick"], ive = ["value"], sve = ["title"], ove = ["value", "disabled"], rve = { "data-testid": "studio-opacity-value" }, ave = ["disabled", "title"], lve = ["disabled", "title"], dve = /* @__PURE__ */ Pe({
  __name: "MarkTools",
  setup(n) {
    const e = yt(), t = e.s, i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(null), o = [
      { id: "move", icon: "MousePointer2", label: "Move", key: "V", hint: "Select annotations to move, resize or turn them" },
      { id: "brush", icon: "Brush", label: "Pencil", key: "B", hint: "Draw on the picture to show where" },
      { id: "text", icon: "Type", label: "Text", key: "T", hint: "Write a label on the picture" },
      { id: "box", icon: "Square", label: "Box", key: "R", hint: "Box an area" },
      { id: "ellipse", icon: "Circle", label: "Ellipse", key: "O", hint: "Circle an area" },
      { id: "arrow", icon: "ArrowUpRight", label: "Arrow", key: "A", hint: "Point at something" },
      { id: "eraser", icon: "Eraser", label: "Eraser", key: "E", hint: "Rub out parts of your annotations" },
      { id: "note", icon: "MapPin", label: "Note", key: "N", hint: "Pin a numbered note where something should change" }
    ], r = I(() => o.find((S) => S.id === t.tool) || o[1]), a = I(() => !O0.includes(t.color)), l = I(() => t.tool === "text"), d = I(() => Math.round(t.opacity * 100));
    let c = !1;
    function h() {
      c = !0, t.tool === "move" && t.selection.length && e.beginGesture();
    }
    function f(S) {
      e.setOpacity(Number(S.target.value) / 100, !c);
    }
    function p() {
      c = !1;
    }
    const y = I(() => {
      const S = e.working();
      return S.strokes.length > 0 || S.pins.length > 0;
    });
    function v(S) {
      e.finishEditing(), t.tool = S, S !== "move" && e.select([]), i.value = null;
    }
    function x(S) {
      !Number.isFinite(S) || S <= 0 || (t.size = Math.max(1, Math.min(80, Math.round(S))));
    }
    function w(S) {
      s.value && !s.value.contains(S.target) && (i.value = null);
    }
    return Ee(i, (S) => {
      S ? window.addEventListener("pointerdown", w, !0) : window.removeEventListener("pointerdown", w, !0);
    }), We(() => window.removeEventListener("pointerdown", w, !0)), (S, M) => (g(), b("div", {
      ref_key: "wrap",
      ref: s,
      class: "ed-tools-inline",
      "data-testid": "studio-mark-tools",
      onKeydown: M[8] || (M[8] = tn(Te((_) => i.value = null, ["stop"]), ["esc"]))
    }, [
      u("div", Wbe, [
        u("button", {
          class: G(["sv-chip ed-tool-chip", { on: i.value === "tool" }]),
          "aria-expanded": i.value === "tool",
          title: r.value.label + " (" + r.value.key + `)
` + r.value.hint,
          "data-testid": "studio-mark-tool",
          onClick: M[0] || (M[0] = (_) => i.value = i.value === "tool" ? null : "tool")
        }, [
          C($, {
            name: r.value.icon,
            size: 13
          }, null, 8, ["name"]),
          u("span", null, E(r.value.label), 1),
          C($, {
            name: "ChevronUp",
            size: 11,
            class: "chev"
          })
        ], 10, qbe),
        i.value === "tool" ? (g(), b("div", Kbe, [
          (g(), b(j, null, ge(o, (_) => u("button", {
            key: _.id,
            class: G(["ed-mark-row", { on: m(t).tool === _.id }]),
            role: "radio",
            "aria-checked": m(t).tool === _.id,
            "data-testid": "studio-tool-" + _.id,
            onClick: (T) => v(_.id)
          }, [
            C($, {
              name: _.icon,
              size: 14
            }, null, 8, ["name"]),
            u("span", Xbe, E(_.label), 1),
            u("kbd", null, E(_.key), 1)
          ], 10, Ybe)), 64)),
          u("div", {
            class: G(["ed-mark-size", { "is-off": m(t).tool === "move" || m(t).tool === "text" || m(t).tool === "note" }])
          }, [
            M[9] || (M[9] = u("span", null, "Size", -1)),
            u("input", {
              value: m(t).size,
              type: "range",
              min: "1",
              max: "80",
              step: "1",
              "aria-label": "Size",
              onInput: M[1] || (M[1] = (_) => x(+_.target.value))
            }, null, 40, Jbe),
            u("b", null, E(m(t).size), 1)
          ], 2),
          u("button", {
            class: "ed-mark-clear",
            disabled: !y.value,
            "data-testid": "studio-clear",
            onClick: M[2] || (M[2] = (_) => {
              m(e).clearMarks(), i.value = null;
            })
          }, [
            C($, {
              name: "Trash2",
              size: 12
            }),
            M[10] || (M[10] = Y(" Clear annotations and notes", -1))
          ], 8, Zbe)
        ])) : z("", !0)
      ]),
      u("div", Qbe, [
        u("button", {
          class: G(["sv-color ed-color", { on: i.value === "colour" }]),
          style: ce({ "--c": m(t).color, "--o": l.value ? 1 : m(t).opacity }),
          title: "Colour" + (l.value ? "" : ", " + d.value + "% opacity"),
          "aria-label": "Colour and opacity",
          "data-testid": "studio-color",
          onClick: M[3] || (M[3] = (_) => i.value = i.value === "colour" ? null : "colour")
        }, [...M[11] || (M[11] = [
          u("i", null, null, -1)
        ])], 14, eve),
        i.value === "colour" ? (g(), b("div", {
          key: 0,
          class: "sv-pop is-colors ed-colour-pop",
          "data-testid": "studio-colour-pop",
          onPointerdown: M[5] || (M[5] = Te(() => {
          }, ["stop"]))
        }, [
          u("div", tve, [
            (g(!0), b(j, null, ge(m(O0), (_) => (g(), b("button", {
              key: _,
              class: G(["sw", { on: m(t).color === _ }]),
              style: ce({ "--c": _ }),
              title: _,
              onClick: (T) => m(e).setColor(_)
            }, null, 14, nve))), 128)),
            u("label", {
              class: G(["sw is-any", { on: a.value }]),
              style: ce(a.value ? { "--c": m(t).color } : void 0),
              title: "Any colour"
            }, [
              u("input", {
                type: "color",
                value: m(t).color,
                onInput: M[4] || (M[4] = (_) => m(e).setColor(_.target.value))
              }, null, 40, ive)
            ], 6)
          ]),
          u("label", {
            class: G(["ed-opacity", { "is-off": l.value }]),
            title: l.value ? "Text stays solid, so it reads clearly" : "How see-through new annotations are"
          }, [
            M[12] || (M[12] = u("span", { class: "lb" }, "Opacity", -1)),
            u("input", {
              class: "ed-opacity-range",
              type: "range",
              min: "10",
              max: "100",
              step: "5",
              value: d.value,
              disabled: l.value,
              style: ce({ "--c": m(t).color }),
              "aria-label": "Opacity",
              "data-testid": "studio-opacity",
              onPointerdown: h,
              onInput: f,
              onChange: p
            }, null, 44, ove),
            u("b", rve, E(l.value ? 100 : d.value) + "%", 1)
          ], 10, sve)
        ], 32)) : z("", !0)
      ]),
      M[13] || (M[13] = u("span", { class: "ed-mini-sep" }, null, -1)),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canUndo(),
        title: "Undo (" + m(wn)(["mod", "Z"]) + ")",
        "aria-label": "Undo",
        "data-testid": "studio-undo",
        onClick: M[6] || (M[6] = (_) => m(e).undoMark())
      }, [
        C($, {
          name: "Undo2",
          size: 13
        })
      ], 8, ave),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canRedo(),
        title: "Redo (" + m(wn)(m(am)()) + ")",
        "aria-label": "Redo",
        "data-testid": "studio-redo",
        onClick: M[7] || (M[7] = (_) => m(e).redoMark())
      }, [
        C($, {
          name: "Redo2",
          size: 13
        })
      ], 8, lve)
    ], 544));
  }
}), cve = { class: "sv-queue-slots" }, uve = ["title", "onMouseenter"], hve = {
  key: 0,
  class: "n"
}, pve = ["aria-label", "onClick"], fve = {
  key: 0,
  class: "sv-slot-add-wrap"
}, mve = ["title", "aria-expanded"], gve = { class: "n" }, bve = /* @__PURE__ */ Pe({
  __name: "EditRefs",
  props: {
    over: { type: Boolean }
  },
  setup(n) {
    const e = n, t = yt(), i = t.s, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(!1), r = I(() => t.editRefItems.value), a = I(() => t.refRoom()), l = I(() => r.value.filter((D) => D.id !== i.stageId)), d = I(() => l.value.length < a.value), c = I(() => t.modelName("edit")), h = I(() => i.bar !== "annotate" && t.hasArea() ? 3 : 2), f = I(() => !!Xr.value && !r.value.some((D) => D.id === Xr.value));
    function p(D) {
      return t.refSent(D.id);
    }
    function y(D) {
      return D.id === i.stageId ? "In the viewer: it's the picture being edited, so it isn't sent as a reference" : p(D) ? "Image " + v(D) + ": a reference" : "Waits: " + c.value + " takes " + a.value + (a.value === 1 ? " reference" : " references") + " here";
    }
    function v(D) {
      return h.value + l.value.findIndex((O) => O.id === D.id);
    }
    function x(D) {
      const O = i.refPulse;
      return O && O.id === D ? O.n : 0;
    }
    function w(D) {
      _.value = null, t.removeEditRef(D.id);
    }
    async function S(D) {
      o.value = !1, await t.addEditRefUrl(D);
    }
    function M() {
      o.value = !1, t.setDropper(!0);
    }
    const _ = /* @__PURE__ */ qe(null);
    function T(D, O) {
      if (!s.value || Xr.value) return;
      const F = Math.min(QI / D.w, eA / D.h), ie = Math.round(D.w * F), ee = Math.round(D.h * F), me = O.currentTarget.getBoundingClientRect(), L = s.value.getBoundingClientRect();
      _.value = { it: D, w: ie, h: ee, left: Math.max(0, Math.min(L.width - ie, me.left - L.left + me.width / 2 - ie / 2)) };
    }
    const k = I(() => Math.min(l.value.length, a.value)), P = I(() => {
      const D = _.value;
      return D && !o.value && !Xr.value && r.value.some((O) => O.id === D.it.id) ? D : null;
    });
    function A(D) {
      const O = D.target;
      s.value && !s.value.contains(O) && !O.closest(".lb-backdrop") && (o.value = !1);
    }
    function R(D) {
      D.key === "Escape" && (D.stopPropagation(), D.preventDefault(), o.value = !1);
    }
    return Ee(o, (D) => {
      D ? (window.addEventListener("pointerdown", A, !0), window.addEventListener("keydown", R, !0)) : (window.removeEventListener("pointerdown", A, !0), window.removeEventListener("keydown", R, !0));
    }), We(() => {
      window.removeEventListener("pointerdown", A, !0), window.removeEventListener("keydown", R, !0);
    }), (D, O) => (g(), b("div", {
      ref_key: "wrap",
      ref: s,
      class: G(["sv-queue ed-refs", { "is-empty": !r.value.length, "is-over": e.over, "is-air": f.value && !e.over && a.value > 0 }]),
      "data-testid": "studio-edit-refs"
    }, [
      O[3] || (O[3] = u("span", { class: "sv-queue-label" }, "References", -1)),
      u("div", cve, [
        C(Zp, { name: "ed-ref" }, {
          default: Xe(() => [
            (g(!0), b(j, null, ge(r.value, (F) => (g(), b("div", {
              key: F.id,
              class: G(["sv-slot is-ref", { "is-unsent": !p(F), "is-stage": F.id === m(i).stageId }]),
              title: y(F),
              "data-testid": "studio-edit-ref",
              onMouseenter: (ie) => T(F, ie),
              onMouseleave: O[0] || (O[0] = (ie) => _.value = null)
            }, [
              C(ao, { item: F }, null, 8, ["item"]),
              p(F) ? (g(), b("span", hve, E(v(F)), 1)) : z("", !0),
              u("button", {
                class: "x",
                title: "Remove",
                "aria-label": "Remove " + (F.label || "reference"),
                "data-testid": "studio-edit-ref-remove",
                onClick: Te((ie) => w(F), ["stop"])
              }, [
                C($, {
                  name: "X",
                  size: 10
                })
              ], 8, pve),
              x(F.id) ? (g(), b("span", {
                key: "pulse" + x(F.id),
                class: "up-ref-pulse",
                "aria-hidden": "true"
              })) : z("", !0)
            ], 42, uve))), 128))
          ]),
          _: 1
        }),
        d.value ? (g(), b("div", fve, [
          u("button", {
            class: G(["sv-slot-add", { "is-target": e.over, "is-dropper": m(i).dropper }]),
            title: m(Bo).addTitle,
            "aria-label": "Add an image",
            "aria-expanded": o.value,
            "data-testid": "studio-edit-ref-add",
            onClick: O[1] || (O[1] = (F) => {
              o.value = !o.value, m(t).setDropper(!1);
            })
          }, [
            C($, {
              name: "ImagePlus",
              size: 16
            })
          ], 10, mve),
          o.value ? (g(), Ie(Zc, {
            key: 0,
            "session-id": m(t).sessionId,
            label: m(Bo).label,
            "dropper-label": m(Bo).dropper,
            tip: m(Bo).tip,
            onPick: S,
            onDropper: M,
            onClose: O[2] || (O[2] = (F) => o.value = !1)
          }, null, 8, ["session-id", "label", "dropper-label", "tip"])) : z("", !0)
        ])) : z("", !0),
        r.value.length ? z("", !0) : (g(), b("span", {
          key: 1,
          class: G(["sv-queue-empty ed-refs-hint", { "is-air": (f.value || e.over) && a.value > 0 }])
        }, E(a.value ? f.value || e.over ? "Drop it here to send it with the edit" : "Nothing yet: drag pictures here from history, or pick them with the eyedropper." : "No room for references while an area is selected: " + c.value + " takes two pictures"), 3))
      ]),
      P.value ? (g(), b("div", {
        key: 0,
        class: "sv-slot-peek",
        style: ce({ left: P.value.left + "px", width: P.value.w + "px", height: P.value.h + "px" }),
        "aria-hidden": "true",
        "data-testid": "studio-edit-ref-peek"
      }, [
        C(ao, {
          item: P.value.it,
          full: ""
        }, null, 8, ["item"]),
        u("span", gve, E(P.value.it.id === m(i).stageId ? "In the viewer" : p(P.value.it) ? "Image " + v(P.value.it) : "Waits"), 1)
      ], 4)) : z("", !0),
      a.value ? (g(), b("span", {
        key: 1,
        class: G(["sv-queue-count", { "is-over": l.value.length > a.value }])
      }, E(k.value) + " of " + E(a.value), 3)) : z("", !0)
    ], 2));
  }
}), vve = ["aria-expanded", "title"], yve = { class: "t" }, xve = {
  key: 0,
  class: "sv-pop ed-keep-pop",
  role: "radiogroup",
  "aria-label": "How the area is kept"
}, wve = { class: "sv-pop-rows" }, kve = ["aria-checked", "data-testid", "onClick"], _ve = { class: "tx" }, Sve = { class: "nm" }, Mve = { class: "hint" }, Tve = /* @__PURE__ */ Pe({
  __name: "AreaKeep",
  setup(n) {
    const t = yt().s, i = /* @__PURE__ */ W(!1), s = /* @__PURE__ */ W(null), o = [
      { precise: !0, label: "Precision", hint: "Only the area changes: every other pixel is kept", testid: "studio-precision" },
      { precise: !1, label: "Creative", hint: "The area changes most, and the rest may change a little to match", testid: "studio-creative" }
    ];
    function r(c) {
      t.precision = c, i.value = !1;
    }
    function a(c) {
      s.value && !s.value.contains(c.target) && (i.value = !1);
    }
    function l(c) {
      c.key === "Escape" && (c.stopPropagation(), c.preventDefault(), i.value = !1);
    }
    function d() {
      window.removeEventListener("pointerdown", a, !0), window.removeEventListener("keydown", l, !0);
    }
    return Ee(i, (c) => {
      if (!c) {
        d();
        return;
      }
      window.addEventListener("pointerdown", a, !0), window.addEventListener("keydown", l, !0);
    }), We(d), (c, h) => (g(), b("div", {
      ref_key: "wrap",
      ref: s,
      class: "sv-pop-wrap"
    }, [
      u("button", {
        class: G(["up-chip ed-keep", { on: i.value }]),
        "aria-expanded": i.value,
        title: "The area you selected: " + (m(t).precision ? o[0].hint : o[1].hint),
        "data-testid": "studio-area-keep",
        onClick: h[0] || (h[0] = (f) => i.value = !i.value)
      }, [
        C($, {
          name: "SquareDashed",
          size: 13
        }),
        u("span", yve, E(m(t).precision ? "Precision" : "Creative"), 1)
      ], 10, vve),
      i.value ? (g(), b("div", xve, [
        h[1] || (h[1] = u("div", { class: "sv-pop-title" }, "The area you selected", -1)),
        u("div", wve, [
          (g(), b(j, null, ge(o, (f) => u("button", {
            key: f.label,
            class: G(["sv-pop-row ed-keep-row", { on: m(t).precision === f.precise }]),
            role: "radio",
            "aria-checked": m(t).precision === f.precise,
            "data-testid": f.testid,
            onClick: (p) => r(f.precise)
          }, [
            u("span", _ve, [
              u("span", Sve, E(f.label), 1),
              u("span", Mve, E(f.hint), 1)
            ]),
            m(t).precision === f.precise ? (g(), Ie($, {
              key: 0,
              name: "Check",
              size: 12,
              class: "ck"
            })) : z("", !0)
          ], 10, kve)), 64))
        ])
      ])) : z("", !0)
    ], 512));
  }
}), Cve = ["title", "aria-expanded"], Ive = { class: "t" }, Ave = { class: "sv-pop-rows" }, Pve = ["aria-selected", "data-testid", "onClick"], Eve = { class: "nm" }, Rve = {
  key: 0,
  class: "mt"
}, zve = /* @__PURE__ */ Pe({
  __name: "EditSize",
  props: {
    kind: {}
  },
  setup(n) {
    const e = n, t = yt(), i = I(() => t.tiersOf(e.kind)), s = I(() => Math.min(t.tierOf(e.kind), Math.max(0, i.value.length - 1))), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(null);
    function a(d) {
      t.setTier(e.kind, d), o.value = !1;
    }
    function l(d) {
      r.value && !r.value.contains(d.target) && (o.value = !1);
    }
    return it(() => window.addEventListener("pointerdown", l, !0)), We(() => window.removeEventListener("pointerdown", l, !0)), (d, c) => i.value.length > 1 ? (g(), b("div", {
      key: 0,
      ref_key: "wrap",
      ref: r,
      class: "sv-pop-wrap"
    }, [
      u("button", {
        class: G(["up-chip", { on: o.value }]),
        title: "Size: " + (i.value[s.value].meta || i.value[s.value].label) + ". The picture keeps its shape.",
        "aria-expanded": o.value,
        "data-testid": "studio-edit-size",
        onClick: c[0] || (c[0] = (h) => o.value = !o.value)
      }, [
        C($, {
          name: "Maximize2",
          size: 13
        }),
        u("span", Ive, E(i.value[s.value].label), 1)
      ], 10, Cve),
      o.value ? (g(), b("div", {
        key: 0,
        class: "sv-pop is-narrow",
        role: "listbox",
        "aria-label": "Size",
        onKeydown: c[1] || (c[1] = tn(Te((h) => o.value = !1, ["stop"]), ["esc"]))
      }, [
        c[2] || (c[2] = u("div", { class: "sv-pop-title" }, "Size", -1)),
        u("div", Ave, [
          (g(!0), b(j, null, ge(i.value, (h, f) => (g(), b("button", {
            key: h.label,
            class: G(["sv-pop-row", { on: f === s.value }]),
            role: "option",
            "aria-selected": f === s.value,
            "data-testid": "studio-edit-size-" + f,
            onClick: (p) => a(f)
          }, [
            u("span", Eve, E(h.label), 1),
            h.meta ? (g(), b("span", Rve, E(h.meta), 1)) : z("", !0)
          ], 10, Pve))), 128))
        ])
      ], 32)) : z("", !0)
    ], 512)) : z("", !0);
  }
}), $ve = {
  key: "tool",
  class: "ed-bar-tool",
  "data-testid": "studio-edit-bar-tool"
}, Dve = { class: "ed-bar-tool-head" }, Ove = { class: "ic" }, Lve = { class: "st" }, Bve = ["disabled"], Fve = {
  key: "bar",
  class: "ed-bar-main ed-card"
}, Nve = { class: "up-side ed-side" }, Uve = ["disabled", "title", "aria-pressed"], Gve = { class: "ed-col" }, jve = ["placeholder", "disabled", "readonly"], Hve = { class: "ed-bar-modes" }, Vve = {
  class: "ed-modes",
  role: "radiogroup",
  "aria-label": "Mode"
}, Wve = ["aria-checked", "title", "data-testid", "onClick"], qve = ["aria-expanded"], Kve = {
  key: 1,
  class: "up-note",
  title: "Your annotations and notes on the picture go with the edit (N to change them)",
  "data-testid": "studio-edit-sending"
}, Yve = 48, Xve = 160, Jve = /* @__PURE__ */ Pe({
  __name: "EditBar",
  setup(n) {
    const e = yt(), t = e.s, i = e.tools, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = [
      { id: "edit", label: "Edit", key: "M", tip: "Say what to change; select an area to keep the change inside it" },
      { id: "erase", label: "Erase", key: "X", tip: "Paint over what should go; no words needed" },
      { id: "annotate", label: "Annotate", key: "N", tip: "Draw, label and pin notes to show the model what to change" }
    ], a = I(() => sx(i.t.open)), l = I(() => e.stage.value), d = I(() => !!l.value && l.value.status === "done"), c = I(() => e.barKind()), h = I(() => t.bar === "erase"), f = I(() => c.value === "erase"), p = I(() => e.takesRefs()), y = I({
      get: () => e.askOf(t.stageId),
      set: (Q) => {
        t.stageId && e.setAsk(t.stageId, Q);
      }
    }), v = I(() => t.bar !== "annotate" && e.hasArea()), x = I(() => e.carried(l.value)), w = I(() => {
      const Q = x.value;
      return [Q.marks ? Q.marks + (Q.marks === 1 ? " annotation" : " annotations") : "", Q.comments ? Q.comments + (Q.comments === 1 ? " note" : " notes") : ""].filter(Boolean).join(", ");
    }), S = I(() => w.value && t.bar !== "annotate" && !f.value ? w.value + (x.value.marks + x.value.comments === 1 ? " goes with it" : " go with it") : ""), M = I(() => v.value && !h.value), _ = I(() => e.modelOf(c.value)), T = I(() => e.fullTakesOver(c.value)), k = I(() => d.value ? e.barProblem() : "Pick an image to edit first"), P = I(() => !!t.fullOpen[c.value] && e.fullShown(c.value)), A = /* @__PURE__ */ W(!1), R = I(() => !f.value && e.advancedOf(c.value).length > 0), D = Ze().board, O = tx({
      board: D,
      field: "edit",
      sessionId: () => e.sessionId,
      value: () => y.value,
      write: (Q) => {
        y.value = Q;
      }
    }), F = I(() => O.ghost.value ? O.ghost.value : h.value ? f.value ? "Erase takes no words: paint over what should go" : "Paint over what should go, and say what belongs there instead (optional)" : t.bar === "annotate" ? w.value ? "Anything else to change? The annotations and notes go with it" : "Annotate the picture, or say what to change" : v.value ? "Say what to change in the area" : "Say what to change, or select an area on the picture to keep the change there"), ie = I(() => {
      const Q = _.value, ne = Q ? qy(Q) : null;
      return ne ? [ne.key] : [];
    }), ee = I(() => p.value ? "Pick a reference from history (I)" : h.value ? "Erase takes no references" : "This model takes one picture: the one you're editing");
    function me() {
      const Q = s.value;
      Q && (Q.style.height = "0px", Q.style.height = Math.min(Xve, Math.max(Yve, Q.scrollHeight)) + "px");
    }
    Ee(y, () => nt(me)), Ee(a, (Q) => {
      Q || nt(me);
    }), it(me);
    function L() {
      t.sending || e.generateEdit();
    }
    function N(Q) {
      t.sending || e.generateEdit(Q);
    }
    function K(Q) {
      Q.key === "Enter" && bn(Q) && (Q.preventDefault(), o.value && o.value.tryRun());
    }
    const B = /* @__PURE__ */ W(!1);
    function re(Q) {
      a.value || !JI(Q) || (Q.preventDefault(), Q.dataTransfer && (Q.dataTransfer.dropEffect = p.value ? "copy" : "none"), B.value = p.value);
    }
    function H(Q) {
      const ne = Q.relatedTarget;
      (!ne || !Q.currentTarget.contains(ne)) && (B.value = !1);
    }
    function J(Q) {
      const ne = ZI(Q);
      B.value = !1, Lf(), !(!ne || a.value) && (Q.preventDefault(), Q.stopPropagation(), e.addEditRef(ne));
    }
    return (Q, ne) => (g(), b("div", {
      class: G(["sv-dock ed-bar", { "is-tool": !!a.value, "is-over": B.value }]),
      "data-testid": "studio-edit-bar",
      onDragover: re,
      onDragleave: H,
      onDrop: J
    }, [
      C(vt, { name: "sv-note" }, {
        default: Xe(() => [
          m(t).note ? (g(), b("div", {
            key: m(t).note.id,
            class: "sv-note",
            role: "status"
          }, E(m(t).note.text), 1)) : z("", !0)
        ]),
        _: 1
      }),
      C(Obe, null, {
        default: Xe(() => [
          C(vt, { name: "ed-swap" }, {
            default: Xe(() => [
              a.value ? (g(), b("div", $ve, [
                u("div", Dve, [
                  u("span", Ove, [
                    C($, {
                      name: a.value.icon,
                      size: 15
                    }, null, 8, ["name"])
                  ]),
                  u("b", null, E(a.value.label), 1),
                  ne[6] || (ne[6] = u("span", { class: "dot" }, "·", -1)),
                  u("span", Lve, [
                    m(i).t.busy ? (g(), b(j, { key: 0 }, [
                      C($, {
                        name: "Loader2",
                        size: 12,
                        spin: ""
                      }),
                      Y(" " + E(m(i).t.busy), 1)
                    ], 64)) : m(i).pending() ? (g(), b(j, { key: 1 }, [
                      Y("Not applied yet")
                    ], 64)) : (g(), b(j, { key: 2 }, [
                      Y(E(a.value.hint), 1)
                    ], 64))
                  ]),
                  ne[7] || (ne[7] = u("span", { class: "grow" }, null, -1)),
                  u("button", {
                    class: "ed-bar-close",
                    "data-testid": "studio-tool-close",
                    title: "Back to the bar (Esc)",
                    disabled: !!m(i).t.busy,
                    onClick: ne[0] || (ne[0] = (ue) => m(i).close())
                  }, [
                    ne[5] || (ne[5] = Y(" Close ", -1)),
                    C($, {
                      name: "X",
                      size: 13
                    })
                  ], 8, Bve)
                ]),
                ne[8] || (ne[8] = u("div", {
                  id: "studio-bar-go",
                  class: "ed-bar-go",
                  "data-testid": "studio-bar-go"
                }, null, -1))
              ])) : (g(), b("div", Fve, [
                u("div", Nve, [
                  u("button", {
                    class: G(["up-side-btn", { on: m(t).dropper }]),
                    disabled: !p.value,
                    title: ee.value,
                    "aria-label": "Pick a reference from history",
                    "aria-pressed": m(t).dropper,
                    "data-testid": "studio-eyedropper",
                    onClick: ne[1] || (ne[1] = (ue) => m(e).setDropper(!m(t).dropper))
                  }, [
                    C($, {
                      name: "Pipette",
                      size: 15
                    })
                  ], 10, Uve)
                ]),
                u("div", Gve, [
                  C(vt, { name: "ed-fold" }, {
                    default: Xe(() => [
                      p.value ? (g(), Ie(bve, {
                        key: 0,
                        over: B.value
                      }, null, 8, ["over"])) : z("", !0)
                    ]),
                    _: 1
                  }),
                  _t(u("textarea", {
                    ref_key: "text",
                    ref: s,
                    "onUpdate:modelValue": ne[2] || (ne[2] = (ue) => y.value = ue),
                    class: G(["up-text ed-words", { "is-tour-ghost": !!m(O).ghost.value, "is-typing": m(O).typing.value }]),
                    spellcheck: "false",
                    placeholder: F.value,
                    disabled: !d.value || f.value,
                    readonly: m(O).held.value || m(O).typing.value,
                    "data-testid": "studio-edit-prompt",
                    onInput: me,
                    onKeydown: K
                  }, null, 42, jve), [
                    [Zt, y.value]
                  ]),
                  m(O).ghost.value ? (g(), b("button", {
                    key: 0,
                    type: "button",
                    tabindex: "-1",
                    class: "up-cue is-tour ed-tour-cue",
                    "data-testid": "studio-ghost-cue",
                    onClick: ne[3] || (ne[3] = (ue) => m(D).tour && m(D).tour.press && m(D).tour.press("edit"))
                  }, [...ne[9] || (ne[9] = [
                    u("kbd", null, "Tab", -1),
                    Y(" to write it in", -1)
                  ])])) : z("", !0),
                  u("div", Hve, [
                    u("div", Vve, [
                      (g(), b(j, null, ge(r, (ue) => u("button", {
                        key: ue.id,
                        class: G(["ed-mode", { on: m(t).bar === ue.id }]),
                        role: "radio",
                        "aria-checked": m(t).bar === ue.id,
                        title: ue.label + " (" + ue.key + `)
` + ue.tip,
                        "data-testid": "studio-mode-" + ue.id,
                        onClick: (Z) => m(e).setBar(ue.id)
                      }, [
                        C(_m, {
                          on: m(t).bar === ue.id
                        }, null, 8, ["on"]),
                        u("span", null, E(ue.label), 1)
                      ], 10, Wve)), 64))
                    ]),
                    ne[10] || (ne[10] = u("span", { class: "sv-sep" }, null, -1)),
                    C(vt, {
                      name: "ed-fade",
                      mode: "out-in"
                    }, {
                      default: Xe(() => [
                        m(t).bar === "annotate" ? (g(), Ie(dve, { key: "marks" })) : (g(), Ie(Vbe, { key: "area" }))
                      ]),
                      _: 1
                    })
                  ]),
                  C(fa, { open: P.value }, {
                    default: Xe(() => [
                      C(ux, {
                        kind: c.value,
                        onRun: N
                      }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  C(fa, {
                    open: A.value && R.value
                  }, {
                    default: Xe(() => [
                      C(px, {
                        kind: c.value,
                        part: "more"
                      }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  C(nA, {
                    ref_key: "foot",
                    ref: o,
                    kind: c.value,
                    own: k.value,
                    resting: T.value,
                    fixed: f.value,
                    "fixed-title": _.value ? _.value.name + " removes what you paint and fills in behind it" : "",
                    most: h.value ? 1 : null,
                    hide: ie.value,
                    "run-testid": "studio-edit-generate",
                    "count-testid": "studio-edit-count",
                    onRun: L
                  }, {
                    chips: Xe(() => [
                      f.value ? z("", !0) : (g(), Ie(zve, {
                        key: 0,
                        kind: c.value
                      }, null, 8, ["kind"])),
                      R.value ? (g(), b("button", {
                        key: 1,
                        class: G(["up-chip", { on: A.value }]),
                        "aria-expanded": A.value,
                        title: "More settings",
                        "data-testid": "studio-edit-more-toggle",
                        onClick: ne[4] || (ne[4] = (ue) => A.value = !A.value)
                      }, [
                        C($, {
                          name: "Settings2",
                          size: 13
                        }),
                        ne[11] || (ne[11] = u("span", { class: "t" }, "More", -1))
                      ], 10, qve)) : z("", !0),
                      M.value || S.value ? (g(), b(j, { key: 2 }, [
                        ne[12] || (ne[12] = u("span", { class: "up-foot-sep" }, null, -1)),
                        M.value ? (g(), Ie(Tve, { key: 0 })) : z("", !0),
                        S.value ? (g(), b("span", Kve, [
                          C($, {
                            name: "Pencil",
                            size: 12
                          }),
                          Y(E(S.value), 1)
                        ])) : z("", !0)
                      ], 64)) : z("", !0)
                    ]),
                    aside: Xe(() => [
                      C(hx, { kind: c.value }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["kind", "own", "resting", "fixed", "fixed-title", "most", "hide"])
                ])
              ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 34));
  }
}), Zve = { class: "ed-panel" }, Qve = {
  class: "ed-modes-x",
  role: "radiogroup",
  "aria-label": "What the bar does"
}, e0e = ["aria-checked", "data-testid", "onClick"], t0e = { class: "hd" }, n0e = { class: "ln" }, i0e = /* @__PURE__ */ Pe({
  __name: "PromptPanel",
  setup(n) {
    const e = yt(), t = e.s, i = [
      { id: "edit", label: "Edit", key: "M", line: "Say what to change. Paint an area to keep the change inside it: Precision keeps every pixel outside it." },
      { id: "erase", label: "Erase", key: "X", line: "Paint over what should go and press Run: no words. In a busy scene, use Edit with an area and say what belongs there." },
      { id: "annotate", label: "Annotate", key: "N", line: "Draw, label and pin numbered notes to show what to change. No area: the model may change the whole picture." }
    ];
    return (s, o) => (g(), b("div", Zve, [
      u("div", Qve, [
        (g(), b(j, null, ge(i, (r) => u("button", {
          key: r.id,
          type: "button",
          role: "radio",
          class: G(["ed-mode-x", { on: m(t).bar === r.id }]),
          "aria-checked": m(t).bar === r.id,
          "data-testid": "mode-explain-" + r.id,
          onClick: (a) => m(e).setBar(r.id)
        }, [
          u("span", t0e, [
            u("b", null, E(r.label), 1),
            u("kbd", null, E(r.key), 1)
          ]),
          u("span", n0e, E(r.line), 1)
        ], 10, e0e)), 64))
      ])
    ]));
  }
}), s0e = { class: "ed-bar-go-in" }, ou = /* @__PURE__ */ Pe({
  __name: "BarGo",
  setup(n) {
    return (e, t) => (g(), Ie(y1, {
      defer: "",
      to: "#studio-bar-go"
    }, [
      u("div", s0e, [
        Ss(e.$slots, "default")
      ])
    ]));
  }
}), o0e = { class: "ed-go is-bar" }, r0e = { class: "ed-go-line" }, a0e = ["title"], l0e = { class: "nm" }, d0e = {
  key: 3,
  class: "ed-model-none"
}, c0e = ["title"], u0e = {
  key: 5,
  class: "ed-go-full"
}, h0e = ["title"], p0e = ["disabled", "title", "data-testid"], f0e = { class: "lb" }, Yo = /* @__PURE__ */ Pe({
  __name: "ToolGo",
  props: {
    kind: {},
    label: {},
    icon: { default: "Sparkles" },
    picker: { type: Boolean, default: !1 },
    why: { default: "" },
    many: { type: Boolean, default: !0 },
    showModel: { type: Boolean, default: !0 },
    testid: { default: void 0 }
  },
  setup(n) {
    const e = n, t = yt(), i = t.s, s = t.tools, o = I(() => t.modelsFor(e.kind)), r = I(() => t.modelOf(e.kind)), a = I(() => t.countOf(e.kind)), l = I(() => e.many ? t.maxCount(e.kind) : 1), d = I(() => r.value ? t.priceOf(e.kind) : ""), c = I(() => t.fullTakesOver(e.kind)), h = I(() => c.value ? KI : s.problem(e.kind)), f = I(() => h.value || (r.value ? t.problemOf(e.kind) : null)), p = I(() => !!i.fullOpen[e.kind] && t.fullShown(e.kind));
    function y() {
      i.sending || c.value || s.runTool(e.kind);
    }
    function v(x) {
      i.sending || s.runTool(e.kind, x);
    }
    return (x, w) => (g(), Ie(ou, null, {
      default: Xe(() => [
        u("div", o0e, [
          C(fa, { open: p.value }, {
            default: Xe(() => [
              C(ux, {
                kind: n.kind,
                class: "is-tool",
                onRun: v
              }, null, 8, ["kind"])
            ]),
            _: 1
          }, 8, ["open"]),
          u("div", r0e, [
            n.showModel ? n.picker && o.value.length > 1 ? (g(), Ie(tA, {
              key: 1,
              mode: n.kind,
              variant: "flat"
            }, null, 8, ["mode"])) : r.value ? (g(), b("span", {
              key: 2,
              class: "ed-model-fixed is-inline",
              title: n.why ? r.value.name + ": " + n.why : r.value.name
            }, [
              C($, {
                name: "Cpu",
                size: 13
              }),
              u("span", l0e, E(r.value.name), 1)
            ], 8, a0e)) : (g(), b("span", d0e, [
              C($, {
                name: "CloudOff",
                size: 13
              }),
              w[1] || (w[1] = Y(" Not available on this board yet", -1))
            ])) : (g(), b(j, { key: 0 }, [], 64)),
            r.value && d.value ? (g(), b("span", {
              key: 4,
              class: "ed-go-cost",
              title: "Token cost for this run" + (r.value.time ? ", about " + r.value.time : "")
            }, [
              C($, {
                name: "Tokens",
                size: 11
              }),
              Y(" " + E(d.value), 1)
            ], 8, c0e)) : z("", !0),
            r.value ? (g(), b("span", u0e, [
              C(hx, { kind: n.kind }, null, 8, ["kind"])
            ])) : z("", !0),
            w[2] || (w[2] = u("span", { class: "grow" }, null, -1)),
            f.value && !c.value ? (g(), b("span", {
              key: 6,
              class: "sv-problem is-inline",
              title: f.value
            }, [
              C($, {
                name: "AlertCircle",
                size: 12
              }),
              Y(" " + E(f.value.replace(/\.$/, "")), 1)
            ], 8, h0e)) : z("", !0),
            l.value > 1 ? (g(), Ie(ex, {
              key: 7,
              value: a.value,
              min: m(t).minCount(n.kind),
              max: l.value,
              onUpdate: w[0] || (w[0] = (S) => m(t).setCount(n.kind, S))
            }, null, 8, ["value", "min", "max"])) : z("", !0),
            u("button", {
              class: G(["sv-go ed-go-btn", { "is-busy": m(i).sending > 0, "is-blocked": !!f.value }]),
              disabled: !r.value || c.value,
              title: f.value || "",
              "data-testid": n.testid || "studio-tool-run-" + n.kind,
              onClick: y
            }, [
              C($, {
                name: m(i).sending ? "Loader2" : n.icon,
                size: 14,
                spin: m(i).sending > 0
              }, null, 8, ["name", "spin"]),
              u("span", f0e, E(m(i).sending ? "Sending" : n.label), 1)
            ], 10, p0e)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), m0e = { class: "ed-panel" }, g0e = {
  key: 0,
  class: "ed-info",
  "data-testid": "studio-upscale-size"
}, b0e = /* @__PURE__ */ Pe({
  __name: "UpscalePanel",
  setup(n) {
    const e = yt(), t = I(() => e.stage.value), i = I(() => {
      var o;
      const r = (o = e.valueOfKey("upscale", "scale")) != null ? o : e.valueOfKey("upscale", "factor"), a = typeof r == "number" ? r : typeof r == "string" ? parseFloat(r) : NaN;
      return Number.isFinite(a) && a > 0 ? a : null;
    }), s = I(() => {
      const o = t.value;
      if (!o || !i.value) return "";
      const r = ba(o.asset), a = r ? r.width : o.w, l = r ? r.height : o.h;
      return Math.round(a * i.value).toLocaleString() + " × " + Math.round(l * i.value).toLocaleString();
    });
    return (o, r) => (g(), b("div", m0e, [
      r[1] || (r[1] = u("p", { class: "ed-hint" }, "More pixels and finer detail. Each upscaler has its own look; its settings follow.", -1)),
      C(px, { kind: "upscale" }),
      s.value ? (g(), b("div", g0e, [
        r[0] || (r[0] = u("span", null, "Final size", -1)),
        u("b", null, E(s.value), 1)
      ])) : z("", !0),
      C(Yo, {
        kind: "upscale",
        label: "Upscale",
        icon: "Maximize2",
        many: !1,
        picker: ""
      })
    ]));
  }
}), v0e = { class: "ed-panel" }, y0e = ["aria-selected"], x0e = ["aria-selected"], w0e = {
  class: "ed-ratios",
  role: "radiogroup",
  "aria-label": "Shape"
}, k0e = ["aria-checked", "data-testid", "onClick"], _0e = ["aria-expanded"], S0e = { class: "ed-wh" }, M0e = ["value"], T0e = ["aria-pressed", "title"], C0e = ["value"], I0e = { class: "ed-acts is-bar" }, A0e = ["disabled"], P0e = ["disabled"], E0e = {
  class: "ed-ratios",
  role: "radiogroup",
  "aria-label": "Frame shape"
}, R0e = ["aria-checked", "data-testid", "onClick"], z0e = ["aria-expanded"], $0e = {
  key: 0,
  class: "ed-info"
}, D0e = {
  key: 1,
  class: "sv-warn"
}, O0e = { class: "ed-field" }, L0e = { class: "ed-acts is-tight" }, B0e = ["disabled"], F0e = ["disabled"], N0e = /* @__PURE__ */ Pe({
  __name: "ResizePanel",
  setup(n) {
    const e = yt(), t = e.tools, i = I(() => t.t.resize), s = I(() => e.stage.value), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(!0), a = I(() => P0.filter((M) => !M.more || o.value || M.id === i.value.ratio)), l = I(() => P0.filter((M) => M.id !== "original" && (!M.more || o.value || M.id === i.value.frameRatio))), d = I(() => t.cropPixels()), c = I(() => t.frame()), h = I(() => {
      const M = s.value, _ = c.value;
      return M && _ ? Math.round(_.iw / M.w * 100) : 100;
    }), f = I(() => !!c.value && The(c.value) < Mhe);
    function p(M) {
      const _ = s.value, T = Mc(M, _ ? _.w : 4, _ ? _.h : 3), k = T == null ? 1.25 : T;
      return k >= 1 ? { w: 22, h: Math.max(6, Math.round(22 / k)) } : { w: Math.max(6, Math.round(22 * k)), h: 22 };
    }
    function y(M) {
      i.value.mode !== M && t.leave(() => {
        t.t.resize.mode = M, t.t.open = "resize", t.readyExpand();
      });
    }
    function v(M) {
      const _ = s.value;
      if (!_ || !Number.isFinite(M) || M < 8) return;
      const T = r.value ? M / Math.max(1, d.value.w) : 1;
      t.setCrop(q_(i.value.crop, M, r.value ? d.value.h * T : d.value.h, _.w, _.h)), r.value || (t.t.resize.ratio = "free");
    }
    function x(M) {
      const _ = s.value;
      if (!_ || !Number.isFinite(M) || M < 8) return;
      const T = r.value ? M / Math.max(1, d.value.h) : 1;
      t.setCrop(q_(i.value.crop, r.value ? d.value.w * T : d.value.w, M, _.w, _.h)), r.value || (t.t.resize.ratio = "free");
    }
    function w(M) {
      const _ = s.value, T = c.value;
      !_ || !T || t.setFrame(Phe(T, _.w, _.h, M / 100));
    }
    function S() {
      const M = s.value;
      M && (t.t.resize.frame = null, t.t.resize.frameRatio = "free", t.setFrame(LI(M.w, M.h)));
    }
    return (M, _) => (g(), b("div", v0e, [
      u("div", {
        class: "sv-seg is-text ed-tabs ed-slide",
        role: "tablist",
        "aria-label": "Crop or expand",
        style: ce({ "--i": i.value.mode === "expand" ? 1 : 0, "--n": 2 })
      }, [
        u("button", {
          role: "tab",
          "aria-selected": i.value.mode === "crop",
          class: G({ on: i.value.mode === "crop" }),
          "data-testid": "studio-resize-crop",
          onClick: _[0] || (_[0] = (T) => y("crop"))
        }, [
          C($, {
            name: "Crop",
            size: 13
          }),
          _[11] || (_[11] = Y(" Crop", -1))
        ], 10, y0e),
        u("button", {
          role: "tab",
          "aria-selected": i.value.mode === "expand",
          class: G({ on: i.value.mode === "expand" }),
          "data-testid": "studio-resize-expand",
          onClick: _[1] || (_[1] = (T) => y("expand"))
        }, [
          C($, {
            name: "Expand",
            size: 13
          }),
          _[12] || (_[12] = Y(" Expand", -1))
        ], 10, x0e)
      ], 4),
      i.value.mode === "crop" ? (g(), b(j, { key: 0 }, [
        _[17] || (_[17] = u("p", { class: "ed-hint" }, "Drag the frame's edges and corners on the picture, or pick a shape. The crop is made at full size.", -1)),
        u("div", w0e, [
          (g(!0), b(j, null, ge(a.value, (T) => (g(), b("button", {
            key: T.id,
            role: "radio",
            "aria-checked": i.value.ratio === T.id,
            class: G(["ed-ratio", { on: i.value.ratio === T.id }]),
            "data-testid": "studio-crop-ratio-" + T.id,
            onClick: (k) => m(t).setRatio(T.id)
          }, [
            u("i", {
              class: G({ free: T.id === "free" }),
              style: ce({ width: p(T.id).w + "px", height: p(T.id).h + "px" })
            }, null, 6),
            u("span", null, E(T.label), 1)
          ], 10, k0e))), 128)),
          u("button", {
            class: "ed-ratio is-more",
            "aria-expanded": o.value,
            onClick: _[2] || (_[2] = (T) => o.value = !o.value)
          }, [
            C($, {
              name: o.value ? "ChevronUp" : "Ellipsis",
              size: 14
            }, null, 8, ["name"]),
            u("span", null, E(o.value ? "Fewer" : "More"), 1)
          ], 8, _0e)
        ]),
        u("div", S0e, [
          u("label", null, [
            _[13] || (_[13] = u("span", null, "W", -1)),
            u("input", {
              type: "number",
              min: "8",
              value: d.value.w,
              "data-testid": "studio-crop-w",
              onChange: _[3] || (_[3] = (T) => v(+T.target.value))
            }, null, 40, M0e)
          ]),
          u("button", {
            class: G(["ed-lock", { on: r.value }]),
            "aria-pressed": r.value,
            title: r.value ? "Keep the shape" : "Width and height apart",
            onClick: _[4] || (_[4] = (T) => r.value = !r.value)
          }, [
            C($, {
              name: r.value ? "Lock" : "LockOpen",
              size: 12
            }, null, 8, ["name"])
          ], 10, T0e),
          u("label", null, [
            _[14] || (_[14] = u("span", null, "H", -1)),
            u("input", {
              type: "number",
              min: "8",
              value: d.value.h,
              "data-testid": "studio-crop-h",
              onChange: _[5] || (_[5] = (T) => x(+T.target.value))
            }, null, 40, C0e)
          ]),
          _[15] || (_[15] = u("span", { class: "u" }, "px", -1))
        ]),
        C(ou, null, {
          default: Xe(() => [
            u("div", I0e, [
              _[16] || (_[16] = u("span", { class: "grow" }, null, -1)),
              u("button", {
                class: "sv-btn",
                disabled: !m(t).pending("resize"),
                onClick: _[6] || (_[6] = (T) => m(t).reset("resize"))
              }, "Reset", 8, A0e),
              u("button", {
                class: "sv-btn is-primary ed-apply",
                disabled: !m(t).pending("resize") || !!m(t).t.busy,
                "data-testid": "studio-crop-apply",
                onClick: _[7] || (_[7] = (T) => m(t).apply("resize"))
              }, [
                C($, {
                  name: m(t).t.busy ? "Loader2" : "Crop",
                  size: 14,
                  spin: !!m(t).t.busy
                }, null, 8, ["name", "spin"]),
                Y(" " + E(m(t).t.busy ? "Cropping" : "Crop"), 1)
              ], 8, P0e)
            ])
          ]),
          _: 1
        })
      ], 64)) : (g(), b(j, { key: 1 }, [
        _[22] || (_[22] = u("p", { class: "ed-hint" }, "Pull the frame past the picture's edges in the viewer, or pick a shape; drag the picture to place it. The new area is painted to match.", -1)),
        u("div", E0e, [
          (g(!0), b(j, null, ge(l.value, (T) => (g(), b("button", {
            key: T.id,
            role: "radio",
            "aria-checked": i.value.frameRatio === T.id,
            class: G(["ed-ratio", { on: i.value.frameRatio === T.id }]),
            "data-testid": "studio-expand-ratio-" + T.id,
            onClick: (k) => m(t).setFrameRatio(T.id)
          }, [
            u("i", {
              class: G({ free: T.id === "free" }),
              style: ce({ width: p(T.id).w + "px", height: p(T.id).h + "px" })
            }, null, 6),
            u("span", null, E(T.label), 1)
          ], 10, R0e))), 128)),
          u("button", {
            class: "ed-ratio is-more",
            "aria-expanded": o.value,
            onClick: _[8] || (_[8] = (T) => o.value = !o.value)
          }, [
            C($, {
              name: o.value ? "ChevronUp" : "Ellipsis",
              size: 14
            }, null, 8, ["name"]),
            u("span", null, E(o.value ? "Fewer" : "More"), 1)
          ], 8, z0e)
        ]),
        C(Ct, {
          label: "Picture size",
          "model-value": h.value,
          min: 30,
          max: 100,
          start: 100,
          format: (T) => T + "%",
          "onUpdate:modelValue": w
        }, null, 8, ["model-value", "format"]),
        c.value ? (g(), b("div", $0e, [
          _[18] || (_[18] = u("span", null, "New size", -1)),
          u("b", null, E(Math.round(c.value.cw)) + " × " + E(Math.round(c.value.ch)), 1)
        ])) : z("", !0),
        f.value ? (g(), b("div", D0e, [
          C($, {
            name: "AlertCircle",
            size: 12
          }),
          _[19] || (_[19] = u("span", null, "The picture is small in this frame; the expand is best when it covers at least a sixth.", -1))
        ])) : z("", !0),
        u("label", O0e, [
          _[20] || (_[20] = u("span", { class: "ed-field-lb" }, "What to add (optional)", -1)),
          _t(u("textarea", {
            "onUpdate:modelValue": _[9] || (_[9] = (T) => m(t).t.resize.words = T),
            class: "ed-text",
            rows: "2",
            placeholder: "More sky, the street continuing, the lawn and planting",
            spellcheck: "false",
            "data-testid": "studio-expand-words"
          }, null, 512), [
            [Zt, m(t).t.resize.words]
          ])
        ]),
        u("div", L0e, [
          u("button", {
            class: "sv-btn",
            disabled: !c.value || !m(R0)(c.value),
            onClick: S
          }, "Reset", 8, B0e),
          u("button", {
            class: "sv-btn",
            disabled: !c.value,
            title: "Centre the picture in the frame",
            onClick: _[10] || (_[10] = (T) => c.value && m(t).setFrame(m(Ehe)(c.value)))
          }, [
            C($, {
              name: "LocateFixed",
              size: 13
            }),
            _[21] || (_[21] = Y(" Centre", -1))
          ], 8, F0e)
        ]),
        C(Yo, {
          kind: "expand",
          label: "Expand",
          icon: "Expand",
          many: !1,
          why: "Bria Expand paints the new area to match",
          picker: ""
        })
      ], 64))
    ]));
  }
}), U0e = { class: "ed-refpick" }, G0e = { class: "ed-field-lb" }, j0e = ["aria-label"], H0e = ["aria-checked", "title", "onClick"], V0e = {
  key: 1,
  class: "ed-hint is-quiet"
}, iA = /* @__PURE__ */ Pe({
  __name: "RefPick",
  props: {
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = yt(), o = I(() => s.items.value.filter((a) => a.status === "done" && a.id !== s.s.stageId).slice(0, 12));
    function r(a) {
      i("update:modelValue", t.modelValue === a ? null : a);
    }
    return (a, l) => (g(), b("div", U0e, [
      u("span", G0e, E(n.label), 1),
      o.value.length ? (g(), b("div", {
        key: 0,
        class: "ed-refpick-row",
        role: "radiogroup",
        "aria-label": n.label
      }, [
        (g(!0), b(j, null, ge(o.value, (d) => (g(), b("button", {
          key: d.id,
          class: G(["ed-refpick-cell", { on: n.modelValue === d.id }]),
          role: "radio",
          "aria-checked": n.modelValue === d.id,
          title: d.label,
          "data-testid": "studio-refpick",
          onClick: (c) => r(d.id)
        }, [
          C(ao, { item: d }, null, 8, ["item"])
        ], 10, H0e))), 128))
      ], 8, j0e)) : (g(), b("span", V0e, "Bring a picture into history first (drop one on the view)."))
    ]));
  }
}), W0e = { class: "ed-panel" }, q0e = ["aria-selected"], K0e = ["aria-selected"], Y0e = ["aria-selected"], X0e = {
  class: "ed-fills",
  role: "radiogroup",
  "aria-label": "Fill"
}, J0e = ["aria-checked"], Z0e = ["aria-checked", "title", "data-testid", "onClick"], Q0e = ["value"], e1e = { class: "ed-acts is-bar" }, t1e = ["disabled"], n1e = ["disabled"], i1e = { class: "ed-field" }, s1e = ["aria-checked"], o1e = ["aria-checked"], r1e = { class: "ed-acts is-bar" }, a1e = ["disabled"], l1e = ["disabled"], d1e = /* @__PURE__ */ Pe({
  __name: "BackgroundPanel",
  setup(n) {
    const e = yt(), t = e.tools, i = I(() => t.t.background), s = I(() => e.stage.value), o = I(() => t.isCutout(s.value)), r = I(() => t.cutoutFor(s.value)), a = I(() => typeof i.value.fill == "string" && !i4.includes(i.value.fill));
    function l(d) {
      i.value.mode !== d && t.leave(() => {
        t.t.background.mode = d, t.t.open = "background";
      });
    }
    return (d, c) => (g(), b("div", W0e, [
      u("div", {
        class: "sv-seg is-text ed-tabs is-three ed-slide",
        role: "tablist",
        "aria-label": "Background",
        style: ce({ "--i": ["remove", "replace", "adjust"].indexOf(i.value.mode), "--n": 3 })
      }, [
        u("button", {
          role: "tab",
          "aria-selected": i.value.mode === "remove",
          class: G({ on: i.value.mode === "remove" }),
          "data-testid": "studio-bg-remove",
          onClick: c[0] || (c[0] = (h) => l("remove"))
        }, "Remove", 10, q0e),
        u("button", {
          role: "tab",
          "aria-selected": i.value.mode === "replace",
          class: G({ on: i.value.mode === "replace" }),
          "data-testid": "studio-bg-replace",
          onClick: c[1] || (c[1] = (h) => l("replace"))
        }, "Replace", 10, K0e),
        u("button", {
          role: "tab",
          "aria-selected": i.value.mode === "adjust",
          class: G({ on: i.value.mode === "adjust" }),
          "data-testid": "studio-bg-adjust",
          onClick: c[2] || (c[2] = (h) => l("adjust"))
        }, "Adjust", 10, Y0e)
      ], 4),
      i.value.mode === "remove" ? (g(), b(j, { key: 0 }, [
        o.value ? (g(), b(j, { key: 1 }, [
          c[21] || (c[21] = u("p", { class: "ed-hint" }, "The background is clear. Fill it, or keep it see-through.", -1)),
          u("div", X0e, [
            u("button", {
              class: G(["ed-fill is-clear", { on: i.value.fill === null }]),
              role: "radio",
              "aria-checked": i.value.fill === null,
              title: "See-through",
              "data-testid": "studio-fill-clear",
              onClick: c[3] || (c[3] = (h) => m(t).setFill(null))
            }, null, 10, J0e),
            (g(!0), b(j, null, ge(m(i4), (h) => (g(), b("button", {
              key: h,
              class: G(["ed-fill", { on: i.value.fill === h }]),
              role: "radio",
              "aria-checked": i.value.fill === h,
              style: ce({ "--c": h }),
              title: h,
              "data-testid": "studio-fill-" + h.slice(1),
              onClick: (f) => m(t).setFill(h)
            }, null, 14, Z0e))), 128)),
            u("label", {
              class: G(["ed-fill is-any", { on: a.value }]),
              style: ce(a.value ? { "--c": i.value.fill } : void 0),
              title: "Any colour"
            }, [
              u("input", {
                type: "color",
                value: typeof i.value.fill == "string" ? i.value.fill : "#ffffff",
                onInput: c[4] || (c[4] = (h) => m(t).setFill(h.target.value))
              }, null, 40, Q0e)
            ], 6)
          ]),
          C(ou, null, {
            default: Xe(() => [
              u("div", e1e, [
                c[20] || (c[20] = u("span", { class: "grow" }, null, -1)),
                u("button", {
                  class: "sv-btn",
                  disabled: i.value.fill === void 0,
                  onClick: c[5] || (c[5] = (h) => m(t).setFill(void 0))
                }, "Reset", 8, t1e),
                u("button", {
                  class: "sv-btn is-primary ed-apply",
                  disabled: i.value.fill === void 0 || !!m(t).t.busy,
                  "data-testid": "studio-fill-apply",
                  onClick: c[6] || (c[6] = (h) => m(t).apply("background"))
                }, [
                  C($, {
                    name: m(t).t.busy ? "Loader2" : "PaintBucket",
                    size: 14,
                    spin: !!m(t).t.busy
                  }, null, 8, ["name", "spin"]),
                  Y(" " + E(m(t).t.busy ? "Filling" : "Fill"), 1)
                ], 8, n1e)
              ])
            ]),
            _: 1
          })
        ], 64)) : (g(), b(j, { key: 0 }, [
          c[19] || (c[19] = u("p", { class: "ed-hint" }, "Cuts the subject out, leaving the background see-through. Then fill it with a colour, or keep it clear.", -1)),
          C(Yo, {
            kind: "removebg",
            label: "Remove background",
            icon: "Scan",
            many: !1,
            why: "Clean edges, hair and fine detail included"
          })
        ], 64))
      ], 64)) : i.value.mode === "replace" ? (g(), b(j, { key: 1 }, [
        c[23] || (c[23] = u("p", { class: "ed-hint" }, "Describe what should be behind the subject, or pick a picture of it. The model keeps the subject as close to the original as it can.", -1)),
        u("label", i1e, [
          c[22] || (c[22] = u("span", { class: "ed-field-lb" }, "The new background", -1)),
          _t(u("textarea", {
            "onUpdate:modelValue": c[7] || (c[7] = (h) => m(t).t.background.words = h),
            class: "ed-text",
            rows: "3",
            placeholder: "A clear sky with soft clouds over a quiet street",
            spellcheck: "false",
            "data-testid": "studio-replace-words"
          }, null, 512), [
            [Zt, m(t).t.background.words]
          ])
        ]),
        C(iA, {
          modelValue: m(t).t.background.refId,
          "onUpdate:modelValue": c[8] || (c[8] = (h) => m(t).t.background.refId = h),
          label: "A picture of it (optional)"
        }, null, 8, ["modelValue"]),
        C(Yo, {
          kind: "replacebg",
          label: "Replace",
          icon: "Replace",
          picker: ""
        })
      ], 64)) : (g(), b(j, { key: 2 }, [
        r.value ? (g(), b(j, { key: 1 }, [
          u("div", {
            class: "sv-seg is-small ed-pills ed-slide",
            role: "radiogroup",
            "aria-label": "Adjust",
            style: ce({ "--i": i.value.layer.target === "subject" ? 1 : 0, "--n": 2 })
          }, [
            u("button", {
              role: "radio",
              "aria-checked": i.value.layer.target === "background",
              class: G({ on: i.value.layer.target === "background" }),
              onClick: c[9] || (c[9] = (h) => m(t).setLayer({ target: "background" }))
            }, "Background", 10, s1e),
            u("button", {
              role: "radio",
              "aria-checked": i.value.layer.target === "subject",
              class: G({ on: i.value.layer.target === "subject" }),
              onClick: c[10] || (c[10] = (h) => m(t).setLayer({ target: "subject" }))
            }, "Subject", 10, o1e)
          ], 4),
          C(Ct, {
            label: "Blur",
            "model-value": i.value.layer.blur,
            min: 0,
            max: 40,
            start: 0,
            format: (h) => h + " px",
            testid: "studio-layer-blur",
            "onUpdate:modelValue": c[11] || (c[11] = (h) => m(t).setLayer({ blur: h }))
          }, null, 8, ["model-value", "format"]),
          C(Ct, {
            label: "Grayscale",
            "model-value": i.value.layer.grayscale,
            min: 0,
            max: 100,
            start: 0,
            "onUpdate:modelValue": c[12] || (c[12] = (h) => m(t).setLayer({ grayscale: h }))
          }, null, 8, ["model-value"]),
          C(Ct, {
            label: "Sepia",
            "model-value": i.value.layer.sepia,
            min: 0,
            max: 100,
            start: 0,
            "onUpdate:modelValue": c[13] || (c[13] = (h) => m(t).setLayer({ sepia: h }))
          }, null, 8, ["model-value"]),
          C(Ct, {
            label: "Brightness",
            "model-value": i.value.layer.brightness,
            min: 0,
            max: 200,
            start: 100,
            format: (h) => (h - 100 > 0 ? "+" : "") + (h - 100),
            "onUpdate:modelValue": c[14] || (c[14] = (h) => m(t).setLayer({ brightness: h }))
          }, null, 8, ["model-value", "format"]),
          C(Ct, {
            label: "Contrast",
            "model-value": i.value.layer.contrast,
            min: 0,
            max: 200,
            start: 100,
            format: (h) => (h - 100 > 0 ? "+" : "") + (h - 100),
            "onUpdate:modelValue": c[15] || (c[15] = (h) => m(t).setLayer({ contrast: h }))
          }, null, 8, ["model-value", "format"]),
          C(Ct, {
            label: "Saturation",
            "model-value": i.value.layer.saturation,
            min: 0,
            max: 200,
            start: 100,
            format: (h) => (h - 100 > 0 ? "+" : "") + (h - 100),
            "onUpdate:modelValue": c[16] || (c[16] = (h) => m(t).setLayer({ saturation: h }))
          }, null, 8, ["model-value", "format"]),
          C(ou, null, {
            default: Xe(() => [
              u("div", r1e, [
                c[25] || (c[25] = u("span", { class: "grow" }, null, -1)),
                u("button", {
                  class: "sv-btn",
                  disabled: !m(nu)(i.value.layer),
                  onClick: c[17] || (c[17] = (h) => m(t).reset("background"))
                }, "Reset", 8, a1e),
                u("button", {
                  class: "sv-btn is-primary ed-apply",
                  disabled: !m(nu)(i.value.layer) || !!m(t).t.busy,
                  "data-testid": "studio-layer-apply",
                  onClick: c[18] || (c[18] = (h) => m(t).apply("background"))
                }, [
                  C($, {
                    name: m(t).t.busy ? "Loader2" : "Check",
                    size: 14,
                    spin: !!m(t).t.busy
                  }, null, 8, ["name", "spin"]),
                  Y(" " + E(m(t).t.busy ? "Applying" : "Apply"), 1)
                ], 8, l1e)
              ])
            ]),
            _: 1
          })
        ], 64)) : (g(), b(j, { key: 0 }, [
          c[24] || (c[24] = u("p", { class: "ed-hint" }, "Adjusting the background apart from the subject needs a cut-out first: Remove background makes one.", -1)),
          C(Yo, {
            kind: "removebg",
            label: "Remove background",
            icon: "Scan",
            many: !1,
            why: "Its cut-out tells the subject from the background"
          })
        ], 64))
      ], 64))
    ]));
  }
}), c1e = { class: "ed-wheel" }, u1e = ["aria-label", "aria-valuenow", "aria-valuetext"], h1e = { class: "ed-wheel-lb" }, p1e = ["value", "aria-label"], $b = 30, Db = /* @__PURE__ */ Pe({
  __name: "ColorWheel",
  props: {
    label: {},
    wheel: {}
  },
  emits: ["change"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(null), o = I(() => {
      const d = (t.wheel.hue - 90) * Math.PI / 180, c = t.wheel.amount / 100 * $b;
      return { left: $b + Math.cos(d) * c + "px", top: $b + Math.sin(d) * c + "px" };
    });
    function r(d) {
      if (!s.value) return;
      const c = s.value.getBoundingClientRect(), h = d.clientX - c.left - c.width / 2, f = d.clientY - c.top - c.height / 2, p = Math.round(Math.min(1, Math.hypot(h, f) / (c.width / 2)) * 100), y = Math.round((Math.atan2(f, h) * 180 / Math.PI + 90 + 360) % 360);
      i("change", { ...t.wheel, hue: y, amount: p });
    }
    function a(d) {
      d.button === 0 && (d.currentTarget.setPointerCapture(d.pointerId), r(d));
    }
    function l(d) {
      d.currentTarget.hasPointerCapture(d.pointerId) && r(d);
    }
    return (d, c) => (g(), b("div", c1e, [
      u("div", {
        ref_key: "el",
        ref: s,
        class: "ed-wheel-disc",
        role: "slider",
        "aria-label": n.label + " tint",
        "aria-valuenow": n.wheel.amount,
        "aria-valuetext": n.wheel.amount ? n.wheel.hue + "°, " + n.wheel.amount + "%" : "none",
        tabindex: "0",
        onPointerdown: a,
        onPointermove: l,
        onDblclick: c[0] || (c[0] = (h) => i("change", { ...n.wheel, amount: 0 }))
      }, [
        u("i", {
          class: G(["ed-wheel-dot", { on: n.wheel.amount > 0 }]),
          style: ce(o.value)
        }, null, 6)
      ], 40, u1e),
      u("span", h1e, E(n.label), 1),
      u("input", {
        class: "ed-wheel-lum",
        type: "range",
        min: "-100",
        max: "100",
        value: n.wheel.lum,
        "aria-label": n.label + " brightness",
        onInput: c[1] || (c[1] = (h) => i("change", { ...n.wheel, lum: Number(h.target.value) })),
        onDblclick: c[2] || (c[2] = (h) => i("change", { ...n.wheel, lum: 0 }))
      }, null, 40, p1e)
    ]));
  }
}), f1e = { class: "ed-panel ed-adjust" }, m1e = { class: "ed-groups" }, g1e = { class: "ed-group-head" }, b1e = ["aria-expanded", "data-testid", "onClick"], v1e = { class: "t" }, y1e = {
  key: 0,
  class: "ed-changed"
}, x1e = ["title", "onClick"], w1e = { class: "ed-group-body" }, k1e = {
  key: 2,
  class: "ed-looks",
  role: "radiogroup",
  "aria-label": "Looks"
}, _1e = ["aria-checked", "data-testid", "onClick"], S1e = { class: "sw" }, M1e = { class: "nm" }, T1e = {
  key: 3,
  class: "ed-wheels"
}, C1e = { class: "ed-mix-pick" }, I1e = ["aria-pressed"], A1e = ["title"], P1e = {
  class: "ed-hint is-quiet",
  "data-testid": "studio-mixer-hint"
}, E1e = {
  class: "ed-bands",
  role: "radiogroup",
  "aria-label": "Colour"
}, R1e = ["aria-checked", "title", "aria-label", "onClick"], z1e = {
  class: "ed-refpick-row",
  role: "radiogroup",
  "aria-label": "Match to"
}, $1e = ["aria-checked", "title", "onClick"], D1e = { class: "tag" }, O1e = { class: "ed-overlay-row" }, L1e = ["value"], B1e = { class: "ed-select" }, F1e = ["value"], N1e = ["value"], U1e = { class: "ed-turns" }, G1e = { class: "ed-acts is-bar" }, j1e = ["disabled"], H1e = ["disabled"], V1e = ["disabled"], W1e = /* @__PURE__ */ Pe({
  __name: "AdjustPanel",
  setup(n) {
    const e = yt(), t = e.tools, i = I(() => t.t.adjust), s = I(() => i.value.a), o = I({
      get: () => i.value.band || "red",
      set: (T) => {
        t.t.adjust.band = T, t.t.adjust.picked = null;
      }
    }), r = I(() => i.value.picked || Vhe((Yi.find((T) => T.id === o.value) || Yi[0]).color)), a = I(() => Ghe(r.value, s.value.mixer)), l = I(() => (Yi.find((T) => T.id === o.value) || Yi[0]).label), d = I(() => !!i.value.picked && Hhe(i.value.picked) < 0.35), c = [
      { id: "light", label: "Light", icon: "Sun" },
      { id: "colour", label: "Colour", icon: "Palette" },
      { id: "looks", label: "Looks", icon: "Sparkle" },
      { id: "grading", label: "Colour grading", icon: "Contrast" },
      { id: "mixer", label: "Colour mixer", icon: "Rainbow" },
      { id: "match", label: "Match colours", icon: "Droplet" },
      { id: "overlay", label: "Overlay", icon: "Blend" },
      { id: "grain", label: "Grain", icon: "Film" },
      { id: "rotate", label: "Rotate", icon: "RotateCw" }
    ], h = I(() => i.value.group);
    function f(T) {
      t.t.adjust.group = i.value.group === T ? null : T;
    }
    function p(T) {
      const k = iu(s.value);
      T(k), k.look = null, t.setAdjust(k);
    }
    function y(T) {
      return T === "looks" ? !!s.value.look : kl(s.value, T);
    }
    function v(T) {
      if (T === "looks") {
        t.setAdjust(Y_(s.value, ""));
        return;
      }
      t.setAdjust($he(s.value, T));
    }
    const x = (T) => T > 0 ? "+" + T : String(T), w = (T) => (T > 0 ? "+" : "") + T + "°", S = I(() => {
      const T = e.family.value.filter((P) => P.status === "done" && P.id !== e.s.stageId), k = e.items.value.filter((P) => P.status === "done" && P.id !== e.s.stageId && !T.some((A) => A.id === P.id));
      return [...T, ...k].slice(0, 12);
    });
    function M(T) {
      return e.names.value.get(T) || "Picture";
    }
    const _ = I(() => $0(s.value));
    return (T, k) => (g(), b("div", f1e, [
      u("div", m1e, [
        (g(), b(j, null, ge(c, (P) => u("section", {
          key: P.id,
          class: G(["ed-group", { on: h.value === P.id, "is-changed": y(P.id) }])
        }, [
          u("div", g1e, [
            u("button", {
              class: "ed-group-btn",
              "aria-expanded": h.value === P.id,
              "data-testid": "studio-adjust-group-" + P.id,
              onClick: (A) => f(P.id)
            }, [
              C($, {
                name: P.icon,
                size: 13,
                class: "ic"
              }, null, 8, ["name"]),
              u("span", v1e, E(P.label), 1),
              y(P.id) ? (g(), b("i", y1e)) : z("", !0),
              C($, {
                name: h.value === P.id ? "ChevronUp" : "ChevronDown",
                size: 12,
                class: "chev"
              }, null, 8, ["name"])
            ], 8, b1e),
            y(P.id) ? (g(), b("button", {
              key: 0,
              class: "ed-group-reset",
              title: "Reset " + P.label.toLowerCase(),
              onClick: (A) => v(P.id)
            }, [
              C($, {
                name: "RotateCcw",
                size: 11
              })
            ], 8, x1e)) : z("", !0)
          ]),
          C(fa, {
            open: h.value === P.id
          }, {
            default: Xe(() => [
              u("div", w1e, [
                P.id === "light" ? (g(), b(j, { key: 0 }, [
                  C(Ct, {
                    label: "Exposure",
                    "model-value": s.value.exposure,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-exposure",
                    "onUpdate:modelValue": k[0] || (k[0] = (A) => p((R) => R.exposure = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Contrast",
                    "model-value": s.value.contrast,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-contrast",
                    "onUpdate:modelValue": k[1] || (k[1] = (A) => p((R) => R.contrast = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Brightness",
                    "model-value": s.value.brightness,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[2] || (k[2] = (A) => p((R) => R.brightness = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Highlights",
                    "model-value": s.value.highlights,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[3] || (k[3] = (A) => p((R) => R.highlights = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Shadows",
                    "model-value": s.value.shadows,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[4] || (k[4] = (A) => p((R) => R.shadows = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "colour" ? (g(), b(j, { key: 1 }, [
                  C(Ct, {
                    label: "Saturation",
                    "model-value": s.value.saturation,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-saturation",
                    "onUpdate:modelValue": k[5] || (k[5] = (A) => p((R) => R.saturation = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Hue",
                    "model-value": s.value.hue,
                    min: -180,
                    max: 180,
                    format: w,
                    "onUpdate:modelValue": k[6] || (k[6] = (A) => p((R) => R.hue = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Temperature",
                    "model-value": s.value.temperature,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-temperature",
                    "onUpdate:modelValue": k[7] || (k[7] = (A) => p((R) => R.temperature = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Tint",
                    "model-value": s.value.tint,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[8] || (k[8] = (A) => p((R) => R.tint = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "looks" ? (g(), b("div", k1e, [
                  (g(!0), b(j, null, ge(m(ox), (A) => (g(), b("button", {
                    key: A.id,
                    class: G(["ed-look", ["look-" + A.id, { on: s.value.look === A.id }]]),
                    role: "radio",
                    "aria-checked": s.value.look === A.id,
                    "data-testid": "studio-look-" + A.id,
                    onClick: (R) => m(t).setAdjust(m(Y_)(s.value, s.value.look === A.id ? "" : A.id))
                  }, [
                    u("span", S1e, [
                      m(e).stage.value ? (g(), Ie(ao, {
                        key: 0,
                        item: m(e).stage.value
                      }, null, 8, ["item"])) : z("", !0)
                    ]),
                    u("span", M1e, E(A.label), 1)
                  ], 10, _1e))), 128))
                ])) : P.id === "grading" ? (g(), b("div", T1e, [
                  C(Db, {
                    label: "Shadows",
                    wheel: s.value.grade.shadows,
                    onChange: k[9] || (k[9] = (A) => p((R) => R.grade.shadows = A))
                  }, null, 8, ["wheel"]),
                  C(Db, {
                    label: "Midtones",
                    wheel: s.value.grade.midtones,
                    onChange: k[10] || (k[10] = (A) => p((R) => R.grade.midtones = A))
                  }, null, 8, ["wheel"]),
                  C(Db, {
                    label: "Highlights",
                    wheel: s.value.grade.highlights,
                    onChange: k[11] || (k[11] = (A) => p((R) => R.grade.highlights = A))
                  }, null, 8, ["wheel"])
                ])) : P.id === "mixer" ? (g(), b(j, { key: 4 }, [
                  u("div", C1e, [
                    u("button", {
                      class: G(["sv-btn ed-mix-dropper", { on: i.value.picking }]),
                      "aria-pressed": !!i.value.picking,
                      title: "Click a colour in the picture to work on it",
                      "data-testid": "studio-mixer-pick",
                      onClick: k[12] || (k[12] = (A) => m(t).t.adjust.picking = !i.value.picking)
                    }, [
                      C($, {
                        name: "Pipette",
                        size: 13
                      }),
                      Y(" " + E(i.value.picking ? "Click the picture" : "Pick a colour"), 1)
                    ], 10, I1e),
                    u("span", {
                      class: "ed-mix-swatch",
                      title: (i.value.picked ? "The colour you picked" : l.value + " in the picture") + ", before and after the mixer",
                      "data-testid": "studio-mixer-swatch"
                    }, [
                      u("i", {
                        style: ce({ background: m(X_)(r.value) })
                      }, null, 4),
                      C($, {
                        name: "ArrowRight",
                        size: 11
                      }),
                      u("i", {
                        style: ce({ background: m(X_)(a.value) })
                      }, null, 4)
                    ], 8, A1e)
                  ]),
                  u("p", P1e, [
                    d.value ? (g(), b(j, { key: 0 }, [
                      Y("That colour is close to grey: the mixer barely moves it. Pick a richer one.")
                    ], 64)) : i.value.picked ? (g(), b(j, { key: 1 }, [
                      Y("You picked a " + E(l.value.toLowerCase()) + ": these move the ", 1),
                      u("b", null, E(l.value.toLowerCase()) + "s", 1),
                      k[34] || (k[34] = Y(" in the picture, its hue, richness and lightness.", -1))
                    ], 64)) : (g(), b(j, { key: 2 }, [
                      k[35] || (k[35] = Y("Moves only the ", -1)),
                      u("b", null, E(l.value.toLowerCase()) + "s", 1),
                      k[36] || (k[36] = Y(" in the picture: shift their hue, make them richer or duller, lighter or darker.", -1))
                    ], 64))
                  ]),
                  u("div", E1e, [
                    (g(!0), b(j, null, ge(m(Yi), (A) => (g(), b("button", {
                      key: A.id,
                      class: G(["ed-band", { on: o.value === A.id, "is-changed": s.value.mixer[A.id].hue || s.value.mixer[A.id].sat || s.value.mixer[A.id].lum }]),
                      style: ce({ "--c": A.color }),
                      role: "radio",
                      "aria-checked": o.value === A.id,
                      title: A.label,
                      "aria-label": A.label,
                      onClick: (R) => o.value = A.id
                    }, null, 14, R1e))), 128))
                  ]),
                  C(Ct, {
                    label: "Hue",
                    "model-value": s.value.mixer[o.value].hue,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[13] || (k[13] = (A) => p((R) => R.mixer[o.value].hue = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Saturation",
                    "model-value": s.value.mixer[o.value].sat,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[14] || (k[14] = (A) => p((R) => R.mixer[o.value].sat = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Luminance",
                    "model-value": s.value.mixer[o.value].lum,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[15] || (k[15] = (A) => p((R) => R.mixer[o.value].lum = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "match" ? (g(), b(j, { key: 5 }, [
                  k[37] || (k[37] = u("p", { class: "ed-hint" }, "Carry another version's colour onto this one: for a cast that crept in over repeated edits, match it to the original.", -1)),
                  u("div", z1e, [
                    (g(!0), b(j, null, ge(S.value, (A) => (g(), b("button", {
                      key: A.id,
                      class: G(["ed-refpick-cell", { on: s.value.match.to === A.id }]),
                      role: "radio",
                      "aria-checked": s.value.match.to === A.id,
                      title: "Match to " + M(A.id),
                      "data-testid": "studio-match-to",
                      onClick: (R) => m(t).matchTo(s.value.match.to === A.id ? null : A.id)
                    }, [
                      C(ao, { item: A }, null, 8, ["item"]),
                      u("span", D1e, E(M(A.id)), 1)
                    ], 10, $1e))), 128))
                  ]),
                  C(Ct, {
                    label: "Amount",
                    "model-value": s.value.match.amount,
                    min: 0,
                    max: 100,
                    start: 0,
                    disabled: !s.value.match.to,
                    format: (A) => A + "%",
                    "onUpdate:modelValue": k[16] || (k[16] = (A) => p((R) => R.match.amount = A))
                  }, null, 8, ["model-value", "disabled", "format"])
                ], 64)) : P.id === "overlay" ? (g(), b(j, { key: 6 }, [
                  u("div", O1e, [
                    u("label", {
                      class: "sv-color ed-color",
                      style: ce({ "--c": s.value.overlay.color }),
                      title: "Overlay colour"
                    }, [
                      k[38] || (k[38] = u("i", null, null, -1)),
                      u("input", {
                        type: "color",
                        value: s.value.overlay.color,
                        onInput: k[17] || (k[17] = (A) => p((R) => R.overlay.color = A.target.value))
                      }, null, 40, L1e)
                    ], 4),
                    u("span", B1e, [
                      u("select", {
                        value: s.value.overlay.blend,
                        "aria-label": "Blend",
                        onChange: k[18] || (k[18] = (A) => p((R) => R.overlay.blend = A.target.value))
                      }, [
                        (g(!0), b(j, null, ge(m(zhe), (A) => (g(), b("option", {
                          key: A.id,
                          value: A.id
                        }, E(A.label), 9, N1e))), 128))
                      ], 40, F1e),
                      C($, {
                        name: "ChevronDown",
                        size: 12
                      })
                    ])
                  ]),
                  C(Ct, {
                    label: "Opacity",
                    "model-value": s.value.overlay.opacity,
                    min: 0,
                    max: 100,
                    start: 0,
                    format: (A) => A + "%",
                    "onUpdate:modelValue": k[19] || (k[19] = (A) => p((R) => R.overlay.opacity = A))
                  }, null, 8, ["model-value", "format"])
                ], 64)) : P.id === "grain" ? (g(), b(j, { key: 7 }, [
                  C(Ct, {
                    label: "Amount",
                    "model-value": s.value.grain.amount,
                    min: 0,
                    max: 100,
                    start: 0,
                    "onUpdate:modelValue": k[20] || (k[20] = (A) => p((R) => R.grain.amount = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Size",
                    "model-value": s.value.grain.size,
                    min: 0,
                    max: 100,
                    start: 35,
                    "onUpdate:modelValue": k[21] || (k[21] = (A) => p((R) => R.grain.size = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "rotate" ? (g(), b(j, { key: 8 }, [
                  C(Ct, {
                    label: "Straighten",
                    "model-value": s.value.straighten,
                    min: -45,
                    max: 45,
                    step: 0.5,
                    format: w,
                    testid: "studio-adjust-straighten",
                    "onUpdate:modelValue": k[22] || (k[22] = (A) => p((R) => R.straighten = A))
                  }, null, 8, ["model-value"]),
                  u("div", U1e, [
                    u("button", {
                      class: "sv-btn",
                      title: "Turn left",
                      "data-testid": "studio-adjust-turn-left",
                      onClick: k[23] || (k[23] = (A) => p((R) => R.quarter = (R.quarter + 3) % 4))
                    }, [
                      C($, {
                        name: "RotateCcw",
                        size: 14
                      })
                    ]),
                    u("button", {
                      class: "sv-btn",
                      title: "Turn right",
                      "data-testid": "studio-adjust-turn-right",
                      onClick: k[24] || (k[24] = (A) => p((R) => R.quarter = (R.quarter + 1) % 4))
                    }, [
                      C($, {
                        name: "RotateCw",
                        size: 14
                      })
                    ]),
                    u("button", {
                      class: G(["sv-btn", { "is-on": s.value.flipH }]),
                      title: "Flip left to right",
                      onClick: k[25] || (k[25] = (A) => p((R) => R.flipH = !R.flipH))
                    }, [
                      C($, {
                        name: "FlipHorizontal2",
                        size: 14
                      })
                    ], 2),
                    u("button", {
                      class: G(["sv-btn", { "is-on": s.value.flipV }]),
                      title: "Flip top to bottom",
                      onClick: k[26] || (k[26] = (A) => p((R) => R.flipV = !R.flipV))
                    }, [
                      C($, {
                        name: "FlipVertical2",
                        size: 14
                      })
                    ], 2)
                  ])
                ], 64)) : z("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["open"])
        ], 2)), 64))
      ]),
      C(ou, null, {
        default: Xe(() => [
          u("div", G1e, [
            k[39] || (k[39] = u("span", { class: "grow" }, null, -1)),
            u("button", {
              class: "sv-btn ed-square ed-hold",
              disabled: !_.value,
              title: "Hold to see the picture as it was",
              "aria-label": "Hold to see the original",
              "data-testid": "studio-adjust-original",
              onPointerdown: k[27] || (k[27] = (P) => m(t).t.adjust.original = !0),
              onPointerup: k[28] || (k[28] = (P) => m(t).t.adjust.original = !1),
              onPointerleave: k[29] || (k[29] = (P) => m(t).t.adjust.original = !1),
              onKeydown: k[30] || (k[30] = tn(Te((P) => m(t).t.adjust.original = !0, ["prevent"]), ["space"])),
              onKeyup: k[31] || (k[31] = tn(Te((P) => m(t).t.adjust.original = !1, ["prevent"]), ["space"]))
            }, [
              C($, {
                name: "Eye",
                size: 14
              })
            ], 40, j1e),
            u("button", {
              class: "sv-btn ed-square",
              disabled: !_.value,
              title: "Reset all",
              "aria-label": "Reset all",
              "data-testid": "studio-adjust-reset",
              onClick: k[32] || (k[32] = (P) => m(t).reset("adjust"))
            }, [
              C($, {
                name: "RotateCcw",
                size: 14
              })
            ], 8, H1e),
            u("button", {
              class: "sv-btn is-primary ed-apply",
              disabled: !m(t).pending("adjust") || !!m(t).t.busy,
              "data-testid": "studio-adjust-apply",
              onClick: k[33] || (k[33] = (P) => m(t).apply("adjust"))
            }, [
              C($, {
                name: m(t).t.busy ? "Loader2" : "Check",
                size: 14,
                spin: !!m(t).t.busy
              }, null, 8, ["name", "spin"]),
              Y(" " + E(m(t).t.busy ? "Applying" : "Apply"), 1)
            ], 8, V1e)
          ])
        ]),
        _: 1
      })
    ]));
  }
}), q1e = { class: "ed-panel" }, K1e = ["aria-checked", "title", "onClick"], Y1e = {
  class: "ed-radios",
  role: "radiogroup",
  "aria-label": "Improve"
}, X1e = ["aria-checked", "onClick"], J1e = /* @__PURE__ */ Pe({
  __name: "SkinPanel",
  setup(n) {
    const e = yt(), t = I(() => e.tools.t.skin);
    return (i, s) => (g(), b("div", q1e, [
      u("div", {
        class: "sv-seg is-small ed-pills ed-slide",
        role: "radiogroup",
        "aria-label": "How faithful",
        style: ce({ "--i": Math.max(0, m(bb).findIndex((o) => o.id === t.value.version)), "--n": m(bb).length })
      }, [
        (g(!0), b(j, null, ge(m(bb), (o) => (g(), b("button", {
          key: o.id,
          role: "radio",
          "aria-checked": t.value.version === o.id,
          class: G({ on: t.value.version === o.id }),
          title: o.hint,
          onClick: (r) => m(e).tools.t.skin.version = o.id
        }, E(o.label), 11, K1e))), 128))
      ], 4),
      u("div", Y1e, [
        (g(!0), b(j, null, ge(m(ahe), (o) => (g(), b("button", {
          key: o.id,
          class: G(["ed-radio-row", { on: t.value.focus === o.id }]),
          role: "radio",
          "aria-checked": t.value.focus === o.id,
          onClick: (r) => m(e).tools.t.skin.focus = o.id
        }, [
          C(_m, {
            on: t.value.focus === o.id
          }, null, 8, ["on"]),
          s[2] || (s[2] = Y()),
          u("span", null, E(o.label), 1)
        ], 10, X1e))), 128))
      ]),
      C(Ct, {
        label: "Sharpen",
        "model-value": t.value.sharpen,
        min: 0,
        max: 100,
        start: 30,
        "onUpdate:modelValue": s[0] || (s[0] = (o) => m(e).tools.t.skin.sharpen = o)
      }, null, 8, ["model-value"]),
      C(Ct, {
        label: "Grain",
        "model-value": t.value.grain,
        min: 0,
        max: 100,
        start: 0,
        "onUpdate:modelValue": s[1] || (s[1] = (o) => m(e).tools.t.skin.grain = o)
      }, null, 8, ["model-value"]),
      C(Yo, {
        kind: "skin",
        label: "Improve",
        icon: "Smile",
        picker: ""
      })
    ]));
  }
}), Z1e = { class: "ed-panel ed-camera" }, Q1e = ["aria-valuenow", "aria-valuetext"], eye = ["rx", "ry"], tye = ["cx", "cy"], nye = ["d"], iye = ["x", "y"], sye = ["x2", "y2"], oye = ["transform"], rye = ["aria-valuenow", "aria-valuetext"], aye = ["d"], lye = ["x2"], dye = ["cx", "cy"], cye = ["x", "y"], uye = ["y1", "x2", "y2"], hye = ["transform"], pye = {
  class: "ed-camera-name",
  "data-testid": "studio-camera-name"
}, fye = {
  class: "ed-views",
  "data-testid": "studio-camera-views"
}, mye = { class: "ed-views-head" }, gye = {
  class: "ed-views-only",
  title: "Your saved views are yours alone, on every board and picture"
}, bye = ["maxlength", "onKeydown"], vye = ["title", "aria-pressed", "onClick", "onDblclick"], yye = { class: "nm" }, xye = ["title", "aria-label", "onClick"], wye = ["disabled", "title"], kye = {
  key: 0,
  class: "ed-views-empty"
}, _ye = {
  key: 0,
  class: "sv-warn ed-camera-warn"
}, Sye = { class: "ed-seed" }, Mye = { class: "ed-switch" }, Tye = ["disabled"], Nh = 78, Pd = 30, Sr = 92, Mr = 52, Ed = 46, Fa = 22, Na = 60, Cye = /* @__PURE__ */ Pe({
  __name: "CameraPanel",
  setup(n) {
    const e = yt(), { board: t } = Ze(), i = e.tools, s = I(() => i.t.camera), o = I(() => s.value.set), r = I(() => t.ui.cameraViews), a = I(() => r.value.find((H) => Lne(H, o.value)) || null), l = I(() => r.value.length >= If), d = I(() => a.value ? "This view is saved as " + a.value.name : l.value ? "You keep the most views there can be: remove one first" : "Save this view, to come back to it on any board"), c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(""), f = /* @__PURE__ */ W(null);
    function p(H) {
      c.value || i.setCamera({ rotate: H.rotate, vertical: H.vertical, zoom: H.zoom });
    }
    function y() {
      const H = t.saveCameraView(o.value, kc(o.value));
      H && v(H);
    }
    function v(H) {
      c.value = H.id, h.value = H.name, nt(() => {
        const J = f.value && f.value[0];
        J && (J.focus(), J.select());
      });
    }
    function x() {
      c.value && (t.renameCameraView(c.value, h.value), c.value = null);
    }
    function w() {
      c.value = null;
    }
    function S(H, J = 1) {
      const Q = H * Math.PI / 180;
      return { x: Sr + Math.sin(Q) * Nh * J, y: Mr + Math.cos(Q) * Pd * J };
    }
    const M = I(() => 1.12 - o.value.zoom / 10 * 0.42), _ = I(() => S(o.value.rotate, M.value)), T = I(() => Math.cos(o.value.rotate * Math.PI / 180) < 0);
    function k(H) {
      const J = H * Math.PI / 180;
      return { x: Fa + Math.cos(J) * Ed, y: Na - Math.sin(J) * Ed };
    }
    const P = I(() => {
      const H = k(-30), J = k(90);
      return "M " + H.x + " " + H.y + " A " + Ed + " " + Ed + " 0 0 0 " + J.x + " " + J.y;
    }), A = I(() => k(o.value.vertical)), R = /* @__PURE__ */ W(null), D = /* @__PURE__ */ W(null);
    let O = null;
    function F(H, J) {
      const Q = H.getBoundingClientRect(), ne = H.viewBox.baseVal;
      return { x: (J.clientX - Q.left) / Q.width * ne.width, y: (J.clientY - Q.top) / Q.height * ne.height };
    }
    function ie(H) {
      if (!R.value) return;
      const J = F(R.value, H), Q = Math.atan2((J.x - Sr) / Nh, (J.y - Mr) / Pd) * 180 / Math.PI;
      i.setCamera({ rotate: H.shiftKey ? Math.round(Su(Q)) : b_(Q) });
    }
    function ee(H) {
      if (!D.value) return;
      const J = F(D.value, H), Q = Math.atan2(Na - J.y, J.x - Fa) * 180 / Math.PI, ne = Math.max(-30, Math.min(90, Q));
      i.setCamera({ vertical: H.shiftKey ? Math.round(ne) : v_(ne) });
    }
    function me(H, J) {
      J.button === 0 && (O = H, J.currentTarget.setPointerCapture(J.pointerId), H === "ring" ? ie(J) : ee(J));
    }
    function L(H) {
      O === "ring" ? ie(H) : O === "arc" && ee(H);
    }
    function N() {
      O = null;
    }
    const K = (H) => {
      const J = Yy(H);
      return (J === 0 ? "0°" : J > 0 ? J + "° right" : -J + "° left") + " · " + w0(H);
    }, B = (H) => (H > 0 ? "+" : "") + H + "° · " + k0(H), re = (H) => nI(H);
    return (H, J) => (g(), b("div", Z1e, [
      u("div", {
        class: "ed-orbit",
        onPointermove: L,
        onPointerup: N,
        onPointercancel: N
      }, [
        (g(), b("svg", {
          ref_key: "ring",
          ref: R,
          class: "ed-orbit-ring",
          viewBox: "0 0 184 104",
          role: "slider",
          "aria-label": "Rotate around the scene",
          "aria-valuenow": o.value.rotate,
          "aria-valuetext": m(w0)(o.value.rotate),
          tabindex: "0",
          "data-testid": "studio-camera-ring",
          onPointerdown: J[0] || (J[0] = (Q) => me("ring", Q))
        }, [
          u("ellipse", {
            cx: Sr,
            cy: Mr,
            rx: Nh,
            ry: Pd,
            class: "track"
          }),
          u("ellipse", {
            cx: Sr,
            cy: Mr,
            rx: Nh * 0.7,
            ry: Pd * 0.7,
            class: "track is-inner"
          }, null, 8, eye),
          (g(!0), b(j, null, ge(m(x0), (Q) => (g(), b("g", { key: Q }, [
            u("circle", {
              cx: S(Q).x,
              cy: S(Q).y,
              r: "2.2",
              class: G(["stop", { on: Q === o.value.rotate }])
            }, null, 10, tye)
          ]))), 128)),
          u("path", {
            d: "M " + (Sr - 5) + " " + (Mr + Pd + 9) + " l 5 -6 l 5 6 z",
            class: "origin"
          }, null, 8, nye),
          u("rect", {
            x: Sr - 16,
            y: Mr - 3,
            width: "32",
            height: "6",
            rx: "1.5",
            class: "card"
          }, null, 8, iye),
          u("line", {
            x1: Sr,
            y1: Mr,
            x2: _.value.x,
            y2: _.value.y,
            class: G(["ray", { "is-behind": T.value }])
          }, null, 10, sye),
          u("g", {
            class: "cam",
            transform: "translate(" + _.value.x + " " + _.value.y + ")"
          }, [...J[8] || (J[8] = [
            u("circle", {
              r: "9",
              class: "halo"
            }, null, -1),
            u("circle", {
              r: "5.5",
              class: "dot"
            }, null, -1)
          ])], 8, oye)
        ], 40, Q1e)),
        (g(), b("svg", {
          ref_key: "arc",
          ref: D,
          class: "ed-orbit-arc",
          viewBox: "0 0 84 96",
          role: "slider",
          "aria-label": "Camera height",
          "aria-valuenow": o.value.vertical,
          "aria-valuetext": m(k0)(o.value.vertical),
          tabindex: "0",
          "data-testid": "studio-camera-arc",
          onPointerdown: J[1] || (J[1] = (Q) => me("arc", Q))
        }, [
          u("path", {
            d: P.value,
            class: "track"
          }, null, 8, aye),
          u("line", {
            x1: Fa,
            y1: Na,
            x2: Fa + Ed + 6,
            y2: Na,
            class: "ground"
          }, null, 8, lye),
          (g(!0), b(j, null, ge(m(Af), (Q) => (g(), b("circle", {
            key: Q.at,
            cx: k(Q.at).x,
            cy: k(Q.at).y,
            r: "2",
            class: G(["stop", { on: Q.at === o.value.vertical }])
          }, null, 10, dye))), 128)),
          u("rect", {
            x: Fa - 3,
            y: Na - 16,
            width: "6",
            height: "16",
            rx: "1.5",
            class: "card"
          }, null, 8, cye),
          u("line", {
            x1: Fa,
            y1: Na - 8,
            x2: A.value.x,
            y2: A.value.y,
            class: "ray"
          }, null, 8, uye),
          u("g", {
            class: "cam",
            transform: "translate(" + A.value.x + " " + A.value.y + ")"
          }, [...J[9] || (J[9] = [
            u("circle", {
              r: "8",
              class: "halo"
            }, null, -1),
            u("circle", {
              r: "5",
              class: "dot"
            }, null, -1)
          ])], 8, hye)
        ], 40, rye))
      ], 32),
      u("div", pye, E(a.value ? a.value.name : m(kc)(o.value)), 1),
      u("section", fye, [
        u("div", mye, [
          J[11] || (J[11] = u("span", { class: "t" }, "Your cameras", -1)),
          u("span", gye, [
            C($, {
              name: "Lock",
              size: 9
            }),
            J[10] || (J[10] = Y(" Only you", -1))
          ])
        ]),
        C(Zp, {
          name: "ed-view",
          tag: "div",
          class: "ed-views-list"
        }, {
          default: Xe(() => [
            (g(!0), b(j, null, ge(r.value, (Q) => (g(), b("div", {
              key: Q.id,
              class: G(["ed-view", { on: !!a.value && a.value.id === Q.id, "is-naming": c.value === Q.id }])
            }, [
              c.value === Q.id ? _t((g(), b("input", {
                key: 0,
                ref_for: !0,
                ref_key: "nameEl",
                ref: f,
                "onUpdate:modelValue": J[2] || (J[2] = (ne) => h.value = ne),
                class: "ed-view-input",
                maxlength: m(Ky),
                spellcheck: "false",
                "aria-label": "The view's name",
                "data-testid": "studio-camera-view-name",
                onKeydown: [
                  tn(Te(x, ["prevent"]), ["enter"]),
                  tn(Te(w, ["stop", "prevent"]), ["esc"])
                ],
                onBlur: x
              }, null, 40, bye)), [
                [Zt, h.value]
              ]) : (g(), b("button", {
                key: 1,
                class: "ed-view-chip",
                title: m(kc)(Q) + ". Double-click to rename it",
                "aria-pressed": !!a.value && a.value.id === Q.id,
                "data-testid": "studio-camera-view",
                onClick: (ne) => p(Q),
                onDblclick: (ne) => v(Q)
              }, [
                C($, {
                  name: "Camera",
                  size: 11
                }),
                u("span", yye, E(Q.name), 1)
              ], 40, vye)),
              c.value !== Q.id ? (g(), b("button", {
                key: 2,
                class: "ed-view-x",
                title: "Remove " + Q.name,
                "aria-label": "Remove " + Q.name,
                "data-testid": "studio-camera-view-remove",
                onClick: (ne) => m(t).removeCameraView(Q.id)
              }, [
                C($, {
                  name: "X",
                  size: 10
                })
              ], 8, xye)) : z("", !0)
            ], 2))), 128)),
            u("button", {
              key: "save",
              class: G(["ed-views-save", { "is-saved": !!a.value }]),
              disabled: !!a.value || l.value,
              title: d.value,
              "data-testid": "studio-camera-save",
              onClick: y
            }, [
              C($, {
                name: a.value ? "Check" : "Plus",
                size: 12
              }, null, 8, ["name"]),
              Y(" " + E(a.value ? "Saved" : "Save view"), 1)
            ], 10, wye)
          ]),
          _: 1
        }),
        r.value.length ? z("", !0) : (g(), b("p", kye, "Save a view to come back to it, on any board and any picture."))
      ]),
      C(Ct, {
        label: "Rotate",
        "model-value": o.value.rotate,
        min: 0,
        max: 359,
        ticks: m(x0),
        format: K,
        testid: "studio-camera-rotate",
        "onUpdate:modelValue": J[3] || (J[3] = (Q) => m(i).setCamera({ rotate: m(b_)(Q, 4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(Ct, {
        label: "Vertical",
        "model-value": o.value.vertical,
        min: -30,
        max: 90,
        ticks: m(Af).map((Q) => Q.at),
        format: B,
        testid: "studio-camera-vertical",
        "onUpdate:modelValue": J[4] || (J[4] = (Q) => m(i).setCamera({ vertical: m(v_)(Q, 4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(Ct, {
        label: "Zoom",
        "model-value": o.value.zoom,
        min: 0,
        max: 10,
        step: 0.5,
        start: 5,
        ticks: m(tI).map((Q) => Q.at),
        format: re,
        testid: "studio-camera-zoom",
        "onUpdate:modelValue": J[5] || (J[5] = (Q) => m(i).setCamera({ zoom: m(Kne)(Q, 0.4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(vt, { name: "ed-fade" }, {
        default: Xe(() => [
          m(iI)(o.value) ? (g(), b("div", _ye, [
            C($, {
              name: "AlertCircle",
              size: 12
            }),
            J[12] || (J[12] = u("span", null, "Past a side view, the sides the picture doesn't show are invented.", -1))
          ])) : z("", !0)
        ]),
        _: 1
      }),
      u("div", Sye, [
        u("label", Mye, [
          _t(u("input", {
            "onUpdate:modelValue": J[6] || (J[6] = (Q) => m(i).t.camera.lock = Q),
            type: "checkbox",
            "data-testid": "studio-camera-seed-lock"
          }, null, 512), [
            [ol, m(i).t.camera.lock]
          ]),
          J[13] || (J[13] = u("i", null, null, -1)),
          J[14] || (J[14] = u("span", { title: "The same seed while you nudge the sliders, so a small move doesn't reshuffle the picture" }, "Keep the seed", -1))
        ]),
        u("button", {
          class: "ed-icon-chip",
          title: "A new seed",
          "aria-label": "A new seed",
          disabled: !s.value.lock,
          onClick: J[7] || (J[7] = (Q) => {
            m(i).t.camera.seed = null, m(i).seed();
          })
        }, [
          C($, {
            name: "Dice5",
            size: 13
          })
        ], 8, Tye)
      ]),
      C(Yo, {
        kind: "camera",
        label: "Change camera",
        icon: "Rotate3d",
        why: "Trained on exactly these three settings",
        many: !0
      })
    ]));
  }
}), Iye = { class: "ed-panel ed-relight" }, Aye = ["aria-selected"], Pye = ["aria-selected"], Eye = {
  class: "ed-looks is-light",
  role: "radiogroup",
  "aria-label": "Looks"
}, Rye = ["aria-checked", "title", "data-testid", "onClick"], zye = { class: "ed-rig" }, $ye = ["title", "onClick"], Dye = { class: "ed-lights" }, Oye = ["data-testid", "onClick"], Lye = { class: "nm" }, Bye = ["aria-label", "onClick"], Fye = {
  class: "ed-quick",
  role: "group",
  "aria-label": "Quick positions"
}, Nye = ["onClick"], Uye = { class: "ed-field" }, Gye = {
  class: "ed-whites",
  role: "radiogroup",
  "aria-label": "White light"
}, jye = ["aria-checked", "title", "onClick"], Hye = {
  class: "ed-gels",
  role: "radiogroup",
  "aria-label": "Coloured light"
}, Vye = ["aria-checked", "title", "onClick"], Wye = {
  class: "ed-gel is-any",
  title: "Any colour"
}, qye = ["value"], Kye = ["aria-checked"], Yye = ["aria-checked"], Xye = {
  key: 2,
  class: "ed-relight-reset"
}, Jye = ["disabled"], Rd = 132, Zye = /* @__PURE__ */ Pe({
  __name: "RelightPanel",
  setup(n) {
    const t = yt().tools, i = I(() => t.t.relight), s = (() => {
      const k = Tc().lights[0];
      return { rotate: k.rotate, elevation: k.elevation, intensity: k.intensity };
    })(), o = I(() => JSON.stringify(r(l.value)) === JSON.stringify(r({ ...Tc(), mode: l.value.mode })));
    function r(k) {
      return { ...k, lights: k.lights.map((P) => ({ ...P, id: "" })) };
    }
    function a() {
      const k = { ...Tc(), mode: l.value.mode };
      t.t.relight.rig = k, t.t.relight.selected = k.lights[0].id;
    }
    const l = I(() => i.value.rig), d = I(() => l.value.lights.find((k) => k.id === i.value.selected) || l.value.lights[0] || null), c = /* @__PURE__ */ W(null);
    function h() {
      const k = c.value;
      if (!k) return;
      const P = Math.min(2, window.devicePixelRatio || 1), A = Math.round(Rd * P);
      k.width !== A && (k.width = A, k.height = A);
      const R = k.getContext("2d");
      if (!R) return;
      const D = R.createImageData(A, A);
      D.data.set(hpe(l.value, A)), R.putImageData(D, 0, 0);
    }
    it(h), Ee(l, h, { deep: !0 });
    function f(k) {
      const P = d.value;
      if (!P) return;
      const A = l.value.lights.map((R) => {
        if (R.id !== P.id) return R;
        const D = { ...R };
        return k(D), D;
      });
      t.t.relight.rig = { ...l.value, lights: A, look: l.value.look };
    }
    function p(k) {
      t.t.relight.rig = { ...l.value, mode: k };
    }
    function y(k) {
      const P = D0.find((A) => A.id === k);
      P && (t.t.relight.rig = tpe(P, l.value.mode), t.t.relight.selected = t.t.relight.rig.lights[0].id);
    }
    function v() {
      var k;
      if (l.value.lights.length >= J_) return;
      const P = l.value.lights.map((D) => D.rotate), A = (k = [90, -90, 135, 0].find((D) => !P.includes(D))) != null ? k : 135, R = ax({ rotate: A, elevation: 0, intensity: 4, color: "#fff4e5", kelvin: 5600 });
      t.t.relight.rig = { ...l.value, lights: [...l.value.lights, R] }, t.t.relight.selected = R.id;
    }
    function x(k) {
      if (l.value.lights.length <= 1) return;
      const P = l.value.lights.filter((A) => A.id !== k);
      t.t.relight.rig = { ...l.value, lights: P }, i.value.selected === k && (t.t.relight.selected = P[0].id);
    }
    const w = (k) => {
      const P = Cc(k);
      return P === 0 ? "Front" : P === 180 ? "Behind" : Math.abs(P) === 90 ? P > 0 ? "Right" : "Left" : (Math.abs(P) > 90 ? "Behind " : "Front ") + (P > 0 ? "right" : "left");
    }, S = (k) => k >= 75 ? "Overhead" : k <= -75 ? "Below" : k > 0 ? "High, " + k + "°" : k < 0 ? "Low, " + k + "°" : "Level", M = (k) => String(k), _ = I(() => ape(l.value.lights));
    function T(k) {
      return _.value[k] || "Light " + (k + 1);
    }
    return (k, P) => (g(), b("div", Iye, [
      u("div", {
        class: "sv-seg is-text ed-tabs ed-slide",
        role: "tablist",
        "aria-label": "Relight",
        style: ce({ "--i": l.value.mode === "transfer" ? 1 : 0, "--n": 2 })
      }, [
        u("button", {
          role: "tab",
          "aria-selected": l.value.mode === "relight",
          class: G({ on: l.value.mode === "relight" }),
          "data-testid": "studio-relight-mode-relight",
          onClick: P[0] || (P[0] = (A) => p("relight"))
        }, "Relight", 10, Aye),
        u("button", {
          role: "tab",
          "aria-selected": l.value.mode === "transfer",
          class: G({ on: l.value.mode === "transfer" }),
          "data-testid": "studio-relight-mode-transfer",
          onClick: P[1] || (P[1] = (A) => p("transfer"))
        }, "Light transfer", 10, Pye)
      ], 4),
      l.value.mode === "relight" ? (g(), b(j, { key: 0 }, [
        u("div", Eye, [
          (g(!0), b(j, null, ge(m(D0), (A) => (g(), b("button", {
            key: A.id,
            class: G(["ed-light-look", { on: l.value.look === A.id }]),
            role: "radio",
            "aria-checked": l.value.look === A.id,
            title: A.words || A.label,
            "data-testid": "studio-relight-look-" + A.id,
            onClick: (R) => y(A.id)
          }, [
            u("i", {
              style: ce({ background: "radial-gradient(circle at 32% 30%, " + A.swatch[0] + ", " + A.swatch[1] + " 72%)" })
            }, null, 4),
            u("span", null, E(A.label), 1)
          ], 10, Rye))), 128))
        ]),
        u("div", zye, [
          u("div", {
            class: "ed-sphere",
            style: ce({ width: Rd + "px", height: Rd + "px" })
          }, [
            u("canvas", {
              ref_key: "sphere",
              ref: c,
              style: ce({ width: Rd + "px", height: Rd + "px" })
            }, null, 4),
            (g(!0), b(j, null, ge(l.value.lights, (A, R) => (g(), b("button", {
              key: A.id,
              class: G(["ed-sphere-light", { on: d.value && d.value.id === A.id, "is-behind": !m(Tb)(A).front }]),
              style: ce({ left: m(Tb)(A).x * 100 + "%", top: m(Tb)(A).y * 100 + "%", "--c": A.color }),
              title: T(R),
              onClick: (D) => m(t).t.relight.selected = A.id
            }, E(R + 1), 15, $ye))), 128))
          ], 4),
          u("div", Dye, [
            (g(!0), b(j, null, ge(l.value.lights, (A, R) => (g(), b("button", {
              key: A.id,
              class: G(["ed-light-chip", { on: d.value && d.value.id === A.id }]),
              style: ce({ "--c": A.color }),
              "data-testid": "studio-relight-light-" + R,
              onClick: (D) => m(t).t.relight.selected = A.id
            }, [
              P[9] || (P[9] = u("i", null, null, -1)),
              u("span", Lye, E(T(R)), 1),
              l.value.lights.length > 1 ? (g(), b("span", {
                key: 0,
                class: "x",
                role: "button",
                "aria-label": "Remove " + T(R),
                onClick: Te((D) => x(A.id), ["stop"])
              }, [
                C($, {
                  name: "X",
                  size: 10
                })
              ], 8, Bye)) : z("", !0)
            ], 14, Oye))), 128)),
            l.value.lights.length < m(J_) ? (g(), b("button", {
              key: 0,
              class: "ed-light-chip is-add",
              "data-testid": "studio-relight-add",
              onClick: v
            }, [
              C($, {
                name: "Plus",
                size: 11
              }),
              P[10] || (P[10] = Y(" Light", -1))
            ])) : z("", !0)
          ])
        ]),
        d.value ? (g(), b(j, { key: 0 }, [
          u("div", Fye, [
            (g(!0), b(j, null, ge(m(Qhe), (A) => (g(), b("button", {
              key: A.id,
              class: G(["ed-quick-btn", { on: m(Cc)(d.value.rotate) === A.rotate && m(Q_)(d.value.elevation) === A.elevation }]),
              onClick: (R) => {
                f((D) => {
                  D.rotate = A.rotate, D.elevation = A.elevation;
                });
              }
            }, E(A.label), 11, Nye))), 128))
          ]),
          C(Ct, {
            label: "Around",
            "model-value": d.value.rotate,
            min: -135,
            max: 180,
            step: 45,
            start: m(s).rotate,
            ticks: [-135, -90, -45, 0, 45, 90, 135, 180],
            format: w,
            testid: "studio-relight-rotate",
            "onUpdate:modelValue": P[2] || (P[2] = (A) => f((R) => R.rotate = m(Cc)(A)))
          }, null, 8, ["model-value", "start"]),
          C(Ct, {
            label: "Height",
            "model-value": d.value.elevation,
            min: -90,
            max: 90,
            step: 45,
            start: m(s).elevation,
            ticks: [-90, -45, 0, 45, 90],
            format: S,
            testid: "studio-relight-elevation",
            "onUpdate:modelValue": P[3] || (P[3] = (A) => f((R) => R.elevation = m(Q_)(A)))
          }, null, 8, ["model-value", "start"]),
          C(Ct, {
            label: "Intensity",
            "model-value": d.value.intensity,
            min: 1,
            max: 10,
            start: m(s).intensity,
            format: M,
            testid: "studio-relight-intensity",
            "onUpdate:modelValue": P[4] || (P[4] = (A) => f((R) => R.intensity = A))
          }, null, 8, ["model-value", "start"]),
          u("div", Uye, [
            P[12] || (P[12] = u("span", { class: "ed-field-lb" }, "Colour", -1)),
            u("div", Gye, [
              (g(!0), b(j, null, ge(m(NI), (A) => (g(), b("button", {
                key: A.kelvin,
                class: G(["ed-white", { on: d.value.kelvin === A.kelvin }]),
                style: ce({ "--c": A.color }),
                role: "radio",
                "aria-checked": d.value.kelvin === A.kelvin,
                title: A.name + ", about " + A.kelvin + " K",
                onClick: (R) => {
                  f((D) => {
                    D.color = A.color, D.kelvin = A.kelvin;
                  });
                }
              }, [
                P[11] || (P[11] = u("i", null, null, -1)),
                u("span", null, E(A.kelvin / 1e3) + "k", 1)
              ], 14, jye))), 128))
            ]),
            u("div", Hye, [
              (g(!0), b(j, null, ge(m(Zhe), (A) => (g(), b("button", {
                key: A,
                class: G(["ed-gel", { on: !d.value.kelvin && d.value.color.toLowerCase() === A }]),
                style: ce({ "--c": A }),
                role: "radio",
                "aria-checked": !d.value.kelvin && d.value.color.toLowerCase() === A,
                title: A,
                onClick: (R) => {
                  f((D) => {
                    D.color = A, D.kelvin = null;
                  });
                }
              }, null, 14, Vye))), 128)),
              u("label", Wye, [
                u("input", {
                  type: "color",
                  value: d.value.color,
                  onInput: P[5] || (P[5] = (A) => {
                    f((R) => {
                      R.color = A.target.value, R.kelvin = null;
                    });
                  })
                }, null, 40, qye)
              ])
            ])
          ])
        ], 64)) : z("", !0),
        u("div", {
          class: "sv-seg is-small ed-pills ed-slide",
          role: "radiogroup",
          "aria-label": "Softness",
          style: ce({ "--i": l.value.softness === "hard" ? 1 : 0, "--n": 2 })
        }, [
          u("button", {
            role: "radio",
            "aria-checked": l.value.softness === "soft",
            class: G({ on: l.value.softness === "soft" }),
            onClick: P[6] || (P[6] = (A) => m(t).t.relight.rig = { ...l.value, softness: "soft" })
          }, "Soft", 10, Kye),
          u("button", {
            role: "radio",
            "aria-checked": l.value.softness === "hard",
            class: G({ on: l.value.softness === "hard" }),
            onClick: P[7] || (P[7] = (A) => m(t).t.relight.rig = { ...l.value, softness: "hard" })
          }, "Hard", 10, Yye)
        ], 4)
      ], 64)) : (g(), b(j, { key: 1 }, [
        P[13] || (P[13] = u("p", { class: "ed-hint" }, "Copies another picture's light (its direction, colour and softness) onto this one, keeping everything else.", -1)),
        C(iA, {
          modelValue: m(t).t.relight.refId,
          "onUpdate:modelValue": P[8] || (P[8] = (A) => m(t).t.relight.refId = A),
          label: "The light to copy"
        }, null, 8, ["modelValue"])
      ], 64)),
      l.value.mode !== "transfer" ? (g(), b("div", Xye, [
        u("button", {
          class: "sv-btn",
          disabled: o.value,
          title: "The lights as Relight starts them",
          "data-testid": "studio-relight-reset",
          onClick: a
        }, [
          C($, {
            name: "RotateCcw",
            size: 13
          }),
          P[14] || (P[14] = Y(" Reset lights", -1))
        ], 8, Jye)
      ])) : z("", !0),
      C(Yo, {
        kind: "relight",
        label: l.value.mode === "transfer" ? "Transfer light" : "Relight",
        icon: "Lightbulb",
        why: l.value.mode === "transfer" ? "Copies the light of the picture you pick: it kept pictures truest in our relighting tests" : "Your lights, described in words: it kept pictures truest in our relighting tests"
      }, null, 8, ["label", "why"])
    ]));
  }
}), Qye = ["data-tool"], exe = ["aria-checked", "disabled", "title", "data-testid", "onClick"], txe = { class: "lbl" }, nxe = {
  key: 0,
  class: "ed-pending",
  title: "Not applied yet"
}, ixe = ["inert", "aria-busy", "data-testid"], sxe = /* @__PURE__ */ Pe({
  __name: "ToolList",
  setup(n) {
    const e = yt(), t = e.tools, i = t.t, s = [
      { id: null, label: "Prompt", icon: "Wand2", hint: "Say what to change in the bar below, select an area, or annotate the picture" },
      ...II
    ], o = {
      prompt: i0e,
      upscale: b0e,
      resize: N0e,
      background: d1e,
      adjust: W1e,
      skin: J1e,
      camera: Cye,
      relight: Zye
    }, r = I(() => !!e.stage.value && e.stage.value.status === "done");
    function a(f) {
      f === null ? t.close() : t.open(f);
    }
    const l = /* @__PURE__ */ W(null), d = () => typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let c = 0;
    Ee(() => [i.open, i.resize.mode, i.background.mode, i.relight.rig.mode], ([f]) => {
      clearTimeout(c), c = window.setTimeout(() => h(f || "prompt"), d() ? 0 : 360);
    });
    function h(f) {
      const p = l.value && l.value.querySelector('[data-tool="' + f + '"]'), y = p && p.closest(".sv-studios");
      if (!p || !y) return;
      if (f === "prompt") {
        y.scrollTop > 0 && y.scrollTo({ top: 0, behavior: d() ? "auto" : "smooth" });
        return;
      }
      const v = y.getBoundingClientRect(), x = p.getBoundingClientRect(), w = x.top - v.top - 10, S = w < 0 ? w : x.bottom > v.bottom ? Math.min(x.bottom - v.bottom, w) : 0;
      Math.abs(S) > 1 && y.scrollBy({ top: S, behavior: d() ? "auto" : "smooth" });
    }
    return We(() => clearTimeout(c)), (f, p) => (g(), b("div", {
      ref_key: "root",
      ref: l,
      class: "ed-tools",
      role: "radiogroup",
      "aria-label": "Edit with",
      "data-testid": "studio-edit-tools"
    }, [
      (g(), b(j, null, ge(s, (y) => u("section", {
        key: y.id || "prompt",
        "data-tool": y.id || "prompt",
        class: G(["ed-tool", { on: m(i).open === y.id, "is-pending": !!y.id && m(i).open === y.id && m(t).pending(y.id) }])
      }, [
        u("button", {
          class: "ed-tool-head",
          role: "radio",
          "aria-checked": m(i).open === y.id,
          disabled: !r.value && !!y.id || !!m(i).busy && m(i).open !== y.id,
          title: y.hint,
          "data-testid": "studio-edit-tool-" + (y.id || "prompt"),
          onClick: (v) => a(y.id)
        }, [
          C(_m, {
            on: m(i).open === y.id
          }, null, 8, ["on"]),
          C($, {
            name: y.icon,
            size: 15,
            class: "ic"
          }, null, 8, ["name"]),
          u("span", txe, E(y.label), 1),
          y.id && m(i).open === y.id && m(t).pending(y.id) ? (g(), b("span", nxe)) : z("", !0)
        ], 8, exe),
        C(fa, {
          open: m(i).open === y.id
        }, {
          default: Xe(() => [
            u("div", {
              class: G(["ed-tool-body", { "is-held": !!m(i).busy }]),
              inert: !!m(i).busy || void 0,
              "aria-busy": !!m(i).busy || void 0,
              "data-testid": "studio-edit-panel-" + (y.id || "prompt")
            }, [
              (g(), Ie(da(o[y.id || "prompt"])))
            ], 10, ixe)
          ]),
          _: 2
        }, 1032, ["open"])
      ], 10, Qye)), 64))
    ], 512));
  }
}), oxe = {
  class: "sv-tools",
  "data-testid": "studio-tools-threed"
}, rxe = {
  class: "sv-views",
  "data-testid": "studio-models"
}, axe = ["title", "onClick"], lxe = { class: "sv-views-adds" }, dxe = {
  class: "sv-views",
  "data-testid": "studio-cameras"
}, cxe = ["value", "onKeydown", "onBlur"], uxe = ["title", "onClick", "onDblclick"], hxe = ["title", "onClick"], pxe = ["disabled"], fxe = ["disabled"], mxe = /* @__PURE__ */ Pe({
  __name: "ThreeDTools",
  props: {
    fly: { type: Function },
    capture: { type: Function }
  },
  emits: ["upload-model", "library-model"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = yt(), { board: o } = Ze(), r = s.s, a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(!1);
    function c() {
      const y = s.saveCamera();
      y && s.say("Saved " + y.name + " with this model");
    }
    function h(y) {
      a.value = y, nt(() => {
        const v = l.value && l.value[0];
        v && (v.focus(), v.select());
      });
    }
    function f(y, v) {
      a.value === y && (s.renameCamera(y, v.target.value), a.value = null);
    }
    async function p() {
      if (!d.value) {
        d.value = !0;
        try {
          await t.capture();
        } finally {
          d.value = !1;
        }
      }
    }
    return (y, v) => (g(), b("div", oxe, [
      m(s).model3d.value ? (g(), b(j, { key: 0 }, [
        v[10] || (v[10] = u("p", { class: "sv-tools-hint" }, "Drag to orbit, right-drag or Shift-drag to move the view, scroll to zoom. Frame it in the viewfinder.", -1)),
        v[11] || (v[11] = u("div", { class: "sv-tools-label" }, "Models", -1)),
        u("ul", rxe, [
          (g(!0), b(j, null, ge(m(s).models3d.value, (x) => (g(), b("li", {
            key: x.id
          }, [
            u("button", {
              class: G(["go", { on: x.id === m(r).three.model }]),
              title: "Show " + x.name,
              onClick: (w) => m(s).useModel(x.id)
            }, [
              C($, {
                name: "Box",
                size: 12
              }),
              Y(" " + E(x.name), 1)
            ], 10, axe)
          ]))), 128)),
          u("li", lxe, [
            u("button", {
              class: "go is-add",
              title: "A model from your computer",
              "data-testid": "studio-3d-add",
              onClick: v[0] || (v[0] = (x) => i("upload-model"))
            }, [
              C($, {
                name: "Upload",
                size: 12
              }),
              v[6] || (v[6] = Y(" Computer", -1))
            ]),
            m(o).hasLibrary ? (g(), b("button", {
              key: 0,
              class: "go is-add",
              title: "A model from your Library",
              onClick: v[1] || (v[1] = (x) => i("library-model"))
            }, [
              C($, {
                name: "Library",
                size: 12
              }),
              v[7] || (v[7] = Y(" Library", -1))
            ])) : z("", !0)
          ])
        ]),
        v[12] || (v[12] = u("div", { class: "sv-tools-label" }, "Saved views", -1)),
        u("ul", dxe, [
          (g(!0), b(j, null, ge(m(s).model3d.value.cameras, (x) => (g(), b("li", {
            key: x.id
          }, [
            a.value === x.id ? (g(), b("input", {
              key: 0,
              ref_for: !0,
              ref_key: "nameEl",
              ref: l,
              class: "sv-view-input",
              value: x.name,
              spellcheck: "false",
              onKeydown: [
                tn(Te((w) => f(x.id, w), ["prevent"]), ["enter"]),
                v[2] || (v[2] = tn(Te((w) => a.value = null, ["stop", "prevent"]), ["esc"]))
              ],
              onBlur: (w) => f(x.id, w)
            }, null, 40, cxe)) : (g(), b(j, { key: 1 }, [
              u("button", {
                class: "go",
                title: "Fly to " + x.name + " (double-click to rename)",
                onClick: (w) => n.fly(x.cam),
                onDblclick: (w) => h(x.id)
              }, [
                C($, {
                  name: "Camera",
                  size: 12
                }),
                Y(" " + E(x.name), 1)
              ], 40, uxe),
              u("button", {
                class: "x",
                title: "Forget " + x.name,
                onClick: (w) => m(s).removeCamera(x.id)
              }, [
                C($, {
                  name: "X",
                  size: 11
                })
              ], 8, hxe)
            ], 64))
          ]))), 128)),
          u("li", null, [
            u("button", {
              class: "go is-add",
              "data-testid": "studio-save-camera",
              title: "Save this view to come back to",
              disabled: !m(r).three.cam,
              onClick: c
            }, [
              C($, {
                name: "Plus",
                size: 12
              }),
              v[8] || (v[8] = Y(" Save this view", -1))
            ], 8, pxe)
          ])
        ]),
        u("button", {
          class: "sv-btn is-wide",
          disabled: d.value || m(r).three.loading || !!m(r).three.error,
          "data-testid": "studio-capture",
          title: "Adds this frame to history and the queue, to draw on, annotate or send",
          onClick: p
        }, [
          C($, {
            name: d.value ? "Loader2" : "Camera",
            size: 14,
            spin: d.value
          }, null, 8, ["name", "spin"]),
          v[9] || (v[9] = Y(" Capture view ", -1))
        ], 8, fxe)
      ], 64)) : (g(), b(j, { key: 1 }, [
        v[16] || (v[16] = u("p", { class: "sv-tools-hint" }, "Bring in a model to find your view. Views you save stay with the model.", -1)),
        u("button", {
          class: "sv-btn is-wide",
          onClick: v[3] || (v[3] = (x) => i("upload-model"))
        }, [
          C($, {
            name: "Upload",
            size: 14
          }),
          v[13] || (v[13] = Y(" From your computer", -1))
        ]),
        m(o).hasLibrary ? (g(), b("button", {
          key: 0,
          class: "sv-btn is-wide",
          onClick: v[4] || (v[4] = (x) => i("library-model"))
        }, [
          C($, {
            name: "Library",
            size: 14
          }),
          v[14] || (v[14] = Y(" From your Library", -1))
        ])) : z("", !0),
        u("button", {
          class: "sv-btn is-wide",
          onClick: v[5] || (v[5] = (x) => m(s).addSample())
        }, [
          C($, {
            name: "Building2",
            size: 14
          }),
          v[15] || (v[15] = Y(" Try the sample", -1))
        ])
      ], 64))
    ]));
  }
}), gxe = {
  class: "sv-hist-pop",
  "data-testid": "studio-history-preview"
}, bxe = ["title"], vxe = { class: "cap" }, yxe = { class: "n" }, xxe = { class: "m" }, wxe = { class: "sv-hist-acts" }, kxe = ["aria-pressed"], _xe = { class: "tip" }, Sxe = { class: "tip" }, Mxe = { class: "tip" }, Txe = { class: "tip" }, Cxe = /* @__PURE__ */ Pe({
  __name: "HistoryPreview",
  props: {
    item: {}
  },
  emits: ["done"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = yt(), { board: o } = Ze(), r = /* @__PURE__ */ W(!1);
    Ee(() => t.item.id, () => {
      r.value = !1;
    });
    const a = I(() => t.item), l = I(() => s.side.value === "generate"), d = I(() => !!a.value.sessionId && a.value.sessionId !== s.sessionId && a.value.kind === "gen"), c = I(() => !!s.card.value && !s.onCard(a.value.id) && s.family.value.some((P) => P.id === a.value.id)), h = I(() => {
      const P = s.names.value.get(a.value.id), A = a.value.parentId ? s.items.value.find((O) => O.id === a.value.parentId) : null, R = A ? "from " + (s.names.value.get(A.id) || A.label) : "";
      return [a.value.pin ? a.value.label : a.value.kind === "ref" && !f.value ? xl[a.value.how || "upload"].text : P || a.value.label, R].filter(Boolean).join(" · ");
    }), f = I(() => a.value.kind === "ref" && a.value.how === "tool" && !!a.value.made), p = I(() => a.value.pin ? "Pinned" : f.value ? xl.tool.text + " · " + Jn(a.value.createdAt) : a.value.kind === "ref" ? "Reference" : (d.value ? s.sessionName(a.value) + " · " : "") + Jn(a.value.createdAt)), y = I(() => d.value ? "Bring it in from " + s.sessionName(a.value) : s.side.value === "edit" ? "Edit this one" : "Open in the viewer"), v = I(() => o.isPinnedImage(a.value.url));
    function x() {
      const P = a.value, A = P.result;
      o.togglePinImage({
        url: P.url,
        w: P.w,
        h: P.h,
        label: P.label,
        asset: P.asset || null,
        resultId: A ? A.id : null,
        sessionId: P.sessionId || (A ? A.sessionId : s.sessionId),
        video: !!(A && A.video),
        videoSrc: A && A.videoSrc || null,
        dur: A && A.dur || null
      });
    }
    const w = I(() => s.editRefItems.value.find((P) => P.id === a.value.id || !!P.source && P.source === a.value.id) || null), S = I(() => !l.value && s.takesRefs() && a.value.status === "done" && a.value.id !== s.s.stageId);
    function M() {
      w.value ? s.removeEditRef(w.value.id) : s.addEditRef(a.value.id);
    }
    function _(P) {
      P(), i("done");
    }
    function T() {
      a.value.status === "done" && s.show(a.value.id);
    }
    function k() {
      if (!r.value) {
        r.value = !0;
        return;
      }
      _(() => s.deleteItem(a.value.id));
    }
    return (P, A) => (g(), b("div", gxe, [
      u("button", {
        class: "art",
        title: y.value,
        onClick: A[0] || (A[0] = (R) => _(T))
      }, [
        C(ao, {
          item: a.value,
          full: ""
        }, null, 8, ["item"])
      ], 8, bxe),
      u("span", vxe, [
        u("span", yxe, E(h.value), 1),
        u("span", xxe, E(p.value), 1)
      ]),
      u("span", wxe, [
        u("button", {
          class: G(["is-pin", { on: v.value }]),
          "aria-pressed": v.value,
          "data-testid": "studio-pin",
          onClick: Te(x, ["stop"])
        }, [
          C($, {
            name: "Pin",
            size: 13
          }),
          u("span", _xe, E(v.value ? m(Xn).unpin : m(Xn).pin), 1)
        ], 10, kxe),
        l.value ? (g(), b("button", {
          key: 0,
          class: G({ on: m(s).queued(a.value.id) > 0 }),
          "data-testid": "studio-queue-toggle",
          onClick: A[1] || (A[1] = Te((R) => m(s).toggleQueued(a.value.id), ["stop"]))
        }, [
          C($, {
            name: m(s).queued(a.value.id) ? "Check" : "ImagePlus",
            size: 13
          }, null, 8, ["name"]),
          u("span", Sxe, E(m(s).queued(a.value.id) ? "Image " + m(s).queued(a.value.id) + " of the next run: take it out" : "Use as reference (add it to the next run)"), 1)
        ], 2)) : z("", !0),
        S.value ? (g(), b("button", {
          key: 1,
          class: G({ on: !!w.value }),
          "data-testid": "studio-ref-toggle",
          onClick: Te(M, ["stop"])
        }, [
          C($, {
            name: w.value ? "Check" : "ImagePlus",
            size: 13
          }, null, 8, ["name"]),
          u("span", Mxe, E(w.value ? "A reference for the edit: take it out" : "Use as reference"), 1)
        ], 2)) : z("", !0),
        u("button", {
          "data-testid": "studio-place",
          onClick: A[2] || (A[2] = Te((R) => _(() => m(s).placeOnBoard(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "ArrowDownToLine",
            size: 13
          }),
          A[6] || (A[6] = u("span", { class: "tip" }, "Place on the board", -1))
        ]),
        a.value.kind === "gen" ? (g(), b("button", {
          key: 2,
          "data-testid": "studio-pop-details",
          onClick: A[3] || (A[3] = Te((R) => _(() => m(s).openInfo(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "Info",
            size: 13
          }),
          A[7] || (A[7] = u("span", { class: "tip" }, "Details", -1))
        ])) : z("", !0),
        m(s).canDelete(a.value.id) ? (g(), b("button", {
          key: 3,
          class: G(["is-danger", { "is-armed": r.value }]),
          "data-testid": "studio-delete",
          onClick: Te(k, ["stop"])
        }, [
          C($, {
            name: "Trash2",
            size: 13
          }),
          u("span", Txe, E(r.value ? "Click again to delete it" : "Delete"), 1)
        ], 2)) : z("", !0),
        l.value ? (g(), b("button", {
          key: 4,
          "data-testid": "studio-continue",
          onClick: A[4] || (A[4] = Te((R) => _(() => m(s).continueFrom(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "CornerDownLeft",
            size: 13
          }),
          A[8] || (A[8] = u("span", { class: "tip" }, "Start from this image: it becomes image 1", -1))
        ])) : z("", !0),
        c.value ? (g(), b("button", {
          key: 5,
          class: "is-promote",
          "data-testid": "studio-promote",
          onClick: A[5] || (A[5] = Te((R) => _(() => m(s).promote(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "Replace",
            size: 13
          }),
          A[9] || (A[9] = u("span", { class: "tip" }, "Use this version on the board, in place of the one there", -1))
        ])) : z("", !0)
      ])
    ]));
  }
}), Ixe = ["inert"], Axe = { class: "sv-hist-head" }, Pxe = { class: "t" }, Exe = {
  class: "n",
  "data-testid": "studio-history-count"
}, Rxe = {
  key: 0,
  class: "sv-hist-from",
  "data-testid": "studio-made-from"
}, zxe = ["aria-expanded"], $xe = { class: "n" }, Dxe = {
  key: 0,
  class: "sv-hist-from-row"
}, Oxe = ["title", "data-testid", "onClick"], Lxe = { class: "k" }, Bxe = ["data-testid", "draggable", "onMouseenter", "onClick", "onDragstart"], Fxe = { class: "frame" }, Nxe = {
  key: 1,
  class: "sv-cell-fail"
}, Uxe = ["title"], Gxe = ["title"], jxe = {
  key: 2,
  class: "sv-cell-marks",
  title: "Annotated: its annotations go with it when it's sent"
}, Hxe = {
  key: 3,
  class: "sv-cell-card",
  title: "The version the board shows",
  "data-testid": "studio-on-board"
}, Vxe = ["title"], Wxe = { class: "sv-cell-cap" }, qxe = {
  key: 1,
  class: "sv-hist-empty"
}, y4 = 60, Kxe = 260, Yxe = /* @__PURE__ */ Pe({
  __name: "History",
  setup(n) {
    const e = yt(), { board: t } = Ze(), i = e.s, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null);
    let r = 0;
    function a(B) {
      return {
        w: Math.max(300, Math.min(640, B.left - 12 - 330)),
        h: Math.max(380, Math.min(720, window.innerHeight - y4 - 40))
      };
    }
    const l = I(() => e.shown.value), d = I(() => e.historySessions.value), c = I(() => e.pickedSessions()), h = I(() => e.allSessions()), f = I(() => G1(e)), p = I(() => (h.value ? d.value.length : c.value.length) > 1), y = I(() => e.side.value === "generate"), v = I(() => e.card.value);
    function x(B) {
      const re = e.stage.value;
      return !!re && (re.id === B.id || re.source === B.id);
    }
    const w = I(() => e.madeFrom(e.stage.value)), S = /* @__PURE__ */ W(!0);
    function M(B) {
      const re = t.store.get(B);
      !re || re.type !== "tool" || e.tools.close(() => {
        e.leave(), t.closeStudio(), t.openSession(re);
      });
    }
    function _(B) {
      return B.kind === "ref" && B.how === "tool" && !!B.made;
    }
    function T(B) {
      return B.status === "pending" ? "Making…" : B.status === "failed" ? "Failed" : i.pinned ? e.sessionName(B) || B.label : B.kind === "ref" && !_(B) ? xl[B.how || "upload"].text : p.value && e.sessionName(B) || Jn(B.createdAt);
    }
    function k() {
      t.openLibrary({
        purpose: "pick",
        max: 24,
        kinds: ["image"],
        confirmLabel: "Bring into the studio",
        onPick: (B) => e.addFromLibrary(B)
      });
    }
    function P(B) {
      B.status === "done" && (i.dropper ? e.dropperPick(B.id) : e.show(B.id));
    }
    function A(B) {
      if (e.side.value !== "edit") {
        const re = e.queued(B.id);
        return re ? { text: "Image " + re, adds: !1 } : { text: "Add to the next image", adds: !0 };
      }
      return x(B) ? { text: "Being edited", adds: !1 } : e.editRefItems.value.some((re) => re.id === B.id || re.source === B.id) ? { text: "A reference", adds: !1 } : { text: "Add as a reference", adds: !0 };
    }
    function R(B, re) {
      if (B.status !== "done") {
        re.preventDefault();
        return;
      }
      F();
      const H = re.currentTarget.querySelector(".frame");
      zme(re, B.id, H);
    }
    const D = () => {
      clearTimeout(r), clearTimeout(ie);
    }, O = () => {
      clearTimeout(r), clearTimeout(ie), r = window.setTimeout(() => {
        o.value = null;
      }, 180);
    }, F = () => {
      clearTimeout(r), clearTimeout(ie), o.value = null;
    };
    Ee(() => o.value && o.value.it.id, (B, re) => {
      B ? i.peekId = B : i.peekId === re && (i.peekId = null);
    }), We(() => {
      clearTimeout(r), clearTimeout(ie), o.value && i.peekId === o.value.it.id && (i.peekId = null);
    });
    let ie = 0, ee = null;
    function me(B) {
      ee = { x: B.clientX, y: B.clientY };
    }
    const L = /* @__PURE__ */ W(!1);
    let N = 0;
    Ee(() => i.histShut, (B) => {
      F(), L.value = !0, clearTimeout(N), N = window.setTimeout(() => {
        L.value = !1;
      }, 380), B && i.dropper && e.setDropper(!1);
    }), We(() => clearTimeout(N));
    function K(B, re) {
      if (D(), B.status !== "done" || !s.value || i.dropper) {
        o.value = null;
        return;
      }
      const H = re.currentTarget.getBoundingClientRect(), J = s.value.getBoundingClientRect(), Q = a(J), ne = Math.min(Q.w / B.w, Q.h / B.h), ue = Math.round(B.w * ne), Z = Math.round(B.h * ne), te = Math.min(Math.max(y4 + 8 - J.top, H.top - J.top + H.height / 2 - Z / 2), window.innerHeight - 8 - Z - J.top), we = { it: B, top: te, w: ue, h: Z }, Fe = o.value, Me = ee ? re.clientX - ee.x : 0, he = ee ? re.clientY - ee.y : 0;
      if (Fe && Fe.it.id !== B.id && Me < 0 && -Me >= Math.abs(he)) {
        ie = window.setTimeout(() => {
          o.value = we;
        }, Kxe);
        return;
      }
      o.value = we;
    }
    return (B, re) => (g(), b("aside", {
      ref_key: "rail",
      ref: s,
      class: G(["sv-hist", ["cols-" + m(i).columns, { "is-dropper": m(i).dropper, "is-shut": m(i).histShut, "is-moving": L.value }]]),
      "data-testid": "studio-history",
      onMouseleave: O,
      onMousemovePassive: me
    }, [
      u("div", {
        class: "sv-hist-body",
        inert: m(i).histShut || void 0
      }, [
        u("div", Axe, [
          u("span", Pxe, E(m(i).pinned ? "Pinned" : "History"), 1),
          u("span", Exe, E(l.value.length), 1),
          re[5] || (re[5] = u("span", { class: "sv-grow" }, null, -1)),
          m(t).hasLibrary ? (g(), b("button", {
            key: 0,
            class: "sv-hist-lib",
            title: "Find a picture anywhere: your Library",
            "data-testid": "studio-open-library",
            onClick: k
          }, [
            C($, {
              name: "Library",
              size: 14
            })
          ])) : z("", !0),
          C(eS, {
            columns: m(i).columns,
            testid: "studio-cols",
            onSet: re[0] || (re[0] = (H) => m(e).setColumns(H))
          }, null, 8, ["columns"]),
          u("button", {
            class: "sv-hist-lib sv-hist-fold",
            title: "Hide history, for more room",
            "aria-label": "Hide history",
            "data-testid": "studio-history-hide",
            onClick: re[1] || (re[1] = (H) => m(e).setHistShut(!0))
          }, [
            C($, {
              name: "PanelRightClose",
              size: 14
            })
          ])
        ]),
        C(tS, {
          filter: m(e),
          tid: "studio",
          pinned: m(i).pinned,
          "pin-count": m(t).pinnedImages.value.length,
          "go-to": M,
          onPinned: re[2] || (re[2] = (H) => m(i).pinned = H)
        }, null, 8, ["filter", "pinned", "pin-count"]),
        w.value.length ? (g(), b("div", Rxe, [
          u("button", {
            class: "sv-hist-from-head",
            "aria-expanded": S.value,
            onClick: re[3] || (re[3] = (H) => S.value = !S.value)
          }, [
            C($, {
              name: "Images",
              size: 12
            }),
            re[6] || (re[6] = u("span", null, "Made from", -1)),
            u("span", $xe, E(w.value.length), 1),
            re[7] || (re[7] = u("span", { class: "sv-grow" }, null, -1)),
            C($, {
              name: S.value ? "ChevronUp" : "ChevronDown",
              size: 12
            }, null, 8, ["name"])
          ], 8, zxe),
          S.value ? (g(), b("div", Dxe, [
            (g(!0), b(j, null, ge(w.value, (H) => (g(), b("button", {
              key: H.url,
              class: "sv-hist-from-pic",
              title: "Image " + H.n + ": open it in the viewer",
              style: ce({ backgroundImage: 'url("' + m(Bt)(H.url) + '"), url("' + H.url + '")' }),
              "data-testid": "studio-made-from-" + H.n,
              onClick: (J) => m(e).showUrl(H.url)
            }, [
              u("span", Lxe, E(H.n), 1)
            ], 12, Oxe))), 128))
          ])) : z("", !0)
        ])) : z("", !0),
        u("div", {
          class: "sv-hist-grid",
          style: ce({ "--cols": m(i).columns }),
          onScroll: F
        }, [
          (g(!0), b(j, null, ge(l.value, (H) => (g(), b("div", {
            key: H.id,
            class: G(["sv-cell", {
              "is-ref": H.kind === "ref",
              "is-stage": x(H),
              "is-pending": H.status === "pending",
              "is-failed": H.status === "failed",
              "is-queued": y.value && m(e).queued(H.id) > 0,
              "is-card": !!v.value && m(e).onCard(H.id),
              "is-new": Date.now() - H.createdAt < 4e3,
              "is-on": o.value && o.value.it.id === H.id
            }]),
            "data-testid": "studio-item-" + H.kind,
            draggable: H.status === "done",
            onMouseenter: (J) => K(H, J),
            onMouseleave: O,
            onClick: (J) => P(H),
            onDragstart: (J) => R(H, J),
            onDragend: re[4] || (re[4] = //@ts-ignore
            (...J) => m(Lf) && m(Lf)(...J))
          }, [
            u("span", Fxe, [
              H.status === "done" ? (g(), Ie(ao, {
                key: 0,
                item: H
              }, null, 8, ["item"])) : H.status === "failed" ? (g(), b("span", Nxe, [
                C($, {
                  name: "AlertCircle",
                  size: 16
                })
              ])) : H.status === "pending" ? (g(), Ie(j1, {
                key: 2,
                class: "sv-cell-time",
                since: H.result && H.result.startedAt || H.createdAt
              }, null, 8, ["since"])) : z("", !0)
            ]),
            H.kind === "ref" ? (g(), b("span", {
              key: 0,
              class: "sv-cell-how",
              title: _(H) ? H.made.label : m(xl)[H.how || "upload"].text
            }, [
              C($, {
                name: m(xl)[H.how || "upload"].icon,
                size: 10
              }, null, 8, ["name"])
            ], 8, Uxe)) : z("", !0),
            y.value && m(e).queued(H.id) ? (g(), b("span", {
              key: 1,
              class: "sv-cell-q",
              title: "Image " + m(e).queued(H.id) + " in the queue"
            }, E(m(e).queued(H.id)), 9, Gxe)) : z("", !0),
            m(e).marked(H.id) ? (g(), b("span", jxe, [
              C($, {
                name: "Pencil",
                size: 9
              })
            ])) : z("", !0),
            v.value && m(e).onCard(H.id) ? (g(), b("span", Hxe, [
              C($, {
                name: "LayoutGrid",
                size: 9
              }),
              re[8] || (re[8] = u("span", { class: "tx" }, "On the board", -1))
            ])) : z("", !0),
            !m(i).pinned && H.status === "done" && m(t).isPinnedImage(H.url) ? (g(), b("span", {
              key: 4,
              class: "sv-cell-pin",
              title: m(Xn).badge
            }, [
              C($, {
                name: "Pin",
                size: 10
              })
            ], 8, Vxe)) : z("", !0),
            u("span", Wxe, E(T(H)), 1),
            m(i).dropper && H.status === "done" ? (g(), b("span", {
              key: 5,
              class: G(["sv-cell-drop", { "is-in": !A(H).adds }]),
              "aria-hidden": "true"
            }, [
              C($, {
                name: A(H).adds ? "Pipette" : "Check",
                size: 11
              }, null, 8, ["name"]),
              Y(E(A(H).text), 1)
            ], 2)) : z("", !0)
          ], 42, Bxe))), 128)),
          m(i).pinned && !l.value.length ? (g(), Ie(H1, { key: 0 })) : l.value.length ? z("", !0) : (g(), b("div", qxe, E(h.value ? "What you make on this board, and the images you bring in, collect here." : "Nothing from " + f.value + " yet."), 1))
        ], 36)
      ], 8, Ixe),
      o.value ? (g(), Ie(Cxe, {
        key: 0,
        item: o.value.it,
        style: ce({ top: o.value.top + "px", width: o.value.w + "px", height: o.value.h + "px" }),
        onMouseenter: D,
        onMouseleave: O,
        onDone: F
      }, null, 8, ["item", "style"])) : z("", !0)
    ], 34));
  }
}), Xxe = 700;
function fx(n = () => !0) {
  const e = /* @__PURE__ */ W(!1);
  let t = 0, i = !1;
  const s = () => {
    clearTimeout(t), e.value = !1;
  }, o = (d) => i || !d.dataTransfer || !Array.from(d.dataTransfer.types).includes("Files") || !n() ? !1 : (e.value = !0, clearTimeout(t), t = window.setTimeout(s, Xxe), !0), r = (d) => {
    const c = d.currentTarget;
    if (!c) return s();
    const h = d.relatedTarget;
    if (h) {
      c.contains(h) || s();
      return;
    }
    const f = c.getBoundingClientRect(), p = d.clientX, y = d.clientY;
    (p === 0 && y === 0 || p <= f.left || p >= f.right - 1 || y <= f.top || y >= f.bottom - 1) && s();
  }, a = () => {
    i = !0;
  }, l = () => {
    i = !1, s();
  };
  return it(() => {
    window.addEventListener("dragstart", a, !0), window.addEventListener("dragend", l, !0), window.addEventListener("drop", l, !0), window.addEventListener("blur", s);
  }), We(() => {
    clearTimeout(t), window.removeEventListener("dragstart", a, !0), window.removeEventListener("dragend", l, !0), window.removeEventListener("drop", l, !0), window.removeEventListener("blur", s);
  }), { active: e, over: o, leave: r, stop: s };
}
const Jxe = {
  class: "sv-ambient",
  "aria-hidden": "true"
}, Zxe = { class: "sv-top" }, Qxe = { class: "sv-title" }, ewe = { class: "eyebrow" }, twe = ["title"], nwe = ["title"], iwe = { class: "ic" }, swe = {
  key: 1,
  class: "sv-pos",
  "data-testid": "studio-position"
}, owe = ["title"], rwe = {
  class: "sv-studios",
  "aria-label": "Studios"
}, awe = ["aria-selected", "disabled", "title", "data-testid", "onClick"], lwe = {
  key: "generate",
  class: "sv-modes ed-tools",
  role: "radiogroup",
  "aria-label": "Generate with"
}, dwe = ["title", "aria-checked", "data-testid", "onClick"], cwe = { class: "lbl" }, uwe = ["data-testid"], hwe = {
  key: 1,
  class: "sv-tools-hint"
}, pwe = {
  key: 2,
  class: "sv-tools-hint"
}, fwe = {
  key: 3,
  class: "sv-tools-hint"
}, mwe = { class: "sv-main" }, gwe = {
  key: 0,
  class: "bd-dropper sv-dropper",
  role: "status",
  "data-testid": "studio-dropper-banner"
}, bwe = { class: "bd-dropper-mark" }, vwe = { class: "bd-dropper-text" }, ywe = {
  class: "bd-dropper-count",
  "data-testid": "studio-dropper-count"
}, xwe = {
  key: 0,
  class: "sv-dropping"
}, wwe = /* @__PURE__ */ Pe({
  __name: "StudiosView",
  setup(n) {
    const { board: e } = Ze(), t = e.ui.studio, i = N0(e, t.sessionId);
    Dpe(i);
    const s = i.s, o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(0), l = I(() => e.ui.library.open && !!e.ui.library.inStudio);
    let d = null;
    Ee(r, (be) => {
      d && d.disconnect(), d = null, be && (d = new ResizeObserver(() => {
        a.value = be.offsetHeight + 30;
      }), d.observe(be));
    });
    const c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(null);
    Ee(() => e.ui.studio && e.ui.studio.n, () => {
      const be = e.ui.studio;
      !be || be.sessionId !== i.sessionId || i.enter(be.elementId || be.resultId ? { elementId: be.elementId, resultId: be.resultId } : null);
    }, { immediate: !0 });
    const f = [
      { id: "prompt", label: "Prompt", icon: "Wand2", side: "generate", tip: "Say what you want: a new image, or one from the images you queue" },
      { id: "threed", label: "3D", icon: "Box", side: "generate", tip: "Find a view of a 3D model and generate from it" },
      { id: "edit", label: "Edit", icon: "Pencil", side: "edit", tip: "Change the image in the viewer" }
    ], p = { edit: "Edit", erase: "Erase", annotate: "Annotate" }, y = [
      { id: "generate", label: "Generate", icon: "Sparkles" },
      { id: "edit", label: "Edit", icon: "Pencil" }
    ], v = I(() => i.session.value), x = I(() => i.stage.value), w = I(() => s.studio === "threed" ? i.model3d.value ? i.model3d.value.name : "3D model" : x.value ? x.value.label : i.video.value ? "New video" : "New image"), S = I(() => {
      const be = x.value;
      if (!be || s.studio === "threed") return "";
      const se = i.names.value.get(be.id), ae = i.family.value.length;
      return se ? se + (ae > 1 ? " of " + ae : "") : "";
    }), M = I(() => {
      if (s.studio !== "edit") return f.find((se) => se.id === s.studio).label;
      const be = sx(i.tools.t.open);
      return be ? be.label : p[s.bar];
    }), _ = I(() => i.side.value), T = /* @__PURE__ */ W(s.histShut ? Date.now() : 0);
    Ee(() => s.histShut, (be) => {
      T.value = be ? Date.now() : 0;
    });
    const k = I(() => i.shown.value.find((be) => be.status === "done" && !!be.url) || null), P = I(() => s.histShut ? i.shown.value.filter((be) => be.status === "done" && (be.result && be.result.doneAt || be.createdAt) > T.value).length : 0);
    Ee(_, () => {
      l.value && e.promptLibrary.close();
    });
    const A = I(() => y.find((be) => be.id === _.value).label), R = I(() => i.video.value ? y.filter((be) => be.id === "generate") : y), D = I(() => f.filter((be) => be.side === _.value && (!i.video.value || be.id === "prompt"))), O = I(() => i.video.value ? "Say what you want: a new video, or one that starts from the pictures you queue" : f[0].tip);
    function F(be) {
      if (!i.canUse(be)) {
        i.say("Pick an image to edit: one from history, or make one");
        return;
      }
      i.setStudio(be);
    }
    function ie(be) {
      be !== _.value && (be === "generate" ? i.tools.close(() => i.setSide(be)) : i.setSide(be));
    }
    function ee() {
      i.tools.close(() => {
        i.leave(), e.closeStudio();
      });
    }
    function me() {
      const be = v.value;
      i.tools.close(() => {
        i.leave(), e.closeStudio(), be && e.openSession(be);
      });
    }
    function L() {
      c.value && c.value.click();
    }
    function N() {
      h.value && h.value.click();
    }
    function K(be) {
      const se = be.target, ae = Array.from(se.files || []);
      se.value = "";
      for (const ye of ae) i.addUpload(ye);
    }
    function B(be) {
      const se = be.target, ae = (se.files || [])[0];
      se.value = "", ae && i.addModelFile(ae);
    }
    const re = /* @__PURE__ */ W(null);
    function H() {
      re.value && re.value.click();
    }
    function J(be) {
      const se = be.target, ae = se.files && se.files[0];
      se.value = "", ae && i.bringInVideo(ae);
    }
    function Q() {
      e.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: ["3d"],
        confirmLabel: "Use this model",
        onPick: (be) => {
          be[0] && i.addModelFromLibrary(be[0]);
        }
      });
    }
    const ne = I(() => o.value && o.value.model || null), ue = (be) => {
      ne.value && ne.value.fly(be);
    };
    async function Z(be = !1) {
      const se = ne.value;
      if (!se) return !1;
      let ae;
      try {
        ae = await se.capture();
      } catch (ye) {
        return console.warn("[board] view not captured", ye), i.say("The view couldn't be captured"), !1;
      }
      return ae ? !!await i.captureView(ae, be) : !1;
    }
    const te = () => Z(!1), we = I(() => s.studio === "threed" && i.model3d.value ? () => Z(!0) : null), Fe = I(() => {
      if (_.value !== "edit") return Math.min(i.queueItems.value.length, i.limit.value) + " of " + i.limit.value;
      const be = i.refRoom(), se = i.editRefItems.value.filter((ae) => ae.id !== s.stageId).length;
      return Math.min(se, be) + " of " + be;
    });
    function Me(be) {
      if (e.ui.libraryOpen) return;
      if (l.value) {
        be.key === "Escape" && (be.preventDefault(), e.promptLibrary.back());
        return;
      }
      const se = be.target, ae = !!se && (se.tagName === "INPUT" || se.tagName === "TEXTAREA" || se.isContentEditable);
      if (be.key === "Escape") {
        if (i.tools.t.guard) return;
        e.ui.infoAt ? e.ui.infoAt = null : s.dropper ? i.setDropper(!1) : s.editingPin ? i.commitPin(s.editingPin) : ae ? se.blur() : _.value === "edit" && s.bar === "annotate" && s.selection.length ? i.select([]) : i.tools.t.compare ? i.tools.compare(null) : i.tools.t.open ? i.tools.close() : ee(), be.preventDefault();
        return;
      }
      if (!e.ui.infoAt && !i.tools.t.guard && o.value && o.value.zoomKey(be, ae)) {
        be.preventDefault();
        return;
      }
      if (e.ui.infoAt || ae || i.tools.t.guard) return;
      const ye = _.value === "edit", Oe = be.key.toLowerCase();
      if (ye && bn(be) && (Oe === "y" || Oe === "z" && be.shiftKey)) {
        be.preventDefault(), i.redoMark();
        return;
      }
      if (ye && bn(be) && Oe === "z") {
        be.preventDefault(), i.undoMark();
        return;
      }
      if ((be.key === "Delete" || be.key === "Backspace") && !bn(be) && !be.altKey && !i.tools.t.open && !(ye && s.bar === "annotate" && s.selection.length)) {
        const Ue = s.peekId || s.stageId;
        if (Ue && i.canDelete(Ue)) {
          be.preventDefault(), i.deleteItem(Ue);
          return;
        }
      }
      if (!ye || i.tools.t.open || bn(be) || be.altKey) return;
      if (Oe === "m" || Oe === "x" || Oe === "n" && s.bar !== "annotate") {
        be.preventDefault(), i.setBar(Oe === "m" ? "edit" : Oe === "x" ? "erase" : "annotate");
        return;
      }
      if (Oe === "i") {
        be.preventDefault(), i.setDropper(!s.dropper);
        return;
      }
      if (s.bar !== "annotate") {
        const Ue = { b: "brush", l: "lasso", s: "object" }[Oe];
        if (Ue) {
          s.areaTool = Ue;
          return;
        }
        if (be.key === "[" || be.key === "]") {
          s.areaSize = Math.max(6, Math.min(200, Math.round(s.areaSize * (be.key === "]" ? 1.2 : 1 / 1.2))));
          return;
        }
        return;
      }
      if ((be.key === "Delete" || be.key === "Backspace") && s.selection.length) {
        be.preventDefault(), i.deleteStrokes(s.selection.slice());
        return;
      }
      const Ve = { v: "move", b: "brush", t: "text", r: "box", o: "ellipse", a: "arrow", e: "eraser", n: "note" }[Oe];
      Ve && (i.finishEditing(), s.tool = Ve, Ve !== "move" && i.select([]));
    }
    const { active: he, over: U, leave: q, stop: oe } = fx();
    function de(be) {
      U(be) && (be.preventDefault(), be.stopPropagation());
    }
    function pe(be) {
      if (oe(), !!be.dataTransfer) {
        be.preventDefault(), be.stopPropagation();
        for (const se of Array.from(be.dataTransfer.files || []).filter((ae) => ae.type.startsWith("image/")).slice(0, 14)) Ce(se);
      }
    }
    function Ce(be) {
      _.value === "edit" ? i.addUploadRef(be) : i.addUpload(be);
    }
    function Be(be) {
      if (e.ui.libraryOpen) return;
      const se = be.target;
      if (se && (se.tagName === "INPUT" || se.tagName === "TEXTAREA")) return;
      const ae = Array.from(be.clipboardData && be.clipboardData.files || []).filter((ye) => ye.type.startsWith("image/"));
      if (ae.length) {
        be.preventDefault();
        for (const ye of ae) Ce(ye);
      }
    }
    return it(() => {
      window.addEventListener("keydown", Me), window.addEventListener("paste", Be);
    }), We(() => {
      window.removeEventListener("keydown", Me), window.removeEventListener("paste", Be), l.value && e.promptLibrary.close(), d && d.disconnect();
    }), (be, se) => (g(), b("div", {
      class: G(["sv-root", ["in-" + m(s).studio, "side-" + _.value, { "is-dropper": m(s).dropper, "hist-shut": m(s).histShut }]]),
      "data-testid": "studios-view",
      onPointerdown: se[3] || (se[3] = Te((ae) => m(s).editingPin && m(i).commitPin(m(s).editingPin), ["self"])),
      onDragover: de,
      onDragleave: se[4] || (se[4] = //@ts-ignore
      (...ae) => m(q) && m(q)(...ae)),
      onDrop: pe
    }, [
      u("div", Jxe, [
        x.value && x.value.url && m(s).studio !== "threed" ? (g(), b("span", {
          key: x.value.url,
          style: ce({ backgroundImage: 'url("' + x.value.url + '")' })
        }, null, 4)) : z("", !0)
      ]),
      u("header", Zxe, [
        u("button", {
          class: "sv-back",
          title: "Back to the board (Esc)",
          "data-testid": "studio-back",
          onClick: ee
        }, [
          C($, {
            name: "ArrowLeft",
            size: 15
          })
        ]),
        u("div", Qxe, [
          u("span", ewe, [
            Y(E(A.value), 1),
            M.value !== A.value ? (g(), b(j, { key: 0 }, [
              Y(" · " + E(M.value), 1)
            ], 64)) : z("", !0)
          ]),
          u("span", {
            class: "name",
            title: w.value
          }, E(w.value), 9, twe)
        ]),
        v.value ? (g(), b("button", {
          key: 0,
          type: "button",
          class: "sv-session",
          title: "Back to the board, on " + v.value.name,
          "data-testid": "studio-session",
          onClick: me
        }, [
          se[5] || (se[5] = u("span", { class: "lb" }, "Session", -1)),
          u("span", iwe, [
            C($, {
              name: v.value.icon || "Image",
              size: 12
            }, null, 8, ["name"])
          ]),
          u("b", null, E(v.value.name), 1)
        ], 8, nwe)) : z("", !0),
        se[7] || (se[7] = u("span", { class: "sv-grow" }, null, -1)),
        S.value ? (g(), b("span", swe, E(S.value), 1)) : z("", !0),
        x.value && x.value.kind === "gen" && x.value.status === "done" && m(s).studio !== "threed" ? (g(), b("button", {
          key: 2,
          class: "sv-top-btn",
          title: "Its details, large",
          "data-testid": "studio-details",
          onClick: se[0] || (se[0] = (ae) => m(i).openInfo(x.value.id))
        }, [
          C($, {
            name: "Info",
            size: 14
          }),
          se[6] || (se[6] = Y(" Details", -1))
        ])) : z("", !0),
        C(vt, { name: "sv-hist-show" }, {
          default: Xe(() => [
            m(s).histShut ? (g(), b("button", {
              key: "pill" + P.value,
              class: G(["sv-top-btn sv-hist-show", { "is-new": P.value > 0 }]),
              title: P.value ? P.value + " new since you folded it: show history" : "Show history",
              "aria-label": "Show history",
              "data-testid": "studio-history-show",
              onClick: se[1] || (se[1] = (ae) => m(i).setHistShut(!1))
            }, [
              k.value ? (g(), b("span", {
                key: 0,
                class: "sh",
                style: ce({ backgroundImage: 'url("' + m(Bt)(k.value.url) + '")' })
              }, null, 4)) : (g(), Ie($, {
                key: 1,
                name: "PanelRightOpen",
                size: 14
              })),
              u("span", null, E(m(s).pinned ? "Pinned" : "History"), 1),
              u("span", {
                class: G(["n", { "is-new": P.value > 0 }])
              }, E(P.value ? "+" + P.value : m(i).shown.value.length), 3)
            ], 10, owe)) : z("", !0)
          ]),
          _: 1
        }),
        u("button", {
          class: "sv-close",
          title: "Close (Esc)",
          "data-testid": "studio-close",
          onClick: ee
        }, [
          C($, {
            name: "X",
            size: 16
          })
        ])
      ]),
      u("nav", rwe, [
        u("div", {
          class: "sv-seg is-text sv-sides ed-slide",
          role: "tablist",
          "aria-label": "Generate or edit",
          style: ce({ "--i": Math.max(0, R.value.findIndex((ae) => ae.id === _.value)), "--n": R.value.length })
        }, [
          (g(!0), b(j, null, ge(R.value, (ae) => (g(), b("button", {
            key: ae.id,
            role: "tab",
            "aria-selected": _.value === ae.id,
            class: G({ on: _.value === ae.id }),
            disabled: ae.id === "edit" && _.value !== "edit" && !m(i).canEdit(),
            title: ae.id === "edit" ? "Change an image: say what to change, select an area, annotate it, or use a tool" : m(i).video.value ? "Make videos: from a prompt, and the pictures they start from" : "Make images: from a prompt, or a 3D view",
            "data-testid": "studio-side-" + ae.id,
            onClick: (ye) => ie(ae.id)
          }, [
            C($, {
              name: ae.icon,
              size: 13
            }, null, 8, ["name"]),
            Y(" " + E(ae.label), 1)
          ], 10, awe))), 128))
        ], 4),
        C(vt, {
          name: "ed-side",
          mode: "out-in"
        }, {
          default: Xe(() => [
            _.value === "edit" ? (g(), Ie(sxe, { key: "edit" })) : (g(), b("div", lwe, [
              (g(!0), b(j, null, ge(D.value, (ae) => (g(), b("section", {
                key: ae.id,
                class: G(["ed-tool", { on: m(s).studio === ae.id }])
              }, [
                u("button", {
                  class: "ed-tool-head",
                  role: "radio",
                  title: ae.id === "prompt" ? O.value : ae.tip,
                  "aria-checked": m(s).studio === ae.id,
                  "data-testid": "studio-pick-" + ae.id,
                  onClick: (ye) => F(ae.id)
                }, [
                  C(_m, {
                    on: m(s).studio === ae.id
                  }, null, 8, ["on"]),
                  C($, {
                    name: ae.icon,
                    size: 15,
                    class: "ic"
                  }, null, 8, ["name"]),
                  u("span", cwe, E(ae.label), 1)
                ], 8, dwe),
                m(s).studio === ae.id ? (g(), b("div", {
                  key: 0,
                  class: "ed-tool-body is-plain",
                  "data-testid": "studio-panel-" + ae.id
                }, [
                  ae.id === "threed" ? (g(), Ie(mxe, {
                    key: 0,
                    fly: ue,
                    capture: te,
                    onUploadModel: N,
                    onLibraryModel: Q
                  })) : m(i).videoField() ? (g(), b("p", hwe, "Choose the video to edit in the box below, then say what to change.")) : m(i).video.value ? (g(), b("p", pwe, "Say what you want in the box below. Queue pictures there for the video to start from, image 1 first.")) : (g(), b("p", fwe, "Say what you want in the box below. Queue images there to start from them, image 1 first; their annotations and notes go with them."))
                ], 8, uwe)) : z("", !0)
              ], 2))), 128))
            ]))
          ]),
          _: 1
        })
      ]),
      u("main", mwe, [
        C(vt, { name: "bd-dropper" }, {
          default: Xe(() => [
            m(s).dropper ? (g(), b("div", gwe, [
              u("span", bwe, [
                C($, {
                  name: "Pipette",
                  size: 13
                })
              ]),
              u("span", vwe, E(_.value === "edit" ? "Click a picture in history to send it with the edit" : "Click a picture in history to add it to the next image"), 1),
              u("span", ywe, E(Fe.value), 1),
              u("button", {
                class: "bd-dropper-done",
                title: "Done (Esc)",
                "data-testid": "studio-dropper-done",
                onClick: se[2] || (se[2] = (ae) => m(i).setDropper(!1))
              }, "Done")
            ])) : z("", !0)
          ]),
          _: 1
        }),
        C(Ame, {
          ref_key: "stageRef",
          ref: o,
          onUpload: L,
          onUploadModel: N,
          onLibraryModel: Q,
          onUploadVideo: H
        }, null, 512),
        l.value && _.value === "generate" ? (g(), b("div", {
          key: 0,
          class: "sv-pl-float",
          style: ce({ bottom: a.value + "px" })
        }, [
          C(Qy, { floating: "" })
        ], 4)) : z("", !0),
        _.value === "generate" ? (g(), b("div", {
          key: 1,
          ref_key: "dockEl",
          ref: r,
          class: "sv-dock"
        }, [
          C(vt, { name: "sv-note" }, {
            default: Xe(() => [
              m(s).note ? (g(), b("div", {
                key: m(s).note.id,
                class: "sv-note",
                role: "status"
              }, E(m(s).note.text), 1)) : z("", !0)
            ]),
            _: 1
          }),
          C(ege),
          C(Dbe, {
            before: we.value,
            label: we.value ? "Run from view" : null
          }, null, 8, ["before", "label"])
        ], 512)) : (g(), Ie(Jve, { key: 2 }))
      ]),
      C(Yxe),
      m(he) ? (g(), b("div", xwe, [
        u("div", null, [
          C($, {
            name: "ImagePlus",
            size: 18
          }),
          Y(" " + E(_.value === "edit" ? "Drop images to send them with the edit" : "Drop images to add them to the queue"), 1)
        ])
      ])) : z("", !0),
      u("input", {
        ref_key: "imageInput",
        ref: c,
        type: "file",
        accept: "image/*",
        multiple: "",
        style: { display: "none" },
        onChange: K
      }, null, 544),
      u("input", {
        ref_key: "modelInput",
        ref: h,
        type: "file",
        accept: ".glb,.gltf,.obj,.stl",
        style: { display: "none" },
        onChange: B
      }, null, 544),
      u("input", {
        ref_key: "videoInput",
        ref: re,
        type: "file",
        accept: "video/*",
        style: { display: "none" },
        onChange: J
      }, null, 544)
    ], 34));
  }
}), kwe = ["disabled"], _we = ["disabled"], Swe = { class: "lb-peek-shell" }, Mwe = { class: "lb-peek-stage" }, Twe = {
  key: 0,
  class: "lb-peek-withheld"
}, Cwe = { class: "lb-empty-mark is-warn" }, Iwe = ["src", "poster"], Awe = ["src"], Pwe = { class: "lb-peek-side" }, Ewe = { class: "lb-peek-top" }, Rwe = { class: "n" }, zwe = ["title", "aria-pressed"], $we = ["title", "aria-pressed"], Dwe = ["title"], Owe = {
  key: 0,
  class: "lb-peek-confirm"
}, Lwe = { class: "lb-peek-block" }, Bwe = { class: "lb-peek-head" }, Fwe = { class: "lb-peek-prompt" }, Nwe = { class: "lb-peek-specs" }, Uwe = { key: 0 }, Gwe = { key: 1 }, jwe = { key: 2 }, Hwe = {
  key: 0,
  class: "lb-peek-acts"
}, Vwe = ["disabled"], Wwe = /* @__PURE__ */ Pe({
  __name: "LibraryPeek",
  props: {
    lib: {},
    item: {},
    placing: { type: Boolean },
    single: { type: Boolean },
    model: {}
  },
  emits: ["close", "pick", "star", "remove"],
  setup(n, { emit: e }) {
    const t = n, i = e, { board: s } = Ze(), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(""), a = /* @__PURE__ */ W(!1), l = I(() => t.lib.shown.value), d = I(() => l.value.findIndex((_) => _.id === t.item.id)), c = I(() => t.lib.order(t.item.id)), h = I(() => t.item.w && t.item.h ? t.item.w + " × " + t.item.h : ""), f = I(() => t.lib.faved(t.item)), p = I(() => s.isPinnedImage(t.item.url));
    Ee(() => t.item.id, () => {
      a.value = !1;
    });
    function y(_) {
      const T = l.value.length;
      T < 2 || d.value < 0 || (t.lib.s.peek = l.value[(d.value + _ + T) % T]);
    }
    async function v() {
      if (t.item.prompt)
        try {
          await navigator.clipboard.writeText(t.item.prompt), o.value = !0, window.setTimeout(() => {
            o.value = !1;
          }, 1400);
        } catch {
        }
    }
    function x() {
      const _ = t.item, T = _.video && _.videoSrc ? _.videoSrc : _.url, k = (/(\.\w{3,4})(\?|$)/.exec(T.replace(/%2F/gi, "/")) || ["", _.video ? ".mp4" : ".webp"])[1], P = _.run ? uf(_.prompt || "", _.run.uuid, T) : _.label.replace(/\.[a-z0-9]+$/i, "") + k;
      s.saveFile(T, P);
    }
    function w() {
      if (!a.value) {
        a.value = !0;
        return;
      }
      a.value = !1, i("remove", t.item);
    }
    function S() {
      s.placeFromLibrary([t.item]), s.closeLibrary();
    }
    function M(_) {
      const T = _.target;
      T && (T.tagName === "INPUT" || T.tagName === "TEXTAREA") || (_.key === "ArrowLeft" ? (_.preventDefault(), y(-1)) : _.key === "ArrowRight" && (_.preventDefault(), y(1)));
    }
    return it(() => window.addEventListener("keydown", M)), We(() => window.removeEventListener("keydown", M)), (_, T) => (g(), b("div", {
      class: "lb-peek",
      "data-testid": "library-peek",
      onPointerdown: T[8] || (T[8] = Te((k) => i("close"), ["self"]))
    }, [
      u("button", {
        class: "lb-peek-nav at-left",
        title: "Previous (←)",
        disabled: l.value.length < 2,
        onClick: T[0] || (T[0] = (k) => y(-1))
      }, [
        C($, {
          name: "ChevronLeft",
          size: 20
        })
      ], 8, kwe),
      u("button", {
        class: "lb-peek-nav at-right",
        title: "Next (→)",
        disabled: l.value.length < 2,
        onClick: T[1] || (T[1] = (k) => y(1))
      }, [
        C($, {
          name: "ChevronRight",
          size: 20
        })
      ], 8, _we),
      u("div", Swe, [
        u("div", Mwe, [
          n.item.moderated ? (g(), b("div", Twe, [
            u("span", Cwe, [
              C($, {
                name: "EyeOff",
                size: 20
              })
            ]),
            T[9] || (T[9] = u("b", null, "Moderated by RunDiffusion", -1)),
            T[10] || (T[10] = u("span", null, "This image was flagged by our moderation system. This can happen because of NSFW, copyright, gore, or other related reasons. This system is currently a work in progress, please have patience as we work to improve it.", -1))
          ])) : n.item.video && n.item.videoSrc ? (g(), b("video", {
            key: n.item.videoSrc,
            class: "lb-peek-art",
            src: n.item.videoSrc,
            poster: n.item.url,
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            controls: "",
            controlslist: "nodownload noplaybackrate",
            disablepictureinpicture: ""
          }, null, 8, Iwe)) : (g(), b("img", {
            key: n.item.url,
            class: G(["lb-peek-art", { "is-loading": r.value !== n.item.url }]),
            src: n.item.url,
            alt: "",
            draggable: "false",
            onLoad: T[2] || (T[2] = (k) => r.value = n.item.url)
          }, null, 42, Awe))
        ]),
        u("aside", Pwe, [
          u("div", Ewe, [
            u("span", Rwe, [
              C($, {
                name: "Images",
                size: 13
              }),
              Y(" " + E(d.value >= 0 ? d.value + 1 : "–") + " of " + E(l.value.length), 1)
            ]),
            T[11] || (T[11] = u("span", { class: "lb-grow" }, null, -1)),
            n.item.moderated ? z("", !0) : (g(), b("button", {
              key: 0,
              class: G(["lb-peek-act lb-peek-pin", { on: p.value }]),
              title: p.value ? m(Xn).unpin : m(Xn).pin,
              "aria-pressed": p.value,
              "data-testid": "library-peek-pin",
              onClick: T[3] || (T[3] = (k) => m(s).togglePinImage(m(aU)(n.item)))
            }, [
              C($, {
                name: "Pin",
                size: 14
              })
            ], 10, zwe)),
            n.lib.canStar(n.item) ? (g(), b("button", {
              key: 1,
              class: G(["lb-peek-act lb-peek-star", { on: f.value }]),
              title: f.value ? "Remove from your favorites" : "Add to your favorites",
              "aria-pressed": f.value,
              "data-testid": "library-peek-star",
              onClick: T[4] || (T[4] = (k) => i("star", n.item))
            }, [
              C($, {
                name: "Heart",
                size: 14
              })
            ], 10, $we)) : z("", !0),
            n.item.moderated ? z("", !0) : (g(), b("button", {
              key: 2,
              class: "lb-peek-act",
              title: "Download",
              "data-testid": "library-peek-download",
              onClick: x
            }, [
              C($, {
                name: "Download",
                size: 14
              })
            ])),
            n.lib.canRemove(n.item) ? (g(), b("button", {
              key: 3,
              class: G(["lb-peek-act is-danger", { "is-confirming": a.value }]),
              title: a.value ? "Click again to delete it for good" : n.item.uploadId ? "Delete this upload" : "Delete this generation",
              "data-testid": "library-peek-delete",
              onClick: w,
              onBlur: T[5] || (T[5] = (k) => a.value = !1)
            }, [
              C($, {
                name: a.value ? "Check" : "Trash2",
                size: 14
              }, null, 8, ["name"]),
              a.value ? (g(), b("span", Owe, "Delete?")) : z("", !0)
            ], 42, Dwe)) : z("", !0),
            u("button", {
              class: "lb-peek-act",
              title: "Back to your Library (Esc)",
              "data-testid": "library-peek-close",
              onClick: T[6] || (T[6] = (k) => i("close"))
            }, [
              C($, {
                name: "X",
                size: 15
              })
            ])
          ]),
          u("div", Lwe, [
            u("div", Bwe, [
              u("span", null, [
                C($, {
                  name: "MessageSquare",
                  size: 13
                }),
                Y(" " + E(n.item.prompt ? "Prompt" : "Name"), 1)
              ]),
              n.item.prompt ? (g(), b("button", {
                key: 0,
                title: "Copy the prompt",
                onClick: v
              }, [
                C($, {
                  name: o.value ? "Check" : "Clipboard",
                  size: 13
                }, null, 8, ["name"])
              ])) : z("", !0)
            ]),
            u("p", Fwe, E(n.item.prompt || n.item.label), 1)
          ]),
          u("dl", Nwe, [
            n.model ? (g(), b("div", Uwe, [
              T[12] || (T[12] = u("dt", null, "Model", -1)),
              u("dd", null, E(n.model), 1)
            ])) : z("", !0),
            n.item.createdAt ? (g(), b("div", Gwe, [
              u("dt", null, E(n.item.uploadId ? "Uploaded" : "Made"), 1),
              u("dd", null, E(m(R1)(n.item.createdAt)), 1)
            ])) : z("", !0),
            h.value ? (g(), b("div", jwe, [
              T[13] || (T[13] = u("dt", null, "Size", -1)),
              u("dd", null, E(h.value), 1)
            ])) : z("", !0),
            u("div", null, [
              T[14] || (T[14] = u("dt", null, "Kind", -1)),
              u("dd", null, E(n.item.uploadId ? "Upload" : n.item.video ? "Video" : "Image") + E(f.value ? ", a favorite" : ""), 1)
            ])
          ]),
          T[16] || (T[16] = u("span", { class: "lb-grow" }, null, -1)),
          n.item.moderated ? z("", !0) : (g(), b("div", Hwe, [
            u("button", {
              class: G(["lb-btn", c.value ? "is-picked" : ""]),
              disabled: !n.lib.allowed(n.item) || !c.value && n.lib.full() && !n.single,
              "data-testid": "library-peek-pick",
              onClick: T[7] || (T[7] = (k) => i("pick", n.item))
            }, [
              C($, {
                name: c.value ? "Check" : "Plus",
                size: 14
              }, null, 8, ["name"]),
              Y(" " + E(n.single ? "Use this one" : c.value ? "Picked (" + c.value + ")" : "Pick"), 1)
            ], 10, Vwe),
            n.placing ? (g(), b("button", {
              key: 0,
              class: "lb-btn is-primary",
              "data-testid": "library-peek-place",
              onClick: S
            }, [
              C($, {
                name: "ArrowDownToLine",
                size: 14
              }),
              T[15] || (T[15] = Y(" Place on the board ", -1))
            ])) : z("", !0)
          ]))
        ])
      ])
    ], 32));
  }
}), qwe = ["data-lb-own-keys"], Kwe = ["aria-expanded", "data-testid"], Ywe = { class: "t" }, Xwe = {
  key: 1,
  class: "bd-spinner is-sm"
}, Jwe = {
  key: 0,
  class: "lb-select-pop",
  role: "listbox"
}, Zwe = {
  key: 0,
  class: "lb-select-search"
}, Qwe = { class: "lb-select-rows" }, eke = ["aria-selected", "onMouseenter", "onClick"], tke = { class: "t" }, nke = {
  key: 0,
  class: "lb-select-none"
}, Uh = /* @__PURE__ */ Pe({
  __name: "LibrarySelect",
  props: {
    modelValue: { default: void 0 },
    options: {},
    anyText: {},
    icon: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    testid: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(!1), o = /* @__PURE__ */ W(""), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(0), d = I(() => t.options.find((w) => w.value === t.modelValue) || null), c = I(() => t.options.length > 8), h = I(() => {
      const w = o.value.trim().toLowerCase();
      return w ? t.options.filter((S) => S.text.toLowerCase().includes(w)) : t.options;
    }), f = I(() => [null, ...h.value]);
    function p() {
      s.value = !s.value;
    }
    function y(w) {
      i("update:modelValue", w ? w.value : void 0), s.value = !1;
    }
    function v(w) {
      s.value && (w.key === "Escape" ? (w.preventDefault(), w.stopPropagation(), s.value = !1) : w.key === "ArrowDown" ? (w.preventDefault(), l.value = Math.min(f.value.length - 1, l.value + 1)) : w.key === "ArrowUp" ? (w.preventDefault(), l.value = Math.max(0, l.value - 1)) : w.key === "Enter" && (w.preventDefault(), y(f.value[l.value])));
    }
    function x(w) {
      r.value && !r.value.contains(w.target) && (s.value = !1);
    }
    return Ee(s, (w) => {
      o.value = "", l.value = Math.max(0, f.value.findIndex((S) => (S ? S.value : void 0) === t.modelValue)), w ? (window.addEventListener("pointerdown", x, !0), nt(() => {
        a.value && a.value.focus();
      })) : window.removeEventListener("pointerdown", x, !0);
    }), Ee(o, () => {
      l.value = 0;
    }), We(() => window.removeEventListener("pointerdown", x, !0)), (w, S) => (g(), b("div", {
      ref_key: "root",
      ref: r,
      class: "lb-select-wrap",
      "data-lb-own-keys": s.value ? "" : void 0,
      onKeydown: v
    }, [
      u("button", {
        class: G(["lb-select-btn", { on: s.value, "is-set": !!d.value }]),
        "aria-expanded": s.value,
        "data-testid": n.testid,
        onClick: p
      }, [
        n.icon ? (g(), Ie($, {
          key: 0,
          name: n.icon,
          size: 13
        }, null, 8, ["name"])) : z("", !0),
        u("span", Ywe, E(d.value ? d.value.text : n.anyText), 1),
        n.loading ? (g(), b("span", Xwe)) : (g(), Ie($, {
          key: 2,
          name: "ChevronDown",
          size: 13,
          class: "chev"
        }))
      ], 10, Kwe),
      s.value ? (g(), b("div", Jwe, [
        c.value ? (g(), b("label", Zwe, [
          C($, {
            name: "Search",
            size: 13
          }),
          _t(u("input", {
            ref_key: "searchEl",
            ref: a,
            "onUpdate:modelValue": S[0] || (S[0] = (M) => o.value = M),
            type: "text",
            spellcheck: "false",
            placeholder: "Find",
            "aria-label": "Find in the list"
          }, null, 512), [
            [Zt, o.value]
          ])
        ])) : z("", !0),
        u("div", Qwe, [
          (g(!0), b(j, null, ge(f.value, (M, _) => (g(), b("button", {
            key: M ? M.value : "(any)",
            class: G(["lb-select-row", { on: (M ? M.value : void 0) === n.modelValue, "is-active": _ === l.value, "is-any": !M }]),
            role: "option",
            "aria-selected": (M ? M.value : void 0) === n.modelValue,
            onMouseenter: (T) => l.value = _,
            onClick: (T) => y(M)
          }, [
            u("span", tke, E(M ? M.text : n.anyText), 1),
            (M ? M.value : void 0) === n.modelValue ? (g(), Ie($, {
              key: 0,
              name: "Check",
              size: 13
            })) : z("", !0)
          ], 42, eke))), 128)),
          h.value.length ? z("", !0) : (g(), b("div", nke, "Nothing matches “" + E(o.value.trim()) + "”", 1))
        ])
      ])) : z("", !0)
    ], 40, qwe));
  }
});
function ike(n) {
  return n.model3d ? "3d" : n.video ? "video" : "image";
}
const x4 = { image: ["picture", "pictures"], video: ["video", "videos"], "3d": ["3D model", "3D models"] };
function ske(n, e, t) {
  if (t) return "Pick pictures to place on the board";
  const [i, s] = n.length === 1 ? x4[n[0]] : x4.image;
  return e === 1 ? "Pick a " + i : "Pick up to " + e + " " + s;
}
const oke = 2, sA = [
  { value: "1:1", text: "1:1 (Square)" },
  { value: "16:9", text: "16:9 (Landscape)" },
  { value: "2:1", text: "2:1" },
  { value: "3:2", text: "3:2" },
  { value: "4:3", text: "4:3" },
  { value: "21:9", text: "21:9 (Ultrawide)" },
  { value: "9:16", text: "9:16 (Portrait)" },
  { value: "2:3", text: "2:3" },
  { value: "3:4", text: "3:4" },
  { value: "OTHER", text: "Other" }
], oA = [
  { value: "1K", text: "1K (~1024px)" },
  { value: "2K", text: "2K (~2048px)" },
  { value: "4K+", text: "4K+ (4096px and up)" }
];
function Sm(n) {
  const e = (n || "").trim();
  return e.length >= oke ? e : "";
}
function rA(n) {
  return Bf(n) > 0;
}
function Bf(n) {
  if (!n) return 0;
  let e = 0;
  for (const t of ["aspect", "resolution", "tool", "family", "media", "board"]) n[t] && e++;
  return (n.from || n.to) && e++, n.favorited && e++, e;
}
const Jr = 24;
function rke(n, e = {}) {
  const t = e.filters || {}, i = typeof e.cursor == "string" ? e.cursor : null, s = { limit: Jr };
  return i && (s.cursor = i), n === "favorites" ? (s.favorites = !0, s) : (s.filters = {
    aspectRatioFilter: t.aspect || null,
    resolutionFilter: t.resolution || null,
    toolFilter: t.tool || null,
    modelFamilyTagFilter: t.family || null,
    mediaTagFilter: t.media || null,
    dateFromFilter: t.from || null,
    dateToFilter: t.to || null,
    favoriteFilter: t.favorited ? "favorited" : null,
    // a search answers in one page: never sent with a cursor
    searchFilter: i ? null : Sm(e.search) || null
  }, t.board && (s.runnitId = t.board), s);
}
function ake(n) {
  switch (n.code) {
    case "ACCOUNT_NOT_MEMBER":
      return "You are not a member of the selected team account";
    case "EMAIL_NOT_VERIFIED":
      return "Verify your email in the web app before filtering team generations";
    case "ANONYMOUS_NOT_ALLOWED":
      return "Sign in with your account to filter generations";
    case "ACCOUNT_NOT_FOUND":
      return "That team account no longer exists";
    case "PERMISSION_DENIED":
      return "You do not have permission to view these generations";
  }
  return n.reason === "unauthorized" ? "Your session expired, please sign in again" : n.reason === "forbidden" ? "You do not have permission to view these generations" : "Could not load filtered generations, please try again";
}
function G0(n, e, t) {
  const i = { storageUrl: e.storageUrl, modelName: e.modelName, authorName: () => "" }, s = [];
  for (const o of fS(n, i)) {
    if (!o.asset || o.status !== "done" && o.status !== "moderated") continue;
    const r = o.asset.nodeRunResult;
    if (r && r.type === "MODEL") continue;
    const a = r && r.file && typeof r.file.name == "string" ? r.file.name : "", l = (/\.([a-z0-9]+)$/i.exec(a) || ["", "glb"])[1].toLowerCase(), d = (t || o.prompt || "").trim();
    s.push({
      id: o.id,
      url: o.url,
      thumb: o.thumb,
      w: o.w,
      h: o.h,
      video: o.kind === "video",
      videoSrc: o.videoSrc,
      model3d: o.kind === "3d" && o.download ? { url: o.download, ext: l } : void 0,
      label: d || o.model || "Generation",
      prompt: d,
      model: o.model || void 0,
      createdAt: o.createdAt,
      moderated: o.status === "moderated" || void 0,
      mine: n.userId === e.uid,
      run: {
        id: n.id,
        uuid: o.uuid || "",
        nodeDefId: n.nodeDefId,
        nodeId: n.nodeId,
        runnitId: n.runnitId,
        type: r && typeof r.type == "string" ? r.type : o.kind === "video" ? "VID" : "IMG"
      },
      asset: o.asset
    });
  }
  return s;
}
function lke(n, e, t) {
  const i = [];
  for (const s of n) {
    const o = {
      id: s.id,
      runnitId: s.board_id || "",
      nodeId: s.node_id || "",
      nodeDefId: s.tool_id || "",
      userId: s.user_id || "",
      teamId: s.team_id,
      email: s.email || void 0,
      state: "DONE",
      initAt: s.init_at ? Date.parse(s.init_at) : void 0,
      doneAt: s.done_at ? Date.parse(s.done_at) : void 0,
      results: s.results || []
    }, r = (a) => e[a] && e[a].title || t.modelName(a);
    i.push(...G0(o, { ...t, modelName: r }, s.prompt));
  }
  return i;
}
const dke = {
  class: "lb-filters",
  "data-testid": "library-filters",
  "aria-label": "Filters"
}, cke = { class: "lb-filters-grid" }, uke = { class: "lb-field is-wide" }, hke = { class: "lb-chips" }, pke = ["title", "data-testid", "onClick"], fke = { class: "lb-field" }, mke = { class: "lb-chips" }, gke = ["title", "onClick"], bke = { class: "lb-field" }, vke = { class: "lb-chips" }, yke = { class: "lb-field" }, xke = { class: "lb-field" }, wke = { class: "lb-field" }, kke = { class: "lb-field" }, _ke = { class: "lb-field is-dates" }, Ske = { class: "lb-dates" }, Mke = ["value", "max"], Tke = ["value", "min"], Cke = { class: "lb-filters-foot" }, Ike = { class: "lb-filters-count" }, Ake = ["disabled"], Pke = /* @__PURE__ */ Pe({
  __name: "LibraryFilters",
  props: {
    lib: {},
    options: {},
    loading: { type: Boolean }
  },
  setup(n) {
    const e = n, t = e.lib.s, i = I(() => Bf(t.draft)), s = I(() => JSON.stringify(o(t.draft)) !== JSON.stringify(o(t.filters)));
    function o(d) {
      const c = {};
      for (const [h, f] of Object.entries(d)) f && (c[h] = f);
      return c;
    }
    function r(d, c) {
      t.draft = { ...t.draft, [d]: c };
    }
    function a(d) {
      const c = /^(\d+):(\d+)$/.exec(d);
      if (!c) return { width: "12px", height: "12px" };
      const h = Number(c[1]) / Number(c[2]), f = 15;
      return h >= 1 ? { width: f + "px", height: Math.max(5, Math.round(f / h)) + "px" } : { width: Math.max(5, Math.round(f * h)) + "px", height: f + "px" };
    }
    function l() {
      e.lib.applyFilters({});
    }
    return (d, c) => (g(), b("section", dke, [
      u("div", cke, [
        u("div", uke, [
          c[13] || (c[13] = u("span", { class: "lb-field-label" }, "Aspect ratio", -1)),
          u("div", hke, [
            u("button", {
              class: G(["lb-chip", { on: !m(t).draft.aspect }]),
              onClick: c[0] || (c[0] = (h) => r("aspect", void 0))
            }, "Any", 2),
            (g(!0), b(j, null, ge(m(sA), (h) => (g(), b("button", {
              key: h.value,
              class: G(["lb-chip", { on: m(t).draft.aspect === h.value }]),
              title: h.text,
              "data-testid": "library-aspect-" + h.value,
              onClick: (f) => r("aspect", m(t).draft.aspect === h.value ? void 0 : h.value)
            }, [
              u("i", {
                class: G(["glyph", { "is-other": h.value === "OTHER" }]),
                style: ce(a(h.value))
              }, null, 6),
              Y(" " + E(h.value === "OTHER" ? "Other" : h.value), 1)
            ], 10, pke))), 128))
          ])
        ]),
        u("div", fke, [
          c[14] || (c[14] = u("span", { class: "lb-field-label" }, "Resolution", -1)),
          u("div", mke, [
            u("button", {
              class: G(["lb-chip", { on: !m(t).draft.resolution }]),
              onClick: c[1] || (c[1] = (h) => r("resolution", void 0))
            }, "Any", 2),
            (g(!0), b(j, null, ge(m(oA), (h) => (g(), b("button", {
              key: h.value,
              class: G(["lb-chip", { on: m(t).draft.resolution === h.value }]),
              title: h.text,
              onClick: (f) => r("resolution", m(t).draft.resolution === h.value ? void 0 : h.value)
            }, E(h.value), 11, gke))), 128))
          ])
        ]),
        u("div", bke, [
          c[16] || (c[16] = u("span", { class: "lb-field-label" }, "Show", -1)),
          u("div", vke, [
            u("button", {
              class: G(["lb-chip", { on: !m(t).draft.favorited }]),
              onClick: c[2] || (c[2] = (h) => r("favorited", void 0))
            }, "All", 2),
            u("button", {
              class: G(["lb-chip", { on: !!m(t).draft.favorited }]),
              "data-testid": "library-only-favorites",
              onClick: c[3] || (c[3] = (h) => r("favorited", !0))
            }, [
              C($, {
                name: "Heart",
                size: 12
              }),
              c[15] || (c[15] = Y(" Favorited", -1))
            ], 2)
          ])
        ]),
        u("div", yke, [
          c[17] || (c[17] = u("span", { class: "lb-field-label" }, "Tool", -1)),
          C(Uh, {
            "model-value": m(t).draft.tool,
            options: n.options ? n.options.tools : [],
            "any-text": "Any tool",
            icon: "Wand2",
            loading: n.loading && !n.options,
            testid: "library-filter-tool",
            "onUpdate:modelValue": c[4] || (c[4] = (h) => r("tool", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", xke, [
          c[18] || (c[18] = u("span", { class: "lb-field-label" }, "Model family", -1)),
          C(Uh, {
            "model-value": m(t).draft.family,
            options: n.options ? n.options.families : [],
            "any-text": "Any family",
            icon: "Layers",
            loading: n.loading && !n.options,
            "onUpdate:modelValue": c[5] || (c[5] = (h) => r("family", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", wke, [
          c[19] || (c[19] = u("span", { class: "lb-field-label" }, "Media", -1)),
          C(Uh, {
            "model-value": m(t).draft.media,
            options: n.options ? n.options.media : [],
            "any-text": "Any media",
            icon: "Images",
            loading: n.loading && !n.options,
            "onUpdate:modelValue": c[6] || (c[6] = (h) => r("media", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", kke, [
          c[20] || (c[20] = u("span", { class: "lb-field-label" }, "Board", -1)),
          C(Uh, {
            "model-value": m(t).draft.board,
            options: n.options ? n.options.boards : [],
            "any-text": "Any board",
            icon: "LayoutGrid",
            loading: n.loading && !n.options,
            "onUpdate:modelValue": c[7] || (c[7] = (h) => r("board", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", _ke, [
          c[22] || (c[22] = u("span", { class: "lb-field-label" }, "Made between", -1)),
          u("div", Ske, [
            u("input", {
              value: m(t).draft.from || "",
              type: "date",
              max: m(t).draft.to || void 0,
              "aria-label": "From",
              "data-testid": "library-from",
              onInput: c[8] || (c[8] = (h) => r("from", h.target.value || void 0))
            }, null, 40, Mke),
            c[21] || (c[21] = u("span", { class: "to" }, "to", -1)),
            u("input", {
              value: m(t).draft.to || "",
              type: "date",
              min: m(t).draft.from || void 0,
              "aria-label": "To",
              "data-testid": "library-to",
              onInput: c[9] || (c[9] = (h) => r("to", h.target.value || void 0))
            }, null, 40, Tke),
            m(t).draft.from || m(t).draft.to ? (g(), b("button", {
              key: 0,
              class: "lb-dates-x",
              title: "Clear the dates",
              onClick: c[10] || (c[10] = (h) => m(t).draft = { ...m(t).draft, from: void 0, to: void 0 })
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])) : z("", !0)
          ])
        ])
      ]),
      u("footer", Cke, [
        u("span", Ike, E(i.value ? i.value + (i.value === 1 ? " filter" : " filters") : "No filters"), 1),
        i.value || n.lib.filtersOn() ? (g(), b("button", {
          key: 0,
          class: "lb-link",
          "data-testid": "library-filters-clear",
          onClick: l
        }, [
          C($, {
            name: "RotateCcw",
            size: 12
          }),
          c[23] || (c[23] = Y(" Clear all", -1))
        ])) : z("", !0),
        c[25] || (c[25] = u("span", { class: "lb-grow" }, null, -1)),
        u("button", {
          class: "lb-btn is-ghost",
          onClick: c[11] || (c[11] = (h) => n.lib.cancelFilters())
        }, "Cancel"),
        u("button", {
          class: "lb-btn is-primary",
          disabled: !s.value,
          "data-testid": "library-filters-apply",
          onClick: c[12] || (c[12] = (h) => n.lib.applyFilters())
        }, [
          C($, {
            name: "Check",
            size: 14
          }),
          c[24] || (c[24] = Y(" Apply filters", -1))
        ], 8, Ake)
      ])
    ]));
  }
}), Eke = ["data-testid"], Rke = {
  key: 0,
  class: "hill b"
}, zke = { class: "le-spark" }, $ke = { class: "le-prompt" }, Dke = { class: "le-drop" }, Oke = { class: "le-check" }, Lke = { class: "le-burst" }, Bke = { class: "le-heart" }, Fke = {
  key: 0,
  class: "le-lens"
}, Ob = /* @__PURE__ */ Pe({
  __name: "LibraryEmptyArt",
  props: {
    kind: {}
  },
  setup(n) {
    return (e, t) => (g(), b("div", {
      class: G(["le", "is-" + n.kind]),
      "aria-hidden": "true",
      "data-testid": "library-empty-art-" + n.kind
    }, [
      t[9] || (t[9] = u("i", { class: "le-glow" }, null, -1)),
      n.kind === "generations" ? (g(), b(j, { key: 0 }, [
        (g(), b(j, null, ge(3, (i) => u("i", {
          key: i,
          class: G(["le-pic", "p" + i])
        }, [
          t[0] || (t[0] = u("i", { class: "sun" }, null, -1)),
          t[1] || (t[1] = u("i", { class: "hill" }, null, -1)),
          i === 2 ? (g(), b("i", Rke)) : z("", !0)
        ], 2)), 64)),
        u("i", zke, [
          C($, {
            name: "Sparkles",
            size: 12
          })
        ]),
        u("i", $ke, [
          C($, {
            name: "Sparkles",
            size: 11
          }),
          t[2] || (t[2] = u("i", { class: "t1" }, null, -1)),
          t[3] || (t[3] = u("i", { class: "t2" }, null, -1)),
          t[4] || (t[4] = u("i", { class: "run" }, null, -1))
        ])
      ], 64)) : n.kind === "uploads" ? (g(), b(j, { key: 1 }, [
        u("i", Dke, [
          C($, {
            name: "Upload",
            size: 14
          })
        ]),
        t[5] || (t[5] = u("i", { class: "le-pic u" }, [
          u("i", { class: "sun" }),
          u("i", { class: "hill" }),
          u("i", { class: "hill b" })
        ], -1)),
        u("i", Oke, [
          C($, {
            name: "Check",
            size: 11
          })
        ])
      ], 64)) : n.kind === "favorites" ? (g(), b(j, { key: 2 }, [
        t[6] || (t[6] = C1('<i class="le-pic f1"><i class="sun"></i><i class="hill"></i></i><i class="le-pic f3"><i class="sun"></i><i class="hill"></i></i><i class="le-pic f2"><i class="sun"></i><i class="hill"></i><i class="hill b"></i></i>', 3)),
        u("i", Lke, [
          (g(), b(j, null, ge(6, (i) => u("i", {
            key: i,
            class: G("b" + i)
          }, null, 2)), 64))
        ]),
        u("i", Bke, [
          C($, {
            name: "Heart",
            size: 12
          })
        ])
      ], 64)) : (g(), b(j, { key: 3 }, [
        (g(), b(j, null, ge(3, (i) => u("i", {
          key: i,
          class: G(["le-ghost", "g" + i])
        }, null, 2)), 64)),
        n.kind === "search" ? (g(), b("i", Fke)) : (g(), b(j, { key: 1 }, [
          t[7] || (t[7] = u("i", { class: "le-track t1" }, [
            u("i", { class: "knob" })
          ], -1)),
          t[8] || (t[8] = u("i", { class: "le-track t2" }, [
            u("i", { class: "knob" })
          ], -1))
        ], 64))
      ], 64))
    ], 10, Eke));
  }
});
var Nke = Object.defineProperty, Uke = (n, e, t) => e in n ? Nke(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ua = (n, e, t) => Uke(n, typeof e != "symbol" ? e + "" : e, t);
const Gke = [
  { id: "generations", label: "Your generations", icon: "Images" },
  { id: "uploads", label: "Uploads", icon: "Upload" },
  { id: "favorites", label: "Favorites", icon: "Heart" }
], aA = 1, lA = 12;
function jke(n) {
  return n >= 1300 ? 6 : n >= 1e3 ? 5 : n >= 760 ? 4 : n >= 480 ? 3 : 2;
}
const dA = "rd-board-library";
function Hke() {
  try {
    const n = localStorage.getItem(dA);
    return n ? JSON.parse(n) : {};
  } catch {
    return {};
  }
}
function w4(n) {
  try {
    localStorage.setItem(dA, JSON.stringify(n));
  } catch {
  }
}
const Vke = { search: !1, filters: !1, star: !1, remove: !1 };
function Wke(n) {
  return /* @__PURE__ */ Xt({
    tab: "generations",
    /** what's typed in the search box */
    searchText: "",
    /** the search in force (two characters or more) */
    search: "",
    /** the filters in force, and the panel's copy being edited */
    filters: {},
    draft: {},
    filtersOpen: !1,
    layout: n.layout || "grid",
    /** chosen columns; 0 until you choose (the view's width decides) */
    columns: n.columns || 0,
    /** picking: a click picks rather than looks */
    selecting: !0,
    /** picked items, in the order picked */
    picked: [],
    /** the item open large, if any */
    peek: null,
    /** starred results (item ids), as far as known */
    favs: /* @__PURE__ */ new Set(),
    /** uploads under way */
    uploading: [],
    tabs: {
      generations: Bb(),
      uploads: Bb(),
      favorites: Bb()
    }
  });
}
class qke {
  constructor(e, t, i = ["image", "video"]) {
    Ua(this, "shelf", e), Ua(this, "max", t), Ua(this, "kinds", i), Ua(this, "s"), Ua(this, "shown"), Ua(this, "features"), this.features = e ? e.features : Vke, this.s = Wke(Hke()), this.shown = I(() => this.s.tabs[this.s.tab].items);
  }
  /** Can this be picked here: a finished picture of a kind wanted? */
  allowed(e) {
    return !e.moderated && this.kinds.includes(ike(e));
  }
  tab() {
    return this.s.tabs[this.s.tab];
  }
  /** The query for a tab: Your generations carries the filters and search in force. */
  query(e, t = null) {
    return e !== "generations" ? { cursor: t } : { cursor: t, filters: { ...this.s.filters }, search: this.s.search || void 0 };
  }
  /** Another tab: as in v1, it starts without filters or search. */
  setTab(e) {
    this.s.tab !== e && (this.s.tab = e, this.s.peek = null, this.s.filtersOpen = !1, (this.s.search || Bf(this.s.filters)) && (this.s.search = "", this.s.searchText = "", this.s.filters = {}, this.reset("generations")), this.s.tabs[e].loaded || this.load(e));
  }
  /** Start a tab over (its query changed). */
  reset(e) {
    const t = this.s.tabs[e];
    t.items = [], t.next = null, t.loaded = !1, t.failed = !1, t.latched = !1, t.error = "", t.loading = !1, t.version++;
  }
  /** The tab's first page, or (more) its next one. */
  async load(e = this.s.tab, t = !1) {
    const i = this.s.tabs[e];
    if (!this.shelf || i.loading || t && (i.next === null || i.latched)) return;
    const s = i.version;
    i.loading = !0, i.failed = !1;
    try {
      const o = this.query(e, t ? i.next : null), r = await (e === "generations" ? this.shelf.generations(o) : e === "uploads" ? this.shelf.uploads(o) : this.shelf.favorites(o));
      if (i.version !== s) return;
      const a = new Set(t ? i.items.map((d) => d.id) : []), l = r.items.filter((d) => !a.has(d.id));
      for (const d of l) d.fav && this.s.favs.add(d.id);
      i.items = t ? i.items.concat(l) : l, i.next = r.next, i.loaded = !0;
    } catch (o) {
      if (i.version !== s) return;
      console.warn("[board] your Library could not be loaded", o), i.failed = !0, i.latched = t, i.error = Lb(o);
    } finally {
      i.version === s && (i.loading = !1);
    }
  }
  /** Ask again after a page failed. */
  retry() {
    const e = this.tab();
    e.latched = !1, this.load(this.s.tab, e.loaded);
  }
  /** Which of your results are starred, to mark them on every tab. */
  async loadFavs() {
    if (!(!this.shelf || !this.shelf.favoriteKeys))
      try {
        for (const e of await this.shelf.favoriteKeys()) this.s.favs.add(e);
      } catch (e) {
        console.warn("[board] your favorites could not be read", e);
      }
  }
  // ------------------------------------------------------------ search and filters
  /** The words in the box, in force (the box waits for a pause, or Enter). */
  commitSearch() {
    const e = Sm(this.s.searchText);
    e !== this.s.search && (this.s.search = e, this.s.tab !== "generations" && (this.s.tab = "generations"), this.reset("generations"), this.load("generations"));
  }
  clearSearch() {
    this.s.searchText = "", this.commitSearch();
  }
  openFilters() {
    this.s.draft = { ...this.s.filters }, this.s.filtersOpen = !0;
  }
  /** The panel's Cancel: back to what's in force. */
  cancelFilters() {
    this.s.draft = { ...this.s.filters }, this.s.filtersOpen = !1;
  }
  /** Apply filters (the panel's draft, or these): Your generations starts over with them; the search stays. */
  applyFilters(e = this.s.draft) {
    const t = {};
    for (const [i, s] of Object.entries(e))
      s && (t[i] = s);
    this.s.filters = t, this.s.draft = { ...t }, this.s.filtersOpen = !1, this.s.tab !== "generations" && (this.s.tab = "generations"), this.reset("generations"), this.load("generations");
  }
  /** One filter off (a chip's ×). */
  dropFilter(e) {
    const t = { ...this.s.filters };
    e === "dates" ? (delete t.from, delete t.to) : delete t[e], this.applyFilters(t);
  }
  filtersOn() {
    return Bf(this.s.filters);
  }
  // ------------------------------------------------------------ layout
  setLayout(e) {
    this.s.layout = e, w4({ layout: e, columns: this.s.columns || void 0 });
  }
  setColumns(e) {
    this.s.columns = Math.max(aA, Math.min(lA, Math.round(e))), w4({ layout: this.s.layout, columns: this.s.columns });
  }
  // ------------------------------------------------------------ picking
  /** Its place in the picks (1 first), or 0. */
  order(e) {
    return this.s.picked.findIndex((t) => t.id === e) + 1;
  }
  /** Pick or unpick; false when it can't be picked here, or the picks are full. */
  toggle(e) {
    return this.order(e.id) ? (this.s.picked = this.s.picked.filter((t) => t.id !== e.id), !0) : !this.allowed(e) || this.s.picked.length >= this.max ? !1 : (this.s.picked = [...this.s.picked, e], !0);
  }
  /** Pick every shown picture that can be, up to the limit, after what's already picked. */
  pickAll() {
    let e = 0;
    for (const t of this.shown.value) {
      if (this.s.picked.length >= this.max) break;
      this.order(t.id) || !this.allowed(t) || (this.s.picked = [...this.s.picked, t], e++);
    }
    return e;
  }
  clear() {
    this.s.picked = [];
  }
  full() {
    return this.s.picked.length >= this.max;
  }
  // ------------------------------------------------------------ stars, deletes, uploads
  faved(e) {
    return this.s.favs.has(e.id);
  }
  /** Can you star it: one of your finished generations, where the Library can star. */
  canStar(e) {
    return !!this.shelf && !!this.shelf.setFavorite && this.features.star && !!e.run && !!e.mine && !e.moderated;
  }
  /** Star or unstar, shown at once; undone, with the reason, if it's refused. */
  async star(e, t) {
    if (!this.canStar(e)) return null;
    const i = this.faved(e);
    this.markFav(e, t);
    try {
      return await this.shelf.setFavorite(e, t), null;
    } catch (s) {
      return this.markFav(e, i), Lb(s) || "Could not change the favorite, please try again";
    }
  }
  markFav(e, t) {
    const i = new Set(this.s.favs);
    t ? i.add(e.id) : i.delete(e.id), this.s.favs = i;
    const s = this.s.tabs.favorites;
    t && s.loaded && !s.items.some((o) => o.id === e.id) && (s.items = [{ ...e, fav: !0 }, ...s.items]), t || (s.items = s.items.filter((o) => o.id !== e.id));
  }
  canRemove(e) {
    return !!this.shelf && !!this.shelf.remove && this.features.remove && !!e.mine;
  }
  /** Delete it: gone from every tab and the picks at once; back, with the reason, if it's refused. */
  async remove(e) {
    if (!this.canRemove(e)) return null;
    const t = Object.keys(this.s.tabs).map((s) => [s, this.s.tabs[s].items]), i = this.s.picked;
    for (const s of Object.keys(this.s.tabs)) this.s.tabs[s].items = this.s.tabs[s].items.filter((o) => o.id !== e.id);
    this.s.picked = this.s.picked.filter((s) => s.id !== e.id), this.s.peek && this.s.peek.id === e.id && (this.s.peek = null);
    try {
      return await this.shelf.remove(e), null;
    } catch (s) {
      for (const [o, r] of t) this.s.tabs[o].items = r;
      return this.s.picked = i, Lb(s) || "Issues deleting image, please try again";
    }
  }
  uploadStarted(e, t) {
    this.s.uploading = [...this.s.uploading, { id: e, name: t }];
  }
  /** An upload landed: first in Uploads, and picked if there's room. */
  uploadDone(e, t) {
    if (this.s.uploading = this.s.uploading.filter((s) => s.id !== e), !t) return;
    const i = this.s.tabs.uploads;
    i.items = [t, ...i.items.filter((s) => s.id !== t.id)], this.s.selecting && !this.order(t.id) && this.allowed(t) && !this.full() && (this.s.picked = [...this.s.picked, t]);
  }
}
function Lb(n) {
  const e = n && typeof n == "object" ? n.userMessage : void 0;
  return typeof e == "string" ? e : "";
}
function Bb() {
  return { items: [], next: null, loading: !1, loaded: !1, failed: !1, error: "", latched: !1, version: 0 };
}
const Kke = {
  class: "lb-shell",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Your Library"
}, Yke = { class: "lb-head" }, Xke = { class: "lb-row is-top" }, Jke = { class: "lb-mark" }, Zke = { class: "lb-title" }, Qke = {
  key: 0,
  class: "bd-spinner is-sm"
}, e2e = { key: 2 }, t2e = {
  key: 1,
  class: "lb-grow"
}, n2e = { class: "lb-row is-bar" }, i2e = {
  class: "lb-tabs",
  role: "tablist",
  "aria-label": "Library"
}, s2e = ["aria-selected", "data-testid", "onClick"], o2e = ["aria-expanded", "title"], r2e = {
  key: 0,
  class: "n"
}, a2e = {
  class: "lb-seg",
  role: "radiogroup",
  "aria-label": "Layout"
}, l2e = ["aria-checked", "title", "data-testid", "onClick"], d2e = {
  key: 1,
  class: "lb-cols",
  title: "Number of columns"
}, c2e = ["disabled"], u2e = { "data-testid": "library-cols" }, h2e = ["disabled"], p2e = ["aria-pressed", "title"], f2e = {
  key: 1,
  class: "lb-applied",
  "data-testid": "library-applied"
}, m2e = {
  key: 0,
  class: "lb-applied-chip is-search"
}, g2e = ["title", "onClick"], b2e = {
  key: 2,
  class: "lb-applied-note"
}, v2e = {
  key: 1,
  class: "lb-empty",
  "data-testid": "library-failed"
}, y2e = { class: "lb-empty-mark is-warn" }, x2e = {
  key: 2,
  class: "lb-empty",
  "data-testid": "library-no-match"
}, w2e = {
  key: 3,
  class: "lb-empty",
  "data-testid": "library-no-match"
}, k2e = {
  key: 4,
  class: "lb-empty",
  "data-testid": "library-empty"
}, _2e = {
  key: 0,
  class: "lb-empty-hint"
}, S2e = { class: "key" }, M2e = { class: "ic" }, T2e = { class: "lb-frame" }, C2e = { class: "lb-uploading" }, I2e = ["title", "onClick", "onDblclick"], A2e = { class: "lb-frame" }, P2e = {
  key: 0,
  class: "lb-withheld"
}, E2e = ["src"], R2e = { class: "lb-info" }, z2e = { class: "p" }, $2e = {
  key: 0,
  class: "m"
}, D2e = {
  key: 0,
  class: "lb-row-text"
}, O2e = { class: "p" }, L2e = { class: "m" }, B2e = {
  key: 1,
  class: "lb-badge is-video"
}, F2e = {
  key: 2,
  class: "lb-badge is-3d"
}, N2e = ["title", "aria-pressed", "onClick"], U2e = {
  key: 4,
  class: "lb-star on is-still"
}, G2e = ["aria-label", "aria-pressed", "onClick"], j2e = { key: 0 }, H2e = ["onClick"], V2e = {
  key: 6,
  class: "lb-more"
}, W2e = {
  key: 7,
  class: "lb-more is-failed",
  "data-testid": "library-more-failed"
}, q2e = {
  key: 8,
  class: "lb-more"
}, K2e = {
  key: 9,
  class: "lb-end"
}, Y2e = {
  key: 0,
  class: "lb-tray",
  "data-testid": "library-tray"
}, X2e = { class: "lb-tray-picks" }, J2e = { class: "lb-tray-count" }, Z2e = ["disabled"], Q2e = {
  key: 2,
  class: "lb-dropping"
}, Hi = 12, Ga = 108, e_e = /* @__PURE__ */ Pe({
  __name: "LibraryView",
  setup(n) {
    const { board: e } = Ze(), t = e.ui.libraryOpen, i = t.kinds || (t.purpose === "place" ? ["image", "video", "3d"] : ["image", "video"]), s = new qke(e.libraryShelf, t.max, i), o = s.s, r = t.purpose === "place", a = t.max === 1, l = !!e.uploader, d = /* @__PURE__ */ W(null), c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(null), f = /* @__PURE__ */ W(1100), p = /* @__PURE__ */ W(700), y = /* @__PURE__ */ W(0), v = /* @__PURE__ */ W(null), { active: x, over: w, leave: S, stop: M } = fx(() => l), _ = /* @__PURE__ */ W(null), T = /* @__PURE__ */ W(!1);
    let k = 0;
    const P = [
      { id: "grid", label: "Grid", icon: "Grid3x3" },
      { id: "masonry", label: "Masonry", icon: "LayoutDashboard" },
      { id: "list", label: "Details", icon: "Rows3" }
    ], A = I(() => o.tabs[o.tab]), R = I(() => s.shown.value), D = I(() => o.layout === "list" ? 1 : o.columns || jke(f.value)), O = I(() => Math.floor((f.value - Hi * (D.value - 1)) / D.value)), F = I(() => a || o.selecting), ie = I(() => {
      const V = [];
      if (o.tab === "uploads" && l) {
        V.push({ kind: "upload", key: "(upload)" });
        for (const X of o.uploading) V.push({ kind: "uploading", name: X.name, key: "up-" + X.id });
      }
      for (const X of R.value) V.push({ kind: "item", it: X, key: X.id });
      return V;
    }), ee = I(() => {
      const V = D.value, X = O.value, le = [];
      if (o.layout === "list")
        return ie.value.forEach((ve, _e) => le.push({ e: ve, x: 0, y: _e * (Ga + 8), w: f.value, h: Ga })), { cells: le, height: ie.value.length ? ie.value.length * (Ga + 8) - 8 : 0 };
      if (o.layout === "grid") {
        ie.value.forEach((_e, De) => le.push({ e: _e, x: De % V * (X + Hi), y: Math.floor(De / V) * (X + Hi), w: X, h: X }));
        const ve = Math.ceil(ie.value.length / V);
        return { cells: le, height: ve ? ve * (X + Hi) - Hi : 0 };
      }
      const Le = new Array(V).fill(0);
      for (const ve of ie.value) {
        let _e = 0;
        for (let Dn = 1; Dn < V; Dn++) Le[Dn] < Le[_e] - 1 && (_e = Dn);
        const De = ve.kind === "item" ? ve.it : null, Qe = De && De.w && De.h ? De.h / De.w : 1, ft = Math.round(X * Math.max(0.45, Math.min(2.2, Qe)));
        le.push({ e: ve, x: _e * (X + Hi), y: Le[_e], w: X, h: ft }), Le[_e] += ft + Hi;
      }
      return { cells: le, height: Math.max(0, ...Le) - Hi };
    }), me = I(() => {
      const V = y.value - 900, X = y.value + p.value + 900;
      return ee.value.cells.filter((le) => le.y + le.h >= V && le.y <= X);
    }), L = I(() => !!o.search), N = I(() => !A.value.loaded && !A.value.failed), K = I(() => A.value.loaded && !ie.value.length && !A.value.loading), B = I(() => o.tab === "generations" && (L.value || s.filtersOn() > 0)), re = I(() => {
      const V = o.picked.length;
      return t.confirmLabel ? t.confirmLabel : r ? V === 1 ? "Place on the board" : "Place " + (V || "") + " on the board" : V === 1 ? "Use image" : "Use " + (V || "") + " images";
    }), H = {
      generations: { title: "No generations yet", sub: "Everything you make, in any session on any board, collects here." },
      uploads: { title: "No uploads yet", sub: "Images you bring in collect here." },
      favorites: { title: "No favorites yet", sub: "Tap the heart on any of your generations to add it to your favorites." }
    }, J = I(() => {
      const V = /* @__PURE__ */ new Map();
      for (const X of e.catalog.value.kits) for (const le of X.models) V.set(le.id, le.name);
      return V;
    });
    function Q(V) {
      return V.model || V.run && J.value.get(V.run.nodeDefId) || "";
    }
    function ne(V) {
      return [Q(V), V.createdAt ? Jn(V.createdAt) : ""].filter(Boolean).join(" · ");
    }
    function ue(V) {
      return V.thumb || Bt(V.url);
    }
    const Z = I(() => _.value && _.value.tools.length ? _.value.tools : Array.from(J.value.entries()).map(([V, X]) => ({ value: V, text: X })).sort((V, X) => V.text.localeCompare(X.text))), te = I(() => _.value ? { ..._.value, tools: Z.value } : null), we = I(() => {
      const V = o.filters, X = _.value, le = (ve, _e) => {
        var De;
        return ve && ((De = ve.find((Qe) => Qe.value === _e)) == null ? void 0 : De.text) || _e;
      }, Le = [];
      return V.favorited && Le.push({ key: "favorited", label: "Favorited" }), V.aspect && Le.push({ key: "aspect", label: le(sA, V.aspect) }), V.resolution && Le.push({ key: "resolution", label: le(oA, V.resolution) }), V.tool && Le.push({ key: "tool", label: le(Z.value, V.tool) }), V.family && Le.push({ key: "family", label: le(X == null ? void 0 : X.families, V.family) }), V.media && Le.push({ key: "media", label: le(X == null ? void 0 : X.media, V.media) }), V.board && Le.push({ key: "board", label: le(X == null ? void 0 : X.boards, V.board) }), (V.from || V.to) && Le.push({ key: "dates", label: (V.from ? Fe(V.from) : "…") + " → " + (V.to ? Fe(V.to) : "…") }), Le;
    });
    function Fe(V) {
      const [X, le, Le] = V.split("-").map(Number);
      return new Date(X, le - 1, Le).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
    function Me(V, X) {
      clearTimeout(k), v.value = { id: Date.now(), text: V, tone: X }, k = window.setTimeout(() => {
        v.value = null;
      }, X ? 5e3 : 2400);
    }
    function he() {
      e.closeLibrary();
    }
    function U(V) {
      o.tab !== V && (s.setTab(V), q());
    }
    function q() {
      d.value && (d.value.scrollTop = 0), y.value = 0;
    }
    function oe(V, X) {
      if (X.shiftKey && F.value && !V.moderated) {
        de(V);
        return;
      }
      o.peek = V;
    }
    function de(V) {
      if (!V.moderated) {
        if (!s.allowed(V)) {
          const X = i, le = { image: "images", video: "videos", "3d": "3D models" };
          Me(X.length === 1 ? "Only " + le[X[0]] + " can be used here" : (V.model3d ? "3D models" : V.video ? "Videos" : "Images") + " can't be used here");
          return;
        }
        if (a) {
          s.s.picked = [V], pe();
          return;
        }
        s.toggle(V) || Me("You can pick " + t.max + (t.max === 1 ? " picture" : " pictures") + " at most: unpick one first");
      }
    }
    function pe() {
      const V = o.picked.slice();
      V.length && (r ? e.placeFromLibrary(V, t.at) : t.onPick && t.onPick(V), he());
    }
    async function Ce(V) {
      const X = await s.star(V, !s.faved(V));
      X && Me(X, "error");
    }
    async function Be(V) {
      const X = await s.remove(V);
      if (X) {
        Me(X, "error");
        return;
      }
      e.forgetLibraryItem(V), Me(V.uploadId ? "Upload deleted" : "Generation deleted");
    }
    function be() {
      if (o.filtersOpen) {
        s.cancelFilters();
        return;
      }
      s.openFilters(), se();
    }
    async function se() {
      const V = e.libraryShelf;
      if (!(_.value || T.value)) {
        if (!V || !V.filterOptions) {
          _.value = { tools: [], families: [], media: [], boards: [] };
          return;
        }
        T.value = !0;
        try {
          _.value = await V.filterOptions(e.meta.teamId);
        } catch (X) {
          console.warn("[board] the Library's filter options are unavailable", X), _.value = { tools: [], families: [], media: [], boards: [] };
        } finally {
          T.value = !1;
        }
      }
    }
    function ae(V) {
      s.setColumns(D.value + V);
    }
    function ye(V) {
      return new Promise((X) => {
        const le = new Image();
        le.onload = () => X({ w: le.naturalWidth || 4, h: le.naturalHeight || 3 }), le.onerror = () => X({ w: 4, h: 3 }), le.src = V;
      });
    }
    async function Oe(V) {
      const X = V.filter((le) => le.type.startsWith("image/")).slice(0, 24);
      !X.length || !l || (o.tab !== "uploads" && U("uploads"), await Promise.all(X.map(async (le) => {
        const Le = wt();
        s.uploadStarted(Le, le.name);
        try {
          const ve = URL.createObjectURL(le), _e = await ye(ve), De = await e.uploadFile(le);
          De.url !== ve && URL.revokeObjectURL(ve);
          const Qe = De.asset && "upload" in De.asset ? De.asset.upload : null;
          s.uploadDone(Le, {
            id: "upload:" + (Qe && Qe.id ? Qe.id : Le),
            url: De.url,
            w: _e.w,
            h: _e.h,
            video: !1,
            label: le.name,
            createdAt: Date.now(),
            mine: !0,
            uploadId: Qe && Qe.id ? Qe.id : void 0,
            asset: De.asset || { upload: { name: le.name } }
          });
        } catch (ve) {
          s.uploadDone(Le, null);
          const _e = ve ? ve.userMessage : void 0;
          Me(_e || le.name + " could not be uploaded.", "error");
        }
      })));
    }
    function Ve(V) {
      const X = V.target, le = Array.from(X.files || []);
      X.value = "", Oe(le);
    }
    function Ue(V) {
      w(V) && V.preventDefault();
    }
    function tt(V) {
      M(), !(!V.dataTransfer || !l) && (V.preventDefault(), Oe(Array.from(V.dataTransfer.files || [])));
    }
    let Ye = null;
    function at() {
      if (!d.value) return;
      const V = getComputedStyle(d.value), X = parseFloat(V.paddingLeft) + parseFloat(V.paddingRight);
      f.value = Math.max(280, d.value.clientWidth - X), p.value = d.value.clientHeight;
    }
    function kt() {
      const V = d.value;
      V && (y.value = V.scrollTop, V.scrollHeight - V.scrollTop - V.clientHeight < 700 && s.load(o.tab, !0));
    }
    let $e = 0;
    Ee(() => o.searchText, () => {
      clearTimeout($e), $e = window.setTimeout(() => {
        s.commitSearch(), q();
      }, 300);
    }), Ee(() => o.filters, q), Ee(() => [ee.value.height, A.value.loading], () => {
      nt(() => {
        const V = A.value;
        d.value && !V.loading && V.loaded && V.next !== null && !V.latched && ee.value.height < p.value + 400 && s.load(o.tab, !0);
      });
    });
    function Ne(V) {
      const X = V.target;
      if (X && X.closest && X.closest("[data-lb-own-keys]")) return;
      const le = !!X && (X.tagName === "INPUT" || X.tagName === "TEXTAREA");
      if (V.key === "Escape") {
        V.preventDefault(), V.stopPropagation(), o.peek ? o.peek = null : o.filtersOpen ? s.cancelFilters() : le && o.searchText ? s.clearSearch() : le ? X.blur() : he();
        return;
      }
      if (!o.peek) {
        if (V.key === "Enter" && le && X === c.value) {
          V.preventDefault(), clearTimeout($e), s.commitSearch();
          return;
        }
        if (V.key === "/" && !le && c.value) {
          V.preventDefault(), c.value.focus();
          return;
        }
        le || (V.key === "Enter" && o.picked.length && !a ? (V.preventDefault(), pe()) : bn(V) && V.key.toLowerCase() === "a" && F.value && !a && (V.preventDefault(), !s.pickAll() && s.full() && Me("That's as many as you can pick")));
      }
    }
    return it(() => {
      s.load("generations"), s.loadFavs(), at(), d.value && (Ye = new ResizeObserver(at), Ye.observe(d.value)), window.addEventListener("keydown", Ne, !0), nt(() => {
        c.value && c.value.focus({ preventScroll: !0 });
      });
    }), We(() => {
      Ye && Ye.disconnect(), window.removeEventListener("keydown", Ne, !0), clearTimeout(k), clearTimeout($e);
    }), (V, X) => (g(), b("div", {
      class: "lb-backdrop",
      "data-testid": "library",
      onPointerdown: Te(he, ["self"]),
      onDragover: Ue,
      onDragleave: X[16] || (X[16] = //@ts-ignore
      (...le) => m(S) && m(S)(...le)),
      onDrop: tt
    }, [
      u("div", Kke, [
        u("header", Yke, [
          X[21] || (X[21] = u("span", {
            class: "lb-glow",
            "aria-hidden": "true"
          }, null, -1)),
          u("div", Xke, [
            u("span", Jke, [
              C($, {
                name: "Library",
                size: 17
              })
            ]),
            u("div", Zke, [
              X[17] || (X[17] = u("b", null, "Library", -1)),
              u("span", null, E(m(ske)(m(i), m(t).max, r)), 1)
            ]),
            m(s).features.search ? (g(), b("label", {
              key: 0,
              class: G(["lb-search", { "has-words": !!m(o).searchText }])
            }, [
              C($, {
                name: "Search",
                size: 15
              }),
              _t(u("input", {
                ref_key: "searchEl",
                ref: c,
                "onUpdate:modelValue": X[0] || (X[0] = (le) => m(o).searchText = le),
                type: "text",
                spellcheck: "false",
                placeholder: "Search your Library",
                "aria-label": "Search your Library",
                "data-testid": "library-search"
              }, null, 512), [
                [Zt, m(o).searchText]
              ]),
              L.value && A.value.loading ? (g(), b("span", Qke)) : z("", !0),
              m(o).searchText ? (g(), b("button", {
                key: 1,
                class: "lb-search-clear",
                title: "Clear",
                onClick: X[1] || (X[1] = (le) => m(s).clearSearch())
              }, [
                C($, {
                  name: "X",
                  size: 12
                })
              ])) : (g(), b("kbd", e2e, "/"))
            ], 2)) : (g(), b("span", t2e)),
            u("button", {
              class: "lb-close",
              title: "Close (Esc)",
              "data-testid": "library-close",
              onClick: he
            }, [
              C($, {
                name: "X",
                size: 16
              })
            ])
          ]),
          u("div", n2e, [
            u("nav", i2e, [
              (g(!0), b(j, null, ge(m(Gke), (le) => (g(), b("button", {
                key: le.id,
                role: "tab",
                "aria-selected": m(o).tab === le.id,
                class: G({ on: m(o).tab === le.id }),
                "data-testid": "library-tab-" + le.id,
                onClick: (Le) => U(le.id)
              }, [
                C($, {
                  name: le.icon,
                  size: 14
                }, null, 8, ["name"]),
                Y(" " + E(le.label), 1)
              ], 10, s2e))), 128))
            ]),
            X[20] || (X[20] = u("span", { class: "lb-grow" }, null, -1)),
            m(s).features.filters && m(o).tab === "generations" ? (g(), b("button", {
              key: 0,
              class: G(["lb-tool", { on: m(o).filtersOpen, "is-set": m(s).filtersOn() > 0 }]),
              "aria-expanded": m(o).filtersOpen,
              title: m(o).filtersOpen ? "Hide filters" : "Show filters",
              "data-testid": "library-filter-toggle",
              onClick: be
            }, [
              C($, {
                name: "SlidersHorizontal",
                size: 14
              }),
              X[18] || (X[18] = Y(" Filters ", -1)),
              m(s).filtersOn() ? (g(), b("span", r2e, E(m(s).filtersOn()), 1)) : z("", !0)
            ], 10, o2e)) : z("", !0),
            u("div", a2e, [
              (g(), b(j, null, ge(P, (le) => u("button", {
                key: le.id,
                role: "radio",
                "aria-checked": m(o).layout === le.id,
                class: G({ on: m(o).layout === le.id }),
                title: le.label,
                "data-testid": "library-layout-" + le.id,
                onClick: (Le) => m(s).setLayout(le.id)
              }, [
                C($, {
                  name: le.icon,
                  size: 14
                }, null, 8, ["name"])
              ], 10, l2e)), 64))
            ]),
            m(o).layout !== "list" ? (g(), b("div", d2e, [
              u("button", {
                disabled: D.value <= m(aA),
                "aria-label": "Fewer columns",
                "data-testid": "library-cols-less",
                onClick: X[2] || (X[2] = (le) => ae(-1))
              }, [
                C($, {
                  name: "Minus",
                  size: 12
                })
              ], 8, c2e),
              u("span", u2e, [
                u("b", null, E(D.value), 1),
                C($, {
                  name: "Columns3",
                  size: 12
                })
              ]),
              u("button", {
                disabled: D.value >= m(lA),
                "aria-label": "More columns",
                "data-testid": "library-cols-more",
                onClick: X[3] || (X[3] = (le) => ae(1))
              }, [
                C($, {
                  name: "Plus",
                  size: 12
                })
              ], 8, h2e)
            ])) : z("", !0),
            a ? z("", !0) : (g(), b("button", {
              key: 2,
              class: G(["lb-select", { on: m(o).selecting }]),
              "aria-pressed": m(o).selecting,
              title: m(o).selecting ? "Selection mode: each picture's check picks it (Shift-click too). Turn off to hide the checks" : "Turn on selection mode to pick pictures",
              "data-testid": "library-selecting",
              onClick: X[4] || (X[4] = (le) => m(o).selecting = !m(o).selecting)
            }, [...X[19] || (X[19] = [
              u("span", { class: "sw" }, [
                u("i")
              ], -1),
              Y(" Select ", -1)
            ])], 10, p2e))
          ])
        ]),
        m(o).filtersOpen ? (g(), Ie(Pke, {
          key: 0,
          lib: m(s),
          options: te.value,
          loading: T.value
        }, null, 8, ["lib", "options", "loading"])) : B.value ? (g(), b("div", f2e, [
          L.value ? (g(), b("span", m2e, [
            C($, {
              name: "Search",
              size: 12
            }),
            Y(" “" + E(m(o).search) + "” ", 1),
            u("button", {
              title: "Clear the search",
              onClick: X[5] || (X[5] = (le) => m(s).clearSearch())
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])
          ])) : z("", !0),
          (g(!0), b(j, null, ge(we.value, (le) => (g(), b("span", {
            key: le.key,
            class: "lb-applied-chip"
          }, [
            Y(E(le.label) + " ", 1),
            u("button", {
              title: "Remove " + le.label,
              onClick: (Le) => m(s).dropFilter(le.key)
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ], 8, g2e)
          ]))), 128)),
          we.value.length ? (g(), b("button", {
            key: 1,
            class: "lb-link",
            onClick: X[6] || (X[6] = (le) => m(s).applyFilters({}))
          }, "Clear filters")) : z("", !0),
          X[22] || (X[22] = u("span", { class: "lb-grow" }, null, -1)),
          L.value ? (g(), b("span", b2e, "Best matches first")) : z("", !0)
        ])) : z("", !0),
        u("main", {
          ref_key: "body",
          ref: d,
          class: G(["lb-body", "is-" + m(o).layout]),
          "data-testid": "library-body",
          onScroll: kt
        }, [
          N.value ? (g(), b("div", {
            key: 0,
            class: "lb-wall",
            style: ce({ height: (m(o).layout === "list" ? 6 * (Ga + 8) : Math.ceil(18 / D.value) * (O.value + Hi)) + "px" })
          }, [
            (g(!0), b(j, null, ge(m(o).layout === "list" ? 6 : Math.min(18, D.value * 3), (le) => (g(), b("span", {
              key: le,
              class: "lb-skel",
              style: ce(m(o).layout === "list" ? { left: "0px", top: (le - 1) * (Ga + 8) + "px", width: f.value + "px", height: Ga + "px", animationDelay: le % 6 * 70 + "ms" } : { left: (le - 1) % D.value * (O.value + Hi) + "px", top: Math.floor((le - 1) / D.value) * (O.value + Hi) + "px", width: O.value + "px", height: O.value + "px", animationDelay: le % 6 * 70 + "ms" })
            }, null, 4))), 128))
          ], 4)) : A.value.failed && !A.value.loaded ? (g(), b("div", v2e, [
            u("span", y2e, [
              C($, {
                name: "AlertCircle",
                size: 20
              })
            ]),
            X[24] || (X[24] = u("b", null, "Your Library couldn't be loaded", -1)),
            u("span", null, E(A.value.error || "Check your connection, then try again."), 1),
            u("button", {
              class: "lb-btn",
              onClick: X[7] || (X[7] = (le) => m(s).retry())
            }, [
              C($, {
                name: "RotateCcw",
                size: 14
              }),
              X[23] || (X[23] = Y(" Try again", -1))
            ])
          ])) : K.value && L.value ? (g(), b("div", x2e, [
            C(Ob, { kind: "search" }),
            X[25] || (X[25] = u("b", null, "No results match your search.", -1)),
            u("span", null, "Try other words" + E(m(s).filtersOn() ? ", or fewer filters" : "") + ".", 1),
            u("button", {
              class: "lb-btn",
              onClick: X[8] || (X[8] = (le) => m(s).clearSearch())
            }, "Clear search")
          ])) : K.value && B.value ? (g(), b("div", w2e, [
            C(Ob, { kind: "filters" }),
            X[26] || (X[26] = u("b", null, "Nothing matches these filters", -1)),
            X[27] || (X[27] = u("span", null, "Loosen one, or clear them all.", -1)),
            u("button", {
              class: "lb-btn",
              onClick: X[9] || (X[9] = (le) => m(s).applyFilters({}))
            }, "Clear filters")
          ])) : K.value ? (g(), b("div", k2e, [
            C(Ob, {
              kind: m(o).tab
            }, null, 8, ["kind"]),
            u("b", null, E(H[m(o).tab].title), 1),
            u("span", null, E(H[m(o).tab].sub), 1),
            m(o).tab === "favorites" ? (g(), b("span", _2e, [
              X[28] || (X[28] = Y("Look for ", -1)),
              u("span", S2e, [
                C($, {
                  name: "Heart",
                  size: 11
                })
              ]),
              X[29] || (X[29] = Y(" on any generation", -1))
            ])) : z("", !0)
          ])) : (g(), b("div", {
            key: 5,
            class: "lb-wall",
            style: ce({ height: ee.value.height + "px" })
          }, [
            (g(!0), b(j, null, ge(me.value, (le) => (g(), b(j, {
              key: le.e.key
            }, [
              le.e.kind === "upload" ? (g(), b("button", {
                key: 0,
                class: G(["lb-upload-tile", { "is-list": m(o).layout === "list" }]),
                style: ce({ left: le.x + "px", top: le.y + "px", width: le.w + "px", height: le.h + "px" }),
                "data-testid": "library-upload",
                onClick: X[10] || (X[10] = (Le) => h.value && h.value.click())
              }, [
                u("span", M2e, [
                  C($, {
                    name: "Upload",
                    size: 18
                  })
                ]),
                X[30] || (X[30] = u("b", null, "Upload images", -1)),
                X[31] || (X[31] = u("span", null, "or drop them here", -1))
              ], 6)) : le.e.kind === "uploading" ? (g(), b("div", {
                key: 1,
                class: G(["lb-cell is-uploading", { "is-list": m(o).layout === "list" }]),
                style: ce({ left: le.x + "px", top: le.y + "px", width: le.w + "px", height: le.h + "px" })
              }, [
                u("span", T2e, [
                  u("span", C2e, [
                    X[32] || (X[32] = u("span", { class: "bd-spinner is-sm" }, null, -1)),
                    Y(" " + E(le.e.name), 1)
                  ])
                ])
              ], 6)) : (g(), b("div", {
                key: 2,
                class: G(["lb-cell", {
                  "is-list": m(o).layout === "list",
                  "is-picked": m(s).order(le.e.it.id) > 0,
                  "is-off": F.value && !le.e.it.moderated && (!m(s).allowed(le.e.it) || m(s).full() && !m(s).order(le.e.it.id) && !a),
                  "is-selecting": F.value,
                  "is-moderated": !!le.e.it.moderated
                }]),
                style: ce({ left: le.x + "px", top: le.y + "px", width: le.w + "px", height: le.h + "px" }),
                title: le.e.it.moderated ? "Moderated by RunDiffusion" : le.e.it.prompt || le.e.it.label,
                "data-testid": "library-item",
                onClick: (Le) => oe(le.e.it, Le),
                onDblclick: (Le) => m(o).peek = le.e.it
              }, [
                u("span", A2e, [
                  le.e.it.moderated ? (g(), b("span", P2e, [
                    C($, {
                      name: "EyeOff",
                      size: 16
                    }),
                    X[33] || (X[33] = u("b", null, "Moderated", -1))
                  ])) : (g(), b("img", {
                    key: 1,
                    src: ue(le.e.it),
                    alt: "",
                    loading: "lazy",
                    draggable: "false",
                    onLoad: X[11] || (X[11] = (Le) => Le.target.classList.add("is-in"))
                  }, null, 40, E2e)),
                  m(o).layout !== "list" ? (g(), b(j, { key: 2 }, [
                    X[34] || (X[34] = u("span", {
                      class: "lb-shade",
                      "aria-hidden": "true"
                    }, null, -1)),
                    u("span", R2e, [
                      u("span", z2e, E(le.e.it.prompt || le.e.it.label), 1),
                      ne(le.e.it) ? (g(), b("span", $2e, E(ne(le.e.it)), 1)) : z("", !0)
                    ])
                  ], 64)) : z("", !0)
                ]),
                m(o).layout === "list" ? (g(), b("span", D2e, [
                  u("span", O2e, E(le.e.it.moderated ? "Moderated by RunDiffusion" : le.e.it.prompt || le.e.it.label), 1),
                  u("span", L2e, [
                    Q(le.e.it) ? (g(), b(j, { key: 0 }, [
                      Y(E(Q(le.e.it)) + " · ", 1)
                    ], 64)) : z("", !0),
                    Y(E(le.e.it.createdAt ? m(Jn)(le.e.it.createdAt) : ""), 1),
                    le.e.it.w && le.e.it.h ? (g(), b(j, { key: 1 }, [
                      Y(" · " + E(le.e.it.w) + " × " + E(le.e.it.h), 1)
                    ], 64)) : z("", !0)
                  ])
                ])) : z("", !0),
                le.e.it.video ? (g(), b("span", B2e, [
                  C($, {
                    name: "Play",
                    size: 9
                  }),
                  X[35] || (X[35] = Y(" Video", -1))
                ])) : le.e.it.model3d ? (g(), b("span", F2e, [
                  C($, {
                    name: "Box",
                    size: 9
                  }),
                  X[36] || (X[36] = Y(" 3D", -1))
                ])) : z("", !0),
                m(s).canStar(le.e.it) ? (g(), b("button", {
                  key: 3,
                  class: G(["lb-star", { on: m(s).faved(le.e.it) }]),
                  title: m(s).faved(le.e.it) ? "Remove from your favorites" : "Add to your favorites",
                  "aria-pressed": m(s).faved(le.e.it),
                  "data-testid": "library-star",
                  onClick: Te((Le) => Ce(le.e.it), ["stop"])
                }, [
                  C($, {
                    name: "Heart",
                    size: 13
                  })
                ], 10, N2e)) : m(s).faved(le.e.it) ? (g(), b("span", U2e, [
                  C($, {
                    name: "Heart",
                    size: 13
                  })
                ])) : z("", !0),
                F.value && !le.e.it.moderated ? (g(), b("button", {
                  key: 5,
                  class: G(["lb-check", { on: m(s).order(le.e.it.id) > 0, "is-single": a }]),
                  "aria-label": m(s).order(le.e.it.id) ? "Unpick" : "Pick",
                  "aria-pressed": m(s).order(le.e.it.id) > 0,
                  onClick: Te((Le) => de(le.e.it), ["stop"])
                }, [
                  m(s).order(le.e.it.id) ? (g(), b("span", j2e, E(m(s).order(le.e.it.id)), 1)) : (g(), Ie($, {
                    key: 1,
                    name: a ? "Check" : "Plus",
                    size: 13
                  }, null, 8, ["name"]))
                ], 10, G2e)) : le.e.it.moderated ? z("", !0) : (g(), b("button", {
                  key: 6,
                  class: "lb-look",
                  title: "Look at it large",
                  onClick: Te((Le) => m(o).peek = le.e.it, ["stop"])
                }, [
                  C($, {
                    name: "Maximize2",
                    size: 12
                  })
                ], 8, H2e))
              ], 46, I2e))
            ], 64))), 128))
          ], 4)),
          A.value.loaded && A.value.loading ? (g(), b("div", V2e, [...X[37] || (X[37] = [
            u("span", { class: "bd-spinner is-sm" }, null, -1),
            Y(" Loading more", -1)
          ])])) : A.value.loaded && A.value.failed ? (g(), b("div", W2e, [
            Y(E(A.value.error || "Couldn't load more") + " ", 1),
            u("button", {
              class: "lb-link",
              onClick: X[12] || (X[12] = (le) => m(s).retry())
            }, "Try again")
          ])) : A.value.loaded && A.value.next !== null ? (g(), b("div", q2e, [
            u("button", {
              class: "lb-btn",
              "data-testid": "library-more",
              onClick: X[13] || (X[13] = (le) => m(s).load(m(o).tab, !0))
            }, "Load more")
          ])) : A.value.loaded && R.value.length > D.value * 2 ? (g(), b("div", K2e, "That's everything" + E(B.value ? " that matches" : ""), 1)) : z("", !0)
        ], 34),
        C(vt, { name: "lb-tray" }, {
          default: Xe(() => [
            F.value && !a ? (g(), b("footer", Y2e, [
              u("div", X2e, [
                (g(!0), b(j, null, ge(m(o).picked.slice(-5), (le, Le) => (g(), b("span", {
                  key: le.id,
                  class: "lb-tray-thumb",
                  style: ce({ backgroundImage: 'url("' + ue(le) + '")', zIndex: Le })
                }, null, 4))), 128)),
                u("span", J2e, [
                  u("b", null, E(m(o).picked.length), 1),
                  Y(" of " + E(m(t).max) + " picked ", 1)
                ])
              ]),
              m(o).picked.length ? (g(), b("button", {
                key: 0,
                class: "lb-tray-clear",
                "data-testid": "library-clear",
                onClick: X[14] || (X[14] = (le) => m(s).clear())
              }, "Clear")) : z("", !0),
              X[38] || (X[38] = u("span", { class: "lb-grow" }, null, -1)),
              u("button", {
                class: "lb-btn is-ghost",
                "data-testid": "library-cancel",
                onClick: he
              }, "Cancel"),
              u("button", {
                class: "lb-btn is-primary",
                disabled: !m(o).picked.length,
                "data-testid": "library-confirm",
                onClick: pe
              }, [
                C($, {
                  name: r ? "ArrowDownToLine" : "Check",
                  size: 14
                }, null, 8, ["name"]),
                Y(" " + E(re.value), 1)
              ], 8, Z2e)
            ])) : z("", !0)
          ]),
          _: 1
        }),
        C(vt, { name: "lb-note" }, {
          default: Xe(() => [
            v.value ? (g(), b("div", {
              key: v.value.id,
              class: G(["lb-note", { "is-error": v.value.tone === "error" }]),
              role: "status"
            }, E(v.value.text), 3)) : z("", !0)
          ]),
          _: 1
        }),
        m(x) ? (g(), b("div", Q2e, [
          u("div", null, [
            C($, {
              name: "Upload",
              size: 18
            }),
            X[39] || (X[39] = Y(" Drop images to upload them to your Library", -1))
          ])
        ])) : z("", !0),
        m(o).peek ? (g(), Ie(Wwe, {
          key: 3,
          lib: m(s),
          item: m(o).peek,
          placing: r,
          single: a,
          model: Q(m(o).peek),
          onClose: X[15] || (X[15] = (le) => m(o).peek = null),
          onPick: de,
          onStar: Ce,
          onRemove: Be
        }, null, 8, ["lib", "item", "model"])) : z("", !0),
        u("input", {
          ref_key: "fileEl",
          ref: h,
          type: "file",
          accept: "image/*",
          multiple: "",
          style: { display: "none" },
          onChange: Ve
        }, null, 544)
      ])
    ], 32));
  }
}), cA = [
  { id: "box", icon: "Square", label: "Box", key: "R", hint: "Box the problem" },
  { id: "arrow", icon: "ArrowUpRight", label: "Arrow", key: "A", hint: "Point at it" },
  { id: "ellipse", icon: "Circle", label: "Circle", key: "O", hint: "Circle it" },
  { id: "brush", icon: "Pencil", label: "Pencil", key: "B", hint: "Draw freely" },
  { id: "pin", icon: "MapPin", label: "Number", key: "N", hint: "Add a numbered marker to mention in your report" }
], uA = ["#ff3d6e", "#ffc93c", "#36d6ff", "#ffffff", "#16141f"], k4 = ["Red", "Yellow", "Blue", "White", "Black"], t_e = 5e-3, n_e = 4, i_e = 2, j0 = { strokes: [], pins: [] };
function ru(n) {
  return !!n && (n.strokes.length > 0 || n.pins.length > 0);
}
function s_e(n) {
  const e = n.toUpperCase(), t = cA.find((i) => i.key === e);
  return t ? t.id : null;
}
function o_e(n) {
  return { x: Math.min(1, Math.max(0, n.x)), y: Math.min(1, Math.max(0, n.y)) };
}
function r_e(n, e, t, i) {
  return { id: i, kind: n, color: e, size: t_e, pts: n === "brush" ? [t] : [t, t] };
}
function a_e(n, e, t, i) {
  if (n.kind !== "brush") return { ...n, pts: [n.pts[0], e] };
  const s = n.pts[n.pts.length - 1];
  return Math.hypot((e.x - s.x) * t, (e.y - s.y) * i) < i_e ? null : { ...n, pts: [...n.pts, e] };
}
function l_e(n, e, t) {
  if (n.kind === "brush") return n.pts.length > 0;
  const i = n.pts[0], s = n.pts[n.pts.length - 1];
  return Math.hypot((s.x - i.x) * e, (s.y - i.y) * t) >= n_e;
}
function d_e(n, e) {
  return { ...n, strokes: [...n.strokes, e] };
}
function c_e(n, e) {
  return { ...n, pins: [...n.pins, e] };
}
const u_e = ["src", "alt"], h_e = /* @__PURE__ */ Pe({
  __name: "FeedbackMarkup",
  props: {
    feedback: {},
    shot: {},
    index: {}
  },
  setup(n) {
    const e = n, t = e.feedback.state, i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W({ w: 0, h: 0 }), r = /* @__PURE__ */ W(null), a = I(() => {
      const { w: v, h: x } = o.value;
      if (!v || !x) return null;
      const w = Math.min(1, v / e.shot.w, x / e.shot.h);
      return { width: Math.round(e.shot.w * w) + "px", height: Math.round(e.shot.h * w) + "px" };
    });
    function l(v, x) {
      const w = x.getBoundingClientRect();
      return o_e({ x: (v.clientX - w.left) / Math.max(1, w.width), y: (v.clientY - w.top) / Math.max(1, w.height) });
    }
    function d(v) {
      const x = s.value;
      if (v.button !== 0 || !x) return;
      v.preventDefault(), x.focus({ preventScroll: !0 });
      const w = l(v, x), S = t.pen.tool;
      if (S === "pin") {
        e.feedback.addPin(e.index, w);
        return;
      }
      x.setPointerCapture(v.pointerId), r.value = r_e(S, t.pen.color, w, wt());
    }
    function c(v) {
      const x = s.value;
      if (!r.value || !x || !x.hasPointerCapture(v.pointerId)) return;
      const w = x.getBoundingClientRect(), S = a_e(r.value, l(v, x), w.width, w.height);
      S && (r.value = S);
    }
    function h() {
      const v = s.value, x = r.value;
      if (r.value = null, !x || !v) return;
      const w = v.getBoundingClientRect();
      l_e(x, w.width, w.height) && e.feedback.addStroke(e.index, x);
    }
    function f() {
      r.value = null;
    }
    let p = null;
    function y() {
      i.value && (o.value = { w: i.value.clientWidth, h: i.value.clientHeight });
    }
    return it(() => {
      y(), typeof ResizeObserver != "undefined" && i.value && (p = new ResizeObserver(y), p.observe(i.value));
    }), We(() => {
      p && p.disconnect();
    }), (v, x) => (g(), b("div", {
      ref_key: "room",
      ref: i,
      class: "fb-mk"
    }, [
      a.value ? (g(), b("div", {
        key: 0,
        ref_key: "stage",
        ref: s,
        class: G(["fb-mk-stage", "is-" + m(t).pen.tool]),
        style: ce(a.value),
        tabindex: "-1",
        "data-testid": "feedback-markup-stage",
        onPointerdown: d,
        onPointermove: c,
        onPointerup: h,
        onPointercancel: f,
        onLostpointercapture: f
      }, [
        u("img", {
          src: n.shot.url,
          alt: "Screenshot " + (n.index + 1),
          draggable: "false",
          "data-testid": "feedback-preview-image"
        }, null, 8, u_e),
        C(xm, {
          marks: n.shot.marks || m(j0),
          w: n.shot.w,
          h: n.shot.h,
          live: r.value,
          fit: "none",
          "data-testid": "feedback-marks"
        }, null, 8, ["marks", "w", "h", "live"])
      ], 38)) : z("", !0)
    ], 512));
  }
}), p_e = {
  class: "fb-mk-bar",
  role: "toolbar",
  "aria-label": "Mark up the screenshot",
  "data-testid": "feedback-markup"
}, f_e = {
  class: "fb-mk-group",
  role: "radiogroup",
  "aria-label": "What to draw"
}, m_e = ["aria-checked", "aria-label", "title", "data-testid", "onClick"], g_e = {
  class: "fb-mk-group",
  role: "radiogroup",
  "aria-label": "Colour"
}, b_e = ["aria-checked", "aria-label", "title", "data-testid", "onClick"], v_e = { class: "fb-mk-hint" }, y_e = { class: "fb-mk-group" }, x_e = ["disabled", "title"], w_e = ["disabled", "title"], k_e = ["disabled"], __e = /* @__PURE__ */ Pe({
  __name: "FeedbackMarkupBar",
  props: {
    feedback: {},
    index: {}
  },
  setup(n) {
    const e = n, t = e.feedback, i = t.state, s = I(() => ru(t.marksOf(e.index))), o = wn(["mod", "Z"]), r = wn(am());
    return (a, l) => (g(), b("div", p_e, [
      u("div", f_e, [
        (g(!0), b(j, null, ge(m(cA), (d) => (g(), b("button", {
          key: d.id,
          type: "button",
          role: "radio",
          class: G(["fb-mk-btn", { on: m(i).pen.tool === d.id }]),
          "aria-checked": m(i).pen.tool === d.id,
          "aria-label": d.label,
          title: d.label + ": " + d.hint + " (" + d.key + ")",
          "data-testid": "feedback-mark-" + d.id,
          onClick: (c) => m(i).pen.tool = d.id
        }, [
          C($, {
            name: d.icon,
            size: 14
          }, null, 8, ["name"])
        ], 10, m_e))), 128))
      ]),
      u("div", g_e, [
        (g(!0), b(j, null, ge(m(uA), (d, c) => (g(), b("button", {
          key: d,
          type: "button",
          role: "radio",
          class: G(["fb-mk-btn fb-mk-swatch", { on: m(i).pen.color === d }]),
          style: ce({ "--fb-swatch": d }),
          "aria-checked": m(i).pen.color === d,
          "aria-label": m(k4)[c],
          title: m(k4)[c],
          "data-testid": "feedback-mark-colour-" + c,
          onClick: (h) => m(i).pen.color = d
        }, null, 14, b_e))), 128))
      ]),
      u("span", v_e, E(s.value ? "Your marks are sent with it" : "Draw on it to show where"), 1),
      u("div", y_e, [
        u("button", {
          type: "button",
          class: "fb-mk-btn",
          disabled: !m(t).canUndoMarks(n.index),
          title: "Undo (" + m(o) + ")",
          "aria-label": "Undo",
          "data-testid": "feedback-mark-undo",
          onClick: l[0] || (l[0] = (d) => m(t).undoMarks(n.index))
        }, [
          C($, {
            name: "Undo2",
            size: 14
          })
        ], 8, x_e),
        u("button", {
          type: "button",
          class: "fb-mk-btn",
          disabled: !m(t).canRedoMarks(n.index),
          title: "Redo (" + m(r) + ")",
          "aria-label": "Redo",
          "data-testid": "feedback-mark-redo",
          onClick: l[1] || (l[1] = (d) => m(t).redoMarks(n.index))
        }, [
          C($, {
            name: "Redo2",
            size: 14
          })
        ], 8, w_e),
        u("button", {
          type: "button",
          class: "fb-mk-btn",
          disabled: !s.value,
          title: "Clear the marks on this screenshot",
          "aria-label": "Clear the marks",
          "data-testid": "feedback-mark-clear",
          onClick: l[2] || (l[2] = (d) => m(t).clearMarks(n.index))
        }, [
          C($, {
            name: "Trash2",
            size: 14
          })
        ], 8, k_e)
      ])
    ]));
  }
}), S_e = {
  image: ["image", "images"],
  frame: ["frame", "frames"],
  note: ["note", "notes"],
  shape: ["shape", "shapes"],
  tool: ["session", "sessions"],
  studio: ["studio record", "studio records"],
  chat: ["chat", "chats"]
}, M_e = ["image", "tool", "note", "frame", "shape", "chat", "studio"], T_e = /* @__PURE__ */ new Set(["Add", "Edit", "Delete", "Remote"]);
function hA(n) {
  const e = [];
  for (const t of M_e) {
    const i = n[t] || 0;
    i && e.push(i + " " + S_e[t][i === 1 ? 0 : 1]);
  }
  return e.join(", ") || "nothing";
}
function C_e(n) {
  if (n.ephemeral || n.origin === "load") return null;
  const e = /* @__PURE__ */ new Map();
  for (const a of n.added) e.set(a.id, a.type);
  for (const a of n.updated) e.set(a.id, a.el.type);
  for (const a of n.removed) e.set(a.id, a.type);
  if (!e.size) return null;
  const t = {};
  for (const a of e.values()) t[a] = (t[a] || 0) + 1;
  const i = hA(t), s = Array.from(e.keys()), o = s.slice(0, 6).join(", ") + (s.length > 6 ? " and " + (s.length - 6) + " more" : "");
  if (n.origin === "remote") return { kind: "remote", label: "Someone else's edit: " + i, detail: o };
  let r = n.label;
  return (!r || T_e.has(r)) && (r = n.removed.length && !n.added.length && !n.updated.length ? "Delete" : n.added.length && !n.updated.length && !n.removed.length ? "Add" : "Edit"), { kind: "edit", label: r + ": " + i, detail: o };
}
const pA = [
  ["the board menu", (n) => n.ui.boardMenu],
  ["Keyboard Shortcuts", (n) => n.ui.keysOpen],
  ["Recently Deleted", (n) => n.ui.trashOpen],
  ["the board's history", (n) => n.ui.boardHistory],
  ["image info", (n) => !!n.ui.infoAt],
  ["the Studios view", (n) => !!n.ui.studio],
  ["your Library", (n) => !!n.ui.libraryOpen],
  ["the prompt library", (n) => n.ui.library.open],
  ["the add menu", (n) => n.ui.addMenu],
  ["the place image menu", (n) => n.ui.placeMenu],
  ["the canvas menu", (n) => !!n.ui.canvasMenu],
  ["the session finder", (n) => !!n.ui.finder],
  ["the eyedropper", (n) => !!n.ui.eyedropper]
];
function fA(n) {
  return pA.filter(([, e]) => e(n)).map(([e]) => e);
}
function I_e(n) {
  const e = {};
  for (const t of n.ui.selection) {
    const i = n.store.get(t);
    i && (e[i.type] = (e[i.type] || 0) + 1);
  }
  return hA(e);
}
const _4 = {
  error: "Saving failed; the board is retrying",
  offline: "The board went offline; changes are kept here"
};
function A_e(n, e) {
  const t = [];
  let i = 0, s = 0;
  n.record("board", "Opened a board", e.meta.id), t.push(e.store.subscribe((o) => {
    const r = C_e(o);
    r && n.record(r.kind, r.label, r.detail);
  })), t.push(Ee(() => e.loaded.value, (o) => {
    o && n.record("board", 'Loaded "' + e.meta.title + '": ' + e.store.size + " elements");
  })), t.push(Ee(() => e.loadError.value, (o) => {
    o && n.record("error", "The board didn't open: " + o);
  })), e.onStep = (o, r, a) => n.record(o, r, a), t.push(Ee(() => e.ui.mode, (o) => n.record("tool", o === "hand" ? "Chose the Hand tool" : "Chose the Select tool"))), t.push(Ee(() => e.ui.shapeArmed ? e.ui.shapeKind : null, (o) => {
    o && n.record("tool", "Chose the " + o + " tool");
  })), t.push(Ee(() => e.ui.selection.slice(), () => {
    clearTimeout(i), i = window.setTimeout(() => {
      n.record("select", e.ui.selection.length ? "Selected " + I_e(e) : "Cleared the selection", e.ui.selection.slice(0, 6).join(", ") || void 0);
    }, 450);
  }));
  for (const [o, r] of pA)
    t.push(Ee(() => r(e), (a) => n.record("panel", (a ? "Opened " : "Closed ") + o)));
  return t.push(Ee(() => e.ui.toast ? e.ui.toast.id : 0, () => {
    const o = e.ui.toast;
    o && n.record(o.tone === "error" ? "error" : "toast", 'The board said: "' + o.text + '"');
  })), t.push(Ee(() => e.saveState.value, (o, r) => {
    _4[o] ? n.record("save", _4[o]) : o === "saved" && (r === "error" || r === "offline") && n.record("save", "Saved again");
  })), t.push(e.onCameraFrame((o) => {
    clearTimeout(s), s = window.setTimeout(() => {
      n.record("view", "Moved the view (" + Math.round(o.zoom * 100) + "%)", "x " + Math.round(o.x) + ", y " + Math.round(o.y));
    }, 700);
  })), () => {
    for (const o of t) o();
    clearTimeout(i), clearTimeout(s), e.onStep && (e.onStep = null), n.record("board", "Left the board", e.meta.id);
  };
}
const mA = "[modern-screenshot]", jl = typeof window != "undefined", P_e = jl && "Worker" in window;
var N3;
const mx = jl ? (N3 = window.navigator) == null ? void 0 : N3.userAgent : "", gA = mx.includes("Chrome"), Ff = mx.includes("AppleWebKit") && !gA, gx = mx.includes("Firefox"), E_e = (n) => n && "__CONTEXT__" in n, R_e = (n) => n.constructor.name === "CSSFontFaceRule", z_e = (n) => n.constructor.name === "CSSImportRule", $_e = (n) => n.constructor.name === "CSSLayerBlockRule", Ms = (n) => n.nodeType === 1, Cu = (n) => typeof n.className == "object", bA = (n) => n.tagName === "image", D_e = (n) => n.tagName === "use", au = (n) => Ms(n) && typeof n.style != "undefined" && !Cu(n), O_e = (n) => n.nodeType === 8, L_e = (n) => n.nodeType === 3, Hl = (n) => n.tagName === "IMG", Mm = (n) => n.tagName === "VIDEO", B_e = (n) => n.tagName === "CANVAS", F_e = (n) => n.tagName === "TEXTAREA", N_e = (n) => n.tagName === "INPUT", U_e = (n) => n.tagName === "STYLE", G_e = (n) => n.tagName === "SCRIPT", j_e = (n) => n.tagName === "SELECT", H_e = (n) => n.tagName === "SLOT", V_e = (n) => n.tagName === "IFRAME", W_e = (...n) => console.warn(mA, ...n);
function q_e(n) {
  var t;
  const e = (t = n == null ? void 0 : n.createElement) == null ? void 0 : t.call(n, "canvas");
  return e && (e.height = e.width = 1), !!e && "toDataURL" in e && !!e.toDataURL("image/webp").includes("image/webp");
}
const H0 = (n) => n.startsWith("data:");
function vA(n, e) {
  if (n.match(/^[a-z]+:\/\//i))
    return n;
  if (jl && n.match(/^\/\//))
    return window.location.protocol + n;
  if (n.match(/^[a-z]+:/i) || !jl)
    return n;
  const t = Tm().implementation.createHTMLDocument(), i = t.createElement("base"), s = t.createElement("a");
  return t.head.appendChild(i), t.body.appendChild(s), e && (i.href = e), s.href = n, s.href;
}
function Tm(n) {
  var e;
  return (e = n && Ms(n) ? n == null ? void 0 : n.ownerDocument : n) != null ? e : window.document;
}
const Cm = "http://www.w3.org/2000/svg";
function K_e(n, e, t) {
  const i = Tm(t).createElementNS(Cm, "svg");
  return i.setAttributeNS(null, "width", n.toString()), i.setAttributeNS(null, "height", e.toString()), i.setAttributeNS(null, "viewBox", `0 0 ${n} ${e}`), i;
}
function Y_e(n, e) {
  let t = new XMLSerializer().serializeToString(n);
  return e && (t = t.replace(/[\u0000-\u0008\v\f\u000E-\u001F\uD800-\uDFFF\uFFFE\uFFFF]/gu, "")), `data:image/svg+xml;charset=utf-8,${encodeURIComponent(t)}`;
}
function X_e(n, e) {
  return new Promise((t, i) => {
    const s = new FileReader();
    s.onload = () => t(s.result), s.onerror = () => i(s.error), s.onabort = () => i(new Error(`Failed read blob to ${e}`)), s.readAsDataURL(n);
  });
}
const J_e = (n) => X_e(n, "dataUrl");
function _l(n, e) {
  const t = Tm(e).createElement("img");
  return t.decoding = "sync", t.loading = "eager", t.src = n, t;
}
function lu(n, e) {
  return new Promise((t) => {
    const { timeout: i, ownerDocument: s, onError: o, onWarn: r } = e != null ? e : {}, a = typeof n == "string" ? _l(n, Tm(s)) : n;
    let l = null, d = null;
    function c() {
      t(a), l && clearTimeout(l), d == null || d();
    }
    if (i && (l = setTimeout(c, i)), Mm(a)) {
      const h = a.currentSrc || a.src;
      if (!h)
        return a.poster ? lu(a.poster, e).then(t) : c();
      if (a.readyState >= 2)
        return c();
      const f = c, p = (y) => {
        r == null || r(
          "Failed video load",
          h,
          y
        ), o == null || o(y), c();
      };
      d = () => {
        a.removeEventListener("loadeddata", f), a.removeEventListener("error", p);
      }, a.addEventListener("loadeddata", f, { once: !0 }), a.addEventListener("error", p, { once: !0 });
    } else {
      const h = bA(a) ? a.href.baseVal : a.currentSrc || a.src;
      if (!h)
        return c();
      const f = async () => {
        if (Hl(a) && "decode" in a)
          try {
            await a.decode();
          } catch (y) {
            r == null || r(
              "Failed to decode image, trying to render anyway",
              a.dataset.originalSrc || h,
              y
            );
          }
        c();
      }, p = (y) => {
        r == null || r(
          "Failed image load",
          a.dataset.originalSrc || h,
          y
        ), c();
      };
      if (Hl(a) && a.complete)
        return f();
      d = () => {
        a.removeEventListener("load", f), a.removeEventListener("error", p);
      }, a.addEventListener("load", f, { once: !0 }), a.addEventListener("error", p, { once: !0 });
    }
  });
}
async function Z_e(n, e) {
  au(n) && (Hl(n) || Mm(n) ? await lu(n, e) : await Promise.all(
    ["img", "video"].flatMap((t) => Array.from(n.querySelectorAll(t)).map((i) => lu(i, e)))
  ));
}
const yA = /* @__PURE__ */ (function() {
  let e = 0;
  const t = () => `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
  return () => (e += 1, `u${t()}${e}`);
})();
function xA(n) {
  return n == null ? void 0 : n.split(",").map((e) => e.trim().replace(/"|'/g, "").toLowerCase()).filter(Boolean);
}
let S4 = 0;
function Q_e(n) {
  const e = `${mA}[#${S4}]`;
  return S4++, {
    // eslint-disable-next-line no-console
    time: (t) => n && console.time(`${e} ${t}`),
    // eslint-disable-next-line no-console
    timeEnd: (t) => n && console.timeEnd(`${e} ${t}`),
    warn: (...t) => n && W_e(...t)
  };
}
function e4e(n) {
  return {
    cache: n ? "no-cache" : "force-cache"
  };
}
async function wA(n, e) {
  return E_e(n) ? n : t4e(n, { ...e, autoDestruct: !0 });
}
async function t4e(n, e) {
  var p, y, v, x, w;
  const { scale: t = 1, workerUrl: i, workerNumber: s = 1 } = e || {}, o = !!(e != null && e.debug), r = (p = e == null ? void 0 : e.features) != null ? p : !0, a = (y = n.ownerDocument) != null ? y : jl ? window.document : void 0, l = (x = (v = n.ownerDocument) == null ? void 0 : v.defaultView) != null ? x : jl ? window : void 0, d = /* @__PURE__ */ new Map(), c = {
    // Options
    width: 0,
    height: 0,
    quality: 1,
    type: "image/png",
    scale: t,
    backgroundColor: null,
    style: null,
    filter: null,
    maximumCanvasSize: 0,
    timeout: 3e4,
    progress: null,
    debug: o,
    fetch: {
      requestInit: e4e((w = e == null ? void 0 : e.fetch) == null ? void 0 : w.bypassingCache),
      placeholderImage: "data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      bypassingCache: !1,
      ...e == null ? void 0 : e.fetch
    },
    fetchFn: null,
    font: {},
    drawImageInterval: 100,
    workerUrl: null,
    workerNumber: s,
    onCloneEachNode: null,
    onCloneNode: null,
    onEmbedNode: null,
    onCreateForeignObjectSvg: null,
    includeStyleProperties: null,
    autoDestruct: !1,
    ...e,
    // InternalContext
    __CONTEXT__: !0,
    log: Q_e(o),
    node: n,
    ownerDocument: a,
    ownerWindow: l,
    dpi: t === 1 ? null : 96 * t,
    svgStyleElement: kA(a),
    svgDefsElement: a == null ? void 0 : a.createElementNS(Cm, "defs"),
    svgStyles: /* @__PURE__ */ new Map(),
    defaultComputedStyles: /* @__PURE__ */ new Map(),
    workers: [
      ...Array.from({
        length: P_e && i && s ? s : 0
      })
    ].map(() => {
      try {
        const S = new Worker(i);
        return S.onmessage = async (M) => {
          var k, P, A, R;
          const { url: _, result: T } = M.data;
          T ? (P = (k = d.get(_)) == null ? void 0 : k.resolve) == null || P.call(k, T) : (R = (A = d.get(_)) == null ? void 0 : A.reject) == null || R.call(A, new Error(`Error receiving message from worker: ${_}`));
        }, S.onmessageerror = (M) => {
          var T, k;
          const { url: _ } = M.data;
          (k = (T = d.get(_)) == null ? void 0 : T.reject) == null || k.call(T, new Error(`Error receiving message from worker: ${_}`));
        }, S;
      } catch (S) {
        return c.log.warn("Failed to new Worker", S), null;
      }
    }).filter(Boolean),
    fontFamilies: /* @__PURE__ */ new Map(),
    fontCssTexts: /* @__PURE__ */ new Map(),
    acceptOfImage: `${[
      q_e(a) && "image/webp",
      "image/svg+xml",
      "image/*",
      "*/*"
    ].filter(Boolean).join(",")};q=0.8`,
    requests: d,
    drawImageCount: 0,
    tasks: [],
    features: r,
    isEnable: (S) => {
      var M, _;
      return S === "restoreScrollPosition" ? typeof r == "boolean" ? !1 : (M = r[S]) != null ? M : !1 : typeof r == "boolean" ? r : (_ = r[S]) != null ? _ : !0;
    },
    shadowRoots: []
  };
  c.log.time("wait until load"), await Z_e(n, { timeout: c.timeout, onWarn: c.log.warn }), c.log.timeEnd("wait until load");
  const { width: h, height: f } = n4e(n, c);
  return c.width = h, c.height = f, c;
}
function kA(n) {
  if (!n)
    return;
  const e = n.createElement("style"), t = e.ownerDocument.createTextNode(`
.______background-clip--text {
  background-clip: text;
  -webkit-background-clip: text;
}
`);
  return e.appendChild(t), e;
}
function n4e(n, e) {
  let { width: t, height: i } = e;
  if (Ms(n) && (!t || !i)) {
    const s = n.getBoundingClientRect();
    t = t || s.width || Number(n.getAttribute("width")) || 0, i = i || s.height || Number(n.getAttribute("height")) || 0;
  }
  return { width: t, height: i };
}
async function i4e(n, e) {
  const {
    log: t,
    timeout: i,
    drawImageCount: s,
    drawImageInterval: o
  } = e;
  t.time("image to canvas");
  const r = await lu(n, { timeout: i, onWarn: e.log.warn }), { canvas: a, context2d: l } = s4e(n.ownerDocument, e), d = () => {
    try {
      l == null || l.drawImage(r, 0, 0, a.width, a.height);
    } catch (c) {
      e.log.warn("Failed to drawImage", c);
    }
  };
  if (d(), e.isEnable("fixSvgXmlDecode"))
    for (let c = 0; c < s; c++)
      await new Promise((h) => {
        setTimeout(() => {
          l == null || l.clearRect(0, 0, a.width, a.height), d(), h();
        }, c + o);
      });
  return e.drawImageCount = 0, t.timeEnd("image to canvas"), a;
}
function s4e(n, e) {
  const { width: t, height: i, scale: s, backgroundColor: o, maximumCanvasSize: r } = e, a = n.createElement("canvas");
  a.width = Math.floor(t * s), a.height = Math.floor(i * s), a.style.width = `${t}px`, a.style.height = `${i}px`, r && (a.width > r || a.height > r) && (a.width > r && a.height > r ? a.width > a.height ? (a.height *= r / a.width, a.width = r) : (a.width *= r / a.height, a.height = r) : a.width > r ? (a.height *= r / a.width, a.width = r) : (a.width *= r / a.height, a.height = r));
  const l = a.getContext("2d");
  return l && o && (l.fillStyle = o, l.fillRect(0, 0, a.width, a.height)), { canvas: a, context2d: l };
}
function _A(n, e) {
  if (n.ownerDocument)
    try {
      const o = n.toDataURL();
      if (o !== "data:,")
        return _l(o, n.ownerDocument);
    } catch (o) {
      e.log.warn("Failed to clone canvas", o);
    }
  const t = n.cloneNode(!1), i = n.getContext("2d"), s = t.getContext("2d");
  try {
    return i && s && s.putImageData(
      i.getImageData(0, 0, n.width, n.height),
      0,
      0
    ), t;
  } catch (o) {
    e.log.warn("Failed to clone canvas", o);
  }
  return t;
}
function o4e(n, e) {
  var t;
  try {
    if ((t = n == null ? void 0 : n.contentDocument) != null && t.documentElement)
      return bx(n.contentDocument.documentElement, e);
  } catch (i) {
    e.log.warn("Failed to clone iframe", i);
  }
  return n.cloneNode(!1);
}
function r4e(n) {
  const e = n.cloneNode(!1);
  return n.currentSrc && n.currentSrc !== n.src && (e.src = n.currentSrc, e.srcset = ""), e.loading === "lazy" && (e.loading = "eager"), e;
}
async function a4e(n, e) {
  if (n.ownerDocument && !n.currentSrc && n.poster)
    return _l(n.poster, n.ownerDocument);
  const t = n.cloneNode(!1);
  t.crossOrigin = "anonymous", n.currentSrc && n.currentSrc !== n.src && (t.src = n.currentSrc);
  const i = t.ownerDocument;
  if (i) {
    let s = !0;
    if (await lu(t, { onError: () => s = !1, onWarn: e.log.warn }), !s)
      return n.poster ? _l(n.poster, n.ownerDocument) : t;
    t.currentTime = n.currentTime, await new Promise((r) => {
      t.addEventListener("seeked", r, { once: !0 });
    });
    const o = i.createElement("canvas");
    o.width = n.offsetWidth, o.height = n.offsetHeight;
    try {
      const r = o.getContext("2d");
      r && r.drawImage(t, 0, 0, o.width, o.height);
    } catch (r) {
      return e.log.warn("Failed to clone video", r), n.poster ? _l(n.poster, n.ownerDocument) : t;
    }
    return _A(o, e);
  }
  return t;
}
function l4e(n, e) {
  return B_e(n) ? _A(n, e) : V_e(n) ? o4e(n, e) : Hl(n) ? r4e(n) : Mm(n) ? a4e(n, e) : n.cloneNode(!1);
}
function d4e(n) {
  let e = n.sandbox;
  if (!e) {
    const { ownerDocument: t } = n;
    try {
      t && (e = t.createElement("iframe"), e.id = `__SANDBOX__${yA()}`, e.width = "0", e.height = "0", e.style.visibility = "hidden", e.style.position = "fixed", t.body.appendChild(e), e.srcdoc = '<!DOCTYPE html><meta charset="UTF-8"><title></title><body>', n.sandbox = e);
    } catch (i) {
      n.log.warn("Failed to getSandBox", i);
    }
  }
  return e;
}
const c4e = [
  "width",
  "height",
  "-webkit-text-fill-color"
], u4e = [
  "stroke",
  "fill"
];
function SA(n, e, t) {
  const { defaultComputedStyles: i } = t, s = n.nodeName.toLowerCase(), o = Cu(n) && s !== "svg", r = o ? u4e.map((v) => [v, n.getAttribute(v)]).filter(([, v]) => v !== null) : [], a = [
    o && "svg",
    s,
    r.map((v, x) => `${v}=${x}`).join(","),
    e
  ].filter(Boolean).join(":");
  if (i.has(a))
    return i.get(a);
  const l = d4e(t), d = l == null ? void 0 : l.contentWindow;
  if (!d)
    return /* @__PURE__ */ new Map();
  const c = d == null ? void 0 : d.document;
  let h, f;
  o ? (h = c.createElementNS(Cm, "svg"), f = h.ownerDocument.createElementNS(h.namespaceURI, s), r.forEach(([v, x]) => {
    f.setAttributeNS(null, v, x);
  }), h.appendChild(f)) : h = f = c.createElement(s), f.textContent = " ", c.body.appendChild(h);
  const p = d.getComputedStyle(f, e), y = /* @__PURE__ */ new Map();
  for (let v = p.length, x = 0; x < v; x++) {
    const w = p.item(x);
    c4e.includes(w) || y.set(w, p.getPropertyValue(w));
  }
  return c.body.removeChild(h), i.set(a, y), y;
}
function MA(n, e, t) {
  var a;
  const i = /* @__PURE__ */ new Map(), s = [], o = /* @__PURE__ */ new Map();
  if (t)
    for (const l of t)
      r(l);
  else
    for (let l = n.length, d = 0; d < l; d++) {
      const c = n.item(d);
      r(c);
    }
  for (let l = s.length, d = 0; d < l; d++)
    (a = o.get(s[d])) == null || a.forEach((c, h) => i.set(h, c));
  function r(l) {
    const d = n.getPropertyValue(l), c = n.getPropertyPriority(l), h = l.lastIndexOf("-"), f = h > -1 ? l.substring(0, h) : void 0;
    if (f) {
      let p = o.get(f);
      p || (p = /* @__PURE__ */ new Map(), o.set(f, p)), p.set(l, [d, c]);
    }
    e.get(l) === d && !c || (f ? s.push(f) : i.set(l, [d, c]));
  }
  return i;
}
function h4e(n, e, t, i) {
  var h, f, p, y;
  const { ownerWindow: s, includeStyleProperties: o, currentParentNodeStyle: r } = i, a = e.style, l = s.getComputedStyle(n), d = SA(n, null, i);
  r == null || r.forEach((v, x) => {
    d.delete(x);
  });
  const c = MA(l, d, o);
  c.delete("transition-property"), c.delete("all"), c.delete("d"), c.delete("content"), t && (c.delete("position"), c.delete("margin-top"), c.delete("margin-right"), c.delete("margin-bottom"), c.delete("margin-left"), c.delete("margin-block-start"), c.delete("margin-block-end"), c.delete("margin-inline-start"), c.delete("margin-inline-end"), c.set("box-sizing", ["border-box", ""])), ((h = c.get("background-clip")) == null ? void 0 : h[0]) === "text" && e.classList.add("______background-clip--text"), gA && (c.has("font-kerning") || c.set("font-kerning", ["normal", ""]), (((f = c.get("overflow-x")) == null ? void 0 : f[0]) === "hidden" || ((p = c.get("overflow-y")) == null ? void 0 : p[0]) === "hidden") && ((y = c.get("text-overflow")) == null ? void 0 : y[0]) === "ellipsis" && n.scrollWidth === n.clientWidth && c.set("text-overflow", ["clip", ""]));
  for (let v = a.length, x = 0; x < v; x++)
    a.removeProperty(a.item(x));
  return c.forEach(([v, x], w) => {
    a.setProperty(w, v, x);
  }), c;
}
function p4e(n, e) {
  (F_e(n) || N_e(n) || j_e(n)) && e.setAttribute("value", n.value);
}
const f4e = [
  "::before",
  "::after"
  // '::placeholder', TODO
], m4e = [
  "::-webkit-scrollbar",
  "::-webkit-scrollbar-button",
  // '::-webkit-scrollbar:horizontal', TODO
  "::-webkit-scrollbar-thumb",
  "::-webkit-scrollbar-track",
  "::-webkit-scrollbar-track-piece",
  // '::-webkit-scrollbar:vertical', TODO
  "::-webkit-scrollbar-corner",
  "::-webkit-resizer"
];
function g4e(n, e, t, i, s) {
  const { ownerWindow: o, svgStyleElement: r, svgStyles: a, currentNodeStyle: l } = i;
  if (!r || !o)
    return;
  function d(c) {
    var M;
    const h = o.getComputedStyle(n, c);
    let f = h.getPropertyValue("content");
    if (!f || f === "none")
      return;
    s == null || s(f), f = f.replace(/(')|(")|(counter\(.+\))/g, "");
    const p = [yA()], y = SA(n, c, i);
    l == null || l.forEach((_, T) => {
      y.delete(T);
    });
    const v = MA(h, y, i.includeStyleProperties);
    v.delete("content"), v.delete("-webkit-locale"), ((M = v.get("background-clip")) == null ? void 0 : M[0]) === "text" && e.classList.add("______background-clip--text");
    const x = [
      `content: '${f}';`
    ];
    if (v.forEach(([_, T], k) => {
      x.push(`${k}: ${_}${T ? " !important" : ""};`);
    }), x.length === 1)
      return;
    try {
      e.className = [e.className, ...p].join(" ");
    } catch (_) {
      i.log.warn("Failed to copyPseudoClass", _);
      return;
    }
    const w = x.join(`
  `);
    let S = a.get(w);
    S || (S = [], a.set(w, S)), S.push(`.${p[0]}${c}`);
  }
  f4e.forEach(d), t && m4e.forEach(d);
}
const M4 = /* @__PURE__ */ new Set([
  "symbol"
  // test/fixtures/svg.symbol.html
]);
async function T4(n, e, t, i, s) {
  if (Ms(t) && (U_e(t) || G_e(t)) || i.filter && !i.filter(t))
    return;
  M4.has(e.nodeName) || M4.has(t.nodeName) ? i.currentParentNodeStyle = void 0 : i.currentParentNodeStyle = i.currentNodeStyle;
  const o = await bx(t, i, !1, s);
  i.isEnable("restoreScrollPosition") && b4e(n, o), e.appendChild(o);
}
async function C4(n, e, t, i) {
  var o;
  let s = n.firstChild;
  Ms(n) && n.shadowRoot && (s = (o = n.shadowRoot) == null ? void 0 : o.firstChild, t.shadowRoots.push(n.shadowRoot));
  for (let r = s; r; r = r.nextSibling)
    if (!O_e(r))
      if (Ms(r) && H_e(r) && typeof r.assignedNodes == "function") {
        const a = r.assignedNodes();
        for (let l = 0; l < a.length; l++)
          await T4(n, e, a[l], t, i);
      } else
        await T4(n, e, r, t, i);
}
function b4e(n, e) {
  if (!au(n) || !au(e))
    return;
  const { scrollTop: t, scrollLeft: i } = n;
  if (!t && !i)
    return;
  const { transform: s } = e.style, o = new DOMMatrix(s), { a: r, b: a, c: l, d } = o;
  o.a = 1, o.b = 0, o.c = 0, o.d = 1, o.translateSelf(-i, -t), o.a = r, o.b = a, o.c = l, o.d = d, e.style.transform = o.toString();
}
function v4e(n, e) {
  const { backgroundColor: t, width: i, height: s, style: o } = e, r = n.style;
  if (t && r.setProperty("background-color", t, "important"), i && r.setProperty("width", `${i}px`, "important"), s && r.setProperty("height", `${s}px`, "important"), o)
    for (const a in o) r[a] = o[a];
}
const y4e = /^[\w-:]+$/;
async function bx(n, e, t = !1, i) {
  var d, c, h, f;
  const { ownerDocument: s, ownerWindow: o, fontFamilies: r, onCloneEachNode: a } = e;
  if (s && L_e(n))
    return i && /\S/.test(n.data) && i(n.data), s.createTextNode(n.data);
  if (s && o && Ms(n) && (au(n) || Cu(n))) {
    const p = await l4e(n, e);
    if (e.isEnable("removeAbnormalAttributes")) {
      const M = p.getAttributeNames();
      for (let _ = M.length, T = 0; T < _; T++) {
        const k = M[T];
        y4e.test(k) || p.removeAttribute(k);
      }
    }
    const y = e.currentNodeStyle = h4e(n, p, t, e);
    t && v4e(p, e);
    let v = !1;
    if (e.isEnable("copyScrollbar")) {
      const M = [
        (d = y.get("overflow-x")) == null ? void 0 : d[0],
        (c = y.get("overflow-y")) == null ? void 0 : c[0]
      ];
      v = M.includes("scroll") || (M.includes("auto") || M.includes("overlay")) && (n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth);
    }
    const x = (h = y.get("text-transform")) == null ? void 0 : h[0], w = xA((f = y.get("font-family")) == null ? void 0 : f[0]), S = w ? (M) => {
      x === "uppercase" ? M = M.toUpperCase() : x === "lowercase" ? M = M.toLowerCase() : x === "capitalize" && (M = M[0].toUpperCase() + M.substring(1)), w.forEach((_) => {
        let T = r.get(_);
        T || r.set(_, T = /* @__PURE__ */ new Set()), M.split("").forEach((k) => T.add(k));
      });
    } : void 0;
    return g4e(
      n,
      p,
      v,
      e,
      S
    ), p4e(n, p), Mm(n) || await C4(
      n,
      p,
      e,
      S
    ), await (a == null ? void 0 : a(p)), p;
  }
  const l = n.cloneNode(!1);
  return await C4(n, l, e), await (a == null ? void 0 : a(l)), l;
}
function x4e(n) {
  if (n.ownerDocument = void 0, n.ownerWindow = void 0, n.svgStyleElement = void 0, n.svgDefsElement = void 0, n.svgStyles.clear(), n.defaultComputedStyles.clear(), n.sandbox) {
    try {
      n.sandbox.remove();
    } catch (e) {
      n.log.warn("Failed to destroyContext", e);
    }
    n.sandbox = void 0;
  }
  n.workers = [], n.fontFamilies.clear(), n.fontCssTexts.clear(), n.requests.clear(), n.tasks = [], n.shadowRoots = [];
}
function w4e(n) {
  const { url: e, timeout: t, responseType: i, ...s } = n, o = new AbortController(), r = t ? setTimeout(() => o.abort(), t) : void 0;
  return fetch(e, { signal: o.signal, ...s }).then((a) => {
    if (!a.ok)
      throw new Error("Failed fetch, not 2xx response", { cause: a });
    switch (i) {
      case "arrayBuffer":
        return a.arrayBuffer();
      case "dataUrl":
        return a.blob().then(J_e);
      default:
        return a.text();
    }
  }).finally(() => clearTimeout(r));
}
function du(n, e) {
  const { url: t, requestType: i = "text", responseType: s = "text", imageDom: o } = e;
  let r = t;
  const {
    timeout: a,
    acceptOfImage: l,
    requests: d,
    fetchFn: c,
    fetch: {
      requestInit: h,
      bypassingCache: f,
      placeholderImage: p
    },
    font: y,
    workers: v,
    fontFamilies: x
  } = n;
  i === "image" && (Ff || gx) && n.drawImageCount++;
  let w = d.get(t);
  if (!w) {
    f && f instanceof RegExp && f.test(r) && (r += (/\?/.test(r) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
    const S = i.startsWith("font") && y && y.minify, M = /* @__PURE__ */ new Set();
    S && i.split(";")[1].split(",").forEach((P) => {
      x.has(P) && x.get(P).forEach((A) => M.add(A));
    });
    const _ = S && M.size, T = {
      url: r,
      timeout: a,
      responseType: _ ? "arrayBuffer" : s,
      headers: i === "image" ? { accept: l } : void 0,
      ...h
    };
    w = {
      type: i,
      resolve: void 0,
      reject: void 0,
      response: null
    }, w.response = (async () => {
      if (c && i === "image") {
        const k = await c(t);
        if (k)
          return k;
      }
      return !Ff && t.startsWith("http") && v.length ? new Promise((k, P) => {
        v[d.size & v.length - 1].postMessage({ rawUrl: t, ...T }), w.resolve = k, w.reject = P;
      }) : w4e(T);
    })().catch((k) => {
      if (d.delete(t), i === "image" && p)
        return n.log.warn("Failed to fetch image base64, trying to use placeholder image", r), typeof p == "string" ? p : p(o);
      throw k;
    }), d.set(t, w);
  }
  return w.response;
}
async function TA(n, e, t, i) {
  if (!CA(n))
    return n;
  for (const [s, o] of k4e(n, e))
    try {
      const r = await du(
        t,
        {
          url: o,
          requestType: i ? "image" : "text",
          responseType: "dataUrl"
        }
      );
      n = n.replace(_4e(s), `$1${r}$3`);
    } catch (r) {
      t.log.warn("Failed to fetch css data url", s, r);
    }
  return n;
}
function CA(n) {
  return /url\((['"]?)([^'"]+?)\1\)/.test(n);
}
const IA = /url\((['"]?)([^'"]+?)\1\)/g;
function k4e(n, e) {
  const t = [];
  return n.replace(IA, (i, s, o) => (t.push([o, vA(o, e)]), i)), t.filter(([i]) => !H0(i));
}
function _4e(n) {
  const e = n.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${e})(['"]?\\))`, "g");
}
const S4e = [
  "background-image",
  "border-image-source",
  "-webkit-border-image",
  "-webkit-mask-image",
  "list-style-image"
];
function M4e(n, e) {
  return S4e.map((t) => {
    const i = n.getPropertyValue(t);
    return !i || i === "none" ? null : ((Ff || gx) && e.drawImageCount++, TA(i, null, e, !0).then((s) => {
      !s || i === s || n.setProperty(
        t,
        s,
        n.getPropertyPriority(t)
      );
    }));
  }).filter(Boolean);
}
function T4e(n, e) {
  if (Hl(n)) {
    const t = n.currentSrc || n.src;
    if (!H0(t))
      return [
        du(e, {
          url: t,
          imageDom: n,
          requestType: "image",
          responseType: "dataUrl"
        }).then((i) => {
          i && (n.srcset = "", n.dataset.originalSrc = t, n.src = i || "");
        })
      ];
    (Ff || gx) && e.drawImageCount++;
  } else if (Cu(n) && !H0(n.href.baseVal)) {
    const t = n.href.baseVal;
    return [
      du(e, {
        url: t,
        imageDom: n,
        requestType: "image",
        responseType: "dataUrl"
      }).then((i) => {
        i && (n.dataset.originalSrc = t, n.href.baseVal = i || "");
      })
    ];
  }
  return [];
}
function C4e(n, e) {
  var a;
  const { ownerDocument: t, svgDefsElement: i } = e, s = (a = n.getAttribute("href")) != null ? a : n.getAttribute("xlink:href");
  if (!s)
    return [];
  const [o, r] = s.split("#");
  if (r) {
    const l = `#${r}`, d = e.shadowRoots.reduce(
      (c, h) => c != null ? c : h.querySelector(`svg ${l}`),
      t == null ? void 0 : t.querySelector(`svg ${l}`)
    );
    if (o && n.setAttribute("href", l), i != null && i.querySelector(l))
      return [];
    if (d)
      return i == null || i.appendChild(d.cloneNode(!0)), [];
    if (o)
      return [
        du(e, {
          url: o,
          responseType: "text"
        }).then((c) => {
          i == null || i.insertAdjacentHTML("beforeend", c);
        })
      ];
  }
  return [];
}
function AA(n, e) {
  const { tasks: t } = e;
  Ms(n) && ((Hl(n) || bA(n)) && t.push(...T4e(n, e)), D_e(n) && t.push(...C4e(n, e))), au(n) && t.push(...M4e(n.style, e)), n.childNodes.forEach((i) => {
    AA(i, e);
  });
}
async function I4e(n, e) {
  const {
    ownerDocument: t,
    svgStyleElement: i,
    fontFamilies: s,
    fontCssTexts: o,
    tasks: r,
    font: a
  } = e;
  if (!(!t || !i || !s.size))
    if (a && a.cssText) {
      const l = A4(a.cssText, e);
      i.appendChild(t.createTextNode(`${l}
`));
    } else {
      const l = Array.from(t.styleSheets).filter((p) => {
        try {
          return "cssRules" in p && !!p.cssRules.length;
        } catch (y) {
          return e.log.warn(`Error while reading CSS rules from ${p.href}`, y), !1;
        }
      }), d = t.implementation.createHTMLDocument(""), c = d.createElement("style");
      d.head.appendChild(c);
      const h = c.sheet;
      await Promise.all(
        l.flatMap((p) => Array.from(p.cssRules).map(async (y) => {
          if (z_e(y)) {
            const v = y.href;
            let x = "";
            try {
              x = await du(e, {
                url: v,
                requestType: "text",
                responseType: "text"
              });
            } catch (S) {
              e.log.warn(`Error fetch remote css import from ${v}`, S);
            }
            const w = x.replace(
              IA,
              (S, M, _) => S.replace(_, vA(_, v))
            );
            for (const S of P4e(w))
              try {
                h.insertRule(S, h.cssRules.length);
              } catch (M) {
                e.log.warn("Error inserting rule from remote css import", { rule: S, error: M });
              }
          }
        }))
      ), h.cssRules.length && l.push(h);
      const f = [];
      l.forEach((p) => {
        V0(p.cssRules, f);
      }), f.filter((p) => {
        var y;
        return R_e(p) && CA(p.style.getPropertyValue("src")) && ((y = xA(p.style.getPropertyValue("font-family"))) == null ? void 0 : y.some((v) => s.has(v)));
      }).forEach((p) => {
        const y = p, v = o.get(y.cssText);
        v ? i.appendChild(t.createTextNode(`${v}
`)) : r.push(
          TA(
            y.cssText,
            y.parentStyleSheet ? y.parentStyleSheet.href : null,
            e
          ).then((x) => {
            x = A4(x, e), o.set(y.cssText, x), i.appendChild(t.createTextNode(`${x}
`));
          })
        );
      });
    }
}
const A4e = /(\/\*[\s\S]*?\*\/)/g, I4 = /((@.*?keyframes [\s\S]*?){([\s\S]*?}\s*?)})/gi;
function P4e(n) {
  if (n == null)
    return [];
  const e = [];
  let t = n.replace(A4e, "");
  for (; ; ) {
    const o = I4.exec(t);
    if (!o)
      break;
    e.push(o[0]);
  }
  t = t.replace(I4, "");
  const i = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, s = new RegExp(
    // eslint-disable-next-line
    "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})",
    "gi"
  );
  for (; ; ) {
    let o = i.exec(t);
    if (o)
      s.lastIndex = i.lastIndex;
    else if (o = s.exec(t), o)
      i.lastIndex = s.lastIndex;
    else
      break;
    e.push(o[0]);
  }
  return e;
}
const E4e = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g, R4e = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function A4(n, e) {
  const { font: t } = e, i = t ? t == null ? void 0 : t.preferredFormat : void 0;
  return i ? n.replace(R4e, (s) => {
    for (; ; ) {
      const [o, , r] = E4e.exec(s) || [];
      if (!r)
        return "";
      if (r === i)
        return `src: ${o};`;
    }
  }) : n;
}
function V0(n, e = []) {
  for (const t of Array.from(n))
    $_e(t) ? e.push(...V0(t.cssRules)) : "cssRules" in t ? V0(t.cssRules, e) : e.push(t);
  return e;
}
const z4e = /\bx?link:?href\s*=\s*["'](?!data:)[^"']+["']/i;
function $4e(n) {
  return z4e.test(n.innerHTML);
}
async function D4e(n, e) {
  const t = await wA(n, e);
  if (Ms(t.node) && Cu(t.node) && !$4e(t.node))
    return t.node;
  const {
    ownerDocument: i,
    log: s,
    tasks: o,
    svgStyleElement: r,
    svgDefsElement: a,
    svgStyles: l,
    font: d,
    progress: c,
    autoDestruct: h,
    onCloneNode: f,
    onEmbedNode: p,
    onCreateForeignObjectSvg: y
  } = t;
  s.time("clone node");
  const v = await bx(t.node, t, !0);
  if (r && i) {
    let _ = "";
    l.forEach((T, k) => {
      _ += `${T.join(`,
`)} {
  ${k}
}
`;
    }), r.appendChild(i.createTextNode(_));
  }
  s.timeEnd("clone node"), await (f == null ? void 0 : f(v)), d !== !1 && Ms(v) && (s.time("embed web font"), await I4e(v, t), s.timeEnd("embed web font")), s.time("embed node"), AA(v, t);
  const x = o.length;
  let w = 0;
  const S = async () => {
    for (; ; ) {
      const _ = o.pop();
      if (!_)
        break;
      try {
        await _;
      } catch (T) {
        t.log.warn("Failed to run task", T);
      }
      c == null || c(++w, x);
    }
  };
  c == null || c(w, x), await Promise.all([...Array.from({ length: 4 })].map(S)), s.timeEnd("embed node"), await (p == null ? void 0 : p(v));
  const M = O4e(v, t);
  return a && M.insertBefore(a, M.children[0]), r && M.insertBefore(r, M.children[0]), h && x4e(t), await (y == null ? void 0 : y(M)), M;
}
function O4e(n, e) {
  const { width: t, height: i } = e, s = K_e(t, i, n.ownerDocument), o = s.ownerDocument.createElementNS(s.namespaceURI, "foreignObject");
  return o.setAttributeNS(null, "x", "0%"), o.setAttributeNS(null, "y", "0%"), o.setAttributeNS(null, "width", "100%"), o.setAttributeNS(null, "height", "100%"), o.append(n), s.appendChild(o), s;
}
async function L4e(n, e) {
  var r;
  const t = await wA(n, e), i = await D4e(t), s = Y_e(i, t.isEnable("removeControlCharacter"));
  t.autoDestruct || (t.svgStyleElement = kA(t.ownerDocument), t.svgDefsElement = (r = t.ownerDocument) == null ? void 0 : r.createElementNS(Cm, "defs"), t.svgStyles.clear());
  const o = _l(s, i.ownerDocument);
  return await i4e(o, t);
}
const PA = 2560, B4e = 3.5 * 1024 * 1024;
function F4e(n) {
  return n instanceof Element ? n.hasAttribute("data-feedback-skip") ? !1 : !(n.tagName === "CANVAS" && n.classList.contains("bd-canvas")) : !0;
}
const W0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
function N4e(n) {
  return new Promise((e, t) => {
    const i = new FileReader();
    i.onload = () => e(String(i.result || "")), i.onerror = () => t(i.error || new Error("The picture couldn't be read")), i.readAsDataURL(n);
  });
}
async function U4e(n) {
  if (!/^https?:/i.test(n)) return !1;
  try {
    if (new URL(n, location.href).origin === location.origin) return !1;
    const e = await fetch(n + (n.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", { mode: "cors", credentials: "omit" });
    return e.ok ? await N4e(await e.blob()) : W0;
  } catch {
    return W0;
  }
}
function G4e(n) {
  const e = [];
  return n.querySelectorAll("img").forEach((t) => {
    t.loading !== "lazy" || t.complete || (t.loading = "eager", e.push(t));
  }), () => {
    for (const t of e) t.loading = "lazy";
  };
}
function P4(n, e, t) {
  return new Promise((i) => n.toBlob(i, e, t));
}
function j4e(n, e) {
  const t = document.createElement("canvas");
  t.width = Math.max(1, Math.round(n.width * e)), t.height = Math.max(1, Math.round(n.height * e));
  const i = t.getContext("2d");
  return i && i.drawImage(n, 0, 0, t.width, t.height), t;
}
async function vx(n) {
  let e = n;
  for (let t = 0; t < 4; t++) {
    let i = await P4(e, "image/webp", 0.86);
    if ((!i || i.type !== "image/webp") && (i = await P4(e, "image/jpeg", 0.88)), i && (i.size <= B4e || t === 3)) {
      const s = i.type === "image/webp" ? "image/webp" : i.type === "image/png" ? "image/png" : "image/jpeg";
      return { blob: i, type: s, w: e.width, h: e.height };
    }
    e = j4e(e, 0.75);
  }
  throw new Error("The screenshot couldn't be encoded");
}
async function H4e(n, e, t) {
  const i = Date.now(), s = e ? e.snapshot() : null, o = n.querySelector("canvas.bd-canvas");
  if (s && o && o.parentElement) {
    const a = o.getBoundingClientRect();
    s.setAttribute("data-feedback-frame", ""), s.style.cssText = "position:absolute;left:0;top:0;width:" + a.width + "px;height:" + a.height + "px;pointer-events:none", o.parentElement.appendChild(s);
  }
  const r = G4e(n);
  try {
    const a = n.getBoundingClientRect(), l = Math.min(2, window.devicePixelRatio || 1), d = Math.min(l, PA / Math.max(1, a.width, a.height)), c = await L4e(n, {
      scale: d,
      filter: F4e,
      timeout: 1e4,
      fetchFn: U4e,
      fetch: { placeholderImage: W0 }
    }), h = await vx(c);
    return { ...h, url: URL.createObjectURL(h.blob), at: i, from: "board", ...t };
  } finally {
    r(), s && s.parentElement && s.parentElement.removeChild(s);
  }
}
const V4e = 40 * 1024 * 1024;
function EA(n) {
  return /^image\//i.test(n.type);
}
async function W4e(n) {
  if (typeof createImageBitmap == "function")
    try {
      const t = await createImageBitmap(n);
      return { pic: t, w: t.width, h: t.height, release: () => t.close() };
    } catch {
    }
  const e = URL.createObjectURL(n);
  try {
    const t = new Image();
    return t.src = e, await t.decode(), { pic: t, w: t.naturalWidth, h: t.naturalHeight, release: () => URL.revokeObjectURL(e) };
  } catch (t) {
    throw URL.revokeObjectURL(e), t;
  }
}
async function q4e(n, e) {
  if (n.size > V4e) throw new Error("The picture is too large to add");
  const t = Date.now(), i = await W4e(n);
  try {
    if (!i.w || !i.h) throw new Error("The picture has no pixels");
    const s = Math.min(1, PA / Math.max(i.w, i.h)), o = document.createElement("canvas");
    o.width = Math.max(1, Math.round(i.w * s)), o.height = Math.max(1, Math.round(i.h * s));
    const r = o.getContext("2d");
    if (!r) throw new Error("No 2D canvas to draw the picture on");
    r.drawImage(i.pic, 0, 0, o.width, o.height);
    const a = await vx(o);
    return { ...a, url: URL.createObjectURL(a.blob), at: t, from: e, camera: null, selection: [], panels: [] };
  } finally {
    i.release();
  }
}
async function K4e(n) {
  const e = document.createElement("canvas");
  e.width = n.w, e.height = n.h;
  const t = e.getContext("2d");
  if (!t) throw new Error("No 2D canvas to draw the marks on");
  const i = new Image();
  return i.src = n.url, await i.decode(), t.drawImage(i, 0, 0, e.width, e.height), n.marks && await ix(t, n.marks, n.w, n.h, e.width, e.height), vx(e);
}
const E4 = 9 * 1024 * 1024, R4 = 4e3, RA = 50;
class zA extends Error {
  constructor() {
    super("This report is too large to send. Remove a screenshot and try again."), this.name = "ReportTooLarge";
  }
}
function Y4e(n) {
  return new Promise((e, t) => {
    const i = new FileReader();
    i.onload = () => {
      const s = String(i.result || "");
      e(s.slice(s.indexOf(",") + 1));
    }, i.onerror = () => t(i.error || new Error("The file couldn't be read")), i.readAsDataURL(n);
  });
}
function z4(n) {
  let e = "";
  for (let t = 0; t < n.length; t += 32768) e += String.fromCharCode.apply(null, Array.from(n.subarray(t, t + 32768)));
  return btoa(e);
}
async function $4(n) {
  const e = JSON.stringify(n), t = typeof CompressionStream != "undefined" ? new Response(e).body : null;
  if (t) {
    const i = await new Response(t.pipeThrough(new CompressionStream("gzip"))).arrayBuffer();
    return { data: z4(new Uint8Array(i)), gzip: !0 };
  }
  return { data: z4(new TextEncoder().encode(e)), gzip: !1 };
}
function $A(n) {
  let e;
  return (e = n.match(/Edg\/(\d+)/)) ? "Edge " + e[1] : (e = n.match(/Firefox\/(\d+)/)) ? "Firefox " + e[1] : (e = n.match(/Chrome\/(\d+)/)) ? "Chrome " + e[1] : (e = n.match(/Version\/(\d+(?:\.\d+)?).*Safari/)) ? "Safari " + e[1] : "Unknown browser";
}
function DA(n, e) {
  return /iPad|iPhone/.test(n) ? "iOS or iPadOS" : /Mac OS X/.test(n) ? e > 1 ? "iPadOS" : "macOS" : /Windows/.test(n) ? "Windows" : /Android/.test(n) ? "Android" : /CrOS/.test(n) ? "ChromeOS" : /Linux/.test(n) ? "Linux" : "Unknown";
}
function OA(n) {
  const e = navigator;
  return {
    browser: $A(e.userAgent),
    os: DA(e.userAgent, e.maxTouchPoints || 0),
    dpr: window.devicePixelRatio || 1,
    viewport: { w: window.innerWidth, h: window.innerHeight },
    gpu: n,
    memoryGb: typeof e.deviceMemory == "number" ? e.deviceMemory : null
  };
}
function X4e(n) {
  const e = navigator;
  return {
    userAgent: e.userAgent,
    language: e.language,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: { w: screen.width, h: screen.height },
    window: { w: window.innerWidth, h: window.innerHeight },
    dpr: window.devicePixelRatio || 1,
    memoryGb: typeof e.deviceMemory == "number" ? e.deviceMemory : null,
    cores: e.hardwareConcurrency || null,
    online: e.onLine,
    connection: e.connection && e.connection.effectiveType ? e.connection.effectiveType : null,
    gpu: n
  };
}
function LA(n) {
  const e = {};
  for (const i of n.store.all()) e[i.type] = (e[i.type] || 0) + 1;
  const t = n.cam.value;
  return {
    board: { id: n.meta.id, title: n.meta.title, teamId: n.meta.teamId, accessLevel: n.meta.accessLevel, size: n.store.size, counts: e },
    camera: { x: Math.round(t.x), y: Math.round(t.y), zoom: Math.round(t.zoom * 1e3) / 1e3 },
    view: { w: Math.round(n.view.w), h: Math.round(n.view.h) },
    selection: n.ui.selection.slice(0, RA),
    tool: n.ui.shapeArmed ? n.ui.shapeKind : n.ui.mode,
    openPanels: fA(n),
    undo: n.store.undoLabels().slice(-12),
    saveState: n.saveState.value,
    running: Object.keys(n.generating),
    loaded: n.loaded.value,
    loadError: n.loadError.value,
    engine: n.engine ? n.engine.currentStats() : null
  };
}
function BA(n, e) {
  return e && e > 0 && n.length > e ? n.slice(-e) : n;
}
async function J4e(n) {
  try {
    return await K4e(n);
  } catch (e) {
    return console.warn("[board] a screenshot's marks couldn't be drawn into it", e), n;
  }
}
async function Z4e(n, e) {
  const { board: t, recorder: i } = e, s = t.engine ? t.engine.gpu() : null, o = n.include.steps ? BA(i.list(), n.include.stepCount) : [], r = n.include.errors ? i.errors() : [], a = await Promise.all(n.shots.map(async (y) => {
    const v = ru(y.marks) ? await J4e(y) : y;
    return {
      contentType: v.type,
      data: await Y4e(v.blob),
      w: v.w,
      h: v.h,
      at: y.at,
      from: y.from,
      camera: y.camera,
      selection: y.selection.slice(0, RA),
      panels: y.panels.slice(0, 20)
    };
  })), l = t.engine, d = (y) => ({
    v: 1,
    createdAt: Date.now(),
    build: e.build,
    steps: o,
    errors: r,
    frames: l ? { intervalsMs: l.frameIntervals().map((v) => Math.round(v * 10) / 10), stats: l.currentStats() } : null,
    state: n.include.state ? LA(t) : null,
    snapshot: n.include.state ? y ? { elements: Array.from(t.store.all()) } : { dropped: "The board was too large to send with this report.", size: t.store.size } : null,
    device: n.include.device ? X4e(s) : null
  }), c = a.reduce((y, v) => y + v.data.length, 0);
  let f = n.include.steps || n.include.errors || n.include.state || n.include.device ? await $4(d(!0)) : null;
  if (f && c + f.data.length > E4 && n.include.state && (f = await $4(d(!1))), c + (f ? f.data.length : 0) > E4) throw new zA();
  const p = n.include.device ? OA(s) : { browser: $A(navigator.userAgent), os: DA(navigator.userAgent, navigator.maxTouchPoints || 0), dpr: window.devicePixelRatio || 1, viewport: { w: window.innerWidth, h: window.innerHeight }, gpu: null, memoryGb: null };
  return {
    kind: n.kind,
    happened: n.happened.trim().slice(0, R4),
    expected: n.expected.trim().slice(0, R4),
    source: n.source,
    board: { id: t.meta.id, title: t.meta.title },
    teamId: t.meta.teamId,
    shots: a,
    bundle: f,
    counts: { steps: o.length, errors: r.length },
    build: e.build,
    env: p
  };
}
var Q4e = Object.defineProperty, e3e = (n, e, t) => e in n ? Q4e(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Tr = (n, e, t) => e3e(n, typeof e != "symbol" ? e + "" : e, t);
const Sl = 6, Fb = "Six screenshots is the most a report holds.", t3e = { upload: "from your computer", paste: "pasted", drop: "dropped in" }, n3e = 100;
function Nb() {
  return {
    kind: "bug",
    happened: "",
    expected: "",
    source: "button",
    include: { steps: !0, stepCount: null, state: !0, errors: !0, device: !0 },
    shots: [],
    active: 0,
    capturing: !1,
    sending: !1,
    error: null,
    marksRev: 0
  };
}
class i3e {
  constructor(e) {
    Tr(this, "state", /* @__PURE__ */ Xt({ mode: "closed", flash: 0, pen: { tool: "box", color: uA[0] }, ...Nb() })), Tr(this, "recorder"), Tr(this, "board"), Tr(this, "sink"), Tr(this, "build"), Tr(this, "histories", /* @__PURE__ */ new Map()), Tr(this, "disposed", !1), this.board = e.board, this.recorder = e.recorder, this.sink = e.sink, this.build = e.build;
  }
  get hasDraft() {
    const e = this.state;
    return e.shots.length > 0 || !!e.happened.trim() || !!e.expected.trim();
  }
  get canSend() {
    return !!this.state.happened.trim() && !this.state.sending && !this.state.capturing;
  }
  /**
   * Feedback asked for. Stepped aside, it takes the next screenshot. With a
   * draft waiting, the button and the menu reopen it as it was, and the key
   * adds the view it caught. Otherwise a new report starts with a screenshot.
   */
  async start(e) {
    const t = this.state;
    if (!(this.disposed || t.mode === "open" || t.capturing || t.sending)) {
      if (t.mode === "aside") {
        await this.capture();
        return;
      }
      if (this.hasDraft && e !== "key") {
        this.open("Reopened the draft report");
        return;
      }
      this.hasDraft || (t.source = e), e !== "key" && (this.board.ui.boardMenu = !1, await nt()), await this.capture(), this.open("Opened Send Feedback (" + (e === "key" ? "the ` key" : e === "menu" ? "the board menu" : "the Feedback button") + ")");
    }
  }
  open(e) {
    this.board.ui.boardMenu = !1, this.state.mode = "open", this.recorder.record("panel", e);
  }
  /** "Add screenshot": the reporter steps aside while the tester sets up the next view. */
  stepAside() {
    this.state.shots.length >= Sl || (this.state.mode = "aside", this.recorder.record("panel", "Stepped aside to set up another screenshot"));
  }
  /** Back to the reporter from stepping aside. */
  resume() {
    this.state.mode === "aside" && this.open("Back to the report");
  }
  /** Close the reporter; the draft waits on the Feedback button. */
  close() {
    this.state.mode !== "closed" && (this.state.mode = "closed", this.recorder.record("panel", this.hasDraft ? "Closed Send Feedback, draft kept" : "Closed Send Feedback"));
  }
  discard() {
    this.releaseShots();
    const e = this.state.flash;
    Object.assign(this.state, { mode: "closed", flash: e }, Nb()), this.recorder.record("panel", "Discarded a draft report");
  }
  removeShot(e) {
    const t = this.state, i = t.shots[e];
    i && (URL.revokeObjectURL(i.url), this.histories.delete(i.url), t.shots.splice(e, 1), t.active >= t.shots.length ? t.active = Math.max(0, t.shots.length - 1) : t.active > e && t.active--, this.recorder.record("shot", "Removed screenshot " + (e + 1)));
  }
  /** What the tester has drawn on screenshot `i`. */
  marksOf(e) {
    const t = this.state.shots[e];
    return t && t.marks ? t.marks : j0;
  }
  /** A box, arrow, circle or pencil line drawn on screenshot `i`. */
  addStroke(e, t) {
    this.changeMarks(e, d_e(this.marksOf(e), t));
  }
  /** A numbered marker on screenshot `i`: the next number. */
  addPin(e, t) {
    this.changeMarks(e, c_e(this.marksOf(e), { id: wt(), x: t.x, y: t.y, text: "" }));
  }
  /** Every mark off screenshot `i` (undo puts them back). */
  clearMarks(e) {
    ru(this.marksOf(e)) && this.changeMarks(e, j0);
  }
  canUndoMarks(e) {
    this.state.marksRev;
    const t = this.historyOf(e);
    return !!t && t.back.length > 0;
  }
  canRedoMarks(e) {
    this.state.marksRev;
    const t = this.historyOf(e);
    return !!t && t.ahead.length > 0;
  }
  undoMarks(e) {
    const t = this.historyOf(e), i = t ? t.back.pop() : void 0;
    !t || !i || (t.ahead.push(this.marksOf(e)), this.putMarks(e, i));
  }
  redoMarks(e) {
    const t = this.historyOf(e), i = t ? t.ahead.pop() : void 0;
    !t || !i || (t.back.push(this.marksOf(e)), this.putMarks(e, i));
  }
  historyOf(e) {
    const t = this.state.shots[e];
    return t ? this.histories.get(t.url) : void 0;
  }
  changeMarks(e, t) {
    const i = this.state.shots[e];
    if (!i) return;
    let s = this.histories.get(i.url);
    s || (s = { back: [], ahead: [] }, this.histories.set(i.url, s), this.recorder.record("shot", "Marked up screenshot " + (e + 1))), s.back.push(this.marksOf(e)), s.back.length > n3e && s.back.shift(), s.ahead = [], this.putMarks(e, t);
  }
  /** The screenshot kept raw, as a new object with its marks, so the reporter sees the change. */
  putMarks(e, t) {
    const i = this.state, s = i.shots[e];
    s && (i.shots.splice(e, 1, mp({ ...s, marks: t })), i.marksRev++);
  }
  /** Take a screenshot of the board as it is now. */
  async capture() {
    const e = this.state;
    if (e.capturing) return !1;
    if (e.shots.length >= Sl)
      return this.board.toast(Fb), !1;
    const t = this.board.worldEl ? this.board.worldEl.closest(".bd-root") : null;
    if (!(t instanceof HTMLElement)) return !1;
    e.capturing = !0, e.error = null, e.flash++;
    try {
      const i = this.board.cam.value, s = await H4e(t, this.board.engine, {
        camera: { x: Math.round(i.x), y: Math.round(i.y), zoom: Math.round(i.zoom * 1e3) / 1e3 },
        selection: this.board.ui.selection.slice(),
        panels: fA(this.board)
      });
      return this.disposed ? (URL.revokeObjectURL(s.url), !1) : (e.shots.push(mp(s)), e.active = e.shots.length - 1, this.recorder.record("shot", "Took screenshot " + e.shots.length, s.w + " × " + s.h), !0);
    } catch (i) {
      return console.warn("[board] the feedback screenshot failed", i), e.error = "The screenshot couldn't be taken. You can still send your report.", !1;
    } finally {
      e.capturing = !1;
    }
  }
  /**
   * Pictures from their computer (chosen, pasted or dropped in), as many as
   * the report has room for. Anything else is left out, and why is said.
   * Resolves to how many were added.
   */
  async addFiles(e, t) {
    const i = this.state;
    if (this.disposed || i.capturing || i.sending || !e.length) return 0;
    const s = e.filter(EA);
    if (!s.length)
      return i.error = "Only pictures can be added as screenshots.", 0;
    const o = Sl - i.shots.length;
    if (o <= 0)
      return i.error = Fb, 0;
    i.capturing = !0, i.error = null;
    let r = 0, a = 0;
    try {
      for (const l of s.slice(0, o))
        try {
          const d = await q4e(l, t);
          if (this.disposed)
            return URL.revokeObjectURL(d.url), r;
          i.shots.push(mp(d)), i.active = i.shots.length - 1, r++, this.recorder.record("shot", "Added screenshot " + i.shots.length + " (" + t3e[t] + ")", d.w + " × " + d.h);
        } catch (d) {
          console.warn("[board] a picture couldn't be added to the feedback report", d), a++;
        }
    } finally {
      i.capturing = !1;
    }
    return a ? i.error = (a === 1 ? "A picture" : a + " pictures") + " couldn't be read. Try a PNG or JPEG under 40 MB." : s.length > o ? i.error = Fb + " " + (s.length - o) + " " + (s.length - o === 1 ? "picture wasn't" : "pictures weren't") + " added." : s.length < e.length && (i.error = "Only pictures can be added as screenshots."), r;
  }
  async send() {
    const e = this.state;
    if (this.canSend) {
      e.sending = !0, e.error = null;
      try {
        const t = await Z4e(
          { kind: e.kind, happened: e.happened, expected: e.expected, source: e.source, include: { ...e.include }, shots: e.shots.slice() },
          { board: this.board, recorder: this.recorder, build: this.build }
        ), i = await this.sink.submit(t);
        if (this.disposed) return;
        if (!i.success) {
          e.error = i.message;
          return;
        }
        this.recorder.record("panel", "Sent report " + i.number), this.releaseShots();
        const s = e.flash;
        Object.assign(e, { mode: "closed", flash: s }, Nb()), this.board.toast("Thanks. Report " + i.number + " is with RunDiffusion.");
      } catch (t) {
        console.warn("[board] the feedback report couldn't be sent", t), e.error = t instanceof zA ? t.message : "Your report couldn't be sent. Check your connection and try again.";
      } finally {
        e.sending = !1;
      }
    }
  }
  releaseShots() {
    for (const e of this.state.shots) URL.revokeObjectURL(e.url);
    this.histories.clear();
  }
  dispose() {
    this.disposed = !0, this.releaseShots();
  }
}
const s3e = { class: "fb-head" }, o3e = { class: "fb-mark" }, r3e = { class: "fb-body" }, a3e = {
  class: "fb-shots",
  "aria-label": "Screenshots"
}, l3e = {
  class: "fb-preview",
  "data-testid": "feedback-preview"
}, d3e = {
  key: 1,
  class: "fb-preview-note"
}, c3e = {
  key: 2,
  class: "fb-preview-note"
}, u3e = {
  key: 3,
  class: "fb-drop",
  "data-testid": "feedback-drop"
}, h3e = { class: "fb-strip" }, p3e = ["aria-label", "aria-pressed", "onClick"], f3e = ["src"], m3e = { class: "fb-thumb-n" }, g3e = ["title", "aria-label", "onClick"], b3e = ["disabled", "title"], v3e = ["disabled", "title"], y3e = {
  key: 1,
  class: "fb-tip"
}, x3e = {
  class: "fb-form",
  "aria-label": "Your report"
}, w3e = {
  class: "fb-seg",
  role: "radiogroup",
  "aria-label": "What kind of feedback"
}, k3e = ["aria-checked", "data-testid", "onClick"], _3e = { class: "fb-field" }, S3e = { class: "fb-label" }, M3e = ["placeholder"], T3e = { class: "fb-field" }, C3e = { class: "fb-label" }, I3e = ["placeholder"], A3e = {
  class: "fb-inc-box",
  "data-testid": "feedback-includes"
}, P3e = { class: "fb-inc" }, E3e = { class: "fb-inc-what is-fixed" }, R3e = { class: "fb-inc" }, z3e = { class: "fb-inc-what" }, $3e = {
  key: 0,
  class: "fb-steps-pick",
  role: "radiogroup",
  "aria-label": "How many recent steps to send",
  "data-testid": "feedback-step-count"
}, D3e = ["aria-checked", "disabled", "data-testid", "onClick"], O3e = ["aria-expanded"], L3e = {
  key: 0,
  class: "fb-peek",
  "data-testid": "feedback-peek"
}, B3e = { class: "fb-inc" }, F3e = { class: "fb-inc-what" }, N3e = ["aria-expanded"], U3e = {
  key: 1,
  class: "fb-peek"
}, G3e = {
  key: 2,
  class: "fb-inc"
}, j3e = { class: "fb-inc-what" }, H3e = ["aria-expanded"], V3e = {
  key: 3,
  class: "fb-inc"
}, W3e = { class: "fb-inc-what is-fixed" }, q3e = {
  key: 4,
  class: "fb-peek"
}, K3e = { class: "fb-inc" }, Y3e = { class: "fb-inc-what" }, X3e = ["aria-expanded"], J3e = {
  key: 5,
  class: "fb-peek"
}, Z3e = { class: "fb-foot" }, Q3e = {
  key: 0,
  class: "fb-error",
  role: "alert",
  "data-testid": "feedback-error"
}, e5e = {
  class: "fb-keys",
  "aria-hidden": "true"
}, t5e = ["disabled", "title"], n5e = /* @__PURE__ */ Pe({
  __name: "FeedbackDialog",
  props: {
    feedback: {}
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = e.feedback, s = i.state, o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(!1), d = /* @__PURE__ */ W(!1), c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(0), f = [
      { id: "bug", label: "Bug", icon: "Bug", q1: "What happened?", p1: "I dragged two images into the frame and one jumped back.", q2: "What did you expect?", p2: "Both stay where I dropped them." },
      { id: "confusing", label: "Confusing", icon: "CircleHelp", q1: "What were you trying to do?", p1: "Start a new image session from a note.", q2: "What got in the way?", p2: "I couldn't find where sessions start." },
      { id: "idea", label: "Idea", icon: "Lightbulb", q1: "What would you like?", p1: "Let me keep the prompt open while I pan.", q2: "What would it help you do?", p2: "Compare results without losing my settings." }
    ], p = I(() => f.find((Z) => Z.id === s.kind) || f[0]), y = I(() => s.shots[s.active] || null), v = I(() => (h.value, i.recorder.list())), x = I(() => v.value.filter((Z) => Z.kind === "error" || Z.kind === "warn")), w = [{ n: 15, label: "15" }, { n: 50, label: "50" }, { n: null, label: "All" }], S = I(() => w.filter((Z) => Z.n == null || Z.n < v.value.length)), M = I(() => BA(v.value, s.include.stepCount)), _ = I(() => (t.docRev.value, t.store.size)), T = I(() => OA(t.engine ? t.engine.gpu() : null)), k = I(() => s.shots.filter((Z) => ru(Z.marks)).length), P = I(() => {
      if (!s.shots.length) return "No screenshots";
      const Z = s.shots.length + (s.shots.length === 1 ? " screenshot" : " screenshots");
      return k.value ? Z + ", " + k.value + " marked up" : Z;
    }), A = wn(["mod", "enter"]), R = wn(["mod", "V"]), D = I(() => s.shots.length >= Sl);
    function O(Z) {
      return new Date(Z).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" });
    }
    function F(Z) {
      return Z.slice().reverse().map((te) => O(te.at) + "  " + te.label + (te.detail ? "  (" + te.detail + ")" : "")).join(`
`) || "Nothing yet.";
    }
    const ie = I(() => (h.value, c.value === "steps" ? F(M.value) : c.value === "errors" ? F(x.value) : c.value === "state" ? JSON.stringify(LA(t), null, 2) : c.value === "device" ? JSON.stringify(T.value, null, 2) : ""));
    function ee(Z) {
      h.value++, c.value = c.value === Z ? null : Z;
    }
    function me(Z) {
      if (Z.stopPropagation(), Z.key === "Escape") {
        Z.preventDefault(), d.value ? d.value = !1 : i.close();
        return;
      }
      if (Z.key === "Enter" && bn(Z)) {
        Z.preventDefault(), i.send();
        return;
      }
      N(Z);
    }
    function L(Z) {
      return Z instanceof HTMLElement && (Z.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(Z.tagName));
    }
    function N(Z) {
      if (!y.value || L(Z.target) || Z.altKey) return;
      const te = Z.key.toLowerCase();
      if (bn(Z)) {
        (te === "z" || te === "y") && (Z.preventDefault(), te === "y" || Z.shiftKey ? i.redoMarks(s.active) : i.undoMarks(s.active));
        return;
      }
      if (Z.metaKey || Z.ctrlKey || Z.shiftKey) return;
      const we = s_e(te);
      we && (s.pen.tool = we);
    }
    function K() {
      a.value && a.value.click();
    }
    function B() {
      const Z = a.value;
      if (!Z) return;
      const te = Array.from(Z.files || []);
      Z.value = "", te.length && i.addFiles(te, "upload");
    }
    function re(Z) {
      const te = Z.clipboardData ? Array.from(Z.clipboardData.files || []) : [];
      te.some(EA) && (Z.preventDefault(), Z.stopImmediatePropagation(), i.addFiles(te, "paste"));
    }
    function H(Z) {
      return !!Z.dataTransfer && Array.from(Z.dataTransfer.types || []).indexOf("Files") >= 0;
    }
    function J(Z) {
      H(Z) && (Z.preventDefault(), Z.dataTransfer && (Z.dataTransfer.dropEffect = "copy"), l.value = !0);
    }
    function Q(Z) {
      const te = Z.relatedTarget;
      (!(te instanceof Node) || !(Z.currentTarget instanceof Node) || !Z.currentTarget.contains(te)) && (l.value = !1);
    }
    function ne(Z) {
      l.value = !1, !(!H(Z) || !Z.dataTransfer) && (Z.preventDefault(), i.addFiles(Array.from(Z.dataTransfer.files || []), "drop"));
    }
    let ue = null;
    return it(() => {
      ue = document.activeElement, window.addEventListener("keydown", me, !0), window.addEventListener("paste", re, !0), nt(() => {
        r.value && !s.happened ? r.value.focus({ preventScroll: !0 }) : o.value && o.value.focus({ preventScroll: !0 });
      });
    }), We(() => {
      window.removeEventListener("keydown", me, !0), window.removeEventListener("paste", re, !0), ue && document.contains(ue) && ue.focus({ preventScroll: !0 });
    }), (Z, te) => (g(), b("div", {
      class: "fb",
      "data-testid": "feedback",
      "data-feedback-skip": "",
      "data-lb-own-keys": "",
      onPointerdown: te[17] || (te[17] = Te((we) => m(i).close(), ["self"])),
      onWheel: te[18] || (te[18] = Te(() => {
      }, ["stop"])),
      onDragover: J,
      onDragleave: Q,
      onDrop: ne
    }, [
      u("div", {
        ref_key: "card",
        ref: o,
        class: G(["fb-card", { "is-dropping": l.value }]),
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "fb-title",
        tabindex: "-1",
        onPointerdown: te[16] || (te[16] = Te(() => {
        }, ["stop"]))
      }, [
        u("header", s3e, [
          u("span", o3e, [
            C($, {
              name: "MessageSquareWarning",
              size: 17
            })
          ]),
          te[19] || (te[19] = u("div", { class: "fb-titles" }, [
            u("h2", { id: "fb-title" }, "Send feedback"),
            u("p", null, "Your screenshots and your recent steps on this board go with it. You can check everything before you send.")
          ], -1)),
          u("button", {
            class: "fb-close",
            title: "Close (your draft is kept)",
            "aria-label": "Close (your draft is kept)",
            "data-testid": "feedback-close",
            onClick: te[0] || (te[0] = (we) => m(i).close())
          }, [
            C($, {
              name: "X",
              size: 15
            })
          ])
        ]),
        u("div", r3e, [
          u("section", a3e, [
            y.value ? (g(), Ie(__e, {
              key: 0,
              feedback: m(i),
              index: m(s).active
            }, null, 8, ["feedback", "index"])) : z("", !0),
            u("div", l3e, [
              y.value ? (g(), Ie(h_e, {
                key: y.value.url,
                feedback: m(i),
                shot: y.value,
                index: m(s).active
              }, null, 8, ["feedback", "shot", "index"])) : m(s).capturing ? (g(), b("span", d3e, [
                C($, {
                  name: "Loader2",
                  size: 14,
                  spin: ""
                }),
                te[20] || (te[20] = Y("Adding the screenshot…", -1))
              ])) : (g(), b("span", c3e, "No screenshots. Add one, or send without.")),
              l.value ? (g(), b("div", u3e, [
                C($, {
                  name: "Upload",
                  size: 20
                }),
                u("span", null, E(D.value ? "Six screenshots is the most a report holds" : "Drop to add it as a screenshot"), 1)
              ])) : z("", !0)
            ]),
            u("div", h3e, [
              (g(!0), b(j, null, ge(m(s).shots, (we, Fe) => (g(), b("div", {
                key: we.url,
                class: G(["fb-thumb", { on: Fe === m(s).active }]),
                "data-testid": "feedback-thumb"
              }, [
                u("button", {
                  class: "fb-thumb-pick",
                  "aria-label": "Show screenshot " + (Fe + 1),
                  "aria-pressed": Fe === m(s).active,
                  onClick: (Me) => m(s).active = Fe
                }, [
                  u("img", {
                    src: we.url,
                    alt: ""
                  }, null, 8, f3e),
                  m(ru)(we.marks) ? (g(), Ie(xm, {
                    key: 0,
                    marks: we.marks,
                    w: we.w,
                    h: we.h,
                    small: ""
                  }, null, 8, ["marks", "w", "h"])) : z("", !0)
                ], 8, p3e),
                u("span", m3e, E(Fe + 1), 1),
                u("button", {
                  class: "fb-thumb-x",
                  title: "Remove screenshot " + (Fe + 1),
                  "aria-label": "Remove screenshot " + (Fe + 1),
                  "data-testid": "feedback-remove-shot",
                  onClick: (Me) => m(i).removeShot(Fe)
                }, [
                  C($, {
                    name: "X",
                    size: 11
                  })
                ], 8, g3e)
              ], 2))), 128)),
              u("button", {
                class: "fb-add",
                disabled: D.value || m(s).capturing,
                title: D.value ? "Six screenshots is the most a report holds" : "Set up another view on the board, then capture it",
                "data-testid": "feedback-add-shot",
                onClick: te[1] || (te[1] = (we) => m(i).stepAside())
              }, [
                C($, {
                  name: "Camera",
                  size: 15
                }),
                te[21] || (te[21] = Y("Capture board ", -1))
              ], 8, b3e),
              u("button", {
                class: "fb-add",
                disabled: D.value || m(s).capturing,
                title: D.value ? "Six screenshots is the most a report holds" : "Add a picture from your computer",
                "data-testid": "feedback-upload",
                onClick: K
              }, [
                C($, {
                  name: "Upload",
                  size: 15
                }),
                te[22] || (te[22] = Y("Upload image ", -1))
              ], 8, v3e),
              u("input", {
                ref_key: "fileEl",
                ref: a,
                type: "file",
                accept: "image/*",
                multiple: "",
                hidden: "",
                "data-testid": "feedback-upload-input",
                onChange: B
              }, null, 544)
            ]),
            D.value ? z("", !0) : (g(), b("p", y3e, "You can also paste a picture (" + E(m(R)) + ") or drop one here.", 1))
          ]),
          u("section", x3e, [
            u("div", w3e, [
              (g(), b(j, null, ge(f, (we) => u("button", {
                key: we.id,
                role: "radio",
                "aria-checked": m(s).kind === we.id,
                class: G({ "is-on": m(s).kind === we.id }),
                "data-testid": "feedback-kind-" + we.id,
                onClick: (Fe) => m(s).kind = we.id
              }, [
                C($, {
                  name: we.icon,
                  size: 13
                }, null, 8, ["name"]),
                Y(E(we.label), 1)
              ], 10, k3e)), 64))
            ]),
            u("label", _3e, [
              u("span", S3e, E(p.value.q1), 1),
              _t(u("textarea", {
                ref_key: "happenedEl",
                ref: r,
                "onUpdate:modelValue": te[2] || (te[2] = (we) => m(s).happened = we),
                class: "fb-text",
                placeholder: p.value.p1,
                maxlength: "4000",
                "data-testid": "feedback-happened"
              }, null, 8, M3e), [
                [Zt, m(s).happened]
              ])
            ]),
            u("label", T3e, [
              u("span", C3e, E(p.value.q2), 1),
              _t(u("textarea", {
                "onUpdate:modelValue": te[3] || (te[3] = (we) => m(s).expected = we),
                class: "fb-text is-short",
                placeholder: p.value.p2,
                maxlength: "4000",
                "data-testid": "feedback-expected"
              }, null, 8, I3e), [
                [Zt, m(s).expected]
              ])
            ]),
            u("div", A3e, [
              te[29] || (te[29] = u("div", { class: "fb-inc-h" }, "Sent with your report", -1)),
              u("div", P3e, [
                u("span", E3e, [
                  C($, {
                    name: "Check",
                    size: 13
                  }),
                  u("span", null, [
                    Y(E(P.value), 1),
                    te[23] || (te[23] = u("small", null, "Remove any in the strip", -1))
                  ])
                ])
              ]),
              u("div", R3e, [
                u("label", z3e, [
                  _t(u("input", {
                    "onUpdate:modelValue": te[4] || (te[4] = (we) => m(s).include.steps = we),
                    type: "checkbox",
                    "data-testid": "feedback-include-steps"
                  }, null, 512), [
                    [ol, m(s).include.steps]
                  ]),
                  u("span", null, [
                    Y("Your last " + E(M.value.length) + " " + E(M.value.length === 1 ? "step" : "steps") + " on this board", 1),
                    te[24] || (te[24] = u("small", null, "What you moved, ran and opened, with times", -1))
                  ])
                ]),
                S.value.length > 1 ? (g(), b("span", $3e, [
                  (g(!0), b(j, null, ge(S.value, (we) => (g(), b("button", {
                    key: we.label,
                    type: "button",
                    role: "radio",
                    "aria-checked": (m(s).include.stepCount || null) === we.n,
                    class: G({ on: (m(s).include.stepCount || null) === we.n }),
                    disabled: !m(s).include.steps,
                    "data-testid": "feedback-steps-" + we.label.toLowerCase(),
                    onClick: (Fe) => m(s).include.stepCount = we.n
                  }, E(we.label), 11, D3e))), 128))
                ])) : z("", !0),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "steps",
                  "data-testid": "feedback-view-steps",
                  onClick: te[5] || (te[5] = (we) => ee("steps"))
                }, E(c.value === "steps" ? "Hide" : "View"), 9, O3e)
              ]),
              c.value === "steps" ? (g(), b("pre", L3e, E(ie.value), 1)) : z("", !0),
              u("div", B3e, [
                u("label", F3e, [
                  _t(u("input", {
                    "onUpdate:modelValue": te[6] || (te[6] = (we) => m(s).include.state = we),
                    type: "checkbox",
                    "data-testid": "feedback-include-state"
                  }, null, 512), [
                    [ol, m(s).include.state]
                  ]),
                  u("span", null, [
                    te[25] || (te[25] = Y("The board as it is now", -1)),
                    u("small", null, E(_.value) + " " + E(_.value === 1 ? "element" : "elements") + ", the view and your selection", 1)
                  ])
                ]),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "state",
                  onClick: te[7] || (te[7] = (we) => ee("state"))
                }, E(c.value === "state" ? "Hide" : "View"), 9, N3e)
              ]),
              c.value === "state" ? (g(), b("pre", U3e, E(ie.value), 1)) : z("", !0),
              x.value.length ? (g(), b("div", G3e, [
                u("label", j3e, [
                  _t(u("input", {
                    "onUpdate:modelValue": te[8] || (te[8] = (we) => m(s).include.errors = we),
                    type: "checkbox",
                    "data-testid": "feedback-include-errors"
                  }, null, 512), [
                    [ol, m(s).include.errors]
                  ]),
                  u("span", null, [
                    Y(E(x.value.length) + " " + E(x.value.length === 1 ? "error or warning" : "errors and warnings"), 1),
                    te[26] || (te[26] = u("small", null, "What the board logged while you worked", -1))
                  ])
                ]),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "errors",
                  onClick: te[9] || (te[9] = (we) => ee("errors"))
                }, E(c.value === "errors" ? "Hide" : "View"), 9, H3e)
              ])) : (g(), b("div", V3e, [
                u("span", W3e, [
                  C($, {
                    name: "Check",
                    size: 13
                  }),
                  te[27] || (te[27] = u("span", null, "No errors seen", -1))
                ])
              ])),
              c.value === "errors" ? (g(), b("pre", q3e, E(ie.value), 1)) : z("", !0),
              u("div", K3e, [
                u("label", Y3e, [
                  _t(u("input", {
                    "onUpdate:modelValue": te[10] || (te[10] = (we) => m(s).include.device = we),
                    type: "checkbox",
                    "data-testid": "feedback-include-device"
                  }, null, 512), [
                    [ol, m(s).include.device]
                  ]),
                  u("span", null, [
                    te[28] || (te[28] = Y("Browser, device and app version", -1)),
                    u("small", null, E(T.value.browser) + " on " + E(T.value.os), 1)
                  ])
                ]),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "device",
                  onClick: te[11] || (te[11] = (we) => ee("device"))
                }, E(c.value === "device" ? "Hide" : "View"), 9, X3e)
              ]),
              c.value === "device" ? (g(), b("pre", J3e, E(ie.value), 1)) : z("", !0)
            ])
          ])
        ]),
        u("footer", Z3e, [
          d.value ? (g(), b(j, { key: 0 }, [
            te[30] || (te[30] = u("span", { class: "fb-confirm" }, "Discard this report and its screenshots?", -1)),
            u("button", {
              class: "bd-btn is-ghost",
              "data-testid": "feedback-discard-keep",
              onClick: te[12] || (te[12] = (we) => d.value = !1)
            }, "Keep it"),
            u("button", {
              class: "bd-btn",
              "data-testid": "feedback-discard-confirm",
              onClick: te[13] || (te[13] = (we) => m(i).discard())
            }, "Discard")
          ], 64)) : (g(), b(j, { key: 1 }, [
            te[31] || (te[31] = u("span", { class: "fb-note" }, "Only RunDiffusion staff can see reports.", -1)),
            m(s).error ? (g(), b("span", Q3e, E(m(s).error), 1)) : z("", !0),
            u("button", {
              class: "bd-btn is-ghost",
              "data-testid": "feedback-discard",
              onClick: te[14] || (te[14] = (we) => d.value = !0)
            }, "Discard"),
            u("span", e5e, E(m(A)), 1),
            u("button", {
              class: "bd-btn",
              disabled: !m(i).canSend,
              title: m(i).canSend ? "Send report (" + m(A) + ")" : "Write a line about it first",
              "data-testid": "feedback-send",
              onClick: te[15] || (te[15] = (we) => m(i).send())
            }, [
              C($, {
                name: m(s).sending ? "Loader2" : "Send",
                size: 14,
                spin: m(s).sending
              }, null, 8, ["name", "spin"]),
              Y(E(m(s).sending ? "Sending…" : "Send report"), 1)
            ], 8, t5e)
          ], 64))
        ])
      ], 34)
    ], 32));
  }
}), i5e = {
  class: "fb-aside",
  role: "status",
  "data-testid": "feedback-aside",
  "data-feedback-skip": "",
  "data-feedback-bar": ""
}, s5e = { class: "fb-aside-mark" }, o5e = { class: "fb-aside-text" }, r5e = {
  class: "fb-aside-count",
  "data-testid": "feedback-aside-count"
}, a5e = ["disabled"], l5e = /* @__PURE__ */ Pe({
  __name: "FeedbackShotBar",
  props: {
    feedback: {}
  },
  setup(n) {
    const e = n, t = e.feedback.state, i = I(() => t.shots.length >= Sl);
    return (s, o) => (g(), b("div", i5e, [
      u("span", s5e, [
        C($, {
          name: "Camera",
          size: 13
        })
      ]),
      u("span", o5e, E(i.value ? "Six screenshots is the most a report holds" : "Set up the next screenshot, then capture it"), 1),
      u("span", r5e, E(m(t).shots.length) + " of " + E(m(Sl)), 1),
      u("button", {
        class: "fb-aside-btn is-cta",
        disabled: i.value || m(t).capturing,
        title: "Capture (`)",
        "data-testid": "feedback-capture",
        onClick: o[0] || (o[0] = (r) => e.feedback.capture())
      }, [
        C($, {
          name: "Camera",
          size: 12
        }),
        o[2] || (o[2] = Y("Capture ", -1))
      ], 8, a5e),
      u("button", {
        class: "fb-aside-btn",
        title: "Back to your report (Esc)",
        "data-testid": "feedback-aside-done",
        onClick: o[1] || (o[1] = (r) => e.feedback.resume())
      }, "Done")
    ]));
  }
}), rr = /* @__PURE__ */ Pe({
  __name: "Avatar",
  props: {
    uid: {},
    name: {},
    size: { default: 26 }
  },
  setup(n) {
    const e = n, t = I(() => {
      const [s, o] = Bie(e.uid || e.name);
      return {
        width: e.size + "px",
        height: e.size + "px",
        fontSize: Math.round(e.size * 0.38) + "px",
        background: "linear-gradient(140deg, " + s + ", " + o + ")"
      };
    }), i = I(() => ga(e.name || "?").slice(0, 2));
    return (s, o) => (g(), b("span", {
      class: "cm-avatar",
      style: ce(t.value),
      "aria-hidden": "true"
    }, E(i.value), 5));
  }
}), d5e = ["href"], cu = /* @__PURE__ */ Pe({
  __name: "CommentText",
  props: {
    text: {},
    mentions: {},
    me: {},
    clamp: {}
  },
  setup(n) {
    const e = n, t = I(() => zie(e.text, e.mentions, e.me)), i = I(() => !e.clamp && Iie(e.text));
    return (s, o) => (g(), b("span", {
      class: G(["cm-text", { "is-big": i.value, "is-clamped": !!n.clamp }]),
      style: ce(n.clamp ? { "-webkit-line-clamp": String(n.clamp) } : void 0)
    }, [
      (g(!0), b(j, null, ge(t.value, (r, a) => (g(), b(j, { key: a }, [
        r.kind === "mention" ? (g(), b("span", {
          key: 0,
          class: G(["cm-mention", { "is-me": r.me }])
        }, E(r.text), 3)) : r.kind === "link" ? (g(), b("a", {
          key: 1,
          class: "cm-link",
          href: r.href,
          target: "_blank",
          rel: "noopener noreferrer",
          onPointerdown: o[0] || (o[0] = Te(() => {
          }, ["stop"])),
          onClick: o[1] || (o[1] = Te(() => {
          }, ["stop"]))
        }, E(r.text), 41, d5e)) : (g(), b(j, { key: 2 }, [
          Y(E(r.text), 1)
        ], 64))
      ], 64))), 128))
    ], 6));
  }
}), Ks = [
  { id: "amethyst", label: "Amethyst", hex: "#9968df" },
  { id: "vista", label: "Vista", hex: "#6b72f0" },
  { id: "sky", label: "Sky", hex: "#3db4e6" },
  { id: "mint", label: "Mint", hex: "#34c79a" },
  { id: "amber", label: "Amber", hex: "#f2a93b" },
  { id: "rose", label: "Rose", hex: "#ef5f7a" }
];
function c5e(n) {
  return typeof n == "string" && Ks.some((e) => e.id === n);
}
const u5e = ["aria-label", "data-thread", "onPointerdown", "onMouseenter"], h5e = { class: "cm-pin-face" }, p5e = {
  key: 0,
  class: "cm-pin-check"
}, f5e = {
  key: 0,
  class: "cm-pin-count"
}, m5e = {
  key: 1,
  class: "cm-pin-dot",
  "data-testid": "comment-pin-unread"
}, g5e = {
  key: 0,
  class: "cm-peek",
  "data-testid": "comment-peek"
}, b5e = { class: "cm-peek-head" }, v5e = {
  key: 0,
  class: "cm-peek-foot"
}, y5e = {
  class: "cm-pin is-draft",
  "data-testid": "comment-draft-pin"
}, x5e = { class: "cm-pin-face" }, w5e = /* @__PURE__ */ Pe({
  __name: "CommentPins",
  setup(n) {
    const { board: e } = Ze(), t = e.comments, i = e.user.uid, s = dr(), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ qe(null);
    let a = 0;
    const l = I(() => t.ui.showPins ? t.pins.value : t.pins.value.filter((M) => M.t.id === t.ui.openId)), d = (M) => (Ks.find((_) => _.id === M) || Ks[0]).hex, c = I(() => t.ui.flash ? t.ui.flash.id + ":" + t.ui.flash.n : "");
    function h(M) {
      return t.commentsOf(M.t.id)[0] || null;
    }
    function f(M) {
      clearTimeout(a), a = window.setTimeout(() => {
        r.value = M;
      }, 220);
    }
    function p() {
      clearTimeout(a), r.value = null;
    }
    We(() => clearTimeout(a));
    function y(M, _) {
      if (_.button !== 0) return;
      _.stopPropagation(), _.preventDefault(), p();
      const T = { x: _.clientX, y: _.clientY };
      let k = !1;
      const P = (R) => {
        if (!k && Math.hypot(R.clientX - T.x, R.clientY - T.y) < 4) return;
        k = !0;
        const D = e.screenToWorld(R.clientX, R.clientY);
        t.ui.dragging = { id: M.t.id, x: D.x, y: D.y };
      }, A = (R) => {
        window.removeEventListener("pointermove", P), window.removeEventListener("pointerup", A), window.removeEventListener("pointercancel", A);
        const D = t.ui.dragging;
        if (k && D) {
          t.moveTo(M.t.id, D.x, D.y), window.setTimeout(() => {
            t.ui.dragging && t.ui.dragging.id === M.t.id && (t.ui.dragging = null);
          }, 400);
          return;
        }
        t.ui.dragging = null, R.type !== "pointercancel" && (t.ui.openId === M.t.id ? t.close() : t.open(M.t.id));
      };
      window.addEventListener("pointermove", P), window.addEventListener("pointerup", A), window.addEventListener("pointercancel", A);
    }
    let v = null;
    function x(M) {
      return M instanceof Element && !!M.closest(".cm-pin, .cm-card, .cm-emoji, .cm-menu, .cm-peek");
    }
    function w(M) {
      if (!(M.button !== 0 || x(M.target))) {
        if (t.ui.armed) {
          if (v && v.classList.contains("is-hand")) return;
          M.preventDefault(), M.stopPropagation(), t.placeAt(M.clientX, M.clientY);
          return;
        }
        t.ui.openId && t.close(), t.ui.draft && !t.ui.draft.text.trim() && t.cancelDraft();
      }
    }
    it(() => {
      v = o.value ? o.value.closest(".cv-stage") : null, v && v.addEventListener("pointerdown", w, !0);
    }), We(() => {
      v && (v.removeEventListener("pointerdown", w, !0), v.classList.remove("is-commenting"));
    }), Ee(() => t.ui.armed, (M) => {
      v && v.classList.toggle("is-commenting", M);
    }, { flush: "post" });
    const S = I(() => t.ui.draft);
    return (M, _) => (g(), b("div", {
      ref_key: "root",
      ref: o,
      class: G(["cm-pins", { "is-armed": m(t).ui.armed }])
    }, [
      (g(!0), b(j, null, ge(l.value, (T) => (g(), b("div", {
        key: T.t.id,
        class: G(["cm-pin-at", { "is-open": m(t).ui.openId === T.t.id, "is-resolved": !!T.t.resolvedAt, "is-dragging": !!m(t).ui.dragging && m(t).ui.dragging.id === T.t.id }]),
        style: ce({ left: T.x + "px", top: T.y + "px", "--thread": d(T.t.color) })
      }, [
        (g(), b("button", {
          key: c.value.startsWith(T.t.id + ":") ? c.value : T.t.id,
          class: G(["cm-pin", { "is-unread": T.unread, "is-flash": c.value.startsWith(T.t.id + ":") }]),
          "aria-label": "Comment by " + T.t.createdByName + (T.unread ? ", unread" : ""),
          "data-thread": T.t.id,
          "data-testid": "comment-pin",
          onPointerdown: (k) => y(T, k),
          onMouseenter: (k) => f(T.t.id),
          onMouseleave: p
        }, [
          u("span", h5e, [
            T.t.resolvedAt ? (g(), b("span", p5e, [
              C($, {
                name: "Check",
                size: 15,
                stroke: 3
              })
            ])) : (g(), Ie(rr, {
              key: 1,
              uid: T.t.createdBy,
              name: T.t.createdByName,
              size: 26
            }, null, 8, ["uid", "name"]))
          ]),
          T.count > 1 ? (g(), b("span", f5e, E(T.count > 99 ? "99+" : T.count), 1)) : z("", !0),
          T.unread ? (g(), b("span", m5e)) : z("", !0)
        ], 42, u5e)),
        r.value === T.t.id && m(t).ui.openId !== T.t.id && h(T) ? (g(), b("div", g5e, [
          u("div", b5e, [
            u("b", null, E(h(T).authorName), 1),
            u("span", null, E(m(Jn)(T.t.lastAt, m(s))), 1)
          ]),
          C(cu, {
            text: h(T).text,
            mentions: h(T).mentions,
            me: m(i),
            clamp: 3
          }, null, 8, ["text", "mentions", "me"]),
          T.count > 1 ? (g(), b("div", v5e, [
            Y(E(T.count - 1 === 1 ? "1 reply" : T.count - 1 + " replies"), 1),
            m(t).freshIn(T.t) ? (g(), b(j, { key: 0 }, [
              _[0] || (_[0] = Y(" · ", -1)),
              u("em", null, E(m(t).freshIn(T.t)) + " new", 1)
            ], 64)) : z("", !0)
          ])) : z("", !0)
        ])) : z("", !0)
      ], 6))), 128)),
      S.value ? (g(), b("div", {
        key: 0,
        class: "cm-pin-at is-draft",
        style: ce({ left: S.value.anchor.x + "px", top: S.value.anchor.y + "px" })
      }, [
        u("span", y5e, [
          u("span", x5e, [
            C(rr, {
              uid: m(i),
              name: m(t).myName,
              size: 26
            }, null, 8, ["uid", "name"])
          ])
        ])
      ], 4)) : z("", !0)
    ], 2));
  }
}), k5e = { class: "cm-emoji-head" }, _5e = { class: "cm-emoji-search" }, S5e = ["aria-label", "onClick"], M5e = {
  key: 0,
  class: "cm-emoji-quick",
  "data-testid": "emoji-quick"
}, T5e = ["onClick"], C5e = {
  key: 1,
  class: "cm-emoji-tabs",
  "aria-label": "Categories"
}, I5e = ["title", "aria-label", "onClick"], A5e = {
  key: 0,
  class: "cm-emoji-grid"
}, P5e = ["aria-label", "onMouseenter", "onClick"], E5e = {
  key: 1,
  class: "cm-emoji-none"
}, R5e = {
  key: 0,
  class: "cm-emoji-sec",
  "data-group": "recent"
}, z5e = { class: "cm-emoji-grid" }, $5e = ["aria-label", "onMouseenter", "onClick"], D5e = ["data-group"], O5e = { class: "cm-emoji-label" }, L5e = { class: "cm-emoji-grid" }, B5e = ["aria-label", "onMouseenter", "onClick"], F5e = { class: "cm-emoji-foot" }, N5e = { class: "cm-emoji-big" }, U5e = { class: "cm-emoji-name" }, G5e = { class: "cm-emoji-code" }, j5e = {
  key: 1,
  class: "cm-emoji-hint"
}, Ub = 340, D4 = 392, O4 = 8, FA = /* @__PURE__ */ Pe({
  __name: "EmojiPicker",
  props: {
    at: {},
    mode: { default: "insert" }
  },
  emits: ["pick", "close"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(""), l = /* @__PURE__ */ W(S0()), d = /* @__PURE__ */ W(!1), c = /* @__PURE__ */ qe(_0()), h = /* @__PURE__ */ qe(null), f = /* @__PURE__ */ W(_0().length ? "recent" : "smileys"), p = kie(), y = I(() => a.value.trim() ? rI(a.value, 160) : null), v = I(() => c.value.map((O) => ({ c: O, e: Jy(O) })).filter((O) => !!O.e)), x = I(() => [
      ...v.value.length ? [{ key: "recent", label: "Recent", icon: "Clock" }] : [],
      ...p.map((O) => ({ key: O.key, label: O.label, icon: w[O.key] || "Smile" }))
    ]), w = {
      smileys: "Smile",
      people: "Hand",
      nature: "Leaf",
      food: "Coffee",
      travel: "Plane",
      activities: "Trophy",
      objects: "Lightbulb",
      symbols: "Heart",
      flags: "Flag"
    }, S = I(() => {
      const O = t.at, F = window.innerWidth, ie = window.innerHeight;
      let ee = O.y + O.h + O4;
      ee + D4 > ie - 8 && (ee = Math.max(8, O.y - O4 - D4));
      let me = O.x + O.w - Ub;
      return me < 8 && (me = Math.min(O.x, F - Ub - 8)), { left: Math.max(8, Math.min(me, F - Ub - 8)) + "px", top: ee + "px" };
    });
    function M(O) {
      const F = typeof O == "string" ? O : ll(O, l.value);
      i("pick", F);
    }
    function _(O) {
      l.value = O, Mie(O), d.value = !1;
    }
    function T() {
      Sie(), c.value = [], f.value === "recent" && (f.value = p[0].key);
    }
    function k(O) {
      a.value = "", nt(() => {
        const F = o.value && o.value.querySelector('[data-group="' + O + '"]');
        F && o.value && o.value.scrollTo({ top: F.offsetTop - 4, behavior: "smooth" }), f.value = O;
      });
    }
    function P() {
      const O = o.value;
      if (!O || y.value) return;
      const F = O.querySelectorAll("[data-group]");
      let ie = f.value;
      for (const ee of Array.from(F)) ee.offsetTop - 24 <= O.scrollTop && (ie = ee.dataset.group || ie);
      f.value = ie;
    }
    function A(O) {
      if (O.key === "Escape")
        O.preventDefault(), O.stopPropagation(), i("close");
      else if (O.key === "Enter") {
        O.preventDefault(), O.stopPropagation();
        const F = y.value;
        F && F[0] && M(F[0]);
      }
    }
    function R(O) {
      const F = O.target;
      s.value && F && s.value.contains(F) || i("close");
    }
    it(() => {
      window.setTimeout(() => window.addEventListener("pointerdown", R, !0), 0), nt(() => {
        r.value && r.value.focus({ preventScroll: !0 });
      });
    }), We(() => window.removeEventListener("pointerdown", R, !0));
    function D(O) {
      return O.s.length ? ":" + O.s[0] + ":" : "";
    }
    return (O, F) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: G(["cm-emoji", "is-" + n.mode]),
      style: ce(S.value),
      role: "dialog",
      "aria-label": "Emoji",
      "data-testid": "emoji-picker",
      onPointerdown: F[4] || (F[4] = Te(() => {
      }, ["stop"])),
      onWheel: F[5] || (F[5] = Te(() => {
      }, ["stop"])),
      onKeydown: A
    }, [
      u("div", k5e, [
        u("label", _5e, [
          C($, {
            name: "Search",
            size: 13
          }),
          _t(u("input", {
            ref_key: "search",
            ref: r,
            "onUpdate:modelValue": F[0] || (F[0] = (ie) => a.value = ie),
            type: "text",
            placeholder: "Search emoji",
            spellcheck: "false",
            "data-testid": "emoji-search"
          }, null, 512), [
            [Zt, a.value]
          ]),
          a.value ? (g(), b("button", {
            key: 0,
            class: "cm-emoji-clear",
            title: "Clear",
            onClick: F[1] || (F[1] = (ie) => a.value = "")
          }, [
            C($, {
              name: "X",
              size: 12
            })
          ])) : z("", !0)
        ]),
        u("div", {
          class: G(["cm-emoji-tone", { open: d.value }])
        }, [
          d.value ? (g(!0), b(j, { key: 1 }, ge(m(x_), (ie, ee) => (g(), b("button", {
            key: ie,
            class: G(["cm-emoji-tonebtn", { on: ee === l.value }]),
            "aria-label": ee ? "Skin tone " + ee : "Default skin tone",
            onClick: (me) => _(ee)
          }, E(ie), 11, S5e))), 128)) : (g(), b("button", {
            key: 0,
            class: "cm-emoji-tonebtn",
            title: "Skin tone",
            "data-testid": "emoji-tone",
            onClick: F[2] || (F[2] = (ie) => d.value = !0)
          }, E(m(x_)[l.value]), 1))
        ], 2)
      ]),
      n.mode === "react" && !a.value ? (g(), b("div", M5e, [
        (g(!0), b(j, null, ge(m(yie), (ie) => (g(), b("button", {
          key: ie,
          class: "cm-emo is-quick",
          onClick: (ee) => M(ie)
        }, E(ie), 9, T5e))), 128))
      ])) : z("", !0),
      a.value ? z("", !0) : (g(), b("nav", C5e, [
        (g(!0), b(j, null, ge(x.value, (ie) => (g(), b("button", {
          key: ie.key,
          class: G({ on: f.value === ie.key }),
          title: ie.label,
          "aria-label": ie.label,
          onClick: (ee) => k(ie.key)
        }, [
          C($, {
            name: ie.icon,
            size: 15
          }, null, 8, ["name"])
        ], 10, I5e))), 128))
      ])),
      u("div", {
        ref_key: "body",
        ref: o,
        class: "cm-emoji-body",
        onScrollPassive: P,
        onMouseleave: F[3] || (F[3] = (ie) => h.value = null)
      }, [
        y.value ? (g(), b(j, { key: 0 }, [
          y.value.length ? (g(), b("div", A5e, [
            (g(!0), b(j, null, ge(y.value, (ie) => (g(), b("button", {
              key: ie.c,
              class: "cm-emo",
              "aria-label": ie.n,
              onMouseenter: (ee) => h.value = ie,
              onClick: (ee) => M(ie)
            }, E(m(ll)(ie, l.value)), 41, P5e))), 128))
          ])) : (g(), b("div", E5e, "No emoji for “" + E(a.value) + "”", 1))
        ], 64)) : (g(), b(j, { key: 1 }, [
          v.value.length ? (g(), b("section", R5e, [
            u("div", { class: "cm-emoji-label" }, [
              F[6] || (F[6] = Y("Recent", -1)),
              u("button", {
                class: "cm-emoji-clearrecent",
                onClick: T
              }, "Clear")
            ]),
            u("div", z5e, [
              (g(!0), b(j, null, ge(v.value, (ie) => (g(), b("button", {
                key: "r" + ie.c,
                class: "cm-emo",
                "aria-label": ie.e.n,
                onMouseenter: (ee) => h.value = ie.e,
                onClick: (ee) => M(ie.c)
              }, E(ie.c), 41, $5e))), 128))
            ])
          ])) : z("", !0),
          (g(!0), b(j, null, ge(m(p), (ie) => (g(), b("section", {
            key: ie.key,
            class: "cm-emoji-sec",
            "data-group": ie.key
          }, [
            u("div", O5e, E(ie.label), 1),
            u("div", L5e, [
              (g(!0), b(j, null, ge(ie.emoji, (ee) => (g(), b("button", {
                key: ee.c,
                class: "cm-emo",
                "aria-label": ee.n,
                onMouseenter: (me) => h.value = ee,
                onClick: (me) => M(ee)
              }, E(m(ll)(ee, l.value)), 41, B5e))), 128))
            ])
          ], 8, D5e))), 128))
        ], 64))
      ], 544),
      u("div", F5e, [
        h.value ? (g(), b(j, { key: 0 }, [
          u("span", N5e, E(m(ll)(h.value, l.value)), 1),
          u("span", U5e, E(h.value.n), 1),
          u("span", G5e, E(D(h.value)), 1)
        ], 64)) : (g(), b("span", j5e, E(n.mode === "react" ? "React with any emoji" : "Type : and a name in a comment for emoji too"), 1))
      ])
    ], 38));
  }
}), H5e = ["placeholder", "data-testid"], V5e = { class: "cm-compose-tools" }, W5e = ["data-testid"], q5e = ["disabled", "data-testid"], K5e = ["data-testid"], Y5e = ["disabled", "data-testid"], X5e = ["aria-selected", "onMouseenter", "onClick"], J5e = { class: "cm-menu-text" }, Z5e = { key: 0 }, Q5e = { class: "cm-menu-group" }, e6e = { class: "cm-menu-text" }, t6e = { class: "cm-menu-emoji" }, n6e = { class: "cm-menu-text" }, i6e = { key: 0 }, s6e = {
  key: 1,
  class: "cm-menu-alone"
}, q0 = /* @__PURE__ */ Pe({
  __name: "Composer",
  props: {
    people: {},
    me: {},
    placeholder: { default: "Add a comment" },
    text: { default: "" },
    mentions: { default: () => [] },
    autofocus: { type: Boolean, default: !1 },
    group: { default: null },
    editing: { type: Boolean, default: !1 },
    alone: { default: null },
    testid: { default: "composer" }
  },
  emits: ["submit", "cancel", "edit-last", "change"],
  setup(n, { expose: e, emit: t }) {
    const i = n, s = t, o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(i.text), d = /* @__PURE__ */ qe(i.mentions.slice()), c = /* @__PURE__ */ W(0), h = /* @__PURE__ */ W(0), f = /* @__PURE__ */ qe(null), p = /* @__PURE__ */ W(!1), y = /* @__PURE__ */ W(!1);
    let v = 0;
    function x() {
      y.value = !1, clearTimeout(v), requestAnimationFrame(() => {
        y.value = !0, v = window.setTimeout(() => {
          y.value = !1;
        }, 450);
      });
    }
    const w = I(() => l.value.trim().length > 0), S = I(() => {
      const B = $ie(l.value, c.value);
      if (!B) return null;
      const re = l.value;
      return d.value.some((H) => re.startsWith("@" + H.name, B.start) && c.value > B.start + H.name.length) ? null : B;
    }), M = I(() => S.value ? null : Die(l.value, c.value)), _ = /* @__PURE__ */ W(-1), T = I(() => {
      const B = S.value;
      if (B && B.start !== _.value) {
        const H = i.alone ? i.people.filter((Z) => Z.uid !== i.me) : i.people, J = Lie(H, B.query, i.me).slice(0, 7).map((Z) => ({ kind: "person", p: Z })), Q = i.people.filter((Z) => Z.uid !== i.me), ne = i.group;
        return ne && Q.length > 1 && Q.length < dI && (!B.query || ne.toLowerCase().startsWith(B.query.toLowerCase()) || "everyone".startsWith(B.query.toLowerCase())) ? [{ kind: "group", label: ne, count: Q.length }, ...J] : J;
      }
      const re = M.value;
      return re && re.start !== _.value ? rI(re.query, 6).map((H) => ({ kind: "emoji", e: H })) : [];
    }), k = I(() => T.value.length > 0 || !!S.value && S.value.start !== _.value && !!i.alone);
    Ee(T, () => {
      h.value = 0;
    }), Ee(k, (B) => {
      if (!B || !r.value) return;
      const re = r.value.getBoundingClientRect();
      p.value = window.innerHeight - re.bottom < 300 && re.top > window.innerHeight - re.bottom;
    });
    function P(B) {
      if (B.kind === "emoji") {
        const H = M.value;
        if (!H) return;
        const J = ll(B.e, S0());
        Pf(J), A(H.start, c.value, J + " ");
        return;
      }
      const re = S.value;
      if (re) {
        if (B.kind === "group") {
          const H = i.people.filter((J) => J.uid !== i.me);
          d.value = [...d.value, ...H.map((J) => ({ uid: J.uid, name: B.label }))], A(re.start, c.value, "@" + B.label + " ");
          return;
        }
        d.value = [...d.value.filter((H) => H.uid !== B.p.uid), { uid: B.p.uid, name: B.p.name }], A(re.start, c.value, "@" + B.p.name + " ");
      }
    }
    function A(B, re, H) {
      const J = l.value;
      l.value = J.slice(0, B) + H + J.slice(re);
      const Q = B + H.length;
      nt(() => {
        const ne = o.value;
        ne && (ne.focus({ preventScroll: !0 }), ne.setSelectionRange(Q, Q), c.value = Q, O());
      });
    }
    function R(B) {
      const re = o.value, H = re ? re.selectionStart : l.value.length, J = re ? re.selectionEnd : H;
      A(H, J, B);
    }
    function D() {
      const B = o.value, re = B ? B.selectionStart : l.value.length, H = l.value.slice(0, re);
      R(H && !/\s$/.test(H) ? " @" : "@");
    }
    function O() {
      const B = o.value;
      B && (B.style.height = "auto", B.style.height = Math.min(B.scrollHeight, 168) + "px");
    }
    function F() {
      const B = o.value;
      B && (c.value = B.selectionStart), O(), s("change", { text: l.value, mentions: d.value });
    }
    function ie() {
      if (!w.value) {
        x();
        return;
      }
      s("submit", { text: l.value, mentions: d.value });
    }
    function ee() {
      l.value = "", d.value = [], nt(O);
    }
    function me(B) {
      if (k.value && T.value.length) {
        if (B.key === "ArrowDown" || B.key === "ArrowUp") {
          B.preventDefault();
          const re = T.value.length;
          h.value = (h.value + (B.key === "ArrowDown" ? 1 : -1) + re) % re;
          return;
        }
        if (B.key === "Enter" || B.key === "Tab") {
          B.preventDefault(), B.stopPropagation(), P(T.value[h.value]);
          return;
        }
      }
      if (B.key === "Escape") {
        if (B.preventDefault(), B.stopPropagation(), k.value) {
          const re = S.value || M.value;
          _.value = re ? re.start : -1;
          return;
        }
        s("cancel");
        return;
      }
      if (B.key === "Enter" && (!B.shiftKey || bn(B))) {
        B.preventDefault(), B.stopPropagation(), ie();
        return;
      }
      B.key === "ArrowUp" && !l.value && !i.editing && (B.preventDefault(), s("edit-last"));
    }
    function L() {
      const B = a.value;
      if (!B) return;
      const re = B.getBoundingClientRect();
      f.value = f.value ? null : { x: re.left, y: re.top, w: re.width, h: re.height };
    }
    function N(B) {
      Pf(B), f.value = null, R(B);
    }
    function K() {
      const B = o.value;
      if (!B) return;
      B.focus({ preventScroll: !0 });
      const re = l.value.length;
      B.setSelectionRange(re, re), c.value = re;
    }
    return Ee(() => i.text, (B) => {
      B !== l.value && (l.value = B, nt(O));
    }), it(() => {
      O(), i.autofocus && nt(K);
    }), We(() => clearTimeout(v)), e({ reset: ee, focus: K, nod: x }), (B, re) => (g(), b("div", {
      ref_key: "wrap",
      ref: r,
      class: G(["cm-compose", { "is-editing": n.editing, "can-send": w.value, "is-nod": y.value }]),
      onPointerdown: re[4] || (re[4] = Te(() => {
      }, ["stop"]))
    }, [
      _t(u("textarea", {
        ref_key: "box",
        ref: o,
        "onUpdate:modelValue": re[0] || (re[0] = (H) => l.value = H),
        class: "cm-compose-box",
        rows: "1",
        placeholder: n.placeholder,
        maxlength: "5000",
        spellcheck: "true",
        "data-testid": n.testid + "-input",
        onInput: F,
        onClick: F,
        onKeyup: F,
        onKeydown: me
      }, null, 40, H5e), [
        [Zt, l.value]
      ]),
      u("div", V5e, [
        n.editing ? (g(), b(j, { key: 0 }, [
          u("button", {
            class: "cm-btn is-ghost is-sm",
            "data-testid": n.testid + "-cancel",
            onClick: re[1] || (re[1] = (H) => s("cancel"))
          }, "Cancel", 8, W5e),
          u("button", {
            class: "cm-btn is-sm",
            disabled: !w.value,
            "data-testid": n.testid + "-save",
            onClick: ie
          }, "Save", 8, q5e)
        ], 64)) : (g(), b(j, { key: 1 }, [
          u("button", {
            class: "cm-tool",
            title: "Mention someone (@)",
            "aria-label": "Mention someone",
            onClick: D
          }, [
            C($, {
              name: "AtSign",
              size: 14
            })
          ]),
          u("button", {
            ref_key: "emojiBtn",
            ref: a,
            class: G(["cm-tool", { on: !!f.value }]),
            title: "Emoji",
            "aria-label": "Emoji",
            "data-testid": n.testid + "-emoji",
            onClick: L
          }, [
            C($, {
              name: "Smile",
              size: 14
            })
          ], 10, K5e),
          u("button", {
            class: "cm-send",
            disabled: !w.value,
            title: "Send (Enter)",
            "aria-label": "Send",
            "data-testid": n.testid + "-send",
            onClick: ie
          }, [
            C($, {
              name: "ArrowUp",
              size: 14,
              stroke: 2.4
            })
          ], 8, Y5e)
        ], 64))
      ]),
      k.value ? (g(), b("div", {
        key: 0,
        class: G(["cm-menu", { "is-up": p.value }]),
        role: "listbox",
        "data-testid": "mention-menu",
        onPointerdown: re[2] || (re[2] = Te(() => {
        }, ["stop", "prevent"]))
      }, [
        T.value.length ? (g(!0), b(j, { key: 0 }, ge(T.value, (H, J) => (g(), b("button", {
          key: H.kind === "person" ? H.p.uid : H.kind === "emoji" ? H.e.c : "group",
          class: G(["cm-menu-row", { on: J === h.value, "is-emoji": H.kind === "emoji" }]),
          role: "option",
          "aria-selected": J === h.value,
          onMouseenter: (Q) => h.value = J,
          onClick: (Q) => P(H)
        }, [
          H.kind === "person" ? (g(), b(j, { key: 0 }, [
            C(rr, {
              uid: H.p.uid,
              name: H.p.name,
              size: 24
            }, null, 8, ["uid", "name"]),
            u("span", J5e, [
              u("b", null, [
                Y(E(H.p.name), 1),
                H.p.uid === n.me ? (g(), b("i", Z5e, " (you)")) : z("", !0)
              ]),
              u("small", null, E(H.p.email), 1)
            ])
          ], 64)) : H.kind === "group" ? (g(), b(j, { key: 1 }, [
            u("span", Q5e, [
              C($, {
                name: "Users",
                size: 13
              })
            ]),
            u("span", e6e, [
              u("b", null, E(H.label), 1),
              u("small", null, "Everyone who can see this board (" + E(H.count) + ")", 1)
            ])
          ], 64)) : (g(), b(j, { key: 2 }, [
            u("span", t6e, E(m(ll)(H.e, m(S0)())), 1),
            u("span", n6e, [
              u("b", null, E(H.e.n), 1),
              H.e.s.length ? (g(), b("small", i6e, ":" + E(H.e.s[0]) + ":", 1)) : z("", !0)
            ])
          ], 64))
        ], 42, X5e))), 128)) : (g(), b("div", s6e, E(n.alone), 1))
      ], 34)) : z("", !0),
      (g(), Ie(y1, {
        defer: "",
        to: ".cm-portal"
      }, [
        f.value ? (g(), Ie(FA, {
          key: 0,
          at: f.value,
          mode: "insert",
          onPick: N,
          onClose: re[3] || (re[3] = (H) => f.value = null)
        }, null, 8, ["at"])) : z("", !0)
      ]))
    ], 34));
  }
}), o6e = ["data-comment"], r6e = { class: "cm-row-main" }, a6e = { class: "cm-row-head" }, l6e = { class: "cm-row-name" }, d6e = ["title"], c6e = ["title"], u6e = {
  key: 2,
  class: "cm-reactions"
}, h6e = ["title", "onClick"], p6e = { class: "e" }, f6e = { class: "n" }, m6e = {
  key: 0,
  class: "cm-row-acts"
}, g6e = ["title", "aria-label"], b6e = /* @__PURE__ */ Pe({
  __name: "CommentRow",
  props: {
    c: {},
    first: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = t.comments, s = t.user.uid, o = dr(), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ qe(null), l = I(() => Oie(e.c, s)), d = I(() => e.c.authorId === s), c = I(() => i.ui.editingId === e.c.id), h = I(() => {
      if (!e.first) return i.canDeleteComment(e.c);
      const S = i.thread(e.c.threadId);
      return !!S && i.canDelete(S);
    }), f = I(() => Jn(e.c.createdAt, o.value)), p = I(() => {
      const S = /* @__PURE__ */ new Map();
      for (const M of i.mentionable()) S.set(M.uid, M.name);
      return S;
    });
    function y(S) {
      const M = S.map((_) => _ === s ? "You" : p.value.get(_) || "Someone");
      return M.length <= 3 ? M.join(", ") : M.slice(0, 3).join(", ") + " and " + (M.length - 3) + " more";
    }
    function v(S) {
      const M = S || r.value;
      if (!M) return;
      const _ = M.getBoundingClientRect();
      a.value = { x: _.left, y: _.top, w: _.width, h: _.height };
    }
    function x(S) {
      a.value = null, i.react(e.c.id, S);
    }
    function w() {
      e.first ? i.askDeleteThread(e.c.threadId) : i.deleteComment(e.c.id);
    }
    return (S, M) => (g(), b("div", {
      class: G(["cm-row", { "is-editing": c.value, "is-mine": d.value }]),
      "data-comment": n.c.id,
      "data-testid": "comment"
    }, [
      C(rr, {
        uid: n.c.authorId,
        name: n.c.authorName,
        size: 28
      }, null, 8, ["uid", "name"]),
      u("div", r6e, [
        u("div", a6e, [
          u("b", l6e, E(d.value ? n.c.authorName || "You" : n.c.authorName), 1),
          u("span", {
            class: "cm-row-time",
            title: m(ef)(n.c.createdAt)
          }, E(f.value), 9, d6e),
          n.c.editedAt ? (g(), b("span", {
            key: 0,
            class: "cm-row-edited",
            title: "Edited " + m(ef)(n.c.editedAt)
          }, "edited", 8, c6e)) : z("", !0)
        ]),
        c.value ? (g(), Ie(q0, {
          key: 0,
          people: m(i).mentionable(),
          me: m(s),
          text: n.c.text,
          mentions: n.c.mentions,
          editing: "",
          autofocus: "",
          testid: "edit",
          onSubmit: M[0] || (M[0] = (_) => m(i).edit(n.c.id, _.text, _.mentions)),
          onCancel: M[1] || (M[1] = (_) => m(i).ui.editingId = null)
        }, null, 8, ["people", "me", "text", "mentions"])) : (g(), Ie(cu, {
          key: 1,
          class: "cm-row-text",
          text: n.c.text,
          mentions: n.c.mentions,
          me: m(s)
        }, null, 8, ["text", "mentions", "me"])),
        l.value.length && !c.value ? (g(), b("div", u6e, [
          (g(!0), b(j, null, ge(l.value, (_) => (g(), b("button", {
            key: _.key,
            class: G(["cm-chip", { mine: _.mine }]),
            title: y(_.who) + " reacted with " + _.emoji,
            "data-testid": "reaction",
            onClick: (T) => x(_.emoji)
          }, [
            u("span", p6e, E(_.emoji), 1),
            u("span", f6e, E(_.count), 1)
          ], 10, h6e))), 128)),
          u("button", {
            class: "cm-chip is-add",
            title: "Add a reaction",
            "aria-label": "Add a reaction",
            onClick: M[2] || (M[2] = (_) => v(_.currentTarget))
          }, [
            C($, {
              name: "SmilePlus",
              size: 13
            })
          ])
        ])) : z("", !0)
      ]),
      c.value ? z("", !0) : (g(), b("div", m6e, [
        u("button", {
          ref_key: "reactBtn",
          ref: r,
          title: "React",
          "aria-label": "React",
          "data-testid": "comment-react",
          onClick: M[3] || (M[3] = (_) => v())
        }, [
          C($, {
            name: "SmilePlus",
            size: 14
          })
        ], 512),
        d.value ? (g(), b("button", {
          key: 0,
          title: "Edit",
          "aria-label": "Edit",
          "data-testid": "comment-edit",
          onClick: M[4] || (M[4] = (_) => m(i).ui.editingId = n.c.id)
        }, [
          C($, {
            name: "Pencil",
            size: 13
          })
        ])) : z("", !0),
        h.value ? (g(), b("button", {
          key: 1,
          title: n.first ? "Delete thread" : "Delete",
          "aria-label": n.first ? "Delete thread" : "Delete",
          "data-testid": "comment-delete",
          onClick: w
        }, [
          C($, {
            name: "Trash2",
            size: 13
          })
        ], 8, g6e)) : z("", !0)
      ])),
      (g(), Ie(y1, {
        defer: "",
        to: ".cm-portal"
      }, [
        a.value ? (g(), Ie(FA, {
          key: 0,
          at: a.value,
          mode: "react",
          onPick: x,
          onClose: M[5] || (M[5] = (_) => a.value = null)
        }, null, 8, ["at"])) : z("", !0)
      ]))
    ], 10, o6e));
  }
}), v6e = ["data-thread", "data-testid"], y6e = { class: "cm-draft-head" }, x6e = ["title"], w6e = { class: "cm-card-head" }, k6e = {
  class: "cm-dots",
  role: "radiogroup",
  "aria-label": "Thread colour"
}, _6e = ["aria-checked", "title", "aria-label", "onClick"], S6e = ["title", "aria-label", "aria-pressed"], M6e = ["title"], T6e = { class: "cm-card-menu-wrap" }, C6e = ["aria-expanded"], I6e = {
  key: 0,
  class: "cm-card-menu",
  role: "menu",
  "data-testid": "thread-menu-list"
}, A6e = { key: 0 }, P6e = ["title", "aria-label"], E6e = {
  key: 0,
  class: "cm-strip"
}, R6e = ["title"], z6e = {
  key: 1,
  class: "cm-resolved-note"
}, $6e = {
  key: 2,
  class: "cm-nav"
}, D6e = {
  class: "cm-nav-n",
  "data-testid": "thread-position"
}, O6e = { class: "cm-reply" }, L6e = /* @__PURE__ */ new Map(), L4 = /* @__PURE__ */ Pe({
  __name: "ThreadCard",
  props: {
    id: {},
    draft: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = t.comments, s = t.user.uid, o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(!1), d = /* @__PURE__ */ qe({ w: 340, h: 200 }), c = I(() => e.draft ? null : i.thread(e.id)), h = I(() => c.value ? i.commentsOf(c.value.id) : []), f = I(() => !e.draft && i.ui.openId === e.id), p = I(() => !!c.value && i.pinned(c.value)), y = I(() => !!c.value && i.following(c.value)), v = I(() => !!c.value && i.isUnread(c.value)), x = I(() => f.value ? i.position() : null), w = I(() => c.value && Ks.find((Z) => Z.id === c.value.color) || Ks[0]), S = I(() => i.mentionable()), M = I(() => i.people.value.scope), _ = I(() => M.value === "team" || M.value === "restricted" ? t.labels.team : null), T = I(() => M.value === "personal" ? "Only you can see this personal board, so there's no one to mention." : M.value === "private" ? "Only its owner can see this private board. Share it from Access Settings to mention others." : null), k = I(() => {
      const Z = c.value, te = e.draft && i.ui.draft ? i.ui.draft.anchor : null, we = Z ? Z.anchorLabel : te ? te.label : "", Fe = Z ? i.elementOf(Z) : te && te.elementId ? t.store.get(te.elementId) : null;
      if (!we && !Fe) return null;
      const Me = Rie(Fe);
      return { label: we || "Board", icon: { image: "Image", video: "Video", note: "StickyNote", tool: "LayoutGrid", frame: "Frame", shape: "Square", chat: "MessagesSquare", canvas: "MapPin" }[Me] };
    }), P = 34, A = 14, R = 62, D = 76;
    function O() {
      if (e.draft) {
        const te = i.ui.draft;
        return te ? { x: te.anchor.x, y: te.anchor.y } : null;
      }
      const Z = c.value;
      return Z ? i.pointOf(Z) : null;
    }
    function F() {
      const Z = o.value, te = O();
      if (!Z || !te) return;
      const we = t.worldToClient(te.x, te.y), Fe = window.innerWidth, Me = window.innerHeight, { w: he, h: U } = d.value, q = Fe - i.rightInset();
      let oe = we.x + 34 + A;
      oe + he > q - 8 && (oe = we.x - A - he), oe = Math.max(8, Math.min(oe, q - he - 8));
      let de = we.y - P - 6;
      de = Math.max(R, Math.min(de, Me - U - D));
      const pe = we.x < -60 || we.y < 0 || we.x > Fe + 60 || we.y > Me + 60;
      Z.style.transform = "translate3d(" + Math.round(oe) + "px," + Math.round(de) + "px,0)", Z.classList.toggle("is-away", pe);
    }
    let ie = null, ee = null;
    it(() => {
      ie = t.onCameraFrame(() => F()), o.value && typeof ResizeObserver != "undefined" && (ee = new ResizeObserver(() => {
        o.value && (d.value = { w: o.value.offsetWidth, h: o.value.offsetHeight }, F());
      }), ee.observe(o.value)), F(), me(!1), window.addEventListener("resize", F);
    }), We(() => {
      ie && ie(), ee && ee.disconnect(), window.removeEventListener("resize", F);
    }), Ee(() => [t.docRev.value, i.ui.panelOpen, t.ui.boardHistory, i.ui.draft && i.ui.draft.anchor, i.ui.dragging], () => nt(F));
    function me(Z = !0) {
      nt(() => {
        const te = r.value;
        te && te.scrollTo({ top: te.scrollHeight, behavior: Z ? "smooth" : "auto" });
      });
    }
    Ee(() => h.value.length, (Z, te) => {
      Z > (te || 0) && me();
    });
    const L = L6e, N = I(() => e.id ? L.get(e.id) || { text: "", mentions: [] } : { text: "", mentions: [] });
    async function K(Z) {
      if (e.draft) {
        await i.post(Z.text, Z.mentions);
        return;
      }
      if (!e.id) return;
      await i.reply(e.id, Z.text, Z.mentions) && (L.delete(e.id), a.value && a.value.reset());
    }
    function B(Z) {
      if (e.draft) {
        const te = i.ui.draft;
        te && (te.text = Z.text, te.mentions = Z.mentions);
        return;
      }
      e.id && L.set(e.id, Z);
    }
    function re() {
      e.draft ? i.cancelDraft() : i.close();
    }
    function H() {
      const Z = h.value.filter((we) => we.authorId === s), te = Z[Z.length - 1];
      te && (i.ui.editingId = te.id);
    }
    Ee(() => e.draft && i.ui.draft ? i.ui.draft.n : 0, (Z) => {
      Z && a.value && a.value.nod();
    });
    function J(Z) {
      l.value = !1, Z();
    }
    function Q() {
      const Z = c.value;
      Z && (f.value ? i.close() : i.pin(Z.id, !1));
    }
    function ne(Z) {
      l.value && o.value && !Z.target.closest(".cm-card-menu-wrap") && (l.value = !1);
    }
    function ue(Z) {
      Z.key !== "Escape" || !l.value || (Z.preventDefault(), Z.stopPropagation(), l.value = !1);
    }
    return it(() => {
      window.addEventListener("pointerdown", ne, !0), window.addEventListener("keydown", ue, !0);
    }), We(() => {
      window.removeEventListener("pointerdown", ne, !0), window.removeEventListener("keydown", ue, !0);
    }), (Z, te) => (g(), b("div", {
      ref_key: "el",
      ref: o,
      class: G(["cm-card", { "is-draft": n.draft, "is-open": f.value, "is-pinned": p.value && !f.value, "is-resolved": c.value && !!c.value.resolvedAt }]),
      style: ce({ "--thread": w.value.hex }),
      "data-thread": n.draft ? "draft" : n.id,
      "data-testid": n.draft ? "comment-draft" : "comment-thread",
      onPointerdown: te[10] || (te[10] = Te(() => {
      }, ["stop"])),
      onWheel: te[11] || (te[11] = Te(() => {
      }, ["stop"])),
      onContextmenu: te[12] || (te[12] = Te(() => {
      }, ["stop"]))
    }, [
      n.draft ? (g(), b(j, { key: 0 }, [
        u("div", y6e, [
          C(rr, {
            uid: m(s),
            name: m(i).myName,
            size: 26
          }, null, 8, ["uid", "name"]),
          te[13] || (te[13] = u("span", { class: "cm-draft-title" }, "New comment", -1)),
          k.value ? (g(), b("span", {
            key: 0,
            class: "cm-on is-inline",
            title: "On " + k.value.label
          }, [
            C($, {
              name: k.value.icon,
              size: 11
            }, null, 8, ["name"]),
            Y(E(k.value.label), 1)
          ], 8, x6e)) : z("", !0),
          u("button", {
            class: "cm-icon",
            title: "Discard (Esc)",
            "aria-label": "Discard",
            onClick: re
          }, [
            C($, {
              name: "X",
              size: 14
            })
          ])
        ]),
        C(q0, {
          ref_key: "composer",
          ref: a,
          people: S.value,
          me: m(s),
          text: m(i).ui.draft ? m(i).ui.draft.text : "",
          mentions: m(i).ui.draft ? m(i).ui.draft.mentions : [],
          group: _.value,
          alone: T.value,
          placeholder: "Add a comment. Use @ to mention.",
          autofocus: "",
          testid: "draft",
          onSubmit: K,
          onChange: B,
          onCancel: re
        }, null, 8, ["people", "me", "text", "mentions", "group", "alone"])
      ], 64)) : c.value ? (g(), b(j, { key: 1 }, [
        u("div", w6e, [
          u("div", k6e, [
            (g(!0), b(j, null, ge(m(Ks), (we) => (g(), b("button", {
              key: we.id,
              class: G(["cm-dot", { on: c.value.color === we.id }]),
              style: ce({ "--c": we.hex }),
              role: "radio",
              "aria-checked": c.value.color === we.id,
              title: we.label,
              "aria-label": we.label,
              onClick: (Fe) => m(i).setColor(c.value.id, we.id)
            }, null, 14, _6e))), 128))
          ]),
          te[19] || (te[19] = u("span", { class: "cm-grow" }, null, -1)),
          u("button", {
            class: G(["cm-icon", { on: y.value }]),
            title: y.value ? "Following: replies show in your Updates. Click to unfollow" : "Follow: hear about replies in your Updates",
            "aria-label": y.value ? "Unfollow" : "Follow",
            "aria-pressed": y.value,
            "data-testid": "thread-follow",
            onClick: te[0] || (te[0] = (we) => m(i).follow(c.value, !y.value))
          }, [
            C($, {
              name: y.value ? "Bell" : "BellOff",
              size: 14
            }, null, 8, ["name"])
          ], 10, S6e),
          u("button", {
            class: G(["cm-resolve", { on: !!c.value.resolvedAt }]),
            title: c.value.resolvedAt ? "Reopen" : "Resolve",
            "data-testid": "thread-resolve",
            onClick: te[1] || (te[1] = (we) => m(i).resolve(c.value.id, !c.value.resolvedAt))
          }, [
            C($, {
              name: "CircleCheck",
              size: 14
            }),
            u("span", null, E(c.value.resolvedAt ? "Resolved" : "Resolve"), 1)
          ], 10, M6e),
          u("div", T6e, [
            u("button", {
              class: G(["cm-icon", { on: l.value }]),
              title: "More",
              "aria-label": "More",
              "aria-haspopup": "menu",
              "aria-expanded": l.value,
              "data-testid": "thread-menu",
              onClick: te[2] || (te[2] = (we) => l.value = !l.value)
            }, [
              C($, {
                name: "Ellipsis",
                size: 15
              })
            ], 10, C6e),
            l.value ? (g(), b("div", I6e, [
              v.value ? (g(), b("button", {
                key: 0,
                role: "menuitem",
                "data-testid": "thread-mark-read",
                onClick: te[3] || (te[3] = (we) => J(() => m(i).markRead([c.value])))
              }, [
                C($, {
                  name: "CheckCheck",
                  size: 14
                }),
                te[14] || (te[14] = Y("Mark as read", -1))
              ])) : (g(), b("button", {
                key: 1,
                role: "menuitem",
                "data-testid": "thread-mark-unread",
                onClick: te[4] || (te[4] = (we) => J(() => m(i).markUnread(c.value)))
              }, [
                C($, {
                  name: "MessageSquareDot",
                  size: 14
                }),
                te[15] || (te[15] = Y("Mark as unread", -1))
              ])),
              u("button", {
                role: "menuitem",
                "data-testid": "thread-pin",
                onClick: te[5] || (te[5] = (we) => J(() => m(i).pin(c.value.id, !p.value)))
              }, [
                C($, {
                  name: p.value ? "PinOff" : "Pin",
                  size: 14
                }, null, 8, ["name"]),
                Y(E(p.value ? "Unpin" : "Pin for yourself") + " ", 1),
                p.value ? z("", !0) : (g(), b("small", A6e, "Keeps it open on the board"))
              ]),
              u("button", {
                role: "menuitem",
                "data-testid": "thread-copy-link",
                onClick: te[6] || (te[6] = (we) => J(() => m(i).copyLink(c.value)))
              }, [
                C($, {
                  name: "Link2",
                  size: 14
                }),
                te[16] || (te[16] = Y("Copy link", -1))
              ]),
              m(i).canDelete(c.value) ? (g(), b(j, { key: 2 }, [
                te[18] || (te[18] = u("span", { class: "cm-card-menu-sep" }, null, -1)),
                u("button", {
                  role: "menuitem",
                  class: "is-danger",
                  "data-testid": "thread-delete",
                  onClick: te[7] || (te[7] = (we) => J(() => m(i).askDeleteThread(c.value.id)))
                }, [
                  C($, {
                    name: "Trash2",
                    size: 14
                  }),
                  te[17] || (te[17] = Y("Delete thread", -1))
                ])
              ], 64)) : z("", !0)
            ])) : z("", !0)
          ]),
          u("button", {
            class: "cm-icon",
            title: f.value ? "Close (Esc)" : "Unpin",
            "aria-label": f.value ? "Close" : "Unpin",
            "data-testid": "thread-close",
            onClick: Q
          }, [
            C($, {
              name: f.value ? "X" : "PinOff",
              size: 14
            }, null, 8, ["name"])
          ], 8, P6e)
        ]),
        k.value || c.value.resolvedAt || x.value && x.value.of > 1 ? (g(), b("div", E6e, [
          k.value ? (g(), b("span", {
            key: 0,
            class: "cm-on",
            title: "On " + k.value.label
          }, [
            C($, {
              name: k.value.icon,
              size: 11
            }, null, 8, ["name"]),
            Y(E(k.value.label), 1)
          ], 8, R6e)) : z("", !0),
          c.value.resolvedAt ? (g(), b("span", z6e, [
            C($, {
              name: "CircleCheck",
              size: 11
            }),
            te[20] || (te[20] = Y("Resolved", -1))
          ])) : z("", !0),
          te[21] || (te[21] = u("span", { class: "cm-grow" }, null, -1)),
          x.value && x.value.of > 1 ? (g(), b("div", $6e, [
            u("button", {
              class: "cm-icon",
              title: "Previous thread",
              "aria-label": "Previous thread",
              "data-testid": "thread-prev",
              onClick: te[8] || (te[8] = (we) => m(i).step(-1))
            }, [
              C($, {
                name: "ChevronLeft",
                size: 14
              })
            ]),
            u("span", D6e, E(x.value.at) + " of " + E(x.value.of), 1),
            u("button", {
              class: "cm-icon",
              title: "Next thread",
              "aria-label": "Next thread",
              "data-testid": "thread-next",
              onClick: te[9] || (te[9] = (we) => m(i).step(1))
            }, [
              C($, {
                name: "ChevronRight",
                size: 14
              })
            ])
          ])) : z("", !0)
        ])) : z("", !0),
        u("div", {
          ref_key: "list",
          ref: r,
          class: "cm-list"
        }, [
          (g(!0), b(j, null, ge(h.value, (we, Fe) => (g(), Ie(b6e, {
            key: we.id,
            c: we,
            first: Fe === 0
          }, null, 8, ["c", "first"]))), 128))
        ], 512),
        u("div", O6e, [
          (g(), Ie(q0, {
            ref_key: "composer",
            ref: a,
            key: "r" + c.value.id,
            people: S.value,
            me: m(s),
            text: N.value.text,
            mentions: N.value.mentions,
            group: _.value,
            alone: T.value,
            placeholder: c.value.resolvedAt ? "Reply to reopen" : "Reply",
            autofocus: f.value,
            testid: "reply",
            onSubmit: K,
            onChange: B,
            onCancel: re,
            onEditLast: H
          }, null, 8, ["people", "me", "text", "mentions", "group", "alone", "placeholder", "autofocus"]))
        ])
      ], 64)) : z("", !0)
    ], 46, v6e));
  }
}), B6e = { class: "cm-reply-main" }, F6e = { class: "cm-reply-head" }, N6e = ["title"], U6e = { key: 0 }, B4 = /* @__PURE__ */ Pe({
  __name: "ReplyRow",
  props: {
    c: {},
    me: {},
    now: {},
    fresh: { type: Boolean, default: !1 },
    clamp: { default: 4 }
  },
  setup(n) {
    return (e, t) => (g(), b("div", {
      class: G(["cm-reply-row", { "is-new": n.fresh }]),
      "data-testid": "comments-reply"
    }, [
      C(rr, {
        uid: n.c.authorId,
        name: n.c.authorName,
        size: 20
      }, null, 8, ["uid", "name"]),
      u("div", B6e, [
        u("div", F6e, [
          u("b", null, E(n.c.authorName), 1),
          u("span", {
            title: m(ef)(n.c.createdAt)
          }, E(m(Jn)(n.c.createdAt, n.now)), 9, N6e),
          n.fresh ? (g(), b("i", U6e, "new")) : z("", !0)
        ]),
        C(cu, {
          class: "cm-reply-text",
          text: n.c.text,
          mentions: n.c.mentions,
          me: n.me,
          clamp: n.clamp
        }, null, 8, ["text", "mentions", "me", "clamp"])
      ])
    ], 2));
  }
}), G6e = { class: "cm-panel-head" }, j6e = { class: "cm-panel-settings-wrap" }, H6e = {
  key: 0,
  class: "cm-card-menu is-settings",
  role: "menu",
  "data-testid": "comments-settings-menu"
}, V6e = ["aria-checked"], W6e = ["aria-checked"], q6e = ["disabled"], K6e = {
  class: "cm-tabs",
  role: "tablist"
}, Y6e = ["aria-selected"], X6e = {
  key: 0,
  class: "cm-count"
}, J6e = ["aria-selected"], Z6e = {
  key: 0,
  class: "cm-count"
}, Q6e = { class: "cm-tools" }, e8e = { class: "cm-search" }, t8e = {
  class: "cm-chips",
  role: "radiogroup",
  "aria-label": "Show"
}, n8e = ["aria-checked", "data-testid", "onClick"], i8e = {
  key: 0,
  class: "n"
}, s8e = {
  class: "cm-feed",
  "data-testid": "comments-feed"
}, o8e = {
  key: 0,
  class: "cm-feed-empty"
}, r8e = {
  key: 1,
  class: "cm-feed-empty"
}, a8e = { class: "cm-empty-mark is-error" }, l8e = {
  key: 2,
  class: "cm-feed-empty",
  "data-testid": "comments-empty"
}, d8e = { class: "cm-empty-mark" }, c8e = {
  key: 3,
  class: "cm-feed-empty"
}, u8e = { class: "cm-empty-mark" }, h8e = {
  key: 0,
  class: "cm-feed-label"
}, p8e = {
  key: 0,
  class: "cm-feed-label"
}, f8e = ["data-thread", "onClick", "onKeydown"], m8e = {
  key: 0,
  class: "cm-item-dot",
  "aria-label": "Unread"
}, g8e = { class: "cm-item-main" }, b8e = { class: "cm-item-head" }, v8e = { class: "cm-item-time" }, y8e = {
  key: 1,
  class: "cm-item-on"
}, x8e = { class: "cm-item-on-label" }, w8e = {
  key: 2,
  class: "cm-replies"
}, k8e = ["onClick"], _8e = {
  key: 3,
  class: "cm-item-foot"
}, S8e = { class: "cm-item-resolved" }, M8e = ["title", "aria-label", "onClick"], T8e = ["title", "aria-label", "onClick"], C8e = { class: "cm-item-menu-wrap" }, I8e = ["onClick"], A8e = ["onClick"], P8e = ["onClick"], E8e = ["onClick"], R8e = ["onClick"], z8e = { class: "cm-tools is-elsewhere" }, $8e = {
  class: "cm-chips",
  role: "radiogroup",
  "aria-label": "Show"
}, D8e = ["aria-checked"], O8e = {
  key: 0,
  class: "n"
}, L8e = ["aria-checked"], B8e = ["disabled"], F8e = {
  class: "cm-feed",
  "data-testid": "elsewhere-feed"
}, N8e = {
  key: 0,
  class: "cm-feed-empty"
}, U8e = { class: "cm-empty-mark" }, G8e = { class: "cm-board-head" }, j8e = { class: "cm-board-title" }, H8e = { class: "cm-board-n" }, V8e = ["onClick"], W8e = ["onClick", "onKeydown"], q8e = {
  key: 0,
  class: "cm-item-dot",
  "aria-label": "Unread"
}, K8e = { class: "cm-item-main" }, Y8e = { class: "cm-item-head" }, X8e = { class: "cm-item-time" }, J8e = {
  key: 1,
  class: "cm-replies is-all",
  "data-testid": "elsewhere-thread"
}, Z8e = {
  key: 0,
  class: "bd-spinner is-sm"
}, Q8e = {
  key: 1,
  class: "cm-replies-failed"
}, eSe = { class: "cm-item-foot" }, tSe = {
  key: 0,
  class: "cm-item-resolved"
}, nSe = ["onClick"], iSe = { class: "cm-item-open" }, sSe = ["title", "aria-label", "onClick"], oSe = ["onClick"], rSe = /* @__PURE__ */ Pe({
  __name: "UpdatesPanel",
  setup(n) {
    const { board: e } = Ze(), t = e.comments, i = e.user.uid, s = dr(), o = /* @__PURE__ */ W(!1), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = [
      { id: "all", label: "All" },
      { id: "unread", label: "Unread" },
      { id: "mentions", label: "Mentions" },
      { id: "mine", label: "Yours" }
    ], d = I(() => t.feed.value), c = I(() => d.value.filter((K) => K.pinned)), h = I(() => d.value.filter((K) => !K.pinned)), f = I(() => t.allThreads().filter((K) => !K.resolvedAt || t.ui.showResolved).length), p = (K) => (Ks.find((B) => B.id === K) || Ks[0]).hex;
    function y(K) {
      r.value = null, t.focus(K.t.id);
    }
    const v = /* @__PURE__ */ W(!1);
    function x(K, B) {
      if (r.value === K) {
        r.value = null;
        return;
      }
      const re = B.currentTarget.getBoundingClientRect(), H = B.currentTarget.closest(".cm-feed"), J = H ? H.getBoundingClientRect().bottom : window.innerHeight;
      v.value = J - re.bottom < 200, r.value = K;
    }
    function w(K) {
      r.value = null, o.value = !1, K();
    }
    function S() {
      t.ui.panelOpen = !1;
    }
    function M() {
      S(), t.arm(!0);
    }
    const _ = I(() => {
      if (t.ui.query) return { title: "No matches", sub: "Nothing on this board says “" + t.ui.query + "”." };
      switch (t.ui.filter) {
        case "unread":
          return { title: "You're all caught up", sub: "Nothing unread on this board." };
        case "mentions":
          return { title: "No mentions", sub: "When someone @mentions you, or replies where you've commented, it shows here." };
        case "mine":
          return { title: "Nothing of yours yet", sub: "Threads you start or reply to show here." };
        default:
          return null;
      }
    }), T = /* @__PURE__ */ W(/* @__PURE__ */ new Set());
    function k(K) {
      const B = new Set(T.value);
      B.has(K) ? B.delete(K) : B.add(K), T.value = B;
    }
    function P(K) {
      return t.commentsOf(K.t.id).slice(1);
    }
    function A(K) {
      const B = P(K);
      return T.value.has(K.t.id) ? B : B.slice(-1);
    }
    function R(K) {
      return P(K).slice(0, -1).filter((B) => t.isFresh(K.t, B)).length;
    }
    const D = I(() => t.elsewhere.value), O = /* @__PURE__ */ qe({});
    function F(K) {
      const B = O.value[K.id];
      return B && B.at === K.lastAt ? B : null;
    }
    async function ie(K) {
      if (k(K.id), !T.value.has(K.id) || F(K)) return;
      const B = K.lastAt;
      O.value = { ...O.value, [K.id]: { at: B, list: null } };
      try {
        const re = await t.commentsElsewhere(K);
        O.value = { ...O.value, [K.id]: { at: B, list: re } };
      } catch (re) {
        console.warn("[board] comments: a thread on another board couldn't be read", re), O.value = { ...O.value, [K.id]: { at: B, list: [], failed: !0 } };
      }
    }
    function ee(K) {
      r.value = null, t.openElsewhere(K);
    }
    function me(K) {
      const B = K.target;
      o.value && !B.closest(".cm-panel-settings-wrap") && (o.value = !1), r.value && !B.closest(".cm-item-menu-wrap") && (r.value = null);
    }
    function L(K) {
      K.key !== "Escape" || !o.value && !r.value || (K.preventDefault(), K.stopPropagation(), o.value = !1, r.value = null);
    }
    function N(K) {
      K.key === "/" && document.activeElement !== a.value && !K.target.closest("textarea, input") && (K.preventDefault(), a.value && a.value.focus());
    }
    return it(() => {
      window.addEventListener("pointerdown", me, !0), window.addEventListener("keydown", N), window.addEventListener("keydown", L, !0), t.refreshPeople();
    }), We(() => {
      window.removeEventListener("pointerdown", me, !0), window.removeEventListener("keydown", N), window.removeEventListener("keydown", L, !0);
    }), (K, B) => (g(), b("aside", {
      class: "cm-panel",
      "aria-label": "Comments",
      "data-testid": "comments-panel",
      onPointerdown: B[13] || (B[13] = Te(() => {
      }, ["stop"])),
      onWheel: B[14] || (B[14] = Te(() => {
      }, ["stop"]))
    }, [
      u("div", G6e, [
        B[20] || (B[20] = u("span", { class: "cm-panel-title" }, "Comments", -1)),
        B[21] || (B[21] = u("span", { class: "cm-grow" }, null, -1)),
        u("button", {
          class: "cm-icon",
          title: "Comment (C)",
          "aria-label": "Add a comment",
          "data-testid": "comments-add",
          onClick: M
        }, [
          C($, {
            name: "MessageCirclePlus",
            size: 15
          })
        ]),
        u("div", j6e, [
          u("button", {
            class: G(["cm-icon", { on: o.value }]),
            title: "Settings",
            "aria-label": "Settings",
            "data-testid": "comments-settings",
            onClick: B[0] || (B[0] = (re) => o.value = !o.value)
          }, [
            C($, {
              name: "SlidersHorizontal",
              size: 15
            })
          ], 2),
          o.value ? (g(), b("div", H6e, [
            u("button", {
              role: "menuitemcheckbox",
              "aria-checked": m(t).ui.showPins,
              "data-testid": "comments-show-pins",
              onClick: B[1] || (B[1] = (re) => m(t).ui.showPins = !m(t).ui.showPins)
            }, [
              C($, {
                name: m(t).ui.showPins ? "Eye" : "EyeOff",
                size: 14
              }, null, 8, ["name"]),
              B[15] || (B[15] = Y("Comments on the board ", -1)),
              u("span", {
                class: G(["cm-switch", { on: m(t).ui.showPins }])
              }, null, 2),
              B[16] || (B[16] = u("kbd", null, "⇧C", -1))
            ], 8, V6e),
            u("button", {
              role: "menuitemcheckbox",
              "aria-checked": m(t).ui.showResolved,
              "data-testid": "comments-show-resolved",
              onClick: B[2] || (B[2] = (re) => m(t).ui.showResolved = !m(t).ui.showResolved)
            }, [
              C($, {
                name: "CircleCheck",
                size: 14
              }),
              B[17] || (B[17] = Y("Resolved threads ", -1)),
              u("span", {
                class: G(["cm-switch", { on: m(t).ui.showResolved }])
              }, null, 2)
            ], 8, W6e),
            B[19] || (B[19] = u("span", { class: "cm-card-menu-sep" }, null, -1)),
            u("button", {
              role: "menuitem",
              disabled: !m(t).unreadCount.value,
              "data-testid": "comments-mark-all",
              onClick: B[3] || (B[3] = (re) => w(() => m(t).markAllRead()))
            }, [
              C($, {
                name: "CheckCheck",
                size: 14
              }),
              B[18] || (B[18] = Y("Mark all as read", -1))
            ], 8, q6e)
          ])) : z("", !0)
        ]),
        u("button", {
          class: "cm-icon",
          title: "Close (Esc)",
          "aria-label": "Close comments",
          "data-testid": "comments-close",
          onClick: S
        }, [
          C($, {
            name: "X",
            size: 15
          })
        ])
      ]),
      u("div", K6e, [
        u("button", {
          role: "tab",
          "aria-selected": m(t).ui.tab === "board",
          class: G({ on: m(t).ui.tab === "board" }),
          "data-testid": "comments-tab-board",
          onClick: B[4] || (B[4] = (re) => m(t).ui.tab = "board")
        }, [
          B[22] || (B[22] = Y(" This board", -1)),
          m(t).unreadCount.value ? (g(), b("span", X6e, E(m(t).unreadCount.value), 1)) : z("", !0)
        ], 10, Y6e),
        u("button", {
          role: "tab",
          "aria-selected": m(t).ui.tab === "elsewhere",
          class: G({ on: m(t).ui.tab === "elsewhere" }),
          "data-testid": "comments-tab-elsewhere",
          onClick: B[5] || (B[5] = (re) => m(t).ui.tab = "elsewhere")
        }, [
          B[23] || (B[23] = Y(" Everywhere else", -1)),
          m(t).elsewhereUnread.value ? (g(), b("span", Z6e, E(m(t).elsewhereUnread.value), 1)) : z("", !0)
        ], 10, J6e)
      ]),
      m(t).ui.tab === "board" ? (g(), b(j, { key: 0 }, [
        u("div", Q6e, [
          u("label", e8e, [
            C($, {
              name: "Search",
              size: 13
            }),
            _t(u("input", {
              ref_key: "search",
              ref: a,
              "onUpdate:modelValue": B[6] || (B[6] = (re) => m(t).ui.query = re),
              type: "text",
              placeholder: "Search comments",
              spellcheck: "false",
              "data-testid": "comments-search"
            }, null, 512), [
              [Zt, m(t).ui.query]
            ]),
            m(t).ui.query ? (g(), b("button", {
              key: 0,
              class: "cm-search-clear",
              "aria-label": "Clear the search",
              onClick: B[7] || (B[7] = (re) => m(t).ui.query = "")
            }, [
              C($, {
                name: "X",
                size: 12
              })
            ])) : z("", !0)
          ]),
          u("div", t8e, [
            (g(), b(j, null, ge(l, (re) => u("button", {
              key: re.id,
              class: G(["cm-fchip", { on: m(t).ui.filter === re.id }]),
              role: "radio",
              "aria-checked": m(t).ui.filter === re.id,
              "data-testid": "comments-filter-" + re.id,
              onClick: (H) => m(t).ui.filter = re.id
            }, [
              Y(E(re.label), 1),
              re.id === "unread" && m(t).unreadCount.value ? (g(), b("span", i8e, E(m(t).unreadCount.value), 1)) : z("", !0)
            ], 10, n8e)), 64))
          ])
        ]),
        u("div", s8e, [
          m(t).loaded.value ? m(t).failed.value ? (g(), b("div", r8e, [
            u("span", a8e, [
              C($, {
                name: "CloudOff",
                size: 18
              })
            ]),
            B[25] || (B[25] = u("b", null, "Comments are unavailable", -1)),
            B[26] || (B[26] = u("span", null, "They couldn't be loaded on this board. Please reload the page.", -1))
          ])) : f.value ? !d.value.length && _.value ? (g(), b("div", c8e, [
            u("span", u8e, [
              C($, {
                name: m(t).ui.filter === "unread" && !m(t).ui.query ? "CheckCheck" : "Search",
                size: 18
              }, null, 8, ["name"])
            ]),
            u("b", null, E(_.value.title), 1),
            u("span", null, E(_.value.sub), 1)
          ])) : (g(), b(j, { key: 4 }, [
            c.value.length ? (g(), b("div", h8e, [
              C($, {
                name: "Pin",
                size: 11
              }),
              B[30] || (B[30] = Y("Pinned for you", -1))
            ])) : z("", !0),
            (g(!0), b(j, null, ge([c.value, h.value], (re, H) => (g(), b(j, { key: H }, [
              H === 1 && c.value.length && h.value.length ? (g(), b("div", p8e, "Recent activity")) : z("", !0),
              (g(!0), b(j, null, ge(re, (J) => (g(), b("div", {
                key: J.t.id,
                class: G(["cm-item", { "is-unread": J.unread, "is-open": m(t).ui.openId === J.t.id, "is-resolved": !!J.t.resolvedAt }]),
                style: ce({ "--thread": p(J.t.color) }),
                role: "button",
                tabindex: "0",
                "data-thread": J.t.id,
                "data-testid": "comments-item",
                onClick: (Q) => y(J),
                onKeydown: tn((Q) => y(J), ["enter"])
              }, [
                J.unread ? (g(), b("span", m8e)) : z("", !0),
                C(rr, {
                  uid: J.t.createdBy,
                  name: J.t.createdByName,
                  size: 28
                }, null, 8, ["uid", "name"]),
                u("div", g8e, [
                  u("div", b8e, [
                    u("b", null, E(J.first ? J.first.authorName : J.t.createdByName), 1),
                    u("span", v8e, E(m(Jn)(J.first ? J.first.createdAt : J.t.createdAt, m(s))), 1)
                  ]),
                  J.first ? (g(), Ie(cu, {
                    key: 0,
                    class: "cm-item-text",
                    text: J.first.text,
                    mentions: J.first.mentions,
                    me: m(i),
                    clamp: 3
                  }, null, 8, ["text", "mentions", "me"])) : z("", !0),
                  J.t.anchorLabel || J.t.anchorThumb ? (g(), b("div", y8e, [
                    J.t.anchorThumb ? (g(), b("span", {
                      key: 0,
                      class: "cm-item-thumb",
                      style: ce({ backgroundImage: 'url("' + m(Bt)(J.t.anchorThumb) + '")' })
                    }, null, 4)) : z("", !0),
                    u("span", x8e, E(J.t.anchorLabel || "Board"), 1)
                  ])) : z("", !0),
                  J.replies ? (g(), b("div", w8e, [
                    J.replies > 1 ? (g(), b("button", {
                      key: 0,
                      class: G(["cm-replies-more", { "is-new": !T.value.has(J.t.id) && R(J) }]),
                      "data-testid": "comments-replies-toggle",
                      onClick: Te((Q) => k(J.t.id), ["stop"])
                    }, [
                      T.value.has(J.t.id) ? (g(), b(j, { key: 0 }, [
                        Y("Hide earlier replies")
                      ], 64)) : (g(), b(j, { key: 1 }, [
                        Y("Show " + E(J.replies - 1) + " earlier " + E(J.replies - 1 === 1 ? "reply" : "replies"), 1),
                        R(J) ? (g(), b(j, { key: 0 }, [
                          Y(" · " + E(R(J)) + " new", 1)
                        ], 64)) : z("", !0)
                      ], 64))
                    ], 10, k8e)) : z("", !0),
                    (g(!0), b(j, null, ge(A(J), (Q) => (g(), Ie(B4, {
                      key: Q.id,
                      c: Q,
                      me: m(i),
                      now: m(s),
                      fresh: m(t).isFresh(J.t, Q)
                    }, null, 8, ["c", "me", "now", "fresh"]))), 128))
                  ])) : z("", !0),
                  J.t.resolvedAt ? (g(), b("div", _8e, [
                    u("span", S8e, [
                      C($, {
                        name: "CircleCheck",
                        size: 11
                      }),
                      B[31] || (B[31] = Y("Resolved", -1))
                    ])
                  ])) : z("", !0)
                ]),
                u("div", {
                  class: "cm-item-acts",
                  onClick: B[8] || (B[8] = Te(() => {
                  }, ["stop"]))
                }, [
                  u("button", {
                    class: G(["is-resolve", { on: !!J.t.resolvedAt }]),
                    title: J.t.resolvedAt ? "Reopen" : "Resolve",
                    "aria-label": J.t.resolvedAt ? "Reopen" : "Resolve",
                    "data-testid": "comments-item-resolve",
                    onClick: (Q) => m(t).resolve(J.t.id, !J.t.resolvedAt)
                  }, [
                    C($, {
                      name: "CircleCheck",
                      size: 14
                    })
                  ], 10, M8e),
                  u("button", {
                    title: J.unread ? "Mark as read" : "Mark as unread",
                    "aria-label": J.unread ? "Mark as read" : "Mark as unread",
                    "data-testid": "comments-item-read",
                    onClick: (Q) => J.unread ? m(t).markRead([J.t]) : m(t).markUnread(J.t)
                  }, [
                    C($, {
                      name: J.unread ? "CheckCheck" : "MessageSquareDot",
                      size: 14
                    }, null, 8, ["name"])
                  ], 8, T8e),
                  u("div", C8e, [
                    u("button", {
                      title: "More",
                      "aria-label": "More",
                      class: G({ on: r.value === J.t.id }),
                      "data-testid": "comments-item-more",
                      onClick: (Q) => x(J.t.id, Q)
                    }, [
                      C($, {
                        name: "Ellipsis",
                        size: 14
                      })
                    ], 10, I8e),
                    r.value === J.t.id ? (g(), b("div", {
                      key: 0,
                      class: G(["cm-card-menu is-item", { "is-up": v.value }]),
                      role: "menu",
                      "data-testid": "comments-item-menu"
                    }, [
                      u("button", {
                        role: "menuitem",
                        onClick: (Q) => w(() => m(t).follow(J.t, !m(t).following(J.t)))
                      }, [
                        C($, {
                          name: m(t).following(J.t) ? "BellOff" : "Bell",
                          size: 14
                        }, null, 8, ["name"]),
                        Y(E(m(t).following(J.t) ? "Unfollow" : "Follow"), 1)
                      ], 8, A8e),
                      u("button", {
                        role: "menuitem",
                        onClick: (Q) => w(() => m(t).pin(J.t.id, !J.pinned))
                      }, [
                        C($, {
                          name: J.pinned ? "PinOff" : "Pin",
                          size: 14
                        }, null, 8, ["name"]),
                        Y(E(J.pinned ? "Unpin" : "Pin for yourself"), 1)
                      ], 8, P8e),
                      u("button", {
                        role: "menuitem",
                        onClick: (Q) => w(() => m(t).copyLink(J.t))
                      }, [
                        C($, {
                          name: "Link2",
                          size: 14
                        }),
                        B[32] || (B[32] = Y("Copy link", -1))
                      ], 8, E8e),
                      m(t).canDelete(J.t) ? (g(), b(j, { key: 0 }, [
                        B[34] || (B[34] = u("span", { class: "cm-card-menu-sep" }, null, -1)),
                        u("button", {
                          role: "menuitem",
                          class: "is-danger",
                          onClick: (Q) => w(() => m(t).askDeleteThread(J.t.id))
                        }, [
                          C($, {
                            name: "Trash2",
                            size: 14
                          }),
                          B[33] || (B[33] = Y("Delete thread", -1))
                        ], 8, R8e)
                      ], 64)) : z("", !0)
                    ], 2)) : z("", !0)
                  ])
                ])
              ], 46, f8e))), 128))
            ], 64))), 128))
          ], 64)) : (g(), b("div", l8e, [
            u("span", d8e, [
              C($, {
                name: "MessageCircle",
                size: 18
              })
            ]),
            B[28] || (B[28] = u("b", null, "No comments yet", -1)),
            B[29] || (B[29] = u("span", null, [
              Y("Press "),
              u("kbd", null, "C"),
              Y(", then click anything on the board (or anywhere on it) to start a thread.")
            ], -1)),
            u("button", {
              class: "cm-btn",
              onClick: M
            }, [
              C($, {
                name: "MessageCirclePlus",
                size: 14
              }),
              B[27] || (B[27] = Y("Add a comment", -1))
            ])
          ])) : (g(), b("div", o8e, [...B[24] || (B[24] = [
            u("span", { class: "bd-spinner is-sm" }, null, -1)
          ])]))
        ])
      ], 64)) : (g(), b(j, { key: 1 }, [
        u("div", z8e, [
          u("div", $8e, [
            u("button", {
              class: G(["cm-fchip", { on: m(t).ui.elsewhereUnread }]),
              role: "radio",
              "aria-checked": m(t).ui.elsewhereUnread,
              "data-testid": "elsewhere-unread",
              onClick: B[9] || (B[9] = (re) => m(t).ui.elsewhereUnread = !0)
            }, [
              B[35] || (B[35] = Y(" Unread", -1)),
              m(t).elsewhereUnread.value ? (g(), b("span", O8e, E(m(t).elsewhereUnread.value), 1)) : z("", !0)
            ], 10, D8e),
            u("button", {
              class: G(["cm-fchip", { on: !m(t).ui.elsewhereUnread }]),
              role: "radio",
              "aria-checked": !m(t).ui.elsewhereUnread,
              "data-testid": "elsewhere-all",
              onClick: B[10] || (B[10] = (re) => m(t).ui.elsewhereUnread = !1)
            }, "All", 10, L8e)
          ]),
          B[36] || (B[36] = u("span", { class: "cm-grow" }, null, -1)),
          u("button", {
            class: "cm-linkbtn",
            disabled: !m(t).elsewhereUnread.value,
            "data-testid": "elsewhere-mark-all",
            onClick: B[11] || (B[11] = (re) => m(t).markAllReadElsewhere())
          }, "Mark all as read", 8, B8e)
        ]),
        u("div", F8e, [
          D.value.length ? z("", !0) : (g(), b("div", N8e, [
            u("span", U8e, [
              C($, {
                name: "Inbox",
                size: 18
              })
            ]),
            u("b", null, E(m(t).ui.elsewhereUnread ? "Nothing new elsewhere" : "Nothing to follow yet"), 1),
            B[37] || (B[37] = u("span", null, "Threads you start, reply to or are mentioned in on your other boards show here.", -1))
          ])),
          (g(!0), b(j, null, ge(D.value, (re) => (g(), b("section", {
            key: re.boardId,
            class: "cm-board-group",
            "data-testid": "elsewhere-board"
          }, [
            u("div", G8e, [
              C($, {
                name: "LayoutDashboard",
                size: 12
              }),
              u("span", j8e, E(re.title), 1),
              u("span", H8e, E(re.items.length), 1),
              B[38] || (B[38] = u("span", { class: "cm-grow" }, null, -1)),
              re.items.some((H) => m(gs)(H, m(i))) ? (g(), b("button", {
                key: 0,
                class: "cm-linkbtn is-sm",
                title: "Mark this board's as read",
                onClick: (H) => m(t).markAllReadElsewhere(re.boardId)
              }, "Mark read", 8, V8e)) : z("", !0)
            ]),
            (g(!0), b(j, null, ge(re.items, (H) => (g(), b("div", {
              key: H.id,
              class: G(["cm-item is-elsewhere", { "is-unread": m(gs)(H, m(i)), "is-resolved": !!H.resolvedAt }]),
              style: ce({ "--thread": p(H.color) }),
              role: "button",
              tabindex: "0",
              "data-testid": "elsewhere-item",
              onClick: (J) => ee(H),
              onKeydown: tn((J) => ee(H), ["enter"])
            }, [
              m(gs)(H, m(i)) ? (g(), b("span", q8e)) : z("", !0),
              C(rr, {
                uid: H.preview ? H.preview.by : H.createdBy,
                name: H.preview ? H.preview.byName : H.createdByName,
                size: 28
              }, null, 8, ["uid", "name"]),
              u("div", K8e, [
                u("div", Y8e, [
                  u("b", null, E(H.preview ? H.preview.byName : H.createdByName), 1),
                  u("span", X8e, E(m(Jn)(H.lastAt, m(s))), 1)
                ]),
                H.preview && !T.value.has(H.id) ? (g(), Ie(cu, {
                  key: 0,
                  class: "cm-item-text",
                  text: H.preview.text,
                  mentions: [{ uid: m(i), name: m(t).myName }],
                  me: m(i),
                  clamp: 3
                }, null, 8, ["text", "mentions", "me"])) : z("", !0),
                T.value.has(H.id) ? (g(), b("div", J8e, [
                  F(H) && !F(H).list ? (g(), b("span", Z8e)) : F(H) && F(H).failed ? (g(), b("span", Q8e, "This thread couldn't be read. Open it on its board.")) : F(H) ? (g(!0), b(j, { key: 2 }, ge(F(H).list, (J) => (g(), Ie(B4, {
                    key: J.id,
                    c: J,
                    me: m(i),
                    now: m(s),
                    fresh: m(t).isFresh(H, J)
                  }, null, 8, ["c", "me", "now", "fresh"]))), 128)) : z("", !0)
                ])) : z("", !0),
                u("div", eSe, [
                  H.resolvedAt ? (g(), b("span", tSe, [
                    C($, {
                      name: "CircleCheck",
                      size: 11
                    }),
                    B[39] || (B[39] = Y("Resolved", -1))
                  ])) : z("", !0),
                  H.count > 1 ? (g(), b("button", {
                    key: 1,
                    class: "cm-replies-more",
                    "data-testid": "elsewhere-thread-toggle",
                    onClick: Te((J) => ie(H), ["stop"])
                  }, E(T.value.has(H.id) ? "Show only the newest" : "Show all " + H.count + " comments"), 9, nSe)) : z("", !0),
                  u("span", iSe, [
                    B[40] || (B[40] = Y("Open", -1)),
                    C($, {
                      name: "ArrowUpRight",
                      size: 11
                    })
                  ])
                ])
              ]),
              u("div", {
                class: "cm-item-acts",
                onClick: B[12] || (B[12] = Te(() => {
                }, ["stop"]))
              }, [
                u("button", {
                  title: m(gs)(H, m(i)) ? "Mark as read" : "Mark as unread",
                  "aria-label": m(gs)(H, m(i)) ? "Mark as read" : "Mark as unread",
                  onClick: (J) => m(gs)(H, m(i)) ? m(t).markRead([H]) : m(t).markUnread(H)
                }, [
                  C($, {
                    name: m(gs)(H, m(i)) ? "CheckCheck" : "MessageSquareDot",
                    size: 14
                  }, null, 8, ["name"])
                ], 8, sSe),
                u("button", {
                  title: "Unfollow",
                  "aria-label": "Unfollow",
                  onClick: (J) => m(t).follow(H, !1)
                }, [
                  C($, {
                    name: "BellOff",
                    size: 14
                  })
                ], 8, oSe)
              ])
            ], 46, W8e))), 128))
          ]))), 128))
        ])
      ], 64))
    ], 32));
  }
}), aSe = { class: "ic" }, lSe = { class: "tx" }, dSe = { class: "acts" }, cSe = /* @__PURE__ */ Pe({
  __name: "DeleteThreadAsk",
  setup(n) {
    const { board: e } = Ze(), t = e.comments, i = I(() => t.ui.confirmDelete);
    function s(d) {
      return d.length <= 2 ? d.join(" and ") : d.slice(0, 2).join(", ") + " and " + (d.length - 2) + (d.length - 2 === 1 ? " other" : " others");
    }
    const o = I(() => {
      const d = i.value;
      return d ? (d.replies === 1 ? "A reply from " : d.replies + " replies from ") + s(d.names) + " will be deleted with it. You can undo it for a few seconds." : "";
    }), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null);
    Ee(i, (d) => {
      d && nt(() => r.value && r.value.focus({ preventScroll: !0 }));
    }, { immediate: !0 });
    function l(d) {
      if (i.value) {
        if (d.key === "Escape")
          d.preventDefault(), d.stopImmediatePropagation(), t.answerDelete(!1);
        else if (d.key === "Enter") {
          const c = d.target;
          if (c && a.value && a.value.contains(c) && c.tagName === "BUTTON") return;
          d.preventDefault(), d.stopImmediatePropagation();
        } else if (d.key === "Tab") {
          const c = d.target;
          (!c || !a.value || !a.value.contains(c)) && (d.preventDefault(), r.value && r.value.focus({ preventScroll: !0 }));
        }
      }
    }
    return it(() => window.addEventListener("keydown", l, !0)), We(() => window.removeEventListener("keydown", l, !0)), (d, c) => (g(), Ie(vt, { name: "cm-ask" }, {
      default: Xe(() => [
        i.value ? (g(), b("div", {
          key: 0,
          class: "cm-ask",
          role: "alertdialog",
          "aria-modal": "true",
          "aria-label": "Delete this thread?",
          "data-testid": "thread-delete-ask",
          onPointerdown: c[2] || (c[2] = Te((h) => m(t).answerDelete(!1), ["self"]))
        }, [
          u("div", {
            ref_key: "card",
            ref: a,
            class: "cm-ask-card"
          }, [
            u("span", aSe, [
              C($, {
                name: "Trash2",
                size: 16
              })
            ]),
            u("div", lSe, [
              c[3] || (c[3] = u("b", null, "Delete this thread?", -1)),
              u("span", null, E(o.value), 1)
            ]),
            u("div", dSe, [
              u("button", {
                class: "cm-ask-btn",
                "data-testid": "thread-delete-keep",
                onClick: c[0] || (c[0] = (h) => m(t).answerDelete(!1))
              }, "Keep it"),
              u("button", {
                ref_key: "confirmBtn",
                ref: r,
                class: "cm-ask-btn is-danger",
                "data-testid": "thread-delete-confirm",
                onClick: c[1] || (c[1] = (h) => m(t).answerDelete(!0))
              }, "Delete thread", 512)
            ])
          ], 512)
        ], 32)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), uSe = { key: 0 }, hSe = { key: 0 }, pSe = { key: 0 }, fSe = { key: 1 }, mSe = { key: 0 }, gSe = { key: 2 }, bSe = { key: 0 }, Gb = /* @__PURE__ */ Pe({
  __name: "ChatText",
  props: {
    text: {},
    caret: { type: Boolean }
  },
  setup(n) {
    const e = n;
    function t(s) {
      const o = [], r = s.split(/(\*\*[^*]+\*\*)/g);
      for (const a of r)
        a && (/^\*\*[^*]+\*\*$/.test(a) ? o.push({ bold: !0, text: a.slice(2, -2) }) : o.push({ bold: !1, text: a }));
      return o;
    }
    const i = I(() => {
      const s = [];
      for (const o of String(e.text || "").split(/\n{2,}/)) {
        const r = o.split(`
`).filter((l) => l.trim() !== "");
        if (!r.length) continue;
        let a = null;
        for (const l of r) {
          const d = /^\s*[-•]\s+(.*)$/.exec(l), c = /^\s*\d+[.)]\s+(.*)$/.exec(l);
          if (d || c) {
            const h = d ? "ul" : "ol";
            (!a || a.kind !== h) && (a = { kind: h, items: [] }, s.push(a)), a.items.push(t((d || c)[1]));
          } else
            (!a || a.kind !== "p") && (a = { kind: "p", lines: [] }, s.push(a)), a.lines.push(t(l));
        }
      }
      return s;
    });
    return (s, o) => (g(), b("div", {
      class: G(["ch-text", { "has-caret": n.caret }])
    }, [
      (g(!0), b(j, null, ge(i.value, (r, a) => (g(), b(j, { key: a }, [
        r.kind === "p" ? (g(), b("p", uSe, [
          (g(!0), b(j, null, ge(r.lines, (l, d) => (g(), b(j, { key: d }, [
            d ? (g(), b("br", hSe)) : z("", !0),
            (g(!0), b(j, null, ge(l, (c, h) => (g(), b(j, { key: h }, [
              c.bold ? (g(), b("b", pSe, E(c.text), 1)) : (g(), b(j, { key: 1 }, [
                Y(E(c.text), 1)
              ], 64))
            ], 64))), 128))
          ], 64))), 128))
        ])) : r.kind === "ul" ? (g(), b("ul", fSe, [
          (g(!0), b(j, null, ge(r.items, (l, d) => (g(), b("li", { key: d }, [
            (g(!0), b(j, null, ge(l, (c, h) => (g(), b(j, { key: h }, [
              c.bold ? (g(), b("b", mSe, E(c.text), 1)) : (g(), b(j, { key: 1 }, [
                Y(E(c.text), 1)
              ], 64))
            ], 64))), 128))
          ]))), 128))
        ])) : (g(), b("ol", gSe, [
          (g(!0), b(j, null, ge(r.items, (l, d) => (g(), b("li", { key: d }, [
            (g(!0), b(j, null, ge(l, (c, h) => (g(), b(j, { key: h }, [
              c.bold ? (g(), b("b", bSe, E(c.text), 1)) : (g(), b(j, { key: 1 }, [
                Y(E(c.text), 1)
              ], 64))
            ], 64))), 128))
          ]))), 128))
        ]))
      ], 64))), 128))
    ], 2));
  }
}), vSe = { class: "ch-plan-head" }, ySe = { class: "ch-plan-mark" }, xSe = { class: "ch-plan-titles" }, wSe = { class: "ch-plan-eyebrow" }, kSe = {
  key: 0,
  class: "dot"
}, _Se = { class: "ch-plan-title" }, SSe = { class: "ch-plan-est" }, MSe = ["title"], TSe = {
  key: 0,
  class: "ch-plan-time"
}, CSe = {
  key: 0,
  class: "ch-plan-summary"
}, ISe = { class: "ch-sessions" }, ASe = { class: "ch-session-icon" }, PSe = { class: "ch-session-main" }, ESe = { class: "ch-session-name" }, RSe = { class: "n" }, zSe = {
  key: 0,
  class: "ch-tag",
  title: "A session already in the frame"
}, $Se = {
  key: 1,
  class: "ch-tag is-new",
  title: "The plan adds this session to the frame"
}, DSe = { class: "ch-session-meta" }, OSe = { class: "tk" }, LSe = {
  key: 0,
  class: "ch-session-settings"
}, BSe = {
  key: 1,
  class: "ch-session-why"
}, FSe = ["title", "onClick"], NSe = ["title"], USe = {
  key: 1,
  class: "ch-actions",
  "data-testid": "plan-steps"
}, GSe = { class: "ch-action-icon" }, jSe = { class: "ch-action-main" }, HSe = { class: "ch-action-text" }, VSe = {
  key: 0,
  class: "ch-action-detail"
}, WSe = {
  key: 2,
  class: "ch-plan-foot"
}, qSe = { class: "ch-plan-breakdown" }, KSe = ["disabled"], YSe = ["disabled"], XSe = {
  key: 3,
  class: "ch-plan-foot is-running"
}, JSe = { class: "ch-plan-breakdown" }, ZSe = { class: "ch-plan-breakdown" }, F4 = /* @__PURE__ */ Pe({
  __name: "PlanCard",
  props: {
    plan: {},
    chatId: {},
    preview: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = os(t), s = I(() => AU(e.plan)), o = I(() => e.plan.status === "proposed"), r = I(() => e.plan.status === "running"), a = I(() => r.value && i.isRunningHere(e.plan.id)), l = I(() => {
      const M = e.plan, _ = M.status === "proposed" ? "Proposed plan" : M.status === "running" ? "Running plan" : "Plan", T = s.value;
      return [_, T.sessions === 1 ? "1 session" : T.sessions + " sessions", T.runs === 1 ? "1 run" : T.runs + " runs"];
    }), d = I(() => {
      const M = s.value;
      return (M.results === 1 ? "1 image" : M.results + " images") + (e.plan.secs ? " · about " + Uw(e.plan.secs) : "");
    });
    function c(M) {
      const _ = [];
      for (const T of M.runs) for (const k of T.images || []) _.push(k.url);
      return _;
    }
    function h(M) {
      return Nl[M.kitId] || "Image";
    }
    const f = /* @__PURE__ */ W({});
    function p(M) {
      f.value = { ...f.value, [M]: !f.value[M] };
    }
    function y(M) {
      return M === "done" ? "CircleCheck" : M === "failed" ? "CircleAlert" : M === "running" ? "Loader2" : "Circle";
    }
    function v() {
      e.preview || i.runPlan(e.chatId, e.plan.id);
    }
    function x() {
      i.cancelPlan(e.chatId, e.plan.id);
    }
    function w() {
      const M = i.chat(e.chatId), _ = M ? i.frameOf(M) : null;
      _ && i.showFrame(_, !0);
      const T = e.plan.sessions.map((k) => k.toolId || k.addedId).filter((k) => !!k && !!t.store.get(k));
      T.length > 1 && t.select(T);
    }
    const S = I(() => {
      const M = e.plan, _ = s.value;
      return M.status === "done" ? "Done: " + (M.results === 1 ? "1 result" : (M.results || 0) + " results") + (M.ranBy ? " · run by " + M.ranBy : "") : M.status === "cancelled" ? M.error || "Cancelled. Nothing was spent." : M.status === "failed" ? "Stopped: " + (M.error || "something went wrong") : M.status === "stopped" ? "Stopped: " + (M.error || "it didn't finish") + (M.results ? " (" + M.results + " of " + _.results + " results made it)" : "") : "";
    });
    return (M, _) => (g(), b("div", {
      class: G(["ch-plan", ["is-" + n.plan.status, { "is-preview": n.preview }]]),
      "data-testid": "plan-card"
    }, [
      u("div", vSe, [
        u("span", ySe, [
          C($, {
            name: "Route",
            size: 13
          })
        ]),
        u("span", xSe, [
          u("span", wSe, [
            (g(!0), b(j, null, ge(l.value, (T, k) => (g(), b(j, { key: k }, [
              k ? (g(), b("span", kSe, "·")) : z("", !0),
              Y(E(T), 1)
            ], 64))), 128))
          ]),
          u("span", _Se, E(n.plan.title), 1)
        ]),
        u("span", SSe, [
          u("span", {
            class: G(["ch-plan-cost", { "is-estimate": o.value }]),
            title: o.value ? "Estimated from each tool's price rules, before anything runs" : "Estimated cost",
            "data-testid": "plan-cost"
          }, [
            C($, {
              name: "Tokens",
              size: 11
            }),
            Y(E(m(hc)(n.plan.tokens)), 1)
          ], 10, MSe),
          n.plan.secs ? (g(), b("span", TSe, [
            C($, {
              name: "Clock",
              size: 9
            }),
            Y("~" + E(m(Uw)(n.plan.secs)), 1)
          ])) : z("", !0)
        ])
      ]),
      n.plan.summary ? (g(), b("div", CSe, E(n.plan.summary), 1)) : z("", !0),
      u("div", ISe, [
        (g(!0), b(j, null, ge(n.plan.sessions, (T) => (g(), b("div", {
          key: T.key,
          class: "ch-session"
        }, [
          u("span", ASe, [
            C($, {
              name: h(T),
              size: 13
            }, null, 8, ["name"])
          ]),
          u("span", PSe, [
            u("span", ESe, [
              u("span", RSe, E(T.name), 1),
              T.toolId ? (g(), b("span", zSe, "In frame")) : (g(), b("span", $Se, "New"))
            ]),
            u("span", DSe, [
              T.model !== T.name ? (g(), b(j, { key: 0 }, [
                Y(E(T.model), 1),
                _[0] || (_[0] = u("span", { class: "sep" }, "·", -1))
              ], 64)) : z("", !0),
              Y(E(T.runs.length === 1 ? "1 run" : T.runs.length + " runs"), 1),
              _[1] || (_[1] = u("span", { class: "sep" }, "·", -1)),
              Y(E(T.n === 1 ? "1 result" : T.n + " results") + E(T.runs.length > 1 ? " each" : ""), 1),
              _[2] || (_[2] = u("span", { class: "sep" }, "·", -1)),
              u("span", OSe, [
                C($, {
                  name: "Tokens",
                  size: 9
                }),
                Y(E(m(hc)(T.tokens)), 1)
              ])
            ]),
            T.settings ? (g(), b("span", LSe, E(T.settings), 1)) : z("", !0),
            T.why && o.value ? (g(), b("span", BSe, [
              C($, {
                name: "CornerDownRight",
                size: 10
              }),
              Y(E(T.why), 1)
            ])) : z("", !0),
            u("button", {
              class: G(["ch-session-prompt", { "is-open": f.value[T.key] }]),
              title: f.value[T.key] ? "Show less" : "Show the whole prompt",
              onClick: (k) => p(T.key)
            }, "“" + E(T.prompt) + "”", 11, FSe),
            c(T).length ? (g(), b("span", {
              key: 2,
              class: "ch-session-inputs",
              title: c(T).length === 1 ? "The image this run takes" : "One image per run"
            }, [
              (g(!0), b(j, null, ge(c(T).slice(0, 8), (k, P) => (g(), b("span", {
                key: P,
                class: "th",
                style: ce({ backgroundImage: 'url("' + m(Bt)(k) + '")' })
              }, null, 4))), 128))
            ], 8, NSe)) : z("", !0)
          ])
        ]))), 128))
      ]),
      n.plan.steps && n.plan.steps.length ? (g(), b("div", USe, [
        (g(!0), b(j, null, ge(n.plan.steps, (T) => (g(), b("div", {
          key: T.id,
          class: G(["ch-action", "is-" + T.status])
        }, [
          u("span", GSe, [
            C($, {
              name: y(T.status),
              size: 12,
              spin: T.status === "running"
            }, null, 8, ["name", "spin"])
          ]),
          u("span", jSe, [
            u("span", HSe, E(T.text), 1),
            T.detail ? (g(), b("span", VSe, E(T.detail), 1)) : z("", !0)
          ])
        ], 2))), 128))
      ])) : z("", !0),
      o.value ? (g(), b("div", WSe, [
        u("span", qSe, E(d.value), 1),
        u("button", {
          class: "ch-plan-cancel",
          disabled: n.preview,
          "data-testid": "plan-cancel",
          onClick: x
        }, "Cancel", 8, KSe),
        u("button", {
          class: "ch-plan-run",
          disabled: n.preview,
          "data-testid": "plan-run",
          onClick: v
        }, [
          C($, {
            name: "Play",
            size: 12
          }),
          _[3] || (_[3] = Y("Run plan", -1)),
          _[4] || (_[4] = u("span", { class: "sep" }, "·", -1)),
          C($, {
            name: "Tokens",
            size: 11
          }),
          Y(E(m(hc)(n.plan.tokens)), 1)
        ], 8, YSe)
      ])) : r.value ? (g(), b("div", XSe, [
        C($, {
          name: "Loader2",
          size: 12,
          spin: ""
        }),
        u("span", JSe, "Running" + E(n.plan.ranBy ? " · run by " + n.plan.ranBy : ""), 1),
        a.value ? (g(), b("button", {
          key: 0,
          class: "ch-plan-cancel",
          title: "Stop before the next step; runs already sent still finish",
          onClick: x
        }, "Stop")) : z("", !0)
      ])) : (g(), b("div", {
        key: 4,
        class: G(["ch-plan-foot", "is-" + n.plan.status])
      }, [
        C($, {
          name: n.plan.status === "done" ? "CircleCheck" : n.plan.status === "cancelled" ? "CircleX" : "CircleAlert",
          size: 12
        }, null, 8, ["name"]),
        u("span", ZSe, E(S.value), 1),
        n.plan.status === "done" || n.plan.results && n.plan.status !== "cancelled" ? (g(), b("button", {
          key: 0,
          class: "ch-plan-show",
          onClick: w
        }, [
          C($, {
            name: "Focus",
            size: 12
          }),
          _[5] || (_[5] = Y("Show on the board", -1))
        ])) : z("", !0)
      ], 2))
    ], 2));
  }
}), QSe = {
  class: "ch-picks",
  "data-testid": "chat-picks"
}, eMe = { class: "ch-pick-main" }, tMe = { class: "ch-pick-top" }, nMe = { class: "ch-pick-name" }, iMe = {
  key: 0,
  class: "ch-pick-price",
  title: "Tokens a result at its default settings"
}, sMe = { class: "ch-pick-why" }, oMe = {
  key: 0,
  class: "ch-pick-kit"
}, rMe = ["disabled", "title", "onClick"], N4 = /* @__PURE__ */ Pe({
  __name: "ToolPicks",
  props: {
    picks: {},
    chatId: {},
    preview: { type: Boolean }
  },
  setup(n) {
    const e = n, { board: t } = Ze(), i = os(t), s = I(() => {
      const r = new b8(t.catalog.value, !!t.user.isAdmin);
      return e.picks.map((a) => {
        const l = r.get(a.modelId), d = l ? r.price(l, { prompt: "x", n: 1 }, 1) : null, c = l ? r.kitFor(l, "generate") : null;
        return {
          ...a,
          on: !!l,
          avatar: l && l.model.avatar ? l.model.avatar : "",
          icon: c && Nl[c.id] || "Image",
          kit: c ? c.name : "",
          price: d == null ? "" : hc(d) + (l && l.model.tokensLabel.includes("+") ? "+" : "")
        };
      });
    });
    function o(r) {
      e.preview || i.addTool(e.chatId, r);
    }
    return (r, a) => (g(), b("div", QSe, [
      (g(!0), b(j, null, ge(s.value, (l) => (g(), b("div", {
        key: l.modelId,
        class: G(["ch-pick", { "is-off": !l.on }])
      }, [
        u("span", {
          class: "ch-pick-pic",
          style: ce(l.avatar ? { backgroundImage: 'url("' + l.avatar + '")' } : void 0)
        }, [
          l.avatar ? z("", !0) : (g(), Ie($, {
            key: 0,
            name: l.icon,
            size: 14
          }, null, 8, ["name"]))
        ], 4),
        u("div", eMe, [
          u("div", tMe, [
            u("span", nMe, E(l.name), 1),
            l.price ? (g(), b("span", iMe, E(l.price), 1)) : z("", !0)
          ]),
          u("div", sMe, E(l.why), 1),
          l.kit ? (g(), b("div", oMe, E(l.kit), 1)) : z("", !0)
        ]),
        l.on ? (g(), b("button", {
          key: 0,
          class: "ch-pick-try",
          disabled: n.preview,
          title: "Add a " + l.name + " session to this frame, ready for a prompt",
          "data-testid": "chat-pick-try",
          onClick: (d) => o(l.modelId)
        }, [
          C($, {
            name: "Plus",
            size: 11
          }),
          a[0] || (a[0] = Y("Try it", -1))
        ], 8, rMe)) : z("", !0)
      ], 2))), 128))
    ]));
  }
}), aMe = {
  class: "ch-ideas",
  "data-testid": "chat-ideas"
}, lMe = ["disabled", "title", "onClick"], dMe = { class: "ch-idea-n" }, cMe = { class: "ch-idea-main" }, uMe = { class: "ch-idea-title" }, hMe = { class: "ch-idea-pitch" }, pMe = {
  key: 0,
  class: "ch-idea-tool"
}, U4 = /* @__PURE__ */ Pe({
  __name: "IdeaCards",
  props: {
    ideas: {},
    preview: { type: Boolean }
  },
  emits: ["pick"],
  setup(n, { emit: e }) {
    const t = n, i = e;
    function s(o) {
      t.preview || i("pick", `Let's go with "` + o.title + '": ' + o.pitch + (o.tool ? " Use " + o.tool + "." : "") + " Make a plan for it.");
    }
    return (o, r) => (g(), b("div", aMe, [
      (g(!0), b(j, null, ge(n.ideas, (a, l) => (g(), b("button", {
        key: a.title,
        class: "ch-idea",
        disabled: n.preview,
        title: "Plan “" + a.title + "”",
        onClick: (d) => s(a)
      }, [
        u("span", dMe, E(l + 1), 1),
        u("span", cMe, [
          u("span", uMe, E(a.title), 1),
          u("span", hMe, E(a.pitch), 1),
          a.tool ? (g(), b("span", pMe, [
            C($, {
              name: "Sparkles",
              size: 10
            }),
            Y(E(a.tool), 1)
          ])) : z("", !0)
        ]),
        C($, {
          class: "ch-idea-go",
          name: "ChevronRight",
          size: 13
        })
      ], 8, lMe))), 128))
    ]));
  }
}), fMe = { class: "ch-head" }, mMe = { class: "ch-head-mark" }, gMe = { class: "ch-head-titles ch-switch" }, bMe = ["title", "aria-expanded"], vMe = { class: "t" }, yMe = {
  key: 0,
  class: "ch-switch-menu",
  role: "menu"
}, xMe = ["onClick"], wMe = { class: "m" }, kMe = { class: "n" }, _Me = { class: "f" }, SMe = { class: "c" }, MMe = { class: "ch-head-sub" }, TMe = ["title"], CMe = {
  class: "ch-head-n",
  "data-testid": "chat-in-context"
}, IMe = {
  class: "ch-head-n",
  "data-testid": "chat-in-context"
}, AMe = {
  key: 0,
  class: "ch-context",
  "data-testid": "chat-context"
}, PMe = ["title", "onClick"], EMe = {
  key: 0,
  class: "ch-ctxchip is-empty"
}, RMe = {
  key: 1,
  class: "ch-context is-picks",
  "data-testid": "chat-picks"
}, zMe = ["title", "onClick"], $Me = { class: "nm" }, DMe = ["aria-label", "onClick"], OMe = {
  key: 2,
  class: "ch-context is-none"
}, LMe = {
  key: 0,
  class: "ch-intro"
}, BMe = { class: "ch-intro-mark" }, FMe = { class: "ch-intro-title" }, NMe = {
  key: 0,
  class: "ch-intro-sub"
}, UMe = {
  key: 1,
  class: "ch-intro-sub"
}, GMe = {
  key: 2,
  class: "ch-chips is-start"
}, jMe = ["onClick"], HMe = { class: "ch-msg-meta" }, VMe = { class: "ch-bubble" }, WMe = {
  key: 1,
  class: "ch-msg is-agent"
}, qMe = { class: "ch-ai-mark" }, KMe = { class: "ch-ai-body" }, YMe = ["title"], XMe = {
  key: 5,
  class: "ch-chips",
  "data-testid": "chat-chips"
}, JMe = ["onClick"], ZMe = {
  key: 1,
  class: "ch-msg is-agent is-live",
  "data-testid": "chat-live"
}, QMe = { class: "ch-ai-mark is-busy" }, eTe = { class: "ch-ai-body" }, tTe = {
  key: 1,
  class: "ch-status"
}, nTe = {
  key: 2,
  class: "ch-plan is-skeleton"
}, iTe = { class: "ch-composer" }, sTe = ["placeholder", "disabled", "readonly", "maxlength"], oTe = { class: "ch-comp-foot" }, rTe = {
  key: 0,
  class: "ch-model"
}, aTe = ["aria-expanded", "title"], lTe = { class: "t" }, dTe = {
  key: 0,
  class: "ch-model-menu",
  role: "menu"
}, cTe = ["aria-checked", "data-testid", "onClick"], uTe = { class: "m" }, hTe = { class: "n" }, pTe = { class: "f" }, fTe = ["aria-checked"], mTe = {
  key: 1,
  class: "ch-model-note"
}, gTe = ["title"], bTe = ["disabled"], vTe = /* @__PURE__ */ Pe({
  __name: "ChatPanel",
  setup(n) {
    const { board: e } = Ze(), t = os(e), i = t.open, s = I(() => i.value ? t.frameOf(i.value) : null), o = I(() => i.value ? t.contextOf(i.value) : null), r = I(() => o.value ? v8(o.value) : 0), a = I(() => {
      if (e.docRev.value, !i.value || s.value) return [];
      const se = new Set(i.value.contextIds || []);
      return e.ui.selection.filter((ae) => {
        var ye;
        return !se.has(ae) && ((ye = e.store.get(ae)) == null ? void 0 : ye.type) === "image";
      });
    }), l = I(() => (e.docRev.value, !i.value || s.value ? [] : t.picksOf(i.value).map((se) => ({
      id: se.id,
      label: se.type === "image" ? se.label && se.label !== "placed_image" ? se.label : "Picture" : se.type === "tool" ? se.name : "Note",
      icon: se.type === "image" ? "Image" : se.type === "tool" ? "Box" : "StickyNote",
      thumb: se.type === "image" ? se.src : null
    })))), d = I(() => i.value ? i.value.messages || [] : []), c = I(() => i.value && t.live[i.value.id] || null), h = dr(), f = I(() => {
      const se = o.value;
      if (!se) return [];
      const ae = [];
      return se.images.length && ae.push({
        key: "images",
        icon: "Image",
        label: se.images.length === 1 ? "1 image" : se.images.length + " images",
        ids: se.images.map((ye) => ye.id),
        title: se.images.map((ye, Oe) => "Image " + (Oe + 1) + (ye.model ? ": " + ye.model : "") + (ye.prompt ? ", “" + ye.prompt.slice(0, 60) + (ye.prompt.length > 60 ? "…" : "") + "”" : "")).join(`
`)
      }), se.sessions.length && ae.push({
        key: "sessions",
        icon: Nl[se.sessions[0].kitId] || "Image",
        label: se.sessions.length === 1 ? "1 session" : se.sessions.length + " sessions",
        ids: se.sessions.map((ye) => ye.id),
        title: se.sessions.map((ye) => ye.name + " (" + ye.model + ")").join(`
`)
      }), se.notes.length && ae.push({
        key: "notes",
        icon: "StickyNote",
        label: se.notes.length === 1 ? "1 note" : se.notes.length + " notes",
        ids: se.notes.map((ye) => ye.id),
        title: `Notes are standing instructions:
` + se.notes.map((ye) => "“" + ye.text.slice(0, 80) + "”").join(`
`)
      }), ae;
    });
    function p(se) {
      const ae = se.filter((ye) => !!e.store.get(ye));
      ae.length && e.select(ae);
    }
    const y = I(() => {
      const se = o.value;
      if (!se) return [];
      const ae = [];
      return se.images.length && ae.push({ label: "Make these night scenes", send: "Please change " + (se.images.length === 1 ? "this image" : "all " + se.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }), se.sessions.length && ae.push({ label: "Run a new prompt through these", send: "Now try: a glass pavilion in a pine forest at dawn" }), ae.push({ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }), se.images.length || ae.push({ label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }), ae.push({ label: "Prompting tips", send: "How should I prompt Ideogram for signage text?" }), ae.slice(0, 4);
    }), v = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ W(""), w = /* @__PURE__ */ W(null), S = /* @__PURE__ */ W(null), M = tx({
      board: e,
      field: "chat",
      sessionId: () => i.value ? i.value.id : null,
      value: () => x.value,
      write: (se) => {
        x.value = se, nt(J);
      }
    }), _ = I(() => M.ghost.value || kU(o.value)), T = I(() => t.brain.value), k = I(() => t.agentStatus.value), P = I(() => k.value && k.value.ready && k.value.models || []), A = I(() => !t.guided && (t.canSimulate || P.value.length > 0)), R = t.showCosts, D = /* @__PURE__ */ W(!1), O = I(() => {
      const se = P.value.find((ae) => ae.id === T.value);
      return se ? se.label : T.value === Ci ? "Simulated" : k.value ? "Unavailable" : "Connecting…";
    }), F = I(() => {
      const se = k.value;
      return se ? se.ready ? "" : se.reason || "No model is set up here." : t.asksAgent ? "Checking which models can answer…" : "";
    });
    function ie(se) {
      D.value = !1, t.setBrain(se);
    }
    function ee(se) {
      return se >= 1e3 ? (Math.round(se / 100) / 10).toLocaleString("en-US") + "K" : String(se);
    }
    function me(se) {
      return se == null ? "" : "≈" + (se < 10 ? Math.round(se * 10) / 10 : Math.round(se)).toLocaleString("en-US");
    }
    function L(se) {
      return "$" + se.input + " / $" + se.output + " per 1M";
    }
    const N = I(() => i.value && i.value.spend || null), K = I(() => {
      const se = N.value;
      return !R || !se || !se.turns ? "" : "This chat " + hg(se.usd) + " at the API · " + me(se.credits) + " tokens · " + se.turns + (se.turns === 1 ? " answer" : " answers");
    }), B = I(() => {
      if (!R) return;
      const se = N.value;
      if (!se) return MU;
      const ae = Object.entries(se.byModel).map(([Ve, Ue]) => Ve + ": " + hg(Ue.usd) + " over " + Ue.turns + (Ue.turns === 1 ? " answer" : " answers")), ye = i.value, Oe = ye ? t.usage[ye.id] : null;
      return Oe && ae.push("Last answer: " + Math.round(Oe.ms / 100) / 10 + "s, " + ee(Oe.input) + " tokens in (" + ee(Oe.cached) + " cached), " + ee(Oe.output) + " out"), ae.push("Tokens are RunDiffusion tokens at $0.0006 each: an estimate, nothing is charged."), ae.join(`
`);
    }), re = I(() => K.value || "nothing runs until Run plan"), H = I(() => !!x.value.trim() && !!s.value && !c.value);
    Ee(() => i.value ? i.value.id : null, (se, ae) => {
      ae && v.set(ae, x.value), x.value = se && v.get(se) || "", nt(() => {
        J(), U(!0), w.value && w.value.focus({ preventScroll: !0 });
      });
    }, { immediate: !0 });
    function J() {
      const se = w.value;
      se && (se.style.height = "auto", se.style.height = Math.min(160, Math.max(44, se.scrollHeight)) + "px");
    }
    function Q(se) {
      const ae = i.value, ye = (se != null ? se : x.value).trim();
      !ae || !ye || c.value || !s.value || (se == null && (x.value = "", nt(J)), t.send(ae.id, ye), nt(() => U(!0)));
    }
    function ne(se) {
      Q(se.send || se.label);
    }
    function ue(se) {
      se.key === "Enter" && !se.shiftKey && !se.isComposing && (se.preventDefault(), Q());
    }
    const Z = I(() => {
      for (let se = d.value.length - 1; se >= 0; se--) if (d.value[se].role === "agent") return d.value[se].id;
      return null;
    }), te = I(() => d.value.length > 0 && d.value[d.value.length - 1].role === "agent");
    function we(se) {
      return se.role === "user" && se.authorId === e.user.uid;
    }
    function Fe(se) {
      return h.value, Jn(se);
    }
    let Me = !0;
    function he() {
      const se = S.value;
      se && (Me = se.scrollTop + se.clientHeight > se.scrollHeight - 60);
    }
    function U(se = !1) {
      const ae = S.value;
      !ae || !se && !Me || (ae.scrollTop = ae.scrollHeight);
    }
    Ee(() => [d.value.length, c.value ? c.value.text.length : -1, c.value && c.value.plan ? 1 : 0, c.value ? c.value.status : ""], () => nt(() => U())), Ee(() => JSON.stringify(d.value.map((se) => se.plan ? (se.plan.steps || []).length + se.plan.status : "")), () => nt(() => U()));
    function q() {
      t.close();
    }
    const oe = /* @__PURE__ */ W(!1), de = I(() => (e.docRev.value, t.allChats().map((se) => {
      const ae = t.frameOf(se);
      return { id: se.id, name: se.name, frame: ae ? ae.title : "Not in a frame", n: F8(se) };
    })));
    function pe(se) {
      oe.value = !1, e.ui.selection = [se], e.ui.chatOpen = se;
    }
    function Ce(se) {
      const ae = se.target;
      oe.value && ae && !ae.closest(".ch-switch") && (oe.value = !1), D.value && ae && !ae.closest(".ch-model") && (D.value = !1);
    }
    window.addEventListener("pointerdown", Ce, !0), We(() => window.removeEventListener("pointerdown", Ce, !0));
    function Be() {
      s.value && t.showFrame(s.value, !0);
    }
    function be(se) {
      if (se.key === "Escape") {
        se.stopPropagation();
        const ae = document.activeElement;
        ae && ae.tagName === "TEXTAREA" ? ae.blur() : q();
      }
    }
    return it(() => nt(() => U(!0))), We(() => {
      i.value && v.set(i.value.id, x.value);
    }), (se, ae) => m(i) ? (g(), b("aside", {
      key: 0,
      class: "ch-panel",
      "data-testid": "chat-panel",
      onPointerdown: ae[8] || (ae[8] = Te(() => {
      }, ["stop"])),
      onKeydown: be
    }, [
      u("header", fMe, [
        u("span", mMe, [
          C($, {
            name: "MessagesSquare",
            size: 15
          })
        ]),
        u("div", gMe, [
          u("button", {
            class: G(["ch-head-name", { "has-more": de.value.length > 1 }]),
            title: de.value.length > 1 ? "Switch to another chat on this board" : m(i).name,
            "aria-expanded": oe.value,
            "data-testid": "chat-switch",
            onClick: ae[0] || (ae[0] = (ye) => de.value.length > 1 && (oe.value = !oe.value))
          }, [
            u("span", vMe, E(m(i).name), 1),
            de.value.length > 1 ? (g(), Ie($, {
              key: 0,
              name: "ChevronDown",
              size: 12
            })) : z("", !0)
          ], 10, bMe),
          oe.value ? (g(), b("div", yMe, [
            ae[9] || (ae[9] = u("div", { class: "ch-switch-eyebrow" }, "Chats on this board", -1)),
            (g(!0), b(j, null, ge(de.value, (ye) => (g(), b("button", {
              key: ye.id,
              class: G(["ch-switch-row", { on: ye.id === m(i).id }]),
              role: "menuitem",
              onClick: (Oe) => pe(ye.id)
            }, [
              C($, {
                name: "MessagesSquare",
                size: 13
              }),
              u("span", wMe, [
                u("span", kMe, E(ye.name), 1),
                u("span", _Me, E(ye.frame), 1)
              ]),
              u("span", SMe, E(ye.n), 1)
            ], 10, xMe))), 128))
          ])) : z("", !0),
          u("div", MMe, [
            s.value ? (g(), b(j, { key: 0 }, [
              u("span", {
                class: "ch-head-frame",
                title: s.value.title
              }, "in " + E(s.value.title), 9, TMe),
              ae[10] || (ae[10] = u("span", { class: "dot" }, "·", -1)),
              u("span", CMe, E(r.value) + " in context", 1)
            ], 64)) : (g(), b(j, { key: 1 }, [
              ae[12] || (ae[12] = Y(" Not in a frame", -1)),
              l.value.length ? (g(), b(j, { key: 0 }, [
                ae[11] || (ae[11] = u("span", { class: "dot" }, "·", -1)),
                u("span", IMe, E(r.value) + " picked", 1)
              ], 64)) : z("", !0)
            ], 64))
          ])
        ]),
        u("button", {
          class: "ch-iconbtn",
          title: "Show the frame",
          "aria-label": "Show the frame",
          onClick: Be
        }, [
          C($, {
            name: "Focus",
            size: 14
          })
        ]),
        u("button", {
          class: "ch-iconbtn",
          title: "Close (Esc)",
          "aria-label": "Close the chat",
          "data-testid": "chat-close",
          onClick: q
        }, [
          C($, {
            name: "X",
            size: 15
          })
        ])
      ]),
      s.value ? (g(), b("div", AMe, [
        (g(!0), b(j, null, ge(f.value, (ye) => (g(), b("button", {
          key: ye.key,
          class: "ch-ctxchip",
          title: ye.title + `

Click to select them on the board.`,
          onClick: (Oe) => p(ye.ids)
        }, [
          C($, {
            name: ye.icon,
            size: 11
          }, null, 8, ["name"]),
          Y(E(ye.label), 1)
        ], 8, PMe))), 128)),
        f.value.length ? z("", !0) : (g(), b("span", EMe, [
          C($, {
            name: "Frame",
            size: 11
          }),
          ae[13] || (ae[13] = Y("Empty frame", -1))
        ]))
      ])) : l.value.length ? (g(), b("div", RMe, [
        (g(!0), b(j, null, ge(l.value, (ye) => (g(), b("span", {
          key: ye.id,
          class: "ch-ctxchip is-pick",
          title: ye.label + `

Click to select it on the board.`,
          onClick: (Oe) => p([ye.id])
        }, [
          ye.thumb ? (g(), b("span", {
            key: 0,
            class: "th",
            style: ce({ backgroundImage: 'url("' + ye.thumb + '")' })
          }, null, 4)) : (g(), Ie($, {
            key: 1,
            name: ye.icon,
            size: 11
          }, null, 8, ["name"])),
          u("span", $Me, E(ye.label), 1),
          u("button", {
            class: "x",
            title: "Take it out",
            "aria-label": "Take " + ye.label + " out",
            "data-testid": "chat-pick-remove",
            onClick: Te((Oe) => m(t).togglePick(m(i).id, ye.id), ["stop"])
          }, [
            C($, {
              name: "X",
              size: 10
            })
          ], 8, DMe)
        ], 8, zMe))), 128)),
        a.value.length ? (g(), b("button", {
          key: 0,
          class: "ch-ctxchip is-add",
          "data-testid": "chat-add-selected",
          onClick: ae[1] || (ae[1] = (ye) => m(t).addPicks(m(i).id, a.value))
        }, [
          C($, {
            name: "Plus",
            size: 11
          }),
          Y("Add the " + E(a.value.length === 1 ? "selected picture" : a.value.length + " selected pictures"), 1)
        ])) : z("", !0),
        ae[14] || (ae[14] = u("span", { class: "ch-picks-hint" }, "Shift-click more on the board. Its plan runs in a frame it makes round them.", -1))
      ])) : (g(), b("div", OMe, [
        ae[15] || (ae[15] = Y(" Not in a frame. Shift-click pictures on the board to give it something to work with, or move it into a frame. ", -1)),
        a.value.length ? (g(), b("button", {
          key: 0,
          class: "ch-ctxchip is-add",
          "data-testid": "chat-add-selected",
          onClick: ae[2] || (ae[2] = (ye) => m(t).addPicks(m(i).id, a.value))
        }, [
          C($, {
            name: "Plus",
            size: 11
          }),
          Y("Add the " + E(a.value.length === 1 ? "selected picture" : a.value.length + " selected pictures"), 1)
        ])) : z("", !0)
      ])),
      u("div", {
        ref_key: "scroller",
        ref: S,
        class: "ch-scroll",
        onScrollPassive: he
      }, [
        !d.value.length && !c.value ? (g(), b("div", LMe, [
          u("span", BMe, [
            C($, {
              name: "Sparkles",
              size: 16
            })
          ]),
          u("div", FMe, E(s.value ? r.value ? "Ask about “" + s.value.title + "”" : "What should we build in “" + s.value.title + "”?" : l.value.length ? "Ask about what you picked" : "Pick what it works with"), 1),
          s.value ? (g(), b("div", NMe, " Everything in this frame is my context. I can set up tool sessions here and run them for you, always with a priced plan you approve first. ")) : (g(), b("div", UMe, " Shift-click pictures on the board, and they're my context. When I run a plan, I put them in a frame with this chat first. Or move this chat into a frame. ")),
          (s.value || l.value.length) && !m(t).guided ? (g(), b("div", GMe, [
            (g(!0), b(j, null, ge(y.value, (ye) => (g(), b("button", {
              key: ye.label,
              class: "ch-chip",
              onClick: (Oe) => ne(ye)
            }, E(ye.label), 9, jMe))), 128))
          ])) : z("", !0)
        ])) : z("", !0),
        (g(!0), b(j, null, ge(d.value, (ye) => (g(), b(j, {
          key: ye.id
        }, [
          ye.role === "user" ? (g(), b("div", {
            key: 0,
            class: G(["ch-msg is-user", { "is-theirs": !we(ye) }])
          }, [
            u("div", HMe, [
              Y(E(we(ye) ? "You" : ye.author), 1),
              ae[16] || (ae[16] = u("span", { class: "dot" }, "·", -1)),
              Y(E(Fe(ye.at)), 1)
            ]),
            u("div", VMe, [
              C(Gb, {
                text: ye.text
              }, null, 8, ["text"])
            ])
          ], 2)) : (g(), b("div", WMe, [
            u("span", qMe, [
              C($, {
                name: "Sparkles",
                size: 12
              })
            ]),
            u("div", KMe, [
              ye.text ? (g(), Ie(Gb, {
                key: 0,
                class: "ch-ai-text",
                text: ye.text
              }, null, 8, ["text"])) : z("", !0),
              ye.plan ? (g(), Ie(F4, {
                key: 1,
                plan: ye.plan,
                "chat-id": m(i).id
              }, null, 8, ["plan", "chat-id"])) : z("", !0),
              ye.picks && ye.picks.length ? (g(), Ie(N4, {
                key: 2,
                picks: ye.picks,
                "chat-id": m(i).id
              }, null, 8, ["picks", "chat-id"])) : z("", !0),
              ye.ideas && ye.ideas.length ? (g(), Ie(U4, {
                key: 3,
                ideas: ye.ideas,
                preview: !!c.value,
                onPick: Q
              }, null, 8, ["ideas", "preview"])) : z("", !0),
              m(R) && ye.usage ? (g(), b("div", {
                key: 4,
                class: "ch-msg-cost",
                title: ee(ye.usage.input) + " tokens in (" + ee(ye.usage.cached) + " cached), " + ee(ye.usage.output) + " out"
              }, [
                Y(E(ye.usage.model), 1),
                ae[18] || (ae[18] = u("span", { class: "dot" }, "·", -1)),
                Y(E(ye.usage.usd == null ? "price unknown" : m(hg)(ye.usage.usd)), 1),
                ye.usage.credits != null ? (g(), b(j, { key: 0 }, [
                  ae[17] || (ae[17] = u("span", { class: "dot" }, "·", -1)),
                  C($, {
                    name: "Tokens",
                    size: 10
                  }),
                  Y(E(me(ye.usage.credits)), 1)
                ], 64)) : z("", !0),
                ae[19] || (ae[19] = u("span", { class: "dot" }, "·", -1)),
                Y(E(Math.round(ye.usage.ms / 100) / 10) + "s ", 1)
              ], 8, YMe)) : z("", !0),
              ye.chips && ye.chips.length && ye.id === Z.value && te.value && !c.value && (!ye.plan || ye.plan.status === "proposed") ? (g(), b("div", XMe, [
                (g(!0), b(j, null, ge(ye.chips, (Oe) => (g(), b("button", {
                  key: Oe.label,
                  class: "ch-chip",
                  onClick: (Ve) => ne(Oe)
                }, E(Oe.label), 9, JMe))), 128))
              ])) : z("", !0)
            ])
          ]))
        ], 64))), 128)),
        c.value ? (g(), b("div", ZMe, [
          u("span", QMe, [
            C($, {
              name: "Sparkles",
              size: 12
            })
          ]),
          u("div", eTe, [
            c.value.text ? (g(), Ie(Gb, {
              key: 0,
              class: "ch-ai-text",
              text: m(N8)(c.value.text),
              caret: ""
            }, null, 8, ["text"])) : z("", !0),
            c.value.status ? (g(), b("div", tTe, E(c.value.status), 1)) : z("", !0),
            c.value.status === "Pricing the plan…" ? (g(), b("div", nTe, [...ae[20] || (ae[20] = [
              u("div", { class: "sk sk-a" }, null, -1),
              u("div", { class: "sk sk-b" }, null, -1),
              u("div", { class: "sk sk-c" }, null, -1)
            ])])) : z("", !0),
            c.value.plan ? (g(), Ie(F4, {
              key: 3,
              plan: c.value.plan,
              "chat-id": m(i).id,
              preview: ""
            }, null, 8, ["plan", "chat-id"])) : z("", !0),
            c.value.picks.length ? (g(), Ie(N4, {
              key: 4,
              picks: c.value.picks,
              "chat-id": m(i).id,
              preview: ""
            }, null, 8, ["picks", "chat-id"])) : z("", !0),
            c.value.ideas.length ? (g(), Ie(U4, {
              key: 5,
              ideas: c.value.ideas,
              preview: ""
            }, null, 8, ["ideas"])) : z("", !0)
          ])
        ])) : z("", !0)
      ], 544),
      u("footer", iTe, [
        u("div", {
          class: G(["ch-comp-box", { "is-off": !s.value }])
        }, [
          _t(u("textarea", {
            ref_key: "inputEl",
            ref: w,
            "onUpdate:modelValue": ae[3] || (ae[3] = (ye) => x.value = ye),
            class: G(["ch-comp-input", { "is-tour-ghost": !!m(M).ghost.value, "is-typing": m(M).typing.value }]),
            placeholder: _.value,
            disabled: !s.value,
            readonly: m(M).held.value || m(M).typing.value,
            maxlength: m(Ov),
            rows: "1",
            spellcheck: "true",
            "data-testid": "chat-input",
            onKeydown: ue,
            onInput: J
          }, null, 42, sTe), [
            [Zt, x.value]
          ]),
          m(M).ghost.value ? (g(), b("button", {
            key: 0,
            type: "button",
            tabindex: "-1",
            class: "up-cue is-tour ch-tour-cue",
            "data-testid": "chat-ghost-cue",
            onClick: ae[4] || (ae[4] = (ye) => m(e).tour && m(e).tour.press && m(e).tour.press("chat"))
          }, [...ae[21] || (ae[21] = [
            u("kbd", null, "Tab", -1),
            Y(" to write it in", -1)
          ])])) : z("", !0),
          u("div", oTe, [
            A.value ? (g(), b("div", rTe, [
              u("button", {
                class: G(["ch-model-btn", { "is-sim": T.value === m(Ci) }]),
                "aria-expanded": D.value,
                title: F.value || "Who answers",
                "data-testid": "chat-model",
                onClick: ae[5] || (ae[5] = (ye) => D.value = !D.value)
              }, [
                C($, {
                  name: T.value === m(Ci) ? "Route" : "Sparkles",
                  size: 11
                }, null, 8, ["name"]),
                u("span", lTe, E(O.value), 1),
                C($, {
                  name: "ChevronUp",
                  size: 11
                })
              ], 10, aTe),
              D.value ? (g(), b("div", dTe, [
                ae[23] || (ae[23] = u("div", { class: "ch-switch-eyebrow" }, "Who answers", -1)),
                (g(!0), b(j, null, ge(P.value, (ye) => (g(), b("button", {
                  key: ye.id,
                  class: G(["ch-model-row", { on: ye.id === T.value }]),
                  role: "menuitemradio",
                  "aria-checked": ye.id === T.value,
                  "data-testid": "chat-model-" + ye.id,
                  onClick: (Oe) => ie(ye.id)
                }, [
                  u("span", uTe, [
                    u("span", hTe, E(ye.label), 1),
                    u("span", pTe, [
                      Y(E(ye.route) + " · " + E(ye.effort) + " reasoning", 1),
                      m(R) && ye.price ? (g(), b(j, { key: 0 }, [
                        Y(" · " + E(L(ye.price)), 1)
                      ], 64)) : z("", !0)
                    ])
                  ]),
                  ye.id === T.value ? (g(), Ie($, {
                    key: 0,
                    name: "Check",
                    size: 12
                  })) : z("", !0)
                ], 10, cTe))), 128)),
                m(t).canSimulate ? (g(), b("button", {
                  key: 0,
                  class: G(["ch-model-row", { on: T.value === m(Ci) }]),
                  role: "menuitemradio",
                  "aria-checked": T.value === m(Ci),
                  "data-testid": "chat-model-simulated",
                  onClick: ae[6] || (ae[6] = (ye) => ie(m(Ci)))
                }, [
                  ae[22] || (ae[22] = u("span", { class: "m" }, [
                    u("span", { class: "n" }, "Simulated"),
                    u("span", { class: "f" }, "Scripted answers, no model")
                  ], -1)),
                  T.value === m(Ci) ? (g(), Ie($, {
                    key: 0,
                    name: "Check",
                    size: 12
                  })) : z("", !0)
                ], 10, fTe)) : z("", !0),
                F.value ? (g(), b("div", mTe, E(F.value), 1)) : z("", !0)
              ])) : z("", !0)
            ])) : z("", !0),
            u("span", {
              class: "ch-comp-hint",
              title: B.value,
              "data-testid": "chat-spend"
            }, E(re.value), 9, gTe),
            u("button", {
              class: "ch-send",
              disabled: !H.value,
              title: "Send (Enter)",
              "aria-label": "Send",
              "data-testid": "chat-send",
              onClick: ae[7] || (ae[7] = (ye) => Q())
            }, [
              C($, {
                name: "ArrowUp",
                size: 15
              })
            ], 8, bTe)
          ])
        ], 2)
      ])
    ], 32)) : z("", !0);
  }
}), yTe = 4, Br = 0.01, xTe = 24, Jt = (n, e) => e === "x" ? n.x : n.y, Ut = (n, e) => e === "x" ? n.x + n.w : n.y + n.h, yx = (n) => n === "x" ? "y" : "x";
function NA(n, e, t) {
  const i = yx(t);
  return Jt(n, i) < Ut(e, i) && Jt(e, i) < Ut(n, i);
}
function G4(n, e, t) {
  const i = j4(n, e, "x", t), s = j4(n, e, "y", t);
  return { dx: i === null ? 0 : i, dy: s === null ? 0 : s, x: i !== null, y: s !== null };
}
function j4(n, e, t, i) {
  let s = null;
  const o = (d) => {
    Math.abs(d) <= i && (s === null || Math.abs(d) < Math.abs(s)) && (s = d);
  }, r = Jt(n, t), a = Ut(n, t), l = (r + a) / 2;
  for (const d of e) {
    const c = Jt(d, t), h = Ut(d, t);
    o(c - r), o(h - r), o(c - a), o(h - a), o((c + h) / 2 - l);
  }
  for (const d of wTe(n, e, t)) o(d);
  return s;
}
function UA(n, e, t, i) {
  const s = [];
  let o = null, r = null;
  const a = Jt(n, t), l = Ut(n, t);
  for (const d of e)
    NA(d, n, t) && (s.push(d), Ut(d, t) <= a + i ? (!o || Ut(d, t) > Ut(o, t)) && (o = d) : Jt(d, t) >= l - i && (!r || Jt(d, t) < Jt(r, t)) && (r = d));
  return { row: s, before: o, after: r };
}
function GA(n, e) {
  if (n.length < 2) return [];
  const t = n.slice().sort((s, o) => Ut(s, e) - Ut(o, e)), i = [];
  for (const s of n) {
    const o = Jt(s, e);
    let r = 0, a = t.length;
    for (; r < a; ) {
      const c = r + a >> 1;
      Ut(t[c], e) <= o ? r = c + 1 : a = c;
    }
    if (r === 0) continue;
    const l = t[r - 1], d = o - Ut(l, e);
    d > 0 && NA(l, s, e) && i.push({ p: l, q: s, size: d });
  }
  return i;
}
function wTe(n, e, t) {
  const { row: i, before: s, after: o } = UA(n, e, t, 0);
  if (!s && !o) return [];
  const r = Jt(n, t), a = Ut(n, t), l = [];
  s && o && Jt(o, t) - Ut(s, t) >= a - r && l.push((Ut(s, t) + Jt(o, t)) / 2 - (r + a) / 2);
  for (const d of GA(i, t))
    s && l.push(Ut(s, t) + d.size - r), o && l.push(Jt(o, t) - d.size - a);
  return l;
}
function H4(n, e) {
  return {
    lines: Nf(n, e, "x", !0).concat(Nf(n, e, "y", !0)),
    gaps: V4(n, e, "x").concat(V4(n, e, "y")).slice(0, xTe)
  };
}
function Nf(n, e, t, i) {
  const s = yx(t), o = Jt(n, t), r = Ut(n, t), a = (o + r) / 2, l = [o, a, r], d = [null, null, null], c = (p, y) => Math.abs(p - y) <= Br, h = (p, y) => {
    const v = d[p] || [Jt(n, s), Ut(n, s)];
    v[0] = Math.min(v[0], Jt(y, s)), v[1] = Math.max(v[1], Ut(y, s)), d[p] = v;
  };
  for (const p of e) {
    const y = Jt(p, t), v = Ut(p, t);
    let x = !1;
    i && (c(o, y) || c(o, v)) && (h(0, p), x = !0), (c(r, y) || c(r, v)) && (h(2, p), x = !0), i && !x && c(a, (y + v) / 2) && h(1, p);
  }
  const f = [];
  return d.forEach((p, y) => {
    if (!p) return;
    const v = f.find((x) => c(x.at, l[y]));
    v ? (v.from = Math.min(v.from, p[0]), v.to = Math.max(v.to, p[1])) : f.push({ axis: t, at: l[y], from: p[0], to: p[1] });
  }), f;
}
function V4(n, e, t) {
  const { row: i, before: s, after: o } = UA(n, e, t, Br);
  if (!s && !o) return [];
  const r = s ? Jt(n, t) - Ut(s, t) : 0, a = o ? Jt(o, t) - Ut(n, t) : 0, l = (p, y) => Math.abs(p - y) <= Br, d = [], c = (p, y) => d.push({ axis: t, from: Ut(p, t), to: Jt(y, t), at: kTe(p, y, t) });
  let h = r > Br && a > Br && l(r, a), f = h;
  for (const p of GA(i, t))
    r > Br && l(p.size, r) ? (h = !0, c(p.p, p.q)) : a > Br && l(p.size, a) && (f = !0, c(p.p, p.q));
  return h && s && c(s, n), f && o && c(n, o), d;
}
function kTe(n, e, t) {
  const i = yx(t), s = Math.max(Jt(n, i), Jt(e, i)), o = Math.min(Ut(n, i), Ut(e, i));
  return s <= o ? (s + o) / 2 : (Jt(n, i) + Ut(n, i) + Jt(e, i) + Ut(e, i)) / 4;
}
function _Te(n, e, t) {
  const i = W4(n.x + n.w, e, "x", t), s = W4(n.y + n.h, e, "y", t);
  return { dx: i === null ? 0 : i, dy: s === null ? 0 : s, x: i !== null, y: s !== null };
}
function W4(n, e, t, i) {
  let s = null;
  const o = (r) => {
    Math.abs(r) <= i && (s === null || Math.abs(r) < Math.abs(s)) && (s = r);
  };
  for (const r of e)
    o(Jt(r, t) - n), o(Ut(r, t) - n);
  return s;
}
function STe(n, e) {
  return { lines: Nf(n, e, "x", !1).concat(Nf(n, e, "y", !1)), gaps: [] };
}
var MTe = Object.defineProperty, TTe = (n, e, t) => e in n ? MTe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, ni = (n, e, t) => TTe(n, typeof e != "symbol" ? e + "" : e, t);
const Gh = 4;
function K0(n) {
  const e = n || document.activeElement;
  if (!e) return !1;
  const t = e.tagName;
  return t === "TEXTAREA" || t === "INPUT" || t === "SELECT" || !!e.isContentEditable;
}
function jh() {
  const n = document.activeElement;
  n && n.blur && K0(n) && n.blur();
}
function yo(n) {
  return Math.round(n * 1e3) / 1e3;
}
function q4(n, e, t) {
  return { x: n.x + e, y: n.y + t, w: n.w, h: n.h };
}
function K4(n) {
  return n.x && (!n.y || Math.abs(n.dx) <= Math.abs(n.dy)) ? "x" : n.y ? "y" : null;
}
class jb {
  constructor(e, t, i, s) {
    ni(this, "b", e), ni(this, "exclude", t), ni(this, "free"), ni(this, "cam", null), ni(this, "rects", []), ni(this, "onKey"), this.free = bn(i), this.onKey = (o) => {
      bn(o) !== this.free && (this.free = !this.free, s());
    }, window.addEventListener("keydown", this.onKey), window.addEventListener("keyup", this.onKey);
  }
  /** The command key, as a pointer event has it. */
  pointer(e) {
    this.free = bn(e);
  }
  /** How near counts, in world units at this zoom. */
  get tol() {
    return yTe / this.b.cam.value.zoom;
  }
  /** What is in view, less what moves; read again whenever the camera moves. */
  targets() {
    const e = this.b.cam.value;
    if (e !== this.cam) {
      this.cam = e, this.rects = [];
      for (const t of this.b.store.query(fl(e, this.b.view.w, this.b.view.h)))
        this.exclude.has(t.id) || this.rects.push(He(t));
    }
    return this.rects;
  }
  show(e) {
    const t = e && (e.lines.length || e.gaps.length) ? e : null;
    (t || this.b.guides.value) && (this.b.guides.value = t);
  }
  end() {
    window.removeEventListener("keydown", this.onKey), window.removeEventListener("keyup", this.onKey), this.b.guides.value = null;
  }
}
function xo(n) {
  let e = null, t = 0;
  return {
    call(i) {
      e = i, t || (t = requestAnimationFrame(() => {
        t = 0, e && n(e);
      }));
    },
    flush() {
      t && cancelAnimationFrame(t), t = 0, e && n(e);
    },
    cancel() {
      t && cancelAnimationFrame(t), t = 0;
    }
  };
}
class CTe {
  constructor(e) {
    ni(this, "b", e), ni(this, "spaceDown", !1), ni(this, "rightPress", null), ni(this, "rightEnded", null), ni(this, "stage", null), ni(this, "cleanups", []), ni(this, "hoverRaf", 0), ni(this, "lastPointer", { x: 0, y: 0 }), ni(this, "lastShift", !1);
  }
  attach(e) {
    this.stage = e;
    const t = (d) => this.onWheel(d);
    e.addEventListener("wheel", t, { passive: !1 });
    const i = (d) => this.onHover(d);
    e.addEventListener("pointermove", i);
    const s = () => this.setHover(null);
    e.addEventListener("pointerleave", s);
    const o = (d) => this.onKeyDown(d), r = (d) => this.onKeyUp(d);
    window.addEventListener("keydown", o), window.addEventListener("keyup", r);
    const a = () => {
      this.spaceDown = !1;
    };
    window.addEventListener("blur", a);
    const l = (d) => d.preventDefault();
    e.addEventListener("gesturestart", l), e.addEventListener("gesturechange", l), this.cleanups.push(() => {
      e.removeEventListener("wheel", t), e.removeEventListener("pointermove", i), e.removeEventListener("pointerleave", s), window.removeEventListener("keydown", o), window.removeEventListener("keyup", r), window.removeEventListener("blur", a), e.removeEventListener("gesturestart", l), e.removeEventListener("gesturechange", l);
    });
  }
  detach() {
    for (const e of this.cleanups) e();
    this.cleanups = [], cancelAnimationFrame(this.hoverRaf);
  }
  get spacePan() {
    return this.spaceDown;
  }
  // ------------------------------------------------------------- wheel
  onWheel(e) {
    if (!e.ctrlKey && !bn(e) && this.noteScrolls(e)) return;
    e.preventDefault();
    const t = this.b;
    if (!t.engine) return;
    (t.ui.canvasMenu || t.ui.finder || t.ui.boardLinkMenu) && (t.ui.canvasMenu = null, t.ui.finder = null, t.ui.boardLinkMenu = null);
    const i = e.clientX - t.view.left, s = e.clientY - t.view.top, o = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? t.view.h : 1, r = e.deltaX * o, a = e.deltaY * o;
    if (e.ctrlKey || bn(e)) {
      const l = e.ctrlKey && !e.metaKey && e.deltaMode === 0 && Math.abs(a) < 50;
      t.engine.zoomAt(i, s, Math.exp(l ? -a * 0.012 : -Math.max(-60, Math.min(60, a)) * 4e-3));
      return;
    }
    e.shiftKey && r === 0 ? t.engine.panBy(-a, 0) : t.engine.panBy(-r, -a);
  }
  /** The wheel is over the text of a selected (or open) note that can still scroll its way. */
  noteScrolls(e) {
    const t = e.target instanceof Element ? e.target.closest(".cv-note-text") : null, i = t && t.closest("[data-el]");
    if (!t || !i) return !1;
    const s = i.dataset.el;
    return !this.b.ui.selection.includes(s) && this.b.ui.editingNote !== s ? !1 : e.deltaY > 0 ? t.scrollTop + t.clientHeight < t.scrollHeight - 1 : e.deltaY < 0 ? t.scrollTop > 0 : !1;
  }
  // ------------------------------------------------------------- hover
  onHover(e) {
    this.lastPointer = { x: e.clientX, y: e.clientY }, this.lastShift = e.shiftKey, !(e.buttons || !this.b.engine) && (this.hoverRaf || (this.hoverRaf = requestAnimationFrame(() => {
      this.hoverRaf = 0;
      const t = this.b;
      if (!t.engine || t.ui.marquee || t.ui.dragging) return;
      const i = document.elementFromPoint(this.lastPointer.x, this.lastPointer.y), o = i && !i.classList.contains("bd-canvas") && !i.closest(".cv-img-hover") && i !== this.stage ? null : t.engine.hitTest(this.lastPointer.x - t.view.left, this.lastPointer.y - t.view.top);
      if (this.setHover(o && o.type === "image" ? o.id : null), this.stage) {
        const r = o && !t.isHeld(o) && (o.type === "image" || o.type === "frame" || o.type === "shape"), a = !!o && o.type === "image" && this.lastShift;
        this.stage.style.cursor = t.ui.eyedropper || t.comments.ui.armed ? "" : t.ui.shapeArmed ? "crosshair" : t.ui.mode === "hand" || this.spaceDown ? "" : a ? "copy" : r ? "grab" : "";
      }
    })));
  }
  setHover(e) {
    const t = this.b;
    t.ui.hoverId !== e && (t.ui.hoverId = e, t.engine && t.engine.setHover(e));
  }
  // ------------------------------------------------------------- stage
  /** pointerdown that reached the stage itself (not a DOM element). */
  stageDown(e) {
    const t = this.b;
    if (!t.engine) return;
    const i = e.button === 1 || e.button === 0 && (t.ui.mode === "hand" || this.spaceDown);
    if (t.ui.addMenu = !1, t.ui.shapeMenu = !1, t.ui.canvasMenu = null, t.ui.finder = null, t.ui.boardLinkMenu = null, i) {
      e.preventDefault(), this.beginPan(e, { clickClears: e.button === 0 });
      return;
    }
    if (e.button === 2) {
      this.beginRightPress(e);
      return;
    }
    if (e.button !== 0) return;
    if (t.ui.styleOpen = !1, jh(), t.ui.eyedropper) {
      e.preventDefault();
      const o = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
      o && o.type === "image" ? t.eyedropImage(o) : this.beginPan(e);
      return;
    }
    if (t.ui.shapeArmed) {
      e.preventDefault(), this.beginShape(e);
      return;
    }
    const s = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
    if (s) {
      this.elementDown(s, e);
      return;
    }
    this.beginMarquee(e);
  }
  stageDoubleClick(e) {
    const t = this.b;
    if (!t.engine || t.ui.eyedropper) return;
    const i = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
    i && i.type === "image" ? (t.ui.selection = [i.id], t.ui.infoAt = i.id) : i && i.type === "frame" ? (t.ui.selection = [i.id], t.engine.fitTo(He(i), { pad: 72, maxZoom: 1, animate: 460 })) : i && i.type === "note" ? t.editNote(i.id) : i && i.type === "tool" ? t.openSession(i) : i && i.type === "chat" ? (t.ui.selection = [i.id], t.ui.chatOpen = i.id) : !i && this.onCanvas(e.target) && t.ui.mode === "select" && !this.spaceDown && !t.ui.shapeArmed && t.openFinder(e.clientX, e.clientY);
  }
  /**
   * Right-click (Ctrl-click on a Mac, a long press on touch) on the empty
   * canvas or inside a frame: the canvas menu, which adds things there.
   * Elsewhere on the board the browser's own menu stays off and none shows.
   */
  stageContextMenu(e) {
    if (e.preventDefault(), this.rightPress) return;
    const t = this.rightEnded;
    t && performance.now() - t.at < 500 || this.menuAt(e.clientX, e.clientY, e.target);
  }
  /** The canvas menu at a point, where it opens: the empty canvas or inside a frame. */
  menuAt(e, t, i) {
    const s = this.b;
    if (!s.engine || s.ui.eyedropper || s.ui.shapeArmed || s.ui.panning || s.ui.dragging || !this.onCanvas(i)) return;
    const o = s.engine.hitTest(e - s.view.left, t - s.view.top);
    o && o.type !== "frame" || (jh(), s.openCanvasMenu(e, t));
  }
  /**
   * Right-drag pans the board, as Miro's does (CHAT-21); a right-click that
   * doesn't move still opens the canvas menu, when it lets go.
   */
  beginRightPress(e) {
    const t = this.b, i = { x: e.clientX, y: e.clientY };
    this.rightPress = { ...i, target: e.target };
    let s = i, o = !1;
    const r = xo((l) => {
      if (t.engine) {
        if (!o) {
          if (Math.hypot(l.clientX - i.x, l.clientY - i.y) <= Gh) return;
          o = !0, t.ui.panning = !0;
        }
        t.engine.panBy(l.clientX - s.x, l.clientY - s.y), s = { x: l.clientX, y: l.clientY };
      }
    }), a = (l) => {
      r.flush();
      const d = this.rightPress;
      this.rightPress = null, this.rightEnded = { at: performance.now(), panned: o }, t.ui.panning = !1, window.removeEventListener("pointermove", r.call), window.removeEventListener("pointerup", a), window.removeEventListener("pointercancel", a), !o && d && l.type === "pointerup" && this.menuAt(d.x, d.y, d.target);
    };
    window.addEventListener("pointermove", r.call), window.addEventListener("pointerup", a), window.addEventListener("pointercancel", a);
  }
  /** The pointer is on the canvas itself, not on a card, a note or a frame's title drawn over it. */
  onCanvas(e) {
    return e === this.stage || e instanceof HTMLElement && e.classList.contains("bd-canvas");
  }
  /**
   * `clickClears`: a press that never moves is a click, which on the empty
   * canvas lets go of the selection, as it does without the hand (IL-100;
   * Blake: with the hand, a drawn shape's box took a second click, after
   * switching back, to go).
   */
  beginPan(e, t = {}) {
    const i = this.b;
    i.ui.panning = !0;
    const s = { x: e.clientX, y: e.clientY };
    let o = { x: e.clientX, y: e.clientY }, r = !1;
    const a = xo((d) => {
      i.engine && (!r && Math.hypot(d.clientX - s.x, d.clientY - s.y) > Gh && (r = !0), i.engine.panBy(d.clientX - o.x, d.clientY - o.y), o = { x: d.clientX, y: d.clientY });
    }), l = (d) => {
      a.flush(), i.ui.panning = !1, t.clickClears && !r && d.type === "pointerup" && i.engine && !i.engine.hitTest(d.clientX - i.view.left, d.clientY - i.view.top) && (i.ui.selection = []), window.removeEventListener("pointermove", a.call), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l);
    };
    window.addEventListener("pointermove", a.call), window.addEventListener("pointerup", l), window.addEventListener("pointercancel", l);
  }
  /**
   * A drag on the empty canvas selects what it touches. Started on a locked
   * frame (IL-070), or on what one holds (B31), which a drag can't move,
   * it's the same drag; a press that never moves is a click on it instead,
   * and selects it (then `onClick`, a session card's Open).
   */
  beginMarquee(e, t = null, i) {
    const s = this.b, o = e.clientX - s.view.left, r = e.clientY - s.view.top, a = e.shiftKey, l = a ? s.ui.selection.slice() : [];
    !a && !t && (s.ui.selection = []), s.ui.editingNote = null, s.ui.editingTitle = null;
    let d = !1;
    const c = xo((f) => {
      const p = f.clientX - s.view.left, y = f.clientY - s.view.top;
      if (!d && Math.hypot(p - o, y - r) < 3) return;
      d = !0, s.ui.marquee = { x0: o, y0: r, x1: p, y1: y };
      const v = s.cam.value, x = (Math.min(o, p) - v.x) / v.zoom, w = (Math.min(r, y) - v.y) / v.zoom, S = (Math.max(o, p) - v.x) / v.zoom, M = (Math.max(r, y) - v.y) / v.zoom, _ = s.store.query({ x, y: w, w: S - x, h: M - w }).filter((k) => k.type !== "frame" || k.x >= x && k.y >= w && k.x + k.w <= S && k.y + k.h <= M).map((k) => k.id), T = a ? Array.from(new Set(l.concat(_))) : _;
      (T.length !== s.ui.selection.length || T.some((k, P) => k !== s.ui.selection[P])) && (s.ui.selection = T);
    }), h = () => {
      if (c.flush(), s.ui.marquee = null, window.removeEventListener("pointermove", c.call), window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", h), t && !d) {
        const f = t.id;
        s.ui.selection = a ? l.includes(f) ? l.filter((p) => p !== f) : l.concat([f]) : [f], i && !a && i();
      }
    };
    window.addEventListener("pointermove", c.call), window.addEventListener("pointerup", h), window.addEventListener("pointercancel", h);
  }
  // ----------------------------------------------------------- elements
  /** pointerdown on an element (DOM or GPU). Click selects; drag moves. */
  /** `onClick`: a press that never became a drag, after it selects (a session card's Open, IL-100) */
  elementDown(e, t, i = {}) {
    const s = this.b;
    if (t.button === 1 || s.ui.mode === "hand" || this.spaceDown) {
      t.preventDefault(), t.stopPropagation(), this.beginPan(t);
      return;
    }
    if (t.button !== 0) return;
    if (t.stopPropagation(), s.ui.eyedropper) {
      t.preventDefault(), e.type === "image" ? s.eyedropImage(e) : this.beginPan(t);
      return;
    }
    if (s.ui.addMenu = !1, s.ui.editingNote === e.id) return;
    if (jh(), Ro(e)) {
      this.beginMarquee(t, e);
      return;
    }
    if (t.shiftKey && e.type === "image") {
      this.beginReferenceDrag(e, t);
      return;
    }
    if (s.isHeld(e)) {
      this.beginMarquee(t, e, i.onClick);
      return;
    }
    const o = s.ui.selection.includes(e.id) ? s.ui.selection.filter((S) => !s.isHeld(s.store.get(S))) : [e.id], r = new Set(o);
    for (const S of o) {
      const M = s.store.get(S);
      if (M && M.type === "frame")
        for (const _ of s.carriedBy(M)) s.isHeld(s.store.get(_)) || r.add(_);
    }
    const a = /* @__PURE__ */ new Map();
    for (const S of r) {
      const M = s.store.get(S);
      M && a.set(S, { x: M.x, y: M.y });
    }
    const l = s.store.bounds(o), d = { x: t.clientX, y: t.clientY };
    let c = !1, h = null;
    const f = e.type === "image" && s.promptTool.value ? this.promptRect() : null;
    let p = !f;
    const y = new jb(s, r, t, () => {
      c && h && v.call(h);
    }), v = xo((S) => {
      const M = s.cam.value.zoom;
      if (c && !p && f && S.clientX >= f.left && S.clientX <= f.right && S.clientY >= f.top && S.clientY <= f.bottom && (p = !0, s.toast("Hold Shift as you drag to use an image as a reference.")), !c && Math.hypot(S.clientX - d.x, S.clientY - d.y) > Gh && (c = !0, s.ui.selection.includes(e.id) || (s.ui.selection = [e.id]), s.ui.dragging = !0, s.ui.styleOpen = !1, s.store.beginGesture(r.size > 1 ? "Move " + r.size + " items" : "Move"), this.setHover(null)), !c) return;
      const _ = (S.clientX - d.x) / M, T = (S.clientY - d.y) / M;
      let k = Math.round(_), P = Math.round(T), A = null;
      if (l && !y.free) {
        const D = y.targets(), O = G4(q4(l, _, T), D, y.tol);
        O.x && (k = yo(_ + O.dx)), O.y && (P = yo(T + O.dy)), (O.x || O.y) && (A = H4(q4(l, k, P), D));
      }
      const R = [];
      for (const [D, O] of a) R.push([D, { x: O.x + k, y: O.y + P }]);
      s.store.updateMany(R), y.show(A);
    }), x = (S) => {
      h = S, y.pointer(S), v.call(S);
    }, w = (S) => {
      if (v.flush(), y.end(), window.removeEventListener("pointermove", x), window.removeEventListener("pointerup", w), window.removeEventListener("pointercancel", w), c) {
        s.growFramesFor(o), s.store.endGesture(), s.ui.dragging = !1;
        return;
      }
      S.shiftKey ? s.ui.selection = s.ui.selection.includes(e.id) ? s.ui.selection.filter((M) => M !== e.id) : s.ui.selection.concat([e.id]) : (s.ui.selection = [e.id], i.onClick && i.onClick());
    };
    window.addEventListener("pointermove", x), window.addEventListener("pointerup", w), window.addEventListener("pointercancel", w);
  }
  /**
   * Shift-drag an image (IL-071): a small copy of it follows the pointer, and
   * dropped on a session (its card, its row in the sessions rail, or the open
   * prompt and its image slots) the picture becomes that session's reference
   * and the session opens. The image itself stays where it is. Without a
   * drag it's Shift-click: in or out of the selection.
   */
  beginReferenceDrag(e, t) {
    const i = this.b, s = { x: t.clientX, y: t.clientY };
    let o = !1, r = null;
    const a = xo((d) => {
      if (!o) {
        if (Math.hypot(d.clientX - s.x, d.clientY - s.y) <= Gh) return;
        o = !0, i.ui.dragging = !0, this.setHover(null);
      }
      r = this.refDropAt(d.clientX, d.clientY);
      const c = r && r.key ? r.key : !1, h = r && !r.key ? r.sessionId : null;
      i.ui.refTarget !== c && (i.ui.refTarget = c), i.ui.refSession !== h && (i.ui.refSession = h), i.ui.ghost = { x: d.clientX, y: d.clientY, url: e.src, ref: !!r };
    }), l = (d) => {
      if (a.flush(), window.removeEventListener("pointermove", a.call), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l), i.ui.ghost = null, i.ui.refTarget = !1, i.ui.refSession = null, i.ui.dragging = !1, !o) {
        if (i.shiftPick && i.shiftPick(e.id)) return;
        i.ui.selection = i.ui.selection.includes(e.id) ? i.ui.selection.filter((h) => h !== e.id) : i.ui.selection.concat([e.id]);
        return;
      }
      if (d.type === "pointercancel") return;
      const c = r;
      c ? i.referenceImage(e.id, c.sessionId, { key: c.key, reveal: c.reveal }) : i.toast("Drop it on a session, or on the open prompt, to use it as a reference.");
    };
    window.addEventListener("pointermove", a.call), window.addEventListener("pointerup", l), window.addEventListener("pointercancel", l);
  }
  /**
   * What a Shift-dragged image would go to at a client point: an image slot
   * in the open prompt, the open prompt, a session's row in the rail (from
   * elsewhere on the board, so it's brought into view), or a session's card
   * (drawn by the engine when far out).
   */
  refDropAt(e, t) {
    const i = this.b, s = document.elementFromPoint(e, t);
    if (!s) return null;
    const o = i.promptTool.value, r = s.closest("[data-ref-key]");
    if (o && r) return { sessionId: o.id, key: r.getAttribute("data-ref-key") || void 0 };
    if (o && s.closest(".v2-uprompt")) return { sessionId: o.id };
    const a = s.closest("[data-ref-session]");
    if (a) return { sessionId: a.getAttribute("data-ref-session"), reveal: a.hasAttribute("data-ref-reveal") };
    if (this.onCanvas(s) && i.engine) {
      const l = i.engine.hitTest(e - i.view.left, t - i.view.top);
      if (l && l.type === "tool") return { sessionId: l.id };
    }
    return null;
  }
  /** Where the open prompt is on screen, if it is. */
  promptRect() {
    const e = document.querySelector(".v2-uprompt");
    return e ? e.getBoundingClientRect() : null;
  }
  /**
   * The bottom-right handle of a single selection. The edges it moves (the
   * right and the bottom) snap to the edges of what is on screen; a card
   * that keeps its proportions snaps whichever of the two is nearer.
   */
  resizeDown(e, t) {
    const i = this.b;
    if (t.button !== 0 || i.isHeld(e)) return;
    t.stopPropagation(), t.preventDefault(), jh();
    const s = { x: t.clientX, y: t.clientY }, o = He(e), r = e.type === "image" ? i.ownerFrame(e) : null;
    i.store.beginGesture("Resize"), i.ui.dragging = !0;
    let a = null;
    const l = new jb(i, /* @__PURE__ */ new Set([e.id]), t, () => {
      a && d.call(a);
    }), d = xo((f) => {
      const p = i.cam.value.zoom, y = (f.clientX - s.x) / p, v = (f.clientY - s.y) / p, x = l.free ? null : l.targets(), w = (M, _) => _Te({ x: o.x, y: o.y, w: M, h: _ }, x || [], l.tol);
      if (e.type === "tool") {
        let M = (o.w + y) / Rt.w;
        const _ = x ? w(Rt.w * M, Rt.h * M) : null, T = _ && K4(_);
        _ && T === "x" ? M = (Rt.w * M + _.dx) / Rt.w : _ && T === "y" && (M = (Rt.h * M + _.dy) / Rt.h), M = Math.max(0.7, Math.min(2.6, M)), i.store.update(e.id, { scale: T ? Math.round(M * 1e4) / 1e4 : Math.round(M * 100) / 100 });
      } else if (e.type === "image") {
        const M = o.h / o.w, _ = o.w + (f.shiftKey || Math.abs(y) > Math.abs(v / M) ? y : v / M);
        let T = Math.round(_), k = Math.round(T * M);
        const P = x ? w(_, _ * M) : null, A = P && K4(P);
        P && A === "x" ? (T = yo(_ + P.dx), k = Math.round(T * M)) : P && A === "y" && (k = yo(_ * M + P.dy), T = Math.round(k / M)), T < 120 && (T = 120, k = Math.round(T * M)), i.store.update(e.id, { w: T, h: k });
      } else {
        const M = e.type === "shape" && (e.shape === "line" || e.shape === "arrow"), _ = e.type === "shape" ? M ? 0 : 12 : e.type === "frame" ? 200 : 140, T = e.type === "shape" ? M ? 0 : 12 : e.type === "frame" ? 160 : 120;
        let k = o.w + y, P = o.h + v;
        const A = x ? w(k, P) : null;
        k = A && A.x ? yo(k + A.dx) : Math.round(k), P = A && A.y ? yo(P + A.dy) : Math.round(P);
        const R = e.type === "note" ? { grow: void 0 } : {};
        i.store.update(e.id, { w: Math.max(_, k), h: Math.max(T, P), ...R });
      }
      const S = i.store.get(e.id);
      l.show(x && S ? STe(He(S), x) : null);
    }), c = (f) => {
      a = f, l.pointer(f), d.call(f);
    }, h = () => {
      d.flush(), l.end(), window.removeEventListener("pointermove", c), window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", h), e.type === "image" && i.growFramesFor([e.id], r ? /* @__PURE__ */ new Map([[e.id, r.id]]) : void 0), i.store.endGesture(), i.ui.dragging = !1;
    };
    window.addEventListener("pointermove", c), window.addEventListener("pointerup", h), window.addEventListener("pointercancel", h);
  }
  // ------------------------------------------------------------- shapes
  /** Drag draws; a plain click drops a readable default. Shift constrains. */
  beginShape(e) {
    const t = this.b, i = t.ui.shapeKind, s = t.screenToWorld(e.clientX, e.clientY), o = wt();
    t.ui.shapeArmed = !1, t.store.beginGesture("Draw " + i);
    const r = {
      id: o,
      type: "shape",
      shape: i,
      x: Math.round(s.x),
      y: Math.round(s.y),
      w: 0,
      h: 0,
      z: 0,
      sc: [0, 0],
      stroke: t.ui.shapeStyle.stroke,
      sw: t.ui.shapeStyle.sw,
      createdBy: t.user.uid
    };
    r.z = t.store.nextZ(r), t.store.add([r]), t.ui.selection = [o], t.ui.dragging = !0;
    let a = !1;
    const l = xo((c) => {
      const h = t.screenToWorld(c.clientX, c.clientY);
      let f = h.x - s.x, p = h.y - s.y;
      if (c.shiftKey)
        if (i === "rect" || i === "ellipse") {
          const y = Math.max(Math.abs(f), Math.abs(p));
          f = (f < 0 ? -1 : 1) * y, p = (p < 0 ? -1 : 1) * y;
        } else {
          const y = Math.round(Math.atan2(p, f) / (Math.PI / 4)) * (Math.PI / 4), v = Math.hypot(f, p);
          f = Math.cos(y) * v, p = Math.sin(y) * v;
        }
      (Math.abs(f) * t.cam.value.zoom > 4 || Math.abs(p) * t.cam.value.zoom > 4) && (a = !0), t.store.update(o, {
        x: Math.round(Math.min(s.x, s.x + f)),
        y: Math.round(Math.min(s.y, s.y + p)),
        w: Math.round(Math.abs(f)),
        h: Math.round(Math.abs(p)),
        sc: [f < 0 ? 1 : 0, p < 0 ? 1 : 0]
      });
    }), d = () => {
      if (l.flush(), window.removeEventListener("pointermove", l.call), window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", d), !a) {
        const c = i === "line" || i === "arrow";
        t.store.update(o, c ? { x: Math.round(s.x - 130), y: Math.round(s.y), w: 260, h: 0, sc: [0, 0] } : { x: Math.round(s.x - 130), y: Math.round(s.y - 85), w: 260, h: 170 });
      }
      t.store.endGesture(), t.ui.dragging = !1, t.ui.styleOpen = !0;
    };
    window.addEventListener("pointermove", l.call), window.addEventListener("pointerup", d), window.addEventListener("pointercancel", d);
  }
  // ------------------------------------------------------- drag-outs
  /**
   * Pull a result out of a tool card or the gallery. Over the canvas it
   * becomes a card that follows the pointer; over the prompt's reference
   * slot it becomes the reference. A short drag is a click.
   */
  dragResultOut(e, t, i = {}) {
    const s = this.b;
    if (t.button !== 0) return;
    t.preventDefault(), t.stopPropagation();
    const o = { x: t.clientX, y: t.clientY }, r = i.slop || 6;
    let a = !1, l = null;
    const d = e.w || 300, c = e.h || 200, h = (_) => {
      const T = document.elementFromPoint(_.clientX, _.clientY), k = T ? T.closest("[data-ref-key]") : null;
      return k && k.getAttribute("data-ref-key") || !1;
    }, f = (_) => {
      const T = document.elementFromPoint(_.clientX, _.clientY);
      return !T || T.closest(".v2-hist, .v2-uprompt, .rs, .cv-topbar, .v2-railwrap, .cv-corner, .cv-addmenu, .v2-info") ? !1 : !!T.closest(".cv-stage");
    }, p = /* @__PURE__ */ new Set();
    let y = null;
    const v = new jb(s, p, t, () => {
      l && y && w.call(y);
    }), x = (_) => {
      const T = { x: _.x - d / 2, y: _.y - c / 2, w: d, h: c };
      let k = Math.round(T.x), P = Math.round(T.y), A = null;
      if (!v.free) {
        const R = v.targets(), D = G4(T, R, v.tol);
        D.x && (k = yo(T.x + D.dx)), D.y && (P = yo(T.y + D.dy)), (D.x || D.y) && (A = H4({ x: k, y: P, w: d, h: c }, R));
      }
      return { x: k, y: P, guides: A };
    }, w = xo((_) => {
      if (!a && Math.hypot(_.clientX - o.x, _.clientY - o.y) > r && (a = !0, s.ui.dragging = !0), !!a)
        if (f(_)) {
          const T = s.screenToWorld(_.clientX, _.clientY);
          if (l) {
            const k = x(T);
            s.store.update(l, { x: k.x, y: k.y }), v.show(k.guides);
          } else {
            s.store.beginGesture("Place result");
            const k = e.result || null, P = {
              id: wt(),
              type: "image",
              x: 0,
              y: 0,
              w: d,
              h: c,
              z: 0,
              src: e.url,
              label: e.label || k && k.label || "result",
              resultId: k ? k.id : void 0,
              sessionId: e.sessionId || k && k.sessionId || void 0,
              video: k ? k.video : void 0,
              dur: k ? k.dur : void 0,
              videoSrc: k ? k.videoSrc : void 0,
              previewSrc: k ? k.previewSrc : void 0,
              asset: k ? k.asset : void 0,
              download: k ? k.download : void 0,
              kind: k ? k.kind : void 0,
              createdBy: s.user.uid
            };
            p.add(P.id);
            const A = x(T);
            P.x = A.x, P.y = A.y, P.z = s.store.nextZ(P), l = P.id, s.ui.ghost = null, s.ui.refTarget = !1, s.store.add([P]), i.keepSelection || (s.ui.selection = [P.id]), v.show(A.guides);
          }
        } else {
          l && (s.store.cancelGesture(), l = null), v.show(null);
          const T = h(_);
          s.ui.refTarget = T, s.ui.ghost = { x: _.clientX, y: _.clientY, url: e.url, ref: !!T };
        }
    }), S = (_) => {
      y = _, v.pointer(_), w.call(_);
    }, M = (_) => {
      w.flush(), v.end(), window.removeEventListener("pointermove", S), window.removeEventListener("pointerup", M), window.removeEventListener("pointercancel", M);
      const T = a && !l && h(_);
      if (s.ui.ghost = null, s.ui.refTarget = !1, s.ui.dragging = !1, l && (s.growFramesFor([l]), s.store.endGesture()), i.keepSelection && (s.ui.selection = [i.keepSelection]), T) {
        const k = s.promptTool.value;
        k && s.setRefInput(k.id, T, e.url, e.result && e.result.asset || s.assetFor(e.url));
        return;
      }
      !a && i.onClick && i.onClick();
    };
    window.addEventListener("pointermove", S), window.addEventListener("pointerup", M), window.addEventListener("pointercancel", M);
  }
  // ----------------------------------------------------------- keyboard
  onKeyUp(e) {
    e.code === "Space" && (this.spaceDown = !1, this.stage && this.stage.classList.remove("is-hand"));
  }
  onKeyDown(e) {
    const t = this.b, i = t.feedback;
    if (i && i.state.mode === "open") return;
    const s = K0(e.target), o = bn(e);
    if (i && !s && e.code === "Backquote" && !o && !e.shiftKey && !e.altKey) {
      e.preventDefault(), i.start("key");
      return;
    }
    if (t.ui.studio || t.ui.libraryOpen) return;
    if (e.key === "Escape") {
      if (i && i.state.mode === "aside") {
        e.preventDefault(), i.resume();
        return;
      }
      this.escape(e, s);
      return;
    }
    if (s || t.ui.trashOpen) return;
    if (e.key === "?" && !o) {
      e.preventDefault(), t.ui.boardMenu = !1, t.ui.keysOpen = !t.ui.keysOpen;
      return;
    }
    if (t.ui.keysOpen || t.ui.infoAt || t.ui.library.open && !o) return;
    if (e.code === "Space") {
      !this.spaceDown && this.stage && this.stage.classList.add("is-hand"), this.spaceDown = !0, e.preventDefault();
      return;
    }
    const r = e.key.toLowerCase();
    if (o) {
      r === "z" ? (e.preventDefault(), e.shiftKey ? t.redo() : t.undo()) : r === "y" ? (e.preventDefault(), t.redo()) : r === "d" ? (e.preventDefault(), t.duplicateIds(t.ui.selection.slice())) : r === "l" && e.shiftKey ? t.ui.selection.some((l) => {
        var d;
        return ((d = t.store.get(l)) == null ? void 0 : d.type) === "frame";
      }) && (e.preventDefault(), t.toggleLock()) : r === "a" ? (e.preventDefault(), t.selectAll()) : r === "c" ? t.ui.selection.length && (e.preventDefault(), t.copy(!1)) : r === "x" ? t.ui.selection.length && (e.preventDefault(), t.copy(!0)) : r === "0" ? (e.preventDefault(), t.zoomTo(1)) : r === "=" || r === "+" ? (e.preventDefault(), t.zoomBy(1.25)) : r === "-" && (e.preventDefault(), t.zoomBy(1 / 1.25));
      return;
    }
    if (e.altKey || gB(e)) return;
    const a = (l) => {
      e.preventDefault(), l();
    };
    switch (r) {
      case "v":
        a(() => t.setMode("select"));
        break;
      case "h":
        a(() => t.setMode("hand"));
        break;
      case "i": {
        const l = t.promptTool.value;
        l && a(() => t.toggleEyedropper(l.id));
        break;
      }
      case "c":
        if (!t.comments.enabled) break;
        e.shiftKey ? a(() => {
          const l = !t.comments.ui.showPins;
          t.comments.ui.showPins = l, t.toast(l ? "Comments shown on the board" : "Comments hidden. Shift+C shows them again");
        }) : a(() => t.comments.arm());
        break;
      case "m":
        a(() => t.armShape("rect"));
        break;
      case "l":
        a(() => t.armShape("ellipse"));
        break;
      case "n":
        a(() => t.addElement("note"));
        break;
      case "f":
        a(() => t.addElement("frame"));
        break;
      case "=":
      case "+":
        a(() => t.zoomBy(1.2));
        break;
      case "-":
      case "_":
        a(() => t.zoomBy(1 / 1.2));
        break;
      case "1":
      case "!":
        a(() => t.fit());
        break;
      case "0":
      case ")":
        a(() => t.zoomTo(1));
        break;
      case "delete":
      case "backspace":
        t.ui.selection.length && (e.preventDefault(), t.deleteIds(t.ui.selection.slice()));
        break;
      case "arrowleft":
      case "arrowright":
      case "arrowup":
      case "arrowdown": {
        if (!t.ui.selection.length) return;
        e.preventDefault();
        const l = e.shiftKey ? 10 : 1;
        t.nudge(r === "arrowleft" ? -l : r === "arrowright" ? l : 0, r === "arrowup" ? -l : r === "arrowdown" ? l : 0);
        break;
      }
      case "enter": {
        const l = t.ui.selection.length === 1 ? t.store.get(t.ui.selection[0]) : null;
        l && l.type === "note" ? (e.preventDefault(), t.editNote(l.id)) : l && l.type === "chat" ? (e.preventDefault(), t.ui.chatOpen = l.id) : l && l.type === "image" && (e.preventDefault(), t.ui.infoAt = l.id);
        break;
      }
      default:
        (e.code === "Backslash" || e.key === "\\" || e.key === "|") && a(() => t.armShape(e.shiftKey || e.key === "|" ? "arrow" : "line"));
    }
  }
  /** Esc closes the top layer only: menus, popovers, modal, then selection. */
  escape(e, t) {
    const i = this.b, s = i.ui;
    if (t) {
      document.activeElement.blur(), s.editingNote && (s.editingNote = null), s.editingTitle && (s.editingTitle = null);
      return;
    }
    const o = i.comments;
    s.boardMenu ? s.boardMenu = !1 : s.ctxMenu ? s.ctxMenu = !1 : s.canvasMenu ? s.canvasMenu = null : s.finder ? s.finder = null : s.boardLinkMenu ? s.boardLinkMenu = null : s.trashOpen ? s.trashOpen = !1 : s.keysOpen ? s.keysOpen = !1 : s.addMenu ? s.addMenu = !1 : s.placeMenu ? s.placeMenu = !1 : s.shapeMenu ? s.shapeMenu = !1 : s.shapeArmed ? s.shapeArmed = !1 : o.ui.draft ? o.cancelDraft() : o.ui.editingId ? o.ui.editingId = null : o.ui.openId ? o.close() : o.ui.armed ? o.ui.armed = !1 : s.eyedropper ? s.eyedropper = null : s.styleOpen ? s.styleOpen = !1 : s.infoAt && s.infoSave ? s.infoSave = !1 : s.infoAt ? s.infoAt = null : s.library.open ? i.promptLibrary.back() : s.boardHistory ? s.boardHistory = !1 : o.ui.panelOpen ? o.ui.panelOpen = !1 : s.chatOpen ? s.chatOpen = null : s.advOpen ? s.advOpen = !1 : s.selection.length ? s.selection = [] : s.mode === "hand" && (s.mode = "select"), e.preventDefault();
  }
  /** Paste from the system clipboard: board elements, or image files. */
  onPaste(e, t) {
    if (K0(e.target)) return;
    const i = this.b;
    if (i.ui.trashOpen || i.ui.studio || i.ui.libraryOpen) return;
    const s = e.clipboardData;
    if (!s) return;
    const o = Array.from(s.files || []).filter((a) => a.type.startsWith("image/"));
    if (o.length) {
      e.preventDefault(), t(o, i.viewportCentre());
      return;
    }
    const r = s.getData("text/plain");
    if (r && r.startsWith('{"rdBoard"'))
      try {
        const a = JSON.parse(r);
        if (a && Array.isArray(a.els)) {
          e.preventDefault(), i.paste(a.els, typeof a.board == "string" ? a.board : null);
          return;
        }
      } catch {
      }
    e.preventDefault(), i.paste();
  }
  /**
   * Leaving a note: its text stays, and so does the note when it has none
   * (Tyler, 2026-10-27: a note placed and left blank stays put, as Miro's
   * do; Delete removes it).
   */
  commitNote(e, t) {
    const i = this.b, s = i.store.get(e);
    i.ui.editingNote = null, s && s.text !== t && i.store.update(e, { text: t }, { history: !1 });
  }
}
const ITe = {
  key: 0,
  class: "bd-empty",
  "data-testid": "empty-board"
}, ATe = { class: "bd-empty-mark" }, PTe = { class: "bd-empty-actions" }, ETe = {
  key: 0,
  class: "cm-cards"
}, RTe = {
  key: 2,
  class: "pl-float"
}, zTe = {
  key: 20,
  class: "bd-drop"
}, $Te = { class: "bd-drop-card" }, DTe = { class: "bd-toast-text" }, OTe = /* @__PURE__ */ Pe({
  __name: "BoardView",
  props: {
    board: {},
    onHome: { type: Function },
    onIndex: { type: Function }
  },
  setup(n) {
    const e = n, t = OE(), i = e.board, s = new CTe(i);
    pL({ board: i, input: s });
    const o = os(i), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(null), c = /* @__PURE__ */ qe(!1), { active: h, over: f, leave: p, stop: y } = fx(), v = i.ui, x = i.comments, w = i.promptTool, S = I(() => (i.results.rev.value, w.value ? i.results.list(w.value.id) : [])), M = I(() => !!o.open.value), _ = I(() => !!w.value && S.value.length > 0 && v.histOpen && !v.boardHistory && !x.ui.panelOpen && !M.value), T = I(() => v.boardHistory || x.ui.panelOpen), k = I(() => ({
      "hist-rail": _.value,
      "board-hist": T.value,
      "chat-open": M.value,
      "light-canvas": v.lightCanvas,
      "no-grid": !v.showGrid,
      "is-studio": !!v.studio
    })), P = I(() => i.overlayIds.value.length > 120), A = i.feedback, R = I(() => !!A && A.state.mode === "open");
    function D(J) {
      const Q = J.target;
      A && Q instanceof Element && Q.closest("[data-feedback-bar]") && J.stopImmediatePropagation();
    }
    window.addEventListener("pointerdown", D, !0), We(() => window.removeEventListener("pointerdown", D, !0)), Ee(() => !!v.studio, (J) => {
      i.engine && i.engine.setPaused(J);
    });
    const O = I(() => (i.docRev.value, i.store.size === 0));
    it(async () => {
      await nt(), !(!r.value || !a.value || !l.value) && (s.attach(r.value), await i.attach(a.value, l.value), c.value = !0, window.addEventListener("paste", ee));
    }), We(() => {
      NG(i), s.detach(), window.removeEventListener("paste", ee);
    });
    function F(J) {
      const Q = J.currentTarget;
      (Q.scrollTop || Q.scrollLeft) && (Q.scrollTop = 0, Q.scrollLeft = 0);
    }
    function ie(J) {
      s.stageDown(J);
    }
    function ee(J) {
      R.value || s.onPaste(J, (Q, ne) => B(Q, ne));
    }
    let me;
    function L(J) {
      me = J, d.value && d.value.click();
    }
    async function N(J) {
      const Q = Array.from(J.target.files || []);
      J.target.value = "";
      const ne = me;
      me = void 0, Q.length && await B(Q, ne);
    }
    function K(J) {
      return new Promise((Q) => {
        const ne = new Image();
        ne.onload = () => Q({ w: ne.naturalWidth || 4, h: ne.naturalHeight || 3 }), ne.onerror = () => Q({ w: 4, h: 3 }), ne.src = J;
      });
    }
    async function B(J, Q) {
      const ne = J.filter((te) => te.type.startsWith("image/")).slice(0, 24);
      if (!ne.length) return;
      const ue = i.uploader;
      i.toast(ne.length === 1 ? "Placing image…" : "Placing " + ne.length + " images…");
      const Z = [];
      for (const te of ne) {
        const we = URL.createObjectURL(te), Fe = await K(we);
        let Me = we, he;
        if (ue)
          try {
            const oe = await i.uploadFile(te);
            Me = oe.url, he = oe.asset || void 0, URL.revokeObjectURL(we);
          } catch (oe) {
            console.error("[board] upload failed", oe);
            const de = oe ? oe.userMessage : void 0;
            i.toast(de || te.name + " could not be uploaded.", "error"), URL.revokeObjectURL(we);
            continue;
          }
        const q = 360 / Math.max(Fe.w, Fe.h);
        Z.push({ url: Me, w: Math.round(Fe.w * q), h: Math.round(Fe.h * q), label: te.name.replace(/\.[a-z0-9]+$/i, "").slice(0, 40), asset: he });
      }
      Z.length && i.placeImages(Z, Q);
    }
    function re(J) {
      R.value || !f(J) || J.preventDefault();
    }
    function H(J) {
      if (y(), R.value || !J.dataTransfer) return;
      const Q = Array.from(J.dataTransfer.files || []);
      Q.length && (J.preventDefault(), B(Q, i.screenToWorld(J.clientX, J.clientY)));
    }
    return (J, Q) => (g(), b("div", {
      class: G(["cv-root v2-root p1-root bd-root", k.value]),
      style: ce(m(v).promptCardH ? { "--up-card-h": m(v).promptCardH + "px" } : void 0),
      "data-screen-label": "Phase 1 - Boards V2",
      onDragover: re,
      onDragleave: Q[10] || (Q[10] = //@ts-ignore
      (...ne) => m(p) && m(p)(...ne)),
      onDrop: H
    }, [
      C(mL),
      u("div", {
        ref_key: "stage",
        ref: r,
        class: G(["cv-stage v2-stage", { "is-hand": m(v).mode === "hand", "is-panning": m(v).panning, "is-draw": m(v).shapeArmed, "is-dropper": !!m(v).eyedropper }]),
        "data-testid": "stage",
        onPointerdown: ie,
        onDblclick: Q[0] || (Q[0] = (ne) => m(s).stageDoubleClick(ne)),
        onContextmenu: Q[1] || (Q[1] = (ne) => m(s).stageContextMenu(ne)),
        onScroll: F
      }, [
        u("div", {
          ref_key: "canvasHost",
          ref: a,
          class: "bd-canvas-host"
        }, null, 512),
        u("div", {
          ref_key: "world",
          ref: l,
          class: G(["cv-world", { "is-moving": m(i).moving.value, "is-crowded": P.value, "is-far": m(i).far.value }])
        }, [
          c.value ? (g(), Ie(rre, { key: 0 })) : z("", !0),
          c.value && m(x).enabled ? (g(), Ie(w5e, { key: 1 })) : z("", !0)
        ], 2),
        m(v).marquee ? (g(), b("div", {
          key: 0,
          class: "cv-marquee",
          style: ce({
            left: Math.min(m(v).marquee.x0, m(v).marquee.x1) + "px",
            top: Math.min(m(v).marquee.y0, m(v).marquee.y1) + "px",
            width: Math.abs(m(v).marquee.x1 - m(v).marquee.x0) + "px",
            height: Math.abs(m(v).marquee.y1 - m(v).marquee.y0) + "px"
          })
        }, null, 4)) : z("", !0),
        C(hre)
      ], 34),
      C(vt, { name: "bd-empty" }, {
        default: Xe(() => [
          c.value && O.value && !m(v).addMenu && !m(v).finder && !m(v).shapeArmed ? (g(), b("div", ITe, [
            u("div", {
              class: "bd-empty-card",
              onPointerdown: Q[5] || (Q[5] = Te(() => {
              }, ["stop"]))
            }, [
              u("span", ATe, [
                C($, {
                  name: "Sparkles",
                  size: 18
                })
              ]),
              Q[14] || (Q[14] = u("b", null, "A blank board", -1)),
              Q[15] || (Q[15] = u("span", { class: "bd-empty-sub" }, "Start a tool session, drop images anywhere, or jot a note.", -1)),
              u("div", PTe, [
                u("button", {
                  class: "bd-btn",
                  "data-testid": "empty-start",
                  onClick: Q[2] || (Q[2] = (ne) => m(i).addElement("tool"))
                }, [
                  C($, {
                    name: "Plus",
                    size: 14
                  }),
                  Q[11] || (Q[11] = Y(" Start a tool session", -1))
                ]),
                u("button", {
                  class: "bd-btn is-ghost",
                  onClick: Q[3] || (Q[3] = (ne) => L())
                }, [
                  C($, {
                    name: "Upload",
                    size: 14
                  }),
                  Q[12] || (Q[12] = Y(" Add images", -1))
                ]),
                m(i).hasLibrary ? (g(), b("button", {
                  key: 0,
                  class: "bd-btn is-ghost",
                  "data-testid": "empty-library",
                  onClick: Q[4] || (Q[4] = (ne) => m(i).openLibrary())
                }, [
                  C($, {
                    name: "Library",
                    size: 14
                  }),
                  Q[13] || (Q[13] = Y(" From your Library", -1))
                ])) : z("", !0)
              ]),
              Q[16] || (Q[16] = u("div", { class: "bd-empty-keys" }, [
                u("kbd", null, "N"),
                Y(" note "),
                u("kbd", null, "F"),
                Y(" frame "),
                u("kbd", null, "M"),
                Y(" shape "),
                u("kbd", null, "V"),
                Y(" select")
              ], -1))
            ], 32)
          ])) : z("", !0)
        ]),
        _: 1
      }),
      c.value && m(x).enabled ? (g(), b("div", ETe, [
        (g(!0), b(j, null, ge(m(x).openCards.value, (ne) => (g(), Ie(L4, {
          id: ne.id,
          key: ne.id
        }, null, 8, ["id"]))), 128)),
        m(x).ui.draft ? (g(), Ie(L4, {
          id: null,
          key: "draft",
          draft: ""
        })) : z("", !0)
      ])) : z("", !0),
      C(fB, {
        "on-home": e.onHome,
        "on-index": e.onIndex
      }, null, 8, ["on-home", "on-index"]),
      C(gre),
      C(tF, {
        away: !!m(w),
        "on-image": () => L()
      }, null, 8, ["away", "on-image"]),
      C(TF),
      m(w) ? (g(), Ie(mue, {
        key: m(w).id,
        tool: m(w)
      }, null, 8, ["tool"])) : z("", !0),
      m(v).library.open && !m(v).library.sessionId ? (g(), b("div", RTe, [
        C(Qy, { floating: "" })
      ])) : z("", !0),
      m(v).addMenu ? (g(), Ie(UF, { key: 3 })) : z("", !0),
      m(v).canvasMenu ? (g(), Ie(nN, {
        key: "cm" + m(v).canvasMenu.x + "," + m(v).canvasMenu.y,
        menu: m(v).canvasMenu,
        "on-image": L
      }, null, 8, ["menu"])) : z("", !0),
      m(v).finder ? (g(), Ie(AN, {
        key: "sf" + m(v).finder.x + "," + m(v).finder.y,
        menu: m(v).finder
      }, null, 8, ["menu"])) : z("", !0),
      m(v).boardLinkMenu ? (g(), Ie(WN, {
        key: "bl" + m(v).boardLinkMenu.x + "," + m(v).boardLinkMenu.y,
        menu: m(v).boardLinkMenu
      }, null, 8, ["menu"])) : z("", !0),
      u("div", {
        class: G(["cv-corner", { "is-away": _.value || T.value || M.value }])
      }, [
        m(v).miniOpen ? (g(), Ie(eU, { key: 0 })) : z("", !0),
        C(sU)
      ], 2),
      C(wH),
      m(v).boardHistory ? (g(), Ie(LV, { key: 7 })) : z("", !0),
      m(x).enabled && m(x).ui.panelOpen && !m(v).boardHistory ? (g(), Ie(rSe, { key: 8 })) : z("", !0),
      M.value && !m(v).boardHistory ? (g(), Ie(vTe, { key: 9 })) : z("", !0),
      _.value && m(w) ? (g(), Ie(rH, {
        key: "h" + m(w).id,
        tool: m(w)
      }, null, 8, ["tool"])) : z("", !0),
      m(w) && S.value.length && !m(v).histOpen && !T.value && !M.value ? (g(), b("button", {
        key: 11,
        class: "v2-hist-open",
        title: "Show the gallery",
        onPointerdown: Q[6] || (Q[6] = Te(() => {
        }, ["stop"])),
        onClick: Q[7] || (Q[7] = (ne) => m(v).histOpen = !0)
      }, [
        C($, {
          name: "PanelRightOpen",
          size: 14
        }),
        u("span", null, E(S.value.length), 1)
      ], 32)) : z("", !0),
      C(cj),
      C(Sj),
      C(Dj),
      m(v).studio ? (g(), Ie(wwe, {
        key: m(v).studio.sessionId
      })) : z("", !0),
      m(v).infoAt ? (g(), Ie(Wq, { key: 13 })) : z("", !0),
      m(v).keysOpen ? (g(), Ie(nK, { key: 14 })) : z("", !0),
      m(v).trashOpen ? (g(), Ie(Bse, { key: 15 })) : z("", !0),
      m(v).libraryOpen ? (g(), Ie(e_e, {
        key: m(v).libraryOpen.n
      })) : z("", !0),
      C(vt, { name: "fb-aside" }, {
        default: Xe(() => [
          m(A) && m(A).state.mode === "aside" ? (g(), Ie(l5e, {
            key: 0,
            feedback: m(A)
          }, null, 8, ["feedback"])) : z("", !0)
        ]),
        _: 1
      }),
      m(A) && m(A).state.mode === "open" ? (g(), Ie(n5e, {
        key: 17,
        feedback: m(A)
      }, null, 8, ["feedback"])) : z("", !0),
      m(A) && m(A).state.flash ? (g(), b("div", {
        key: "fb-flash" + m(A).state.flash,
        class: "fb-flash",
        "data-feedback-skip": ""
      })) : z("", !0),
      m(v).ghost ? (g(), b("div", {
        key: 19,
        class: G(["tl-ghost", { "is-ref": m(v).ghost.ref }]),
        style: ce({ left: m(v).ghost.x + "px", top: m(v).ghost.y + "px", backgroundImage: 'url("' + m(v).ghost.url + '")' })
      }, null, 6)) : z("", !0),
      m(h) ? (g(), b("div", zTe, [
        u("div", $Te, [
          C($, {
            name: "ImagePlus",
            size: 20
          }),
          Q[17] || (Q[17] = Y(" Drop images to place them on the board", -1))
        ])
      ])) : z("", !0),
      C(vt, { name: "bd-toast" }, {
        default: Xe(() => [
          m(v).toast ? (g(), b("div", {
            key: m(v).toast.id,
            class: G(["bd-toast", { "is-error": m(v).toast.tone === "error", "has-action": !!m(v).toast.action, "is-long": m(v).toast.text.length > 70 }]),
            role: "status",
            "data-testid": "toast"
          }, [
            C($, {
              name: m(v).toast.tone === "error" ? "AlertCircle" : "Check",
              size: 13
            }, null, 8, ["name"]),
            u("span", DTe, E(m(v).toast.text), 1),
            m(v).toast.action ? (g(), b("button", {
              key: 0,
              class: "bd-toast-act",
              "data-testid": "toast-action",
              onPointerdown: Q[8] || (Q[8] = Te(() => {
              }, ["stop"])),
              onClick: Q[9] || (Q[9] = (ne) => m(v).toast.action.run())
            }, E(m(v).toast.action.label), 33)) : z("", !0)
          ], 2)) : z("", !0)
        ]),
        _: 1
      }),
      Ss(J.$slots, "hud"),
      m(v).showStats && !m(t).hud ? (g(), Ie(Use, { key: 21 })) : z("", !0),
      u("input", {
        ref_key: "fileEl",
        ref: d,
        type: "file",
        accept: "image/*",
        multiple: "",
        style: { display: "none" },
        onChange: N
      }, null, 544),
      Q[18] || (Q[18] = u("div", { class: "cm-portal" }, null, -1)),
      m(x).enabled ? (g(), Ie(cSe, { key: 22 })) : z("", !0)
    ], 38));
  }
}), Ql = "1 33 239 173", ma = [
  {
    d: "M160.973 91.1044H105.586C103.271 91.1044 101.134 89.8671 99.9766 87.8597L74.5215 43.7307C72.0284 39.4055 75.1448 33.9999 80.1311 33.9999H135.518C137.833 33.9999 139.97 35.2372 141.128 37.2447L166.579 81.3772C169.072 85.7024 165.956 91.108 160.97 91.108L160.973 91.1044Z",
    fill: "#CC5FD1",
    origin: "50% 17.1%",
    axis: [0.87, 0.49],
    out: [0, -1]
  },
  {
    d: "M150.485 148.213H205.872C208.187 148.213 210.324 146.975 211.481 144.968L236.933 100.835C239.426 96.5102 236.31 91.1046 231.323 91.1046H175.936C173.621 91.1046 171.484 92.3419 170.327 94.3494L144.875 138.482C142.382 142.807 145.498 148.213 150.485 148.213Z",
    fill: "#9A6ADF",
    origin: "79.5% 50.1%",
    axis: [0.87, -0.49],
    out: [1, 0]
  },
  {
    d: "M160.974 205.317H105.587C103.271 205.317 101.134 204.079 99.9769 202.072L74.5254 157.939C72.0323 153.614 75.1487 148.209 80.135 148.209H135.522C137.837 148.209 139.974 149.446 141.132 151.453L166.583 195.586C169.076 199.911 165.96 205.317 160.974 205.317Z",
    fill: "#B0B3F6",
    origin: "50% 83.1%",
    axis: [0.87, 0.49],
    out: [0, 1]
  },
  {
    d: "M40.7394 200.572L67.1953 151.857C68.2994 149.821 68.2389 147.35 67.0279 145.371L40.4581 101.905C37.8545 97.6479 31.6216 97.8048 29.2389 102.194L2.78656 150.909C1.68245 152.945 1.74299 155.416 2.95395 157.395L29.5238 200.86C32.1274 205.118 38.3603 204.961 40.743 200.572H40.7394Z",
    fill: "#A691DF",
    origin: "14.2% 68%",
    axis: [0, 1],
    out: [-0.94, 0.34]
  }
], jA = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='${Ql}'>${ma.map((n) => `<path d='${n.d}'/>`).join("")}</svg>`
)}")`;
function LTe(n, e) {
  return {
    "--i": String(e),
    "--ox": n.origin.split(" ")[0],
    "--oy": n.origin.split(" ")[1],
    "--ax": String(n.axis[0]),
    "--ay": String(n.axis[1]),
    "--dx": String(n.out[0]),
    "--dy": String(n.out[1])
  };
}
const BTe = 800;
function FTe() {
  var n;
  const e = performance.now(), t = (n = window.__rdMarkLoaderClock) != null ? n : window.__rdMarkLoaderClock = { epoch: e, live: 0, lastSeen: -1 / 0 };
  return t.live === 0 && e - t.lastSeen > BTe && (t.epoch = e), t.live++, Math.round(e - t.epoch);
}
function NTe() {
  const n = window.__rdMarkLoaderClock;
  n && (n.live = Math.max(0, n.live - 1), n.lastSeen = performance.now());
}
const UTe = { class: "bd-ml-mark" }, GTe = ["viewBox"], jTe = ["d", "fill"], HA = /* @__PURE__ */ Pe({
  __name: "MarkLoader",
  props: {
    size: { default: 72 }
  },
  setup(n) {
    const e = n, t = FTe();
    return We(NTe), (i, s) => (g(), b("div", {
      class: "bd-mark-loader",
      role: "status",
      "aria-label": "Loading",
      style: ce({ "--ml-size": `${e.size}px`, "--ml-offset": `${m(t)}ms`, "--ml-mask": m(jA) })
    }, [
      s[1] || (s[1] = u("div", { class: "bd-ml-glow" }, null, -1)),
      u("div", UTe, [
        (g(!0), b(j, null, ge(m(ma), (o, r) => (g(), b("svg", {
          key: r,
          class: "bd-ml-facet",
          viewBox: m(Ql),
          style: ce(m(LTe)(o, r)),
          "aria-hidden": "true",
          focusable: "false"
        }, [
          u("path", {
            d: o.d,
            fill: o.fill
          }, null, 8, jTe)
        ], 12, GTe))), 128)),
        s[0] || (s[0] = u("div", { class: "bd-ml-sheen" }, null, -1))
      ])
    ], 4));
  }
}), Qd = [
  { id: "pan", label: "Pan, whole board", hint: "All of it in view", about: "A trackpad pan at the overview, with every object on screen" },
  { id: "zoom", label: "Pinch zoom", hint: "In close and back", about: "Pinch from the overview about 45 times closer and back out, through every level of detail" },
  { id: "pan-near", label: "Pan at 60%", hint: "Images stream in", about: "A steady trackpad pan across copies at 60%, loading images as they come into view" },
  { id: "fly", label: "Fly-through", hint: "Dives and glides", about: "Camera glides: dives into a copy, a long glide across, pull-backs to the overview; reports how long the images take to sharpen after landing" }
];
class xx extends Error {
  constructor() {
    super("Benchmark stopped");
  }
}
const Hb = 4e3;
function Hh(n, e) {
  const t = n.slice().sort((r, a) => r - a), i = (r) => t.length ? t[Math.min(t.length - 1, Math.floor(r * t.length))] : 0, s = i(0.95), o = n.filter((r) => r > e * 3).length;
  return {
    p50: i(0.5),
    p95: s,
    max: t.length ? t[t.length - 1] : 0,
    slow: o,
    n: n.length,
    vsync: e,
    pass: t.length > 0 && s <= e * 1.5 + 1 && o === 0
  };
}
function VA(n = 30) {
  return new Promise((e) => {
    const t = [];
    let i = 0;
    const s = (o) => {
      if (i && t.push(o - i), i = o, t.length < n) {
        requestAnimationFrame(s);
        return;
      }
      t.sort((r, a) => r - a), e(t[Math.floor(t.length / 2)]);
    };
    requestAnimationFrame(s);
  });
}
const Y0 = (n) => new Promise((e) => setTimeout(e, n));
function Op(n) {
  if (n.cancelled && n.cancelled()) throw new xx();
}
function HTe(n) {
  const e = n.worldEl && n.worldEl.closest('[data-testid="stage"]');
  if (!e) throw new Error("The board is not on screen");
  return e;
}
async function WA(n, e = 6e3, t) {
  const i = performance.now();
  for (await Y0(300); performance.now() - i < e && (t && Op(t), !(!n.engine || n.engine.textureStats().pending === 0)); )
    await Y0(50);
  return performance.now() - i;
}
function Vh(n) {
  const e = n.store.bounds() || { x: 0, y: 0, w: n.view.w, h: n.view.h };
  return dm(e, n.view.w, n.view.h, 120, 1);
}
function Wh(n, e) {
  let t = null;
  for (const s of n.store.all()) {
    if (s.type !== "frame") continue;
    const o = He(s);
    o.x < e.x || o.y < e.y || o.x + o.w > e.x + e.w || o.y + o.h > e.y + e.h || (!t || o.w * o.h > t.w * t.h) && (t = o);
  }
  const i = t || e;
  return { x: i.x + i.w / 2, y: i.y + i.h / 2 };
}
function Vb(n, e, t) {
  return new Promise((i, s) => {
    const o = [];
    let r = 0, a = 0;
    const l = (d) => {
      if (n.cancelled && n.cancelled()) {
        s(new xx());
        return;
      }
      r || (r = d), a && o.push(d - a), a = d;
      const c = d - r;
      if (n.onProgress && n.onProgress(Math.min(1, c / e)), c >= e) {
        i(o);
        return;
      }
      t(c), requestAnimationFrame(l);
    };
    requestAnimationFrame(l);
  });
}
function VTe(n) {
  return new Promise((e, t) => {
    const i = [];
    let s = !1, o = null;
    n.then(() => {
      s = !0;
    }, (l) => {
      o = l, s = !0;
    });
    let r = 0;
    const a = (l) => {
      if (r && i.push(l - r), r = l, s) {
        o ? t(o) : e(i);
        return;
      }
      requestAnimationFrame(a);
    };
    requestAnimationFrame(a);
  });
}
function Wb(n, e) {
  const t = n.getBoundingClientRect();
  n.dispatchEvent(new WheelEvent("wheel", {
    deltaMode: 0,
    clientX: t.left + t.width / 2,
    clientY: t.top + t.height / 2,
    bubbles: !0,
    cancelable: !0,
    ...e
  }));
}
async function qb(n, e, t) {
  n.onPhase && n.onPhase("warm"), n.onProgress && n.onProgress(0), n.board.setCamera(e), await WA(n.board, t, n);
}
async function WTe(n, e) {
  const { board: t, layout: i } = e;
  if (!t.engine) throw new Error("The board is still loading");
  const s = HTe(t), o = t.view.w, r = t.view.h, a = i.tiles[Math.floor(i.rows / 2) * i.cols + Math.floor(i.cols / 2)] || i.tiles[0];
  if (n === "pan" || n === "zoom")
    await qb(e, Vh(t), 8e3);
  else if (n === "pan-near") {
    const T = Wh(t, a);
    await qb(e, rl(T.x, T.y, 0.6, o, r), 5e3);
  } else
    await qb(e, Vh(t), 8e3);
  Op(e);
  const l = await VA();
  Op(e), e.onPhase && e.onPhase("measure");
  const d = l / (1e3 / 60);
  if (n === "pan") {
    const T = await Vb(e, Hb, (k) => {
      const P = k / 16.666666666666668;
      Wb(s, { deltaX: 12 * d * Math.cos(P / 17), deltaY: 9 * d * Math.cos(P / 23) });
    });
    return Hh(T, l);
  }
  if (n === "pan-near") {
    const T = await Vb(e, Hb, (k) => {
      const P = k / 16.666666666666668;
      Wb(s, { deltaX: d * (26 + 8 * Math.sin(P / 13)), deltaY: 14 * d * Math.cos(P / 23) });
    });
    return Hh(T, l);
  }
  if (n === "zoom") {
    const T = await Vb(e, Hb, (k) => {
      const P = k / 16.666666666666668;
      Wb(s, { deltaY: -8 * d * Math.sin(P / 20), ctrlKey: !0 });
    });
    return Hh(T, l);
  }
  const c = t.engine, h = i.tiles[Math.min(i.tiles.indexOf(a) + 2, i.tiles.length - 1)], f = i.tiles[i.tiles.length - 1], p = Wh(t, a), y = Wh(t, h), v = Wh(t, f), x = [
    { cam: dm(a, o, r, 60, 1), ms: 1400 },
    { cam: rl(p.x, p.y, 0.6, o, r), ms: 900, sharp: !0 },
    { cam: rl(y.x, y.y, 0.6, o, r), ms: 2200 },
    { cam: Vh(t), ms: 1400 },
    { cam: rl(v.x, v.y, 1, o, r), ms: 1700, sharp: !0 },
    { cam: Vh(t), ms: 1400 }
  ], w = x.reduce((T, k) => T + k.ms, 0);
  let S = 0;
  const M = (async () => {
    let T = 0;
    for (const k of x) {
      Op(e);
      const P = performance.now(), A = window.setInterval(() => {
        e.onProgress && e.onProgress(Math.min(1, (T + Math.min(k.ms, performance.now() - P)) / w));
      }, 100);
      try {
        await c.animateCamera(k.cam, k.ms);
      } finally {
        clearInterval(A);
      }
      T += k.ms, k.sharp ? S = Math.max(S, await WA(t, 5e3, e)) : await Y0(250);
    }
  })(), _ = await VTe(M);
  return e.onProgress && e.onProgress(1), { ...Hh(_, l), sharpMs: S };
}
const qTe = [1e3, 4500, 1e4, 2e4], KTe = 4500, YTe = 5e4;
function Y4(n) {
  const e = Math.round(Number(n));
  return !Number.isFinite(e) || e <= 0 ? KTe : Math.min(YTe, e);
}
const X4 = (n) => Math.round(n).toLocaleString("en-US"), qh = (n) => (Math.round(n * 10) / 10).toFixed(1);
function XTe(n) {
  const e = (l) => {
    const d = n.match(l);
    return d ? d[1] : null;
  };
  let t = "Browser";
  const i = e(/Edg\/(\d+)/), s = e(/Chrome\/(\d+)/), o = e(/Firefox\/(\d+)/), r = e(/Version\/(\d+(?:\.\d+)?).*Safari/);
  i ? t = "Edge " + i : s ? t = "Chrome " + s : o ? t = "Firefox " + o : r && (t = "Safari " + r);
  let a = "";
  return /Mac OS X/.test(n) ? a = "macOS" : /Windows/.test(n) ? a = "Windows" : /Android/.test(n) ? a = "Android" : /iPhone|iPad/.test(n) ? a = "iOS" : /Linux/.test(n) && (a = "Linux"), a ? t + " on " + a : t;
}
function qA(n) {
  return n.pass ? "Smooth" : "Dropped frames";
}
function JTe(n, e, t) {
  const i = (l, d) => l.length >= d ? l + " " : l + " ".repeat(d - l.length), s = [], o = t.getFullYear() + "-" + String(t.getMonth() + 1).padStart(2, "0") + "-" + String(t.getDate()).padStart(2, "0") + " " + String(t.getHours()).padStart(2, "0") + ":" + String(t.getMinutes()).padStart(2, "0");
  s.push("Boards stress test, " + o);
  let r = 0;
  for (const l of n) for (const d of Object.values(l.results)) d && d.vsync && (r = d.vsync);
  const a = [XTe(e.userAgent), e.viewport.w + "×" + e.viewport.h + " at " + e.dpr + "x"];
  r && a.push(Math.round(1e3 / r) + " Hz display (" + qh(r) + " ms frames)"), e.cores && a.push(e.cores + " cores"), e.memoryGB && a.push(e.memoryGB + " GB memory"), s.push(a.join(" · "));
  for (const l of n) {
    const d = Qd.filter((c) => l.results[c.id]);
    if (d.length) {
      s.push(""), s.push(X4(l.images) + " images · " + X4(l.objects) + " objects · " + l.copies + " copies (" + l.cols + " × " + l.rows + ")");
      for (const c of d) {
        const h = l.results[c.id];
        let f = "  " + i(c.label, 19) + i("p50 " + qh(h.p50), 10) + i("p95 " + qh(h.p95), 10) + i("max " + qh(h.max), 11) + i(h.slow + " slow", 8) + qA(h);
        h.sharpMs != null && (f += ", sharp in " + (h.sharpMs / 1e3).toFixed(1) + " s"), s.push(f);
      }
    }
  }
  return s.push(""), s.push("Frame times in ms. Smooth: p95 within 1.5 display frames and no frame past 3."), s.join(`
`);
}
const ZTe = { class: "sx-head" }, QTe = { class: "sx-mark" }, eCe = { class: "sx-title" }, tCe = { key: 0 }, nCe = { key: 1 }, iCe = ["title"], sCe = { class: "sx-pinned" }, oCe = {
  class: "sx-graph",
  title: "Frame times, newest on the right. The line is the budget: 1.5 display frames."
}, rCe = { class: "sx-graph-label" }, aCe = { class: "sx-live" }, lCe = { title: "CPU time of the last frame the board drew" }, dCe = { title: "Elements inside the view" }, cCe = { title: "Notes, sessions and labels mounted as DOM" }, uCe = { title: "GPU memory held by image textures (budget 420 MB)" }, hCe = { title: "Image renditions queued or decoding" }, pCe = { title: "JavaScript heap in use (Chrome only)" }, fCe = {
  class: "sx-tabs",
  role: "tablist"
}, mCe = ["aria-selected"], gCe = ["aria-selected"], bCe = {
  key: 0,
  class: "sx-dot"
}, vCe = {
  key: 1,
  class: "sx-tab-n"
}, yCe = { class: "sx-body" }, xCe = {
  key: 0,
  class: "sx-pane"
}, wCe = {
  class: "sx-seg",
  role: "radiogroup",
  "aria-label": "Board size"
}, kCe = ["aria-checked", "disabled", "data-testid", "onClick"], _Ce = {
  class: "sx-counts",
  "data-testid": "stress-counts"
}, SCe = { class: "sx-big" }, MCe = {
  class: "is-grad",
  "data-testid": "stress-images"
}, TCe = { class: "sx-big" }, CCe = { "data-testid": "stress-objects" }, ICe = { key: 0 }, ACe = { class: "sx-row" }, PCe = ["disabled"], ECe = ["disabled"], RCe = ["disabled"], zCe = ["disabled"], $Ce = {
  key: 1,
  class: "sx-pane"
}, DCe = { class: "sx-bench" }, OCe = ["data-testid"], LCe = ["title"], BCe = {
  key: 0,
  class: "sx-phase"
}, FCe = {
  key: 2,
  class: "sx-hint"
}, NCe = ["disabled", "title", "aria-label", "onClick"], UCe = {
  key: 0,
  class: "sx-bench-res",
  "data-testid": "stress-result"
}, GCe = {
  key: 1,
  class: "sx-progress"
}, jCe = { class: "sx-note" }, HCe = { class: "sx-actions" }, VCe = ["disabled"], WCe = ["disabled"], Rs = 120, qCe = /* @__PURE__ */ Pe({
  __name: "StressPanel",
  props: {
    board: {},
    stress: {}
  },
  setup(n) {
    const e = n, t = e.board, i = e.stress, s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = i.collapsed, a = i.tab, l = (U) => U.toLocaleString("en-US"), d = I(() => {
      t.docRev.value, t.results.rev.value;
      const U = { image: 0, video: 0, tool: 0, note: 0, frame: 0, shape: 0, chat: 0 };
      for (const q of t.store.all())
        q.type === "image" ? (U.image++, q.video && U.video++) : q.type in U && U[q.type]++;
      return { ...U, objects: t.store.size, results: t.results.size };
    }), c = I(() => i.layout.value), h = new Float32Array(Rs);
    let f = 0, p = 0, y = 0, v = 0, x = 0, w = null;
    const S = /* @__PURE__ */ qe(1e3 / 60), M = /* @__PURE__ */ qe(0), _ = /* @__PURE__ */ Xt({ frameMs: 0, visible: 0, dom: 0, textureMB: 0, pending: 0, heapMB: 0 }), T = I(() => {
      const U = 1e3 / S.value;
      return M.value ? M.value < U * 0.6 ? "is-bad" : M.value < U * 0.9 ? "is-warn" : "" : "";
    });
    function k() {
      const U = o.value;
      if (!U) return;
      const q = U.getBoundingClientRect();
      if (q.width < 2) return;
      const oe = Math.min(2, window.devicePixelRatio || 1);
      U.width = Math.round(q.width * oe), U.height = Math.round(q.height * oe), w = U.getContext("2d");
    }
    function P() {
      const U = o.value;
      if (!U || !w || r.value) return;
      const q = U.width, oe = U.height, de = S.value, pe = de * 4;
      w.clearRect(0, 0, q, oe), w.fillStyle = "rgba(255, 255, 255, 0.12)", w.fillRect(0, Math.round(oe - de * 1.5 / pe * oe), q, 1);
      const Ce = q / Rs, Be = Ce > 3 ? 1 : 0;
      for (let be = 0; be < p; be++) {
        const se = h[(f - p + be + Rs) % Rs], ae = Math.max(2, Math.min(oe, se / pe * oe));
        w.fillStyle = se > de * 3 ? "#ff5c7a" : se > de * 1.5 + 1 ? "#ffb347" : "rgba(55, 211, 153, 0.85)", w.fillRect((Rs - p + be) * Ce, oe - ae, Ce - Be, ae);
      }
    }
    function A(U) {
      y && U - y < 1e3 && (h[f] = U - y, f = (f + 1) % Rs, p = Math.min(Rs, p + 1), P()), y = U, v = requestAnimationFrame(A);
    }
    function R() {
      if (p) {
        const oe = Math.min(p, 60);
        let de = 0;
        for (let pe = 1; pe <= oe; pe++) de += h[(f - pe + Rs) % Rs];
        M.value = Math.round(1e3 / (de / oe));
      }
      const U = t.stats.value;
      if (U && (_.frameMs = U.frameMs, _.visible = U.visible), t.engine) {
        const oe = t.engine.textureStats();
        _.textureMB = oe.mb, _.pending = oe.pending;
      }
      _.dom = t.overlayIds.value.length;
      const q = performance.memory;
      q && (_.heapMB = Math.round(q.usedJSHeapSize / 1048576));
    }
    const D = /* @__PURE__ */ qe(null);
    function O(U) {
      B.value || U === i.images.value || (D.value = U, requestAnimationFrame(() => setTimeout(() => i.rebuild(U), 30)));
    }
    function F(U) {
      t.zoomTo(U);
    }
    function ie() {
      const U = c.value.tiles;
      if (!t.engine || !U.length) return;
      const q = U[Math.floor(Math.random() * U.length)];
      let oe = q;
      for (const de of t.store.all()) {
        if (de.type !== "frame") continue;
        const pe = He(de);
        pe.x >= q.x && pe.y >= q.y && pe.x + pe.w <= q.x + q.w && pe.y + pe.h <= q.y + q.h && (oe === q || pe.w * pe.h > oe.w * oe.h) && (oe = pe);
      }
      t.engine.animateCamera(rl(oe.x + oe.w / 2, oe.y + oe.h / 2, 0.6, t.view.w, t.view.h), 900);
    }
    const ee = i.reports.get(i.images.value), me = /* @__PURE__ */ Xt(ee ? { ...ee.results } : {}), L = /* @__PURE__ */ qe(null), N = /* @__PURE__ */ qe("warm"), K = /* @__PURE__ */ qe(!1), B = I(() => !!L.value || D.value != null), re = I(() => Qd.filter((U) => me[U.id]).length), H = I(() => re.value > 0 || Array.from(i.reports.values()).some((U) => Object.keys(U.results).length > 0));
    let J = !1;
    function Q(U) {
      s.value && s.value.style.setProperty("--sx-p", String(U));
    }
    function ne(U, q) {
      me[U] = q;
      const oe = i.images.value, de = c.value, pe = i.reports.get(oe) || {
        images: d.value.image,
        objects: d.value.objects,
        copies: de.copies,
        cols: de.cols,
        rows: de.rows,
        results: {}
      };
      pe.results[U] = q, i.reports.set(oe, pe);
    }
    async function ue(U) {
      if (!B.value) {
        J = !1;
        for (const q of U) {
          L.value = q, N.value = "warm", Q(0);
          try {
            const oe = await WTe(q, {
              board: t,
              layout: c.value,
              onProgress: Q,
              onPhase: (de) => {
                N.value = de;
              },
              cancelled: () => J
            });
            ne(q, oe);
          } catch (oe) {
            oe instanceof xx || t.toast(oe.message || "The benchmark stopped", "error");
            break;
          }
        }
        L.value = null, Q(0);
      }
    }
    function Z() {
      J = !0;
    }
    function te(U) {
      U.key === "Escape" && L.value && Z();
    }
    function we(U) {
      const q = (de) => (Math.round(de * 10) / 10).toFixed(1);
      let oe = "p95 " + q(U.p95) + " · max " + q(U.max) + " ms · " + U.slow + " slow";
      return U.sharpMs != null && (oe += " · sharp " + (U.sharpMs / 1e3).toFixed(1) + " s"), oe;
    }
    function Fe() {
      const U = navigator;
      return {
        userAgent: U.userAgent,
        dpr: window.devicePixelRatio || 1,
        viewport: { w: window.innerWidth, h: window.innerHeight },
        cores: U.hardwareConcurrency || void 0,
        memoryGB: U.deviceMemory
      };
    }
    async function Me() {
      const U = JTe(Array.from(i.reports.values()).sort((q, oe) => q.images - oe.images), Fe(), /* @__PURE__ */ new Date());
      try {
        await navigator.clipboard.writeText(U), K.value = !0, setTimeout(() => {
          K.value = !1;
        }, 1800);
      } catch {
        t.toast("Couldn't copy the report. The browser blocked clipboard access.", "error");
      }
    }
    function he() {
      r.value = !r.value, r.value || requestAnimationFrame(k);
    }
    return it(() => {
      k(), v = requestAnimationFrame(A), x = window.setInterval(R, 250), window.addEventListener("keydown", te), window.addEventListener("resize", k), VA().then((U) => {
        S.value = U;
      });
    }), We(() => {
      J = !0, cancelAnimationFrame(v), clearInterval(x), window.removeEventListener("keydown", te), window.removeEventListener("resize", k);
    }), (U, q) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: G(["sx", { "is-collapsed": m(r), "is-busy": B.value }]),
      "data-testid": "stress-panel",
      onPointerdown: q[6] || (q[6] = Te(() => {
      }, ["stop"])),
      onWheel: q[7] || (q[7] = Te(() => {
      }, ["stop"]))
    }, [
      u("header", ZTe, [
        u("span", QTe, [
          C($, {
            name: "Gauge",
            size: 15
          })
        ]),
        u("div", eCe, [
          q[8] || (q[8] = u("b", null, "Stress test", -1)),
          m(r) ? (g(), b("span", tCe, E(l(d.value.image)) + " images", 1)) : (g(), b("span", nCe, "Demo board × " + E(c.value.copies), 1))
        ]),
        u("span", {
          class: G(["sx-fps", T.value]),
          title: "Frames per second, from the browser's frame clock",
          "data-testid": "stress-fps"
        }, E(M.value || "–") + " fps", 3),
        u("button", {
          class: "sx-icon",
          title: m(r) ? "Expand the panel" : "Collapse the panel",
          onClick: he
        }, [
          C($, {
            name: m(r) ? "ChevronDown" : "ChevronUp",
            size: 14
          }, null, 8, ["name"])
        ], 8, iCe)
      ]),
      _t(u("div", sCe, [
        u("div", oCe, [
          u("canvas", {
            ref_key: "graph",
            ref: o,
            "aria-hidden": "true"
          }, null, 512),
          u("span", rCe, E((Math.round(S.value * 10) / 10).toFixed(1)) + " ms frames", 1)
        ]),
        u("div", aCe, [
          u("div", lCe, [
            u("b", null, E(_.frameMs.toFixed(1)), 1),
            q[9] || (q[9] = u("span", null, "ms to draw", -1))
          ]),
          u("div", dCe, [
            u("b", null, E(l(_.visible)), 1),
            q[10] || (q[10] = u("span", null, "in view", -1))
          ]),
          u("div", cCe, [
            u("b", null, E(l(_.dom)), 1),
            q[11] || (q[11] = u("span", null, "DOM cards", -1))
          ]),
          u("div", uCe, [
            u("b", null, E(l(_.textureMB)), 1),
            q[12] || (q[12] = u("span", null, "MB textures", -1))
          ]),
          u("div", hCe, [
            u("b", null, E(l(_.pending)), 1),
            q[13] || (q[13] = u("span", null, "loading", -1))
          ]),
          u("div", pCe, [
            u("b", null, E(_.heapMB ? l(_.heapMB) : "–"), 1),
            q[14] || (q[14] = u("span", null, "MB JS heap", -1))
          ])
        ]),
        u("div", fCe, [
          u("button", {
            role: "tab",
            "aria-selected": m(a) === "board",
            class: G({ "is-on": m(a) === "board" }),
            "data-testid": "stress-tab-board",
            onClick: q[0] || (q[0] = (oe) => a.value = "board")
          }, "Board", 10, mCe),
          u("button", {
            role: "tab",
            "aria-selected": m(a) === "bench",
            class: G({ "is-on": m(a) === "bench" }),
            "data-testid": "stress-tab-bench",
            onClick: q[1] || (q[1] = (oe) => a.value = "bench")
          }, [
            q[15] || (q[15] = Y(" Benchmarks ", -1)),
            L.value ? (g(), b("span", bCe)) : re.value ? (g(), b("span", vCe, E(re.value) + "/" + E(m(Qd).length), 1)) : z("", !0)
          ], 10, gCe)
        ])
      ], 512), [
        [xv, !m(r)]
      ]),
      _t(u("div", yCe, [
        m(a) === "board" ? (g(), b("section", xCe, [
          q[26] || (q[26] = u("h4", null, [
            Y("Board size "),
            u("span", null, "images, at least")
          ], -1)),
          u("div", wCe, [
            (g(!0), b(j, null, ge(m(qTe), (oe) => (g(), b("button", {
              key: oe,
              role: "radio",
              "aria-checked": oe === m(i).images.value,
              class: G({ "is-on": oe === m(i).images.value }),
              disabled: B.value && D.value !== oe,
              "data-testid": "stress-size-" + oe,
              onClick: (de) => O(oe)
            }, [
              D.value === oe ? (g(), Ie($, {
                key: 0,
                name: "Loader2",
                size: 12,
                spin: ""
              })) : z("", !0),
              Y(" " + E(l(oe)), 1)
            ], 10, kCe))), 128))
          ]),
          u("div", _Ce, [
            u("div", SCe, [
              u("b", MCe, E(l(d.value.image)), 1),
              q[16] || (q[16] = u("span", null, "images", -1))
            ]),
            u("div", TCe, [
              u("b", CCe, E(l(d.value.objects)), 1),
              u("span", null, "objects, " + E(c.value.cols) + " × " + E(c.value.rows) + " copies", 1)
            ]),
            u("dl", null, [
              u("div", null, [
                q[17] || (q[17] = u("dt", null, "Sessions", -1)),
                u("dd", null, E(l(d.value.tool)), 1)
              ]),
              u("div", null, [
                q[18] || (q[18] = u("dt", null, "Notes", -1)),
                u("dd", null, E(l(d.value.note)), 1)
              ]),
              d.value.chat ? (g(), b("div", ICe, [
                q[19] || (q[19] = u("dt", null, "Chats", -1)),
                u("dd", null, E(l(d.value.chat)), 1)
              ])) : z("", !0),
              u("div", null, [
                q[20] || (q[20] = u("dt", null, "Frames", -1)),
                u("dd", null, E(l(d.value.frame)), 1)
              ]),
              u("div", null, [
                q[21] || (q[21] = u("dt", null, "Shapes", -1)),
                u("dd", null, E(l(d.value.shape)), 1)
              ]),
              u("div", null, [
                q[22] || (q[22] = u("dt", null, "Videos", -1)),
                u("dd", null, E(l(d.value.video)), 1)
              ]),
              u("div", null, [
                q[23] || (q[23] = u("dt", null, "Results", -1)),
                u("dd", null, E(l(d.value.results)), 1)
              ])
            ])
          ]),
          q[27] || (q[27] = u("h4", { class: "sx-h-gap" }, "Camera", -1)),
          u("div", ACe, [
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "See the whole board",
              onClick: q[2] || (q[2] = (oe) => m(t).fit())
            }, [
              C($, {
                name: "Scan",
                size: 13
              }),
              q[24] || (q[24] = Y("Fit all", -1))
            ], 8, PCe),
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "Zoom to 60%",
              onClick: q[3] || (q[3] = (oe) => F(0.6))
            }, "60%", 8, ECe),
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "Zoom to 100%",
              onClick: q[4] || (q[4] = (oe) => F(1))
            }, "100%", 8, RCe),
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "Fly to a random copy",
              onClick: ie
            }, [
              C($, {
                name: "LocateFixed",
                size: 13
              }),
              q[25] || (q[25] = Y("Random", -1))
            ], 8, zCe)
          ])
        ])) : (g(), b("section", $Ce, [
          u("ul", DCe, [
            (g(!0), b(j, null, ge(m(Qd), (oe) => (g(), b("li", {
              key: oe.id,
              class: G({ "is-running": L.value === oe.id }),
              "data-testid": "stress-bench-" + oe.id
            }, [
              u("div", {
                class: "sx-bench-name",
                title: oe.about
              }, [
                u("b", null, E(oe.label), 1),
                L.value === oe.id ? (g(), b("span", BCe, E(N.value === "warm" ? "Loading the start" + (_.pending ? ", " + l(_.pending) + " to go" : "") : "Measuring"), 1)) : me[oe.id] ? (g(), b("span", {
                  key: 1,
                  class: G(["sx-pill", me[oe.id].pass ? "is-ok" : "is-bad"]),
                  "data-testid": "stress-verdict"
                }, E(m(qA)(me[oe.id])), 3)) : (g(), b("span", FCe, E(oe.hint), 1))
              ], 8, LCe),
              u("button", {
                class: "sx-play",
                disabled: B.value,
                title: "Run " + oe.label.toLowerCase(),
                "aria-label": "Run " + oe.label.toLowerCase(),
                onClick: (de) => ue([oe.id])
              }, [
                L.value === oe.id ? (g(), Ie($, {
                  key: 0,
                  name: "Loader2",
                  size: 13,
                  spin: ""
                })) : (g(), Ie($, {
                  key: 1,
                  name: "Play",
                  size: 12
                }))
              ], 8, NCe),
              me[oe.id] && L.value !== oe.id ? (g(), b("div", UCe, E(we(me[oe.id])), 1)) : z("", !0),
              L.value === oe.id ? (g(), b("div", GCe)) : z("", !0)
            ], 10, OCe))), 128))
          ]),
          u("p", jCe, E(L.value ? "Hands off the board while it runs. Esc stops it." : "Smooth: p95 under 1.5 frames, none over 3."), 1),
          u("div", HCe, [
            L.value ? (g(), b("button", {
              key: 0,
              class: "bd-btn is-ghost",
              "data-testid": "stress-stop",
              onClick: Z
            }, [
              C($, {
                name: "Square",
                size: 12
              }),
              q[28] || (q[28] = Y("Stop", -1))
            ])) : (g(), b("button", {
              key: 1,
              class: "bd-btn",
              disabled: B.value,
              "data-testid": "stress-run-all",
              onClick: q[5] || (q[5] = (oe) => ue(m(Qd).map((de) => de.id)))
            }, [
              C($, {
                name: "Play",
                size: 12
              }),
              q[29] || (q[29] = Y("Run all", -1))
            ], 8, VCe)),
            u("button", {
              class: "bd-btn is-ghost",
              disabled: !H.value,
              "data-testid": "stress-copy",
              onClick: Me
            }, [
              C($, {
                name: K.value ? "Check" : "Copy",
                size: 13
              }, null, 8, ["name"]),
              Y(E(K.value ? "Copied" : "Copy report"), 1)
            ], 8, WCe)
          ])
        ]))
      ], 512), [
        [xv, !m(r)]
      ])
    ], 34));
  }
}), KCe = "/internal/canvas-boards", YCe = 100, XCe = 200, JCe = 100;
function ja(n) {
  return n && n.trim() ? n.trim() : null;
}
function ZCe(n) {
  const e = new URLSearchParams(), t = ja(n.teamId);
  t && e.set("team_id", t), n.view && e.set("view", n.view);
  const i = ja(n.cursor);
  i && e.set("cursor", i), e.set("limit", String(Math.min(YCe, Math.max(1, Math.floor(n.limit) || 1)))), ja(n.customFieldKey);
  const s = ja(n.q);
  s && e.set("q", s.slice(0, XCe));
  const o = Array.from(new Set(n.ownerUserIds.map((a) => ja(a)).filter((a) => !!a))).slice(0, JCe);
  o.length && e.set("owner_user_id", o.join(","));
  const r = ja(n.accessLevel);
  return r && e.set("access_level", r), e;
}
function uu(n) {
  return n !== null && typeof n == "object" && !Array.isArray(n) ? n : null;
}
function zi(n) {
  return typeof n == "string" && n ? n : null;
}
function QCe(n) {
  const e = uu(n), t = e ? zi(e.key) : null;
  return !e || !t ? null : { key: t, label: zi(e.label), value: typeof e.value == "string" ? e.value : null };
}
function eIe(n) {
  const e = uu(n), t = e ? zi(e.id) : null;
  return !e || !t ? null : {
    id: t,
    created: zi(e.created),
    title: zi(e.title),
    description: zi(e.description),
    accessLevel: zi(e.access_level) || "PRIVATE",
    ownerUserId: zi(e.owner_user_id),
    ownerEmail: zi(e.owner_email),
    teamId: zi(e.team_id),
    avatarUrl: zi(e.avatar_url),
    customFields: Array.isArray(e.custom_fields) ? e.custom_fields.map(QCe).filter((i) => i !== null) : []
  };
}
function tIe(n) {
  const e = uu(n) || {};
  return {
    rows: Array.isArray(e.data) ? e.data.map(eIe).filter((t) => t !== null) : [],
    nextCursor: zi(e.next_cursor),
    hasMore: !!e.has_more
  };
}
async function nIe(n) {
  var e;
  try {
    const t = uu((e = uu(await n.json())) == null ? void 0 : e.error) || {};
    return {
      code: typeof t.code == "string" ? t.code : void 0,
      message: typeof t.message == "string" ? t.message : void 0
    };
  } catch {
    return {};
  }
}
async function iIe(n, e, t) {
  let i;
  try {
    i = await t(n, { method: "GET", headers: e });
  } catch {
    return { ok: !1, reason: "network" };
  }
  if (!i.ok) {
    const { code: s, message: o } = await nIe(i);
    return { ok: !1, reason: s === "INVALID_CURSOR" ? "stale-cursor" : i.status === 401 ? "unauthorized" : i.status === 403 ? "forbidden" : "failed", ...s ? { code: s } : {}, message: o || "HTTP " + i.status };
  }
  try {
    return { ok: !0, body: await i.json() };
  } catch {
    return { ok: !1, reason: "failed", message: "Invalid JSON" };
  }
}
async function sIe(n, e, t, i = window.fetch.bind(window)) {
  const s = ZCe(t).toString(), o = n.replace(/\/$/, "") + KCe + (s ? "?" + s : ""), r = await iIe(o, { Authorization: "Bearer " + e.idToken, "X-Device-Id": e.deviceId }, i);
  return r.ok ? { ok: !0, page: tIe(r.body) } : r;
}
const oIe = {
  key: 0,
  class: "cv-root bd-root"
}, rIe = { class: "bd-center" }, aIe = {
  class: "bd-error-card",
  "data-testid": "board-error"
}, lIe = { style: { "margin-bottom": "16px" } }, dIe = { class: "bd-error-actions" }, cIe = {
  key: 0,
  class: "bd-root bd-splash",
  "data-testid": "board-opening"
}, KA = /* @__PURE__ */ Pe({
  __name: "BoardApp",
  props: {
    env: {}
  },
  setup(n) {
    const t = n.env, i = /* @__PURE__ */ qe(null);
    let s = null;
    function o() {
      s && s(), s = null;
      const l = i.value;
      l && (l.feedback && l.feedback.dispose(), l.dispose(), i.value = null, t.onController && t.onController(null));
    }
    function r(l) {
      if (o(), !l) return;
      const d = t.servicesFor ? t.servicesFor(l) : null;
      let c = null;
      const h = () => c ? { title: c.meta.title, teamId: c.meta.teamId, ownerId: c.meta.ownerId, accessLevel: c.meta.accessLevel } : { title: "", teamId: null, ownerId: "", accessLevel: null }, f = t.commentsFor ? t.commentsFor(l, h) : null, p = t.initialComment || null;
      t.initialComment = null;
      const y = t.linkedFrom && t.linkedFrom.id !== l ? t.linkedFrom : null;
      t.linkedFrom = null;
      const v = new Rf({
        boardId: l,
        sync: t.directory.open(l),
        user: t.user,
        catalog: t.catalog,
        gen: d ? d.gen : t.gen,
        runs: d ? d.runs : null,
        prompts: d ? d.prompts : null,
        favorites: d ? d.favorites : null,
        pins: d ? d.pins : null,
        models: d ? d.models : null,
        balance: d ? d.balance : null,
        teamStatus: d ? d.teamStatus : null,
        library: d ? d.library : t.library || null,
        companyTools: d ? d.companyTools : null,
        featured: d ? d.featured : t.featured || null,
        myPrompts: d ? d.myPrompts : t.myPrompts || null,
        labels: t.labels,
        onGetTokens: t.getTokens,
        canBuyTokens: t.canBuyTokens,
        onOpenTour: t.openTour ? () => t.openTour(l) : void 0,
        track: t.track,
        storageUrl: t.storageUrl,
        studio: { ...t.studio || {}, ...d ? { annotate: d.annotate } : {} },
        initialCamera: t.initialCamera,
        onCameraSettled: t.onCameraSettled,
        initialStudio: t.initialStudio,
        onStudio: t.onStudio,
        onTitle: t.onTitle,
        comments: f ? {
          store: f,
          linkFor: t.commentLink,
          openAt: (w, S) => {
            t.initialComment = S, t.openBoard(w);
          },
          initial: p,
          onShown: t.clearCommentLink
        } : null,
        agent: t.agent || null,
        boardLinks: {
          // the boards list's listing, which the server keeps to what you may open (R1); the harness lists its own
          list: async (w, S) => {
            const M = t.boardsApi;
            if (M) {
              const T = await M.credentials();
              if (!T) return [];
              const k = await sIe(M.baseUrl, T, {
                teamId: w,
                view: "all",
                cursor: null,
                limit: 100,
                customFieldKey: null,
                q: S || null,
                ownerUserIds: [],
                accessLevel: null
              });
              if (!k.ok)
                throw k.code && M.onRejected && M.onRejected(k.code), new Error(k.message || k.reason);
              return k.page.rows.map((P) => ({ id: P.id, title: P.title || "Untitled board", at: P.created ? Date.parse(P.created) : null }));
            }
            const _ = S.toLowerCase();
            return (await t.directory.list()).filter((T) => (T.teamId || null) === (w || null) && (!_ || (T.title || "").toLowerCase().includes(_))).map((T) => ({ id: T.id, title: T.title || "Untitled board", at: T.updatedAt || T.createdAt || null }));
          },
          get: async (w) => {
            const S = t.directory.get ? await t.directory.get(w) : (await t.directory.list()).find((M) => M.id === w) || null;
            return S ? { id: S.id, title: S.title || "Untitled board" } : null;
          },
          create: async (w) => {
            const S = await t.directory.create(w);
            return { id: S.id, title: S.title || w };
          },
          open: (w, S) => {
            t.linkedFrom = S, t.openBoard(w);
          }
        },
        linkedFrom: y
      });
      c = v, v.uploader = t.uploaderFor ? t.uploaderFor(l) : null;
      const x = t.feedback;
      x && (v.feedback = new i3e({ board: v, recorder: x.recorder, sink: x.sink, build: x.build }), s = A_e(x.recorder, v)), v.ui.showStats = P1, i.value = v, t.onController && t.onController(v), v.load(), t.initialCamera = null, t.initialStudio = null;
    }
    Ee(() => t.ready.value ? t.boardId.value : void 0, (l) => {
      l !== void 0 && r(l);
    }, { immediate: !0 }), We(() => {
      i.value ? o() : t.onController && t.onController(null);
    });
    const a = I(() => !t.ready.value || !!i.value && !i.value.loadError.value && !i.value.loaded.value);
    return (l, d) => (g(), b(j, null, [
      m(t).ready.value && i.value ? (g(), b(j, { key: 0 }, [
        i.value.loadError.value ? (g(), b("div", oIe, [
          u("div", rIe, [
            u("div", aIe, [
              u("b", null, E(i.value.loadErrorKind.value === "not-canvas" ? "This board opens in Boards" : "This board couldn't be opened"), 1),
              u("div", lIe, E(i.value.loadError.value), 1),
              u("div", dIe, [
                i.value.loadErrorKind.value === "not-canvas" && m(t).openRunnit ? (g(), b("button", {
                  key: 0,
                  class: "bd-btn",
                  "data-testid": "open-in-boards",
                  onClick: d[0] || (d[0] = (c) => m(t).openRunnit(i.value.meta.id))
                }, " Open in Boards ")) : z("", !0),
                u("button", {
                  class: "bd-btn is-ghost",
                  onClick: d[1] || (d[1] = (c) => m(t).openBoard(null))
                }, "Back to boards")
              ])
            ])
          ])
        ])) : i.value.loaded.value ? (g(), Ie(OTe, {
          key: i.value.meta.id,
          board: i.value,
          "on-home": m(t).home,
          "on-index": () => m(t).openBoard(null)
        }, $E({ _: 2 }, [
          m(t).stress ? {
            name: "hud",
            fn: Xe(() => [
              C(qCe, {
                board: i.value,
                stress: m(t).stress
              }, null, 8, ["board", "stress"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["board", "on-home", "on-index"])) : z("", !0)
      ], 64)) : z("", !0),
      C(vt, { name: "bd-splash" }, {
        default: Xe(() => [
          a.value ? (g(), b("div", cIe, [
            C(HA)
          ])) : z("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), uIe = '.bd-root{--steel-pink-300: #812686;--steel-pink-500: #c750ce;--amethyst-300: #5722a2;--amethyst-400: #7532d3;--amethyst-500: #9968df;--amethyst-600: #ae86e5;--amethyst-700: #c2a4ec;--amethyst-800: #d6c2f2;--vista-blue-300: #1822dc;--vista-blue-400: #5a61ed;--vista-blue-500: #a3a7f5;--vista-blue-600: #b6b9f7;--bg-deep: #04030c;--bg-base: #070910;--bg-raised: #0b0d14;--bg-surface: #121521;--bg-overlay: rgba(4, 3, 12, .86);--hairline: rgba(255, 255, 255, .1);--hairline-soft: rgba(255, 255, 255, .06);--inset-highlight: inset 0 1px 0 rgba(255, 255, 255, .08);--fg-1: #ffffff;--fg-2: rgba(255, 255, 255, .72);--fg-3: rgba(255, 255, 255, .58);--fg-4: rgba(255, 255, 255, .38);--fg-5: rgba(255, 255, 255, .25);--success: #37d399;--warning: #ffb347;--danger: #ff5c7a;--grad-cta: linear-gradient(90deg, var(--amethyst-500) 0%, #8f72ff 50%, var(--vista-blue-400) 100%);--grad-glass: linear-gradient(180deg, rgba(255, 255, 255, .09), rgba(255, 255, 255, .03));--grad-purple-pink: linear-gradient(90deg, var(--steel-pink-500), var(--amethyst-500), var(--vista-blue-500));--shadow-card: 0 18px 60px rgba(5, 8, 20, .28);--shadow-deep: 0 30px 100px rgba(2, 6, 23, .55);--radius-xs: 6px;--radius-sm: 10px;--radius-md: 16px;--radius-lg: 24px;--radius-pill: 999px;--font-sans: "SpaceGrotesk", "Space Grotesk", system-ui, -apple-system, "Segoe UI", sans-serif;--ease-out-soft: cubic-bezier(.16, 1, .3, 1);--dur-fast: .2s;--dur-med: .3s;--dur-slow: .5s}.bd-root,.bd-root *,.bd-root *:before,.bd-root *:after{box-sizing:border-box;background-repeat:repeat}.bd-root{font-family:var(--font-sans);font-size:14px;line-height:normal;color:var(--fg-2);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}.bd-root button,.bd-root input,.bd-root textarea{font-family:var(--font-sans);letter-spacing:inherit}:where(.bd-root) button,:where(.bd-root) input,:where(.bd-root) textarea{margin:0}.bd-root button{-webkit-tap-highlight-color:transparent}.bd-root button:focus{outline:none}.bd-root button:focus-visible{outline:2px solid rgba(163,167,245,.7);outline-offset:2px}.bd-root p{margin:0}', hIe = `.cv-root{--cv-accent: var(--amethyst-500);--cv-accent-strong: var(--amethyst-400);--cv-accent-soft: rgba(153, 104, 223, .4);--cv-accent-tint: rgba(153, 104, 223, .14);--cv-accent-text: var(--amethyst-700);--cv-guide: var(--amethyst-600);--cv-guide-halo: rgba(4, 3, 12, .35);--cv-glass-a: 1;--cv-blur: 24px;--cv-atmo: 1;--cv-zoom: 1;--cv-inv-zoom: 1;position:fixed;inset:0;overflow:hidden;overflow:clip;background:var(--bg-deep);user-select:none;-webkit-user-select:none;touch-action:none;overscroll-behavior:none;z-index:200}.licon{display:inline-flex;align-items:center;justify-content:center;line-height:0;flex:none}.licon svg{display:block}.licon-spin svg{animation:cvSpin .9s linear infinite}@keyframes cvSpin{to{transform:rotate(360deg)}}.cv-atmo{position:absolute;inset:0;pointer-events:none}.cv-atmo-glow{position:absolute;inset:0;background:radial-gradient(56% 42% at 50% -6%,rgba(255,255,255,.075),transparent 60%),linear-gradient(115deg,#9968df21,#04030c00 30%,#a3a7f51a 68%,#04030c00 90%);opacity:var(--cv-atmo)}.cv-atmo-orb-a,.cv-atmo-orb-b{position:absolute;width:560px;height:560px;border-radius:50%;filter:blur(160px);opacity:calc(.16 * var(--cv-atmo));transform:translateZ(0)}.cv-atmo-orb-a{left:-220px;top:-180px;background:var(--amethyst-500)}.cv-atmo-orb-b{right:-200px;top:-120px;background:var(--vista-blue-400);opacity:calc(.11 * var(--cv-atmo))}.cv-grid{position:absolute;inset:0;pointer-events:none;background-image:radial-gradient(rgba(255,255,255,.85) 1.15px,transparent 1.6px);opacity:calc(.26 * var(--cv-atmo));transition:opacity var(--dur-med) var(--ease-out-soft)}.v2-root.no-grid .cv-grid{opacity:0}.cv-stage{position:absolute;inset:0;overflow:hidden;overflow:clip;cursor:default;outline:none}.cv-stage.is-hand{cursor:grab}.cv-stage.is-dropper{--dropper-cursor: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke-linecap='round' stroke-linejoin='round'><g stroke='%23070910' stroke-width='4'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g><g stroke='white' stroke-width='2'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g></svg>") 2 22, crosshair;cursor:var(--dropper-cursor)}.cv-stage.is-dropper .cv-el,.cv-stage.is-dropper .cv-el *{cursor:grab}.cv-stage.is-dropper .cv-el .cv-thumb-pull{cursor:var(--dropper-cursor)}.cv-stage.is-panning,.cv-stage.is-panning *{cursor:grabbing!important}.bd-canvas{position:absolute;left:0;top:0;display:block}.cv-world{position:absolute;left:0;top:0;width:0;height:0;transform-origin:0 0;pointer-events:none}.cv-world.is-moving{will-change:transform}.cv-el{position:absolute;pointer-events:auto}.cv-el-body{position:relative;width:100%;height:100%;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-el.is-dragging .cv-el-body{transition:none}@media(prefers-reduced-motion:no-preference){.cv-el.cv-enter{animation:cvEnter .65s var(--ease-out-soft) both;animation-delay:var(--d, 0s)}@keyframes cvEnter{0%{opacity:0;transform:translateY(34px)}to{opacity:1;transform:translateY(0)}}}.cv-ring{position:absolute;inset:calc(-3px * var(--cv-inv-zoom));border-radius:inherit;pointer-events:none;border:calc(1.5px * var(--cv-inv-zoom)) solid var(--cv-accent);box-shadow:0 0 0 calc(4px * var(--cv-inv-zoom)) var(--cv-accent-tint);opacity:0;transition:opacity var(--dur-fast)}.is-selected>.cv-el-body>*>.cv-ring,.is-selected .cv-bucket>.cv-ring,.is-selected .cv-note>.cv-ring{opacity:1}.cv-bucket{width:100%;border-radius:var(--radius-md);background:linear-gradient(180deg,rgba(255,255,255,calc(.09 * var(--cv-glass-a))),rgba(255,255,255,calc(.03 * var(--cv-glass-a))));border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(var(--cv-blur));-webkit-backdrop-filter:blur(var(--cv-blur));padding:14px;cursor:pointer;position:relative;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-world.is-moving .cv-bucket,.cv-world.is-crowded .cv-bucket{backdrop-filter:none;-webkit-backdrop-filter:none}.cv-el:hover .cv-bucket{transform:translateY(-4px);box-shadow:var(--inset-highlight),0 24px 70px #05081461}.cv-el.is-dragging .cv-bucket,.cv-el.is-open .cv-bucket{transform:none}.cv-bucket .cv-ring{border-radius:var(--radius-md)}.cv-el.is-stack-top:before,.cv-el.is-stack-deep:after{content:"";position:absolute;inset:0;z-index:-1;pointer-events:none;border-radius:var(--radius-md);background:linear-gradient(180deg,#282a3cf5,#161824f5);border:1px solid rgba(255,255,255,.14);box-shadow:0 10px 26px #04061073;transform:translate(7px,8px);transition:transform var(--dur-med) var(--ease-out-soft)}.cv-el.is-stack-deep:after{z-index:-2;transform:translate(14px,16px);opacity:.7}.cv-el.is-stack-top:hover:before{transform:translate(9px,11px)}.cv-el.is-stack-deep:hover:after{transform:translate(18px,22px)}.cv-stack-badge{position:absolute;top:-11px;right:-11px;z-index:3;display:inline-flex;align-items:center;gap:4px;height:22px;padding:0 8px 0 7px;border-radius:999px;border:1px solid rgba(214,194,242,.45);background:linear-gradient(180deg,#7e56d0f5,#5c4cd6f5);color:#fff;font:600 11px/1 var(--font-sans);font-variant-numeric:tabular-nums;box-shadow:0 4px 14px #543cc873,inset 0 1px #ffffff40;cursor:pointer;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cv-stack-badge:hover,.cv-stack-badge.is-open{transform:scale(1.08);box-shadow:0 6px 18px #543cc899,0 0 0 3px var(--cv-accent-tint),inset 0 1px #ffffff40}.cv-fan{position:fixed;z-index:62;display:flex;gap:10px;align-items:flex-end;pointer-events:auto}.cv-fan.is-below{align-items:flex-start}.cv-fan-card{position:relative;flex:none;width:168px;padding:0;overflow:hidden;display:flex;flex-direction:column;text-align:left;border-radius:13px;border:1px solid var(--hairline);background:#0e101af7;color:var(--fg-1);cursor:pointer;box-shadow:var(--inset-highlight),0 18px 46px #02040c99;transform:var(--tilt);transition:transform var(--dur-med) var(--ease-out-soft),border-color var(--dur-fast),box-shadow var(--dur-med);animation:fanIn .38s var(--ease-out-soft) both;animation-delay:calc(var(--i) * 45ms)}.cv-fan-card:hover{transform:translateY(-6px) scale(1.03);border-color:#c2a4ec8c;box-shadow:var(--inset-highlight),0 22px 56px #02040cb3,0 0 0 3px var(--cv-accent-tint);z-index:1}.cv-fan-card .pic{display:flex;align-items:center;justify-content:center;height:76px;background:#ffffff0a center / cover no-repeat;color:var(--fg-4)}.cv-fan-card .txt{display:flex;flex-direction:column;gap:3px;padding:8px 10px 9px;min-width:0}.cv-fan-card .txt b{font-size:12px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cv-fan-card .txt small{display:flex;align-items:center;gap:4px;font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cv-fan-card .on-top{position:absolute;top:7px;left:7px;height:18px;padding:0 7px;border-radius:999px;display:inline-flex;align-items:center;background:#080910c7;color:var(--fg-2);font-size:9.5px;font-weight:600;letter-spacing:.02em;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}@keyframes fanIn{0%{opacity:0;transform:translateY(26px) scale(.86)}}.cv-fan.is-below .cv-fan-card{animation-name:fanInBelow}@keyframes fanInBelow{0%{opacity:0;transform:translateY(-26px) scale(.86)}}.cv-fan-leave-active{transition:opacity .18s ease,transform .18s ease}.cv-fan-leave-to{opacity:0;transform:translateY(10px) scale(.97)}@media(prefers-reduced-motion:reduce){.cv-fan-card{animation:none}}.cv-el.is-ref-target .cv-bucket{box-shadow:var(--inset-highlight),0 0 0 1px var(--cv-accent-soft),0 18px 54px #9968df4d}.cv-el.is-ref-target .cv-bucket>.cv-ring{opacity:1}.cv-bucket-head{display:flex;align-items:center;gap:10px}.cv-badge{width:36px;height:36px;flex:none;border-radius:12px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;display:flex;align-items:center;justify-content:center;color:var(--cv-accent-text)}.cv-bucket-titles{min-width:0;flex:1}.cv-bucket-kind{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;display:flex;align-items:baseline;min-width:0}.cv-bucket-sep{margin:0 6px;color:var(--fg-5);letter-spacing:0}.cv-bucket-model{min-width:0;overflow:hidden;text-overflow:ellipsis;font-size:10px;font-weight:500;text-transform:none;letter-spacing:.01em;color:var(--fg-5)}.cv-bucket-name{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1px}.cv-bucket-name-input{width:100%;font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:6px;padding:0 5px;margin:0 0 0 -6px;outline:none;height:21px;user-select:text;-webkit-user-select:text}.cv-count{flex:none;font-size:11px;font-weight:600;color:var(--fg-3);background:#ffffff0d;border:1px solid var(--hairline-soft);border-radius:var(--radius-pill);padding:3px 9px;font-variant-numeric:tabular-nums}.cv-fold{flex:none;width:26px;height:26px;margin:0 -4px 0 -2px;padding:0;border:0;border-radius:8px;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.cv-el:hover .cv-fold,.cv-el.is-selected .cv-fold,.cv-el.is-folded .cv-fold,.cv-fold:focus-visible{opacity:1}.cv-fold:hover{color:var(--fg-1);background:#ffffff12}.cv-fold:disabled{display:none}.cv-el.is-folded .cv-bucket{height:100%;padding-top:13px;padding-bottom:13px}.cv-count.is-state{display:inline-flex;align-items:center;justify-content:center;min-width:30px;padding:3px 8px}.cv-count.is-state.is-error{color:#ff8aa0}.cv-count.is-state .ch-pulse{margin:0}.cv-bucket-thumbs{display:flex;gap:6px;margin-top:12px}.cv-bucket-thumbs .cv-thumb{flex:1;aspect-ratio:1}.cv-bucket-thumbs .cv-thumb-empty{flex:1;aspect-ratio:1;border-radius:8px;border:1px dashed rgba(255,255,255,.1);background:#ffffff05}.cv-thumb{border-radius:8px;min-width:0;border:1px solid rgba(255,255,255,.07);box-shadow:inset 0 1px #ffffff0f;background-color:#ffffff0a;background-size:cover;background-position:center}.cv-thumb-pull{cursor:grab;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast),border-color var(--dur-fast)}.cv-thumb-pull:hover{transform:translateY(-2px) scale(1.03);box-shadow:inset 0 1px #ffffff1a,0 10px 26px #05081473;border-color:var(--cv-accent-soft)}.cv-thumb-pull:active{cursor:grabbing}@media(prefers-reduced-motion:no-preference){.cv-thumb.thumb-new{animation:thumbIn .55s var(--ease-out-soft) both;animation-delay:var(--d, 0s)}@keyframes thumbIn{0%{opacity:0;transform:scale(.82)}to{opacity:1;transform:scale(1)}}}.cv-thumb.thumb-shimmer,.cv-thumb-empty.thumb-shimmer{position:relative;overflow:hidden}.cv-thumb.thumb-shimmer:after,.cv-thumb-empty.thumb-shimmer:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}@keyframes shimmer{0%{transform:translate(-100%)}to{transform:translate(100%)}}.cv-bucket-foot{display:flex;align-items:center;justify-content:space-between;margin-top:11px;font-size:11px;color:var(--fg-4)}.cv-bucket-foot .is-error{color:#ff8aa0;display:inline-flex;align-items:center;gap:5px}.cv-bucket-open-hint{display:inline-flex;align-items:center;gap:5px;margin:-3px -6px;padding:3px 6px;border:0;border-radius:7px;background:transparent;color:var(--fg-4);font:inherit;cursor:pointer;opacity:0;transition:opacity var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.cv-el:hover .cv-bucket-open-hint{opacity:1}.cv-bucket-open-hint:hover,.cv-bucket-open-hint:focus-visible{color:var(--fg-1);background:#ffffff12;opacity:1}.cv-thumb-empty.is-open{cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.cv-thumb-empty.is-open:hover{background:#ffffff0d;border-color:#ffffff29}.cv-note{width:100%;height:100%;border-radius:var(--radius-md);padding:16px;display:flex;flex-direction:column;backdrop-filter:blur(var(--cv-blur));-webkit-backdrop-filter:blur(var(--cv-blur));cursor:grab;position:relative;box-shadow:inset 0 1px #ffffff1a,var(--shadow-card);transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-world.is-moving .cv-note,.cv-world.is-crowded .cv-note{backdrop-filter:none;-webkit-backdrop-filter:none}.cv-el.is-dragging .cv-note{cursor:grabbing}.cv-el:hover .cv-note{transform:translateY(-4px)}.cv-el.is-dragging .cv-note,.cv-el.is-selected .cv-note,.cv-note.is-editing{transform:none}.cv-note .cv-ring{border-radius:var(--radius-md)}.cv-note.tint-amethyst{background:linear-gradient(180deg,#9968df2b,#9968df14);border:1px solid rgba(194,164,236,.22)}.cv-note.tint-vista{background:linear-gradient(180deg,#5a61ed2b,#5a61ed14);border:1px solid rgba(163,167,245,.22)}.cv-note.tint-sky{background:linear-gradient(180deg,#3db4e62b,#3db4e614);border:1px solid rgba(153,217,243,.22)}.cv-note.tint-mint{background:linear-gradient(180deg,#34c79a2b,#34c79a14);border:1px solid rgba(143,229,201,.22)}.cv-note.tint-amber{background:linear-gradient(180deg,#f0b44a2b,#f0b44a14);border:1px solid rgba(247,212,143,.22)}.cv-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14);border:1px solid rgba(245,163,199,.22)}.cv-note.tint-glass{background:var(--grad-glass);border:1px solid var(--hairline)}.cv-note-text{flex:1;min-height:0;font-size:13.5px;line-height:1.45;color:#ffffffdb;letter-spacing:-.005em;outline:none;overflow-x:hidden;overflow-y:auto;word-wrap:break-word;white-space:pre-wrap;scrollbar-width:none;overscroll-behavior:contain}.cv-note-text::-webkit-scrollbar{display:none}.cv-note.more-below .cv-note-text{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 28px),transparent)}.cv-note.more-above .cv-note-text{-webkit-mask-image:linear-gradient(0deg,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(0deg,#000 calc(100% - 28px),transparent)}.cv-note.more-above.more-below .cv-note-text{-webkit-mask-image:linear-gradient(180deg,transparent,#000 28px,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(180deg,transparent,#000 28px,#000 calc(100% - 28px),transparent)}.cv-note.is-editing .cv-note-text{cursor:text;user-select:text;-webkit-user-select:text}.cv-note-meta{font-size:10px;color:#ffffff61;font-weight:600;letter-spacing:.16em;text-transform:uppercase;margin-top:8px}.cv-link{padding:14px 16px;gap:6px;cursor:pointer}.cv-link-head{display:flex;align-items:center;gap:7px}.cv-link-head .ic{width:22px;height:22px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:#c9ccfa}.cv-link-head .kind{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#ffffff80}.cv-link-title{flex:1;min-height:0;font-size:16px;font-weight:600;line-height:1.3;letter-spacing:-.01em;color:#fff;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.cv-link-foot{display:flex;align-items:center;justify-content:flex-end;min-height:24px}.cv-link-open{display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 10px;border:0;border-radius:8px;background:#ffffff1a;color:#fff;font:inherit;font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast)}.cv-link-open:hover{background:#ffffff2e}.cv-link .miss{font-size:11px;color:#ffb3c1}.cv-link.is-missing .cv-link-title{color:#ffffff8c;text-decoration:line-through;text-decoration-color:#ffffff4d}.cv-frame-title{position:absolute;left:0;bottom:0;padding:0 0 9px 4px;max-width:calc(100% * var(--cv-zoom));transform:scale(var(--cv-inv-zoom));transform-origin:0 100%;display:flex;align-items:center;gap:10px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;cursor:grab;outline:none;pointer-events:auto}.cv-frame-title .cv-frame-name{min-width:0;overflow:hidden;text-overflow:ellipsis}.cv-frame-title .cv-frame-count{flex:none}.cv-world.is-far .cv-frame-count{display:none}.cv-world.is-far .cv-frame-title{left:8px;padding:3px 8px 3px 9px;font-size:9.5px;letter-spacing:.18em;color:var(--fg-2);max-width:calc(100% * var(--cv-zoom) - 16px);transform:scale(var(--cv-inv-zoom)) translateY(50%);background:#0d0c1ae0;border:1px solid rgba(255,255,255,.09);border-radius:7px;box-shadow:0 4px 14px #00000059}.light-canvas .cv-world.is-far .cv-frame-title{background:#fffffff0;border-color:#1318281a;color:#131828b3;box-shadow:0 4px 14px #13182814}.cv-frame-title .cv-frame-count{letter-spacing:.06em;color:var(--fg-5);text-transform:none;font-weight:500}.cv-frame-title.is-selected{color:var(--cv-accent-text)}.cv-frame-title.is-locked{cursor:default}.cv-frame-title .cv-frame-lock{flex:none;display:inline-flex;margin-right:-4px;color:var(--fg-3)}.cv-frame-title.is-selected .cv-frame-lock{color:inherit}.cv-frame-title-input{font:inherit;letter-spacing:.22em;text-transform:uppercase;color:var(--fg-1);background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:6px;padding:1px 6px;margin:-2px 0 0 -7px;outline:none;min-width:120px;user-select:text;-webkit-user-select:text}.cv-resize{position:absolute;right:calc(-6px * var(--cv-inv-zoom));bottom:calc(-6px * var(--cv-inv-zoom));width:calc(15px * var(--cv-inv-zoom));height:calc(15px * var(--cv-inv-zoom));border-radius:calc(5px * var(--cv-inv-zoom));background:var(--cv-accent);border:calc(2px * var(--cv-inv-zoom)) solid var(--bg-deep);box-shadow:0 0 0 calc(3px * var(--cv-inv-zoom)) var(--cv-accent-tint);cursor:nwse-resize;z-index:7;pointer-events:auto;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-resize:hover{transform:scale(1.15)}.cv-marquee{position:absolute;pointer-events:none;border:1px solid var(--cv-accent-soft);background:var(--cv-accent-tint);border-radius:4px}.cv-guides{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:visible}.cv-guides path{fill:none;stroke-width:1px}.cv-guide-line{stroke:var(--cv-guide);stroke-dasharray:4 4}.cv-guide-gap{stroke:var(--cv-guide)}.cv-guide-halo{stroke:var(--cv-guide-halo);stroke-width:3px!important}.cv-guide-halo.is-dashed{stroke-dasharray:4 4}.cv-vid{position:absolute;pointer-events:none;border-radius:12px;overflow:hidden;opacity:0;transition:opacity .22s var(--ease-out-soft),top .2s var(--ease-out-soft)}.cv-vid.is-shown{opacity:1}.cv-vid video{display:block;width:100%;height:100%;object-fit:cover}.cv-vid-bar{position:absolute;left:0;right:0;bottom:0;height:calc(2px * var(--cv-inv-zoom));background:#ffffff29}.cv-vid-bar i{display:block;height:100%;transform-origin:0 50%;transform:scaleX(0);background:linear-gradient(90deg,var(--amethyst-600),var(--vista-blue-500))}.cv-dropper-ring{position:absolute;pointer-events:none;border-radius:12px;box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) var(--amethyst-500),0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df38;animation:cvFade var(--dur-fast) ease both}.cv-dropper-ring.is-in{box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #ffffff8c}.cv-dropper-chip{position:absolute;left:0;top:0;transform-origin:0 0;transform:translate(calc(8px * var(--cv-inv-zoom)),calc(8px * var(--cv-inv-zoom))) scale(var(--cv-inv-zoom));display:inline-flex;align-items:center;gap:5px;padding:3px 9px 3px 7px;border-radius:999px;background:#04030ccc;color:#fff;font-size:11px;font-weight:600;white-space:nowrap;box-shadow:0 4px 14px #02040c73}.cv-img-hover{position:absolute;pointer-events:none;border-radius:12px;overflow:hidden;transition:transform var(--dur-fast) var(--ease-out-soft)}.cv-img-shade{position:absolute;left:0;right:0;bottom:0;height:46%;background:linear-gradient(180deg,#04030c00,#04030c8c);pointer-events:none;animation:cvFade var(--dur-fast) ease both}.cv-img-foot{position:absolute;left:12px;bottom:9px;right:9px;display:flex;align-items:center;gap:8px;pointer-events:none}.cv-img-label{flex:1;min-width:0;font-size:11px;font-weight:500;color:#ffffffc7;letter-spacing:.01em;pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;animation:cvFade var(--dur-fast) ease both}.cv-img-model{flex:none;max-width:60%;padding:2px 8px;border-radius:var(--radius-pill);background:#0c0e1894;border:1px solid rgba(255,255,255,.12);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);font-size:10.5px;font-weight:600;color:#ffffffe6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;animation:cvFade var(--dur-fast) ease both}.cv-img-actions{position:absolute;top:8px;right:8px;display:flex;gap:4px;pointer-events:auto;animation:cvFade var(--dur-fast) ease both}@keyframes cvFade{0%{opacity:0}to{opacity:1}}.cv-img-hint{--s: var(--cv-inv-zoom);flex:none;display:inline-flex;align-items:center;gap:calc(6px * var(--s));padding:calc(3px * var(--s)) calc(9px * var(--s)) calc(3px * var(--s)) calc(3px * var(--s));border-radius:var(--radius-pill);background:#0c0e189e;border:calc(1px * var(--s)) solid rgba(255,255,255,.1);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);font-size:calc(10.5px * var(--s));font-weight:500;color:#fffc;white-space:nowrap;animation:cvFade .3s ease .7s both}.cv-img-hint kbd{display:inline-flex;align-items:center;justify-content:center;min-width:calc(18px * var(--s));height:calc(17px * var(--s));padding:0 calc(5px * var(--s));border-radius:999px;background:#ffffff1f;color:#fff;font-family:var(--font-sans);font-size:calc(10px * var(--s));font-weight:600;line-height:1}.cv-img-actions button{width:26px;height:26px;border:1px solid rgba(255,255,255,.1);border-radius:8px;background:#0c0e189e;backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);color:#ffffffb8;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:background var(--dur-fast),color var(--dur-fast)}.cv-img-actions button:hover{background:#141624d9;color:#fff}.cv-img-badges{position:absolute;pointer-events:none}.cv-img-vid{position:absolute;left:10px;top:10px;display:inline-flex;align-items:center;gap:5px;padding:4px 9px;border-radius:var(--radius-pill);background:#04030c94;border:1px solid rgba(255,255,255,.12);font-size:10px;font-weight:600;color:#ffffffd1;font-variant-numeric:tabular-nums}.cv-img-fav{position:absolute;top:8px;left:8px;width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:#04030c9e;color:#ef5f7a}.cv-img-vid+.cv-img-fav{left:auto;right:8px}.cv-img-fav svg{fill:currentColor}.cv-img-missing{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:6px;color:var(--fg-4);font-size:11px;pointer-events:none}.cv-topbar{position:absolute;top:0;left:0;right:0;height:60px;z-index:48;display:flex;align-items:center;gap:16px;padding:0 18px;background:#0709109e;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-bottom:1px solid var(--hairline-soft)}.cv-topbar-left{display:flex;align-items:center;gap:12px;flex:1;min-width:0}.cv-topbar-right{display:flex;align-items:center;gap:14px;flex:1;justify-content:flex-end}.cv-mark{width:34px;height:30px;border-radius:9px;flex:none;display:flex;align-items:center;justify-content:center;background:none;border:0;cursor:pointer;padding:0;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-med)}.cv-mark svg{display:block;width:28px;height:auto}.cv-mark:hover{transform:scale(1.06);filter:drop-shadow(0 4px 12px rgba(153,104,223,.45))}.cv-mark:focus-visible{outline:none;box-shadow:0 0 0 1px #04030ca6,0 0 0 3px #a3a7f58c}.cv-crumb{font-size:12.5px;color:var(--fg-4);white-space:nowrap;background:none;border:0;padding:0;cursor:pointer;transition:color var(--dur-fast)}.cv-crumb:hover{color:var(--fg-2)}.cv-crumb-sep{color:var(--fg-5);margin:0 -4px}.cv-board-title{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;padding:3px 6px;margin:0 -6px;border-radius:7px;cursor:text;transition:background var(--dur-fast)}.cv-board-title:hover{background:#ffffff0d}.cv-board-title-input{font:inherit;font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1);background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:7px;padding:3px 6px;margin:0 -6px;outline:none;min-width:220px;user-select:text;-webkit-user-select:text}.cv-tokens{display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-tokens .licon{color:var(--fg-4)}.cv-tokens.is-link{cursor:pointer}.cv-tokens.is-link:hover{background:#ffffff12;color:var(--fg-1)}.cv-tokens.is-empty{color:#ffb38a;border-color:#ff8c5a59}.cv-tokens.is-empty .licon{color:#ffb38a}.cv-save-state{display:inline-flex;align-items:center;gap:6px;font-size:11px;color:var(--fg-5);white-space:nowrap;transition:color var(--dur-med)}.cv-save-state .dot{width:6px;height:6px;border-radius:50%;background:var(--fg-5);transition:background var(--dur-med)}.cv-save-state.is-saving .dot{background:var(--warning);animation:syPulse 1.1s ease-in-out infinite}.cv-save-state.is-error{color:#ff8aa0}.cv-save-state.is-error .dot{background:var(--danger)}@keyframes syPulse{0%,to{opacity:1}50%{opacity:.35}}.cv-tool{width:32px;height:32px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.cv-tool:hover{background:#ffffff12;color:var(--fg-1)}.cv-tool.on{background:var(--cv-accent-tint);color:var(--cv-accent-text)}.cv-tool .tip{position:absolute;bottom:calc(100% + 10px);left:50%;transform:translate(-50%) translateY(4px);background:#0b0d14eb;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 10px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-tool:hover .tip{opacity:1;transform:translate(-50%) translateY(0);transition-delay:.26s}.cv-tool .key{color:var(--fg-5);margin-left:6px}.cv-iconbtn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:9px;border:1px solid transparent;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.cv-iconbtn:hover{background:#ffffff12;color:var(--fg-1)}.cv-corner{position:absolute;right:18px;bottom:22px;z-index:40;display:flex;flex-direction:column;align-items:flex-end;gap:10px;transition:opacity var(--dur-med) var(--ease-out-soft),transform var(--dur-med) var(--ease-out-soft)}.cv-corner.is-away .cv-minimap{display:none}.cv-corner.is-away .cv-zoomhud{flex-direction:column;padding:4px;animation:upIn var(--dur-med) var(--ease-out-soft) both}.cv-corner.is-away .cv-zoomhud button{width:28px}.cv-corner.is-away .cv-zoomhud .pct{min-width:0;padding:0;font-size:10px;letter-spacing:-.02em}.cv-corner.is-away .cv-zoomhud .sep{width:16px;height:1px;margin:3px 0}.cv-minimap{width:188px;height:124px;border-radius:14px;overflow:hidden;background:#0b0d14b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);position:relative;cursor:pointer;transform-origin:50% 50%;animation:upIn var(--dur-med) var(--ease-out-soft) both}.cv-minimap canvas{position:absolute;left:0;top:0;width:188px;height:124px;pointer-events:none}.cv-minimap .mm-view{position:absolute;border:1.5px solid var(--cv-accent);border-radius:3px;background:var(--cv-accent-tint);cursor:grab;pointer-events:none}.cv-minimap.is-going{animation:none;pointer-events:none;will-change:transform,opacity;transition:transform .46s cubic-bezier(.4,0,.2,1),opacity .46s cubic-bezier(.4,0,.2,1) .06s,border-radius .46s var(--ease-out-soft)}.mm-hide{position:absolute;top:6px;right:6px;z-index:2;width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid rgba(255,255,255,.1);border-radius:6px;background:#04030cb8;color:var(--fg-3);cursor:pointer;opacity:0;transform:translateY(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),color var(--dur-fast),background var(--dur-fast)}.cv-minimap:hover .mm-hide,.mm-hide:focus-visible{opacity:1;transform:none}.mm-hide:hover{background:#04030ceb;color:#fff}.cv-minimap.is-going .mm-hide{opacity:0}.cv-zoomhud{display:flex;align-items:center;gap:2px;padding:5px;border-radius:var(--radius-sm);background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px)}.cv-zoomhud button{height:28px;min-width:28px;border:0;border-radius:7px;padding:0;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-zoomhud button:hover{background:#ffffff12;color:var(--fg-1)}.cv-zoomhud .pct{padding:0 6px;min-width:46px}.cv-zoomhud .sep{width:1px;height:16px;margin:0 3px;background:var(--hairline-soft);flex:none}.cv-zoomhud .grid-toggle{color:var(--fg-2)}.cv-zoomhud .grid-toggle.is-off{color:var(--fg-5)}.cv-zoomhud .mm-slot:disabled{cursor:default}.cv-zoomhud .mm-slot.is-landing{animation:mmLand .5s cubic-bezier(.16,1,.3,1) .26s both}@keyframes mmLand{0%{transform:scale(.5);color:var(--fg-4)}45%{transform:scale(1.18);color:var(--cv-accent-soft)}to{transform:none;color:var(--fg-3)}}.cv-ctxbar{position:absolute;z-index:45;display:flex;align-items:center;gap:2px;padding:5px;border-radius:12px;background:#121521d1;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);white-space:nowrap}@media(prefers-reduced-motion:no-preference){.cv-ctxbar{animation:ctxIn .3s var(--ease-out-soft) both}@keyframes ctxIn{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}}.cv-ctxbar .sep{width:1px;height:18px;background:var(--hairline-soft);margin:0 4px;flex:none}.cv-ctxbar button{width:30px;height:30px;border:0;border-radius:8px;padding:0;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative;transition:background var(--dur-fast),color var(--dur-fast)}.cv-ctxbar button:hover{background:#ffffff14;color:var(--fg-1)}.cv-ctxbar button.danger:hover{background:#ff5c7a24;color:var(--danger)}.cv-ctxbar .swatch{width:14px;height:14px;border-radius:5px;border:1px solid rgba(255,255,255,.25);transition:box-shadow var(--dur-fast)}.cv-ctxbar button.is-swatch{width:26px}.cv-ctxbar button.is-swatch.on .swatch{box-shadow:0 0 0 2px var(--bg-deep),0 0 0 3.5px #ffffffbf}.cv-ctxbar .swatch.tint-amethyst{background:#9968df8c}.cv-ctxbar .swatch.tint-vista{background:#5a61ed99}.cv-ctxbar .swatch.tint-sky{background:#3db4e68c}.cv-ctxbar .swatch.tint-mint{background:#34c79a8c}.cv-ctxbar .swatch.tint-amber{background:#f0b44a8c}.cv-ctxbar .swatch.tint-rose{background:#ec5b9a8c}.cv-ctxbar .swatch.tint-glass{background:#ffffff2e}.cv-ctxbar .tip{position:absolute;bottom:calc(100% + 9px);left:50%;transform:translate(-50%) translateY(4px);background:#0b0d14f0;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 9px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-ctxbar button:hover .tip{opacity:1;transform:translate(-50%) translateY(0);transition-delay:.26s}.cv-ctxbar button.is-rest{color:var(--fg-5);cursor:default}.cv-ctxbar button.is-rest:hover{background:transparent;color:var(--fg-4)}.cv-ctxbar .tip .why{display:block;margin-top:2px;font-weight:400;color:var(--fg-4)}.cv-ctx-edit{display:inline-flex;align-items:center;gap:6px;width:auto!important;height:30px;padding:0 11px!important;border:0;border-radius:8px;background:var(--cv-accent-tint)!important;color:var(--fg-1)!important;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.cv-ctx-edit:hover{background:#9968df4d!important}.cv-ctx-edit .swatch{width:12px;height:12px;border-radius:4px;border:1px solid rgba(255,255,255,.3)}.cv-ctx-info{display:inline-flex;align-items:center;gap:6px;width:auto!important;height:30px;padding:0 11px!important;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.cv-ctx-info:hover{background:#ffffff14;color:var(--fg-1)}.cv-ctx-info.is-locked{color:var(--fg-2)}.cv-ctxbar button.is-more.on{background:#ffffff14;color:var(--fg-1)}.cv-addmenu{position:absolute;left:50%;bottom:88px;transform:translate(-50%);width:312px;z-index:46;border-radius:var(--radius-md);background:#121521d9;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);overflow:hidden}.am-view{will-change:transform,opacity}@media(prefers-reduced-motion:no-preference){.am-view.fwd{animation:amFwd .3s var(--ease-out-soft) both}.am-view.back{animation:amBack .3s var(--ease-out-soft) both}@keyframes amFwd{0%{opacity:0;transform:translate(28px)}to{opacity:1;transform:none}}@keyframes amBack{0%{opacity:0;transform:translate(-28px)}to{opacity:1;transform:none}}}.am-search{display:flex;align-items:center;gap:8px;margin:2px 12px 4px;padding:0 6px 0 11px;height:34px;border-radius:var(--radius-sm);background:#ffffff0b;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.am-search:focus-within{border-color:var(--cv-accent-soft);box-shadow:0 0 0 3px var(--cv-accent-tint)}.am-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;font-family:var(--font-sans);font-size:12.5px;color:var(--fg-1);user-select:text;-webkit-user-select:text}.am-search input::placeholder{color:var(--fg-4)}.am-none{padding:14px 10px 12px;font-size:12px;color:var(--fg-4)}.am-rows{padding:4px 6px 8px;max-height:348px;overflow-y:auto}.am-rows::-webkit-scrollbar{width:8px}.am-rows::-webkit-scrollbar-thumb{background:#ffffff1a;border-radius:4px;border:2px solid transparent;background-clip:content-box}.am-eyebrow{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5);padding:10px 10px 5px}.am-row{display:flex;align-items:center;gap:11px;width:100%;text-align:left;border:0;background:transparent;padding:8px 9px;border-radius:10px;cursor:pointer;transition:background var(--dur-fast)}.am-row:hover,.am-row.is-active{background:#ffffff0f}.am-row .cv-badge{width:32px;height:32px;border-radius:10px}.am-eyebrow.is-apart{margin:6px 4px 0;padding:12px 6px 5px;border-top:1px solid var(--hairline-soft)}.cv-badge.is-prompts{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.am-main{flex:1;min-width:0}.am-name{font-size:13px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.am-sub{font-size:11px;color:var(--fg-4);margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.am-go{color:var(--fg-5);flex:none;transition:color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.am-row:hover .am-go{color:var(--fg-2);transform:translate(1px)}.am-searchrow{display:flex;align-items:center;gap:6px;padding:12px 10px 8px 12px}.am-searchrow .am-search{flex:1;min-width:0;margin:0}.am-close{flex:none;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.am-close:hover{background:#ffffff14;color:var(--fg-1)}`, pIe = '.v2-root{--cv-fav: #ef5f7a;--chat-w: 80px;--set-w: 0px}.v2-root .cv-topbar{height:52px;padding:0 16px;gap:14px}.v2-root .cv-topbar-left{gap:11px}.v2-root .cv-topbar-right{gap:12px}.v2-root .cv-mark{width:31px;height:27px;border-radius:8px}.v2-root .cv-mark svg{width:25px}.v2-root .cv-crumb{font-size:12px}.v2-root .cv-board-title{font-size:13.5px}.v2-root.light-canvas{background:#f4f5f7}.v2-root.light-canvas .cv-topbar{background:#070910f0}.v2-root.light-canvas .rs,.v2-root.light-canvas .bd-siderail,.v2-root.light-canvas .v2-rail,.v2-root.light-canvas .cv-zoomhud{background:#121521f0}.v2-root.light-canvas .cv-atmo-glow,.v2-root.light-canvas .cv-atmo-orb-a,.v2-root.light-canvas .cv-atmo-orb-b{opacity:0}.v2-root.light-canvas .cv-grid{background-image:radial-gradient(rgba(12,16,30,.85) 1.15px,transparent 1.6px);opacity:calc(.3 * var(--cv-atmo))}.v2-root.light-canvas.no-grid .cv-grid{opacity:0}.v2-root.light-canvas{--lc-ink: #131828;--lc-ink-2: rgba(19, 24, 40, .74);--lc-ink-3: rgba(19, 24, 40, .56);--lc-line: rgba(19, 24, 40, .14);--cv-guide: var(--amethyst-400);--cv-guide-halo: rgba(255, 255, 255, .55)}.v2-root.light-canvas .cv-frame-title{color:var(--lc-ink-2)}.v2-root.light-canvas .cv-frame-title .cv-frame-count{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-frame-title.is-selected{color:var(--amethyst-400)}.v2-root.light-canvas .cv-frame-title-input{color:var(--lc-ink);background:#fff;border-color:#7532d373;box-shadow:0 1px 2px #13182814}.v2-root.light-canvas .cv-frame-title .cv-frame-lock{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-frame-title.is-selected .cv-frame-lock{color:inherit}.v2-root.light-canvas .cv-minimap{background:#f4f5f7f5;border-color:var(--lc-line);box-shadow:0 1px 2px #13182814,0 18px 40px #1318281f}.v2-root.light-canvas .mm-hide{background:#fff;border-color:var(--lc-line);color:var(--lc-ink-2)}.v2-root.light-canvas .mm-hide:hover{background:#fff;color:var(--lc-ink)}.v2-root.light-canvas .cv-bucket{background:#fff;border-color:var(--lc-line);box-shadow:0 1px 2px #13182814,0 18px 40px #1318281a;backdrop-filter:none;-webkit-backdrop-filter:none}.v2-root.light-canvas .cv-el:hover .cv-bucket{box-shadow:0 1px 2px #13182814,0 26px 60px #13182829}.v2-root.light-canvas .cv-bucket-name{color:var(--lc-ink)}.v2-root.light-canvas .cv-bucket-kind,.v2-root.light-canvas .cv-bucket-foot{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-bucket-model,.v2-root.light-canvas .cv-bucket-sep{color:#1318286b}.v2-root.light-canvas .cv-count{color:var(--lc-ink-2);background:#1318280f;border-color:var(--lc-line)}.v2-root.light-canvas .cv-badge{background:#1318280d;box-shadow:inset 0 1px #fffc;color:var(--amethyst-400)}.v2-root.light-canvas .cv-thumb{border-color:#13182814}.v2-root.light-canvas .cv-thumb-empty{border-color:#13182824;background:#13182808}.v2-root.light-canvas .cv-note{box-shadow:0 1px 2px #13182814,0 16px 36px #1318281f;backdrop-filter:none;-webkit-backdrop-filter:none}.v2-root.light-canvas .cv-note.tint-glass{background:#fff;border-color:var(--lc-line)}.v2-root.light-canvas .cv-note.tint-amethyst{background:linear-gradient(180deg,#9968df33,#9968df1a);border-color:#9968df52}.v2-root.light-canvas .cv-note.tint-vista{background:linear-gradient(180deg,#5a61ed2e,#5a61ed17);border-color:#5a61ed4d}.v2-root.light-canvas .cv-note.tint-sky{background:linear-gradient(180deg,#3db4e633,#3db4e61a);border-color:#3db4e657}.v2-root.light-canvas .cv-note.tint-mint{background:linear-gradient(180deg,#34c79a33,#34c79a1a);border-color:#34c79a57}.v2-root.light-canvas .cv-note.tint-amber{background:linear-gradient(180deg,#f0b44a42,#f0b44a21);border-color:#d696285c}.v2-root.light-canvas .cv-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2e,#ec5b9a17);border-color:#ec5b9a52}.v2-root.light-canvas .cv-note-text{color:var(--lc-ink)}.v2-root.light-canvas .cv-note-meta{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-img-label{color:#fff;text-shadow:0 1px 6px rgba(4,3,12,.85)}.v2-root.light-canvas .cv-marquee{border-color:#7532d38c;background:#7532d31a}.v2-stage{left:0!important;top:52px!important;right:var(--set-w)!important}.v2-root .cv-corner{right:calc(18px + var(--set-w))}.v2-railwrap{position:absolute;left:var(--chat-w);right:var(--set-w);bottom:22px;z-index:41;pointer-events:none;display:flex;align-items:center;justify-content:center;gap:10px;transition:left var(--dur-med) var(--ease-out-soft),right var(--dur-med) var(--ease-out-soft),opacity var(--dur-med) var(--ease-out-soft),transform var(--dur-med) var(--ease-out-soft)}.v2-railwrap>*{pointer-events:auto}.v2-railwrap.is-away{opacity:0;transform:translateY(18px)}.v2-railwrap.is-away>*{pointer-events:none}.v2-rail .cv-tool.v2-add{background:var(--grad-cta);color:#fff;box-shadow:0 5px 14px #745aff47,inset 0 1px #ffffff2e;transition:box-shadow var(--dur-med),filter var(--dur-fast)}.v2-rail .cv-tool.v2-add:hover{background:var(--grad-cta);color:#fff;filter:brightness(1.1)}.v2-rail .cv-tool.v2-add.on{box-shadow:0 5px 14px #745aff47,inset 0 1px #ffffff38,0 0 0 3px var(--cv-accent-tint)}.v2-add>.licon{transition:transform var(--dur-med) var(--ease-out-soft)}.v2-add.on>.licon{transform:rotate(45deg)}.v2-rail{position:relative;display:flex;flex-direction:row;align-items:center;gap:3px;padding:6px;border-radius:15px;background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}.v2-rail .sep{width:1px;height:20px;background:var(--hairline-soft);margin:auto 4px}.v2-rail .cv-tool{width:36px;height:36px;border-radius:10px}.v2-rail .v2-shapetool .face{width:40px}.cv-addmenu.at-rail{left:calc(var(--chat-w) + (100vw - var(--chat-w) - var(--set-w)) / 2);right:auto;top:auto;bottom:80px;transform:translate(-50%)}@media(prefers-reduced-motion:no-preference){.cv-addmenu.at-rail{animation:amInRail .35s var(--ease-out-soft) both}@keyframes amInRail{0%{opacity:0;transform:translate(-50%) translateY(12px)}to{opacity:1;transform:translate(-50%) translateY(0)}}}.v2-uprompt{position:absolute;left:var(--chat-w);right:var(--set-w);bottom:20px;z-index:70;pointer-events:none;display:flex;flex-direction:column;align-items:center;animation:upIn var(--dur-med) var(--ease-out-soft) both;transition:left var(--dur-med) var(--ease-out-soft),right var(--dur-med) var(--ease-out-soft)}.v2-uprompt>*{pointer-events:auto}.v2-root.hist-rail .v2-uprompt{right:calc(var(--set-w) + 368px)}.v2-root.board-hist .v2-uprompt{right:calc(var(--set-w) + 398px)}@keyframes upIn{0%{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}.up-card{position:relative;z-index:5;width:min(720px,100%);display:grid;grid-template-columns:30px minmax(0,1fr);gap:10px 12px;padding:11px 12px;border-radius:18px;border:1px solid rgba(255,255,255,.055);background:#0b0d15fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e;transition:box-shadow var(--dur-med) var(--ease-out-soft),border-color var(--dur-med)}.up-card:focus-within{border-color:#ffffff17}.up-card.is-fresh{animation:upFresh 2.2s var(--ease-out-soft) infinite}@keyframes upFresh{0%,to{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #9968df73,0 0 0 4px #9968df1a,0 30px 80px #02040c9e}50%{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #9968dfbf,0 0 0 7px #9968df29,0 30px 80px #02040c9e}}@media(prefers-reduced-motion:reduce){.up-card.is-fresh{animation:none;box-shadow:0 0 0 1px #9968df99,0 30px 80px #02040c9e}}.up-card.is-nudge{animation:upNudge .42s var(--ease-out-soft)}.up-card.is-nudge .up-run-wrap .tip{opacity:1}@keyframes upNudge{0%,to{translate:0 0}20%{translate:-6px 0}40%{translate:5px 0}60%{translate:-3px 0}80%{translate:2px 0}}@media(prefers-reduced-motion:reduce){.up-card.is-nudge{animation:none}}.up-side{grid-column:1;grid-row:1 / span 2;display:flex;flex-direction:column;align-items:center;gap:7px}.up-card.has-refs .up-side{grid-row:1 / span 3}.up-card.has-refs .up-text,.up-card.has-refs .up-ghost,.up-card.has-refs .up-cue{grid-row:2}.up-card.has-refs .up-foot{grid-row:3}.up-side-btn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.up-side-btn:hover{background:#ffffff0f;color:var(--fg-2)}.up-side-btn.on{background:var(--cv-accent-tint);color:var(--cv-accent-soft)}.up-side-btn .badge{position:absolute;margin:-18px 0 0 18px;min-width:14px;height:14px;padding:0 4px;border-radius:999px;background:var(--cv-accent);color:#fff;font-size:9px;font-weight:700;line-height:14px}.up-text{grid-column:2;grid-row:1;width:100%;min-height:70px;resize:none;overflow-y:auto;box-sizing:border-box;border:0;background:transparent;padding:4px 0 0;color:var(--fg-1);font-family:var(--font-sans);font-size:13.5px;line-height:1.55;letter-spacing:-.005em;outline:none;text-wrap:pretty;user-select:text;-webkit-user-select:text}textarea.up-text{min-height:0}.up-text::placeholder{color:var(--fg-4)}.up-grip{position:absolute;top:-9px;left:12px;z-index:3;width:30px;height:18px;display:flex;align-items:center;justify-content:center;cursor:ns-resize;touch-action:none;outline:none}.up-grip i{display:block;width:22px;height:4px;border-radius:999px;background:#ffffff29;box-shadow:0 0 0 1px #04030ca6;transition:background var(--dur-fast),width var(--dur-fast) var(--ease-out-soft)}.up-card:hover .up-grip i{background:#ffffff4d}.up-grip:hover i,.up-grip.is-on i,.up-grip:focus-visible i{width:28px;background:#ffffffa6}.up-grip:focus-visible i{box-shadow:0 0 0 1px #04030ca6,0 0 0 3px #a3a7f58c}.up-card.is-resizing,.up-card.is-resizing *{cursor:ns-resize!important;user-select:none}.up-text::-webkit-scrollbar{width:6px}.up-text::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-drop{width:56px;height:56px;flex:none;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px dashed rgba(255,255,255,.2);border-radius:12px;background:#ffffff08;color:var(--fg-4);cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.up-drop:hover,.up-drop.is-target{border-color:var(--cv-accent-soft);color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.up-drop.is-target{transform:scale(1.06);border-style:solid}.up-refs{grid-column:2;grid-row:1;display:flex;flex-wrap:wrap;gap:6px;align-items:flex-start}.up-ref{position:relative;width:56px;height:56px;border-radius:12px;flex:none;background-size:cover;background-position:center;background-color:#ffffff0d;box-shadow:inset 0 0 0 1px #ffffff1f;animation:refIn .32s var(--ease-out-soft) both}@keyframes refIn{0%{opacity:0;transform:scale(.85)}to{opacity:1;transform:none}}.up-ref.is-target{box-shadow:inset 0 0 0 2px var(--cv-accent-text)}.up-ref button{position:absolute;top:-6px;right:-6px;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:#0b0d15f0;color:var(--fg-3);cursor:pointer;box-shadow:0 4px 12px #02040c99;transition:color var(--dur-fast);opacity:0}.up-ref:hover button,.up-ref button:focus-visible{opacity:1}.up-ref button:hover{color:#fff}.up-ref .lbl{position:absolute;left:4px;right:4px;bottom:4px;padding:1px 5px;border-radius:6px;background:#04030cb3;color:var(--fg-2);font-size:8.5px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-drop.is-dropper{border-style:solid;border-color:var(--cv-accent-soft);color:var(--cv-accent-text);background:var(--cv-accent-tint)}.up-ref.is-dropper{box-shadow:inset 0 0 0 2px var(--cv-accent-soft)}.up-ref-pulse{position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:upPulse .9s var(--ease-out-soft) both}@keyframes upPulse{0%{box-shadow:inset 0 0 0 2px #ffffffe6,0 0 #9968df99}to{box-shadow:inset 0 0 0 2px #fff0,0 0 0 10px #9968df00}}@media(prefers-reduced-motion:reduce){.up-ref-pulse{animation:none}}.up-ref-glow{position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:upGlowBreathe 1.25s ease-in-out infinite alternate,upGlowLife 5s linear both}@keyframes upGlowBreathe{0%{box-shadow:inset 0 0 0 1.5px #c4a2ff80,0 0 6px 1px #9968df33}to{box-shadow:inset 0 0 0 1.5px #c4a2ffd9,0 0 18px 4px #9968df6b}}@keyframes upGlowLife{0%{opacity:0}8%{opacity:1}76%{opacity:1}to{opacity:0}}@media(prefers-reduced-motion:reduce){.up-ref-glow{animation:upGlowLife 5s linear both;box-shadow:inset 0 0 0 1.5px #c4a2ffb3,0 0 10px 2px #9968df4d}}.up-ref-peek{position:absolute;bottom:calc(100% + 12px);z-index:8;transform:translate(-50%);border-radius:12px;overflow:hidden;pointer-events:none;background:#ffffff0a;box-shadow:0 0 0 1px #ffffff24,0 24px 60px #02040cb8;animation:upPeek .18s var(--ease-out-soft) both}.up-ref-peek img{display:block;max-width:320px;max-height:320px}.up-ref-peek .n{position:absolute;left:8px;top:8px;padding:2px 8px;border-radius:999px;background:#04030cb3;color:#fff;font-size:10.5px;font-weight:600}@keyframes upPeek{0%{opacity:0;transform:translate(-50%) translateY(6px) scale(.96)}to{opacity:1;transform:translate(-50%)}}@media(prefers-reduced-motion:reduce){.up-ref-peek{animation:none}}.up-foot{grid-column:2;grid-row:2;display:flex;align-items:flex-end;gap:7px;min-width:0}.up-chips{display:flex;align-items:center;gap:6px;row-gap:6px;flex:1;min-width:0;overflow:visible;flex-wrap:wrap}.up-chip-wrap{position:relative;display:inline-flex;min-width:0}.up-chip{display:inline-flex;align-items:center;gap:6px;max-width:190px;height:30px;padding:0 11px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff0d;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.up-chip:hover{background:#ffffff17;color:var(--fg-1)}.up-chip.on{border-color:var(--cv-accent-soft);color:var(--fg-1);background:var(--cv-accent-tint)}.up-chip .licon{flex:none;color:var(--fg-4)}.up-chip.on .licon{color:var(--cv-accent-soft)}.up-chip .t{min-width:0;overflow:hidden;text-overflow:ellipsis}.up-cog{flex:none;width:24px;height:30px;padding:0;border:0;background:none;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;color:var(--fg-4);transition:color var(--dur-fast)}.up-cog:hover,.up-cog.on{color:var(--fg-1)}.up-chip.is-locked{cursor:default;background:#ffffff06;border-style:dashed;color:var(--fg-4)}.up-chip.is-locked:hover{background:#ffffff0a;color:var(--fg-3)}.up-chip .lk{flex:none;margin-left:-2px;color:var(--fg-4);opacity:.8}.up-count-wrap{position:relative;flex:none;display:inline-flex}.up-count{display:inline-flex;align-items:center;gap:3px;height:30px;padding:0 6px 0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);cursor:pointer;font-family:var(--font-sans);font-size:12px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast)}.up-count:hover:not(:disabled),.up-count.on{background:#ffffff0d;color:var(--fg-1)}.up-count .chev{color:var(--fg-4);opacity:.85;transition:transform .22s var(--ease-out-soft),color var(--dur-fast)}.up-count:hover .chev,.up-count.on .chev{color:var(--fg-2)}.up-count.on .chev{transform:rotate(180deg)}.up-count:disabled{cursor:default;color:var(--fg-3)}.up-count:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:1px}.up-count.is-tall{height:40px;padding:0 9px 0 12px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08}.up-count.is-tall:hover:not(:disabled),.up-count.is-tall.on{background:#ffffff0f}.up-count-pop .sv-pop-row{font-variant-numeric:tabular-nums}.up-count-pop .sv-pop-row:focus-visible{outline:none;background:#ffffff0f;color:var(--fg-1)}.up-count-pop .ck{margin-left:auto;color:var(--cv-accent-text)}@media(prefers-reduced-motion:reduce){.up-count .chev{transition:none}}.up-run{flex:none;height:30px;padding:0 17px;display:inline-flex;align-items:center;gap:7px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12.5px;font-weight:600;letter-spacing:-.01em;cursor:pointer;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e;transition:filter var(--dur-fast),box-shadow var(--dur-med),transform var(--dur-fast) var(--ease-out-soft);position:relative}.up-run:hover{filter:brightness(1.08);box-shadow:0 9px 24px #745aff61,inset 0 1px #ffffff38}.up-run:active:not(:disabled){transform:scale(.97)}.up-run:disabled{cursor:default;filter:none;background:#ffffff12;color:var(--fg-4);box-shadow:none}.up-run:disabled:hover{filter:none;box-shadow:none}.up-run:disabled.is-busy{background:var(--grad-cta);color:#fff;opacity:.72}.up-run.is-get{background:linear-gradient(135deg,#ff9a6b,#f2668b);box-shadow:0 6px 18px #f2668b47,inset 0 1px #fff3}.up-run.is-get .licon{color:#fff}.up-run-wrap .tip{position:absolute;bottom:calc(100% + 9px);right:0;width:max-content;max-width:300px;background:#0b0d14f0;border:1px solid var(--hairline-soft);line-height:1.4;text-align:left;color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 9px;border-radius:8px;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.up-run-wrap{position:relative;display:inline-flex}.up-run-wrap:hover .tip{opacity:1}.up-out-line{flex:none;margin-left:auto;margin-right:6px;font-size:11px;color:var(--fg-4);white-space:nowrap;font-variant-numeric:tabular-nums}.v2-root.light-canvas .up-out-line{color:var(--fg-4)}.up-cost{flex:none;display:inline-flex;align-items:baseline;gap:4px;margin-left:1px;white-space:nowrap;color:var(--fg-4);font-size:11px;font-weight:500;font-variant-numeric:tabular-nums}.up-cost .licon{color:var(--fg-5);align-self:center}.up-note{flex:none;display:inline-flex;align-items:center;gap:5px;height:30px;white-space:nowrap;color:var(--fg-4);font-size:11px;font-weight:500}.up-note .licon{color:var(--fg-5)}.up-model-wrap{min-width:0;flex:0 1 auto;align-items:baseline}.up-model{display:inline-flex;align-items:baseline;gap:7px;min-width:0;max-width:240px;height:30px;padding:0 8px;margin-left:-6px;border:0;border-radius:8px;background:transparent;color:var(--fg-1);font-family:var(--font-sans);cursor:pointer;line-height:30px;transition:background var(--dur-fast)}.up-model:hover,.up-model.on{background:#ffffff0d}.up-model .lb{flex:none;font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.up-model .nm{min-width:0;font-size:12.5px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.up-model .licon{flex:none;align-self:center;color:var(--fg-4)}.up-foot-sep{flex:none;width:1px;height:18px;margin:0 3px;background:var(--hairline-soft)}.up-pop{position:absolute;bottom:calc(100% + 8px);left:0;min-width:190px;z-index:6;display:flex;flex-direction:column;gap:2px;padding:7px;border:1px solid var(--hairline);border-radius:14px;background:#11131ef5;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),var(--shadow-deep);animation:upIn var(--dur-fast) var(--ease-out-soft) both;max-height:min(420px,60vh);overflow-y:auto}.up-pop::-webkit-scrollbar{width:6px}.up-pop::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-pop.is-wide{min-width:320px}.up-pop-label{padding:3px 6px 6px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.2em;color:var(--fg-4)}.up-pop-search{display:flex;align-items:center;gap:7px;margin:0 2px 6px;height:30px;padding:0 9px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-4)}.up-pop-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:12px;user-select:text;-webkit-user-select:text}.up-pop-row{display:flex;align-items:center;gap:8px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast);flex:none}.up-pop-row:hover{background:#ffffff12;color:var(--fg-1)}.up-pop-row.on{background:var(--cv-accent-tint);color:var(--fg-1)}.up-pop-main{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.up-pop-meta{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.up-pop-sep{flex:none;height:1px;margin:3px 6px;background:var(--hairline-soft)}.up-pop-slider{display:flex;align-items:center;gap:10px;min-width:220px;padding:2px 6px 6px}.up-pop-slider .up-adv-num{flex:none;width:58px}.up-pop-avatar{width:24px;height:24px;flex:none;border-radius:7px;background-size:cover;background-position:center;background-color:#ffffff0f}.up-pop-item{position:relative;flex:none}.up-pop-item .up-pop-row{padding-right:38px}.up-pop-item:hover .up-pop-row{background:#ffffff12;color:var(--fg-1)}.up-pop-item:hover .up-pop-row.on{background:var(--cv-accent-tint)}.up-pop-pin{position:absolute;right:5px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.up-pop-item:hover .up-pop-pin,.up-pop-pin.on,.up-pop-pin:focus-visible{opacity:1}.up-pop-pin:hover{background:#ffffff17;color:#fff}.up-pop-pin.on{color:var(--cv-accent-text)}.up-pop-pin.on svg{fill:currentColor}.up-pop-empty{padding:10px 8px 12px;font-size:12px;line-height:1.45;color:var(--fg-4)}.up-modelpick{width:320px}.up-modelpick-row{padding-top:6px;padding-bottom:6px}.up-modelpick-av{width:32px;height:32px;flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:8px;object-fit:cover;background:#ffffff0f;color:var(--fg-4)}.up-modelpick-av.is-none{background:transparent;border:1px dashed var(--hairline)}.up-modelpick-desc{display:block;margin-top:1px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;font-weight:400;color:var(--fg-4)}.up-modelpick-group{padding:8px 6px 4px;font-size:10px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-5)}.up-modelpick-note{display:flex;align-items:center;gap:8px;padding:8px 8px 10px;font-size:12px;line-height:1.45;color:var(--fg-4)}.up-influence{width:260px;gap:8px;padding:9px 12px 12px}.up-influence .up-pop-label{padding:3px 0 2px}.up-influence-ends{display:flex;align-items:flex-end;justify-content:space-between;height:22px;color:var(--fg-2);font-weight:600;font-variant-numeric:tabular-nums}.up-influence-ends span{display:inline-flex;align-items:center;gap:5px;transition:font-size var(--dur-fast)}.up-influence-ends .licon{color:var(--fg-4)}.up-influence .up-range{width:100%;margin:4px 0 2px}.up-chip .av{width:20px;height:20px;flex:none;margin-left:-6px;border-radius:50%;object-fit:cover;box-shadow:0 0 0 1px #ffffff14}.up-pop-tabs{display:flex;flex-wrap:wrap;gap:4px;margin:0 2px 6px;flex:none}.up-pop-tabs button{flex:none;height:24px;padding:0 9px;border-radius:999px;border:1px solid var(--hairline-soft);background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.up-pop-tabs button:hover{color:var(--fg-1);background:#ffffff0d}.up-pop-tabs button.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.up-pop-badge{display:inline-flex;align-items:center;height:16px;padding:0 6px;margin-left:6px;border-radius:999px;vertical-align:1px;font-size:9.5px;font-weight:600;letter-spacing:.02em;color:var(--fg-3);background:#ffffff12}.up-pop-badge.is-popular{color:#ffb38a;background:#ff8c5a24}.up-adv{position:relative;width:min(360px,100%);margin-bottom:10px;z-index:4;display:flex;flex-direction:column;gap:16px;padding:16px;border:1px solid rgba(255,255,255,.055);border-radius:18px;background:#0b0d15fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e;animation:upIn var(--dur-med) var(--ease-out-soft) both;max-height:calc(100vh - 290px);overflow-y:auto}.up-adv::-webkit-scrollbar{width:6px}.up-adv::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-adv-head{display:flex;align-items:center;gap:6px}.up-adv-title{flex:1;font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.up-adv-field{display:flex;flex-direction:column;gap:9px;min-width:0;margin:0;padding:0;border:0}.up-adv-field.is-locked>:not(.up-adv-label):not(.up-adv-why){opacity:.45;pointer-events:none}.up-adv-why{display:flex;align-items:flex-start;gap:6px;margin-top:-3px;font-size:11px;line-height:1.45;color:var(--fg-4)}.up-adv-why .licon{flex:none;margin-top:2px}.up-adv-label{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:500;color:var(--fg-2)}.up-adv-label .licon{color:var(--fg-4)}.up-adv-label .req{color:var(--cv-accent-text)}.up-adv-hint{font-size:11px;line-height:1.45;color:var(--fg-4)}.up-adv-row{display:flex;align-items:center;gap:10px}.up-range{flex:1;min-width:0;height:4px;-webkit-appearance:none;appearance:none;border-radius:999px;background:#ffffff1f;outline:none}.up-range::-webkit-slider-thumb{-webkit-appearance:none;width:13px;height:13px;border-radius:50%;background:#fff;box-shadow:0 2px 6px #02061780;cursor:pointer}.up-range::-moz-range-thumb{width:13px;height:13px;border:0;border-radius:50%;background:#fff;cursor:pointer}.up-adv-num{width:64px;flex:none;height:30px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;text-align:center;outline:none;font-variant-numeric:tabular-nums;user-select:text;-webkit-user-select:text}.up-adv-num.is-full{width:100%;text-align:left;padding:0 10px}.up-adv-num:focus{border-color:var(--cv-accent-soft)}textarea.up-adv-num{height:auto;min-height:62px;padding:8px 10px;line-height:1.5;resize:vertical;text-align:left}.up-seg{display:inline-flex;flex-wrap:wrap;gap:2px;padding:2px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08;align-self:flex-start}.up-seg button{height:26px;padding:0 12px;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.up-seg button:hover{color:var(--fg-1)}.up-seg button.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:var(--fg-1)}.up-toggle{position:relative;width:32px;height:18px;border-radius:999px;border:0;padding:0;cursor:pointer;background:#ffffff24;transition:background var(--dur-fast)}.up-toggle:after{content:"";position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 2px 6px #02061766;transition:transform var(--dur-fast) var(--ease-out-soft)}.up-toggle.on{background:var(--cv-accent)}.up-toggle.on:after{transform:translate(14px)}.up-error{display:flex;align-items:flex-start;gap:8px;width:min(720px,100%);margin-bottom:8px;padding:9px 12px;border-radius:12px;font-size:12px;line-height:1.45;background:#ff5c7a1a;border:1px solid rgba(255,92,122,.28);color:#ffb3c1;animation:upIn var(--dur-med) var(--ease-out-soft) both}.up-error .licon{margin-top:1px}.up-error button{margin-left:auto;border:0;background:transparent;color:inherit;cursor:pointer;padding:0;opacity:.7}.up-error button:hover{opacity:1}.v2-hist{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:300px;display:flex;flex-direction:column;padding:12px;border-radius:18px;background:#0b0d15f7;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;pointer-events:auto;animation:histIn .26s var(--ease-out-soft) both}@keyframes histIn{0%{opacity:0;transform:translate(16px)}to{opacity:1;transform:none}}.v2-hist-head{flex:none;display:flex;align-items:center;gap:8px;margin-bottom:6px}.v2-hist-head .n{flex:none;padding:2px 7px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);font-size:10px;font-weight:600;font-variant-numeric:tabular-nums}.v2-hist-head .t{min-width:0;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-hist-close{margin-left:auto;flex:none;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:8px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-hist-close:hover{background:#ffffff17;color:var(--fg-1)}.v2-hist-hint{flex:none;margin-bottom:9px;font-size:10px;line-height:1.4;color:var(--fg-5)}.v2-hist-open{position:absolute;z-index:46;top:66px;right:68px;display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 11px;border-radius:11px;border:1px solid var(--hairline);background:#0b0d15f0;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);box-shadow:var(--inset-highlight),0 18px 44px #02040c80;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;animation:histIn .26s var(--ease-out-soft) both}.v2-hist-open:hover{background:#161926f5;color:#fff}.v2-hist-grid{flex:1;min-height:0;overflow-y:auto;padding-right:2px;position:relative;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.v2-hist-grid::-webkit-scrollbar{width:5px}.v2-hist-grid::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.v2-hist-item{position:absolute}.v2-hist-item .shot{position:absolute;inset:0;padding:0;border:0;border-radius:10px;background:transparent;cursor:pointer;outline:none}.v2-hist-item .art{position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff12;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);background-color:#ffffff0a;background-size:cover;background-position:center}.v2-hist-item:hover .art{transform:translateY(-2px);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft),0 12px 28px #02040c80}.v2-hist-item.is-on .art{box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.v2-hist-item.is-new .art{animation:thumbIn .55s var(--ease-out-soft) both}.v2-hist-item.is-pending .art{overflow:hidden}.v2-hist-item.is-pending .art:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.v2-hist-item.is-failed .art{display:flex;align-items:center;justify-content:center;color:#ff8aa0;background:#ff5c7a14;box-shadow:inset 0 0 0 1px #ff5c7a40}.v2-hist-acts{position:absolute;right:10px;bottom:10px;z-index:3;display:flex;align-items:center;gap:6px}.v2-hist-acts button{height:28px;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:#04030cb8;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);color:#fff;font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast);position:relative}.v2-hist-acts .find{width:28px;display:inline-flex;align-items:center;justify-content:center;padding:0}.v2-hist-acts button:hover{background:var(--cv-accent);border-color:transparent}.v2-hist-acts .tip{position:absolute;bottom:calc(100% + 8px);left:50%;transform:translate(-50%);background:#0b0d14f0;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:10.5px;font-weight:500;padding:4px 8px;border-radius:7px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.v2-hist-acts button:hover .tip{opacity:1}.v2-hist-pop{position:absolute;right:calc(100% + 12px);z-index:6;border-radius:14px;pointer-events:auto;box-shadow:0 28px 70px #02040cc2;animation:histPop .22s var(--ease-out-soft) both}@keyframes histPop{0%{opacity:0;transform:translate(10px) scale(.94)}to{opacity:1;transform:none}}.v2-hist-pop:after{content:"";position:absolute;right:-14px;top:0;bottom:0;width:14px}.v2-hist-pop .art{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;cursor:pointer;border-radius:14px;box-shadow:inset 0 0 0 1px #ffffff1f;background-color:#ffffff0a;background-size:cover;background-position:center}.v2-hist-pop .art-vid{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px;pointer-events:none;opacity:0;transition:opacity .22s var(--ease-out-soft)}.v2-hist-pop .art-vid.is-shown{opacity:1}.v2-hist-pop .cap{position:absolute;left:0;right:0;bottom:0;display:flex;align-items:center;gap:8px;padding:30px 112px 15px 13px;pointer-events:none;border-radius:0 0 14px 14px;background:linear-gradient(180deg,#04030c00,#04030ce0 64%)}.v2-hist-pop .cap .n{flex:1;min-width:0;font-size:11.5px;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-hist-pop .cap .m{flex:none;display:inline-flex;align-items:center;gap:4px;font-size:10.5px;font-weight:600;color:#ffffffb8}.v2-hist-vid,.v2-hist-fav{position:absolute;top:5px;display:inline-flex;align-items:center;gap:2px;height:14px;padding:0 5px;border-radius:999px;background:#04030cb3;font-size:7.5px;font-weight:700;letter-spacing:.02em}.v2-hist-vid{right:5px;color:#fff}.v2-hist-fav{left:5px;padding:0 4px;color:var(--cv-fav)}.v2-hist-fav svg{fill:currentColor}.v2-hist-empty{padding:30px 12px;text-align:center;font-size:11.5px;line-height:1.5;color:var(--fg-4)}.v2-hist-time{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:1;font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums;letter-spacing:.02em;color:#ffffff9e;pointer-events:none}.v2-hist-item.is-withheld .art{display:flex;align-items:center;justify-content:center;background:radial-gradient(120% 90% at 30% 20%,#9968df38,#ffffff08 70%);box-shadow:inset 0 0 0 1px #ffffff14}.v2-hist-withheld{display:inline-flex;flex-direction:column;align-items:center;gap:5px;font-size:9.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:var(--fg-4)}.v2-hist-more{display:flex;justify-content:center;padding:10px 0 14px}.tl-ghost{position:fixed;z-index:95;pointer-events:none;width:132px;height:92px;border-radius:10px;background-size:cover;background-position:center;background-color:#ffffff0f;border:1px solid rgba(255,255,255,.22);box-shadow:0 24px 60px #02061799;opacity:.9;transform:translate(-50%,-50%) rotate(-2deg);transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.tl-ghost.is-ref{box-shadow:0 0 0 2px var(--cv-accent-text),0 18px 44px #02040c99;transform:translate(-50%,-50%) rotate(0) scale(.86)}.v2-info{position:fixed;inset:0;z-index:90;display:flex;align-items:center;justify-content:center;padding:28px 64px;background:#04030cc7;backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);animation:infoIn .22s var(--ease-out-soft) both}@keyframes infoIn{0%{opacity:0}to{opacity:1}}.v2-info-shell{display:grid;grid-template-columns:minmax(0,1fr) 372px;gap:26px;width:min(1440px,100%);height:min(88vh,960px);animation:infoShell .32s var(--ease-out-soft) both}@keyframes infoShell{0%{opacity:0;transform:translateY(10px) scale(.99)}to{opacity:1;transform:none}}.v2-info-stage{position:relative;min-width:0;display:flex;align-items:center;justify-content:center;border-radius:18px;background:#ffffff08;border:1px solid var(--hairline-soft);overflow:hidden}.v2-info-art{display:block;border-radius:12px;object-fit:cover;box-shadow:0 30px 100px #0206178c;transition:transform .25s var(--ease-out-soft),opacity .3s ease;max-width:none}.v2-info-art.is-loading{opacity:0}.v2-info-play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:60px;height:60px;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:0;cursor:pointer;background:#04030c99;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;transition:transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast)}.v2-info-play:hover{transform:translate(-50%,-50%) scale(1.06);background:#04030cbf}span.v2-info-play{cursor:default;pointer-events:none}.v2-info-art.is-video{background:#000}.v2-info-zoom{position:absolute;left:50%;bottom:16px;transform:translate(-50%);display:flex;align-items:center;gap:2px;padding:4px;border-radius:999px;background:#04030c9e;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(255,255,255,.1);color:#fffc}.v2-info-zoom button,.v2-info-zoom span{width:28px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:999px;background:transparent;color:inherit;cursor:pointer}.v2-info-zoom button:hover{background:#ffffff1a;color:#fff}.v2-info-zoom span{color:#ffffff80;cursor:default;width:auto;padding:0 6px;font-size:11px;font-weight:600;font-variant-numeric:tabular-nums}.v2-info-zoom button.is-word{width:auto;padding:0 11px;gap:6px;font:600 11.5px var(--font-sans)}.v2-info-zoom button.is-word.on{background:#9968df4d;color:#fff}.v2-info-zoom .sep{width:1px;height:16px;margin:0 3px;background:#ffffff24}.v2-info-cmp-menu{position:absolute;left:50%;bottom:58px;transform:translate(-50%);z-index:3;min-width:240px;padding:6px;border-radius:14px;background:#0a0b14f5;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99;animation:cmpIn .2s var(--ease-out-soft) both}@keyframes cmpIn{0%{opacity:0;transform:translate(-50%) translateY(6px)}}.v2-info-cmp-menu .hd{padding:6px 8px 4px;font-size:9.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-5)}.v2-info-cmp-menu .row{display:flex;align-items:center;gap:10px;width:100%;padding:6px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-1);font:500 12px var(--font-sans);text-align:left;cursor:pointer}.v2-info-cmp-menu .row:hover{background:#ffffff12}.v2-info-cmp-menu .pic{width:34px;height:34px;flex:none;border-radius:7px;background:#ffffff0d center / cover no-repeat;border:1px solid var(--hairline-soft)}.v2-info-cmp{position:relative;overflow:hidden;border-radius:12px;cursor:ew-resize;touch-action:none;user-select:none;box-shadow:0 30px 100px #0206178c;background:#ffffff08}.v2-info-cmp img{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}.v2-info-cmp .under{object-fit:contain}.v2-info-cmp .over{object-fit:cover}.v2-info-cmp .line{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 0 1px #00000040,0 0 16px #00000059;pointer-events:none}.v2-info-cmp .knob{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:50%;background:#fff;color:#12131c;box-shadow:0 4px 16px #0006}.v2-info-cmp .tag,.v2-info-pair-view figcaption{position:absolute;top:12px;height:24px;padding:0 10px;border-radius:999px;display:inline-flex;align-items:center;background:#04030ca8;color:#fff;font:600 11px var(--font-sans);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);pointer-events:none;max-width:45%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-cmp .tag.at-left{left:12px}.v2-info-cmp .tag.at-right{right:12px}.v2-info-pair-view{display:flex;gap:14px;width:calc(100% - 36px);height:calc(100% - 96px)}.v2-info-pair-view figure{position:relative;flex:1;min-width:0;margin:0;display:flex;align-items:center;justify-content:center}.v2-info-pair-view .pic{position:relative;display:inline-flex;max-width:100%;max-height:100%}.v2-info-pair-view img{display:block;max-width:100%;max-height:min(100%,calc(88vh - 160px));object-fit:contain;border-radius:12px;box-shadow:0 24px 70px #02061780}.v2-info-pair-view figcaption{left:12px}.v2-info-specs em.is-compare{cursor:zoom-in;transition:box-shadow var(--dur-fast)}.v2-info-specs em.is-compare:hover{box-shadow:0 0 0 2px #c2a4ecb3}.v2-info-nav{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:transparent;color:#fff9;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-nav:hover{background:#ffffff14;color:#fff}.v2-info-nav:disabled{opacity:.25;cursor:default}.v2-info-nav.at-left{left:12px}.v2-info-nav.at-right{right:12px}.v2-info-side{min-width:0;display:flex;flex-direction:column;gap:14px;overflow-y:auto}.v2-info-side::-webkit-scrollbar{width:6px}.v2-info-side::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.v2-info-top{flex:none;display:flex;align-items:center;gap:9px}.v2-info-mail{flex:1;min-width:0;font-size:12.5px;font-weight:500;color:var(--fg-2);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-act{flex:none;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:50%;background:#ffffff0d;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-act:hover{background:#ffffff1c;color:#fff}.v2-info-act.is-danger:hover{color:#ff8aa0}.v2-info-act.is-confirming{width:auto;padding:0 11px 0 9px;gap:5px;border-radius:999px;color:#fff;background:#ff5c7a38;border-color:#ff5c7a73}.v2-info-confirm{font-size:11.5px;font-weight:600}.v2-info-avatar{width:26px;height:26px;border-radius:50%;flex:none;display:flex;align-items:center;justify-content:center;font-size:9.5px;font-weight:700;color:#fff;letter-spacing:.02em;background:var(--grad-cta)}.v2-info-card{flex:none;display:flex;flex-direction:column;gap:14px;padding:14px;border-radius:20px;background:linear-gradient(180deg,#ffffff12,#ffffff06);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card)}.v2-info-card.is-record{flex:0 1 auto;min-height:0}.v2-info-scroll{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:14px;overflow-y:auto;margin:0 -6px;padding:0 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.v2-info-scroll.is-more{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent)}.v2-info-acts{flex:none;display:flex;flex-direction:column;gap:14px}.v2-info-strip{display:flex;align-items:center;gap:10px}.v2-info-strip .n{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums}.v2-info-strip .when{flex:1;font-size:11.5px;color:var(--fg-3);font-variant-numeric:tabular-nums;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-star{flex:none;width:26px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.v2-info-star:hover{color:var(--fg-2);background:#ffffff0f}.v2-info-star.on{color:var(--cv-fav)}.v2-info-star.on svg{fill:currentColor}.v2-info-star:active{transform:scale(.88)}.v2-info-star.is-pin+.v2-info-star{margin-left:-6px}.v2-info-star.is-pin.on{color:var(--cv-accent-text)}.v2-info-block{border-radius:14px;background:#04030c57;border:1px solid var(--hairline-soft);padding:12px}.v2-info-block-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:9px}.v2-info-block-head span{display:inline-flex;align-items:center;gap:7px;font-size:11.5px;font-weight:600;color:var(--fg-2);min-width:0}.v2-info-block-head span .licon{color:var(--cv-accent-text)}.v2-info-block-head i{font-style:normal;font-weight:500;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:170px}.v2-info-block-head button{width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.v2-info-block-head button:hover{background:#ffffff12;color:var(--fg-1)}.v2-info-prompt{margin:0;font-size:12px;line-height:1.65;color:var(--fg-2);max-height:260px;overflow-y:auto;text-wrap:pretty;user-select:text;-webkit-user-select:text}.v2-info-prompt.is-reading{color:var(--fg-3);animation:infoReading 1.2s ease-in-out infinite alternate}.v2-info-prompt.is-none{color:var(--fg-3)}@keyframes infoReading{0%{opacity:.55}to{opacity:1}}@media(prefers-reduced-motion:reduce){.v2-info-prompt.is-reading{animation:none}}.v2-info-specs{display:grid;grid-template-columns:1fr 1fr;gap:14px 12px;padding:0 2px}.v2-info-specs>div{min-width:0}.v2-info-specs span{display:block;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4);margin-bottom:5px}.v2-info-specs b{display:block;font-size:12px;font-weight:500;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-specs b.none{color:var(--fg-5);font-style:italic}.v2-info-specs em{display:block;width:46px;height:32px;border-radius:7px;background-size:cover;background-position:center;border:1px solid var(--hairline-soft)}.v2-info-tool{display:flex;align-items:center;gap:11px;padding:10px;border-radius:14px;background:#04030c57;border:1px solid var(--hairline-soft);width:100%;text-align:left;font-family:var(--font-sans);cursor:default}button.v2-info-tool{cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}button.v2-info-tool:hover{background:#ffffff0d;border-color:var(--hairline)}.v2-info-tool .thumb{flex:none;width:38px;height:38px;border-radius:10px;background-size:cover;background-position:center;background-color:#ffffff0d}.v2-info-tool .body{min-width:0;flex:1}.v2-info-tool em{display:block;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.16em;color:var(--fg-4);font-style:normal}.v2-info-tool b{display:block;margin-top:3px;font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-tool .go{flex:none;color:var(--fg-4)}.v2-info-place{display:inline-flex;align-items:center;justify-content:center;gap:9px;height:46px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:14px;font-weight:600;cursor:pointer;box-shadow:0 18px 44px #745aff52;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.v2-info-place:hover{transform:translateY(-1px);filter:brightness(1.06)}.v2-info-remix{display:inline-flex;align-items:center;justify-content:center;gap:9px;height:38px;border-radius:999px;background:#ffffff0f;border:1px solid var(--hairline-soft);color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-remix:hover{background:#ffffff1a;color:var(--fg-1)}.v2-stage.is-draw,.v2-stage.is-draw *{cursor:crosshair!important}.v2-shapetool{position:relative;display:inline-flex;align-items:center}.v2-shapetool .face{position:relative;width:36px}.v2-shapetool .face>.licon:first-child{transform:translate(-2px)}.v2-shapetool .caret{position:absolute;right:4px;bottom:6px;display:inline-flex;color:var(--fg-5);transition:color var(--dur-fast),transform var(--dur-med) var(--ease-out-soft)}.v2-shapetool .face:hover .caret{color:var(--fg-3)}.v2-shapetool.is-open .face{background:#ffffff12;color:var(--fg-1)}.v2-shapetool.is-open .caret{color:var(--fg-2);transform:rotate(180deg)}.v2-shapetool.on .face{background:var(--cv-accent-tint);color:var(--cv-accent-text)}.v2-shapetool.on .caret{color:var(--cv-accent-text);opacity:.7}.v2-shapetool.is-open .tip{display:none}.v2-shapemenu{position:absolute;bottom:calc(100% + 12px);left:50%;transform:translate(-50%);width:218px;padding:8px;z-index:60;border-radius:var(--radius-md);background:#0e101af0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}@media(prefers-reduced-motion:no-preference){.v2-shapemenu{animation:shpIn .24s var(--ease-out-soft) both}@keyframes shpIn{0%{opacity:0;transform:translate(-50%) translateY(8px)}to{opacity:1;transform:translate(-50%) translateY(0)}}}.v2-shapemenu .hd{font-size:10.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5);padding:4px 8px 8px}.v2-shapemenu .row{display:flex;align-items:center;gap:9px;width:100%;height:34px;padding:0 9px 0 4px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:13px;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-shapemenu .row:hover{background:#ffffff12;color:var(--fg-1)}.v2-shapemenu .row.on{color:var(--fg-1)}.v2-shapemenu .row .tick{width:18px;display:inline-flex;justify-content:center;color:var(--cv-accent-text)}.v2-shapemenu .row .lb{flex:1;text-align:left}.v2-shapemenu .row .k{color:var(--fg-5);font-size:11.5px;letter-spacing:.04em}.v2-stylebar{position:absolute;z-index:46;padding:10px 12px 12px;border-radius:var(--radius-md);background:#0e101af0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}@media(prefers-reduced-motion:no-preference){.v2-stylebar{animation:ctxIn .26s var(--ease-out-soft) both}}.v2-stylebar .hd{display:flex;align-items:center;justify-content:space-between;font-size:10.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5);margin-bottom:9px}.v2-stylebar .hd .x{width:22px;height:22px;border:0;padding:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.v2-stylebar .hd .x:hover{background:#ffffff14;color:var(--fg-1)}.v2-stylebar .sw-grid{display:grid;grid-template-columns:repeat(9,1fr);gap:6px}.v2-stylebar .sw{width:100%;aspect-ratio:1;padding:2px;border:1px solid transparent;border-radius:8px;background:#ffffff0d;cursor:pointer;display:flex;transition:border-color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.v2-stylebar .sw span{flex:1;border-radius:5px;box-shadow:inset 0 0 0 1px #ffffff24}.v2-stylebar .sw:hover{background:#ffffff1f;transform:scale(1.08)}.v2-stylebar .sw.on{border-color:var(--cv-accent-text);background:var(--cv-accent-tint)}.v2-stylebar .wrow{display:flex;align-items:center;gap:10px;margin-top:13px}.v2-stylebar .wrow .lb{font-size:12px;color:var(--fg-3);flex:none}.v2-stylebar input[type=range]{flex:1;min-width:0;-webkit-appearance:none;appearance:none;height:3px;border-radius:999px;background:#ffffff29;outline:none}.v2-stylebar input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:14px;height:14px;border-radius:50%;background:var(--fg-1);border:0;cursor:pointer;box-shadow:0 2px 6px #02040c80}.v2-stylebar input[type=range]::-moz-range-thumb{width:14px;height:14px;border-radius:50%;background:var(--fg-1);border:0;cursor:pointer}.v2-stylebar .num{flex:none;display:flex;align-items:stretch;height:28px;border:1px solid var(--hairline-soft);border-radius:8px;overflow:hidden;background:#ffffff0a}.v2-stylebar .num>span{display:inline-flex;align-items:center;justify-content:center;width:32px;font-size:12.5px;font-variant-numeric:tabular-nums;color:var(--fg-1)}.v2-stylebar .num .stp{display:flex;flex-direction:column;border-left:1px solid var(--hairline-soft)}.v2-stylebar .num .stp button{flex:1;width:20px;border:0;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;padding:0}.v2-stylebar .num .stp button:hover{background:#ffffff1a;color:var(--fg-1)}.v2-stylebar .prev{margin-top:11px;border-radius:9px;background:#ffffff0a;padding:6px 0;display:flex;align-items:center;overflow:hidden}.rs{position:absolute;left:14px;bottom:22px;z-index:44;display:flex;flex-direction:column;width:58px;max-height:calc(100vh - 230px);overflow:hidden;border-radius:14px;background:#121521b8;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);font-family:var(--font-sans);transition:width .42s cubic-bezier(.16,1,.3,1)}.rs.is-open{width:336px}.rs-head{display:flex;align-items:center;gap:7px;height:0;padding:0 12px;opacity:0;overflow:hidden;transition:height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs.is-open .rs-head{height:32px;padding-top:6px;opacity:1}.rs-eyebrow{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap}.rs-count{font-size:10px;font-weight:600;color:var(--fg-3);padding:1px 6px;border-radius:999px;background:#ffffff0f;font-variant-numeric:tabular-nums}.rs-list{display:flex;flex-direction:column;gap:2px;padding:5px 5px 0;max-height:200px;overflow:hidden;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent;transition:max-height .42s cubic-bezier(.16,1,.3,1)}.rs.is-open .rs-list{flex:none;height:200px;max-height:200px;overflow-y:auto;overscroll-behavior:contain}.rs-list::-webkit-scrollbar{width:5px}.rs-list::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.rs-head,.rs-more{flex-shrink:0}.rs-row{position:relative;display:flex;align-items:center;gap:11px;flex:none;width:324px;padding:5px;border:0;border-radius:11px;background:transparent;color:inherit;cursor:pointer;font-family:var(--font-sans);transition:background var(--dur-fast)}.rs-row:hover{background:#ffffff12}.rs-row.on{background:var(--cv-accent-tint)}.rs-row.on .rs-shot{box-shadow:0 0 0 2px var(--cv-accent-text)}.rs-row.is-ref-target,.rs-item:hover .rs-row.is-ref-target{background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.rs-item{position:relative;flex:none}.rs-item:hover .rs-row{background:#ffffff12}.rs-item:hover .rs-row.on{background:var(--cv-accent-tint)}.rs.is-open .rs-row{padding-right:38px}.rs-pin{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.rs.is-open .rs-pin{pointer-events:auto}.rs.is-open .rs-item:hover .rs-pin,.rs.is-open .rs-pin.on,.rs.is-open .rs-pin:focus-visible{opacity:1}.rs-pin:hover{background:#ffffff17;color:#fff}.rs-pin.on{color:var(--cv-accent-text)}.rs-pin.on svg{fill:currentColor}.rs-shot .pin{position:absolute;left:-4px;top:-4px;width:15px;height:15px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 2px #121521f2;transition:opacity .18s}.rs-shot .pin svg{fill:currentColor}.rs.is-open .rs-shot .pin{opacity:0}.rs-shot{position:relative;flex:none;display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:10px;background-color:#ffffff0f;background-size:cover;background-position:center;color:var(--fg-3);box-shadow:inset 0 0 0 1px #ffffff1a;transition:box-shadow var(--dur-fast)}.rs-shot .k{position:absolute;right:-3px;bottom:-3px;width:15px;height:15px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#090b13f0;color:var(--fg-2);box-shadow:0 0 0 1px var(--hairline)}.rs-shot .busy{position:absolute;inset:0;border-radius:10px;overflow:hidden}.rs-shot .busy:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.18) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.rs-meta{min-width:0;flex:1;display:flex;flex-direction:column;gap:2px;text-align:left;opacity:0;transition:opacity .18s}.rs-n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums;padding-right:4px;opacity:0;transition:opacity .18s}.rs.is-open .rs-meta,.rs.is-open .rs-n{opacity:1;transition-delay:.08s}.rs-name{font-size:12.5px;font-weight:500;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rs-sub{display:flex;align-items:baseline;gap:5px;min-width:0;font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rs-sub .kind{font-size:9px;font-weight:600;letter-spacing:.16em;text-transform:uppercase}.rs-sub .sep{color:var(--fg-5)}.rs-more{align-self:flex-start;margin:3px 0 7px 9px;width:38px;text-align:center;font-size:10.5px;font-weight:600;color:var(--fg-3)}.rs-tools{flex:none;display:flex;flex-direction:column;gap:8px;width:324px;max-height:0;padding:0 6px;overflow:hidden;opacity:0;pointer-events:none;transition:max-height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs.is-open .rs-tools{max-height:110px;padding:6px 6px 4px;opacity:1;pointer-events:auto;transition-delay:0s,0s,.06s}.v2-dock-search{flex:none;display:flex;align-items:center;gap:8px;height:34px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.v2-dock-search:focus-within{border-color:var(--cv-accent-soft);box-shadow:0 0 0 3px var(--cv-accent-tint)}.v2-dock-search input{flex:1;min-width:0;border:0;background:transparent;outline:none;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.v2-dock-search input::placeholder{color:var(--fg-5)}.v2-dock-filters{flex:none;display:flex;flex-wrap:nowrap;gap:5px}.v2-fchip{flex:none;height:26px;padding:0 11px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff09;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.v2-fchip:hover{background:#ffffff14;color:var(--fg-1)}.v2-fchip.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.rs-filters{gap:4px;overflow-x:auto;scrollbar-width:none}.rs-filters::-webkit-scrollbar{display:none}.rs-filters .v2-fchip{padding:0 9px}.rs-none{width:314px;padding:18px 8px;text-align:center;font-size:12px;color:var(--fg-4)}.rs-pad{flex:none;height:5px}.rs.is-open .rs-pad{height:6px}.rs-empty-body{display:flex;align-items:center;gap:11px;width:324px;padding:9px 9px 0}.rs-empty.is-open .rs-empty-body{padding:5px 9px 0}.rs-empty-slot{flex:none;width:38px;height:38px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px dashed rgba(255,255,255,.22);border-radius:10px;background:#ffffff08;color:var(--fg-3);cursor:pointer;transition:border-color var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.rs-empty-slot:hover{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--cv-accent-text)}.rs-empty-txt{min-width:0;flex:1;display:flex;flex-direction:column;gap:3px;opacity:0;transition:opacity .18s}.rs-empty.is-open .rs-empty-txt{opacity:1;transition-delay:.08s}.rs-empty-txt .t{font-size:12.5px;font-weight:500;color:var(--fg-1);white-space:nowrap}.rs-empty-txt .s{font-size:11px;line-height:1.45;color:var(--fg-4);text-wrap:pretty}.rs-empty-kinds{display:flex;gap:5px;width:324px;max-height:0;padding:0 6px;overflow:hidden;opacity:0;transition:max-height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs-empty.is-open .rs-empty-kinds{max-height:40px;padding:10px 6px 0;opacity:1}.rs-empty-kind{display:inline-flex;align-items:center;gap:4px;height:24px;padding:0 9px;border:1px solid transparent;border-radius:999px;background:#ffffff0d;color:var(--fg-3);font:inherit;font-size:10.5px;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.rs-empty-kind:hover{background:var(--cv-accent-tint);border-color:#c2a4ec4d;color:var(--cv-accent-text)}.rs-empty-cta{flex:none;display:flex;align-items:center;justify-content:center;gap:6px;width:288px;height:0;margin:0 6px;padding:0;border:0;border-radius:10px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;white-space:nowrap;cursor:pointer;opacity:0;pointer-events:none;overflow:hidden;transition:opacity .18s,height .3s,margin .3s,transform var(--dur-fast)}.rs-empty.is-open .rs-empty-cta{height:34px;margin:10px 6px 0;opacity:1;pointer-events:auto}.rs-empty-cta:hover{transform:translateY(-1px)}.rs-empty .rs-pad{height:9px}.rs-empty.is-open .rs-pad{height:6px}.v2-placewrap{position:relative;display:inline-flex}.v2-placemenu{position:absolute;left:50%;bottom:calc(100% + 14px);transform:translate(-50%);z-index:46;width:292px;padding:6px;border-radius:var(--radius-md);background:#121521e6;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%)}.v2-placemenu .am-row .cv-badge{color:var(--fg-2)}.v2-placemenu .am-row .cv-badge.is-lib{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.v2-placemenu .am-name,.v2-placemenu .am-sub{display:block}.v2-placemenu-enter-active,.v2-placemenu-leave-active{transition:opacity .18s var(--ease-out-soft),transform .18s var(--ease-out-soft)}.v2-placemenu-enter-from,.v2-placemenu-leave-to{opacity:0;transform:translate(-50%) translateY(6px) scale(.98)}.bd-pointmenu{position:absolute;left:0;top:0;z-index:72;border-radius:var(--radius-md);font-family:var(--font-sans);outline:none;background:#121521e0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);transform-origin:var(--pm-origin, top left)}@media(prefers-reduced-motion:no-preference){.bd-pointmenu{animation:pmIn .16s var(--ease-out-soft) both}@keyframes pmIn{0%{opacity:0;transform:scale(.96)}to{opacity:1;transform:none}}}.v2-root.light-canvas .bd-pointmenu{background:#121521f0}.bd-pointmenu kbd{flex:none;display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0a;font-family:var(--font-sans);font-size:10px;font-weight:600;line-height:1;color:var(--fg-3)}.bd-canvasmenu{width:212px;padding:5px}.bd-pm-eyebrow{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5);padding:7px 8px 5px}.bd-pm-row{display:flex;align-items:center;gap:10px;width:100%;height:32px;padding:0 7px 0 4px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);cursor:pointer;outline:none;font-family:var(--font-sans);font-size:12.5px;font-weight:500;letter-spacing:-.01em;text-align:left;transition:background var(--dur-fast),color var(--dur-fast)}.bd-pm-row:hover,.bd-pm-row:focus{background:#ffffff12;color:var(--fg-1)}.bd-pm-row .lbl{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bd-pm-add{flex:none;display:inline-flex;color:var(--cv-accent-text);opacity:0;transform:translate(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast)}.bd-pm-row:hover .bd-pm-add,.bd-pm-row:focus .bd-pm-add{opacity:1;transform:none}.bd-pm-ic{flex:none;width:24px;height:24px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;color:var(--cv-accent-text)}.bd-pm-ic.is-plain{color:var(--fg-2)}.bd-pm-ic.is-prompts{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.bd-pm-sep{height:1px;margin:5px 6px;background:var(--hairline-soft)}.bd-ctxmenu{width:224px;padding:5px}.bd-pm-ic.is-bare{width:20px;background:none;box-shadow:none}.bd-pm-row:disabled{cursor:default;color:var(--fg-5);background:transparent}.bd-pm-row:disabled .bd-pm-ic,.bd-pm-row:disabled kbd{opacity:.45}.bd-pm-row.is-danger:not(:disabled):hover,.bd-pm-row.is-danger:not(:disabled):focus{background:#ff5c7a24;color:var(--danger)}.bd-pm-row.is-danger:not(:disabled):hover .bd-pm-ic,.bd-pm-row.is-danger:not(:disabled):focus .bd-pm-ic{color:var(--danger)}.bd-finder{width:380px;display:flex;flex-direction:column;overflow:hidden}.sf-searchrow{flex:none;padding:10px 8px 8px 10px}.sf-filters{padding:0 10px 4px;gap:4px;overflow-x:auto;scrollbar-width:none}.sf-filters::-webkit-scrollbar{display:none}.sf-filters .v2-fchip{padding:0 10px}.sf-body{flex:1;min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:0 6px 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sf-body::-webkit-scrollbar{width:5px}.sf-body::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sf-eyebrow{display:flex;align-items:center;gap:7px;padding:12px 6px 6px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5)}.sf-eyebrow .n{font-size:10px;letter-spacing:0;color:var(--fg-3);padding:1px 6px;border-radius:999px;background:#ffffff0f;font-variant-numeric:tabular-nums}.sf-kits{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:5px;padding:0 2px}.sf-kit,.sf-prompts{display:flex;align-items:center;gap:8px;min-width:0;height:40px;padding:0 8px 0 7px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08;color:var(--fg-1);cursor:pointer;text-align:left;font-family:var(--font-sans);font-size:12px;font-weight:600;letter-spacing:-.01em;transition:background var(--dur-fast),border-color var(--dur-fast)}.sf-kit .nm{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sf-kit.is-active,.sf-prompts.is-active{background:#ffffff12;border-color:var(--cv-accent-soft)}.sf-kit-ic{position:relative;transition:background var(--dur-fast)}.sf-add{position:absolute;right:-5px;bottom:-5px;width:14px;height:14px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:0 0 0 1.5px #0a0c14f2,0 2px 6px #745aff59;opacity:0;transform:scale(.4);transition:opacity .14s ease,transform .22s var(--ease-out-soft)}.sf-kit:hover .sf-add,.sf-kit.is-active .sf-add{opacity:1;transform:none}.sf-kit:hover .sf-kit-ic,.sf-kit.is-active .sf-kit-ic{background:var(--cv-accent-tint)}@media(prefers-reduced-motion:reduce){.sf-add{transition:none}}.sf-prompts{width:calc(100% - 4px);margin:0 2px}.sf-prompts .nm{flex:none;white-space:nowrap}.sf-prompts .sub{min-width:0;font-size:11px;font-weight:500;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sf-item{position:relative}.sf-row{display:flex;align-items:center;gap:11px;width:100%;padding:5px 40px 5px 5px;border:0;border-radius:11px;background:transparent;color:inherit;cursor:pointer;text-align:left;font-family:var(--font-sans);transition:background var(--dur-fast)}.sf-item.is-active .sf-row{background:#ffffff12}.sf-meta{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.sf-n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.sf-pin{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sf-item:hover .sf-pin,.sf-item.is-active .sf-pin,.sf-pin.on{opacity:1}.sf-pin:hover{background:#ffffff17;color:#fff}.sf-pin.on{color:var(--cv-accent-text)}.sf-pin.on svg{fill:currentColor}.sf-none{padding:22px 8px;text-align:center;font-size:12px;color:var(--fg-4)}.bd-linkmenu{width:340px}.bl-row{padding-right:10px}.bl-ic{flex:none;width:34px;height:34px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:#5a61ed29;color:#c9ccfa}.bl-row.is-new .bl-ic{background:var(--cv-accent-tint);color:var(--cv-accent-soft)}.sf-foot{flex:none;display:flex;align-items:center;gap:14px;height:34px;padding:0 12px;border-top:1px solid var(--hairline-soft);font-size:11px;color:var(--fg-4)}.sf-foot>span{display:inline-flex;align-items:center;gap:3px}.sf-foot kbd{margin-right:3px}.bd-siderail{position:absolute;z-index:46;top:66px;right:14px;display:flex;flex-direction:column;gap:2px;padding:4px;border-radius:13px;background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}.bd-siderail-btn{position:relative;width:36px;height:36px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.bd-siderail-btn:hover{background:#ffffff14;color:var(--fg-1)}.bd-siderail-btn.on{background:var(--cv-accent-tint);color:#fff;box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.bd-siderail-btn .badge{position:absolute;left:-5px;top:-5px;min-width:16px;height:16px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;font-size:9.5px;font-weight:700;line-height:1;font-variant-numeric:tabular-nums;box-shadow:0 0 0 2px #121521f2;pointer-events:none}.bd-siderail-btn .tip{position:absolute;right:calc(100% + 12px);top:50%;transform:translateY(-50%) translate(4px);background:#0b0d14eb;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 10px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.bd-siderail-btn:hover .tip{opacity:1;transform:translateY(-50%);transition-delay:.26s}.bd-siderail-btn.on .tip{display:none}.bd-boardhist.sv-hist{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:330px;margin:0;background:#0b0d15f7;border-color:var(--hairline);animation:histIn .26s var(--ease-out-soft) both}.bd-boardhist .sv-hist-head .t,.bd-boardhist .sv-hist-head .n{display:revert}.bd-boardhist-close{flex:none;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.bd-boardhist-close:hover{background:#ffffff14;color:var(--fg-1)}.bd-boardhist .sv-cell{touch-action:none}.bd-boardhist-vid{position:absolute;left:6px;top:6px;z-index:2;display:inline-flex;align-items:center;gap:3px;height:16px;padding:0 5px;border-radius:5px;background:#04030cb8;color:#fff;font-size:9.5px;font-weight:600;font-variant-numeric:tabular-nums;pointer-events:none}.bd-boardhist.cols-4 .bd-boardhist-vid,.bd-boardhist.cols-5 .bd-boardhist-vid{left:4px;top:4px;padding:0 3px;font-size:0;gap:0}.bd-boardhist-play{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px;pointer-events:none}.sv-hist-filterrow{flex:none;display:flex;align-items:center;gap:6px;margin:10px 0 8px}.sv-hist-filterrow .sv-hist-filter{flex:1;min-width:0;margin:0}.sv-hist-filter.is-resting .sv-hist-filter-btn{cursor:default;color:var(--fg-2)}.sv-hist-filter.is-resting .sv-hist-filter-btn:hover{background:#ffffff0d}.sv-hist-filter.is-resting .sv-hist-filter-btn .chev{opacity:.35}.sv-hist-pinned{flex:none;display:inline-flex;align-items:center;justify-content:center;gap:5px;min-width:32px;height:32px;padding:0 9px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0d;color:var(--fg-3);cursor:pointer;font-family:var(--font-sans);font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-hist-pinned:hover{background:#ffffff17;color:var(--fg-1)}.sv-hist-pinned.on{background:#9968df2e;border-color:#9968df80;color:#fff}.sv-hist-pinned.on svg{fill:currentColor}.sv-hist-pinned .ct{color:inherit;opacity:.8}.sv-cell-pin,.v2-hist-pin,.cv-img-pin{display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 1.5px #090b13d9;pointer-events:none}.sv-cell-pin svg,.v2-hist-pin svg,.cv-img-pin svg{fill:currentColor}.sv-cell-pin{position:absolute;right:6px;top:6px;z-index:2;width:18px;height:18px}.sv-hist.cols-4 .sv-cell-pin,.sv-hist.cols-5 .sv-cell-pin{right:4px;top:4px;width:14px;height:14px}.sv-hist.cols-4 .sv-cell-pin svg,.sv-hist.cols-5 .sv-cell-pin svg{width:8px;height:8px}.v2-hist-pin{position:absolute;right:5px;bottom:5px;z-index:2;width:16px;height:16px}.cv-img-pin{position:absolute;top:8px;right:8px;width:20px;height:20px}.cv-img-vid+.cv-img-fav:has(+.cv-img-pin){right:34px}.sv-hist-acts button.is-pin.on{background:var(--amethyst-400);border-color:transparent}.sv-hist-acts button.is-pin.on svg,.v2-hist-acts button.is-pin.on svg{fill:currentColor}.v2-hist-acts button.is-pin.on{background:var(--amethyst-400);border-color:transparent;color:#fff}.pe{grid-column:1 / -1;display:flex;flex-direction:column;align-items:center;text-align:center;padding:22px 14px 18px}.pe-art{position:relative;width:184px;height:112px;margin-bottom:14px}.pe-glow{position:absolute;left:50%;top:54%;width:170px;height:110px;translate:-50% -50%;border-radius:50%;background:radial-gradient(closest-side,rgba(153,104,223,.32),rgba(90,97,237,.12) 60%,transparent);filter:blur(6px)}.pe-card{position:absolute;width:60px;height:46px;border-radius:9px;overflow:hidden;box-shadow:inset 0 0 0 1px #ffffff2e,0 12px 26px #02040c8c}.pe-card.c1{left:28px;top:40px;rotate:-12deg;background:linear-gradient(160deg,#2d2160,#7532d3 58%,#c750ce)}.pe-card.c3{left:96px;top:40px;rotate:11deg;background:linear-gradient(165deg,#3a2240,#c750ce 52%,#ffb38a)}.pe-card.c2{left:62px;top:26px;rotate:-2deg;z-index:2;background:linear-gradient(175deg,#1d3a6e,#5a61ed 55%,#9ad0ff)}.pe-card .sun{position:absolute;right:10px;top:8px;width:10px;height:10px;border-radius:50%;background:#ffffffd1;box-shadow:0 0 10px #fff9}.pe-card .hill{position:absolute;left:-10px;right:-6px;bottom:-18px;height:30px;border-radius:50%;background:#090b1e8c}.pe-card .hill.b{left:26px;right:-30px;bottom:-20px;background:#090b1e59}.pe-pin{position:absolute;left:81px;top:15px;z-index:4;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.pe-pin svg{fill:currentColor}.pe-ring{position:absolute;left:81px;top:15px;z-index:3;width:22px;height:22px;border-radius:50%;box-shadow:0 0 0 2px #c4a7ffe6;opacity:0}@media(prefers-reduced-motion:no-preference){.pe-card.c1{animation:peFloat 4.8s ease-in-out infinite}.pe-card.c3{animation:peFloat 4.8s ease-in-out -1.6s infinite}.pe-card.c2{animation:peSettle 4.8s var(--ease-out-soft) infinite}.pe-pin{animation:peDrop 4.8s var(--ease-out-soft) infinite}.pe-ring{animation:peRing 4.8s ease-out infinite}.pe-glow{animation:peGlow 4.8s ease-in-out infinite}@keyframes peFloat{0%,to{translate:0 0}50%{translate:0 -4px}}@keyframes peSettle{0%,26%{translate:0 -3px;scale:1}31%{translate:0 1px;scale:.97}40%,to{translate:0 0;scale:1}}@keyframes peDrop{0%{opacity:0;translate:0 -34px;rotate:-30deg;scale:1}12%{opacity:1}27%{translate:0 0;rotate:0deg;scale:1}31%{scale:.84}38%{scale:1}82%{opacity:1;translate:0 0;rotate:0deg}94%,to{opacity:0;translate:0 -8px;rotate:8deg}}@keyframes peRing{0%,29%{opacity:0;scale:.5}32%{opacity:.9;scale:.6}62%,to{opacity:0;scale:2.6}}@keyframes peGlow{0%,to{opacity:.75}35%{opacity:1}}}.pe-title{font-size:14px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.pe-body{margin:7px 0 0;max-width:270px;font-size:12px;line-height:1.55;color:var(--fg-3)}.pe-note{margin:0;max-width:292px;font-size:11px;line-height:1.5;color:var(--fg-4)}.pe-note:before{content:"";display:block;width:32px;height:1px;margin:16px auto 14px;background:var(--hairline)}.pe-hint{display:inline-flex;align-items:center;gap:6px;margin-top:14px;padding:4px 12px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;font-size:11px;color:var(--fg-3)}.pe-key{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.pe-key svg{fill:currentColor}.cv-ctxbar button.is-pin.on{color:var(--cv-accent-text);background:var(--cv-accent-tint)}.cv-ctxbar button.is-pin.on svg{fill:currentColor}.pe.is-compact{padding:2px 12px 6px}.pe.is-compact .pe-art{scale:.8;margin:-10px 0 -6px}.pe.is-compact .pe-private{margin-bottom:7px}.pe.is-compact .pe-title{font-size:13px}.pe.is-compact .pe-body{margin-top:4px;max-width:290px;font-size:11.5px}.pe.is-compact .pe-hint{margin-top:11px}.sv-hist-private,.pe-private{flex:none;display:inline-flex;align-items:center;gap:4px;height:18px;padding:0 7px;border-radius:999px;background:#9968df24;color:#c4a7ff;font-size:10px;font-weight:600;letter-spacing:.01em;white-space:nowrap}.pe-private{margin-bottom:9px;height:20px;padding:0 9px;font-size:10.5px}.up-studio-wrap{position:absolute;top:10px;right:12px;z-index:7;display:inline-flex}.up-studio{position:relative;isolation:isolate;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 12px 0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:600;letter-spacing:-.005em;cursor:pointer;transition:color var(--dur-fast),box-shadow var(--dur-med),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.up-studio:before{content:"";position:absolute;inset:-1px;z-index:-1;border-radius:inherit;opacity:0;background:linear-gradient(135deg,#9968df5c,#5a61ed3d);transition:opacity var(--dur-fast)}.up-studio:hover,.up-studio.on,.up-studio:focus-visible{color:#fff;border-color:#c4a2ffcc;box-shadow:inset 0 1px #fff3,0 6px 22px #7532d373;outline:none}.up-studio:hover:before,.up-studio.on:before,.up-studio:focus-visible:before{opacity:1}.up-studio:active{transform:scale(.97)}.up-studio .licon{color:var(--fg-4);transition:color var(--dur-fast)}.up-studio:hover .licon,.up-studio.on .licon,.up-studio:focus-visible .licon{color:#e6dbff}.up-card.has-refs .up-refs{padding-right:96px}.up-card:not(.has-refs) .up-text{padding-right:96px}.up-studio-pop{position:absolute;right:-6px;bottom:calc(100% + 10px);width:480px;border-radius:18px;overflow:hidden;cursor:pointer;background:#0f101a;border:1px solid rgba(255,255,255,.09);box-shadow:0 0 0 1px #9968df29,0 28px 70px #02040cb8,0 10px 24px #02040c73;transform-origin:calc(100% - 44px) 100%}.up-studio-pop-enter-active{transition:opacity .22s ease,transform .32s var(--ease-out-soft)}.up-studio-pop-leave-active{transition:opacity .14s ease,transform .16s ease}.up-studio-pop-enter-from,.up-studio-pop-leave-to{opacity:0;transform:translateY(8px) scale(.95)}.up-studio-pop .media{position:relative;aspect-ratio:16 / 9;background:#07080e;overflow:hidden}.up-studio-pop .media>video,.up-studio-pop .media>img{position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover}.up-studio-pop .media>img{animation:upStudioDrift 4.2s ease-out both}@keyframes upStudioDrift{0%{transform:scale(1.06)}to{transform:scale(1)}}.up-studio-slide-enter-active,.up-studio-slide-leave-active{transition:opacity .45s ease}.up-studio-slide-enter-from,.up-studio-slide-leave-to{opacity:0}.up-studio-pop .media:after{content:"";position:absolute;left:0;right:0;bottom:0;height:48px;pointer-events:none;background:linear-gradient(180deg,transparent,rgba(15,16,26,.6))}.up-studio-pop .tag{position:absolute;left:12px;top:12px;z-index:1;display:inline-flex;align-items:center;gap:6px;padding:4px 10px 4px 8px;border-radius:999px;background:#04030c9e;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}.up-studio-pop .tag .licon{color:#d9c6ff}.up-studio-pop .body{display:flex;flex-direction:column;gap:12px;padding:14px 18px 15px}.up-studio-pop .words{display:flex;flex-direction:column;gap:4px;height:62px;overflow:hidden}.up-studio-pop .words b{font-size:15px;font-weight:650;letter-spacing:-.01em;color:#fff}.up-studio-pop .words span{font-size:12.5px;line-height:1.45;color:var(--fg-3)}.up-studio-words-enter-active{transition:opacity .26s ease,transform .32s var(--ease-out-soft)}.up-studio-words-leave-active{transition:opacity .12s ease}.up-studio-words-enter-from{opacity:0;transform:translateY(4px)}.up-studio-words-leave-to{opacity:0}.up-studio-pop .foot{display:flex;align-items:center;justify-content:space-between}.up-studio-pop .dots{display:inline-flex;align-items:center;gap:5px}.up-studio-pop .dots button{position:relative;width:7px;height:7px;padding:0;border:0;border-radius:999px;overflow:hidden;cursor:pointer;background:#ffffff38;transition:width .32s var(--ease-out-soft),background var(--dur-fast)}.up-studio-pop .dots button:hover{background:#fff6}.up-studio-pop .dots button.on{width:26px;background:#ffffff29}.up-studio-pop .dots button.on i{position:absolute;inset:0;border-radius:inherit;transform-origin:0 50%;background:linear-gradient(90deg,var(--amethyst-500),#8b8ff5);animation:upStudioFill var(--d, 3.4s) linear both}@keyframes upStudioFill{0%{transform:scaleX(0)}to{transform:scaleX(1)}}.up-studio-pop .cta{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:600;color:var(--cv-accent-text);transition:gap var(--dur-fast)}.up-studio-pop:hover .cta{gap:7px;color:#fff}@media(prefers-reduced-motion:reduce){.up-studio-pop-enter-active,.up-studio-pop-leave-active,.up-studio-slide-enter-active,.up-studio-slide-leave-active,.up-studio-words-enter-active,.up-studio-words-leave-active{transition:none}.up-studio-pop .media>img{animation:none}.up-studio-pop .dots button.on i{animation:none;transform:none}}', fIe = '.bd-canvas-host{position:absolute;inset:0}.cv-el.is-tool .cv-el-body{height:100%}.cv-el.is-tool .cv-bucket{height:100%;display:flex;flex-direction:column}.cv-el.is-tool .cv-bucket-foot{margin-top:auto}.cv-bucket.is-busy .cv-badge{color:#fff;background:var(--cv-accent-tint)}.cv-el.is-frame-title{pointer-events:none}.cv-el.is-frame-title .cv-frame-title{pointer-events:auto}.cv-note-text:empty:before{content:attr(data-placeholder);color:#ffffff57}.v2-root.light-canvas .cv-note-text:empty:before{color:var(--lc-ink-3)}.up-drop-wrap{position:relative;display:inline-flex}.up-text-static{display:flex;align-items:center;color:var(--fg-4);font-size:13px;line-height:1.5;min-height:70px;padding:4px 10px 0;margin:0 -10px;border-radius:12px;border:1px dashed transparent;transition:border-color var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.up-text-static.is-target{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--fg-2)}.up-card.has-refs .up-text-static{min-height:48px}.up-refpick{min-width:300px;width:300px}.up-refpick.has-tabs{width:404px}.up-pop.up-refpick{max-height:min(460px,64vh)}.up-refpick-note{display:flex;align-items:center;gap:8px;padding:4px 6px 8px}.up-refpick-more{justify-content:center}.up-refpick-tip{display:flex;align-items:center;gap:9px;margin:6px 0 0;padding:9px 8px 3px;border-top:1px solid var(--hairline-soft);font-size:11px;line-height:1.45;color:var(--fg-4)}.up-refpick-tip kbd{flex:none;display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 5px;border-radius:6px;border:1px solid var(--hairline);background:#ffffff0d;font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1;color:var(--cv-accent-text)}.up-refpick-more .up-pop-main{flex:none}.up-refcell.is-video{position:relative}.up-refcell.is-video:after{content:"";position:absolute;right:5px;bottom:5px;width:0;height:0;border-left:7px solid rgba(255,255,255,.9);border-top:4.5px solid transparent;border-bottom:4.5px solid transparent;filter:drop-shadow(0 1px 2px rgba(0,0,0,.6))}.up-drop.up-more{flex-direction:column;gap:1px;border-style:solid;border-color:var(--hairline)}.up-drop.up-more .n{font-size:15px;font-weight:600;color:var(--fg-2);letter-spacing:-.01em}.up-drop.up-more .s{font-size:9px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--fg-4)}.up-drop.up-more.has-some .s{color:var(--cv-accent-text)}.up-drop.up-more.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.up-refmore{width:276px;min-width:0}.up-moregrid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px 8px;padding:2px 4px 4px}.up-morecell{display:flex;flex-direction:column;align-items:center;gap:5px;min-width:0}.up-morecell .lbl{max-width:100%;font-size:9.5px;font-weight:500;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-drop.is-sm,.up-ref.is-sm{width:52px;height:52px;border-radius:11px}.up-refgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;padding:2px 2px 8px;max-height:230px;overflow-y:auto}.up-refpick .up-refgrid{margin-bottom:6px}.up-refcell{aspect-ratio:1;border:0;padding:0;border-radius:8px;cursor:pointer;background-color:#ffffff0d;background-size:cover;background-position:center;box-shadow:inset 0 0 0 1px #ffffff14;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.up-refcell:hover{transform:translateY(-1px);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft),0 8px 20px #02040c80}.bd-drop{position:absolute;inset:52px 0 0;z-index:95;pointer-events:none;display:flex;align-items:center;justify-content:center;background:#9968df0f;box-shadow:inset 0 0 0 2px #9968df73;animation:cvFade var(--dur-fast) ease both}.bd-drop-card{display:inline-flex;align-items:center;gap:10px;padding:14px 20px;border-radius:16px;background:#0b0d15eb;border:1px solid var(--hairline);color:var(--fg-1);font-size:13px;font-weight:600;box-shadow:var(--shadow-deep)}.bd-empty{position:absolute;inset:52px 0 0;z-index:40;pointer-events:none;display:flex;align-items:center;justify-content:center;padding-bottom:60px}.bd-empty-card{pointer-events:none;width:fit-content;min-width:min(380px,calc(100vw - 32px));max-width:calc(100vw - 32px);display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px;padding:26px 26px 20px;border-radius:22px;background:linear-gradient(180deg,#ffffff12,#ffffff06);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040c8c;backdrop-filter:blur(24px) saturate(120%);-webkit-backdrop-filter:blur(24px) saturate(120%);font-family:var(--font-sans)}.bd-empty-mark{width:42px;height:42px;border-radius:14px;margin-bottom:6px;display:flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:0 12px 30px #745aff59}.bd-empty-card b{font-size:16px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.bd-empty-sub{font-size:12.5px;line-height:1.5;color:var(--fg-3);max-width:280px}.bd-empty-actions{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-top:10px}.bd-empty-actions button{pointer-events:auto}.bd-empty-keys{margin-top:12px;font-size:11px;color:var(--fg-4);display:flex;align-items:center;gap:5px;flex-wrap:wrap;justify-content:center}.bd-empty-keys kbd{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 4px;margin-left:6px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0d;font-family:var(--font-sans);font-size:10px;font-weight:600;color:var(--fg-2)}.bd-empty-keys kbd:first-child{margin-left:0}.bd-empty-enter-active{transition:opacity .5s var(--ease-out-soft) .25s,transform .5s var(--ease-out-soft) .25s}.bd-empty-leave-active{transition:opacity .18s ease,transform .18s ease}.bd-empty-enter-from{opacity:0;transform:translateY(8px) scale(.985)}.bd-empty-leave-to{opacity:0;transform:scale(.985)}.light-canvas .bd-empty-card{background:#ffffffeb;border-color:#1318281a;box-shadow:0 1px 2px #13182814,0 24px 60px #1318281f}.light-canvas .bd-empty-card b{color:#131828}.light-canvas .bd-empty-sub,.light-canvas .bd-empty-keys{color:#13182899}.light-canvas .bd-empty-keys kbd{color:#131828bf;background:#1318280a;border-color:#13182824}@media(prefers-reduced-motion:reduce){.bd-empty-enter-active,.bd-empty-leave-active{transition:opacity .2s ease}.bd-empty-enter-from,.bd-empty-leave-to{transform:none}}.bd-toast{position:absolute;left:50%;bottom:186px;z-index:96;transform:translate(-50%);display:inline-flex;align-items:center;gap:8px;max-width:min(560px,calc(100vw - 32px));padding:9px 14px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.bd-toast .licon{color:var(--success)}.bd-toast.is-error{border-color:#ff5c7a59}.bd-toast.is-error .licon{color:var(--danger)}.bd-toast.is-error{white-space:normal;align-items:flex-start;border-radius:14px;max-width:min(460px,calc(100vw - 32px));line-height:1.45;text-align:left}.bd-toast.is-error .licon{margin-top:2px}.bd-toast-enter-active{transition:opacity .3s var(--ease-out-soft),transform .3s var(--ease-out-soft)}.bd-toast-leave-active{transition:opacity .2s ease,transform .2s ease}.bd-toast-enter-from,.bd-toast-leave-to{opacity:0;transform:translate(-50%) translateY(8px)}.bd-dropper{position:absolute;left:50%;top:72px;z-index:60;transform:translate(-50%);display:inline-flex;align-items:center;gap:10px;max-width:min(620px,calc(100vw - 32px));padding:5px 5px 5px 6px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-size:12.5px;font-weight:500;white-space:nowrap}.bd-dropper-mark{flex:none;width:26px;height:26px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.bd-dropper-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.bd-dropper-count{flex:none;color:var(--fg-4);font-variant-numeric:tabular-nums}.bd-dropper-done{flex:none;height:26px;padding:0 12px;border:0;border-radius:999px;cursor:pointer;background:#ffffff14;color:var(--fg-1);font:inherit;font-weight:600;transition:background var(--dur-fast)}.bd-dropper-done:hover{background:#ffffff24}.bd-dropper-enter-active{transition:opacity .25s var(--ease-out-soft),transform .25s var(--ease-out-soft)}.bd-dropper-leave-active{transition:opacity .18s ease,transform .18s ease}.bd-dropper-enter-from,.bd-dropper-leave-to{opacity:0;transform:translate(-50%) translateY(-6px)}.bd-stats{position:absolute;left:82px;top:62px;z-index:97;display:flex;flex-direction:column;gap:2px;padding:8px 10px;border-radius:10px;background:#04030cd1;border:1px solid var(--hairline-soft);font-family:ui-monospace,SF Mono,Menlo,monospace;font-size:10.5px;color:var(--fg-3);pointer-events:none;font-variant-numeric:tabular-nums}.bd-stats b{color:var(--success);font-size:12px}.bd-stats b.warn{color:var(--warning)}.bd-stats b.bad{color:var(--danger)}.sx{--sx-mono: ui-monospace, "SF Mono", Menlo, monospace;position:absolute;left:14px;top:66px;z-index:45;width:304px;max-width:calc(100vw - 28px);max-height:max(300px,calc(100% - 336px));display:flex;flex-direction:column;border-radius:18px;background:#0b0d15e6;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;font-family:var(--font-sans);color:var(--fg-2);animation:sxIn .34s var(--ease-out-soft) both}@keyframes sxIn{0%{opacity:0;transform:translateY(-6px) scale(.985)}to{opacity:1;transform:none}}.sx:before{content:"";position:absolute;left:22px;right:22px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.55),rgba(153,104,223,.7),rgba(90,97,237,.55),transparent)}.sx.is-collapsed{width:auto}.sx-head{flex:none;display:flex;align-items:center;gap:10px;padding:11px 11px 11px 12px}.sx-mark{flex:none;width:30px;height:30px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 8px 20px #745aff52}.sx-title{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.sx-title b{font-size:13px;font-weight:600;color:var(--fg-1);letter-spacing:.005em}.sx-title span{font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-fps{flex:none;min-width:58px;text-align:center;padding:4px 9px;border-radius:999px;font:600 11.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--success);background:#37d3991a;border:1px solid rgba(55,211,153,.22);transition:color var(--dur-fast),background var(--dur-fast),border-color var(--dur-fast)}.sx-fps.is-warn{color:var(--warning);background:#ffb3471a;border-color:#ffb34742}.sx-fps.is-bad{color:var(--danger);background:#ff5c7a1a;border-color:#ff5c7a47}.sx-icon{flex:none;width:26px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:8px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sx-icon:hover{background:#ffffff17;color:var(--fg-1)}.sx-pinned{flex:none;display:flex;flex-direction:column;gap:6px;padding:0 12px}.sx-body{min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:12px}.sx-body::-webkit-scrollbar{width:8px}.sx-body::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.sx-pane{animation:sxPane .24s var(--ease-out-soft) both}@keyframes sxPane{0%{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.sx-graph{position:relative;flex:none;height:44px;border-radius:11px;overflow:hidden;background:linear-gradient(180deg,#ffffff04,#ffffff0a);border:1px solid var(--hairline-soft)}.sx-graph canvas{display:block;width:100%;height:100%}.sx-graph-label{position:absolute;left:8px;top:5px;font:500 9.5px var(--sx-mono);color:var(--fg-5);pointer-events:none}.sx-live{display:grid;grid-template-columns:repeat(3,1fr);gap:5px}.sx-live>div{display:flex;flex-direction:column;gap:1px;padding:6px 9px;border-radius:9px;background:#ffffff09}.sx-live b{font:600 12px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-1)}.sx-live span{font-size:9.5px;color:var(--fg-4);white-space:nowrap}.sx-tabs{display:flex;gap:18px;margin-top:4px;padding:0 2px;border-bottom:1px solid var(--hairline-soft)}.sx-tabs button{position:relative;height:32px;display:inline-flex;align-items:center;gap:6px;padding:0;border:0;background:transparent;color:var(--fg-4);cursor:pointer;font-size:12px;font-weight:600;transition:color var(--dur-fast)}.sx-tabs button:hover{color:var(--fg-2)}.sx-tabs button.is-on{color:var(--fg-1)}.sx-tabs button:after{content:"";position:absolute;left:0;right:0;bottom:-1px;height:2px;border-radius:2px;background:var(--grad-cta);transform:scaleX(0);transition:transform var(--dur-med) var(--ease-out-soft)}.sx-tabs button.is-on:after{transform:scaleX(1)}.sx-tab-n{padding:1px 6px;border-radius:999px;background:#ffffff12;color:var(--fg-3);font-size:9.5px;font-variant-numeric:tabular-nums}.sx-dot{width:6px;height:6px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 8px var(--amethyst-500);animation:sxPulse 1s ease-in-out infinite}@keyframes sxPulse{50%{opacity:.35}}.sx h4{display:flex;align-items:baseline;justify-content:space-between;gap:8px;margin:0 0 8px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.sx h4 span{font-size:10.5px;font-weight:500;letter-spacing:0;text-transform:none;color:var(--fg-5)}.sx h4.sx-h-gap{margin-top:14px}.sx-seg{display:grid;grid-template-columns:repeat(4,1fr);gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.sx-seg button{height:28px;display:inline-flex;align-items:center;justify-content:center;gap:5px;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.sx-seg button:hover:not(:disabled):not(.is-on){color:var(--fg-1);background:#ffffff0d}.sx-seg button.is-on{color:#fff;cursor:default;background:linear-gradient(180deg,#9968df75,#5a61ed57);box-shadow:inset 0 1px #ffffff29,0 6px 16px #745aff42}.sx-seg button:disabled:not(.is-on){opacity:.45;cursor:default}.sx-counts{display:grid;grid-template-columns:1fr 1fr;gap:9px 12px;margin-top:11px}.sx-big{display:flex;flex-direction:column;gap:1px}.sx-big b{font-size:22px;font-weight:600;line-height:1.1;color:var(--fg-1);font-variant-numeric:tabular-nums;letter-spacing:-.01em}.sx-big b.is-grad{background:var(--grad-purple-pink);-webkit-background-clip:text;background-clip:text;color:transparent}.sx-big span{font-size:11px;color:var(--fg-4)}.sx-counts dl{grid-column:1 / -1;display:grid;grid-template-columns:1fr 1fr 1fr;gap:5px 14px;margin:0;padding-top:9px;border-top:1px solid var(--hairline-soft)}.sx-counts dl>div{display:flex;flex-direction:column;gap:1px}.sx-counts dt{font-size:10px;color:var(--fg-4)}.sx-counts dd{margin:0;font:500 11.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-2)}.sx-note{margin:10px 2px 0;font-size:10.5px;line-height:1.45;color:var(--fg-5)}.sx-row{display:grid;grid-template-columns:1.1fr .8fr .8fr 1.1fr;gap:6px}.sx-chip{height:30px;display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:0 8px;white-space:nowrap;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);cursor:pointer;font-size:11.5px;font-weight:600;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sx-chip:hover:not(:disabled){background:#ffffff14;border-color:var(--hairline);color:#fff}.sx-chip:disabled{opacity:.45;cursor:default}.sx-bench{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:6px}.sx-bench li{position:relative;overflow:hidden;display:grid;grid-template-columns:1fr auto;align-items:center;gap:2px 10px;padding:7px 7px 7px 12px;border-radius:12px;background:#ffffff08;border:1px solid var(--hairline-soft);transition:border-color var(--dur-med),background var(--dur-med)}.sx-bench li.is-running{border-color:#9968df6b;background:#9968df12}.sx-bench-name{min-width:0;display:flex;align-items:center;gap:8px}.sx-bench-name b{flex:none;font-size:12px;font-weight:600;color:var(--fg-1)}.sx-hint{min-width:0;font-size:10.5px;color:var(--fg-5);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-play{width:28px;height:28px;display:inline-flex;align-items:center;justify-content:center;padding:0;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast),box-shadow var(--dur-fast)}.sx-play:hover:not(:disabled){background:var(--grad-cta);border-color:transparent;color:#fff;box-shadow:0 6px 16px #745aff4d}.sx-play:disabled{opacity:.45;cursor:default}.sx-bench li.is-running .sx-play{opacity:1;color:var(--amethyst-700)}.sx-bench-res{grid-column:1 / -1;padding-bottom:2px;font:500 10.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-3);animation:sxRes .3s var(--ease-out-soft) both}@keyframes sxRes{0%{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}.sx-phase{min-width:0;font-size:10.5px;color:var(--amethyst-700);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-pill{flex:none;padding:2px 8px;border-radius:999px;font-family:var(--font-sans);font-size:10px;font-weight:600}.sx-pill.is-ok{color:var(--success);background:#37d3991f}.sx-pill.is-bad{color:var(--danger);background:#ff5c7a1f}.sx-progress{position:absolute;left:0;right:0;bottom:0;height:2px;transform-origin:0 50%;transform:scaleX(var(--sx-p, 0));background:var(--grad-purple-pink);box-shadow:0 0 10px #9968dfcc}.sx-actions{display:flex;gap:8px;margin-top:10px}.sx-actions .bd-btn{flex:1;height:34px;padding:0 12px;gap:7px}.sx-actions .bd-btn:disabled{opacity:.45;cursor:default;transform:none;filter:none}.bd-center{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:14px;color:var(--fg-3);font-size:13px;z-index:30}.bd-spinner{width:26px;height:26px;border-radius:50%;border:2px solid rgba(255,255,255,.12);border-top-color:var(--amethyst-500);animation:cvSpin .8s linear infinite}.bd-spinner.is-sm{width:16px;height:16px}.bd-splash{position:fixed;inset:0;z-index:210;display:flex;align-items:center;justify-content:center;background:var(--bg-deep)}.bd-splash-leave-active{transition:opacity .5s cubic-bezier(.4,0,.2,1);pointer-events:none}.bd-splash-leave-to{opacity:0}.bd-mark-loader{--ml-size: 72px;--ml-cycle: 3.6s;--ml-step: .12s;--ml-offset: 0ms;position:relative;flex:none;width:var(--ml-size);aspect-ratio:239 / 173;isolation:isolate}.bd-ml-glow{position:absolute;inset:-70% -55%;pointer-events:none;opacity:0;background:radial-gradient(closest-side,rgba(153,104,223,.2),rgba(153,104,223,.06) 55%,transparent 100%);animation:bdMlGlow var(--ml-cycle) ease-in-out calc(0ms - var(--ml-offset)) infinite}.bd-ml-mark{position:absolute;inset:0;perspective:calc(var(--ml-size) * 3);animation:bdMlBreathe var(--ml-cycle) ease-in-out calc(0ms - var(--ml-offset)) infinite}.bd-ml-facet{position:absolute;inset:0;width:100%;height:100%;overflow:visible;transform-origin:var(--ox) var(--oy);animation:bdMlFacet var(--ml-cycle) linear calc(var(--i) * var(--ml-step) - var(--ml-offset)) infinite both;will-change:transform,opacity,filter}.bd-ml-sheen{position:absolute;inset:0;pointer-events:none;opacity:0;-webkit-mask:var(--ml-mask) center / 100% 100% no-repeat;mask:var(--ml-mask) center / 100% 100% no-repeat;background-image:linear-gradient(105deg,transparent 38%,rgba(255,255,255,.8) 50%,transparent 62%);background-size:320% 100%;background-repeat:no-repeat;mix-blend-mode:screen;animation:bdMlSheen var(--ml-cycle) linear calc(0ms - var(--ml-offset)) infinite}@keyframes bdMlFacet{0%{opacity:0;filter:brightness(.35);transform:translate(calc(var(--dx) * var(--ml-size) * .09),calc(var(--dy) * var(--ml-size) * .09)) rotate3d(var(--ax),var(--ay),0,88deg) scale(.84);animation-timing-function:cubic-bezier(.16,1,.3,1)}5%{opacity:1}21%{opacity:1;filter:brightness(1);transform:translate(0) rotate3d(var(--ax),var(--ay),0,0) scale(1)}67%{opacity:1;filter:brightness(1);transform:translate(0) rotate3d(var(--ax),var(--ay),0,0) scale(1);animation-timing-function:cubic-bezier(.55,0,.75,.2)}80%{opacity:1}83%,to{opacity:0;filter:brightness(.3);transform:translate(calc(var(--dx) * var(--ml-size) * -.05),calc(var(--dy) * var(--ml-size) * -.05)) rotate3d(var(--ax),var(--ay),0,-88deg) scale(.9)}}@keyframes bdMlBreathe{0%,28%{transform:scale(1)}50%{transform:scale(1.035)}72%,to{transform:scale(1)}}@keyframes bdMlGlow{0%,18%{opacity:0}42%,58%{opacity:1}82%,to{opacity:0}}@keyframes bdMlSheen{0%,34%{opacity:0;background-position:100% 0}37%,55%{opacity:1}58%,to{opacity:0;background-position:0% 0}}@keyframes bdMlPulse{0%,to{opacity:.55}50%{opacity:1}}@media(prefers-reduced-motion:reduce){.bd-ml-glow,.bd-ml-facet,.bd-ml-sheen{animation:none}.bd-ml-mark{animation:bdMlPulse 1.8s ease-in-out infinite}}.bd-error-card{width:360px;padding:24px;border-radius:18px;text-align:center;background:#121521d9;border:1px solid var(--hairline);box-shadow:var(--shadow-deep)}.bd-error-actions{display:flex;justify-content:center;gap:10px;flex-wrap:wrap}.bd-error-card b{display:block;color:var(--fg-1);font-size:15px;margin-bottom:6px}.bd-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:36px;padding:0 18px;white-space:nowrap;flex-shrink:0;border:0;border-radius:999px;cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:600;background:var(--grad-cta);color:#fff;box-shadow:0 10px 28px #745aff47;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.bd-btn:hover{transform:translateY(-1px);filter:brightness(1.06)}.bd-btn.is-ghost{background:#ffffff0f;border:1px solid var(--hairline);color:var(--fg-1);box-shadow:none}.bd-btn.is-ghost:hover{background:#ffffff1a}.cv-topbar-btn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cv-topbar-btn:hover{background:#ffffff12;color:var(--fg-1)}.cv-topbar-btn.on{background:var(--cv-accent-tint, rgba(153, 104, 223, .16));color:var(--fg-1)}.cv-board-menu-wrap{position:relative;display:inline-flex}.cv-board-menu-wrap .cv-topbar-btn{position:relative}.cv-topbar-dot{position:absolute;top:5px;right:6px;width:6px;height:6px;border-radius:50%;background:var(--amethyst-700, #c2a4ec);box-shadow:0 0 0 2px #070910e6}.cv-board-menu{position:absolute;top:calc(100% + 10px);right:-4px;z-index:50;width:300px;display:flex;flex-direction:column;gap:2px;padding:6px;border:1px solid var(--hairline);border-radius:16px;background:radial-gradient(130% 100% at 100% 100%,rgba(153,104,223,.34),transparent 72%),#11131ef5;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),var(--shadow-deep);animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}@keyframes cvMenuIn{0%{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}.cv-board-menu-item{display:flex;align-items:flex-start;gap:12px;width:100%;padding:10px 12px;text-align:left;border:0;border-radius:11px;background:transparent;color:var(--fg-2);cursor:pointer;font-family:var(--font-sans);transition:background var(--dur-fast),color var(--dur-fast)}.cv-board-menu-item:hover,.cv-board-menu-item:focus-visible{background:#ffffff12;color:var(--fg-1);outline:none}.cv-board-menu-item>.licon{margin-top:1px;color:var(--fg-3)}.cv-board-menu-item:hover>.licon{color:var(--fg-1)}.cv-board-menu-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.cv-board-menu-title{font-size:13.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.cv-board-menu-desc{font-size:11.5px;line-height:1.4;color:var(--fg-4)}.cv-board-menu-count,.cv-board-menu-kbd{flex:none;min-width:20px;height:20px;padding:0 6px;margin-top:1px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1;font-variant-numeric:tabular-nums}.cv-board-menu-count{background:var(--cv-accent-tint, rgba(153, 104, 223, .16));color:var(--fg-1)}.cv-board-menu-kbd{border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-3)}.cv-links-wrap{position:relative;display:inline-flex;flex:none}.cv-links-btn{height:26px;min-width:26px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;gap:5px;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;font-family:var(--font-sans);font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-links-btn.has-links{border-color:var(--hairline);color:var(--fg-2)}.cv-links-btn:hover,.cv-links-btn.on{background:#ffffff12;color:var(--fg-1)}.cv-links-menu{left:-4px;right:auto;width:340px}.cv-links-head{display:flex;align-items:center;gap:7px;padding:8px 10px 6px;font-size:9.5px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.cv-links-head .n{padding:1px 6px;border-radius:999px;background:#ffffff12;color:var(--fg-2);letter-spacing:0}.cv-links-empty{padding:4px 10px 10px;font-size:12px;line-height:1.45;color:var(--fg-3)}.cv-links-row{display:flex;align-items:center;gap:10px;padding:7px 8px 7px 10px;border-radius:11px}.cv-links-row:hover{background:#ffffff0d}.cv-links-row .ic{flex:none;width:30px;height:30px;border-radius:9px;display:inline-flex;align-items:center;justify-content:center;background:#5a61ed29;color:#c9ccfa}.cv-links-row .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.cv-links-row .t{font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cv-links-row .s{font-size:11px;color:var(--fg-4)}.cv-links-row.is-missing .t{color:var(--fg-4);text-decoration:line-through}.cv-links-row.is-missing .s{color:#ffb3c1}.cv-links-open{flex:none;display:inline-flex;align-items:center;gap:4px;height:28px;padding:0 10px;border:0;border-radius:8px;background:#ffffff17;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer}.cv-links-open:hover{background:#ffffff29}.cv-links-add{margin-top:2px;border-top:1px solid var(--hairline-soft);border-radius:0 0 11px 11px}.ks{position:absolute;inset:0;z-index:120;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}@keyframes ksFade{0%{opacity:0}to{opacity:1}}.ks-card{position:relative;width:min(940px,100%);max-height:100%;overflow-y:auto;outline:none;padding:30px 36px 34px;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}@keyframes ksIn{0%{opacity:0;transform:translateY(10px) scale(.985)}to{opacity:1;transform:none}}.ks-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.ks-card::-webkit-scrollbar{width:8px}.ks-card::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.ks-head{display:flex;align-items:center;gap:14px;margin-bottom:30px}.ks-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.ks-titles{flex:1;min-width:0}.ks-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ks-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.ks-os{display:inline-flex;align-items:center;height:20px;padding:0 8px;margin-left:10px;vertical-align:2px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0d;font-size:10.5px;font-weight:600;letter-spacing:.04em;color:var(--fg-3)}.ks-close{margin-left:auto;align-self:flex-start;flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ks-close:hover{background:#ffffff17;color:var(--fg-1)}.ks-grid{display:grid;gap:30px 44px;align-items:start;grid-template-columns:repeat(3,minmax(0,1fr));grid-template-areas:"tools view edit" "tools board edit"}@media(max-width:920px){.ks-grid{grid-template-columns:repeat(2,minmax(0,1fr));grid-template-areas:"tools edit" "view board"}}@media(max-width:620px){.ks-card{padding:24px 22px 26px}.ks-grid{grid-template-columns:minmax(0,1fr);grid-template-areas:"tools" "view" "edit" "board"}}.ks-group h3{margin:0 0 8px;padding-bottom:11px;border-bottom:1px solid var(--hairline-soft);font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.ks-group ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column}.ks-group li{display:flex;align-items:center;justify-content:space-between;gap:16px;min-height:36px;padding:3px 0}.ks-label{min-width:0;display:flex;flex-direction:column;gap:2px;font-size:13px;color:var(--fg-2)}.ks-label small{font-size:11px;color:var(--fg-5)}.ks-keys{flex:none;display:inline-flex;align-items:center;gap:4px}.ks-key{min-width:24px;height:24px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;border-radius:7px;font-family:var(--font-sans);font-size:12px;font-weight:500;line-height:1;color:var(--fg-1);background:linear-gradient(180deg,#ffffff1a,#ffffff0b);border:1px solid rgba(255,255,255,.1);border-bottom-color:#ffffff0d;box-shadow:inset 0 1px #ffffff12,0 1px #00000073}.ks-key.is-word{padding:0 9px;font-size:11px;color:var(--fg-2)}.ks-key.is-inline{min-width:20px;height:20px;padding:0 6px;margin:0 2px;font-size:11px;vertical-align:1px}.rd{position:absolute;inset:0;z-index:92;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}.rd-card{position:relative;width:min(980px,100%);max-height:min(780px,100%);outline:none;display:flex;flex-direction:column;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}.rd-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.rd-head{flex:none;display:flex;align-items:center;gap:14px;padding:28px 32px 22px;border-bottom:1px solid var(--hairline-soft)}.rd-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.rd-titles{flex:1;min-width:0}.rd-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.rd-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.rd-head-acts{flex:none;display:flex;gap:8px}.rd-close{flex:none;align-self:flex-start;width:32px;height:32px;padding:0;margin-left:4px;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-close:hover{background:#ffffff17;color:var(--fg-1)}.rd-btn{height:30px;padding:0 11px;display:inline-flex;align-items:center;gap:6px;white-space:nowrap;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0d;font-family:var(--font-sans);font-size:12px;font-weight:500;line-height:1;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.rd-btn:hover{background:#ffffff1a;color:var(--fg-1)}.rd-btn.is-danger:hover{color:var(--danger);border-color:#ff5c7a59;background:#ff5c7a14}.rd-btn.is-confirming,.rd-btn.is-confirming:hover{color:#fff;background:#ff5c7ae0;border-color:transparent}.rd-groups{flex:1;min-height:0;overflow-y:auto;padding:0 32px 32px}.rd-groups::-webkit-scrollbar{width:8px}.rd-groups::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.rd-group{padding:22px 0 6px}.rd-group+.rd-group{border-top:1px solid var(--hairline-soft)}.rd-group-head{display:flex;align-items:center;gap:12px;margin-bottom:14px}.rd-avatar{flex:none;width:30px;height:30px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:10.5px;font-weight:600;letter-spacing:.02em;color:#fff;background:linear-gradient(135deg,var(--amethyst-500),var(--vista-blue-400));box-shadow:inset 0 1px #ffffff38}.rd-who{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.rd-email{font-size:13px;font-weight:500;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-email em{font-style:normal;margin-left:8px;padding:1px 6px;vertical-align:1px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0f;font-size:10px;font-weight:600;color:var(--fg-3)}.rd-when{font-size:11.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-left{flex:none;display:inline-flex;align-items:center;gap:5px;margin-right:4px;font-size:11.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.rd-group-acts{flex:none;display:flex;gap:6px}.rd-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(128px,1fr));gap:14px}.rd-item{position:relative;min-width:0;display:flex;flex-direction:column;gap:7px}.rd-thumb{position:relative;aspect-ratio:1 / 1;overflow:hidden;display:flex;align-items:center;justify-content:center;border-radius:12px;border:1px solid var(--hairline-soft);background:#ffffff09}.rd-thumb img{width:100%;height:100%;object-fit:cover;display:block}.rd-play{position:absolute;left:8px;bottom:8px;width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:#08091099;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}.rd-note{position:absolute;inset:10px;padding:9px 10px;border-radius:9px;overflow:hidden}.rd-note span{overflow:hidden;font-size:10.5px;line-height:1.45;color:var(--fg-2);white-space:pre-wrap;word-break:break-word;display:-webkit-box;-webkit-line-clamp:6;-webkit-box-orient:vertical}.rd-note.tint-amethyst{background:linear-gradient(180deg,#9968df2b,#9968df14);border:1px solid rgba(194,164,236,.22)}.rd-note.tint-vista{background:linear-gradient(180deg,#5a61ed2b,#5a61ed14);border:1px solid rgba(163,167,245,.22)}.rd-note.tint-sky{background:linear-gradient(180deg,#3db4e62b,#3db4e614);border:1px solid rgba(153,217,243,.22)}.rd-note.tint-mint{background:linear-gradient(180deg,#34c79a2b,#34c79a14);border:1px solid rgba(143,229,201,.22)}.rd-note.tint-amber{background:linear-gradient(180deg,#f0b44a2b,#f0b44a14);border:1px solid rgba(247,212,143,.22)}.rd-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14);border:1px solid rgba(245,163,199,.22)}.rd-note.tint-glass{background:var(--grad-glass);border:1px solid var(--hairline)}.rd-frame{position:absolute;inset:18px 14px;padding:8px;display:flex;align-items:flex-start;border-radius:8px;border:1.5px dashed rgba(255,255,255,.26)}.rd-frame span{min-width:0;font-size:10.5px;font-weight:600;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-shape{width:72%;height:72%;fill:none;stroke-width:4;stroke-linecap:round;stroke-linejoin:round}.rd-tool{color:var(--fg-3);display:inline-flex}.rd-item-acts{position:absolute;top:7px;right:7px;display:flex;gap:5px;opacity:0;transform:translateY(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast)}.rd-item:hover .rd-item-acts,.rd-item:focus-within .rd-item-acts{opacity:1;transform:none}.rd-item-acts button{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:8px;border:1px solid rgba(255,255,255,.12);background:#0a0b13cc;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:var(--fg-1);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-item-acts button:hover{background:#1e2030f0}.rd-item-acts button.is-danger:hover{color:var(--danger)}.rd-item-acts button.is-confirming,.rd-item-acts button.is-confirming:hover{background:#ff5c7aeb;border-color:transparent;color:#fff}.rd-item-name{min-width:0;display:flex;align-items:center;gap:6px;font-size:11.5px;color:var(--fg-3)}.rd-item-name>:first-child{flex:none;color:var(--fg-4)}.rd-item-name span{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-more{aspect-ratio:1 / 1;border-radius:12px;border:1px dashed var(--hairline);background:transparent;font-family:var(--font-sans);font-size:12px;font-weight:500;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-more:hover{color:var(--fg-1);background:#ffffff0a}.rd-empty{padding:64px 32px 76px;display:flex;flex-direction:column;align-items:center;text-align:center}.rd-empty-mark{width:52px;height:52px;margin-bottom:16px;border-radius:16px;display:inline-flex;align-items:center;justify-content:center;color:var(--fg-3);background:#ffffff0a;border:1px solid var(--hairline-soft)}.rd-empty h3{margin:0;font-size:15px;font-weight:600;color:var(--fg-1)}.rd-empty p{margin:6px 0 0;max-width:380px;font-size:12.5px;line-height:1.55;color:var(--fg-4)}.rd-pop-leave-active{transition:opacity .18s ease,transform .18s ease}.rd-pop-leave-to{opacity:0;transform:scale(.94)}@media(max-width:720px){.rd{padding:12px}.rd-head{flex-wrap:wrap;padding:22px 20px 18px}.rd-head-acts{order:3;width:100%}.rd-groups{padding:0 20px 24px}.rd-group-head{flex-wrap:wrap;row-gap:10px}.rd-who{flex-basis:calc(100% - 42px)}.rd-left{margin-left:42px}.rd-group-acts{margin-left:auto}.rd-grid{grid-template-columns:repeat(auto-fill,minmax(96px,1fr));gap:10px}.rd-note span{-webkit-line-clamp:3}}@media(prefers-reduced-motion:reduce){.rd,.rd-card{animation:none}.rd-pop-leave-active{transition:none}}', mIe = '.sv-root{position:absolute;inset:0;z-index:88;overflow:hidden;--hist-w: 340px;--hist-col: var(--hist-w);display:grid;grid-template-columns:290px minmax(0,1fr) var(--hist-col);grid-template-rows:60px minmax(0,1fr);transition:grid-template-columns .34s var(--ease-out-soft);background:var(--bg-deep);color:var(--fg-2);animation:svIn .3s var(--ease-out-soft) both}@keyframes svIn{0%{opacity:0;transform:scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.sv-root{animation:none}}.sv-ambient{position:absolute;inset:0;pointer-events:none;overflow:hidden}.sv-ambient span{position:absolute;inset:-12%;background-size:cover;background-position:center;filter:blur(90px) saturate(1.35);opacity:.2;animation:svAmbient .9s ease both}@keyframes svAmbient{0%{opacity:0}to{opacity:.2}}.sv-ambient:after{content:"";position:absolute;inset:0;background:radial-gradient(ellipse 70% 60% at 50% 45%,#04030c26,#04030cb8 70%,#04030cf0)}.sv-top{grid-column:1 / -1;grid-row:1;position:relative;z-index:3;display:flex;align-items:center;gap:12px;padding:0 14px;border-bottom:1px solid var(--hairline-soft);background:#0709108c;backdrop-filter:blur(22px);-webkit-backdrop-filter:blur(22px)}.sv-back,.sv-close{flex:none;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-back:hover,.sv-close:hover{background:#ffffff14;color:var(--fg-1);border-color:var(--hairline)}.sv-close{border-color:transparent;background:transparent}.sv-title{display:flex;flex-direction:column;min-width:0;gap:2px}.sv-title .eyebrow{font-size:9.5px;font-weight:600;letter-spacing:.22em;text-transform:uppercase;color:var(--fg-4)}.sv-title .name{font-size:14.5px;font-weight:600;color:var(--fg-1);max-width:340px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;letter-spacing:-.005em}.sv-session{flex:none;display:inline-flex;align-items:center;gap:8px;height:32px;padding:0 13px 0 11px;margin-left:6px;border-radius:999px;border:1px solid rgba(153,104,223,.32);background:#9968df14;font:inherit;color:inherit;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-session:hover{background:#9968df29;border-color:#9968df8c}.sv-session:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:2px}.sv-session .lb{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.sv-session .ic{width:20px;height:20px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:var(--amethyst-700)}.sv-session b{font-size:12.5px;font-weight:600;color:var(--fg-1);white-space:nowrap}.sv-pos{font-size:12px;color:var(--fg-4);font-variant-numeric:tabular-nums;white-space:nowrap}.sv-top-btn{display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 12px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-top-btn:hover{background:#ffffff14;color:var(--fg-1)}.sv-grow{flex:1;min-width:0}.sv-studios{grid-column:1;grid-row:2;position:relative;z-index:2;min-height:0;display:flex;flex-direction:column;margin:14px 0 14px 14px;padding:10px;border-radius:18px;background:#0b0d15e6;border:1px solid var(--hairline-soft);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c8c;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-studios::-webkit-scrollbar{width:5px}.sv-studios::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sv-seg.sv-sides{flex:none;display:flex;width:100%;padding:3px;border-radius:12px}.sv-seg.sv-sides button{flex:1;height:34px;font-size:12.5px;font-weight:600;border-radius:9px}.sv-seg.sv-sides button.on{background:#9968df38;color:#fff;box-shadow:inset 0 0 0 1px #9968df5c,inset 0 1px #ffffff14}.sv-seg.sv-sides button.on .licon{color:var(--amethyst-700)}.sv-modes{display:flex;flex-direction:column;margin-top:8px}.sv-mode+.sv-mode{border-top:1px solid var(--hairline-soft)}.sv-mode-head{display:flex;align-items:center;gap:11px;width:100%;height:48px;padding:0 8px;border:0;border-radius:10px;background:transparent;color:var(--fg-2);font-size:13.5px;font-weight:500;cursor:pointer;text-align:left;transition:background var(--dur-fast),color var(--dur-fast)}.sv-mode-head .licon{color:var(--fg-4);transition:color var(--dur-fast)}.sv-mode-head .chev{margin-left:auto;color:var(--fg-5)}.sv-mode-head:hover{color:var(--fg-1)}.sv-mode-head:hover .licon{color:var(--fg-2)}.sv-mode.on .sv-mode-head{color:var(--fg-1);cursor:default}.sv-mode.on .sv-mode-head .licon:first-child{color:var(--amethyst-600)}.sv-mode.on .sv-mode-head .chev{color:var(--fg-3)}.sv-mode.is-locked:not(.on) .sv-mode-head{opacity:.4}.sv-mode-body{display:flex;flex-direction:column;gap:14px;padding:0 4px 14px;animation:svPop .22s var(--ease-out-soft) both}.sv-main{grid-column:2;grid-row:2;position:relative;z-index:1;display:flex;flex-direction:column;min-width:0;min-height:0}.sv-stage{position:relative;flex:1;min-height:0}.sv-pic{position:absolute;border-radius:12px;background:#ffffff08;box-shadow:0 0 0 1px #ffffff0f,0 30px 90px #0206179e;transition:left .28s var(--ease-out-soft),top .28s var(--ease-out-soft),width .28s var(--ease-out-soft),height .28s var(--ease-out-soft);animation:svPic .36s var(--ease-out-soft) both}@keyframes svPic{0%{opacity:0;transform:scale(.985)}to{opacity:1;transform:none}}.sv-pic img{display:block;width:100%;height:100%;object-fit:cover;border-radius:12px;user-select:none;-webkit-user-drag:none;transition:opacity .3s ease}.sv-art-play{position:absolute;left:5px;bottom:5px;width:18px;height:18px;border-radius:50%;display:grid;place-items:center;color:#fff;background:#080a129e;pointer-events:none}.sv-pic video{display:block;width:100%;height:100%;object-fit:contain;border-radius:12px;background:#000}.sv-pic.is-loading img{opacity:0}.sv-pic.is-loading{overflow:hidden}.sv-pic.is-loading:after{content:"";position:absolute;inset:0;border-radius:12px;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.07) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.sv-pic.is-editing{box-shadow:0 0 0 1px #9968df73,0 0 0 5px #9968df14,0 30px 90px #0206179e}.sv-pic-tag,.sv-pic-unsaved{position:absolute;top:-27px;display:inline-flex;align-items:center;gap:6px;height:22px;padding:0 10px;white-space:nowrap;border-radius:999px;font-size:11px;font-weight:600;pointer-events:none;background:#04030c9e;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);border:1px solid rgba(255,255,255,.12);color:var(--fg-1)}.sv-pic-tag{left:0;max-width:70%;overflow:hidden;text-overflow:ellipsis}.sv-pic-tag.is-ref{border-color:#a3a7f573;color:var(--vista-blue-600)}.sv-pic-unsaved{right:0;border-color:#ffb34766;color:#ffd08a}.sv-marks{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}.sv-pin-mark circle{fill:#7c4dff;stroke:#fff;stroke-width:2.5}.sv-pin-mark text{fill:#fff;font-family:var(--font-sans);font-weight:700}.sv-layer{position:absolute;inset:0;touch-action:none;border-radius:12px}.sv-layer.is-draw{cursor:crosshair}.sv-layer.is-draw.tool-eraser{cursor:cell}.sv-layer.is-comment{cursor:copy}.sv-pin{position:absolute;z-index:2;transform:translate(-50%,-50%);width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:2.5px solid #fff;background:#7c4dff;color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:700;box-shadow:0 6px 18px #04030c80;cursor:grab;transition:box-shadow var(--dur-fast),transform var(--dur-fast);animation:svPinIn .28s var(--ease-out-soft) both}@keyframes svPinIn{0%{transform:translate(-50%,-50%) scale(.4);opacity:0}to{transform:translate(-50%,-50%);opacity:1}}.sv-pin:hover{transform:translate(-50%,-50%) scale(1.08)}.sv-pin:active{cursor:grabbing}.sv-pin.is-on{box-shadow:0 0 0 4px #7c4dff59,0 6px 18px #04030c80}.sv-pin.is-empty{background:#7c4dff8c}.sv-pin-editor{position:absolute;z-index:4;width:250px;padding:10px;border-radius:14px;background:#0d0f18f7;border:1px solid var(--hairline);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .2s var(--ease-out-soft) both;cursor:default}@keyframes svPop{0%{opacity:0;transform:translateY(4px) scale(.98)}to{opacity:1;transform:none}}.sv-pin-editor-head{display:flex;align-items:center;gap:8px;margin-bottom:8px}.sv-pin-editor-head .n{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:10.5px;font-weight:700}.sv-pin-editor-head .t{font-size:11px;font-weight:600;color:var(--fg-3)}.sv-pin-editor-head .x{margin-left:auto;width:24px;height:24px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.sv-pin-editor-head .x:hover{background:#ff5c7a1f;color:#ff8aa0}.sv-pin-editor textarea{display:block;width:100%;min-height:52px;resize:none;padding:8px 9px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:13px;line-height:1.45;outline:none}.sv-pin-editor textarea:focus{border-color:#9968df80}.sv-pin-editor-foot{display:flex;align-items:center;justify-content:space-between;margin-top:8px;font-size:10.5px;color:var(--fg-5)}.sv-mini-btn{height:26px;padding:0 12px;border:0;border-radius:8px;background:#9968df38;color:var(--amethyst-800);font-size:11.5px;font-weight:600;cursor:pointer}.sv-mini-btn:hover{background:#9968df57;color:#fff}.sv-invite{position:absolute;left:50%;top:48%;transform:translate(-50%,-50%);width:min(440px,calc(100% - 40px));display:flex;flex-direction:column;align-items:center;gap:10px;text-align:center;animation:svInvite .4s var(--ease-out-soft) both}@keyframes svInvite{0%{opacity:0;transform:translate(-50%,-46%)}to{opacity:1;transform:translate(-50%,-50%)}}.sv-invite b{font-size:18px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.sv-invite .sub{font-size:13px;line-height:1.55;color:var(--fg-3);max-width:380px}.sv-invite-mark{width:46px;height:46px;border-radius:14px;display:inline-flex;align-items:center;justify-content:center;margin-bottom:4px;background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff;box-shadow:inset 0 1px #ffffff2e,0 14px 40px #7532d34d}.sv-invite-acts{display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;justify-content:center}.sv-invite.is-making{gap:14px}.sv-making-time{margin-top:-6px;font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;color:var(--fg-3)}.sv-making{width:34px;height:34px;border-radius:50%;border:2.5px solid rgba(255,255,255,.12);border-top-color:var(--amethyst-600);animation:cvSpin .9s linear infinite}.sv-model{position:absolute;inset:16px 16px 8px;border-radius:16px;overflow:hidden;background:#e4e1dc;box-shadow:0 0 0 1px #ffffff0f,0 30px 90px #0206178c}.sv-model.is-clear{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.07) 25%,transparent 0 50%,rgba(255,255,255,.07) 0 75%,transparent 0);background-size:22px 22px}.sv-model canvas{display:block;cursor:grab;touch-action:none}.sv-model.is-dragging canvas{cursor:grabbing}.sv-finder{position:absolute;pointer-events:none;box-shadow:0 0 0 9999px #04030c4d;border-radius:4px}.sv-finder i{position:absolute;width:18px;height:18px;border:2px solid rgba(255,255,255,.92)}.sv-finder .tl{left:-2px;top:-2px;border-right:0;border-bottom:0;border-radius:4px 0 0}.sv-finder .tr{right:-2px;top:-2px;border-left:0;border-bottom:0;border-radius:0 4px 0 0}.sv-finder .bl{left:-2px;bottom:-2px;border-right:0;border-top:0;border-radius:0 0 0 4px}.sv-finder .br{right:-2px;bottom:-2px;border-left:0;border-top:0;border-radius:0 0 4px}.sv-finder-tag{position:absolute;right:8px;top:8px;padding:2px 8px;border-radius:999px;background:#04030c8c;color:#fff;font-size:10.5px;font-weight:600}.sv-dock{position:relative;z-index:6;flex:none;width:min(880px,calc(100% - 40px));margin:6px auto 18px;padding:10px 12px 12px;border-radius:18px;border:1px solid rgba(255,255,255,.06);background:#0b0d15f0;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e}.sv-note{position:absolute;left:50%;bottom:calc(100% + 10px);transform:translate(-50%);z-index:3;display:inline-flex;align-items:center;height:30px;padding:0 14px;border-radius:999px;white-space:nowrap;background:#11131ef5;border:1px solid var(--hairline);color:var(--fg-1);font-size:12px;font-weight:500;box-shadow:0 14px 40px #02040c80}.sv-note-enter-active,.sv-note-leave-active{transition:opacity .22s var(--ease-out-soft),transform .22s var(--ease-out-soft)}.sv-note-enter-from,.sv-note-leave-to{opacity:0;transform:translate(-50%,6px)}.sv-queue{display:flex;align-items:center;gap:12px;padding:2px 2px 10px;margin-bottom:10px;border-bottom:1px solid var(--hairline-soft);min-height:58px}.sv-queue-label{flex:none;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap}.sv-queue-slots{flex:1;min-width:0;display:flex;align-items:center;gap:9px;padding:5px 0 0 5px}.sv-queue-slots.is-video{flex:0 1 auto}.sv-queue-slots.is-video:only-of-type,.sv-queue:not(:has(.sv-queue-sep)) .sv-queue-slots.is-video{flex:1}.sv-slot.is-video{width:64px;overflow:hidden;cursor:default}.sv-slot.is-video video,.sv-slot.is-video img{width:100%;height:100%;object-fit:cover;border-radius:10px;display:block;background:#000}.sv-slot.is-video .v{position:absolute;left:4px;bottom:4px;display:inline-flex;padding:2px;border-radius:5px;background:#04030cb3;color:#fff}.sv-queue-sep{flex:none;width:1px;height:30px;background:var(--hairline-soft)}.sv-slot{position:relative;flex:none;width:44px;height:44px;border-radius:10px;cursor:pointer;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff1a;transition:transform var(--dur-fast) var(--ease-out-soft),opacity var(--dur-fast);animation:svSlot .32s var(--ease-out-soft) backwards}@keyframes svSlot{0%{opacity:0;transform:scale(.7)}to{opacity:1;transform:none}}.sv-slot:hover{transform:translateY(-2px)}.sv-slot .sv-art{border-radius:10px}.sv-slot:after{content:"";position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff1f;pointer-events:none}.sv-slot.is-ref:after{box-shadow:inset 0 0 0 1.5px #a3a7f599}.sv-slot.is-base:after{box-shadow:inset 0 0 0 2px var(--amethyst-500)}.sv-slot.is-stage{outline:2px solid rgba(255,255,255,.85);outline-offset:2px}.sv-slot.is-unsent{opacity:.38}.sv-slot.is-unsent:after{box-shadow:inset 0 0 0 1px #ffffff4d;border:1px dashed rgba(255,255,255,.5)}.sv-slot .n{position:absolute;left:-6px;top:-6px;z-index:2;min-width:18px;height:18px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--amethyst-400);color:#fff;font-size:10px;font-weight:700;box-shadow:0 0 0 2px #0b0d15}.sv-slot.is-base .n{background:linear-gradient(135deg,var(--amethyst-500),var(--vista-blue-400))}.sv-slot .x{position:absolute;right:-6px;top:-6px;z-index:2;width:18px;height:18px;padding:0;border-radius:50%;border:0;display:inline-flex;align-items:center;justify-content:center;background:#2a2d3b;color:var(--fg-2);cursor:pointer;box-shadow:0 0 0 2px #0b0d15;opacity:0;transition:opacity var(--dur-fast)}.sv-slot:hover .x{opacity:1}.sv-slot .x:hover{background:#ff5c7a;color:#fff}.sv-slot-add,.sv-slot-more{flex:none;width:44px;height:44px;padding:0;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;border:1px dashed rgba(255,255,255,.18);background:transparent;color:var(--fg-4);font-size:12px;font-weight:600;cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.sv-slot-more{border-style:solid;background:#ffffff0a;color:var(--fg-2)}.sv-slot-add:hover,.sv-slot-more:hover{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}.sv-queue-empty{font-size:12px;color:var(--fg-4);margin-left:4px}.sv-slot-add-wrap{position:relative;display:inline-flex}.sv-slot-add-wrap>.up-pop{left:0;right:auto;bottom:calc(100% + 10px);top:auto}.sv-queue{border-radius:14px;transition:background var(--dur-fast),box-shadow var(--dur-fast)}.sv-queue.is-air .sv-slot-add{border-color:var(--cv-accent-soft);color:var(--amethyst-700)}.sv-queue.is-over{background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.sv-queue-count{flex:none;font-size:11.5px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums}.sv-queue-count.is-over{color:#ffd08a}.sv-art{position:absolute;inset:0;display:block;overflow:hidden;border-radius:inherit}.sv-art img{display:block;width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none}.sv-bar{display:flex;align-items:center;gap:10px;min-height:36px}.sv-studio-bar{display:flex;flex-direction:column;gap:8px}.sv-bar-top{min-height:44px;display:flex;align-items:center;padding:0 4px}.sv-bar-top .sv-hint b{color:var(--fg-1);font-weight:600}.sv-chip.is-placeholder{cursor:default;color:var(--fg-5);background:transparent;border-style:dashed}.sv-chip.is-placeholder:hover{background:transparent;color:var(--fg-5)}.sv-pinchips{display:flex;align-items:center;gap:6px;min-width:0;overflow-x:auto;scrollbar-width:none}.sv-pinchips::-webkit-scrollbar{display:none}.sv-pinchip{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;max-width:220px;padding:0 11px 0 5px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-size:12px;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.sv-pinchip:hover{background:#ffffff14;color:var(--fg-1)}.sv-pinchip .n{flex:none;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:11px;font-weight:700}.sv-pinchip .t{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-pinchip.on{border-color:#7c4dff99;background:#7c4dff24;color:var(--fg-1)}.sv-pinchip.is-empty .t{color:var(--fg-4)}.sv-pinchips-empty{font-size:12px;color:var(--fg-5);padding-left:4px}.sv-hint{display:inline-flex;align-items:center;gap:8px;min-width:0;font-size:12.5px;color:var(--fg-3)}.sv-hint .licon{color:var(--amethyst-600);flex:none}.sv-sep{flex:none;width:1px;height:20px;background:var(--hairline-soft);margin:0 2px}.sv-seg{display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;background:#ffffff09;border:1px solid var(--hairline-soft)}.sv-seg button{height:30px;min-width:32px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;gap:6px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-seg button:hover:not(:disabled){color:var(--fg-1);background:#ffffff0d}.sv-seg button.on{background:#ffffff1a;color:var(--fg-1);box-shadow:inset 0 1px #ffffff0f}.sv-seg button:disabled{opacity:.4;cursor:default}.sv-seg.is-text button{padding:0 11px}.sv-seg.is-small{padding:2px;border-radius:9px}.sv-seg.is-small button{height:24px;font-size:11px;padding:0 9px;border-radius:7px}.sv-swatches{display:inline-flex;align-items:center;gap:7px;padding:0 2px;transition:opacity var(--dur-fast)}.sv-swatches.is-off,.sv-size.is-off{opacity:.35;pointer-events:none}.sv-swatches .sw{width:20px;height:20px;padding:0;border-radius:50%;border:0;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff38;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-swatches .sw:hover{transform:scale(1.12)}.sv-swatches .sw.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.sv-size{display:inline-flex;align-items:center;gap:9px;transition:opacity var(--dur-fast)}.sv-size i{flex:none;display:inline-block;border-radius:50%;box-shadow:0 0 0 1px #fff3}.sv-size input{width:88px;accent-color:var(--amethyst-500)}.sv-icon-btn{flex:none;width:34px;height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-icon-btn:hover:not(:disabled){background:#ffffff14;color:var(--fg-1)}.sv-icon-btn:disabled{opacity:.35;cursor:default}.sv-go{flex:none;display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 16px;border:0;border-radius:11px;background:var(--grad-cta);color:#fff;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff38;transition:filter var(--dur-fast),box-shadow var(--dur-fast),transform var(--dur-fast)}.sv-go:hover:not(:disabled){filter:brightness(1.08);box-shadow:0 9px 24px #745aff66,inset 0 1px #ffffff38}.sv-go:active:not(:disabled){transform:scale(.97)}.sv-go:disabled{background:#ffffff12;color:var(--fg-4);box-shadow:none;cursor:default}.sv-go.is-busy{opacity:.85}.sv-btn{display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 15px;border-radius:11px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font-size:13px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-btn:hover{background:#ffffff17;border-color:#ffffff29}.sv-btn.is-primary{border-color:transparent;background:var(--grad-cta);box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff38}.sv-btn.is-primary:hover{filter:brightness(1.08)}.sv-chip{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 11px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-chip:hover{background:#ffffff14;color:var(--fg-1)}.sv-chip.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--fg-1)}.sv-chip .licon{color:var(--fg-4)}.sv-chip.is-model .lb{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.sv-chip.is-model .nm{font-size:12.5px;color:var(--fg-1)}.sv-chip.is-dashed{border-style:dashed;border-color:#fff3;background:transparent;color:var(--fg-3)}.sv-chip.is-dashed:hover{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}.sv-chip.is-file .nm{max-width:170px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--fg-1)}.sv-cost{flex:none;display:inline-flex;align-items:center;gap:5px;font-size:11.5px;color:var(--fg-4);white-space:nowrap}.sv-pop-wrap{position:relative;flex:none;display:inline-flex}.sv-pop{position:absolute;left:0;bottom:calc(100% + 8px);z-index:10;min-width:290px;padding:6px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .18s var(--ease-out-soft) both}.sv-pop.is-narrow{min-width:110px}.sv-pop-row{display:flex;align-items:center;gap:10px;width:100%;height:34px;padding:0 10px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-size:12.5px;text-align:left;cursor:pointer}.sv-pop-row:hover{background:#ffffff0f;color:var(--fg-1)}.sv-pop-row.on{background:var(--cv-accent-tint);color:var(--fg-1)}.sv-pop-row .nm{font-weight:500}.sv-pop-sep{height:1px;margin:3px 8px;background:var(--hairline-soft)}.sv-pop-row .mt{margin-left:auto;font-size:11px;color:var(--fg-4);white-space:nowrap}.sv-pop-row .tk{display:inline-flex;align-items:center;gap:4px;font-size:11px;color:var(--fg-3);min-width:44px;justify-content:flex-end}.sv-describe{display:flex;flex-direction:column;gap:8px}.sv-words{position:relative}.sv-words.has-side .sv-describe-text{padding-right:40px}.sv-words-side{position:absolute;top:2px;right:0}.sv-lines{display:flex;flex-direction:column;gap:6px;max-height:128px;overflow-y:auto;padding:8px 10px;border-radius:12px;background:#ffffff08;border:1px solid var(--hairline-soft)}.sv-lines.is-quiet{padding:6px 10px}.sv-lines-head{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:11px;color:var(--fg-3)}.sv-lines-head>span{display:inline-flex;align-items:center;gap:6px}.sv-lines-head .licon{color:var(--amethyst-600)}.sv-line{display:flex;align-items:baseline;gap:9px;font-size:12.5px;color:var(--fg-1);line-height:1.45}.sv-line .tag{flex:none;display:inline-flex;align-items:center;gap:2px;padding:1px 7px;border-radius:999px;background:#7c4dff33;color:var(--amethyst-800);font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.sv-line .tag i{font-style:normal;opacity:.6}.sv-warn{display:flex;align-items:center;gap:8px;padding:7px 10px;border-radius:10px;font-size:12px;color:#ffd08a;background:#ffb34714;border:1px solid rgba(255,179,71,.22)}.sv-warn span{flex:1;min-width:0}.sv-link{flex:none;padding:0;border:0;background:transparent;color:var(--amethyst-700);font-size:11.5px;font-weight:600;cursor:pointer}.sv-link:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.sv-prompt{display:block;width:100%;min-height:44px;max-height:150px;resize:none;padding:6px 4px;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:15px;line-height:1.5;overflow-y:auto}.sv-prompt::placeholder{color:var(--fg-4)}.sv-foot{display:flex;align-items:center;gap:8px}.sv-foot .sv-go{margin-left:auto}.sv-cams{display:flex;align-items:center;gap:6px;min-width:0;overflow-x:auto;scrollbar-width:none}.sv-cams::-webkit-scrollbar{display:none}.sv-cam{flex:none;display:inline-flex;align-items:center;height:32px;border-radius:10px;border:1px solid rgba(163,167,245,.3);background:#5a61ed1a;overflow:hidden}.sv-cam button{height:100%;border:0;background:transparent;color:var(--fg-1);cursor:pointer;display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:500}.sv-cam .go{padding:0 6px 0 10px}.sv-cam .go .licon{color:var(--vista-blue-500)}.sv-cam .x{padding:0 8px 0 4px;color:var(--fg-4)}.sv-cam .go:hover{background:#5a61ed29}.sv-cam .x:hover{color:#ff8aa0}.sv-cam-input{flex:none;width:120px;height:32px;padding:0 10px;border-radius:10px;border:1px solid rgba(163,167,245,.6);background:#5a61ed24;color:var(--fg-1);font-size:12px;outline:none}.sv-hist{grid-column:3;grid-row:2;position:relative;z-index:2;min-height:0;margin:14px 14px 14px 0;display:flex;flex-direction:column;padding:12px;border-radius:18px;background:#0b0d15e6;border:1px solid var(--hairline-soft);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c8c}.sv-hist-head{flex:none;display:flex;align-items:center;gap:8px}.sv-hist-head .t{font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.sv-hist-head .n{padding:2px 7px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);font-size:10px;font-weight:600;font-variant-numeric:tabular-nums}.sv-hist-from{flex:none;border-radius:12px;border:1px solid var(--hairline-soft);background:#ffffff06}.sv-hist-from-head{display:flex;align-items:center;gap:7px;width:100%;height:30px;padding:0 10px;border:0;background:transparent;color:var(--fg-3);cursor:pointer;font:600 10px var(--font-sans);letter-spacing:.14em;text-transform:uppercase}.sv-hist-from-head:hover{color:var(--fg-1)}.sv-hist-from-head .n{padding:1px 6px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);letter-spacing:0;font-variant-numeric:tabular-nums}.sv-hist-from-row{display:flex;flex-wrap:wrap;gap:6px;padding:0 10px 10px}.sv-hist-from-pic{position:relative;width:52px;height:52px;padding:0;border-radius:8px;cursor:pointer;border:1px solid var(--hairline);background:#ffffff0a center / cover no-repeat;transition:transform var(--dur-fast) var(--ease-out-soft),border-color var(--dur-fast)}.sv-hist-from-pic:hover{transform:translateY(-2px);border-color:#c2a4ec99}.sv-hist-from-pic .k{position:absolute;left:4px;top:4px;min-width:15px;height:15px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:#080910c7;color:#fff;font:600 9px var(--font-sans)}.sv-hist-cols{flex:none;display:inline-flex;align-items:center;gap:8px;height:30px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-4);transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.sv-hist-cols:hover,.sv-hist-cols:focus-within{background:#ffffff0f;color:var(--fg-2)}.sv-hist-cols .licon{flex:none}.sv-hist-cols-track{position:relative;flex:none;width:66px;height:18px}.sv-hist-cols-track .rail,.sv-hist-cols-track .fill{position:absolute;top:50%;height:3px;margin-top:-1.5px;border-radius:999px;pointer-events:none}.sv-hist-cols-track .rail{left:6px;right:6px;background:#ffffff24}.sv-hist-cols-track .fill{left:6px;background:var(--amethyst-500);transition:width var(--dur-fast) var(--ease-out-soft)}.sv-hist-cols-track i{position:absolute;top:50%;width:3px;height:3px;margin:-1.5px 0 0 -1.5px;border-radius:50%;background:#ffffff4d;pointer-events:none}.sv-hist-cols-track i.on{background:#ffffffd9}.sv-hist-cols-track input{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;-webkit-appearance:none;appearance:none;background:transparent;cursor:pointer;outline:none}.sv-hist-cols-track input::-webkit-slider-runnable-track{height:18px;background:transparent;border:0}.sv-hist-cols-track input::-moz-range-track{height:18px;background:transparent;border:0}.sv-hist-cols-track input::-webkit-slider-thumb{-webkit-appearance:none;width:12px;height:12px;margin-top:3px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c8c;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-hist-cols-track input::-moz-range-thumb{width:12px;height:12px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c8c}.sv-hist-cols-track input:hover::-webkit-slider-thumb,.sv-hist-cols-track input:active::-webkit-slider-thumb{transform:scale(1.15)}.sv-hist-cols-track input:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft),0 1px 4px #02040c8c}.sv-hist-cols-track input:focus-visible::-moz-range-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft)}.sv-hist-grid{--cols: 2;flex:1;min-height:0;overflow-y:auto;display:grid;grid-template-columns:repeat(var(--cols),minmax(0,1fr));gap:10px;align-content:start;padding:6px 2px 2px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-hist.cols-3 .sv-hist-grid{gap:8px}.sv-hist.cols-4 .sv-hist-grid,.sv-hist.cols-5 .sv-hist-grid{gap:6px}.sv-hist-grid::-webkit-scrollbar{width:5px}.sv-hist-grid::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sv-hist-empty{grid-column:1 / -1;padding:18px 8px;font-size:12px;line-height:1.5;color:var(--fg-4);text-align:center}.sv-cell{position:relative;flex:none;aspect-ratio:4 / 3;cursor:pointer}.sv-cell.is-new{animation:svCellIn .45s var(--ease-out-soft) backwards}@keyframes svCellIn{0%{opacity:0;transform:scale(.86)}to{opacity:1;transform:none}}.sv-cell .frame{position:absolute;inset:0;border-radius:10px;overflow:hidden;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff12;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-cell .frame:after{content:"";position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff14;pointer-events:none;transition:box-shadow var(--dur-fast)}.sv-cell:hover .frame,.sv-cell.is-on .frame{transform:translateY(-2px);box-shadow:0 12px 28px #02040c80}.sv-cell:hover .frame:after,.sv-cell.is-on .frame:after{box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.sv-cell.is-ref .frame:after{box-shadow:inset 0 0 0 1.5px #a3a7f58c}.sv-cell.is-stage .frame:after{box-shadow:inset 0 0 0 2px #ffffffe6}.sv-cell.is-pending .frame:before{content:"";position:absolute;inset:0;z-index:1;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.sv-cell-time{position:absolute;left:50%;top:50%;z-index:2;transform:translate(-50%,-50%);font-size:11px;font-weight:600;font-variant-numeric:tabular-nums;letter-spacing:.02em;color:#ffffffa8;pointer-events:none}.sv-cell.is-failed .frame{display:flex;align-items:center;justify-content:center;background:#ff5c7a14;box-shadow:inset 0 0 0 1px #ff5c7a40}.sv-cell-fail{color:#ff8aa0;display:inline-flex}.sv-cell-how{position:absolute;left:6px;top:6px;z-index:2;width:20px;height:20px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#5a61ede6;color:#fff;box-shadow:0 2px 8px #04030c66}.sv-cell-q{position:absolute;right:6px;top:6px;z-index:2;min-width:20px;height:20px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--amethyst-400);color:#fff;font-size:10.5px;font-weight:700;box-shadow:0 2px 8px #04030c66}.sv-cell-dot{position:absolute;right:8px;bottom:8px;z-index:2;width:8px;height:8px;border-radius:50%;background:#ffb347;box-shadow:0 0 0 2px #0b0d15e6}.sv-cell-cap{position:absolute;left:6px;bottom:6px;z-index:2;max-width:calc(100% - 12px);padding:2px 7px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:var(--fg-2);font-size:10.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:opacity var(--dur-fast)}.sv-hist.cols-3 .sv-cell-cap,.sv-hist.cols-4 .sv-cell-cap,.sv-hist.cols-5 .sv-cell-cap{display:none}.sv-hist:not(.cols-1) .sv-cell-card{padding:0;width:18px;justify-content:center}.sv-hist:not(.cols-1) .sv-cell-card .tx{display:none}.sv-hist.cols-4 .sv-cell .frame,.sv-hist.cols-5 .sv-cell .frame,.sv-hist.cols-4 .sv-cell .frame:after,.sv-hist.cols-5 .sv-cell .frame:after{border-radius:8px}.sv-hist.cols-4 .sv-cell-how,.sv-hist.cols-5 .sv-cell-how{left:4px;top:4px;width:16px;height:16px;border-radius:5px}.sv-hist.cols-4 .sv-cell-q,.sv-hist.cols-5 .sv-cell-q{right:4px;top:4px;min-width:16px;height:16px;padding:0 4px;font-size:9.5px}.sv-hist.cols-4 .sv-cell-marks,.sv-hist.cols-5 .sv-cell-marks{right:4px;bottom:4px;width:14px;height:14px}.sv-hist.cols-4 .sv-cell-marks .licon,.sv-hist.cols-5 .sv-cell-marks .licon{display:none}.sv-hist.cols-4 .sv-cell-card,.sv-hist.cols-5 .sv-cell-card{right:4px;bottom:4px;width:16px;height:16px}.sv-hist-pop{position:absolute;z-index:6;border-radius:14px;pointer-events:auto;box-shadow:0 28px 70px #02040cc2}.sv-hist .sv-hist-pop{right:calc(100% + 12px);animation:svHistPop .22s var(--ease-out-soft) both}@keyframes svHistPop{0%{opacity:0;transform:translate(10px) scale(.94)}to{opacity:1;transform:none}}.sv-hist .sv-hist-pop:after{content:"";position:absolute;right:-26px;top:0;bottom:0;width:26px}.sv-hist-pop .art{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;border-radius:14px;overflow:hidden;cursor:pointer;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff1f}.sv-hist-pop .art .sv-art{border-radius:14px}.sv-hist-pop .cap{position:absolute;left:0;right:0;bottom:0;display:flex;flex-direction:column;gap:2px;padding:34px 13px 12px;pointer-events:none;border-radius:0 0 14px 14px;background:linear-gradient(180deg,#04030c00,#04030ce0 64%)}.sv-hist-pop .cap .n{min-width:0;font-size:12px;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sv-hist-pop .cap .m{font-size:10.5px;font-weight:500;color:#ffffffa8}.sv-hist-acts{position:absolute;right:10px;top:10px;z-index:3;display:flex;align-items:center;gap:6px}.sv-hist-acts button{position:relative;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:#04030cb8;color:#fff;cursor:pointer;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-hist-acts button:hover{background:var(--cv-accent);border-color:transparent}.sv-hist-acts button.on{background:var(--amethyst-400);border-color:transparent}.sv-hist-acts button.is-danger:hover,.sv-hist-acts button.is-armed{background:#e5486a;border-color:transparent}.sv-hist-acts .tip{position:absolute;top:calc(100% + 8px);right:-4px;z-index:2;background:#0b0d14f5;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:10.5px;font-weight:500;padding:4px 8px;border-radius:7px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.sv-hist-acts button:hover .tip,.sv-hist-acts button.is-armed .tip{opacity:1}.sv-dropping{position:absolute;inset:0;z-index:20;display:flex;align-items:center;justify-content:center;background:#04030c8c;pointer-events:none}.sv-dropping>div{display:inline-flex;align-items:center;gap:10px;padding:14px 20px;border-radius:14px;border:1.5px dashed rgba(153,104,223,.7);background:#0d0f18eb;color:var(--fg-1);font-size:13.5px}@media(max-width:900px){.sv-session .lb,.sv-queue-label,.sv-cost,.sv-pos{display:none}.sv-bar,.sv-foot{flex-wrap:wrap;row-gap:8px}.sv-bar .sv-go{margin-left:auto}.sv-hist{margin-right:10px;padding:10px}.sv-title .name{max-width:180px}.sv-dock{width:calc(100% - 20px);margin-bottom:10px}.sv-size input{width:64px}}.sv-continue{position:absolute;left:50%;bottom:14px;transform:translate(-50%);z-index:3;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-size:12px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);box-shadow:0 10px 30px #02040c73;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);animation:svContIn .24s var(--ease-out-soft) backwards}@keyframes svContIn{0%{opacity:0;transform:translate(-50%,6px)}to{opacity:1;transform:translate(-50%)}}.sv-continue:hover{background:var(--cv-accent);border-color:transparent;transform:translate(-50%) translateY(-1px)}.bd-root.is-studio .cv-stage{visibility:hidden;transition:visibility 0s linear .32s}.sv-model-tools{position:absolute;right:14px;bottom:14px;display:flex;align-items:center;gap:6px}.sv-seg.is-dark{background:#04030c8c;border-color:#ffffff1f;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}.sv-seg.is-dark button{color:#ffffffb8}.sv-seg.is-dark button.on{background:#ffffff2e;color:#fff}.sv-model-btn{width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:9px;border:1px solid rgba(255,255,255,.12);background:#04030c8c;color:#fffc;cursor:pointer;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);transition:background var(--dur-fast)}.sv-model-btn:hover{background:#04030cbf;color:#fff}.sv-layer.is-draw.tool-move{cursor:default}.sv-layer.is-draw.tool-move.is-over{cursor:move}.sv-layer.is-draw.tool-text{cursor:text}.sv-layer.is-draw.tool-brush,.sv-layer.is-draw.tool-eraser{cursor:none}.sv-sel{position:absolute;z-index:2;pointer-events:none;border:1.5px dashed rgba(255,255,255,.95);border-radius:3px;box-shadow:0 0 0 1px #04030c73}.sv-sel .h{position:absolute;width:11px;height:11px;border-radius:3px;pointer-events:auto;background:#fff;box-shadow:0 0 0 1.5px #7c4dff,0 2px 6px #04030c66}.sv-sel .nw{left:-6px;top:-6px;cursor:nwse-resize}.sv-sel .ne{right:-6px;top:-6px;cursor:nesw-resize}.sv-sel .se{right:-6px;bottom:-6px;cursor:nwse-resize}.sv-sel .sw{left:-6px;bottom:-6px;cursor:nesw-resize}.sv-sel .stem{position:absolute;left:50%;top:-22px;width:1.5px;height:16px;margin-left:-.75px;background:#ffffffe6}.sv-sel .turn{left:50%;top:-30px;margin-left:-6px;width:12px;height:12px;border-radius:50%;cursor:grab}.sv-marquee{position:absolute;z-index:2;pointer-events:none;border:1px solid rgba(153,104,223,.9);background:#7c4dff1f;border-radius:2px}.sv-ring{position:absolute;z-index:3;pointer-events:none;transform:translate(-50%,-50%);border-radius:50%;border:1.5px solid #fff;box-shadow:0 0 0 1px #04030c8c,inset 0 0 0 1px #04030c59}.sv-ring.is-eraser{border-style:dashed;background:#ffffff1f}.sv-text-editor{position:absolute;z-index:4;margin:0;padding:0;border:0;outline:1px dashed rgba(255,255,255,.85);outline-offset:3px;background:transparent;resize:none;overflow:hidden;white-space:pre-wrap;word-break:normal;overflow-wrap:anywhere;font-weight:400;letter-spacing:normal;transform-origin:center;caret-color:currentColor;text-shadow:none}.sv-text-editor::placeholder{color:currentColor;opacity:.45}.sv-color{flex:none;width:34px;height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;cursor:pointer;transition:background var(--dur-fast)}.sv-color i{width:18px;height:18px;border-radius:50%;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff4d}.sv-color:hover,.sv-color.on{background:#ffffff14}.sv-pop.is-colors{min-width:0;display:flex;align-items:center;gap:8px;padding:9px 10px}.sv-pop.is-colors .sw{position:relative;width:22px;height:22px;padding:0;border-radius:50%;border:0;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff38;transition:transform var(--dur-fast) var(--ease-out-soft)}.sv-pop.is-colors .sw:hover{transform:scale(1.12)}.sv-pop.is-colors .sw.on{box-shadow:0 0 0 2px #0d0f18,0 0 0 4px #ffffffd9}.sv-pop.is-colors .sw.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.sv-pop.is-colors .sw.is-any.on{background:var(--c)}.sv-pop.is-colors .sw.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.sv-size .num{width:42px;height:28px;padding:0 6px;border-radius:8px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:12px;font-variant-numeric:tabular-nums;text-align:center;outline:none;-moz-appearance:textfield}.sv-size .num::-webkit-inner-spin-button,.sv-size .num::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.sv-size .num:focus{border-color:#9968df80}.sv-size i.is-eraser{border:1.5px dashed rgba(255,255,255,.6)}.sv-size input[type=range]{width:84px}.sv-tools{display:flex;flex-direction:column;gap:10px}.sv-tools-hint{margin:0;font-size:11.5px;line-height:1.5;color:var(--fg-2)}.sv-tools-empty{margin:0;font-size:11.5px;color:var(--fg-3)}.sv-tools-label{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-3);margin-bottom:-4px}.sv-tools-row{display:flex;align-items:center;gap:8px}.sv-tools-row.is-hist{gap:6px}.sv-toolgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}.sv-toolgrid button{height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-toolgrid button:hover{background:#ffffff0f;color:var(--fg-1)}.sv-toolgrid button.on{background:#9968df33;color:#fff;box-shadow:inset 0 0 0 1px #9968df59}.sv-tools .sv-size{flex:1;min-width:0;gap:6px}.sv-tools .sv-size input[type=range]{flex:1;min-width:0;width:auto}.sv-tools .sv-size .num{width:38px}.sv-icon-btn.is-text{width:auto;padding:0 10px;gap:6px;font-size:12px;margin-left:auto}.sv-pop.is-below{top:calc(100% + 8px);bottom:auto}.sv-comments{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:4px;max-height:300px;overflow-y:auto}.sv-comments li{display:flex;align-items:flex-start;gap:2px;border-radius:9px;transition:background var(--dur-fast)}.sv-comments li:hover,.sv-comments li.on{background:#7c4dff1f}.sv-comments .go{flex:1;min-width:0;display:flex;align-items:flex-start;gap:8px;padding:6px 4px 6px 6px;border:0;background:transparent;color:var(--fg-1);text-align:left;cursor:pointer;font-size:12px;line-height:1.4}.sv-comments .n{flex:none;width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:10.5px;font-weight:700}.sv-comments .t{min-width:0;padding-top:1px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.sv-comments .t.is-empty{color:var(--fg-4)}.sv-comments .x{flex:none;width:24px;height:24px;margin:4px 4px 0 0;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-5);cursor:pointer;opacity:0;transition:opacity var(--dur-fast)}.sv-comments li:hover .x{opacity:1}.sv-comments .x:hover{color:#ff8aa0;background:#ff5c7a1f}.sv-file{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:12px;cursor:pointer;text-align:left}.sv-file span{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-file .licon{color:var(--fg-4)}.sv-file:hover{background:#ffffff14}.sv-views{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:3px}.sv-views li{display:flex;align-items:center;border-radius:9px;transition:background var(--dur-fast)}.sv-views li:hover{background:#5a61ed1f}.sv-views .go{flex:1;min-width:0;display:flex;align-items:center;gap:8px;height:30px;padding:0 8px;border:0;background:transparent;color:var(--fg-1);font-size:12px;cursor:pointer;text-align:left}.sv-views .go .licon{color:var(--vista-blue-500)}.sv-views .go.is-add{color:var(--fg-2)}.sv-views .go.is-add .licon{color:var(--fg-3)}.sv-views .x{width:24px;height:24px;margin-right:3px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.sv-views .x:hover{color:#ff8aa0;background:#ff5c7a1f}.sv-view-input{width:100%;height:30px;padding:0 8px;border-radius:8px;border:1px solid rgba(163,167,245,.6);background:#5a61ed24;color:var(--fg-1);font-size:12px;outline:none}.sv-btn.is-wide{width:100%;justify-content:center;height:34px;font-size:12.5px}.sv-cell-marks,.sv-slot .m{position:absolute;z-index:2;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:#ff3d6e;color:#fff;box-shadow:0 0 0 2px #0b0d15e6}.sv-cell-marks{right:6px;bottom:6px;width:18px;height:18px}.sv-slot .m{right:-5px;bottom:-5px;width:16px;height:16px}.sv-pic-unsaved.is-marks{border-color:#ff3d6e66;color:#ff9db5}@media(max-width:1180px){.sv-root{--hist-w: 284px;grid-template-columns:266px minmax(0,1fr) var(--hist-col)}.sv-hist-head .t,.sv-hist-head .n,.sv-chip.is-model .lb{display:none}}@media(max-width:900px){.sv-root{--hist-w: 184px;grid-template-columns:240px minmax(0,1fr) var(--hist-col)}.sv-hist-head{gap:6px}.sv-hist-head .sv-hist-cols{padding:0 8px}.sv-hist-head .sv-hist-cols .licon{display:none}}.sv-pop-wrap.is-row{display:flex;flex-direction:column;gap:6px;width:100%}.sv-model-row{display:flex;align-items:center;gap:9px;width:100%;height:40px;padding:0 12px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-1);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-model-row:hover,.sv-model-row.on{background:#ffffff12}.sv-model-row.on{border-color:var(--cv-accent-soft)}.sv-model-row .licon{flex:none;color:var(--fg-4)}.sv-model-row .nm{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-model-row .tk{flex:none;display:inline-flex;align-items:center;gap:4px;font-size:11.5px;color:var(--fg-3);font-variant-numeric:tabular-nums}.sv-model-row .tk .licon{color:inherit}.sv-model-list{display:flex;flex-direction:column;gap:2px;padding:4px;border-radius:11px;border:1px solid var(--hairline-soft);background:#090a1099;animation:svPop .18s var(--ease-out-soft) both}.sv-model-list .sv-pop-row{display:grid;grid-template-columns:minmax(0,1fr) auto;grid-template-rows:auto auto;align-items:center;row-gap:1px;height:auto;padding:7px 10px}.sv-model-list .sv-pop-row .nm{grid-column:1;grid-row:1;font-size:12.5px}.sv-model-list .sv-pop-row .mt{grid-column:1;grid-row:2;margin-left:0;font-size:10.5px}.sv-model-list .sv-pop-row .tk{grid-column:2;grid-row:1 / span 2}.sv-pop-item{position:relative}.sv-pop-item .sv-pop-row{padding-right:40px}.sv-pop-item:hover .sv-pop-row{background:#ffffff0f;color:var(--fg-1)}.sv-pop-item:hover .sv-pop-row.on{background:var(--cv-accent-tint)}.sv-pop-pin{position:absolute;right:6px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-pop-item:hover .sv-pop-pin,.sv-pop-pin.on,.sv-pop-pin:focus-visible{opacity:1}.sv-pop-pin:hover{background:#ffffff17;color:#fff}.sv-pop-pin.on{color:var(--cv-accent-text)}.sv-pop-pin.on svg{fill:currentColor}.sv-queue{position:relative}.sv-slot-peek{position:absolute;bottom:calc(100% + 24px);z-index:8;border-radius:12px;overflow:hidden;pointer-events:none;background:#ffffff0a;box-shadow:0 0 0 1px #ffffff24,0 24px 60px #02040cb8;animation:svPeek .18s var(--ease-out-soft) both}@keyframes svPeek{0%{opacity:0;transform:translateY(6px) scale(.96)}to{opacity:1;transform:none}}.sv-slot-peek .sv-art{border-radius:12px}.sv-slot-peek .n{position:absolute;left:8px;top:8px;z-index:2;padding:2px 8px;border-radius:999px;background:#04030cb3;color:#fff;font-size:10.5px;font-weight:600}.sv-note.is-floating{bottom:22px}.sv-root.side-edit .sv-stage{margin-bottom:6px}.sv-hist-lib{flex:none;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-hist-lib:hover{background:#9968df29;border-color:#9968df66;color:#fff}.sv-hist-filter{position:relative;flex:none;margin:10px 0 8px}.sv-hist-filter-btn{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 9px 0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0d;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-hist-filter-btn .licon{flex:none;color:var(--fg-4)}.sv-hist-filter-btn .licon:first-child{color:var(--amethyst-600)}.sv-hist-filter-btn .lb{flex:1;min-width:0;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-hist-filter-btn .chev{transition:transform var(--dur-med) var(--ease-out-soft)}.sv-hist-filter-btn:hover,.sv-hist-filter-btn.on{background:#ffffff17}.sv-hist-filter-btn.on{border-color:#9968df73}.sv-hist-filter-btn.on .chev{transform:rotate(180deg)}.sv-hist-filter-btn.is-narrowed{border-color:#9968df61;background:#9968df1f}.sv-hist-filter-pop{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:12;padding:5px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .18s var(--ease-out-soft) both}.sv-hist-opts{max-height:320px;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-hist-opt-sep{height:1px;margin:4px 6px;background:var(--hairline-soft)}.sv-hist-opt-line{position:relative;display:flex;align-items:center;border-radius:9px;transition:background var(--dur-fast)}.sv-hist-opt-line:hover{background:#ffffff0f}.sv-hist-opt{flex:1;min-width:0;display:flex;align-items:center;gap:9px;width:100%;margin:0;padding:7px 9px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt.is-all:hover{background:#ffffff0f}.sv-hist-opt:hover,.sv-hist-opt.on{color:#fff}.sv-hist-filter-pop .ck{flex:none;width:16px;height:16px;border-radius:5px;display:inline-flex;align-items:center;justify-content:center;box-shadow:inset 0 0 0 1.5px #ffffff3d;color:#fff;transition:background var(--dur-fast),box-shadow var(--dur-fast)}.sv-hist-opt.on .ck{background:var(--amethyst-400);box-shadow:none}.sv-hist-filter-pop .ic{flex:none;width:20px;height:20px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff12;color:var(--amethyst-700)}.sv-hist-filter-pop .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.sv-hist-filter-pop .tx b{font-size:12.5px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-hist-filter-pop .tx small{font-size:10.5px;color:var(--fg-4);line-height:1.35}.sv-hist-filter-pop .ct{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.sv-hist-opt-line .sv-hist-opt{padding-right:40px}.sv-hist-opt-acts{position:absolute;right:6px;top:50%;transform:translateY(-50%);display:flex;align-items:center;gap:4px}.sv-hist-only{height:24px;padding:0 9px;border-radius:7px;border:1px solid var(--hairline);background:#161824fa;color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt-line:hover .sv-hist-only,.sv-hist-only:focus-visible{opacity:1}.sv-hist-only:hover{background:var(--cv-accent);border-color:transparent;color:#fff}.sv-hist-opt-line:hover .ct{visibility:hidden}.sv-hist-pin{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt-line:hover .sv-hist-pin,.sv-hist-pin.on,.sv-hist-pin:focus-visible{opacity:1}.sv-hist-pin:hover{background:#ffffff17;color:#fff}.sv-hist-pin.on{color:var(--amethyst-700)}.sv-hist-pin.on svg{fill:currentColor}.sv-hist-opt-label{padding:8px 10px 4px;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-hist-opt-none{padding:14px 10px;font-size:12px;color:var(--fg-4);text-align:center}.sv-hist-opt-note{margin:4px 0 0;padding:8px 10px 4px;border-top:1px solid var(--hairline-soft);font-size:10.5px;line-height:1.45;color:var(--fg-4)}.sv-hist-opt.is-current small{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sv-hist-search{display:flex;align-items:center;gap:8px;height:34px;margin:0 0 4px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.sv-hist-search:focus-within{border-color:#9968df80;box-shadow:0 0 0 3px #9968df1f}.sv-hist-search input{flex:1;min-width:0;height:100%;margin:0;padding:0;border:0;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;outline:none}.sv-hist-search input::placeholder{color:var(--fg-5)}.sv-hist-search .x{flex:none;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:6px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.sv-hist-search .x:hover{background:#ffffff1f;color:#fff}.sv-pop-search{display:flex;align-items:center;gap:7px;height:32px;margin:0 0 4px;padding:0 9px;border-radius:8px;background:#ffffff0a;border:1px solid var(--hairline-soft);color:var(--fg-4)}.sv-pop-search input{flex:1;min-width:0;height:100%;border:0;background:transparent;color:var(--fg-1);font-size:12.5px;outline:none}.sv-pop-rows{max-height:300px;overflow-y:auto}.sv-model-list .sv-pop-rows{max-height:260px}.sv-pop-empty{padding:10px;font-size:12px;color:var(--fg-4)}.sv-pop-foot{margin:6px 4px 2px;font-size:10.5px;line-height:1.4;color:var(--fg-5)}.sv-pop-title{padding:4px 10px 6px;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-pop.is-down{bottom:auto;top:calc(100% + 6px)}.sv-pop-slider{display:flex;align-items:center;gap:10px;padding:4px 10px 8px;min-width:200px}.sv-pop-slider input{flex:1;accent-color:var(--amethyst-500)}.sv-pop-slider b{min-width:28px;text-align:right;font-size:12px;color:var(--fg-1);font-variant-numeric:tabular-nums}.sv-fields{display:flex;align-items:center;flex-wrap:wrap;gap:6px}.sv-problem{display:flex;align-items:center;gap:6px;margin-top:8px;font-size:11.5px;color:#ffcf8a}.sv-problem.is-inline{margin-top:0}.sv-problem .licon{flex:none}.sv-go.is-blocked:not(.is-busy){filter:saturate(.6)}.sv-promote{position:absolute;right:12px;bottom:14px;z-index:3;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-size:12px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);box-shadow:0 10px 30px #02040c73;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);animation:svPop .24s var(--ease-out-soft) backwards}.sv-promote:hover{background:var(--cv-accent);border-color:transparent;transform:translateY(-1px)}.sv-promote.is-done{cursor:default;height:28px;padding:0 11px;font-size:11px;font-weight:600;color:#b9f3d0;border-color:#34d39959}.sv-promote.is-done:hover{background:#04030ca8;border-color:#34d39959;transform:none}.sv-cell-card{position:absolute;right:6px;bottom:6px;z-index:2;display:inline-flex;align-items:center;gap:4px;height:18px;padding:0 7px;border-radius:999px;background:#107052e0;color:#e8fff4;font-size:9.5px;font-weight:700;letter-spacing:.02em;box-shadow:0 2px 8px #04030c66}.sv-cell.is-card .frame:after{box-shadow:inset 0 0 0 1.5px #34d399b3}.sv-cell.is-card.is-stage .frame:after{box-shadow:inset 0 0 0 2px #ffffffe6}.sv-hist-acts button.is-promote:hover{background:#10916a}.sv-model-canvas{position:absolute;inset:0;width:100%;height:100%;display:block;outline:none;cursor:grab;touch-action:none}.sv-model-canvas:active{cursor:grabbing}.sv-model.is-night{background:#0e0f17}.sv-model-state{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2;display:inline-flex;align-items:center;gap:10px;padding:10px 16px;border-radius:12px;background:#04030cb8;color:#fff;font-size:12.5px;font-weight:500;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);max-width:min(420px,80%);text-align:left}.sv-model-state .sv-making{width:18px;height:18px;border-width:2px}.sv-model-state.is-error{color:#ffd0d8}.sv-model-state.is-inline{position:static;transform:none;margin-top:8px}.sv-model-tools{flex-wrap:wrap;justify-content:flex-end;max-width:calc(100% - 28px)}.sv-views .go.on{color:#fff;background:#5a61ed33;border-radius:9px}.sv-views-adds{gap:4px}.sv-views-adds:hover{background:transparent}.sv-views-adds .go{flex:1;border-radius:9px}.sv-views-adds .go:hover{background:#5a61ed1f}.sv-views .go:disabled{opacity:.45;cursor:default}.sv-foot{flex-wrap:wrap;row-gap:8px}.sv-foot .sv-fields{flex:0 1 auto}.sv-hist.cols-1 .sv-cell.is-card .sv-cell-marks{right:108px}.sv-hist:not(.cols-1) .sv-cell.is-card .sv-cell-marks{right:28px}.sv-hist.cols-4 .sv-cell.is-card .sv-cell-marks,.sv-hist.cols-5 .sv-cell.is-card .sv-cell-marks{right:23px}.sv-pop-rows .sv-pop-row .nm{flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-pop-rows .sv-pop-row .mt,.sv-pop-rows .sv-pop-row .tk{flex:none;white-space:nowrap}.sv-pop:has(.sv-pop-search),.sv-pop:has(.sv-pop-foot){min-width:360px}.sv-pic-clip.is-openable{cursor:zoom-in}.sv-edit-video{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:48px 24px 14px}.sv-edit-video video,.sv-edit-video img{min-height:0;max-width:100%;max-height:calc(100% - 52px);border-radius:14px;background:#000;box-shadow:0 30px 90px #02040c99}.sv-edit-video>.sv-pic-tag{position:absolute;top:14px;left:50%;transform:translate(-50%)}.sv-out-line{flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap;margin-right:4px;font-variant-numeric:tabular-nums}@media(max-width:1100px){.sv-out-line{display:none}}.sv-pop-tabs{display:flex;flex-wrap:wrap;gap:4px;padding:6px 6px 2px}.sv-pop-tab{height:24px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:transparent;color:var(--fg-3);font:600 11px var(--font-sans);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast),border-color var(--dur-fast)}.sv-pop-tab:hover{color:var(--fg-1);background:#ffffff0d}.sv-pop-tab.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.sv-pl-float{position:absolute;left:0;right:0;top:0;z-index:7;display:flex;align-items:flex-end;justify-content:center;padding:14px 14px 0;pointer-events:none}.sv-pl-float>.pl-wrap{pointer-events:auto;width:100%;max-width:1040px;height:100%;max-height:780px;margin:0}.sv-pl-float>.pl-wrap.is-floating .pl-panel{height:100%}', gIe = `.ed-radio{position:relative;flex:none;width:16px;height:16px;border-radius:50%;box-shadow:inset 0 0 0 1.5px #ffffff42;transition:box-shadow .22s var(--ease-out-soft),background .22s var(--ease-out-soft)}.ed-radio i{position:absolute;left:50%;top:50%;width:8px;height:8px;margin:-4px 0 0 -4px;border-radius:50%;background:#fff;transform:scale(0);opacity:0;transition:transform .3s cubic-bezier(.34,1.56,.64,1),opacity .18s ease}.ed-radio.on{box-shadow:inset 0 0 0 1.5px var(--amethyst-500),0 0 0 3px #9968df29;background:#9968df38}.ed-radio.on i{transform:scale(1);opacity:1;background:linear-gradient(135deg,#fff,var(--amethyst-800))}*:hover>.ed-radio:not(.on){box-shadow:inset 0 0 0 1.5px #ffffff73}@media(prefers-reduced-motion:reduce){.ed-radio,.ed-radio i{transition:none}}.ed-collapse{transition:height .34s var(--ease-out-soft),opacity .26s ease}.ed-autoh{position:relative;transition:height .34s var(--ease-out-soft)}.ed-autoh.is-moving{overflow:hidden}.ed-autoh-in{position:relative}.ed-autoh.is-moving>.ed-autoh-in{position:absolute;left:0;right:0;bottom:0}.ed-swap-enter-active{transition:opacity .22s ease .07s,transform .3s var(--ease-out-soft) .04s}.ed-swap-leave-active{position:absolute;left:0;right:0;bottom:0;pointer-events:none;transition:opacity .12s ease}.ed-swap-enter-from{opacity:0;transform:translateY(6px)}.ed-swap-leave-to{opacity:0}.ed-fade-enter-active,.ed-fade-leave-active{transition:opacity .2s ease}.ed-fade-enter-from,.ed-fade-leave-to{opacity:0}.ed-side-enter-active,.ed-side-leave-active{transition:opacity .18s ease,transform .24s var(--ease-out-soft)}.ed-side-enter-from{opacity:0;transform:translate(-6px)}.ed-side-leave-to{opacity:0;transform:translate(6px)}.ed-slide{position:relative;isolation:isolate;--p: 3px;--g: 2px;--r: 8px}.ed-slide:before{content:"";position:absolute;z-index:-1;top:var(--p);bottom:var(--p);width:calc((100% - 2 * var(--p) - (var(--n) - 1) * var(--g)) / var(--n));left:calc(var(--p) + var(--i) * ((100% - 2 * var(--p) - (var(--n) - 1) * var(--g)) / var(--n) + var(--g)));border-radius:var(--r);background:#9968df38;box-shadow:inset 0 0 0 1px #9968df5c,inset 0 1px #ffffff14;transition:left .32s var(--ease-out-soft)}.sv-seg.ed-slide>button{position:relative}.sv-seg.ed-slide>button.on,.sv-seg.ed-slide>button.on:hover{background:transparent;box-shadow:none;color:#fff}.sv-seg.ed-slide.sv-sides{--r: 9px}.sv-seg.ed-slide.is-small{--p: 2px;--r: 7px;display:inline-grid;grid-template-columns:repeat(var(--n),minmax(0,1fr))}@media(prefers-reduced-motion:reduce){.ed-collapse,.ed-autoh,.ed-swap-enter-active,.ed-swap-leave-active,.ed-side-enter-active,.ed-side-leave-active,.ed-slide:before{transition:none}}kbd{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:5px;background:#ffffff12;box-shadow:inset 0 -1px #ffffff0f,inset 0 0 0 1px #ffffff14;color:var(--fg-3);font-family:var(--font-sans);font-size:10px;font-weight:600}.ed-tools{display:flex;flex-direction:column;margin-top:8px;gap:2px}.ed-tool{border-radius:12px;transition:background .24s ease,box-shadow .24s ease}.ed-tool.on{background:#ffffff06;box-shadow:inset 0 0 0 1px #ffffff0d}.ed-tool-head{display:flex;align-items:center;gap:11px;width:100%;height:44px;padding:0 10px;border:0;border-radius:11px;background:transparent;color:var(--fg-2);font-size:13.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-tool-head .ic{color:var(--fg-4);transition:color var(--dur-fast),transform .3s var(--ease-out-soft)}.ed-tool-head .lbl{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-tool-head:hover:not(:disabled){color:var(--fg-1);background:#ffffff0a}.ed-tool-head:hover:not(:disabled) .ic{color:var(--fg-2)}.ed-tool-head:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:-2px}.ed-tool-head:disabled{opacity:.38;cursor:default}.ed-tool.on .ed-tool-head{color:#fff;cursor:default}.ed-tool.on .ed-tool-head .ic{color:var(--amethyst-600);transform:scale(1.06)}.ed-pending{flex:none;width:7px;height:7px;border-radius:50%;background:#ffb347;box-shadow:0 0 0 3px #ffb34729;animation:edPulse 1.8s ease-in-out infinite}@keyframes edPulse{0%,to{box-shadow:0 0 0 3px #ffb34729}50%{box-shadow:0 0 0 5px #ffb3470f}}.ed-tool-body{padding:2px 8px 14px}.ed-tool-body.is-plain{padding:0 10px 12px 37px;animation:svPop .22s var(--ease-out-soft) both}.ed-tools .ed-tool+.ed-tool:not(.on):not(:has(+.on)){position:relative}.ed-panel{display:flex;flex-direction:column;gap:12px}.ed-hint{margin:0;font-size:11.5px;line-height:1.5;color:var(--fg-3)}.ed-hint.is-quiet{color:var(--fg-5)}.ed-keys{display:flex;flex-wrap:wrap;gap:10px;font-size:11px;color:var(--fg-4)}.ed-keys span{display:inline-flex;align-items:center;gap:5px}.ed-modes-x{display:flex;flex-direction:column;gap:4px}.ed-mode-x{display:flex;flex-direction:column;gap:3px;width:100%;padding:8px 10px;text-align:left;cursor:pointer;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font:inherit;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-mode-x:hover{background:#ffffff0a;color:var(--fg-2)}.ed-mode-x.on{background:var(--cv-accent-tint);border-color:#c2a4ec4d;color:var(--fg-2)}.ed-mode-x .hd{display:flex;align-items:center;gap:7px}.ed-mode-x b{font-size:12px;font-weight:600;color:var(--fg-1)}.ed-mode-x kbd{padding:0 5px;border-radius:4px;background:#ffffff12;color:var(--fg-4);font:600 9.5px var(--font-sans);line-height:16px}.ed-mode-x .ln{font-size:11px;line-height:1.45}.ed-info{display:flex;align-items:baseline;justify-content:space-between;gap:10px;padding:8px 10px;border-radius:10px;background:#ffffff08;border:1px solid var(--hairline-soft);font-size:11.5px;color:var(--fg-3)}.ed-info b{font-size:12px;font-weight:600;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-tabs{display:flex;width:100%}.ed-tabs button{flex:1;height:30px;font-size:12px;font-weight:600}.ed-tabs button.on{background:#9968df33;color:#fff;box-shadow:inset 0 0 0 1px #9968df52}.ed-acts{display:flex;align-items:center;gap:8px}.ed-acts .sv-btn{height:34px;padding:0 12px;font-size:12.5px}.ed-acts .ed-apply{flex:1;justify-content:center}.ed-acts .ed-square{flex:none;width:34px;padding:0;justify-content:center}.ed-acts.is-foot,.ed-go{position:sticky;bottom:-10px;z-index:3;margin:0 -8px -14px;padding:12px 8px 14px;background:#0b0d15}.ed-acts.is-foot:after,.ed-go:after{content:"";position:absolute;left:0;right:0;bottom:100%;height:18px;pointer-events:none;background:linear-gradient(180deg,#0b0d1500,#0b0d15)}.ed-go{padding-top:14px}.ed-go:before{content:"";position:absolute;left:8px;right:8px;top:4px;height:1px;background:var(--hairline-soft)}.ed-acts.is-tight .sv-btn{flex:1;justify-content:center}.sv-btn:disabled{opacity:.4;cursor:default;filter:none}.sv-btn.is-primary:disabled{background:#ffffff12;box-shadow:none;color:var(--fg-4)}.sv-btn.is-on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:#fff}.ed-slider{display:flex;flex-direction:column;gap:6px;cursor:default}.ed-slider-head{display:flex;align-items:baseline;justify-content:space-between;gap:8px}.ed-slider-head .lb{font-size:11.5px;color:var(--fg-3);transition:color var(--dur-fast)}.ed-slider-head .v{font-size:11px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;transition:color var(--dur-fast)}.ed-slider.is-changed .ed-slider-head .lb{color:var(--fg-1)}.ed-slider.is-changed .ed-slider-head .v{color:var(--amethyst-700)}.ed-slider.is-off{opacity:.4}.ed-slider-track{position:relative;height:16px}.ed-slider-track .rail,.ed-slider-track .fill{position:absolute;top:50%;height:3px;margin-top:-1.5px;border-radius:999px;pointer-events:none}.ed-slider-track .rail{left:0;right:0;background:#ffffff1f}.ed-slider-track .fill{background:linear-gradient(90deg,var(--amethyst-500),#8f72ff);transition:left .08s linear,width .08s linear}.ed-slider-track .tick{position:absolute;top:50%;width:3px;height:3px;margin:-1.5px 0 0 -1.5px;border-radius:50%;background:#ffffff52;pointer-events:none;transition:background var(--dur-fast),transform var(--dur-fast)}.ed-slider-track .tick.on{background:#fff;transform:scale(1.4)}.ed-slider-track input{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;-webkit-appearance:none;appearance:none;background:transparent;cursor:pointer;outline:none}.ed-slider-track input::-webkit-slider-runnable-track{height:16px;background:transparent;border:0}.ed-slider-track input::-moz-range-track{height:16px;background:transparent;border:0}.ed-slider-track input::-webkit-slider-thumb{-webkit-appearance:none;width:13px;height:13px;margin-top:1.5px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c99,0 0 #9968df66;transition:transform .18s var(--ease-out-soft),box-shadow .18s ease}.ed-slider-track input::-moz-range-thumb{width:13px;height:13px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c99}.ed-slider-track input:hover::-webkit-slider-thumb{transform:scale(1.12)}.ed-slider-track input:active::-webkit-slider-thumb{transform:scale(1.2);box-shadow:0 1px 4px #02040c99,0 0 0 5px #9968df40}.ed-slider-track input:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft),0 1px 4px #02040c8c}.ed-slider-track input:disabled{cursor:default}.ed-fields,.ed-fields-more{display:flex;flex-direction:column;gap:12px}.ed-fields-more{animation:svPop .2s var(--ease-out-soft) both}.ed-field{display:flex;flex-direction:column;gap:6px}.ed-field-lb{font-size:11.5px;color:var(--fg-3)}.ed-pills{display:flex;width:100%;flex-wrap:wrap}.ed-pills button{flex:1 1 auto;height:26px;font-size:11.5px;padding:0 8px}.ed-pills button.on{background:#9968df38;color:#fff;box-shadow:inset 0 0 0 1px #9968df5c}.ed-select{position:relative;display:flex;align-items:center}.ed-select select{width:100%;height:32px;padding:0 30px 0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;-webkit-appearance:none;appearance:none;cursor:pointer;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast)}.ed-select select:hover{background:#ffffff12}.ed-select select:focus{border-color:#9968df80}.ed-select select option{background:#14151f;color:var(--fg-1)}.ed-select .licon{position:absolute;right:10px;pointer-events:none;color:var(--fg-4)}.ed-text{display:block;width:100%;min-height:54px;max-height:140px;resize:vertical;padding:8px 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;line-height:1.45;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast)}.ed-text::placeholder{color:var(--fg-5)}.ed-text:focus{border-color:#9968df80;background:#ffffff0d}.ed-more{align-self:flex-start;display:inline-flex;align-items:center;gap:6px;height:26px;padding:0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-more:hover,.ed-more.on{background:#ffffff0d;color:var(--fg-1)}.ed-switch{display:flex;align-items:center;gap:10px;font-size:12px;color:var(--fg-2);cursor:pointer;user-select:none}.ed-switch input{position:absolute;opacity:0;width:0;height:0}.ed-switch i{position:relative;flex:none;width:30px;height:18px;border-radius:999px;background:#ffffff24;transition:background .2s ease}.ed-switch i:after{content:"";position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 3px #02040c80;transition:transform .25s var(--ease-out-soft)}.ed-switch input:checked+i{background:var(--amethyst-500)}.ed-switch input:checked+i:after{transform:translate(12px)}.ed-switch input:focus-visible+i{box-shadow:0 0 0 3px var(--cv-accent-soft)}.ed-radios{display:flex;flex-direction:column;gap:2px}.ed-radio-row{display:flex;align-items:center;gap:10px;height:32px;padding:0 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-radio-row:hover{background:#ffffff0d;color:var(--fg-1)}.ed-radio-row.on{color:#fff}.ed-go{display:flex;flex-direction:column;gap:9px}.ed-model-fixed,.ed-model-none{display:flex;align-items:center;gap:9px;min-height:32px;padding:0 2px;font-size:12px;color:var(--fg-2)}.ed-model-fixed .licon{flex:none;color:var(--fg-4)}.ed-model-fixed .tx{min-width:0;display:flex;flex-direction:column;gap:1px}.ed-model-fixed .nm{font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ed-model-fixed .why{font-size:10.5px;line-height:1.35;color:var(--fg-4)}.ed-model-none{color:var(--fg-4)}.ed-go-row{display:flex;align-items:center;gap:8px;container:edgo / inline-size}@container edgo (max-width: 228px){.ed-go-btn .licon{display:none}}@media(max-height:820px){.ed-model-fixed .why{display:none}.ed-go{gap:7px}}.ed-go-btn{flex:1;min-width:0;justify-content:center;height:40px;padding:0 12px;gap:7px}.ed-go-btn .lb{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-go-cost{display:flex;align-items:center;justify-content:center;gap:5px;margin-top:-3px;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.ed-bar{transition:border-color .3s ease,background .3s ease,box-shadow .3s ease}.ed-bar.is-tool{border-color:#9968df57;background:#100e1cf2;box-shadow:inset 0 1px #ffffff0b,0 0 0 4px #9968df0f,0 30px 80px #02040c9e}.ed-bar-tool{display:flex;flex-direction:column;gap:10px;padding:0 2px 0 4px}.ed-bar-tool-head{display:flex;align-items:center;gap:10px;height:40px;min-width:0}.ed-bar-go{display:flex;flex-direction:column;gap:8px;padding-top:10px;border-top:1px solid var(--hairline-soft)}.ed-bar-go:empty{display:none}.ed-bar-go-in{display:flex;flex-direction:column;gap:8px}.ed-go.is-bar{position:static;margin:0;padding:0;gap:8px;background:none}.ed-go.is-bar:before,.ed-go.is-bar:after{display:none}.ed-go-line{display:flex;align-items:center;gap:10px;min-height:30px;min-width:0}.ed-go-line .grow{flex:1}.ed-go-line .ed-model-fixed.is-inline{min-height:0;flex:0 1 auto;min-width:0}.ed-go-line .ed-go-cost,.ed-go-line .ed-go-full{margin:0;flex:none}.ed-go-line .sv-problem.is-inline{min-width:0;max-width:300px;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-go-line .ed-go-btn{flex:none;min-width:112px;height:30px;padding:0 14px}.ed-acts.is-bar{display:flex;align-items:center;gap:8px;min-height:40px}.ed-acts.is-bar .grow{flex:1}.ed-acts.is-bar .ed-apply{flex:none;min-width:120px;height:40px}.ed-acts.is-bar .sv-btn:not(.ed-apply){height:40px}.ed-acts.is-bar .ed-square{width:40px}.ed-bar-tool .ic{flex:none;width:30px;height:30px;border-radius:9px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df73,#5a61ed52);color:#fff;box-shadow:inset 0 1px #ffffff2e,0 6px 16px #7532d34d}.ed-bar-tool b{font-size:13.5px;font-weight:600;color:#fff;white-space:nowrap}.ed-bar-tool .dot{color:var(--fg-5)}.ed-bar-tool .st{min-width:0;display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--fg-3);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-bar-tool-head .grow{flex:1}.ed-bar-close{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 12px 0 14px;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.ed-bar-close:hover{background:#ffffff1a;border-color:#ffffff2e}.ed-bar-main{display:flex;flex-direction:column}.ed-bar-main .sv-prompt:disabled{opacity:.55;cursor:default}.ed-bar{container:edbar / inline-size}@container edbar (max-width: 600px){.ed-bar-modes>.sv-sep{display:none}}.ed-grow{flex:1 1 0;min-width:4px}.ed-modes{flex:none;display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;background:#ffffff08;border:1px solid var(--hairline-soft)}.ed-mode{display:inline-flex;align-items:center;gap:7px;height:28px;padding:0 10px 0 7px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:500;cursor:pointer;transition:background .2s ease,color .2s ease}.ed-mode .ed-radio{width:14px;height:14px}.ed-mode .ed-radio i{width:6px;height:6px;margin:-3px 0 0 -3px}.ed-mode:hover{color:var(--fg-1);background:#ffffff0a}.ed-mode.on{color:#fff;background:#9968df29}.ed-mode:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:1px}.sv-chip.is-fixed{cursor:default}.sv-chip.is-fixed:hover{background:#ffffff0a;color:var(--fg-2)}.ed-tools-inline{flex:none;display:inline-flex;align-items:center;gap:4px}.ed-seg-icons button{width:30px;min-width:30px;height:26px;padding:0}.ed-seg-icons button.on{background:#9968df3d;color:#fff;box-shadow:inset 0 0 0 1px #9968df61}.ed-icon-chip{flex:none;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid transparent;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.ed-icon-chip:hover:not(:disabled){background:#ffffff12;color:var(--fg-1)}.ed-icon-chip.on{border-color:#ff5c7a6b;background:#ff5c7a1f;color:#ff9db0}.ed-icon-chip:disabled{opacity:.3;cursor:default}.ed-mini-sep{flex:none;width:1px;height:16px;margin:0 2px;background:var(--hairline-soft)}.ed-size{display:inline-flex;align-items:center;gap:7px;padding:0 4px 0 6px}.ed-size i{flex:none;display:inline-block;border-radius:50%;background:#ffffff8c;box-shadow:0 0 0 1px #fff3;transition:width .12s ease,height .12s ease}.ed-size input{width:64px;accent-color:var(--amethyst-500)}.ed-tool-chip{height:30px;padding:0 9px;gap:6px}.ed-tool-chip .chev{color:var(--fg-4);transition:transform var(--dur-fast)}.ed-tool-chip.on .chev{transform:rotate(180deg)}.ed-color{width:30px;height:30px;border-radius:9px;position:relative;overflow:hidden}.ed-color input[type=color]{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.ed-mark-pop{min-width:228px;padding:6px;display:grid;grid-template-columns:1fr 1fr;gap:2px}.ed-mark-row{display:flex;align-items:center;gap:9px;height:32px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-mark-row .nm{flex:1}.ed-mark-row:hover{background:#ffffff0f;color:var(--fg-1)}.ed-mark-row.on{background:var(--cv-accent-tint);color:#fff}.ed-mark-row.on kbd{background:#9968df4d;color:#fff}.ed-mark-size{grid-column:1 / -1;display:flex;align-items:center;gap:9px;padding:8px 8px 4px;margin-top:4px;border-top:1px solid var(--hairline-soft);font-size:11.5px;color:var(--fg-3);transition:opacity var(--dur-fast)}.ed-mark-size input{flex:1;accent-color:var(--amethyst-500)}.ed-mark-size b{min-width:20px;text-align:right;font-size:11.5px;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-mark-size.is-off{opacity:.35;pointer-events:none}.ed-mark-clear{grid-column:1 / -1;display:flex;align-items:center;gap:7px;height:30px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;cursor:pointer}.ed-mark-clear:hover:not(:disabled){background:#ff5c7a1a;color:#ff9db0}.ed-mark-clear:disabled{opacity:.35;cursor:default}.ed-guard{position:absolute;inset:0;z-index:30;display:flex;align-items:flex-end;justify-content:center;padding-bottom:26px;background:#04030c52;backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}.ed-guard-card{display:flex;align-items:center;gap:14px;width:min(560px,calc(100% - 40px));padding:14px 14px 14px 16px;border-radius:16px;background:#10111cfa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040cb3}.ed-guard-card .ic{flex:none;width:34px;height:34px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:#ffb34724;color:#ffc670}.ed-guard-card .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ed-guard-card .tx b{font-size:13.5px;font-weight:600;color:#fff}.ed-guard-card .tx span{font-size:11.5px;line-height:1.45;color:var(--fg-3)}.ed-guard-card .acts{flex:none;display:flex;gap:8px}.ed-guard-card .acts .sv-btn{height:34px;padding:0 14px;font-size:12.5px}.ed-guard-enter-active,.ed-guard-leave-active{transition:opacity .2s ease}.ed-guard-enter-active .ed-guard-card,.ed-guard-leave-active .ed-guard-card{transition:transform .3s var(--ease-out-soft),opacity .2s ease}.ed-guard-enter-from,.ed-guard-leave-to{opacity:0}.ed-guard-enter-from .ed-guard-card{transform:translateY(12px) scale(.98)}.ed-guard-leave-to .ed-guard-card{transform:translateY(6px)}.ed-ratios{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}.ed-ratio{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;height:56px;padding:0;border:1px solid transparent;border-radius:10px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform .2s var(--ease-out-soft)}.ed-ratio i{display:block;border-radius:3px;box-shadow:inset 0 0 0 1.5px currentColor;opacity:.85;transition:width .3s var(--ease-out-soft),height .3s var(--ease-out-soft)}.ed-ratio i.free{box-shadow:none;border:1.5px dashed currentColor}.ed-ratio:hover{background:#ffffff12;color:var(--fg-1)}.ed-ratio:active{transform:scale(.97)}.ed-ratio.on{border-color:#9968df80;background:#9968df29;color:#fff}.ed-ratio.is-more{color:var(--fg-4)}.ed-wh{display:flex;align-items:center;gap:6px}.ed-wh label{flex:1;min-width:0;display:flex;align-items:center;gap:6px;height:32px;padding:0 8px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff09;transition:border-color var(--dur-fast)}.ed-wh label:focus-within{border-color:#9968df80}.ed-wh label span{font-size:10.5px;font-weight:700;color:var(--fg-5)}.ed-wh input{flex:1;min-width:0;width:100%;border:0;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;font-variant-numeric:tabular-nums;outline:none;-moz-appearance:textfield}.ed-wh input::-webkit-inner-spin-button,.ed-wh input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.ed-wh .u{font-size:10.5px;color:var(--fg-5)}.ed-lock{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-lock:hover{background:#ffffff12;color:var(--fg-1)}.ed-lock.on{color:var(--amethyst-700)}.ed-crop{pointer-events:none;border-radius:12px;overflow:hidden}.ed-crop .shade{position:absolute;background:#04030c94;pointer-events:none;transition:background .24s ease}.ed-crop.is-active .shade{background:#04030ca8}.ed-crop-box{position:absolute;pointer-events:auto;cursor:move;box-shadow:inset 0 0 0 1.5px #ffffffeb,0 0 0 1px #04030c66;animation:edCropIn .34s var(--ease-out-soft) both}@keyframes edCropIn{0%{opacity:0;transform:scale(1.02)}to{opacity:1;transform:none}}.ed-crop-box .third{position:absolute;background:#ffffff5c;opacity:0;transition:opacity .2s ease;pointer-events:none}.ed-crop.is-active .ed-crop-box .third{opacity:1}.ed-crop-box .third.v1{left:33.333%;top:0;bottom:0;width:1px}.ed-crop-box .third.v2{left:66.666%;top:0;bottom:0;width:1px}.ed-crop-box .third.h1{top:33.333%;left:0;right:0;height:1px}.ed-crop-box .third.h2{top:66.666%;left:0;right:0;height:1px}.ed-crop-h{position:absolute;z-index:2;width:22px;height:22px;margin:-11px 0 0 -11px;pointer-events:auto}.ed-crop-h:after{content:"";position:absolute;left:50%;top:50%;width:11px;height:11px;margin:-5.5px 0 0 -5.5px;border-radius:3px;background:#fff;box-shadow:0 0 0 1.5px var(--amethyst-400),0 2px 6px #04030c73;transition:transform .18s var(--ease-out-soft)}.ed-crop-h:hover:after{transform:scale(1.25)}.ed-crop-h.h-n,.ed-crop-h.h-s{left:50%;cursor:ns-resize}.ed-crop-h.h-e,.ed-crop-h.h-w{top:50%;cursor:ew-resize}.ed-crop-h.h-n:after,.ed-crop-h.h-s:after{width:22px;height:6px;margin:-3px 0 0 -11px;border-radius:3px}.ed-crop-h.h-e:after,.ed-crop-h.h-w:after{width:6px;height:22px;margin:-11px 0 0 -3px;border-radius:3px}.ed-crop-h.h-nw{left:0;top:0;cursor:nwse-resize}.ed-crop-h.h-ne{left:100%;top:0;cursor:nesw-resize}.ed-crop-h.h-se{left:100%;top:100%;cursor:nwse-resize}.ed-crop-h.h-sw{left:0;top:100%;cursor:nesw-resize}.ed-crop-h.h-n{top:0}.ed-crop-h.h-s{top:100%}.ed-crop-h.h-e{left:100%}.ed-crop-h.h-w{left:0}.ed-crop-size{position:absolute;left:50%;bottom:10px;transform:translate(-50%);padding:3px 9px;border-radius:999px;white-space:nowrap;pointer-events:none;background:#04030cb8;color:#fff;font-size:11px;font-weight:600;font-variant-numeric:tabular-nums;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}.ed-expand{position:absolute;border-radius:12px;animation:svPic .36s var(--ease-out-soft) both;transition:left .28s var(--ease-out-soft),top .28s var(--ease-out-soft),width .28s var(--ease-out-soft),height .28s var(--ease-out-soft)}.ed-expand-room{position:absolute;inset:0;border-radius:12px;border:1.5px dashed rgba(199,166,255,.55);background-color:#9968df0d;background-image:radial-gradient(rgba(255,255,255,.11) 1px,transparent 1.4px);background-size:14px 14px;background-repeat:repeat}.ed-expand-pic{position:absolute;cursor:move;border-radius:4px;overflow:hidden;box-shadow:0 0 0 1.5px #ffffffe6,0 18px 50px #0206178c}.ed-expand.is-active .ed-expand-pic{transition:none}.ed-expand-pic img{display:block;width:100%;height:100%;object-fit:fill;user-select:none;-webkit-user-drag:none}.ed-expand-h{position:absolute;z-index:2;display:flex;align-items:center;justify-content:center}.ed-expand-h i{display:block;border-radius:3px;background:#fff;box-shadow:0 0 0 1.5px var(--amethyst-400),0 2px 6px #04030c73;transition:transform .18s var(--ease-out-soft)}.ed-expand-h:hover i{transform:scale(1.2)}.ed-expand-h.h-n,.ed-expand-h.h-s{left:0;right:0;height:22px;cursor:ns-resize}.ed-expand-h.h-n{top:-11px}.ed-expand-h.h-s{bottom:-11px}.ed-expand-h.h-n i,.ed-expand-h.h-s i{width:28px;height:6px}.ed-expand-h.h-e,.ed-expand-h.h-w{top:0;bottom:0;width:22px;cursor:ew-resize}.ed-expand-h.h-e{right:-11px}.ed-expand-h.h-w{left:-11px}.ed-expand-h.h-e i,.ed-expand-h.h-w i{width:6px;height:28px}.ed-tabs.is-three button{padding:0 6px}.ed-fills{display:grid;grid-template-columns:repeat(6,1fr);gap:7px}.ed-fill{position:relative;aspect-ratio:1;padding:0;border:0;border-radius:9px;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1px #ffffff29;transition:transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-fill:hover{transform:scale(1.07)}.ed-fill.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-fill.is-clear{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.22) 25%,transparent 0 50%,rgba(255,255,255,.22) 0 75%,transparent 0);background-size:10px 10px;background-repeat:repeat}.ed-fill.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.ed-fill.is-any.on{background:var(--c)}.ed-fill.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.sv-pic.is-cutout{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.07) 25%,transparent 0 50%,rgba(255,255,255,.07) 0 75%,transparent 0);background-size:22px 22px;background-repeat:repeat}.ed-layers-canvas{position:absolute;inset:0;border-radius:12px;pointer-events:none}.ed-refpick{display:flex;flex-direction:column;gap:6px}.ed-refpick-row{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.ed-refpick-cell{position:relative;aspect-ratio:1;padding:0;border:0;border-radius:9px;overflow:hidden;cursor:pointer;background:#ffffff0a;opacity:.72;transition:opacity var(--dur-fast),transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-refpick-cell:after{content:"";position:absolute;inset:0;border-radius:9px;box-shadow:inset 0 0 0 1px #ffffff1a;pointer-events:none;transition:box-shadow var(--dur-fast)}.ed-refpick-cell:hover{opacity:1;transform:translateY(-1px)}.ed-refpick-cell.on{opacity:1}.ed-refpick-cell.on:after{box-shadow:inset 0 0 0 2px var(--amethyst-500)}.ed-refpick-cell .tag{position:absolute;left:4px;bottom:4px;z-index:2;padding:1px 5px;border-radius:999px;background:#04030cb8;color:#fff;font-size:9.5px;font-weight:600}.ed-groups{display:flex;flex-direction:column;gap:2px;margin:0 -4px}.ed-group{border-radius:10px;transition:background .24s ease}.ed-group.on{background:#ffffff06}.ed-group-head{display:flex;align-items:center}.ed-group-btn{flex:1;min-width:0;display:flex;align-items:center;gap:9px;height:34px;padding:0 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-group-btn .ic{color:var(--fg-4);transition:color var(--dur-fast)}.ed-group-btn .t{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ed-group-btn .chev{color:var(--fg-5)}.ed-group-btn:hover{background:#ffffff0a;color:var(--fg-1)}.ed-group.on .ed-group-btn{color:#fff}.ed-group.on .ed-group-btn .ic,.ed-group.is-changed .ed-group-btn .ic{color:var(--amethyst-600)}.ed-changed{flex:none;width:6px;height:6px;border-radius:50%;background:var(--amethyst-500);box-shadow:0 0 0 3px #9968df2e}.ed-group-reset{flex:none;width:26px;height:26px;margin-right:4px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-group-reset:hover{background:#ffffff12;color:#fff}.ed-group-body{display:flex;flex-direction:column;gap:12px;padding:4px 8px 12px}.ed-looks{display:grid;grid-template-columns:repeat(2,1fr);gap:6px}.ed-look{display:flex;flex-direction:column;gap:5px;padding:4px;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-look .sw{position:relative;display:block;height:46px;border-radius:7px;overflow:hidden;background:#ffffff0d}.ed-look:hover{background:#ffffff0d;color:var(--fg-1)}.ed-look.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-look .nm{padding:0 2px 2px;text-align:left}.ed-look.look-vintage .sw{filter:sepia(.35) saturate(.75) contrast(.92) brightness(1.04)}.ed-look.look-retro-film .sw{filter:contrast(1.12) saturate(.88) hue-rotate(-8deg) sepia(.12)}.ed-look.look-duotone .sw{filter:grayscale(1) sepia(.6) hue-rotate(220deg) saturate(1.6) contrast(1.05)}.ed-look.look-vibrant .sw{filter:saturate(1.45) contrast(1.08)}.ed-look.look-warm .sw{filter:sepia(.22) saturate(1.15) hue-rotate(-6deg)}.ed-look.look-cool-breeze .sw{filter:hue-rotate(12deg) saturate(.9) brightness(1.05)}.ed-look.look-red-tint .sw{filter:sepia(.3) hue-rotate(-30deg) saturate(1.4)}.ed-look.look-cold .sw{filter:hue-rotate(18deg) saturate(.75) contrast(1.04)}.ed-look.look-mono .sw{filter:grayscale(1) contrast(1.15)}.ed-look.look-matte .sw{filter:contrast(.8) brightness(1.08) saturate(.85)}.ed-wheels{display:grid;grid-template-columns:repeat(3,1fr);gap:6px}.ed-wheel{display:flex;flex-direction:column;align-items:center;gap:6px}.ed-wheel-disc{position:relative;width:60px;height:60px;border-radius:50%;cursor:crosshair;touch-action:none;outline:none;background:radial-gradient(circle,gray,#80808000 72%),conic-gradient(from 0deg,#ff4d4d,#ffd24d,#4dff6a,#4dffff,#4d6aff,#d24dff,#ff4d4d);box-shadow:inset 0 0 0 1px #ffffff24,0 4px 14px #02040c66}.ed-wheel-disc:focus-visible{box-shadow:0 0 0 3px var(--cv-accent-soft)}.ed-wheel-dot{position:absolute;width:12px;height:12px;margin:-6px 0 0 -6px;border-radius:50%;background:#fff9;box-shadow:0 0 0 2px #04030c99;pointer-events:none;transition:left .06s linear,top .06s linear}.ed-wheel-dot.on{background:#fff}.ed-wheel-lb{font-size:10.5px;font-weight:600;color:var(--fg-3)}.ed-wheel-lum{width:60px;accent-color:var(--amethyst-500)}.ed-bands{display:flex;justify-content:space-between;gap:4px}.ed-band{position:relative;width:22px;height:22px;padding:0;border:0;border-radius:50%;background:var(--c);cursor:pointer;box-shadow:inset 0 0 0 1px #fff3;transition:transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-band:hover{transform:scale(1.1)}.ed-band.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-band.is-changed:after{content:"";position:absolute;right:-2px;top:-2px;width:7px;height:7px;border-radius:50%;background:#fff;box-shadow:0 0 0 2px #0b0d15}.ed-overlay-row{display:flex;align-items:center;gap:8px}.ed-overlay-row .ed-select{flex:1}.ed-turns{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.ed-turns .sv-btn{justify-content:center;height:32px;padding:0}.ed-hold{user-select:none}.ed-hold:active{background:#ffffff24}.ed-adjust-canvas{position:absolute;inset:0;border-radius:12px;pointer-events:none;opacity:0;transition:opacity .2s ease}.ed-adjust-canvas.is-ready{opacity:1}.ed-stage-note{position:absolute;left:50%;bottom:12px;transform:translate(-50%);z-index:3;padding:4px 10px;border-radius:999px;white-space:nowrap;pointer-events:none;background:#04030ca8;color:#ffffffd1;font-size:11px;font-weight:500;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}.ed-area-layer{cursor:crosshair}.ed-area-layer.tool-brush{cursor:none}.ed-area-layer.tool-object{cursor:default}.ed-area-layer.tool-object.is-over{cursor:pointer}.ed-area-paint,.ed-area-hover,.ed-area-lasso{position:absolute;inset:0;border-radius:12px;pointer-events:none}.ed-area-paint{animation:edAreaBreathe 2.6s ease-in-out infinite}@keyframes edAreaBreathe{0%,to{opacity:1}50%{opacity:.86}}@media(prefers-reduced-motion:reduce){.ed-area-paint{animation:none}}.ed-area-hover{transition:opacity .12s ease}.ed-area-lasso path{fill:#a876ff29;stroke:#fff;stroke-width:1.5;stroke-dasharray:5 4;animation:edAnts .6s linear infinite}.ed-area-layer.is-cut .ed-area-lasso path{fill:#ff5c6e1f}@keyframes edAnts{to{stroke-dashoffset:-9}}.ed-area-ring{border-color:#fff;background:#a876ff24}.ed-area-layer.is-erase .ed-area-ring{background:#ff5c6e29}.ed-area-ring.is-eraser{border-style:dashed;background:#ffffff0f}.ed-area-find{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:4;display:inline-flex;align-items:center;gap:8px;padding:8px 14px;border-radius:999px;background:#04030cc7;color:#fff;font-size:12px;font-weight:500;white-space:nowrap;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);box-shadow:0 14px 40px #02040c80}.ed-area-find-btn{display:inline-flex;align-items:center;gap:8px;padding:0;border:0;background:transparent;color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.ed-area-find-btn .tk{display:inline-flex;align-items:center;gap:3px;padding:2px 7px;border-radius:999px;background:#ffffff24;font-size:11px}.ed-area-find:has(.ed-area-find-btn):hover{background:#7532d3e0}.ed-stage-tools{position:absolute;left:12px;bottom:14px;z-index:5;display:flex;align-items:center;gap:6px;animation:svPop .24s var(--ease-out-soft) backwards}.ed-stage-btn{display:inline-flex;align-items:center;gap:7px;height:30px;padding:0 12px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);transition:background var(--dur-fast),border-color var(--dur-fast)}.ed-stage-btn:hover{background:#04030cd1}.ed-stage-btn.on{background:var(--cv-accent);border-color:transparent}.ed-compare{z-index:3;cursor:ew-resize}.ed-compare.is-toggle{cursor:pointer}.ed-compare-other{position:absolute;inset:0;border-radius:12px;overflow:hidden;transition:opacity .18s ease}.ed-compare.is-split .ed-compare-other{transition:none}.ed-compare-other img{display:block;width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none}.ed-compare-line{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 0 1px #04030c59,0 0 18px #04030c66;pointer-events:none}.ed-compare-line span{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:30px;height:30px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#fff;color:#1a1530;box-shadow:0 4px 14px #04030c80}.ed-compare-line span .licon{margin:0 -3px}.ed-compare-tag{position:absolute;top:10px;z-index:2;padding:3px 9px;border-radius:999px;background:#04030cb3;color:#fff;font-size:11px;font-weight:600;pointer-events:none}.ed-compare-tag.is-left{left:10px}.ed-compare-tag.is-right{right:10px}.ed-baking{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:6;display:inline-flex;align-items:center;gap:9px;padding:9px 16px;border-radius:999px;background:#04030ccc;color:#fff;font-size:12.5px;font-weight:500;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);box-shadow:0 14px 40px #02040c80}.sv-pic.is-tool{box-shadow:0 0 0 1px #ffffff14,0 30px 90px #0206179e}.ed-orbit{display:grid;grid-template-columns:minmax(0,1fr) 76px;gap:6px;align-items:center;padding:6px 4px 2px;border-radius:12px;background:radial-gradient(ellipse at 50% 60%,#9968df1a,#ffffff04 70%);border:1px solid var(--hairline-soft)}.ed-orbit svg{display:block;width:100%;height:auto;touch-action:none;cursor:grab;overflow:visible;outline:none}.ed-orbit svg:active{cursor:grabbing}.ed-orbit svg:focus-visible{filter:drop-shadow(0 0 4px rgba(153,104,223,.6))}.ed-orbit .track{fill:none;stroke:#fff3;stroke-width:1.2}.ed-orbit .track.is-inner{stroke:#ffffff12;stroke-dasharray:2 3}.ed-orbit .ground{stroke:#ffffff24;stroke-width:1}.ed-orbit .stop{fill:#ffffff59;transition:fill .2s ease,r .2s ease}.ed-orbit .stop.on{fill:#fff}.ed-orbit .origin{fill:#ffffff47}.ed-orbit .card{fill:#c7a6ff8c;stroke:#fff9;stroke-width:.8}.ed-orbit .ray{stroke:#c7a6ff8c;stroke-width:1;stroke-dasharray:2 2.5}.ed-orbit .ray.is-behind{stroke:#ffb34799}.ed-orbit .cam{transition:transform .18s var(--ease-out-soft)}.ed-orbit .cam .halo{fill:#9968df38}.ed-orbit .cam .dot{fill:#fff;stroke:var(--amethyst-400);stroke-width:2}.ed-camera-name{margin-top:-4px;text-align:center;font-size:12.5px;font-weight:600;color:#fff;letter-spacing:-.005em}.ed-seed{display:flex;align-items:center;justify-content:space-between;gap:8px}.ed-cam-stage{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;animation:svPic .36s var(--ease-out-soft) both}.ed-cam-view{position:relative;flex:1;width:100%;display:flex;align-items:center;justify-content:center;perspective:1500px;perspective-origin:50% 40%;overflow:hidden}.ed-cam-scene{position:relative;width:0;height:0;transform-style:preserve-3d;transition:transform .5s var(--ease-out-soft)}.ed-cam-floor{position:absolute;left:-480px;top:-480px;width:960px;height:960px;transform:rotateX(90deg);border-radius:50%;background:radial-gradient(circle,rgba(153,104,223,.16),transparent 62%),repeating-linear-gradient(0deg,rgba(255,255,255,.07) 0 1px,transparent 1px 48px),repeating-linear-gradient(90deg,rgba(255,255,255,.07) 0 1px,transparent 1px 48px);-webkit-mask-image:radial-gradient(circle,#000 30%,transparent 68%);mask-image:radial-gradient(circle,#000 30%,transparent 68%)}.ed-cam-box{position:absolute;left:0;top:0;transform-style:preserve-3d}.ed-cam-face{position:absolute;display:block;backface-visibility:hidden;-webkit-backface-visibility:hidden}.ed-cam-face.is-front{left:0;top:0;width:100%;height:100%;object-fit:cover;border-radius:3px;box-shadow:0 0 0 1px #ffffff24}.ed-cam-face.is-side{background-repeat:no-repeat;filter:blur(1.2px) brightness(.5) saturate(.7)}.ed-cam-face.is-side:after,.ed-cam-face.is-back:after{content:"";position:absolute;inset:0;background-image:linear-gradient(#16122661,#16122661),repeating-linear-gradient(45deg,rgba(255,255,255,.08) 0 2px,transparent 2px 9px);background-repeat:repeat;box-shadow:inset 0 0 0 1px #ffb34761}.ed-cam-face.is-top{filter:blur(1.2px) brightness(.62) saturate(.7)}.ed-cam-face.is-back{display:flex;align-items:center;justify-content:center;filter:none;background-image:none!important;background-color:#1a162cf5}.ed-cam-face.is-back span{position:relative;z-index:1;padding:4px 10px;border-radius:999px;background:#ffb34724;color:#ffd08a;font-size:11px;font-weight:600;transform:scaleX(-1) scaleX(-1)}.ed-cam-hud{flex:none;display:flex;flex-direction:column;align-items:center;gap:3px;padding:10px 0 18px;text-align:center}.ed-cam-hud b{font-size:14px;font-weight:600;color:#fff}.ed-cam-hud span{font-size:11.5px;color:var(--fg-3)}@media(prefers-reduced-motion:reduce){.ed-cam-scene{transition:none}}.ed-looks.is-light{grid-template-columns:repeat(3,1fr);gap:4px}.ed-light-look{display:flex;flex-direction:column;align-items:center;gap:5px;padding:7px 2px 6px;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:10px;font-weight:600;line-height:1.2;text-align:center;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-light-look i{width:26px;height:26px;border-radius:50%;box-shadow:inset 0 0 0 1px #ffffff2e,0 4px 12px #02040c73;transition:transform .25s var(--ease-out-soft)}.ed-light-look:hover{background:#ffffff0d;color:var(--fg-1)}.ed-light-look:hover i{transform:scale(1.08)}.ed-light-look.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-rig{display:flex;align-items:center;gap:12px}.ed-sphere{position:relative;flex:none;border-radius:50%}.ed-sphere canvas{display:block;border-radius:50%}.ed-sphere-light{position:absolute;z-index:2;width:20px;height:20px;margin:-10px 0 0 -10px;padding:0;border:2px solid #fff;border-radius:50%;background:var(--c);color:#16141f;font-family:var(--font-sans);font-size:10px;font-weight:800;cursor:pointer;box-shadow:0 0 0 1px #04030c80,0 0 14px var(--c);transition:left .3s var(--ease-out-soft),top .3s var(--ease-out-soft),transform .2s var(--ease-out-soft),opacity .2s ease}.ed-sphere-light.is-behind{opacity:.45;border-style:dashed}.ed-sphere-light.on{transform:scale(1.18);box-shadow:0 0 0 2px var(--amethyst-400),0 0 18px var(--c)}.ed-lights{flex:1;min-width:0;display:flex;flex-direction:column;gap:4px}.ed-light-chip{display:flex;align-items:center;gap:8px;height:28px;padding:0 6px 0 8px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff08;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-light-chip{white-space:nowrap}.ed-light-chip .nm{min-width:0;overflow:hidden;text-overflow:ellipsis}.ed-light-chip i{flex:none;width:10px;height:10px;border-radius:50%;background:var(--c);box-shadow:0 0 8px var(--c)}.ed-light-chip .x{margin-left:auto;width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;color:var(--fg-4)}.ed-light-chip .x:hover{background:#ff5c7a24;color:#ff9db0}.ed-light-chip:hover{background:#ffffff0f;color:var(--fg-1)}.ed-light-chip.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-light-chip.is-add{border-style:dashed;color:var(--fg-4);justify-content:center}.ed-quick{display:grid;grid-template-columns:repeat(6,1fr);gap:3px}.ed-quick-btn{height:26px;padding:0;border:0;border-radius:7px;background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-quick-btn:hover{background:#ffffff14;color:var(--fg-1)}.ed-quick-btn.on{background:#9968df3d;color:#fff}.ed-whites{display:grid;grid-template-columns:repeat(7,1fr);gap:3px}.ed-white{display:flex;flex-direction:column;align-items:center;gap:3px;padding:4px 0;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:9px;font-weight:600;cursor:pointer}.ed-white i{width:16px;height:16px;border-radius:50%;background:var(--c);box-shadow:inset 0 0 0 1px #ffffff40}.ed-white:hover{background:#ffffff0d;color:var(--fg-1)}.ed-white.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-gels{display:flex;align-items:center;gap:6px;margin-top:4px}.ed-gel{position:relative;width:20px;height:20px;padding:0;border:0;border-radius:50%;background:var(--c);cursor:pointer;box-shadow:inset 0 0 0 1px #ffffff38;transition:transform .2s var(--ease-out-soft)}.ed-gel:hover{transform:scale(1.12)}.ed-gel.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-gel.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.ed-gel.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.ed-relight-preview{position:absolute;inset:0;border-radius:12px;overflow:hidden;pointer-events:none}.ed-relight-preview .wash,.ed-relight-preview .shade{position:absolute;inset:0;transition:opacity .4s ease,background .4s ease}.ed-relight-preview .wash{mix-blend-mode:overlay}.ed-relight-preview .shade{mix-blend-mode:multiply}@media(max-width:1180px){.ed-mode{padding:0 8px 0 6px}.ed-size input{width:48px}}.sv-warn .licon{flex:none}.ed-panel .sv-warn{align-items:flex-start;line-height:1.45;font-size:11.5px}.ed-panel .sv-warn .licon{margin-top:2px}.ed-card{position:relative;display:flex;flex-direction:row;align-items:stretch;gap:12px;padding:1px 0 0}.ed-side{flex:none;width:30px;padding-top:1px}.up-side-btn:disabled{opacity:.35;cursor:default;background:transparent;color:var(--fg-4)}.ed-col{flex:1;min-width:0;display:flex;flex-direction:column;gap:10px}.ed-words,.sv-describe-text{display:block;height:48px;max-height:160px}.ed-words:disabled{opacity:.55;cursor:default}.ed-bar-modes{display:flex;align-items:center;gap:6px;row-gap:6px;min-width:0;flex-wrap:wrap}.ed-keep .licon{color:#c7a6ff}.ed-keep-pop{min-width:0;width:280px}.ed-keep-row{height:auto;align-items:flex-start;gap:10px;padding:8px 10px}.ed-keep-row .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ed-keep-row .nm{color:var(--fg-1)}.ed-keep-row .hint{font-size:11px;line-height:1.4;color:var(--fg-4);white-space:normal}.ed-keep-row .ck{flex:none;margin-top:2px;color:var(--cv-accent-text)}.ed-refs{min-height:56px}.ed-refs .sv-slot-peek{z-index:12}.ed-refs .up-ref-pulse{z-index:1;border-radius:10px}.ed-ref-leave-active{transition:opacity .16s ease,transform .16s ease}.ed-ref-leave-to{opacity:0;transform:scale(.85)}.ed-ref-move{transition:transform .26s var(--ease-out-soft)}.ed-refs-hint{line-height:1.4;transition:color var(--dur-fast)}.ed-refs-hint.is-air{color:var(--cv-accent-text)}.sv-queue.is-air .sv-slot-add{border-color:#9968df99;color:var(--cv-accent-soft);animation:edAir .9s ease-in-out infinite alternate}.sv-slot-add.is-target,.sv-slot-add.is-dropper{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}@keyframes edAir{0%{background:#9968df0a}to{background:#9968df29}}.ed-bar.is-over{border-color:#9968df80;box-shadow:inset 0 1px #ffffff0b,0 0 0 4px #9968df1a,0 30px 80px #02040c9e}.ed-fold-enter-active,.ed-fold-leave-active{transition:opacity .2s ease,transform .24s var(--ease-out-soft)}.ed-fold-enter-from,.ed-fold-leave-to{opacity:0;transform:translateY(4px)}.ed-fold-leave-active{position:absolute}.up-model.is-fixed{cursor:default}.up-model.is-fixed:hover{background:transparent}.sv-pfoot{width:100%;container:pfoot / inline-size;flex-wrap:wrap;row-gap:8px}@container pfoot (max-width: 520px){.sv-pfoot .up-foot-sep{display:none}.sv-pfoot>.up-chips{flex-basis:100%}.sv-pfoot>.up-chips+*{margin-left:auto}}.sv-describe .sv-pfoot{margin-top:2px}.sv-dock.is-nudge{animation:upNudge .42s var(--ease-out-soft)}.sv-dock.is-nudge .up-run-wrap .tip{opacity:1}.sv-root.is-dropper{--dropper-cursor: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke-linecap='round' stroke-linejoin='round'><g stroke='%23070910' stroke-width='4'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g><g stroke='white' stroke-width='2'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g></svg>") 2 22, crosshair}.sv-hist.is-dropper .sv-cell{cursor:var(--dropper-cursor)}.sv-hist.is-dropper .sv-cell:hover .frame{transform:translateY(-2px);box-shadow:0 0 0 2px var(--amethyst-500),0 0 0 6px #9968df38,0 12px 28px #02040c80}.sv-cell-drop{position:absolute;left:7px;top:7px;z-index:4;display:inline-flex;align-items:center;gap:5px;padding:3px 9px 3px 7px;border-radius:999px;background:#04030cd1;color:#fff;font-size:11px;font-weight:600;white-space:nowrap;box-shadow:0 4px 14px #02040c73;opacity:0;transform:translateY(-3px);pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.sv-cell-drop .licon{color:var(--cv-accent-text)}.sv-cell-drop.is-in{color:var(--fg-2)}.sv-cell-drop.is-in .licon{color:var(--fg-3)}.sv-hist.is-dropper .sv-cell:hover .sv-cell-drop{opacity:1;transform:none}.bd-dropper.sv-dropper{top:10px;z-index:30}@media(prefers-reduced-motion:reduce){.sv-queue.is-air .sv-slot-add{animation:none;background:#9968df1f}.sv-dock.is-nudge{animation:none}.ed-fold-enter-active,.ed-fold-leave-active,.ed-ref-leave-active,.ed-ref-move{transition:none}}.sv-fp-link{flex:none;display:inline-flex;align-items:center;gap:4px;height:30px;padding:0 7px;margin-right:1px;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;font-family:var(--font-sans);font-size:11px;font-weight:500;white-space:nowrap;transition:color var(--dur-fast),background var(--dur-fast)}.sv-fp-link:hover{color:var(--fg-2);background:#ffffff0a}.sv-fp-link.on{color:var(--fg-2)}.sv-fp-link .chev{color:inherit;opacity:.7;transition:transform .22s var(--ease-out-soft)}.sv-fp-link.on .chev{transform:rotate(180deg)}.sv-fp-link .dot{width:5px;height:5px;border-radius:50%;background:var(--amethyst-500);box-shadow:0 0 0 2px #9968df2e}.ed-go-full{display:flex;justify-content:center;margin:-4px 0 -6px}.ed-go-full .sv-fp-link{height:24px}.sv-fp{display:flex;flex-direction:column;gap:6px;padding:8px 10px 9px;border-radius:12px;background:#ffffff06;border:1px solid var(--hairline-soft);transition:border-color .24s ease,background .24s ease}.sv-fp.is-edited{border-color:#9968df5c;background:#9968df0e}.sv-fp-head{display:flex;align-items:center;gap:8px;min-height:22px}.sv-fp-head .t{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-fp-tag{padding:1px 7px;border-radius:999px;background:#9968df2e;color:var(--amethyst-800);font-size:10px;font-weight:600;letter-spacing:.02em}.sv-fp-tag-enter-active,.sv-fp-tag-leave-active{transition:opacity .18s ease,transform .2s var(--ease-out-soft)}.sv-fp-tag-enter-from,.sv-fp-tag-leave-to{opacity:0;transform:scale(.85)}.sv-fp-only{display:inline-flex;align-items:center;gap:7px;height:24px;padding:0 9px 0 5px;margin-right:6px;border:1px solid var(--hairline-soft);border-radius:999px;background:transparent;color:var(--fg-3);font:600 10.5px var(--font-sans);cursor:pointer;transition:color var(--dur-fast),border-color var(--dur-fast),background var(--dur-fast)}.sv-fp-only i{position:relative;width:22px;height:13px;border-radius:999px;background:#ffffff24;transition:background var(--dur-fast)}.sv-fp-only i:after{content:"";position:absolute;left:2px;top:2px;width:9px;height:9px;border-radius:50%;background:#fff;transition:transform var(--dur-fast) var(--ease-out-soft)}.sv-fp-only:hover{color:var(--fg-1)}.sv-fp-only.on{color:var(--fg-1);border-color:#c2a4ec73;background:var(--cv-accent-tint)}.sv-fp-only.on i{background:var(--amethyst-500)}.sv-fp-only.on i:after{transform:translate(9px)}.sv-fp-reset{display:inline-flex;align-items:center;gap:4px;height:22px;padding:0 7px;border:0;border-radius:7px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:11px;font-weight:500;cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast)}.sv-fp-reset:hover{color:var(--fg-1);background:#ffffff0f}.sv-fp-text{display:block;width:100%;min-height:54px;max-height:180px;resize:none;padding:1px 0;border:0;outline:none;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;line-height:1.55;overflow-y:auto;white-space:pre-wrap;user-select:text;-webkit-user-select:text;transition:color var(--dur-fast)}.sv-fp-text:focus,.sv-fp.is-edited .sv-fp-text{color:var(--fg-1)}.sv-fp-text::-webkit-scrollbar{width:6px}.sv-fp-text::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.sv-fp-foot{display:flex;align-items:center;gap:10px}.sv-fp-note{flex:1;min-width:0;font-size:11px;line-height:1.4;color:var(--fg-5)}.sv-fp.is-edited .sv-fp-note{color:var(--fg-4)}.sv-fp-run{height:26px;padding:0 13px;font-size:11.5px}.sv-fp.is-tool{margin:6px 0 0}.sv-fp.is-tool .sv-fp-text{max-height:140px}.sv-fp.is-tool .sv-fp-foot{flex-direction:column;align-items:stretch;gap:8px}.sv-fp.is-tool .up-run-wrap,.sv-fp.is-tool .sv-fp-run{width:100%;justify-content:center}@media(prefers-reduced-motion:reduce){.sv-fp-link .chev,.sv-fp,.sv-fp-tag-enter-active,.sv-fp-tag-leave-active{transition:none}}.ed-views{display:flex;flex-direction:column;gap:8px;padding:9px 10px 10px;border-radius:12px;background:#ffffff06;border:1px solid var(--hairline-soft)}.ed-views-head{display:flex;align-items:center;gap:7px;min-height:24px}.ed-views-head .t{white-space:nowrap;font-size:9.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ed-views-only{flex:none;display:inline-flex;align-items:center;gap:3px;padding:1px 6px;border-radius:999px;white-space:nowrap;background:#9968df1f;color:var(--amethyst-800);font-size:9.5px;font-weight:600}.ed-views-save{display:inline-flex;align-items:center;gap:5px;height:28px;padding:0 11px;border-radius:999px;white-space:nowrap;border:1px dashed rgba(255,255,255,.2);background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-views-save:hover:not(:disabled){background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.ed-views-save:disabled{cursor:default;color:var(--fg-5)}.ed-views-save.is-saved{border-style:solid;border-color:transparent;color:var(--fg-4);padding:0 6px}.ed-views-list{display:flex;flex-wrap:wrap;gap:6px}.ed-view{position:relative;display:inline-flex;max-width:100%}.ed-view-chip{display:inline-flex;align-items:center;gap:6px;max-width:100%;height:28px;padding:0 22px 0 9px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-view-chip .licon{flex:none;color:var(--fg-4)}.ed-view-chip .nm{min-width:0;overflow:hidden;text-overflow:ellipsis}.ed-view-chip:hover{background:#ffffff14;color:var(--fg-1)}.ed-view.on .ed-view-chip{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:#fff}.ed-view.on .ed-view-chip .licon{color:var(--cv-accent-text)}.ed-view-x{position:absolute;right:4px;top:50%;width:18px;height:18px;margin-top:-9px;padding:0;border:0;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:var(--fg-5);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.ed-view:hover .ed-view-x,.ed-view-x:focus-visible{opacity:1}.ed-view-x:hover{background:#ff5c7a29;color:#ff9db0}.ed-view-input{height:28px;width:180px;max-width:100%;padding:0 10px;border-radius:999px;border:1px solid var(--cv-accent-soft);background:#9968df14;color:#fff;font-family:var(--font-sans);font-size:11.5px;outline:none;box-shadow:0 0 0 3px #9968df24}.ed-views-empty{margin:0;font-size:11px;line-height:1.45;color:var(--fg-5)}.ed-view-enter-active{transition:opacity .22s ease,transform .26s var(--ease-out-soft)}.ed-view-leave-active{transition:opacity .16s ease,transform .16s ease}.ed-view-enter-from,.ed-view-leave-to{opacity:0;transform:scale(.85)}.ed-view-move{transition:transform .24s var(--ease-out-soft)}@media(prefers-reduced-motion:reduce){.ed-view-enter-active,.ed-view-leave-active,.ed-view-move{transition:none}}.sv-root.hist-shut{--hist-col: 0px}.sv-hist-body{flex:1;min-height:0;display:flex;flex-direction:column;gap:inherit;transition:opacity .22s ease}.sv-hist.is-shut,.sv-hist.is-moving{overflow:hidden}.sv-hist.is-shut .sv-hist-body,.sv-hist.is-moving .sv-hist-body{flex:none;align-self:flex-end;width:calc(var(--hist-w) - 40px);height:100%}.sv-hist.is-shut .sv-hist-body{opacity:0;pointer-events:none}.sv-hist-fold{margin-left:-2px}.sv-hist.is-shut{padding:0;visibility:hidden;transition:visibility 0s linear .34s}.sv-hist-show .n{padding:1px 7px;border-radius:999px;background:#ffffff12;color:var(--fg-2);font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums}.sv-hist-show{gap:7px;padding-left:5px}.sv-hist-show .sh{width:22px;height:22px;flex:none;border-radius:6px;background-size:cover;background-position:center;box-shadow:0 0 0 1px #ffffff1f}.sv-hist-show .n.is-new{background:var(--cv-accent);color:#fff}.sv-hist-show-enter-active{animation:svPillGlow 1.4s var(--ease-out-soft) .3s}.sv-hist-show.is-new{animation:svPillGlow 1.4s var(--ease-out-soft)}@keyframes svPillGlow{0%{box-shadow:0 0 #9968dfa6}70%{box-shadow:0 0 0 9px #9968df00}to{box-shadow:0 0 #9968df00}}.sv-hist-show-enter-active{transition:opacity .22s ease .12s,transform .28s var(--ease-out-soft) .12s}.sv-hist-show-leave-active{transition:opacity .12s ease}.sv-hist-show-enter-from{opacity:0;transform:translate(10px)}.sv-hist-show-leave-to{opacity:0}@media(prefers-reduced-motion:reduce){.sv-root,.sv-hist.is-shut{transition:none}.sv-hist-show.is-new,.sv-hist-show-enter-active{animation:none}.sv-hist-body,.sv-hist-show-enter-active,.sv-hist-show-leave-active{transition:none}}.ed-color i{position:relative;overflow:hidden;background:transparent;box-shadow:none}.ed-color i:before{content:"";position:absolute;inset:0;border-radius:inherit;background:conic-gradient(#ffffff57 25%,#ffffff14 0 50%,#ffffff57 0 75%,#ffffff14 0) 0 0 / 8px 8px}.ed-color i:after{content:"";position:absolute;inset:0;border-radius:inherit;background:var(--c);opacity:var(--o, 1);box-shadow:inset 0 0 0 1.5px #ffffff4d;transition:opacity var(--dur-fast)}.sv-pop.ed-colour-pop{flex-direction:column;align-items:stretch;gap:10px;padding:10px 12px 11px}.ed-swatch-row{display:flex;align-items:center;gap:8px}.ed-opacity{display:flex;align-items:center;gap:10px}.ed-opacity .lb{flex:none;font-size:9.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ed-opacity b{flex:none;min-width:34px;text-align:right;font-size:11.5px;font-weight:600;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-opacity.is-off{opacity:.45}.ed-opacity-range{-webkit-appearance:none;appearance:none;flex:1;min-width:96px;height:10px;margin:0;border-radius:999px;cursor:pointer;background:linear-gradient(90deg,transparent,var(--c)),conic-gradient(#ffffff42 25%,#ffffff0f 0 50%,#ffffff42 0 75%,#ffffff0f 0) 0 0 / 8px 8px;box-shadow:inset 0 0 0 1px #ffffff24}.ed-opacity-range:disabled{cursor:default}.ed-opacity-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:16px;height:16px;border-radius:50%;background:#fff;box-shadow:0 0 0 2px #0d0f18e6,0 2px 6px #0006;cursor:grab}.ed-opacity-range:active::-webkit-slider-thumb{cursor:grabbing}.ed-opacity-range:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:3px}.sv-pic-clip{position:absolute;inset:0;border-radius:inherit}.sv-pic.is-viewed .sv-pic-clip{overflow:hidden}.sv-pic-view{position:absolute;left:0;top:0;width:100%;height:100%;transform-origin:0 0;--zoom: 1}.sv-pic.is-viewed{transition:none}.sv-pic.is-gliding,.sv-pic.is-gliding .sv-pic-view{transition:left .24s var(--ease-out-soft),top .24s var(--ease-out-soft),width .24s var(--ease-out-soft),height .24s var(--ease-out-soft),transform .24s var(--ease-out-soft)}.sv-pic-view img,.sv-pic-view video,.sv-pic-view .sv-layer,.sv-pic-view .ed-compare-other{border-radius:calc(12px / var(--zoom))}.sv-pic.is-tag-inside .sv-pic-tag,.sv-pic.is-tag-inside .sv-pic-unsaved{top:10px;z-index:6}.sv-pic.is-tag-inside .sv-pic-tag{left:10px}.sv-pic.is-tag-inside .sv-pic-unsaved{right:10px}.sv-pic.is-viewed .sv-pin,.sv-pic.is-viewed .sv-pin-editor,.sv-pic.is-viewed .ed-compare-line span,.sv-pic.is-viewed .ed-compare-tag.is-left,.sv-pic.is-viewed .ed-area-find{transform-origin:0 0;scale:calc(1 / var(--zoom))}.sv-pic.is-viewed .ed-compare-tag.is-right{transform-origin:100% 0;scale:calc(1 / var(--zoom))}.sv-pic.is-viewed .ed-compare-line{width:calc(2px / var(--zoom));margin-left:calc(-1px / var(--zoom))}.sv-stage.is-space,.sv-stage.is-space *{cursor:grab!important}.sv-stage.is-panning,.sv-stage.is-panning *{cursor:grabbing!important}.sv-zoom{position:relative;display:inline-flex;align-items:center;gap:1px;height:30px;padding:0 3px;border-radius:999px;border:1px solid rgba(255,255,255,.2);background:#04030ca8;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px)}.sv-zoom-btn,.sv-zoom-pct{display:inline-flex;align-items:center;justify-content:center;height:24px;padding:0;border:0;border-radius:999px;background:transparent;color:#fff;font-family:var(--font-sans);cursor:pointer;transition:background var(--dur-fast)}.sv-zoom-btn{width:24px;color:var(--fg-2)}.sv-zoom-btn:hover:not(:disabled),.sv-zoom-pct:hover,.sv-zoom-pct.on{background:#ffffff1f;color:#fff}.sv-zoom-btn:disabled{opacity:.35;cursor:default}.sv-zoom-pct{gap:2px;min-width:52px;padding:0 4px 0 7px;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums}.sv-zoom-pct .chev{color:var(--fg-3);transition:transform .2s var(--ease-out-soft)}.sv-zoom-pct.on .chev{transform:rotate(180deg)}.sv-pop.sv-zoom-pop{min-width:0;width:208px;left:-4px}.sv-zoom-pop .sv-pop-row{justify-content:space-between;white-space:nowrap}.sv-zoom-pop .sv-pop-row:disabled{opacity:.4;cursor:default}.sv-zoom-pop .sv-pop-row:disabled:hover{background:transparent}.sv-zoom-pop kbd{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid rgba(255,255,255,.1);background:#ffffff0f;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600}@media(prefers-reduced-motion:reduce){.sv-pic.is-gliding,.sv-pic.is-gliding .sv-pic-view{transition:none}}.ed-tool-body.is-held{opacity:.55;transition:opacity var(--dur-fast)}.ed-relight-reset{display:flex;justify-content:flex-end}.ed-relight-reset .sv-btn{height:30px;padding:0 11px;gap:6px;font-size:11.5px}.ed-mix-pick{display:flex;align-items:center;gap:10px}.ed-mix-dropper{height:30px;padding:0 11px;gap:6px;font-size:11.5px}.ed-mix-dropper.on{background:var(--cv-accent-tint);border-color:#c2a4ec73;color:var(--fg-1)}.ed-mix-swatch{display:inline-flex;align-items:center;gap:5px;margin-left:auto;color:var(--fg-4)}.ed-mix-swatch i{width:26px;height:26px;border-radius:8px;box-shadow:inset 0 0 0 1px #fff3;transition:background .2s ease}.ed-hint b{font-weight:600;color:var(--fg-2)}.sv-pic-clip.is-picking,.sv-pic-clip.is-picking *{cursor:crosshair!important}`, bIe = '.lb-backdrop{position:fixed;inset:0;z-index:92;display:flex;align-items:center;justify-content:center;padding:26px 34px;background:#04030cb8;backdrop-filter:blur(16px) saturate(110%);-webkit-backdrop-filter:blur(16px) saturate(110%);animation:lbFade .22s var(--ease-out-soft) both}@keyframes lbFade{0%{opacity:0}to{opacity:1}}.lb-shell{position:relative;display:flex;flex-direction:column;width:min(1520px,100%);height:min(940px,100%);border-radius:24px;overflow:hidden;color:var(--fg-2);background:linear-gradient(180deg,#10121ef7,#090a11fa);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb3,0 0 0 1px #0006;animation:lbIn .34s var(--ease-out-soft) both}@keyframes lbIn{0%{opacity:0;transform:translateY(12px) scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.lb-backdrop,.lb-shell{animation:none}}.lb-head{position:relative;flex:none;padding:18px 22px 0;border-bottom:1px solid var(--hairline-soft)}.lb-glow{position:absolute;inset:0 0 auto;height:190px;pointer-events:none;opacity:.9;background:radial-gradient(60% 120% at 6% -20%,rgba(153,104,223,.3),transparent 62%),radial-gradient(40% 90% at 70% -40%,rgba(90,97,237,.2),transparent 70%),radial-gradient(30% 80% at 98% -30%,rgba(199,80,206,.12),transparent 70%)}.lb-row{position:relative;display:flex;align-items:center;gap:12px}.lb-row.is-top{padding-bottom:16px}.lb-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df6b,#5a61ed4d);color:#fff;box-shadow:inset 0 1px #fff3,0 10px 30px #7532d359}.lb-title{display:flex;flex-direction:column;gap:1px;min-width:0;margin-right:8px}.lb-title b{font-size:18px;font-weight:600;color:var(--fg-1);letter-spacing:-.015em}.lb-title span{font-size:12px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-search{flex:1;max-width:560px;margin-left:auto;height:42px;display:flex;align-items:center;gap:10px;padding:0 8px 0 14px;border-radius:13px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-4);box-shadow:inset 0 1px #ffffff0d;cursor:text;transition:border-color var(--dur-fast),box-shadow var(--dur-fast),background var(--dur-fast)}.lb-search:focus-within{border-color:#9968df8c;background:#ffffff12;box-shadow:0 0 0 4px #9968df24;color:var(--amethyst-700)}.lb-search input{flex:1;min-width:0;height:100%;border:0;outline:none;background:transparent;font-family:var(--font-sans);font-size:14px;color:var(--fg-1);user-select:text;-webkit-user-select:text}.lb-search input::placeholder{color:var(--fg-4)}.lb-search kbd{flex:none;min-width:22px;height:22px;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-4);font-family:var(--font-sans);font-size:11px}.lb-search-clear{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:#ffffff14;color:var(--fg-2);cursor:pointer}.lb-search-clear:hover{background:#ffffff24;color:#fff}.lb-close{flex:none;width:38px;height:38px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid transparent;border-radius:12px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.lb-close:hover{background:#ffffff12;border-color:var(--hairline-soft);color:#fff}.lb-row.is-bar{gap:10px}.lb-tabs{display:flex;align-items:flex-end;gap:4px;align-self:stretch}.lb-tabs button{position:relative;display:inline-flex;align-items:center;gap:8px;height:44px;padding:0 14px;border:0;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:13px;font-weight:600;letter-spacing:.01em;cursor:pointer;transition:color var(--dur-fast)}.lb-tabs button .licon{color:var(--fg-4);transition:color var(--dur-fast)}.lb-tabs button:hover{color:var(--fg-1)}.lb-tabs button:after{content:"";position:absolute;left:12px;right:12px;bottom:-1px;height:2px;border-radius:2px;background:var(--grad-cta);opacity:0;transform:scaleX(.6);transition:opacity var(--dur-fast),transform var(--dur-med) var(--ease-out-soft)}.lb-tabs button.on{color:#fff}.lb-tabs button.on .licon{color:var(--amethyst-600)}.lb-tabs button.on:after{opacity:1;transform:none}.lb-grow{flex:1;min-width:0}.lb-seg{display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09}.lb-seg button{min-width:30px;height:28px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:11px;font-weight:700;letter-spacing:.04em;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-seg button:hover{color:var(--fg-1);background:#ffffff0d}.lb-seg button.on{background:#ffffff1c;color:#fff;box-shadow:inset 0 1px #ffffff12}.lb-select{display:inline-flex;align-items:center;gap:9px;height:36px;padding:0 13px 0 9px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-select:hover{background:#ffffff12;color:#fff}.lb-select .sw{position:relative;width:30px;height:18px;border-radius:999px;background:#ffffff24;transition:background var(--dur-med)}.lb-select .sw i{position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #0006;transition:transform var(--dur-med) var(--ease-out-soft)}.lb-select.on{border-color:#9968df73;background:#9968df24;color:#fff}.lb-select.on .sw{background:var(--grad-cta)}.lb-select.on .sw i{transform:translate(12px)}.lb-row.is-bar .lb-seg,.lb-row.is-bar .lb-select{margin-bottom:6px}.lb-body{position:relative;flex:1;min-height:0;overflow-y:auto;padding:18px 22px 110px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.16) transparent}.lb-body::-webkit-scrollbar{width:8px}.lb-body::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px;border:2px solid transparent;background-clip:content-box}.lb-wall{position:relative}.lb-cell{position:absolute;border-radius:12px;cursor:zoom-in;animation:lbCell .4s var(--ease-out-soft) backwards}.lb-cell.is-selecting{cursor:pointer}@keyframes lbCell{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.lb-frame{position:absolute;inset:0;overflow:hidden;border-radius:12px;background:#ffffff0a;transition:transform .26s var(--ease-out-soft),box-shadow var(--dur-fast)}.lb-frame img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transform:scale(1.02);transition:opacity .35s ease,transform .6s var(--ease-out-soft);user-select:none;-webkit-user-drag:none}.lb-frame img.is-in{opacity:1;transform:none}.lb-frame:after{content:"";position:absolute;inset:0;border-radius:12px;box-shadow:inset 0 0 0 1px #ffffff12;pointer-events:none;transition:box-shadow var(--dur-fast)}.lb-cell:hover .lb-frame{transform:translateY(-2px);box-shadow:0 16px 40px #02040c8c}.lb-cell:hover .lb-frame:after{box-shadow:inset 0 0 0 1.5px #c2a4ec80}.lb-shade{position:absolute;inset:0;border-radius:12px;pointer-events:none;opacity:0;background:linear-gradient(180deg,#04030c6b,#04030c00 26% 52%,#04030cdb);transition:opacity var(--dur-fast)}.lb-cell:hover .lb-shade,.lb-cell.is-picked .lb-shade{opacity:1}.lb-info{position:absolute;left:12px;right:12px;bottom:10px;display:flex;flex-direction:column;gap:3px;pointer-events:none;opacity:0;transform:translateY(4px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.lb-cell:hover .lb-info{opacity:1;transform:none}.lb-info .p{font-size:12px;line-height:1.35;color:#fff;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.lb-info .m{font-size:10.5px;font-weight:500;color:#ffffff9e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-badge{position:absolute;top:9px;left:9px;display:inline-flex;align-items:center;gap:4px;height:20px;padding:0 7px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:600;pointer-events:none}.lb-badge.is-fav{left:auto;right:44px;padding:0 6px;color:var(--cv-fav, #ff6b8b)}.lb-badge.is-fav svg{fill:currentColor}.lb-cell:not(.is-selecting) .lb-badge.is-fav{right:9px}.lb-check,.lb-look{position:absolute;top:8px;right:8px;z-index:2;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1.5px solid rgba(255,255,255,.75);background:#04030c6b;color:#fff;cursor:pointer;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);font-family:var(--font-sans);font-size:12px;font-weight:700;transition:transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast),border-color var(--dur-fast),opacity var(--dur-fast)}.lb-check{opacity:.85}.lb-cell:hover .lb-check{opacity:1;transform:scale(1.06)}.lb-check.on{opacity:1;border-color:transparent;background:var(--grad-cta);box-shadow:0 4px 14px #745aff80}.lb-look{opacity:0;border-color:#ffffff4d}.lb-cell:hover .lb-look{opacity:1}.lb-look:hover{background:#04030cb3}.lb-cell.is-picked .lb-frame{transform:scale(.94)}.lb-cell.is-picked .lb-frame:after{box-shadow:inset 0 0 0 2.5px var(--amethyst-500)}.lb-cell.is-picked:hover .lb-frame{transform:scale(.94) translateY(-2px)}.lb-cell.is-off{cursor:not-allowed}.lb-cell.is-off .lb-frame{opacity:.35;filter:saturate(.6)}.lb-cell.is-off .lb-check{opacity:.35}.lb-skel{position:absolute;border-radius:12px;overflow:hidden;background:#ffffff0b;animation:lbSkel 1.4s ease-in-out infinite}@keyframes lbSkel{0%,to{opacity:.55}50%{opacity:1}}.lb-more,.lb-end{display:flex;align-items:center;justify-content:center;gap:10px;padding:22px 0 6px;font-size:12px;color:var(--fg-4)}.lb-end{color:var(--fg-5)}.lb-empty{box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;max-width:400px;min-height:100%;margin:0 auto;padding-bottom:4vh;text-align:center;animation:lbEmptyIn .4s var(--ease-out-soft) both}@keyframes lbEmptyIn{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.lb-empty b{font-size:17px;font-weight:600;color:var(--fg-1)}.lb-empty>span{font-size:13px;line-height:1.55;color:var(--fg-3);text-wrap:balance}.lb-empty .lb-empty-hint{display:inline-flex;align-items:center;gap:6px;margin-top:8px;padding:4px 12px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;font-size:11.5px;color:var(--fg-3)}.lb-empty-hint .key{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#ff5b8a29;color:#ff8aa8}.lb-empty-hint .key svg{fill:currentColor}.le{position:relative;flex:none;width:200px;height:118px;margin-bottom:10px}.le svg{display:block}.le-glow{position:absolute;left:50%;top:52%;width:190px;height:116px;translate:-50% -50%;border-radius:50%;background:radial-gradient(closest-side,rgba(153,104,223,.3),rgba(90,97,237,.11) 60%,transparent);filter:blur(6px)}.le-pic{position:absolute;width:54px;height:42px;border-radius:9px;overflow:hidden;box-shadow:inset 0 0 0 1px #ffffff2e,0 12px 26px #02040c8c}.le-pic .sun{position:absolute;right:9px;top:7px;width:9px;height:9px;border-radius:50%;background:#ffffffd1;box-shadow:0 0 10px #fff9}.le-pic .hill{position:absolute;left:-10px;right:-6px;bottom:-17px;height:28px;border-radius:50%;background:#090b1e8c}.le-pic .hill.b{left:24px;right:-28px;bottom:-19px;background:#090b1e59}.le-pic.p1,.le-pic.f1{background:linear-gradient(160deg,#2d2160,#7532d3 58%,#c750ce)}.le-pic.p2,.le-pic.f2,.le-pic.u{background:linear-gradient(175deg,#1d3a6e,#5a61ed 55%,#9ad0ff)}.le-pic.p3,.le-pic.f3{background:linear-gradient(165deg,#3a2240,#c750ce 52%,#ffb38a)}.le-pic.p1{left:24px;top:14px;rotate:-7deg}.le-pic.p2{left:73px;top:8px;z-index:2}.le-pic.p3{left:122px;top:14px;rotate:7deg}.le-spark{position:absolute;left:170px;top:0;color:#e2d4ff;filter:drop-shadow(0 0 6px rgba(196,167,255,.8))}.le-prompt{position:absolute;left:28px;top:78px;z-index:3;box-sizing:border-box;width:144px;height:26px;padding:0 5px 0 9px;display:flex;align-items:center;gap:6px;border-radius:13px;color:#c4a7ff;background:#10121ef0;border:1px solid rgba(255,255,255,.12);box-shadow:0 10px 24px #02040c80}.le-prompt .t1,.le-prompt .t2{height:5px;border-radius:3px;transform-origin:0 50%}.le-prompt .t1{width:54px;background:#ffffff57}.le-prompt .t2{width:26px;background:#ffffff2e}.le-prompt .run{margin-left:auto;width:16px;height:16px;border-radius:50%;background:var(--grad-cta, #8b5cf6)}.le-drop{position:absolute;left:46px;top:40px;box-sizing:border-box;width:108px;height:66px;border-radius:12px;display:flex;align-items:center;justify-content:center;color:#c4a7ff8c;border:1.5px dashed rgba(194,164,236,.38);background:#9968df0f}.le-pic.u{left:73px;top:52px;z-index:2}.le-check{position:absolute;left:144px;top:30px;z-index:3;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#34c79a;color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.le-pic.f1{left:30px;top:38px;rotate:-10deg}.le-pic.f3{left:116px;top:38px;rotate:10deg}.le-pic.f2{left:73px;top:24px;z-index:2;rotate:-1deg}.le-heart{position:absolute;left:113px;top:14px;z-index:4;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#ff5b8a;color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.le-heart svg{fill:currentColor}.le-burst{position:absolute;left:124px;top:25px;z-index:3;width:0;height:0}.le-burst i{position:absolute;left:-2px;top:-2px;width:4px;height:4px;border-radius:50%;background:#ff9ab6;opacity:0}.le-burst .b1{--bx: 0px;--by: -18px}.le-burst .b2{--bx: 16px;--by: -9px}.le-burst .b3{--bx: 16px;--by: 9px}.le-burst .b4{--bx: 0px;--by: 18px}.le-burst .b5{--bx: -16px;--by: 9px}.le-burst .b6{--bx: -16px;--by: -9px}.le-ghost{position:absolute;box-sizing:border-box;width:54px;height:42px;border-radius:9px;border:1.5px dashed rgba(255,255,255,.18);background:#ffffff06}.le-ghost.g1{left:24px;top:30px;rotate:-6deg}.le-ghost.g2{left:73px;top:24px}.le-ghost.g3{left:122px;top:30px;rotate:6deg}.le-lens{position:absolute;left:85px;top:28px;z-index:2;box-sizing:border-box;width:30px;height:30px;border-radius:50%;border:2.5px solid rgba(214,200,255,.92);background:#9968df24;box-shadow:0 8px 20px #02040c80}.le-lens:after{content:"";position:absolute;left:22px;top:25px;width:12px;height:3.5px;border-radius:2px;background:#d6c8ffeb;rotate:45deg}.le-track{position:absolute;left:50px;width:100px;height:3px;border-radius:2px;background:#ffffff24}.le-track.t1{top:84px}.le-track.t2{top:98px}.le-track .knob{position:absolute;top:-5px;box-sizing:border-box;width:13px;height:13px;border-radius:50%;background:#fff;border:2.5px solid #9968df;box-shadow:0 3px 8px #02040c8c}.le-track.t1 .knob{left:20px}.le-track.t2 .knob{left:68px}@media(prefers-reduced-motion:no-preference){.le-glow{animation:leGlow 6s ease-in-out infinite}@keyframes leGlow{0%,to{opacity:.7}45%{opacity:1}}.is-generations .le-prompt .t1{animation:leType1 6s ease-out infinite}.is-generations .le-prompt .t2{animation:leType2 6s ease-out infinite}.is-generations .le-prompt .run{animation:leRun 6s ease-out infinite}.le-pic.p1{animation:leLand1 6s var(--ease-out-soft) infinite}.le-pic.p2{animation:leLand2 6s var(--ease-out-soft) infinite}.le-pic.p3{animation:leLand3 6s var(--ease-out-soft) infinite}.le-spark{animation:leSpark 6s ease-out infinite}@keyframes leType1{0%{transform:scaleX(0);opacity:1}14%,86%{transform:scaleX(1);opacity:1}95%,to{transform:scaleX(1);opacity:0}}@keyframes leType2{0%,10%{transform:scaleX(0);opacity:1}22%,86%{transform:scaleX(1);opacity:1}95%,to{transform:scaleX(1);opacity:0}}@keyframes leRun{0%,24%{scale:1;box-shadow:0 0 #c2a4ecb3}27%{scale:.8}36%{scale:1;box-shadow:0 0 0 8px #c2a4ec00}to{scale:1;box-shadow:0 0 #c2a4ec00}}@keyframes leLand1{0%,30%{opacity:0;translate:0 14px;scale:.7}38%{opacity:1;translate:0 -2px;scale:1.04}44%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leLand2{0%,35%{opacity:0;translate:0 14px;scale:.7}43%{opacity:1;translate:0 -2px;scale:1.04}49%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leLand3{0%,40%{opacity:0;translate:0 14px;scale:.7}48%{opacity:1;translate:0 -2px;scale:1.04}54%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leSpark{0%,52%{opacity:0;scale:.4;rotate:-25deg}60%{opacity:1;scale:1.2;rotate:0deg}66%,82%{opacity:1;scale:1;rotate:0deg}92%,to{opacity:0;scale:.6;rotate:10deg}}.le-pic.u{animation:leDropIn 5.6s var(--ease-out-soft) infinite}.le-drop{animation:leZone 5.6s ease-in-out infinite}.le-check{animation:leCheck 5.6s var(--ease-out-soft) infinite}@keyframes leDropIn{0%{opacity:0;translate:28px -60px;rotate:14deg;scale:1}10%{opacity:1}34%{translate:0 0;rotate:0deg;scale:1}39%{scale:.93}45%,86%{opacity:1;translate:0 0;rotate:0deg;scale:1}95%,to{opacity:0;translate:0 0;rotate:0deg;scale:.96}}@keyframes leZone{0%,16%,52%,to{border-color:#c2a4ec61;background-color:#9968df0f}26%,38%{border-color:#c2a4ece6;background-color:#9968df29}}@keyframes leCheck{0%,42%{opacity:0;scale:.3}50%{opacity:1;scale:1.2}56%,86%{opacity:1;scale:1}95%,to{opacity:0;scale:.8}}.le-heart{animation:leHeart 5.2s var(--ease-out-soft) infinite}.le-burst i{animation:leBurst 5.2s ease-out infinite}.le-pic.f2{animation:leLift 5.2s var(--ease-out-soft) infinite}.le-pic.f1{animation:leFloat 5.2s ease-in-out infinite}.le-pic.f3{animation:leFloat 5.2s ease-in-out -1.7s infinite}@keyframes leHeart{0%,20%{opacity:0;scale:.2}28%{opacity:1;scale:1.32}34%{scale:.9}40%,86%{opacity:1;scale:1}95%,to{opacity:0;scale:.7}}@keyframes leBurst{0%,26%{opacity:0;translate:0 0;scale:1}29%{opacity:1}46%,to{opacity:0;translate:var(--bx) var(--by);scale:.4}}@keyframes leLift{0%,26%{translate:0 0}34%,86%{translate:0 -3px}96%,to{translate:0 0}}@keyframes leFloat{0%,to{translate:0 0}50%{translate:0 -4px}}.le-lens{animation:leSweep 4.4s ease-in-out infinite}.is-filters .le-ghost{animation:leDim 4.4s ease-in-out infinite}.le-track.t1 .knob{animation:leKnob1 4.4s ease-in-out infinite}.le-track.t2 .knob{animation:leKnob2 4.4s ease-in-out infinite}@keyframes leSweep{0%,to{translate:-54px 6px;rotate:-8deg}50%{translate:54px 2px;rotate:8deg}}@keyframes leDim{0%,to{opacity:1}50%{opacity:.3}}@keyframes leKnob1{0%,to{translate:0 0}50%{translate:48px 0}}@keyframes leKnob2{0%,to{translate:0 0}50%{translate:-48px 0}}}.lb-empty .lb-btn{margin-top:8px}.lb-empty-mark{width:48px;height:48px;border-radius:15px;margin-bottom:6px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df4d,#5a61ed33);color:#fff;box-shadow:inset 0 1px #ffffff29,0 14px 40px #7532d347}.lb-empty-mark.is-warn{background:#ff5c7a24;color:#ff8aa0;box-shadow:none}.lb-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:40px;padding:0 16px;border-radius:12px;border:1px solid var(--hairline);background:#ffffff0f;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),filter var(--dur-fast),transform var(--dur-fast)}.lb-btn:hover:not(:disabled){background:#ffffff1a;border-color:#ffffff29}.lb-btn:active:not(:disabled){transform:scale(.98)}.lb-btn:disabled{opacity:.45;cursor:default}.lb-btn.is-ghost{border-color:transparent;background:transparent;color:var(--fg-2)}.lb-btn.is-ghost:hover{background:#ffffff0f;color:#fff}.lb-btn.is-primary{border-color:transparent;background:var(--grad-cta);color:#fff;box-shadow:0 8px 24px #745aff59,inset 0 1px #ffffff38}.lb-btn.is-primary:hover:not(:disabled){filter:brightness(1.08);background:var(--grad-cta)}.lb-btn.is-primary:disabled{background:#ffffff12;box-shadow:none;color:var(--fg-4);opacity:1}.lb-btn.is-picked{border-color:#9968df80;background:#9968df2e}.lb-tray{position:absolute;left:50%;bottom:22px;z-index:5;transform:translate(-50%);display:flex;align-items:center;gap:12px;width:min(720px,calc(100% - 44px));padding:10px 10px 10px 14px;border-radius:18px;background:#0e101af0;border:1px solid var(--hairline);backdrop-filter:blur(26px) saturate(120%);-webkit-backdrop-filter:blur(26px) saturate(120%);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3}.lb-tray-enter-active,.lb-tray-leave-active{transition:opacity .24s var(--ease-out-soft),transform .24s var(--ease-out-soft)}.lb-tray-enter-from,.lb-tray-leave-to{opacity:0;transform:translate(-50%) translateY(14px)}.lb-tray-picks{display:flex;align-items:center;min-width:0}.lb-tray-thumb{position:relative;flex:none;width:34px;height:34px;margin-right:-10px;border-radius:9px;background-size:cover;background-position:center;box-shadow:0 0 0 2px #0e101a,0 4px 12px #0006;animation:lbThumb .26s var(--ease-out-soft) backwards}@keyframes lbThumb{0%{opacity:0;transform:scale(.6) translateY(6px)}to{opacity:1;transform:none}}.lb-tray-count{margin-left:22px;font-size:13px;color:var(--fg-3);white-space:nowrap}.lb-tray-picks .lb-tray-count:first-child{margin-left:2px}.lb-tray-count b{font-size:15px;font-weight:700;color:#fff;font-variant-numeric:tabular-nums}.lb-tray-clear{flex:none;padding:0 4px;border:0;background:transparent;color:var(--amethyst-700);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.lb-tray-clear:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.lb-note{position:absolute;left:50%;bottom:96px;z-index:6;transform:translate(-50%);display:inline-flex;align-items:center;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;background:#11131ef7;border:1px solid var(--hairline);color:var(--fg-1);font-size:12.5px;font-weight:500;box-shadow:0 14px 40px #02040c80}.lb-note-enter-active,.lb-note-leave-active{transition:opacity .2s var(--ease-out-soft),transform .2s var(--ease-out-soft)}.lb-note-enter-from,.lb-note-leave-to{opacity:0;transform:translate(-50%,6px)}.lb-peek{position:absolute;inset:0;z-index:8;display:flex;align-items:center;justify-content:center;padding:26px 70px;background:#06060ee6;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);animation:lbFade .2s var(--ease-out-soft) both}.lb-peek-shell{display:grid;grid-template-columns:minmax(0,1fr) 340px;gap:22px;width:100%;height:100%;animation:lbIn .3s var(--ease-out-soft) both}.lb-peek-stage{position:relative;min-width:0;display:flex;align-items:center;justify-content:center;border-radius:18px;background:#ffffff06;border:1px solid var(--hairline-soft);overflow:hidden}.lb-peek-art{display:block;max-width:calc(100% - 36px);max-height:calc(100% - 36px);border-radius:12px;box-shadow:0 30px 100px #02061799;transition:opacity .3s ease}.lb-peek-art.is-loading{opacity:0}.lb-peek-nav{position:absolute;top:50%;z-index:2;width:44px;height:44px;margin-top:-22px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-peek-nav:hover:not(:disabled){background:#ffffff1f;color:#fff}.lb-peek-nav:disabled{opacity:.3;cursor:default}.lb-peek-nav.at-left{left:14px}.lb-peek-nav.at-right{right:14px}.lb-peek-side{display:flex;flex-direction:column;gap:16px;min-width:0;padding:18px;border-radius:18px;background:#ffffff09;border:1px solid var(--hairline-soft);overflow-y:auto}.lb-peek-top{display:flex;align-items:center;gap:8px}.lb-peek-top .n{display:inline-flex;align-items:center;gap:7px;font-size:12px;color:var(--fg-3);font-variant-numeric:tabular-nums}.lb-peek-x{margin-left:auto;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:10px;background:#ffffff0d;color:var(--fg-2);cursor:pointer}.lb-peek-x:hover{background:#ffffff1a;color:#fff}.lb-peek-block{display:flex;flex-direction:column;gap:8px}.lb-peek-head{display:flex;align-items:center;justify-content:space-between;font-size:11px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.lb-peek-head span{display:inline-flex;align-items:center;gap:7px}.lb-peek-head button{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer}.lb-peek-head button:hover{background:#ffffff12;color:#fff}.lb-peek-prompt{margin:0;max-height:260px;overflow-y:auto;font-size:13.5px;line-height:1.6;color:var(--fg-1);white-space:pre-wrap;overflow-wrap:anywhere}.lb-peek-specs{margin:0;display:flex;flex-direction:column;gap:1px;border-radius:12px;overflow:hidden;border:1px solid var(--hairline-soft)}.lb-peek-specs div{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;background:#ffffff06}.lb-peek-specs dt{font-size:12px;color:var(--fg-4)}.lb-peek-specs dd{margin:0;font-size:12.5px;color:var(--fg-1);text-align:right;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-peek-acts{display:flex;flex-direction:column;gap:8px}.lb-peek-acts .lb-btn{width:100%}@media(max-width:980px){.lb-backdrop{padding:12px}.lb-title span{display:none}.lb-row.is-bar{flex-wrap:wrap}.lb-tabs button{padding:0 10px}.lb-peek{padding:16px}.lb-peek-shell{grid-template-columns:1fr;grid-template-rows:minmax(0,1fr) auto}.lb-peek-nav{display:none}}.lb-tool{display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 12px;margin-bottom:6px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-tool .licon{color:var(--fg-4);transition:color var(--dur-fast)}.lb-tool:hover{background:#ffffff12;color:#fff}.lb-tool.on,.lb-tool.is-set{border-color:#9968df73;background:#9968df24;color:#fff}.lb-tool.on .licon,.lb-tool.is-set .licon{color:var(--amethyst-700)}.lb-tool .n{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.lb-cols{display:inline-flex;align-items:center;gap:2px;height:36px;padding:3px;margin-bottom:6px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09}.lb-cols button{width:26px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-cols button:hover:not(:disabled){background:#ffffff12;color:#fff}.lb-cols button:disabled{opacity:.3;cursor:default}.lb-cols span{display:inline-flex;align-items:center;gap:5px;min-width:38px;justify-content:center;color:var(--fg-4)}.lb-cols span b{font-size:12.5px;font-weight:700;color:#fff;font-variant-numeric:tabular-nums}.lb-link{display:inline-flex;align-items:center;gap:6px;padding:0;border:0;background:transparent;color:var(--amethyst-700);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.lb-link:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.lb-filters{position:relative;z-index:4;flex:none;padding:16px 22px 14px;border-bottom:1px solid var(--hairline-soft);background:linear-gradient(180deg,#9968df0f,#ffffff04);animation:lbDrop .26s var(--ease-out-soft) both}@keyframes lbDrop{0%{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:none}}.lb-filters-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(212px,1fr));gap:14px 16px}.lb-field{display:flex;flex-direction:column;gap:7px;min-width:0}.lb-field.is-wide{grid-column:1 / -1}.lb-field.is-dates{grid-column:span 2}.lb-field.is-dates .lb-dates input{max-width:190px}.lb-field-label{font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.lb-chips{display:flex;flex-wrap:wrap;gap:6px}.lb-chip{display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 11px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-chip:hover{background:#ffffff12;color:#fff}.lb-chip.on{border-color:#9968df8c;background:#9968df33;color:#fff}.lb-chip .licon{color:var(--fg-4)}.lb-chip.on .licon{color:#ff8fb0}.lb-chip .glyph{flex:none;display:inline-block;border-radius:2.5px;border:1.5px solid currentColor;opacity:.75}.lb-chip .glyph.is-other{border-style:dashed}.lb-dates{display:flex;align-items:center;gap:6px}.lb-dates input{flex:1;min-width:0;height:36px;padding:0 9px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;color-scheme:dark;outline:none}.lb-dates input:focus{border-color:#9968df8c}.lb-dates .to{font-size:11.5px;color:var(--fg-4)}.lb-dates-x{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.lb-dates-x:hover{background:#ffffff1f;color:#fff}.lb-filters-foot{display:flex;align-items:center;gap:12px;margin-top:16px;padding-top:14px;border-top:1px solid var(--hairline-soft)}.lb-filters-count{font-size:12px;color:var(--fg-4)}.lb-filters-foot .lb-btn{height:36px}.lb-select-wrap{position:relative;min-width:0}.lb-select-btn{display:flex;align-items:center;gap:8px;width:100%;height:36px;padding:0 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-select-btn .licon{flex:none;color:var(--fg-4)}.lb-select-btn .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-select-btn:hover,.lb-select-btn.on{background:#ffffff12;color:#fff}.lb-select-btn.on{border-color:#9968df80}.lb-select-btn.is-set{color:#fff;border-color:#9968df73;background:#9968df1f}.lb-select-btn.is-set .licon:first-child{color:var(--amethyst-700)}.lb-select-pop{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:20;min-width:220px;padding:6px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:lbDrop .18s var(--ease-out-soft) both}.lb-select-search{display:flex;align-items:center;gap:8px;height:32px;padding:0 9px;margin-bottom:4px;border-radius:9px;background:#ffffff0d;color:var(--fg-4)}.lb-select-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px}.lb-select-rows{max-height:260px;overflow-y:auto;scrollbar-width:thin}.lb-select-row{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;text-align:left;cursor:pointer}.lb-select-row .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-select-row.is-active{background:#ffffff0f;color:#fff}.lb-select-row.on{color:#fff}.lb-select-row.on .licon{color:var(--amethyst-600)}.lb-select-row.is-any{color:var(--fg-4)}.lb-select-none{padding:10px 9px;font-size:12px;color:var(--fg-4)}.lb-applied{flex:none;display:flex;align-items:center;flex-wrap:wrap;gap:8px;padding:12px 22px 0}.lb-applied-chip{display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 4px 0 11px;border-radius:999px;border:1px solid rgba(153,104,223,.4);background:#9968df1f;color:#fff;font-size:12px;font-weight:600;animation:lbThumb .24s var(--ease-out-soft) backwards}.lb-applied-chip.is-search .licon{color:var(--amethyst-700)}.lb-applied-chip button{width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:#ffffff1a;color:var(--fg-2);cursor:pointer}.lb-applied-chip button:hover{background:#fff3;color:#fff}.lb-applied-note{font-size:11.5px;color:var(--fg-4)}.lb-star{position:absolute;top:8px;right:42px;z-index:2;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:0;background:#04030c80;color:#fff;cursor:pointer;opacity:0;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast)}.lb-cell:hover .lb-star,.lb-star.on{opacity:1}.lb-star:hover{transform:scale(1.08);background:#04030cb8}.lb-star.on{color:#ff6b8b}.lb-star.on svg{fill:currentColor}.lb-star.is-still{cursor:default}.lb-cell:not(.is-selecting) .lb-star{right:42px}.lb-cell.is-moderated{cursor:help}.lb-withheld{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;color:var(--fg-4);background:radial-gradient(120% 90% at 30% 20%,#9968df38,#ffffff08 70%)}.lb-withheld b{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}.lb-cell.is-list{display:flex;align-items:center;gap:16px;padding:8px 120px 8px 8px;border-radius:14px;background:#ffffff06;border:1px solid var(--hairline-soft);transition:background var(--dur-fast),border-color var(--dur-fast)}.lb-cell.is-list:hover{background:#ffffff0d}.lb-cell.is-list .lb-frame{position:relative;inset:auto;flex:none;width:92px;height:92px;border-radius:10px}.lb-cell.is-list:hover .lb-frame{transform:none;box-shadow:none}.lb-cell.is-list.is-picked{border-color:#9968df99;background:#9968df1a}.lb-cell.is-list.is-picked .lb-frame{transform:none}.lb-row-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:6px}.lb-row-text .p{font-size:13px;line-height:1.45;color:var(--fg-1);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.lb-row-text .m{font-size:11.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-cell.is-list .lb-check,.lb-cell.is-list .lb-look{top:50%;right:16px;margin-top:-14px}.lb-cell.is-list .lb-star{top:50%;right:54px;margin-top:-14px}.lb-cell.is-list .lb-badge{top:14px;left:14px}.lb-upload-tile{position:absolute;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:10px;border-radius:12px;border:1.5px dashed rgba(194,164,236,.4);background:#9968df0f;color:var(--fg-2);font-family:var(--font-sans);cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.lb-upload-tile:hover{background:#9968df21;border-color:#c2a4ecb3;transform:translateY(-2px)}.lb-upload-tile .ic{width:40px;height:40px;margin-bottom:4px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df66,#5a61ed4d);color:#fff}.lb-upload-tile b{font-size:13px;font-weight:600;color:#fff}.lb-upload-tile span{font-size:11.5px;color:var(--fg-4)}.lb-upload-tile.is-list{flex-direction:row;gap:14px;justify-content:flex-start;padding:0 18px}.lb-upload-tile.is-list .ic{margin:0}.lb-cell.is-uploading{cursor:progress}.lb-uploading{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:8px;padding:10px;font-size:11.5px;color:var(--fg-3);text-align:center;overflow:hidden}.lb-cell.is-uploading .lb-frame:before{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.08) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.lb-dropping{position:absolute;inset:0;z-index:9;display:flex;align-items:center;justify-content:center;background:#04030c99;pointer-events:none;animation:lbFade .16s ease both}.lb-dropping>div{display:inline-flex;align-items:center;gap:10px;padding:16px 22px;border-radius:16px;border:1.5px dashed rgba(194,164,236,.75);background:#0d0f18f0;color:#fff;font-size:14px;font-weight:500}.lb-more.is-failed{color:#ff9db5}.lb-note.is-error{border-color:#ff5c7a66;color:#ffb3c1}.lb-peek-act{flex:none;height:32px;min-width:32px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;gap:6px;border:0;border-radius:10px;background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-peek-act:hover{background:#ffffff1a;color:#fff}.lb-peek-act.lb-peek-star.on{color:#ff6b8b}.lb-peek-act.lb-peek-star.on svg{fill:currentColor}.lb-peek-act.lb-peek-pin.on{color:#c4a7ff;background:#9968df29}.lb-peek-act.lb-peek-pin.on svg{fill:currentColor}.lb-peek-act.is-danger:hover,.lb-peek-act.is-confirming{background:#ff5c7a29;color:#ff9db5}.lb-peek-withheld{display:flex;flex-direction:column;align-items:center;gap:10px;max-width:420px;padding:24px;text-align:center}.lb-peek-withheld b{font-size:16px;color:#fff}.lb-peek-withheld span{font-size:13px;line-height:1.6;color:var(--fg-3)}.lb-badge.is-3d{color:#b9c1ff}', vIe = '.pl-wrap{position:relative;z-index:6;width:min(1200px,calc(100% - 16px));margin-bottom:12px;animation:plRise .46s var(--ease-out-soft) both}@keyframes plRise{0%{opacity:0;transform:translateY(18px) scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.pl-wrap{animation:none}}.pl-float{position:absolute;left:var(--chat-w);right:var(--set-w);top:52px;bottom:84px;z-index:72;display:flex;align-items:center;justify-content:center;pointer-events:none}.pl-float>.pl-wrap{pointer-events:auto;margin-bottom:0}.pl-panel{position:relative;display:flex;overflow:hidden;height:clamp(340px,calc(100vh - 52px - var(--up-card-h, 150px) - 84px),740px);border:1px solid rgba(255,255,255,.06);border-radius:22px;background:radial-gradient(120% 70% at 50% -18%,rgba(153,104,223,.11),transparent 62%),#0a0c14fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 40px 110px #02040cad;container:pl-panel / inline-size}.pl-wrap.is-floating .pl-panel{height:clamp(360px,calc(100vh - 184px),760px)}.pl-close{position:absolute;top:-12px;right:-12px;z-index:3;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.1);border-radius:50%;background:#141723f7;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);color:var(--fg-2);cursor:pointer;box-shadow:0 6px 18px #02040c8c;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-close:hover{background:#222638fa;color:#fff;transform:rotate(90deg)}.pl-side{flex:none;width:248px;min-height:0;box-sizing:border-box;display:flex;flex-direction:column;padding:14px 8px 12px 12px;border-right:1px solid rgba(255,255,255,.05);background:#ffffff04}.pl-side-tabs{display:flex;width:100%;box-sizing:border-box}.pl-tabs.pl-side-tabs button{flex:1 1 0;min-width:0;justify-content:center;gap:6px;padding:0 6px;white-space:nowrap}.pl-side-scroll{flex:1;min-height:0;overflow-y:auto;margin-top:12px;padding-right:4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.1) transparent}.pl-tree{display:flex;flex-direction:column;gap:1px}.pl-node{position:relative;display:flex;align-items:center;gap:9px;width:100%;min-height:32px;box-sizing:border-box;padding:0 10px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;outline:none;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.pl-node>.licon{flex:none;color:var(--fg-4);transition:color var(--dur-fast)}.pl-node .lbl{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-node .n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-node:hover{background:#ffffff0b;color:var(--fg-1)}.pl-node:focus-visible{box-shadow:inset 0 0 0 1.5px var(--vista-blue-500)}.pl-node.on{background:var(--cv-accent-tint);color:var(--fg-1);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.pl-node.on>.licon,.pl-node.is-in>.licon{color:var(--cv-accent-text)}.pl-node.is-empty:not(.on) .lbl,.pl-node.is-empty:not(.on)>.licon{opacity:.5}.pl-node.is-root{margin-bottom:4px}.pl-node.is-kind{margin-top:8px;color:var(--fg-2);font-weight:600}.pl-branch.is-in>.pl-node.is-kind{color:var(--fg-1)}.pl-node.is-action{min-height:40px;padding:5px 10px 5px 30px}.pl-node.is-action .lbl{display:flex;flex-direction:column;gap:1px;line-height:1.3}.pl-node.is-action em{font-style:normal;font-size:10.5px;font-weight:500;color:var(--fg-4);overflow:hidden;text-overflow:ellipsis}.pl-node.is-action.on em{color:var(--fg-3)}.pl-leaves{position:relative;display:flex;flex-direction:column;gap:1px;margin:1px 0 3px}.pl-leaves:before{content:"";position:absolute;left:36px;top:4px;bottom:4px;width:1px;background:#ffffff14}@media(prefers-reduced-motion:no-preference){.pl-leaves{animation:plLeaves .32s var(--ease-out-soft) both}}@keyframes plLeaves{0%{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}.pl-node.is-cat{min-height:29px;padding:5px 10px 5px 46px;font-size:12px;line-height:1.35}.pl-node.is-cat .lbl{white-space:normal;text-wrap:pretty}.pl-side-sec{display:flex;flex-direction:column;gap:1px;margin-top:14px;padding-top:12px;border-top:1px solid var(--hairline-soft)}.pl-side-label{padding:0 10px 6px;font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.pl-node.is-level.on{background:transparent;box-shadow:none}.pl-node.is-level.on:hover{background:#ffffff0b}.pl-tick{flex:none;width:14px;height:14px;display:inline-flex;align-items:center;justify-content:center;border-radius:4px;box-shadow:inset 0 0 0 1.5px #ffffff38;color:transparent;transition:background var(--dur-fast),box-shadow var(--dur-fast),color var(--dur-fast)}.pl-node.is-level.on .pl-tick{background:var(--cv-accent);box-shadow:none;color:#fff}.pl-head .pl-side-toggle,.pl-side-scrim{display:none}@container pl-panel (max-width: 700px){.pl-side{position:absolute;z-index:6;top:0;bottom:0;left:0;width:248px;background:#0c0e16fe;box-shadow:18px 0 50px #02040c8c;transform:translate(-104%);visibility:hidden;transition:transform .32s var(--ease-out-soft),visibility 0s linear .32s}.pl-panel.is-side-open .pl-side{transform:none;visibility:visible;transition:transform .32s var(--ease-out-soft)}.pl-head .pl-side-toggle{display:inline-flex;flex:none;width:36px;height:36px;border-radius:11px}.pl-side-scrim{display:block;position:absolute;inset:0;z-index:5;background:#04050a73}}.pl-content{position:relative;flex:1;min-width:0;min-height:0;display:flex;flex-direction:column;container-type:inline-size}.pl-head{display:flex;align-items:center;gap:10px;padding:14px 16px 10px;flex:none}.pl-tabs{display:inline-flex;gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;flex:none}.pl-tabs button{height:30px;padding:0 13px;display:inline-flex;align-items:center;gap:7px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-tabs button:hover{color:var(--fg-1)}.pl-tabs button.on{background:#ffffff17;color:var(--fg-1);box-shadow:var(--inset-highlight)}.pl-tabs .n{font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-search{flex:1;min-width:0;height:36px;padding:0 8px 0 12px;display:flex;align-items:center;gap:9px;border:1px solid transparent;border-radius:11px;background:#ffffff0b;color:var(--fg-4);transition:border-color var(--dur-fast),background var(--dur-fast)}.pl-search:focus-within{border-color:var(--cv-accent-soft);background:#ffffff0f}.pl-search.is-off{opacity:.5}.pl-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:500;user-select:text;-webkit-user-select:text}.pl-search input::placeholder{color:var(--fg-4)}.pl-clear{width:22px;height:22px;flex:none;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.pl-clear:hover{background:#ffffff1f;color:#fff}.pl-kbd{flex:none;min-width:20px;height:20px;padding:0 6px;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;background:#ffffff0f;color:var(--fg-4);font-family:var(--font-sans);font-size:10.5px}.pl-scope{flex:none;display:flex;align-items:center;gap:8px;min-width:0;padding:0 16px 12px}.pl-scope-crumb{flex:none;display:inline-flex;align-items:center;gap:3px;font-size:12.5px;color:var(--fg-4);white-space:nowrap}.pl-scope-title{flex:none;max-width:50%;font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-scope-hint{flex:1;min-width:0;font-size:12px;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-scope-n{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-chip{flex:none;height:28px;padding:0 12px;border:1px solid var(--hairline-soft);border-radius:999px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.pl-chip:hover{color:var(--fg-1);background:#ffffff0d}.pl-chip.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.pl-main{position:relative;flex:1;min-height:0}.pl-body{position:absolute;inset:0;overflow-y:auto;padding:2px 16px 16px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.pl-body::-webkit-scrollbar{width:6px}.pl-body::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.pl-body.is-covered{visibility:hidden}.pl-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}@container (max-width: 640px){.pl-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@container (max-width: 400px){.pl-grid{grid-template-columns:minmax(0,1fr)}}.pl-tile{position:relative;aspect-ratio:4 / 3;border-radius:15px;overflow:hidden;isolation:isolate;background:#0c0e17;box-shadow:inset 0 0 0 1px #ffffff0f;transition:transform .35s var(--ease-out-soft),box-shadow .35s var(--ease-out-soft)}@media(prefers-reduced-motion:no-preference){.pl-tile{animation:plTileIn .5s var(--ease-out-soft) both}.pl-tile:nth-child(2){animation-delay:.03s}.pl-tile:nth-child(3){animation-delay:.06s}.pl-tile:nth-child(4){animation-delay:.09s}.pl-tile:nth-child(5){animation-delay:.12s}.pl-tile:nth-child(6){animation-delay:.15s}}@keyframes plTileIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}.pl-tile:hover,.pl-tile:focus-within{transform:translateY(-3px);box-shadow:inset 0 0 0 1px #ffffff26,0 18px 44px #02040c8c}.pl-tile-art{position:absolute;inset:0;overflow:hidden}.pl-tile-art:before,.pl-tile.is-skeleton:before{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.05) 50%,transparent 80%);animation:shimmer 1.4s linear infinite}.pl-tile.is-in .pl-tile-art:before{display:none}.pl-tile.is-skeleton{animation:none}.pl-tile-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;opacity:0;transform:scale(1.04);transition:opacity .5s var(--ease-out-soft),transform .9s var(--ease-out-soft)}.pl-tile.is-in .pl-tile-img{opacity:1;transform:none}.pl-tile:hover .pl-tile-img:not(.is-peek){transform:scale(1.035)}.pl-tile-img.is-peek,.pl-tile-img.is-video{z-index:1;opacity:1;transform:none}.pl-tile-shade{position:absolute;inset:0;z-index:2;pointer-events:none;background:linear-gradient(180deg,#04030c00 46%,#04030cd6)}.pl-tile-shade:after{content:"";position:absolute;inset:0;opacity:0;background:linear-gradient(180deg,#04030c00 20%,#04030c99);transition:opacity .55s var(--ease-out-soft)}.pl-tile:hover .pl-tile-shade:after,.pl-tile:focus-within .pl-tile-shade:after{opacity:1}.pl-tile-hit{position:absolute;inset:0;z-index:3;padding:0;border:0;border-radius:inherit;background:transparent;cursor:pointer;outline:none}.pl-tile-hit:focus-visible{box-shadow:inset 0 0 0 2px var(--vista-blue-500)}.pl-tile-meta{position:absolute;left:12px;right:12px;bottom:11px;z-index:4;display:flex;flex-direction:column;gap:2px;pointer-events:none;transform:translateY(40px);transition:transform .6s var(--ease-out-soft)}.pl-tile:hover .pl-tile-meta,.pl-tile:focus-within .pl-tile-meta{transform:none}.pl-tile-name{font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-shadow:0 1px 12px rgba(4,3,12,.5)}.pl-tile-tool{font-size:11px;color:#ffffff9e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-tile-acts{display:flex;gap:6px;margin-top:9px;opacity:0;pointer-events:auto;transition:opacity .45s var(--ease-out-soft)}.pl-tile:hover .pl-tile-acts,.pl-tile:focus-within .pl-tile-acts{opacity:1}.pl-tile-cap{position:absolute;top:10px;left:58px;z-index:5;max-width:calc(100% - 68px);width:max-content;padding:3px 9px;border-radius:999px;background:#04030cbd;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.pl-stack{position:absolute;top:10px;left:10px;z-index:5;display:flex;flex-direction:column;gap:5px}.pl-stack-win{height:calc(var(--rows) * 42px - 4px);width:42px;margin:-2px;padding:2px;overflow:hidden;border-radius:11px;box-sizing:content-box}.pl-stack-reel{display:flex;flex-direction:column;gap:4px;transform:translateY(calc(var(--off) * -42px));transition:transform .42s var(--ease-out-soft)}.pl-stack-th{width:38px;height:38px;flex:none;border-radius:9px;background-size:cover;background-position:center;background-color:#ffffff0f;cursor:pointer;box-shadow:0 0 0 1.5px #ffffffd1,0 6px 14px #04030c80;transition:box-shadow var(--dur-fast)}.pl-stack-th.is-markup{box-shadow:0 0 0 1.5px var(--amethyst-700),0 6px 14px #04030c80}.pl-stack-th.on{box-shadow:0 0 0 2px var(--vista-blue-500),0 8px 18px #04030c99}.pl-stack-more{position:relative;width:38px;height:20px;padding:0;overflow:hidden;border:0;border-radius:7px;background:#04030cc2;color:#fff;font-family:var(--font-sans);font-size:10px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-stack-more .n,.pl-stack-more .ic{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;transition:opacity .2s var(--ease-out-soft),transform .2s var(--ease-out-soft)}.pl-stack-more .ic{opacity:0;transform:translateY(-4px)}.pl-tile:hover .pl-stack-more .n{opacity:0;transform:translateY(4px)}.pl-tile:hover .pl-stack-more .ic{opacity:1;transform:none}.pl-stack-more:hover{background:#fffffff0;color:#0b0d14}.pl-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:28px;padding:0 12px;border:0;border-radius:999px;font-family:var(--font-sans);font-size:11.5px;font-weight:600;letter-spacing:-.005em;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-btn:active{transform:scale(.97)}.pl-btn.is-light{background:#fffffff0;color:#0b0d14}.pl-btn.is-light:hover{background:#fff}.pl-btn.is-glass{background:#ffffff1a;color:var(--fg-1);box-shadow:inset 0 0 0 1px #ffffff24;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}.pl-btn.is-glass:hover{background:#ffffff2b}.pl-btn.is-lg{height:38px;padding:0 16px;border-radius:12px;font-size:12.5px}.pl-cta{height:38px;padding:0 22px;border:0;border-radius:12px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:13px;font-weight:600;cursor:pointer;box-shadow:0 14px 34px #745aff4d;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.pl-cta:hover{transform:translateY(-1px);box-shadow:0 18px 42px #745aff66}.pl-cta:active{transform:scale(.98)}.pl-icon-btn{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-icon-btn:hover{background:#ffffff12;color:var(--fg-1)}.pl-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;min-height:100%;padding:32px 24px;box-sizing:border-box;text-align:center;color:var(--fg-3);font-size:12.5px;line-height:1.55;text-wrap:pretty}.pl-empty>.licon{color:var(--fg-4);margin-bottom:4px}.pl-empty b{color:var(--fg-1);font-size:14px;font-weight:600;letter-spacing:-.01em}.pl-empty>span{max-width:380px}.pl-empty .pl-btn{margin-top:8px}.pl-empty-acts{display:flex;gap:8px}.pl-empty-mark{width:44px;height:44px;margin-bottom:6px;display:inline-flex;align-items:center;justify-content:center;border-radius:14px;background:var(--cv-accent-tint);color:var(--cv-accent-text);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.pl-detail{position:absolute;inset:0;z-index:2;display:grid;grid-template-columns:minmax(0,1.12fr) minmax(0,1fr);gap:16px;padding:2px 16px 14px}@container (max-width: 600px){.pl-detail{grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(150px,40%) minmax(0,1fr);gap:12px}}.pl-detail-enter-active{transition:opacity .3s var(--ease-out-soft)}.pl-detail-leave-active{transition:opacity .16s ease}.pl-detail-enter-from,.pl-detail-leave-to{opacity:0}.pl-detail-art{position:relative;min-height:0;border-radius:16px;overflow:hidden;display:flex;align-items:center;justify-content:center;background:radial-gradient(90% 70% at 50% 40%,rgba(153,104,223,.07),transparent 70%),#07080f;box-shadow:inset 0 0 0 1px #ffffff0d}.pl-detail-img{display:block;max-width:calc(100% - 28px);max-height:calc(100% - 28px);width:auto;height:auto;border-radius:12px;box-shadow:0 22px 60px #02040c8c}.pl-detail-img.is-landing{opacity:0}.pl-peek-enter-active{transition:opacity .2s var(--ease-out-soft)}.pl-peek-leave-active{transition:opacity .12s ease}.pl-peek-enter-from,.pl-peek-leave-to{opacity:0}.pl-back{position:absolute;top:12px;left:12px;z-index:2;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:10px;background:#04030c9e;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;cursor:pointer;box-shadow:inset 0 0 0 1px #ffffff1f;transition:background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-back:hover{background:#04030cd6;transform:translate(-2px)}.pl-detail-cap{position:absolute;top:14px;right:14px;z-index:2;max-width:70%;padding:4px 11px;border-radius:999px;background:#04030cb8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#ffffffd9;font-size:11px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.pl-detail-strip{position:absolute;left:14px;bottom:14px;z-index:2;display:flex;gap:7px}.pl-th-slot{display:flex;flex:none}.pl-detail-th{width:52px;height:52px;padding:0;border:0;border-radius:11px;cursor:pointer;background-size:cover;background-position:center;background-color:#ffffff0f;box-shadow:0 0 0 1.5px #fffc,0 8px 18px #04030c8c;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-detail-th:hover,.pl-detail-th.on{transform:translateY(-2px);box-shadow:0 0 0 2px var(--vista-blue-500),0 10px 22px #04030c99}.pl-detail-th.is-markup{box-shadow:0 0 0 1.5px var(--amethyst-700),0 8px 18px #04030c8c}.pl-detail-more{height:52px;min-width:40px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;border-radius:11px;background:#04030cbd;color:#fff;font-size:11px;font-weight:600}.pl-detail-info{position:relative;display:flex;flex-direction:column;min-height:0}.pl-detail-scroll{flex:1;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:16px;padding:6px 6px 16px 2px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.pl-detail-foot{flex:none;display:flex;flex-direction:column;gap:8px;padding-top:14px;border-top:1px solid var(--hairline-soft)}@media(prefers-reduced-motion:no-preference){.pl-detail-info{animation:plInfoIn .5s var(--ease-out-soft) .08s both}@keyframes plInfoIn{0%{opacity:0;transform:translate(14px)}to{opacity:1;transform:none}}}.pl-detail-top{display:flex;align-items:center;gap:10px}.pl-crumb{flex:1;min-width:0;font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-detail-nav{display:inline-flex;align-items:center;gap:2px;flex:none}.pl-detail-nav button{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-detail-nav button:hover:not(:disabled){background:#ffffff12;color:#fff}.pl-detail-nav button:disabled{opacity:.3;cursor:default}.pl-detail-count{min-width:56px;text-align:center;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-detail-name{margin:-6px 0 0;font-size:19px;font-weight:600;letter-spacing:-.02em;line-height:1.2;color:var(--fg-1)}.pl-detail-desc{margin:-8px 0 0;font-size:12.5px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.pl-block{display:flex;flex-direction:column;gap:8px}.pl-label-row{display:flex;align-items:center;justify-content:space-between;margin:-4px 0}.pl-label{font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.pl-prompt{margin:0;padding:12px 14px;max-height:220px;overflow-y:auto;border-radius:12px;background:#ffffff09;box-shadow:inset 0 0 0 1px #ffffff0d;color:var(--fg-2);font-size:12.5px;line-height:1.6;white-space:pre-wrap;text-wrap:pretty;user-select:text;-webkit-user-select:text;scrollbar-width:thin}.pl-pills{display:flex;flex-wrap:wrap;gap:6px}.pl-pill{display:inline-flex;align-items:center;gap:7px;height:28px;padding:0 11px 0 9px;border-radius:999px;background:#ffffff0e;color:var(--fg-2);font-size:12px;font-weight:500}.pl-pill .licon{color:var(--cv-accent-text)}.pl-pill.is-quiet{background:#ffffff08;color:var(--fg-3)}.pl-pill.is-quiet .licon{color:var(--fg-4)}.pl-note{display:flex;align-items:flex-start;gap:7px;margin:0;padding:9px 11px;border-radius:10px;background:#ffb34712;box-shadow:inset 0 0 0 1px #ffb34729;color:#ffdcaadb;font-size:11.5px;line-height:1.5}.pl-note .licon{margin-top:2px;color:var(--warning);flex:none}.pl-inputs{display:flex;flex-wrap:wrap;gap:7px}.pl-input{position:relative;width:62px;height:62px;padding:0;overflow:hidden;border:0;border-radius:11px;cursor:pointer;background-size:cover;background-position:center;background-color:#ffffff0d;box-shadow:inset 0 0 0 1px #ffffff17;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-input:hover,.pl-input.on{transform:translateY(-2px);box-shadow:0 0 0 2px var(--vista-blue-500)}.pl-input.is-markup{box-shadow:inset 0 0 0 1.5px var(--amethyst-700)}.pl-input-n{position:absolute;top:4px;left:4px;min-width:16px;height:16px;padding:0 4px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#04030cbd;color:#fff;font-size:9.5px;font-weight:600}.pl-input-tag{position:absolute;left:0;right:0;bottom:0;padding:3px 0;background:#04030cc2;color:#fff;font-size:8.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;text-align:center}.pl-detail-acts{display:flex;align-items:center;gap:8px}.pl-acts-hint{margin:0;font-size:11px;color:var(--fg-4);line-height:1.5}.up-ghost{grid-column:2;grid-row:1;align-self:start;min-width:0;padding-top:4px;font-family:var(--font-sans);font-size:13.5px;line-height:1.55;letter-spacing:-.005em;color:var(--fg-4);pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-ghost-enter-active{transition:opacity .45s var(--ease-out-soft),transform .45s var(--ease-out-soft)}.up-ghost-leave-active{transition:opacity .22s ease}.up-ghost-enter-from{opacity:0;transform:translateY(5px)}.up-ghost-leave-to{opacity:0}.up-cue{grid-column:2;grid-row:1;align-self:end;justify-self:start;margin-bottom:2px;display:inline-flex;align-items:center;gap:6px;padding:2px 9px 2px 4px;border-radius:999px;background:var(--cv-accent-tint);color:var(--cv-accent-text);font-size:10.5px;letter-spacing:.01em;pointer-events:none;animation:upIn .4s var(--ease-out-soft) .15s both}.up-cue kbd{font-family:var(--font-sans);font-size:9.5px;padding:1px 6px;border-radius:5px;background:#ffffff24;color:var(--fg-1)}.up-cue .src{color:var(--fg-4)}.up-card.is-landed{animation:upLanded 1.2s var(--ease-out-soft)}@keyframes upLanded{0%{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #a3a7f5e6,0 0 42px #745aff73,0 30px 80px #02040c9e}to{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #a3a7f500,0 0 #745aff00,0 30px 80px #02040c9e}}@media(prefers-reduced-motion:reduce){.up-card.is-landed{animation:none}}.bd-toast{bottom:max(186px,calc(var(--up-card-h, 0px) + 44px))}.bd-toast.has-action{pointer-events:auto;padding-right:6px}.bd-toast-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.bd-toast.is-long{white-space:normal;border-radius:14px;max-width:min(520px,calc(100vw - 32px));line-height:1.45}.bd-toast.is-long .bd-toast-text{overflow:visible}.bd-toast-act{flex:none;margin-left:4px;height:24px;padding:0 11px;border:0;border-radius:999px;background:#ffffff1c;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast)}.bd-toast-act:hover{background:#fff3}.lib-new{position:absolute;top:3px;right:3px;width:7px;height:7px;border-radius:50%;pointer-events:none;background:var(--cv-accent-soft);box-shadow:0 0 0 2px #0e101af2,0 0 10px #9968dfbf}.up-side-btn.has-new{position:relative}.pl-head-act{flex:none;height:36px;border-radius:11px}.pl-chip .n{font-size:10px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-tile-levels{position:absolute;top:10px;right:10px;z-index:5;display:inline-flex;align-items:center;gap:5px;height:22px;padding:0 8px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#ffffffd1}.pl-tile-words,.pl-cover-text{position:absolute;inset:0;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;padding:18px 18px 64px;box-sizing:border-box;background:radial-gradient(120% 90% at 0% 0%,rgba(153,104,223,.22),transparent 60%),radial-gradient(90% 80% at 100% 100%,rgba(90,97,237,.18),transparent 60%),#0d0f1a;color:#ffffffdb;font-size:15px;font-weight:500;line-height:1.45;letter-spacing:-.01em;-webkit-line-clamp:6}.pl-cover-text{position:relative;inset:auto;width:calc(100% - 28px);height:calc(100% - 28px);border-radius:12px;padding:28px;font-size:18px;-webkit-line-clamp:12}.pl-detail-by{margin:-10px 0 0;font-size:11.5px;color:var(--fg-4)}.pl-acts-own{margin-left:auto;display:inline-flex;gap:4px}.pl-icon-btn.is-lg{width:auto;min-width:38px;height:38px;padding:0 10px;gap:6px;border-radius:12px;font-family:var(--font-sans);font-size:12px;font-weight:600}.pl-icon-btn.is-danger:hover,.pl-icon-btn.is-danger.is-confirming{background:#ff5c7a24;color:var(--danger)}.pl-icon-btn.is-danger.is-confirming{box-shadow:inset 0 0 0 1px #ff5c7a66}.pl-edit{position:absolute;inset:0;z-index:3;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px;padding:2px 16px 14px}@container (max-width: 600px){.pl-edit{grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(140px,32%) minmax(0,1fr);gap:12px}}.pl-edit-form{min-height:0;display:flex;flex-direction:column;padding:4px 2px}.ps{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:16px}.ps-body{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:16px;overflow-y:auto;margin:0 -6px;padding:0 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.ps-body.is-more{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent)}.ps-head{display:flex;align-items:center;gap:11px}.ps-mark{flex:none;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border-radius:11px;background:var(--cv-accent-tint);color:var(--cv-accent-text);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.ps-title{display:flex;flex-direction:column;gap:2px;min-width:0}.ps-title b{font-size:14.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ps-title em{font-style:normal;font-size:11.5px;color:var(--fg-4)}.ps-field{display:flex;flex-direction:column;gap:8px;min-width:0}.ps-input{width:100%;box-sizing:border-box;height:38px;padding:0 12px;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;font-weight:500;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast);user-select:text;-webkit-user-select:text}.ps-input:focus{border-color:var(--cv-accent-soft);background:#ffffff0f}.ps-input::placeholder{color:var(--fg-4)}.ps-input.is-chip{width:150px;height:28px;border-radius:999px;font-size:11.5px}.ps-text{height:auto;min-height:96px;padding:10px 12px;resize:vertical;line-height:1.55;font-size:12.5px}.ps-hint{font-size:11px;color:var(--fg-4)}.ps-hint.is-bad{color:var(--danger)}.ps-audience{display:flex;align-items:center;gap:7px;margin:0;font-size:12px;color:var(--fg-2)}.ps-audience .licon{color:var(--cv-accent-text)}.ps-levels{display:flex;flex-direction:column;gap:6px}.ps-level{display:flex;align-items:center;gap:11px;width:100%;padding:10px 12px;text-align:left;cursor:pointer;border:1px solid var(--hairline-soft);border-radius:12px;background:#ffffff06;color:var(--fg-2);font-family:var(--font-sans);transition:background var(--dur-fast),border-color var(--dur-fast)}.ps-level:hover{background:#ffffff0d}.ps-level.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.ps-level>.licon{flex:none;color:var(--fg-4)}.ps-level.on>.licon{color:var(--cv-accent-text)}.ps-level-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ps-level-text b{font-size:12.5px;font-weight:600;color:var(--fg-1)}.ps-level-text em{font-style:normal;font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ps-switch{position:relative;flex:none;width:30px;height:18px;border-radius:999px;background:#ffffff1f;transition:background var(--dur-fast)}.ps-switch:after{content:"";position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c66;transition:transform var(--dur-med) var(--ease-out-soft)}.ps-level.on .ps-switch{background:var(--cv-accent)}.ps-level.on .ps-switch:after{transform:translate(12px)}.ps-level.is-off{cursor:default;opacity:.5}.ps-level.is-off:hover{background:#ffffff06}.ps-level.is-off:disabled{opacity:.62}.ps-level.is-off .ps-level-text em{white-space:normal}.ps-cats{display:flex;flex-wrap:wrap;align-items:center;gap:6px}.ps-check{display:flex;align-items:center;gap:9px;font-size:12px;color:var(--fg-2);cursor:pointer}.ps-check input{accent-color:var(--cv-accent);width:15px;height:15px;margin:0}.ps-thumbs{display:inline-flex;margin-left:4px}.ps-thumbs span{width:26px;height:26px;margin-left:-6px;border-radius:8px;background-size:cover;background-position:center;box-shadow:0 0 0 1.5px #0b0d15}.ps-thumbs span:first-child{margin-left:0}.ps-dup{display:flex;flex-wrap:wrap;align-items:center;gap:6px 8px;margin:0;padding:10px 12px;border-radius:11px;background:#a3a7f514;box-shadow:inset 0 0 0 1px #a3a7f533;color:var(--fg-2);font-size:12px}.ps-dup .licon{color:var(--vista-blue-500)}.ps-link{padding:0;border:0;background:none;color:var(--vista-blue-500);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:3px}.ps-foot{flex:none;display:flex;gap:8px}.pl-cta:disabled{opacity:.45;cursor:default;box-shadow:none;transform:none}.v2-info-pair{display:grid;grid-template-columns:1fr 1fr;gap:8px}.v2-info-pair>:last-child:nth-child(odd){grid-column:1 / -1}.v2-info-card.is-form{flex:0 1 auto;min-height:0;padding:16px;overflow:hidden}.v2-info-card.is-form>.ps{animation:infoForm .32s var(--ease-out-soft) both}@keyframes infoForm{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.v2-info-card.is-form>.ps{animation:none}}', yIe = '.dp-wrap{position:relative;display:inline-flex}.dp-pop{position:absolute;z-index:60;bottom:calc(100% + 14px);width:480px;cursor:pointer}.dp-wrap.is-above .dp-pop{left:50%;transform:translate(-50%)}.dp-wrap.is-above-start .dp-pop{left:-8px}.dp-pop:after{content:"";position:absolute;left:0;right:0;top:100%;height:16px}.dp-card{overflow:hidden;border-radius:18px;border:1px solid rgba(255,255,255,.08);background:radial-gradient(120% 70% at 50% -18%,rgba(153,104,223,.1),transparent 62%),#0a0c14f9;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 40px 110px #02040cad;transition:border-color var(--dur-fast)}.dp-pop:hover .dp-card{border-color:#c4a2ff57}.dp-media{position:relative;aspect-ratio:16 / 9;overflow:hidden;background:#07080d}.dp-media img,.dp-media video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;user-select:none;-webkit-user-select:none}.dp-tag{position:absolute;top:10px;left:10px;z-index:2;display:inline-flex;align-items:center;gap:5px;height:22px;padding:0 9px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;font-family:var(--font-sans);font-size:10.5px;font-weight:600;letter-spacing:.01em}.dp-body{padding:13px 16px 14px;font-family:var(--font-sans)}.dp-words b{display:block;font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.dp-words span{display:block;margin-top:3px;min-height:2.9em;font-size:12px;line-height:1.45;color:var(--fg-3)}.dp-foot{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:11px}.dp-dots{display:inline-flex;align-items:center;gap:5px}.dp-dots button{width:16px;height:4px;padding:0;border:0;border-radius:999px;overflow:hidden;background:#ffffff24;cursor:pointer;transition:width var(--dur-med) var(--ease-out-soft),background var(--dur-fast)}.dp-dots button:hover{background:#ffffff3d}.dp-dots button.on{width:30px}.dp-dots button i{display:block;width:0;height:100%;border-radius:inherit;background:var(--cv-accent-soft)}.dp-dots button.on i{animation:dpFill var(--d, 3.4s) linear forwards}@keyframes dpFill{to{width:100%}}.dp-cta{display:inline-flex;align-items:center;gap:3px;font-size:11.5px;font-weight:600;color:var(--cv-accent-text);white-space:nowrap}.dp-pop-enter-active,.dp-pop-leave-active{transition:opacity .22s var(--ease-out-soft),translate .22s var(--ease-out-soft),scale .22s var(--ease-out-soft)}.dp-pop-enter-from,.dp-pop-leave-to{opacity:0;translate:0 8px;scale:.98}.dp-slide-enter-active,.dp-slide-leave-active{transition:opacity .45s ease}.dp-slide-enter-from,.dp-slide-leave-to{opacity:0}.dp-words-enter-active,.dp-words-leave-active{transition:opacity .18s ease,translate .18s ease}.dp-words-enter-from{opacity:0;translate:0 4px}.dp-words-leave-to{opacity:0}@media(prefers-reduced-motion:reduce){.dp-pop-enter-active,.dp-pop-leave-active,.dp-slide-enter-active,.dp-slide-leave-active,.dp-words-enter-active,.dp-words-leave-active{transition:none}.dp-dots button.on i{animation:none;width:100%}}', xIe = '.cv-feedback{position:relative;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-feedback .licon{color:var(--fg-4);transition:color var(--dur-fast)}.cv-feedback:hover{background:#ffffff12;color:var(--fg-1)}.cv-feedback:hover .licon{color:var(--fg-2)}.cv-feedback-dot{position:absolute;top:-2px;right:-2px;width:7px;height:7px;border-radius:50%;background:var(--amethyst-700, #c2a4ec);box-shadow:0 0 0 2px #070910e6}.fb-flash{position:absolute;inset:0;z-index:130;pointer-events:none;background:#fff;opacity:0;animation:fbFlash .36s ease-out both}@keyframes fbFlash{0%{opacity:.38}to{opacity:0}}@media(prefers-reduced-motion:reduce){.fb-flash{animation:none}}.fb{position:absolute;inset:0;z-index:120;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}.fb-card{position:relative;width:min(1060px,100%);height:min(720px,100%);outline:none;display:flex;flex-direction:column;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}.fb-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.fb-head{flex:none;display:flex;align-items:center;gap:14px;padding:24px 30px 18px}.fb-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.fb-titles{flex:1;min-width:0}.fb-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.fb-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.fb-close{margin-left:auto;align-self:flex-start;flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.fb-close:hover{background:#ffffff17;color:var(--fg-1)}.fb-body{flex:1;min-height:0;display:grid;grid-template-columns:minmax(0,1fr) 344px;gap:24px;padding:0 30px}.fb-shots{min-width:0;min-height:0;display:flex;flex-direction:column;gap:12px}.fb-preview{position:relative;flex:1;min-height:0;display:flex;align-items:center;justify-content:center;overflow:hidden;border-radius:16px;border:1px solid var(--hairline-soft);background:var(--bg-deep)}.fb-preview img{display:block;max-width:100%;max-height:100%;object-fit:contain}.fb-preview-note{display:inline-flex;align-items:center;gap:8px;padding:0 24px;text-align:center;font-size:12.5px;color:var(--fg-4)}.fb-strip{flex:none;display:flex;align-items:center;gap:8px;overflow-x:auto;padding:2px 2px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.fb-thumb{position:relative;flex:none;width:104px;height:64px;border-radius:10px}.fb-thumb-pick{position:relative;width:100%;height:100%;padding:0;overflow:hidden;cursor:pointer;border:1.5px solid var(--hairline-soft);border-radius:10px;background:var(--bg-deep);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.fb-thumb-pick img{display:block;width:100%;height:100%;object-fit:cover}.fb-thumb.on .fb-thumb-pick{border-color:var(--cv-accent);box-shadow:0 0 0 3px var(--cv-accent-tint)}.fb-thumb-n{position:absolute;left:5px;top:5px;min-width:18px;height:18px;padding:0 5px;pointer-events:none;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;background:#04030cc7;color:var(--fg-1);font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums}.fb-thumb-x{position:absolute;right:4px;top:4px;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;opacity:0;border:0;border-radius:50%;background:#04030cd9;color:var(--fg-1);cursor:pointer;transition:opacity var(--dur-fast)}.fb-thumb:hover .fb-thumb-x,.fb-thumb:focus-within .fb-thumb-x{opacity:1}.fb-add{flex:none;width:128px;height:64px;padding:0 8px;display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;border:1.5px dashed rgba(255,255,255,.18);border-radius:10px;background:transparent;color:var(--fg-3);font-size:11.5px;font-weight:600;cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.fb-add:hover:not(:disabled){border-color:var(--cv-accent-soft);color:var(--fg-1);background:#ffffff08}.fb-add:disabled{opacity:.45;cursor:default}.fb-tip{flex:none;margin:-4px 2px 0;font-size:11.5px;color:var(--fg-4)}.fb-card.is-dropping{border-color:var(--cv-accent-soft);box-shadow:var(--inset-highlight),0 0 0 3px var(--cv-accent-tint),0 40px 120px #02040cb8}.fb-drop{position:absolute;inset:0;pointer-events:none;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;border:1.5px dashed var(--cv-accent-soft);border-radius:inherit;background:#0b0d15db;color:var(--fg-1);font-size:13px;font-weight:600}.fb-mk-bar{flex:none;display:flex;flex-wrap:wrap;align-items:center;gap:8px;min-width:0}.fb-mk-group{flex:none;display:inline-flex;gap:2px;padding:3px;border-radius:11px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.fb-mk-btn{position:relative;width:28px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.fb-mk-btn:hover:not(:disabled):not(.on){color:var(--fg-1);background:#ffffff0f}.fb-mk-btn.on{color:#fff;cursor:default;background:linear-gradient(180deg,#9968df75,#5a61ed57);box-shadow:inset 0 1px #ffffff29}.fb-mk-btn:disabled{opacity:.35;cursor:default}.fb-mk-swatch{width:26px}.fb-mk-swatch:before{content:"";width:14px;height:14px;border-radius:50%;background:var(--fb-swatch);box-shadow:inset 0 0 0 1px #ffffff47,0 0 0 1px #04030c66}.fb-mk-swatch.on{background:#ffffff14;box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.fb-mk-hint{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:right;font-size:11.5px;color:var(--fg-4)}.fb-mk{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}.fb-mk-stage{position:relative;flex:none;outline:none;cursor:crosshair;touch-action:none;user-select:none;-webkit-user-select:none}.fb-mk-stage.is-pin{cursor:copy}.fb-preview .fb-mk-stage img{width:100%;height:100%;pointer-events:none;-webkit-user-drag:none}.fb-form{min-width:0;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:14px;margin:0 -6px;padding:0 6px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.fb-seg{flex:none;display:grid;grid-template-columns:repeat(3,1fr);gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.fb-seg button{height:30px;display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;font-size:12px;font-weight:600;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.fb-seg button:hover:not(.is-on){color:var(--fg-1);background:#ffffff0d}.fb-seg button.is-on{color:#fff;cursor:default;background:linear-gradient(180deg,#9968df75,#5a61ed57);box-shadow:inset 0 1px #ffffff29,0 6px 16px #745aff42}.fb-field{flex:none;display:flex;flex-direction:column;gap:8px;min-width:0}.fb-label{font-size:12px;font-weight:600;color:var(--fg-2)}.fb-text{width:100%;box-sizing:border-box;min-height:84px;padding:10px 12px;resize:vertical;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;line-height:1.55;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast);user-select:text;-webkit-user-select:text}.fb-text.is-short{min-height:58px}.fb-text:focus{border-color:var(--cv-accent-soft);background:#ffffff0f}.fb-text::placeholder{color:var(--fg-4)}.fb-inc-box{flex:none;padding:4px 12px 6px;border:1px solid var(--hairline-soft);border-radius:14px;background:#ffffff05}.fb-inc-h{padding:8px 0 6px;font-size:10px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.fb-inc{display:flex;align-items:flex-start;gap:10px;padding:7px 0;border-top:1px solid var(--hairline-soft)}.fb-inc-what{flex:1;min-width:0;display:flex;align-items:flex-start;gap:9px;font-size:12.5px;color:var(--fg-2);cursor:pointer}.fb-inc-what.is-fixed{cursor:default}.fb-inc-what input{flex:none;width:15px;height:15px;margin:1px 0 0;accent-color:var(--cv-accent)}.fb-inc-what .licon{flex:none;width:15px;color:var(--success)}.fb-inc-what small{display:block;margin-top:2px;font-size:11px;color:var(--fg-4)}.fb-steps-pick{flex:none;display:inline-flex;padding:2px;gap:2px;border-radius:8px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.fb-steps-pick button{min-width:30px;height:22px;padding:0 7px;border:0;border-radius:6px;background:transparent;cursor:pointer;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;font-variant-numeric:tabular-nums}.fb-steps-pick button:hover:not(:disabled){color:var(--fg-1);background:#ffffff0f}.fb-steps-pick button.on{color:#fff;background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.fb-steps-pick button:disabled{opacity:.4;cursor:default}.fb-view{flex:none;padding:0;border:0;background:none;cursor:pointer;color:var(--vista-blue-500);font-family:var(--font-sans);font-size:11.5px;font-weight:600}.fb-view:hover{text-decoration:underline;text-underline-offset:3px}.fb-peek{margin:0 0 8px 24px;max-height:168px;overflow:auto;padding:8px 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:var(--bg-deep);font:11px/1.55 ui-monospace,SF Mono,Menlo,monospace;color:var(--fg-3);white-space:pre-wrap;overflow-wrap:anywhere;user-select:text;-webkit-user-select:text}.fb-foot{flex:none;display:flex;align-items:center;gap:10px;padding:18px 30px 24px}.fb-note{margin-right:auto;font-size:11.5px;color:var(--fg-4)}.fb-error{max-width:420px;font-size:12px;color:#ff8aa0}.fb-keys{font-size:11px;color:var(--fg-5);font-variant-numeric:tabular-nums}.fb-foot .bd-btn:disabled{opacity:.45;cursor:default;transform:none;filter:none}.fb-confirm{margin-right:auto;display:inline-flex;align-items:center;gap:10px;font-size:12.5px;color:var(--fg-2)}@media(max-width:860px){.fb-card{height:100%}.fb-mk-hint{display:none}.fb-body{grid-template-columns:minmax(0,1fr);overflow-y:auto}.fb-preview{flex:none;height:240px}.fb-form{overflow:visible}}.fb-aside{position:absolute;left:50%;top:72px;z-index:150;transform:translate(-50%);display:inline-flex;align-items:center;gap:10px;max-width:min(640px,calc(100vw - 32px));padding:5px 5px 5px 6px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:500;white-space:nowrap}.fb-aside-mark{flex:none;width:26px;height:26px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.fb-aside-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.fb-aside-count{flex:none;color:var(--fg-4);font-variant-numeric:tabular-nums}.fb-aside-btn{flex:none;height:26px;padding:0 12px;border:0;border-radius:999px;cursor:pointer;display:inline-flex;align-items:center;gap:6px;background:#ffffff14;color:var(--fg-1);font:inherit;font-weight:600;transition:background var(--dur-fast),filter var(--dur-fast)}.fb-aside-btn:hover:not(:disabled){background:#ffffff24}.fb-aside-btn.is-cta{background:var(--grad-cta)}.fb-aside-btn.is-cta:hover:not(:disabled){filter:brightness(1.08)}.fb-aside-btn:disabled{opacity:.5;cursor:default}.fb-aside-enter-active{transition:opacity .25s var(--ease-out-soft),transform .25s var(--ease-out-soft)}.fb-aside-leave-active{transition:opacity .18s ease,transform .18s ease}.fb-aside-enter-from,.fb-aside-leave-to{opacity:0;transform:translate(-50%) translateY(-6px)}', wIe = `.cv-root{--cm-unread: #d36be0;--cm-unread-glow: rgba(211, 107, 224, .45);--cm-card-bg: rgba(14, 16, 26, .97);--cm-raise: rgba(255, 255, 255, .05)}.cm-avatar{flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;color:#fff;font-weight:700;letter-spacing:.02em;line-height:1;box-shadow:inset 0 0 0 1px #ffffff2e,inset 0 1px #ffffff40;text-shadow:0 1px 2px rgba(10,6,30,.35);user-select:none}.cm-text{white-space:pre-wrap;word-wrap:break-word;overflow-wrap:anywhere}.cm-text.is-clamped{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.cm-text.is-big{font-size:30px;line-height:1.15;letter-spacing:.04em}.cm-mention{color:var(--amethyst-700);font-weight:600;border-radius:5px;padding:0 2px;margin:0 -1px;background:#9968df24}.cm-mention.is-me{color:#fff;background:linear-gradient(90deg,#c750ce6b,#9968df6b)}.cm-link{color:var(--vista-blue-500);text-decoration:underline;text-decoration-color:#a3a7f566;text-underline-offset:2px;word-break:break-all}.cm-link:hover{color:#fff;text-decoration-color:currentColor}.cv-stage.is-commenting,.cv-stage.is-commenting .cv-el,.cv-stage.is-commenting .cv-el *,.cv-stage.is-commenting .cv-frame-title{cursor:url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'><path d='M3 25V14a10 10 0 1 1 10 10z' fill='%239968df' stroke='white' stroke-width='2' stroke-linejoin='round'/><path d='M13 9.5v8M9 13.5h8' stroke='white' stroke-width='2.2' stroke-linecap='round'/></svg>") 3 25,crosshair}.cm-pins{position:absolute;left:0;top:0;width:0;height:0;z-index:1000000;pointer-events:none}.cm-pin-at{position:absolute;width:0;height:0}.cm-pin-at.is-open,.cm-pin-at:hover{z-index:2}.cm-pin{position:absolute;left:0;bottom:0;width:36px;height:36px;padding:3px;margin:0;transform-origin:0 100%;transform:scale(var(--cv-inv-zoom));border:0;border-radius:18px 18px 18px 4px;background:var(--thread, var(--amethyst-500));box-shadow:0 0 0 1.5px #ffffffeb,0 8px 22px #02040e80,0 2px 5px #02040e59;cursor:pointer;pointer-events:auto;touch-action:none;transition:box-shadow var(--dur-fast),filter var(--dur-fast);animation:cmPinIn .42s cubic-bezier(.34,1.56,.64,1) both}@keyframes cmPinIn{0%{opacity:0;scale:.3}to{opacity:1;scale:1}}.cm-pin-face{width:30px;height:30px;border-radius:15px 15px 15px 2px;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#0b0d14;transition:transform var(--dur-fast) var(--ease-out-soft)}.cm-pin-face .cm-avatar{width:30px!important;height:30px!important;border-radius:0;box-shadow:none;font-size:11px!important}.cm-pin:hover{filter:brightness(1.08);box-shadow:0 0 0 1.5px #fff,0 12px 28px #02040e8c,0 0 0 6px color-mix(in srgb,var(--thread) 26%,transparent)}.cm-pin:hover .cm-pin-face{transform:scale(1.04)}.cm-pin-at.is-open .cm-pin{box-shadow:0 0 0 2px #fff,0 0 0 7px color-mix(in srgb,var(--thread) 38%,transparent),0 12px 30px #02040e99}.cm-pin-at.is-dragging .cm-pin{cursor:grabbing;filter:brightness(1.1);box-shadow:0 0 0 2px #fff,0 20px 40px #02040e99;animation:none}.cm-pin-at.is-resolved .cm-pin{opacity:.86}.cm-pin-check{display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#fff;background:var(--thread)}.cm-pin-count{position:absolute;right:-9px;bottom:-5px;min-width:18px;height:18px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:#0b0d14;color:#fff;font-size:10px;font-weight:700;font-variant-numeric:tabular-nums;line-height:1;box-shadow:0 0 0 1.5px var(--thread),0 3px 8px #0006}.cm-pin-dot{position:absolute;right:-3px;top:-3px;width:12px;height:12px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #fff,0 0 12px var(--cm-unread-glow)}.cm-pin-dot:after{content:"";position:absolute;inset:-2px;border-radius:50%;border:2px solid var(--cm-unread);animation:cmPulse 1.8s var(--ease-out-soft) infinite}@keyframes cmPulse{0%{opacity:.85;transform:scale(1)}to{opacity:0;transform:scale(2.4)}}.cm-pin.is-flash{animation:cmPinFlash .9s cubic-bezier(.34,1.56,.64,1) both}@keyframes cmPinFlash{0%{scale:1;rotate:0deg}30%{scale:1.28;rotate:-4deg}60%{scale:.94;rotate:2deg}to{scale:1;rotate:0deg}}.cm-pin.is-flash:before{content:"";position:absolute;inset:-4px;border-radius:inherit;border:2px solid var(--thread);animation:cmRipple .9s var(--ease-out-soft) both;pointer-events:none}@keyframes cmRipple{0%{opacity:.9;transform:scale(1)}to{opacity:0;transform:scale(2)}}.cm-pin.is-draft{cursor:default;pointer-events:none;background:transparent;padding:1px;border:2px dashed rgba(255,255,255,.85);box-shadow:0 8px 22px #02040e80;animation:cmPinIn .42s cubic-bezier(.34,1.56,.64,1) both,cmDraft 1.6s ease-in-out .42s infinite}.cm-pin.is-draft .cm-pin-face{width:30px;height:30px}@keyframes cmDraft{50%{box-shadow:0 0 0 6px #9968df47,0 8px 22px #02040e80}}.cm-peek{position:absolute;left:0;bottom:0;width:260px;padding:11px 13px 12px;transform-origin:0 100%;transform:scale(var(--cv-inv-zoom)) translate(46px,6px);border-radius:14px;background:var(--cm-card-bg);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 20px 50px #02040e99;color:var(--fg-2);font-size:12.5px;line-height:1.45;pointer-events:none;animation:cmPeekIn var(--dur-fast) var(--ease-out-soft) both}@keyframes cmPeekIn{0%{opacity:0;margin-left:-6px}to{opacity:1;margin-left:0}}.cm-peek-head{display:flex;align-items:baseline;gap:8px;margin-bottom:4px}.cm-peek-head b{color:var(--fg-1);font-size:12.5px;font-weight:600}.cm-peek-head span{font-size:11px;color:var(--fg-4)}.cm-peek-foot{margin-top:7px;font-size:11px;color:var(--fg-4)}.cm-peek-foot em{font-style:normal;color:var(--cm-unread);font-weight:600}.cm-cards{position:absolute;inset:0;z-index:44;pointer-events:none;overflow:hidden}.cm-card{position:absolute;left:0;top:0;width:344px;max-height:calc(100vh - 140px);display:flex;flex-direction:column;pointer-events:auto;border-radius:18px;background:var(--cm-card-bg);border:1px solid var(--hairline);backdrop-filter:blur(28px) saturate(120%);-webkit-backdrop-filter:blur(28px) saturate(120%);box-shadow:var(--inset-highlight),0 0 0 1px #00000040,0 30px 80px #02040e9e;color:var(--fg-2);font-size:13px;user-select:text;-webkit-user-select:text;animation:cmCardIn .28s var(--ease-out-soft) both}.cm-card:before{content:"";position:absolute;left:16px;right:16px;top:-1px;height:2px;border-radius:0 0 2px 2px;background:linear-gradient(90deg,transparent,var(--thread),transparent);opacity:.85;pointer-events:none}@keyframes cmCardIn{0%{opacity:0;scale:.96}to{opacity:1;scale:1}}.cm-card.is-away{visibility:hidden}.cm-card.is-pinned{box-shadow:var(--inset-highlight),0 0 0 1px color-mix(in srgb,var(--thread) 40%,transparent),0 24px 60px #02040e80}.cm-card-head{flex:none;display:flex;align-items:center;gap:4px;padding:9px 9px 7px 12px}.cm-grow{flex:1}.cm-icon{flex:none;position:relative;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cm-icon:hover{background:#ffffff14;color:var(--fg-1)}.cm-icon.on{color:var(--amethyst-700)}.cm-nav{flex:none;display:inline-flex;align-items:center;gap:0;margin:-2px -4px -2px 0;padding:0 2px;border-radius:9px;background:#ffffff0a}.cm-nav .cm-icon{width:22px;height:22px}.cm-nav-n{min-width:40px;text-align:center;font-size:11px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums;white-space:nowrap}.cm-dots{display:inline-flex;align-items:center;gap:3px}.cm-dot{width:18px;height:18px;padding:0;border:0;border-radius:50%;background:transparent;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative}.cm-dot:after{content:"";width:10px;height:10px;border-radius:50%;background:var(--c);transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cm-dot:hover:after{transform:scale(1.25)}.cm-dot.on:after{box-shadow:0 0 0 2px var(--cm-card-bg),0 0 0 3.5px var(--c)}.cm-resolve{flex:none;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px 0 8px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cm-resolve:hover{background:#37d3991f;border-color:#37d39966;color:#fff}.cm-resolve:hover .licon{color:var(--success)}.cm-resolve.on{background:#37d39929;border-color:#37d39973;color:#c9f5e4}.cm-resolve.on .licon{color:var(--success);animation:cmTick .5s cubic-bezier(.34,1.56,.64,1)}@keyframes cmTick{0%{transform:scale(.4) rotate(-30deg)}to{transform:none}}.cm-card-menu-wrap{position:relative;display:inline-flex}.cm-card-menu{position:absolute;right:-4px;top:calc(100% + 6px);z-index:5;min-width:220px;display:flex;flex-direction:column;padding:5px;border:1px solid var(--hairline);border-radius:13px;background:#131521fa;box-shadow:var(--inset-highlight),0 20px 50px #02040e99;animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}.cm-card-menu>button{display:flex;align-items:center;flex-wrap:wrap;column-gap:10px;width:100%;padding:8px 10px;text-align:left;border:0;border-radius:8px;background:transparent;color:var(--fg-1);cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:500;white-space:nowrap}.cm-card-menu>button small{flex-basis:100%;padding-left:24px;font-size:11px;color:var(--fg-4);font-weight:400}.cm-card-menu>button .licon{color:var(--fg-3)}.cm-card-menu>button:hover:not(:disabled){background:#ffffff12}.cm-card-menu>button:hover .licon{color:var(--fg-1)}.cm-card-menu>button:disabled{opacity:.4;cursor:default}.cm-card-menu>button.is-danger{color:#ff9eb0}.cm-card-menu>button.is-danger .licon{color:#ff7f98}.cm-card-menu>button.is-danger:hover{background:#ff5c7a1f}.cm-card-menu-sep{height:1px;margin:4px 6px;background:var(--hairline-soft)}.cm-card-menu kbd{margin-left:6px;padding:1px 5px;border-radius:5px;border:1px solid var(--hairline);font-family:var(--font-sans);font-size:10.5px;color:var(--fg-4)}.cm-switch{position:relative;margin-left:auto;width:28px;height:16px;border-radius:999px;background:#ffffff24;transition:background var(--dur-fast)}.cm-switch:after{content:"";position:absolute;left:2px;top:2px;width:12px;height:12px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #0006;transition:transform var(--dur-fast) var(--ease-out-soft)}.cm-switch.on{background:var(--cv-accent)}.cm-switch.on:after{transform:translate(12px)}.cm-strip{flex:none;display:flex;align-items:center;gap:8px;min-height:22px;padding:0 14px 8px}.cm-on{min-width:0;display:inline-flex;align-items:center;gap:5px;max-width:100%;height:20px;padding:0 8px 0 6px;border-radius:6px;background:#ffffff0d;color:var(--fg-3);font-size:11px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-on.is-inline{flex:0 1 auto;margin-left:2px}.cm-resolved-note{display:inline-flex;align-items:center;gap:4px;font-size:11px;font-weight:600;color:var(--success)}.cm-list{flex:1 1 auto;min-height:0;max-height:380px;overflow-y:auto;padding:2px 6px 4px;border-top:1px solid var(--hairline-soft);scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-reply{flex:none;padding:8px 10px 10px;border-top:1px solid var(--hairline-soft)}.cm-card.is-resolved .cm-list{opacity:.8}.cm-draft-head{display:flex;align-items:center;gap:9px;padding:10px 9px 8px 12px}.cm-draft-title{font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap}.cm-card.is-draft{width:336px}.cm-card.is-draft .cm-compose{margin:0 10px 10px}.cm-row{position:relative;display:flex;gap:10px;padding:10px 8px;border-radius:12px;animation:cmRowIn .32s var(--ease-out-soft) both;transition:background var(--dur-fast)}@keyframes cmRowIn{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.cm-row:hover{background:#ffffff09}.cm-row-main{flex:1;min-width:0}.cm-row-head{display:flex;align-items:baseline;gap:7px;margin-bottom:3px;padding-right:64px}.cm-row.is-editing .cm-row-head{padding-right:0}.cm-row-name{color:var(--fg-1);font-size:12.5px;font-weight:600;letter-spacing:-.005em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-row-time{flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap}.cm-row-edited{flex:none;font-size:10.5px;color:var(--fg-5);font-style:italic}.cm-row-text{display:block;color:#ffffffdb;font-size:13px;line-height:1.5}.cm-row-acts{position:absolute;right:6px;top:6px;display:flex;gap:1px;padding:2px;border-radius:9px;background:#181b29fa;border:1px solid var(--hairline);box-shadow:0 6px 16px #0006;opacity:0;transform:translateY(2px);pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cm-row:hover .cm-row-acts,.cm-row:focus-within .cm-row-acts{opacity:1;transform:none;pointer-events:auto}.cm-row-acts button{width:26px;height:24px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-3);cursor:pointer}.cm-row-acts button:hover{background:#ffffff17;color:var(--fg-1)}.cm-reactions{display:flex;flex-wrap:wrap;gap:5px;margin-top:7px}.cm-chip{display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 8px 0 6px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cm-chip .e{font-size:14px;line-height:1}.cm-chip .n{font-variant-numeric:tabular-nums}.cm-chip:hover{background:#ffffff14;border-color:#ffffff2e;transform:translateY(-1px)}.cm-chip:active{transform:scale(.94)}.cm-chip.mine{background:#9968df33;border-color:#ae86e599;color:#fff}.cm-chip.is-add{padding:0 7px;color:var(--fg-4);opacity:0}.cm-row:hover .cm-chip.is-add{opacity:1}.cm-compose{position:relative;display:flex;align-items:flex-end;gap:6px;padding:6px 6px 6px 12px;border:1px solid var(--hairline);border-radius:14px;background:#ffffff0b;transition:border-color var(--dur-fast),background var(--dur-fast),box-shadow var(--dur-fast)}.cm-compose:focus-within{border-color:var(--cv-accent-soft);background:#ffffff0f;box-shadow:0 0 0 3px #9968df1f}.cm-compose.is-nod{animation:cmNod .42s cubic-bezier(.36,.07,.19,.97) both}@keyframes cmNod{20%,60%{transform:translate(-5px)}40%,80%{transform:translate(5px)}}.cm-compose-box{flex:1;min-width:0;min-height:22px;max-height:168px;padding:4px 0;resize:none;overflow-y:auto;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;line-height:1.45;user-select:text;-webkit-user-select:text}.cm-compose-box::placeholder{color:var(--fg-4)}.cm-compose-tools{flex:none;display:flex;align-items:center;gap:2px}.cm-tool{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cm-tool:hover,.cm-tool.on{background:#ffffff14;color:var(--fg-1)}.cm-send{width:28px;height:28px;padding:0;margin-left:2px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:#ffffff14;color:var(--fg-4);cursor:default;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cm-compose.can-send .cm-send{background:var(--grad-cta);color:#fff;cursor:pointer;box-shadow:0 6px 16px #785ae673}.cm-compose.can-send .cm-send:hover{transform:translateY(-1px)}.cm-compose.can-send .cm-send:active{transform:scale(.92)}.cm-compose.is-editing{flex-direction:column;align-items:stretch;padding:6px 6px 6px 10px;margin-top:2px}.cm-compose.is-editing .cm-compose-tools{justify-content:flex-end;gap:6px}.cm-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:32px;padding:0 14px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:600;box-shadow:0 8px 20px #785ae659;transition:transform var(--dur-fast) var(--ease-out-soft),opacity var(--dur-fast)}.cm-btn:hover{transform:translateY(-1px)}.cm-btn:disabled{opacity:.4;cursor:default;transform:none}.cm-btn.is-sm{height:26px;padding:0 12px;font-size:12px}.cm-btn.is-ghost{background:#ffffff0f;color:var(--fg-2);box-shadow:none;border:1px solid var(--hairline)}.cm-btn.is-ghost:hover{background:#ffffff1a;color:#fff}.cm-portal{position:absolute;inset:0;z-index:140;pointer-events:none}.cm-portal>*{pointer-events:auto}.cm-menu{position:absolute;left:-1px;right:-1px;top:calc(100% + 6px);z-index:10;min-width:260px;max-height:300px;overflow-y:auto;padding:5px;border:1px solid var(--hairline);border-radius:13px;background:#131521fa;box-shadow:var(--inset-highlight),0 24px 60px #02040ea6;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}.cm-menu.is-up{top:auto;bottom:calc(100% + 6px)}.cm-menu-row{display:flex;align-items:center;gap:10px;width:100%;padding:6px 8px;text-align:left;border:0;border-radius:9px;background:transparent;color:var(--fg-1);cursor:pointer;font-family:var(--font-sans)}.cm-menu-row.on{background:#9968df2e}.cm-menu-text{min-width:0;display:flex;flex-direction:column;gap:1px}.cm-menu-text b{font-size:12.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-menu-text b i{font-style:normal;font-weight:500;color:var(--fg-4)}.cm-menu-text small{font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-menu-group{width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:var(--fg-2);flex:none}.cm-menu-emoji{width:24px;text-align:center;font-size:18px;line-height:1;flex:none}.cm-menu-alone{padding:10px;font-size:12px;line-height:1.45;color:var(--fg-3);max-width:300px}.cm-emoji{position:absolute;width:340px;height:392px;display:flex;flex-direction:column;border:1px solid var(--hairline);border-radius:16px;background:#11131efb;box-shadow:var(--inset-highlight),0 30px 80px #02040eb3;backdrop-filter:blur(28px);-webkit-backdrop-filter:blur(28px);animation:cmCardIn .22s var(--ease-out-soft) both;overflow:hidden;user-select:none}.cm-emoji-head{flex:none;display:flex;align-items:center;gap:6px;padding:10px 10px 6px}.cm-emoji-search{flex:1;min-width:0;display:flex;align-items:center;gap:7px;height:32px;padding:0 8px 0 10px;border:1px solid var(--hairline);border-radius:10px;background:#ffffff0d;color:var(--fg-4)}.cm-emoji-search:focus-within{border-color:var(--cv-accent-soft);color:var(--fg-2)}.cm-emoji-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.cm-emoji-search input::placeholder{color:var(--fg-4)}.cm-emoji-clear{width:20px;height:20px;padding:0;border:0;border-radius:6px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.cm-emoji-clear:hover{color:var(--fg-1);background:#ffffff14}.cm-emoji-tone{flex:none;display:flex;gap:1px;padding:2px;border-radius:10px}.cm-emoji-tone.open{background:#ffffff0d}.cm-emoji-tonebtn{width:28px;height:28px;padding:0;border:0;border-radius:8px;background:transparent;font-size:17px;line-height:1;cursor:pointer}.cm-emoji-tonebtn:hover,.cm-emoji-tonebtn.on{background:#ffffff1a}.cm-emoji-quick{flex:none;display:flex;justify-content:space-between;padding:2px 10px 6px}.cm-emo{width:36px;height:36px;padding:0;border:0;border-radius:9px;background:transparent;cursor:pointer;font-size:22px;line-height:1;font-family:"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif;transition:background var(--dur-fast),transform .12s var(--ease-out-soft)}.cm-emo:hover{background:#ffffff1a;transform:scale(1.14)}.cm-emo:active{transform:scale(.9)}.cm-emo.is-quick{width:36px;height:36px;font-size:22px;background:#ffffff0a}.cm-emoji-tabs{flex:none;display:flex;justify-content:space-between;padding:0 8px 4px;border-bottom:1px solid var(--hairline-soft)}.cm-emoji-tabs button{position:relative;width:32px;height:30px;padding:0;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:color var(--dur-fast),background var(--dur-fast)}.cm-emoji-tabs button:hover{color:var(--fg-1);background:#ffffff0f}.cm-emoji-tabs button.on{color:#fff}.cm-emoji-tabs button.on:after{content:"";position:absolute;left:8px;right:8px;bottom:-5px;height:2px;border-radius:2px;background:var(--grad-purple-pink)}.cm-emoji-body{flex:1;min-height:0;overflow-y:auto;padding:4px 8px 6px;scroll-behavior:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-emoji-sec{content-visibility:auto;contain-intrinsic-size:auto 360px}.cm-emoji-label{position:sticky;top:-4px;z-index:1;display:flex;align-items:center;justify-content:space-between;padding:8px 4px 4px;background:#11131efb;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.cm-emoji-clearrecent{border:0;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:10.5px;font-weight:600;letter-spacing:0;text-transform:none;cursor:pointer;padding:0 2px}.cm-emoji-clearrecent:hover{color:var(--fg-1)}.cm-emoji-grid{display:grid;grid-template-columns:repeat(8,36px);justify-content:space-between;row-gap:1px}.cm-emoji-none{padding:40px 12px;text-align:center;font-size:12.5px;color:var(--fg-4)}.cm-emoji-foot{flex:none;display:flex;align-items:center;gap:9px;height:44px;padding:0 12px;border-top:1px solid var(--hairline-soft);background:#ffffff05}.cm-emoji-big{font-size:24px;line-height:1}.cm-emoji-name{flex:1;min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-emoji-name:first-letter{text-transform:uppercase}.cm-emoji-code{flex:none;font-size:11px;color:var(--fg-4)}.cm-emoji-hint{font-size:11.5px;color:var(--fg-4)}.cm-panel{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:340px;display:flex;flex-direction:column;border-radius:18px;background:#0b0d15f7;border:1px solid var(--hairline);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;animation:histIn .26s var(--ease-out-soft) both;user-select:none}.cm-panel-head{flex:none;display:flex;align-items:center;gap:2px;padding:12px 10px 6px 16px}.cm-panel-title{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.cm-panel-settings-wrap{position:relative;display:inline-flex}.cm-card-menu.is-settings{width:268px}.cm-card-menu.is-settings>button{flex-wrap:nowrap}.cm-tabs{flex:none;display:grid;grid-template-columns:1fr 1fr;gap:2px;margin:4px 12px 8px;padding:3px;border-radius:11px;background:#ffffff0b;border:1px solid var(--hairline-soft)}.cm-tabs button{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:30px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;font-family:var(--font-sans);font-size:12px;font-weight:600;white-space:nowrap;transition:background var(--dur-fast),color var(--dur-fast)}.cm-tabs button:hover{color:var(--fg-1)}.cm-tabs button.on{background:#ffffff17;color:#fff;box-shadow:var(--inset-highlight),0 2px 8px #00000040}.cm-count{min-width:17px;height:17px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--cm-unread);color:#fff;font-size:10px;font-weight:700;font-variant-numeric:tabular-nums;box-shadow:0 0 10px var(--cm-unread-glow)}.cm-tools{flex:none;display:flex;flex-direction:column;gap:8px;padding:0 12px 10px;border-bottom:1px solid var(--hairline-soft)}.cm-tools.is-elsewhere{flex-direction:row;align-items:center}.cm-search{display:flex;align-items:center;gap:7px;height:32px;padding:0 8px 0 10px;border:1px solid var(--hairline);border-radius:10px;background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast)}.cm-search:focus-within{border-color:var(--cv-accent-soft);color:var(--fg-2)}.cm-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.cm-search input::placeholder{color:var(--fg-4)}.cm-search-clear{width:20px;height:20px;padding:0;border:0;border-radius:6px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.cm-search-clear:hover{color:var(--fg-1);background:#ffffff14}.cm-chips{display:flex;gap:5px;flex-wrap:wrap}.cm-fchip{display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 10px;border:1px solid var(--hairline);border-radius:999px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cm-fchip:hover{color:var(--fg-1);border-color:#fff3}.cm-fchip.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.cm-fchip .n{font-size:10px;color:var(--cm-unread);font-variant-numeric:tabular-nums}.cm-fchip.on .n{color:#f3c8f7}.cm-linkbtn{border:0;background:transparent;padding:0;color:var(--amethyst-700);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;white-space:nowrap}.cm-linkbtn:hover:not(:disabled){color:#fff}.cm-linkbtn:disabled{color:var(--fg-5);cursor:default}.cm-linkbtn.is-sm{font-size:11px}.cm-feed{flex:1;min-height:0;overflow-y:auto;padding:8px 8px 12px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-feed-label{display:flex;align-items:center;gap:6px;padding:6px 8px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.cm-feed-empty{display:flex;flex-direction:column;align-items:center;gap:8px;padding:46px 22px;text-align:center;font-size:12.5px;line-height:1.5;color:var(--fg-4)}.cm-feed-empty b{font-size:13.5px;color:var(--fg-1);font-weight:600}.cm-feed-empty kbd{padding:1px 6px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:11px}.cm-feed-empty .cm-btn{margin-top:8px}.cm-empty-mark{width:42px;height:42px;border-radius:14px;display:inline-flex;align-items:center;justify-content:center;margin-bottom:4px;background:linear-gradient(140deg,#9968df47,#5a61ed33);color:#fff;box-shadow:inset 0 0 0 1px #ffffff1f,0 10px 30px #785ae640}.cm-empty-mark.is-error{background:#ff5c7a24;color:#ff9eb0}.cm-item{position:relative;display:flex;gap:10px;padding:11px 10px 11px 14px;margin-bottom:4px;border-radius:13px;border:1px solid transparent;cursor:pointer;outline:none;transition:background var(--dur-fast),border-color var(--dur-fast)}.cm-item:before{content:"";position:absolute;left:4px;top:14px;bottom:14px;width:3px;border-radius:3px;background:var(--thread);opacity:.55}.cm-item:hover,.cm-item:focus-visible{background:#ffffff0d;border-color:var(--hairline-soft)}.cm-item.is-open{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.cm-item.is-unread{background:#d36be00f}.cm-item.is-unread:hover{background:#d36be01a}.cm-item.is-resolved{opacity:.62}.cm-item.is-resolved:hover{opacity:.9}.cm-item-dot{position:absolute;left:-1px;top:18px;width:8px;height:8px;border-radius:50%;z-index:1;background:var(--cm-unread);box-shadow:0 0 0 2px #0b0d15f7,0 0 10px var(--cm-unread-glow)}.cm-item-main{flex:1;min-width:0}.cm-item-head{display:flex;align-items:baseline;gap:8px;margin-bottom:3px}.cm-item-head b{min-width:0;color:var(--fg-1);font-size:12.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-item-time{margin-left:auto;flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap;transition:opacity var(--dur-fast)}.cm-item-text{color:var(--fg-2);font-size:12.5px;line-height:1.45}.cm-item.is-unread .cm-item-text{color:#ffffffe6}.cm-item-on{display:flex;align-items:center;gap:6px;margin-top:7px;min-width:0}.cm-item-thumb{flex:none;width:22px;height:22px;border-radius:6px;background-size:cover;background-position:center;background-repeat:no-repeat;box-shadow:inset 0 0 0 1px #ffffff1f}.cm-item-on-label{min-width:0;font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-item-foot{display:flex;align-items:center;gap:10px;margin-top:7px;font-size:11px;color:var(--fg-4)}.cm-item-foot>span{display:inline-flex;align-items:center;gap:4px}.cm-replies{display:flex;flex-direction:column;align-items:stretch;gap:8px;margin-top:9px;padding-left:11px;border-left:2px solid rgba(255,255,255,.08)}.cm-replies.is-all{gap:9px}.cm-replies-more{align-self:flex-start;padding:0;border:0;background:transparent;cursor:pointer;color:var(--amethyst-700);font-family:var(--font-sans);font-size:11.5px;font-weight:600;transition:color var(--dur-fast)}.cm-replies-more:hover{color:#fff}.cm-replies-more.is-new{color:var(--cm-unread)}.cm-replies-failed{font-size:11.5px;color:var(--fg-4)}.cm-reply-row{position:relative;display:flex;gap:8px}.cm-reply-row.is-new:before{content:"";position:absolute;left:-16px;top:7px;width:6px;height:6px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #0b0d15f7,0 0 8px var(--cm-unread-glow)}.cm-reply-main{flex:1;min-width:0}.cm-reply-head{display:flex;align-items:baseline;gap:6px;margin-bottom:1px;min-width:0}.cm-reply-head b{min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-reply-head span{flex:none;font-size:10.5px;color:var(--fg-4)}.cm-reply-head i{flex:none;font-style:normal;font-size:9.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--cm-unread)}.cm-reply-text{display:block;font-size:12px;line-height:1.45;color:var(--fg-2)}.cm-item.is-unread .cm-reply-row.is-new .cm-reply-text{color:#ffffffe0}.cm-item-resolved{color:var(--success);font-weight:600}.cm-item-open{margin-left:auto;color:var(--fg-4);opacity:0;transition:opacity var(--dur-fast)}.cm-item:hover .cm-item-open{opacity:1;color:var(--amethyst-700)}.cm-item-acts{position:absolute;right:8px;top:5px;display:flex;gap:1px;padding:2px;border-radius:9px;background:#181b29fa;border:1px solid var(--hairline);box-shadow:0 6px 16px #0006;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.cm-item:hover .cm-item-acts,.cm-item:focus-within .cm-item-acts{opacity:1;pointer-events:auto}.cm-item:hover .cm-item-time{opacity:0}.cm-item-acts>button,.cm-item-menu-wrap>button{width:26px;height:22px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-3);cursor:pointer}.cm-item-acts>button:hover,.cm-item-acts>button.on,.cm-item-menu-wrap>button:hover,.cm-item-menu-wrap>button.on{background:#ffffff17;color:var(--fg-1)}.cm-item-acts>button.is-resolve.on .licon{color:var(--success)}.cm-item-menu-wrap{position:relative;display:inline-flex}.cm-card-menu.is-item{right:-6px;min-width:200px}.cm-card-menu.is-item.is-up{top:auto;bottom:calc(100% + 6px)}.cm-board-group{margin-bottom:10px}.cm-board-head{display:flex;align-items:center;gap:7px;padding:8px 8px 6px;color:var(--fg-3)}.cm-board-title{min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-board-n{flex:none;padding:1px 6px;border-radius:999px;background:#ffffff0f;font-size:10px;font-weight:600;color:var(--fg-3)}.bd-siderail-btn .badge.is-unread{background:var(--cm-unread);box-shadow:0 0 0 2px #121521f2,0 0 12px var(--cm-unread-glow)}.cm-rail-dot{position:absolute;right:6px;top:6px;width:8px;height:8px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #121521f2;pointer-events:none}.v2-root.light-canvas .cm-pin{box-shadow:0 0 0 1.5px #fff,0 8px 22px #13182840,0 2px 5px #13182833}@media(prefers-reduced-motion:reduce){.cm-pin,.cm-card,.cm-row,.cm-peek,.cm-emoji,.cm-pin-dot:after{animation:none!important}}.cm-ask{position:absolute;inset:0;z-index:150;display:flex;align-items:center;justify-content:center;background:#04030c6b}.cm-ask-card{display:flex;align-items:center;gap:14px;width:min(560px,calc(100% - 40px));padding:14px 14px 14px 16px;border-radius:16px;background:#10111cfa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040cb3}.cm-ask-card .ic{flex:none;width:34px;height:34px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:#ff5c7a24;color:#ff8aa0}.cm-ask-card .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.cm-ask-card .tx b{font-size:13.5px;font-weight:600;color:#fff}.cm-ask-card .tx span{font-size:11.5px;line-height:1.45;color:var(--fg-3)}.cm-ask-card .acts{flex:none;display:flex;gap:8px}.cm-ask-btn{height:34px;padding:0 14px;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font:inherit;font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.cm-ask-btn:hover{background:#ffffff17}.cm-ask-btn:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.cm-ask-btn.is-danger{border-color:#ff5c7a80;background:#ff5c7a29;color:#ffb3c1}.cm-ask-btn.is-danger:hover{background:#ff5c7a42;color:#fff}.cm-ask-enter-active,.cm-ask-leave-active{transition:opacity .2s ease}.cm-ask-enter-active .cm-ask-card,.cm-ask-leave-active .cm-ask-card{transition:transform .3s var(--ease-out-soft),opacity .2s ease}.cm-ask-enter-from,.cm-ask-leave-to{opacity:0}.cm-ask-enter-from .cm-ask-card{transform:translateY(10px) scale(.98)}`, kIe = '.cv-el.is-chat .cv-el-body{height:100%}.cv-el.is-chat .cv-bucket{height:100%;display:flex;flex-direction:column}.cv-el.is-chat .cv-bucket-foot{margin-top:auto}.ch-card{background:linear-gradient(180deg,rgba(153,104,223,calc(.17 * var(--cv-glass-a))),rgba(153,104,223,calc(.06 * var(--cv-glass-a))));border-color:#c2a4ec38}.ch-card.is-live{border-color:#c2a4ec8c;box-shadow:var(--inset-highlight),0 0 0 calc(3px * var(--cv-inv-zoom)) #9968df29,var(--shadow-card)}.ch-badge{background:linear-gradient(135deg,#9968df8c,#5a61ed6b);color:#fff;box-shadow:inset 0 1px #ffffff2e}.ch-card .cv-bucket-model{color:var(--amethyst-700);opacity:.8}.ch-card-last{margin-top:12px;font-size:12px;line-height:1.45;color:var(--fg-2);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;word-break:break-word}.ch-card-last b{color:var(--fg-1);font-weight:600}.ch-card-last.is-empty{color:var(--fg-4)}.ch-card-state{display:inline-flex;align-items:center;gap:6px;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-card-state.is-busy{color:var(--amethyst-700);font-weight:600}.ch-pulse{width:6px;height:6px;flex:none;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 #ae86e599}@media(prefers-reduced-motion:no-preference){.ch-pulse{animation:chPulse 1.4s var(--ease-out-soft) infinite}@keyframes chPulse{0%{box-shadow:0 0 #ae86e599}70%{box-shadow:0 0 0 7px #ae86e500}to{box-shadow:0 0 #ae86e500}}}.v2-root.light-canvas .ch-card{background:#fff;border-color:#7532d342}.v2-root.light-canvas .ch-card-last{color:var(--lc-ink-2)}.v2-root.light-canvas .ch-card-last b{color:var(--lc-ink)}.v2-root.light-canvas .ch-card-state.is-busy,.v2-root.light-canvas .ch-card .cv-bucket-model{color:var(--amethyst-400)}.cv-frame-glow{position:absolute;pointer-events:none;z-index:3;border-radius:24px;box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #c2a4ecd9,0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df29,0 0 calc(70px * var(--cv-inv-zoom)) calc(6px * var(--cv-inv-zoom)) #8f72ff47}.cv-pick-glow{border-radius:10px}@media(prefers-reduced-motion:no-preference){.cv-frame-glow{animation:chGlowIn .5s var(--ease-out-soft) both}.cv-frame-glow.is-working{animation:chGlowIn .5s var(--ease-out-soft) both,chBreathe 2.2s ease-in-out .5s infinite}@keyframes chGlowIn{0%{opacity:0}to{opacity:1}}@keyframes chBreathe{0%,to{opacity:1}50%{opacity:.55}}}.v2-root.light-canvas .cv-frame-glow{box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #7532d3bf,0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df29,0 0 calc(60px * var(--cv-inv-zoom)) calc(4px * var(--cv-inv-zoom)) #7532d32e}.v2-root.chat-open .v2-uprompt{right:calc(var(--set-w) + 464px)}.cv-ctxbar .cv-ctx-info.is-chat .licon{color:var(--amethyst-700)}.ch-panel{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:380px;display:flex;flex-direction:column;overflow:hidden;background:#090b13f0;backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);border:1px solid var(--hairline);border-radius:20px;box-shadow:var(--inset-highlight),var(--shadow-deep);pointer-events:auto;animation:histIn .26s var(--ease-out-soft) both;font-family:var(--font-sans)}.ch-head{flex:none;display:flex;align-items:center;gap:10px;padding:13px 12px 11px 14px;border-bottom:1px solid var(--hairline-soft)}.ch-head-mark{width:30px;height:30px;flex:none;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:inset 0 1px #fff3,0 6px 18px #745aff4d}.ch-head-titles{flex:1;min-width:0}.ch-head-name{display:inline-flex;align-items:center;gap:4px;max-width:100%;padding:0;border:0;background:transparent;cursor:default;font-family:var(--font-sans);font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ch-head-name .t{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-head-name.has-more{cursor:pointer}.ch-head-name.has-more .licon{color:var(--fg-4);transition:color var(--dur-fast)}.ch-head-name.has-more:hover .licon{color:var(--fg-1)}.ch-switch{position:relative}.ch-switch-menu{position:absolute;left:-6px;top:calc(100% + 8px);z-index:5;width:280px;max-height:320px;overflow-y:auto;display:flex;flex-direction:column;gap:2px;padding:6px;border-radius:14px;background:#121217fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3;animation:histIn .18s var(--ease-out-soft) both}.ch-switch-eyebrow{padding:4px 8px 6px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.18em;color:var(--fg-5)}.ch-switch-row{display:flex;align-items:center;gap:9px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast)}.ch-switch-row:hover{background:#ffffff0f}.ch-switch-row.on{background:var(--cv-accent-tint)}.ch-switch-row>.licon{flex:none;color:var(--amethyst-700)}.ch-switch-row .m{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.ch-switch-row .n{font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-switch-row .f{font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-switch-row .c{flex:none;font-size:10px;font-weight:600;color:var(--fg-4);background:#ffffff0f;border-radius:999px;padding:2px 7px;font-variant-numeric:tabular-nums}.ch-head-sub{display:flex;align-items:center;gap:5px;margin-top:2px;font-size:11px;color:var(--fg-4);min-width:0}.ch-head-frame{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--fg-3)}.ch-head-sub .dot{color:var(--fg-5)}.ch-head-n{flex:none;color:var(--amethyst-700);font-weight:600}.ch-iconbtn{flex:none;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ch-iconbtn:hover{background:#ffffff17;color:var(--fg-1)}.ch-context{flex:none;display:flex;flex-wrap:wrap;gap:5px;padding:9px 14px 10px;border-bottom:1px solid var(--hairline-soft)}.ch-context.is-none{font-size:11px;line-height:1.45;color:var(--fg-4)}.ch-ctxchip{display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 9px;border-radius:999px;border:1px solid rgba(194,164,236,.22);background:#9968df1a;color:var(--amethyst-800);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ch-ctxchip:hover{background:#9968df33;border-color:var(--cv-accent-soft);color:#fff}.ch-ctxchip .licon{color:var(--amethyst-700)}.ch-ctxchip.is-empty{cursor:default;border-color:var(--hairline-soft);background:#ffffff0a;color:var(--fg-4)}.ch-ctxchip.is-empty .licon{color:var(--fg-5)}.ch-context.is-picks{align-items:center}.ch-ctxchip.is-pick{max-width:100%;padding:0 3px 0 4px;gap:5px}.ch-ctxchip.is-pick .th{width:18px;height:18px;flex:none;border-radius:6px;background-size:cover;background-position:center}.ch-ctxchip.is-pick .nm{min-width:0;max-width:140px;overflow:hidden;text-overflow:ellipsis}.ch-ctxchip.is-pick .x{width:18px;height:18px;padding:0;border:0;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:var(--fg-3);cursor:pointer}.ch-ctxchip.is-pick .x:hover{background:#ff5c7a33;color:#fff}.ch-ctxchip.is-add{border-style:dashed;background:transparent}.ch-context.is-none .ch-ctxchip.is-add{margin-top:6px}.ch-picks-hint{flex-basis:100%;font-size:10.5px;line-height:1.4;color:var(--fg-4)}.ch-scroll{flex:1;min-height:0;overflow-y:auto;padding:16px 14px 6px;overscroll-behavior:contain}.ch-scroll::-webkit-scrollbar{width:8px}.ch-scroll::-webkit-scrollbar-thumb{background:#ffffff17;border-radius:4px;border:2px solid transparent;background-clip:content-box}.ch-intro{display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px;padding:22px 8px 10px}.ch-intro-mark{width:36px;height:36px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:0 10px 26px #745aff4d}.ch-intro-title{margin-top:4px;font-size:15px;font-weight:600;letter-spacing:-.015em;color:var(--fg-1);text-wrap:balance}.ch-intro-sub{font-size:12px;line-height:1.5;color:var(--fg-4);text-wrap:pretty;max-width:300px}.ch-msg{margin-bottom:16px}@media(prefers-reduced-motion:no-preference){.ch-msg{animation:chMsgIn .45s var(--ease-out-soft) both}@keyframes chMsgIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}}.ch-msg.is-user{display:flex;flex-direction:column;align-items:flex-end}.ch-msg-meta{display:flex;align-items:center;gap:5px;margin:0 4px 4px;font-size:10px;font-weight:500;color:var(--fg-5)}.ch-msg.is-theirs .ch-msg-meta{color:var(--fg-4)}.ch-bubble{max-width:88%;border-radius:16px 16px 6px;background:linear-gradient(180deg,#ffffff16,#ffffff09);border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff12;padding:10px 13px;font-size:13px;line-height:1.5;color:#ffffffe0;word-break:break-word}.ch-msg.is-theirs .ch-bubble{background:linear-gradient(180deg,#5a61ed29,#5a61ed12);border-color:#a3a7f538}.ch-msg.is-agent{display:flex;gap:10px}.ch-ai-mark{width:24px;height:24px;flex:none;border-radius:8px;margin-top:1px;background:var(--grad-cta);display:flex;align-items:center;justify-content:center;color:#fff}@media(prefers-reduced-motion:no-preference){.ch-ai-mark.is-busy{animation:chBreathe 1.6s ease-in-out infinite}}.ch-ai-body{flex:1;min-width:0}.ch-ai-text{font-size:12.5px;line-height:1.55;color:var(--fg-2)}.ch-text{word-break:break-word;text-wrap:pretty}.ch-text p{margin:0 0 8px}.ch-text>:last-child{margin-bottom:0}.ch-text ul,.ch-text ol{margin:2px 0 8px;padding-left:18px}.ch-text li{margin:3px 0;padding-left:2px}.ch-text li::marker{color:var(--fg-5)}.ch-text b{color:var(--fg-1);font-weight:600}.ch-text.has-caret>:last-child:after{content:"";display:inline-block;width:7px;height:13px;margin-left:2px;vertical-align:-2px;border-radius:2px;background:var(--amethyst-600)}@media(prefers-reduced-motion:no-preference){.ch-text.has-caret>:last-child:after{animation:chCaret .9s steps(2,start) infinite}@keyframes chCaret{to{visibility:hidden}}}.ch-status{margin-top:2px;font-size:11.5px;font-weight:500;color:var(--fg-4);position:relative;width:fit-content;overflow:hidden}.ch-status:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(9,11,19,.75) 50%,transparent 80%);animation:shimmer 1.6s linear infinite}.ch-ai-text+.ch-status{margin-top:8px}.ch-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}.ch-chips.is-start{justify-content:center;margin-top:8px}.ch-chip{display:inline-flex;align-items:center;gap:5px;max-width:100%;padding:5px 10px;border-radius:999px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1.3;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-chip:hover{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff;transform:translateY(-1px)}.ch-plan{margin-top:10px;border-radius:16px;overflow:hidden;background:#ffffff08;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d}.ch-ai-text+.ch-plan{margin-top:12px}.ch-plan.is-proposed,.ch-plan.is-running{border-color:#c2a4ec38;background:#9968df0e}.ch-plan.is-cancelled{opacity:.62}.ch-plan-head{display:flex;align-items:flex-start;gap:9px;padding:11px 12px 0}.ch-plan-mark{width:22px;height:22px;flex:none;border-radius:7px;margin-top:1px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;display:inline-flex;align-items:center;justify-content:center;color:var(--amethyst-700)}.ch-plan-titles{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-plan-eyebrow{display:flex;align-items:center;flex-wrap:wrap;gap:3px 5px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.ch-plan-eyebrow .dot{color:var(--fg-5);letter-spacing:0}.ch-plan-title{font-size:13px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ch-plan-est{flex:none;display:flex;flex-direction:column;align-items:flex-end;gap:4px}.ch-plan-cost{display:inline-flex;align-items:center;gap:4px;font-size:10.5px;font-weight:700;color:var(--fg-2);background:#ffffff0f;border-radius:999px;padding:3px 9px;font-variant-numeric:tabular-nums;white-space:nowrap}.ch-plan-cost.is-estimate{color:var(--amethyst-700);background:var(--cv-accent-tint)}.ch-plan-time{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;white-space:nowrap;padding-right:2px}.ch-plan-summary{margin:8px 12px 6px;font-size:12px;line-height:1.5;color:var(--fg-2);text-wrap:pretty}.ch-sessions{display:flex;flex-direction:column;gap:2px;padding:2px 6px 4px}.ch-session{display:flex;align-items:flex-start;gap:9px;padding:8px;border-radius:11px;border:1px solid transparent}.ch-session+.ch-session{border-top-color:var(--hairline-soft);border-radius:0 0 11px 11px}.ch-session-icon{width:24px;height:24px;flex:none;border-radius:8px;margin-top:1px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff0f;color:var(--amethyst-700)}.ch-session-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-session-name{display:flex;align-items:center;gap:6px;min-width:0}.ch-session-name .n{min-width:0;font-size:12.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-tag{flex:none;font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.12em;color:var(--fg-4);background:#ffffff12;border-radius:999px;padding:2px 6px}.ch-tag.is-new{color:var(--amethyst-700);background:var(--cv-accent-tint)}.ch-session-meta{display:flex;align-items:center;flex-wrap:wrap;gap:2px 5px;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.ch-session-meta .sep{color:var(--fg-5)}.ch-session-meta .tk{display:inline-flex;align-items:center;gap:3px;color:var(--fg-3);font-weight:600}.ch-session-settings{font-size:10.5px;color:var(--fg-3)}.ch-session-why{display:flex;align-items:flex-start;gap:5px;font-size:10.5px;line-height:1.4;color:var(--fg-4)}.ch-session-why .licon{flex:none;margin-top:1px;color:var(--fg-5)}.ch-session-prompt{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;margin-top:3px;padding:7px 9px;border-radius:9px;text-align:left;cursor:pointer;border:1px solid var(--hairline-soft);background:#0000002e;font-family:var(--font-sans);font-size:11px;line-height:1.45;color:var(--fg-2);font-style:italic;transition:border-color var(--dur-fast),background var(--dur-fast)}.ch-session-prompt:hover{border-color:var(--hairline);background:#00000042}.ch-session-prompt.is-open{display:block;-webkit-line-clamp:unset}.ch-session-inputs{display:flex;flex-wrap:wrap;gap:4px;margin-top:4px}.ch-session-inputs .th{width:30px;height:30px;border-radius:6px;background-size:cover;background-position:center;background-color:#ffffff0d;border:1px solid rgba(255,255,255,.08)}.ch-actions{display:flex;flex-direction:column;gap:1px;margin:4px 12px 2px;padding:8px 10px;border-radius:11px;background:#00000029;border:1px solid var(--hairline-soft)}.ch-action{display:flex;align-items:flex-start;gap:8px;padding:3px 0;font-size:11.5px;line-height:1.4;color:var(--fg-3)}@media(prefers-reduced-motion:no-preference){.ch-action{animation:chMsgIn .35s var(--ease-out-soft) both}}.ch-action-icon{flex:none;display:inline-flex;margin-top:1px;color:var(--fg-5)}.ch-action.is-done .ch-action-icon{color:var(--success)}.ch-action.is-done{color:var(--fg-2)}.ch-action.is-running .ch-action-icon,.ch-action.is-running{color:var(--amethyst-700)}.ch-action.is-running{font-weight:600}.ch-action.is-failed .ch-action-icon,.ch-action.is-failed{color:#ff8aa0}.ch-action-main{min-width:0;display:flex;flex-direction:column;gap:1px}.ch-action-detail{font-size:10.5px;font-weight:500;color:var(--fg-4)}.ch-action.is-failed .ch-action-detail{color:#ffb3c1}.ch-plan-foot{display:flex;align-items:center;gap:8px;margin-top:8px;padding:10px 12px;border-top:1px solid var(--hairline-soft);font-size:10.5px;color:var(--fg-4)}.ch-plan-foot.is-running{color:var(--amethyst-700);font-weight:600}.ch-plan-foot.is-done{color:var(--success);font-weight:600}.ch-plan-foot.is-failed,.ch-plan-foot.is-stopped{color:#ff8aa0;font-weight:600}.ch-plan-breakdown{flex:1;min-width:0;line-height:1.4}.ch-plan-run{flex:none;display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 13px;border:0;border-radius:9px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;box-shadow:0 10px 26px #745aff42,inset 0 1px #ffffff2e;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.ch-plan-run .sep{opacity:.6;margin:0 1px}.ch-plan-run:hover:not(:disabled){transform:translateY(-1px);filter:brightness(1.08)}.ch-plan-run:disabled{opacity:.7;cursor:default}.ch-plan-cancel,.ch-plan-show{flex:none;display:inline-flex;align-items:center;gap:5px;height:28px;padding:0 11px;border-radius:9px;background:#ffffff0e;border:1px solid var(--hairline);color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),color var(--dur-fast)}.ch-plan-cancel:hover:not(:disabled),.ch-plan-show:hover{background:#ffffff1a;color:var(--fg-1)}.ch-plan-cancel:disabled{opacity:.5;cursor:default}.ch-plan.is-skeleton{padding:12px;display:flex;flex-direction:column;gap:8px}.ch-plan .sk{height:11px;border-radius:5px;background:#ffffff12;position:relative;overflow:hidden}.ch-plan .sk-a{width:76%}.ch-plan .sk-b{width:92%}.ch-plan .sk-c{width:58%}.ch-plan .sk:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.ch-composer{flex:none;padding:10px 12px 12px;border-top:1px solid var(--hairline-soft)}.ch-comp-box{border-radius:var(--radius-md);background:#1e1e23bf;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 20px 40px #0206173d;padding:10px 10px 8px 12px;transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.ch-comp-box:focus-within{border-color:var(--cv-accent-soft);box-shadow:var(--inset-highlight),0 0 0 3px var(--cv-accent-tint)}.ch-comp-box.is-off{opacity:.6}.ch-comp-input{display:block;width:100%;min-height:44px;max-height:160px;resize:none;border:0;outline:none;background:transparent;padding:0;font-family:var(--font-sans);font-size:13px;line-height:1.5;color:var(--fg-1);user-select:text;-webkit-user-select:text}.ch-comp-input::placeholder{color:var(--fg-4)}.ch-comp-foot{display:flex;align-items:center;gap:10px;margin-top:6px}.ch-comp-hint{flex:1;min-width:0;font-size:10px;color:var(--fg-5);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model{position:relative;flex:none}.ch-model-btn{display:inline-flex;align-items:center;gap:5px;max-width:170px;height:24px;padding:0 8px 0 9px;border:1px solid var(--cv-accent-soft);border-radius:999px;background:var(--cv-accent-tint);color:#fff;font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ch-model-btn .t{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-btn.is-sim{border-color:var(--hairline-soft);background:#ffffff0d;color:var(--fg-3)}.ch-model-btn:hover{border-color:var(--cv-accent-soft);color:#fff}.ch-model-menu{position:absolute;left:-4px;bottom:calc(100% + 10px);z-index:6;width:250px;display:flex;flex-direction:column;gap:2px;padding:6px;border-radius:14px;background:#121217fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3;animation:histIn .18s var(--ease-out-soft) both}.ch-model-row{display:flex;align-items:center;gap:9px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast)}.ch-model-row:hover{background:#ffffff0f}.ch-model-row.on{background:var(--cv-accent-tint)}.ch-model-row>.licon{flex:none;color:var(--amethyst-700)}.ch-model-row .m{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.ch-model-row .n{font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-row .f{font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-note{padding:6px 8px 4px;font-size:10.5px;line-height:1.45;color:var(--fg-4);text-wrap:pretty}.ch-send{flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:var(--grad-cta);color:#fff;cursor:pointer;box-shadow:0 8px 22px #745aff4d,inset 0 1px #fff3;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.ch-send:hover:not(:disabled){transform:translateY(-1px);filter:brightness(1.08)}.ch-send:disabled{cursor:default;background:#ffffff14;color:var(--fg-5);box-shadow:none}.ch-picks{display:flex;flex-direction:column;gap:6px;margin-top:10px}.ch-ai-text+.ch-picks{margin-top:12px}.ch-pick{display:flex;align-items:flex-start;gap:10px;padding:9px 10px;border-radius:14px;background:#ffffff08;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d}.ch-pick.is-off{opacity:.55}.ch-pick-pic{flex:none;width:34px;height:34px;border-radius:10px;margin-top:1px;background:#ffffff0f center / cover no-repeat;box-shadow:inset 0 0 0 1px #ffffff14;display:inline-flex;align-items:center;justify-content:center;color:var(--amethyst-700)}.ch-pick-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ch-pick-top{display:flex;align-items:baseline;gap:6px;min-width:0}.ch-pick-name{min-width:0;font-size:12.5px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-pick-price{flex:none;margin-left:auto;font-size:10px;font-weight:700;color:var(--fg-2);background:#ffffff0f;border-radius:999px;padding:2px 7px;font-variant-numeric:tabular-nums;white-space:nowrap}.ch-pick-why{font-size:11.5px;line-height:1.45;color:var(--fg-3);text-wrap:pretty}.ch-pick-kit{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-5);margin-top:1px}.ch-pick-try{flex:none;align-self:center;display:inline-flex;align-items:center;gap:4px;height:26px;padding:0 10px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-pick-try:hover:not(:disabled){background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff;transform:translateY(-1px)}.ch-pick-try:disabled{opacity:.5;cursor:default}.ch-ideas{display:flex;flex-direction:column;gap:6px;margin-top:10px}.ch-ai-text+.ch-ideas{margin-top:12px}.ch-idea{display:flex;align-items:flex-start;gap:10px;width:100%;padding:10px 10px 10px 11px;border-radius:14px;background:#ffffff08;border:1px solid var(--hairline-soft);color:var(--fg-2);box-shadow:inset 0 1px #ffffff0d;font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-idea:hover:not(:disabled){background:#9968df14;border-color:#c2a4ec47;transform:translateY(-1px)}.ch-idea:disabled{cursor:default}.ch-idea-n{flex:none;width:20px;height:20px;margin-top:1px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--amethyst-700);font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.ch-idea-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-idea-title{font-size:12.5px;font-weight:600;color:var(--fg-1)}.ch-idea-pitch{font-size:11.5px;line-height:1.45;color:var(--fg-3);text-wrap:pretty}.ch-idea-tool{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;color:var(--amethyst-700);margin-top:1px}.ch-idea-go{flex:none;align-self:center;color:var(--fg-5)}.ch-idea:hover:not(:disabled) .ch-idea-go{color:var(--fg-2)}.ch-msg-cost{display:flex;align-items:center;gap:4px;margin-top:8px;font-size:10px;font-weight:500;color:var(--fg-4);font-variant-numeric:tabular-nums}.ch-msg-cost .dot{color:var(--fg-5);opacity:.7}.ch-msg-cost .licon{opacity:.8}', _Ie = `
/* while a board is open the host's emulator banner would sit on the rail */
body.bd-open .firebase-emulator-warning { display: none !important; }
`;
let Kh = 0, wo = null;
function YA() {
  return Kh++, wo || (wo = document.createElement("style"), wo.setAttribute("data-rd-board", ""), wo.textContent = [uIe, hIe, pIe, fIe, mIe, gIe, bIe, vIe, yIe, xIe, wIe, kIe, RL, _Ie].join(`
`), document.head.appendChild(wo)), () => {
    Kh = Math.max(0, Kh - 1), !Kh && wo && (wo.remove(), wo = null);
  };
}
const SIe = ".bd-root.bd-tip{position:fixed;left:0;top:0;z-index:2147483600;pointer-events:none;display:flex;flex-direction:column;gap:3px;width:max-content;max-width:280px;padding:6px 10px 7px;border-radius:9px;background:#131520fa;border:1px solid rgba(255,255,255,.11);box-shadow:inset 0 1px #ffffff0b,0 12px 32px #02040c8c,0 2px 8px #02040c66;color:var(--fg-1);font-size:12px;font-weight:500;line-height:1.35;letter-spacing:-.005em;text-align:left;white-space:normal;overflow-wrap:anywhere;opacity:0;transform:translateY(3px);transition:opacity .12s ease,transform .16s var(--ease-out-soft)}.bd-root.bd-tip.is-below{transform:translateY(-3px)}.bd-root.bd-tip.on{opacity:1;transform:none}.bd-root.bd-tip.is-now{transition:none}.bd-tip .ln{display:flex;align-items:center;gap:10px}.bd-tip .tx{flex:1 1 auto;min-width:0}.bd-tip .keys{flex:none;display:inline-flex;gap:3px;margin-right:-3px}.bd-tip kbd{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid rgba(255,255,255,.1);background:#ffffff12;box-shadow:inset 0 -1px #0000004d;color:var(--fg-2);font-family:var(--font-sans);font-size:10.5px;font-weight:600;line-height:1}.bd-tip .hint{font-size:11.5px;font-weight:400;line-height:1.4;color:var(--fg-3)}@media(prefers-reduced-motion:reduce){.bd-root.bd-tip,.bd-root.bd-tip.is-below{transition:none;transform:none}}", MIe = 260, TIe = 400, Kb = 8, zd = 8, Uf = "bd-tip", Yb = "(?:Esc|Enter|Del|Space|Tab|↵|⌫|[←→↑↓\\[\\]/\\\\,.=+\\-?])", CIe = new RegExp("^(?:[A-Z]|" + Yb + "|[⌘⇧⌥⌃]+(?:[A-Z0-9]|" + Yb + ")|(?:(?:Ctrl|Alt|Shift|Cmd)\\+)+(?:[A-Z0-9]|" + Yb + "))$");
function XA(n) {
  const [e, ...t] = n.split(`
`), i = e.trim(), s = /^(.*\S)\s+\(([^()]+)\)$/.exec(i), o = s ? s[2].trim() : "", r = s && CIe.test(o) ? IIe(o) : [];
  return { label: r.length ? s[1] : i, keys: r, hint: t.map((a) => a.trim()).filter(Boolean).join(" ") };
}
function IIe(n) {
  const e = /^((?:(?:Ctrl|Alt|Shift|Cmd)\+)+)(.+)$/.exec(n);
  if (e) return [...e[1].split("+").filter(Boolean), e[2]];
  const t = /^([⌘⇧⌥⌃]*)(.+)$/u.exec(n);
  return t ? [...Array.from(t[1]), t[2]] : [n];
}
let Yh = 0, Cr = null, jn = null, _n = null, wx = "pointer", Im = !1, Ml = !1, kx = -1 / 0, Gf = 0, X0 = 0, Ic = null;
const ar = /* @__PURE__ */ new WeakMap(), J0 = /* @__PURE__ */ new WeakSet();
function JA(n) {
  const e = n instanceof Element ? n : null, t = e ? e.closest("[title]") : null;
  return !t || !t.closest(".bd-root") || t === jn || !ar.has(t) && !(t.getAttribute("title") || "").trim() ? null : t;
}
function AIe(n) {
  const e = ar.get(n);
  if (e != null) return e;
  const t = n.getAttribute("title");
  return !t || !t.trim() ? null : (ar.set(n, t), n.setAttribute("title", ""), !n.hasAttribute("aria-label") && !n.hasAttribute("aria-labelledby") && !(n.textContent || "").trim() && (n.setAttribute("aria-label", XA(t).label), J0.add(n)), t);
}
function PIe(n) {
  const e = ar.get(n);
  ar.delete(n), e != null && n.getAttribute("title") === "" && n.setAttribute("title", e), J0.has(n) && (n.removeAttribute("aria-label"), J0.delete(n));
  const t = (n.getAttribute("aria-describedby") || "").split(/\s+/).filter((i) => i && i !== Uf);
  t.length ? n.setAttribute("aria-describedby", t.join(" ")) : n.removeAttribute("aria-describedby");
}
function EIe() {
  if (!_n) return;
  const n = _n.getAttribute("title");
  if (n !== "") {
    if (n == null) {
      ar.delete(_n), _x();
      return;
    }
    ar.set(_n, n), _n.setAttribute("title", ""), Ml && Z0(!0);
  }
}
function ZA(n, e) {
  AIe(n) != null && (_n = n, wx = e, Im = !1, Ic = new MutationObserver(EIe), Ic.observe(n, { attributes: !0, attributeFilter: ["title"] }), clearTimeout(Gf), performance.now() - kx < TIe ? Z0(!0) : Gf = window.setTimeout(() => Z0(!1), MIe));
}
function ed() {
  clearTimeout(Gf), Ic && Ic.disconnect(), Ic = null;
  const n = _n;
  _n = null, Im = !1, _x(), n && PIe(n);
}
function RIe() {
  return jn && jn.isConnected || (jn = document.createElement("div"), jn.className = "bd-root bd-tip", jn.id = Uf, jn.setAttribute("role", "tooltip"), jn.setAttribute("data-testid", "board-tip"), document.body.appendChild(jn)), jn;
}
function zIe(n, e) {
  n.replaceChildren();
  const t = document.createElement("span");
  t.className = "ln";
  const i = document.createElement("span");
  if (i.className = "tx", i.textContent = e.label, t.appendChild(i), e.keys.length) {
    const s = document.createElement("span");
    s.className = "keys";
    for (const o of e.keys) {
      const r = document.createElement("kbd");
      r.textContent = o, s.appendChild(r);
    }
    t.appendChild(s);
  }
  if (n.appendChild(t), e.hint) {
    const s = document.createElement("span");
    s.className = "hint", s.textContent = e.hint, n.appendChild(s);
  }
}
function $Ie(n, e) {
  const t = e.getBoundingClientRect(), i = n.offsetWidth, s = n.offsetHeight;
  let o = t.top - Kb - s, r = !1;
  o < zd && (o = t.bottom + Kb, r = !0, o + s > window.innerHeight - zd && (o = Math.max(zd, t.top - Kb - s), r = !1));
  const a = Math.max(zd, Math.min(window.innerWidth - zd - i, t.left + t.width / 2 - i / 2));
  n.classList.toggle("is-below", r), n.style.left = Math.round(a) + "px", n.style.top = Math.round(o) + "px";
}
function Z0(n) {
  const e = _n, t = e ? ar.get(e) : null;
  if (!e || !t || Im || !e.isConnected || e.querySelector(".tip")) return;
  const i = RIe();
  zIe(i, XA(t)), i.classList.toggle("is-now", n || Ml), Ml || i.classList.remove("on"), $Ie(i, e), i.offsetWidth, i.classList.add("on"), Ml = !0, kx = performance.now();
  const s = (e.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
  s.includes(Uf) || e.setAttribute("aria-describedby", [...s, Uf].join(" ")), clearInterval(X0), X0 = window.setInterval(() => {
    (!_n || !_n.isConnected) && ed();
  }, 250);
}
function _x() {
  clearTimeout(Gf), clearInterval(X0), Ml && (kx = performance.now()), Ml = !1, jn && jn.classList.remove("on");
}
function J4(n) {
  if (n.pointerType === "touch") return;
  const e = JA(n.target);
  e !== _n && (_n && ed(), e && !n.buttons && ZA(e, "pointer"));
}
function Z4(n) {
  _n && wx === "pointer" && !n.relatedTarget && ed();
}
function ms() {
  _n && (Im = !0, _x());
}
function Q4(n) {
  n.key === "Escape" && ms();
}
function e3(n) {
  const e = n.target;
  _n && (e === document || e instanceof Node && e.contains(_n)) && ms();
}
function t3(n) {
  const e = n.target;
  if (!(e instanceof HTMLElement) || !e.matches(":focus-visible")) return;
  const t = JA(e);
  !t || t === _n || (_n && ed(), ZA(t, "focus"));
}
function n3() {
  _n && wx === "focus" && ed();
}
function QA() {
  if (typeof document == "undefined") return () => {
  };
  Yh++, Yh === 1 && (Cr = document.createElement("style"), Cr.setAttribute("data-rd-board-tips", ""), Cr.textContent = SIe, document.head.appendChild(Cr), document.addEventListener("pointerover", J4, !0), document.addEventListener("pointerout", Z4, !0), document.addEventListener("pointerdown", ms, !0), document.addEventListener("keydown", Q4, !0), document.addEventListener("focusin", t3, !0), document.addEventListener("focusout", n3, !0), window.addEventListener("scroll", e3, !0), window.addEventListener("wheel", ms, { capture: !0, passive: !0 }), window.addEventListener("blur", ms), window.addEventListener("resize", ms));
  let n = !1;
  return () => {
    n || (n = !0, Yh--, !(Yh > 0) && (ed(), document.removeEventListener("pointerover", J4, !0), document.removeEventListener("pointerout", Z4, !0), document.removeEventListener("pointerdown", ms, !0), document.removeEventListener("keydown", Q4, !0), document.removeEventListener("focusin", t3, !0), document.removeEventListener("focusout", n3, !0), window.removeEventListener("scroll", e3, !0), window.removeEventListener("wheel", ms, !0), window.removeEventListener("blur", ms), window.removeEventListener("resize", ms), jn && jn.remove(), jn = null, Cr && Cr.remove(), Cr = null));
  };
}
const DIe = [
  { value: "1:1", label: "1:1", meta: "1024×1024", icon: "Square" },
  { value: "3:4", label: "3:4", meta: "896×1152", icon: "RectangleVertical" },
  { value: "4:3", label: "4:3", meta: "1152×896", icon: "RectangleHorizontal" },
  { value: "16:9", label: "16:9", meta: "1344×768", icon: "RectangleHorizontal" },
  { value: "9:16", label: "9:16", meta: "768×1344", icon: "RectangleVertical" }
], OIe = ["2s", "4s", "6s", "10s"].map((n) => ({ value: n, label: n })), i3 = {
  "Nano Banana Pro": 14,
  "Nano Banana 2": 14,
  "ChatGPT Image 2": 16,
  "GPT Image 1.5": 16,
  "Seedream 5 Lite": 10,
  "Flux 2 Pro": 0
};
function s3(n, e = "") {
  const t = { key: "prompt", kind: "prompt", label: "Prompt", placement: "prompt", required: !0, defaultValue: "" }, i = { key: "aspect", kind: "size", label: "Output size", placement: "chip", defaultValue: "3:4", options: DIe }, s = { key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null, tooltip: "The same seed with the same prompt and settings repeats a result." };
  if (n === "video")
    return [
      t,
      { key: "startFrame", kind: "image", label: "Start frame", placement: "reference" },
      { ...i, defaultValue: "16:9" },
      { key: "length", kind: "select", label: "Length", placement: "chip", icon: "Clock", defaultValue: "4s", options: OIe },
      s
    ];
  if (n === "threed")
    return [
      { ...t, required: !1, placeholder: "Optional: describe the object" },
      { key: "source", kind: "image", label: "Source image", placement: "reference", required: !0 },
      { key: "texture", kind: "boolean", label: "Bake textures", placement: "advanced", defaultValue: !0 },
      s
    ];
  if (n === "upscale" && /video/i.test(e))
    return [
      { key: "video", kind: "video", label: "Video to upscale", placement: "reference", required: !0 },
      { key: "factor", kind: "select", label: "Scale", placement: "chip", icon: "Maximize2", defaultValue: "2x", options: [{ value: "2x", label: "2×" }, { value: "4x", label: "4×" }] }
    ];
  if (n === "upscale")
    return [
      { key: "image", kind: "image", label: "Image to upscale", placement: "reference", required: !0 },
      {
        key: "factor",
        kind: "select",
        label: "Scale",
        placement: "chip",
        icon: "Maximize2",
        defaultValue: "2x",
        options: [{ value: "2x", label: "2×" }, { value: "4x", label: "4×" }]
      },
      { key: "creativity", kind: "slider", label: "Creativity", placement: "advanced", min: 0, max: 10, step: 1, defaultValue: 3, tooltip: "How much new detail the upscaler may invent." }
    ];
  const o = e in i3 ? i3[e] : 4;
  return [
    t,
    ...o ? [{ key: "images", kind: "images", label: "Images", placement: "reference", maxImages: o }] : [],
    i,
    { key: "steps", kind: "slider", label: "Steps (Quality)", placement: "advanced", min: 1, max: 50, step: 1, defaultValue: 4, tooltip: "More steps take longer and add detail." },
    s
  ];
}
function LIe() {
  return {
    id: "demo:threed:Hunyuan 3D Pro",
    name: "Hunyuan 3D Pro",
    desc: "One object from up to six views",
    kitId: "threed",
    tokensLabel: "813",
    tokensPerResult: 813,
    time: "2m",
    fields: [
      { key: "prompt", kind: "prompt", label: "Prompt", placement: "prompt", required: !1, defaultValue: "", placeholder: "Optional: describe the object" },
      ...["Front", "Back", "Left", "Right", "Top", "Bottom"].map((e, t) => ({ key: "view" + e, kind: "image", label: e + " view", placement: "reference", required: t === 0 })),
      { key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null }
    ],
    numResults: { min: 1, max: 1, def: 1 }
  };
}
const BIe = [
  { kitId: "image", name: "Qwen Image", tokens: 43, time: "10s" },
  { kitId: "image", name: "Recraft v4 Pro", tokens: 698, time: "25s" },
  { kitId: "video", name: "Veo 3.1 Fast", tokens: 233, time: "1m" },
  { kitId: "video", name: "Luma Ray 2", tokens: 1164, time: "2m" }
];
function Vi(n) {
  const { display: e, ...t } = n;
  return { ...t, raw: { boardKey: n.key, display: e || {} } };
}
function $d(n, e, t, i, s, o, r = 1) {
  return {
    id: "demo:tools:" + n,
    name: e,
    kitId: "tools",
    tokensLabel: String(i),
    tokensPerResult: i,
    time: s,
    fields: o,
    numResults: { min: 1, max: r, def: 1 },
    boardTool: t
  };
}
function FIe() {
  const n = (t = "Image") => Vi({ key: "image", kind: "image", label: t, placement: "reference", required: !0 }), e = (t, i) => Vi({ key: t, kind: "slider", label: i, placement: "advanced", min: 0, max: 5e3, step: 1 });
  return [
    $d("removebg", "Remove Background", "removebg", 9, "6s", [n("Image to cut out")]),
    $d("erase", "Person and Object Remover", "erase", 93, "11s", [Vi({ key: "image", kind: "image", label: "Image to remove items from", placement: "reference", required: !0, display: { hasInpainting: !0, inpaintingRequired: !0 } })]),
    $d("expand", "Expand", "expand", 93, "15s", [
      n("Image to expand"),
      Vi({ key: "prompt", kind: "prompt", label: "What to add", placement: "prompt", required: !1, defaultValue: "" }),
      e("canvasWidth", "Canvas width"),
      e("canvasHeight", "Canvas height"),
      e("imageWidth", "Image width"),
      e("imageHeight", "Image height"),
      e("imageX", "Image left"),
      e("imageY", "Image top")
    ]),
    $d("camera", "Change Camera", "camera", 76, "18s", [
      n("Image to see from another angle"),
      Vi({ key: "rotate", kind: "slider", label: "Rotate", placement: "advanced", min: 0, max: 360, step: 1, defaultValue: 45 }),
      Vi({ key: "vertical", kind: "slider", label: "Vertical", placement: "advanced", min: -30, max: 90, step: 1, defaultValue: 0 }),
      Vi({ key: "zoom", kind: "slider", label: "Zoom", placement: "advanced", min: 0, max: 10, step: 0.5, defaultValue: 5 }),
      Vi({ key: "keep", kind: "text", label: "Keep", placement: "advanced", defaultValue: "" }),
      Vi({ key: "avoid", kind: "negPrompt", label: "Avoid", placement: "advanced", defaultValue: "" }),
      Vi({ key: "loraScale", kind: "slider", label: "LoRA scale", placement: "advanced", min: 0, max: 4, step: 0.1, defaultValue: 0.9 }),
      Vi({ key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null })
    ], 4),
    $d("select", "Find Objects", "select", 11, "4s", [n("Image to find the objects in")])
  ];
}
function NIe() {
  const n = (e) => e.map((t) => ({ value: t, label: t }));
  return {
    id: "demo:upscale:Magnific Upscaler",
    name: "Magnific Upscaler",
    kitId: "upscale",
    tokensLabel: "282+",
    time: "45s",
    numResults: { min: 1, max: 1, def: 1 },
    fields: [
      { key: "image", kind: "image", label: "Image", placement: "reference", required: !0 },
      { key: "scale", kind: "select", label: "Scale Factor", placement: "chip", icon: "Maximize2", defaultValue: 2, options: [2, 4, 8, 16].map((e) => ({ value: e, label: String(e) })) },
      { key: "optimized", kind: "select", label: "Optimized For", placement: "chip", defaultValue: "standard", options: n(["standard", "soft_portraits", "hard_portraits", "art_n_illustration", "videogame_assets", "nature_n_landscapes", "films_n_photography", "3d_renders", "science_fiction_n_horror"]) },
      { key: "prompt", kind: "text", label: "Prompt (Optional)", placement: "advanced", defaultValue: "" },
      { key: "creativity", kind: "slider", label: "Creativity", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "hdr", kind: "slider", label: "HDR", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "resemblance", kind: "slider", label: "Resemblance", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "fractality", kind: "slider", label: "Fractality", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "engine", kind: "select", label: "Engine", placement: "advanced", defaultValue: "automatic", options: n(["automatic", "magnific_illusio", "magnific_sharpy", "magnific_sparkle"]) }
    ]
  };
}
function eP() {
  const n = ia.kits.map((t) => ({
    id: t.id,
    name: t.name,
    icon: t.icon,
    desc: t.desc,
    models: t.models.map((i) => ({
      id: "demo:" + t.id + ":" + i.name,
      name: i.name,
      desc: i.desc,
      kitId: t.id,
      tokensLabel: String(i.tokens),
      tokensPerResult: /^\d+$/.test(String(i.tokens)) ? Number(i.tokens) : void 0,
      time: i.time,
      fields: s3(t.id, i.name),
      numResults: { min: 1, max: 8, def: 1 }
    })).concat(t.id === "threed" ? [LIe()] : t.id === "upscale" ? [NIe()] : [])
  })), e = BIe.map((t) => ({
    id: "demo:" + t.kitId + ":" + t.name,
    name: t.name,
    kitId: t.kitId,
    tokensLabel: String(t.tokens),
    tokensPerResult: t.tokens,
    time: t.time,
    fields: s3(t.kitId, t.name),
    numResults: { min: 1, max: 4, def: 1 }
  }));
  return of("demo", n, e, FIe());
}
var UIe = Object.defineProperty, GIe = (n, e, t) => e in n ? UIe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Zr = (n, e, t) => GIe(n, typeof e != "symbol" ? e + "" : e, t);
class Sx {
  constructor(e = null, t = null) {
    if (Zr(this, "persistKey", e), Zr(this, "user", t), Zr(this, "boards", /* @__PURE__ */ new Map()), e)
      try {
        const i = localStorage.getItem(e);
        if (i) {
          const s = JSON.parse(i);
          for (const [o, r] of Object.entries(s)) this.boards.set(o, r);
        }
      } catch {
      }
  }
  save() {
    if (this.persistKey)
      try {
        const e = {};
        for (const [t, i] of this.boards)
          t.startsWith("stress-") || (e[t] = i);
        localStorage.setItem(this.persistKey, JSON.stringify(e));
      } catch {
      }
  }
  async list() {
    return Array.from(this.boards.values()).map((e) => ({ ...e.meta })).sort((e, t) => (t.updatedAt || 0) - (e.updatedAt || 0));
  }
  async get(e) {
    const t = this.boards.get(e);
    return t ? { ...t.meta } : null;
  }
  /** `id`: the harness gives a board the boards list made the list's own id */
  async create(e, t = "blank", i = wt()) {
    const s = Date.now(), o = t === "demo" ? Kl() : null, r = {
      meta: { id: i, title: o ? o.title : e, createdAt: s, updatedAt: s, ...this.user ? { ownerId: this.user.uid } : {} },
      elements: {},
      results: {}
    };
    if (o) {
      for (const a of o.elements) r.elements[a.id] = a;
      for (const a of o.results) r.results[a.id] = a;
    }
    return this.boards.set(i, r), this.save(), { ...r.meta };
  }
  /** Benchmark boards: regenerated every time, never persisted. */
  ensureStress(e, t) {
    const i = "stress-" + e + (t ? "-syn" : "");
    return this.boards.has(i) || this.addSeeded(i, qW(e, t)), i;
  }
  /** The demo board tiled to at least `minImages` images (the stress page). */
  ensureTiledDemo(e) {
    const t = "stress-demo-" + e;
    return this.boards.has(t) || this.addSeeded(t, WW(e)), t;
  }
  /** A board made from a seed under the id given (the stress page's, the tour's practice board). */
  addSeeded(e, t) {
    const i = { meta: { id: e, title: t.title, createdAt: Date.now(), updatedAt: Date.now() }, elements: {}, results: {} };
    for (const s of t.elements) i.elements[s.id] = s;
    for (const s of t.results) i.results[s.id] = s;
    this.boards.set(e, i);
  }
  async rename(e, t) {
    const i = this.boards.get(e);
    i && (i.meta.title = t, i.meta.updatedAt = Date.now(), this.save());
  }
  async remove(e) {
    this.boards.delete(e), this.save();
  }
  open(e) {
    return new jIe(this, e);
  }
  board(e) {
    return this.boards.get(e);
  }
}
class jIe {
  constructor(e, t) {
    Zr(this, "dir", e), Zr(this, "id", t), Zr(this, "status", /* @__PURE__ */ W("saved")), Zr(this, "saveTimer", 0);
  }
  async load() {
    const e = this.dir.board(this.id);
    if (!e) throw new Error("Board not found");
    return {
      meta: JSON.parse(JSON.stringify(e.meta)),
      elements: Object.values(e.elements).map((t) => JSON.parse(JSON.stringify(t))),
      results: Object.values(e.results).map((t) => JSON.parse(JSON.stringify(t)))
    };
  }
  watch(e) {
  }
  commit(e) {
    const t = this.dir.board(this.id);
    if (!t) return;
    const i = Date.now(), s = this.dir.user;
    for (const o of e.added)
      t.elements[o.id] = JSON.parse(JSON.stringify(o)), t.trash && delete t.trash[o.id];
    for (const o of e.updated) t.elements[o.id] = JSON.parse(JSON.stringify(o.el));
    for (const o of e.removed)
      delete t.elements[o.id], t.trash || (t.trash = {}), t.trash[o.id] = {
        el: JSON.parse(JSON.stringify(o)),
        deletedAt: i,
        hardDeleteAt: i + N1,
        deletedBy: s ? s.uid : void 0,
        deletedByEmail: s ? s.email : void 0
      };
    t.meta.updatedAt = i, this.schedule();
  }
  trash() {
    const e = this.dir.board(this.id);
    if (!e || !e.trash) return [];
    const t = Date.now();
    return Object.values(e.trash).filter((i) => i.hardDeleteAt > t).map((i) => JSON.parse(JSON.stringify(i))).sort((i, s) => s.deletedAt - i.deletedAt);
  }
  purge(e) {
    const t = this.dir.board(this.id);
    if (!(!t || !t.trash)) {
      for (const i of e) delete t.trash[i];
      this.schedule();
    }
  }
  commitResults(e) {
    const t = this.dir.board(this.id);
    if (t) {
      for (const i of e) t.results[i.id] = JSON.parse(JSON.stringify(i));
      this.schedule();
    }
  }
  saveMeta(e) {
    const t = this.dir.board(this.id);
    t && (Object.assign(t.meta, JSON.parse(JSON.stringify(e)), { updatedAt: Date.now() }), this.schedule());
  }
  schedule() {
    this.status.value = "saving", clearTimeout(this.saveTimer), this.saveTimer = window.setTimeout(() => {
      this.dir.save(), this.status.value = "saved";
    }, 500);
  }
  async flush() {
    clearTimeout(this.saveTimer), this.dir.save(), this.status.value = "saved";
  }
  dispose() {
    this.flush();
  }
}
var HIe = Object.defineProperty, VIe = (n, e, t) => e in n ? HIe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Xh = (n, e, t) => VIe(n, typeof e != "symbol" ? e + "" : e, t);
const tP = 260, ko = (n, e = tP) => new Promise((t) => setTimeout(() => t(n), e)), WIe = [{ value: "demo-board", text: "Bonneville Tower" }, { value: "demo-old", text: "Depot Yards (v1 board)" }], o3 = [
  [/nano banana/i, "fam-gemini", "Nano Banana"],
  [/gpt|chatgpt/i, "fam-openai", "GPT Image"],
  [/seedream/i, "fam-seedream", "Seedream"],
  [/kling/i, "fam-kling", "Kling"],
  [/flux/i, "fam-flux", "Flux"]
], qIe = [["1:1", 1], ["16:9", 16 / 9], ["2:1", 2], ["3:2", 1.5], ["4:3", 4 / 3], ["21:9", 21 / 9], ["9:16", 9 / 16], ["2:3", 2 / 3], ["3:4", 0.75]];
function KIe(n = 1, e = 1) {
  const t = n / e;
  let i = "OTHER", s = 0.06;
  for (const [o, r] of qIe) {
    const a = Math.abs(Math.log(t / r));
    a < s && (s = a, i = o);
  }
  return i;
}
function YIe(n = 0) {
  const e = new Date(n);
  return e.getFullYear() + "-" + String(e.getMonth() + 1).padStart(2, "0") + "-" + String(e.getDate()).padStart(2, "0");
}
function XIe(n, e) {
  const t = e.trim().toLowerCase();
  if (!t) return !0;
  const i = [n.prompt, n.label, n.model].filter(Boolean).join(" ").toLowerCase();
  return t.split(/\s+/).every((s) => i.includes(s));
}
class JIe {
  constructor() {
    Xh(this, "features", { search: !0, filters: !0, star: !0, remove: !0 }), Xh(this, "gens"), Xh(this, "ups"), Xh(this, "facets", /* @__PURE__ */ new Map());
    const e = Kl(), t = /* @__PURE__ */ new Set(), i = [];
    e.results.forEach((a, l) => {
      if (!a.url || t.has(a.url)) return;
      t.add(a.url);
      const d = "demo:" + a.id;
      i.push({
        id: d,
        url: a.url,
        w: a.w,
        h: a.h,
        video: !!a.video,
        videoSrc: a.videoSrc,
        label: a.prompt || a.label || "Generation",
        prompt: a.prompt || "",
        model: a.model,
        createdAt: a.createdAt,
        fav: !!a.fav,
        mine: !0,
        run: { id: "demo-run-" + a.id, uuid: a.id, nodeDefId: a.model || "", nodeId: a.sessionId, runnitId: "demo-board", type: a.video ? "VID" : "IMG" },
        asset: { nodeRunResult: { url: a.url, uuid: a.id } }
      });
      const c = o3.find(([h]) => h.test(a.model || ""));
      this.facets.set(d, {
        aspect: KIe(a.w, a.h),
        // the demo's renders are all small: give them a spread to filter by
        resolution: l % 7 === 0 ? "4K+" : l % 3 === 0 ? "2K" : "1K",
        tool: a.model || "",
        family: c ? c[1] : "",
        media: a.video ? "media-video" : "media-image",
        board: l % 5 === 4 ? "demo-old" : "demo-board",
        day: YIe(a.createdAt)
      });
    }), this.gens = i.sort((a, l) => (l.createdAt || 0) - (a.createdAt || 0));
    const s = [];
    let o = Date.UTC(2026, 8, 14, 18, 0);
    for (const a of e.elements) {
      if (a.type !== "image") continue;
      const l = a;
      l.video || !/site|existing|reference|sketch|plan|photo|material/i.test(l.label || "") || s.some((d) => d.url === l.src) || s.push({
        id: "demo-upload:" + l.id,
        url: l.src,
        w: l.w,
        h: l.h,
        video: !1,
        label: (l.label || "upload") + ".jpg",
        createdAt: o -= 5.5 * 3600 * 1e3,
        mine: !0,
        uploadId: l.id,
        asset: { upload: { id: l.id, name: (l.label || "upload") + ".jpg" } }
      });
    }
    const r = e.elements.find((a) => a.type === "image" && /massing|white card|model/i.test(a.label || ""));
    r && s.unshift({
      id: "demo-upload:massing-obj",
      url: r.src,
      w: r.w,
      h: r.h,
      video: !1,
      label: "bonneville-massing.obj",
      createdAt: Date.UTC(2026, 8, 15, 9, 0),
      mine: !0,
      uploadId: "massing-obj",
      asset: { upload: { id: "massing-obj", name: "bonneville-massing.obj", type: "ASSET_3D" } },
      model3d: { url: "data:text/plain;base64," + btoa(SI()), ext: "obj" }
    }), this.ups = s;
  }
  filtered(e) {
    if (!rA(e)) return this.gens;
    const t = e;
    return this.gens.filter((i) => {
      const s = this.facets.get(i.id);
      return !(!s || t.aspect && s.aspect !== t.aspect || t.resolution && s.resolution !== t.resolution || t.tool && s.tool !== t.tool || t.family && s.family !== t.family || t.media && s.media !== t.media || t.board && s.board !== t.board || t.favorited && !i.fav || t.from && s.day < t.from || t.to && s.day > t.to);
    });
  }
  page(e, t) {
    const i = typeof t == "string" && Number(t) || 0, s = e.slice(i, i + Jr).map((r) => ({ ...r })), o = i + Jr;
    return { items: s, next: o < e.length ? String(o) : null };
  }
  generations(e = {}) {
    const t = Sm(e.search), i = this.filtered(e.filters);
    return t ? ko({ items: i.filter((s) => XIe(s, t)).slice(0, 200).map((s) => ({ ...s })), next: null }, tP + 240) : ko(this.page(i, e.cursor));
  }
  uploads(e = {}) {
    return ko(this.page(this.ups, e.cursor));
  }
  favorites(e = {}) {
    return ko(this.page(this.gens.filter((t) => t.fav), e.cursor));
  }
  favoriteKeys() {
    return ko(this.gens.filter((e) => e.fav).map((e) => e.id), 120);
  }
  filterOptions() {
    const e = o3.filter(([, i]) => this.gens.some((s) => {
      var o;
      return ((o = this.facets.get(s.id)) == null ? void 0 : o.family) === i;
    })).map(([, i, s]) => ({ value: i, text: s })), t = Array.from(new Set(this.gens.map((i) => i.model).filter((i) => !!i))).sort().map((i) => ({ value: i, text: i }));
    return ko({
      tools: t,
      families: e,
      media: [{ value: "media-image", text: "Image" }, { value: "media-video", text: "Video" }],
      boards: WIe
    }, 180);
  }
  setFavorite(e, t) {
    const i = this.gens.find((s) => s.id === e.id);
    return i && (i.fav = t), ko(void 0, 120);
  }
  remove(e) {
    return this.gens = this.gens.filter((t) => t.id !== e.id), this.ups = this.ups.filter((t) => t.id !== e.id), ko(void 0, 160);
  }
  /** The harness's uploads land in its Library too. */
  addUpload(e) {
    this.ups = [e, ...this.ups.filter((t) => t.id !== e.id)];
  }
}
var ZIe = Object.defineProperty, QIe = (n, e, t) => e in n ? ZIe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, r3 = (n, e, t) => QIe(n, typeof e != "symbol" ? e + "" : e, t);
const eAe = 200, a3 = 300, tAe = /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
function l3(n) {
  return n.length > a3 ? n.slice(0, a3 - 1) + "…" : n;
}
function d3(n) {
  if (n instanceof Error) {
    const e = n.stack ? n.stack.split(`
`).slice(1, 3).map((t) => t.trim()).join(" ") : "";
    return n.name + ": " + n.message + (e ? " (" + e + ")" : "");
  }
  if (typeof n == "string") return n;
  if (n && typeof n == "object")
    try {
      return JSON.stringify(n);
    } catch {
      return String(n);
    }
  return String(n);
}
class nAe {
  constructor() {
    r3(this, "steps", []), r3(this, "released", []);
  }
  record(e, t, i) {
    const s = { at: Date.now(), kind: e, label: l3(t) };
    i && (s.detail = l3(i)), this.steps.push(s), this.steps.length > eAe && this.steps.shift();
  }
  /** Every step kept, oldest first (a copy). */
  list() {
    return this.steps.slice();
  }
  errors() {
    return this.steps.filter((e) => e.kind === "error" || e.kind === "warn");
  }
  /**
   * Keep the page's console errors and warnings, and anything thrown or
   * rejected that nobody caught. The console still prints them as before.
   */
  captureConsole() {
    for (const i of ["error", "warn"]) {
      const s = console[i], o = this, r = function(...a) {
        try {
          o.record(i, a.map(d3).join(" "));
        } catch {
        }
        return s.apply(this, a);
      };
      console[i] = r, this.released.push(() => {
        console[i] === r && (console[i] = s);
      });
    }
    const e = (i) => {
      tAe.test(i.message || "") || this.record("error", "Uncaught: " + (i.message || "an error"), i.filename ? i.filename + ":" + i.lineno : void 0);
    }, t = (i) => this.record("error", "Unhandled rejection: " + d3(i.reason));
    window.addEventListener("error", e), window.addEventListener("unhandledrejection", t), this.released.push(() => {
      window.removeEventListener("error", e), window.removeEventListener("unhandledrejection", t);
    });
  }
  dispose() {
    for (const e of this.released) e();
    this.released = [], this.steps = [];
  }
}
var iAe = Object.defineProperty, sAe = (n, e, t) => e in n ? iAe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Xb = (n, e, t) => sAe(n, typeof e != "symbol" ? e + "" : e, t);
class oAe {
  constructor() {
    Xb(this, "sent", []), Xb(this, "fail", null), Xb(this, "next", 1);
  }
  async submit(e) {
    return this.fail ? { success: !1, message: this.fail } : (this.sent.push(e), { success: !0, id: "memory-" + this.sent.length, number: this.next++ });
  }
}
const rAe = 12e4;
function aAe(n) {
  return !!n && typeof n == "object" && typeof n.success == "boolean";
}
function lAe(n) {
  return {
    async submit(e) {
      const t = await n.functions.httpsCallable("submitBoardFeedback", { timeout: rAe })(e);
      return aAe(t.data) ? t.data : { success: !1, message: "Your report couldn't be sent. Try again in a moment." };
    }
  };
}
var dAe = Object.defineProperty, cAe = (n, e, t) => e in n ? dAe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Dd = (n, e, t) => cAe(n, typeof e != "symbol" ? e + "" : e, t);
let Jb = 0;
function Ha() {
  return Jb = Math.max(Date.now(), Jb + 1), Jb;
}
class uAe {
  constructor(e) {
    Dd(this, "opts", e), Dd(this, "db"), Dd(this, "me"), Dd(this, "boardId"), Dd(this, "unsubs", []), this.db = e.db, this.me = e.me, this.boardId = e.boardId;
  }
  watchBoard(e) {
    const t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
    let s = !0;
    const o = () => {
      const d = this.db.data, c = [], h = /* @__PURE__ */ new Set();
      for (const x of Object.values(d.threads))
        x.boardId === this.boardId && (h.add(x.id), t.get(x.id) !== x && (t.set(x.id, x), c.push(x)));
      const f = Array.from(t.keys()).filter((x) => !h.has(x));
      for (const x of f) t.delete(x);
      const p = [], y = /* @__PURE__ */ new Set();
      for (const x of Object.values(d.comments))
        x.boardId === this.boardId && (y.add(x.id), i.get(x.id) !== x && (i.set(x.id, x), p.push(x)));
      const v = Array.from(i.keys()).filter((x) => !y.has(x));
      for (const x of v) i.delete(x);
      (s || c.length || f.length) && e.threads(c, f), (p.length || v.length) && e.comments(p, v), s = !1;
    };
    let r = !0;
    queueMicrotask(() => {
      r && o();
    });
    const a = this.db.subscribe(o), l = () => {
      r = !1, a();
    };
    return this.unsubs.push(l), l;
  }
  watchFollowed(e) {
    const t = () => {
      const r = Object.values(this.db.data.threads).filter((a) => a.followers.includes(this.me.uid)).sort((a, l) => l.lastAt - a.lastAt).slice(0, 60);
      e(r);
    };
    let i = !0;
    queueMicrotask(() => {
      i && t();
    });
    const s = this.db.subscribe(t), o = () => {
      i = !1, s();
    };
    return this.unsubs.push(o), o;
  }
  async people() {
    const e = this.opts.people || [];
    return e.length ? { people: [this.me, ...e], scope: "team" } : { people: [this.me], scope: "personal" };
  }
  async checkIn() {
    const e = this.db.data.seen[this.boardId] || {};
    return e[this.me.uid] ? e[this.me.uid] : (this.db.write((t) => {
      t.seen[this.boardId] = { ...t.seen[this.boardId] || {}, [this.me.uid]: 1 }, t.titles[this.boardId] = this.opts.board().title;
    }), 1);
  }
  async createThread(e, t) {
    const i = Ha();
    this.db.write((s) => {
      s.threads[e.id] = { ...e, createdAt: i, lastAt: i, readBy: { ...e.readBy, [this.me.uid]: i } }, s.comments[t.id] = { ...t, createdAt: i }, s.titles[this.boardId] = e.boardTitle;
    });
  }
  async reply(e, t, i) {
    const s = Ha();
    this.db.write((o) => {
      o.comments[t.id] = { ...t, createdAt: s };
      const r = o.threads[e.id];
      r && (o.threads[e.id] = {
        ...r,
        lastAt: s,
        lastBy: t.authorId,
        count: r.count + 1,
        preview: zp(t),
        followers: Od(r.followers, [t.authorId, ...i]),
        readBy: { ...r.readBy, [t.authorId]: s },
        markedUnread: r.markedUnread.filter((a) => a !== t.authorId),
        resolvedAt: null,
        resolvedBy: null
      });
    });
  }
  async editComment(e, t, i) {
    const s = Ha();
    this.db.write((o) => {
      const r = o.comments[e.id];
      if (!r) return;
      o.comments[e.id] = { ...r, text: e.text, mentions: e.mentions, editedAt: s };
      const a = o.threads[e.threadId];
      a && (o.threads[e.threadId] = { ...a, preview: t || a.preview, followers: Od(a.followers, i) });
    });
  }
  async deleteComment(e, t, i) {
    this.db.write((s) => {
      delete s.comments[e.id];
      const o = s.threads[e.threadId];
      o && (s.threads[e.threadId] = { ...o, count: t, preview: i });
    });
  }
  async deleteThread(e, t) {
    this.db.write((i) => {
      delete i.threads[e];
      for (const s of t) delete i.comments[s];
    });
  }
  async markDeleted(e) {
    this.db.patchThread(e, (t) => t.deletedAt ? t : { ...t, deletedAt: Ha(), deletedBy: this.me.uid });
  }
  async react(e, t, i) {
    const s = this.me.uid;
    this.db.write((o) => {
      const r = o.comments[e.id];
      if (!r) return;
      const a = (r.reactions[s] || []).filter((l) => l !== t);
      i && a.push(t), o.comments[e.id] = { ...r, reactions: { ...r.reactions, [s]: a } };
    });
  }
  async resolve(e, t) {
    this.db.patchThread(e, (i) => ({ ...i, resolvedAt: t ? Ha() : null, resolvedBy: t ? this.me.uid : null }));
  }
  async setColor(e, t) {
    this.db.patchThread(e, (i) => ({ ...i, color: t }));
  }
  async move(e, t) {
    this.db.patchThread(e, (i) => ({ ...i, x: t.x, y: t.y, elementId: t.elementId, ex: t.ex, ey: t.ey, anchorLabel: t.label, anchorThumb: t.thumb }));
  }
  async follow(e, t) {
    const i = this.me.uid;
    this.db.patchThread(e, (s) => ({ ...s, followers: t ? Od(s.followers, [i]) : s.followers.filter((o) => o !== i) }));
  }
  async pin(e, t) {
    const i = this.me.uid;
    this.db.patchThread(e, (s) => ({ ...s, pinnedBy: t ? Od(s.pinnedBy, [i]) : s.pinnedBy.filter((o) => o !== i) }));
  }
  async markRead(e) {
    const t = this.me.uid, i = Ha();
    this.db.write((s) => {
      for (const { id: o } of e) {
        const r = s.threads[o];
        r && (s.threads[o] = { ...r, readBy: { ...r.readBy, [t]: i }, markedUnread: r.markedUnread.filter((a) => a !== t) });
      }
    });
  }
  async markUnread(e) {
    const t = this.me.uid;
    this.db.patchThread(e, (i) => ({ ...i, markedUnread: Od(i.markedUnread, [t]) }));
  }
  async threadComments(e, t) {
    return Object.values(this.db.data.comments).filter((i) => i.boardId === e && i.threadId === t).sort((i, s) => i.createdAt - s.createdAt);
  }
  async boardTitles(e) {
    const t = {};
    for (const i of e) this.db.data.titles[i] && (t[i] = this.db.data.titles[i]);
    return t;
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
function Od(n, e) {
  const t = n.slice();
  for (const i of e) i && !t.includes(i) && t.push(i);
  return t;
}
const hAe = 8e-4;
function pAe(n, e) {
  const t = n.pad == null ? 8 : n.pad, i = t + (n.padTop || 0);
  let s = null;
  if (n.el) {
    const o = n.el(), r = o ? o.getBoundingClientRect() : null;
    r && (r.width || r.height) && (s = { x: r.left, y: r.top, w: r.width, h: r.height });
  } else if (n.box)
    s = n.box();
  else if (n.world && e) {
    const o = n.world();
    if (o) {
      const r = e.worldToClient(o.x, o.y), a = e.cam.value.zoom;
      s = { x: r.x, y: r.y, w: o.w * a, h: o.h * a };
    }
  }
  return s ? { x: s.x - t, y: s.y - i, w: s.w + t * 2, h: s.h + t + i } : null;
}
function fAe(n, e, t) {
  const i = /* @__PURE__ */ qe([]), s = /* @__PURE__ */ qe([]);
  let o = 0, r = 0;
  const a = /* @__PURE__ */ new Map();
  function l(d) {
    const c = r ? Math.min(0.1, (d - r) / 1e3) : 1;
    r = d;
    const h = t ? 1 : 1 - Math.pow(hAe, c), f = /* @__PURE__ */ new Map(), p = [];
    for (const v of n.value) {
      const x = pAe(v, e.value);
      x && (f.set(v.key, { ...x, r: v.radius == null ? 14 : v.radius, drop: v.drop, look: v.look, ring: v.ring }), p.push({ key: v.key, x: Math.round(x.x), y: Math.round(x.y), w: Math.round(x.w), h: Math.round(x.h) }));
    }
    let y = !1;
    for (const [v, x] of f) {
      let w = a.get(v);
      if (!w) {
        const A = a.size ? [...a.values()][0] : null;
        w = A && !t ? { key: v, x: A.x, y: A.y, w: A.w, h: A.h, r: A.r, open: A.open, drop: x.drop, look: x.look, ring: x.ring } : { key: v, x: x.x + x.w / 2, y: x.y + x.h / 2, w: 0, h: 0, r: x.r, open: t ? 1 : 0, drop: x.drop, look: x.look, ring: x.ring }, a.set(v, w), y = !0;
      }
      const S = w.x + (x.x - w.x) * h, M = w.y + (x.y - w.y) * h, _ = w.w + (x.w - w.w) * h, T = w.h + (x.h - w.h) * h, k = w.r + (Math.min(x.r, x.w / 2, x.h / 2) - w.r) * h, P = w.open + (1 - w.open) * h;
      Math.abs(S - w.x) + Math.abs(M - w.y) + Math.abs(_ - w.w) + Math.abs(T - w.h) + Math.abs(P - w.open) > 0.05 && (y = !0), Object.assign(w, { x: S, y: M, w: _, h: T, r: k, open: P, drop: x.drop, look: x.look, ring: x.ring });
    }
    for (const [v, x] of a) {
      if (f.has(v)) continue;
      y = !0;
      const w = x.x + x.w / 2, S = x.y + x.h / 2;
      x.w += (0 - x.w) * h, x.h += (0 - x.h) * h, x.x = w - x.w / 2, x.y = S - x.h / 2, x.open += (0 - x.open) * h, (x.w < 1 || x.h < 1 || t) && a.delete(v);
    }
    y && (i.value = [...a.values()].map((v) => ({ ...v }))), JSON.stringify(p) !== JSON.stringify(s.value) && (s.value = p), o = requestAnimationFrame(l);
  }
  return it(() => {
    o = requestAnimationFrame(l);
  }), We(() => {
    o && cancelAnimationFrame(o);
  }), { holes: i, exact: s };
}
const hu = 76, Xo = 16, Jh = 18, Zh = { above: "below", below: "above", left: "right", right: "left" };
function Zb(n, e, t, i) {
  switch (n) {
    case "above":
      return { x: e.x + e.w / 2 - t.w / 2, y: e.y - t.h - Jh };
    case "below":
      return { x: e.x + e.w / 2 - t.w / 2, y: e.y + e.h + Jh };
    case "left":
      return { x: e.x - t.w - Jh, y: e.y + e.h / 2 - t.h / 2 };
    case "right":
      return { x: e.x + e.w + Jh, y: e.y + e.h / 2 - t.h / 2 };
    case "right-edge":
      return { x: i.w - t.w - 24, y: e.y + e.h / 2 - t.h / 2 };
    case "left-edge":
      return { x: 24, y: e.y + e.h / 2 - t.h / 2 };
    case "top-right":
      return { x: i.w - t.w - 24, y: hu + 6 };
    case "bottom-left":
      return { x: 24, y: i.h - t.h - Xo };
    case "bottom-right":
      return { x: i.w - t.w - 24, y: i.h - t.h - Xo };
    case "bottom-center":
      return { x: i.w / 2 - t.w / 2, y: i.h - t.h - 108 };
    default:
      return { x: i.w / 2 - t.w / 2, y: i.h / 2 - t.h / 2 };
  }
}
function mAe(n, e, t) {
  return n.x >= Xo && n.y >= hu && n.x + e.w <= t.w - Xo && n.y + e.h <= t.h - Xo;
}
const Qb = (n, e, t) => ({
  x: Math.max(Xo, Math.min(t.w - e.w - Xo, n.x)),
  y: Math.max(hu, Math.min(t.h - e.h - Xo, n.y))
});
function gAe(n, e) {
  return n.x < e.x + e.w && e.x < n.x + n.w && n.y < e.y + e.h && e.y < n.y + n.h;
}
const bAe = ["below", "above", "right", "left", "bottom-left", "bottom-right", "top-right", "right-edge", "left-edge"];
function vAe(n, e, t, i, s = []) {
  if (!e && !(n === "top-right" || n === "bottom-center")) return { ...Qb(Zb("center", { x: 0, y: 0, w: 0, h: 0 }, t, i), t, i), side: "center" };
  const r = e || { x: 0, y: 0, w: 0, h: 0 }, a = [n];
  if (Zh[n] && a.push(Zh[n]), e)
    for (const c of bAe) a.includes(c) || a.push(c);
  const l = e ? [...s, e] : s, d = (c) => !l.some((h) => gAe({ x: c.x, y: c.y, w: t.w, h: t.h }, h));
  for (const c of a) {
    const h = Zb(c, r, t, i), f = c === n || c === Zh[n] ? Qb(h, t, i) : h;
    if ((c === n || c === Zh[n] || mAe(f, t, i)) && d(f)) return { ...f, side: c };
  }
  return { ...Qb(Zb(n, r, t, i), t, i), side: n };
}
function c3(n) {
  if (!n.length) return null;
  const e = Math.min(...n.map((o) => o.x)), t = Math.min(...n.map((o) => o.y)), i = Math.max(...n.map((o) => o.x + o.w)), s = Math.max(...n.map((o) => o.y + o.h));
  return { x: e, y: t, w: i - e, h: s - t };
}
const Wn = { w: 1180, h: 620, bar: 44, shown: 540 }, nP = { w: Wn.w, h: Wn.h - Wn.bar }, jf = { x: nP.w / 2, y: 217 }, Q0 = Wn.shown - Wn.bar - 16, Ys = { w: 600, h: 138, x: (nP.w - 600) / 2, y: Q0 - 138 }, Fo = { x: Ys.x + 54, y: Ys.y + 12, w: 44, h: 44 }, ec = { x: Ys.x + Ys.w - 12 - 62, y: Ys.y + Ys.h - 12 - 30, w: 62, h: 30 }, Lp = "https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-", Qt = (n) => Lp + n + "-400w.webp", pt = {
  whiteCard: Qt("e05-option-a-white-card-model-c61989"),
  golden: Qt("t03-autumn-golden-hour-3768d6"),
  dusk: Qt("t07-alpenglow-dusk-1d0baa"),
  blueHour: Qt("t04-winter-blue-hour-50f063"),
  night: Qt("t06-night-facade-lighting-69ccb0"),
  aerial: Qt("s01-existing-site-aerial-f3aa4c"),
  depot: Qt("s02-existing-depot-street-7c94e0"),
  creek: Qt("s03-existing-buried-creek-channel-160598"),
  sketchCanyon: Qt("e02-option-b-sketch-canyon-374663"),
  sketchSalt: Qt("e03-option-c-sketch-salt-11df63"),
  sketchShore: Qt("e01-option-a-sketch-shoreline-c101a0"),
  whiteCardSet: Qt("e04-white-card-options-a-b-c-1713cd"),
  lobbyModel: Qt("i01-lobby-white-model-d9fd93"),
  optionB: Qt("e06-option-b-render-parked-80d4c0"),
  optionC: Qt("e07-option-c-render-parked-e0c191"),
  watercolor: Qt("e08-option-a-watercolor-db5917"),
  openCrown: Qt("e10-hero-v2-open-crown-4a3b4d"),
  terraces: Qt("e12-hero-v3-deeper-terraces-1c4ede"),
  brickPodium: Qt("e15-hero-v4-brick-podium-11449d"),
  lobby: Qt("i02-lobby-v1-geometry-materials-ef49f9"),
  lobbyBright: Qt("i06-lobby-v4-competition-brightening-34918a"),
  masterplan: Qt("l02-watercolor-masterplan-6b0e55"),
  creekWalk: Qt("l04-creek-walk-marketing-hero-92d17d"),
  gardens: Qt("l08-daytime-gardens-with-people-8fb7f2"),
  dollyIn: Lp + "v02-hero-dolly-in-88196408-poster-400w.webp",
  dayToNight: Lp + "v03-aerial-day-to-night-time-lapse-744df3b5-poster-400w.webp",
  skyLounge: Lp + "v06-sky-lounge-sunset-time-lapse-a0a91aee-poster-400w.webp"
}, _o = { w: 252, h: 160 }, zs = [0, 1304, 2608], $s = [0, 470, 1e3], Ds = 1164, iP = [
  { title: "Site photos", x: zs[0], y: $s[0], w: Ds, h: 300 },
  { title: "Massing sketches", x: zs[1], y: $s[0], w: Ds, h: 300 },
  { title: "White card models", x: zs[2], y: $s[0], w: Ds, h: 300 },
  { title: "Direction renders", x: zs[0], y: $s[1], w: Ds, h: 330 },
  { title: "Hero options", x: zs[1], y: $s[1], w: Ds, h: 330 },
  { title: "Facade iterations", x: zs[2], y: $s[1], w: Ds, h: 330 },
  { title: "Lobby", x: zs[0], y: $s[2], w: Ds, h: 300 },
  { title: "Bench Gardens", x: zs[1], y: $s[2], w: Ds, h: 300 },
  { title: "Motion", x: zs[2], y: $s[2], w: Ds, h: 300 }
], sP = iP[4], Tl = { id: "white-card", src: pt.whiteCard, x: 1608, y: 500, w: 150, h: 200 }, No = [
  { id: "golden", src: pt.golden, x: 1798, y: 500, w: 150, h: 200 },
  { id: "dusk", src: pt.dusk, x: 1962, y: 500, w: 150, h: 200 },
  { id: "blue-hour", src: pt.blueHour, x: 2126, y: 500, w: 150, h: 200 },
  { id: "night", src: pt.night, x: 2290, y: 500, w: 150, h: 200 }
], oP = [
  { id: "aerial", src: pt.aerial, x: 304, y: 30, w: 260, h: 146 },
  { id: "depot", src: pt.depot, x: 578, y: 30, w: 260, h: 146 },
  { id: "creek", src: pt.creek, x: 852, y: 30, w: 260, h: 146 },
  { id: "sketch-canyon", src: pt.sketchCanyon, x: 1332, y: 30, w: 180, h: 240 },
  { id: "sketch-salt", src: pt.sketchSalt, x: 1526, y: 30, w: 180, h: 240 },
  { id: "sketch-shore", src: pt.sketchShore, x: 1720, y: 30, w: 180, h: 240 },
  { id: "white-card-set", src: pt.whiteCardSet, x: 2912, y: 30, w: 400, h: 225 },
  { id: "lobby-model", src: pt.lobbyModel, x: 3326, y: 30, w: 400, h: 225 },
  { id: "option-b", src: pt.optionB, x: 304, y: 500, w: 200, h: 267 },
  { id: "option-c", src: pt.optionC, x: 518, y: 500, w: 200, h: 267 },
  { id: "watercolor", src: pt.watercolor, x: 732, y: 500, w: 200, h: 267 },
  Tl,
  { id: "open-crown", src: pt.openCrown, x: 2636, y: 500, w: 200, h: 267 },
  { id: "terraces", src: pt.terraces, x: 2850, y: 500, w: 200, h: 267 },
  { id: "brick-podium", src: pt.brickPodium, x: 3064, y: 500, w: 200, h: 267 },
  { id: "lobby", src: pt.lobby, x: 304, y: 1030, w: 316, h: 236 },
  { id: "lobby-bright", src: pt.lobbyBright, x: 634, y: 1030, w: 316, h: 236 },
  { id: "masterplan", src: pt.masterplan, x: 1332, y: 1030, w: 316, h: 237 },
  { id: "creek-walk", src: pt.creekWalk, x: 1662, y: 1030, w: 400, h: 225 },
  { id: "gardens", src: pt.gardens, x: 2076, y: 1030, w: 364, h: 205 },
  { id: "dolly-in", src: pt.dollyIn, x: 2912, y: 1030, w: 180, h: 240, video: !0 },
  { id: "day-to-night", src: pt.dayToNight, x: 3106, y: 1030, w: 300, h: 169, video: !0 },
  { id: "sky-lounge", src: pt.skyLounge, x: 3420, y: 1030, w: 300, h: 169, video: !0 }
], ti = { id: "hero", kind: "Image", model: "Nano Banana Pro", name: "Hero options", x: 1332, y: 500, thumbs: [], foot: "No runs yet" }, rP = [
  { id: "site", kind: "Image", model: "Nano Banana Pro", name: "Site photos", x: 28, y: 30, thumbs: [pt.aerial, pt.depot, pt.creek], foot: "Updated Sep 2" },
  { id: "sketch", kind: "Image", model: "Nano Banana 2", name: "Sketch options", x: 1928, y: 30, thumbs: [pt.sketchCanyon, pt.sketchSalt, pt.sketchShore], foot: "Updated Sep 4" },
  { id: "white", kind: "Image", model: "Seedream 5 Lite", name: "White card", x: 2636, y: 30, thumbs: [pt.whiteCardSet, pt.lobbyModel], foot: "Updated Sep 5" },
  { id: "directions", kind: "Image", model: "Nano Banana 2", name: "Directions", x: 28, y: 500, thumbs: [pt.optionB, pt.optionC, pt.watercolor], foot: "Updated Sep 6" },
  ti,
  { id: "facade", kind: "Image", model: "Nano Banana Pro", name: "Facade", x: 3292, y: 500, thumbs: [pt.openCrown, pt.terraces, pt.brickPodium], foot: "Updated Sep 9" },
  { id: "lobby", kind: "Image", model: "Nano Banana 2", name: "Lobby", x: 28, y: 1030, thumbs: [pt.lobby, pt.lobbyBright], foot: "Updated Sep 11" },
  { id: "motion", kind: "Video", model: "Kling 2.6 Pro", name: "Hero dolly-in", x: 2636, y: 1030, thumbs: [pt.dollyIn, pt.dayToNight, pt.skyLounge], foot: "Updated Sep 12" }
], Qh = { id: "cover", text: "Golden hour for the cover. Client review Thursday.", by: "MT", tint: "amethyst", x: 1332, y: 676, w: 252, h: 96 }, aP = [
  { id: "creek", text: "Option B reads best from the creek.", by: "KB", tint: "amber", x: 2194, y: 30, w: 246, h: 120 },
  { id: "canyon", text: "Canyon for the competition entry.", by: "JR", tint: "rose", x: 946, y: 500, w: 190, h: 120 },
  { id: "podium", text: "Brick podium is the keeper.", by: "MT", tint: "mint", x: 3292, y: 676, w: 252, h: 96 }
], e1 = "Photoreal, at golden hour, dusk, blue hour and night";
function t1(n) {
  const e = (t, i) => t >= n.x && t < n.x + n.w && i >= n.y && i < n.y + n.h;
  return oP.filter((t) => e(t.x, t.y)).length + rP.filter((t) => e(t.x, t.y)).length + aP.filter((t) => e(t.x, t.y)).length;
}
const ep = { x: 1886, y: 650 }, yAe = 0.6;
function xAe(n, e = 0) {
  const t = n.x + (n.w || 0) / 2, i = n.y + (n.h || 0) / 2, s = Math.hypot(ep.x, ep.y), o = yAe * Math.pow(Math.min(1, Math.hypot(t - ep.x, i - ep.y) / s), 0.85) - e;
  return Math.max(0, Math.round(o * 1e3) / 1e3);
}
const tc = { fx: 1886, fy: 628, z: 0.29 }, Bp = { fx: 1886, fy: 653, z: 0.9 };
function wAe(n, e, t) {
  return { x: jf.x + (e - n.fx) * n.z, y: jf.y + (t - n.fy) * n.z };
}
function n1(n, e, t) {
  return { fx: n.fx + (e.fx - n.fx) * t, fy: n.fy + (e.fy - n.fy) * t, z: n.z * Math.pow(e.z / n.z, t) };
}
function Uo(n, e, t, i) {
  const s = 3 * n, o = 3 * (t - n) - s, r = 1 - s - o, a = 3 * e, l = 3 * (i - e) - a, d = 1 - a - l, c = (p) => ((r * p + o) * p + s) * p, h = (p) => ((d * p + l) * p + a) * p, f = (p) => (3 * r * p + 2 * o) * p + s;
  return (p) => {
    if (p <= 0) return 0;
    if (p >= 1) return 1;
    let y = p;
    for (let w = 0; w < 8; w++) {
      const S = c(y) - p;
      if (Math.abs(S) < 1e-6) return h(y);
      const M = f(y);
      if (Math.abs(M) < 1e-6) break;
      y -= S / M;
    }
    let v = 0, x = 1;
    y = p;
    for (let w = 0; w < 30; w++) {
      const S = c(y);
      if (Math.abs(S - p) < 1e-6) break;
      S < p ? v = y : x = y, y = (v + x) / 2;
    }
    return h(y);
  };
}
const Je = {
  /** the camera's dive: slow away, slow to rest */
  dive: Uo(0.65, 0, 0.3, 1),
  /** the pull back: it eases away, then settles over a long tail */
  settle: Uo(0.5, 0, 0.12, 1),
  /** the pointer: quick to start, gentle to arrive */
  move: Uo(0.4, 0, 0.2, 1),
  /** the board's --ease-out-soft: things arriving */
  out: Uo(0.16, 1, 0.3, 1),
  linear: (n) => n,
  sine: (n) => 0.5 - 0.5 * Math.cos(Math.PI * n)
}, pu = (n) => n < 0 ? 0 : n > 1 ? 1 : n;
function Ge(n, e, t, i = Je.linear) {
  return i(pu((n - e) / (t - e)));
}
function kAe(n) {
  const t = n - 1;
  return 1 + t * t * ((1.9 + 1) * t + 1.9);
}
const Fp = 30, je = {
  zoomIn: [1.2, 3.8],
  cursorIn: [3.9, 4.2],
  toSession: [4, 4.7],
  clickSession: 4.75,
  promptOpen: [4.8, 5.3],
  toWhiteCard: [5.45, 6.05],
  /** Shift goes down: the keycap shows beside the pointer */
  shift: 6.05,
  /** the press on the model: its copy lifts */
  press: 6.2,
  drag: [6.25, 7.05],
  drop: 7.1,
  type: [7.4, 9.4],
  toRun: [9.5, 10],
  run: 10.05,
  land: 11.95,
  toHeart: [12.65, 13.25],
  heart: 13.35,
  note: 14.05,
  toEmpty: [14.85, 15.45],
  deselect: 15.5,
  promptClose: [15.55, 16],
  cursorOut: [15.75, 16.15],
  zoomOut: [16.05, 19.65],
  sheen: [21.2, 23.9],
  /** the run's additions leave, while the board is small, ready for the next loop */
  reset: [28.2, 29.2]
}, u3 = 14.75;
function _Ae(n) {
  return n < je.zoomIn[0] ? tc : n < je.zoomIn[1] ? n1(tc, Bp, Ge(n, je.zoomIn[0], je.zoomIn[1], Je.dive)) : n < je.zoomOut[0] ? Bp : n < je.zoomOut[1] ? n1(Bp, tc, Ge(n, je.zoomOut[0], je.zoomOut[1], Je.settle)) : tc;
}
function ev(n, e) {
  return wAe(Bp, n, e);
}
const wi = {
  start: { x: 760, y: 262 },
  session: ev(ti.x + 132, ti.y + 50),
  whiteCard: ev(Tl.x + 78, Tl.y + 112),
  slot: { x: Fo.x + Fo.w / 2 + 2, y: Fo.y + Fo.h / 2 + 2 },
  run: { x: ec.x + ec.w / 2 + 4, y: ec.y + ec.h / 2 + 3 },
  heart: ev(No[0].x + 17, No[0].y + 17),
  // clear canvas, below Hero options and right of the prompt
  empty: { x: 968, y: 398 }
}, SAe = [
  { at: je.toSession, from: wi.start, to: wi.session, arc: 0.12 },
  { at: je.toWhiteCard, from: wi.session, to: wi.whiteCard, arc: -0.1 },
  { at: je.drag, from: wi.whiteCard, to: wi.slot, arc: 0.16 },
  { at: je.toRun, from: wi.slot, to: wi.run, arc: -0.08 },
  { at: je.toHeart, from: wi.run, to: wi.heart, arc: 0.1 },
  { at: je.toEmpty, from: wi.heart, to: wi.empty, arc: -0.12 }
];
function tv(n) {
  let e = wi.start;
  for (const t of SAe) {
    if (n < t.at[0]) return e;
    if (n < t.at[1]) {
      const i = Ge(n, t.at[0], t.at[1], Je.move), s = t.to.x - t.from.x, o = t.to.y - t.from.y, r = Math.sin(Math.PI * i) * t.arc;
      return { x: t.from.x + s * i - o * r, y: t.from.y + o * i + s * r };
    }
    e = t.to;
  }
  return e;
}
const lP = [je.clickSession, je.run, je.heart, je.deselect], h3 = (() => {
  const n = Array.from(e1, (s, o) => {
    const r = e1[o - 1], a = (Math.sin(o * 12.9898) * 43758.5453 % 1 + 1) % 1;
    return (r === "," ? 3.2 : r === " " ? 1.5 : 1) * (0.82 + 0.36 * a);
  }), e = n.reduce((s, o) => s + o, 0), t = je.type[1] - je.type[0];
  let i = 0;
  return n.map((s) => (i += s, je.type[0] + i / e * t));
})();
function MAe(n) {
  if (n < je.type[0] || n >= je.reset[1]) return 0;
  let e = 0;
  for (; e < h3.length && h3[e] <= n; ) e++;
  return e;
}
function TAe(n, e, t, i) {
  return n < e || n > t ? 0 : Math.min(pu((n - e) / i), pu((t - n) / i));
}
function CAe(n) {
  for (const e of lP) if (n >= e - 0.02 && n < e + 0.14) return 1;
  return n >= je.press && n < je.drop ? 1 : 0;
}
function tp(n) {
  const e = (n % Fp + Fp) % Fp, t = _Ae(e), i = 1 - Ge(e, je.reset[0], je.reset[1], Je.sine), s = e >= je.land && e < je.reset[1], o = tv(e), r = Math.min(Ge(e, je.cursorIn[0], je.cursorIn[1], Je.sine), 1 - Ge(e, je.cursorOut[0], je.cursorOut[1], Je.sine));
  let a = { x: o.x, y: o.y, shown: 0, size: 0 };
  for (const F of lP)
    if (e >= F && e < F + 0.5) {
      const ie = (e - F) / 0.5;
      a = { x: tv(F).x, y: tv(F).y, shown: 0.42 * (1 - ie), size: 0.45 + 0.75 * Je.out(ie) };
    }
  const l = Ge(e, je.press, je.press + 0.2, Je.out), d = Ge(e, je.drop, je.drop + 0.18, Je.sine), c = Ge(e, je.drag[1] - 0.3, je.drag[1], Je.sine), h = {
    x: o.x,
    y: o.y,
    shown: e >= je.press && e < je.drop + 0.18 ? l * (1 - d) : 0,
    tilt: -7 * (1 - c),
    ring: c
  }, f = Ge(e, je.promptOpen[0], je.promptOpen[1], Je.out) * (1 - Ge(e, je.promptClose[0], je.promptClose[1], Je.sine)), p = MAe(e), y = e >= je.type[0] && e < je.type[1] + 0.05, v = (F) => Math.floor((e - F) / 0.53) % 2 === 0 ? 1 : 0;
  let x = 0;
  f > 0.5 && e < je.run && (x = y ? 1 : v(e < je.type[0] ? je.promptOpen[1] : je.type[1]));
  const w = e >= je.drop && e < je.promptClose[1] ? Ge(e, je.drop, je.drop + 0.55, Je.out) : 0, S = e - je.drop, M = w > 0 && S < 5 ? Math.min(pu(S / 0.6), pu((5 - S) / 1)) * (0.55 + 0.45 * Math.sin(S / 2.5 * Math.PI * 2 - Math.PI / 2)) : 0, _ = e >= je.promptClose[1] ? 0 : Ge(e, je.type[0], je.type[0] + 0.25, Je.sine), T = e >= je.run - 0.02 && e < je.run + 0.14 ? 1 : 0, k = e >= je.run && e < je.land, P = Ge(e, je.clickSession, je.clickSession + 0.18) * (1 - Ge(e, je.deselect, je.deselect + 0.18));
  let A = ti.foot;
  k ? A = "Generating… 0:0" + Math.floor(e - je.run) : s && e < je.reset[0] && (A = "Updated just now");
  const R = (F) => s ? Ge(e, je.land + F * 0.08, je.land + F * 0.08 + 0.65, Je.out) * i : 0, D = No.map((F, ie) => R(ie)), O = e >= je.note && e < je.reset[1];
  return {
    cam: t,
    pointer: { x: o.x, y: o.y, shown: r, pressed: CAe(e), shift: TAe(e, je.shift, je.drop + 0.3, 0.15) },
    ripple: a,
    ghost: h,
    dock: 1 - f,
    prompt: f,
    refIn: w,
    refGlow: M,
    typed: p,
    caret: x,
    runLit: _,
    runPressed: T,
    runBusy: k,
    sessionSelected: P,
    sessionFoot: A,
    sessionThumbs: D,
    sessionCount: s ? 4 : 0,
    shimmer: k,
    results: D,
    heart: e >= je.heart && e < je.reset[1] ? kAe(Ge(e, je.heart, je.heart + 0.38)) * i : 0,
    note: O ? Ge(e, je.note, je.note + 0.65, Je.out) * i : 0,
    frameItems: t1(sP) + (s && e < je.reset[0] ? No.length : 0) + (O && e < je.reset[0] ? 1 : 0),
    sheen: e >= je.sheen[0] && e < je.sheen[1] ? Ge(e, je.sheen[0], je.sheen[1], Je.sine) : -1
  };
}
const Mx = [
  { id: "board", label: "Board" },
  { id: "session", label: "Sessions" },
  { id: "generate", label: "Generate" },
  { id: "studio", label: "Studio view" },
  { id: "edit", label: "Edit" },
  { id: "chat", label: "Chat" },
  { id: "finish", label: "Finish" }
], dP = "Bonneville Tower", IAe = "Client review Thursday: a hero render from Depot Street. Planted terraces, the mountains behind.", AAe = "MT", p3 = "Bonneville Tower from Depot Street, planted timber terraces, a glass crown, the Wasatch behind, photoreal", f3 = "Make it night, with warm light in every window", m3 = 4, PAe = "https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-", Ji = (n) => PAe + n + "-800w.webp", Iu = [
  { id: "site-aerial", src: Ji("s01-existing-site-aerial-f3aa4c"), label: "Site aerial" },
  { id: "site-depot", src: Ji("s02-existing-depot-street-7c94e0"), label: "Depot Street today" },
  { id: "site-creek", src: Ji("s03-existing-buried-creek-channel-160598"), label: "Buried creek channel" }
], Hf = [
  { src: Ji("t03-autumn-golden-hour-3768d6"), label: "Golden hour" },
  { src: Ji("t01-spring-noon-3be8a4"), label: "Spring noon" },
  { src: Ji("t07-alpenglow-dusk-1d0baa"), label: "Alpenglow" },
  { src: Ji("e12-hero-v3-deeper-terraces-1c4ede"), label: "Deeper terraces" }
], nc = { src: Ji("t06-night-facade-lighting-69ccb0"), label: "Night, windows lit" }, Va = { w: 300, h: 402 }, EAe = "Show this tower in each of these site photos", cP = "Nano Banana Pro", Wa = {
  title: "The finished tower, from each site photo",
  session: "Site photos, finished",
  prompt: "Image 1 is a photo of the site; image 2 is the tower designed for it. Show this site with the tower finished, from image 1's viewpoint and in its light: the tower's planted timber terraces and glass crown, green streets, the buried creek opened up as a park. Photorealistic architectural photograph.",
  why: "It keeps each photo's viewpoint and light, so every view lines up with the site",
  /** the runs' shape: the site photos' own */
  size: "16:9"
}, RAe = "I can see a render of the tower and three site photos in this frame: the aerial, Depot Street today and the buried creek channel. I'll give each photo to " + cP + " with the tower render, one run per photo, so you see the tower finished from every viewpoint.", zAe = "Done: three views, set out in the frame under the session. From Depot Street the tower sits just out of the photo, so that one shows the planted street instead. Open the session to change its prompt or run it again.", i1 = {
  "site-aerial": { src: Ji("s06-masterplan-aerial-55b63e"), label: "Aerial, finished" },
  "site-depot": { src: Ji("l09-greener-depot-street-a56204"), label: "Depot Street, finished" },
  "site-creek": { src: Ji("l04-creek-walk-marketing-hero-92d17d"), label: "Creek walk, finished" }
}, Wi = [
  {
    id: "welcome",
    chapter: "board",
    eyebrow: "Welcome to Boards",
    title: "Every project, on one board",
    body: "A board is an endless space for a project: the images, the AI sessions that make them, and the notes around them, side by side. Let's make your first image together. It takes about three minutes.",
    kind: "continue",
    demo: "board",
    place: "center"
  },
  {
    id: "look",
    chapter: "board",
    title: "Here's your brief",
    body: "This practice board holds the site photos for " + dP + " and a note from the client. Let's make the render they asked for. Nothing here is saved, and nothing costs tokens.",
    kind: "continue",
    place: "below"
  },
  {
    id: "add-session",
    hint: "Use the glowing + button, in the bar at the bottom, then Image",
    chapter: "session",
    title: "Start a tool session",
    body: "A session is an AI tool that lives on your board. It keeps its model, your prompt and every image it makes, all in one place.",
    task: "Click **+** and choose **Image**",
    kind: "click",
    demo: "session",
    place: "above"
  },
  {
    id: "open-session",
    hint: "Click the session card that's lit up",
    chapter: "session",
    title: "Open it to write a prompt",
    body: "Your session is on the board, beside the brief. Click any session to open its prompt, and click the board to put it away.",
    task: "Click the session",
    kind: "click",
    demo: "open",
    place: "right"
  },
  {
    id: "tab-prompt",
    hint: "Press the Tab key on your keyboard",
    chapter: "generate",
    title: "Write the prompt with Tab",
    body: "Say what to make: the subject, where it stands, the light. We've drafted this one from the brief.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    demo: "prompt",
    place: "above"
  },
  {
    id: "run",
    hint: "Click Run, at the prompt's bottom right",
    chapter: "generate",
    title: "Run it",
    body: "Run sends your prompt to the model. This session makes four images at a time, so you can pick the best.",
    task: "Click **Run**",
    kind: "run",
    demo: "run",
    place: "above",
    waiting: { title: "Making your images", body: "A real run takes about half a minute. This practice one is quicker." },
    landed: { title: "Your four images are in", body: "Four takes on the brief, each in its own light." }
  },
  {
    id: "results",
    chapter: "generate",
    title: "Four options, kept in the session",
    body: "Each image lands in its session: on the card, and in the gallery on the right. Open the session any time to find them again.",
    kind: "continue",
    // the run's own demonstration carries on (it shows just this), so the card holds still as the words change
    demo: "run",
    place: "left"
  },
  {
    id: "drag",
    hint: "Hold a picture in the gallery, then drag it onto the board",
    chapter: "generate",
    title: "Put one on the board",
    body: "Drag a picture out of the gallery to lay it out on the board, beside the session it came from. The session keeps every image either way.",
    task: "Drag an image onto the board",
    kind: "drag",
    demo: "drag",
    place: "left"
  },
  {
    id: "studio-open",
    hint: "Click Studio, at the prompt's top right",
    chapter: "studio",
    title: "Studio view: the session, full screen",
    body: "Studio view gives a session the whole screen: the picture large, its versions above it, and every editing tool beside it.",
    task: "Click **Studio**",
    kind: "click",
    demo: "studio",
    place: "above"
  },
  {
    id: "edit-side",
    hint: "Click Edit, at the top left",
    chapter: "edit",
    title: "Switch to Edit",
    body: "Generate makes new images from words. Edit changes the picture in the viewer.",
    task: "Click **Edit**",
    kind: "click",
    demo: "edit",
    place: "top-right"
  },
  {
    id: "edit-tab",
    hint: "Press the Tab key on your keyboard",
    chapter: "edit",
    title: "Say what changes",
    body: "Plain words are enough. To change just one part, paint over it first so the model knows where to focus.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    place: "top-right"
  },
  {
    id: "edit-run",
    hint: "Click Run, under the picture",
    chapter: "edit",
    title: "Run the edit",
    body: "The edit becomes a new version of the picture, and the one you started from is kept.",
    task: "Click **Run**",
    kind: "run",
    place: "top-right",
    waiting: { title: "Making the new version", body: "Same building, same view. Only what you asked for changes." },
    landed: { title: "Your new version is in", body: "Night, with warm light in every window, as you asked." }
  },
  {
    id: "edit-result",
    chapter: "edit",
    title: "Same building, new light",
    body: "Every edit is a version you can step through above the picture, or split two to compare. Relight, Change camera and Upscale wait in the list on the left.",
    kind: "continue",
    place: "top-right"
  },
  {
    id: "chat-open",
    hint: "Click Chat, on the bar over the Site photos frame",
    chapter: "chat",
    // the tour closes Studio view on the way here (TourController), so this says it did
    note: { did: "We closed Studio view for you", how: "To close it yourself, press **Esc** or click the back arrow at its top left." },
    title: "Hand a chat the work",
    body: "A chat lives in a frame, and everything in the frame is what it works with: here, the three site photos and the tower render we've added beside them. Say what you need, and it sets up the sessions and runs them for you.",
    task: "Click **Chat** on the frame",
    kind: "click",
    demo: "chat",
    place: "right"
  },
  {
    id: "chat-tab",
    hint: "Press the Tab key on your keyboard",
    chapter: "chat",
    title: "Ask in plain words",
    body: "Say it the way you'd ask a colleague. It sees the photos, so you only say what you want from them.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    place: "left"
  },
  {
    id: "chat-send",
    hint: "Press Enter, or click the arrow under the message",
    chapter: "chat",
    title: "Send it",
    body: "It reads the frame first, then answers with a plan.",
    task: "Press **Enter** to send it",
    kind: "run",
    place: "left",
    waiting: { title: "Reading the frame", body: "It looks at each photo, then works out the session, its prompt and what it costs." },
    landed: { title: "Here's its plan", body: "One session and a run per photo, with what it would cost. Nothing has run yet." }
  },
  {
    id: "chat-run",
    hint: "Click Run plan, at the bottom of the plan",
    chapter: "chat",
    title: "Nothing runs until you say so",
    body: "A plan shows its sessions, the prompt it wrote and the cost before anything is spent. One click runs the lot.",
    task: "Click **Run plan**",
    kind: "run",
    place: "left",
    waiting: { title: "Working in the frame", body: "It adds the session, gives it each photo in turn and runs it. Watch the frame." },
    landed: { title: "Every photo, finished", body: "A new picture from each viewpoint, set out in the frame under the session that made it." }
  },
  {
    id: "chat-result",
    chapter: "chat",
    title: "Its work is yours to change",
    body: "What the chat made is an ordinary session in the frame: open it to change the prompt or run it again. Anyone on the board can open the chat and carry on.",
    kind: "continue",
    place: "left"
  },
  {
    id: "organize",
    chapter: "finish",
    title: "Keep the whole project together",
    body: "Frames group the work, notes keep decisions beside it, and comments start a conversation right on the board. Press F for a frame and N for a note.",
    kind: "continue",
    demo: "organize",
    place: "bottom-center"
  },
  {
    id: "finale",
    chapter: "finish",
    title: "You're ready",
    body: "",
    kind: "continue",
    place: "center"
  }
];
function Am(n) {
  const e = Wi.find((t) => t.id === n);
  if (!e) throw new Error("No tour step " + n);
  return e;
}
function $Ae(n) {
  return Mx.findIndex((e) => e.id === n);
}
function Tx(n) {
  const e = (n.title || "").trim();
  return !e || /^untitled board$/i.test(e) ? "your new board" : e;
}
function DAe(n, e) {
  return n === "first-board" && e ? "Take a three-minute tour of how a board works before you start on " + Tx(e) + ". You'll make an image, edit it, ask a chat to run some work for you, and see where your results go. Nothing here is saved, and nothing costs tokens." : n === "replay" ? "Everything a board does, in about three minutes. You'll make an image, edit it, ask a chat to run some work for you, and see where your results go. Nothing here is saved, and nothing costs tokens." : Am("welcome").body;
}
function OAe(n) {
  return n === "replay" ? "Start" : "Start the tour";
}
function LAe(n, e) {
  if (n === "first-board" && e) {
    const t = Tx(e);
    return "That's the heart of Boards: sessions on the board, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. " + t.charAt(0).toUpperCase() + t.slice(1) + " is ready for you.";
  }
  return n === "replay" ? "That's the tour: sessions on the board, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. Your boards are right where you left them." : "That's the heart of Boards: sessions on the board, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. Your first board is one click away.";
}
const BAe = [
  "Sessions live on your board",
  "Tab writes a prompt",
  "Every image stays in its session",
  "Studio view edits in place",
  "A chat works with its frame"
];
function FAe(n, e) {
  if (n === "new-account") return { label: "Create my first board", exit: "create-board" };
  if (e) {
    const t = Tx(e) === "your new board";
    return n === "first-board" ? { label: t ? "Open my board" : "Open " + e.title, exit: "open-board" } : { label: t ? "Back to my board" : "Back to " + e.title, exit: "open-board" };
  }
  return { label: "Done", exit: "leave" };
}
function g3(n) {
  const e = [], t = /\*\*([^*]+)\*\*/g;
  let i = 0, s;
  for (; s = t.exec(n); )
    s.index > i && e.push({ text: n.slice(i, s.index), strong: !1 }), e.push({ text: s[1], strong: !0 }), i = s.index + s[0].length;
  return i < n.length && e.push({ text: n.slice(i), strong: !1 }), e;
}
const So = { w: 640, h: 360 }, b3 = (n) => n < 0 ? 0 : n > 1 ? 1 : n, ra = (n) => ({ x: n.x + n.w / 2, y: n.y + n.h / 2 });
function no(n, e, t, i = 0.3, s = 0.3) {
  return n < e || n > t ? 0 : Math.min(b3((n - e) / i), b3((t - n) / s));
}
function ur(n, e, t, i, s, o = []) {
  let r = e, a = e, l = !1;
  for (const h of t) {
    if (n < h.at[0]) {
      a = r, l = !0;
      break;
    }
    if (n < h.at[1]) {
      const f = Ge(n, h.at[0], h.at[1], Je.move), p = h.to.x - r.x, y = h.to.y - r.y, v = Math.sin(Math.PI * f) * (h.arc == null ? 0.1 : h.arc);
      a = { x: r.x + p * f - y * v, y: r.y + y * f + p * v }, l = !0;
      break;
    }
    r = h.to;
  }
  l || (a = r);
  let d = { x: a.x, y: a.y, shown: 0, size: 0 };
  for (const h of i)
    if (n >= h && n < h + 0.5) {
      const f = (n - h) / 0.5, p = ur(h, e, t, [], s);
      d = { x: p.x, y: p.y, shown: 0.5 * (1 - f), size: 0.45 + 0.8 * Je.out(f) };
    }
  const c = i.some((h) => n >= h - 0.03 && n < h + 0.14) || o.some(([h, f]) => n >= h && n < f);
  return { x: a.x, y: a.y, shown: no(n, s[0], s[1], 0.3, 0.35), pressed: c, ring: d };
}
const Ni = { w: 252, h: 160 }, Yn = Hf.map((n) => n.src.replace("-800w.webp", "-400w.webp")), Vf = nc.src.replace("-800w.webp", "-400w.webp"), fu = "Bonneville Tower from Depot Street, planted terraces, photoreal", v3 = "Make it night, warm light in every window";
function Pm(n, e, t, i) {
  if (e <= t) return "";
  if (e >= i) return n;
  const s = Array.from(n), o = s.map((c, h) => s[h - 1] === "," ? 3 : s[h - 1] === " " ? 1.4 : 1), r = o.reduce((c, h) => c + h, 0), a = (e - t) / (i - t) * r;
  let l = 0, d = 0;
  for (; d < s.length && l + o[d] <= a; ) l += o[d++];
  return s.slice(0, d).join("");
}
const Ei = {
  loop: 8.4,
  still: 6.2,
  dock: { x: 196, y: 298, w: 248, h: 46 },
  /** the dock's + (CHAT-20: it opens the tool menu) */
  add: { x: 201, y: 304, w: 34, h: 34 },
  /** the tool menu, risen from the dock */
  menu: { x: 180, y: 118, w: 280, h: 170 },
  /** its Image row */
  image: { x: 188, y: 174, w: 264, h: 30 },
  card: { x: 194, y: 58, w: Ni.w, h: Ni.h },
  tags: ["Its model", "Your prompt", "Every image it makes"],
  T: { cursorIn: [0.35, 7.7], toAdd: [0.6, 1.4], click: 1.55, menu: [1.62, 1.95], toImage: [2.15, 2.85], pick: 3, menuOut: [3.05, 3.3], land: [3.2, 3.85], tags: [4.05, 4.35, 4.65], reset: [7.6, 8.25] }
};
function NAe(n) {
  const e = Ei, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = Ge(t, e.T.land[0], e.T.land[1], Je.out) * i;
  return {
    pointer: ur(t, { x: 560, y: 210 }, [
      { at: e.T.toAdd, to: ra(e.add), arc: -0.12 },
      { at: e.T.toImage, to: { x: e.image.x + 46, y: e.image.y + e.image.h / 2 }, arc: 0.08 }
    ], [e.T.click, e.T.pick], e.T.cursorIn),
    addLit: no(t, e.T.click - 0.05, e.T.menuOut[0], 0.05, 0.2),
    menu: Ge(t, e.T.menu[0], e.T.menu[1], Je.out) * (1 - Ge(t, e.T.menuOut[0], e.T.menuOut[1], Je.sine)),
    imageLit: no(t, e.T.toImage[1] - 0.15, e.T.menuOut[0], 0.15, 0.1),
    card: s,
    selected: Ge(t, e.T.land[1] - 0.1, e.T.land[1] + 0.2) * i,
    tags: e.T.tags.map((o) => Ge(t, o, o + 0.45, Je.out) * i)
  };
}
const il = {
  loop: 6.4,
  still: 3.4,
  card: { x: 194, y: 40, w: Ni.w, h: Ni.h },
  prompt: { x: 70, y: 218, w: 500, h: 124 },
  dock: { x: 196, y: 298, w: 248, h: 46 },
  empty: { x: 96, y: 128 },
  T: { cursorIn: [0.3, 5.9], toCard: [0.5, 1.3], click: 1.45, open: [1.55, 2.05], toEmpty: [3.6, 4.3], away: 4.45, close: [4.55, 5] }
};
function UAe(n) {
  const e = il, t = (n % e.loop + e.loop) % e.loop, i = Ge(t, e.T.open[0], e.T.open[1], Je.out) * (1 - Ge(t, e.T.close[0], e.T.close[1], Je.sine));
  return {
    pointer: ur(t, { x: 560, y: 150 }, [
      { at: e.T.toCard, to: { x: e.card.x + 128, y: e.card.y + 52 }, arc: 0.1 },
      { at: e.T.toEmpty, to: e.empty, arc: -0.1 }
    ], [e.T.click, e.T.away], e.T.cursorIn),
    selected: Ge(t, e.T.click, e.T.click + 0.18) * (1 - Ge(t, e.T.away, e.T.away + 0.18)),
    prompt: i
  };
}
const Io = {
  loop: 7.2,
  still: 5.2,
  prompt: { x: 40, y: 40, w: 560, h: 156 },
  key: { x: 272, y: 240, w: 96, h: 56 },
  T: { fadeIn: 0.35, keyIn: [0.4, 0.8], press: [1.45, 1.7], type: [1.75, 4.3], run: 4.4, keyOut: [5.6, 6], reset: [6.4, 7] }
}, GAe = { ghost: 1, typed: "", caret: 0, cue: 1, key: 0, keyDown: !1, runLit: 0, fade: 0 };
function jAe(n) {
  const e = Io, t = (n % e.loop + e.loop) % e.loop, i = Math.min(Ge(t, 0, e.T.fadeIn, Je.sine), 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine));
  if (i <= 0) return { ...GAe };
  const s = t < e.T.reset[0] ? Pm(fu, t, e.T.type[0], e.T.type[1]) : fu, o = t >= e.T.type[0] && t < e.T.type[1], r = Math.floor(t / 0.53) % 2 === 0 ? 1 : 0;
  return {
    ghost: t < e.T.type[0] ? 1 : 0,
    typed: t >= e.T.reset[1] ? "" : s,
    caret: o ? 1 : t < e.T.reset[0] ? r : 0,
    cue: t < e.T.type[0] ? 1 - Ge(t, e.T.press[0], e.T.type[0]) : 0,
    key: no(t, e.T.keyIn[0], e.T.keyOut[1], 0.4, 0.4),
    keyDown: t >= e.T.press[0] && t < e.T.press[1],
    runLit: Ge(t, e.T.run, e.T.run + 0.3) * i,
    fade: i
  };
}
const sl = {
  loop: 8.2,
  still: 5.6,
  card: { x: 36, y: 36, w: Ni.w, h: Ni.h },
  prompt: { x: 30, y: 226, w: 400, h: 116 },
  run: { x: 356, y: 300, w: 62, h: 30 },
  gallery: { x: 452, y: 14, w: 174, h: 332 },
  T: { cursorIn: [0.3, 2.2], toRun: [0.5, 1.2], click: 1.35, busy: [1.4, 3.3], land: 3.3, gallery: [4, 4.7], reset: [7.4, 8.1] }
};
function HAe(n) {
  const e = sl, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = t >= e.T.busy[0] && t < e.T.busy[1], o = Yn.map((r, a) => t >= e.T.land ? Ge(t, e.T.land + a * 0.14, e.T.land + a * 0.14 + 0.5, Je.out) * i : 0);
  return {
    pointer: ur(t, { x: 560, y: 250 }, [{ at: e.T.toRun, to: ra(e.run), arc: 0.12 }], [e.T.click], e.T.cursorIn),
    busy: s,
    seconds: s ? Math.floor(t - e.T.busy[0]) : 0,
    thumbs: o,
    count: t >= e.T.land && t < e.T.reset[0] ? Yn.length : 0,
    gallery: Ge(t, e.T.gallery[0], e.T.gallery[1], Je.out) * i,
    foot: s ? "Generating… 0:0" + Math.floor(t - e.T.busy[0] + 1) : t >= e.T.land && t < e.T.reset[0] ? "Updated just now" : "No runs yet",
    runPressed: t >= e.T.click - 0.03 && t < e.T.click + 0.14
  };
}
const ki = {
  loop: 7,
  still: 3.4,
  card: { x: 36, y: 36, w: Ni.w, h: Ni.h },
  gallery: { x: 452, y: 14, w: 174, h: 332 },
  /** the gallery's first picture */
  pick: { x: 462, y: 54, w: 73, h: 98 },
  /** where it lands on the board */
  drop: { x: 316, y: 26, w: 116, h: 156 },
  T: { cursorIn: [0.3, 5], toPick: [0.5, 1.2], press: 1.38, drag: [1.5, 2.65], drop: 2.75, reset: [6.2, 6.8] }
};
function VAe(n) {
  const e = ki, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = { x: e.drop.x + 40, y: e.drop.y + 54 }, o = ur(t, { x: 560, y: 300 }, [
    { at: e.T.toPick, to: { x: e.pick.x + 30, y: e.pick.y + 40 }, arc: 0.1 },
    { at: e.T.drag, to: s, arc: -0.18 }
  ], [], e.T.cursorIn, [[e.T.press, e.T.drop]]), r = Ge(t, e.T.press, e.T.press + 0.2, Je.out), a = Ge(t, e.T.drop, e.T.drop + 0.16, Je.sine), l = Ge(t, e.T.drag[1] - 0.35, e.T.drag[1], Je.sine);
  return {
    pointer: o,
    ghost: { x: o.x, y: o.y, shown: t >= e.T.press && t < e.T.drop + 0.16 ? r * (1 - a) : 0, tilt: -8 * (1 - l) },
    placed: t >= e.T.drop ? Ge(t, e.T.drop, e.T.drop + 0.45, Je.out) * i : 0,
    slot: no(t, e.T.press + 0.1, e.T.drop + 0.1, 0.25, 0.2)
  };
}
const Fs = {
  loop: 8,
  still: 4.2,
  card: { x: 194, y: 34, w: Ni.w, h: Ni.h },
  prompt: { x: 70, y: 214, w: 500, h: 128 },
  pill: { x: 482, y: 224, w: 76, h: 26 },
  T: { cursorIn: [0.3, 1.9], toPill: [0.5, 1.3], hover: 1.3, click: 1.7, open: [1.85, 2.6], close: [6.5, 7.1], reset: [7.1, 7.6] }
};
function WAe(n) {
  const e = Fs, t = (n % e.loop + e.loop) % e.loop, i = Ge(t, e.T.open[0], e.T.open[1], Je.dive) * (1 - Ge(t, e.T.close[0], e.T.close[1], Je.sine));
  return {
    pointer: ur(t, { x: 600, y: 120 }, [{ at: e.T.toPill, to: ra(e.pill), arc: 0.14 }], [e.T.click], e.T.cursorIn),
    pillLit: no(t, e.T.hover, e.T.open[1], 0.2, 0.2),
    open: i,
    parts: Ge(t, e.T.open[1] - 0.1, e.T.open[1] + 0.6, Je.out) * (1 - Ge(t, e.T.close[0], e.T.close[0] + 0.3))
  };
}
const Ao = {
  loop: 9.4,
  still: 7.2,
  stage: { x: 222, y: 30, w: 196, h: 262 },
  bar: { x: 162, y: 302, w: 316, h: 44 },
  run: { x: 416, y: 310, w: 54, h: 28 },
  /** the painted area: over the tower's middle floors */
  stroke: "M262 128 C 300 120, 336 122, 378 130 M262 150 C 300 142, 340 146, 380 152 M264 172 C 302 166, 338 168, 378 174",
  T: { cursorIn: [0.3, 4.9], toPaint: [0.5, 1], paint: [1.05, 2.4], type: [2.6, 4], toRun: [4, 4.5], click: 4.62, busy: [4.7, 5.6], wipe: [5.6, 6.5], version: 6.5, reset: [8.6, 9.2] }
};
function qAe(n) {
  const e = Ao, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = ur(t, { x: 560, y: 200 }, [
    { at: e.T.toPaint, to: { x: 262, y: 128 }, arc: 0.08 },
    { at: [e.T.paint[0], e.T.paint[0] + 0.45], to: { x: 378, y: 130 }, arc: -0.03 },
    { at: [e.T.paint[0] + 0.45, e.T.paint[0] + 0.9], to: { x: 262, y: 150 }, arc: 0.02 },
    { at: [e.T.paint[0] + 0.9, e.T.paint[1]], to: { x: 378, y: 172 }, arc: -0.02 },
    { at: e.T.toRun, to: ra(e.run), arc: 0.1 }
  ], [e.T.click], e.T.cursorIn, [[e.T.paint[0], e.T.paint[1]]]), o = t >= e.T.reset[1] ? "" : t < e.T.reset[0] ? Pm(v3, t, e.T.type[0], e.T.type[1]) : v3;
  return {
    pointer: s,
    brush: t >= e.T.toPaint[1] - 0.1 && t < e.T.paint[1] + 0.15,
    // the area goes once the new version is in
    painted: t < e.T.wipe[1] ? Ge(t, e.T.paint[0], e.T.paint[1]) : 0,
    area: (1 - Ge(t, e.T.wipe[0], e.T.wipe[1])) * (t >= e.T.paint[0] ? 1 : 0),
    typed: o,
    busy: t >= e.T.busy[0] && t < e.T.busy[1],
    wipe: Ge(t, e.T.wipe[0], e.T.wipe[1], Je.dive) * i,
    versions: t >= e.T.version && t < e.T.reset[0] ? 2 : 1
  };
}
const KAe = Iu.map((n) => n.src.replace("-800w.webp", "-400w.webp")), YAe = Iu.map((n) => i1[n.id].src.replace("-800w.webp", "-400w.webp")), uP = "Show the finished tower in each of these photos", Ln = {
  loop: 11.8,
  still: 9.8,
  frame: { x: 24, y: 50, w: 372, h: 286 },
  /** where a click on the frame's title lands */
  title: { x: 62, y: 38 },
  photos: [
    { x: 40, y: 72, w: 108, h: 61 },
    { x: 156, y: 72, w: 108, h: 61 },
    { x: 272, y: 72, w: 108, h: 61 }
  ],
  /** each photo's finished view lands under it */
  finished: [
    { x: 40, y: 145, w: 108, h: 61 },
    { x: 156, y: 145, w: 108, h: 61 },
    { x: 272, y: 145, w: 108, h: 61 }
  ],
  /** the chat's card, in the frame */
  card: { x: 40, y: 222, w: 132, h: 96 },
  /** the frame's bar, and its Chat button */
  bar: { x: 150, y: 4, w: 118, h: 30 },
  chat: { x: 155, y: 9, w: 56, h: 20 },
  /** the chat panel, docked on the right, and what's in it (in the stage's pixels) */
  panel: { x: 412, y: 10, w: 216, h: 340 },
  bubble: { x: 452, y: 58, w: 168, h: 34 },
  answer: { x: 420, y: 104, w: 200, h: 30 },
  plan: { x: 440, y: 142, w: 180, h: 92 },
  run: { x: 538, y: 204, w: 76, h: 22 },
  composer: { x: 420, y: 284, w: 200, h: 58 },
  send: { x: 592, y: 314, w: 22, h: 22 },
  T: {
    cursorIn: [0.3, 9.6],
    toTitle: [0.5, 1.15],
    select: 1.3,
    toChat: [1.6, 2.2],
    open: 2.35,
    panel: [2.45, 2.95],
    card: [2.6, 3],
    type: [3.2, 4.5],
    toSend: [4.4, 4.95],
    send: 5.1,
    bubble: [5.15, 5.45],
    think: [5.45, 5.95],
    answer: [5.95, 6.5],
    plan: [6.55, 6.95],
    toRun: [7, 7.6],
    run: 7.75,
    busy: [7.8, 8.5],
    land: [8.5, 8.8, 9.1],
    reset: [10.8, 11.4]
  }
};
function XAe(n) {
  const e = Ln, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = t >= e.T.send, o = Ge(t, e.T.panel[0], e.T.panel[1], Je.out) * i;
  return {
    pointer: ur(t, { x: 560, y: 210 }, [
      { at: e.T.toTitle, to: e.title, arc: -0.1 },
      { at: e.T.toChat, to: ra(e.chat), arc: 0.12 },
      { at: e.T.toSend, to: ra(e.send), arc: -0.08 },
      { at: e.T.toRun, to: ra(e.run), arc: 0.1 }
    ], [e.T.select, e.T.open, e.T.send, e.T.run], e.T.cursorIn),
    // the frame selected shows its bar; both go as the chat opens (its glow takes over)
    selected: Ge(t, e.T.select, e.T.select + 0.18) * (1 - Ge(t, e.T.panel[0], e.T.panel[1])),
    bar: Ge(t, e.T.select, e.T.select + 0.2) * (1 - Ge(t, e.T.panel[0], e.T.panel[1])),
    chatLit: no(t, e.T.open - 0.05, e.T.open + 0.4, 0.05, 0.3),
    panel: o,
    glow: o * (1 - Ge(t, e.T.reset[0] - 0.4, e.T.reset[0])),
    card: Ge(t, e.T.card[0], e.T.card[1], Je.out) * i,
    typed: s || t >= e.T.reset[0] ? "" : Pm(uP, t, e.T.type[0], e.T.type[1]),
    sendLit: t >= e.T.type[1] && !s ? 1 : no(t, e.T.send - 0.05, e.T.send + 0.3, 0.05, 0.25),
    bubble: Ge(t, e.T.bubble[0], e.T.bubble[1], Je.out) * i,
    thinking: t >= e.T.think[0] && t < e.T.think[1],
    answer: Ge(t, e.T.answer[0], e.T.answer[1]) * i,
    plan: Ge(t, e.T.plan[0], e.T.plan[1], Je.out) * i,
    runLit: no(t, e.T.run - 0.05, e.T.run + 0.4, 0.05, 0.3),
    busy: t >= e.T.busy[0] && t < e.T.busy[1],
    done: t >= e.T.busy[1] && t < e.T.reset[0],
    finished: e.T.land.map((r) => Ge(t, r, r + 0.45, Je.out) * i)
  };
}
const Mn = {
  loop: 9,
  still: 5.2,
  frame: { x: 40, y: 46, w: 420, h: 214 },
  card: { x: 60, y: 92, w: Ni.w, h: Ni.h },
  pics: [
    { x: 332, y: 86, w: 54, h: 72 },
    { x: 392, y: 86, w: 54, h: 72 },
    { x: 332, y: 166, w: 54, h: 72 }
  ],
  note: { x: 486, y: 70, w: 128, h: 100 },
  pin: { x: 380, y: 92 },
  /** the frame's title, the note's words and the comment's, as the demo writes them */
  title: "Hero options",
  noteText: "Night version for the cover.",
  comment: "This one. Ship it.",
  T: { draw: [0.6, 1.8], title: [1.9, 2.5], note: [2.8, 3.4], pin: [3.8, 4.2], bubble: [4.2, 4.8], zoom: [5.6, 7], reset: [8.4, 9] }
};
function JAe(n) {
  const e = Mn, t = (n % e.loop + e.loop) % e.loop, i = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine);
  return {
    frame: Ge(t, e.T.draw[0], e.T.draw[1], Je.move) * i,
    title: t >= e.T.reset[0] ? "" : Pm(e.title, t, e.T.title[0], e.T.title[1]),
    note: Ge(t, e.T.note[0], e.T.note[1], Je.out) * i,
    pin: Ge(t, e.T.pin[0], e.T.pin[1], Je.out) * i,
    bubble: Ge(t, e.T.bubble[0], e.T.bubble[1], Je.out) * i,
    zoom: 1 - 0.18 * Ge(t, e.T.zoom[0], e.T.zoom[1], Je.settle) * i
  };
}
function Cx() {
  return typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function uo(n, e) {
  const t = /* @__PURE__ */ W(null), i = /* @__PURE__ */ qe(0), s = /* @__PURE__ */ W(0.55), o = /* @__PURE__ */ W({ x: 0, y: 0 }), r = Cx();
  let a = 0, l = 0, d = !1, c = null;
  function h() {
    const w = t.value;
    if (!w || !w.clientWidth) return;
    const S = w.clientWidth, M = w.clientHeight || S * So.h / So.w, _ = Math.min(S / So.w, M / So.h);
    s.value = _, o.value = { x: (S - So.w * _) / 2, y: (M - So.h * _) / 2 };
  }
  function f(w) {
    l || (l = w - i.value * 1e3), document.hidden ? l = w - i.value * 1e3 : i.value = (w - l) / 1e3 % n, a = requestAnimationFrame(f);
  }
  function p() {
    a || r || d || (l = 0, a = requestAnimationFrame(f));
  }
  function y() {
    a && cancelAnimationFrame(a), a = 0;
  }
  it(() => {
    h(), typeof ResizeObserver != "undefined" && t.value && (c = new ResizeObserver(h), c.observe(t.value)), r ? i.value = e : p();
  }), We(() => {
    y(), c && c.disconnect();
  });
  const v = I(() => ({
    width: So.w + "px",
    height: So.h + "px",
    transform: "translate(" + o.value.x.toFixed(2) + "px, " + o.value.y.toFixed(2) + "px) scale(" + s.value.toFixed(5) + ")"
  }));
  return { root: t, bind: (w) => {
    t.value = w || null;
  }, t: i, scale: s, stageStyle: v, reduced: r };
}
const Dt = (n) => n.toFixed(2), ut = (n) => n.toFixed(3), ZAe = {
  class: "ob-head",
  "data-tour-ui": "",
  "data-testid": "tour-header"
}, QAe = { class: "ob-head-left" }, ePe = ["viewBox"], tPe = ["d", "fill"], nPe = {
  class: "ob-chapters",
  "aria-label": "Tour progress"
}, iPe = ["aria-current", "data-chapter"], sPe = { class: "n" }, oPe = { class: "l" }, rPe = { class: "ob-head-right" }, aPe = /* @__PURE__ */ Pe({
  __name: "TourHeader",
  props: {
    tour: {}
  },
  setup(n) {
    const e = n, t = I(() => $Ae(e.tour.step.value.chapter)), i = I(() => e.tour.phase.value === "finished"), s = I(() => e.tour.reason === "replay" ? "Exit tour" : "Skip tour");
    return (o, r) => (g(), b("header", ZAe, [
      u("div", QAe, [
        (g(), b("svg", {
          class: "ob-head-mark",
          viewBox: m(Ql),
          width: "25",
          height: "18",
          "aria-hidden": "true"
        }, [
          (g(!0), b(j, null, ge(m(ma), (a) => (g(), b("path", {
            key: a.d,
            d: a.d,
            fill: a.fill
          }, null, 8, tPe))), 128))
        ], 8, ePe)),
        r[1] || (r[1] = u("span", { class: "ob-head-name" }, [
          Y("Boards"),
          u("span", { class: "sep" }, "/"),
          u("b", null, "Getting started")
        ], -1))
      ]),
      u("ol", nPe, [
        (g(!0), b(j, null, ge(m(Mx), (a, l) => (g(), b("li", {
          key: a.id,
          class: G({ on: l === t.value && !i.value, done: l < t.value || i.value }),
          "aria-current": l === t.value ? "step" : void 0,
          "data-chapter": a.id
        }, [
          u("span", sPe, [
            l < t.value || i.value ? (g(), Ie($, {
              key: 0,
              name: "Check",
              size: 10,
              stroke: 3
            })) : (g(), b(j, { key: 1 }, [
              Y(E(l + 1), 1)
            ], 64))
          ]),
          u("span", oPe, E(a.label), 1)
        ], 10, iPe))), 128))
      ]),
      u("div", rPe, [
        n.tour.canSkip && !i.value ? (g(), b("button", {
          key: 0,
          class: "ob-skip",
          "data-testid": "tour-skip",
          onClick: r[0] || (r[0] = (a) => n.tour.skip())
        }, E(s.value), 1)) : z("", !0)
      ])
    ]));
  }
}), lPe = {
  key: 0,
  class: "ob-d-brush"
}, dPe = {
  key: 1,
  class: "arrow",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, ya = /* @__PURE__ */ Pe({
  __name: "DemoPointer",
  props: {
    p: {},
    brush: { type: Boolean }
  },
  setup(n) {
    const e = n, t = I(() => ({
      opacity: ut(e.p.ring.shown),
      transform: "translate(" + Dt(e.p.ring.x) + "px, " + Dt(e.p.ring.y) + "px) scale(" + ut(e.p.ring.size) + ")"
    })), i = I(() => ({ opacity: ut(e.p.shown), transform: "translate(" + Dt(e.p.x) + "px, " + Dt(e.p.y) + "px)" }));
    return (s, o) => (g(), b(j, null, [
      u("span", {
        class: "bl-hd-ripple",
        style: ce(t.value)
      }, null, 4),
      u("span", {
        class: G(["bl-hd-pointer ob-d-pointer", { "is-pressed": n.p.pressed, "is-brush": n.brush }]),
        style: ce(i.value)
      }, [
        n.brush ? (g(), b("span", lPe)) : (g(), b("svg", dPe, [...o[0] || (o[0] = [
          u("path", {
            d: "M4 2.5v15.2l3.9-3.7 2.6 6 2.7-1.2-2.6-5.9h5.4z",
            fill: "#fff",
            stroke: "#0b0d14",
            "stroke-width": "1.3",
            "stroke-linejoin": "round"
          }, null, -1)
        ])])),
        Ss(s.$slots, "default")
      ], 6)
    ], 64));
  }
}), cPe = { class: "bl-hd-session-head" }, uPe = { class: "bl-hd-badge" }, hPe = { class: "bl-hd-session-titles" }, pPe = { class: "kind" }, fPe = { class: "model" }, mPe = { class: "name" }, gPe = { class: "bl-hd-count" }, bPe = ["src"], vPe = { class: "bl-hd-foot" }, td = /* @__PURE__ */ Pe({
  __name: "DemoCard",
  props: {
    box: {},
    name: { default: "Image Tool 1" },
    model: { default: "Nano Banana Pro" },
    thumbs: { default: () => [] },
    shown: { default: void 0 },
    count: { default: 0 },
    foot: { default: "No runs yet" },
    selected: { default: 0 },
    busy: { type: Boolean, default: !1 }
  },
  setup(n) {
    return (e, t) => (g(), b("div", {
      class: "bl-hd-session ob-d-card",
      style: ce({ left: n.box.x + "px", top: n.box.y + "px", width: n.box.w + "px", height: n.box.h + "px" })
    }, [
      u("span", {
        class: "bl-hd-ring",
        style: ce({ opacity: m(ut)(n.selected) })
      }, null, 4),
      u("div", cPe, [
        u("span", uPe, [
          C($, {
            name: "Image",
            size: 17
          })
        ]),
        u("span", hPe, [
          u("span", pPe, [
            t[0] || (t[0] = Y("Image", -1)),
            t[1] || (t[1] = u("span", { class: "sep" }, "·", -1)),
            u("span", fPe, E(n.model), 1)
          ]),
          u("span", mPe, E(n.name), 1)
        ]),
        u("span", gPe, E(n.count), 1)
      ]),
      u("div", {
        class: G(["bl-hd-thumbs", { "is-busy": n.busy }])
      }, [
        (g(), b(j, null, ge(4, (i) => u("span", {
          key: i,
          class: "bl-hd-thumb is-empty"
        }, [
          n.thumbs[i - 1] ? (g(), b("img", {
            key: 0,
            src: n.thumbs[i - 1],
            alt: "",
            draggable: "false",
            class: "is-in",
            style: ce(n.shown ? { opacity: m(ut)(n.shown[i - 1] || 0), transform: "scale(" + m(ut)(0.82 + 0.18 * (n.shown[i - 1] || 0)) + ")" } : void 0)
          }, null, 12, bPe)) : z("", !0)
        ])), 64))
      ], 2),
      u("div", vPe, E(n.foot), 1)
    ], 4));
  }
}), yPe = { class: "bl-hd-rail" }, xPe = { class: "is-on" }, hP = /* @__PURE__ */ Pe({
  __name: "DemoDock",
  props: {
    box: {},
    lit: { default: 0 },
    shown: { default: 1 },
    open: { default: 0 }
  },
  setup(n) {
    return (e, t) => (g(), b("div", {
      class: "bl-hd-dock ob-d-dock",
      style: ce({ left: n.box.x + "px", top: n.box.y + "px", width: n.box.w + "px", opacity: m(ut)(n.shown), transform: "translateY(" + m(Dt)((1 - n.shown) * 10) + "px)" })
    }, [
      u("span", {
        class: G(["bl-hd-add is-plus", { "is-lit": n.lit > 0.3, "is-open": n.open > 0.5 }])
      }, [
        C($, {
          name: "Plus",
          size: 17,
          stroke: 2.4
        })
      ], 2),
      u("span", yPe, [
        u("i", xPe, [
          C($, {
            name: "MousePointer2",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "Hand",
            size: 15
          })
        ]),
        t[0] || (t[0] = u("b", null, null, -1)),
        u("i", null, [
          C($, {
            name: "Image",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "StickyNote",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "Frame",
            size: 15
          })
        ])
      ])
    ], 4));
  }
}), wPe = { class: "search" }, kPe = { class: "badge" }, _Pe = { class: "main" }, SPe = /* @__PURE__ */ Pe({
  __name: "DemoSession",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(Ei.loop, Ei.still), s = I(() => NAe(t.value)), o = [
      { icon: "Image", name: "Image", sub: "Create images with AI-powered models" },
      { icon: "Video", name: "Video", sub: "Generate dynamic videos and animations" },
      { icon: "Box", name: "3D", sub: "Generate 3D models from images or prompts" },
      { icon: "Maximize2", name: "Upscale", sub: "Upscale your images and videos" }
    ];
    return (r, a) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "session"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        a[3] || (a[3] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          class: "ob-d-land",
          style: ce({ opacity: m(ut)(s.value.card), transform: "translateY(" + m(Dt)((1 - s.value.card) * -18) + "px) scale(" + m(ut)(0.9 + 0.1 * s.value.card) + ")" })
        }, [
          C(td, {
            box: m(Ei).card,
            selected: s.value.selected
          }, null, 8, ["box", "selected"])
        ], 4),
        (g(!0), b(j, null, ge(m(Ei).tags, (l, d) => (g(), b("span", {
          key: l,
          class: "ob-d-tag",
          style: ce({ left: m(Ei).card.x + m(Ei).card.w + 22 + "px", top: m(Ei).card.y + 20 + d * 44 + "px", opacity: m(ut)(s.value.tags[d]), transform: "translateX(" + m(Dt)((1 - s.value.tags[d]) * -10) + "px)" })
        }, [
          a[0] || (a[0] = u("i", null, null, -1)),
          Y(E(l), 1)
        ], 4))), 128)),
        u("div", {
          class: "ob-d-menu",
          style: ce({ left: m(Ei).menu.x + "px", top: m(Ei).menu.y + "px", width: m(Ei).menu.w + "px", opacity: m(ut)(s.value.menu), transform: "translateY(" + m(Dt)((1 - s.value.menu) * 12) + "px)" })
        }, [
          u("div", wPe, [
            C($, {
              name: "Search",
              size: 11
            }),
            a[1] || (a[1] = Y("Search generators", -1))
          ]),
          a[2] || (a[2] = u("div", { class: "eyebrow" }, "New tool session", -1)),
          (g(), b(j, null, ge(o, (l, d) => u("div", {
            key: l.name,
            class: G(["row", { "is-lit": d === 0 && s.value.imageLit > 0.3 }])
          }, [
            u("span", kPe, [
              C($, {
                name: l.icon,
                size: 12
              }, null, 8, ["name"])
            ]),
            u("span", _Pe, [
              u("b", null, E(l.name), 1),
              u("small", null, E(l.sub), 1)
            ])
          ], 2)), 64))
        ], 4),
        C(hP, {
          box: m(Ei).dock,
          lit: s.value.addLit,
          open: s.value.menu
        }, null, 8, ["box", "lit", "open"]),
        C(ya, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), MPe = { class: "bl-hd-prompt-side" }, TPe = { class: "ob-d-words" }, CPe = {
  key: 0,
  class: "ph"
}, IPe = { class: "typed" }, APe = { class: "bl-hd-prompt-foot" }, PPe = { class: "chip" }, EPe = { class: "chip" }, RPe = { class: "step" }, Em = /* @__PURE__ */ Pe({
  __name: "DemoPrompt",
  props: {
    box: {},
    typed: { default: "" },
    ghost: { default: "" },
    ghostShown: { default: 0 },
    cue: { default: 0 },
    caret: { default: 0 },
    placeholder: { default: "Describe what Image Tool 1 should make" },
    runLit: { default: 0 },
    runPressed: { type: Boolean, default: !1 },
    runBusy: { type: Boolean, default: !1 },
    studio: { type: Boolean, default: !0 },
    studioLit: { default: 0 },
    shown: { default: 1 }
  },
  setup(n) {
    return (e, t) => (g(), b("div", {
      class: "bl-hd-prompt ob-d-prompt",
      style: ce({
        left: n.box.x + "px",
        top: n.box.y + "px",
        width: n.box.w + "px",
        height: n.box.h + "px",
        opacity: m(ut)(n.shown),
        visibility: n.shown > 1e-3 ? "visible" : "hidden",
        transform: "translateY(" + m(Dt)((1 - n.shown) * 16) + "px)"
      })
    }, [
      u("span", MPe, [
        u("i", null, [
          C($, {
            name: "LayoutTemplate",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "Pipette",
            size: 15
          })
        ])
      ]),
      n.studio ? (g(), b("span", {
        key: 0,
        class: G(["ob-d-pill", { "is-lit": n.studioLit > 0.5 }])
      }, [
        C($, {
          name: "Expand",
          size: 12
        }),
        t[0] || (t[0] = Y("Studio", -1))
      ], 2)) : z("", !0),
      u("span", TPe, [
        !n.typed && !n.ghost ? (g(), b("span", CPe, E(n.placeholder), 1)) : z("", !0),
        n.ghost && !n.typed ? (g(), b("span", {
          key: 1,
          class: "ghost",
          style: ce({ opacity: m(ut)(n.ghostShown) })
        }, E(n.ghost), 5)) : z("", !0),
        u("span", IPe, E(n.typed), 1),
        u("span", {
          class: "caret",
          style: ce({ opacity: m(ut)(n.caret) })
        }, null, 4)
      ]),
      n.cue > 0.01 ? (g(), b("span", {
        key: 1,
        class: "ob-d-cue",
        style: ce({ opacity: m(ut)(n.cue) })
      }, [...t[1] || (t[1] = [
        u("kbd", null, "Tab", -1),
        Y(" to write it in", -1)
      ])], 4)) : z("", !0),
      u("span", APe, [
        u("span", PPe, [
          t[2] || (t[2] = u("small", null, "Model", -1)),
          t[3] || (t[3] = Y("Nano Banana Pro", -1)),
          C($, {
            name: "ChevronDown",
            size: 12
          })
        ]),
        u("span", EPe, [
          C($, {
            name: "RectangleVertical",
            size: 12
          }),
          t[4] || (t[4] = Y("896×1152", -1))
        ]),
        t[6] || (t[6] = u("span", { class: "sp" }, null, -1)),
        u("span", RPe, [
          C($, {
            name: "Minus",
            size: 11
          }),
          t[5] || (t[5] = u("b", null, "4", -1)),
          C($, {
            name: "Plus",
            size: 11
          })
        ]),
        u("span", {
          class: G(["run", { "is-lit": n.runLit > 0.5, "is-pressed": n.runPressed, "is-busy": n.runBusy }]),
          style: { width: "62px" }
        }, E(n.runBusy ? "Running" : "Run"), 3)
      ])
    ], 4));
  }
}), zPe = /* @__PURE__ */ Pe({
  __name: "DemoOpen",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(il.loop, il.still), s = I(() => UAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "open"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(il).card,
          selected: s.value.selected
        }, null, 8, ["box", "selected"]),
        C(hP, {
          box: m(il).dock,
          shown: 1 - s.value.prompt
        }, null, 8, ["box", "shown"]),
        C(Em, {
          box: m(il).prompt,
          shown: s.value.prompt,
          caret: s.value.prompt > 0.9 ? 1 : 0,
          studio: !1
        }, null, 8, ["box", "shown", "caret"]),
        C(ya, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), $Pe = /* @__PURE__ */ Pe({
  __name: "DemoPromptTab",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(Io.loop, Io.still), s = I(() => jAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "prompt"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        r[1] || (r[1] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          style: ce({ opacity: m(ut)(s.value.fade) })
        }, [
          C(Em, {
            box: m(Io).prompt,
            class: "is-big",
            typed: s.value.typed,
            ghost: m(fu),
            "ghost-shown": s.value.ghost,
            cue: s.value.cue,
            caret: s.value.caret,
            "run-lit": s.value.runLit,
            studio: !1
          }, null, 8, ["box", "typed", "ghost", "ghost-shown", "cue", "caret", "run-lit"])
        ], 4),
        u("span", {
          class: G(["ob-d-keycap", { "is-down": s.value.keyDown }]),
          style: ce({ left: m(Io).key.x + "px", top: m(Io).key.y + "px", width: m(Io).key.w + "px", height: m(Io).key.h + "px", opacity: m(ut)(s.value.key), transform: "translateY(" + m(Dt)((1 - s.value.key) * 8) + "px)" })
        }, [...r[0] || (r[0] = [
          u("span", null, "Tab", -1),
          u("i", null, "⇥", -1)
        ])], 6)
      ], 4)
    ], 512));
  }
}), DPe = { class: "grid" }, OPe = ["src"], pP = /* @__PURE__ */ Pe({
  __name: "DemoGallery",
  props: {
    box: {},
    shown: { default: 1 },
    lifted: { default: -1 }
  },
  setup(n) {
    return (e, t) => (g(), b("div", {
      class: "ob-d-gallery",
      style: ce({ left: n.box.x + "px", top: n.box.y + "px", width: n.box.w + "px", height: n.box.h + "px", opacity: m(ut)(n.shown), transform: "translateX(" + m(Dt)((1 - n.shown) * 60) + "px)" })
    }, [
      t[0] || (t[0] = u("div", { class: "head" }, [
        u("b", null, "4"),
        Y(" Image Tool 1")
      ], -1)),
      u("div", DPe, [
        (g(!0), b(j, null, ge(m(Yn), (i, s) => (g(), b("span", {
          key: i,
          class: G(["cell", { "is-lifted": s === n.lifted }])
        }, [
          u("img", {
            src: i,
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, OPe)
        ], 2))), 128))
      ])
    ], 4));
  }
}), LPe = /* @__PURE__ */ Pe({
  __name: "DemoRun",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(sl.loop, sl.still), s = I(() => HAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "run"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(sl).card,
          thumbs: m(Yn),
          shown: s.value.thumbs,
          count: s.value.count,
          foot: s.value.foot,
          busy: s.value.busy,
          selected: 1
        }, null, 8, ["box", "thumbs", "shown", "count", "foot", "busy"]),
        C(Em, {
          box: m(sl).prompt,
          typed: m(fu),
          "run-lit": 1,
          "run-pressed": s.value.runPressed,
          "run-busy": s.value.busy,
          studio: !1
        }, null, 8, ["box", "typed", "run-pressed", "run-busy"]),
        C(pP, {
          box: m(sl).gallery,
          shown: s.value.gallery
        }, null, 8, ["box", "shown"]),
        C(ya, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), BPe = ["src"], FPe = ["src"], NPe = /* @__PURE__ */ Pe({
  __name: "DemoDrag",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(ki.loop, ki.still), s = I(() => VAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "drag"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(ki).card,
          thumbs: m(Yn),
          count: 4,
          foot: "Updated just now",
          selected: 1
        }, null, 8, ["box", "thumbs"]),
        u("span", {
          class: "ob-d-slot",
          style: ce({ left: m(ki).drop.x + "px", top: m(ki).drop.y + "px", width: m(ki).drop.w + "px", height: m(ki).drop.h + "px", opacity: m(ut)(s.value.slot) })
        }, null, 4),
        u("div", {
          class: "bl-hd-pic ob-d-placed",
          style: ce({ left: m(ki).drop.x + "px", top: m(ki).drop.y + "px", width: m(ki).drop.w + "px", height: m(ki).drop.h + "px", opacity: m(ut)(s.value.placed), transform: "scale(" + m(ut)(1.05 - 0.05 * s.value.placed) + ")" })
        }, [
          u("img", {
            src: m(Yn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, BPe)
        ], 4),
        C(pP, {
          box: m(ki).gallery,
          lifted: s.value.ghost.shown > 0.05 ? 0 : -1
        }, null, 8, ["box", "lifted"]),
        u("span", {
          class: "bl-hd-ghost ob-d-ghost",
          style: ce({ opacity: m(ut)(s.value.ghost.shown), transform: "translate(" + m(Dt)(s.value.ghost.x - 26) + "px, " + m(Dt)(s.value.ghost.y - 30) + "px) rotate(" + m(Dt)(s.value.ghost.tilt) + "deg)" })
        }, [
          u("img", {
            src: m(Yn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, FPe)
        ], 4),
        C(ya, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), UPe = { class: "back" }, GPe = { class: "crumb" }, jPe = { class: "chip" }, HPe = { class: "x" }, VPe = { class: "tabs" }, WPe = { class: "v on" }, qPe = ["src"], KPe = {
  key: 0,
  class: "v is-new"
}, YPe = ["src"], XPe = ["src"], JPe = ["src"], ZPe = ["src"], fP = /* @__PURE__ */ Pe({
  __name: "DemoStudioView",
  props: {
    side: { default: "generate" },
    parts: { default: 1 },
    wipe: { default: -1 },
    versions: { default: 1 },
    busy: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = [
      { icon: "Wand2", label: "Prompt" },
      { icon: "Sparkles", label: "Upscale" },
      { icon: "Lightbulb", label: "Relight" },
      { icon: "Camera", label: "Change camera" },
      { icon: "Layers", label: "Background" }
    ];
    return (t, i) => (g(), b("div", {
      class: G(["ob-d-studio", "is-" + n.side])
    }, [
      u("div", {
        class: "top",
        style: ce({ opacity: m(ut)(n.parts) })
      }, [
        u("span", UPe, [
          C($, {
            name: "ArrowLeft",
            size: 13
          })
        ]),
        u("span", GPe, [
          u("small", null, E(n.side === "edit" ? "Edit" : "Generate"), 1),
          i[0] || (i[0] = Y("Image Tool 1", -1))
        ]),
        u("span", jPe, [
          C($, {
            name: "Image",
            size: 11
          }),
          i[1] || (i[1] = Y("Session", -1))
        ]),
        u("span", HPe, [
          C($, {
            name: "X",
            size: 13
          })
        ])
      ], 4),
      u("div", {
        class: "tools",
        style: ce({ opacity: m(ut)(n.parts), transform: "translateX(" + m(Dt)((1 - n.parts) * -14) + "px)" })
      }, [
        u("div", VPe, [
          u("span", {
            class: G({ on: n.side === "generate" })
          }, "Generate", 2),
          u("span", {
            class: G({ on: n.side === "edit" })
          }, "Edit", 2)
        ]),
        (g(), b(j, null, ge(e, (s, o) => u("div", {
          key: s.label,
          class: G(["row", { on: o === 0 }])
        }, [
          C($, {
            name: s.icon,
            size: 12
          }, null, 8, ["name"]),
          Y(E(s.label), 1)
        ], 2)), 64))
      ], 4),
      u("div", {
        class: "versions",
        style: ce({ opacity: m(ut)(n.parts) })
      }, [
        u("span", WPe, [
          u("img", {
            src: m(Yn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, qPe)
        ]),
        n.versions > 1 ? (g(), b("span", KPe, [
          u("img", {
            src: m(Vf),
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, YPe)
        ])) : z("", !0)
      ], 4),
      u("div", {
        class: G(["stage", { "is-busy": n.busy }]),
        style: ce({ opacity: m(ut)(n.parts), transform: "scale(" + m(ut)(0.94 + 0.06 * n.parts) + ")" })
      }, [
        u("img", {
          src: m(Yn)[0],
          alt: "",
          draggable: "false",
          class: "is-in"
        }, null, 8, XPe),
        n.wipe >= 0 ? (g(), b("img", {
          key: 0,
          src: m(Vf),
          alt: "",
          draggable: "false",
          class: "is-in night",
          style: ce({ clipPath: "inset(0 " + m(Dt)((1 - n.wipe) * 100) + "% 0 0)" })
        }, null, 12, JPe)) : z("", !0),
        n.wipe > 0 && n.wipe < 1 ? (g(), b("span", {
          key: 1,
          class: "seam",
          style: ce({ left: m(Dt)(n.wipe * 100) + "%" })
        }, null, 4)) : z("", !0),
        Ss(t.$slots, "stage")
      ], 6),
      u("div", {
        class: "hist",
        style: ce({ opacity: m(ut)(n.parts), transform: "translateX(" + m(Dt)((1 - n.parts) * 14) + "px)" })
      }, [
        (g(!0), b(j, null, ge(m(Yn), (s) => (g(), b("span", {
          key: s,
          class: "h"
        }, [
          u("img", {
            src: s,
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, ZPe)
        ]))), 128))
      ], 4),
      Ss(t.$slots, "default")
    ], 2));
  }
}), QPe = /* @__PURE__ */ Pe({
  __name: "DemoStudio",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(Fs.loop, Fs.still), s = I(() => WAe(t.value)), o = Fs.pill.x + Fs.pill.w / 2 + "px " + (Fs.pill.y + Fs.pill.h / 2) + "px";
    return (r, a) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "studio"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        a[0] || (a[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(Fs).card,
          thumbs: m(Yn),
          count: 4,
          foot: "Updated just now",
          selected: 1
        }, null, 8, ["box", "thumbs"]),
        C(Em, {
          box: m(Fs).prompt,
          typed: m(fu),
          "run-lit": 1,
          "studio-lit": s.value.pillLit
        }, null, 8, ["box", "typed", "studio-lit"]),
        u("div", {
          class: "ob-d-studio-wrap",
          style: ce({ opacity: m(ut)(Math.min(1, s.value.open * 1.6)), transform: "scale(" + m(ut)(0.12 + 0.88 * s.value.open) + ")", transformOrigin: o, visibility: s.value.open > 1e-3 ? "visible" : "hidden", borderRadius: m(Dt)(28 * (1 - s.value.open) + 4) + "px" })
        }, [
          C(fP, {
            parts: s.value.parts
          }, null, 8, ["parts"])
        ], 4),
        C(ya, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), eEe = ["d", "stroke-dashoffset"], tEe = { class: "words" }, nEe = {
  key: 0,
  class: "ph"
}, iEe = { class: "typed" }, y3 = 420, sEe = /* @__PURE__ */ Pe({
  __name: "DemoEdit",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(Ao.loop, Ao.still), s = I(() => qAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "edit"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(fP, {
          side: "edit",
          wipe: s.value.wipe > 0 ? s.value.wipe : -1,
          versions: s.value.versions,
          busy: s.value.busy
        }, null, 8, ["wipe", "versions", "busy"]),
        (g(), b("svg", {
          class: "ob-d-paint",
          viewBox: "0 0 640 360",
          width: "640",
          height: "360",
          style: ce({ opacity: m(ut)(s.value.area) })
        }, [
          u("path", {
            d: m(Ao).stroke,
            fill: "none",
            stroke: "rgba(174, 134, 229, 0.62)",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-dasharray": y3,
            "stroke-dashoffset": y3 * (1 - s.value.painted)
          }, null, 8, eEe)
        ], 4)),
        u("div", {
          class: "ob-d-editbar",
          style: ce({ left: m(Ao).bar.x + "px", top: m(Ao).bar.y + "px", width: m(Ao).bar.w + "px", height: m(Ao).bar.h + "px" })
        }, [
          u("span", tEe, [
            s.value.typed ? z("", !0) : (g(), b("span", nEe, "Say what to change")),
            u("span", iEe, E(s.value.typed), 1)
          ]),
          u("span", {
            class: G(["run", { "is-lit": !!s.value.typed, "is-busy": s.value.busy }])
          }, E(s.value.busy ? "Running" : "Run"), 3)
        ], 4),
        C(ya, {
          p: s.value.pointer,
          brush: s.value.brush
        }, null, 8, ["p", "brush"])
      ], 4)
    ], 512));
  }
}), oEe = ["src"], rEe = ["src"], aEe = { class: "head" }, lEe = { class: "mark" }, dEe = { class: "head" }, cEe = { class: "mark" }, uEe = { class: "lines" }, hEe = { class: "eyebrow" }, pEe = { class: "sess" }, fEe = { class: "words" }, mEe = {
  key: 0,
  class: "ph"
}, gEe = { class: "typed" }, bEe = /* @__PURE__ */ Pe({
  __name: "DemoChat",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(Ln.loop, Ln.still), s = I(() => XAe(t.value)), o = (a) => ({ left: a.x + "px", top: a.y + "px", width: a.w + "px", height: a.h + "px" }), r = (a) => o({ x: a.x - Ln.panel.x, y: a.y - Ln.panel.y, w: a.w, h: a.h });
    return (a, l) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "chat"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        l[11] || (l[11] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          class: "ob-d-frame is-drawn ob-d-chatframe",
          style: ce({ ...o(m(Ln).frame), "--glow": m(ut)(s.value.glow), "--sel": m(ut)(s.value.selected) })
        }, [...l[0] || (l[0] = [
          u("span", { class: "title" }, "Site photos", -1)
        ])], 4),
        (g(!0), b(j, null, ge(m(Ln).photos, (d, c) => (g(), b("div", {
          key: "p" + c,
          class: "bl-hd-pic",
          style: ce(o(d))
        }, [
          u("img", {
            src: m(KAe)[c],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, oEe)
        ], 4))), 128)),
        (g(!0), b(j, null, ge(m(Ln).finished, (d, c) => (g(), b("div", {
          key: "f" + c,
          class: "bl-hd-pic ob-d-finished",
          style: ce({ ...o(d), opacity: m(ut)(s.value.finished[c]), transform: "translateY(" + m(Dt)((1 - s.value.finished[c]) * 10) + "px) scale(" + m(ut)(0.94 + 0.06 * s.value.finished[c]) + ")" })
        }, [
          u("img", {
            src: m(YAe)[c],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, rEe)
        ], 4))), 128)),
        u("div", {
          class: "ob-d-chatcard",
          style: ce({ ...o(m(Ln).card), opacity: m(ut)(s.value.card), transform: "scale(" + m(ut)(0.9 + 0.1 * s.value.card) + ")" })
        }, [
          u("span", aEe, [
            u("span", lEe, [
              C($, {
                name: "MessagesSquare",
                size: 11
              })
            ]),
            l[1] || (l[1] = u("span", { class: "n" }, "Chat 1", -1))
          ]),
          l[2] || (l[2] = u("span", { class: "line" }, null, -1)),
          l[3] || (l[3] = u("span", { class: "line is-short" }, null, -1))
        ], 4),
        u("div", {
          class: "ob-d-ctxbar",
          style: ce({ ...o(m(Ln).bar), opacity: m(ut)(s.value.bar) })
        }, [
          u("span", {
            class: G(["chat", { "is-lit": s.value.chatLit > 0.01 }])
          }, [
            C($, {
              name: "MessageSquarePlus",
              size: 10
            }),
            l[4] || (l[4] = Y("Chat", -1))
          ], 2),
          l[5] || (l[5] = u("span", { class: "ic" }, null, -1)),
          l[6] || (l[6] = u("span", { class: "ic" }, null, -1)),
          l[7] || (l[7] = u("span", { class: "ic" }, null, -1))
        ], 4),
        u("div", {
          class: "ob-d-chat",
          style: ce({ ...o(m(Ln).panel), opacity: m(ut)(s.value.panel), transform: "translateX(" + m(Dt)((1 - s.value.panel) * 44) + "px)" })
        }, [
          u("div", dEe, [
            u("span", cEe, [
              C($, {
                name: "MessagesSquare",
                size: 11
              })
            ]),
            l[8] || (l[8] = u("span", { class: "t" }, [
              u("b", null, "Chat 1"),
              u("small", null, "in Site photos · 3 in context")
            ], -1))
          ]),
          u("div", {
            class: "bubble",
            style: ce({ ...r(m(Ln).bubble), opacity: m(ut)(s.value.bubble), transform: "translateY(" + m(Dt)((1 - s.value.bubble) * 10) + "px)" })
          }, E(m(uP)), 5),
          u("div", {
            class: "answer",
            style: ce(r(m(Ln).answer))
          }, [
            u("span", {
              class: G(["ai", { "is-busy": s.value.thinking }]),
              style: ce({ opacity: m(ut)(s.value.thinking || s.value.answer > 0 ? 1 : 0) })
            }, [
              C($, {
                name: "Sparkles",
                size: 9
              })
            ], 6),
            u("span", uEe, [
              u("i", {
                style: ce({ width: m(Dt)(100 * Math.min(1, s.value.answer * 1.6)) + "%" })
              }, null, 4),
              u("i", {
                style: ce({ width: m(Dt)(72 * Math.max(0, s.value.answer * 1.6 - 0.6)) + "%" })
              }, null, 4)
            ])
          ], 4),
          u("div", {
            class: "plan",
            style: ce({ ...r(m(Ln).plan), opacity: m(ut)(s.value.plan), transform: "translateY(" + m(Dt)((1 - s.value.plan) * 8) + "px)" })
          }, [
            u("span", hEe, E(s.value.busy || s.value.done ? "Plan" : "Proposed plan") + " · 3 runs", 1),
            l[10] || (l[10] = u("span", { class: "ttl" }, "The finished tower", -1)),
            u("span", pEe, [
              C($, {
                name: "Image",
                size: 10
              }),
              l[9] || (l[9] = Y("Nano Banana Pro · 3 photos", -1))
            ])
          ], 4),
          u("span", {
            class: G(["run", { "is-lit": s.value.runLit > 0.01, "is-busy": s.value.busy, "is-done": s.value.done }]),
            style: ce({ ...r(m(Ln).run), opacity: m(ut)(s.value.plan) })
          }, [
            C($, {
              name: s.value.done ? "CircleCheck" : "Play",
              size: 9
            }, null, 8, ["name"]),
            Y(E(s.value.done ? "Done" : s.value.busy ? "Running" : "Run plan"), 1)
          ], 6),
          u("div", {
            class: "composer",
            style: ce(r(m(Ln).composer))
          }, [
            u("span", fEe, [
              s.value.typed ? z("", !0) : (g(), b("span", mEe, "Ask about these 3 images…")),
              u("span", gEe, E(s.value.typed), 1)
            ])
          ], 4),
          u("span", {
            class: G(["send", { "is-lit": s.value.sendLit > 0.01 }]),
            style: ce(r(m(Ln).send))
          }, [
            C($, {
              name: "ArrowUp",
              size: 11
            })
          ], 6)
        ], 4),
        C(ya, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), vEe = {
  key: 0,
  class: "title"
}, yEe = ["src"], xEe = { class: "text" }, wEe = /* @__PURE__ */ Pe({
  __name: "DemoOrganize",
  setup(n) {
    const { bind: e, t, stageStyle: i } = uo(Mn.loop, Mn.still), s = I(() => JAe(t.value)), o = [Yn[0], Vf, Yn[2]];
    return (r, a) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "organize"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(i))
      }, [
        a[1] || (a[1] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          class: "ob-d-world",
          style: ce({ transform: "scale(" + m(ut)(s.value.zoom) + ")" })
        }, [
          u("div", {
            class: G(["ob-d-frame", { "is-drawn": s.value.frame >= 1 }]),
            style: ce({ left: m(Mn).frame.x + "px", top: m(Mn).frame.y + "px", width: m(Dt)(m(Mn).frame.w * s.value.frame) + "px", height: m(Dt)(m(Mn).frame.h * s.value.frame) + "px", opacity: s.value.frame > 0.01 ? 1 : 0 })
          }, [
            s.value.title ? (g(), b("span", vEe, E(s.value.title), 1)) : z("", !0)
          ], 6),
          C(td, {
            box: m(Mn).card,
            thumbs: [m(Yn)[0], m(Vf), m(Yn)[2], m(Yn)[3]],
            count: 5,
            foot: "Updated just now"
          }, null, 8, ["box", "thumbs"]),
          (g(!0), b(j, null, ge(m(Mn).pics, (l, d) => (g(), b("div", {
            key: d,
            class: "bl-hd-pic",
            style: ce({ left: l.x + "px", top: l.y + "px", width: l.w + "px", height: l.h + "px" })
          }, [
            u("img", {
              src: o[d],
              alt: "",
              draggable: "false",
              class: "is-in"
            }, null, 8, yEe)
          ], 4))), 128)),
          u("div", {
            class: "bl-hd-note is-amber ob-d-note",
            style: ce({ left: m(Mn).note.x + "px", top: m(Mn).note.y + "px", width: m(Mn).note.w + "px", height: m(Mn).note.h + "px", opacity: m(ut)(s.value.note), transform: "translateY(" + m(Dt)((1 - s.value.note) * -16) + "px) rotate(" + m(Dt)((1 - s.value.note) * -4) + "deg)" })
          }, [
            u("span", xEe, E(m(Mn).noteText), 1),
            a[0] || (a[0] = u("span", { class: "meta" }, "MT", -1))
          ], 4),
          u("span", {
            class: "ob-d-pin",
            style: ce({ left: m(Mn).pin.x + "px", top: m(Mn).pin.y + "px", opacity: m(ut)(s.value.pin), transform: "scale(" + m(ut)(0.4 + 0.6 * s.value.pin) + ")" })
          }, "JR", 4),
          u("span", {
            class: "ob-d-bubble",
            style: ce({ left: m(Mn).pin.x + 30 + "px", top: m(Mn).pin.y - 6 + "px", opacity: m(ut)(s.value.bubble), transform: "translateX(" + m(Dt)((1 - s.value.bubble) * -8) + "px)" })
          }, E(m(Mn).comment), 5)
        ], 4)
      ], 4)
    ], 512));
  }
}), kEe = ["aria-label", "data-step"], _Ee = { class: "ob-tag" }, SEe = { class: "ob-body" }, MEe = { class: "ob-words-stack" }, TEe = {
  key: 0,
  class: "ob-note",
  "data-testid": "tour-note"
}, CEe = { class: "ob-tick" }, IEe = { class: "ob-note-words" }, AEe = {
  key: 0,
  class: "ob-key"
}, PEe = { class: "ob-title" }, EEe = { class: "ob-text" }, REe = { class: "ob-tick" }, zEe = { class: "ob-task-words" }, $Ee = {
  key: 0,
  class: "ob-key"
}, DEe = {
  key: 1,
  class: "ob-chip"
}, OEe = { class: "ob-foot" }, LEe = ["aria-label"], BEe = { class: "ob-foot-acts" }, FEe = ["disabled"], NEe = /* @__PURE__ */ Pe({
  __name: "CoachCard",
  props: {
    tour: {},
    x: {},
    y: {},
    wide: { type: Boolean },
    short: { type: Boolean }
  },
  emits: ["size"],
  setup(n, { emit: e }) {
    const t = n, i = e, s = {
      session: SPe,
      open: zPe,
      prompt: $Pe,
      run: LPe,
      drag: NPe,
      studio: QPe,
      edit: sEe,
      chat: bEe,
      organize: wEe
    }, o = { board: "LayoutDashboard", session: "Image", generate: "Sparkles", studio: "Expand", edit: "Wand2", chat: "MessagesSquare", finish: "Check" }, r = I(() => t.tour.step.value), a = I(() => t.tour.phase.value), l = I(() => t.tour.waiting.value), d = I(() => r.value.demo && s[r.value.demo] || null), c = I(() => Mx.find((A) => A.id === r.value.chapter)), h = I(() => Wi.filter((A) => A.chapter === r.value.chapter && A.id !== "finale")), f = I(() => h.value.findIndex((A) => A.id === r.value.id)), p = I(() => {
      const A = r.value;
      return a.value === "success" && A.landed ? { key: "landed", ...A.landed } : l.value && A.waiting ? { key: "wait", ...A.waiting } : { key: "step", title: A.title, body: A.body };
    }), y = I(() => p.value.title), v = I(() => p.value.body), x = I(() => r.value.task ? g3(r.value.task) : []), w = /* @__PURE__ */ new Set(["Tab", "Esc", "Enter"]), S = I(() => r.value.kind === "run" && !x.value.some((A) => A.strong && w.has(A.text))), M = I(() => r.value.note ? g3(r.value.note.how) : []), _ = pn(["mod", "enter"]), T = /* @__PURE__ */ W(0);
    Ee(() => t.tour.nudges.value, () => {
      T.value++;
    });
    const k = /* @__PURE__ */ W(null);
    let P = null;
    return Ee(k, (A, R) => {
      P && R && P.unobserve(R), A && (P || (P = new ResizeObserver(() => {
        k.value && i("size", { w: k.value.offsetWidth, h: k.value.offsetHeight });
      })), P.observe(A), i("size", { w: A.offsetWidth, h: A.offsetHeight }));
    }), (A, R) => (g(), b("div", {
      ref_key: "card",
      ref: k,
      class: G(["ob-card", { "has-demo": !!d.value, "is-wide": n.wide, "is-short": n.short && !!d.value, "is-entering": a.value === "enter", "is-done": a.value === "success", "is-waiting": l.value }]),
      style: ce({ transform: "translate3d(" + Math.round(n.x) + "px, " + Math.round(n.y) + "px, 0)" }),
      role: "dialog",
      "aria-live": "polite",
      "aria-label": r.value.title,
      "data-tour-ui": "",
      "data-testid": "tour-card",
      "data-step": r.value.id
    }, [
      C(vt, {
        name: "ob-media",
        mode: "out-in"
      }, {
        default: Xe(() => [
          d.value ? (g(), b("div", {
            key: r.value.demo,
            class: "ob-media"
          }, [
            (g(), Ie(da(d.value))),
            u("span", _Ee, [
              C($, {
                name: o[c.value.id] || "Sparkles",
                size: 10
              }, null, 8, ["name"]),
              Y(E(c.value.label), 1)
            ])
          ])) : z("", !0)
        ]),
        _: 1
      }),
      u("div", SEe, [
        u("div", MEe, [
          C(vt, { name: "ob-words" }, {
            default: Xe(() => [
              (g(), b("div", {
                key: r.value.id + ":" + p.value.key,
                class: "ob-words"
              }, [
                r.value.note ? (g(), b("div", TEe, [
                  u("span", CEe, [
                    C($, {
                      name: "Check",
                      size: 11,
                      stroke: 3
                    })
                  ]),
                  u("span", IEe, [
                    u("b", null, E(r.value.note.did), 1),
                    u("span", null, [
                      (g(!0), b(j, null, ge(M.value, (D, O) => (g(), b(j, { key: O }, [
                        D.strong ? (g(), b("kbd", AEe, E(D.text), 1)) : (g(), b(j, { key: 1 }, [
                          Y(E(D.text), 1)
                        ], 64))
                      ], 64))), 128))
                    ])
                  ])
                ])) : z("", !0),
                u("b", PEe, E(y.value), 1),
                u("span", EEe, E(v.value), 1)
              ]))
            ]),
            _: 1
          })
        ]),
        r.value.kind !== "continue" ? (g(), b("div", {
          key: "task" + T.value,
          class: G(["ob-task", { "is-shaking": T.value > 0 && a.value === "task" }]),
          "data-testid": "tour-task"
        }, [
          a.value === "success" ? (g(), b(j, { key: 0 }, [
            u("span", REe, [
              C($, {
                name: "Check",
                size: 12,
                stroke: 3
              })
            ]),
            R[2] || (R[2] = u("span", null, "Nice", -1))
          ], 64)) : l.value ? (g(), b(j, { key: 1 }, [
            R[3] || (R[3] = u("span", { class: "ob-spin" }, null, -1)),
            R[4] || (R[4] = u("span", null, "Working on it", -1))
          ], 64)) : (g(), b(j, { key: 2 }, [
            R[6] || (R[6] = u("span", { class: "ob-dot" }, null, -1)),
            u("span", zEe, [
              (g(!0), b(j, null, ge(x.value, (D, O) => (g(), b(j, { key: O }, [
                D.strong && m(w).has(D.text) ? (g(), b("kbd", $Ee, E(D.text), 1)) : D.strong ? (g(), b("span", DEe, E(D.text), 1)) : (g(), b(j, { key: 2 }, [
                  Y(E(D.text), 1)
                ], 64))
              ], 64))), 128)),
              S.value ? (g(), b(j, { key: 0 }, [
                R[5] || (R[5] = Y(" or press ", -1)),
                (g(!0), b(j, null, ge(m(_), (D) => (g(), b("kbd", {
                  key: D,
                  class: "ob-key"
                }, E(D), 1))), 128))
              ], 64)) : z("", !0)
            ])
          ], 64))
        ], 2)) : z("", !0),
        n.tour.nudgeHint.value && a.value === "task" && r.value.kind !== "continue" ? (g(), b("div", {
          key: "hint" + T.value,
          class: "ob-hint",
          "data-testid": "tour-hint"
        }, E(n.tour.nudgeHint.value), 1)) : z("", !0),
        u("div", OEe, [
          u("span", {
            class: "ob-steps",
            "aria-label": "Step " + (f.value + 1) + " of " + h.value.length + " in " + c.value.label
          }, [
            (g(!0), b(j, null, ge(h.value, (D, O) => (g(), b("i", {
              key: D.id,
              class: G({ on: O === f.value, done: O < f.value || O === f.value && a.value === "success" })
            }, null, 2))), 128))
          ], 8, LEe),
          u("span", BEe, [
            n.tour.canBack ? (g(), b("button", {
              key: 0,
              class: "ob-link",
              "data-testid": "tour-back",
              onClick: R[0] || (R[0] = (D) => n.tour.back())
            }, "Back")) : z("", !0),
            r.value.kind === "continue" ? (g(), b("button", {
              key: 1,
              class: "ob-btn",
              disabled: a.value !== "task",
              "data-testid": "tour-continue",
              onClick: R[1] || (R[1] = (D) => n.tour.next())
            }, [...R[7] || (R[7] = [
              Y(" Continue", -1),
              u("kbd", { class: "ob-key is-on-btn" }, "↵", -1)
            ])], 8, FEe)) : z("", !0)
          ])
        ])
      ])
    ], 14, kEe));
  }
}), UEe = {
  class: "licon",
  "aria-hidden": "true",
  style: { display: "inline-flex", flex: "none" }
}, an = /* @__PURE__ */ Pe({
  __name: "LIcon",
  props: {
    name: {},
    size: { default: 16 },
    stroke: { default: 2 }
  },
  setup(n) {
    const e = {
      ArrowDown: vR,
      ArrowUp: r6,
      ArrowUpDown: _R,
      ArrowUpRight: o6,
      Check: a6,
      ChevronDown: l6,
      ChevronLeft: d6,
      ChevronRight: c6,
      CircleAlert: wv,
      CircleCheck: u6,
      Copy: p6,
      Download: f6,
      Ellipsis: m6,
      ExternalLink: g6,
      Globe: v6,
      Image: k6,
      LayoutGrid: _6,
      Lock: T6,
      Minus: I6,
      Pencil: P6,
      Plus: z6,
      RefreshCw: zD,
      Search: D6,
      ShieldCheck: uO,
      SlidersHorizontal: L6,
      Sparkles: kv,
      StickyNote: F6,
      Table2: zO,
      Trash2: N6,
      UserRound: iL,
      Users: G6,
      Wand2: H6,
      X: V6,
      // Edit and Access Settings
      ArrowRight: s6,
      CircleMinus: pz,
      CircleX: h6,
      Link: d7,
      LoaderCircle: M6,
      UserCheck: ZO,
      UserPlus: U6,
      UserRoundCog: tL,
      // the hero's demo window
      Frame: b6,
      Hand: y6,
      Heart: x6,
      ImagePlus: w6,
      LayoutTemplate: S6,
      Maximize2: C6,
      MousePointer2: A6,
      Pause: hD,
      Pipette: E6,
      Play: R6,
      RectangleVertical: $6,
      Settings: O6,
      Square: B6,
      Video: j6,
      // the hero's Take the tour (IL-095), and its minimize (IL-108)
      CirclePlay: mz,
      Minimize2: N7
    }, t = n, i = I(() => e[t.name] || kv);
    return (s, o) => (g(), b("span", UEe, [
      (g(), Ie(da(i.value), {
        size: n.size,
        "stroke-width": n.stroke
      }, null, 8, ["size", "stroke-width"]))
    ]));
  }
});
function GEe() {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return !1;
  }
}
function jEe() {
  const n = /* @__PURE__ */ W(GEe());
  let e = null;
  const t = () => {
    n.value = !!e && e.matches;
  };
  return it(() => {
    try {
      e = window.matchMedia("(prefers-reduced-motion: reduce)"), e.addEventListener("change", t);
    } catch {
      e = null;
    }
  }), We(() => {
    e && e.removeEventListener("change", t);
  }), n;
}
const HEe = ["viewBox"], VEe = ["d", "fill"], WEe = { class: "bl-hd-canvas" }, qEe = { class: "bl-hd-ftitle" }, KEe = { key: 1 }, YEe = { class: "bl-hd-flabel" }, XEe = ["src", "fetchpriority"], JEe = {
  key: 0,
  class: "bl-hd-play"
}, ZEe = ["src"], QEe = { class: "bl-hd-session-head" }, e9e = { class: "bl-hd-badge" }, t9e = { class: "bl-hd-session-titles" }, n9e = { class: "kind" }, i9e = { class: "model" }, s9e = { class: "name" }, o9e = { class: "bl-hd-count" }, r9e = { class: "bl-hd-thumbs" }, a9e = ["src"], l9e = { class: "bl-hd-foot" }, d9e = { class: "bl-hd-session-head" }, c9e = { class: "bl-hd-badge" }, u9e = { class: "bl-hd-session-titles" }, h9e = { class: "kind" }, p9e = { class: "model" }, f9e = { class: "name" }, m9e = ["src"], g9e = { class: "text" }, b9e = { class: "meta" }, v9e = { class: "text" }, y9e = { class: "meta" }, x9e = { class: "bl-hd-add is-plus" }, w9e = { class: "bl-hd-rail" }, k9e = { class: "is-on" }, _9e = { class: "bl-hd-prompt-side" }, S9e = ["src"], M9e = { class: "bl-hd-prompt-text" }, T9e = { class: "bl-hd-prompt-foot" }, C9e = { class: "chip" }, I9e = { class: "chip" }, A9e = { class: "cog" }, P9e = { class: "step" }, E9e = ["src"], mP = /* @__PURE__ */ Pe({
  __name: "HeroDemo",
  props: {
    paused: { type: Boolean },
    opening: { type: Boolean }
  },
  setup(n, { expose: e }) {
    const t = n, i = jEe(), s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(null), c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(null), f = /* @__PURE__ */ W(null), p = /* @__PURE__ */ W(null), y = /* @__PURE__ */ W(null), v = /* @__PURE__ */ W(null), x = /* @__PURE__ */ W(null), w = /* @__PURE__ */ W(null), S = /* @__PURE__ */ W(null), M = /* @__PURE__ */ W(null), _ = /* @__PURE__ */ W(null), T = /* @__PURE__ */ W(null), k = /* @__PURE__ */ W(null), P = /* @__PURE__ */ W(null), A = /* @__PURE__ */ W(null), R = /* @__PURE__ */ W(null), D = /* @__PURE__ */ W(null), O = /* @__PURE__ */ W(null), F = /* @__PURE__ */ W(null), ie = /* @__PURE__ */ W(null), ee = [], me = [];
    let L = null, N = null;
    const K = ($e) => {
      L = $e;
    }, B = ($e) => {
      N = $e;
    }, re = rP.filter(($e) => $e !== ti), H = oP;
    function J($e) {
      const Ne = { left: $e.x + "px", top: $e.y + "px" };
      return $e.w && (Ne.width = $e.w + "px"), $e.h && (Ne.height = $e.h + "px"), Ne;
    }
    function Q($e) {
      return $e + ($e === 1 ? " item" : " items");
    }
    function ne($e) {
      const Ne = $e.target;
      Ne.classList.remove("is-broken"), Ne.classList.add("is-in");
    }
    function ue($e) {
      const Ne = $e.target;
      Ne.classList.add("is-broken"), !(Ne.dataset.retried || !at) && (Ne.dataset.retried = "1", window.setTimeout(() => {
        at && (Ne.src = Ne.src + (Ne.src.includes("?") ? "&" : "?") + "retry=1");
      }, 2e3));
    }
    const Z = /* @__PURE__ */ new WeakMap();
    function te($e, Ne, V) {
      if (!$e) return;
      let X = Z.get($e);
      X || Z.set($e, X = {}), X[Ne] !== V && (X[Ne] = V, $e.style.setProperty(Ne, V));
    }
    function we($e, Ne) {
      $e && $e.textContent !== Ne && ($e.textContent = Ne);
    }
    function Fe($e, Ne, V) {
      $e && $e.classList.contains(Ne) !== V && $e.classList.toggle(Ne, V);
    }
    const Me = ($e) => $e.toFixed(2), he = ($e) => $e.toFixed(3);
    function U($e, Ne = !1) {
      const { cam: V } = $e;
      te(a.value, "transform", `translate(${Me(jf.x - V.fx * V.z)}px, ${Me(jf.y - V.fy * V.z)}px) scale(${V.z.toFixed(4)})`), te(a.value, "--z", he(V.z)), te(a.value, "--iz", he(1 / V.z)), we(d.value, Math.round(V.z * 100) + "%"), te(c.value, "opacity", he($e.dock)), te(c.value, "transform", `translate(-50%, ${Me((1 - $e.dock) * 10)}px)`), te(h.value, "opacity", he($e.prompt)), te(h.value, "transform", `translateY(${Me((1 - $e.prompt) * 14)}px)`), te(h.value, "visibility", $e.prompt > 1e-3 ? "visible" : "hidden"), te(f.value, "opacity", $e.typed ? "0" : "1"), we(p.value, e1.slice(0, $e.typed)), te(y.value, "opacity", String(Ne ? 0 : $e.caret)), te(x.value, "opacity", he($e.refIn)), te(x.value, "transform", `scale(${he(0.82 + 0.18 * $e.refIn)})`), te(w.value, "opacity", he($e.refGlow)), Fe(v.value, "is-target", $e.ghost.ring > 0.5 && $e.ghost.shown > 0 && !$e.refIn), Fe(S.value, "is-lit", $e.runLit > 0.5), Fe(S.value, "is-pressed", $e.runPressed > 0), Fe(S.value, "is-busy", $e.runBusy), te(M.value, "opacity", he($e.sessionSelected)), we(_.value, $e.sessionFoot), te(T.value, "opacity", $e.sessionCount ? "1" : "0"), Fe(k.value, "is-busy", $e.shimmer), $e.sessionThumbs.forEach((Le, ve) => {
        te(me[ve], "opacity", he(Le)), te(me[ve], "transform", `scale(${he(0.82 + 0.18 * Le)})`);
      }), $e.results.forEach((Le, ve) => {
        te(ee[ve], "opacity", he(Le)), te(ee[ve], "transform", `translateY(${Me((1 - Le) * 34)}px)`);
      }), te(N, "opacity", $e.heart > 0 ? "1" : "0"), te(N, "transform", `scale(${he($e.heart)})`), te(P.value, "opacity", he($e.note)), te(P.value, "transform", `translateY(${Me((1 - $e.note) * 34)}px)`), we(L, Q($e.frameItems));
      const X = $e.pointer;
      te(A.value, "opacity", Ne ? "0" : he(X.shown)), te(A.value, "transform", `translate(${Me(X.x)}px, ${Me(X.y)}px)`), Fe(A.value, "is-pressed", X.pressed > 0), te(R.value, "opacity", he(X.shift)), te(F.value, "opacity", Ne ? "0" : he($e.ripple.shown)), te(F.value, "transform", `translate(${Me($e.ripple.x)}px, ${Me($e.ripple.y)}px) scale(${he($e.ripple.size)})`);
      const le = $e.ghost;
      te(D.value, "opacity", Ne ? "0" : he(le.shown)), te(D.value, "transform", `translate(${Me(le.x + 12)}px, ${Me(le.y + 14)}px) rotate(${Me(le.tilt)}deg) scale(${he(0.86 + 0.14 * le.shown)})`), te(O.value, "opacity", he(le.ring)), te(ie.value, "opacity", $e.sheen < 0 ? "0" : he(Math.sin(Math.PI * $e.sheen))), te(ie.value, "transform", `translateX(${Me(-100 + 270 * Math.max(0, $e.sheen))}%)`);
    }
    let q = 0, oe = 0, de = 0, pe = !1, Ce = !1;
    function Be() {
      return !i.value && pe && Ce && !0 && !t.paused && !t.opening && !document.hidden;
    }
    function be($e) {
      const Ne = tp(0);
      U({ ...Ne, cam: $e.cam, dock: Ne.dock * $e.chrome }, !0), te(s.value, "--build", he($e.build)), te(r.value, "opacity", he($e.chrome)), te(l.value, "opacity", he($e.chrome));
      const V = $e.glint || { pic: 0, session: 0, note: 0, frame: 0 };
      te(s.value, "--g-pic", he(V.pic)), te(s.value, "--g-session", he(V.session)), te(s.value, "--g-note", he(V.note)), te(s.value, "--g-frame", he(V.frame));
    }
    e({ paintOpening: be });
    const se = ($e, Ne = 0) => ({ "--d": String(xAe($e, Ne)) });
    function ae($e) {
      oe = ($e - de) / 1e3 % Fp, U(tp(oe)), q = requestAnimationFrame(ae);
    }
    function ye() {
      if (Be()) {
        q || (de = performance.now() - oe * 1e3, q = requestAnimationFrame(ae));
        return;
      }
      q && (cancelAnimationFrame(q), q = 0), i.value && U(tp(u3), !0);
    }
    Ee(() => t.paused, ye), Ee(i, ye);
    function Oe() {
      const $e = s.value;
      $e && o.value && te(o.value, "transform", `scale(${($e.clientWidth / Wn.w).toFixed(5)})`);
    }
    function Ve() {
      const $e = Array.from(s.value ? s.value.querySelectorAll("img") : []), Ne = Promise.allSettled($e.map((V) => V.decode ? V.decode() : Promise.resolve()));
      return Promise.race([Ne.then(() => {
      }), new Promise((V) => window.setTimeout(V, 4500))]);
    }
    let Ue = null, tt = null;
    const Ye = () => ye();
    let at = !0;
    it(() => {
      Oe(), typeof ResizeObserver != "undefined" && s.value && (tt = new ResizeObserver(Oe), tt.observe(s.value)), U(tp(i.value ? u3 : 0), i.value), typeof IntersectionObserver != "undefined" && s.value ? (Ue = new IntersectionObserver(($e) => {
        pe = $e.some((Ne) => Ne.isIntersecting), ye();
      }, { threshold: 0.08 }), Ue.observe(s.value)) : pe = !0, document.addEventListener("visibilitychange", Ye), Ve().then(() => {
        at && (Ce = !0, ye());
      });
    }), We(() => {
      at = !1, q && cancelAnimationFrame(q), q = 0, Ue && Ue.disconnect(), tt && tt.disconnect(), document.removeEventListener("visibilitychange", Ye);
    });
    const kt = ($e) => "is-" + $e.tint;
    return ($e, Ne) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: G(["bl-hd", { "is-opening": n.opening }]),
      "aria-hidden": "true",
      "data-testid": "hero-demo"
    }, [
      u("div", {
        ref_key: "win",
        ref: o,
        class: "bl-hd-win",
        style: ce({ width: m(Wn).w + "px", height: m(Wn).h + "px" })
      }, [
        u("div", {
          ref_key: "bar",
          ref: r,
          class: "bl-hd-bar"
        }, [
          Ne[0] || (Ne[0] = u("span", { class: "bl-hd-lights" }, [
            u("i"),
            u("i"),
            u("i")
          ], -1)),
          (g(), b("svg", {
            class: "bl-hd-mark",
            viewBox: m(Ql),
            width: "25",
            height: "18"
          }, [
            (g(!0), b(j, null, ge(m(ma), (V) => (g(), b("path", {
              key: V.d,
              d: V.d,
              fill: V.fill
            }, null, 8, VEe))), 128))
          ], 8, HEe)),
          Ne[1] || (Ne[1] = u("span", { class: "bl-hd-crumbs" }, [
            Y("Boards "),
            u("span", { class: "sep" }, "/"),
            Y(),
            u("b", null, "Bonneville Tower")
          ], -1)),
          Ne[2] || (Ne[2] = u("span", { class: "bl-hd-saved" }, [
            u("i"),
            Y("Saved")
          ], -1)),
          Ne[3] || (Ne[3] = u("span", { class: "bl-hd-kebab" }, [
            u("i"),
            u("i"),
            u("i")
          ], -1))
        ], 512),
        u("div", WEe, [
          u("div", {
            ref_key: "world",
            ref: a,
            class: "bl-hd-world"
          }, [
            Ne[6] || (Ne[6] = u("div", { class: "bl-hd-dots is-fine" }, null, -1)),
            Ne[7] || (Ne[7] = u("div", { class: "bl-hd-dots is-coarse" }, null, -1)),
            (g(!0), b(j, null, ge(m(iP), (V) => (g(), b("div", {
              key: V.title,
              class: "bl-hd-frame",
              style: ce({ ...J(V), ...se(V, 0.06) })
            }, [
              u("span", qEe, [
                Y(E(V.title) + " ", 1),
                V === m(sP) ? (g(), b("small", {
                  key: 0,
                  ref_for: !0,
                  ref: K
                }, E(Q(m(t1)(V))), 513)) : (g(), b("small", KEe, E(Q(m(t1)(V))), 1))
              ]),
              u("span", YEe, E(V.title), 1)
            ], 4))), 128)),
            (g(!0), b(j, null, ge(m(H), (V) => (g(), b("div", {
              key: V.id,
              class: G(["bl-hd-pic", { "is-video": V.video }]),
              style: ce({ ...J(V), ...se(V) })
            }, [
              u("img", {
                src: V.src,
                alt: "",
                decoding: "async",
                fetchpriority: V === m(Tl) ? "high" : "low",
                onLoad: ne,
                onError: ue
              }, null, 40, XEe),
              V.video ? (g(), b("span", JEe, [
                C(an, {
                  name: "Play",
                  size: 11,
                  stroke: 2.4
                })
              ])) : z("", !0)
            ], 6))), 128)),
            (g(!0), b(j, null, ge(m(No), (V, X) => (g(), b("div", {
              key: V.id,
              ref_for: !0,
              ref: (le) => {
                le && (ee[X] = le);
              },
              class: G(["bl-hd-pic is-result", { "is-first": X === 0 }]),
              style: ce(J(V))
            }, [
              u("img", {
                src: V.src,
                alt: "",
                decoding: "async",
                onLoad: ne,
                onError: ue
              }, null, 40, ZEe),
              X === 0 ? (g(), b("span", {
                key: 0,
                ref_for: !0,
                ref: B,
                class: "bl-hd-heart"
              }, [
                C(an, {
                  name: "Heart",
                  size: 10,
                  stroke: 2.6
                })
              ], 512)) : z("", !0)
            ], 6))), 128)),
            (g(!0), b(j, null, ge(m(re), (V) => (g(), b("div", {
              key: V.id,
              class: "bl-hd-session",
              style: ce({ ...J({ x: V.x, y: V.y, w: m(_o).w, h: m(_o).h }), ...se({ x: V.x, y: V.y, w: m(_o).w, h: m(_o).h }) })
            }, [
              u("div", QEe, [
                u("span", e9e, [
                  C(an, {
                    name: V.kind,
                    size: 17
                  }, null, 8, ["name"])
                ]),
                u("span", t9e, [
                  u("span", n9e, [
                    Y(E(V.kind), 1),
                    Ne[4] || (Ne[4] = u("span", { class: "sep" }, "·", -1)),
                    u("span", i9e, E(V.model), 1)
                  ]),
                  u("span", s9e, E(V.name), 1)
                ]),
                u("span", o9e, E(V.thumbs.length), 1)
              ]),
              u("div", r9e, [
                (g(), b(j, null, ge(4, (X) => u("span", {
                  key: X,
                  class: G(["bl-hd-thumb", { "is-empty": !V.thumbs[X - 1] }])
                }, [
                  V.thumbs[X - 1] ? (g(), b("img", {
                    key: 0,
                    src: V.thumbs[X - 1],
                    alt: "",
                    decoding: "async",
                    fetchpriority: "low",
                    onLoad: ne,
                    onError: ue
                  }, null, 40, a9e)) : z("", !0)
                ], 2)), 64))
              ]),
              u("div", l9e, E(V.foot), 1)
            ], 4))), 128)),
            u("div", {
              class: "bl-hd-session is-hero",
              style: ce({ ...J({ x: m(ti).x, y: m(ti).y, w: m(_o).w, h: m(_o).h }), ...se({ x: m(ti).x, y: m(ti).y, w: m(_o).w, h: m(_o).h }) })
            }, [
              u("span", {
                ref_key: "ring",
                ref: M,
                class: "bl-hd-ring"
              }, null, 512),
              u("div", d9e, [
                u("span", c9e, [
                  C(an, {
                    name: "Image",
                    size: 17
                  })
                ]),
                u("span", u9e, [
                  u("span", h9e, [
                    Y(E(m(ti).kind), 1),
                    Ne[5] || (Ne[5] = u("span", { class: "sep" }, "·", -1)),
                    u("span", p9e, E(m(ti).model), 1)
                  ]),
                  u("span", f9e, E(m(ti).name), 1)
                ]),
                u("span", {
                  ref_key: "count",
                  ref: T,
                  class: "bl-hd-count"
                }, E(m(No).length), 513)
              ]),
              u("div", {
                ref_key: "thumbsRow",
                ref: k,
                class: "bl-hd-thumbs"
              }, [
                (g(!0), b(j, null, ge(m(No), (V, X) => (g(), b("span", {
                  key: V.id,
                  class: "bl-hd-thumb is-empty"
                }, [
                  u("img", {
                    ref_for: !0,
                    ref: (le) => {
                      le && (me[X] = le);
                    },
                    src: V.src,
                    alt: "",
                    decoding: "async",
                    class: "is-in",
                    onLoad: ne,
                    onError: ue
                  }, null, 40, m9e)
                ]))), 128))
              ], 512),
              u("div", {
                ref_key: "foot",
                ref: _,
                class: "bl-hd-foot"
              }, E(m(ti).foot), 513)
            ], 4),
            (g(!0), b(j, null, ge(m(aP), (V) => (g(), b("div", {
              key: V.id,
              class: G(["bl-hd-note", kt(V)]),
              style: ce({ ...J(V), ...se(V) })
            }, [
              u("span", g9e, E(V.text), 1),
              u("span", b9e, E(V.by), 1)
            ], 6))), 128)),
            u("div", {
              ref_key: "note",
              ref: P,
              class: G(["bl-hd-note", kt(m(Qh))]),
              style: ce(J(m(Qh)))
            }, [
              u("span", v9e, E(m(Qh).text), 1),
              u("span", y9e, E(m(Qh).by), 1)
            ], 6)
          ], 512),
          u("div", {
            ref_key: "dock",
            ref: c,
            class: "bl-hd-dock",
            style: ce({ top: m(Q0) - 46 + "px" })
          }, [
            u("span", x9e, [
              C(an, {
                name: "Plus",
                size: 17,
                stroke: 2.4
              })
            ]),
            u("span", w9e, [
              u("i", k9e, [
                C(an, {
                  name: "MousePointer2",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Hand",
                  size: 15
                })
              ]),
              Ne[8] || (Ne[8] = u("b", null, null, -1)),
              u("i", null, [
                C(an, {
                  name: "Image",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "StickyNote",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Frame",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Square",
                  size: 15
                })
              ])
            ])
          ], 4),
          u("div", {
            ref_key: "prompt",
            ref: h,
            class: "bl-hd-prompt",
            style: ce(J(m(Ys)))
          }, [
            u("span", _9e, [
              u("i", null, [
                C(an, {
                  name: "LayoutTemplate",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Pipette",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Maximize2",
                  size: 14
                })
              ])
            ]),
            u("span", {
              ref_key: "slot",
              ref: v,
              class: "bl-hd-slot",
              style: ce({ left: m(Fo).x - m(Ys).x + "px", top: m(Fo).y - m(Ys).y + "px", width: m(Fo).w + "px", height: m(Fo).h + "px" })
            }, [
              C(an, {
                name: "ImagePlus",
                size: 17
              }),
              u("span", {
                ref_key: "refGlow",
                ref: w,
                class: "glow"
              }, null, 512),
              u("img", {
                ref_key: "refThumb",
                ref: x,
                src: m(Tl).src,
                alt: "",
                decoding: "async",
                class: "is-in",
                onError: ue
              }, null, 40, S9e)
            ], 4),
            u("span", M9e, [
              u("span", {
                ref_key: "placeholder",
                ref: f,
                class: "ph"
              }, "Describe what " + E(m(ti).name) + " should make", 513),
              u("span", {
                ref_key: "typedEl",
                ref: p,
                class: "typed"
              }, null, 512),
              u("span", {
                ref_key: "caret",
                ref: y,
                class: "caret"
              }, null, 512)
            ]),
            u("span", T9e, [
              u("span", C9e, [
                Ne[9] || (Ne[9] = u("small", null, "Model", -1)),
                Y(E(m(ti).model), 1),
                C(an, {
                  name: "ChevronDown",
                  size: 12
                })
              ]),
              u("span", I9e, [
                C(an, {
                  name: "RectangleVertical",
                  size: 12
                }),
                Ne[10] || (Ne[10] = Y("896×1152", -1))
              ]),
              u("span", A9e, [
                C(an, {
                  name: "Settings",
                  size: 14
                })
              ]),
              Ne[11] || (Ne[11] = u("span", { class: "sp" }, null, -1)),
              u("span", P9e, [
                C(an, {
                  name: "Minus",
                  size: 11
                }),
                u("b", null, E(m(No).length), 1),
                C(an, {
                  name: "Plus",
                  size: 11
                })
              ]),
              u("span", {
                ref_key: "run",
                ref: S,
                class: "run",
                style: ce({ width: m(ec).w + "px" })
              }, "Run", 4)
            ])
          ], 4),
          u("span", {
            ref_key: "zoomPill",
            ref: l,
            class: "bl-hd-zoom",
            style: ce({ top: m(Q0) - 34 + "px" })
          }, [
            C(an, {
              name: "Minus",
              size: 12
            }),
            u("span", {
              ref_key: "zoomText",
              ref: d,
              class: "pct"
            }, "29%", 512),
            C(an, {
              name: "Plus",
              size: 12
            })
          ], 4),
          u("span", {
            ref_key: "ghost",
            ref: D,
            class: "bl-hd-ghost"
          }, [
            u("img", {
              src: m(Tl).src,
              alt: "",
              class: "is-in",
              onError: ue
            }, null, 40, E9e),
            u("span", {
              ref_key: "ghostRing",
              ref: O,
              class: "ring"
            }, null, 512)
          ], 512),
          u("span", {
            ref_key: "ripple",
            ref: F,
            class: "bl-hd-ripple"
          }, null, 512),
          u("span", {
            ref_key: "pointer",
            ref: A,
            class: "bl-hd-pointer"
          }, [
            Ne[12] || (Ne[12] = u("svg", {
              class: "arrow",
              width: "22",
              height: "22",
              viewBox: "0 0 22 22"
            }, [
              u("path", {
                d: "M4 2.5v15.2l3.9-3.7 2.6 6 2.7-1.2-2.6-5.9h5.4z",
                fill: "#fff",
                stroke: "#0b0d14",
                "stroke-width": "1.3",
                "stroke-linejoin": "round"
              })
            ], -1)),
            u("span", {
              ref_key: "shiftKey",
              ref: R,
              class: "bl-hd-key"
            }, "⇧ Shift", 512)
          ], 512)
        ]),
        u("span", {
          ref_key: "sheen",
          ref: ie,
          class: "bl-hd-sheen"
        }, null, 512)
      ], 4)
    ], 2));
  }
}), R9e = ["aria-label"], z9e = { class: "ob-welcome-media" }, $9e = { class: "ob-welcome-body" }, D9e = { class: "ob-eyebrow" }, O9e = { class: "ob-welcome-title" }, L9e = { class: "ob-welcome-text" }, B9e = { class: "ob-welcome-actions" }, F9e = ["disabled"], N9e = /* @__PURE__ */ Pe({
  __name: "WelcomeCard",
  props: {
    tour: {}
  },
  setup(n) {
    const e = n, t = Am("welcome"), i = I(() => DAe(e.tour.reason, e.tour.boardRef)), s = I(() => e.tour.phase.value === "task");
    return (o, r) => (g(), b("div", {
      class: G(["ob-welcome", { "is-intro": !!n.tour.intro.value }]),
      role: "dialog",
      "aria-label": m(t).title,
      "data-tour-ui": "",
      "data-testid": "tour-welcome"
    }, [
      u("div", z9e, [
        C(mP, {
          paused: !!n.tour.intro.value
        }, null, 8, ["paused"]),
        r[1] || (r[1] = u("span", { class: "ob-welcome-fade" }, null, -1))
      ]),
      u("div", $9e, [
        u("span", D9e, E(m(t).eyebrow), 1),
        u("h1", O9e, E(m(t).title), 1),
        u("p", L9e, E(i.value), 1),
        u("div", B9e, [
          u("button", {
            class: "ob-btn is-big",
            disabled: !s.value,
            "data-testid": "tour-start",
            onClick: r[0] || (r[0] = (a) => n.tour.next())
          }, [
            Y(E(m(OAe)(n.tour.reason)), 1),
            C($, {
              name: "ArrowRight",
              size: 15,
              stroke: 2.4
            })
          ], 8, F9e),
          r[2] || (r[2] = u("span", { class: "ob-or" }, [
            Y("or press "),
            u("kbd", { class: "ob-key" }, "↵")
          ], -1))
        ])
      ])
    ], 10, R9e));
  }
}), U9e = ["aria-label"], G9e = {
  class: "ob-finale-mark",
  "aria-hidden": "true"
}, j9e = ["viewBox"], H9e = ["d", "fill"], V9e = { class: "ob-finale-title" }, W9e = { class: "ob-finale-text" }, q9e = { class: "ob-learned" }, K9e = { class: "ob-tick" }, Y9e = {
  key: 0,
  class: "ob-finale-error",
  role: "alert"
}, X9e = { class: "ob-finale-actions" }, J9e = ["disabled"], Z9e = ["disabled"], Q9e = /* @__PURE__ */ Pe({
  __name: "TourFinale",
  props: {
    tour: {},
    busy: { type: Boolean },
    error: {}
  },
  setup(n) {
    const e = n, t = Am("finale"), i = I(() => LAe(e.tour.reason, e.tour.boardRef)), s = I(() => FAe(e.tour.reason, e.tour.boardRef)), o = I(() => e.busy ? s.value.exit === "create-board" ? "Creating your board…" : "Opening…" : s.value.label), r = /* @__PURE__ */ W(null);
    return it(() => {
      window.setTimeout(() => {
        r.value && r.value.focus({ preventScroll: !0 });
      }, 700);
    }), (a, l) => (g(), b("div", {
      class: "ob-finale",
      role: "dialog",
      "aria-label": m(t).title,
      "data-tour-ui": "",
      "data-testid": "tour-finale"
    }, [
      u("div", G9e, [
        l[2] || (l[2] = u("span", { class: "halo" }, null, -1)),
        (g(), b("svg", {
          viewBox: m(Ql),
          width: "64",
          height: "46"
        }, [
          (g(!0), b(j, null, ge(m(ma), (d, c) => (g(), b("path", {
            key: d.d,
            d: d.d,
            fill: d.fill,
            style: ce({ "--i": c })
          }, null, 12, H9e))), 128))
        ], 8, j9e))
      ]),
      u("h1", V9e, E(m(t).title), 1),
      u("p", W9e, E(i.value), 1),
      u("ul", q9e, [
        (g(!0), b(j, null, ge(m(BAe), (d, c) => (g(), b("li", {
          key: d,
          style: ce({ "--i": c })
        }, [
          u("span", K9e, [
            C($, {
              name: "Check",
              size: 11,
              stroke: 3
            })
          ]),
          Y(E(d), 1)
        ], 4))), 128))
      ]),
      n.error ? (g(), b("p", Y9e, E(n.error), 1)) : z("", !0),
      u("div", X9e, [
        u("button", {
          ref_key: "primary",
          ref: r,
          class: "ob-btn is-big",
          disabled: n.busy,
          "data-testid": "tour-finish",
          onClick: l[0] || (l[0] = (d) => n.tour.finish(s.value.exit))
        }, [
          Y(E(o.value), 1),
          n.busy ? z("", !0) : (g(), Ie($, {
            key: 0,
            name: "ArrowRight",
            size: 15,
            stroke: 2.4
          }))
        ], 8, J9e),
        u("button", {
          class: "ob-link",
          disabled: n.busy,
          "data-testid": "tour-again",
          onClick: l[1] || (l[1] = (d) => n.tour.again())
        }, [
          C($, {
            name: "RotateCcw",
            size: 13
          }),
          l[3] || (l[3] = Y("Take the tour again", -1))
        ], 8, Z9e)
      ])
    ], 8, U9e));
  }
}), mu = 6.4, xt = {
  /** the loader that held while the board opened gives way */
  loader: [0, 0.45],
  /** the light behind the mark */
  glow: [0.1, 1.2],
  /** the mark's facets turn in, each a step after the last, where the loader was (the middle of the window) */
  facets: { at: 0.2, each: 0.78, step: 0.12 },
  /** the light passes over the mark */
  sheen: [1.35, 2.05],
  /** the mark rises from the middle to make room for the line */
  rise: [1.2, 2.05],
  /** the mark's slow breath while it holds */
  breathe: [1.1, 3.6],
  /** the line rises, a word a step after the last */
  words: { at: 1.45, each: 0.75, step: 0.13 },
  /** the board's canvas fades up behind the words */
  stage: [2.2, 2.8],
  /** the board builds itself, from the middle out */
  build: [2.3, 4.25],
  /** the row naming what a board holds comes in under the line */
  row: [2.9, 3.15],
  /** the camera draws back the whole time the board shows, ending on the card's first frame */
  pull: [2.2, 6.1],
  /** the shade behind the words while they're over the board */
  scrim: [2.3, 2.9],
  /** the view shrinks into the card's window */
  land: [4.8, 6.1],
  /** the dark lifts off the practice board */
  lift: [4.95, 6.05],
  /** the window's bar, the dock and the zoom come in as it lands */
  chrome: [5.5, 6.05],
  /** the card comes up round it */
  card: [5.3, 6.2],
  /** the big mark hands over to the window bar's own */
  markOut: [5.8, 6.1],
  /** landed: the card's own window (the same picture) shows under the opening's, which fades off it */
  handover: [6.1, 6.35],
  /** Skip intro: there while the opening is full screen */
  skip: [0.8, 1.4]
}, s1 = [
  { key: "pic", label: "Images", at: 3.15 },
  { key: "session", label: "AI sessions", at: 3.5 },
  { key: "note", label: "Notes", at: 3.85 },
  { key: "frame", label: "Frames", at: 4.2 }
], eRe = 0.6, tRe = { fx: 1886, fy: 640, z: 0.6 }, nRe = Uo(0.7, 0, 0.2, 1), iRe = Uo(0.33, 0, 0.15, 1), sRe = Uo(0.16, 1, 0.3, 1), oRe = Uo(0.65, 0, 0.35, 1);
function rRe(n) {
  return n.split(" ").filter(Boolean);
}
function aRe(n, e = 5) {
  const t = Math.max(0, Math.min(mu, n)), i = xt.facets, s = xt.words, o = Ge(t, xt.land[0], xt.land[1], nRe), r = (a) => 1 - Ge(t, xt.land[0], xt.land[0] + a, Je.sine);
  return {
    t,
    backdrop: 1 - Ge(t, xt.lift[0], xt.lift[1], Je.sine),
    loader: 1 - Ge(t, xt.loader[0], xt.loader[1], Je.sine),
    glow: Ge(t, xt.glow[0], xt.glow[1], Je.sine) * r(0.8),
    facets: [0, 1, 2, 3].map((a) => Ge(t, i.at + a * i.step, i.at + a * i.step + i.each)),
    sheen: t < xt.sheen[0] || t > xt.sheen[1] ? -1 : Ge(t, xt.sheen[0], xt.sheen[1]),
    breathe: 1 + 0.03 * Math.sin(Math.PI * Ge(t, xt.breathe[0], xt.breathe[1])),
    rise: Ge(t, xt.rise[0], xt.rise[1], oRe),
    mark: 1 - Ge(t, xt.markOut[0], xt.markOut[1], Je.sine),
    words: Array.from({ length: e }, (a, l) => Ge(t, s.at + l * s.step, s.at + l * s.step + s.each, Je.out)),
    stage: Ge(t, xt.stage[0], xt.stage[1], Je.sine) * (1 - Ge(t, xt.handover[0], xt.handover[1], Je.sine)),
    build: Ge(t, xt.build[0], xt.build[1]),
    row: Ge(t, xt.row[0], xt.row[1], Je.sine) * r(0.35),
    named: s1.map((a) => Ge(t, a.at, a.at + 0.25, Je.out)),
    lit: s1.map((a) => Math.sin(Math.PI * Ge(t, a.at, a.at + eRe))),
    media: t >= xt.handover[0] ? 1 : 0,
    cam: n1(tRe, tc, Ge(t, xt.pull[0], xt.pull[1], iRe)),
    scrim: Ge(t, xt.scrim[0], xt.scrim[1], Je.sine) * r(0.7),
    land: o,
    chrome: Ge(t, xt.chrome[0], xt.chrome[1], Je.sine),
    card: Ge(t, xt.card[0], xt.card[1], Je.out),
    skip: Ge(t, xt.skip[0], xt.skip[1], Je.sine) * r(0.3),
    done: n >= mu
  };
}
function lRe(n, e, t) {
  const i = sRe(Math.max(0, Math.min(1, e))), s = 1 - i, o = t * 0.09 * s;
  return {
    opacity: Math.min(1, Math.max(0, e) / 0.24),
    brightness: 0.35 + 0.65 * i,
    transform: `translate(${(n.out[0] * o).toFixed(2)}px, ${(n.out[1] * o).toFixed(2)}px) rotate3d(${n.axis[0]}, ${n.axis[1]}, 0, ${(88 * s).toFixed(2)}deg) scale(${(0.84 + 0.16 * i).toFixed(4)})`
  };
}
function x3(n) {
  const e = Wn.h - Wn.bar, t = Math.max(n.w, n.h * Wn.w / e), i = t / Wn.w;
  return { x: (n.w - t) / 2, y: (n.h - e * i) / 2 - Wn.bar * i, w: t, h: Wn.h * i };
}
function w3(n) {
  return { x: n.x, y: n.y, w: n.w, h: n.w * Wn.h / Wn.w };
}
function dRe(n, e) {
  return { x: (n.x - e.x) / e.w, y: (n.y - e.y) / e.w, w: n.w / e.w, h: n.h / e.w };
}
function cRe(n, e) {
  return { x: e.x + n.x * e.w, y: e.y + n.y * e.w, w: n.w * e.w, h: n.h * e.w };
}
function k3(n, e, t) {
  return { x: n.x + (e.x - n.x) * t, y: n.y + (e.y - n.y) * t, w: n.w + (e.w - n.w) * t, h: n.h + (e.h - n.h) * t };
}
function _3(n, e, t) {
  const i = 1 + (e.w / n.w - 1) * t;
  return `translate(${((e.x - n.x) * t).toFixed(2)}px, ${((e.y - n.y) * t).toFixed(2)}px) scale(${i.toFixed(4)})`;
}
const uRe = {
  class: "ob-intro-center",
  "aria-hidden": "true"
}, hRe = ["viewBox"], pRe = ["d", "fill"], fRe = {
  key: 0,
  class: "sep"
}, mRe = /* @__PURE__ */ Pe({
  __name: "TourIntro",
  props: {
    tour: {}
  },
  setup(n) {
    const t = n.tour, i = rRe(Am("welcome").title), s = /* @__PURE__ */ W(null), o = /* @__PURE__ */ W(null), r = /* @__PURE__ */ W(null), a = /* @__PURE__ */ W(null), l = /* @__PURE__ */ W(null), d = /* @__PURE__ */ W(null), c = /* @__PURE__ */ W(null), h = /* @__PURE__ */ W(null), f = /* @__PURE__ */ W(null), p = /* @__PURE__ */ W(null), y = /* @__PURE__ */ W(null), v = /* @__PURE__ */ W(null), x = /* @__PURE__ */ W(null), w = /* @__PURE__ */ W(null), S = /* @__PURE__ */ W(null), M = [], _ = [], T = [];
    let k = null;
    const P = /* @__PURE__ */ new WeakMap();
    function A(ue, Z, te) {
      if (!ue) return;
      let we = P.get(ue);
      we || P.set(ue, we = {}), we[Z] !== te && (we[Z] = te, ue.style.setProperty(Z, te));
    }
    const R = (ue) => ue.toFixed(2), D = (ue) => ue.toFixed(3);
    function O(ue, Z) {
      A(ue, "left", R(Z.x) + "px"), A(ue, "top", R(Z.y) + "px"), A(ue, "width", R(Z.w) + "px"), A(ue, "height", R(Z.h) + "px");
    }
    function F(ue) {
      if (!ue) return null;
      const Z = ue.getBoundingClientRect();
      return { x: Z.left, y: Z.top, w: Z.width, h: Z.height };
    }
    let ie = null, ee = null, me = 120;
    function L() {
      const ue = f.value, Z = v.value;
      if (!ue || !Z) return;
      const te = [ue.style.transform, Z.style.transform];
      ue.style.transform = "none", Z.style.transform = "none";
      const we = F(ue), Fe = F(Z);
      ue.style.transform = te[0], Z.style.transform = te[1], we && Fe && (ie = { mark: we, title: Fe }, me = we.w);
    }
    function N() {
      const ue = k ? k.querySelector(".ob-welcome") : null, Z = F(ue && ue.querySelector(".ob-welcome-media")), te = F(ue && ue.querySelector(".ob-welcome-title")), we = F(ue && ue.querySelector(".ob-welcome-media .bl-hd-mark"));
      ee = ue && Z && te && we ? { media: Z, title: te, mark: dRe(we, w3(Z)), radius: parseFloat(getComputedStyle(ue).borderTopLeftRadius) || 0 } : null;
    }
    function K(ue) {
      const Z = aRe(ue, i.length), te = { w: window.innerWidth, h: window.innerHeight };
      A(o.value, "opacity", D(Z.backdrop)), A(r.value, "opacity", D(Z.loader)), A(r.value, "transform", `scale(${D(1 + 0.35 * (1 - Z.loader))})`), A(h.value, "opacity", D(Z.glow)), A(h.value, "transform", `translate(-50%, -50%) scale(${D(0.55 + 0.45 * Z.glow)})`), ma.forEach((q, oe) => {
        const de = lRe(q, Z.facets[oe], me);
        A(M[oe], "opacity", D(de.opacity)), A(M[oe], "transform", de.transform), A(M[oe], "filter", `brightness(${D(de.brightness)})`);
      }), A(y.value, "opacity", Z.sheen < 0 ? "0" : D(Math.sin(Math.PI * Z.sheen))), A(y.value, "background-position", `${R(100 - 100 * Math.max(0, Z.sheen))}% 0`), A(p.value, "transform", `scale(${D(Z.breathe)})`), Z.words.forEach((q, oe) => {
        A(_[oe], "opacity", D(q)), A(_[oe], "transform", `translateY(${R((1 - q) * 28)}px)`), A(_[oe], "filter", q >= 1 ? "none" : `blur(${R((1 - q) * 12)}px)`);
      }), A(x.value, "opacity", D(Z.row)), Z.named.forEach((q, oe) => {
        A(T[oe], "opacity", D(q * (0.5 + 0.5 * Z.lit[oe]))), A(T[oe], "transform", `translateY(${R((1 - q) * 8)}px)`), A(T[oe], "color", Z.lit[oe] > 0.5 ? "#fff" : "");
      }), Z.land > 0 && !ee && (L(), N());
      const we = { x: 0, y: 0, w: te.w, h: te.h }, Fe = ee ? k3(we, ee.media, Z.land) : we, Me = ee ? k3(x3(te), w3(ee.media), Z.land) : x3(te);
      A(a.value, "opacity", D(Z.stage)), O(a.value, Fe);
      const he = R((ee ? ee.radius : 0) * Z.land), U = R(14 * Math.sin(Math.PI * Z.land));
      if (A(a.value, "border-radius", `${he}px ${he}px ${U}px ${U}px`), A(a.value, "box-shadow", `0 40px 120px rgba(0, 0, 0, ${D(0.65 * Math.sin(Math.PI * Z.land))})`), O(l.value, { x: Me.x - Fe.x, y: Me.y - Fe.y, w: Me.w, h: Me.h }), A(d.value, "opacity", D(Z.card)), A(c.value, "opacity", D(Z.scrim)), S.value) {
        const [q, oe, de, pe] = Z.lit;
        S.value.paintOpening({ build: Z.build, cam: Z.cam, chrome: Z.chrome, glint: { pic: q, session: oe, note: de, frame: pe } });
      }
      if (ie && ee && Z.land > 0)
        A(f.value, "transform", _3(ie.mark, cRe(ee.mark, Me), Z.land)), A(v.value, "transform", _3(ie.title, ee.title, Z.land));
      else {
        const q = ie ? te.h / 2 - (ie.mark.y + ie.mark.h / 2) : 0;
        A(f.value, "transform", Z.rise >= 1 ? "none" : `translateY(${R((1 - Z.rise) * q)}px)`), A(v.value, "transform", "none");
      }
      A(f.value, "opacity", D(Z.mark)), A(v.value, "--ts", D(1 - Z.land)), A(w.value, "opacity", D(Z.skip)), A(w.value, "visibility", Z.skip > 0.01 ? "visible" : "hidden"), A(k, "--ob-intro-card", D(Z.card)), A(k, "--ob-intro-media", String(Z.media));
    }
    let B = 0, re = 0, H = 0;
    function J(ue) {
      const Z = H ? Math.min(0.1, (ue - H) / 1e3) : 0;
      if (H = ue, re = Math.min(mu, re + Z), K(re), re >= mu) {
        B = 0, t.introDone();
        return;
      }
      B = requestAnimationFrame(J);
    }
    function Q() {
      B || (H = 0, B = requestAnimationFrame(J));
    }
    Ee(() => t.intro.value, (ue) => {
      ue === "playing" && Q();
    }, { immediate: !0 });
    const ne = () => {
      L(), ee && N(), K(re);
    };
    return it(() => {
      k = s.value ? s.value.closest(".ob-layer") : null, L(), K(re), window.addEventListener("resize", ne);
    }), We(() => {
      B && cancelAnimationFrame(B), B = 0, window.removeEventListener("resize", ne), k && (k.style.removeProperty("--ob-intro-card"), k.style.removeProperty("--ob-intro-media"));
    }), (ue, Z) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: "ob-intro",
      "data-tour-ui": "",
      "data-testid": "tour-intro",
      onWheel: Z[1] || (Z[1] = Te(() => {
      }, ["prevent"])),
      onContextmenu: Z[2] || (Z[2] = Te(() => {
      }, ["prevent"]))
    }, [
      u("div", {
        ref_key: "dark",
        ref: o,
        class: "ob-intro-dark"
      }, null, 512),
      u("div", {
        ref_key: "loader",
        ref: r,
        class: "ob-intro-loader"
      }, [
        C(HA)
      ], 512),
      u("div", {
        ref_key: "stage",
        ref: a,
        class: "ob-intro-stage",
        "aria-hidden": "true"
      }, [
        u("div", {
          ref_key: "win",
          ref: l,
          class: "ob-intro-win"
        }, [
          C(mP, {
            ref_key: "hero",
            ref: S,
            paused: !0,
            opening: ""
          }, null, 512)
        ], 512),
        u("span", {
          ref_key: "fade",
          ref: d,
          class: "ob-welcome-fade"
        }, null, 512),
        u("div", {
          ref_key: "scrim",
          ref: c,
          class: "ob-intro-scrim"
        }, null, 512)
      ], 512),
      u("div", uRe, [
        u("div", {
          ref_key: "mark",
          ref: f,
          class: "ob-intro-mark"
        }, [
          u("div", {
            ref_key: "glow",
            ref: h,
            class: "ob-intro-glow"
          }, null, 512),
          u("div", {
            ref_key: "markIn",
            ref: p,
            class: "ob-intro-mark-in",
            style: ce({ "--mask": m(jA) })
          }, [
            (g(!0), b(j, null, ge(m(ma), (te, we) => (g(), b("svg", {
              key: we,
              ref_for: !0,
              ref: (Fe) => {
                Fe && (M[we] = Fe);
              },
              class: "ob-intro-facet",
              viewBox: m(Ql),
              style: ce({ transformOrigin: te.origin }),
              focusable: "false"
            }, [
              u("path", {
                d: te.d,
                fill: te.fill
              }, null, 8, pRe)
            ], 12, hRe))), 128)),
            u("div", {
              ref_key: "sheen",
              ref: y,
              class: "ob-intro-sheen"
            }, null, 512)
          ], 4)
        ], 512),
        u("div", {
          ref_key: "title",
          ref: v,
          class: "ob-intro-title"
        }, [
          (g(!0), b(j, null, ge(m(i), (te, we) => (g(), b("span", {
            key: we,
            ref_for: !0,
            ref: (Fe) => {
              Fe && (_[we] = Fe);
            },
            class: "ob-intro-word"
          }, E(te + (we < m(i).length - 1 ? " " : "")), 1))), 128))
        ], 512),
        u("div", {
          ref_key: "row",
          ref: x,
          class: "ob-intro-row"
        }, [
          (g(!0), b(j, null, ge(m(s1), (te, we) => (g(), b("span", {
            key: te.key,
            ref_for: !0,
            ref: (Fe) => {
              Fe && (T[we] = Fe);
            },
            class: "ob-intro-aspect"
          }, [
            we > 0 ? (g(), b("i", fRe)) : z("", !0),
            Y(E(te.label), 1)
          ]))), 128))
        ], 512)
      ]),
      u("button", {
        ref_key: "skipBtn",
        ref: w,
        class: "ob-intro-skip",
        "data-testid": "tour-intro-skip",
        onClick: Z[0] || (Z[0] = (te) => m(t).skipIntro())
      }, [...Z[3] || (Z[3] = [
        Y(" Skip intro", -1),
        u("kbd", { class: "ob-key" }, "Esc", -1)
      ])], 512)
    ], 544));
  }
}), nv = ["#9968df", "#c750ce", "#a3a7f5", "#5a61ed", "#d6c2f2", "#ffd27a"], gRe = 1500, bRe = 2.4, vRe = 420;
function iv(n, e = Math.random) {
  const t = n.count == null ? 120 : n.count, i = n.angle == null ? -Math.PI / 2 : n.angle, s = n.spread == null ? Math.PI / 2.2 : n.spread, o = n.power == null ? 1250 : n.power, r = [];
  for (let a = 0; a < t; a++) {
    const l = i + (e() - 0.5) * s, d = o * (0.45 + e() * 0.55);
    r.push({
      x: n.x,
      y: n.y,
      vx: Math.cos(l) * d,
      vy: Math.sin(l) * d,
      rot: e() * Math.PI * 2,
      vr: (e() - 0.5) * 14,
      flip: e() * Math.PI * 2,
      vf: 6 + e() * 10,
      w: 6 + e() * 6,
      h: 3 + e() * 4,
      color: nv[Math.floor(e() * nv.length) % nv.length],
      life: 1,
      span: 1.9 + e() * 0.8
    });
  }
  return r;
}
function yRe(n, e) {
  const t = Math.max(0, 1 - bRe * e), i = [];
  for (const s of n)
    s.vx *= t, s.vy = Math.min(vRe, (s.vy + gRe * e) * t), s.x += s.vx * e, s.y += s.vy * e, s.rot += s.vr * e, s.flip += s.vf * e, s.life -= e / s.span, s.life > 0 && i.push(s);
  return i;
}
function xRe(n) {
  return Math.max(0, Math.min(1, n.life * 3));
}
const wRe = ["data-bursts"], kRe = /* @__PURE__ */ Pe({
  __name: "TourConfetti",
  props: {
    tour: {},
    reduced: { type: Boolean },
    origin: {}
  },
  setup(n) {
    const e = n, t = /* @__PURE__ */ new Set(["run", "chat-run"]), i = /* @__PURE__ */ W(null), s = /* @__PURE__ */ W(0);
    let o = [], r = 0, a = 0;
    function l(c) {
      const h = i.value;
      if (!h) {
        r = 0;
        return;
      }
      const f = Math.min(0.05, a ? (c - a) / 1e3 : 0.016);
      a = c, o = yRe(o, f);
      const p = window.devicePixelRatio || 1, y = window.innerWidth, v = window.innerHeight;
      (h.width !== Math.round(y * p) || h.height !== Math.round(v * p)) && (h.width = Math.round(y * p), h.height = Math.round(v * p));
      const x = h.getContext("2d");
      if (!x) {
        r = 0;
        return;
      }
      x.setTransform(p, 0, 0, p, 0, 0), x.clearRect(0, 0, y, v);
      for (const w of o)
        x.save(), x.globalAlpha = xRe(w), x.translate(w.x, w.y), x.rotate(w.rot), x.scale(Math.cos(w.flip), 1), x.fillStyle = w.color, x.fillRect(-w.w / 2, -w.h / 2, w.w, w.h), x.restore();
      o.length ? r = requestAnimationFrame(l) : (r = 0, a = 0, x.clearRect(0, 0, y, v));
    }
    function d(c) {
      s.value++, !e.reduced && (o = o.concat(c), r || (r = requestAnimationFrame(l)));
    }
    return Ee(
      () => [e.tour.step.value.id, e.tour.phase.value],
      ([c, h], f) => {
        const [p, y] = f || ["", ""];
        if (h === "success" && y !== "success" && t.has(c)) {
          const v = e.origin || { x: window.innerWidth / 2, y: window.innerHeight * 0.55 };
          d(iv({ x: v.x, y: v.y, count: 110, power: 1100 }));
        } else if (c === "finale" && p !== "finale") {
          const v = window.innerHeight, x = window.innerWidth;
          d([
            ...iv({ x: x * 0.04, y: v * 0.96, angle: -Math.PI / 2 + 0.5, spread: Math.PI / 4, power: 1500, count: 90 }),
            ...iv({ x: x * 0.96, y: v * 0.96, angle: -Math.PI / 2 - 0.5, spread: Math.PI / 4, power: 1500, count: 90 })
          ]);
        }
      }
    ), We(() => {
      r && cancelAnimationFrame(r);
    }), (c, h) => (g(), b("canvas", {
      ref_key: "canvas",
      ref: i,
      class: "ob-confetti",
      "aria-hidden": "true",
      "data-testid": "tour-confetti",
      "data-bursts": s.value
    }, null, 8, wRe));
  }
}), _Re = ["data-step", "data-phase"], SRe = ["width", "height", "viewBox"], MRe = ["width", "height"], TRe = ["width", "height"], CRe = ["x", "y", "width", "height", "rx", "fill-opacity"], IRe = ["width", "height"], ARe = ["width", "height"], PRe = ["d"], ERe = ["cx", "cy"], RRe = /* @__PURE__ */ Pe({
  __name: "TourLayer",
  props: {
    tour: {},
    busy: { type: Boolean },
    error: {}
  },
  setup(n) {
    const t = n.tour, i = Cx(), { holes: s, exact: o } = fAe(t.targets, t.board, i), r = /* @__PURE__ */ W({ w: window.innerWidth, h: window.innerHeight }), a = () => {
      r.value = { w: window.innerWidth, h: window.innerHeight };
    };
    it(() => window.addEventListener("resize", a)), We(() => window.removeEventListener("resize", a));
    const l = I(() => t.step.value), d = I(() => l.value.id), c = I(() => d.value === "welcome" || d.value === "finale"), h = I(() => d.value === "welcome" ? 0.5 : d.value === "finale" ? 0.46 : d.value === "organize" ? 0.18 : 0.32), f = /* @__PURE__ */ W({ w: 380, h: 420 }), p = I(() => t.cardPlace.value), y = I(() => {
      const A = p.value.anchor;
      if (A) return o.value.find((D) => D.key === A) || null;
      const R = t.targets.value.filter((D) => !D.look).map((D) => D.key);
      return c3(o.value.filter((D) => R.includes(D.key)));
    }), v = I(() => p.value.place === "center" ? [] : o.value.map((A) => ({ x: A.x, y: A.y, w: A.w, h: A.h }))), x = I(() => vAe(p.value.place, p.value.place === "center" ? null : y.value, f.value, r.value, v.value)), w = I(() => p.value.place === "center" || p.value.place === "bottom-center"), S = I(() => p.value.place === "bottom-center" || r.value.h < 820 && p.value.place !== "top-right" && p.value.place !== "center"), M = I(() => t.phase.value === "success"), _ = I(() => {
      const A = c3(o.value);
      return A ? { x: A.x + A.w / 2, y: A.y + A.h / 2 } : null;
    }), T = /* @__PURE__ */ W(0);
    Ee(() => t.nudges.value, () => {
      T.value++;
    });
    const k = I(() => {
      if (d.value !== "drag" || t.phase.value === "success") return null;
      const A = o.value.find((ee) => ee.key === "pick"), R = o.value.find((ee) => ee.key === "slot");
      if (!A || !R) return null;
      const D = { x: A.x + A.w / 2, y: A.y + A.h / 2 }, O = { x: R.x + R.w * 0.62, y: R.y + R.h * 0.42 }, F = Math.min(160, Math.abs(D.x - O.x) * 0.35 + 40), ie = { x: (D.x + O.x) / 2, y: Math.min(D.y, O.y) - F };
      return { d: "M" + D.x + " " + D.y + " Q " + ie.x + " " + ie.y + " " + O.x + " " + O.y, to: O };
    }), P = (A) => ({
      left: A.x + "px",
      top: A.y + "px",
      width: A.w + "px",
      height: A.h + "px",
      borderRadius: A.r + "px"
    });
    return (A, R) => (g(), b("div", {
      class: G(["bd-root ob-layer", { "is-own": c.value, "is-reduced": m(i) }]),
      "data-testid": "tour",
      "data-step": d.value,
      "data-phase": m(t).phase.value
    }, [
      (g(), b("svg", {
        class: "ob-dim",
        width: r.value.w,
        height: r.value.h,
        viewBox: "0 0 " + r.value.w + " " + r.value.h,
        "aria-hidden": "true"
      }, [
        u("defs", null, [
          u("mask", {
            id: "ob-holes",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: r.value.w,
            height: r.value.h
          }, [
            u("rect", {
              x: "0",
              y: "0",
              width: r.value.w,
              height: r.value.h,
              fill: "#fff"
            }, null, 8, TRe),
            (g(!0), b(j, null, ge(m(s), (D) => (g(), b("rect", {
              key: D.key,
              x: D.x,
              y: D.y,
              width: Math.max(0, D.w),
              height: Math.max(0, D.h),
              rx: Math.max(0, D.r),
              fill: "#000",
              "fill-opacity": D.look && !D.ring ? 0.55 : 1
            }, null, 8, CRe))), 128))
          ], 8, MRe)
        ]),
        u("rect", {
          class: "ob-dim-fill",
          x: "0",
          y: "0",
          width: r.value.w,
          height: r.value.h,
          mask: "url(#ob-holes)",
          style: ce({ opacity: h.value })
        }, null, 12, IRe)
      ], 8, SRe)),
      (g(!0), b(j, null, ge(m(s), (D) => (g(), b(j, {
        key: "ring:" + D.key
      }, [
        D.drop ? (g(), b("div", {
          key: 0,
          class: G(["ob-slot", { "is-done": M.value }]),
          style: ce({ ...P(D), opacity: D.open }),
          "data-testid": "tour-drop"
        }, [
          u("span", null, E(D.drop), 1)
        ], 6)) : !D.look || D.ring ? (g(), b("div", {
          key: "r" + T.value,
          class: G(["ob-ring", { "is-done": M.value, "is-nudged": T.value > 0 }]),
          style: ce({ ...P(D), opacity: D.open }),
          "data-testid": "tour-ring"
        }, null, 6)) : z("", !0)
      ], 64))), 128)),
      k.value ? (g(), b("svg", {
        key: 0,
        class: "ob-arc",
        width: r.value.w,
        height: r.value.h,
        "aria-hidden": "true"
      }, [
        u("path", {
          d: k.value.d
        }, null, 8, PRe),
        u("circle", {
          cx: k.value.to.x,
          cy: k.value.to.y,
          r: "4"
        }, null, 8, ERe)
      ], 8, ARe)) : z("", !0),
      C(aPe, { tour: m(t) }, null, 8, ["tour"]),
      C(vt, { name: "ob-own" }, {
        default: Xe(() => [
          d.value === "welcome" ? (g(), Ie(N9e, {
            key: 0,
            tour: m(t)
          }, null, 8, ["tour"])) : d.value === "finale" ? (g(), Ie(Q9e, {
            key: 1,
            tour: m(t),
            busy: n.busy,
            error: n.error
          }, null, 8, ["tour", "busy", "error"])) : z("", !0)
        ]),
        _: 1
      }),
      C(vt, { name: "ob-card" }, {
        default: Xe(() => [
          c.value ? z("", !0) : (g(), Ie(NEe, {
            key: 0,
            tour: m(t),
            x: x.value.x,
            y: x.value.y,
            wide: w.value,
            short: S.value,
            onSize: R[0] || (R[0] = (D) => f.value = D)
          }, null, 8, ["tour", "x", "y", "wide", "short"]))
        ]),
        _: 1
      }),
      C(kRe, {
        tour: m(t),
        reduced: m(i),
        origin: _.value
      }, null, 8, ["tour", "reduced", "origin"]),
      C(vt, { name: "ob-intro" }, {
        default: Xe(() => [
          m(t).intro.value ? (g(), Ie(mRe, {
            key: 0,
            tour: m(t)
          }, null, 8, ["tour"])) : z("", !0)
        ]),
        _: 1
      })
    ], 10, _Re));
  }
}), zRe = /* @__PURE__ */ Pe({
  __name: "OnboardingApp",
  props: {
    env: {},
    tour: {},
    busy: {},
    error: {}
  },
  setup(n) {
    return (e, t) => (g(), b(j, null, [
      C(KA, { env: n.env }, null, 8, ["env"]),
      C(RRe, {
        tour: n.tour,
        busy: n.busy.value,
        error: n.error.value
      }, null, 8, ["tour", "busy", "error"])
    ], 64));
  }
}), Cl = { w: 316, h: 176 }, aa = 28, Ix = 96, gP = (n) => "tour-" + n;
function $Re(n) {
  const e = Iu.find((t) => gP(t.id) === n);
  return e ? e.id : null;
}
const Hn = {
  id: "tour-site",
  type: "frame",
  title: "Site photos",
  z: 0,
  x: 0,
  y: 0,
  w: aa + Iu.length * (Cl.w + aa),
  h: Ix + Cl.h + 40
}, Go = {
  id: "tour-brief",
  type: "note",
  tint: "amber",
  text: IAe,
  author: AAe,
  z: 1,
  x: Hn.x + Hn.w + 48,
  y: 64,
  w: 236,
  h: 196
}, sv = {
  x: Go.x + Go.w + 64 + Rt.w / 2,
  y: Go.y + Go.h / 2
}, Wf = "tour-tower";
function DRe(n, e) {
  const t = Cl.h, i = Math.round(t * e), s = Hn.x - (i + aa);
  return {
    frame: { x: s, w: Hn.w + i + aa },
    tower: { id: Wf, type: "image", src: n, label: "Tower render", z: 5, x: s + aa, y: Hn.y + Ix, w: i, h: t }
  };
}
function ORe() {
  const n = Iu.map((e, t) => ({
    id: gP(e.id),
    type: "image",
    src: e.src,
    label: e.label,
    z: 2 + t,
    x: Hn.x + aa + t * (Cl.w + aa),
    y: Hn.y + Ix,
    w: Cl.w,
    h: Cl.h
  }));
  return { title: dP, elements: [Hn, Go, ...n], results: [] };
}
var LRe = Object.defineProperty, BRe = (n, e, t) => e in n ? LRe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, np = (n, e, t) => BRe(n, typeof e != "symbol" ? e + "" : e, t);
const FRe = (n) => new Promise((e) => window.setTimeout(e, n)), NRe = "There are no photos in this frame for me to work with. Move this chat back into the Site photos frame, and ask again.";
function URe(n) {
  const e = n.catalog.search(cP)[0], t = n.context.images.filter((r) => !r.video && !r.kind), i = t.find((r) => r.id === Wf) || null, s = t.filter((r) => r.id !== Wf);
  if (!e || !s.length) return null;
  const o = e.model.fields.find((r) => r.kind === "size" && (r.options || []).some((a) => a.value === Wa.size));
  return {
    title: Wa.title,
    place: !0,
    sessions: [{
      name: Wa.session,
      modelId: e.id,
      job: "generate",
      prompt: Wa.prompt,
      n: 1,
      runs: s.map((r) => ({ imageIds: i ? [r.id, i.id] : [r.id] })),
      ...o ? { settings: { [o.label]: Wa.size } } : {},
      why: Wa.why
    }]
  };
}
class GRe {
  constructor(e = {}) {
    np(this, "id", "tour"), np(this, "label", "Assistant"), np(this, "pace"), np(this, "sleep"), this.pace = e.pace == null ? 1 : e.pace, this.sleep = e.sleep || FRe;
  }
  wait(e) {
    return this.pace > 0 ? this.sleep(e * this.pace) : Promise.resolve();
  }
  async *say(e, t) {
    for (const i of z8(e)) {
      if (t.aborted) return;
      yield { type: "text", delta: i }, await this.wait(26);
    }
  }
  // Its status lines hold long enough to read (IL-100): a first-timer is
  // reading the card beside the chat as well, and at a model's own pace
  // (1.1 s, 0.5 s) they went by unread.
  async *turn(e, t) {
    if (e.input.kind === "plan-ended") {
      yield { type: "status", text: "Looking at what it made…" }, await this.wait(1500), yield* this.say(zAe, t);
      return;
    }
    if (yield { type: "status", text: "Reading the frame…" }, await this.wait(2e3), t.aborted) return;
    const i = URe(e);
    if (!i) {
      yield* this.say(NRe, t);
      return;
    }
    yield* this.say(RAe, t), !t.aborted && (yield { type: "status", text: "Pricing the plan…" }, await this.wait(1300), !t.aborted && (yield { type: "plan", plan: i }));
  }
}
var jRe = Object.defineProperty, HRe = (n, e, t) => e in n ? jRe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, It = (n, e, t) => HRe(n, typeof e != "symbol" ? e + "" : e, t);
const bP = { enter: 520, success: 780, fly: 900, intro: mu * 1e3, chatRun: 2400 };
function VRe(n, e) {
  const t = (n.title + " " + n.body).split(/\s+/).filter(Boolean).length, i = Math.min(4600, t * 230) * (e / bP.success);
  return Math.round(Math.max(e * 1.8, i));
}
const WRe = /* @__PURE__ */ new Set(["contextmenu", "dblclick", "auxclick"]), qRe = /* @__PURE__ */ new Set(["Shift", "Meta", "Control", "Alt", "CapsLock", "Fn", "OS", "Hyper", "Super"]), Qn = (n) => () => document.querySelector(n), S3 = '[data-testid="studio-stage"] .sv-pic', KRe = {
  session: '.up-card [data-testid="prompt-text"]',
  edit: '[data-testid="studio-edit-prompt"]',
  chat: '[data-testid="chat-input"]'
};
class YRe {
  constructor(e) {
    It(this, "reason"), It(this, "canSkip"), It(this, "boardRef"), It(this, "step", /* @__PURE__ */ qe(Wi[0])), It(this, "index", /* @__PURE__ */ qe(0)), It(this, "phase", /* @__PURE__ */ qe("enter")), It(this, "nudges", /* @__PURE__ */ qe(0)), It(this, "nudgeHint", /* @__PURE__ */ qe("")), It(this, "toolId", /* @__PURE__ */ qe(null)), It(this, "placedId", /* @__PURE__ */ qe(null)), It(this, "chatId", /* @__PURE__ */ qe(null)), It(this, "asked", /* @__PURE__ */ qe(!1)), It(this, "typingField", /* @__PURE__ */ qe(null)), It(this, "board", /* @__PURE__ */ qe(null)), It(this, "intro", /* @__PURE__ */ qe(null)), It(this, "hooks"), It(this, "opts"), It(this, "timing"), It(this, "tabs", /* @__PURE__ */ Xt({ session: 0, edit: 0, chat: 0 })), It(this, "timers", []), It(this, "stops", []), It(this, "stepStops", []), It(this, "started", !1), It(this, "disposed", !1), It(this, "listening", !1), It(this, "rt", {}), It(this, "snaps", /* @__PURE__ */ new Map()), It(this, "boardTick", /* @__PURE__ */ qe(0)), It(this, "waiting", I(() => (this.step.value, this.boardTick.value, this.phase.value === "task" && !!this.rt.waiting && this.rt.waiting()))), It(this, "targets", I(() => (this.step.value, this.board.value, this.toolId.value, this.placedId.value, this.phase.value, this.waiting.value, this.rt.targets ? this.rt.targets() : []))), It(this, "cardPlace", I(() => (this.step.value, this.phase.value, this.waiting.value, this.rt.card ? this.rt.card() : { place: this.step.value.place }))), It(this, "onKey", (i) => {
      if (qRe.has(i.key) || XRe(i) || !this.inScope(i.target)) return;
      if (this.intro.value) {
        i.preventDefault(), i.stopImmediatePropagation(), !i.repeat && (i.key === "Escape" || i.key === "Enter" || i.key === " ") && this.skipIntro();
        return;
      }
      const s = i.target, o = !!(s && s.closest && s.closest("[data-tour-ui]")), r = this.step.value;
      if (o && (i.key === "Enter" || i.key === " " || i.key === "Tab" && r.kind !== "tab")) return;
      const a = this.phase.value === "task" && this.rt.key ? this.rt.key(i) : void 0;
      if (a !== "pass" && (i.preventDefault(), i.stopImmediatePropagation(), !(a === "handled" || i.repeat))) {
        if (this.phase.value === "task" && r.kind === "continue" && i.key === "Enter") {
          this.next();
          return;
        }
        this.phase.value === "task" && this.nudge(C3(r));
      }
    }), It(this, "onPointer", (i) => {
      const s = i.target;
      this.inScope(s) && (s && s.closest && s.closest("[data-tour-ui]") || i.type !== "wheel" && !WRe.has(i.type) && this.phase.value === "task" && this.rt.hands && this.inTargets(s, i) || (i.cancelable && i.preventDefault(), i.stopImmediatePropagation(), i.type === "pointerdown" && this.phase.value === "task" && this.step.value.kind !== "continue" && this.nudge(C3(this.step.value))));
    }), this.opts = e, this.reason = e.reason, this.canSkip = e.canSkip, this.boardRef = e.board, this.timing = { ...bP, ...e.reducedMotion ? { fly: 0, enter: 200, intro: 0 } : {}, ...e.timing || {} }, this.intro.value = this.timing.intro > 0 ? "waiting" : null;
    const t = this;
    this.hooks = {
      chat: e.chat || new GRe(),
      lineFor(i, s) {
        const o = t.step.value.id;
        return i === "chat" ? s === t.chatId.value && o === "chat-tab" ? EAe : null : s !== t.toolId.value ? null : i === "session" ? o === "tab-prompt" ? p3 : null : o === "edit-tab" ? f3 : null;
      },
      holds(i, s) {
        return i === "chat" ? s === t.chatId.value && t.index.value >= T3("chat-tab") : s !== t.toolId.value ? !1 : t.index.value >= T3(i === "session" ? "tab-prompt" : "edit-tab");
      },
      tabbed(i) {
        return t.tabs[i];
      },
      typing(i, s) {
        t.typingField.value = s ? i : null, i === "chat" && !s && (t.asked.value = !0);
      },
      landing() {
        return t.step.value.id === "add-session" ? { ...sv } : null;
      },
      press(i) {
        const s = t.step.value.id;
        t.phase.value !== "task" || t.typingField.value === i || (i === "session" && s === "tab-prompt" || i === "edit" && s === "edit-tab" || i === "chat" && s === "chat-tab") && t.tabs[i]++;
      }
    };
  }
  /** the tour began: its practice board opened and is drawing */
  get isStarted() {
    return this.started;
  }
  // ---------------------------------------------------------------- the board
  /** The practice board's controller, as it opens (and again, if the tour starts over on a new one). */
  attach(e) {
    for (const t of this.stops) t();
    this.stops = [], this.board.value = e, e && (e.tour = this.hooks, this.stops.push(Ee(() => e.results.rev.value, () => {
      this.boardTick.value++;
    })), this.stops.push(Ee(() => e.loaded.value, (t) => {
      if (!t || this.started) return;
      const i = () => {
        if (!(this.disposed || this.started || this.board.value !== e)) {
          if (!e.engine) {
            requestAnimationFrame(i);
            return;
          }
          this.started = !0, this.listen(), this.opts.onProgress && this.opts.onProgress({ status: "started", step: Wi[0].id }), this.go(0);
        }
      };
      i();
    }, { immediate: !0 })));
  }
  /** Back to the welcome, on a fresh board (the finale's Take the tour again). */
  reset() {
    this.clearStep(), this.snaps.clear(), this.started = !1, this.toolId.value = null, this.placedId.value = null, this.chatId.value = null, this.asked.value = !1, this.typingField.value = null, this.tabs.session = 0, this.tabs.edit = 0, this.tabs.chat = 0, this.index.value = 0, this.step.value = Wi[0], this.phase.value = "enter";
  }
  dispose() {
    this.disposed = !0, this.clearStep();
    for (const t of this.stops) t();
    this.stops = [], this.unlisten();
    const e = this.board.value;
    e && e.tour === this.hooks && (e.tour = null);
  }
  // ---------------------------------------------------------------- playing
  go(e) {
    if (this.disposed) return;
    this.clearStep();
    const t = Wi[Math.max(0, Math.min(Wi.length - 1, e))];
    if (this.capture(Wi.indexOf(t)), this.index.value = Wi.indexOf(t), this.step.value = t, this.nudgeHint.value = "", this.rt = this.runtime(t.id), this.phase.value = "enter", this.rt.enter && this.rt.enter(), t.id === "finale" && this.opts.onProgress && this.opts.onProgress({ status: "completed", step: t.id }), t.id === "welcome" && this.intro.value === "waiting") {
      this.intro.value = "playing", this.later(() => this.introDone(), this.timing.intro + 4e3);
      return;
    }
    t.id !== "welcome" && (this.intro.value = null), this.later(() => this.arrive(), this.timing.enter);
  }
  /** The step has arrived: it takes input, and watches the board for being done. */
  arrive() {
    const e = this.step.value;
    this.phase.value = e.id === "finale" ? "finished" : "task";
    const t = this.rt;
    t.done && this.stepStops.push(Ee(() => (this.boardTick.value, t.done()), (i) => {
      i && this.phase.value === "task" && this.succeed();
    }, { immediate: !0 })), t.watchStray && t.watchStray();
  }
  /** The opening has played (or was skipped): the welcome takes over. */
  introDone() {
    this.intro.value === "playing" && (this.intro.value = null, this.step.value.id === "welcome" && this.phase.value === "enter" && this.arrive());
  }
  /** Skip intro (its button, Esc, Enter or Space) while it plays. */
  skipIntro() {
    this.introDone();
  }
  /** The step is done: a beat, then the next (long enough to read, when a run has landed and says so). */
  succeed() {
    if (this.phase.value !== "task") return;
    this.rt.onDone && this.rt.onDone(), this.phase.value = "success";
    const e = this.index.value, t = this.step.value.landed;
    this.later(() => {
      this.index.value === e && this.go(e + 1);
    }, t ? VRe(t, this.timing.success) : this.timing.success);
  }
  /** The harness and tests: straight to a step (its board readied as the step readies it). */
  goTo(e) {
    const t = Wi.findIndex((i) => i.id === e);
    t >= 0 && this.go(t);
  }
  /** Continue (the button, or Enter), on a step that only says something. */
  next() {
    this.phase.value !== "task" || this.step.value.kind !== "continue" || this.go(this.index.value + 1);
  }
  /**
   * Back, to the step before (TD-03): from any step but the first, once it's
   * taking input and nothing's on its way. What the steps since put on the
   * practice board (a session, a run's pictures, a placed picture, a chat and
   * its plan, typed words) goes, so the step before can be done again.
   */
  get canBack() {
    const e = this.index.value;
    return e > 0 && this.step.value.id !== "finale" && this.phase.value === "task" && !this.waiting.value && !this.typingField.value && this.snaps.has(e - 1);
  }
  back() {
    if (!this.canBack) return;
    const e = this.index.value - 1, t = this.snaps.get(e), i = this.board.value;
    this.clearStep(), i && i.tourRestore(t.board), this.toolId.value = t.toolId, this.placedId.value = t.placedId, this.chatId.value = t.chatId, this.asked.value = t.asked, this.tabs.session = t.tabs.session, this.tabs.edit = t.tabs.edit, this.tabs.chat = t.tabs.chat;
    const s = this.studio();
    if (s && t.studio) {
      s.s.studio !== t.studio.side && s.setStudio(t.studio.side), s.s.asks = { ...t.studio.asks };
      const o = t.studio.stageId;
      o && s.s.stageId !== o && s.show(o);
    }
    this.go(e);
  }
  /** The practice board and the tour's notes as step `i` begins, for a Back to it. */
  capture(e) {
    const t = this.board.value;
    if (!t) return;
    const i = this.studio();
    this.snaps.set(e, {
      board: t.tourSnapshot(),
      toolId: this.toolId.value,
      placedId: this.placedId.value,
      chatId: this.chatId.value,
      asked: this.asked.value,
      tabs: { ...this.tabs },
      studio: i ? { side: i.s.studio, asks: { ...i.s.asks }, stageId: i.s.stageId } : null
    });
    for (const s of Array.from(this.snaps.keys())) s > e && this.snaps.delete(s);
  }
  /** Skip (or Exit): only where it's offered. */
  skip() {
    !this.canSkip || this.disposed || (this.opts.onProgress && this.opts.onProgress({ status: "skipped", step: this.step.value.id }), this.opts.onExit("skip"));
  }
  /** The finale's way out. */
  finish(e) {
    this.phase.value === "finished" && this.opts.onExit(e);
  }
  /** The finale's Take the tour again. */
  again() {
    this.phase.value === "finished" && this.opts.restart && this.opts.restart();
  }
  clearStep() {
    for (const e of this.timers) clearTimeout(e);
    this.timers = [];
    for (const e of this.stepStops) e();
    this.stepStops = [], this.rt = {};
  }
  later(e, t) {
    this.timers.push(window.setTimeout(e, t));
  }
  nudge(e = "") {
    this.nudgeHint.value = e, this.nudges.value++;
  }
  // ---------------------------------------------------------------- the steps
  tool() {
    const e = this.board.value, t = this.toolId.value, i = e && t ? e.store.get(t) : null;
    return i && i.type === "tool" ? i : null;
  }
  studio() {
    const e = this.board.value, t = this.toolId.value;
    return e && t ? N0(e, t) : null;
  }
  results() {
    const e = this.board.value, t = this.toolId.value;
    return !e || !t ? [] : (this.boardTick.value, e.results.list(t));
  }
  runtime(e) {
    const t = this.board.value;
    switch (e) {
      case "welcome":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo(Np([Hn, Go]), { zoom: 0.62, ax: 0.5, ay: 0.46 });
          }
        };
      case "look":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo(Np([Hn, Go]), { fit: 0.84, maxZoom: 0.95, ax: 0.5, ay: 0.4 });
          },
          targets: () => [
            { key: "site", world: () => this.rectOf(Hn.id), pad: 10, padTop: 40, radius: 18 },
            { key: "brief", world: () => this.rectOf(Go.id), pad: 10, radius: 18 }
          ]
        };
      case "add-session":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo({ x: sv.x - 1, y: sv.y - 1, w: 2, h: 2 }, { zoom: 0.8, ax: 0.68, ay: 0.28 });
          },
          // the dock's +, then (its menu up) the menu's Image: a session starts from a choice of kit (CHAT-20)
          targets: () => t.ui.addMenu ? [{ key: "add-image", el: Qn('[data-testid="add-kit-image"]'), pad: 4, radius: 12 }] : [{ key: "add", el: Qn('[data-testid="all-tools"]'), pad: 6, radius: 14 }],
          hands: !0,
          done: () => !!this.addedTool(),
          onDone: () => {
            const i = this.addedTool();
            i && this.adopt(i);
          }
        };
      case "open-session":
        return {
          enter: () => {
            const i = this.tool();
            i && this.flyTo(He(i), { zoom: 1.12, ax: 0.3, ay: 0.34 });
          },
          targets: () => [{ key: "session", el: () => this.sessionCard(), pad: 8, radius: 22 }],
          hands: !0,
          done: () => !!t.promptTool.value && t.promptTool.value.id === this.toolId.value
        };
      case "tab-prompt":
        return {
          enter: () => {
            this.keepOpen(), this.focusField("session");
          },
          targets: () => [{ key: "prompt", box: () => ip('.up-card [data-testid="prompt-text"]', '.up-card [data-testid="ghost-cue"]'), pad: 12, radius: 14 }],
          hands: !0,
          done: () => {
            t.promptRev.value;
            const i = this.toolId.value;
            return !!i && t.promptOf(i).prompt === p3 && this.typingField.value !== "session";
          },
          key: (i) => this.tabKey(i, "session")
        };
      case "run":
        return {
          enter: () => {
            this.keepOpen(), this.opts.gen.planned || this.opts.gen.plan(Hf);
          },
          // once it runs, the light moves to where the images land, and stays there as they
          // land (the success beat), so nothing jumps back to Run before the next step
          targets: () => this.results().length > 0 ? [
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22, look: !0, ring: !0 },
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16, look: !0 }
          ] : [{ key: "run", el: Qn('[data-testid="run"]'), pad: 6, radius: 14 }],
          hands: !0,
          waiting: () => this.results().some((i) => i.status === "pending"),
          done: () => this.results().filter((i) => i.status === "done").length >= m3,
          key: (i) => this.runKey(i, '[data-testid="run"]'),
          card: () => this.results().length > 0 ? { place: "right", anchor: "session" } : { place: "above" }
        };
      case "results":
        return {
          enter: () => {
            this.keepOpen(), t.ui.histOpen = !0;
          },
          targets: () => [
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22 },
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16 }
          ],
          card: () => ({ place: "right", anchor: "session" })
        };
      case "drag":
        return {
          enter: () => {
            this.keepOpen(), t.ui.histOpen = !0;
          },
          targets: () => [
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16 },
            { key: "pick", el: Qn('[data-testid="results-gallery"] .shot'), pad: 0, radius: 10, look: !0 },
            { key: "slot", world: () => this.dropSlot(), pad: 0, radius: 16, drop: "Drop it here", look: !0 },
            // the session the picture came from, beside where it goes; its pictures drag out
            // as the gallery's do (CHAT-03: lit, and saying so as you hovered, but they stuck)
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22, look: !0, takes: ".cv-thumb-pull" }
          ],
          card: () => ({ place: "below", anchor: "slot" }),
          hands: !0,
          // dropped, not just carried over the board (the board makes the picture as the drag
          // crosses the canvas, and takes it back if it's carried off again)
          done: () => !!this.placedImage() && !t.ui.dragging,
          onDone: () => {
            const i = this.placedImage();
            i && (this.placedId.value = i.id);
          },
          watchStray: () => {
            this.stepStops.push(Ee(() => t.ui.infoAt, (i) => {
              i && (t.ui.infoAt = null, this.nudge("Hold the picture, then drag it onto the board"));
            }));
          }
        };
      case "studio-open":
        return {
          enter: () => {
            this.keepOpen();
          },
          targets: () => [{ key: "studio", el: Qn(".up-studio-wrap"), pad: 6, radius: 999 }],
          hands: !0,
          done: () => !!t.ui.studio && t.ui.studio.sessionId === this.toolId.value
        };
      case "edit-side":
        return {
          enter: () => {
            const i = this.studio(), s = this.placedResultId();
            i && s && this.later(() => i.show(s), 60);
          },
          targets: () => [{ key: "edit", el: Qn('[data-testid="studio-side-edit"]'), pad: 5, radius: 12 }],
          hands: !0,
          done: () => {
            const i = this.studio();
            return !!i && i.side.value === "edit";
          }
        };
      case "edit-tab":
        return {
          enter: () => this.focusField("edit"),
          targets: () => [{ key: "words", box: () => ip('[data-testid="studio-edit-prompt"]', '[data-testid="studio-ghost-cue"]'), pad: 10, radius: 14 }],
          hands: !0,
          done: () => {
            const i = this.studio();
            return !!i && i.askOf(i.s.stageId) === f3 && this.typingField.value !== "edit";
          },
          key: (i) => this.tabKey(i, "edit")
        };
      case "edit-run":
        return {
          enter: () => {
            this.opts.gen.planned || this.opts.gen.plan([nc]);
          },
          // once it runs, the light moves to the picture, where the new version arrives, and
          // stays there as it lands
          targets: () => this.results().some((i) => i.status === "pending" || i.url === nc.src) ? [{ key: "stage", el: Qn(S3), pad: 10, padTop: 32, radius: 16, look: !0, ring: !0 }] : [{ key: "run", el: Qn('[data-testid="studio-edit-generate"]'), pad: 6, radius: 14 }],
          hands: !0,
          waiting: () => this.results().some((i) => i.status === "pending"),
          done: () => this.results().some((i) => i.status === "done" && i.url === nc.src),
          key: (i) => this.runKey(i, '[data-testid="studio-edit-generate"]')
        };
      case "edit-result":
        return {
          enter: () => {
            const i = this.studio(), s = this.results().find((o) => o.status === "done" && o.url === nc.src);
            i && s && i.s.stageId !== s.id && i.show(s.id);
          },
          targets: () => [
            // the picture (and its tag), not the whole stage round it, as while the edit ran: the card keeps its
            // corner from the run, with no flight across the window
            { key: "stage", el: Qn(S3), pad: 10, padTop: 32, radius: 16 },
            // the versions themselves, not their whole bar
            { key: "versions", box: () => o1(Array.from(document.querySelectorAll('[data-testid="studio-version"]'))), pad: 6, radius: 14 }
          ]
        };
      case "chat-open":
        return {
          enter: () => {
            this.closeStudio(), t.ui.histOpen = !1, this.addTower(), t.select([Hn.id]), this.flyTo(this.rectOf(Hn.id), { fitW: 0.42, fitH: 0.5, maxZoom: 0.58, ax: 0.28, ay: 0.42 });
          },
          targets: () => [
            { key: "chat", el: Qn('[data-testid="ctx-chat"]'), pad: 6, radius: 12 },
            { key: "site", world: () => this.rectOf(Hn.id), pad: 10, padTop: 40, radius: 18, look: !0 }
          ],
          hands: !0,
          done: () => !!this.openChat(),
          onDone: () => {
            const i = this.openChat();
            i && (this.chatId.value = i.id);
          },
          card: () => ({ place: "right", anchor: "site" })
        };
      case "chat-tab":
        return {
          enter: () => this.focusField("chat"),
          targets: () => [{ key: "ask", box: () => ip('[data-testid="chat-input"]', '[data-testid="chat-ghost-cue"]'), pad: 10, radius: 14 }],
          hands: !0,
          done: () => this.asked.value && this.typingField.value !== "chat",
          key: (i) => this.tabKey(i, "chat")
        };
      case "chat-send":
        return {
          // once it's sent, the light moves to where the answer arrives, and stays there as the plan lands;
          // till then the card keeps clear of the message it asks you to send
          targets: () => this.sent() ? [{ key: "answer", el: Qn('[data-testid="chat-panel"] .ch-scroll'), pad: 0, radius: 14, look: !0, ring: !0 }] : [
            { key: "send", el: Qn('[data-testid="chat-send"]'), pad: 6, radius: 999 },
            { key: "ask", box: () => ip('[data-testid="chat-input"]', '[data-testid="chat-send"]'), pad: 10, radius: 14, look: !0 }
          ],
          hands: !0,
          waiting: () => this.chatBusy(),
          done: () => !!this.chatPlan("proposed"),
          key: (i) => this.sendKey(i),
          card: () => ({ place: "left", anchor: this.sent() ? "answer" : "ask" })
        };
      case "chat-run":
        return {
          enter: () => this.planChatRuns(),
          // once it runs, the light moves to the frame, where the work lands, and to the plan's rows ticking
          targets: () => this.chatPlan("started") ? [
            { key: "frame", world: () => this.rectOf(Hn.id), pad: 10, padTop: 40, radius: 18, look: !0, ring: !0 },
            { key: "steps", el: Qn('[data-testid="chat-panel"] [data-testid="plan-steps"]'), pad: 6, radius: 12, look: !0 }
          ] : [
            { key: "plan-run", el: Qn('[data-testid="chat-panel"] [data-testid="plan-run"]'), pad: 6, radius: 12 },
            // the whole plan shows, and the card keeps off it (its prompt, its cost, Cancel)
            { key: "plan", el: Qn('[data-testid="chat-panel"] [data-testid="plan-card"]'), pad: 4, radius: 14, look: !0 }
          ],
          hands: !0,
          waiting: () => !!this.chatPlan("started") && !this.chatSettled(),
          // the plan has run and the chat has said how it went
          done: () => this.chatSettled(),
          key: (i) => this.runKey(i, '[data-testid="chat-panel"] [data-testid="plan-run"]'),
          card: () => ({ place: "left", anchor: this.chatPlan("started") ? "steps" : "plan" })
        };
      case "chat-result":
        return {
          targets: () => [{ key: "made", world: () => this.chatWork(), pad: 12, radius: 18 }],
          card: () => ({ place: "left", anchor: "made" })
        };
      case "organize":
        return {
          enter: () => {
            this.closeStudio(), t.ui.chatOpen = null, t.clearSelection(), t.ui.histOpen = !1;
            const i = t.store.bounds(), s = Math.max(160, t.view.h - hu - 320);
            i && this.flyTo(i, { fitW: 0.84, fitH: s / t.view.h, maxZoom: 0.9, ax: 0.5, ay: (hu + 6 + s / 2) / t.view.h });
          },
          targets: () => [{ key: "board", world: () => t.store.bounds(), pad: 26, radius: 24, look: !0 }]
        };
      case "finale":
        return {
          enter: () => {
            t.clearSelection();
            const i = t.store.bounds();
            i && this.flyTo(i, { fit: 0.7, maxZoom: 0.9, ax: 0.5, ay: 0.5 });
          }
        };
    }
    return {};
  }
  /** The session Image Gen added (the board holds no other). */
  addedTool() {
    const e = this.board.value;
    if (!e) return null;
    e.docRev.value;
    for (const t of e.store.all()) if (t.type === "tool") return t;
    return null;
  }
  /** The session the tour had you add, set to make four, waiting closed on the board. */
  adopt(e) {
    const t = this.board.value;
    this.toolId.value = e.id, t.setPrompt(e.id, { n: m3 }), t.clearSelection();
  }
  /** The session's prompt stays up while the steps need it. */
  keepOpen() {
    const e = this.board.value, t = this.toolId.value;
    !e || !t || (!e.promptTool.value || e.promptTool.value.id !== t) && e.select([t]);
  }
  sessionCard() {
    const e = this.toolId.value;
    return e ? document.querySelector('[data-el="' + e + '"] .cv-bucket') || document.querySelector('[data-el="' + e + '"]') : null;
  }
  rectOf(e) {
    const t = this.board.value, i = t ? t.store.get(e) : null;
    return i ? He(i) : null;
  }
  /** The gallery's pictures and its head, as one box (not the empty panel below them). */
  galleryBox() {
    const e = document.querySelector('[data-testid="results-gallery"]');
    if (!e) return null;
    const t = Array.from(e.querySelectorAll(".v2-hist-head, .v2-hist-item"));
    return o1(t.length ? t : [e]);
  }
  /** Where the drag step suggests the picture goes: right of the session. */
  dropSlot() {
    const e = this.tool();
    if (!e) return null;
    const t = 236;
    return { x: e.x + e.w + 56, y: e.y + e.h / 2 - t * Va.h / Va.w / 2, w: t, h: Math.round(t * Va.h / Va.w) };
  }
  /** A picture on the board placed from the session's gallery. */
  placedImage() {
    const e = this.board.value, t = this.toolId.value;
    if (!e || !t) return null;
    e.docRev.value;
    const i = new Set(this.results().map((s) => s.id));
    for (const s of e.store.all()) {
      if (s.type !== "image") continue;
      const o = s;
      if (o.sessionId === t || o.resultId && i.has(o.resultId)) return o;
    }
    return null;
  }
  /**
   * The tower goes into the site photos' frame before the chat sees it
   * (TD-04): the render you placed on the board, else the run's first, at
   * the frame's front. Once: a Back or a second visit finds it there.
   */
  addTower() {
    const e = this.board.value;
    if (!e || e.store.get(Wf)) return;
    const t = this.placedId.value ? e.store.get(this.placedId.value) : void 0, i = t && t.src ? t.src : Hf[0].src, s = t && t.w && t.h ? t.w / t.h : Va.w / Va.h, { frame: o, tower: r } = DRe(i, s);
    e.store.update(Hn.id, o, { history: !1 }), e.store.add([r], { history: !1 });
  }
  placedResultId() {
    const e = this.board.value, t = this.placedId.value, i = e && t ? e.store.get(t) : void 0;
    if (i && i.resultId) return i.resultId;
    const s = this.results().find((o) => o.status === "done");
    return s ? s.id : null;
  }
  focusField(e) {
    this.later(() => {
      const t = document.querySelector(KRe[e]);
      t && document.activeElement !== t && t.focus({ preventScroll: !0 });
    }, 80);
  }
  /** Done with Studio view: closed, as its back arrow closes it. */
  closeStudio() {
    const e = this.board.value;
    !e || !e.ui.studio || (N0(e, e.ui.studio.sessionId).leave(), e.closeStudio());
  }
  /** The chat open in the panel (Chat on the frame made it). */
  openChat() {
    const e = this.board.value;
    if (!e) return null;
    e.docRev.value;
    const t = e.ui.chatOpen, i = t ? e.store.get(t) : void 0;
    return i && i.type === "chat" ? i : null;
  }
  /** The chat you started, as it stands. */
  chat() {
    const e = this.board.value, t = this.chatId.value;
    if (!e || !t) return null;
    e.docRev.value;
    const i = e.store.get(t);
    return i && i.type === "chat" ? i : null;
  }
  /** Your message is in the chat. */
  sent() {
    const e = this.chat();
    return !!e && (e.messages || []).some((t) => t.role === "user");
  }
  /** The chat is answering. */
  chatBusy() {
    const e = this.board.value, t = this.chatId.value;
    return !!e && !!t && os(e).busy(t);
  }
  /** Its plan: waiting for Run plan (`proposed`), or run, running or done (`started`). */
  chatPlan(e) {
    const t = this.chat(), i = t && t.messages || [];
    for (let s = i.length - 1; s >= 0; s--) {
      const o = i[s].plan;
      if (o && (e === "proposed" ? o.status === "proposed" : o.status !== "proposed" && o.status !== "cancelled")) return o;
    }
    return null;
  }
  /** The plan has run, and the chat has said how it went. */
  chatSettled() {
    const e = this.chatPlan("started");
    return !!e && e.status === "done" && !this.chatBusy();
  }
  /** Each of the plan's runs lands its photo's finished view, in the plan's order. */
  planChatRuns() {
    const e = this.chatPlan("proposed"), t = this.opts.gen;
    if (!(!e || t.planned))
      for (const i of e.sessions)
        for (const s of i.runs) {
          const o = s.images && s.images.length ? $Re(s.images[0].id) : null, r = o && i1[o] || Object.values(i1)[0];
          t.plan([r], { first: this.timing.chatRun });
        }
  }
  /** What the chat's plan made: its session, and the pictures set out under it. */
  chatWork() {
    const e = this.board.value, t = this.chatPlan("started");
    if (!e || !t) return null;
    e.docRev.value;
    const i = new Set(t.sessions.map((o) => o.toolId || o.addedId).filter((o) => !!o)), s = [];
    for (const o of e.store.all())
      (i.has(o.id) || o.type === "image" && o.sessionId && i.has(o.sessionId)) && s.push(He(o));
    return s.length ? Np(s) : null;
  }
  /** Enter sends the chat's message (as the composer's own Enter does), wherever the focus is. */
  sendKey(e) {
    if (!(e.key !== "Enter" || e.shiftKey || e.altKey)) {
      if (!e.repeat) {
        const t = document.querySelector('[data-testid="chat-send"]');
        t && !t.disabled && t.click();
      }
      return "handled";
    }
  }
  tabKey(e, t) {
    if (e.key === "Tab")
      return e.shiftKey || e.metaKey || e.ctrlKey || e.altKey || !e.repeat && this.typingField.value !== t && (this.focusField(t), this.tabs[t]++), "handled";
  }
  runKey(e, t) {
    if (!(e.key !== "Enter" || !bn(e))) {
      if (!e.repeat) {
        const i = document.querySelector(t);
        i && !i.disabled && i.click();
      }
      return "handled";
    }
  }
  // ---------------------------------------------------------------- the camera
  /**
   * Fly so a place on the board sits at (ax, ay) of the view (fractions),
   * at `zoom`, or zoomed to fill `fit` of the view (no closer than maxZoom).
   */
  flyTo(e, t) {
    const i = this.board.value;
    if (!i || !i.engine || !e) return;
    const s = i.view.w, o = i.view.h;
    let r = t.zoom || 1;
    const a = t.fitW || t.fit, l = t.fitH || t.fit;
    a && l && (r = Math.min(t.maxZoom || 1, s * a / Math.max(1, e.w), o * l / Math.max(1, e.h)));
    const d = { zoom: r, x: s * t.ax - (e.x + e.w / 2) * r, y: o * t.ay - (e.y + e.h / 2) * r };
    this.timing.fly ? i.engine.animateCamera(d, this.timing.fly) : i.setCamera(d);
  }
  // ---------------------------------------------------------------- holding the board still
  listen() {
    if (!this.listening) {
      this.listening = !0, window.addEventListener("keydown", this.onKey, !0);
      for (const e of M3) window.addEventListener(e, this.onPointer, { capture: !0, passive: !1 });
    }
  }
  unlisten() {
    if (this.listening) {
      this.listening = !1, window.removeEventListener("keydown", this.onKey, !0);
      for (const e of M3) window.removeEventListener(e, this.onPointer, { capture: !0 });
    }
  }
  /** Inside the tour's part of the page (the page itself counts: a key pressed with nothing focused). */
  inScope(e) {
    const t = this.opts.scope ? this.opts.scope() : null;
    return !t || !(e instanceof Node) ? !0 : e === document.body || e === document.documentElement || e === document || t.contains(e);
  }
  /** Inside a lit control that takes clicks: in its element, or (a box of several) within its bounds. */
  inTargets(e, t) {
    if (!e) return !1;
    const i = JRe(t);
    for (const s of this.targets.value) {
      if (s.look) {
        const o = s.takes, r = o && s.el ? s.el() : null, a = r && o ? e.closest(o) : null;
        if (r && a && r.contains(a)) return !0;
        continue;
      }
      if (s.el) {
        const o = s.el();
        if (o && (o === e || o.contains(e))) return !0;
      } else if (s.box && i) {
        const o = s.box();
        if (o && i.x >= o.x && i.x <= o.x + o.w && i.y >= o.y && i.y <= o.y + o.h) return !0;
      }
    }
    return !1;
  }
}
const M3 = ["pointerdown", "mousedown", "click", "dblclick", "auxclick", "contextmenu", "wheel", "touchstart", "dragstart"];
function XRe(n) {
  if (/^F\d{1,2}$/.test(n.key)) return !0;
  if (!n.metaKey && !n.ctrlKey) return !1;
  if (n.altKey) return !0;
  const e = n.key.toLowerCase();
  return ["r", "t", "w", "n", "q", "p", "f"].includes(e) || e === "l" && !n.shiftKey;
}
function T3(n) {
  return Wi.findIndex((e) => e.id === n);
}
function Np(n) {
  const e = Math.min(...n.map((o) => o.x)), t = Math.min(...n.map((o) => o.y)), i = Math.max(...n.map((o) => o.x + o.w)), s = Math.max(...n.map((o) => o.y + o.h));
  return { x: e, y: t, w: i - e, h: s - t };
}
function C3(n) {
  return n.hint || "";
}
function JRe(n) {
  const e = n;
  if (typeof e.clientX == "number") return { x: e.clientX, y: e.clientY };
  const t = n.touches && n.touches[0];
  return t ? { x: t.clientX, y: t.clientY } : null;
}
function o1(n) {
  const e = n.map((t) => t.getBoundingClientRect()).filter((t) => t.width || t.height);
  return e.length ? Np(e.map((t) => ({ x: t.left, y: t.top, w: t.width, h: t.height }))) : null;
}
function ip(...n) {
  return o1(n.map((e) => document.querySelector(e)).filter((e) => !!e));
}
var ZRe = Object.defineProperty, QRe = (n, e, t) => e in n ? ZRe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, sp = (n, e, t) => QRe(n, typeof e != "symbol" ? e + "" : e, t);
const eze = { first: 2600, gap: 420 };
class tze {
  constructor(e, t = eze) {
    sp(this, "fallback", e), sp(this, "timing", t), sp(this, "queue", []), sp(this, "runs", 0);
  }
  /** What the next run makes (several plans wait their turn), and, when it isn't the usual, how soon it lands. */
  plan(e, t = {}) {
    this.queue.push({ pictures: e, timing: { ...this.timing, ...t } });
  }
  /** Forget every plan (the tour starting over). */
  reset() {
    this.queue.length = 0, this.runs = 0;
  }
  /** Plans not yet used. */
  get planned() {
    return this.queue.length;
  }
  run(e, t) {
    this.runs++;
    const i = wt(), s = this.queue.shift(), o = s ? s.pictures : this.fallback, r = s ? s.timing : this.timing, a = Hy(e.aspect || "3:4"), l = Date.now(), d = [];
    for (let p = 0; p < e.count; p++)
      d.push({
        id: wt(),
        sessionId: e.sessionId,
        status: "pending",
        url: "",
        w: a.w,
        h: a.h,
        prompt: e.prompt,
        model: e.model.name,
        modelId: e.model.id,
        inputs: e.inputs,
        refs: e.refs,
        seed: 1e3 + p,
        author: e.author,
        createdAt: l + p,
        runId: i,
        parents: e.refs.slice()
      });
    const c = [];
    let h = !1;
    const f = [];
    return d.forEach((p, y) => {
      c.push(window.setTimeout(() => {
        if (h) return;
        const v = o[y % o.length], x = { ...p, status: "done", url: v.src, label: v.label };
        f.push(x), t.onResult(x), f.length === d.length && t.onDone(f);
      }, r.first + y * r.gap));
    }), {
      runId: i,
      pending: d,
      cancel: () => {
        h = !0;
        for (const p of c) clearTimeout(p);
      }
    };
  }
}
const nze = '.bl-hero{--stage-w: min(80%, 940px);position:relative;display:flex;flex-direction:column;align-items:center;margin:0 0 44px;border-radius:28px;background:var(--bg-deep);border:1px solid transparent;box-shadow:0 40px 120px #00000073;text-align:center}.bl-hero:before{content:"";position:absolute;inset:-1px;z-index:1;padding:1px;border-radius:inherit;background:linear-gradient(180deg,#d6c8f24d,#ffffff17 34%,#ffffff0d 70%,#ffffff12);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0);pointer-events:none}.bl-hero-clip{position:absolute;inset:0;border-radius:inherit;overflow:hidden;container-type:inline-size;pointer-events:none}.bl-hero-atmo{position:absolute;inset:0;background:radial-gradient(64% 44% at 50% -10%,rgba(255,255,255,.05),transparent 66%)}.bl-hero-light{position:absolute;inset:0}.bl-hero-lit{position:absolute;inset:0;-webkit-mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);-webkit-mask-size:3200px 1500px,100% 100%;-webkit-mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;-webkit-mask-repeat:no-repeat,no-repeat;-webkit-mask-composite:source-in;mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);mask-size:3200px 1500px,100% 100%;mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;mask-repeat:no-repeat,no-repeat;mask-composite:intersect}.bl-hero .glow{position:absolute;aspect-ratio:1;border-radius:50%;animation:bl-glow-drift calc(26s + var(--i) * 4.3s) ease-in-out calc(var(--i) * -5.1s) infinite alternate,bl-glow-breathe calc(12s + var(--i) * 2.2s) ease-in-out calc(var(--i) * -3.7s) infinite;animation-play-state:paused}.bl-hero-light .glow{filter:blur(40px)}.bl-hero.is-live .glow{animation-play-state:running}@keyframes bl-glow-drift{0%{transform:translate(0) scale(1)}50%{transform:translate(1.5cqw,9cqw) scale(1.08)}to{transform:translate(-1cqw,-5cqw) scale(.95)}}@keyframes bl-glow-breathe{0%,to{opacity:.6}50%{opacity:1}}.bl-hero-stage{position:absolute;left:50%;bottom:0;width:var(--stage-w);aspect-ratio:1180 / 540;transform:translate(-50%)}.bl-hero-stage:before{content:"";position:absolute;left:6%;right:6%;top:-14%;height:50%;border-radius:50%;background:radial-gradient(50% 50% at 50% 50%,rgba(170,160,225,.13),rgba(150,156,230,.04) 55%,transparent 75%);filter:blur(40px)}.bl-hero-room{flex:none;width:var(--stage-w);aspect-ratio:1180 / 540;margin-top:34px}.bl-hero-top{position:absolute;left:18px;top:18px;z-index:4;display:flex;text-align:left}.bl-hero-copy{position:relative;z-index:2;max-width:880px;padding:50px 24px 0}.bl-title{font-size:clamp(36px,4vw,54px);line-height:1.03;letter-spacing:-.045em;font-weight:500!important;color:#fff;background:linear-gradient(180deg,#fff 35%,#ffffffbd);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-title em{font-style:normal;background:linear-gradient(100deg,#efe6ff 0%,var(--amethyst-700) 48%,var(--vista-blue-500) 100%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-sub{max-width:820px;margin:14px auto 0!important;font-size:15.5px;line-height:1.55;color:#ffffff8f;text-wrap:balance}.bl-hero-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:12px;margin-top:24px}.bl-hero-pause{position:absolute;right:16px;bottom:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:#12121a9e;color:#ffffffc7;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-pause:hover{background:#282836cc;color:#fff;border-color:#fff3}.bl-hero-pause:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-corner{position:absolute;right:18px;top:18px;z-index:4;display:flex;align-items:center;gap:8px}.bl-hero-tour{display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 13px 0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;font:500 12.5px var(--font-sans);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-tour .licon{color:var(--amethyst-700)}.bl-hero-tour:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-tour:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-round{display:inline-flex;flex:none;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-round:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-round:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero.is-min{flex-direction:row;align-items:stretch;margin:0 0 26px;border-radius:0;background:none;border-color:transparent;box-shadow:none;text-align:left}.bl-hero.is-min:before{display:none}.bl-hero.is-min .bl-hero-copy{display:flex;flex:1;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:18px 32px;max-width:none;padding:8px 0 0;animation:bl-head-in .3s var(--ease-out-soft)}.bl-hero.is-min .bl-hero-text{flex:1 1 360px;min-width:0}.bl-hero.is-min .bl-title{font-size:clamp(28px,2.4vw,34px);letter-spacing:-.04em}.bl-hero.is-min .bl-sub{max-width:560px;margin:8px 0 0!important;font-size:14px;text-wrap:pretty}.bl-hero.is-min .bl-hero-actions{flex:none;justify-content:flex-end;gap:10px;margin-top:0}.bl-hero.is-min .bl-hero-tour{height:38px;padding:0 14px 0 12px}.bl-hero.is-min .bl-hero-round{width:38px;height:38px}@keyframes bl-head-in{0%{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.bl-hd{position:absolute;inset:0;pointer-events:none}.bl-hd-win{position:absolute;left:0;top:0;transform-origin:0 0;border-radius:16px;overflow:hidden;background:#070910;box-shadow:0 0 0 1px #ffffff1f,0 -8px 40px #00000080,0 50px 140px #000000e6;font-family:var(--font-sans);color:var(--fg-2);text-align:left;user-select:none;-webkit-user-select:none;contain:layout paint}.bl-hd-win:after{content:"";position:absolute;inset:0;z-index:9;border-radius:inherit;box-shadow:inset 0 1px #ffffff1a;pointer-events:none}.bl-hd img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .6s var(--ease-out-soft)}.bl-hd img.is-in{opacity:1}.bl-hd img.is-broken{visibility:hidden}.bl-hd-bar{position:absolute;left:0;right:0;top:0;z-index:3;display:flex;align-items:center;gap:12px;height:44px;padding:0 16px;background:linear-gradient(180deg,#10121b,#0b0d14);border-bottom:1px solid rgba(255,255,255,.06)}.bl-hd-lights{display:inline-flex;gap:8px;margin-right:12px}.bl-hd-lights i{width:12px;height:12px;border-radius:50%;background:#ff5f57;box-shadow:inset 0 0 0 .5px #0000004d}.bl-hd-lights i:nth-child(2){background:#febc2e}.bl-hd-lights i:nth-child(3){background:#28c840}.bl-hd-mark{flex:none}.bl-hd-crumbs{font-size:13px;color:var(--fg-4);letter-spacing:-.005em;white-space:nowrap}.bl-hd-crumbs .sep{margin:0 5px;color:var(--fg-5)}.bl-hd-crumbs b{color:var(--fg-1);font-weight:600}.bl-hd-saved{margin-left:auto;display:inline-flex;align-items:center;gap:6px;font-size:11.5px;color:var(--fg-4)}.bl-hd-saved i{width:6px;height:6px;border-radius:50%;background:#ffffff47}.bl-hd-kebab{display:inline-flex;flex-direction:column;gap:2.5px;padding:0 8px 0 14px}.bl-hd-kebab i{width:3px;height:3px;border-radius:50%;background:var(--fg-4)}.bl-hd-canvas{position:absolute;inset:44px 0 0;overflow:hidden;background:radial-gradient(55% 75% at 16% 0%,rgba(117,50,211,.17),transparent 70%),radial-gradient(45% 60% at 90% 10%,rgba(90,97,237,.1),transparent 70%),#070910}.bl-hd-world{position:absolute;left:0;top:0;width:0;height:0;transform-origin:0 0}.bl-hd-dots{position:absolute;left:-900px;top:-800px;width:5600px;height:3400px}.bl-hd-dots.is-fine{background-image:radial-gradient(circle,rgba(255,255,255,.14) 1.2px,transparent 1.7px);background-size:26px 26px;opacity:clamp(0,calc((var(--z, 1) - .4) * 4),1)}.bl-hd-dots.is-coarse{background-image:radial-gradient(circle,rgba(255,255,255,.12) 3.4px,transparent 4.6px);background-size:104px 104px;opacity:clamp(0,calc((.66 - var(--z, 1)) * 4),1)}.bl-hd-frame{position:absolute;border-radius:22px;background:#ffffff06;border:1.5px solid rgba(255,255,255,.065)}.bl-hd-ftitle{position:absolute;left:4px;bottom:calc(100% + 10px);white-space:nowrap;font-size:11.5px;font-weight:600;letter-spacing:.26em;text-transform:uppercase;color:#ffffff94;opacity:clamp(0,calc((var(--z, 1) - .42) * 5),1)}.bl-hd-ftitle small{margin-left:8px;font-size:11.5px;font-weight:500;letter-spacing:.02em;text-transform:none;color:#ffffff4d}.bl-hd-flabel{position:absolute;left:0;bottom:100%;transform-origin:0 100%;transform:scale(var(--iz, 1)) translateY(-6px);white-space:nowrap;padding:3px 7px;border-radius:6px;background:#0c0e16eb;border:1px solid rgba(255,255,255,.1);font-size:8.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#ffffffb8;opacity:clamp(0,calc((.5 - var(--z, 1)) * 5),1)}.bl-hd-pic{position:absolute;border-radius:9px;overflow:hidden;background:#ffffff0b;box-shadow:0 14px 40px #02040c73,inset 0 0 0 1px #ffffff0d}.bl-hd-pic.is-result{opacity:0}.bl-hd-pic.is-video img{animation:bl-hd-drift 9s ease-in-out infinite alternate;animation-play-state:paused}.bl-hero.is-live .bl-hd-pic.is-video img{animation-play-state:running}@keyframes bl-hd-drift{0%{transform:scale(1)}to{transform:scale(1.09) translate(-2%,-1.5%)}}.bl-hd-play,.bl-hd-heart{position:absolute;left:9px;top:9px;display:flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#080a129e;box-shadow:inset 0 0 0 1px #ffffff2e;color:#fff}.bl-hd-play .licon svg{fill:currentColor}.bl-hd-heart{color:#ff6b8b;opacity:0}.bl-hd-heart .licon svg{fill:currentColor}.bl-hd-session{position:absolute;border-radius:16px;padding:14px;background:linear-gradient(180deg,#ffffff13,#ffffff08),#0c0e17;border:1px solid rgba(255,255,255,.1);box-shadow:inset 0 1px #ffffff14,0 18px 60px #05081459}.bl-hd-session-head{display:flex;align-items:center;gap:10px}.bl-hd-badge{display:flex;flex:none;align-items:center;justify-content:center;width:36px;height:36px;border-radius:12px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;color:var(--amethyst-700)}.bl-hd-session-titles{display:flex;flex:1;flex-direction:column;min-width:0}.bl-hd-session-titles .kind{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;overflow:hidden}.bl-hd-session-titles .sep{margin:0 6px;color:var(--fg-5);letter-spacing:0}.bl-hd-session-titles .model{font-size:10px;font-weight:500;text-transform:none;letter-spacing:.01em;color:var(--fg-5)}.bl-hd-session-titles .name{margin-top:1px;font-size:14.5px;font-weight:600;color:#fff;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bl-hd-count{flex:none;padding:3px 9px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:11px;font-weight:600;color:var(--fg-3)}.bl-hd-thumbs{display:flex;gap:6px;margin-top:12px}.bl-hd-thumb{position:relative;flex:1;aspect-ratio:1;border-radius:8px;overflow:hidden;border:1px solid rgba(255,255,255,.07);background:#ffffff0a}.bl-hd-thumb.is-empty{border:1px dashed rgba(255,255,255,.1);background:#ffffff05}.is-hero .bl-hd-thumb img{transition:none}.bl-hd-thumbs.is-busy .bl-hd-thumb:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:bl-hd-shimmer 1.2s linear infinite}@keyframes bl-hd-shimmer{0%{transform:translate(-100%)}to{transform:translate(100%)}}.bl-hd-foot{margin-top:11px;font-size:11px;color:var(--fg-4);white-space:nowrap}.bl-hd-ring{position:absolute;inset:-4px;border-radius:19px;border:1.7px solid var(--amethyst-500);box-shadow:0 0 0 4.5px #9968df33;opacity:0}.bl-hd-note{position:absolute;display:flex;flex-direction:column;padding:16px;border-radius:16px;box-shadow:inset 0 1px #ffffff1a,0 18px 60px #0508144d}.bl-hd-note .text{flex:1;font-size:13.5px;line-height:1.45;color:#ffffffdb;letter-spacing:-.005em}.bl-hd-note .meta{margin-top:8px;font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#ffffff61}.bl-hd-note.is-amethyst{background:linear-gradient(180deg,#9968df33,#9968df17),#0b0b16;border:1px solid rgba(194,164,236,.24)}.bl-hd-note.is-amber{background:linear-gradient(180deg,#f0b44a2e,#f0b44a14),#0d0b0c;border:1px solid rgba(247,212,143,.22)}.bl-hd-note.is-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14),#0d0a12;border:1px solid rgba(245,163,199,.22)}.bl-hd-note.is-mint{background:linear-gradient(180deg,#34c79a29,#34c79a12),#080d10;border:1px solid rgba(143,229,201,.2)}.bl-hd.is-opening .bl-hd-frame,.bl-hd.is-opening .bl-hd-pic:not(.is-result),.bl-hd.is-opening .bl-hd-session,.bl-hd.is-opening .bl-hd-note{--p: clamp(0, calc((var(--build, 0) - var(--d, 0)) * 2.5), 1);--q: calc(1 - var(--p));opacity:var(--p);transform:translate3d(0,calc(var(--q) * var(--q) * 56px),0) scale(calc(1 - .1 * var(--q) * var(--q)));filter:blur(calc(var(--q) * var(--q) * 16px))}.bl-hd.is-opening .bl-hd-frame:after,.bl-hd.is-opening .bl-hd-pic:not(.is-result):after,.bl-hd.is-opening .bl-hd-session:after,.bl-hd.is-opening .bl-hd-note:after{content:"";position:absolute;inset:calc(-3px * var(--iz, 1));border-radius:inherit;pointer-events:none;box-shadow:0 0 0 calc(1.5px * var(--iz, 1)) #decefaeb,0 0 calc(26px * var(--iz, 1)) calc(4px * var(--iz, 1)) #9968df80;opacity:0}.bl-hd.is-opening .bl-hd-pic:not(.is-result):after{inset:0;z-index:1;box-shadow:inset 0 0 0 calc(2.5px * var(--iz, 1)) #decefaf2,inset 0 0 calc(38px * var(--iz, 1)) #9968dfb3;opacity:var(--g-pic, 0)}.bl-hd.is-opening .bl-hd-session:after{opacity:var(--g-session, 0)}.bl-hd.is-opening .bl-hd-note:after{opacity:var(--g-note, 0)}.bl-hd.is-opening .bl-hd-frame:after{opacity:var(--g-frame, 0)}.bl-hd-dock{position:absolute;left:50%;z-index:2;display:flex;align-items:center;gap:6px;padding:5px;border-radius:15px;background:#121521e6;border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff14,0 30px 80px #0206178c}.bl-hd-add{display:inline-flex;height:34px;border-radius:10px;overflow:hidden;background:var(--grad-cta);color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-add.is-plus{width:34px;align-items:center;justify-content:center}.bl-hd-add.is-plus .licon{transition:transform .3s cubic-bezier(.16,1,.3,1)}.bl-hd-add.is-plus.is-open .licon{transform:rotate(45deg)}.bl-hd-rail{display:inline-flex;align-items:center;gap:2px}.bl-hd-rail i{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:9px;color:var(--fg-3)}.bl-hd-rail i.is-on{background:#9968df29;color:#fff}.bl-hd-rail b{width:1px;height:18px;margin:0 4px;background:var(--hairline-soft)}.bl-hd-prompt{position:absolute;z-index:2;border-radius:18px;border:1px solid rgba(255,255,255,.075);background:#0b0d15fb;box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 30px 80px #02040c9e;visibility:hidden}.bl-hd-prompt-side{position:absolute;left:12px;top:12px;display:flex;flex-direction:column;gap:7px}.bl-hd-prompt-side i{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:9px;color:var(--fg-4)}.bl-hd-slot{position:absolute;display:flex;align-items:center;justify-content:center;border-radius:10px;border:1px dashed rgba(255,255,255,.16);background:#ffffff05;color:var(--fg-4)}.bl-hd-slot.is-target{border:1px solid rgba(194,164,236,.7);background:#9968df24;color:var(--amethyst-700)}.bl-hd-slot img{position:absolute;inset:-1px;width:calc(100% + 2px);height:calc(100% + 2px);border-radius:10px;transition:none}.bl-hd-slot .glow{position:absolute;inset:-4px;z-index:1;border-radius:13px;box-shadow:0 0 0 1.5px #c2a4ecd9,0 0 22px 4px #9968df6b;opacity:0}.bl-hd-prompt-text{position:absolute;left:54px;right:18px;top:66px;height:22px;white-space:nowrap;font-size:15px;line-height:22px;letter-spacing:-.005em;color:#fff}.bl-hd-prompt-text .ph{position:absolute;left:0;top:0;color:var(--fg-4)}.bl-hd-prompt-text .caret{display:inline-block;width:1.5px;height:18px;margin-left:1px;vertical-align:-3px;border-radius:1px;background:var(--amethyst-700)}.bl-hd-prompt-foot{position:absolute;left:54px;right:12px;bottom:12px;display:flex;align-items:center;gap:7px}.bl-hd-prompt-foot .chip{display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 11px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:12px;color:var(--fg-2);white-space:nowrap}.bl-hd-prompt-foot .chip small{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.bl-hd-prompt-foot .chip .licon{color:var(--fg-4)}.bl-hd-prompt-foot .cog{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;color:var(--fg-4)}.bl-hd-prompt-foot .sp{flex:1}.bl-hd-prompt-foot .step{display:inline-flex;align-items:center;gap:10px;height:30px;padding:0 11px;border-radius:999px;border:1px solid rgba(255,255,255,.08);color:var(--fg-4);font-size:12.5px}.bl-hd-prompt-foot .step b{color:#fff;font-weight:600}.bl-hd-prompt-foot .run{position:relative;isolation:isolate;display:inline-flex;align-items:center;justify-content:center;height:30px;border-radius:999px;background:#ffffff12;font-size:12.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-4);transition:color .3s,box-shadow .3s,transform .12s var(--ease-out-soft),opacity .2s}.bl-hd-prompt-foot .run:before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;background:var(--grad-cta);opacity:0;transition:opacity .3s}.bl-hd-prompt-foot .run.is-lit{color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-prompt-foot .run.is-lit:before{opacity:1}.bl-hd-prompt-foot .run.is-pressed{transform:scale(.95)}.bl-hd-prompt-foot .run.is-busy{opacity:.72}.bl-hd-zoom{position:absolute;right:16px;z-index:2;display:inline-flex;align-items:center;gap:10px;height:34px;padding:0 11px;border-radius:12px;background:#121521e6;border:1px solid var(--hairline);color:var(--fg-4);font-size:12px}.bl-hd-zoom .pct{min-width:30px;text-align:center;color:var(--fg-2);font-variant-numeric:tabular-nums}.bl-hd-ghost{position:absolute;left:0;top:0;z-index:5;width:54px;height:72px;border-radius:8px;opacity:0;transform-origin:0 0;box-shadow:0 16px 40px #0000008c}.bl-hd-ghost img{border-radius:8px}.bl-hd-ghost .ring{position:absolute;inset:-3px;border-radius:10px;box-shadow:0 0 0 1.5px var(--amethyst-700),0 0 18px #9968df80;opacity:0}.bl-hd-ripple{position:absolute;left:-18px;top:-18px;z-index:6;width:36px;height:36px;border-radius:50%;border:1.5px solid rgba(255,255,255,.9);opacity:0}.bl-hd-pointer{position:absolute;left:0;top:0;z-index:7;opacity:0}.bl-hd-pointer .arrow{display:block;margin:-3px 0 0 -4px;filter:drop-shadow(0 3px 6px rgba(0,0,0,.45));transform-origin:4px 3px;transition:transform .09s ease-out}.bl-hd-pointer.is-pressed .arrow{transform:scale(.86)}.bl-hd-key{position:absolute;left:16px;top:-26px;padding:3px 7px;border-radius:6px;background:#f5f5faf5;box-shadow:0 1px #00000040,0 6px 16px #00000059;font-size:11px;font-weight:600;white-space:nowrap;color:#11131c;opacity:0}.bl-hd-sheen{position:absolute;top:-10%;bottom:-10%;left:0;z-index:8;width:60%;opacity:0;pointer-events:none;background:linear-gradient(105deg,transparent 25%,rgba(255,255,255,.1) 50%,transparent 75%);mix-blend-mode:screen}@media(max-width:900px){.bl-hero{--stage-w: 92%;margin:0 0 30px;border-radius:22px}.bl-hero-pause{top:14px;right:14px;bottom:auto}.bl-hero-corner{top:14px;right:56px}.bl-hero-copy{padding-top:54px}.bl-sub{font-size:14.5px}}@media(max-width:600px){.bl-hero-stage,.bl-hero-room{display:none}.bl-hero-copy{padding:52px 18px 34px}.bl-hero.is-min{margin-bottom:18px}.bl-hero.is-min .bl-hero-copy{padding:4px 0 0}.bl-hero.is-min .bl-hero-actions{flex:1 1 100%;justify-content:flex-start}}', ize = '.ob-layer{position:fixed;inset:0;z-index:2147483000;pointer-events:none;color:var(--fg-2)}.ob-layer [data-tour-ui]{pointer-events:auto}.ob-dim{position:absolute;inset:0}.ob-confetti{position:absolute;inset:0;width:100%;height:100%;z-index:30;pointer-events:none}.ob-dim-fill{fill:#04030c;transition:opacity .7s var(--ease-out-soft)}.ob-ring{position:absolute;box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df38,0 0 34px 6px #9968df52;animation:obBreathe 2.4s ease-in-out infinite}.ob-ring:after{content:"";position:absolute;inset:-2px;border-radius:inherit;box-shadow:0 0 0 1.5px #d6c2f2b3;animation:obRipple 2.4s var(--ease-out-soft) infinite}@keyframes obBreathe{0%,to{box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df33,0 0 30px 4px #9968df42}50%{box-shadow:0 0 0 1.5px #e8dcff,0 0 0 7px #9968df47,0 0 46px 10px #9968df66}}@keyframes obRipple{0%{inset:-2px;opacity:.9}70%,to{inset:-16px;opacity:0}}.ob-ring.is-nudged{animation:obCall .6s var(--ease-out-soft),obBreathe 2.4s ease-in-out .6s infinite}@keyframes obCall{0%{box-shadow:0 0 0 1.5px #fff,0 0 0 12px #9968df59,0 0 60px 16px #9968df8c}to{box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df33,0 0 30px 4px #9968df42}}.ob-ring.is-done{animation:obDone .75s var(--ease-out-soft) forwards}.ob-ring.is-done:after{animation:none;opacity:0}@keyframes obDone{0%{box-shadow:0 0 0 1.5px #fff,0 0 0 5px #37d39959,0 0 40px 8px #37d39966}to{box-shadow:0 0 0 1.5px #37d39900,0 0 0 18px #37d39900,0 0 60px 16px #37d39900}}.ob-slot{position:absolute;display:flex;align-items:center;justify-content:center;border:1.5px dashed rgba(214,194,242,.75);background:#9968df12;animation:obSlot 1.8s ease-in-out infinite}.ob-slot span{padding:6px 12px;border-radius:999px;background:#04030cb8;color:#fff;font-size:12px;font-weight:600;letter-spacing:-.005em;white-space:nowrap}.ob-slot.is-done{animation:none;border-color:#37d399cc}@keyframes obSlot{0%,to{background:#9968df0d}50%{background:#9968df24}}.ob-arc{position:absolute;inset:0;overflow:visible}.ob-arc path{fill:none;stroke:#d6c2f2d9;stroke-width:2;stroke-linecap:round;stroke-dasharray:.5 9;animation:obMarch .8s linear infinite;filter:drop-shadow(0 0 4px rgba(153,104,223,.8))}.ob-arc circle{fill:#fff;filter:drop-shadow(0 0 6px rgba(153,104,223,.9))}@keyframes obMarch{to{stroke-dashoffset:-9.5}}.ob-head{position:absolute;left:0;right:0;top:0;height:60px;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;padding:0 18px;background:#070910f0;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-bottom:1px solid var(--hairline-soft)}.ob-head-left{display:flex;align-items:center;gap:12px;min-width:0}.ob-head-mark{flex:none}.ob-head-name{font-size:13px;color:var(--fg-4);white-space:nowrap}.ob-head-name .sep{margin:0 6px;color:var(--fg-5)}.ob-head-name b{color:var(--fg-1);font-weight:600}.ob-chapters{display:flex;align-items:center;gap:4px;margin:0;padding:0;list-style:none}.ob-chapters li{display:flex;align-items:center;gap:7px;height:30px;padding:0 11px 0 5px;border-radius:999px;color:var(--fg-4);font-size:12px;font-weight:500;white-space:nowrap;transition:background .4s var(--ease-out-soft),color .4s}.ob-chapters li+li:before{content:"";width:14px;height:1px;margin:0 4px 0 -6px;background:var(--hairline)}.ob-chapters .n{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;border:1px solid var(--hairline);font-size:10.5px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;transition:background .4s,border-color .4s,color .4s}.ob-chapters li.on{background:#9968df24;color:#fff}.ob-chapters li.on .n{border-color:transparent;background:var(--grad-cta);color:#fff;box-shadow:0 0 14px #9968df8c}.ob-chapters li.done{color:var(--fg-3)}.ob-chapters li.done .n{border-color:#c2a4ec66;background:#9968df33;color:var(--amethyst-800)}.ob-head-right{display:flex;justify-content:flex-end}.ob-skip{height:32px;padding:0 14px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff08;color:var(--fg-3);font:500 12.5px var(--font-sans);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ob-skip:hover{background:#ffffff14;color:#fff}.ob-card{position:absolute;left:0;top:0;width:372px;border-radius:20px;overflow:hidden;background:#0f101a;border:1px solid rgba(255,255,255,.09);box-shadow:0 0 0 1px #9968df29,0 34px 90px #02040cb8,0 10px 26px #02040c73;transition:transform .7s var(--ease-out-soft);will-change:transform}.ob-card.is-wide{width:min(560px,calc(100vw - 32px))}.ob-card.is-short,.ob-card.is-short.is-wide{display:flex;align-items:stretch;width:min(600px,calc(100vw - 32px))}.ob-card.is-short .ob-media{flex:none;width:236px;aspect-ratio:auto;min-height:150px;border-bottom:0;border-right:1px solid var(--hairline-soft)}.ob-card.is-short .ob-body{flex:1;min-width:0;gap:10px;padding:14px 16px}.ob-card.is-short .ob-title{font-size:15.5px}.ob-card.is-short .ob-text{font-size:12.5px}.ob-card-enter-active{transition:opacity .4s ease,transform .7s var(--ease-out-soft)}.ob-card-leave-active{transition:opacity .2s ease}.ob-card-enter-from,.ob-card-leave-to{opacity:0}.ob-media{position:relative;aspect-ratio:16 / 9;overflow:hidden;background:#070910;border-bottom:1px solid var(--hairline-soft)}.ob-media:after{content:"";position:absolute;left:0;right:0;bottom:0;height:40px;pointer-events:none;background:linear-gradient(180deg,transparent,rgba(15,16,26,.5))}.ob-media-enter-active{transition:opacity .35s ease}.ob-media-leave-active{transition:opacity .18s ease}.ob-media-enter-from,.ob-media-leave-to{opacity:0}.ob-tag{position:absolute;left:12px;top:12px;z-index:3;display:inline-flex;align-items:center;gap:6px;padding:4px 10px 4px 8px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}.ob-tag .licon{color:#d9c6ff}.ob-body{display:flex;flex-direction:column;gap:12px;padding:16px 18px}.ob-words-stack{display:grid}.ob-words-stack>.ob-words{grid-area:1 / 1;min-width:0}.ob-words{display:flex;flex-direction:column;gap:6px}.ob-words-enter-active{transition:opacity .32s ease .06s,transform .42s var(--ease-out-soft) .06s}.ob-words-leave-active{transition:opacity .18s ease}.ob-words-enter-from{opacity:0;transform:translateY(6px)}.ob-words-leave-to{opacity:0}.ob-title{font-size:16.5px;font-weight:650;letter-spacing:-.015em;color:#fff;line-height:1.3}.ob-text{font-size:13px;line-height:1.55;color:var(--fg-3);text-wrap:pretty}.ob-card.is-wide .ob-title{font-size:19px}.ob-card.is-wide .ob-text{font-size:14px}.ob-note{display:flex;align-items:flex-start;gap:10px;margin-bottom:6px;padding:9px 12px;border-radius:12px;background:linear-gradient(180deg,#37d39921,#37d3990d);border:1px solid rgba(55,211,153,.3);font-size:12.5px;line-height:1.45;color:var(--fg-3)}.ob-note .ob-tick{width:18px;height:18px;margin-top:1px;animation-delay:.2s;animation-fill-mode:both}.ob-note-words{display:flex;flex-direction:column;gap:3px;min-width:0}.ob-note-words b{color:#fff;font-size:13px;font-weight:600}.ob-note .ob-key{min-width:0;height:18px;padding:0 5px;font-size:10.5px;box-shadow:0 1.5px #8e8ea6,0 3px 8px #0000004d}.ob-task{display:flex;align-items:center;gap:10px;min-height:42px;padding:8px 12px;border-radius:12px;background:linear-gradient(180deg,#9968df24,#9968df14);border:1px solid rgba(194,164,236,.22);color:#fff;font-size:13px;font-weight:500;line-height:1.4;transition:background .4s,border-color .4s}.ob-task-words{display:inline}.ob-task.is-shaking{animation:obShake .42s var(--ease-out-soft)}@keyframes obShake{0%,to{transform:translate(0)}20%{transform:translate(-5px)}45%{transform:translate(4px)}70%{transform:translate(-2px)}}.ob-dot{flex:none;width:8px;height:8px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 #ae86e599;animation:obDot 1.6s ease-out infinite}@keyframes obDot{0%{box-shadow:0 0 #ae86e599}to{box-shadow:0 0 0 9px #ae86e500}}.ob-chip{display:inline-flex;align-items:center;height:22px;margin:0 2px;padding:0 9px;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:12px;font-weight:600;vertical-align:1px;box-shadow:0 4px 12px #745aff4d}.ob-key{display:inline-flex;align-items:center;justify-content:center;min-width:24px;height:22px;margin:0 2px;padding:0 7px;border-radius:6px;background:linear-gradient(180deg,#fdfdff,#e4e4ee);color:#11131c;font:650 11.5px var(--font-sans);vertical-align:1px;box-shadow:0 2px #8e8ea6,0 4px 10px #00000059}.ob-key+.ob-key{margin-left:3px}.ob-key.is-on-btn{min-width:0;height:18px;margin-left:8px;padding:0 5px;font-size:11px;background:#ffffff38;color:#fff;box-shadow:none}.ob-card.is-done .ob-task{background:linear-gradient(180deg,#37d39929,#37d39914);border-color:#37d39959}.ob-tick{display:inline-flex;align-items:center;justify-content:center;flex:none;width:20px;height:20px;border-radius:50%;background:var(--success);color:#04130d;animation:obTick .42s var(--ease-out-soft)}@keyframes obTick{0%{transform:scale(.4);opacity:0}to{transform:scale(1);opacity:1}}.ob-spin{flex:none;width:15px;height:15px;border-radius:50%;border:2px solid rgba(255,255,255,.16);border-top-color:var(--amethyst-700);animation:obSpin .8s linear infinite}@keyframes obSpin{to{transform:rotate(360deg)}}.ob-hint{margin-top:-4px;font-size:12px;color:var(--amethyst-800);animation:obHint .35s var(--ease-out-soft)}@keyframes obHint{0%{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}.ob-foot{display:flex;align-items:center;justify-content:space-between;min-height:22px}.ob-foot-acts{display:inline-flex;align-items:center;gap:6px}.ob-steps{display:inline-flex;align-items:center;gap:5px}.ob-steps i{width:6px;height:6px;border-radius:999px;background:#ffffff29;transition:width .4s var(--ease-out-soft),background .4s}.ob-steps i.on{width:20px;background:#c2a4ec99}.ob-steps i.done{background:var(--amethyst-500)}.ob-steps i.on.done{background:var(--success)}.ob-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:36px;padding:0 16px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font:600 13px var(--font-sans);letter-spacing:-.01em;cursor:pointer;box-shadow:0 8px 22px #745aff52,inset 0 1px #fff3;transition:transform .15s var(--ease-out-soft),box-shadow var(--dur-fast),filter var(--dur-fast),opacity var(--dur-fast)}.ob-btn:hover{filter:brightness(1.08);box-shadow:0 10px 28px #745aff73,inset 0 1px #ffffff3d}.ob-btn:active{transform:scale(.97)}.ob-btn:disabled{opacity:.55;cursor:default;filter:none}.ob-btn:focus-visible,.ob-link:focus-visible,.ob-skip:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:3px}.ob-btn.is-big{height:46px;padding:0 24px;font-size:14.5px}.ob-link{display:inline-flex;align-items:center;gap:7px;padding:6px 10px;border:0;border-radius:999px;background:transparent;color:var(--fg-3);font:500 13px var(--font-sans);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast)}.ob-link:hover{color:#fff;background:#ffffff0d}.ob-link:disabled{opacity:.5;cursor:default}.ob-welcome,.ob-finale{position:absolute;left:50%;top:calc(50% + 30px);transform:translate(-50%,-50%);border-radius:26px;background:#070810;box-shadow:0 0 0 1px #ffffff14,0 0 0 1px #9968df24,0 50px 140px #000000b3}.ob-welcome{width:min(760px,calc(100vw - 32px));max-height:calc(100vh - 92px);overflow:hidden;display:flex;flex-direction:column}.ob-welcome:before,.ob-finale:before{content:"";position:absolute;inset:-1px;z-index:2;padding:1px;border-radius:inherit;background:linear-gradient(180deg,#d6c8f257,#ffffff14 34%,#ffffff0a 70%,#ffffff0f);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0);pointer-events:none}.ob-welcome-media{position:relative;flex:none;aspect-ratio:1180 / 540;overflow:hidden;background:#04030c}.ob-welcome-media .bl-hd-win{border-radius:0}.ob-welcome-fade{position:absolute;left:0;right:0;bottom:0;height:90px;z-index:9;background:linear-gradient(180deg,#07081000,#070810);pointer-events:none}.ob-welcome-body{position:relative;z-index:10;display:flex;flex-direction:column;align-items:flex-start;gap:10px;margin-top:-28px;padding:0 36px 32px}.ob-eyebrow{font-size:11px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--amethyst-700)}.ob-welcome-title,.ob-finale-title{margin:0;font-size:30px;font-weight:650;line-height:1.15;letter-spacing:-.025em;color:#fff}.ob-welcome-text{max-width:600px;margin:2px 0 8px;font-size:15px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.ob-welcome-actions{display:flex;align-items:center;gap:16px}.ob-or{font-size:12.5px;color:var(--fg-4)}.ob-own-enter-active{transition:opacity .5s ease,transform .7s var(--ease-out-soft)}.ob-own-leave-active{transition:opacity .3s ease,transform .4s ease}.ob-own-enter-from{opacity:0;transform:translate(-50%,calc(-50% + 18px)) scale(.98)}.ob-own-leave-to{opacity:0;transform:translate(-50%,calc(-50% - 10px)) scale(.985)}.ob-welcome.is-intro{opacity:var(--ob-intro-card, 0)}.ob-welcome.is-intro .ob-welcome-media{opacity:var(--ob-intro-media, 0)}.ob-welcome.is-intro .ob-welcome-title{visibility:hidden}.ob-intro{position:absolute;inset:0;z-index:40;overflow:hidden;cursor:default;user-select:none;-webkit-user-select:none}.ob-intro-leave-active{transition:opacity .32s ease}.ob-intro-leave-to{opacity:0}.ob-intro-dark{position:absolute;inset:0;background:var(--bg-deep)}.ob-intro-loader{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}.ob-intro-stage{position:absolute;left:0;top:0;overflow:hidden;opacity:0;background:#070910;isolation:isolate}.ob-intro-win{position:absolute}.ob-intro-win .bl-hd-win{border-radius:0}.ob-intro-stage .ob-welcome-fade{opacity:0}.ob-intro-scrim{position:absolute;inset:0;pointer-events:none;opacity:0;background:radial-gradient(ellipse 52% 48% at 50% 50%,#04030ce0,#04030c99 58%,#04030c42)}.ob-intro-center{position:absolute;inset:0;z-index:2;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:clamp(22px,3.6vh,40px);padding-bottom:6vh;pointer-events:none}.ob-intro-mark{position:relative;flex:none;width:clamp(84px,9.5vw,148px);aspect-ratio:239 / 173;transform-origin:0 0}.ob-intro-glow{position:absolute;left:50%;top:50%;width:560%;aspect-ratio:1;border-radius:50%;opacity:0;pointer-events:none;background:radial-gradient(closest-side,rgba(153,104,223,.3),rgba(90,97,237,.1) 52%,transparent 100%)}.ob-intro-mark-in{position:absolute;inset:0;perspective:calc(clamp(84px,9.5vw,148px)*3)}.ob-intro-facet{position:absolute;inset:0;width:100%;height:100%;overflow:visible;opacity:0;will-change:transform,opacity,filter}.ob-intro-sheen{position:absolute;inset:0;opacity:0;pointer-events:none;-webkit-mask:var(--mask) center / 100% 100% no-repeat;mask:var(--mask) center / 100% 100% no-repeat;background-image:linear-gradient(105deg,transparent 38%,rgba(255,255,255,.85) 50%,transparent 62%);background-size:320% 100%;background-repeat:no-repeat;mix-blend-mode:screen}.ob-intro-title{position:relative;flex:none;white-space:nowrap;font-size:clamp(32px,4.6vw,66px);font-weight:650;line-height:1.15;letter-spacing:-.025em;color:#fff;transform-origin:0 0;text-shadow:0 2px 34px rgba(4,3,12,calc(.9 * var(--ts, 1)))}.ob-intro-word{display:inline-block;opacity:0}.ob-intro-row{display:flex;align-items:center;margin-top:calc(-1*clamp(8px,1.6vh,18px));opacity:0;white-space:nowrap;font-size:clamp(11px,.95vw,13.5px);font-weight:600;letter-spacing:.26em;text-transform:uppercase}.ob-intro-aspect{display:inline-flex;align-items:center;opacity:0;color:#cbb8f2;transition:color .25s ease}.ob-intro-aspect .sep{width:4px;height:4px;margin:0 1.1em 0 .9em;border-radius:50%;background:#cbb8f280}.ob-intro-skip{position:absolute;right:22px;bottom:20px;z-index:3;display:inline-flex;align-items:center;gap:9px;height:34px;padding:0 10px 0 14px;border:1px solid rgba(255,255,255,.1);border-radius:999px;background:#ffffff0a;color:var(--fg-3);font:500 12.5px var(--font-sans);cursor:pointer;opacity:0;visibility:hidden;transition:color var(--dur-fast),background var(--dur-fast)}.ob-intro-skip:hover{color:#fff;background:#ffffff14}.ob-intro-skip .ob-key{min-width:0;height:18px;margin:0;padding:0 5px;font-size:10.5px;box-shadow:0 1.5px #8e8ea6}.ob-finale{width:min(540px,calc(100vw - 32px));display:flex;flex-direction:column;align-items:center;padding:40px 40px 32px;text-align:center}.ob-finale-mark{position:relative;display:flex;align-items:center;justify-content:center;width:96px;height:96px;margin-bottom:18px}.ob-finale-mark .halo{position:absolute;inset:0;border-radius:50%;background:radial-gradient(circle,rgba(153,104,223,.42),rgba(90,97,237,.12) 55%,transparent 72%);animation:obHalo 3.2s ease-in-out infinite}@keyframes obHalo{0%,to{transform:scale(.92);opacity:.75}50%{transform:scale(1.12);opacity:1}}.ob-finale-mark svg{position:relative;overflow:visible}.ob-finale-mark path{transform-box:fill-box;transform-origin:50% 50%;animation:obFacet .7s var(--ease-out-soft) both;animation-delay:calc(.12s + var(--i) * .09s)}@keyframes obFacet{0%{opacity:0;transform:scale(.4) rotate(-30deg)}to{opacity:1;transform:none}}.ob-finale .ob-finale-text{max-width:420px;margin:12px 0 26px;font-size:14.5px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.ob-learned{display:grid;grid-template-columns:1fr 1fr;gap:8px 10px;width:100%;margin:0 0 26px;padding:0;list-style:none;text-align:left}.ob-learned li{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:12px;background:#ffffff09;border:1px solid var(--hairline-soft);font-size:12.5px;color:var(--fg-2);animation:obLearned .55s var(--ease-out-soft) both;animation-delay:calc(.5s + var(--i) * .14s)}.ob-learned .ob-tick{width:18px;height:18px;animation:obTick .42s var(--ease-out-soft) both;animation-delay:calc(.62s + var(--i) * .14s)}.ob-learned li:last-child:nth-child(odd){grid-column:1 / -1}@keyframes obLearned{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}.ob-finale .ob-finale-error{margin:-12px 0 16px;font-size:12.5px;color:var(--danger)}.ob-finale-actions{display:flex;flex-direction:column;align-items:center;gap:10px}.bd-root .up-ghost.is-tour{white-space:normal;overflow:visible;color:var(--fg-3)}.bd-root .up-cue.is-tour{border:0;font-family:var(--font-sans);pointer-events:auto;cursor:pointer;animation:upIn .4s var(--ease-out-soft) .15s both,obCue 2.2s ease-in-out .6s infinite}.bd-root .up-cue.is-tour:hover{background:#9968df3d}@keyframes obCue{0%,to{box-shadow:0 0 #9968df00}50%{box-shadow:0 0 0 4px #9968df2e}}.bd-root .up-text.is-typing{caret-color:var(--amethyst-700);text-shadow:0 0 16px rgba(194,164,236,.45)}.bd-root .ed-words.is-tour-ghost::placeholder{color:var(--fg-3)}.bd-root .ed-tour-cue{position:static;align-self:flex-start;margin:2px 0 4px}.bd-root .ch-comp-input.is-tour-ghost::placeholder{color:var(--fg-3)}.bd-root .ch-comp-input.is-typing{caret-color:var(--amethyst-700);text-shadow:0 0 16px rgba(194,164,236,.45)}.bd-root .ch-tour-cue{position:static;display:inline-flex;margin:2px 0}.ob-demo{position:absolute;inset:0;overflow:hidden;pointer-events:none}.ob-demo-stage{position:absolute;left:0;top:0;transform-origin:0 0}.ob-demo-canvas{position:absolute;inset:0;background:radial-gradient(60% 80% at 14% 0%,rgba(117,50,211,.18),transparent 70%),radial-gradient(50% 60% at 92% 8%,rgba(90,97,237,.11),transparent 70%),#070910}.ob-demo-canvas:before{content:"";position:absolute;inset:0;background-image:radial-gradient(circle,rgba(255,255,255,.075) 1px,transparent 1.4px);background-size:22px 22px;background-position:11px 11px;background-repeat:repeat}.ob-demo .bl-hd-session{position:absolute}.ob-d-land{position:absolute;inset:0;transform-origin:320px 138px}.ob-d-tag{position:absolute;display:inline-flex;align-items:center;gap:8px;height:28px;padding:0 12px 0 9px;border-radius:999px;background:#121521f0;border:1px solid var(--hairline);color:var(--fg-1);font-size:12.5px;font-weight:500;white-space:nowrap;box-shadow:0 10px 24px #02040c73}.ob-d-tag:before{content:"";position:absolute;left:-20px;top:50%;width:18px;height:1px;background:linear-gradient(90deg,transparent,rgba(194,164,236,.6))}.ob-d-tag i{width:7px;height:7px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 8px var(--amethyst-500)}.ob-demo .bl-hd-add{transition:box-shadow .25s ease,filter .25s ease}.ob-demo .bl-hd-add.is-lit{filter:brightness(1.15);box-shadow:0 0 0 3px #d6c2f280,0 10px 30px #745aff99}.ob-d-dock{transform:none}.ob-d-menu{position:absolute;z-index:3;padding:8px;border-radius:14px;background:#0e101af7;border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff0f,0 24px 60px #02040c99}.ob-d-menu .search{display:flex;align-items:center;gap:6px;height:26px;padding:0 9px;border-radius:8px;background:#ffffff0d;color:var(--fg-4);font-size:10.5px}.ob-d-menu .eyebrow{margin:8px 6px 4px;font-size:8.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-5)}.ob-d-menu .row{display:flex;align-items:center;gap:8px;height:30px;padding:0 8px;border-radius:8px;transition:background .2s ease,box-shadow .2s ease}.ob-d-menu .row.is-lit{background:#9968df33;box-shadow:inset 0 0 0 1px #c2a4ec59}.ob-d-menu .badge{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:6px;background:#ffffff0f;color:var(--fg-2)}.ob-d-menu .main{display:flex;flex-direction:column;min-width:0;line-height:1.15}.ob-d-menu .main b{font-size:10.5px;font-weight:600;color:#fff}.ob-d-menu .main small{font-size:8.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ob-d-prompt{transform-origin:50% 100%}.ob-d-words{position:absolute;left:54px;right:92px;top:16px;font-size:15px;line-height:22px;letter-spacing:-.005em;color:#fff;white-space:normal}.ob-d-prompt.is-big .ob-d-words{right:22px;top:20px;font-size:17px;line-height:26px}.ob-d-words .ph{color:var(--fg-4)}.ob-d-words .ghost{position:absolute;left:0;top:0;right:0;color:var(--fg-4)}.ob-d-words .caret{display:inline-block;width:1.5px;height:18px;margin-left:1px;vertical-align:-3px;border-radius:1px;background:var(--amethyst-700)}.ob-d-prompt.is-big .ob-d-words .caret{height:21px}.ob-d-words .typed{text-shadow:0 0 14px rgba(194,164,236,.35)}.ob-d-cue{position:absolute;left:54px;top:78px;display:inline-flex;align-items:center;gap:6px;padding:3px 10px 3px 4px;border-radius:999px;background:#9968df29;color:var(--amethyst-800);font-size:11.5px}.ob-d-cue kbd{padding:1px 7px;border-radius:5px;background:#ffffff29;color:#fff;font:600 10.5px var(--font-sans)}.ob-d-pill{position:absolute;top:10px;right:12px;display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 11px 0 9px;border-radius:999px;background:#9968df29;border:1px solid rgba(194,164,236,.3);color:#e9dcff;font-size:11.5px;font-weight:600;transition:background .25s,box-shadow .25s}.ob-d-pill.is-lit{background:#9968df57;box-shadow:0 0 0 3px #9968df38,0 0 20px #9968df80}.ob-d-keycap{position:absolute;display:flex;align-items:flex-end;justify-content:space-between;padding:0 12px 8px;border-radius:11px;background:linear-gradient(180deg,#fdfdff,#e5e5ee);color:#11131c;font-size:15px;font-weight:650;box-shadow:0 5px #8e8ea6,0 14px 30px #00000080;transition:transform .1s ease-out,box-shadow .1s ease-out}.ob-d-keycap i{font-style:normal;font-size:18px;line-height:1;color:#4a4c5e}.ob-d-keycap.is-down{box-shadow:0 1px #8e8ea6,0 6px 14px #00000073,0 0 0 4px #9968df73;margin-top:4px}.ob-d-gallery{position:absolute;padding:10px;border-radius:14px;background:#0b0d15f7;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99}.ob-d-gallery .head{display:flex;align-items:center;gap:7px;height:30px;font-size:10.5px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--fg-4)}.ob-d-gallery .head b{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;border-radius:999px;background:#ffffff14;color:#fff;font-size:10px;letter-spacing:0}.ob-d-gallery .grid{display:grid;grid-template-columns:1fr 1fr;gap:6px}.ob-d-gallery .cell{aspect-ratio:3 / 4;border-radius:8px;overflow:hidden;background:#ffffff0a;transition:opacity .2s}.ob-d-gallery .cell.is-lifted{opacity:.35}.ob-d-slot{position:absolute;border:1.5px dashed rgba(214,194,242,.7);border-radius:12px;background:#9968df1a}.ob-d-placed{position:absolute;border-radius:10px;overflow:hidden;box-shadow:0 22px 50px #0000008c,0 0 0 1px #ffffff14}.ob-d-ghost{width:52px;height:70px}.ob-d-pointer .ob-d-brush{display:block;width:18px;height:18px;margin:-9px 0 0 -9px;border-radius:50%;border:2px solid #fff;background:#ae86e540;box-shadow:0 0 0 1px #0006,0 2px 8px #0006}.ob-d-studio-wrap{position:absolute;inset:0;z-index:4;overflow:hidden;box-shadow:0 30px 80px #0009}.ob-d-studio{position:absolute;inset:0;background:#090b12}.ob-d-studio .top{position:absolute;left:0;right:0;top:0;height:26px;display:flex;align-items:center;gap:9px;padding:0 10px;border-bottom:1px solid var(--hairline-soft);color:var(--fg-3);font-size:10.5px}.ob-d-studio .top .back,.ob-d-studio .top .x{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:6px;background:#ffffff0d}.ob-d-studio .top .x{margin-left:auto}.ob-d-studio .top .crumb{color:#fff;font-weight:600}.ob-d-studio .top .crumb small{margin-right:6px;font-size:8px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ob-d-studio .top .chip{display:inline-flex;align-items:center;gap:4px;height:16px;padding:0 7px;border-radius:999px;border:1px solid rgba(194,164,236,.3);color:var(--amethyst-800);font-size:9px}.ob-d-studio .tools,.ob-d-studio .hist{position:absolute;top:34px;width:132px;height:316px;padding:8px;border-radius:12px;background:#121521d9;border:1px solid var(--hairline-soft)}.ob-d-studio .tools{left:10px}.ob-d-studio .hist{left:498px;display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:min-content;gap:5px}.ob-d-studio .tabs{display:flex;padding:3px;margin-bottom:6px;border-radius:9px;background:#ffffff0a}.ob-d-studio .tabs span{flex:1;padding:5px 0;border-radius:7px;text-align:center;font-size:10.5px;font-weight:600;color:var(--fg-3)}.ob-d-studio .tabs span.on{background:#9968df4d;color:#fff}.ob-d-studio .row{display:flex;align-items:center;gap:7px;margin-top:3px;padding:7px 8px;border-radius:8px;font-size:10.5px;color:var(--fg-3)}.ob-d-studio .row.on{background:#ffffff0d;color:#fff}.ob-d-studio .row .licon{color:var(--fg-4)}.ob-d-studio .row.on .licon{color:var(--amethyst-700)}.ob-d-studio .versions{position:absolute;left:230px;top:38px;z-index:3;display:flex;gap:5px}.ob-d-studio .versions .v{width:24px;height:32px;border-radius:5px;overflow:hidden;border:1.5px solid rgba(255,255,255,.18);box-shadow:0 4px 10px #00000080}.ob-d-studio .versions .v.is-new{border-color:var(--amethyst-600);animation:obTick .4s var(--ease-out-soft)}.ob-d-studio .stage{position:absolute;left:222px;top:30px;width:196px;height:262px;border-radius:12px;overflow:hidden;box-shadow:0 20px 50px #0000008c,0 0 0 1px #ffffff12;transform-origin:50% 50%}.ob-d-studio .stage img{position:absolute;inset:0}.ob-d-studio .stage .seam{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 14px 3px #c2a4ecd9}.ob-d-studio .stage.is-busy:after{content:"";position:absolute;inset:0;background:linear-gradient(105deg,transparent 30%,rgba(255,255,255,.18) 50%,transparent 70%);background-size:250% 100%;animation:obShimmer 1.1s linear infinite}@keyframes obShimmer{0%{background-position:120% 0}to{background-position:-120% 0}}.ob-d-studio .hist .h{aspect-ratio:3 / 4;border-radius:6px;overflow:hidden}.ob-d-paint{position:absolute;left:0;top:0;z-index:3;overflow:visible;mix-blend-mode:screen}.ob-d-editbar{position:absolute;z-index:3;display:flex;align-items:center;gap:8px;padding:0 8px 0 14px;border-radius:14px;background:#0b0d15fa;border:1px solid var(--hairline);box-shadow:0 20px 50px #02040c99}.ob-d-editbar .words{flex:1;min-width:0;font-size:12px;color:#fff;white-space:nowrap;overflow:hidden}.ob-d-editbar .ph{color:var(--fg-4)}.ob-d-editbar .run{display:inline-flex;align-items:center;justify-content:center;width:54px;height:28px;border-radius:999px;background:#ffffff12;color:var(--fg-4);font-size:11.5px;font-weight:600;transition:background .3s,color .3s}.ob-d-editbar .run.is-lit{background:var(--grad-cta);color:#fff;box-shadow:0 6px 16px #745aff59}.ob-d-editbar .run.is-busy{opacity:.75}.ob-d-world{position:absolute;inset:0;transform-origin:320px 170px}.ob-d-frame{position:absolute;border:1px solid rgba(255,255,255,.16);border-radius:14px;background:#ffffff06}.ob-d-frame:not(.is-drawn){border-style:dashed;border-color:#d6c2f2bf;background:#9968df0f}.ob-d-frame .title{position:absolute;left:2px;top:-24px;font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--fg-2);white-space:nowrap}.ob-d-note{z-index:2}.ob-d-note .text{font-size:12.5px}.ob-d-pin{position:absolute;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;margin:-28px 0 0;border-radius:50% 50% 50% 4px;background:linear-gradient(135deg,#e07bb3,#9968df);color:#fff;font-size:10px;font-weight:700;box-shadow:0 0 0 2px #070910,0 8px 20px #00000073;transform-origin:0 100%}.ob-d-bubble{position:absolute;z-index:3;margin-top:-28px;padding:6px 11px;border-radius:10px 10px 10px 3px;background:#121521f7;border:1px solid var(--hairline);color:#fff;font-size:11.5px;white-space:nowrap;box-shadow:0 10px 26px #00000073}.ob-d-chatframe{box-shadow:0 0 0 calc(2px * var(--sel, 0)) rgba(174,134,229,calc(.9 * var(--sel, 0))),0 0 0 calc(1.5px * var(--glow, 0)) rgba(194,164,236,calc(.85 * var(--glow, 0))),0 0 calc(26px * var(--glow, 0)) rgba(153,104,223,calc(.55 * var(--glow, 0)))}.ob-d-finished{z-index:1;box-shadow:0 14px 40px #02040c73,0 0 0 1px #c2a4ec59}.ob-d-chatcard{position:absolute;display:flex;flex-direction:column;gap:7px;padding:9px 10px;border-radius:11px;background:#121521f0;border:1px solid rgba(194,164,236,.4);box-shadow:0 12px 30px #00000073;transform-origin:0 0}.ob-d-chatcard .head{display:flex;align-items:center;gap:6px;font-size:10.5px;font-weight:600;color:#fff}.ob-d-chatcard .line{height:5px;border-radius:3px;background:#ffffff1a}.ob-d-chatcard .line.is-short{width:62%}.ob-d-chatcard .mark,.ob-d-chat .head .mark{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:6px;background:var(--grad-cta);color:#fff}.ob-d-ctxbar{position:absolute;z-index:3;display:flex;align-items:center;gap:6px;padding:0 5px;border-radius:10px;background:#0e101af7;border:1px solid var(--hairline);box-shadow:0 10px 26px #00000073}.ob-d-ctxbar .chat{display:inline-flex;align-items:center;justify-content:center;gap:4px;width:56px;height:20px;border-radius:6px;color:#fff;font-size:10px;font-weight:600;transition:background .2s}.ob-d-ctxbar .chat.is-lit{background:#9968df61;box-shadow:0 0 0 3px #9968df38}.ob-d-ctxbar .ic{width:14px;height:14px;border-radius:4px;background:#ffffff14}.ob-d-chat{position:absolute;z-index:2;border-radius:14px;background:#0b0d15fa;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99}.ob-d-chat>*{position:absolute}.ob-d-chat .head{left:0;right:0;top:0;display:flex;align-items:center;gap:8px;height:38px;padding:0 10px;border-bottom:1px solid var(--hairline-soft)}.ob-d-chat .head .t{display:flex;flex-direction:column;line-height:1.25}.ob-d-chat .head b{font-size:10.5px;color:#fff}.ob-d-chat .head small{font-size:8.5px;color:var(--fg-4)}.ob-d-chat .bubble{box-sizing:border-box;padding:6px 9px;border-radius:11px 11px 3px;background:#9968df4d;color:#fff;font-size:9.5px;line-height:1.35}.ob-d-chat .answer{display:flex;gap:7px}.ob-d-chat .answer .ai{display:inline-flex;align-items:center;justify-content:center;flex:none;width:16px;height:16px;border-radius:50%;background:#9968df52;color:var(--amethyst-800)}.ob-d-chat .answer .ai.is-busy{animation:obCue 1s ease-in-out infinite}.ob-d-chat .answer .lines{flex:1;display:flex;flex-direction:column;gap:6px;padding-top:3px}.ob-d-chat .answer .lines i{display:block;height:5px;border-radius:3px;background:#ffffff29}.ob-d-chat .plan{box-sizing:border-box;display:flex;flex-direction:column;gap:4px;padding:9px 10px;border-radius:11px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.ob-d-chat .plan .eyebrow{font-size:7.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.ob-d-chat .plan .ttl{font-size:11px;font-weight:600;color:#fff}.ob-d-chat .plan .sess{display:inline-flex;align-items:center;gap:5px;font-size:9px;color:var(--fg-3)}.ob-d-chat .run{z-index:1;display:inline-flex;align-items:center;justify-content:center;gap:4px;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:9.5px;font-weight:600;box-shadow:0 6px 16px #745aff59;transition:box-shadow .25s,background .3s}.ob-d-chat .run.is-lit{box-shadow:0 0 0 3px #d6c2f280,0 8px 22px #745aff99}.ob-d-chat .run.is-busy{opacity:.8}.ob-d-chat .run.is-done{background:#2ecc8a2e;color:#7fe3b4;box-shadow:none}.ob-d-chat .composer{box-sizing:border-box;padding:8px 34px 8px 10px;border-radius:11px;background:#ffffff09;border:1px solid var(--hairline-soft)}.ob-d-chat .composer .words{display:block;font-size:9.5px;line-height:1.4;color:#fff}.ob-d-chat .composer .ph{color:var(--fg-4)}.ob-d-chat .composer .typed{text-shadow:0 0 14px rgba(194,164,236,.35)}.ob-d-chat .send{display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:#ffffff14;color:var(--fg-4);transition:background .25s,color .25s}.ob-d-chat .send.is-lit{background:var(--grad-cta);color:#fff;box-shadow:0 4px 12px #745aff73}@media(max-width:900px){.ob-chapters li .l{display:none}.ob-chapters li.on .l{display:inline}.ob-head-name{display:none}}@media(max-width:640px){.ob-card{width:calc(100vw - 32px)}.ob-welcome-title,.ob-finale-title{font-size:24px}.ob-welcome-body{padding:0 22px 24px}.ob-learned{grid-template-columns:1fr}}@media(prefers-reduced-motion:reduce){.ob-ring,.ob-ring:after,.ob-slot,.ob-arc path,.ob-dot,.ob-finale-mark .halo,.ob-finale-mark path,.ob-learned li,.ob-learned .ob-tick,.bd-root .up-cue.is-tour{animation:none}.ob-card,.ob-own-enter-active,.ob-own-leave-active,.ob-card-enter-active,.ob-card-leave-active,.ob-media-enter-active,.ob-media-leave-active,.ob-words-enter-active,.ob-words-leave-active{transition:none}}';
let op = 0, Mo = null;
function sze() {
  return op++, Mo || (Mo = document.createElement("style"), Mo.setAttribute("data-rd-board-tour", ""), Mo.textContent = [nze, ize].join(`
`), document.head.appendChild(Mo)), () => {
    op = Math.max(0, op - 1), !op && Mo && (Mo.remove(), Mo = null);
  };
}
const oze = 25e3;
function x$e(n, e) {
  const t = YA(), i = sze(), s = QA(), o = e.user || { uid: "local", name: "You", email: "" }, r = { ...o, initials: ga(o.name || o.email || "You") }, a = new Sx(null, { uid: r.uid, email: r.email }), l = new tze(Hf);
  let d = 0;
  const c = () => {
    const T = "tour-practice-" + Date.now().toString(36) + "-" + ++d;
    return a.addSeeded(T, ORe()), T;
  }, h = /* @__PURE__ */ W(c()), f = /* @__PURE__ */ W(!1), p = /* @__PURE__ */ W(""), y = new YRe({
    reason: e.reason,
    canSkip: e.canSkip || e.reason === "replay",
    board: e.board || null,
    gen: l,
    onProgress: e.onProgress,
    onExit: (T) => {
      f.value || (f.value = !0, p.value = "", Promise.resolve().then(() => e.onExit(T)).catch((k) => {
        f.value = !1, p.value = k instanceof Error && k.message || "Something went wrong. Please try again.";
      }));
    },
    restart: () => {
      const T = h.value;
      y.reset(), l.reset(), h.value = c(), T && a.remove(T);
    },
    reducedMotion: Cx(),
    timing: e.timing,
    // a host's own dialogs, outside the tour's element, keep their clicks and keys
    scope: () => n
  }), v = {
    directory: a,
    user: r,
    catalog: /* @__PURE__ */ qe(eP()),
    gen: l,
    boardId: h,
    ready: /* @__PURE__ */ W(!0),
    onController: (T) => {
      y.attach(T), e.onController && e.onController(T, y);
    },
    // the tour's bar covers the board's: nothing leaves through it
    openBoard: () => {
    },
    home: () => {
    },
    library: null,
    labels: e.labels
  };
  let x = !1;
  const w = (T) => {
    x || y.isStarted || (x = !0, console.error("[tour] the practice board did not open:", T), Promise.resolve().then(() => e.onExit("failed")).catch((k) => console.error("[tour]", k)));
  }, S = window.setTimeout(() => w("it took too long"), e.startWithin || oze), M = Ee(() => y.board.value && y.board.value.loadError.value, (T) => {
    T && w(T);
  }), _ = i6(zRe, { env: v, tour: y, busy: f, error: p });
  return _.config.errorHandler = (T) => console.error("[tour]", T), _.mount(n), document.body.classList.add("bd-open"), {
    unmount() {
      clearTimeout(S), M(), y.dispose(), _.unmount(), document.body.classList.remove("bd-open"), s(), i(), t();
    }
  };
}
var rze = { version: "0.1.0", commit: "a1ece6b46" };
function aze(n) {
  if (!n) return null;
  const e = Number(n.x), t = Number(n.y), i = Number(n.z);
  return !Number.isFinite(e) || !Number.isFinite(t) || !Number.isFinite(i) || i <= 0 ? null : { x: e, y: t, zoom: i };
}
function lze(n, e) {
  const t = YA(), i = QA(), s = e.user || { uid: "local", name: "You", email: "" }, o = { ...s, initials: ga(s.name || s.email || "You") };
  let r = null;
  const a = /* @__PURE__ */ W(e.boardId), l = /* @__PURE__ */ qe(eP()), d = dS(), c = new ene(d, HW());
  let h, f, p, y, v = null;
  const x = /* @__PURE__ */ W(!0);
  if (e.directory)
    h = e.directory;
  else if (e.firebase) {
    const R = e.firebase, D = Promise.resolve().then(() => Ax), O = [];
    let F = null, ie = null;
    x.value = !1, D.then((me) => {
      ie = me, F = new me.RunnitCanvasDirectory(R, o);
      for (const L of O) L(F);
      x.value = !0, v = () => {
        me.loadToolCatalog(R, o, { isBlocked: e.isToolBlocked }).then((L) => {
          L && L.kits.length && (l.value = L);
        }).catch((L) => console.warn("[board] live tool catalog unavailable, using the demo catalog", L));
      }, v();
    });
    const ee = () => F ? Promise.resolve(F) : new Promise((me) => O.push(me));
    h = {
      list: () => ee().then((me) => me.list()),
      create: (me, L) => ee().then((N) => N.create(me, L)),
      rename: (me, L) => ee().then((N) => N.rename(me, L)),
      open: (me) => {
        if (F) return F.open(me);
        throw new Error("Board storage is still starting");
      }
    }, p = (me) => ie ? ie.boardServices(R, o, me, { isBlocked: e.isToolBlocked }) : null, y = (me, L) => ie ? ie.commentStore(R, o, me, L) : null, f = () => ({
      upload: (me) => D.then((L) => L.uploadFile(R, o, me)).then((L) => L.url),
      uploadRecord: (me) => D.then((L) => L.uploadFile(R, o, me)),
      uploadVideo: R.uploadVideo
    });
  } else
    h = new Sx(null, { uid: o.uid, email: o.email });
  const w = e.comments;
  !y && w && (y = (R, D) => new uAe({ db: w.db, me: { uid: o.uid, name: o.name, email: o.email }, boardId: R, board: D, people: w.people }));
  const S = (R) => {
    const D = e.stress;
    if (D) {
      D.rebuild(R || D.images.value);
      return;
    }
    const O = R ? "?images=" + R : "";
    e.navigate ? e.navigate("/board/stress" + O) : location.assign("/stress.html" + O);
  }, M = e.feedback || {};
  let _ = null;
  M.enabled !== !1 && !e.stress && (_ = new nAe(), _.captureConsole());
  const T = M.sink || (e.firebase ? lAe(e.firebase) : new oAe()), k = e.stress ? "in memory (the stress page, never saved)" : e.backend ? e.backend : e.firebase ? "Firebase project " + (e.firebase.db.app.options.projectId || "unknown") : e.directory ? "this browser (the harness)" : "in memory", P = {
    directory: h,
    user: o,
    catalog: l,
    gen: c,
    boardId: a,
    ready: x,
    // the open board's controller: the host's refreshTokenAccess reaches it (and the harness and tests get it too)
    onController: (R) => {
      r = R, e.onController && e.onController(R);
    },
    openBoard: (R) => {
      e.openBoard ? e.openBoard(R) : a.value = R;
    },
    home: () => {
      e.navigate && e.navigate("/runnit/home");
    },
    uploaderFor: f || (() => ({
      // harness: the image (or video) lives as long as the page
      upload: (R) => Promise.resolve(URL.createObjectURL(R)),
      uploadVideo: (R) => Promise.resolve({ url: URL.createObjectURL(R) })
    })),
    servicesFor: p,
    studio: {
      babylon: e.babylon,
      upload3d: e.firebase && e.firebase.upload3d ? e.firebase.upload3d : void 0,
      uploadMask: e.firebase && e.firebase.uploadMask ? e.firebase.uploadMask : void 0
    },
    // without real services (the harness, tests), a Library of the demo's pictures
    library: e.firebase ? null : new JIe(),
    storageUrl: e.firebase ? e.firebase.storageUrl : void 0,
    openRunnit: (R) => {
      e.navigate && e.navigate("/runnit/" + R);
    },
    getTokens: e.getTokens,
    canBuyTokens: e.canBuyTokens,
    openTour: e.openTour,
    track: e.track,
    initialCamera: aze(e.initialQuery),
    onCameraSettled: (R) => {
      e.replaceQuery && e.replaceQuery({ x: String(Math.round(R.x)), y: String(Math.round(R.y)), z: String(Math.round(R.zoom * 1e3) / 1e3) });
    },
    // ?studio= keeps the Studios view's session, so a refresh comes back to it (CHAT-07)
    initialStudio: e.initialQuery && typeof e.initialQuery.studio == "string" ? e.initialQuery.studio : null,
    onStudio: (R) => {
      e.replaceQuery && e.replaceQuery({ studio: R || void 0 });
    },
    onTitle: (R) => {
      e.onTitle ? e.onTitle(R) : document.title = R + " | RunDiffusion";
    },
    showStats: P1,
    openStress: S,
    backend: k,
    stress: e.stress,
    featured: e.featuredPrompts ? { load: e.featuredPrompts } : void 0,
    myPrompts: e.promptShelf,
    labels: e.labels,
    feedback: _ ? { recorder: _, sink: T, build: rze } : void 0,
    commentsFor: y,
    commentLink: e.commentLink || ((R, D) => location.origin + "/board/" + R + "?comment=" + encodeURIComponent(D)),
    initialComment: e.initialQuery && typeof e.initialQuery.comment == "string" ? e.initialQuery.comment : null,
    clearCommentLink: () => {
      e.replaceQuery && e.replaceQuery({ comment: void 0 });
    },
    agent: e.agent || null,
    boardsApi: e.firebase && e.firebase.api || null
  }, A = i6(KA, { env: P });
  return A.config.errorHandler = (R) => console.error("[board]", R), A.mount(n), document.body.classList.add("bd-open"), {
    setBoardId(R) {
      a.value !== R && (a.value = R);
    },
    refreshTools() {
      v && v();
    },
    refreshTokenAccess() {
      r && r.refreshTokenAccess();
    },
    unmount() {
      A.unmount(), _ && _.dispose(), document.body.classList.remove("bd-open"), i(), t();
    }
  };
}
async function w$e(n, e, t) {
  const i = await Promise.resolve().then(() => Ax), s = { ...e, initials: ga(e.name || e.email || "You") };
  return (await new i.RunnitCanvasDirectory(n, s).create(t, "blank")).id;
}
async function k$e(n, e, t = {}) {
  const i = await Promise.resolve().then(() => Ax), s = { ...e, initials: ga(e.name || e.email || "You") }, o = new i.RunnitCanvasDirectory(n, s);
  if (!t.fresh) {
    const a = await o.findOwn("Bonneville Tower");
    if (a) return a.id;
  }
  return (await o.create("Bonneville Tower", "demo")).id;
}
function _$e(n, e = {}) {
  const t = new Sx(null), i = /* @__PURE__ */ W(Y4(e.images));
  let s = t.ensureTiledDemo(i.value), o = null;
  const r = {
    images: i,
    layout: /* @__PURE__ */ qe(uk(i.value)),
    collapsed: /* @__PURE__ */ W(!1),
    tab: /* @__PURE__ */ W("board"),
    reports: /* @__PURE__ */ new Map(),
    rebuild(a) {
      const l = Y4(a);
      if (l === i.value || !o) return;
      const d = s;
      s = t.ensureTiledDemo(l), i.value = l, r.layout.value = uk(l), o.setBoardId(s), t.remove(d), e.onImages && e.onImages(l);
    }
  };
  return o = lze(n, {
    boardId: s,
    directory: t,
    user: e.user,
    navigate: e.navigate,
    onController: e.onController,
    openBoard: (a) => {
      a && o ? o.setBoardId(a) : !a && e.onIndex && e.onIndex();
    },
    showStats: !0,
    stress: r
  }), o;
}
ht.add(EY);
ht.mixin(mn, RY);
ht.add(jM);
ht.add(HM);
ht.mixin(mn, hZ);
ht.add(YM, qM);
ht.add(KM);
const dze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), cze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var uze = Object.defineProperty, hze = (n, e, t) => e in n ? uze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Yt = (n, e, t) => hze(n, typeof e != "symbol" ? e + "" : e, t);
const r1 = 450, pze = 500, ic = "CANVAS";
class rp extends Error {
  constructor(e, t, i) {
    super(e), Yt(this, "kind", t), Yt(this, "runnitType", i);
  }
}
function qf(n, e) {
  return {
    id: n,
    title: e.title || "Untitled board",
    ownerId: e.userId,
    teamId: e.teamId || null,
    description: e.description || "",
    accessLevel: e.accessLevel || null,
    createdAt: gn(e.createdAt)
  };
}
class fze {
  constructor(e, t) {
    Yt(this, "fb", e), Yt(this, "user", t);
  }
  /** Your personal canvas boards, and your team's: the Dev chip's links to your demo boards (the real list is src/list). */
  async list() {
    const e = this.fb.db.collection("runnits"), t = [
      e.where("userId", "==", this.user.uid).where("type", "==", ic).where("deletedAt", "==", null).where("teamId", "==", null)
    ];
    this.user.teamId && t.push(e.where("teamId", "==", this.user.teamId).where("type", "==", ic).where("deletedAt", "==", null));
    const i = await Promise.all(t.map((o) => o.limit(200).get())), s = [];
    for (const o of i)
      for (const r of o.docs) s.push(qf(r.id, r.data()));
    return s.sort((o, r) => (r.createdAt || 0) - (o.createdAt || 0));
  }
  /**
   * One board by id (B33's links): null when it's deleted, isn't a canvas
   * board, or the rules refuse you it. Each link is looked up on its own, so
   * none is taken for gone because a listing stopped short of it.
   */
  async get(e) {
    try {
      const t = await this.fb.db.collection("runnits").doc(e).get();
      if (!t.exists) return null;
      const i = t.data();
      return i.type !== ic || i.deletedAt ? null : qf(e, i);
    } catch (t) {
      if ((t && typeof t == "object" && "code" in t ? String(t.code) : "") === "permission-denied") return null;
      throw t;
    }
  }
  /**
   * Your own board by this title in the account you're working in (the
   * newest), or null: the admins' demo board reopens rather than coming again
   * every time (IL-100).
   */
  async findOwn(e) {
    const t = this.user.teamId || null;
    return (await this.list()).filter((s) => s.ownerId === this.user.uid && (s.teamId || null) === t && s.title === e)[0] || null;
  }
  /** A canvas board in the team you're working in (or a personal one), as v1's create path writes a runnit. */
  async create(e, t = "blank") {
    const i = this.fb.FieldValue, s = t === "demo" ? Kl() : null, o = this.user.teamId || null, r = {
      createdAt: i.serverTimestamp(),
      deletedAt: null,
      userId: this.user.uid,
      teamId: o,
      type: ic,
      accessLevel: "PRIVATE",
      title: s ? s.title : e,
      description: "",
      avatarId: null,
      avatar: null
    }, a = await this.fb.db.collection("runnits").add(r);
    return s && await mze(this.fb, this.user, a, s.elements), { id: a.id, title: r.title, ownerId: this.user.uid, teamId: o, createdAt: Date.now() };
  }
  async rename(e, t) {
    await this.fb.db.collection("runnits").doc(e).update({ title: t });
  }
  open(e) {
    return new gze(this.fb, this.user, e);
  }
}
async function mze(n, e, t, i) {
  const s = new B8(), o = t.collection("runnitCanvasElements"), r = Date.now(), a = /* @__PURE__ */ new Map();
  for (const c of i) {
    const h = wp(c, e.uid, r), f = s.place(c.id, zl(h), () => o.doc().id);
    a.has(f) || a.set(f, {}), a.get(f)[c.id] = h;
  }
  let l = n.db.batch(), d = 0;
  for (const [c, h] of a)
    l.set(o.doc(c), { v: $8, elements: h, updatedBy: e.uid, updatedAt: n.FieldValue.serverTimestamp() }), ++d >= r1 && (await l.commit(), l = n.db.batch(), d = 0);
  d && await l.commit();
}
class gze {
  constructor(e, t, i) {
    Yt(this, "fb", e), Yt(this, "user", t), Yt(this, "boardId", i), Yt(this, "status", /* @__PURE__ */ W("saved")), Yt(this, "index", new B8()), Yt(this, "known", /* @__PURE__ */ new Map()), Yt(this, "idsIn", /* @__PURE__ */ new Map()), Yt(this, "serverBuckets", /* @__PURE__ */ new Set()), Yt(this, "latest", /* @__PURE__ */ new Map()), Yt(this, "hints", /* @__PURE__ */ new Map()), Yt(this, "queue", /* @__PURE__ */ new Map()), Yt(this, "onRemote", null), Yt(this, "unsubs", []), Yt(this, "timer", 0), Yt(this, "flushing", null), Yt(this, "retry", 0), Yt(this, "loaded", !1), Yt(this, "disposed", !1), Yt(this, "abortLoad", null), Yt(this, "meta", null), Yt(this, "onlineHandler", () => this.updateOnline()), window.addEventListener("online", this.onlineHandler), window.addEventListener("offline", this.onlineHandler), this.updateOnline();
  }
  runnitRef() {
    return this.fb.db.collection("runnits").doc(this.boardId);
  }
  bucketRef(e) {
    return this.runnitRef().collection("runnitCanvasElements").doc(e);
  }
  updateOnline() {
    navigator.onLine ? this.status.value === "offline" && (this.status.value = this.queue.size ? "saving" : "saved") : this.status.value = "offline";
  }
  async load() {
    let e;
    try {
      e = await this.runnitRef().get();
    } catch (s) {
      throw Wo(s) === "permission-denied" ? new rp("This board doesn't exist, or you don't have access to it.", "missing") : s;
    }
    if (this.disposed) throw new Error("The board was closed while it loaded.");
    if (!e.exists) throw new rp("This board doesn't exist, or you don't have access to it.", "missing");
    const t = e.data();
    if (t.type !== ic) throw new rp("It was made in Boards, before canvas boards, and it opens there.", "not-canvas", t.type);
    if (t.deletedAt) throw new rp("This board was deleted.", "deleted");
    this.meta = qf(this.boardId, t);
    const i = await new Promise((s, o) => {
      this.abortLoad = o;
      const r = this.runnitRef().collection("runnitCanvasElements").onSnapshot(
        (a) => {
          this.loaded ? this.nextSnapshot(a) : (this.loaded = !0, s(this.firstSnapshot(a)));
        },
        (a) => {
          console.error("[board] contents listener failed", a), this.loaded ? this.status.value = "error" : o(a);
        }
      );
      this.keep(r);
    });
    return this.abortLoad = null, this.keep(this.runnitRef().onSnapshot((s) => {
      if (!this.onRemote || s.metadata.hasPendingWrites || !s.exists) return;
      const o = s.data();
      this.meta = qf(this.boardId, o), this.onRemote({ upserted: [], removed: [], meta: { ...this.meta, deleted: !!o.deletedAt } });
    }, () => {
    })), { meta: { ...this.meta }, elements: i, results: jW(i) };
  }
  firstSnapshot(e) {
    const t = [];
    for (const i of e.docs) {
      const s = this.readBucket(i);
      t.push(...qw(this.known, this.idsOf(i.id), s).upserted);
    }
    return t;
  }
  nextSnapshot(e) {
    if (!this.onRemote) return;
    const t = [], i = [];
    let s = !1;
    const o = new Set(this.queue.keys());
    for (const r of e.docChanges()) {
      if (r.doc.metadata.hasPendingWrites) continue;
      const a = r.type === "removed" ? {} : this.readBucket(r.doc), l = qw(this.known, this.idsOf(r.doc.id), a, o);
      t.push(...l.upserted), i.push(...l.removed), l.trash && (s = !0);
    }
    (t.length || i.length || s) && this.onRemote({ upserted: t, removed: i, trash: s || void 0 });
  }
  readBucket(e) {
    const t = e.data(), i = t.elements || {};
    return this.serverBuckets.add(e.id), this.latest.set(e.id, i), this.hints.set(e.id, gn(t.hardDeleteAt) || null), this.index.setBucket(e.id, i), i;
  }
  idsOf(e) {
    let t = this.idsIn.get(e);
    return t || (t = /* @__PURE__ */ new Set(), this.idsIn.set(e, t)), t;
  }
  watch(e) {
    this.onRemote = e;
  }
  enqueue(e, t, i) {
    const s = this.queue.get(e);
    this.queue.set(e, { op: Ku(s ? s.op : void 0, t), full: i || (s ? s.full : null) });
  }
  commit(e) {
    const t = Date.now(), i = this.user.uid;
    for (const s of e.added) {
      const o = wp(s, i, t);
      this.index.place(s.id, zl(o), () => this.newBucketId()), this.enqueue(s.id, { kind: "put", data: o }, s);
    }
    for (const s of e.updated) {
      const o = {};
      for (const [r, a] of Object.entries(s.after)) o[r] = a === void 0 ? void 0 : rf(a);
      o.updatedBy = i, o.updatedAt = t, this.enqueue(s.id, { kind: "patch", fields: o }, s.el);
    }
    for (const s of e.removed)
      this.enqueue(s.id, { kind: "patch", fields: TG(i, this.user.email, t) }, s);
    this.schedule();
  }
  /** An element as the server will have it once the queue is saved. */
  pending(e) {
    const t = this.known.get(e), i = this.queue.get(e);
    if (!i) return t;
    let s = i.op;
    return s.kind === "patch" && !t && i.full && (s = Ku({ kind: "put", data: wp(i.full, this.user.uid, Date.now()) }, s)), ug(t, s);
  }
  trash() {
    const e = Date.now(), t = [], i = new Set(this.known.keys());
    for (const s of this.queue.keys()) i.add(s);
    for (const s of i) {
      const o = IG(s, this.pending(s), e);
      o && t.push(o);
    }
    return t.sort((s, o) => o.deletedAt - s.deletedAt);
  }
  purge(e) {
    for (const t of e)
      this.index.bucketOf(t) && this.enqueue(t, { kind: "delete" }, null);
    this.schedule();
  }
  commitResults() {
  }
  saveMeta(e) {
    const t = {};
    e.title !== void 0 && (t.title = e.title), e.description !== void 0 && (t.description = e.description), Object.keys(t).length && this.runnitRef().update(t).catch((i) => {
      console.error("[board] board details not saved", i), this.onRemote && this.meta && this.onRemote({ upserted: [], removed: [], meta: { ...this.meta, refused: Wo(i) === "permission-denied" ? "owner" : "error" } });
    });
  }
  newBucketId() {
    return this.runnitRef().collection("runnitCanvasElements").doc().id;
  }
  schedule() {
    this.status.value !== "offline" && (this.status.value = "saving"), clearTimeout(this.timer), this.timer = window.setTimeout(() => {
      this.flush().catch(() => {
      });
    }, pze);
  }
  async flush() {
    if (clearTimeout(this.timer), this.flushing && (await this.flushing, !this.queue.size))
      return;
    if (!this.queue.size) {
      this.status.value === "saving" && (this.status.value = "saved");
      return;
    }
    const e = this.queue;
    return this.queue = /* @__PURE__ */ new Map(), this.flushing = this.write(e).then(() => {
      this.retry = 0, !this.queue.size && navigator.onLine && (this.status.value = "saved");
    }).catch((t) => {
      if (Wo(t) === "permission-denied") {
        console.error("[board] save refused", t), this.status.value = "error";
        return;
      }
      console.error("[board] save failed, retrying", t);
      for (const [i, s] of e) {
        const o = this.queue.get(i);
        this.queue.set(i, o ? { op: Ku(s.op, o.op), full: o.full || s.full } : s);
      }
      this.status.value = navigator.onLine ? "error" : "offline", this.retry = Math.min(6, this.retry + 1), this.disposed || (clearTimeout(this.timer), this.timer = window.setTimeout(() => {
        this.flush().catch(() => {
        });
      }, 1e3 * 2 ** this.retry));
    }).finally(() => {
      this.flushing = null;
    }), this.flushing;
  }
  /** One batch: per bucket, one set (a new bucket) or one field-level update. */
  async write(e) {
    const t = this.fb.FieldValue, i = this.fb.FieldPath, s = Date.now(), o = /* @__PURE__ */ new Map();
    for (const [d, c] of e) {
      let h = c.op;
      const f = this.index.bucketOf(d) || this.index.place(d, h.kind === "put" ? zl(h.data) : 400, () => this.newBucketId());
      if (h.kind === "patch" && (!this.known.has(d) || !this.serverBuckets.has(f))) {
        if (!c.full) continue;
        h = Ku({ kind: "put", data: wp(c.full, this.user.uid, s) }, h);
      }
      o.has(f) || o.set(f, []), o.get(f).push([d, h]);
    }
    const r = [], a = [];
    for (const [d, c] of o) {
      const h = this.bucketRef(d);
      if (!this.serverBuckets.has(d)) {
        const w = {};
        for (const [M, _] of c) _.kind === "put" && (w[M] = _.data);
        if (!Object.keys(w).length) continue;
        const S = L8(w);
        r.push((M) => M.set(h, {
          v: $8,
          elements: w,
          ...S != null ? { hardDeleteAt: new Date(S) } : {},
          updatedBy: this.user.uid,
          updatedAt: t.serverTimestamp(),
          _created: t.serverTimestamp()
        }, { merge: !0 })), a.push(d);
        continue;
      }
      const f = [];
      for (const [w, S] of c)
        if (S.kind === "put") f.push(new i("elements", w), S.data);
        else if (S.kind === "delete") f.push(new i("elements", w), t.delete());
        else for (const [M, _] of Object.entries(S.fields)) f.push(new i("elements", w, M), _ === void 0 ? t.delete() : _);
      const p = this.hintFor(d, c);
      p != null && f.push("hardDeleteAt", new Date(p)), f.push("updatedBy", this.user.uid, "updatedAt", t.serverTimestamp());
      const [y, v, ...x] = f;
      r.push((w) => w.update(h, y, v, ...x));
    }
    const l = /* @__PURE__ */ new Map();
    for (const d of o.values())
      for (const [c, h] of d) {
        l.set(c, this.known.get(c));
        const f = ug(this.known.get(c), h);
        f ? this.known.set(c, f) : this.known.delete(c);
      }
    try {
      for (let d = 0; d < r.length; d += r1) {
        const c = this.fb.db.batch();
        for (const h of r.slice(d, d + r1)) h(c);
        await c.commit();
      }
    } catch (d) {
      for (const [c, h] of l)
        h ? this.known.set(c, h) : this.known.delete(c);
      throw d;
    }
    for (const d of a) this.serverBuckets.add(d);
  }
  /** The bucket's hardDeleteAt for a write (buckets.ts hintForWrite); `known` is still the state before it. */
  hintFor(e, t) {
    const i = t.map(([s, o]) => {
      const r = this.known.get(s);
      return [r, ug(r, o)];
    });
    return CG(this.hints.get(e) || null, i, this.latest.get(e) || {});
  }
  /** Keep a listener until dispose; one set up after it (closed mid-load) stops at once. */
  keep(e) {
    this.disposed ? e() : this.unsubs.push(e);
  }
  dispose() {
    this.disposed = !0, window.removeEventListener("online", this.onlineHandler), window.removeEventListener("offline", this.onlineHandler), this.flush().catch(() => {
    });
    for (const e of this.unsubs) e();
    this.unsubs = [], this.onRemote = null, this.abortLoad && this.abortLoad(new Error("The board was closed while it loaded.")), this.abortLoad = null;
  }
}
var bze = Object.defineProperty, vze = (n, e, t) => e in n ? bze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, ov = (n, e, t) => vze(n, typeof e != "symbol" ? e + "" : e, t);
const yze = 60;
function Qr(n, e) {
  const t = e.staticInputs || {};
  return {
    id: n,
    runnitId: String(e.runnitId || ""),
    nodeId: String(e.nodeId || ""),
    nodeDefId: String(e.nodeDefId || ""),
    userId: String(e.userId || ""),
    teamId: e.teamId || null,
    email: typeof e.email == "string" ? e.email : void 0,
    state: e.state || "INIT",
    initAt: gn(e.initAt) || gn(e.createdAt),
    doneAt: gn(e.doneAt),
    inputs: e.inputs || {},
    staticInputs: { numResults: typeof t.numResults == "number" ? t.numResults : void 0 },
    fields: Array.isArray(e.fields) ? e.fields : void 0,
    results: Array.isArray(e.results) ? e.results : void 0,
    tokensCharged: ap(e.tokensCharged),
    freeTokensCharged: ap(e.freeTokensCharged),
    tokensReturned: ap(e.tokensReturned),
    freeTokensReturned: ap(e.freeTokensReturned),
    deletedAt: e.deletedAt || null
  };
}
function ap(n) {
  return typeof n == "number" ? n : void 0;
}
async function vP(n, e, t = !1) {
  try {
    const i = n.db.collection("runnitNodeRuns").doc(e), s = await (t ? i.get({ source: "server" }) : i.get());
    return s.exists ? Qr(s.id, s.data({ serverTimestamps: "estimate" }) || {}) : null;
  } catch (i) {
    if (Wo(i) === "permission-denied" || Wo(i) === "not-found") return null;
    throw i;
  }
}
class xze {
  constructor(e, t) {
    ov(this, "fb", e), ov(this, "boardId", t), ov(this, "unsubs", []);
  }
  col() {
    return this.fb.db.collection("runnitNodeRuns");
  }
  /** The board's newest runs, live. `changed` is what this snapshot brought. */
  watchRecent(e, t) {
    const i = this.col().where("runnitId", "==", this.boardId).where("deletedAt", "==", null).orderBy("initAt", "desc").limit(yze).onSnapshot((s) => {
      const o = [], r = [];
      for (const a of s.docChanges())
        a.type === "removed" ? r.push(a.doc.id) : o.push(Qr(a.doc.id, a.doc.data({ serverTimestamps: "estimate" })));
      (o.length || r.length) && e(o, r);
    }, (s) => {
      console.warn("[board] the board's runs are unavailable", s), t && t(s);
    });
    this.unsubs.push(i);
  }
  /**
   * A page of the whole board's runs, newest first, for the board's history;
   * `before` is the last page's oldest initAt. watchRecent's query, paged, so
   * it needs no index of its own.
   */
  async boardPage(e, t = 40) {
    let i = this.col().where("runnitId", "==", this.boardId).where("deletedAt", "==", null).orderBy("initAt", "desc");
    return e != null && (i = i.startAfter(new Date(e))), (await i.limit(t).get()).docs.map((o) => Qr(o.id, o.data({ serverTimestamps: "estimate" })));
  }
  /** A page of one session's runs, newest first; `before` is the last page's oldest initAt. */
  async sessionPage(e, t, i = 24) {
    let s = this.col().where("runnitId", "==", this.boardId).where("nodeId", "==", e).where("deletedAt", "==", null).orderBy("initAt", "desc");
    return t != null && (s = s.startAfter(new Date(t))), (await s.limit(i).get()).docs.map((r) => Qr(r.id, r.data({ serverTimestamps: "estimate" })));
  }
  /** One run, read once (see readRun). */
  getRun(e, t = !1) {
    return vP(this.fb, e, t);
  }
  /** Follow one run (one you just started) until it's over. */
  watchRun(e, t) {
    const i = this.col().doc(e).onSnapshot((s) => {
      t(s.exists ? Qr(s.id, s.data({ serverTimestamps: "estimate" }) || {}) : null);
    }, () => t(null));
    return this.unsubs.push(i), () => {
      i(), this.unsubs = this.unsubs.filter((s) => s !== i);
    };
  }
  /**
   * Delete one result from its session's history, as v1 does: the result
   * is marked deleted inside its run, and the run too once all of its are.
   * The rules let its runner (or a team admin who manages generations) do it.
   */
  async deleteResult(e, t, i) {
    const s = this.col().doc(e);
    await this.fb.db.runTransaction(async (o) => {
      const r = await o.get(s);
      if (!r.exists) return;
      const a = (r.data() || {}).results || [], l = /* @__PURE__ */ new Date(), d = a.map((h) => h.uuid === t && !h.deletedAt ? { ...h, deletedAt: l, deletedByUserId: i } : h), c = d.every((h) => !!h.deletedAt);
      o.update(s, {
        results: d,
        ...c ? { deletedAt: l, deletedByUserId: i } : {}
      });
    });
  }
  /**
   * deleteResult taken back (Recently Deleted's Recover, CHAT-14): the
   * result's delete stamps go, and the run's too when the delete had taken
   * its last result. The same fields deleteResult writes, which the run's
   * owner may write either way. The run's deletedAt goes back to null rather
   * than away: every query of runs asks for deletedAt == null, which a run
   * without the field doesn't match, so it would be in no history at all.
   */
  async restoreResult(e, t) {
    const i = this.col().doc(e), s = this.fb.FieldValue;
    await this.fb.db.runTransaction(async (o) => {
      const r = await o.get(i);
      if (!r.exists) throw new Error("run " + e + " is gone");
      const a = r.data() || {}, d = (a.results || []).map((c) => {
        if (c.uuid !== t || !c.deletedAt) return c;
        const h = { ...c };
        return delete h.deletedAt, delete h.deletedByUserId, h;
      });
      o.update(i, {
        results: d,
        ...a.deletedAt ? { deletedAt: null, deletedByUserId: s.delete() } : {}
      });
    });
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
var wze = Object.defineProperty, kze = (n, e, t) => e in n ? wze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, On = (n, e, t) => kze(n, typeof e != "symbol" ? e + "" : e, t);
function _ze(n, e) {
  return !n || !e ? n !== e : n.id !== e.id || n.nodeDefId !== e.nodeDefId || n.numResults !== e.numResults || JSON.stringify(n.inputs) !== JSON.stringify(e.inputs);
}
const Sze = 800, Mze = 8e3;
class Tze {
  constructor(e, t, i) {
    On(this, "fb", e), On(this, "uid", t), On(this, "boardId", i), On(this, "all", /* @__PURE__ */ new Map()), On(this, "current", /* @__PURE__ */ new Map()), On(this, "consumed", /* @__PURE__ */ new Set()), On(this, "submitting", /* @__PURE__ */ new Set()), On(this, "awaiting", /* @__PURE__ */ new Map()), On(this, "pending", /* @__PURE__ */ new Map()), On(this, "restoring", /* @__PURE__ */ new Map()), On(this, "runNode", /* @__PURE__ */ new Map()), On(this, "writing", /* @__PURE__ */ new Map()), On(this, "onChange", null), On(this, "followed", /* @__PURE__ */ new Map()), On(this, "listening", /* @__PURE__ */ new Map()), On(this, "timer", 0), On(this, "disposed", !1);
  }
  /**
   * Where your drafts go as they arrive. Nothing is read yet: a session's are
   * read when it's followed (opened, saved or run), so a board with many
   * sessions reads only the few you use.
   */
  start(e) {
    this.onChange = e;
    for (const [t, i] of this.current) e(t, i);
    return Promise.resolve();
  }
  /**
   * Follow your drafts in one session, live, so another tab's edit shows here.
   * Resolves once its first snapshot is in, so a save or a run knows which
   * draft is the session's before it writes.
   */
  follow(e) {
    let t = this.followed.get(e);
    return t || (t = new Promise((i) => {
      const s = { unsub: () => {
      }, settled: !1 }, o = () => {
        s.settled || (s.settled = !0, i(), this.disposed && s.unsub());
      };
      s.unsub = this.fb.db.collection("runnitNodeRunDrafts").where("userId", "==", this.uid).where("runnitId", "==", this.boardId).where("nodeId", "==", e).where("deletedAt", "==", null).onSnapshot((r) => {
        this.read(r, !s.settled), o();
      }, (r) => {
        console.warn("[board] drafts unavailable", r), o();
      }), this.listening.set(e, s);
    }), this.followed.set(e, t), t);
  }
  read(e, t) {
    const i = /* @__PURE__ */ new Set();
    for (const s of e.docChanges()) {
      const o = s.doc.data({ serverTimestamps: "estimate" }), r = String(o.nodeId || "");
      if (!r) continue;
      if (i.add(r), s.type === "removed") {
        this.all.delete(s.doc.id);
        continue;
      }
      if (o.state && o.state !== "DRAFT") {
        this.all.delete(s.doc.id);
        continue;
      }
      const a = o.staticInputs || {};
      this.all.set(s.doc.id, {
        id: s.doc.id,
        nodeId: r,
        nodeDefId: String(o.nodeDefId || ""),
        draftAt: gn(o.draftAt) || gn(o.createdAt) || 0,
        inputs: o.inputs || {},
        numResults: typeof a.numResults == "number" ? a.numResults : void 0
      });
    }
    for (const s of i) {
      const o = this.current.get(s), r = this.newest(s);
      r ? (this.current.set(s, r), o && o.id !== r.id && this.awaiting.delete(s)) : this.current.delete(s), !(this.pending.has(s) || this.restoring.has(s)) && this.onChange && (t || _ze(o, r)) && this.onChange(s, r);
    }
  }
  newest(e) {
    let t = null;
    for (const i of this.all.values())
      i.nodeId !== e || this.consumed.has(i.id) || (!t || i.draftAt > t.draftAt) && (t = i);
    return t;
  }
  get(e) {
    return this.current.get(e) || null;
  }
  /** Keep a session's prompt (debounced). */
  save(e, t, i, s) {
    this.pending.set(e, { nodeDefId: t, inputs: i, numResults: s }), this.later(Sze);
  }
  later(e) {
    clearTimeout(this.timer), this.disposed || (this.timer = window.setTimeout(() => {
      this.flush().catch(() => {
      });
    }, e));
  }
  /**
   * Whether a session's saves wait: a run is on its way with its draft, or
   * took it and the draft it leaves in its place hasn't arrived yet.
   */
  holding(e, t) {
    const i = this.current.get(e);
    if (i && this.submitting.has(i.id)) return !0;
    const s = this.awaiting.get(e);
    return !!(s && s > t && !i);
  }
  async flush() {
    clearTimeout(this.timer);
    const e = Date.now();
    let t = !1;
    const i = [];
    for (const [s, o] of Array.from(this.pending)) {
      if (this.holding(s, e)) {
        t = !0;
        continue;
      }
      this.pending.delete(s), i.push(this.queue(s, () => this.saveNow(s, o)).catch((r) => console.warn("[board] prompt not kept", r)));
    }
    await Promise.all(i), t && this.later(1e3);
  }
  /** A save's turn came: unless a run took the draft while it waited, in which case it waits again. */
  async saveNow(e, t) {
    if (await this.follow(e), this.holding(e, Date.now())) {
      this.pending.has(e) || this.pending.set(e, t), this.later(1e3);
      return;
    }
    await this.write(e, t);
  }
  /** Run a session's writes one after another, whatever became of the one before. */
  queue(e, t) {
    const s = (this.writing.get(e) || Promise.resolve()).then(t, t), o = s.catch(() => {
    });
    return this.writing.set(e, o), o.then(() => {
      this.writing.get(e) === o && this.writing.delete(e);
    }), s;
  }
  /**
   * Write a session's prompt now and give the draft id a run takes. Saves
   * leave that draft alone until the run settles: markConsumed when it went,
   * release when it didn't.
   */
  prepare(e, t, i, s, o = null) {
    return this.pending.delete(e), o && this.restoring.set(e, o), this.queue(e, async () => {
      await this.follow(e);
      let r;
      try {
        r = await this.write(e, { nodeDefId: t, inputs: i, numResults: s });
      } catch (a) {
        throw this.restoring.delete(e), a;
      }
      return this.submitting.add(r), this.runNode.set(r, e), r;
    });
  }
  /** The run didn't go: its draft is the session's again, and saves held for it go now. */
  release(e) {
    const t = this.submitting.delete(e), i = this.runNode.get(e);
    this.runNode.delete(e), i && this.putBack(i), t && this.pending.size && this.later(0);
  }
  /**
   * A run that wasn't the session's prompt is done with its draft: the prompt
   * goes back into it (or into the one a run leaves), unless something typed
   * since is waiting to be saved, which is newer and wins.
   */
  putBack(e) {
    const t = this.restoring.get(e);
    t && (this.restoring.delete(e), this.pending.has(e) || this.pending.set(e, t), this.later(0));
  }
  /** A run took this draft: later saves wait for the one the server leaves in its place. */
  markConsumed(e) {
    this.submitting.delete(e), this.consumed.add(e);
    const t = this.all.get(e), i = t && t.nodeId || this.runNode.get(e);
    if (this.runNode.delete(e), !i) return;
    this.awaiting.set(i, Date.now() + Mze);
    const s = this.newest(i);
    s ? this.current.set(i, s) : this.current.delete(i), this.putBack(i);
  }
  /** Write to the session's draft, or start one. Only ever in the session's queue. */
  async write(e, t) {
    const i = this.current.get(e), s = this.fb.db.collection("runnitNodeRunDrafts"), o = this.fb.db.collection("runnitNodeDefs").doc(t.nodeDefId);
    if (i && !this.consumed.has(i.id) && !this.submitting.has(i.id))
      try {
        return await s.doc(i.id).update({
          inputs: t.inputs,
          staticInputs: { numResults: t.numResults },
          ...i.nodeDefId !== t.nodeDefId ? { nodeDefId: t.nodeDefId, nodeDef: o } : {}
        }), this.all.set(i.id, { ...i, nodeDefId: t.nodeDefId, inputs: t.inputs, numResults: t.numResults }), this.current.set(e, this.all.get(i.id)), i.id;
      } catch (d) {
        if (Wo(d) !== "permission-denied" && Wo(d) !== "not-found") throw d;
        this.consumed.add(i.id);
      }
    const r = this.fb.FieldValue, a = await s.add({
      createdAt: r.serverTimestamp(),
      deletedAt: null,
      draftAt: r.serverTimestamp(),
      userId: this.uid,
      runnitId: this.boardId,
      nodeId: e,
      nodeDefId: t.nodeDefId,
      nodeDef: o,
      mode: "MANUAL",
      state: "DRAFT",
      inputs: t.inputs,
      staticInputs: { numResults: t.numResults }
    }), l = { id: a.id, nodeId: e, nodeDefId: t.nodeDefId, draftAt: Date.now(), inputs: t.inputs, numResults: t.numResults };
    return this.all.set(a.id, l), this.current.set(e, l), this.awaiting.delete(e), a.id;
  }
  dispose() {
    this.disposed = !0, this.flush().catch(() => {
    });
    for (const e of this.listening.values()) e.settled && e.unsub();
    this.onChange = null;
  }
}
var Cze = Object.defineProperty, Ize = (n, e, t) => e in n ? Cze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Ld = (n, e, t) => Ize(n, typeof e != "symbol" ? e + "" : e, t);
class Aze {
  constructor(e, t, i) {
    Ld(this, "fb", e), Ld(this, "uid", t), Ld(this, "boardId", i), Ld(this, "uuids", /* @__PURE__ */ qe(/* @__PURE__ */ new Set())), Ld(this, "unsub", null);
  }
  start() {
    this.unsub = this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).where("runnitId", "==", this.boardId).onSnapshot((e) => {
      const t = /* @__PURE__ */ new Set();
      for (const i of e.docs) {
        const s = i.data().nodeRunResultUuid;
        s && t.add(s);
      }
      this.uuids.value = t, xs(this.uuids);
    }, (e) => console.warn("[board] favorites unavailable", e));
  }
  has(e) {
    return !!e && this.uuids.value.has(e);
  }
  /** A result can be starred by whoever ran it, once it's finished. */
  canStar(e) {
    return !!e.uuid && !!e.runId && e.status === "done" && e.userId === this.uid;
  }
  async set(e, t) {
    if (!this.canStar(e)) return;
    const i = this.fb.db.collection("resultFavorites").doc(this.uid + "_" + e.uuid), s = new Set(this.uuids.value);
    if (t ? s.add(e.uuid) : s.delete(e.uuid), this.uuids.value = s, xs(this.uuids), !t) {
      await i.delete();
      return;
    }
    await i.set({
      createdAt: this.fb.FieldValue.serverTimestamp(),
      userId: this.uid,
      nodeRunId: e.runId,
      nodeRunResultUuid: e.uuid,
      nodeDefId: e.modelId || "",
      nodeId: e.sessionId,
      runnitId: this.boardId,
      resultType: e.video ? "VID" : e.kind === "3d" ? "ASSET_3D" : e.kind === "layers" ? "LAYERS" : "IMG"
    });
  }
  dispose() {
    this.unsub && this.unsub(), this.unsub = null;
  }
}
var Pze = Object.defineProperty, Eze = (n, e, t) => e in n ? Pze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, lp = (n, e, t) => Eze(n, typeof e != "symbol" ? e + "" : e, t);
const rv = { models: "pinnedModelIds", sessions: "pinnedSessionIds" };
class Rze {
  constructor(e, t, i) {
    lp(this, "fb", e), lp(this, "uid", t), lp(this, "boardId", i), lp(this, "there", /* @__PURE__ */ new Map());
  }
  docId(e) {
    return e === "models" ? "global" : this.boardId;
  }
  ref(e) {
    return this.fb.db.doc("users/" + this.uid + "/boardPrefs/" + this.docId(e));
  }
  /**
   * A merge into the doc, naming its `_created` when this write makes it.
   * Before any snapshot has said whether it's there, a read does; when that
   * fails too, `_created` is left alone rather than reset.
   */
  async merge(e, t) {
    const i = this.docId(e);
    let s = this.there.get(i);
    s === void 0 && (s = await this.ref(e).get().then((o) => o.exists, () => !0)), this.there.set(i, !0);
    try {
      await this.ref(e).set(s ? t : { ...t, _created: this.fb.FieldValue.serverTimestamp() }, { merge: !0 });
    } catch (o) {
      throw s || this.there.delete(i), o;
    }
  }
  watch(e, t, i) {
    return this.ref(e).onSnapshot((s) => {
      this.there.set(this.docId(e), s.exists);
      const o = s.exists ? (s.data() || {})[rv[e]] : void 0;
      t(Array.isArray(o) ? o.filter((r) => typeof r == "string") : null);
    }, (s) => {
      console.warn("[board] your pins are kept in this browser only", s), i();
    });
  }
  pin(e, t, i) {
    const s = this.fb.FieldValue;
    return this.merge(e, { [rv[e]]: i ? s.arrayUnion(t) : s.arrayRemove(t) });
  }
  seed(e, t) {
    return this.merge(e, { [rv[e]]: t });
  }
  watchViews(e, t) {
    return this.ref("models").onSnapshot((i) => {
      this.there.set(this.docId("models"), i.exists);
      const s = i.exists ? (i.data() || {}).cameraViews : void 0;
      e(Array.isArray(s) ? s : null);
    }, (i) => {
      console.warn("[board] your camera views are kept in this browser only", i), t();
    });
  }
  saveViews(e) {
    return this.merge("models", { cameraViews: e });
  }
}
var zze = Object.defineProperty, $ze = (n, e, t) => e in n ? zze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, av = (n, e, t) => $ze(n, typeof e != "symbol" ? e + "" : e, t);
class Dze {
  constructor(e, t) {
    av(this, "fb", e), av(this, "uid", t), av(this, "avatars", /* @__PURE__ */ new Map());
  }
  /** Newest first: yours, then the team's shared ones. */
  async list(e) {
    const t = this.fb.db.collection("models"), i = e ? [
      t.where("teamId", "==", e).where("accessLevel", "==", "PRIVATE").where("isDeleted", "==", !1).where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(1e3),
      t.where("teamId", "==", e).where("accessLevel", "==", "SHARED").where("isDeleted", "==", !1).orderBy("createdAt", "desc").limit(1e3)
    ] : [
      t.where("userId", "==", this.uid).where("teamId", "==", null).where("accessLevel", "==", "PRIVATE").where("isDeleted", "==", !1).orderBy("createdAt", "desc").limit(100)
    ], s = await Promise.all(i.map((a) => a.get())), o = [];
    return s.forEach((a, l) => a.docs.forEach((d) => o.push({ doc: d, shared: !!e && l === 1 }))), (await Promise.all(o.map(({ doc: a, shared: l }) => this.toModel(a, l)))).filter((a) => !!a);
  }
  async toModel(e, t) {
    const i = e.data();
    if (!i.file) return null;
    const s = i.avatarId ? await this.avatar(i.avatarId) : null, o = { ...i, id: e.id };
    s && (o.avatar = s);
    const r = s ? hS(s) : null, a = this.fb.storageUrl;
    return {
      id: e.id,
      name: i.name || "Untitled model",
      description: i.description || void 0,
      architecture: i.architecture || void 0,
      shared: t,
      thumb: r && a ? a(r.thumb) : void 0,
      image: r && a ? a(r.file) : void 0,
      record: o
    };
  }
  avatar(e) {
    let t = this.avatars.get(e);
    return t || (t = this.fb.db.doc("avatars/" + e).get().then((i) => i.exists ? { ...i.data(), id: e } : null).catch(() => null), this.avatars.set(e, t)), t;
  }
}
var Oze = Object.defineProperty, Lze = (n, e, t) => e in n ? Oze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, I3 = (n, e, t) => Lze(n, typeof e != "symbol" ? e + "" : e, t);
function A3(n, e) {
  let t = typeof n[e] == "number" ? n[e] : 0;
  const i = e + "_delta_";
  for (const s of Object.keys(n))
    s.startsWith(i) && typeof n[s] == "number" && (t += n[s]);
  return t;
}
function Bze(n, e) {
  const t = A3(n, "runnitTokens"), i = n.type === "USER" && e ? A3(n, "freeRunnitTokens") : 0;
  return t + i;
}
class Fze {
  constructor(e, t) {
    I3(this, "fb", e), I3(this, "freemiumPassport", t);
  }
  /** Follow an account (a team id, or your uid); null while it can't be read. */
  watch(e, t) {
    return this.fb.db.doc("balanceAccounts/" + e).onSnapshot((i) => {
      if (!i.exists) {
        t(null);
        return;
      }
      const s = i.data() || {};
      t({ tokens: Bze(s, this.freemiumPassport), team: s.type === "TEAM" });
    }, (i) => {
      console.warn("[board] balance unavailable", i), t(null);
    });
  }
}
var Nze = Object.defineProperty, Uze = (n, e, t) => e in n ? Nze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Gze = (n, e, t) => Uze(n, e + "", t);
class jze {
  constructor(e) {
    Gze(this, "fb", e);
  }
  /**
   * Follow a team: whether it's active (no isActive counts as not), or null
   * while it can't be read; and its name, which the token chip names as the
   * account that pays (N5).
   */
  watch(e, t) {
    return this.fb.db.doc("teams/" + e).onSnapshot((i) => {
      if (!i.exists) {
        t(null);
        return;
      }
      const s = i.data() || {};
      t(s.isActive === !0, typeof s.name == "string" && s.name.trim() ? s.name.trim() : null);
    }, (i) => {
      console.warn("[board] team status unavailable", i), t(null);
    });
  }
}
var Hze = Object.defineProperty, Vze = (n, e, t) => e in n ? Hze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, dp = (n, e, t) => Vze(n, typeof e != "symbol" ? e + "" : e, t);
const Wze = 48, qze = 1e3, cp = 200;
function Bd(n, e) {
  const t = new Error(n);
  return t.userMessage = n, t.cause = e, t;
}
class Kze {
  constructor(e, t, i = {}) {
    dp(this, "fb", e), dp(this, "uid", t), dp(this, "features"), dp(this, "api"), this.api = e.library || null, this.features = { search: !!this.api && !!i.isAdmin, filters: !!this.api, star: !0, remove: !0 };
  }
  url(e) {
    return this.fb.storageUrl ? this.fb.storageUrl(e) : "";
  }
  ctx() {
    return { uid: this.uid, storageUrl: (e) => this.url(e), modelName: () => "" };
  }
  /** Your finished generations, from any board, a page at a time; filtered or searched through the API. */
  async generations(e = {}) {
    if (this.api && (rA(e.filters) || Sm(e.search) || typeof e.cursor == "string")) return this.fromApi("generations", e);
    let t = this.fb.db.collection("runnitNodeRuns").where("deletedAt", "==", null).where("state", "==", "DONE").where("templateOriginalData", "==", null).where("userId", "==", this.uid).orderBy("initAt", "desc");
    typeof e.cursor == "number" && (t = t.startAfter(new Date(e.cursor)));
    const s = (await t.limit(Jr).get()).docs.map((a) => Qr(a.id, a.data())), o = [];
    for (const a of s) o.push(...G0(a, this.ctx()));
    const r = s[s.length - 1];
    return { items: o, next: s.length === Jr && r && r.initAt ? r.initAt : null };
  }
  /** Your uploads, newest first, a page at a time. */
  async uploads(e = {}) {
    let t = this.fb.db.collection("runnitUploads").where("deletedAt", "==", null).where("userId", "==", this.uid).orderBy("createdAt", "desc");
    typeof e.cursor == "number" && (t = t.startAfter(new Date(e.cursor)));
    const i = await t.limit(Jr).get(), s = [];
    let o = null;
    for (const r of i.docs) {
      const a = { ...r.data(), id: r.id };
      if (o = gn(a.createdAt) || o, !a.name || a.type && a.type !== "IMG" && a.type !== "VID" && a.type !== "ASSET_3D") continue;
      const l = K1(a), d = a.type === "VID", c = a.type === "ASSET_3D", h = l.replace(/[^/]+$/, (f) => "thumbs/" + f.replace(/\.[^/.]+$/, "_512x512.webp"));
      s.push({
        id: "upload:" + r.id,
        // a video shows its first frame, as results do, and a 3D model its preview
        url: this.url(d || c ? h : l),
        thumb: this.url(h),
        w: a.width,
        h: a.height,
        video: d,
        videoSrc: d ? this.url(l) : void 0,
        label: a.name,
        createdAt: gn(a.createdAt),
        mine: a.userId === this.uid,
        uploadId: r.id,
        asset: { upload: a },
        model3d: c ? { url: this.url(l), ext: (/\.([a-z0-9]+)$/i.exec(a.name) || ["", "glb"])[1].toLowerCase() } : void 0
      });
    }
    return { items: s, next: i.docs.length === Jr ? o : null };
  }
  /** What you've starred, most recently first: through the API (paged), or each favorite's run. */
  async favorites(e = {}) {
    if (this.api) return this.fromApi("favorites", e);
    const i = (await this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(Wze).get()).docs.map((a) => a.data()).filter((a) => !!a.nodeRunId && !!a.nodeRunResultUuid), s = Array.from(new Set(i.map((a) => a.nodeRunId))), o = /* @__PURE__ */ new Map();
    await Promise.all(s.map(async (a) => {
      const l = await this.fb.db.doc("runnitNodeRuns/" + a).get().catch(() => null);
      l && l.exists && o.set(a, Qr(a, l.data() || {}));
    }));
    const r = [];
    for (const a of i) {
      const l = o.get(a.nodeRunId);
      if (!l) continue;
      const d = G0(l, this.ctx()).find((c) => c.id === l.id + ":" + a.nodeRunResultUuid);
      d && r.push({ ...d, fav: !0 });
    }
    return { items: r, next: null };
  }
  async fromApi(e, t) {
    const i = await this.api(rke(e, t));
    if (!i.ok) throw Bd(ake(i), i);
    const s = lke(i.page.data, i.page.nodeDefs || {}, this.ctx());
    if (e === "favorites") for (const o of s) o.fav = !0;
    return { items: s, next: i.page.hasMore ? i.page.nextCursor : null };
  }
  /** The results you've starred, as Library item ids (run:result), to mark them anywhere. */
  async favoriteKeys() {
    const e = await this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(qze).get(), t = [];
    for (const i of e.docs) {
      const s = i.data();
      s.nodeRunId && s.nodeRunResultUuid && t.push(s.nodeRunId + ":" + s.nodeRunResultUuid);
    }
    return t;
  }
  /**
   * What the filters pick from: the tools' Model family and Media tags, and
   * the boards you can read (v1's board reads, canvas boards too). Tools come
   * from the board's own catalog.
   */
  async filterOptions(e = null) {
    const [t, i] = await Promise.all([this.tags(), this.boards(e)]);
    return { tools: [], families: t.families, media: t.media, boards: i };
  }
  async tags() {
    try {
      const t = (await this.fb.db.collection("runnitNodeDefTags").where("isDeleted", "==", !1).get()).docs.map((s) => ({ id: s.id, ...s.data() })).sort((s, o) => (s.sortOrder || 0) - (o.sortOrder || 0) || (s.label || "").localeCompare(o.label || "")), i = (s) => t.filter((o) => o.type === s && o.label).map((o) => ({ value: o.id, text: o.label }));
      return { families: i("MODEL_FAMILY"), media: i("MEDIA") };
    } catch (e) {
      return console.warn("[board] the Library's tool tags are unavailable", e), { families: [], media: [] };
    }
  }
  /** v1's board reads (libraryBoards.ts), for v1's boards and canvas boards alike; deduped, by title. */
  async boards(e) {
    const t = () => this.fb.db.collection("runnits"), i = [];
    for (const o of ["WORKFLOW", "CANVAS"])
      i.push(t().where("userId", "==", this.uid).where("teamId", "==", null).where("deletedAt", "==", null).where("type", "==", o).orderBy("createdAt", "desc").limit(cp)), e && (i.push(t().where("teamId", "==", e).where("accessLevel", "==", "PRIVATE").where("deletedAt", "==", null).where("type", "==", o).where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(cp)), i.push(t().where("teamId", "==", e).where("accessLevel", "==", "RESTRICTED").where("deletedAt", "==", null).where("type", "==", o).where(`userIds.${this.uid}`, "==", !0).limit(cp)), i.push(t().where("teamId", "==", e).where("accessLevel", "==", "SHARED").where("deletedAt", "==", null).where("type", "==", o).orderBy("createdAt", "desc").limit(cp)));
    const s = /* @__PURE__ */ new Map();
    return await Promise.all(i.map(async (o) => {
      try {
        const r = await o.get();
        for (const a of r.docs)
          s.has(a.id) || s.set(a.id, { value: a.id, text: a.data().title || "Untitled board" });
      } catch (r) {
        console.warn("[board] a board list for the Library is unavailable", r);
      }
    })), Array.from(s.values()).sort((o, r) => o.text.localeCompare(r.text));
  }
  /** Star or unstar one of your finished generations (resultFavorites/{uid}_{result}, as v1 writes it). */
  async setFavorite(e, t) {
    if (!e.run || !e.mine || e.moderated) throw Bd("Only your own generations can be starred");
    const i = this.fb.db.collection("resultFavorites").doc(this.uid + "_" + e.run.uuid);
    try {
      if (!t) {
        await i.delete();
        return;
      }
      await i.set({
        createdAt: this.fb.FieldValue.serverTimestamp(),
        userId: this.uid,
        nodeRunId: e.run.id,
        nodeRunResultUuid: e.run.uuid,
        nodeDefId: e.run.nodeDefId || null,
        nodeId: e.run.nodeId || null,
        runnitId: e.run.runnitId || null,
        resultType: e.run.type || (e.video ? "VID" : "IMG")
      });
    } catch (s) {
      throw Bd(t ? "Could not favorite it, please try again" : "Could not unfavorite it, please try again", s);
    }
  }
  /** Delete one of your generations or uploads (stamped, as v1 deletes them). */
  async remove(e) {
    if (!e.mine) throw Bd("Only your own pictures can be deleted");
    try {
      if (e.uploadId) {
        await this.fb.db.collection("runnitUploads").doc(e.uploadId).update({ deletedAt: /* @__PURE__ */ new Date(), deletedByUserId: this.uid });
        return;
      }
      if (!e.run) return;
      const t = e.run.id, i = e.run.uuid, s = this.fb.db.collection("runnitNodeRuns").doc(t);
      await this.fb.db.runTransaction(async (o) => {
        const r = await o.get(s);
        if (!r.exists) return;
        const a = (r.data() || {}).results || [], l = /* @__PURE__ */ new Date(), d = a.map((h) => h.uuid === i && !h.deletedAt ? { ...h, deletedAt: l, deletedByUserId: this.uid } : h), c = d.every((h) => !!h.deletedAt);
        o.update(s, { results: d, ...c ? { deletedAt: l, deletedByUserId: this.uid } : {} });
      });
    } catch (t) {
      throw Bd("Issues deleting image, please try again", t);
    }
  }
}
var Yze = Object.defineProperty, Xze = (n, e, t) => e in n ? Yze(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, P3 = (n, e, t) => Xze(n, typeof e != "symbol" ? e + "" : e, t);
function Jze(n, e = Date.now()) {
  const t = typeof n == "string" ? Date.parse(n) : typeof n == "number" ? n : NaN;
  if (!Number.isFinite(t)) return "";
  const i = new Date(t), s = i.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase();
  return i.toDateString() === new Date(e).toDateString() ? s : s + " on " + i.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
function Zze(n) {
  if (!n) return "The run couldn't start. Please try again.";
  if (n.message === "TOKEN_COOLDOWN_ACTIVE") {
    const e = Jze(n.resetAt);
    return "The spending limit for runs here has been reached for now. It resets " + (e ? "at " + e : "soon") + "; ask an admin if you need more.";
  }
  return n.message ? n.message : "The run couldn't start. Please try again.";
}
function Qze(n) {
  const e = n && typeof n == "object" && "code" in n ? String(n.code) : "";
  return e.endsWith("deadline-exceeded") ? "The run took too long to start. Please try again." : e.endsWith("unavailable") ? "The run couldn't start. Check your connection and try again." : "The run couldn't start. Please try again.";
}
class e$e {
  constructor(e, t) {
    P3(this, "fb", e), P3(this, "drafts", t);
  }
  run(e, t) {
    let i = !1;
    const s = { runId: "", pending: [], cancel: () => {
      i = !0;
    } }, o = e.v1Inputs || {};
    return (async () => {
      let r;
      try {
        r = await this.drafts.prepare(e.sessionId, e.model.id, o, e.count, e.restore || null);
      } catch (c) {
        console.error("[board] run draft not written", c), i || t.onError("The run couldn't start: your prompt wasn't saved. Please try again.", []);
        return;
      }
      let a = null, l = !1, d = null;
      try {
        const h = await this.fb.functions.httpsCallable("runRunnitNode")({
          nodeRunId: r,
          nodeDefId: e.model.id,
          inputValues: o,
          staticInputValues: { numResults: e.count }
        });
        a = h && h.data || null;
      } catch (c) {
        l = !0, d = c;
      }
      if (l) {
        if (console.error("[board] runRunnitNode failed", d), !await this.ranAnyway(r)) {
          this.drafts.release(r), i || t.onError(Qze(d), []);
          return;
        }
      } else if (!a || !a.success) {
        this.drafts.release(r), i || t.onError(Zze(a), []);
        return;
      }
      this.drafts.markConsumed(r), s.runId = r, !i && t.onStarted && t.onStarted(r);
    })(), s;
  }
  /** Whether a run whose call failed went through all the same; no, when nobody can say. */
  async ranAnyway(e) {
    try {
      return !!await vP(this.fb, e, !0);
    } catch {
      return !1;
    }
  }
}
var t$e = Object.defineProperty, n$e = (n, e, t) => e in n ? t$e(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, E3 = (n, e, t) => n$e(n, typeof e != "symbol" ? e + "" : e, t);
const i$e = "featuredPrompts";
class s$e {
  constructor(e) {
    E3(this, "fb", e), E3(this, "pending", null);
  }
  load() {
    if (!this.pending) {
      const e = this.fb.db.collection(i$e).doc("current").get().then(
        (t) => t.exists ? NV(t.data()) : null,
        // rules that don't know the collection yet (not deployed) refuse the read:
        // that's no set published, not a connection to try again
        (t) => {
          if (t && t.code === "permission-denied") return null;
          throw t;
        }
      );
      e.catch(() => {
        this.pending === e && (this.pending = null);
      }), this.pending = e;
    }
    return this.pending;
  }
}
const R3 = /* @__PURE__ */ new WeakMap();
function o$e(n) {
  let e = R3.get(n);
  return e || (e = new s$e(n), R3.set(n, e)), e;
}
var r$e = Object.defineProperty, a$e = (n, e, t) => e in n ? r$e(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, up = (n, e, t) => a$e(n, typeof e != "symbol" ? e + "" : e, t);
const Fd = "libraryPrompts";
function z3(n) {
  return JSON.parse(JSON.stringify(n));
}
class l$e {
  constructor(e, t = e.api || null, i) {
    up(this, "fb", e), up(this, "api", t), up(this, "fetchImpl", i), up(this, "teams", /* @__PURE__ */ new Map());
  }
  async list(e) {
    const t = this.api;
    if (!t) return { ok: !1, reason: "failed", message: "The web app's API isn't available here" };
    let i;
    try {
      i = await t.credentials();
    } catch (o) {
      return console.warn("[board] my prompts: no API credentials", o), { ok: !1, reason: "failed" };
    }
    if (!i) return { ok: !1, reason: "unauthorized" };
    const s = await aie(t.baseUrl, i, e, this.fetchImpl);
    return !s.ok && s.code && t.onRejected && t.onRejected(s.code), s;
  }
  follow(e, t, i) {
    return this.fb.db.collection(Fd).doc(e).onSnapshot(
      // a save of yours shows at once, its server times estimated until they land
      (s) => t(s.exists ? JV(s.id, s.data({ serverTimestamps: "estimate" })) : null),
      (s) => {
        i && i(s);
      }
    );
  }
  async save(e, t) {
    const i = this.fb.FieldValue.serverTimestamp();
    return (await this.fb.db.collection(Fd).add({ ...z3(e), v: 1, authorId: t.uid, authorName: t.name, createdAt: i, updatedAt: i, deletedAt: null })).id;
  }
  async update(e, t) {
    await this.fb.db.collection(Fd).doc(e).update({ ...z3(t), updatedAt: this.fb.FieldValue.serverTimestamp() });
  }
  async remove(e) {
    await this.fb.db.collection(Fd).doc(e).update({ deletedAt: this.fb.FieldValue.serverTimestamp() });
  }
  async restore(e) {
    await this.fb.db.collection(Fd).doc(e).update({ deletedAt: null });
  }
  teamName(e) {
    let t = this.teams.get(e);
    return t || (t = this.fb.db.collection("teams").doc(e).get().then((i) => {
      const s = i.exists ? i.data() : void 0;
      return s && typeof s.name == "string" ? s.name : null;
    }).catch(() => null), this.teams.set(e, t)), t;
  }
}
const $3 = /* @__PURE__ */ new WeakMap();
function d$e(n) {
  let e = $3.get(n);
  return e || (e = new l$e(n), $3.set(n, e)), e;
}
var c$e = Object.defineProperty, u$e = (n, e, t) => e in n ? c$e(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Nd = (n, e, t) => u$e(n, typeof e != "symbol" ? e + "" : e, t);
const h$e = 24 * 3600 * 1e3, hp = 450;
function sn(n, e = "") {
  return typeof n == "string" ? n : e;
}
function Up(n) {
  return Array.isArray(n) ? n.filter((e) => typeof e == "string") : [];
}
function Ud(n, e = 0) {
  return typeof n == "number" && Number.isFinite(n) ? n : e;
}
function p$e(n) {
  if (!n || typeof n != "object") return null;
  const e = n;
  return { by: sn(e.by), byName: sn(e.byName), text: sn(e.text) };
}
function D3(n, e) {
  var t, i;
  const s = {};
  if (e.readBy && typeof e.readBy == "object")
    for (const [r, a] of Object.entries(e.readBy)) {
      const l = gn(a);
      l != null && (s[r] = l);
    }
  const o = gn(e.createdAt) || Date.now();
  return {
    id: n,
    boardId: sn(e.boardId),
    teamId: typeof e.teamId == "string" ? e.teamId : null,
    createdBy: sn(e.createdBy),
    createdByName: sn(e.createdByName),
    createdByEmail: sn(e.createdByEmail),
    createdAt: o,
    x: Ud(e.x),
    y: Ud(e.y),
    elementId: typeof e.elementId == "string" ? e.elementId : null,
    ex: Ud(e.ex),
    ey: Ud(e.ey),
    anchorLabel: sn(e.anchorLabel),
    anchorThumb: typeof e.anchorThumb == "string" ? e.anchorThumb : null,
    color: c5e(e.color) ? e.color : "amethyst",
    resolvedAt: (t = gn(e.resolvedAt)) != null ? t : null,
    resolvedBy: typeof e.resolvedBy == "string" ? e.resolvedBy : null,
    followers: Up(e.followers),
    readBy: s,
    markedUnread: Up(e.markedUnread),
    pinnedBy: Up(e.pinnedBy),
    lastAt: gn(e.lastAt) || o,
    lastBy: sn(e.lastBy),
    count: Ud(e.count, 1),
    preview: p$e(e.preview),
    boardTitle: sn(e.boardTitle),
    deletedAt: (i = gn(e.deletedAt)) != null ? i : null,
    deletedBy: typeof e.deletedBy == "string" ? e.deletedBy : null
  };
}
function O3(n, e) {
  var t;
  const i = [];
  if (Array.isArray(e.mentions))
    for (const o of e.mentions)
      o && typeof o == "object" && typeof o.uid == "string" && i.push({ uid: o.uid, name: sn(o.name) });
  const s = {};
  if (e.reactions && typeof e.reactions == "object")
    for (const [o, r] of Object.entries(e.reactions)) {
      const a = Up(r);
      a.length && (s[o] = a);
    }
  return {
    id: n,
    threadId: sn(e.threadId),
    boardId: sn(e.boardId),
    authorId: sn(e.authorId),
    authorName: sn(e.authorName),
    authorEmail: sn(e.authorEmail),
    text: sn(e.text),
    mentions: i,
    createdAt: gn(e.createdAt) || Date.now(),
    editedAt: (t = gn(e.editedAt)) != null ? t : null,
    reactions: s
  };
}
const pp = (n) => n.data({ serverTimestamps: "estimate" }) || {}, L3 = 60, B3 = 480;
class f$e {
  constructor(e, t, i, s) {
    Nd(this, "fb", e), Nd(this, "user", t), Nd(this, "boardId", i), Nd(this, "board", s), Nd(this, "unsubs", []);
  }
  get runnit() {
    return this.fb.db.collection("runnits").doc(this.boardId);
  }
  threadRef(e, t = this.boardId) {
    return this.fb.db.collection("runnits").doc(t).collection("runnitCanvasThreads").doc(e);
  }
  commentRef(e) {
    return this.runnit.collection("runnitCanvasComments").doc(e);
  }
  watchBoard(e) {
    const t = this.runnit.collection("runnitCanvasThreads").onSnapshot((o) => {
      const r = [], a = [];
      for (const l of o.docChanges())
        l.type === "removed" ? a.push(l.doc.id) : r.push(D3(l.doc.id, pp(l.doc)));
      (r.length || a.length || !o.docChanges().length) && e.threads(r, a);
    }, (o) => e.error(o)), i = this.runnit.collection("runnitCanvasComments").onSnapshot((o) => {
      const r = [], a = [];
      for (const l of o.docChanges())
        l.type === "removed" ? a.push(l.doc.id) : r.push(O3(l.doc.id, pp(l.doc)));
      (r.length || a.length) && e.comments(r, a);
    }, (o) => e.error(o)), s = () => {
      t(), i();
    };
    return this.unsubs.push(s), s;
  }
  watchFollowed(e, t) {
    let i = L3, s = () => {
    }, o = !1;
    const r = () => {
      s(), s = this.fb.db.collectionGroup("runnitCanvasThreads").where("followers", "array-contains", this.user.uid).orderBy("lastAt", "desc").limit(i).onSnapshot((l) => {
        if (o) return;
        const d = l.docs.map((h) => D3(h.id, pp(h))).filter((h) => !!h.boardId);
        if (d.filter((h) => !h.deletedAt).length < L3 && l.docs.length >= i && i < B3) {
          i = Math.min(B3, i * 2), r();
          return;
        }
        e(d);
      }, (l) => t(l));
    };
    r();
    const a = () => {
      o = !0, s();
    };
    return this.unsubs.push(a), a;
  }
  async people() {
    const e = this.board(), t = { uid: this.user.uid, name: this.user.name || _c(this.user.email), email: this.user.email };
    if (!e.teamId) return { people: [t], scope: "personal" };
    const i = /* @__PURE__ */ new Map();
    try {
      const l = await this.runnit.collection("runnitCanvasPeople").limit(500).get();
      for (const d of l.docs) {
        const c = d.data();
        i.set(d.id, { uid: d.id, name: sn(c.name), email: sn(c.email) });
      }
    } catch (l) {
      console.warn("[board] comments: the board's people couldn't be read", l);
    }
    const s = e.accessLevel || "PRIVATE";
    let o = null;
    if (s === "PRIVATE" && (o = /* @__PURE__ */ new Set([e.ownerId])), s === "RESTRICTED") {
      o = /* @__PURE__ */ new Set([e.ownerId]);
      try {
        const d = ((await this.runnit.get()).data() || {}).userIds;
        if (d && typeof d == "object")
          for (const [c, h] of Object.entries(d)) h && o.add(c);
      } catch (l) {
        console.warn("[board] comments: the board's access couldn't be read", l);
      }
    }
    const r = /* @__PURE__ */ new Map();
    r.set(t.uid, t);
    try {
      const l = await this.fb.db.collection("teams").doc(e.teamId).collection("teamMembers").where("isAccepted", "==", !0).limit(500).get();
      for (const d of l.docs) {
        const c = d.data(), h = sn(c.userId), f = sn(c.email, d.id);
        if (!h || r.has(h) || o && !o.has(h)) continue;
        const p = i.get(h);
        r.set(h, { uid: h, email: f, name: p && p.name || _c(f) });
      }
    } catch (l) {
      console.warn("[board] comments: the team's members couldn't be read", l);
      for (const d of i.values()) !r.has(d.uid) && (!o || o.has(d.uid)) && r.set(d.uid, d);
    }
    const a = s === "SHARED" ? "team" : s === "RESTRICTED" ? "restricted" : "private";
    return { people: Array.from(r.values()), scope: a };
  }
  async checkIn() {
    const e = this.runnit.collection("runnitCanvasPeople").doc(this.user.uid), t = this.fb.FieldValue, i = this.user.name || _c(this.user.email);
    let s = await e.get();
    if (!s.exists)
      try {
        return await e.set({ uid: this.user.uid, name: i, email: this.user.email, firstSeenAt: t.serverTimestamp(), seenAt: t.serverTimestamp() }), Date.now();
      } catch (a) {
        if (s = await e.get(), !s.exists) throw a;
      }
    const o = s.data() || {}, r = gn(o.seenAt) || 0;
    return (sn(o.name) !== i || sn(o.email) !== this.user.email || Date.now() - r > h$e) && e.update({ name: i, email: this.user.email, seenAt: t.serverTimestamp() }).catch((a) => console.warn("[board] comments: check-in not saved", a)), gn(o.firstSeenAt) || null;
  }
  async createThread(e, t) {
    const s = this.fb.FieldValue.serverTimestamp(), o = this.fb.db.batch();
    o.set(this.threadRef(e.id), {
      v: 1,
      boardId: e.boardId,
      teamId: e.teamId,
      createdBy: e.createdBy,
      createdByName: e.createdByName,
      createdByEmail: e.createdByEmail,
      createdAt: s,
      x: e.x,
      y: e.y,
      elementId: e.elementId,
      ex: e.ex,
      ey: e.ey,
      anchorLabel: e.anchorLabel.slice(0, 120),
      anchorThumb: e.anchorThumb && e.anchorThumb.length <= 1e3 ? e.anchorThumb : null,
      color: e.color,
      resolvedAt: null,
      resolvedBy: null,
      followers: e.followers,
      readBy: { [this.user.uid]: s },
      markedUnread: [],
      pinnedBy: [],
      lastAt: s,
      lastBy: e.lastBy,
      count: 1,
      preview: e.preview,
      boardTitle: e.boardTitle.slice(0, 200)
    }), o.set(this.commentRef(t.id), this.commentDoc(t)), await o.commit();
  }
  commentDoc(e) {
    return {
      v: 1,
      threadId: e.threadId,
      boardId: e.boardId,
      authorId: e.authorId,
      authorName: e.authorName,
      authorEmail: e.authorEmail,
      text: e.text,
      mentions: e.mentions.map((t) => ({ uid: t.uid, name: t.name })),
      createdAt: this.fb.FieldValue.serverTimestamp(),
      editedAt: null,
      reactions: {}
    };
  }
  async reply(e, t, i) {
    const s = this.fb.FieldValue, o = this.fb.db.batch();
    o.set(this.commentRef(t.id), this.commentDoc(t));
    const r = {
      lastAt: s.serverTimestamp(),
      lastBy: this.user.uid,
      count: s.increment(1),
      preview: { by: t.authorId, byName: t.authorName, text: t.text.replace(/\s+/g, " ").trim().slice(0, 280) },
      followers: s.arrayUnion(this.user.uid, ...i),
      ["readBy." + this.user.uid]: s.serverTimestamp(),
      markedUnread: s.arrayRemove(this.user.uid)
    };
    e.resolvedAt && (r.resolvedAt = null, r.resolvedBy = null), o.update(this.threadRef(e.id), r), await o.commit();
  }
  async editComment(e, t, i) {
    const s = this.fb.FieldValue, o = this.fb.db.batch();
    o.update(this.commentRef(e.id), { text: e.text, mentions: e.mentions.map((a) => ({ uid: a.uid, name: a.name })), editedAt: s.serverTimestamp() });
    const r = {};
    t && (r.preview = t), i.length && (r.followers = s.arrayUnion(...i)), Object.keys(r).length && o.update(this.threadRef(e.threadId), r), await o.commit();
  }
  async deleteComment(e, t, i) {
    const s = this.fb.db.batch();
    s.delete(this.commentRef(e.id)), s.update(this.threadRef(e.threadId), { count: Math.max(1, t), preview: i }), await s.commit();
  }
  async deleteThread(e, t) {
    const i = t.slice();
    for (; i.length > hp; ) {
      const o = this.fb.db.batch();
      for (const r of i.splice(0, hp)) o.delete(this.commentRef(r));
      await o.commit();
    }
    const s = this.fb.db.batch();
    for (const o of i) s.delete(this.commentRef(o));
    s.delete(this.threadRef(e)), await s.commit();
  }
  async markDeleted(e) {
    await this.threadRef(e).update({ deletedAt: this.fb.FieldValue.serverTimestamp(), deletedBy: this.user.uid });
  }
  async react(e, t, i) {
    const s = this.fb.FieldValue;
    await this.commentRef(e.id).update({ ["reactions." + this.user.uid]: i ? s.arrayUnion(t) : s.arrayRemove(t) });
  }
  async resolve(e, t) {
    const i = this.fb.FieldValue;
    await this.threadRef(e).update(t ? { resolvedAt: i.serverTimestamp(), resolvedBy: this.user.uid } : { resolvedAt: null, resolvedBy: null });
  }
  async setColor(e, t) {
    await this.threadRef(e).update({ color: t });
  }
  async move(e, t) {
    await this.threadRef(e).update({
      x: t.x,
      y: t.y,
      elementId: t.elementId,
      ex: t.ex,
      ey: t.ey,
      anchorLabel: t.label.slice(0, 120),
      anchorThumb: t.thumb && t.thumb.length <= 1e3 ? t.thumb : null
    });
  }
  async follow(e, t, i) {
    const s = this.fb.FieldValue;
    await this.threadRef(e, i).update({ followers: t ? s.arrayUnion(this.user.uid) : s.arrayRemove(this.user.uid) });
  }
  async pin(e, t) {
    const i = this.fb.FieldValue;
    await this.threadRef(e).update({ pinnedBy: t ? i.arrayUnion(this.user.uid) : i.arrayRemove(this.user.uid) });
  }
  async markRead(e) {
    const t = this.fb.FieldValue, i = /* @__PURE__ */ new Map();
    for (const s of e) {
      const o = s.boardId || this.boardId;
      i.set(o, [...i.get(o) || [], s.id]);
    }
    await Promise.all(Array.from(i.entries()).map(async ([s, o]) => {
      for (let r = 0; r < o.length; r += hp) {
        const a = this.fb.db.batch();
        for (const l of o.slice(r, r + hp))
          a.update(this.threadRef(l, s), { ["readBy." + this.user.uid]: t.serverTimestamp(), markedUnread: t.arrayRemove(this.user.uid) });
        await a.commit();
      }
    }));
  }
  async markUnread(e, t) {
    await this.threadRef(e, t).update({ markedUnread: this.fb.FieldValue.arrayUnion(this.user.uid) });
  }
  async threadComments(e, t) {
    return (await this.fb.db.collection("runnits").doc(e).collection("runnitCanvasComments").where("threadId", "==", t).limit(300).get()).docs.map((s) => O3(s.id, pp(s))).sort((s, o) => s.createdAt - o.createdAt);
  }
  async boardTitles(e) {
    const t = {};
    return await Promise.all(e.map(async (i) => {
      try {
        const s = await this.fb.db.collection("runnits").doc(i).get(), o = s.exists ? s.data() || {} : null;
        t[i] = !o || o.deletedAt ? null : typeof o.title == "string" && o.title ? o.title : "Untitled board";
      } catch (s) {
        Wo(s) === "permission-denied" && (t[i] = null);
      }
    })), t;
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
function yP(n) {
  return async (e, t) => {
    const s = await n.functions.httpsCallable("saveAnnotatedImage", { timeout: 25e4 })({ source: e, overlayPngBase64: t }), o = s && s.data || null;
    if (!o || !o.upload)
      throw new Error(o && o.error && o.error.message || "Your marks couldn't be added to the picture. Please try again.");
    const { createdAtMs: r, ...a } = o.upload;
    return { ...a, createdAt: typeof r == "number" ? new Date(r) : /* @__PURE__ */ new Date() };
  };
}
function m$e(n, e, t, i = {}) {
  const s = new Tze(n, e.uid, t);
  return {
    runs: new xze(n, t),
    prompts: s,
    favorites: new Aze(n, e.uid, t),
    pins: new Rze(n, e.uid, t),
    models: new Dze(n, e.uid),
    balance: new Fze(n, !!e.freemiumPassport),
    teamStatus: new jze(n),
    library: new Kze(n, e.uid, { isAdmin: e.isAdmin }),
    companyTools: (o) => ZC(n, o, e, { isBlocked: i.isBlocked }),
    gen: new e$e(n, s),
    annotate: yP(n),
    featured: o$e(n),
    myPrompts: d$e(n)
  };
}
function g$e(n, e, t, i) {
  return new f$e(n, e, t, i);
}
async function b$e(n, e, t) {
  if (n.upload) return n.upload(t);
  const i = (t.name.split(".").pop() || "png").toLowerCase().replace(/[^a-z0-9]/g, "") || "png", s = n.storage.ref("runnitUploads/users/" + e.uid + "/uploads/board-" + wt() + "." + i);
  return await s.put(t, { contentType: t.type || "image/png" }), { url: await s.getDownloadURL() };
}
const Ax = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RunnitCanvasDirectory: fze,
  annotateWith: yP,
  boardServices: m$e,
  commentStore: g$e,
  loadCompanyTools: ZC,
  loadToolCatalog: _ne,
  uploadFile: b$e
}, Symbol.toStringTag, { value: "Module" }));
export {
  w$e as createCanvasBoard,
  k$e as createDemoBoard,
  lze as mountBoard,
  x$e as mountOnboarding,
  _$e as mountStressBoard
};
